(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire39c1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire39c1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fR5Jw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("agMVl"));

});
parcelRegister("agMVl", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $77a1594697e19933$export$ffb0004e005737fa; }, function (v) { return $77a1594697e19933$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $77a1594697e19933$export$34b9dba7ce09269b; }, function (v) { return $77a1594697e19933$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $77a1594697e19933$export$25062201e9e25d76; }, function (v) { return $77a1594697e19933$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77a1594697e19933$export$ffb0004e005737fa;
var $77a1594697e19933$export$34b9dba7ce09269b;
var $77a1594697e19933$export$25062201e9e25d76;
"use strict";

var $dgG1Y = parcelRequire("dgG1Y");
var $77a1594697e19933$var$k = Symbol.for("react.element"), $77a1594697e19933$var$l = Symbol.for("react.fragment"), $77a1594697e19933$var$m = Object.prototype.hasOwnProperty, $77a1594697e19933$var$n = $dgG1Y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $77a1594697e19933$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $77a1594697e19933$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$77a1594697e19933$var$m.call(a, b) && !$77a1594697e19933$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $77a1594697e19933$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $77a1594697e19933$var$n.current
    };
}
$77a1594697e19933$export$ffb0004e005737fa = $77a1594697e19933$var$l;
$77a1594697e19933$export$34b9dba7ce09269b = $77a1594697e19933$var$q;
$77a1594697e19933$export$25062201e9e25d76 = $77a1594697e19933$var$q;

});
parcelRegister("dgG1Y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a8Fy5"));

});
parcelRegister("a8Fy5", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $761ae17b869e19f8$export$dca3b0875bd9a954; }, function (v) { return $761ae17b869e19f8$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $761ae17b869e19f8$export$16fa2f45be04daa8; }, function (v) { return $761ae17b869e19f8$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $761ae17b869e19f8$export$ffb0004e005737fa; }, function (v) { return $761ae17b869e19f8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $761ae17b869e19f8$export$e2c29f18771995cb; }, function (v) { return $761ae17b869e19f8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $761ae17b869e19f8$export$221d75b3f55bb0bd; }, function (v) { return $761ae17b869e19f8$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $761ae17b869e19f8$export$5f8d39834fd61797; }, function (v) { return $761ae17b869e19f8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $761ae17b869e19f8$export$74bf444e3cd11ea5; }, function (v) { return $761ae17b869e19f8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $761ae17b869e19f8$export$ae55be85d98224ed; }, function (v) { return $761ae17b869e19f8$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $761ae17b869e19f8$export$3ba232387fd5d6dd; }, function (v) { return $761ae17b869e19f8$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $761ae17b869e19f8$export$e530037191fcd5d7; }, function (v) { return $761ae17b869e19f8$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $761ae17b869e19f8$export$fd42f52fd3ae1109; }, function (v) { return $761ae17b869e19f8$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $761ae17b869e19f8$export$c8a8987d4410bf2d; }, function (v) { return $761ae17b869e19f8$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $761ae17b869e19f8$export$d38cd72104c1f0e9; }, function (v) { return $761ae17b869e19f8$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $761ae17b869e19f8$export$7d1e3a5e95ceca43; }, function (v) { return $761ae17b869e19f8$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $761ae17b869e19f8$export$257a8862b851cb5b; }, function (v) { return $761ae17b869e19f8$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $761ae17b869e19f8$export$a8257692ac88316c; }, function (v) { return $761ae17b869e19f8$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $761ae17b869e19f8$export$488013bae63b21da; }, function (v) { return $761ae17b869e19f8$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $761ae17b869e19f8$export$7c73462e0d25e514; }, function (v) { return $761ae17b869e19f8$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $761ae17b869e19f8$export$7568632d0d33d16d; }, function (v) { return $761ae17b869e19f8$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $761ae17b869e19f8$export$88948ce120ea2619; }, function (v) { return $761ae17b869e19f8$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $761ae17b869e19f8$export$35808ee640e87ca7; }, function (v) { return $761ae17b869e19f8$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $761ae17b869e19f8$export$fae74005e78b1a27; }, function (v) { return $761ae17b869e19f8$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $761ae17b869e19f8$export$dc8fbce3eb94dc1e; }, function (v) { return $761ae17b869e19f8$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $761ae17b869e19f8$export$6a7bc4e911dc01cf; }, function (v) { return $761ae17b869e19f8$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $761ae17b869e19f8$export$6d9c69b0de29b591; }, function (v) { return $761ae17b869e19f8$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $761ae17b869e19f8$export$f680877a34711e37; }, function (v) { return $761ae17b869e19f8$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $761ae17b869e19f8$export$d5a552a76deda3c2; }, function (v) { return $761ae17b869e19f8$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $761ae17b869e19f8$export$aaabe4eda9ed9969; }, function (v) { return $761ae17b869e19f8$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $761ae17b869e19f8$export$e5c5a5f917a5871c; }, function (v) { return $761ae17b869e19f8$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $761ae17b869e19f8$export$1538c33de8887b59; }, function (v) { return $761ae17b869e19f8$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $761ae17b869e19f8$export$13e3392192263954; }, function (v) { return $761ae17b869e19f8$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $761ae17b869e19f8$export$b8f5890fc79d6aca; }, function (v) { return $761ae17b869e19f8$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $761ae17b869e19f8$export$60241385465d0a34; }, function (v) { return $761ae17b869e19f8$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $761ae17b869e19f8$export$306c0aa65ff9ec16; }, function (v) { return $761ae17b869e19f8$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $761ae17b869e19f8$export$7b286972b8d8ccbf; }, function (v) { return $761ae17b869e19f8$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $761ae17b869e19f8$export$83d89fbfd8236492; }, function (v) { return $761ae17b869e19f8$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $761ae17b869e19f8$export$dca3b0875bd9a954;
var $761ae17b869e19f8$export$16fa2f45be04daa8;
var $761ae17b869e19f8$export$ffb0004e005737fa;
var $761ae17b869e19f8$export$e2c29f18771995cb;
var $761ae17b869e19f8$export$221d75b3f55bb0bd;
var $761ae17b869e19f8$export$5f8d39834fd61797;
var $761ae17b869e19f8$export$74bf444e3cd11ea5;
var $761ae17b869e19f8$export$ae55be85d98224ed;
var $761ae17b869e19f8$export$3ba232387fd5d6dd;
var $761ae17b869e19f8$export$e530037191fcd5d7;
var $761ae17b869e19f8$export$fd42f52fd3ae1109;
var $761ae17b869e19f8$export$c8a8987d4410bf2d;
var $761ae17b869e19f8$export$d38cd72104c1f0e9;
var $761ae17b869e19f8$export$7d1e3a5e95ceca43;
var $761ae17b869e19f8$export$257a8862b851cb5b;
var $761ae17b869e19f8$export$a8257692ac88316c;
var $761ae17b869e19f8$export$488013bae63b21da;
var $761ae17b869e19f8$export$7c73462e0d25e514;
var $761ae17b869e19f8$export$7568632d0d33d16d;
var $761ae17b869e19f8$export$88948ce120ea2619;
var $761ae17b869e19f8$export$35808ee640e87ca7;
var $761ae17b869e19f8$export$fae74005e78b1a27;
var $761ae17b869e19f8$export$dc8fbce3eb94dc1e;
var $761ae17b869e19f8$export$6a7bc4e911dc01cf;
var $761ae17b869e19f8$export$6d9c69b0de29b591;
var $761ae17b869e19f8$export$f680877a34711e37;
var $761ae17b869e19f8$export$d5a552a76deda3c2;
var $761ae17b869e19f8$export$aaabe4eda9ed9969;
var $761ae17b869e19f8$export$e5c5a5f917a5871c;
var $761ae17b869e19f8$export$1538c33de8887b59;
var $761ae17b869e19f8$export$13e3392192263954;
var $761ae17b869e19f8$export$b8f5890fc79d6aca;
var $761ae17b869e19f8$export$60241385465d0a34;
var $761ae17b869e19f8$export$306c0aa65ff9ec16;
var $761ae17b869e19f8$export$7b286972b8d8ccbf;
var $761ae17b869e19f8$export$83d89fbfd8236492;
"use strict";
var $761ae17b869e19f8$var$l = Symbol.for("react.element"), $761ae17b869e19f8$var$n = Symbol.for("react.portal"), $761ae17b869e19f8$var$p = Symbol.for("react.fragment"), $761ae17b869e19f8$var$q = Symbol.for("react.strict_mode"), $761ae17b869e19f8$var$r = Symbol.for("react.profiler"), $761ae17b869e19f8$var$t = Symbol.for("react.provider"), $761ae17b869e19f8$var$u = Symbol.for("react.context"), $761ae17b869e19f8$var$v = Symbol.for("react.forward_ref"), $761ae17b869e19f8$var$w = Symbol.for("react.suspense"), $761ae17b869e19f8$var$x = Symbol.for("react.memo"), $761ae17b869e19f8$var$y = Symbol.for("react.lazy"), $761ae17b869e19f8$var$z = Symbol.iterator;
function $761ae17b869e19f8$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $761ae17b869e19f8$var$z && a[$761ae17b869e19f8$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $761ae17b869e19f8$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $761ae17b869e19f8$var$C = Object.assign, $761ae17b869e19f8$var$D = {};
function $761ae17b869e19f8$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $761ae17b869e19f8$var$D;
    this.updater = e || $761ae17b869e19f8$var$B;
}
$761ae17b869e19f8$var$E.prototype.isReactComponent = {};
$761ae17b869e19f8$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$761ae17b869e19f8$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $761ae17b869e19f8$var$F() {}
$761ae17b869e19f8$var$F.prototype = $761ae17b869e19f8$var$E.prototype;
function $761ae17b869e19f8$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $761ae17b869e19f8$var$D;
    this.updater = e || $761ae17b869e19f8$var$B;
}
var $761ae17b869e19f8$var$H = $761ae17b869e19f8$var$G.prototype = new $761ae17b869e19f8$var$F;
$761ae17b869e19f8$var$H.constructor = $761ae17b869e19f8$var$G;
$761ae17b869e19f8$var$C($761ae17b869e19f8$var$H, $761ae17b869e19f8$var$E.prototype);
$761ae17b869e19f8$var$H.isPureReactComponent = !0;
var $761ae17b869e19f8$var$I = Array.isArray, $761ae17b869e19f8$var$J = Object.prototype.hasOwnProperty, $761ae17b869e19f8$var$K = {
    current: null
}, $761ae17b869e19f8$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $761ae17b869e19f8$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$761ae17b869e19f8$var$J.call(b, d) && !$761ae17b869e19f8$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $761ae17b869e19f8$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $761ae17b869e19f8$var$K.current
    };
}
function $761ae17b869e19f8$var$N(a, b) {
    return {
        $$typeof: $761ae17b869e19f8$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $761ae17b869e19f8$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $761ae17b869e19f8$var$l;
}
function $761ae17b869e19f8$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $761ae17b869e19f8$var$P = /\/+/g;
function $761ae17b869e19f8$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $761ae17b869e19f8$var$escape("" + a.key) : b.toString(36);
}
function $761ae17b869e19f8$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $761ae17b869e19f8$var$l:
                case $761ae17b869e19f8$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $761ae17b869e19f8$var$Q(h, 0) : d, $761ae17b869e19f8$var$I(c) ? (e = "", null != a && (e = a.replace($761ae17b869e19f8$var$P, "$&/") + "/"), $761ae17b869e19f8$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($761ae17b869e19f8$var$O(c) && (c = $761ae17b869e19f8$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($761ae17b869e19f8$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($761ae17b869e19f8$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $761ae17b869e19f8$var$Q(k, g);
        h += $761ae17b869e19f8$var$R(k, b, e, f, c);
    }
    else if (f = $761ae17b869e19f8$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $761ae17b869e19f8$var$Q(k, g++), h += $761ae17b869e19f8$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $761ae17b869e19f8$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $761ae17b869e19f8$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $761ae17b869e19f8$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $761ae17b869e19f8$var$U = {
    current: null
}, $761ae17b869e19f8$var$V = {
    transition: null
}, $761ae17b869e19f8$var$W = {
    ReactCurrentDispatcher: $761ae17b869e19f8$var$U,
    ReactCurrentBatchConfig: $761ae17b869e19f8$var$V,
    ReactCurrentOwner: $761ae17b869e19f8$var$K
};
function $761ae17b869e19f8$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$761ae17b869e19f8$export$dca3b0875bd9a954 = {
    map: $761ae17b869e19f8$var$S,
    forEach: function(a, b, e) {
        $761ae17b869e19f8$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $761ae17b869e19f8$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $761ae17b869e19f8$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$761ae17b869e19f8$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$761ae17b869e19f8$export$16fa2f45be04daa8 = $761ae17b869e19f8$var$E;
$761ae17b869e19f8$export$ffb0004e005737fa = $761ae17b869e19f8$var$p;
$761ae17b869e19f8$export$e2c29f18771995cb = $761ae17b869e19f8$var$r;
$761ae17b869e19f8$export$221d75b3f55bb0bd = $761ae17b869e19f8$var$G;
$761ae17b869e19f8$export$5f8d39834fd61797 = $761ae17b869e19f8$var$q;
$761ae17b869e19f8$export$74bf444e3cd11ea5 = $761ae17b869e19f8$var$w;
$761ae17b869e19f8$export$ae55be85d98224ed = $761ae17b869e19f8$var$W;
$761ae17b869e19f8$export$3ba232387fd5d6dd = $761ae17b869e19f8$var$X;
$761ae17b869e19f8$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $761ae17b869e19f8$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $761ae17b869e19f8$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$761ae17b869e19f8$var$J.call(b, f) && !$761ae17b869e19f8$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $761ae17b869e19f8$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$761ae17b869e19f8$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $761ae17b869e19f8$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $761ae17b869e19f8$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$761ae17b869e19f8$export$c8a8987d4410bf2d = $761ae17b869e19f8$var$M;
$761ae17b869e19f8$export$d38cd72104c1f0e9 = function(a) {
    var b = $761ae17b869e19f8$var$M.bind(null, a);
    b.type = a;
    return b;
};
$761ae17b869e19f8$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$761ae17b869e19f8$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $761ae17b869e19f8$var$v,
        render: a
    };
};
$761ae17b869e19f8$export$a8257692ac88316c = $761ae17b869e19f8$var$O;
$761ae17b869e19f8$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $761ae17b869e19f8$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $761ae17b869e19f8$var$T
    };
};
$761ae17b869e19f8$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $761ae17b869e19f8$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$761ae17b869e19f8$export$7568632d0d33d16d = function(a) {
    var b = $761ae17b869e19f8$var$V.transition;
    $761ae17b869e19f8$var$V.transition = {};
    try {
        a();
    } finally{
        $761ae17b869e19f8$var$V.transition = b;
    }
};
$761ae17b869e19f8$export$88948ce120ea2619 = $761ae17b869e19f8$var$X;
$761ae17b869e19f8$export$35808ee640e87ca7 = function(a, b) {
    return $761ae17b869e19f8$var$U.current.useCallback(a, b);
};
$761ae17b869e19f8$export$fae74005e78b1a27 = function(a) {
    return $761ae17b869e19f8$var$U.current.useContext(a);
};
$761ae17b869e19f8$export$dc8fbce3eb94dc1e = function() {};
$761ae17b869e19f8$export$6a7bc4e911dc01cf = function(a) {
    return $761ae17b869e19f8$var$U.current.useDeferredValue(a);
};
$761ae17b869e19f8$export$6d9c69b0de29b591 = function(a, b) {
    return $761ae17b869e19f8$var$U.current.useEffect(a, b);
};
$761ae17b869e19f8$export$f680877a34711e37 = function() {
    return $761ae17b869e19f8$var$U.current.useId();
};
$761ae17b869e19f8$export$d5a552a76deda3c2 = function(a, b, e) {
    return $761ae17b869e19f8$var$U.current.useImperativeHandle(a, b, e);
};
$761ae17b869e19f8$export$aaabe4eda9ed9969 = function(a, b) {
    return $761ae17b869e19f8$var$U.current.useInsertionEffect(a, b);
};
$761ae17b869e19f8$export$e5c5a5f917a5871c = function(a, b) {
    return $761ae17b869e19f8$var$U.current.useLayoutEffect(a, b);
};
$761ae17b869e19f8$export$1538c33de8887b59 = function(a, b) {
    return $761ae17b869e19f8$var$U.current.useMemo(a, b);
};
$761ae17b869e19f8$export$13e3392192263954 = function(a, b, e) {
    return $761ae17b869e19f8$var$U.current.useReducer(a, b, e);
};
$761ae17b869e19f8$export$b8f5890fc79d6aca = function(a) {
    return $761ae17b869e19f8$var$U.current.useRef(a);
};
$761ae17b869e19f8$export$60241385465d0a34 = function(a) {
    return $761ae17b869e19f8$var$U.current.useState(a);
};
$761ae17b869e19f8$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $761ae17b869e19f8$var$U.current.useSyncExternalStore(a, b, e);
};
$761ae17b869e19f8$export$7b286972b8d8ccbf = function() {
    return $761ae17b869e19f8$var$U.current.useTransition();
};
$761ae17b869e19f8$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("8idXE", function(module, exports) {
"use strict";
function $609ad588a09955dd$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($609ad588a09955dd$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$609ad588a09955dd$var$checkDCE();

module.exports = (parcelRequire("bzvmG"));

});
parcelRegister("bzvmG", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86cb4b0557295782$export$ae55be85d98224ed; }, function (v) { return $86cb4b0557295782$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $86cb4b0557295782$export$d39a5bbd09211389; }, function (v) { return $86cb4b0557295782$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $86cb4b0557295782$export$882461b6382ed46c; }, function (v) { return $86cb4b0557295782$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $86cb4b0557295782$export$466bfc07425424d5; }, function (v) { return $86cb4b0557295782$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $86cb4b0557295782$export$cd75ccfd720a3cd4; }, function (v) { return $86cb4b0557295782$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $86cb4b0557295782$export$fa8d919ba61d84db; }, function (v) { return $86cb4b0557295782$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $86cb4b0557295782$export$757ceba2d55c277e; }, function (v) { return $86cb4b0557295782$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $86cb4b0557295782$export$b3890eb0ae9dca99; }, function (v) { return $86cb4b0557295782$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $86cb4b0557295782$export$502457920280e6be; }, function (v) { return $86cb4b0557295782$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $86cb4b0557295782$export$c78a37762a8d58e1; }, function (v) { return $86cb4b0557295782$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $86cb4b0557295782$export$dc54d992c10e8a18; }, function (v) { return $86cb4b0557295782$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $86cb4b0557295782$export$83d89fbfd8236492; }, function (v) { return $86cb4b0557295782$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $86cb4b0557295782$export$ae55be85d98224ed;
var $86cb4b0557295782$export$d39a5bbd09211389;
var $86cb4b0557295782$export$882461b6382ed46c;
var $86cb4b0557295782$export$466bfc07425424d5;
var $86cb4b0557295782$export$cd75ccfd720a3cd4;
var $86cb4b0557295782$export$fa8d919ba61d84db;
var $86cb4b0557295782$export$757ceba2d55c277e;
var $86cb4b0557295782$export$b3890eb0ae9dca99;
var $86cb4b0557295782$export$502457920280e6be;
var $86cb4b0557295782$export$c78a37762a8d58e1;
var $86cb4b0557295782$export$dc54d992c10e8a18;
var $86cb4b0557295782$export$83d89fbfd8236492;
"use strict";

var $dgG1Y = parcelRequire("dgG1Y");

var $9iFCZ = parcelRequire("9iFCZ");
function $86cb4b0557295782$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $86cb4b0557295782$var$da = new Set, $86cb4b0557295782$var$ea = {};
function $86cb4b0557295782$var$fa(a, b) {
    $86cb4b0557295782$var$ha(a, b);
    $86cb4b0557295782$var$ha(a + "Capture", b);
}
function $86cb4b0557295782$var$ha(a, b) {
    $86cb4b0557295782$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$86cb4b0557295782$var$da.add(b[a]);
}
var $86cb4b0557295782$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $86cb4b0557295782$var$ja = Object.prototype.hasOwnProperty, $86cb4b0557295782$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $86cb4b0557295782$var$la = {}, $86cb4b0557295782$var$ma = {};
function $86cb4b0557295782$var$oa(a) {
    if ($86cb4b0557295782$var$ja.call($86cb4b0557295782$var$ma, a)) return !0;
    if ($86cb4b0557295782$var$ja.call($86cb4b0557295782$var$la, a)) return !1;
    if ($86cb4b0557295782$var$ka.test(a)) return $86cb4b0557295782$var$ma[a] = !0;
    $86cb4b0557295782$var$la[a] = !0;
    return !1;
}
function $86cb4b0557295782$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $86cb4b0557295782$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $86cb4b0557295782$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $86cb4b0557295782$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $86cb4b0557295782$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $86cb4b0557295782$var$z[b] = new $86cb4b0557295782$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $86cb4b0557295782$var$ra = /[\-:]([a-z])/g;
function $86cb4b0557295782$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($86cb4b0557295782$var$ra, $86cb4b0557295782$var$sa);
    $86cb4b0557295782$var$z[b] = new $86cb4b0557295782$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($86cb4b0557295782$var$ra, $86cb4b0557295782$var$sa);
    $86cb4b0557295782$var$z[b] = new $86cb4b0557295782$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($86cb4b0557295782$var$ra, $86cb4b0557295782$var$sa);
    $86cb4b0557295782$var$z[b] = new $86cb4b0557295782$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$86cb4b0557295782$var$z.xlinkHref = new $86cb4b0557295782$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $86cb4b0557295782$var$z[a] = new $86cb4b0557295782$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $86cb4b0557295782$var$ta(a, b, c, d) {
    var e = $86cb4b0557295782$var$z.hasOwnProperty(b) ? $86cb4b0557295782$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $86cb4b0557295782$var$qa(b, c, e, d) && (c = null), d || null === e ? $86cb4b0557295782$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $86cb4b0557295782$var$ua = $dgG1Y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $86cb4b0557295782$var$va = Symbol.for("react.element"), $86cb4b0557295782$var$wa = Symbol.for("react.portal"), $86cb4b0557295782$var$ya = Symbol.for("react.fragment"), $86cb4b0557295782$var$za = Symbol.for("react.strict_mode"), $86cb4b0557295782$var$Aa = Symbol.for("react.profiler"), $86cb4b0557295782$var$Ba = Symbol.for("react.provider"), $86cb4b0557295782$var$Ca = Symbol.for("react.context"), $86cb4b0557295782$var$Da = Symbol.for("react.forward_ref"), $86cb4b0557295782$var$Ea = Symbol.for("react.suspense"), $86cb4b0557295782$var$Fa = Symbol.for("react.suspense_list"), $86cb4b0557295782$var$Ga = Symbol.for("react.memo"), $86cb4b0557295782$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $86cb4b0557295782$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $86cb4b0557295782$var$Ja = Symbol.iterator;
function $86cb4b0557295782$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86cb4b0557295782$var$Ja && a[$86cb4b0557295782$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86cb4b0557295782$var$A = Object.assign, $86cb4b0557295782$var$La;
function $86cb4b0557295782$var$Ma(a) {
    if (void 0 === $86cb4b0557295782$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $86cb4b0557295782$var$La = b && b[1] || "";
    }
    return "\n" + $86cb4b0557295782$var$La + a;
}
var $86cb4b0557295782$var$Na = !1;
function $86cb4b0557295782$var$Oa(a, b) {
    if (!a || $86cb4b0557295782$var$Na) return "";
    $86cb4b0557295782$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $86cb4b0557295782$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $86cb4b0557295782$var$Ma(a) : "";
}
function $86cb4b0557295782$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $86cb4b0557295782$var$Ma(a.type);
        case 16:
            return $86cb4b0557295782$var$Ma("Lazy");
        case 13:
            return $86cb4b0557295782$var$Ma("Suspense");
        case 19:
            return $86cb4b0557295782$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $86cb4b0557295782$var$Oa(a.type, !1), a;
        case 11:
            return a = $86cb4b0557295782$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $86cb4b0557295782$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $86cb4b0557295782$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $86cb4b0557295782$var$ya:
            return "Fragment";
        case $86cb4b0557295782$var$wa:
            return "Portal";
        case $86cb4b0557295782$var$Aa:
            return "Profiler";
        case $86cb4b0557295782$var$za:
            return "StrictMode";
        case $86cb4b0557295782$var$Ea:
            return "Suspense";
        case $86cb4b0557295782$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $86cb4b0557295782$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $86cb4b0557295782$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $86cb4b0557295782$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $86cb4b0557295782$var$Ga:
            return b = a.displayName || null, null !== b ? b : $86cb4b0557295782$var$Qa(a.type) || "Memo";
        case $86cb4b0557295782$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $86cb4b0557295782$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $86cb4b0557295782$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $86cb4b0557295782$var$Qa(b);
        case 8:
            return b === $86cb4b0557295782$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $86cb4b0557295782$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $86cb4b0557295782$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $86cb4b0557295782$var$Ua(a) {
    var b = $86cb4b0557295782$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $86cb4b0557295782$var$Va(a) {
    a._valueTracker || (a._valueTracker = $86cb4b0557295782$var$Ua(a));
}
function $86cb4b0557295782$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $86cb4b0557295782$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $86cb4b0557295782$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $86cb4b0557295782$var$Ya(a, b) {
    var c = b.checked;
    return $86cb4b0557295782$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $86cb4b0557295782$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $86cb4b0557295782$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $86cb4b0557295782$var$ab(a, b) {
    b = b.checked;
    null != b && $86cb4b0557295782$var$ta(a, "checked", b, !1);
}
function $86cb4b0557295782$var$bb(a, b) {
    $86cb4b0557295782$var$ab(a, b);
    var c = $86cb4b0557295782$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $86cb4b0557295782$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $86cb4b0557295782$var$cb(a, b.type, $86cb4b0557295782$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $86cb4b0557295782$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $86cb4b0557295782$var$cb(a, b, c) {
    if ("number" !== b || $86cb4b0557295782$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $86cb4b0557295782$var$eb = Array.isArray;
function $86cb4b0557295782$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $86cb4b0557295782$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $86cb4b0557295782$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($86cb4b0557295782$var$p(91));
    return $86cb4b0557295782$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $86cb4b0557295782$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($86cb4b0557295782$var$p(92));
            if ($86cb4b0557295782$var$eb(c)) {
                if (1 < c.length) throw Error($86cb4b0557295782$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $86cb4b0557295782$var$Sa(c)
    };
}
function $86cb4b0557295782$var$ib(a, b) {
    var c = $86cb4b0557295782$var$Sa(b.value), d = $86cb4b0557295782$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $86cb4b0557295782$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $86cb4b0557295782$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $86cb4b0557295782$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $86cb4b0557295782$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $86cb4b0557295782$var$mb, $86cb4b0557295782$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $86cb4b0557295782$var$mb = $86cb4b0557295782$var$mb || document.createElement("div");
        $86cb4b0557295782$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $86cb4b0557295782$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $86cb4b0557295782$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $86cb4b0557295782$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $86cb4b0557295782$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($86cb4b0557295782$var$pb).forEach(function(a) {
    $86cb4b0557295782$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $86cb4b0557295782$var$pb[b] = $86cb4b0557295782$var$pb[a];
    });
});
function $86cb4b0557295782$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $86cb4b0557295782$var$pb.hasOwnProperty(a) && $86cb4b0557295782$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $86cb4b0557295782$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $86cb4b0557295782$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $86cb4b0557295782$var$tb = $86cb4b0557295782$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $86cb4b0557295782$var$ub(a, b) {
    if (b) {
        if ($86cb4b0557295782$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($86cb4b0557295782$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($86cb4b0557295782$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($86cb4b0557295782$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($86cb4b0557295782$var$p(62));
    }
}
function $86cb4b0557295782$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $86cb4b0557295782$var$wb = null;
function $86cb4b0557295782$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $86cb4b0557295782$var$yb = null, $86cb4b0557295782$var$zb = null, $86cb4b0557295782$var$Ab = null;
function $86cb4b0557295782$var$Bb(a) {
    if (a = $86cb4b0557295782$var$Cb(a)) {
        if ("function" !== typeof $86cb4b0557295782$var$yb) throw Error($86cb4b0557295782$var$p(280));
        var b = a.stateNode;
        b && (b = $86cb4b0557295782$var$Db(b), $86cb4b0557295782$var$yb(a.stateNode, a.type, b));
    }
}
function $86cb4b0557295782$var$Eb(a) {
    $86cb4b0557295782$var$zb ? $86cb4b0557295782$var$Ab ? $86cb4b0557295782$var$Ab.push(a) : $86cb4b0557295782$var$Ab = [
        a
    ] : $86cb4b0557295782$var$zb = a;
}
function $86cb4b0557295782$var$Fb() {
    if ($86cb4b0557295782$var$zb) {
        var a = $86cb4b0557295782$var$zb, b = $86cb4b0557295782$var$Ab;
        $86cb4b0557295782$var$Ab = $86cb4b0557295782$var$zb = null;
        $86cb4b0557295782$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$86cb4b0557295782$var$Bb(b[a]);
    }
}
function $86cb4b0557295782$var$Gb(a, b) {
    return a(b);
}
function $86cb4b0557295782$var$Hb() {}
var $86cb4b0557295782$var$Ib = !1;
function $86cb4b0557295782$var$Jb(a, b, c) {
    if ($86cb4b0557295782$var$Ib) return a(b, c);
    $86cb4b0557295782$var$Ib = !0;
    try {
        return $86cb4b0557295782$var$Gb(a, b, c);
    } finally{
        if ($86cb4b0557295782$var$Ib = !1, null !== $86cb4b0557295782$var$zb || null !== $86cb4b0557295782$var$Ab) $86cb4b0557295782$var$Hb(), $86cb4b0557295782$var$Fb();
    }
}
function $86cb4b0557295782$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $86cb4b0557295782$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($86cb4b0557295782$var$p(231, b, typeof c));
    return c;
}
var $86cb4b0557295782$var$Lb = !1;
if ($86cb4b0557295782$var$ia) try {
    var $86cb4b0557295782$var$Mb = {};
    Object.defineProperty($86cb4b0557295782$var$Mb, "passive", {
        get: function() {
            $86cb4b0557295782$var$Lb = !0;
        }
    });
    window.addEventListener("test", $86cb4b0557295782$var$Mb, $86cb4b0557295782$var$Mb);
    window.removeEventListener("test", $86cb4b0557295782$var$Mb, $86cb4b0557295782$var$Mb);
} catch (a) {
    $86cb4b0557295782$var$Lb = !1;
}
function $86cb4b0557295782$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $86cb4b0557295782$var$Ob = !1, $86cb4b0557295782$var$Pb = null, $86cb4b0557295782$var$Qb = !1, $86cb4b0557295782$var$Rb = null, $86cb4b0557295782$var$Sb = {
    onError: function(a) {
        $86cb4b0557295782$var$Ob = !0;
        $86cb4b0557295782$var$Pb = a;
    }
};
function $86cb4b0557295782$var$Tb(a, b, c, d, e, f, g, h, k) {
    $86cb4b0557295782$var$Ob = !1;
    $86cb4b0557295782$var$Pb = null;
    $86cb4b0557295782$var$Nb.apply($86cb4b0557295782$var$Sb, arguments);
}
function $86cb4b0557295782$var$Ub(a, b, c, d, e, f, g, h, k) {
    $86cb4b0557295782$var$Tb.apply(this, arguments);
    if ($86cb4b0557295782$var$Ob) {
        if ($86cb4b0557295782$var$Ob) {
            var l = $86cb4b0557295782$var$Pb;
            $86cb4b0557295782$var$Ob = !1;
            $86cb4b0557295782$var$Pb = null;
        } else throw Error($86cb4b0557295782$var$p(198));
        $86cb4b0557295782$var$Qb || ($86cb4b0557295782$var$Qb = !0, $86cb4b0557295782$var$Rb = l);
    }
}
function $86cb4b0557295782$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $86cb4b0557295782$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $86cb4b0557295782$var$Xb(a) {
    if ($86cb4b0557295782$var$Vb(a) !== a) throw Error($86cb4b0557295782$var$p(188));
}
function $86cb4b0557295782$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $86cb4b0557295782$var$Vb(a);
        if (null === b) throw Error($86cb4b0557295782$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $86cb4b0557295782$var$Xb(e), a;
                if (f === d) return $86cb4b0557295782$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($86cb4b0557295782$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($86cb4b0557295782$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($86cb4b0557295782$var$p(190));
    }
    if (3 !== c.tag) throw Error($86cb4b0557295782$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $86cb4b0557295782$var$Zb(a) {
    a = $86cb4b0557295782$var$Yb(a);
    return null !== a ? $86cb4b0557295782$var$$b(a) : null;
}
function $86cb4b0557295782$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $86cb4b0557295782$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $86cb4b0557295782$var$ac = $9iFCZ.unstable_scheduleCallback, $86cb4b0557295782$var$bc = $9iFCZ.unstable_cancelCallback, $86cb4b0557295782$var$cc = $9iFCZ.unstable_shouldYield, $86cb4b0557295782$var$dc = $9iFCZ.unstable_requestPaint, $86cb4b0557295782$var$B = $9iFCZ.unstable_now, $86cb4b0557295782$var$ec = $9iFCZ.unstable_getCurrentPriorityLevel, $86cb4b0557295782$var$fc = $9iFCZ.unstable_ImmediatePriority, $86cb4b0557295782$var$gc = $9iFCZ.unstable_UserBlockingPriority, $86cb4b0557295782$var$hc = $9iFCZ.unstable_NormalPriority, $86cb4b0557295782$var$ic = $9iFCZ.unstable_LowPriority, $86cb4b0557295782$var$jc = $9iFCZ.unstable_IdlePriority, $86cb4b0557295782$var$kc = null, $86cb4b0557295782$var$lc = null;
function $86cb4b0557295782$var$mc(a) {
    if ($86cb4b0557295782$var$lc && "function" === typeof $86cb4b0557295782$var$lc.onCommitFiberRoot) try {
        $86cb4b0557295782$var$lc.onCommitFiberRoot($86cb4b0557295782$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $86cb4b0557295782$var$oc = Math.clz32 ? Math.clz32 : $86cb4b0557295782$var$nc, $86cb4b0557295782$var$pc = Math.log, $86cb4b0557295782$var$qc = Math.LN2;
function $86cb4b0557295782$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($86cb4b0557295782$var$pc(a) / $86cb4b0557295782$var$qc | 0) | 0;
}
var $86cb4b0557295782$var$rc = 64, $86cb4b0557295782$var$sc = 4194304;
function $86cb4b0557295782$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $86cb4b0557295782$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $86cb4b0557295782$var$tc(h) : (f &= g, 0 !== f && (d = $86cb4b0557295782$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $86cb4b0557295782$var$tc(g) : 0 !== f && (d = $86cb4b0557295782$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $86cb4b0557295782$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $86cb4b0557295782$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $86cb4b0557295782$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $86cb4b0557295782$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $86cb4b0557295782$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $86cb4b0557295782$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $86cb4b0557295782$var$yc() {
    var a = $86cb4b0557295782$var$rc;
    $86cb4b0557295782$var$rc <<= 1;
    0 === ($86cb4b0557295782$var$rc & 4194240) && ($86cb4b0557295782$var$rc = 64);
    return a;
}
function $86cb4b0557295782$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $86cb4b0557295782$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $86cb4b0557295782$var$oc(b);
    a[b] = c;
}
function $86cb4b0557295782$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $86cb4b0557295782$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $86cb4b0557295782$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $86cb4b0557295782$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $86cb4b0557295782$var$C = 0;
function $86cb4b0557295782$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $86cb4b0557295782$var$Ec, $86cb4b0557295782$var$Fc, $86cb4b0557295782$var$Gc, $86cb4b0557295782$var$Hc, $86cb4b0557295782$var$Ic, $86cb4b0557295782$var$Jc = !1, $86cb4b0557295782$var$Kc = [], $86cb4b0557295782$var$Lc = null, $86cb4b0557295782$var$Mc = null, $86cb4b0557295782$var$Nc = null, $86cb4b0557295782$var$Oc = new Map, $86cb4b0557295782$var$Pc = new Map, $86cb4b0557295782$var$Qc = [], $86cb4b0557295782$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $86cb4b0557295782$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $86cb4b0557295782$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $86cb4b0557295782$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $86cb4b0557295782$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $86cb4b0557295782$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $86cb4b0557295782$var$Pc.delete(b.pointerId);
    }
}
function $86cb4b0557295782$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $86cb4b0557295782$var$Cb(b), null !== b && $86cb4b0557295782$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $86cb4b0557295782$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $86cb4b0557295782$var$Lc = $86cb4b0557295782$var$Tc($86cb4b0557295782$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $86cb4b0557295782$var$Mc = $86cb4b0557295782$var$Tc($86cb4b0557295782$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $86cb4b0557295782$var$Nc = $86cb4b0557295782$var$Tc($86cb4b0557295782$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $86cb4b0557295782$var$Oc.set(f, $86cb4b0557295782$var$Tc($86cb4b0557295782$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $86cb4b0557295782$var$Pc.set(f, $86cb4b0557295782$var$Tc($86cb4b0557295782$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $86cb4b0557295782$var$Vc(a) {
    var b = $86cb4b0557295782$var$Wc(a.target);
    if (null !== b) {
        var c = $86cb4b0557295782$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $86cb4b0557295782$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $86cb4b0557295782$var$Ic(a.priority, function() {
                        $86cb4b0557295782$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $86cb4b0557295782$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $86cb4b0557295782$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $86cb4b0557295782$var$wb = d;
            c.target.dispatchEvent(d);
            $86cb4b0557295782$var$wb = null;
        } else return b = $86cb4b0557295782$var$Cb(c), null !== b && $86cb4b0557295782$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $86cb4b0557295782$var$Zc(a, b, c) {
    $86cb4b0557295782$var$Xc(a) && c.delete(b);
}
function $86cb4b0557295782$var$$c() {
    $86cb4b0557295782$var$Jc = !1;
    null !== $86cb4b0557295782$var$Lc && $86cb4b0557295782$var$Xc($86cb4b0557295782$var$Lc) && ($86cb4b0557295782$var$Lc = null);
    null !== $86cb4b0557295782$var$Mc && $86cb4b0557295782$var$Xc($86cb4b0557295782$var$Mc) && ($86cb4b0557295782$var$Mc = null);
    null !== $86cb4b0557295782$var$Nc && $86cb4b0557295782$var$Xc($86cb4b0557295782$var$Nc) && ($86cb4b0557295782$var$Nc = null);
    $86cb4b0557295782$var$Oc.forEach($86cb4b0557295782$var$Zc);
    $86cb4b0557295782$var$Pc.forEach($86cb4b0557295782$var$Zc);
}
function $86cb4b0557295782$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $86cb4b0557295782$var$Jc || ($86cb4b0557295782$var$Jc = !0, $9iFCZ.unstable_scheduleCallback($9iFCZ.unstable_NormalPriority, $86cb4b0557295782$var$$c)));
}
function $86cb4b0557295782$var$bd(a) {
    function b(b) {
        return $86cb4b0557295782$var$ad(b, a);
    }
    if (0 < $86cb4b0557295782$var$Kc.length) {
        $86cb4b0557295782$var$ad($86cb4b0557295782$var$Kc[0], a);
        for(var c = 1; c < $86cb4b0557295782$var$Kc.length; c++){
            var d = $86cb4b0557295782$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $86cb4b0557295782$var$Lc && $86cb4b0557295782$var$ad($86cb4b0557295782$var$Lc, a);
    null !== $86cb4b0557295782$var$Mc && $86cb4b0557295782$var$ad($86cb4b0557295782$var$Mc, a);
    null !== $86cb4b0557295782$var$Nc && $86cb4b0557295782$var$ad($86cb4b0557295782$var$Nc, a);
    $86cb4b0557295782$var$Oc.forEach(b);
    $86cb4b0557295782$var$Pc.forEach(b);
    for(c = 0; c < $86cb4b0557295782$var$Qc.length; c++)d = $86cb4b0557295782$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $86cb4b0557295782$var$Qc.length && (c = $86cb4b0557295782$var$Qc[0], null === c.blockedOn);)$86cb4b0557295782$var$Vc(c), null === c.blockedOn && $86cb4b0557295782$var$Qc.shift();
}
var $86cb4b0557295782$var$cd = $86cb4b0557295782$var$ua.ReactCurrentBatchConfig, $86cb4b0557295782$var$dd = !0;
function $86cb4b0557295782$var$ed(a, b, c, d) {
    var e = $86cb4b0557295782$var$C, f = $86cb4b0557295782$var$cd.transition;
    $86cb4b0557295782$var$cd.transition = null;
    try {
        $86cb4b0557295782$var$C = 1, $86cb4b0557295782$var$fd(a, b, c, d);
    } finally{
        $86cb4b0557295782$var$C = e, $86cb4b0557295782$var$cd.transition = f;
    }
}
function $86cb4b0557295782$var$gd(a, b, c, d) {
    var e = $86cb4b0557295782$var$C, f = $86cb4b0557295782$var$cd.transition;
    $86cb4b0557295782$var$cd.transition = null;
    try {
        $86cb4b0557295782$var$C = 4, $86cb4b0557295782$var$fd(a, b, c, d);
    } finally{
        $86cb4b0557295782$var$C = e, $86cb4b0557295782$var$cd.transition = f;
    }
}
function $86cb4b0557295782$var$fd(a, b, c, d) {
    if ($86cb4b0557295782$var$dd) {
        var e = $86cb4b0557295782$var$Yc(a, b, c, d);
        if (null === e) $86cb4b0557295782$var$hd(a, b, d, $86cb4b0557295782$var$id, c), $86cb4b0557295782$var$Sc(a, d);
        else if ($86cb4b0557295782$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($86cb4b0557295782$var$Sc(a, d), b & 4 && -1 < $86cb4b0557295782$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $86cb4b0557295782$var$Cb(e);
                null !== f && $86cb4b0557295782$var$Ec(f);
                f = $86cb4b0557295782$var$Yc(a, b, c, d);
                null === f && $86cb4b0557295782$var$hd(a, b, d, $86cb4b0557295782$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $86cb4b0557295782$var$hd(a, b, d, null, c);
    }
}
var $86cb4b0557295782$var$id = null;
function $86cb4b0557295782$var$Yc(a, b, c, d) {
    $86cb4b0557295782$var$id = null;
    a = $86cb4b0557295782$var$xb(d);
    a = $86cb4b0557295782$var$Wc(a);
    if (null !== a) {
        if (b = $86cb4b0557295782$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $86cb4b0557295782$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $86cb4b0557295782$var$id = a;
    return null;
}
function $86cb4b0557295782$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($86cb4b0557295782$var$ec()){
                case $86cb4b0557295782$var$fc:
                    return 1;
                case $86cb4b0557295782$var$gc:
                    return 4;
                case $86cb4b0557295782$var$hc:
                case $86cb4b0557295782$var$ic:
                    return 16;
                case $86cb4b0557295782$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $86cb4b0557295782$var$kd = null, $86cb4b0557295782$var$ld = null, $86cb4b0557295782$var$md = null;
function $86cb4b0557295782$var$nd() {
    if ($86cb4b0557295782$var$md) return $86cb4b0557295782$var$md;
    var a, b = $86cb4b0557295782$var$ld, c = b.length, d, e = "value" in $86cb4b0557295782$var$kd ? $86cb4b0557295782$var$kd.value : $86cb4b0557295782$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $86cb4b0557295782$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $86cb4b0557295782$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $86cb4b0557295782$var$pd() {
    return !0;
}
function $86cb4b0557295782$var$qd() {
    return !1;
}
function $86cb4b0557295782$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $86cb4b0557295782$var$pd : $86cb4b0557295782$var$qd;
        this.isPropagationStopped = $86cb4b0557295782$var$qd;
        return this;
    }
    $86cb4b0557295782$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $86cb4b0557295782$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $86cb4b0557295782$var$pd);
        },
        persist: function() {},
        isPersistent: $86cb4b0557295782$var$pd
    });
    return b;
}
var $86cb4b0557295782$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $86cb4b0557295782$var$td = $86cb4b0557295782$var$rd($86cb4b0557295782$var$sd), $86cb4b0557295782$var$ud = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$sd, {
    view: 0,
    detail: 0
}), $86cb4b0557295782$var$vd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$ud), $86cb4b0557295782$var$wd, $86cb4b0557295782$var$xd, $86cb4b0557295782$var$yd, $86cb4b0557295782$var$Ad = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $86cb4b0557295782$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $86cb4b0557295782$var$yd && ($86cb4b0557295782$var$yd && "mousemove" === a.type ? ($86cb4b0557295782$var$wd = a.screenX - $86cb4b0557295782$var$yd.screenX, $86cb4b0557295782$var$xd = a.screenY - $86cb4b0557295782$var$yd.screenY) : $86cb4b0557295782$var$xd = $86cb4b0557295782$var$wd = 0, $86cb4b0557295782$var$yd = a);
        return $86cb4b0557295782$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $86cb4b0557295782$var$xd;
    }
}), $86cb4b0557295782$var$Bd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Ad), $86cb4b0557295782$var$Cd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$Ad, {
    dataTransfer: 0
}), $86cb4b0557295782$var$Dd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Cd), $86cb4b0557295782$var$Ed = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$ud, {
    relatedTarget: 0
}), $86cb4b0557295782$var$Fd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Ed), $86cb4b0557295782$var$Gd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $86cb4b0557295782$var$Hd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Gd), $86cb4b0557295782$var$Id = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $86cb4b0557295782$var$Jd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Id), $86cb4b0557295782$var$Kd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$sd, {
    data: 0
}), $86cb4b0557295782$var$Ld = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Kd), $86cb4b0557295782$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $86cb4b0557295782$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $86cb4b0557295782$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $86cb4b0557295782$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $86cb4b0557295782$var$Od[a]) ? !!b[a] : !1;
}
function $86cb4b0557295782$var$zd() {
    return $86cb4b0557295782$var$Pd;
}
var $86cb4b0557295782$var$Qd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $86cb4b0557295782$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $86cb4b0557295782$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $86cb4b0557295782$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $86cb4b0557295782$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $86cb4b0557295782$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $86cb4b0557295782$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $86cb4b0557295782$var$Rd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Qd), $86cb4b0557295782$var$Sd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $86cb4b0557295782$var$Td = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Sd), $86cb4b0557295782$var$Ud = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $86cb4b0557295782$var$zd
}), $86cb4b0557295782$var$Vd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Ud), $86cb4b0557295782$var$Wd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $86cb4b0557295782$var$Xd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Wd), $86cb4b0557295782$var$Yd = $86cb4b0557295782$var$A({}, $86cb4b0557295782$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $86cb4b0557295782$var$Zd = $86cb4b0557295782$var$rd($86cb4b0557295782$var$Yd), $86cb4b0557295782$var$$d = [
    9,
    13,
    27,
    32
], $86cb4b0557295782$var$ae = $86cb4b0557295782$var$ia && "CompositionEvent" in window, $86cb4b0557295782$var$be = null;
$86cb4b0557295782$var$ia && "documentMode" in document && ($86cb4b0557295782$var$be = document.documentMode);
var $86cb4b0557295782$var$ce = $86cb4b0557295782$var$ia && "TextEvent" in window && !$86cb4b0557295782$var$be, $86cb4b0557295782$var$de = $86cb4b0557295782$var$ia && (!$86cb4b0557295782$var$ae || $86cb4b0557295782$var$be && 8 < $86cb4b0557295782$var$be && 11 >= $86cb4b0557295782$var$be), $86cb4b0557295782$var$ee = String.fromCharCode(32), $86cb4b0557295782$var$fe = !1;
function $86cb4b0557295782$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $86cb4b0557295782$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $86cb4b0557295782$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $86cb4b0557295782$var$ie = !1;
function $86cb4b0557295782$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $86cb4b0557295782$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $86cb4b0557295782$var$fe = !0;
            return $86cb4b0557295782$var$ee;
        case "textInput":
            return a = b.data, a === $86cb4b0557295782$var$ee && $86cb4b0557295782$var$fe ? null : a;
        default:
            return null;
    }
}
function $86cb4b0557295782$var$ke(a, b) {
    if ($86cb4b0557295782$var$ie) return "compositionend" === a || !$86cb4b0557295782$var$ae && $86cb4b0557295782$var$ge(a, b) ? (a = $86cb4b0557295782$var$nd(), $86cb4b0557295782$var$md = $86cb4b0557295782$var$ld = $86cb4b0557295782$var$kd = null, $86cb4b0557295782$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $86cb4b0557295782$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $86cb4b0557295782$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $86cb4b0557295782$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$86cb4b0557295782$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $86cb4b0557295782$var$ne(a, b, c, d) {
    $86cb4b0557295782$var$Eb(d);
    b = $86cb4b0557295782$var$oe(b, "onChange");
    0 < b.length && (c = new $86cb4b0557295782$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $86cb4b0557295782$var$pe = null, $86cb4b0557295782$var$qe = null;
function $86cb4b0557295782$var$re(a) {
    $86cb4b0557295782$var$se(a, 0);
}
function $86cb4b0557295782$var$te(a) {
    var b = $86cb4b0557295782$var$ue(a);
    if ($86cb4b0557295782$var$Wa(b)) return a;
}
function $86cb4b0557295782$var$ve(a, b) {
    if ("change" === a) return b;
}
var $86cb4b0557295782$var$we = !1;
if ($86cb4b0557295782$var$ia) {
    var $86cb4b0557295782$var$xe;
    if ($86cb4b0557295782$var$ia) {
        var $86cb4b0557295782$var$ye = "oninput" in document;
        if (!$86cb4b0557295782$var$ye) {
            var $86cb4b0557295782$var$ze = document.createElement("div");
            $86cb4b0557295782$var$ze.setAttribute("oninput", "return;");
            $86cb4b0557295782$var$ye = "function" === typeof $86cb4b0557295782$var$ze.oninput;
        }
        $86cb4b0557295782$var$xe = $86cb4b0557295782$var$ye;
    } else $86cb4b0557295782$var$xe = !1;
    $86cb4b0557295782$var$we = $86cb4b0557295782$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $86cb4b0557295782$var$Ae() {
    $86cb4b0557295782$var$pe && ($86cb4b0557295782$var$pe.detachEvent("onpropertychange", $86cb4b0557295782$var$Be), $86cb4b0557295782$var$qe = $86cb4b0557295782$var$pe = null);
}
function $86cb4b0557295782$var$Be(a) {
    if ("value" === a.propertyName && $86cb4b0557295782$var$te($86cb4b0557295782$var$qe)) {
        var b = [];
        $86cb4b0557295782$var$ne(b, $86cb4b0557295782$var$qe, a, $86cb4b0557295782$var$xb(a));
        $86cb4b0557295782$var$Jb($86cb4b0557295782$var$re, b);
    }
}
function $86cb4b0557295782$var$Ce(a, b, c) {
    "focusin" === a ? ($86cb4b0557295782$var$Ae(), $86cb4b0557295782$var$pe = b, $86cb4b0557295782$var$qe = c, $86cb4b0557295782$var$pe.attachEvent("onpropertychange", $86cb4b0557295782$var$Be)) : "focusout" === a && $86cb4b0557295782$var$Ae();
}
function $86cb4b0557295782$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $86cb4b0557295782$var$te($86cb4b0557295782$var$qe);
}
function $86cb4b0557295782$var$Ee(a, b) {
    if ("click" === a) return $86cb4b0557295782$var$te(b);
}
function $86cb4b0557295782$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $86cb4b0557295782$var$te(b);
}
function $86cb4b0557295782$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $86cb4b0557295782$var$He = "function" === typeof Object.is ? Object.is : $86cb4b0557295782$var$Ge;
function $86cb4b0557295782$var$Ie(a, b) {
    if ($86cb4b0557295782$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$86cb4b0557295782$var$ja.call(b, e) || !$86cb4b0557295782$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $86cb4b0557295782$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $86cb4b0557295782$var$Ke(a, b) {
    var c = $86cb4b0557295782$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $86cb4b0557295782$var$Je(c);
    }
}
function $86cb4b0557295782$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $86cb4b0557295782$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $86cb4b0557295782$var$Me() {
    for(var a = window, b = $86cb4b0557295782$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $86cb4b0557295782$var$Xa(a.document);
    }
    return b;
}
function $86cb4b0557295782$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $86cb4b0557295782$var$Oe(a) {
    var b = $86cb4b0557295782$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $86cb4b0557295782$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $86cb4b0557295782$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $86cb4b0557295782$var$Ke(c, f);
                var g = $86cb4b0557295782$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $86cb4b0557295782$var$Pe = $86cb4b0557295782$var$ia && "documentMode" in document && 11 >= document.documentMode, $86cb4b0557295782$var$Qe = null, $86cb4b0557295782$var$Re = null, $86cb4b0557295782$var$Se = null, $86cb4b0557295782$var$Te = !1;
function $86cb4b0557295782$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $86cb4b0557295782$var$Te || null == $86cb4b0557295782$var$Qe || $86cb4b0557295782$var$Qe !== $86cb4b0557295782$var$Xa(d) || (d = $86cb4b0557295782$var$Qe, "selectionStart" in d && $86cb4b0557295782$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $86cb4b0557295782$var$Se && $86cb4b0557295782$var$Ie($86cb4b0557295782$var$Se, d) || ($86cb4b0557295782$var$Se = d, d = $86cb4b0557295782$var$oe($86cb4b0557295782$var$Re, "onSelect"), 0 < d.length && (b = new $86cb4b0557295782$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $86cb4b0557295782$var$Qe)));
}
function $86cb4b0557295782$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $86cb4b0557295782$var$We = {
    animationend: $86cb4b0557295782$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $86cb4b0557295782$var$Ve("Animation", "AnimationIteration"),
    animationstart: $86cb4b0557295782$var$Ve("Animation", "AnimationStart"),
    transitionend: $86cb4b0557295782$var$Ve("Transition", "TransitionEnd")
}, $86cb4b0557295782$var$Xe = {}, $86cb4b0557295782$var$Ye = {};
$86cb4b0557295782$var$ia && ($86cb4b0557295782$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $86cb4b0557295782$var$We.animationend.animation, delete $86cb4b0557295782$var$We.animationiteration.animation, delete $86cb4b0557295782$var$We.animationstart.animation), "TransitionEvent" in window || delete $86cb4b0557295782$var$We.transitionend.transition);
function $86cb4b0557295782$var$Ze(a) {
    if ($86cb4b0557295782$var$Xe[a]) return $86cb4b0557295782$var$Xe[a];
    if (!$86cb4b0557295782$var$We[a]) return a;
    var b = $86cb4b0557295782$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $86cb4b0557295782$var$Ye) return $86cb4b0557295782$var$Xe[a] = b[c];
    return a;
}
var $86cb4b0557295782$var$$e = $86cb4b0557295782$var$Ze("animationend"), $86cb4b0557295782$var$af = $86cb4b0557295782$var$Ze("animationiteration"), $86cb4b0557295782$var$bf = $86cb4b0557295782$var$Ze("animationstart"), $86cb4b0557295782$var$cf = $86cb4b0557295782$var$Ze("transitionend"), $86cb4b0557295782$var$df = new Map, $86cb4b0557295782$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $86cb4b0557295782$var$ff(a, b) {
    $86cb4b0557295782$var$df.set(a, b);
    $86cb4b0557295782$var$fa(b, [
        a
    ]);
}
for(var $86cb4b0557295782$var$gf = 0; $86cb4b0557295782$var$gf < $86cb4b0557295782$var$ef.length; $86cb4b0557295782$var$gf++){
    var $86cb4b0557295782$var$hf = $86cb4b0557295782$var$ef[$86cb4b0557295782$var$gf], $86cb4b0557295782$var$jf = $86cb4b0557295782$var$hf.toLowerCase(), $86cb4b0557295782$var$kf = $86cb4b0557295782$var$hf[0].toUpperCase() + $86cb4b0557295782$var$hf.slice(1);
    $86cb4b0557295782$var$ff($86cb4b0557295782$var$jf, "on" + $86cb4b0557295782$var$kf);
}
$86cb4b0557295782$var$ff($86cb4b0557295782$var$$e, "onAnimationEnd");
$86cb4b0557295782$var$ff($86cb4b0557295782$var$af, "onAnimationIteration");
$86cb4b0557295782$var$ff($86cb4b0557295782$var$bf, "onAnimationStart");
$86cb4b0557295782$var$ff("dblclick", "onDoubleClick");
$86cb4b0557295782$var$ff("focusin", "onFocus");
$86cb4b0557295782$var$ff("focusout", "onBlur");
$86cb4b0557295782$var$ff($86cb4b0557295782$var$cf, "onTransitionEnd");
$86cb4b0557295782$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$86cb4b0557295782$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$86cb4b0557295782$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$86cb4b0557295782$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$86cb4b0557295782$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$86cb4b0557295782$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$86cb4b0557295782$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$86cb4b0557295782$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$86cb4b0557295782$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$86cb4b0557295782$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $86cb4b0557295782$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $86cb4b0557295782$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($86cb4b0557295782$var$lf));
function $86cb4b0557295782$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $86cb4b0557295782$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $86cb4b0557295782$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $86cb4b0557295782$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $86cb4b0557295782$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($86cb4b0557295782$var$Qb) throw a = $86cb4b0557295782$var$Rb, $86cb4b0557295782$var$Qb = !1, $86cb4b0557295782$var$Rb = null, a;
}
function $86cb4b0557295782$var$D(a, b) {
    var c = b[$86cb4b0557295782$var$of];
    void 0 === c && (c = b[$86cb4b0557295782$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($86cb4b0557295782$var$pf(b, a, 2, !1), c.add(d));
}
function $86cb4b0557295782$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $86cb4b0557295782$var$pf(c, a, d, b);
}
var $86cb4b0557295782$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $86cb4b0557295782$var$sf(a) {
    if (!a[$86cb4b0557295782$var$rf]) {
        a[$86cb4b0557295782$var$rf] = !0;
        $86cb4b0557295782$var$da.forEach(function(b) {
            "selectionchange" !== b && ($86cb4b0557295782$var$mf.has(b) || $86cb4b0557295782$var$qf(b, !1, a), $86cb4b0557295782$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$86cb4b0557295782$var$rf] || (b[$86cb4b0557295782$var$rf] = !0, $86cb4b0557295782$var$qf("selectionchange", !1, b));
    }
}
function $86cb4b0557295782$var$pf(a, b, c, d) {
    switch($86cb4b0557295782$var$jd(b)){
        case 1:
            var e = $86cb4b0557295782$var$ed;
            break;
        case 4:
            e = $86cb4b0557295782$var$gd;
            break;
        default:
            e = $86cb4b0557295782$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$86cb4b0557295782$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $86cb4b0557295782$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $86cb4b0557295782$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $86cb4b0557295782$var$Jb(function() {
        var d = f, e = $86cb4b0557295782$var$xb(c), g = [];
        a: {
            var h = $86cb4b0557295782$var$df.get(a);
            if (void 0 !== h) {
                var k = $86cb4b0557295782$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $86cb4b0557295782$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $86cb4b0557295782$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $86cb4b0557295782$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $86cb4b0557295782$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $86cb4b0557295782$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $86cb4b0557295782$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $86cb4b0557295782$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $86cb4b0557295782$var$Vd;
                        break;
                    case $86cb4b0557295782$var$$e:
                    case $86cb4b0557295782$var$af:
                    case $86cb4b0557295782$var$bf:
                        k = $86cb4b0557295782$var$Hd;
                        break;
                    case $86cb4b0557295782$var$cf:
                        k = $86cb4b0557295782$var$Xd;
                        break;
                    case "scroll":
                        k = $86cb4b0557295782$var$vd;
                        break;
                    case "wheel":
                        k = $86cb4b0557295782$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $86cb4b0557295782$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $86cb4b0557295782$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $86cb4b0557295782$var$Kb(w, x), null != F && t.push($86cb4b0557295782$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $86cb4b0557295782$var$wb && (n = c.relatedTarget || c.fromElement) && ($86cb4b0557295782$var$Wc(n) || n[$86cb4b0557295782$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $86cb4b0557295782$var$Wc(n) : null, null !== n && (J = $86cb4b0557295782$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $86cb4b0557295782$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $86cb4b0557295782$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $86cb4b0557295782$var$ue(k);
                        u = null == n ? h : $86cb4b0557295782$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $86cb4b0557295782$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $86cb4b0557295782$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $86cb4b0557295782$var$vf(F))u++;
                            for(; 0 < w - u;)t = $86cb4b0557295782$var$vf(t), w--;
                            for(; 0 < u - w;)x = $86cb4b0557295782$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $86cb4b0557295782$var$vf(t);
                                x = $86cb4b0557295782$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $86cb4b0557295782$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $86cb4b0557295782$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $86cb4b0557295782$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $86cb4b0557295782$var$ve;
                else if ($86cb4b0557295782$var$me(h)) {
                    if ($86cb4b0557295782$var$we) na = $86cb4b0557295782$var$Fe;
                    else {
                        na = $86cb4b0557295782$var$De;
                        var xa = $86cb4b0557295782$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $86cb4b0557295782$var$Ee);
                if (na && (na = na(a, d))) {
                    $86cb4b0557295782$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $86cb4b0557295782$var$cb(h, "number", h.value);
            }
            xa = d ? $86cb4b0557295782$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($86cb4b0557295782$var$me(xa) || "true" === xa.contentEditable) $86cb4b0557295782$var$Qe = xa, $86cb4b0557295782$var$Re = d, $86cb4b0557295782$var$Se = null;
                    break;
                case "focusout":
                    $86cb4b0557295782$var$Se = $86cb4b0557295782$var$Re = $86cb4b0557295782$var$Qe = null;
                    break;
                case "mousedown":
                    $86cb4b0557295782$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $86cb4b0557295782$var$Te = !1;
                    $86cb4b0557295782$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($86cb4b0557295782$var$Pe) break;
                case "keydown":
                case "keyup":
                    $86cb4b0557295782$var$Ue(g, c, e);
            }
            var $a;
            if ($86cb4b0557295782$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $86cb4b0557295782$var$ie ? $86cb4b0557295782$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($86cb4b0557295782$var$de && "ko" !== c.locale && ($86cb4b0557295782$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $86cb4b0557295782$var$ie && ($a = $86cb4b0557295782$var$nd()) : ($86cb4b0557295782$var$kd = e, $86cb4b0557295782$var$ld = "value" in $86cb4b0557295782$var$kd ? $86cb4b0557295782$var$kd.value : $86cb4b0557295782$var$kd.textContent, $86cb4b0557295782$var$ie = !0)), xa = $86cb4b0557295782$var$oe(d, ba), 0 < xa.length && (ba = new $86cb4b0557295782$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $86cb4b0557295782$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $86cb4b0557295782$var$ce ? $86cb4b0557295782$var$je(a, c) : $86cb4b0557295782$var$ke(a, c)) d = $86cb4b0557295782$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $86cb4b0557295782$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $86cb4b0557295782$var$se(g, b);
    });
}
function $86cb4b0557295782$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $86cb4b0557295782$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $86cb4b0557295782$var$Kb(a, c), null != f && d.unshift($86cb4b0557295782$var$tf(a, f, e)), f = $86cb4b0557295782$var$Kb(a, b), null != f && d.push($86cb4b0557295782$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $86cb4b0557295782$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $86cb4b0557295782$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $86cb4b0557295782$var$Kb(c, f), null != k && g.unshift($86cb4b0557295782$var$tf(c, k, h))) : e || (k = $86cb4b0557295782$var$Kb(c, f), null != k && g.push($86cb4b0557295782$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $86cb4b0557295782$var$xf = /\r\n?/g, $86cb4b0557295782$var$yf = /\u0000|\uFFFD/g;
function $86cb4b0557295782$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($86cb4b0557295782$var$xf, "\n").replace($86cb4b0557295782$var$yf, "");
}
function $86cb4b0557295782$var$Af(a, b, c) {
    b = $86cb4b0557295782$var$zf(b);
    if ($86cb4b0557295782$var$zf(a) !== b && c) throw Error($86cb4b0557295782$var$p(425));
}
function $86cb4b0557295782$var$Bf() {}
var $86cb4b0557295782$var$Cf = null, $86cb4b0557295782$var$Df = null;
function $86cb4b0557295782$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $86cb4b0557295782$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $86cb4b0557295782$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $86cb4b0557295782$var$Hf = "function" === typeof Promise ? Promise : void 0, $86cb4b0557295782$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $86cb4b0557295782$var$Hf ? function(a) {
    return $86cb4b0557295782$var$Hf.resolve(null).then(a).catch($86cb4b0557295782$var$If);
} : $86cb4b0557295782$var$Ff;
function $86cb4b0557295782$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $86cb4b0557295782$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $86cb4b0557295782$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $86cb4b0557295782$var$bd(b);
}
function $86cb4b0557295782$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $86cb4b0557295782$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $86cb4b0557295782$var$Nf = Math.random().toString(36).slice(2), $86cb4b0557295782$var$Of = "__reactFiber$" + $86cb4b0557295782$var$Nf, $86cb4b0557295782$var$Pf = "__reactProps$" + $86cb4b0557295782$var$Nf, $86cb4b0557295782$var$uf = "__reactContainer$" + $86cb4b0557295782$var$Nf, $86cb4b0557295782$var$of = "__reactEvents$" + $86cb4b0557295782$var$Nf, $86cb4b0557295782$var$Qf = "__reactListeners$" + $86cb4b0557295782$var$Nf, $86cb4b0557295782$var$Rf = "__reactHandles$" + $86cb4b0557295782$var$Nf;
function $86cb4b0557295782$var$Wc(a) {
    var b = a[$86cb4b0557295782$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$86cb4b0557295782$var$uf] || c[$86cb4b0557295782$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $86cb4b0557295782$var$Mf(a); null !== a;){
                if (c = a[$86cb4b0557295782$var$Of]) return c;
                a = $86cb4b0557295782$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $86cb4b0557295782$var$Cb(a) {
    a = a[$86cb4b0557295782$var$Of] || a[$86cb4b0557295782$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $86cb4b0557295782$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($86cb4b0557295782$var$p(33));
}
function $86cb4b0557295782$var$Db(a) {
    return a[$86cb4b0557295782$var$Pf] || null;
}
var $86cb4b0557295782$var$Sf = [], $86cb4b0557295782$var$Tf = -1;
function $86cb4b0557295782$var$Uf(a) {
    return {
        current: a
    };
}
function $86cb4b0557295782$var$E(a) {
    0 > $86cb4b0557295782$var$Tf || (a.current = $86cb4b0557295782$var$Sf[$86cb4b0557295782$var$Tf], $86cb4b0557295782$var$Sf[$86cb4b0557295782$var$Tf] = null, $86cb4b0557295782$var$Tf--);
}
function $86cb4b0557295782$var$G(a, b) {
    $86cb4b0557295782$var$Tf++;
    $86cb4b0557295782$var$Sf[$86cb4b0557295782$var$Tf] = a.current;
    a.current = b;
}
var $86cb4b0557295782$var$Vf = {}, $86cb4b0557295782$var$H = $86cb4b0557295782$var$Uf($86cb4b0557295782$var$Vf), $86cb4b0557295782$var$Wf = $86cb4b0557295782$var$Uf(!1), $86cb4b0557295782$var$Xf = $86cb4b0557295782$var$Vf;
function $86cb4b0557295782$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $86cb4b0557295782$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $86cb4b0557295782$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $86cb4b0557295782$var$$f() {
    $86cb4b0557295782$var$E($86cb4b0557295782$var$Wf);
    $86cb4b0557295782$var$E($86cb4b0557295782$var$H);
}
function $86cb4b0557295782$var$ag(a, b, c) {
    if ($86cb4b0557295782$var$H.current !== $86cb4b0557295782$var$Vf) throw Error($86cb4b0557295782$var$p(168));
    $86cb4b0557295782$var$G($86cb4b0557295782$var$H, b);
    $86cb4b0557295782$var$G($86cb4b0557295782$var$Wf, c);
}
function $86cb4b0557295782$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($86cb4b0557295782$var$p(108, $86cb4b0557295782$var$Ra(a) || "Unknown", e));
    return $86cb4b0557295782$var$A({}, c, d);
}
function $86cb4b0557295782$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $86cb4b0557295782$var$Vf;
    $86cb4b0557295782$var$Xf = $86cb4b0557295782$var$H.current;
    $86cb4b0557295782$var$G($86cb4b0557295782$var$H, a);
    $86cb4b0557295782$var$G($86cb4b0557295782$var$Wf, $86cb4b0557295782$var$Wf.current);
    return !0;
}
function $86cb4b0557295782$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($86cb4b0557295782$var$p(169));
    c ? (a = $86cb4b0557295782$var$bg(a, b, $86cb4b0557295782$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $86cb4b0557295782$var$E($86cb4b0557295782$var$Wf), $86cb4b0557295782$var$E($86cb4b0557295782$var$H), $86cb4b0557295782$var$G($86cb4b0557295782$var$H, a)) : $86cb4b0557295782$var$E($86cb4b0557295782$var$Wf);
    $86cb4b0557295782$var$G($86cb4b0557295782$var$Wf, c);
}
var $86cb4b0557295782$var$eg = null, $86cb4b0557295782$var$fg = !1, $86cb4b0557295782$var$gg = !1;
function $86cb4b0557295782$var$hg(a) {
    null === $86cb4b0557295782$var$eg ? $86cb4b0557295782$var$eg = [
        a
    ] : $86cb4b0557295782$var$eg.push(a);
}
function $86cb4b0557295782$var$ig(a) {
    $86cb4b0557295782$var$fg = !0;
    $86cb4b0557295782$var$hg(a);
}
function $86cb4b0557295782$var$jg() {
    if (!$86cb4b0557295782$var$gg && null !== $86cb4b0557295782$var$eg) {
        $86cb4b0557295782$var$gg = !0;
        var a = 0, b = $86cb4b0557295782$var$C;
        try {
            var c = $86cb4b0557295782$var$eg;
            for($86cb4b0557295782$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $86cb4b0557295782$var$eg = null;
            $86cb4b0557295782$var$fg = !1;
        } catch (e) {
            throw null !== $86cb4b0557295782$var$eg && ($86cb4b0557295782$var$eg = $86cb4b0557295782$var$eg.slice(a + 1)), $86cb4b0557295782$var$ac($86cb4b0557295782$var$fc, $86cb4b0557295782$var$jg), e;
        } finally{
            $86cb4b0557295782$var$C = b, $86cb4b0557295782$var$gg = !1;
        }
    }
    return null;
}
var $86cb4b0557295782$var$kg = [], $86cb4b0557295782$var$lg = 0, $86cb4b0557295782$var$mg = null, $86cb4b0557295782$var$ng = 0, $86cb4b0557295782$var$og = [], $86cb4b0557295782$var$pg = 0, $86cb4b0557295782$var$qg = null, $86cb4b0557295782$var$rg = 1, $86cb4b0557295782$var$sg = "";
function $86cb4b0557295782$var$tg(a, b) {
    $86cb4b0557295782$var$kg[$86cb4b0557295782$var$lg++] = $86cb4b0557295782$var$ng;
    $86cb4b0557295782$var$kg[$86cb4b0557295782$var$lg++] = $86cb4b0557295782$var$mg;
    $86cb4b0557295782$var$mg = a;
    $86cb4b0557295782$var$ng = b;
}
function $86cb4b0557295782$var$ug(a, b, c) {
    $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg++] = $86cb4b0557295782$var$rg;
    $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg++] = $86cb4b0557295782$var$sg;
    $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg++] = $86cb4b0557295782$var$qg;
    $86cb4b0557295782$var$qg = a;
    var d = $86cb4b0557295782$var$rg;
    a = $86cb4b0557295782$var$sg;
    var e = 32 - $86cb4b0557295782$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $86cb4b0557295782$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $86cb4b0557295782$var$rg = 1 << 32 - $86cb4b0557295782$var$oc(b) + e | c << e | d;
        $86cb4b0557295782$var$sg = f + a;
    } else $86cb4b0557295782$var$rg = 1 << f | c << e | d, $86cb4b0557295782$var$sg = a;
}
function $86cb4b0557295782$var$vg(a) {
    null !== a.return && ($86cb4b0557295782$var$tg(a, 1), $86cb4b0557295782$var$ug(a, 1, 0));
}
function $86cb4b0557295782$var$wg(a) {
    for(; a === $86cb4b0557295782$var$mg;)$86cb4b0557295782$var$mg = $86cb4b0557295782$var$kg[--$86cb4b0557295782$var$lg], $86cb4b0557295782$var$kg[$86cb4b0557295782$var$lg] = null, $86cb4b0557295782$var$ng = $86cb4b0557295782$var$kg[--$86cb4b0557295782$var$lg], $86cb4b0557295782$var$kg[$86cb4b0557295782$var$lg] = null;
    for(; a === $86cb4b0557295782$var$qg;)$86cb4b0557295782$var$qg = $86cb4b0557295782$var$og[--$86cb4b0557295782$var$pg], $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg] = null, $86cb4b0557295782$var$sg = $86cb4b0557295782$var$og[--$86cb4b0557295782$var$pg], $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg] = null, $86cb4b0557295782$var$rg = $86cb4b0557295782$var$og[--$86cb4b0557295782$var$pg], $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg] = null;
}
var $86cb4b0557295782$var$xg = null, $86cb4b0557295782$var$yg = null, $86cb4b0557295782$var$I = !1, $86cb4b0557295782$var$zg = null;
function $86cb4b0557295782$var$Ag(a, b) {
    var c = $86cb4b0557295782$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $86cb4b0557295782$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $86cb4b0557295782$var$xg = a, $86cb4b0557295782$var$yg = $86cb4b0557295782$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $86cb4b0557295782$var$xg = a, $86cb4b0557295782$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $86cb4b0557295782$var$qg ? {
                id: $86cb4b0557295782$var$rg,
                overflow: $86cb4b0557295782$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $86cb4b0557295782$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $86cb4b0557295782$var$xg = a, $86cb4b0557295782$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $86cb4b0557295782$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $86cb4b0557295782$var$Eg(a) {
    if ($86cb4b0557295782$var$I) {
        var b = $86cb4b0557295782$var$yg;
        if (b) {
            var c = b;
            if (!$86cb4b0557295782$var$Cg(a, b)) {
                if ($86cb4b0557295782$var$Dg(a)) throw Error($86cb4b0557295782$var$p(418));
                b = $86cb4b0557295782$var$Lf(c.nextSibling);
                var d = $86cb4b0557295782$var$xg;
                b && $86cb4b0557295782$var$Cg(a, b) ? $86cb4b0557295782$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $86cb4b0557295782$var$I = !1, $86cb4b0557295782$var$xg = a);
            }
        } else {
            if ($86cb4b0557295782$var$Dg(a)) throw Error($86cb4b0557295782$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $86cb4b0557295782$var$I = !1;
            $86cb4b0557295782$var$xg = a;
        }
    }
}
function $86cb4b0557295782$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $86cb4b0557295782$var$xg = a;
}
function $86cb4b0557295782$var$Gg(a) {
    if (a !== $86cb4b0557295782$var$xg) return !1;
    if (!$86cb4b0557295782$var$I) return $86cb4b0557295782$var$Fg(a), $86cb4b0557295782$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$86cb4b0557295782$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $86cb4b0557295782$var$yg)) {
        if ($86cb4b0557295782$var$Dg(a)) throw $86cb4b0557295782$var$Hg(), Error($86cb4b0557295782$var$p(418));
        for(; b;)$86cb4b0557295782$var$Ag(a, b), b = $86cb4b0557295782$var$Lf(b.nextSibling);
    }
    $86cb4b0557295782$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($86cb4b0557295782$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $86cb4b0557295782$var$yg = $86cb4b0557295782$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $86cb4b0557295782$var$yg = null;
        }
    } else $86cb4b0557295782$var$yg = $86cb4b0557295782$var$xg ? $86cb4b0557295782$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $86cb4b0557295782$var$Hg() {
    for(var a = $86cb4b0557295782$var$yg; a;)a = $86cb4b0557295782$var$Lf(a.nextSibling);
}
function $86cb4b0557295782$var$Ig() {
    $86cb4b0557295782$var$yg = $86cb4b0557295782$var$xg = null;
    $86cb4b0557295782$var$I = !1;
}
function $86cb4b0557295782$var$Jg(a) {
    null === $86cb4b0557295782$var$zg ? $86cb4b0557295782$var$zg = [
        a
    ] : $86cb4b0557295782$var$zg.push(a);
}
var $86cb4b0557295782$var$Kg = $86cb4b0557295782$var$ua.ReactCurrentBatchConfig;
function $86cb4b0557295782$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($86cb4b0557295782$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($86cb4b0557295782$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($86cb4b0557295782$var$p(284));
        if (!c._owner) throw Error($86cb4b0557295782$var$p(290, a));
    }
    return a;
}
function $86cb4b0557295782$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($86cb4b0557295782$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $86cb4b0557295782$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $86cb4b0557295782$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $86cb4b0557295782$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $86cb4b0557295782$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $86cb4b0557295782$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $86cb4b0557295782$var$Ha && $86cb4b0557295782$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $86cb4b0557295782$var$Lg(a, b, c), d.return = a, d;
        d = $86cb4b0557295782$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $86cb4b0557295782$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $86cb4b0557295782$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $86cb4b0557295782$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $86cb4b0557295782$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $86cb4b0557295782$var$va:
                    return c = $86cb4b0557295782$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $86cb4b0557295782$var$Lg(a, null, b), c.return = a, c;
                case $86cb4b0557295782$var$wa:
                    return b = $86cb4b0557295782$var$Sg(b, a.mode, c), b.return = a, b;
                case $86cb4b0557295782$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($86cb4b0557295782$var$eb(b) || $86cb4b0557295782$var$Ka(b)) return b = $86cb4b0557295782$var$Tg(b, a.mode, c, null), b.return = a, b;
            $86cb4b0557295782$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $86cb4b0557295782$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $86cb4b0557295782$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $86cb4b0557295782$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($86cb4b0557295782$var$eb(c) || $86cb4b0557295782$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $86cb4b0557295782$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $86cb4b0557295782$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $86cb4b0557295782$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $86cb4b0557295782$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($86cb4b0557295782$var$eb(d) || $86cb4b0557295782$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $86cb4b0557295782$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $86cb4b0557295782$var$I && $86cb4b0557295782$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $86cb4b0557295782$var$I && $86cb4b0557295782$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $86cb4b0557295782$var$I && $86cb4b0557295782$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $86cb4b0557295782$var$Ka(h);
        if ("function" !== typeof l) throw Error($86cb4b0557295782$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($86cb4b0557295782$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $86cb4b0557295782$var$I && $86cb4b0557295782$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $86cb4b0557295782$var$I && $86cb4b0557295782$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $86cb4b0557295782$var$I && $86cb4b0557295782$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $86cb4b0557295782$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $86cb4b0557295782$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $86cb4b0557295782$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $86cb4b0557295782$var$Ha && $86cb4b0557295782$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $86cb4b0557295782$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $86cb4b0557295782$var$ya ? (d = $86cb4b0557295782$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $86cb4b0557295782$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $86cb4b0557295782$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $86cb4b0557295782$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $86cb4b0557295782$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $86cb4b0557295782$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($86cb4b0557295782$var$eb(f)) return n(a, d, f, h);
            if ($86cb4b0557295782$var$Ka(f)) return t(a, d, f, h);
            $86cb4b0557295782$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $86cb4b0557295782$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $86cb4b0557295782$var$Ug = $86cb4b0557295782$var$Og(!0), $86cb4b0557295782$var$Vg = $86cb4b0557295782$var$Og(!1), $86cb4b0557295782$var$Wg = $86cb4b0557295782$var$Uf(null), $86cb4b0557295782$var$Xg = null, $86cb4b0557295782$var$Yg = null, $86cb4b0557295782$var$Zg = null;
function $86cb4b0557295782$var$$g() {
    $86cb4b0557295782$var$Zg = $86cb4b0557295782$var$Yg = $86cb4b0557295782$var$Xg = null;
}
function $86cb4b0557295782$var$ah(a) {
    var b = $86cb4b0557295782$var$Wg.current;
    $86cb4b0557295782$var$E($86cb4b0557295782$var$Wg);
    a._currentValue = b;
}
function $86cb4b0557295782$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $86cb4b0557295782$var$ch(a, b) {
    $86cb4b0557295782$var$Xg = a;
    $86cb4b0557295782$var$Zg = $86cb4b0557295782$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($86cb4b0557295782$var$dh = !0), a.firstContext = null);
}
function $86cb4b0557295782$var$eh(a) {
    var b = a._currentValue;
    if ($86cb4b0557295782$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $86cb4b0557295782$var$Yg) {
            if (null === $86cb4b0557295782$var$Xg) throw Error($86cb4b0557295782$var$p(308));
            $86cb4b0557295782$var$Yg = a;
            $86cb4b0557295782$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $86cb4b0557295782$var$Yg = $86cb4b0557295782$var$Yg.next = a;
    }
    return b;
}
var $86cb4b0557295782$var$fh = null;
function $86cb4b0557295782$var$gh(a) {
    null === $86cb4b0557295782$var$fh ? $86cb4b0557295782$var$fh = [
        a
    ] : $86cb4b0557295782$var$fh.push(a);
}
function $86cb4b0557295782$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $86cb4b0557295782$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $86cb4b0557295782$var$ih(a, d);
}
function $86cb4b0557295782$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $86cb4b0557295782$var$jh = !1;
function $86cb4b0557295782$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $86cb4b0557295782$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $86cb4b0557295782$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $86cb4b0557295782$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($86cb4b0557295782$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $86cb4b0557295782$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $86cb4b0557295782$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $86cb4b0557295782$var$ih(a, c);
}
function $86cb4b0557295782$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $86cb4b0557295782$var$Cc(a, c);
    }
}
function $86cb4b0557295782$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $86cb4b0557295782$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $86cb4b0557295782$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $86cb4b0557295782$var$A({}, q, r);
                            break a;
                        case 2:
                            $86cb4b0557295782$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $86cb4b0557295782$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $86cb4b0557295782$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($86cb4b0557295782$var$p(191, e));
            e.call(d);
        }
    }
}
var $86cb4b0557295782$var$th = {}, $86cb4b0557295782$var$uh = $86cb4b0557295782$var$Uf($86cb4b0557295782$var$th), $86cb4b0557295782$var$vh = $86cb4b0557295782$var$Uf($86cb4b0557295782$var$th), $86cb4b0557295782$var$wh = $86cb4b0557295782$var$Uf($86cb4b0557295782$var$th);
function $86cb4b0557295782$var$xh(a) {
    if (a === $86cb4b0557295782$var$th) throw Error($86cb4b0557295782$var$p(174));
    return a;
}
function $86cb4b0557295782$var$yh(a, b) {
    $86cb4b0557295782$var$G($86cb4b0557295782$var$wh, b);
    $86cb4b0557295782$var$G($86cb4b0557295782$var$vh, a);
    $86cb4b0557295782$var$G($86cb4b0557295782$var$uh, $86cb4b0557295782$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $86cb4b0557295782$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $86cb4b0557295782$var$lb(b, a);
    }
    $86cb4b0557295782$var$E($86cb4b0557295782$var$uh);
    $86cb4b0557295782$var$G($86cb4b0557295782$var$uh, b);
}
function $86cb4b0557295782$var$zh() {
    $86cb4b0557295782$var$E($86cb4b0557295782$var$uh);
    $86cb4b0557295782$var$E($86cb4b0557295782$var$vh);
    $86cb4b0557295782$var$E($86cb4b0557295782$var$wh);
}
function $86cb4b0557295782$var$Ah(a) {
    $86cb4b0557295782$var$xh($86cb4b0557295782$var$wh.current);
    var b = $86cb4b0557295782$var$xh($86cb4b0557295782$var$uh.current);
    var c = $86cb4b0557295782$var$lb(b, a.type);
    b !== c && ($86cb4b0557295782$var$G($86cb4b0557295782$var$vh, a), $86cb4b0557295782$var$G($86cb4b0557295782$var$uh, c));
}
function $86cb4b0557295782$var$Bh(a) {
    $86cb4b0557295782$var$vh.current === a && ($86cb4b0557295782$var$E($86cb4b0557295782$var$uh), $86cb4b0557295782$var$E($86cb4b0557295782$var$vh));
}
var $86cb4b0557295782$var$L = $86cb4b0557295782$var$Uf(0);
function $86cb4b0557295782$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $86cb4b0557295782$var$Dh = [];
function $86cb4b0557295782$var$Eh() {
    for(var a = 0; a < $86cb4b0557295782$var$Dh.length; a++)$86cb4b0557295782$var$Dh[a]._workInProgressVersionPrimary = null;
    $86cb4b0557295782$var$Dh.length = 0;
}
var $86cb4b0557295782$var$Fh = $86cb4b0557295782$var$ua.ReactCurrentDispatcher, $86cb4b0557295782$var$Gh = $86cb4b0557295782$var$ua.ReactCurrentBatchConfig, $86cb4b0557295782$var$Hh = 0, $86cb4b0557295782$var$M = null, $86cb4b0557295782$var$N = null, $86cb4b0557295782$var$O = null, $86cb4b0557295782$var$Ih = !1, $86cb4b0557295782$var$Jh = !1, $86cb4b0557295782$var$Kh = 0, $86cb4b0557295782$var$Lh = 0;
function $86cb4b0557295782$var$P() {
    throw Error($86cb4b0557295782$var$p(321));
}
function $86cb4b0557295782$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$86cb4b0557295782$var$He(a[c], b[c])) return !1;
    return !0;
}
function $86cb4b0557295782$var$Nh(a, b, c, d, e, f) {
    $86cb4b0557295782$var$Hh = f;
    $86cb4b0557295782$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $86cb4b0557295782$var$Fh.current = null === a || null === a.memoizedState ? $86cb4b0557295782$var$Oh : $86cb4b0557295782$var$Ph;
    a = c(d, e);
    if ($86cb4b0557295782$var$Jh) {
        f = 0;
        do {
            $86cb4b0557295782$var$Jh = !1;
            $86cb4b0557295782$var$Kh = 0;
            if (25 <= f) throw Error($86cb4b0557295782$var$p(301));
            f += 1;
            $86cb4b0557295782$var$O = $86cb4b0557295782$var$N = null;
            b.updateQueue = null;
            $86cb4b0557295782$var$Fh.current = $86cb4b0557295782$var$Qh;
            a = c(d, e);
        }while ($86cb4b0557295782$var$Jh);
    }
    $86cb4b0557295782$var$Fh.current = $86cb4b0557295782$var$Rh;
    b = null !== $86cb4b0557295782$var$N && null !== $86cb4b0557295782$var$N.next;
    $86cb4b0557295782$var$Hh = 0;
    $86cb4b0557295782$var$O = $86cb4b0557295782$var$N = $86cb4b0557295782$var$M = null;
    $86cb4b0557295782$var$Ih = !1;
    if (b) throw Error($86cb4b0557295782$var$p(300));
    return a;
}
function $86cb4b0557295782$var$Sh() {
    var a = 0 !== $86cb4b0557295782$var$Kh;
    $86cb4b0557295782$var$Kh = 0;
    return a;
}
function $86cb4b0557295782$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $86cb4b0557295782$var$O ? $86cb4b0557295782$var$M.memoizedState = $86cb4b0557295782$var$O = a : $86cb4b0557295782$var$O = $86cb4b0557295782$var$O.next = a;
    return $86cb4b0557295782$var$O;
}
function $86cb4b0557295782$var$Uh() {
    if (null === $86cb4b0557295782$var$N) {
        var a = $86cb4b0557295782$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $86cb4b0557295782$var$N.next;
    var b = null === $86cb4b0557295782$var$O ? $86cb4b0557295782$var$M.memoizedState : $86cb4b0557295782$var$O.next;
    if (null !== b) $86cb4b0557295782$var$O = b, $86cb4b0557295782$var$N = a;
    else {
        if (null === a) throw Error($86cb4b0557295782$var$p(310));
        $86cb4b0557295782$var$N = a;
        a = {
            memoizedState: $86cb4b0557295782$var$N.memoizedState,
            baseState: $86cb4b0557295782$var$N.baseState,
            baseQueue: $86cb4b0557295782$var$N.baseQueue,
            queue: $86cb4b0557295782$var$N.queue,
            next: null
        };
        null === $86cb4b0557295782$var$O ? $86cb4b0557295782$var$M.memoizedState = $86cb4b0557295782$var$O = a : $86cb4b0557295782$var$O = $86cb4b0557295782$var$O.next = a;
    }
    return $86cb4b0557295782$var$O;
}
function $86cb4b0557295782$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $86cb4b0557295782$var$Wh(a) {
    var b = $86cb4b0557295782$var$Uh(), c = b.queue;
    if (null === c) throw Error($86cb4b0557295782$var$p(311));
    c.lastRenderedReducer = a;
    var d = $86cb4b0557295782$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($86cb4b0557295782$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $86cb4b0557295782$var$M.lanes |= m;
                $86cb4b0557295782$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $86cb4b0557295782$var$He(d, b.memoizedState) || ($86cb4b0557295782$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $86cb4b0557295782$var$M.lanes |= f, $86cb4b0557295782$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $86cb4b0557295782$var$Xh(a) {
    var b = $86cb4b0557295782$var$Uh(), c = b.queue;
    if (null === c) throw Error($86cb4b0557295782$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $86cb4b0557295782$var$He(f, b.memoizedState) || ($86cb4b0557295782$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $86cb4b0557295782$var$Yh() {}
function $86cb4b0557295782$var$Zh(a, b) {
    var c = $86cb4b0557295782$var$M, d = $86cb4b0557295782$var$Uh(), e = b(), f = !$86cb4b0557295782$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $86cb4b0557295782$var$dh = !0);
    d = d.queue;
    $86cb4b0557295782$var$$h($86cb4b0557295782$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $86cb4b0557295782$var$O && $86cb4b0557295782$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $86cb4b0557295782$var$bi(9, $86cb4b0557295782$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $86cb4b0557295782$var$Q) throw Error($86cb4b0557295782$var$p(349));
        0 !== ($86cb4b0557295782$var$Hh & 30) || $86cb4b0557295782$var$di(c, b, e);
    }
    return e;
}
function $86cb4b0557295782$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $86cb4b0557295782$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $86cb4b0557295782$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $86cb4b0557295782$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $86cb4b0557295782$var$ei(b) && $86cb4b0557295782$var$fi(a);
}
function $86cb4b0557295782$var$ai(a, b, c) {
    return c(function() {
        $86cb4b0557295782$var$ei(b) && $86cb4b0557295782$var$fi(a);
    });
}
function $86cb4b0557295782$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$86cb4b0557295782$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $86cb4b0557295782$var$fi(a) {
    var b = $86cb4b0557295782$var$ih(a, 1);
    null !== b && $86cb4b0557295782$var$gi(b, a, 1, -1);
}
function $86cb4b0557295782$var$hi(a) {
    var b = $86cb4b0557295782$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $86cb4b0557295782$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $86cb4b0557295782$var$ii.bind(null, $86cb4b0557295782$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $86cb4b0557295782$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $86cb4b0557295782$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $86cb4b0557295782$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $86cb4b0557295782$var$ji() {
    return $86cb4b0557295782$var$Uh().memoizedState;
}
function $86cb4b0557295782$var$ki(a, b, c, d) {
    var e = $86cb4b0557295782$var$Th();
    $86cb4b0557295782$var$M.flags |= a;
    e.memoizedState = $86cb4b0557295782$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $86cb4b0557295782$var$li(a, b, c, d) {
    var e = $86cb4b0557295782$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $86cb4b0557295782$var$N) {
        var g = $86cb4b0557295782$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $86cb4b0557295782$var$Mh(d, g.deps)) {
            e.memoizedState = $86cb4b0557295782$var$bi(b, c, f, d);
            return;
        }
    }
    $86cb4b0557295782$var$M.flags |= a;
    e.memoizedState = $86cb4b0557295782$var$bi(1 | b, c, f, d);
}
function $86cb4b0557295782$var$mi(a, b) {
    return $86cb4b0557295782$var$ki(8390656, 8, a, b);
}
function $86cb4b0557295782$var$$h(a, b) {
    return $86cb4b0557295782$var$li(2048, 8, a, b);
}
function $86cb4b0557295782$var$ni(a, b) {
    return $86cb4b0557295782$var$li(4, 2, a, b);
}
function $86cb4b0557295782$var$oi(a, b) {
    return $86cb4b0557295782$var$li(4, 4, a, b);
}
function $86cb4b0557295782$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $86cb4b0557295782$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $86cb4b0557295782$var$li(4, 4, $86cb4b0557295782$var$pi.bind(null, b, a), c);
}
function $86cb4b0557295782$var$ri() {}
function $86cb4b0557295782$var$si(a, b) {
    var c = $86cb4b0557295782$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $86cb4b0557295782$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $86cb4b0557295782$var$ti(a, b) {
    var c = $86cb4b0557295782$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $86cb4b0557295782$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $86cb4b0557295782$var$ui(a, b, c) {
    if (0 === ($86cb4b0557295782$var$Hh & 21)) return a.baseState && (a.baseState = !1, $86cb4b0557295782$var$dh = !0), a.memoizedState = c;
    $86cb4b0557295782$var$He(c, b) || (c = $86cb4b0557295782$var$yc(), $86cb4b0557295782$var$M.lanes |= c, $86cb4b0557295782$var$rh |= c, a.baseState = !0);
    return b;
}
function $86cb4b0557295782$var$vi(a, b) {
    var c = $86cb4b0557295782$var$C;
    $86cb4b0557295782$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $86cb4b0557295782$var$Gh.transition;
    $86cb4b0557295782$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $86cb4b0557295782$var$C = c, $86cb4b0557295782$var$Gh.transition = d;
    }
}
function $86cb4b0557295782$var$wi() {
    return $86cb4b0557295782$var$Uh().memoizedState;
}
function $86cb4b0557295782$var$xi(a, b, c) {
    var d = $86cb4b0557295782$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($86cb4b0557295782$var$zi(a)) $86cb4b0557295782$var$Ai(b, c);
    else if (c = $86cb4b0557295782$var$hh(a, b, c, d), null !== c) {
        var e = $86cb4b0557295782$var$R();
        $86cb4b0557295782$var$gi(c, a, d, e);
        $86cb4b0557295782$var$Bi(c, b, d);
    }
}
function $86cb4b0557295782$var$ii(a, b, c) {
    var d = $86cb4b0557295782$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($86cb4b0557295782$var$zi(a)) $86cb4b0557295782$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($86cb4b0557295782$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $86cb4b0557295782$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $86cb4b0557295782$var$hh(a, b, e, d);
        null !== c && (e = $86cb4b0557295782$var$R(), $86cb4b0557295782$var$gi(c, a, d, e), $86cb4b0557295782$var$Bi(c, b, d));
    }
}
function $86cb4b0557295782$var$zi(a) {
    var b = a.alternate;
    return a === $86cb4b0557295782$var$M || null !== b && b === $86cb4b0557295782$var$M;
}
function $86cb4b0557295782$var$Ai(a, b) {
    $86cb4b0557295782$var$Jh = $86cb4b0557295782$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $86cb4b0557295782$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $86cb4b0557295782$var$Cc(a, c);
    }
}
var $86cb4b0557295782$var$Rh = {
    readContext: $86cb4b0557295782$var$eh,
    useCallback: $86cb4b0557295782$var$P,
    useContext: $86cb4b0557295782$var$P,
    useEffect: $86cb4b0557295782$var$P,
    useImperativeHandle: $86cb4b0557295782$var$P,
    useInsertionEffect: $86cb4b0557295782$var$P,
    useLayoutEffect: $86cb4b0557295782$var$P,
    useMemo: $86cb4b0557295782$var$P,
    useReducer: $86cb4b0557295782$var$P,
    useRef: $86cb4b0557295782$var$P,
    useState: $86cb4b0557295782$var$P,
    useDebugValue: $86cb4b0557295782$var$P,
    useDeferredValue: $86cb4b0557295782$var$P,
    useTransition: $86cb4b0557295782$var$P,
    useMutableSource: $86cb4b0557295782$var$P,
    useSyncExternalStore: $86cb4b0557295782$var$P,
    useId: $86cb4b0557295782$var$P,
    unstable_isNewReconciler: !1
}, $86cb4b0557295782$var$Oh = {
    readContext: $86cb4b0557295782$var$eh,
    useCallback: function(a, b) {
        $86cb4b0557295782$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $86cb4b0557295782$var$eh,
    useEffect: $86cb4b0557295782$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $86cb4b0557295782$var$ki(4194308, 4, $86cb4b0557295782$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $86cb4b0557295782$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $86cb4b0557295782$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $86cb4b0557295782$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $86cb4b0557295782$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $86cb4b0557295782$var$xi.bind(null, $86cb4b0557295782$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $86cb4b0557295782$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $86cb4b0557295782$var$hi,
    useDebugValue: $86cb4b0557295782$var$ri,
    useDeferredValue: function(a) {
        return $86cb4b0557295782$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $86cb4b0557295782$var$hi(!1), b = a[0];
        a = $86cb4b0557295782$var$vi.bind(null, a[1]);
        $86cb4b0557295782$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $86cb4b0557295782$var$M, e = $86cb4b0557295782$var$Th();
        if ($86cb4b0557295782$var$I) {
            if (void 0 === c) throw Error($86cb4b0557295782$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $86cb4b0557295782$var$Q) throw Error($86cb4b0557295782$var$p(349));
            0 !== ($86cb4b0557295782$var$Hh & 30) || $86cb4b0557295782$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $86cb4b0557295782$var$mi($86cb4b0557295782$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $86cb4b0557295782$var$bi(9, $86cb4b0557295782$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $86cb4b0557295782$var$Th(), b = $86cb4b0557295782$var$Q.identifierPrefix;
        if ($86cb4b0557295782$var$I) {
            var c = $86cb4b0557295782$var$sg;
            var d = $86cb4b0557295782$var$rg;
            c = (d & ~(1 << 32 - $86cb4b0557295782$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $86cb4b0557295782$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $86cb4b0557295782$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $86cb4b0557295782$var$Ph = {
    readContext: $86cb4b0557295782$var$eh,
    useCallback: $86cb4b0557295782$var$si,
    useContext: $86cb4b0557295782$var$eh,
    useEffect: $86cb4b0557295782$var$$h,
    useImperativeHandle: $86cb4b0557295782$var$qi,
    useInsertionEffect: $86cb4b0557295782$var$ni,
    useLayoutEffect: $86cb4b0557295782$var$oi,
    useMemo: $86cb4b0557295782$var$ti,
    useReducer: $86cb4b0557295782$var$Wh,
    useRef: $86cb4b0557295782$var$ji,
    useState: function() {
        return $86cb4b0557295782$var$Wh($86cb4b0557295782$var$Vh);
    },
    useDebugValue: $86cb4b0557295782$var$ri,
    useDeferredValue: function(a) {
        var b = $86cb4b0557295782$var$Uh();
        return $86cb4b0557295782$var$ui(b, $86cb4b0557295782$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $86cb4b0557295782$var$Wh($86cb4b0557295782$var$Vh)[0], b = $86cb4b0557295782$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $86cb4b0557295782$var$Yh,
    useSyncExternalStore: $86cb4b0557295782$var$Zh,
    useId: $86cb4b0557295782$var$wi,
    unstable_isNewReconciler: !1
}, $86cb4b0557295782$var$Qh = {
    readContext: $86cb4b0557295782$var$eh,
    useCallback: $86cb4b0557295782$var$si,
    useContext: $86cb4b0557295782$var$eh,
    useEffect: $86cb4b0557295782$var$$h,
    useImperativeHandle: $86cb4b0557295782$var$qi,
    useInsertionEffect: $86cb4b0557295782$var$ni,
    useLayoutEffect: $86cb4b0557295782$var$oi,
    useMemo: $86cb4b0557295782$var$ti,
    useReducer: $86cb4b0557295782$var$Xh,
    useRef: $86cb4b0557295782$var$ji,
    useState: function() {
        return $86cb4b0557295782$var$Xh($86cb4b0557295782$var$Vh);
    },
    useDebugValue: $86cb4b0557295782$var$ri,
    useDeferredValue: function(a) {
        var b = $86cb4b0557295782$var$Uh();
        return null === $86cb4b0557295782$var$N ? b.memoizedState = a : $86cb4b0557295782$var$ui(b, $86cb4b0557295782$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $86cb4b0557295782$var$Xh($86cb4b0557295782$var$Vh)[0], b = $86cb4b0557295782$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $86cb4b0557295782$var$Yh,
    useSyncExternalStore: $86cb4b0557295782$var$Zh,
    useId: $86cb4b0557295782$var$wi,
    unstable_isNewReconciler: !1
};
function $86cb4b0557295782$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $86cb4b0557295782$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $86cb4b0557295782$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $86cb4b0557295782$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $86cb4b0557295782$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $86cb4b0557295782$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $86cb4b0557295782$var$R(), e = $86cb4b0557295782$var$yi(a), f = $86cb4b0557295782$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $86cb4b0557295782$var$nh(a, f, e);
        null !== b && ($86cb4b0557295782$var$gi(b, a, e, d), $86cb4b0557295782$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $86cb4b0557295782$var$R(), e = $86cb4b0557295782$var$yi(a), f = $86cb4b0557295782$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $86cb4b0557295782$var$nh(a, f, e);
        null !== b && ($86cb4b0557295782$var$gi(b, a, e, d), $86cb4b0557295782$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $86cb4b0557295782$var$R(), d = $86cb4b0557295782$var$yi(a), e = $86cb4b0557295782$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $86cb4b0557295782$var$nh(a, e, d);
        null !== b && ($86cb4b0557295782$var$gi(b, a, d, c), $86cb4b0557295782$var$oh(b, a, d));
    }
};
function $86cb4b0557295782$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$86cb4b0557295782$var$Ie(c, d) || !$86cb4b0557295782$var$Ie(e, f) : !0;
}
function $86cb4b0557295782$var$Gi(a, b, c) {
    var d = !1, e = $86cb4b0557295782$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $86cb4b0557295782$var$eh(f) : (e = $86cb4b0557295782$var$Zf(b) ? $86cb4b0557295782$var$Xf : $86cb4b0557295782$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $86cb4b0557295782$var$Yf(a, e) : $86cb4b0557295782$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $86cb4b0557295782$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $86cb4b0557295782$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $86cb4b0557295782$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $86cb4b0557295782$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $86cb4b0557295782$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $86cb4b0557295782$var$eh(f) : (f = $86cb4b0557295782$var$Zf(b) ? $86cb4b0557295782$var$Xf : $86cb4b0557295782$var$H.current, e.context = $86cb4b0557295782$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($86cb4b0557295782$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $86cb4b0557295782$var$Ei.enqueueReplaceState(e, e.state, null), $86cb4b0557295782$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $86cb4b0557295782$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $86cb4b0557295782$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $86cb4b0557295782$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $86cb4b0557295782$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $86cb4b0557295782$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $86cb4b0557295782$var$Ni(a, b, c) {
    c = $86cb4b0557295782$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $86cb4b0557295782$var$Oi || ($86cb4b0557295782$var$Oi = !0, $86cb4b0557295782$var$Pi = d);
        $86cb4b0557295782$var$Li(a, b);
    };
    return c;
}
function $86cb4b0557295782$var$Qi(a, b, c) {
    c = $86cb4b0557295782$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $86cb4b0557295782$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $86cb4b0557295782$var$Li(a, b);
        "function" !== typeof d && (null === $86cb4b0557295782$var$Ri ? $86cb4b0557295782$var$Ri = new Set([
            this
        ]) : $86cb4b0557295782$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $86cb4b0557295782$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $86cb4b0557295782$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $86cb4b0557295782$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $86cb4b0557295782$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $86cb4b0557295782$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $86cb4b0557295782$var$mh(-1, 1), b.tag = 2, $86cb4b0557295782$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $86cb4b0557295782$var$Wi = $86cb4b0557295782$var$ua.ReactCurrentOwner, $86cb4b0557295782$var$dh = !1;
function $86cb4b0557295782$var$Xi(a, b, c, d) {
    b.child = null === a ? $86cb4b0557295782$var$Vg(b, null, c, d) : $86cb4b0557295782$var$Ug(b, a.child, c, d);
}
function $86cb4b0557295782$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $86cb4b0557295782$var$ch(b, e);
    d = $86cb4b0557295782$var$Nh(a, b, c, d, f, e);
    c = $86cb4b0557295782$var$Sh();
    if (null !== a && !$86cb4b0557295782$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $86cb4b0557295782$var$Zi(a, b, e);
    $86cb4b0557295782$var$I && c && $86cb4b0557295782$var$vg(b);
    b.flags |= 1;
    $86cb4b0557295782$var$Xi(a, b, d, e);
    return b.child;
}
function $86cb4b0557295782$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$86cb4b0557295782$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $86cb4b0557295782$var$bj(a, b, f, d, e);
        a = $86cb4b0557295782$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $86cb4b0557295782$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $86cb4b0557295782$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $86cb4b0557295782$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $86cb4b0557295782$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($86cb4b0557295782$var$Ie(f, d) && a.ref === b.ref) {
            if ($86cb4b0557295782$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($86cb4b0557295782$var$dh = !0);
            else return b.lanes = a.lanes, $86cb4b0557295782$var$Zi(a, b, e);
        }
    }
    return $86cb4b0557295782$var$cj(a, b, c, d, e);
}
function $86cb4b0557295782$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $86cb4b0557295782$var$G($86cb4b0557295782$var$ej, $86cb4b0557295782$var$fj), $86cb4b0557295782$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $86cb4b0557295782$var$G($86cb4b0557295782$var$ej, $86cb4b0557295782$var$fj), $86cb4b0557295782$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $86cb4b0557295782$var$G($86cb4b0557295782$var$ej, $86cb4b0557295782$var$fj);
            $86cb4b0557295782$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $86cb4b0557295782$var$G($86cb4b0557295782$var$ej, $86cb4b0557295782$var$fj), $86cb4b0557295782$var$fj |= d;
    $86cb4b0557295782$var$Xi(a, b, e, c);
    return b.child;
}
function $86cb4b0557295782$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $86cb4b0557295782$var$cj(a, b, c, d, e) {
    var f = $86cb4b0557295782$var$Zf(c) ? $86cb4b0557295782$var$Xf : $86cb4b0557295782$var$H.current;
    f = $86cb4b0557295782$var$Yf(b, f);
    $86cb4b0557295782$var$ch(b, e);
    c = $86cb4b0557295782$var$Nh(a, b, c, d, f, e);
    d = $86cb4b0557295782$var$Sh();
    if (null !== a && !$86cb4b0557295782$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $86cb4b0557295782$var$Zi(a, b, e);
    $86cb4b0557295782$var$I && d && $86cb4b0557295782$var$vg(b);
    b.flags |= 1;
    $86cb4b0557295782$var$Xi(a, b, c, e);
    return b.child;
}
function $86cb4b0557295782$var$hj(a, b, c, d, e) {
    if ($86cb4b0557295782$var$Zf(c)) {
        var f = !0;
        $86cb4b0557295782$var$cg(b);
    } else f = !1;
    $86cb4b0557295782$var$ch(b, e);
    if (null === b.stateNode) $86cb4b0557295782$var$ij(a, b), $86cb4b0557295782$var$Gi(b, c, d), $86cb4b0557295782$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $86cb4b0557295782$var$eh(l) : (l = $86cb4b0557295782$var$Zf(c) ? $86cb4b0557295782$var$Xf : $86cb4b0557295782$var$H.current, l = $86cb4b0557295782$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $86cb4b0557295782$var$Hi(b, g, d, l);
        $86cb4b0557295782$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $86cb4b0557295782$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $86cb4b0557295782$var$Wf.current || $86cb4b0557295782$var$jh ? ("function" === typeof m && ($86cb4b0557295782$var$Di(b, c, m, d), k = b.memoizedState), (h = $86cb4b0557295782$var$jh || $86cb4b0557295782$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $86cb4b0557295782$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $86cb4b0557295782$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $86cb4b0557295782$var$eh(k) : (k = $86cb4b0557295782$var$Zf(c) ? $86cb4b0557295782$var$Xf : $86cb4b0557295782$var$H.current, k = $86cb4b0557295782$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $86cb4b0557295782$var$Hi(b, g, d, k);
        $86cb4b0557295782$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $86cb4b0557295782$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $86cb4b0557295782$var$Wf.current || $86cb4b0557295782$var$jh ? ("function" === typeof y && ($86cb4b0557295782$var$Di(b, c, y, d), n = b.memoizedState), (l = $86cb4b0557295782$var$jh || $86cb4b0557295782$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $86cb4b0557295782$var$jj(a, b, c, d, f, e);
}
function $86cb4b0557295782$var$jj(a, b, c, d, e, f) {
    $86cb4b0557295782$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $86cb4b0557295782$var$dg(b, c, !1), $86cb4b0557295782$var$Zi(a, b, f);
    d = b.stateNode;
    $86cb4b0557295782$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $86cb4b0557295782$var$Ug(b, a.child, null, f), b.child = $86cb4b0557295782$var$Ug(b, null, h, f)) : $86cb4b0557295782$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $86cb4b0557295782$var$dg(b, c, !0);
    return b.child;
}
function $86cb4b0557295782$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $86cb4b0557295782$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $86cb4b0557295782$var$ag(a, b.context, !1);
    $86cb4b0557295782$var$yh(a, b.containerInfo);
}
function $86cb4b0557295782$var$lj(a, b, c, d, e) {
    $86cb4b0557295782$var$Ig();
    $86cb4b0557295782$var$Jg(e);
    b.flags |= 256;
    $86cb4b0557295782$var$Xi(a, b, c, d);
    return b.child;
}
var $86cb4b0557295782$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $86cb4b0557295782$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $86cb4b0557295782$var$oj(a, b, c) {
    var d = b.pendingProps, e = $86cb4b0557295782$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $86cb4b0557295782$var$G($86cb4b0557295782$var$L, e & 1);
    if (null === a) {
        $86cb4b0557295782$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $86cb4b0557295782$var$pj(g, d, 0, null), a = $86cb4b0557295782$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $86cb4b0557295782$var$nj(c), b.memoizedState = $86cb4b0557295782$var$mj, a) : $86cb4b0557295782$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $86cb4b0557295782$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $86cb4b0557295782$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $86cb4b0557295782$var$Pg(h, f) : (f = $86cb4b0557295782$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $86cb4b0557295782$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $86cb4b0557295782$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $86cb4b0557295782$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $86cb4b0557295782$var$qj(a, b) {
    b = $86cb4b0557295782$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $86cb4b0557295782$var$sj(a, b, c, d) {
    null !== d && $86cb4b0557295782$var$Jg(d);
    $86cb4b0557295782$var$Ug(b, a.child, null, c);
    a = $86cb4b0557295782$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $86cb4b0557295782$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $86cb4b0557295782$var$Ki(Error($86cb4b0557295782$var$p(422))), $86cb4b0557295782$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $86cb4b0557295782$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $86cb4b0557295782$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $86cb4b0557295782$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $86cb4b0557295782$var$nj(g);
        b.memoizedState = $86cb4b0557295782$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $86cb4b0557295782$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($86cb4b0557295782$var$p(419));
        d = $86cb4b0557295782$var$Ki(f, d, void 0);
        return $86cb4b0557295782$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($86cb4b0557295782$var$dh || h) {
        d = $86cb4b0557295782$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $86cb4b0557295782$var$ih(a, e), $86cb4b0557295782$var$gi(d, a, e, -1));
        }
        $86cb4b0557295782$var$tj();
        d = $86cb4b0557295782$var$Ki(Error($86cb4b0557295782$var$p(421)));
        return $86cb4b0557295782$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $86cb4b0557295782$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $86cb4b0557295782$var$yg = $86cb4b0557295782$var$Lf(e.nextSibling);
    $86cb4b0557295782$var$xg = b;
    $86cb4b0557295782$var$I = !0;
    $86cb4b0557295782$var$zg = null;
    null !== a && ($86cb4b0557295782$var$og[$86cb4b0557295782$var$pg++] = $86cb4b0557295782$var$rg, $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg++] = $86cb4b0557295782$var$sg, $86cb4b0557295782$var$og[$86cb4b0557295782$var$pg++] = $86cb4b0557295782$var$qg, $86cb4b0557295782$var$rg = a.id, $86cb4b0557295782$var$sg = a.overflow, $86cb4b0557295782$var$qg = b);
    b = $86cb4b0557295782$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $86cb4b0557295782$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $86cb4b0557295782$var$bh(a.return, b, c);
}
function $86cb4b0557295782$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $86cb4b0557295782$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $86cb4b0557295782$var$Xi(a, b, d.children, c);
    d = $86cb4b0557295782$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $86cb4b0557295782$var$vj(a, c, b);
            else if (19 === a.tag) $86cb4b0557295782$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $86cb4b0557295782$var$G($86cb4b0557295782$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $86cb4b0557295782$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $86cb4b0557295782$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $86cb4b0557295782$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $86cb4b0557295782$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $86cb4b0557295782$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $86cb4b0557295782$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $86cb4b0557295782$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $86cb4b0557295782$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($86cb4b0557295782$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $86cb4b0557295782$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $86cb4b0557295782$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $86cb4b0557295782$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $86cb4b0557295782$var$kj(b);
            $86cb4b0557295782$var$Ig();
            break;
        case 5:
            $86cb4b0557295782$var$Ah(b);
            break;
        case 1:
            $86cb4b0557295782$var$Zf(b.type) && $86cb4b0557295782$var$cg(b);
            break;
        case 4:
            $86cb4b0557295782$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $86cb4b0557295782$var$G($86cb4b0557295782$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $86cb4b0557295782$var$G($86cb4b0557295782$var$L, $86cb4b0557295782$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $86cb4b0557295782$var$oj(a, b, c);
                $86cb4b0557295782$var$G($86cb4b0557295782$var$L, $86cb4b0557295782$var$L.current & 1);
                a = $86cb4b0557295782$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $86cb4b0557295782$var$G($86cb4b0557295782$var$L, $86cb4b0557295782$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $86cb4b0557295782$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $86cb4b0557295782$var$G($86cb4b0557295782$var$L, $86cb4b0557295782$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $86cb4b0557295782$var$dj(a, b, c);
    }
    return $86cb4b0557295782$var$Zi(a, b, c);
}
var $86cb4b0557295782$var$zj, $86cb4b0557295782$var$Aj, $86cb4b0557295782$var$Bj, $86cb4b0557295782$var$Cj;
$86cb4b0557295782$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$86cb4b0557295782$var$Aj = function() {};
$86cb4b0557295782$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $86cb4b0557295782$var$xh($86cb4b0557295782$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $86cb4b0557295782$var$Ya(a, e);
                d = $86cb4b0557295782$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $86cb4b0557295782$var$A({}, e, {
                    value: void 0
                });
                d = $86cb4b0557295782$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $86cb4b0557295782$var$gb(a, e);
                d = $86cb4b0557295782$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $86cb4b0557295782$var$Bf);
        }
        $86cb4b0557295782$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($86cb4b0557295782$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($86cb4b0557295782$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $86cb4b0557295782$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$86cb4b0557295782$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $86cb4b0557295782$var$Dj(a, b) {
    if (!$86cb4b0557295782$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $86cb4b0557295782$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $86cb4b0557295782$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $86cb4b0557295782$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $86cb4b0557295782$var$S(b), null;
        case 1:
            return $86cb4b0557295782$var$Zf(b.type) && $86cb4b0557295782$var$$f(), $86cb4b0557295782$var$S(b), null;
        case 3:
            d = b.stateNode;
            $86cb4b0557295782$var$zh();
            $86cb4b0557295782$var$E($86cb4b0557295782$var$Wf);
            $86cb4b0557295782$var$E($86cb4b0557295782$var$H);
            $86cb4b0557295782$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $86cb4b0557295782$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $86cb4b0557295782$var$zg && ($86cb4b0557295782$var$Fj($86cb4b0557295782$var$zg), $86cb4b0557295782$var$zg = null));
            $86cb4b0557295782$var$Aj(a, b);
            $86cb4b0557295782$var$S(b);
            return null;
        case 5:
            $86cb4b0557295782$var$Bh(b);
            var e = $86cb4b0557295782$var$xh($86cb4b0557295782$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $86cb4b0557295782$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($86cb4b0557295782$var$p(166));
                    $86cb4b0557295782$var$S(b);
                    return null;
                }
                a = $86cb4b0557295782$var$xh($86cb4b0557295782$var$uh.current);
                if ($86cb4b0557295782$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$86cb4b0557295782$var$Of] = b;
                    d[$86cb4b0557295782$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $86cb4b0557295782$var$D("cancel", d);
                            $86cb4b0557295782$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $86cb4b0557295782$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $86cb4b0557295782$var$lf.length; e++)$86cb4b0557295782$var$D($86cb4b0557295782$var$lf[e], d);
                            break;
                        case "source":
                            $86cb4b0557295782$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $86cb4b0557295782$var$D("error", d);
                            $86cb4b0557295782$var$D("load", d);
                            break;
                        case "details":
                            $86cb4b0557295782$var$D("toggle", d);
                            break;
                        case "input":
                            $86cb4b0557295782$var$Za(d, f);
                            $86cb4b0557295782$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $86cb4b0557295782$var$D("invalid", d);
                            break;
                        case "textarea":
                            $86cb4b0557295782$var$hb(d, f), $86cb4b0557295782$var$D("invalid", d);
                    }
                    $86cb4b0557295782$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $86cb4b0557295782$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $86cb4b0557295782$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $86cb4b0557295782$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $86cb4b0557295782$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $86cb4b0557295782$var$Va(d);
                            $86cb4b0557295782$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $86cb4b0557295782$var$Va(d);
                            $86cb4b0557295782$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $86cb4b0557295782$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $86cb4b0557295782$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$86cb4b0557295782$var$Of] = b;
                    a[$86cb4b0557295782$var$Pf] = d;
                    $86cb4b0557295782$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $86cb4b0557295782$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $86cb4b0557295782$var$D("cancel", a);
                                $86cb4b0557295782$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $86cb4b0557295782$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $86cb4b0557295782$var$lf.length; e++)$86cb4b0557295782$var$D($86cb4b0557295782$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $86cb4b0557295782$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $86cb4b0557295782$var$D("error", a);
                                $86cb4b0557295782$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $86cb4b0557295782$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $86cb4b0557295782$var$Za(a, d);
                                e = $86cb4b0557295782$var$Ya(a, d);
                                $86cb4b0557295782$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $86cb4b0557295782$var$A({}, d, {
                                    value: void 0
                                });
                                $86cb4b0557295782$var$D("invalid", a);
                                break;
                            case "textarea":
                                $86cb4b0557295782$var$hb(a, d);
                                e = $86cb4b0557295782$var$gb(a, d);
                                $86cb4b0557295782$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $86cb4b0557295782$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $86cb4b0557295782$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $86cb4b0557295782$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $86cb4b0557295782$var$ob(a, k) : "number" === typeof k && $86cb4b0557295782$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($86cb4b0557295782$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $86cb4b0557295782$var$D("scroll", a) : null != k && $86cb4b0557295782$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $86cb4b0557295782$var$Va(a);
                                $86cb4b0557295782$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $86cb4b0557295782$var$Va(a);
                                $86cb4b0557295782$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $86cb4b0557295782$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $86cb4b0557295782$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $86cb4b0557295782$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $86cb4b0557295782$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $86cb4b0557295782$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $86cb4b0557295782$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($86cb4b0557295782$var$p(166));
                c = $86cb4b0557295782$var$xh($86cb4b0557295782$var$wh.current);
                $86cb4b0557295782$var$xh($86cb4b0557295782$var$uh.current);
                if ($86cb4b0557295782$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$86cb4b0557295782$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $86cb4b0557295782$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $86cb4b0557295782$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $86cb4b0557295782$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$86cb4b0557295782$var$Of] = b, b.stateNode = d;
            }
            $86cb4b0557295782$var$S(b);
            return null;
        case 13:
            $86cb4b0557295782$var$E($86cb4b0557295782$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($86cb4b0557295782$var$I && null !== $86cb4b0557295782$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $86cb4b0557295782$var$Hg(), $86cb4b0557295782$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $86cb4b0557295782$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($86cb4b0557295782$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($86cb4b0557295782$var$p(317));
                        f[$86cb4b0557295782$var$Of] = b;
                    } else $86cb4b0557295782$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $86cb4b0557295782$var$S(b);
                    f = !1;
                } else null !== $86cb4b0557295782$var$zg && ($86cb4b0557295782$var$Fj($86cb4b0557295782$var$zg), $86cb4b0557295782$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($86cb4b0557295782$var$L.current & 1) ? 0 === $86cb4b0557295782$var$T && ($86cb4b0557295782$var$T = 3) : $86cb4b0557295782$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $86cb4b0557295782$var$S(b);
            return null;
        case 4:
            return $86cb4b0557295782$var$zh(), $86cb4b0557295782$var$Aj(a, b), null === a && $86cb4b0557295782$var$sf(b.stateNode.containerInfo), $86cb4b0557295782$var$S(b), null;
        case 10:
            return $86cb4b0557295782$var$ah(b.type._context), $86cb4b0557295782$var$S(b), null;
        case 17:
            return $86cb4b0557295782$var$Zf(b.type) && $86cb4b0557295782$var$$f(), $86cb4b0557295782$var$S(b), null;
        case 19:
            $86cb4b0557295782$var$E($86cb4b0557295782$var$L);
            f = b.memoizedState;
            if (null === f) return $86cb4b0557295782$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $86cb4b0557295782$var$Dj(f, !1);
                else {
                    if (0 !== $86cb4b0557295782$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $86cb4b0557295782$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $86cb4b0557295782$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $86cb4b0557295782$var$G($86cb4b0557295782$var$L, $86cb4b0557295782$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $86cb4b0557295782$var$B() > $86cb4b0557295782$var$Gj && (b.flags |= 128, d = !0, $86cb4b0557295782$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $86cb4b0557295782$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $86cb4b0557295782$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$86cb4b0557295782$var$I) return $86cb4b0557295782$var$S(b), null;
                    } else 2 * $86cb4b0557295782$var$B() - f.renderingStartTime > $86cb4b0557295782$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $86cb4b0557295782$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $86cb4b0557295782$var$B(), b.sibling = null, c = $86cb4b0557295782$var$L.current, $86cb4b0557295782$var$G($86cb4b0557295782$var$L, d ? c & 1 | 2 : c & 1), b;
            $86cb4b0557295782$var$S(b);
            return null;
        case 22:
        case 23:
            return $86cb4b0557295782$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($86cb4b0557295782$var$fj & 1073741824) && ($86cb4b0557295782$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $86cb4b0557295782$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($86cb4b0557295782$var$p(156, b.tag));
}
function $86cb4b0557295782$var$Ij(a, b) {
    $86cb4b0557295782$var$wg(b);
    switch(b.tag){
        case 1:
            return $86cb4b0557295782$var$Zf(b.type) && $86cb4b0557295782$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $86cb4b0557295782$var$zh(), $86cb4b0557295782$var$E($86cb4b0557295782$var$Wf), $86cb4b0557295782$var$E($86cb4b0557295782$var$H), $86cb4b0557295782$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $86cb4b0557295782$var$Bh(b), null;
        case 13:
            $86cb4b0557295782$var$E($86cb4b0557295782$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($86cb4b0557295782$var$p(340));
                $86cb4b0557295782$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $86cb4b0557295782$var$E($86cb4b0557295782$var$L), null;
        case 4:
            return $86cb4b0557295782$var$zh(), null;
        case 10:
            return $86cb4b0557295782$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $86cb4b0557295782$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $86cb4b0557295782$var$Jj = !1, $86cb4b0557295782$var$U = !1, $86cb4b0557295782$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $86cb4b0557295782$var$V = null;
function $86cb4b0557295782$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $86cb4b0557295782$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $86cb4b0557295782$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $86cb4b0557295782$var$W(a, b, d);
    }
}
var $86cb4b0557295782$var$Nj = !1;
function $86cb4b0557295782$var$Oj(a, b) {
    $86cb4b0557295782$var$Cf = $86cb4b0557295782$var$dd;
    a = $86cb4b0557295782$var$Me();
    if ($86cb4b0557295782$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $86cb4b0557295782$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $86cb4b0557295782$var$dd = !1;
    for($86cb4b0557295782$var$V = b; null !== $86cb4b0557295782$var$V;)if (b = $86cb4b0557295782$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $86cb4b0557295782$var$V = a;
    else for(; null !== $86cb4b0557295782$var$V;){
        b = $86cb4b0557295782$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $86cb4b0557295782$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($86cb4b0557295782$var$p(163));
            }
        } catch (F) {
            $86cb4b0557295782$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $86cb4b0557295782$var$V = a;
            break;
        }
        $86cb4b0557295782$var$V = b.return;
    }
    n = $86cb4b0557295782$var$Nj;
    $86cb4b0557295782$var$Nj = !1;
    return n;
}
function $86cb4b0557295782$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $86cb4b0557295782$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $86cb4b0557295782$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $86cb4b0557295782$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $86cb4b0557295782$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $86cb4b0557295782$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$86cb4b0557295782$var$Of], delete b[$86cb4b0557295782$var$Pf], delete b[$86cb4b0557295782$var$of], delete b[$86cb4b0557295782$var$Qf], delete b[$86cb4b0557295782$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $86cb4b0557295782$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $86cb4b0557295782$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $86cb4b0557295782$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $86cb4b0557295782$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $86cb4b0557295782$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($86cb4b0557295782$var$Vj(a, b, c), a = a.sibling; null !== a;)$86cb4b0557295782$var$Vj(a, b, c), a = a.sibling;
}
function $86cb4b0557295782$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($86cb4b0557295782$var$Wj(a, b, c), a = a.sibling; null !== a;)$86cb4b0557295782$var$Wj(a, b, c), a = a.sibling;
}
var $86cb4b0557295782$var$X = null, $86cb4b0557295782$var$Xj = !1;
function $86cb4b0557295782$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$86cb4b0557295782$var$Zj(a, b, c), c = c.sibling;
}
function $86cb4b0557295782$var$Zj(a, b, c) {
    if ($86cb4b0557295782$var$lc && "function" === typeof $86cb4b0557295782$var$lc.onCommitFiberUnmount) try {
        $86cb4b0557295782$var$lc.onCommitFiberUnmount($86cb4b0557295782$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $86cb4b0557295782$var$U || $86cb4b0557295782$var$Lj(c, b);
        case 6:
            var d = $86cb4b0557295782$var$X, e = $86cb4b0557295782$var$Xj;
            $86cb4b0557295782$var$X = null;
            $86cb4b0557295782$var$Yj(a, b, c);
            $86cb4b0557295782$var$X = d;
            $86cb4b0557295782$var$Xj = e;
            null !== $86cb4b0557295782$var$X && ($86cb4b0557295782$var$Xj ? (a = $86cb4b0557295782$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $86cb4b0557295782$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $86cb4b0557295782$var$X && ($86cb4b0557295782$var$Xj ? (a = $86cb4b0557295782$var$X, c = c.stateNode, 8 === a.nodeType ? $86cb4b0557295782$var$Kf(a.parentNode, c) : 1 === a.nodeType && $86cb4b0557295782$var$Kf(a, c), $86cb4b0557295782$var$bd(a)) : $86cb4b0557295782$var$Kf($86cb4b0557295782$var$X, c.stateNode));
            break;
        case 4:
            d = $86cb4b0557295782$var$X;
            e = $86cb4b0557295782$var$Xj;
            $86cb4b0557295782$var$X = c.stateNode.containerInfo;
            $86cb4b0557295782$var$Xj = !0;
            $86cb4b0557295782$var$Yj(a, b, c);
            $86cb4b0557295782$var$X = d;
            $86cb4b0557295782$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$86cb4b0557295782$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $86cb4b0557295782$var$Mj(c, b, g) : 0 !== (f & 4) && $86cb4b0557295782$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $86cb4b0557295782$var$Yj(a, b, c);
            break;
        case 1:
            if (!$86cb4b0557295782$var$U && ($86cb4b0557295782$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $86cb4b0557295782$var$W(c, b, h);
            }
            $86cb4b0557295782$var$Yj(a, b, c);
            break;
        case 21:
            $86cb4b0557295782$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($86cb4b0557295782$var$U = (d = $86cb4b0557295782$var$U) || null !== c.memoizedState, $86cb4b0557295782$var$Yj(a, b, c), $86cb4b0557295782$var$U = d) : $86cb4b0557295782$var$Yj(a, b, c);
            break;
        default:
            $86cb4b0557295782$var$Yj(a, b, c);
    }
}
function $86cb4b0557295782$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $86cb4b0557295782$var$Kj);
        b.forEach(function(b) {
            var d = $86cb4b0557295782$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $86cb4b0557295782$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $86cb4b0557295782$var$X = h.stateNode;
                        $86cb4b0557295782$var$Xj = !1;
                        break a;
                    case 3:
                        $86cb4b0557295782$var$X = h.stateNode.containerInfo;
                        $86cb4b0557295782$var$Xj = !0;
                        break a;
                    case 4:
                        $86cb4b0557295782$var$X = h.stateNode.containerInfo;
                        $86cb4b0557295782$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $86cb4b0557295782$var$X) throw Error($86cb4b0557295782$var$p(160));
            $86cb4b0557295782$var$Zj(f, g, e);
            $86cb4b0557295782$var$X = null;
            $86cb4b0557295782$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $86cb4b0557295782$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$86cb4b0557295782$var$dk(b, a), b = b.sibling;
}
function $86cb4b0557295782$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            if (d & 4) {
                try {
                    $86cb4b0557295782$var$Pj(3, a, a.return), $86cb4b0557295782$var$Qj(3, a);
                } catch (t) {
                    $86cb4b0557295782$var$W(a, a.return, t);
                }
                try {
                    $86cb4b0557295782$var$Pj(5, a, a.return);
                } catch (t) {
                    $86cb4b0557295782$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            d & 512 && null !== c && $86cb4b0557295782$var$Lj(c, c.return);
            break;
        case 5:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            d & 512 && null !== c && $86cb4b0557295782$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $86cb4b0557295782$var$ob(e, "");
                } catch (t) {
                    $86cb4b0557295782$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $86cb4b0557295782$var$ab(e, f);
                    $86cb4b0557295782$var$vb(h, g);
                    var l = $86cb4b0557295782$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $86cb4b0557295782$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $86cb4b0557295782$var$nb(e, q) : "children" === m ? $86cb4b0557295782$var$ob(e, q) : $86cb4b0557295782$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $86cb4b0557295782$var$bb(e, f);
                            break;
                        case "textarea":
                            $86cb4b0557295782$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $86cb4b0557295782$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $86cb4b0557295782$var$fb(e, !!f.multiple, f.defaultValue, !0) : $86cb4b0557295782$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$86cb4b0557295782$var$Pf] = f;
                } catch (t) {
                    $86cb4b0557295782$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($86cb4b0557295782$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $86cb4b0557295782$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $86cb4b0557295782$var$bd(b.containerInfo);
            } catch (t) {
                $86cb4b0557295782$var$W(a, a.return, t);
            }
            break;
        case 4:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            break;
        case 13:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($86cb4b0557295782$var$fk = $86cb4b0557295782$var$B()));
            d & 4 && $86cb4b0557295782$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($86cb4b0557295782$var$U = (l = $86cb4b0557295782$var$U) || m, $86cb4b0557295782$var$ck(b, a), $86cb4b0557295782$var$U = l) : $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($86cb4b0557295782$var$V = a, m = a.child; null !== m;){
                    for(q = $86cb4b0557295782$var$V = m; null !== $86cb4b0557295782$var$V;){
                        r = $86cb4b0557295782$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $86cb4b0557295782$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $86cb4b0557295782$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $86cb4b0557295782$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $86cb4b0557295782$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $86cb4b0557295782$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $86cb4b0557295782$var$V = y) : $86cb4b0557295782$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $86cb4b0557295782$var$rb("display", g));
                            } catch (t) {
                                $86cb4b0557295782$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $86cb4b0557295782$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $86cb4b0557295782$var$ck(b, a);
            $86cb4b0557295782$var$ek(a);
            d & 4 && $86cb4b0557295782$var$ak(a);
            break;
        case 21:
            break;
        default:
            $86cb4b0557295782$var$ck(b, a), $86cb4b0557295782$var$ek(a);
    }
}
function $86cb4b0557295782$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($86cb4b0557295782$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($86cb4b0557295782$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($86cb4b0557295782$var$ob(e, ""), d.flags &= -33);
                    var f = $86cb4b0557295782$var$Uj(a);
                    $86cb4b0557295782$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $86cb4b0557295782$var$Uj(a);
                    $86cb4b0557295782$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($86cb4b0557295782$var$p(161));
            }
        } catch (k) {
            $86cb4b0557295782$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $86cb4b0557295782$var$hk(a, b, c) {
    $86cb4b0557295782$var$V = a;
    $86cb4b0557295782$var$ik(a, b, c);
}
function $86cb4b0557295782$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $86cb4b0557295782$var$V;){
        var e = $86cb4b0557295782$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $86cb4b0557295782$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $86cb4b0557295782$var$U;
                h = $86cb4b0557295782$var$Jj;
                var l = $86cb4b0557295782$var$U;
                $86cb4b0557295782$var$Jj = g;
                if (($86cb4b0557295782$var$U = k) && !l) for($86cb4b0557295782$var$V = e; null !== $86cb4b0557295782$var$V;)g = $86cb4b0557295782$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $86cb4b0557295782$var$jk(e) : null !== k ? (k.return = g, $86cb4b0557295782$var$V = k) : $86cb4b0557295782$var$jk(e);
                for(; null !== f;)$86cb4b0557295782$var$V = f, $86cb4b0557295782$var$ik(f, b, c), f = f.sibling;
                $86cb4b0557295782$var$V = e;
                $86cb4b0557295782$var$Jj = h;
                $86cb4b0557295782$var$U = l;
            }
            $86cb4b0557295782$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $86cb4b0557295782$var$V = f) : $86cb4b0557295782$var$kk(a, b, c);
    }
}
function $86cb4b0557295782$var$kk(a) {
    for(; null !== $86cb4b0557295782$var$V;){
        var b = $86cb4b0557295782$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $86cb4b0557295782$var$U || $86cb4b0557295782$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$86cb4b0557295782$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $86cb4b0557295782$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $86cb4b0557295782$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $86cb4b0557295782$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $86cb4b0557295782$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($86cb4b0557295782$var$p(163));
                }
                $86cb4b0557295782$var$U || b.flags & 512 && $86cb4b0557295782$var$Rj(b);
            } catch (r) {
                $86cb4b0557295782$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $86cb4b0557295782$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $86cb4b0557295782$var$V = c;
            break;
        }
        $86cb4b0557295782$var$V = b.return;
    }
}
function $86cb4b0557295782$var$gk(a) {
    for(; null !== $86cb4b0557295782$var$V;){
        var b = $86cb4b0557295782$var$V;
        if (b === a) {
            $86cb4b0557295782$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $86cb4b0557295782$var$V = c;
            break;
        }
        $86cb4b0557295782$var$V = b.return;
    }
}
function $86cb4b0557295782$var$jk(a) {
    for(; null !== $86cb4b0557295782$var$V;){
        var b = $86cb4b0557295782$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $86cb4b0557295782$var$Qj(4, b);
                    } catch (k) {
                        $86cb4b0557295782$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $86cb4b0557295782$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $86cb4b0557295782$var$Rj(b);
                    } catch (k) {
                        $86cb4b0557295782$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $86cb4b0557295782$var$Rj(b);
                    } catch (k) {
                        $86cb4b0557295782$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $86cb4b0557295782$var$W(b, b.return, k);
        }
        if (b === a) {
            $86cb4b0557295782$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $86cb4b0557295782$var$V = h;
            break;
        }
        $86cb4b0557295782$var$V = b.return;
    }
}
var $86cb4b0557295782$var$lk = Math.ceil, $86cb4b0557295782$var$mk = $86cb4b0557295782$var$ua.ReactCurrentDispatcher, $86cb4b0557295782$var$nk = $86cb4b0557295782$var$ua.ReactCurrentOwner, $86cb4b0557295782$var$ok = $86cb4b0557295782$var$ua.ReactCurrentBatchConfig, $86cb4b0557295782$var$K = 0, $86cb4b0557295782$var$Q = null, $86cb4b0557295782$var$Y = null, $86cb4b0557295782$var$Z = 0, $86cb4b0557295782$var$fj = 0, $86cb4b0557295782$var$ej = $86cb4b0557295782$var$Uf(0), $86cb4b0557295782$var$T = 0, $86cb4b0557295782$var$pk = null, $86cb4b0557295782$var$rh = 0, $86cb4b0557295782$var$qk = 0, $86cb4b0557295782$var$rk = 0, $86cb4b0557295782$var$sk = null, $86cb4b0557295782$var$tk = null, $86cb4b0557295782$var$fk = 0, $86cb4b0557295782$var$Gj = Infinity, $86cb4b0557295782$var$uk = null, $86cb4b0557295782$var$Oi = !1, $86cb4b0557295782$var$Pi = null, $86cb4b0557295782$var$Ri = null, $86cb4b0557295782$var$vk = !1, $86cb4b0557295782$var$wk = null, $86cb4b0557295782$var$xk = 0, $86cb4b0557295782$var$yk = 0, $86cb4b0557295782$var$zk = null, $86cb4b0557295782$var$Ak = -1, $86cb4b0557295782$var$Bk = 0;
function $86cb4b0557295782$var$R() {
    return 0 !== ($86cb4b0557295782$var$K & 6) ? $86cb4b0557295782$var$B() : -1 !== $86cb4b0557295782$var$Ak ? $86cb4b0557295782$var$Ak : $86cb4b0557295782$var$Ak = $86cb4b0557295782$var$B();
}
function $86cb4b0557295782$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($86cb4b0557295782$var$K & 2) && 0 !== $86cb4b0557295782$var$Z) return $86cb4b0557295782$var$Z & -$86cb4b0557295782$var$Z;
    if (null !== $86cb4b0557295782$var$Kg.transition) return 0 === $86cb4b0557295782$var$Bk && ($86cb4b0557295782$var$Bk = $86cb4b0557295782$var$yc()), $86cb4b0557295782$var$Bk;
    a = $86cb4b0557295782$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $86cb4b0557295782$var$jd(a.type);
    return a;
}
function $86cb4b0557295782$var$gi(a, b, c, d) {
    if (50 < $86cb4b0557295782$var$yk) throw $86cb4b0557295782$var$yk = 0, $86cb4b0557295782$var$zk = null, Error($86cb4b0557295782$var$p(185));
    $86cb4b0557295782$var$Ac(a, c, d);
    if (0 === ($86cb4b0557295782$var$K & 2) || a !== $86cb4b0557295782$var$Q) a === $86cb4b0557295782$var$Q && (0 === ($86cb4b0557295782$var$K & 2) && ($86cb4b0557295782$var$qk |= c), 4 === $86cb4b0557295782$var$T && $86cb4b0557295782$var$Ck(a, $86cb4b0557295782$var$Z)), $86cb4b0557295782$var$Dk(a, d), 1 === c && 0 === $86cb4b0557295782$var$K && 0 === (b.mode & 1) && ($86cb4b0557295782$var$Gj = $86cb4b0557295782$var$B() + 500, $86cb4b0557295782$var$fg && $86cb4b0557295782$var$jg());
}
function $86cb4b0557295782$var$Dk(a, b) {
    var c = a.callbackNode;
    $86cb4b0557295782$var$wc(a, b);
    var d = $86cb4b0557295782$var$uc(a, a === $86cb4b0557295782$var$Q ? $86cb4b0557295782$var$Z : 0);
    if (0 === d) null !== c && $86cb4b0557295782$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $86cb4b0557295782$var$bc(c);
        if (1 === b) 0 === a.tag ? $86cb4b0557295782$var$ig($86cb4b0557295782$var$Ek.bind(null, a)) : $86cb4b0557295782$var$hg($86cb4b0557295782$var$Ek.bind(null, a)), $86cb4b0557295782$var$Jf(function() {
            0 === ($86cb4b0557295782$var$K & 6) && $86cb4b0557295782$var$jg();
        }), c = null;
        else {
            switch($86cb4b0557295782$var$Dc(d)){
                case 1:
                    c = $86cb4b0557295782$var$fc;
                    break;
                case 4:
                    c = $86cb4b0557295782$var$gc;
                    break;
                case 16:
                    c = $86cb4b0557295782$var$hc;
                    break;
                case 536870912:
                    c = $86cb4b0557295782$var$jc;
                    break;
                default:
                    c = $86cb4b0557295782$var$hc;
            }
            c = $86cb4b0557295782$var$Fk(c, $86cb4b0557295782$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $86cb4b0557295782$var$Gk(a, b) {
    $86cb4b0557295782$var$Ak = -1;
    $86cb4b0557295782$var$Bk = 0;
    if (0 !== ($86cb4b0557295782$var$K & 6)) throw Error($86cb4b0557295782$var$p(327));
    var c = a.callbackNode;
    if ($86cb4b0557295782$var$Hk() && a.callbackNode !== c) return null;
    var d = $86cb4b0557295782$var$uc(a, a === $86cb4b0557295782$var$Q ? $86cb4b0557295782$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $86cb4b0557295782$var$Ik(a, d);
    else {
        b = d;
        var e = $86cb4b0557295782$var$K;
        $86cb4b0557295782$var$K |= 2;
        var f = $86cb4b0557295782$var$Jk();
        if ($86cb4b0557295782$var$Q !== a || $86cb4b0557295782$var$Z !== b) $86cb4b0557295782$var$uk = null, $86cb4b0557295782$var$Gj = $86cb4b0557295782$var$B() + 500, $86cb4b0557295782$var$Kk(a, b);
        for(;;)try {
            $86cb4b0557295782$var$Lk();
            break;
        } catch (h) {
            $86cb4b0557295782$var$Mk(a, h);
        }
        $86cb4b0557295782$var$$g();
        $86cb4b0557295782$var$mk.current = f;
        $86cb4b0557295782$var$K = e;
        null !== $86cb4b0557295782$var$Y ? b = 0 : ($86cb4b0557295782$var$Q = null, $86cb4b0557295782$var$Z = 0, b = $86cb4b0557295782$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $86cb4b0557295782$var$xc(a), 0 !== e && (d = e, b = $86cb4b0557295782$var$Nk(a, e)));
        if (1 === b) throw c = $86cb4b0557295782$var$pk, $86cb4b0557295782$var$Kk(a, 0), $86cb4b0557295782$var$Ck(a, d), $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B()), c;
        if (6 === b) $86cb4b0557295782$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$86cb4b0557295782$var$Ok(e) && (b = $86cb4b0557295782$var$Ik(a, d), 2 === b && (f = $86cb4b0557295782$var$xc(a), 0 !== f && (d = f, b = $86cb4b0557295782$var$Nk(a, f))), 1 === b)) throw c = $86cb4b0557295782$var$pk, $86cb4b0557295782$var$Kk(a, 0), $86cb4b0557295782$var$Ck(a, d), $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($86cb4b0557295782$var$p(345));
                case 2:
                    $86cb4b0557295782$var$Pk(a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk);
                    break;
                case 3:
                    $86cb4b0557295782$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $86cb4b0557295782$var$fk + 500 - $86cb4b0557295782$var$B(), 10 < b)) {
                        if (0 !== $86cb4b0557295782$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $86cb4b0557295782$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $86cb4b0557295782$var$Ff($86cb4b0557295782$var$Pk.bind(null, a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk), b);
                        break;
                    }
                    $86cb4b0557295782$var$Pk(a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk);
                    break;
                case 4:
                    $86cb4b0557295782$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $86cb4b0557295782$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $86cb4b0557295782$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $86cb4b0557295782$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $86cb4b0557295782$var$Ff($86cb4b0557295782$var$Pk.bind(null, a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk), d);
                        break;
                    }
                    $86cb4b0557295782$var$Pk(a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk);
                    break;
                case 5:
                    $86cb4b0557295782$var$Pk(a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk);
                    break;
                default:
                    throw Error($86cb4b0557295782$var$p(329));
            }
        }
    }
    $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B());
    return a.callbackNode === c ? $86cb4b0557295782$var$Gk.bind(null, a) : null;
}
function $86cb4b0557295782$var$Nk(a, b) {
    var c = $86cb4b0557295782$var$sk;
    a.current.memoizedState.isDehydrated && ($86cb4b0557295782$var$Kk(a, b).flags |= 256);
    a = $86cb4b0557295782$var$Ik(a, b);
    2 !== a && (b = $86cb4b0557295782$var$tk, $86cb4b0557295782$var$tk = c, null !== b && $86cb4b0557295782$var$Fj(b));
    return a;
}
function $86cb4b0557295782$var$Fj(a) {
    null === $86cb4b0557295782$var$tk ? $86cb4b0557295782$var$tk = a : $86cb4b0557295782$var$tk.push.apply($86cb4b0557295782$var$tk, a);
}
function $86cb4b0557295782$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$86cb4b0557295782$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $86cb4b0557295782$var$Ck(a, b) {
    b &= ~$86cb4b0557295782$var$rk;
    b &= ~$86cb4b0557295782$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $86cb4b0557295782$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $86cb4b0557295782$var$Ek(a) {
    if (0 !== ($86cb4b0557295782$var$K & 6)) throw Error($86cb4b0557295782$var$p(327));
    $86cb4b0557295782$var$Hk();
    var b = $86cb4b0557295782$var$uc(a, 0);
    if (0 === (b & 1)) return $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B()), null;
    var c = $86cb4b0557295782$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $86cb4b0557295782$var$xc(a);
        0 !== d && (b = d, c = $86cb4b0557295782$var$Nk(a, d));
    }
    if (1 === c) throw c = $86cb4b0557295782$var$pk, $86cb4b0557295782$var$Kk(a, 0), $86cb4b0557295782$var$Ck(a, b), $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B()), c;
    if (6 === c) throw Error($86cb4b0557295782$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $86cb4b0557295782$var$Pk(a, $86cb4b0557295782$var$tk, $86cb4b0557295782$var$uk);
    $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B());
    return null;
}
function $86cb4b0557295782$var$Qk(a, b) {
    var c = $86cb4b0557295782$var$K;
    $86cb4b0557295782$var$K |= 1;
    try {
        return a(b);
    } finally{
        $86cb4b0557295782$var$K = c, 0 === $86cb4b0557295782$var$K && ($86cb4b0557295782$var$Gj = $86cb4b0557295782$var$B() + 500, $86cb4b0557295782$var$fg && $86cb4b0557295782$var$jg());
    }
}
function $86cb4b0557295782$var$Rk(a) {
    null !== $86cb4b0557295782$var$wk && 0 === $86cb4b0557295782$var$wk.tag && 0 === ($86cb4b0557295782$var$K & 6) && $86cb4b0557295782$var$Hk();
    var b = $86cb4b0557295782$var$K;
    $86cb4b0557295782$var$K |= 1;
    var c = $86cb4b0557295782$var$ok.transition, d = $86cb4b0557295782$var$C;
    try {
        if ($86cb4b0557295782$var$ok.transition = null, $86cb4b0557295782$var$C = 1, a) return a();
    } finally{
        $86cb4b0557295782$var$C = d, $86cb4b0557295782$var$ok.transition = c, $86cb4b0557295782$var$K = b, 0 === ($86cb4b0557295782$var$K & 6) && $86cb4b0557295782$var$jg();
    }
}
function $86cb4b0557295782$var$Hj() {
    $86cb4b0557295782$var$fj = $86cb4b0557295782$var$ej.current;
    $86cb4b0557295782$var$E($86cb4b0557295782$var$ej);
}
function $86cb4b0557295782$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $86cb4b0557295782$var$Gf(c));
    if (null !== $86cb4b0557295782$var$Y) for(c = $86cb4b0557295782$var$Y.return; null !== c;){
        var d = c;
        $86cb4b0557295782$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $86cb4b0557295782$var$$f();
                break;
            case 3:
                $86cb4b0557295782$var$zh();
                $86cb4b0557295782$var$E($86cb4b0557295782$var$Wf);
                $86cb4b0557295782$var$E($86cb4b0557295782$var$H);
                $86cb4b0557295782$var$Eh();
                break;
            case 5:
                $86cb4b0557295782$var$Bh(d);
                break;
            case 4:
                $86cb4b0557295782$var$zh();
                break;
            case 13:
                $86cb4b0557295782$var$E($86cb4b0557295782$var$L);
                break;
            case 19:
                $86cb4b0557295782$var$E($86cb4b0557295782$var$L);
                break;
            case 10:
                $86cb4b0557295782$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $86cb4b0557295782$var$Hj();
        }
        c = c.return;
    }
    $86cb4b0557295782$var$Q = a;
    $86cb4b0557295782$var$Y = a = $86cb4b0557295782$var$Pg(a.current, null);
    $86cb4b0557295782$var$Z = $86cb4b0557295782$var$fj = b;
    $86cb4b0557295782$var$T = 0;
    $86cb4b0557295782$var$pk = null;
    $86cb4b0557295782$var$rk = $86cb4b0557295782$var$qk = $86cb4b0557295782$var$rh = 0;
    $86cb4b0557295782$var$tk = $86cb4b0557295782$var$sk = null;
    if (null !== $86cb4b0557295782$var$fh) {
        for(b = 0; b < $86cb4b0557295782$var$fh.length; b++)if (c = $86cb4b0557295782$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $86cb4b0557295782$var$fh = null;
    }
    return a;
}
function $86cb4b0557295782$var$Mk(a, b) {
    do {
        var c = $86cb4b0557295782$var$Y;
        try {
            $86cb4b0557295782$var$$g();
            $86cb4b0557295782$var$Fh.current = $86cb4b0557295782$var$Rh;
            if ($86cb4b0557295782$var$Ih) {
                for(var d = $86cb4b0557295782$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $86cb4b0557295782$var$Ih = !1;
            }
            $86cb4b0557295782$var$Hh = 0;
            $86cb4b0557295782$var$O = $86cb4b0557295782$var$N = $86cb4b0557295782$var$M = null;
            $86cb4b0557295782$var$Jh = !1;
            $86cb4b0557295782$var$Kh = 0;
            $86cb4b0557295782$var$nk.current = null;
            if (null === c || null === c.return) {
                $86cb4b0557295782$var$T = 1;
                $86cb4b0557295782$var$pk = b;
                $86cb4b0557295782$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $86cb4b0557295782$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $86cb4b0557295782$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $86cb4b0557295782$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $86cb4b0557295782$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $86cb4b0557295782$var$Si(f, l, b);
                            $86cb4b0557295782$var$tj();
                            break a;
                        }
                        k = Error($86cb4b0557295782$var$p(426));
                    }
                } else if ($86cb4b0557295782$var$I && h.mode & 1) {
                    var J = $86cb4b0557295782$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $86cb4b0557295782$var$Vi(J, g, h, f, b);
                        $86cb4b0557295782$var$Jg($86cb4b0557295782$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $86cb4b0557295782$var$Ji(k, h);
                4 !== $86cb4b0557295782$var$T && ($86cb4b0557295782$var$T = 2);
                null === $86cb4b0557295782$var$sk ? $86cb4b0557295782$var$sk = [
                    f
                ] : $86cb4b0557295782$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $86cb4b0557295782$var$Ni(f, k, b);
                            $86cb4b0557295782$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $86cb4b0557295782$var$Ri || !$86cb4b0557295782$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $86cb4b0557295782$var$Qi(f, h, b);
                                $86cb4b0557295782$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $86cb4b0557295782$var$Sk(c);
        } catch (na) {
            b = na;
            $86cb4b0557295782$var$Y === c && null !== c && ($86cb4b0557295782$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $86cb4b0557295782$var$Jk() {
    var a = $86cb4b0557295782$var$mk.current;
    $86cb4b0557295782$var$mk.current = $86cb4b0557295782$var$Rh;
    return null === a ? $86cb4b0557295782$var$Rh : a;
}
function $86cb4b0557295782$var$tj() {
    if (0 === $86cb4b0557295782$var$T || 3 === $86cb4b0557295782$var$T || 2 === $86cb4b0557295782$var$T) $86cb4b0557295782$var$T = 4;
    null === $86cb4b0557295782$var$Q || 0 === ($86cb4b0557295782$var$rh & 268435455) && 0 === ($86cb4b0557295782$var$qk & 268435455) || $86cb4b0557295782$var$Ck($86cb4b0557295782$var$Q, $86cb4b0557295782$var$Z);
}
function $86cb4b0557295782$var$Ik(a, b) {
    var c = $86cb4b0557295782$var$K;
    $86cb4b0557295782$var$K |= 2;
    var d = $86cb4b0557295782$var$Jk();
    if ($86cb4b0557295782$var$Q !== a || $86cb4b0557295782$var$Z !== b) $86cb4b0557295782$var$uk = null, $86cb4b0557295782$var$Kk(a, b);
    for(;;)try {
        $86cb4b0557295782$var$Tk();
        break;
    } catch (e) {
        $86cb4b0557295782$var$Mk(a, e);
    }
    $86cb4b0557295782$var$$g();
    $86cb4b0557295782$var$K = c;
    $86cb4b0557295782$var$mk.current = d;
    if (null !== $86cb4b0557295782$var$Y) throw Error($86cb4b0557295782$var$p(261));
    $86cb4b0557295782$var$Q = null;
    $86cb4b0557295782$var$Z = 0;
    return $86cb4b0557295782$var$T;
}
function $86cb4b0557295782$var$Tk() {
    for(; null !== $86cb4b0557295782$var$Y;)$86cb4b0557295782$var$Uk($86cb4b0557295782$var$Y);
}
function $86cb4b0557295782$var$Lk() {
    for(; null !== $86cb4b0557295782$var$Y && !$86cb4b0557295782$var$cc();)$86cb4b0557295782$var$Uk($86cb4b0557295782$var$Y);
}
function $86cb4b0557295782$var$Uk(a) {
    var b = $86cb4b0557295782$var$Vk(a.alternate, a, $86cb4b0557295782$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $86cb4b0557295782$var$Sk(a) : $86cb4b0557295782$var$Y = b;
    $86cb4b0557295782$var$nk.current = null;
}
function $86cb4b0557295782$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $86cb4b0557295782$var$Ej(c, b, $86cb4b0557295782$var$fj), null !== c) {
                $86cb4b0557295782$var$Y = c;
                return;
            }
        } else {
            c = $86cb4b0557295782$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $86cb4b0557295782$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $86cb4b0557295782$var$T = 6;
                $86cb4b0557295782$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $86cb4b0557295782$var$Y = b;
            return;
        }
        $86cb4b0557295782$var$Y = b = a;
    }while (null !== b);
    0 === $86cb4b0557295782$var$T && ($86cb4b0557295782$var$T = 5);
}
function $86cb4b0557295782$var$Pk(a, b, c) {
    var d = $86cb4b0557295782$var$C, e = $86cb4b0557295782$var$ok.transition;
    try {
        $86cb4b0557295782$var$ok.transition = null, $86cb4b0557295782$var$C = 1, $86cb4b0557295782$var$Wk(a, b, c, d);
    } finally{
        $86cb4b0557295782$var$ok.transition = e, $86cb4b0557295782$var$C = d;
    }
    return null;
}
function $86cb4b0557295782$var$Wk(a, b, c, d) {
    do $86cb4b0557295782$var$Hk();
    while (null !== $86cb4b0557295782$var$wk);
    if (0 !== ($86cb4b0557295782$var$K & 6)) throw Error($86cb4b0557295782$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($86cb4b0557295782$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $86cb4b0557295782$var$Bc(a, f);
    a === $86cb4b0557295782$var$Q && ($86cb4b0557295782$var$Y = $86cb4b0557295782$var$Q = null, $86cb4b0557295782$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $86cb4b0557295782$var$vk || ($86cb4b0557295782$var$vk = !0, $86cb4b0557295782$var$Fk($86cb4b0557295782$var$hc, function() {
        $86cb4b0557295782$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $86cb4b0557295782$var$ok.transition;
        $86cb4b0557295782$var$ok.transition = null;
        var g = $86cb4b0557295782$var$C;
        $86cb4b0557295782$var$C = 1;
        var h = $86cb4b0557295782$var$K;
        $86cb4b0557295782$var$K |= 4;
        $86cb4b0557295782$var$nk.current = null;
        $86cb4b0557295782$var$Oj(a, c);
        $86cb4b0557295782$var$dk(c, a);
        $86cb4b0557295782$var$Oe($86cb4b0557295782$var$Df);
        $86cb4b0557295782$var$dd = !!$86cb4b0557295782$var$Cf;
        $86cb4b0557295782$var$Df = $86cb4b0557295782$var$Cf = null;
        a.current = c;
        $86cb4b0557295782$var$hk(c, a, e);
        $86cb4b0557295782$var$dc();
        $86cb4b0557295782$var$K = h;
        $86cb4b0557295782$var$C = g;
        $86cb4b0557295782$var$ok.transition = f;
    } else a.current = c;
    $86cb4b0557295782$var$vk && ($86cb4b0557295782$var$vk = !1, $86cb4b0557295782$var$wk = a, $86cb4b0557295782$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($86cb4b0557295782$var$Ri = null);
    $86cb4b0557295782$var$mc(c.stateNode, d);
    $86cb4b0557295782$var$Dk(a, $86cb4b0557295782$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($86cb4b0557295782$var$Oi) throw $86cb4b0557295782$var$Oi = !1, a = $86cb4b0557295782$var$Pi, $86cb4b0557295782$var$Pi = null, a;
    0 !== ($86cb4b0557295782$var$xk & 1) && 0 !== a.tag && $86cb4b0557295782$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $86cb4b0557295782$var$zk ? $86cb4b0557295782$var$yk++ : ($86cb4b0557295782$var$yk = 0, $86cb4b0557295782$var$zk = a) : $86cb4b0557295782$var$yk = 0;
    $86cb4b0557295782$var$jg();
    return null;
}
function $86cb4b0557295782$var$Hk() {
    if (null !== $86cb4b0557295782$var$wk) {
        var a = $86cb4b0557295782$var$Dc($86cb4b0557295782$var$xk), b = $86cb4b0557295782$var$ok.transition, c = $86cb4b0557295782$var$C;
        try {
            $86cb4b0557295782$var$ok.transition = null;
            $86cb4b0557295782$var$C = 16 > a ? 16 : a;
            if (null === $86cb4b0557295782$var$wk) var d = !1;
            else {
                a = $86cb4b0557295782$var$wk;
                $86cb4b0557295782$var$wk = null;
                $86cb4b0557295782$var$xk = 0;
                if (0 !== ($86cb4b0557295782$var$K & 6)) throw Error($86cb4b0557295782$var$p(331));
                var e = $86cb4b0557295782$var$K;
                $86cb4b0557295782$var$K |= 4;
                for($86cb4b0557295782$var$V = a.current; null !== $86cb4b0557295782$var$V;){
                    var f = $86cb4b0557295782$var$V, g = f.child;
                    if (0 !== ($86cb4b0557295782$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($86cb4b0557295782$var$V = l; null !== $86cb4b0557295782$var$V;){
                                    var m = $86cb4b0557295782$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $86cb4b0557295782$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $86cb4b0557295782$var$V = q;
                                    else for(; null !== $86cb4b0557295782$var$V;){
                                        m = $86cb4b0557295782$var$V;
                                        var r = m.sibling, y = m.return;
                                        $86cb4b0557295782$var$Sj(m);
                                        if (m === l) {
                                            $86cb4b0557295782$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $86cb4b0557295782$var$V = r;
                                            break;
                                        }
                                        $86cb4b0557295782$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $86cb4b0557295782$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $86cb4b0557295782$var$V = g;
                    else b: for(; null !== $86cb4b0557295782$var$V;){
                        f = $86cb4b0557295782$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $86cb4b0557295782$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $86cb4b0557295782$var$V = x;
                            break b;
                        }
                        $86cb4b0557295782$var$V = f.return;
                    }
                }
                var w = a.current;
                for($86cb4b0557295782$var$V = w; null !== $86cb4b0557295782$var$V;){
                    g = $86cb4b0557295782$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $86cb4b0557295782$var$V = u;
                    else b: for(g = w; null !== $86cb4b0557295782$var$V;){
                        h = $86cb4b0557295782$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $86cb4b0557295782$var$Qj(9, h);
                            }
                        } catch (na) {
                            $86cb4b0557295782$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $86cb4b0557295782$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $86cb4b0557295782$var$V = F;
                            break b;
                        }
                        $86cb4b0557295782$var$V = h.return;
                    }
                }
                $86cb4b0557295782$var$K = e;
                $86cb4b0557295782$var$jg();
                if ($86cb4b0557295782$var$lc && "function" === typeof $86cb4b0557295782$var$lc.onPostCommitFiberRoot) try {
                    $86cb4b0557295782$var$lc.onPostCommitFiberRoot($86cb4b0557295782$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $86cb4b0557295782$var$C = c, $86cb4b0557295782$var$ok.transition = b;
        }
    }
    return !1;
}
function $86cb4b0557295782$var$Xk(a, b, c) {
    b = $86cb4b0557295782$var$Ji(c, b);
    b = $86cb4b0557295782$var$Ni(a, b, 1);
    a = $86cb4b0557295782$var$nh(a, b, 1);
    b = $86cb4b0557295782$var$R();
    null !== a && ($86cb4b0557295782$var$Ac(a, 1, b), $86cb4b0557295782$var$Dk(a, b));
}
function $86cb4b0557295782$var$W(a, b, c) {
    if (3 === a.tag) $86cb4b0557295782$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $86cb4b0557295782$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $86cb4b0557295782$var$Ri || !$86cb4b0557295782$var$Ri.has(d))) {
                a = $86cb4b0557295782$var$Ji(c, a);
                a = $86cb4b0557295782$var$Qi(b, a, 1);
                b = $86cb4b0557295782$var$nh(b, a, 1);
                a = $86cb4b0557295782$var$R();
                null !== b && ($86cb4b0557295782$var$Ac(b, 1, a), $86cb4b0557295782$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $86cb4b0557295782$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $86cb4b0557295782$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $86cb4b0557295782$var$Q === a && ($86cb4b0557295782$var$Z & c) === c && (4 === $86cb4b0557295782$var$T || 3 === $86cb4b0557295782$var$T && ($86cb4b0557295782$var$Z & 130023424) === $86cb4b0557295782$var$Z && 500 > $86cb4b0557295782$var$B() - $86cb4b0557295782$var$fk ? $86cb4b0557295782$var$Kk(a, 0) : $86cb4b0557295782$var$rk |= c);
    $86cb4b0557295782$var$Dk(a, b);
}
function $86cb4b0557295782$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $86cb4b0557295782$var$sc, $86cb4b0557295782$var$sc <<= 1, 0 === ($86cb4b0557295782$var$sc & 130023424) && ($86cb4b0557295782$var$sc = 4194304)));
    var c = $86cb4b0557295782$var$R();
    a = $86cb4b0557295782$var$ih(a, b);
    null !== a && ($86cb4b0557295782$var$Ac(a, b, c), $86cb4b0557295782$var$Dk(a, c));
}
function $86cb4b0557295782$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $86cb4b0557295782$var$Yk(a, c);
}
function $86cb4b0557295782$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($86cb4b0557295782$var$p(314));
    }
    null !== d && d.delete(b);
    $86cb4b0557295782$var$Yk(a, c);
}
var $86cb4b0557295782$var$Vk;
$86cb4b0557295782$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $86cb4b0557295782$var$Wf.current) $86cb4b0557295782$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $86cb4b0557295782$var$dh = !1, $86cb4b0557295782$var$yj(a, b, c);
            $86cb4b0557295782$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $86cb4b0557295782$var$dh = !1, $86cb4b0557295782$var$I && 0 !== (b.flags & 1048576) && $86cb4b0557295782$var$ug(b, $86cb4b0557295782$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $86cb4b0557295782$var$ij(a, b);
            a = b.pendingProps;
            var e = $86cb4b0557295782$var$Yf(b, $86cb4b0557295782$var$H.current);
            $86cb4b0557295782$var$ch(b, c);
            e = $86cb4b0557295782$var$Nh(null, b, d, a, e, c);
            var f = $86cb4b0557295782$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $86cb4b0557295782$var$Zf(d) ? (f = !0, $86cb4b0557295782$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $86cb4b0557295782$var$kh(b), e.updater = $86cb4b0557295782$var$Ei, b.stateNode = e, e._reactInternals = b, $86cb4b0557295782$var$Ii(b, d, a, c), b = $86cb4b0557295782$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $86cb4b0557295782$var$I && f && $86cb4b0557295782$var$vg(b), $86cb4b0557295782$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $86cb4b0557295782$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $86cb4b0557295782$var$Zk(d);
                a = $86cb4b0557295782$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $86cb4b0557295782$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $86cb4b0557295782$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $86cb4b0557295782$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $86cb4b0557295782$var$$i(null, b, d, $86cb4b0557295782$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($86cb4b0557295782$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $86cb4b0557295782$var$Ci(d, e), $86cb4b0557295782$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $86cb4b0557295782$var$Ci(d, e), $86cb4b0557295782$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $86cb4b0557295782$var$kj(b);
                if (null === a) throw Error($86cb4b0557295782$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $86cb4b0557295782$var$lh(a, b);
                $86cb4b0557295782$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $86cb4b0557295782$var$Ji(Error($86cb4b0557295782$var$p(423)), b);
                        b = $86cb4b0557295782$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $86cb4b0557295782$var$Ji(Error($86cb4b0557295782$var$p(424)), b);
                        b = $86cb4b0557295782$var$lj(a, b, d, c, e);
                        break a;
                    } else for($86cb4b0557295782$var$yg = $86cb4b0557295782$var$Lf(b.stateNode.containerInfo.firstChild), $86cb4b0557295782$var$xg = b, $86cb4b0557295782$var$I = !0, $86cb4b0557295782$var$zg = null, c = $86cb4b0557295782$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $86cb4b0557295782$var$Ig();
                    if (d === e) {
                        b = $86cb4b0557295782$var$Zi(a, b, c);
                        break a;
                    }
                    $86cb4b0557295782$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $86cb4b0557295782$var$Ah(b), null === a && $86cb4b0557295782$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $86cb4b0557295782$var$Ef(d, e) ? g = null : null !== f && $86cb4b0557295782$var$Ef(d, f) && (b.flags |= 32), $86cb4b0557295782$var$gj(a, b), $86cb4b0557295782$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $86cb4b0557295782$var$Eg(b), null;
        case 13:
            return $86cb4b0557295782$var$oj(a, b, c);
        case 4:
            return $86cb4b0557295782$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $86cb4b0557295782$var$Ug(b, null, d, c) : $86cb4b0557295782$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $86cb4b0557295782$var$Ci(d, e), $86cb4b0557295782$var$Yi(a, b, d, e, c);
        case 7:
            return $86cb4b0557295782$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $86cb4b0557295782$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $86cb4b0557295782$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $86cb4b0557295782$var$G($86cb4b0557295782$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($86cb4b0557295782$var$He(f.value, g)) {
                        if (f.children === e.children && !$86cb4b0557295782$var$Wf.current) {
                            b = $86cb4b0557295782$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $86cb4b0557295782$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $86cb4b0557295782$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($86cb4b0557295782$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $86cb4b0557295782$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $86cb4b0557295782$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $86cb4b0557295782$var$ch(b, c), e = $86cb4b0557295782$var$eh(e), d = d(e), b.flags |= 1, $86cb4b0557295782$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $86cb4b0557295782$var$Ci(d, b.pendingProps), e = $86cb4b0557295782$var$Ci(d.type, e), $86cb4b0557295782$var$$i(a, b, d, e, c);
        case 15:
            return $86cb4b0557295782$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $86cb4b0557295782$var$Ci(d, e), $86cb4b0557295782$var$ij(a, b), b.tag = 1, $86cb4b0557295782$var$Zf(d) ? (a = !0, $86cb4b0557295782$var$cg(b)) : a = !1, $86cb4b0557295782$var$ch(b, c), $86cb4b0557295782$var$Gi(b, d, e), $86cb4b0557295782$var$Ii(b, d, e, c), $86cb4b0557295782$var$jj(null, b, d, !0, a, c);
        case 19:
            return $86cb4b0557295782$var$xj(a, b, c);
        case 22:
            return $86cb4b0557295782$var$dj(a, b, c);
    }
    throw Error($86cb4b0557295782$var$p(156, b.tag));
};
function $86cb4b0557295782$var$Fk(a, b) {
    return $86cb4b0557295782$var$ac(a, b);
}
function $86cb4b0557295782$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $86cb4b0557295782$var$Bg(a, b, c, d) {
    return new $86cb4b0557295782$var$$k(a, b, c, d);
}
function $86cb4b0557295782$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $86cb4b0557295782$var$Zk(a) {
    if ("function" === typeof a) return $86cb4b0557295782$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $86cb4b0557295782$var$Da) return 11;
        if (a === $86cb4b0557295782$var$Ga) return 14;
    }
    return 2;
}
function $86cb4b0557295782$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $86cb4b0557295782$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $86cb4b0557295782$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $86cb4b0557295782$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $86cb4b0557295782$var$ya:
            return $86cb4b0557295782$var$Tg(c.children, e, f, b);
        case $86cb4b0557295782$var$za:
            g = 8;
            e |= 8;
            break;
        case $86cb4b0557295782$var$Aa:
            return a = $86cb4b0557295782$var$Bg(12, c, b, e | 2), a.elementType = $86cb4b0557295782$var$Aa, a.lanes = f, a;
        case $86cb4b0557295782$var$Ea:
            return a = $86cb4b0557295782$var$Bg(13, c, b, e), a.elementType = $86cb4b0557295782$var$Ea, a.lanes = f, a;
        case $86cb4b0557295782$var$Fa:
            return a = $86cb4b0557295782$var$Bg(19, c, b, e), a.elementType = $86cb4b0557295782$var$Fa, a.lanes = f, a;
        case $86cb4b0557295782$var$Ia:
            return $86cb4b0557295782$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $86cb4b0557295782$var$Ba:
                    g = 10;
                    break a;
                case $86cb4b0557295782$var$Ca:
                    g = 9;
                    break a;
                case $86cb4b0557295782$var$Da:
                    g = 11;
                    break a;
                case $86cb4b0557295782$var$Ga:
                    g = 14;
                    break a;
                case $86cb4b0557295782$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($86cb4b0557295782$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $86cb4b0557295782$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $86cb4b0557295782$var$Tg(a, b, c, d) {
    a = $86cb4b0557295782$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $86cb4b0557295782$var$pj(a, b, c, d) {
    a = $86cb4b0557295782$var$Bg(22, a, d, b);
    a.elementType = $86cb4b0557295782$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $86cb4b0557295782$var$Qg(a, b, c) {
    a = $86cb4b0557295782$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $86cb4b0557295782$var$Sg(a, b, c) {
    b = $86cb4b0557295782$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $86cb4b0557295782$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $86cb4b0557295782$var$zc(0);
    this.expirationTimes = $86cb4b0557295782$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $86cb4b0557295782$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $86cb4b0557295782$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $86cb4b0557295782$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $86cb4b0557295782$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $86cb4b0557295782$var$kh(f);
    return a;
}
function $86cb4b0557295782$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $86cb4b0557295782$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $86cb4b0557295782$var$dl(a) {
    if (!a) return $86cb4b0557295782$var$Vf;
    a = a._reactInternals;
    a: {
        if ($86cb4b0557295782$var$Vb(a) !== a || 1 !== a.tag) throw Error($86cb4b0557295782$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($86cb4b0557295782$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($86cb4b0557295782$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($86cb4b0557295782$var$Zf(c)) return $86cb4b0557295782$var$bg(a, c, b);
    }
    return b;
}
function $86cb4b0557295782$var$el(a, b, c, d, e, f, g, h, k) {
    a = $86cb4b0557295782$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $86cb4b0557295782$var$dl(null);
    c = a.current;
    d = $86cb4b0557295782$var$R();
    e = $86cb4b0557295782$var$yi(c);
    f = $86cb4b0557295782$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $86cb4b0557295782$var$nh(c, f, e);
    a.current.lanes = e;
    $86cb4b0557295782$var$Ac(a, e, d);
    $86cb4b0557295782$var$Dk(a, d);
    return a;
}
function $86cb4b0557295782$var$fl(a, b, c, d) {
    var e = b.current, f = $86cb4b0557295782$var$R(), g = $86cb4b0557295782$var$yi(e);
    c = $86cb4b0557295782$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $86cb4b0557295782$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $86cb4b0557295782$var$nh(e, b, g);
    null !== a && ($86cb4b0557295782$var$gi(a, e, g, f), $86cb4b0557295782$var$oh(a, e, g));
    return g;
}
function $86cb4b0557295782$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $86cb4b0557295782$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $86cb4b0557295782$var$il(a, b) {
    $86cb4b0557295782$var$hl(a, b);
    (a = a.alternate) && $86cb4b0557295782$var$hl(a, b);
}
function $86cb4b0557295782$var$jl() {
    return null;
}
var $86cb4b0557295782$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $86cb4b0557295782$var$ll(a) {
    this._internalRoot = a;
}
$86cb4b0557295782$var$ml.prototype.render = $86cb4b0557295782$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($86cb4b0557295782$var$p(409));
    $86cb4b0557295782$var$fl(a, b, null, null);
};
$86cb4b0557295782$var$ml.prototype.unmount = $86cb4b0557295782$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $86cb4b0557295782$var$Rk(function() {
            $86cb4b0557295782$var$fl(null, a, null, null);
        });
        b[$86cb4b0557295782$var$uf] = null;
    }
};
function $86cb4b0557295782$var$ml(a) {
    this._internalRoot = a;
}
$86cb4b0557295782$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $86cb4b0557295782$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $86cb4b0557295782$var$Qc.length && 0 !== b && b < $86cb4b0557295782$var$Qc[c].priority; c++);
        $86cb4b0557295782$var$Qc.splice(c, 0, a);
        0 === c && $86cb4b0557295782$var$Vc(a);
    }
};
function $86cb4b0557295782$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $86cb4b0557295782$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $86cb4b0557295782$var$pl() {}
function $86cb4b0557295782$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $86cb4b0557295782$var$gl(g);
                f.call(a);
            };
        }
        var g = $86cb4b0557295782$var$el(b, d, a, 0, null, !1, !1, "", $86cb4b0557295782$var$pl);
        a._reactRootContainer = g;
        a[$86cb4b0557295782$var$uf] = g.current;
        $86cb4b0557295782$var$sf(8 === a.nodeType ? a.parentNode : a);
        $86cb4b0557295782$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $86cb4b0557295782$var$gl(k);
            h.call(a);
        };
    }
    var k = $86cb4b0557295782$var$bl(a, 0, !1, null, null, !1, !1, "", $86cb4b0557295782$var$pl);
    a._reactRootContainer = k;
    a[$86cb4b0557295782$var$uf] = k.current;
    $86cb4b0557295782$var$sf(8 === a.nodeType ? a.parentNode : a);
    $86cb4b0557295782$var$Rk(function() {
        $86cb4b0557295782$var$fl(b, k, c, d);
    });
    return k;
}
function $86cb4b0557295782$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $86cb4b0557295782$var$gl(g);
                h.call(a);
            };
        }
        $86cb4b0557295782$var$fl(b, g, a, e);
    } else g = $86cb4b0557295782$var$ql(c, b, a, e, d);
    return $86cb4b0557295782$var$gl(g);
}
$86cb4b0557295782$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $86cb4b0557295782$var$tc(b.pendingLanes);
                0 !== c && ($86cb4b0557295782$var$Cc(b, c | 1), $86cb4b0557295782$var$Dk(b, $86cb4b0557295782$var$B()), 0 === ($86cb4b0557295782$var$K & 6) && ($86cb4b0557295782$var$Gj = $86cb4b0557295782$var$B() + 500, $86cb4b0557295782$var$jg()));
            }
            break;
        case 13:
            $86cb4b0557295782$var$Rk(function() {
                var b = $86cb4b0557295782$var$ih(a, 1);
                if (null !== b) {
                    var c = $86cb4b0557295782$var$R();
                    $86cb4b0557295782$var$gi(b, a, 1, c);
                }
            }), $86cb4b0557295782$var$il(a, 1);
    }
};
$86cb4b0557295782$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $86cb4b0557295782$var$ih(a, 134217728);
        if (null !== b) {
            var c = $86cb4b0557295782$var$R();
            $86cb4b0557295782$var$gi(b, a, 134217728, c);
        }
        $86cb4b0557295782$var$il(a, 134217728);
    }
};
$86cb4b0557295782$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $86cb4b0557295782$var$yi(a), c = $86cb4b0557295782$var$ih(a, b);
        if (null !== c) {
            var d = $86cb4b0557295782$var$R();
            $86cb4b0557295782$var$gi(c, a, b, d);
        }
        $86cb4b0557295782$var$il(a, b);
    }
};
$86cb4b0557295782$var$Hc = function() {
    return $86cb4b0557295782$var$C;
};
$86cb4b0557295782$var$Ic = function(a, b) {
    var c = $86cb4b0557295782$var$C;
    try {
        return $86cb4b0557295782$var$C = a, b();
    } finally{
        $86cb4b0557295782$var$C = c;
    }
};
$86cb4b0557295782$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $86cb4b0557295782$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $86cb4b0557295782$var$Db(d);
                        if (!e) throw Error($86cb4b0557295782$var$p(90));
                        $86cb4b0557295782$var$Wa(d);
                        $86cb4b0557295782$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $86cb4b0557295782$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $86cb4b0557295782$var$fb(a, !!c.multiple, b, !1);
    }
};
$86cb4b0557295782$var$Gb = $86cb4b0557295782$var$Qk;
$86cb4b0557295782$var$Hb = $86cb4b0557295782$var$Rk;
var $86cb4b0557295782$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $86cb4b0557295782$var$Cb,
        $86cb4b0557295782$var$ue,
        $86cb4b0557295782$var$Db,
        $86cb4b0557295782$var$Eb,
        $86cb4b0557295782$var$Fb,
        $86cb4b0557295782$var$Qk
    ]
}, $86cb4b0557295782$var$tl = {
    findFiberByHostInstance: $86cb4b0557295782$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $86cb4b0557295782$var$ul = {
    bundleType: $86cb4b0557295782$var$tl.bundleType,
    version: $86cb4b0557295782$var$tl.version,
    rendererPackageName: $86cb4b0557295782$var$tl.rendererPackageName,
    rendererConfig: $86cb4b0557295782$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $86cb4b0557295782$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $86cb4b0557295782$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $86cb4b0557295782$var$tl.findFiberByHostInstance || $86cb4b0557295782$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $86cb4b0557295782$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$86cb4b0557295782$var$vl.isDisabled && $86cb4b0557295782$var$vl.supportsFiber) try {
        $86cb4b0557295782$var$kc = $86cb4b0557295782$var$vl.inject($86cb4b0557295782$var$ul), $86cb4b0557295782$var$lc = $86cb4b0557295782$var$vl;
    } catch (a) {}
}
$86cb4b0557295782$export$ae55be85d98224ed = $86cb4b0557295782$var$sl;
$86cb4b0557295782$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$86cb4b0557295782$var$nl(b)) throw Error($86cb4b0557295782$var$p(200));
    return $86cb4b0557295782$var$cl(a, b, null, c);
};
$86cb4b0557295782$export$882461b6382ed46c = function(a, b) {
    if (!$86cb4b0557295782$var$nl(a)) throw Error($86cb4b0557295782$var$p(299));
    var c = !1, d = "", e = $86cb4b0557295782$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $86cb4b0557295782$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$86cb4b0557295782$var$uf] = b.current;
    $86cb4b0557295782$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $86cb4b0557295782$var$ll(b);
};
$86cb4b0557295782$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($86cb4b0557295782$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($86cb4b0557295782$var$p(268, a));
    }
    a = $86cb4b0557295782$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$86cb4b0557295782$export$cd75ccfd720a3cd4 = function(a) {
    return $86cb4b0557295782$var$Rk(a);
};
$86cb4b0557295782$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$86cb4b0557295782$var$ol(b)) throw Error($86cb4b0557295782$var$p(200));
    return $86cb4b0557295782$var$rl(null, a, b, !0, c);
};
$86cb4b0557295782$export$757ceba2d55c277e = function(a, b, c) {
    if (!$86cb4b0557295782$var$nl(a)) throw Error($86cb4b0557295782$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $86cb4b0557295782$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $86cb4b0557295782$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$86cb4b0557295782$var$uf] = b.current;
    $86cb4b0557295782$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $86cb4b0557295782$var$ml(b);
};
$86cb4b0557295782$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$86cb4b0557295782$var$ol(b)) throw Error($86cb4b0557295782$var$p(200));
    return $86cb4b0557295782$var$rl(null, a, b, !1, c);
};
$86cb4b0557295782$export$502457920280e6be = function(a) {
    if (!$86cb4b0557295782$var$ol(a)) throw Error($86cb4b0557295782$var$p(40));
    return a._reactRootContainer ? ($86cb4b0557295782$var$Rk(function() {
        $86cb4b0557295782$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$86cb4b0557295782$var$uf] = null;
        });
    }), !0) : !1;
};
$86cb4b0557295782$export$c78a37762a8d58e1 = $86cb4b0557295782$var$Qk;
$86cb4b0557295782$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$86cb4b0557295782$var$ol(c)) throw Error($86cb4b0557295782$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($86cb4b0557295782$var$p(38));
    return $86cb4b0557295782$var$rl(a, b, c, !1, d);
};
$86cb4b0557295782$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9iFCZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kuoqR"));

});
parcelRegister("kuoqR", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $eea98fbc4fce5a1a$export$c4744153514ff05d; }, function (v) { return $eea98fbc4fce5a1a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $eea98fbc4fce5a1a$export$3e506c1ccc9cc1a7; }, function (v) { return $eea98fbc4fce5a1a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $eea98fbc4fce5a1a$export$e26fe2ed2fa76875; }, function (v) { return $eea98fbc4fce5a1a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $eea98fbc4fce5a1a$export$502329bbf4b505b1; }, function (v) { return $eea98fbc4fce5a1a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $eea98fbc4fce5a1a$export$6e3807111c4874c4; }, function (v) { return $eea98fbc4fce5a1a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $eea98fbc4fce5a1a$export$c27134553091fb3a; }, function (v) { return $eea98fbc4fce5a1a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $eea98fbc4fce5a1a$export$33ee1acdc04fd2a2; }, function (v) { return $eea98fbc4fce5a1a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $eea98fbc4fce5a1a$export$b00a404bbd5edef2; }, function (v) { return $eea98fbc4fce5a1a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $eea98fbc4fce5a1a$export$8352ce38b91d0c62; }, function (v) { return $eea98fbc4fce5a1a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $eea98fbc4fce5a1a$export$d66a1c1c77bd778b; }, function (v) { return $eea98fbc4fce5a1a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $eea98fbc4fce5a1a$export$d3dfb8e4810cb555; }, function (v) { return $eea98fbc4fce5a1a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $eea98fbc4fce5a1a$export$839f9183b0465a69; }, function (v) { return $eea98fbc4fce5a1a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $eea98fbc4fce5a1a$export$72fdf0e06517287b; }, function (v) { return $eea98fbc4fce5a1a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $eea98fbc4fce5a1a$export$4b844e58a3e414b4; }, function (v) { return $eea98fbc4fce5a1a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $eea98fbc4fce5a1a$export$816d2913ae6b83b1; }, function (v) { return $eea98fbc4fce5a1a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $eea98fbc4fce5a1a$export$61bcfe829111a1d0; }, function (v) { return $eea98fbc4fce5a1a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $eea98fbc4fce5a1a$export$7ee8c9beb337bc3f; }, function (v) { return $eea98fbc4fce5a1a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $eea98fbc4fce5a1a$export$b5836b71941fa3ed; }, function (v) { return $eea98fbc4fce5a1a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $eea98fbc4fce5a1a$export$cf845f2c119da08a; }, function (v) { return $eea98fbc4fce5a1a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eea98fbc4fce5a1a$export$c4744153514ff05d;
var $eea98fbc4fce5a1a$export$3e506c1ccc9cc1a7;
var $eea98fbc4fce5a1a$export$e26fe2ed2fa76875;
var $eea98fbc4fce5a1a$export$502329bbf4b505b1;
var $eea98fbc4fce5a1a$export$6e3807111c4874c4;
var $eea98fbc4fce5a1a$export$c27134553091fb3a;
var $eea98fbc4fce5a1a$export$33ee1acdc04fd2a2;
var $eea98fbc4fce5a1a$export$b00a404bbd5edef2;
var $eea98fbc4fce5a1a$export$8352ce38b91d0c62;
var $eea98fbc4fce5a1a$export$d66a1c1c77bd778b;
var $eea98fbc4fce5a1a$export$d3dfb8e4810cb555;
var $eea98fbc4fce5a1a$export$839f9183b0465a69;
var $eea98fbc4fce5a1a$export$72fdf0e06517287b;
var $eea98fbc4fce5a1a$export$4b844e58a3e414b4;
var $eea98fbc4fce5a1a$export$816d2913ae6b83b1;
var $eea98fbc4fce5a1a$export$61bcfe829111a1d0;
var $eea98fbc4fce5a1a$export$7ee8c9beb337bc3f;
var $eea98fbc4fce5a1a$export$b5836b71941fa3ed;
var $eea98fbc4fce5a1a$export$cf845f2c119da08a;
"use strict";
function $eea98fbc4fce5a1a$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $eea98fbc4fce5a1a$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $eea98fbc4fce5a1a$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $eea98fbc4fce5a1a$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $eea98fbc4fce5a1a$var$g(C, c)) n < e && 0 > $eea98fbc4fce5a1a$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $eea98fbc4fce5a1a$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $eea98fbc4fce5a1a$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $eea98fbc4fce5a1a$var$l = performance;
    $eea98fbc4fce5a1a$export$c4744153514ff05d = function() {
        return $eea98fbc4fce5a1a$var$l.now();
    };
} else {
    var $eea98fbc4fce5a1a$var$p = Date, $eea98fbc4fce5a1a$var$q = $eea98fbc4fce5a1a$var$p.now();
    $eea98fbc4fce5a1a$export$c4744153514ff05d = function() {
        return $eea98fbc4fce5a1a$var$p.now() - $eea98fbc4fce5a1a$var$q;
    };
}
var $eea98fbc4fce5a1a$var$r = [], $eea98fbc4fce5a1a$var$t = [], $eea98fbc4fce5a1a$var$u = 1, $eea98fbc4fce5a1a$var$v = null, $eea98fbc4fce5a1a$var$y = 3, $eea98fbc4fce5a1a$var$z = !1, $eea98fbc4fce5a1a$var$A = !1, $eea98fbc4fce5a1a$var$B = !1, $eea98fbc4fce5a1a$var$D = "function" === typeof setTimeout ? setTimeout : null, $eea98fbc4fce5a1a$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $eea98fbc4fce5a1a$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $eea98fbc4fce5a1a$var$G(a) {
    for(var b = $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$t); null !== b;){
        if (null === b.callback) $eea98fbc4fce5a1a$var$k($eea98fbc4fce5a1a$var$t);
        else if (b.startTime <= a) $eea98fbc4fce5a1a$var$k($eea98fbc4fce5a1a$var$t), b.sortIndex = b.expirationTime, $eea98fbc4fce5a1a$var$f($eea98fbc4fce5a1a$var$r, b);
        else break;
        b = $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$t);
    }
}
function $eea98fbc4fce5a1a$var$H(a) {
    $eea98fbc4fce5a1a$var$B = !1;
    $eea98fbc4fce5a1a$var$G(a);
    if (!$eea98fbc4fce5a1a$var$A) {
        if (null !== $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$r)) $eea98fbc4fce5a1a$var$A = !0, $eea98fbc4fce5a1a$var$I($eea98fbc4fce5a1a$var$J);
        else {
            var b = $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$t);
            null !== b && $eea98fbc4fce5a1a$var$K($eea98fbc4fce5a1a$var$H, b.startTime - a);
        }
    }
}
function $eea98fbc4fce5a1a$var$J(a, b) {
    $eea98fbc4fce5a1a$var$A = !1;
    $eea98fbc4fce5a1a$var$B && ($eea98fbc4fce5a1a$var$B = !1, $eea98fbc4fce5a1a$var$E($eea98fbc4fce5a1a$var$L), $eea98fbc4fce5a1a$var$L = -1);
    $eea98fbc4fce5a1a$var$z = !0;
    var c = $eea98fbc4fce5a1a$var$y;
    try {
        $eea98fbc4fce5a1a$var$G(b);
        for($eea98fbc4fce5a1a$var$v = $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$r); null !== $eea98fbc4fce5a1a$var$v && (!($eea98fbc4fce5a1a$var$v.expirationTime > b) || a && !$eea98fbc4fce5a1a$var$M());){
            var d = $eea98fbc4fce5a1a$var$v.callback;
            if ("function" === typeof d) {
                $eea98fbc4fce5a1a$var$v.callback = null;
                $eea98fbc4fce5a1a$var$y = $eea98fbc4fce5a1a$var$v.priorityLevel;
                var e = d($eea98fbc4fce5a1a$var$v.expirationTime <= b);
                b = $eea98fbc4fce5a1a$export$c4744153514ff05d();
                "function" === typeof e ? $eea98fbc4fce5a1a$var$v.callback = e : $eea98fbc4fce5a1a$var$v === $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$r) && $eea98fbc4fce5a1a$var$k($eea98fbc4fce5a1a$var$r);
                $eea98fbc4fce5a1a$var$G(b);
            } else $eea98fbc4fce5a1a$var$k($eea98fbc4fce5a1a$var$r);
            $eea98fbc4fce5a1a$var$v = $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$r);
        }
        if (null !== $eea98fbc4fce5a1a$var$v) var w = !0;
        else {
            var m = $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$t);
            null !== m && $eea98fbc4fce5a1a$var$K($eea98fbc4fce5a1a$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $eea98fbc4fce5a1a$var$v = null, $eea98fbc4fce5a1a$var$y = c, $eea98fbc4fce5a1a$var$z = !1;
    }
}
var $eea98fbc4fce5a1a$var$N = !1, $eea98fbc4fce5a1a$var$O = null, $eea98fbc4fce5a1a$var$L = -1, $eea98fbc4fce5a1a$var$P = 5, $eea98fbc4fce5a1a$var$Q = -1;
function $eea98fbc4fce5a1a$var$M() {
    return $eea98fbc4fce5a1a$export$c4744153514ff05d() - $eea98fbc4fce5a1a$var$Q < $eea98fbc4fce5a1a$var$P ? !1 : !0;
}
function $eea98fbc4fce5a1a$var$R() {
    if (null !== $eea98fbc4fce5a1a$var$O) {
        var a = $eea98fbc4fce5a1a$export$c4744153514ff05d();
        $eea98fbc4fce5a1a$var$Q = a;
        var b = !0;
        try {
            b = $eea98fbc4fce5a1a$var$O(!0, a);
        } finally{
            b ? $eea98fbc4fce5a1a$var$S() : ($eea98fbc4fce5a1a$var$N = !1, $eea98fbc4fce5a1a$var$O = null);
        }
    } else $eea98fbc4fce5a1a$var$N = !1;
}
var $eea98fbc4fce5a1a$var$S;
if ("function" === typeof $eea98fbc4fce5a1a$var$F) $eea98fbc4fce5a1a$var$S = function() {
    $eea98fbc4fce5a1a$var$F($eea98fbc4fce5a1a$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $eea98fbc4fce5a1a$var$T = new MessageChannel, $eea98fbc4fce5a1a$var$U = $eea98fbc4fce5a1a$var$T.port2;
    $eea98fbc4fce5a1a$var$T.port1.onmessage = $eea98fbc4fce5a1a$var$R;
    $eea98fbc4fce5a1a$var$S = function() {
        $eea98fbc4fce5a1a$var$U.postMessage(null);
    };
} else $eea98fbc4fce5a1a$var$S = function() {
    $eea98fbc4fce5a1a$var$D($eea98fbc4fce5a1a$var$R, 0);
};
function $eea98fbc4fce5a1a$var$I(a) {
    $eea98fbc4fce5a1a$var$O = a;
    $eea98fbc4fce5a1a$var$N || ($eea98fbc4fce5a1a$var$N = !0, $eea98fbc4fce5a1a$var$S());
}
function $eea98fbc4fce5a1a$var$K(a, b) {
    $eea98fbc4fce5a1a$var$L = $eea98fbc4fce5a1a$var$D(function() {
        a($eea98fbc4fce5a1a$export$c4744153514ff05d());
    }, b);
}
$eea98fbc4fce5a1a$export$3e506c1ccc9cc1a7 = 5;
$eea98fbc4fce5a1a$export$e26fe2ed2fa76875 = 1;
$eea98fbc4fce5a1a$export$502329bbf4b505b1 = 4;
$eea98fbc4fce5a1a$export$6e3807111c4874c4 = 3;
$eea98fbc4fce5a1a$export$c27134553091fb3a = null;
$eea98fbc4fce5a1a$export$33ee1acdc04fd2a2 = 2;
$eea98fbc4fce5a1a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$eea98fbc4fce5a1a$export$8352ce38b91d0c62 = function() {
    $eea98fbc4fce5a1a$var$A || $eea98fbc4fce5a1a$var$z || ($eea98fbc4fce5a1a$var$A = !0, $eea98fbc4fce5a1a$var$I($eea98fbc4fce5a1a$var$J));
};
$eea98fbc4fce5a1a$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $eea98fbc4fce5a1a$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$eea98fbc4fce5a1a$export$d3dfb8e4810cb555 = function() {
    return $eea98fbc4fce5a1a$var$y;
};
$eea98fbc4fce5a1a$export$839f9183b0465a69 = function() {
    return $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$r);
};
$eea98fbc4fce5a1a$export$72fdf0e06517287b = function(a) {
    switch($eea98fbc4fce5a1a$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $eea98fbc4fce5a1a$var$y;
    }
    var c = $eea98fbc4fce5a1a$var$y;
    $eea98fbc4fce5a1a$var$y = b;
    try {
        return a();
    } finally{
        $eea98fbc4fce5a1a$var$y = c;
    }
};
$eea98fbc4fce5a1a$export$4b844e58a3e414b4 = function() {};
$eea98fbc4fce5a1a$export$816d2913ae6b83b1 = function() {};
$eea98fbc4fce5a1a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $eea98fbc4fce5a1a$var$y;
    $eea98fbc4fce5a1a$var$y = a;
    try {
        return b();
    } finally{
        $eea98fbc4fce5a1a$var$y = c;
    }
};
$eea98fbc4fce5a1a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $eea98fbc4fce5a1a$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $eea98fbc4fce5a1a$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $eea98fbc4fce5a1a$var$f($eea98fbc4fce5a1a$var$t, a), null === $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$r) && a === $eea98fbc4fce5a1a$var$h($eea98fbc4fce5a1a$var$t) && ($eea98fbc4fce5a1a$var$B ? ($eea98fbc4fce5a1a$var$E($eea98fbc4fce5a1a$var$L), $eea98fbc4fce5a1a$var$L = -1) : $eea98fbc4fce5a1a$var$B = !0, $eea98fbc4fce5a1a$var$K($eea98fbc4fce5a1a$var$H, c - d))) : (a.sortIndex = e, $eea98fbc4fce5a1a$var$f($eea98fbc4fce5a1a$var$r, a), $eea98fbc4fce5a1a$var$A || $eea98fbc4fce5a1a$var$z || ($eea98fbc4fce5a1a$var$A = !0, $eea98fbc4fce5a1a$var$I($eea98fbc4fce5a1a$var$J)));
    return a;
};
$eea98fbc4fce5a1a$export$b5836b71941fa3ed = $eea98fbc4fce5a1a$var$M;
$eea98fbc4fce5a1a$export$cf845f2c119da08a = function(a) {
    var b = $eea98fbc4fce5a1a$var$y;
    return function() {
        var c = $eea98fbc4fce5a1a$var$y;
        $eea98fbc4fce5a1a$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $eea98fbc4fce5a1a$var$y = c;
        }
    };
};

});




parcelRegister("kunpB", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $eea8c520394917af$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $eea8c520394917af$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $eea8c520394917af$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useSearchParams", function () { return $eea8c520394917af$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("fOZMN")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("fOZMN")).useNavigate; });
/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");

var $hQMXr = parcelRequire("hQMXr");
var $fOZMN = parcelRequire("fOZMN");

var $hQMXr = parcelRequire("hQMXr");
function $eea8c520394917af$var$_extends() {
    $eea8c520394917af$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eea8c520394917af$var$_extends.apply(this, arguments);
}
function $eea8c520394917af$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $eea8c520394917af$var$defaultMethod = "get";
const $eea8c520394917af$var$defaultEncType = "application/x-www-form-urlencoded";
function $eea8c520394917af$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $eea8c520394917af$var$isButtonElement(object) {
    return $eea8c520394917af$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $eea8c520394917af$var$isFormElement(object) {
    return $eea8c520394917af$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $eea8c520394917af$var$isInputElement(object) {
    return $eea8c520394917af$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $eea8c520394917af$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $eea8c520394917af$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$eea8c520394917af$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $eea8c520394917af$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $eea8c520394917af$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $eea8c520394917af$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $eea8c520394917af$var$_formDataSupportsSubmitter = null;
function $eea8c520394917af$var$isFormDataSubmitterSupported() {
    if ($eea8c520394917af$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $eea8c520394917af$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $eea8c520394917af$var$_formDataSupportsSubmitter = true;
    }
    return $eea8c520394917af$var$_formDataSupportsSubmitter;
}
const $eea8c520394917af$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $eea8c520394917af$var$getFormEncType(encType) {
    if (encType != null && !$eea8c520394917af$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $eea8c520394917af$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($eea8c520394917af$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $hQMXr.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $eea8c520394917af$var$defaultMethod;
        encType = $eea8c520394917af$var$getFormEncType(target.getAttribute("enctype")) || $eea8c520394917af$var$defaultEncType;
        formData = new FormData(target);
    } else if ($eea8c520394917af$var$isButtonElement(target) || $eea8c520394917af$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $hQMXr.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $eea8c520394917af$var$defaultMethod;
        encType = $eea8c520394917af$var$getFormEncType(target.getAttribute("formenctype")) || $eea8c520394917af$var$getFormEncType(form.getAttribute("enctype")) || $eea8c520394917af$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$eea8c520394917af$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($eea8c520394917af$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $eea8c520394917af$var$defaultMethod;
        action = null;
        encType = $eea8c520394917af$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $eea8c520394917af$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $eea8c520394917af$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $eea8c520394917af$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $eea8c520394917af$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $eea8c520394917af$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $eea8c520394917af$export$1f3f55432a00e06d(routes, opts) {
    return (0, $hQMXr.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $eea8c520394917af$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hQMXr.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $eea8c520394917af$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $fOZMN.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $eea8c520394917af$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $hQMXr.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $eea8c520394917af$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hQMXr.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $eea8c520394917af$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $fOZMN.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $eea8c520394917af$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $eea8c520394917af$var$_extends({}, state, {
        errors: $eea8c520394917af$var$deserializeErrors(state.errors)
    });
    return state;
}
function $eea8c520394917af$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $hQMXr.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $eea8c520394917af$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dgG1Y.createContext({
    isTransitioning: false
});
const $eea8c520394917af$export$148fd98d095596d4 = /*#__PURE__*/ $dgG1Y.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $eea8c520394917af$var$START_TRANSITION = "startTransition";
const $eea8c520394917af$var$startTransitionImpl = $dgG1Y[$eea8c520394917af$var$START_TRANSITION];
const $eea8c520394917af$var$FLUSH_SYNC = "flushSync";
const $eea8c520394917af$var$flushSyncImpl = $8idXE[$eea8c520394917af$var$FLUSH_SYNC];
const $eea8c520394917af$var$USE_ID = "useId";
const $eea8c520394917af$var$useIdImpl = $dgG1Y[$eea8c520394917af$var$USE_ID];
function $eea8c520394917af$var$startTransitionSafe(cb) {
    if ($eea8c520394917af$var$startTransitionImpl) $eea8c520394917af$var$startTransitionImpl(cb);
    else cb();
}
function $eea8c520394917af$var$flushSyncSafe(cb) {
    if ($eea8c520394917af$var$flushSyncImpl) $eea8c520394917af$var$flushSyncImpl(cb);
    else cb();
}
class $eea8c520394917af$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $eea8c520394917af$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dgG1Y.useState(router.state);
    let [pendingState, setPendingState] = $dgG1Y.useState();
    let [vtContext, setVtContext] = $dgG1Y.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dgG1Y.useState();
    let [transition, setTransition] = $dgG1Y.useState();
    let [interruption, setInterruption] = $dgG1Y.useState();
    let fetcherData = $dgG1Y.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $dgG1Y.useCallback((cb)=>{
        if (v7_startTransition) $eea8c520394917af$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $dgG1Y.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $eea8c520394917af$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $eea8c520394917af$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $eea8c520394917af$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $eea8c520394917af$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $eea8c520394917af$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dgG1Y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dgG1Y.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $eea8c520394917af$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dgG1Y.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dgG1Y.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dgG1Y.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dgG1Y.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dgG1Y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dgG1Y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $dgG1Y.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement((0, $fOZMN.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dgG1Y.createElement((0, $fOZMN.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $dgG1Y.createElement($eea8c520394917af$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dgG1Y.createElement($eea8c520394917af$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dgG1Y.createElement((0, $fOZMN.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dgG1Y.createElement($eea8c520394917af$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $eea8c520394917af$var$MemoizedDataRoutes = /*#__PURE__*/ $dgG1Y.memo($eea8c520394917af$var$DataRoutes);
function $eea8c520394917af$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $fOZMN.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $eea8c520394917af$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $dgG1Y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hQMXr.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dgG1Y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dgG1Y.useCallback((newState)=>{
        v7_startTransition && $eea8c520394917af$var$startTransitionImpl ? $eea8c520394917af$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dgG1Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $fOZMN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $eea8c520394917af$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $dgG1Y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hQMXr.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dgG1Y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dgG1Y.useCallback((newState)=>{
        v7_startTransition && $eea8c520394917af$var$startTransitionImpl ? $eea8c520394917af$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dgG1Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $fOZMN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $eea8c520394917af$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $dgG1Y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dgG1Y.useCallback((newState)=>{
        v7_startTransition && $eea8c520394917af$var$startTransitionImpl ? $eea8c520394917af$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dgG1Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $fOZMN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $eea8c520394917af$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $eea8c520394917af$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $eea8c520394917af$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dgG1Y.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $eea8c520394917af$var$_objectWithoutPropertiesLoose(_ref7, $eea8c520394917af$var$_excluded);
    let { basename: basename } = $dgG1Y.useContext((0, $fOZMN.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $eea8c520394917af$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($eea8c520394917af$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $hQMXr.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $fOZMN.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $eea8c520394917af$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dgG1Y.createElement("a", $eea8c520394917af$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $eea8c520394917af$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dgG1Y.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $eea8c520394917af$var$_objectWithoutPropertiesLoose(_ref8, $eea8c520394917af$var$_excluded2);
    let path = (0, $fOZMN.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $fOZMN.useLocation)();
    let routerState = $dgG1Y.useContext((0, $fOZMN.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $dgG1Y.useContext((0, $fOZMN.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eea8c520394917af$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $hQMXr.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dgG1Y.createElement($eea8c520394917af$export$a6c7ac8248d6e38a, $eea8c520394917af$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $eea8c520394917af$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dgG1Y.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $eea8c520394917af$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $eea8c520394917af$var$_objectWithoutPropertiesLoose(_ref9, $eea8c520394917af$var$_excluded3);
    let submit = $eea8c520394917af$export$47c85c6e3a081d3();
    let formAction = $eea8c520394917af$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $dgG1Y.createElement("form", $eea8c520394917af$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $eea8c520394917af$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $eea8c520394917af$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $eea8c520394917af$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($eea8c520394917af$var$DataRouterHook || ($eea8c520394917af$var$DataRouterHook = {}));
var $eea8c520394917af$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($eea8c520394917af$var$DataRouterStateHook || ($eea8c520394917af$var$DataRouterStateHook = {}));
// Internal hooks
function $eea8c520394917af$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $eea8c520394917af$var$useDataRouterContext(hookName) {
    let ctx = $dgG1Y.useContext((0, $fOZMN.UNSAFE_DataRouterContext));
    !ctx && (0, $hQMXr.UNSAFE_invariant)(false);
    return ctx;
}
function $eea8c520394917af$var$useDataRouterState(hookName) {
    let state = $dgG1Y.useContext((0, $fOZMN.UNSAFE_DataRouterStateContext));
    !state && (0, $hQMXr.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $eea8c520394917af$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $fOZMN.useNavigate)();
    let location = (0, $fOZMN.useLocation)();
    let path = (0, $fOZMN.useResolvedPath)(to, {
        relative: relative
    });
    return $dgG1Y.useCallback((event)=>{
        if ($eea8c520394917af$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $hQMXr.createPath)(location) === (0, $hQMXr.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $eea8c520394917af$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $dgG1Y.useRef($eea8c520394917af$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dgG1Y.useRef(false);
    let location = (0, $fOZMN.useLocation)();
    let searchParams = $dgG1Y.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $eea8c520394917af$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $fOZMN.useNavigate)();
    let setSearchParams = $dgG1Y.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $eea8c520394917af$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $eea8c520394917af$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $eea8c520394917af$var$fetcherId = 0;
let $eea8c520394917af$var$getUniqueFetcherId = ()=>"__" + String(++$eea8c520394917af$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $eea8c520394917af$export$47c85c6e3a081d3() {
    let { router: router } = $eea8c520394917af$var$useDataRouterContext($eea8c520394917af$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $dgG1Y.useContext((0, $fOZMN.UNSAFE_NavigationContext));
    let currentRouteId = (0, $fOZMN.UNSAFE_useRouteId)();
    return $dgG1Y.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $eea8c520394917af$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $eea8c520394917af$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $eea8c520394917af$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $eea8c520394917af$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $dgG1Y.useContext((0, $fOZMN.UNSAFE_NavigationContext));
    let routeContext = $dgG1Y.useContext((0, $fOZMN.UNSAFE_RouteContext));
    !routeContext && (0, $hQMXr.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $eea8c520394917af$var$_extends({}, (0, $fOZMN.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $fOZMN.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $hQMXr.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $hQMXr.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $eea8c520394917af$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $eea8c520394917af$var$useDataRouterContext($eea8c520394917af$var$DataRouterHook.UseFetcher);
    let state = $eea8c520394917af$var$useDataRouterState($eea8c520394917af$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $dgG1Y.useContext($eea8c520394917af$export$148fd98d095596d4);
    let route = $dgG1Y.useContext((0, $fOZMN.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $hQMXr.UNSAFE_invariant)(false);
    !route && (0, $hQMXr.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $hQMXr.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $eea8c520394917af$var$useIdImpl ? $eea8c520394917af$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $dgG1Y.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($eea8c520394917af$var$getUniqueFetcherId());
    // Registration/cleanup
    $dgG1Y.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $dgG1Y.useCallback((href, opts)=>{
        !routeId && (0, $hQMXr.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $eea8c520394917af$export$47c85c6e3a081d3();
    let submit = $dgG1Y.useCallback((target, opts)=>{
        submitImpl(target, $eea8c520394917af$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $dgG1Y.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $dgG1Y.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $dgG1Y.createElement($eea8c520394917af$export$a7fed597f4b8afd8, $eea8c520394917af$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $hQMXr.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dgG1Y.useMemo(()=>$eea8c520394917af$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $eea8c520394917af$export$fa996778a3a31087() {
    let state = $eea8c520394917af$var$useDataRouterState($eea8c520394917af$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $eea8c520394917af$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $eea8c520394917af$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $eea8c520394917af$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $eea8c520394917af$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $eea8c520394917af$var$useDataRouterContext($eea8c520394917af$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $eea8c520394917af$var$useDataRouterState($eea8c520394917af$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $dgG1Y.useContext((0, $fOZMN.UNSAFE_NavigationContext));
    let location = (0, $fOZMN.useLocation)();
    let matches = (0, $fOZMN.useMatches)();
    let navigation = (0, $fOZMN.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $dgG1Y.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $eea8c520394917af$var$usePageHide($dgG1Y.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $eea8c520394917af$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $eea8c520394917af$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($eea8c520394917af$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dgG1Y.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $eea8c520394917af$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $eea8c520394917af$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dgG1Y.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($eea8c520394917af$var$_extends({}, location, {
                    pathname: (0, $hQMXr.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($eea8c520394917af$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dgG1Y.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $eea8c520394917af$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dgG1Y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $eea8c520394917af$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dgG1Y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $eea8c520394917af$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $fOZMN.useBlocker)(when);
    $dgG1Y.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dgG1Y.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $eea8c520394917af$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $dgG1Y.useContext($eea8c520394917af$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $hQMXr.UNSAFE_invariant)(false);
    let { basename: basename } = $eea8c520394917af$var$useDataRouterContext($eea8c520394917af$var$DataRouterHook.useViewTransitionState);
    let path = (0, $fOZMN.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $hQMXr.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $hQMXr.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $hQMXr.matchPath)(path.pathname, nextPath) != null || (0, $hQMXr.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("hQMXr", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $cfed44f7d2d34a69$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $cfed44f7d2d34a69$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $cfed44f7d2d34a69$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $cfed44f7d2d34a69$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $cfed44f7d2d34a69$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $cfed44f7d2d34a69$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $cfed44f7d2d34a69$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $cfed44f7d2d34a69$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $cfed44f7d2d34a69$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $cfed44f7d2d34a69$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $cfed44f7d2d34a69$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $cfed44f7d2d34a69$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $cfed44f7d2d34a69$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $cfed44f7d2d34a69$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $cfed44f7d2d34a69$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $cfed44f7d2d34a69$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $cfed44f7d2d34a69$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $cfed44f7d2d34a69$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $cfed44f7d2d34a69$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $cfed44f7d2d34a69$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $cfed44f7d2d34a69$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $cfed44f7d2d34a69$var$_extends() {
    $cfed44f7d2d34a69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cfed44f7d2d34a69$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $cfed44f7d2d34a69$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($cfed44f7d2d34a69$export$e19cd5f9376f8cee || ($cfed44f7d2d34a69$export$e19cd5f9376f8cee = {}));
const $cfed44f7d2d34a69$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $cfed44f7d2d34a69$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $cfed44f7d2d34a69$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $cfed44f7d2d34a69$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $cfed44f7d2d34a69$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $cfed44f7d2d34a69$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $cfed44f7d2d34a69$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $cfed44f7d2d34a69$export$fe53371bee54353d(to);
    }
    return $cfed44f7d2d34a69$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $cfed44f7d2d34a69$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $cfed44f7d2d34a69$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $cfed44f7d2d34a69$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $cfed44f7d2d34a69$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $cfed44f7d2d34a69$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $cfed44f7d2d34a69$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $cfed44f7d2d34a69$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $cfed44f7d2d34a69$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $cfed44f7d2d34a69$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $cfed44f7d2d34a69$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $cfed44f7d2d34a69$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $cfed44f7d2d34a69$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $cfed44f7d2d34a69$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $cfed44f7d2d34a69$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $cfed44f7d2d34a69$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $cfed44f7d2d34a69$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($cfed44f7d2d34a69$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Push;
        let location = $cfed44f7d2d34a69$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $cfed44f7d2d34a69$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Replace;
        let location = $cfed44f7d2d34a69$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $cfed44f7d2d34a69$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $cfed44f7d2d34a69$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $cfed44f7d2d34a69$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($cfed44f7d2d34a69$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($cfed44f7d2d34a69$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $cfed44f7d2d34a69$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($cfed44f7d2d34a69$var$ResultType || ($cfed44f7d2d34a69$var$ResultType = {}));
const $cfed44f7d2d34a69$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $cfed44f7d2d34a69$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $cfed44f7d2d34a69$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $cfed44f7d2d34a69$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $cfed44f7d2d34a69$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($cfed44f7d2d34a69$var$isIndexRoute(route)) {
            let indexRoute = $cfed44f7d2d34a69$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $cfed44f7d2d34a69$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $cfed44f7d2d34a69$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $cfed44f7d2d34a69$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $cfed44f7d2d34a69$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $cfed44f7d2d34a69$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $cfed44f7d2d34a69$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $cfed44f7d2d34a69$var$flattenRoutes(routes);
    $cfed44f7d2d34a69$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $cfed44f7d2d34a69$export$30d21fd6d7295f52(pathname);
        matches = $cfed44f7d2d34a69$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $cfed44f7d2d34a69$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $cfed44f7d2d34a69$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $cfed44f7d2d34a69$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $cfed44f7d2d34a69$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $cfed44f7d2d34a69$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $cfed44f7d2d34a69$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $cfed44f7d2d34a69$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $cfed44f7d2d34a69$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $cfed44f7d2d34a69$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $cfed44f7d2d34a69$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $cfed44f7d2d34a69$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $cfed44f7d2d34a69$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $cfed44f7d2d34a69$var$paramRe = /^:[\w-]+$/;
const $cfed44f7d2d34a69$var$dynamicSegmentValue = 3;
const $cfed44f7d2d34a69$var$indexRouteValue = 2;
const $cfed44f7d2d34a69$var$emptySegmentValue = 1;
const $cfed44f7d2d34a69$var$staticSegmentValue = 10;
const $cfed44f7d2d34a69$var$splatPenalty = -2;
const $cfed44f7d2d34a69$var$isSplat = (s)=>s === "*";
function $cfed44f7d2d34a69$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($cfed44f7d2d34a69$var$isSplat)) initialScore += $cfed44f7d2d34a69$var$splatPenalty;
    if (index) initialScore += $cfed44f7d2d34a69$var$indexRouteValue;
    return segments.filter((s)=>!$cfed44f7d2d34a69$var$isSplat(s)).reduce((score, segment)=>score + ($cfed44f7d2d34a69$var$paramRe.test(segment) ? $cfed44f7d2d34a69$var$dynamicSegmentValue : segment === "" ? $cfed44f7d2d34a69$var$emptySegmentValue : $cfed44f7d2d34a69$var$staticSegmentValue), initialScore);
}
function $cfed44f7d2d34a69$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $cfed44f7d2d34a69$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $cfed44f7d2d34a69$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $cfed44f7d2d34a69$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $cfed44f7d2d34a69$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $cfed44f7d2d34a69$export$a5c6d149b50c1d86($cfed44f7d2d34a69$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $cfed44f7d2d34a69$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $cfed44f7d2d34a69$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $cfed44f7d2d34a69$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $cfed44f7d2d34a69$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $cfed44f7d2d34a69$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $cfed44f7d2d34a69$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $cfed44f7d2d34a69$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $cfed44f7d2d34a69$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $cfed44f7d2d34a69$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $cfed44f7d2d34a69$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $cfed44f7d2d34a69$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $cfed44f7d2d34a69$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $cfed44f7d2d34a69$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $cfed44f7d2d34a69$var$normalizeSearch(search),
        hash: $cfed44f7d2d34a69$var$normalizeHash(hash)
    };
}
function $cfed44f7d2d34a69$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $cfed44f7d2d34a69$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $cfed44f7d2d34a69$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $cfed44f7d2d34a69$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $cfed44f7d2d34a69$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $cfed44f7d2d34a69$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $cfed44f7d2d34a69$export$8ccf933b0513f8d0(toArg);
    else {
        to = $cfed44f7d2d34a69$var$_extends({}, toArg);
        $cfed44f7d2d34a69$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $cfed44f7d2d34a69$var$getInvalidPathError("?", "pathname", "search", to));
        $cfed44f7d2d34a69$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $cfed44f7d2d34a69$var$getInvalidPathError("#", "pathname", "hash", to));
        $cfed44f7d2d34a69$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $cfed44f7d2d34a69$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $cfed44f7d2d34a69$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $cfed44f7d2d34a69$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $cfed44f7d2d34a69$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $cfed44f7d2d34a69$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $cfed44f7d2d34a69$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $cfed44f7d2d34a69$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $cfed44f7d2d34a69$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $cfed44f7d2d34a69$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $cfed44f7d2d34a69$export$42a99a7a4bc0e76a extends Error {
}
class $cfed44f7d2d34a69$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $cfed44f7d2d34a69$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $cfed44f7d2d34a69$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $cfed44f7d2d34a69$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $cfed44f7d2d34a69$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $cfed44f7d2d34a69$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $cfed44f7d2d34a69$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $cfed44f7d2d34a69$var$unwrapTrackedPromise(value) {
    if (!$cfed44f7d2d34a69$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $cfed44f7d2d34a69$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $cfed44f7d2d34a69$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cfed44f7d2d34a69$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $cfed44f7d2d34a69$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cfed44f7d2d34a69$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $cfed44f7d2d34a69$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $cfed44f7d2d34a69$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $cfed44f7d2d34a69$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $cfed44f7d2d34a69$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $cfed44f7d2d34a69$var$validMutationMethods = new Set($cfed44f7d2d34a69$var$validMutationMethodsArr);
const $cfed44f7d2d34a69$var$validRequestMethodsArr = [
    "get",
    ...$cfed44f7d2d34a69$var$validMutationMethodsArr
];
const $cfed44f7d2d34a69$var$validRequestMethods = new Set($cfed44f7d2d34a69$var$validRequestMethodsArr);
const $cfed44f7d2d34a69$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $cfed44f7d2d34a69$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $cfed44f7d2d34a69$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cfed44f7d2d34a69$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cfed44f7d2d34a69$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $cfed44f7d2d34a69$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $cfed44f7d2d34a69$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $cfed44f7d2d34a69$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $cfed44f7d2d34a69$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $cfed44f7d2d34a69$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cfed44f7d2d34a69$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $cfed44f7d2d34a69$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $cfed44f7d2d34a69$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $cfed44f7d2d34a69$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $cfed44f7d2d34a69$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $cfed44f7d2d34a69$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $cfed44f7d2d34a69$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $cfed44f7d2d34a69$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $cfed44f7d2d34a69$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $cfed44f7d2d34a69$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $cfed44f7d2d34a69$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$cfed44f7d2d34a69$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $cfed44f7d2d34a69$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $cfed44f7d2d34a69$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $cfed44f7d2d34a69$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $cfed44f7d2d34a69$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $cfed44f7d2d34a69$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($cfed44f7d2d34a69$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $cfed44f7d2d34a69$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $cfed44f7d2d34a69$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $cfed44f7d2d34a69$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $cfed44f7d2d34a69$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $cfed44f7d2d34a69$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $cfed44f7d2d34a69$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $cfed44f7d2d34a69$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $cfed44f7d2d34a69$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $cfed44f7d2d34a69$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $cfed44f7d2d34a69$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $cfed44f7d2d34a69$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $cfed44f7d2d34a69$var$findNearestBoundary(matches).route.id,
            {
                type: $cfed44f7d2d34a69$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $cfed44f7d2d34a69$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($cfed44f7d2d34a69$var$isErrorResult(result) && $cfed44f7d2d34a69$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $cfed44f7d2d34a69$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $cfed44f7d2d34a69$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $cfed44f7d2d34a69$var$_extends({
            matches: updatedMatches || matches
        }, $cfed44f7d2d34a69$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $cfed44f7d2d34a69$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $cfed44f7d2d34a69$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $cfed44f7d2d34a69$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $cfed44f7d2d34a69$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $cfed44f7d2d34a69$var$ResultType.error,
            error: $cfed44f7d2d34a69$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($cfed44f7d2d34a69$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $cfed44f7d2d34a69$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($cfed44f7d2d34a69$var$isDeferredResult(result)) throw $cfed44f7d2d34a69$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($cfed44f7d2d34a69$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $cfed44f7d2d34a69$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $cfed44f7d2d34a69$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $cfed44f7d2d34a69$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($cfed44f7d2d34a69$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $cfed44f7d2d34a69$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $cfed44f7d2d34a69$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $cfed44f7d2d34a69$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $cfed44f7d2d34a69$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cfed44f7d2d34a69$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $cfed44f7d2d34a69$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $cfed44f7d2d34a69$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $cfed44f7d2d34a69$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $cfed44f7d2d34a69$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $cfed44f7d2d34a69$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $cfed44f7d2d34a69$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $cfed44f7d2d34a69$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $cfed44f7d2d34a69$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $cfed44f7d2d34a69$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cfed44f7d2d34a69$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cfed44f7d2d34a69$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cfed44f7d2d34a69$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $cfed44f7d2d34a69$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($cfed44f7d2d34a69$var$isRedirectResult(actionResult) || $cfed44f7d2d34a69$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $cfed44f7d2d34a69$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($cfed44f7d2d34a69$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $cfed44f7d2d34a69$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $cfed44f7d2d34a69$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($cfed44f7d2d34a69$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($cfed44f7d2d34a69$var$isDeferredResult(actionResult)) throw $cfed44f7d2d34a69$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $cfed44f7d2d34a69$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $cfed44f7d2d34a69$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $cfed44f7d2d34a69$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $cfed44f7d2d34a69$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $cfed44f7d2d34a69$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $cfed44f7d2d34a69$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $cfed44f7d2d34a69$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cfed44f7d2d34a69$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $cfed44f7d2d34a69$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $cfed44f7d2d34a69$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $cfed44f7d2d34a69$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cfed44f7d2d34a69$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cfed44f7d2d34a69$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cfed44f7d2d34a69$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $cfed44f7d2d34a69$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($cfed44f7d2d34a69$var$isDeferredResult(result)) result = await $cfed44f7d2d34a69$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $cfed44f7d2d34a69$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($cfed44f7d2d34a69$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $cfed44f7d2d34a69$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($cfed44f7d2d34a69$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $cfed44f7d2d34a69$export$3e9cee6b33872309(!$cfed44f7d2d34a69$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $cfed44f7d2d34a69$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $cfed44f7d2d34a69$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $cfed44f7d2d34a69$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $cfed44f7d2d34a69$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($cfed44f7d2d34a69$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $cfed44f7d2d34a69$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Replace : $cfed44f7d2d34a69$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $cfed44f7d2d34a69$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($cfed44f7d2d34a69$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $cfed44f7d2d34a69$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $cfed44f7d2d34a69$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $cfed44f7d2d34a69$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $cfed44f7d2d34a69$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($cfed44f7d2d34a69$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $cfed44f7d2d34a69$var$ResultType.redirect,
                        response: $cfed44f7d2d34a69$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $cfed44f7d2d34a69$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $cfed44f7d2d34a69$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $cfed44f7d2d34a69$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $cfed44f7d2d34a69$var$ResultType.error,
                    error: $cfed44f7d2d34a69$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $cfed44f7d2d34a69$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $cfed44f7d2d34a69$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $cfed44f7d2d34a69$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $cfed44f7d2d34a69$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $cfed44f7d2d34a69$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $cfed44f7d2d34a69$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $cfed44f7d2d34a69$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $cfed44f7d2d34a69$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $cfed44f7d2d34a69$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $cfed44f7d2d34a69$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $cfed44f7d2d34a69$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $cfed44f7d2d34a69$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $cfed44f7d2d34a69$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $cfed44f7d2d34a69$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $cfed44f7d2d34a69$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $cfed44f7d2d34a69$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $cfed44f7d2d34a69$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$cfed44f7d2d34a69$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $cfed44f7d2d34a69$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $cfed44f7d2d34a69$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $cfed44f7d2d34a69$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $cfed44f7d2d34a69$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $cfed44f7d2d34a69$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $cfed44f7d2d34a69$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $cfed44f7d2d34a69$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $cfed44f7d2d34a69$export$4d0306f8f6a4585b = Symbol("deferred");
function $cfed44f7d2d34a69$export$3336b097a6fbc59a(routes, opts) {
    $cfed44f7d2d34a69$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cfed44f7d2d34a69$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $cfed44f7d2d34a69$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $cfed44f7d2d34a69$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cfed44f7d2d34a69$var$createLocation("", $cfed44f7d2d34a69$export$fe53371bee54353d(url), null, "default");
        let matches = $cfed44f7d2d34a69$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cfed44f7d2d34a69$var$isValidMethod(method) && method !== "HEAD") {
            let error = $cfed44f7d2d34a69$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $cfed44f7d2d34a69$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $cfed44f7d2d34a69$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $cfed44f7d2d34a69$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($cfed44f7d2d34a69$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $cfed44f7d2d34a69$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cfed44f7d2d34a69$var$createLocation("", $cfed44f7d2d34a69$export$fe53371bee54353d(url), null, "default");
        let matches = $cfed44f7d2d34a69$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cfed44f7d2d34a69$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $cfed44f7d2d34a69$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $cfed44f7d2d34a69$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $cfed44f7d2d34a69$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $cfed44f7d2d34a69$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $cfed44f7d2d34a69$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($cfed44f7d2d34a69$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$cfed44f7d2d34a69$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $cfed44f7d2d34a69$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($cfed44f7d2d34a69$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $cfed44f7d2d34a69$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $cfed44f7d2d34a69$var$isResponse(result) ? result : $cfed44f7d2d34a69$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($cfed44f7d2d34a69$var$isHandlerResult(e) && $cfed44f7d2d34a69$var$isResponse(e.result)) {
                if (e.type === $cfed44f7d2d34a69$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($cfed44f7d2d34a69$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $cfed44f7d2d34a69$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cfed44f7d2d34a69$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $cfed44f7d2d34a69$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($cfed44f7d2d34a69$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($cfed44f7d2d34a69$var$isDeferredResult(result)) {
            let error = $cfed44f7d2d34a69$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cfed44f7d2d34a69$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($cfed44f7d2d34a69$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($cfed44f7d2d34a69$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $cfed44f7d2d34a69$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $cfed44f7d2d34a69$var$_extends({}, context, {
                statusCode: $cfed44f7d2d34a69$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $cfed44f7d2d34a69$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $cfed44f7d2d34a69$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $cfed44f7d2d34a69$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? $cfed44f7d2d34a69$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $cfed44f7d2d34a69$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $cfed44f7d2d34a69$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $cfed44f7d2d34a69$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $cfed44f7d2d34a69$var$callDataStrategyImpl(unstable_dataStrategy || $cfed44f7d2d34a69$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($cfed44f7d2d34a69$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $cfed44f7d2d34a69$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($cfed44f7d2d34a69$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $cfed44f7d2d34a69$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $cfed44f7d2d34a69$export$fec11da027c70692(routes, context, error) {
    let newContext = $cfed44f7d2d34a69$var$_extends({}, context, {
        statusCode: $cfed44f7d2d34a69$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $cfed44f7d2d34a69$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $cfed44f7d2d34a69$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $cfed44f7d2d34a69$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $cfed44f7d2d34a69$export$cae722b0cc860f13(to ? to : ".", $cfed44f7d2d34a69$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $cfed44f7d2d34a69$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$cfed44f7d2d34a69$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $cfed44f7d2d34a69$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $cfed44f7d2d34a69$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $cfed44f7d2d34a69$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$cfed44f7d2d34a69$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$cfed44f7d2d34a69$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $cfed44f7d2d34a69$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $cfed44f7d2d34a69$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $cfed44f7d2d34a69$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$cfed44f7d2d34a69$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$cfed44f7d2d34a69$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $cfed44f7d2d34a69$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $cfed44f7d2d34a69$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $cfed44f7d2d34a69$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $cfed44f7d2d34a69$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $cfed44f7d2d34a69$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($cfed44f7d2d34a69$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $cfed44f7d2d34a69$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $cfed44f7d2d34a69$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $cfed44f7d2d34a69$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $cfed44f7d2d34a69$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $cfed44f7d2d34a69$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $cfed44f7d2d34a69$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($cfed44f7d2d34a69$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $cfed44f7d2d34a69$var$shouldRevalidateLoader(match, $cfed44f7d2d34a69$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $cfed44f7d2d34a69$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $cfed44f7d2d34a69$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $cfed44f7d2d34a69$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $cfed44f7d2d34a69$var$shouldRevalidateLoader(fetcherMatch, $cfed44f7d2d34a69$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $cfed44f7d2d34a69$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $cfed44f7d2d34a69$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $cfed44f7d2d34a69$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $cfed44f7d2d34a69$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $cfed44f7d2d34a69$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $cfed44f7d2d34a69$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $cfed44f7d2d34a69$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $cfed44f7d2d34a69$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $cfed44f7d2d34a69$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $cfed44f7d2d34a69$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $cfed44f7d2d34a69$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $cfed44f7d2d34a69$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $cfed44f7d2d34a69$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$cfed44f7d2d34a69$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $cfed44f7d2d34a69$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $cfed44f7d2d34a69$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $cfed44f7d2d34a69$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $cfed44f7d2d34a69$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $cfed44f7d2d34a69$var$ResultType.data,
                    result: undefined
                });
            };
            return $cfed44f7d2d34a69$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$cfed44f7d2d34a69$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $cfed44f7d2d34a69$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $cfed44f7d2d34a69$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $cfed44f7d2d34a69$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $cfed44f7d2d34a69$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $cfed44f7d2d34a69$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $cfed44f7d2d34a69$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $cfed44f7d2d34a69$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $cfed44f7d2d34a69$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $cfed44f7d2d34a69$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($cfed44f7d2d34a69$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $cfed44f7d2d34a69$var$ResultType.error,
                error: e
            };
        }
        if (type === $cfed44f7d2d34a69$var$ResultType.error) return {
            type: $cfed44f7d2d34a69$var$ResultType.error,
            error: new $cfed44f7d2d34a69$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $cfed44f7d2d34a69$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $cfed44f7d2d34a69$var$ResultType.error) return {
        type: $cfed44f7d2d34a69$var$ResultType.error,
        error: result,
        statusCode: $cfed44f7d2d34a69$export$972111febbeef05b(result) ? result.status : status
    };
    if ($cfed44f7d2d34a69$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $cfed44f7d2d34a69$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $cfed44f7d2d34a69$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $cfed44f7d2d34a69$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $cfed44f7d2d34a69$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$cfed44f7d2d34a69$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $cfed44f7d2d34a69$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $cfed44f7d2d34a69$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($cfed44f7d2d34a69$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $cfed44f7d2d34a69$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $cfed44f7d2d34a69$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($cfed44f7d2d34a69$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $cfed44f7d2d34a69$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $cfed44f7d2d34a69$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $cfed44f7d2d34a69$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $cfed44f7d2d34a69$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $cfed44f7d2d34a69$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $cfed44f7d2d34a69$export$3e9cee6b33872309(!$cfed44f7d2d34a69$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($cfed44f7d2d34a69$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $cfed44f7d2d34a69$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $cfed44f7d2d34a69$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($cfed44f7d2d34a69$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $cfed44f7d2d34a69$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $cfed44f7d2d34a69$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $cfed44f7d2d34a69$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($cfed44f7d2d34a69$var$isErrorResult(result)) {
            let boundaryMatch = $cfed44f7d2d34a69$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $cfed44f7d2d34a69$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($cfed44f7d2d34a69$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $cfed44f7d2d34a69$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($cfed44f7d2d34a69$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $cfed44f7d2d34a69$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $cfed44f7d2d34a69$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $cfed44f7d2d34a69$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $cfed44f7d2d34a69$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $cfed44f7d2d34a69$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $cfed44f7d2d34a69$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $cfed44f7d2d34a69$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $cfed44f7d2d34a69$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $cfed44f7d2d34a69$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $cfed44f7d2d34a69$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $cfed44f7d2d34a69$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($cfed44f7d2d34a69$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $cfed44f7d2d34a69$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(path) : path;
    return $cfed44f7d2d34a69$export$fe53371bee54353d($cfed44f7d2d34a69$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $cfed44f7d2d34a69$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $cfed44f7d2d34a69$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $cfed44f7d2d34a69$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $cfed44f7d2d34a69$var$ResultType.data || result.type === $cfed44f7d2d34a69$var$ResultType.error);
}
function $cfed44f7d2d34a69$var$isRedirectHandlerResult(result) {
    return $cfed44f7d2d34a69$var$isResponse(result.result) && $cfed44f7d2d34a69$var$redirectStatusCodes.has(result.result.status);
}
function $cfed44f7d2d34a69$var$isDeferredResult(result) {
    return result.type === $cfed44f7d2d34a69$var$ResultType.deferred;
}
function $cfed44f7d2d34a69$var$isErrorResult(result) {
    return result.type === $cfed44f7d2d34a69$var$ResultType.error;
}
function $cfed44f7d2d34a69$var$isRedirectResult(result) {
    return (result && result.type) === $cfed44f7d2d34a69$var$ResultType.redirect;
}
function $cfed44f7d2d34a69$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $cfed44f7d2d34a69$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $cfed44f7d2d34a69$var$isRedirectResponse(result) {
    if (!$cfed44f7d2d34a69$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $cfed44f7d2d34a69$var$isValidMethod(method) {
    return $cfed44f7d2d34a69$var$validRequestMethods.has(method.toLowerCase());
}
function $cfed44f7d2d34a69$var$isMutationMethod(method) {
    return $cfed44f7d2d34a69$var$validMutationMethods.has(method.toLowerCase());
}
async function $cfed44f7d2d34a69$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$cfed44f7d2d34a69$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($cfed44f7d2d34a69$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $cfed44f7d2d34a69$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $cfed44f7d2d34a69$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $cfed44f7d2d34a69$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $cfed44f7d2d34a69$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $cfed44f7d2d34a69$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $cfed44f7d2d34a69$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $cfed44f7d2d34a69$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $cfed44f7d2d34a69$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $cfed44f7d2d34a69$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $cfed44f7d2d34a69$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $cfed44f7d2d34a69$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $cfed44f7d2d34a69$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $cfed44f7d2d34a69$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $cfed44f7d2d34a69$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $cfed44f7d2d34a69$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $cfed44f7d2d34a69$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $cfed44f7d2d34a69$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $cfed44f7d2d34a69$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($cfed44f7d2d34a69$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $cfed44f7d2d34a69$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($cfed44f7d2d34a69$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $cfed44f7d2d34a69$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("fOZMN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $b84b73f2c12e694f$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $b84b73f2c12e694f$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $b84b73f2c12e694f$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $b84b73f2c12e694f$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $b84b73f2c12e694f$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $b84b73f2c12e694f$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $b84b73f2c12e694f$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $b84b73f2c12e694f$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $b84b73f2c12e694f$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $b84b73f2c12e694f$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $b84b73f2c12e694f$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $b84b73f2c12e694f$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $b84b73f2c12e694f$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $b84b73f2c12e694f$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $b84b73f2c12e694f$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $b84b73f2c12e694f$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $b84b73f2c12e694f$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $b84b73f2c12e694f$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $b84b73f2c12e694f$export$52b333d321859367; });
/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dgG1Y = parcelRequire("dgG1Y");

var $hQMXr = parcelRequire("hQMXr");
function $b84b73f2c12e694f$var$_extends() {
    $b84b73f2c12e694f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b84b73f2c12e694f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $b84b73f2c12e694f$export$3add0d5dce533e2e = /*#__PURE__*/ $dgG1Y.createContext(null);
const $b84b73f2c12e694f$export$145dfa71566a64dc = /*#__PURE__*/ $dgG1Y.createContext(null);
const $b84b73f2c12e694f$var$AwaitContext = /*#__PURE__*/ $dgG1Y.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $b84b73f2c12e694f$export$26749e8557646306 = /*#__PURE__*/ $dgG1Y.createContext(null);
const $b84b73f2c12e694f$export$c7914228fb69b0f5 = /*#__PURE__*/ $dgG1Y.createContext(null);
const $b84b73f2c12e694f$export$9072aa6dd1f93057 = /*#__PURE__*/ $dgG1Y.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $b84b73f2c12e694f$var$RouteErrorContext = /*#__PURE__*/ $dgG1Y.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b84b73f2c12e694f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $dgG1Y.useContext($b84b73f2c12e694f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b84b73f2c12e694f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $hQMXr.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b84b73f2c12e694f$export$9c954a9d03d32f4a() {
    return $dgG1Y.useContext($b84b73f2c12e694f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b84b73f2c12e694f$export$45d76561a5302f2b() {
    !$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    return $dgG1Y.useContext($b84b73f2c12e694f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b84b73f2c12e694f$export$1b3f31771c5d07c() {
    return $dgG1Y.useContext($b84b73f2c12e694f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b84b73f2c12e694f$export$6c330e8992e8a295(pattern) {
    !$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    let { pathname: pathname } = $b84b73f2c12e694f$export$45d76561a5302f2b();
    return $dgG1Y.useMemo(()=>(0, $hQMXr.matchPath)(pattern, (0, $hQMXr.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $b84b73f2c12e694f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b84b73f2c12e694f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dgG1Y.useContext($b84b73f2c12e694f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dgG1Y.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b84b73f2c12e694f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b84b73f2c12e694f$var$useNavigateStable() : $b84b73f2c12e694f$var$useNavigateUnstable();
}
function $b84b73f2c12e694f$var$useNavigateUnstable() {
    !$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    let dataRouterContext = $dgG1Y.useContext($b84b73f2c12e694f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $dgG1Y.useContext($b84b73f2c12e694f$export$26749e8557646306);
    let { matches: matches } = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b84b73f2c12e694f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $hQMXr.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $dgG1Y.useRef(false);
    $b84b73f2c12e694f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dgG1Y.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $hQMXr.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $hQMXr.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $b84b73f2c12e694f$var$OutletContext = /*#__PURE__*/ $dgG1Y.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b84b73f2c12e694f$export$4138103a3ae699cc() {
    return $dgG1Y.useContext($b84b73f2c12e694f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b84b73f2c12e694f$export$a3be3530d8e40d0b(context) {
    let outlet = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b84b73f2c12e694f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b84b73f2c12e694f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $dgG1Y.useContext($b84b73f2c12e694f$export$26749e8557646306);
    let { matches: matches } = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b84b73f2c12e694f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $hQMXr.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $dgG1Y.useMemo(()=>(0, $hQMXr.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b84b73f2c12e694f$export$5d3fca4a98652595(routes, locationArg) {
    return $b84b73f2c12e694f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b84b73f2c12e694f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    let { navigator: navigator } = $dgG1Y.useContext($b84b73f2c12e694f$export$26749e8557646306);
    let { matches: parentMatches } = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b84b73f2c12e694f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $hQMXr.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $hQMXr.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $hQMXr.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b84b73f2c12e694f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $hQMXr.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $hQMXr.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b84b73f2c12e694f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $hQMXr.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b84b73f2c12e694f$var$DefaultErrorComponent() {
    let error = $b84b73f2c12e694f$export$ed527bf60f6e05f2();
    let message = (0, $hQMXr.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dgG1Y.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dgG1Y.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $b84b73f2c12e694f$var$defaultErrorElement = /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$DefaultErrorComponent, null);
class $b84b73f2c12e694f$var$RenderErrorBoundary extends $dgG1Y.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $b84b73f2c12e694f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $dgG1Y.useContext($b84b73f2c12e694f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b84b73f2c12e694f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $hQMXr.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $b84b73f2c12e694f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $b84b73f2c12e694f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dgG1Y.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b84b73f2c12e694f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b84b73f2c12e694f$var$DataRouterHook || {});
var $b84b73f2c12e694f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b84b73f2c12e694f$var$DataRouterStateHook || {});
function $b84b73f2c12e694f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b84b73f2c12e694f$var$useDataRouterContext(hookName) {
    let ctx = $dgG1Y.useContext($b84b73f2c12e694f$export$3add0d5dce533e2e);
    !ctx && (0, $hQMXr.UNSAFE_invariant)(false);
    return ctx;
}
function $b84b73f2c12e694f$var$useDataRouterState(hookName) {
    let state = $dgG1Y.useContext($b84b73f2c12e694f$export$145dfa71566a64dc);
    !state && (0, $hQMXr.UNSAFE_invariant)(false);
    return state;
}
function $b84b73f2c12e694f$var$useRouteContext(hookName) {
    let route = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    !route && (0, $hQMXr.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b84b73f2c12e694f$var$useCurrentRouteId(hookName) {
    let route = $b84b73f2c12e694f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $hQMXr.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b84b73f2c12e694f$export$5fc8298006ad9e58() {
    return $b84b73f2c12e694f$var$useCurrentRouteId($b84b73f2c12e694f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b84b73f2c12e694f$export$d0fd4b7106de2769() {
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b84b73f2c12e694f$export$600dc272ed516c15() {
    let dataRouterContext = $b84b73f2c12e694f$var$useDataRouterContext($b84b73f2c12e694f$var$DataRouterHook.UseRevalidator);
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseRevalidator);
    return $dgG1Y.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b84b73f2c12e694f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseMatches);
    return $dgG1Y.useMemo(()=>matches.map((m)=>(0, $hQMXr.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b84b73f2c12e694f$export$1448a5050d252c4d() {
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $b84b73f2c12e694f$var$useCurrentRouteId($b84b73f2c12e694f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b84b73f2c12e694f$export$fd5d37484eab868d(routeId) {
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b84b73f2c12e694f$export$fdc00f3f26066d5e() {
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseActionData);
    let routeId = $b84b73f2c12e694f$var$useCurrentRouteId($b84b73f2c12e694f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b84b73f2c12e694f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $dgG1Y.useContext($b84b73f2c12e694f$var$RouteErrorContext);
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseRouteError);
    let routeId = $b84b73f2c12e694f$var$useCurrentRouteId($b84b73f2c12e694f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $b84b73f2c12e694f$export$78a72ddb39bdd145() {
    let value = $dgG1Y.useContext($b84b73f2c12e694f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $b84b73f2c12e694f$export$17f53340677d5831() {
    let value = $dgG1Y.useContext($b84b73f2c12e694f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $b84b73f2c12e694f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b84b73f2c12e694f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $b84b73f2c12e694f$var$useDataRouterContext($b84b73f2c12e694f$var$DataRouterHook.UseBlocker);
    let state = $b84b73f2c12e694f$var$useDataRouterState($b84b73f2c12e694f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $dgG1Y.useState("");
    let blockerFunction = $dgG1Y.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $b84b73f2c12e694f$var$_extends({}, currentLocation, {
                pathname: (0, $hQMXr.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b84b73f2c12e694f$var$_extends({}, nextLocation, {
                pathname: (0, $hQMXr.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dgG1Y.useEffect(()=>{
        let key = String(++$b84b73f2c12e694f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dgG1Y.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $hQMXr.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b84b73f2c12e694f$var$useNavigateStable() {
    let { router: router } = $b84b73f2c12e694f$var$useDataRouterContext($b84b73f2c12e694f$var$DataRouterHook.UseNavigateStable);
    let id = $b84b73f2c12e694f$var$useCurrentRouteId($b84b73f2c12e694f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $dgG1Y.useRef(false);
    $b84b73f2c12e694f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dgG1Y.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b84b73f2c12e694f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $b84b73f2c12e694f$var$alreadyWarned = {};
function $b84b73f2c12e694f$var$warningOnce(key, cond, message) {
    if (!cond && !$b84b73f2c12e694f$var$alreadyWarned[key]) $b84b73f2c12e694f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b84b73f2c12e694f$var$START_TRANSITION = "startTransition";
const $b84b73f2c12e694f$var$startTransitionImpl = $dgG1Y[$b84b73f2c12e694f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b84b73f2c12e694f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dgG1Y.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dgG1Y.useCallback((newState)=>{
        if (v7_startTransition && $b84b73f2c12e694f$var$startTransitionImpl) $b84b73f2c12e694f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dgG1Y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $dgG1Y.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dgG1Y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dgG1Y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $b84b73f2c12e694f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $b84b73f2c12e694f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b84b73f2c12e694f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $dgG1Y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hQMXr.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dgG1Y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dgG1Y.useCallback((newState)=>{
        v7_startTransition && $b84b73f2c12e694f$var$startTransitionImpl ? $b84b73f2c12e694f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dgG1Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b84b73f2c12e694f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $dgG1Y.useContext($b84b73f2c12e694f$export$26749e8557646306);
    let { matches: matches } = $dgG1Y.useContext($b84b73f2c12e694f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b84b73f2c12e694f$export$45d76561a5302f2b();
    let navigate = $b84b73f2c12e694f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $hQMXr.resolveTo)(to, (0, $hQMXr.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dgG1Y.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b84b73f2c12e694f$export$910ae8079b2c2852(props) {
    return $b84b73f2c12e694f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b84b73f2c12e694f$export$e7b0ac011bb776c6(_props) {
    (0, $hQMXr.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b84b73f2c12e694f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $hQMXr.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$b84b73f2c12e694f$export$9c954a9d03d32f4a() && (0, $hQMXr.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dgG1Y.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $b84b73f2c12e694f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $hQMXr.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $dgG1Y.useMemo(()=>{
        let trailingPathname = (0, $hQMXr.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b84b73f2c12e694f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $b84b73f2c12e694f$export$5d3fca4a98652595($b84b73f2c12e694f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b84b73f2c12e694f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$ResolveAwait, null, children));
}
var $b84b73f2c12e694f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b84b73f2c12e694f$var$AwaitRenderStatus || {});
const $b84b73f2c12e694f$var$neverSettledPromise = new Promise(()=>{});
class $b84b73f2c12e694f$var$AwaitErrorBoundary extends $dgG1Y.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b84b73f2c12e694f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b84b73f2c12e694f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b84b73f2c12e694f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $b84b73f2c12e694f$var$AwaitRenderStatus.error : "_data" in promise ? $b84b73f2c12e694f$var$AwaitRenderStatus.success : $b84b73f2c12e694f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b84b73f2c12e694f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b84b73f2c12e694f$var$AwaitRenderStatus.error && promise._error instanceof (0, $hQMXr.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $b84b73f2c12e694f$var$neverSettledPromise;
        if (status === $b84b73f2c12e694f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b84b73f2c12e694f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b84b73f2c12e694f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $dgG1Y.createElement($b84b73f2c12e694f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $b84b73f2c12e694f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $b84b73f2c12e694f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b84b73f2c12e694f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $dgG1Y.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dgG1Y.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b84b73f2c12e694f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b84b73f2c12e694f$export$e7b0ac011bb776c6) && (0, $hQMXr.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $hQMXr.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b84b73f2c12e694f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b84b73f2c12e694f$export$daf73786167a7f72(matches) {
    return $b84b73f2c12e694f$var$_renderMatches(matches);
}
function $b84b73f2c12e694f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dgG1Y.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dgG1Y.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dgG1Y.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b84b73f2c12e694f$export$f30f7e456d254e83(routes, opts) {
    return (0, $hQMXr.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b84b73f2c12e694f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hQMXr.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b84b73f2c12e694f$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}

});


parcelRegister("bh1oa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83525c01783f8b24$export$2e2bcd8739ae039; });
function $83525c01783f8b24$export$2e2bcd8739ae039() {
    return $83525c01783f8b24$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $83525c01783f8b24$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jlzll", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e15b64e73fde39cd$var$ReactIs, $e15b64e73fde39cd$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("cMGZX"))();

});
parcelRegister("cMGZX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aEx7d = parcelRequire("aEx7d");
function $94eb5251d84a5e72$var$emptyFunction() {}
function $94eb5251d84a5e72$var$emptyFunctionWithReset() {}
$94eb5251d84a5e72$var$emptyFunctionWithReset.resetWarningCache = $94eb5251d84a5e72$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aEx7d) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $94eb5251d84a5e72$var$emptyFunctionWithReset,
        resetWarningCache: $94eb5251d84a5e72$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aEx7d", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7c1753dac5b40237$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7c1753dac5b40237$var$ReactPropTypesSecret;

});



parcelRegister("57IP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bb0602b08cd933f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $hiqiT = parcelRequire("hiqiT");
function $3bb0602b08cd933f$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useContext((0, $hiqiT.default));
    return theme;
}

});
parcelRegister("hiqiT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c978857e7793f29f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
var $c978857e7793f29f$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createContext(null);
var $c978857e7793f29f$export$2e2bcd8739ae039 = $c978857e7793f29f$var$ThemeContext;

});


parcelRegister("2OelD", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $20bb617bff0f9221$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $20bb617bff0f9221$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $20bb617bff0f9221$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("hBw4X")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("hBw4X")).w; });

var $hBw4X = parcelRequire("hBw4X");

var $dgG1Y = parcelRequire("dgG1Y");

var $b8nth = parcelRequire("b8nth");

var $eMF9c = parcelRequire("eMF9c");

var $7e46i = parcelRequire("7e46i");
parcelRequire("5XZq2");
parcelRequire("46AbS");
parcelRequire("8NZtP");

parcelRequire("bUYS0");
var $20bb617bff0f9221$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $hBw4X.h).call(props, "css")) return $dgG1Y.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $hBw4X.E);
    createElementArgArray[1] = (0, $hBw4X.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $dgG1Y.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $20bb617bff0f9221$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $hBw4X.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $7e46i.serializeStyles)([
        styles
    ], undefined, $dgG1Y.useContext((0, $hBw4X.T)));
    if (!(0, $hBw4X.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $dgG1Y.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $dgG1Y.useRef();
    (0, $eMF9c.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $eMF9c.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $b8nth.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $20bb617bff0f9221$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $7e46i.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $20bb617bff0f9221$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $20bb617bff0f9221$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $20bb617bff0f9221$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $20bb617bff0f9221$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $b8nth.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $20bb617bff0f9221$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $eMF9c.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $b8nth.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $hBw4X.i) && res !== undefined) rules += res;
        }
        if (!(0, $hBw4X.i)) return rules;
    });
    if (!(0, $hBw4X.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $dgG1Y.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $20bb617bff0f9221$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $hBw4X.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $hBw4X.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $7e46i.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $b8nth.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $hBw4X.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $20bb617bff0f9221$var$merge(cache.registered, css, $20bb617bff0f9221$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $dgG1Y.useContext((0, $hBw4X.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement($20bb617bff0f9221$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("hBw4X", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $cd0ec6958673752a$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $cd0ec6958673752a$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $cd0ec6958673752a$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $cd0ec6958673752a$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $cd0ec6958673752a$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $cd0ec6958673752a$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $cd0ec6958673752a$export$a9c23c6ac3fc3eca; });

var $dgG1Y = parcelRequire("dgG1Y");

var $5XZq2 = parcelRequire("5XZq2");

var $bh1oa = parcelRequire("bh1oa");

var $8NZtP = parcelRequire("8NZtP");

var $1x9nf = parcelRequire("1x9nf");

var $b8nth = parcelRequire("b8nth");

var $7e46i = parcelRequire("7e46i");

var $eMF9c = parcelRequire("eMF9c");
var $cd0ec6958673752a$export$407448d2b89b1813 = false;
var $cd0ec6958673752a$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $cd0ec6958673752a$var$EmotionCacheContext = /* #__PURE__ */ $dgG1Y.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $5XZq2.default)({
    key: "css"
}) : null);
var $cd0ec6958673752a$export$e7094788287c5e9b = $cd0ec6958673752a$var$EmotionCacheContext.Provider;
var $cd0ec6958673752a$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $dgG1Y.useContext)($cd0ec6958673752a$var$EmotionCacheContext);
};
var $cd0ec6958673752a$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $dgG1Y.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $dgG1Y.useContext)($cd0ec6958673752a$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$cd0ec6958673752a$export$23f2a1d2818174ef) $cd0ec6958673752a$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $dgG1Y.useContext)($cd0ec6958673752a$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $5XZq2.default)({
                key: "css"
            });
            return /*#__PURE__*/ $dgG1Y.createElement($cd0ec6958673752a$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $cd0ec6958673752a$export$971d5caa766a69d7 = /* #__PURE__ */ $dgG1Y.createContext({});
var $cd0ec6958673752a$export$3b14a55fb2447963 = function useTheme() {
    return $dgG1Y.useContext($cd0ec6958673752a$export$971d5caa766a69d7);
};
var $cd0ec6958673752a$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $bh1oa.default)({}, outerTheme, theme);
};
var $cd0ec6958673752a$var$createCacheWithTheme = /* #__PURE__ */ (0, $8NZtP.default)(function(outerTheme) {
    return (0, $8NZtP.default)(function(theme) {
        return $cd0ec6958673752a$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $cd0ec6958673752a$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $dgG1Y.useContext($cd0ec6958673752a$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $cd0ec6958673752a$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $dgG1Y.createElement($cd0ec6958673752a$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $cd0ec6958673752a$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $dgG1Y.useContext($cd0ec6958673752a$export$971d5caa766a69d7);
        return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $dgG1Y.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $1x9nf.default)(WithTheme, Component);
}
var $cd0ec6958673752a$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $cd0ec6958673752a$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $cd0ec6958673752a$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($cd0ec6958673752a$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$cd0ec6958673752a$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $cd0ec6958673752a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $b8nth.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $eMF9c.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $b8nth.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$cd0ec6958673752a$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $dgG1Y.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $cd0ec6958673752a$var$Emotion = /* #__PURE__ */ $cd0ec6958673752a$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$cd0ec6958673752a$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $b8nth.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $7e46i.serializeStyles)(registeredStyles, undefined, $dgG1Y.useContext($cd0ec6958673752a$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($cd0ec6958673752a$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $cd0ec6958673752a$var$typePropName && !$cd0ec6958673752a$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement($cd0ec6958673752a$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $dgG1Y.createElement(WrappedComponent, newProps));
});
var $cd0ec6958673752a$export$a9c23c6ac3fc3eca = $cd0ec6958673752a$var$Emotion;

});
parcelRegister("5XZq2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45821afbd0312303$export$2e2bcd8739ae039; });

var $fGPwU = parcelRequire("fGPwU");

var $1GVpu = parcelRequire("1GVpu");

var $8NZtP = parcelRequire("8NZtP");

var $eyO54 = parcelRequire("eyO54");
var $45821afbd0312303$var$isBrowser = typeof document !== "undefined";
var $45821afbd0312303$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $1GVpu.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $1GVpu.token)(character)) break;
        (0, $1GVpu.next)();
    }
    return (0, $1GVpu.slice)(begin, (0, $1GVpu.position));
};
var $45821afbd0312303$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $1GVpu.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $1GVpu.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $45821afbd0312303$var$identifierWithPointTracking((0, $1GVpu.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $1GVpu.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $1GVpu.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $1GVpu.from)(character);
    }
    while (character = (0, $1GVpu.next)());
    return parsed;
};
var $45821afbd0312303$var$getRules = function getRules(value, points) {
    return (0, $1GVpu.dealloc)($45821afbd0312303$var$toRules((0, $1GVpu.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $45821afbd0312303$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $45821afbd0312303$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$45821afbd0312303$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $45821afbd0312303$var$fixedElements.set(element, true);
    var points = [];
    var rules = $45821afbd0312303$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $45821afbd0312303$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $45821afbd0312303$var$prefix(value, length) {
    switch((0, $1GVpu.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $1GVpu.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $1GVpu.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MOZ) + value + (0, $1GVpu.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + value + value;
        // order
        case 6165:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.replace)(value, /(\w+).+(:[^]+)/, (0, $1GVpu.WEBKIT) + "box-$1$2" + (0, $1GVpu.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + "flex-item-" + (0, $1GVpu.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + "flex-line-pack" + (0, $1GVpu.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + (0, $1GVpu.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + (0, $1GVpu.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $1GVpu.WEBKIT) + "box-" + (0, $1GVpu.replace)(value, "-grow", "") + (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + (0, $1GVpu.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $1GVpu.WEBKIT) + (0, $1GVpu.replace)(value, /([^-])(transform)/g, "$1" + (0, $1GVpu.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $1GVpu.replace)((0, $1GVpu.replace)((0, $1GVpu.replace)(value, /(zoom-|grab)/, (0, $1GVpu.WEBKIT) + "$1"), /(image-set)/, (0, $1GVpu.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $1GVpu.replace)(value, /(image-set\([^]*)/, (0, $1GVpu.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $1GVpu.replace)((0, $1GVpu.replace)(value, /(.+:)(flex-)?(.*)/, (0, $1GVpu.WEBKIT) + "box-pack:$3" + (0, $1GVpu.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $1GVpu.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $1GVpu.replace)(value, /(.+)-inline(.+)/, (0, $1GVpu.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $1GVpu.strlen)(value) - 1 - length > 6) switch((0, $1GVpu.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $1GVpu.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $1GVpu.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $1GVpu.WEBKIT) + "$2-$3" + "$1" + (0, $1GVpu.MOZ) + ((0, $1GVpu.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $1GVpu.indexof)(value, "stretch") ? $45821afbd0312303$var$prefix((0, $1GVpu.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $1GVpu.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $1GVpu.charat)(value, (0, $1GVpu.strlen)(value) - 3 - (~(0, $1GVpu.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $1GVpu.replace)(value, ":", ":" + (0, $1GVpu.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $1GVpu.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $1GVpu.WEBKIT) + ((0, $1GVpu.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $1GVpu.WEBKIT) + "$2$3" + "$1" + (0, $1GVpu.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $1GVpu.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + (0, $1GVpu.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + (0, $1GVpu.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + (0, $1GVpu.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $1GVpu.WEBKIT) + value + (0, $1GVpu.MS) + value + value;
    }
    return value;
}
var $45821afbd0312303$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $1GVpu.DECLARATION:
                element["return"] = $45821afbd0312303$var$prefix(element.value, element.length);
                break;
            case 0, $1GVpu.KEYFRAMES:
                return (0, $1GVpu.serialize)([
                    (0, $1GVpu.copy)(element, {
                        value: (0, $1GVpu.replace)(element.value, "@", "@" + (0, $1GVpu.WEBKIT))
                    })
                ], callback);
            case 0, $1GVpu.RULESET:
                if (element.length) return (0, $1GVpu.combine)(element.props, function(value) {
                    switch((0, $1GVpu.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $1GVpu.serialize)([
                                (0, $1GVpu.copy)(element, {
                                    props: [
                                        (0, $1GVpu.replace)(value, /:(read-\w+)/, ":" + (0, $1GVpu.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $1GVpu.serialize)([
                                (0, $1GVpu.copy)(element, {
                                    props: [
                                        (0, $1GVpu.replace)(value, /:(plac\w+)/, ":" + (0, $1GVpu.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $1GVpu.copy)(element, {
                                    props: [
                                        (0, $1GVpu.replace)(value, /:(plac\w+)/, ":" + (0, $1GVpu.MOZ) + "$1")
                                    ]
                                }),
                                (0, $1GVpu.copy)(element, {
                                    props: [
                                        (0, $1GVpu.replace)(value, /:(plac\w+)/, (0, $1GVpu.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $45821afbd0312303$var$getServerStylisCache = $45821afbd0312303$var$isBrowser ? undefined : (0, $8NZtP.default)(function() {
    return (0, $eyO54.default)(function() {
        return {};
    });
});
var $45821afbd0312303$var$defaultStylisPlugins = [
    $45821afbd0312303$var$prefixer
];
var $45821afbd0312303$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($45821afbd0312303$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $45821afbd0312303$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($45821afbd0312303$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $45821afbd0312303$var$compat,
        $45821afbd0312303$var$removeLabel
    ];
    if (!$45821afbd0312303$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $1GVpu.stringify),
            (0, $1GVpu.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $1GVpu.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $1GVpu.serialize)((0, $1GVpu.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $1GVpu.stringify)
        ];
        var _serializer = (0, $1GVpu.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $1GVpu.serialize)((0, $1GVpu.compile)(styles), _serializer);
        };
        var serverStylisCache = $45821afbd0312303$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $fGPwU.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("fGPwU", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $b6c2bffe3b8b54db$export$9d753cd7ae895cce; });
var $b6c2bffe3b8b54db$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $b6c2bffe3b8b54db$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $b6c2bffe3b8b54db$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $b6c2bffe3b8b54db$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$b6c2bffe3b8b54db$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($b6c2bffe3b8b54db$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $b6c2bffe3b8b54db$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("1GVpu", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $37363dd27b61ab0f$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $37363dd27b61ab0f$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $37363dd27b61ab0f$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $37363dd27b61ab0f$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $37363dd27b61ab0f$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $37363dd27b61ab0f$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $37363dd27b61ab0f$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $37363dd27b61ab0f$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $37363dd27b61ab0f$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $37363dd27b61ab0f$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $37363dd27b61ab0f$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $37363dd27b61ab0f$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $37363dd27b61ab0f$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $37363dd27b61ab0f$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $37363dd27b61ab0f$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $37363dd27b61ab0f$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $37363dd27b61ab0f$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $37363dd27b61ab0f$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $37363dd27b61ab0f$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $37363dd27b61ab0f$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $37363dd27b61ab0f$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $37363dd27b61ab0f$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $37363dd27b61ab0f$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $37363dd27b61ab0f$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $37363dd27b61ab0f$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $37363dd27b61ab0f$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $37363dd27b61ab0f$export$38bcb760f1d4871c; });
var $37363dd27b61ab0f$export$71ad59f2e432cfe8 = "-ms-";
var $37363dd27b61ab0f$export$2c0f367103c8d01c = "-moz-";
var $37363dd27b61ab0f$export$39dfd62a25e0fe93 = "-webkit-";
var $37363dd27b61ab0f$export$a29989082612d0d9 = "comm";
var $37363dd27b61ab0f$export$aa3a2e812ca8570d = "rule";
var $37363dd27b61ab0f$export$527d108ccf083c2b = "decl";
var $37363dd27b61ab0f$export$d3d35020fa5b54f0 = "@page";
var $37363dd27b61ab0f$export$500415a86c544f73 = "@media";
var $37363dd27b61ab0f$export$a763edbf796b780a = "@import";
var $37363dd27b61ab0f$export$2790aeb8b4e5c826 = "@charset";
var $37363dd27b61ab0f$export$1cc683e23b84b133 = "@viewport";
var $37363dd27b61ab0f$export$9447a5efea57e862 = "@supports";
var $37363dd27b61ab0f$export$ef011b4e114b1fba = "@document";
var $37363dd27b61ab0f$export$6aad947bda0f3f46 = "@namespace";
var $37363dd27b61ab0f$export$b44a8529a35fcb60 = "@keyframes";
var $37363dd27b61ab0f$export$2c16de31893252e6 = "@font-face";
var $37363dd27b61ab0f$export$3d846dd52e150c6f = "@counter-style";
var $37363dd27b61ab0f$export$22314bfbb57653fe = "@font-feature-values";
var $37363dd27b61ab0f$export$d773506282b3cfe6 = "@layer";
var $37363dd27b61ab0f$export$2335f513bbd82c6d = Math.abs;
var $37363dd27b61ab0f$export$6788812c4e6611e6 = String.fromCharCode;
var $37363dd27b61ab0f$export$e6e34fd1f2686227 = Object.assign;
function $37363dd27b61ab0f$export$d6af199866bfb566(e, r) {
    return $37363dd27b61ab0f$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $37363dd27b61ab0f$export$a9db5e087081082d(e, 0)) << 2 ^ $37363dd27b61ab0f$export$a9db5e087081082d(e, 1)) << 2 ^ $37363dd27b61ab0f$export$a9db5e087081082d(e, 2)) << 2 ^ $37363dd27b61ab0f$export$a9db5e087081082d(e, 3) : 0;
}
function $37363dd27b61ab0f$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $37363dd27b61ab0f$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $37363dd27b61ab0f$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $37363dd27b61ab0f$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $37363dd27b61ab0f$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $37363dd27b61ab0f$export$36776f635604f274(e) {
    return e.length;
}
function $37363dd27b61ab0f$export$f9084667e487ed46(e) {
    return e.length;
}
function $37363dd27b61ab0f$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $37363dd27b61ab0f$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $37363dd27b61ab0f$export$53f1d5ea8de3d7c = 1;
var $37363dd27b61ab0f$export$4e0c71f277ca26b3 = 1;
var $37363dd27b61ab0f$export$f24224f1c91d8156 = 0;
var $37363dd27b61ab0f$export$5880b8b5730aff45 = 0;
var $37363dd27b61ab0f$export$c0306caf338ac095 = 0;
var $37363dd27b61ab0f$export$30a86d91af8ff6e6 = "";
function $37363dd27b61ab0f$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $37363dd27b61ab0f$export$53f1d5ea8de3d7c,
        column: $37363dd27b61ab0f$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $37363dd27b61ab0f$export$784d13d8ee351f07(e, r) {
    return $37363dd27b61ab0f$export$e6e34fd1f2686227($37363dd27b61ab0f$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $37363dd27b61ab0f$export$eba6f6f03b0a92e7() {
    return $37363dd27b61ab0f$export$c0306caf338ac095;
}
function $37363dd27b61ab0f$export$232faf9add678146() {
    $37363dd27b61ab0f$export$c0306caf338ac095 = $37363dd27b61ab0f$export$5880b8b5730aff45 > 0 ? $37363dd27b61ab0f$export$a9db5e087081082d($37363dd27b61ab0f$export$30a86d91af8ff6e6, --$37363dd27b61ab0f$export$5880b8b5730aff45) : 0;
    if ($37363dd27b61ab0f$export$4e0c71f277ca26b3--, $37363dd27b61ab0f$export$c0306caf338ac095 === 10) $37363dd27b61ab0f$export$4e0c71f277ca26b3 = 1, $37363dd27b61ab0f$export$53f1d5ea8de3d7c--;
    return $37363dd27b61ab0f$export$c0306caf338ac095;
}
function $37363dd27b61ab0f$export$48cfd1e771a65c4f() {
    $37363dd27b61ab0f$export$c0306caf338ac095 = $37363dd27b61ab0f$export$5880b8b5730aff45 < $37363dd27b61ab0f$export$f24224f1c91d8156 ? $37363dd27b61ab0f$export$a9db5e087081082d($37363dd27b61ab0f$export$30a86d91af8ff6e6, $37363dd27b61ab0f$export$5880b8b5730aff45++) : 0;
    if ($37363dd27b61ab0f$export$4e0c71f277ca26b3++, $37363dd27b61ab0f$export$c0306caf338ac095 === 10) $37363dd27b61ab0f$export$4e0c71f277ca26b3 = 1, $37363dd27b61ab0f$export$53f1d5ea8de3d7c++;
    return $37363dd27b61ab0f$export$c0306caf338ac095;
}
function $37363dd27b61ab0f$export$4d3fb11e950abb9e() {
    return $37363dd27b61ab0f$export$a9db5e087081082d($37363dd27b61ab0f$export$30a86d91af8ff6e6, $37363dd27b61ab0f$export$5880b8b5730aff45);
}
function $37363dd27b61ab0f$export$e88cb2efb12ae807() {
    return $37363dd27b61ab0f$export$5880b8b5730aff45;
}
function $37363dd27b61ab0f$export$58adb3bec8346d0f(e, r) {
    return $37363dd27b61ab0f$export$2f35ab04d2335697($37363dd27b61ab0f$export$30a86d91af8ff6e6, e, r);
}
function $37363dd27b61ab0f$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $37363dd27b61ab0f$export$2de70f21292aac9e(e) {
    return $37363dd27b61ab0f$export$53f1d5ea8de3d7c = $37363dd27b61ab0f$export$4e0c71f277ca26b3 = 1, $37363dd27b61ab0f$export$f24224f1c91d8156 = $37363dd27b61ab0f$export$36776f635604f274($37363dd27b61ab0f$export$30a86d91af8ff6e6 = e), $37363dd27b61ab0f$export$5880b8b5730aff45 = 0, [];
}
function $37363dd27b61ab0f$export$45918ac1574455b1(e) {
    return $37363dd27b61ab0f$export$30a86d91af8ff6e6 = "", e;
}
function $37363dd27b61ab0f$export$410ac95b9ec204b8(e) {
    return $37363dd27b61ab0f$export$87c2784dc9fc4ab($37363dd27b61ab0f$export$58adb3bec8346d0f($37363dd27b61ab0f$export$5880b8b5730aff45 - 1, $37363dd27b61ab0f$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $37363dd27b61ab0f$export$660b2ee2d4fb4eff(e) {
    return $37363dd27b61ab0f$export$45918ac1574455b1($37363dd27b61ab0f$export$5f8c09e3ae6f64e1($37363dd27b61ab0f$export$2de70f21292aac9e(e)));
}
function $37363dd27b61ab0f$export$7af1228ff777d175(e) {
    while($37363dd27b61ab0f$export$c0306caf338ac095 = $37363dd27b61ab0f$export$4d3fb11e950abb9e())if ($37363dd27b61ab0f$export$c0306caf338ac095 < 33) $37363dd27b61ab0f$export$48cfd1e771a65c4f();
    else break;
    return $37363dd27b61ab0f$export$9e1725a4cfeada27(e) > 2 || $37363dd27b61ab0f$export$9e1725a4cfeada27($37363dd27b61ab0f$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $37363dd27b61ab0f$export$5f8c09e3ae6f64e1(e) {
    while($37363dd27b61ab0f$export$48cfd1e771a65c4f())switch($37363dd27b61ab0f$export$9e1725a4cfeada27($37363dd27b61ab0f$export$c0306caf338ac095)){
        case 0:
            $37363dd27b61ab0f$export$10d8903dec122b9d($37363dd27b61ab0f$export$c2ab62c7bf24634($37363dd27b61ab0f$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $37363dd27b61ab0f$export$10d8903dec122b9d($37363dd27b61ab0f$export$410ac95b9ec204b8($37363dd27b61ab0f$export$c0306caf338ac095), e);
            break;
        default:
            $37363dd27b61ab0f$export$10d8903dec122b9d($37363dd27b61ab0f$export$6788812c4e6611e6($37363dd27b61ab0f$export$c0306caf338ac095), e);
    }
    return e;
}
function $37363dd27b61ab0f$export$955ba06d119e085e(e, r) {
    while(--r && $37363dd27b61ab0f$export$48cfd1e771a65c4f())if ($37363dd27b61ab0f$export$c0306caf338ac095 < 48 || $37363dd27b61ab0f$export$c0306caf338ac095 > 102 || $37363dd27b61ab0f$export$c0306caf338ac095 > 57 && $37363dd27b61ab0f$export$c0306caf338ac095 < 65 || $37363dd27b61ab0f$export$c0306caf338ac095 > 70 && $37363dd27b61ab0f$export$c0306caf338ac095 < 97) break;
    return $37363dd27b61ab0f$export$58adb3bec8346d0f(e, $37363dd27b61ab0f$export$e88cb2efb12ae807() + (r < 6 && $37363dd27b61ab0f$export$4d3fb11e950abb9e() == 32 && $37363dd27b61ab0f$export$48cfd1e771a65c4f() == 32));
}
function $37363dd27b61ab0f$export$c889f2fcc19dbf12(e) {
    while($37363dd27b61ab0f$export$48cfd1e771a65c4f())switch($37363dd27b61ab0f$export$c0306caf338ac095){
        case e:
            return $37363dd27b61ab0f$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $37363dd27b61ab0f$export$c889f2fcc19dbf12($37363dd27b61ab0f$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $37363dd27b61ab0f$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $37363dd27b61ab0f$export$48cfd1e771a65c4f();
            break;
    }
    return $37363dd27b61ab0f$export$5880b8b5730aff45;
}
function $37363dd27b61ab0f$export$4254d4e2b3745c4c(e, r) {
    while($37363dd27b61ab0f$export$48cfd1e771a65c4f())if (e + $37363dd27b61ab0f$export$c0306caf338ac095 === 57) break;
    else if (e + $37363dd27b61ab0f$export$c0306caf338ac095 === 84 && $37363dd27b61ab0f$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $37363dd27b61ab0f$export$58adb3bec8346d0f(r, $37363dd27b61ab0f$export$5880b8b5730aff45 - 1) + "*" + $37363dd27b61ab0f$export$6788812c4e6611e6(e === 47 ? e : $37363dd27b61ab0f$export$48cfd1e771a65c4f());
}
function $37363dd27b61ab0f$export$c2ab62c7bf24634(e) {
    while(!$37363dd27b61ab0f$export$9e1725a4cfeada27($37363dd27b61ab0f$export$4d3fb11e950abb9e()))$37363dd27b61ab0f$export$48cfd1e771a65c4f();
    return $37363dd27b61ab0f$export$58adb3bec8346d0f(e, $37363dd27b61ab0f$export$5880b8b5730aff45);
}
function $37363dd27b61ab0f$export$ef7acd7185315e22(e) {
    return $37363dd27b61ab0f$export$45918ac1574455b1($37363dd27b61ab0f$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $37363dd27b61ab0f$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $37363dd27b61ab0f$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $37363dd27b61ab0f$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $37363dd27b61ab0f$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($37363dd27b61ab0f$export$f8e21b1e77979a08(j += $37363dd27b61ab0f$export$77ad94ebf1c2b9ed($37363dd27b61ab0f$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $37363dd27b61ab0f$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $37363dd27b61ab0f$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $37363dd27b61ab0f$export$955ba06d119e085e($37363dd27b61ab0f$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($37363dd27b61ab0f$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $37363dd27b61ab0f$export$10d8903dec122b9d($37363dd27b61ab0f$export$4a34f930e789283c($37363dd27b61ab0f$export$4254d4e2b3745c4c($37363dd27b61ab0f$export$48cfd1e771a65c4f(), $37363dd27b61ab0f$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $37363dd27b61ab0f$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $37363dd27b61ab0f$export$36776f635604f274(j) - l) $37363dd27b61ab0f$export$10d8903dec122b9d(p > 32 ? $37363dd27b61ab0f$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $37363dd27b61ab0f$export$f8483753829ec8f3($37363dd27b61ab0f$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $37363dd27b61ab0f$export$10d8903dec122b9d(y = $37363dd27b61ab0f$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $37363dd27b61ab0f$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $37363dd27b61ab0f$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $37363dd27b61ab0f$export$98e6a39c04603d36(e, y, y, n && $37363dd27b61ab0f$export$10d8903dec122b9d($37363dd27b61ab0f$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $37363dd27b61ab0f$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $37363dd27b61ab0f$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $37363dd27b61ab0f$export$232faf9add678146() == 125) continue;
            }
            switch(j += $37363dd27b61ab0f$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($37363dd27b61ab0f$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($37363dd27b61ab0f$export$4d3fb11e950abb9e() === 45) j += $37363dd27b61ab0f$export$410ac95b9ec204b8($37363dd27b61ab0f$export$48cfd1e771a65c4f());
                    v = $37363dd27b61ab0f$export$4d3fb11e950abb9e(), o = l = $37363dd27b61ab0f$export$36776f635604f274(g = j += $37363dd27b61ab0f$export$c2ab62c7bf24634($37363dd27b61ab0f$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $37363dd27b61ab0f$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $37363dd27b61ab0f$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $37363dd27b61ab0f$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $37363dd27b61ab0f$export$2f35ab04d2335697(e, v + 1, v = $37363dd27b61ab0f$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $37363dd27b61ab0f$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $37363dd27b61ab0f$export$35059013cd4a06db(e, r, a, s === 0 ? $37363dd27b61ab0f$export$aa3a2e812ca8570d : i, f, o, l);
}
function $37363dd27b61ab0f$export$4a34f930e789283c(e, r, a) {
    return $37363dd27b61ab0f$export$35059013cd4a06db(e, r, a, $37363dd27b61ab0f$export$a29989082612d0d9, $37363dd27b61ab0f$export$6788812c4e6611e6($37363dd27b61ab0f$export$eba6f6f03b0a92e7()), $37363dd27b61ab0f$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $37363dd27b61ab0f$export$f8483753829ec8f3(e, r, a, n) {
    return $37363dd27b61ab0f$export$35059013cd4a06db(e, r, a, $37363dd27b61ab0f$export$527d108ccf083c2b, $37363dd27b61ab0f$export$2f35ab04d2335697(e, 0, n), $37363dd27b61ab0f$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $37363dd27b61ab0f$export$82e9f45cca5ba907(n, c, s) {
    switch($37363dd27b61ab0f$export$d6af199866bfb566(n, c)){
        case 5103:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $37363dd27b61ab0f$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$2c0f367103c8d01c + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($37363dd27b61ab0f$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "box-$1$2" + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "flex-item-" + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$37363dd27b61ab0f$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "grid-row-" + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "flex-line-pack" + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "box-" + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "-grow", "") + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $37363dd27b61ab0f$export$39dfd62a25e0fe93 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed($37363dd27b61ab0f$export$77ad94ebf1c2b9ed($37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed($37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "box-pack:$3" + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$37363dd27b61ab0f$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "grid-column-align" + $37363dd27b61ab0f$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $37363dd27b61ab0f$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$37363dd27b61ab0f$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$37363dd27b61ab0f$export$f8e21b1e77979a08(s, "span") ? $37363dd27b61ab0f$export$4659b591c19bdf3d(s, /\d+/) : +$37363dd27b61ab0f$export$4659b591c19bdf3d(s, /\d+/) - +$37363dd27b61ab0f$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $37363dd27b61ab0f$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $37363dd27b61ab0f$export$71ad59f2e432cfe8 + $37363dd27b61ab0f$export$77ad94ebf1c2b9ed($37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($37363dd27b61ab0f$export$36776f635604f274(n) - 1 - c > 6) switch($37363dd27b61ab0f$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($37363dd27b61ab0f$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $37363dd27b61ab0f$export$2c0f367103c8d01c + ($37363dd27b61ab0f$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$37363dd27b61ab0f$export$f8e21b1e77979a08(n, "stretch") ? $37363dd27b61ab0f$export$82e9f45cca5ba907($37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $37363dd27b61ab0f$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $37363dd27b61ab0f$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($37363dd27b61ab0f$export$a9db5e087081082d(n, c + 6) === 121) return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, ":", ":" + $37363dd27b61ab0f$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($37363dd27b61ab0f$export$a9db5e087081082d(n, $37363dd27b61ab0f$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + ($37363dd27b61ab0f$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, ":", ":" + $37363dd27b61ab0f$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $37363dd27b61ab0f$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $37363dd27b61ab0f$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $37363dd27b61ab0f$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $37363dd27b61ab0f$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $37363dd27b61ab0f$export$a763edbf796b780a:
        case $37363dd27b61ab0f$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $37363dd27b61ab0f$export$a29989082612d0d9:
            return "";
        case $37363dd27b61ab0f$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $37363dd27b61ab0f$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $37363dd27b61ab0f$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $37363dd27b61ab0f$export$36776f635604f274(a = $37363dd27b61ab0f$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $37363dd27b61ab0f$export$5a7767152ae0305f(e) {
    var r = $37363dd27b61ab0f$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $37363dd27b61ab0f$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $37363dd27b61ab0f$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $37363dd27b61ab0f$export$527d108ccf083c2b:
                n.return = $37363dd27b61ab0f$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $37363dd27b61ab0f$export$b44a8529a35fcb60:
                return $37363dd27b61ab0f$export$dfdc1655ccc5b9cb([
                    $37363dd27b61ab0f$export$784d13d8ee351f07(n, {
                        value: $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $37363dd27b61ab0f$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $37363dd27b61ab0f$export$aa3a2e812ca8570d:
                if (n.length) return $37363dd27b61ab0f$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($37363dd27b61ab0f$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $37363dd27b61ab0f$export$dfdc1655ccc5b9cb([
                                $37363dd27b61ab0f$export$784d13d8ee351f07(n, {
                                    props: [
                                        $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $37363dd27b61ab0f$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $37363dd27b61ab0f$export$dfdc1655ccc5b9cb([
                                $37363dd27b61ab0f$export$784d13d8ee351f07(n, {
                                    props: [
                                        $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $37363dd27b61ab0f$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $37363dd27b61ab0f$export$784d13d8ee351f07(n, {
                                    props: [
                                        $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $37363dd27b61ab0f$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $37363dd27b61ab0f$export$784d13d8ee351f07(n, {
                                    props: [
                                        $37363dd27b61ab0f$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $37363dd27b61ab0f$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $37363dd27b61ab0f$export$76a88f7de6507443(e) {
    switch(e.type){
        case $37363dd27b61ab0f$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $37363dd27b61ab0f$export$1be1fc439b849fdf($37363dd27b61ab0f$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($37363dd27b61ab0f$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $37363dd27b61ab0f$export$2f35ab04d2335697(r, 1, $37363dd27b61ab0f$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $37363dd27b61ab0f$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $37363dd27b61ab0f$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $37363dd27b61ab0f$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("8NZtP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $669296fe4018fb64$export$2e2bcd8739ae039; });
var $669296fe4018fb64$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("eyO54", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a99b16aa64d503ff$export$2e2bcd8739ae039; });
function $a99b16aa64d503ff$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("1x9nf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e024f66a0f6fb2$export$2e2bcd8739ae039; });

var $bUYS0 = parcelRequire("bUYS0");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $11e024f66a0f6fb2$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bUYS0)))(targetComponent, sourceComponent);
};

});
parcelRegister("bUYS0", function(module, exports) {
"use strict";

var $hGPdi = parcelRequire("hGPdi");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $8ad42436d66eeeef$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $8ad42436d66eeeef$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $8ad42436d66eeeef$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $8ad42436d66eeeef$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $8ad42436d66eeeef$var$TYPE_STATICS = {};
$8ad42436d66eeeef$var$TYPE_STATICS[$hGPdi.ForwardRef] = $8ad42436d66eeeef$var$FORWARD_REF_STATICS;
$8ad42436d66eeeef$var$TYPE_STATICS[$hGPdi.Memo] = $8ad42436d66eeeef$var$MEMO_STATICS;
function $8ad42436d66eeeef$var$getStatics(component) {
    // React v16.11 and below
    if ($hGPdi.isMemo(component)) return $8ad42436d66eeeef$var$MEMO_STATICS;
     // React v16.12 and above
    return $8ad42436d66eeeef$var$TYPE_STATICS[component["$$typeof"]] || $8ad42436d66eeeef$var$REACT_STATICS;
}
var $8ad42436d66eeeef$var$defineProperty = Object.defineProperty;
var $8ad42436d66eeeef$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $8ad42436d66eeeef$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8ad42436d66eeeef$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8ad42436d66eeeef$var$getPrototypeOf = Object.getPrototypeOf;
var $8ad42436d66eeeef$var$objectPrototype = Object.prototype;
function $8ad42436d66eeeef$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($8ad42436d66eeeef$var$objectPrototype) {
            var inheritedComponent = $8ad42436d66eeeef$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $8ad42436d66eeeef$var$objectPrototype) $8ad42436d66eeeef$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $8ad42436d66eeeef$var$getOwnPropertyNames(sourceComponent);
        if ($8ad42436d66eeeef$var$getOwnPropertySymbols) keys = keys.concat($8ad42436d66eeeef$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $8ad42436d66eeeef$var$getStatics(targetComponent);
        var sourceStatics = $8ad42436d66eeeef$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$8ad42436d66eeeef$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $8ad42436d66eeeef$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $8ad42436d66eeeef$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $8ad42436d66eeeef$var$hoistNonReactStatics;

});
parcelRegister("hGPdi", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3fzjI"));

});
parcelRegister("3fzjI", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $25de2b0add077430$export$2b8d127b894957b9; }, function (v) { return $25de2b0add077430$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $25de2b0add077430$export$cea3a54a6425200c; }, function (v) { return $25de2b0add077430$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $25de2b0add077430$export$a7c73072b1a182ae; }, function (v) { return $25de2b0add077430$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $25de2b0add077430$export$9f27bc3417b4524d; }, function (v) { return $25de2b0add077430$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $25de2b0add077430$export$db77ccec0bb4ccac; }, function (v) { return $25de2b0add077430$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $25de2b0add077430$export$8392c0c9d3dcbd35; }, function (v) { return $25de2b0add077430$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $25de2b0add077430$export$ffb0004e005737fa; }, function (v) { return $25de2b0add077430$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $25de2b0add077430$export$b624eff549462981; }, function (v) { return $25de2b0add077430$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $25de2b0add077430$export$7897aa7841a5380c; }, function (v) { return $25de2b0add077430$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $25de2b0add077430$export$602eac185826482c; }, function (v) { return $25de2b0add077430$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $25de2b0add077430$export$e2c29f18771995cb; }, function (v) { return $25de2b0add077430$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $25de2b0add077430$export$5f8d39834fd61797; }, function (v) { return $25de2b0add077430$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $25de2b0add077430$export$74bf444e3cd11ea5; }, function (v) { return $25de2b0add077430$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $25de2b0add077430$export$92387174baf9b227; }, function (v) { return $25de2b0add077430$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $25de2b0add077430$export$ec112efeb987d9c6; }, function (v) { return $25de2b0add077430$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $25de2b0add077430$export$b706b080d889d2c9; }, function (v) { return $25de2b0add077430$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $25de2b0add077430$export$5be5a87408f70ddc; }, function (v) { return $25de2b0add077430$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $25de2b0add077430$export$45a5e7f76e0caa8d; }, function (v) { return $25de2b0add077430$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $25de2b0add077430$export$455c2e768291efa6; }, function (v) { return $25de2b0add077430$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $25de2b0add077430$export$9522e17588c12572; }, function (v) { return $25de2b0add077430$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $25de2b0add077430$export$2110ac352bb060b9; }, function (v) { return $25de2b0add077430$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $25de2b0add077430$export$56885ab8b9c456ab; }, function (v) { return $25de2b0add077430$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $25de2b0add077430$export$d927fcb6adf8f9de; }, function (v) { return $25de2b0add077430$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $25de2b0add077430$export$b82d16f27459e05a; }, function (v) { return $25de2b0add077430$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $25de2b0add077430$export$522c17b4f5e123e8; }, function (v) { return $25de2b0add077430$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $25de2b0add077430$export$1aabd8a0274ecfd6; }, function (v) { return $25de2b0add077430$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $25de2b0add077430$export$9b621391a187a31a; }, function (v) { return $25de2b0add077430$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $25de2b0add077430$export$f5bbd400c2f4426f; }, function (v) { return $25de2b0add077430$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25de2b0add077430$export$2b8d127b894957b9;
var $25de2b0add077430$export$cea3a54a6425200c;
var $25de2b0add077430$export$a7c73072b1a182ae;
var $25de2b0add077430$export$9f27bc3417b4524d;
var $25de2b0add077430$export$db77ccec0bb4ccac;
var $25de2b0add077430$export$8392c0c9d3dcbd35;
var $25de2b0add077430$export$ffb0004e005737fa;
var $25de2b0add077430$export$b624eff549462981;
var $25de2b0add077430$export$7897aa7841a5380c;
var $25de2b0add077430$export$602eac185826482c;
var $25de2b0add077430$export$e2c29f18771995cb;
var $25de2b0add077430$export$5f8d39834fd61797;
var $25de2b0add077430$export$74bf444e3cd11ea5;
var $25de2b0add077430$export$92387174baf9b227;
var $25de2b0add077430$export$ec112efeb987d9c6;
var $25de2b0add077430$export$b706b080d889d2c9;
var $25de2b0add077430$export$5be5a87408f70ddc;
var $25de2b0add077430$export$45a5e7f76e0caa8d;
var $25de2b0add077430$export$455c2e768291efa6;
var $25de2b0add077430$export$9522e17588c12572;
var $25de2b0add077430$export$2110ac352bb060b9;
var $25de2b0add077430$export$56885ab8b9c456ab;
var $25de2b0add077430$export$d927fcb6adf8f9de;
var $25de2b0add077430$export$b82d16f27459e05a;
var $25de2b0add077430$export$522c17b4f5e123e8;
var $25de2b0add077430$export$1aabd8a0274ecfd6;
var $25de2b0add077430$export$9b621391a187a31a;
var $25de2b0add077430$export$f5bbd400c2f4426f;
"use strict";
var $25de2b0add077430$var$b = "function" === typeof Symbol && Symbol.for, $25de2b0add077430$var$c = $25de2b0add077430$var$b ? Symbol.for("react.element") : 60103, $25de2b0add077430$var$d = $25de2b0add077430$var$b ? Symbol.for("react.portal") : 60106, $25de2b0add077430$var$e = $25de2b0add077430$var$b ? Symbol.for("react.fragment") : 60107, $25de2b0add077430$var$f = $25de2b0add077430$var$b ? Symbol.for("react.strict_mode") : 60108, $25de2b0add077430$var$g = $25de2b0add077430$var$b ? Symbol.for("react.profiler") : 60114, $25de2b0add077430$var$h = $25de2b0add077430$var$b ? Symbol.for("react.provider") : 60109, $25de2b0add077430$var$k = $25de2b0add077430$var$b ? Symbol.for("react.context") : 60110, $25de2b0add077430$var$l = $25de2b0add077430$var$b ? Symbol.for("react.async_mode") : 60111, $25de2b0add077430$var$m = $25de2b0add077430$var$b ? Symbol.for("react.concurrent_mode") : 60111, $25de2b0add077430$var$n = $25de2b0add077430$var$b ? Symbol.for("react.forward_ref") : 60112, $25de2b0add077430$var$p = $25de2b0add077430$var$b ? Symbol.for("react.suspense") : 60113, $25de2b0add077430$var$q = $25de2b0add077430$var$b ? Symbol.for("react.suspense_list") : 60120, $25de2b0add077430$var$r = $25de2b0add077430$var$b ? Symbol.for("react.memo") : 60115, $25de2b0add077430$var$t = $25de2b0add077430$var$b ? Symbol.for("react.lazy") : 60116, $25de2b0add077430$var$v = $25de2b0add077430$var$b ? Symbol.for("react.block") : 60121, $25de2b0add077430$var$w = $25de2b0add077430$var$b ? Symbol.for("react.fundamental") : 60117, $25de2b0add077430$var$x = $25de2b0add077430$var$b ? Symbol.for("react.responder") : 60118, $25de2b0add077430$var$y = $25de2b0add077430$var$b ? Symbol.for("react.scope") : 60119;
function $25de2b0add077430$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $25de2b0add077430$var$c:
                switch(a = a.type, a){
                    case $25de2b0add077430$var$l:
                    case $25de2b0add077430$var$m:
                    case $25de2b0add077430$var$e:
                    case $25de2b0add077430$var$g:
                    case $25de2b0add077430$var$f:
                    case $25de2b0add077430$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $25de2b0add077430$var$k:
                            case $25de2b0add077430$var$n:
                            case $25de2b0add077430$var$t:
                            case $25de2b0add077430$var$r:
                            case $25de2b0add077430$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $25de2b0add077430$var$d:
                return u;
        }
    }
}
function $25de2b0add077430$var$A(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$m;
}
$25de2b0add077430$export$2b8d127b894957b9 = $25de2b0add077430$var$l;
$25de2b0add077430$export$cea3a54a6425200c = $25de2b0add077430$var$m;
$25de2b0add077430$export$a7c73072b1a182ae = $25de2b0add077430$var$k;
$25de2b0add077430$export$9f27bc3417b4524d = $25de2b0add077430$var$h;
$25de2b0add077430$export$db77ccec0bb4ccac = $25de2b0add077430$var$c;
$25de2b0add077430$export$8392c0c9d3dcbd35 = $25de2b0add077430$var$n;
$25de2b0add077430$export$ffb0004e005737fa = $25de2b0add077430$var$e;
$25de2b0add077430$export$b624eff549462981 = $25de2b0add077430$var$t;
$25de2b0add077430$export$7897aa7841a5380c = $25de2b0add077430$var$r;
$25de2b0add077430$export$602eac185826482c = $25de2b0add077430$var$d;
$25de2b0add077430$export$e2c29f18771995cb = $25de2b0add077430$var$g;
$25de2b0add077430$export$5f8d39834fd61797 = $25de2b0add077430$var$f;
$25de2b0add077430$export$74bf444e3cd11ea5 = $25de2b0add077430$var$p;
$25de2b0add077430$export$92387174baf9b227 = function(a) {
    return $25de2b0add077430$var$A(a) || $25de2b0add077430$var$z(a) === $25de2b0add077430$var$l;
};
$25de2b0add077430$export$ec112efeb987d9c6 = $25de2b0add077430$var$A;
$25de2b0add077430$export$b706b080d889d2c9 = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$k;
};
$25de2b0add077430$export$5be5a87408f70ddc = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$h;
};
$25de2b0add077430$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $25de2b0add077430$var$c;
};
$25de2b0add077430$export$455c2e768291efa6 = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$n;
};
$25de2b0add077430$export$9522e17588c12572 = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$e;
};
$25de2b0add077430$export$2110ac352bb060b9 = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$t;
};
$25de2b0add077430$export$56885ab8b9c456ab = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$r;
};
$25de2b0add077430$export$d927fcb6adf8f9de = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$d;
};
$25de2b0add077430$export$b82d16f27459e05a = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$g;
};
$25de2b0add077430$export$522c17b4f5e123e8 = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$f;
};
$25de2b0add077430$export$1aabd8a0274ecfd6 = function(a) {
    return $25de2b0add077430$var$z(a) === $25de2b0add077430$var$p;
};
$25de2b0add077430$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $25de2b0add077430$var$e || a === $25de2b0add077430$var$m || a === $25de2b0add077430$var$g || a === $25de2b0add077430$var$f || a === $25de2b0add077430$var$p || a === $25de2b0add077430$var$q || "object" === typeof a && null !== a && (a.$$typeof === $25de2b0add077430$var$t || a.$$typeof === $25de2b0add077430$var$r || a.$$typeof === $25de2b0add077430$var$h || a.$$typeof === $25de2b0add077430$var$k || a.$$typeof === $25de2b0add077430$var$n || a.$$typeof === $25de2b0add077430$var$w || a.$$typeof === $25de2b0add077430$var$x || a.$$typeof === $25de2b0add077430$var$y || a.$$typeof === $25de2b0add077430$var$v);
};
$25de2b0add077430$export$f5bbd400c2f4426f = $25de2b0add077430$var$z;

});




parcelRegister("b8nth", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $81b2a5f59fdb5f86$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $81b2a5f59fdb5f86$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $81b2a5f59fdb5f86$export$6f077d94b33a01aa; });
var $81b2a5f59fdb5f86$var$isBrowser = typeof document !== "undefined";
function $81b2a5f59fdb5f86$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $81b2a5f59fdb5f86$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $81b2a5f59fdb5f86$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $81b2a5f59fdb5f86$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $81b2a5f59fdb5f86$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$81b2a5f59fdb5f86$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$81b2a5f59fdb5f86$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("7e46i", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $542d057f5c327bb5$export$6321afa313b251b5; });

var $eFje6 = parcelRequire("eFje6");

var $kFbzx = parcelRequire("kFbzx");

var $cJ8UG = parcelRequire("cJ8UG");
var $542d057f5c327bb5$var$isDevelopment = false;
var $542d057f5c327bb5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $542d057f5c327bb5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $542d057f5c327bb5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $542d057f5c327bb5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $542d057f5c327bb5$var$processStyleName = /* #__PURE__ */ (0, $cJ8UG.default)(function(styleName) {
    return $542d057f5c327bb5$var$isCustomProperty(styleName) ? styleName : styleName.replace($542d057f5c327bb5$var$hyphenateRegex, "-$&").toLowerCase();
});
var $542d057f5c327bb5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($542d057f5c327bb5$var$animationRegex, function(match, p1, p2) {
                $542d057f5c327bb5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $542d057f5c327bb5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $kFbzx.default)[key] !== 1 && !$542d057f5c327bb5$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $542d057f5c327bb5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $542d057f5c327bb5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $542d057f5c327bb5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $542d057f5c327bb5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $542d057f5c327bb5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $542d057f5c327bb5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $542d057f5c327bb5$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $542d057f5c327bb5$var$cursor;
                var result = interpolation(mergedProps);
                $542d057f5c327bb5$var$cursor = previousCursor;
                return $542d057f5c327bb5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $542d057f5c327bb5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $542d057f5c327bb5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($542d057f5c327bb5$var$isProcessableValue(asString)) string += $542d057f5c327bb5$var$processStyleName(key) + ":" + $542d057f5c327bb5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $542d057f5c327bb5$var$isDevelopment) throw new Error($542d057f5c327bb5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($542d057f5c327bb5$var$isProcessableValue(value[_i])) string += $542d057f5c327bb5$var$processStyleName(key) + ":" + $542d057f5c327bb5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $542d057f5c327bb5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $542d057f5c327bb5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $542d057f5c327bb5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $542d057f5c327bb5$var$cursor;
function $542d057f5c327bb5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $542d057f5c327bb5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $542d057f5c327bb5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $542d057f5c327bb5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $542d057f5c327bb5$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $542d057f5c327bb5$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $eFje6.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $542d057f5c327bb5$var$cursor
    };
}

});
parcelRegister("eFje6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aad3cefd4d1bfb2a$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $aad3cefd4d1bfb2a$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("kFbzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0b09cfd4bd61ec2$export$2e2bcd8739ae039; });
var $f0b09cfd4bd61ec2$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("cJ8UG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94409a004f223e59$export$2e2bcd8739ae039; });
function $94409a004f223e59$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("eMF9c", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $ac357766209e6c70$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $ac357766209e6c70$export$811a713a7276cb9d; });

var $dgG1Y = parcelRequire("dgG1Y");
var $ac357766209e6c70$var$isBrowser = typeof document !== "undefined";
var $ac357766209e6c70$var$syncFallback = function syncFallback(create) {
    return create();
};
var $ac357766209e6c70$var$useInsertionEffect = $dgG1Y.useInsertionEffect ? $dgG1Y.useInsertionEffect : false;
var $ac357766209e6c70$export$db21c7ffa21794e7 = !$ac357766209e6c70$var$isBrowser ? $ac357766209e6c70$var$syncFallback : $ac357766209e6c70$var$useInsertionEffect || $ac357766209e6c70$var$syncFallback;
var $ac357766209e6c70$export$811a713a7276cb9d = $ac357766209e6c70$var$useInsertionEffect || $dgG1Y.useLayoutEffect;

});


parcelRegister("46AbS", function(module, exports) {
function $2fd3cba448854f32$var$_extends() {
    return module.exports = $2fd3cba448854f32$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2fd3cba448854f32$var$_extends.apply(null, arguments);
}
module.exports = $2fd3cba448854f32$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gK9Ik", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $c3087a314cfc24d3$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $c3087a314cfc24d3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $fR5Jw = parcelRequire("fR5Jw");
const $c3087a314cfc24d3$var$RtlContext = /*#__PURE__*/ $dgG1Y.createContext();
function $c3087a314cfc24d3$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($c3087a314cfc24d3$var$RtlContext.Provider, {
        value: value !== null && value !== void 0 ? value : true,
        ...props
    });
}
const $c3087a314cfc24d3$export$b2dd014b6c321cb = ()=>{
    const value = $dgG1Y.useContext($c3087a314cfc24d3$var$RtlContext);
    return value !== null && value !== void 0 ? value : false;
};
var $c3087a314cfc24d3$export$2e2bcd8739ae039 = $c3087a314cfc24d3$var$RtlProvider;

});

parcelRegister("79EgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53589c4d9e1a44c8$export$2e2bcd8739ae039; });
var $53589c4d9e1a44c8$export$2e2bcd8739ae039 = "$$material";

});

parcelRegister("ilnWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5acc31282ba5874$export$2e2bcd8739ae039; });

var $iPooL = parcelRequire("iPooL");
function $d5acc31282ba5874$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $iPooL.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("iPooL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db4fea686dd3a7e9$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $db4fea686dd3a7e9$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append("args[]", arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("9vjtd", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $6eb61cb259166176$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $6eb61cb259166176$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $6eb61cb259166176$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $6eb61cb259166176$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $6eb61cb259166176$export$980e6a259d807490; });


var $ig9jY = parcelRequire("ig9jY");

var $70aAV = parcelRequire("70aAV");

var $79FHu = parcelRequire("79FHu");
const $6eb61cb259166176$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $6eb61cb259166176$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$6eb61cb259166176$export$68c286be0e7e55b7[key]}px)`
};
const $6eb61cb259166176$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === "number" ? key : $6eb61cb259166176$export$68c286be0e7e55b7[key] || key;
                if (typeof result === "number") result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $6eb61cb259166176$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $6eb61cb259166176$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $6eb61cb259166176$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $79FHu.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $79FHu.getContainerQuery)(theme.containerQueries ? theme : $6eb61cb259166176$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $6eb61cb259166176$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $6eb61cb259166176$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $6eb61cb259166176$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $70aAV.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $6eb61cb259166176$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput_keys;
    const breakpointsInOrder = (_breakpointsInput_keys = breakpointsInput.keys) === null || _breakpointsInput_keys === void 0 ? void 0 : _breakpointsInput_keys.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $6eb61cb259166176$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $6eb61cb259166176$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $6eb61cb259166176$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $ig9jY.default)(prev, next), {});
    return $6eb61cb259166176$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $6eb61cb259166176$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $6eb61cb259166176$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $6eb61cb259166176$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $6eb61cb259166176$export$2e2bcd8739ae039 = $6eb61cb259166176$var$breakpoints;

});
parcelRegister("ig9jY", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $d4b0f39dbdc35a5b$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $d4b0f39dbdc35a5b$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
function $d4b0f39dbdc35a5b$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $d4b0f39dbdc35a5b$var$deepClone(source) {
    if (/*#__PURE__*/ $dgG1Y.isValidElement(source) || !$d4b0f39dbdc35a5b$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $d4b0f39dbdc35a5b$var$deepClone(source[key]);
    });
    return output;
}
function $d4b0f39dbdc35a5b$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($d4b0f39dbdc35a5b$export$53b83ca8eaab0383(target) && $d4b0f39dbdc35a5b$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $dgG1Y.isValidElement(source[key])) output[key] = source[key];
        else if ($d4b0f39dbdc35a5b$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $d4b0f39dbdc35a5b$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $d4b0f39dbdc35a5b$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $d4b0f39dbdc35a5b$export$53b83ca8eaab0383(source[key]) ? $d4b0f39dbdc35a5b$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("70aAV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5190c05cbcbb1e24$export$2e2bcd8739ae039; });

var $ig9jY = parcelRequire("ig9jY");
function $5190c05cbcbb1e24$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $ig9jY.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $5190c05cbcbb1e24$export$2e2bcd8739ae039 = $5190c05cbcbb1e24$var$merge;

});

parcelRegister("79FHu", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $5359b88615e4ebf3$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $5359b88615e4ebf3$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $5359b88615e4ebf3$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $5359b88615e4ebf3$export$2e2bcd8739ae039; });

function $5359b88615e4ebf3$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith("@container")).sort((a, b)=>{
        var _a_match, _b_match;
        const regex = /min-width:\s*([0-9.]+)/;
        return +(((_a_match = a.match(regex)) === null || _a_match === void 0 ? void 0 : _a_match[1]) || 0) - +(((_b_match = b.match(regex)) === null || _b_match === void 0 ? void 0 : _b_match[1]) || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $5359b88615e4ebf3$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === "@" || value.startsWith("@") && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $5359b88615e4ebf3$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $5359b88615e4ebf3$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes("not all and")) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("kqewD", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $ede180cdf5b0e151$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $ede180cdf5b0e151$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $ede180cdf5b0e151$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $ede180cdf5b0e151$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $ede180cdf5b0e151$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $ede180cdf5b0e151$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $ede180cdf5b0e151$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $ede180cdf5b0e151$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $ede180cdf5b0e151$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $ede180cdf5b0e151$export$11bb74ba10c85505; });

var $iPooL = parcelRequire("iPooL");

var $66Cp8 = parcelRequire("66Cp8");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ede180cdf5b0e151$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $66Cp8.default)(value, min, max);
}
function $ede180cdf5b0e151$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $ede180cdf5b0e151$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ede180cdf5b0e151$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $ede180cdf5b0e151$export$677b39864803984e($ede180cdf5b0e151$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if (![
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].includes(type)) throw new Error((0, $iPooL.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if (![
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].includes(colorSpace)) throw new Error((0, $iPooL.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ede180cdf5b0e151$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ede180cdf5b0e151$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes("hsl") && idx !== 0 ? `${val}%` : val).join(" ");
};
const $ede180cdf5b0e151$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $ede180cdf5b0e151$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $ede180cdf5b0e151$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes("rgb")) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes("hsl")) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes("color")) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $ede180cdf5b0e151$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith("#")) return color;
    const { values: values } = $ede180cdf5b0e151$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ede180cdf5b0e151$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $ede180cdf5b0e151$export$29fb7152bd3f781a(color) {
    color = $ede180cdf5b0e151$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $ede180cdf5b0e151$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ede180cdf5b0e151$export$c852d90bf7403b62(color) {
    color = $ede180cdf5b0e151$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $ede180cdf5b0e151$export$677b39864803984e($ede180cdf5b0e151$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ede180cdf5b0e151$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ede180cdf5b0e151$export$c852d90bf7403b62(foreground);
    const lumB = $ede180cdf5b0e151$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ede180cdf5b0e151$export$58f0f39f63f3cf42(color, value) {
    color = $ede180cdf5b0e151$export$677b39864803984e(color);
    value = $ede180cdf5b0e151$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ede180cdf5b0e151$export$211a73f2b8c10ce4(color);
}
function $ede180cdf5b0e151$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $ede180cdf5b0e151$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $ede180cdf5b0e151$export$4b073707ff63303(color, coefficient) {
    color = $ede180cdf5b0e151$export$677b39864803984e(color);
    coefficient = $ede180cdf5b0e151$var$clampWrapper(coefficient);
    if (color.type.includes("hsl")) color.values[2] *= 1 - coefficient;
    else if (color.type.includes("rgb") || color.type.includes("color")) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ede180cdf5b0e151$export$211a73f2b8c10ce4(color);
}
function $ede180cdf5b0e151$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $ede180cdf5b0e151$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ede180cdf5b0e151$export$c0816ed86df316af(color, coefficient) {
    color = $ede180cdf5b0e151$export$677b39864803984e(color);
    coefficient = $ede180cdf5b0e151$var$clampWrapper(coefficient);
    if (color.type.includes("hsl")) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes("rgb")) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes("color")) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ede180cdf5b0e151$export$211a73f2b8c10ce4(color);
}
function $ede180cdf5b0e151$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $ede180cdf5b0e151$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ede180cdf5b0e151$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ede180cdf5b0e151$export$c852d90bf7403b62(color) > 0.5 ? $ede180cdf5b0e151$export$4b073707ff63303(color, coefficient) : $ede180cdf5b0e151$export$c0816ed86df316af(color, coefficient);
}
function $ede180cdf5b0e151$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $ede180cdf5b0e151$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ede180cdf5b0e151$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $ede180cdf5b0e151$export$677b39864803984e(background);
    const overlayColor = $ede180cdf5b0e151$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $ede180cdf5b0e151$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("66Cp8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $472117eb736b8a42$export$2e2bcd8739ae039; });
function $472117eb736b8a42$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $472117eb736b8a42$export$2e2bcd8739ae039 = $472117eb736b8a42$var$clamp;

});


parcelRegister("1v4KJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $117c5f7951b75fec$export$2e2bcd8739ae039; });

var $ig9jY = parcelRequire("ig9jY");

var $82nQs = parcelRequire("82nQs");

var $79FHu = parcelRequire("79FHu");

var $a2G8v = parcelRequire("a2G8v");

var $d3Twb = parcelRequire("d3Twb");

var $2RnpB = parcelRequire("2RnpB");

var $7U7Z7 = parcelRequire("7U7Z7");

var $9SZy8 = parcelRequire("9SZy8");
function $117c5f7951b75fec$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $82nQs.default)(breakpointsInput);
    const spacing = (0, $d3Twb.default)(spacingInput);
    let muiTheme = (0, $ig9jY.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: {
            mode: "light",
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $a2G8v.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $79FHu.default)(muiTheme);
    muiTheme.applyStyles = (0, $9SZy8.default);
    muiTheme = args.reduce((acc, argument)=>(0, $ig9jY.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $7U7Z7.default),
        ...other === null || other === void 0 ? void 0 : other.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $2RnpB.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $117c5f7951b75fec$export$2e2bcd8739ae039 = $117c5f7951b75fec$var$createTheme;

});
parcelRegister("82nQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da101cb61fc807e$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $5da101cb61fc807e$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $5da101cb61fc807e$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $5da101cb61fc807e$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5, ...other } = breakpoints;
    const sortedValues = $5da101cb61fc807e$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("a2G8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74fac6ab72014579$export$2e2bcd8739ae039; });
const $74fac6ab72014579$var$shape = {
    borderRadius: 4
};
var $74fac6ab72014579$export$2e2bcd8739ae039 = $74fac6ab72014579$var$shape;

});

parcelRegister("d3Twb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98269eeaeb03eb0e$export$2e2bcd8739ae039; });

var $99wkl = parcelRequire("99wkl");
function $98269eeaeb03eb0e$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $99wkl.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("99wkl", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $6a9e07cfe71ee18f$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $6a9e07cfe71ee18f$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $6a9e07cfe71ee18f$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $6a9e07cfe71ee18f$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $6a9e07cfe71ee18f$export$6f98e8eaf0be1996; });


var $9vjtd = parcelRequire("9vjtd");

var $fY2z8 = parcelRequire("fY2z8");

var $70aAV = parcelRequire("70aAV");

var $7vsy3 = parcelRequire("7vsy3");
const $6a9e07cfe71ee18f$var$properties = {
    m: "margin",
    p: "padding"
};
const $6a9e07cfe71ee18f$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $6a9e07cfe71ee18f$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $6a9e07cfe71ee18f$var$getCssProperties = (0, $7vsy3.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($6a9e07cfe71ee18f$var$aliases[prop]) prop = $6a9e07cfe71ee18f$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $6a9e07cfe71ee18f$var$properties[a];
    const direction = $6a9e07cfe71ee18f$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $6a9e07cfe71ee18f$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $6a9e07cfe71ee18f$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $6a9e07cfe71ee18f$var$spacingKeys = [
    ...$6a9e07cfe71ee18f$export$aab52a0dde05ad8a,
    ...$6a9e07cfe71ee18f$export$f8397d44f03ab6ad
];
function $6a9e07cfe71ee18f$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $fY2z8.getPath)(theme, themeKey, true)) !== null && _getPath !== void 0 ? _getPath : defaultValue;
    if (typeof themeSpacing === "number" || typeof themeSpacing === "string") return (val)=>{
        if (typeof val === "string") return val;
        if (typeof themeSpacing === "string") return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === "string") return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === "number") return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $6a9e07cfe71ee18f$export$1def6f833384e3d1(theme) {
    return $6a9e07cfe71ee18f$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $6a9e07cfe71ee18f$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    return transformer(propValue);
}
function $6a9e07cfe71ee18f$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $6a9e07cfe71ee18f$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $6a9e07cfe71ee18f$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $6a9e07cfe71ee18f$var$getCssProperties(prop);
    const styleFromPropValue = $6a9e07cfe71ee18f$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $9vjtd.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $6a9e07cfe71ee18f$var$style(props, keys) {
    const transformer = $6a9e07cfe71ee18f$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$6a9e07cfe71ee18f$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $70aAV.default), {});
}
function $6a9e07cfe71ee18f$export$7ede87f9b603dd3c(props) {
    return $6a9e07cfe71ee18f$var$style(props, $6a9e07cfe71ee18f$export$aab52a0dde05ad8a);
}
$6a9e07cfe71ee18f$export$7ede87f9b603dd3c.propTypes = {};
$6a9e07cfe71ee18f$export$7ede87f9b603dd3c.filterProps = $6a9e07cfe71ee18f$export$aab52a0dde05ad8a;
function $6a9e07cfe71ee18f$export$6f98e8eaf0be1996(props) {
    return $6a9e07cfe71ee18f$var$style(props, $6a9e07cfe71ee18f$export$f8397d44f03ab6ad);
}
$6a9e07cfe71ee18f$export$6f98e8eaf0be1996.propTypes = {};
$6a9e07cfe71ee18f$export$6f98e8eaf0be1996.filterProps = $6a9e07cfe71ee18f$export$f8397d44f03ab6ad;
function $6a9e07cfe71ee18f$var$spacing(props) {
    return $6a9e07cfe71ee18f$var$style(props, $6a9e07cfe71ee18f$var$spacingKeys);
}
$6a9e07cfe71ee18f$var$spacing.propTypes = {};
$6a9e07cfe71ee18f$var$spacing.filterProps = $6a9e07cfe71ee18f$var$spacingKeys;
var $6a9e07cfe71ee18f$export$2e2bcd8739ae039 = $6a9e07cfe71ee18f$var$spacing;

});
parcelRegister("fY2z8", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $b9fe731ae08926a2$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $b9fe731ae08926a2$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $b9fe731ae08926a2$export$2e2bcd8739ae039; });

var $ilnWD = parcelRequire("ilnWD");


var $9vjtd = parcelRequire("9vjtd");
function $b9fe731ae08926a2$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $b9fe731ae08926a2$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $b9fe731ae08926a2$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $b9fe731ae08926a2$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $b9fe731ae08926a2$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $b9fe731ae08926a2$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $b9fe731ae08926a2$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $ilnWD.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9vjtd.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $b9fe731ae08926a2$export$2e2bcd8739ae039 = $b9fe731ae08926a2$var$style;

});

parcelRegister("7vsy3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $577192c03ccb222c$export$2e2bcd8739ae039; });
function $577192c03ccb222c$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("2RnpB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2152b11d6dba88d0$export$2e2bcd8739ae039; });

var $ilnWD = parcelRequire("ilnWD");

var $70aAV = parcelRequire("70aAV");

var $fY2z8 = parcelRequire("fY2z8");

var $9vjtd = parcelRequire("9vjtd");

var $79FHu = parcelRequire("79FHu");

var $7U7Z7 = parcelRequire("7U7Z7");
function $2152b11d6dba88d0$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $2152b11d6dba88d0$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $2152b11d6dba88d0$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $fY2z8.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $fY2z8.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $fY2z8.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $ilnWD.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9vjtd.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        var _theme_unstable_sxConfig;
        const config = (_theme_unstable_sxConfig = theme.unstable_sxConfig) !== null && _theme_unstable_sxConfig !== void 0 ? _theme_unstable_sxConfig : (0, $7U7Z7.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $9vjtd.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $2152b11d6dba88d0$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $70aAV.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $9vjtd.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($2152b11d6dba88d0$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $70aAV.default)(css, breakpointsValues);
                        }
                    } else css = (0, $70aAV.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $79FHu.sortContainerQueries)(theme, (0, $9vjtd.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $2152b11d6dba88d0$var$styleFunctionSx = $2152b11d6dba88d0$export$7d53d8bf2911e013();
$2152b11d6dba88d0$var$styleFunctionSx.filterProps = [
    "sx"
];
var $2152b11d6dba88d0$export$2e2bcd8739ae039 = $2152b11d6dba88d0$var$styleFunctionSx;

});
parcelRegister("7U7Z7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c13f4ffa91f412f$export$2e2bcd8739ae039; });

var $99wkl = parcelRequire("99wkl");

var $35EJm = parcelRequire("35EJm");

var $go49r = parcelRequire("go49r");

var $48y3r = parcelRequire("48y3r");

var $lDU3g = parcelRequire("lDU3g");
const $5c13f4ffa91f412f$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $35EJm.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $35EJm.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $35EJm.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $35EJm.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $35EJm.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $35EJm.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $35EJm.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $48y3r.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $48y3r.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $48y3r.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $99wkl.padding)
    },
    pt: {
        style: (0, $99wkl.padding)
    },
    pr: {
        style: (0, $99wkl.padding)
    },
    pb: {
        style: (0, $99wkl.padding)
    },
    pl: {
        style: (0, $99wkl.padding)
    },
    px: {
        style: (0, $99wkl.padding)
    },
    py: {
        style: (0, $99wkl.padding)
    },
    padding: {
        style: (0, $99wkl.padding)
    },
    paddingTop: {
        style: (0, $99wkl.padding)
    },
    paddingRight: {
        style: (0, $99wkl.padding)
    },
    paddingBottom: {
        style: (0, $99wkl.padding)
    },
    paddingLeft: {
        style: (0, $99wkl.padding)
    },
    paddingX: {
        style: (0, $99wkl.padding)
    },
    paddingY: {
        style: (0, $99wkl.padding)
    },
    paddingInline: {
        style: (0, $99wkl.padding)
    },
    paddingInlineStart: {
        style: (0, $99wkl.padding)
    },
    paddingInlineEnd: {
        style: (0, $99wkl.padding)
    },
    paddingBlock: {
        style: (0, $99wkl.padding)
    },
    paddingBlockStart: {
        style: (0, $99wkl.padding)
    },
    paddingBlockEnd: {
        style: (0, $99wkl.padding)
    },
    m: {
        style: (0, $99wkl.margin)
    },
    mt: {
        style: (0, $99wkl.margin)
    },
    mr: {
        style: (0, $99wkl.margin)
    },
    mb: {
        style: (0, $99wkl.margin)
    },
    ml: {
        style: (0, $99wkl.margin)
    },
    mx: {
        style: (0, $99wkl.margin)
    },
    my: {
        style: (0, $99wkl.margin)
    },
    margin: {
        style: (0, $99wkl.margin)
    },
    marginTop: {
        style: (0, $99wkl.margin)
    },
    marginRight: {
        style: (0, $99wkl.margin)
    },
    marginBottom: {
        style: (0, $99wkl.margin)
    },
    marginLeft: {
        style: (0, $99wkl.margin)
    },
    marginX: {
        style: (0, $99wkl.margin)
    },
    marginY: {
        style: (0, $99wkl.margin)
    },
    marginInline: {
        style: (0, $99wkl.margin)
    },
    marginInlineStart: {
        style: (0, $99wkl.margin)
    },
    marginInlineEnd: {
        style: (0, $99wkl.margin)
    },
    marginBlock: {
        style: (0, $99wkl.margin)
    },
    marginBlockStart: {
        style: (0, $99wkl.margin)
    },
    marginBlockEnd: {
        style: (0, $99wkl.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $go49r.gap)
    },
    rowGap: {
        style: (0, $go49r.rowGap)
    },
    columnGap: {
        style: (0, $go49r.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $lDU3g.sizingTransform)
    },
    maxWidth: {
        style: (0, $lDU3g.maxWidth)
    },
    minWidth: {
        transform: (0, $lDU3g.sizingTransform)
    },
    height: {
        transform: (0, $lDU3g.sizingTransform)
    },
    maxHeight: {
        transform: (0, $lDU3g.sizingTransform)
    },
    minHeight: {
        transform: (0, $lDU3g.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: "font"
    },
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $5c13f4ffa91f412f$export$2e2bcd8739ae039 = $5c13f4ffa91f412f$var$defaultSxConfig;

});
parcelRegister("35EJm", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $24016ef518328241$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $24016ef518328241$export$7a57f79000377ca2; });


var $fY2z8 = parcelRequire("fY2z8");

var $jdJNd = parcelRequire("jdJNd");

var $99wkl = parcelRequire("99wkl");

var $9vjtd = parcelRequire("9vjtd");
function $24016ef518328241$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $24016ef518328241$var$createBorderStyle(prop, transform) {
    return (0, $fY2z8.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $24016ef518328241$export$1edee58a52776cd9 = $24016ef518328241$var$createBorderStyle("border", $24016ef518328241$export$34e2febe53ae29cc);
const $24016ef518328241$export$f9a7b6bd24892946 = $24016ef518328241$var$createBorderStyle("borderTop", $24016ef518328241$export$34e2febe53ae29cc);
const $24016ef518328241$export$5abca33e6be905d2 = $24016ef518328241$var$createBorderStyle("borderRight", $24016ef518328241$export$34e2febe53ae29cc);
const $24016ef518328241$export$e2ce9f12a980a822 = $24016ef518328241$var$createBorderStyle("borderBottom", $24016ef518328241$export$34e2febe53ae29cc);
const $24016ef518328241$export$47658cca1a909427 = $24016ef518328241$var$createBorderStyle("borderLeft", $24016ef518328241$export$34e2febe53ae29cc);
const $24016ef518328241$export$e7fb0694ba2404fc = $24016ef518328241$var$createBorderStyle("borderColor");
const $24016ef518328241$export$126a92c968acdb85 = $24016ef518328241$var$createBorderStyle("borderTopColor");
const $24016ef518328241$export$85cc51cb8fbb8c0e = $24016ef518328241$var$createBorderStyle("borderRightColor");
const $24016ef518328241$export$340b0327727f6d1a = $24016ef518328241$var$createBorderStyle("borderBottomColor");
const $24016ef518328241$export$60beef91a985b4bf = $24016ef518328241$var$createBorderStyle("borderLeftColor");
const $24016ef518328241$export$f9258c55612cbed7 = $24016ef518328241$var$createBorderStyle("outline", $24016ef518328241$export$34e2febe53ae29cc);
const $24016ef518328241$export$621fe586efeb64b9 = $24016ef518328241$var$createBorderStyle("outlineColor");
const $24016ef518328241$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $99wkl.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $99wkl.getValue)(transformer, propValue)
            });
        return (0, $9vjtd.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$24016ef518328241$export$7a57f79000377ca2.propTypes = {};
$24016ef518328241$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $24016ef518328241$var$borders = (0, $jdJNd.default)($24016ef518328241$export$1edee58a52776cd9, $24016ef518328241$export$f9a7b6bd24892946, $24016ef518328241$export$5abca33e6be905d2, $24016ef518328241$export$e2ce9f12a980a822, $24016ef518328241$export$47658cca1a909427, $24016ef518328241$export$e7fb0694ba2404fc, $24016ef518328241$export$126a92c968acdb85, $24016ef518328241$export$85cc51cb8fbb8c0e, $24016ef518328241$export$340b0327727f6d1a, $24016ef518328241$export$60beef91a985b4bf, $24016ef518328241$export$7a57f79000377ca2, $24016ef518328241$export$f9258c55612cbed7, $24016ef518328241$export$621fe586efeb64b9);
var $24016ef518328241$export$2e2bcd8739ae039 = $24016ef518328241$var$borders;

});
parcelRegister("jdJNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfe2c0b6722fe2b5$export$2e2bcd8739ae039; });

var $70aAV = parcelRequire("70aAV");
function $dfe2c0b6722fe2b5$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $70aAV.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $dfe2c0b6722fe2b5$export$2e2bcd8739ae039 = $dfe2c0b6722fe2b5$var$compose;

});


parcelRegister("go49r", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $bee21b9beb11a1fe$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $bee21b9beb11a1fe$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $bee21b9beb11a1fe$export$8a833ffa5f5dbeda; });

var $fY2z8 = parcelRequire("fY2z8");

var $jdJNd = parcelRequire("jdJNd");

var $99wkl = parcelRequire("99wkl");

var $9vjtd = parcelRequire("9vjtd");

const $bee21b9beb11a1fe$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $99wkl.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $99wkl.getValue)(transformer, propValue)
            });
        return (0, $9vjtd.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$bee21b9beb11a1fe$export$5df9adcb0db95e1e.propTypes = {};
$bee21b9beb11a1fe$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $bee21b9beb11a1fe$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $99wkl.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $99wkl.getValue)(transformer, propValue)
            });
        return (0, $9vjtd.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$bee21b9beb11a1fe$export$ec60d70ff941a580.propTypes = {};
$bee21b9beb11a1fe$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $bee21b9beb11a1fe$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $99wkl.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $99wkl.getValue)(transformer, propValue)
            });
        return (0, $9vjtd.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$bee21b9beb11a1fe$export$8a833ffa5f5dbeda.propTypes = {};
$bee21b9beb11a1fe$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $bee21b9beb11a1fe$export$baf44164ca3a34e8 = (0, $fY2z8.default)({
    prop: "gridColumn"
});
const $bee21b9beb11a1fe$export$8f7213a1cd01e832 = (0, $fY2z8.default)({
    prop: "gridRow"
});
const $bee21b9beb11a1fe$export$b0e0abbc49ba668 = (0, $fY2z8.default)({
    prop: "gridAutoFlow"
});
const $bee21b9beb11a1fe$export$bcd8b929d4b4142 = (0, $fY2z8.default)({
    prop: "gridAutoColumns"
});
const $bee21b9beb11a1fe$export$e5039a674e14c828 = (0, $fY2z8.default)({
    prop: "gridAutoRows"
});
const $bee21b9beb11a1fe$export$42bd9088661ffb03 = (0, $fY2z8.default)({
    prop: "gridTemplateColumns"
});
const $bee21b9beb11a1fe$export$920682ae05b999bc = (0, $fY2z8.default)({
    prop: "gridTemplateRows"
});
const $bee21b9beb11a1fe$export$1b88fbdd482fd33a = (0, $fY2z8.default)({
    prop: "gridTemplateAreas"
});
const $bee21b9beb11a1fe$export$bdb486e40d52d26f = (0, $fY2z8.default)({
    prop: "gridArea"
});
const $bee21b9beb11a1fe$var$grid = (0, $jdJNd.default)($bee21b9beb11a1fe$export$5df9adcb0db95e1e, $bee21b9beb11a1fe$export$ec60d70ff941a580, $bee21b9beb11a1fe$export$8a833ffa5f5dbeda, $bee21b9beb11a1fe$export$baf44164ca3a34e8, $bee21b9beb11a1fe$export$8f7213a1cd01e832, $bee21b9beb11a1fe$export$b0e0abbc49ba668, $bee21b9beb11a1fe$export$bcd8b929d4b4142, $bee21b9beb11a1fe$export$e5039a674e14c828, $bee21b9beb11a1fe$export$42bd9088661ffb03, $bee21b9beb11a1fe$export$920682ae05b999bc, $bee21b9beb11a1fe$export$1b88fbdd482fd33a, $bee21b9beb11a1fe$export$bdb486e40d52d26f);
var $bee21b9beb11a1fe$export$2e2bcd8739ae039 = $bee21b9beb11a1fe$var$grid;

});

parcelRegister("48y3r", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $303253506b97aa46$export$dbaffd4420ea0ac6; });

var $fY2z8 = parcelRequire("fY2z8");

var $jdJNd = parcelRequire("jdJNd");
function $303253506b97aa46$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $303253506b97aa46$export$35e9368ef982300f = (0, $fY2z8.default)({
    prop: "color",
    themeKey: "palette",
    transform: $303253506b97aa46$export$dbaffd4420ea0ac6
});
const $303253506b97aa46$export$2506f56c10355b33 = (0, $fY2z8.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $303253506b97aa46$export$dbaffd4420ea0ac6
});
const $303253506b97aa46$export$8c5a050822fd698c = (0, $fY2z8.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $303253506b97aa46$export$dbaffd4420ea0ac6
});
const $303253506b97aa46$var$palette = (0, $jdJNd.default)($303253506b97aa46$export$35e9368ef982300f, $303253506b97aa46$export$2506f56c10355b33, $303253506b97aa46$export$8c5a050822fd698c);
var $303253506b97aa46$export$2e2bcd8739ae039 = $303253506b97aa46$var$palette;

});

parcelRegister("lDU3g", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $fc18b82e37851a42$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $fc18b82e37851a42$export$488fda99655ff65a; });

var $fY2z8 = parcelRequire("fY2z8");

var $jdJNd = parcelRequire("jdJNd");

var $9vjtd = parcelRequire("9vjtd");
function $fc18b82e37851a42$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $fc18b82e37851a42$export$7e3df82ee760448c = (0, $fY2z8.default)({
    prop: "width",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props_theme_breakpoints_values, _props_theme_breakpoints, _props_theme, _props_theme_breakpoints1, _props_theme1;
            const breakpoint = ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_breakpoints = _props_theme.breakpoints) === null || _props_theme_breakpoints === void 0 ? void 0 : (_props_theme_breakpoints_values = _props_theme_breakpoints.values) === null || _props_theme_breakpoints_values === void 0 ? void 0 : _props_theme_breakpoints_values[propValue]) || (0, $9vjtd.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $fc18b82e37851a42$export$8afece71750ec241(propValue)
            };
            if (((_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : (_props_theme_breakpoints1 = _props_theme1.breakpoints) === null || _props_theme_breakpoints1 === void 0 ? void 0 : _props_theme_breakpoints1.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $9vjtd.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$fc18b82e37851a42$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $fc18b82e37851a42$export$ee148fbbe8357dd2 = (0, $fY2z8.default)({
    prop: "minWidth",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$ac607276a8fe9f0a = (0, $fY2z8.default)({
    prop: "height",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$dc0d8bd0b94f8570 = (0, $fY2z8.default)({
    prop: "maxHeight",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$a43cf604e12f3b17 = (0, $fY2z8.default)({
    prop: "minHeight",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$ffed9f14fb65e276 = (0, $fY2z8.default)({
    prop: "size",
    cssProperty: "width",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$905076ed6620e671 = (0, $fY2z8.default)({
    prop: "size",
    cssProperty: "height",
    transform: $fc18b82e37851a42$export$8afece71750ec241
});
const $fc18b82e37851a42$export$6ccc93f785106a58 = (0, $fY2z8.default)({
    prop: "boxSizing"
});
const $fc18b82e37851a42$var$sizing = (0, $jdJNd.default)($fc18b82e37851a42$export$7e3df82ee760448c, $fc18b82e37851a42$export$488fda99655ff65a, $fc18b82e37851a42$export$ee148fbbe8357dd2, $fc18b82e37851a42$export$ac607276a8fe9f0a, $fc18b82e37851a42$export$dc0d8bd0b94f8570, $fc18b82e37851a42$export$a43cf604e12f3b17, $fc18b82e37851a42$export$6ccc93f785106a58);
var $fc18b82e37851a42$export$2e2bcd8739ae039 = $fc18b82e37851a42$var$sizing;

});



parcelRegister("9SZy8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7328e6aad6904280$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $7328e6aad6904280$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        var _theme_colorSchemes;
        if (!((_theme_colorSchemes = theme.colorSchemes) === null || _theme_colorSchemes === void 0 ? void 0 : _theme_colorSchemes[key]) || typeof theme.getColorSchemeSelector !== "function") return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === "&") return styles;
        if (selector.includes("data-") || selector.includes(".")) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("1IjmQ", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $13f8ec75fe5c11db$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $13f8ec75fe5c11db$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $13f8ec75fe5c11db$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $13f8ec75fe5c11db$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $13f8ec75fe5c11db$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $13f8ec75fe5c11db$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $13f8ec75fe5c11db$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$13f8ec75fe5c11db$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$13f8ec75fe5c11db$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $13f8ec75fe5c11db$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $13f8ec75fe5c11db$var$formatMs(delay)}`).join(",");
    };
    return {
        getAutoHeightDuration: $13f8ec75fe5c11db$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("8DY8l", function(module, exports) {

$parcel$export(module.exports, "legacyTheme", function () { return $4a31ebc68a6e7b8c$export$7132e4bb2707de3c; });
$parcel$export(module.exports, "theme", function () { return $4a31ebc68a6e7b8c$export$bca14c5b3b88a9c9; });

var $6L0PO = parcelRequire("6L0PO");

var $iikr3 = parcelRequire("iikr3");

var $iuDcE = parcelRequire("iuDcE");

var $73wUy = parcelRequire("73wUy");

var $1J3Ci = parcelRequire("1J3Ci");

var $dEHhz = parcelRequire("dEHhz");
const $4a31ebc68a6e7b8c$export$7132e4bb2707de3c = (0, $6L0PO.default)({
    palette: $iuDcE.default,
    typography: $73wUy.default,
    overrides: $dEHhz.default,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});
const $4a31ebc68a6e7b8c$export$bca14c5b3b88a9c9 = (0, $iikr3.default)({
    palette: $iuDcE.default,
    typography: $73wUy.default,
    components: $1J3Ci.default,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});

});
parcelRegister("6L0PO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb7c7a1f6a448e2$export$2e2bcd8739ae039; });
parcelRequire("bey4Q");

var $gZz4Z = parcelRequire("gZz4Z");

var $9gLdn = parcelRequire("9gLdn");

var $hwY02 = parcelRequire("hwY02");

var $flbOF = parcelRequire("flbOF");

var $5249x = parcelRequire("5249x");

var $efZae = parcelRequire("efZae");

var $ju1pB = parcelRequire("ju1pB");

var $5xbKO = parcelRequire("5xbKO");

var $eo1lV = parcelRequire("eo1lV");

var $frSQs = parcelRequire("frSQs");

var $3iAmy = parcelRequire("3iAmy");
function $4eb7c7a1f6a448e2$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $gZz4Z.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $5249x.default)(paletteInput);
    var breakpoints = (0, $hwY02.default)(breakpointsInput);
    var spacing = (0, $eo1lV.default)(spacingInput);
    var muiTheme = (0, $9gLdn.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $flbOF.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $ju1pB.default),
        typography: (0, $efZae.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $5xbKO.default),
        transitions: (0, $frSQs.default),
        zIndex: (0, $3iAmy.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $9gLdn.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $4eb7c7a1f6a448e2$var$warnedOnce = false;
function $4eb7c7a1f6a448e2$export$c469355549431d9b() {
    return $4eb7c7a1f6a448e2$var$createTheme.apply(void 0, arguments);
}
var $4eb7c7a1f6a448e2$export$2e2bcd8739ae039 = $4eb7c7a1f6a448e2$var$createTheme;

});
parcelRegister("bey4Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82db6f8482379ee3$export$2e2bcd8739ae039; });

var $ai0kl = parcelRequire("ai0kl");
function $82db6f8482379ee3$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ai0kl.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("ai0kl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77dbd6c6849b72da$export$2e2bcd8739ae039; });

var $5FKop = parcelRequire("5FKop");

var $1EVaG = parcelRequire("1EVaG");
function $77dbd6c6849b72da$export$2e2bcd8739ae039(t) {
    var i = (0, $1EVaG.default)(t, "string");
    return "symbol" == (0, $5FKop.default)(i) ? i : i + "";
}

});
parcelRegister("5FKop", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4214c4b66f9eccd4$export$2e2bcd8739ae039; });
function $4214c4b66f9eccd4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4214c4b66f9eccd4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4214c4b66f9eccd4$export$2e2bcd8739ae039(o);
}

});

parcelRegister("1EVaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1355dfe82560565d$export$2e2bcd8739ae039; });

var $5FKop = parcelRequire("5FKop");
function $1355dfe82560565d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5FKop.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5FKop.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gZz4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5ed8de07d78a313$export$2e2bcd8739ae039; });

var $gppKd = parcelRequire("gppKd");
function $c5ed8de07d78a313$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $gppKd.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("gppKd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf22f373e9e53c99$export$2e2bcd8739ae039; });
function $bf22f373e9e53c99$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("9gLdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bfa3b8cb7c3ad47$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $5FKop = parcelRequire("5FKop");
function $6bfa3b8cb7c3ad47$export$53b83ca8eaab0383(item) {
    return item && (0, $5FKop.default)(item) === "object" && item.constructor === Object;
}
function $6bfa3b8cb7c3ad47$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $bh1oa.default)({}, target) : target;
    if ($6bfa3b8cb7c3ad47$export$53b83ca8eaab0383(target) && $6bfa3b8cb7c3ad47$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($6bfa3b8cb7c3ad47$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $6bfa3b8cb7c3ad47$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("hwY02", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc33f7804f1274da$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");
var $cc33f7804f1274da$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $cc33f7804f1274da$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $gZz4Z.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $cc33f7804f1274da$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$cc33f7804f1274da$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $cc33f7804f1274da$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $cc33f7804f1274da$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $cc33f7804f1274da$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$cc33f7804f1274da$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$cc33f7804f1274da$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $bh1oa.default)({
        keys: $cc33f7804f1274da$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("flbOF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b1fba7249686c8$export$2e2bcd8739ae039; });

var $bey4Q = parcelRequire("bey4Q");

var $bh1oa = parcelRequire("bh1oa");
function $b2b1fba7249686c8$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $bh1oa.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $bh1oa.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $bey4Q.default)({}, breakpoints.up("sm"), (0, $bh1oa.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $bey4Q.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $bey4Q.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("5249x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aa05c4f3939c331$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $9gLdn = parcelRequire("9gLdn");
var $gNnan = parcelRequire("gNnan");

var $1zUo6 = parcelRequire("1zUo6");

var $lcF3K = parcelRequire("lcF3K");

var $e9QBE = parcelRequire("e9QBE");

var $7Hlqk = parcelRequire("7Hlqk");

var $8UprC = parcelRequire("8UprC");

var $aPk5R = parcelRequire("aPk5R");

var $6I9LF = parcelRequire("6I9LF");

var $4Mdjv = parcelRequire("4Mdjv");

var $4BFH5 = parcelRequire("4BFH5");
var $3aa05c4f3939c331$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $1zUo6.default).white,
        default: (0, $lcF3K.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $3aa05c4f3939c331$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $1zUo6.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $lcF3K.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $1zUo6.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $3aa05c4f3939c331$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $4BFH5.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $4BFH5.darken)(intent.main, tonalOffsetDark);
    }
}
function $3aa05c4f3939c331$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $e9QBE.default)[300],
        main: (0, $e9QBE.default)[500],
        dark: (0, $e9QBE.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $7Hlqk.default).A200,
        main: (0, $7Hlqk.default).A400,
        dark: (0, $7Hlqk.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $8UprC.default)[300],
        main: (0, $8UprC.default)[500],
        dark: (0, $8UprC.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $aPk5R.default)[300],
        main: (0, $aPk5R.default)[500],
        dark: (0, $aPk5R.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $6I9LF.default)[300],
        main: (0, $6I9LF.default)[500],
        dark: (0, $6I9LF.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $4Mdjv.default)[300],
        main: (0, $4Mdjv.default)[500],
        dark: (0, $4Mdjv.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $gZz4Z.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $4BFH5.getContrastRatio)(background, $3aa05c4f3939c331$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $3aa05c4f3939c331$export$55ce6f3a06c59543.text.primary : $3aa05c4f3939c331$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $bh1oa.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $gNnan.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $gNnan.default)(5, JSON.stringify(color.main)));
        $3aa05c4f3939c331$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $3aa05c4f3939c331$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $3aa05c4f3939c331$export$55ce6f3a06c59543,
        light: $3aa05c4f3939c331$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $9gLdn.default)((0, $bh1oa.default)({
        // A collection of common colors.
        common: (0, $1zUo6.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $lcF3K.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("gNnan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3a33149dae00e5d$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $c3a33149dae00e5d$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://mui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("1zUo6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1264ccbd61b564fb$export$2e2bcd8739ae039; });
var $1264ccbd61b564fb$var$common = {
    black: "#000",
    white: "#fff"
};
var $1264ccbd61b564fb$export$2e2bcd8739ae039 = $1264ccbd61b564fb$var$common;

});

parcelRegister("lcF3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6fa91851339ad09$export$2e2bcd8739ae039; });
var $f6fa91851339ad09$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $f6fa91851339ad09$export$2e2bcd8739ae039 = $f6fa91851339ad09$var$grey;

});

parcelRegister("e9QBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4eab67c3df05010$export$2e2bcd8739ae039; });
var $a4eab67c3df05010$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $a4eab67c3df05010$export$2e2bcd8739ae039 = $a4eab67c3df05010$var$indigo;

});

parcelRegister("7Hlqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59ad2ad903dd277d$export$2e2bcd8739ae039; });
var $59ad2ad903dd277d$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $59ad2ad903dd277d$export$2e2bcd8739ae039 = $59ad2ad903dd277d$var$pink;

});

parcelRegister("8UprC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67c74a6aca2bcb32$export$2e2bcd8739ae039; });
var $67c74a6aca2bcb32$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $67c74a6aca2bcb32$export$2e2bcd8739ae039 = $67c74a6aca2bcb32$var$red;

});

parcelRegister("aPk5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e1e40f8daf777c9$export$2e2bcd8739ae039; });
var $7e1e40f8daf777c9$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $7e1e40f8daf777c9$export$2e2bcd8739ae039 = $7e1e40f8daf777c9$var$orange;

});

parcelRegister("6I9LF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e2e6dd596328b3d$export$2e2bcd8739ae039; });
var $4e2e6dd596328b3d$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $4e2e6dd596328b3d$export$2e2bcd8739ae039 = $4e2e6dd596328b3d$var$blue;

});

parcelRegister("4Mdjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37a5f8e8a45fde61$export$2e2bcd8739ae039; });
var $37a5f8e8a45fde61$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $37a5f8e8a45fde61$export$2e2bcd8739ae039 = $37a5f8e8a45fde61$var$green;

});

parcelRegister("4BFH5", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $35aaf5b2f3735873$export$d061e26956a60b0a; });
$parcel$export(module.exports, "emphasize", function () { return $35aaf5b2f3735873$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $35aaf5b2f3735873$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $35aaf5b2f3735873$export$c0816ed86df316af; });
$parcel$export(module.exports, "alpha", function () { return $35aaf5b2f3735873$export$58f0f39f63f3cf42; });

var $gNnan = parcelRequire("gNnan");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $35aaf5b2f3735873$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $35aaf5b2f3735873$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $35aaf5b2f3735873$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $35aaf5b2f3735873$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $35aaf5b2f3735873$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $35aaf5b2f3735873$var$intToHex(n);
    }).join(""));
}
function $35aaf5b2f3735873$export$29fb7152bd3f781a(color) {
    color = $35aaf5b2f3735873$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $35aaf5b2f3735873$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $35aaf5b2f3735873$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $35aaf5b2f3735873$export$677b39864803984e($35aaf5b2f3735873$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $gNnan.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $35aaf5b2f3735873$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $35aaf5b2f3735873$export$d061e26956a60b0a(foreground, background) {
    var lumA = $35aaf5b2f3735873$export$c852d90bf7403b62(foreground);
    var lumB = $35aaf5b2f3735873$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $35aaf5b2f3735873$export$c852d90bf7403b62(color) {
    color = $35aaf5b2f3735873$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $35aaf5b2f3735873$export$677b39864803984e($35aaf5b2f3735873$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $35aaf5b2f3735873$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $35aaf5b2f3735873$export$c852d90bf7403b62(color) > 0.5 ? $35aaf5b2f3735873$export$4b073707ff63303(color, coefficient) : $35aaf5b2f3735873$export$c0816ed86df316af(color, coefficient);
}
var $35aaf5b2f3735873$var$warnedOnce = false;
function $35aaf5b2f3735873$export$cbea29d068a2e18f(color, value) {
    return $35aaf5b2f3735873$export$58f0f39f63f3cf42(color, value);
}
function $35aaf5b2f3735873$export$58f0f39f63f3cf42(color, value) {
    color = $35aaf5b2f3735873$export$677b39864803984e(color);
    value = $35aaf5b2f3735873$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $35aaf5b2f3735873$export$211a73f2b8c10ce4(color);
}
function $35aaf5b2f3735873$export$4b073707ff63303(color, coefficient) {
    color = $35aaf5b2f3735873$export$677b39864803984e(color);
    coefficient = $35aaf5b2f3735873$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $35aaf5b2f3735873$export$211a73f2b8c10ce4(color);
}
function $35aaf5b2f3735873$export$c0816ed86df316af(color, coefficient) {
    color = $35aaf5b2f3735873$export$677b39864803984e(color);
    coefficient = $35aaf5b2f3735873$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $35aaf5b2f3735873$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("efZae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02adb54fbcff253f$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $9gLdn = parcelRequire("9gLdn");
function $02adb54fbcff253f$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $02adb54fbcff253f$var$warnedOnce = false;
function $02adb54fbcff253f$var$roundWithDeprecationWarning(value) {
    return $02adb54fbcff253f$var$round(value);
}
var $02adb54fbcff253f$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $02adb54fbcff253f$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $02adb54fbcff253f$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $02adb54fbcff253f$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $gZz4Z.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $bh1oa.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $02adb54fbcff253f$var$defaultFontFamily ? {
            letterSpacing: "".concat($02adb54fbcff253f$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $02adb54fbcff253f$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $02adb54fbcff253f$var$caseAllCaps)
    };
    return (0, $9gLdn.default)((0, $bh1oa.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $02adb54fbcff253f$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("ju1pB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2f1ea1217f52591$export$2e2bcd8739ae039; });
var $e2f1ea1217f52591$var$shadowKeyUmbraOpacity = 0.2;
var $e2f1ea1217f52591$var$shadowKeyPenumbraOpacity = 0.14;
var $e2f1ea1217f52591$var$shadowAmbientShadowOpacity = 0.12;
function $e2f1ea1217f52591$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($e2f1ea1217f52591$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($e2f1ea1217f52591$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($e2f1ea1217f52591$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $e2f1ea1217f52591$var$shadows = [
    "none",
    $e2f1ea1217f52591$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2f1ea1217f52591$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2f1ea1217f52591$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2f1ea1217f52591$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2f1ea1217f52591$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2f1ea1217f52591$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2f1ea1217f52591$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2f1ea1217f52591$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2f1ea1217f52591$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2f1ea1217f52591$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2f1ea1217f52591$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2f1ea1217f52591$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2f1ea1217f52591$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2f1ea1217f52591$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2f1ea1217f52591$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2f1ea1217f52591$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2f1ea1217f52591$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2f1ea1217f52591$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2f1ea1217f52591$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2f1ea1217f52591$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2f1ea1217f52591$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2f1ea1217f52591$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2f1ea1217f52591$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2f1ea1217f52591$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2f1ea1217f52591$export$2e2bcd8739ae039 = $e2f1ea1217f52591$var$shadows;

});

parcelRegister("5xbKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $407926e6b3b00427$export$2e2bcd8739ae039; });
var $407926e6b3b00427$var$shape = {
    borderRadius: 4
};
var $407926e6b3b00427$export$2e2bcd8739ae039 = $407926e6b3b00427$var$shape;

});

parcelRegister("eo1lV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7945b34cd6e5c63$export$2e2bcd8739ae039; });

var $8jBXs = parcelRequire("8jBXs");
var $a7945b34cd6e5c63$var$warnOnce;
function $a7945b34cd6e5c63$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $8jBXs.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8jBXs", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $60dd8abfd3569f9a$export$1def6f833384e3d1; });
$parcel$export(module.exports, "default", function () { return $60dd8abfd3569f9a$export$2e2bcd8739ae039; });

var $ckFPG = parcelRequire("ckFPG");


var $jpkgZ = parcelRequire("jpkgZ");

var $bh1K7 = parcelRequire("bh1K7");

var $lkdBc = parcelRequire("lkdBc");
var $60dd8abfd3569f9a$var$properties = {
    m: "margin",
    p: "padding"
};
var $60dd8abfd3569f9a$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $60dd8abfd3569f9a$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $60dd8abfd3569f9a$var$getCssProperties = (0, $lkdBc.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($60dd8abfd3569f9a$var$aliases[prop]) prop = $60dd8abfd3569f9a$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $ckFPG.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $60dd8abfd3569f9a$var$properties[a];
    var direction = $60dd8abfd3569f9a$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $60dd8abfd3569f9a$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $60dd8abfd3569f9a$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $60dd8abfd3569f9a$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $60dd8abfd3569f9a$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $60dd8abfd3569f9a$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $60dd8abfd3569f9a$var$spacing(props) {
    var theme = props.theme;
    var transformer = $60dd8abfd3569f9a$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($60dd8abfd3569f9a$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $60dd8abfd3569f9a$var$getCssProperties(prop);
        var styleFromPropValue = $60dd8abfd3569f9a$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $jpkgZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $bh1K7.default), {});
}
$60dd8abfd3569f9a$var$spacing.propTypes = {};
$60dd8abfd3569f9a$var$spacing.filterProps = $60dd8abfd3569f9a$var$spacingKeys;
var $60dd8abfd3569f9a$export$2e2bcd8739ae039 = $60dd8abfd3569f9a$var$spacing;

});
parcelRegister("ckFPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa7cd5f9f56468f$export$2e2bcd8739ae039; });

var $4LCVO = parcelRequire("4LCVO");

var $hsLTA = parcelRequire("hsLTA");

var $gLbpU = parcelRequire("gLbpU");

var $ishYT = parcelRequire("ishYT");
function $8fa7cd5f9f56468f$export$2e2bcd8739ae039(r, e) {
    return (0, $4LCVO.default)(r) || (0, $hsLTA.default)(r, e) || (0, $gLbpU.default)(r, e) || (0, $ishYT.default)();
}

});
parcelRegister("4LCVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3789c029df677549$export$2e2bcd8739ae039; });
function $3789c029df677549$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hsLTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb6a343ada960a5c$export$2e2bcd8739ae039; });
function $cb6a343ada960a5c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gLbpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c339e44e2d2d7b73$export$2e2bcd8739ae039; });

var $hVB46 = parcelRequire("hVB46");
function $c339e44e2d2d7b73$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $hVB46.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $hVB46.default)(r, a) : void 0;
    }
}

});
parcelRegister("hVB46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0d482e494ae6a37$export$2e2bcd8739ae039; });
function $d0d482e494ae6a37$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("ishYT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f8ca348c4846a1$export$2e2bcd8739ae039; });
function $d6f8ca348c4846a1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jpkgZ", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $e21013f11d88d90a$export$88347efdb2e19abd; });

var $foPig = parcelRequire("foPig");

var $bh1oa = parcelRequire("bh1oa");

var $5FKop = parcelRequire("5FKop");


var $bh1K7 = parcelRequire("bh1K7");
// For instance with the first breakpoint xs: [xs, sm[.
var $e21013f11d88d90a$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $e21013f11d88d90a$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($e21013f11d88d90a$var$values[key], "px)");
    }
};
function $e21013f11d88d90a$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $e21013f11d88d90a$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $5FKop.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $e21013f11d88d90a$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $e21013f11d88d90a$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $e21013f11d88d90a$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $bh1oa.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $bh1K7.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $foPig.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $e21013f11d88d90a$export$2e2bcd8739ae039 = $e21013f11d88d90a$var$breakpoints;

});
parcelRegister("foPig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b360e2bee7ad7ceb$export$2e2bcd8739ae039; });

var $alKEO = parcelRequire("alKEO");

var $lnDUc = parcelRequire("lnDUc");

var $gLbpU = parcelRequire("gLbpU");

var $98PK4 = parcelRequire("98PK4");
function $b360e2bee7ad7ceb$export$2e2bcd8739ae039(r) {
    return (0, $alKEO.default)(r) || (0, $lnDUc.default)(r) || (0, $gLbpU.default)(r) || (0, $98PK4.default)();
}

});
parcelRegister("alKEO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78900eb7ac69a024$export$2e2bcd8739ae039; });

var $hVB46 = parcelRequire("hVB46");
function $78900eb7ac69a024$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $hVB46.default)(r);
}

});

parcelRegister("lnDUc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f90ab359ed434fe0$export$2e2bcd8739ae039; });
function $f90ab359ed434fe0$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("98PK4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a7cff493b7ecb4f$export$2e2bcd8739ae039; });
function $6a7cff493b7ecb4f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bh1K7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8352a2515b1b08d8$export$2e2bcd8739ae039; });

var $9gLdn = parcelRequire("9gLdn");
function $8352a2515b1b08d8$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $9gLdn.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $8352a2515b1b08d8$export$2e2bcd8739ae039 = $8352a2515b1b08d8$var$merge;

});


parcelRegister("lkdBc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f86603bac5b73807$export$2e2bcd8739ae039; });
function $f86603bac5b73807$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("frSQs", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $b3f3ebbc2082f970$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $b3f3ebbc2082f970$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");
var $b3f3ebbc2082f970$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $b3f3ebbc2082f970$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3f3ebbc2082f970$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $b3f3ebbc2082f970$export$2e2bcd8739ae039 = {
    easing: $b3f3ebbc2082f970$export$24c5ac7c37452e7d,
    duration: $b3f3ebbc2082f970$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $b3f3ebbc2082f970$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $b3f3ebbc2082f970$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $gZz4Z.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $b3f3ebbc2082f970$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $b3f3ebbc2082f970$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("3iAmy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $266f42727e95a6b4$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $266f42727e95a6b4$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $266f42727e95a6b4$export$2e2bcd8739ae039 = $266f42727e95a6b4$var$zIndex;

});


parcelRegister("iikr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d519c27cdd0c6a6c$export$2e2bcd8739ae039; });

var $hGVlT = parcelRequire("hGVlT");

var $3HGU4 = parcelRequire("3HGU4");

var $6fn7q = parcelRequire("6fn7q");
// eslint-disable-next-line consistent-return
function $d519c27cdd0c6a6c$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $hGVlT.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $d519c27cdd0c6a6c$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette === null || palette === void 0 ? void 0 : palette.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || "light";
    const defaultScheme = initialColorSchemes === null || initialColorSchemes === void 0 ? void 0 : initialColorSchemes[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== "boolean" && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!("colorSchemes" in options)) // Behaves exactly as v5
        return (0, $6fn7q.default)(options, ...args);
        let paletteOptions = palette;
        if (!("palette" in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === "dark") // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: "dark"
                };
            }
        }
        const theme = (0, $6fn7q.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === "light") {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d519c27cdd0c6a6c$var$attachColorScheme(theme, "dark", colorSchemesInput.dark);
        }
        if (theme.palette.mode === "dark") {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d519c27cdd0c6a6c$var$attachColorScheme(theme, "light", colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !("light" in colorSchemesInput) && defaultColorSchemeInput === "light") colorSchemesInput.light = true;
    return (0, $3HGU4.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== "boolean" && cssVariables
    }, ...args);
}

});
parcelRegister("hGVlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce12d8d59e28ad04$export$2e2bcd8739ae039; });

var $iPooL = parcelRequire("iPooL");

var $ig9jY = parcelRequire("ig9jY");

var $kqewD = parcelRequire("kqewD");

var $52DDr = parcelRequire("52DDr");

var $dkL17 = parcelRequire("dkL17");

var $nC27X = parcelRequire("nC27X");

var $bziLn = parcelRequire("bziLn");

var $eGNZP = parcelRequire("eGNZP");

var $4hzoI = parcelRequire("4hzoI");

var $1XCqW = parcelRequire("1XCqW");

var $3VzRO = parcelRequire("3VzRO");
function $ce12d8d59e28ad04$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: "rgba(0, 0, 0, 0.87)",
            // Secondary text.
            secondary: "rgba(0, 0, 0, 0.6)",
            // Disabled text have even lower visual prominence.
            disabled: "rgba(0, 0, 0, 0.38)"
        },
        // The color used to divide different elements.
        divider: "rgba(0, 0, 0, 0.12)",
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $52DDr.default).white,
            default: (0, $52DDr.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: "rgba(0, 0, 0, 0.54)",
            // The color of an hovered action.
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: "rgba(0, 0, 0, 0.26)",
            // The background color of a disabled action.
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $ce12d8d59e28ad04$export$a43af521ac8c3202 = $ce12d8d59e28ad04$var$getLight();
function $ce12d8d59e28ad04$var$getDark() {
    return {
        text: {
            primary: (0, $52DDr.default).white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {
            paper: "#121212",
            default: "#121212"
        },
        action: {
            active: (0, $52DDr.default).white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: 0.08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: 0.16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $ce12d8d59e28ad04$export$55ce6f3a06c59543 = $ce12d8d59e28ad04$var$getDark();
function $ce12d8d59e28ad04$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $kqewD.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $kqewD.darken)(intent.main, tonalOffsetDark);
    }
}
function $ce12d8d59e28ad04$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $4hzoI.default)[200],
        light: (0, $4hzoI.default)[50],
        dark: (0, $4hzoI.default)[400]
    };
    return {
        main: (0, $4hzoI.default)[700],
        light: (0, $4hzoI.default)[400],
        dark: (0, $4hzoI.default)[800]
    };
}
function $ce12d8d59e28ad04$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $nC27X.default)[200],
        light: (0, $nC27X.default)[50],
        dark: (0, $nC27X.default)[400]
    };
    return {
        main: (0, $nC27X.default)[500],
        light: (0, $nC27X.default)[300],
        dark: (0, $nC27X.default)[700]
    };
}
function $ce12d8d59e28ad04$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bziLn.default)[500],
        light: (0, $bziLn.default)[300],
        dark: (0, $bziLn.default)[700]
    };
    return {
        main: (0, $bziLn.default)[700],
        light: (0, $bziLn.default)[400],
        dark: (0, $bziLn.default)[800]
    };
}
function $ce12d8d59e28ad04$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1XCqW.default)[400],
        light: (0, $1XCqW.default)[300],
        dark: (0, $1XCqW.default)[700]
    };
    return {
        main: (0, $1XCqW.default)[700],
        light: (0, $1XCqW.default)[500],
        dark: (0, $1XCqW.default)[900]
    };
}
function $ce12d8d59e28ad04$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3VzRO.default)[400],
        light: (0, $3VzRO.default)[300],
        dark: (0, $3VzRO.default)[700]
    };
    return {
        main: (0, $3VzRO.default)[800],
        light: (0, $3VzRO.default)[500],
        dark: (0, $3VzRO.default)[900]
    };
}
function $ce12d8d59e28ad04$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $eGNZP.default)[400],
        light: (0, $eGNZP.default)[300],
        dark: (0, $eGNZP.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $eGNZP.default)[500],
        dark: (0, $eGNZP.default)[900]
    };
}
function $ce12d8d59e28ad04$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $ce12d8d59e28ad04$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $ce12d8d59e28ad04$var$getDefaultSecondary(mode);
    const error = palette.error || $ce12d8d59e28ad04$var$getDefaultError(mode);
    const info = palette.info || $ce12d8d59e28ad04$var$getDefaultInfo(mode);
    const success = palette.success || $ce12d8d59e28ad04$var$getDefaultSuccess(mode);
    const warning = palette.warning || $ce12d8d59e28ad04$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kqewD.getContrastRatio)(background, $ce12d8d59e28ad04$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $ce12d8d59e28ad04$export$55ce6f3a06c59543.text.primary : $ce12d8d59e28ad04$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $iPooL.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $iPooL.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $ce12d8d59e28ad04$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $ce12d8d59e28ad04$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === "light") modeHydrated = $ce12d8d59e28ad04$var$getLight();
    else if (mode === "dark") modeHydrated = $ce12d8d59e28ad04$var$getDark();
    const paletteOutput = (0, $ig9jY.default)({
        // A collection of common colors.
        common: {
            ...(0, $52DDr.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $dkL17.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("52DDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3abbe263da032ace$export$2e2bcd8739ae039; });
const $3abbe263da032ace$var$common = {
    black: "#000",
    white: "#fff"
};
var $3abbe263da032ace$export$2e2bcd8739ae039 = $3abbe263da032ace$var$common;

});

parcelRegister("dkL17", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b519d3c58aa6144$export$2e2bcd8739ae039; });
const $9b519d3c58aa6144$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $9b519d3c58aa6144$export$2e2bcd8739ae039 = $9b519d3c58aa6144$var$grey;

});

parcelRegister("nC27X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $046fa6b86a1aa64d$export$2e2bcd8739ae039; });
const $046fa6b86a1aa64d$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $046fa6b86a1aa64d$export$2e2bcd8739ae039 = $046fa6b86a1aa64d$var$purple;

});

parcelRegister("bziLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $022c695d32b0bc76$export$2e2bcd8739ae039; });
const $022c695d32b0bc76$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $022c695d32b0bc76$export$2e2bcd8739ae039 = $022c695d32b0bc76$var$red;

});

parcelRegister("eGNZP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab1bc52b18b00c2d$export$2e2bcd8739ae039; });
const $ab1bc52b18b00c2d$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $ab1bc52b18b00c2d$export$2e2bcd8739ae039 = $ab1bc52b18b00c2d$var$orange;

});

parcelRegister("4hzoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31e4352d8122170a$export$2e2bcd8739ae039; });
const $31e4352d8122170a$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $31e4352d8122170a$export$2e2bcd8739ae039 = $31e4352d8122170a$var$blue;

});

parcelRegister("1XCqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d91d35d672a373$export$2e2bcd8739ae039; });
const $16d91d35d672a373$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $16d91d35d672a373$export$2e2bcd8739ae039 = $16d91d35d672a373$var$lightBlue;

});

parcelRegister("3VzRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dc2846b82abc275$export$2e2bcd8739ae039; });
const $2dc2846b82abc275$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $2dc2846b82abc275$export$2e2bcd8739ae039 = $2dc2846b82abc275$var$green;

});


parcelRegister("3HGU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b26aaf91313b5fb$export$2e2bcd8739ae039; });

var $iPooL = parcelRequire("iPooL");

var $ig9jY = parcelRequire("ig9jY");

var $d3Twb = parcelRequire("d3Twb");
var $eedOL = parcelRequire("eedOL");

var $99wkl = parcelRequire("99wkl");

var $zWGFW = parcelRequire("zWGFW");
var $1s3Ns = parcelRequire("1s3Ns");
var $jwBDn = parcelRequire("jwBDn");

var $2RnpB = parcelRequire("2RnpB");
var $7U7Z7 = parcelRequire("7U7Z7");

var $kqewD = parcelRequire("kqewD");

var $6fn7q = parcelRequire("6fn7q");

var $6ZvFy = parcelRequire("6ZvFy");

var $gTt4k = parcelRequire("gTt4k");

var $jmooZ = parcelRequire("jmooZ");

var $7ycvS = parcelRequire("7ycvS");
function $2b26aaf91313b5fb$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $2b26aaf91313b5fb$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $2b26aaf91313b5fb$var$toRgb(color) {
    if (typeof color !== "string" || !color.startsWith("hsl")) return color;
    return (0, $kqewD.hslToRgb)(color);
}
function $2b26aaf91313b5fb$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $kqewD.private_safeColorChannel)($2b26aaf91313b5fb$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + "\n" + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $2b26aaf91313b5fb$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === "number") return `${spacingInput}px`;
    if (typeof spacingInput === "string" || typeof spacingInput === "function" || Array.isArray(spacingInput)) return spacingInput;
    return "8px";
}
const $2b26aaf91313b5fb$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $2b26aaf91313b5fb$export$65418b4d9082cc44 = (cssVarPrefix = "mui")=>(0, $eedOL.default)(cssVarPrefix);
function $2b26aaf91313b5fb$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === "dark" ? "dark" : "light";
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $6ZvFy.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme === null || scheme === void 0 ? void 0 : scheme.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $6fn7q.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme === null || scheme === void 0 ? void 0 : scheme.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $6ZvFy.getOpacity)(mode),
            ...scheme === null || scheme === void 0 ? void 0 : scheme.opacity
        },
        overlays: (scheme === null || scheme === void 0 ? void 0 : scheme.overlays) || (0, $6ZvFy.getOverlays)(mode)
    };
    return muiTheme;
}
function $2b26aaf91313b5fb$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = "mui", shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $gTt4k.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? "media" : undefined, rootSelector: rootSelector = ":root", ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== "light" ? "light" : firstColorScheme);
    const getCssVar = $2b26aaf91313b5fb$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === "dark" && !("dark" in colorSchemesInput) || defaultColorScheme === "light" && !("light" in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $iPooL.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $2b26aaf91313b5fb$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $2b26aaf91313b5fb$var$attachColorScheme(colorSchemes, builtInLight, undefined, "light");
    if (builtInDark && !colorSchemes.dark) $2b26aaf91313b5fb$var$attachColorScheme(colorSchemes, builtInDark, undefined, "dark");
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $jwBDn.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $2b26aaf91313b5fb$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split("-");
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === "light") {
            $2b26aaf91313b5fb$var$setColor(palette.common, "background", "#fff");
            $2b26aaf91313b5fb$var$setColor(palette.common, "onBackground", "#000");
        }
        if (palette.mode === "dark") {
            $2b26aaf91313b5fb$var$setColor(palette.common, "background", "#000");
            $2b26aaf91313b5fb$var$setColor(palette.common, "onBackground", "#fff");
        }
        // assign component variables
        $2b26aaf91313b5fb$var$assignNode(palette, [
            "Alert",
            "AppBar",
            "Avatar",
            "Button",
            "Chip",
            "FilledInput",
            "LinearProgress",
            "Skeleton",
            "Slider",
            "SnackbarContent",
            "SpeedDialAction",
            "StepConnector",
            "StepContent",
            "Switch",
            "TableCell",
            "Tooltip"
        ]);
        if (palette.mode === "light") {
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorColor", (0, $kqewD.private_safeDarken)(palette.error.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoColor", (0, $kqewD.private_safeDarken)(palette.info.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successColor", (0, $kqewD.private_safeDarken)(palette.success.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningColor", (0, $kqewD.private_safeDarken)(palette.warning.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.error.main)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.info.main)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.success.main)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorStandardBg", (0, $kqewD.private_safeLighten)(palette.error.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoStandardBg", (0, $kqewD.private_safeLighten)(palette.info.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successStandardBg", (0, $kqewD.private_safeLighten)(palette.success.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningStandardBg", (0, $kqewD.private_safeLighten)(palette.warning.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            $2b26aaf91313b5fb$var$setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-100"));
            $2b26aaf91313b5fb$var$setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-400"));
            $2b26aaf91313b5fb$var$setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-300"));
            $2b26aaf91313b5fb$var$setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-A100"));
            $2b26aaf91313b5fb$var$setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-400"));
            $2b26aaf91313b5fb$var$setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-700"));
            $2b26aaf91313b5fb$var$setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-700"));
            $2b26aaf91313b5fb$var$setColor(palette.FilledInput, "bg", "rgba(0, 0, 0, 0.06)");
            $2b26aaf91313b5fb$var$setColor(palette.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)");
            $2b26aaf91313b5fb$var$setColor(palette.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)");
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "primaryBg", (0, $kqewD.private_safeLighten)(palette.primary.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "secondaryBg", (0, $kqewD.private_safeLighten)(palette.secondary.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "errorBg", (0, $kqewD.private_safeLighten)(palette.error.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "infoBg", (0, $kqewD.private_safeLighten)(palette.info.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "successBg", (0, $kqewD.private_safeLighten)(palette.success.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "warningBg", (0, $kqewD.private_safeLighten)(palette.warning.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.11)`);
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "primaryTrack", (0, $kqewD.private_safeLighten)(palette.primary.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "secondaryTrack", (0, $kqewD.private_safeLighten)(palette.secondary.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "errorTrack", (0, $kqewD.private_safeLighten)(palette.error.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "infoTrack", (0, $kqewD.private_safeLighten)(palette.info.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "successTrack", (0, $kqewD.private_safeLighten)(palette.success.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "warningTrack", (0, $kqewD.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $kqewD.private_safeEmphasize)(palette.background.default, 0.8);
            $2b26aaf91313b5fb$var$setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            $2b26aaf91313b5fb$var$setColor(palette.SnackbarContent, "color", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $2b26aaf91313b5fb$var$setColor(palette.SpeedDialAction, "fabHoverBg", (0, $kqewD.private_safeEmphasize)(palette.background.paper, 0.15));
            $2b26aaf91313b5fb$var$setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-400"));
            $2b26aaf91313b5fb$var$setColor(palette.StepContent, "border", setCssVarColor("palette-grey-400"));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "defaultColor", setCssVarColor("palette-common-white"));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-100"));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "primaryDisabledColor", (0, $kqewD.private_safeLighten)(palette.primary.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "secondaryDisabledColor", (0, $kqewD.private_safeLighten)(palette.secondary.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "errorDisabledColor", (0, $kqewD.private_safeLighten)(palette.error.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "infoDisabledColor", (0, $kqewD.private_safeLighten)(palette.info.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "successDisabledColor", (0, $kqewD.private_safeLighten)(palette.success.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "warningDisabledColor", (0, $kqewD.private_safeLighten)(palette.warning.main, 0.62));
            $2b26aaf91313b5fb$var$setColor(palette.TableCell, "border", (0, $kqewD.private_safeLighten)((0, $kqewD.private_safeAlpha)(palette.divider, 1), 0.88));
            $2b26aaf91313b5fb$var$setColor(palette.Tooltip, "bg", (0, $kqewD.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === "dark") {
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorColor", (0, $kqewD.private_safeLighten)(palette.error.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoColor", (0, $kqewD.private_safeLighten)(palette.info.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successColor", (0, $kqewD.private_safeLighten)(palette.success.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningColor", (0, $kqewD.private_safeLighten)(palette.warning.light, 0.6));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-dark"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-dark"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-dark"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-dark"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningFilledColor", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorStandardBg", (0, $kqewD.private_safeDarken)(palette.error.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoStandardBg", (0, $kqewD.private_safeDarken)(palette.info.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successStandardBg", (0, $kqewD.private_safeDarken)(palette.success.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningStandardBg", (0, $kqewD.private_safeDarken)(palette.warning.light, 0.9));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            $2b26aaf91313b5fb$var$setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            $2b26aaf91313b5fb$var$setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-900"));
            $2b26aaf91313b5fb$var$setColor(palette.AppBar, "darkBg", setCssVarColor("palette-background-paper")); // specific for dark mode
            $2b26aaf91313b5fb$var$setColor(palette.AppBar, "darkColor", setCssVarColor("palette-text-primary")); // specific for dark mode
            $2b26aaf91313b5fb$var$setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-600"));
            $2b26aaf91313b5fb$var$setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-800"));
            $2b26aaf91313b5fb$var$setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-700"));
            $2b26aaf91313b5fb$var$setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-700"));
            $2b26aaf91313b5fb$var$setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-300"));
            $2b26aaf91313b5fb$var$setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-300"));
            $2b26aaf91313b5fb$var$setColor(palette.FilledInput, "bg", "rgba(255, 255, 255, 0.09)");
            $2b26aaf91313b5fb$var$setColor(palette.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)");
            $2b26aaf91313b5fb$var$setColor(palette.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)");
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "primaryBg", (0, $kqewD.private_safeDarken)(palette.primary.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "secondaryBg", (0, $kqewD.private_safeDarken)(palette.secondary.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "errorBg", (0, $kqewD.private_safeDarken)(palette.error.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "infoBg", (0, $kqewD.private_safeDarken)(palette.info.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "successBg", (0, $kqewD.private_safeDarken)(palette.success.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.LinearProgress, "warningBg", (0, $kqewD.private_safeDarken)(palette.warning.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.13)`);
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "primaryTrack", (0, $kqewD.private_safeDarken)(palette.primary.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "secondaryTrack", (0, $kqewD.private_safeDarken)(palette.secondary.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "errorTrack", (0, $kqewD.private_safeDarken)(palette.error.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "infoTrack", (0, $kqewD.private_safeDarken)(palette.info.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "successTrack", (0, $kqewD.private_safeDarken)(palette.success.main, 0.5));
            $2b26aaf91313b5fb$var$setColor(palette.Slider, "warningTrack", (0, $kqewD.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $kqewD.private_safeEmphasize)(palette.background.default, 0.98);
            $2b26aaf91313b5fb$var$setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            $2b26aaf91313b5fb$var$setColor(palette.SnackbarContent, "color", $2b26aaf91313b5fb$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $2b26aaf91313b5fb$var$setColor(palette.SpeedDialAction, "fabHoverBg", (0, $kqewD.private_safeEmphasize)(palette.background.paper, 0.15));
            $2b26aaf91313b5fb$var$setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-600"));
            $2b26aaf91313b5fb$var$setColor(palette.StepContent, "border", setCssVarColor("palette-grey-600"));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "defaultColor", setCssVarColor("palette-grey-300"));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-600"));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "primaryDisabledColor", (0, $kqewD.private_safeDarken)(palette.primary.main, 0.55));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "secondaryDisabledColor", (0, $kqewD.private_safeDarken)(palette.secondary.main, 0.55));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "errorDisabledColor", (0, $kqewD.private_safeDarken)(palette.error.main, 0.55));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "infoDisabledColor", (0, $kqewD.private_safeDarken)(palette.info.main, 0.55));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "successDisabledColor", (0, $kqewD.private_safeDarken)(palette.success.main, 0.55));
            $2b26aaf91313b5fb$var$setColor(palette.Switch, "warningDisabledColor", (0, $kqewD.private_safeDarken)(palette.warning.main, 0.55));
            $2b26aaf91313b5fb$var$setColor(palette.TableCell, "border", (0, $kqewD.private_safeDarken)((0, $kqewD.private_safeAlpha)(palette.divider, 1), 0.68));
            $2b26aaf91313b5fb$var$setColor(palette.Tooltip, "bg", (0, $kqewD.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $2b26aaf91313b5fb$var$setColorChannel(palette.background, "default");
        // added for consistency with the `background.default` token
        $2b26aaf91313b5fb$var$setColorChannel(palette.background, "paper");
        $2b26aaf91313b5fb$var$setColorChannel(palette.common, "background");
        $2b26aaf91313b5fb$var$setColorChannel(palette.common, "onBackground");
        $2b26aaf91313b5fb$var$setColorChannel(palette, "divider");
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== "tonalOffset" && colors && typeof colors === "object") {
                // Silent the error for custom palettes.
                if (colors.main) $2b26aaf91313b5fb$var$setColor(palette[color], "mainChannel", (0, $kqewD.private_safeColorChannel)($2b26aaf91313b5fb$var$toRgb(colors.main)));
                if (colors.light) $2b26aaf91313b5fb$var$setColor(palette[color], "lightChannel", (0, $kqewD.private_safeColorChannel)($2b26aaf91313b5fb$var$toRgb(colors.light)));
                if (colors.dark) $2b26aaf91313b5fb$var$setColor(palette[color], "darkChannel", (0, $kqewD.private_safeColorChannel)($2b26aaf91313b5fb$var$toRgb(colors.dark)));
                if (colors.contrastText) $2b26aaf91313b5fb$var$setColor(palette[color], "contrastTextChannel", (0, $kqewD.private_safeColorChannel)($2b26aaf91313b5fb$var$toRgb(colors.contrastText)));
                if (color === "text") {
                    // Text colors: text.primary, text.secondary
                    $2b26aaf91313b5fb$var$setColorChannel(palette[color], "primary");
                    $2b26aaf91313b5fb$var$setColorChannel(palette[color], "secondary");
                }
                if (color === "action") {
                    // Action colors: action.active, action.selected
                    if (colors.active) $2b26aaf91313b5fb$var$setColorChannel(palette[color], "active");
                    if (colors.selected) $2b26aaf91313b5fb$var$setColorChannel(palette[color], "selected");
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $ig9jY.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $jmooZ.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $1s3Ns.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $d3Twb.default)(input.spacing, (0, $99wkl.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $zWGFW.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $7U7Z7.default),
        ...input === null || input === void 0 ? void 0 : input.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $2RnpB.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $7ycvS.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("eedOL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5bd176c73d35c39$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $a5bd176c73d35c39$export$2e2bcd8739ae039(prefix = "") {
    function appendVar(...vars) {
        if (!vars.length) return "";
        const value = vars[0];
        if (typeof value === "string" && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ""}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ""}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("zWGFW", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $06c0cb13c3121f75$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $06c0cb13c3121f75$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === "media") return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith("data-") && !selector.includes("%s")) return `[${selector}="${colorScheme}"] &`;
            if (selector === "class") return `.${colorScheme} &`;
            if (selector === "data") return `[data-${colorScheme}] &`;
            return `${selector.replace("%s", colorScheme)} &`;
        }
        return "&";
    };
}

});

parcelRegister("1s3Ns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10eb59e60ca053af$export$2e2bcd8739ae039; });

var $ig9jY = parcelRequire("ig9jY");

var $8Sjx7 = parcelRequire("8Sjx7");
function $10eb59e60ca053af$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = "light", ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $8Sjx7.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $8Sjx7.default)(scheme, parserConfig);
        themeVars = (0, $ig9jY.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $8Sjx7.default)(defaultScheme, parserConfig);
        themeVars = (0, $ig9jY.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === "class") rule = ".%s";
        if (selector === "data") rule = "[data-%s]";
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith("data-")) && !selector.includes("%s")) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === "media") {
                var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
                if (theme.defaultColorScheme === colorScheme) return ":root";
                const mode = ((_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode) || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ":root": cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace("%s", String(colorScheme))}`;
                return rule.replace("%s", String(colorScheme));
            }
        }
        return ":root";
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $ig9jY.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || "light";
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === "string" ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = (_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            var _colorSchemes_key_palette, _colorSchemes_key;
            const cssColorSheme = (_colorSchemes_key = colorSchemes[key]) === null || _colorSchemes_key === void 0 ? void 0 : (_colorSchemes_key_palette = _colorSchemes_key.palette) === null || _colorSchemes_key_palette === void 0 ? void 0 : _colorSchemes_key_palette.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $10eb59e60ca053af$export$2e2bcd8739ae039 = $10eb59e60ca053af$var$prepareCssVars;

});
parcelRegister("8Sjx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676284c08171ea2e$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $676284c08171ea2e$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === "object") temp[k] = value;
        } else if (temp && typeof temp === "object") {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $676284c08171ea2e$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === "object" && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $676284c08171ea2e$var$getCssValue = (keys, value)=>{
    if (typeof value === "number") {
        if ([
            "lineHeight",
            "fontWeight",
            "opacity",
            "zIndex"
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes("opacity")) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $676284c08171ea2e$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $676284c08171ea2e$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === "string" || typeof value === "number") {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ""}${keys.join("-")}`;
                const resolvedValue = $676284c08171ea2e$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $676284c08171ea2e$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $676284c08171ea2e$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === "vars" // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("jwBDn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e36e32da2bc58d8e$export$2e2bcd8739ae039; });
function $e36e32da2bc58d8e$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === "object") vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ""}${value.fontVariant ? `${value.fontVariant} ` : ""}${value.fontWeight ? `${value.fontWeight} ` : ""}${value.fontStretch ? `${value.fontStretch} ` : ""}${value.fontSize || ""}${value.lineHeight ? `/${value.lineHeight} ` : ""}${value.fontFamily || ""}`;
    });
    return vars;
}

});

parcelRegister("6fn7q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c613b221b222c9$export$2e2bcd8739ae039; });

var $iPooL = parcelRequire("iPooL");

var $ig9jY = parcelRequire("ig9jY");

var $2RnpB = parcelRequire("2RnpB");
var $7U7Z7 = parcelRequire("7U7Z7");

var $1v4KJ = parcelRequire("1v4KJ");


var $6AdOp = parcelRequire("6AdOp");

var $hGVlT = parcelRequire("hGVlT");

var $1NRdZ = parcelRequire("1NRdZ");

var $gMj5z = parcelRequire("gMj5z");

var $1IjmQ = parcelRequire("1IjmQ");

var $24bkH = parcelRequire("24bkH");

var $7ycvS = parcelRequire("7ycvS");
function $48c613b221b222c9$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars) throw new Error((0, $iPooL.default)(20));
    const palette = (0, $hGVlT.default)(paletteInput);
    const systemTheme = (0, $1v4KJ.default)(options);
    let muiTheme = (0, $ig9jY.default)(systemTheme, {
        mixins: (0, $6AdOp.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $gMj5z.default).slice(),
        typography: (0, $1NRdZ.default)(palette, typographyInput),
        transitions: (0, $1IjmQ.default)(transitionsInput),
        zIndex: {
            ...(0, $24bkH.default)
        }
    });
    muiTheme = (0, $ig9jY.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $ig9jY.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $7U7Z7.default),
        ...other === null || other === void 0 ? void 0 : other.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $2RnpB.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $7ycvS.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $48c613b221b222c9$var$warnedOnce = false;
function $48c613b221b222c9$export$c469355549431d9b(...args) {
    return $48c613b221b222c9$var$createThemeNoVars(...args);
}
var $48c613b221b222c9$export$2e2bcd8739ae039 = $48c613b221b222c9$var$createThemeNoVars;

});
parcelRegister("6AdOp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb0d1ac5a7667bd$export$2e2bcd8739ae039; });
function $4cb0d1ac5a7667bd$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("1NRdZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1503a75b79347a8e$export$2e2bcd8739ae039; });

var $ig9jY = parcelRequire("ig9jY");
function $1503a75b79347a8e$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $1503a75b79347a8e$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $1503a75b79347a8e$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $1503a75b79347a8e$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $1503a75b79347a8e$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === "function" ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $1503a75b79347a8e$var$defaultFontFamily ? {
                letterSpacing: `${$1503a75b79347a8e$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $1503a75b79347a8e$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $1503a75b79347a8e$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $ig9jY.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("gMj5z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c36fefae19cd7006$export$2e2bcd8739ae039; });
const $c36fefae19cd7006$var$shadowKeyUmbraOpacity = 0.2;
const $c36fefae19cd7006$var$shadowKeyPenumbraOpacity = 0.14;
const $c36fefae19cd7006$var$shadowAmbientShadowOpacity = 0.12;
function $c36fefae19cd7006$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$c36fefae19cd7006$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$c36fefae19cd7006$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$c36fefae19cd7006$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $c36fefae19cd7006$var$shadows = [
    "none",
    $c36fefae19cd7006$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $c36fefae19cd7006$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $c36fefae19cd7006$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $c36fefae19cd7006$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $c36fefae19cd7006$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $c36fefae19cd7006$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $c36fefae19cd7006$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $c36fefae19cd7006$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $c36fefae19cd7006$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $c36fefae19cd7006$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $c36fefae19cd7006$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $c36fefae19cd7006$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $c36fefae19cd7006$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $c36fefae19cd7006$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $c36fefae19cd7006$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $c36fefae19cd7006$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $c36fefae19cd7006$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $c36fefae19cd7006$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $c36fefae19cd7006$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $c36fefae19cd7006$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $c36fefae19cd7006$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $c36fefae19cd7006$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $c36fefae19cd7006$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $c36fefae19cd7006$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $c36fefae19cd7006$export$2e2bcd8739ae039 = $c36fefae19cd7006$var$shadows;

});

parcelRegister("24bkH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1814bef113dcc18a$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $1814bef113dcc18a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $1814bef113dcc18a$export$2e2bcd8739ae039 = $1814bef113dcc18a$var$zIndex;

});

parcelRegister("7ycvS", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $57f56a40829c61b9$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $ig9jY = parcelRequire("ig9jY");
function $57f56a40829c61b9$var$isSerializable(val) {
    return (0, $ig9jY.isPlainObject)(val) || typeof val === "undefined" || typeof val === "string" || typeof val === "boolean" || typeof val === "number" || Array.isArray(val);
}
function $57f56a40829c61b9$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$57f56a40829c61b9$var$isSerializable(value) || key.startsWith("unstable_")) delete object[key];
            else if ((0, $ig9jY.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("6ZvFy", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $5171016a10737c4a$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $5171016a10737c4a$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $5171016a10737c4a$export$2e2bcd8739ae039; });

var $hGVlT = parcelRequire("hGVlT");

var $f9SwI = parcelRequire("f9SwI");
const $5171016a10737c4a$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return "none";
    const overlay = (0, $f9SwI.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $5171016a10737c4a$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === "dark" ? 0.5 : 0.42,
        inputUnderline: mode === "dark" ? 0.7 : 0.42,
        switchTrackDisabled: mode === "dark" ? 0.2 : 0.12,
        switchTrack: mode === "dark" ? 0.3 : 0.38
    };
}
function $5171016a10737c4a$export$dd191566510330d3(mode) {
    return mode === "dark" ? $5171016a10737c4a$var$defaultDarkOverlays : [];
}
function $5171016a10737c4a$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: "light"
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $hGVlT.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$5171016a10737c4a$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $5171016a10737c4a$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("f9SwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b091fe282dc3e54c$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $b091fe282dc3e54c$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("gTt4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4c854da8f266f1e$export$2e2bcd8739ae039; });
function $c4c854da8f266f1e$export$2e2bcd8739ae039(keys) {
    var _keys_;
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === "palette" && !!((_keys_ = keys[1]) === null || _keys_ === void 0 ? void 0 : _keys_.match(/(mode|contrastThreshold|tonalOffset)/));
}

});

parcelRegister("jmooZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e183001f903b1c24$export$2e2bcd8739ae039; });

var $bo7Bq = parcelRequire("bo7Bq");
var $e183001f903b1c24$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ":root";
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === "class") rule = ".%s";
        if (selector === "data") rule = "[data-%s]";
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith("data-")) && !selector.includes("%s")) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === "dark") {
                const excludedVariables = {};
                (0, $bo7Bq.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === "media") return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace("%s", colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace("%s", colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== "media") return `${root}, ${rule.replace("%s", String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === "media") return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace("%s", String(colorScheme));
        }
        return root;
    };

});
parcelRegister("bo7Bq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84a7d5525400852a$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $84a7d5525400852a$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ""}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkColor`
    ];
var $84a7d5525400852a$export$2e2bcd8739ae039 = $84a7d5525400852a$var$excludeVariablesFromRoot;

});




parcelRegister("iuDcE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d769703fe665f99f$export$2e2bcd8739ae039; });

var $lRVfF = parcelRequire("lRVfF");
const $d769703fe665f99f$var$white = "#FFFFFF";
const $d769703fe665f99f$var$black = "#000000";
var $d769703fe665f99f$export$2e2bcd8739ae039 = {
    black: $d769703fe665f99f$var$black,
    white: $d769703fe665f99f$var$white,
    primary: {
        contrastText: $d769703fe665f99f$var$white,
        dark: (0, $lRVfF).lightBlue[900],
        main: "#FB877A",
        light: (0, $lRVfF).lightBlue[100]
    },
    secondary: {
        contrastText: $d769703fe665f99f$var$white,
        dark: (0, $lRVfF).blue[900],
        main: "#38B6FF",
        light: (0, $lRVfF).blue.A400
    },
    success: {
        contrastText: $d769703fe665f99f$var$white,
        dark: (0, $lRVfF).green[900],
        main: (0, $lRVfF).green[600],
        light: (0, $lRVfF).green[400]
    },
    info: {
        contrastText: $d769703fe665f99f$var$white,
        dark: (0, $lRVfF).blue[900],
        main: (0, $lRVfF).blue[600],
        light: (0, $lRVfF).blue[400]
    },
    warning: {
        contrastText: $d769703fe665f99f$var$white,
        dark: (0, $lRVfF).orange[900],
        main: (0, $lRVfF).orange[600],
        light: (0, $lRVfF).orange[400]
    },
    error: {
        contrastText: $d769703fe665f99f$var$white,
        dark: (0, $lRVfF).red[900],
        main: (0, $lRVfF).red[600],
        light: (0, $lRVfF).red[400]
    },
    text: {
        primary: (0, $lRVfF).blueGrey[900],
        secondary: "#0098c2",
        link: (0, $lRVfF).blue[600]
    },
    background: {
        default: "#F4F6F8",
        light: (0, $lRVfF).grey[200],
        paper: $d769703fe665f99f$var$white
    },
    icon: (0, $lRVfF).blueGrey[600],
    divider: (0, $lRVfF).grey[200]
};

});
parcelRegister("lRVfF", function(module, exports) {

$parcel$export(module.exports, "common", function () { return (parcelRequire("1zUo6")).default; });
$parcel$export(module.exports, "red", function () { return (parcelRequire("8UprC")).default; });
$parcel$export(module.exports, "pink", function () { return (parcelRequire("7Hlqk")).default; });
$parcel$export(module.exports, "purple", function () { return (parcelRequire("3pcfJ")).default; });
$parcel$export(module.exports, "deepPurple", function () { return (parcelRequire("92Nf3")).default; });
$parcel$export(module.exports, "indigo", function () { return (parcelRequire("e9QBE")).default; });
$parcel$export(module.exports, "blue", function () { return (parcelRequire("6I9LF")).default; });
$parcel$export(module.exports, "lightBlue", function () { return (parcelRequire("4F30o")).default; });
$parcel$export(module.exports, "cyan", function () { return (parcelRequire("dPXl3")).default; });
$parcel$export(module.exports, "teal", function () { return (parcelRequire("dYb5s")).default; });
$parcel$export(module.exports, "green", function () { return (parcelRequire("4Mdjv")).default; });
$parcel$export(module.exports, "lightGreen", function () { return (parcelRequire("3q728")).default; });
$parcel$export(module.exports, "lime", function () { return (parcelRequire("leVkl")).default; });
$parcel$export(module.exports, "yellow", function () { return (parcelRequire("c14Eh")).default; });
$parcel$export(module.exports, "amber", function () { return (parcelRequire("dfW1g")).default; });
$parcel$export(module.exports, "orange", function () { return (parcelRequire("aPk5R")).default; });
$parcel$export(module.exports, "deepOrange", function () { return (parcelRequire("ag7UR")).default; });
$parcel$export(module.exports, "brown", function () { return (parcelRequire("dxE0t")).default; });
$parcel$export(module.exports, "grey", function () { return (parcelRequire("lcF3K")).default; });
$parcel$export(module.exports, "blueGrey", function () { return (parcelRequire("cpnft")).default; });

var $1zUo6 = parcelRequire("1zUo6");

var $8UprC = parcelRequire("8UprC");

var $7Hlqk = parcelRequire("7Hlqk");

var $3pcfJ = parcelRequire("3pcfJ");

var $92Nf3 = parcelRequire("92Nf3");

var $e9QBE = parcelRequire("e9QBE");

var $6I9LF = parcelRequire("6I9LF");

var $4F30o = parcelRequire("4F30o");

var $dPXl3 = parcelRequire("dPXl3");

var $dYb5s = parcelRequire("dYb5s");

var $4Mdjv = parcelRequire("4Mdjv");

var $3q728 = parcelRequire("3q728");

var $leVkl = parcelRequire("leVkl");

var $c14Eh = parcelRequire("c14Eh");

var $dfW1g = parcelRequire("dfW1g");

var $aPk5R = parcelRequire("aPk5R");

var $ag7UR = parcelRequire("ag7UR");

var $dxE0t = parcelRequire("dxE0t");

var $lcF3K = parcelRequire("lcF3K");

var $cpnft = parcelRequire("cpnft");

});
parcelRegister("3pcfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27ad360749c49c9a$export$2e2bcd8739ae039; });
var $27ad360749c49c9a$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $27ad360749c49c9a$export$2e2bcd8739ae039 = $27ad360749c49c9a$var$purple;

});

parcelRegister("92Nf3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $695a7f5b50d1ee99$export$2e2bcd8739ae039; });
var $695a7f5b50d1ee99$var$deepPurple = {
    50: "#ede7f6",
    100: "#d1c4e9",
    200: "#b39ddb",
    300: "#9575cd",
    400: "#7e57c2",
    500: "#673ab7",
    600: "#5e35b1",
    700: "#512da8",
    800: "#4527a0",
    900: "#311b92",
    A100: "#b388ff",
    A200: "#7c4dff",
    A400: "#651fff",
    A700: "#6200ea"
};
var $695a7f5b50d1ee99$export$2e2bcd8739ae039 = $695a7f5b50d1ee99$var$deepPurple;

});

parcelRegister("4F30o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364d52946ff23ee3$export$2e2bcd8739ae039; });
var $364d52946ff23ee3$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $364d52946ff23ee3$export$2e2bcd8739ae039 = $364d52946ff23ee3$var$lightBlue;

});

parcelRegister("dPXl3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a12e112e4b174ae6$export$2e2bcd8739ae039; });
var $a12e112e4b174ae6$var$cyan = {
    50: "#e0f7fa",
    100: "#b2ebf2",
    200: "#80deea",
    300: "#4dd0e1",
    400: "#26c6da",
    500: "#00bcd4",
    600: "#00acc1",
    700: "#0097a7",
    800: "#00838f",
    900: "#006064",
    A100: "#84ffff",
    A200: "#18ffff",
    A400: "#00e5ff",
    A700: "#00b8d4"
};
var $a12e112e4b174ae6$export$2e2bcd8739ae039 = $a12e112e4b174ae6$var$cyan;

});

parcelRegister("dYb5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2b97aa1f239e47f$export$2e2bcd8739ae039; });
var $a2b97aa1f239e47f$var$teal = {
    50: "#e0f2f1",
    100: "#b2dfdb",
    200: "#80cbc4",
    300: "#4db6ac",
    400: "#26a69a",
    500: "#009688",
    600: "#00897b",
    700: "#00796b",
    800: "#00695c",
    900: "#004d40",
    A100: "#a7ffeb",
    A200: "#64ffda",
    A400: "#1de9b6",
    A700: "#00bfa5"
};
var $a2b97aa1f239e47f$export$2e2bcd8739ae039 = $a2b97aa1f239e47f$var$teal;

});

parcelRegister("3q728", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d941814f01f918$export$2e2bcd8739ae039; });
var $27d941814f01f918$var$lightGreen = {
    50: "#f1f8e9",
    100: "#dcedc8",
    200: "#c5e1a5",
    300: "#aed581",
    400: "#9ccc65",
    500: "#8bc34a",
    600: "#7cb342",
    700: "#689f38",
    800: "#558b2f",
    900: "#33691e",
    A100: "#ccff90",
    A200: "#b2ff59",
    A400: "#76ff03",
    A700: "#64dd17"
};
var $27d941814f01f918$export$2e2bcd8739ae039 = $27d941814f01f918$var$lightGreen;

});

parcelRegister("leVkl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7675fc74ac5e412$export$2e2bcd8739ae039; });
var $f7675fc74ac5e412$var$lime = {
    50: "#f9fbe7",
    100: "#f0f4c3",
    200: "#e6ee9c",
    300: "#dce775",
    400: "#d4e157",
    500: "#cddc39",
    600: "#c0ca33",
    700: "#afb42b",
    800: "#9e9d24",
    900: "#827717",
    A100: "#f4ff81",
    A200: "#eeff41",
    A400: "#c6ff00",
    A700: "#aeea00"
};
var $f7675fc74ac5e412$export$2e2bcd8739ae039 = $f7675fc74ac5e412$var$lime;

});

parcelRegister("c14Eh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bf92f23cbff3a06$export$2e2bcd8739ae039; });
var $8bf92f23cbff3a06$var$yellow = {
    50: "#fffde7",
    100: "#fff9c4",
    200: "#fff59d",
    300: "#fff176",
    400: "#ffee58",
    500: "#ffeb3b",
    600: "#fdd835",
    700: "#fbc02d",
    800: "#f9a825",
    900: "#f57f17",
    A100: "#ffff8d",
    A200: "#ffff00",
    A400: "#ffea00",
    A700: "#ffd600"
};
var $8bf92f23cbff3a06$export$2e2bcd8739ae039 = $8bf92f23cbff3a06$var$yellow;

});

parcelRegister("dfW1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a69ae7fcf3ada44$export$2e2bcd8739ae039; });
var $9a69ae7fcf3ada44$var$amber = {
    50: "#fff8e1",
    100: "#ffecb3",
    200: "#ffe082",
    300: "#ffd54f",
    400: "#ffca28",
    500: "#ffc107",
    600: "#ffb300",
    700: "#ffa000",
    800: "#ff8f00",
    900: "#ff6f00",
    A100: "#ffe57f",
    A200: "#ffd740",
    A400: "#ffc400",
    A700: "#ffab00"
};
var $9a69ae7fcf3ada44$export$2e2bcd8739ae039 = $9a69ae7fcf3ada44$var$amber;

});

parcelRegister("ag7UR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $778189f5fd141f4e$export$2e2bcd8739ae039; });
var $778189f5fd141f4e$var$deepOrange = {
    50: "#fbe9e7",
    100: "#ffccbc",
    200: "#ffab91",
    300: "#ff8a65",
    400: "#ff7043",
    500: "#ff5722",
    600: "#f4511e",
    700: "#e64a19",
    800: "#d84315",
    900: "#bf360c",
    A100: "#ff9e80",
    A200: "#ff6e40",
    A400: "#ff3d00",
    A700: "#dd2c00"
};
var $778189f5fd141f4e$export$2e2bcd8739ae039 = $778189f5fd141f4e$var$deepOrange;

});

parcelRegister("dxE0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dbd63e5e6f8f5f6$export$2e2bcd8739ae039; });
var $9dbd63e5e6f8f5f6$var$brown = {
    50: "#efebe9",
    100: "#d7ccc8",
    200: "#bcaaa4",
    300: "#a1887f",
    400: "#8d6e63",
    500: "#795548",
    600: "#6d4c41",
    700: "#5d4037",
    800: "#4e342e",
    900: "#3e2723",
    A100: "#d7ccc8",
    A200: "#bcaaa4",
    A400: "#8d6e63",
    A700: "#5d4037"
};
var $9dbd63e5e6f8f5f6$export$2e2bcd8739ae039 = $9dbd63e5e6f8f5f6$var$brown;

});

parcelRegister("cpnft", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9089da8a8442b5b5$export$2e2bcd8739ae039; });
var $9089da8a8442b5b5$var$blueGrey = {
    50: "#eceff1",
    100: "#cfd8dc",
    200: "#b0bec5",
    300: "#90a4ae",
    400: "#78909c",
    500: "#607d8b",
    600: "#546e7a",
    700: "#455a64",
    800: "#37474f",
    900: "#263238",
    A100: "#cfd8dc",
    A200: "#b0bec5",
    A400: "#78909c",
    A700: "#455a64"
};
var $9089da8a8442b5b5$export$2e2bcd8739ae039 = $9089da8a8442b5b5$var$blueGrey;

});



parcelRegister("73wUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $523257b6a66effed$export$2e2bcd8739ae039; });

var $iuDcE = parcelRequire("iuDcE");
var $523257b6a66effed$export$2e2bcd8739ae039 = {
    h1: {
        color: (0, $iuDcE.default).text.primary,
        fontWeight: 500,
        fontSize: "35px",
        letterSpacing: "-0.24px",
        lineHeight: "40px"
    },
    h2: {
        color: (0, $iuDcE.default).text.primary,
        fontWeight: 500,
        fontSize: "29px",
        letterSpacing: "-0.24px",
        lineHeight: "32px"
    },
    h3: {
        color: (0, $iuDcE.default).text.primary,
        fontWeight: 500,
        fontSize: "24px",
        letterSpacing: "-0.06px",
        lineHeight: "28px"
    },
    h4: {
        color: (0, $iuDcE.default).text.primary,
        fontWeight: 500,
        fontSize: "20px",
        letterSpacing: "-0.06px",
        lineHeight: "24px"
    },
    h5: {
        color: (0, $iuDcE.default).text.primary,
        fontWeight: 500,
        fontSize: "16px",
        letterSpacing: "-0.05px",
        lineHeight: "20px"
    },
    h6: {
        color: (0, $iuDcE.default).text.primary,
        fontWeight: 500,
        fontSize: "14px",
        letterSpacing: "-0.05px",
        lineHeight: "20px"
    },
    subtitle1: {
        color: (0, $iuDcE.default).text.primary,
        fontSize: "16px",
        letterSpacing: "-0.05px",
        lineHeight: "25px"
    },
    subtitle2: {
        color: (0, $iuDcE.default).text.secondary,
        fontWeight: 400,
        fontSize: "14px",
        letterSpacing: "-0.05px",
        lineHeight: "21px"
    },
    body1: {
        color: (0, $iuDcE.default).text.primary,
        fontSize: "14px",
        letterSpacing: "-0.05px",
        lineHeight: "21px"
    },
    body2: {
        color: (0, $iuDcE.default).text.secondary,
        fontSize: "12px",
        letterSpacing: "-0.04px",
        lineHeight: "18px"
    },
    button: {
        color: (0, $iuDcE.default).text.primary,
        fontSize: "14px"
    },
    caption: {
        color: (0, $iuDcE.default).text.secondary,
        fontSize: "12px",
        letterSpacing: "0.33px",
        lineHeight: "13px"
    },
    overline: {
        color: (0, $iuDcE.default).text.secondary,
        fontSize: "11px",
        fontWeight: 500,
        letterSpacing: "0.33px",
        lineHeight: "13px"
    }
};

});

parcelRegister("1J3Ci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01373456f6ace849$export$2e2bcd8739ae039; });

var $eiHeI = parcelRequire("eiHeI");

var $iuDcE = parcelRequire("iuDcE");

var $73wUy = parcelRequire("73wUy");
const $01373456f6ace849$var$components = {
    // MuiButton: {
    //   styleOverrides: {
    //     contained: {
    //       boxShadow:
    //         '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    //       backgroundColor: '#FFFFFF'
    //     }
    //   }
    // },
    MuiIconButton: {
        styleOverrides: {
            root: {
                color: (0, $iuDcE.default).icon,
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.03)"
                }
            }
        }
    },
    MuiPaper: {
        styleOverrides: {
            elevation1: {
                boxShadow: "0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)"
            }
        }
    },
    MuiTableCell: {
        styleOverrides: {
            root: {
                ...(0, $73wUy.default).body1,
                borderBottom: `1px solid ${(0, $iuDcE.default).divider}`
            }
        }
    },
    MuiTableHead: {
        styleOverrides: {
            root: {
                backgroundColor: (0, $eiHeI).grey[50]
            }
        }
    },
    // MuiTableRow: {
    //   styleOverrides: {
    //     root: {
    //       '&.Mui-selected': {
    //         backgroundColor: palette.background.default
    //       },
    //       '&:hover': {
    //         backgroundColor: palette.background.default
    //       }
    //     }
    //   }
    // },
    MuiTypography: {
        styleOverrides: {
            gutterBottom: {
                marginBottom: 8
            }
        }
    }
};
var $01373456f6ace849$export$2e2bcd8739ae039 = $01373456f6ace849$var$components;

});
parcelRegister("eiHeI", function(module, exports) {

$parcel$export(module.exports, "common", function () { return (parcelRequire("52DDr")).default; });
$parcel$export(module.exports, "red", function () { return (parcelRequire("bziLn")).default; });
$parcel$export(module.exports, "pink", function () { return (parcelRequire("iZ8yI")).default; });
$parcel$export(module.exports, "purple", function () { return (parcelRequire("nC27X")).default; });
$parcel$export(module.exports, "deepPurple", function () { return (parcelRequire("3donh")).default; });
$parcel$export(module.exports, "indigo", function () { return (parcelRequire("g17re")).default; });
$parcel$export(module.exports, "blue", function () { return (parcelRequire("4hzoI")).default; });
$parcel$export(module.exports, "lightBlue", function () { return (parcelRequire("1XCqW")).default; });
$parcel$export(module.exports, "cyan", function () { return (parcelRequire("gR4wS")).default; });
$parcel$export(module.exports, "teal", function () { return (parcelRequire("9wkJv")).default; });
$parcel$export(module.exports, "green", function () { return (parcelRequire("3VzRO")).default; });
$parcel$export(module.exports, "lightGreen", function () { return (parcelRequire("brC0y")).default; });
$parcel$export(module.exports, "lime", function () { return (parcelRequire("11khf")).default; });
$parcel$export(module.exports, "yellow", function () { return (parcelRequire("iNW9U")).default; });
$parcel$export(module.exports, "amber", function () { return (parcelRequire("4BLLH")).default; });
$parcel$export(module.exports, "orange", function () { return (parcelRequire("eGNZP")).default; });
$parcel$export(module.exports, "deepOrange", function () { return (parcelRequire("1NKwr")).default; });
$parcel$export(module.exports, "brown", function () { return (parcelRequire("6DngJ")).default; });
$parcel$export(module.exports, "grey", function () { return (parcelRequire("dkL17")).default; });
$parcel$export(module.exports, "blueGrey", function () { return (parcelRequire("6kfks")).default; });

var $52DDr = parcelRequire("52DDr");

var $bziLn = parcelRequire("bziLn");

var $iZ8yI = parcelRequire("iZ8yI");

var $nC27X = parcelRequire("nC27X");

var $3donh = parcelRequire("3donh");

var $g17re = parcelRequire("g17re");

var $4hzoI = parcelRequire("4hzoI");

var $1XCqW = parcelRequire("1XCqW");

var $gR4wS = parcelRequire("gR4wS");

var $9wkJv = parcelRequire("9wkJv");

var $3VzRO = parcelRequire("3VzRO");

var $brC0y = parcelRequire("brC0y");

var $11khf = parcelRequire("11khf");

var $iNW9U = parcelRequire("iNW9U");

var $4BLLH = parcelRequire("4BLLH");

var $eGNZP = parcelRequire("eGNZP");

var $1NKwr = parcelRequire("1NKwr");

var $6DngJ = parcelRequire("6DngJ");

var $dkL17 = parcelRequire("dkL17");

var $6kfks = parcelRequire("6kfks");

});
parcelRegister("iZ8yI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd2490246a573f6b$export$2e2bcd8739ae039; });
const $dd2490246a573f6b$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $dd2490246a573f6b$export$2e2bcd8739ae039 = $dd2490246a573f6b$var$pink;

});

parcelRegister("3donh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25757e3e2870a5c6$export$2e2bcd8739ae039; });
const $25757e3e2870a5c6$var$deepPurple = {
    50: "#ede7f6",
    100: "#d1c4e9",
    200: "#b39ddb",
    300: "#9575cd",
    400: "#7e57c2",
    500: "#673ab7",
    600: "#5e35b1",
    700: "#512da8",
    800: "#4527a0",
    900: "#311b92",
    A100: "#b388ff",
    A200: "#7c4dff",
    A400: "#651fff",
    A700: "#6200ea"
};
var $25757e3e2870a5c6$export$2e2bcd8739ae039 = $25757e3e2870a5c6$var$deepPurple;

});

parcelRegister("g17re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba92826631e4aa1b$export$2e2bcd8739ae039; });
const $ba92826631e4aa1b$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $ba92826631e4aa1b$export$2e2bcd8739ae039 = $ba92826631e4aa1b$var$indigo;

});

parcelRegister("gR4wS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4551c03d8e167d3$export$2e2bcd8739ae039; });
const $c4551c03d8e167d3$var$cyan = {
    50: "#e0f7fa",
    100: "#b2ebf2",
    200: "#80deea",
    300: "#4dd0e1",
    400: "#26c6da",
    500: "#00bcd4",
    600: "#00acc1",
    700: "#0097a7",
    800: "#00838f",
    900: "#006064",
    A100: "#84ffff",
    A200: "#18ffff",
    A400: "#00e5ff",
    A700: "#00b8d4"
};
var $c4551c03d8e167d3$export$2e2bcd8739ae039 = $c4551c03d8e167d3$var$cyan;

});

parcelRegister("9wkJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ee72f5b75821c9b$export$2e2bcd8739ae039; });
const $6ee72f5b75821c9b$var$teal = {
    50: "#e0f2f1",
    100: "#b2dfdb",
    200: "#80cbc4",
    300: "#4db6ac",
    400: "#26a69a",
    500: "#009688",
    600: "#00897b",
    700: "#00796b",
    800: "#00695c",
    900: "#004d40",
    A100: "#a7ffeb",
    A200: "#64ffda",
    A400: "#1de9b6",
    A700: "#00bfa5"
};
var $6ee72f5b75821c9b$export$2e2bcd8739ae039 = $6ee72f5b75821c9b$var$teal;

});

parcelRegister("brC0y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $854fb2e659b3c299$export$2e2bcd8739ae039; });
const $854fb2e659b3c299$var$lightGreen = {
    50: "#f1f8e9",
    100: "#dcedc8",
    200: "#c5e1a5",
    300: "#aed581",
    400: "#9ccc65",
    500: "#8bc34a",
    600: "#7cb342",
    700: "#689f38",
    800: "#558b2f",
    900: "#33691e",
    A100: "#ccff90",
    A200: "#b2ff59",
    A400: "#76ff03",
    A700: "#64dd17"
};
var $854fb2e659b3c299$export$2e2bcd8739ae039 = $854fb2e659b3c299$var$lightGreen;

});

parcelRegister("11khf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0be59d11d1971bda$export$2e2bcd8739ae039; });
const $0be59d11d1971bda$var$lime = {
    50: "#f9fbe7",
    100: "#f0f4c3",
    200: "#e6ee9c",
    300: "#dce775",
    400: "#d4e157",
    500: "#cddc39",
    600: "#c0ca33",
    700: "#afb42b",
    800: "#9e9d24",
    900: "#827717",
    A100: "#f4ff81",
    A200: "#eeff41",
    A400: "#c6ff00",
    A700: "#aeea00"
};
var $0be59d11d1971bda$export$2e2bcd8739ae039 = $0be59d11d1971bda$var$lime;

});

parcelRegister("iNW9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db09eab49699adb9$export$2e2bcd8739ae039; });
const $db09eab49699adb9$var$yellow = {
    50: "#fffde7",
    100: "#fff9c4",
    200: "#fff59d",
    300: "#fff176",
    400: "#ffee58",
    500: "#ffeb3b",
    600: "#fdd835",
    700: "#fbc02d",
    800: "#f9a825",
    900: "#f57f17",
    A100: "#ffff8d",
    A200: "#ffff00",
    A400: "#ffea00",
    A700: "#ffd600"
};
var $db09eab49699adb9$export$2e2bcd8739ae039 = $db09eab49699adb9$var$yellow;

});

parcelRegister("4BLLH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35afabe784bb1caa$export$2e2bcd8739ae039; });
const $35afabe784bb1caa$var$amber = {
    50: "#fff8e1",
    100: "#ffecb3",
    200: "#ffe082",
    300: "#ffd54f",
    400: "#ffca28",
    500: "#ffc107",
    600: "#ffb300",
    700: "#ffa000",
    800: "#ff8f00",
    900: "#ff6f00",
    A100: "#ffe57f",
    A200: "#ffd740",
    A400: "#ffc400",
    A700: "#ffab00"
};
var $35afabe784bb1caa$export$2e2bcd8739ae039 = $35afabe784bb1caa$var$amber;

});

parcelRegister("1NKwr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14fe7469cfda9bcf$export$2e2bcd8739ae039; });
const $14fe7469cfda9bcf$var$deepOrange = {
    50: "#fbe9e7",
    100: "#ffccbc",
    200: "#ffab91",
    300: "#ff8a65",
    400: "#ff7043",
    500: "#ff5722",
    600: "#f4511e",
    700: "#e64a19",
    800: "#d84315",
    900: "#bf360c",
    A100: "#ff9e80",
    A200: "#ff6e40",
    A400: "#ff3d00",
    A700: "#dd2c00"
};
var $14fe7469cfda9bcf$export$2e2bcd8739ae039 = $14fe7469cfda9bcf$var$deepOrange;

});

parcelRegister("6DngJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d486f53aa9e0afc$export$2e2bcd8739ae039; });
const $4d486f53aa9e0afc$var$brown = {
    50: "#efebe9",
    100: "#d7ccc8",
    200: "#bcaaa4",
    300: "#a1887f",
    400: "#8d6e63",
    500: "#795548",
    600: "#6d4c41",
    700: "#5d4037",
    800: "#4e342e",
    900: "#3e2723",
    A100: "#d7ccc8",
    A200: "#bcaaa4",
    A400: "#8d6e63",
    A700: "#5d4037"
};
var $4d486f53aa9e0afc$export$2e2bcd8739ae039 = $4d486f53aa9e0afc$var$brown;

});

parcelRegister("6kfks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49b0805d8c475e12$export$2e2bcd8739ae039; });
const $49b0805d8c475e12$var$blueGrey = {
    50: "#eceff1",
    100: "#cfd8dc",
    200: "#b0bec5",
    300: "#90a4ae",
    400: "#78909c",
    500: "#607d8b",
    600: "#546e7a",
    700: "#455a64",
    800: "#37474f",
    900: "#263238",
    A100: "#cfd8dc",
    A200: "#b0bec5",
    A400: "#78909c",
    A700: "#455a64"
};
var $49b0805d8c475e12$export$2e2bcd8739ae039 = $49b0805d8c475e12$var$blueGrey;

});



parcelRegister("dEHhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f1095bf8ce563a5$export$2e2bcd8739ae039; });

var $6QKPY = parcelRequire("6QKPY");

var $4SM0i = parcelRequire("4SM0i");

var $1Xa11 = parcelRequire("1Xa11");

var $ifIX9 = parcelRequire("ifIX9");

var $irgqS = parcelRequire("irgqS");

var $fIeiB = parcelRequire("fIeiB");
var $9f1095bf8ce563a5$export$2e2bcd8739ae039 = {
    MuiButton: $6QKPY.default,
    MuiIconButton: $4SM0i.default,
    MuiPaper: $1Xa11.default,
    MuiTableCell: $ifIX9.default,
    MuiTableHead: $irgqS.default,
    MuiTypography: $fIeiB.default
};

});
parcelRegister("6QKPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fcbee5602d8d06b$export$2e2bcd8739ae039; });
var $4fcbee5602d8d06b$export$2e2bcd8739ae039 = {
    contained: {
        boxShadow: "0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)",
        backgroundColor: "#FFFFFF"
    }
};

});

parcelRegister("4SM0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e17124df05a6ac$export$2e2bcd8739ae039; });

var $iuDcE = parcelRequire("iuDcE");
var $38e17124df05a6ac$export$2e2bcd8739ae039 = {
    root: {
        color: (0, $iuDcE.default).icon,
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.03)"
        }
    }
};

});

parcelRegister("1Xa11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16c311fdd3a02fb9$export$2e2bcd8739ae039; });
var $16c311fdd3a02fb9$export$2e2bcd8739ae039 = {
    elevation1: {
        boxShadow: "0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)"
    }
};

});

parcelRegister("ifIX9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d49c7f6e92eeb7db$export$2e2bcd8739ae039; });

var $iuDcE = parcelRequire("iuDcE");

var $73wUy = parcelRequire("73wUy");
var $d49c7f6e92eeb7db$export$2e2bcd8739ae039 = {
    root: {
        ...(0, $73wUy.default).body1,
        borderBottom: `1px solid ${(0, $iuDcE.default).divider}`
    }
};

});

parcelRegister("irgqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6c77ec5e728c347$export$2e2bcd8739ae039; });

var $lRVfF = parcelRequire("lRVfF");
var $d6c77ec5e728c347$export$2e2bcd8739ae039 = {
    root: {
        backgroundColor: (0, $lRVfF).grey[50]
    }
};

});

parcelRegister("fIeiB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7060e8fbd243a91$export$2e2bcd8739ae039; });
var $b7060e8fbd243a91$export$2e2bcd8739ae039 = {
    gutterBottom: {
        marginBottom: 8
    }
};

});



parcelRegister("cVxYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $969529ef1e7f0467$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $63Wik = parcelRequire("63Wik");

var $f1jnN = parcelRequire("f1jnN");

var $eaNQk = parcelRequire("eaNQk");
const $969529ef1e7f0467$var$useStyles = (0, $eaNQk.default)((theme)=>({
        backdrop: {
            zIndex: theme.zIndex.modal + 10,
            color: "#fff"
        }
    }));
const $969529ef1e7f0467$var$LoadingSpinner = (props)=>{
    const classes = $969529ef1e7f0467$var$useStyles();
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f1jnN.default), {
        className: classes.backdrop,
        open: props.open,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $63Wik.default), {
            color: "inherit"
        })
    });
};
var $969529ef1e7f0467$export$2e2bcd8739ae039 = $969529ef1e7f0467$var$LoadingSpinner;

});
parcelRegister("63Wik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46a03dfd0965e30a$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");
var $46a03dfd0965e30a$var$SIZE = 44;
var $46a03dfd0965e30a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-block"
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: "$circular-rotate 1.4s linear infinite"
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: "block" // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: "currentColor" // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px" // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        "@keyframes circular-rotate": {
            "0%": {
                // Fix IE 11 wobbly
                transformOrigin: "50% 50%"
            },
            "100%": {
                transform: "rotate(360deg)"
            }
        },
        "@keyframes circular-dash": {
            "0%": {
                strokeDasharray: "1px, 200px",
                strokeDashoffset: "0px"
            },
            "50%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-15px"
            },
            "100%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-125px"
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: "none"
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $46a03dfd0965e30a$var$CircularProgress = /*#__PURE__*/ $dgG1Y.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate" || variant === "static") {
        var circumference = 2 * Math.PI * (($46a03dfd0965e30a$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $bdWPY.default)(color))], {
            "determinate": classes.determinate,
            "indeterminate": classes.indeterminate,
            "static": classes.static
        }[variant]),
        style: (0, $bh1oa.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $dgG1Y.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($46a03dfd0965e30a$var$SIZE / 2, " ").concat($46a03dfd0965e30a$var$SIZE / 2, " ").concat($46a03dfd0965e30a$var$SIZE, " ").concat($46a03dfd0965e30a$var$SIZE)
    }, /*#__PURE__*/ $dgG1Y.createElement("circle", {
        className: (0, $cXVHi.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            "determinate": classes.circleDeterminate,
            "indeterminate": classes.circleIndeterminate,
            "static": classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $46a03dfd0965e30a$var$SIZE,
        cy: $46a03dfd0965e30a$var$SIZE,
        r: ($46a03dfd0965e30a$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $46a03dfd0965e30a$export$2e2bcd8739ae039 = (0, $7xfqK.default)($46a03dfd0965e30a$export$9dd6ff9ea0189349, {
    name: "MuiCircularProgress",
    flip: false
})($46a03dfd0965e30a$var$CircularProgress);

});
parcelRegister("cXVHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9707c03613e47d66$export$2e2bcd8739ae039; });
function $9707c03613e47d66$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $9707c03613e47d66$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $9707c03613e47d66$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $9707c03613e47d66$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $9707c03613e47d66$export$2e2bcd8739ae039 = $9707c03613e47d66$export$4f5d2d50c9deca37;

});

parcelRegister("7xfqK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57c795a624a706e1$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $3wT7a = parcelRequire("3wT7a");

var $jGlhj = parcelRequire("jGlhj");
function $57c795a624a706e1$var$withStyles(stylesOrCreator, options) {
    return (0, $3wT7a.default)(stylesOrCreator, (0, $bh1oa.default)({
        defaultTheme: (0, $jGlhj.default)
    }, options));
}
var $57c795a624a706e1$export$2e2bcd8739ae039 = $57c795a624a706e1$var$withStyles;

});
parcelRegister("3wT7a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $291f1ce35c39ba58$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $bUYS0 = parcelRequire("bUYS0");


var $h2Xtr = parcelRequire("h2Xtr");

var $2RFFw = parcelRequire("2RFFw");

var $57IP6 = parcelRequire("57IP6");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $291f1ce35c39ba58$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $gZz4Z.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $h2Xtr.default)(stylesOrCreator, (0, $bh1oa.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $gZz4Z.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $bh1oa.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $57IP6.default)() || defaultTheme;
                if (name) more = (0, $2RFFw.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement(Component, (0, $bh1oa.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bUYS0)))(WithStyles, Component);
        return WithStyles;
    };
};
var $291f1ce35c39ba58$export$2e2bcd8739ae039 = $291f1ce35c39ba58$var$withStyles;

});
parcelRegister("h2Xtr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c690c1d494531375$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");

var $7C9HG = parcelRequire("7C9HG");

var $l1BQr = parcelRequire("l1BQr");

var $aA0VM = parcelRequire("aA0VM");

var $57IP6 = parcelRequire("57IP6");

var $dkH96 = parcelRequire("dkH96");

var $evIEs = parcelRequire("evIEs");

var $dcria = parcelRequire("dcria");

var $9EChL = parcelRequire("9EChL");
function $c690c1d494531375$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $l1BQr.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $c690c1d494531375$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $aA0VM.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $aA0VM.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $bh1oa.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $aA0VM.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $bh1oa.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $aA0VM.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $7C9HG.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $bh1oa.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $l1BQr.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $c690c1d494531375$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $c690c1d494531375$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $aA0VM.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $aA0VM.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $c690c1d494531375$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $c690c1d494531375$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $9EChL.default) : _options$defaultTheme, stylesOptions2 = (0, $gZz4Z.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $dcria.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $evIEs.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $57IP6.default)() || defaultTheme;
        var stylesOptions = (0, $bh1oa.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useContext((0, $dkH96.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useRef();
        $c690c1d494531375$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $c690c1d494531375$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $c690c1d494531375$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useEffect(function() {
            if (shouldUpdate.current) $c690c1d494531375$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $c690c1d494531375$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("7C9HG", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $bh1oa = parcelRequire("bh1oa");

var $cT6U4 = parcelRequire("cT6U4");

var $45LKI = parcelRequire("45LKI");

var $5ywZr = parcelRequire("5ywZr");

var $2BhAF = parcelRequire("2BhAF");

var $fONHp = parcelRequire("fONHp");

var $gppKd = parcelRequire("gppKd");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $2BhAF.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $fONHp.default)((0, $fONHp.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $bh1oa.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $5ywZr.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $bh1oa.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $bh1oa.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $bh1oa.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $2BhAF.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $bh1oa.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $bh1oa.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $bh1oa.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $bh1oa.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $gppKd.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $5ywZr.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $cT6U4.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $bh1oa.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $bh1oa.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $bh1oa.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $45LKI.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $45LKI.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $5ywZr.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $58b39bf0f9ef94ed$export$2e2bcd8739ae039 = index;

});
parcelRegister("cT6U4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $961ff9f8a7409300$export$2e2bcd8739ae039; });
var $961ff9f8a7409300$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $961ff9f8a7409300$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $961ff9f8a7409300$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $961ff9f8a7409300$var$_typeof(document)) === "object" && document.nodeType === 9;
var $961ff9f8a7409300$export$2e2bcd8739ae039 = $961ff9f8a7409300$export$4e09c449d6c407f7;

});

parcelRegister("45LKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2facabb83a392fe9$export$2e2bcd8739ae039; });
var $2facabb83a392fe9$var$isProduction = true;
function $2facabb83a392fe9$var$warning(condition, message) {
    if (!$2facabb83a392fe9$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $2facabb83a392fe9$export$2e2bcd8739ae039 = $2facabb83a392fe9$var$warning;

});

parcelRegister("5ywZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40b9b7da852ed404$export$2e2bcd8739ae039; });

var $ai0kl = parcelRequire("ai0kl");
function $40b9b7da852ed404$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $ai0kl.default)(o.key), o);
    }
}
function $40b9b7da852ed404$export$2e2bcd8739ae039(e, r, t) {
    return r && $40b9b7da852ed404$var$_defineProperties(e.prototype, r), t && $40b9b7da852ed404$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("2BhAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e4cae8969b8b3ab$export$2e2bcd8739ae039; });

var $3nhMH = parcelRequire("3nhMH");
function $1e4cae8969b8b3ab$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3nhMH.default)(t, o);
}

});
parcelRegister("3nhMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $275150b0bc2a13ed$export$2e2bcd8739ae039; });
function $275150b0bc2a13ed$export$2e2bcd8739ae039(t, e) {
    return $275150b0bc2a13ed$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $275150b0bc2a13ed$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("fONHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b84213bb50ed3474$export$2e2bcd8739ae039; });
function $b84213bb50ed3474$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("l1BQr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4e70c24005ccda7$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

function $f4e70c24005ccda7$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $bh1oa.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("aA0VM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b3dfd08eb8464cb$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $7b3dfd08eb8464cb$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $7b3dfd08eb8464cb$export$2e2bcd8739ae039 = $7b3dfd08eb8464cb$var$multiKeyStore;

});

parcelRegister("dkH96", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $9b4e9c7ce0c92626$export$f4de434b269fe487; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");



var $l2ezn = parcelRequire("l2ezn");

var $7C9HG = parcelRequire("7C9HG");

var $ghiLB = parcelRequire("ghiLB");
var $9b4e9c7ce0c92626$var$jss = (0, $7C9HG.create)((0, $ghiLB.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $9b4e9c7ce0c92626$var$generateClassName = (0, $l2ezn.default)(); // Exported for test purposes
var $9b4e9c7ce0c92626$export$70a8aea9ff58d1cd = new Map();
var $9b4e9c7ce0c92626$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $9b4e9c7ce0c92626$var$generateClassName,
    jss: $9b4e9c7ce0c92626$var$jss,
    sheetsCache: null,
    sheetsManager: $9b4e9c7ce0c92626$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $9b4e9c7ce0c92626$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createContext($9b4e9c7ce0c92626$var$defaultOptions);
var $9b4e9c7ce0c92626$var$injectFirstNode;
function $9b4e9c7ce0c92626$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $gZz4Z.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useContext($9b4e9c7ce0c92626$export$f4de434b269fe487);
    var context = (0, $bh1oa.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$9b4e9c7ce0c92626$var$injectFirstNode) {
            var head = document.head;
            $9b4e9c7ce0c92626$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($9b4e9c7ce0c92626$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $7C9HG.create)({
            plugins: (0, $ghiLB.default)().plugins,
            insertionPoint: $9b4e9c7ce0c92626$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement($9b4e9c7ce0c92626$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("l2ezn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f505161aea817243$export$2e2bcd8739ae039; });

var $gVjjv = parcelRequire("gVjjv");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $f505161aea817243$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $f505161aea817243$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($f505161aea817243$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $gVjjv.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("gVjjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c520f37c22d8b258$export$2e2bcd8739ae039; });
var $c520f37c22d8b258$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $c520f37c22d8b258$export$2e2bcd8739ae039 = $c520f37c22d8b258$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("ghiLB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $030eea7e21208de0$export$2e2bcd8739ae039; });

var $lttFr = parcelRequire("lttFr");

var $h165c = parcelRequire("h165c");

var $3i0cM = parcelRequire("3i0cM");

var $5DhPx = parcelRequire("5DhPx");

var $nx9pG = parcelRequire("nx9pG");

var $e1jvw = parcelRequire("e1jvw");

var $eDu2M = parcelRequire("eDu2M");
function $030eea7e21208de0$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $lttFr.default)(),
            (0, $h165c.default)(),
            (0, $3i0cM.default)(),
            (0, $5DhPx.default)(),
            (0, $nx9pG.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $e1jvw.default)(),
            (0, $eDu2M.default)()
        ]
    };
}

});
parcelRegister("lttFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2351b79fe8b897$export$2e2bcd8739ae039; });


var $7C9HG = parcelRequire("7C9HG");
var $fa2351b79fe8b897$var$now = Date.now();
var $fa2351b79fe8b897$var$fnValuesNs = "fnValues" + $fa2351b79fe8b897$var$now;
var $fa2351b79fe8b897$var$fnRuleNs = "fnStyle" + ++$fa2351b79fe8b897$var$now;
var $fa2351b79fe8b897$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $7C9HG.createRule)(name, {}, options);
            rule[$fa2351b79fe8b897$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($fa2351b79fe8b897$var$fnValuesNs in rule || $fa2351b79fe8b897$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$fa2351b79fe8b897$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$fa2351b79fe8b897$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$fa2351b79fe8b897$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $fa2351b79fe8b897$export$2e2bcd8739ae039 = $fa2351b79fe8b897$var$functionPlugin;

});

parcelRegister("h165c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6373f9d67bb02aa$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $7C9HG = parcelRequire("7C9HG");
var $c6373f9d67bb02aa$var$at = "@global";
var $c6373f9d67bb02aa$var$atPrefix = "@global ";
var $c6373f9d67bb02aa$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $c6373f9d67bb02aa$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $7C9HG.RuleList)((0, $bh1oa.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $c6373f9d67bb02aa$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $c6373f9d67bb02aa$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($c6373f9d67bb02aa$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $bh1oa.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $c6373f9d67bb02aa$var$separatorRegExp = /\s*,\s*/g;
function $c6373f9d67bb02aa$var$addScope(selector, scope) {
    var parts = selector.split($c6373f9d67bb02aa$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $c6373f9d67bb02aa$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$c6373f9d67bb02aa$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $bh1oa.default)({}, options, {
        selector: $c6373f9d67bb02aa$var$addScope(name, rule.selector)
    }));
    delete style[$c6373f9d67bb02aa$var$at];
}
function $c6373f9d67bb02aa$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $c6373f9d67bb02aa$var$at.length) !== $c6373f9d67bb02aa$var$at) continue;
        var selector = $c6373f9d67bb02aa$var$addScope(prop.substr($c6373f9d67bb02aa$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $bh1oa.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $c6373f9d67bb02aa$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $c6373f9d67bb02aa$var$at) return new $c6373f9d67bb02aa$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $c6373f9d67bb02aa$var$atPrefix.length) === $c6373f9d67bb02aa$var$atPrefix) return new $c6373f9d67bb02aa$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $c6373f9d67bb02aa$var$handleNestedGlobalContainerRule(rule, sheet);
        $c6373f9d67bb02aa$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $c6373f9d67bb02aa$export$2e2bcd8739ae039 = $c6373f9d67bb02aa$var$jssGlobal;

});

parcelRegister("3i0cM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $265336490eb4df59$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $265336490eb4df59$var$separatorRegExp = /\s*,\s*/g;
var $265336490eb4df59$var$parentRegExp = /&/g;
var $265336490eb4df59$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $265336490eb4df59$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($265336490eb4df59$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($265336490eb4df59$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($265336490eb4df59$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $bh1oa.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $bh1oa.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($265336490eb4df59$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $bh1oa.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $bh1oa.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $265336490eb4df59$export$2e2bcd8739ae039 = $265336490eb4df59$var$jssNested;

});

parcelRegister("5DhPx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $419e6cfc171df8c6$export$2e2bcd8739ae039; });

var $228JG = parcelRequire("228JG");
/**
 * Convert camel cased property names to dash separated.
 */ function $419e6cfc171df8c6$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $228JG.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($419e6cfc171df8c6$var$convertCase);
        else converted.fallbacks = $419e6cfc171df8c6$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $419e6cfc171df8c6$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $419e6cfc171df8c6$var$convertCase(style[index]);
            return style;
        }
        return $419e6cfc171df8c6$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $228JG.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $419e6cfc171df8c6$export$2e2bcd8739ae039 = $419e6cfc171df8c6$var$camelCase;

});
parcelRegister("228JG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17b28b67678384df$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $17b28b67678384df$var$uppercasePattern = /[A-Z]/g;
var $17b28b67678384df$var$msPattern = /^ms-/;
var $17b28b67678384df$var$cache = {};
function $17b28b67678384df$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $17b28b67678384df$var$hyphenateStyleName(name) {
    if ($17b28b67678384df$var$cache.hasOwnProperty(name)) return $17b28b67678384df$var$cache[name];
    var hName = name.replace($17b28b67678384df$var$uppercasePattern, $17b28b67678384df$var$toHyphenLower);
    return $17b28b67678384df$var$cache[name] = $17b28b67678384df$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $17b28b67678384df$export$2e2bcd8739ae039 = $17b28b67678384df$var$hyphenateStyleName;

});


parcelRegister("nx9pG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $046bdd29120940c0$export$2e2bcd8739ae039; });

var $7C9HG = parcelRequire("7C9HG");
var $046bdd29120940c0$var$px = (0, $7C9HG.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $046bdd29120940c0$var$ms = (0, $7C9HG.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $046bdd29120940c0$var$percent = (0, $7C9HG.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $046bdd29120940c0$var$defaultUnits = {
    // Animation properties
    "animation-delay": $046bdd29120940c0$var$ms,
    "animation-duration": $046bdd29120940c0$var$ms,
    // Background properties
    "background-position": $046bdd29120940c0$var$px,
    "background-position-x": $046bdd29120940c0$var$px,
    "background-position-y": $046bdd29120940c0$var$px,
    "background-size": $046bdd29120940c0$var$px,
    // Border Properties
    border: $046bdd29120940c0$var$px,
    "border-bottom": $046bdd29120940c0$var$px,
    "border-bottom-left-radius": $046bdd29120940c0$var$px,
    "border-bottom-right-radius": $046bdd29120940c0$var$px,
    "border-bottom-width": $046bdd29120940c0$var$px,
    "border-left": $046bdd29120940c0$var$px,
    "border-left-width": $046bdd29120940c0$var$px,
    "border-radius": $046bdd29120940c0$var$px,
    "border-right": $046bdd29120940c0$var$px,
    "border-right-width": $046bdd29120940c0$var$px,
    "border-top": $046bdd29120940c0$var$px,
    "border-top-left-radius": $046bdd29120940c0$var$px,
    "border-top-right-radius": $046bdd29120940c0$var$px,
    "border-top-width": $046bdd29120940c0$var$px,
    "border-width": $046bdd29120940c0$var$px,
    "border-block": $046bdd29120940c0$var$px,
    "border-block-end": $046bdd29120940c0$var$px,
    "border-block-end-width": $046bdd29120940c0$var$px,
    "border-block-start": $046bdd29120940c0$var$px,
    "border-block-start-width": $046bdd29120940c0$var$px,
    "border-block-width": $046bdd29120940c0$var$px,
    "border-inline": $046bdd29120940c0$var$px,
    "border-inline-end": $046bdd29120940c0$var$px,
    "border-inline-end-width": $046bdd29120940c0$var$px,
    "border-inline-start": $046bdd29120940c0$var$px,
    "border-inline-start-width": $046bdd29120940c0$var$px,
    "border-inline-width": $046bdd29120940c0$var$px,
    "border-start-start-radius": $046bdd29120940c0$var$px,
    "border-start-end-radius": $046bdd29120940c0$var$px,
    "border-end-start-radius": $046bdd29120940c0$var$px,
    "border-end-end-radius": $046bdd29120940c0$var$px,
    // Margin properties
    margin: $046bdd29120940c0$var$px,
    "margin-bottom": $046bdd29120940c0$var$px,
    "margin-left": $046bdd29120940c0$var$px,
    "margin-right": $046bdd29120940c0$var$px,
    "margin-top": $046bdd29120940c0$var$px,
    "margin-block": $046bdd29120940c0$var$px,
    "margin-block-end": $046bdd29120940c0$var$px,
    "margin-block-start": $046bdd29120940c0$var$px,
    "margin-inline": $046bdd29120940c0$var$px,
    "margin-inline-end": $046bdd29120940c0$var$px,
    "margin-inline-start": $046bdd29120940c0$var$px,
    // Padding properties
    padding: $046bdd29120940c0$var$px,
    "padding-bottom": $046bdd29120940c0$var$px,
    "padding-left": $046bdd29120940c0$var$px,
    "padding-right": $046bdd29120940c0$var$px,
    "padding-top": $046bdd29120940c0$var$px,
    "padding-block": $046bdd29120940c0$var$px,
    "padding-block-end": $046bdd29120940c0$var$px,
    "padding-block-start": $046bdd29120940c0$var$px,
    "padding-inline": $046bdd29120940c0$var$px,
    "padding-inline-end": $046bdd29120940c0$var$px,
    "padding-inline-start": $046bdd29120940c0$var$px,
    // Mask properties
    "mask-position-x": $046bdd29120940c0$var$px,
    "mask-position-y": $046bdd29120940c0$var$px,
    "mask-size": $046bdd29120940c0$var$px,
    // Width and height properties
    height: $046bdd29120940c0$var$px,
    width: $046bdd29120940c0$var$px,
    "min-height": $046bdd29120940c0$var$px,
    "max-height": $046bdd29120940c0$var$px,
    "min-width": $046bdd29120940c0$var$px,
    "max-width": $046bdd29120940c0$var$px,
    // Position properties
    bottom: $046bdd29120940c0$var$px,
    left: $046bdd29120940c0$var$px,
    top: $046bdd29120940c0$var$px,
    right: $046bdd29120940c0$var$px,
    inset: $046bdd29120940c0$var$px,
    "inset-block": $046bdd29120940c0$var$px,
    "inset-block-end": $046bdd29120940c0$var$px,
    "inset-block-start": $046bdd29120940c0$var$px,
    "inset-inline": $046bdd29120940c0$var$px,
    "inset-inline-end": $046bdd29120940c0$var$px,
    "inset-inline-start": $046bdd29120940c0$var$px,
    // Shadow properties
    "box-shadow": $046bdd29120940c0$var$px,
    "text-shadow": $046bdd29120940c0$var$px,
    // Column properties
    "column-gap": $046bdd29120940c0$var$px,
    "column-rule": $046bdd29120940c0$var$px,
    "column-rule-width": $046bdd29120940c0$var$px,
    "column-width": $046bdd29120940c0$var$px,
    // Font and text properties
    "font-size": $046bdd29120940c0$var$px,
    "font-size-delta": $046bdd29120940c0$var$px,
    "letter-spacing": $046bdd29120940c0$var$px,
    "text-decoration-thickness": $046bdd29120940c0$var$px,
    "text-indent": $046bdd29120940c0$var$px,
    "text-stroke": $046bdd29120940c0$var$px,
    "text-stroke-width": $046bdd29120940c0$var$px,
    "word-spacing": $046bdd29120940c0$var$px,
    // Motion properties
    motion: $046bdd29120940c0$var$px,
    "motion-offset": $046bdd29120940c0$var$px,
    // Outline properties
    outline: $046bdd29120940c0$var$px,
    "outline-offset": $046bdd29120940c0$var$px,
    "outline-width": $046bdd29120940c0$var$px,
    // Perspective properties
    perspective: $046bdd29120940c0$var$px,
    "perspective-origin-x": $046bdd29120940c0$var$percent,
    "perspective-origin-y": $046bdd29120940c0$var$percent,
    // Transform properties
    "transform-origin": $046bdd29120940c0$var$percent,
    "transform-origin-x": $046bdd29120940c0$var$percent,
    "transform-origin-y": $046bdd29120940c0$var$percent,
    "transform-origin-z": $046bdd29120940c0$var$percent,
    // Transition properties
    "transition-delay": $046bdd29120940c0$var$ms,
    "transition-duration": $046bdd29120940c0$var$ms,
    // Alignment properties
    "vertical-align": $046bdd29120940c0$var$px,
    "flex-basis": $046bdd29120940c0$var$px,
    // Some random properties
    "shape-margin": $046bdd29120940c0$var$px,
    size: $046bdd29120940c0$var$px,
    gap: $046bdd29120940c0$var$px,
    // Grid properties
    grid: $046bdd29120940c0$var$px,
    "grid-gap": $046bdd29120940c0$var$px,
    "row-gap": $046bdd29120940c0$var$px,
    "grid-row-gap": $046bdd29120940c0$var$px,
    "grid-column-gap": $046bdd29120940c0$var$px,
    "grid-template-rows": $046bdd29120940c0$var$px,
    "grid-template-columns": $046bdd29120940c0$var$px,
    "grid-auto-rows": $046bdd29120940c0$var$px,
    "grid-auto-columns": $046bdd29120940c0$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $046bdd29120940c0$var$px,
    "box-shadow-y": $046bdd29120940c0$var$px,
    "box-shadow-blur": $046bdd29120940c0$var$px,
    "box-shadow-spread": $046bdd29120940c0$var$px,
    "font-line-height": $046bdd29120940c0$var$px,
    "text-shadow-x": $046bdd29120940c0$var$px,
    "text-shadow-y": $046bdd29120940c0$var$px,
    "text-shadow-blur": $046bdd29120940c0$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $046bdd29120940c0$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $046bdd29120940c0$var$units = $046bdd29120940c0$var$addCamelCasedVersion($046bdd29120940c0$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $046bdd29120940c0$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $046bdd29120940c0$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $046bdd29120940c0$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $046bdd29120940c0$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $046bdd29120940c0$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $046bdd29120940c0$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $046bdd29120940c0$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $046bdd29120940c0$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $046bdd29120940c0$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $046bdd29120940c0$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $046bdd29120940c0$export$2e2bcd8739ae039 = $046bdd29120940c0$var$defaultUnit;

});

parcelRegister("e1jvw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3504a77a7b6c09d$export$2e2bcd8739ae039; });

var $mgPKS = parcelRequire("mgPKS");

var $7C9HG = parcelRequire("7C9HG");
/**
 * Add vendor prefix to a property name when needed.
 */ function $a3504a77a7b6c09d$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $mgPKS.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $mgPKS.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $mgPKS.supportedValue)(supportedProp, (0, $7C9HG.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $mgPKS.supportedValue)(prop, (0, $7C9HG.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $a3504a77a7b6c09d$export$2e2bcd8739ae039 = $a3504a77a7b6c09d$var$jssVendorPrefixer;

});
parcelRegister("mgPKS", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $042f1d05d630f801$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $042f1d05d630f801$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $042f1d05d630f801$export$511766124059c277; });

var $cT6U4 = parcelRequire("cT6U4");

var $foPig = parcelRequire("foPig");
// Export javascript style and css style vendor prefixes.
var $042f1d05d630f801$var$js = "";
var $042f1d05d630f801$var$css = "";
var $042f1d05d630f801$var$vendor = "";
var $042f1d05d630f801$var$browser = "";
var $042f1d05d630f801$var$isTouch = (0, $cT6U4.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $cT6U4.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $042f1d05d630f801$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $042f1d05d630f801$var$_document$createEleme = document.createElement("p"), $042f1d05d630f801$var$style = $042f1d05d630f801$var$_document$createEleme.style;
    var $042f1d05d630f801$var$testProp = "Transform";
    for(var $042f1d05d630f801$var$key in $042f1d05d630f801$var$jsCssMap)if ($042f1d05d630f801$var$key + $042f1d05d630f801$var$testProp in $042f1d05d630f801$var$style) {
        $042f1d05d630f801$var$js = $042f1d05d630f801$var$key;
        $042f1d05d630f801$var$css = $042f1d05d630f801$var$jsCssMap[$042f1d05d630f801$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($042f1d05d630f801$var$js === "Webkit" && "msHyphens" in $042f1d05d630f801$var$style) {
        $042f1d05d630f801$var$js = "ms";
        $042f1d05d630f801$var$css = $042f1d05d630f801$var$jsCssMap.ms;
        $042f1d05d630f801$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($042f1d05d630f801$var$js === "Webkit" && "-apple-trailing-word" in $042f1d05d630f801$var$style) $042f1d05d630f801$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $042f1d05d630f801$export$82e9f45cca5ba907 = {
    js: $042f1d05d630f801$var$js,
    css: $042f1d05d630f801$var$css,
    vendor: $042f1d05d630f801$var$vendor,
    browser: $042f1d05d630f801$var$browser,
    isTouch: $042f1d05d630f801$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $042f1d05d630f801$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $042f1d05d630f801$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $042f1d05d630f801$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $042f1d05d630f801$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Webkit") return $042f1d05d630f801$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $042f1d05d630f801$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $042f1d05d630f801$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $042f1d05d630f801$var$camelize(str) {
    return str.replace($042f1d05d630f801$var$regExp, $042f1d05d630f801$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $042f1d05d630f801$var$pascalize(str) {
    return $042f1d05d630f801$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $042f1d05d630f801$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($042f1d05d630f801$var$camelize(longhand) in style) return prop;
            if ($042f1d05d630f801$export$82e9f45cca5ba907.js + $042f1d05d630f801$var$pascalize(longhand) in style) return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $042f1d05d630f801$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.vendor === "apple" && !$042f1d05d630f801$export$82e9f45cca5ba907.isTouch) return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $042f1d05d630f801$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $042f1d05d630f801$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $042f1d05d630f801$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Webkit" || $042f1d05d630f801$export$82e9f45cca5ba907.js === "ms" && $042f1d05d630f801$export$82e9f45cca5ba907.browser !== "edge") return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $042f1d05d630f801$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Moz" || $042f1d05d630f801$export$82e9f45cca5ba907.js === "ms" || $042f1d05d630f801$export$82e9f45cca5ba907.vendor === "apple") return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $042f1d05d630f801$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $042f1d05d630f801$var$pascalize(prop);
            return jsProp in style ? $042f1d05d630f801$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $042f1d05d630f801$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $042f1d05d630f801$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $042f1d05d630f801$export$82e9f45cca5ba907.js + $042f1d05d630f801$var$pascalize(newProp) in style ? $042f1d05d630f801$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $042f1d05d630f801$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $042f1d05d630f801$var$camelize(prop) in style ? prop : false;
    }
};
var $042f1d05d630f801$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $042f1d05d630f801$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js + pascalized in style) return $042f1d05d630f801$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $042f1d05d630f801$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "ms") return "" + $042f1d05d630f801$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $042f1d05d630f801$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($042f1d05d630f801$export$82e9f45cca5ba907.js === "ms") return $042f1d05d630f801$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $042f1d05d630f801$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $042f1d05d630f801$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $042f1d05d630f801$var$propMap[prop];
        if (!newProp) return false;
        return $042f1d05d630f801$export$82e9f45cca5ba907.js + $042f1d05d630f801$var$pascalize(newProp) in style ? $042f1d05d630f801$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $042f1d05d630f801$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $042f1d05d630f801$var$propKeys = Object.keys($042f1d05d630f801$var$propMap$1);
var $042f1d05d630f801$var$prefixCss = function prefixCss(p) {
    return $042f1d05d630f801$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $042f1d05d630f801$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($042f1d05d630f801$var$propKeys.indexOf(prop) > -1) {
            var newProp = $042f1d05d630f801$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $042f1d05d630f801$export$82e9f45cca5ba907.js + $042f1d05d630f801$var$pascalize(newProp) in style ? $042f1d05d630f801$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($042f1d05d630f801$export$82e9f45cca5ba907.js + $042f1d05d630f801$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($042f1d05d630f801$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $042f1d05d630f801$var$plugins = [
    $042f1d05d630f801$var$appearence,
    $042f1d05d630f801$var$colorAdjust,
    $042f1d05d630f801$var$mask,
    $042f1d05d630f801$var$textOrientation,
    $042f1d05d630f801$var$transform,
    $042f1d05d630f801$var$transition,
    $042f1d05d630f801$var$writingMode,
    $042f1d05d630f801$var$userSelect,
    $042f1d05d630f801$var$breakPropsOld,
    $042f1d05d630f801$var$inlineLogicalOld,
    $042f1d05d630f801$var$unprefixed,
    $042f1d05d630f801$var$prefixed,
    $042f1d05d630f801$var$scrollSnap,
    $042f1d05d630f801$var$overscrollBehavior,
    $042f1d05d630f801$var$flex2012,
    $042f1d05d630f801$var$flex2009
];
var $042f1d05d630f801$var$propertyDetectors = $042f1d05d630f801$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $042f1d05d630f801$var$noPrefill = $042f1d05d630f801$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $foPig.default)(p.noPrefill));
    return a;
}, []);
var $042f1d05d630f801$var$el;
var $042f1d05d630f801$var$cache = {};
if (0, $cT6U4.default) {
    $042f1d05d630f801$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $042f1d05d630f801$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $042f1d05d630f801$var$key$1 in $042f1d05d630f801$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($042f1d05d630f801$var$key$1)) $042f1d05d630f801$var$cache[$042f1d05d630f801$var$computed[$042f1d05d630f801$var$key$1]] = $042f1d05d630f801$var$computed[$042f1d05d630f801$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $042f1d05d630f801$var$noPrefill.forEach(function(x) {
        return delete $042f1d05d630f801$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $042f1d05d630f801$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$042f1d05d630f801$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($042f1d05d630f801$var$cache[prop] != null) return $042f1d05d630f801$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $042f1d05d630f801$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $042f1d05d630f801$var$propertyDetectors.length; i++){
        $042f1d05d630f801$var$cache[prop] = $042f1d05d630f801$var$propertyDetectors[i](prop, $042f1d05d630f801$var$el.style, options); // Break loop, if value found.
        if ($042f1d05d630f801$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $042f1d05d630f801$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $042f1d05d630f801$var$cache[prop];
}
var $042f1d05d630f801$var$cache$1 = {};
var $042f1d05d630f801$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $042f1d05d630f801$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $042f1d05d630f801$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $042f1d05d630f801$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $042f1d05d630f801$export$ce097f82c2e4551a(p1) : ", " + $042f1d05d630f801$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $cT6U4.default) $042f1d05d630f801$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $042f1d05d630f801$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$042f1d05d630f801$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($042f1d05d630f801$var$cache$1[cacheKey] != null) return $042f1d05d630f801$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $042f1d05d630f801$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $042f1d05d630f801$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($042f1d05d630f801$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($042f1d05d630f801$var$transPropsRegExp, $042f1d05d630f801$var$prefixTransitionCallback);
    else if ($042f1d05d630f801$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $042f1d05d630f801$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $042f1d05d630f801$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $042f1d05d630f801$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($042f1d05d630f801$var$el$1.style[property] === "") {
            $042f1d05d630f801$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $042f1d05d630f801$var$el$1.style[property] = ""; // Write current value to cache.
    $042f1d05d630f801$var$cache$1[cacheKey] = prefixedValue;
    return $042f1d05d630f801$var$cache$1[cacheKey];
}

});


parcelRegister("eDu2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa7c034685afd745$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $aa7c034685afd745$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $aa7c034685afd745$export$2e2bcd8739ae039 = $aa7c034685afd745$var$jssPropsSort;

});



parcelRegister("evIEs", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $a90698d3c343c7ec$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $a90698d3c343c7ec$var$indexCounter = -1000000000;
function $a90698d3c343c7ec$export$a2647aa13413c947() {
    $a90698d3c343c7ec$var$indexCounter += 1;
    return $a90698d3c343c7ec$var$indexCounter;
}

});

parcelRegister("dcria", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99c190f64482b0d4$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");
parcelRequire("5FKop");

var $9gLdn = parcelRequire("9gLdn");

function $99c190f64482b0d4$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $bh1oa.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $9gLdn.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});

parcelRegister("9EChL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70758c35c7fd09c0$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $70758c35c7fd09c0$var$noopTheme = {};
var $70758c35c7fd09c0$export$2e2bcd8739ae039 = $70758c35c7fd09c0$var$noopTheme;

});


parcelRegister("2RFFw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2160da8b5cb09213$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $2160da8b5cb09213$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("jGlhj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e54271f5e334e08d$export$2e2bcd8739ae039; });

var $6L0PO = parcelRequire("6L0PO");
var $e54271f5e334e08d$var$defaultTheme = (0, $6L0PO.default)();
var $e54271f5e334e08d$export$2e2bcd8739ae039 = $e54271f5e334e08d$var$defaultTheme;

});


parcelRegister("bdWPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82be8c726a25f5e5$export$2e2bcd8739ae039; });

var $gNnan = parcelRequire("gNnan");
function $82be8c726a25f5e5$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $gNnan.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("f1jnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aef5fc04e03a4942$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $1eKt7 = parcelRequire("1eKt7");
var $aef5fc04e03a4942$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
var $aef5fc04e03a4942$var$Backdrop = /*#__PURE__*/ $dgG1Y.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $1eKt7.default) : _props$TransitionComp, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(TransitionComponent, (0, $bh1oa.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $dgG1Y.createElement("div", {
        className: (0, $cXVHi.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $aef5fc04e03a4942$export$2e2bcd8739ae039 = (0, $7xfqK.default)($aef5fc04e03a4942$export$9dd6ff9ea0189349, {
    name: "MuiBackdrop"
})($aef5fc04e03a4942$var$Backdrop);

});
parcelRegister("1eKt7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e6b24f3dd7eef9c$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $ckFPG = parcelRequire("ckFPG");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $dlCX6 = parcelRequire("dlCX6");

var $frSQs = parcelRequire("frSQs");

var $fbIlN = parcelRequire("fbIlN");

var $lcwuC = parcelRequire("lcwuC");

var $arbQ3 = parcelRequire("arbQ3");
var $0e6b24f3dd7eef9c$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $0e6b24f3dd7eef9c$var$defaultTimeout = {
    enter: (0, $frSQs.duration).enteringScreen,
    exit: (0, $frSQs.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $0e6b24f3dd7eef9c$var$Fade = /*#__PURE__*/ $dgG1Y.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dlCX6.default) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $0e6b24f3dd7eef9c$var$defaultTimeout : _props$timeout, other = (0, $gZz4Z.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $fbIlN.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $dgG1Y.useRef(null);
    var foreignRef = (0, $arbQ3.default)(children.ref, ref);
    var handleRef = (0, $arbQ3.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $ckFPG.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $lcwuC.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, $lcwuC.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $lcwuC.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $dgG1Y.createElement(TransitionComponent, (0, $bh1oa.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $dgG1Y.cloneElement(children, (0, $bh1oa.default)({
            style: (0, $bh1oa.default)({
                opacity: 0,
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $0e6b24f3dd7eef9c$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $0e6b24f3dd7eef9c$export$2e2bcd8739ae039 = $0e6b24f3dd7eef9c$var$Fade;

});
parcelRegister("dlCX6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7b73a8d5d175a8$export$2e2bcd8739ae039; });

var $gppKd = parcelRequire("gppKd");

var $2BhAF = parcelRequire("2BhAF");


var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");

var $s5n8q = parcelRequire("s5n8q");


var $afFkE = parcelRequire("afFkE");

var $f1tuU = parcelRequire("f1tuU");
var $9b7b73a8d5d175a8$export$bb38bb9a1161268 = "unmounted";
var $9b7b73a8d5d175a8$export$84cbff306f539230 = "exited";
var $9b7b73a8d5d175a8$export$df38205c966be359 = "entering";
var $9b7b73a8d5d175a8$export$78e9e6e3e014d60a = "entered";
var $9b7b73a8d5d175a8$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9b7b73a8d5d175a8$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $2BhAF.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9b7b73a8d5d175a8$export$84cbff306f539230;
                _this.appearStatus = $9b7b73a8d5d175a8$export$df38205c966be359;
            } else initialStatus = $9b7b73a8d5d175a8$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9b7b73a8d5d175a8$export$bb38bb9a1161268;
        else initialStatus = $9b7b73a8d5d175a8$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9b7b73a8d5d175a8$export$bb38bb9a1161268) return {
            status: $9b7b73a8d5d175a8$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9b7b73a8d5d175a8$export$df38205c966be359 && status !== $9b7b73a8d5d175a8$export$78e9e6e3e014d60a) nextStatus = $9b7b73a8d5d175a8$export$df38205c966be359;
            } else if (status === $9b7b73a8d5d175a8$export$df38205c966be359 || status === $9b7b73a8d5d175a8$export$78e9e6e3e014d60a) nextStatus = $9b7b73a8d5d175a8$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9b7b73a8d5d175a8$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($8idXE))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1tuU.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9b7b73a8d5d175a8$export$84cbff306f539230) this.setState({
            status: $9b7b73a8d5d175a8$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($8idXE))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $s5n8q.default).disabled) {
            this.safeSetState({
                status: $9b7b73a8d5d175a8$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9b7b73a8d5d175a8$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9b7b73a8d5d175a8$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8idXE))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $s5n8q.default).disabled) {
            this.safeSetState({
                status: $9b7b73a8d5d175a8$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9b7b73a8d5d175a8$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9b7b73a8d5d175a8$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($8idXE))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9b7b73a8d5d175a8$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $gppKd.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement((0, $afFkE.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).Component);
$9b7b73a8d5d175a8$var$Transition.contextType = (0, $afFkE.default);
$9b7b73a8d5d175a8$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9b7b73a8d5d175a8$var$noop() {}
$9b7b73a8d5d175a8$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9b7b73a8d5d175a8$var$noop,
    onEntering: $9b7b73a8d5d175a8$var$noop,
    onEntered: $9b7b73a8d5d175a8$var$noop,
    onExit: $9b7b73a8d5d175a8$var$noop,
    onExiting: $9b7b73a8d5d175a8$var$noop,
    onExited: $9b7b73a8d5d175a8$var$noop
};
$9b7b73a8d5d175a8$var$Transition.UNMOUNTED = $9b7b73a8d5d175a8$export$bb38bb9a1161268;
$9b7b73a8d5d175a8$var$Transition.EXITED = $9b7b73a8d5d175a8$export$84cbff306f539230;
$9b7b73a8d5d175a8$var$Transition.ENTERING = $9b7b73a8d5d175a8$export$df38205c966be359;
$9b7b73a8d5d175a8$var$Transition.ENTERED = $9b7b73a8d5d175a8$export$78e9e6e3e014d60a;
$9b7b73a8d5d175a8$var$Transition.EXITING = $9b7b73a8d5d175a8$export$4aacc83d4d59139f;
var $9b7b73a8d5d175a8$export$2e2bcd8739ae039 = $9b7b73a8d5d175a8$var$Transition;

});
parcelRegister("s5n8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0546c86f6c16b4d1$export$2e2bcd8739ae039; });
var $0546c86f6c16b4d1$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("afFkE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $776b5dc3c23cc392$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
var $776b5dc3c23cc392$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createContext(null);

});

parcelRegister("f1tuU", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $aefdd49ef7b758a0$export$7d26bbb1236dafd6; });
var $aefdd49ef7b758a0$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("fbIlN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0ea492cf2552c95$export$2e2bcd8739ae039; });

var $57IP6 = parcelRequire("57IP6");
parcelRequire("dgG1Y");

var $jGlhj = parcelRequire("jGlhj");
function $b0ea492cf2552c95$export$2e2bcd8739ae039() {
    var theme = (0, $57IP6.default)() || (0, $jGlhj.default);
    return theme;
}

});

parcelRegister("lcwuC", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $f6f3ec64352efabd$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $f6f3ec64352efabd$export$8cb1e9b404609ae9; });
var $f6f3ec64352efabd$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $f6f3ec64352efabd$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}

});

parcelRegister("arbQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79959be2be78ee33$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $ajiTB = parcelRequire("ajiTB");
function $79959be2be78ee33$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $dgG1Y.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $ajiTB.default)(refA, refValue);
            (0, $ajiTB.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("ajiTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781a560c290c6ebf$export$2e2bcd8739ae039; });
// TODO v5: consider to make it private
function $781a560c290c6ebf$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});




parcelRegister("eaNQk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a518a9a029c2b0eb$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $h2Xtr = parcelRequire("h2Xtr");

var $jGlhj = parcelRequire("jGlhj");
function $a518a9a029c2b0eb$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $h2Xtr.default)(stylesOrCreator, (0, $bh1oa.default)({
        defaultTheme: (0, $jGlhj.default)
    }, options));
}
var $a518a9a029c2b0eb$export$2e2bcd8739ae039 = $a518a9a029c2b0eb$var$makeStyles;

});


parcelRegister("2Po3a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20f3000fbda24d38$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");
var $20f3000fbda24d38$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $bh1oa.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $20f3000fbda24d38$var$Paper = /*#__PURE__*/ $dgG1Y.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $20f3000fbda24d38$export$2e2bcd8739ae039 = (0, $7xfqK.default)($20f3000fbda24d38$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($20f3000fbda24d38$var$Paper);

});

parcelRegister("3XSLK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e315dcb8812e72a$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $bey4Q = parcelRequire("bey4Q");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");
var $2e315dcb8812e72a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "flex",
            alignItems: "center"
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $bey4Q.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up("sm"), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $2e315dcb8812e72a$var$Toolbar = /*#__PURE__*/ $dgG1Y.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? "regular" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $2e315dcb8812e72a$export$2e2bcd8739ae039 = (0, $7xfqK.default)($2e315dcb8812e72a$export$9dd6ff9ea0189349, {
    name: "MuiToolbar"
})($2e315dcb8812e72a$var$Toolbar);

});

parcelRegister("kngbJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed52834582ac2235$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4SCEc = parcelRequire("4SCEc");

var $7wlV1 = parcelRequire("7wlV1");

var $79EgL = parcelRequire("79EgL");
"use client";
function $ed52834582ac2235$export$2e2bcd8739ae039() {
    const theme = (0, $4SCEc.default)((0, $7wlV1.default));
    return theme[0, $79EgL.default] || theme;
}

});
parcelRegister("4SCEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38da2f23ab6671f2$export$2e2bcd8739ae039; });

var $1v4KJ = parcelRequire("1v4KJ");

var $aByKf = parcelRequire("aByKf");
"use client";
const $38da2f23ab6671f2$export$35e57303dbd8a66 = (0, $1v4KJ.default)();
function $38da2f23ab6671f2$var$useTheme(defaultTheme = $38da2f23ab6671f2$export$35e57303dbd8a66) {
    return (0, $aByKf.default)(defaultTheme);
}
var $38da2f23ab6671f2$export$2e2bcd8739ae039 = $38da2f23ab6671f2$var$useTheme;

});
parcelRegister("aByKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b884fb3732570a3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("2OelD");
var $hBw4X = parcelRequire("hBw4X");
"use client";
function $7b884fb3732570a3$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $7b884fb3732570a3$var$useTheme(defaultTheme = null) {
    const contextTheme = $dgG1Y.useContext((0, $hBw4X.T));
    return !contextTheme || $7b884fb3732570a3$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $7b884fb3732570a3$export$2e2bcd8739ae039 = $7b884fb3732570a3$var$useTheme;

});


parcelRegister("7wlV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $579c862c5206dad5$export$2e2bcd8739ae039; });

var $iikr3 = parcelRequire("iikr3");
"use client";
const $579c862c5206dad5$var$defaultTheme = (0, $iikr3.default)();
var $579c862c5206dad5$export$2e2bcd8739ae039 = $579c862c5206dad5$var$defaultTheme;

});


parcelRegister("6xSIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c40462d626264d8$export$2e2bcd8739ae039; });

var $7dz6E = parcelRequire("7dz6E");

var $79EgL = parcelRequire("79EgL");
const $4c40462d626264d8$var$useMediaQuery = (0, $7dz6E.unstable_createUseMediaQuery)({
    themeId: (0, $79EgL.default)
});
var $4c40462d626264d8$export$2e2bcd8739ae039 = $4c40462d626264d8$var$useMediaQuery;

});
parcelRegister("7dz6E", function(module, exports) {

$parcel$export(module.exports, "unstable_createUseMediaQuery", function () { return $5414faa9b16f5157$export$96d7927a982220b5; });

var $dgG1Y = parcelRequire("dgG1Y");

var $huSf2 = parcelRequire("huSf2");

var $gbZB8 = parcelRequire("gbZB8");

var $aByKf = parcelRequire("aByKf");
"use client";
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $5414faa9b16f5157$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $dgG1Y.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $huSf2.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener("change", updateMatch);
        return ()=>{
            queryList.removeEventListener("change", updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $5414faa9b16f5157$var$safeReact = {
    ...$dgG1Y
};
const $5414faa9b16f5157$var$maybeReactUseSyncExternalStore = $5414faa9b16f5157$var$safeReact.useSyncExternalStore;
function $5414faa9b16f5157$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $dgG1Y.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $dgG1Y.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $dgG1Y.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener("change", notify);
                return ()=>{
                    mediaQueryList.removeEventListener("change", notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $5414faa9b16f5157$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $5414faa9b16f5157$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $aByKf.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $gbZB8.default)({
            name: "MuiUseMediaQuery",
            props: options,
            theme: theme
        });
        let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, "");
        const useMediaQueryImplementation = $5414faa9b16f5157$var$maybeReactUseSyncExternalStore !== undefined ? $5414faa9b16f5157$var$useMediaQueryNew : $5414faa9b16f5157$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $5414faa9b16f5157$var$useMediaQuery = $5414faa9b16f5157$export$96d7927a982220b5();
var $5414faa9b16f5157$export$2e2bcd8739ae039 = $5414faa9b16f5157$var$useMediaQuery;

});
parcelRegister("huSf2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbcf503bc6ee39e3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $cbcf503bc6ee39e3$var$useEnhancedEffect = typeof window !== "undefined" ? $dgG1Y.useLayoutEffect : $dgG1Y.useEffect;
var $cbcf503bc6ee39e3$export$2e2bcd8739ae039 = $cbcf503bc6ee39e3$var$useEnhancedEffect;

});

parcelRegister("gbZB8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9d748398e622f1$export$2e2bcd8739ae039; });

var $kLIBw = parcelRequire("kLIBw");
function $bc9d748398e622f1$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $kLIBw.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("kLIBw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1eacbdf813ed825$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $f1eacbdf813ed825$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === "components" || propName === "slots") output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === "componentsProps" || propName === "slotProps") {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $f1eacbdf813ed825$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});




parcelRegister("lBH8Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbae853270b2be23$export$2e2bcd8739ae039; });

var $hgTDg = parcelRequire("hgTDg");


var $9BqDg = parcelRequire("9BqDg");

var $iikr3 = parcelRequire("iikr3");

var $79EgL = parcelRequire("79EgL");

var $kEFLT = parcelRequire("kEFLT");
"use client";
const $fbae853270b2be23$var$defaultTheme = (0, $iikr3.default)();
const $fbae853270b2be23$var$Box = (0, $hgTDg.default)({
    themeId: (0, $79EgL.default),
    defaultTheme: $fbae853270b2be23$var$defaultTheme,
    defaultClassName: (0, $kEFLT.default).root,
    generateClassName: (0, $9BqDg.default).generate
});
var $fbae853270b2be23$export$2e2bcd8739ae039 = $fbae853270b2be23$var$Box;

});
parcelRegister("hgTDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c92f15b010a3c646$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $i5k0d = parcelRequire("i5k0d");

var $c7XNj = parcelRequire("c7XNj");

var $2RnpB = parcelRequire("2RnpB");
var $aR4Hj = parcelRequire("aR4Hj");

var $4SCEc = parcelRequire("4SCEc");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $c92f15b010a3c646$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $c7XNj.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $2RnpB.default));
    const Box = /*#__PURE__*/ $dgG1Y.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4SCEc.default)(defaultTheme);
        const { className: className, component: component = "div", ...other } = (0, $aR4Hj.default)(inProps);
        return /*#__PURE__*/ (0, $fR5Jw.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $i5k0d.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});
parcelRegister("i5k0d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27877cb897b8f141$export$2e2bcd8739ae039; });
function $27877cb897b8f141$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $27877cb897b8f141$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $27877cb897b8f141$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $27877cb897b8f141$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $27877cb897b8f141$export$2e2bcd8739ae039 = $27877cb897b8f141$export$4f5d2d50c9deca37;

});

parcelRegister("c7XNj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d448568020559b2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $8d448568020559b2$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $8d448568020559b2$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v6.3.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $2qBjN = parcelRequire("2qBjN");

var $7e46i = parcelRequire("7e46i");

var $2OelD = parcelRequire("2OelD");
var $hBw4X = parcelRequire("hBw4X");


var $jaTkQ = parcelRequire("jaTkQ");
function $8d448568020559b2$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $2qBjN.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $8d448568020559b2$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $8d448568020559b2$var$wrapper = [];
function $8d448568020559b2$export$13a2d3ef13012b32(styles) {
    $8d448568020559b2$var$wrapper[0] = styles;
    return (0, $7e46i.serializeStyles)($8d448568020559b2$var$wrapper);
}

});
parcelRegister("2qBjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4af51af6484b55$export$2e2bcd8739ae039; });

var $cHvIk = parcelRequire("cHvIk");
parcelRequire("46AbS");
parcelRequire("dgG1Y");
parcelRequire("6wnmd");

parcelRequire("b8nth");
parcelRequire("7e46i");
parcelRequire("eMF9c");
var $1c4af51af6484b55$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $1c4af51af6484b55$export$2e2bcd8739ae039 = (0, $cHvIk.default).bind();
$1c4af51af6484b55$var$tags.forEach(function(tagName) {
    $1c4af51af6484b55$export$2e2bcd8739ae039[tagName] = $1c4af51af6484b55$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("cHvIk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93f219e68d139ca1$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");

var $6wnmd = parcelRequire("6wnmd");
parcelRequire("2OelD");
var $hBw4X = parcelRequire("hBw4X");

var $b8nth = parcelRequire("b8nth");

var $7e46i = parcelRequire("7e46i");

var $eMF9c = parcelRequire("eMF9c");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $93f219e68d139ca1$var$testOmitPropsOnStringTag = (0, $6wnmd.default);
var $93f219e68d139ca1$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $93f219e68d139ca1$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $93f219e68d139ca1$var$testOmitPropsOnStringTag : $93f219e68d139ca1$var$testOmitPropsOnComponent;
};
var $93f219e68d139ca1$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $93f219e68d139ca1$var$isDevelopment = false;
var $93f219e68d139ca1$var$isBrowser = typeof document !== "undefined";
var $93f219e68d139ca1$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $b8nth.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $eMF9c.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $b8nth.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$93f219e68d139ca1$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $dgG1Y.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $93f219e68d139ca1$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $93f219e68d139ca1$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $93f219e68d139ca1$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $hBw4X.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $dgG1Y.useContext((0, $hBw4X.T));
            }
            if (typeof props.className === "string") className = (0, $b8nth.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $7e46i.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $93f219e68d139ca1$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement($93f219e68d139ca1$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $dgG1Y.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $93f219e68d139ca1$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $bh1oa.default)({}, options, nextOptions, {
                shouldForwardProp: $93f219e68d139ca1$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("6wnmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf7d97d4e6b7b8c$export$2e2bcd8739ae039; });

var $aGTOf = parcelRequire("aGTOf");
// eslint-disable-next-line no-undef
var $4bf7d97d4e6b7b8c$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $4bf7d97d4e6b7b8c$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $aGTOf.default)(function(prop) {
    return $4bf7d97d4e6b7b8c$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("aGTOf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c891e3a6e42238c$export$2e2bcd8739ae039; });
function $7c891e3a6e42238c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("jaTkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df59dfef52f345b2$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");


var $2OelD = parcelRequire("2OelD");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $df59dfef52f345b2$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $df59dfef52f345b2$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($df59dfef52f345b2$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2OelD.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("aR4Hj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e727f7670c1ee70$export$2e2bcd8739ae039; });

var $ig9jY = parcelRequire("ig9jY");

var $7U7Z7 = parcelRequire("7U7Z7");
const $7e727f7670c1ee70$var$splitProps = (props)=>{
    var _props_theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    var _props_theme_unstable_sxConfig;
    const config = (_props_theme_unstable_sxConfig = props === null || props === void 0 ? void 0 : (_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.unstable_sxConfig) !== null && _props_theme_unstable_sxConfig !== void 0 ? _props_theme_unstable_sxConfig : (0, $7U7Z7.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $7e727f7670c1ee70$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $7e727f7670c1ee70$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $ig9jY.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("9BqDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fdc3a64e77219bf$export$2e2bcd8739ae039; });
const $6fdc3a64e77219bf$var$defaultGenerator = (componentName)=>componentName;
const $6fdc3a64e77219bf$var$createClassNameGenerator = ()=>{
    let generate = $6fdc3a64e77219bf$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $6fdc3a64e77219bf$var$defaultGenerator;
        }
    };
};
const $6fdc3a64e77219bf$var$ClassNameGenerator = $6fdc3a64e77219bf$var$createClassNameGenerator();
var $6fdc3a64e77219bf$export$2e2bcd8739ae039 = $6fdc3a64e77219bf$var$ClassNameGenerator;

});

parcelRegister("kEFLT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f097f1ff1c40099c$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");
const $f097f1ff1c40099c$var$boxClasses = (0, $eFHYA.default)("MuiBox", [
    "root"
]);
var $f097f1ff1c40099c$export$2e2bcd8739ae039 = $f097f1ff1c40099c$var$boxClasses;

});
parcelRegister("eFHYA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae701c5167d5b4f$export$2e2bcd8739ae039; });

var $5xHgF = parcelRequire("5xHgF");
function $aae701c5167d5b4f$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $5xHgF.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("5xHgF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $409198ea0583feeb$export$2e2bcd8739ae039; });

var $9BqDg = parcelRequire("9BqDg");
const $409198ea0583feeb$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $409198ea0583feeb$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $409198ea0583feeb$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $9BqDg.default).generate(componentName)}-${slot}`;
}
function $409198ea0583feeb$export$34c0130b1f3e8ae3(slot) {
    return $409198ea0583feeb$export$9d6b9120de57c54[slot] !== undefined;
}

});




parcelRegister("j0KmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd71fc509e2715f6$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $59WLo = parcelRequire("59WLo");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $dd71fc509e2715f6$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $59WLo.getDividerUtilityClass), classes);
};
const $dd71fc509e2715f6$var$DividerRoot = (0, $dTuzq.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin",
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%"
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kqewD.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: "inset"
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: "middle",
                    orientation: "horizontal"
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: "middle",
                    orientation: "vertical"
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    height: "100%",
                    borderBottomWidth: 0,
                    borderRightWidth: "thin"
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: "stretch",
                    height: "auto"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: "flex",
                    textAlign: "center",
                    border: 0,
                    borderTopStyle: "solid",
                    borderLeftStyle: "solid",
                    "&::before, &::after": {
                        content: '""',
                        alignSelf: "center"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== "vertical",
                style: {
                    "&::before, &::after": {
                        width: "100%",
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: "inherit"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === "vertical" && ownerState.children,
                style: {
                    flexDirection: "column",
                    "&::before, &::after": {
                        height: "100%",
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: "inherit"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === "right" && ownerState.orientation !== "vertical",
                style: {
                    "&::before": {
                        width: "90%"
                    },
                    "&::after": {
                        width: "10%"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === "left" && ownerState.orientation !== "vertical",
                style: {
                    "&::before": {
                        width: "10%"
                    },
                    "&::after": {
                        width: "90%"
                    }
                }
            }
        ]
    })));
const $dd71fc509e2715f6$var$DividerWrapper = (0, $dTuzq.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: "nowrap",
        variants: [
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $dd71fc509e2715f6$var$Divider = /*#__PURE__*/ $dgG1Y.forwardRef(function Divider(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = "horizontal", component: component = children || orientation === "vertical" ? "div" : "hr", flexItem: flexItem = false, light: light = false, role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth", ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $dd71fc509e2715f6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($dd71fc509e2715f6$var$DividerRoot, {
        as: component,
        className: (0, $8MGTi.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === "separator" && (component !== "hr" || orientation === "vertical") ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $fR5Jw.jsx)($dd71fc509e2715f6$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($dd71fc509e2715f6$var$Divider) $dd71fc509e2715f6$var$Divider.muiSkipListHighlight = true;
var $dd71fc509e2715f6$export$2e2bcd8739ae039 = $dd71fc509e2715f6$var$Divider;

});
parcelRegister("8MGTi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b282b069df34f5b7$export$2e2bcd8739ae039; });
function $b282b069df34f5b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $b282b069df34f5b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $b282b069df34f5b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $b282b069df34f5b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $b282b069df34f5b7$export$2e2bcd8739ae039 = $b282b069df34f5b7$export$4f5d2d50c9deca37;

});

parcelRegister("1wSL5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d3417e2e2b88b4$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $11d3417e2e2b88b4$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = "";
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? "" : " ") + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += " " + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("dTuzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1d8200ea78ef1c7$export$2e2bcd8739ae039; });

var $cMjQv = parcelRequire("cMjQv");

var $7wlV1 = parcelRequire("7wlV1");

var $79EgL = parcelRequire("79EgL");

var $c1SJa = parcelRequire("c1SJa");

"use client";
const $a1d8200ea78ef1c7$var$styled = (0, $cMjQv.default)({
    themeId: (0, $79EgL.default),
    defaultTheme: $7wlV1.default,
    rootShouldForwardProp: $c1SJa.default
});
var $a1d8200ea78ef1c7$export$2e2bcd8739ae039 = $a1d8200ea78ef1c7$var$styled;

});
parcelRegister("cMjQv", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $94d95cb5a0b764a9$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $94d95cb5a0b764a9$export$2e2bcd8739ae039; });

var $c7XNj = parcelRequire("c7XNj");

var $ig9jY = parcelRequire("ig9jY");

var $ilnWD = parcelRequire("ilnWD");

var $iWVZt = parcelRequire("iWVZt");

var $1v4KJ = parcelRequire("1v4KJ");

var $2RnpB = parcelRequire("2RnpB");

var $h955Q = parcelRequire("h955Q");
const $94d95cb5a0b764a9$export$35e57303dbd8a66 = (0, $1v4KJ.default)();
function $94d95cb5a0b764a9$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function $94d95cb5a0b764a9$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $94d95cb5a0b764a9$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $94d95cb5a0b764a9$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $94d95cb5a0b764a9$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === "function" ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$94d95cb5a0b764a9$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle === null || resolvedStyle === void 0 ? void 0 : resolvedStyle.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $94d95cb5a0b764a9$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle === null || resolvedStyle === void 0 ? void 0 : resolvedStyle.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $94d95cb5a0b764a9$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === "function") {
            mergedState !== null && mergedState !== void 0 ? mergedState : mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            var _props_ownerState;
            if (props[key] !== variant.props[key] && ((_props_ownerState = props.ownerState) === null || _props_ownerState === void 0 ? void 0 : _props_ownerState[key]) !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === "function") {
            mergedState !== null && mergedState !== void 0 ? mergedState : mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $94d95cb5a0b764a9$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $94d95cb5a0b764a9$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $94d95cb5a0b764a9$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $94d95cb5a0b764a9$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $94d95cb5a0b764a9$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $c7XNj.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $2RnpB.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $94d95cb5a0b764a9$var$defaultOverridesResolver($94d95cb5a0b764a9$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $94d95cb5a0b764a9$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($94d95cb5a0b764a9$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $c7XNj.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $94d95cb5a0b764a9$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === "function" && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $94d95cb5a0b764a9$var$processStyle(props, style);
            };
            if ((0, $ig9jY.isPlainObject)(style)) {
                const serialized = (0, $h955Q.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $94d95cb5a0b764a9$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                var _theme_components_componentName, _theme_components;
                const theme = props.theme;
                const styleOverrides = (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_componentName = _theme_components[componentName]) === null || _theme_components_componentName === void 0 ? void 0 : _theme_components_componentName.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $94d95cb5a0b764a9$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                var _theme_components_componentName, _theme_components;
                const theme = props.theme;
                const themeVariants = theme === null || theme === void 0 ? void 0 : (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_componentName = _theme_components[componentName]) === null || _theme_components_componentName === void 0 ? void 0 : _theme_components_componentName.variants;
                if (!themeVariants) return null;
                return $94d95cb5a0b764a9$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $2RnpB.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill("");
                const placeholdersTail = new Array(expressionsTail.length).fill("");
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $94d95cb5a0b764a9$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $ilnWD.default)(componentSlot || "")}`;
    return `Styled(${(0, $iWVZt.default)(tag)})`;
}
function $94d95cb5a0b764a9$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $94d95cb5a0b764a9$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $94d95cb5a0b764a9$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $94d95cb5a0b764a9$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("iWVZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcbaa075486dce80$export$2e2bcd8739ae039; });

var $eyea9 = parcelRequire("eyea9");
function $dcbaa075486dce80$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || fallback;
}
function $dcbaa075486dce80$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $dcbaa075486dce80$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $dcbaa075486dce80$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $dcbaa075486dce80$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $eyea9.ForwardRef:
            return $dcbaa075486dce80$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $eyea9.Memo:
            return $dcbaa075486dce80$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("eyea9", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lalnK"));

});
parcelRegister("lalnK", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $f68b1e28f5ea911d$export$a7c73072b1a182ae; }, function (v) { return $f68b1e28f5ea911d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f68b1e28f5ea911d$export$9f27bc3417b4524d; }, function (v) { return $f68b1e28f5ea911d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f68b1e28f5ea911d$export$db77ccec0bb4ccac; }, function (v) { return $f68b1e28f5ea911d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f68b1e28f5ea911d$export$8392c0c9d3dcbd35; }, function (v) { return $f68b1e28f5ea911d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f68b1e28f5ea911d$export$ffb0004e005737fa; }, function (v) { return $f68b1e28f5ea911d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f68b1e28f5ea911d$export$b624eff549462981; }, function (v) { return $f68b1e28f5ea911d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f68b1e28f5ea911d$export$7897aa7841a5380c; }, function (v) { return $f68b1e28f5ea911d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f68b1e28f5ea911d$export$602eac185826482c; }, function (v) { return $f68b1e28f5ea911d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f68b1e28f5ea911d$export$e2c29f18771995cb; }, function (v) { return $f68b1e28f5ea911d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f68b1e28f5ea911d$export$5f8d39834fd61797; }, function (v) { return $f68b1e28f5ea911d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f68b1e28f5ea911d$export$74bf444e3cd11ea5; }, function (v) { return $f68b1e28f5ea911d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $f68b1e28f5ea911d$export$998bcd577473dd93; }, function (v) { return $f68b1e28f5ea911d$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f68b1e28f5ea911d$export$b706b080d889d2c9; }, function (v) { return $f68b1e28f5ea911d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f68b1e28f5ea911d$export$5be5a87408f70ddc; }, function (v) { return $f68b1e28f5ea911d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f68b1e28f5ea911d$export$45a5e7f76e0caa8d; }, function (v) { return $f68b1e28f5ea911d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f68b1e28f5ea911d$export$455c2e768291efa6; }, function (v) { return $f68b1e28f5ea911d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f68b1e28f5ea911d$export$9522e17588c12572; }, function (v) { return $f68b1e28f5ea911d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f68b1e28f5ea911d$export$2110ac352bb060b9; }, function (v) { return $f68b1e28f5ea911d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f68b1e28f5ea911d$export$56885ab8b9c456ab; }, function (v) { return $f68b1e28f5ea911d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f68b1e28f5ea911d$export$d927fcb6adf8f9de; }, function (v) { return $f68b1e28f5ea911d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f68b1e28f5ea911d$export$b82d16f27459e05a; }, function (v) { return $f68b1e28f5ea911d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f68b1e28f5ea911d$export$522c17b4f5e123e8; }, function (v) { return $f68b1e28f5ea911d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f68b1e28f5ea911d$export$1aabd8a0274ecfd6; }, function (v) { return $f68b1e28f5ea911d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $f68b1e28f5ea911d$export$3d6c20d97e46b957; }, function (v) { return $f68b1e28f5ea911d$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f68b1e28f5ea911d$export$9b621391a187a31a; }, function (v) { return $f68b1e28f5ea911d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f68b1e28f5ea911d$export$f5bbd400c2f4426f; }, function (v) { return $f68b1e28f5ea911d$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f68b1e28f5ea911d$export$a7c73072b1a182ae;
var $f68b1e28f5ea911d$export$9f27bc3417b4524d;
var $f68b1e28f5ea911d$export$db77ccec0bb4ccac;
var $f68b1e28f5ea911d$export$8392c0c9d3dcbd35;
var $f68b1e28f5ea911d$export$ffb0004e005737fa;
var $f68b1e28f5ea911d$export$b624eff549462981;
var $f68b1e28f5ea911d$export$7897aa7841a5380c;
var $f68b1e28f5ea911d$export$602eac185826482c;
var $f68b1e28f5ea911d$export$e2c29f18771995cb;
var $f68b1e28f5ea911d$export$5f8d39834fd61797;
var $f68b1e28f5ea911d$export$74bf444e3cd11ea5;
var $f68b1e28f5ea911d$export$998bcd577473dd93;
var $f68b1e28f5ea911d$export$b706b080d889d2c9;
var $f68b1e28f5ea911d$export$5be5a87408f70ddc;
var $f68b1e28f5ea911d$export$45a5e7f76e0caa8d;
var $f68b1e28f5ea911d$export$455c2e768291efa6;
var $f68b1e28f5ea911d$export$9522e17588c12572;
var $f68b1e28f5ea911d$export$2110ac352bb060b9;
var $f68b1e28f5ea911d$export$56885ab8b9c456ab;
var $f68b1e28f5ea911d$export$d927fcb6adf8f9de;
var $f68b1e28f5ea911d$export$b82d16f27459e05a;
var $f68b1e28f5ea911d$export$522c17b4f5e123e8;
var $f68b1e28f5ea911d$export$1aabd8a0274ecfd6;
var $f68b1e28f5ea911d$export$3d6c20d97e46b957;
var $f68b1e28f5ea911d$export$9b621391a187a31a;
var $f68b1e28f5ea911d$export$f5bbd400c2f4426f;
"use strict";
var $f68b1e28f5ea911d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f68b1e28f5ea911d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f68b1e28f5ea911d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f68b1e28f5ea911d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f68b1e28f5ea911d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $f68b1e28f5ea911d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f68b1e28f5ea911d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f68b1e28f5ea911d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f68b1e28f5ea911d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f68b1e28f5ea911d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f68b1e28f5ea911d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f68b1e28f5ea911d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $f68b1e28f5ea911d$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $f68b1e28f5ea911d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f68b1e28f5ea911d$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $f68b1e28f5ea911d$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f68b1e28f5ea911d$var$REACT_FRAGMENT_TYPE:
                    case $f68b1e28f5ea911d$var$REACT_PROFILER_TYPE:
                    case $f68b1e28f5ea911d$var$REACT_STRICT_MODE_TYPE:
                    case $f68b1e28f5ea911d$var$REACT_SUSPENSE_TYPE:
                    case $f68b1e28f5ea911d$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f68b1e28f5ea911d$var$REACT_CONTEXT_TYPE:
                            case $f68b1e28f5ea911d$var$REACT_FORWARD_REF_TYPE:
                            case $f68b1e28f5ea911d$var$REACT_LAZY_TYPE:
                            case $f68b1e28f5ea911d$var$REACT_MEMO_TYPE:
                                return object;
                            case $f68b1e28f5ea911d$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f68b1e28f5ea911d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$f68b1e28f5ea911d$export$a7c73072b1a182ae = $f68b1e28f5ea911d$var$REACT_CONSUMER_TYPE;
$f68b1e28f5ea911d$export$9f27bc3417b4524d = $f68b1e28f5ea911d$var$REACT_CONTEXT_TYPE;
$f68b1e28f5ea911d$export$db77ccec0bb4ccac = $f68b1e28f5ea911d$var$REACT_ELEMENT_TYPE;
$f68b1e28f5ea911d$export$8392c0c9d3dcbd35 = $f68b1e28f5ea911d$var$REACT_FORWARD_REF_TYPE;
$f68b1e28f5ea911d$export$ffb0004e005737fa = $f68b1e28f5ea911d$var$REACT_FRAGMENT_TYPE;
$f68b1e28f5ea911d$export$b624eff549462981 = $f68b1e28f5ea911d$var$REACT_LAZY_TYPE;
$f68b1e28f5ea911d$export$7897aa7841a5380c = $f68b1e28f5ea911d$var$REACT_MEMO_TYPE;
$f68b1e28f5ea911d$export$602eac185826482c = $f68b1e28f5ea911d$var$REACT_PORTAL_TYPE;
$f68b1e28f5ea911d$export$e2c29f18771995cb = $f68b1e28f5ea911d$var$REACT_PROFILER_TYPE;
$f68b1e28f5ea911d$export$5f8d39834fd61797 = $f68b1e28f5ea911d$var$REACT_STRICT_MODE_TYPE;
$f68b1e28f5ea911d$export$74bf444e3cd11ea5 = $f68b1e28f5ea911d$var$REACT_SUSPENSE_TYPE;
$f68b1e28f5ea911d$export$998bcd577473dd93 = $f68b1e28f5ea911d$var$REACT_SUSPENSE_LIST_TYPE;
$f68b1e28f5ea911d$export$b706b080d889d2c9 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_CONSUMER_TYPE;
};
$f68b1e28f5ea911d$export$5be5a87408f70ddc = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_CONTEXT_TYPE;
};
$f68b1e28f5ea911d$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $f68b1e28f5ea911d$var$REACT_ELEMENT_TYPE;
};
$f68b1e28f5ea911d$export$455c2e768291efa6 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_FORWARD_REF_TYPE;
};
$f68b1e28f5ea911d$export$9522e17588c12572 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_FRAGMENT_TYPE;
};
$f68b1e28f5ea911d$export$2110ac352bb060b9 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_LAZY_TYPE;
};
$f68b1e28f5ea911d$export$56885ab8b9c456ab = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_MEMO_TYPE;
};
$f68b1e28f5ea911d$export$d927fcb6adf8f9de = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_PORTAL_TYPE;
};
$f68b1e28f5ea911d$export$b82d16f27459e05a = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_PROFILER_TYPE;
};
$f68b1e28f5ea911d$export$522c17b4f5e123e8 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_STRICT_MODE_TYPE;
};
$f68b1e28f5ea911d$export$1aabd8a0274ecfd6 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_SUSPENSE_TYPE;
};
$f68b1e28f5ea911d$export$3d6c20d97e46b957 = function(object) {
    return $f68b1e28f5ea911d$var$typeOf(object) === $f68b1e28f5ea911d$var$REACT_SUSPENSE_LIST_TYPE;
};
$f68b1e28f5ea911d$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $f68b1e28f5ea911d$var$REACT_FRAGMENT_TYPE || type === $f68b1e28f5ea911d$var$REACT_PROFILER_TYPE || type === $f68b1e28f5ea911d$var$REACT_STRICT_MODE_TYPE || type === $f68b1e28f5ea911d$var$REACT_SUSPENSE_TYPE || type === $f68b1e28f5ea911d$var$REACT_SUSPENSE_LIST_TYPE || type === $f68b1e28f5ea911d$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $f68b1e28f5ea911d$var$REACT_LAZY_TYPE || type.$$typeof === $f68b1e28f5ea911d$var$REACT_MEMO_TYPE || type.$$typeof === $f68b1e28f5ea911d$var$REACT_CONTEXT_TYPE || type.$$typeof === $f68b1e28f5ea911d$var$REACT_CONSUMER_TYPE || type.$$typeof === $f68b1e28f5ea911d$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f68b1e28f5ea911d$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$f68b1e28f5ea911d$export$f5bbd400c2f4426f = $f68b1e28f5ea911d$var$typeOf;

});



parcelRegister("h955Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7b73a5a32bcd512$export$2e2bcd8739ae039; });

var $c7XNj = parcelRequire("c7XNj");
function $c7b73a5a32bcd512$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $c7XNj.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== "function") variant.style = (0, $c7XNj.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("c1SJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c2007c028275876$export$2e2bcd8739ae039; });

var $3EdCI = parcelRequire("3EdCI");
const $8c2007c028275876$var$rootShouldForwardProp = (prop)=>(0, $3EdCI.default)(prop) && prop !== "classes";
var $8c2007c028275876$export$2e2bcd8739ae039 = $8c2007c028275876$var$rootShouldForwardProp;

});
parcelRegister("3EdCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a7facd801b4a77d$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $2a7facd801b4a77d$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $2a7facd801b4a77d$export$2e2bcd8739ae039 = $2a7facd801b4a77d$var$slotShouldForwardProp;

});



parcelRegister("iIVKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da19228a65650643$export$2e2bcd8739ae039; });

var $4m2KF = parcelRequire("4m2KF");
const $da19228a65650643$var$memoTheme = (0, $4m2KF.default);
var $da19228a65650643$export$2e2bcd8739ae039 = $da19228a65650643$var$memoTheme;

});
parcelRegister("4m2KF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32bb59e7f74b9613$export$2e2bcd8739ae039; });

var $h955Q = parcelRequire("h955Q");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $32bb59e7f74b9613$var$arg = {
    theme: undefined
};
function $32bb59e7f74b9613$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $32bb59e7f74b9613$var$arg.theme = props.theme;
            value = (0, $h955Q.default)(styleFn($32bb59e7f74b9613$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("aR3AP", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $7e71a420c207bb08$export$2440da353cedad43; });
parcelRequire("dgG1Y");


var $bSXLK = parcelRequire("bSXLK");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $7e71a420c207bb08$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $bSXLK.default), {
        ...props
    });
}
var $7e71a420c207bb08$export$2e2bcd8739ae039 = $7e71a420c207bb08$var$DefaultPropsProvider;
function $7e71a420c207bb08$export$2440da353cedad43(params) {
    return (0, $bSXLK.useDefaultProps)(params);
}

});
parcelRegister("bSXLK", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $8a7319be9a2cdea0$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $8a7319be9a2cdea0$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $kLIBw = parcelRequire("kLIBw");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $8a7319be9a2cdea0$var$PropsContext = /*#__PURE__*/ $dgG1Y.createContext(undefined);
function $8a7319be9a2cdea0$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($8a7319be9a2cdea0$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $8a7319be9a2cdea0$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $kLIBw.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $kLIBw.default)(config, props);
    return props;
}
function $8a7319be9a2cdea0$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $dgG1Y.useContext($8a7319be9a2cdea0$var$PropsContext);
    return $8a7319be9a2cdea0$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $8a7319be9a2cdea0$export$2e2bcd8739ae039 = $8a7319be9a2cdea0$var$DefaultPropsProvider;

});


parcelRegister("59WLo", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $3c1b602dded2cfcb$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $3c1b602dded2cfcb$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $3c1b602dded2cfcb$export$46f01d01378ec5a2(slot) {
    return (0, $5xHgF.default)("MuiDivider", slot);
}
const $3c1b602dded2cfcb$var$dividerClasses = (0, $eFHYA.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $3c1b602dded2cfcb$export$2e2bcd8739ae039 = $3c1b602dded2cfcb$var$dividerClasses;

});


parcelRegister("kDVit", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f073e528e87bee53$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");



var $1wSL5 = parcelRequire("1wSL5");

var $iuqy2 = parcelRequire("iuqy2");

var $5dz7O = parcelRequire("5dz7O");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $1cwyu = parcelRequire("1cwyu");

var $3VTQI = parcelRequire("3VTQI");

var $Z9YcK = parcelRequire("Z9YcK");

var $eAnru = parcelRequire("eAnru");

var $51QVq = parcelRequire("51QVq");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $f073e528e87bee53$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $Z9YcK.getModalUtilityClass), classes);
};
const $f073e528e87bee53$var$ModalRoot = (0, $dTuzq.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: "hidden"
                }
            }
        ]
    })));
const $f073e528e87bee53$var$ModalBackdrop = (0, $dTuzq.default)((0, $1cwyu.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $f073e528e87bee53$var$Modal = /*#__PURE__*/ $dgG1Y.forwardRef(function Modal(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $f073e528e87bee53$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $3VTQI.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $f073e528e87bee53$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        ...other,
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $eAnru.default)("root", {
        elementType: $f073e528e87bee53$var$ModalRoot,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $8MGTi.default)(className, classes === null || classes === void 0 ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes === null || classes === void 0 ? void 0 : classes.hidden))
    });
    const [BackdropSlot, backdropProps] = (0, $eAnru.default)("backdrop", {
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers === null || otherHandlers === void 0 ? void 0 : otherHandlers.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $8MGTi.default)(BackdropProps === null || BackdropProps === void 0 ? void 0 : BackdropProps.className, classes === null || classes === void 0 ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    const backdropRef = (0, $51QVq.default)(BackdropProps === null || BackdropProps === void 0 ? void 0 : BackdropProps.ref, backdropProps.ref);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $5dz7O.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $fR5Jw.jsx)(BackdropSlot, {
                    ...backdropProps,
                    ref: backdropRef
                }) : null,
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iuqy2.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $dgG1Y.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $f073e528e87bee53$export$2e2bcd8739ae039 = $f073e528e87bee53$var$Modal;

});
parcelRegister("iuqy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d75f9f338fb939be$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $bEw0x = parcelRequire("bEw0x");
var $2gobp = parcelRequire("2gobp");
var $1ZLdA = parcelRequire("1ZLdA");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $d75f9f338fb939be$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $d75f9f338fb939be$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $d75f9f338fb939be$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $d75f9f338fb939be$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $d75f9f338fb939be$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $d75f9f338fb939be$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($d75f9f338fb939be$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $d75f9f338fb939be$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$d75f9f338fb939be$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $d75f9f338fb939be$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $d75f9f338fb939be$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $d75f9f338fb939be$var$defaultGetTabbable, isEnabled: isEnabled = $d75f9f338fb939be$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $dgG1Y.useRef(false);
    const sentinelStart = $dgG1Y.useRef(null);
    const sentinelEnd = $dgG1Y.useRef(null);
    const nodeToRestore = $dgG1Y.useRef(null);
    const reactFocusEventTarget = $dgG1Y.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $dgG1Y.useRef(false);
    const rootRef = $dgG1Y.useRef(null);
    const handleRef = (0, $1ZLdA.default)((0, $bEw0x.default)(children), rootRef);
    const lastKeydown = $dgG1Y.useRef(null);
    $dgG1Y.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $dgG1Y.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2gobp.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $dgG1Y.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2gobp.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown_current, _lastKeydown_current1;
                const isShiftTab = Boolean(((_lastKeydown_current = lastKeydown.current) === null || _lastKeydown_current === void 0 ? void 0 : _lastKeydown_current.shiftKey) && ((_lastKeydown_current1 = lastKeydown.current) === null || _lastKeydown_current1 === void 0 ? void 0 : _lastKeydown_current1.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $dgG1Y.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $d75f9f338fb939be$export$2e2bcd8739ae039 = $d75f9f338fb939be$var$FocusTrap;

});
parcelRegister("bEw0x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87bc42361971a0b0$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
function $87bc42361971a0b0$export$2e2bcd8739ae039(element) {
    var _element_props;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($dgG1Y.version, 10) >= 19) return (element === null || element === void 0 ? void 0 : (_element_props = element.props) === null || _element_props === void 0 ? void 0 : _element_props.ref) || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element === null || element === void 0 ? void 0 : element.ref) || null;
}

});

parcelRegister("2gobp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a5fd5a537b35aa6$export$2e2bcd8739ae039; });
function $1a5fd5a537b35aa6$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("1ZLdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17401d7bdb90c97c$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $Sqeay = parcelRequire("Sqeay");
"use client";
function $17401d7bdb90c97c$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $dgG1Y.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $Sqeay.default)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("Sqeay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a396380ae52ced0$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $0a396380ae52ced0$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("5dz7O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cc969be5cda89dd$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");


var $bEw0x = parcelRequire("bEw0x");
var $Sqeay = parcelRequire("Sqeay");
var $huSf2 = parcelRequire("huSf2");
var $1ZLdA = parcelRequire("1ZLdA");
"use client";
function $3cc969be5cda89dd$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $3cc969be5cda89dd$var$Portal = /*#__PURE__*/ $dgG1Y.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $dgG1Y.useState(null);
    const handleRef = (0, $1ZLdA.default)(/*#__PURE__*/ $dgG1Y.isValidElement(children) ? (0, $bEw0x.default)(children) : null, forwardedRef);
    (0, $huSf2.default)(()=>{
        if (!disablePortal) setMountNode($3cc969be5cda89dd$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $huSf2.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $Sqeay.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $Sqeay.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $dgG1Y.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $dgG1Y.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $8idXE.createPortal(children, mountNode) : mountNode;
});
var $3cc969be5cda89dd$export$2e2bcd8739ae039 = $3cc969be5cda89dd$var$Portal;

});

parcelRegister("1cwyu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e002a384d66005b$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $eAnru = parcelRequire("eAnru");

var $7YCge = parcelRequire("7YCge");

var $2wrVe = parcelRequire("2wrVe");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $0e002a384d66005b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $2wrVe.getBackdropUtilityClass), classes);
};
const $0e002a384d66005b$var$BackdropRoot = (0, $dTuzq.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent",
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: "transparent"
            }
        }
    ]
});
const $0e002a384d66005b$var$Backdrop = /*#__PURE__*/ $dgG1Y.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $0e002a384d66005b$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $eAnru.default)("root", {
        elementType: $0e002a384d66005b$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $eAnru.default)("transition", {
        elementType: (0, $7YCge.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $0e002a384d66005b$export$2e2bcd8739ae039 = $0e002a384d66005b$var$Backdrop;

});
parcelRegister("eAnru", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9e69ca18525a54c$export$2e2bcd8739ae039; });

var $1ZLdA = parcelRequire("1ZLdA");

var $WPBOJ = parcelRequire("WPBOJ");

var $9oznn = parcelRequire("9oznn");

var $eZ4aO = parcelRequire("eZ4aO");
"use client";
function $a9e69ca18525a54c$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $9oznn.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $eZ4aO.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $1ZLdA.default)(internalRef, resolvedComponentsProps === null || resolvedComponentsProps === void 0 ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $WPBOJ.default)(elementType, {
        ...name === "root" && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== "root" && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && {
            as: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("WPBOJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b0d735bb156bb35$export$2e2bcd8739ae039; });

var $eWhTy = parcelRequire("eWhTy");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $0b0d735bb156bb35$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $eWhTy.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $0b0d735bb156bb35$export$2e2bcd8739ae039 = $0b0d735bb156bb35$var$appendOwnerState;

});
parcelRegister("eWhTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae045d0a93f28ed4$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $ae045d0a93f28ed4$var$isHostComponent(element) {
    return typeof element === "string";
}
var $ae045d0a93f28ed4$export$2e2bcd8739ae039 = $ae045d0a93f28ed4$var$isHostComponent;

});


parcelRegister("9oznn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d71cbde6283bb73$export$2e2bcd8739ae039; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $6d71cbde6283bb73$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $6d71cbde6283bb73$export$2e2bcd8739ae039 = $6d71cbde6283bb73$var$resolveComponentProps;

});

parcelRegister("eZ4aO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae89ffeb369c908b$export$2e2bcd8739ae039; });

var $6tLrx = parcelRequire("6tLrx");

var $bEb4B = parcelRequire("bEb4B");

var $eydrk = parcelRequire("eydrk");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $ae89ffeb369c908b$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $6tLrx.default)(additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className, className, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
        const mergedStyle = {
            ...additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style,
            ...externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.style,
            ...externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $bEb4B.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $eydrk.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $eydrk.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $6tLrx.default)(internalSlotProps === null || internalSlotProps === void 0 ? void 0 : internalSlotProps.className, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className, className, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
    const mergedStyle = {
        ...internalSlotProps === null || internalSlotProps === void 0 ? void 0 : internalSlotProps.style,
        ...additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style,
        ...externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.style,
        ...externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $ae89ffeb369c908b$export$2e2bcd8739ae039 = $ae89ffeb369c908b$var$mergeSlotProps;

});
parcelRegister("6tLrx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1d5413369e5707$export$2e2bcd8739ae039; });
function $0a1d5413369e5707$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $0a1d5413369e5707$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $0a1d5413369e5707$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $0a1d5413369e5707$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $0a1d5413369e5707$export$2e2bcd8739ae039 = $0a1d5413369e5707$export$4f5d2d50c9deca37;

});

parcelRegister("bEb4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87ac0510f11c49c8$export$2e2bcd8739ae039; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $87ac0510f11c49c8$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $87ac0510f11c49c8$export$2e2bcd8739ae039 = $87ac0510f11c49c8$var$extractEventHandlers;

});

parcelRegister("eydrk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97eaa8ab144aee0$export$2e2bcd8739ae039; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $a97eaa8ab144aee0$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $a97eaa8ab144aee0$export$2e2bcd8739ae039 = $a97eaa8ab144aee0$var$omitEventHandlers;

});



parcelRegister("7YCge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cebd0c97c06b65f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $dlCX6 = parcelRequire("dlCX6");


var $bEw0x = parcelRequire("bEw0x");

var $kngbJ = parcelRequire("kngbJ");

var $bDI8z = parcelRequire("bDI8z");

var $51QVq = parcelRequire("51QVq");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $5cebd0c97c06b65f$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5cebd0c97c06b65f$var$Fade = /*#__PURE__*/ $dgG1Y.forwardRef(function Fade(props, ref) {
    const theme = (0, $kngbJ.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dlCX6.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $dgG1Y.useRef(null);
    const handleRef = (0, $51QVq.default)(nodeRef, (0, $bEw0x.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $bDI8z.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $bDI8z.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $bDI8z.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $dgG1Y.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...$5cebd0c97c06b65f$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $5cebd0c97c06b65f$export$2e2bcd8739ae039 = $5cebd0c97c06b65f$var$Fade;

});
parcelRegister("bDI8z", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $879592fcf1752879$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $879592fcf1752879$export$8cb1e9b404609ae9; });
const $879592fcf1752879$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $879592fcf1752879$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    var _style_transitionDuration, _style_transitionTimingFunction;
    return {
        duration: (_style_transitionDuration = style.transitionDuration) !== null && _style_transitionDuration !== void 0 ? _style_transitionDuration : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style_transitionTimingFunction = style.transitionTimingFunction) !== null && _style_transitionTimingFunction !== void 0 ? _style_transitionTimingFunction : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});

parcelRegister("51QVq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a96199a1a65404b$export$2e2bcd8739ae039; });

var $1ZLdA = parcelRequire("1ZLdA");
"use client";
var $3a96199a1a65404b$export$2e2bcd8739ae039 = (0, $1ZLdA.default);

});


parcelRegister("2wrVe", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $1d643aaf4c1796a0$export$9927a91fd93152bd; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $1d643aaf4c1796a0$export$9927a91fd93152bd(slot) {
    return (0, $5xHgF.default)("MuiBackdrop", slot);
}
const $1d643aaf4c1796a0$var$backdropClasses = (0, $eFHYA.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $1d643aaf4c1796a0$export$2e2bcd8739ae039 = $1d643aaf4c1796a0$var$backdropClasses;

});


parcelRegister("3VTQI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dd2047bf384712b$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $hbyNy = parcelRequire("hbyNy");
var $2gobp = parcelRequire("2gobp");
var $9qeKF = parcelRequire("9qeKF");
var $1ZLdA = parcelRequire("1ZLdA");

var $bEb4B = parcelRequire("bEb4B");

var $b5MXd = parcelRequire("b5MXd");
"use client";
function $2dd2047bf384712b$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $2dd2047bf384712b$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
const $2dd2047bf384712b$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $2dd2047bf384712b$var$manager = new (0, $b5MXd.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $2dd2047bf384712b$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $dgG1Y.useRef({});
    const mountNodeRef = $dgG1Y.useRef(null);
    const modalRef = $dgG1Y.useRef(null);
    const handleRef = (0, $1ZLdA.default)(modalRef, rootRef);
    const [exited, setExited] = $dgG1Y.useState(!open);
    const hasTransition = $2dd2047bf384712b$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $2gobp.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $2dd2047bf384712b$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $9qeKF.default)(()=>{
        const resolvedContainer = $2dd2047bf384712b$var$getContainer(container) || getDoc().body;
        $2dd2047bf384712b$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$2dd2047bf384712b$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $9qeKF.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $b5MXd.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $dgG1Y.useCallback(()=>{
        $2dd2047bf384712b$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $dgG1Y.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $dgG1Y.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers_onKeyDown;
            (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers_onClick;
            (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $bEb4B.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: "presentation",
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            "aria-hidden": true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        var _children_props_onEnter, _children_props_onExited;
        return {
            onEnter: (0, $hbyNy.default)(handleEnter, (_children_props_onEnter = children === null || children === void 0 ? void 0 : children.props.onEnter) !== null && _children_props_onEnter !== void 0 ? _children_props_onEnter : $2dd2047bf384712b$var$noop),
            onExited: (0, $hbyNy.default)(handleExited, (_children_props_onExited = children === null || children === void 0 ? void 0 : children.props.onExited) !== null && _children_props_onExited !== void 0 ? _children_props_onExited : $2dd2047bf384712b$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $2dd2047bf384712b$export$2e2bcd8739ae039 = $2dd2047bf384712b$var$useModal;

});
parcelRegister("hbyNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c82e74f5f2134db4$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c82e74f5f2134db4$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("9qeKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dc1fc287f095fad$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $huSf2 = parcelRequire("huSf2");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $6dc1fc287f095fad$var$useEventCallback(fn) {
    const ref = $dgG1Y.useRef(fn);
    (0, $huSf2.default)(()=>{
        ref.current = fn;
    });
    return $dgG1Y.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $6dc1fc287f095fad$export$2e2bcd8739ae039 = $6dc1fc287f095fad$var$useEventCallback;

});

parcelRegister("b5MXd", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $813622967c07d3d5$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $813622967c07d3d5$export$ce11c4ecd08cea67; });

var $dNTYI = parcelRequire("dNTYI");
var $2gobp = parcelRequire("2gobp");
var $lK2kL = parcelRequire("lK2kL");
// Is a vertical scrollbar displayed?
function $813622967c07d3d5$var$isOverflowing(container) {
    const doc = (0, $2gobp.default)(container);
    if (doc.body === container) return (0, $lK2kL.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $813622967c07d3d5$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $813622967c07d3d5$var$getPaddingRight(element) {
    return parseInt((0, $lK2kL.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $813622967c07d3d5$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $813622967c07d3d5$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$813622967c07d3d5$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $813622967c07d3d5$export$e1bd0c6150f13d96(element, hide);
    });
}
function $813622967c07d3d5$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $813622967c07d3d5$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($813622967c07d3d5$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $dNTYI.default)((0, $lK2kL.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$813622967c07d3d5$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $2gobp.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$813622967c07d3d5$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $2gobp.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $lK2kL.default)(container);
            scrollContainer = (parent === null || parent === void 0 ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $813622967c07d3d5$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $813622967c07d3d5$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $813622967c07d3d5$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $813622967c07d3d5$var$getHiddenSiblings(container);
        $813622967c07d3d5$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $813622967c07d3d5$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $813622967c07d3d5$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $813622967c07d3d5$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $813622967c07d3d5$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $813622967c07d3d5$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $813622967c07d3d5$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $813622967c07d3d5$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.modals = [];
        this.containers = [];
    }
}

});
parcelRegister("dNTYI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0cb461841246332$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $a0cb461841246332$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});

parcelRegister("lK2kL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3fb453fb41f3ae$export$2e2bcd8739ae039; });

var $2gobp = parcelRequire("2gobp");
function $fd3fb453fb41f3ae$export$2e2bcd8739ae039(node) {
    const doc = (0, $2gobp.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("Z9YcK", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $0b7d6e7651c025c4$export$67960e22b12a638d; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $0b7d6e7651c025c4$export$67960e22b12a638d(slot) {
    return (0, $5xHgF.default)("MuiModal", slot);
}
const $0b7d6e7651c025c4$var$modalClasses = (0, $eFHYA.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $0b7d6e7651c025c4$export$2e2bcd8739ae039 = $0b7d6e7651c025c4$var$modalClasses;

});


parcelRegister("blSgQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $843bc0e9887b2912$export$2e2bcd8739ae039; });

var $d9Tuz = parcelRequire("d9Tuz");
var $843bc0e9887b2912$export$2e2bcd8739ae039 = (0, $d9Tuz.default);

});
parcelRegister("d9Tuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9947292e6132de95$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $9947292e6132de95$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("44E5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f76a0ad63f3c4e1$export$2e2bcd8739ae039; });

var $lK2kL = parcelRequire("lK2kL");
var $2f76a0ad63f3c4e1$export$2e2bcd8739ae039 = (0, $lK2kL.default);

});

parcelRegister("cBhUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92c6d5209f37fda9$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");



var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $dTuzq = parcelRequire("dTuzq");
var $kngbJ = parcelRequire("kngbJ");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $f9SwI = parcelRequire("f9SwI");

var $hFhyF = parcelRequire("hFhyF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $92c6d5209f37fda9$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $hFhyF.getPaperUtilityClass), classes);
};
const $92c6d5209f37fda9$var$PaperRoot = (0, $dTuzq.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow"),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: "elevation"
                },
                style: {
                    boxShadow: "var(--Paper-shadow)",
                    backgroundImage: "var(--Paper-overlay)"
                }
            }
        ]
    })));
const $92c6d5209f37fda9$var$Paper = /*#__PURE__*/ $dgG1Y.forwardRef(function Paper(inProps, ref) {
    var _theme_vars_overlays;
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiPaper"
    });
    const theme = (0, $kngbJ.default)();
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation", ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $92c6d5209f37fda9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($92c6d5209f37fda9$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $8MGTi.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === "elevation" && {
                "--Paper-shadow": (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    "--Paper-overlay": (_theme_vars_overlays = theme.vars.overlays) === null || _theme_vars_overlays === void 0 ? void 0 : _theme_vars_overlays[elevation]
                },
                ...!theme.vars && theme.palette.mode === "dark" && {
                    "--Paper-overlay": `linear-gradient(${(0, $kqewD.alpha)("#fff", (0, $f9SwI.default)(elevation))}, ${(0, $kqewD.alpha)("#fff", (0, $f9SwI.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $92c6d5209f37fda9$export$2e2bcd8739ae039 = $92c6d5209f37fda9$var$Paper;

});
parcelRegister("hFhyF", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $cdc3e2b5e8a85dcb$export$29cdb466b9b6f20b; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $cdc3e2b5e8a85dcb$export$29cdb466b9b6f20b(slot) {
    return (0, $5xHgF.default)("MuiPaper", slot);
}
const $cdc3e2b5e8a85dcb$var$paperClasses = (0, $eFHYA.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $cdc3e2b5e8a85dcb$export$2e2bcd8739ae039 = $cdc3e2b5e8a85dcb$var$paperClasses;

});


parcelRegister("9TQfG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7351c83e001cdf70$export$2e2bcd8739ae039; });

var $ilnWD = parcelRequire("ilnWD");
var $7351c83e001cdf70$export$2e2bcd8739ae039 = (0, $ilnWD.default);

});

parcelRegister("kMmDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f209d8a412d9ece9$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $jAq4b = parcelRequire("jAq4b");
var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $9TQfG = parcelRequire("9TQfG");

var $80lma = parcelRequire("80lma");

var $bcP3f = parcelRequire("bcP3f");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $f209d8a412d9ece9$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $f209d8a412d9ece9$var$extendSxProp = (0, $jAq4b.internal_createExtendSxProp)();
const $f209d8a412d9ece9$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $9TQfG.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $bcP3f.getTypographyUtilityClass), classes);
};
const $f209d8a412d9ece9$export$140e2f5526d3cad8 = (0, $dTuzq.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $9TQfG.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>{
    var _theme_palette;
    return {
        margin: 0,
        variants: [
            {
                props: {
                    variant: "inherit"
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: "inherit",
                    lineHeight: "inherit",
                    letterSpacing: "inherit"
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== "inherit" && value && typeof value === "object").map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(((_theme_palette = theme.palette) === null || _theme_palette === void 0 ? void 0 : _theme_palette.text) || {}).filter(([, value])=>typeof value === "string").map(([color])=>({
                    props: {
                        color: `text${(0, $9TQfG.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== "inherit",
                style: {
                    textAlign: "var(--Typography-textAlign)"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: "0.35em"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    };
}));
const $f209d8a412d9ece9$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
const $f209d8a412d9ece9$var$Typography = /*#__PURE__*/ $dgG1Y.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiTypography"
    });
    const isSxColor = !$f209d8a412d9ece9$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $f209d8a412d9ece9$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $f209d8a412d9ece9$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $f209d8a412d9ece9$var$defaultVariantMapping[variant]) || "span";
    const classes = $f209d8a412d9ece9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($f209d8a412d9ece9$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $8MGTi.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== "inherit" && {
                "--Typography-textAlign": align
            },
            ...other.style
        }
    });
});
var $f209d8a412d9ece9$export$2e2bcd8739ae039 = $f209d8a412d9ece9$var$Typography;

});
parcelRegister("jAq4b", function(module, exports) {

$parcel$export(module.exports, "globalCss", function () { return $e425995c1f8d6646$export$db53682eef82cc11; });
$parcel$export(module.exports, "internal_createExtendSxProp", function () { return $e425995c1f8d6646$export$7e7f5719ff4debb1; });
parcelRequire("dgG1Y");

var $aR4Hj = parcelRequire("aR4Hj");

var $kngbJ = parcelRequire("kngbJ");

var $kUL2O = parcelRequire("kUL2O");

var $fR5Jw = parcelRequire("fR5Jw");

var $2OelD = parcelRequire("2OelD");

var $dTuzq = parcelRequire("dTuzq");
function $e425995c1f8d6646$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $fR5Jw.jsx)((0, $kUL2O.default), {
            styles: typeof styles === "function" ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $e425995c1f8d6646$export$7e7f5719ff4debb1() {
    return 0, $aR4Hj.default;
}

});
parcelRegister("kUL2O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f39d879ddaa16377$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");


var $3c2F8 = parcelRequire("3c2F8");

var $7wlV1 = parcelRequire("7wlV1");

var $79EgL = parcelRequire("79EgL");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $f39d879ddaa16377$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3c2F8.default), {
        ...props,
        defaultTheme: (0, $7wlV1.default),
        themeId: (0, $79EgL.default)
    });
}
var $f39d879ddaa16377$export$2e2bcd8739ae039 = $f39d879ddaa16377$var$GlobalStyles;

});
parcelRegister("3c2F8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25348ecd9d964eaf$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");


var $jaTkQ = parcelRequire("jaTkQ");

var $4SCEc = parcelRequire("4SCEc");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $25348ecd9d964eaf$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $4SCEc.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jaTkQ.default), {
        styles: globalStyles
    });
}
var $25348ecd9d964eaf$export$2e2bcd8739ae039 = $25348ecd9d964eaf$var$GlobalStyles;

});



parcelRegister("80lma", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3ee3c230bf012d$export$2e2bcd8739ae039; });
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $5d3ee3c230bf012d$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === "string";
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $5d3ee3c230bf012d$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$5d3ee3c230bf012d$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== "string") return false;
    }
    return true;
}
function $5d3ee3c230bf012d$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $5d3ee3c230bf012d$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("bcP3f", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $82886a70c5281edb$export$24c1f8f60cbac79e; });
$parcel$export(module.exports, "default", function () { return $82886a70c5281edb$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $82886a70c5281edb$export$24c1f8f60cbac79e(slot) {
    return (0, $5xHgF.default)("MuiTypography", slot);
}
const $82886a70c5281edb$var$typographyClasses = (0, $eFHYA.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $82886a70c5281edb$export$2e2bcd8739ae039 = $82886a70c5281edb$var$typographyClasses;

});


parcelRegister("53O4H", function(module, exports) {
function $3af4135e85fa460f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $3af4135e85fa460f$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cZslG", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4OQMF.default;
    }
});

var $4OQMF = parcelRequire("4OQMF");

});
parcelRegister("4OQMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3824c6b679498c4c$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $2GWc0 = parcelRequire("2GWc0");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $3824c6b679498c4c$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2GWc0.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $2GWc0.default).muiName;
    return /*#__PURE__*/ $dgG1Y.memo(/*#__PURE__*/ $dgG1Y.forwardRef(Component));
}

});
parcelRegister("2GWc0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f5ca4e20b523059$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $9TQfG = parcelRequire("9TQfG");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $cJUJF = parcelRequire("cJUJF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $1f5ca4e20b523059$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $9TQfG.default)(color)}`,
            `fontSize${(0, $9TQfG.default)(fontSize)}`
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $cJUJF.getSvgIconUtilityClass), classes);
};
const $1f5ca4e20b523059$var$SvgIconRoot = (0, $dTuzq.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $9TQfG.default)(ownerState.color)}`],
            styles[`fontSize${(0, $9TQfG.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>{
    var _transitions_duration, _transitions, _theme_transitions_create, _theme_transitions, _theme_typography_pxToRem, _theme_typography, _theme_typography_pxToRem1, _theme_typography1, _theme_typography_pxToRem2, _theme_typography2, _palette_action, _palette, _palette_action1, _palette1;
    var _theme_vars, _theme_vars1, _theme_vars2, _theme_vars3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        flexShrink: 0,
        transition: (_theme_transitions = theme.transitions) === null || _theme_transitions === void 0 ? void 0 : (_theme_transitions_create = _theme_transitions.create) === null || _theme_transitions_create === void 0 ? void 0 : _theme_transitions_create.call(_theme_transitions, "fill", {
            duration: (_transitions = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).transitions) === null || _transitions === void 0 ? void 0 : (_transitions_duration = _transitions.duration) === null || _transitions_duration === void 0 ? void 0 : _transitions_duration.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: "currentColor"
                }
            },
            {
                props: {
                    fontSize: "inherit"
                },
                style: {
                    fontSize: "inherit"
                }
            },
            {
                props: {
                    fontSize: "small"
                },
                style: {
                    fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_pxToRem = _theme_typography.pxToRem) === null || _theme_typography_pxToRem === void 0 ? void 0 : _theme_typography_pxToRem.call(_theme_typography, 20)) || "1.25rem"
                }
            },
            {
                props: {
                    fontSize: "medium"
                },
                style: {
                    fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_pxToRem1 = _theme_typography1.pxToRem) === null || _theme_typography_pxToRem1 === void 0 ? void 0 : _theme_typography_pxToRem1.call(_theme_typography1, 24)) || "1.5rem"
                }
            },
            {
                props: {
                    fontSize: "large"
                },
                style: {
                    fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_pxToRem2 = _theme_typography2.pxToRem) === null || _theme_typography_pxToRem2 === void 0 ? void 0 : _theme_typography_pxToRem2.call(_theme_typography2, 35)) || "2.1875rem"
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries(((_theme_vars1 = theme.vars) !== null && _theme_vars1 !== void 0 ? _theme_vars1 : theme).palette).filter(([, value])=>value && value.main).map(([color])=>{
                var _palette_color, _palette;
                var _theme_vars;
                return {
                    props: {
                        color: color
                    },
                    style: {
                        color: (_palette = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_color = _palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main
                    }
                };
            }),
            {
                props: {
                    color: "action"
                },
                style: {
                    color: (_palette = ((_theme_vars2 = theme.vars) !== null && _theme_vars2 !== void 0 ? _theme_vars2 : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_action = _palette.action) === null || _palette_action === void 0 ? void 0 : _palette_action.active
                }
            },
            {
                props: {
                    color: "disabled"
                },
                style: {
                    color: (_palette1 = ((_theme_vars3 = theme.vars) !== null && _theme_vars3 !== void 0 ? _theme_vars3 : theme).palette) === null || _palette1 === void 0 ? void 0 : (_palette_action1 = _palette1.action) === null || _palette_action1 === void 0 ? void 0 : _palette_action1.disabled
                }
            },
            {
                props: {
                    color: "inherit"
                },
                style: {
                    color: undefined
                }
            }
        ]
    };
}));
const $1f5ca4e20b523059$var$SvgIcon = /*#__PURE__*/ $dgG1Y.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24", ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $dgG1Y.isValidElement(children) && children.type === "svg";
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $1f5ca4e20b523059$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($1f5ca4e20b523059$var$SvgIconRoot, {
        as: component,
        className: (0, $8MGTi.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $fR5Jw.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$1f5ca4e20b523059$var$SvgIcon.muiName = "SvgIcon";
var $1f5ca4e20b523059$export$2e2bcd8739ae039 = $1f5ca4e20b523059$var$SvgIcon;

});
parcelRegister("cJUJF", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $9465b286b41d3e58$export$c7c50641356bdfa5; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $9465b286b41d3e58$export$c7c50641356bdfa5(slot) {
    return (0, $5xHgF.default)("MuiSvgIcon", slot);
}
const $9465b286b41d3e58$var$svgIconClasses = (0, $eFHYA.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $9465b286b41d3e58$export$2e2bcd8739ae039 = $9465b286b41d3e58$var$svgIconClasses;

});




parcelRegister("iJ8f3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da22d2a18219d40f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $kLIBw = parcelRequire("kLIBw");

var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $fX4dN = parcelRequire("fX4dN");

var $9TQfG = parcelRequire("9TQfG");

var $80lma = parcelRequire("80lma");

var $5sogl = parcelRequire("5sogl");

var $7ZAQE = parcelRequire("7ZAQE");

var $6G8aj = parcelRequire("6G8aj");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $da22d2a18219d40f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $9TQfG.default)(color)}`,
            `size${(0, $9TQfG.default)(size)}`,
            `${variant}Size${(0, $9TQfG.default)(size)}`,
            `color${(0, $9TQfG.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $9TQfG.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $9TQfG.default)(size)}`
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $5sogl.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $da22d2a18219d40f$var$commonIconStyles = [
    {
        props: {
            size: "small"
        },
        style: {
            "& > *:nth-of-type(1)": {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: "medium"
        },
        style: {
            "& > *:nth-of-type(1)": {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: "large"
        },
        style: {
            "& > *:nth-of-type(1)": {
                fontSize: 22
            }
        }
    }
];
const $da22d2a18219d40f$var$ButtonRoot = (0, $dTuzq.default)((0, $fX4dN.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $9TQfG.default)(ownerState.color)}`],
            styles[`size${(0, $9TQfG.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $9TQfG.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: "6px 16px",
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            textDecoration: "none"
        },
        [`&.${(0, $5sogl.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: "contained"
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    "&:hover": {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    "&:active": {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $5sogl.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $5sogl.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    padding: "5px 15px",
                    border: "1px solid currentColor",
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $5sogl.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: "text"
                },
                style: {
                    padding: "6px 8px",
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        "--variant-textColor": (theme.vars || theme).palette[color].main,
                        "--variant-outlinedColor": (theme.vars || theme).palette[color].main,
                        "--variant-outlinedBorder": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $kqewD.alpha)(theme.palette[color].main, 0.5),
                        "--variant-containedColor": (theme.vars || theme).palette[color].contrastText,
                        "--variant-containedBg": (theme.vars || theme).palette[color].main,
                        "@media (hover: hover)": {
                            "&:hover": {
                                "--variant-containedBg": (theme.vars || theme).palette[color].dark,
                                "--variant-textBg": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                "--variant-outlinedBorder": (theme.vars || theme).palette[color].main,
                                "--variant-outlinedBg": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: "inherit"
                },
                style: {
                    color: "inherit",
                    borderColor: "currentColor",
                    "--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    "@media (hover: hover)": {
                        "&:hover": {
                            "--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            "--variant-textBg": theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            "--variant-outlinedBg": theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: "small",
                    variant: "text"
                },
                style: {
                    padding: "4px 5px",
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: "large",
                    variant: "text"
                },
                style: {
                    padding: "8px 11px",
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: "small",
                    variant: "outlined"
                },
                style: {
                    padding: "3px 9px",
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: "large",
                    variant: "outlined"
                },
                style: {
                    padding: "7px 21px",
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: "small",
                    variant: "contained"
                },
                style: {
                    padding: "4px 10px",
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: "large",
                    variant: "contained"
                },
                style: {
                    padding: "8px 22px",
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none"
                    },
                    [`&.${(0, $5sogl.default).focusVisible}`]: {
                        boxShadow: "none"
                    },
                    "&:active": {
                        boxShadow: "none"
                    },
                    [`&.${(0, $5sogl.default).disabled}`]: {
                        boxShadow: "none"
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: "100%"
                }
            }
        ]
    };
}));
const $da22d2a18219d40f$var$ButtonStartIcon = (0, $dTuzq.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $9TQfG.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inherit",
    marginRight: 8,
    marginLeft: -4,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                marginLeft: -2
            }
        },
        ...$da22d2a18219d40f$var$commonIconStyles
    ]
});
const $da22d2a18219d40f$var$ButtonEndIcon = (0, $dTuzq.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $9TQfG.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inherit",
    marginRight: -4,
    marginLeft: 8,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                marginRight: -2
            }
        },
        ...$da22d2a18219d40f$var$commonIconStyles
    ]
});
const $da22d2a18219d40f$var$Button = /*#__PURE__*/ $dgG1Y.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $dgG1Y.useContext((0, $7ZAQE.default));
    const buttonGroupButtonContextPositionClassName = $dgG1Y.useContext((0, $6G8aj.default));
    const resolvedProps = (0, $kLIBw.default)(contextProps, inProps);
    const props = (0, $aR3AP.useDefaultProps)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $da22d2a18219d40f$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $fR5Jw.jsx)($da22d2a18219d40f$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $fR5Jw.jsx)($da22d2a18219d40f$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($da22d2a18219d40f$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $8MGTi.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $8MGTi.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        ...other,
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    });
});
var $da22d2a18219d40f$export$2e2bcd8739ae039 = $da22d2a18219d40f$var$Button;

});
parcelRegister("fX4dN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9cfa407d5b86c4e$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");



var $1wSL5 = parcelRequire("1wSL5");

var $69eGa = parcelRequire("69eGa");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $51QVq = parcelRequire("51QVq");

var $eGG39 = parcelRequire("eGG39");

var $7hwtY = parcelRequire("7hwtY");

var $gy6Bh = parcelRequire("gy6Bh");

var $sYTIC = parcelRequire("sYTIC");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $b9cfa407d5b86c4e$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $sYTIC.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $b9cfa407d5b86c4e$export$7ec0dcc5e3cdcd36 = (0, $dTuzq.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $sYTIC.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $b9cfa407d5b86c4e$var$ButtonBase = /*#__PURE__*/ $dgG1Y.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $dgG1Y.useRef(null);
    const ripple = (0, $7hwtY.default)();
    const handleRippleRef = (0, $51QVq.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $dgG1Y.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $dgG1Y.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $dgG1Y.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "start", onMouseDown, disableTouchRipple);
    const handleContextMenu = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", onContextMenu, disableTouchRipple);
    const handleDragLeave = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", onDragLeave, disableTouchRipple);
    const handleMouseUp = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", onMouseUp, disableTouchRipple);
    const handleMouseLeave = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "start", onTouchStart, disableTouchRipple);
    const handleTouchEnd = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", onTouchEnd, disableTouchRipple);
    const handleTouchMove = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", onTouchMove, disableTouchRipple);
    const handleBlur = $b9cfa407d5b86c4e$var$useRippleHandler(ripple, "stop", (event)=>{
        if (!(0, $69eGa.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $eGG39.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $69eGa.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    const handleKeyDown = (0, $eGG39.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === " ") ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $eGG39.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $51QVq.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $b9cfa407d5b86c4e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($b9cfa407d5b86c4e$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gy6Bh.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $b9cfa407d5b86c4e$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $eGG39.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $b9cfa407d5b86c4e$export$2e2bcd8739ae039 = $b9cfa407d5b86c4e$var$ButtonBase;

});
parcelRegister("69eGa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $479ef84f8123ecb4$export$2e2bcd8739ae039; });
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $479ef84f8123ecb4$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(":focus-visible");
    } catch (error) {}
    return false;
}

});

parcelRegister("eGG39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab159b2b73bc799a$export$2e2bcd8739ae039; });

var $9qeKF = parcelRequire("9qeKF");
"use client";
var $ab159b2b73bc799a$export$2e2bcd8739ae039 = (0, $9qeKF.default);

});

parcelRegister("7hwtY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54d35147fbe76f1d$export$2e2bcd8739ae039; });

var $d1GIu = parcelRequire("d1GIu");

var $dgG1Y = parcelRequire("dgG1Y");

var $4U760 = parcelRequire("4U760");
"use client";
class $54d35147fbe76f1d$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $54d35147fbe76f1d$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $4U760.default)($54d35147fbe76f1d$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $dgG1Y.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $dgG1Y.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $54d35147fbe76f1d$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    /* Ripple API */ start(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.start(...args);
        });
    }
    stop(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.stop(...args);
        });
    }
    pulsate(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.pulsate(...args);
        });
    }
    constructor(){
        (0, $d1GIu._)(this, "mountEffect", ()=>{
            if (this.shouldMount && !this.didMount) {
                if (this.ref.current !== null) {
                    this.didMount = true;
                    this.mounted.resolve();
                }
            }
        });
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
}
function $54d35147fbe76f1d$export$2e2bcd8739ae039() {
    return $54d35147fbe76f1d$export$f5de0641c7db4154.use();
}
function $54d35147fbe76f1d$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("d1GIu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $97bc80f8f4833822$export$71511d61b312f219; });
function $97bc80f8f4833822$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("4U760", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3921e5745a424df7$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
const $3921e5745a424df7$var$UNINITIALIZED = {};
function $3921e5745a424df7$export$2e2bcd8739ae039(init, initArg) {
    const ref = $dgG1Y.useRef($3921e5745a424df7$var$UNINITIALIZED);
    if (ref.current === $3921e5745a424df7$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("gy6Bh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c4f0fca97afeea$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $j7gCK = parcelRequire("j7gCK");

var $8MGTi = parcelRequire("8MGTi");

var $2wmnn = parcelRequire("2wmnn");

var $2OelD = parcelRequire("2OelD");
var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $j5zIr = parcelRequire("j5zIr");

var $7a4DL = parcelRequire("7a4DL");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
let $c0c4f0fca97afeea$var$_ = (t)=>t, $c0c4f0fca97afeea$var$t, $c0c4f0fca97afeea$var$t1, $c0c4f0fca97afeea$var$t2, $c0c4f0fca97afeea$var$t3;
const $c0c4f0fca97afeea$var$DURATION = 550;
const $c0c4f0fca97afeea$export$95d0c9356b2231a3 = 80;
const $c0c4f0fca97afeea$var$enterKeyframe = (0, $2OelD.keyframes)($c0c4f0fca97afeea$var$t || ($c0c4f0fca97afeea$var$t = $c0c4f0fca97afeea$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $c0c4f0fca97afeea$var$exitKeyframe = (0, $2OelD.keyframes)($c0c4f0fca97afeea$var$t1 || ($c0c4f0fca97afeea$var$t1 = $c0c4f0fca97afeea$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $c0c4f0fca97afeea$var$pulsateKeyframe = (0, $2OelD.keyframes)($c0c4f0fca97afeea$var$t2 || ($c0c4f0fca97afeea$var$t2 = $c0c4f0fca97afeea$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $c0c4f0fca97afeea$export$f6b7418508c72c25 = (0, $dTuzq.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $c0c4f0fca97afeea$export$676cfe7b12693c4b = (0, $dTuzq.default)((0, $j5zIr.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($c0c4f0fca97afeea$var$t3 || ($c0c4f0fca97afeea$var$t3 = $c0c4f0fca97afeea$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $7a4DL.default).rippleVisible, $c0c4f0fca97afeea$var$enterKeyframe, $c0c4f0fca97afeea$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $7a4DL.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $7a4DL.default).child, (0, $7a4DL.default).childLeaving, $c0c4f0fca97afeea$var$exitKeyframe, $c0c4f0fca97afeea$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $7a4DL.default).childPulsate, $c0c4f0fca97afeea$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c0c4f0fca97afeea$var$TouchRipple = /*#__PURE__*/ $dgG1Y.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $dgG1Y.useState([]);
    const nextKey = $dgG1Y.useRef(0);
    const rippleCallback = $dgG1Y.useRef(null);
    $dgG1Y.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $dgG1Y.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $2wmnn.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $dgG1Y.useRef(null);
    const container = $dgG1Y.useRef(null);
    const startCommit = $dgG1Y.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $fR5Jw.jsx)($c0c4f0fca97afeea$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $8MGTi.default)(classes.ripple, (0, $7a4DL.default).ripple),
                        rippleVisible: (0, $8MGTi.default)(classes.rippleVisible, (0, $7a4DL.default).rippleVisible),
                        ripplePulsate: (0, $8MGTi.default)(classes.ripplePulsate, (0, $7a4DL.default).ripplePulsate),
                        child: (0, $8MGTi.default)(classes.child, (0, $7a4DL.default).child),
                        childLeaving: (0, $8MGTi.default)(classes.childLeaving, (0, $7a4DL.default).childLeaving),
                        childPulsate: (0, $8MGTi.default)(classes.childPulsate, (0, $7a4DL.default).childPulsate)
                    },
                    timeout: $c0c4f0fca97afeea$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $dgG1Y.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event === null || event === void 0 ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event === null || event === void 0 ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event === null || event === void 0 ? void 0 : event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($c0c4f0fca97afeea$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $dgG1Y.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $dgG1Y.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event === null || event === void 0 ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $dgG1Y.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($c0c4f0fca97afeea$export$f6b7418508c72c25, {
        className: (0, $8MGTi.default)((0, $7a4DL.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $j7gCK.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $c0c4f0fca97afeea$export$2e2bcd8739ae039 = $c0c4f0fca97afeea$var$TouchRipple;

});
parcelRegister("j7gCK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deab90f13bcfd992$export$2e2bcd8739ae039; });

var $gppKd = parcelRequire("gppKd");

var $bh1oa = parcelRequire("bh1oa");

var $fONHp = parcelRequire("fONHp");

var $2BhAF = parcelRequire("2BhAF");


var $dgG1Y = parcelRequire("dgG1Y");

var $afFkE = parcelRequire("afFkE");

var $13hha = parcelRequire("13hha");
var $deab90f13bcfd992$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $deab90f13bcfd992$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $deab90f13bcfd992$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $2BhAF.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $fONHp.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $13hha.getInitialChildMapping)(nextProps, handleExited) : (0, $13hha.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $13hha.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $bh1oa.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $gppKd.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $deab90f13bcfd992$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement((0, $afFkE.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement((0, $afFkE.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).Component);
$deab90f13bcfd992$var$TransitionGroup.propTypes = {};
$deab90f13bcfd992$var$TransitionGroup.defaultProps = $deab90f13bcfd992$var$defaultProps;
var $deab90f13bcfd992$export$2e2bcd8739ae039 = $deab90f13bcfd992$var$TransitionGroup;

});
parcelRegister("13hha", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $0c4378de9ff44d00$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $0c4378de9ff44d00$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $0c4378de9ff44d00$export$36fd1af28d383ec0; });

var $dgG1Y = parcelRequire("dgG1Y");
function $0c4378de9ff44d00$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $dgG1Y.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $dgG1Y.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $0c4378de9ff44d00$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $0c4378de9ff44d00$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $0c4378de9ff44d00$export$fa71e2345c31d7a2(props, onExited) {
    return $0c4378de9ff44d00$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $dgG1Y.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $0c4378de9ff44d00$var$getProp(child, "appear", props),
            enter: $0c4378de9ff44d00$var$getProp(child, "enter", props),
            exit: $0c4378de9ff44d00$var$getProp(child, "exit", props)
        });
    });
}
function $0c4378de9ff44d00$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $0c4378de9ff44d00$export$bbc8a025727ea824(nextProps.children);
    var children = $0c4378de9ff44d00$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $dgG1Y.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $dgG1Y.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $dgG1Y.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $0c4378de9ff44d00$var$getProp(child, "exit", nextProps),
            enter: $0c4378de9ff44d00$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $dgG1Y.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $dgG1Y.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $dgG1Y.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $0c4378de9ff44d00$var$getProp(child, "exit", nextProps),
            enter: $0c4378de9ff44d00$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("2wmnn", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $1d5fed5cd80b8981$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $1d5fed5cd80b8981$export$2e2bcd8739ae039; });

var $d1GIu = parcelRequire("d1GIu");

var $4U760 = parcelRequire("4U760");

var $2l3om = parcelRequire("2l3om");
"use client";
class $1d5fed5cd80b8981$export$786b4da70f00938b {
    static create() {
        return new $1d5fed5cd80b8981$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        (0, $d1GIu._)(this, "currentId", null);
        (0, $d1GIu._)(this, "clear", ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        });
        (0, $d1GIu._)(this, "disposeEffect", ()=>{
            return this.clear;
        });
    }
}
function $1d5fed5cd80b8981$export$2e2bcd8739ae039() {
    const timeout = (0, $4U760.default)($1d5fed5cd80b8981$export$786b4da70f00938b.create).current;
    (0, $2l3om.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("2l3om", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b402c7fcad63cc0$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
const $1b402c7fcad63cc0$var$EMPTY = [];
function $1b402c7fcad63cc0$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $dgG1Y.useEffect(fn, $1b402c7fcad63cc0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("j5zIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de5a3063432478f1$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $de5a3063432478f1$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $dgG1Y.useState(false);
    const rippleClassName = (0, $8MGTi.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $8MGTi.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $dgG1Y.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
            className: childClassName
        })
    });
}
var $de5a3063432478f1$export$2e2bcd8739ae039 = $de5a3063432478f1$var$Ripple;

});

parcelRegister("7a4DL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $536d11114b259cfc$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $536d11114b259cfc$export$b464606f735ab902(slot) {
    return (0, $5xHgF.default)("MuiTouchRipple", slot);
}
const $536d11114b259cfc$var$touchRippleClasses = (0, $eFHYA.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $536d11114b259cfc$export$2e2bcd8739ae039 = $536d11114b259cfc$var$touchRippleClasses;

});


parcelRegister("sYTIC", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $0571daa6eec9df67$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $0571daa6eec9df67$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $0571daa6eec9df67$export$fccb0498dcd99783(slot) {
    return (0, $5xHgF.default)("MuiButtonBase", slot);
}
const $0571daa6eec9df67$var$buttonBaseClasses = (0, $eFHYA.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $0571daa6eec9df67$export$2e2bcd8739ae039 = $0571daa6eec9df67$var$buttonBaseClasses;

});


parcelRegister("5sogl", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $3f9263534cf6d700$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $3f9263534cf6d700$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $3f9263534cf6d700$export$5a6f9035944c8119(slot) {
    return (0, $5xHgF.default)("MuiButton", slot);
}
const $3f9263534cf6d700$var$buttonClasses = (0, $eFHYA.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $3f9263534cf6d700$export$2e2bcd8739ae039 = $3f9263534cf6d700$var$buttonClasses;

});

parcelRegister("7ZAQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d1ad02f3c560fd9$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ const $5d1ad02f3c560fd9$var$ButtonGroupContext = /*#__PURE__*/ $dgG1Y.createContext({});
var $5d1ad02f3c560fd9$export$2e2bcd8739ae039 = $5d1ad02f3c560fd9$var$ButtonGroupContext;

});

parcelRegister("6G8aj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dccffc86c5ccbdb$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ const $4dccffc86c5ccbdb$var$ButtonGroupButtonContext = /*#__PURE__*/ $dgG1Y.createContext(undefined);
var $4dccffc86c5ccbdb$export$2e2bcd8739ae039 = $4dccffc86c5ccbdb$var$ButtonGroupButtonContext;

});


parcelRegister("jayBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df49ca2d29ae0d91$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $kRnLR = parcelRequire("kRnLR");

var $aUrhR = parcelRequire("aUrhR");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $df49ca2d29ae0d91$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $aUrhR.getListUtilityClass), classes);
};
const $df49ca2d29ae0d91$var$ListRoot = (0, $dTuzq.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $df49ca2d29ae0d91$var$List = /*#__PURE__*/ $dgG1Y.forwardRef(function List(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $dgG1Y.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $df49ca2d29ae0d91$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kRnLR.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)($df49ca2d29ae0d91$var$ListRoot, {
            as: component,
            className: (0, $8MGTi.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $df49ca2d29ae0d91$export$2e2bcd8739ae039 = $df49ca2d29ae0d91$var$List;

});
parcelRegister("kRnLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03eb47014479c50d$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
/**
 * @ignore - internal component.
 */ const $03eb47014479c50d$var$ListContext = /*#__PURE__*/ $dgG1Y.createContext({});
var $03eb47014479c50d$export$2e2bcd8739ae039 = $03eb47014479c50d$var$ListContext;

});

parcelRegister("aUrhR", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $7f144d01086d1481$export$c6bd6795ed6e3203; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $7f144d01086d1481$export$c6bd6795ed6e3203(slot) {
    return (0, $5xHgF.default)("MuiList", slot);
}
const $7f144d01086d1481$var$listClasses = (0, $eFHYA.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $7f144d01086d1481$export$2e2bcd8739ae039 = $7f144d01086d1481$var$listClasses;

});


parcelRegister("f9Dhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0862aedaf902513$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");



var $a3KHH = parcelRequire("a3KHH");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $cG4rf = parcelRequire("cG4rf");

var $51QVq = parcelRequire("51QVq");

var $kRnLR = parcelRequire("kRnLR");

var $i9d0b = parcelRequire("i9d0b");

var $f2xUB = parcelRequire("f2xUB");

var $lTaI6 = parcelRequire("lTaI6");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $b0862aedaf902513$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $b0862aedaf902513$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction"
        ],
        container: [
            "container"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $i9d0b.getListItemUtilityClass), classes);
};
const $b0862aedaf902513$export$aed538f7519abe89 = (0, $dTuzq.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $b0862aedaf902513$export$4334bb34c76fef24
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left",
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $f2xUB.default).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: "flex-start"
                },
                style: {
                    alignItems: "flex-start"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: "padding-box"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create("background-color", {
                        duration: theme.transitions.duration.shortest
                    }),
                    "&:hover": {
                        textDecoration: "none",
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $b0862aedaf902513$var$ListItemContainer = (0, $dTuzq.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $b0862aedaf902513$var$ListItem = /*#__PURE__*/ $dgG1Y.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $dgG1Y.useContext((0, $kRnLR.default));
    const childContext = $dgG1Y.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $dgG1Y.useRef(null);
    const children = $dgG1Y.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $cG4rf.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $b0862aedaf902513$var$useUtilityClasses(ownerState);
    const handleRef = (0, $51QVq.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $b0862aedaf902513$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $8MGTi.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || "li";
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kRnLR.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)($b0862aedaf902513$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $8MGTi.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $a3KHH.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kRnLR.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $a3KHH.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lTaI6.default), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $b0862aedaf902513$export$2e2bcd8739ae039 = $b0862aedaf902513$var$ListItem;

});
parcelRegister("a3KHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $752e699e05ad0b30$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $752e699e05ad0b30$var$isHostComponent(element) {
    return typeof element === "string";
}
var $752e699e05ad0b30$export$2e2bcd8739ae039 = $752e699e05ad0b30$var$isHostComponent;

});

parcelRegister("cG4rf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93acd9aa4f34b467$export$2e2bcd8739ae039; });

var $oyGDr = parcelRequire("oyGDr");
var $93acd9aa4f34b467$export$2e2bcd8739ae039 = (0, $oyGDr.default);

});
parcelRegister("oyGDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $049d260ddc1b4452$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
function $049d260ddc1b4452$export$2e2bcd8739ae039(element, muiNames) {
    var _element_type__payload_value, _element_type__payload, _element_type;
    var // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    _element_type_muiName;
    return /*#__PURE__*/ $dgG1Y.isValidElement(element) && muiNames.indexOf((_element_type_muiName = element.type.muiName) !== null && _element_type_muiName !== void 0 ? _element_type_muiName : (_element_type = element.type) === null || _element_type === void 0 ? void 0 : (_element_type__payload = _element_type._payload) === null || _element_type__payload === void 0 ? void 0 : (_element_type__payload_value = _element_type__payload.value) === null || _element_type__payload_value === void 0 ? void 0 : _element_type__payload_value.muiName) !== -1;
}

});


parcelRegister("i9d0b", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", function () { return $d363272ec898164a$export$5682c366c0c669d9; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $d363272ec898164a$export$5682c366c0c669d9(slot) {
    return (0, $5xHgF.default)("MuiListItem", slot);
}
const $d363272ec898164a$var$listItemClasses = (0, $eFHYA.default)("MuiListItem", [
    "root",
    "container",
    "dense",
    "alignItemsFlexStart",
    "divider",
    "gutters",
    "padding",
    "secondaryAction"
]);
var $d363272ec898164a$export$2e2bcd8739ae039 = $d363272ec898164a$var$listItemClasses;

});

parcelRegister("f2xUB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af3159208b3b8a18$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $af3159208b3b8a18$export$c09531d8563c67a5(slot) {
    return (0, $5xHgF.default)("MuiListItemButton", slot);
}
const $af3159208b3b8a18$var$listItemButtonClasses = (0, $eFHYA.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $af3159208b3b8a18$export$2e2bcd8739ae039 = $af3159208b3b8a18$var$listItemButtonClasses;

});

parcelRegister("lTaI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef70adc6b43232e$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $kRnLR = parcelRequire("kRnLR");

var $9beON = parcelRequire("9beON");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $fef70adc6b43232e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $9beON.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $fef70adc6b43232e$var$ListItemSecondaryActionRoot = (0, $dTuzq.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: "absolute",
    right: 16,
    top: "50%",
    transform: "translateY(-50%)",
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $fef70adc6b43232e$var$ListItemSecondaryAction = /*#__PURE__*/ $dgG1Y.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className, ...other } = props;
    const context = $dgG1Y.useContext((0, $kRnLR.default));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $fef70adc6b43232e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($fef70adc6b43232e$var$ListItemSecondaryActionRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$fef70adc6b43232e$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $fef70adc6b43232e$export$2e2bcd8739ae039 = $fef70adc6b43232e$var$ListItemSecondaryAction;

});
parcelRegister("9beON", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", function () { return $6af0a2bea2b801ed$export$ccdb26aeba48a86e; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $6af0a2bea2b801ed$export$ccdb26aeba48a86e(slot) {
    return (0, $5xHgF.default)("MuiListItemSecondaryAction", slot);
}
const $6af0a2bea2b801ed$var$listItemSecondaryActionClasses = (0, $eFHYA.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $6af0a2bea2b801ed$export$2e2bcd8739ae039 = $6af0a2bea2b801ed$var$listItemSecondaryActionClasses;

});



parcelRegister("ewdxp", function(module, exports) {

$parcel$export(module.exports, "AuthContext", function () { return $1d3a6f7e1cbf529a$export$a0fd8390cfe8ae69; });

var $dgG1Y = parcelRequire("dgG1Y");
const $1d3a6f7e1cbf529a$export$a0fd8390cfe8ae69 = (0, $dgG1Y.createContext)({
    isLoggedIn: false,
    token: null,
    userId: null,
    email: null,
    tenant: null,
    error: null,
    authProvider: false,
    stripeStatus: null,
    tokenExpirationDate: null,
    accountableAdmin: false,
    supervisor: false,
    siteAdmin: false,
    harambe: false,
    provider: false,
    programProvider: false,
    program: false,
    client: false,
    wsClient: null,
    loading: true,
    login: ()=>{},
    logout: ()=>{},
    clearError: ()=>{},
    updateSettings: ()=>{},
    setAccountableAdmin: ()=>{},
    setSiteAdmin: ()=>{},
    setHarambe: ()=>{},
    setProvider: ()=>{},
    setProgram: ()=>{},
    setProgramProvider: ()=>{},
    setClient: ()=>{},
    setWsClient: ()=>{},
    setSupervisor: ()=>{}
});

});

parcelRegister("4sMUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33ffb6c54d6e8d44$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $fxPHS = parcelRequire("fxPHS");

var $1wSL5 = parcelRequire("1wSL5");

var $a3oUN = parcelRequire("a3oUN");

var $hh5ki = parcelRequire("hh5ki");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $9TQfG = parcelRequire("9TQfG");

var $3ulTJ = parcelRequire("3ulTJ");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $33ffb6c54d6e8d44$var$RADIUS_STANDARD = 10;
const $33ffb6c54d6e8d44$var$RADIUS_DOT = 4;
const $33ffb6c54d6e8d44$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, $9TQfG.default)(anchorOrigin.vertical)}${(0, $9TQfG.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $9TQfG.default)(anchorOrigin.vertical)}${(0, $9TQfG.default)(anchorOrigin.horizontal)}${(0, $9TQfG.default)(overlap)}`,
            `overlap${(0, $9TQfG.default)(overlap)}`,
            color !== "default" && `color${(0, $9TQfG.default)(color)}`
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $3ulTJ.getBadgeUtilityClass), classes);
};
const $33ffb6c54d6e8d44$var$BadgeRoot = (0, $dTuzq.default)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $33ffb6c54d6e8d44$var$BadgeBadge = (0, $dTuzq.default)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $9TQfG.default)(ownerState.anchorOrigin.vertical)}${(0, $9TQfG.default)(ownerState.anchorOrigin.horizontal)}${(0, $9TQfG.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $9TQfG.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $33ffb6c54d6e8d44$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $33ffb6c54d6e8d44$var$RADIUS_STANDARD * 2,
        borderRadius: $33ffb6c54d6e8d44$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $80lma.default)([
                "contrastText"
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: "dot"
                },
                style: {
                    borderRadius: $33ffb6c54d6e8d44$var$RADIUS_DOT,
                    height: $33ffb6c54d6e8d44$var$RADIUS_DOT * 2,
                    minWidth: $33ffb6c54d6e8d44$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $3ulTJ.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $33ffb6c54d6e8d44$var$getAnchorOrigin(anchorOrigin) {
    var _anchorOrigin_vertical, _anchorOrigin_horizontal;
    return {
        vertical: (_anchorOrigin_vertical = anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.vertical) !== null && _anchorOrigin_vertical !== void 0 ? _anchorOrigin_vertical : "top",
        horizontal: (_anchorOrigin_horizontal = anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.horizontal) !== null && _anchorOrigin_horizontal !== void 0 ? _anchorOrigin_horizontal : "right"
    };
}
const $33ffb6c54d6e8d44$var$Badge = /*#__PURE__*/ $dgG1Y.forwardRef(function Badge(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = "standard", ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $hh5ki.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $fxPHS.default)({
        anchorOrigin: $33ffb6c54d6e8d44$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $33ffb6c54d6e8d44$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $33ffb6c54d6e8d44$var$useUtilityClasses(ownerState);
    var _slots_root, _ref;
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots_root = slots === null || slots === void 0 ? void 0 : slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref !== void 0 ? _ref : $33ffb6c54d6e8d44$var$BadgeRoot;
    var _slots_badge, _ref1;
    const BadgeSlot = (_ref1 = (_slots_badge = slots === null || slots === void 0 ? void 0 : slots.badge) !== null && _slots_badge !== void 0 ? _slots_badge : components.Badge) !== null && _ref1 !== void 0 ? _ref1 : $33ffb6c54d6e8d44$var$BadgeBadge;
    var _slotProps_root;
    const rootSlotProps = (_slotProps_root = slotProps === null || slotProps === void 0 ? void 0 : slotProps.root) !== null && _slotProps_root !== void 0 ? _slotProps_root : componentsProps.root;
    var _slotProps_badge;
    const badgeSlotProps = (_slotProps_badge = slotProps === null || slotProps === void 0 ? void 0 : slotProps.badge) !== null && _slotProps_badge !== void 0 ? _slotProps_badge : componentsProps.badge;
    const rootProps = (0, $a3oUN.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $8MGTi.default)(rootSlotProps === null || rootSlotProps === void 0 ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $a3oUN.default)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $8MGTi.default)(classes.badge, badgeSlotProps === null || badgeSlotProps === void 0 ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $fR5Jw.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $33ffb6c54d6e8d44$export$2e2bcd8739ae039 = $33ffb6c54d6e8d44$var$Badge;

});
parcelRegister("fxPHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5120bf7de5e8903$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
const $b5120bf7de5e8903$var$usePreviousProps = (value)=>{
    const ref = $dgG1Y.useRef({});
    $dgG1Y.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $b5120bf7de5e8903$export$2e2bcd8739ae039 = $b5120bf7de5e8903$var$usePreviousProps;

});

parcelRegister("a3oUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $751d82d28a1b39b1$export$2e2bcd8739ae039; });

var $1ZLdA = parcelRequire("1ZLdA");

var $WPBOJ = parcelRequire("WPBOJ");

var $eZ4aO = parcelRequire("eZ4aO");

var $9oznn = parcelRequire("9oznn");
"use client";
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $751d82d28a1b39b1$var$useSlotProps(parameters) {
    var _parameters_additionalProps;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $9oznn.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $eZ4aO.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $1ZLdA.default)(internalRef, resolvedComponentsProps === null || resolvedComponentsProps === void 0 ? void 0 : resolvedComponentsProps.ref, (_parameters_additionalProps = parameters.additionalProps) === null || _parameters_additionalProps === void 0 ? void 0 : _parameters_additionalProps.ref);
    const props = (0, $WPBOJ.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $751d82d28a1b39b1$export$2e2bcd8739ae039 = $751d82d28a1b39b1$var$useSlotProps;

});

parcelRegister("hh5ki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93827e2d02f9224$export$2e2bcd8739ae039; });

var $fxPHS = parcelRequire("fxPHS");
"use client";
/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $c93827e2d02f9224$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $fxPHS.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $c93827e2d02f9224$export$2e2bcd8739ae039 = $c93827e2d02f9224$var$useBadge;

});

parcelRegister("3ulTJ", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", function () { return $28a528e1a8d96196$export$aaccef17e6dab084; });
$parcel$export(module.exports, "default", function () { return $28a528e1a8d96196$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $28a528e1a8d96196$export$aaccef17e6dab084(slot) {
    return (0, $5xHgF.default)("MuiBadge", slot);
}
const $28a528e1a8d96196$var$badgeClasses = (0, $eFHYA.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
var $28a528e1a8d96196$export$2e2bcd8739ae039 = $28a528e1a8d96196$var$badgeClasses;

});


parcelRegister("4VA2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $396870ccf0d14353$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $fX4dN = parcelRequire("fX4dN");

var $9TQfG = parcelRequire("9TQfG");

var $dGKWP = parcelRequire("dGKWP");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $396870ccf0d14353$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $9TQfG.default)(color)}`,
            edge && `edge${(0, $9TQfG.default)(edge)}`,
            `size${(0, $9TQfG.default)(size)}`
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $dGKWP.getIconButtonUtilityClass), classes);
};
const $396870ccf0d14353$var$IconButtonRoot = (0, $dTuzq.default)((0, $fX4dN.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $9TQfG.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $9TQfG.default)(ownerState.edge)}`],
            styles[`size${(0, $9TQfG.default)(ownerState.size)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    "--IconButton-hoverBg": theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    "&:hover": {
                        backgroundColor: "var(--IconButton-hoverBg)",
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            },
            {
                props: {
                    edge: "start"
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: "start",
                    size: "small"
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: "end"
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: "end",
                    size: "small"
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $iIVKJ.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: "inherit"
                },
                style: {
                    color: "inherit"
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $80lma.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        "--IconButton-hoverBg": theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: "small"
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: "large"
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $dGKWP.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    })));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $396870ccf0d14353$var$IconButton = /*#__PURE__*/ $dgG1Y.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium", ...other } = props;
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    };
    const classes = $396870ccf0d14353$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($396870ccf0d14353$var$IconButtonRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children
    });
});
var $396870ccf0d14353$export$2e2bcd8739ae039 = $396870ccf0d14353$var$IconButton;

});
parcelRegister("dGKWP", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $9f739d7491af8463$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $9f739d7491af8463$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $9f739d7491af8463$export$5e8702d71474f093(slot) {
    return (0, $5xHgF.default)("MuiIconButton", slot);
}
const $9f739d7491af8463$var$iconButtonClasses = (0, $eFHYA.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $9f739d7491af8463$export$2e2bcd8739ae039 = $9f739d7491af8463$var$iconButtonClasses;

});


parcelRegister("7nM5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55fffcf5ac21fa6b$export$2e2bcd8739ae039; });

var $2gobp = parcelRequire("2gobp");
var $55fffcf5ac21fa6b$export$2e2bcd8739ae039 = (0, $2gobp.default);

});

parcelRegister("lUlBP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff2f970ad4a96806$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $2wmnn = parcelRequire("2wmnn");


var $bEw0x = parcelRequire("bEw0x");

var $dlCX6 = parcelRequire("dlCX6");

var $kngbJ = parcelRequire("kngbJ");

var $bDI8z = parcelRequire("bDI8z");

var $51QVq = parcelRequire("51QVq");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $ff2f970ad4a96806$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $ff2f970ad4a96806$var$styles = {
    entering: {
        opacity: 1,
        transform: $ff2f970ad4a96806$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $ff2f970ad4a96806$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $ff2f970ad4a96806$var$Grow = /*#__PURE__*/ $dgG1Y.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dlCX6.default), ...other } = props;
    const timer = (0, $2wmnn.default)();
    const autoTimeout = $dgG1Y.useRef();
    const theme = (0, $kngbJ.default)();
    const nodeRef = $dgG1Y.useRef(null);
    const handleRef = (0, $51QVq.default)(nodeRef, (0, $bEw0x.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $bDI8z.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $bDI8z.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $ff2f970ad4a96806$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $bDI8z.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $ff2f970ad4a96806$var$isWebKit154 ? duration : duration * 0.666,
                delay: $ff2f970ad4a96806$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $ff2f970ad4a96806$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $dgG1Y.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $ff2f970ad4a96806$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...$ff2f970ad4a96806$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($ff2f970ad4a96806$var$Grow) $ff2f970ad4a96806$var$Grow.muiSupportAuto = true;
var $ff2f970ad4a96806$export$2e2bcd8739ae039 = $ff2f970ad4a96806$var$Grow;

});

parcelRegister("2MkBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20600cc48965d8ec$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $5GllH = parcelRequire("5GllH");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $20600cc48965d8ec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $5GllH.getToolbarUtilityClass), classes);
};
const $20600cc48965d8ec$var$ToolbarRoot = (0, $dTuzq.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up("sm")]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: "dense"
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: "regular"
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $20600cc48965d8ec$var$Toolbar = /*#__PURE__*/ $dgG1Y.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular", ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $20600cc48965d8ec$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($20600cc48965d8ec$var$ToolbarRoot, {
        as: component,
        className: (0, $8MGTi.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $20600cc48965d8ec$export$2e2bcd8739ae039 = $20600cc48965d8ec$var$Toolbar;

});
parcelRegister("5GllH", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $42316f71454458c9$export$b12cb262231eef32; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $42316f71454458c9$export$b12cb262231eef32(slot) {
    return (0, $5xHgF.default)("MuiToolbar", slot);
}
const $42316f71454458c9$var$toolbarClasses = (0, $eFHYA.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $42316f71454458c9$export$2e2bcd8739ae039 = $42316f71454458c9$var$toolbarClasses;

});


parcelRegister("kqcrq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eddfe2f40e5593fe$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $lBH8Z = parcelRequire("lBH8Z");
var $iJ8f3 = parcelRequire("iJ8f3");
var $erWIP = parcelRequire("erWIP");
var $gpxpg = parcelRequire("gpxpg");
var $jayBd = parcelRequire("jayBd");
var $f9Dhz = parcelRequire("f9Dhz");
var $8Zcdm = parcelRequire("8Zcdm");
var $kMmDg = parcelRequire("kMmDg");

var $lxR1S = parcelRequire("lxR1S");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $en0cX = parcelRequire("en0cX");

var $6PhUi = parcelRequire("6PhUi");

var $aviiX = parcelRequire("aviiX");

var $EDk0j = parcelRequire("EDk0j");

var $fD19N = parcelRequire("fD19N");

var $d9ASo = parcelRequire("d9ASo");
const $eddfe2f40e5593fe$var$NotificationsMenu = (props)=>{
    const { isLoading: isLoading, error: error, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const [showBACAlerts, setShowBACAlerts] = (0, $dgG1Y.useState)(false);
    const [showSMS, setShowSMS] = (0, $dgG1Y.useState)(false);
    const [showTox, setShowTox] = (0, $dgG1Y.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $dgG1Y.useState)(false);
    const [notifications, setNotifications] = (0, $dgG1Y.useState)([]);
    const readNotification = async (event)=>{
        event.preventDefault();
        const { value: value } = event.currentTarget;
        try {
            await fetch("https://apiv2.youareaccountable.com/api/notification/clearNotifications", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + props.auth.token
                },
                body: JSON.stringify({
                    id: value
                })
            });
            const newNotifications = notifications.filter((notification)=>notification._id !== value);
            setNotifications(newNotifications);
            props.onNotificationRead(newNotifications);
        } catch (err) {
            console.error(err);
        }
    };
    const closeAll = ()=>{
        setShowBACAlerts(false);
        setShowSMS(false);
        setSelectedUser(false);
        setShowTox(false);
    };
    (0, $dgG1Y.useEffect)(()=>{
        setNotifications(props.notifications);
    }, [
        props.notifications
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Team Member",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            showTox && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aviiX.default), {
                open: showTox,
                close: closeAll,
                title: "Tox Alerts",
                ChildComponent: (0, $fD19N.default),
                selectedUser: selectedUser,
                size: "md"
            }),
            showBACAlerts && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aviiX.default), {
                open: showBACAlerts,
                close: closeAll,
                title: "BAC Alerts",
                ChildComponent: (0, $6PhUi.default),
                selectedUser: selectedUser,
                size: "md"
            }),
            showSMS && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aviiX.default), {
                open: showSMS,
                close: closeAll,
                title: "Communication",
                ChildComponent: (0, $EDk0j.default),
                selectedUser: selectedUser,
                size: "md"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $erWIP.default), {
                sx: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gpxpg.default), {
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                            sx: {
                                fontWeight: 700
                            },
                            color: "textSecondary",
                            variant: "h6",
                            gutterBottom: true,
                            children: "MY NOTIFICATIONS"
                        }),
                        props.auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
                            mb: 2,
                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $d9ASo.default), {
                                auth: props.auth,
                                arsUser: props.arsUser,
                                handleSetArsUser: props.handleSetArsUser,
                                filterByARS: props.filterByARS,
                                arsOnly: true
                            })
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jayBd.default), {
                            children: notifications && notifications.map((notification)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $f9Dhz.default), {
                                    sx: {
                                        marginBottom: 2,
                                        borderRadius: 2,
                                        backgroundColor: "background.paper",
                                        boxShadow: 2,
                                        position: "relative",
                                        pl: 7
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                            sx: {
                                                position: "absolute",
                                                left: 8,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                minWidth: "auto",
                                                padding: 0.5
                                            },
                                            onClick: readNotification,
                                            value: notification._id,
                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lxR1S.default), {
                                                color: "error"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8Zcdm.default), {
                                            primary: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                                                variant: "h4",
                                                children: notification.notification
                                            }),
                                            secondary: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $kMmDg.default), {
                                                        variant: "body1",
                                                        color: "textSecondary",
                                                        children: [
                                                            "User timezone: ",
                                                            notification.User.timeZone
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                                                        variant: "body1",
                                                        color: "textSecondary",
                                                        children: new Date(notification.date).toLocaleDateString()
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
                                                        sx: {
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            gap: 1,
                                                            marginTop: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                                                variant: "contained",
                                                                size: "small",
                                                                color: "secondary",
                                                                sx: {
                                                                    fontSize: {
                                                                        xs: "0.7rem",
                                                                        sm: "0.8rem"
                                                                    },
                                                                    padding: {
                                                                        xs: "4px 8px",
                                                                        sm: "6px 16px"
                                                                    }
                                                                },
                                                                onClick: ()=>{
                                                                    setShowBACAlerts(true);
                                                                    setSelectedUser(notification.User._id || notification.User);
                                                                },
                                                                children: "BAC Records"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                                                variant: "contained",
                                                                size: "small",
                                                                color: "secondary",
                                                                sx: {
                                                                    fontSize: {
                                                                        xs: "0.7rem",
                                                                        sm: "0.8rem"
                                                                    },
                                                                    padding: {
                                                                        xs: "4px 8px",
                                                                        sm: "6px 16px"
                                                                    }
                                                                },
                                                                onClick: ()=>{
                                                                    setShowTox(true);
                                                                    setSelectedUser(notification.User._id);
                                                                },
                                                                children: "Tox Records"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                                                variant: "contained",
                                                                size: "small",
                                                                color: "secondary",
                                                                sx: {
                                                                    fontSize: {
                                                                        xs: "0.7rem",
                                                                        sm: "0.8rem"
                                                                    },
                                                                    padding: {
                                                                        xs: "4px 8px",
                                                                        sm: "6px 16px"
                                                                    }
                                                                },
                                                                onClick: ()=>{
                                                                    setShowSMS(true);
                                                                    setSelectedUser(notification.User._id);
                                                                },
                                                                children: "Communication"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, notification._id))
                        }),
                        props.notifications.length === 0 && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                            variant: "body1",
                            align: "center",
                            children: "No Notifications For Now!"
                        })
                    ]
                })
            })
        ]
    });
};
var $eddfe2f40e5593fe$export$2e2bcd8739ae039 = $eddfe2f40e5593fe$var$NotificationsMenu;

});
parcelRegister("erWIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8512345ff513c1f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $cBhUq = parcelRequire("cBhUq");

var $2zkCe = parcelRequire("2zkCe");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $a8512345ff513c1f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $2zkCe.getCardUtilityClass), classes);
};
const $a8512345ff513c1f$var$CardRoot = (0, $dTuzq.default)((0, $cBhUq.default), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: "hidden"
});
const $a8512345ff513c1f$var$Card = /*#__PURE__*/ $dgG1Y.forwardRef(function Card(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $a8512345ff513c1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($a8512345ff513c1f$var$CardRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $a8512345ff513c1f$export$2e2bcd8739ae039 = $a8512345ff513c1f$var$Card;

});
parcelRegister("2zkCe", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", function () { return $1deed77cc875bf75$export$f3b76d2cce458caa; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $1deed77cc875bf75$export$f3b76d2cce458caa(slot) {
    return (0, $5xHgF.default)("MuiCard", slot);
}
const $1deed77cc875bf75$var$cardClasses = (0, $eFHYA.default)("MuiCard", [
    "root"
]);
var $1deed77cc875bf75$export$2e2bcd8739ae039 = $1deed77cc875bf75$var$cardClasses;

});


parcelRegister("gpxpg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf28e4f7ec8cddb0$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $jEZfn = parcelRequire("jEZfn");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $bf28e4f7ec8cddb0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $jEZfn.getCardContentUtilityClass), classes);
};
const $bf28e4f7ec8cddb0$var$CardContentRoot = (0, $dTuzq.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    "&:last-child": {
        paddingBottom: 24
    }
});
const $bf28e4f7ec8cddb0$var$CardContent = /*#__PURE__*/ $dgG1Y.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div", ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $bf28e4f7ec8cddb0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($bf28e4f7ec8cddb0$var$CardContentRoot, {
        as: component,
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $bf28e4f7ec8cddb0$export$2e2bcd8739ae039 = $bf28e4f7ec8cddb0$var$CardContent;

});
parcelRegister("jEZfn", function(module, exports) {

$parcel$export(module.exports, "getCardContentUtilityClass", function () { return $e501432134f03b99$export$964336739a8c7119; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $e501432134f03b99$export$964336739a8c7119(slot) {
    return (0, $5xHgF.default)("MuiCardContent", slot);
}
const $e501432134f03b99$var$cardContentClasses = (0, $eFHYA.default)("MuiCardContent", [
    "root"
]);
var $e501432134f03b99$export$2e2bcd8739ae039 = $e501432134f03b99$var$cardContentClasses;

});


parcelRegister("8Zcdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68ad7ec1f862893c$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $kMmDg = parcelRequire("kMmDg");
var $bcP3f = parcelRequire("bcP3f");

var $kRnLR = parcelRequire("kRnLR");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $5xeEX = parcelRequire("5xeEX");

var $eAnru = parcelRequire("eAnru");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $68ad7ec1f862893c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $5xeEX.getListItemTextUtilityClass), classes);
};
const $68ad7ec1f862893c$var$ListItemTextRoot = (0, $dTuzq.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5xeEX.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $5xeEX.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: "1 1 auto",
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $bcP3f.default).root}:where(& .${(0, $5xeEX.default).primary})`]: {
        display: "block"
    },
    [`.${(0, $bcP3f.default).root}:where(& .${(0, $5xeEX.default).secondary})`]: {
        display: "block"
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $68ad7ec1f862893c$var$ListItemText = /*#__PURE__*/ $dgG1Y.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $dgG1Y.useContext((0, $kRnLR.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $68ad7ec1f862893c$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [PrimarySlot, primarySlotProps] = (0, $eAnru.default)("primary", {
        className: classes.primary,
        elementType: (0, $kMmDg.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $eAnru.default)("secondary", {
        className: classes.secondary,
        elementType: (0, $kMmDg.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $kMmDg.default) && !disableTypography) primary = /*#__PURE__*/ (0, $fR5Jw.jsx)(PrimarySlot, {
        variant: dense ? "body2" : "body1",
        component: (primarySlotProps === null || primarySlotProps === void 0 ? void 0 : primarySlotProps.variant) ? undefined : "span",
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $kMmDg.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $fR5Jw.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($68ad7ec1f862893c$var$ListItemTextRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            primary,
            secondary
        ]
    });
});
var $68ad7ec1f862893c$export$2e2bcd8739ae039 = $68ad7ec1f862893c$var$ListItemText;

});
parcelRegister("5xeEX", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", function () { return $407b67edfd4a142e$export$1061006a0db3aeb5; });
$parcel$export(module.exports, "default", function () { return $407b67edfd4a142e$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $407b67edfd4a142e$export$1061006a0db3aeb5(slot) {
    return (0, $5xHgF.default)("MuiListItemText", slot);
}
const $407b67edfd4a142e$var$listItemTextClasses = (0, $eFHYA.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $407b67edfd4a142e$export$2e2bcd8739ae039 = $407b67edfd4a142e$var$listItemTextClasses;

});


parcelRegister("lxR1S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf5d08d5b93b9cd$export$2e2bcd8739ae039; });

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $faf5d08d5b93b9cd$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircle");

});

parcelRegister("56aO2", function(module, exports) {

$parcel$export(module.exports, "useHttpClient", function () { return $a48db6af47b00bae$export$432302c8a11bb372; });

var $dgG1Y = parcelRequire("dgG1Y");
const $a48db6af47b00bae$export$432302c8a11bb372 = ()=>{
    const [isLoading, setIsLoading] = (0, $dgG1Y.useState)(false);
    const [error, setError] = (0, $dgG1Y.useState)(null);
    const activeHttpRequests = (0, $dgG1Y.useRef)([]);
    const sendRequest = (0, $dgG1Y.useCallback)(async (url, method = "GET", body = null, headers = {})=>{
        try {
            setIsLoading(true);
            const httpAbortCtrl = new AbortController();
            activeHttpRequests.current.push(httpAbortCtrl);
            const response = await fetch(url, {
                method: method,
                body: body,
                headers: headers,
                signal: httpAbortCtrl.signal
            });
            const responseData = await response.json();
            activeHttpRequests.current = activeHttpRequests.current.filter((reqCtrl)=>reqCtrl !== httpAbortCtrl);
            if (!response.ok) throw new Error(responseData.message || "An error occurred");
            setIsLoading(false);
            return responseData;
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err));
            setIsLoading(false);
            throw err;
        }
    }, []);
    const clearError = (0, $dgG1Y.useCallback)(()=>{
        setError(null);
    }, []);
    return {
        isLoading: isLoading,
        error: error,
        sendRequest: sendRequest,
        clearError: clearError
    };
};

});

parcelRegister("en0cX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7635fff130a501b$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $iJ8f3 = parcelRequire("iJ8f3");

var $9EE4V = parcelRequire("9EE4V");

var $3kUUy = parcelRequire("3kUUy");

var $2gTUh = parcelRequire("2gTUh");

var $aXBMD = parcelRequire("aXBMD");

var $9f741 = parcelRequire("9f741");
const $a7635fff130a501b$var$ErrorModal = (props)=>{
    const handleClose = ()=>{
        props.clearError();
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
        open: props.open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        fullWidth: true,
        maxWidth: props.size || "sm",
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9f741.default), {
                children: props.title
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2gTUh.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $aXBMD.default), {
                    children: [
                        props.alert,
                        props.supportEmail && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                "For additional support, please contact:",
                                " ",
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("a", {
                                    href: `mailto:${props.supportEmail}`,
                                    children: props.supportEmail
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3kUUy.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $iJ8f3.default), {
                    onClick: handleClose,
                    fullWidth: props.fullWidth || false,
                    variant: props.variant || "text",
                    color: "primary",
                    autoFocus: true,
                    children: [
                        props.buttonTitle || "Close",
                        " "
                    ]
                })
            })
        ]
    });
};
var $a7635fff130a501b$export$2e2bcd8739ae039 = $a7635fff130a501b$var$ErrorModal;

});
parcelRegister("9EE4V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7076f03a931231d3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $383VY = parcelRequire("383VY");

var $9TQfG = parcelRequire("9TQfG");

var $kDVit = parcelRequire("kDVit");

var $7YCge = parcelRequire("7YCge");

var $cBhUq = parcelRequire("cBhUq");

var $8CnVv = parcelRequire("8CnVv");

var $bwffF = parcelRequire("bwffF");

var $1cwyu = parcelRequire("1cwyu");

var $dTuzq = parcelRequire("dTuzq");
var $kngbJ = parcelRequire("kngbJ");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $7076f03a931231d3$var$DialogBackdrop = (0, $dTuzq.default)((0, $1cwyu.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7076f03a931231d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $9TQfG.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $9TQfG.default)(scroll)}`,
            `paperWidth${(0, $9TQfG.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $8CnVv.getDialogUtilityClass), classes);
};
const $7076f03a931231d3$var$DialogRoot = (0, $dTuzq.default)((0, $kDVit.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $7076f03a931231d3$var$DialogContainer = (0, $dTuzq.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $9TQfG.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: "100%",
    "@media print": {
        height: "auto"
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: "paper"
            },
            style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        },
        {
            props: {
                scroll: "body"
            },
            style: {
                overflowY: "auto",
                overflowX: "hidden",
                textAlign: "center",
                "&::after": {
                    content: '""',
                    display: "inline-block",
                    verticalAlign: "middle",
                    height: "100%",
                    width: "0"
                }
            }
        }
    ]
});
const $7076f03a931231d3$var$DialogPaper = (0, $dTuzq.default)((0, $cBhUq.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $9TQfG.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $9TQfG.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        },
        variants: [
            {
                props: {
                    scroll: "paper"
                },
                style: {
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "calc(100% - 64px)"
                }
            },
            {
                props: {
                    scroll: "body"
                },
                style: {
                    display: "inline-block",
                    verticalAlign: "middle",
                    textAlign: "initial"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: "calc(100% - 64px)"
                }
            },
            {
                props: {
                    maxWidth: "xs"
                },
                style: {
                    maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $8CnVv.default).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: "calc(100% - 64px)"
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== "xs").map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $8CnVv.default).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: "calc(100% - 64px)"
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: "calc(100% - 64px)"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: "100%",
                    maxWidth: "100%",
                    height: "100%",
                    maxHeight: "none",
                    borderRadius: 0,
                    [`&.${(0, $8CnVv.default).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: "100%"
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7076f03a931231d3$var$Dialog = /*#__PURE__*/ $dgG1Y.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $kngbJ.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, "aria-modal": ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $cBhUq.default), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $7YCge.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $7076f03a931231d3$var$useUtilityClasses(ownerState);
    const backdropClick = $dgG1Y.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $383VY.default)(ariaLabelledbyProp);
    const dialogContextValue = $dgG1Y.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($7076f03a931231d3$var$DialogRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7076f03a931231d3$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...BackdropProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionComponent, {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation",
            ...TransitionProps,
            children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7076f03a931231d3$var$DialogContainer, {
                className: (0, $8MGTi.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7076f03a931231d3$var$DialogPaper, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...PaperProps,
                    className: (0, $8MGTi.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $bwffF.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $7076f03a931231d3$export$2e2bcd8739ae039 = $7076f03a931231d3$var$Dialog;

});
parcelRegister("383VY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24752bb1c2065b54$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
let $24752bb1c2065b54$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $24752bb1c2065b54$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $dgG1Y.useState(idOverride);
    const id = idOverride || defaultId;
    $dgG1Y.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $24752bb1c2065b54$var$globalId += 1;
            setDefaultId(`mui-${$24752bb1c2065b54$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $24752bb1c2065b54$var$safeReact = {
    ...$dgG1Y
};
const $24752bb1c2065b54$var$maybeReactUseId = $24752bb1c2065b54$var$safeReact.useId;
function $24752bb1c2065b54$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($24752bb1c2065b54$var$maybeReactUseId !== undefined) {
        const reactId = $24752bb1c2065b54$var$maybeReactUseId();
        return idOverride !== null && idOverride !== void 0 ? idOverride : reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $24752bb1c2065b54$var$useGlobalId(idOverride);
}

});

parcelRegister("8CnVv", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $64646ea7ece433ba$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $64646ea7ece433ba$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $64646ea7ece433ba$export$2177af0aa15c34c2(slot) {
    return (0, $5xHgF.default)("MuiDialog", slot);
}
const $64646ea7ece433ba$var$dialogClasses = (0, $eFHYA.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $64646ea7ece433ba$export$2e2bcd8739ae039 = $64646ea7ece433ba$var$dialogClasses;

});

parcelRegister("bwffF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $862e838c3c5b276f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
const $862e838c3c5b276f$var$DialogContext = /*#__PURE__*/ $dgG1Y.createContext({});
var $862e838c3c5b276f$export$2e2bcd8739ae039 = $862e838c3c5b276f$var$DialogContext;

});


parcelRegister("3kUUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26df62b6f9faad2b$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $4RPzo = parcelRequire("4RPzo");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $26df62b6f9faad2b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $4RPzo.getDialogActionsUtilityClass), classes);
};
const $26df62b6f9faad2b$var$DialogActionsRoot = (0, $dTuzq.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: "flex",
    alignItems: "center",
    padding: 8,
    justifyContent: "flex-end",
    flex: "0 0 auto",
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                "& > :not(style) ~ :not(style)": {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $26df62b6f9faad2b$var$DialogActions = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $26df62b6f9faad2b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($26df62b6f9faad2b$var$DialogActionsRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $26df62b6f9faad2b$export$2e2bcd8739ae039 = $26df62b6f9faad2b$var$DialogActions;

});
parcelRegister("4RPzo", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", function () { return $38b41d5f14e7bc99$export$5e57a444791c63be; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $38b41d5f14e7bc99$export$5e57a444791c63be(slot) {
    return (0, $5xHgF.default)("MuiDialogActions", slot);
}
const $38b41d5f14e7bc99$var$dialogActionsClasses = (0, $eFHYA.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $38b41d5f14e7bc99$export$2e2bcd8739ae039 = $38b41d5f14e7bc99$var$dialogActionsClasses;

});


parcelRegister("2gTUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a7871496b585e83$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $7niuk = parcelRequire("7niuk");

var $g1mpx = parcelRequire("g1mpx");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $1a7871496b585e83$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $7niuk.getDialogContentUtilityClass), classes);
};
const $1a7871496b585e83$var$DialogContentRoot = (0, $dTuzq.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px",
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: "16px 24px",
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $g1mpx.default).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $1a7871496b585e83$var$DialogContent = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $1a7871496b585e83$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($1a7871496b585e83$var$DialogContentRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $1a7871496b585e83$export$2e2bcd8739ae039 = $1a7871496b585e83$var$DialogContent;

});
parcelRegister("7niuk", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", function () { return $55e905c4513e4bfe$export$61b0ee1f05fb344e; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $55e905c4513e4bfe$export$61b0ee1f05fb344e(slot) {
    return (0, $5xHgF.default)("MuiDialogContent", slot);
}
const $55e905c4513e4bfe$var$dialogContentClasses = (0, $eFHYA.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $55e905c4513e4bfe$export$2e2bcd8739ae039 = $55e905c4513e4bfe$var$dialogContentClasses;

});

parcelRegister("g1mpx", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", function () { return $ba9e1fa97c189b8e$export$f5d2ec7e4c47e088; });
$parcel$export(module.exports, "default", function () { return $ba9e1fa97c189b8e$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $ba9e1fa97c189b8e$export$f5d2ec7e4c47e088(slot) {
    return (0, $5xHgF.default)("MuiDialogTitle", slot);
}
const $ba9e1fa97c189b8e$var$dialogTitleClasses = (0, $eFHYA.default)("MuiDialogTitle", [
    "root"
]);
var $ba9e1fa97c189b8e$export$2e2bcd8739ae039 = $ba9e1fa97c189b8e$var$dialogTitleClasses;

});


parcelRegister("aXBMD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7facb917cd1ff7a3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $kMmDg = parcelRequire("kMmDg");

var $ljKE7 = parcelRequire("ljKE7");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $7facb917cd1ff7a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $ljKE7.getDialogContentTextUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $7facb917cd1ff7a3$var$DialogContentTextRoot = (0, $dTuzq.default)((0, $kMmDg.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $7facb917cd1ff7a3$var$DialogContentText = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $7facb917cd1ff7a3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($7facb917cd1ff7a3$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $8MGTi.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $7facb917cd1ff7a3$export$2e2bcd8739ae039 = $7facb917cd1ff7a3$var$DialogContentText;

});
parcelRegister("ljKE7", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", function () { return $f84f8e43724c6274$export$d9c6dc45f75b0e4f; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $f84f8e43724c6274$export$d9c6dc45f75b0e4f(slot) {
    return (0, $5xHgF.default)("MuiDialogContentText", slot);
}
const $f84f8e43724c6274$var$dialogContentTextClasses = (0, $eFHYA.default)("MuiDialogContentText", [
    "root"
]);
var $f84f8e43724c6274$export$2e2bcd8739ae039 = $f84f8e43724c6274$var$dialogContentTextClasses;

});


parcelRegister("9f741", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6baafe8880de47c3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $kMmDg = parcelRequire("kMmDg");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $g1mpx = parcelRequire("g1mpx");

var $bwffF = parcelRequire("bwffF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $6baafe8880de47c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $g1mpx.getDialogTitleUtilityClass), classes);
};
const $6baafe8880de47c3$var$DialogTitleRoot = (0, $dTuzq.default)((0, $kMmDg.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $6baafe8880de47c3$var$DialogTitle = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $6baafe8880de47c3$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $dgG1Y.useContext((0, $bwffF.default));
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($6baafe8880de47c3$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp !== null && idProp !== void 0 ? idProp : titleId,
        ...other
    });
});
var $6baafe8880de47c3$export$2e2bcd8739ae039 = $6baafe8880de47c3$var$DialogTitle;

});


parcelRegister("6PhUi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4f85657b1ce6b823$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $en0cX = parcelRequire("en0cX");

var $4m0VC = parcelRequire("4m0VC");
var $7efta = parcelRequire("7efta");
var $hEZLG = parcelRequire("hEZLG");
var $gJFkA = parcelRequire("gJFkA");
var $5MowX = parcelRequire("5MowX");
var $f2CoU = parcelRequire("f2CoU");
var $1u2lJ = parcelRequire("1u2lJ");
var $12a5h = parcelRequire("12a5h");
var $hMt12 = parcelRequire("hMt12");
var $k0kWg = parcelRequire("k0kWg");
var $1QHfa = parcelRequire("1QHfa");

var $h2Xtr = parcelRequire("h2Xtr");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $04Fi6 = parcelRequire("04Fi6");

var $5t9Vu = parcelRequire("5t9Vu");

var $hgbGA = parcelRequire("hgbGA");

var $8wOzK = parcelRequire("8wOzK");

var $gElWY = parcelRequire("gElWY");

var $T5LKB = parcelRequire("T5LKB");



var $cxFzf = parcelRequire("cxFzf");

var $axbIu = parcelRequire("axbIu");

var $bocI1 = parcelRequire("bocI1");

var $5wep2 = parcelRequire("5wep2");

var $jFtgc = parcelRequire("jFtgc");

var $7RXGR = parcelRequire("7RXGR");

var $jYTVM = parcelRequire("jYTVM");

var $4C1tJ = parcelRequire("4C1tJ");

var $d9ASo = parcelRequire("d9ASo");

var $caSAq = parcelRequire("caSAq");

var $6wnIC = parcelRequire("6wnIC");
(0, (/*@__PURE__*/$parcel$interopDefault($jFtgc))).vfs = (0, (/*@__PURE__*/$parcel$interopDefault($7RXGR))).pdfMake.vfs;
const $4f85657b1ce6b823$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(6)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        add: {
            alignContent: "right"
        }
    }));
const $4f85657b1ce6b823$var$VendorAlerts = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $4f85657b1ce6b823$var$useStyles();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [showModal, setShowModal] = (0, $dgG1Y.useState)(false);
    const [toxes, setToxes] = (0, $dgG1Y.useState)([]);
    const [editTox, setEditTox] = (0, $dgG1Y.useState)(null); //for payer edit button
    const [rerender, setReRender] = (0, $dgG1Y.useState)(false);
    const { adminUsers: adminUsers, getAdminUsers: getAdminUsers, setSelectedButton: setSelectedButton, selectedButton: selectedButton, setFilterText: setFilterText, filterText: filterText, handleSetArsUser: handleSetArsUser, arsUser: arsUser, filterByARS: filterByARS } = (0, $gElWY.useGetFilters)(sendRequest, auth, showModal, false, null, rerender, null, setReRender);
    const [messageCount, setMessageCount] = (0, $dgG1Y.useState)(1); //how many previous messages to pull
    const [selectedUser, setSelectedUser] = (0, $dgG1Y.useState)();
    const [filteredUsers, setFilteredUsers] = (0, $dgG1Y.useState)([]);
    const [showConfirmationDialog, setShowConfirmationDialog] = (0, $dgG1Y.useState)(false);
    const [voidImageID, setVoidImageID] = (0, $dgG1Y.useState)();
    const [contextMenu, setContextMenu] = (0, $dgG1Y.useState)(null);
    const [selectedVendorAlert, setSelectedVendorAlert] = (0, $dgG1Y.useState)(null);
    const [fetchedUser, setFetchedUser] = (0, $dgG1Y.useState)(null);
    (0, $dgG1Y.useEffect)(()=>{
        if (props.selectedUser && adminUsers) {
            setSelectedButton(2); //set to all users
            const user = adminUsers.find((users)=>users._id === props.selectedUser);
            if (user) {
                const myUser = {
                    alt: user.firstName + " " + user.lastName,
                    title: user.firstName + " " + user.lastName,
                    subtitle: user.phoneNumber || "No Number Entered",
                    id: user._id,
                    unread: "0",
                    timeZone: user.timeZone || "AMERICA/NEW_YORK",
                    testingTimes: user.testingTimes || [],
                    bacTesting: user.bacTesting || []
                };
                setSelectedUser(myUser);
            }
        }
    }, [
        adminUsers,
        props.selectedUser,
        setSelectedButton
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        //get users for tenant
        const getToxes = async ()=>{
            try {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/getvendoralerts", "POST", JSON.stringify({
                    user: selectedUser || null,
                    count: messageCount
                }), {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData && !responseData.message && (!selectedUser || selectedUser.id === "")) setToxes(responseData.sort((a, b)=>a.toxDate < b.toxDate ? 1 : -1));
                else if (responseData && !responseData.message && selectedUser && selectedUser.id !== "") setToxes(responseData.sort((a, b)=>a.toxDate < b.toxDate ? 1 : -1));
            } catch (err) {}
        };
        getToxes();
    }, [
        sendRequest,
        selectedUser,
        messageCount,
        auth.token
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        //filter out non breathalyzer clients
        setFilteredUsers(adminUsers.filter((adminUser)=>adminUser.recoveryTrekID));
    }, [
        adminUsers
    ]);
    const addTox = (event)=>{
        event.preventDefault();
        setEditTox(null);
        setShowModal(true);
    };
    const showEditModal = (event)=>{
        setEditTox(event.currentTarget.value);
        setShowModal(true);
    };
    const handleChange = (event)=>{
        const target = event.target.value;
        setFilterText(target);
        if (target.length > 2) getAdminUsers(target);
        else if (target.length < (filterText && filterText.length)) getAdminUsers(target);
    };
    const getMoreResults = (event)=>{
        setMessageCount(messageCount + 1);
    };
    const saveSelectedUser = (event)=>{
        setSelectedUser(event);
        console.log(event);
        setMessageCount(1);
    };
    const createPDF = async (event)=>{
        if (!toxes) alert("Please select a user with data to export");
        else {
            let documentData = null;
            const data = [];
            data.push({
                text: "You Are Accountable Breathalyzer Results",
                style: "header",
                alignment: "center"
            });
            data.push({
                text: "https://youareaccountable.com",
                style: "subheader",
                alignment: "center"
            });
            data.push({
                text: "646-450-7641",
                style: "subheader",
                alignment: "center"
            });
            data.push({
                image: "data:image/png;base64,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",
                alignment: "center"
            });
            const table = {
                style: "tableExample",
                table: {
                    body: [
                        [
                            "Member Name",
                            "Date",
                            "Result",
                            "Notes"
                        ]
                    ]
                }
            };
            toxes.map(async (tox)=>{
                table.table.body.push([
                    selectedUser ? selectedUser.title : auth.tenant,
                    new Date(tox.toxDate).toLocaleString(),
                    tox.toxResult,
                    tox.Notes
                ]);
            });
            data.push(table);
            documentData = {
                content: data,
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [
                            0,
                            0,
                            0,
                            10
                        ]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [
                            0,
                            10,
                            0,
                            5
                        ]
                    },
                    tableExample: {
                        margin: [
                            0,
                            5,
                            0,
                            15
                        ]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: "black"
                    }
                }
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($jFtgc))).createPdf(documentData).download("YouAreAccountableBreathalyzerExport.pdf");
        }
    };
    const handleExclude = async ()=>{
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/excludeimage", "POST", JSON.stringify({
                id: voidImageID
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData) setVoidImageID(null);
        } catch (err) {
            setShowConfirmationDialog(false);
        }
        setShowConfirmationDialog(false);
    };
    const handleContextMenu = (event, tox)=>{
        event.preventDefault();
        setContextMenu(contextMenu === null ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
        } : null);
        setSelectedVendorAlert(tox);
    };
    const handleCloseContextMenu = ()=>{
        setContextMenu(null);
    };
    const handleAddToxFromVendorAlert = ()=>{
        setShowModal(true);
        handleCloseContextMenu();
    };
    const handleCloseAddTox = ()=>{
        setShowModal(false);
        setSelectedVendorAlert(null);
    };
    const formatTestingSchedule = (user)=>{
        if (!(user === null || user === void 0 ? void 0 : user.bacTesting)) return null;
        return user.bacTesting.map((schedule)=>{
            var _schedule_testingDays, _schedule_testingTimes;
            const days = ((_schedule_testingDays = schedule.testingDays) === null || _schedule_testingDays === void 0 ? void 0 : _schedule_testingDays.join(", ")) || "All";
            const times = ((_schedule_testingTimes = schedule.testingTimes) === null || _schedule_testingTimes === void 0 ? void 0 : _schedule_testingTimes.join(", ")) || "No times set";
            return `${days}: ${times}`;
        }).join(" | ");
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $5wep2.default), {
                open: showConfirmationDialog,
                close: ()=>{
                    setShowConfirmationDialog(false);
                    setVoidImageID(null);
                },
                runConfirmation: handleExclude,
                title: "Exclude Image From Facial Recognition",
                buttonTitle: "Exclude Image"
            }),
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Tox",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                className: classes.textField,
                label: "Filter By Last Name",
                name: "filter",
                onChange: handleChange,
                variant: "outlined"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                container: true,
                spacing: 4,
                children: [
                    auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $5t9Vu.default), {
                        open: showModal,
                        close: handleCloseAddTox,
                        userId: selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id,
                        vendorAlert: selectedVendorAlert,
                        clientTimeZone: (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.timeZone) || "UTC"
                    }),
                    (auth.accountableAdmin || auth.provider) && !props.selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        item: true,
                        lg: 3,
                        sm: 12,
                        xl: 3,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                                children: [
                                    (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $T5LKB.default), {
                                                selectedButton: selectedButton,
                                                setSelectedButton: setSelectedButton,
                                                authContext: auth,
                                                sms: true
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                variant: "h4",
                                                color: "primary",
                                                children: "Members"
                                            }),
                                            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $d9ASo.default), {
                                                auth: auth,
                                                arsUser: arsUser,
                                                handleSetArsUser: handleSetArsUser,
                                                filterByARS: filterByARS
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.ChatList), {
                                        onClick: saveSelectedUser,
                                        className: "chat-list",
                                        dataSource: filteredUsers.map((user)=>{
                                            return {
                                                avatar: (0, (/*@__PURE__*/$parcel$interopDefault($jYTVM))),
                                                alt: user.firstName + " " + user.lastName,
                                                title: user.firstName + " " + user.lastName,
                                                subtitle: user.phoneNumber || "No Number Entered",
                                                id: user._id,
                                                unread: "0",
                                                timeZone: user.timeZone || "AMERICA/NEW_YORK",
                                                bacTesting: user.bacTesting || []
                                            };
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        item: true,
                        lg: props.selectedUser ? 12 : 8,
                        sm: 12,
                        xl: props.selectedUser ? 12 : 8,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                                children: [
                                    (auth.accountableAdmin || auth.provider) && !selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        gutterBottom: true,
                                        className: classes.title,
                                        color: "textSecondary",
                                        variant: "h3",
                                        children: "Please Select a User"
                                    }),
                                    (selectedUser || !auth.accountableAdmin && !auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        gutterBottom: true,
                                        className: classes.title,
                                        color: "textSecondary",
                                        variant: "h3",
                                        children: [
                                            selectedUser ? selectedUser.title : auth.tenant,
                                            "'s Breathalyzer Results"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        variant: "h6",
                                        gutterBottom: true,
                                        children: [
                                            "Continuous Breathalyzer Monitoring acts as a safety measure for you and your loved ones. It reduces your families/support systems worries about needing to monitor you and allows you to not feel overwhelmed in your own home. It allows you to work on communication and growing along your path of recovery together. Continuous Breathalyzer Monitoring also serve as a way to see your progress - you will be able to see how far you have come and it is a testament to all of the hard work that you have been doing.",
                                            " "
                                        ]
                                    }),
                                    (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.bacTesting) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                variant: "h6",
                                                color: "secondary",
                                                children: "Testing Schedule"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                variant: "body1",
                                                children: formatTestingSchedule(selectedUser) || "No testing schedule set"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                        container: true,
                                        justify: "flex-end",
                                        children: [
                                            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                color: "secondary",
                                                onClick: addTox,
                                                children: [
                                                    "Add Tox\xa0\xa0",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04Fi6))), {
                                                        color: "secondary",
                                                        fontSize: "small"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: createPDF,
                                                variant: "contained",
                                                color: "secondary",
                                                children: "Download Export"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                        container: true,
                                        justify: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                color: "primary",
                                                onClick: getMoreResults,
                                                variant: "contained",
                                                children: [
                                                    "See Prior Results\xa0\xa0",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cxFzf))), {
                                                        color: "secondary",
                                                        fontSize: "small"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $12a5h.default), {
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $5MowX.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hMt12.default), {
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                        children: [
                                                            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Last Name"
                                                            }),
                                                            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "First Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Breathalyzer Date"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Breathalyzer Result"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Notes"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Picture"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Verified"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Location"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f2CoU.default), {
                                                    children: ((auth.accountableAdmin || auth.provider) && selectedUser || !auth.accountableAdmin && !auth.provider) && toxes && toxes.map((tox)=>{
                                                        let toxValue = "";
                                                        switch(tox.toxType){
                                                            case 1:
                                                                toxValue = "Alcohol";
                                                                break;
                                                            case 2:
                                                                toxValue = "10 Panel";
                                                                break;
                                                            case 3:
                                                                toxValue = "12 Panel";
                                                                break;
                                                            case 4:
                                                                toxValue = "14 Panel";
                                                                break;
                                                            case 5:
                                                                toxValue = "Lab Confirmation";
                                                                break;
                                                            case 6:
                                                                toxValue = "Breathalyzer";
                                                                break;
                                                        }
                                                        let bacDate = (0, (/*@__PURE__*/$parcel$interopDefault($4C1tJ)))(tox.toxDate);
                                                        if (selectedUser) bacDate = bacDate.tz(selectedUser.timeZone);
                                                        bacDate = bacDate.format("MM/DD/YYYY hh:mm A z");
                                                        return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                            onContextMenu: (event)=>handleContextMenu(event, tox),
                                                            children: [
                                                                (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.User.lastName
                                                                }),
                                                                (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.User.firstName
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: bacDate
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.toxResult
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.Notes
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.image && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                                        onClick: ()=>{
                                                                            setShowConfirmationDialog(true);
                                                                            setVoidImageID(tox._id);
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("img", {
                                                                            src: tox.image,
                                                                            width: "100px"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.image && (tox.recog ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($axbIu))), {
                                                                        className: classes.icon,
                                                                        htmlColor: "#73CD81"
                                                                    }) : /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bocI1))), {
                                                                        className: classes.icon,
                                                                        htmlColor: "#FF0000"
                                                                    }))
                                                                }),
                                                                tox.latitude && !tox.access && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1u2lJ.default), {
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)("a", {
                                                                            href: `https://maps.google.com?q=${tox.latitude},${tox.longitude}`,
                                                                            target: "_blank",
                                                                            rel: "noreferrer",
                                                                            children: "Location"
                                                                        })
                                                                    ]
                                                                }),
                                                                tox.access && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: "NA"
                                                                })
                                                            ]
                                                        }, tox._id);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $caSAq.default), {
                keepMounted: true,
                open: contextMenu !== null,
                onClose: handleCloseContextMenu,
                anchorReference: "anchorPosition",
                anchorPosition: contextMenu !== null ? {
                    top: contextMenu.mouseY,
                    left: contextMenu.mouseX
                } : undefined,
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                    onClick: handleAddToxFromVendorAlert,
                    children: "Add Tox from BAC Entry"
                })
            })
        ]
    });
};
var $4f85657b1ce6b823$export$2e2bcd8739ae039 = $4f85657b1ce6b823$var$VendorAlerts;

});
parcelRegister("4m0VC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32b9efd49bd098fb$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $4BFH5 = parcelRequire("4BFH5");

var $9tnMP = parcelRequire("9tnMP");

var $bdWPY = parcelRequire("bdWPY");
var $32b9efd49bd098fb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $bh1oa.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $4BFH5.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $4BFH5.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $32b9efd49bd098fb$var$Button = /*#__PURE__*/ $dgG1Y.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $dgG1Y.createElement("span", {
        className: (0, $cXVHi.default)(classes.startIcon, classes["iconSize".concat((0, $bdWPY.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $dgG1Y.createElement("span", {
        className: (0, $cXVHi.default)(classes.endIcon, classes["iconSize".concat((0, $bdWPY.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $9tnMP.default), (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $bdWPY.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $bdWPY.default)(size))],
            classes["size".concat((0, $bdWPY.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $cXVHi.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $dgG1Y.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $32b9efd49bd098fb$export$2e2bcd8739ae039 = (0, $7xfqK.default)($32b9efd49bd098fb$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($32b9efd49bd098fb$var$Button);

});
parcelRegister("9tnMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e59460568ae0e52$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $8idXE = parcelRequire("8idXE");

var $cXVHi = parcelRequire("cXVHi");


var $arbQ3 = parcelRequire("arbQ3");

var $i3vbM = parcelRequire("i3vbM");


var $7xfqK = parcelRequire("7xfqK");

var $h9piZ = parcelRequire("h9piZ");

var $lhXDP = parcelRequire("lhXDP");
var $6e59460568ae0e52$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $6e59460568ae0e52$var$ButtonBase = /*#__PURE__*/ $dgG1Y.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $gZz4Z.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $dgG1Y.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $8idXE.findDOMNode(buttonRef.current);
    }
    var rippleRef = $dgG1Y.useRef(null);
    var _React$useState = $dgG1Y.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $h9piZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $dgG1Y.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $dgG1Y.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $i3vbM.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $i3vbM.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $dgG1Y.useRef(false);
    var handleKeyDown = (0, $i3vbM.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $i3vbM.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $arbQ3.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $arbQ3.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $arbQ3.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $dgG1Y.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $dgG1Y.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $dgG1Y.createElement(ComponentProp, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $dgG1Y.createElement((0, $lhXDP.default), (0, $bh1oa.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $6e59460568ae0e52$export$2e2bcd8739ae039 = (0, $7xfqK.default)($6e59460568ae0e52$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($6e59460568ae0e52$var$ButtonBase);

});
parcelRegister("i3vbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d250b34ae201a837$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
var $d250b34ae201a837$var$useEnhancedEffect = typeof window !== "undefined" ? $dgG1Y.useLayoutEffect : $dgG1Y.useEffect;
function $d250b34ae201a837$export$2e2bcd8739ae039(fn) {
    var ref = $dgG1Y.useRef(fn);
    $d250b34ae201a837$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $dgG1Y.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("h9piZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7c6e80b565a820e$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");
var $c7c6e80b565a820e$var$hadKeyboardEvent = true;
var $c7c6e80b565a820e$var$hadFocusVisibleRecently = false;
var $c7c6e80b565a820e$var$hadFocusVisibleRecentlyTimeout = null;
var $c7c6e80b565a820e$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $c7c6e80b565a820e$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $c7c6e80b565a820e$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $c7c6e80b565a820e$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $c7c6e80b565a820e$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $c7c6e80b565a820e$var$handlePointerDown() {
    $c7c6e80b565a820e$var$hadKeyboardEvent = false;
}
function $c7c6e80b565a820e$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($c7c6e80b565a820e$var$hadFocusVisibleRecently) $c7c6e80b565a820e$var$hadKeyboardEvent = true;
    }
}
function $c7c6e80b565a820e$var$prepare(doc) {
    doc.addEventListener("keydown", $c7c6e80b565a820e$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $c7c6e80b565a820e$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $c7c6e80b565a820e$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $c7c6e80b565a820e$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $c7c6e80b565a820e$var$handleVisibilityChange, true);
}
function $c7c6e80b565a820e$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $c7c6e80b565a820e$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $c7c6e80b565a820e$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $c7c6e80b565a820e$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $c7c6e80b565a820e$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $c7c6e80b565a820e$var$handleVisibilityChange, true);
}
function $c7c6e80b565a820e$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $c7c6e80b565a820e$var$hadKeyboardEvent || $c7c6e80b565a820e$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $c7c6e80b565a820e$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $c7c6e80b565a820e$var$hadFocusVisibleRecently = true;
    window.clearTimeout($c7c6e80b565a820e$var$hadFocusVisibleRecentlyTimeout);
    $c7c6e80b565a820e$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $c7c6e80b565a820e$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $c7c6e80b565a820e$export$2e2bcd8739ae039() {
    var ref = $dgG1Y.useCallback(function(instance) {
        var node = $8idXE.findDOMNode(instance);
        if (node != null) $c7c6e80b565a820e$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $c7c6e80b565a820e$var$isFocusVisible,
        onBlurVisible: $c7c6e80b565a820e$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("lhXDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7f973050e0ad8ed$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $foPig = parcelRequire("foPig");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $j7gCK = parcelRequire("j7gCK");

var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $jlpyo = parcelRequire("jlpyo");
var $f7f973050e0ad8ed$var$DURATION = 550;
var $f7f973050e0ad8ed$export$95d0c9356b2231a3 = 80;
var $f7f973050e0ad8ed$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($f7f973050e0ad8ed$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($f7f973050e0ad8ed$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $f7f973050e0ad8ed$var$TouchRipple = /*#__PURE__*/ $dgG1Y.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $gZz4Z.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $dgG1Y.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $dgG1Y.useRef(0);
    var rippleCallback = $dgG1Y.useRef(null);
    $dgG1Y.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $dgG1Y.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $dgG1Y.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $dgG1Y.useRef(null);
    var container = $dgG1Y.useRef(null);
    $dgG1Y.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $dgG1Y.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $foPig.default)(oldRipples), [
                /*#__PURE__*/ $dgG1Y.createElement((0, $jlpyo.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $f7f973050e0ad8ed$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $dgG1Y.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $f7f973050e0ad8ed$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $dgG1Y.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $dgG1Y.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $dgG1Y.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement("span", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $dgG1Y.createElement((0, $j7gCK.default), {
        component: null,
        exit: true
    }, ripples));
});
var $f7f973050e0ad8ed$export$2e2bcd8739ae039 = (0, $7xfqK.default)($f7f973050e0ad8ed$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $dgG1Y.memo($f7f973050e0ad8ed$var$TouchRipple));

});
parcelRegister("jlpyo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e153cce632b43141$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $i3vbM = parcelRequire("i3vbM");
var $e153cce632b43141$var$useEnhancedEffect = typeof window === "undefined" ? $dgG1Y.useEffect : $dgG1Y.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $e153cce632b43141$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $dgG1Y.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $cXVHi.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $cXVHi.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $i3vbM.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $e153cce632b43141$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $dgG1Y.createElement("span", {
        className: childClassName
    }));
}
var $e153cce632b43141$export$2e2bcd8739ae039 = $e153cce632b43141$var$Ripple;

});




parcelRegister("7efta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5435d71b000d15e5$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $2Po3a = parcelRequire("2Po3a");

var $7xfqK = parcelRequire("7xfqK");
var $5435d71b000d15e5$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        overflow: "hidden"
    }
};
var $5435d71b000d15e5$var$Card = /*#__PURE__*/ $dgG1Y.forwardRef(function Card(props, ref) {
    var classes = props.classes, className = props.className, _props$raised = props.raised, raised = _props$raised === void 0 ? false : _props$raised, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "raised"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $2Po3a.default), (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        elevation: raised ? 8 : 1,
        ref: ref
    }, other));
});
var $5435d71b000d15e5$export$2e2bcd8739ae039 = (0, $7xfqK.default)($5435d71b000d15e5$export$9dd6ff9ea0189349, {
    name: "MuiCard"
})($5435d71b000d15e5$var$Card);

});

parcelRegister("hEZLG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdb615f96b54c2df$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");
var $cdb615f96b54c2df$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    }
};
var $cdb615f96b54c2df$var$CardContent = /*#__PURE__*/ $dgG1Y.forwardRef(function CardContent(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        ref: ref
    }, other));
});
var $cdb615f96b54c2df$export$2e2bcd8739ae039 = (0, $7xfqK.default)($cdb615f96b54c2df$export$9dd6ff9ea0189349, {
    name: "MuiCardContent"
})($cdb615f96b54c2df$var$CardContent);

});

parcelRegister("gJFkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2f0e8c88467e3bf$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");


var $c2f0e8c88467e3bf$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $c2f0e8c88467e3bf$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $c2f0e8c88467e3bf$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $c2f0e8c88467e3bf$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: "100%"
            };
            return;
        }
        if (size === "auto") {
            styles[key] = {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none"
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === "xs") (0, $bh1oa.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $c2f0e8c88467e3bf$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function $c2f0e8c88467e3bf$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $c2f0e8c88467e3bf$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($c2f0e8c88467e3bf$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($c2f0e8c88467e3bf$var$getOffset(themeSpacing), ")"),
            "& > $item": {
                padding: $c2f0e8c88467e3bf$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $c2f0e8c88467e3bf$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $bh1oa.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: "border-box",
            margin: "0" // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ "direction-xs-column": {
            flexDirection: "column"
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ "direction-xs-column-reverse": {
            flexDirection: "column-reverse"
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ "direction-xs-row-reverse": {
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ "wrap-xs-nowrap": {
            flexWrap: "nowrap"
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ "wrap-xs-wrap-reverse": {
            flexWrap: "wrap-reverse"
        },
        /* Styles applied to the root element if `alignItems="center"`. */ "align-items-xs-center": {
            alignItems: "center"
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ "align-items-xs-flex-start": {
            alignItems: "flex-start"
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ "align-items-xs-flex-end": {
            alignItems: "flex-end"
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ "align-items-xs-baseline": {
            alignItems: "baseline"
        },
        /* Styles applied to the root element if `alignContent="center"`. */ "align-content-xs-center": {
            alignContent: "center"
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ "align-content-xs-flex-start": {
            alignContent: "flex-start"
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ "align-content-xs-flex-end": {
            alignContent: "flex-end"
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ "align-content-xs-space-between": {
            alignContent: "space-between"
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ "align-content-xs-space-around": {
            alignContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ "justify-content-xs-center": {
            justifyContent: "center"
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ "justify-content-xs-flex-end": {
            justifyContent: "flex-end"
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ "justify-content-xs-space-between": {
            justifyContent: "space-between"
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ "justify-content-xs-space-around": {
            justifyContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ "justify-content-xs-space-evenly": {
            justifyContent: "space-evenly"
        }
    }, $c2f0e8c88467e3bf$var$generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $c2f0e8c88467e3bf$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $c2f0e8c88467e3bf$var$Grid = /*#__PURE__*/ $dgG1Y.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $gZz4Z.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $cXVHi.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: className,
        ref: ref
    }, other));
});
var $c2f0e8c88467e3bf$var$StyledGrid = (0, $7xfqK.default)($c2f0e8c88467e3bf$export$9dd6ff9ea0189349, {
    name: "MuiGrid"
})($c2f0e8c88467e3bf$var$Grid);
var $c2f0e8c88467e3bf$var$requireProp;
var $c2f0e8c88467e3bf$export$2e2bcd8739ae039 = $c2f0e8c88467e3bf$var$StyledGrid;

});

parcelRegister("5MowX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $435476b902aede48$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $lhzZ1 = parcelRequire("lhzZ1");
var $435476b902aede48$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "table",
            width: "100%",
            borderCollapse: "collapse",
            borderSpacing: 0,
            "& caption": (0, $bh1oa.default)({}, theme.typography.body2, {
                padding: theme.spacing(2),
                color: theme.palette.text.secondary,
                textAlign: "left",
                captionSide: "bottom"
            })
        },
        /* Styles applied to the root element if `stickyHeader={true}`. */ stickyHeader: {
            borderCollapse: "separate"
        }
    };
};
var $435476b902aede48$var$defaultComponent = "table";
var $435476b902aede48$var$Table = /*#__PURE__*/ $dgG1Y.forwardRef(function Table(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $435476b902aede48$var$defaultComponent : _props$component, _props$padding = props.padding, padding = _props$padding === void 0 ? "normal" : _props$padding, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$stickyHeader = props.stickyHeader, stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component",
        "padding",
        "size",
        "stickyHeader"
    ]);
    var table = $dgG1Y.useMemo(function() {
        return {
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        };
    }, [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $lhzZ1.default).Provider, {
        value: table
    }, /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        role: Component === $435476b902aede48$var$defaultComponent ? null : "table",
        ref: ref,
        className: (0, $cXVHi.default)(classes.root, className, stickyHeader && classes.stickyHeader)
    }, other)));
});
var $435476b902aede48$export$2e2bcd8739ae039 = (0, $7xfqK.default)($435476b902aede48$export$9dd6ff9ea0189349, {
    name: "MuiTable"
})($435476b902aede48$var$Table);

});
parcelRegister("lhzZ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7e719085b65ea98$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ var $f7e719085b65ea98$var$TableContext = $dgG1Y.createContext();
var $f7e719085b65ea98$export$2e2bcd8739ae039 = $f7e719085b65ea98$var$TableContext;

});


parcelRegister("f2CoU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af34d4850fa205e0$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $8zySp = parcelRequire("8zySp");
var $af34d4850fa205e0$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "table-row-group"
    }
};
var $af34d4850fa205e0$var$tablelvl2 = {
    variant: "body"
};
var $af34d4850fa205e0$var$defaultComponent = "tbody";
var $af34d4850fa205e0$var$TableBody = /*#__PURE__*/ $dgG1Y.forwardRef(function TableBody(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $af34d4850fa205e0$var$defaultComponent : _props$component, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $8zySp.default).Provider, {
        value: $af34d4850fa205e0$var$tablelvl2
    }, /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        ref: ref,
        role: Component === $af34d4850fa205e0$var$defaultComponent ? null : "rowgroup"
    }, other)));
});
var $af34d4850fa205e0$export$2e2bcd8739ae039 = (0, $7xfqK.default)($af34d4850fa205e0$export$9dd6ff9ea0189349, {
    name: "MuiTableBody"
})($af34d4850fa205e0$var$TableBody);

});
parcelRegister("8zySp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63dca559b3947f78$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ var $63dca559b3947f78$var$Tablelvl2Context = $dgG1Y.createContext();
var $63dca559b3947f78$export$2e2bcd8739ae039 = $63dca559b3947f78$var$Tablelvl2Context;

});


parcelRegister("1u2lJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $114a6a5cb97bce24$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");

var $4BFH5 = parcelRequire("4BFH5");

var $lhzZ1 = parcelRequire("lhzZ1");

var $8zySp = parcelRequire("8zySp");
var $114a6a5cb97bce24$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $bh1oa.default)({}, theme.typography.body2, {
            display: "table-cell",
            verticalAlign: "inherit",
            // Workaround for a rendering bug with spanned columns in Chrome 62.0.
            // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
            borderBottom: "1px solid\n    ".concat(theme.palette.type === "light" ? (0, $4BFH5.lighten)((0, $4BFH5.alpha)(theme.palette.divider, 1), 0.88) : (0, $4BFH5.darken)((0, $4BFH5.alpha)(theme.palette.divider, 1), 0.68)),
            textAlign: "left",
            padding: 16
        }),
        /* Styles applied to the root element if `variant="head"` or `context.table.head`. */ head: {
            color: theme.palette.text.primary,
            lineHeight: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the root element if `variant="body"` or `context.table.body`. */ body: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */ footer: {
            color: theme.palette.text.secondary,
            lineHeight: theme.typography.pxToRem(21),
            fontSize: theme.typography.pxToRem(12)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: "6px 24px 6px 16px",
            "&:last-child": {
                paddingRight: 16
            },
            "&$paddingCheckbox": {
                width: 24,
                // prevent the checkbox column from growing
                padding: "0 12px 0 16px",
                "&:last-child": {
                    paddingLeft: 12,
                    paddingRight: 16
                },
                "& > *": {
                    padding: 0
                }
            }
        },
        /* Styles applied to the root element if `padding="checkbox"`. */ paddingCheckbox: {
            width: 48,
            // prevent the checkbox column from growing
            padding: "0 0 0 4px",
            "&:last-child": {
                paddingLeft: 0,
                paddingRight: 4
            }
        },
        /* Styles applied to the root element if `padding="none"`. */ paddingNone: {
            padding: 0,
            "&:last-child": {
                padding: 0
            }
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right",
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `context.table.stickyHeader={true}`. */ stickyHeader: {
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.default
        }
    };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ var $114a6a5cb97bce24$var$TableCell = /*#__PURE__*/ $dgG1Y.forwardRef(function TableCell(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0, $gZz4Z.default)(props, [
        "align",
        "classes",
        "className",
        "component",
        "padding",
        "scope",
        "size",
        "sortDirection",
        "variant"
    ]);
    var table = $dgG1Y.useContext((0, $lhzZ1.default));
    var tablelvl2 = $dgG1Y.useContext((0, $8zySp.default));
    var isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    var role;
    var Component;
    if (component) {
        Component = component;
        role = isHeadCell ? "columnheader" : "cell";
    } else Component = isHeadCell ? "th" : "td";
    var scope = scopeProp;
    if (!scope && isHeadCell) scope = "col";
    var padding = paddingProp || (table && table.padding ? table.padding : "normal");
    var size = sizeProp || (table && table.size ? table.size : "medium");
    var variant = variantProp || tablelvl2 && tablelvl2.variant;
    var ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        ref: ref,
        className: (0, $cXVHi.default)(classes.root, classes[variant], className, align !== "inherit" && classes["align".concat((0, $bdWPY.default)(align))], padding !== "normal" && classes["padding".concat((0, $bdWPY.default)(padding))], size !== "medium" && classes["size".concat((0, $bdWPY.default)(size))], variant === "head" && table && table.stickyHeader && classes.stickyHeader),
        "aria-sort": ariaSort,
        role: role,
        scope: scope
    }, other));
});
var $114a6a5cb97bce24$export$2e2bcd8739ae039 = (0, $7xfqK.default)($114a6a5cb97bce24$export$9dd6ff9ea0189349, {
    name: "MuiTableCell"
})($114a6a5cb97bce24$var$TableCell);

});

parcelRegister("12a5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c0dccdab69b5c09$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");
var $0c0dccdab69b5c09$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: "100%",
        overflowX: "auto"
    }
};
var $0c0dccdab69b5c09$var$TableContainer = /*#__PURE__*/ $dgG1Y.forwardRef(function TableContainer(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        ref: ref,
        className: (0, $cXVHi.default)(classes.root, className)
    }, other));
});
var $0c0dccdab69b5c09$export$2e2bcd8739ae039 = (0, $7xfqK.default)($0c0dccdab69b5c09$export$9dd6ff9ea0189349, {
    name: "MuiTableContainer"
})($0c0dccdab69b5c09$var$TableContainer);

});

parcelRegister("hMt12", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf1d6d4cf1ef1ca6$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $8zySp = parcelRequire("8zySp");
var $cf1d6d4cf1ef1ca6$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "table-header-group"
    }
};
var $cf1d6d4cf1ef1ca6$var$tablelvl2 = {
    variant: "head"
};
var $cf1d6d4cf1ef1ca6$var$defaultComponent = "thead";
var $cf1d6d4cf1ef1ca6$var$TableHead = /*#__PURE__*/ $dgG1Y.forwardRef(function TableHead(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $cf1d6d4cf1ef1ca6$var$defaultComponent : _props$component, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $8zySp.default).Provider, {
        value: $cf1d6d4cf1ef1ca6$var$tablelvl2
    }, /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        ref: ref,
        role: Component === $cf1d6d4cf1ef1ca6$var$defaultComponent ? null : "rowgroup"
    }, other)));
});
var $cf1d6d4cf1ef1ca6$export$2e2bcd8739ae039 = (0, $7xfqK.default)($cf1d6d4cf1ef1ca6$export$9dd6ff9ea0189349, {
    name: "MuiTableHead"
})($cf1d6d4cf1ef1ca6$var$TableHead);

});

parcelRegister("k0kWg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9040cbbc7a6f7cd$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $8zySp = parcelRequire("8zySp");

var $4BFH5 = parcelRequire("4BFH5");
var $e9040cbbc7a6f7cd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: "inherit",
            display: "table-row",
            verticalAlign: "middle",
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            "&$hover:hover": {
                backgroundColor: theme.palette.action.hover
            },
            "&$selected, &$selected:hover": {
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Pseudo-class applied to the root element if `hover={true}`. */ hover: {},
        /* Styles applied to the root element if table variant="head". */ head: {},
        /* Styles applied to the root element if table variant="footer". */ footer: {}
    };
};
var $e9040cbbc7a6f7cd$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ var $e9040cbbc7a6f7cd$var$TableRow = /*#__PURE__*/ $dgG1Y.forwardRef(function TableRow(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $e9040cbbc7a6f7cd$var$defaultComponent : _props$component, _props$hover = props.hover, hover = _props$hover === void 0 ? false : _props$hover, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component",
        "hover",
        "selected"
    ]);
    var tablelvl2 = $dgG1Y.useContext((0, $8zySp.default));
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        ref: ref,
        className: (0, $cXVHi.default)(classes.root, className, tablelvl2 && ({
            "head": classes.head,
            "footer": classes.footer
        })[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
        role: Component === $e9040cbbc7a6f7cd$var$defaultComponent ? null : "row"
    }, other));
});
var $e9040cbbc7a6f7cd$export$2e2bcd8739ae039 = (0, $7xfqK.default)($e9040cbbc7a6f7cd$export$9dd6ff9ea0189349, {
    name: "MuiTableRow"
})($e9040cbbc7a6f7cd$var$TableRow);

});

parcelRegister("1QHfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $158c310c161d365e$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");
var $158c310c161d365e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $158c310c161d365e$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $158c310c161d365e$var$Typography = /*#__PURE__*/ $dgG1Y.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $158c310c161d365e$var$defaultVariantMapping : _props$variantMapping, other = (0, $gZz4Z.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $158c310c161d365e$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $bdWPY.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $bdWPY.default)(align))], display !== "initial" && classes["display".concat((0, $bdWPY.default)(display))]),
        ref: ref
    }, other));
});
var $158c310c161d365e$export$2e2bcd8739ae039 = (0, $7xfqK.default)($158c310c161d365e$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($158c310c161d365e$var$Typography);

});

parcelRegister("04Fi6", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e0675b0002a247$var$React = $3kONX((parcelRequire("dgG1Y")));

var $00e0675b0002a247$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $00e0675b0002a247$var$_default = (0, $00e0675b0002a247$var$_createSvgIcon.default)(/*#__PURE__*/ $00e0675b0002a247$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), "AddCircle");
module.exports.default = $00e0675b0002a247$var$_default;

});
parcelRegister("3kONX", function(module, exports) {

var $d3IY9 = parcelRequire("d3IY9");
var $26daa61dd598ea7a$var$_typeof = $d3IY9.default;
function $26daa61dd598ea7a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($26daa61dd598ea7a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $26daa61dd598ea7a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $26daa61dd598ea7a$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $26daa61dd598ea7a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $26daa61dd598ea7a$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("d3IY9", function(module, exports) {
function $981e701a3cf56300$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $981e701a3cf56300$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $981e701a3cf56300$var$_typeof(o);
}
module.exports = $981e701a3cf56300$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dbCoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $6mYJl.default;
    }
});

var $6mYJl = parcelRequire("6mYJl");

});
parcelRegister("6mYJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a33e7f3404d508a$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");

var $4j6wO = parcelRequire("4j6wO");
function $4a33e7f3404d508a$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement((0, $4j6wO.default), (0, $bh1oa.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $4j6wO.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).forwardRef(Component));
}

});
parcelRegister("4j6wO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $322e00294152813a$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");
var $322e00294152813a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $322e00294152813a$var$SvgIcon = /*#__PURE__*/ $dgG1Y.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $bdWPY.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $bdWPY.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $dgG1Y.createElement("title", null, titleAccess) : null);
});
$322e00294152813a$var$SvgIcon.muiName = "SvgIcon";
var $322e00294152813a$export$2e2bcd8739ae039 = (0, $7xfqK.default)($322e00294152813a$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($322e00294152813a$var$SvgIcon);

});




parcelRegister("5t9Vu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68172d558cb16d43$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $en0cX = parcelRequire("en0cX");

var $iJ8f3 = parcelRequire("iJ8f3");
var $lFkXs = parcelRequire("lFkXs");
var $9EE4V = parcelRequire("9EE4V");
var $3kUUy = parcelRequire("3kUUy");
var $2gTUh = parcelRequire("2gTUh");
var $aXBMD = parcelRequire("aXBMD");
var $9f741 = parcelRequire("9f741");
var $1jYbn = parcelRequire("1jYbn");
var $7cH5t = parcelRequire("7cH5t");
var $cHWQJ = parcelRequire("cHWQJ");
var $1vvTA = parcelRequire("1vvTA");
var $e43jk = parcelRequire("e43jk");
var $4wnpT = parcelRequire("4wnpT");

var $jUw8I = parcelRequire("jUw8I");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $6GvYA = parcelRequire("6GvYA");

var $4C1tJ = parcelRequire("4C1tJ");

var $htjEL = parcelRequire("htjEL");
const $68172d558cb16d43$var$schema = {
    toxDate: [
        (0, $htjEL.required)
    ],
    Notes: [
        (0, $htjEL.required)
    ]
};
const $68172d558cb16d43$var$AddTox = ({ open: open, close: close, userId: userId, vendorAlert: vendorAlert, clientTimeZone: clientTimeZone, onAddTox: onAddTox, getProgramUsers: getProgramUsers = false })=>{
    var _formState_errors_toxDate, _formState_errors_Notes;
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const { hasError: hasError, handleChange: handleChange, formState: formState, clearFormState: clearFormState } = (0, $jUw8I.useForm)($68172d558cb16d43$var$schema);
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [toxType, setToxType] = (0, $dgG1Y.useState)(""); // Start as blank
    const { members: members } = (0, $6GvYA.useGetMembers)(sendRequest, auth);
    const [file, setFile] = (0, $dgG1Y.useState)(null);
    const [result, setResult] = (0, $dgG1Y.useState)(""); // Start as blank
    const [selfReport, setSelfReport] = (0, $dgG1Y.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $dgG1Y.useState)(userId || "");
    const [dnaConfirmation, setDNAConfirmation] = (0, $dgG1Y.useState)(1);
    const [kits, setKits] = (0, $dgG1Y.useState)([]);
    const [selectedKit, setSelectedKit] = (0, $dgG1Y.useState)("");
    const [vendorAlerts, setVendorAlerts] = (0, $dgG1Y.useState)([]);
    const [selectedVendorAlert, setSelectedVendorAlert] = (0, $dgG1Y.useState)("");
    const [programMembers, setProgramMembers] = (0, $dgG1Y.useState)([]);
    const [kitManual, setKitManual] = (0, $dgG1Y.useState)("");
    const formatDate = (date, toxResult)=>{
        let formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($4C1tJ)))(date).tz(clientTimeZone || "UTC");
        if (toxResult === "Missed") formattedDate = formattedDate.subtract(2, "hours");
        return formattedDate.format("MM/DD/YYYY hh:mm A");
    };
    (0, $dgG1Y.useEffect)(()=>{
        if (open) {
            console.log(userId);
            clearFormState();
            setFile(null);
            if (userId) {
                setSelectedUser(userId);
                getOpenKits(userId);
                getVendorAlerts(userId);
            }
            if (vendorAlert) {
                setResult(vendorAlert.toxResult);
                setToxType(6); // BAC
                const date = (0, (/*@__PURE__*/$parcel$interopDefault($4C1tJ)))(vendorAlert.toxDate).format("YYYY-MM-DD");
                handleChange({
                    target: {
                        name: "toxDate",
                        value: date
                    }
                });
                handleChange({
                    target: {
                        name: "Notes",
                        value: vendorAlert.Notes || ""
                    }
                });
                setSelectedVendorAlert(vendorAlert._id);
            } else {
                setToxType("");
                setResult("");
                setSelectedKit("");
                setKitManual("");
            }
        }
    }, [
        open,
        userId,
        vendorAlert
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        if (getProgramUsers) fetchProgramUsers();
    }, [
        getProgramUsers
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        if (selectedUser) {
            getOpenKits(selectedUser);
            getVendorAlerts(selectedUser);
        }
    }, [
        selectedUser
    ]);
    const getOpenKits = async (id)=>{
        try {
            const myKits = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/order/getOpenKits`, "POST", JSON.stringify({
                id: id
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            setKits(myKits.kits);
        } catch (err) {
            console.log(err);
        }
    };
    const fetchProgramUsers = async ()=>{
        try {
            const programUsers = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/accountable/programusersfilter`, "GET", null, {
                Authorization: "Bearer " + auth.token
            });
            setProgramMembers(programUsers);
        } catch (err) {
            console.log(err);
        }
    };
    const getVendorAlerts = async (id)=>{
        try {
            const alerts = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/accountable/getvendoralerts`, "POST", JSON.stringify({
                user: {
                    id: id
                },
                count: 10
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            const filteredAlerts = alerts.filter((alert)=>[
                    "Missed",
                    "Positive"
                ].includes(alert.toxResult));
            setVendorAlerts(filteredAlerts);
        } catch (err) {
            console.log(err);
        }
    };
    const handleSave = async (event)=>{
        event.preventDefault();
        if (!result || !toxType || toxType === 5 && !selectedKit && result !== "Missed") return; // Prevent saving if result, toxType, or kit (when Lab Confirmation) is not selected
        const formData = new FormData();
        if (file) formData.append("file", file);
        try {
            const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/accountable/toxes`, "POST", JSON.stringify({
                member: selectedUser,
                toxDate: formState.values.toxDate,
                Notes: formState.values.Notes,
                toxResult: result,
                toxType: toxType,
                selfReport: selfReport,
                kit: kitManual !== "" ? kitManual : selectedKit,
                dnaConfirmation: dnaConfirmation,
                vendorAlert: [
                    "Missed",
                    "Positive"
                ].includes(result) && toxType === 6 && selectedVendorAlert ? selectedVendorAlert : null,
                doUpdateToxCounts: true
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (file && responseData._id) {
                formData.append("toxID", responseData._id);
                await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/upload/uploadTox`, "POST", formData, {
                    Authorization: "Bearer " + auth.token
                });
            }
            onAddTox === null || onAddTox === void 0 ? void 0 : onAddTox();
        } catch (err) {
            console.log(err);
        }
        close(false);
    };
    const handleCancel = (event)=>{
        event.preventDefault();
        close(false);
    };
    const handleSelfReport = ()=>{
        setSelfReport(!selfReport);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating User",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
                open: open,
                onClose: handleCancel,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                fullWidth: true,
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9f741.default), {
                        children: "Add a Tox Result"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $2gTUh.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aXBMD.default), {
                                children: "Please enter the details from the toxicology test. The notes should include what the individual tested positive for if anything."
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1jYbn.default), {
                                sx: {
                                    m: 1,
                                    minWidth: 120
                                },
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cHWQJ.default), {
                                        id: "member-label",
                                        children: "Member"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e43jk.default), {
                                        sx: {
                                            mt: 2
                                        },
                                        error: hasError("member"),
                                        fullWidth: true,
                                        labelId: "member-label",
                                        name: "member",
                                        onChange: (e)=>setSelectedUser(e.target.value),
                                        value: selectedUser,
                                        children: [
                                            getProgramUsers && programMembers && programMembers.map((member)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1vvTA.default), {
                                                    value: member._id,
                                                    children: [
                                                        member.lastName,
                                                        ", ",
                                                        member.firstName
                                                    ]
                                                }, member._id)),
                                            members && members.map((member)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1vvTA.default), {
                                                    value: member._id,
                                                    children: [
                                                        member.lastName,
                                                        ", ",
                                                        member.firstName
                                                    ]
                                                }, member._id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4wnpT.default), {
                                sx: {
                                    mt: 2
                                },
                                error: hasError("toxDate"),
                                fullWidth: true,
                                helperText: hasError("toxDate") ? (_formState_errors_toxDate = formState.errors.toxDate) === null || _formState_errors_toxDate === void 0 ? void 0 : _formState_errors_toxDate[0] : null,
                                label: "Toxicology Date",
                                name: "toxDate",
                                onChange: handleChange,
                                type: "date",
                                defaultValue: new Date().toISOString().substring(0, 10),
                                value: formState.values.toxDate || "",
                                InputLabelProps: {
                                    shrink: true
                                }
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1jYbn.default), {
                                sx: {
                                    m: 1,
                                    minWidth: 120
                                },
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cHWQJ.default), {
                                        id: "result-label",
                                        children: "Result"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e43jk.default), {
                                        labelId: "result-label",
                                        id: "result-select",
                                        value: result,
                                        onChange: (e)=>setResult(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: "Positive",
                                                children: "Positive"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: "Missed",
                                                children: "Missed"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: "Negative",
                                                children: "Negative"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: "Update",
                                                children: "Update"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: "Collected",
                                                children: "Lab Test Collected"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1jYbn.default), {
                                sx: {
                                    m: 1,
                                    minWidth: 120
                                },
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cHWQJ.default), {
                                        id: "toxType-label",
                                        children: "Tox Type"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e43jk.default), {
                                        labelId: "toxType-label",
                                        id: "toxType-select",
                                        value: toxType,
                                        onChange: (e)=>setToxType(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 2,
                                                children: "10 Panel"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 4,
                                                children: "14 Panel"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 5,
                                                children: "Lab Confirmation"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 6,
                                                children: "BAC"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 7,
                                                children: "Medication Monitoring"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1jYbn.default), {
                                sx: {
                                    m: 1,
                                    minWidth: 120
                                },
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cHWQJ.default), {
                                        id: "toxType-label",
                                        children: "DNA Confirmation"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e43jk.default), {
                                        labelId: "toxType-label",
                                        id: "toxType-select",
                                        value: dnaConfirmation,
                                        onChange: (e)=>setDNAConfirmation(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 1,
                                                children: "Not Applicable"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 2,
                                                children: "Pass"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 3,
                                                children: "Indeterminite"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: 4,
                                                children: "Fail"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            toxType === 5 && result !== "Missed" && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1jYbn.default), {
                                        sx: {
                                            m: 1,
                                            minWidth: 120
                                        },
                                        variant: "standard",
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cHWQJ.default), {
                                                id: "kit-label",
                                                children: "Kit"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e43jk.default), {
                                                labelId: "kit-label",
                                                id: "kit-select",
                                                value: selectedKit,
                                                onChange: (e)=>setSelectedKit(e.target.value),
                                                children: [
                                                    kits && kits.length > 0 && kits.map((kit)=>/*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                            value: kit.kitID,
                                                            children: kit.kitID
                                                        }, kit.kitID)),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                        value: "not_listed",
                                                        children: "Kit Not Listed"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (auth.harambe || [
                                        "nicole@youareaccountable.com"
                                    ].includes(auth.email || "")) && selectedKit === "not_listed" && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4wnpT.default), {
                                        sx: {
                                            m: 1,
                                            minWidth: 120
                                        },
                                        label: "Manual Kit ID",
                                        value: kitManual,
                                        onChange: (e)=>setKitManual(e.target.value)
                                    })
                                ]
                            }),
                            [
                                "Missed",
                                "Positive"
                            ].includes(result) && toxType === 6 && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1jYbn.default), {
                                sx: {
                                    m: 1,
                                    minWidth: 120
                                },
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cHWQJ.default), {
                                        id: "vendor-alert-label",
                                        children: "BAC Entry"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e43jk.default), {
                                        labelId: "vendor-alert-label",
                                        id: "vendor-alert-select",
                                        value: selectedVendorAlert,
                                        onChange: (e)=>setSelectedVendorAlert(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1vvTA.default), {
                                                value: "",
                                                children: /*#__PURE__*/ (0, $fR5Jw.jsx)("em", {
                                                    children: "Not Applicable"
                                                })
                                            }),
                                            vendorAlerts.map((alert)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1vvTA.default), {
                                                    value: alert._id,
                                                    children: [
                                                        formatDate(alert.toxDate, alert.toxResult),
                                                        " - ",
                                                        alert.toxResult
                                                    ]
                                                }, alert._id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4wnpT.default), {
                                sx: {
                                    mt: 2
                                },
                                error: hasError("Notes"),
                                fullWidth: true,
                                helperText: hasError("Notes") ? (_formState_errors_Notes = formState.errors.Notes) === null || _formState_errors_Notes === void 0 ? void 0 : _formState_errors_Notes[0] : null,
                                label: "Notes",
                                name: "Notes",
                                onChange: handleChange,
                                value: formState.values.Notes || ""
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4wnpT.default), {
                                sx: {
                                    mt: 2
                                },
                                fullWidth: true,
                                label: "Report File",
                                name: "file",
                                onChange: (event)=>{
                                    const target = event.target;
                                    if (target.files) setFile(target.files[0]);
                                },
                                type: "file",
                                InputLabelProps: {
                                    shrink: true
                                }
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1jYbn.default), {
                                sx: {
                                    mt: 2,
                                    width: "100%"
                                },
                                variant: "standard",
                                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7cH5t.default), {
                                    control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lFkXs.default), {
                                        checked: selfReport,
                                        onChange: handleSelfReport,
                                        disabled: !auth.accountableAdmin
                                    }),
                                    label: "Was this a self report?"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $3kUUy.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                onClick: handleSave,
                                variant: "contained",
                                color: "primary",
                                autoFocus: true,
                                disabled: !formState.isValid || !result || !toxType || toxType === 5 && !selectedKit && result !== "Missed" // Disable if kit is not selected when Lab Confirmation and result is not Missed
                                ,
                                children: "Save Toxicology"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                onClick: handleCancel,
                                variant: "contained",
                                color: "secondary",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $68172d558cb16d43$export$2e2bcd8739ae039 = $68172d558cb16d43$var$AddTox;

});
parcelRegister("lFkXs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc5daf24959caee6$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $2YiNh = parcelRequire("2YiNh");

var $fTq1Z = parcelRequire("fTq1Z");

var $dPm6L = parcelRequire("dPm6L");

var $kUwtT = parcelRequire("kUwtT");

var $9TQfG = parcelRequire("9TQfG");

var $c1SJa = parcelRequire("c1SJa");

var $52gaR = parcelRequire("52gaR");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $fc5daf24959caee6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $9TQfG.default)(color)}`,
            `size${(0, $9TQfG.default)(size)}`
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $52gaR.getCheckboxUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $fc5daf24959caee6$var$CheckboxRoot = (0, $dTuzq.default)((0, $2YiNh.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $9TQfG.default)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $9TQfG.default)(ownerState.color)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: "default",
                    disableRipple: false
                },
                style: {
                    "&:hover": {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        "&:hover": {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $52gaR.default).checked}, &.${(0, $52gaR.default).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $52gaR.default).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    "&:hover": {
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            }
        ]
    })));
const $fc5daf24959caee6$var$defaultCheckedIcon = /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $dPm6L.default), {});
const $fc5daf24959caee6$var$defaultIcon = /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fTq1Z.default), {});
const $fc5daf24959caee6$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kUwtT.default), {});
const $fc5daf24959caee6$var$Checkbox = /*#__PURE__*/ $dgG1Y.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $fc5daf24959caee6$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $fc5daf24959caee6$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $fc5daf24959caee6$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", disableRipple: disableRipple = false, className: className, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $fc5daf24959caee6$var$useUtilityClasses(ownerState);
    var _icon_props_fontSize, _indeterminateIcon_props_fontSize;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($fc5daf24959caee6$var$CheckboxRoot, {
        type: "checkbox",
        inputProps: {
            "data-indeterminate": indeterminate,
            ...inputProps
        },
        icon: /*#__PURE__*/ $dgG1Y.cloneElement(icon, {
            fontSize: (_icon_props_fontSize = icon.props.fontSize) !== null && _icon_props_fontSize !== void 0 ? _icon_props_fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $dgG1Y.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon_props_fontSize = indeterminateIcon.props.fontSize) !== null && _indeterminateIcon_props_fontSize !== void 0 ? _indeterminateIcon_props_fontSize : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $8MGTi.default)(classes.root, className),
        disableRipple: disableRipple,
        ...other,
        classes: classes
    });
});
var $fc5daf24959caee6$export$2e2bcd8739ae039 = $fc5daf24959caee6$var$Checkbox;

});
parcelRegister("2YiNh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $229fc36edf606708$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $9TQfG = parcelRequire("9TQfG");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $fPTK9 = parcelRequire("fPTK9");

var $5cF86 = parcelRequire("5cF86");

var $fX4dN = parcelRequire("fX4dN");

var $kfcsu = parcelRequire("kfcsu");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $229fc36edf606708$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $9TQfG.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $kfcsu.getSwitchBaseUtilityClass), classes);
};
const $229fc36edf606708$var$SwitchBaseRoot = (0, $dTuzq.default)((0, $fX4dN.default))({
    padding: 9,
    borderRadius: "50%",
    variants: [
        {
            props: {
                edge: "start",
                size: "small"
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === "start" && ownerState.size !== "small",
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: "end",
                size: "small"
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === "end" && ownerState.size !== "small",
            style: {
                marginRight: -12
            }
        }
    ]
});
const $229fc36edf606708$var$SwitchBaseInput = (0, $dTuzq.default)("input", {
    shouldForwardProp: (0, $c1SJa.default)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $229fc36edf606708$var$SwitchBase = /*#__PURE__*/ $dgG1Y.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, ...other } = props;
    const [checked, setCheckedState] = (0, $fPTK9.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $5cF86.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $229fc36edf606708$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($229fc36edf606708$var$SwitchBaseRoot, {
        component: "span",
        className: (0, $8MGTi.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)($229fc36edf606708$var$SwitchBaseInput, {
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type,
                ...type === "checkbox" && value === undefined ? {} : {
                    value: value
                },
                ...inputProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $229fc36edf606708$export$2e2bcd8739ae039 = $229fc36edf606708$var$SwitchBase;

});
parcelRegister("fPTK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b876dbea1f520206$export$2e2bcd8739ae039; });

var $jxQkg = parcelRequire("jxQkg");
"use client";
var $b876dbea1f520206$export$2e2bcd8739ae039 = (0, $jxQkg.default);

});
parcelRegister("jxQkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a9b039be6fd4c6$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
"use client";
function $e3a9b039be6fd4c6$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $dgG1Y.useRef(controlled !== undefined);
    const [valueState, setValue] = $dgG1Y.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $dgG1Y.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("5cF86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9dfa3d56069c0e$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $duW1R = parcelRequire("duW1R");
"use client";
function $3c9dfa3d56069c0e$export$2e2bcd8739ae039() {
    return $dgG1Y.useContext((0, $duW1R.default));
}

});
parcelRegister("duW1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3b1708949cf551$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ const $9d3b1708949cf551$var$FormControlContext = /*#__PURE__*/ $dgG1Y.createContext(undefined);
var $9d3b1708949cf551$export$2e2bcd8739ae039 = $9d3b1708949cf551$var$FormControlContext;

});


parcelRegister("kfcsu", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", function () { return $ebcedf5d1c9a994c$export$baa0faa0c7ad8085; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $ebcedf5d1c9a994c$export$baa0faa0c7ad8085(slot) {
    return (0, $5xHgF.default)("PrivateSwitchBase", slot);
}
const $ebcedf5d1c9a994c$var$switchBaseClasses = (0, $eFHYA.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $ebcedf5d1c9a994c$export$2e2bcd8739ae039 = $ebcedf5d1c9a994c$var$switchBaseClasses;

});


parcelRegister("fTq1Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9202f4e2c8655eb$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $b9202f4e2c8655eb$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRegister("dPm6L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1112ff8858cefb1$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $a1112ff8858cefb1$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRegister("kUwtT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3923bac84ea0630$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $f3923bac84ea0630$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRegister("52gaR", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", function () { return $3aa9af846ef4d3e1$export$6c57c6e16b4063b; });
$parcel$export(module.exports, "default", function () { return $3aa9af846ef4d3e1$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $3aa9af846ef4d3e1$export$6c57c6e16b4063b(slot) {
    return (0, $5xHgF.default)("MuiCheckbox", slot);
}
const $3aa9af846ef4d3e1$var$checkboxClasses = (0, $eFHYA.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $3aa9af846ef4d3e1$export$2e2bcd8739ae039 = $3aa9af846ef4d3e1$var$checkboxClasses;

});


parcelRegister("1jYbn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f663fc24ad597c8$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $jC58J = parcelRequire("jC58J");

var $9TQfG = parcelRequire("9TQfG");

var $cG4rf = parcelRequire("cG4rf");

var $duW1R = parcelRequire("duW1R");

var $64uBO = parcelRequire("64uBO");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $0f663fc24ad597c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $9TQfG.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $64uBO.getFormControlUtilityClasses), classes);
};
const $0f663fc24ad597c8$var$FormControlRoot = (0, $dTuzq.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $9TQfG.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: "inline-flex",
    flexDirection: "column",
    position: "relative",
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: "top",
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: "normal"
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: "dense"
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $0f663fc24ad597c8$var$FormControl = /*#__PURE__*/ $dgG1Y.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $0f663fc24ad597c8$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $dgG1Y.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $dgG1Y.Children.forEach(children, (child)=>{
            if (!(0, $cG4rf.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $cG4rf.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $jC58J.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $dgG1Y.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $dgG1Y.Children.forEach(children, (child)=>{
            if (!(0, $cG4rf.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $jC58J.isFilled)(child.props, true) || (0, $jC58J.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $dgG1Y.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $dgG1Y.useRef(false);
    const childContext = $dgG1Y.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $duW1R.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)($0f663fc24ad597c8$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $8MGTi.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $0f663fc24ad597c8$export$2e2bcd8739ae039 = $0f663fc24ad597c8$var$FormControl;

});
parcelRegister("jC58J", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $e4758d9280f837f7$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $e4758d9280f837f7$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $e4758d9280f837f7$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $e4758d9280f837f7$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($e4758d9280f837f7$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $e4758d9280f837f7$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $e4758d9280f837f7$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("64uBO", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $46badc196ea3c38f$export$149c8b8bab2289d1; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $46badc196ea3c38f$export$149c8b8bab2289d1(slot) {
    return (0, $5xHgF.default)("MuiFormControl", slot);
}
const $46badc196ea3c38f$var$formControlClasses = (0, $eFHYA.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $46badc196ea3c38f$export$2e2bcd8739ae039 = $46badc196ea3c38f$var$formControlClasses;

});


parcelRegister("7cH5t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53eb139cce4e1415$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $5cF86 = parcelRequire("5cF86");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $kMmDg = parcelRequire("kMmDg");

var $9TQfG = parcelRequire("9TQfG");

var $56S9Q = parcelRequire("56S9Q");

var $57Zgm = parcelRequire("57Zgm");

var $eAnru = parcelRequire("eAnru");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $53eb139cce4e1415$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $9TQfG.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $56S9Q.getFormControlLabelUtilityClasses), classes);
};
const $53eb139cce4e1415$export$1b479270917a5676 = (0, $dTuzq.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $56S9Q.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $9TQfG.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $56S9Q.default).disabled}`]: {
            cursor: "default"
        },
        [`& .${(0, $56S9Q.default).label}`]: {
            [`&.${(0, $56S9Q.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: "start"
                },
                style: {
                    flexDirection: "row-reverse",
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: "top"
                },
                style: {
                    flexDirection: "column-reverse"
                }
            },
            {
                props: {
                    labelPlacement: "bottom"
                },
                style: {
                    flexDirection: "column"
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === "start" || labelPlacement === "top" || labelPlacement === "bottom",
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $53eb139cce4e1415$var$AsteriskComponent = (0, $dTuzq.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $iIVKJ.default)(({ theme: theme })=>({
        [`&.${(0, $56S9Q.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $53eb139cce4e1415$var$FormControlLabel = /*#__PURE__*/ $dgG1Y.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = "end", name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $5cF86.default)();
    var _ref;
    const disabled = (_ref = disabledProp !== null && disabledProp !== void 0 ? disabledProp : control.props.disabled) !== null && _ref !== void 0 ? _ref : muiFormControl === null || muiFormControl === void 0 ? void 0 : muiFormControl.disabled;
    const required = requiredProp !== null && requiredProp !== void 0 ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $53eb139cce4e1415$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $eAnru.default)("typography", {
        elementType: (0, $kMmDg.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $kMmDg.default) && !disableTypography) label = /*#__PURE__*/ (0, $fR5Jw.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $8MGTi.default)(classes.label, typographySlotProps === null || typographySlotProps === void 0 ? void 0 : typographySlotProps.className),
        children: label
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($53eb139cce4e1415$export$1b479270917a5676, {
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $dgG1Y.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)($53eb139cce4e1415$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $53eb139cce4e1415$export$2e2bcd8739ae039 = $53eb139cce4e1415$var$FormControlLabel;

});
parcelRegister("56S9Q", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", function () { return $3b8785e05c751c1f$export$717666c39ec07e12; });
$parcel$export(module.exports, "default", function () { return $3b8785e05c751c1f$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $3b8785e05c751c1f$export$717666c39ec07e12(slot) {
    return (0, $5xHgF.default)("MuiFormControlLabel", slot);
}
const $3b8785e05c751c1f$var$formControlLabelClasses = (0, $eFHYA.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $3b8785e05c751c1f$export$2e2bcd8739ae039 = $3b8785e05c751c1f$var$formControlLabelClasses;

});

parcelRegister("57Zgm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bbd20be5e4a3e5a$export$2e2bcd8739ae039; });
function $3bbd20be5e4a3e5a$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});


parcelRegister("cHWQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $940726756ac4fdbd$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $1wSL5 = parcelRequire("1wSL5");

var $8MGTi = parcelRequire("8MGTi");

var $57Zgm = parcelRequire("57Zgm");

var $5cF86 = parcelRequire("5cF86");

var $8GddG = parcelRequire("8GddG");
var $lyqZb = parcelRequire("lyqZb");

var $9TQfG = parcelRequire("9TQfG");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $cw1q5 = parcelRequire("cw1q5");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $940726756ac4fdbd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $9TQfG.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $cw1q5.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $940726756ac4fdbd$var$InputLabelRoot = (0, $dTuzq.default)((0, $8GddG.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $lyqZb.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: "translate(0, 20px) scale(1)"
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: "translate(0, 17px) scale(1)"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: "translate(0, -1.5px) scale(0.75)",
                    transformOrigin: "top left",
                    maxWidth: "133%"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        "color",
                        "transform",
                        "max-width"
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: "filled"
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: "none",
                    transform: "translate(12px, 16px) scale(1)",
                    maxWidth: "calc(100% - 24px)"
                }
            },
            {
                props: {
                    variant: "filled",
                    size: "small"
                },
                style: {
                    transform: "translate(12px, 13px) scale(1)"
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === "filled" && ownerState.shrink,
                style: {
                    userSelect: "none",
                    pointerEvents: "auto",
                    transform: "translate(12px, 7px) scale(0.75)",
                    maxWidth: "calc(133% - 24px)"
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === "filled" && ownerState.shrink && size === "small",
                style: {
                    transform: "translate(12px, 4px) scale(0.75)"
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: "none",
                    transform: "translate(14px, 16px) scale(1)",
                    maxWidth: "calc(100% - 24px)"
                }
            },
            {
                props: {
                    variant: "outlined",
                    size: "small"
                },
                style: {
                    transform: "translate(14px, 9px) scale(1)"
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === "outlined" && ownerState.shrink,
                style: {
                    userSelect: "none",
                    pointerEvents: "auto",
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: "calc(133% - 32px)",
                    transform: "translate(14px, -9px) scale(0.75)"
                }
            }
        ]
    })));
const $940726756ac4fdbd$var$InputLabel = /*#__PURE__*/ $dgG1Y.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $5cF86.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $940726756ac4fdbd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($940726756ac4fdbd$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $8MGTi.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $940726756ac4fdbd$export$2e2bcd8739ae039 = $940726756ac4fdbd$var$InputLabel;

});
parcelRegister("8GddG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $651c801adec83754$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $57Zgm = parcelRequire("57Zgm");

var $5cF86 = parcelRequire("5cF86");

var $9TQfG = parcelRequire("9TQfG");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $lyqZb = parcelRequire("lyqZb");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $651c801adec83754$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $9TQfG.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $lyqZb.getFormLabelUtilityClasses), classes);
};
const $651c801adec83754$export$aa5bc7f8a4705b27 = (0, $dTuzq.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === "secondary" && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        variants: [
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $lyqZb.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $lyqZb.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $lyqZb.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $651c801adec83754$var$AsteriskComponent = (0, $dTuzq.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $iIVKJ.default)(({ theme: theme })=>({
        [`&.${(0, $lyqZb.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $651c801adec83754$var$FormLabel = /*#__PURE__*/ $dgG1Y.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, color: color, component: component = "label", disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $5cF86.default)();
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $651c801adec83754$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($651c801adec83754$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $8MGTi.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $fR5Jw.jsxs)($651c801adec83754$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    });
});
var $651c801adec83754$export$2e2bcd8739ae039 = $651c801adec83754$var$FormLabel;

});
parcelRegister("lyqZb", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $fb11b4ca00a3a72f$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $fb11b4ca00a3a72f$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $fb11b4ca00a3a72f$export$f7d501e40371cd17(slot) {
    return (0, $5xHgF.default)("MuiFormLabel", slot);
}
const $fb11b4ca00a3a72f$var$formLabelClasses = (0, $eFHYA.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $fb11b4ca00a3a72f$export$2e2bcd8739ae039 = $fb11b4ca00a3a72f$var$formLabelClasses;

});


parcelRegister("cw1q5", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $91c9931e7539ebe7$export$c1c4b4545ad2ea5f; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $91c9931e7539ebe7$export$c1c4b4545ad2ea5f(slot) {
    return (0, $5xHgF.default)("MuiInputLabel", slot);
}
const $91c9931e7539ebe7$var$inputLabelClasses = (0, $eFHYA.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $91c9931e7539ebe7$export$2e2bcd8739ae039 = $91c9931e7539ebe7$var$inputLabelClasses;

});


parcelRegister("1vvTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11916d793da5b598$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $kRnLR = parcelRequire("kRnLR");

var $fX4dN = parcelRequire("fX4dN");

var $c3WFh = parcelRequire("c3WFh");

var $51QVq = parcelRequire("51QVq");

var $59WLo = parcelRequire("59WLo");

var $5a0Wz = parcelRequire("5a0Wz");

var $5xeEX = parcelRequire("5xeEX");

var $a8dzi = parcelRequire("a8dzi");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $11916d793da5b598$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $11916d793da5b598$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $a8dzi.getMenuItemUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $11916d793da5b598$var$MenuItemRoot = (0, $dTuzq.default)((0, $fX4dN.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $11916d793da5b598$export$4334bb34c76fef24
})((0, $iIVKJ.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap",
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $a8dzi.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kqewD.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $a8dzi.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kqewD.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $a8dzi.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kqewD.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kqewD.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $a8dzi.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $a8dzi.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $59WLo.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $59WLo.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $5xeEX.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $5xeEX.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $5a0Wz.default).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: "padding-box"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up("sm")]: {
                        minHeight: "auto"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $5a0Wz.default).root} svg`]: {
                        fontSize: "1.25rem"
                    }
                }
            }
        ]
    })));
const $11916d793da5b598$var$MenuItem = /*#__PURE__*/ $dgG1Y.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $dgG1Y.useContext((0, $kRnLR.default));
    const childContext = $dgG1Y.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $dgG1Y.useRef(null);
    (0, $c3WFh.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $11916d793da5b598$var$useUtilityClasses(props);
    const handleRef = (0, $51QVq.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kRnLR.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)($11916d793da5b598$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $8MGTi.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $8MGTi.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $11916d793da5b598$export$2e2bcd8739ae039 = $11916d793da5b598$var$MenuItem;

});
parcelRegister("c3WFh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c834573e766f6d8$export$2e2bcd8739ae039; });

var $huSf2 = parcelRequire("huSf2");
"use client";
var $8c834573e766f6d8$export$2e2bcd8739ae039 = (0, $huSf2.default);

});

parcelRegister("5a0Wz", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", function () { return $3c1e9e4e0dee8506$export$81478e24460c57f2; });
$parcel$export(module.exports, "default", function () { return $3c1e9e4e0dee8506$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $3c1e9e4e0dee8506$export$81478e24460c57f2(slot) {
    return (0, $5xHgF.default)("MuiListItemIcon", slot);
}
const $3c1e9e4e0dee8506$var$listItemIconClasses = (0, $eFHYA.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $3c1e9e4e0dee8506$export$2e2bcd8739ae039 = $3c1e9e4e0dee8506$var$listItemIconClasses;

});

parcelRegister("a8dzi", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", function () { return $76052d1f494cf3e9$export$515f8c67b5305377; });
$parcel$export(module.exports, "default", function () { return $76052d1f494cf3e9$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $76052d1f494cf3e9$export$515f8c67b5305377(slot) {
    return (0, $5xHgF.default)("MuiMenuItem", slot);
}
const $76052d1f494cf3e9$var$menuItemClasses = (0, $eFHYA.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $76052d1f494cf3e9$export$2e2bcd8739ae039 = $76052d1f494cf3e9$var$menuItemClasses;

});


parcelRegister("e43jk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3d401de5b43a536$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $ig9jY = parcelRequire("ig9jY");

var $bEw0x = parcelRequire("bEw0x");

var $isWTK = parcelRequire("isWTK");

var $57Zgm = parcelRequire("57Zgm");

var $5cF86 = parcelRequire("5cF86");

var $bY3mL = parcelRequire("bY3mL");

var $a2T3z = parcelRequire("a2T3z");

var $hoxek = parcelRequire("hoxek");

var $2TqGF = parcelRequire("2TqGF");

var $2FiVa = parcelRequire("2FiVa");

var $aR3AP = parcelRequire("aR3AP");

var $51QVq = parcelRequire("51QVq");

var $dTuzq = parcelRequire("dTuzq");

var $c1SJa = parcelRequire("c1SJa");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $a3d401de5b43a536$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $a3d401de5b43a536$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $a3d401de5b43a536$var$StyledInput = (0, $dTuzq.default)((0, $a2T3z.default), $a3d401de5b43a536$var$styledRootConfig)("");
const $a3d401de5b43a536$var$StyledOutlinedInput = (0, $dTuzq.default)((0, $2FiVa.default), $a3d401de5b43a536$var$styledRootConfig)("");
const $a3d401de5b43a536$var$StyledFilledInput = (0, $dTuzq.default)((0, $2TqGF.default), $a3d401de5b43a536$var$styledRootConfig)("");
const $a3d401de5b43a536$var$Select = /*#__PURE__*/ $dgG1Y.forwardRef(function Select(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $bY3mL.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined", ...other } = props;
    const inputComponent = native ? (0, $hoxek.default) : (0, $isWTK.default);
    const muiFormControl = (0, $5cF86.default)();
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $a3d401de5b43a536$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $fR5Jw.jsx)($a3d401de5b43a536$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $fR5Jw.jsx)($a3d401de5b43a536$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $fR5Jw.jsx)($a3d401de5b43a536$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $51QVq.default)(ref, (0, $bEw0x.default)(InputComponent));
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($dgG1Y.Fragment, {
        children: /*#__PURE__*/ $dgG1Y.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $ig9jY.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === "outlined" ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $8MGTi.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$a3d401de5b43a536$var$Select.muiName = "Select";
var $a3d401de5b43a536$export$2e2bcd8739ae039 = $a3d401de5b43a536$var$Select;

});
parcelRegister("isWTK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7188777956a4830$export$2e2bcd8739ae039; });

var $iPooL = parcelRequire("iPooL");

var $dgG1Y = parcelRequire("dgG1Y");



var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $383VY = parcelRequire("383VY");


var $7nM5V = parcelRequire("7nM5V");

var $9TQfG = parcelRequire("9TQfG");

var $8o3ta = parcelRequire("8o3ta");

var $hoxek = parcelRequire("hoxek");

var $jC58J = parcelRequire("jC58J");

var $dTuzq = parcelRequire("dTuzq");

var $3EdCI = parcelRequire("3EdCI");

var $51QVq = parcelRequire("51QVq");

var $fPTK9 = parcelRequire("fPTK9");

var $bGK5A = parcelRequire("bGK5A");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $d7188777956a4830$var$_span;
const $d7188777956a4830$var$SelectSelect = (0, $dTuzq.default)((0, $hoxek.StyledSelectSelect), {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bGK5A.default).select}`]: styles.select
            },
            {
                [`&.${(0, $bGK5A.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bGK5A.default).error}`]: styles.error
            },
            {
                [`&.${(0, $bGK5A.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $bGK5A.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $d7188777956a4830$var$SelectIcon = (0, $dTuzq.default)((0, $hoxek.StyledSelectIcon), {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $9TQfG.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $d7188777956a4830$var$SelectNativeInput = (0, $dTuzq.default)("input", {
    shouldForwardProp: (prop)=>(0, $3EdCI.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $d7188777956a4830$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $d7188777956a4830$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $d7188777956a4830$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $9TQfG.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $bGK5A.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $d7188777956a4830$var$SelectInput = /*#__PURE__*/ $dgG1Y.forwardRef(function SelectInput(props, ref) {
    var _MenuProps_slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = "standard", ...other } = props;
    const [value, setValueState] = (0, $fPTK9.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $fPTK9.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $dgG1Y.useRef(null);
    const displayRef = $dgG1Y.useRef(null);
    const [displayNode, setDisplayNode] = $dgG1Y.useState(null);
    const { current: isOpenControlled } = $dgG1Y.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $dgG1Y.useState();
    const handleRef = (0, $51QVq.default)(ref, inputRefProp);
    const handleDisplayRef = $dgG1Y.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode === null || displayNode === void 0 ? void 0 : displayNode.parentNode;
    $dgG1Y.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $dgG1Y.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $dgG1Y.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $dgG1Y.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $7nM5V.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $dgG1Y.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $jC58J.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $iPooL.default)(2));
            selected = value.some((v)=>$d7188777956a4830$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $d7188777956a4830$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $dgG1Y.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $d7188777956a4830$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...(_MenuProps_slotProps = MenuProps.slotProps) === null || _MenuProps_slotProps === void 0 ? void 0 : _MenuProps_slotProps.paper
    };
    const listboxId = (0, $383VY.default)();
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)($d7188777956a4830$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? "true" : undefined,
                "aria-invalid": error ? "true" : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $8MGTi.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $d7188777956a4830$var$isEmpty(display) ? $d7188777956a4830$var$_span || ($d7188777956a4830$var$_span = /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)($d7188777956a4830$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)($d7188777956a4830$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8o3ta.default), {
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                ...MenuProps,
                MenuListProps: {
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId,
                    ...MenuProps.MenuListProps
                },
                slotProps: {
                    ...MenuProps.slotProps,
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $d7188777956a4830$export$2e2bcd8739ae039 = $d7188777956a4830$var$SelectInput;

});
parcelRegister("8o3ta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61b341910a3a3f72$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");



var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");


var $gK9Ik = parcelRequire("gK9Ik");

var $a3oUN = parcelRequire("a3oUN");

var $72IPZ = parcelRequire("72IPZ");

var $iAs39 = parcelRequire("iAs39");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $9wUyL = parcelRequire("9wUyL");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $61b341910a3a3f72$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $61b341910a3a3f72$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $61b341910a3a3f72$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $9wUyL.getMenuUtilityClass), classes);
};
const $61b341910a3a3f72$var$MenuRoot = (0, $dTuzq.default)((0, $iAs39.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $61b341910a3a3f72$export$4f7c51a5920c9f33 = (0, $dTuzq.default)((0, $iAs39.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $61b341910a3a3f72$var$MenuMenuList = (0, $dTuzq.default)((0, $72IPZ.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $61b341910a3a3f72$var$Menu = /*#__PURE__*/ $dgG1Y.forwardRef(function Menu(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $gK9Ik.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $61b341910a3a3f72$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $dgG1Y.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $dgG1Y.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var _slots_paper;
    const PaperSlot = (_slots_paper = slots.paper) !== null && _slots_paper !== void 0 ? _slots_paper : $61b341910a3a3f72$export$4f7c51a5920c9f33;
    var _slotProps_paper;
    const paperExternalSlotProps = (_slotProps_paper = slotProps.paper) !== null && _slotProps_paper !== void 0 ? _slotProps_paper : PaperProps;
    const rootSlotProps = (0, $a3oUN.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $a3oUN.default)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($61b341910a3a3f72$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $61b341910a3a3f72$var$RTL_ORIGIN : $61b341910a3a3f72$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: {
            onEntering: handleEntering,
            ...TransitionProps
        },
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)($61b341910a3a3f72$var$MenuMenuList, {
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...MenuListProps,
            className: (0, $8MGTi.default)(classes.list, MenuListProps.className),
            children: children
        })
    });
});
var $61b341910a3a3f72$export$2e2bcd8739ae039 = $61b341910a3a3f72$var$Menu;

});
parcelRegister("72IPZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $520b8022b91d190c$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");



var $7nM5V = parcelRequire("7nM5V");

var $jayBd = parcelRequire("jayBd");

var $7FwGg = parcelRequire("7FwGg");

var $51QVq = parcelRequire("51QVq");

var $c3WFh = parcelRequire("c3WFh");

var $44E5a = parcelRequire("44E5a");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $520b8022b91d190c$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $520b8022b91d190c$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $520b8022b91d190c$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(""));
}
function $520b8022b91d190c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$520b8022b91d190c$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $520b8022b91d190c$var$MenuList = /*#__PURE__*/ $dgG1Y.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu", ...other } = props;
    const listRef = $dgG1Y.useRef(null);
    const textCriteriaRef = $dgG1Y.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $c3WFh.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $dgG1Y.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $7FwGg.default)((0, $44E5a.default)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $7nM5V.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $520b8022b91d190c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $520b8022b91d190c$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $520b8022b91d190c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $520b8022b91d190c$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $520b8022b91d190c$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $520b8022b91d190c$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $520b8022b91d190c$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $520b8022b91d190c$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $520b8022b91d190c$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $520b8022b91d190c$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $520b8022b91d190c$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $51QVq.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $dgG1Y.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $dgG1Y.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $dgG1Y.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jayBd.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $520b8022b91d190c$export$2e2bcd8739ae039 = $520b8022b91d190c$var$MenuList;

});
parcelRegister("7FwGg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5955b6711d855836$export$2e2bcd8739ae039; });

var $dNTYI = parcelRequire("dNTYI");
var $5955b6711d855836$export$2e2bcd8739ae039 = (0, $dNTYI.default);

});


parcelRegister("iAs39", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $d88158e32b1f2b41$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $d88158e32b1f2b41$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");






var $a3KHH = parcelRequire("a3KHH");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $blSgQ = parcelRequire("blSgQ");

var $7nM5V = parcelRequire("7nM5V");

var $44E5a = parcelRequire("44E5a");

var $51QVq = parcelRequire("51QVq");

var $lUlBP = parcelRequire("lUlBP");

var $kDVit = parcelRequire("kDVit");

var $cBhUq = parcelRequire("cBhUq");

var $7wgs1 = parcelRequire("7wgs1");

var $eAnru = parcelRequire("eAnru");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $d88158e32b1f2b41$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $d88158e32b1f2b41$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $d88158e32b1f2b41$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $d88158e32b1f2b41$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $d88158e32b1f2b41$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $7wgs1.getPopoverUtilityClass), classes);
};
const $d88158e32b1f2b41$export$bcce13685275fc99 = (0, $dTuzq.default)((0, $kDVit.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $d88158e32b1f2b41$export$821346c38a2d9390 = (0, $dTuzq.default)((0, $cBhUq.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $d88158e32b1f2b41$var$Popover = /*#__PURE__*/ $dgG1Y.forwardRef(function Popover(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $lUlBP.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, disableScrollLock: disableScrollLock = false, ...other } = props;
    var _slotProps_paper;
    const externalPaperSlotProps = (_slotProps_paper = slotProps === null || slotProps === void 0 ? void 0 : slotProps.paper) !== null && _slotProps_paper !== void 0 ? _slotProps_paper : PaperPropsProp;
    const paperRef = $dgG1Y.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $d88158e32b1f2b41$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $dgG1Y.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $d88158e32b1f2b41$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $7nM5V.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $d88158e32b1f2b41$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $d88158e32b1f2b41$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $dgG1Y.useCallback((elemRect)=>{
        return {
            vertical: $d88158e32b1f2b41$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $d88158e32b1f2b41$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $dgG1Y.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $d88158e32b1f2b41$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $44E5a.default)($d88158e32b1f2b41$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $d88158e32b1f2b41$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $dgG1Y.useState(open);
    const setPositioningStyles = $dgG1Y.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty("top", positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $dgG1Y.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $dgG1Y.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $dgG1Y.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $dgG1Y.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $blSgQ.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $44E5a.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $7nM5V.default)($d88158e32b1f2b41$var$resolveAnchorEl(anchorEl)).body : undefined);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...slotProps,
            paper: externalPaperSlotProps
        }
    };
    const [PaperSlot, paperProps] = (0, $eAnru.default)("paper", {
        elementType: $d88158e32b1f2b41$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: elevation,
            className: (0, $8MGTi.default)(classes.paper, externalPaperSlotProps === null || externalPaperSlotProps === void 0 ? void 0 : externalPaperSlotProps.className),
            style: isPositioned ? externalPaperSlotProps.style : {
                ...externalPaperSlotProps.style,
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    const [RootSlot, { slotProps: rootSlotPropsProp, ...rootProps }] = (0, $eAnru.default)("root", {
        elementType: $d88158e32b1f2b41$export$bcce13685275fc99,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $8MGTi.default)(classes.root, className)
    });
    const handlePaperRef = (0, $51QVq.default)(paperRef, paperProps.ref);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $a3KHH.default)(RootSlot) && {
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        ...other,
        ref: ref,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionComponent, {
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration,
            ...TransitionProps,
            children: /*#__PURE__*/ (0, $fR5Jw.jsx)(PaperSlot, {
                ...paperProps,
                ref: handlePaperRef,
                children: children
            })
        })
    });
});
var $d88158e32b1f2b41$export$2e2bcd8739ae039 = $d88158e32b1f2b41$var$Popover;

});
parcelRegister("7wgs1", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $5798485ea1979297$export$88f455dd56c95edb; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $5798485ea1979297$export$88f455dd56c95edb(slot) {
    return (0, $5xHgF.default)("MuiPopover", slot);
}
const $5798485ea1979297$var$popoverClasses = (0, $eFHYA.default)("MuiPopover", [
    "root",
    "paper"
]);
var $5798485ea1979297$export$2e2bcd8739ae039 = $5798485ea1979297$var$popoverClasses;

});


parcelRegister("9wUyL", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $6f02f9cfba9a7144$export$2cf86a63a84fe23d; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $6f02f9cfba9a7144$export$2cf86a63a84fe23d(slot) {
    return (0, $5xHgF.default)("MuiMenu", slot);
}
const $6f02f9cfba9a7144$var$menuClasses = (0, $eFHYA.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $6f02f9cfba9a7144$export$2e2bcd8739ae039 = $6f02f9cfba9a7144$var$menuClasses;

});


parcelRegister("hoxek", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", function () { return $ca9e7463ad2b2bc3$export$50b3545a8ccd87af; });
$parcel$export(module.exports, "StyledSelectIcon", function () { return $ca9e7463ad2b2bc3$export$7dd4d92f143902e3; });
$parcel$export(module.exports, "default", function () { return $ca9e7463ad2b2bc3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $9TQfG = parcelRequire("9TQfG");

var $db4q2 = parcelRequire("db4q2");

var $dTuzq = parcelRequire("dTuzq");

var $c1SJa = parcelRequire("c1SJa");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $ca9e7463ad2b2bc3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $9TQfG.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $db4q2.getNativeSelectUtilityClasses), classes);
};
const $ca9e7463ad2b2bc3$export$50b3545a8ccd87af = (0, $dTuzq.default)("select")(({ theme: theme })=>({
        // Reset
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        // Reset
        borderRadius: 0,
        cursor: "pointer",
        "&:focus": {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $db4q2.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== "filled" && ownerState.variant !== "outlined",
                style: {
                    // Bump specificity to allow extending custom inputs
                    "&&&": {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: "filled"
                },
                style: {
                    "&&&": {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    "&:focus": {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    "&&&": {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $ca9e7463ad2b2bc3$var$NativeSelectSelect = (0, $dTuzq.default)($ca9e7463ad2b2bc3$export$50b3545a8ccd87af, {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $c1SJa.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $db4q2.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $ca9e7463ad2b2bc3$export$7dd4d92f143902e3 = (0, $dTuzq.default)("svg")(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        // Center vertically, height is 1em
        top: "calc(50% - .5em)",
        // Don't block pointer events on the select under the icon.
        pointerEvents: "none",
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $db4q2.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: "rotate(180deg)"
                }
            },
            {
                props: {
                    variant: "filled"
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $ca9e7463ad2b2bc3$var$NativeSelectIcon = (0, $dTuzq.default)($ca9e7463ad2b2bc3$export$7dd4d92f143902e3, {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $9TQfG.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $ca9e7463ad2b2bc3$var$NativeSelectInput = /*#__PURE__*/ $dgG1Y.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard", ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $ca9e7463ad2b2bc3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)($ca9e7463ad2b2bc3$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $8MGTi.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $fR5Jw.jsx)($ca9e7463ad2b2bc3$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $ca9e7463ad2b2bc3$export$2e2bcd8739ae039 = $ca9e7463ad2b2bc3$var$NativeSelectInput;

});
parcelRegister("db4q2", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $997fbaf7ed1d96d7$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $997fbaf7ed1d96d7$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $997fbaf7ed1d96d7$export$1ee13051fd9e2ab5(slot) {
    return (0, $5xHgF.default)("MuiNativeSelect", slot);
}
const $997fbaf7ed1d96d7$var$nativeSelectClasses = (0, $eFHYA.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $997fbaf7ed1d96d7$export$2e2bcd8739ae039 = $997fbaf7ed1d96d7$var$nativeSelectClasses;

});


parcelRegister("bGK5A", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $88275e4f2b43caf9$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $88275e4f2b43caf9$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $88275e4f2b43caf9$export$2c0c1ee5a3392e(slot) {
    return (0, $5xHgF.default)("MuiSelect", slot);
}
const $88275e4f2b43caf9$var$selectClasses = (0, $eFHYA.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $88275e4f2b43caf9$export$2e2bcd8739ae039 = $88275e4f2b43caf9$var$selectClasses;

});


parcelRegister("bY3mL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b67e8bee1a69513$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $8b67e8bee1a69513$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("a2T3z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7504cc5a76d995cd$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $1wSL5 = parcelRequire("1wSL5");

var $ig9jY = parcelRequire("ig9jY");


var $4Vxp8 = parcelRequire("4Vxp8");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $1odYE = parcelRequire("1odYE");

var $4Vxp8 = parcelRequire("4Vxp8");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $7504cc5a76d995cd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $1odYE.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $7504cc5a76d995cd$var$InputRoot = (0, $dTuzq.default)((0, $4Vxp8.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $4Vxp8.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: "relative",
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    "label + &": {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $1odYE.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $1odYE.default).error}`]: {
                        "&::before, &::after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $1odYE.default).disabled}, .${(0, $1odYE.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $1odYE.default).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        "&::after": {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $7504cc5a76d995cd$var$InputInput = (0, $dTuzq.default)((0, $4Vxp8.InputBaseInput), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $4Vxp8.inputOverridesResolver)
})({});
const $7504cc5a76d995cd$var$Input = /*#__PURE__*/ $dgG1Y.forwardRef(function Input(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text", ...other } = props;
    const classes = $7504cc5a76d995cd$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps !== null && slotProps !== void 0 ? slotProps : componentsPropsProp) ? (0, $ig9jY.default)(slotProps !== null && slotProps !== void 0 ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    var _slots_root, _ref;
    const RootSlot = (_ref = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref !== void 0 ? _ref : $7504cc5a76d995cd$var$InputRoot;
    var _slots_input, _ref1;
    const InputSlot = (_ref1 = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : components.Input) !== null && _ref1 !== void 0 ? _ref1 : $7504cc5a76d995cd$var$InputInput;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Vxp8.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$7504cc5a76d995cd$var$Input.muiName = "Input";
var $7504cc5a76d995cd$export$2e2bcd8739ae039 = $7504cc5a76d995cd$var$Input;

});
parcelRegister("4Vxp8", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $396665b30b45ab1b$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $396665b30b45ab1b$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $396665b30b45ab1b$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseInput", function () { return $396665b30b45ab1b$export$ee10465db6ff6017; });
$parcel$export(module.exports, "default", function () { return $396665b30b45ab1b$export$2e2bcd8739ae039; });

var $iPooL = parcelRequire("iPooL");

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");



var $1wSL5 = parcelRequire("1wSL5");

var $eXtse = parcelRequire("eXtse");

var $a3KHH = parcelRequire("a3KHH");

var $57Zgm = parcelRequire("57Zgm");

var $duW1R = parcelRequire("duW1R");

var $5cF86 = parcelRequire("5cF86");

var $jAq4b = parcelRequire("jAq4b");
var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $9TQfG = parcelRequire("9TQfG");

var $51QVq = parcelRequire("51QVq");

var $c3WFh = parcelRequire("c3WFh");

var $jC58J = parcelRequire("jC58J");

var $34via = parcelRequire("34via");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $396665b30b45ab1b$var$_InputGlobalStyles;
const $396665b30b45ab1b$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $9TQfG.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $396665b30b45ab1b$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $396665b30b45ab1b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $9TQfG.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $9TQfG.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $34via.getInputBaseUtilityClass), classes);
};
const $396665b30b45ab1b$export$298a043133d72a38 = (0, $dTuzq.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $396665b30b45ab1b$export$965edad20a84fa75
})((0, $iIVKJ.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $34via.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: "4px 0 5px"
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === "small",
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: "100%"
                }
            }
        ]
    })));
const $396665b30b45ab1b$export$ee10465db6ff6017 = (0, $dTuzq.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $396665b30b45ab1b$export$cf507b112810e72d
})((0, $iIVKJ.default)(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const placeholder = {
        color: "currentColor",
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $34via.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $34via.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: "mui-auto-fill-cancel",
                    animationDuration: "10ms",
                    "&:-webkit-autofill": {
                        animationDuration: "5000s",
                        animationName: "mui-auto-fill"
                    }
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: "auto",
                    resize: "none",
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: "search"
                },
                style: {
                    MozAppearance: "textfield" // Improve type search style.
                }
            }
        ]
    };
}));
const $396665b30b45ab1b$var$InputGlobalStyles = (0, $jAq4b.globalCss)({
    "@keyframes mui-auto-fill": {
        from: {
            display: "block"
        }
    },
    "@keyframes mui-auto-fill-cancel": {
        from: {
            display: "block"
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $396665b30b45ab1b$var$InputBase = /*#__PURE__*/ $dgG1Y.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $dgG1Y.useRef(value != null);
    const inputRef = $dgG1Y.useRef();
    const handleInputRefWarning = $dgG1Y.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $51QVq.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $dgG1Y.useState(false);
    const muiFormControl = (0, $5cF86.default)();
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $dgG1Y.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $dgG1Y.useCallback((obj)=>{
        if ((0, $jC58J.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $c3WFh.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $iPooL.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $dgG1Y.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $eXtse.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $dgG1Y.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $396665b30b45ab1b$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $396665b30b45ab1b$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $396665b30b45ab1b$export$ee10465db6ff6017;
    var _slotProps_input;
    inputProps = {
        ...inputProps,
        ...(_slotProps_input = slotProps.input) !== null && _slotProps_input !== void 0 ? _slotProps_input : componentsProps.input
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $396665b30b45ab1b$var$InputGlobalStyles === "function" && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($396665b30b45ab1b$var$_InputGlobalStyles || ($396665b30b45ab1b$var$_InputGlobalStyles = /*#__PURE__*/ (0, $fR5Jw.jsx)($396665b30b45ab1b$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $a3KHH.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $8MGTi.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $duW1R.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $a3KHH.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $8MGTi.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $396665b30b45ab1b$export$2e2bcd8739ae039 = $396665b30b45ab1b$var$InputBase;

});
parcelRegister("eXtse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae3d6c64f718a5c5$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $d9Tuz = parcelRequire("d9Tuz");
var $lK2kL = parcelRequire("lK2kL");
var $huSf2 = parcelRequire("huSf2");
var $1ZLdA = parcelRequire("1ZLdA");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $ae3d6c64f718a5c5$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $ae3d6c64f718a5c5$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $ae3d6c64f718a5c5$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $ae3d6c64f718a5c5$var$TextareaAutosize = /*#__PURE__*/ $dgG1Y.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $dgG1Y.useRef(value != null);
    const inputRef = $dgG1Y.useRef(null);
    const handleRef = (0, $1ZLdA.default)(forwardedRef, inputRef);
    const heightRef = $dgG1Y.useRef(null);
    const shadowRef = $dgG1Y.useRef(null);
    const calculateTextareaStyles = $dgG1Y.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $lK2kL.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $ae3d6c64f718a5c5$var$getStyleValue(computedStyle.paddingBottom) + $ae3d6c64f718a5c5$var$getStyleValue(computedStyle.paddingTop);
        const border = $ae3d6c64f718a5c5$var$getStyleValue(computedStyle.borderBottomWidth) + $ae3d6c64f718a5c5$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $dgG1Y.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($ae3d6c64f718a5c5$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $huSf2.default)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $d9Tuz.default)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $lK2kL.default)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $huSf2.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: {
                    ...$ae3d6c64f718a5c5$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $ae3d6c64f718a5c5$export$2e2bcd8739ae039 = $ae3d6c64f718a5c5$var$TextareaAutosize;

});

parcelRegister("34via", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $23ca04c80a8f0191$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $23ca04c80a8f0191$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $23ca04c80a8f0191$export$ef57d5c8ca2278f6(slot) {
    return (0, $5xHgF.default)("MuiInputBase", slot);
}
const $23ca04c80a8f0191$var$inputBaseClasses = (0, $eFHYA.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $23ca04c80a8f0191$export$2e2bcd8739ae039 = $23ca04c80a8f0191$var$inputBaseClasses;

});


parcelRegister("1odYE", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $1032dfef72704fa4$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $1032dfef72704fa4$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");

var $34via = parcelRequire("34via");
function $1032dfef72704fa4$export$cdb270390122322b(slot) {
    return (0, $5xHgF.default)("MuiInput", slot);
}
const $1032dfef72704fa4$var$inputClasses = {
    ...(0, $34via.default),
    ...(0, $eFHYA.default)("MuiInput", [
        "root",
        "underline",
        "input"
    ])
};
var $1032dfef72704fa4$export$2e2bcd8739ae039 = $1032dfef72704fa4$var$inputClasses;

});


parcelRegister("2TqGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21b56b53da445a4f$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $ig9jY = parcelRequire("ig9jY");



var $1wSL5 = parcelRequire("1wSL5");

var $4Vxp8 = parcelRequire("4Vxp8");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $lcJ11 = parcelRequire("lcJ11");

var $4Vxp8 = parcelRequire("4Vxp8");

var $9TQfG = parcelRequire("9TQfG");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $21b56b53da445a4f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            size === "small" && `size${(0, $9TQfG.default)(size)}`,
            hiddenLabel && "hiddenLabel",
            multiline && "multiline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $lcJ11.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $21b56b53da445a4f$var$FilledInputRoot = (0, $dTuzq.default)((0, $4Vxp8.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $4Vxp8.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return {
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $lcJ11.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $lcJ11.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $lcJ11.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $lcJ11.default).error}`]: {
                        "&::before, &::after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $lcJ11.default).disabled}, .${(0, $lcJ11.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $lcJ11.default).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()) // check all the used fields in the style below
            .map(([color])=>{
                var _palette_color;
                return {
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        "&::after": {
                            borderBottom: `2px solid ${(_palette_color = (theme.vars || theme).palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main}`
                        }
                    }
                };
            }),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: "25px 12px 8px"
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === "small",
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === "small",
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $21b56b53da445a4f$var$FilledInputInput = (0, $dTuzq.default)((0, $4Vxp8.InputBaseInput), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $4Vxp8.inputOverridesResolver)
})((0, $iIVKJ.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
                caretColor: theme.palette.mode === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        ...theme.vars && {
            "&:-webkit-autofill": {
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            },
            [theme.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 100px #266798 inset",
                    WebkitTextFillColor: "#fff",
                    caretColor: "#fff"
                }
            }
        },
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === "small",
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $21b56b53da445a4f$var$FilledInput = /*#__PURE__*/ $dgG1Y.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text", ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $21b56b53da445a4f$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps !== null && slotProps !== void 0 ? slotProps : componentsPropsProp) ? (0, $ig9jY.default)(filledInputComponentsProps, slotProps !== null && slotProps !== void 0 ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    var _slots_root, _ref;
    const RootSlot = (_ref = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref !== void 0 ? _ref : $21b56b53da445a4f$var$FilledInputRoot;
    var _slots_input, _ref1;
    const InputSlot = (_ref1 = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : components.Input) !== null && _ref1 !== void 0 ? _ref1 : $21b56b53da445a4f$var$FilledInputInput;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Vxp8.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$21b56b53da445a4f$var$FilledInput.muiName = "Input";
var $21b56b53da445a4f$export$2e2bcd8739ae039 = $21b56b53da445a4f$var$FilledInput;

});
parcelRegister("lcJ11", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $f6fda31ca6f283ce$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $f6fda31ca6f283ce$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");

var $34via = parcelRequire("34via");
function $f6fda31ca6f283ce$export$3331e419f1a48437(slot) {
    return (0, $5xHgF.default)("MuiFilledInput", slot);
}
const $f6fda31ca6f283ce$var$filledInputClasses = {
    ...(0, $34via.default),
    ...(0, $eFHYA.default)("MuiFilledInput", [
        "root",
        "underline",
        "input",
        "adornedStart",
        "adornedEnd",
        "sizeSmall",
        "multiline",
        "hiddenLabel"
    ])
};
var $f6fda31ca6f283ce$export$2e2bcd8739ae039 = $f6fda31ca6f283ce$var$filledInputClasses;

});


parcelRegister("2FiVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0e166d1ceae549$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");



var $1wSL5 = parcelRequire("1wSL5");

var $6rJOM = parcelRequire("6rJOM");

var $5cF86 = parcelRequire("5cF86");

var $57Zgm = parcelRequire("57Zgm");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $5MLDO = parcelRequire("5MLDO");

var $4Vxp8 = parcelRequire("4Vxp8");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $1f0e166d1ceae549$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $1wSL5.default)(slots, (0, $5MLDO.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $1f0e166d1ceae549$var$OutlinedInputRoot = (0, $dTuzq.default)((0, $4Vxp8.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $4Vxp8.rootOverridesResolver)
})((0, $iIVKJ.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $5MLDO.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $5MLDO.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $5MLDO.default).focused} .${(0, $5MLDO.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5MLDO.default).focused} .${(0, $5MLDO.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $5MLDO.default).error} .${(0, $5MLDO.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $5MLDO.default).disabled} .${(0, $5MLDO.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: "16.5px 14px"
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === "small",
                style: {
                    padding: "8.5px 14px"
                }
            }
        ]
    };
}));
const $1f0e166d1ceae549$var$NotchedOutlineRoot = (0, $dTuzq.default)((0, $6rJOM.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $iIVKJ.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $1f0e166d1ceae549$var$OutlinedInputInput = (0, $dTuzq.default)((0, $4Vxp8.InputBaseInput), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $4Vxp8.inputOverridesResolver)
})((0, $iIVKJ.default)(({ theme: theme })=>({
        padding: "16.5px 14px",
        ...!theme.vars && {
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
                caretColor: theme.palette.mode === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        ...theme.vars && {
            "&:-webkit-autofill": {
                borderRadius: "inherit"
            },
            [theme.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 100px #266798 inset",
                    WebkitTextFillColor: "#fff",
                    caretColor: "#fff"
                }
            }
        },
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    padding: "8.5px 14px"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $1f0e166d1ceae549$var$OutlinedInput = /*#__PURE__*/ $dgG1Y.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text", ...other } = props;
    const classes = $1f0e166d1ceae549$var$useUtilityClasses(props);
    const muiFormControl = (0, $5cF86.default)();
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    var _slots_root, _ref;
    const RootSlot = (_ref = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref !== void 0 ? _ref : $1f0e166d1ceae549$var$OutlinedInputRoot;
    var _slots_input, _ref1;
    const InputSlot = (_ref1 = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : components.Input) !== null && _ref1 !== void 0 ? _ref1 : $1f0e166d1ceae549$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Vxp8.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $fR5Jw.jsx)($1f0e166d1ceae549$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$1f0e166d1ceae549$var$OutlinedInput.muiName = "Input";
var $1f0e166d1ceae549$export$2e2bcd8739ae039 = $1f0e166d1ceae549$var$OutlinedInput;

});
parcelRegister("6rJOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b18ce2d7e6bf648$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");


var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $4b18ce2d7e6bf648$var$_span;
const $4b18ce2d7e6bf648$var$NotchedOutlineRoot = (0, $dTuzq.default)("fieldset", {
    shouldForwardProp: (0, $c1SJa.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $4b18ce2d7e6bf648$var$NotchedOutlineLegend = (0, $dTuzq.default)("legend", {
    shouldForwardProp: (0, $c1SJa.default)
})((0, $iIVKJ.default)(({ theme: theme })=>({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden",
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: "11px",
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create("width", {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: "block",
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: theme.transitions.create("max-width", {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: "inline-block",
                        opacity: 0,
                        visibility: "visible"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: "100%",
                    transition: theme.transitions.create("max-width", {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $4b18ce2d7e6bf648$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== "";
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($4b18ce2d7e6bf648$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)($4b18ce2d7e6bf648$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
                children: label
            }) : $4b18ce2d7e6bf648$var$_span || ($4b18ce2d7e6bf648$var$_span = /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("5MLDO", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $436663fe1cec129f$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $436663fe1cec129f$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");

var $34via = parcelRequire("34via");
function $436663fe1cec129f$export$89922944c7227687(slot) {
    return (0, $5xHgF.default)("MuiOutlinedInput", slot);
}
const $436663fe1cec129f$var$outlinedInputClasses = {
    ...(0, $34via.default),
    ...(0, $eFHYA.default)("MuiOutlinedInput", [
        "root",
        "notchedOutline",
        "input"
    ])
};
var $436663fe1cec129f$export$2e2bcd8739ae039 = $436663fe1cec129f$var$outlinedInputClasses;

});



parcelRegister("4wnpT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34ac50a2cd0b6797$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $383VY = parcelRequire("383VY");


var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $a2T3z = parcelRequire("a2T3z");

var $2TqGF = parcelRequire("2TqGF");

var $2FiVa = parcelRequire("2FiVa");

var $cHWQJ = parcelRequire("cHWQJ");

var $1jYbn = parcelRequire("1jYbn");

var $jXddm = parcelRequire("jXddm");

var $e43jk = parcelRequire("e43jk");

var $frP6i = parcelRequire("frP6i");

var $eAnru = parcelRequire("eAnru");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $34ac50a2cd0b6797$var$variantComponent = {
    standard: (0, $a2T3z.default),
    filled: (0, $2TqGF.default),
    outlined: (0, $2FiVa.default)
};
const $34ac50a2cd0b6797$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $frP6i.getTextFieldUtilityClass), classes);
};
const $34ac50a2cd0b6797$var$TextFieldRoot = (0, $dTuzq.default)((0, $1jYbn.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $34ac50a2cd0b6797$var$TextField = /*#__PURE__*/ $dgG1Y.forwardRef(function TextField(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = "outlined", ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $34ac50a2cd0b6797$var$useUtilityClasses(ownerState);
    const id = (0, $383VY.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $34ac50a2cd0b6797$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === "outlined") {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== "undefined") inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps["aria-describedby"] = undefined;
    }
    const [InputSlot, inputProps] = (0, $eAnru.default)("input", {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $eAnru.default)("inputLabel", {
        elementType: (0, $cHWQJ.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $eAnru.default)("htmlInput", {
        elementType: "input",
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $eAnru.default)("formHelperText", {
        elementType: (0, $jXddm.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $eAnru.default)("select", {
        elementType: (0, $e43jk.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $fR5Jw.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($34ac50a2cd0b6797$var$TextFieldRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState,
        ...other,
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $fR5Jw.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $fR5Jw.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $fR5Jw.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $34ac50a2cd0b6797$export$2e2bcd8739ae039 = $34ac50a2cd0b6797$var$TextField;

});
parcelRegister("jXddm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e86dc71d48309c1a$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $57Zgm = parcelRequire("57Zgm");

var $5cF86 = parcelRequire("5cF86");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $9TQfG = parcelRequire("9TQfG");

var $4WQFN = parcelRequire("4WQFN");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $e86dc71d48309c1a$var$_span;
const $e86dc71d48309c1a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $9TQfG.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $4WQFN.getFormHelperTextUtilityClasses), classes);
};
const $e86dc71d48309c1a$var$FormHelperTextRoot = (0, $dTuzq.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $9TQfG.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $4WQFN.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $4WQFN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $e86dc71d48309c1a$var$FormHelperText = /*#__PURE__*/ $dgG1Y.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p", disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $5cF86.default)();
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $e86dc71d48309c1a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($e86dc71d48309c1a$var$FormHelperTextRoot, {
        as: component,
        className: (0, $8MGTi.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === " " ? $e86dc71d48309c1a$var$_span || ($e86dc71d48309c1a$var$_span = /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $e86dc71d48309c1a$export$2e2bcd8739ae039 = $e86dc71d48309c1a$var$FormHelperText;

});
parcelRegister("4WQFN", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $39a570017656c4da$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $39a570017656c4da$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $39a570017656c4da$export$a394fa61b1d583a9(slot) {
    return (0, $5xHgF.default)("MuiFormHelperText", slot);
}
const $39a570017656c4da$var$formHelperTextClasses = (0, $eFHYA.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $39a570017656c4da$export$2e2bcd8739ae039 = $39a570017656c4da$var$formHelperTextClasses;

});


parcelRegister("frP6i", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $b3f10421d37a8775$export$c1bdcbaf0596aeda; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $b3f10421d37a8775$export$c1bdcbaf0596aeda(slot) {
    return (0, $5xHgF.default)("MuiTextField", slot);
}
const $b3f10421d37a8775$var$textFieldClasses = (0, $eFHYA.default)("MuiTextField", [
    "root"
]);
var $b3f10421d37a8775$export$2e2bcd8739ae039 = $b3f10421d37a8775$var$textFieldClasses;

});


parcelRegister("jUw8I", function(module, exports) {

$parcel$export(module.exports, "useForm", function () { return $2b60a2a31b769596$export$87c0cf8eb5a167e0; });

var $dgG1Y = parcelRequire("dgG1Y");
const $2b60a2a31b769596$export$87c0cf8eb5a167e0 = (schema)=>{
    const [formState, setFormState] = (0, $dgG1Y.useState)({
        isValid: false,
        values: {},
        touched: {},
        errors: {}
    });
    (0, $dgG1Y.useEffect)(()=>{
        const errors = {};
        let hasErrors = false;
        if (!schema) return;
        Object.entries(schema).forEach(([field, rules])=>{
            if (rules) {
                const fieldErrors = [];
                rules.forEach((rule)=>{
                    const error = rule(formState.values[field], formState.values);
                    if (error) fieldErrors.push(...error);
                });
                if (fieldErrors.length > 0) {
                    errors[field] = fieldErrors;
                    hasErrors = true;
                }
            }
        });
        setFormState((formState)=>({
                ...formState,
                isValid: !hasErrors,
                errors: errors || {}
            }));
    }, [
        formState.values,
        schema
    ]);
    const clearFormState = ()=>{
        setFormState({
            isValid: false,
            values: {},
            touched: {},
            errors: {}
        });
    };
    const handleChange = (event)=>{
        if (event.persist) event.persist();
        setFormState((formState)=>({
                ...formState,
                values: {
                    ...formState.values,
                    [event.target.name]: event.target.type === "checkbox" ? event.target.checked : event.target.value
                },
                touched: {
                    ...formState.touched,
                    [event.target.name]: true
                }
            }));
    };
    const hasError = (field)=>!!(formState.touched[field] && formState.errors[field]);
    return {
        hasError: hasError,
        handleChange: handleChange,
        formState: formState,
        clearFormState: clearFormState
    };
};

});

parcelRegister("6GvYA", function(module, exports) {

$parcel$export(module.exports, "useGetMembers", function () { return $02209e4849843a6d$export$f5dce56aee59a0a0; });

var $dgG1Y = parcelRequire("dgG1Y");
const $02209e4849843a6d$export$f5dce56aee59a0a0 = (sendRequest, auth, showOnlyNumbers = false)=>{
    const [members, setMembers] = (0, $dgG1Y.useState)();
    (0, $dgG1Y.useEffect)(()=>{
        const getUsers = async ()=>{
            try {
                const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/accountable/users`, "GET", null, {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (!showOnlyNumbers) setMembers(responseData.sort((a, b)=>a.lastName.toLowerCase() > b.lastName.toLowerCase() ? 1 : -1));
                else setMembers(responseData.filter((user)=>user.phoneNumber).sort((a, b)=>a.lastName.toLowerCase() > b.lastName.toLowerCase() ? 1 : -1));
            } catch (err) {
                console.error("Error fetching members:", err);
            }
        };
        getUsers();
    }, [
        sendRequest,
        auth.token,
        showOnlyNumbers
    ]);
    return {
        members: members
    };
};

});

parcelRegister("4C1tJ", function(module, exports) {

var $35bbdba9a7802529$var$moment = module.exports = (parcelRequire("jxwKV"));

$35bbdba9a7802529$var$moment.tz.load((parcelRequire("duiJv")));

});
parcelRegister("jxwKV", function(module, exports) {

//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory((parcelRequire("7h4Wt"))); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})(module.exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.45", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

});
parcelRegister("7h4Wt", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});


parcelRegister("duiJv", function(module, exports) {
module.exports = JSON.parse('{"version":"2024a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}');

});


parcelRegister("htjEL", function(module, exports) {

$parcel$export(module.exports, "checked", function () { return $16852bddaace5809$export$b96bb35bc88d6fa; });
$parcel$export(module.exports, "required", function () { return $16852bddaace5809$export$a7a0278c004aac3f; });
$parcel$export(module.exports, "email", function () { return $16852bddaace5809$export$d290fa47940df19d; });
$parcel$export(module.exports, "maxLength", function () { return $16852bddaace5809$export$c9f461152c658a8b; });
$parcel$export(module.exports, "minLength", function () { return $16852bddaace5809$export$8fe860a115a1e636; });
$parcel$export(module.exports, "equality", function () { return $16852bddaace5809$export$2aea80e752d0055b; });
const $16852bddaace5809$export$b96bb35bc88d6fa = (value)=>{
    if (value !== true) return [
        "Must be checked"
    ];
    return undefined;
};
const $16852bddaace5809$export$a7a0278c004aac3f = (value)=>{
    if (!value && value !== 0) return [
        "This field is required"
    ];
    return undefined;
};
const $16852bddaace5809$export$d290fa47940df19d = (value)=>{
    if (!value) return undefined;
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (!emailRegex.test(value)) return [
        "Invalid email address"
    ];
    return undefined;
};
const $16852bddaace5809$export$c9f461152c658a8b = (max)=>(value)=>{
        if (!value) return undefined;
        if (value.length > max) return [
            `Must be less than ${max} characters`
        ];
        return undefined;
    };
const $16852bddaace5809$export$8fe860a115a1e636 = (min)=>(value)=>{
        if (!value) return undefined;
        if (value.length < min) return [
            `Must be at least ${min} characters`
        ];
        return undefined;
    };
const $16852bddaace5809$export$2aea80e752d0055b = (compareField)=>(value, allValues)=>{
        if (!value) return undefined;
        if (value !== allValues[compareField]) return [
            `Must match ${compareField}`
        ];
        return undefined;
    };
var $16852bddaace5809$export$2e2bcd8739ae039 = {
    checked: $16852bddaace5809$export$b96bb35bc88d6fa,
    required: $16852bddaace5809$export$a7a0278c004aac3f,
    email: $16852bddaace5809$export$d290fa47940df19d,
    maxLength: $16852bddaace5809$export$c9f461152c658a8b,
    equality: $16852bddaace5809$export$2aea80e752d0055b
};

});


parcelRegister("hgbGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c90cfed84012758f$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");



var $3cVbD = parcelRequire("3cVbD");

var $dR51C = parcelRequire("dR51C");

var $9cYhW = parcelRequire("9cYhW");

var $cWJc2 = parcelRequire("cWJc2");

var $ekoiq = parcelRequire("ekoiq");

var $7p6xb = parcelRequire("7p6xb");

var $lqAG1 = parcelRequire("lqAG1");

var $7xfqK = parcelRequire("7xfqK");
var $c90cfed84012758f$var$variantComponent = {
    standard: (0, $3cVbD.default),
    filled: (0, $dR51C.default),
    outlined: (0, $9cYhW.default)
};
var $c90cfed84012758f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $c90cfed84012758f$var$TextField = /*#__PURE__*/ $dgG1Y.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, label, displayRequired && "\xa0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $c90cfed84012758f$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $dgG1Y.createElement(InputComponent, (0, $bh1oa.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $dgG1Y.createElement((0, $ekoiq.default), (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $dgG1Y.createElement((0, $cWJc2.default), (0, $bh1oa.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $dgG1Y.createElement((0, $lqAG1.default), (0, $bh1oa.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $dgG1Y.createElement((0, $7p6xb.default), (0, $bh1oa.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $c90cfed84012758f$export$2e2bcd8739ae039 = (0, $7xfqK.default)($c90cfed84012758f$export$9dd6ff9ea0189349, {
    name: "MuiTextField"
})($c90cfed84012758f$var$TextField);

});
parcelRegister("3cVbD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255eda311808c472$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $i2LhC = parcelRequire("i2LhC");

var $7xfqK = parcelRequire("7xfqK");
var $255eda311808c472$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative"
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            "label + &": {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:not($disabled):before": {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $255eda311808c472$var$Input = /*#__PURE__*/ $dgG1Y.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $gZz4Z.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $i2LhC.default), (0, $bh1oa.default)({
        classes: (0, $bh1oa.default)({}, classes, {
            root: (0, $cXVHi.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$255eda311808c472$var$Input.muiName = "Input";
var $255eda311808c472$export$2e2bcd8739ae039 = (0, $7xfqK.default)($255eda311808c472$export$9dd6ff9ea0189349, {
    name: "MuiInput"
})($255eda311808c472$var$Input);

});
parcelRegister("i2LhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d22d1756f3d4a97f$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $gNnan = parcelRequire("gNnan");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $ajabD = parcelRequire("ajabD");

var $49T3m = parcelRequire("49T3m");

var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");

var $arbQ3 = parcelRequire("arbQ3");

var $ch08i = parcelRequire("ch08i");

var $XAtht = parcelRequire("XAtht");
var $d22d1756f3d4a97f$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        "@global": {
            "@keyframes mui-auto-fill": {},
            "@keyframes mui-auto-fill-cancel": {}
        },
        /* Styles applied to the root element. */ root: (0, $bh1oa.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: "1.1876em",
            // Reset (19px), match the native input line-height
            boxSizing: "border-box",
            // Prevent padding issue with fullWidth.
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": {
                color: theme.palette.text.disabled,
                cursor: "default"
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the `input` element. */ input: {
            font: "inherit",
            letterSpacing: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1876em",
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: "transparent",
            display: "block",
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: "100%",
            // Fix IE 11 width issue
            animationName: "mui-auto-fill-cancel",
            animationDuration: "10ms",
            "&::-webkit-input-placeholder": placeholder,
            "&::-moz-placeholder": placeholder,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholder,
            // IE 11
            "&::-ms-input-placeholder": placeholder,
            // Edge
            "&:focus": {
                outline: 0
            },
            // Reset Firefox invalid required input style
            "&:invalid": {
                boxShadow: "none"
            },
            "&::-webkit-search-decoration": {
                // Remove the padding when type=search.
                "-webkit-appearance": "none"
            },
            // Show and hide the placeholder logic
            "label[data-shrink=false] + $formControl &": {
                "&::-webkit-input-placeholder": placeholderHidden,
                "&::-moz-placeholder": placeholderHidden,
                // Firefox 19+
                "&:-ms-input-placeholder": placeholderHidden,
                // IE 11
                "&::-ms-input-placeholder": placeholderHidden,
                // Edge
                "&:focus::-webkit-input-placeholder": placeholderVisible,
                "&:focus::-moz-placeholder": placeholderVisible,
                // Firefox 19+
                "&:focus:-ms-input-placeholder": placeholderVisible,
                // IE 11
                "&:focus::-ms-input-placeholder": placeholderVisible // Edge
            },
            "&$disabled": {
                opacity: 1 // Reset iOS opacity
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: "auto",
            resize: "none",
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield"
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $d22d1756f3d4a97f$var$useEnhancedEffect = typeof window === "undefined" ? $dgG1Y.useEffect : $dgG1Y.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $d22d1756f3d4a97f$var$InputBase = /*#__PURE__*/ $dgG1Y.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0, $gZz4Z.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $dgG1Y.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $dgG1Y.useRef();
    var handleInputRefWarning = $dgG1Y.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $arbQ3.default)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $arbQ3.default)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $arbQ3.default)(inputRef, handleInputRefProp);
    var _React$useState = $dgG1Y.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $49T3m.useFormControl)();
    var fcs = (0, $ajabD.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $dgG1Y.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $dgG1Y.useCallback(function(obj) {
        if ((0, $XAtht.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $d22d1756f3d4a97f$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $gNnan.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $dgG1Y.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $bh1oa.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== "string") inputProps = (0, $bh1oa.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = "textarea";
        else {
            inputProps = (0, $bh1oa.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $ch08i.default);
        }
    } else inputProps = (0, $bh1oa.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $dgG1Y.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes["color".concat((0, $bdWPY.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $dgG1Y.createElement((0, $49T3m.default).Provider, {
        value: null
    }, /*#__PURE__*/ $dgG1Y.createElement(InputComponent, (0, $bh1oa.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $cXVHi.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $bh1oa.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $d22d1756f3d4a97f$export$2e2bcd8739ae039 = (0, $7xfqK.default)($d22d1756f3d4a97f$export$9dd6ff9ea0189349, {
    name: "MuiInputBase"
})($d22d1756f3d4a97f$var$InputBase);

});
parcelRegister("ajabD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781394956373f58c$export$2e2bcd8739ae039; });
function $781394956373f58c$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("49T3m", function(module, exports) {

$parcel$export(module.exports, "useFormControl", function () { return $3072b51794bcfaa3$export$62ecd8ad1bbe1a18; });
$parcel$export(module.exports, "default", function () { return $3072b51794bcfaa3$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ var $3072b51794bcfaa3$var$FormControlContext = $dgG1Y.createContext();
function $3072b51794bcfaa3$export$62ecd8ad1bbe1a18() {
    return $dgG1Y.useContext($3072b51794bcfaa3$var$FormControlContext);
}
var $3072b51794bcfaa3$export$2e2bcd8739ae039 = $3072b51794bcfaa3$var$FormControlContext;

});

parcelRegister("ch08i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ef72cef3b9437d9$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $47HpE = parcelRequire("47HpE");

var $arbQ3 = parcelRequire("arbQ3");

function $8ef72cef3b9437d9$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $8ef72cef3b9437d9$var$useEnhancedEffect = typeof window !== "undefined" ? $dgG1Y.useLayoutEffect : $dgG1Y.useEffect;
var $8ef72cef3b9437d9$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
var $8ef72cef3b9437d9$var$TextareaAutosize = /*#__PURE__*/ $dgG1Y.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $gZz4Z.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $dgG1Y.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $dgG1Y.useRef(null);
    var handleRef = (0, $arbQ3.default)(ref, inputRef);
    var shadowRef = $dgG1Y.useRef(null);
    var renders = $dgG1Y.useRef(0);
    var _React$useState = $dgG1Y.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $dgG1Y.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle["box-sizing"];
        var padding = $8ef72cef3b9437d9$var$getStyleValue(computedStyle, "padding-bottom") + $8ef72cef3b9437d9$var$getStyleValue(computedStyle, "padding-top");
        var border = $8ef72cef3b9437d9$var$getStyleValue(computedStyle, "border-bottom-width") + $8ef72cef3b9437d9$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $dgG1Y.useEffect(function() {
        var handleResize = (0, $47HpE.default)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        syncHeight
    ]);
    $8ef72cef3b9437d9$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $dgG1Y.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement("textarea", (0, $bh1oa.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $bh1oa.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? "hidden" : null
        }, style)
    }, other)), /*#__PURE__*/ $dgG1Y.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $bh1oa.default)({}, $8ef72cef3b9437d9$var$styles.shadow, style)
    }));
});
var $8ef72cef3b9437d9$export$2e2bcd8739ae039 = $8ef72cef3b9437d9$var$TextareaAutosize;

});
parcelRegister("47HpE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30097db9665d6dc7$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $30097db9665d6dc7$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("XAtht", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $0b31cd3cd704c80a$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $0b31cd3cd704c80a$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $0b31cd3cd704c80a$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $0b31cd3cd704c80a$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($0b31cd3cd704c80a$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $0b31cd3cd704c80a$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $0b31cd3cd704c80a$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});



parcelRegister("dR51C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1641f76d10b9bae$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $i2LhC = parcelRequire("i2LhC");

var $7xfqK = parcelRequire("7xfqK");
var $a1641f76d10b9bae$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            "&:hover": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: backgroundColor
                }
            },
            "&$focused": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
            },
            "&$disabled": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:before": {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $a1641f76d10b9bae$var$FilledInput = /*#__PURE__*/ $dgG1Y.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $gZz4Z.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $i2LhC.default), (0, $bh1oa.default)({
        classes: (0, $bh1oa.default)({}, classes, {
            root: (0, $cXVHi.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$a1641f76d10b9bae$var$FilledInput.muiName = "Input";
var $a1641f76d10b9bae$export$2e2bcd8739ae039 = (0, $7xfqK.default)($a1641f76d10b9bae$export$9dd6ff9ea0189349, {
    name: "MuiFilledInput"
})($a1641f76d10b9bae$var$FilledInput);

});

parcelRegister("9cYhW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b44001458547149$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $i2LhC = parcelRequire("i2LhC");

var $968UI = parcelRequire("968UI");

var $7xfqK = parcelRequire("7xfqK");
var $6b44001458547149$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            "&:hover $notchedOutline": {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                "&:hover $notchedOutline": {
                    borderColor: borderColor
                }
            },
            "&$focused $notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            "&$error $notchedOutline": {
                borderColor: theme.palette.error.main
            },
            "&$disabled $notchedOutline": {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused $notchedOutline": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "18.5px 14px",
            "&$marginDense": {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "18.5px 14px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $6b44001458547149$var$OutlinedInput = /*#__PURE__*/ $dgG1Y.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $gZz4Z.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $i2LhC.default), (0, $bh1oa.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $dgG1Y.createElement((0, $968UI.default), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $bh1oa.default)({}, classes, {
            root: (0, $cXVHi.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$6b44001458547149$var$OutlinedInput.muiName = "Input";
var $6b44001458547149$export$2e2bcd8739ae039 = (0, $7xfqK.default)($6b44001458547149$export$9dd6ff9ea0189349, {
    name: "MuiOutlinedInput"
})($6b44001458547149$var$OutlinedInput);

});
parcelRegister("968UI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69fb96b163d0e8b2$export$2e2bcd8739ae039; });

var $bey4Q = parcelRequire("bey4Q");

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $fbIlN = parcelRequire("fbIlN");

var $bdWPY = parcelRequire("bdWPY");
var $69fb96b163d0e8b2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden"
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            // sync with `height` in `legend` styles
            transition: theme.transitions.create("width", {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: theme.transitions.create("max-width", {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            "& > span": {
                paddingLeft: 5,
                paddingRight: 5,
                display: "inline-block"
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create("max-width", {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $69fb96b163d0e8b2$var$NotchedOutline = /*#__PURE__*/ $dgG1Y.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $fbIlN.default)();
    var align = theme.direction === "rtl" ? "right" : "left";
    if (label !== undefined) return /*#__PURE__*/ $dgG1Y.createElement("fieldset", (0, $bh1oa.default)({
        "aria-hidden": true,
        className: (0, $cXVHi.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $dgG1Y.createElement("legend", {
        className: (0, $cXVHi.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $dgG1Y.createElement("span", null, label) : /*#__PURE__*/ $dgG1Y.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $dgG1Y.createElement("fieldset", (0, $bh1oa.default)({
        "aria-hidden": true,
        style: (0, $bh1oa.default)((0, $bey4Q.default)({}, "padding".concat((0, $bdWPY.default)(align)), 8), style),
        className: (0, $cXVHi.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $dgG1Y.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $dgG1Y.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
});
var $69fb96b163d0e8b2$export$2e2bcd8739ae039 = (0, $7xfqK.default)($69fb96b163d0e8b2$export$9dd6ff9ea0189349, {
    name: "PrivateNotchedOutline"
})($69fb96b163d0e8b2$var$NotchedOutline);

});


parcelRegister("cWJc2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96cdf53dbd561249$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $ajabD = parcelRequire("ajabD");

var $fJyy2 = parcelRequire("fJyy2");

var $7xfqK = parcelRequire("7xfqK");

var $bol5D = parcelRequire("bol5D");
var $96cdf53dbd561249$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            transformOrigin: "top left"
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: "translate(0, 24px) scale(1)"
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: "translate(0, 21px) scale(1)"
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left"
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(12px, 17px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(12px, 10px) scale(0.75)",
                "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(14px, 12px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(14px, -6px) scale(0.75)"
            }
        }
    };
};
var $96cdf53dbd561249$var$InputLabel = /*#__PURE__*/ $dgG1Y.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $fJyy2.default)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $ajabD.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "margin",
            "variant"
        ]
    });
    return /*#__PURE__*/ $dgG1Y.createElement((0, $bol5D.default), (0, $bh1oa.default)({
        "data-shrink": shrink,
        className: (0, $cXVHi.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
            "filled": classes.filled,
            "outlined": classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $96cdf53dbd561249$export$2e2bcd8739ae039 = (0, $7xfqK.default)($96cdf53dbd561249$export$9dd6ff9ea0189349, {
    name: "MuiInputLabel"
})($96cdf53dbd561249$var$InputLabel);

});
parcelRegister("fJyy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b745db8600e62430$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $49T3m = parcelRequire("49T3m");
function $b745db8600e62430$export$2e2bcd8739ae039() {
    return $dgG1Y.useContext((0, $49T3m.default));
}

});

parcelRegister("bol5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84b24ba20250de1b$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $ajabD = parcelRequire("ajabD");

var $fJyy2 = parcelRequire("fJyy2");

var $bdWPY = parcelRequire("bdWPY");

var $7xfqK = parcelRequire("7xfqK");
var $84b24ba20250de1b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $bh1oa.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused": {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            "&$error": {
                color: theme.palette.error.main
            }
        }
    };
};
var $84b24ba20250de1b$var$FormLabel = /*#__PURE__*/ $dgG1Y.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $fJyy2.default)();
    var fcs = (0, $ajabD.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes["color".concat((0, $bdWPY.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $dgG1Y.createElement("span", {
        "aria-hidden": true,
        className: (0, $cXVHi.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", "*"));
});
var $84b24ba20250de1b$export$2e2bcd8739ae039 = (0, $7xfqK.default)($84b24ba20250de1b$export$9dd6ff9ea0189349, {
    name: "MuiFormLabel"
})($84b24ba20250de1b$var$FormLabel);

});


parcelRegister("ekoiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6e5c7a3a075262e$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $XAtht = parcelRequire("XAtht");

var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");

var $8GJwR = parcelRequire("8GJwR");

var $49T3m = parcelRequire("49T3m");
var $a6e5c7a3a075262e$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top" // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: "100%"
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $a6e5c7a3a075262e$var$FormControl = /*#__PURE__*/ $dgG1Y.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $dgG1Y.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $dgG1Y.Children.forEach(children, function(child) {
            if (!(0, $8GJwR.default)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $8GJwR.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $XAtht.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $dgG1Y.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $dgG1Y.Children.forEach(children, function(child) {
            if (!(0, $8GJwR.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $XAtht.isFilled)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $dgG1Y.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $dgG1Y.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $dgG1Y.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === "small" ? "dense" : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $dgG1Y.createElement((0, $49T3m.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, margin !== "none" && classes["margin".concat((0, $bdWPY.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $a6e5c7a3a075262e$export$2e2bcd8739ae039 = (0, $7xfqK.default)($a6e5c7a3a075262e$export$9dd6ff9ea0189349, {
    name: "MuiFormControl"
})($a6e5c7a3a075262e$var$FormControl);

});
parcelRegister("8GJwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65359010def73fb7$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
function $65359010def73fb7$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $dgG1Y.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRegister("7p6xb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563fefc36666422d$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $ajabD = parcelRequire("ajabD");

var $fJyy2 = parcelRequire("fJyy2");

var $7xfqK = parcelRequire("7xfqK");
var $563fefc36666422d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $bh1oa.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $563fefc36666422d$var$FormHelperText = /*#__PURE__*/ $dgG1Y.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $fJyy2.default)();
    var fcs = (0, $ajabD.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), children === " " ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $dgG1Y.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : children);
});
var $563fefc36666422d$export$2e2bcd8739ae039 = (0, $7xfqK.default)($563fefc36666422d$export$9dd6ff9ea0189349, {
    name: "MuiFormHelperText"
})($563fefc36666422d$var$FormHelperText);

});

parcelRegister("lqAG1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f99879efd4b81e7f$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $l1BQr = parcelRequire("l1BQr");

var $fwiwO = parcelRequire("fwiwO");

var $ajabD = parcelRequire("ajabD");

var $fJyy2 = parcelRequire("fJyy2");

var $7xfqK = parcelRequire("7xfqK");

var $c4LVg = parcelRequire("c4LVg");

var $3cVbD = parcelRequire("3cVbD");

var $k9xEQ = parcelRequire("k9xEQ");

var $etWrI = parcelRequire("etWrI");

var $dR51C = parcelRequire("dR51C");

var $9cYhW = parcelRequire("9cYhW");
var $f99879efd4b81e7f$export$9dd6ff9ea0189349 = (0, $k9xEQ.styles);
var $f99879efd4b81e7f$var$_ref = /*#__PURE__*/ $dgG1Y.createElement((0, $3cVbD.default), null);
var $f99879efd4b81e7f$var$_ref2 = /*#__PURE__*/ $dgG1Y.createElement((0, $dR51C.default), null);
var $f99879efd4b81e7f$var$Select = /*#__PURE__*/ $dgG1Y.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $c4LVg.default) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $etWrI.default) : (0, $fwiwO.default);
    var muiFormControl = (0, $fJyy2.default)();
    var fcs = (0, $ajabD.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $f99879efd4b81e7f$var$_ref,
        outlined: /*#__PURE__*/ $dgG1Y.createElement((0, $9cYhW.default), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $f99879efd4b81e7f$var$_ref2
    })[variant];
    return /*#__PURE__*/ $dgG1Y.cloneElement(InputComponent, (0, $bh1oa.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $bh1oa.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $bh1oa.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $l1BQr.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$f99879efd4b81e7f$var$Select.muiName = "Select";
var $f99879efd4b81e7f$export$2e2bcd8739ae039 = (0, $7xfqK.default)($f99879efd4b81e7f$export$9dd6ff9ea0189349, {
    name: "MuiSelect"
})($f99879efd4b81e7f$var$Select);

});
parcelRegister("fwiwO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4c8377b5f835201$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $ckFPG = parcelRequire("ckFPG");

var $gZz4Z = parcelRequire("gZz4Z");

var $5FKop = parcelRequire("5FKop");

var $gNnan = parcelRequire("gNnan");

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("O2eT5");


var $cXVHi = parcelRequire("cXVHi");

var $2q8lO = parcelRequire("2q8lO");

var $bdWPY = parcelRequire("bdWPY");

var $caSAq = parcelRequire("caSAq");

var $XAtht = parcelRequire("XAtht");

var $arbQ3 = parcelRequire("arbQ3");

var $ikQKD = parcelRequire("ikQKD");
function $b4c8377b5f835201$var$areEqualValues(a, b) {
    if ((0, $5FKop.default)(b) === "object" && b !== null) return a === b;
    return String(a) === String(b);
}
function $b4c8377b5f835201$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $b4c8377b5f835201$var$SelectInput = /*#__PURE__*/ $dgG1Y.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $ikQKD.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    }), _useControlled2 = (0, $ckFPG.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $dgG1Y.useRef(null);
    var _React$useState = $dgG1Y.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $dgG1Y.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $dgG1Y.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $dgG1Y.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $arbQ3.default)(ref, inputRefProp);
    $dgG1Y.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $dgG1Y.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $dgG1Y.useEffect(function() {
        if (displayNode) {
            var label = (0, $2q8lO.default)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener("click", handler);
                return function() {
                    label.removeEventListener("click", handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $dgG1Y.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, "target", {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $XAtht.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $gNnan.default)(2));
            selected = value.some(function(v) {
                return $b4c8377b5f835201$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $b4c8377b5f835201$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $dgG1Y.cloneElement(child, {
            "aria-selected": selected ? "true" : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(", ") : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-expanded": open ? "true" : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(" ") || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $b4c8377b5f835201$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $dgG1Y.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : display), /*#__PURE__*/ $dgG1Y.createElement("input", (0, $bh1oa.default)({
        value: Array.isArray(value) ? value.join(",") : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $dgG1Y.createElement(IconComponent, {
        className: (0, $cXVHi.default)(classes.icon, classes["icon".concat((0, $bdWPY.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $dgG1Y.createElement((0, $caSAq.default), (0, $bh1oa.default)({
        id: "menu-".concat(name || ""),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $bh1oa.default)({
            "aria-labelledby": labelId,
            role: "listbox",
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $bh1oa.default)({}, MenuProps.PaperProps, {
            style: (0, $bh1oa.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $b4c8377b5f835201$export$2e2bcd8739ae039 = $b4c8377b5f835201$var$SelectInput;

});
parcelRegister("O2eT5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hy9lW"));

});
parcelRegister("hy9lW", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $cc6cddee020c8fd7$export$a7c73072b1a182ae; }, function (v) { return $cc6cddee020c8fd7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cc6cddee020c8fd7$export$9f27bc3417b4524d; }, function (v) { return $cc6cddee020c8fd7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cc6cddee020c8fd7$export$db77ccec0bb4ccac; }, function (v) { return $cc6cddee020c8fd7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cc6cddee020c8fd7$export$8392c0c9d3dcbd35; }, function (v) { return $cc6cddee020c8fd7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cc6cddee020c8fd7$export$ffb0004e005737fa; }, function (v) { return $cc6cddee020c8fd7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cc6cddee020c8fd7$export$b624eff549462981; }, function (v) { return $cc6cddee020c8fd7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cc6cddee020c8fd7$export$7897aa7841a5380c; }, function (v) { return $cc6cddee020c8fd7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cc6cddee020c8fd7$export$602eac185826482c; }, function (v) { return $cc6cddee020c8fd7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cc6cddee020c8fd7$export$e2c29f18771995cb; }, function (v) { return $cc6cddee020c8fd7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cc6cddee020c8fd7$export$5f8d39834fd61797; }, function (v) { return $cc6cddee020c8fd7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cc6cddee020c8fd7$export$74bf444e3cd11ea5; }, function (v) { return $cc6cddee020c8fd7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cc6cddee020c8fd7$export$92387174baf9b227; }, function (v) { return $cc6cddee020c8fd7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cc6cddee020c8fd7$export$ec112efeb987d9c6; }, function (v) { return $cc6cddee020c8fd7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cc6cddee020c8fd7$export$b706b080d889d2c9; }, function (v) { return $cc6cddee020c8fd7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cc6cddee020c8fd7$export$5be5a87408f70ddc; }, function (v) { return $cc6cddee020c8fd7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cc6cddee020c8fd7$export$45a5e7f76e0caa8d; }, function (v) { return $cc6cddee020c8fd7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cc6cddee020c8fd7$export$455c2e768291efa6; }, function (v) { return $cc6cddee020c8fd7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cc6cddee020c8fd7$export$9522e17588c12572; }, function (v) { return $cc6cddee020c8fd7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cc6cddee020c8fd7$export$2110ac352bb060b9; }, function (v) { return $cc6cddee020c8fd7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cc6cddee020c8fd7$export$56885ab8b9c456ab; }, function (v) { return $cc6cddee020c8fd7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cc6cddee020c8fd7$export$d927fcb6adf8f9de; }, function (v) { return $cc6cddee020c8fd7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cc6cddee020c8fd7$export$b82d16f27459e05a; }, function (v) { return $cc6cddee020c8fd7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cc6cddee020c8fd7$export$522c17b4f5e123e8; }, function (v) { return $cc6cddee020c8fd7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cc6cddee020c8fd7$export$1aabd8a0274ecfd6; }, function (v) { return $cc6cddee020c8fd7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cc6cddee020c8fd7$export$9b621391a187a31a; }, function (v) { return $cc6cddee020c8fd7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cc6cddee020c8fd7$export$f5bbd400c2f4426f; }, function (v) { return $cc6cddee020c8fd7$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc6cddee020c8fd7$export$a7c73072b1a182ae;
var $cc6cddee020c8fd7$export$9f27bc3417b4524d;
var $cc6cddee020c8fd7$export$db77ccec0bb4ccac;
var $cc6cddee020c8fd7$export$8392c0c9d3dcbd35;
var $cc6cddee020c8fd7$export$ffb0004e005737fa;
var $cc6cddee020c8fd7$export$b624eff549462981;
var $cc6cddee020c8fd7$export$7897aa7841a5380c;
var $cc6cddee020c8fd7$export$602eac185826482c;
var $cc6cddee020c8fd7$export$e2c29f18771995cb;
var $cc6cddee020c8fd7$export$5f8d39834fd61797;
var $cc6cddee020c8fd7$export$74bf444e3cd11ea5;
var $cc6cddee020c8fd7$export$92387174baf9b227;
var $cc6cddee020c8fd7$export$ec112efeb987d9c6;
var $cc6cddee020c8fd7$export$b706b080d889d2c9;
var $cc6cddee020c8fd7$export$5be5a87408f70ddc;
var $cc6cddee020c8fd7$export$45a5e7f76e0caa8d;
var $cc6cddee020c8fd7$export$455c2e768291efa6;
var $cc6cddee020c8fd7$export$9522e17588c12572;
var $cc6cddee020c8fd7$export$2110ac352bb060b9;
var $cc6cddee020c8fd7$export$56885ab8b9c456ab;
var $cc6cddee020c8fd7$export$d927fcb6adf8f9de;
var $cc6cddee020c8fd7$export$b82d16f27459e05a;
var $cc6cddee020c8fd7$export$522c17b4f5e123e8;
var $cc6cddee020c8fd7$export$1aabd8a0274ecfd6;
var $cc6cddee020c8fd7$export$9b621391a187a31a;
var $cc6cddee020c8fd7$export$f5bbd400c2f4426f;
"use strict";
var $cc6cddee020c8fd7$var$b = 60103, $cc6cddee020c8fd7$var$c = 60106, $cc6cddee020c8fd7$var$d = 60107, $cc6cddee020c8fd7$var$e = 60108, $cc6cddee020c8fd7$var$f = 60114, $cc6cddee020c8fd7$var$g = 60109, $cc6cddee020c8fd7$var$h = 60110, $cc6cddee020c8fd7$var$k = 60112, $cc6cddee020c8fd7$var$l = 60113, $cc6cddee020c8fd7$var$m = 60120, $cc6cddee020c8fd7$var$n = 60115, $cc6cddee020c8fd7$var$p = 60116, $cc6cddee020c8fd7$var$q = 60121, $cc6cddee020c8fd7$var$r = 60122, $cc6cddee020c8fd7$var$u = 60117, $cc6cddee020c8fd7$var$v = 60129, $cc6cddee020c8fd7$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $cc6cddee020c8fd7$var$x = Symbol.for;
    $cc6cddee020c8fd7$var$b = $cc6cddee020c8fd7$var$x("react.element");
    $cc6cddee020c8fd7$var$c = $cc6cddee020c8fd7$var$x("react.portal");
    $cc6cddee020c8fd7$var$d = $cc6cddee020c8fd7$var$x("react.fragment");
    $cc6cddee020c8fd7$var$e = $cc6cddee020c8fd7$var$x("react.strict_mode");
    $cc6cddee020c8fd7$var$f = $cc6cddee020c8fd7$var$x("react.profiler");
    $cc6cddee020c8fd7$var$g = $cc6cddee020c8fd7$var$x("react.provider");
    $cc6cddee020c8fd7$var$h = $cc6cddee020c8fd7$var$x("react.context");
    $cc6cddee020c8fd7$var$k = $cc6cddee020c8fd7$var$x("react.forward_ref");
    $cc6cddee020c8fd7$var$l = $cc6cddee020c8fd7$var$x("react.suspense");
    $cc6cddee020c8fd7$var$m = $cc6cddee020c8fd7$var$x("react.suspense_list");
    $cc6cddee020c8fd7$var$n = $cc6cddee020c8fd7$var$x("react.memo");
    $cc6cddee020c8fd7$var$p = $cc6cddee020c8fd7$var$x("react.lazy");
    $cc6cddee020c8fd7$var$q = $cc6cddee020c8fd7$var$x("react.block");
    $cc6cddee020c8fd7$var$r = $cc6cddee020c8fd7$var$x("react.server.block");
    $cc6cddee020c8fd7$var$u = $cc6cddee020c8fd7$var$x("react.fundamental");
    $cc6cddee020c8fd7$var$v = $cc6cddee020c8fd7$var$x("react.debug_trace_mode");
    $cc6cddee020c8fd7$var$w = $cc6cddee020c8fd7$var$x("react.legacy_hidden");
}
function $cc6cddee020c8fd7$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $cc6cddee020c8fd7$var$b:
                switch(a = a.type, a){
                    case $cc6cddee020c8fd7$var$d:
                    case $cc6cddee020c8fd7$var$f:
                    case $cc6cddee020c8fd7$var$e:
                    case $cc6cddee020c8fd7$var$l:
                    case $cc6cddee020c8fd7$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cc6cddee020c8fd7$var$h:
                            case $cc6cddee020c8fd7$var$k:
                            case $cc6cddee020c8fd7$var$p:
                            case $cc6cddee020c8fd7$var$n:
                            case $cc6cddee020c8fd7$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $cc6cddee020c8fd7$var$c:
                return t;
        }
    }
}
var $cc6cddee020c8fd7$var$z = $cc6cddee020c8fd7$var$g, $cc6cddee020c8fd7$var$A = $cc6cddee020c8fd7$var$b, $cc6cddee020c8fd7$var$B = $cc6cddee020c8fd7$var$k, $cc6cddee020c8fd7$var$C = $cc6cddee020c8fd7$var$d, $cc6cddee020c8fd7$var$D = $cc6cddee020c8fd7$var$p, $cc6cddee020c8fd7$var$E = $cc6cddee020c8fd7$var$n, $cc6cddee020c8fd7$var$F = $cc6cddee020c8fd7$var$c, $cc6cddee020c8fd7$var$G = $cc6cddee020c8fd7$var$f, $cc6cddee020c8fd7$var$H = $cc6cddee020c8fd7$var$e, $cc6cddee020c8fd7$var$I = $cc6cddee020c8fd7$var$l;
$cc6cddee020c8fd7$export$a7c73072b1a182ae = $cc6cddee020c8fd7$var$h;
$cc6cddee020c8fd7$export$9f27bc3417b4524d = $cc6cddee020c8fd7$var$z;
$cc6cddee020c8fd7$export$db77ccec0bb4ccac = $cc6cddee020c8fd7$var$A;
$cc6cddee020c8fd7$export$8392c0c9d3dcbd35 = $cc6cddee020c8fd7$var$B;
$cc6cddee020c8fd7$export$ffb0004e005737fa = $cc6cddee020c8fd7$var$C;
$cc6cddee020c8fd7$export$b624eff549462981 = $cc6cddee020c8fd7$var$D;
$cc6cddee020c8fd7$export$7897aa7841a5380c = $cc6cddee020c8fd7$var$E;
$cc6cddee020c8fd7$export$602eac185826482c = $cc6cddee020c8fd7$var$F;
$cc6cddee020c8fd7$export$e2c29f18771995cb = $cc6cddee020c8fd7$var$G;
$cc6cddee020c8fd7$export$5f8d39834fd61797 = $cc6cddee020c8fd7$var$H;
$cc6cddee020c8fd7$export$74bf444e3cd11ea5 = $cc6cddee020c8fd7$var$I;
$cc6cddee020c8fd7$export$92387174baf9b227 = function() {
    return !1;
};
$cc6cddee020c8fd7$export$ec112efeb987d9c6 = function() {
    return !1;
};
$cc6cddee020c8fd7$export$b706b080d889d2c9 = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$h;
};
$cc6cddee020c8fd7$export$5be5a87408f70ddc = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$g;
};
$cc6cddee020c8fd7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cc6cddee020c8fd7$var$b;
};
$cc6cddee020c8fd7$export$455c2e768291efa6 = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$k;
};
$cc6cddee020c8fd7$export$9522e17588c12572 = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$d;
};
$cc6cddee020c8fd7$export$2110ac352bb060b9 = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$p;
};
$cc6cddee020c8fd7$export$56885ab8b9c456ab = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$n;
};
$cc6cddee020c8fd7$export$d927fcb6adf8f9de = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$c;
};
$cc6cddee020c8fd7$export$b82d16f27459e05a = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$f;
};
$cc6cddee020c8fd7$export$522c17b4f5e123e8 = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$e;
};
$cc6cddee020c8fd7$export$1aabd8a0274ecfd6 = function(a) {
    return $cc6cddee020c8fd7$var$y(a) === $cc6cddee020c8fd7$var$l;
};
$cc6cddee020c8fd7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cc6cddee020c8fd7$var$d || a === $cc6cddee020c8fd7$var$f || a === $cc6cddee020c8fd7$var$v || a === $cc6cddee020c8fd7$var$e || a === $cc6cddee020c8fd7$var$l || a === $cc6cddee020c8fd7$var$m || a === $cc6cddee020c8fd7$var$w || "object" === typeof a && null !== a && (a.$$typeof === $cc6cddee020c8fd7$var$p || a.$$typeof === $cc6cddee020c8fd7$var$n || a.$$typeof === $cc6cddee020c8fd7$var$g || a.$$typeof === $cc6cddee020c8fd7$var$h || a.$$typeof === $cc6cddee020c8fd7$var$k || a.$$typeof === $cc6cddee020c8fd7$var$u || a.$$typeof === $cc6cddee020c8fd7$var$q || a[0] === $cc6cddee020c8fd7$var$r) ? !0 : !1;
};
$cc6cddee020c8fd7$export$f5bbd400c2f4426f = $cc6cddee020c8fd7$var$y;

});


parcelRegister("2q8lO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c347cc1e137e479$export$2e2bcd8739ae039; });
function $1c347cc1e137e479$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("caSAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dd0c2ed1a0f164e$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("O2eT5");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $gF7Ty = parcelRequire("gF7Ty");

var $2w1qt = parcelRequire("2w1qt");

var $8idXE = parcelRequire("8idXE");

var $ajiTB = parcelRequire("ajiTB");

var $fbIlN = parcelRequire("fbIlN");

var $8dd0c2ed1a0f164e$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $8dd0c2ed1a0f164e$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $8dd0c2ed1a0f164e$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: "calc(100% - 96px)",
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: "touch"
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $8dd0c2ed1a0f164e$var$Menu = /*#__PURE__*/ $dgG1Y.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $gZz4Z.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $fbIlN.default)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $dgG1Y.useRef(null);
    var contentAnchorRef = $dgG1Y.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $dgG1Y.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $dgG1Y.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $dgG1Y.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $8idXE.findDOMNode(instance);
                (0, $ajiTB.default)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $dgG1Y.createElement((0, $gF7Ty.default), (0, $bh1oa.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $bh1oa.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === "rtl" ? $8dd0c2ed1a0f164e$var$RTL_ORIGIN : $8dd0c2ed1a0f164e$var$LTR_ORIGIN,
        transformOrigin: theme.direction === "rtl" ? $8dd0c2ed1a0f164e$var$RTL_ORIGIN : $8dd0c2ed1a0f164e$var$LTR_ORIGIN,
        PaperProps: (0, $bh1oa.default)({}, PaperProps, {
            classes: (0, $bh1oa.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $dgG1Y.createElement((0, $2w1qt.default), (0, $bh1oa.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $cXVHi.default)(classes.list, MenuListProps.className)
    }), items));
});
var $8dd0c2ed1a0f164e$export$2e2bcd8739ae039 = (0, $7xfqK.default)($8dd0c2ed1a0f164e$export$9dd6ff9ea0189349, {
    name: "MuiMenu"
})($8dd0c2ed1a0f164e$var$Menu);

});
parcelRegister("gF7Ty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c216997a322fae74$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $8idXE = parcelRequire("8idXE");


var $47HpE = parcelRequire("47HpE");

var $cXVHi = parcelRequire("cXVHi");

var $2q8lO = parcelRequire("2q8lO");

var $kyRuv = parcelRequire("kyRuv");

var $2OBNu = parcelRequire("2OBNu");


var $7xfqK = parcelRequire("7xfqK");

var $6bQBn = parcelRequire("6bQBn");

var $DdcdG = parcelRequire("DdcdG");

var $2Po3a = parcelRequire("2Po3a");
function $c216997a322fae74$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $c216997a322fae74$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $c216997a322fae74$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
} // Sum the scrollTop between two elements.
function $c216997a322fae74$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $c216997a322fae74$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $c216997a322fae74$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: "absolute",
        overflowY: "auto",
        overflowX: "hidden",
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: "calc(100% - 32px)",
        maxHeight: "calc(100% - 32px)",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $c216997a322fae74$var$Popover = /*#__PURE__*/ $dgG1Y.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $DdcdG.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $gZz4Z.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $dgG1Y.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $dgG1Y.useCallback(function(contentAnchorOffset) {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $c216997a322fae74$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $2q8lO.default)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
        return {
            top: anchorRect.top + $c216997a322fae74$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $c216997a322fae74$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $dgG1Y.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === "anchorEl") {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $c216997a322fae74$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $dgG1Y.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $c216997a322fae74$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $c216997a322fae74$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $dgG1Y.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $c216997a322fae74$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $kyRuv.default)($c216997a322fae74$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $c216997a322fae74$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $dgG1Y.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $dgG1Y.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $8idXE.findDOMNode(instance);
    }, []);
    $dgG1Y.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $dgG1Y.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $dgG1Y.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $47HpE.default)(function() {
            setPositioningStyles();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $2q8lO.default)($c216997a322fae74$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $6bQBn.default), (0, $bh1oa.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $cXVHi.default)(classes.root, className)
    }, other), /*#__PURE__*/ $dgG1Y.createElement(TransitionComponent, (0, $bh1oa.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $2OBNu.default)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $dgG1Y.createElement((0, $2Po3a.default), (0, $bh1oa.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $cXVHi.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $c216997a322fae74$export$2e2bcd8739ae039 = (0, $7xfqK.default)($c216997a322fae74$export$9dd6ff9ea0189349, {
    name: "MuiPopover"
})($c216997a322fae74$var$Popover);

});
parcelRegister("kyRuv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef8079d3fd445515$export$2e2bcd8739ae039; });

var $2q8lO = parcelRequire("2q8lO");
function $ef8079d3fd445515$export$2e2bcd8739ae039(node) {
    var doc = (0, $2q8lO.default)(node);
    return doc.defaultView || window;
}

});

parcelRegister("2OBNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20cd9207d1340bc5$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $20cd9207d1340bc5$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}

});

parcelRegister("6bQBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $481c92ceb1929a59$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");


var $2RFFw = parcelRequire("2RFFw");
var $57IP6 = parcelRequire("57IP6");



var $2q8lO = parcelRequire("2q8lO");

var $hBmNS = parcelRequire("hBmNS");

var $2OBNu = parcelRequire("2OBNu");

var $arbQ3 = parcelRequire("arbQ3");

var $i3vbM = parcelRequire("i3vbM");

var $3iAmy = parcelRequire("3iAmy");

var $fW2Da = parcelRequire("fW2Da");

var $8wlQD = parcelRequire("8wlQD");

var $iHcH0 = parcelRequire("iHcH0");
function $481c92ceb1929a59$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $8idXE.findDOMNode(container);
}
function $481c92ceb1929a59$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $481c92ceb1929a59$var$defaultManager = new (0, $fW2Da.default)();
var $481c92ceb1929a59$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $481c92ceb1929a59$var$Modal = /*#__PURE__*/ $dgG1Y.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $57IP6.default)();
    var props = (0, $2RFFw.default)({
        name: "MuiModal",
        props: (0, $bh1oa.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $iHcH0.default) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $481c92ceb1929a59$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $gZz4Z.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $dgG1Y.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $dgG1Y.useRef({});
    var mountNodeRef = $dgG1Y.useRef(null);
    var modalRef = $dgG1Y.useRef(null);
    var handleRef = (0, $arbQ3.default)(modalRef, ref);
    var hasTransition = $481c92ceb1929a59$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $2q8lO.default)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $i3vbM.default)(function() {
        var resolvedContainer = $481c92ceb1929a59$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $dgG1Y.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $i3vbM.default)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $fW2Da.ariaHidden)(modalRef.current, true);
    });
    var handleClose = $dgG1Y.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $dgG1Y.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $dgG1Y.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $481c92ceb1929a59$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $3iAmy.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $2OBNu.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $2OBNu.default)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $dgG1Y.createElement((0, $hBmNS.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $bh1oa.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $dgG1Y.createElement(BackdropComponent, (0, $bh1oa.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $dgG1Y.createElement((0, $8wlQD.default), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $dgG1Y.cloneElement(children, childProps))));
});
var $481c92ceb1929a59$export$2e2bcd8739ae039 = $481c92ceb1929a59$var$Modal;

});
parcelRegister("hBmNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd0794b0076da7a8$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");




var $ajiTB = parcelRequire("ajiTB");

var $arbQ3 = parcelRequire("arbQ3");
function $cd0794b0076da7a8$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $8idXE.findDOMNode(container);
}
var $cd0794b0076da7a8$var$useEnhancedEffect = typeof window !== "undefined" ? $dgG1Y.useLayoutEffect : $dgG1Y.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $cd0794b0076da7a8$var$Portal = /*#__PURE__*/ $dgG1Y.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $dgG1Y.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $arbQ3.default)(/*#__PURE__*/ $dgG1Y.isValidElement(children) ? children.ref : null, ref);
    $cd0794b0076da7a8$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($cd0794b0076da7a8$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $cd0794b0076da7a8$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $ajiTB.default)(ref, mountNode);
            return function() {
                (0, $ajiTB.default)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $cd0794b0076da7a8$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $dgG1Y.isValidElement(children)) return /*#__PURE__*/ $dgG1Y.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $8idXE.createPortal(children, mountNode) : mountNode;
});
var $cd0794b0076da7a8$export$2e2bcd8739ae039 = $cd0794b0076da7a8$var$Portal;

});

parcelRegister("fW2Da", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $b99e5037dadfeb7b$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "default", function () { return $b99e5037dadfeb7b$export$2e2bcd8739ae039; });

var $9Vj8z = parcelRequire("9Vj8z");

var $5ywZr = parcelRequire("5ywZr");

var $foPig = parcelRequire("foPig");

var $9z5S6 = parcelRequire("9z5S6");

var $2q8lO = parcelRequire("2q8lO");

var $kyRuv = parcelRequire("kyRuv");
function $b99e5037dadfeb7b$var$isOverflowing(container) {
    var doc = (0, $2q8lO.default)(container);
    if (doc.body === container) return (0, $kyRuv.default)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $b99e5037dadfeb7b$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $b99e5037dadfeb7b$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $b99e5037dadfeb7b$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $foPig.default)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $b99e5037dadfeb7b$export$e1bd0c6150f13d96(node, show);
    });
}
function $b99e5037dadfeb7b$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $b99e5037dadfeb7b$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($b99e5037dadfeb7b$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $9z5S6.default)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($b99e5037dadfeb7b$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $2q8lO.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($b99e5037dadfeb7b$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $b99e5037dadfeb7b$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $b99e5037dadfeb7b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $9Vj8z.default)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $5ywZr.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $b99e5037dadfeb7b$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $b99e5037dadfeb7b$var$getHiddenSiblings(container);
                $b99e5037dadfeb7b$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $b99e5037dadfeb7b$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $b99e5037dadfeb7b$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $b99e5037dadfeb7b$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $b99e5037dadfeb7b$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $b99e5037dadfeb7b$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $b99e5037dadfeb7b$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $b99e5037dadfeb7b$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();

});
parcelRegister("9Vj8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7398482d025d612a$export$2e2bcd8739ae039; });
function $7398482d025d612a$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9z5S6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6befec276609c9$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $6f6befec276609c9$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}

});


parcelRegister("8wlQD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6342427531447e38$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $dgG1Y = parcelRequire("dgG1Y");

var $8idXE = parcelRequire("8idXE");


var $2q8lO = parcelRequire("2q8lO");

var $arbQ3 = parcelRequire("arbQ3");

/**
 * Utility component that locks focus inside the component.
 */ function $6342427531447e38$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $dgG1Y.useRef();
    var sentinelStart = $dgG1Y.useRef(null);
    var sentinelEnd = $dgG1Y.useRef(null);
    var nodeToRestore = $dgG1Y.useRef();
    var rootRef = $dgG1Y.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $dgG1Y.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $8idXE.findDOMNode(instance);
    }, []);
    var handleRef = (0, $arbQ3.default)(children.ref, handleOwnRef);
    var prevOpenRef = $dgG1Y.useRef();
    $dgG1Y.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $dgG1Y.useEffect(function() {
        if (!open) return;
        var doc = (0, $2q8lO.default)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $dgG1Y.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $dgG1Y.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $6342427531447e38$export$2e2bcd8739ae039 = $6342427531447e38$var$Unstable_TrapFocus;

});

parcelRegister("iHcH0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9c616a99c65f062$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");

var $d9c616a99c65f062$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $d9c616a99c65f062$var$SimpleBackdrop = /*#__PURE__*/ $dgG1Y.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $gZz4Z.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $bh1oa.default)({}, $d9c616a99c65f062$export$9dd6ff9ea0189349.root, invisible ? $d9c616a99c65f062$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $d9c616a99c65f062$export$2e2bcd8739ae039 = $d9c616a99c65f062$var$SimpleBackdrop;

});


parcelRegister("DdcdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075de11a13d45a51$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $ckFPG = parcelRequire("ckFPG");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $dlCX6 = parcelRequire("dlCX6");

var $fbIlN = parcelRequire("fbIlN");

var $lcwuC = parcelRequire("lcwuC");

var $arbQ3 = parcelRequire("arbQ3");
function $075de11a13d45a51$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $075de11a13d45a51$var$styles = {
    entering: {
        opacity: 1,
        transform: $075de11a13d45a51$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $075de11a13d45a51$var$Grow = /*#__PURE__*/ $dgG1Y.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dlCX6.default) : _props$TransitionComp, other = (0, $gZz4Z.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $dgG1Y.useRef();
    var autoTimeout = $dgG1Y.useRef();
    var theme = (0, $fbIlN.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $dgG1Y.useRef(null);
    var foreignRef = (0, $arbQ3.default)(children.ref, ref);
    var handleRef = (0, $arbQ3.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $ckFPG.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $lcwuC.reflow)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $lcwuC.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $lcwuC.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $075de11a13d45a51$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $dgG1Y.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $dgG1Y.createElement(TransitionComponent, (0, $bh1oa.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $dgG1Y.cloneElement(children, (0, $bh1oa.default)({
            style: (0, $bh1oa.default)({
                opacity: 0,
                transform: $075de11a13d45a51$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $075de11a13d45a51$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$075de11a13d45a51$var$Grow.muiSupportAuto = true;
var $075de11a13d45a51$export$2e2bcd8739ae039 = $075de11a13d45a51$var$Grow;

});


parcelRegister("2w1qt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d4fad1e99af8103$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("O2eT5");


var $8idXE = parcelRequire("8idXE");

var $2q8lO = parcelRequire("2q8lO");

var $e2odR = parcelRequire("e2odR");

var $9z5S6 = parcelRequire("9z5S6");

var $arbQ3 = parcelRequire("arbQ3");
function $1d4fad1e99af8103$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $1d4fad1e99af8103$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $1d4fad1e99af8103$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $1d4fad1e99af8103$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$1d4fad1e99af8103$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $1d4fad1e99af8103$var$useEnhancedEffect = typeof window === "undefined" ? $dgG1Y.useEffect : $dgG1Y.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $1d4fad1e99af8103$var$MenuList = /*#__PURE__*/ $dgG1Y.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $dgG1Y.useRef(null);
    var textCriteriaRef = $dgG1Y.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $1d4fad1e99af8103$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $dgG1Y.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $9z5S6.default)(true), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $2q8lO.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $1d4fad1e99af8103$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $1d4fad1e99af8103$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $1d4fad1e99af8103$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $1d4fad1e99af8103$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $1d4fad1e99af8103$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $1d4fad1e99af8103$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $1d4fad1e99af8103$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $1d4fad1e99af8103$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $1d4fad1e99af8103$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $1d4fad1e99af8103$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $1d4fad1e99af8103$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $dgG1Y.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $8idXE.findDOMNode(instance);
    }, []);
    var handleRef = (0, $arbQ3.default)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $dgG1Y.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $dgG1Y.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $dgG1Y.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $dgG1Y.createElement((0, $e2odR.default), (0, $bh1oa.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $1d4fad1e99af8103$export$2e2bcd8739ae039 = $1d4fad1e99af8103$var$MenuList;

});
parcelRegister("e2odR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3840aaddc682d81$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $1vdtn = parcelRequire("1vdtn");
var $a3840aaddc682d81$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $a3840aaddc682d81$var$List = /*#__PURE__*/ $dgG1Y.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $dgG1Y.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $1vdtn.default).Provider, {
        value: context
    }, /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $a3840aaddc682d81$export$2e2bcd8739ae039 = (0, $7xfqK.default)($a3840aaddc682d81$export$9dd6ff9ea0189349, {
    name: "MuiList"
})($a3840aaddc682d81$var$List);

});
parcelRegister("1vdtn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1183231f615e6211$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ var $1183231f615e6211$var$ListContext = $dgG1Y.createContext({});
var $1183231f615e6211$export$2e2bcd8739ae039 = $1183231f615e6211$var$ListContext;

});




parcelRegister("ikQKD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d593038c508baf20$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $dgG1Y = parcelRequire("dgG1Y");
function $d593038c508baf20$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
    var _React$useRef = $dgG1Y.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $dgG1Y.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $dgG1Y.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("c4LVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cab082c5341da84$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $6mYJl = parcelRequire("6mYJl");
var /**
 * @ignore - internal component.
 */ $8cab082c5341da84$export$2e2bcd8739ae039 = (0, $6mYJl.default)(/*#__PURE__*/ $dgG1Y.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("k9xEQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $eabec19f6a25c20c$export$9dd6ff9ea0189349; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $etWrI = parcelRequire("etWrI");

var $7xfqK = parcelRequire("7xfqK");

var $ajabD = parcelRequire("ajabD");

var $fJyy2 = parcelRequire("fJyy2");

var $c4LVg = parcelRequire("c4LVg");

var $3cVbD = parcelRequire("3cVbD");
var $eabec19f6a25c20c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            "-moz-appearance": "none",
            // Reset
            "-webkit-appearance": "none",
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: "none",
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: "pointer",
            "&:focus": {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            "&::-ms-expand": {
                display: "none"
            },
            "&$disabled": {
                cursor: "default"
            },
            "&[multiple]": {
                height: "auto"
            },
            "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: theme.palette.background.paper
            },
            "&&": {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: "auto",
            // Resets for multpile select with chips
            minHeight: "1.1876em",
            // Required for select\text-field height consistency
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: "absolute",
            right: 0,
            top: "calc(50% - 12px)",
            // Center vertically
            pointerEvents: "none",
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: "100%"
        }
    };
};
var $eabec19f6a25c20c$var$defaultInput = /*#__PURE__*/ $dgG1Y.createElement((0, $3cVbD.default), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $eabec19f6a25c20c$var$NativeSelect = /*#__PURE__*/ $dgG1Y.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $c4LVg.default) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $eabec19f6a25c20c$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $fJyy2.default)();
    var fcs = (0, $ajabD.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    return /*#__PURE__*/ $dgG1Y.cloneElement(input, (0, $bh1oa.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $etWrI.default),
        inputProps: (0, $bh1oa.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$eabec19f6a25c20c$var$NativeSelect.muiName = "Select";
var $eabec19f6a25c20c$export$2e2bcd8739ae039 = (0, $7xfqK.default)($eabec19f6a25c20c$export$9dd6ff9ea0189349, {
    name: "MuiNativeSelect"
})($eabec19f6a25c20c$var$NativeSelect);

});
parcelRegister("etWrI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b11c4e3f8f0df3$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $bdWPY = parcelRequire("bdWPY");
/**
 * @ignore - internal component.
 */ var $a8b11c4e3f8f0df3$var$NativeSelectInput = /*#__PURE__*/ $dgG1Y.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement("select", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $dgG1Y.createElement(IconComponent, {
        className: (0, $cXVHi.default)(classes.icon, classes["icon".concat((0, $bdWPY.default)(variant))], disabled && classes.disabled)
    }));
});
var $a8b11c4e3f8f0df3$export$2e2bcd8739ae039 = $a8b11c4e3f8f0df3$var$NativeSelectInput;

});




parcelRegister("8wOzK", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $63588b29016207fb$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "ChatList", function () { return $63588b29016207fb$export$f3b2d8a9ecf740ec; });
$parcel$export(module.exports, "MessageList", function () { return $63588b29016207fb$export$89085c7857c3f940; });
$parcel$export(module.exports, "Input", function () { return $63588b29016207fb$export$f5b8910cec6cf069; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");
var $63588b29016207fb$var$u = {
    color: void 0,
    size: void 0,
    className: void 0,
    style: void 0,
    attr: void 0
}, $63588b29016207fb$var$d = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createContext($63588b29016207fb$var$u), $63588b29016207fb$var$h = function() {
    return $63588b29016207fb$var$h = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$h.apply(this, arguments);
}, $63588b29016207fb$var$p = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
};
function $63588b29016207fb$var$v(t) {
    return t && t.map(function(t, e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement(t.tag, $63588b29016207fb$var$h({
            key: e
        }, t.attr), $63588b29016207fb$var$v(t.child));
    });
}
function $63588b29016207fb$var$f(t) {
    return function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement($63588b29016207fb$var$m, $63588b29016207fb$var$h({
            attr: $63588b29016207fb$var$h({}, t.attr)
        }, e), $63588b29016207fb$var$v(t.child));
    };
}
function $63588b29016207fb$var$m(t) {
    var e = function(e) {
        var n, o = t.attr, i = t.size, a = t.title, l = $63588b29016207fb$var$p(t, [
            "attr",
            "size",
            "title"
        ]), c = i || e.size || "1em";
        return e.className && (n = e.className), t.className && (n = (n ? n + " " : "") + t.className), (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement("svg", $63588b29016207fb$var$h({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, e.attr, o, l, {
            className: n,
            style: $63588b29016207fb$var$h($63588b29016207fb$var$h({
                color: t.color || e.color
            }, e.style), t.style),
            height: c,
            width: c,
            xmlns: "http://www.w3.org/2000/svg"
        }), a && (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement("title", null, a), t.children);
    };
    return void 0 !== $63588b29016207fb$var$d ? (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement($63588b29016207fb$var$d.Consumer, null, function(t) {
        return e(t);
    }) : e($63588b29016207fb$var$u);
}
function $63588b29016207fb$var$g(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 448 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$y(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 320 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$b(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 192 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$w(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 448 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$O(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 640 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$_(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 576 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$x(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 384 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(t);
}
var $63588b29016207fb$var$C, $63588b29016207fb$var$k = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, $63588b29016207fb$var$S = {
    exports: {}
};
$63588b29016207fb$var$C = function() {
    return (()=>{
        var t = {
            720: (t, e, n)=>{
                n.r(e), n.d(e, {
                    Scene: ()=>re,
                    Tweenable: ()=>wt,
                    interpolate: ()=>Yt,
                    processTweens: ()=>ht,
                    setBezierFunction: ()=>ie,
                    shouldScheduleUpdate: ()=>ft,
                    tween: ()=>Ot,
                    unsetBezierFunction: ()=>ae
                });
                var r = {};
                n.r(r), n.d(r, {
                    bounce: ()=>A,
                    bouncePast: ()=>I,
                    easeFrom: ()=>H,
                    easeFromTo: ()=>B,
                    easeInBack: ()=>P,
                    easeInCirc: ()=>S,
                    easeInCubic: ()=>u,
                    easeInExpo: ()=>_,
                    easeInOutBack: ()=>T,
                    easeInOutCirc: ()=>M,
                    easeInOutCubic: ()=>h,
                    easeInOutExpo: ()=>C,
                    easeInOutQuad: ()=>s,
                    easeInOutQuart: ()=>f,
                    easeInOutQuint: ()=>y,
                    easeInOutSine: ()=>O,
                    easeInQuad: ()=>l,
                    easeInQuart: ()=>p,
                    easeInQuint: ()=>m,
                    easeInSine: ()=>b,
                    easeOutBack: ()=>E,
                    easeOutBounce: ()=>j,
                    easeOutCirc: ()=>N,
                    easeOutCubic: ()=>d,
                    easeOutExpo: ()=>x,
                    easeOutQuad: ()=>c,
                    easeOutQuart: ()=>v,
                    easeOutQuint: ()=>g,
                    easeOutSine: ()=>w,
                    easeTo: ()=>R,
                    elastic: ()=>z,
                    linear: ()=>a,
                    swingFrom: ()=>F,
                    swingFromTo: ()=>L,
                    swingTo: ()=>D
                });
                var o = {};
                n.r(o), n.d(o, {
                    afterTween: ()=>Ut,
                    beforeTween: ()=>Vt,
                    doesApply: ()=>Rt,
                    tweenCreated: ()=>Wt
                });
                /*!
	 * All equations are adapted from Thomas Fuchs'
	 * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js).
	 *
	 * Based on Easing Equations (c) 2003 [Robert
	 * Penner](http://www.robertpenner.com/), all rights reserved. This work is
	 * [subject to terms](http://www.robertpenner.com/easing_terms_of_use.html).
	 */ /*!
	 *  TERMS OF USE - EASING EQUATIONS
	 *  Open source under the BSD License.
	 *  Easing Equations (c) 2003 Robert Penner, all rights reserved.
	 */ var i, a = function(t) {
                    return t;
                }, l = function(t) {
                    return Math.pow(t, 2);
                }, c = function(t) {
                    return -(Math.pow(t - 1, 2) - 1);
                }, s = function(t) {
                    return (t /= .5) < 1 ? .5 * Math.pow(t, 2) : -0.5 * ((t -= 2) * t - 2);
                }, u = function(t) {
                    return Math.pow(t, 3);
                }, d = function(t) {
                    return Math.pow(t - 1, 3) + 1;
                }, h = function(t) {
                    return (t /= .5) < 1 ? .5 * Math.pow(t, 3) : .5 * (Math.pow(t - 2, 3) + 2);
                }, p = function(t) {
                    return Math.pow(t, 4);
                }, v = function(t) {
                    return -(Math.pow(t - 1, 4) - 1);
                }, f = function(t) {
                    return (t /= .5) < 1 ? .5 * Math.pow(t, 4) : -0.5 * ((t -= 2) * Math.pow(t, 3) - 2);
                }, m = function(t) {
                    return Math.pow(t, 5);
                }, g = function(t) {
                    return Math.pow(t - 1, 5) + 1;
                }, y = function(t) {
                    return (t /= .5) < 1 ? .5 * Math.pow(t, 5) : .5 * (Math.pow(t - 2, 5) + 2);
                }, b = function(t) {
                    return 1 - Math.cos(t * (Math.PI / 2));
                }, w = function(t) {
                    return Math.sin(t * (Math.PI / 2));
                }, O = function(t) {
                    return -0.5 * (Math.cos(Math.PI * t) - 1);
                }, _ = function(t) {
                    return 0 === t ? 0 : Math.pow(2, 10 * (t - 1));
                }, x = function(t) {
                    return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
                }, C = function(t) {
                    return 0 === t ? 0 : 1 === t ? 1 : (t /= .5) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * --t));
                }, S = function(t) {
                    return -(Math.sqrt(1 - t * t) - 1);
                }, N = function(t) {
                    return Math.sqrt(1 - Math.pow(t - 1, 2));
                }, M = function(t) {
                    return (t /= .5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
                }, j = function(t) {
                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                }, P = function(t) {
                    var e = 1.70158;
                    return t * t * ((e + 1) * t - e);
                }, E = function(t) {
                    var e = 1.70158;
                    return (t -= 1) * t * ((e + 1) * t + e) + 1;
                }, T = function(t) {
                    var e = 1.70158;
                    return (t /= .5) < 1 ? t * t * ((1 + (e *= 1.525)) * t - e) * .5 : .5 * ((t -= 2) * t * ((1 + (e *= 1.525)) * t + e) + 2);
                }, z = function(t) {
                    return -1 * Math.pow(4, -8 * t) * Math.sin((6 * t - 1) * (2 * Math.PI) / 2) + 1;
                }, L = function(t) {
                    var e = 1.70158;
                    return (t /= .5) < 1 ? t * t * ((1 + (e *= 1.525)) * t - e) * .5 : .5 * ((t -= 2) * t * ((1 + (e *= 1.525)) * t + e) + 2);
                }, F = function(t) {
                    var e = 1.70158;
                    return t * t * ((e + 1) * t - e);
                }, D = function(t) {
                    var e = 1.70158;
                    return (t -= 1) * t * ((e + 1) * t + e) + 1;
                }, A = function(t) {
                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                }, I = function(t) {
                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 2 - (7.5625 * (t -= 1.5 / 2.75) * t + .75) : t < 2.5 / 2.75 ? 2 - (7.5625 * (t -= 2.25 / 2.75) * t + .9375) : 2 - (7.5625 * (t -= 2.625 / 2.75) * t + .984375);
                }, B = function(t) {
                    return (t /= .5) < 1 ? .5 * Math.pow(t, 4) : -0.5 * ((t -= 2) * Math.pow(t, 3) - 2);
                }, H = function(t) {
                    return Math.pow(t, 4);
                }, R = function(t) {
                    return Math.pow(t, .25);
                };
                function W(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }
                function V(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                function U(t) {
                    return U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t;
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                    }, U(t);
                }
                function K(t, e) {
                    var n = Object.keys(t);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(t);
                        e && (r = r.filter(function(e) {
                            return Object.getOwnPropertyDescriptor(t, e).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function q(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = null != arguments[e] ? arguments[e] : {};
                        e % 2 ? K(Object(n), !0).forEach(function(e) {
                            Q(t, e, n[e]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function(e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                        });
                    }
                    return t;
                }
                function Q(t, e, n) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = n, t;
                }
                var $, G, Y, Z = "linear", J = "undefined" != typeof window ? window : $63588b29016207fb$var$k, X = "afterTween", tt = "afterTweenEnd", et = "beforeTween", nt = "tweenCreated", rt = "function", ot = "string", it = J.requestAnimationFrame || J.webkitRequestAnimationFrame || J.oRequestAnimationFrame || J.msRequestAnimationFrame || J.mozCancelRequestAnimationFrame && J.mozRequestAnimationFrame || setTimeout, at = function() {}, lt = null, ct = null, st = q({}, r), ut = function(t, e, n, r, o, i, a) {
                    var l, c, s, u = t < i ? 0 : (t - i) / o, d = !1;
                    for(var h in a && a.call && (d = !0, l = a(u)), e)d || (l = ((c = a[h]).call ? c : st[c])(u)), s = n[h], e[h] = s + (r[h] - s) * l;
                    return e;
                }, dt = function(t, e) {
                    var n = t._timestamp, r = t._currentState, o = t._delay;
                    if (!(e < n + o)) {
                        var i = t._duration, a = t._targetState, l = n + o + i, c = e > l ? l : e;
                        t._hasEnded = c >= l;
                        var s = i - (l - c), u = t._filters.length > 0;
                        if (t._hasEnded) return t._render(a, t._data, s), t.stop(!0);
                        u && t._applyFilter(et), c < n + o ? n = i = c = 1 : n += o, ut(c, r, t._originalState, a, i, n, t._easing), u && t._applyFilter(X), t._render(r, t._data, s);
                    }
                }, ht = function() {
                    for(var t, e = wt.now(), n = lt; n;)t = n._next, dt(n, e), n = t;
                }, pt = Date.now || function() {
                    return +new Date;
                }, vt = !1, ft = function(t) {
                    t && vt || (vt = t, t && mt());
                }, mt = function t() {
                    $ = pt(), vt && it.call(J, t, 16.666666666666668), ht();
                }, gt = function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Z, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = U(e);
                    if (st[e]) return st[e];
                    if (r === ot || r === rt) for(var o in t)n[o] = e;
                    else for(var i in t)n[i] = e[i] || Z;
                    return n;
                }, yt = function(t) {
                    t === lt ? (lt = t._next) ? lt._previous = null : ct = null : t === ct ? (ct = t._previous) ? ct._next = null : lt = null : (G = t._previous, Y = t._next, G._next = Y, Y._previous = G), t._previous = t._next = null;
                }, bt = "function" == typeof Promise ? Promise : null;
                i = Symbol.toStringTag;
                var wt = function() {
                    function t() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                        W(this, t), Q(this, i, "Promise"), this._config = {}, this._data = {}, this._delay = 0, this._filters = [], this._next = null, this._previous = null, this._timestamp = null, this._hasEnded = !1, this._resolve = null, this._reject = null, this._currentState = e || {}, this._originalState = {}, this._targetState = {}, this._start = at, this._render = at, this._promiseCtor = bt, n && this.setConfig(n);
                    }
                    var e, n, r;
                    return e = t, n = [
                        {
                            key: "_applyFilter",
                            value: function(t) {
                                for(var e = this._filters.length; e > 0; e--){
                                    var n = this._filters[e - e][t];
                                    n && n(this);
                                }
                            }
                        },
                        {
                            key: "tween",
                            value: function() {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                                return this._isPlaying && this.stop(), !e && this._config || this.setConfig(e), this._pausedAtTime = null, this._timestamp = t.now(), this._start(this.get(), this._data), this._delay && this._render(this._currentState, this._data, 0), this._resume(this._timestamp);
                            }
                        },
                        {
                            key: "setConfig",
                            value: function() {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = this._config;
                                for(var r in e)n[r] = e[r];
                                var o = n.promise, i = void 0 === o ? this._promiseCtor : o, a = n.start, l = void 0 === a ? at : a, c = n.finish, s = n.render, u = void 0 === s ? this._config.step || at : s, d = n.step, h = void 0 === d ? at : d;
                                this._data = n.data || n.attachment || this._data, this._isPlaying = !1, this._pausedAtTime = null, this._scheduleId = null, this._delay = e.delay || 0, this._start = l, this._render = u || h, this._duration = n.duration || 500, this._promiseCtor = i, c && (this._resolve = c);
                                var p = e.from, v = e.to, f = void 0 === v ? {} : v, m = this._currentState, g = this._originalState, y = this._targetState;
                                for(var b in p)m[b] = p[b];
                                var w = !1;
                                for(var O in m){
                                    var _ = m[O];
                                    w || U(_) !== ot || (w = !0), g[O] = _, y[O] = f.hasOwnProperty(O) ? f[O] : _;
                                }
                                if (this._easing = gt(this._currentState, n.easing, this._easing), this._filters.length = 0, w) {
                                    for(var x in t.filters)t.filters[x].doesApply(this) && this._filters.push(t.filters[x]);
                                    this._applyFilter(nt);
                                }
                                return this;
                            }
                        },
                        {
                            key: "then",
                            value: function(t, e) {
                                var n = this;
                                return this._promise = new this._promiseCtor(function(t, e) {
                                    n._resolve = t, n._reject = e;
                                }), this._promise.then(t, e);
                            }
                        },
                        {
                            key: "catch",
                            value: function(t) {
                                return this.then().catch(t);
                            }
                        },
                        {
                            key: "finally",
                            value: function(t) {
                                return this.then().finally(t);
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                return q({}, this._currentState);
                            }
                        },
                        {
                            key: "set",
                            value: function(t) {
                                this._currentState = t;
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                if (this._isPlaying) return this._pausedAtTime = t.now(), this._isPlaying = !1, yt(this), this;
                            }
                        },
                        {
                            key: "resume",
                            value: function() {
                                return this._resume();
                            }
                        },
                        {
                            key: "_resume",
                            value: function() {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.now();
                                return null === this._timestamp ? this.tween() : this._isPlaying ? this._promise : (this._pausedAtTime && (this._timestamp += e - this._pausedAtTime, this._pausedAtTime = null), this._isPlaying = !0, null === lt ? (lt = this, ct = this) : (this._previous = ct, ct._next = this, ct = this), this);
                            }
                        },
                        {
                            key: "seek",
                            value: function(e) {
                                e = Math.max(e, 0);
                                var n = t.now();
                                return this._timestamp + e === 0 || (this._timestamp = n - e, dt(this, n)), this;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                                if (!this._isPlaying) return this;
                                this._isPlaying = !1, yt(this);
                                var e = this._filters.length > 0;
                                return t && (e && this._applyFilter(et), ut(1, this._currentState, this._originalState, this._targetState, 1, 0, this._easing), e && (this._applyFilter(X), this._applyFilter(tt))), this._resolve && this._resolve({
                                    data: this._data,
                                    state: this._currentState,
                                    tweenable: this
                                }), this._resolve = null, this._reject = null, this;
                            }
                        },
                        {
                            key: "cancel",
                            value: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], e = this._currentState, n = this._data, r = this._isPlaying;
                                return r ? (this._reject && this._reject({
                                    data: n,
                                    state: e,
                                    tweenable: this
                                }), this._resolve = null, this._reject = null, this.stop(t)) : this;
                            }
                        },
                        {
                            key: "isPlaying",
                            value: function() {
                                return this._isPlaying;
                            }
                        },
                        {
                            key: "hasEnded",
                            value: function() {
                                return this._hasEnded;
                            }
                        },
                        {
                            key: "setScheduleFunction",
                            value: function(e) {
                                t.setScheduleFunction(e);
                            }
                        },
                        {
                            key: "data",
                            value: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                                return t && (this._data = q({}, t)), this._data;
                            }
                        },
                        {
                            key: "dispose",
                            value: function() {
                                for(var t in this)delete this[t];
                            }
                        }
                    ], n && V(e.prototype, n), r && V(e, r), t;
                }();
                function Ot() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = new wt;
                    return e.tween(t), e.tweenable = e, e;
                }
                Q(wt, "now", function() {
                    return $;
                }), Q(wt, "setScheduleFunction", function(t) {
                    return it = t;
                }), Q(wt, "filters", {}), Q(wt, "formulas", st), ft(!0);
                var _t, xt, Ct = /(\d|-|\.)/, kt = /([^\-0-9.]+)/g, St = /[0-9.-]+/g, Nt = (_t = St.source, xt = /,\s*/.source, new RegExp("rgba?\\(".concat(_t).concat(xt).concat(_t).concat(xt).concat(_t, "(").concat(xt).concat(_t, ")?\\)"), "g")), Mt = /^.*\(/, jt = /#([0-9]|[a-f]){3,6}/gi, Pt = "VAL", Et = function(t, e) {
                    return t.map(function(t, n) {
                        return "_".concat(e, "_").concat(n);
                    });
                };
                function Tt(t) {
                    return parseInt(t, 16);
                }
                var zt = function(t) {
                    var e;
                    return "rgb(".concat((e = t, 3 === (e = e.replace(/#/, "")).length && (e = (e = e.split(""))[0] + e[0] + e[1] + e[1] + e[2] + e[2]), [
                        Tt(e.substr(0, 2)),
                        Tt(e.substr(2, 2)),
                        Tt(e.substr(4, 2))
                    ]).join(","), ")");
                }, Lt = function(t, e, n) {
                    var r = e.match(t), o = e.replace(t, Pt);
                    return r && r.forEach(function(t) {
                        return o = o.replace(Pt, n(t));
                    }), o;
                }, Ft = function(t) {
                    for(var e in t){
                        var n = t[e];
                        "string" == typeof n && n.match(jt) && (t[e] = Lt(jt, n, zt));
                    }
                }, Dt = function(t) {
                    var e = t.match(St), n = e.slice(0, 3).map(Math.floor), r = t.match(Mt)[0];
                    if (3 === e.length) return "".concat(r).concat(n.join(","), ")");
                    if (4 === e.length) return "".concat(r).concat(n.join(","), ",").concat(e[3], ")");
                    throw new Error("Invalid rgbChunk: ".concat(t));
                }, At = function(t) {
                    return t.match(St);
                }, It = function(t, e) {
                    var n = {};
                    return e.forEach(function(e) {
                        n[e] = t[e], delete t[e];
                    }), n;
                }, Bt = function(t, e) {
                    return e.map(function(e) {
                        return t[e];
                    });
                }, Ht = function(t, e) {
                    return e.forEach(function(e) {
                        return t = t.replace(Pt, +e.toFixed(4));
                    }), t;
                }, Rt = function(t) {
                    for(var e in t._currentState)if ("string" == typeof t._currentState[e]) return !0;
                    return !1;
                };
                function Wt(t) {
                    var e = t._currentState;
                    [
                        e,
                        t._originalState,
                        t._targetState
                    ].forEach(Ft), t._tokenData = function(t) {
                        var e, n, r = {};
                        for(var o in t){
                            var i = t[o];
                            "string" == typeof i && (r[o] = {
                                formatString: (e = i, n = void 0, n = e.match(kt), n ? (1 === n.length || e.charAt(0).match(Ct)) && n.unshift("") : n = [
                                    "",
                                    ""
                                ], n.join(Pt)),
                                chunkNames: Et(At(i), o)
                            });
                        }
                        return r;
                    }(e);
                }
                function Vt(t) {
                    var e = t._currentState, n = t._originalState, r = t._targetState, o = t._easing, i = t._tokenData;
                    !function(t, e) {
                        var n = function(n) {
                            var r = e[n].chunkNames, o = t[n];
                            if ("string" == typeof o) {
                                var i = o.split(" "), a = i[i.length - 1];
                                r.forEach(function(e, n) {
                                    return t[e] = i[n] || a;
                                });
                            } else r.forEach(function(e) {
                                return t[e] = o;
                            });
                            delete t[n];
                        };
                        for(var r in e)n(r);
                    }(o, i), [
                        e,
                        n,
                        r
                    ].forEach(function(t) {
                        return function(t, e) {
                            var n = function(n) {
                                At(t[n]).forEach(function(r, o) {
                                    return t[e[n].chunkNames[o]] = +r;
                                }), delete t[n];
                            };
                            for(var r in e)n(r);
                        }(t, i);
                    });
                }
                function Ut(t) {
                    var e = t._currentState, n = t._originalState, r = t._targetState, o = t._easing, i = t._tokenData;
                    [
                        e,
                        n,
                        r
                    ].forEach(function(t) {
                        return function(t, e) {
                            for(var n in e){
                                var r = e[n], o = r.chunkNames, i = r.formatString, a = Ht(i, Bt(It(t, o), o));
                                t[n] = Lt(Nt, a, Dt);
                            }
                        }(t, i);
                    }), function(t, e) {
                        for(var n in e){
                            var r = e[n].chunkNames, o = t[r[0]];
                            t[n] = "string" == typeof o ? r.map(function(e) {
                                var n = t[e];
                                return delete t[e], n;
                            }).join(" ") : o;
                        }
                    }(o, i);
                }
                function Kt(t, e) {
                    var n = Object.keys(t);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(t);
                        e && (r = r.filter(function(e) {
                            return Object.getOwnPropertyDescriptor(t, e).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function qt(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = null != arguments[e] ? arguments[e] : {};
                        e % 2 ? Kt(Object(n), !0).forEach(function(e) {
                            Qt(t, e, n[e]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Kt(Object(n)).forEach(function(e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                        });
                    }
                    return t;
                }
                function Qt(t, e, n) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = n, t;
                }
                var $t = new wt, Gt = wt.filters, Yt = function(t, e, n, r) {
                    var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, i = qt({}, t), a = gt(t, r);
                    for(var l in $t._filters.length = 0, $t.set({}), $t._currentState = i, $t._originalState = t, $t._targetState = e, $t._easing = a, Gt)Gt[l].doesApply($t) && $t._filters.push(Gt[l]);
                    $t._applyFilter("tweenCreated"), $t._applyFilter("beforeTween");
                    var c = ut(n, i, t, e, 1, o, a);
                    return $t._applyFilter("afterTween"), c;
                };
                function Zt(t) {
                    return function(t) {
                        if (Array.isArray(t)) return Jt(t);
                    }(t) || function(t) {
                        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
                    }(t) || function(t, e) {
                        if (t) {
                            if ("string" == typeof t) return Jt(t, e);
                            var n = Object.prototype.toString.call(t).slice(8, -1);
                            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Jt(t, e) : void 0;
                        }
                    }(t) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function Jt(t, e) {
                    (null == e || e > t.length) && (e = t.length);
                    for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                    return r;
                }
                function Xt(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }
                function te(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                function ee(t, e) {
                    var n = e.get(t);
                    if (!n) throw new TypeError("attempted to get private field on non-instance");
                    return n.get ? n.get.call(t) : n.value;
                }
                var ne = new WeakMap, re = function() {
                    function t() {
                        Xt(this, t), ne.set(this, {
                            writable: !0,
                            value: []
                        });
                        for(var e = arguments.length, n = new Array(e), r = 0; r < e; r++)n[r] = arguments[r];
                        n.forEach(this.add.bind(this));
                    }
                    var e, n, r;
                    return e = t, n = [
                        {
                            key: "add",
                            value: function(t) {
                                return ee(this, ne).push(t), t;
                            }
                        },
                        {
                            key: "remove",
                            value: function(t) {
                                var e = ee(this, ne).indexOf(t);
                                return ~e && ee(this, ne).splice(e, 1), t;
                            }
                        },
                        {
                            key: "empty",
                            value: function() {
                                return this.tweenables.map(this.remove.bind(this));
                            }
                        },
                        {
                            key: "isPlaying",
                            value: function() {
                                return ee(this, ne).some(function(t) {
                                    return t.isPlaying();
                                });
                            }
                        },
                        {
                            key: "play",
                            value: function() {
                                return ee(this, ne).forEach(function(t) {
                                    return t.tween();
                                }), this;
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                return ee(this, ne).forEach(function(t) {
                                    return t.pause();
                                }), this;
                            }
                        },
                        {
                            key: "resume",
                            value: function() {
                                return ee(this, ne).forEach(function(t) {
                                    return t.resume();
                                }), this;
                            }
                        },
                        {
                            key: "stop",
                            value: function(t) {
                                return ee(this, ne).forEach(function(e) {
                                    return e.stop(t);
                                }), this;
                            }
                        },
                        {
                            key: "tweenables",
                            get: function() {
                                return Zt(ee(this, ne));
                            }
                        },
                        {
                            key: "promises",
                            get: function() {
                                return ee(this, ne).map(function(t) {
                                    return t.then();
                                });
                            }
                        }
                    ], te(e.prototype, n), r && te(e, r), t;
                }();
                function oe(t, e, n, r, o, i) {
                    var a, l, c = 0, s = 0, u = 0, d = 0, h = 0, p = 0, v = function(t) {
                        return ((c * t + s) * t + u) * t;
                    }, f = function(t) {
                        return (3 * c * t + 2 * s) * t + u;
                    }, m = function(t) {
                        return t >= 0 ? t : 0 - t;
                    };
                    return c = 1 - (u = 3 * e) - (s = 3 * (r - e) - u), d = 1 - (p = 3 * n) - (h = 3 * (o - n) - p), a = t, l = function(t) {
                        return 1 / (200 * t);
                    }(i), function(t) {
                        return ((d * t + h) * t + p) * t;
                    }(function(t, e) {
                        var n, r, o, i, a, l;
                        for(o = t, l = 0; l < 8; l++){
                            if (i = v(o) - t, m(i) < e) return o;
                            if (a = f(o), m(a) < 1e-6) break;
                            o -= i / a;
                        }
                        if ((o = t) < (n = 0)) return n;
                        if (o > (r = 1)) return r;
                        for(; n < r;){
                            if (i = v(o), m(i - t) < e) return o;
                            t > i ? n = o : r = o, o = .5 * (r - n) + n;
                        }
                        return o;
                    }(a, l));
                }
                var ie = function(t, e, n, r, o) {
                    var i = function(t, e, n, r) {
                        return function(o) {
                            return oe(o, t, e, n, r, 1);
                        };
                    }(e, n, r, o);
                    return i.displayName = t, i.x1 = e, i.y1 = n, i.x2 = r, i.y2 = o, wt.formulas[t] = i;
                }, ae = function(t) {
                    return delete wt.formulas[t];
                };
                wt.filters.token = o;
            }
        }, e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var o = e[r] = {
                exports: {}
            };
            return t[r](o, o.exports, n), o.exports;
        }
        return n.d = (t, e)=>{
            for(var r in e)n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
                enumerable: !0,
                get: e[r]
            });
        }, n.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), n.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n(720);
    })();
}, $63588b29016207fb$var$S.exports = $63588b29016207fb$var$C();
var $63588b29016207fb$var$N = "Webkit Moz O ms".split(" ");
function $63588b29016207fb$var$M(t, e, n) {
    for(var r = t.style, o = 0; o < $63588b29016207fb$var$N.length; ++o)r[$63588b29016207fb$var$N[o] + $63588b29016207fb$var$j(e)] = n;
    r[e] = n;
}
function $63588b29016207fb$var$j(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
}
function $63588b29016207fb$var$P(t) {
    return !function(t) {
        return "[object Array]" === Object.prototype.toString.call(t);
    }(t) && "object" === typeof t && !!t;
}
function $63588b29016207fb$var$E(t, e) {
    for(var n in t)if (t.hasOwnProperty(n)) e(t[n], n);
}
var $63588b29016207fb$var$T = {
    extend: function t(e, n, r) {
        for(var o in e = e || {}, r = r || !1, n = n || {})if (n.hasOwnProperty(o)) {
            var i = e[o], a = n[o];
            r && $63588b29016207fb$var$P(i) && $63588b29016207fb$var$P(a) ? e[o] = t(i, a, r) : e[o] = a;
        }
        return e;
    },
    render: function(t, e) {
        var n = t;
        for(var r in e)if (e.hasOwnProperty(r)) {
            var o = e[r], i = new RegExp("\\{" + r + "\\}", "g");
            n = n.replace(i, o);
        }
        return n;
    },
    setStyle: $63588b29016207fb$var$M,
    setStyles: function(t, e) {
        $63588b29016207fb$var$E(e, function(e, n) {
            null != e && ($63588b29016207fb$var$P(e) && !0 === e.prefix ? $63588b29016207fb$var$M(t, n, e.value) : t.style[n] = e);
        });
    },
    capitalize: $63588b29016207fb$var$j,
    isString: function(t) {
        return "string" == typeof t || t instanceof String;
    },
    isFunction: function(t) {
        return "function" == typeof t;
    },
    isObject: $63588b29016207fb$var$P,
    forEachObject: $63588b29016207fb$var$E,
    floatEquals: function(t, e) {
        return Math.abs(t - e) < .001;
    },
    removeChildren: function(t) {
        for(; t.firstChild;)t.removeChild(t.firstChild);
    }
}, $63588b29016207fb$var$z = $63588b29016207fb$var$S.exports, $63588b29016207fb$var$L = $63588b29016207fb$var$T, $63588b29016207fb$var$F = $63588b29016207fb$var$z.Tweenable, $63588b29016207fb$var$D = {
    easeIn: "easeInCubic",
    easeOut: "easeOutCubic",
    easeInOut: "easeInOutCubic"
}, $63588b29016207fb$var$A = function t(e, n) {
    if (!(this instanceof t)) throw new Error("Constructor was called without new keyword");
    var r;
    n = $63588b29016207fb$var$L.extend({
        delay: 0,
        duration: 800,
        easing: "linear",
        from: {},
        to: {},
        step: function() {}
    }, n), r = $63588b29016207fb$var$L.isString(e) ? document.querySelector(e) : e, this.path = r, this._opts = n, this._tweenable = null;
    var o = this.path.getTotalLength();
    this.path.style.strokeDasharray = o + " " + o, this.set(0);
};
$63588b29016207fb$var$A.prototype.value = function() {
    var t = this._getComputedDashOffset(), e = this.path.getTotalLength();
    return parseFloat((1 - t / e).toFixed(6), 10);
}, $63588b29016207fb$var$A.prototype.set = function(t) {
    this.stop(), this.path.style.strokeDashoffset = this._progressToOffset(t);
    var e = this._opts.step;
    if ($63588b29016207fb$var$L.isFunction(e)) {
        var n = this._easing(this._opts.easing);
        e(this._calculateTo(t, n), this._opts.shape || this, this._opts.attachment);
    }
}, $63588b29016207fb$var$A.prototype.stop = function() {
    this._stopTween(), this.path.style.strokeDashoffset = this._getComputedDashOffset();
}, $63588b29016207fb$var$A.prototype.animate = function(t, e, n) {
    e = e || {}, $63588b29016207fb$var$L.isFunction(e) && (n = e, e = {});
    var r = $63588b29016207fb$var$L.extend({}, e), o = $63588b29016207fb$var$L.extend({}, this._opts);
    e = $63588b29016207fb$var$L.extend(o, e);
    var i = this._easing(e.easing), a = this._resolveFromAndTo(t, i, r);
    this.stop(), this.path.getBoundingClientRect();
    var l = this._getComputedDashOffset(), c = this._progressToOffset(t), s = this;
    this._tweenable = new $63588b29016207fb$var$F, this._tweenable.tween({
        from: $63588b29016207fb$var$L.extend({
            offset: l
        }, a.from),
        to: $63588b29016207fb$var$L.extend({
            offset: c
        }, a.to),
        duration: e.duration,
        delay: e.delay,
        easing: i,
        step: function(t) {
            s.path.style.strokeDashoffset = t.offset;
            var n = e.shape || s;
            e.step(t, n, e.attachment);
        }
    }).then(function(t) {
        $63588b29016207fb$var$L.isFunction(n) && n();
    });
}, $63588b29016207fb$var$A.prototype._getComputedDashOffset = function() {
    var t = window.getComputedStyle(this.path, null);
    return parseFloat(t.getPropertyValue("stroke-dashoffset"), 10);
}, $63588b29016207fb$var$A.prototype._progressToOffset = function(t) {
    var e = this.path.getTotalLength();
    return e - t * e;
}, $63588b29016207fb$var$A.prototype._resolveFromAndTo = function(t, e, n) {
    return n.from && n.to ? {
        from: n.from,
        to: n.to
    } : {
        from: this._calculateFrom(e),
        to: this._calculateTo(t, e)
    };
}, $63588b29016207fb$var$A.prototype._calculateFrom = function(t) {
    return $63588b29016207fb$var$z.interpolate(this._opts.from, this._opts.to, this.value(), t);
}, $63588b29016207fb$var$A.prototype._calculateTo = function(t, e) {
    return $63588b29016207fb$var$z.interpolate(this._opts.from, this._opts.to, t, e);
}, $63588b29016207fb$var$A.prototype._stopTween = function() {
    null !== this._tweenable && (this._tweenable.stop(), this._tweenable = null);
}, $63588b29016207fb$var$A.prototype._easing = function(t) {
    return $63588b29016207fb$var$D.hasOwnProperty(t) ? $63588b29016207fb$var$D[t] : t;
};
var $63588b29016207fb$var$I = $63588b29016207fb$var$A, $63588b29016207fb$var$B = $63588b29016207fb$var$I, $63588b29016207fb$var$H = $63588b29016207fb$var$T, $63588b29016207fb$var$R = "Object is destroyed", $63588b29016207fb$var$W = function t(e, n) {
    if (!(this instanceof t)) throw new Error("Constructor was called without new keyword");
    if (0 !== arguments.length) {
        this._opts = $63588b29016207fb$var$H.extend({
            color: "#555",
            strokeWidth: 1,
            trailColor: null,
            trailWidth: null,
            fill: null,
            text: {
                style: {
                    color: null,
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    padding: 0,
                    margin: 0,
                    transform: {
                        prefix: !0,
                        value: "translate(-50%, -50%)"
                    }
                },
                autoStyleContainer: !0,
                alignToBottom: !0,
                value: null,
                className: "progressbar-text"
            },
            svgStyle: {
                display: "block",
                width: "100%"
            },
            warnings: !1
        }, n, !0), $63588b29016207fb$var$H.isObject(n) && void 0 !== n.svgStyle && (this._opts.svgStyle = n.svgStyle), $63588b29016207fb$var$H.isObject(n) && $63588b29016207fb$var$H.isObject(n.text) && void 0 !== n.text.style && (this._opts.text.style = n.text.style);
        var r, o = this._createSvgView(this._opts);
        if (!(r = $63588b29016207fb$var$H.isString(e) ? document.querySelector(e) : e)) throw new Error("Container does not exist: " + e);
        this._container = r, this._container.appendChild(o.svg), this._opts.warnings && this._warnContainerAspectRatio(this._container), this._opts.svgStyle && $63588b29016207fb$var$H.setStyles(o.svg, this._opts.svgStyle), this.svg = o.svg, this.path = o.path, this.trail = o.trail, this.text = null;
        var i = $63588b29016207fb$var$H.extend({
            attachment: void 0,
            shape: this
        }, this._opts);
        this._progressPath = new $63588b29016207fb$var$B(o.path, i), $63588b29016207fb$var$H.isObject(this._opts.text) && null !== this._opts.text.value && this.setText(this._opts.text.value);
    }
};
$63588b29016207fb$var$W.prototype.animate = function(t, e, n) {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    this._progressPath.animate(t, e, n);
}, $63588b29016207fb$var$W.prototype.stop = function() {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    void 0 !== this._progressPath && this._progressPath.stop();
}, $63588b29016207fb$var$W.prototype.pause = function() {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    void 0 !== this._progressPath && this._progressPath._tweenable && this._progressPath._tweenable.pause();
}, $63588b29016207fb$var$W.prototype.resume = function() {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    void 0 !== this._progressPath && this._progressPath._tweenable && this._progressPath._tweenable.resume();
}, $63588b29016207fb$var$W.prototype.destroy = function() {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    this.stop(), this.svg.parentNode.removeChild(this.svg), this.svg = null, this.path = null, this.trail = null, this._progressPath = null, null !== this.text && (this.text.parentNode.removeChild(this.text), this.text = null);
}, $63588b29016207fb$var$W.prototype.set = function(t) {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    this._progressPath.set(t);
}, $63588b29016207fb$var$W.prototype.value = function() {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    return void 0 === this._progressPath ? 0 : this._progressPath.value();
}, $63588b29016207fb$var$W.prototype.setText = function(t) {
    if (null === this._progressPath) throw new Error($63588b29016207fb$var$R);
    null === this.text && (this.text = this._createTextContainer(this._opts, this._container), this._container.appendChild(this.text)), $63588b29016207fb$var$H.isObject(t) ? ($63588b29016207fb$var$H.removeChildren(this.text), this.text.appendChild(t)) : this.text.innerHTML = t;
}, $63588b29016207fb$var$W.prototype._createSvgView = function(t) {
    var e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    this._initializeSvg(e, t);
    var n = null;
    (t.trailColor || t.trailWidth) && (n = this._createTrail(t), e.appendChild(n));
    var r = this._createPath(t);
    return e.appendChild(r), {
        svg: e,
        path: r,
        trail: n
    };
}, $63588b29016207fb$var$W.prototype._initializeSvg = function(t, e) {
    t.setAttribute("viewBox", "0 0 100 100");
}, $63588b29016207fb$var$W.prototype._createPath = function(t) {
    var e = this._pathString(t);
    return this._createPathElement(e, t);
}, $63588b29016207fb$var$W.prototype._createTrail = function(t) {
    var e = this._trailString(t), n = $63588b29016207fb$var$H.extend({}, t);
    return n.trailColor || (n.trailColor = "#eee"), n.trailWidth || (n.trailWidth = n.strokeWidth), n.color = n.trailColor, n.strokeWidth = n.trailWidth, n.fill = null, this._createPathElement(e, n);
}, $63588b29016207fb$var$W.prototype._createPathElement = function(t, e) {
    var n = document.createElementNS("http://www.w3.org/2000/svg", "path");
    return n.setAttribute("d", t), n.setAttribute("stroke", e.color), n.setAttribute("stroke-width", e.strokeWidth), e.fill ? n.setAttribute("fill", e.fill) : n.setAttribute("fill-opacity", "0"), n;
}, $63588b29016207fb$var$W.prototype._createTextContainer = function(t, e) {
    var n = document.createElement("div");
    n.className = t.text.className;
    var r = t.text.style;
    return r && (t.text.autoStyleContainer && (e.style.position = "relative"), $63588b29016207fb$var$H.setStyles(n, r), r.color || (n.style.color = t.color)), this._initializeTextContainer(t, e, n), n;
}, $63588b29016207fb$var$W.prototype._initializeTextContainer = function(t, e, n) {}, $63588b29016207fb$var$W.prototype._pathString = function(t) {
    throw new Error("Override this function for each progress bar");
}, $63588b29016207fb$var$W.prototype._trailString = function(t) {
    throw new Error("Override this function for each progress bar");
}, $63588b29016207fb$var$W.prototype._warnContainerAspectRatio = function(t) {
    if (this.containerAspectRatio) {
        var e = window.getComputedStyle(t, null), n = parseFloat(e.getPropertyValue("width"), 10), r = parseFloat(e.getPropertyValue("height"), 10);
        $63588b29016207fb$var$H.floatEquals(this.containerAspectRatio, n / r) || (console.warn("Incorrect aspect ratio of container", "#" + t.id, "detected:", e.getPropertyValue("width") + "(width)", "/", e.getPropertyValue("height") + "(height)", "=", n / r), console.warn("Aspect ratio of should be", this.containerAspectRatio));
    }
};
var $63588b29016207fb$var$V = $63588b29016207fb$var$W, $63588b29016207fb$var$U = $63588b29016207fb$var$V, $63588b29016207fb$var$K = $63588b29016207fb$var$T, $63588b29016207fb$var$q = function(t, e) {
    this._pathTemplate = "M 0,{center} L 100,{center}", $63588b29016207fb$var$U.apply(this, arguments);
};
($63588b29016207fb$var$q.prototype = new $63588b29016207fb$var$U).constructor = $63588b29016207fb$var$q, $63588b29016207fb$var$q.prototype._initializeSvg = function(t, e) {
    t.setAttribute("viewBox", "0 0 100 " + e.strokeWidth), t.setAttribute("preserveAspectRatio", "none");
}, $63588b29016207fb$var$q.prototype._pathString = function(t) {
    return $63588b29016207fb$var$K.render(this._pathTemplate, {
        center: t.strokeWidth / 2
    });
}, $63588b29016207fb$var$q.prototype._trailString = function(t) {
    return this._pathString(t);
};
var $63588b29016207fb$var$Q = $63588b29016207fb$var$q, $63588b29016207fb$var$$ = $63588b29016207fb$var$V, $63588b29016207fb$var$G = $63588b29016207fb$var$T, $63588b29016207fb$var$Y = function(t, e) {
    this._pathTemplate = "M 50,50 m 0,-{radius} a {radius},{radius} 0 1 1 0,{2radius} a {radius},{radius} 0 1 1 0,-{2radius}", this.containerAspectRatio = 1, $63588b29016207fb$var$$.apply(this, arguments);
};
($63588b29016207fb$var$Y.prototype = new $63588b29016207fb$var$$).constructor = $63588b29016207fb$var$Y, $63588b29016207fb$var$Y.prototype._pathString = function(t) {
    var e = t.strokeWidth;
    t.trailWidth && t.trailWidth > t.strokeWidth && (e = t.trailWidth);
    var n = 50 - e / 2;
    return $63588b29016207fb$var$G.render(this._pathTemplate, {
        radius: n,
        "2radius": 2 * n
    });
}, $63588b29016207fb$var$Y.prototype._trailString = function(t) {
    return this._pathString(t);
};
var $63588b29016207fb$var$Z = $63588b29016207fb$var$Y, $63588b29016207fb$var$J = $63588b29016207fb$var$V, $63588b29016207fb$var$X = $63588b29016207fb$var$Z, $63588b29016207fb$var$tt = $63588b29016207fb$var$T, $63588b29016207fb$var$et = function(t, e) {
    this._pathTemplate = "M 50,50 m -{radius},0 a {radius},{radius} 0 1 1 {2radius},0", this.containerAspectRatio = 2, $63588b29016207fb$var$J.apply(this, arguments);
};
($63588b29016207fb$var$et.prototype = new $63588b29016207fb$var$J).constructor = $63588b29016207fb$var$et, $63588b29016207fb$var$et.prototype._initializeSvg = function(t, e) {
    t.setAttribute("viewBox", "0 0 100 50");
}, $63588b29016207fb$var$et.prototype._initializeTextContainer = function(t, e, n) {
    t.text.style && (n.style.top = "auto", n.style.bottom = "0", t.text.alignToBottom ? $63588b29016207fb$var$tt.setStyle(n, "transform", "translate(-50%, 0)") : $63588b29016207fb$var$tt.setStyle(n, "transform", "translate(-50%, 50%)"));
}, $63588b29016207fb$var$et.prototype._pathString = $63588b29016207fb$var$X.prototype._pathString, $63588b29016207fb$var$et.prototype._trailString = $63588b29016207fb$var$X.prototype._trailString;
var $63588b29016207fb$var$nt = $63588b29016207fb$var$et, $63588b29016207fb$var$rt = $63588b29016207fb$var$V, $63588b29016207fb$var$ot = $63588b29016207fb$var$T, $63588b29016207fb$var$it = function(t, e) {
    this._pathTemplate = "M 0,{halfOfStrokeWidth} L {width},{halfOfStrokeWidth} L {width},{width} L {halfOfStrokeWidth},{width} L {halfOfStrokeWidth},{strokeWidth}", this._trailTemplate = "M {startMargin},{halfOfStrokeWidth} L {width},{halfOfStrokeWidth} L {width},{width} L {halfOfStrokeWidth},{width} L {halfOfStrokeWidth},{halfOfStrokeWidth}", $63588b29016207fb$var$rt.apply(this, arguments);
};
($63588b29016207fb$var$it.prototype = new $63588b29016207fb$var$rt).constructor = $63588b29016207fb$var$it, $63588b29016207fb$var$it.prototype._pathString = function(t) {
    var e = 100 - t.strokeWidth / 2;
    return $63588b29016207fb$var$ot.render(this._pathTemplate, {
        width: e,
        strokeWidth: t.strokeWidth,
        halfOfStrokeWidth: t.strokeWidth / 2
    });
}, $63588b29016207fb$var$it.prototype._trailString = function(t) {
    var e = 100 - t.strokeWidth / 2;
    return $63588b29016207fb$var$ot.render(this._trailTemplate, {
        width: e,
        strokeWidth: t.strokeWidth,
        halfOfStrokeWidth: t.strokeWidth / 2,
        startMargin: t.strokeWidth / 2 - t.trailWidth / 2
    });
};
var $63588b29016207fb$var$at, $63588b29016207fb$var$lt, $63588b29016207fb$var$ct = {
    Line: $63588b29016207fb$var$Q,
    Circle: $63588b29016207fb$var$Z,
    SemiCircle: $63588b29016207fb$var$nt,
    Square: $63588b29016207fb$var$it,
    Path: $63588b29016207fb$var$I,
    Shape: $63588b29016207fb$var$V,
    utils: $63588b29016207fb$var$T
}, $63588b29016207fb$export$c89a927ffc67e6fa = function(e) {
    var n = e.animate, r = e.progressOptions, l = e.className, c = (0, $dgG1Y.useMemo)(function() {
        return $63588b29016207fb$var$at = document.createElement("div"), new $63588b29016207fb$var$ct.Circle($63588b29016207fb$var$at, r);
    }, []), s = (0, $dgG1Y.useCallback)(function(t) {
        t && t.appendChild($63588b29016207fb$var$at);
    }, []);
    return (0, $dgG1Y.useEffect)(function() {
        c.animate(n);
    }, [
        n,
        c
    ]), (0, $fR5Jw.jsx)("div", {
        className: l,
        ref: s
    });
}, $63588b29016207fb$var$ut = function() {
    return $63588b29016207fb$var$ut = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$ut.apply(this, arguments);
}, $63588b29016207fb$export$931efd43a5219854 = function(n) {
    var r, o, i, a, l, c, s, u, d, h, p, v, f, m = {
        strokeWidth: 2.3,
        color: "#efe",
        trailColor: "#aaa",
        trailWidth: 1,
        step: function(t, e) {
            var n, r;
            e.path.setAttribute("trail", null === (n = null == t ? void 0 : t.state) || void 0 === n ? void 0 : n.color), e.path.setAttribute("trailwidth-width", null === (r = null == t ? void 0 : t.state) || void 0 === r ? void 0 : r.width);
            var o = Math.round(100 * e.value());
            0 === o ? e.setText("") : e.setText(o);
        }
    }, g = (null === (r = null == n ? void 0 : n.data) || void 0 === r ? void 0 : r.status) && !0 === (null === (o = null == n ? void 0 : n.data) || void 0 === o ? void 0 : o.status.error);
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ut({
        className: "rce-mbox-photo"
    }, {
        children: [
            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ut({
                className: "rce-mbox-photo--img",
                style: $63588b29016207fb$var$ut({}, (null === (i = null == n ? void 0 : n.data) || void 0 === i ? void 0 : i.width) && (null === (a = null == n ? void 0 : n.data) || void 0 === a ? void 0 : a.height) && {
                    width: n.data.width,
                    height: n.data.height
                })
            }, {
                children: [
                    (0, $fR5Jw.jsx)("img", {
                        src: null === (l = null == n ? void 0 : n.data) || void 0 === l ? void 0 : l.uri,
                        alt: null === (c = null == n ? void 0 : n.data) || void 0 === c ? void 0 : c.alt,
                        onClick: n.onOpen,
                        onLoad: n.onLoad,
                        onError: n.onPhotoError
                    }),
                    g && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ut({
                        className: "rce-mbox-photo--img__block"
                    }, {
                        children: (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$ut({
                            className: "rce-mbox-photo--img__block-item rce-mbox-photo--error"
                        }, {
                            children: (0, $fR5Jw.jsx)($63588b29016207fb$var$_, {})
                        }))
                    })),
                    !g && (null === (s = null == n ? void 0 : n.data) || void 0 === s ? void 0 : s.status) && !(null === (d = null === (u = null == n ? void 0 : n.data) || void 0 === u ? void 0 : u.status) || void 0 === d ? void 0 : d.download) && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ut({
                        className: "rce-mbox-photo--img__block"
                    }, {
                        children: [
                            !(null === (h = null == n ? void 0 : n.data) || void 0 === h ? void 0 : h.status.click) && (0, $fR5Jw.jsx)("button", $63588b29016207fb$var$ut({
                                onClick: n.onDownload,
                                className: "rce-mbox-photo--img__block-item rce-mbox-photo--download"
                            }, {
                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$O, {})
                            })),
                            "number" == typeof (null === (p = null == n ? void 0 : n.data) || void 0 === p ? void 0 : p.status.loading) && 0 !== (null === (v = null == n ? void 0 : n.data) || void 0 === v ? void 0 : v.status.loading) && (0, $fR5Jw.jsx)($63588b29016207fb$export$c89a927ffc67e6fa, {
                                animate: null === (f = null == n ? void 0 : n.data) || void 0 === f ? void 0 : f.status.loading,
                                progressOptions: m,
                                className: "rce-mbox-photo--img__block-item"
                            })
                        ]
                    }))
                ]
            })),
            (null == n ? void 0 : n.text) && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ut({
                className: "rce-mbox-text"
            }, {
                children: n.text
            }))
        ]
    }));
}, $63588b29016207fb$var$ht = function() {
    return $63588b29016207fb$var$ht = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$ht.apply(this, arguments);
}, $63588b29016207fb$export$47a7619ac01f54ff = function(n) {
    var r, o, i, a, l, c, s, u, d, h = {
        strokeWidth: 5,
        color: "#333",
        trailColor: "#aaa",
        trailWidth: 5,
        step: function(t, e) {
            e.path.setAttribute("trail", t.color), e.path.setAttribute("trailwidth-width", t.width);
            var n = Math.round(100 * e.value());
            0 === n ? e.setText("") : e.setText(n);
        }
    }, p = (null === (r = null == n ? void 0 : n.data) || void 0 === r ? void 0 : r.status) && !0 === (null === (o = null == n ? void 0 : n.data) || void 0 === o ? void 0 : o.status.error);
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ht({
        className: "rce-mbox-file"
    }, {
        children: (0, $fR5Jw.jsxs)("button", $63588b29016207fb$var$ht({
            onClick: function(t) {
                var e, r, o;
                (null === (e = null == n ? void 0 : n.data) || void 0 === e ? void 0 : e.status) && (!(null === (r = null == n ? void 0 : n.data) || void 0 === r ? void 0 : r.status.download) && n.onDownload instanceof Function ? n.onDownload(t) : (null === (o = null == n ? void 0 : n.data) || void 0 === o ? void 0 : o.status.download) && n.onOpen instanceof Function && n.onOpen(t));
            }
        }, {
            children: [
                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ht({
                    className: "rce-mbox-file--icon"
                }, {
                    children: [
                        (0, $fR5Jw.jsx)($63588b29016207fb$var$x, {
                            color: "#aaa"
                        }),
                        (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ht({
                            className: "rce-mbox-file--size"
                        }, {
                            children: null == n ? void 0 : n.data.size
                        }))
                    ]
                })),
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ht({
                    className: "rce-mbox-file--text"
                }, {
                    children: n.text
                })),
                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ht({
                    className: "rce-mbox-file--buttons"
                }, {
                    children: [
                        p && (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$ht({
                            className: "rce-error-button"
                        }, {
                            children: (0, $fR5Jw.jsx)($63588b29016207fb$var$_, {
                                color: "#ff3d3d"
                            })
                        })),
                        !p && (null === (i = null == n ? void 0 : n.data) || void 0 === i ? void 0 : i.status) && !(null === (a = null == n ? void 0 : n.data) || void 0 === a ? void 0 : a.status.download) && !(null === (l = null == n ? void 0 : n.data) || void 0 === l ? void 0 : l.status.click) && (0, $fR5Jw.jsx)($63588b29016207fb$var$O, {
                            color: "#aaa"
                        }),
                        !p && (null === (c = null == n ? void 0 : n.data) || void 0 === c ? void 0 : c.status) && "number" == typeof (null === (s = null == n ? void 0 : n.data) || void 0 === s ? void 0 : s.status.loading) && 0 !== (null === (u = null == n ? void 0 : n.data) || void 0 === u ? void 0 : u.status.loading) && (0, $fR5Jw.jsx)($63588b29016207fb$export$c89a927ffc67e6fa, {
                            animate: null === (d = null == n ? void 0 : n.data) || void 0 === d ? void 0 : d.status.loading,
                            className: "rce-mbox-file--loading",
                            progressOptions: h
                        })
                    ]
                }))
            ]
        }))
    }));
}, $63588b29016207fb$var$vt = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ $63588b29016207fb$var$lt = $63588b29016207fb$var$vt, function() {
    var t = {}.hasOwnProperty;
    function e() {
        for(var n = [], r = 0; r < arguments.length; r++){
            var o = arguments[r];
            if (o) {
                var i = typeof o;
                if ("string" === i || "number" === i) n.push(o);
                else if (Array.isArray(o)) {
                    if (o.length) {
                        var a = e.apply(null, o);
                        a && n.push(a);
                    }
                } else if ("object" === i) {
                    if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
                        n.push(o.toString());
                        continue;
                    }
                    for(var l in o)t.call(o, l) && o[l] && n.push(l);
                }
            }
        }
        return n.join(" ");
    }
    $63588b29016207fb$var$lt.exports ? (e.default = e, $63588b29016207fb$var$lt.exports = e) : window.classNames = e;
}();
var $63588b29016207fb$var$ft = $63588b29016207fb$var$vt.exports, $63588b29016207fb$var$mt = function() {
    return $63588b29016207fb$var$mt = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$mt.apply(this, arguments);
}, $63588b29016207fb$export$3f91b0466c5e5f77 = function(e) {
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$mt({
        className: $63588b29016207fb$var$ft("rce-container-smsg", e.className)
    }, {
        children: (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$mt({
            className: "rce-smsg"
        }, {
            children: (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$mt({
                className: "rce-smsg-text"
            }, {
                children: e.text
            }))
        }))
    }));
}, $63588b29016207fb$var$yt = function() {
    return $63588b29016207fb$var$yt = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$yt.apply(this, arguments);
}, $63588b29016207fb$var$bt = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$8040adcb815f3b4a = function(n) {
    var r, o = n.markerColor, i = void 0 === o ? "red" : o, a = n.target, l = void 0 === a ? "_blank" : a, c = n.zoom, s = void 0 === c ? "14" : c, u = $63588b29016207fb$var$bt(n, [
        "markerColor",
        "target",
        "zoom"
    ]), d = function(t) {
        return t.replace(/LATITUDE/g, null == u ? void 0 : u.data.latitude).replace(/LONGITUDE/g, null == u ? void 0 : u.data.longitude).replace("MARKER_COLOR", i).replace("ZOOM", s).replace("KEY", u.apiKey);
    };
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$yt({
        className: "rce-container-lmsg"
    }, {
        children: [
            (0, $fR5Jw.jsx)("a", $63588b29016207fb$var$yt({
                onClick: u.onOpen,
                target: l,
                href: u.href || u.src || d(u.data.mapURL || "https://www.google.com/maps/search/?api=1&query=LATITUDE,LONGITUDE&zoom=ZOOM"),
                className: (r = $63588b29016207fb$var$ft("rce-mbox-location", u.className), u.text && (r = $63588b29016207fb$var$ft(r, "rce-mbox-location-has-text")), r)
            }, {
                children: (0, $fR5Jw.jsx)("img", {
                    onError: u.onError,
                    className: "rce-mbox-location-img",
                    src: u.src || d(u.data.staticURL || "https://maps.googleapis.com/maps/api/staticmap?markers=color:MARKER_COLOR|LATITUDE,LONGITUDE&zoom=ZOOM&size=270x200&scale=2&key=KEY")
                })
            })),
            u.text && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$yt({
                className: "rce-mbox-text rce-mbox-location-text"
            }, {
                children: u.text
            }))
        ]
    }));
}, $63588b29016207fb$var$Ot = function() {
    return $63588b29016207fb$var$Ot = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Ot.apply(this, arguments);
}, $63588b29016207fb$var$_t = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$8795595c0e92613d = function(e) {
    var n = e.width, r = void 0 === n ? 300 : n, o = e.height, i = void 0 === o ? 380 : o, a = $63588b29016207fb$var$_t(e, [
        "width",
        "height"
    ]);
    return a.uri ? (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ot({
        className: "rce-mbox-spotify"
    }, {
        children: (0, $fR5Jw.jsx)("iframe", {
            src: "https://open.spotify.com/embed?" + function() {
                var t = [];
                for(var e in a){
                    var n = encodeURIComponent(e), r = encodeURIComponent(a[e]);
                    t.push(n + "=" + r);
                }
                return t.join("&");
            }(),
            width: r,
            height: i,
            frameBorder: "0",
            allowTransparency: !0
        })
    })) : null;
}, $63588b29016207fb$var$Ct = function() {
    return $63588b29016207fb$var$Ct = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Ct.apply(this, arguments);
}, $63588b29016207fb$var$kt = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$358065eb18c469bb = function(n) {
    var r = n.onClick, o = $63588b29016207fb$var$kt(n, [
        "onClick"
    ]);
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Ct({
        className: $63588b29016207fb$var$ft("rce-mbox-reply", {
            "rce-mbox-reply-border": !!o.titleColor
        }),
        style: $63588b29016207fb$var$Ct({}, o.titleColor && {
            borderColor: o.titleColor
        }),
        onClick: r
    }, {
        children: [
            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Ct({
                className: "rce-mbox-reply-left"
            }, {
                children: [
                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ct({
                        style: $63588b29016207fb$var$Ct({}, o.titleColor && {
                            color: o.titleColor
                        }),
                        className: "rce-mbox-reply-owner"
                    }, {
                        children: o.title || "Unknown"
                    })),
                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ct({
                        className: "rce-mbox-reply-message"
                    }, {
                        children: o.message || "..."
                    }))
                ]
            })),
            o.photoURL && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ct({
                className: "rce-mbox-reply-right"
            }, {
                children: (0, $fR5Jw.jsx)("img", {
                    src: o.photoURL,
                    alt: ""
                })
            }))
        ]
    }));
};
function $63588b29016207fb$var$Nt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
        },
        child: [
            {
                tag: "path",
                attr: {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2",
                    d: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Mt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 512 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M317.5 210.3c1.7-1.8 1.8-4.7 0-6.5l-19.8-21c-.8-.9-2-1.4-3.2-1.4-1.2 0-2.4.5-3.2 1.4l-66.5 69.1 26.4 27.1 66.3-68.7zM123.8 253.1c-.9-.9-2-1.4-3.2-1.4-1.2 0-2.3.5-3.2 1.4l-20.1 20.7c-1.8 1.8-1.8 4.8 0 6.6l63.2 65c4 4.2 9 6.6 13.2 6.6 6 0 11.1-4.5 13.1-6.4l.1-.1 13.4-13.8-76.5-78.6z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M414.7 182.4l-19.8-21c-.8-.9-2-1.4-3.2-1.4-1.2 0-2.4.5-3.2 1.4L250.7 304.1l-50.1-51.6c-.9-.9-2-1.4-3.2-1.4-1.2 0-2.3.5-3.2 1.4l-20.1 20.7c-1.8 1.8-1.8 4.8 0 6.6l63.2 65c4 4.2 9 6.6 13.2 6.6 6 0 11.1-4.5 13.1-6.4l.1-.1 151-156.1c1.7-1.7 1.7-4.6 0-6.4z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$jt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 512 512"
        },
        child: [
            {
                tag: "path",
                attr: {
                    d: "M391.553 64H57.607C53.131 64 48 67.745 48 72.159v214.217c0 4.413 5.131 8.624 9.607 8.624H115v88.894L205.128 295h186.425c4.477 0 7.447-4.211 7.447-8.624V72.159c0-4.414-2.971-8.159-7.447-8.159z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M456.396 127H424v166.57c0 15.987-6.915 26.43-25.152 26.43H218.096l-38.905 39h129.688L399 448v-89h57.396c4.478 0 7.604-4.262 7.604-8.682V136.103c0-4.414-3.126-9.103-7.604-9.103z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Pt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Et(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Tt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0V0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$zt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0021 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 003.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Lt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Ft(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Dt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$At(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$It(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Bt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Ht(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                }
            }
        ]
    })(t);
}
function $63588b29016207fb$var$Rt(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "path",
                attr: {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }
            },
            {
                tag: "path",
                attr: {
                    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(t);
}
var $63588b29016207fb$var$Wt = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "year"
];
var $63588b29016207fb$var$Vt = [
    "\u79D2",
    "\u5206\u949F",
    "\u5C0F\u65F6",
    "\u5929",
    "\u5468",
    "\u4E2A\u6708",
    "\u5E74"
];
var $63588b29016207fb$var$Ut = {}, $63588b29016207fb$var$Kt = function(t, e) {
    $63588b29016207fb$var$Ut[t] = e;
}, $63588b29016207fb$var$qt = [
    60,
    60,
    24,
    7,
    365 / 7 / 12,
    12
];
function $63588b29016207fb$var$Qt(t) {
    return t instanceof Date ? t : !isNaN(t) || /^\d+$/.test(t) ? new Date(parseInt(t)) : (t = (t || "").trim().replace(/\.\d+/, "").replace(/-/, "/").replace(/-/, "/").replace(/(\d)T(\d)/, "$1 $2").replace(/Z/, " UTC").replace(/([+-]\d\d):?(\d\d)/, " $1$2"), new Date(t));
}
var $63588b29016207fb$var$$t = function(t, e, n) {
    var r = function(t, e) {
        return (+(e ? $63588b29016207fb$var$Qt(e) : new Date) - +$63588b29016207fb$var$Qt(t)) / 1e3;
    }(t, n && n.relativeDate);
    return function(t, e) {
        for(var n = t < 0 ? 1 : 0, r = t = Math.abs(t), o = 0; t >= $63588b29016207fb$var$qt[o] && o < $63588b29016207fb$var$qt.length; o++)t /= $63588b29016207fb$var$qt[o];
        return (t = Math.floor(t)) > (0 == (o *= 2) ? 9 : 1) && (o += 1), e(t, o, r)[n].replace("%s", t.toString());
    }(r, function(t) {
        return $63588b29016207fb$var$Ut[t] || $63588b29016207fb$var$Ut.en_US;
    }(e));
};
$63588b29016207fb$var$Kt("en_US", function(t, e) {
    if (0 === e) return [
        "just now",
        "right now"
    ];
    var n = $63588b29016207fb$var$Wt[Math.floor(e / 2)];
    return t > 1 && (n += "s"), [
        t + " " + n + " ago",
        "in " + t + " " + n
    ];
}), $63588b29016207fb$var$Kt("zh_CN", function(t, e) {
    if (0 === e) return [
        "\u521A\u521A",
        "\u7247\u523B\u540E"
    ];
    var n = $63588b29016207fb$var$Vt[~~(e / 2)];
    return [
        t + " " + n + "\u524D",
        t + " " + n + "\u540E"
    ];
});
var $63588b29016207fb$var$Gt = function() {
    return $63588b29016207fb$var$Gt = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Gt.apply(this, arguments);
}, $63588b29016207fb$var$Yt = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$e2255cf6045e8d47 = function(n) {
    var r = n.type, o = void 0 === r ? "default" : r, i = n.size, l = void 0 === i ? "default" : i, c = n.lazyLoadingImage, s = void 0 === c ? void 0 : c, u = $63588b29016207fb$var$Yt(n, [
        "type",
        "size",
        "lazyLoadingImage"
    ]), d = [], h = !1, p = u.src, v = !1;
    (0, $dgG1Y.useEffect)(function() {
        s && (v = !0, f(p) ? v = !1 : (p = s, h || m(u.src)));
    }, []);
    var f = function(t) {
        return -1 !== d.indexOf(t);
    }, m = function(t) {
        h = !0;
        var e = function() {
            d.push(t), h = !1;
        }, n = document.createElement("img");
        n.src = t, n.onload = e, n.onerror = e;
    };
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Gt({
        className: $63588b29016207fb$var$ft("rce-avatar-container", o, l, u.className)
    }, {
        children: [
            u.letterItem ? (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Gt({
                className: "rce-avatar-letter-background",
                style: {
                    backgroundColor: function(t) {
                        for(var e = 0, n = 0; n < t.length; n++)e = t.charCodeAt(n) + ((e << 5) - e);
                        var r = "#";
                        for(n = 0; n < 3; n++){
                            var o = e >> 8 * n & 255;
                            r += ("00" + (o = o % 150 + 50).toString(16)).substr(-2);
                        }
                        return r;
                    }(u.letterItem.id)
                }
            }, {
                children: (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$Gt({
                    className: "rce-avatar-letter"
                }, {
                    children: u.letterItem.letter
                }))
            })) : (0, $fR5Jw.jsx)("img", {
                alt: u.alt,
                src: p,
                onError: u.onError,
                className: $63588b29016207fb$var$ft("rce-avatar", {
                    "rce-avatar-lazy": v
                })
            }),
            u.sideElement
        ]
    }));
}, $63588b29016207fb$var$Jt = function() {
    return $63588b29016207fb$var$Jt = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Jt.apply(this, arguments);
}, $63588b29016207fb$var$Xt = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$353f5b6fc5456de1 = function(n) {
    var r = n.disabled, o = void 0 !== r && r, i = n.backgroundColor, a = void 0 === i ? "#3979aa" : i, l = n.color, c = void 0 === l ? "white" : l, s = $63588b29016207fb$var$Xt(n, [
        "disabled",
        "backgroundColor",
        "color"
    ]);
    return (0, $fR5Jw.jsx)("button", $63588b29016207fb$var$Jt({
        ref: s.buttonRef,
        title: s.title,
        className: $63588b29016207fb$var$ft("rce-button", s.type, s.className),
        style: {
            backgroundColor: a,
            color: c,
            borderColor: a
        },
        disabled: o,
        onClick: s.onClick
    }, {
        children: s.icon ? (0, $fR5Jw.jsxs)("span", $63588b29016207fb$var$Jt({
            className: "rce-button-icon--container"
        }, {
            children: [
                ("right" === s.icon.float || !s.icon.float) && (0, $fR5Jw.jsx)("span", {
                    children: s.text
                }),
                (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$Jt({
                    style: {
                        float: s.icon.float,
                        fontSize: s.icon.size || 12
                    },
                    className: "rce-button-icon"
                }, {
                    children: s.icon.component
                })),
                "left" === s.icon.float && (0, $fR5Jw.jsx)("span", {
                    children: s.text
                })
            ]
        })) : (0, $fR5Jw.jsx)("span", {
            children: s.text
        })
    }));
}, $63588b29016207fb$var$ee = function() {
    return $63588b29016207fb$var$ee = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$ee.apply(this, arguments);
}, $63588b29016207fb$var$ne = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$931cbfb6bfb85fc = function(n) {
    var r, o = n.animationPosition, i = void 0 === o ? "nortwest" : o, a = n.animationType, c = void 0 === a ? "default" : a, s = $63588b29016207fb$var$ne(n, [
        "animationPosition",
        "animationType"
    ]), u = (0, $dgG1Y.useState)(void 0), d = u[0], h = u[1];
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ee({
        className: $63588b29016207fb$var$ft("rce-dropdown-container", s.className),
        onBlur: function() {
            !0 === d && h(!1);
        }
    }, {
        children: [
            (0, $fR5Jw.jsx)($63588b29016207fb$export$353f5b6fc5456de1, $63588b29016207fb$var$ee({}, s.buttonProps, {
                onClick: function() {
                    return h(!d);
                }
            })),
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ee({
                className: $63588b29016207fb$var$ft("rce-dropdown", c, "rce-dropdown-open__" + i, {
                    "dropdown-hide": !1 === d
                }, {
                    "dropdown-show": !0 === d
                })
            }, {
                children: (0, $fR5Jw.jsxs)("ul", {
                    children: [
                        s.title && (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$ee({
                            className: "rce-dropdown-title"
                        }, {
                            children: s.title
                        })),
                        null === (r = s.items) || void 0 === r ? void 0 : r.map(function(n, r) {
                            return (0, $fR5Jw.jsx)("li", $63588b29016207fb$var$ee({
                                onMouseDown: function(t) {
                                    return s.onSelect(r);
                                }
                            }, {
                                children: n instanceof Object ? n.icon ? (0, $fR5Jw.jsxs)("span", $63588b29016207fb$var$ee({
                                    className: "rce-button-icon--container"
                                }, {
                                    children: [
                                        ("right" === n.icon.float || !n.icon.float) && (0, $fR5Jw.jsx)("a", {
                                            children: n.text
                                        }),
                                        (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$ee({
                                            style: {
                                                float: n.icon.float,
                                                color: n.icon.color,
                                                fontSize: n.icon.size || 12
                                            },
                                            className: $63588b29016207fb$var$ft("rce-button-icon", n.icon.className)
                                        }, {
                                            children: n.icon.component
                                        })),
                                        "left" === n.icon.float && (0, $fR5Jw.jsx)("a", {
                                            children: n.text
                                        })
                                    ]
                                })) : (0, $fR5Jw.jsx)("a", {
                                    children: n.text
                                }) : (0, $fR5Jw.jsx)("a", {
                                    children: n
                                })
                            }), r);
                        })
                    ]
                })
            }))
        ]
    }));
}, $63588b29016207fb$var$oe = function() {
    return $63588b29016207fb$var$oe = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$oe.apply(this, arguments);
}, $63588b29016207fb$var$ie = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$adfebd04958b75e = function(n) {
    var r = n.date, o = n.dateString, i = n.title, a = n.subject, c = n.collapseTitle, s = n.moreItems, u = n.participants, d = n.dataSource, h = n.onClick, p = n.onMeetingTitleClick, v = n.onMeetingVideoLinkClick, f = n.onMeetingMoreSelect, m = $63588b29016207fb$var$ie(n, [
        "date",
        "dateString",
        "title",
        "subject",
        "collapseTitle",
        "moreItems",
        "participants",
        "dataSource",
        "onClick",
        "onMeetingTitleClick",
        "onMeetingVideoLinkClick",
        "onMeetingMoreSelect"
    ]), w = (0, $dgG1Y.useState)(!1), O = w[0], _ = w[1], x = m.participantsLimit, C = o || r && $63588b29016207fb$var$$t(r);
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
        className: "rce-mbox-mtmg"
    }, {
        children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
            className: "rce-mtmg"
        }, {
            children: [
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                    className: "rce-mtmg-subject"
                }, {
                    children: a || "Unknown Meeting"
                })),
                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                    className: "rce-mtmg-body",
                    onClick: h
                }, {
                    children: [
                        (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                            className: "rce-mtmg-item"
                        }, {
                            children: [
                                (0, $fR5Jw.jsx)($63588b29016207fb$var$g, {}),
                                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                    className: "rce-mtmg-content"
                                }, {
                                    children: [
                                        (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$oe({
                                            className: "rce-mtmg-title"
                                        }, {
                                            children: i
                                        })),
                                        (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$oe({
                                            className: "rce-mtmg-date"
                                        }, {
                                            children: C
                                        }))
                                    ]
                                }))
                            ]
                        })),
                        f && s && s.length > 0 && (0, $fR5Jw.jsx)("div", {
                            children: (0, $fR5Jw.jsx)($63588b29016207fb$export$931cbfb6bfb85fc, {
                                animationType: "bottom",
                                animationPosition: "norteast",
                                buttonProps: {
                                    className: "rce-mtmg-right-icon",
                                    icon: {
                                        component: (0, $fR5Jw.jsx)($63588b29016207fb$var$Rt, {}),
                                        size: 24
                                    }
                                },
                                items: s,
                                onSelect: f
                            })
                        })
                    ]
                })),
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                    className: "rce-mtmg-body-bottom",
                    onClick: function() {
                        _(!O);
                    }
                }, {
                    children: (0, $fR5Jw.jsxs)("div", !0 === O ? $63588b29016207fb$var$oe({
                        className: "rce-mtmg-bottom--tptitle"
                    }, {
                        children: [
                            (0, $fR5Jw.jsx)($63588b29016207fb$var$y, {}),
                            (0, $fR5Jw.jsx)("span", {
                                children: c
                            })
                        ]
                    }) : $63588b29016207fb$var$oe({
                        className: "rce-mtmg-body-bottom--bttitle"
                    }, {
                        children: [
                            (0, $fR5Jw.jsx)($63588b29016207fb$var$b, {}),
                            (0, $fR5Jw.jsxs)("span", {
                                children: [
                                    null == u ? void 0 : u.slice(0, x).map(function(t) {
                                        return t.title || "Unknow";
                                    }).join(", "),
                                    u && x && u.length > x && ", +".concat(u.length - x)
                                ]
                            })
                        ]
                    }))
                })),
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                    className: $63588b29016207fb$var$ft("rce-mtmg-toogleContent", {
                        "rce-mtmg-toogleContent--click": !0 === O
                    })
                }, {
                    children: d && d.map(function(n, r) {
                        return (0, $fR5Jw.jsxs)("div", {
                            children: [
                                !n.event && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                    className: "rce-mitem"
                                }, {
                                    children: [
                                        (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                            className: $63588b29016207fb$var$ft("rce-mitem avatar", {
                                                "rce-mitem no-avatar": !n.avatar
                                            })
                                        }, {
                                            children: n.avatar ? (0, $fR5Jw.jsx)($63588b29016207fb$export$e2255cf6045e8d47, {
                                                src: n.avatar
                                            }) : (0, $fR5Jw.jsx)($63588b29016207fb$var$jt, {})
                                        })),
                                        (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                            className: "rce-mitem-body"
                                        }, {
                                            children: [
                                                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                                    className: "rce-mitem-body--top"
                                                }, {
                                                    children: [
                                                        (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                            className: "rce-mitem-body--top-title",
                                                            onClick: function(t) {
                                                                var e, o, i;
                                                                return e = n, o = r, i = t, void (p instanceof Function && p(e, o, i));
                                                            }
                                                        }, {
                                                            children: n.title
                                                        })),
                                                        (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                            className: "rce-mitem-body--top-time"
                                                        }, {
                                                            children: n.dateString ? n.dateString : n.date && n.date && $63588b29016207fb$var$$t(n.date)
                                                        }))
                                                    ]
                                                })),
                                                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                    className: "rce-mitem-body--bottom"
                                                }, {
                                                    children: (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                        className: "rce-mitem-body--bottom-title"
                                                    }, {
                                                        children: n.message
                                                    }))
                                                }))
                                            ]
                                        }))
                                    ]
                                })),
                                n.event && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                    className: "rce-mitem-event"
                                }, {
                                    children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                        className: "rce-mitem-bottom-body"
                                    }, {
                                        children: [
                                            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                className: "rce-mitem-body avatar"
                                            }, {
                                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$Nt, {})
                                            })),
                                            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                                className: "rce-mitem-bottom-body-top"
                                            }, {
                                                children: [
                                                    n.event.title,
                                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                        className: "rce-mitem-body--top-time"
                                                    }, {
                                                        children: n.dateString ? n.dateString : n.date && $63588b29016207fb$var$$t(n.date)
                                                    })),
                                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                        className: "rce-mitem-avatar-content"
                                                    }, {
                                                        children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                                            className: "rce-mitem-avatar"
                                                        }, {
                                                            children: [
                                                                n.event.avatars && n.event.avatars.slice(0, n.event.avatarsLimit).map(function(e, n) {
                                                                    return (0, $fR5Jw.jsx)($63588b29016207fb$export$e2255cf6045e8d47, {
                                                                        src: e.src
                                                                    }, n);
                                                                }),
                                                                n.event.avatars && n.event.avatarsLimit && n.event.avatars.length > n.event.avatarsLimit && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                                    className: "rce-mitem-length rce-mitem-tooltip",
                                                                    tooltip: n.event.avatars.slice(n.event.avatarsLimit, n.event.avatars.length).map(function(t) {
                                                                        return t.title;
                                                                    }).join(",").toString()
                                                                }, {
                                                                    children: (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$oe({
                                                                        className: "rce-mitem-tooltip-text"
                                                                    }, {
                                                                        children: "+" + (n.event.avatars.length - n.event.avatarsLimit)
                                                                    }))
                                                                }))
                                                            ]
                                                        }))
                                                    })),
                                                    n.record && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                        className: "rce-mtmg-call-record"
                                                    }, {
                                                        children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                                            className: "rce-mtmg-call-body"
                                                        }, {
                                                            children: [
                                                                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                                                    onClick: function(t) {
                                                                        var e, o, i;
                                                                        return e = n, o = r, i = t, void (v instanceof Function && v(e, o, i));
                                                                    },
                                                                    className: "rce-mtmg-call-avatars"
                                                                }, {
                                                                    children: [
                                                                        (0, $fR5Jw.jsx)($63588b29016207fb$export$e2255cf6045e8d47, {
                                                                            className: "rce-mtmg-call-avatars",
                                                                            src: n.record.avatar
                                                                        }),
                                                                        (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                                            className: "rce-mtmg-record-time"
                                                                        }, {
                                                                            children: n.record.time
                                                                        }))
                                                                    ]
                                                                })),
                                                                (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$oe({
                                                                    className: "rce-mtmg-call-body-title"
                                                                }, {
                                                                    children: [
                                                                        (0, $fR5Jw.jsx)("span", {
                                                                            children: n.record.title
                                                                        }),
                                                                        (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$oe({
                                                                            className: "rce-mtmg-call-body-bottom"
                                                                        }, {
                                                                            children: n.record.savedBy
                                                                        }))
                                                                    ]
                                                                }))
                                                            ]
                                                        }))
                                                    }))
                                                ]
                                            }))
                                        ]
                                    }))
                                }))
                            ]
                        }, r);
                    })
                }))
            ]
        }))
    }));
}, $63588b29016207fb$var$le = function() {
    return $63588b29016207fb$var$le = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$le.apply(this, arguments);
}, $63588b29016207fb$export$de6b193820660101 = function(n) {
    var r, o, i, a, l, c = {
        strokeWidth: 2.3,
        color: "#efe",
        trailColor: "#aaa",
        trailWidth: 1,
        step: function(t, e) {
            var n, r;
            e.path.setAttribute("trail", void 0 !== t.state && (null === (n = null == t ? void 0 : t.state) || void 0 === n ? void 0 : n.color) || ""), e.path.setAttribute("trailwidth-width", void 0 !== t.state && (null === (r = null == t ? void 0 : t.state) || void 0 === r ? void 0 : r.width) || "");
            var o = Math.round(100 * (null == e ? void 0 : e.value()));
            0 === o ? null == e || e.setText("") : null == e || e.setText(o);
        }
    }, s = (null === (r = null == n ? void 0 : n.data) || void 0 === r ? void 0 : r.status) && !0 === (null === (o = null == n ? void 0 : n.data) || void 0 === o ? void 0 : o.status.error), u = (null === (i = null == n ? void 0 : n.data) || void 0 === i ? void 0 : i.status) && (null === (a = null == n ? void 0 : n.data) || void 0 === a ? void 0 : a.status.download);
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$le({
        className: $63588b29016207fb$var$ft("rce-mbox-video", {
            "padding-time": !(null == n ? void 0 : n.text)
        })
    }, {
        children: [
            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$le({
                className: "rce-mbox-video--video",
                style: $63588b29016207fb$var$le({}, (null == n ? void 0 : n.data.width) && (null == n ? void 0 : n.data.height) && {
                    width: n.data.width,
                    height: n.data.height
                })
            }, {
                children: [
                    !u && (0, $fR5Jw.jsx)("img", {
                        src: null == n ? void 0 : n.data.uri,
                        alt: null == n ? void 0 : n.data.alt,
                        onClick: n.onOpen,
                        onLoad: n.onLoad,
                        onError: n.onPhotoError
                    }),
                    u && (0, $fR5Jw.jsxs)("video", $63588b29016207fb$var$le({
                        controls: !0,
                        controlsList: n.controlsList
                    }, {
                        children: [
                            (0, $fR5Jw.jsx)("source", {
                                src: null == n ? void 0 : n.data.videoURL,
                                type: "video/mp4"
                            }),
                            "Your browser does not support HTML video."
                        ]
                    })),
                    s && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$le({
                        className: "rce-mbox-video--video__block"
                    }, {
                        children: (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$le({
                            className: "rce-mbox-video--video__block-item rce-mbox-video--error"
                        }, {
                            children: (0, $fR5Jw.jsx)($63588b29016207fb$var$_, {})
                        }))
                    })),
                    !s && (null === (l = null == n ? void 0 : n.data) || void 0 === l ? void 0 : l.status) && !u && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$le({
                        className: "rce-mbox-video--video__block"
                    }, {
                        children: [
                            !n.data.status.click && (0, $fR5Jw.jsx)("button", $63588b29016207fb$var$le({
                                onClick: n.onDownload,
                                className: "rce-mbox-video--video__block-item rce-mbox-video--download"
                            }, {
                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$O, {})
                            })),
                            "number" == typeof n.data.status.loading && 0 !== n.data.status.loading && (0, $fR5Jw.jsx)($63588b29016207fb$export$c89a927ffc67e6fa, {
                                animate: n.data.status.loading,
                                className: "rce-mbox-video--video__block-item",
                                progressOptions: c
                            })
                        ]
                    }))
                ]
            })),
            (null == n ? void 0 : n.text) && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$le({
                className: "rce-mbox-text"
            }, {
                children: n.text
            }))
        ]
    }));
}, $63588b29016207fb$var$se = function() {
    return $63588b29016207fb$var$se = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$se.apply(this, arguments);
}, $63588b29016207fb$export$b4e51405b5c96db = function(n) {
    var r = n.data.controlsList;
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$se({
        className: "rce-mbox-audio",
        style: n.customStyle
    }, {
        children: [
            (0, $fR5Jw.jsxs)("audio", $63588b29016207fb$var$se({}, n.audioProps, {
                controls: !0,
                controlsList: r || "nodownload"
            }, {
                children: [
                    (0, $fR5Jw.jsx)("source", {
                        src: n.data.audioURL,
                        type: n.data.audioType || "audio/mp3"
                    }),
                    "Your browser does not support the audio element."
                ]
            })),
            n.text && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$se({
                className: "rce-mbox-text"
            }, {
                children: n.text
            }))
        ]
    }));
}, $63588b29016207fb$var$de = function() {
    return $63588b29016207fb$var$de = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$de.apply(this, arguments);
}, $63588b29016207fb$export$d1de28d57ebaefd6 = function(n) {
    var r;
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$de({
        className: "rce-mtlink"
    }, {
        children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$de({
            className: "rce-mtlink-content"
        }, {
            children: [
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$de({
                    className: "rce-mtlink-item"
                }, {
                    children: (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$de({
                        className: "rce-mtlink-title"
                    }, {
                        children: n.text
                    }))
                })),
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$de({
                    className: "rce-mtlink-btn"
                }, {
                    children: null === (r = null == n ? void 0 : n.actionButtons) || void 0 === r ? void 0 : r.map(function(e) {
                        return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$de({
                            className: "rce-mtlink-btn-content",
                            onClick: function() {
                                var t;
                                return e.onClickButton(null !== (t = null == n ? void 0 : n.meetingID) && void 0 !== t ? t : "");
                            }
                        }, {
                            children: (0, $fR5Jw.jsx)(e.Component, {})
                        }));
                    })
                }))
            ]
        }))
    }));
};
function $63588b29016207fb$var$pe(t) {
    return $63588b29016207fb$var$f({
        tag: "svg",
        attr: {
            viewBox: "0 0 24 24"
        },
        child: [
            {
                tag: "g",
                attr: {},
                child: [
                    {
                        tag: "path",
                        attr: {
                            fill: "none",
                            d: "M0 0h24v24H0z"
                        }
                    },
                    {
                        tag: "path",
                        attr: {
                            d: "M13 14h-2a8.999 8.999 0 0 0-7.968 4.81A10.136 10.136 0 0 1 3 18C3 12.477 7.477 8 13 8V3l10 8-10 8v-5z"
                        }
                    }
                ]
            }
        ]
    })(t);
}
var $63588b29016207fb$var$ve = function() {
    return $63588b29016207fb$var$ve = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$ve.apply(this, arguments);
}, $63588b29016207fb$var$fe = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$52499e2c5ea4b095 = function(n) {
    var r = n.focus, o = void 0 !== r && r, i = n.notch, l = void 0 === i || i, s = n.styles, u = $63588b29016207fb$var$fe(n, [
        "focus",
        "notch",
        "styles"
    ]), d = (0, $dgG1Y.useRef)(o), h = (0, $dgG1Y.useRef)(null), p = $63588b29016207fb$var$ft("rce-mbox", {
        "rce-mbox-right": "right" === u.position
    }), v = !(/(text|video|file|meeting|audio)/g.test(u.type || "text") || "location" === u.type && u.text), f = u.date && (u.dateString || $63588b29016207fb$var$$t(u.date));
    return (0, $dgG1Y.useEffect)(function() {
        var t;
        d.current !== o && !0 === o && h && (null === (t = h.current) || void 0 === t || t.scrollIntoView({
            block: "center",
            behavior: "smooth"
        }), u.onMessageFocused(d)), d.current = o;
    }, [
        o,
        d
    ]), (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ve({
        ref: h,
        className: $63588b29016207fb$var$ft("rce-container-mbox", u.className),
        onClick: u.onClick
    }, {
        children: [
            u.renderAddCmp instanceof Function ? u.renderAddCmp() : u.renderAddCmp,
            "system" === u.type ? (0, $fR5Jw.jsx)($63588b29016207fb$export$3f91b0466c5e5f77, $63588b29016207fb$var$ve({}, u, {
                focus: o,
                notch: l
            })) : (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ve({
                style: s,
                className: $63588b29016207fb$var$ft(p, {
                    "rce-mbox--clear-padding": v
                }, {
                    "rce-mbox--clear-notch": !l
                }, {
                    "message-focus": o
                })
            }, {
                children: [
                    (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ve({
                        className: "rce-mbox-body",
                        onContextMenu: u.onContextMenu
                    }, {
                        children: [
                            !u.retracted && !0 === u.forwarded && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ve({
                                className: $63588b29016207fb$var$ft("rce-mbox-forward", {
                                    "rce-mbox-forward-right": "left" === u.position
                                }, {
                                    "rce-mbox-forward-left": "right" === u.position
                                }),
                                onClick: u.onForwardClick
                            }, {
                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$pe, {})
                            })),
                            !u.retracted && !0 === u.replyButton && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ve({
                                className: !0 !== u.forwarded ? $63588b29016207fb$var$ft("rce-mbox-forward", {
                                    "rce-mbox-forward-right": "left" === u.position
                                }, {
                                    "rce-mbox-forward-left": "right" === u.position
                                }) : $63588b29016207fb$var$ft("rce-mbox-forward", {
                                    "rce-mbox-reply-btn-right": "left" === u.position
                                }, {
                                    "rce-mbox-reply-btn-left": "right" === u.position
                                }),
                                onClick: u.onReplyClick
                            }, {
                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$Dt, {})
                            })),
                            !u.retracted && !0 === u.removeButton && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ve({
                                className: !0 === u.forwarded ? $63588b29016207fb$var$ft("rce-mbox-remove", {
                                    "rce-mbox-remove-right": "left" === u.position
                                }, {
                                    "rce-mbox-remove-left": "right" === u.position
                                }) : $63588b29016207fb$var$ft("rce-mbox-forward", {
                                    "rce-mbox-reply-btn-right": "left" === u.position
                                }, {
                                    "rce-mbox-reply-btn-left": "right" === u.position
                                }),
                                onClick: u.onRemoveMessageClick
                            }, {
                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$Pt, {})
                            })),
                            (u.title || u.avatar) && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ve({
                                style: $63588b29016207fb$var$ve({}, u.titleColor && {
                                    color: u.titleColor
                                }),
                                onClick: u.onTitleClick,
                                className: $63588b29016207fb$var$ft("rce-mbox-title", {
                                    "rce-mbox-title--clear": "text" === u.type
                                })
                            }, {
                                children: [
                                    u.avatar && (0, $fR5Jw.jsx)($63588b29016207fb$export$e2255cf6045e8d47, {
                                        letterItem: u.letterItem,
                                        src: u.avatar
                                    }),
                                    u.title && (0, $fR5Jw.jsx)("span", {
                                        children: u.title
                                    })
                                ]
                            })),
                            u.reply && (0, $fR5Jw.jsx)($63588b29016207fb$export$358065eb18c469bb, $63588b29016207fb$var$ve({
                                onClick: u.onReplyMessageClick
                            }, u.reply)),
                            "text" === u.type && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ve({
                                className: $63588b29016207fb$var$ft("rce-mbox-text", {
                                    "rce-mbox-text-retracted": u.retracted,
                                    left: "left" === u.position,
                                    right: "right" === u.position
                                })
                            }, {
                                children: [
                                    u.retracted && (0, $fR5Jw.jsx)($63588b29016207fb$var$At, {}),
                                    u.text
                                ]
                            })),
                            "location" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$8040adcb815f3b4a, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "photo" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$931efd43a5219854, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "video" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$de6b193820660101, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "file" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$47a7619ac01f54ff, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "spotify" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$8795595c0e92613d, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "meeting" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$adfebd04958b75e, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "audio" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$b4e51405b5c96db, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u)),
                            "meetingLink" === u.type && (0, $fR5Jw.jsx)($63588b29016207fb$export$d1de28d57ebaefd6, $63588b29016207fb$var$ve({
                                focus: o,
                                notch: l
                            }, u, {
                                actionButtons: null == u ? void 0 : u.actionButtons
                            })),
                            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ve({
                                title: u.statusTitle,
                                className: $63588b29016207fb$var$ft("rce-mbox-time", {
                                    "rce-mbox-time-block": v
                                }, {
                                    "non-copiable": !u.copiableDate
                                }),
                                "data-text": u.copiableDate ? void 0 : f
                            }, {
                                children: [
                                    u.copiableDate && u.date && (u.dateString || $63588b29016207fb$var$$t(u.date)),
                                    u.status && (0, $fR5Jw.jsxs)("span", $63588b29016207fb$var$ve({
                                        className: "rce-mbox-status"
                                    }, {
                                        children: [
                                            "waiting" === u.status && (0, $fR5Jw.jsx)($63588b29016207fb$var$Bt, {}),
                                            "sent" === u.status && (0, $fR5Jw.jsx)($63588b29016207fb$var$Ht, {}),
                                            "received" === u.status && (0, $fR5Jw.jsx)($63588b29016207fb$var$Mt, {}),
                                            "read" === u.status && (0, $fR5Jw.jsx)($63588b29016207fb$var$Et, {
                                                color: "#4FC3F7"
                                            })
                                        ]
                                    }))
                                ]
                            }))
                        ]
                    })),
                    l && ("right" === u.position ? (0, $fR5Jw.jsx)("svg", $63588b29016207fb$var$ve({
                        style: u.notchStyle,
                        className: $63588b29016207fb$var$ft("rce-mbox-right-notch", {
                            "message-focus": o
                        }),
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 20 20"
                    }, {
                        children: (0, $fR5Jw.jsx)("path", {
                            d: "M0 0v20L20 0"
                        })
                    })) : (0, $fR5Jw.jsx)("div", {
                        children: (0, $fR5Jw.jsxs)("svg", $63588b29016207fb$var$ve({
                            style: u.notchStyle,
                            className: $63588b29016207fb$var$ft("rce-mbox-left-notch", {
                                "message-focus": o
                            }),
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20"
                        }, {
                            children: [
                                (0, $fR5Jw.jsx)("defs", {
                                    children: (0, $fR5Jw.jsxs)("filter", $63588b29016207fb$var$ve({
                                        id: "filter1",
                                        x: "0",
                                        y: "0"
                                    }, {
                                        children: [
                                            (0, $fR5Jw.jsx)("feOffset", {
                                                result: "offOut",
                                                in: "SourceAlpha",
                                                dx: "-2",
                                                dy: "-5"
                                            }),
                                            (0, $fR5Jw.jsx)("feGaussianBlur", {
                                                result: "blurOut",
                                                in: "offOut",
                                                stdDeviation: "3"
                                            }),
                                            (0, $fR5Jw.jsx)("feBlend", {
                                                in: "SourceGraphic",
                                                in2: "blurOut",
                                                mode: "normal"
                                            })
                                        ]
                                    }))
                                }),
                                (0, $fR5Jw.jsx)("path", {
                                    d: "M20 0v20L0 0",
                                    filter: "url(#filter1)"
                                })
                            ]
                        }))
                    }))
                ]
            }))
        ]
    }));
}, $63588b29016207fb$var$ge = function() {
    return $63588b29016207fb$var$ge = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$ge.apply(this, arguments);
}, $63588b29016207fb$var$ye = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$86e6771ca9311520 = function(r) {
    var o = r.avatarFlexible, i = void 0 !== o && o, c = r.date, s = void 0 === c ? new Date : c, u = r.unread, d = void 0 === u ? 0 : u, h = r.statusColorType, p = void 0 === h ? "badge" : h, v = r.lazyLoadingImage, f = void 0 === v ? void 0 : v, m = r.onAvatarError, g = void 0 === m ? function() {} : m, y = $63588b29016207fb$var$ye(r, [
        "avatarFlexible",
        "date",
        "unread",
        "statusColorType",
        "lazyLoadingImage",
        "onAvatarError"
    ]), b = (0, $dgG1Y.useState)(!1), w = b[0], O = b[1], _ = (0, $dgG1Y.useState)(!1), x = _[0], C = _[1];
    (0, $dgG1Y.useEffect)(function() {
        var t;
        null === (t = y.setDragStates) || void 0 === t || t.call(y, C);
    }, []);
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
        className: $63588b29016207fb$var$ft("rce-container-citem", y.className),
        onClick: function(t) {
            var e;
            t.preventDefault(), !0 !== w && (null === (e = y.onClick) || void 0 === e || e.call(y, t));
        },
        onContextMenu: y.onContextMenu
    }, {
        children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ge({
            className: "rce-citem",
            onDragOver: function(t) {
                t.preventDefault(), y.onDragOver instanceof Function && y.onDragOver(t, y.id);
            },
            onDragEnter: function(t) {
                t.preventDefault(), y.onDragEnter instanceof Function && y.onDragEnter(t, y.id), x || C(!0);
            },
            onDragLeave: function(t) {
                t.preventDefault(), y.onDragLeave instanceof Function && y.onDragLeave(t, y.id), x && C(!1);
            },
            onDrop: function(t) {
                t.preventDefault(), y.onDrop instanceof Function && y.onDrop(t, y.id), x && C(!1);
            }
        }, {
            children: [
                !!y.onDragComponent && x && y.onDragComponent(y.id),
                (x && !y.onDragComponent || !x) && [
                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                        className: $63588b29016207fb$var$ft("rce-citem-avatar", {
                            "rce-citem-status-encircle": "encircle" === p
                        })
                    }, {
                        children: (0, $fR5Jw.jsx)($63588b29016207fb$export$e2255cf6045e8d47, {
                            src: y.avatar,
                            alt: y.alt,
                            className: "encircle" === p ? "rce-citem-avatar-encircle-status" : "",
                            size: "large",
                            letterItem: y.letterItem,
                            sideElement: y.statusColor ? (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$ge({
                                className: "rce-citem-status",
                                style: "encircle" === p ? {
                                    border: "solid 2px ".concat(y.statusColor)
                                } : {
                                    backgroundColor: y.statusColor
                                }
                            }, {
                                children: y.statusText
                            })) : (0, $fR5Jw.jsx)((0, $fR5Jw.Fragment), {}),
                            onError: g,
                            lazyLoadingImage: f,
                            type: $63588b29016207fb$var$ft("circle", {
                                flexible: i
                            })
                        })
                    }), "avatar"),
                    (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ge({
                        className: "rce-citem-body"
                    }, {
                        children: [
                            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ge({
                                className: "rce-citem-body--top"
                            }, {
                                children: [
                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                        className: "rce-citem-body--top-title"
                                    }, {
                                        children: y.title
                                    })),
                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                        className: "rce-citem-body--top-time"
                                    }, {
                                        children: s && (y.dateString || $63588b29016207fb$var$$t(s))
                                    }))
                                ]
                            })),
                            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ge({
                                className: "rce-citem-body--bottom"
                            }, {
                                children: [
                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                        className: "rce-citem-body--bottom-title"
                                    }, {
                                        children: y.subtitle
                                    })),
                                    (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ge({
                                        className: "rce-citem-body--bottom-tools",
                                        onMouseEnter: function() {
                                            O(!0);
                                        },
                                        onMouseLeave: function() {
                                            O(!1);
                                        }
                                    }, {
                                        children: [
                                            y.showMute && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$ge({
                                                className: "rce-citem-body--bottom-tools-item",
                                                onClick: y.onClickMute
                                            }, {
                                                children: [
                                                    !0 === y.muted && (0, $fR5Jw.jsx)($63588b29016207fb$var$zt, {}),
                                                    !1 === y.muted && (0, $fR5Jw.jsx)($63588b29016207fb$var$Lt, {})
                                                ]
                                            })),
                                            y.showVideoCall && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                                className: "rce-citem-body--bottom-tools-item",
                                                onClick: y.onClickVideoCall
                                            }, {
                                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$Tt, {})
                                            }))
                                        ]
                                    })),
                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                        className: "rce-citem-body--bottom-tools-item-hidden-hover"
                                    }, {
                                        children: y.showMute && y.muted && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                            className: "rce-citem-body--bottom-tools-item"
                                        }, {
                                            children: (0, $fR5Jw.jsx)($63588b29016207fb$var$zt, {})
                                        }))
                                    })),
                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$ge({
                                        className: "rce-citem-body--bottom-status"
                                    }, {
                                        children: d && d > 0 ? (0, $fR5Jw.jsx)("span", {
                                            children: d
                                        }) : null
                                    })),
                                    void 0 !== y.customStatusComponents ? y.customStatusComponents.map(function(e) {
                                        return (0, $fR5Jw.jsx)(e, {});
                                    }) : null
                                ]
                            }))
                        ]
                    }), "rce-citem-body")
                ]
            ]
        }))
    }), y.id);
}, $63588b29016207fb$var$we = function() {
    return $63588b29016207fb$var$we = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$we.apply(this, arguments);
}, $63588b29016207fb$var$Oe = [], $63588b29016207fb$export$f3b2d8a9ecf740ec = function(e) {
    var n = function(t) {
        $63588b29016207fb$var$Oe.push(t);
    }, r = function(t, n) {
        var r;
        $63588b29016207fb$var$Oe.length > 0 && $63588b29016207fb$var$Oe.forEach(function(t) {
            return t(!1);
        }), null === (r = e.onDragLeave) || void 0 === r || r.call(e, t, n);
    };
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$we({
        className: $63588b29016207fb$var$ft("rce-container-clist", e.className)
    }, {
        children: e.dataSource.map(function(t, o) {
            return (0, $dgG1Y.createElement)($63588b29016207fb$export$86e6771ca9311520, $63588b29016207fb$var$we({}, t, {
                key: o,
                lazyLoadingImage: e.lazyLoadingImage,
                onAvatarError: function(n) {
                    var r, i, a;
                    return r = t, i = o, a = n, void (e.onAvatarError instanceof Function && e.onAvatarError(r, i, a));
                },
                onContextMenu: function(n) {
                    var r, i, a;
                    return r = t, i = o, (a = n).preventDefault(), void (e.onContextMenu instanceof Function && e.onContextMenu(r, i, a));
                },
                onClick: function(n) {
                    var r, i, a;
                    return r = t, i = o, a = n, void (e.onClick instanceof Function && e.onClick(r, i, a));
                },
                onClickMute: function(n) {
                    var r;
                    return null === (r = e.onClickMute) || void 0 === r ? void 0 : r.call(e, t, o, n);
                },
                onClickVideoCall: function(n) {
                    var r;
                    return null === (r = e.onClickVideoCall) || void 0 === r ? void 0 : r.call(e, t, o, n);
                },
                onDragOver: null == e ? void 0 : e.onDragOver,
                onDragEnter: null == e ? void 0 : e.onDragEnter,
                onDrop: e.onDrop,
                onDragLeave: r,
                onDragComponent: e.onDragComponent,
                setDragStates: n
            }));
        })
    }));
}, $63588b29016207fb$var$xe = function() {
    return $63588b29016207fb$var$xe = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$xe.apply(this, arguments);
}, $63588b29016207fb$var$Ce = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$89085c7857c3f940 = function(n) {
    var r = n.referance, o = void 0 === r ? null : r, i = n.lockable, s = void 0 !== i && i, u = n.toBottomHeight, d = void 0 === u ? 300 : u, h = n.downButton, p = $63588b29016207fb$var$Ce(n, [
        "referance",
        "lockable",
        "toBottomHeight",
        "downButton"
    ]), v = (0, $dgG1Y.useState)(0), f = v[0], m = v[1], g = (0, $dgG1Y.useState)(!1), y = g[0], b = g[1], O = (0, $dgG1Y.useRef)(p);
    (0, $dgG1Y.useEffect)(function() {
        var t;
        o && (O.current.dataSource.length !== p.dataSource.length && (m(_(o)), (t = o) && t.current && ("100%" === d || d && f < d ? t.current.scrollTop = t.current.scrollHeight : !0 === s && (t.current.scrollTop = t.current.scrollHeight - t.current.offsetHeight - f))), O.current = p);
    }, [
        O,
        p
    ]);
    var _ = function(t) {
        return t.current ? t.current.scrollHeight - t.current.scrollTop - t.current.offsetHeight : t.scrollHeight - t.scrollTop - t.offsetHeight;
    };
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$xe({
        className: $63588b29016207fb$var$ft([
            "rce-container-mlist",
            p.className
        ])
    }, p.customProps, {
        children: [
            !!p.children && p.isShowChild && p.children,
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$xe({
                ref: o,
                onScroll: function(t) {
                    var e = _(t.currentTarget);
                    m(e), "100%" === d || d && e > d ? !0 !== y && (b(!0), m(e)) : !1 !== y && (b(!1), m(e)), p.onScroll instanceof Function && p.onScroll(t);
                },
                className: "rce-mlist"
            }, {
                children: p.dataSource.map(function(e, n) {
                    return (0, $fR5Jw.jsx)($63588b29016207fb$export$52499e2c5ea4b095, $63588b29016207fb$var$xe({}, e, {
                        onOpen: p.onOpen && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onOpen instanceof Function && p.onOpen(r, o, i));
                        },
                        onPhotoError: p.onPhotoError && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onPhotoError instanceof Function && p.onPhotoError(r, o, i));
                        },
                        onDownload: p.onDownload && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onDownload instanceof Function && p.onDownload(r, o, i));
                        },
                        onTitleClick: p.onTitleClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onTitleClick instanceof Function && p.onTitleClick(r, o, i));
                        },
                        onForwardClick: p.onForwardClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onForwardClick instanceof Function && p.onForwardClick(r, o, i));
                        },
                        onReplyClick: p.onReplyClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onReplyClick instanceof Function && p.onReplyClick(r, o, i));
                        },
                        onReplyMessageClick: p.onReplyMessageClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onReplyMessageClick instanceof Function && p.onReplyMessageClick(r, o, i));
                        },
                        onRemoveMessageClick: p.onRemoveMessageClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onRemoveMessageClick instanceof Function && p.onRemoveMessageClick(r, o, i));
                        },
                        onClick: p.onClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onClick instanceof Function && p.onClick(r, o, i));
                        },
                        onContextMenu: p.onContextMenu && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onContextMenu instanceof Function && p.onContextMenu(r, o, i));
                        },
                        onMeetingMoreSelect: p.onMeetingMoreSelect && function(t) {
                            return function(t, e, n) {
                                p.onMeetingMoreSelect instanceof Function && p.onMeetingMoreSelect(t, e, n);
                            }(e, n, t);
                        },
                        onMessageFocused: p.onMessageFocused && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onMessageFocused instanceof Function && p.onMessageFocused(r, o, i));
                        },
                        onMeetingMessageClick: p.onMeetingMessageClick && function(t) {
                            var r, o, i;
                            return r = e, o = n, i = t, void (p.onMeetingMessageClick instanceof Function && p.onMeetingMessageClick(r, o, i));
                        },
                        onMeetingTitleClick: p.onMeetingTitleClick,
                        onMeetingVideoLinkClick: p.onMeetingVideoLinkClick,
                        onMeetingLinkClick: p.onMeetingLinkClick && function(t) {
                            return function(t, e, n) {
                                p.onMeetingLinkClick instanceof Function && p.onMeetingLinkClick(t, e, n);
                            }(e, n, t);
                        },
                        actionButtons: p.actionButtons,
                        styles: p.messageBoxStyles,
                        notchStyle: p.notchStyle
                    }), n);
                })
            })),
            !0 === h && y && "100%" !== d && (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$xe({
                className: "rce-mlist-down-button",
                onClick: function(t) {
                    o && (o.current.scrollTop = o.current.scrollHeight, p.onDownButtonClick instanceof Function && p.onDownButtonClick(t));
                }
            }, {
                children: [
                    (0, $fR5Jw.jsx)($63588b29016207fb$var$w, {}),
                    void 0 !== p.downButtonBadge ? (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$xe({
                        className: "rce-mlist-down-button--badge"
                    }, {
                        children: p.downButtonBadge.toString()
                    })) : null
                ]
            }))
        ]
    }));
}, $63588b29016207fb$var$Se = function() {
    return $63588b29016207fb$var$Se = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Se.apply(this, arguments);
}, $63588b29016207fb$var$Ne = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$6729b32064d8b37b = function(r) {
    var o = r.subjectLimit, i = void 0 === o ? 60 : o, a = r.onClick, l = void 0 === a ? function() {} : a, c = r.avatarFlexible, s = void 0 !== c && c, u = r.date, d = void 0 === u ? new Date : u, h = r.lazyLoadingImage, p = void 0 === h ? void 0 : h, v = r.avatarLimit, f = void 0 === v ? 5 : v, m = r.avatars, g = void 0 === m ? [] : m, y = r.audioMuted, b = void 0 === y || y, w = r.onAvatarError, O = void 0 === w ? function() {} : w, _ = r.onMeetingClick, x = void 0 === _ ? function() {} : _, C = r.onShareClick, k = void 0 === C ? function() {} : C, S = $63588b29016207fb$var$Ne(r, [
        "subjectLimit",
        "onClick",
        "avatarFlexible",
        "date",
        "lazyLoadingImage",
        "avatarLimit",
        "avatars",
        "audioMuted",
        "onAvatarError",
        "onMeetingClick",
        "onShareClick"
    ]), N = S.statusColorType, M = f, j = d && (S.dateString || $63588b29016207fb$var$$t(d)), P = S.subject && i && S.subject.substring(0, i) + (S.subject.length > i ? "..." : "");
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Se({
        className: $63588b29016207fb$var$ft("rce-container-mtitem", S.className),
        onClick: l,
        onContextMenu: S.onContextMenu
    }, {
        children: [
            (0, $fR5Jw.jsx)("audio", {
                autoPlay: !0,
                loop: !0,
                muted: b,
                src: S.audioSource
            }),
            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Se({
                className: "rce-mtitem"
            }, {
                children: [
                    (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Se({
                        className: "rce-mtitem-top"
                    }, {
                        children: [
                            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Se({
                                className: "rce-mtitem-subject"
                            }, {
                                children: P
                            })),
                            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Se({
                                className: "rce-mtitem-share",
                                onClick: k
                            }, {
                                children: (0, $fR5Jw.jsx)($63588b29016207fb$var$It, {})
                            }))
                        ]
                    })),
                    (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Se({
                        className: "rce-mtitem-body"
                    }, {
                        children: [
                            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Se({
                                className: "rce-mtitem-body--avatars"
                            }, {
                                children: [
                                    null == g ? void 0 : g.slice(0, M).map(function(e, r) {
                                        return (0, $fR5Jw.jsx)($63588b29016207fb$export$e2255cf6045e8d47, {
                                            src: e.src,
                                            alt: e.alt,
                                            className: "encircle" === e.statusColorType ? "rce-mtitem-avatar-encircle-status" : "",
                                            size: "small",
                                            letterItem: e.letterItem,
                                            sideElement: e.statusColor ? (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$Se({
                                                className: "rce-mtitem-status",
                                                style: "encircle" === N ? {
                                                    boxShadow: "inset 0 0 0 2px ".concat(e.statusColor, ", inset 0 0 0 5px #FFFFFF")
                                                } : {
                                                    backgroundColor: e.statusColor
                                                }
                                            }, {
                                                children: e.statusText
                                            })) : (0, $fR5Jw.jsx)((0, $fR5Jw.Fragment), {}),
                                            onError: O,
                                            lazyLoadingImage: p,
                                            type: $63588b29016207fb$var$ft("circle", {
                                                flexible: s
                                            })
                                        }, r);
                                    }),
                                    g && M && g.length > M && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Se({
                                        className: "rce-avatar-container circle small rce-mtitem-letter"
                                    }, {
                                        children: (0, $fR5Jw.jsx)("span", {
                                            children: "+" + (g.length - M)
                                        })
                                    }))
                                ]
                            })),
                            (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Se({
                                className: "rce-mtitem-body--functions"
                            }, {
                                children: [
                                    S.closable && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Se({
                                        className: "rce-mtitem-closable",
                                        onClick: S.onCloseClick
                                    }, {
                                        children: (0, $fR5Jw.jsx)($63588b29016207fb$var$Ft, {})
                                    })),
                                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Se({
                                        className: "rce-mtitem-button",
                                        onClick: x
                                    }, {
                                        children: (0, $fR5Jw.jsx)($63588b29016207fb$var$Tt, {})
                                    }))
                                ]
                            }))
                        ]
                    })),
                    (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Se({
                        className: "rce-mtitem-footer"
                    }, {
                        children: (0, $fR5Jw.jsx)("span", $63588b29016207fb$var$Se({
                            className: "rce-mtitem-date"
                        }, {
                            children: j
                        }))
                    }))
                ]
            }))
        ]
    }));
}, $63588b29016207fb$var$je = function() {
    return $63588b29016207fb$var$je = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$je.apply(this, arguments);
}, $63588b29016207fb$export$cf377cb109c13546 = function(e) {
    var n;
    return (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$je({
        ref: e.cmpRef,
        className: $63588b29016207fb$var$ft("rce-container-mtlist", e.className)
    }, {
        children: null === (n = e.dataSource) || void 0 === n ? void 0 : n.map(function(n, r) {
            return (0, $fR5Jw.jsx)($63588b29016207fb$export$6729b32064d8b37b, $63588b29016207fb$var$je({
                lazyLoadingImage: e.lazyLoadingImage
            }, n, {
                onAvatarError: function(t) {
                    var o, i, a;
                    return o = n, i = r, a = t, void (e.onAvatarError instanceof Function && e.onAvatarError(o, i, a));
                },
                onContextMenu: function(t) {
                    var o, i, a;
                    return o = n, i = r, (a = t).preventDefault(), void (e.onContextMenu instanceof Function && e.onContextMenu(o, i, a));
                },
                onClick: function(t) {
                    var o, i, a;
                    return o = n, i = r, a = t, void (e.onClick instanceof Function && e.onClick(o, i, a));
                },
                onMeetingClick: function(t) {
                    var o, i, a;
                    return o = n, i = r, a = t, void (e.onMeetingClick instanceof Function && e.onMeetingClick(o, i, a));
                },
                onShareClick: function(t) {
                    var o, i, a;
                    return o = n, i = r, a = t, void (e.onShareClick instanceof Function && e.onShareClick(o, i, a));
                },
                onCloseClick: function(t) {
                    var o, i, a;
                    return o = n, i = r, a = t, void (e.onCloseClick instanceof Function && e.onCloseClick(o, i, a));
                }
            }), r);
        })
    }));
}, $63588b29016207fb$var$Ee = function() {
    return $63588b29016207fb$var$Ee = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Ee.apply(this, arguments);
}, $63588b29016207fb$var$Te = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$f5b8910cec6cf069 = function(n) {
    var r, o = n.type, i = void 0 === o ? "text" : o, l = n.multiline, c = void 0 !== l && l, s = n.minHeight, u = void 0 === s ? 25 : s, d = n.maxHeight, h = void 0 === d ? 200 : d, p = n.autoHeight, v = void 0 === p || p, f = n.autofocus, m = void 0 !== f && f, g = $63588b29016207fb$var$Te(n, [
        "type",
        "multiline",
        "minHeight",
        "maxHeight",
        "autoHeight",
        "autofocus"
    ]);
    (0, $dgG1Y.useEffect)(function() {
        var t, e;
        !0 === m && (null === (e = null === (t = g.referance) || void 0 === t ? void 0 : t.current) || void 0 === e || e.focus()), g.clear instanceof Function && g.clear(b);
    }, []);
    var y = function(t) {
        if (!0 === c && !0 === v) {
            t.target.style.height !== u + "px" && (t.target.style.height = u + "px");
            var e = void 0;
            e = t.target.scrollHeight <= h ? t.target.scrollHeight + "px" : h + "px", t.target.style.height !== e && (t.target.style.height = e);
        }
        if (g.maxlength && (t.target.value || "").length > g.maxlength) return g.onMaxLengthExceed instanceof Function && g.onMaxLengthExceed(), void (g.referance && (g.referance.current.value = (t.target.value || "").substring(0, g.maxlength)));
        g.onChange instanceof Function && g.onChange(t);
    }, b = function() {
        var t, e, n, r = {
            FAKE_EVENT: !0,
            target: null === (t = g.referance) || void 0 === t ? void 0 : t.current
        };
        (null === (n = null === (e = g.referance) || void 0 === e ? void 0 : e.current) || void 0 === n ? void 0 : n.value) && (g.referance.current.value = ""), y(r);
    };
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Ee({
        className: $63588b29016207fb$var$ft("rce-container-input", g.className)
    }, {
        children: [
            g.leftButtons && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ee({
                className: "rce-input-buttons"
            }, {
                children: g.leftButtons
            })),
            !1 === c ? (0, $fR5Jw.jsx)("input", {
                ref: g.referance,
                type: i,
                className: $63588b29016207fb$var$ft("rce-input"),
                placeholder: g.placeholder,
                defaultValue: g.defaultValue,
                style: g.inputStyle,
                onChange: y,
                onCopy: g.onCopy,
                onCut: g.onCut,
                onPaste: g.onPaste,
                onBlur: g.onBlur,
                onFocus: g.onFocus,
                onSelect: g.onSelect,
                onSubmit: g.onSubmit,
                onReset: g.onReset,
                onKeyDown: g.onKeyDown,
                onKeyPress: g.onKeyPress,
                onKeyUp: g.onKeyUp,
                value: g.value
            }) : (0, $fR5Jw.jsx)("textarea", $63588b29016207fb$var$Ee({
                ref: g.referance,
                className: $63588b29016207fb$var$ft("rce-input", "rce-input-textarea"),
                placeholder: g.placeholder,
                defaultValue: g.defaultValue,
                style: g.inputStyle,
                onChange: y,
                onCopy: g.onCopy,
                onCut: g.onCut,
                onPaste: g.onPaste,
                onBlur: g.onBlur,
                onFocus: g.onFocus,
                onSelect: g.onSelect,
                onSubmit: g.onSubmit,
                onReset: g.onReset,
                onKeyDown: g.onKeyDown,
                onKeyPress: g.onKeyPress,
                onKeyUp: g.onKeyUp
            }, {
                children: g.defaultValue && null !== (r = null == g ? void 0 : g.value) && void 0 !== r ? r : null
            })),
            g.rightButtons && (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ee({
                className: "rce-input-buttons"
            }, {
                children: g.rightButtons
            }))
        ]
    }));
}, $63588b29016207fb$var$Le = function() {
    return $63588b29016207fb$var$Le = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Le.apply(this, arguments);
}, $63588b29016207fb$var$Fe = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$42cfbb80f7861e77 = function(n) {
    var r = n.type, o = void 0 === r ? "light" : r, i = $63588b29016207fb$var$Fe(n, [
        "type"
    ]);
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Le({
        className: $63588b29016207fb$var$ft("rce-navbar", o, i.className)
    }, {
        children: [
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Le({
                className: "rce-navbar-item rce-navbar-item__left"
            }, {
                children: i.left
            })),
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Le({
                className: "rce-navbar-item rce-navbar-item__center"
            }, {
                children: i.center
            })),
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Le({
                className: "rce-navbar-item rce-navbar-item__right"
            }, {
                children: i.right
            }))
        ]
    }));
}, $63588b29016207fb$var$Ae = function() {
    return $63588b29016207fb$var$Ae = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$Ae.apply(this, arguments);
}, $63588b29016207fb$var$Ie = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$614264b7ca4804e6 = function(n) {
    var r, o, i, a = n.type, l = void 0 === a ? "dark" : a, c = $63588b29016207fb$var$Ie(n, [
        "type"
    ]);
    return (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$Ae({
        className: $63588b29016207fb$var$ft("rce-sbar", l, c.data.className)
    }, {
        children: [
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ae({
                className: "rce-sbar-item"
            }, {
                children: null === (r = c.data) || void 0 === r ? void 0 : r.top
            })),
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ae({
                className: "rce-sbar-item rce-sbar-item__center"
            }, {
                children: null === (o = c.data) || void 0 === o ? void 0 : o.center
            })),
            (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$Ae({
                className: "rce-sbar-item"
            }, {
                children: null === (i = c.data) || void 0 === i ? void 0 : i.bottom
            }))
        ]
    }));
}, $63588b29016207fb$var$He = function() {
    return $63588b29016207fb$var$He = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var o in e = arguments[n])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $63588b29016207fb$var$He.apply(this, arguments);
}, $63588b29016207fb$var$Re = function(t, e) {
    var n = {};
    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(t); o < r.length; o++)e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
    }
    return n;
}, $63588b29016207fb$export$129a32eedafa97c5 = function(n) {
    var r, o, i, a, l, c, s, u, d, h, p, v, f, m, g, y = $63588b29016207fb$var$Re(n, []);
    return !0 === (null === (r = y.popup) || void 0 === r ? void 0 : r.show) ? (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$He({
        className: $63588b29016207fb$var$ft("rce-popup-wrapper", y.type, y.className)
    }, {
        children: (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$He({
            className: "rce-popup"
        }, {
            children: [
                (null === (o = y.popup) || void 0 === o ? void 0 : o.renderHeader) ? (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$He({
                    className: "rce-popup-header"
                }, {
                    children: null === (i = y.popup) || void 0 === i ? void 0 : i.renderHeader()
                })) : (0, $fR5Jw.jsxs)("div", $63588b29016207fb$var$He({
                    className: "rce-popup-header"
                }, {
                    children: [
                        (0, $fR5Jw.jsx)("span", {
                            children: null === (a = y.popup) || void 0 === a ? void 0 : a.header
                        }),
                        (null === (l = y.popup) || void 0 === l ? void 0 : l.header) && (null === (s = null === (c = y.popup) || void 0 === c ? void 0 : c.headerButtons) || void 0 === s ? void 0 : s.map(function(e, n) {
                            return (0, $fR5Jw.jsx)($63588b29016207fb$export$353f5b6fc5456de1, $63588b29016207fb$var$He({}, e), n);
                        }))
                    ]
                })),
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$He({
                    className: "rce-popup-content",
                    style: {
                        color: null === (u = y.popup) || void 0 === u ? void 0 : u.color
                    }
                }, {
                    children: (null === (d = y.popup) || void 0 === d ? void 0 : d.renderContent) ? null === (h = y.popup) || void 0 === h ? void 0 : h.renderContent() : null === (p = y.popup) || void 0 === p ? void 0 : p.text
                })),
                (0, $fR5Jw.jsx)("div", $63588b29016207fb$var$He({
                    className: "rce-popup-footer"
                }, {
                    children: (null === (v = y.popup) || void 0 === v ? void 0 : v.renderFooter) ? null === (f = y.popup) || void 0 === f ? void 0 : f.renderFooter() : null === (g = null === (m = y.popup) || void 0 === m ? void 0 : m.footerButtons) || void 0 === g ? void 0 : g.map(function(e, n) {
                        return (0, $fR5Jw.jsx)($63588b29016207fb$export$353f5b6fc5456de1, $63588b29016207fb$var$He({}, e), n);
                    })
                }))
            ]
        }))
    })) : null;
};

});

parcelRegister("gElWY", function(module, exports) {

$parcel$export(module.exports, "useGetFilters", function () { return $0320cc028e5c384e$export$d5483d34fe29d84a; });
/* eslint-disable import/prefer-default-export */ 
var $dgG1Y = parcelRequire("dgG1Y");
const $0320cc028e5c384e$export$d5483d34fe29d84a = (sendRequest, auth, showModal, isSMS, url, rerender, filterOutDx, setReRender)=>{
    const [ARS, setARS] = (0, $dgG1Y.useState)();
    const [adminUsers, setAdminUsers] = (0, $dgG1Y.useState)([]);
    const [selectedButton, setSelectedButton] = (0, $dgG1Y.useState)(auth.accountableAdmin ? 1 : 2); //start with ARS
    const [filterText, setFilterText] = (0, $dgG1Y.useState)();
    const [filterByARS, setFilterByARS] = (0, $dgG1Y.useState)();
    const [arsFilter, setARSFilter] = (0, $dgG1Y.useState)();
    const [programFilter, setProgramFilter] = (0, $dgG1Y.useState)();
    const [sortFilter, setSortFilter] = (0, $dgG1Y.useState)(); //1 Lab Screens Ascending, 2 Lab Screens Descending, 3 Last Name Ascending, 4 Last Name Descending, 5 tox screens ascending, 6 tox screens descending
    const [arsUser, setARSUser] = (0, $dgG1Y.useState)(0);
    //get ars
    (0, $dgG1Y.useEffect)(()=>{
        //get permission level for protected subpages.
        const getARS = async ()=>{
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/adminusersfilter", "GET", null, {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData) {
                setARS(responseData);
                setFilterByARS(responseData);
            }
        };
        if (auth.accountableAdmin) getARS();
    }, [
        auth.accountableAdmin
    ]);
    //get admin users
    (0, $dgG1Y.useEffect)(()=>{
        console.log("in get admin users");
        console.dir(auth);
        console.log("isSMS: " + isSMS);
        //get users for tenant
        const getAdminUsers = async ()=>{
            console.log("in get admin users");
            if (!isSMS) try {
                if (!url) url = "/api/accountable/adminusers";
                // Add tab parameter to query string
                const queryParams = new URLSearchParams({
                    tab: selectedButton
                }).toString();
                const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}${url}?${queryParams}`, "GET", null, {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData && !responseData.message) {
                    if (filterText || filterText === "") setAdminUsers(adjustFilter(responseData.filter((users)=>users.lastName.toLowerCase().includes(filterText.toLowerCase())).sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1)));
                    else setAdminUsers(adjustFilter(responseData.sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1)));
                }
            } catch (err) {}
        };
        if (!isSMS && (auth.accountableAdmin || auth.provider || auth.siteAdmin)) getAdminUsers();
        else if (auth.accountableAdmin || auth.provider || auth.siteAdmin) {
            const getAdminUsers = async ()=>{
                try {
                    const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/adminuserssms?" + new URLSearchParams({
                        filter: selectedButton
                    }), "GET", null, {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + auth.token
                    });
                    if (responseData && !responseData.message) setAdminUsers(adjustFilter(responseData.filter((user)=>user.phoneNumber).sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1))); //only show users with active phone numbers
                } catch (err) {}
            };
            if (auth.accountableAdmin || auth.provider || auth.siteAdmin) getAdminUsers();
        }
    }, [
        sendRequest,
        showModal,
        selectedButton,
        rerender,
        auth.accountableAdmin
    ]);
    const getAdminUsers = async (event)=>{
        console.log("in get admin users");
        if (!isSMS) try {
            if (!url) url = "/api/accountable/adminusers";
            // Add tab parameter to query string
            const queryParams = new URLSearchParams({
                tab: selectedButton
            }).toString();
            const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}${url}?${queryParams}`, "GET", null, {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData && !responseData.message) {
                if (!event || event.length < 2) setAdminUsers(adjustFilter(responseData.filter((users)=>users.lastName.toLowerCase()).sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1)));
                else setAdminUsers(adjustFilter(responseData.filter((users)=>users.lastName.toLowerCase().includes(event.toLowerCase())).sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1)));
            }
        } catch (err) {
            console.log("is something breaking?");
        }
        if (isSMS) try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/adminuserssms?" + new URLSearchParams({
                filter: selectedButton
            }), "GET", null, {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData && !responseData.message) {
                if (!event || event.length < 2) setAdminUsers(adjustFilter(responseData.filter((user)=>user.phoneNumber).sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1)));
                else setAdminUsers(adjustFilter(responseData.filter((user)=>user.phoneNumber).filter((users)=>users.lastName.toLowerCase().includes(event.toLowerCase())).sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1)));
            }
        } catch (err) {
            console.log("is something breaking? " + err);
        }
    };
    const getDifferenceBetweenDates = (date1, date2)=>{
        const diffInMs = Math.abs(date2 - date1);
        return diffInMs / 86400000;
    };
    const adjustFilter = (users)=>{
        switch(parseInt(selectedButton)){
            case 0:
                users = users.filter((user)=>!user.provider && !user.accountableAdmin);
                break;
            case 1:
                users = users.filter((user)=>user.ARS === auth.userId && !user.provider && !user.accountableAdmin && (!user.dischargeDate || new Date(user.dischargeDate) > new Date()));
                break;
            case 2:
                users = users.filter((user)=>(!user.dischargeDate || new Date(user.dischargeDate) > new Date()) && !user.provider && !user.accountableAdmin && user.stripeStatus !== "trialing");
                break;
            case 3:
                users = users.filter((user)=>new Date(user.dischargeDate) < new Date() && !user.provider && !user.accountableAdmin);
                break;
            case 4:
                users = users.filter((user)=>user.provider);
                break;
            case 5:
                users = users.filter((user)=>user.accountableAdmin);
                break;
            case 6:
                users = users.filter((user)=>user.stripeStatus === "trialing" && (!user.dischargeDate || new Date(user.dischargeDate) > new Date()));
                break;
            case 7:
                users = users.filter((user)=>user.program);
                break;
        }
        if (arsFilter) {
            if (arsFilter === "UNASSIGNED") users = users.filter((user)=>!user.ARS && !user.partnerManaged);
            else if (arsFilter === "PROGRAMMANAGED") users = users.filter((user)=>user.partnerManaged);
            else if (arsFilter === "NOTPROGRAMMANAGED") users = users.filter((user)=>!user.partnerManaged);
            else if (arsFilter === "RECENTINTAKE") users = users.filter((user)=>getDifferenceBetweenDates(new Date(user.intakeDate), new Date()) <= 10);
            else if (arsFilter === "RECENTREGISTER") users = users.filter((user)=>getDifferenceBetweenDates(new Date(user.startDate), new Date()) <= 10);
            else if (arsFilter === "RECENTDX") users = users.filter((user)=>getDifferenceBetweenDates(new Date(user.dischargeDate), new Date()) <= 10 && user.intakeDate);
            else if (arsFilter === "LABTESTING") users = users.filter((user)=>user.planDetails.some((detail)=>detail.includes("Saliva Lab Test") || detail.includes("UA Test")));
            else if (arsFilter === "INSTANTTEST") users = users.filter((user)=>user.planDetails.some((detail)=>detail.includes("Saliva Test") && !detail.includes("Saliva Lab Test")));
            else if (arsFilter === "INSURANCECARRIER") users = users.filter((user)=>user.insuranceCarrier);
            else users = users.filter((user)=>user.ARS === arsFilter);
        }
        if (programFilter) users = users.filter((user)=>user.programTenant === programFilter);
        if (filterOutDx) users = users.filter((user)=>!user.dxFromProgram);
        switch(sortFilter //1 Lab Screens Ascending, 2 Lab Screens Descending, 3 Last Name Ascending, 4 Last Name Descending, 5 tox screens ascending, 6 tox screens descending
        ){
            case 1:
                users = users.sort((a, b)=>{
                    if (a.labScreens == null) return 1;
                    if (b.labScreens == null) return -1;
                    return a.labScreens - b.labScreens;
                });
                break;
            case 2:
                users = users.sort((a, b)=>{
                    if (a.labScreens == null) return 1;
                    if (b.labScreens == null) return -1;
                    return b.labScreens - a.labScreens;
                });
                break;
            case 3:
                users = users.sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id > b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1);
                break;
            case 4:
                users = users.sort((a, b)=>a.lastName.toLowerCase() + a.firstName.toLowerCase() + a._id < b.lastName.toLowerCase() + b.firstName.toLowerCase() + a._id ? 1 : -1);
                break;
            case 5:
                users = users.sort((a, b)=>{
                    if (a.toxes == null) return 1;
                    if (b.toxes == null) return -1;
                    return a.toxes - b.toxes;
                });
                break;
            case 6:
                users = users.sort((a, b)=>{
                    if (a.toxes == null) return 1;
                    if (b.toxes == null) return -1;
                    return b.toxes - a.toxes;
                });
                break;
        }
        return users;
    };
    const handleSetArsUser = (event)=>{
        setARSUser(event.target.value);
        setARSFilter(event.target.value);
        setReRender(!rerender);
    };
    return {
        ARS: ARS,
        adminUsers: adminUsers,
        setAdminUsers: setAdminUsers,
        getAdminUsers: getAdminUsers,
        selectedButton: selectedButton,
        setSelectedButton: setSelectedButton,
        adjustFilter: adjustFilter,
        setFilterText: setFilterText,
        arsFilter: arsFilter,
        setARSFilter: setARSFilter,
        programFilter: programFilter,
        setProgramFilter: setProgramFilter,
        setSortFilter: setSortFilter,
        sortFilter: sortFilter,
        filterByARS: filterByARS,
        setFilterByARS: setFilterByARS,
        handleSetArsUser: handleSetArsUser,
        arsUser: arsUser,
        setARSUser: setARSUser,
        filterText: filterText
    };
};

});

parcelRegister("T5LKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a599cce786727ed$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $4m0VC = parcelRequire("4m0VC");
var $i6p4h = parcelRequire("i6p4h");
const $0a599cce786727ed$var$Filter = (props)=>{
    const adjustFilter = (event)=>{
        let val = event.currentTarget ? event.currentTarget.value : event;
        props.setSelectedButton(parseInt(val));
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $i6p4h.default), {
        color: "primary",
        variant: "contained",
        size: "small",
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 0,
                color: props.selectedButton === 0 ? "secondary" : "primary",
                children: "ALL"
            }),
            props.authContext.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 1,
                color: props.selectedButton === 1 ? "secondary" : "primary",
                children: "ARS"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 2,
                color: props.selectedButton === 2 ? "secondary" : "primary",
                children: "Active"
            }),
            !props.authContext.provider && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 6,
                color: props.selectedButton === 6 ? "secondary" : "primary",
                children: "Trial"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 3,
                color: props.selectedButton === 3 ? "secondary" : "primary",
                children: "Inactive"
            }),
            props.authContext.accountableAdmin && !props.sms && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 7,
                color: props.selectedButton === 7 ? "secondary" : "primary",
                children: "Programs"
            }),
            props.authContext.accountableAdmin && !props.sms && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 4,
                color: props.selectedButton === 4 ? "secondary" : "primary",
                children: "Providers"
            }),
            props.authContext.accountableAdmin && !props.sms && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                onClick: adjustFilter,
                value: 5,
                color: props.selectedButton === 5 ? "secondary" : "primary",
                children: "Admins"
            })
        ]
    });
};
var $0a599cce786727ed$export$2e2bcd8739ae039 = $0a599cce786727ed$var$Filter;

});
parcelRegister("i6p4h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2dc3b7f22d6db22$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("O2eT5");


var $cXVHi = parcelRequire("cXVHi");

var $bdWPY = parcelRequire("bdWPY");

var $4BFH5 = parcelRequire("4BFH5");

var $7xfqK = parcelRequire("7xfqK");

var $4m0VC = parcelRequire("4m0VC");
// eslint-disable-next-line no-unused-expressions
(0, $4m0VC.default).styles;
var $d2dc3b7f22d6db22$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-flex",
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            boxShadow: theme.shadows[2]
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none"
        },
        /* Pseudo-class applied to child elements if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: "column"
        },
        /* Styles applied to the children. */ grouped: {
            minWidth: 40
        },
        /* Styles applied to the children if `orientation="horizontal"`. */ groupedHorizontal: {
            "&:not(:first-child)": {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
            },
            "&:not(:last-child)": {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        /* Styles applied to the children if `orientation="vertical"`. */ groupedVertical: {
            "&:not(:first-child)": {
                borderTopRightRadius: 0,
                borderTopLeftRadius: 0
            },
            "&:not(:last-child)": {
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
        /* Styles applied to the children if `variant="text"`. */ groupedText: {},
        /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */ groupedTextHorizontal: {
            "&:not(:last-child)": {
                borderRight: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)")
            }
        },
        /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */ groupedTextVertical: {
            "&:not(:last-child)": {
                borderBottom: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)")
            }
        },
        /* Styles applied to the children if `variant="text"` and `color="primary"`. */ groupedTextPrimary: {
            "&:not(:last-child)": {
                borderColor: (0, $4BFH5.alpha)(theme.palette.primary.main, 0.5)
            }
        },
        /* Styles applied to the children if `variant="text"` and `color="secondary"`. */ groupedTextSecondary: {
            "&:not(:last-child)": {
                borderColor: (0, $4BFH5.alpha)(theme.palette.secondary.main, 0.5)
            }
        },
        /* Styles applied to the children if `variant="outlined"`. */ groupedOutlined: {},
        /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */ groupedOutlinedHorizontal: {
            "&:not(:first-child)": {
                marginLeft: -1
            },
            "&:not(:last-child)": {
                borderRightColor: "transparent"
            }
        },
        /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */ groupedOutlinedVertical: {
            "&:not(:first-child)": {
                marginTop: -1
            },
            "&:not(:last-child)": {
                borderBottomColor: "transparent"
            }
        },
        /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */ groupedOutlinedPrimary: {
            "&:hover": {
                borderColor: theme.palette.primary.main
            }
        },
        /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */ groupedOutlinedSecondary: {
            "&:hover": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the children if `variant="contained"`. */ groupedContained: {
            boxShadow: "none"
        },
        /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */ groupedContainedHorizontal: {
            "&:not(:last-child)": {
                borderRight: "1px solid ".concat(theme.palette.grey[400]),
                "&$disabled": {
                    borderRight: "1px solid ".concat(theme.palette.action.disabled)
                }
            }
        },
        /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */ groupedContainedVertical: {
            "&:not(:last-child)": {
                borderBottom: "1px solid ".concat(theme.palette.grey[400]),
                "&$disabled": {
                    borderBottom: "1px solid ".concat(theme.palette.action.disabled)
                }
            }
        },
        /* Styles applied to the children if `variant="contained"` and `color="primary"`. */ groupedContainedPrimary: {
            "&:not(:last-child)": {
                borderColor: theme.palette.primary.dark
            }
        },
        /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */ groupedContainedSecondary: {
            "&:not(:last-child)": {
                borderColor: theme.palette.secondary.dark
            }
        }
    };
};
var $d2dc3b7f22d6db22$var$ButtonGroup = /*#__PURE__*/ $dgG1Y.forwardRef(function ButtonGroup(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "outlined" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "disableRipple",
        "fullWidth",
        "orientation",
        "size",
        "variant"
    ]);
    var buttonClassName = (0, $cXVHi.default)(classes.grouped, classes["grouped".concat((0, $bdWPY.default)(orientation))], classes["grouped".concat((0, $bdWPY.default)(variant))], classes["grouped".concat((0, $bdWPY.default)(variant)).concat((0, $bdWPY.default)(orientation))], classes["grouped".concat((0, $bdWPY.default)(variant)).concat(color !== "default" ? (0, $bdWPY.default)(color) : "")], disabled && classes.disabled);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        role: "group",
        className: (0, $cXVHi.default)(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === "contained" && classes.contained, orientation === "vertical" && classes.vertical),
        ref: ref
    }, other), $dgG1Y.Children.map(children, function(child) {
        if (!/*#__PURE__*/ $dgG1Y.isValidElement(child)) return null;
        return /*#__PURE__*/ $dgG1Y.cloneElement(child, {
            className: (0, $cXVHi.default)(buttonClassName, child.props.className),
            color: child.props.color || color,
            disabled: child.props.disabled || disabled,
            disableElevation: child.props.disableElevation || disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: child.props.size || size,
            variant: child.props.variant || variant
        });
    }));
});
var $d2dc3b7f22d6db22$export$2e2bcd8739ae039 = (0, $7xfqK.default)($d2dc3b7f22d6db22$export$9dd6ff9ea0189349, {
    name: "MuiButtonGroup"
})($d2dc3b7f22d6db22$var$ButtonGroup);

});


parcelRegister("cxFzf", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9218cf8ce954ac2a$var$React = $3kONX((parcelRequire("dgG1Y")));

var $9218cf8ce954ac2a$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $9218cf8ce954ac2a$var$_default = (0, $9218cf8ce954ac2a$var$_createSvgIcon.default)(/*#__PURE__*/ $9218cf8ce954ac2a$var$React.createElement("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Loop");
module.exports.default = $9218cf8ce954ac2a$var$_default;

});

parcelRegister("axbIu", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ab6131efb7c7a6e$var$React = $3kONX((parcelRequire("dgG1Y")));

var $7ab6131efb7c7a6e$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $7ab6131efb7c7a6e$var$_default = (0, $7ab6131efb7c7a6e$var$_createSvgIcon.default)(/*#__PURE__*/ $7ab6131efb7c7a6e$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
module.exports.default = $7ab6131efb7c7a6e$var$_default;

});

parcelRegister("bocI1", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84abcb59a1a6949f$var$React = $3kONX((parcelRequire("dgG1Y")));

var $84abcb59a1a6949f$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $84abcb59a1a6949f$var$_default = (0, $84abcb59a1a6949f$var$_createSvgIcon.default)(/*#__PURE__*/ $84abcb59a1a6949f$var$React.createElement("path", {
    d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), "HighlightOff");
module.exports.default = $84abcb59a1a6949f$var$_default;

});

parcelRegister("5wep2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $404b1d058bc7e06d$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $iJ8f3 = parcelRequire("iJ8f3");

var $9EE4V = parcelRequire("9EE4V");

var $3kUUy = parcelRequire("3kUUy");

var $2gTUh = parcelRequire("2gTUh");

var $aXBMD = parcelRequire("aXBMD");

var $9f741 = parcelRequire("9f741");
const $404b1d058bc7e06d$var$ConfirmationDialog = (props)=>{
    const handleClose = ()=>{
        props.close();
    };
    // Determine which type of dialog to show
    const isPaymentDialog = props.type === "payment";
    const isEnrollmentDialog = props.type === "enrollment";
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
        open: props.open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        fullWidth: true,
        maxWidth: props.size || "sm",
        sx: {
            "& .MuiDialog-paper": {
                width: "100%"
            }
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9f741.default), {
                sx: {
                    pb: 2
                },
                children: props.title
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2gTUh.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aXBMD.default), {
                    sx: {
                        mb: 2
                    },
                    children: props.alert
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $3kUUy.default), {
                sx: {
                    p: 2,
                    gap: 1
                },
                children: [
                    isPaymentDialog && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                onClick: props.programPaying ? props.runSwitchToSelfPay : props.runSwitchToProgramPay,
                                fullWidth: props.fullWidth || false,
                                variant: props.variant || "contained",
                                color: "secondary",
                                sx: {
                                    flex: props.fullWidth ? 1 : "none"
                                },
                                children: props.programPaying ? "Switch to Self Pay" : "Switch to Program Pay"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                onClick: handleClose,
                                fullWidth: props.fullWidth || false,
                                variant: props.variant || "text",
                                color: "primary",
                                sx: {
                                    flex: props.fullWidth ? 1 : "none"
                                },
                                children: "Cancel"
                            })
                        ]
                    }),
                    isEnrollmentDialog && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                onClick: props.dxFromProgram ? props.runReEnroll : props.runDischarge,
                                fullWidth: props.fullWidth || false,
                                variant: props.variant || "contained",
                                color: "secondary",
                                sx: {
                                    flex: props.fullWidth ? 1 : "none"
                                },
                                children: props.dxFromProgram ? "Re-Enroll Member" : "Discharge Member"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                                onClick: handleClose,
                                fullWidth: props.fullWidth || false,
                                variant: props.variant || "text",
                                color: "primary",
                                sx: {
                                    flex: props.fullWidth ? 1 : "none"
                                },
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $404b1d058bc7e06d$export$2e2bcd8739ae039 = $404b1d058bc7e06d$var$ConfirmationDialog;

});

parcelRegister("jFtgc", function(module, exports) {
/*! pdfmake v0.2.9, @license MIT, @link http://pdfmake.org */ (function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(typeof self !== "undefined" ? self : module.exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 71692: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                // The following break classes are handled by the pair table
                exports.OP = 0; // Opening punctuation
                exports.CL = 1; // Closing punctuation
                exports.CP = 2; // Closing parenthesis
                exports.QU = 3; // Ambiguous quotation
                exports.GL = 4; // Glue
                exports.NS = 5; // Non-starters
                exports.EX = 6; // Exclamation/Interrogation
                exports.SY = 7; // Symbols allowing break after
                exports.IS = 8; // Infix separator
                exports.PR = 9; // Prefix
                exports.PO = 10; // Postfix
                exports.NU = 11; // Numeric
                exports.AL = 12; // Alphabetic
                exports.HL = 13; // Hebrew Letter
                exports.ID = 14; // Ideographic
                exports.IN = 15; // Inseparable characters
                exports.HY = 16; // Hyphen
                exports.BA = 17; // Break after
                exports.BB = 18; // Break before
                exports.B2 = 19; // Break on either side (but not pair)
                exports.ZW = 20; // Zero-width space
                exports.CM = 21; // Combining marks
                exports.WJ = 22; // Word joiner
                exports.H2 = 23; // Hangul LV
                exports.H3 = 24; // Hangul LVT
                exports.JL = 25; // Hangul L Jamo
                exports.JV = 26; // Hangul V Jamo
                exports.JT = 27; // Hangul T Jamo
                exports.RI = 28; // Regional Indicator
                exports.EB = 29; // Emoji Base
                exports.EM = 30; // Emoji Modifier
                exports.ZWJ = 31; // Zero Width Joiner
                exports.CB = 32; // Contingent break
                // The following break classes are not handled by the pair table
                exports.AI = 33; // Ambiguous (Alphabetic or Ideograph)
                exports.BK = 34; // Break (mandatory)
                exports.CJ = 35; // Conditional Japanese Starter
                exports.CR = 36; // Carriage return
                exports.LF = 37; // Line feed
                exports.NL = 38; // Next line
                exports.SA = 39; // South-East Asian
                exports.SG = 40; // Surrogates
                exports.SP = 41; // Space
                exports.XX = 42; // Unknown
            /***/ },
            /***/ 54069: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;
                exports.DI_BRK = DI_BRK = 0; // Direct break opportunity
                exports.IN_BRK = IN_BRK = 1; // Indirect break opportunity
                exports.CI_BRK = CI_BRK = 2; // Indirect break opportunity for combining marks
                exports.CP_BRK = CP_BRK = 3; // Prohibited break for combining marks
                exports.PR_BRK = PR_BRK = 4; // Prohibited break
                // Based on example pair table from https://www.unicode.org/reports/tr14/tr14-37.html#Table2
                // - ZWJ special processing for LB8a of Revision 41
                // - CB manually added as per Rule LB20
                // - CL, CP, NS, SY, IS, PR, PO, HY, BA, B2 and RI manually adjusted as per LB22 of Revision 45
                exports.pairTable = [
                    //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
                    [
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        CP_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK
                    ],
                    // OP
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // CL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // CP
                    [
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK
                    ],
                    // QU
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK
                    ],
                    // GL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // NS
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // EX
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // SY
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // IS
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // PR
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // PO
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // NU
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // AL
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // HL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // ID
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // IN
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // HY
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // BA
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // BB
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // B2
                    [
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK
                    ],
                    // ZW
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // CM
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK
                    ],
                    // WJ
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // H2
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // H3
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // JL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // JV
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // JT
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // RI
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // EB
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // EM
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // ZWJ
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ] // CB
                ];
            /***/ },
            /***/ 27398: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(33130);
                exports.EncodeStream = __webpack_require__(74883);
                exports.DecodeStream = __webpack_require__(42092);
                exports.Array = __webpack_require__(23948);
                exports.LazyArray = __webpack_require__(88931);
                exports.Bitfield = __webpack_require__(41602);
                exports.Boolean = __webpack_require__(21210);
                exports.Buffer = __webpack_require__(96204);
                exports.Enum = __webpack_require__(2463);
                exports.Optional = __webpack_require__(11568);
                exports.Reserved = __webpack_require__(62211);
                exports.String = __webpack_require__(69046);
                exports.Struct = __webpack_require__(90433);
                exports.VersionedStruct = __webpack_require__(37529);
                var utils = __webpack_require__(76959);
                var NumberT = __webpack_require__(61002);
                var Pointer = __webpack_require__(27309);
                Object.assign(exports, utils, NumberT, Pointer);
            /***/ },
            /***/ 23948: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                __webpack_require__(10853);
                __webpack_require__(33290);
                __webpack_require__(54994);
                __webpack_require__(4845);
                __webpack_require__(45007);
                __webpack_require__(39275);
                __webpack_require__(26364);
                __webpack_require__(86632);
                __webpack_require__(61928);
                __webpack_require__(54883);
                __webpack_require__(68995);
                function _createForOfIteratorHelperLoose(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (it) return (it = it.call(o)).next.bind(it);
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        return function() {
                            if (i >= o.length) return {
                                done: true
                            };
                            return {
                                done: false,
                                value: o[i++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                var _require = __webpack_require__(61002), NumberT = _require.Number;
                var utils = __webpack_require__(76959);
                var ArrayT = /*#__PURE__*/ function() {
                    function ArrayT(type, length, lengthType) {
                        if (lengthType === void 0) lengthType = "count";
                        this.type = type;
                        this.length = length;
                        this.lengthType = lengthType;
                    }
                    var _proto = ArrayT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var length;
                        var pos = stream.pos;
                        var res = [];
                        var ctx = parent;
                        if (this.length != null) length = utils.resolveLength(this.length, stream, parent);
                        if (this.length instanceof NumberT) {
                            // define hidden properties
                            Object.defineProperties(res, {
                                parent: {
                                    value: parent
                                },
                                _startOffset: {
                                    value: pos
                                },
                                _currentOffset: {
                                    value: 0,
                                    writable: true
                                },
                                _length: {
                                    value: length
                                }
                            });
                            ctx = res;
                        }
                        if (length == null || this.lengthType === "bytes") {
                            var target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
                            while(stream.pos < target)res.push(this.type.decode(stream, ctx));
                        } else for(var i = 0, end = length; i < end; i++)res.push(this.type.decode(stream, ctx));
                        return res;
                    };
                    _proto.size = function size(array, ctx) {
                        if (!array) return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
                        var size = 0;
                        if (this.length instanceof NumberT) {
                            size += this.length.size();
                            ctx = {
                                parent: ctx
                            };
                        }
                        for(var _iterator = _createForOfIteratorHelperLoose(array), _step; !(_step = _iterator()).done;){
                            var item = _step.value;
                            size += this.type.size(item, ctx);
                        }
                        return size;
                    };
                    _proto.encode = function encode(stream, array, parent) {
                        var ctx = parent;
                        if (this.length instanceof NumberT) {
                            ctx = {
                                pointers: [],
                                startOffset: stream.pos,
                                parent: parent
                            };
                            ctx.pointerOffset = stream.pos + this.size(array, ctx);
                            this.length.encode(stream, array.length);
                        }
                        for(var _iterator2 = _createForOfIteratorHelperLoose(array), _step2; !(_step2 = _iterator2()).done;){
                            var item = _step2.value;
                            this.type.encode(stream, item, ctx);
                        }
                        if (this.length instanceof NumberT) {
                            var i = 0;
                            while(i < ctx.pointers.length){
                                var ptr = ctx.pointers[i++];
                                ptr.type.encode(stream, ptr.val);
                            }
                        }
                    };
                    return ArrayT;
                }();
                module1.exports = ArrayT;
            /***/ },
            /***/ 41602: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(15158);
                var Bitfield = /*#__PURE__*/ function() {
                    function Bitfield(type, flags) {
                        if (flags === void 0) flags = [];
                        this.type = type;
                        this.flags = flags;
                    }
                    var _proto = Bitfield.prototype;
                    _proto.decode = function decode(stream) {
                        var val = this.type.decode(stream);
                        var res = {};
                        for(var i = 0; i < this.flags.length; i++){
                            var flag = this.flags[i];
                            if (flag != null) res[flag] = !!(val & 1 << i);
                        }
                        return res;
                    };
                    _proto.size = function size() {
                        return this.type.size();
                    };
                    _proto.encode = function encode(stream, keys) {
                        var val = 0;
                        for(var i = 0; i < this.flags.length; i++){
                            var flag = this.flags[i];
                            if (flag != null) {
                                if (keys[flag]) val |= 1 << i;
                            }
                        }
                        return this.type.encode(stream, val);
                    };
                    return Bitfield;
                }();
                module1.exports = Bitfield;
            /***/ },
            /***/ 21210: /***/ function(module1) {
                "use strict";
                var BooleanT = /*#__PURE__*/ function() {
                    function BooleanT(type) {
                        this.type = type;
                    }
                    var _proto = BooleanT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        return !!this.type.decode(stream, parent);
                    };
                    _proto.size = function size(val, parent) {
                        return this.type.size(val, parent);
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        return this.type.encode(stream, +val, parent);
                    };
                    return BooleanT;
                }();
                module1.exports = BooleanT;
            /***/ },
            /***/ 96204: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var utils = __webpack_require__(76959);
                var _require = __webpack_require__(61002), NumberT = _require.Number;
                var BufferT = /*#__PURE__*/ function() {
                    function BufferT(length) {
                        this.length = length;
                    }
                    var _proto = BufferT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var length = utils.resolveLength(this.length, stream, parent);
                        return stream.readBuffer(length);
                    };
                    _proto.size = function size(val, parent) {
                        if (!val) return utils.resolveLength(this.length, null, parent);
                        return val.length;
                    };
                    _proto.encode = function encode(stream, buf, parent) {
                        if (this.length instanceof NumberT) this.length.encode(stream, buf.length);
                        return stream.writeBuffer(buf);
                    };
                    return BufferT;
                }();
                module1.exports = BufferT;
            /***/ },
            /***/ 42092: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                __webpack_require__(10853);
                __webpack_require__(33290);
                __webpack_require__(18821);
                __webpack_require__(39275);
                __webpack_require__(22321);
                var iconv;
                try {
                    iconv = __webpack_require__(32766);
                } catch (error) {}
                var DecodeStream = /*#__PURE__*/ function() {
                    function DecodeStream(buffer) {
                        this.buffer = buffer;
                        this.pos = 0;
                        this.length = this.buffer.length;
                    }
                    var _proto = DecodeStream.prototype;
                    _proto.readString = function readString(length, encoding) {
                        if (encoding === void 0) encoding = "ascii";
                        switch(encoding){
                            case "utf16le":
                            case "ucs2":
                            case "utf8":
                            case "ascii":
                                return this.buffer.toString(encoding, this.pos, this.pos += length);
                            case "utf16be":
                                var buf = Buffer.from(this.readBuffer(length));
                                // swap the bytes
                                for(var i = 0, end = buf.length - 1; i < end; i += 2){
                                    var byte = buf[i];
                                    buf[i] = buf[i + 1];
                                    buf[i + 1] = byte;
                                }
                                return buf.toString("utf16le");
                            default:
                                buf = this.readBuffer(length);
                                if (iconv) try {
                                    return iconv.decode(buf, encoding);
                                } catch (error1) {}
                                return buf;
                        }
                    };
                    _proto.readBuffer = function readBuffer(length) {
                        return this.buffer.slice(this.pos, this.pos += length);
                    };
                    _proto.readUInt24BE = function readUInt24BE() {
                        return (this.readUInt16BE() << 8) + this.readUInt8();
                    };
                    _proto.readUInt24LE = function readUInt24LE() {
                        return this.readUInt16LE() + (this.readUInt8() << 16);
                    };
                    _proto.readInt24BE = function readInt24BE() {
                        return (this.readInt16BE() << 8) + this.readUInt8();
                    };
                    _proto.readInt24LE = function readInt24LE() {
                        return this.readUInt16LE() + (this.readInt8() << 16);
                    };
                    return DecodeStream;
                }();
                DecodeStream.TYPES = {
                    UInt8: 1,
                    UInt16: 2,
                    UInt24: 3,
                    UInt32: 4,
                    Int8: 1,
                    Int16: 2,
                    Int24: 3,
                    Int32: 4,
                    Float: 4,
                    Double: 8
                };
                var _loop = function _loop(key) {
                    if (key.slice(0, 4) === "read") {
                        var bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, "")];
                        DecodeStream.prototype[key] = function() {
                            var ret = this.buffer[key](this.pos);
                            this.pos += bytes;
                            return ret;
                        };
                    }
                };
                for(var key in Buffer.prototype)_loop(key);
                module1.exports = DecodeStream;
            /***/ },
            /***/ 74883: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                __webpack_require__(18821);
                __webpack_require__(83382);
                __webpack_require__(39275);
                __webpack_require__(22321);
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                var iconv;
                var stream = __webpack_require__(20202);
                var DecodeStream = __webpack_require__(42092);
                try {
                    iconv = __webpack_require__(32766);
                } catch (error) {}
                var EncodeStream = /*#__PURE__*/ function(_stream$Readable) {
                    _inheritsLoose(EncodeStream, _stream$Readable);
                    function EncodeStream(bufferSize) {
                        var _this;
                        if (bufferSize === void 0) bufferSize = 65536;
                        _this = _stream$Readable.apply(this, arguments) || this;
                        _this.buffer = Buffer.alloc(bufferSize);
                        _this.bufferOffset = 0;
                        _this.pos = 0;
                        return _this;
                    }
                    // do nothing, required by node
                    var _proto = EncodeStream.prototype;
                    _proto._read = function _read() {};
                    _proto.ensure = function ensure(bytes) {
                        if (this.bufferOffset + bytes > this.buffer.length) return this.flush();
                    };
                    _proto.flush = function flush() {
                        if (this.bufferOffset > 0) {
                            this.push(Buffer.from(this.buffer.slice(0, this.bufferOffset)));
                            return this.bufferOffset = 0;
                        }
                    };
                    _proto.writeBuffer = function writeBuffer(buffer) {
                        this.flush();
                        this.push(buffer);
                        return this.pos += buffer.length;
                    };
                    _proto.writeString = function writeString(string, encoding) {
                        if (encoding === void 0) encoding = "ascii";
                        switch(encoding){
                            case "utf16le":
                            case "ucs2":
                            case "utf8":
                            case "ascii":
                                return this.writeBuffer(Buffer.from(string, encoding));
                            case "utf16be":
                                var buf = Buffer.from(string, "utf16le");
                                // swap the bytes
                                for(var i = 0, end = buf.length - 1; i < end; i += 2){
                                    var byte = buf[i];
                                    buf[i] = buf[i + 1];
                                    buf[i + 1] = byte;
                                }
                                return this.writeBuffer(buf);
                            default:
                                if (iconv) return this.writeBuffer(iconv.encode(string, encoding));
                                else throw new Error("Install iconv-lite to enable additional string encodings.");
                        }
                    };
                    _proto.writeUInt24BE = function writeUInt24BE(val) {
                        this.ensure(3);
                        this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                        this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                        this.buffer[this.bufferOffset++] = val & 0xff;
                        return this.pos += 3;
                    };
                    _proto.writeUInt24LE = function writeUInt24LE(val) {
                        this.ensure(3);
                        this.buffer[this.bufferOffset++] = val & 0xff;
                        this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                        this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                        return this.pos += 3;
                    };
                    _proto.writeInt24BE = function writeInt24BE(val) {
                        if (val >= 0) return this.writeUInt24BE(val);
                        else return this.writeUInt24BE(val + 0xffffff + 1);
                    };
                    _proto.writeInt24LE = function writeInt24LE(val) {
                        if (val >= 0) return this.writeUInt24LE(val);
                        else return this.writeUInt24LE(val + 0xffffff + 1);
                    };
                    _proto.fill = function fill(val, length) {
                        if (length < this.buffer.length) {
                            this.ensure(length);
                            this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
                            this.bufferOffset += length;
                            return this.pos += length;
                        } else {
                            var buf = Buffer.alloc(length);
                            buf.fill(val);
                            return this.writeBuffer(buf);
                        }
                    };
                    _proto.end = function end() {
                        this.flush();
                        return this.push(null);
                    };
                    return EncodeStream;
                }(stream.Readable);
                var _loop = function _loop(key) {
                    if (key.slice(0, 5) === "write") {
                        var bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, "")];
                        EncodeStream.prototype[key] = function(value) {
                            this.ensure(bytes);
                            this.buffer[key](value, this.bufferOffset);
                            this.bufferOffset += bytes;
                            return this.pos += bytes;
                        };
                    }
                };
                for(var key in Buffer.prototype)_loop(key);
                module1.exports = EncodeStream;
            /***/ },
            /***/ 2463: /***/ function(module1) {
                "use strict";
                var Enum = /*#__PURE__*/ function() {
                    function Enum(type, options) {
                        if (options === void 0) options = [];
                        this.type = type;
                        this.options = options;
                    }
                    var _proto = Enum.prototype;
                    _proto.decode = function decode(stream) {
                        var index = this.type.decode(stream);
                        return this.options[index] || index;
                    };
                    _proto.size = function size() {
                        return this.type.size();
                    };
                    _proto.encode = function encode(stream, val) {
                        var index = this.options.indexOf(val);
                        if (index === -1) throw new Error("Unknown option in enum: " + val);
                        return this.type.encode(stream, index);
                    };
                    return Enum;
                }();
                module1.exports = Enum;
            /***/ },
            /***/ 88931: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(10853);
                __webpack_require__(35054);
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                var ArrayT = __webpack_require__(23948);
                var _require = __webpack_require__(61002), NumberT = _require.Number;
                var utils = __webpack_require__(76959);
                var _require2 = __webpack_require__(85663), _inspect = _require2.inspect;
                var LazyArrayT = /*#__PURE__*/ function(_ArrayT) {
                    _inheritsLoose(LazyArrayT, _ArrayT);
                    function LazyArrayT() {
                        return _ArrayT.apply(this, arguments) || this;
                    }
                    var _proto = LazyArrayT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var pos = stream.pos;
                        var length = utils.resolveLength(this.length, stream, parent);
                        if (this.length instanceof NumberT) parent = {
                            parent: parent,
                            _startOffset: pos,
                            _currentOffset: 0,
                            _length: length
                        };
                        var res = new LazyArray(this.type, length, stream, parent);
                        stream.pos += length * this.type.size(null, parent);
                        return res;
                    };
                    _proto.size = function size(val, ctx) {
                        if (val instanceof LazyArray) val = val.toArray();
                        return _ArrayT.prototype.size.call(this, val, ctx);
                    };
                    _proto.encode = function encode(stream, val, ctx) {
                        if (val instanceof LazyArray) val = val.toArray();
                        return _ArrayT.prototype.encode.call(this, stream, val, ctx);
                    };
                    return LazyArrayT;
                }(ArrayT);
                var LazyArray = /*#__PURE__*/ function() {
                    function LazyArray(type, length, stream, ctx) {
                        this.type = type;
                        this.length = length;
                        this.stream = stream;
                        this.ctx = ctx;
                        this.base = this.stream.pos;
                        this.items = [];
                    }
                    var _proto2 = LazyArray.prototype;
                    _proto2.get = function get(index) {
                        if (index < 0 || index >= this.length) return undefined;
                        if (this.items[index] == null) {
                            var pos = this.stream.pos;
                            this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
                            this.items[index] = this.type.decode(this.stream, this.ctx);
                            this.stream.pos = pos;
                        }
                        return this.items[index];
                    };
                    _proto2.toArray = function toArray() {
                        var result = [];
                        for(var i = 0, end = this.length; i < end; i++)result.push(this.get(i));
                        return result;
                    };
                    _proto2.inspect = function inspect() {
                        return _inspect(this.toArray());
                    };
                    return LazyArray;
                }();
                module1.exports = LazyArrayT;
            /***/ },
            /***/ 61002: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                var DecodeStream = __webpack_require__(42092);
                var NumberT = /*#__PURE__*/ function() {
                    function NumberT(type, endian) {
                        if (endian === void 0) endian = "BE";
                        this.type = type;
                        this.endian = endian;
                        this.fn = this.type;
                        if (this.type[this.type.length - 1] !== "8") this.fn += this.endian;
                    }
                    var _proto = NumberT.prototype;
                    _proto.size = function size() {
                        return DecodeStream.TYPES[this.type];
                    };
                    _proto.decode = function decode(stream) {
                        return stream["read" + this.fn]();
                    };
                    _proto.encode = function encode(stream, val) {
                        return stream["write" + this.fn](val);
                    };
                    return NumberT;
                }();
                exports.Number = NumberT;
                exports.uint8 = new NumberT("UInt8");
                exports.uint16be = exports.uint16 = new NumberT("UInt16", "BE");
                exports.uint16le = new NumberT("UInt16", "LE");
                exports.uint24be = exports.uint24 = new NumberT("UInt24", "BE");
                exports.uint24le = new NumberT("UInt24", "LE");
                exports.uint32be = exports.uint32 = new NumberT("UInt32", "BE");
                exports.uint32le = new NumberT("UInt32", "LE");
                exports.int8 = new NumberT("Int8");
                exports.int16be = exports.int16 = new NumberT("Int16", "BE");
                exports.int16le = new NumberT("Int16", "LE");
                exports.int24be = exports.int24 = new NumberT("Int24", "BE");
                exports.int24le = new NumberT("Int24", "LE");
                exports.int32be = exports.int32 = new NumberT("Int32", "BE");
                exports.int32le = new NumberT("Int32", "LE");
                exports.floatbe = exports.float = new NumberT("Float", "BE");
                exports.floatle = new NumberT("Float", "LE");
                exports.doublebe = exports.double = new NumberT("Double", "BE");
                exports.doublele = new NumberT("Double", "LE");
                var Fixed = /*#__PURE__*/ function(_NumberT) {
                    _inheritsLoose(Fixed, _NumberT);
                    function Fixed(size, endian, fracBits) {
                        var _this;
                        if (fracBits === void 0) fracBits = size >> 1;
                        _this = _NumberT.call(this, "Int" + size, endian) || this;
                        _this._point = 1 << fracBits;
                        return _this;
                    }
                    var _proto2 = Fixed.prototype;
                    _proto2.decode = function decode(stream) {
                        return _NumberT.prototype.decode.call(this, stream) / this._point;
                    };
                    _proto2.encode = function encode(stream, val) {
                        return _NumberT.prototype.encode.call(this, stream, val * this._point | 0);
                    };
                    return Fixed;
                }(NumberT);
                exports.Fixed = Fixed;
                exports.fixed16be = exports.fixed16 = new Fixed(16, "BE");
                exports.fixed16le = new Fixed(16, "LE");
                exports.fixed32be = exports.fixed32 = new Fixed(32, "BE");
                exports.fixed32le = new Fixed(32, "LE");
            /***/ },
            /***/ 11568: /***/ function(module1) {
                "use strict";
                var Optional = /*#__PURE__*/ function() {
                    function Optional(type, condition) {
                        if (condition === void 0) condition = true;
                        this.type = type;
                        this.condition = condition;
                    }
                    var _proto = Optional.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var condition = this.condition;
                        if (typeof condition === "function") condition = condition.call(parent, parent);
                        if (condition) return this.type.decode(stream, parent);
                    };
                    _proto.size = function size(val, parent) {
                        var condition = this.condition;
                        if (typeof condition === "function") condition = condition.call(parent, parent);
                        if (condition) return this.type.size(val, parent);
                        else return 0;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var condition = this.condition;
                        if (typeof condition === "function") condition = condition.call(parent, parent);
                        if (condition) return this.type.encode(stream, val, parent);
                    };
                    return Optional;
                }();
                module1.exports = Optional;
            /***/ },
            /***/ 27309: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var utils = __webpack_require__(76959);
                var Pointer = /*#__PURE__*/ function() {
                    function Pointer(offsetType, type, options) {
                        if (options === void 0) options = {};
                        this.offsetType = offsetType;
                        this.type = type;
                        this.options = options;
                        if (this.type === "void") this.type = null;
                        if (this.options.type == null) this.options.type = "local";
                        if (this.options.allowNull == null) this.options.allowNull = true;
                        if (this.options.nullValue == null) this.options.nullValue = 0;
                        if (this.options.lazy == null) this.options.lazy = false;
                        if (this.options.relativeTo) {
                            if (typeof this.options.relativeTo !== "function") throw new Error("relativeTo option must be a function");
                            this.relativeToGetter = options.relativeTo;
                        }
                    }
                    var _proto = Pointer.prototype;
                    _proto.decode = function decode(stream, ctx) {
                        var _this = this;
                        var offset = this.offsetType.decode(stream, ctx);
                        // handle NULL pointers
                        if (offset === this.options.nullValue && this.options.allowNull) return null;
                        var relative;
                        switch(this.options.type){
                            case "local":
                                relative = ctx._startOffset;
                                break;
                            case "immediate":
                                relative = stream.pos - this.offsetType.size();
                                break;
                            case "parent":
                                relative = ctx.parent._startOffset;
                                break;
                            default:
                                var c = ctx;
                                while(c.parent)c = c.parent;
                                relative = c._startOffset || 0;
                        }
                        if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
                        var ptr = offset + relative;
                        if (this.type != null) {
                            var val = null;
                            var decodeValue = function decodeValue() {
                                if (val != null) return val;
                                var pos = stream.pos;
                                stream.pos = ptr;
                                val = _this.type.decode(stream, ctx);
                                stream.pos = pos;
                                return val;
                            };
                            // If this is a lazy pointer, define a getter to decode only when needed.
                            // This obviously only works when the pointer is contained by a Struct.
                            if (this.options.lazy) return new utils.PropertyDescriptor({
                                get: decodeValue
                            });
                            return decodeValue();
                        } else return ptr;
                    };
                    _proto.size = function size(val, ctx) {
                        var parent = ctx;
                        switch(this.options.type){
                            case "local":
                            case "immediate":
                                break;
                            case "parent":
                                ctx = ctx.parent;
                                break;
                            default:
                                // global
                                while(ctx.parent)ctx = ctx.parent;
                        }
                        var type = this.type;
                        if (type == null) {
                            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                            var _val = val;
                            type = _val.type;
                            val = val.value;
                        }
                        if (val && ctx) ctx.pointerSize += type.size(val, parent);
                        return this.offsetType.size();
                    };
                    _proto.encode = function encode(stream, val, ctx) {
                        var relative;
                        var parent = ctx;
                        if (val == null) {
                            this.offsetType.encode(stream, this.options.nullValue);
                            return;
                        }
                        switch(this.options.type){
                            case "local":
                                relative = ctx.startOffset;
                                break;
                            case "immediate":
                                relative = stream.pos + this.offsetType.size(val, parent);
                                break;
                            case "parent":
                                ctx = ctx.parent;
                                relative = ctx.startOffset;
                                break;
                            default:
                                // global
                                relative = 0;
                                while(ctx.parent)ctx = ctx.parent;
                        }
                        if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
                        this.offsetType.encode(stream, ctx.pointerOffset - relative);
                        var type = this.type;
                        if (type == null) {
                            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                            var _val2 = val;
                            type = _val2.type;
                            val = val.value;
                        }
                        ctx.pointers.push({
                            type: type,
                            val: val,
                            parent: parent
                        });
                        return ctx.pointerOffset += type.size(val, parent);
                    };
                    return Pointer;
                }(); // A pointer whose type is determined at decode time
                var VoidPointer = function VoidPointer(type, value) {
                    this.type = type;
                    this.value = value;
                };
                exports.Pointer = Pointer;
                exports.VoidPointer = VoidPointer;
            /***/ },
            /***/ 62211: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(83382);
                var utils = __webpack_require__(76959);
                var Reserved = /*#__PURE__*/ function() {
                    function Reserved(type, count) {
                        if (count === void 0) count = 1;
                        this.type = type;
                        this.count = count;
                    }
                    var _proto = Reserved.prototype;
                    _proto.decode = function decode(stream, parent) {
                        stream.pos += this.size(null, parent);
                        return undefined;
                    };
                    _proto.size = function size(data, parent) {
                        var count = utils.resolveLength(this.count, null, parent);
                        return this.type.size() * count;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        return stream.fill(0, this.size(val, parent));
                    };
                    return Reserved;
                }();
                module1.exports = Reserved;
            /***/ },
            /***/ 69046: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                var _require = __webpack_require__(61002), NumberT = _require.Number;
                var utils = __webpack_require__(76959);
                var StringT = /*#__PURE__*/ function() {
                    function StringT(length, encoding) {
                        if (encoding === void 0) encoding = "ascii";
                        this.length = length;
                        this.encoding = encoding;
                    }
                    var _proto = StringT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var length, pos;
                        if (this.length != null) length = utils.resolveLength(this.length, stream, parent);
                        else {
                            var buffer;
                            buffer = stream.buffer;
                            length = stream.length;
                            pos = stream.pos;
                            while(pos < length && buffer[pos] !== 0x00)++pos;
                            length = pos - stream.pos;
                        }
                        var encoding = this.encoding;
                        if (typeof encoding === "function") encoding = encoding.call(parent, parent) || "ascii";
                        var string = stream.readString(length, encoding);
                        if (this.length == null && stream.pos < stream.length) stream.pos++;
                        return string;
                    };
                    _proto.size = function size(val, parent) {
                        // Use the defined value if no value was given
                        if (!val) return utils.resolveLength(this.length, null, parent);
                        var encoding = this.encoding;
                        if (typeof encoding === "function") encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || "ascii";
                        if (encoding === "utf16be") encoding = "utf16le";
                        var size = Buffer.byteLength(val, encoding);
                        if (this.length instanceof NumberT) size += this.length.size();
                        if (this.length == null) size++;
                        return size;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var encoding = this.encoding;
                        if (typeof encoding === "function") encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || "ascii";
                        if (this.length instanceof NumberT) this.length.encode(stream, Buffer.byteLength(val, encoding));
                        stream.writeString(val, encoding);
                        if (this.length == null) return stream.writeUInt8(0x00);
                    };
                    return StringT;
                }();
                module1.exports = StringT;
            /***/ },
            /***/ 90433: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var utils = __webpack_require__(76959);
                var Struct = /*#__PURE__*/ function() {
                    function Struct(fields) {
                        if (fields === void 0) fields = {};
                        this.fields = fields;
                    }
                    var _proto = Struct.prototype;
                    _proto.decode = function decode(stream, parent, length) {
                        if (length === void 0) length = 0;
                        var res = this._setup(stream, parent, length);
                        this._parseFields(stream, res, this.fields);
                        if (this.process != null) this.process.call(res, stream);
                        return res;
                    };
                    _proto._setup = function _setup(stream, parent, length) {
                        var res = {};
                        // define hidden properties
                        Object.defineProperties(res, {
                            parent: {
                                value: parent
                            },
                            _startOffset: {
                                value: stream.pos
                            },
                            _currentOffset: {
                                value: 0,
                                writable: true
                            },
                            _length: {
                                value: length
                            }
                        });
                        return res;
                    };
                    _proto._parseFields = function _parseFields(stream, res, fields) {
                        for(var key in fields){
                            var val;
                            var type = fields[key];
                            if (typeof type === "function") val = type.call(res, res);
                            else val = type.decode(stream, res);
                            if (val !== undefined) {
                                if (val instanceof utils.PropertyDescriptor) Object.defineProperty(res, key, val);
                                else res[key] = val;
                            }
                            res._currentOffset = stream.pos - res._startOffset;
                        }
                    };
                    _proto.size = function size(val, parent, includePointers) {
                        if (val == null) val = {};
                        if (includePointers == null) includePointers = true;
                        var ctx = {
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        var size = 0;
                        for(var key in this.fields){
                            var type = this.fields[key];
                            if (type.size != null) size += type.size(val[key], ctx);
                        }
                        if (includePointers) size += ctx.pointerSize;
                        return size;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var type;
                        if (this.preEncode != null) this.preEncode.call(val, stream);
                        var ctx = {
                            pointers: [],
                            startOffset: stream.pos,
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                        for(var key in this.fields){
                            type = this.fields[key];
                            if (type.encode != null) type.encode(stream, val[key], ctx);
                        }
                        var i = 0;
                        while(i < ctx.pointers.length){
                            var ptr = ctx.pointers[i++];
                            ptr.type.encode(stream, ptr.val, ptr.parent);
                        }
                    };
                    return Struct;
                }();
                module1.exports = Struct;
            /***/ },
            /***/ 37529: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(10853);
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                var Struct = __webpack_require__(90433);
                var getPath = function getPath(object, pathArray) {
                    return pathArray.reduce(function(prevObj, key) {
                        return prevObj && prevObj[key];
                    }, object);
                };
                var VersionedStruct = /*#__PURE__*/ function(_Struct) {
                    _inheritsLoose(VersionedStruct, _Struct);
                    function VersionedStruct(type, versions) {
                        var _this;
                        if (versions === void 0) versions = {};
                        _this = _Struct.call(this) || this;
                        _this.type = type;
                        _this.versions = versions;
                        if (typeof type === "string") _this.versionPath = type.split(".");
                        return _this;
                    }
                    var _proto = VersionedStruct.prototype;
                    _proto.decode = function decode(stream, parent, length) {
                        if (length === void 0) length = 0;
                        var res = this._setup(stream, parent, length);
                        if (typeof this.type === "string") res.version = getPath(parent, this.versionPath);
                        else res.version = this.type.decode(stream);
                        if (this.versions.header) this._parseFields(stream, res, this.versions.header);
                        var fields = this.versions[res.version];
                        if (fields == null) throw new Error("Unknown version " + res.version);
                        if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
                        this._parseFields(stream, res, fields);
                        if (this.process != null) this.process.call(res, stream);
                        return res;
                    };
                    _proto.size = function size(val, parent, includePointers) {
                        if (includePointers === void 0) includePointers = true;
                        var key, type;
                        if (!val) throw new Error("Not a fixed size");
                        var ctx = {
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        var size = 0;
                        if (typeof this.type !== "string") size += this.type.size(val.version, ctx);
                        if (this.versions.header) for(key in this.versions.header){
                            type = this.versions.header[key];
                            if (type.size != null) size += type.size(val[key], ctx);
                        }
                        var fields = this.versions[val.version];
                        if (fields == null) throw new Error("Unknown version " + val.version);
                        for(key in fields){
                            type = fields[key];
                            if (type.size != null) size += type.size(val[key], ctx);
                        }
                        if (includePointers) size += ctx.pointerSize;
                        return size;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var key, type;
                        if (this.preEncode != null) this.preEncode.call(val, stream);
                        var ctx = {
                            pointers: [],
                            startOffset: stream.pos,
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                        if (typeof this.type !== "string") this.type.encode(stream, val.version);
                        if (this.versions.header) for(key in this.versions.header){
                            type = this.versions.header[key];
                            if (type.encode != null) type.encode(stream, val[key], ctx);
                        }
                        var fields = this.versions[val.version];
                        for(key in fields){
                            type = fields[key];
                            if (type.encode != null) type.encode(stream, val[key], ctx);
                        }
                        var i = 0;
                        while(i < ctx.pointers.length){
                            var ptr = ctx.pointers[i++];
                            ptr.type.encode(stream, ptr.val, ptr.parent);
                        }
                    };
                    return VersionedStruct;
                }(Struct);
                module1.exports = VersionedStruct;
            /***/ },
            /***/ 76959: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _require = __webpack_require__(61002), NumberT = _require.Number;
                exports.resolveLength = function(length, stream, parent) {
                    var res;
                    if (typeof length === "number") res = length;
                    else if (typeof length === "function") res = length.call(parent, parent);
                    else if (parent && typeof length === "string") res = parent[length];
                    else if (stream && length instanceof NumberT) res = length.decode(stream);
                    if (isNaN(res)) throw new Error("Not a fixed size");
                    return res;
                };
                var PropertyDescriptor = function PropertyDescriptor(opts) {
                    if (opts === void 0) opts = {};
                    this.enumerable = true;
                    this.configurable = true;
                    for(var key in opts){
                        var val = opts[key];
                        this[key] = val;
                    }
                };
                exports.PropertyDescriptor = PropertyDescriptor;
            /***/ },
            /***/ 43060: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ __webpack_require__(26364);
                __webpack_require__(86632);
                __webpack_require__(10853);
                __webpack_require__(54883);
                __webpack_require__(79627);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(36501);
                __webpack_require__(16543);
                __webpack_require__(33142);
                __webpack_require__(83382);
                __webpack_require__(18821);
                __webpack_require__(33290);
                __webpack_require__(55862);
                __webpack_require__(29897);
                __webpack_require__(39275);
                __webpack_require__(22321);
                __webpack_require__(18183);
                __webpack_require__(19985);
                __webpack_require__(80174);
                __webpack_require__(87191);
                __webpack_require__(42833);
                __webpack_require__(54994);
                __webpack_require__(35727);
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == typeof i ? i : String(i);
                }
                function _toPrimitive(t, r) {
                    if ("object" != typeof t || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                var base64 = __webpack_require__(5155);
                var ieee754 = __webpack_require__(74525);
                var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
                 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
                 : null;
                exports.Buffer = Buffer;
                exports.SlowBuffer = SlowBuffer;
                exports.INSPECT_MAX_BYTES = 50;
                var K_MAX_LENGTH = 0x7fffffff;
                exports.kMaxLength = K_MAX_LENGTH;
                /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                function typedArraySupport() {
                    // Can typed array instances can be augmented?
                    try {
                        var arr = new Uint8Array(1);
                        var proto = {
                            foo: function foo() {
                                return 42;
                            }
                        };
                        Object.setPrototypeOf(proto, Uint8Array.prototype);
                        Object.setPrototypeOf(arr, proto);
                        return arr.foo() === 42;
                    } catch (e) {
                        return false;
                    }
                }
                Object.defineProperty(Buffer.prototype, "parent", {
                    enumerable: true,
                    get: function get() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.buffer;
                    }
                });
                Object.defineProperty(Buffer.prototype, "offset", {
                    enumerable: true,
                    get: function get() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.byteOffset;
                    }
                });
                function createBuffer(length) {
                    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                    // Return an augmented `Uint8Array` instance
                    var buf = new Uint8Array(length);
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                    // Common case.
                    if (typeof arg === "number") {
                        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                        return allocUnsafe(arg);
                    }
                    return from(arg, encodingOrOffset, length);
                }
                Buffer.poolSize = 8192; // not used by this implementation
                function from(value, encodingOrOffset, length) {
                    if (typeof value === "string") return fromString(value, encodingOrOffset);
                    if (ArrayBuffer.isView(value)) return fromArrayView(value);
                    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                    var valueOf = value.valueOf && value.valueOf();
                    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                    var b = fromObject(value);
                    if (b) return b;
                    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                }
                /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                    return from(value, encodingOrOffset, length);
                };
                // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                // https://github.com/feross/buffer/pull/148
                Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
                Object.setPrototypeOf(Buffer, Uint8Array);
                function assertSize(size) {
                    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
                    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                }
                function alloc(size, fill, encoding) {
                    assertSize(size);
                    if (size <= 0) return createBuffer(size);
                    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                    // prevents accidentally sending in a number that would
                    // be interpreted as a start offset.
                    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                    return createBuffer(size);
                }
                /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                    return alloc(size, fill, encoding);
                };
                function allocUnsafe(size) {
                    assertSize(size);
                    return createBuffer(size < 0 ? 0 : checked(size) | 0);
                }
                /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                    return allocUnsafe(size);
                };
                /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                    return allocUnsafe(size);
                };
                function fromString(string, encoding) {
                    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
                    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                    var length = byteLength(string, encoding) | 0;
                    var buf = createBuffer(length);
                    var actual = buf.write(string, encoding);
                    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                    // cause everything after the first invalid character to be ignored. (e.g.
                    // 'abxxcd' will be treated as 'ab')
                    buf = buf.slice(0, actual);
                    return buf;
                }
                function fromArrayLike(array) {
                    var length = array.length < 0 ? 0 : checked(array.length) | 0;
                    var buf = createBuffer(length);
                    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                    return buf;
                }
                function fromArrayView(arrayView) {
                    if (isInstance(arrayView, Uint8Array)) {
                        var copy = new Uint8Array(arrayView);
                        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
                    }
                    return fromArrayLike(arrayView);
                }
                function fromArrayBuffer(array, byteOffset, length) {
                    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                    var buf;
                    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                    else buf = new Uint8Array(array, byteOffset, length);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                function fromObject(obj) {
                    if (Buffer.isBuffer(obj)) {
                        var len = checked(obj.length) | 0;
                        var buf = createBuffer(len);
                        if (buf.length === 0) return buf;
                        obj.copy(buf, 0, 0, len);
                        return buf;
                    }
                    if (obj.length !== undefined) {
                        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                        return fromArrayLike(obj);
                    }
                    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                }
                function checked(length) {
                    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                    // length is NaN (which is otherwise coerced to zero.)
                    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
                    return length | 0;
                }
                function SlowBuffer(length) {
                    if (+length != length) // eslint-disable-line eqeqeq
                    length = 0;
                    return Buffer.alloc(+length);
                }
                Buffer.isBuffer = function isBuffer(b) {
                    return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
                };
                Buffer.compare = function compare(a, b) {
                    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                Buffer.isEncoding = function isEncoding(encoding) {
                    switch(String(encoding).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return true;
                        default:
                            return false;
                    }
                };
                Buffer.concat = function concat(list, length) {
                    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (list.length === 0) return Buffer.alloc(0);
                    var i;
                    if (length === undefined) {
                        length = 0;
                        for(i = 0; i < list.length; ++i)length += list[i].length;
                    }
                    var buffer = Buffer.allocUnsafe(length);
                    var pos = 0;
                    for(i = 0; i < list.length; ++i){
                        var buf = list[i];
                        if (isInstance(buf, Uint8Array)) {
                            if (pos + buf.length > buffer.length) {
                                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                                buf.copy(buffer, pos);
                            } else Uint8Array.prototype.set.call(buffer, buf, pos);
                        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                        else buf.copy(buffer, pos);
                        pos += buf.length;
                    }
                    return buffer;
                };
                function byteLength(string, encoding) {
                    if (Buffer.isBuffer(string)) return string.length;
                    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                    var len = string.length;
                    var mustMatch = arguments.length > 2 && arguments[2] === true;
                    if (!mustMatch && len === 0) return 0;
                    // Use a for loop to avoid recursion
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return len;
                        case "utf8":
                        case "utf-8":
                            return utf8ToBytes(string).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return len * 2;
                        case "hex":
                            return len >>> 1;
                        case "base64":
                            return base64ToBytes(string).length;
                        default:
                            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                            encoding = ("" + encoding).toLowerCase();
                            loweredCase = true;
                    }
                }
                Buffer.byteLength = byteLength;
                function slowToString(encoding, start, end) {
                    var loweredCase = false;
                    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                    // property of a typed array.
                    // This behaves neither like String nor Uint8Array in that we set start/end
                    // to their upper/lower bounds if the value passed is out of range.
                    // undefined is handled specially as per ECMA-262 6th Edition,
                    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                    if (start === undefined || start < 0) start = 0;
                    // Return early if start > this.length. Done here to prevent potential uint32
                    // coercion fail below.
                    if (start > this.length) return "";
                    if (end === undefined || end > this.length) end = this.length;
                    if (end <= 0) return "";
                    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
                    end >>>= 0;
                    start >>>= 0;
                    if (end <= start) return "";
                    if (!encoding) encoding = "utf8";
                    while(true)switch(encoding){
                        case "hex":
                            return hexSlice(this, start, end);
                        case "utf8":
                        case "utf-8":
                            return utf8Slice(this, start, end);
                        case "ascii":
                            return asciiSlice(this, start, end);
                        case "latin1":
                        case "binary":
                            return latin1Slice(this, start, end);
                        case "base64":
                            return base64Slice(this, start, end);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return utf16leSlice(this, start, end);
                        default:
                            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                            encoding = (encoding + "").toLowerCase();
                            loweredCase = true;
                    }
                }
                // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                // reliably in a browserify context because there could be multiple different
                // copies of the 'buffer' package in use. This method works even for Buffer
                // instances that were created from another copy of the `buffer` package.
                // See: https://github.com/feross/buffer/issues/154
                Buffer.prototype._isBuffer = true;
                function swap(b, n, m) {
                    var i = b[n];
                    b[n] = b[m];
                    b[m] = i;
                }
                Buffer.prototype.swap16 = function swap16() {
                    var len = this.length;
                    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                    return this;
                };
                Buffer.prototype.swap32 = function swap32() {
                    var len = this.length;
                    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(var i = 0; i < len; i += 4){
                        swap(this, i, i + 3);
                        swap(this, i + 1, i + 2);
                    }
                    return this;
                };
                Buffer.prototype.swap64 = function swap64() {
                    var len = this.length;
                    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(var i = 0; i < len; i += 8){
                        swap(this, i, i + 7);
                        swap(this, i + 1, i + 6);
                        swap(this, i + 2, i + 5);
                        swap(this, i + 3, i + 4);
                    }
                    return this;
                };
                Buffer.prototype.toString = function toString() {
                    var length = this.length;
                    if (length === 0) return "";
                    if (arguments.length === 0) return utf8Slice(this, 0, length);
                    return slowToString.apply(this, arguments);
                };
                Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                Buffer.prototype.equals = function equals(b) {
                    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
                    if (this === b) return true;
                    return Buffer.compare(this, b) === 0;
                };
                Buffer.prototype.inspect = function inspect() {
                    var str = "";
                    var max = exports.INSPECT_MAX_BYTES;
                    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
                    if (this.length > max) str += " ... ";
                    return "<Buffer " + str + ">";
                };
                if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
                Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                    if (start === undefined) start = 0;
                    if (end === undefined) end = target ? target.length : 0;
                    if (thisStart === undefined) thisStart = 0;
                    if (thisEnd === undefined) thisEnd = this.length;
                    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
                    if (thisStart >= thisEnd && start >= end) return 0;
                    if (thisStart >= thisEnd) return -1;
                    if (start >= end) return 1;
                    start >>>= 0;
                    end >>>= 0;
                    thisStart >>>= 0;
                    thisEnd >>>= 0;
                    if (this === target) return 0;
                    var x = thisEnd - thisStart;
                    var y = end - start;
                    var len = Math.min(x, y);
                    var thisCopy = this.slice(thisStart, thisEnd);
                    var targetCopy = target.slice(start, end);
                    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                        x = thisCopy[i];
                        y = targetCopy[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                //
                // Arguments:
                // - buffer - a Buffer to search
                // - val - a string, Buffer, or number
                // - byteOffset - an index into `buffer`; will be clamped to an int32
                // - encoding - an optional encoding, relevant is val is a string
                // - dir - true for indexOf, false for lastIndexOf
                function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                    // Empty buffer means no match
                    if (buffer.length === 0) return -1;
                    // Normalize byteOffset
                    if (typeof byteOffset === "string") {
                        encoding = byteOffset;
                        byteOffset = 0;
                    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                    else if (byteOffset < -2147483648) byteOffset = -2147483648;
                    byteOffset = +byteOffset; // Coerce to Number.
                    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                    byteOffset = dir ? 0 : buffer.length - 1;
                    // Normalize byteOffset: negative offsets start from the end of the buffer
                    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                    if (byteOffset >= buffer.length) {
                        if (dir) return -1;
                        else byteOffset = buffer.length - 1;
                    } else if (byteOffset < 0) {
                        if (dir) byteOffset = 0;
                        else return -1;
                    }
                    // Normalize val
                    if (typeof val === "string") val = Buffer.from(val, encoding);
                    // Finally, search either indexOf (if dir is true) or lastIndexOf
                    if (Buffer.isBuffer(val)) {
                        // Special case: looking for empty string/buffer always fails
                        if (val.length === 0) return -1;
                        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                    } else if (typeof val === "number") {
                        val = val & 0xFF; // Search for a byte value [0-255]
                        if (typeof Uint8Array.prototype.indexOf === "function") {
                            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                        }
                        return arrayIndexOf(buffer, [
                            val
                        ], byteOffset, encoding, dir);
                    }
                    throw new TypeError("val must be string, number or Buffer");
                }
                function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                    var indexSize = 1;
                    var arrLength = arr.length;
                    var valLength = val.length;
                    if (encoding !== undefined) {
                        encoding = String(encoding).toLowerCase();
                        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                            if (arr.length < 2 || val.length < 2) return -1;
                            indexSize = 2;
                            arrLength /= 2;
                            valLength /= 2;
                            byteOffset /= 2;
                        }
                    }
                    function read(buf, i) {
                        if (indexSize === 1) return buf[i];
                        else return buf.readUInt16BE(i * indexSize);
                    }
                    var i;
                    if (dir) {
                        var foundIndex = -1;
                        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                            if (foundIndex === -1) foundIndex = i;
                            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                        } else {
                            if (foundIndex !== -1) i -= i - foundIndex;
                            foundIndex = -1;
                        }
                    } else {
                        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                        for(i = byteOffset; i >= 0; i--){
                            var found = true;
                            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                found = false;
                                break;
                            }
                            if (found) return i;
                        }
                    }
                    return -1;
                }
                Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                    return this.indexOf(val, byteOffset, encoding) !== -1;
                };
                Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                };
                Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                };
                function hexWrite(buf, string, offset, length) {
                    offset = Number(offset) || 0;
                    var remaining = buf.length - offset;
                    if (!length) length = remaining;
                    else {
                        length = Number(length);
                        if (length > remaining) length = remaining;
                    }
                    var strLen = string.length;
                    if (length > strLen / 2) length = strLen / 2;
                    var i;
                    for(i = 0; i < length; ++i){
                        var parsed = parseInt(string.substr(i * 2, 2), 16);
                        if (numberIsNaN(parsed)) return i;
                        buf[offset + i] = parsed;
                    }
                    return i;
                }
                function utf8Write(buf, string, offset, length) {
                    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                }
                function asciiWrite(buf, string, offset, length) {
                    return blitBuffer(asciiToBytes(string), buf, offset, length);
                }
                function base64Write(buf, string, offset, length) {
                    return blitBuffer(base64ToBytes(string), buf, offset, length);
                }
                function ucs2Write(buf, string, offset, length) {
                    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                }
                Buffer.prototype.write = function write(string, offset, length, encoding) {
                    // Buffer#write(string)
                    if (offset === undefined) {
                        encoding = "utf8";
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, encoding)
                    } else if (length === undefined && typeof offset === "string") {
                        encoding = offset;
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, offset[, length][, encoding])
                    } else if (isFinite(offset)) {
                        offset = offset >>> 0;
                        if (isFinite(length)) {
                            length = length >>> 0;
                            if (encoding === undefined) encoding = "utf8";
                        } else {
                            encoding = length;
                            length = undefined;
                        }
                    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                    var remaining = this.length - offset;
                    if (length === undefined || length > remaining) length = remaining;
                    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    if (!encoding) encoding = "utf8";
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case "hex":
                            return hexWrite(this, string, offset, length);
                        case "utf8":
                        case "utf-8":
                            return utf8Write(this, string, offset, length);
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return asciiWrite(this, string, offset, length);
                        case "base64":
                            // Warning: maxLength not taken into account in base64Write
                            return base64Write(this, string, offset, length);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return ucs2Write(this, string, offset, length);
                        default:
                            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                            encoding = ("" + encoding).toLowerCase();
                            loweredCase = true;
                    }
                };
                Buffer.prototype.toJSON = function toJSON() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                function base64Slice(buf, start, end) {
                    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                    else return base64.fromByteArray(buf.slice(start, end));
                }
                function utf8Slice(buf, start, end) {
                    end = Math.min(buf.length, end);
                    var res = [];
                    var i = start;
                    while(i < end){
                        var firstByte = buf[i];
                        var codePoint = null;
                        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                        if (i + bytesPerSequence <= end) {
                            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
                            switch(bytesPerSequence){
                                case 1:
                                    if (firstByte < 0x80) codePoint = firstByte;
                                    break;
                                case 2:
                                    secondByte = buf[i + 1];
                                    if ((secondByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 3:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 4:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    fourthByte = buf[i + 3];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                    }
                            }
                        }
                        if (codePoint === null) {
                            // we did not generate a valid codePoint so insert a
                            // replacement char (U+FFFD) and advance only 1 byte
                            codePoint = 0xFFFD;
                            bytesPerSequence = 1;
                        } else if (codePoint > 0xFFFF) {
                            // encode to utf16 (surrogate pair dance)
                            codePoint -= 0x10000;
                            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                            codePoint = 0xDC00 | codePoint & 0x3FF;
                        }
                        res.push(codePoint);
                        i += bytesPerSequence;
                    }
                    return decodeCodePointsArray(res);
                }
                // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                // the lowest limit is Chrome, with 0x10000 args.
                // We go 1 magnitude less, for safety
                var MAX_ARGUMENTS_LENGTH = 0x1000;
                function decodeCodePointsArray(codePoints) {
                    var len = codePoints.length;
                    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
                    // Decode in chunks to avoid "call stack size exceeded".
                    var res = "";
                    var i = 0;
                    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                    return res;
                }
                function asciiSlice(buf, start, end) {
                    var ret = "";
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                    return ret;
                }
                function latin1Slice(buf, start, end) {
                    var ret = "";
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                    return ret;
                }
                function hexSlice(buf, start, end) {
                    var len = buf.length;
                    if (!start || start < 0) start = 0;
                    if (!end || end < 0 || end > len) end = len;
                    var out = "";
                    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
                    return out;
                }
                function utf16leSlice(buf, start, end) {
                    var bytes = buf.slice(start, end);
                    var res = "";
                    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
                    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                    return res;
                }
                Buffer.prototype.slice = function slice(start, end) {
                    var len = this.length;
                    start = ~~start;
                    end = end === undefined ? len : ~~end;
                    if (start < 0) {
                        start += len;
                        if (start < 0) start = 0;
                    } else if (start > len) start = len;
                    if (end < 0) {
                        end += len;
                        if (end < 0) end = 0;
                    } else if (end > len) end = len;
                    if (end < start) end = start;
                    var newBuf = this.subarray(start, end);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(newBuf, Buffer.prototype);
                    return newBuf;
                };
                /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
                    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
                }
                Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    return val;
                };
                Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset + --byteLength];
                    var mul = 1;
                    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                    return val;
                };
                Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    return this[offset];
                };
                Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] | this[offset + 1] << 8;
                };
                Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] << 8 | this[offset + 1];
                };
                Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                };
                Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                };
                Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, "offset");
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
                    var hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
                    return BigInt(lo) + (BigInt(hi) << BigInt(32));
                });
                Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, "offset");
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
                    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
                    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
                });
                Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var i = byteLength;
                    var mul = 1;
                    var val = this[offset + --i];
                    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    if (!(this[offset] & 0x80)) return this[offset];
                    return (0xff - this[offset] + 1) * -1;
                };
                Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset] | this[offset + 1] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset + 1] | this[offset] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                };
                Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                };
                Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, "offset");
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24); // Overflow
                    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
                });
                Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, "offset");
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var val = (first << 24) + // Overflow
                    this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
                    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
                });
                Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, true, 23, 4);
                };
                Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, false, 23, 4);
                };
                Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, true, 52, 8);
                };
                Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, false, 52, 8);
                };
                function checkInt(buf, value, offset, ext, max, min) {
                    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                    if (offset + ext > buf.length) throw new RangeError("Index out of range");
                }
                Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var mul = 1;
                    var i = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset + 3] = value >>> 24;
                    this[offset + 2] = value >>> 16;
                    this[offset + 1] = value >>> 8;
                    this[offset] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                function wrtBigUInt64LE(buf, value, offset, min, max) {
                    checkIntBI(value, min, max, buf, offset, 7);
                    var lo = Number(value & BigInt(0xffffffff));
                    buf[offset++] = lo;
                    lo = lo >> 8;
                    buf[offset++] = lo;
                    lo = lo >> 8;
                    buf[offset++] = lo;
                    lo = lo >> 8;
                    buf[offset++] = lo;
                    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
                    buf[offset++] = hi;
                    hi = hi >> 8;
                    buf[offset++] = hi;
                    hi = hi >> 8;
                    buf[offset++] = hi;
                    hi = hi >> 8;
                    buf[offset++] = hi;
                    return offset;
                }
                function wrtBigUInt64BE(buf, value, offset, min, max) {
                    checkIntBI(value, min, max, buf, offset, 7);
                    var lo = Number(value & BigInt(0xffffffff));
                    buf[offset + 7] = lo;
                    lo = lo >> 8;
                    buf[offset + 6] = lo;
                    lo = lo >> 8;
                    buf[offset + 5] = lo;
                    lo = lo >> 8;
                    buf[offset + 4] = lo;
                    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
                    buf[offset + 3] = hi;
                    hi = hi >> 8;
                    buf[offset + 2] = hi;
                    hi = hi >> 8;
                    buf[offset + 1] = hi;
                    hi = hi >> 8;
                    buf[offset] = hi;
                    return offset + 8;
                }
                Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
                });
                Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
                });
                Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = 0;
                    var mul = 1;
                    var sub = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    var sub = 0;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                    if (value < 0) value = 0xff + value + 1;
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    this[offset + 2] = value >>> 16;
                    this[offset + 3] = value >>> 24;
                    return offset + 4;
                };
                Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    if (value < 0) value = 0xffffffff + value + 1;
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                });
                Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                });
                function checkIEEE754(buf, value, offset, ext, max, min) {
                    if (offset + ext > buf.length) throw new RangeError("Index out of range");
                    if (offset < 0) throw new RangeError("Index out of range");
                }
                function writeFloat(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 23, 4);
                    return offset + 4;
                }
                Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, false, noAssert);
                };
                function writeDouble(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 52, 8);
                    return offset + 8;
                }
                Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, false, noAssert);
                };
                // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
                    if (!start) start = 0;
                    if (!end && end !== 0) end = this.length;
                    if (targetStart >= target.length) targetStart = target.length;
                    if (!targetStart) targetStart = 0;
                    if (end > 0 && end < start) end = start;
                    // Copy 0 bytes; we're done
                    if (end === start) return 0;
                    if (target.length === 0 || this.length === 0) return 0;
                    // Fatal error conditions
                    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
                    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
                    if (end < 0) throw new RangeError("sourceEnd out of bounds");
                    // Are we oob?
                    if (end > this.length) end = this.length;
                    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                    var len = end - start;
                    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
                    this.copyWithin(targetStart, start, end);
                    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                    return len;
                };
                // Usage:
                //    buffer.fill(number[, offset[, end]])
                //    buffer.fill(buffer[, offset[, end]])
                //    buffer.fill(string[, offset[, end]][, encoding])
                Buffer.prototype.fill = function fill(val, start, end, encoding) {
                    // Handle string cases:
                    if (typeof val === "string") {
                        if (typeof start === "string") {
                            encoding = start;
                            start = 0;
                            end = this.length;
                        } else if (typeof end === "string") {
                            encoding = end;
                            end = this.length;
                        }
                        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                        if (val.length === 1) {
                            var code = val.charCodeAt(0);
                            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                            val = code;
                        }
                    } else if (typeof val === "number") val = val & 255;
                    else if (typeof val === "boolean") val = Number(val);
                    // Invalid ranges are not set to a default, so can range check early.
                    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
                    if (end <= start) return this;
                    start = start >>> 0;
                    end = end === undefined ? this.length : end >>> 0;
                    if (!val) val = 0;
                    var i;
                    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
                    else {
                        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                        var len = bytes.length;
                        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                    }
                    return this;
                };
                // CUSTOM ERRORS
                // =============
                // Simplified versions from Node, changed for Buffer-only usage
                var errors = {};
                function E(sym, getMessage, Base) {
                    errors[sym] = /*#__PURE__*/ function(_Base) {
                        _inheritsLoose(NodeError, _Base);
                        function NodeError() {
                            var _this;
                            _this = _Base.call(this) || this;
                            Object.defineProperty(_assertThisInitialized(_this), "message", {
                                value: getMessage.apply(_assertThisInitialized(_this), arguments),
                                writable: true,
                                configurable: true
                            });
                            // Add the error code to the name to include it in the stack trace.
                            _this.name = _this.name + " [" + sym + "]";
                            // Access the stack to generate the error message including the error code
                            // from the name.
                            _this.stack; // eslint-disable-line no-unused-expressions
                            // Reset the name to the actual name.
                            delete _this.name;
                            return _this;
                        }
                        var _proto = NodeError.prototype;
                        _proto.toString = function toString() {
                            return this.name + " [" + sym + "]: " + this.message;
                        };
                        _createClass(NodeError, [
                            {
                                key: "code",
                                get: function get() {
                                    return sym;
                                },
                                set: function set(value) {
                                    Object.defineProperty(this, "code", {
                                        configurable: true,
                                        enumerable: true,
                                        value: value,
                                        writable: true
                                    });
                                }
                            }
                        ]);
                        return NodeError;
                    }(Base);
                }
                E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
                    if (name) return name + " is outside of buffer bounds";
                    return "Attempt to access memory outside buffer bounds";
                }, RangeError);
                E("ERR_INVALID_ARG_TYPE", function(name, actual) {
                    return 'The "' + name + '" argument must be of type number. Received type ' + typeof actual;
                }, TypeError);
                E("ERR_OUT_OF_RANGE", function(str, range, input) {
                    var msg = 'The value of "' + str + '" is out of range.';
                    var received = input;
                    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = addNumericalSeparator(String(input));
                    else if (typeof input === "bigint") {
                        received = String(input);
                        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = addNumericalSeparator(received);
                        received += "n";
                    }
                    msg += " It must be " + range + ". Received " + received;
                    return msg;
                }, RangeError);
                function addNumericalSeparator(val) {
                    var res = "";
                    var i = val.length;
                    var start = val[0] === "-" ? 1 : 0;
                    for(; i >= start + 4; i -= 3)res = "_" + val.slice(i - 3, i) + res;
                    return "" + val.slice(0, i) + res;
                }
                // CHECK FUNCTIONS
                // ===============
                function checkBounds(buf, offset, byteLength) {
                    validateNumber(offset, "offset");
                    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
                }
                function checkIntBI(value, min, max, buf, offset, byteLength) {
                    if (value > max || value < min) {
                        var n = typeof min === "bigint" ? "n" : "";
                        var range;
                        if (byteLength > 3) {
                            if (min === 0 || min === BigInt(0)) range = ">= 0" + n + " and < 2" + n + " ** " + (byteLength + 1) * 8 + n;
                            else range = ">= -(2" + n + " ** " + ((byteLength + 1) * 8 - 1) + n + ") and < 2 ** " + ("" + ((byteLength + 1) * 8 - 1) + n);
                        } else range = ">= " + min + n + " and <= " + max + n;
                        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
                    }
                    checkBounds(buf, offset, byteLength);
                }
                function validateNumber(value, name) {
                    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
                }
                function boundsError(value, length, type) {
                    if (Math.floor(value) !== value) {
                        validateNumber(value, type);
                        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
                    }
                    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
                    throw new errors.ERR_OUT_OF_RANGE(type || "offset", ">= " + (type ? 1 : 0) + " and <= " + length, value);
                }
                // HELPER FUNCTIONS
                // ================
                var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                function base64clean(str) {
                    // Node takes equal signs as end of the Base64 encoding
                    str = str.split("=")[0];
                    // Node strips out invalid characters like \n and \t from the string, base64-js does not
                    str = str.trim().replace(INVALID_BASE64_RE, "");
                    // Node converts strings with length < 2 to ''
                    if (str.length < 2) return "";
                    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                    while(str.length % 4 !== 0)str = str + "=";
                    return str;
                }
                function utf8ToBytes(string, units) {
                    units = units || Infinity;
                    var codePoint;
                    var length = string.length;
                    var leadSurrogate = null;
                    var bytes = [];
                    for(var i = 0; i < length; ++i){
                        codePoint = string.charCodeAt(i);
                        // is surrogate component
                        if (codePoint > 0xD7FF && codePoint < 0xE000) {
                            // last char was a lead
                            if (!leadSurrogate) {
                                // no lead yet
                                if (codePoint > 0xDBFF) {
                                    // unexpected trail
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                } else if (i + 1 === length) {
                                    // unpaired lead
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                }
                                // valid lead
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // 2 leads in a row
                            if (codePoint < 0xDC00) {
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // valid surrogate pair
                            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                        } else if (leadSurrogate) // valid bmp char, but last char was a lead
                        {
                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        }
                        leadSurrogate = null;
                        // encode utf8
                        if (codePoint < 0x80) {
                            if ((units -= 1) < 0) break;
                            bytes.push(codePoint);
                        } else if (codePoint < 0x800) {
                            if ((units -= 2) < 0) break;
                            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x10000) {
                            if ((units -= 3) < 0) break;
                            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x110000) {
                            if ((units -= 4) < 0) break;
                            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else throw new Error("Invalid code point");
                    }
                    return bytes;
                }
                function asciiToBytes(str) {
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                    byteArray.push(str.charCodeAt(i) & 0xFF);
                    return byteArray;
                }
                function utf16leToBytes(str, units) {
                    var c, hi, lo;
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i){
                        if ((units -= 2) < 0) break;
                        c = str.charCodeAt(i);
                        hi = c >> 8;
                        lo = c % 256;
                        byteArray.push(lo);
                        byteArray.push(hi);
                    }
                    return byteArray;
                }
                function base64ToBytes(str) {
                    return base64.toByteArray(base64clean(str));
                }
                function blitBuffer(src, dst, offset, length) {
                    var i;
                    for(i = 0; i < length; ++i){
                        if (i + offset >= dst.length || i >= src.length) break;
                        dst[i + offset] = src[i];
                    }
                    return i;
                }
                // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                // the `instanceof` check but they should be treated as of that type.
                // See: https://github.com/feross/buffer/issues/166
                function isInstance(obj, type) {
                    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                }
                function numberIsNaN(obj) {
                    // For IE11 support
                    return obj !== obj; // eslint-disable-line no-self-compare
                }
                // Create lookup table for `toString('hex')`
                // See: https://github.com/feross/buffer/issues/219
                var hexSliceLookupTable = function() {
                    var alphabet = "0123456789abcdef";
                    var table = new Array(256);
                    for(var i = 0; i < 16; ++i){
                        var i16 = i * 16;
                        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
                    }
                    return table;
                }();
                // Return not function with Error if BigInt not supported
                function defineBigIntMethod(fn) {
                    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
                }
                function BufferBigIntNotDefined() {
                    throw new Error("BigInt not supported");
                }
            /***/ },
            /***/ 20724: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(36501);
                __webpack_require__(10853);
                // eslint-disable-next-line es/no-typed-arrays -- safe
                module1.exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
            /***/ },
            /***/ 32590: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_ARRAY_BUFFER = __webpack_require__(20724);
                var DESCRIPTORS = __webpack_require__(7493);
                var global = __webpack_require__(98363);
                var isCallable = __webpack_require__(75277);
                var isObject = __webpack_require__(52786);
                var hasOwn = __webpack_require__(24792);
                var classof = __webpack_require__(36994);
                var tryToString = __webpack_require__(28768);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var redefine = __webpack_require__(35974);
                var defineProperty = __webpack_require__(86385).f;
                var isPrototypeOf = __webpack_require__(32010);
                var getPrototypeOf = __webpack_require__(12654);
                var setPrototypeOf = __webpack_require__(22412);
                var wellKnownSymbol = __webpack_require__(52280);
                var uid = __webpack_require__(34524);
                var Int8Array1 = global.Int8Array;
                var Int8ArrayPrototype = Int8Array1 && Int8Array1.prototype;
                var Uint8ClampedArray1 = global.Uint8ClampedArray;
                var Uint8ClampedArrayPrototype = Uint8ClampedArray1 && Uint8ClampedArray1.prototype;
                var TypedArray = Int8Array1 && getPrototypeOf(Int8Array1);
                var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
                var ObjectPrototype = Object.prototype;
                var TypeError1 = global.TypeError;
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var TYPED_ARRAY_TAG = uid("TYPED_ARRAY_TAG");
                var TYPED_ARRAY_CONSTRUCTOR = uid("TYPED_ARRAY_CONSTRUCTOR");
                // Fixing native typed arrays in Opera Presto crashes the browser, see #595
                var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== "Opera";
                var TYPED_ARRAY_TAG_REQIRED = false;
                var NAME, Constructor, Prototype;
                var TypedArrayConstructorsList = {
                    Int8Array: 1,
                    Uint8Array: 1,
                    Uint8ClampedArray: 1,
                    Int16Array: 2,
                    Uint16Array: 2,
                    Int32Array: 4,
                    Uint32Array: 4,
                    Float32Array: 4,
                    Float64Array: 8
                };
                var BigIntArrayConstructorsList = {
                    BigInt64Array: 8,
                    BigUint64Array: 8
                };
                var isView = function isView(it) {
                    if (!isObject(it)) return false;
                    var klass = classof(it);
                    return klass === "DataView" || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
                };
                var isTypedArray = function isTypedArray(it) {
                    if (!isObject(it)) return false;
                    var klass = classof(it);
                    return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
                };
                var aTypedArray = function aTypedArray(it) {
                    if (isTypedArray(it)) return it;
                    throw TypeError1("Target is not a typed array");
                };
                var aTypedArrayConstructor = function aTypedArrayConstructor(C) {
                    if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
                    throw TypeError1(tryToString(C) + " is not a typed array constructor");
                };
                var exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced) {
                    if (!DESCRIPTORS) return;
                    if (forced) for(var ARRAY in TypedArrayConstructorsList){
                        var TypedArrayConstructor = global[ARRAY];
                        if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
                            delete TypedArrayConstructor.prototype[KEY];
                        } catch (error) {}
                    }
                    if (!TypedArrayPrototype[KEY] || forced) redefine(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
                };
                var exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
                    var ARRAY, TypedArrayConstructor;
                    if (!DESCRIPTORS) return;
                    if (setPrototypeOf) {
                        if (forced) for(ARRAY in TypedArrayConstructorsList){
                            TypedArrayConstructor = global[ARRAY];
                            if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
                                delete TypedArrayConstructor[KEY];
                            } catch (error) {}
                        }
                        if (!TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
                        try {
                            return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
                        } catch (error) {}
                        else return;
                    }
                    for(ARRAY in TypedArrayConstructorsList){
                        TypedArrayConstructor = global[ARRAY];
                        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) redefine(TypedArrayConstructor, KEY, property);
                    }
                };
                for(NAME in TypedArrayConstructorsList){
                    Constructor = global[NAME];
                    Prototype = Constructor && Constructor.prototype;
                    if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
                    else NATIVE_ARRAY_BUFFER_VIEWS = false;
                }
                for(NAME in BigIntArrayConstructorsList){
                    Constructor = global[NAME];
                    Prototype = Constructor && Constructor.prototype;
                    if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
                }
                // WebKit bug - typed arrays constructors prototype is Object.prototype
                if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
                    // eslint-disable-next-line no-shadow -- safe
                    TypedArray = function TypedArray() {
                        throw TypeError1("Incorrect invocation");
                    };
                    if (NATIVE_ARRAY_BUFFER_VIEWS) {
                        for(NAME in TypedArrayConstructorsList)if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
                    }
                }
                if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
                    TypedArrayPrototype = TypedArray.prototype;
                    if (NATIVE_ARRAY_BUFFER_VIEWS) {
                        for(NAME in TypedArrayConstructorsList)if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
                    }
                }
                // WebKit bug - one more object in Uint8ClampedArray prototype chain
                if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
                if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
                    TYPED_ARRAY_TAG_REQIRED = true;
                    defineProperty(TypedArrayPrototype, TO_STRING_TAG, {
                        get: function get() {
                            return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
                        }
                    });
                    for(NAME in TypedArrayConstructorsList)if (global[NAME]) createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
                }
                module1.exports = {
                    NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
                    TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
                    TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
                    aTypedArray: aTypedArray,
                    aTypedArrayConstructor: aTypedArrayConstructor,
                    exportTypedArrayMethod: exportTypedArrayMethod,
                    exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
                    isView: isView,
                    isTypedArray: isTypedArray,
                    TypedArray: TypedArray,
                    TypedArrayPrototype: TypedArrayPrototype
                };
            /***/ },
            /***/ 74510: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(54994);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var DESCRIPTORS = __webpack_require__(7493);
                var NATIVE_ARRAY_BUFFER = __webpack_require__(20724);
                var FunctionName = __webpack_require__(55316);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var redefineAll = __webpack_require__(7592);
                var fails = __webpack_require__(79044);
                var anInstance = __webpack_require__(9519);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var toLength = __webpack_require__(35108);
                var toIndex = __webpack_require__(27302);
                var IEEE754 = __webpack_require__(45489);
                var getPrototypeOf = __webpack_require__(12654);
                var setPrototypeOf = __webpack_require__(22412);
                var getOwnPropertyNames = __webpack_require__(87994).f;
                var defineProperty = __webpack_require__(86385).f;
                var arrayFill = __webpack_require__(55522);
                var arraySlice = __webpack_require__(15629);
                var setToStringTag = __webpack_require__(60878);
                var InternalStateModule = __webpack_require__(20821);
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var getInternalState = InternalStateModule.get;
                var setInternalState = InternalStateModule.set;
                var ARRAY_BUFFER = "ArrayBuffer";
                var DATA_VIEW = "DataView";
                var PROTOTYPE = "prototype";
                var WRONG_LENGTH = "Wrong length";
                var WRONG_INDEX = "Wrong index";
                var NativeArrayBuffer = global[ARRAY_BUFFER];
                var $ArrayBuffer = NativeArrayBuffer;
                var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
                var $DataView = global[DATA_VIEW];
                var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
                var ObjectPrototype = Object.prototype;
                var Array1 = global.Array;
                var RangeError1 = global.RangeError;
                var fill = uncurryThis(arrayFill);
                var reverse = uncurryThis([].reverse);
                var packIEEE754 = IEEE754.pack;
                var unpackIEEE754 = IEEE754.unpack;
                var packInt8 = function packInt8(number) {
                    return [
                        number & 0xFF
                    ];
                };
                var packInt16 = function packInt16(number) {
                    return [
                        number & 0xFF,
                        number >> 8 & 0xFF
                    ];
                };
                var packInt32 = function packInt32(number) {
                    return [
                        number & 0xFF,
                        number >> 8 & 0xFF,
                        number >> 16 & 0xFF,
                        number >> 24 & 0xFF
                    ];
                };
                var unpackInt32 = function unpackInt32(buffer) {
                    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
                };
                var packFloat32 = function packFloat32(number) {
                    return packIEEE754(number, 23, 4);
                };
                var packFloat64 = function packFloat64(number) {
                    return packIEEE754(number, 52, 8);
                };
                var addGetter = function addGetter(Constructor, key) {
                    defineProperty(Constructor[PROTOTYPE], key, {
                        get: function get() {
                            return getInternalState(this)[key];
                        }
                    });
                };
                var get = function get(view, count, index, isLittleEndian) {
                    var intIndex = toIndex(index);
                    var store = getInternalState(view);
                    if (intIndex + count > store.byteLength) throw RangeError1(WRONG_INDEX);
                    var bytes = getInternalState(store.buffer).bytes;
                    var start = intIndex + store.byteOffset;
                    var pack = arraySlice(bytes, start, start + count);
                    return isLittleEndian ? pack : reverse(pack);
                };
                var set = function set(view, count, index, conversion, value, isLittleEndian) {
                    var intIndex = toIndex(index);
                    var store = getInternalState(view);
                    if (intIndex + count > store.byteLength) throw RangeError1(WRONG_INDEX);
                    var bytes = getInternalState(store.buffer).bytes;
                    var start = intIndex + store.byteOffset;
                    var pack = conversion(+value);
                    for(var i = 0; i < count; i++)bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
                };
                if (!NATIVE_ARRAY_BUFFER) {
                    $ArrayBuffer = function ArrayBuffer1(length) {
                        anInstance(this, ArrayBufferPrototype);
                        var byteLength = toIndex(length);
                        setInternalState(this, {
                            bytes: fill(Array1(byteLength), 0),
                            byteLength: byteLength
                        });
                        if (!DESCRIPTORS) this.byteLength = byteLength;
                    };
                    ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];
                    $DataView = function DataView1(buffer, byteOffset, byteLength) {
                        anInstance(this, DataViewPrototype);
                        anInstance(buffer, ArrayBufferPrototype);
                        var bufferLength = getInternalState(buffer).byteLength;
                        var offset = toIntegerOrInfinity(byteOffset);
                        if (offset < 0 || offset > bufferLength) throw RangeError1("Wrong offset");
                        byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
                        if (offset + byteLength > bufferLength) throw RangeError1(WRONG_LENGTH);
                        setInternalState(this, {
                            buffer: buffer,
                            byteLength: byteLength,
                            byteOffset: offset
                        });
                        if (!DESCRIPTORS) {
                            this.buffer = buffer;
                            this.byteLength = byteLength;
                            this.byteOffset = offset;
                        }
                    };
                    DataViewPrototype = $DataView[PROTOTYPE];
                    if (DESCRIPTORS) {
                        addGetter($ArrayBuffer, "byteLength");
                        addGetter($DataView, "buffer");
                        addGetter($DataView, "byteLength");
                        addGetter($DataView, "byteOffset");
                    }
                    redefineAll(DataViewPrototype, {
                        getInt8: function getInt8(byteOffset) {
                            return get(this, 1, byteOffset)[0] << 24 >> 24;
                        },
                        getUint8: function getUint8(byteOffset) {
                            return get(this, 1, byteOffset)[0];
                        },
                        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
                            var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
                            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
                        },
                        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
                            var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
                            return bytes[1] << 8 | bytes[0];
                        },
                        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
                            return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
                        },
                        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
                            return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
                        },
                        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
                            return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
                        },
                        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
                            return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
                        },
                        setInt8: function setInt8(byteOffset, value) {
                            set(this, 1, byteOffset, packInt8, value);
                        },
                        setUint8: function setUint8(byteOffset, value) {
                            set(this, 1, byteOffset, packInt8, value);
                        },
                        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
                            set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
                            set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
                            set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
                            set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
                            set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
                            set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
                        }
                    });
                } else {
                    var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
                    /* eslint-disable no-new -- required for testing */ if (!fails(function() {
                        NativeArrayBuffer(1);
                    }) || !fails(function() {
                        new NativeArrayBuffer(-1);
                    }) || fails(function() {
                        new NativeArrayBuffer();
                        new NativeArrayBuffer(1.5);
                        new NativeArrayBuffer(NaN);
                        return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
                    })) {
                        /* eslint-enable no-new -- required for testing */ $ArrayBuffer = function ArrayBuffer1(length) {
                            anInstance(this, ArrayBufferPrototype);
                            return new NativeArrayBuffer(toIndex(length));
                        };
                        $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;
                        for(var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;)if (!((key = keys[j++]) in $ArrayBuffer)) createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
                        ArrayBufferPrototype.constructor = $ArrayBuffer;
                    } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(NativeArrayBuffer, "name", ARRAY_BUFFER);
                    // WebKit bug - the same parent prototype for typed arrays and data view
                    if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) setPrototypeOf(DataViewPrototype, ObjectPrototype);
                    // iOS Safari 7.x bug
                    var testView = new $DataView(new $ArrayBuffer(2));
                    var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
                    testView.setInt8(0, 2147483648);
                    testView.setInt8(1, 2147483649);
                    if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll(DataViewPrototype, {
                        setInt8: function setInt8(byteOffset, value) {
                            $setInt8(this, byteOffset, value << 24 >> 24);
                        },
                        setUint8: function setUint8(byteOffset, value) {
                            $setInt8(this, byteOffset, value << 24 >> 24);
                        }
                    }, {
                        unsafe: true
                    });
                }
                setToStringTag($ArrayBuffer, ARRAY_BUFFER);
                setToStringTag($DataView, DATA_VIEW);
                module1.exports = {
                    ArrayBuffer: $ArrayBuffer,
                    DataView: $DataView
                };
            /***/ },
            /***/ 36501: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var arrayBufferModule = __webpack_require__(74510);
                var setSpecies = __webpack_require__(57323);
                var ARRAY_BUFFER = "ArrayBuffer";
                var ArrayBuffer1 = arrayBufferModule[ARRAY_BUFFER];
                var NativeArrayBuffer = global[ARRAY_BUFFER];
                // `ArrayBuffer` constructor
                // https://tc39.es/ecma262/#sec-arraybuffer-constructor
                $({
                    global: true,
                    forced: NativeArrayBuffer !== ArrayBuffer1
                }, {
                    ArrayBuffer: ArrayBuffer1
                });
                setSpecies(ARRAY_BUFFER);
            /***/ },
            /***/ 22449: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(31946), __webpack_require__(57510), __webpack_require__(95194), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var BlockCipher = C_lib.BlockCipher;
                        var C_algo = C.algo;
                        // Lookup tables
                        var SBOX = [];
                        var INV_SBOX = [];
                        var SUB_MIX_0 = [];
                        var SUB_MIX_1 = [];
                        var SUB_MIX_2 = [];
                        var SUB_MIX_3 = [];
                        var INV_SUB_MIX_0 = [];
                        var INV_SUB_MIX_1 = [];
                        var INV_SUB_MIX_2 = [];
                        var INV_SUB_MIX_3 = [];
                        // Compute lookup tables
                        (function() {
                            // Compute double table
                            var d = [];
                            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
                            else d[i] = i << 1 ^ 0x11b;
                            // Walk GF(2^8)
                            var x = 0;
                            var xi = 0;
                            for(var i = 0; i < 256; i++){
                                // Compute sbox
                                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                                SBOX[x] = sx;
                                INV_SBOX[sx] = x;
                                // Compute multiplication
                                var x2 = d[x];
                                var x4 = d[x2];
                                var x8 = d[x4];
                                // Compute sub bytes, mix columns tables
                                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                                SUB_MIX_0[x] = t << 24 | t >>> 8;
                                SUB_MIX_1[x] = t << 16 | t >>> 16;
                                SUB_MIX_2[x] = t << 8 | t >>> 24;
                                SUB_MIX_3[x] = t;
                                // Compute inv sub bytes, inv mix columns tables
                                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                                INV_SUB_MIX_3[sx] = t;
                                // Compute next counter
                                if (!x) x = xi = 1;
                                else {
                                    x = x2 ^ d[d[d[x8 ^ x2]]];
                                    xi ^= d[d[xi]];
                                }
                            }
                        })();
                        // Precomputed Rcon lookup
                        var RCON = [
                            0x00,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36
                        ];
                        /**
     * AES block cipher algorithm.
     */ var AES = C_algo.AES = BlockCipher.extend({
                            _doReset: function _doReset() {
                                var t;
                                // Skip reset of nRounds has been set before and key did not change
                                if (this._nRounds && this._keyPriorReset === this._key) return;
                                // Shortcuts
                                var key = this._keyPriorReset = this._key;
                                var keyWords = key.words;
                                var keySize = key.sigBytes / 4;
                                // Compute number of rounds
                                var nRounds = this._nRounds = keySize + 6;
                                // Compute number of key schedule rows
                                var ksRows = (nRounds + 1) * 4;
                                // Compute key schedule
                                var keySchedule = this._keySchedule = [];
                                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                                else {
                                    t = keySchedule[ksRow - 1];
                                    if (!(ksRow % keySize)) {
                                        // Rot word
                                        t = t << 8 | t >>> 24;
                                        // Sub word
                                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                                        // Mix Rcon
                                        t ^= RCON[ksRow / keySize | 0] << 24;
                                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                                }
                                // Compute inv key schedule
                                var invKeySchedule = this._invKeySchedule = [];
                                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                                    var ksRow = ksRows - invKsRow;
                                    if (invKsRow % 4) var t = keySchedule[ksRow];
                                    else var t = keySchedule[ksRow - 4];
                                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                                }
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                // Swap 2nd and 4th rows
                                var t = M[offset + 1];
                                M[offset + 1] = M[offset + 3];
                                M[offset + 3] = t;
                                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                                // Inv swap 2nd and 4th rows
                                var t = M[offset + 1];
                                M[offset + 1] = M[offset + 3];
                                M[offset + 3] = t;
                            },
                            _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                                // Shortcut
                                var nRounds = this._nRounds;
                                // Get input, add round key
                                var s0 = M[offset] ^ keySchedule[0];
                                var s1 = M[offset + 1] ^ keySchedule[1];
                                var s2 = M[offset + 2] ^ keySchedule[2];
                                var s3 = M[offset + 3] ^ keySchedule[3];
                                // Key schedule row counter
                                var ksRow = 4;
                                // Rounds
                                for(var round = 1; round < nRounds; round++){
                                    // Shift rows, sub bytes, mix columns, add round key
                                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                                    // Update state
                                    s0 = t0;
                                    s1 = t1;
                                    s2 = t2;
                                    s3 = t3;
                                }
                                // Shift rows, sub bytes, add round key
                                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                                // Set output
                                M[offset] = t0;
                                M[offset + 1] = t1;
                                M[offset + 2] = t2;
                                M[offset + 3] = t3;
                            },
                            keySize: 8
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
     */ C.AES = BlockCipher._createHelper(AES);
                    })();
                    return CryptoJS.AES;
                });
            /***/ },
            /***/ 67646: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(31946), __webpack_require__(57510), __webpack_require__(95194), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var BlockCipher = C_lib.BlockCipher;
                        var C_algo = C.algo;
                        var N = 16;
                        //Origin pbox and sbox, derived from PI
                        var ORIG_P = [
                            0x243F6A88,
                            0x85A308D3,
                            0x13198A2E,
                            0x03707344,
                            0xA4093822,
                            0x299F31D0,
                            0x082EFA98,
                            0xEC4E6C89,
                            0x452821E6,
                            0x38D01377,
                            0xBE5466CF,
                            0x34E90C6C,
                            0xC0AC29B7,
                            0xC97C50DD,
                            0x3F84D5B5,
                            0xB5470917,
                            0x9216D5D9,
                            0x8979FB1B
                        ];
                        var ORIG_S = [
                            [
                                0xD1310BA6,
                                0x98DFB5AC,
                                0x2FFD72DB,
                                0xD01ADFB7,
                                0xB8E1AFED,
                                0x6A267E96,
                                0xBA7C9045,
                                0xF12C7F99,
                                0x24A19947,
                                0xB3916CF7,
                                0x0801F2E2,
                                0x858EFC16,
                                0x636920D8,
                                0x71574E69,
                                0xA458FEA3,
                                0xF4933D7E,
                                0x0D95748F,
                                0x728EB658,
                                0x718BCD58,
                                0x82154AEE,
                                0x7B54A41D,
                                0xC25A59B5,
                                0x9C30D539,
                                0x2AF26013,
                                0xC5D1B023,
                                0x286085F0,
                                0xCA417918,
                                0xB8DB38EF,
                                0x8E79DCB0,
                                0x603A180E,
                                0x6C9E0E8B,
                                0xB01E8A3E,
                                0xD71577C1,
                                0xBD314B27,
                                0x78AF2FDA,
                                0x55605C60,
                                0xE65525F3,
                                0xAA55AB94,
                                0x57489862,
                                0x63E81440,
                                0x55CA396A,
                                0x2AAB10B6,
                                0xB4CC5C34,
                                0x1141E8CE,
                                0xA15486AF,
                                0x7C72E993,
                                0xB3EE1411,
                                0x636FBC2A,
                                0x2BA9C55D,
                                0x741831F6,
                                0xCE5C3E16,
                                0x9B87931E,
                                0xAFD6BA33,
                                0x6C24CF5C,
                                0x7A325381,
                                0x28958677,
                                0x3B8F4898,
                                0x6B4BB9AF,
                                0xC4BFE81B,
                                0x66282193,
                                0x61D809CC,
                                0xFB21A991,
                                0x487CAC60,
                                0x5DEC8032,
                                0xEF845D5D,
                                0xE98575B1,
                                0xDC262302,
                                0xEB651B88,
                                0x23893E81,
                                0xD396ACC5,
                                0x0F6D6FF3,
                                0x83F44239,
                                0x2E0B4482,
                                0xA4842004,
                                0x69C8F04A,
                                0x9E1F9B5E,
                                0x21C66842,
                                0xF6E96C9A,
                                0x670C9C61,
                                0xABD388F0,
                                0x6A51A0D2,
                                0xD8542F68,
                                0x960FA728,
                                0xAB5133A3,
                                0x6EEF0B6C,
                                0x137A3BE4,
                                0xBA3BF050,
                                0x7EFB2A98,
                                0xA1F1651D,
                                0x39AF0176,
                                0x66CA593E,
                                0x82430E88,
                                0x8CEE8619,
                                0x456F9FB4,
                                0x7D84A5C3,
                                0x3B8B5EBE,
                                0xE06F75D8,
                                0x85C12073,
                                0x401A449F,
                                0x56C16AA6,
                                0x4ED3AA62,
                                0x363F7706,
                                0x1BFEDF72,
                                0x429B023D,
                                0x37D0D724,
                                0xD00A1248,
                                0xDB0FEAD3,
                                0x49F1C09B,
                                0x075372C9,
                                0x80991B7B,
                                0x25D479D8,
                                0xF6E8DEF7,
                                0xE3FE501A,
                                0xB6794C3B,
                                0x976CE0BD,
                                0x04C006BA,
                                0xC1A94FB6,
                                0x409F60C4,
                                0x5E5C9EC2,
                                0x196A2463,
                                0x68FB6FAF,
                                0x3E6C53B5,
                                0x1339B2EB,
                                0x3B52EC6F,
                                0x6DFC511F,
                                0x9B30952C,
                                0xCC814544,
                                0xAF5EBD09,
                                0xBEE3D004,
                                0xDE334AFD,
                                0x660F2807,
                                0x192E4BB3,
                                0xC0CBA857,
                                0x45C8740F,
                                0xD20B5F39,
                                0xB9D3FBDB,
                                0x5579C0BD,
                                0x1A60320A,
                                0xD6A100C6,
                                0x402C7279,
                                0x679F25FE,
                                0xFB1FA3CC,
                                0x8EA5E9F8,
                                0xDB3222F8,
                                0x3C7516DF,
                                0xFD616B15,
                                0x2F501EC8,
                                0xAD0552AB,
                                0x323DB5FA,
                                0xFD238760,
                                0x53317B48,
                                0x3E00DF82,
                                0x9E5C57BB,
                                0xCA6F8CA0,
                                0x1A87562E,
                                0xDF1769DB,
                                0xD542A8F6,
                                0x287EFFC3,
                                0xAC6732C6,
                                0x8C4F5573,
                                0x695B27B0,
                                0xBBCA58C8,
                                0xE1FFA35D,
                                0xB8F011A0,
                                0x10FA3D98,
                                0xFD2183B8,
                                0x4AFCB56C,
                                0x2DD1D35B,
                                0x9A53E479,
                                0xB6F84565,
                                0xD28E49BC,
                                0x4BFB9790,
                                0xE1DDF2DA,
                                0xA4CB7E33,
                                0x62FB1341,
                                0xCEE4C6E8,
                                0xEF20CADA,
                                0x36774C01,
                                0xD07E9EFE,
                                0x2BF11FB4,
                                0x95DBDA4D,
                                0xAE909198,
                                0xEAAD8E71,
                                0x6B93D5A0,
                                0xD08ED1D0,
                                0xAFC725E0,
                                0x8E3C5B2F,
                                0x8E7594B7,
                                0x8FF6E2FB,
                                0xF2122B64,
                                0x8888B812,
                                0x900DF01C,
                                0x4FAD5EA0,
                                0x688FC31C,
                                0xD1CFF191,
                                0xB3A8C1AD,
                                0x2F2F2218,
                                0xBE0E1777,
                                0xEA752DFE,
                                0x8B021FA1,
                                0xE5A0CC0F,
                                0xB56F74E8,
                                0x18ACF3D6,
                                0xCE89E299,
                                0xB4A84FE0,
                                0xFD13E0B7,
                                0x7CC43B81,
                                0xD2ADA8D9,
                                0x165FA266,
                                0x80957705,
                                0x93CC7314,
                                0x211A1477,
                                0xE6AD2065,
                                0x77B5FA86,
                                0xC75442F5,
                                0xFB9D35CF,
                                0xEBCDAF0C,
                                0x7B3E89A0,
                                0xD6411BD3,
                                0xAE1E7E49,
                                0x00250E2D,
                                0x2071B35E,
                                0x226800BB,
                                0x57B8E0AF,
                                0x2464369B,
                                0xF009B91E,
                                0x5563911D,
                                0x59DFA6AA,
                                0x78C14389,
                                0xD95A537F,
                                0x207D5BA2,
                                0x02E5B9C5,
                                0x83260376,
                                0x6295CFA9,
                                0x11C81968,
                                0x4E734A41,
                                0xB3472DCA,
                                0x7B14A94A,
                                0x1B510052,
                                0x9A532915,
                                0xD60F573F,
                                0xBC9BC6E4,
                                0x2B60A476,
                                0x81E67400,
                                0x08BA6FB5,
                                0x571BE91F,
                                0xF296EC6B,
                                0x2A0DD915,
                                0xB6636521,
                                0xE7B9F9B6,
                                0xFF34052E,
                                0xC5855664,
                                0x53B02D5D,
                                0xA99F8FA1,
                                0x08BA4799,
                                0x6E85076A
                            ],
                            [
                                0x4B7A70E9,
                                0xB5B32944,
                                0xDB75092E,
                                0xC4192623,
                                0xAD6EA6B0,
                                0x49A7DF7D,
                                0x9CEE60B8,
                                0x8FEDB266,
                                0xECAA8C71,
                                0x699A17FF,
                                0x5664526C,
                                0xC2B19EE1,
                                0x193602A5,
                                0x75094C29,
                                0xA0591340,
                                0xE4183A3E,
                                0x3F54989A,
                                0x5B429D65,
                                0x6B8FE4D6,
                                0x99F73FD6,
                                0xA1D29C07,
                                0xEFE830F5,
                                0x4D2D38E6,
                                0xF0255DC1,
                                0x4CDD2086,
                                0x8470EB26,
                                0x6382E9C6,
                                0x021ECC5E,
                                0x09686B3F,
                                0x3EBAEFC9,
                                0x3C971814,
                                0x6B6A70A1,
                                0x687F3584,
                                0x52A0E286,
                                0xB79C5305,
                                0xAA500737,
                                0x3E07841C,
                                0x7FDEAE5C,
                                0x8E7D44EC,
                                0x5716F2B8,
                                0xB03ADA37,
                                0xF0500C0D,
                                0xF01C1F04,
                                0x0200B3FF,
                                0xAE0CF51A,
                                0x3CB574B2,
                                0x25837A58,
                                0xDC0921BD,
                                0xD19113F9,
                                0x7CA92FF6,
                                0x94324773,
                                0x22F54701,
                                0x3AE5E581,
                                0x37C2DADC,
                                0xC8B57634,
                                0x9AF3DDA7,
                                0xA9446146,
                                0x0FD0030E,
                                0xECC8C73E,
                                0xA4751E41,
                                0xE238CD99,
                                0x3BEA0E2F,
                                0x3280BBA1,
                                0x183EB331,
                                0x4E548B38,
                                0x4F6DB908,
                                0x6F420D03,
                                0xF60A04BF,
                                0x2CB81290,
                                0x24977C79,
                                0x5679B072,
                                0xBCAF89AF,
                                0xDE9A771F,
                                0xD9930810,
                                0xB38BAE12,
                                0xDCCF3F2E,
                                0x5512721F,
                                0x2E6B7124,
                                0x501ADDE6,
                                0x9F84CD87,
                                0x7A584718,
                                0x7408DA17,
                                0xBC9F9ABC,
                                0xE94B7D8C,
                                0xEC7AEC3A,
                                0xDB851DFA,
                                0x63094366,
                                0xC464C3D2,
                                0xEF1C1847,
                                0x3215D908,
                                0xDD433B37,
                                0x24C2BA16,
                                0x12A14D43,
                                0x2A65C451,
                                0x50940002,
                                0x133AE4DD,
                                0x71DFF89E,
                                0x10314E55,
                                0x81AC77D6,
                                0x5F11199B,
                                0x043556F1,
                                0xD7A3C76B,
                                0x3C11183B,
                                0x5924A509,
                                0xF28FE6ED,
                                0x97F1FBFA,
                                0x9EBABF2C,
                                0x1E153C6E,
                                0x86E34570,
                                0xEAE96FB1,
                                0x860E5E0A,
                                0x5A3E2AB3,
                                0x771FE71C,
                                0x4E3D06FA,
                                0x2965DCB9,
                                0x99E71D0F,
                                0x803E89D6,
                                0x5266C825,
                                0x2E4CC978,
                                0x9C10B36A,
                                0xC6150EBA,
                                0x94E2EA78,
                                0xA5FC3C53,
                                0x1E0A2DF4,
                                0xF2F74EA7,
                                0x361D2B3D,
                                0x1939260F,
                                0x19C27960,
                                0x5223A708,
                                0xF71312B6,
                                0xEBADFE6E,
                                0xEAC31F66,
                                0xE3BC4595,
                                0xA67BC883,
                                0xB17F37D1,
                                0x018CFF28,
                                0xC332DDEF,
                                0xBE6C5AA5,
                                0x65582185,
                                0x68AB9802,
                                0xEECEA50F,
                                0xDB2F953B,
                                0x2AEF7DAD,
                                0x5B6E2F84,
                                0x1521B628,
                                0x29076170,
                                0xECDD4775,
                                0x619F1510,
                                0x13CCA830,
                                0xEB61BD96,
                                0x0334FE1E,
                                0xAA0363CF,
                                0xB5735C90,
                                0x4C70A239,
                                0xD59E9E0B,
                                0xCBAADE14,
                                0xEECC86BC,
                                0x60622CA7,
                                0x9CAB5CAB,
                                0xB2F3846E,
                                0x648B1EAF,
                                0x19BDF0CA,
                                0xA02369B9,
                                0x655ABB50,
                                0x40685A32,
                                0x3C2AB4B3,
                                0x319EE9D5,
                                0xC021B8F7,
                                0x9B540B19,
                                0x875FA099,
                                0x95F7997E,
                                0x623D7DA8,
                                0xF837889A,
                                0x97E32D77,
                                0x11ED935F,
                                0x16681281,
                                0x0E358829,
                                0xC7E61FD6,
                                0x96DEDFA1,
                                0x7858BA99,
                                0x57F584A5,
                                0x1B227263,
                                0x9B83C3FF,
                                0x1AC24696,
                                0xCDB30AEB,
                                0x532E3054,
                                0x8FD948E4,
                                0x6DBC3128,
                                0x58EBF2EF,
                                0x34C6FFEA,
                                0xFE28ED61,
                                0xEE7C3C73,
                                0x5D4A14D9,
                                0xE864B7E3,
                                0x42105D14,
                                0x203E13E0,
                                0x45EEE2B6,
                                0xA3AAABEA,
                                0xDB6C4F15,
                                0xFACB4FD0,
                                0xC742F442,
                                0xEF6ABBB5,
                                0x654F3B1D,
                                0x41CD2105,
                                0xD81E799E,
                                0x86854DC7,
                                0xE44B476A,
                                0x3D816250,
                                0xCF62A1F2,
                                0x5B8D2646,
                                0xFC8883A0,
                                0xC1C7B6A3,
                                0x7F1524C3,
                                0x69CB7492,
                                0x47848A0B,
                                0x5692B285,
                                0x095BBF00,
                                0xAD19489D,
                                0x1462B174,
                                0x23820E00,
                                0x58428D2A,
                                0x0C55F5EA,
                                0x1DADF43E,
                                0x233F7061,
                                0x3372F092,
                                0x8D937E41,
                                0xD65FECF1,
                                0x6C223BDB,
                                0x7CDE3759,
                                0xCBEE7460,
                                0x4085F2A7,
                                0xCE77326E,
                                0xA6078084,
                                0x19F8509E,
                                0xE8EFD855,
                                0x61D99735,
                                0xA969A7AA,
                                0xC50C06C2,
                                0x5A04ABFC,
                                0x800BCADC,
                                0x9E447A2E,
                                0xC3453484,
                                0xFDD56705,
                                0x0E1E9EC9,
                                0xDB73DBD3,
                                0x105588CD,
                                0x675FDA79,
                                0xE3674340,
                                0xC5C43465,
                                0x713E38D8,
                                0x3D28F89E,
                                0xF16DFF20,
                                0x153E21E7,
                                0x8FB03D4A,
                                0xE6E39F2B,
                                0xDB83ADF7
                            ],
                            [
                                0xE93D5A68,
                                0x948140F7,
                                0xF64C261C,
                                0x94692934,
                                0x411520F7,
                                0x7602D4F7,
                                0xBCF46B2E,
                                0xD4A20068,
                                0xD4082471,
                                0x3320F46A,
                                0x43B7D4B7,
                                0x500061AF,
                                0x1E39F62E,
                                0x97244546,
                                0x14214F74,
                                0xBF8B8840,
                                0x4D95FC1D,
                                0x96B591AF,
                                0x70F4DDD3,
                                0x66A02F45,
                                0xBFBC09EC,
                                0x03BD9785,
                                0x7FAC6DD0,
                                0x31CB8504,
                                0x96EB27B3,
                                0x55FD3941,
                                0xDA2547E6,
                                0xABCA0A9A,
                                0x28507825,
                                0x530429F4,
                                0x0A2C86DA,
                                0xE9B66DFB,
                                0x68DC1462,
                                0xD7486900,
                                0x680EC0A4,
                                0x27A18DEE,
                                0x4F3FFEA2,
                                0xE887AD8C,
                                0xB58CE006,
                                0x7AF4D6B6,
                                0xAACE1E7C,
                                0xD3375FEC,
                                0xCE78A399,
                                0x406B2A42,
                                0x20FE9E35,
                                0xD9F385B9,
                                0xEE39D7AB,
                                0x3B124E8B,
                                0x1DC9FAF7,
                                0x4B6D1856,
                                0x26A36631,
                                0xEAE397B2,
                                0x3A6EFA74,
                                0xDD5B4332,
                                0x6841E7F7,
                                0xCA7820FB,
                                0xFB0AF54E,
                                0xD8FEB397,
                                0x454056AC,
                                0xBA489527,
                                0x55533A3A,
                                0x20838D87,
                                0xFE6BA9B7,
                                0xD096954B,
                                0x55A867BC,
                                0xA1159A58,
                                0xCCA92963,
                                0x99E1DB33,
                                0xA62A4A56,
                                0x3F3125F9,
                                0x5EF47E1C,
                                0x9029317C,
                                0xFDF8E802,
                                0x04272F70,
                                0x80BB155C,
                                0x05282CE3,
                                0x95C11548,
                                0xE4C66D22,
                                0x48C1133F,
                                0xC70F86DC,
                                0x07F9C9EE,
                                0x41041F0F,
                                0x404779A4,
                                0x5D886E17,
                                0x325F51EB,
                                0xD59BC0D1,
                                0xF2BCC18F,
                                0x41113564,
                                0x257B7834,
                                0x602A9C60,
                                0xDFF8E8A3,
                                0x1F636C1B,
                                0x0E12B4C2,
                                0x02E1329E,
                                0xAF664FD1,
                                0xCAD18115,
                                0x6B2395E0,
                                0x333E92E1,
                                0x3B240B62,
                                0xEEBEB922,
                                0x85B2A20E,
                                0xE6BA0D99,
                                0xDE720C8C,
                                0x2DA2F728,
                                0xD0127845,
                                0x95B794FD,
                                0x647D0862,
                                0xE7CCF5F0,
                                0x5449A36F,
                                0x877D48FA,
                                0xC39DFD27,
                                0xF33E8D1E,
                                0x0A476341,
                                0x992EFF74,
                                0x3A6F6EAB,
                                0xF4F8FD37,
                                0xA812DC60,
                                0xA1EBDDF8,
                                0x991BE14C,
                                0xDB6E6B0D,
                                0xC67B5510,
                                0x6D672C37,
                                0x2765D43B,
                                0xDCD0E804,
                                0xF1290DC7,
                                0xCC00FFA3,
                                0xB5390F92,
                                0x690FED0B,
                                0x667B9FFB,
                                0xCEDB7D9C,
                                0xA091CF0B,
                                0xD9155EA3,
                                0xBB132F88,
                                0x515BAD24,
                                0x7B9479BF,
                                0x763BD6EB,
                                0x37392EB3,
                                0xCC115979,
                                0x8026E297,
                                0xF42E312D,
                                0x6842ADA7,
                                0xC66A2B3B,
                                0x12754CCC,
                                0x782EF11C,
                                0x6A124237,
                                0xB79251E7,
                                0x06A1BBE6,
                                0x4BFB6350,
                                0x1A6B1018,
                                0x11CAEDFA,
                                0x3D25BDD8,
                                0xE2E1C3C9,
                                0x44421659,
                                0x0A121386,
                                0xD90CEC6E,
                                0xD5ABEA2A,
                                0x64AF674E,
                                0xDA86A85F,
                                0xBEBFE988,
                                0x64E4C3FE,
                                0x9DBC8057,
                                0xF0F7C086,
                                0x60787BF8,
                                0x6003604D,
                                0xD1FD8346,
                                0xF6381FB0,
                                0x7745AE04,
                                0xD736FCCC,
                                0x83426B33,
                                0xF01EAB71,
                                0xB0804187,
                                0x3C005E5F,
                                0x77A057BE,
                                0xBDE8AE24,
                                0x55464299,
                                0xBF582E61,
                                0x4E58F48F,
                                0xF2DDFDA2,
                                0xF474EF38,
                                0x8789BDC2,
                                0x5366F9C3,
                                0xC8B38E74,
                                0xB475F255,
                                0x46FCD9B9,
                                0x7AEB2661,
                                0x8B1DDF84,
                                0x846A0E79,
                                0x915F95E2,
                                0x466E598E,
                                0x20B45770,
                                0x8CD55591,
                                0xC902DE4C,
                                0xB90BACE1,
                                0xBB8205D0,
                                0x11A86248,
                                0x7574A99E,
                                0xB77F19B6,
                                0xE0A9DC09,
                                0x662D09A1,
                                0xC4324633,
                                0xE85A1F02,
                                0x09F0BE8C,
                                0x4A99A025,
                                0x1D6EFE10,
                                0x1AB93D1D,
                                0x0BA5A4DF,
                                0xA186F20F,
                                0x2868F169,
                                0xDCB7DA83,
                                0x573906FE,
                                0xA1E2CE9B,
                                0x4FCD7F52,
                                0x50115E01,
                                0xA70683FA,
                                0xA002B5C4,
                                0x0DE6D027,
                                0x9AF88C27,
                                0x773F8641,
                                0xC3604C06,
                                0x61A806B5,
                                0xF0177A28,
                                0xC0F586E0,
                                0x006058AA,
                                0x30DC7D62,
                                0x11E69ED7,
                                0x2338EA63,
                                0x53C2DD94,
                                0xC2C21634,
                                0xBBCBEE56,
                                0x90BCB6DE,
                                0xEBFC7DA1,
                                0xCE591D76,
                                0x6F05E409,
                                0x4B7C0188,
                                0x39720A3D,
                                0x7C927C24,
                                0x86E3725F,
                                0x724D9DB9,
                                0x1AC15BB4,
                                0xD39EB8FC,
                                0xED545578,
                                0x08FCA5B5,
                                0xD83D7CD3,
                                0x4DAD0FC4,
                                0x1E50EF5E,
                                0xB161E6F8,
                                0xA28514D9,
                                0x6C51133C,
                                0x6FD5C7E7,
                                0x56E14EC4,
                                0x362ABFCE,
                                0xDDC6C837,
                                0xD79A3234,
                                0x92638212,
                                0x670EFA8E,
                                0x406000E0
                            ],
                            [
                                0x3A39CE37,
                                0xD3FAF5CF,
                                0xABC27737,
                                0x5AC52D1B,
                                0x5CB0679E,
                                0x4FA33742,
                                0xD3822740,
                                0x99BC9BBE,
                                0xD5118E9D,
                                0xBF0F7315,
                                0xD62D1C7E,
                                0xC700C47B,
                                0xB78C1B6B,
                                0x21A19045,
                                0xB26EB1BE,
                                0x6A366EB4,
                                0x5748AB2F,
                                0xBC946E79,
                                0xC6A376D2,
                                0x6549C2C8,
                                0x530FF8EE,
                                0x468DDE7D,
                                0xD5730A1D,
                                0x4CD04DC6,
                                0x2939BBDB,
                                0xA9BA4650,
                                0xAC9526E8,
                                0xBE5EE304,
                                0xA1FAD5F0,
                                0x6A2D519A,
                                0x63EF8CE2,
                                0x9A86EE22,
                                0xC089C2B8,
                                0x43242EF6,
                                0xA51E03AA,
                                0x9CF2D0A4,
                                0x83C061BA,
                                0x9BE96A4D,
                                0x8FE51550,
                                0xBA645BD6,
                                0x2826A2F9,
                                0xA73A3AE1,
                                0x4BA99586,
                                0xEF5562E9,
                                0xC72FEFD3,
                                0xF752F7DA,
                                0x3F046F69,
                                0x77FA0A59,
                                0x80E4A915,
                                0x87B08601,
                                0x9B09E6AD,
                                0x3B3EE593,
                                0xE990FD5A,
                                0x9E34D797,
                                0x2CF0B7D9,
                                0x022B8B51,
                                0x96D5AC3A,
                                0x017DA67D,
                                0xD1CF3ED6,
                                0x7C7D2D28,
                                0x1F9F25CF,
                                0xADF2B89B,
                                0x5AD6B472,
                                0x5A88F54C,
                                0xE029AC71,
                                0xE019A5E6,
                                0x47B0ACFD,
                                0xED93FA9B,
                                0xE8D3C48D,
                                0x283B57CC,
                                0xF8D56629,
                                0x79132E28,
                                0x785F0191,
                                0xED756055,
                                0xF7960E44,
                                0xE3D35E8C,
                                0x15056DD4,
                                0x88F46DBA,
                                0x03A16125,
                                0x0564F0BD,
                                0xC3EB9E15,
                                0x3C9057A2,
                                0x97271AEC,
                                0xA93A072A,
                                0x1B3F6D9B,
                                0x1E6321F5,
                                0xF59C66FB,
                                0x26DCF319,
                                0x7533D928,
                                0xB155FDF5,
                                0x03563482,
                                0x8ABA3CBB,
                                0x28517711,
                                0xC20AD9F8,
                                0xABCC5167,
                                0xCCAD925F,
                                0x4DE81751,
                                0x3830DC8E,
                                0x379D5862,
                                0x9320F991,
                                0xEA7A90C2,
                                0xFB3E7BCE,
                                0x5121CE64,
                                0x774FBE32,
                                0xA8B6E37E,
                                0xC3293D46,
                                0x48DE5369,
                                0x6413E680,
                                0xA2AE0810,
                                0xDD6DB224,
                                0x69852DFD,
                                0x09072166,
                                0xB39A460A,
                                0x6445C0DD,
                                0x586CDECF,
                                0x1C20C8AE,
                                0x5BBEF7DD,
                                0x1B588D40,
                                0xCCD2017F,
                                0x6BB4E3BB,
                                0xDDA26A7E,
                                0x3A59FF45,
                                0x3E350A44,
                                0xBCB4CDD5,
                                0x72EACEA8,
                                0xFA6484BB,
                                0x8D6612AE,
                                0xBF3C6F47,
                                0xD29BE463,
                                0x542F5D9E,
                                0xAEC2771B,
                                0xF64E6370,
                                0x740E0D8D,
                                0xE75B1357,
                                0xF8721671,
                                0xAF537D5D,
                                0x4040CB08,
                                0x4EB4E2CC,
                                0x34D2466A,
                                0x0115AF84,
                                0xE1B00428,
                                0x95983A1D,
                                0x06B89FB4,
                                0xCE6EA048,
                                0x6F3F3B82,
                                0x3520AB82,
                                0x011A1D4B,
                                0x277227F8,
                                0x611560B1,
                                0xE7933FDC,
                                0xBB3A792B,
                                0x344525BD,
                                0xA08839E1,
                                0x51CE794B,
                                0x2F32C9B7,
                                0xA01FBAC9,
                                0xE01CC87E,
                                0xBCC7D1F6,
                                0xCF0111C3,
                                0xA1E8AAC7,
                                0x1A908749,
                                0xD44FBD9A,
                                0xD0DADECB,
                                0xD50ADA38,
                                0x0339C32A,
                                0xC6913667,
                                0x8DF9317C,
                                0xE0B12B4F,
                                0xF79E59B7,
                                0x43F5BB3A,
                                0xF2D519FF,
                                0x27D9459C,
                                0xBF97222C,
                                0x15E6FC2A,
                                0x0F91FC71,
                                0x9B941525,
                                0xFAE59361,
                                0xCEB69CEB,
                                0xC2A86459,
                                0x12BAA8D1,
                                0xB6C1075E,
                                0xE3056A0C,
                                0x10D25065,
                                0xCB03A442,
                                0xE0EC6E0E,
                                0x1698DB3B,
                                0x4C98A0BE,
                                0x3278E964,
                                0x9F1F9532,
                                0xE0D392DF,
                                0xD3A0342B,
                                0x8971F21E,
                                0x1B0A7441,
                                0x4BA3348C,
                                0xC5BE7120,
                                0xC37632D8,
                                0xDF359F8D,
                                0x9B992F2E,
                                0xE60B6F47,
                                0x0FE3F11D,
                                0xE54CDA54,
                                0x1EDAD891,
                                0xCE6279CF,
                                0xCD3E7E6F,
                                0x1618B166,
                                0xFD2C1D05,
                                0x848FD2C5,
                                0xF6FB2299,
                                0xF523F357,
                                0xA6327623,
                                0x93A83531,
                                0x56CCCD02,
                                0xACF08162,
                                0x5A75EBB5,
                                0x6E163697,
                                0x88D273CC,
                                0xDE966292,
                                0x81B949D0,
                                0x4C50901B,
                                0x71C65614,
                                0xE6C6C7BD,
                                0x327A140A,
                                0x45E1D006,
                                0xC3F27B9A,
                                0xC9AA53FD,
                                0x62A80F00,
                                0xBB25BFE2,
                                0x35BDD2F6,
                                0x71126905,
                                0xB2040222,
                                0xB6CBCF7C,
                                0xCD769C2B,
                                0x53113EC0,
                                0x1640E3D3,
                                0x38ABBD60,
                                0x2547ADF0,
                                0xBA38209C,
                                0xF746CE76,
                                0x77AFA1C5,
                                0x20756060,
                                0x85CBFE4E,
                                0x8AE88DD8,
                                0x7AAAF9B0,
                                0x4CF9AA7E,
                                0x1948C25C,
                                0x02FB8A8C,
                                0x01C36AE4,
                                0xD6EBE1F9,
                                0x90D4F869,
                                0xA65CDEA0,
                                0x3F09252D,
                                0xC208E69F,
                                0xB74E6132,
                                0xCE77E25B,
                                0x578FDFE3,
                                0x3AC372E6
                            ]
                        ];
                        var BLOWFISH_CTX = {
                            pbox: [],
                            sbox: []
                        };
                        function F(ctx, x) {
                            var a = x >> 24 & 0xFF;
                            var b = x >> 16 & 0xFF;
                            var c = x >> 8 & 0xFF;
                            var d = x & 0xFF;
                            var y = ctx.sbox[0][a] + ctx.sbox[1][b];
                            y = y ^ ctx.sbox[2][c];
                            y = y + ctx.sbox[3][d];
                            return y;
                        }
                        function BlowFish_Encrypt(ctx, left, right) {
                            var Xl = left;
                            var Xr = right;
                            var temp;
                            for(var i = 0; i < N; ++i){
                                Xl = Xl ^ ctx.pbox[i];
                                Xr = F(ctx, Xl) ^ Xr;
                                temp = Xl;
                                Xl = Xr;
                                Xr = temp;
                            }
                            temp = Xl;
                            Xl = Xr;
                            Xr = temp;
                            Xr = Xr ^ ctx.pbox[N];
                            Xl = Xl ^ ctx.pbox[N + 1];
                            return {
                                left: Xl,
                                right: Xr
                            };
                        }
                        function BlowFish_Decrypt(ctx, left, right) {
                            var Xl = left;
                            var Xr = right;
                            var temp;
                            for(var i = N + 1; i > 1; --i){
                                Xl = Xl ^ ctx.pbox[i];
                                Xr = F(ctx, Xl) ^ Xr;
                                temp = Xl;
                                Xl = Xr;
                                Xr = temp;
                            }
                            temp = Xl;
                            Xl = Xr;
                            Xr = temp;
                            Xr = Xr ^ ctx.pbox[1];
                            Xl = Xl ^ ctx.pbox[0];
                            return {
                                left: Xl,
                                right: Xr
                            };
                        }
                        /**
     * Initialization ctx's pbox and sbox.
     *
     * @param {Object} ctx The object has pbox and sbox.
     * @param {Array} key An array of 32-bit words.
     * @param {int} keysize The length of the key.
     *
     * @example
     *
     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
     */ function BlowFishInit(ctx, key, keysize) {
                            for(var Row = 0; Row < 4; Row++){
                                ctx.sbox[Row] = [];
                                for(var Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
                            }
                            var keyIndex = 0;
                            for(var index = 0; index < N + 2; index++){
                                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                                keyIndex++;
                                if (keyIndex >= keysize) keyIndex = 0;
                            }
                            var Data1 = 0;
                            var Data2 = 0;
                            var res = 0;
                            for(var i = 0; i < N + 2; i += 2){
                                res = BlowFish_Encrypt(ctx, Data1, Data2);
                                Data1 = res.left;
                                Data2 = res.right;
                                ctx.pbox[i] = Data1;
                                ctx.pbox[i + 1] = Data2;
                            }
                            for(var _i = 0; _i < 4; _i++)for(var j = 0; j < 256; j += 2){
                                res = BlowFish_Encrypt(ctx, Data1, Data2);
                                Data1 = res.left;
                                Data2 = res.right;
                                ctx.sbox[_i][j] = Data1;
                                ctx.sbox[_i][j + 1] = Data2;
                            }
                            return true;
                        }
                        /**
     * Blowfish block cipher algorithm.
     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
                            _doReset: function _doReset() {
                                // Skip reset of nRounds has been set before and key did not change
                                if (this._keyPriorReset === this._key) return;
                                // Shortcuts
                                var key = this._keyPriorReset = this._key;
                                var keyWords = key.words;
                                var keySize = key.sigBytes / 4;
                                //Initialization pbox and sbox
                                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                                M[offset] = res.left;
                                M[offset + 1] = res.right;
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                                M[offset] = res.left;
                                M[offset + 1] = res.right;
                            },
                            blockSize: 2,
                            keySize: 4,
                            ivSize: 2
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
                    })();
                    return CryptoJS.Blowfish;
                });
            /***/ },
            /***/ 52810: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                __webpack_require__(55862);
                __webpack_require__(10853);
                __webpack_require__(33290);
                __webpack_require__(45550);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(95194));
                })(void 0, function(CryptoJS) {
                    /**
   * Cipher core components.
   */ CryptoJS.lib.Cipher || function(undefined1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var WordArray = C_lib.WordArray;
                        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
                        var C_enc = C.enc;
                        var Utf8 = C_enc.Utf8;
                        var Base64 = C_enc.Base64;
                        var C_algo = C.algo;
                        var EvpKDF = C_algo.EvpKDF;
                        /**
     * Abstract base cipher template.
     *
     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
                            /**
       * Configuration options.
       *
       * @property {WordArray} iv The IV to use for this operation.
       */ cfg: Base.extend(),
                            /**
       * Creates this cipher in encryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
       */ createEncryptor: function createEncryptor(key, cfg) {
                                return this.create(this._ENC_XFORM_MODE, key, cfg);
                            },
                            /**
       * Creates this cipher in decryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
       */ createDecryptor: function createDecryptor(key, cfg) {
                                return this.create(this._DEC_XFORM_MODE, key, cfg);
                            },
                            /**
       * Initializes a newly created cipher.
       *
       * @param {number} xformMode Either the encryption or decryption transormation mode constant.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
       */ init: function init(xformMode, key, cfg) {
                                // Apply config defaults
                                this.cfg = this.cfg.extend(cfg);
                                // Store transform mode and key
                                this._xformMode = xformMode;
                                this._key = key;
                                // Set initial values
                                this.reset();
                            },
                            /**
       * Resets this cipher to its initial state.
       *
       * @example
       *
       *     cipher.reset();
       */ reset: function reset() {
                                // Reset data buffer
                                BufferedBlockAlgorithm.reset.call(this);
                                // Perform concrete-cipher logic
                                this._doReset();
                            },
                            /**
       * Adds data to be encrypted or decrypted.
       *
       * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
       *
       * @return {WordArray} The data after processing.
       *
       * @example
       *
       *     var encrypted = cipher.process('data');
       *     var encrypted = cipher.process(wordArray);
       */ process: function process(dataUpdate) {
                                // Append
                                this._append(dataUpdate);
                                // Process available blocks
                                return this._process();
                            },
                            /**
       * Finalizes the encryption or decryption process.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
       *
       * @return {WordArray} The data after final processing.
       *
       * @example
       *
       *     var encrypted = cipher.finalize();
       *     var encrypted = cipher.finalize('data');
       *     var encrypted = cipher.finalize(wordArray);
       */ finalize: function finalize(dataUpdate) {
                                // Final data update
                                if (dataUpdate) this._append(dataUpdate);
                                // Perform concrete-cipher logic
                                var finalProcessedData = this._doFinalize();
                                return finalProcessedData;
                            },
                            keySize: 4,
                            ivSize: 4,
                            _ENC_XFORM_MODE: 1,
                            _DEC_XFORM_MODE: 2,
                            /**
       * Creates shortcut functions to a cipher's object interface.
       *
       * @param {Cipher} cipher The cipher to create a helper for.
       *
       * @return {Object} An object with encrypt and decrypt shortcut functions.
       *
       * @static
       *
       * @example
       *
       *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
       */ _createHelper: function() {
                                function selectCipherStrategy(key) {
                                    if (typeof key == "string") return PasswordBasedCipher;
                                    else return SerializableCipher;
                                }
                                return function(cipher) {
                                    return {
                                        encrypt: function encrypt(message, key, cfg) {
                                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                                        },
                                        decrypt: function decrypt(ciphertext, key, cfg) {
                                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                                        }
                                    };
                                };
                            }()
                        });
                        /**
     * Abstract base stream cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
                            _doFinalize: function _doFinalize() {
                                // Process partial blocks
                                var finalProcessedBlocks = this._process(true);
                                return finalProcessedBlocks;
                            },
                            blockSize: 1
                        });
                        /**
     * Mode namespace.
     */ var C_mode = C.mode = {};
                        /**
     * Abstract base block cipher mode template.
     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
                            /**
       * Creates this mode for encryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
       */ createEncryptor: function createEncryptor(cipher, iv) {
                                return this.Encryptor.create(cipher, iv);
                            },
                            /**
       * Creates this mode for decryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
       */ createDecryptor: function createDecryptor(cipher, iv) {
                                return this.Decryptor.create(cipher, iv);
                            },
                            /**
       * Initializes a newly created mode.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
       */ init: function init(cipher, iv) {
                                this._cipher = cipher;
                                this._iv = iv;
                            }
                        });
                        /**
     * Cipher Block Chaining mode.
     */ var CBC = C_mode.CBC = function() {
                            /**
       * Abstract base CBC mode.
       */ var CBC = BlockCipherMode.extend();
                            /**
       * CBC encryptor.
       */ CBC.Encryptor = CBC.extend({
                                /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */ processBlock: function processBlock(words, offset) {
                                    // Shortcuts
                                    var cipher = this._cipher;
                                    var blockSize = cipher.blockSize;
                                    // XOR and encrypt
                                    xorBlock.call(this, words, offset, blockSize);
                                    cipher.encryptBlock(words, offset);
                                    // Remember this block to use with next block
                                    this._prevBlock = words.slice(offset, offset + blockSize);
                                }
                            });
                            /**
       * CBC decryptor.
       */ CBC.Decryptor = CBC.extend({
                                /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */ processBlock: function processBlock(words, offset) {
                                    // Shortcuts
                                    var cipher = this._cipher;
                                    var blockSize = cipher.blockSize;
                                    // Remember this block to use with next block
                                    var thisBlock = words.slice(offset, offset + blockSize);
                                    // Decrypt and XOR
                                    cipher.decryptBlock(words, offset);
                                    xorBlock.call(this, words, offset, blockSize);
                                    // This block becomes the previous block
                                    this._prevBlock = thisBlock;
                                }
                            });
                            function xorBlock(words, offset, blockSize) {
                                var block;
                                // Shortcut
                                var iv = this._iv;
                                // Choose mixing block
                                if (iv) {
                                    block = iv;
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined1;
                                } else block = this._prevBlock;
                                // XOR blocks
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
                            }
                            return CBC;
                        }();
                        /**
     * Padding namespace.
     */ var C_pad = C.pad = {};
                        /**
     * PKCS #5/7 padding strategy.
     */ var Pkcs7 = C_pad.Pkcs7 = {
                            /**
       * Pads data using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to pad.
       * @param {number} blockSize The multiple that the data should be padded to.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
       */ pad: function pad(data, blockSize) {
                                // Shortcut
                                var blockSizeBytes = blockSize * 4;
                                // Count padding bytes
                                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                                // Create padding word
                                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                                // Create padding
                                var paddingWords = [];
                                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                                var padding = WordArray.create(paddingWords, nPaddingBytes);
                                // Add padding
                                data.concat(padding);
                            },
                            /**
       * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to unpad.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.unpad(wordArray);
       */ unpad: function unpad(data) {
                                // Get number of padding bytes from last byte
                                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                                // Remove padding
                                data.sigBytes -= nPaddingBytes;
                            }
                        };
                        /**
     * Abstract base block cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
                            /**
       * Configuration options.
       *
       * @property {Mode} mode The block mode to use. Default: CBC
       * @property {Padding} padding The padding strategy to use. Default: Pkcs7
       */ cfg: Cipher.cfg.extend({
                                mode: CBC,
                                padding: Pkcs7
                            }),
                            reset: function reset() {
                                var modeCreator;
                                // Reset cipher
                                Cipher.reset.call(this);
                                // Shortcuts
                                var cfg = this.cfg;
                                var iv = cfg.iv;
                                var mode = cfg.mode;
                                // Reset block mode
                                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                    modeCreator = mode.createDecryptor;
                                    // Keep at least one block in the buffer for unpadding
                                    this._minBufferSize = 1;
                                }
                                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                                else {
                                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                                    this._mode.__creator = modeCreator;
                                }
                            },
                            _doProcessBlock: function _doProcessBlock(words, offset) {
                                this._mode.processBlock(words, offset);
                            },
                            _doFinalize: function _doFinalize() {
                                var finalProcessedBlocks;
                                // Shortcut
                                var padding = this.cfg.padding;
                                // Finalize
                                if (this._xformMode == this._ENC_XFORM_MODE) {
                                    // Pad data
                                    padding.pad(this._data, this.blockSize);
                                    // Process final blocks
                                    finalProcessedBlocks = this._process(true);
                                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                    // Process final blocks
                                    finalProcessedBlocks = this._process(true);
                                    // Unpad data
                                    padding.unpad(finalProcessedBlocks);
                                }
                                return finalProcessedBlocks;
                            },
                            blockSize: 4
                        });
                        /**
     * A collection of cipher parameters.
     *
     * @property {WordArray} ciphertext The raw ciphertext.
     * @property {WordArray} key The key to this ciphertext.
     * @property {WordArray} iv The IV used in the ciphering operation.
     * @property {WordArray} salt The salt used with a key derivation function.
     * @property {Cipher} algorithm The cipher algorithm.
     * @property {Mode} mode The block mode used in the ciphering operation.
     * @property {Padding} padding The padding scheme used in the ciphering operation.
     * @property {number} blockSize The block size of the cipher.
     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
     */ var CipherParams = C_lib.CipherParams = Base.extend({
                            /**
       * Initializes a newly created cipher params object.
       *
       * @param {Object} cipherParams An object with any of the possible cipher parameters.
       *
       * @example
       *
       *     var cipherParams = CryptoJS.lib.CipherParams.create({
       *         ciphertext: ciphertextWordArray,
       *         key: keyWordArray,
       *         iv: ivWordArray,
       *         salt: saltWordArray,
       *         algorithm: CryptoJS.algo.AES,
       *         mode: CryptoJS.mode.CBC,
       *         padding: CryptoJS.pad.PKCS7,
       *         blockSize: 4,
       *         formatter: CryptoJS.format.OpenSSL
       *     });
       */ init: function init(cipherParams) {
                                this.mixIn(cipherParams);
                            },
                            /**
       * Converts this cipher params object to a string.
       *
       * @param {Format} formatter (Optional) The formatting strategy to use.
       *
       * @return {string} The stringified cipher params.
       *
       * @throws Error If neither the formatter nor the default formatter is set.
       *
       * @example
       *
       *     var string = cipherParams + '';
       *     var string = cipherParams.toString();
       *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
       */ toString: function toString(formatter) {
                                return (formatter || this.formatter).stringify(this);
                            }
                        });
                        /**
     * Format namespace.
     */ var C_format = C.format = {};
                        /**
     * OpenSSL formatting strategy.
     */ var OpenSSLFormatter = C_format.OpenSSL = {
                            /**
       * Converts a cipher params object to an OpenSSL-compatible string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The OpenSSL-compatible string.
       *
       * @static
       *
       * @example
       *
       *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
       */ stringify: function stringify(cipherParams) {
                                var wordArray;
                                // Shortcuts
                                var ciphertext = cipherParams.ciphertext;
                                var salt = cipherParams.salt;
                                // Format
                                if (salt) wordArray = WordArray.create([
                                    0x53616c74,
                                    0x65645f5f
                                ]).concat(salt).concat(ciphertext);
                                else wordArray = ciphertext;
                                return wordArray.toString(Base64);
                            },
                            /**
       * Converts an OpenSSL-compatible string to a cipher params object.
       *
       * @param {string} openSSLStr The OpenSSL-compatible string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
       */ parse: function parse(openSSLStr) {
                                var salt;
                                // Parse base64
                                var ciphertext = Base64.parse(openSSLStr);
                                // Shortcut
                                var ciphertextWords = ciphertext.words;
                                // Test for salt
                                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                                    // Extract salt
                                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                                    // Remove salt from ciphertext
                                    ciphertextWords.splice(0, 4);
                                    ciphertext.sigBytes -= 16;
                                }
                                return CipherParams.create({
                                    ciphertext: ciphertext,
                                    salt: salt
                                });
                            }
                        };
                        /**
     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
                            /**
       * Configuration options.
       *
       * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
       */ cfg: Base.extend({
                                format: OpenSSLFormatter
                            }),
                            /**
       * Encrypts a message.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */ encrypt: function encrypt(cipher, message, key, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Encrypt
                                var encryptor = cipher.createEncryptor(key, cfg);
                                var ciphertext = encryptor.finalize(message);
                                // Shortcut
                                var cipherCfg = encryptor.cfg;
                                // Create and return serializable cipher params
                                return CipherParams.create({
                                    ciphertext: ciphertext,
                                    key: key,
                                    iv: cipherCfg.iv,
                                    algorithm: cipher,
                                    mode: cipherCfg.mode,
                                    padding: cipherCfg.padding,
                                    blockSize: cipher.blockSize,
                                    formatter: cfg.format
                                });
                            },
                            /**
       * Decrypts serialized ciphertext.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */ decrypt: function decrypt(cipher, ciphertext, key, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Convert string to CipherParams
                                ciphertext = this._parse(ciphertext, cfg.format);
                                // Decrypt
                                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                                return plaintext;
                            },
                            /**
       * Converts serialized ciphertext to CipherParams,
       * else assumed CipherParams already and returns ciphertext unchanged.
       *
       * @param {CipherParams|string} ciphertext The ciphertext.
       * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
       *
       * @return {CipherParams} The unserialized ciphertext.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
       */ _parse: function _parse(ciphertext, format) {
                                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                                else return ciphertext;
                            }
                        });
                        /**
     * Key derivation function namespace.
     */ var C_kdf = C.kdf = {};
                        /**
     * OpenSSL key derivation function.
     */ var OpenSSLKdf = C_kdf.OpenSSL = {
                            /**
       * Derives a key and IV from a password.
       *
       * @param {string} password The password to derive from.
       * @param {number} keySize The size in words of the key to generate.
       * @param {number} ivSize The size in words of the IV to generate.
       * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
       *
       * @return {CipherParams} A cipher params object with the key, IV, and salt.
       *
       * @static
       *
       * @example
       *
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
       */ execute: function execute(password, keySize, ivSize, salt, hasher) {
                                // Generate random salt
                                if (!salt) salt = WordArray.random(8);
                                // Derive key and IV
                                if (!hasher) var key = EvpKDF.create({
                                    keySize: keySize + ivSize
                                }).compute(password, salt);
                                else var key = EvpKDF.create({
                                    keySize: keySize + ivSize,
                                    hasher: hasher
                                }).compute(password, salt);
                                // Separate key and IV
                                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                                key.sigBytes = keySize * 4;
                                // Return params
                                return CipherParams.create({
                                    key: key,
                                    iv: iv,
                                    salt: salt
                                });
                            }
                        };
                        /**
     * A serializable cipher wrapper that derives the key from a password,
     * and returns ciphertext as a serializable cipher params object.
     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
                            /**
       * Configuration options.
       *
       * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
       */ cfg: SerializableCipher.cfg.extend({
                                kdf: OpenSSLKdf
                            }),
                            /**
       * Encrypts a message using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
       */ encrypt: function encrypt(cipher, message, password, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Derive key and other params
                                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                                // Add IV to config
                                cfg.iv = derivedParams.iv;
                                // Encrypt
                                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                                // Mix in derived params
                                ciphertext.mixIn(derivedParams);
                                return ciphertext;
                            },
                            /**
       * Decrypts serialized ciphertext using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
       */ decrypt: function decrypt(cipher, ciphertext, password, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Convert string to CipherParams
                                ciphertext = this._parse(ciphertext, cfg.format);
                                // Derive key and other params
                                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                                // Add IV to config
                                cfg.iv = derivedParams.iv;
                                // Decrypt
                                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                                return plaintext;
                            }
                        });
                    }();
                });
            /***/ },
            /***/ 53264: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(4116);
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(35779);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(33290);
                __webpack_require__(18821);
                __webpack_require__(85005);
                __webpack_require__(55862);
                __webpack_require__(45550);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory();
                })(void 0, function() {
                    /*globals window, global, require*/ /**
   * CryptoJS core components.
   */ var CryptoJS = CryptoJS || function(Math1, undefined1) {
                        var crypto;
                        // Native crypto from window (Browser)
                        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
                        // Native crypto in web worker (Browser)
                        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
                        // Native crypto from worker
                        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
                        // Native (experimental IE 11) crypto from window (Browser)
                        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
                        // Native crypto from global (NodeJS)
                        if (!crypto && typeof __webpack_require__.g !== "undefined" && __webpack_require__.g.crypto) crypto = __webpack_require__.g.crypto;
                        // Native crypto import via require (NodeJS)
                        if (!crypto && true) try {
                            crypto = __webpack_require__(42480);
                        } catch (err) {}
                        /*
     * Cryptographically secure pseudorandom number generator
     *
     * As Math.random() is cryptographically not safe to use
     */ var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
                            if (crypto) {
                                // Use getRandomValues method (Browser)
                                if (typeof crypto.getRandomValues === "function") try {
                                    return crypto.getRandomValues(new Uint32Array(1))[0];
                                } catch (err) {}
                                // Use randomBytes method (NodeJS)
                                if (typeof crypto.randomBytes === "function") try {
                                    return crypto.randomBytes(4).readInt32LE();
                                } catch (err) {}
                            }
                            throw new Error("Native crypto module could not be used to get secure random number.");
                        };
                        /*
     * Local polyfill of Object.create
      */ var create = Object.create || function() {
                            function F() {}
                            return function(obj) {
                                var subtype;
                                F.prototype = obj;
                                subtype = new F();
                                F.prototype = null;
                                return subtype;
                            };
                        }();
                        /**
     * CryptoJS namespace.
     */ var C = {};
                        /**
     * Library namespace.
     */ var C_lib = C.lib = {};
                        /**
     * Base object for prototypal inheritance.
     */ var Base = C_lib.Base = function() {
                            return {
                                /**
         * Creates a new object that inherits from this object.
         *
         * @param {Object} overrides Properties to copy into the new object.
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         field: 'value',
         *
         *         method: function () {
         *         }
         *     });
         */ extend: function extend(overrides) {
                                    // Spawn
                                    var subtype = create(this);
                                    // Augment
                                    if (overrides) subtype.mixIn(overrides);
                                    // Create default initializer
                                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                                        subtype.$super.init.apply(this, arguments);
                                    };
                                    // Initializer's prototype is the subtype object
                                    subtype.init.prototype = subtype;
                                    // Reference supertype
                                    subtype.$super = this;
                                    return subtype;
                                },
                                /**
         * Extends this object and runs the init method.
         * Arguments to create() will be passed to init().
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var instance = MyType.create();
         */ create: function create() {
                                    var instance = this.extend();
                                    instance.init.apply(instance, arguments);
                                    return instance;
                                },
                                /**
         * Initializes a newly created object.
         * Override this method to add some logic when your objects are created.
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         init: function () {
         *             // ...
         *         }
         *     });
         */ init: function init() {},
                                /**
         * Copies properties into this object.
         *
         * @param {Object} properties The properties to mix in.
         *
         * @example
         *
         *     MyType.mixIn({
         *         field: 'value'
         *     });
         */ mixIn: function mixIn(properties) {
                                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                                    // IE won't copy toString using the loop above
                                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                                },
                                /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = instance.clone();
         */ clone: function clone() {
                                    return this.init.prototype.extend(this);
                                }
                            };
                        }();
                        /**
     * An array of 32-bit words.
     *
     * @property {Array} words The array of 32-bit words.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */ var WordArray = C_lib.WordArray = Base.extend({
                            /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of 32-bit words.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.create();
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
       */ init: function init(words, sigBytes) {
                                words = this.words = words || [];
                                if (sigBytes != undefined1) this.sigBytes = sigBytes;
                                else this.sigBytes = words.length * 4;
                            },
                            /**
       * Converts this word array to a string.
       *
       * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
       *
       * @return {string} The stringified word array.
       *
       * @example
       *
       *     var string = wordArray + '';
       *     var string = wordArray.toString();
       *     var string = wordArray.toString(CryptoJS.enc.Utf8);
       */ toString: function toString(encoder) {
                                return (encoder || Hex).stringify(this);
                            },
                            /**
       * Concatenates a word array to this word array.
       *
       * @param {WordArray} wordArray The word array to append.
       *
       * @return {WordArray} This word array.
       *
       * @example
       *
       *     wordArray1.concat(wordArray2);
       */ concat: function concat(wordArray) {
                                // Shortcuts
                                var thisWords = this.words;
                                var thatWords = wordArray.words;
                                var thisSigBytes = this.sigBytes;
                                var thatSigBytes = wordArray.sigBytes;
                                // Clamp excess bits
                                this.clamp();
                                // Concat
                                if (thisSigBytes % 4) // Copy one byte at a time
                                for(var i = 0; i < thatSigBytes; i++){
                                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                                }
                                else // Copy one word at a time
                                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                                this.sigBytes += thatSigBytes;
                                // Chainable
                                return this;
                            },
                            /**
       * Removes insignificant bits.
       *
       * @example
       *
       *     wordArray.clamp();
       */ clamp: function clamp() {
                                // Shortcuts
                                var words = this.words;
                                var sigBytes = this.sigBytes;
                                // Clamp
                                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                                words.length = Math1.ceil(sigBytes / 4);
                            },
                            /**
       * Creates a copy of this word array.
       *
       * @return {WordArray} The clone.
       *
       * @example
       *
       *     var clone = wordArray.clone();
       */ clone: function clone() {
                                var clone = Base.clone.call(this);
                                clone.words = this.words.slice(0);
                                return clone;
                            },
                            /**
       * Creates a word array filled with random bytes.
       *
       * @param {number} nBytes The number of random bytes to generate.
       *
       * @return {WordArray} The random word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.random(16);
       */ random: function random(nBytes) {
                                var words = [];
                                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                                return new WordArray.init(words, nBytes);
                            }
                        });
                        /**
     * Encoder namespace.
     */ var C_enc = C.enc = {};
                        /**
     * Hex encoding strategy.
     */ var Hex = C_enc.Hex = {
                            /**
       * Converts a word array to a hex string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The hex string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var hexChars = [];
                                for(var i = 0; i < sigBytes; i++){
                                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    hexChars.push((bite >>> 4).toString(16));
                                    hexChars.push((bite & 0x0f).toString(16));
                                }
                                return hexChars.join("");
                            },
                            /**
       * Converts a hex string to a word array.
       *
       * @param {string} hexStr The hex string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
       */ parse: function parse(hexStr) {
                                // Shortcut
                                var hexStrLength = hexStr.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                                return new WordArray.init(words, hexStrLength / 2);
                            }
                        };
                        /**
     * Latin1 encoding strategy.
     */ var Latin1 = C_enc.Latin1 = {
                            /**
       * Converts a word array to a Latin1 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Latin1 string.
       *
       * @static
       *
       * @example
       *
       *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var latin1Chars = [];
                                for(var i = 0; i < sigBytes; i++){
                                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    latin1Chars.push(String.fromCharCode(bite));
                                }
                                return latin1Chars.join("");
                            },
                            /**
       * Converts a Latin1 string to a word array.
       *
       * @param {string} latin1Str The Latin1 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
       */ parse: function parse(latin1Str) {
                                // Shortcut
                                var latin1StrLength = latin1Str.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                                return new WordArray.init(words, latin1StrLength);
                            }
                        };
                        /**
     * UTF-8 encoding strategy.
     */ var Utf8 = C_enc.Utf8 = {
                            /**
       * Converts a word array to a UTF-8 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-8 string.
       *
       * @static
       *
       * @example
       *
       *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                try {
                                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                                } catch (e) {
                                    throw new Error("Malformed UTF-8 data");
                                }
                            },
                            /**
       * Converts a UTF-8 string to a word array.
       *
       * @param {string} utf8Str The UTF-8 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
       */ parse: function parse(utf8Str) {
                                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
                            }
                        };
                        /**
     * Abstract buffered block algorithm template.
     *
     * The property blockSize must be implemented in a concrete subtype.
     *
     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
                            /**
       * Resets this block algorithm's data buffer to its initial state.
       *
       * @example
       *
       *     bufferedBlockAlgorithm.reset();
       */ reset: function reset() {
                                // Initial values
                                this._data = new WordArray.init();
                                this._nDataBytes = 0;
                            },
                            /**
       * Adds new data to this block algorithm's buffer.
       *
       * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
       *
       * @example
       *
       *     bufferedBlockAlgorithm._append('data');
       *     bufferedBlockAlgorithm._append(wordArray);
       */ _append: function _append(data) {
                                // Convert string to WordArray, else assume WordArray already
                                if (typeof data == "string") data = Utf8.parse(data);
                                // Append
                                this._data.concat(data);
                                this._nDataBytes += data.sigBytes;
                            },
                            /**
       * Processes available data blocks.
       *
       * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
       *
       * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
       *
       * @return {WordArray} The processed data.
       *
       * @example
       *
       *     var processedData = bufferedBlockAlgorithm._process();
       *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
       */ _process: function _process(doFlush) {
                                var processedWords;
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var dataSigBytes = data.sigBytes;
                                var blockSize = this.blockSize;
                                var blockSizeBytes = blockSize * 4;
                                // Count blocks ready
                                var nBlocksReady = dataSigBytes / blockSizeBytes;
                                if (doFlush) // Round up to include partial blocks
                                nBlocksReady = Math1.ceil(nBlocksReady);
                                else // Round down to include only full blocks,
                                // less the number of blocks that must remain in the buffer
                                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                                // Count words ready
                                var nWordsReady = nBlocksReady * blockSize;
                                // Count bytes ready
                                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                                // Process blocks
                                if (nWordsReady) {
                                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                                    this._doProcessBlock(dataWords, offset);
                                    // Remove processed words
                                    processedWords = dataWords.splice(0, nWordsReady);
                                    data.sigBytes -= nBytesReady;
                                }
                                // Return processed words
                                return new WordArray.init(processedWords, nBytesReady);
                            },
                            /**
       * Creates a copy of this object.
       *
       * @return {Object} The clone.
       *
       * @example
       *
       *     var clone = bufferedBlockAlgorithm.clone();
       */ clone: function clone() {
                                var clone = Base.clone.call(this);
                                clone._data = this._data.clone();
                                return clone;
                            },
                            _minBufferSize: 0
                        });
                        /**
     * Abstract hasher template.
     *
     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
                            /**
       * Configuration options.
       */ cfg: Base.extend(),
                            /**
       * Initializes a newly created hasher.
       *
       * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
       *
       * @example
       *
       *     var hasher = CryptoJS.algo.SHA256.create();
       */ init: function init(cfg) {
                                // Apply config defaults
                                this.cfg = this.cfg.extend(cfg);
                                // Set initial values
                                this.reset();
                            },
                            /**
       * Resets this hasher to its initial state.
       *
       * @example
       *
       *     hasher.reset();
       */ reset: function reset() {
                                // Reset data buffer
                                BufferedBlockAlgorithm.reset.call(this);
                                // Perform concrete-hasher logic
                                this._doReset();
                            },
                            /**
       * Updates this hasher with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {Hasher} This hasher.
       *
       * @example
       *
       *     hasher.update('message');
       *     hasher.update(wordArray);
       */ update: function update(messageUpdate) {
                                // Append
                                this._append(messageUpdate);
                                // Update the hash
                                this._process();
                                // Chainable
                                return this;
                            },
                            /**
       * Finalizes the hash computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The hash.
       *
       * @example
       *
       *     var hash = hasher.finalize();
       *     var hash = hasher.finalize('message');
       *     var hash = hasher.finalize(wordArray);
       */ finalize: function finalize(messageUpdate) {
                                // Final message update
                                if (messageUpdate) this._append(messageUpdate);
                                // Perform concrete-hasher logic
                                var hash = this._doFinalize();
                                return hash;
                            },
                            blockSize: 16,
                            /**
       * Creates a shortcut function to a hasher's object interface.
       *
       * @param {Hasher} hasher The hasher to create a helper for.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
       */ _createHelper: function _createHelper(hasher) {
                                return function(message, cfg) {
                                    return new hasher.init(cfg).finalize(message);
                                };
                            },
                            /**
       * Creates a shortcut function to the HMAC's object interface.
       *
       * @param {Hasher} hasher The hasher to use in this HMAC helper.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
       */ _createHmacHelper: function _createHmacHelper(hasher) {
                                return function(message, key) {
                                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                                };
                            }
                        });
                        /**
     * Algorithm namespace.
     */ var C_algo = C.algo = {};
                        return C;
                    }(Math);
                    return CryptoJS;
                });
            /***/ },
            /***/ 31946: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(85005);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_enc = C.enc;
                        /**
     * Base64 encoding strategy.
     */ var Base64 = C_enc.Base64 = {
                            /**
       * Converts a word array to a Base64 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Base64 string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                var map = this._map;
                                // Clamp excess bits
                                wordArray.clamp();
                                // Convert
                                var base64Chars = [];
                                for(var i = 0; i < sigBytes; i += 3){
                                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                                }
                                // Add padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                                return base64Chars.join("");
                            },
                            /**
       * Converts a Base64 string to a word array.
       *
       * @param {string} base64Str The Base64 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
       */ parse: function parse(base64Str) {
                                // Shortcuts
                                var base64StrLength = base64Str.length;
                                var map = this._map;
                                var reverseMap = this._reverseMap;
                                if (!reverseMap) {
                                    reverseMap = this._reverseMap = [];
                                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                                }
                                // Ignore padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) {
                                    var paddingIndex = base64Str.indexOf(paddingChar);
                                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                                }
                                // Convert
                                return parseLoop(base64Str, base64StrLength, reverseMap);
                            },
                            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
                        };
                        function parseLoop(base64Str, base64StrLength, reverseMap) {
                            var words = [];
                            var nBytes = 0;
                            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                                var bitsCombined = bits1 | bits2;
                                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                                nBytes++;
                            }
                            return WordArray.create(words, nBytes);
                        }
                    })();
                    return CryptoJS.enc.Base64;
                });
            /***/ },
            /***/ 30961: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(85005);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_enc = C.enc;
                        /**
     * Base64url encoding strategy.
     */ var Base64url = C_enc.Base64url = {
                            /**
       * Converts a word array to a Base64url string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {string} The Base64url string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
       */ stringify: function stringify(wordArray, urlSafe) {
                                if (urlSafe === undefined) urlSafe = true;
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                var map = urlSafe ? this._safe_map : this._map;
                                // Clamp excess bits
                                wordArray.clamp();
                                // Convert
                                var base64Chars = [];
                                for(var i = 0; i < sigBytes; i += 3){
                                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                                }
                                // Add padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                                return base64Chars.join("");
                            },
                            /**
       * Converts a Base64url string to a word array.
       *
       * @param {string} base64Str The Base64url string.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
       */ parse: function parse(base64Str, urlSafe) {
                                if (urlSafe === undefined) urlSafe = true;
                                // Shortcuts
                                var base64StrLength = base64Str.length;
                                var map = urlSafe ? this._safe_map : this._map;
                                var reverseMap = this._reverseMap;
                                if (!reverseMap) {
                                    reverseMap = this._reverseMap = [];
                                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                                }
                                // Ignore padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) {
                                    var paddingIndex = base64Str.indexOf(paddingChar);
                                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                                }
                                // Convert
                                return parseLoop(base64Str, base64StrLength, reverseMap);
                            },
                            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
                        };
                        function parseLoop(base64Str, base64StrLength, reverseMap) {
                            var words = [];
                            var nBytes = 0;
                            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                                var bitsCombined = bits1 | bits2;
                                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                                nBytes++;
                            }
                            return WordArray.create(words, nBytes);
                        }
                    })();
                    return CryptoJS.enc.Base64url;
                });
            /***/ },
            /***/ 44087: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(85005);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_enc = C.enc;
                        /**
     * UTF-16 BE encoding strategy.
     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
                            /**
       * Converts a word array to a UTF-16 BE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 BE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var utf16Chars = [];
                                for(var i = 0; i < sigBytes; i += 2){
                                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                                    utf16Chars.push(String.fromCharCode(codePoint));
                                }
                                return utf16Chars.join("");
                            },
                            /**
       * Converts a UTF-16 BE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 BE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
       */ parse: function parse(utf16Str) {
                                // Shortcut
                                var utf16StrLength = utf16Str.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                                return WordArray.create(words, utf16StrLength * 2);
                            }
                        };
                        /**
     * UTF-16 LE encoding strategy.
     */ C_enc.Utf16LE = {
                            /**
       * Converts a word array to a UTF-16 LE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 LE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var utf16Chars = [];
                                for(var i = 0; i < sigBytes; i += 2){
                                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                                    utf16Chars.push(String.fromCharCode(codePoint));
                                }
                                return utf16Chars.join("");
                            },
                            /**
       * Converts a UTF-16 LE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 LE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
       */ parse: function parse(utf16Str) {
                                // Shortcut
                                var utf16StrLength = utf16Str.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                                return WordArray.create(words, utf16StrLength * 2);
                            }
                        };
                        function swapEndian(word) {
                            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
                        }
                    })();
                    return CryptoJS.enc.Utf16;
                });
            /***/ },
            /***/ 95194: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(55862);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(61977), __webpack_require__(5577));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var WordArray = C_lib.WordArray;
                        var C_algo = C.algo;
                        var MD5 = C_algo.MD5;
                        /**
     * This key derivation function is meant to conform with EVP_BytesToKey.
     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
                            /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hash algorithm to use. Default: MD5
       * @property {number} iterations The number of iterations to perform. Default: 1
       */ cfg: Base.extend({
                                keySize: 4,
                                hasher: MD5,
                                iterations: 1
                            }),
                            /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.EvpKDF.create();
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
       */ init: function init(cfg) {
                                this.cfg = this.cfg.extend(cfg);
                            },
                            /**
       * Derives a key from a password.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */ compute: function compute(password, salt) {
                                var block;
                                // Shortcut
                                var cfg = this.cfg;
                                // Init hasher
                                var hasher = cfg.hasher.create();
                                // Initial values
                                var derivedKey = WordArray.create();
                                // Shortcuts
                                var derivedKeyWords = derivedKey.words;
                                var keySize = cfg.keySize;
                                var iterations = cfg.iterations;
                                // Generate key
                                while(derivedKeyWords.length < keySize){
                                    if (block) hasher.update(block);
                                    block = hasher.update(password).finalize(salt);
                                    hasher.reset();
                                    // Iterations
                                    for(var i = 1; i < iterations; i++){
                                        block = hasher.finalize(block);
                                        hasher.reset();
                                    }
                                    derivedKey.concat(block);
                                }
                                derivedKey.sigBytes = keySize * 4;
                                return derivedKey;
                            }
                        });
                        /**
     * Derives a key from a password.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.EvpKDF(password, salt);
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
     */ C.EvpKDF = function(password, salt, cfg) {
                            return EvpKDF.create(cfg).compute(password, salt);
                        };
                    })();
                    return CryptoJS.EvpKDF;
                });
            /***/ },
            /***/ 3902: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(10853);
                __webpack_require__(33290);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function(undefined1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var CipherParams = C_lib.CipherParams;
                        var C_enc = C.enc;
                        var Hex = C_enc.Hex;
                        var C_format = C.format;
                        var HexFormatter = C_format.Hex = {
                            /**
       * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The hexadecimally encoded string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
       */ stringify: function stringify(cipherParams) {
                                return cipherParams.ciphertext.toString(Hex);
                            },
                            /**
       * Converts a hexadecimally encoded ciphertext string to a cipher params object.
       *
       * @param {string} input The hexadecimally encoded string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
       */ parse: function parse(input) {
                                var ciphertext = Hex.parse(input);
                                return CipherParams.create({
                                    ciphertext: ciphertext
                                });
                            }
                        };
                    })();
                    return CryptoJS.format.Hex;
                });
            /***/ },
            /***/ 5577: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(55862);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var C_enc = C.enc;
                        var Utf8 = C_enc.Utf8;
                        var C_algo = C.algo;
                        /**
     * HMAC algorithm.
     */ var HMAC = C_algo.HMAC = Base.extend({
                            /**
       * Initializes a newly created HMAC.
       *
       * @param {Hasher} hasher The hash algorithm to use.
       * @param {WordArray|string} key The secret key.
       *
       * @example
       *
       *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
       */ init: function init(hasher, key) {
                                // Init hasher
                                hasher = this._hasher = new hasher.init();
                                // Convert string to WordArray, else assume WordArray already
                                if (typeof key == "string") key = Utf8.parse(key);
                                // Shortcuts
                                var hasherBlockSize = hasher.blockSize;
                                var hasherBlockSizeBytes = hasherBlockSize * 4;
                                // Allow arbitrary length keys
                                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                                // Clamp excess bits
                                key.clamp();
                                // Clone key for inner and outer pads
                                var oKey = this._oKey = key.clone();
                                var iKey = this._iKey = key.clone();
                                // Shortcuts
                                var oKeyWords = oKey.words;
                                var iKeyWords = iKey.words;
                                // XOR keys with pad constants
                                for(var i = 0; i < hasherBlockSize; i++){
                                    oKeyWords[i] ^= 0x5c5c5c5c;
                                    iKeyWords[i] ^= 0x36363636;
                                }
                                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                                // Set initial values
                                this.reset();
                            },
                            /**
       * Resets this HMAC to its initial state.
       *
       * @example
       *
       *     hmacHasher.reset();
       */ reset: function reset() {
                                // Shortcut
                                var hasher = this._hasher;
                                // Reset
                                hasher.reset();
                                hasher.update(this._iKey);
                            },
                            /**
       * Updates this HMAC with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {HMAC} This HMAC instance.
       *
       * @example
       *
       *     hmacHasher.update('message');
       *     hmacHasher.update(wordArray);
       */ update: function update(messageUpdate) {
                                this._hasher.update(messageUpdate);
                                // Chainable
                                return this;
                            },
                            /**
       * Finalizes the HMAC computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The HMAC.
       *
       * @example
       *
       *     var hmac = hmacHasher.finalize();
       *     var hmac = hmacHasher.finalize('message');
       *     var hmac = hmacHasher.finalize(wordArray);
       */ finalize: function finalize(messageUpdate) {
                                // Shortcut
                                var hasher = this._hasher;
                                // Compute HMAC
                                var innerHash = hasher.finalize(messageUpdate);
                                hasher.reset();
                                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                                return hmac;
                            }
                        });
                    })();
                });
            /***/ },
            /***/ 35243: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(23204), __webpack_require__(70879), __webpack_require__(44087), __webpack_require__(31946), __webpack_require__(30961), __webpack_require__(57510), __webpack_require__(61977), __webpack_require__(85209), __webpack_require__(11707), __webpack_require__(20595), __webpack_require__(21410), __webpack_require__(11691), __webpack_require__(53601), __webpack_require__(5577), __webpack_require__(75883), __webpack_require__(95194), __webpack_require__(52810), __webpack_require__(90347), __webpack_require__(54032), __webpack_require__(63197), __webpack_require__(38710), __webpack_require__(21123), __webpack_require__(93007), __webpack_require__(7489), __webpack_require__(91695), __webpack_require__(29556), __webpack_require__(68028), __webpack_require__(3902), __webpack_require__(22449), __webpack_require__(77059), __webpack_require__(97690), __webpack_require__(24222), __webpack_require__(79338), __webpack_require__(67646));
                })(void 0, function(CryptoJS) {
                    return CryptoJS;
                });
            /***/ },
            /***/ 70879: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(36501);
                __webpack_require__(10853);
                __webpack_require__(54883);
                __webpack_require__(79627);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(33324);
                __webpack_require__(71228);
                __webpack_require__(100);
                __webpack_require__(51360);
                __webpack_require__(26770);
                __webpack_require__(35779);
                __webpack_require__(31120);
                __webpack_require__(85569);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Check if typed arrays are supported
                        if (typeof ArrayBuffer != "function") return;
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        // Reference original init
                        var superInit = WordArray.init;
                        // Augment WordArray.init to handle typed arrays
                        var subInit = WordArray.init = function(typedArray) {
                            // Convert buffers to uint8
                            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
                            // Convert other array views to uint8
                            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
                            // Handle Uint8Array
                            if (typedArray instanceof Uint8Array) {
                                // Shortcut
                                var typedArrayByteLength = typedArray.byteLength;
                                // Extract bytes
                                var words = [];
                                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                                // Initialize this word array
                                superInit.call(this, words, typedArrayByteLength);
                            } else // Else call normal init
                            superInit.apply(this, arguments);
                        };
                        subInit.prototype = WordArray;
                    })();
                    return CryptoJS.lib.WordArray;
                });
            /***/ },
            /***/ 57510: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Constants table
                        var T = [];
                        // Compute constants
                        (function() {
                            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
                        })();
                        /**
     * MD5 hash algorithm.
     */ var MD5 = C_algo.MD5 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init([
                                    0x67452301,
                                    0xefcdab89,
                                    0x98badcfe,
                                    0x10325476
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Swap endian
                                for(var i = 0; i < 16; i++){
                                    // Shortcuts
                                    var offset_i = offset + i;
                                    var M_offset_i = M[offset_i];
                                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                                }
                                // Shortcuts
                                var H = this._hash.words;
                                var M_offset_0 = M[offset + 0];
                                var M_offset_1 = M[offset + 1];
                                var M_offset_2 = M[offset + 2];
                                var M_offset_3 = M[offset + 3];
                                var M_offset_4 = M[offset + 4];
                                var M_offset_5 = M[offset + 5];
                                var M_offset_6 = M[offset + 6];
                                var M_offset_7 = M[offset + 7];
                                var M_offset_8 = M[offset + 8];
                                var M_offset_9 = M[offset + 9];
                                var M_offset_10 = M[offset + 10];
                                var M_offset_11 = M[offset + 11];
                                var M_offset_12 = M[offset + 12];
                                var M_offset_13 = M[offset + 13];
                                var M_offset_14 = M[offset + 14];
                                var M_offset_15 = M[offset + 15];
                                // Working variables
                                var a = H[0];
                                var b = H[1];
                                var c = H[2];
                                var d = H[3];
                                // Computation
                                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                                // Intermediate hash value
                                H[0] = H[0] + a | 0;
                                H[1] = H[1] + b | 0;
                                H[2] = H[2] + c | 0;
                                H[3] = H[3] + d | 0;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                                var nBitsTotalL = nBitsTotal;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                                data.sigBytes = (dataWords.length + 1) * 4;
                                // Hash final blocks
                                this._process();
                                // Shortcuts
                                var hash = this._hash;
                                var H = hash.words;
                                // Swap endian
                                for(var i = 0; i < 4; i++){
                                    // Shortcut
                                    var H_i = H[i];
                                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                                }
                                // Return final computed hash
                                return hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        function FF(a, b, c, d, x, s, t) {
                            var n = a + (b & c | ~b & d) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        function GG(a, b, c, d, x, s, t) {
                            var n = a + (b & d | c & ~d) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        function HH(a, b, c, d, x, s, t) {
                            var n = a + (b ^ c ^ d) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        function II(a, b, c, d, x, s, t) {
                            var n = a + (c ^ (b | ~d)) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.MD5('message');
     *     var hash = CryptoJS.MD5(wordArray);
     */ C.MD5 = Hasher._createHelper(MD5);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacMD5(message, key);
     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
                    })(Math);
                    return CryptoJS.MD5;
                });
            /***/ },
            /***/ 90347: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * Cipher Feedback block mode.
   */ CryptoJS.mode.CFB = function() {
                        var CFB = CryptoJS.lib.BlockCipherMode.extend();
                        CFB.Encryptor = CFB.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                                // Remember this block to use with next block
                                this._prevBlock = words.slice(offset, offset + blockSize);
                            }
                        });
                        CFB.Decryptor = CFB.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                // Remember this block to use with next block
                                var thisBlock = words.slice(offset, offset + blockSize);
                                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                                // This block becomes the previous block
                                this._prevBlock = thisBlock;
                            }
                        });
                        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
                            var keystream;
                            // Shortcut
                            var iv = this._iv;
                            // Generate keystream
                            if (iv) {
                                keystream = iv.slice(0);
                                // Remove IV for subsequent blocks
                                this._iv = undefined;
                            } else keystream = this._prevBlock;
                            cipher.encryptBlock(keystream, 0);
                            // Encrypt
                            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                        }
                        return CFB;
                    }();
                    return CryptoJS.mode.CFB;
                });
            /***/ },
            /***/ 63197: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /** @preserve
   * Counter block mode compatible with  Dr Brian Gladman fileenc.c
   * derived from CryptoJS.mode.CTR
   * Jan Hruby jhruby.web@gmail.com
   */ CryptoJS.mode.CTRGladman = function() {
                        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
                        function incWord(word) {
                            if ((word >> 24 & 0xff) === 0xff) {
                                //overflow
                                var b1 = word >> 16 & 0xff;
                                var b2 = word >> 8 & 0xff;
                                var b3 = word & 0xff;
                                if (b1 === 0xff) // overflow b1
                                {
                                    b1 = 0;
                                    if (b2 === 0xff) {
                                        b2 = 0;
                                        if (b3 === 0xff) b3 = 0;
                                        else ++b3;
                                    } else ++b2;
                                } else ++b1;
                                word = 0;
                                word += b1 << 16;
                                word += b2 << 8;
                                word += b3;
                            } else word += 16777216;
                            return word;
                        }
                        function incCounter(counter) {
                            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
                            counter[1] = incWord(counter[1]);
                            return counter;
                        }
                        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                var iv = this._iv;
                                var counter = this._counter;
                                // Generate keystream
                                if (iv) {
                                    counter = this._counter = iv.slice(0);
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined;
                                }
                                incCounter(counter);
                                var keystream = counter.slice(0);
                                cipher.encryptBlock(keystream, 0);
                                // Encrypt
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                            }
                        });
                        CTRGladman.Decryptor = Encryptor;
                        return CTRGladman;
                    }();
                    return CryptoJS.mode.CTRGladman;
                });
            /***/ },
            /***/ 54032: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * Counter block mode.
   */ CryptoJS.mode.CTR = function() {
                        var CTR = CryptoJS.lib.BlockCipherMode.extend();
                        var Encryptor = CTR.Encryptor = CTR.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                var iv = this._iv;
                                var counter = this._counter;
                                // Generate keystream
                                if (iv) {
                                    counter = this._counter = iv.slice(0);
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined;
                                }
                                var keystream = counter.slice(0);
                                cipher.encryptBlock(keystream, 0);
                                // Increment counter
                                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                                // Encrypt
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                            }
                        });
                        CTR.Decryptor = Encryptor;
                        return CTR;
                    }();
                    return CryptoJS.mode.CTR;
                });
            /***/ },
            /***/ 21123: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * Electronic Codebook block mode.
   */ CryptoJS.mode.ECB = function() {
                        var ECB = CryptoJS.lib.BlockCipherMode.extend();
                        ECB.Encryptor = ECB.extend({
                            processBlock: function processBlock(words, offset) {
                                this._cipher.encryptBlock(words, offset);
                            }
                        });
                        ECB.Decryptor = ECB.extend({
                            processBlock: function processBlock(words, offset) {
                                this._cipher.decryptBlock(words, offset);
                            }
                        });
                        return ECB;
                    }();
                    return CryptoJS.mode.ECB;
                });
            /***/ },
            /***/ 38710: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * Output Feedback block mode.
   */ CryptoJS.mode.OFB = function() {
                        var OFB = CryptoJS.lib.BlockCipherMode.extend();
                        var Encryptor = OFB.Encryptor = OFB.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                var iv = this._iv;
                                var keystream = this._keystream;
                                // Generate keystream
                                if (iv) {
                                    keystream = this._keystream = iv.slice(0);
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined;
                                }
                                cipher.encryptBlock(keystream, 0);
                                // Encrypt
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                            }
                        });
                        OFB.Decryptor = Encryptor;
                        return OFB;
                    }();
                    return CryptoJS.mode.OFB;
                });
            /***/ },
            /***/ 93007: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * ANSI X.923 padding strategy.
   */ CryptoJS.pad.AnsiX923 = {
                        pad: function pad(data, blockSize) {
                            // Shortcuts
                            var dataSigBytes = data.sigBytes;
                            var blockSizeBytes = blockSize * 4;
                            // Count padding bytes
                            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
                            // Compute last byte position
                            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
                            // Pad
                            data.clamp();
                            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
                            data.sigBytes += nPaddingBytes;
                        },
                        unpad: function unpad(data) {
                            // Get number of padding bytes from last byte
                            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                            // Remove padding
                            data.sigBytes -= nPaddingBytes;
                        }
                    };
                    return CryptoJS.pad.Ansix923;
                });
            /***/ },
            /***/ 7489: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(55862);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * ISO 10126 padding strategy.
   */ CryptoJS.pad.Iso10126 = {
                        pad: function pad(data, blockSize) {
                            // Shortcut
                            var blockSizeBytes = blockSize * 4;
                            // Count padding bytes
                            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                            // Pad
                            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                                nPaddingBytes << 24
                            ], 1));
                        },
                        unpad: function unpad(data) {
                            // Get number of padding bytes from last byte
                            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                            // Remove padding
                            data.sigBytes -= nPaddingBytes;
                        }
                    };
                    return CryptoJS.pad.Iso10126;
                });
            /***/ },
            /***/ 91695: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(55862);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * ISO/IEC 9797-1 Padding Method 2.
   */ CryptoJS.pad.Iso97971 = {
                        pad: function pad(data, blockSize) {
                            // Add 0x80 byte
                            data.concat(CryptoJS.lib.WordArray.create([
                                0x80000000
                            ], 1));
                            // Zero pad the rest
                            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
                        },
                        unpad: function unpad(data) {
                            // Remove zero padding
                            CryptoJS.pad.ZeroPadding.unpad(data);
                            // Remove one more byte -- the 0x80 byte
                            data.sigBytes--;
                        }
                    };
                    return CryptoJS.pad.Iso97971;
                });
            /***/ },
            /***/ 68028: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * A noop padding strategy.
   */ CryptoJS.pad.NoPadding = {
                        pad: function pad() {},
                        unpad: function unpad() {}
                    };
                    return CryptoJS.pad.NoPadding;
                });
            /***/ },
            /***/ 29556: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    /**
   * Zero padding strategy.
   */ CryptoJS.pad.ZeroPadding = {
                        pad: function pad(data, blockSize) {
                            // Shortcut
                            var blockSizeBytes = blockSize * 4;
                            // Pad
                            data.clamp();
                            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
                        },
                        unpad: function unpad(data) {
                            // Shortcut
                            var dataWords = data.words;
                            // Unpad
                            var i = data.sigBytes - 1;
                            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                                data.sigBytes = i + 1;
                                break;
                            }
                        }
                    };
                    return CryptoJS.pad.ZeroPadding;
                });
            /***/ },
            /***/ 75883: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(55862);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(85209), __webpack_require__(5577));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var WordArray = C_lib.WordArray;
                        var C_algo = C.algo;
                        var SHA256 = C_algo.SHA256;
                        var HMAC = C_algo.HMAC;
                        /**
     * Password-Based Key Derivation Function 2 algorithm.
     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
                            /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hasher to use. Default: SHA256
       * @property {number} iterations The number of iterations to perform. Default: 250000
       */ cfg: Base.extend({
                                keySize: 4,
                                hasher: SHA256,
                                iterations: 250000
                            }),
                            /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.PBKDF2.create();
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
       */ init: function init(cfg) {
                                this.cfg = this.cfg.extend(cfg);
                            },
                            /**
       * Computes the Password-Based Key Derivation Function 2.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */ compute: function compute(password, salt) {
                                // Shortcut
                                var cfg = this.cfg;
                                // Init HMAC
                                var hmac = HMAC.create(cfg.hasher, password);
                                // Initial values
                                var derivedKey = WordArray.create();
                                var blockIndex = WordArray.create([
                                    0x00000001
                                ]);
                                // Shortcuts
                                var derivedKeyWords = derivedKey.words;
                                var blockIndexWords = blockIndex.words;
                                var keySize = cfg.keySize;
                                var iterations = cfg.iterations;
                                // Generate key
                                while(derivedKeyWords.length < keySize){
                                    var block = hmac.update(salt).finalize(blockIndex);
                                    hmac.reset();
                                    // Shortcuts
                                    var blockWords = block.words;
                                    var blockWordsLength = blockWords.length;
                                    // Iterations
                                    var intermediate = block;
                                    for(var i = 1; i < iterations; i++){
                                        intermediate = hmac.finalize(intermediate);
                                        hmac.reset();
                                        // Shortcut
                                        var intermediateWords = intermediate.words;
                                        // XOR intermediate with block
                                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                                    }
                                    derivedKey.concat(block);
                                    blockIndexWords[0]++;
                                }
                                derivedKey.sigBytes = keySize * 4;
                                return derivedKey;
                            }
                        });
                        /**
     * Computes the Password-Based Key Derivation Function 2.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.PBKDF2(password, salt);
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
     */ C.PBKDF2 = function(password, salt, cfg) {
                            return PBKDF2.create(cfg).compute(password, salt);
                        };
                    })();
                    return CryptoJS.PBKDF2;
                });
            /***/ },
            /***/ 79338: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(31946), __webpack_require__(57510), __webpack_require__(95194), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var StreamCipher = C_lib.StreamCipher;
                        var C_algo = C.algo;
                        // Reusable objects
                        var S = [];
                        var C_ = [];
                        var G = [];
                        /**
     * Rabbit stream cipher algorithm.
     *
     * This is a legacy version that neglected to convert the key to little-endian.
     * This error doesn't affect the cipher's security,
     * but it does affect its compatibility with other implementations.
     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var K = this._key.words;
                                var iv = this.cfg.iv;
                                // Generate initial state values
                                var X = this._X = [
                                    K[0],
                                    K[3] << 16 | K[2] >>> 16,
                                    K[1],
                                    K[0] << 16 | K[3] >>> 16,
                                    K[2],
                                    K[1] << 16 | K[0] >>> 16,
                                    K[3],
                                    K[2] << 16 | K[1] >>> 16
                                ];
                                // Generate initial counter values
                                var C = this._C = [
                                    K[2] << 16 | K[2] >>> 16,
                                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                                    K[3] << 16 | K[3] >>> 16,
                                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                                    K[0] << 16 | K[0] >>> 16,
                                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                                    K[1] << 16 | K[1] >>> 16,
                                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                                ];
                                // Carry bit
                                this._b = 0;
                                // Iterate the system four times
                                for(var i = 0; i < 4; i++)nextState.call(this);
                                // Modify the counters
                                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                                // IV setup
                                if (iv) {
                                    // Shortcuts
                                    var IV = iv.words;
                                    var IV_0 = IV[0];
                                    var IV_1 = IV[1];
                                    // Generate four subvectors
                                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                                    // Modify counter values
                                    C[0] ^= i0;
                                    C[1] ^= i1;
                                    C[2] ^= i2;
                                    C[3] ^= i3;
                                    C[4] ^= i0;
                                    C[5] ^= i1;
                                    C[6] ^= i2;
                                    C[7] ^= i3;
                                    // Iterate the system four times
                                    for(var i = 0; i < 4; i++)nextState.call(this);
                                }
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var X = this._X;
                                // Iterate the system
                                nextState.call(this);
                                // Generate four keystream words
                                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                                for(var i = 0; i < 4; i++){
                                    // Swap endian
                                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                                    // Encrypt
                                    M[offset + i] ^= S[i];
                                }
                            },
                            blockSize: 4,
                            ivSize: 2
                        });
                        function nextState() {
                            // Shortcuts
                            var X = this._X;
                            var C = this._C;
                            // Save old counter values
                            for(var i = 0; i < 8; i++)C_[i] = C[i];
                            // Calculate new counter values
                            C[0] = C[0] + 0x4d34d34d + this._b | 0;
                            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
                            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
                            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
                            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
                            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
                            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
                            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
                            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
                            // Calculate the g-values
                            for(var i = 0; i < 8; i++){
                                var gx = X[i] + C[i];
                                // Construct high and low argument for squaring
                                var ga = gx & 0xffff;
                                var gb = gx >>> 16;
                                // Calculate high and low result of squaring
                                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                                // High XOR low
                                G[i] = gh ^ gl;
                            }
                            // Calculate new state values
                            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
                            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
                            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
                            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
                            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
                            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
                            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
                            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
                    })();
                    return CryptoJS.RabbitLegacy;
                });
            /***/ },
            /***/ 24222: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(31946), __webpack_require__(57510), __webpack_require__(95194), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var StreamCipher = C_lib.StreamCipher;
                        var C_algo = C.algo;
                        // Reusable objects
                        var S = [];
                        var C_ = [];
                        var G = [];
                        /**
     * Rabbit stream cipher algorithm
     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var K = this._key.words;
                                var iv = this.cfg.iv;
                                // Swap endian
                                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                                // Generate initial state values
                                var X = this._X = [
                                    K[0],
                                    K[3] << 16 | K[2] >>> 16,
                                    K[1],
                                    K[0] << 16 | K[3] >>> 16,
                                    K[2],
                                    K[1] << 16 | K[0] >>> 16,
                                    K[3],
                                    K[2] << 16 | K[1] >>> 16
                                ];
                                // Generate initial counter values
                                var C = this._C = [
                                    K[2] << 16 | K[2] >>> 16,
                                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                                    K[3] << 16 | K[3] >>> 16,
                                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                                    K[0] << 16 | K[0] >>> 16,
                                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                                    K[1] << 16 | K[1] >>> 16,
                                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                                ];
                                // Carry bit
                                this._b = 0;
                                // Iterate the system four times
                                for(var i = 0; i < 4; i++)nextState.call(this);
                                // Modify the counters
                                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                                // IV setup
                                if (iv) {
                                    // Shortcuts
                                    var IV = iv.words;
                                    var IV_0 = IV[0];
                                    var IV_1 = IV[1];
                                    // Generate four subvectors
                                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                                    // Modify counter values
                                    C[0] ^= i0;
                                    C[1] ^= i1;
                                    C[2] ^= i2;
                                    C[3] ^= i3;
                                    C[4] ^= i0;
                                    C[5] ^= i1;
                                    C[6] ^= i2;
                                    C[7] ^= i3;
                                    // Iterate the system four times
                                    for(var i = 0; i < 4; i++)nextState.call(this);
                                }
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var X = this._X;
                                // Iterate the system
                                nextState.call(this);
                                // Generate four keystream words
                                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                                for(var i = 0; i < 4; i++){
                                    // Swap endian
                                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                                    // Encrypt
                                    M[offset + i] ^= S[i];
                                }
                            },
                            blockSize: 4,
                            ivSize: 2
                        });
                        function nextState() {
                            // Shortcuts
                            var X = this._X;
                            var C = this._C;
                            // Save old counter values
                            for(var i = 0; i < 8; i++)C_[i] = C[i];
                            // Calculate new counter values
                            C[0] = C[0] + 0x4d34d34d + this._b | 0;
                            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
                            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
                            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
                            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
                            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
                            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
                            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
                            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
                            // Calculate the g-values
                            for(var i = 0; i < 8; i++){
                                var gx = X[i] + C[i];
                                // Construct high and low argument for squaring
                                var ga = gx & 0xffff;
                                var gb = gx >>> 16;
                                // Calculate high and low result of squaring
                                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                                // High XOR low
                                G[i] = gh ^ gl;
                            }
                            // Calculate new state values
                            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
                            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
                            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
                            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
                            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
                            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
                            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
                            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
                    })();
                    return CryptoJS.Rabbit;
                });
            /***/ },
            /***/ 97690: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(10853);
                __webpack_require__(35054);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(31946), __webpack_require__(57510), __webpack_require__(95194), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var StreamCipher = C_lib.StreamCipher;
                        var C_algo = C.algo;
                        /**
     * RC4 stream cipher algorithm.
     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var key = this._key;
                                var keyWords = key.words;
                                var keySigBytes = key.sigBytes;
                                // Init sbox
                                var S = this._S = [];
                                for(var i = 0; i < 256; i++)S[i] = i;
                                // Key setup
                                for(var i = 0, j = 0; i < 256; i++){
                                    var keyByteIndex = i % keySigBytes;
                                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                                    j = (j + S[i] + keyByte) % 256;
                                    // Swap
                                    var t = S[i];
                                    S[i] = S[j];
                                    S[j] = t;
                                }
                                // Counters
                                this._i = this._j = 0;
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                M[offset] ^= generateKeystreamWord.call(this);
                            },
                            keySize: 8,
                            ivSize: 0
                        });
                        function generateKeystreamWord() {
                            // Shortcuts
                            var S = this._S;
                            var i = this._i;
                            var j = this._j;
                            // Generate keystream word
                            var keystreamWord = 0;
                            for(var n = 0; n < 4; n++){
                                i = (i + 1) % 256;
                                j = (j + S[i]) % 256;
                                // Swap
                                var t = S[i];
                                S[i] = S[j];
                                S[j] = t;
                                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
                            }
                            // Update counters
                            this._i = i;
                            this._j = j;
                            return keystreamWord;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
     */ C.RC4 = StreamCipher._createHelper(RC4);
                        /**
     * Modified RC4 stream cipher algorithm.
     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
                            /**
       * Configuration options.
       *
       * @property {number} drop The number of keystream words to drop. Default 192
       */ cfg: RC4.cfg.extend({
                                drop: 192
                            }),
                            _doReset: function _doReset() {
                                RC4._doReset.call(this);
                                // Drop
                                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
                            }
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
                    })();
                    return CryptoJS.RC4;
                });
            /***/ },
            /***/ 53601: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    /** @preserve
  (c) 2012 by Cédric Mesnil. All rights reserved.
  	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
  	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
  	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Constants table
                        var _zl = WordArray.create([
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            7,
                            4,
                            13,
                            1,
                            10,
                            6,
                            15,
                            3,
                            12,
                            0,
                            9,
                            5,
                            2,
                            14,
                            11,
                            8,
                            3,
                            10,
                            14,
                            4,
                            9,
                            15,
                            8,
                            1,
                            2,
                            7,
                            0,
                            6,
                            13,
                            11,
                            5,
                            12,
                            1,
                            9,
                            11,
                            10,
                            0,
                            8,
                            12,
                            4,
                            13,
                            3,
                            7,
                            15,
                            14,
                            5,
                            6,
                            2,
                            4,
                            0,
                            5,
                            9,
                            7,
                            12,
                            2,
                            10,
                            14,
                            1,
                            3,
                            8,
                            11,
                            6,
                            15,
                            13
                        ]);
                        var _zr = WordArray.create([
                            5,
                            14,
                            7,
                            0,
                            9,
                            2,
                            11,
                            4,
                            13,
                            6,
                            15,
                            8,
                            1,
                            10,
                            3,
                            12,
                            6,
                            11,
                            3,
                            7,
                            0,
                            13,
                            5,
                            10,
                            14,
                            15,
                            8,
                            12,
                            4,
                            9,
                            1,
                            2,
                            15,
                            5,
                            1,
                            3,
                            7,
                            14,
                            6,
                            9,
                            11,
                            8,
                            12,
                            2,
                            10,
                            0,
                            4,
                            13,
                            8,
                            6,
                            4,
                            1,
                            3,
                            11,
                            15,
                            0,
                            5,
                            12,
                            2,
                            13,
                            9,
                            7,
                            10,
                            14,
                            12,
                            15,
                            10,
                            4,
                            1,
                            5,
                            8,
                            7,
                            6,
                            2,
                            13,
                            14,
                            0,
                            3,
                            9,
                            11
                        ]);
                        var _sl = WordArray.create([
                            11,
                            14,
                            15,
                            12,
                            5,
                            8,
                            7,
                            9,
                            11,
                            13,
                            14,
                            15,
                            6,
                            7,
                            9,
                            8,
                            7,
                            6,
                            8,
                            13,
                            11,
                            9,
                            7,
                            15,
                            7,
                            12,
                            15,
                            9,
                            11,
                            7,
                            13,
                            12,
                            11,
                            13,
                            6,
                            7,
                            14,
                            9,
                            13,
                            15,
                            14,
                            8,
                            13,
                            6,
                            5,
                            12,
                            7,
                            5,
                            11,
                            12,
                            14,
                            15,
                            14,
                            15,
                            9,
                            8,
                            9,
                            14,
                            5,
                            6,
                            8,
                            6,
                            5,
                            12,
                            9,
                            15,
                            5,
                            11,
                            6,
                            8,
                            13,
                            12,
                            5,
                            12,
                            13,
                            14,
                            11,
                            8,
                            5,
                            6
                        ]);
                        var _sr = WordArray.create([
                            8,
                            9,
                            9,
                            11,
                            13,
                            15,
                            15,
                            5,
                            7,
                            7,
                            8,
                            11,
                            14,
                            14,
                            12,
                            6,
                            9,
                            13,
                            15,
                            7,
                            12,
                            8,
                            9,
                            11,
                            7,
                            7,
                            12,
                            7,
                            6,
                            15,
                            13,
                            11,
                            9,
                            7,
                            15,
                            11,
                            8,
                            6,
                            6,
                            14,
                            12,
                            13,
                            5,
                            14,
                            13,
                            13,
                            7,
                            5,
                            15,
                            5,
                            8,
                            11,
                            14,
                            14,
                            6,
                            14,
                            6,
                            9,
                            12,
                            9,
                            12,
                            5,
                            15,
                            8,
                            8,
                            5,
                            12,
                            9,
                            12,
                            5,
                            14,
                            6,
                            8,
                            13,
                            6,
                            5,
                            15,
                            13,
                            11,
                            11
                        ]);
                        var _hl = WordArray.create([
                            0x00000000,
                            0x5A827999,
                            0x6ED9EBA1,
                            0x8F1BBCDC,
                            0xA953FD4E
                        ]);
                        var _hr = WordArray.create([
                            0x50A28BE6,
                            0x5C4DD124,
                            0x6D703EF3,
                            0x7A6D76E9,
                            0x00000000
                        ]);
                        /**
     * RIPEMD160 hash algorithm.
     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = WordArray.create([
                                    0x67452301,
                                    0xEFCDAB89,
                                    0x98BADCFE,
                                    0x10325476,
                                    0xC3D2E1F0
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Swap endian
                                for(var i = 0; i < 16; i++){
                                    // Shortcuts
                                    var offset_i = offset + i;
                                    var M_offset_i = M[offset_i];
                                    // Swap
                                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                                }
                                // Shortcut
                                var H = this._hash.words;
                                var hl = _hl.words;
                                var hr = _hr.words;
                                var zl = _zl.words;
                                var zr = _zr.words;
                                var sl = _sl.words;
                                var sr = _sr.words;
                                // Working variables
                                var al, bl, cl, dl, el;
                                var ar, br, cr, dr, er;
                                ar = al = H[0];
                                br = bl = H[1];
                                cr = cl = H[2];
                                dr = dl = H[3];
                                er = el = H[4];
                                // Computation
                                var t;
                                for(var i = 0; i < 80; i += 1){
                                    t = al + M[offset + zl[i]] | 0;
                                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                                    else // if (i<80) {
                                    t += f5(bl, cl, dl) + hl[4];
                                    t = t | 0;
                                    t = rotl(t, sl[i]);
                                    t = t + el | 0;
                                    al = el;
                                    el = dl;
                                    dl = rotl(cl, 10);
                                    cl = bl;
                                    bl = t;
                                    t = ar + M[offset + zr[i]] | 0;
                                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                                    else // if (i<80) {
                                    t += f1(br, cr, dr) + hr[4];
                                    t = t | 0;
                                    t = rotl(t, sr[i]);
                                    t = t + er | 0;
                                    ar = er;
                                    er = dr;
                                    dr = rotl(cr, 10);
                                    cr = br;
                                    br = t;
                                }
                                // Intermediate hash value
                                t = H[1] + cl + dr | 0;
                                H[1] = H[2] + dl + er | 0;
                                H[2] = H[3] + el + ar | 0;
                                H[3] = H[4] + al + br | 0;
                                H[4] = H[0] + bl + cr | 0;
                                H[0] = t;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                                data.sigBytes = (dataWords.length + 1) * 4;
                                // Hash final blocks
                                this._process();
                                // Shortcuts
                                var hash = this._hash;
                                var H = hash.words;
                                // Swap endian
                                for(var i = 0; i < 5; i++){
                                    // Shortcut
                                    var H_i = H[i];
                                    // Swap
                                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                                }
                                // Return final computed hash
                                return hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        function f1(x, y, z) {
                            return x ^ y ^ z;
                        }
                        function f2(x, y, z) {
                            return x & y | ~x & z;
                        }
                        function f3(x, y, z) {
                            return (x | ~y) ^ z;
                        }
                        function f4(x, y, z) {
                            return x & z | y & ~z;
                        }
                        function f5(x, y, z) {
                            return x ^ (y | ~z);
                        }
                        function rotl(x, n) {
                            return x << n | x >>> 32 - n;
                        }
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.RIPEMD160('message');
     *     var hash = CryptoJS.RIPEMD160(wordArray);
     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
                    })(Math);
                    return CryptoJS.RIPEMD160;
                });
            /***/ },
            /***/ 61977: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Reusable object
                        var W = [];
                        /**
     * SHA-1 hash algorithm.
     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init([
                                    0x67452301,
                                    0xefcdab89,
                                    0x98badcfe,
                                    0x10325476,
                                    0xc3d2e1f0
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var H = this._hash.words;
                                // Working variables
                                var a = H[0];
                                var b = H[1];
                                var c = H[2];
                                var d = H[3];
                                var e = H[4];
                                // Computation
                                for(var i = 0; i < 80; i++){
                                    if (i < 16) W[i] = M[offset + i] | 0;
                                    else {
                                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                                        W[i] = n << 1 | n >>> 31;
                                    }
                                    var t = (a << 5 | a >>> 27) + e + W[i];
                                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                                    else t += (b ^ c ^ d) - 0x359d3e2a;
                                    e = d;
                                    d = c;
                                    c = b << 30 | b >>> 2;
                                    b = a;
                                    a = t;
                                }
                                // Intermediate hash value
                                H[0] = H[0] + a | 0;
                                H[1] = H[1] + b | 0;
                                H[2] = H[2] + c | 0;
                                H[3] = H[3] + d | 0;
                                H[4] = H[4] + e | 0;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Return final computed hash
                                return this._hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA1('message');
     *     var hash = CryptoJS.SHA1(wordArray);
     */ C.SHA1 = Hasher._createHelper(SHA1);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA1(message, key);
     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
                    })();
                    return CryptoJS.SHA1;
                });
            /***/ },
            /***/ 11707: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(85209));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_algo = C.algo;
                        var SHA256 = C_algo.SHA256;
                        /**
     * SHA-224 hash algorithm.
     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init([
                                    0xc1059ed8,
                                    0x367cd507,
                                    0x3070dd17,
                                    0xf70e5939,
                                    0xffc00b31,
                                    0x68581511,
                                    0x64f98fa7,
                                    0xbefa4fa4
                                ]);
                            },
                            _doFinalize: function _doFinalize() {
                                var hash = SHA256._doFinalize.call(this);
                                hash.sigBytes -= 4;
                                return hash;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA224('message');
     *     var hash = CryptoJS.SHA224(wordArray);
     */ C.SHA224 = SHA256._createHelper(SHA224);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA224(message, key);
     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
                    })();
                    return CryptoJS.SHA224;
                });
            /***/ },
            /***/ 85209: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Initialization and round constants tables
                        var H = [];
                        var K = [];
                        // Compute constants
                        (function() {
                            function isPrime(n) {
                                var sqrtN = Math1.sqrt(n);
                                for(var factor = 2; factor <= sqrtN; factor++){
                                    if (!(n % factor)) return false;
                                }
                                return true;
                            }
                            function getFractionalBits(n) {
                                return (n - (n | 0)) * 0x100000000 | 0;
                            }
                            var n = 2;
                            var nPrime = 0;
                            while(nPrime < 64){
                                if (isPrime(n)) {
                                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                                    nPrime++;
                                }
                                n++;
                            }
                        })();
                        // Reusable object
                        var W = [];
                        /**
     * SHA-256 hash algorithm.
     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init(H.slice(0));
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var H = this._hash.words;
                                // Working variables
                                var a = H[0];
                                var b = H[1];
                                var c = H[2];
                                var d = H[3];
                                var e = H[4];
                                var f = H[5];
                                var g = H[6];
                                var h = H[7];
                                // Computation
                                for(var i = 0; i < 64; i++){
                                    if (i < 16) W[i] = M[offset + i] | 0;
                                    else {
                                        var gamma0x = W[i - 15];
                                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                                        var gamma1x = W[i - 2];
                                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                                    }
                                    var ch = e & f ^ ~e & g;
                                    var maj = a & b ^ a & c ^ b & c;
                                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                                    var t1 = h + sigma1 + ch + K[i] + W[i];
                                    var t2 = sigma0 + maj;
                                    h = g;
                                    g = f;
                                    f = e;
                                    e = d + t1 | 0;
                                    d = c;
                                    c = b;
                                    b = a;
                                    a = t1 + t2 | 0;
                                }
                                // Intermediate hash value
                                H[0] = H[0] + a | 0;
                                H[1] = H[1] + b | 0;
                                H[2] = H[2] + c | 0;
                                H[3] = H[3] + d | 0;
                                H[4] = H[4] + e | 0;
                                H[5] = H[5] + f | 0;
                                H[6] = H[6] + g | 0;
                                H[7] = H[7] + h | 0;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Return final computed hash
                                return this._hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA256('message');
     *     var hash = CryptoJS.SHA256(wordArray);
     */ C.SHA256 = Hasher._createHelper(SHA256);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA256(message, key);
     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
                    })(Math);
                    return CryptoJS.SHA256;
                });
            /***/ },
            /***/ 11691: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(23204));
                })(void 0, function(CryptoJS) {
                    (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_x64 = C.x64;
                        var X64Word = C_x64.Word;
                        var C_algo = C.algo;
                        // Constants tables
                        var RHO_OFFSETS = [];
                        var PI_INDEXES = [];
                        var ROUND_CONSTANTS = [];
                        // Compute Constants
                        (function() {
                            // Compute rho offset constants
                            var x = 1, y = 0;
                            for(var t = 0; t < 24; t++){
                                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                                var newX = y % 5;
                                var newY = (2 * x + 3 * y) % 5;
                                x = newX;
                                y = newY;
                            }
                            // Compute pi index constants
                            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
                            // Compute round constants
                            var LFSR = 0x01;
                            for(var i = 0; i < 24; i++){
                                var roundConstantMsw = 0;
                                var roundConstantLsw = 0;
                                for(var j = 0; j < 7; j++){
                                    if (LFSR & 0x01) {
                                        var bitPosition = (1 << j) - 1;
                                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                                        else roundConstantMsw ^= 1 << bitPosition - 32;
                                    }
                                    // Compute next LFSR
                                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                                    LFSR = LFSR << 1 ^ 0x71;
                                    else LFSR <<= 1;
                                }
                                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
                            }
                        })();
                        // Reusable objects for temporary values
                        var T = [];
                        (function() {
                            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
                        })();
                        /**
     * SHA-3 hash algorithm.
     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
                            /**
       * Configuration options.
       *
       * @property {number} outputLength
       *   The desired number of bits in the output hash.
       *   Only values permitted are: 224, 256, 384, 512.
       *   Default: 512
       */ cfg: Hasher.cfg.extend({
                                outputLength: 512
                            }),
                            _doReset: function _doReset() {
                                var state = this._state = [];
                                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcuts
                                var state = this._state;
                                var nBlockSizeLanes = this.blockSize / 2;
                                // Absorb
                                for(var i = 0; i < nBlockSizeLanes; i++){
                                    // Shortcuts
                                    var M2i = M[offset + 2 * i];
                                    var M2i1 = M[offset + 2 * i + 1];
                                    // Swap endian
                                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                                    // Absorb message into state
                                    var lane = state[i];
                                    lane.high ^= M2i1;
                                    lane.low ^= M2i;
                                }
                                // Rounds
                                for(var round = 0; round < 24; round++){
                                    // Theta
                                    for(var x = 0; x < 5; x++){
                                        // Mix column lanes
                                        var tMsw = 0, tLsw = 0;
                                        for(var y = 0; y < 5; y++){
                                            var lane = state[x + 5 * y];
                                            tMsw ^= lane.high;
                                            tLsw ^= lane.low;
                                        }
                                        // Temporary values
                                        var Tx = T[x];
                                        Tx.high = tMsw;
                                        Tx.low = tLsw;
                                    }
                                    for(var x = 0; x < 5; x++){
                                        // Shortcuts
                                        var Tx4 = T[(x + 4) % 5];
                                        var Tx1 = T[(x + 1) % 5];
                                        var Tx1Msw = Tx1.high;
                                        var Tx1Lsw = Tx1.low;
                                        // Mix surrounding columns
                                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                                        for(var y = 0; y < 5; y++){
                                            var lane = state[x + 5 * y];
                                            lane.high ^= tMsw;
                                            lane.low ^= tLsw;
                                        }
                                    }
                                    // Rho Pi
                                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                                        var tMsw;
                                        var tLsw;
                                        // Shortcuts
                                        var lane = state[laneIndex];
                                        var laneMsw = lane.high;
                                        var laneLsw = lane.low;
                                        var rhoOffset = RHO_OFFSETS[laneIndex];
                                        // Rotate lanes
                                        if (rhoOffset < 32) {
                                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                                        } else /* if (rhoOffset >= 32) */ {
                                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                                        }
                                        // Transpose lanes
                                        var TPiLane = T[PI_INDEXES[laneIndex]];
                                        TPiLane.high = tMsw;
                                        TPiLane.low = tLsw;
                                    }
                                    // Rho pi at x = y = 0
                                    var T0 = T[0];
                                    var state0 = state[0];
                                    T0.high = state0.high;
                                    T0.low = state0.low;
                                    // Chi
                                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                                        // Shortcuts
                                        var laneIndex = x + 5 * y;
                                        var lane = state[laneIndex];
                                        var TLane = T[laneIndex];
                                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                                        // Mix rows
                                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                                    }
                                    // Iota
                                    var lane = state[0];
                                    var roundConstant = ROUND_CONSTANTS[round];
                                    lane.high ^= roundConstant.high;
                                    lane.low ^= roundConstant.low;
                                }
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                var blockSizeBits = this.blockSize * 32;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Shortcuts
                                var state = this._state;
                                var outputLengthBytes = this.cfg.outputLength / 8;
                                var outputLengthLanes = outputLengthBytes / 8;
                                // Squeeze
                                var hashWords = [];
                                for(var i = 0; i < outputLengthLanes; i++){
                                    // Shortcuts
                                    var lane = state[i];
                                    var laneMsw = lane.high;
                                    var laneLsw = lane.low;
                                    // Swap endian
                                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                                    // Squeeze state to retrieve hash
                                    hashWords.push(laneLsw);
                                    hashWords.push(laneMsw);
                                }
                                // Return final computed hash
                                return new WordArray.init(hashWords, outputLengthBytes);
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                var state = clone._state = this._state.slice(0);
                                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                                return clone;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA3('message');
     *     var hash = CryptoJS.SHA3(wordArray);
     */ C.SHA3 = Hasher._createHelper(SHA3);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA3(message, key);
     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
                    })(Math);
                    return CryptoJS.SHA3;
                });
            /***/ },
            /***/ 21410: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(23204), __webpack_require__(20595));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_x64 = C.x64;
                        var X64Word = C_x64.Word;
                        var X64WordArray = C_x64.WordArray;
                        var C_algo = C.algo;
                        var SHA512 = C_algo.SHA512;
                        /**
     * SHA-384 hash algorithm.
     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
                            _doReset: function _doReset() {
                                this._hash = new X64WordArray.init([
                                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                                    new X64Word.init(0x629a292a, 0x367cd507),
                                    new X64Word.init(0x9159015a, 0x3070dd17),
                                    new X64Word.init(0x152fecd8, 0xf70e5939),
                                    new X64Word.init(0x67332667, 0xffc00b31),
                                    new X64Word.init(0x8eb44a87, 0x68581511),
                                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                                ]);
                            },
                            _doFinalize: function _doFinalize() {
                                var hash = SHA512._doFinalize.call(this);
                                hash.sigBytes -= 16;
                                return hash;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA384('message');
     *     var hash = CryptoJS.SHA384(wordArray);
     */ C.SHA384 = SHA512._createHelper(SHA384);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA384(message, key);
     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
                    })();
                    return CryptoJS.SHA384;
                });
            /***/ },
            /***/ 20595: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(23204));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Hasher = C_lib.Hasher;
                        var C_x64 = C.x64;
                        var X64Word = C_x64.Word;
                        var X64WordArray = C_x64.WordArray;
                        var C_algo = C.algo;
                        function X64Word_create() {
                            return X64Word.create.apply(X64Word, arguments);
                        }
                        // Constants
                        var K = [
                            X64Word_create(0x428a2f98, 0xd728ae22),
                            X64Word_create(0x71374491, 0x23ef65cd),
                            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
                            X64Word_create(0xe9b5dba5, 0x8189dbbc),
                            X64Word_create(0x3956c25b, 0xf348b538),
                            X64Word_create(0x59f111f1, 0xb605d019),
                            X64Word_create(0x923f82a4, 0xaf194f9b),
                            X64Word_create(0xab1c5ed5, 0xda6d8118),
                            X64Word_create(0xd807aa98, 0xa3030242),
                            X64Word_create(0x12835b01, 0x45706fbe),
                            X64Word_create(0x243185be, 0x4ee4b28c),
                            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
                            X64Word_create(0x72be5d74, 0xf27b896f),
                            X64Word_create(0x80deb1fe, 0x3b1696b1),
                            X64Word_create(0x9bdc06a7, 0x25c71235),
                            X64Word_create(0xc19bf174, 0xcf692694),
                            X64Word_create(0xe49b69c1, 0x9ef14ad2),
                            X64Word_create(0xefbe4786, 0x384f25e3),
                            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
                            X64Word_create(0x240ca1cc, 0x77ac9c65),
                            X64Word_create(0x2de92c6f, 0x592b0275),
                            X64Word_create(0x4a7484aa, 0x6ea6e483),
                            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
                            X64Word_create(0x76f988da, 0x831153b5),
                            X64Word_create(0x983e5152, 0xee66dfab),
                            X64Word_create(0xa831c66d, 0x2db43210),
                            X64Word_create(0xb00327c8, 0x98fb213f),
                            X64Word_create(0xbf597fc7, 0xbeef0ee4),
                            X64Word_create(0xc6e00bf3, 0x3da88fc2),
                            X64Word_create(0xd5a79147, 0x930aa725),
                            X64Word_create(0x06ca6351, 0xe003826f),
                            X64Word_create(0x14292967, 0x0a0e6e70),
                            X64Word_create(0x27b70a85, 0x46d22ffc),
                            X64Word_create(0x2e1b2138, 0x5c26c926),
                            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
                            X64Word_create(0x53380d13, 0x9d95b3df),
                            X64Word_create(0x650a7354, 0x8baf63de),
                            X64Word_create(0x766a0abb, 0x3c77b2a8),
                            X64Word_create(0x81c2c92e, 0x47edaee6),
                            X64Word_create(0x92722c85, 0x1482353b),
                            X64Word_create(0xa2bfe8a1, 0x4cf10364),
                            X64Word_create(0xa81a664b, 0xbc423001),
                            X64Word_create(0xc24b8b70, 0xd0f89791),
                            X64Word_create(0xc76c51a3, 0x0654be30),
                            X64Word_create(0xd192e819, 0xd6ef5218),
                            X64Word_create(0xd6990624, 0x5565a910),
                            X64Word_create(0xf40e3585, 0x5771202a),
                            X64Word_create(0x106aa070, 0x32bbd1b8),
                            X64Word_create(0x19a4c116, 0xb8d2d0c8),
                            X64Word_create(0x1e376c08, 0x5141ab53),
                            X64Word_create(0x2748774c, 0xdf8eeb99),
                            X64Word_create(0x34b0bcb5, 0xe19b48a8),
                            X64Word_create(0x391c0cb3, 0xc5c95a63),
                            X64Word_create(0x4ed8aa4a, 0xe3418acb),
                            X64Word_create(0x5b9cca4f, 0x7763e373),
                            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
                            X64Word_create(0x748f82ee, 0x5defb2fc),
                            X64Word_create(0x78a5636f, 0x43172f60),
                            X64Word_create(0x84c87814, 0xa1f0ab72),
                            X64Word_create(0x8cc70208, 0x1a6439ec),
                            X64Word_create(0x90befffa, 0x23631e28),
                            X64Word_create(0xa4506ceb, 0xde82bde9),
                            X64Word_create(0xbef9a3f7, 0xb2c67915),
                            X64Word_create(0xc67178f2, 0xe372532b),
                            X64Word_create(0xca273ece, 0xea26619c),
                            X64Word_create(0xd186b8c7, 0x21c0c207),
                            X64Word_create(0xeada7dd6, 0xcde0eb1e),
                            X64Word_create(0xf57d4f7f, 0xee6ed178),
                            X64Word_create(0x06f067aa, 0x72176fba),
                            X64Word_create(0x0a637dc5, 0xa2c898a6),
                            X64Word_create(0x113f9804, 0xbef90dae),
                            X64Word_create(0x1b710b35, 0x131c471b),
                            X64Word_create(0x28db77f5, 0x23047d84),
                            X64Word_create(0x32caab7b, 0x40c72493),
                            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
                            X64Word_create(0x431d67c4, 0x9c100d4c),
                            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
                            X64Word_create(0x597f299c, 0xfc657e2a),
                            X64Word_create(0x5fcb6fab, 0x3ad6faec),
                            X64Word_create(0x6c44198c, 0x4a475817)
                        ];
                        // Reusable objects
                        var W = [];
                        (function() {
                            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
                        })();
                        /**
     * SHA-512 hash algorithm.
     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new X64WordArray.init([
                                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                                    new X64Word.init(0x510e527f, 0xade682d1),
                                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                                    new X64Word.init(0x5be0cd19, 0x137e2179)
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcuts
                                var H = this._hash.words;
                                var H0 = H[0];
                                var H1 = H[1];
                                var H2 = H[2];
                                var H3 = H[3];
                                var H4 = H[4];
                                var H5 = H[5];
                                var H6 = H[6];
                                var H7 = H[7];
                                var H0h = H0.high;
                                var H0l = H0.low;
                                var H1h = H1.high;
                                var H1l = H1.low;
                                var H2h = H2.high;
                                var H2l = H2.low;
                                var H3h = H3.high;
                                var H3l = H3.low;
                                var H4h = H4.high;
                                var H4l = H4.low;
                                var H5h = H5.high;
                                var H5l = H5.low;
                                var H6h = H6.high;
                                var H6l = H6.low;
                                var H7h = H7.high;
                                var H7l = H7.low;
                                // Working variables
                                var ah = H0h;
                                var al = H0l;
                                var bh = H1h;
                                var bl = H1l;
                                var ch = H2h;
                                var cl = H2l;
                                var dh = H3h;
                                var dl = H3l;
                                var eh = H4h;
                                var el = H4l;
                                var fh = H5h;
                                var fl = H5l;
                                var gh = H6h;
                                var gl = H6l;
                                var hh = H7h;
                                var hl = H7l;
                                // Rounds
                                for(var i = 0; i < 80; i++){
                                    var Wil;
                                    var Wih;
                                    // Shortcut
                                    var Wi = W[i];
                                    // Extend message
                                    if (i < 16) {
                                        Wih = Wi.high = M[offset + i * 2] | 0;
                                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                                    } else {
                                        // Gamma0
                                        var gamma0x = W[i - 15];
                                        var gamma0xh = gamma0x.high;
                                        var gamma0xl = gamma0x.low;
                                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                                        // Gamma1
                                        var gamma1x = W[i - 2];
                                        var gamma1xh = gamma1x.high;
                                        var gamma1xl = gamma1x.low;
                                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                                        var Wi7 = W[i - 7];
                                        var Wi7h = Wi7.high;
                                        var Wi7l = Wi7.low;
                                        var Wi16 = W[i - 16];
                                        var Wi16h = Wi16.high;
                                        var Wi16l = Wi16.low;
                                        Wil = gamma0l + Wi7l;
                                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                                        Wil = Wil + gamma1l;
                                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                                        Wil = Wil + Wi16l;
                                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                                        Wi.high = Wih;
                                        Wi.low = Wil;
                                    }
                                    var chh = eh & fh ^ ~eh & gh;
                                    var chl = el & fl ^ ~el & gl;
                                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                                    var majl = al & bl ^ al & cl ^ bl & cl;
                                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                                    // t1 = h + sigma1 + ch + K[i] + W[i]
                                    var Ki = K[i];
                                    var Kih = Ki.high;
                                    var Kil = Ki.low;
                                    var t1l = hl + sigma1l;
                                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                                    var t1l = t1l + chl;
                                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                                    var t1l = t1l + Kil;
                                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                                    var t1l = t1l + Wil;
                                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                                    // t2 = sigma0 + maj
                                    var t2l = sigma0l + majl;
                                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                                    // Update working variables
                                    hh = gh;
                                    hl = gl;
                                    gh = fh;
                                    gl = fl;
                                    fh = eh;
                                    fl = el;
                                    el = dl + t1l | 0;
                                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                                    dh = ch;
                                    dl = cl;
                                    ch = bh;
                                    cl = bl;
                                    bh = ah;
                                    bl = al;
                                    al = t1l + t2l | 0;
                                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                                }
                                // Intermediate hash value
                                H0l = H0.low = H0l + al;
                                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                                H1l = H1.low = H1l + bl;
                                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                                H2l = H2.low = H2l + cl;
                                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                                H3l = H3.low = H3l + dl;
                                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                                H4l = H4.low = H4l + el;
                                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                                H5l = H5.low = H5l + fl;
                                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                                H6l = H6.low = H6l + gl;
                                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                                H7l = H7.low = H7l + hl;
                                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Convert hash to 32-bit word array before returning
                                var hash = this._hash.toX32();
                                // Return final computed hash
                                return hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            },
                            blockSize: 32
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA512('message');
     *     var hash = CryptoJS.SHA512(wordArray);
     */ C.SHA512 = Hasher._createHelper(SHA512);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA512(message, key);
     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
                    })();
                    return CryptoJS.SHA512;
                });
            /***/ },
            /***/ 77059: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264), __webpack_require__(31946), __webpack_require__(57510), __webpack_require__(95194), __webpack_require__(52810));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var BlockCipher = C_lib.BlockCipher;
                        var C_algo = C.algo;
                        // Permuted Choice 1 constants
                        var PC1 = [
                            57,
                            49,
                            41,
                            33,
                            25,
                            17,
                            9,
                            1,
                            58,
                            50,
                            42,
                            34,
                            26,
                            18,
                            10,
                            2,
                            59,
                            51,
                            43,
                            35,
                            27,
                            19,
                            11,
                            3,
                            60,
                            52,
                            44,
                            36,
                            63,
                            55,
                            47,
                            39,
                            31,
                            23,
                            15,
                            7,
                            62,
                            54,
                            46,
                            38,
                            30,
                            22,
                            14,
                            6,
                            61,
                            53,
                            45,
                            37,
                            29,
                            21,
                            13,
                            5,
                            28,
                            20,
                            12,
                            4
                        ];
                        // Permuted Choice 2 constants
                        var PC2 = [
                            14,
                            17,
                            11,
                            24,
                            1,
                            5,
                            3,
                            28,
                            15,
                            6,
                            21,
                            10,
                            23,
                            19,
                            12,
                            4,
                            26,
                            8,
                            16,
                            7,
                            27,
                            20,
                            13,
                            2,
                            41,
                            52,
                            31,
                            37,
                            47,
                            55,
                            30,
                            40,
                            51,
                            45,
                            33,
                            48,
                            44,
                            49,
                            39,
                            56,
                            34,
                            53,
                            46,
                            42,
                            50,
                            36,
                            29,
                            32
                        ];
                        // Cumulative bit shift constants
                        var BIT_SHIFTS = [
                            1,
                            2,
                            4,
                            6,
                            8,
                            10,
                            12,
                            14,
                            15,
                            17,
                            19,
                            21,
                            23,
                            25,
                            27,
                            28
                        ];
                        // SBOXes and round permutation constants
                        var SBOX_P = [
                            {
                                0x0: 0x808200,
                                0x10000000: 0x8000,
                                0x20000000: 0x808002,
                                0x30000000: 0x2,
                                0x40000000: 0x200,
                                0x50000000: 0x808202,
                                0x60000000: 0x800202,
                                0x70000000: 0x800000,
                                0x80000000: 0x202,
                                0x90000000: 0x800200,
                                0xa0000000: 0x8200,
                                0xb0000000: 0x808000,
                                0xc0000000: 0x8002,
                                0xd0000000: 0x800002,
                                0xe0000000: 0x0,
                                0xf0000000: 0x8202,
                                0x8000000: 0x0,
                                0x18000000: 0x808202,
                                0x28000000: 0x8202,
                                0x38000000: 0x8000,
                                0x48000000: 0x808200,
                                0x58000000: 0x200,
                                0x68000000: 0x808002,
                                0x78000000: 0x2,
                                0x88000000: 0x800200,
                                0x98000000: 0x8200,
                                0xa8000000: 0x808000,
                                0xb8000000: 0x800202,
                                0xc8000000: 0x800002,
                                0xd8000000: 0x8002,
                                0xe8000000: 0x202,
                                0xf8000000: 0x800000,
                                0x1: 0x8000,
                                0x10000001: 0x2,
                                0x20000001: 0x808200,
                                0x30000001: 0x800000,
                                0x40000001: 0x808002,
                                0x50000001: 0x8200,
                                0x60000001: 0x200,
                                0x70000001: 0x800202,
                                0x80000001: 0x808202,
                                0x90000001: 0x808000,
                                0xa0000001: 0x800002,
                                0xb0000001: 0x8202,
                                0xc0000001: 0x202,
                                0xd0000001: 0x800200,
                                0xe0000001: 0x8002,
                                0xf0000001: 0x0,
                                0x8000001: 0x808202,
                                0x18000001: 0x808000,
                                0x28000001: 0x800000,
                                0x38000001: 0x200,
                                0x48000001: 0x8000,
                                0x58000001: 0x800002,
                                0x68000001: 0x2,
                                0x78000001: 0x8202,
                                0x88000001: 0x8002,
                                0x98000001: 0x800202,
                                0xa8000001: 0x202,
                                0xb8000001: 0x808200,
                                0xc8000001: 0x800200,
                                0xd8000001: 0x0,
                                0xe8000001: 0x8200,
                                0xf8000001: 0x808002
                            },
                            {
                                0x0: 0x40084010,
                                0x1000000: 0x4000,
                                0x2000000: 0x80000,
                                0x3000000: 0x40080010,
                                0x4000000: 0x40000010,
                                0x5000000: 0x40084000,
                                0x6000000: 0x40004000,
                                0x7000000: 0x10,
                                0x8000000: 0x84000,
                                0x9000000: 0x40004010,
                                0xa000000: 0x40000000,
                                0xb000000: 0x84010,
                                0xc000000: 0x80010,
                                0xd000000: 0x0,
                                0xe000000: 0x4010,
                                0xf000000: 0x40080000,
                                0x800000: 0x40004000,
                                0x1800000: 0x84010,
                                0x2800000: 0x10,
                                0x3800000: 0x40004010,
                                0x4800000: 0x40084010,
                                0x5800000: 0x40000000,
                                0x6800000: 0x80000,
                                0x7800000: 0x40080010,
                                0x8800000: 0x80010,
                                0x9800000: 0x0,
                                0xa800000: 0x4000,
                                0xb800000: 0x40080000,
                                0xc800000: 0x40000010,
                                0xd800000: 0x84000,
                                0xe800000: 0x40084000,
                                0xf800000: 0x4010,
                                0x10000000: 0x0,
                                0x11000000: 0x40080010,
                                0x12000000: 0x40004010,
                                0x13000000: 0x40084000,
                                0x14000000: 0x40080000,
                                0x15000000: 0x10,
                                0x16000000: 0x84010,
                                0x17000000: 0x4000,
                                0x18000000: 0x4010,
                                0x19000000: 0x80000,
                                0x1a000000: 0x80010,
                                0x1b000000: 0x40000010,
                                0x1c000000: 0x84000,
                                0x1d000000: 0x40004000,
                                0x1e000000: 0x40000000,
                                0x1f000000: 0x40084010,
                                0x10800000: 0x84010,
                                0x11800000: 0x80000,
                                0x12800000: 0x40080000,
                                0x13800000: 0x4000,
                                0x14800000: 0x40004000,
                                0x15800000: 0x40084010,
                                0x16800000: 0x10,
                                0x17800000: 0x40000000,
                                0x18800000: 0x40084000,
                                0x19800000: 0x40000010,
                                0x1a800000: 0x40004010,
                                0x1b800000: 0x80010,
                                0x1c800000: 0x0,
                                0x1d800000: 0x4010,
                                0x1e800000: 0x40080010,
                                0x1f800000: 0x84000
                            },
                            {
                                0x0: 0x104,
                                0x100000: 0x0,
                                0x200000: 0x4000100,
                                0x300000: 0x10104,
                                0x400000: 0x10004,
                                0x500000: 0x4000004,
                                0x600000: 0x4010104,
                                0x700000: 0x4010000,
                                0x800000: 0x4000000,
                                0x900000: 0x4010100,
                                0xa00000: 0x10100,
                                0xb00000: 0x4010004,
                                0xc00000: 0x4000104,
                                0xd00000: 0x10000,
                                0xe00000: 0x4,
                                0xf00000: 0x100,
                                0x80000: 0x4010100,
                                0x180000: 0x4010004,
                                0x280000: 0x0,
                                0x380000: 0x4000100,
                                0x480000: 0x4000004,
                                0x580000: 0x10000,
                                0x680000: 0x10004,
                                0x780000: 0x104,
                                0x880000: 0x4,
                                0x980000: 0x100,
                                0xa80000: 0x4010000,
                                0xb80000: 0x10104,
                                0xc80000: 0x10100,
                                0xd80000: 0x4000104,
                                0xe80000: 0x4010104,
                                0xf80000: 0x4000000,
                                0x1000000: 0x4010100,
                                0x1100000: 0x10004,
                                0x1200000: 0x10000,
                                0x1300000: 0x4000100,
                                0x1400000: 0x100,
                                0x1500000: 0x4010104,
                                0x1600000: 0x4000004,
                                0x1700000: 0x0,
                                0x1800000: 0x4000104,
                                0x1900000: 0x4000000,
                                0x1a00000: 0x4,
                                0x1b00000: 0x10100,
                                0x1c00000: 0x4010000,
                                0x1d00000: 0x104,
                                0x1e00000: 0x10104,
                                0x1f00000: 0x4010004,
                                0x1080000: 0x4000000,
                                0x1180000: 0x104,
                                0x1280000: 0x4010100,
                                0x1380000: 0x0,
                                0x1480000: 0x10004,
                                0x1580000: 0x4000100,
                                0x1680000: 0x100,
                                0x1780000: 0x4010004,
                                0x1880000: 0x10000,
                                0x1980000: 0x4010104,
                                0x1a80000: 0x10104,
                                0x1b80000: 0x4000004,
                                0x1c80000: 0x4000104,
                                0x1d80000: 0x4010000,
                                0x1e80000: 0x4,
                                0x1f80000: 0x10100
                            },
                            {
                                0x0: 0x80401000,
                                0x10000: 0x80001040,
                                0x20000: 0x401040,
                                0x30000: 0x80400000,
                                0x40000: 0x0,
                                0x50000: 0x401000,
                                0x60000: 0x80000040,
                                0x70000: 0x400040,
                                0x80000: 0x80000000,
                                0x90000: 0x400000,
                                0xa0000: 0x40,
                                0xb0000: 0x80001000,
                                0xc0000: 0x80400040,
                                0xd0000: 0x1040,
                                0xe0000: 0x1000,
                                0xf0000: 0x80401040,
                                0x8000: 0x80001040,
                                0x18000: 0x40,
                                0x28000: 0x80400040,
                                0x38000: 0x80001000,
                                0x48000: 0x401000,
                                0x58000: 0x80401040,
                                0x68000: 0x0,
                                0x78000: 0x80400000,
                                0x88000: 0x1000,
                                0x98000: 0x80401000,
                                0xa8000: 0x400000,
                                0xb8000: 0x1040,
                                0xc8000: 0x80000000,
                                0xd8000: 0x400040,
                                0xe8000: 0x401040,
                                0xf8000: 0x80000040,
                                0x100000: 0x400040,
                                0x110000: 0x401000,
                                0x120000: 0x80000040,
                                0x130000: 0x0,
                                0x140000: 0x1040,
                                0x150000: 0x80400040,
                                0x160000: 0x80401000,
                                0x170000: 0x80001040,
                                0x180000: 0x80401040,
                                0x190000: 0x80000000,
                                0x1a0000: 0x80400000,
                                0x1b0000: 0x401040,
                                0x1c0000: 0x80001000,
                                0x1d0000: 0x400000,
                                0x1e0000: 0x40,
                                0x1f0000: 0x1000,
                                0x108000: 0x80400000,
                                0x118000: 0x80401040,
                                0x128000: 0x0,
                                0x138000: 0x401000,
                                0x148000: 0x400040,
                                0x158000: 0x80000000,
                                0x168000: 0x80001040,
                                0x178000: 0x40,
                                0x188000: 0x80000040,
                                0x198000: 0x1000,
                                0x1a8000: 0x80001000,
                                0x1b8000: 0x80400040,
                                0x1c8000: 0x1040,
                                0x1d8000: 0x80401000,
                                0x1e8000: 0x400000,
                                0x1f8000: 0x401040
                            },
                            {
                                0x0: 0x80,
                                0x1000: 0x1040000,
                                0x2000: 0x40000,
                                0x3000: 0x20000000,
                                0x4000: 0x20040080,
                                0x5000: 0x1000080,
                                0x6000: 0x21000080,
                                0x7000: 0x40080,
                                0x8000: 0x1000000,
                                0x9000: 0x20040000,
                                0xa000: 0x20000080,
                                0xb000: 0x21040080,
                                0xc000: 0x21040000,
                                0xd000: 0x0,
                                0xe000: 0x1040080,
                                0xf000: 0x21000000,
                                0x800: 0x1040080,
                                0x1800: 0x21000080,
                                0x2800: 0x80,
                                0x3800: 0x1040000,
                                0x4800: 0x40000,
                                0x5800: 0x20040080,
                                0x6800: 0x21040000,
                                0x7800: 0x20000000,
                                0x8800: 0x20040000,
                                0x9800: 0x0,
                                0xa800: 0x21040080,
                                0xb800: 0x1000080,
                                0xc800: 0x20000080,
                                0xd800: 0x21000000,
                                0xe800: 0x1000000,
                                0xf800: 0x40080,
                                0x10000: 0x40000,
                                0x11000: 0x80,
                                0x12000: 0x20000000,
                                0x13000: 0x21000080,
                                0x14000: 0x1000080,
                                0x15000: 0x21040000,
                                0x16000: 0x20040080,
                                0x17000: 0x1000000,
                                0x18000: 0x21040080,
                                0x19000: 0x21000000,
                                0x1a000: 0x1040000,
                                0x1b000: 0x20040000,
                                0x1c000: 0x40080,
                                0x1d000: 0x20000080,
                                0x1e000: 0x0,
                                0x1f000: 0x1040080,
                                0x10800: 0x21000080,
                                0x11800: 0x1000000,
                                0x12800: 0x1040000,
                                0x13800: 0x20040080,
                                0x14800: 0x20000000,
                                0x15800: 0x1040080,
                                0x16800: 0x80,
                                0x17800: 0x21040000,
                                0x18800: 0x40080,
                                0x19800: 0x21040080,
                                0x1a800: 0x0,
                                0x1b800: 0x21000000,
                                0x1c800: 0x1000080,
                                0x1d800: 0x40000,
                                0x1e800: 0x20040000,
                                0x1f800: 0x20000080
                            },
                            {
                                0x0: 0x10000008,
                                0x100: 0x2000,
                                0x200: 0x10200000,
                                0x300: 0x10202008,
                                0x400: 0x10002000,
                                0x500: 0x200000,
                                0x600: 0x200008,
                                0x700: 0x10000000,
                                0x800: 0x0,
                                0x900: 0x10002008,
                                0xa00: 0x202000,
                                0xb00: 0x8,
                                0xc00: 0x10200008,
                                0xd00: 0x202008,
                                0xe00: 0x2008,
                                0xf00: 0x10202000,
                                0x80: 0x10200000,
                                0x180: 0x10202008,
                                0x280: 0x8,
                                0x380: 0x200000,
                                0x480: 0x202008,
                                0x580: 0x10000008,
                                0x680: 0x10002000,
                                0x780: 0x2008,
                                0x880: 0x200008,
                                0x980: 0x2000,
                                0xa80: 0x10002008,
                                0xb80: 0x10200008,
                                0xc80: 0x0,
                                0xd80: 0x10202000,
                                0xe80: 0x202000,
                                0xf80: 0x10000000,
                                0x1000: 0x10002000,
                                0x1100: 0x10200008,
                                0x1200: 0x10202008,
                                0x1300: 0x2008,
                                0x1400: 0x200000,
                                0x1500: 0x10000000,
                                0x1600: 0x10000008,
                                0x1700: 0x202000,
                                0x1800: 0x202008,
                                0x1900: 0x0,
                                0x1a00: 0x8,
                                0x1b00: 0x10200000,
                                0x1c00: 0x2000,
                                0x1d00: 0x10002008,
                                0x1e00: 0x10202000,
                                0x1f00: 0x200008,
                                0x1080: 0x8,
                                0x1180: 0x202000,
                                0x1280: 0x200000,
                                0x1380: 0x10000008,
                                0x1480: 0x10002000,
                                0x1580: 0x2008,
                                0x1680: 0x10202008,
                                0x1780: 0x10200000,
                                0x1880: 0x10202000,
                                0x1980: 0x10200008,
                                0x1a80: 0x2000,
                                0x1b80: 0x202008,
                                0x1c80: 0x200008,
                                0x1d80: 0x0,
                                0x1e80: 0x10000000,
                                0x1f80: 0x10002008
                            },
                            {
                                0x0: 0x100000,
                                0x10: 0x2000401,
                                0x20: 0x400,
                                0x30: 0x100401,
                                0x40: 0x2100401,
                                0x50: 0x0,
                                0x60: 0x1,
                                0x70: 0x2100001,
                                0x80: 0x2000400,
                                0x90: 0x100001,
                                0xa0: 0x2000001,
                                0xb0: 0x2100400,
                                0xc0: 0x2100000,
                                0xd0: 0x401,
                                0xe0: 0x100400,
                                0xf0: 0x2000000,
                                0x8: 0x2100001,
                                0x18: 0x0,
                                0x28: 0x2000401,
                                0x38: 0x2100400,
                                0x48: 0x100000,
                                0x58: 0x2000001,
                                0x68: 0x2000000,
                                0x78: 0x401,
                                0x88: 0x100401,
                                0x98: 0x2000400,
                                0xa8: 0x2100000,
                                0xb8: 0x100001,
                                0xc8: 0x400,
                                0xd8: 0x2100401,
                                0xe8: 0x1,
                                0xf8: 0x100400,
                                0x100: 0x2000000,
                                0x110: 0x100000,
                                0x120: 0x2000401,
                                0x130: 0x2100001,
                                0x140: 0x100001,
                                0x150: 0x2000400,
                                0x160: 0x2100400,
                                0x170: 0x100401,
                                0x180: 0x401,
                                0x190: 0x2100401,
                                0x1a0: 0x100400,
                                0x1b0: 0x1,
                                0x1c0: 0x0,
                                0x1d0: 0x2100000,
                                0x1e0: 0x2000001,
                                0x1f0: 0x400,
                                0x108: 0x100400,
                                0x118: 0x2000401,
                                0x128: 0x2100001,
                                0x138: 0x1,
                                0x148: 0x2000000,
                                0x158: 0x100000,
                                0x168: 0x401,
                                0x178: 0x2100400,
                                0x188: 0x2000001,
                                0x198: 0x2100000,
                                0x1a8: 0x0,
                                0x1b8: 0x2100401,
                                0x1c8: 0x100401,
                                0x1d8: 0x400,
                                0x1e8: 0x2000400,
                                0x1f8: 0x100001
                            },
                            {
                                0x0: 0x8000820,
                                0x1: 0x20000,
                                0x2: 0x8000000,
                                0x3: 0x20,
                                0x4: 0x20020,
                                0x5: 0x8020820,
                                0x6: 0x8020800,
                                0x7: 0x800,
                                0x8: 0x8020000,
                                0x9: 0x8000800,
                                0xa: 0x20800,
                                0xb: 0x8020020,
                                0xc: 0x820,
                                0xd: 0x0,
                                0xe: 0x8000020,
                                0xf: 0x20820,
                                0x80000000: 0x800,
                                0x80000001: 0x8020820,
                                0x80000002: 0x8000820,
                                0x80000003: 0x8000000,
                                0x80000004: 0x8020000,
                                0x80000005: 0x20800,
                                0x80000006: 0x20820,
                                0x80000007: 0x20,
                                0x80000008: 0x8000020,
                                0x80000009: 0x820,
                                0x8000000a: 0x20020,
                                0x8000000b: 0x8020800,
                                0x8000000c: 0x0,
                                0x8000000d: 0x8020020,
                                0x8000000e: 0x8000800,
                                0x8000000f: 0x20000,
                                0x10: 0x20820,
                                0x11: 0x8020800,
                                0x12: 0x20,
                                0x13: 0x800,
                                0x14: 0x8000800,
                                0x15: 0x8000020,
                                0x16: 0x8020020,
                                0x17: 0x20000,
                                0x18: 0x0,
                                0x19: 0x20020,
                                0x1a: 0x8020000,
                                0x1b: 0x8000820,
                                0x1c: 0x8020820,
                                0x1d: 0x20800,
                                0x1e: 0x820,
                                0x1f: 0x8000000,
                                0x80000010: 0x20000,
                                0x80000011: 0x800,
                                0x80000012: 0x8020020,
                                0x80000013: 0x20820,
                                0x80000014: 0x20,
                                0x80000015: 0x8020000,
                                0x80000016: 0x8000000,
                                0x80000017: 0x8000820,
                                0x80000018: 0x8020820,
                                0x80000019: 0x8000020,
                                0x8000001a: 0x8000800,
                                0x8000001b: 0x0,
                                0x8000001c: 0x20800,
                                0x8000001d: 0x820,
                                0x8000001e: 0x20020,
                                0x8000001f: 0x8020800
                            }
                        ];
                        // Masks that select the SBOX input
                        var SBOX_MASK = [
                            0xf8000001,
                            0x1f800000,
                            0x01f80000,
                            0x001f8000,
                            0x0001f800,
                            0x00001f80,
                            0x000001f8,
                            0x8000001f
                        ];
                        /**
     * DES block cipher algorithm.
     */ var DES = C_algo.DES = BlockCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var key = this._key;
                                var keyWords = key.words;
                                // Select 56 bits according to PC1
                                var keyBits = [];
                                for(var i = 0; i < 56; i++){
                                    var keyBitPos = PC1[i] - 1;
                                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                                }
                                // Assemble 16 subkeys
                                var subKeys = this._subKeys = [];
                                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                                    // Create subkey
                                    var subKey = subKeys[nSubKey] = [];
                                    // Shortcut
                                    var bitShift = BIT_SHIFTS[nSubKey];
                                    // Select 48 bits according to PC2
                                    for(var i = 0; i < 24; i++){
                                        // Select from the left 28 key bits
                                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                                        // Select from the right 28 key bits
                                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                                    }
                                    // Since each subkey is applied to an expanded 32-bit input,
                                    // the subkey can be broken into 8 values scaled to 32-bits,
                                    // which allows the key to be used without expansion
                                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                                }
                                // Compute inverse subkeys
                                var invSubKeys = this._invSubKeys = [];
                                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                this._doCryptBlock(M, offset, this._subKeys);
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                this._doCryptBlock(M, offset, this._invSubKeys);
                            },
                            _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
                                // Get input
                                this._lBlock = M[offset];
                                this._rBlock = M[offset + 1];
                                // Initial permutation
                                exchangeLR.call(this, 4, 0x0f0f0f0f);
                                exchangeLR.call(this, 16, 0x0000ffff);
                                exchangeRL.call(this, 2, 0x33333333);
                                exchangeRL.call(this, 8, 0x00ff00ff);
                                exchangeLR.call(this, 1, 0x55555555);
                                // Rounds
                                for(var round = 0; round < 16; round++){
                                    // Shortcuts
                                    var subKey = subKeys[round];
                                    var lBlock = this._lBlock;
                                    var rBlock = this._rBlock;
                                    // Feistel function
                                    var f = 0;
                                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                                    this._lBlock = rBlock;
                                    this._rBlock = lBlock ^ f;
                                }
                                // Undo swap from last round
                                var t = this._lBlock;
                                this._lBlock = this._rBlock;
                                this._rBlock = t;
                                // Final permutation
                                exchangeLR.call(this, 1, 0x55555555);
                                exchangeRL.call(this, 8, 0x00ff00ff);
                                exchangeRL.call(this, 2, 0x33333333);
                                exchangeLR.call(this, 16, 0x0000ffff);
                                exchangeLR.call(this, 4, 0x0f0f0f0f);
                                // Set output
                                M[offset] = this._lBlock;
                                M[offset + 1] = this._rBlock;
                            },
                            keySize: 2,
                            ivSize: 2,
                            blockSize: 2
                        });
                        // Swap bits across the left and right words
                        function exchangeLR(offset, mask) {
                            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
                            this._rBlock ^= t;
                            this._lBlock ^= t << offset;
                        }
                        function exchangeRL(offset, mask) {
                            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
                            this._lBlock ^= t;
                            this._rBlock ^= t << offset;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
     */ C.DES = BlockCipher._createHelper(DES);
                        /**
     * Triple-DES block cipher algorithm.
     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var key = this._key;
                                var keyWords = key.words;
                                // Make sure the key length is valid (64, 128 or >= 192 bit)
                                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                                // Extend the key according to the keying options defined in 3DES standard
                                var key1 = keyWords.slice(0, 2);
                                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                                // Create DES instances
                                this._des1 = DES.createEncryptor(WordArray.create(key1));
                                this._des2 = DES.createEncryptor(WordArray.create(key2));
                                this._des3 = DES.createEncryptor(WordArray.create(key3));
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                this._des1.encryptBlock(M, offset);
                                this._des2.decryptBlock(M, offset);
                                this._des3.encryptBlock(M, offset);
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                this._des3.decryptBlock(M, offset);
                                this._des2.encryptBlock(M, offset);
                                this._des1.decryptBlock(M, offset);
                            },
                            keySize: 6,
                            ivSize: 2,
                            blockSize: 2
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
                    })();
                    return CryptoJS.TripleDES;
                });
            /***/ },
            /***/ 23204: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(53264));
                })(void 0, function(CryptoJS) {
                    (function(undefined1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var X32WordArray = C_lib.WordArray;
                        /**
     * x64 namespace.
     */ var C_x64 = C.x64 = {};
                        /**
     * A 64-bit word.
     */ var X64Word = C_x64.Word = Base.extend({
                            /**
       * Initializes a newly created 64-bit word.
       *
       * @param {number} high The high 32 bits.
       * @param {number} low The low 32 bits.
       *
       * @example
       *
       *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
       */ init: function init(high, low) {
                                this.high = high;
                                this.low = low;
                            }
                        });
                        /**
     * An array of 64-bit words.
     *
     * @property {Array} words The array of CryptoJS.x64.Word objects.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */ var X64WordArray = C_x64.WordArray = Base.extend({
                            /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.x64.WordArray.create();
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ]);
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ], 10);
       */ init: function init(words, sigBytes) {
                                words = this.words = words || [];
                                if (sigBytes != undefined1) this.sigBytes = sigBytes;
                                else this.sigBytes = words.length * 8;
                            },
                            /**
       * Converts this 64-bit word array to a 32-bit word array.
       *
       * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
       *
       * @example
       *
       *     var x32WordArray = x64WordArray.toX32();
       */ toX32: function toX32() {
                                // Shortcuts
                                var x64Words = this.words;
                                var x64WordsLength = x64Words.length;
                                // Convert
                                var x32Words = [];
                                for(var i = 0; i < x64WordsLength; i++){
                                    var x64Word = x64Words[i];
                                    x32Words.push(x64Word.high);
                                    x32Words.push(x64Word.low);
                                }
                                return X32WordArray.create(x32Words, this.sigBytes);
                            },
                            /**
       * Creates a copy of this word array.
       *
       * @return {X64WordArray} The clone.
       *
       * @example
       *
       *     var clone = x64WordArray.clone();
       */ clone: function clone() {
                                var clone = Base.clone.call(this);
                                // Clone "words" array
                                var words = clone.words = this.words.slice(0);
                                // Clone each X64Word object
                                var wordsLength = words.length;
                                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                                return clone;
                            }
                        });
                    })();
                    return CryptoJS;
                });
            /***/ },
            /***/ 41966: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(52729);
                __webpack_require__(33694);
                __webpack_require__(44063);
                __webpack_require__(62031);
                __webpack_require__(56908);
                __webpack_require__(6208);
                __webpack_require__(54994);
                __webpack_require__(35054);
                __webpack_require__(33290);
                __webpack_require__(4845);
                __webpack_require__(39275);
                __webpack_require__(75668);
                __webpack_require__(61928);
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(45007);
                __webpack_require__(68995);
                __webpack_require__(26364);
                __webpack_require__(86632);
                __webpack_require__(18821);
                function _createForOfIteratorHelperLoose(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (it) return (it = it.call(o)).next.bind(it);
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        return function() {
                            if (i >= o.length) return {
                                done: true
                            };
                            return {
                                done: false,
                                value: o[i++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _regeneratorRuntime() {
                    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
                    _regeneratorRuntime = function _regeneratorRuntime() {
                        return e;
                    };
                    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
                        t[e] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
                    function define(t, e, r) {
                        return Object.defineProperty(t, e, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), t[e];
                    }
                    try {
                        define({}, "");
                    } catch (t) {
                        define = function define(t, e, r) {
                            return t[e] = r;
                        };
                    }
                    function wrap(t, e, r, n) {
                        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
                        return o(a, "_invoke", {
                            value: makeInvokeMethod(t, r, c)
                        }), a;
                    }
                    function tryCatch(t, e, r) {
                        try {
                            return {
                                type: "normal",
                                arg: t.call(e, r)
                            };
                        } catch (t) {
                            return {
                                type: "throw",
                                arg: t
                            };
                        }
                    }
                    e.wrap = wrap;
                    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
                    function Generator() {}
                    function GeneratorFunction() {}
                    function GeneratorFunctionPrototype() {}
                    var p = {};
                    define(p, a, function() {
                        return this;
                    });
                    var d = Object.getPrototypeOf, v = d && d(d(values([])));
                    v && v !== r && n.call(v, a) && (p = v);
                    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
                    function defineIteratorMethods(t) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(e) {
                            define(t, e, function(t) {
                                return this._invoke(e, t);
                            });
                        });
                    }
                    function AsyncIterator(t, e) {
                        function invoke(r, o, i, a) {
                            var c = tryCatch(t[r], t, o);
                            if ("throw" !== c.type) {
                                var u = c.arg, h = u.value;
                                return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                                    invoke("next", t, i, a);
                                }, function(t) {
                                    invoke("throw", t, i, a);
                                }) : e.resolve(h).then(function(t) {
                                    u.value = t, i(u);
                                }, function(t) {
                                    return invoke("throw", t, i, a);
                                });
                            }
                            a(c.arg);
                        }
                        var r;
                        o(this, "_invoke", {
                            value: function value(t, n) {
                                function callInvokeWithMethodAndArg() {
                                    return new e(function(e, r) {
                                        invoke(t, n, e, r);
                                    });
                                }
                                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                            }
                        });
                    }
                    function makeInvokeMethod(e, r, n) {
                        var o = h;
                        return function(i, a) {
                            if (o === f) throw new Error("Generator is already running");
                            if (o === s) {
                                if ("throw" === i) throw a;
                                return {
                                    value: t,
                                    done: !0
                                };
                            }
                            for(n.method = i, n.arg = a;;){
                                var c = n.delegate;
                                if (c) {
                                    var u = maybeInvokeDelegate(c, n);
                                    if (u) {
                                        if (u === y) continue;
                                        return u;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (o === h) throw o = s, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                o = f;
                                var p = tryCatch(e, r, n);
                                if ("normal" === p.type) {
                                    if (o = n.done ? s : l, p.arg === y) continue;
                                    return {
                                        value: p.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                            }
                        };
                    }
                    function maybeInvokeDelegate(e, r) {
                        var n = r.method, o = e.iterator[n];
                        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var i = tryCatch(o, e.iterator, r.arg);
                        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                        var a = i.arg;
                        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function pushTryEntry(t) {
                        var e = {
                            tryLoc: t[0]
                        };
                        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
                    }
                    function resetTryEntry(t) {
                        var e = t.completion || {};
                        e.type = "normal", delete e.arg, t.completion = e;
                    }
                    function Context(t) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], t.forEach(pushTryEntry, this), this.reset(!0);
                    }
                    function values(e) {
                        if (e || "" === e) {
                            var r = e[a];
                            if (r) return r.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var o = -1, i = function next() {
                                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                                    return next.value = t, next.done = !0, next;
                                };
                                return i.next = i;
                            }
                        }
                        throw new TypeError(typeof e + " is not iterable");
                    }
                    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
                        value: GeneratorFunctionPrototype,
                        configurable: !0
                    }), o(GeneratorFunctionPrototype, "constructor", {
                        value: GeneratorFunction,
                        configurable: !0
                    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                        var e = "function" == typeof t && t.constructor;
                        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
                    }, e.mark = function(t) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
                    }, e.awrap = function(t) {
                        return {
                            __await: t
                        };
                    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
                        return this;
                    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new AsyncIterator(wrap(t, r, n, o), i);
                        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                            return t.done ? t.value : a.next();
                        });
                    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
                        return this;
                    }), define(g, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(t) {
                        var e = Object(t), r = [];
                        for(var n in e)r.push(n);
                        return r.reverse(), function next() {
                            for(; r.length;){
                                var t = r.pop();
                                if (t in e) return next.value = t, next.done = !1, next;
                            }
                            return next.done = !0, next;
                        };
                    }, e.values = values, Context.prototype = {
                        constructor: Context,
                        reset: function reset(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                        },
                        stop: function stop() {
                            this.done = !0;
                            var t = this.tryEntries[0].completion;
                            if ("throw" === t.type) throw t.arg;
                            return this.rval;
                        },
                        dispatchException: function dispatchException(e) {
                            if (this.done) throw e;
                            var r = this;
                            function handle(n, o) {
                                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var i = this.tryEntries[o], a = i.completion;
                                if ("root" === i.tryLoc) return handle("end");
                                if (i.tryLoc <= this.prev) {
                                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                                    if (c && u) {
                                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                                    } else if (c) {
                                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                    } else {
                                        if (!u) throw new Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function abrupt(t, e) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var o = this.tryEntries[r];
                                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var i = o;
                                    break;
                                }
                            }
                            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                            var a = i ? i.completion : {};
                            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                        },
                        complete: function complete(t, e) {
                            if ("throw" === t.type) throw t.arg;
                            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                        },
                        finish: function finish(t) {
                            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                                var r = this.tryEntries[e];
                                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                            }
                        },
                        catch: function _catch(t) {
                            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                                var r = this.tryEntries[e];
                                if (r.tryLoc === t) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var o = n.arg;
                                        resetTryEntry(r);
                                    }
                                    return o;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function delegateYield(e, r, n) {
                            return this.delegate = {
                                iterator: values(e),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = t), y;
                        }
                    }, e;
                }
                var INITIAL_STATE = 1;
                var FAIL_STATE = 0;
                /**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ var StateMachine = /*#__PURE__*/ function() {
                    function StateMachine(dfa) {
                        this.stateTable = dfa.stateTable;
                        this.accepting = dfa.accepting;
                        this.tags = dfa.tags;
                    }
                    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ var _proto = StateMachine.prototype;
                    _proto.match = function match(str) {
                        var _ref;
                        var self1 = this;
                        return _ref = {}, _ref[Symbol.iterator] = /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                            var state, startRun, lastAccepting, lastState, p, c;
                            return _regeneratorRuntime().wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        state = INITIAL_STATE;
                                        startRun = null;
                                        lastAccepting = null;
                                        lastState = null;
                                        p = 0;
                                    case 5:
                                        if (!(p < str.length)) {
                                            _context.next = 21;
                                            break;
                                        }
                                        c = str[p];
                                        lastState = state;
                                        state = self1.stateTable[state][c];
                                        if (!(state === FAIL_STATE)) {
                                            _context.next = 15;
                                            break;
                                        }
                                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                                            _context.next = 13;
                                            break;
                                        }
                                        _context.next = 13;
                                        return [
                                            startRun,
                                            lastAccepting,
                                            self1.tags[lastState]
                                        ];
                                    case 13:
                                        // reset the state as if we started over from the initial state
                                        state = self1.stateTable[INITIAL_STATE][c];
                                        startRun = null;
                                    case 15:
                                        // start a run if not in the failure state
                                        if (state !== FAIL_STATE && startRun == null) startRun = p;
                                         // if accepting, mark the potential match end
                                        if (self1.accepting[state]) lastAccepting = p;
                                         // reset the state to the initial state if we get into the failure state
                                        if (state === FAIL_STATE) state = INITIAL_STATE;
                                    case 18:
                                        p++;
                                        _context.next = 5;
                                        break;
                                    case 21:
                                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                                            _context.next = 24;
                                            break;
                                        }
                                        _context.next = 24;
                                        return [
                                            startRun,
                                            lastAccepting,
                                            self1.tags[state]
                                        ];
                                    case 24:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }), _ref;
                    } /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ ;
                    _proto.apply = function apply(str, actions) {
                        for(var _iterator = _createForOfIteratorHelperLoose(this.match(str)), _step; !(_step = _iterator()).done;){
                            var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
                            for(var _iterator2 = _createForOfIteratorHelperLoose(tags), _step2; !(_step2 = _iterator2()).done;){
                                var tag = _step2.value;
                                if (typeof actions[tag] === "function") actions[tag](start, end, str.slice(start, end + 1));
                            }
                        }
                    };
                    return StateMachine;
                }();
                module1.exports = StateMachine;
            /***/ },
            /***/ 45968: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                __webpack_require__(10853);
                __webpack_require__(35054);
                __webpack_require__(18821);
                __webpack_require__(18183);
                /*
 * MIT LICENSE
 * Copyright (c) 2011 Devon Govett
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify, merge,
 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons
 * to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or
 * substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ var fs = __webpack_require__(52773);
                var zlib = __webpack_require__(63339);
                module1.exports = /*#__PURE__*/ function() {
                    PNG.decode = function decode(path, fn) {
                        return fs.readFile(path, function(err, file) {
                            var png = new PNG(file);
                            return png.decode(function(pixels) {
                                return fn(pixels);
                            });
                        });
                    };
                    PNG.load = function load(path) {
                        var file = fs.readFileSync(path);
                        return new PNG(file);
                    };
                    function PNG(data) {
                        var i;
                        this.data = data;
                        this.pos = 8; // Skip the default header
                        this.palette = [];
                        this.imgData = [];
                        this.transparency = {};
                        this.text = {};
                        while(true){
                            var chunkSize = this.readUInt32();
                            var section = "";
                            for(i = 0; i < 4; i++)section += String.fromCharCode(this.data[this.pos++]);
                            switch(section){
                                case "IHDR":
                                    // we can grab  interesting values from here (like width, height, etc)
                                    this.width = this.readUInt32();
                                    this.height = this.readUInt32();
                                    this.bits = this.data[this.pos++];
                                    this.colorType = this.data[this.pos++];
                                    this.compressionMethod = this.data[this.pos++];
                                    this.filterMethod = this.data[this.pos++];
                                    this.interlaceMethod = this.data[this.pos++];
                                    break;
                                case "PLTE":
                                    this.palette = this.read(chunkSize);
                                    break;
                                case "IDAT":
                                    for(i = 0; i < chunkSize; i++)this.imgData.push(this.data[this.pos++]);
                                    break;
                                case "tRNS":
                                    // This chunk can only occur once and it must occur after the
                                    // PLTE chunk and before the IDAT chunk.
                                    this.transparency = {};
                                    switch(this.colorType){
                                        case 3:
                                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                                            // the palette index in the PLTE ("palette") chunk up until the
                                            // last non-opaque entry. Set up an array, stretching over all
                                            // palette entries which will be 0 (opaque) or 1 (transparent).
                                            this.transparency.indexed = this.read(chunkSize);
                                            var short = 255 - this.transparency.indexed.length;
                                            if (short > 0) for(i = 0; i < short; i++)this.transparency.indexed.push(255);
                                            break;
                                        case 0:
                                            // Greyscale. Corresponding to entries in the PLTE chunk.
                                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                                            this.transparency.grayscale = this.read(chunkSize)[0];
                                            break;
                                        case 2:
                                            // True color with proper alpha channel.
                                            this.transparency.rgb = this.read(chunkSize);
                                            break;
                                    }
                                    break;
                                case "tEXt":
                                    var text = this.read(chunkSize);
                                    var index = text.indexOf(0);
                                    var key = String.fromCharCode.apply(String, text.slice(0, index));
                                    this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                                    break;
                                case "IEND":
                                    // we've got everything we need!
                                    switch(this.colorType){
                                        case 0:
                                        case 3:
                                        case 4:
                                            this.colors = 1;
                                            break;
                                        case 2:
                                        case 6:
                                            this.colors = 3;
                                            break;
                                    }
                                    this.hasAlphaChannel = [
                                        4,
                                        6
                                    ].includes(this.colorType);
                                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                                    this.pixelBitlength = this.bits * colors;
                                    switch(this.colors){
                                        case 1:
                                            this.colorSpace = "DeviceGray";
                                            break;
                                        case 3:
                                            this.colorSpace = "DeviceRGB";
                                            break;
                                    }
                                    this.imgData = new Buffer(this.imgData);
                                    return;
                                default:
                                    // unknown (or unimportant) section, skip it
                                    this.pos += chunkSize;
                            }
                            this.pos += 4; // Skip the CRC
                            if (this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
                        }
                    }
                    var _proto = PNG.prototype;
                    _proto.read = function read(bytes) {
                        var result = new Array(bytes);
                        for(var i = 0; i < bytes; i++)result[i] = this.data[this.pos++];
                        return result;
                    };
                    _proto.readUInt32 = function readUInt32() {
                        var b1 = this.data[this.pos++] << 24;
                        var b2 = this.data[this.pos++] << 16;
                        var b3 = this.data[this.pos++] << 8;
                        var b4 = this.data[this.pos++];
                        return b1 | b2 | b3 | b4;
                    };
                    _proto.readUInt16 = function readUInt16() {
                        var b1 = this.data[this.pos++] << 8;
                        var b2 = this.data[this.pos++];
                        return b1 | b2;
                    };
                    _proto.decodePixels = function decodePixels(fn) {
                        var _this = this;
                        return zlib.inflate(this.imgData, function(err, data) {
                            if (err) throw err;
                            var width = _this.width, height = _this.height;
                            var pixelBytes = _this.pixelBitlength / 8;
                            var pixels = new Buffer(width * height * pixelBytes);
                            var length = data.length;
                            var pos = 0;
                            function pass(x0, y0, dx, dy, singlePass) {
                                if (singlePass === void 0) singlePass = false;
                                var w = Math.ceil((width - x0) / dx);
                                var h = Math.ceil((height - y0) / dy);
                                var scanlineLength = pixelBytes * w;
                                var buffer = singlePass ? pixels : new Buffer(scanlineLength * h);
                                var row = 0;
                                var c = 0;
                                while(row < h && pos < length){
                                    var byte, col, i, left, upper;
                                    switch(data[pos++]){
                                        case 0:
                                            // None
                                            for(i = 0; i < scanlineLength; i++)buffer[c++] = data[pos++];
                                            break;
                                        case 1:
                                            // Sub
                                            for(i = 0; i < scanlineLength; i++){
                                                byte = data[pos++];
                                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                                buffer[c++] = (byte + left) % 256;
                                            }
                                            break;
                                        case 2:
                                            // Up
                                            for(i = 0; i < scanlineLength; i++){
                                                byte = data[pos++];
                                                col = (i - i % pixelBytes) / pixelBytes;
                                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                                buffer[c++] = (upper + byte) % 256;
                                            }
                                            break;
                                        case 3:
                                            // Average
                                            for(i = 0; i < scanlineLength; i++){
                                                byte = data[pos++];
                                                col = (i - i % pixelBytes) / pixelBytes;
                                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                                buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                                            }
                                            break;
                                        case 4:
                                            // Paeth
                                            for(i = 0; i < scanlineLength; i++){
                                                var paeth, upperLeft;
                                                byte = data[pos++];
                                                col = (i - i % pixelBytes) / pixelBytes;
                                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                                if (row === 0) upper = upperLeft = 0;
                                                else {
                                                    upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                                    upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                                }
                                                var p = left + upper - upperLeft;
                                                var pa = Math.abs(p - left);
                                                var pb = Math.abs(p - upper);
                                                var pc = Math.abs(p - upperLeft);
                                                if (pa <= pb && pa <= pc) paeth = left;
                                                else if (pb <= pc) paeth = upper;
                                                else paeth = upperLeft;
                                                buffer[c++] = (byte + paeth) % 256;
                                            }
                                            break;
                                        default:
                                            throw new Error("Invalid filter algorithm: " + data[pos - 1]);
                                    }
                                    if (!singlePass) {
                                        var pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                                        var bufferPos = row * scanlineLength;
                                        for(i = 0; i < w; i++){
                                            for(var j = 0; j < pixelBytes; j++)pixels[pixelsPos++] = buffer[bufferPos++];
                                            pixelsPos += (dx - 1) * pixelBytes;
                                        }
                                    }
                                    row++;
                                }
                            }
                            if (_this.interlaceMethod === 1) {
                                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */ pass(0, 0, 8, 8); // 1
                                pass(4, 0, 8, 8); // 2
                                pass(0, 4, 4, 8); // 3
                                pass(2, 0, 4, 4); // 4
                                pass(0, 2, 2, 4); // 5
                                pass(1, 0, 2, 2); // 6
                                pass(0, 1, 1, 2); // 7
                            } else pass(0, 0, 1, 1, true);
                            return fn(pixels);
                        });
                    };
                    _proto.decodePalette = function decodePalette() {
                        var palette = this.palette;
                        var length = palette.length;
                        var transparency = this.transparency.indexed || [];
                        var ret = new Buffer(transparency.length + length);
                        var pos = 0;
                        var c = 0;
                        for(var i = 0; i < length; i += 3){
                            var left;
                            ret[pos++] = palette[i];
                            ret[pos++] = palette[i + 1];
                            ret[pos++] = palette[i + 2];
                            ret[pos++] = (left = transparency[c++]) != null ? left : 255;
                        }
                        return ret;
                    };
                    _proto.copyToImageData = function copyToImageData(imageData, pixels) {
                        var j, k;
                        var colors = this.colors;
                        var palette = null;
                        var alpha = this.hasAlphaChannel;
                        if (this.palette.length) {
                            palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
                            colors = 4;
                            alpha = true;
                        }
                        var data = imageData.data || imageData;
                        var length = data.length;
                        var input = palette || pixels;
                        var i = j = 0;
                        if (colors === 1) while(i < length){
                            k = palette ? pixels[i / 4] * 4 : j;
                            var v = input[k++];
                            data[i++] = v;
                            data[i++] = v;
                            data[i++] = v;
                            data[i++] = alpha ? input[k++] : 255;
                            j = k;
                        }
                        else while(i < length){
                            k = palette ? pixels[i / 4] * 4 : j;
                            data[i++] = input[k++];
                            data[i++] = input[k++];
                            data[i++] = input[k++];
                            data[i++] = alpha ? input[k++] : 255;
                            j = k;
                        }
                    };
                    _proto.decode = function decode(fn) {
                        var _this2 = this;
                        var ret = new Buffer(this.width * this.height * 4);
                        return this.decodePixels(function(pixels) {
                            _this2.copyToImageData(ret, pixels);
                            return fn(ret);
                        });
                    };
                    return PNG;
                }();
            /***/ },
            /***/ 85543: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                /* eslint-disable node/no-deprecated-api */ __webpack_require__(26875);
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(79627);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(83382);
                var buffer = __webpack_require__(43060);
                var Buffer = buffer.Buffer;
                var safer = {};
                var key;
                for(key in buffer){
                    if (!buffer.hasOwnProperty(key)) continue;
                    if (key === "SlowBuffer" || key === "Buffer") continue;
                    safer[key] = buffer[key];
                }
                var Safer = safer.Buffer = {};
                for(key in Buffer){
                    if (!Buffer.hasOwnProperty(key)) continue;
                    if (key === "allocUnsafe" || key === "allocUnsafeSlow") continue;
                    Safer[key] = Buffer[key];
                }
                safer.Buffer.prototype = Buffer.prototype;
                if (!Safer.from || Safer.from === Uint8Array.from) Safer.from = function(value, encodingOrOffset, length) {
                    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
                    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                    return Buffer(value, encodingOrOffset, length);
                };
                if (!Safer.alloc) Safer.alloc = function(size, fill, encoding) {
                    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
                    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                    var buf = Buffer(size);
                    if (!fill || fill.length === 0) buf.fill(0);
                    else if (typeof encoding === "string") buf.fill(fill, encoding);
                    else buf.fill(fill);
                    return buf;
                };
                if (!safer.kStringMaxLength) try {
                    safer.kStringMaxLength = process.binding("buffer").kStringMaxLength;
                } catch (e) {
                // we can't determine kStringMaxLength in environments where process.binding
                // is unsupported, so let's not set it
                }
                if (!safer.constants) {
                    safer.constants = {
                        MAX_LENGTH: safer.kMaxLength
                    };
                    if (safer.kStringMaxLength) safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength;
                }
                module1.exports = safer;
            /***/ },
            /***/ 55681: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(80044);
                __webpack_require__(26364);
                __webpack_require__(19701);
                __webpack_require__(10853);
                __webpack_require__(80238);
                __webpack_require__(6208);
                __webpack_require__(12938);
                __webpack_require__(16543);
                __webpack_require__(33142);
                __webpack_require__(86632);
                __webpack_require__(80174);
                __webpack_require__(18821);
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return typeof key === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (typeof input !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (typeof res !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                var _require = __webpack_require__(43060), Buffer = _require.Buffer;
                var _require2 = __webpack_require__(69862), inspect = _require2.inspect;
                var custom = inspect && inspect.custom || "inspect";
                function copyBuffer(src, target, offset) {
                    Buffer.prototype.copy.call(src, target, offset);
                }
                module1.exports = /*#__PURE__*/ function() {
                    function BufferList() {
                        _classCallCheck(this, BufferList);
                        this.head = null;
                        this.tail = null;
                        this.length = 0;
                    }
                    _createClass(BufferList, [
                        {
                            key: "push",
                            value: function push(v) {
                                var entry = {
                                    data: v,
                                    next: null
                                };
                                if (this.length > 0) this.tail.next = entry;
                                else this.head = entry;
                                this.tail = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function unshift(v) {
                                var entry = {
                                    data: v,
                                    next: this.head
                                };
                                if (this.length === 0) this.tail = entry;
                                this.head = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function shift() {
                                if (this.length === 0) return;
                                var ret = this.head.data;
                                if (this.length === 1) this.head = this.tail = null;
                                else this.head = this.head.next;
                                --this.length;
                                return ret;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.head = this.tail = null;
                                this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function join(s) {
                                if (this.length === 0) return "";
                                var p = this.head;
                                var ret = "" + p.data;
                                while(p = p.next)ret += s + p.data;
                                return ret;
                            }
                        },
                        {
                            key: "concat",
                            value: function concat(n) {
                                if (this.length === 0) return Buffer.alloc(0);
                                var ret = Buffer.allocUnsafe(n >>> 0);
                                var p = this.head;
                                var i = 0;
                                while(p){
                                    copyBuffer(p.data, ret, i);
                                    i += p.data.length;
                                    p = p.next;
                                }
                                return ret;
                            }
                        },
                        {
                            key: "consume",
                            value: function consume(n, hasStrings) {
                                var ret;
                                if (n < this.head.data.length) {
                                    // `slice` is the same for buffers and strings.
                                    ret = this.head.data.slice(0, n);
                                    this.head.data = this.head.data.slice(n);
                                } else if (n === this.head.data.length) // First chunk is a perfect match.
                                ret = this.shift();
                                else // Result spans more than one buffer.
                                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                                return ret;
                            }
                        },
                        {
                            key: "first",
                            value: function first() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function _getString(n) {
                                var p = this.head;
                                var c = 1;
                                var ret = p.data;
                                n -= ret.length;
                                while(p = p.next){
                                    var str = p.data;
                                    var nb = n > str.length ? str.length : n;
                                    if (nb === str.length) ret += str;
                                    else ret += str.slice(0, n);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === str.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = str.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function _getBuffer(n) {
                                var ret = Buffer.allocUnsafe(n);
                                var p = this.head;
                                var c = 1;
                                p.data.copy(ret);
                                n -= p.data.length;
                                while(p = p.next){
                                    var buf = p.data;
                                    var nb = n > buf.length ? buf.length : n;
                                    buf.copy(ret, ret.length - n, 0, nb);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === buf.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = buf.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            }
                        },
                        {
                            key: custom,
                            value: function value(_, options) {
                                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                                    // Only inspect one level.
                                    depth: 0,
                                    // It should not recurse.
                                    customInspect: false
                                }));
                            }
                        }
                    ]);
                    return BufferList;
                }();
            /***/ },
            /***/ 11504: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(83382);
                /* eslint-disable node/no-deprecated-api */ var buffer = __webpack_require__(43060);
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module1.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === "string") buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return buffer.SlowBuffer(size);
                };
            /***/ },
            /***/ 67827: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18821);
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(79627);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(35779);
                var inflate = __webpack_require__(84346);
                var _require = __webpack_require__(84962), swap32LE = _require.swap32LE;
                // Shift size for getting the index-1 table offset.
                var SHIFT_1 = 11;
                // Shift size for getting the index-2 table offset.
                var SHIFT_2 = 5;
                // Difference between the two shift sizes,
                // for getting an index-1 offset from an index-2 offset. 6=11-5
                var SHIFT_1_2 = SHIFT_1 - SHIFT_2;
                // Number of index-1 entries for the BMP. 32=0x20
                // This part of the index-1 table is omitted from the serialized form.
                var OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
                // Number of entries in an index-2 block. 64=0x40
                var INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
                // Mask for getting the lower bits for the in-index-2-block offset. */
                var INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
                // Shift size for shifting left the index array values.
                // Increases possible data size with 16-bit index values at the cost
                // of compactability.
                // This requires data blocks to be aligned by DATA_GRANULARITY.
                var INDEX_SHIFT = 2;
                // Number of entries in a data block. 32=0x20
                var DATA_BLOCK_LENGTH = 1 << SHIFT_2;
                // Mask for getting the lower bits for the in-data-block offset.
                var DATA_MASK = DATA_BLOCK_LENGTH - 1;
                // The part of the index-2 table for U+D800..U+DBFF stores values for
                // lead surrogate code _units_ not code _points_.
                // Values for lead surrogate code _points_ are indexed with this portion of the table.
                // Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
                var LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
                var LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
                // Count the lengths of both BMP pieces. 2080=0x820
                var INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
                // The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
                // Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
                var UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
                var UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
                // The index-1 table, only used for supplementary code points, at offset 2112=0x840.
                // Variable length, for code points up to highStart, where the last single-value range starts.
                // Maximum length 512=0x200=0x100000>>SHIFT_1.
                // (For 0x100000 supplementary code points U+10000..U+10ffff.)
                //
                // The part of the index-2 table for supplementary code points starts
                // after this index-1 table.
                //
                // Both the index-1 table and the following part of the index-2 table
                // are omitted completely if there is only BMP data.
                var INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
                // The alignment size of a data block. Also the granularity for compaction.
                var DATA_GRANULARITY = 1 << INDEX_SHIFT;
                var UnicodeTrie = /*#__PURE__*/ function() {
                    function UnicodeTrie(data) {
                        var isBuffer = typeof data.readUInt32BE === "function" && typeof data.slice === "function";
                        if (isBuffer || data instanceof Uint8Array) {
                            // read binary format
                            var uncompressedLength;
                            if (isBuffer) {
                                this.highStart = data.readUInt32LE(0);
                                this.errorValue = data.readUInt32LE(4);
                                uncompressedLength = data.readUInt32LE(8);
                                data = data.slice(12);
                            } else {
                                var view = new DataView(data.buffer);
                                this.highStart = view.getUint32(0, true);
                                this.errorValue = view.getUint32(4, true);
                                uncompressedLength = view.getUint32(8, true);
                                data = data.subarray(12);
                            }
                            // double inflate the actual trie data
                            data = inflate(data, new Uint8Array(uncompressedLength));
                            data = inflate(data, new Uint8Array(uncompressedLength));
                            // swap bytes from little-endian
                            swap32LE(data);
                            this.data = new Uint32Array(data.buffer);
                        } else {
                            // pre-parsed data
                            var _data = data;
                            this.data = _data.data;
                            this.highStart = _data.highStart;
                            this.errorValue = _data.errorValue;
                        }
                    }
                    var _proto = UnicodeTrie.prototype;
                    _proto.get = function get(codePoint) {
                        var index;
                        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
                        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
                            // Ordinary BMP code point, excluding leading surrogates.
                            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
                            // data is stored in the index array itself.
                            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
                            return this.data[index];
                        }
                        if (codePoint <= 0xffff) {
                            // Lead Surrogate Code Point.  A Separate index section is stored for
                            // lead surrogate code units and code points.
                            //   The main index has the code unit data.
                            //   For this function, we need the code point data.
                            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
                            return this.data[index];
                        }
                        if (codePoint < this.highStart) {
                            // Supplemental code point, use two-level lookup.
                            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
                            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
                            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
                            return this.data[index];
                        }
                        return this.data[this.data.length - DATA_GRANULARITY];
                    };
                    return UnicodeTrie;
                }();
                module1.exports = UnicodeTrie;
            /***/ },
            /***/ 84962: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(79627);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(35779);
                var isBigEndian = new Uint8Array(new Uint32Array([
                    0x12345678
                ]).buffer)[0] === 0x12;
                var swap = function swap(b, n, m) {
                    var i = b[n];
                    b[n] = b[m];
                    b[m] = i;
                };
                var swap32 = function swap32(array) {
                    var len = array.length;
                    for(var i = 0; i < len; i += 4){
                        swap(array, i, i + 3);
                        swap(array, i + 1, i + 2);
                    }
                };
                var swap32LE = function swap32LE(array) {
                    if (isBigEndian) swap32(array);
                };
                module1.exports = {
                    swap32LE: swap32LE
                };
            /***/ },
            /***/ 31589: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var SVGtoPDF = __webpack_require__(60902);
                module1.exports = SVGtoPDF;
            /***/ },
            /***/ 60902: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                __webpack_require__(54994);
                __webpack_require__(80044);
                __webpack_require__(29897);
                __webpack_require__(39275);
                __webpack_require__(75668);
                __webpack_require__(47639);
                __webpack_require__(22321);
                __webpack_require__(18821);
                __webpack_require__(80174);
                __webpack_require__(67838);
                __webpack_require__(55862);
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(68995);
                __webpack_require__(86125);
                __webpack_require__(83382);
                var SVGtoPDF = function SVGtoPDF(doc, svg, x, y, options) {
                    "use strict";
                    var NamedColors = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ]
                    };
                    var DefaultColors = {
                        black: [
                            NamedColors.black,
                            1
                        ],
                        white: [
                            NamedColors.white,
                            1
                        ],
                        transparent: [
                            NamedColors.black,
                            0
                        ]
                    };
                    var Entities = {
                        quot: 34,
                        amp: 38,
                        lt: 60,
                        gt: 62,
                        apos: 39,
                        OElig: 338,
                        oelig: 339,
                        Scaron: 352,
                        scaron: 353,
                        Yuml: 376,
                        circ: 710,
                        tilde: 732,
                        ensp: 8194,
                        emsp: 8195,
                        thinsp: 8201,
                        zwnj: 8204,
                        zwj: 8205,
                        lrm: 8206,
                        rlm: 8207,
                        ndash: 8211,
                        mdash: 8212,
                        lsquo: 8216,
                        rsquo: 8217,
                        sbquo: 8218,
                        ldquo: 8220,
                        rdquo: 8221,
                        bdquo: 8222,
                        dagger: 8224,
                        Dagger: 8225,
                        permil: 8240,
                        lsaquo: 8249,
                        rsaquo: 8250,
                        euro: 8364,
                        nbsp: 160,
                        iexcl: 161,
                        cent: 162,
                        pound: 163,
                        curren: 164,
                        yen: 165,
                        brvbar: 166,
                        sect: 167,
                        uml: 168,
                        copy: 169,
                        ordf: 170,
                        laquo: 171,
                        not: 172,
                        shy: 173,
                        reg: 174,
                        macr: 175,
                        deg: 176,
                        plusmn: 177,
                        sup2: 178,
                        sup3: 179,
                        acute: 180,
                        micro: 181,
                        para: 182,
                        middot: 183,
                        cedil: 184,
                        sup1: 185,
                        ordm: 186,
                        raquo: 187,
                        frac14: 188,
                        frac12: 189,
                        frac34: 190,
                        iquest: 191,
                        Agrave: 192,
                        Aacute: 193,
                        Acirc: 194,
                        Atilde: 195,
                        Auml: 196,
                        Aring: 197,
                        AElig: 198,
                        Ccedil: 199,
                        Egrave: 200,
                        Eacute: 201,
                        Ecirc: 202,
                        Euml: 203,
                        Igrave: 204,
                        Iacute: 205,
                        Icirc: 206,
                        Iuml: 207,
                        ETH: 208,
                        Ntilde: 209,
                        Ograve: 210,
                        Oacute: 211,
                        Ocirc: 212,
                        Otilde: 213,
                        Ouml: 214,
                        times: 215,
                        Oslash: 216,
                        Ugrave: 217,
                        Uacute: 218,
                        Ucirc: 219,
                        Uuml: 220,
                        Yacute: 221,
                        THORN: 222,
                        szlig: 223,
                        agrave: 224,
                        aacute: 225,
                        acirc: 226,
                        atilde: 227,
                        auml: 228,
                        aring: 229,
                        aelig: 230,
                        ccedil: 231,
                        egrave: 232,
                        eacute: 233,
                        ecirc: 234,
                        euml: 235,
                        igrave: 236,
                        iacute: 237,
                        icirc: 238,
                        iuml: 239,
                        eth: 240,
                        ntilde: 241,
                        ograve: 242,
                        oacute: 243,
                        ocirc: 244,
                        otilde: 245,
                        ouml: 246,
                        divide: 247,
                        oslash: 248,
                        ugrave: 249,
                        uacute: 250,
                        ucirc: 251,
                        uuml: 252,
                        yacute: 253,
                        thorn: 254,
                        yuml: 255,
                        fnof: 402,
                        Alpha: 913,
                        Beta: 914,
                        Gamma: 915,
                        Delta: 916,
                        Epsilon: 917,
                        Zeta: 918,
                        Eta: 919,
                        Theta: 920,
                        Iota: 921,
                        Kappa: 922,
                        Lambda: 923,
                        Mu: 924,
                        Nu: 925,
                        Xi: 926,
                        Omicron: 927,
                        Pi: 928,
                        Rho: 929,
                        Sigma: 931,
                        Tau: 932,
                        Upsilon: 933,
                        Phi: 934,
                        Chi: 935,
                        Psi: 936,
                        Omega: 937,
                        alpha: 945,
                        beta: 946,
                        gamma: 947,
                        delta: 948,
                        epsilon: 949,
                        zeta: 950,
                        eta: 951,
                        theta: 952,
                        iota: 953,
                        kappa: 954,
                        lambda: 955,
                        mu: 956,
                        nu: 957,
                        xi: 958,
                        omicron: 959,
                        pi: 960,
                        rho: 961,
                        sigmaf: 962,
                        sigma: 963,
                        tau: 964,
                        upsilon: 965,
                        phi: 966,
                        chi: 967,
                        psi: 968,
                        omega: 969,
                        thetasym: 977,
                        upsih: 978,
                        piv: 982,
                        bull: 8226,
                        hellip: 8230,
                        prime: 8242,
                        Prime: 8243,
                        oline: 8254,
                        frasl: 8260,
                        weierp: 8472,
                        image: 8465,
                        real: 8476,
                        trade: 8482,
                        alefsym: 8501,
                        larr: 8592,
                        uarr: 8593,
                        rarr: 8594,
                        darr: 8595,
                        harr: 8596,
                        crarr: 8629,
                        lArr: 8656,
                        uArr: 8657,
                        rArr: 8658,
                        dArr: 8659,
                        hArr: 8660,
                        forall: 8704,
                        part: 8706,
                        exist: 8707,
                        empty: 8709,
                        nabla: 8711,
                        isin: 8712,
                        notin: 8713,
                        ni: 8715,
                        prod: 8719,
                        sum: 8721,
                        minus: 8722,
                        lowast: 8727,
                        radic: 8730,
                        prop: 8733,
                        infin: 8734,
                        ang: 8736,
                        and: 8743,
                        or: 8744,
                        cap: 8745,
                        cup: 8746,
                        int: 8747,
                        there4: 8756,
                        sim: 8764,
                        cong: 8773,
                        asymp: 8776,
                        ne: 8800,
                        equiv: 8801,
                        le: 8804,
                        ge: 8805,
                        sub: 8834,
                        sup: 8835,
                        nsub: 8836,
                        sube: 8838,
                        supe: 8839,
                        oplus: 8853,
                        otimes: 8855,
                        perp: 8869,
                        sdot: 8901,
                        lceil: 8968,
                        rceil: 8969,
                        lfloor: 8970,
                        rfloor: 8971,
                        lang: 9001,
                        rang: 9002,
                        loz: 9674,
                        spades: 9824,
                        clubs: 9827,
                        hearts: 9829,
                        diams: 9830
                    };
                    var PathArguments = {
                        A: 7,
                        a: 7,
                        C: 6,
                        c: 6,
                        H: 1,
                        h: 1,
                        L: 2,
                        l: 2,
                        M: 2,
                        m: 2,
                        Q: 4,
                        q: 4,
                        S: 4,
                        s: 4,
                        T: 2,
                        t: 2,
                        V: 1,
                        v: 1,
                        Z: 0,
                        z: 0
                    };
                    var PathFlags = {
                        A3: true,
                        A4: true,
                        a3: true,
                        a4: true
                    };
                    var Properties = {
                        "color": {
                            inherit: true,
                            initial: undefined
                        },
                        "visibility": {
                            inherit: true,
                            initial: "visible",
                            values: {
                                "hidden": "hidden",
                                "collapse": "hidden",
                                "visible": "visible"
                            }
                        },
                        "fill": {
                            inherit: true,
                            initial: DefaultColors.black
                        },
                        "stroke": {
                            inherit: true,
                            initial: "none"
                        },
                        "stop-color": {
                            inherit: false,
                            initial: DefaultColors.black
                        },
                        "fill-opacity": {
                            inherit: true,
                            initial: 1
                        },
                        "stroke-opacity": {
                            inherit: true,
                            initial: 1
                        },
                        "stop-opacity": {
                            inherit: false,
                            initial: 1
                        },
                        "fill-rule": {
                            inherit: true,
                            initial: "nonzero",
                            values: {
                                "nonzero": "nonzero",
                                "evenodd": "evenodd"
                            }
                        },
                        "clip-rule": {
                            inherit: true,
                            initial: "nonzero",
                            values: {
                                "nonzero": "nonzero",
                                "evenodd": "evenodd"
                            }
                        },
                        "stroke-width": {
                            inherit: true,
                            initial: 1
                        },
                        "stroke-dasharray": {
                            inherit: true,
                            initial: []
                        },
                        "stroke-dashoffset": {
                            inherit: true,
                            initial: 0
                        },
                        "stroke-miterlimit": {
                            inherit: true,
                            initial: 4
                        },
                        "stroke-linejoin": {
                            inherit: true,
                            initial: "miter",
                            values: {
                                "miter": "miter",
                                "round": "round",
                                "bevel": "bevel"
                            }
                        },
                        "stroke-linecap": {
                            inherit: true,
                            initial: "butt",
                            values: {
                                "butt": "butt",
                                "round": "round",
                                "square": "square"
                            }
                        },
                        "font-size": {
                            inherit: true,
                            initial: 16,
                            values: {
                                "xx-small": 9,
                                "x-small": 10,
                                "small": 13,
                                "medium": 16,
                                "large": 18,
                                "x-large": 24,
                                "xx-large": 32
                            }
                        },
                        "font-family": {
                            inherit: true,
                            initial: "sans-serif"
                        },
                        "font-weight": {
                            inherit: true,
                            initial: "normal",
                            values: {
                                "600": "bold",
                                "700": "bold",
                                "800": "bold",
                                "900": "bold",
                                "bold": "bold",
                                "bolder": "bold",
                                "500": "normal",
                                "400": "normal",
                                "300": "normal",
                                "200": "normal",
                                "100": "normal",
                                "normal": "normal",
                                "lighter": "normal"
                            }
                        },
                        "font-style": {
                            inherit: true,
                            initial: "normal",
                            values: {
                                "italic": "italic",
                                "oblique": "italic",
                                "normal": "normal"
                            }
                        },
                        "text-anchor": {
                            inherit: true,
                            initial: "start",
                            values: {
                                "start": "start",
                                "middle": "middle",
                                "end": "end"
                            }
                        },
                        "direction": {
                            inherit: true,
                            initial: "ltr",
                            values: {
                                "ltr": "ltr",
                                "rtl": "rtl"
                            }
                        },
                        "dominant-baseline": {
                            inherit: true,
                            initial: "baseline",
                            values: {
                                "auto": "baseline",
                                "baseline": "baseline",
                                "before-edge": "before-edge",
                                "text-before-edge": "before-edge",
                                "middle": "middle",
                                "central": "central",
                                "after-edge": "after-edge",
                                "text-after-edge": "after-edge",
                                "ideographic": "ideographic",
                                "alphabetic": "alphabetic",
                                "hanging": "hanging",
                                "mathematical": "mathematical"
                            }
                        },
                        "alignment-baseline": {
                            inherit: false,
                            initial: undefined,
                            values: {
                                "auto": "baseline",
                                "baseline": "baseline",
                                "before-edge": "before-edge",
                                "text-before-edge": "before-edge",
                                "middle": "middle",
                                "central": "central",
                                "after-edge": "after-edge",
                                "text-after-edge": "after-edge",
                                "ideographic": "ideographic",
                                "alphabetic": "alphabetic",
                                "hanging": "hanging",
                                "mathematical": "mathematical"
                            }
                        },
                        "baseline-shift": {
                            inherit: true,
                            initial: "baseline",
                            values: {
                                "baseline": "baseline",
                                "sub": "sub",
                                "super": "super"
                            }
                        },
                        "word-spacing": {
                            inherit: true,
                            initial: 0,
                            values: {
                                normal: 0
                            }
                        },
                        "letter-spacing": {
                            inherit: true,
                            initial: 0,
                            values: {
                                normal: 0
                            }
                        },
                        "text-decoration": {
                            inherit: false,
                            initial: "none",
                            values: {
                                "none": "none",
                                "underline": "underline",
                                "overline": "overline",
                                "line-through": "line-through"
                            }
                        },
                        "xml:space": {
                            inherit: true,
                            initial: "default",
                            css: "white-space",
                            values: {
                                "preserve": "preserve",
                                "default": "default",
                                "pre": "preserve",
                                "pre-line": "preserve",
                                "pre-wrap": "preserve",
                                "nowrap": "default"
                            }
                        },
                        "marker-start": {
                            inherit: true,
                            initial: "none"
                        },
                        "marker-mid": {
                            inherit: true,
                            initial: "none"
                        },
                        "marker-end": {
                            inherit: true,
                            initial: "none"
                        },
                        "opacity": {
                            inherit: false,
                            initial: 1
                        },
                        "transform": {
                            inherit: false,
                            initial: [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ]
                        },
                        "display": {
                            inherit: false,
                            initial: "inline",
                            values: {
                                "none": "none",
                                "inline": "inline",
                                "block": "inline"
                            }
                        },
                        "clip-path": {
                            inherit: false,
                            initial: "none"
                        },
                        "mask": {
                            inherit: false,
                            initial: "none"
                        },
                        "overflow": {
                            inherit: false,
                            initial: "hidden",
                            values: {
                                "hidden": "hidden",
                                "scroll": "hidden",
                                "visible": "visible"
                            }
                        }
                    };
                    function docBeginGroup(bbox) {
                        var group = new function PDFGroup() {}();
                        group.name = "G" + (doc._groupCount = (doc._groupCount || 0) + 1);
                        group.resources = doc.ref();
                        group.xobj = doc.ref({
                            Type: "XObject",
                            Subtype: "Form",
                            FormType: 1,
                            BBox: bbox,
                            Group: {
                                S: "Transparency",
                                CS: "DeviceRGB",
                                I: true,
                                K: false
                            },
                            Resources: group.resources
                        });
                        group.xobj.write("");
                        group.savedMatrix = doc._ctm;
                        group.savedPage = doc.page;
                        groupStack.push(group);
                        doc._ctm = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        doc.page = {
                            width: doc.page.width,
                            height: doc.page.height,
                            write: function write(data) {
                                group.xobj.write(data);
                            },
                            fonts: {},
                            xobjects: {},
                            ext_gstates: {},
                            patterns: {}
                        };
                        return group;
                    }
                    function docEndGroup(group) {
                        if (group !== groupStack.pop()) throw "Group not matching";
                        if (Object.keys(doc.page.fonts).length) group.resources.data.Font = doc.page.fonts;
                        if (Object.keys(doc.page.xobjects).length) group.resources.data.XObject = doc.page.xobjects;
                        if (Object.keys(doc.page.ext_gstates).length) group.resources.data.ExtGState = doc.page.ext_gstates;
                        if (Object.keys(doc.page.patterns).length) group.resources.data.Pattern = doc.page.patterns;
                        group.resources.end();
                        group.xobj.end();
                        doc._ctm = group.savedMatrix;
                        doc.page = group.savedPage;
                    }
                    function docInsertGroup(group) {
                        doc.page.xobjects[group.name] = group.xobj;
                        doc.addContent("/" + group.name + " Do");
                    }
                    function docApplyMask(group, clip) {
                        var name = "M" + (doc._maskCount = (doc._maskCount || 0) + 1);
                        var gstate = doc.ref({
                            Type: "ExtGState",
                            CA: 1,
                            ca: 1,
                            BM: "Normal",
                            SMask: {
                                S: "Luminosity",
                                G: group.xobj,
                                BC: clip ? [
                                    0,
                                    0,
                                    0
                                ] : [
                                    1,
                                    1,
                                    1
                                ]
                            }
                        });
                        gstate.end();
                        doc.page.ext_gstates[name] = gstate;
                        doc.addContent("/" + name + " gs");
                    }
                    function docCreatePattern(group, dx, dy, matrix) {
                        var pattern = new function PDFPattern() {}();
                        pattern.group = group;
                        pattern.dx = dx;
                        pattern.dy = dy;
                        pattern.matrix = matrix || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        return pattern;
                    }
                    function docUsePattern(pattern, stroke) {
                        var name = "P" + (doc._patternCount = (doc._patternCount || 0) + 1);
                        var ref = doc.ref({
                            Type: "Pattern",
                            PatternType: 1,
                            PaintType: 1,
                            TilingType: 2,
                            BBox: [
                                0,
                                0,
                                pattern.dx,
                                pattern.dy
                            ],
                            XStep: pattern.dx,
                            YStep: pattern.dy,
                            Matrix: multiplyMatrix(doc._ctm, pattern.matrix),
                            Resources: {
                                ProcSet: [
                                    "PDF",
                                    "Text",
                                    "ImageB",
                                    "ImageC",
                                    "ImageI"
                                ],
                                XObject: function() {
                                    var temp = {};
                                    temp[pattern.group.name] = pattern.group.xobj;
                                    return temp;
                                }()
                            }
                        });
                        ref.write("/" + pattern.group.name + " Do");
                        ref.end();
                        doc.page.patterns[name] = ref;
                        if (stroke) {
                            doc.addContent("/Pattern CS");
                            doc.addContent("/" + name + " SCN");
                        } else {
                            doc.addContent("/Pattern cs");
                            doc.addContent("/" + name + " scn");
                        }
                    }
                    function docBeginText(font, size) {
                        if (!doc.page.fonts[font.id]) doc.page.fonts[font.id] = font.ref();
                        doc.addContent("BT").addContent("/" + font.id + " " + size + " Tf");
                    }
                    function docSetTextMatrix(a, b, c, d, e, f) {
                        doc.addContent(validateNumber(a) + " " + validateNumber(b) + " " + validateNumber(-c) + " " + validateNumber(-d) + " " + validateNumber(e) + " " + validateNumber(f) + " Tm");
                    }
                    function docSetTextMode(fill, stroke) {
                        var mode = fill && stroke ? 2 : stroke ? 1 : fill ? 0 : 3;
                        doc.addContent(mode + " Tr");
                    }
                    function docWriteGlyph(glyph) {
                        doc.addContent("<" + glyph + "> Tj");
                    }
                    function docEndText() {
                        doc.addContent("ET");
                    }
                    function docFillColor(color) {
                        if (color[0].constructor.name === "PDFPattern") {
                            doc.fillOpacity(color[1]);
                            docUsePattern(color[0], false);
                        } else doc.fillColor(color[0], color[1]);
                    }
                    function docStrokeColor(color) {
                        if (color[0].constructor.name === "PDFPattern") {
                            doc.strokeOpacity(color[1]);
                            docUsePattern(color[0], true);
                        } else doc.strokeColor(color[0], color[1]);
                    }
                    function docInsertLink(x, y, w, h, url) {
                        var ref = doc.ref({
                            Type: "Annot",
                            Subtype: "Link",
                            Rect: [
                                x,
                                y,
                                w,
                                h
                            ],
                            Border: [
                                0,
                                0,
                                0
                            ],
                            A: {
                                S: "URI",
                                URI: new String(url)
                            }
                        });
                        ref.end();
                        links.push(ref);
                    }
                    function parseXml(xml) {
                        var SvgNode = function SvgNode(tag, type, value, error) {
                            this.error = error;
                            this.nodeName = tag;
                            this.nodeValue = value;
                            this.nodeType = type;
                            this.attributes = Object.create(null);
                            this.childNodes = [];
                            this.parentNode = null;
                            this.id = "";
                            this.textContent = "";
                            this.classList = [];
                        };
                        SvgNode.prototype.getAttribute = function(attr) {
                            return this.attributes[attr] != null ? this.attributes[attr] : null;
                        };
                        SvgNode.prototype.getElementById = function(id) {
                            var result = null;
                            (function recursive(node) {
                                if (result) return;
                                if (node.nodeType === 1) {
                                    if (node.id === id) result = node;
                                    for(var i = 0; i < node.childNodes.length; i++)recursive(node.childNodes[i]);
                                }
                            })(this);
                            return result;
                        };
                        SvgNode.prototype.getElementsByTagName = function(tag) {
                            var result = [];
                            (function recursive(node) {
                                if (node.nodeType === 1) {
                                    if (node.nodeName === tag) result.push(node);
                                    for(var i = 0; i < node.childNodes.length; i++)recursive(node.childNodes[i]);
                                }
                            })(this);
                            return result;
                        };
                        var parser = new StringParser(xml.trim()), result, child, error = false;
                        var recursive = function recursive() {
                            var temp, child;
                            if (temp = parser.match(/^<([\w:.-]+)\s*/, true)) {
                                // Opening tag
                                var node = new SvgNode(temp[1], 1, null, error);
                                while(temp = parser.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, true)){
                                    // Attribute
                                    var attr = temp[1], value = decodeEntities(temp[2] || temp[3] || "");
                                    if (!node.attributes[attr]) {
                                        node.attributes[attr] = value;
                                        if (attr === "id") node.id = value;
                                        if (attr === "class") node.classList = value.split(" ");
                                    } else {
                                        warningCallback('parseXml: duplicate attribute "' + attr + '"');
                                        error = true;
                                    }
                                }
                                if (parser.match(/^>/)) {
                                    // End of opening tag
                                    while(child = recursive()){
                                        node.childNodes.push(child);
                                        child.parentNode = node;
                                        node.textContent += child.nodeType === 3 || child.nodeType === 4 ? child.nodeValue : child.textContent;
                                    }
                                    if (temp = parser.match(/^<\/([\w:.-]+)\s*>/, true)) {
                                        // Closing tag
                                        if (temp[1] === node.nodeName) return node;
                                        else {
                                            warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & closing "' + temp[1] + '"');
                                            error = true;
                                            return node;
                                        }
                                    } else {
                                        warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & not closing');
                                        error = true;
                                        return node;
                                    }
                                } else if (parser.match(/^\/>/)) // Self-closing tag
                                return node;
                                else {
                                    warningCallback('parseXml: tag could not be parsed "' + node.nodeName + '"');
                                    error = true;
                                }
                            } else if (temp = parser.match(/^<!--[\s\S]*?-->/)) // Comment
                            return new SvgNode(null, 8, temp, error);
                            else if (temp = parser.match(/^<\?[\s\S]*?\?>/)) // Processing instructions
                            return new SvgNode(null, 7, temp, error);
                            else if (temp = parser.match(/^<!DOCTYPE\s*([\s\S]*?)>/)) // Doctype
                            return new SvgNode(null, 10, temp, error);
                            else if (temp = parser.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, true)) // Cdata node
                            return new SvgNode("#cdata-section", 4, temp[1], error);
                            else if (temp = parser.match(/^([^<]+)/, true)) // Text node
                            return new SvgNode("#text", 3, decodeEntities(temp[1]), error);
                        };
                        while(child = recursive()){
                            if (child.nodeType === 1 && !result) result = child;
                            else if (child.nodeType === 1 || child.nodeType === 3 && child.nodeValue.trim() !== "") warningCallback("parseXml: data after document end has been discarded");
                        }
                        if (parser.matchAll()) warningCallback("parseXml: parsing error");
                        return result;
                    }
                    function decodeEntities(str) {
                        return str.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, function(mt, m0, m1, m2) {
                            if (m0) return String.fromCharCode(parseInt(m0, 10));
                            else if (m1) return String.fromCharCode(parseInt(m1, 16));
                            else if (m2 && Entities[m2]) return String.fromCharCode(Entities[m2]);
                            else return mt;
                        });
                    }
                    function parseColor(raw) {
                        var temp, result;
                        raw = (raw || "").trim();
                        if (temp = NamedColors[raw]) result = [
                            temp.slice(),
                            1
                        ];
                        else if (temp = raw.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) {
                            temp[1] = parseInt(temp[1]);
                            temp[2] = parseInt(temp[2]);
                            temp[3] = parseInt(temp[3]);
                            temp[4] = parseFloat(temp[4]);
                            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256 && temp[4] <= 1) result = [
                                temp.slice(1, 4),
                                temp[4]
                            ];
                        } else if (temp = raw.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) {
                            temp[1] = parseInt(temp[1]);
                            temp[2] = parseInt(temp[2]);
                            temp[3] = parseInt(temp[3]);
                            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) result = [
                                temp.slice(1, 4),
                                1
                            ];
                        } else if (temp = raw.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) {
                            temp[1] = 2.55 * parseFloat(temp[1]);
                            temp[2] = 2.55 * parseFloat(temp[2]);
                            temp[3] = 2.55 * parseFloat(temp[3]);
                            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) result = [
                                temp.slice(1, 4),
                                1
                            ];
                        } else if (temp = raw.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) result = [
                            [
                                parseInt(temp[1], 16),
                                parseInt(temp[2], 16),
                                parseInt(temp[3], 16)
                            ],
                            1
                        ];
                        else if (temp = raw.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) result = [
                            [
                                0x11 * parseInt(temp[1], 16),
                                0x11 * parseInt(temp[2], 16),
                                0x11 * parseInt(temp[3], 16)
                            ],
                            1
                        ];
                        return colorCallback ? colorCallback(result, raw) : result;
                    }
                    function opacityToColor(color, opacity, isMask) {
                        var newColor = color[0].slice(), newOpacity = color[1] * opacity;
                        if (isMask) {
                            for(var i = 0; i < color.length; i++)newColor[i] *= newOpacity;
                            return [
                                newColor,
                                1
                            ];
                        } else return [
                            newColor,
                            newOpacity
                        ];
                    }
                    function multiplyMatrix() {
                        function multiply(a, b) {
                            return [
                                a[0] * b[0] + a[2] * b[1],
                                a[1] * b[0] + a[3] * b[1],
                                a[0] * b[2] + a[2] * b[3],
                                a[1] * b[2] + a[3] * b[3],
                                a[0] * b[4] + a[2] * b[5] + a[4],
                                a[1] * b[4] + a[3] * b[5] + a[5]
                            ];
                        }
                        var result = arguments[0];
                        for(var i = 1; i < arguments.length; i++)result = multiply(result, arguments[i]);
                        return result;
                    }
                    function transformPoint(p, m) {
                        return [
                            m[0] * p[0] + m[2] * p[1] + m[4],
                            m[1] * p[0] + m[3] * p[1] + m[5]
                        ];
                    }
                    function getGlobalMatrix() {
                        var ctm = doc._ctm;
                        for(var i = groupStack.length - 1; i >= 0; i--)ctm = multiplyMatrix(groupStack[i].savedMatrix, ctm);
                        return ctm;
                    }
                    function getPageBBox() {
                        return new SvgShape().M(0, 0).L(doc.page.width, 0).L(doc.page.width, doc.page.height).L(0, doc.page.height).transform(inverseMatrix(getGlobalMatrix())).getBoundingBox();
                    }
                    function inverseMatrix(m) {
                        var dt = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / dt,
                            -m[1] / dt,
                            -m[2] / dt,
                            m[0] / dt,
                            (m[2] * m[5] - m[3] * m[4]) / dt,
                            (m[1] * m[4] - m[0] * m[5]) / dt
                        ];
                    }
                    function validateMatrix(m) {
                        var m0 = validateNumber(m[0]), m1 = validateNumber(m[1]), m2 = validateNumber(m[2]), m3 = validateNumber(m[3]), m4 = validateNumber(m[4]), m5 = validateNumber(m[5]);
                        if (isNotEqual(m0 * m3 - m1 * m2, 0)) return [
                            m0,
                            m1,
                            m2,
                            m3,
                            m4,
                            m5
                        ];
                    }
                    function solveEquation(curve) {
                        var a = curve[2] || 0, b = curve[1] || 0, c = curve[0] || 0;
                        if (isEqual(a, 0) && isEqual(b, 0)) return [];
                        else if (isEqual(a, 0)) return [
                            -c / b
                        ];
                        else {
                            var d = b * b - 4 * a * c;
                            if (isNotEqual(d, 0) && d > 0) return [
                                (-b + Math.sqrt(d)) / (2 * a),
                                (-b - Math.sqrt(d)) / (2 * a)
                            ];
                            else if (isEqual(d, 0)) return [
                                -b / (2 * a)
                            ];
                            else return [];
                        }
                    }
                    function getCurveValue(t, curve) {
                        return (curve[0] || 0) + (curve[1] || 0) * t + (curve[2] || 0) * t * t + (curve[3] || 0) * t * t * t;
                    }
                    function isEqual(number, ref) {
                        return Math.abs(number - ref) < 1e-10;
                    }
                    function isNotEqual(number, ref) {
                        return Math.abs(number - ref) >= 1e-10;
                    }
                    function validateNumber(n) {
                        return n > -1000000000000000000000 && n < 1e21 ? Math.round(n * 1e6) / 1e6 : 0;
                    }
                    function isArrayLike(v) {
                        return typeof v === "object" && v !== null && typeof v.length === "number";
                    }
                    function parseTranform(v) {
                        var parser = new StringParser((v || "").trim()), result = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ], temp;
                        while(temp = parser.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, true)){
                            var func = temp[1], nums = [], parser2 = new StringParser(temp[2].trim()), temp2 = void 0;
                            while(temp2 = parser2.matchNumber()){
                                nums.push(Number(temp2));
                                parser2.matchSeparator();
                            }
                            if (func === "matrix" && nums.length === 6) result = multiplyMatrix(result, [
                                nums[0],
                                nums[1],
                                nums[2],
                                nums[3],
                                nums[4],
                                nums[5]
                            ]);
                            else if (func === "translate" && nums.length === 2) result = multiplyMatrix(result, [
                                1,
                                0,
                                0,
                                1,
                                nums[0],
                                nums[1]
                            ]);
                            else if (func === "translate" && nums.length === 1) result = multiplyMatrix(result, [
                                1,
                                0,
                                0,
                                1,
                                nums[0],
                                0
                            ]);
                            else if (func === "scale" && nums.length === 2) result = multiplyMatrix(result, [
                                nums[0],
                                0,
                                0,
                                nums[1],
                                0,
                                0
                            ]);
                            else if (func === "scale" && nums.length === 1) result = multiplyMatrix(result, [
                                nums[0],
                                0,
                                0,
                                nums[0],
                                0,
                                0
                            ]);
                            else if (func === "rotate" && nums.length === 3) {
                                var a = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    nums[1],
                                    nums[2]
                                ], [
                                    Math.cos(a),
                                    Math.sin(a),
                                    -Math.sin(a),
                                    Math.cos(a),
                                    0,
                                    0
                                ], [
                                    1,
                                    0,
                                    0,
                                    1,
                                    -nums[1],
                                    -nums[2]
                                ]);
                            } else if (func === "rotate" && nums.length === 1) {
                                var _a = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    Math.cos(_a),
                                    Math.sin(_a),
                                    -Math.sin(_a),
                                    Math.cos(_a),
                                    0,
                                    0
                                ]);
                            } else if (func === "skewX" && nums.length === 1) {
                                var _a2 = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    1,
                                    0,
                                    Math.tan(_a2),
                                    1,
                                    0,
                                    0
                                ]);
                            } else if (func === "skewY" && nums.length === 1) {
                                var _a3 = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    1,
                                    Math.tan(_a3),
                                    0,
                                    1,
                                    0,
                                    0
                                ]);
                            } else return;
                            parser.matchSeparator();
                        }
                        if (parser.matchAll()) return;
                        return result;
                    }
                    function parseAspectRatio(aspectRatio, availWidth, availHeight, elemWidth, elemHeight, initAlign) {
                        var temp = (aspectRatio || "").trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [], ratioType = temp[1] || temp[4] || "meet", xAlign = temp[2] || "Mid", yAlign = temp[3] || "Mid", scaleX = availWidth / elemWidth, scaleY = availHeight / elemHeight, dx = {
                            "Min": 0,
                            "Mid": 0.5,
                            "Max": 1
                        }[xAlign] - (initAlign || 0), dy = {
                            "Min": 0,
                            "Mid": 0.5,
                            "Max": 1
                        }[yAlign] - (initAlign || 0);
                        if (ratioType === "slice") scaleY = scaleX = Math.max(scaleX, scaleY);
                        else if (ratioType === "meet") scaleY = scaleX = Math.min(scaleX, scaleY);
                        return [
                            scaleX,
                            0,
                            0,
                            scaleY,
                            dx * (availWidth - elemWidth * scaleX),
                            dy * (availHeight - elemHeight * scaleY)
                        ];
                    }
                    function parseStyleAttr(v) {
                        var result = Object.create(null);
                        v = (v || "").trim().split(/;/);
                        for(var i = 0; i < v.length; i++){
                            var key = (v[i].split(":")[0] || "").trim(), value = (v[i].split(":")[1] || "").trim();
                            if (key) result[key] = value;
                        }
                        if (result["marker"]) {
                            if (!result["marker-start"]) result["marker-start"] = result["marker"];
                            if (!result["marker-mid"]) result["marker-mid"] = result["marker"];
                            if (!result["marker-end"]) result["marker-end"] = result["marker"];
                        }
                        if (result["font"]) {
                            var fontFamily = null, fontSize = null, fontStyle = "normal", fontWeight = "normal", fontVariant = "normal";
                            var parts = result["font"].split(/\s+/);
                            for(var _i = 0; _i < parts.length; _i++)switch(parts[_i]){
                                case "normal":
                                    break;
                                case "italic":
                                case "oblique":
                                    fontStyle = parts[_i];
                                    break;
                                case "small-caps":
                                    fontVariant = parts[_i];
                                    break;
                                case "bold":
                                case "bolder":
                                case "lighter":
                                case "100":
                                case "200":
                                case "300":
                                case "400":
                                case "500":
                                case "600":
                                case "700":
                                case "800":
                                case "900":
                                    fontWeight = parts[_i];
                                    break;
                                default:
                                    if (!fontSize) fontSize = parts[_i].split("/")[0];
                                    else if (!fontFamily) fontFamily = parts[_i];
                                    else fontFamily += " " + parts[_i];
                                    break;
                            }
                            if (!result["font-style"]) result["font-style"] = fontStyle;
                            if (!result["font-variant"]) result["font-variant"] = fontVariant;
                            if (!result["font-weight"]) result["font-weight"] = fontWeight;
                            if (!result["font-size"]) result["font-size"] = fontSize;
                            if (!result["font-family"]) result["font-family"] = fontFamily;
                        }
                        return result;
                    }
                    function parseSelector(v) {
                        var parts = v.split(/(?=[.#])/g), ids = [], classes = [], tags = [], temp;
                        for(var i = 0; i < parts.length; i++){
                            if (temp = parts[i].match(/^[#]([_A-Za-z0-9-]+)$/)) ids.push(temp[1]);
                            else if (temp = parts[i].match(/^[.]([_A-Za-z0-9-]+)$/)) classes.push(temp[1]);
                            else if (temp = parts[i].match(/^([_A-Za-z0-9-]+)$/)) tags.push(temp[1]);
                            else if (parts[i] !== "*") return;
                        }
                        return {
                            tags: tags,
                            ids: ids,
                            classes: classes,
                            specificity: ids.length * 10000 + classes.length * 100 + tags.length
                        };
                    }
                    function parseStyleSheet(v) {
                        var parser = new StringParser(v.trim()), rules = [], rule;
                        while(rule = parser.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, true)){
                            var selectors = rule[1].split(/\s*,\s*/g), css = parseStyleAttr(rule[2]);
                            for(var i = 0; i < selectors.length; i++){
                                var selector = parseSelector(selectors[i]);
                                if (selector) rules.push({
                                    selector: selector,
                                    css: css
                                });
                            }
                        }
                        return rules;
                    }
                    function matchesSelector(elem, selector) {
                        if (elem.nodeType !== 1) return false;
                        for(var i = 0; i < selector.tags.length; i++){
                            if (selector.tags[i] !== elem.nodeName) return false;
                        }
                        for(var _i2 = 0; _i2 < selector.ids.length; _i2++){
                            if (selector.ids[_i2] !== elem.id) return false;
                        }
                        for(var _i3 = 0; _i3 < selector.classes.length; _i3++){
                            if (elem.classList.indexOf(selector.classes[_i3]) === -1) return false;
                        }
                        return true;
                    }
                    function getStyle(elem) {
                        var result = Object.create(null);
                        var specificities = Object.create(null);
                        for(var i = 0; i < styleRules.length; i++){
                            var rule = styleRules[i];
                            if (matchesSelector(elem, rule.selector)) {
                                for(var key in rule.css)if (!(specificities[key] > rule.selector.specificity)) {
                                    result[key] = rule.css[key];
                                    specificities[key] = rule.selector.specificity;
                                }
                            }
                        }
                        return result;
                    }
                    function combineArrays(array1, array2) {
                        return array1.concat(array2.slice(array1.length));
                    }
                    function getAscent(font, size) {
                        return Math.max(font.ascender, (font.bbox[3] || font.bbox.maxY) * (font.scale || 1)) * size / 1000;
                    }
                    function getDescent(font, size) {
                        return Math.min(font.descender, (font.bbox[1] || font.bbox.minY) * (font.scale || 1)) * size / 1000;
                    }
                    function getXHeight(font, size) {
                        return (font.xHeight || 0.5 * (font.ascender - font.descender)) * size / 1000;
                    }
                    function getBaseline(font, size, baseline, shift) {
                        var dy1, dy2;
                        switch(baseline){
                            case "middle":
                                dy1 = 0.5 * getXHeight(font, size);
                                break;
                            case "central":
                                dy1 = 0.5 * (getDescent(font, size) + getAscent(font, size));
                                break;
                            case "after-edge":
                            case "text-after-edge":
                                dy1 = getDescent(font, size);
                                break;
                            case "alphabetic":
                            case "auto":
                            case "baseline":
                                dy1 = 0;
                                break;
                            case "mathematical":
                                dy1 = 0.5 * getAscent(font, size);
                                break;
                            case "hanging":
                                dy1 = 0.8 * getAscent(font, size);
                                break;
                            case "before-edge":
                            case "text-before-edge":
                                dy1 = getAscent(font, size);
                                break;
                            default:
                                dy1 = 0;
                                break;
                        }
                        switch(shift){
                            case "baseline":
                                dy2 = 0;
                                break;
                            case "super":
                                dy2 = 0.6 * size;
                                break;
                            case "sub":
                                dy2 = -0.6 * size;
                                break;
                            default:
                                dy2 = shift;
                                break;
                        }
                        return dy1 - dy2;
                    }
                    function getTextPos(font, size, text) {
                        var encoded = font.encode("" + text), hex = encoded[0], pos = encoded[1], data = [];
                        for(var i = 0; i < hex.length; i++){
                            var unicode = font.unicode ? font.unicode[parseInt(hex[i], 16)] : [
                                text.charCodeAt(i)
                            ];
                            data.push({
                                glyph: hex[i],
                                unicode: unicode,
                                width: pos[i].advanceWidth * size / 1000,
                                xOffset: pos[i].xOffset * size / 1000,
                                yOffset: pos[i].yOffset * size / 1000,
                                xAdvance: pos[i].xAdvance * size / 1000,
                                yAdvance: pos[i].yAdvance * size / 1000
                            });
                        }
                        return data;
                    }
                    function createSVGElement(obj, inherits) {
                        switch(obj.nodeName){
                            case "use":
                                return new SvgElemUse(obj, inherits);
                            case "symbol":
                                return new SvgElemSymbol(obj, inherits);
                            case "g":
                                return new SvgElemGroup(obj, inherits);
                            case "a":
                                return new SvgElemLink(obj, inherits);
                            case "svg":
                                return new SvgElemSvg(obj, inherits);
                            case "image":
                                return new SVGElemImage(obj, inherits);
                            case "rect":
                                return new SvgElemRect(obj, inherits);
                            case "circle":
                                return new SvgElemCircle(obj, inherits);
                            case "ellipse":
                                return new SvgElemEllipse(obj, inherits);
                            case "line":
                                return new SvgElemLine(obj, inherits);
                            case "polyline":
                                return new SvgElemPolyline(obj, inherits);
                            case "polygon":
                                return new SvgElemPolygon(obj, inherits);
                            case "path":
                                return new SvgElemPath(obj, inherits);
                            case "text":
                                return new SvgElemText(obj, inherits);
                            case "tspan":
                                return new SvgElemTspan(obj, inherits);
                            case "textPath":
                                return new SvgElemTextPath(obj, inherits);
                            case "#text":
                            case "#cdata-section":
                                return new SvgElemTextNode(obj, inherits);
                            default:
                                return new SvgElem(obj, inherits);
                        }
                    }
                    var StringParser = function StringParser(str) {
                        this.match = function(exp, all) {
                            var temp = str.match(exp);
                            if (!temp || temp.index !== 0) return;
                            str = str.substring(temp[0].length);
                            return all ? temp : temp[0];
                        };
                        this.matchSeparator = function() {
                            return this.match(/^(?:\s*,\s*|\s*|)/);
                        };
                        this.matchSpace = function() {
                            return this.match(/^(?:\s*)/);
                        };
                        this.matchLengthUnit = function() {
                            return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
                        };
                        this.matchNumber = function() {
                            return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
                        };
                        this.matchAll = function() {
                            return this.match(/^[\s\S]+/);
                        };
                    };
                    var BezierSegment = function BezierSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
                        var divisions = 6 * precision;
                        var equationX = [
                            p1x,
                            -3 * p1x + 3 * c1x,
                            3 * p1x - 6 * c1x + 3 * c2x,
                            -p1x + 3 * c1x - 3 * c2x + p2x
                        ];
                        var equationY = [
                            p1y,
                            -3 * p1y + 3 * c1y,
                            3 * p1y - 6 * c1y + 3 * c2y,
                            -p1y + 3 * c1y - 3 * c2y + p2y
                        ];
                        var derivativeX = [
                            -3 * p1x + 3 * c1x,
                            6 * p1x - 12 * c1x + 6 * c2x,
                            -3 * p1x + 9 * c1x - 9 * c2x + 3 * p2x
                        ];
                        var derivativeY = [
                            -3 * p1y + 3 * c1y,
                            6 * p1y - 12 * c1y + 6 * c2y,
                            -3 * p1y + 9 * c1y - 9 * c2y + 3 * p2y
                        ];
                        var lengthMap = [
                            0
                        ];
                        for(var i = 1; i <= divisions; i++){
                            var t = (i - 0.5) / divisions;
                            var dx = getCurveValue(t, derivativeX) / divisions, dy = getCurveValue(t, derivativeY) / divisions, l = Math.sqrt(dx * dx + dy * dy);
                            lengthMap[i] = lengthMap[i - 1] + l;
                        }
                        this.totalLength = lengthMap[divisions];
                        this.startPoint = [
                            p1x,
                            p1y,
                            isEqual(p1x, c1x) && isEqual(p1y, c1y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(c1y - p1y, c1x - p1x)
                        ];
                        this.endPoint = [
                            p2x,
                            p2y,
                            isEqual(c2x, p2x) && isEqual(c2y, p2y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(p2y - c2y, p2x - c2x)
                        ];
                        this.getBoundingBox = function() {
                            var temp;
                            var minX = getCurveValue(0, equationX), minY = getCurveValue(0, equationY), maxX = getCurveValue(1, equationX), maxY = getCurveValue(1, equationY);
                            if (minX > maxX) {
                                temp = maxX;
                                maxX = minX;
                                minX = temp;
                            }
                            if (minY > maxY) {
                                temp = maxY;
                                maxY = minY;
                                minY = temp;
                            }
                            var rootsX = solveEquation(derivativeX);
                            for(var _i4 = 0; _i4 < rootsX.length; _i4++)if (rootsX[_i4] >= 0 && rootsX[_i4] <= 1) {
                                var _x = getCurveValue(rootsX[_i4], equationX);
                                if (_x < minX) minX = _x;
                                if (_x > maxX) maxX = _x;
                            }
                            var rootsY = solveEquation(derivativeY);
                            for(var _i5 = 0; _i5 < rootsY.length; _i5++)if (rootsY[_i5] >= 0 && rootsY[_i5] <= 1) {
                                var _y = getCurveValue(rootsY[_i5], equationY);
                                if (_y < minY) minY = _y;
                                if (_y > maxY) maxY = _y;
                            }
                            return [
                                minX,
                                minY,
                                maxX,
                                maxY
                            ];
                        };
                        this.getPointAtLength = function(l) {
                            if (isEqual(l, 0)) return this.startPoint;
                            if (isEqual(l, this.totalLength)) return this.endPoint;
                            if (l < 0 || l > this.totalLength) return;
                            for(var _i6 = 1; _i6 <= divisions; _i6++){
                                var l1 = lengthMap[_i6 - 1], l2 = lengthMap[_i6];
                                if (l1 <= l && l <= l2) {
                                    var _t = (_i6 - (l2 - l) / (l2 - l1)) / divisions, _x2 = getCurveValue(_t, equationX), _y2 = getCurveValue(_t, equationY), _dx = getCurveValue(_t, derivativeX), _dy = getCurveValue(_t, derivativeY);
                                    return [
                                        _x2,
                                        _y2,
                                        Math.atan2(_dy, _dx)
                                    ];
                                }
                            }
                        };
                    };
                    var LineSegment = function LineSegment(p1x, p1y, p2x, p2y) {
                        this.totalLength = Math.sqrt((p2x - p1x) * (p2x - p1x) + (p2y - p1y) * (p2y - p1y));
                        this.startPoint = [
                            p1x,
                            p1y,
                            Math.atan2(p2y - p1y, p2x - p1x)
                        ];
                        this.endPoint = [
                            p2x,
                            p2y,
                            Math.atan2(p2y - p1y, p2x - p1x)
                        ];
                        this.getBoundingBox = function() {
                            return [
                                Math.min(this.startPoint[0], this.endPoint[0]),
                                Math.min(this.startPoint[1], this.endPoint[1]),
                                Math.max(this.startPoint[0], this.endPoint[0]),
                                Math.max(this.startPoint[1], this.endPoint[1])
                            ];
                        };
                        this.getPointAtLength = function(l) {
                            if (l >= 0 && l <= this.totalLength) {
                                var r = l / this.totalLength || 0, _x3 = this.startPoint[0] + r * (this.endPoint[0] - this.startPoint[0]), _y3 = this.startPoint[1] + r * (this.endPoint[1] - this.startPoint[1]);
                                return [
                                    _x3,
                                    _y3,
                                    this.startPoint[2]
                                ];
                            }
                        };
                    };
                    var SvgShape = function SvgShape() {
                        this.pathCommands = [];
                        this.pathSegments = [];
                        this.startPoint = null;
                        this.endPoint = null;
                        this.totalLength = 0;
                        var startX = 0, startY = 0, currX = 0, currY = 0, lastCom, lastCtrlX, lastCtrlY;
                        this.move = function(x, y) {
                            startX = currX = x;
                            startY = currY = y;
                            return null;
                        };
                        this.line = function(x, y) {
                            var segment = new LineSegment(currX, currY, x, y);
                            currX = x;
                            currY = y;
                            return segment;
                        };
                        this.curve = function(c1x, c1y, c2x, c2y, x, y) {
                            var segment = new BezierSegment(currX, currY, c1x, c1y, c2x, c2y, x, y);
                            currX = x;
                            currY = y;
                            return segment;
                        };
                        this.close = function() {
                            var segment = new LineSegment(currX, currY, startX, startY);
                            currX = startX;
                            currY = startY;
                            return segment;
                        };
                        this.addCommand = function(data) {
                            this.pathCommands.push(data);
                            var segment = this[data[0]].apply(this, data.slice(3));
                            if (segment) {
                                segment.hasStart = data[1];
                                segment.hasEnd = data[2];
                                this.startPoint = this.startPoint || segment.startPoint;
                                this.endPoint = segment.endPoint;
                                this.pathSegments.push(segment);
                                this.totalLength += segment.totalLength;
                            }
                        };
                        this.M = function(x, y) {
                            this.addCommand([
                                "move",
                                true,
                                true,
                                x,
                                y
                            ]);
                            lastCom = "M";
                            return this;
                        };
                        this.m = function(x, y) {
                            return this.M(currX + x, currY + y);
                        };
                        this.Z = this.z = function() {
                            this.addCommand([
                                "close",
                                true,
                                true
                            ]);
                            lastCom = "Z";
                            return this;
                        };
                        this.L = function(x, y) {
                            this.addCommand([
                                "line",
                                true,
                                true,
                                x,
                                y
                            ]);
                            lastCom = "L";
                            return this;
                        };
                        this.l = function(x, y) {
                            return this.L(currX + x, currY + y);
                        };
                        this.H = function(x) {
                            return this.L(x, currY);
                        };
                        this.h = function(x) {
                            return this.L(currX + x, currY);
                        };
                        this.V = function(y) {
                            return this.L(currX, y);
                        };
                        this.v = function(y) {
                            return this.L(currX, currY + y);
                        };
                        this.C = function(c1x, c1y, c2x, c2y, x, y) {
                            this.addCommand([
                                "curve",
                                true,
                                true,
                                c1x,
                                c1y,
                                c2x,
                                c2y,
                                x,
                                y
                            ]);
                            lastCom = "C";
                            lastCtrlX = c2x;
                            lastCtrlY = c2y;
                            return this;
                        };
                        this.c = function(c1x, c1y, c2x, c2y, x, y) {
                            return this.C(currX + c1x, currY + c1y, currX + c2x, currY + c2y, currX + x, currY + y);
                        };
                        this.S = function(c1x, c1y, x, y) {
                            return this.C(currX + (lastCom === "C" ? currX - lastCtrlX : 0), currY + (lastCom === "C" ? currY - lastCtrlY : 0), c1x, c1y, x, y);
                        };
                        this.s = function(c1x, c1y, x, y) {
                            return this.C(currX + (lastCom === "C" ? currX - lastCtrlX : 0), currY + (lastCom === "C" ? currY - lastCtrlY : 0), currX + c1x, currY + c1y, currX + x, currY + y);
                        };
                        this.Q = function(cx, cy, x, y) {
                            var c1x = currX + 2 / 3 * (cx - currX), c1y = currY + 2 / 3 * (cy - currY), c2x = x + 2 / 3 * (cx - x), c2y = y + 2 / 3 * (cy - y);
                            this.addCommand([
                                "curve",
                                true,
                                true,
                                c1x,
                                c1y,
                                c2x,
                                c2y,
                                x,
                                y
                            ]);
                            lastCom = "Q";
                            lastCtrlX = cx;
                            lastCtrlY = cy;
                            return this;
                        };
                        this.q = function(c1x, c1y, x, y) {
                            return this.Q(currX + c1x, currY + c1y, currX + x, currY + y);
                        };
                        this.T = function(x, y) {
                            return this.Q(currX + (lastCom === "Q" ? currX - lastCtrlX : 0), currY + (lastCom === "Q" ? currY - lastCtrlY : 0), x, y);
                        };
                        this.t = function(x, y) {
                            return this.Q(currX + (lastCom === "Q" ? currX - lastCtrlX : 0), currY + (lastCom === "Q" ? currY - lastCtrlY : 0), currX + x, currY + y);
                        };
                        this.A = function(rx, ry, fi, fa, fs, x, y) {
                            if (isEqual(rx, 0) || isEqual(ry, 0)) this.addCommand([
                                "line",
                                true,
                                true,
                                x,
                                y
                            ]);
                            else {
                                fi = fi * (Math.PI / 180);
                                rx = Math.abs(rx);
                                ry = Math.abs(ry);
                                fa = 1 * !!fa;
                                fs = 1 * !!fs;
                                var x1 = Math.cos(fi) * (currX - x) / 2 + Math.sin(fi) * (currY - y) / 2, y1 = Math.cos(fi) * (currY - y) / 2 - Math.sin(fi) * (currX - x) / 2, lambda = x1 * x1 / (rx * rx) + y1 * y1 / (ry * ry);
                                if (lambda > 1) {
                                    rx *= Math.sqrt(lambda);
                                    ry *= Math.sqrt(lambda);
                                }
                                var r = Math.sqrt(Math.max(0, rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1)), x2 = (fa === fs ? -1 : 1) * r * rx * y1 / ry, y2 = (fa === fs ? 1 : -1) * r * ry * x1 / rx;
                                var cx = Math.cos(fi) * x2 - Math.sin(fi) * y2 + (currX + x) / 2, cy = Math.sin(fi) * x2 + Math.cos(fi) * y2 + (currY + y) / 2, th1 = Math.atan2((y1 - y2) / ry, (x1 - x2) / rx), th2 = Math.atan2((-y1 - y2) / ry, (-x1 - x2) / rx);
                                if (fs === 0 && th2 - th1 > 0) th2 -= 2 * Math.PI;
                                else if (fs === 1 && th2 - th1 < 0) th2 += 2 * Math.PI;
                                var segms = Math.ceil(Math.abs(th2 - th1) / (Math.PI / precision));
                                for(var i = 0; i < segms; i++){
                                    var th3 = th1 + i * (th2 - th1) / segms, th4 = th1 + (i + 1) * (th2 - th1) / segms, t = 4 / 3 * Math.tan((th4 - th3) / 4);
                                    var c1x = cx + Math.cos(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) - Math.sin(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)), c1y = cy + Math.sin(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) + Math.cos(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)), c2x = cx + Math.cos(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) - Math.sin(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)), c2y = cy + Math.sin(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) + Math.cos(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)), endX = cx + Math.cos(fi) * rx * Math.cos(th4) - Math.sin(fi) * ry * Math.sin(th4), endY = cy + Math.sin(fi) * rx * Math.cos(th4) + Math.cos(fi) * ry * Math.sin(th4);
                                    this.addCommand([
                                        "curve",
                                        i === 0,
                                        i === segms - 1,
                                        c1x,
                                        c1y,
                                        c2x,
                                        c2y,
                                        endX,
                                        endY
                                    ]);
                                }
                            }
                            lastCom = "A";
                            return this;
                        };
                        this.a = function(rx, ry, fi, fa, fs, x, y) {
                            return this.A(rx, ry, fi, fa, fs, currX + x, currY + y);
                        };
                        this.path = function(d) {
                            var command, value, temp, parser = new StringParser((d || "").trim());
                            while(command = parser.match(/^[astvzqmhlcASTVZQMHLC]/)){
                                parser.matchSeparator();
                                var values = [];
                                while(value = PathFlags[command + values.length] ? parser.match(/^[01]/) : parser.matchNumber()){
                                    parser.matchSeparator();
                                    if (values.length === PathArguments[command]) {
                                        this[command].apply(this, values);
                                        values = [];
                                        if (command === "M") command = "L";
                                        else if (command === "m") command = "l";
                                    }
                                    values.push(Number(value));
                                }
                                if (values.length === PathArguments[command]) this[command].apply(this, values);
                                else {
                                    warningCallback("SvgPath: command " + command + " with " + values.length + " numbers");
                                    return;
                                }
                            }
                            if (temp = parser.matchAll()) warningCallback("SvgPath: unexpected string " + temp);
                            return this;
                        };
                        this.getBoundingBox = function() {
                            var bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            function addBounds(bbox1) {
                                if (bbox1[0] < bbox[0]) bbox[0] = bbox1[0];
                                if (bbox1[2] > bbox[2]) bbox[2] = bbox1[2];
                                if (bbox1[1] < bbox[1]) bbox[1] = bbox1[1];
                                if (bbox1[3] > bbox[3]) bbox[3] = bbox1[3];
                            }
                            for(var i = 0; i < this.pathSegments.length; i++)addBounds(this.pathSegments[i].getBoundingBox());
                            if (bbox[0] === Infinity) bbox[0] = 0;
                            if (bbox[1] === Infinity) bbox[1] = 0;
                            if (bbox[2] === -Infinity) bbox[2] = 0;
                            if (bbox[3] === -Infinity) bbox[3] = 0;
                            return bbox;
                        };
                        this.getPointAtLength = function(l) {
                            if (l >= 0 && l <= this.totalLength) {
                                var temp;
                                for(var i = 0; i < this.pathSegments.length; i++){
                                    if (temp = this.pathSegments[i].getPointAtLength(l)) return temp;
                                    l -= this.pathSegments[i].totalLength;
                                }
                                return this.endPoint;
                            }
                        };
                        this.transform = function(m) {
                            this.pathSegments = [];
                            this.startPoint = null;
                            this.endPoint = null;
                            this.totalLength = 0;
                            for(var i = 0; i < this.pathCommands.length; i++){
                                var data = this.pathCommands.shift();
                                for(var j = 3; j < data.length; j += 2){
                                    var p = transformPoint([
                                        data[j],
                                        data[j + 1]
                                    ], m);
                                    data[j] = p[0];
                                    data[j + 1] = p[1];
                                }
                                this.addCommand(data);
                            }
                            return this;
                        };
                        this.mergeShape = function(shape) {
                            for(var i = 0; i < shape.pathCommands.length; i++)this.addCommand(shape.pathCommands[i].slice());
                            return this;
                        };
                        this.clone = function() {
                            return new SvgShape().mergeShape(this);
                        };
                        this.insertInDocument = function() {
                            for(var i = 0; i < this.pathCommands.length; i++){
                                var command = this.pathCommands[i][0], values = this.pathCommands[i].slice(3);
                                switch(command){
                                    case "move":
                                        doc.moveTo(values[0], values[1]);
                                        break;
                                    case "line":
                                        doc.lineTo(values[0], values[1]);
                                        break;
                                    case "curve":
                                        doc.bezierCurveTo(values[0], values[1], values[2], values[3], values[4], values[5]);
                                        break;
                                    case "close":
                                        doc.closePath();
                                        break;
                                }
                            }
                        };
                        this.getSubPaths = function() {
                            var subPaths = [], shape = new SvgShape();
                            for(var i = 0; i < this.pathCommands.length; i++){
                                var data = this.pathCommands[i], command = this.pathCommands[i][0];
                                if (command === "move" && i !== 0) {
                                    subPaths.push(shape);
                                    shape = new SvgShape();
                                }
                                shape.addCommand(data);
                            }
                            subPaths.push(shape);
                            return subPaths;
                        };
                        this.getMarkers = function() {
                            var markers = [], subPaths = this.getSubPaths();
                            for(var i = 0; i < subPaths.length; i++){
                                var subPath = subPaths[i], subPathMarkers = [];
                                for(var j = 0; j < subPath.pathSegments.length; j++){
                                    var segment = subPath.pathSegments[j];
                                    if (isNotEqual(segment.totalLength, 0) || j === 0 || j === subPath.pathSegments.length - 1) {
                                        if (segment.hasStart) {
                                            var startMarker = segment.getPointAtLength(0), prevEndMarker = subPathMarkers.pop();
                                            if (prevEndMarker) startMarker[2] = 0.5 * (prevEndMarker[2] + startMarker[2]);
                                            subPathMarkers.push(startMarker);
                                        }
                                        if (segment.hasEnd) {
                                            var endMarker = segment.getPointAtLength(segment.totalLength);
                                            subPathMarkers.push(endMarker);
                                        }
                                    }
                                }
                                markers = markers.concat(subPathMarkers);
                            }
                            return markers;
                        };
                    };
                    var SvgElem = function SvgElem(obj, inherits) {
                        var styleCache = Object.create(null);
                        var childrenCache = null;
                        this.name = obj.nodeName;
                        this.isOuterElement = obj === svg || !obj.parentNode;
                        this.inherits = inherits || (!this.isOuterElement ? createSVGElement(obj.parentNode, null) : null);
                        this.stack = this.inherits ? this.inherits.stack.concat(obj) : [
                            obj
                        ];
                        this.style = parseStyleAttr(typeof obj.getAttribute === "function" && obj.getAttribute("style"));
                        this.css = useCSS ? getComputedStyle(obj) : getStyle(obj);
                        this.allowedChildren = [];
                        this.attr = function(key) {
                            if (typeof obj.getAttribute === "function") return obj.getAttribute(key);
                        };
                        this.resolveUrl = function(value) {
                            var temp = (value || "").match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [];
                            var file = temp[1] || temp[3] || temp[5] || temp[7], id = temp[2] || temp[4] || temp[6] || temp[8];
                            if (id) {
                                if (!file) {
                                    var svgObj = svg.getElementById(id);
                                    if (svgObj) {
                                        if (this.stack.indexOf(svgObj) === -1) return svgObj;
                                        else {
                                            warningCallback('SVGtoPDF: loop of circular references for id "' + id + '"');
                                            return;
                                        }
                                    }
                                }
                                if (documentCallback) {
                                    var svgs = documentCache[file];
                                    if (!svgs) {
                                        svgs = documentCallback(file);
                                        if (!isArrayLike(svgs)) svgs = [
                                            svgs
                                        ];
                                        for(var i = 0; i < svgs.length; i++)if (typeof svgs[i] === "string") svgs[i] = parseXml(svgs[i]);
                                        documentCache[file] = svgs;
                                    }
                                    for(var _i7 = 0; _i7 < svgs.length; _i7++){
                                        var _svgObj = svgs[_i7].getElementById(id);
                                        if (_svgObj) {
                                            if (this.stack.indexOf(_svgObj) === -1) return _svgObj;
                                            else {
                                                warningCallback('SVGtoPDF: loop of circular references for id "' + file + "#" + id + '"');
                                                return;
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        this.computeUnits = function(value, unit, percent, isFontSize) {
                            if (unit === "%") return parseFloat(value) / 100 * (isFontSize || percent != null ? percent : this.getViewport());
                            else if (unit === "ex" || unit === "em") return value * ({
                                "em": 1,
                                "ex": 0.5
                            })[unit] * (isFontSize ? percent : this.get("font-size"));
                            else return value * ({
                                "": 1,
                                "px": 1,
                                "pt": 96 / 72,
                                "cm": 96 / 2.54,
                                "mm": 96 / 25.4,
                                "in": 96,
                                "pc": 16
                            })[unit];
                        };
                        this.computeLength = function(value, percent, initial, isFontSize) {
                            var parser = new StringParser((value || "").trim()), temp1, temp2;
                            if (typeof (temp1 = parser.matchNumber()) === "string" && typeof (temp2 = parser.matchLengthUnit()) === "string" && !parser.matchAll()) return this.computeUnits(temp1, temp2, percent, isFontSize);
                            return initial;
                        };
                        this.computeLengthList = function(value, percent, strict) {
                            var parser = new StringParser((value || "").trim()), result = [], temp1, temp2;
                            while(typeof (temp1 = parser.matchNumber()) === "string" && typeof (temp2 = parser.matchLengthUnit()) === "string"){
                                result.push(this.computeUnits(temp1, temp2, percent));
                                parser.matchSeparator();
                            }
                            if (strict && parser.matchAll()) return;
                            return result;
                        };
                        this.getLength = function(key, percent, initial) {
                            return this.computeLength(this.attr(key), percent, initial);
                        };
                        this.getLengthList = function(key, percent) {
                            return this.computeLengthList(this.attr(key), percent);
                        };
                        this.getUrl = function(key) {
                            return this.resolveUrl(this.attr(key));
                        };
                        this.getNumberList = function(key) {
                            var parser = new StringParser((this.attr(key) || "").trim()), result = [], temp;
                            while(temp = parser.matchNumber()){
                                result.push(Number(temp));
                                parser.matchSeparator();
                            }
                            result.error = parser.matchAll();
                            return result;
                        };
                        this.getViewbox = function(key, initial) {
                            var viewBox = this.getNumberList(key);
                            if (viewBox.length === 4 && viewBox[2] >= 0 && viewBox[3] >= 0) return viewBox;
                            return initial;
                        };
                        this.getPercent = function(key, initial) {
                            var value = this.attr(key);
                            var parser = new StringParser((value || "").trim()), temp1, temp2;
                            var number = parser.matchNumber();
                            if (!number) return initial;
                            if (parser.match("%")) number *= 0.01;
                            if (parser.matchAll()) return initial;
                            return Math.max(0, Math.min(1, number));
                        };
                        this.chooseValue = function(args) {
                            for(var i = 0; i < arguments.length; i++){
                                if (arguments[i] != null && arguments[i] === arguments[i]) return arguments[i];
                            }
                            return arguments[arguments.length - 1];
                        };
                        this.get = function(key) {
                            if (styleCache[key] !== undefined) return styleCache[key];
                            var keyInfo = Properties[key] || {}, value, result;
                            for(var i = 0; i < 3; i++){
                                switch(i){
                                    case 0:
                                        if (key !== "transform") // the CSS transform behaves strangely
                                        value = this.css[keyInfo.css || key];
                                        break;
                                    case 1:
                                        value = this.style[key];
                                        break;
                                    case 2:
                                        value = this.attr(key);
                                        break;
                                }
                                if (value === "inherit") {
                                    result = this.inherits ? this.inherits.get(key) : keyInfo.initial;
                                    if (result != null) return styleCache[key] = result;
                                }
                                if (keyInfo.values != null) {
                                    result = keyInfo.values[value];
                                    if (result != null) return styleCache[key] = result;
                                }
                                if (value != null) {
                                    var parsed = void 0;
                                    switch(key){
                                        case "font-size":
                                            result = this.computeLength(value, this.inherits ? this.inherits.get(key) : keyInfo.initial, undefined, true);
                                            break;
                                        case "baseline-shift":
                                            result = this.computeLength(value, this.get("font-size"));
                                            break;
                                        case "font-family":
                                            result = value || undefined;
                                            break;
                                        case "opacity":
                                        case "stroke-opacity":
                                        case "fill-opacity":
                                        case "stop-opacity":
                                            parsed = parseFloat(value);
                                            if (!isNaN(parsed)) result = Math.max(0, Math.min(1, parsed));
                                            break;
                                        case "transform":
                                            result = parseTranform(value);
                                            break;
                                        case "stroke-dasharray":
                                            if (value === "none") result = [];
                                            else if (parsed = this.computeLengthList(value, this.getViewport(), true)) {
                                                var sum = 0, error = false;
                                                for(var j = 0; j < parsed.length; j++){
                                                    if (parsed[j] < 0) error = true;
                                                    sum += parsed[j];
                                                }
                                                if (!error) {
                                                    if (parsed.length % 2 === 1) parsed = parsed.concat(parsed);
                                                    result = sum === 0 ? [] : parsed;
                                                }
                                            }
                                            break;
                                        case "color":
                                            if (value === "none" || value === "transparent") result = "none";
                                            else result = parseColor(value);
                                            break;
                                        case "fill":
                                        case "stroke":
                                            if (value === "none" || value === "transparent") result = "none";
                                            else if (value === "currentColor") result = this.get("color");
                                            else if (parsed = parseColor(value)) return parsed;
                                            else if (parsed = (value || "").split(" ")) {
                                                var object = this.resolveUrl(parsed[0]), fallbackColor = parseColor(parsed[1]);
                                                if (object == null) result = fallbackColor;
                                                else if (object.nodeName === "linearGradient" || object.nodeName === "radialGradient") result = new SvgElemGradient(object, null, fallbackColor);
                                                else if (object.nodeName === "pattern") result = new SvgElemPattern(object, null, fallbackColor);
                                                else result = fallbackColor;
                                            }
                                            break;
                                        case "stop-color":
                                            if (value === "none" || value === "transparent") result = "none";
                                            else if (value === "currentColor") result = this.get("color");
                                            else result = parseColor(value);
                                            break;
                                        case "marker-start":
                                        case "marker-mid":
                                        case "marker-end":
                                        case "clip-path":
                                        case "mask":
                                            if (value === "none") result = "none";
                                            else result = this.resolveUrl(value);
                                            break;
                                        case "stroke-width":
                                            parsed = this.computeLength(value, this.getViewport());
                                            if (parsed != null && parsed >= 0) result = parsed;
                                            break;
                                        case "stroke-miterlimit":
                                            parsed = parseFloat(value);
                                            if (parsed != null && parsed >= 1) result = parsed;
                                            break;
                                        case "word-spacing":
                                        case "letter-spacing":
                                            result = this.computeLength(value, this.getViewport());
                                            break;
                                        case "stroke-dashoffset":
                                            result = this.computeLength(value, this.getViewport());
                                            if (result != null) {
                                                if (result < 0) {
                                                    // fix for crbug.com/660850
                                                    var dasharray = this.get("stroke-dasharray");
                                                    for(var _j = 0; _j < dasharray.length; _j++)result += dasharray[_j];
                                                }
                                            }
                                            break;
                                    }
                                    if (result != null) return styleCache[key] = result;
                                }
                            }
                            return styleCache[key] = keyInfo.inherit && this.inherits ? this.inherits.get(key) : keyInfo.initial;
                        };
                        this.getChildren = function() {
                            if (childrenCache != null) return childrenCache;
                            var children = [];
                            for(var i = 0; i < obj.childNodes.length; i++){
                                var child = obj.childNodes[i];
                                if (!child.error && this.allowedChildren.indexOf(child.nodeName) !== -1) children.push(createSVGElement(child, this));
                            }
                            return childrenCache = children;
                        };
                        this.getParentVWidth = function() {
                            return this.inherits ? this.inherits.getVWidth() : viewportWidth;
                        };
                        this.getParentVHeight = function() {
                            return this.inherits ? this.inherits.getVHeight() : viewportHeight;
                        };
                        this.getParentViewport = function() {
                            return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
                        };
                        this.getVWidth = function() {
                            return this.getParentVWidth();
                        };
                        this.getVHeight = function() {
                            return this.getParentVHeight();
                        };
                        this.getViewport = function() {
                            return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
                        };
                        this.getBoundingBox = function() {
                            var shape = this.getBoundingShape();
                            return shape.getBoundingBox();
                        };
                    };
                    var SvgElemStylable = function SvgElemStylable(obj, inherits) {
                        SvgElem.call(this, obj, inherits);
                        this.transform = function() {
                            doc.transform.apply(doc, this.getTransformation());
                        };
                        this.clip = function() {
                            if (this.get("clip-path") !== "none") {
                                var clipPath = new SvgElemClipPath(this.get("clip-path"), null);
                                clipPath.useMask(this.getBoundingBox());
                                return true;
                            }
                        };
                        this.mask = function() {
                            if (this.get("mask") !== "none") {
                                var mask = new SvgElemMask(this.get("mask"), null);
                                mask.useMask(this.getBoundingBox());
                                return true;
                            }
                        };
                        this.getFill = function(isClip, isMask) {
                            var opacity = this.get("opacity"), fill = this.get("fill"), fillOpacity = this.get("fill-opacity");
                            if (isClip) return DefaultColors.white;
                            if (fill !== "none" && opacity && fillOpacity) {
                                if (fill instanceof SvgElemGradient || fill instanceof SvgElemPattern) return fill.getPaint(this.getBoundingBox(), fillOpacity * opacity, isClip, isMask);
                                return opacityToColor(fill, fillOpacity * opacity, isMask);
                            }
                        };
                        this.getStroke = function(isClip, isMask) {
                            var opacity = this.get("opacity"), stroke = this.get("stroke"), strokeOpacity = this.get("stroke-opacity");
                            if (isClip || isEqual(this.get("stroke-width"), 0)) return;
                            if (stroke !== "none" && opacity && strokeOpacity) {
                                if (stroke instanceof SvgElemGradient || stroke instanceof SvgElemPattern) return stroke.getPaint(this.getBoundingBox(), strokeOpacity * opacity, isClip, isMask);
                                return opacityToColor(stroke, strokeOpacity * opacity, isMask);
                            }
                        };
                    };
                    var SvgElemHasChildren = function SvgElemHasChildren(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        this.allowedChildren = [
                            "use",
                            "g",
                            "a",
                            "svg",
                            "image",
                            "rect",
                            "circle",
                            "ellipse",
                            "line",
                            "polyline",
                            "polygon",
                            "path",
                            "text"
                        ];
                        this.getBoundingShape = function() {
                            var shape = new SvgShape(), children = this.getChildren();
                            for(var i = 0; i < children.length; i++){
                                if (children[i].get("display") !== "none") {
                                    if (typeof children[i].getBoundingShape === "function") {
                                        var childShape = children[i].getBoundingShape().clone();
                                        if (typeof children[i].getTransformation === "function") childShape.transform(children[i].getTransformation());
                                        shape.mergeShape(childShape);
                                    }
                                }
                            }
                            return shape;
                        };
                        this.drawChildren = function(isClip, isMask) {
                            var children = this.getChildren();
                            for(var i = 0; i < children.length; i++){
                                if (children[i].get("display") !== "none") {
                                    if (typeof children[i].drawInDocument === "function") children[i].drawInDocument(isClip, isMask);
                                }
                            }
                        };
                    };
                    var SvgElemContainer = function SvgElemContainer(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.drawContent = function(isClip, isMask) {
                            this.transform();
                            var clipped = this.clip(), masked = this.mask(), group;
                            if ((this.get("opacity") < 1 || clipped || masked) && !isClip) group = docBeginGroup(getPageBBox());
                            this.drawChildren(isClip, isMask);
                            if (group) {
                                docEndGroup(group);
                                doc.fillOpacity(this.get("opacity"));
                                docInsertGroup(group);
                            }
                        };
                    };
                    var SvgElemUse = function SvgElemUse(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        var x = this.getLength("x", this.getVWidth(), 0), y = this.getLength("y", this.getVHeight(), 0), child = this.getUrl("href") || this.getUrl("xlink:href");
                        if (child) child = createSVGElement(child, this);
                        this.getChildren = function() {
                            return child ? [
                                child
                            ] : [];
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return multiplyMatrix(this.get("transform"), [
                                1,
                                0,
                                0,
                                1,
                                x,
                                y
                            ]);
                        };
                    };
                    var SvgElemSymbol = function SvgElemSymbol(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        var width = this.getLength("width", this.getParentVWidth(), this.getParentVWidth()), height = this.getLength("height", this.getParentVHeight(), this.getParentVHeight());
                        if (inherits instanceof SvgElemUse) {
                            width = inherits.getLength("width", inherits.getParentVWidth(), width);
                            height = inherits.getLength("height", inherits.getParentVHeight(), height);
                        }
                        var aspectRatio = (this.attr("preserveAspectRatio") || "").trim(), viewBox = this.getViewbox("viewBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        this.getVWidth = function() {
                            return viewBox[2];
                        };
                        this.getVHeight = function() {
                            return viewBox[3];
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [
                                1,
                                0,
                                0,
                                1,
                                -viewBox[0],
                                -viewBox[1]
                            ]);
                        };
                    };
                    var SvgElemGroup = function SvgElemGroup(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            if (this.link && !isClip && !isMask) this.addLink();
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return this.get("transform");
                        };
                    };
                    var SvgElemLink = function SvgElemLink(obj, inherits) {
                        if (inherits && inherits.isText) {
                            SvgElemTspan.call(this, obj, inherits);
                            this.allowedChildren = [
                                "textPath",
                                "tspan",
                                "#text",
                                "#cdata-section",
                                "a"
                            ];
                        } else SvgElemGroup.call(this, obj, inherits);
                        this.link = this.attr("href") || this.attr("xlink:href");
                        this.addLink = function() {
                            if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
                                var bbox = this.getBoundingShape().transform(getGlobalMatrix()).getBoundingBox();
                                docInsertLink(bbox[0], bbox[1], bbox[2], bbox[3], this.link);
                            }
                        };
                    };
                    var SvgElemSvg = function SvgElemSvg(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        var width = this.getLength("width", this.getParentVWidth(), this.getParentVWidth()), height = this.getLength("height", this.getParentVHeight(), this.getParentVHeight()), x = this.getLength("x", this.getParentVWidth(), 0), y = this.getLength("y", this.getParentVHeight(), 0);
                        if (inherits instanceof SvgElemUse) {
                            width = inherits.getLength("width", inherits.getParentVWidth(), width);
                            height = inherits.getLength("height", inherits.getParentVHeight(), height);
                        }
                        var aspectRatio = this.attr("preserveAspectRatio"), viewBox = this.getViewbox("viewBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        if (this.isOuterElement && preserveAspectRatio) {
                            x = y = 0;
                            width = viewportWidth;
                            height = viewportHeight;
                            aspectRatio = preserveAspectRatio;
                        }
                        this.getVWidth = function() {
                            return viewBox[2];
                        };
                        this.getVHeight = function() {
                            return viewBox[3];
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            if (this.get("overflow") === "hidden") {
                                new SvgShape().M(x, y).L(x + width, y).L(x + width, y + height).L(x, y + height).Z().transform(this.get("transform")).insertInDocument();
                                doc.clip();
                            }
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return multiplyMatrix(this.get("transform"), [
                                1,
                                0,
                                0,
                                1,
                                x,
                                y
                            ], parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [
                                1,
                                0,
                                0,
                                1,
                                -viewBox[0],
                                -viewBox[1]
                            ]);
                        };
                    };
                    var SVGElemImage = function SVGElemImage(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        var link = imageCallback(this.attr("href") || this.attr("xlink:href") || ""), x = this.getLength("x", this.getVWidth(), 0), y = this.getLength("y", this.getVHeight(), 0), width = this.getLength("width", this.getVWidth(), "auto"), height = this.getLength("height", this.getVHeight(), "auto"), image;
                        try {
                            image = doc.openImage(link);
                        } catch (e) {
                            warningCallback('SVGElemImage: failed to open image "' + link + '" in PDFKit');
                        }
                        if (image) {
                            if (width === "auto" && height !== "auto") width = height * image.width / image.height;
                            else if (height === "auto" && width !== "auto") height = width * image.height / image.width;
                            else if (width === "auto" && height === "auto") {
                                width = image.width;
                                height = image.height;
                            }
                        }
                        if (width === "auto" || width < 0) width = 0;
                        if (height === "auto" || height < 0) height = 0;
                        this.getTransformation = function() {
                            return this.get("transform");
                        };
                        this.getBoundingShape = function() {
                            return new SvgShape().M(x, y).L(x + width, y).M(x + width, y + height).L(x, y + height);
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            if (this.get("visibility") === "hidden" || !image) return;
                            doc.save();
                            this.transform();
                            if (this.get("overflow") === "hidden") doc.rect(x, y, width, height).clip();
                            this.clip();
                            this.mask();
                            doc.translate(x, y);
                            doc.transform.apply(doc, parseAspectRatio(this.attr("preserveAspectRatio"), width, height, image ? image.width : width, image ? image.height : height));
                            if (!isClip) {
                                doc.fillOpacity(this.get("opacity"));
                                doc.image(image, 0, 0);
                            } else {
                                doc.rect(0, 0, image.width, image.height);
                                docFillColor(DefaultColors.white).fill();
                            }
                            doc.restore();
                        };
                    };
                    var SvgElemPattern = function SvgElemPattern(obj, inherits, fallback) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.ref = (function() {
                            var ref = this.getUrl("href") || this.getUrl("xlink:href");
                            if (ref && ref.nodeName === obj.nodeName) return new SvgElemPattern(ref, inherits, fallback);
                        }).call(this);
                        var _attr = this.attr;
                        this.attr = function(key) {
                            var attr = _attr.call(this, key);
                            if (attr != null || key === "href" || key === "xlink:href") return attr;
                            return this.ref ? this.ref.attr(key) : null;
                        };
                        var _getChildren = this.getChildren;
                        this.getChildren = function() {
                            var children = _getChildren.call(this);
                            if (children.length > 0) return children;
                            return this.ref ? this.ref.getChildren() : [];
                        };
                        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
                            var bBoxUnitsPattern = this.attr("patternUnits") !== "userSpaceOnUse", bBoxUnitsContent = this.attr("patternContentUnits") === "objectBoundingBox", x = this.getLength("x", bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0), y = this.getLength("y", bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0), width = this.getLength("width", bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0), height = this.getLength("height", bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
                            if (bBoxUnitsContent && !bBoxUnitsPattern) {
                                // Use the same units for pattern & pattern content
                                x = (x - bBox[0]) / (bBox[2] - bBox[0]) || 0;
                                y = (y - bBox[1]) / (bBox[3] - bBox[1]) || 0;
                                width = width / (bBox[2] - bBox[0]) || 0;
                                height = height / (bBox[3] - bBox[1]) || 0;
                            } else if (!bBoxUnitsContent && bBoxUnitsPattern) {
                                x = bBox[0] + x * (bBox[2] - bBox[0]);
                                y = bBox[1] + y * (bBox[3] - bBox[1]);
                                width = width * (bBox[2] - bBox[0]);
                                height = height * (bBox[3] - bBox[1]);
                            }
                            var viewBox = this.getViewbox("viewBox", [
                                0,
                                0,
                                width,
                                height
                            ]), aspectRatio = (this.attr("preserveAspectRatio") || "").trim(), aspectRatioMatrix = multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3], 0), [
                                1,
                                0,
                                0,
                                1,
                                -viewBox[0],
                                -viewBox[1]
                            ]), matrix = parseTranform(this.attr("patternTransform"));
                            if (bBoxUnitsContent) matrix = multiplyMatrix([
                                bBox[2] - bBox[0],
                                0,
                                0,
                                bBox[3] - bBox[1],
                                bBox[0],
                                bBox[1]
                            ], matrix);
                            matrix = multiplyMatrix(matrix, [
                                1,
                                0,
                                0,
                                1,
                                x,
                                y
                            ]);
                            if ((matrix = validateMatrix(matrix)) && (aspectRatioMatrix = validateMatrix(aspectRatioMatrix)) && (width = validateNumber(width)) && (height = validateNumber(height))) {
                                var group = docBeginGroup([
                                    0,
                                    0,
                                    width,
                                    height
                                ]);
                                doc.transform.apply(doc, aspectRatioMatrix);
                                this.drawChildren(isClip, isMask);
                                docEndGroup(group);
                                return [
                                    docCreatePattern(group, width, height, matrix),
                                    gOpacity
                                ];
                            } else return fallback ? [
                                fallback[0],
                                fallback[1] * gOpacity
                            ] : undefined;
                        };
                        this.getVWidth = function() {
                            var bBoxUnitsPattern = this.attr("patternUnits") !== "userSpaceOnUse", width = this.getLength("width", bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0);
                            return this.getViewbox("viewBox", [
                                0,
                                0,
                                width,
                                0
                            ])[2];
                        };
                        this.getVHeight = function() {
                            var bBoxUnitsPattern = this.attr("patternUnits") !== "userSpaceOnUse", height = this.getLength("height", bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
                            return this.getViewbox("viewBox", [
                                0,
                                0,
                                0,
                                height
                            ])[3];
                        };
                    };
                    var SvgElemGradient = function SvgElemGradient(obj, inherits, fallback) {
                        SvgElem.call(this, obj, inherits);
                        this.allowedChildren = [
                            "stop"
                        ];
                        this.ref = (function() {
                            var ref = this.getUrl("href") || this.getUrl("xlink:href");
                            if (ref && ref.nodeName === obj.nodeName) return new SvgElemGradient(ref, inherits, fallback);
                        }).call(this);
                        var _attr = this.attr;
                        this.attr = function(key) {
                            var attr = _attr.call(this, key);
                            if (attr != null || key === "href" || key === "xlink:href") return attr;
                            return this.ref ? this.ref.attr(key) : null;
                        };
                        var _getChildren = this.getChildren;
                        this.getChildren = function() {
                            var children = _getChildren.call(this);
                            if (children.length > 0) return children;
                            return this.ref ? this.ref.getChildren() : [];
                        };
                        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
                            var children = this.getChildren();
                            if (children.length === 0) return;
                            if (children.length === 1) {
                                var child = children[0], stopColor = child.get("stop-color");
                                if (stopColor === "none") return;
                                return opacityToColor(stopColor, child.get("stop-opacity") * gOpacity, isMask);
                            }
                            var bBoxUnits = this.attr("gradientUnits") !== "userSpaceOnUse", matrix = parseTranform(this.attr("gradientTransform")), spread = this.attr("spreadMethod"), grad, x1, x2, y1, y2, r2, nAfter = 0, nBefore = 0, nTotal = 1;
                            if (bBoxUnits) matrix = multiplyMatrix([
                                bBox[2] - bBox[0],
                                0,
                                0,
                                bBox[3] - bBox[1],
                                bBox[0],
                                bBox[1]
                            ], matrix);
                            if (matrix = validateMatrix(matrix)) {
                                if (this.name === "linearGradient") {
                                    x1 = this.getLength("x1", bBoxUnits ? 1 : this.getVWidth(), 0);
                                    x2 = this.getLength("x2", bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 1 : this.getVWidth());
                                    y1 = this.getLength("y1", bBoxUnits ? 1 : this.getVHeight(), 0);
                                    y2 = this.getLength("y2", bBoxUnits ? 1 : this.getVHeight(), 0);
                                } else {
                                    x2 = this.getLength("cx", bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 0.5 : 0.5 * this.getVWidth());
                                    y2 = this.getLength("cy", bBoxUnits ? 1 : this.getVHeight(), bBoxUnits ? 0.5 : 0.5 * this.getVHeight());
                                    r2 = this.getLength("r", bBoxUnits ? 1 : this.getViewport(), bBoxUnits ? 0.5 : 0.5 * this.getViewport());
                                    x1 = this.getLength("fx", bBoxUnits ? 1 : this.getVWidth(), x2);
                                    y1 = this.getLength("fy", bBoxUnits ? 1 : this.getVHeight(), y2);
                                    if (r2 < 0) warningCallback("SvgElemGradient: negative r value");
                                    var d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), multiplier = 1;
                                    if (d > r2) {
                                        // according to specification
                                        multiplier = r2 / d;
                                        x1 = x2 + (x1 - x2) * multiplier;
                                        y1 = y2 + (y1 - y2) * multiplier;
                                    }
                                    r2 = Math.max(r2, d * multiplier * (1 + 1e-6)); // fix for edge-case gradients see issue #84
                                }
                                if (spread === "reflect" || spread === "repeat") {
                                    var inv = inverseMatrix(matrix), corner1 = transformPoint([
                                        bBox[0],
                                        bBox[1]
                                    ], inv), corner2 = transformPoint([
                                        bBox[2],
                                        bBox[1]
                                    ], inv), corner3 = transformPoint([
                                        bBox[2],
                                        bBox[3]
                                    ], inv), corner4 = transformPoint([
                                        bBox[0],
                                        bBox[3]
                                    ], inv);
                                    if (this.name === "linearGradient") {
                                        // See file 'gradient-repeat-maths.png'
                                        nAfter = Math.max((corner1[0] - x2) * (x2 - x1) + (corner1[1] - y2) * (y2 - y1), (corner2[0] - x2) * (x2 - x1) + (corner2[1] - y2) * (y2 - y1), (corner3[0] - x2) * (x2 - x1) + (corner3[1] - y2) * (y2 - y1), (corner4[0] - x2) * (x2 - x1) + (corner4[1] - y2) * (y2 - y1)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                                        nBefore = Math.max((corner1[0] - x1) * (x1 - x2) + (corner1[1] - y1) * (y1 - y2), (corner2[0] - x1) * (x1 - x2) + (corner2[1] - y1) * (y1 - y2), (corner3[0] - x1) * (x1 - x2) + (corner3[1] - y1) * (y1 - y2), (corner4[0] - x1) * (x1 - x2) + (corner4[1] - y1) * (y1 - y2)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                                    } else nAfter = Math.sqrt(Math.max(Math.pow(corner1[0] - x2, 2) + Math.pow(corner1[1] - y2, 2), Math.pow(corner2[0] - x2, 2) + Math.pow(corner2[1] - y2, 2), Math.pow(corner3[0] - x2, 2) + Math.pow(corner3[1] - y2, 2), Math.pow(corner4[0] - x2, 2) + Math.pow(corner4[1] - y2, 2))) / r2 - 1;
                                    nAfter = Math.ceil(nAfter + 0.5); // Add a little more because the stroke can extend outside of the bounding box
                                    nBefore = Math.ceil(nBefore + 0.5);
                                    nTotal = nBefore + 1 + nAfter; // How many times the gradient needs to be repeated to fill the object bounding box
                                }
                                if (this.name === "linearGradient") grad = doc.linearGradient(x1 - nBefore * (x2 - x1), y1 - nBefore * (y2 - y1), x2 + nAfter * (x2 - x1), y2 + nAfter * (y2 - y1));
                                else grad = doc.radialGradient(x1, y1, 0, x2, y2, r2 + nAfter * r2);
                                for(var n = 0; n < nTotal; n++){
                                    var offset = 0, inOrder = spread !== "reflect" || (n - nBefore) % 2 === 0;
                                    for(var i = 0; i < children.length; i++){
                                        var _child = children[inOrder ? i : children.length - 1 - i], _stopColor = _child.get("stop-color");
                                        if (_stopColor === "none") _stopColor = DefaultColors.transparent;
                                        _stopColor = opacityToColor(_stopColor, _child.get("stop-opacity") * gOpacity, isMask);
                                        offset = Math.max(offset, inOrder ? _child.getPercent("offset", 0) : 1 - _child.getPercent("offset", 0));
                                        if (i === 0 && _stopColor[0].length === 4) grad._colorSpace = "DeviceCMYK";
                                         // Fix until PR #763 is merged into PDFKit
                                        if (i === 0 && offset > 0) grad.stop((n + 0) / nTotal, _stopColor[0], _stopColor[1]);
                                        grad.stop((n + offset) / (nAfter + nBefore + 1), _stopColor[0], _stopColor[1]);
                                        if (i === children.length - 1 && offset < 1) grad.stop((n + 1) / nTotal, _stopColor[0], _stopColor[1]);
                                    }
                                }
                                grad.setTransform.apply(grad, matrix);
                                return [
                                    grad,
                                    1
                                ];
                            } else return fallback ? [
                                fallback[0],
                                fallback[1] * gOpacity
                            ] : undefined;
                        };
                    };
                    var SvgElemBasicShape = function SvgElemBasicShape(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        this.dashScale = 1;
                        this.getBoundingShape = function() {
                            return this.shape;
                        };
                        this.getTransformation = function() {
                            return this.get("transform");
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            if (this.get("visibility") === "hidden" || !this.shape) return;
                            doc.save();
                            this.transform();
                            this.clip();
                            if (!isClip) {
                                var masked = this.mask(), group;
                                if (masked) group = docBeginGroup(getPageBBox());
                                var subPaths = this.shape.getSubPaths(), fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask), lineWidth = this.get("stroke-width"), lineCap = this.get("stroke-linecap");
                                if (fill || stroke) {
                                    if (fill) docFillColor(fill);
                                    if (stroke) {
                                        for(var j = 0; j < subPaths.length; j++)if (isEqual(subPaths[j].totalLength, 0)) {
                                            if ((lineCap === "square" || lineCap === "round") && lineWidth > 0) {
                                                if (subPaths[j].startPoint && subPaths[j].startPoint.length > 1) {
                                                    var _x4 = subPaths[j].startPoint[0], _y4 = subPaths[j].startPoint[1];
                                                    docFillColor(stroke);
                                                    if (lineCap === "square") doc.rect(_x4 - 0.5 * lineWidth, _y4 - 0.5 * lineWidth, lineWidth, lineWidth);
                                                    else if (lineCap === "round") doc.circle(_x4, _y4, 0.5 * lineWidth);
                                                    doc.fill();
                                                }
                                            }
                                        }
                                        var dashArray = this.get("stroke-dasharray"), dashOffset = this.get("stroke-dashoffset");
                                        if (isNotEqual(this.dashScale, 1)) {
                                            for(var _j2 = 0; _j2 < dashArray.length; _j2++)dashArray[_j2] *= this.dashScale;
                                            dashOffset *= this.dashScale;
                                        }
                                        docStrokeColor(stroke);
                                        doc.lineWidth(lineWidth).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(lineCap).dash(dashArray, {
                                            phase: dashOffset
                                        });
                                    }
                                    for(var _j3 = 0; _j3 < subPaths.length; _j3++)if (subPaths[_j3].totalLength > 0) subPaths[_j3].insertInDocument();
                                    if (fill && stroke) doc.fillAndStroke(this.get("fill-rule"));
                                    else if (fill) doc.fill(this.get("fill-rule"));
                                    else if (stroke) doc.stroke();
                                }
                                var markerStart = this.get("marker-start"), markerMid = this.get("marker-mid"), markerEnd = this.get("marker-end");
                                if (markerStart !== "none" || markerMid !== "none" || markerEnd !== "none") {
                                    var markersPos = this.shape.getMarkers();
                                    if (markerStart !== "none") {
                                        var marker = new SvgElemMarker(markerStart, null);
                                        marker.drawMarker(false, isMask, markersPos[0], lineWidth);
                                    }
                                    if (markerMid !== "none") for(var i = 1; i < markersPos.length - 1; i++){
                                        var _marker = new SvgElemMarker(markerMid, null);
                                        _marker.drawMarker(false, isMask, markersPos[i], lineWidth);
                                    }
                                    if (markerEnd !== "none") {
                                        var _marker2 = new SvgElemMarker(markerEnd, null);
                                        _marker2.drawMarker(false, isMask, markersPos[markersPos.length - 1], lineWidth);
                                    }
                                }
                                if (group) {
                                    docEndGroup(group);
                                    docInsertGroup(group);
                                }
                            } else {
                                this.shape.insertInDocument();
                                docFillColor(DefaultColors.white);
                                doc.fill(this.get("clip-rule"));
                            }
                            doc.restore();
                        };
                    };
                    var SvgElemRect = function SvgElemRect(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var x = this.getLength("x", this.getVWidth(), 0), y = this.getLength("y", this.getVHeight(), 0), w = this.getLength("width", this.getVWidth(), 0), h = this.getLength("height", this.getVHeight(), 0), rx = this.getLength("rx", this.getVWidth()), ry = this.getLength("ry", this.getVHeight());
                        if (rx === undefined && ry === undefined) rx = ry = 0;
                        else if (rx === undefined && ry !== undefined) rx = ry;
                        else if (rx !== undefined && ry === undefined) ry = rx;
                        if (w > 0 && h > 0) {
                            if (rx && ry) {
                                rx = Math.min(rx, 0.5 * w);
                                ry = Math.min(ry, 0.5 * h);
                                this.shape = new SvgShape().M(x + rx, y).L(x + w - rx, y).A(rx, ry, 0, 0, 1, x + w, y + ry).L(x + w, y + h - ry).A(rx, ry, 0, 0, 1, x + w - rx, y + h).L(x + rx, y + h).A(rx, ry, 0, 0, 1, x, y + h - ry).L(x, y + ry).A(rx, ry, 0, 0, 1, x + rx, y).Z();
                            } else this.shape = new SvgShape().M(x, y).L(x + w, y).L(x + w, y + h).L(x, y + h).Z();
                        } else this.shape = new SvgShape();
                    };
                    var SvgElemCircle = function SvgElemCircle(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var cx = this.getLength("cx", this.getVWidth(), 0), cy = this.getLength("cy", this.getVHeight(), 0), r = this.getLength("r", this.getViewport(), 0);
                        if (r > 0) this.shape = new SvgShape().M(cx + r, cy).A(r, r, 0, 0, 1, cx - r, cy).A(r, r, 0, 0, 1, cx + r, cy).Z();
                        else this.shape = new SvgShape();
                    };
                    var SvgElemEllipse = function SvgElemEllipse(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var cx = this.getLength("cx", this.getVWidth(), 0), cy = this.getLength("cy", this.getVHeight(), 0), rx = this.getLength("rx", this.getVWidth(), 0), ry = this.getLength("ry", this.getVHeight(), 0);
                        if (rx > 0 && ry > 0) this.shape = new SvgShape().M(cx + rx, cy).A(rx, ry, 0, 0, 1, cx - rx, cy).A(rx, ry, 0, 0, 1, cx + rx, cy).Z();
                        else this.shape = new SvgShape();
                    };
                    var SvgElemLine = function SvgElemLine(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var x1 = this.getLength("x1", this.getVWidth(), 0), y1 = this.getLength("y1", this.getVHeight(), 0), x2 = this.getLength("x2", this.getVWidth(), 0), y2 = this.getLength("y2", this.getVHeight(), 0);
                        this.shape = new SvgShape().M(x1, y1).L(x2, y2);
                    };
                    var SvgElemPolyline = function SvgElemPolyline(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var points = this.getNumberList("points");
                        this.shape = new SvgShape();
                        for(var i = 0; i < points.length - 1; i += 2)if (i === 0) this.shape.M(points[i], points[i + 1]);
                        else this.shape.L(points[i], points[i + 1]);
                        if (points.error) warningCallback("SvgElemPolygon: unexpected string " + points.error);
                        if (points.length % 2 === 1) warningCallback("SvgElemPolyline: uneven number of coordinates");
                    };
                    var SvgElemPolygon = function SvgElemPolygon(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var points = this.getNumberList("points");
                        this.shape = new SvgShape();
                        for(var i = 0; i < points.length - 1; i += 2)if (i === 0) this.shape.M(points[i], points[i + 1]);
                        else this.shape.L(points[i], points[i + 1]);
                        this.shape.Z();
                        if (points.error) warningCallback("SvgElemPolygon: unexpected string " + points.error);
                        if (points.length % 2 === 1) warningCallback("SvgElemPolygon: uneven number of coordinates");
                    };
                    var SvgElemPath = function SvgElemPath(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        this.shape = new SvgShape().path(this.attr("d"));
                        var pathLength = this.getLength("pathLength", this.getViewport());
                        this.pathLength = pathLength > 0 ? pathLength : undefined;
                        this.dashScale = this.pathLength !== undefined ? this.shape.totalLength / this.pathLength : 1;
                    };
                    var SvgElemMarker = function SvgElemMarker(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        var width = this.getLength("markerWidth", this.getParentVWidth(), 3), height = this.getLength("markerHeight", this.getParentVHeight(), 3), viewBox = this.getViewbox("viewBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        this.getVWidth = function() {
                            return viewBox[2];
                        };
                        this.getVHeight = function() {
                            return viewBox[3];
                        };
                        this.drawMarker = function(isClip, isMask, posArray, strokeWidth) {
                            doc.save();
                            var orient = this.attr("orient"), units = this.attr("markerUnits"), rotate = orient === "auto" ? posArray[2] : (parseFloat(orient) || 0) * Math.PI / 180, scale = units === "userSpaceOnUse" ? 1 : strokeWidth;
                            doc.transform(Math.cos(rotate) * scale, Math.sin(rotate) * scale, -Math.sin(rotate) * scale, Math.cos(rotate) * scale, posArray[0], posArray[1]);
                            var refX = this.getLength("refX", this.getVWidth(), 0), refY = this.getLength("refY", this.getVHeight(), 0), aspectRatioMatrix = parseAspectRatio(this.attr("preserveAspectRatio"), width, height, viewBox[2], viewBox[3], 0.5);
                            if (this.get("overflow") === "hidden") doc.rect(aspectRatioMatrix[0] * (viewBox[0] + viewBox[2] / 2 - refX) - width / 2, aspectRatioMatrix[3] * (viewBox[1] + viewBox[3] / 2 - refY) - height / 2, width, height).clip();
                            doc.transform.apply(doc, aspectRatioMatrix);
                            doc.translate(-refX, -refY);
                            var group;
                            if (this.get("opacity") < 1 && !isClip) group = docBeginGroup(getPageBBox());
                            this.drawChildren(isClip, isMask);
                            if (group) {
                                docEndGroup(group);
                                doc.fillOpacity(this.get("opacity"));
                                docInsertGroup(group);
                            }
                            doc.restore();
                        };
                    };
                    var SvgElemClipPath = function SvgElemClipPath(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.useMask = function(bBox) {
                            var group = docBeginGroup(getPageBBox());
                            doc.save();
                            if (this.attr("clipPathUnits") === "objectBoundingBox") doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
                            this.clip();
                            this.drawChildren(true, false);
                            doc.restore();
                            docEndGroup(group);
                            docApplyMask(group, true);
                        };
                    };
                    var SvgElemMask = function SvgElemMask(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.useMask = function(bBox) {
                            var group = docBeginGroup(getPageBBox());
                            doc.save();
                            var x, y, w, h;
                            if (this.attr("maskUnits") === "userSpaceOnUse") {
                                x = this.getLength("x", this.getVWidth(), -0.1 * (bBox[2] - bBox[0]) + bBox[0]);
                                y = this.getLength("y", this.getVHeight(), -0.1 * (bBox[3] - bBox[1]) + bBox[1]);
                                w = this.getLength("width", this.getVWidth(), 1.2 * (bBox[2] - bBox[0]));
                                h = this.getLength("height", this.getVHeight(), 1.2 * (bBox[3] - bBox[1]));
                            } else {
                                x = this.getLength("x", this.getVWidth(), -0.1) * (bBox[2] - bBox[0]) + bBox[0];
                                y = this.getLength("y", this.getVHeight(), -0.1) * (bBox[3] - bBox[1]) + bBox[1];
                                w = this.getLength("width", this.getVWidth(), 1.2) * (bBox[2] - bBox[0]);
                                h = this.getLength("height", this.getVHeight(), 1.2) * (bBox[3] - bBox[1]);
                            }
                            doc.rect(x, y, w, h).clip();
                            if (this.attr("maskContentUnits") === "objectBoundingBox") doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
                            this.clip();
                            this.drawChildren(false, true);
                            doc.restore();
                            docEndGroup(group);
                            docApplyMask(group, true);
                        };
                    };
                    var SvgElemTextContainer = function SvgElemTextContainer(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        this.allowedChildren = [
                            "tspan",
                            "#text",
                            "#cdata-section",
                            "a"
                        ];
                        this.isText = true;
                        this.getBoundingShape = function() {
                            var shape = new SvgShape();
                            for(var i = 0; i < this._pos.length; i++){
                                var pos = this._pos[i];
                                if (!pos.hidden) {
                                    var dx0 = pos.ascent * Math.sin(pos.rotate), dy0 = -pos.ascent * Math.cos(pos.rotate), dx1 = pos.descent * Math.sin(pos.rotate), dy1 = -pos.descent * Math.cos(pos.rotate), dx2 = pos.width * Math.cos(pos.rotate), dy2 = pos.width * Math.sin(pos.rotate);
                                    shape.M(pos.x + dx0, pos.y + dy0).L(pos.x + dx0 + dx2, pos.y + dy0 + dy2).M(pos.x + dx1 + dx2, pos.y + dy1 + dy2).L(pos.x + dx1, pos.y + dy1);
                                }
                            }
                            return shape;
                        };
                        this.drawTextInDocument = function(isClip, isMask) {
                            if (this.link && !isClip && !isMask) this.addLink();
                            if (this.get("text-decoration") === "underline") this.decorate(0.05 * this._font.size, -0.075 * this._font.size, isClip, isMask);
                            if (this.get("text-decoration") === "overline") this.decorate(0.05 * this._font.size, getAscent(this._font.font, this._font.size) + 0.075 * this._font.size, isClip, isMask);
                            var fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask), strokeWidth = this.get("stroke-width");
                            if (this._font.fauxBold) {
                                if (!stroke) {
                                    stroke = fill;
                                    strokeWidth = this._font.size * 0.03;
                                } else strokeWidth += this._font.size * 0.03;
                            }
                            var children = this.getChildren();
                            for(var i = 0; i < children.length; i++){
                                var childElem = children[i];
                                switch(childElem.name){
                                    case "tspan":
                                    case "textPath":
                                    case "a":
                                        if (childElem.get("display") !== "none") childElem.drawTextInDocument(isClip, isMask);
                                        break;
                                    case "#text":
                                    case "#cdata-section":
                                        if (this.get("visibility") === "hidden") continue;
                                        if (fill || stroke || isClip) {
                                            if (fill) docFillColor(fill);
                                            if (stroke && strokeWidth) {
                                                docStrokeColor(stroke);
                                                doc.lineWidth(strokeWidth).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(this.get("stroke-linecap")).dash(this.get("stroke-dasharray"), {
                                                    phase: this.get("stroke-dashoffset")
                                                });
                                            }
                                            docBeginText(this._font.font, this._font.size);
                                            docSetTextMode(!!fill, !!stroke);
                                            for(var j = 0, pos = childElem._pos; j < pos.length; j++)if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                                                var cos = Math.cos(pos[j].rotate), sin = Math.sin(pos[j].rotate), skew = this._font.fauxItalic ? -0.25 : 0;
                                                docSetTextMatrix(cos * pos[j].scale, sin * pos[j].scale, cos * skew - sin, sin * skew + cos, pos[j].x, pos[j].y);
                                                docWriteGlyph(pos[j].glyph);
                                            }
                                            docEndText();
                                        }
                                        break;
                                }
                            }
                            if (this.get("text-decoration") === "line-through") this.decorate(0.05 * this._font.size, 0.5 * (getAscent(this._font.font, this._font.size) + getDescent(this._font.font, this._font.size)), isClip, isMask);
                        };
                        this.decorate = function(lineWidth, linePosition, isClip, isMask) {
                            var fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask);
                            if (fill) docFillColor(fill);
                            if (stroke) {
                                docStrokeColor(stroke);
                                doc.lineWidth(this.get("stroke-width")).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(this.get("stroke-linecap")).dash(this.get("stroke-dasharray"), {
                                    phase: this.get("stroke-dashoffset")
                                });
                            }
                            for(var j = 0, pos = this._pos; j < pos.length; j++)if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                                var dx0 = (linePosition + lineWidth / 2) * Math.sin(pos[j].rotate), dy0 = -(linePosition + lineWidth / 2) * Math.cos(pos[j].rotate), dx1 = (linePosition - lineWidth / 2) * Math.sin(pos[j].rotate), dy1 = -(linePosition - lineWidth / 2) * Math.cos(pos[j].rotate), dx2 = pos[j].width * Math.cos(pos[j].rotate), dy2 = pos[j].width * Math.sin(pos[j].rotate);
                                new SvgShape().M(pos[j].x + dx0, pos[j].y + dy0).L(pos[j].x + dx0 + dx2, pos[j].y + dy0 + dy2).L(pos[j].x + dx1 + dx2, pos[j].y + dy1 + dy2).L(pos[j].x + dx1, pos[j].y + dy1).Z().insertInDocument();
                                if (fill && stroke) doc.fillAndStroke();
                                else if (fill) doc.fill();
                                else if (stroke) doc.stroke();
                            }
                        };
                    };
                    var SvgElemTextNode = function SvgElemTextNode(obj, inherits) {
                        this.name = obj.nodeName;
                        this.textContent = obj.nodeValue;
                    };
                    var SvgElemTspan = function SvgElemTspan(obj, inherits) {
                        SvgElemTextContainer.call(this, obj, inherits);
                    };
                    var SvgElemTextPath = function SvgElemTextPath(obj, inherits) {
                        SvgElemTextContainer.call(this, obj, inherits);
                        var pathObject, pathLength, temp;
                        if ((temp = this.attr("path")) && temp.trim() !== "") {
                            var _pathLength = this.getLength("pathLength", this.getViewport());
                            this.pathObject = new SvgShape().path(temp);
                            this.pathLength = _pathLength > 0 ? _pathLength : this.pathObject.totalLength;
                            this.pathScale = this.pathObject.totalLength / this.pathLength;
                        } else if ((temp = this.getUrl("href") || this.getUrl("xlink:href")) && temp.nodeName === "path") {
                            var pathElem = new SvgElemPath(temp, this);
                            this.pathObject = pathElem.shape.clone().transform(pathElem.get("transform"));
                            this.pathLength = this.chooseValue(pathElem.pathLength, this.pathObject.totalLength);
                            this.pathScale = this.pathObject.totalLength / this.pathLength;
                        }
                    };
                    var SvgElemText = function SvgElemText(obj, inherits) {
                        SvgElemTextContainer.call(this, obj, inherits);
                        this.allowedChildren = [
                            "textPath",
                            "tspan",
                            "#text",
                            "#cdata-section",
                            "a"
                        ];
                        (function(textParentElem) {
                            var processedText = "", remainingText = obj.textContent, textPaths = [], currentChunk = [], currentAnchor, currentDirection, currentX = 0, currentY = 0;
                            function doAnchoring() {
                                if (currentChunk.length) {
                                    var last = currentChunk[currentChunk.length - 1];
                                    var first = currentChunk[0];
                                    var width = last.x + last.width - first.x;
                                    var anchordx = {
                                        "startltr": 0,
                                        "middleltr": 0.5,
                                        "endltr": 1,
                                        "startrtl": 1,
                                        "middlertl": 0.5,
                                        "endrtl": 0
                                    }[currentAnchor + currentDirection] * width || 0;
                                    for(var i = 0; i < currentChunk.length; i++)currentChunk[i].x -= anchordx;
                                }
                                currentChunk = [];
                            }
                            function adjustLength(pos, length, spacingAndGlyphs) {
                                var firstChar = pos[0], lastChar = pos[pos.length - 1], startX = firstChar.x, endX = lastChar.x + lastChar.width;
                                if (spacingAndGlyphs) {
                                    var textScale = length / (endX - startX);
                                    if (textScale > 0 && textScale < Infinity) for(var j = 0; j < pos.length; j++){
                                        pos[j].x = startX + textScale * (pos[j].x - startX);
                                        pos[j].scale *= textScale;
                                        pos[j].width *= textScale;
                                    }
                                } else if (pos.length >= 2) {
                                    var spaceDiff = (length - (endX - startX)) / (pos.length - 1);
                                    for(var _j4 = 0; _j4 < pos.length; _j4++)pos[_j4].x += _j4 * spaceDiff;
                                }
                                currentX += length - (endX - startX);
                            }
                            function recursive(currentElem, parentElem) {
                                currentElem._x = combineArrays(currentElem.getLengthList("x", currentElem.getVWidth()), parentElem ? parentElem._x.slice(parentElem._pos.length) : []);
                                currentElem._y = combineArrays(currentElem.getLengthList("y", currentElem.getVHeight()), parentElem ? parentElem._y.slice(parentElem._pos.length) : []);
                                currentElem._dx = combineArrays(currentElem.getLengthList("dx", currentElem.getVWidth()), parentElem ? parentElem._dx.slice(parentElem._pos.length) : []);
                                currentElem._dy = combineArrays(currentElem.getLengthList("dy", currentElem.getVHeight()), parentElem ? parentElem._dy.slice(parentElem._pos.length) : []);
                                currentElem._rot = combineArrays(currentElem.getNumberList("rotate"), parentElem ? parentElem._rot.slice(parentElem._pos.length) : []);
                                currentElem._defRot = currentElem.chooseValue(currentElem._rot[currentElem._rot.length - 1], parentElem && parentElem._defRot, 0);
                                if (currentElem.name === "textPath") currentElem._y = [];
                                var fontOptions = {
                                    fauxItalic: false,
                                    fauxBold: false
                                }, fontNameorLink = fontCallback(currentElem.get("font-family"), currentElem.get("font-weight") === "bold", currentElem.get("font-style") === "italic", fontOptions);
                                try {
                                    doc.font(fontNameorLink);
                                } catch (e) {
                                    warningCallback('SVGElemText: failed to open font "' + fontNameorLink + '" in PDFKit');
                                }
                                currentElem._pos = [];
                                currentElem._index = 0;
                                currentElem._font = {
                                    font: doc._font,
                                    size: currentElem.get("font-size"),
                                    fauxItalic: fontOptions.fauxItalic,
                                    fauxBold: fontOptions.fauxBold
                                };
                                var textLength = currentElem.getLength("textLength", currentElem.getVWidth(), undefined), spacingAndGlyphs = currentElem.attr("lengthAdjust") === "spacingAndGlyphs", wordSpacing = currentElem.get("word-spacing"), letterSpacing = currentElem.get("letter-spacing"), textAnchor = currentElem.get("text-anchor"), textDirection = currentElem.get("direction"), baseline = getBaseline(currentElem._font.font, currentElem._font.size, currentElem.get("alignment-baseline") || currentElem.get("dominant-baseline"), currentElem.get("baseline-shift"));
                                if (currentElem.name === "textPath") {
                                    doAnchoring();
                                    currentX = currentY = 0;
                                }
                                var children = currentElem.getChildren();
                                for(var i = 0; i < children.length; i++){
                                    var childElem = children[i];
                                    switch(childElem.name){
                                        case "tspan":
                                        case "textPath":
                                        case "a":
                                            recursive(childElem, currentElem);
                                            break;
                                        case "#text":
                                        case "#cdata-section":
                                            var rawText = childElem.textContent, renderedText = rawText, words = void 0;
                                            childElem._font = currentElem._font;
                                            childElem._pos = [];
                                            remainingText = remainingText.substring(rawText.length);
                                            if (currentElem.get("xml:space") === "preserve") renderedText = renderedText.replace(/[\s]/g, " ");
                                            else {
                                                renderedText = renderedText.replace(/[\s]+/g, " ");
                                                if (processedText.match(/[\s]$|^$/)) renderedText = renderedText.replace(/^[\s]/, "");
                                                if (remainingText.match(/^[\s]*$/)) renderedText = renderedText.replace(/[\s]$/, "");
                                            }
                                            processedText += rawText;
                                            if (wordSpacing === 0) words = [
                                                renderedText
                                            ];
                                            else words = renderedText.split(/(\s)/);
                                            for(var w = 0; w < words.length; w++){
                                                var pos = getTextPos(currentElem._font.font, currentElem._font.size, words[w]);
                                                for(var j = 0; j < pos.length; j++){
                                                    var index = currentElem._index, xAttr = currentElem._x[index], yAttr = currentElem._y[index], dxAttr = currentElem._dx[index], dyAttr = currentElem._dy[index], rotAttr = currentElem._rot[index], continuous = !(w === 0 && j === 0);
                                                    if (xAttr !== undefined) {
                                                        continuous = false;
                                                        doAnchoring();
                                                        currentX = xAttr;
                                                    }
                                                    if (yAttr !== undefined) {
                                                        continuous = false;
                                                        doAnchoring();
                                                        currentY = yAttr;
                                                    }
                                                    if (dxAttr !== undefined) {
                                                        continuous = false;
                                                        currentX += dxAttr;
                                                    }
                                                    if (dyAttr !== undefined) {
                                                        continuous = false;
                                                        currentY += dyAttr;
                                                    }
                                                    if (rotAttr !== undefined || currentElem._defRot !== 0) continuous = false;
                                                    var position = {
                                                        glyph: pos[j].glyph,
                                                        rotate: Math.PI / 180 * currentElem.chooseValue(rotAttr, currentElem._defRot),
                                                        x: currentX + pos[j].xOffset,
                                                        y: currentY + baseline + pos[j].yOffset,
                                                        width: pos[j].width,
                                                        ascent: getAscent(currentElem._font.font, currentElem._font.size),
                                                        descent: getDescent(currentElem._font.font, currentElem._font.size),
                                                        scale: 1,
                                                        hidden: false,
                                                        continuous: continuous
                                                    };
                                                    currentChunk.push(position);
                                                    childElem._pos.push(position);
                                                    currentElem._pos.push(position);
                                                    currentElem._index += pos[j].unicode.length;
                                                    if (currentChunk.length === 1) {
                                                        currentAnchor = textAnchor;
                                                        currentDirection = textDirection;
                                                    }
                                                    currentX += pos[j].xAdvance + letterSpacing;
                                                    currentY += pos[j].yAdvance;
                                                }
                                                if (words[w] === " ") currentX += wordSpacing;
                                            }
                                            break;
                                        default:
                                            remainingText = remainingText.substring(childElem.textContent.length);
                                    }
                                }
                                if (textLength && currentElem._pos.length) adjustLength(currentElem._pos, textLength, spacingAndGlyphs);
                                if (currentElem.name === "textPath" || currentElem.name === "text") doAnchoring();
                                if (currentElem.name === "textPath") {
                                    textPaths.push(currentElem);
                                    var pathObject = currentElem.pathObject;
                                    if (pathObject) {
                                        currentX = pathObject.endPoint[0];
                                        currentY = pathObject.endPoint[1];
                                    }
                                }
                                if (parentElem) {
                                    parentElem._pos = parentElem._pos.concat(currentElem._pos);
                                    parentElem._index += currentElem._index;
                                }
                            }
                            function textOnPath(currentElem) {
                                var pathObject = currentElem.pathObject, pathLength = currentElem.pathLength, pathScale = currentElem.pathScale;
                                if (pathObject) {
                                    var textOffset = currentElem.getLength("startOffset", pathLength, 0);
                                    for(var j = 0; j < currentElem._pos.length; j++){
                                        var charMidX = textOffset + currentElem._pos[j].x + 0.5 * currentElem._pos[j].width;
                                        if (charMidX > pathLength || charMidX < 0) currentElem._pos[j].hidden = true;
                                        else {
                                            var pointOnPath = pathObject.getPointAtLength(charMidX * pathScale);
                                            if (isNotEqual(pathScale, 1)) {
                                                currentElem._pos[j].scale *= pathScale;
                                                currentElem._pos[j].width *= pathScale;
                                            }
                                            currentElem._pos[j].x = pointOnPath[0] - 0.5 * currentElem._pos[j].width * Math.cos(pointOnPath[2]) - currentElem._pos[j].y * Math.sin(pointOnPath[2]);
                                            currentElem._pos[j].y = pointOnPath[1] - 0.5 * currentElem._pos[j].width * Math.sin(pointOnPath[2]) + currentElem._pos[j].y * Math.cos(pointOnPath[2]);
                                            currentElem._pos[j].rotate = pointOnPath[2] + currentElem._pos[j].rotate;
                                            currentElem._pos[j].continuous = false;
                                        }
                                    }
                                } else for(var _j5 = 0; _j5 < currentElem._pos.length; _j5++)currentElem._pos[_j5].hidden = true;
                            }
                            recursive(textParentElem, null);
                            for(var i = 0; i < textPaths.length; i++)textOnPath(textPaths[i]);
                        })(this);
                        this.getTransformation = function() {
                            return this.get("transform");
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            this.transform();
                            this.clip();
                            var masked = this.mask(), group;
                            if (masked) group = docBeginGroup(getPageBBox());
                            this.drawTextInDocument(isClip, isMask);
                            if (group) {
                                docEndGroup(group);
                                docInsertGroup(group);
                            }
                            doc.restore();
                        };
                    };
                    options = options || {};
                    var pxToPt = options.assumePt ? 1 : 0.75, // 1px = 72/96pt, but only if assumePt is false
                    viewportWidth = (options.width || doc.page.width) / pxToPt, viewportHeight = (options.height || doc.page.height) / pxToPt, preserveAspectRatio = options.preserveAspectRatio || null, // default to null so that the attr can override if not passed
                    useCSS = options.useCSS && typeof SVGElement !== "undefined" && svg instanceof SVGElement && typeof getComputedStyle === "function", warningCallback = options.warningCallback, fontCallback = options.fontCallback, imageCallback = options.imageCallback, colorCallback = options.colorCallback, documentCallback = options.documentCallback, precision = Math.ceil(Math.max(1, options.precision)) || 3, groupStack = [], documentCache = {}, links = [], styleRules = [];
                    if (typeof warningCallback !== "function") warningCallback = function warningCallback(str) {
                        if (typeof console.warn === "function") console.warn(str);
                    };
                    if (typeof fontCallback !== "function") fontCallback = function fontCallback(family, bold, italic, fontOptions) {
                        // Check if the font is already registered in the document
                        if (bold && italic) {
                            if (doc._registeredFonts.hasOwnProperty(family + "-BoldItalic")) return family + "-BoldItalic";
                            else if (doc._registeredFonts.hasOwnProperty(family + "-Italic")) {
                                fontOptions.fauxBold = true;
                                return family + "-Italic";
                            } else if (doc._registeredFonts.hasOwnProperty(family + "-Bold")) {
                                fontOptions.fauxItalic = true;
                                return family + "-Bold";
                            } else if (doc._registeredFonts.hasOwnProperty(family)) {
                                fontOptions.fauxBold = true;
                                fontOptions.fauxItalic = true;
                                return family;
                            }
                        }
                        if (bold && !italic) {
                            if (doc._registeredFonts.hasOwnProperty(family + "-Bold")) return family + "-Bold";
                            else if (doc._registeredFonts.hasOwnProperty(family)) {
                                fontOptions.fauxBold = true;
                                return family;
                            }
                        }
                        if (!bold && italic) {
                            if (doc._registeredFonts.hasOwnProperty(family + "-Italic")) return family + "-Italic";
                            else if (doc._registeredFonts.hasOwnProperty(family)) {
                                fontOptions.fauxItalic = true;
                                return family;
                            }
                        }
                        if (!bold && !italic) {
                            if (doc._registeredFonts.hasOwnProperty(family)) return family;
                        }
                        // Use standard fonts as fallback
                        if (family.match(/(?:^|,)\s*serif\s*$/)) {
                            if (bold && italic) return "Times-BoldItalic";
                            if (bold && !italic) return "Times-Bold";
                            if (!bold && italic) return "Times-Italic";
                            if (!bold && !italic) return "Times-Roman";
                        } else if (family.match(/(?:^|,)\s*monospace\s*$/)) {
                            if (bold && italic) return "Courier-BoldOblique";
                            if (bold && !italic) return "Courier-Bold";
                            if (!bold && italic) return "Courier-Oblique";
                            if (!bold && !italic) return "Courier";
                        } else {
                            family.match(/(?:^|,)\s*sans-serif\s*$/);
                            if (bold && italic) return "Helvetica-BoldOblique";
                            if (bold && !italic) return "Helvetica-Bold";
                            if (!bold && italic) return "Helvetica-Oblique";
                            if (!bold && !italic) return "Helvetica";
                        }
                    };
                    if (typeof imageCallback !== "function") imageCallback = function imageCallback(link) {
                        return link.replace(/\s+/g, "");
                    };
                    if (typeof colorCallback !== "function") colorCallback = null;
                    else for(var color in DefaultColors){
                        var newColor = colorCallback(DefaultColors[color]);
                        DefaultColors[color][0] = newColor[0];
                        DefaultColors[color][1] = newColor[1];
                    }
                    if (typeof documentCallback !== "function") documentCallback = null;
                    if (typeof svg === "string") svg = parseXml(svg);
                    if (svg) {
                        var styles = svg.getElementsByTagName("style");
                        for(var i = 0; i < styles.length; i++)styleRules = styleRules.concat(parseStyleSheet(styles[i].textContent));
                        var elem = createSVGElement(svg, null);
                        if (typeof elem.drawInDocument === "function") {
                            if (options.useCSS && !useCSS) warningCallback("SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers");
                            var savedFillColor = doc._fillColor;
                            doc.save().translate(x || 0, y || 0).scale(pxToPt);
                            elem.drawInDocument();
                            for(var _i8 = 0; _i8 < links.length; _i8++)doc.page.annotations.push(links[_i8]);
                            doc.restore();
                            doc._fillColor = savedFillColor;
                        } else warningCallback("SVGtoPDF: this element can't be rendered directly: " + svg.nodeName);
                    } else warningCallback("SVGtoPDF: the input does not look like a valid SVG");
                };
                if (module1 && typeof module1.exports !== "undefined") module1.exports = SVGtoPDF;
            /***/ },
            /***/ 83036: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __dirname = "/";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                __webpack_require__(80044);
                __webpack_require__(26364);
                __webpack_require__(19701);
                __webpack_require__(10853);
                __webpack_require__(80238);
                __webpack_require__(6208);
                __webpack_require__(12938);
                __webpack_require__(56908);
                __webpack_require__(54130);
                __webpack_require__(33290);
                __webpack_require__(86632);
                __webpack_require__(61928);
                __webpack_require__(54883);
                __webpack_require__(45007);
                __webpack_require__(68995);
                __webpack_require__(4845);
                __webpack_require__(18821);
                __webpack_require__(54994);
                __webpack_require__(39275);
                __webpack_require__(55281);
                __webpack_require__(55862);
                __webpack_require__(85005);
                __webpack_require__(22321);
                __webpack_require__(73214);
                __webpack_require__(18481);
                __webpack_require__(66923);
                __webpack_require__(12798);
                __webpack_require__(18183);
                __webpack_require__(14686);
                __webpack_require__(80174);
                __webpack_require__(67838);
                __webpack_require__(75668);
                __webpack_require__(67666);
                __webpack_require__(79627);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(36501);
                __webpack_require__(83382);
                __webpack_require__(33130);
                __webpack_require__(29897);
                __webpack_require__(86125);
                __webpack_require__(54902);
                __webpack_require__(35054);
                var _stream = _interopRequireDefault(__webpack_require__(20202));
                var _zlib = _interopRequireDefault(__webpack_require__(63339));
                var _cryptoJs = _interopRequireDefault(__webpack_require__(35243));
                var _fontkit = _interopRequireDefault(__webpack_require__(89233));
                var _events = __webpack_require__(5939);
                var _linebreak = _interopRequireDefault(__webpack_require__(46982));
                var _pngJs = _interopRequireDefault(__webpack_require__(45968));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var fs = __webpack_require__(52773);
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (typeof call === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self1);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
                }
                function _iterableToArrayLimit(arr, i) {
                    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it;
                    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = o[Symbol.iterator]();
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it.return != null) it.return();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                /*
PDFAbstractReference - abstract class for PDF reference
*/ var PDFAbstractReference = /*#__PURE__*/ function() {
                    function PDFAbstractReference() {
                        _classCallCheck(this, PDFAbstractReference);
                    }
                    _createClass(PDFAbstractReference, [
                        {
                            key: "toString",
                            value: function toString() {
                                throw new Error("Must be implemented by subclasses");
                            }
                        }
                    ]);
                    return PDFAbstractReference;
                }();
                var PDFTree = /*#__PURE__*/ function() {
                    function PDFTree() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        _classCallCheck(this, PDFTree);
                        this._items = {}; // disable /Limits output for this tree
                        this.limits = typeof options.limits === "boolean" ? options.limits : true;
                    }
                    _createClass(PDFTree, [
                        {
                            key: "add",
                            value: function add(key, val) {
                                return this._items[key] = val;
                            }
                        },
                        {
                            key: "get",
                            value: function get(key) {
                                return this._items[key];
                            }
                        },
                        {
                            key: "toString",
                            value: function toString() {
                                var _this = this;
                                // Needs to be sorted by key
                                var sortedKeys = Object.keys(this._items).sort(function(a, b) {
                                    return _this._compareKeys(a, b);
                                });
                                var out = [
                                    "<<"
                                ];
                                if (this.limits && sortedKeys.length > 1) {
                                    var first = sortedKeys[0], last = sortedKeys[sortedKeys.length - 1];
                                    out.push("  /Limits ".concat(PDFObject.convert([
                                        this._dataForKey(first),
                                        this._dataForKey(last)
                                    ])));
                                }
                                out.push("  /".concat(this._keysName(), " ["));
                                var _iterator = _createForOfIteratorHelper(sortedKeys), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var key = _step.value;
                                        out.push("    ".concat(PDFObject.convert(this._dataForKey(key)), " ").concat(PDFObject.convert(this._items[key])));
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                out.push("]");
                                out.push(">>");
                                return out.join("\n");
                            }
                        },
                        {
                            key: "_compareKeys",
                            value: function _compareKeys() /*a, b*/ {
                                throw new Error("Must be implemented by subclasses");
                            }
                        },
                        {
                            key: "_keysName",
                            value: function _keysName() {
                                throw new Error("Must be implemented by subclasses");
                            }
                        },
                        {
                            key: "_dataForKey",
                            value: function _dataForKey() /*k*/ {
                                throw new Error("Must be implemented by subclasses");
                            }
                        }
                    ]);
                    return PDFTree;
                }();
                var pad = function pad(str, length) {
                    return (Array(length + 1).join("0") + str).slice(-length);
                };
                var escapableRe = /[\n\r\t\b\f()\\]/g;
                var escapable = {
                    "\n": "\\n",
                    "\r": "\\r",
                    "	": "\\t",
                    "\b": "\\b",
                    "\f": "\\f",
                    "\\": "\\\\",
                    "(": "\\(",
                    ")": "\\)"
                }; // Convert little endian UTF-16 to big endian
                var swapBytes = function swapBytes(buff) {
                    var l = buff.length;
                    if (l & 0x01) throw new Error("Buffer length must be even");
                    else for(var i = 0, end = l - 1; i < end; i += 2){
                        var a = buff[i];
                        buff[i] = buff[i + 1];
                        buff[i + 1] = a;
                    }
                    return buff;
                };
                var PDFObject = /*#__PURE__*/ function() {
                    function PDFObject() {
                        _classCallCheck(this, PDFObject);
                    }
                    _createClass(PDFObject, null, [
                        {
                            key: "convert",
                            value: function convert(object) {
                                var encryptFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                // String literals are converted to the PDF name type
                                if (typeof object === "string") return "/".concat(object); // String objects are converted to PDF strings (UTF-16)
                                else if (object instanceof String) {
                                    var string = object; // Detect if this is a unicode string
                                    var isUnicode = false;
                                    for(var i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                                        isUnicode = true;
                                        break;
                                    }
                                     // If so, encode it as big endian UTF-16
                                    var stringBuffer;
                                    if (isUnicode) stringBuffer = swapBytes(Buffer.from("\uFEFF".concat(string), "utf16le"));
                                    else stringBuffer = Buffer.from(string.valueOf(), "ascii");
                                     // Encrypt the string when necessary
                                    if (encryptFn) string = encryptFn(stringBuffer).toString("binary");
                                    else string = stringBuffer.toString("binary");
                                     // Escape characters as required by the spec
                                    string = string.replace(escapableRe, function(c) {
                                        return escapable[c];
                                    });
                                    return "(".concat(string, ")"); // Buffers are converted to PDF hex strings
                                } else if (Buffer.isBuffer(object)) return "<".concat(object.toString("hex"), ">");
                                else if (object instanceof PDFAbstractReference || object instanceof PDFTree) return object.toString();
                                else if (object instanceof Date) {
                                    var _string = "D:".concat(pad(object.getUTCFullYear(), 4)) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + "Z"; // Encrypt the string when necessary
                                    if (encryptFn) {
                                        _string = encryptFn(Buffer.from(_string, "ascii")).toString("binary"); // Escape characters as required by the spec
                                        _string = _string.replace(escapableRe, function(c) {
                                            return escapable[c];
                                        });
                                    }
                                    return "(".concat(_string, ")");
                                } else if (Array.isArray(object)) {
                                    var items = object.map(function(e) {
                                        return PDFObject.convert(e, encryptFn);
                                    }).join(" ");
                                    return "[".concat(items, "]");
                                } else if (({}).toString.call(object) === "[object Object]") {
                                    var out = [
                                        "<<"
                                    ];
                                    for(var key in object){
                                        var val = object[key];
                                        out.push("/".concat(key, " ").concat(PDFObject.convert(val, encryptFn)));
                                    }
                                    out.push(">>");
                                    return out.join("\n");
                                } else if (typeof object === "number") return PDFObject.number(object);
                                else return "".concat(object);
                            }
                        },
                        {
                            key: "number",
                            value: function number(n) {
                                if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
                                throw new Error("unsupported number: ".concat(n));
                            }
                        }
                    ]);
                    return PDFObject;
                }();
                var PDFReference = /*#__PURE__*/ function(_PDFAbstractReference) {
                    _inherits(PDFReference, _PDFAbstractReference);
                    var _super = _createSuper(PDFReference);
                    function PDFReference(document1, id) {
                        var _this;
                        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        _classCallCheck(this, PDFReference);
                        _this = _super.call(this);
                        _this.document = document1;
                        _this.id = id;
                        _this.data = data;
                        _this.gen = 0;
                        _this.compress = _this.document.compress && !_this.data.Filter;
                        _this.uncompressedLength = 0;
                        _this.buffer = [];
                        return _this;
                    }
                    _createClass(PDFReference, [
                        {
                            key: "write",
                            value: function write(chunk) {
                                if (!Buffer.isBuffer(chunk)) chunk = Buffer.from(chunk + "\n", "binary");
                                this.uncompressedLength += chunk.length;
                                if (this.data.Length == null) this.data.Length = 0;
                                this.buffer.push(chunk);
                                this.data.Length += chunk.length;
                                if (this.compress) return this.data.Filter = "FlateDecode";
                            }
                        },
                        {
                            key: "end",
                            value: function end(chunk) {
                                if (chunk) this.write(chunk);
                                return this.finalize();
                            }
                        },
                        {
                            key: "finalize",
                            value: function finalize() {
                                this.offset = this.document._offset;
                                var encryptFn = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;
                                if (this.buffer.length) {
                                    this.buffer = Buffer.concat(this.buffer);
                                    if (this.compress) this.buffer = _zlib.default.deflateSync(this.buffer);
                                    if (encryptFn) this.buffer = encryptFn(this.buffer);
                                    this.data.Length = this.buffer.length;
                                }
                                this.document._write("".concat(this.id, " ").concat(this.gen, " obj"));
                                this.document._write(PDFObject.convert(this.data, encryptFn));
                                if (this.buffer.length) {
                                    this.document._write("stream");
                                    this.document._write(this.buffer);
                                    this.buffer = []; // free up memory
                                    this.document._write("\nendstream");
                                }
                                this.document._write("endobj");
                                this.document._refEnd(this);
                            }
                        },
                        {
                            key: "toString",
                            value: function toString() {
                                return "".concat(this.id, " ").concat(this.gen, " R");
                            }
                        }
                    ]);
                    return PDFReference;
                }(PDFAbstractReference);
                /*
PDFPage - represents a single page in the PDF document
By Devon Govett
*/ var DEFAULT_MARGINS = {
                    top: 72,
                    left: 72,
                    bottom: 72,
                    right: 72
                };
                var SIZES = {
                    "4A0": [
                        4767.87,
                        6740.79
                    ],
                    "2A0": [
                        3370.39,
                        4767.87
                    ],
                    A0: [
                        2383.94,
                        3370.39
                    ],
                    A1: [
                        1683.78,
                        2383.94
                    ],
                    A2: [
                        1190.55,
                        1683.78
                    ],
                    A3: [
                        841.89,
                        1190.55
                    ],
                    A4: [
                        595.28,
                        841.89
                    ],
                    A5: [
                        419.53,
                        595.28
                    ],
                    A6: [
                        297.64,
                        419.53
                    ],
                    A7: [
                        209.76,
                        297.64
                    ],
                    A8: [
                        147.4,
                        209.76
                    ],
                    A9: [
                        104.88,
                        147.4
                    ],
                    A10: [
                        73.7,
                        104.88
                    ],
                    B0: [
                        2834.65,
                        4008.19
                    ],
                    B1: [
                        2004.09,
                        2834.65
                    ],
                    B2: [
                        1417.32,
                        2004.09
                    ],
                    B3: [
                        1000.63,
                        1417.32
                    ],
                    B4: [
                        708.66,
                        1000.63
                    ],
                    B5: [
                        498.9,
                        708.66
                    ],
                    B6: [
                        354.33,
                        498.9
                    ],
                    B7: [
                        249.45,
                        354.33
                    ],
                    B8: [
                        175.75,
                        249.45
                    ],
                    B9: [
                        124.72,
                        175.75
                    ],
                    B10: [
                        87.87,
                        124.72
                    ],
                    C0: [
                        2599.37,
                        3676.54
                    ],
                    C1: [
                        1836.85,
                        2599.37
                    ],
                    C2: [
                        1298.27,
                        1836.85
                    ],
                    C3: [
                        918.43,
                        1298.27
                    ],
                    C4: [
                        649.13,
                        918.43
                    ],
                    C5: [
                        459.21,
                        649.13
                    ],
                    C6: [
                        323.15,
                        459.21
                    ],
                    C7: [
                        229.61,
                        323.15
                    ],
                    C8: [
                        161.57,
                        229.61
                    ],
                    C9: [
                        113.39,
                        161.57
                    ],
                    C10: [
                        79.37,
                        113.39
                    ],
                    RA0: [
                        2437.8,
                        3458.27
                    ],
                    RA1: [
                        1729.13,
                        2437.8
                    ],
                    RA2: [
                        1218.9,
                        1729.13
                    ],
                    RA3: [
                        864.57,
                        1218.9
                    ],
                    RA4: [
                        609.45,
                        864.57
                    ],
                    SRA0: [
                        2551.18,
                        3628.35
                    ],
                    SRA1: [
                        1814.17,
                        2551.18
                    ],
                    SRA2: [
                        1275.59,
                        1814.17
                    ],
                    SRA3: [
                        907.09,
                        1275.59
                    ],
                    SRA4: [
                        637.8,
                        907.09
                    ],
                    EXECUTIVE: [
                        521.86,
                        756.0
                    ],
                    FOLIO: [
                        612.0,
                        936.0
                    ],
                    LEGAL: [
                        612.0,
                        1008.0
                    ],
                    LETTER: [
                        612.0,
                        792.0
                    ],
                    TABLOID: [
                        792.0,
                        1224.0
                    ]
                };
                var PDFPage = /*#__PURE__*/ function() {
                    function PDFPage(document1) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _classCallCheck(this, PDFPage);
                        this.document = document1;
                        this.size = options.size || "letter";
                        this.layout = options.layout || "portrait"; // process margins
                        if (typeof options.margin === "number") this.margins = {
                            top: options.margin,
                            left: options.margin,
                            bottom: options.margin,
                            right: options.margin
                        }; // default to 1 inch margins
                        else this.margins = options.margins || DEFAULT_MARGINS;
                         // calculate page dimensions
                        var dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
                        this.width = dimensions[this.layout === "portrait" ? 0 : 1];
                        this.height = dimensions[this.layout === "portrait" ? 1 : 0];
                        this.content = this.document.ref(); // Initialize the Font, XObject, and ExtGState dictionaries
                        this.resources = this.document.ref({
                            ProcSet: [
                                "PDF",
                                "Text",
                                "ImageB",
                                "ImageC",
                                "ImageI"
                            ]
                        }); // The page dictionary
                        this.dictionary = this.document.ref({
                            Type: "Page",
                            Parent: this.document._root.data.Pages,
                            MediaBox: [
                                0,
                                0,
                                this.width,
                                this.height
                            ],
                            Contents: this.content,
                            Resources: this.resources
                        });
                        this.markings = [];
                    } // Lazily create these objects
                    _createClass(PDFPage, [
                        {
                            key: "maxY",
                            value: function maxY() {
                                return this.height - this.margins.bottom;
                            }
                        },
                        {
                            key: "write",
                            value: function write(chunk) {
                                return this.content.write(chunk);
                            }
                        },
                        {
                            key: "end",
                            value: function end() {
                                this.dictionary.end();
                                this.resources.end();
                                return this.content.end();
                            }
                        },
                        {
                            key: "fonts",
                            get: function get() {
                                var data = this.resources.data;
                                return data.Font != null ? data.Font : data.Font = {};
                            }
                        },
                        {
                            key: "xobjects",
                            get: function get() {
                                var data = this.resources.data;
                                return data.XObject != null ? data.XObject : data.XObject = {};
                            }
                        },
                        {
                            key: "ext_gstates",
                            get: function get() {
                                var data = this.resources.data;
                                return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
                            }
                        },
                        {
                            key: "patterns",
                            get: function get() {
                                var data = this.resources.data;
                                return data.Pattern != null ? data.Pattern : data.Pattern = {};
                            }
                        },
                        {
                            key: "colorSpaces",
                            get: function get() {
                                var data = this.resources.data;
                                return data.ColorSpace || (data.ColorSpace = {});
                            }
                        },
                        {
                            key: "annotations",
                            get: function get() {
                                var data = this.dictionary.data;
                                return data.Annots != null ? data.Annots : data.Annots = [];
                            }
                        },
                        {
                            key: "structParentTreeKey",
                            get: function get() {
                                var data = this.dictionary.data;
                                return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
                            }
                        }
                    ]);
                    return PDFPage;
                }();
                var PDFNameTree = /*#__PURE__*/ function(_PDFTree) {
                    _inherits(PDFNameTree, _PDFTree);
                    var _super = _createSuper(PDFNameTree);
                    function PDFNameTree() {
                        _classCallCheck(this, PDFNameTree);
                        return _super.apply(this, arguments);
                    }
                    _createClass(PDFNameTree, [
                        {
                            key: "_compareKeys",
                            value: function _compareKeys(a, b) {
                                return a.localeCompare(b);
                            }
                        },
                        {
                            key: "_keysName",
                            value: function _keysName() {
                                return "Names";
                            }
                        },
                        {
                            key: "_dataForKey",
                            value: function _dataForKey(k) {
                                return new String(k);
                            }
                        }
                    ]);
                    return PDFNameTree;
                }(PDFTree);
                /**
 * Check if value is in a range group.
 * @param {number} value
 * @param {number[]} rangeGroup
 * @returns {boolean}
 */ function inRange(value, rangeGroup) {
                    if (value < rangeGroup[0]) return false;
                    var startRange = 0;
                    var endRange = rangeGroup.length / 2;
                    while(startRange <= endRange){
                        var middleRange = Math.floor((startRange + endRange) / 2); // actual array index
                        var arrayIndex = middleRange * 2; // Check if value is in range pointed by actual index
                        if (value >= rangeGroup[arrayIndex] && value <= rangeGroup[arrayIndex + 1]) return true;
                        if (value > rangeGroup[arrayIndex + 1]) // Search Right Side Of Array
                        startRange = middleRange + 1;
                        else // Search Left Side Of Array
                        endRange = middleRange - 1;
                    }
                    return false;
                }
                /**
 * A.1 Unassigned code points in Unicode 3.2
 * @link https://tools.ietf.org/html/rfc3454#appendix-A.1
 */ var unassigned_code_points = [
                    0x0221,
                    0x0221,
                    0x0234,
                    0x024f,
                    0x02ae,
                    0x02af,
                    0x02ef,
                    0x02ff,
                    0x0350,
                    0x035f,
                    0x0370,
                    0x0373,
                    0x0376,
                    0x0379,
                    0x037b,
                    0x037d,
                    0x037f,
                    0x0383,
                    0x038b,
                    0x038b,
                    0x038d,
                    0x038d,
                    0x03a2,
                    0x03a2,
                    0x03cf,
                    0x03cf,
                    0x03f7,
                    0x03ff,
                    0x0487,
                    0x0487,
                    0x04cf,
                    0x04cf,
                    0x04f6,
                    0x04f7,
                    0x04fa,
                    0x04ff,
                    0x0510,
                    0x0530,
                    0x0557,
                    0x0558,
                    0x0560,
                    0x0560,
                    0x0588,
                    0x0588,
                    0x058b,
                    0x0590,
                    0x05a2,
                    0x05a2,
                    0x05ba,
                    0x05ba,
                    0x05c5,
                    0x05cf,
                    0x05eb,
                    0x05ef,
                    0x05f5,
                    0x060b,
                    0x060d,
                    0x061a,
                    0x061c,
                    0x061e,
                    0x0620,
                    0x0620,
                    0x063b,
                    0x063f,
                    0x0656,
                    0x065f,
                    0x06ee,
                    0x06ef,
                    0x06ff,
                    0x06ff,
                    0x070e,
                    0x070e,
                    0x072d,
                    0x072f,
                    0x074b,
                    0x077f,
                    0x07b2,
                    0x0900,
                    0x0904,
                    0x0904,
                    0x093a,
                    0x093b,
                    0x094e,
                    0x094f,
                    0x0955,
                    0x0957,
                    0x0971,
                    0x0980,
                    0x0984,
                    0x0984,
                    0x098d,
                    0x098e,
                    0x0991,
                    0x0992,
                    0x09a9,
                    0x09a9,
                    0x09b1,
                    0x09b1,
                    0x09b3,
                    0x09b5,
                    0x09ba,
                    0x09bb,
                    0x09bd,
                    0x09bd,
                    0x09c5,
                    0x09c6,
                    0x09c9,
                    0x09ca,
                    0x09ce,
                    0x09d6,
                    0x09d8,
                    0x09db,
                    0x09de,
                    0x09de,
                    0x09e4,
                    0x09e5,
                    0x09fb,
                    0x0a01,
                    0x0a03,
                    0x0a04,
                    0x0a0b,
                    0x0a0e,
                    0x0a11,
                    0x0a12,
                    0x0a29,
                    0x0a29,
                    0x0a31,
                    0x0a31,
                    0x0a34,
                    0x0a34,
                    0x0a37,
                    0x0a37,
                    0x0a3a,
                    0x0a3b,
                    0x0a3d,
                    0x0a3d,
                    0x0a43,
                    0x0a46,
                    0x0a49,
                    0x0a4a,
                    0x0a4e,
                    0x0a58,
                    0x0a5d,
                    0x0a5d,
                    0x0a5f,
                    0x0a65,
                    0x0a75,
                    0x0a80,
                    0x0a84,
                    0x0a84,
                    0x0a8c,
                    0x0a8c,
                    0x0a8e,
                    0x0a8e,
                    0x0a92,
                    0x0a92,
                    0x0aa9,
                    0x0aa9,
                    0x0ab1,
                    0x0ab1,
                    0x0ab4,
                    0x0ab4,
                    0x0aba,
                    0x0abb,
                    0x0ac6,
                    0x0ac6,
                    0x0aca,
                    0x0aca,
                    0x0ace,
                    0x0acf,
                    0x0ad1,
                    0x0adf,
                    0x0ae1,
                    0x0ae5,
                    0x0af0,
                    0x0b00,
                    0x0b04,
                    0x0b04,
                    0x0b0d,
                    0x0b0e,
                    0x0b11,
                    0x0b12,
                    0x0b29,
                    0x0b29,
                    0x0b31,
                    0x0b31,
                    0x0b34,
                    0x0b35,
                    0x0b3a,
                    0x0b3b,
                    0x0b44,
                    0x0b46,
                    0x0b49,
                    0x0b4a,
                    0x0b4e,
                    0x0b55,
                    0x0b58,
                    0x0b5b,
                    0x0b5e,
                    0x0b5e,
                    0x0b62,
                    0x0b65,
                    0x0b71,
                    0x0b81,
                    0x0b84,
                    0x0b84,
                    0x0b8b,
                    0x0b8d,
                    0x0b91,
                    0x0b91,
                    0x0b96,
                    0x0b98,
                    0x0b9b,
                    0x0b9b,
                    0x0b9d,
                    0x0b9d,
                    0x0ba0,
                    0x0ba2,
                    0x0ba5,
                    0x0ba7,
                    0x0bab,
                    0x0bad,
                    0x0bb6,
                    0x0bb6,
                    0x0bba,
                    0x0bbd,
                    0x0bc3,
                    0x0bc5,
                    0x0bc9,
                    0x0bc9,
                    0x0bce,
                    0x0bd6,
                    0x0bd8,
                    0x0be6,
                    0x0bf3,
                    0x0c00,
                    0x0c04,
                    0x0c04,
                    0x0c0d,
                    0x0c0d,
                    0x0c11,
                    0x0c11,
                    0x0c29,
                    0x0c29,
                    0x0c34,
                    0x0c34,
                    0x0c3a,
                    0x0c3d,
                    0x0c45,
                    0x0c45,
                    0x0c49,
                    0x0c49,
                    0x0c4e,
                    0x0c54,
                    0x0c57,
                    0x0c5f,
                    0x0c62,
                    0x0c65,
                    0x0c70,
                    0x0c81,
                    0x0c84,
                    0x0c84,
                    0x0c8d,
                    0x0c8d,
                    0x0c91,
                    0x0c91,
                    0x0ca9,
                    0x0ca9,
                    0x0cb4,
                    0x0cb4,
                    0x0cba,
                    0x0cbd,
                    0x0cc5,
                    0x0cc5,
                    0x0cc9,
                    0x0cc9,
                    0x0cce,
                    0x0cd4,
                    0x0cd7,
                    0x0cdd,
                    0x0cdf,
                    0x0cdf,
                    0x0ce2,
                    0x0ce5,
                    0x0cf0,
                    0x0d01,
                    0x0d04,
                    0x0d04,
                    0x0d0d,
                    0x0d0d,
                    0x0d11,
                    0x0d11,
                    0x0d29,
                    0x0d29,
                    0x0d3a,
                    0x0d3d,
                    0x0d44,
                    0x0d45,
                    0x0d49,
                    0x0d49,
                    0x0d4e,
                    0x0d56,
                    0x0d58,
                    0x0d5f,
                    0x0d62,
                    0x0d65,
                    0x0d70,
                    0x0d81,
                    0x0d84,
                    0x0d84,
                    0x0d97,
                    0x0d99,
                    0x0db2,
                    0x0db2,
                    0x0dbc,
                    0x0dbc,
                    0x0dbe,
                    0x0dbf,
                    0x0dc7,
                    0x0dc9,
                    0x0dcb,
                    0x0dce,
                    0x0dd5,
                    0x0dd5,
                    0x0dd7,
                    0x0dd7,
                    0x0de0,
                    0x0df1,
                    0x0df5,
                    0x0e00,
                    0x0e3b,
                    0x0e3e,
                    0x0e5c,
                    0x0e80,
                    0x0e83,
                    0x0e83,
                    0x0e85,
                    0x0e86,
                    0x0e89,
                    0x0e89,
                    0x0e8b,
                    0x0e8c,
                    0x0e8e,
                    0x0e93,
                    0x0e98,
                    0x0e98,
                    0x0ea0,
                    0x0ea0,
                    0x0ea4,
                    0x0ea4,
                    0x0ea6,
                    0x0ea6,
                    0x0ea8,
                    0x0ea9,
                    0x0eac,
                    0x0eac,
                    0x0eba,
                    0x0eba,
                    0x0ebe,
                    0x0ebf,
                    0x0ec5,
                    0x0ec5,
                    0x0ec7,
                    0x0ec7,
                    0x0ece,
                    0x0ecf,
                    0x0eda,
                    0x0edb,
                    0x0ede,
                    0x0eff,
                    0x0f48,
                    0x0f48,
                    0x0f6b,
                    0x0f70,
                    0x0f8c,
                    0x0f8f,
                    0x0f98,
                    0x0f98,
                    0x0fbd,
                    0x0fbd,
                    0x0fcd,
                    0x0fce,
                    0x0fd0,
                    0x0fff,
                    0x1022,
                    0x1022,
                    0x1028,
                    0x1028,
                    0x102b,
                    0x102b,
                    0x1033,
                    0x1035,
                    0x103a,
                    0x103f,
                    0x105a,
                    0x109f,
                    0x10c6,
                    0x10cf,
                    0x10f9,
                    0x10fa,
                    0x10fc,
                    0x10ff,
                    0x115a,
                    0x115e,
                    0x11a3,
                    0x11a7,
                    0x11fa,
                    0x11ff,
                    0x1207,
                    0x1207,
                    0x1247,
                    0x1247,
                    0x1249,
                    0x1249,
                    0x124e,
                    0x124f,
                    0x1257,
                    0x1257,
                    0x1259,
                    0x1259,
                    0x125e,
                    0x125f,
                    0x1287,
                    0x1287,
                    0x1289,
                    0x1289,
                    0x128e,
                    0x128f,
                    0x12af,
                    0x12af,
                    0x12b1,
                    0x12b1,
                    0x12b6,
                    0x12b7,
                    0x12bf,
                    0x12bf,
                    0x12c1,
                    0x12c1,
                    0x12c6,
                    0x12c7,
                    0x12cf,
                    0x12cf,
                    0x12d7,
                    0x12d7,
                    0x12ef,
                    0x12ef,
                    0x130f,
                    0x130f,
                    0x1311,
                    0x1311,
                    0x1316,
                    0x1317,
                    0x131f,
                    0x131f,
                    0x1347,
                    0x1347,
                    0x135b,
                    0x1360,
                    0x137d,
                    0x139f,
                    0x13f5,
                    0x1400,
                    0x1677,
                    0x167f,
                    0x169d,
                    0x169f,
                    0x16f1,
                    0x16ff,
                    0x170d,
                    0x170d,
                    0x1715,
                    0x171f,
                    0x1737,
                    0x173f,
                    0x1754,
                    0x175f,
                    0x176d,
                    0x176d,
                    0x1771,
                    0x1771,
                    0x1774,
                    0x177f,
                    0x17dd,
                    0x17df,
                    0x17ea,
                    0x17ff,
                    0x180f,
                    0x180f,
                    0x181a,
                    0x181f,
                    0x1878,
                    0x187f,
                    0x18aa,
                    0x1dff,
                    0x1e9c,
                    0x1e9f,
                    0x1efa,
                    0x1eff,
                    0x1f16,
                    0x1f17,
                    0x1f1e,
                    0x1f1f,
                    0x1f46,
                    0x1f47,
                    0x1f4e,
                    0x1f4f,
                    0x1f58,
                    0x1f58,
                    0x1f5a,
                    0x1f5a,
                    0x1f5c,
                    0x1f5c,
                    0x1f5e,
                    0x1f5e,
                    0x1f7e,
                    0x1f7f,
                    0x1fb5,
                    0x1fb5,
                    0x1fc5,
                    0x1fc5,
                    0x1fd4,
                    0x1fd5,
                    0x1fdc,
                    0x1fdc,
                    0x1ff0,
                    0x1ff1,
                    0x1ff5,
                    0x1ff5,
                    0x1fff,
                    0x1fff,
                    0x2053,
                    0x2056,
                    0x2058,
                    0x205e,
                    0x2064,
                    0x2069,
                    0x2072,
                    0x2073,
                    0x208f,
                    0x209f,
                    0x20b2,
                    0x20cf,
                    0x20eb,
                    0x20ff,
                    0x213b,
                    0x213c,
                    0x214c,
                    0x2152,
                    0x2184,
                    0x218f,
                    0x23cf,
                    0x23ff,
                    0x2427,
                    0x243f,
                    0x244b,
                    0x245f,
                    0x24ff,
                    0x24ff,
                    0x2614,
                    0x2615,
                    0x2618,
                    0x2618,
                    0x267e,
                    0x267f,
                    0x268a,
                    0x2700,
                    0x2705,
                    0x2705,
                    0x270a,
                    0x270b,
                    0x2728,
                    0x2728,
                    0x274c,
                    0x274c,
                    0x274e,
                    0x274e,
                    0x2753,
                    0x2755,
                    0x2757,
                    0x2757,
                    0x275f,
                    0x2760,
                    0x2795,
                    0x2797,
                    0x27b0,
                    0x27b0,
                    0x27bf,
                    0x27cf,
                    0x27ec,
                    0x27ef,
                    0x2b00,
                    0x2e7f,
                    0x2e9a,
                    0x2e9a,
                    0x2ef4,
                    0x2eff,
                    0x2fd6,
                    0x2fef,
                    0x2ffc,
                    0x2fff,
                    0x3040,
                    0x3040,
                    0x3097,
                    0x3098,
                    0x3100,
                    0x3104,
                    0x312d,
                    0x3130,
                    0x318f,
                    0x318f,
                    0x31b8,
                    0x31ef,
                    0x321d,
                    0x321f,
                    0x3244,
                    0x3250,
                    0x327c,
                    0x327e,
                    0x32cc,
                    0x32cf,
                    0x32ff,
                    0x32ff,
                    0x3377,
                    0x337a,
                    0x33de,
                    0x33df,
                    0x33ff,
                    0x33ff,
                    0x4db6,
                    0x4dff,
                    0x9fa6,
                    0x9fff,
                    0xa48d,
                    0xa48f,
                    0xa4c7,
                    0xabff,
                    0xd7a4,
                    0xd7ff,
                    0xfa2e,
                    0xfa2f,
                    0xfa6b,
                    0xfaff,
                    0xfb07,
                    0xfb12,
                    0xfb18,
                    0xfb1c,
                    0xfb37,
                    0xfb37,
                    0xfb3d,
                    0xfb3d,
                    0xfb3f,
                    0xfb3f,
                    0xfb42,
                    0xfb42,
                    0xfb45,
                    0xfb45,
                    0xfbb2,
                    0xfbd2,
                    0xfd40,
                    0xfd4f,
                    0xfd90,
                    0xfd91,
                    0xfdc8,
                    0xfdcf,
                    0xfdfd,
                    0xfdff,
                    0xfe10,
                    0xfe1f,
                    0xfe24,
                    0xfe2f,
                    0xfe47,
                    0xfe48,
                    0xfe53,
                    0xfe53,
                    0xfe67,
                    0xfe67,
                    0xfe6c,
                    0xfe6f,
                    0xfe75,
                    0xfe75,
                    0xfefd,
                    0xfefe,
                    0xff00,
                    0xff00,
                    0xffbf,
                    0xffc1,
                    0xffc8,
                    0xffc9,
                    0xffd0,
                    0xffd1,
                    0xffd8,
                    0xffd9,
                    0xffdd,
                    0xffdf,
                    0xffe7,
                    0xffe7,
                    0xffef,
                    0xfff8,
                    0x10000,
                    0x102ff,
                    0x1031f,
                    0x1031f,
                    0x10324,
                    0x1032f,
                    0x1034b,
                    0x103ff,
                    0x10426,
                    0x10427,
                    0x1044e,
                    0x1cfff,
                    0x1d0f6,
                    0x1d0ff,
                    0x1d127,
                    0x1d129,
                    0x1d1de,
                    0x1d3ff,
                    0x1d455,
                    0x1d455,
                    0x1d49d,
                    0x1d49d,
                    0x1d4a0,
                    0x1d4a1,
                    0x1d4a3,
                    0x1d4a4,
                    0x1d4a7,
                    0x1d4a8,
                    0x1d4ad,
                    0x1d4ad,
                    0x1d4ba,
                    0x1d4ba,
                    0x1d4bc,
                    0x1d4bc,
                    0x1d4c1,
                    0x1d4c1,
                    0x1d4c4,
                    0x1d4c4,
                    0x1d506,
                    0x1d506,
                    0x1d50b,
                    0x1d50c,
                    0x1d515,
                    0x1d515,
                    0x1d51d,
                    0x1d51d,
                    0x1d53a,
                    0x1d53a,
                    0x1d53f,
                    0x1d53f,
                    0x1d545,
                    0x1d545,
                    0x1d547,
                    0x1d549,
                    0x1d551,
                    0x1d551,
                    0x1d6a4,
                    0x1d6a7,
                    0x1d7ca,
                    0x1d7cd,
                    0x1d800,
                    0x1fffd,
                    0x2a6d7,
                    0x2f7ff,
                    0x2fa1e,
                    0x2fffd,
                    0x30000,
                    0x3fffd,
                    0x40000,
                    0x4fffd,
                    0x50000,
                    0x5fffd,
                    0x60000,
                    0x6fffd,
                    0x70000,
                    0x7fffd,
                    0x80000,
                    0x8fffd,
                    0x90000,
                    0x9fffd,
                    0xa0000,
                    0xafffd,
                    0xb0000,
                    0xbfffd,
                    0xc0000,
                    0xcfffd,
                    0xd0000,
                    0xdfffd,
                    0xe0000,
                    0xe0000,
                    0xe0002,
                    0xe001f,
                    0xe0080,
                    0xefffd
                ]; // prettier-ignore-end
                var isUnassignedCodePoint = function isUnassignedCodePoint(character) {
                    return inRange(character, unassigned_code_points);
                }; // prettier-ignore-start
                /**
 * B.1 Commonly mapped to nothing
 * @link https://tools.ietf.org/html/rfc3454#appendix-B.1
 */ var commonly_mapped_to_nothing = [
                    0x00ad,
                    0x00ad,
                    0x034f,
                    0x034f,
                    0x1806,
                    0x1806,
                    0x180b,
                    0x180b,
                    0x180c,
                    0x180c,
                    0x180d,
                    0x180d,
                    0x200b,
                    0x200b,
                    0x200c,
                    0x200c,
                    0x200d,
                    0x200d,
                    0x2060,
                    0x2060,
                    0xfe00,
                    0xfe00,
                    0xfe01,
                    0xfe01,
                    0xfe02,
                    0xfe02,
                    0xfe03,
                    0xfe03,
                    0xfe04,
                    0xfe04,
                    0xfe05,
                    0xfe05,
                    0xfe06,
                    0xfe06,
                    0xfe07,
                    0xfe07,
                    0xfe08,
                    0xfe08,
                    0xfe09,
                    0xfe09,
                    0xfe0a,
                    0xfe0a,
                    0xfe0b,
                    0xfe0b,
                    0xfe0c,
                    0xfe0c,
                    0xfe0d,
                    0xfe0d,
                    0xfe0e,
                    0xfe0e,
                    0xfe0f,
                    0xfe0f,
                    0xfeff,
                    0xfeff
                ]; // prettier-ignore-end
                var isCommonlyMappedToNothing = function isCommonlyMappedToNothing(character) {
                    return inRange(character, commonly_mapped_to_nothing);
                }; // prettier-ignore-start
                /**
 * C.1.2 Non-ASCII space characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.1.2
 */ var non_ASCII_space_characters = [
                    0x00a0,
                    0x00a0,
                    0x1680,
                    0x1680,
                    0x2000,
                    0x2000,
                    0x2001,
                    0x2001,
                    0x2002,
                    0x2002,
                    0x2003,
                    0x2003,
                    0x2004,
                    0x2004,
                    0x2005,
                    0x2005,
                    0x2006,
                    0x2006,
                    0x2007,
                    0x2007,
                    0x2008,
                    0x2008,
                    0x2009,
                    0x2009,
                    0x200a,
                    0x200a,
                    0x200b,
                    0x200b,
                    0x202f,
                    0x202f,
                    0x205f,
                    0x205f,
                    0x3000,
                    0x3000
                ]; // prettier-ignore-end
                var isNonASCIISpaceCharacter = function isNonASCIISpaceCharacter(character) {
                    return inRange(character, non_ASCII_space_characters);
                }; // prettier-ignore-start
                var non_ASCII_controls_characters = [
                    /**
 * C.2.2 Non-ASCII control characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.2
 */ 0x0080,
                    0x009f,
                    0x06dd,
                    0x06dd,
                    0x070f,
                    0x070f,
                    0x180e,
                    0x180e,
                    0x200c,
                    0x200c,
                    0x200d,
                    0x200d,
                    0x2028,
                    0x2028,
                    0x2029,
                    0x2029,
                    0x2060,
                    0x2060,
                    0x2061,
                    0x2061,
                    0x2062,
                    0x2062,
                    0x2063,
                    0x2063,
                    0x206a,
                    0x206f,
                    0xfeff,
                    0xfeff,
                    0xfff9,
                    0xfffc,
                    0x1d173,
                    0x1d17a
                ];
                var non_character_codepoints = [
                    /**
 * C.4 Non-character code points
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.4
 */ 0xfdd0,
                    0xfdef,
                    0xfffe,
                    0xffff,
                    0x1fffe,
                    0x1ffff,
                    0x2fffe,
                    0x2ffff,
                    0x3fffe,
                    0x3ffff,
                    0x4fffe,
                    0x4ffff,
                    0x5fffe,
                    0x5ffff,
                    0x6fffe,
                    0x6ffff,
                    0x7fffe,
                    0x7ffff,
                    0x8fffe,
                    0x8ffff,
                    0x9fffe,
                    0x9ffff,
                    0xafffe,
                    0xaffff,
                    0xbfffe,
                    0xbffff,
                    0xcfffe,
                    0xcffff,
                    0xdfffe,
                    0xdffff,
                    0xefffe,
                    0xeffff,
                    0x10fffe,
                    0x10ffff
                ];
                /**
 * 2.3.  Prohibited Output
 */ var prohibited_characters = [
                    /**
 * C.2.1 ASCII control characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.1
 */ 0,
                    0x001f,
                    0x007f,
                    0x007f,
                    /**
 * C.8 Change display properties or are deprecated
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.8
 */ 0x0340,
                    0x0340,
                    0x0341,
                    0x0341,
                    0x200e,
                    0x200e,
                    0x200f,
                    0x200f,
                    0x202a,
                    0x202a,
                    0x202b,
                    0x202b,
                    0x202c,
                    0x202c,
                    0x202d,
                    0x202d,
                    0x202e,
                    0x202e,
                    0x206a,
                    0x206a,
                    0x206b,
                    0x206b,
                    0x206c,
                    0x206c,
                    0x206d,
                    0x206d,
                    0x206e,
                    0x206e,
                    0x206f,
                    0x206f,
                    /**
 * C.7 Inappropriate for canonical representation
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.7
 */ 0x2ff0,
                    0x2ffb,
                    /**
 * C.5 Surrogate codes
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.5
 */ 0xd800,
                    0xdfff,
                    /**
 * C.3 Private use
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
 */ 0xe000,
                    0xf8ff,
                    /**
 * C.6 Inappropriate for plain text
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.6
 */ 0xfff9,
                    0xfff9,
                    0xfffa,
                    0xfffa,
                    0xfffb,
                    0xfffb,
                    0xfffc,
                    0xfffc,
                    0xfffd,
                    0xfffd,
                    /**
 * C.9 Tagging characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.9
 */ 0xe0001,
                    0xe0001,
                    0xe0020,
                    0xe007f,
                    /**
 * C.3 Private use
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
 */ 0xf0000,
                    0xffffd,
                    0x100000,
                    0x10fffd
                ]; // prettier-ignore-end
                var isProhibitedCharacter = function isProhibitedCharacter(character) {
                    return inRange(character, non_ASCII_space_characters) || inRange(character, prohibited_characters) || inRange(character, non_ASCII_controls_characters) || inRange(character, non_character_codepoints);
                }; // prettier-ignore-start
                /**
 * D.1 Characters with bidirectional property "R" or "AL"
 * @link https://tools.ietf.org/html/rfc3454#appendix-D.1
 */ var bidirectional_r_al = [
                    0x05be,
                    0x05be,
                    0x05c0,
                    0x05c0,
                    0x05c3,
                    0x05c3,
                    0x05d0,
                    0x05ea,
                    0x05f0,
                    0x05f4,
                    0x061b,
                    0x061b,
                    0x061f,
                    0x061f,
                    0x0621,
                    0x063a,
                    0x0640,
                    0x064a,
                    0x066d,
                    0x066f,
                    0x0671,
                    0x06d5,
                    0x06dd,
                    0x06dd,
                    0x06e5,
                    0x06e6,
                    0x06fa,
                    0x06fe,
                    0x0700,
                    0x070d,
                    0x0710,
                    0x0710,
                    0x0712,
                    0x072c,
                    0x0780,
                    0x07a5,
                    0x07b1,
                    0x07b1,
                    0x200f,
                    0x200f,
                    0xfb1d,
                    0xfb1d,
                    0xfb1f,
                    0xfb28,
                    0xfb2a,
                    0xfb36,
                    0xfb38,
                    0xfb3c,
                    0xfb3e,
                    0xfb3e,
                    0xfb40,
                    0xfb41,
                    0xfb43,
                    0xfb44,
                    0xfb46,
                    0xfbb1,
                    0xfbd3,
                    0xfd3d,
                    0xfd50,
                    0xfd8f,
                    0xfd92,
                    0xfdc7,
                    0xfdf0,
                    0xfdfc,
                    0xfe70,
                    0xfe74,
                    0xfe76,
                    0xfefc
                ]; // prettier-ignore-end
                var isBidirectionalRAL = function isBidirectionalRAL(character) {
                    return inRange(character, bidirectional_r_al);
                }; // prettier-ignore-start
                /**
 * D.2 Characters with bidirectional property "L"
 * @link https://tools.ietf.org/html/rfc3454#appendix-D.2
 */ var bidirectional_l = [
                    0x0041,
                    0x005a,
                    0x0061,
                    0x007a,
                    0x00aa,
                    0x00aa,
                    0x00b5,
                    0x00b5,
                    0x00ba,
                    0x00ba,
                    0x00c0,
                    0x00d6,
                    0x00d8,
                    0x00f6,
                    0x00f8,
                    0x0220,
                    0x0222,
                    0x0233,
                    0x0250,
                    0x02ad,
                    0x02b0,
                    0x02b8,
                    0x02bb,
                    0x02c1,
                    0x02d0,
                    0x02d1,
                    0x02e0,
                    0x02e4,
                    0x02ee,
                    0x02ee,
                    0x037a,
                    0x037a,
                    0x0386,
                    0x0386,
                    0x0388,
                    0x038a,
                    0x038c,
                    0x038c,
                    0x038e,
                    0x03a1,
                    0x03a3,
                    0x03ce,
                    0x03d0,
                    0x03f5,
                    0x0400,
                    0x0482,
                    0x048a,
                    0x04ce,
                    0x04d0,
                    0x04f5,
                    0x04f8,
                    0x04f9,
                    0x0500,
                    0x050f,
                    0x0531,
                    0x0556,
                    0x0559,
                    0x055f,
                    0x0561,
                    0x0587,
                    0x0589,
                    0x0589,
                    0x0903,
                    0x0903,
                    0x0905,
                    0x0939,
                    0x093d,
                    0x0940,
                    0x0949,
                    0x094c,
                    0x0950,
                    0x0950,
                    0x0958,
                    0x0961,
                    0x0964,
                    0x0970,
                    0x0982,
                    0x0983,
                    0x0985,
                    0x098c,
                    0x098f,
                    0x0990,
                    0x0993,
                    0x09a8,
                    0x09aa,
                    0x09b0,
                    0x09b2,
                    0x09b2,
                    0x09b6,
                    0x09b9,
                    0x09be,
                    0x09c0,
                    0x09c7,
                    0x09c8,
                    0x09cb,
                    0x09cc,
                    0x09d7,
                    0x09d7,
                    0x09dc,
                    0x09dd,
                    0x09df,
                    0x09e1,
                    0x09e6,
                    0x09f1,
                    0x09f4,
                    0x09fa,
                    0x0a05,
                    0x0a0a,
                    0x0a0f,
                    0x0a10,
                    0x0a13,
                    0x0a28,
                    0x0a2a,
                    0x0a30,
                    0x0a32,
                    0x0a33,
                    0x0a35,
                    0x0a36,
                    0x0a38,
                    0x0a39,
                    0x0a3e,
                    0x0a40,
                    0x0a59,
                    0x0a5c,
                    0x0a5e,
                    0x0a5e,
                    0x0a66,
                    0x0a6f,
                    0x0a72,
                    0x0a74,
                    0x0a83,
                    0x0a83,
                    0x0a85,
                    0x0a8b,
                    0x0a8d,
                    0x0a8d,
                    0x0a8f,
                    0x0a91,
                    0x0a93,
                    0x0aa8,
                    0x0aaa,
                    0x0ab0,
                    0x0ab2,
                    0x0ab3,
                    0x0ab5,
                    0x0ab9,
                    0x0abd,
                    0x0ac0,
                    0x0ac9,
                    0x0ac9,
                    0x0acb,
                    0x0acc,
                    0x0ad0,
                    0x0ad0,
                    0x0ae0,
                    0x0ae0,
                    0x0ae6,
                    0x0aef,
                    0x0b02,
                    0x0b03,
                    0x0b05,
                    0x0b0c,
                    0x0b0f,
                    0x0b10,
                    0x0b13,
                    0x0b28,
                    0x0b2a,
                    0x0b30,
                    0x0b32,
                    0x0b33,
                    0x0b36,
                    0x0b39,
                    0x0b3d,
                    0x0b3e,
                    0x0b40,
                    0x0b40,
                    0x0b47,
                    0x0b48,
                    0x0b4b,
                    0x0b4c,
                    0x0b57,
                    0x0b57,
                    0x0b5c,
                    0x0b5d,
                    0x0b5f,
                    0x0b61,
                    0x0b66,
                    0x0b70,
                    0x0b83,
                    0x0b83,
                    0x0b85,
                    0x0b8a,
                    0x0b8e,
                    0x0b90,
                    0x0b92,
                    0x0b95,
                    0x0b99,
                    0x0b9a,
                    0x0b9c,
                    0x0b9c,
                    0x0b9e,
                    0x0b9f,
                    0x0ba3,
                    0x0ba4,
                    0x0ba8,
                    0x0baa,
                    0x0bae,
                    0x0bb5,
                    0x0bb7,
                    0x0bb9,
                    0x0bbe,
                    0x0bbf,
                    0x0bc1,
                    0x0bc2,
                    0x0bc6,
                    0x0bc8,
                    0x0bca,
                    0x0bcc,
                    0x0bd7,
                    0x0bd7,
                    0x0be7,
                    0x0bf2,
                    0x0c01,
                    0x0c03,
                    0x0c05,
                    0x0c0c,
                    0x0c0e,
                    0x0c10,
                    0x0c12,
                    0x0c28,
                    0x0c2a,
                    0x0c33,
                    0x0c35,
                    0x0c39,
                    0x0c41,
                    0x0c44,
                    0x0c60,
                    0x0c61,
                    0x0c66,
                    0x0c6f,
                    0x0c82,
                    0x0c83,
                    0x0c85,
                    0x0c8c,
                    0x0c8e,
                    0x0c90,
                    0x0c92,
                    0x0ca8,
                    0x0caa,
                    0x0cb3,
                    0x0cb5,
                    0x0cb9,
                    0x0cbe,
                    0x0cbe,
                    0x0cc0,
                    0x0cc4,
                    0x0cc7,
                    0x0cc8,
                    0x0cca,
                    0x0ccb,
                    0x0cd5,
                    0x0cd6,
                    0x0cde,
                    0x0cde,
                    0x0ce0,
                    0x0ce1,
                    0x0ce6,
                    0x0cef,
                    0x0d02,
                    0x0d03,
                    0x0d05,
                    0x0d0c,
                    0x0d0e,
                    0x0d10,
                    0x0d12,
                    0x0d28,
                    0x0d2a,
                    0x0d39,
                    0x0d3e,
                    0x0d40,
                    0x0d46,
                    0x0d48,
                    0x0d4a,
                    0x0d4c,
                    0x0d57,
                    0x0d57,
                    0x0d60,
                    0x0d61,
                    0x0d66,
                    0x0d6f,
                    0x0d82,
                    0x0d83,
                    0x0d85,
                    0x0d96,
                    0x0d9a,
                    0x0db1,
                    0x0db3,
                    0x0dbb,
                    0x0dbd,
                    0x0dbd,
                    0x0dc0,
                    0x0dc6,
                    0x0dcf,
                    0x0dd1,
                    0x0dd8,
                    0x0ddf,
                    0x0df2,
                    0x0df4,
                    0x0e01,
                    0x0e30,
                    0x0e32,
                    0x0e33,
                    0x0e40,
                    0x0e46,
                    0x0e4f,
                    0x0e5b,
                    0x0e81,
                    0x0e82,
                    0x0e84,
                    0x0e84,
                    0x0e87,
                    0x0e88,
                    0x0e8a,
                    0x0e8a,
                    0x0e8d,
                    0x0e8d,
                    0x0e94,
                    0x0e97,
                    0x0e99,
                    0x0e9f,
                    0x0ea1,
                    0x0ea3,
                    0x0ea5,
                    0x0ea5,
                    0x0ea7,
                    0x0ea7,
                    0x0eaa,
                    0x0eab,
                    0x0ead,
                    0x0eb0,
                    0x0eb2,
                    0x0eb3,
                    0x0ebd,
                    0x0ebd,
                    0x0ec0,
                    0x0ec4,
                    0x0ec6,
                    0x0ec6,
                    0x0ed0,
                    0x0ed9,
                    0x0edc,
                    0x0edd,
                    0x0f00,
                    0x0f17,
                    0x0f1a,
                    0x0f34,
                    0x0f36,
                    0x0f36,
                    0x0f38,
                    0x0f38,
                    0x0f3e,
                    0x0f47,
                    0x0f49,
                    0x0f6a,
                    0x0f7f,
                    0x0f7f,
                    0x0f85,
                    0x0f85,
                    0x0f88,
                    0x0f8b,
                    0x0fbe,
                    0x0fc5,
                    0x0fc7,
                    0x0fcc,
                    0x0fcf,
                    0x0fcf,
                    0x1000,
                    0x1021,
                    0x1023,
                    0x1027,
                    0x1029,
                    0x102a,
                    0x102c,
                    0x102c,
                    0x1031,
                    0x1031,
                    0x1038,
                    0x1038,
                    0x1040,
                    0x1057,
                    0x10a0,
                    0x10c5,
                    0x10d0,
                    0x10f8,
                    0x10fb,
                    0x10fb,
                    0x1100,
                    0x1159,
                    0x115f,
                    0x11a2,
                    0x11a8,
                    0x11f9,
                    0x1200,
                    0x1206,
                    0x1208,
                    0x1246,
                    0x1248,
                    0x1248,
                    0x124a,
                    0x124d,
                    0x1250,
                    0x1256,
                    0x1258,
                    0x1258,
                    0x125a,
                    0x125d,
                    0x1260,
                    0x1286,
                    0x1288,
                    0x1288,
                    0x128a,
                    0x128d,
                    0x1290,
                    0x12ae,
                    0x12b0,
                    0x12b0,
                    0x12b2,
                    0x12b5,
                    0x12b8,
                    0x12be,
                    0x12c0,
                    0x12c0,
                    0x12c2,
                    0x12c5,
                    0x12c8,
                    0x12ce,
                    0x12d0,
                    0x12d6,
                    0x12d8,
                    0x12ee,
                    0x12f0,
                    0x130e,
                    0x1310,
                    0x1310,
                    0x1312,
                    0x1315,
                    0x1318,
                    0x131e,
                    0x1320,
                    0x1346,
                    0x1348,
                    0x135a,
                    0x1361,
                    0x137c,
                    0x13a0,
                    0x13f4,
                    0x1401,
                    0x1676,
                    0x1681,
                    0x169a,
                    0x16a0,
                    0x16f0,
                    0x1700,
                    0x170c,
                    0x170e,
                    0x1711,
                    0x1720,
                    0x1731,
                    0x1735,
                    0x1736,
                    0x1740,
                    0x1751,
                    0x1760,
                    0x176c,
                    0x176e,
                    0x1770,
                    0x1780,
                    0x17b6,
                    0x17be,
                    0x17c5,
                    0x17c7,
                    0x17c8,
                    0x17d4,
                    0x17da,
                    0x17dc,
                    0x17dc,
                    0x17e0,
                    0x17e9,
                    0x1810,
                    0x1819,
                    0x1820,
                    0x1877,
                    0x1880,
                    0x18a8,
                    0x1e00,
                    0x1e9b,
                    0x1ea0,
                    0x1ef9,
                    0x1f00,
                    0x1f15,
                    0x1f18,
                    0x1f1d,
                    0x1f20,
                    0x1f45,
                    0x1f48,
                    0x1f4d,
                    0x1f50,
                    0x1f57,
                    0x1f59,
                    0x1f59,
                    0x1f5b,
                    0x1f5b,
                    0x1f5d,
                    0x1f5d,
                    0x1f5f,
                    0x1f7d,
                    0x1f80,
                    0x1fb4,
                    0x1fb6,
                    0x1fbc,
                    0x1fbe,
                    0x1fbe,
                    0x1fc2,
                    0x1fc4,
                    0x1fc6,
                    0x1fcc,
                    0x1fd0,
                    0x1fd3,
                    0x1fd6,
                    0x1fdb,
                    0x1fe0,
                    0x1fec,
                    0x1ff2,
                    0x1ff4,
                    0x1ff6,
                    0x1ffc,
                    0x200e,
                    0x200e,
                    0x2071,
                    0x2071,
                    0x207f,
                    0x207f,
                    0x2102,
                    0x2102,
                    0x2107,
                    0x2107,
                    0x210a,
                    0x2113,
                    0x2115,
                    0x2115,
                    0x2119,
                    0x211d,
                    0x2124,
                    0x2124,
                    0x2126,
                    0x2126,
                    0x2128,
                    0x2128,
                    0x212a,
                    0x212d,
                    0x212f,
                    0x2131,
                    0x2133,
                    0x2139,
                    0x213d,
                    0x213f,
                    0x2145,
                    0x2149,
                    0x2160,
                    0x2183,
                    0x2336,
                    0x237a,
                    0x2395,
                    0x2395,
                    0x249c,
                    0x24e9,
                    0x3005,
                    0x3007,
                    0x3021,
                    0x3029,
                    0x3031,
                    0x3035,
                    0x3038,
                    0x303c,
                    0x3041,
                    0x3096,
                    0x309d,
                    0x309f,
                    0x30a1,
                    0x30fa,
                    0x30fc,
                    0x30ff,
                    0x3105,
                    0x312c,
                    0x3131,
                    0x318e,
                    0x3190,
                    0x31b7,
                    0x31f0,
                    0x321c,
                    0x3220,
                    0x3243,
                    0x3260,
                    0x327b,
                    0x327f,
                    0x32b0,
                    0x32c0,
                    0x32cb,
                    0x32d0,
                    0x32fe,
                    0x3300,
                    0x3376,
                    0x337b,
                    0x33dd,
                    0x33e0,
                    0x33fe,
                    0x3400,
                    0x4db5,
                    0x4e00,
                    0x9fa5,
                    0xa000,
                    0xa48c,
                    0xac00,
                    0xd7a3,
                    0xd800,
                    0xfa2d,
                    0xfa30,
                    0xfa6a,
                    0xfb00,
                    0xfb06,
                    0xfb13,
                    0xfb17,
                    0xff21,
                    0xff3a,
                    0xff41,
                    0xff5a,
                    0xff66,
                    0xffbe,
                    0xffc2,
                    0xffc7,
                    0xffca,
                    0xffcf,
                    0xffd2,
                    0xffd7,
                    0xffda,
                    0xffdc,
                    0x10300,
                    0x1031e,
                    0x10320,
                    0x10323,
                    0x10330,
                    0x1034a,
                    0x10400,
                    0x10425,
                    0x10428,
                    0x1044d,
                    0x1d000,
                    0x1d0f5,
                    0x1d100,
                    0x1d126,
                    0x1d12a,
                    0x1d166,
                    0x1d16a,
                    0x1d172,
                    0x1d183,
                    0x1d184,
                    0x1d18c,
                    0x1d1a9,
                    0x1d1ae,
                    0x1d1dd,
                    0x1d400,
                    0x1d454,
                    0x1d456,
                    0x1d49c,
                    0x1d49e,
                    0x1d49f,
                    0x1d4a2,
                    0x1d4a2,
                    0x1d4a5,
                    0x1d4a6,
                    0x1d4a9,
                    0x1d4ac,
                    0x1d4ae,
                    0x1d4b9,
                    0x1d4bb,
                    0x1d4bb,
                    0x1d4bd,
                    0x1d4c0,
                    0x1d4c2,
                    0x1d4c3,
                    0x1d4c5,
                    0x1d505,
                    0x1d507,
                    0x1d50a,
                    0x1d50d,
                    0x1d514,
                    0x1d516,
                    0x1d51c,
                    0x1d51e,
                    0x1d539,
                    0x1d53b,
                    0x1d53e,
                    0x1d540,
                    0x1d544,
                    0x1d546,
                    0x1d546,
                    0x1d54a,
                    0x1d550,
                    0x1d552,
                    0x1d6a3,
                    0x1d6a8,
                    0x1d7c9,
                    0x20000,
                    0x2a6d6,
                    0x2f800,
                    0x2fa1d,
                    0xf0000,
                    0xffffd,
                    0x100000,
                    0x10fffd
                ]; // prettier-ignore-end
                var isBidirectionalL = function isBidirectionalL(character) {
                    return inRange(character, bidirectional_l);
                };
                /**
 * non-ASCII space characters [StringPrep, C.1.2] that can be
 * mapped to SPACE (U+0020)
 */ var mapping2space = isNonASCIISpaceCharacter;
                /**
 * the "commonly mapped to nothing" characters [StringPrep, B.1]
 * that can be mapped to nothing.
 */ var mapping2nothing = isCommonlyMappedToNothing; // utils
                var getCodePoint = function getCodePoint(character) {
                    return character.codePointAt(0);
                };
                var first = function first(x) {
                    return x[0];
                };
                var last = function last(x) {
                    return x[x.length - 1];
                };
                /**
 * Convert provided string into an array of Unicode Code Points.
 * Based on https://stackoverflow.com/a/21409165/1556249
 * and https://www.npmjs.com/package/code-point-at.
 * @param {string} input
 * @returns {number[]}
 */ function toCodePoints(input) {
                    var codepoints = [];
                    var size = input.length;
                    for(var i = 0; i < size; i += 1){
                        var before = input.charCodeAt(i);
                        if (before >= 0xd800 && before <= 0xdbff && size > i + 1) {
                            var next = input.charCodeAt(i + 1);
                            if (next >= 0xdc00 && next <= 0xdfff) {
                                codepoints.push((before - 0xd800) * 0x400 + next - 0xdc00 + 0x10000);
                                i += 1;
                                continue;
                            }
                        }
                        codepoints.push(before);
                    }
                    return codepoints;
                }
                /**
 * SASLprep.
 * @param {string} input
 * @param {Object} opts
 * @param {boolean} opts.allowUnassigned
 * @returns {string}
 */ function saslprep(input) {
                    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (typeof input !== "string") throw new TypeError("Expected string.");
                    if (input.length === 0) return "";
                     // 1. Map
                    var mapped_input = toCodePoints(input) // 1.1 mapping to space
                    .map(function(character) {
                        return mapping2space(character) ? 0x20 : character;
                    }) // 1.2 mapping to nothing
                    .filter(function(character) {
                        return !mapping2nothing(character);
                    }); // 2. Normalize
                    var normalized_input = String.fromCodePoint.apply(null, mapped_input).normalize("NFKC");
                    var normalized_map = toCodePoints(normalized_input); // 3. Prohibit
                    var hasProhibited = normalized_map.some(isProhibitedCharacter);
                    if (hasProhibited) throw new Error("Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3");
                     // Unassigned Code Points
                    if (opts.allowUnassigned !== true) {
                        var hasUnassigned = normalized_map.some(isUnassignedCodePoint);
                        if (hasUnassigned) throw new Error("Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5");
                    } // 4. check bidi
                    var hasBidiRAL = normalized_map.some(isBidirectionalRAL);
                    var hasBidiL = normalized_map.some(isBidirectionalL); // 4.1 If a string contains any RandALCat character, the string MUST NOT
                    // contain any LCat character.
                    if (hasBidiRAL && hasBidiL) throw new Error("String must not contain RandALCat and LCat at the same time, see https://tools.ietf.org/html/rfc3454#section-6");
                    /**
   * 4.2 If a string contains any RandALCat character, a RandALCat
   * character MUST be the first character of the string, and a
   * RandALCat character MUST be the last character of the string.
   */ var isFirstBidiRAL = isBidirectionalRAL(getCodePoint(first(normalized_input)));
                    var isLastBidiRAL = isBidirectionalRAL(getCodePoint(last(normalized_input)));
                    if (hasBidiRAL && !(isFirstBidiRAL && isLastBidiRAL)) throw new Error("Bidirectional RandALCat character must be the first and the last character of the string, see https://tools.ietf.org/html/rfc3454#section-6");
                    return normalized_input;
                }
                var PDFSecurity = /*#__PURE__*/ function() {
                    _createClass(PDFSecurity, null, [
                        {
                            key: "generateFileID",
                            value: function generateFileID() {
                                var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                var infoStr = "".concat(info.CreationDate.getTime(), "\n");
                                for(var key in info){
                                    // eslint-disable-next-line no-prototype-builtins
                                    if (!info.hasOwnProperty(key)) continue;
                                    infoStr += "".concat(key, ": ").concat(info[key].valueOf(), "\n");
                                }
                                return wordArrayToBuffer(_cryptoJs.default.MD5(infoStr));
                            }
                        },
                        {
                            key: "generateRandomWordArray",
                            value: function generateRandomWordArray(bytes) {
                                return _cryptoJs.default.lib.WordArray.random(bytes);
                            }
                        },
                        {
                            key: "create",
                            value: function create(document1) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                if (!options.ownerPassword && !options.userPassword) return null;
                                return new PDFSecurity(document1, options);
                            }
                        }
                    ]);
                    function PDFSecurity(document1) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _classCallCheck(this, PDFSecurity);
                        if (!options.ownerPassword && !options.userPassword) throw new Error("None of owner password and user password is defined.");
                        this.document = document1;
                        this._setupEncryption(options);
                    }
                    _createClass(PDFSecurity, [
                        {
                            key: "_setupEncryption",
                            value: function _setupEncryption(options) {
                                switch(options.pdfVersion){
                                    case "1.4":
                                    case "1.5":
                                        this.version = 2;
                                        break;
                                    case "1.6":
                                    case "1.7":
                                        this.version = 4;
                                        break;
                                    case "1.7ext3":
                                        this.version = 5;
                                        break;
                                    default:
                                        this.version = 1;
                                        break;
                                }
                                var encDict = {
                                    Filter: "Standard"
                                };
                                switch(this.version){
                                    case 1:
                                    case 2:
                                    case 4:
                                        this._setupEncryptionV1V2V4(this.version, encDict, options);
                                        break;
                                    case 5:
                                        this._setupEncryptionV5(encDict, options);
                                        break;
                                }
                                this.dictionary = this.document.ref(encDict);
                            }
                        },
                        {
                            key: "_setupEncryptionV1V2V4",
                            value: function _setupEncryptionV1V2V4(v, encDict, options) {
                                var r, permissions;
                                switch(v){
                                    case 1:
                                        r = 2;
                                        this.keyBits = 40;
                                        permissions = getPermissionsR2(options.permissions);
                                        break;
                                    case 2:
                                        r = 3;
                                        this.keyBits = 128;
                                        permissions = getPermissionsR3(options.permissions);
                                        break;
                                    case 4:
                                        r = 4;
                                        this.keyBits = 128;
                                        permissions = getPermissionsR3(options.permissions);
                                        break;
                                }
                                var paddedUserPassword = processPasswordR2R3R4(options.userPassword);
                                var paddedOwnerPassword = options.ownerPassword ? processPasswordR2R3R4(options.ownerPassword) : paddedUserPassword;
                                var ownerPasswordEntry = getOwnerPasswordR2R3R4(r, this.keyBits, paddedUserPassword, paddedOwnerPassword);
                                this.encryptionKey = getEncryptionKeyR2R3R4(r, this.keyBits, this.document._id, paddedUserPassword, ownerPasswordEntry, permissions);
                                var userPasswordEntry;
                                if (r === 2) userPasswordEntry = getUserPasswordR2(this.encryptionKey);
                                else userPasswordEntry = getUserPasswordR3R4(this.document._id, this.encryptionKey);
                                encDict.V = v;
                                if (v >= 2) encDict.Length = this.keyBits;
                                if (v === 4) {
                                    encDict.CF = {
                                        StdCF: {
                                            AuthEvent: "DocOpen",
                                            CFM: "AESV2",
                                            Length: this.keyBits / 8
                                        }
                                    };
                                    encDict.StmF = "StdCF";
                                    encDict.StrF = "StdCF";
                                }
                                encDict.R = r;
                                encDict.O = wordArrayToBuffer(ownerPasswordEntry);
                                encDict.U = wordArrayToBuffer(userPasswordEntry);
                                encDict.P = permissions;
                            }
                        },
                        {
                            key: "_setupEncryptionV5",
                            value: function _setupEncryptionV5(encDict, options) {
                                this.keyBits = 256;
                                var permissions = getPermissionsR3(options.permissions);
                                var processedUserPassword = processPasswordR5(options.userPassword);
                                var processedOwnerPassword = options.ownerPassword ? processPasswordR5(options.ownerPassword) : processedUserPassword;
                                this.encryptionKey = getEncryptionKeyR5(PDFSecurity.generateRandomWordArray);
                                var userPasswordEntry = getUserPasswordR5(processedUserPassword, PDFSecurity.generateRandomWordArray);
                                var userKeySalt = _cryptoJs.default.lib.WordArray.create(userPasswordEntry.words.slice(10, 12), 8);
                                var userEncryptionKeyEntry = getUserEncryptionKeyR5(processedUserPassword, userKeySalt, this.encryptionKey);
                                var ownerPasswordEntry = getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, PDFSecurity.generateRandomWordArray);
                                var ownerKeySalt = _cryptoJs.default.lib.WordArray.create(ownerPasswordEntry.words.slice(10, 12), 8);
                                var ownerEncryptionKeyEntry = getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, this.encryptionKey);
                                var permsEntry = getEncryptedPermissionsR5(permissions, this.encryptionKey, PDFSecurity.generateRandomWordArray);
                                encDict.V = 5;
                                encDict.Length = this.keyBits;
                                encDict.CF = {
                                    StdCF: {
                                        AuthEvent: "DocOpen",
                                        CFM: "AESV3",
                                        Length: this.keyBits / 8
                                    }
                                };
                                encDict.StmF = "StdCF";
                                encDict.StrF = "StdCF";
                                encDict.R = 5;
                                encDict.O = wordArrayToBuffer(ownerPasswordEntry);
                                encDict.OE = wordArrayToBuffer(ownerEncryptionKeyEntry);
                                encDict.U = wordArrayToBuffer(userPasswordEntry);
                                encDict.UE = wordArrayToBuffer(userEncryptionKeyEntry);
                                encDict.P = permissions;
                                encDict.Perms = wordArrayToBuffer(permsEntry);
                            }
                        },
                        {
                            key: "getEncryptFn",
                            value: function getEncryptFn(obj, gen) {
                                var digest;
                                if (this.version < 5) digest = this.encryptionKey.clone().concat(_cryptoJs.default.lib.WordArray.create([
                                    (obj & 0xff) << 24 | (obj & 0xff00) << 8 | obj >> 8 & 0xff00 | gen & 0xff,
                                    (gen & 0xff00) << 16
                                ], 5));
                                if (this.version === 1 || this.version === 2) {
                                    var _key = _cryptoJs.default.MD5(digest);
                                    _key.sigBytes = Math.min(16, this.keyBits / 8 + 5);
                                    return function(buffer) {
                                        return wordArrayToBuffer(_cryptoJs.default.RC4.encrypt(_cryptoJs.default.lib.WordArray.create(buffer), _key).ciphertext);
                                    };
                                }
                                var key;
                                if (this.version === 4) key = _cryptoJs.default.MD5(digest.concat(_cryptoJs.default.lib.WordArray.create([
                                    0x73416c54
                                ], 4)));
                                else key = this.encryptionKey;
                                var iv = PDFSecurity.generateRandomWordArray(16);
                                var options = {
                                    mode: _cryptoJs.default.mode.CBC,
                                    padding: _cryptoJs.default.pad.Pkcs7,
                                    iv: iv
                                };
                                return function(buffer) {
                                    return wordArrayToBuffer(iv.clone().concat(_cryptoJs.default.AES.encrypt(_cryptoJs.default.lib.WordArray.create(buffer), key, options).ciphertext));
                                };
                            }
                        },
                        {
                            key: "end",
                            value: function end() {
                                this.dictionary.end();
                            }
                        }
                    ]);
                    return PDFSecurity;
                }();
                function getPermissionsR2() {
                    var permissionObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var permissions = -64;
                    if (permissionObject.printing) permissions |= 4;
                    if (permissionObject.modifying) permissions |= 8;
                    if (permissionObject.copying) permissions |= 16;
                    if (permissionObject.annotating) permissions |= 32;
                    return permissions;
                }
                function getPermissionsR3() {
                    var permissionObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var permissions = -3904;
                    if (permissionObject.printing === "lowResolution") permissions |= 4;
                    if (permissionObject.printing === "highResolution") permissions |= 2052;
                    if (permissionObject.modifying) permissions |= 8;
                    if (permissionObject.copying) permissions |= 16;
                    if (permissionObject.annotating) permissions |= 32;
                    if (permissionObject.fillingForms) permissions |= 256;
                    if (permissionObject.contentAccessibility) permissions |= 512;
                    if (permissionObject.documentAssembly) permissions |= 1024;
                    return permissions;
                }
                function getUserPasswordR2(encryptionKey) {
                    return _cryptoJs.default.RC4.encrypt(processPasswordR2R3R4(), encryptionKey).ciphertext;
                }
                function getUserPasswordR3R4(documentId, encryptionKey) {
                    var key = encryptionKey.clone();
                    var cipher = _cryptoJs.default.MD5(processPasswordR2R3R4().concat(_cryptoJs.default.lib.WordArray.create(documentId)));
                    for(var i = 0; i < 20; i++){
                        var xorRound = Math.ceil(key.sigBytes / 4);
                        for(var j = 0; j < xorRound; j++)key.words[j] = encryptionKey.words[j] ^ (i | i << 8 | i << 16 | i << 24);
                        cipher = _cryptoJs.default.RC4.encrypt(cipher, key).ciphertext;
                    }
                    return cipher.concat(_cryptoJs.default.lib.WordArray.create(null, 16));
                }
                function getOwnerPasswordR2R3R4(r, keyBits, paddedUserPassword, paddedOwnerPassword) {
                    var digest = paddedOwnerPassword;
                    var round = r >= 3 ? 51 : 1;
                    for(var i = 0; i < round; i++)digest = _cryptoJs.default.MD5(digest);
                    var key = digest.clone();
                    key.sigBytes = keyBits / 8;
                    var cipher = paddedUserPassword;
                    round = r >= 3 ? 20 : 1;
                    for(var _i = 0; _i < round; _i++){
                        var xorRound = Math.ceil(key.sigBytes / 4);
                        for(var j = 0; j < xorRound; j++)key.words[j] = digest.words[j] ^ (_i | _i << 8 | _i << 16 | _i << 24);
                        cipher = _cryptoJs.default.RC4.encrypt(cipher, key).ciphertext;
                    }
                    return cipher;
                }
                function getEncryptionKeyR2R3R4(r, keyBits, documentId, paddedUserPassword, ownerPasswordEntry, permissions) {
                    var key = paddedUserPassword.clone().concat(ownerPasswordEntry).concat(_cryptoJs.default.lib.WordArray.create([
                        lsbFirstWord(permissions)
                    ], 4)).concat(_cryptoJs.default.lib.WordArray.create(documentId));
                    var round = r >= 3 ? 51 : 1;
                    for(var i = 0; i < round; i++){
                        key = _cryptoJs.default.MD5(key);
                        key.sigBytes = keyBits / 8;
                    }
                    return key;
                }
                function getUserPasswordR5(processedUserPassword, generateRandomWordArray) {
                    var validationSalt = generateRandomWordArray(8);
                    var keySalt = generateRandomWordArray(8);
                    return _cryptoJs.default.SHA256(processedUserPassword.clone().concat(validationSalt)).concat(validationSalt).concat(keySalt);
                }
                function getUserEncryptionKeyR5(processedUserPassword, userKeySalt, encryptionKey) {
                    var key = _cryptoJs.default.SHA256(processedUserPassword.clone().concat(userKeySalt));
                    var options = {
                        mode: _cryptoJs.default.mode.CBC,
                        padding: _cryptoJs.default.pad.NoPadding,
                        iv: _cryptoJs.default.lib.WordArray.create(null, 16)
                    };
                    return _cryptoJs.default.AES.encrypt(encryptionKey, key, options).ciphertext;
                }
                function getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, generateRandomWordArray) {
                    var validationSalt = generateRandomWordArray(8);
                    var keySalt = generateRandomWordArray(8);
                    return _cryptoJs.default.SHA256(processedOwnerPassword.clone().concat(validationSalt).concat(userPasswordEntry)).concat(validationSalt).concat(keySalt);
                }
                function getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, encryptionKey) {
                    var key = _cryptoJs.default.SHA256(processedOwnerPassword.clone().concat(ownerKeySalt).concat(userPasswordEntry));
                    var options = {
                        mode: _cryptoJs.default.mode.CBC,
                        padding: _cryptoJs.default.pad.NoPadding,
                        iv: _cryptoJs.default.lib.WordArray.create(null, 16)
                    };
                    return _cryptoJs.default.AES.encrypt(encryptionKey, key, options).ciphertext;
                }
                function getEncryptionKeyR5(generateRandomWordArray) {
                    return generateRandomWordArray(32);
                }
                function getEncryptedPermissionsR5(permissions, encryptionKey, generateRandomWordArray) {
                    var cipher = _cryptoJs.default.lib.WordArray.create([
                        lsbFirstWord(permissions),
                        0xffffffff,
                        0x54616462
                    ], 12).concat(generateRandomWordArray(4));
                    var options = {
                        mode: _cryptoJs.default.mode.ECB,
                        padding: _cryptoJs.default.pad.NoPadding
                    };
                    return _cryptoJs.default.AES.encrypt(cipher, encryptionKey, options).ciphertext;
                }
                function processPasswordR2R3R4() {
                    var password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                    var out = Buffer.alloc(32);
                    var length = password.length;
                    var index = 0;
                    while(index < length && index < 32){
                        var code = password.charCodeAt(index);
                        if (code > 0xff) throw new Error("Password contains one or more invalid characters.");
                        out[index] = code;
                        index++;
                    }
                    while(index < 32){
                        out[index] = PASSWORD_PADDING[index - length];
                        index++;
                    }
                    return _cryptoJs.default.lib.WordArray.create(out);
                }
                function processPasswordR5() {
                    var password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                    password = unescape(encodeURIComponent(saslprep(password)));
                    var length = Math.min(127, password.length);
                    var out = Buffer.alloc(length);
                    for(var i = 0; i < length; i++)out[i] = password.charCodeAt(i);
                    return _cryptoJs.default.lib.WordArray.create(out);
                }
                function lsbFirstWord(data) {
                    return (data & 0xff) << 24 | (data & 0xff00) << 8 | data >> 8 & 0xff00 | data >> 24 & 0xff;
                }
                function wordArrayToBuffer(wordArray) {
                    var byteArray = [];
                    for(var i = 0; i < wordArray.sigBytes; i++)byteArray.push(wordArray.words[Math.floor(i / 4)] >> 8 * (3 - i % 4) & 0xff);
                    return Buffer.from(byteArray);
                }
                var PASSWORD_PADDING = [
                    0x28,
                    0xbf,
                    0x4e,
                    0x5e,
                    0x4e,
                    0x75,
                    0x8a,
                    0x41,
                    0x64,
                    0x00,
                    0x4e,
                    0x56,
                    0xff,
                    0xfa,
                    0x01,
                    0x08,
                    0x2e,
                    0x2e,
                    0x00,
                    0xb6,
                    0xd0,
                    0x68,
                    0x3e,
                    0x80,
                    0x2f,
                    0x0c,
                    0xa9,
                    0xfe,
                    0x64,
                    0x53,
                    0x69,
                    0x7a
                ];
                var number = PDFObject.number;
                var PDFGradient = /*#__PURE__*/ function() {
                    function PDFGradient(doc) {
                        _classCallCheck(this, PDFGradient);
                        this.doc = doc;
                        this.stops = [];
                        this.embedded = false;
                        this.transform = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                    }
                    _createClass(PDFGradient, [
                        {
                            key: "stop",
                            value: function stop(pos, color, opacity) {
                                if (opacity == null) opacity = 1;
                                color = this.doc._normalizeColor(color);
                                if (this.stops.length === 0) {
                                    if (color.length === 3) this._colorSpace = "DeviceRGB";
                                    else if (color.length === 4) this._colorSpace = "DeviceCMYK";
                                    else if (color.length === 1) this._colorSpace = "DeviceGray";
                                    else throw new Error("Unknown color space");
                                } else if (this._colorSpace === "DeviceRGB" && color.length !== 3 || this._colorSpace === "DeviceCMYK" && color.length !== 4 || this._colorSpace === "DeviceGray" && color.length !== 1) throw new Error("All gradient stops must use the same color space");
                                opacity = Math.max(0, Math.min(1, opacity));
                                this.stops.push([
                                    pos,
                                    color,
                                    opacity
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "setTransform",
                            value: function setTransform(m11, m12, m21, m22, dx, dy) {
                                this.transform = [
                                    m11,
                                    m12,
                                    m21,
                                    m22,
                                    dx,
                                    dy
                                ];
                                return this;
                            }
                        },
                        {
                            key: "embed",
                            value: function embed(m) {
                                var fn;
                                var stopsLength = this.stops.length;
                                if (stopsLength === 0) return;
                                this.embedded = true;
                                this.matrix = m; // if the last stop comes before 100%, add a copy at 100%
                                var last = this.stops[stopsLength - 1];
                                if (last[0] < 1) this.stops.push([
                                    1,
                                    last[1],
                                    last[2]
                                ]);
                                var bounds = [];
                                var encode = [];
                                var stops = [];
                                for(var i = 0; i < stopsLength - 1; i++){
                                    encode.push(0, 1);
                                    if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
                                    fn = this.doc.ref({
                                        FunctionType: 2,
                                        Domain: [
                                            0,
                                            1
                                        ],
                                        C0: this.stops[i + 0][1],
                                        C1: this.stops[i + 1][1],
                                        N: 1
                                    });
                                    stops.push(fn);
                                    fn.end();
                                } // if there are only two stops, we don't need a stitching function
                                if (stopsLength === 1) fn = stops[0];
                                else {
                                    fn = this.doc.ref({
                                        FunctionType: 3,
                                        // stitching function
                                        Domain: [
                                            0,
                                            1
                                        ],
                                        Functions: stops,
                                        Bounds: bounds,
                                        Encode: encode
                                    });
                                    fn.end();
                                }
                                this.id = "Sh".concat(++this.doc._gradCount);
                                var shader = this.shader(fn);
                                shader.end();
                                var pattern = this.doc.ref({
                                    Type: "Pattern",
                                    PatternType: 2,
                                    Shading: shader,
                                    Matrix: this.matrix.map(number)
                                });
                                pattern.end();
                                if (this.stops.some(function(stop) {
                                    return stop[2] < 1;
                                })) {
                                    var grad = this.opacityGradient();
                                    grad._colorSpace = "DeviceGray";
                                    var _iterator = _createForOfIteratorHelper(this.stops), _step;
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            var stop = _step.value;
                                            grad.stop(stop[0], [
                                                stop[2]
                                            ]);
                                        }
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    grad = grad.embed(this.matrix);
                                    var pageBBox = [
                                        0,
                                        0,
                                        this.doc.page.width,
                                        this.doc.page.height
                                    ];
                                    var form = this.doc.ref({
                                        Type: "XObject",
                                        Subtype: "Form",
                                        FormType: 1,
                                        BBox: pageBBox,
                                        Group: {
                                            Type: "Group",
                                            S: "Transparency",
                                            CS: "DeviceGray"
                                        },
                                        Resources: {
                                            ProcSet: [
                                                "PDF",
                                                "Text",
                                                "ImageB",
                                                "ImageC",
                                                "ImageI"
                                            ],
                                            Pattern: {
                                                Sh1: grad
                                            }
                                        }
                                    });
                                    form.write("/Pattern cs /Sh1 scn");
                                    form.end("".concat(pageBBox.join(" "), " re f"));
                                    var gstate = this.doc.ref({
                                        Type: "ExtGState",
                                        SMask: {
                                            Type: "Mask",
                                            S: "Luminosity",
                                            G: form
                                        }
                                    });
                                    gstate.end();
                                    var opacityPattern = this.doc.ref({
                                        Type: "Pattern",
                                        PatternType: 1,
                                        PaintType: 1,
                                        TilingType: 2,
                                        BBox: pageBBox,
                                        XStep: pageBBox[2],
                                        YStep: pageBBox[3],
                                        Resources: {
                                            ProcSet: [
                                                "PDF",
                                                "Text",
                                                "ImageB",
                                                "ImageC",
                                                "ImageI"
                                            ],
                                            Pattern: {
                                                Sh1: pattern
                                            },
                                            ExtGState: {
                                                Gs1: gstate
                                            }
                                        }
                                    });
                                    opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
                                    opacityPattern.end("".concat(pageBBox.join(" "), " re f"));
                                    this.doc.page.patterns[this.id] = opacityPattern;
                                } else this.doc.page.patterns[this.id] = pattern;
                                return pattern;
                            }
                        },
                        {
                            key: "apply",
                            value: function apply(stroke) {
                                // apply gradient transform to existing document ctm
                                var _this$doc$_ctm = _slicedToArray(this.doc._ctm, 6), m0 = _this$doc$_ctm[0], m1 = _this$doc$_ctm[1], m2 = _this$doc$_ctm[2], m3 = _this$doc$_ctm[3], m4 = _this$doc$_ctm[4], m5 = _this$doc$_ctm[5];
                                var _this$transform = _slicedToArray(this.transform, 6), m11 = _this$transform[0], m12 = _this$transform[1], m21 = _this$transform[2], m22 = _this$transform[3], dx = _this$transform[4], dy = _this$transform[5];
                                var m = [
                                    m0 * m11 + m2 * m12,
                                    m1 * m11 + m3 * m12,
                                    m0 * m21 + m2 * m22,
                                    m1 * m21 + m3 * m22,
                                    m0 * dx + m2 * dy + m4,
                                    m1 * dx + m3 * dy + m5
                                ];
                                if (!this.embedded || m.join(" ") !== this.matrix.join(" ")) this.embed(m);
                                this.doc._setColorSpace("Pattern", stroke);
                                var op = stroke ? "SCN" : "scn";
                                return this.doc.addContent("/".concat(this.id, " ").concat(op));
                            }
                        }
                    ]);
                    return PDFGradient;
                }();
                var PDFLinearGradient = /*#__PURE__*/ function(_PDFGradient) {
                    _inherits(PDFLinearGradient, _PDFGradient);
                    var _super = _createSuper(PDFLinearGradient);
                    function PDFLinearGradient(doc, x1, y1, x2, y2) {
                        var _this;
                        _classCallCheck(this, PDFLinearGradient);
                        _this = _super.call(this, doc);
                        _this.x1 = x1;
                        _this.y1 = y1;
                        _this.x2 = x2;
                        _this.y2 = y2;
                        return _this;
                    }
                    _createClass(PDFLinearGradient, [
                        {
                            key: "shader",
                            value: function shader(fn) {
                                return this.doc.ref({
                                    ShadingType: 2,
                                    ColorSpace: this._colorSpace,
                                    Coords: [
                                        this.x1,
                                        this.y1,
                                        this.x2,
                                        this.y2
                                    ],
                                    Function: fn,
                                    Extend: [
                                        true,
                                        true
                                    ]
                                });
                            }
                        },
                        {
                            key: "opacityGradient",
                            value: function opacityGradient() {
                                return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
                            }
                        }
                    ]);
                    return PDFLinearGradient;
                }(PDFGradient);
                var PDFRadialGradient = /*#__PURE__*/ function(_PDFGradient2) {
                    _inherits(PDFRadialGradient, _PDFGradient2);
                    var _super2 = _createSuper(PDFRadialGradient);
                    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
                        var _this2;
                        _classCallCheck(this, PDFRadialGradient);
                        _this2 = _super2.call(this, doc);
                        _this2.doc = doc;
                        _this2.x1 = x1;
                        _this2.y1 = y1;
                        _this2.r1 = r1;
                        _this2.x2 = x2;
                        _this2.y2 = y2;
                        _this2.r2 = r2;
                        return _this2;
                    }
                    _createClass(PDFRadialGradient, [
                        {
                            key: "shader",
                            value: function shader(fn) {
                                return this.doc.ref({
                                    ShadingType: 3,
                                    ColorSpace: this._colorSpace,
                                    Coords: [
                                        this.x1,
                                        this.y1,
                                        this.r1,
                                        this.x2,
                                        this.y2,
                                        this.r2
                                    ],
                                    Function: fn,
                                    Extend: [
                                        true,
                                        true
                                    ]
                                });
                            }
                        },
                        {
                            key: "opacityGradient",
                            value: function opacityGradient() {
                                return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
                            }
                        }
                    ]);
                    return PDFRadialGradient;
                }(PDFGradient);
                var Gradient = {
                    PDFGradient: PDFGradient,
                    PDFLinearGradient: PDFLinearGradient,
                    PDFRadialGradient: PDFRadialGradient
                };
                /*
PDF tiling pattern support. Uncolored only.
 */ var underlyingColorSpaces = [
                    "DeviceCMYK",
                    "DeviceRGB"
                ];
                var PDFTilingPattern = /*#__PURE__*/ function() {
                    function PDFTilingPattern(doc, bBox, xStep, yStep, stream) {
                        _classCallCheck(this, PDFTilingPattern);
                        this.doc = doc;
                        this.bBox = bBox;
                        this.xStep = xStep;
                        this.yStep = yStep;
                        this.stream = stream;
                    }
                    _createClass(PDFTilingPattern, [
                        {
                            key: "createPattern",
                            value: function createPattern() {
                                // no resources needed for our current usage
                                // required entry
                                var resources = this.doc.ref();
                                resources.end(); // apply default transform matrix (flipped in the default doc._ctm)
                                // see document.js & gradient.js
                                var _this$doc$_ctm = _slicedToArray(this.doc._ctm, 6), m0 = _this$doc$_ctm[0], m1 = _this$doc$_ctm[1], m2 = _this$doc$_ctm[2], m3 = _this$doc$_ctm[3], m4 = _this$doc$_ctm[4], m5 = _this$doc$_ctm[5];
                                var m11 = 1, m12 = 0, m21 = 0, m22 = 1, dx = 0, dy = 0;
                                var m = [
                                    m0 * m11 + m2 * m12,
                                    m1 * m11 + m3 * m12,
                                    m0 * m21 + m2 * m22,
                                    m1 * m21 + m3 * m22,
                                    m0 * dx + m2 * dy + m4,
                                    m1 * dx + m3 * dy + m5
                                ];
                                var pattern = this.doc.ref({
                                    Type: "Pattern",
                                    PatternType: 1,
                                    // tiling
                                    PaintType: 2,
                                    // 1-colored, 2-uncolored
                                    TilingType: 2,
                                    // 2-no distortion
                                    BBox: this.bBox,
                                    XStep: this.xStep,
                                    YStep: this.yStep,
                                    Matrix: m.map(function(v) {
                                        return +v.toFixed(5);
                                    }),
                                    Resources: resources
                                });
                                pattern.end(this.stream);
                                return pattern;
                            }
                        },
                        {
                            key: "embedPatternColorSpaces",
                            value: function embedPatternColorSpaces() {
                                var _this = this;
                                // map each pattern to an underlying color space
                                // and embed on each page
                                underlyingColorSpaces.forEach(function(csName) {
                                    var csId = _this.getPatternColorSpaceId(csName);
                                    if (_this.doc.page.colorSpaces[csId]) return;
                                    var cs = _this.doc.ref([
                                        "Pattern",
                                        csName
                                    ]);
                                    cs.end();
                                    _this.doc.page.colorSpaces[csId] = cs;
                                });
                            }
                        },
                        {
                            key: "getPatternColorSpaceId",
                            value: function getPatternColorSpaceId(underlyingColorspace) {
                                return "CsP".concat(underlyingColorspace);
                            }
                        },
                        {
                            key: "embed",
                            value: function embed() {
                                if (!this.id) {
                                    this.doc._patternCount = this.doc._patternCount + 1;
                                    this.id = "P" + this.doc._patternCount;
                                    this.pattern = this.createPattern();
                                } // patterns are embedded in each page
                                if (!this.doc.page.patterns[this.id]) this.doc.page.patterns[this.id] = this.pattern;
                            }
                        },
                        {
                            key: "apply",
                            value: function apply(stroke, patternColor) {
                                // do any embedding/creating that might be needed
                                this.embedPatternColorSpaces();
                                this.embed();
                                var normalizedColor = this.doc._normalizeColor(patternColor);
                                if (!normalizedColor) throw Error("invalid pattern color. (value: ".concat(patternColor, ")")); // select one of the pattern color spaces
                                var csId = this.getPatternColorSpaceId(this.doc._getColorSpace(normalizedColor));
                                this.doc._setColorSpace(csId, stroke); // stroke/fill using the pattern and color (in the above underlying color space)
                                var op = stroke ? "SCN" : "scn";
                                return this.doc.addContent("".concat(normalizedColor.join(" "), " /").concat(this.id, " ").concat(op));
                            }
                        }
                    ]);
                    return PDFTilingPattern;
                }();
                var pattern = {
                    PDFTilingPattern: PDFTilingPattern
                };
                var PDFGradient$1 = Gradient.PDFGradient, PDFLinearGradient$1 = Gradient.PDFLinearGradient, PDFRadialGradient$1 = Gradient.PDFRadialGradient;
                var PDFTilingPattern$1 = pattern.PDFTilingPattern;
                var ColorMixin = {
                    initColor: function initColor() {
                        // The opacity dictionaries
                        this._opacityRegistry = {};
                        this._opacityCount = 0;
                        this._patternCount = 0;
                        return this._gradCount = 0;
                    },
                    _normalizeColor: function _normalizeColor(color) {
                        if (typeof color === "string") {
                            if (color.charAt(0) === "#") {
                                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3");
                                var hex = parseInt(color.slice(1), 16);
                                color = [
                                    hex >> 16,
                                    hex >> 8 & 0xff,
                                    hex & 0xff
                                ];
                            } else if (namedColors[color]) color = namedColors[color];
                        }
                        if (Array.isArray(color)) {
                            // RGB
                            if (color.length === 3) color = color.map(function(part) {
                                return part / 255;
                            }); // CMYK
                            else if (color.length === 4) color = color.map(function(part) {
                                return part / 100;
                            });
                            return color;
                        }
                        return null;
                    },
                    _setColor: function _setColor(color, stroke) {
                        if (color instanceof PDFGradient$1) {
                            color.apply(stroke);
                            return true; // see if tiling pattern, decode & apply it it
                        } else if (Array.isArray(color) && color[0] instanceof PDFTilingPattern$1) {
                            color[0].apply(stroke, color[1]);
                            return true;
                        } // any other case should be a normal color and not a pattern
                        return this._setColorCore(color, stroke);
                    },
                    _setColorCore: function _setColorCore(color, stroke) {
                        color = this._normalizeColor(color);
                        if (!color) return false;
                        var op = stroke ? "SCN" : "scn";
                        var space = this._getColorSpace(color);
                        this._setColorSpace(space, stroke);
                        color = color.join(" ");
                        this.addContent("".concat(color, " ").concat(op));
                        return true;
                    },
                    _setColorSpace: function _setColorSpace(space, stroke) {
                        var op = stroke ? "CS" : "cs";
                        return this.addContent("/".concat(space, " ").concat(op));
                    },
                    _getColorSpace: function _getColorSpace(color) {
                        return color.length === 4 ? "DeviceCMYK" : "DeviceRGB";
                    },
                    fillColor: function fillColor(color, opacity) {
                        var set = this._setColor(color, false);
                        if (set) this.fillOpacity(opacity);
                         // save this for text wrapper, which needs to reset
                        // the fill color on new pages
                        this._fillColor = [
                            color,
                            opacity
                        ];
                        return this;
                    },
                    strokeColor: function strokeColor(color, opacity) {
                        var set = this._setColor(color, true);
                        if (set) this.strokeOpacity(opacity);
                        return this;
                    },
                    opacity: function opacity(_opacity) {
                        this._doOpacity(_opacity, _opacity);
                        return this;
                    },
                    fillOpacity: function fillOpacity(opacity) {
                        this._doOpacity(opacity, null);
                        return this;
                    },
                    strokeOpacity: function strokeOpacity(opacity) {
                        this._doOpacity(null, opacity);
                        return this;
                    },
                    _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
                        var dictionary, name;
                        if (fillOpacity == null && strokeOpacity == null) return;
                        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
                        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
                        var key = "".concat(fillOpacity, "_").concat(strokeOpacity);
                        if (this._opacityRegistry[key]) {
                            var _this$_opacityRegistr = _slicedToArray(this._opacityRegistry[key], 2);
                            dictionary = _this$_opacityRegistr[0];
                            name = _this$_opacityRegistr[1];
                        } else {
                            dictionary = {
                                Type: "ExtGState"
                            };
                            if (fillOpacity != null) dictionary.ca = fillOpacity;
                            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
                            dictionary = this.ref(dictionary);
                            dictionary.end();
                            var id = ++this._opacityCount;
                            name = "Gs".concat(id);
                            this._opacityRegistry[key] = [
                                dictionary,
                                name
                            ];
                        }
                        this.page.ext_gstates[name] = dictionary;
                        return this.addContent("/".concat(name, " gs"));
                    },
                    linearGradient: function linearGradient(x1, y1, x2, y2) {
                        return new PDFLinearGradient$1(this, x1, y1, x2, y2);
                    },
                    radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
                        return new PDFRadialGradient$1(this, x1, y1, r1, x2, y2, r2);
                    },
                    pattern: function pattern(bbox, xStep, yStep, stream) {
                        return new PDFTilingPattern$1(this, bbox, xStep, yStep, stream);
                    }
                };
                var namedColors = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
                var cx, cy, px, py, sx, sy;
                cx = cy = px = py = sx = sy = 0;
                var parameters = {
                    A: 7,
                    a: 7,
                    C: 6,
                    c: 6,
                    H: 1,
                    h: 1,
                    L: 2,
                    l: 2,
                    M: 2,
                    m: 2,
                    Q: 4,
                    q: 4,
                    S: 4,
                    s: 4,
                    T: 2,
                    t: 2,
                    V: 1,
                    v: 1,
                    Z: 0,
                    z: 0
                };
                var parse = function parse(path) {
                    var cmd;
                    var ret = [];
                    var args = [];
                    var curArg = "";
                    var foundDecimal = false;
                    var params = 0;
                    var _iterator = _createForOfIteratorHelper(path), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var c = _step.value;
                            if (parameters[c] != null) {
                                params = parameters[c];
                                if (cmd) {
                                    // save existing command
                                    if (curArg.length > 0) args[args.length] = +curArg;
                                    ret[ret.length] = {
                                        cmd: cmd,
                                        args: args
                                    };
                                    args = [];
                                    curArg = "";
                                    foundDecimal = false;
                                }
                                cmd = c;
                            } else if ([
                                " ",
                                ","
                            ].includes(c) || c === "-" && curArg.length > 0 && curArg[curArg.length - 1] !== "e" || c === "." && foundDecimal) {
                                if (curArg.length === 0) continue;
                                if (args.length === params) {
                                    // handle reused commands
                                    ret[ret.length] = {
                                        cmd: cmd,
                                        args: args
                                    };
                                    args = [
                                        +curArg
                                    ]; // handle assumed commands
                                    if (cmd === "M") cmd = "L";
                                    if (cmd === "m") cmd = "l";
                                } else args[args.length] = +curArg;
                                foundDecimal = c === "."; // fix for negative numbers or repeated decimals with no delimeter between commands
                                curArg = [
                                    "-",
                                    "."
                                ].includes(c) ? c : "";
                            } else {
                                curArg += c;
                                if (c === ".") foundDecimal = true;
                            }
                        } // add the last command
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    if (curArg.length > 0) {
                        if (args.length === params) {
                            // handle reused commands
                            ret[ret.length] = {
                                cmd: cmd,
                                args: args
                            };
                            args = [
                                +curArg
                            ]; // handle assumed commands
                            if (cmd === "M") cmd = "L";
                            if (cmd === "m") cmd = "l";
                        } else args[args.length] = +curArg;
                    }
                    ret[ret.length] = {
                        cmd: cmd,
                        args: args
                    };
                    return ret;
                };
                var _apply = function apply(commands, doc) {
                    // current point, control point, and subpath starting point
                    cx = cy = px = py = sx = sy = 0; // run the commands
                    for(var i = 0; i < commands.length; i++){
                        var c = commands[i];
                        if (typeof runners[c.cmd] === "function") runners[c.cmd](doc, c.args);
                    }
                };
                var runners = {
                    M: function M(doc, a) {
                        cx = a[0];
                        cy = a[1];
                        px = py = null;
                        sx = cx;
                        sy = cy;
                        return doc.moveTo(cx, cy);
                    },
                    m: function m(doc, a) {
                        cx += a[0];
                        cy += a[1];
                        px = py = null;
                        sx = cx;
                        sy = cy;
                        return doc.moveTo(cx, cy);
                    },
                    C: function C(doc, a) {
                        cx = a[4];
                        cy = a[5];
                        px = a[2];
                        py = a[3];
                        return doc.bezierCurveTo.apply(doc, _toConsumableArray(a));
                    },
                    c: function c(doc, a) {
                        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
                        px = cx + a[2];
                        py = cy + a[3];
                        cx += a[4];
                        return cy += a[5];
                    },
                    S: function S(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        }
                        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
                        px = a[0];
                        py = a[1];
                        cx = a[2];
                        return cy = a[3];
                    },
                    s: function s(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        }
                        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
                        px = cx + a[0];
                        py = cy + a[1];
                        cx += a[2];
                        return cy += a[3];
                    },
                    Q: function Q(doc, a) {
                        px = a[0];
                        py = a[1];
                        cx = a[2];
                        cy = a[3];
                        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
                    },
                    q: function q(doc, a) {
                        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
                        px = cx + a[0];
                        py = cy + a[1];
                        cx += a[2];
                        return cy += a[3];
                    },
                    T: function T(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        } else {
                            px = cx - (px - cx);
                            py = cy - (py - cy);
                        }
                        doc.quadraticCurveTo(px, py, a[0], a[1]);
                        px = cx - (px - cx);
                        py = cy - (py - cy);
                        cx = a[0];
                        return cy = a[1];
                    },
                    t: function t(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        } else {
                            px = cx - (px - cx);
                            py = cy - (py - cy);
                        }
                        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
                        cx += a[0];
                        return cy += a[1];
                    },
                    A: function A(doc, a) {
                        solveArc(doc, cx, cy, a);
                        cx = a[5];
                        return cy = a[6];
                    },
                    a: function a(doc, _a) {
                        _a[5] += cx;
                        _a[6] += cy;
                        solveArc(doc, cx, cy, _a);
                        cx = _a[5];
                        return cy = _a[6];
                    },
                    L: function L(doc, a) {
                        cx = a[0];
                        cy = a[1];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    l: function l(doc, a) {
                        cx += a[0];
                        cy += a[1];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    H: function H(doc, a) {
                        cx = a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    h: function h(doc, a) {
                        cx += a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    V: function V(doc, a) {
                        cy = a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    v: function v(doc, a) {
                        cy += a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    Z: function Z(doc) {
                        doc.closePath();
                        cx = sx;
                        return cy = sy;
                    },
                    z: function z(doc) {
                        doc.closePath();
                        cx = sx;
                        return cy = sy;
                    }
                };
                var solveArc = function solveArc(doc, x, y, coords) {
                    var _coords = _slicedToArray(coords, 7), rx = _coords[0], ry = _coords[1], rot = _coords[2], large = _coords[3], sweep = _coords[4], ex = _coords[5], ey = _coords[6];
                    var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
                    var _iterator2 = _createForOfIteratorHelper(segs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var seg = _step2.value;
                            var bez = segmentToBezier.apply(void 0, _toConsumableArray(seg));
                            doc.bezierCurveTo.apply(doc, _toConsumableArray(bez));
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }; // from Inkscape svgtopdf, thanks!
                var arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
                    var th = rotateX * (Math.PI / 180);
                    var sin_th = Math.sin(th);
                    var cos_th = Math.cos(th);
                    rx = Math.abs(rx);
                    ry = Math.abs(ry);
                    px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
                    py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
                    var pl = px * px / (rx * rx) + py * py / (ry * ry);
                    if (pl > 1) {
                        pl = Math.sqrt(pl);
                        rx *= pl;
                        ry *= pl;
                    }
                    var a00 = cos_th / rx;
                    var a01 = sin_th / rx;
                    var a10 = -sin_th / ry;
                    var a11 = cos_th / ry;
                    var x0 = a00 * ox + a01 * oy;
                    var y0 = a10 * ox + a11 * oy;
                    var x1 = a00 * x + a01 * y;
                    var y1 = a10 * x + a11 * y;
                    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
                    var sfactor_sq = 1 / d - 0.25;
                    if (sfactor_sq < 0) sfactor_sq = 0;
                    var sfactor = Math.sqrt(sfactor_sq);
                    if (sweep === large) sfactor = -sfactor;
                    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
                    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
                    var th0 = Math.atan2(y0 - yc, x0 - xc);
                    var th1 = Math.atan2(y1 - yc, x1 - xc);
                    var th_arc = th1 - th0;
                    if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
                    else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
                    var segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
                    var result = [];
                    for(var i = 0; i < segments; i++){
                        var th2 = th0 + i * th_arc / segments;
                        var th3 = th0 + (i + 1) * th_arc / segments;
                        result[i] = [
                            xc,
                            yc,
                            th2,
                            th3,
                            rx,
                            ry,
                            sin_th,
                            cos_th
                        ];
                    }
                    return result;
                };
                var segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
                    var a00 = cos_th * rx;
                    var a01 = -sin_th * ry;
                    var a10 = sin_th * rx;
                    var a11 = cos_th * ry;
                    var th_half = 0.5 * (th1 - th0);
                    var t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
                    var x1 = cx + Math.cos(th0) - t * Math.sin(th0);
                    var y1 = cy + Math.sin(th0) + t * Math.cos(th0);
                    var x3 = cx + Math.cos(th1);
                    var y3 = cy + Math.sin(th1);
                    var x2 = x3 + t * Math.sin(th1);
                    var y2 = y3 - t * Math.cos(th1);
                    return [
                        a00 * x1 + a01 * y1,
                        a10 * x1 + a11 * y1,
                        a00 * x2 + a01 * y2,
                        a10 * x2 + a11 * y2,
                        a00 * x3 + a01 * y3,
                        a10 * x3 + a11 * y3
                    ];
                };
                var SVGPath = /*#__PURE__*/ function() {
                    function SVGPath() {
                        _classCallCheck(this, SVGPath);
                    }
                    _createClass(SVGPath, null, [
                        {
                            key: "apply",
                            value: function apply(doc, path) {
                                var commands = parse(path);
                                _apply(commands, doc);
                            }
                        }
                    ]);
                    return SVGPath;
                }();
                var number$1 = PDFObject.number; // This constant is used to approximate a symmetrical arc using a cubic
                // Bezier curve.
                var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
                var VectorMixin = {
                    initVector: function initVector() {
                        this._ctm = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]; // current transformation matrix
                        return this._ctmStack = [];
                    },
                    save: function save() {
                        this._ctmStack.push(this._ctm.slice()); // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?
                        return this.addContent("q");
                    },
                    restore: function restore() {
                        this._ctm = this._ctmStack.pop() || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        return this.addContent("Q");
                    },
                    closePath: function closePath() {
                        return this.addContent("h");
                    },
                    lineWidth: function lineWidth(w) {
                        return this.addContent("".concat(number$1(w), " w"));
                    },
                    _CAP_STYLES: {
                        BUTT: 0,
                        ROUND: 1,
                        SQUARE: 2
                    },
                    lineCap: function lineCap(c) {
                        if (typeof c === "string") c = this._CAP_STYLES[c.toUpperCase()];
                        return this.addContent("".concat(c, " J"));
                    },
                    _JOIN_STYLES: {
                        MITER: 0,
                        ROUND: 1,
                        BEVEL: 2
                    },
                    lineJoin: function lineJoin(j) {
                        if (typeof j === "string") j = this._JOIN_STYLES[j.toUpperCase()];
                        return this.addContent("".concat(j, " j"));
                    },
                    miterLimit: function miterLimit(m) {
                        return this.addContent("".concat(number$1(m), " M"));
                    },
                    dash: function dash(length) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var originalLength = length;
                        if (!Array.isArray(length)) length = [
                            length,
                            options.space || length
                        ];
                        var valid = length.every(function(x) {
                            return Number.isFinite(x) && x > 0;
                        });
                        if (!valid) throw new Error("dash(".concat(JSON.stringify(originalLength), ", ").concat(JSON.stringify(options), ") invalid, lengths must be numeric and greater than zero"));
                        length = length.map(number$1).join(" ");
                        return this.addContent("[".concat(length, "] ").concat(number$1(options.phase || 0), " d"));
                    },
                    undash: function undash() {
                        return this.addContent("[] 0 d");
                    },
                    moveTo: function moveTo(x, y) {
                        return this.addContent("".concat(number$1(x), " ").concat(number$1(y), " m"));
                    },
                    lineTo: function lineTo(x, y) {
                        return this.addContent("".concat(number$1(x), " ").concat(number$1(y), " l"));
                    },
                    bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
                        return this.addContent("".concat(number$1(cp1x), " ").concat(number$1(cp1y), " ").concat(number$1(cp2x), " ").concat(number$1(cp2y), " ").concat(number$1(x), " ").concat(number$1(y), " c"));
                    },
                    quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
                        return this.addContent("".concat(number$1(cpx), " ").concat(number$1(cpy), " ").concat(number$1(x), " ").concat(number$1(y), " v"));
                    },
                    rect: function rect(x, y, w, h) {
                        return this.addContent("".concat(number$1(x), " ").concat(number$1(y), " ").concat(number$1(w), " ").concat(number$1(h), " re"));
                    },
                    roundedRect: function roundedRect(x, y, w, h, r) {
                        if (r == null) r = 0;
                        r = Math.min(r, 0.5 * w, 0.5 * h); // amount to inset control points from corners (see `ellipse`)
                        var c = r * (1.0 - KAPPA);
                        this.moveTo(x + r, y);
                        this.lineTo(x + w - r, y);
                        this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
                        this.lineTo(x + w, y + h - r);
                        this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
                        this.lineTo(x + r, y + h);
                        this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
                        this.lineTo(x, y + r);
                        this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
                        return this.closePath();
                    },
                    ellipse: function ellipse(x, y, r1, r2) {
                        // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
                        if (r2 == null) r2 = r1;
                        x -= r1;
                        y -= r2;
                        var ox = r1 * KAPPA;
                        var oy = r2 * KAPPA;
                        var xe = x + r1 * 2;
                        var ye = y + r2 * 2;
                        var xm = x + r1;
                        var ym = y + r2;
                        this.moveTo(x, ym);
                        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
                        return this.closePath();
                    },
                    circle: function circle(x, y, radius) {
                        return this.ellipse(x, y, radius);
                    },
                    arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
                        if (anticlockwise == null) anticlockwise = false;
                        var TWO_PI = 2.0 * Math.PI;
                        var HALF_PI = 0.5 * Math.PI;
                        var deltaAng = endAngle - startAngle;
                        if (Math.abs(deltaAng) > TWO_PI) // draw only full circle if more than that is specified
                        deltaAng = TWO_PI;
                        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
                            // necessary to flip direction of rendering
                            var dir = anticlockwise ? -1 : 1;
                            deltaAng = dir * TWO_PI + deltaAng;
                        }
                        var numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
                        var segAng = deltaAng / numSegs;
                        var handleLen = segAng / HALF_PI * KAPPA * radius;
                        var curAng = startAngle; // component distances between anchor point and control point
                        var deltaCx = -Math.sin(curAng) * handleLen;
                        var deltaCy = Math.cos(curAng) * handleLen; // anchor point
                        var ax = x + Math.cos(curAng) * radius;
                        var ay = y + Math.sin(curAng) * radius; // calculate and render segments
                        this.moveTo(ax, ay);
                        for(var segIdx = 0; segIdx < numSegs; segIdx++){
                            // starting control point
                            var cp1x = ax + deltaCx;
                            var cp1y = ay + deltaCy; // step angle
                            curAng += segAng; // next anchor point
                            ax = x + Math.cos(curAng) * radius;
                            ay = y + Math.sin(curAng) * radius; // next control point delta
                            deltaCx = -Math.sin(curAng) * handleLen;
                            deltaCy = Math.cos(curAng) * handleLen; // ending control point
                            var cp2x = ax - deltaCx;
                            var cp2y = ay - deltaCy; // render segment
                            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
                        }
                        return this;
                    },
                    polygon: function polygon() {
                        for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
                        this.moveTo.apply(this, _toConsumableArray(points.shift() || []));
                        for(var _i = 0, _points = points; _i < _points.length; _i++){
                            var point = _points[_i];
                            this.lineTo.apply(this, _toConsumableArray(point || []));
                        }
                        return this.closePath();
                    },
                    path: function path(_path) {
                        SVGPath.apply(this, _path);
                        return this;
                    },
                    _windingRule: function _windingRule(rule) {
                        if (/even-?odd/.test(rule)) return "*";
                        return "";
                    },
                    fill: function fill(color, rule) {
                        if (/(even-?odd)|(non-?zero)/.test(color)) {
                            rule = color;
                            color = null;
                        }
                        if (color) this.fillColor(color);
                        return this.addContent("f".concat(this._windingRule(rule)));
                    },
                    stroke: function stroke(color) {
                        if (color) this.strokeColor(color);
                        return this.addContent("S");
                    },
                    fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
                        if (strokeColor == null) strokeColor = fillColor;
                        var isFillRule = /(even-?odd)|(non-?zero)/;
                        if (isFillRule.test(fillColor)) {
                            rule = fillColor;
                            fillColor = null;
                        }
                        if (isFillRule.test(strokeColor)) {
                            rule = strokeColor;
                            strokeColor = fillColor;
                        }
                        if (fillColor) {
                            this.fillColor(fillColor);
                            this.strokeColor(strokeColor);
                        }
                        return this.addContent("B".concat(this._windingRule(rule)));
                    },
                    clip: function clip(rule) {
                        return this.addContent("W".concat(this._windingRule(rule), " n"));
                    },
                    transform: function transform(m11, m12, m21, m22, dx, dy) {
                        // keep track of the current transformation matrix
                        var m = this._ctm;
                        var _m = _slicedToArray(m, 6), m0 = _m[0], m1 = _m[1], m2 = _m[2], m3 = _m[3], m4 = _m[4], m5 = _m[5];
                        m[0] = m0 * m11 + m2 * m12;
                        m[1] = m1 * m11 + m3 * m12;
                        m[2] = m0 * m21 + m2 * m22;
                        m[3] = m1 * m21 + m3 * m22;
                        m[4] = m0 * dx + m2 * dy + m4;
                        m[5] = m1 * dx + m3 * dy + m5;
                        var values = [
                            m11,
                            m12,
                            m21,
                            m22,
                            dx,
                            dy
                        ].map(function(v) {
                            return number$1(v);
                        }).join(" ");
                        return this.addContent("".concat(values, " cm"));
                    },
                    translate: function translate(x, y) {
                        return this.transform(1, 0, 0, 1, x, y);
                    },
                    rotate: function rotate(angle) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var y;
                        var rad = angle * Math.PI / 180;
                        var cos = Math.cos(rad);
                        var sin = Math.sin(rad);
                        var x = y = 0;
                        if (options.origin != null) {
                            var _options$origin = _slicedToArray(options.origin, 2);
                            x = _options$origin[0];
                            y = _options$origin[1];
                            var x1 = x * cos - y * sin;
                            var y1 = x * sin + y * cos;
                            x -= x1;
                            y -= y1;
                        }
                        return this.transform(cos, sin, -sin, cos, x, y);
                    },
                    scale: function scale(xFactor, yFactor) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var y;
                        if (yFactor == null) yFactor = xFactor;
                        if (typeof yFactor === "object") {
                            options = yFactor;
                            yFactor = xFactor;
                        }
                        var x = y = 0;
                        if (options.origin != null) {
                            var _options$origin2 = _slicedToArray(options.origin, 2);
                            x = _options$origin2[0];
                            y = _options$origin2[1];
                            x -= xFactor * x;
                            y -= yFactor * y;
                        }
                        return this.transform(xFactor, 0, 0, yFactor, x, y);
                    }
                };
                var WIN_ANSI_MAP = {
                    402: 131,
                    8211: 150,
                    8212: 151,
                    8216: 145,
                    8217: 146,
                    8218: 130,
                    8220: 147,
                    8221: 148,
                    8222: 132,
                    8224: 134,
                    8225: 135,
                    8226: 149,
                    8230: 133,
                    8364: 128,
                    8240: 137,
                    8249: 139,
                    8250: 155,
                    710: 136,
                    8482: 153,
                    338: 140,
                    339: 156,
                    732: 152,
                    352: 138,
                    353: 154,
                    376: 159,
                    381: 142,
                    382: 158
                };
                var characters = ".notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n  \nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n  \nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n  \ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n  \nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n  \nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n  \nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n  \nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis".split(/\s+/);
                var AFMFont = /*#__PURE__*/ function() {
                    _createClass(AFMFont, null, [
                        {
                            key: "open",
                            value: function open1(filename) {
                                return new AFMFont(fs.readFileSync(filename, "utf8"));
                            }
                        }
                    ]);
                    function AFMFont(contents) {
                        _classCallCheck(this, AFMFont);
                        this.contents = contents;
                        this.attributes = {};
                        this.glyphWidths = {};
                        this.boundingBoxes = {};
                        this.kernPairs = {};
                        this.parse(); // todo: remove charWidths since appears to not be used
                        this.charWidths = new Array(256);
                        for(var char = 0; char <= 255; char++)this.charWidths[char] = this.glyphWidths[characters[char]];
                        this.bbox = this.attributes["FontBBox"].split(/\s+/).map(function(e) {
                            return +e;
                        });
                        this.ascender = +(this.attributes["Ascender"] || 0);
                        this.descender = +(this.attributes["Descender"] || 0);
                        this.xHeight = +(this.attributes["XHeight"] || 0);
                        this.capHeight = +(this.attributes["CapHeight"] || 0);
                        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
                    }
                    _createClass(AFMFont, [
                        {
                            key: "parse",
                            value: function parse() {
                                var section = "";
                                var _iterator = _createForOfIteratorHelper(this.contents.split("\n")), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var line = _step.value;
                                        var match;
                                        var a;
                                        if (match = line.match(/^Start(\w+)/)) {
                                            section = match[1];
                                            continue;
                                        } else if (match = line.match(/^End(\w+)/)) {
                                            section = "";
                                            continue;
                                        }
                                        switch(section){
                                            case "FontMetrics":
                                                match = line.match(/(^\w+)\s+(.*)/);
                                                var key = match[1];
                                                var value = match[2];
                                                if (a = this.attributes[key]) {
                                                    if (!Array.isArray(a)) a = this.attributes[key] = [
                                                        a
                                                    ];
                                                    a.push(value);
                                                } else this.attributes[key] = value;
                                                break;
                                            case "CharMetrics":
                                                if (!/^CH?\s/.test(line)) continue;
                                                var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                                                this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                                                break;
                                            case "KernPairs":
                                                match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
                                                if (match) this.kernPairs[match[1] + "\0" + match[2]] = parseInt(match[3]);
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        },
                        {
                            key: "encodeText",
                            value: function encodeText(text) {
                                var res = [];
                                for(var i = 0, len = text.length; i < len; i++){
                                    var char = text.charCodeAt(i);
                                    char = WIN_ANSI_MAP[char] || char;
                                    res.push(char.toString(16));
                                }
                                return res;
                            }
                        },
                        {
                            key: "glyphsForString",
                            value: function glyphsForString(string) {
                                var glyphs = [];
                                for(var i = 0, len = string.length; i < len; i++){
                                    var charCode = string.charCodeAt(i);
                                    glyphs.push(this.characterToGlyph(charCode));
                                }
                                return glyphs;
                            }
                        },
                        {
                            key: "characterToGlyph",
                            value: function characterToGlyph(character) {
                                return characters[WIN_ANSI_MAP[character] || character] || ".notdef";
                            }
                        },
                        {
                            key: "widthOfGlyph",
                            value: function widthOfGlyph(glyph) {
                                return this.glyphWidths[glyph] || 0;
                            }
                        },
                        {
                            key: "getKernPair",
                            value: function getKernPair(left, right) {
                                return this.kernPairs[left + "\0" + right] || 0;
                            }
                        },
                        {
                            key: "advancesForGlyphs",
                            value: function advancesForGlyphs(glyphs) {
                                var advances = [];
                                for(var index = 0; index < glyphs.length; index++){
                                    var left = glyphs[index];
                                    var right = glyphs[index + 1];
                                    advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
                                }
                                return advances;
                            }
                        }
                    ]);
                    return AFMFont;
                }();
                var PDFFont = /*#__PURE__*/ function() {
                    function PDFFont() {
                        _classCallCheck(this, PDFFont);
                    }
                    _createClass(PDFFont, [
                        {
                            key: "encode",
                            value: function encode() {
                                throw new Error("Must be implemented by subclasses");
                            }
                        },
                        {
                            key: "widthOfString",
                            value: function widthOfString() {
                                throw new Error("Must be implemented by subclasses");
                            }
                        },
                        {
                            key: "ref",
                            value: function ref() {
                                return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
                            }
                        },
                        {
                            key: "finalize",
                            value: function finalize() {
                                if (this.embedded || this.dictionary == null) return;
                                this.embed();
                                return this.embedded = true;
                            }
                        },
                        {
                            key: "embed",
                            value: function embed() {
                                throw new Error("Must be implemented by subclasses");
                            }
                        },
                        {
                            key: "lineHeight",
                            value: function lineHeight(size, includeGap) {
                                if (includeGap == null) includeGap = false;
                                var gap = includeGap ? this.lineGap : 0;
                                return (this.ascender + gap - this.descender) / 1000 * size;
                            }
                        }
                    ]);
                    return PDFFont;
                }();
                var STANDARD_FONTS = {
                    Courier: function Courier() {
                        return fs.readFileSync(__dirname + "/data/Courier.afm", "utf8");
                    },
                    "Courier-Bold": function CourierBold() {
                        return fs.readFileSync(__dirname + "/data/Courier-Bold.afm", "utf8");
                    },
                    "Courier-Oblique": function CourierOblique() {
                        return fs.readFileSync(__dirname + "/data/Courier-Oblique.afm", "utf8");
                    },
                    "Courier-BoldOblique": function CourierBoldOblique() {
                        return fs.readFileSync(__dirname + "/data/Courier-BoldOblique.afm", "utf8");
                    },
                    Helvetica: function Helvetica() {
                        return fs.readFileSync(__dirname + "/data/Helvetica.afm", "utf8");
                    },
                    "Helvetica-Bold": function HelveticaBold() {
                        return fs.readFileSync(__dirname + "/data/Helvetica-Bold.afm", "utf8");
                    },
                    "Helvetica-Oblique": function HelveticaOblique() {
                        return fs.readFileSync(__dirname + "/data/Helvetica-Oblique.afm", "utf8");
                    },
                    "Helvetica-BoldOblique": function HelveticaBoldOblique() {
                        return fs.readFileSync(__dirname + "/data/Helvetica-BoldOblique.afm", "utf8");
                    },
                    "Times-Roman": function TimesRoman() {
                        return fs.readFileSync(__dirname + "/data/Times-Roman.afm", "utf8");
                    },
                    "Times-Bold": function TimesBold() {
                        return fs.readFileSync(__dirname + "/data/Times-Bold.afm", "utf8");
                    },
                    "Times-Italic": function TimesItalic() {
                        return fs.readFileSync(__dirname + "/data/Times-Italic.afm", "utf8");
                    },
                    "Times-BoldItalic": function TimesBoldItalic() {
                        return fs.readFileSync(__dirname + "/data/Times-BoldItalic.afm", "utf8");
                    },
                    Symbol: function Symbol1() {
                        return fs.readFileSync(__dirname + "/data/Symbol.afm", "utf8");
                    },
                    ZapfDingbats: function ZapfDingbats() {
                        return fs.readFileSync(__dirname + "/data/ZapfDingbats.afm", "utf8");
                    }
                };
                var StandardFont = /*#__PURE__*/ function(_PDFFont) {
                    _inherits(StandardFont, _PDFFont);
                    var _super = _createSuper(StandardFont);
                    function StandardFont(document1, name, id) {
                        var _this;
                        _classCallCheck(this, StandardFont);
                        _this = _super.call(this);
                        _this.document = document1;
                        _this.name = name;
                        _this.id = id;
                        _this.font = new AFMFont(STANDARD_FONTS[_this.name]());
                        var _this$font = _this.font;
                        _this.ascender = _this$font.ascender;
                        _this.descender = _this$font.descender;
                        _this.bbox = _this$font.bbox;
                        _this.lineGap = _this$font.lineGap;
                        _this.xHeight = _this$font.xHeight;
                        _this.capHeight = _this$font.capHeight;
                        return _this;
                    }
                    _createClass(StandardFont, [
                        {
                            key: "embed",
                            value: function embed() {
                                this.dictionary.data = {
                                    Type: "Font",
                                    BaseFont: this.name,
                                    Subtype: "Type1",
                                    Encoding: "WinAnsiEncoding"
                                };
                                return this.dictionary.end();
                            }
                        },
                        {
                            key: "encode",
                            value: function encode(text) {
                                var encoded = this.font.encodeText(text);
                                var glyphs = this.font.glyphsForString("".concat(text));
                                var advances = this.font.advancesForGlyphs(glyphs);
                                var positions = [];
                                for(var i = 0; i < glyphs.length; i++){
                                    var glyph = glyphs[i];
                                    positions.push({
                                        xAdvance: advances[i],
                                        yAdvance: 0,
                                        xOffset: 0,
                                        yOffset: 0,
                                        advanceWidth: this.font.widthOfGlyph(glyph)
                                    });
                                }
                                return [
                                    encoded,
                                    positions
                                ];
                            }
                        },
                        {
                            key: "widthOfString",
                            value: function widthOfString(string, size) {
                                var glyphs = this.font.glyphsForString("".concat(string));
                                var advances = this.font.advancesForGlyphs(glyphs);
                                var width = 0;
                                var _iterator = _createForOfIteratorHelper(advances), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var advance = _step.value;
                                        width += advance;
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                var scale = size / 1000;
                                return width * scale;
                            }
                        }
                    ], [
                        {
                            key: "isStandardFont",
                            value: function isStandardFont(name) {
                                return name in STANDARD_FONTS;
                            }
                        }
                    ]);
                    return StandardFont;
                }(PDFFont);
                var toHex = function toHex(num) {
                    return "0000".concat(num.toString(16)).slice(-4);
                };
                var EmbeddedFont = /*#__PURE__*/ function(_PDFFont) {
                    _inherits(EmbeddedFont, _PDFFont);
                    var _super = _createSuper(EmbeddedFont);
                    function EmbeddedFont(document1, font, id) {
                        var _this;
                        _classCallCheck(this, EmbeddedFont);
                        _this = _super.call(this);
                        _this.document = document1;
                        _this.font = font;
                        _this.id = id;
                        _this.subset = _this.font.createSubset();
                        _this.unicode = [
                            [
                                0
                            ]
                        ];
                        _this.widths = [
                            _this.font.getGlyph(0).advanceWidth
                        ];
                        _this.name = _this.font.postscriptName;
                        _this.scale = 1000 / _this.font.unitsPerEm;
                        _this.ascender = _this.font.ascent * _this.scale;
                        _this.descender = _this.font.descent * _this.scale;
                        _this.xHeight = _this.font.xHeight * _this.scale;
                        _this.capHeight = _this.font.capHeight * _this.scale;
                        _this.lineGap = _this.font.lineGap * _this.scale;
                        _this.bbox = _this.font.bbox;
                        if (document1.options.fontLayoutCache !== false) _this.layoutCache = Object.create(null);
                        return _this;
                    }
                    _createClass(EmbeddedFont, [
                        {
                            key: "layoutRun",
                            value: function layoutRun(text, features) {
                                var run = this.font.layout(text, features); // Normalize position values
                                for(var i = 0; i < run.positions.length; i++){
                                    var position = run.positions[i];
                                    for(var key in position)position[key] *= this.scale;
                                    position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
                                }
                                return run;
                            }
                        },
                        {
                            key: "layoutCached",
                            value: function layoutCached(text) {
                                if (!this.layoutCache) return this.layoutRun(text);
                                var cached;
                                if (cached = this.layoutCache[text]) return cached;
                                var run = this.layoutRun(text);
                                this.layoutCache[text] = run;
                                return run;
                            }
                        },
                        {
                            key: "layout",
                            value: function layout(text, features, onlyWidth) {
                                // Skip the cache if any user defined features are applied
                                if (features) return this.layoutRun(text, features);
                                var glyphs = onlyWidth ? null : [];
                                var positions = onlyWidth ? null : [];
                                var advanceWidth = 0; // Split the string by words to increase cache efficiency.
                                // For this purpose, spaces and tabs are a good enough delimeter.
                                var last = 0;
                                var index = 0;
                                while(index <= text.length){
                                    var needle;
                                    if (index === text.length && last < index || (needle = text.charAt(index), [
                                        " ",
                                        "	"
                                    ].includes(needle))) {
                                        var run = this.layoutCached(text.slice(last, ++index));
                                        if (!onlyWidth) {
                                            glyphs = glyphs.concat(run.glyphs);
                                            positions = positions.concat(run.positions);
                                        }
                                        advanceWidth += run.advanceWidth;
                                        last = index;
                                    } else index++;
                                }
                                return {
                                    glyphs: glyphs,
                                    positions: positions,
                                    advanceWidth: advanceWidth
                                };
                            }
                        },
                        {
                            key: "encode",
                            value: function encode(text, features) {
                                var _this$layout = this.layout(text, features), glyphs = _this$layout.glyphs, positions = _this$layout.positions;
                                var res = [];
                                for(var i = 0; i < glyphs.length; i++){
                                    var glyph = glyphs[i];
                                    var gid = this.subset.includeGlyph(glyph.id);
                                    res.push("0000".concat(gid.toString(16)).slice(-4));
                                    if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                                    if (this.unicode[gid] == null) this.unicode[gid] = glyph.codePoints;
                                }
                                return [
                                    res,
                                    positions
                                ];
                            }
                        },
                        {
                            key: "widthOfString",
                            value: function widthOfString(string, size, features) {
                                var width = this.layout(string, features, true).advanceWidth;
                                var scale = size / 1000;
                                return width * scale;
                            }
                        },
                        {
                            key: "embed",
                            value: function embed() {
                                var _this2 = this;
                                var isCFF = this.subset.cff != null;
                                var fontFile = this.document.ref();
                                if (isCFF) fontFile.data.Subtype = "CIDFontType0C";
                                this.subset.encodeStream().on("data", function(data) {
                                    return fontFile.write(data);
                                }).on("end", function() {
                                    return fontFile.end();
                                });
                                var familyClass = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : undefined) || 0) >> 8;
                                var flags = 0;
                                if (this.font.post.isFixedPitch) flags |= 1;
                                if (1 <= familyClass && familyClass <= 7) flags |= 2;
                                flags |= 4; // assume the font uses non-latin characters
                                if (familyClass === 10) flags |= 8;
                                if (this.font.head.macStyle.italic) flags |= 64;
                                 // generate a tag (6 uppercase letters. 17 is the char code offset from '0' to 'A'. 73 will map to 'Z')
                                var tag = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ].map(function(i) {
                                    return String.fromCharCode((_this2.id.charCodeAt(i) || 73) + 17);
                                }).join("");
                                var name = tag + "+" + this.font.postscriptName;
                                var bbox = this.font.bbox;
                                var descriptor = this.document.ref({
                                    Type: "FontDescriptor",
                                    FontName: name,
                                    Flags: flags,
                                    FontBBox: [
                                        bbox.minX * this.scale,
                                        bbox.minY * this.scale,
                                        bbox.maxX * this.scale,
                                        bbox.maxY * this.scale
                                    ],
                                    ItalicAngle: this.font.italicAngle,
                                    Ascent: this.ascender,
                                    Descent: this.descender,
                                    CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                                    XHeight: (this.font.xHeight || 0) * this.scale,
                                    StemV: 0
                                }); // not sure how to calculate this
                                if (isCFF) descriptor.data.FontFile3 = fontFile;
                                else descriptor.data.FontFile2 = fontFile;
                                if (this.document.subset) {
                                    var CIDSet = Buffer.from("FFFFFFFFC0", "hex");
                                    var CIDSetRef = this.document.ref();
                                    CIDSetRef.write(CIDSet);
                                    CIDSetRef.end();
                                    descriptor.data.CIDSet = CIDSetRef;
                                }
                                descriptor.end();
                                var descendantFontData = {
                                    Type: "Font",
                                    Subtype: "CIDFontType0",
                                    BaseFont: name,
                                    CIDSystemInfo: {
                                        Registry: new String("Adobe"),
                                        Ordering: new String("Identity"),
                                        Supplement: 0
                                    },
                                    FontDescriptor: descriptor,
                                    W: [
                                        0,
                                        this.widths
                                    ]
                                };
                                if (!isCFF) {
                                    descendantFontData.Subtype = "CIDFontType2";
                                    descendantFontData.CIDToGIDMap = "Identity";
                                }
                                var descendantFont = this.document.ref(descendantFontData);
                                descendantFont.end();
                                this.dictionary.data = {
                                    Type: "Font",
                                    Subtype: "Type0",
                                    BaseFont: name,
                                    Encoding: "Identity-H",
                                    DescendantFonts: [
                                        descendantFont
                                    ],
                                    ToUnicode: this.toUnicodeCmap()
                                };
                                return this.dictionary.end();
                            } // Maps the glyph ids encoded in the PDF back to unicode strings
                        },
                        {
                            key: "toUnicodeCmap",
                            value: function toUnicodeCmap() {
                                var cmap = this.document.ref();
                                var entries = [];
                                var _iterator = _createForOfIteratorHelper(this.unicode), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var codePoints = _step.value;
                                        var encoded = []; // encode codePoints to utf16
                                        var _iterator2 = _createForOfIteratorHelper(codePoints), _step2;
                                        try {
                                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                                var value = _step2.value;
                                                if (value > 0xffff) {
                                                    value -= 0x10000;
                                                    encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
                                                    value = 0xdc00 | value & 0x3ff;
                                                }
                                                encoded.push(toHex(value));
                                            }
                                        } catch (err) {
                                            _iterator2.e(err);
                                        } finally{
                                            _iterator2.f();
                                        }
                                        entries.push("<".concat(encoded.join(" "), ">"));
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                cmap.end("/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n1 beginbfrange\n<0000> <".concat(toHex(entries.length - 1), "> [").concat(entries.join(" "), "]\nendbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"));
                                return cmap;
                            }
                        }
                    ]);
                    return EmbeddedFont;
                }(PDFFont);
                var PDFFontFactory = /*#__PURE__*/ function() {
                    function PDFFontFactory() {
                        _classCallCheck(this, PDFFontFactory);
                    }
                    _createClass(PDFFontFactory, null, [
                        {
                            key: "open",
                            value: function open1(document1, src, family, id) {
                                var font;
                                if (typeof src === "string") {
                                    if (StandardFont.isStandardFont(src)) return new StandardFont(document1, src, id);
                                    src = fs.readFileSync(src);
                                }
                                if (Buffer.isBuffer(src)) font = _fontkit.default.create(src, family);
                                else if (src instanceof Uint8Array) font = _fontkit.default.create(Buffer.from(src), family);
                                else if (src instanceof ArrayBuffer) font = _fontkit.default.create(Buffer.from(new Uint8Array(src)), family);
                                if (font == null) throw new Error("Not a supported font format or standard PDF font.");
                                return new EmbeddedFont(document1, font, id);
                            }
                        }
                    ]);
                    return PDFFontFactory;
                }();
                var FontsMixin = {
                    initFonts: function initFonts() {
                        var defaultFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Helvetica";
                        // Lookup table for embedded fonts
                        this._fontFamilies = {};
                        this._fontCount = 0; // Font state
                        this._fontSize = 12;
                        this._font = null;
                        this._registeredFonts = {}; // Set the default font
                        if (defaultFont) this.font(defaultFont);
                    },
                    font: function font(src, family, size) {
                        var cacheKey, font;
                        if (typeof family === "number") {
                            size = family;
                            family = null;
                        } // check registered fonts if src is a string
                        if (typeof src === "string" && this._registeredFonts[src]) {
                            cacheKey = src;
                            var _this$_registeredFont = this._registeredFonts[src];
                            src = _this$_registeredFont.src;
                            family = _this$_registeredFont.family;
                        } else {
                            cacheKey = family || src;
                            if (typeof cacheKey !== "string") cacheKey = null;
                        }
                        if (size != null) this.fontSize(size);
                         // fast path: check if the font is already in the PDF
                        if (font = this._fontFamilies[cacheKey]) {
                            this._font = font;
                            return this;
                        } // load the font
                        var id = "F".concat(++this._fontCount);
                        this._font = PDFFontFactory.open(this, src, family, id); // check for existing font familes with the same name already in the PDF
                        // useful if the font was passed as a buffer
                        if (font = this._fontFamilies[this._font.name]) {
                            this._font = font;
                            return this;
                        } // save the font for reuse later
                        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
                        if (this._font.name) this._fontFamilies[this._font.name] = this._font;
                        return this;
                    },
                    fontSize: function fontSize(_fontSize) {
                        this._fontSize = _fontSize;
                        return this;
                    },
                    currentLineHeight: function currentLineHeight(includeGap) {
                        if (includeGap == null) includeGap = false;
                        return this._font.lineHeight(this._fontSize, includeGap);
                    },
                    registerFont: function registerFont(name, src, family) {
                        this._registeredFonts[name] = {
                            src: src,
                            family: family
                        };
                        return this;
                    }
                };
                var LineWrapper = /*#__PURE__*/ function(_EventEmitter) {
                    _inherits(LineWrapper, _EventEmitter);
                    var _super = _createSuper(LineWrapper);
                    function LineWrapper(document1, options) {
                        var _this;
                        _classCallCheck(this, LineWrapper);
                        _this = _super.call(this);
                        _this.document = document1;
                        _this.indent = options.indent || 0;
                        _this.characterSpacing = options.characterSpacing || 0;
                        _this.wordSpacing = options.wordSpacing === 0;
                        _this.columns = options.columns || 1;
                        _this.columnGap = options.columnGap != null ? options.columnGap : 18; // 1/4 inch
                        _this.lineWidth = (options.width - _this.columnGap * (_this.columns - 1)) / _this.columns;
                        _this.spaceLeft = _this.lineWidth;
                        _this.startX = _this.document.x;
                        _this.startY = _this.document.y;
                        _this.column = 1;
                        _this.ellipsis = options.ellipsis;
                        _this.continuedX = 0;
                        _this.features = options.features; // calculate the maximum Y position the text can appear at
                        if (options.height != null) {
                            _this.height = options.height;
                            _this.maxY = _this.startY + options.height;
                        } else _this.maxY = _this.document.page.maxY();
                         // handle paragraph indents
                        _this.on("firstLine", function(options) {
                            // if this is the first line of the text segment, and
                            // we're continuing where we left off, indent that much
                            // otherwise use the user specified indent option
                            var indent = _this.continuedX || _this.indent;
                            _this.document.x += indent;
                            _this.lineWidth -= indent;
                            return _this.once("line", function() {
                                _this.document.x -= indent;
                                _this.lineWidth += indent;
                                if (options.continued && !_this.continuedX) _this.continuedX = _this.indent;
                                if (!options.continued) return _this.continuedX = 0;
                            });
                        }); // handle left aligning last lines of paragraphs
                        _this.on("lastLine", function(options) {
                            var align = options.align;
                            if (align === "justify") options.align = "left";
                            _this.lastLine = true;
                            return _this.once("line", function() {
                                _this.document.y += options.paragraphGap || 0;
                                options.align = align;
                                return _this.lastLine = false;
                            });
                        });
                        return _this;
                    }
                    _createClass(LineWrapper, [
                        {
                            key: "wordWidth",
                            value: function wordWidth(word) {
                                return this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing;
                            }
                        },
                        {
                            key: "eachWord",
                            value: function eachWord(text, fn) {
                                // setup a unicode line breaker
                                var bk;
                                var breaker = new _linebreak.default(text);
                                var last = null;
                                var wordWidths = Object.create(null);
                                while(bk = breaker.nextBreak()){
                                    var shouldContinue;
                                    var word = text.slice((last != null ? last.position : undefined) || 0, bk.position);
                                    var w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word); // if the word is longer than the whole line, chop it up
                                    // TODO: break by grapheme clusters, not JS string characters
                                    if (w > this.lineWidth + this.continuedX) {
                                        // make some fake break objects
                                        var lbk = last;
                                        var fbk = {};
                                        while(word.length){
                                            // fit as much of the word as possible into the space we have
                                            var l, mightGrow;
                                            if (w > this.spaceLeft) {
                                                // start our check at the end of our available space - this method is faster than a loop of each character and it resolves
                                                // an issue with long loops when processing massive words, such as a huge number of spaces
                                                l = Math.ceil(this.spaceLeft / (w / word.length));
                                                w = this.wordWidth(word.slice(0, l));
                                                mightGrow = w <= this.spaceLeft && l < word.length;
                                            } else l = word.length;
                                            var mustShrink = w > this.spaceLeft && l > 0; // shrink or grow word as necessary after our near-guess above
                                            while(mustShrink || mightGrow)if (mustShrink) {
                                                w = this.wordWidth(word.slice(0, --l));
                                                mustShrink = w > this.spaceLeft && l > 0;
                                            } else {
                                                w = this.wordWidth(word.slice(0, ++l));
                                                mustShrink = w > this.spaceLeft && l > 0;
                                                mightGrow = w <= this.spaceLeft && l < word.length;
                                            }
                                             // check for the edge case where a single character cannot fit into a line.
                                            if (l === 0 && this.spaceLeft === this.lineWidth) l = 1;
                                             // send a required break unless this is the last piece and a linebreak is not specified
                                            fbk.required = bk.required || l < word.length;
                                            shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
                                            lbk = {
                                                required: false
                                            }; // get the remaining piece of the word
                                            word = word.slice(l);
                                            w = this.wordWidth(word);
                                            if (shouldContinue === false) break;
                                        }
                                    } else // otherwise just emit the break as it was given to us
                                    shouldContinue = fn(word, w, bk, last);
                                    if (shouldContinue === false) break;
                                    last = bk;
                                }
                            }
                        },
                        {
                            key: "wrap",
                            value: function wrap(text, options) {
                                var _this2 = this;
                                // override options from previous continued fragments
                                if (options.indent != null) this.indent = options.indent;
                                if (options.characterSpacing != null) this.characterSpacing = options.characterSpacing;
                                if (options.wordSpacing != null) this.wordSpacing = options.wordSpacing;
                                if (options.ellipsis != null) this.ellipsis = options.ellipsis;
                                 // make sure we're actually on the page
                                // and that the first line of is never by
                                // itself at the bottom of a page (orphans)
                                var nextY = this.document.y + this.document.currentLineHeight(true);
                                if (this.document.y > this.maxY || nextY > this.maxY) this.nextSection();
                                var buffer = "";
                                var textWidth = 0;
                                var wc = 0;
                                var lc = 0;
                                var y = this.document.y; // used to reset Y pos if options.continued (below)
                                var emitLine = function emitLine() {
                                    options.textWidth = textWidth + _this2.wordSpacing * (wc - 1);
                                    options.wordCount = wc;
                                    options.lineWidth = _this2.lineWidth;
                                    y = _this2.document.y;
                                    _this2.emit("line", buffer, options, _this2);
                                    return lc++;
                                };
                                this.emit("sectionStart", options, this);
                                this.eachWord(text, function(word, w, bk, last) {
                                    if (last == null || last.required) {
                                        _this2.emit("firstLine", options, _this2);
                                        _this2.spaceLeft = _this2.lineWidth;
                                    }
                                    if (w <= _this2.spaceLeft) {
                                        buffer += word;
                                        textWidth += w;
                                        wc++;
                                    }
                                    if (bk.required || w > _this2.spaceLeft) {
                                        // if the user specified a max height and an ellipsis, and is about to pass the
                                        // max height and max columns after the next line, append the ellipsis
                                        var lh = _this2.document.currentLineHeight(true);
                                        if (_this2.height != null && _this2.ellipsis && _this2.document.y + lh * 2 > _this2.maxY && _this2.column >= _this2.columns) {
                                            if (_this2.ellipsis === true) _this2.ellipsis = "\u2026";
                                             // map default ellipsis character
                                            buffer = buffer.replace(/\s+$/, "");
                                            textWidth = _this2.wordWidth(buffer + _this2.ellipsis); // remove characters from the buffer until the ellipsis fits
                                            // to avoid infinite loop need to stop while-loop if buffer is empty string
                                            while(buffer && textWidth > _this2.lineWidth){
                                                buffer = buffer.slice(0, -1).replace(/\s+$/, "");
                                                textWidth = _this2.wordWidth(buffer + _this2.ellipsis);
                                            } // need to add ellipsis only if there is enough space for it
                                            if (textWidth <= _this2.lineWidth) buffer = buffer + _this2.ellipsis;
                                            textWidth = _this2.wordWidth(buffer);
                                        }
                                        if (bk.required) {
                                            if (w > _this2.spaceLeft) {
                                                emitLine();
                                                buffer = word;
                                                textWidth = w;
                                                wc = 1;
                                            }
                                            _this2.emit("lastLine", options, _this2);
                                        }
                                        emitLine(); // if we've reached the edge of the page,
                                        // continue on a new page or column
                                        if (_this2.document.y + lh > _this2.maxY) {
                                            var shouldContinue = _this2.nextSection(); // stop if we reached the maximum height
                                            if (!shouldContinue) {
                                                wc = 0;
                                                buffer = "";
                                                return false;
                                            }
                                        } // reset the space left and buffer
                                        if (bk.required) {
                                            _this2.spaceLeft = _this2.lineWidth;
                                            buffer = "";
                                            textWidth = 0;
                                            return wc = 0;
                                        } else {
                                            // reset the space left and buffer
                                            _this2.spaceLeft = _this2.lineWidth - w;
                                            buffer = word;
                                            textWidth = w;
                                            return wc = 1;
                                        }
                                    } else return _this2.spaceLeft -= w;
                                });
                                if (wc > 0) {
                                    this.emit("lastLine", options, this);
                                    emitLine();
                                }
                                this.emit("sectionEnd", options, this); // if the wrap is set to be continued, save the X position
                                // to start the first line of the next segment at, and reset
                                // the y position
                                if (options.continued === true) {
                                    if (lc > 1) this.continuedX = 0;
                                    this.continuedX += options.textWidth || 0;
                                    return this.document.y = y;
                                } else return this.document.x = this.startX;
                            }
                        },
                        {
                            key: "nextSection",
                            value: function nextSection(options) {
                                this.emit("sectionEnd", options, this);
                                if (++this.column > this.columns) {
                                    // if a max height was specified by the user, we're done.
                                    // otherwise, the default is to make a new page at the bottom.
                                    if (this.height != null) return false;
                                    this.document.continueOnNewPage();
                                    this.column = 1;
                                    this.startY = this.document.page.margins.top;
                                    this.maxY = this.document.page.maxY();
                                    this.document.x = this.startX;
                                    if (this.document._fillColor) {
                                        var _this$document;
                                        (_this$document = this.document).fillColor.apply(_this$document, _toConsumableArray(this.document._fillColor));
                                    }
                                    this.emit("pageBreak", options, this);
                                } else {
                                    this.document.x += this.lineWidth + this.columnGap;
                                    this.document.y = this.startY;
                                    this.emit("columnBreak", options, this);
                                }
                                this.emit("sectionStart", options, this);
                                return true;
                            }
                        }
                    ]);
                    return LineWrapper;
                }(_events.EventEmitter);
                var number$2 = PDFObject.number;
                var TextMixin = {
                    initText: function initText() {
                        this._line = this._line.bind(this); // Current coordinates
                        this.x = 0;
                        this.y = 0;
                        return this._lineGap = 0;
                    },
                    lineGap: function lineGap(_lineGap) {
                        this._lineGap = _lineGap;
                        return this;
                    },
                    moveDown: function moveDown(lines) {
                        if (lines == null) lines = 1;
                        this.y += this.currentLineHeight(true) * lines + this._lineGap;
                        return this;
                    },
                    moveUp: function moveUp(lines) {
                        if (lines == null) lines = 1;
                        this.y -= this.currentLineHeight(true) * lines + this._lineGap;
                        return this;
                    },
                    _text: function _text(text, x, y, options, lineCallback) {
                        var _this = this;
                        options = this._initOptions(x, y, options); // Convert text to a string
                        text = text == null ? "" : "".concat(text); // if the wordSpacing option is specified, remove multiple consecutive spaces
                        if (options.wordSpacing) text = text.replace(/\s{2,}/g, " ");
                        var addStructure = function addStructure() {
                            if (options.structParent) options.structParent.add(_this.struct(options.structType || "P", [
                                _this.markStructureContent(options.structType || "P")
                            ]));
                        }; // word wrapping
                        if (options.width) {
                            var wrapper = this._wrapper;
                            if (!wrapper) {
                                wrapper = new LineWrapper(this, options);
                                wrapper.on("line", lineCallback);
                                wrapper.on("firstLine", addStructure);
                            }
                            this._wrapper = options.continued ? wrapper : null;
                            this._textOptions = options.continued ? options : null;
                            wrapper.wrap(text, options); // render paragraphs as single lines
                        } else {
                            var _iterator = _createForOfIteratorHelper(text.split("\n")), _step;
                            try {
                                for(_iterator.s(); !(_step = _iterator.n()).done;){
                                    var line = _step.value;
                                    addStructure();
                                    lineCallback(line, options);
                                }
                            } catch (err) {
                                _iterator.e(err);
                            } finally{
                                _iterator.f();
                            }
                        }
                        return this;
                    },
                    text: function text(_text2, x, y, options) {
                        return this._text(_text2, x, y, options, this._line);
                    },
                    widthOfString: function widthOfString(string) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
                    },
                    heightOfString: function heightOfString(text, options) {
                        var _this2 = this;
                        var x = this.x, y = this.y;
                        options = this._initOptions(options);
                        options.height = Infinity; // don't break pages
                        var lineGap = options.lineGap || this._lineGap || 0;
                        this._text(text, this.x, this.y, options, function() {
                            return _this2.y += _this2.currentLineHeight(true) + lineGap;
                        });
                        var height = this.y - y;
                        this.x = x;
                        this.y = y;
                        return height;
                    },
                    list: function list(_list, x, y, options, wrapper) {
                        var _this3 = this;
                        options = this._initOptions(x, y, options);
                        var listType = options.listType || "bullet";
                        var unit = Math.round(this._font.ascender / 1000 * this._fontSize);
                        var midLine = unit / 2;
                        var r = options.bulletRadius || unit / 3;
                        var indent = options.textIndent || (listType === "bullet" ? r * 5 : unit * 2);
                        var itemIndent = options.bulletIndent || (listType === "bullet" ? r * 8 : unit * 2);
                        var level = 1;
                        var items = [];
                        var levels = [];
                        var numbers = [];
                        var flatten = function flatten(list) {
                            var n = 1;
                            for(var _i = 0; _i < list.length; _i++){
                                var item = list[_i];
                                if (Array.isArray(item)) {
                                    level++;
                                    flatten(item);
                                    level--;
                                } else {
                                    items.push(item);
                                    levels.push(level);
                                    if (listType !== "bullet") numbers.push(n++);
                                }
                            }
                        };
                        flatten(_list);
                        var label = function label(n) {
                            switch(listType){
                                case "numbered":
                                    return "".concat(n, ".");
                                case "lettered":
                                    var letter = String.fromCharCode((n - 1) % 26 + 65);
                                    var times = Math.floor((n - 1) / 26 + 1);
                                    var text = Array(times + 1).join(letter);
                                    return "".concat(text, ".");
                            }
                        };
                        wrapper = new LineWrapper(this, options);
                        wrapper.on("line", this._line);
                        level = 1;
                        var i = 0;
                        wrapper.on("firstLine", function() {
                            var item, itemType, labelType, bodyType;
                            if (options.structParent) {
                                if (options.structTypes) {
                                    var _options$structTypes = _slicedToArray(options.structTypes, 3);
                                    itemType = _options$structTypes[0];
                                    labelType = _options$structTypes[1];
                                    bodyType = _options$structTypes[2];
                                } else {
                                    itemType = "LI";
                                    labelType = "Lbl";
                                    bodyType = "LBody";
                                }
                            }
                            if (itemType) {
                                item = _this3.struct(itemType);
                                options.structParent.add(item);
                            } else if (options.structParent) item = options.structParent;
                            var l;
                            if ((l = levels[i++]) !== level) {
                                var diff = itemIndent * (l - level);
                                _this3.x += diff;
                                wrapper.lineWidth -= diff;
                                level = l;
                            }
                            if (item && (labelType || bodyType)) item.add(_this3.struct(labelType || bodyType, [
                                _this3.markStructureContent(labelType || bodyType)
                            ]));
                            switch(listType){
                                case "bullet":
                                    _this3.circle(_this3.x - indent + r, _this3.y + midLine, r);
                                    _this3.fill();
                                    break;
                                case "numbered":
                                case "lettered":
                                    var text = label(numbers[i - 1]);
                                    _this3._fragment(text, _this3.x - indent, _this3.y, options);
                                    break;
                            }
                            if (item && labelType && bodyType) item.add(_this3.struct(bodyType, [
                                _this3.markStructureContent(bodyType)
                            ]));
                            if (item && item !== options.structParent) item.end();
                        });
                        wrapper.on("sectionStart", function() {
                            var pos = indent + itemIndent * (level - 1);
                            _this3.x += pos;
                            return wrapper.lineWidth -= pos;
                        });
                        wrapper.on("sectionEnd", function() {
                            var pos = indent + itemIndent * (level - 1);
                            _this3.x -= pos;
                            return wrapper.lineWidth += pos;
                        });
                        wrapper.wrap(items.join("\n"), options);
                        return this;
                    },
                    _initOptions: function _initOptions() {
                        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var y = arguments.length > 1 ? arguments[1] : undefined;
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        if (typeof x === "object") {
                            options = x;
                            x = null;
                        } // clone options object
                        var result = Object.assign({}, options); // extend options with previous values for continued text
                        if (this._textOptions) for(var key in this._textOptions){
                            var val = this._textOptions[key];
                            if (key !== "continued") {
                                if (result[key] === undefined) result[key] = val;
                            }
                        }
                         // Update the current position
                        if (x != null) this.x = x;
                        if (y != null) this.y = y;
                         // wrap to margins if no x or y position passed
                        if (result.lineBreak !== false) {
                            if (result.width == null) result.width = this.page.width - this.x - this.page.margins.right;
                            result.width = Math.max(result.width, 0);
                        }
                        if (!result.columns) result.columns = 0;
                        if (result.columnGap == null) result.columnGap = 18;
                         // 1/4 inch
                        return result;
                    },
                    _line: function _line(text) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var wrapper = arguments.length > 2 ? arguments[2] : undefined;
                        this._fragment(text, this.x, this.y, options);
                        var lineGap = options.lineGap || this._lineGap || 0;
                        if (!wrapper) return this.x += this.widthOfString(text);
                        else return this.y += this.currentLineHeight(true) + lineGap;
                    },
                    _fragment: function _fragment(text, x, y, options) {
                        var _this4 = this;
                        var dy, encoded, i, positions, textWidth, words;
                        text = "".concat(text).replace(/\n/g, "");
                        if (text.length === 0) return;
                         // handle options
                        var align = options.align || "left";
                        var wordSpacing = options.wordSpacing || 0;
                        var characterSpacing = options.characterSpacing || 0; // text alignments
                        if (options.width) switch(align){
                            case "right":
                                textWidth = this.widthOfString(text.replace(/\s+$/, ""), options);
                                x += options.lineWidth - textWidth;
                                break;
                            case "center":
                                x += options.lineWidth / 2 - options.textWidth / 2;
                                break;
                            case "justify":
                                // calculate the word spacing value
                                words = text.trim().split(/\s+/);
                                textWidth = this.widthOfString(text.replace(/\s+/g, ""), options);
                                var spaceWidth = this.widthOfString(" ") + characterSpacing;
                                wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                                break;
                        }
                         // text baseline alignments based on http://wiki.apache.org/xmlgraphics-fop/LineLayout/AlignmentHandling
                        if (typeof options.baseline === "number") dy = -options.baseline;
                        else {
                            switch(options.baseline){
                                case "svg-middle":
                                    dy = 0.5 * this._font.xHeight;
                                    break;
                                case "middle":
                                case "svg-central":
                                    dy = 0.5 * (this._font.descender + this._font.ascender);
                                    break;
                                case "bottom":
                                case "ideographic":
                                    dy = this._font.descender;
                                    break;
                                case "alphabetic":
                                    dy = 0;
                                    break;
                                case "mathematical":
                                    dy = 0.5 * this._font.ascender;
                                    break;
                                case "hanging":
                                    dy = 0.8 * this._font.ascender;
                                    break;
                                case "top":
                                    dy = this._font.ascender;
                                    break;
                                default:
                                    dy = this._font.ascender;
                            }
                            dy = dy / 1000 * this._fontSize;
                        } // calculate the actual rendered width of the string after word and character spacing
                        var renderedWidth = options.textWidth + wordSpacing * (options.wordCount - 1) + characterSpacing * (text.length - 1); // create link annotations if the link option is given
                        if (options.link != null) this.link(x, y, renderedWidth, this.currentLineHeight(), options.link);
                        if (options.goTo != null) this.goTo(x, y, renderedWidth, this.currentLineHeight(), options.goTo);
                        if (options.destination != null) this.addNamedDestination(options.destination, "XYZ", x, y, null);
                         // create underline
                        if (options.underline) {
                            this.save();
                            if (!options.stroke) this.strokeColor.apply(this, _toConsumableArray(this._fillColor || []));
                            var lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                            this.lineWidth(lineWidth);
                            var lineY = y + this.currentLineHeight() - lineWidth;
                            this.moveTo(x, lineY);
                            this.lineTo(x + renderedWidth, lineY);
                            this.stroke();
                            this.restore();
                        } // create strikethrough line
                        if (options.strike) {
                            this.save();
                            if (!options.stroke) this.strokeColor.apply(this, _toConsumableArray(this._fillColor || []));
                            var _lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                            this.lineWidth(_lineWidth);
                            var _lineY = y + this.currentLineHeight() / 2;
                            this.moveTo(x, _lineY);
                            this.lineTo(x + renderedWidth, _lineY);
                            this.stroke();
                            this.restore();
                        }
                        this.save(); // oblique (angle in degrees or boolean)
                        if (options.oblique) {
                            var skew;
                            if (typeof options.oblique === "number") skew = -Math.tan(options.oblique * Math.PI / 180);
                            else skew = -0.25;
                            this.transform(1, 0, 0, 1, x, y);
                            this.transform(1, 0, skew, 1, -skew * dy, 0);
                            this.transform(1, 0, 0, 1, -x, -y);
                        } // flip coordinate system
                        this.transform(1, 0, 0, -1, 0, this.page.height);
                        y = this.page.height - y - dy; // add current font to page if necessary
                        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
                         // begin the text object
                        this.addContent("BT"); // text position
                        this.addContent("1 0 0 1 ".concat(number$2(x), " ").concat(number$2(y), " Tm")); // font and font size
                        this.addContent("/".concat(this._font.id, " ").concat(number$2(this._fontSize), " Tf")); // rendering mode
                        var mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
                        if (mode) this.addContent("".concat(mode, " Tr"));
                         // Character spacing
                        if (characterSpacing) this.addContent("".concat(number$2(characterSpacing), " Tc"));
                         // Add the actual text
                        // If we have a word spacing value, we need to encode each word separately
                        // since the normal Tw operator only works on character code 32, which isn't
                        // used for embedded fonts.
                        if (wordSpacing) {
                            words = text.trim().split(/\s+/);
                            wordSpacing += this.widthOfString(" ") + characterSpacing;
                            wordSpacing *= 1000 / this._fontSize;
                            encoded = [];
                            positions = [];
                            var _iterator2 = _createForOfIteratorHelper(words), _step2;
                            try {
                                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                    var word = _step2.value;
                                    var _this$_font$encode = this._font.encode(word, options.features), _this$_font$encode2 = _slicedToArray(_this$_font$encode, 2), encodedWord = _this$_font$encode2[0], positionsWord = _this$_font$encode2[1];
                                    encoded = encoded.concat(encodedWord);
                                    positions = positions.concat(positionsWord); // add the word spacing to the end of the word
                                    // clone object because of cache
                                    var space = {};
                                    var object = positions[positions.length - 1];
                                    for(var key in object){
                                        var val = object[key];
                                        space[key] = val;
                                    }
                                    space.xAdvance += wordSpacing;
                                    positions[positions.length - 1] = space;
                                }
                            } catch (err) {
                                _iterator2.e(err);
                            } finally{
                                _iterator2.f();
                            }
                        } else {
                            var _this$_font$encode3 = this._font.encode(text, options.features);
                            var _this$_font$encode4 = _slicedToArray(_this$_font$encode3, 2);
                            encoded = _this$_font$encode4[0];
                            positions = _this$_font$encode4[1];
                        }
                        var scale = this._fontSize / 1000;
                        var commands = [];
                        var last = 0;
                        var hadOffset = false; // Adds a segment of text to the TJ command buffer
                        var addSegment = function addSegment(cur) {
                            if (last < cur) {
                                var hex = encoded.slice(last, cur).join("");
                                var advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                                commands.push("<".concat(hex, "> ").concat(number$2(-advance)));
                            }
                            return last = cur;
                        }; // Flushes the current TJ commands to the output stream
                        var flush = function flush(i) {
                            addSegment(i);
                            if (commands.length > 0) {
                                _this4.addContent("[".concat(commands.join(" "), "] TJ"));
                                return commands.length = 0;
                            }
                        };
                        for(i = 0; i < positions.length; i++){
                            // If we have an x or y offset, we have to break out of the current TJ command
                            // so we can move the text position.
                            var pos = positions[i];
                            if (pos.xOffset || pos.yOffset) {
                                // Flush the current buffer
                                flush(i); // Move the text position and flush just the current character
                                this.addContent("1 0 0 1 ".concat(number$2(x + pos.xOffset * scale), " ").concat(number$2(y + pos.yOffset * scale), " Tm"));
                                flush(i + 1);
                                hadOffset = true;
                            } else {
                                // If the last character had an offset, reset the text position
                                if (hadOffset) {
                                    this.addContent("1 0 0 1 ".concat(number$2(x), " ").concat(number$2(y), " Tm"));
                                    hadOffset = false;
                                } // Group segments that don't have any advance adjustments
                                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
                            }
                            x += pos.xAdvance * scale;
                        } // Flush any remaining commands
                        flush(i); // end the text object
                        this.addContent("ET"); // restore flipped coordinate system
                        return this.restore();
                    }
                };
                var MARKERS = [
                    0xffc0,
                    0xffc1,
                    0xffc2,
                    0xffc3,
                    0xffc5,
                    0xffc6,
                    0xffc7,
                    0xffc8,
                    0xffc9,
                    0xffca,
                    0xffcb,
                    0xffcc,
                    0xffcd,
                    0xffce,
                    0xffcf
                ];
                var COLOR_SPACE_MAP = {
                    1: "DeviceGray",
                    3: "DeviceRGB",
                    4: "DeviceCMYK"
                };
                var JPEG = /*#__PURE__*/ function() {
                    function JPEG(data, label) {
                        _classCallCheck(this, JPEG);
                        var marker;
                        this.data = data;
                        this.label = label;
                        if (this.data.readUInt16BE(0) !== 0xffd8) throw "SOI not found in JPEG";
                        var pos = 2;
                        while(pos < this.data.length){
                            marker = this.data.readUInt16BE(pos);
                            pos += 2;
                            if (MARKERS.includes(marker)) break;
                            pos += this.data.readUInt16BE(pos);
                        }
                        if (!MARKERS.includes(marker)) throw "Invalid JPEG.";
                        pos += 2;
                        this.bits = this.data[pos++];
                        this.height = this.data.readUInt16BE(pos);
                        pos += 2;
                        this.width = this.data.readUInt16BE(pos);
                        pos += 2;
                        var channels = this.data[pos++];
                        this.colorSpace = COLOR_SPACE_MAP[channels];
                        this.obj = null;
                    }
                    _createClass(JPEG, [
                        {
                            key: "embed",
                            value: function embed(document1) {
                                if (this.obj) return;
                                this.obj = document1.ref({
                                    Type: "XObject",
                                    Subtype: "Image",
                                    BitsPerComponent: this.bits,
                                    Width: this.width,
                                    Height: this.height,
                                    ColorSpace: this.colorSpace,
                                    Filter: "DCTDecode"
                                }); // add extra decode params for CMYK images. By swapping the
                                // min and max values from the default, we invert the colors. See
                                // section 4.8.4 of the spec.
                                if (this.colorSpace === "DeviceCMYK") this.obj.data["Decode"] = [
                                    1.0,
                                    0.0,
                                    1.0,
                                    0.0,
                                    1.0,
                                    0.0,
                                    1.0,
                                    0.0
                                ];
                                this.obj.end(this.data); // free memory
                                return this.data = null;
                            }
                        }
                    ]);
                    return JPEG;
                }();
                var PNGImage = /*#__PURE__*/ function() {
                    function PNGImage(data, label) {
                        _classCallCheck(this, PNGImage);
                        this.label = label;
                        this.image = new _pngJs.default(data);
                        this.width = this.image.width;
                        this.height = this.image.height;
                        this.imgData = this.image.imgData;
                        this.obj = null;
                    }
                    _createClass(PNGImage, [
                        {
                            key: "embed",
                            value: function embed(document1) {
                                var dataDecoded = false;
                                this.document = document1;
                                if (this.obj) return;
                                var hasAlphaChannel = this.image.hasAlphaChannel;
                                var isInterlaced = this.image.interlaceMethod === 1;
                                this.obj = this.document.ref({
                                    Type: "XObject",
                                    Subtype: "Image",
                                    BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
                                    Width: this.width,
                                    Height: this.height,
                                    Filter: "FlateDecode"
                                });
                                if (!hasAlphaChannel) {
                                    var params = this.document.ref({
                                        Predictor: isInterlaced ? 1 : 15,
                                        Colors: this.image.colors,
                                        BitsPerComponent: this.image.bits,
                                        Columns: this.width
                                    });
                                    this.obj.data["DecodeParms"] = params;
                                    params.end();
                                }
                                if (this.image.palette.length === 0) this.obj.data["ColorSpace"] = this.image.colorSpace;
                                else {
                                    // embed the color palette in the PDF as an object stream
                                    var palette = this.document.ref();
                                    palette.end(Buffer.from(this.image.palette)); // build the color space array for the image
                                    this.obj.data["ColorSpace"] = [
                                        "Indexed",
                                        "DeviceRGB",
                                        this.image.palette.length / 3 - 1,
                                        palette
                                    ];
                                } // For PNG color types 0, 2 and 3, the transparency data is stored in
                                // a dedicated PNG chunk.
                                if (this.image.transparency.grayscale != null) {
                                    // Use Color Key Masking (spec section 4.8.5)
                                    // An array with N elements, where N is two times the number of color components.
                                    var val = this.image.transparency.grayscale;
                                    this.obj.data["Mask"] = [
                                        val,
                                        val
                                    ];
                                } else if (this.image.transparency.rgb) {
                                    // Use Color Key Masking (spec section 4.8.5)
                                    // An array with N elements, where N is two times the number of color components.
                                    var rgb = this.image.transparency.rgb;
                                    var mask = [];
                                    var _iterator = _createForOfIteratorHelper(rgb), _step;
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            var x = _step.value;
                                            mask.push(x, x);
                                        }
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    this.obj.data["Mask"] = mask;
                                } else if (this.image.transparency.indexed) {
                                    // Create a transparency SMask for the image based on the data
                                    // in the PLTE and tRNS sections. See below for details on SMasks.
                                    dataDecoded = true;
                                    return this.loadIndexedAlphaChannel();
                                } else if (hasAlphaChannel) {
                                    // For PNG color types 4 and 6, the transparency data is stored as a alpha
                                    // channel mixed in with the main image data. Separate this data out into an
                                    // SMask object and store it separately in the PDF.
                                    dataDecoded = true;
                                    return this.splitAlphaChannel();
                                }
                                if (isInterlaced && !dataDecoded) return this.decodeData();
                                this.finalize();
                            }
                        },
                        {
                            key: "finalize",
                            value: function finalize() {
                                if (this.alphaChannel) {
                                    var sMask = this.document.ref({
                                        Type: "XObject",
                                        Subtype: "Image",
                                        Height: this.height,
                                        Width: this.width,
                                        BitsPerComponent: 8,
                                        Filter: "FlateDecode",
                                        ColorSpace: "DeviceGray",
                                        Decode: [
                                            0,
                                            1
                                        ]
                                    });
                                    sMask.end(this.alphaChannel);
                                    this.obj.data["SMask"] = sMask;
                                } // add the actual image data
                                this.obj.end(this.imgData); // free memory
                                this.image = null;
                                return this.imgData = null;
                            }
                        },
                        {
                            key: "splitAlphaChannel",
                            value: function splitAlphaChannel() {
                                var _this = this;
                                return this.image.decodePixels(function(pixels) {
                                    var a, p;
                                    var colorCount = _this.image.colors;
                                    var pixelCount = _this.width * _this.height;
                                    var imgData = Buffer.alloc(pixelCount * colorCount);
                                    var alphaChannel = Buffer.alloc(pixelCount);
                                    var i = p = a = 0;
                                    var len = pixels.length; // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)
                                    var skipByteCount = _this.image.bits === 16 ? 1 : 0;
                                    while(i < len){
                                        for(var colorIndex = 0; colorIndex < colorCount; colorIndex++){
                                            imgData[p++] = pixels[i++];
                                            i += skipByteCount;
                                        }
                                        alphaChannel[a++] = pixels[i++];
                                        i += skipByteCount;
                                    }
                                    _this.imgData = _zlib.default.deflateSync(imgData);
                                    _this.alphaChannel = _zlib.default.deflateSync(alphaChannel);
                                    return _this.finalize();
                                });
                            }
                        },
                        {
                            key: "loadIndexedAlphaChannel",
                            value: function loadIndexedAlphaChannel() {
                                var _this2 = this;
                                var transparency = this.image.transparency.indexed;
                                return this.image.decodePixels(function(pixels) {
                                    var alphaChannel = Buffer.alloc(_this2.width * _this2.height);
                                    var i = 0;
                                    for(var j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
                                    _this2.alphaChannel = _zlib.default.deflateSync(alphaChannel);
                                    return _this2.finalize();
                                });
                            }
                        },
                        {
                            key: "decodeData",
                            value: function decodeData() {
                                var _this3 = this;
                                this.image.decodePixels(function(pixels) {
                                    _this3.imgData = _zlib.default.deflateSync(pixels);
                                    _this3.finalize();
                                });
                            }
                        }
                    ]);
                    return PNGImage;
                }();
                var PDFImage = /*#__PURE__*/ function() {
                    function PDFImage() {
                        _classCallCheck(this, PDFImage);
                    }
                    _createClass(PDFImage, null, [
                        {
                            key: "open",
                            value: function open1(src, label) {
                                var data;
                                if (Buffer.isBuffer(src)) data = src;
                                else if (src instanceof ArrayBuffer) data = Buffer.from(new Uint8Array(src));
                                else {
                                    var match;
                                    if (match = /^data:.+;base64,(.*)$/.exec(src)) data = Buffer.from(match[1], "base64");
                                    else {
                                        data = fs.readFileSync(src);
                                        if (!data) return;
                                    }
                                }
                                if (data[0] === 0xff && data[1] === 0xd8) return new JPEG(data, label);
                                else if (data[0] === 0x89 && data.toString("ascii", 1, 4) === "PNG") return new PNGImage(data, label);
                                else throw new Error("Unknown image format.");
                            }
                        }
                    ]);
                    return PDFImage;
                }();
                var ImagesMixin = {
                    initImages: function initImages() {
                        this._imageRegistry = {};
                        return this._imageCount = 0;
                    },
                    image: function image(src, x, y) {
                        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                        var bh, bp, bw, image, ip, left, left1;
                        if (typeof x === "object") {
                            options = x;
                            x = null;
                        }
                        x = (left = x != null ? x : options.x) != null ? left : this.x;
                        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
                        if (typeof src === "string") image = this._imageRegistry[src];
                        if (!image) {
                            if (src.width && src.height) image = src;
                            else image = this.openImage(src);
                        }
                        if (!image.obj) image.embed(this);
                        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
                        var w = options.width || image.width;
                        var h = options.height || image.height;
                        if (options.width && !options.height) {
                            var wp = w / image.width;
                            w = image.width * wp;
                            h = image.height * wp;
                        } else if (options.height && !options.width) {
                            var hp = h / image.height;
                            w = image.width * hp;
                            h = image.height * hp;
                        } else if (options.scale) {
                            w = image.width * options.scale;
                            h = image.height * options.scale;
                        } else if (options.fit) {
                            var _options$fit = _slicedToArray(options.fit, 2);
                            bw = _options$fit[0];
                            bh = _options$fit[1];
                            bp = bw / bh;
                            ip = image.width / image.height;
                            if (ip > bp) {
                                w = bw;
                                h = bw / ip;
                            } else {
                                h = bh;
                                w = bh * ip;
                            }
                        } else if (options.cover) {
                            var _options$cover = _slicedToArray(options.cover, 2);
                            bw = _options$cover[0];
                            bh = _options$cover[1];
                            bp = bw / bh;
                            ip = image.width / image.height;
                            if (ip > bp) {
                                h = bh;
                                w = bh * ip;
                            } else {
                                w = bw;
                                h = bw / ip;
                            }
                        }
                        if (options.fit || options.cover) {
                            if (options.align === "center") x = x + bw / 2 - w / 2;
                            else if (options.align === "right") x = x + bw - w;
                            if (options.valign === "center") y = y + bh / 2 - h / 2;
                            else if (options.valign === "bottom") y = y + bh - h;
                        } // create link annotations if the link option is given
                        if (options.link != null) this.link(x, y, w, h, options.link);
                        if (options.goTo != null) this.goTo(x, y, w, h, options.goTo);
                        if (options.destination != null) this.addNamedDestination(options.destination, "XYZ", x, y, null);
                         // Set the current y position to below the image if it is in the document flow
                        if (this.y === y) this.y += h;
                        this.save();
                        this.transform(w, 0, 0, -h, x, y + h);
                        this.addContent("/".concat(image.label, " Do"));
                        this.restore();
                        return this;
                    },
                    openImage: function openImage(src) {
                        var image;
                        if (typeof src === "string") image = this._imageRegistry[src];
                        if (!image) {
                            image = PDFImage.open(src, "I".concat(++this._imageCount));
                            if (typeof src === "string") this._imageRegistry[src] = image;
                        }
                        return image;
                    }
                };
                var AnnotationsMixin = {
                    annotate: function annotate(x, y, w, h, options) {
                        options.Type = "Annot";
                        options.Rect = this._convertRect(x, y, w, h);
                        options.Border = [
                            0,
                            0,
                            0
                        ];
                        if (options.Subtype === "Link" && typeof options.F === "undefined") options.F = 4; // Print Annotation Flag
                        if (options.Subtype !== "Link") {
                            if (options.C == null) options.C = this._normalizeColor(options.color || [
                                0,
                                0,
                                0
                            ]);
                        } // convert colors
                        delete options.color;
                        if (typeof options.Dest === "string") options.Dest = new String(options.Dest);
                         // Capitalize keys
                        for(var key in options){
                            var val = options[key];
                            options[key[0].toUpperCase() + key.slice(1)] = val;
                        }
                        var ref = this.ref(options);
                        this.page.annotations.push(ref);
                        ref.end();
                        return this;
                    },
                    note: function note(x, y, w, h, contents) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = "Text";
                        options.Contents = new String(contents);
                        options.Name = "Comment";
                        if (options.color == null) options.color = [
                            243,
                            223,
                            92
                        ];
                        return this.annotate(x, y, w, h, options);
                    },
                    goTo: function goTo(x, y, w, h, name) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = "Link";
                        options.A = this.ref({
                            S: "GoTo",
                            D: new String(name)
                        });
                        options.A.end();
                        return this.annotate(x, y, w, h, options);
                    },
                    link: function link(x, y, w, h, url) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = "Link";
                        if (typeof url === "number") {
                            // Link to a page in the document (the page must already exist)
                            var pages = this._root.data.Pages.data;
                            if (url >= 0 && url < pages.Kids.length) {
                                options.A = this.ref({
                                    S: "GoTo",
                                    D: [
                                        pages.Kids[url],
                                        "XYZ",
                                        null,
                                        null,
                                        null
                                    ]
                                });
                                options.A.end();
                            } else throw new Error("The document has no page ".concat(url));
                        } else {
                            // Link to an external url
                            options.A = this.ref({
                                S: "URI",
                                URI: new String(url)
                            });
                            options.A.end();
                        }
                        return this.annotate(x, y, w, h, options);
                    },
                    _markup: function _markup(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        var _this$_convertRect = this._convertRect(x, y, w, h), _this$_convertRect2 = _slicedToArray(_this$_convertRect, 4), x1 = _this$_convertRect2[0], y1 = _this$_convertRect2[1], x2 = _this$_convertRect2[2], y2 = _this$_convertRect2[3];
                        options.QuadPoints = [
                            x1,
                            y2,
                            x2,
                            y2,
                            x1,
                            y1,
                            x2,
                            y1
                        ];
                        options.Contents = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    highlight: function highlight(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = "Highlight";
                        if (options.color == null) options.color = [
                            241,
                            238,
                            148
                        ];
                        return this._markup(x, y, w, h, options);
                    },
                    underline: function underline(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = "Underline";
                        return this._markup(x, y, w, h, options);
                    },
                    strike: function strike(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = "StrikeOut";
                        return this._markup(x, y, w, h, options);
                    },
                    lineAnnotation: function lineAnnotation(x1, y1, x2, y2) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = "Line";
                        options.Contents = new String();
                        options.L = [
                            x1,
                            this.page.height - y1,
                            x2,
                            this.page.height - y2
                        ];
                        return this.annotate(x1, y1, x2, y2, options);
                    },
                    rectAnnotation: function rectAnnotation(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = "Square";
                        options.Contents = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    ellipseAnnotation: function ellipseAnnotation(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = "Circle";
                        options.Contents = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    textAnnotation: function textAnnotation(x, y, w, h, text) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = "FreeText";
                        options.Contents = new String(text);
                        options.DA = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    fileAnnotation: function fileAnnotation(x, y, w, h) {
                        var file = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        // create hidden file
                        var filespec = this.file(file.src, Object.assign({
                            hidden: true
                        }, file));
                        options.Subtype = "FileAttachment";
                        options.FS = filespec; // add description from filespec unless description (Contents) has already been set
                        if (options.Contents) options.Contents = new String(options.Contents);
                        else if (filespec.data.Desc) options.Contents = filespec.data.Desc;
                        return this.annotate(x, y, w, h, options);
                    },
                    _convertRect: function _convertRect(x1, y1, w, h) {
                        // flip y1 and y2
                        var y2 = y1;
                        y1 += h; // make x2
                        var x2 = x1 + w; // apply current transformation matrix to points
                        var _this$_ctm = _slicedToArray(this._ctm, 6), m0 = _this$_ctm[0], m1 = _this$_ctm[1], m2 = _this$_ctm[2], m3 = _this$_ctm[3], m4 = _this$_ctm[4], m5 = _this$_ctm[5];
                        x1 = m0 * x1 + m2 * y1 + m4;
                        y1 = m1 * x1 + m3 * y1 + m5;
                        x2 = m0 * x2 + m2 * y2 + m4;
                        y2 = m1 * x2 + m3 * y2 + m5;
                        return [
                            x1,
                            y1,
                            x2,
                            y2
                        ];
                    }
                };
                var PDFOutline = /*#__PURE__*/ function() {
                    function PDFOutline(document1, parent, title, dest) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                            expanded: false
                        };
                        _classCallCheck(this, PDFOutline);
                        this.document = document1;
                        this.options = options;
                        this.outlineData = {};
                        if (dest !== null) this.outlineData["Dest"] = [
                            dest.dictionary,
                            "Fit"
                        ];
                        if (parent !== null) this.outlineData["Parent"] = parent;
                        if (title !== null) this.outlineData["Title"] = new String(title);
                        this.dictionary = this.document.ref(this.outlineData);
                        this.children = [];
                    }
                    _createClass(PDFOutline, [
                        {
                            key: "addItem",
                            value: function addItem(title) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    expanded: false
                                };
                                var result = new PDFOutline(this.document, this.dictionary, title, this.document.page, options);
                                this.children.push(result);
                                return result;
                            }
                        },
                        {
                            key: "endOutline",
                            value: function endOutline() {
                                if (this.children.length > 0) {
                                    if (this.options.expanded) this.outlineData.Count = this.children.length;
                                    var first = this.children[0], last = this.children[this.children.length - 1];
                                    this.outlineData.First = first.dictionary;
                                    this.outlineData.Last = last.dictionary;
                                    for(var i = 0, len = this.children.length; i < len; i++){
                                        var child = this.children[i];
                                        if (i > 0) child.outlineData.Prev = this.children[i - 1].dictionary;
                                        if (i < this.children.length - 1) child.outlineData.Next = this.children[i + 1].dictionary;
                                        child.endOutline();
                                    }
                                }
                                return this.dictionary.end();
                            }
                        }
                    ]);
                    return PDFOutline;
                }();
                var OutlineMixin = {
                    initOutline: function initOutline() {
                        return this.outline = new PDFOutline(this, null, null, null);
                    },
                    endOutline: function endOutline() {
                        this.outline.endOutline();
                        if (this.outline.children.length > 0) {
                            this._root.data.Outlines = this.outline.dictionary;
                            return this._root.data.PageMode = "UseOutlines";
                        }
                    }
                };
                /*
PDFStructureContent - a reference to a marked structure content
By Ben Schmidt
*/ var PDFStructureContent = /*#__PURE__*/ function() {
                    function PDFStructureContent(pageRef, mcid) {
                        _classCallCheck(this, PDFStructureContent);
                        this.refs = [
                            {
                                pageRef: pageRef,
                                mcid: mcid
                            }
                        ];
                    }
                    _createClass(PDFStructureContent, [
                        {
                            key: "push",
                            value: function push(structContent) {
                                var _this = this;
                                structContent.refs.forEach(function(ref) {
                                    return _this.refs.push(ref);
                                });
                            }
                        }
                    ]);
                    return PDFStructureContent;
                }();
                var PDFStructureElement = /*#__PURE__*/ function() {
                    function PDFStructureElement(document1, type) {
                        var _this = this;
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck(this, PDFStructureElement);
                        this.document = document1;
                        this._attached = false;
                        this._ended = false;
                        this._flushed = false;
                        this.dictionary = document1.ref({
                            // Type: "StructElem",
                            S: type
                        });
                        var data = this.dictionary.data;
                        if (Array.isArray(options) || this._isValidChild(options)) {
                            children = options;
                            options = {};
                        }
                        if (typeof options.title !== "undefined") data.T = new String(options.title);
                        if (typeof options.lang !== "undefined") data.Lang = new String(options.lang);
                        if (typeof options.alt !== "undefined") data.Alt = new String(options.alt);
                        if (typeof options.expanded !== "undefined") data.E = new String(options.expanded);
                        if (typeof options.actual !== "undefined") data.ActualText = new String(options.actual);
                        this._children = [];
                        if (children) {
                            if (!Array.isArray(children)) children = [
                                children
                            ];
                            children.forEach(function(child) {
                                return _this.add(child);
                            });
                            this.end();
                        }
                    }
                    _createClass(PDFStructureElement, [
                        {
                            key: "add",
                            value: function add(child) {
                                if (this._ended) throw new Error("Cannot add child to already-ended structure element");
                                if (!this._isValidChild(child)) throw new Error("Invalid structure element child");
                                if (child instanceof PDFStructureElement) {
                                    child.setParent(this.dictionary);
                                    if (this._attached) child.setAttached();
                                }
                                if (child instanceof PDFStructureContent) this._addContentToParentTree(child);
                                if (typeof child === "function" && this._attached) // _contentForClosure() adds the content to the parent tree
                                child = this._contentForClosure(child);
                                this._children.push(child);
                                return this;
                            }
                        },
                        {
                            key: "_addContentToParentTree",
                            value: function _addContentToParentTree(content) {
                                var _this2 = this;
                                content.refs.forEach(function(_ref) {
                                    var pageRef = _ref.pageRef, mcid = _ref.mcid;
                                    var pageStructParents = _this2.document.getStructParentTree().get(pageRef.data.StructParents);
                                    pageStructParents[mcid] = _this2.dictionary;
                                });
                            }
                        },
                        {
                            key: "setParent",
                            value: function setParent(parentRef) {
                                if (this.dictionary.data.P) throw new Error("Structure element added to more than one parent");
                                this.dictionary.data.P = parentRef;
                                this._flush();
                            }
                        },
                        {
                            key: "setAttached",
                            value: function setAttached() {
                                var _this3 = this;
                                if (this._attached) return;
                                this._children.forEach(function(child, index) {
                                    if (child instanceof PDFStructureElement) child.setAttached();
                                    if (typeof child === "function") _this3._children[index] = _this3._contentForClosure(child);
                                });
                                this._attached = true;
                                this._flush();
                            }
                        },
                        {
                            key: "end",
                            value: function end() {
                                if (this._ended) return;
                                this._children.filter(function(child) {
                                    return child instanceof PDFStructureElement;
                                }).forEach(function(child) {
                                    return child.end();
                                });
                                this._ended = true;
                                this._flush();
                            }
                        },
                        {
                            key: "_isValidChild",
                            value: function _isValidChild(child) {
                                return child instanceof PDFStructureElement || child instanceof PDFStructureContent || typeof child === "function";
                            }
                        },
                        {
                            key: "_contentForClosure",
                            value: function _contentForClosure(closure) {
                                var content = this.document.markStructureContent(this.dictionary.data.S);
                                closure();
                                this.document.endMarkedContent();
                                this._addContentToParentTree(content);
                                return content;
                            }
                        },
                        {
                            key: "_isFlushable",
                            value: function _isFlushable() {
                                if (!this.dictionary.data.P || !this._ended) return false;
                                return this._children.every(function(child) {
                                    if (typeof child === "function") return false;
                                    if (child instanceof PDFStructureElement) return child._isFlushable();
                                    return true;
                                });
                            }
                        },
                        {
                            key: "_flush",
                            value: function _flush() {
                                var _this4 = this;
                                if (this._flushed || !this._isFlushable()) return;
                                this.dictionary.data.K = [];
                                this._children.forEach(function(child) {
                                    return _this4._flushChild(child);
                                });
                                this.dictionary.end(); // free memory used by children; the dictionary itself may still be
                                // referenced by a parent structure element or root, but we can
                                // at least trim the tree here
                                this._children = [];
                                this.dictionary.data.K = null;
                                this._flushed = true;
                            }
                        },
                        {
                            key: "_flushChild",
                            value: function _flushChild(child) {
                                var _this5 = this;
                                if (child instanceof PDFStructureElement) this.dictionary.data.K.push(child.dictionary);
                                if (child instanceof PDFStructureContent) child.refs.forEach(function(_ref2) {
                                    var pageRef = _ref2.pageRef, mcid = _ref2.mcid;
                                    if (!_this5.dictionary.data.Pg) _this5.dictionary.data.Pg = pageRef;
                                    if (_this5.dictionary.data.Pg === pageRef) _this5.dictionary.data.K.push(mcid);
                                    else _this5.dictionary.data.K.push({
                                        Type: "MCR",
                                        Pg: pageRef,
                                        MCID: mcid
                                    });
                                });
                            }
                        }
                    ]);
                    return PDFStructureElement;
                }();
                var PDFNumberTree = /*#__PURE__*/ function(_PDFTree) {
                    _inherits(PDFNumberTree, _PDFTree);
                    var _super = _createSuper(PDFNumberTree);
                    function PDFNumberTree() {
                        _classCallCheck(this, PDFNumberTree);
                        return _super.apply(this, arguments);
                    }
                    _createClass(PDFNumberTree, [
                        {
                            key: "_compareKeys",
                            value: function _compareKeys(a, b) {
                                return parseInt(a) - parseInt(b);
                            }
                        },
                        {
                            key: "_keysName",
                            value: function _keysName() {
                                return "Nums";
                            }
                        },
                        {
                            key: "_dataForKey",
                            value: function _dataForKey(k) {
                                return parseInt(k);
                            }
                        }
                    ]);
                    return PDFNumberTree;
                }(PDFTree);
                var MarkingsMixin = {
                    initMarkings: function initMarkings(options) {
                        this.structChildren = [];
                        if (options.tagged) {
                            this.getMarkInfoDictionary().data.Marked = true;
                            this.getStructTreeRoot();
                        }
                    },
                    markContent: function markContent(tag) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        if (tag === "Artifact" || options && options.mcid) {
                            var toClose = 0;
                            this.page.markings.forEach(function(marking) {
                                if (toClose || marking.structContent || marking.tag === "Artifact") toClose++;
                            });
                            while(toClose--)this.endMarkedContent();
                        }
                        if (!options) {
                            this.page.markings.push({
                                tag: tag
                            });
                            this.addContent("/".concat(tag, " BMC"));
                            return this;
                        }
                        this.page.markings.push({
                            tag: tag,
                            options: options
                        });
                        var dictionary = {};
                        if (typeof options.mcid !== "undefined") dictionary.MCID = options.mcid;
                        if (tag === "Artifact") {
                            if (typeof options.type === "string") dictionary.Type = options.type;
                            if (Array.isArray(options.bbox)) dictionary.BBox = [
                                options.bbox[0],
                                this.page.height - options.bbox[3],
                                options.bbox[2],
                                this.page.height - options.bbox[1]
                            ];
                            if (Array.isArray(options.attached) && options.attached.every(function(val) {
                                return typeof val === "string";
                            })) dictionary.Attached = options.attached;
                        }
                        if (tag === "Span") {
                            if (options.lang) dictionary.Lang = new String(options.lang);
                            if (options.alt) dictionary.Alt = new String(options.alt);
                            if (options.expanded) dictionary.E = new String(options.expanded);
                            if (options.actual) dictionary.ActualText = new String(options.actual);
                        }
                        this.addContent("/".concat(tag, " ").concat(PDFObject.convert(dictionary), " BDC"));
                        return this;
                    },
                    markStructureContent: function markStructureContent(tag) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var pageStructParents = this.getStructParentTree().get(this.page.structParentTreeKey);
                        var mcid = pageStructParents.length;
                        pageStructParents.push(null);
                        this.markContent(tag, _objectSpread2(_objectSpread2({}, options), {}, {
                            mcid: mcid
                        }));
                        var structContent = new PDFStructureContent(this.page.dictionary, mcid);
                        this.page.markings.slice(-1)[0].structContent = structContent;
                        return structContent;
                    },
                    endMarkedContent: function endMarkedContent() {
                        this.page.markings.pop();
                        this.addContent("EMC");
                        return this;
                    },
                    struct: function struct(type) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                        return new PDFStructureElement(this, type, options, children);
                    },
                    addStructure: function addStructure(structElem) {
                        var structTreeRoot = this.getStructTreeRoot();
                        structElem.setParent(structTreeRoot);
                        structElem.setAttached();
                        this.structChildren.push(structElem);
                        if (!structTreeRoot.data.K) structTreeRoot.data.K = [];
                        structTreeRoot.data.K.push(structElem.dictionary);
                        return this;
                    },
                    initPageMarkings: function initPageMarkings(pageMarkings) {
                        var _this = this;
                        pageMarkings.forEach(function(marking) {
                            if (marking.structContent) {
                                var structContent = marking.structContent;
                                var newStructContent = _this.markStructureContent(marking.tag, marking.options);
                                structContent.push(newStructContent);
                                _this.page.markings.slice(-1)[0].structContent = structContent;
                            } else _this.markContent(marking.tag, marking.options);
                        });
                    },
                    endPageMarkings: function endPageMarkings(page) {
                        var pageMarkings = page.markings;
                        pageMarkings.forEach(function() {
                            return page.write("EMC");
                        });
                        page.markings = [];
                        return pageMarkings;
                    },
                    getMarkInfoDictionary: function getMarkInfoDictionary() {
                        if (!this._root.data.MarkInfo) this._root.data.MarkInfo = this.ref({});
                        return this._root.data.MarkInfo;
                    },
                    getStructTreeRoot: function getStructTreeRoot() {
                        if (!this._root.data.StructTreeRoot) this._root.data.StructTreeRoot = this.ref({
                            Type: "StructTreeRoot",
                            ParentTree: new PDFNumberTree(),
                            ParentTreeNextKey: 0
                        });
                        return this._root.data.StructTreeRoot;
                    },
                    getStructParentTree: function getStructParentTree() {
                        return this.getStructTreeRoot().data.ParentTree;
                    },
                    createStructParentTreeNextKey: function createStructParentTreeNextKey() {
                        // initialise the MarkInfo dictionary
                        this.getMarkInfoDictionary();
                        var structTreeRoot = this.getStructTreeRoot();
                        var key = structTreeRoot.data.ParentTreeNextKey++;
                        structTreeRoot.data.ParentTree.add(key, []);
                        return key;
                    },
                    endMarkings: function endMarkings() {
                        var structTreeRoot = this._root.data.StructTreeRoot;
                        if (structTreeRoot) {
                            structTreeRoot.end();
                            this.structChildren.forEach(function(structElem) {
                                return structElem.end();
                            });
                        }
                        if (this._root.data.MarkInfo) this._root.data.MarkInfo.end();
                    }
                };
                var FIELD_FLAGS = {
                    readOnly: 1,
                    required: 2,
                    noExport: 4,
                    multiline: 0x1000,
                    password: 0x2000,
                    toggleToOffButton: 0x4000,
                    radioButton: 0x8000,
                    pushButton: 0x10000,
                    combo: 0x20000,
                    edit: 0x40000,
                    sort: 0x80000,
                    multiSelect: 0x200000,
                    noSpell: 0x400000
                };
                var FIELD_JUSTIFY = {
                    left: 0,
                    center: 1,
                    right: 2
                };
                var VALUE_MAP = {
                    value: "V",
                    defaultValue: "DV"
                };
                var FORMAT_SPECIAL = {
                    zip: "0",
                    zipPlus4: "1",
                    zip4: "1",
                    phone: "2",
                    ssn: "3"
                };
                var FORMAT_DEFAULT = {
                    number: {
                        nDec: 0,
                        sepComma: false,
                        negStyle: "MinusBlack",
                        currency: "",
                        currencyPrepend: true
                    },
                    percent: {
                        nDec: 0,
                        sepComma: false
                    }
                };
                var AcroFormMixin = {
                    /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */ initForm: function initForm() {
                        if (!this._font) throw new Error("Must set a font before calling initForm method");
                        this._acroform = {
                            fonts: {},
                            defaultFont: this._font.name
                        };
                        this._acroform.fonts[this._font.id] = this._font.ref();
                        var data = {
                            Fields: [],
                            NeedAppearances: true,
                            DA: new String("/".concat(this._font.id, " 0 Tf 0 g")),
                            DR: {
                                Font: {}
                            }
                        };
                        data.DR.Font[this._font.id] = this._font.ref();
                        var AcroForm = this.ref(data);
                        this._root.data.AcroForm = AcroForm;
                        return this;
                    },
                    /**
   * Called automatically by document.js
   */ endAcroForm: function endAcroForm() {
                        var _this = this;
                        if (this._root.data.AcroForm) {
                            if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw new Error("No fonts specified for PDF form");
                            var fontDict = this._root.data.AcroForm.data.DR.Font;
                            Object.keys(this._acroform.fonts).forEach(function(name) {
                                fontDict[name] = _this._acroform.fonts[name];
                            });
                            this._root.data.AcroForm.data.Fields.forEach(function(fieldRef) {
                                _this._endChild(fieldRef);
                            });
                            this._root.data.AcroForm.end();
                        }
                        return this;
                    },
                    _endChild: function _endChild(ref) {
                        var _this2 = this;
                        if (Array.isArray(ref.data.Kids)) {
                            ref.data.Kids.forEach(function(childRef) {
                                _this2._endChild(childRef);
                            });
                            ref.end();
                        }
                        return this;
                    },
                    /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */ formField: function formField(name) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var fieldDict = this._fieldDict(name, null, options);
                        var fieldRef = this.ref(fieldDict);
                        this._addToParent(fieldRef);
                        return fieldRef;
                    },
                    /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */ formAnnotation: function formAnnotation(name, type, x, y, w, h) {
                        var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
                        var fieldDict = this._fieldDict(name, type, options);
                        fieldDict.Subtype = "Widget";
                        if (fieldDict.F === undefined) fieldDict.F = 4; // print the annotation
                         // Add Field annot to page, and get it's ref
                        this.annotate(x, y, w, h, fieldDict);
                        var annotRef = this.page.annotations[this.page.annotations.length - 1];
                        return this._addToParent(annotRef);
                    },
                    formText: function formText(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, "text", x, y, w, h, options);
                    },
                    formPushButton: function formPushButton(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, "pushButton", x, y, w, h, options);
                    },
                    formCombo: function formCombo(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, "combo", x, y, w, h, options);
                    },
                    formList: function formList(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, "list", x, y, w, h, options);
                    },
                    formRadioButton: function formRadioButton(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, "radioButton", x, y, w, h, options);
                    },
                    formCheckbox: function formCheckbox(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, "checkbox", x, y, w, h, options);
                    },
                    _addToParent: function _addToParent(fieldRef) {
                        var parent = fieldRef.data.Parent;
                        if (parent) {
                            if (!parent.data.Kids) parent.data.Kids = [];
                            parent.data.Kids.push(fieldRef);
                        } else this._root.data.AcroForm.data.Fields.push(fieldRef);
                        return this;
                    },
                    _fieldDict: function _fieldDict(name, type) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        if (!this._acroform) throw new Error("Call document.initForms() method before adding form elements to document");
                        var opts = Object.assign({}, options);
                        if (type !== null) opts = this._resolveType(type, options);
                        opts = this._resolveFlags(opts);
                        opts = this._resolveJustify(opts);
                        opts = this._resolveFont(opts);
                        opts = this._resolveStrings(opts);
                        opts = this._resolveColors(opts);
                        opts = this._resolveFormat(opts);
                        opts.T = new String(name);
                        if (opts.parent) {
                            opts.Parent = opts.parent;
                            delete opts.parent;
                        }
                        return opts;
                    },
                    _resolveType: function _resolveType(type, opts) {
                        if (type === "text") opts.FT = "Tx";
                        else if (type === "pushButton") {
                            opts.FT = "Btn";
                            opts.pushButton = true;
                        } else if (type === "radioButton") {
                            opts.FT = "Btn";
                            opts.radioButton = true;
                        } else if (type === "checkbox") opts.FT = "Btn";
                        else if (type === "combo") {
                            opts.FT = "Ch";
                            opts.combo = true;
                        } else if (type === "list") opts.FT = "Ch";
                        else throw new Error("Invalid form annotation type '".concat(type, "'"));
                        return opts;
                    },
                    _resolveFormat: function _resolveFormat(opts) {
                        var f = opts.format;
                        if (f && f.type) {
                            var fnKeystroke;
                            var fnFormat;
                            var params = "";
                            if (FORMAT_SPECIAL[f.type] !== undefined) {
                                fnKeystroke = "AFSpecial_Keystroke";
                                fnFormat = "AFSpecial_Format";
                                params = FORMAT_SPECIAL[f.type];
                            } else {
                                var format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
                                fnKeystroke = "AF".concat(format, "_Keystroke");
                                fnFormat = "AF".concat(format, "_Format");
                                if (f.type === "date") {
                                    fnKeystroke += "Ex";
                                    params = String(f.param);
                                } else if (f.type === "time") params = String(f.param);
                                else if (f.type === "number") {
                                    var p = Object.assign({}, FORMAT_DEFAULT.number, f);
                                    params = String([
                                        String(p.nDec),
                                        p.sepComma ? "0" : "1",
                                        '"' + p.negStyle + '"',
                                        "null",
                                        '"' + p.currency + '"',
                                        String(p.currencyPrepend)
                                    ].join(","));
                                } else if (f.type === "percent") {
                                    var _p = Object.assign({}, FORMAT_DEFAULT.percent, f);
                                    params = String([
                                        String(_p.nDec),
                                        _p.sepComma ? "0" : "1"
                                    ].join(","));
                                }
                            }
                            opts.AA = opts.AA ? opts.AA : {};
                            opts.AA.K = {
                                S: "JavaScript",
                                JS: new String("".concat(fnKeystroke, "(").concat(params, ");"))
                            };
                            opts.AA.F = {
                                S: "JavaScript",
                                JS: new String("".concat(fnFormat, "(").concat(params, ");"))
                            };
                        }
                        delete opts.format;
                        return opts;
                    },
                    _resolveColors: function _resolveColors(opts) {
                        var color = this._normalizeColor(opts.backgroundColor);
                        if (color) {
                            if (!opts.MK) opts.MK = {};
                            opts.MK.BG = color;
                        }
                        color = this._normalizeColor(opts.borderColor);
                        if (color) {
                            if (!opts.MK) opts.MK = {};
                            opts.MK.BC = color;
                        }
                        delete opts.backgroundColor;
                        delete opts.borderColor;
                        return opts;
                    },
                    _resolveFlags: function _resolveFlags(options) {
                        var result = 0;
                        Object.keys(options).forEach(function(key) {
                            if (FIELD_FLAGS[key]) {
                                result |= FIELD_FLAGS[key];
                                delete options[key];
                            }
                        });
                        if (result !== 0) {
                            options.Ff = options.Ff ? options.Ff : 0;
                            options.Ff |= result;
                        }
                        return options;
                    },
                    _resolveJustify: function _resolveJustify(options) {
                        var result = 0;
                        if (options.align !== undefined) {
                            if (typeof FIELD_JUSTIFY[options.align] === "number") result = FIELD_JUSTIFY[options.align];
                            delete options.align;
                        }
                        if (result !== 0) options.Q = result; // default
                        return options;
                    },
                    _resolveFont: function _resolveFont(options) {
                        // add current font to document-level AcroForm dict if necessary
                        if (this._acroform.fonts[this._font.id] === null) this._acroform.fonts[this._font.id] = this._font.ref();
                         // add current font to field's resource dict (RD) if not the default acroform font
                        if (this._acroform.defaultFont !== this._font.name) {
                            options.DR = {
                                Font: {}
                            }; // Get the fontSize option. If not set use auto sizing
                            var fontSize = options.fontSize || 0;
                            options.DR.Font[this._font.id] = this._font.ref();
                            options.DA = new String("/".concat(this._font.id, " ").concat(fontSize, " Tf 0 g"));
                        }
                        return options;
                    },
                    _resolveStrings: function _resolveStrings(options) {
                        var select = [];
                        function appendChoices(a) {
                            if (Array.isArray(a)) {
                                for(var idx = 0; idx < a.length; idx++)if (typeof a[idx] === "string") select.push(new String(a[idx]));
                                else select.push(a[idx]);
                            }
                        }
                        appendChoices(options.Opt);
                        if (options.select) {
                            appendChoices(options.select);
                            delete options.select;
                        }
                        if (select.length) options.Opt = select;
                        Object.keys(VALUE_MAP).forEach(function(key) {
                            if (options[key] !== undefined) {
                                options[VALUE_MAP[key]] = options[key];
                                delete options[key];
                            }
                        });
                        [
                            "V",
                            "DV"
                        ].forEach(function(key) {
                            if (typeof options[key] === "string") options[key] = new String(options[key]);
                        });
                        if (options.MK && options.MK.CA) options.MK.CA = new String(options.MK.CA);
                        if (options.label) {
                            options.MK = options.MK ? options.MK : {};
                            options.MK.CA = new String(options.label);
                            delete options.label;
                        }
                        return options;
                    }
                };
                var AttachmentsMixin = {
                    /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */ file: function file(src) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        options.name = options.name || src;
                        var refBody = {
                            Type: "EmbeddedFile",
                            Params: {}
                        };
                        var data;
                        if (!src) throw new Error("No src specified");
                        if (Buffer.isBuffer(src)) data = src;
                        else if (src instanceof ArrayBuffer) data = Buffer.from(new Uint8Array(src));
                        else {
                            var match;
                            if (match = /^data:(.*);base64,(.*)$/.exec(src)) {
                                if (match[1]) refBody.Subtype = match[1].replace("/", "#2F");
                                data = Buffer.from(match[2], "base64");
                            } else {
                                data = fs.readFileSync(src);
                                if (!data) throw new Error("Could not read contents of file at filepath ".concat(src));
                                 // update CreationDate and ModDate
                                var _fs$statSync = fs.statSync(src), birthtime = _fs$statSync.birthtime, ctime = _fs$statSync.ctime;
                                refBody.Params.CreationDate = birthtime;
                                refBody.Params.ModDate = ctime;
                            }
                        } // override creation date and modified date
                        if (options.creationDate instanceof Date) refBody.Params.CreationDate = options.creationDate;
                        if (options.modifiedDate instanceof Date) refBody.Params.ModDate = options.modifiedDate;
                         // add optional subtype
                        if (options.type) refBody.Subtype = options.type.replace("/", "#2F");
                         // add checksum and size information
                        var checksum = _cryptoJs.default.MD5(_cryptoJs.default.lib.WordArray.create(new Uint8Array(data)));
                        refBody.Params.CheckSum = new String(checksum);
                        refBody.Params.Size = data.byteLength; // save some space when embedding the same file again
                        // if a file with the same name and metadata exists, reuse its reference
                        var ref;
                        if (!this._fileRegistry) this._fileRegistry = {};
                        var file = this._fileRegistry[options.name];
                        if (file && isEqual(refBody, file)) ref = file.ref;
                        else {
                            ref = this.ref(refBody);
                            ref.end(data);
                            this._fileRegistry[options.name] = _objectSpread2(_objectSpread2({}, refBody), {}, {
                                ref: ref
                            });
                        } // add filespec for embedded file
                        var fileSpecBody = {
                            Type: "Filespec",
                            F: new String(options.name),
                            EF: {
                                F: ref
                            },
                            UF: new String(options.name)
                        };
                        if (options.description) fileSpecBody.Desc = new String(options.description);
                        var filespec = this.ref(fileSpecBody);
                        filespec.end();
                        if (!options.hidden) this.addNamedEmbeddedFile(options.name, filespec);
                        return filespec;
                    }
                };
                /** check two embedded file metadata objects for equality */ function isEqual(a, b) {
                    return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && a.Params.CreationDate === b.Params.CreationDate && a.Params.ModDate === b.Params.ModDate;
                }
                var PDFA = {
                    initPDFA: function initPDFA(pSubset) {
                        if (pSubset.charAt(pSubset.length - 3) === "-") {
                            this.subset_conformance = pSubset.charAt(pSubset.length - 1).toUpperCase();
                            this.subset = parseInt(pSubset.charAt(pSubset.length - 2));
                        } else {
                            // Default to Basic conformance when user doesn't specify
                            this.subset_conformance = "B";
                            this.subset = parseInt(pSubset.charAt(pSubset.length - 1));
                        }
                    },
                    endSubset: function endSubset() {
                        this._addPdfaMetadata();
                        var jsPath = "".concat(__dirname, "/data/sRGB_IEC61966_2_1.icc");
                        var jestPath = "".concat(__dirname, "/../color_profiles/sRGB_IEC61966_2_1.icc");
                        this._addColorOutputIntent(fs.existsSync(jsPath) ? jsPath : jestPath);
                    },
                    _addColorOutputIntent: function _addColorOutputIntent(pICCPath) {
                        var iccProfile = fs.readFileSync(pICCPath);
                        var colorProfileRef = this.ref({
                            Length: iccProfile.length,
                            N: 3
                        });
                        colorProfileRef.write(iccProfile);
                        colorProfileRef.end();
                        var intentRef = this.ref({
                            Type: "OutputIntent",
                            S: "GTS_PDFA1",
                            Info: new String("sRGB IEC61966-2.1"),
                            OutputConditionIdentifier: new String("sRGB IEC61966-2.1"),
                            DestOutputProfile: colorProfileRef
                        });
                        intentRef.end();
                        this._root.data.OutputIntents = [
                            intentRef
                        ];
                    },
                    _getPdfaid: function _getPdfaid() {
                        return '\n        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">\n            <pdfaid:part>'.concat(this.subset, "</pdfaid:part>\n            <pdfaid:conformance>").concat(this.subset_conformance, "</pdfaid:conformance>\n        </rdf:Description>\n        ");
                    },
                    _addPdfaMetadata: function _addPdfaMetadata() {
                        this.appendXML(this._getPdfaid());
                    }
                };
                var SubsetMixin = {
                    _importSubset: function _importSubset(subset) {
                        Object.assign(this, subset);
                    },
                    initSubset: function initSubset(options) {
                        switch(options.subset){
                            case "PDF/A-1":
                            case "PDF/A-1a":
                            case "PDF/A-1b":
                            case "PDF/A-2":
                            case "PDF/A-2a":
                            case "PDF/A-2b":
                            case "PDF/A-3":
                            case "PDF/A-3a":
                            case "PDF/A-3b":
                                this._importSubset(PDFA);
                                this.initPDFA(options.subset);
                                break;
                        }
                    }
                };
                var PDFMetadata = /*#__PURE__*/ function() {
                    function PDFMetadata() {
                        _classCallCheck(this, PDFMetadata);
                        this._metadata = '\n        <?xpacket begin="\uFEFF" id="W5M0MpCehiHzreSzNTczkc9d"?>\n            <x:xmpmeta xmlns:x="adobe:ns:meta/">\n                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n        ';
                    }
                    _createClass(PDFMetadata, [
                        {
                            key: "_closeTags",
                            value: function _closeTags() {
                                this._metadata = this._metadata.concat('\n                </rdf:RDF>\n            </x:xmpmeta>\n        <?xpacket end="w"?>\n        ');
                            }
                        },
                        {
                            key: "append",
                            value: function append(xml) {
                                var newline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                                this._metadata = this._metadata.concat(xml);
                                if (newline) this._metadata = this._metadata.concat("\n");
                            }
                        },
                        {
                            key: "getXML",
                            value: function getXML() {
                                return this._metadata;
                            }
                        },
                        {
                            key: "getLength",
                            value: function getLength() {
                                return this._metadata.length;
                            }
                        },
                        {
                            key: "end",
                            value: function end() {
                                this._closeTags();
                                this._metadata = this._metadata.trim();
                            }
                        }
                    ]);
                    return PDFMetadata;
                }();
                var MetadataMixin = {
                    initMetadata: function initMetadata() {
                        this.metadata = new PDFMetadata();
                    },
                    appendXML: function appendXML(xml) {
                        var newline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        this.metadata.append(xml, newline);
                    },
                    _addInfo: function _addInfo() {
                        this.appendXML('\n        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">\n            <xmp:CreateDate>'.concat(this.info.CreationDate.toISOString().split(".")[0] + "Z", "</xmp:CreateDate>\n            <xmp:CreatorTool>").concat(this.info.Creator, "</xmp:CreatorTool>\n        </rdf:Description>\n        "));
                        if (this.info.Title || this.info.Author || this.info.Subject) {
                            this.appendXML('\n            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">\n            ');
                            if (this.info.Title) this.appendXML('\n                <dc:title>\n                    <rdf:Alt>\n                        <rdf:li xml:lang="x-default">'.concat(this.info.Title, "</rdf:li>\n                    </rdf:Alt>\n                </dc:title>\n                "));
                            if (this.info.Author) this.appendXML("\n                <dc:creator>\n                    <rdf:Seq>\n                        <rdf:li>".concat(this.info.Author, "</rdf:li>\n                    </rdf:Seq>\n                </dc:creator>\n                "));
                            if (this.info.Subject) this.appendXML('\n                <dc:description>\n                    <rdf:Alt>\n                        <rdf:li xml:lang="x-default">'.concat(this.info.Subject, "</rdf:li>\n                    </rdf:Alt>\n                </dc:description>\n                "));
                            this.appendXML("\n            </rdf:Description>\n            ");
                        }
                        this.appendXML('\n        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">\n            <pdf:Producer>'.concat(this.info.Creator, "</pdf:Producer>"), false);
                        if (this.info.Keywords) this.appendXML("\n            <pdf:Keywords>".concat(this.info.Keywords, "</pdf:Keywords>"), false);
                        this.appendXML("\n        </rdf:Description>\n        ");
                    },
                    endMetadata: function endMetadata() {
                        this._addInfo();
                        this.metadata.end();
                        /*
    Metadata was introduced in PDF 1.4, so adding it to 1.3 
    will likely only take up more space.
    */ if (this.version != 1.3) {
                            this.metadataRef = this.ref({
                                length: this.metadata.getLength(),
                                Type: "Metadata",
                                Subtype: "XML"
                            });
                            this.metadataRef.compress = false;
                            this.metadataRef.write(Buffer.from(this.metadata.getXML(), "utf-8"));
                            this.metadataRef.end();
                            this._root.data.Metadata = this.metadataRef;
                        }
                    }
                };
                var PDFDocument = /*#__PURE__*/ function(_stream$Readable) {
                    _inherits(PDFDocument, _stream$Readable);
                    var _super = _createSuper(PDFDocument);
                    function PDFDocument() {
                        var _this;
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        _classCallCheck(this, PDFDocument);
                        _this = _super.call(this, options);
                        _this.options = options; // PDF version
                        switch(options.pdfVersion){
                            case "1.4":
                                _this.version = 1.4;
                                break;
                            case "1.5":
                                _this.version = 1.5;
                                break;
                            case "1.6":
                                _this.version = 1.6;
                                break;
                            case "1.7":
                            case "1.7ext3":
                                _this.version = 1.7;
                                break;
                            default:
                                _this.version = 1.3;
                                break;
                        } // Whether streams should be compressed
                        _this.compress = _this.options.compress != null ? _this.options.compress : true;
                        _this._pageBuffer = [];
                        _this._pageBufferStart = 0; // The PDF object store
                        _this._offsets = [];
                        _this._waiting = 0;
                        _this._ended = false;
                        _this._offset = 0;
                        var Pages = _this.ref({
                            Type: "Pages",
                            Count: 0,
                            Kids: []
                        });
                        var Names = _this.ref({
                            Dests: new PDFNameTree()
                        });
                        _this._root = _this.ref({
                            Type: "Catalog",
                            Pages: Pages,
                            Names: Names
                        });
                        if (_this.options.lang) _this._root.data.Lang = new String(_this.options.lang);
                         // The current page
                        _this.page = null; // Initialize mixins
                        _this.initMetadata();
                        _this.initColor();
                        _this.initVector();
                        _this.initFonts(options.font);
                        _this.initText();
                        _this.initImages();
                        _this.initOutline();
                        _this.initMarkings(options);
                        _this.initSubset(options); // Initialize the metadata
                        _this.info = {
                            Producer: "PDFKit",
                            Creator: "PDFKit",
                            CreationDate: new Date()
                        };
                        if (_this.options.info) for(var key in _this.options.info){
                            var val = _this.options.info[key];
                            _this.info[key] = val;
                        }
                        if (_this.options.displayTitle) _this._root.data.ViewerPreferences = _this.ref({
                            DisplayDocTitle: true
                        });
                         // Generate file ID
                        _this._id = PDFSecurity.generateFileID(_this.info); // Initialize security settings
                        _this._security = PDFSecurity.create(_assertThisInitialized(_this), options); // Write the header
                        // PDF version
                        _this._write("%PDF-".concat(_this.version)); // 4 binary chars, as recommended by the spec
                        _this._write("%\xff\xff\xff\xff"); // Add the first page
                        if (_this.options.autoFirstPage !== false) _this.addPage();
                        return _this;
                    }
                    _createClass(PDFDocument, [
                        {
                            key: "addPage",
                            value: function addPage(options) {
                                if (options == null) options = this.options;
                                 // end the current page if needed
                                if (!this.options.bufferPages) this.flushPages();
                                 // create a page object
                                this.page = new PDFPage(this, options);
                                this._pageBuffer.push(this.page); // add the page to the object store
                                var pages = this._root.data.Pages.data;
                                pages.Kids.push(this.page.dictionary);
                                pages.Count++; // reset x and y coordinates
                                this.x = this.page.margins.left;
                                this.y = this.page.margins.top; // flip PDF coordinate system so that the origin is in
                                // the top left rather than the bottom left
                                this._ctm = [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0
                                ];
                                this.transform(1, 0, 0, -1, 0, this.page.height);
                                this.emit("pageAdded");
                                return this;
                            }
                        },
                        {
                            key: "continueOnNewPage",
                            value: function continueOnNewPage(options) {
                                var pageMarkings = this.endPageMarkings(this.page);
                                this.addPage(options);
                                this.initPageMarkings(pageMarkings);
                                return this;
                            }
                        },
                        {
                            key: "bufferedPageRange",
                            value: function bufferedPageRange() {
                                return {
                                    start: this._pageBufferStart,
                                    count: this._pageBuffer.length
                                };
                            }
                        },
                        {
                            key: "switchToPage",
                            value: function switchToPage(n) {
                                var page;
                                if (!(page = this._pageBuffer[n - this._pageBufferStart])) throw new Error("switchToPage(".concat(n, ") out of bounds, current buffer covers pages ").concat(this._pageBufferStart, " to ").concat(this._pageBufferStart + this._pageBuffer.length - 1));
                                return this.page = page;
                            }
                        },
                        {
                            key: "flushPages",
                            value: function flushPages() {
                                // this local variable exists so we're future-proof against
                                // reentrant calls to flushPages.
                                var pages = this._pageBuffer;
                                this._pageBuffer = [];
                                this._pageBufferStart += pages.length;
                                var _iterator = _createForOfIteratorHelper(pages), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var page = _step.value;
                                        this.endPageMarkings(page);
                                        page.end();
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        },
                        {
                            key: "addNamedDestination",
                            value: function addNamedDestination(name) {
                                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                                if (args.length === 0) args = [
                                    "XYZ",
                                    null,
                                    null,
                                    null
                                ];
                                if (args[0] === "XYZ" && args[2] !== null) args[2] = this.page.height - args[2];
                                args.unshift(this.page.dictionary);
                                this._root.data.Names.data.Dests.add(name, args);
                            }
                        },
                        {
                            key: "addNamedEmbeddedFile",
                            value: function addNamedEmbeddedFile(name, ref) {
                                if (!this._root.data.Names.data.EmbeddedFiles) // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
                                this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
                                    limits: false
                                });
                                 // add filespec to EmbeddedFiles
                                this._root.data.Names.data.EmbeddedFiles.add(name, ref);
                            }
                        },
                        {
                            key: "addNamedJavaScript",
                            value: function addNamedJavaScript(name, js) {
                                if (!this._root.data.Names.data.JavaScript) this._root.data.Names.data.JavaScript = new PDFNameTree();
                                var data = {
                                    JS: new String(js),
                                    S: "JavaScript"
                                };
                                this._root.data.Names.data.JavaScript.add(name, data);
                            }
                        },
                        {
                            key: "ref",
                            value: function ref(data) {
                                var ref = new PDFReference(this, this._offsets.length + 1, data);
                                this._offsets.push(null); // placeholder for this object's offset once it is finalized
                                this._waiting++;
                                return ref;
                            }
                        },
                        {
                            key: "_read",
                            value: function _read() {} // do nothing, but this method is required by node
                        },
                        {
                            key: "_write",
                            value: function _write(data) {
                                if (!Buffer.isBuffer(data)) data = Buffer.from(data + "\n", "binary");
                                this.push(data);
                                return this._offset += data.length;
                            }
                        },
                        {
                            key: "addContent",
                            value: function addContent(data) {
                                this.page.write(data);
                                return this;
                            }
                        },
                        {
                            key: "_refEnd",
                            value: function _refEnd(ref) {
                                this._offsets[ref.id - 1] = ref.offset;
                                if (--this._waiting === 0 && this._ended) {
                                    this._finalize();
                                    return this._ended = false;
                                }
                            }
                        },
                        {
                            key: "write",
                            value: function write(filename, fn) {
                                // print a deprecation warning with a stacktrace
                                var err = new Error("PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.");
                                console.warn(err.stack);
                                this.pipe(fs.createWriteStream(filename));
                                this.end();
                                return this.once("end", fn);
                            }
                        },
                        {
                            key: "end",
                            value: function end() {
                                this.flushPages();
                                this._info = this.ref();
                                for(var key in this.info){
                                    var val = this.info[key];
                                    if (typeof val === "string") val = new String(val);
                                    var entry = this.ref(val);
                                    entry.end();
                                    this._info.data[key] = entry;
                                }
                                this._info.end();
                                for(var name in this._fontFamilies){
                                    var font = this._fontFamilies[name];
                                    font.finalize();
                                }
                                this.endOutline();
                                this.endMarkings();
                                if (this.subset) this.endSubset();
                                this.endMetadata();
                                this._root.end();
                                this._root.data.Pages.end();
                                this._root.data.Names.end();
                                this.endAcroForm();
                                if (this._root.data.ViewerPreferences) this._root.data.ViewerPreferences.end();
                                if (this._security) this._security.end();
                                if (this._waiting === 0) return this._finalize();
                                else return this._ended = true;
                            }
                        },
                        {
                            key: "_finalize",
                            value: function _finalize() {
                                // generate xref
                                var xRefOffset = this._offset;
                                this._write("xref");
                                this._write("0 ".concat(this._offsets.length + 1));
                                this._write("0000000000 65535 f ");
                                var _iterator2 = _createForOfIteratorHelper(this._offsets), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var offset = _step2.value;
                                        offset = "0000000000".concat(offset).slice(-10);
                                        this._write(offset + " 00000 n ");
                                    } // trailer
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                var trailer = {
                                    Size: this._offsets.length + 1,
                                    Root: this._root,
                                    Info: this._info,
                                    ID: [
                                        this._id,
                                        this._id
                                    ]
                                };
                                if (this._security) trailer.Encrypt = this._security.dictionary;
                                this._write("trailer");
                                this._write(PDFObject.convert(trailer));
                                this._write("startxref");
                                this._write("".concat(xRefOffset));
                                this._write("%%EOF"); // end the stream
                                return this.push(null);
                            }
                        },
                        {
                            key: "toString",
                            value: function toString() {
                                return "[object PDFDocument]";
                            }
                        }
                    ]);
                    return PDFDocument;
                }(_stream.default.Readable);
                var mixin = function mixin(methods) {
                    Object.assign(PDFDocument.prototype, methods);
                };
                mixin(MetadataMixin);
                mixin(ColorMixin);
                mixin(VectorMixin);
                mixin(FontsMixin);
                mixin(TextMixin);
                mixin(ImagesMixin);
                mixin(AnnotationsMixin);
                mixin(OutlineMixin);
                mixin(MarkingsMixin);
                mixin(AcroFormMixin);
                mixin(AttachmentsMixin);
                mixin(SubsetMixin);
                PDFDocument.LineWrapper = LineWrapper;
                var _default = exports["default"] = PDFDocument;
            /***/ },
            /***/ 26949: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var ___EXPOSE_LOADER_IMPORT___ = __webpack_require__(82669);
                var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = __webpack_require__(88706);
                var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
                if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["pdfMake"] === "undefined") ___EXPOSE_LOADER_GLOBAL_THIS___["pdfMake"] = ___EXPOSE_LOADER_IMPORT___;
                module1.exports = ___EXPOSE_LOADER_IMPORT___;
            /***/ },
            /***/ 76118: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                // Currently in sync with Node.js lib/assert.js
                // https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
                // Originally from narwhal.js (http://narwhaljs.org)
                // Copyright (c) 2009 Thomas Robinson <280north.com>
                //
                // Permission is hereby granted, free of charge, to any person obtaining a copy
                // of this software and associated documentation files (the 'Software'), to
                // deal in the Software without restriction, including without limitation the
                // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
                // sell copies of the Software, and to permit persons to whom the Software is
                // furnished to do so, subject to the following conditions:
                //
                // The above copyright notice and this permission notice shall be included in
                // all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var _require = __webpack_require__(78619), _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
                var AssertionError = __webpack_require__(66979);
                var _require2 = __webpack_require__(85663), inspect = _require2.inspect;
                var _require$types = __webpack_require__(85663).types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
                var objectAssign = __webpack_require__(10293)();
                var objectIs = __webpack_require__(25280)();
                var RegExpPrototypeTest = __webpack_require__(97615)("RegExp.prototype.test");
                var errorCache = new Map();
                var isDeepEqual;
                var isDeepStrictEqual;
                var parseExpressionAt;
                var findNodeAround;
                var decoder;
                function lazyLoadComparison() {
                    var comparison = __webpack_require__(61667);
                    isDeepEqual = comparison.isDeepEqual;
                    isDeepStrictEqual = comparison.isDeepStrictEqual;
                }
                // Escape control characters but not \n and \t to keep the line breaks and
                // indentation intact.
                // eslint-disable-next-line no-control-regex
                var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
                var meta = /* unused pure expression or super */ null;
                var escapeFn = function escapeFn(str) {
                    return meta[str.charCodeAt(0)];
                };
                var warned = false;
                // The assert module provides functions that throw
                // AssertionError's when particular conditions are not met. The
                // assert module must conform to the following interface.
                var assert = module1.exports = ok;
                var NO_EXCEPTION_SENTINEL = {};
                // All of the following functions must throw an AssertionError
                // when a corresponding condition is not met, with a message that
                // may be undefined if not provided. All assertion methods provide
                // both the actual and expected values to the assertion error for
                // display purposes.
                function innerFail(obj) {
                    if (obj.message instanceof Error) throw obj.message;
                    throw new AssertionError(obj);
                }
                function fail(actual, expected, message, operator, stackStartFn) {
                    var argsLen = arguments.length;
                    var internalMessage;
                    if (argsLen === 0) internalMessage = "Failed";
                    else if (argsLen === 1) {
                        message = actual;
                        actual = undefined;
                    } else {
                        if (warned === false) {
                            warned = true;
                            var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
                            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
                        }
                        if (argsLen === 2) operator = "!=";
                    }
                    if (message instanceof Error) throw message;
                    var errArgs = {
                        actual: actual,
                        expected: expected,
                        operator: operator === undefined ? "fail" : operator,
                        stackStartFn: stackStartFn || fail
                    };
                    if (message !== undefined) errArgs.message = message;
                    var err = new AssertionError(errArgs);
                    if (internalMessage) {
                        err.message = internalMessage;
                        err.generatedMessage = true;
                    }
                    throw err;
                }
                assert.fail = fail;
                // The AssertionError is defined in internal/error.
                assert.AssertionError = AssertionError;
                function innerOk(fn, argLen, value, message) {
                    if (!value) {
                        var generatedMessage = false;
                        if (argLen === 0) {
                            generatedMessage = true;
                            message = "No value argument passed to `assert.ok()`";
                        } else if (message instanceof Error) throw message;
                        var err = new AssertionError({
                            actual: value,
                            expected: true,
                            message: message,
                            operator: "==",
                            stackStartFn: fn
                        });
                        err.generatedMessage = generatedMessage;
                        throw err;
                    }
                }
                // Pure assertion tests whether a value is truthy, as determined
                // by !!value.
                function ok() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    innerOk.apply(void 0, [
                        ok,
                        args.length
                    ].concat(args));
                }
                assert.ok = ok;
                // The equality assertion tests shallow, coercive equality with ==.
                /* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    // eslint-disable-next-line eqeqeq
                    if (actual != expected) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "==",
                        stackStartFn: equal
                    });
                };
                // The non-equality assertion tests for whether two objects are not
                // equal with !=.
                assert.notEqual = function notEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    // eslint-disable-next-line eqeqeq
                    if (actual == expected) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "!=",
                        stackStartFn: notEqual
                    });
                };
                // The equivalence assertion tests a deep equality relation.
                assert.deepEqual = function deepEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (!isDeepEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "deepEqual",
                        stackStartFn: deepEqual
                    });
                };
                // The non-equivalence assertion tests for any deep inequality.
                assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (isDeepEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "notDeepEqual",
                        stackStartFn: notDeepEqual
                    });
                };
                /* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (!isDeepStrictEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "deepStrictEqual",
                        stackStartFn: deepStrictEqual
                    });
                };
                assert.notDeepStrictEqual = notDeepStrictEqual;
                function notDeepStrictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (isDeepStrictEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "notDeepStrictEqual",
                        stackStartFn: notDeepStrictEqual
                    });
                }
                assert.strictEqual = function strictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    if (!objectIs(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "strictEqual",
                        stackStartFn: strictEqual
                    });
                };
                assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
                    if (objectIs(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: "notStrictEqual",
                        stackStartFn: notStrictEqual
                    });
                };
                var Comparison = /*#__PURE__*/ _createClass(function Comparison(obj, keys, actual) {
                    var _this = this;
                    _classCallCheck(this, Comparison);
                    keys.forEach(function(key) {
                        if (key in obj) {
                            if (actual !== undefined && typeof actual[key] === "string" && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
                            else _this[key] = obj[key];
                        }
                    });
                });
                function compareExceptionKey(actual, expected, key, message, keys, fn) {
                    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
                        if (!message) {
                            // Create placeholder objects to create a nice output.
                            var a = new Comparison(actual, keys);
                            var b = new Comparison(expected, keys, actual);
                            var err = new AssertionError({
                                actual: a,
                                expected: b,
                                operator: "deepStrictEqual",
                                stackStartFn: fn
                            });
                            err.actual = actual;
                            err.expected = expected;
                            err.operator = fn.name;
                            throw err;
                        }
                        innerFail({
                            actual: actual,
                            expected: expected,
                            message: message,
                            operator: fn.name,
                            stackStartFn: fn
                        });
                    }
                }
                function expectedException(actual, expected, msg, fn) {
                    if (typeof expected !== "function") {
                        if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
                        // assert.doesNotThrow does not accept objects.
                        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE("expected", [
                            "Function",
                            "RegExp"
                        ], expected);
                        // Handle primitives properly.
                        if (_typeof(actual) !== "object" || actual === null) {
                            var err = new AssertionError({
                                actual: actual,
                                expected: expected,
                                message: msg,
                                operator: "deepStrictEqual",
                                stackStartFn: fn
                            });
                            err.operator = fn.name;
                            throw err;
                        }
                        var keys = Object.keys(expected);
                        // Special handle errors to make sure the name and the message are compared
                        // as well.
                        if (expected instanceof Error) keys.push("name", "message");
                        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
                        if (isDeepEqual === undefined) lazyLoadComparison();
                        keys.forEach(function(key) {
                            if (typeof actual[key] === "string" && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key])) return;
                            compareExceptionKey(actual, expected, key, msg, keys, fn);
                        });
                        return true;
                    }
                    // Guard instanceof against arrow functions as they don't have a prototype.
                    if (expected.prototype !== undefined && actual instanceof expected) return true;
                    if (Error.isPrototypeOf(expected)) return false;
                    return expected.call({}, actual) === true;
                }
                function getActual(fn) {
                    if (typeof fn !== "function") throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
                    try {
                        fn();
                    } catch (e) {
                        return e;
                    }
                    return NO_EXCEPTION_SENTINEL;
                }
                function checkIsPromise(obj) {
                    // Accept native ES6 promises and promises that are implemented in a similar
                    // way. Do not accept thenables that use a function as `obj` and that have no
                    // `catch` handler.
                    // TODO: thenables are checked up until they have the correct methods,
                    // but according to documentation, the `then` method should receive
                    // the `fulfill` and `reject` arguments as well or it may be never resolved.
                    return isPromise(obj) || obj !== null && _typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
                }
                function waitForActual(promiseFn) {
                    return Promise.resolve().then(function() {
                        var resultPromise;
                        if (typeof promiseFn === "function") {
                            // Return a rejected promise if `promiseFn` throws synchronously.
                            resultPromise = promiseFn();
                            // Fail in case no promise is returned.
                            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
                        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
                        else throw new ERR_INVALID_ARG_TYPE("promiseFn", [
                            "Function",
                            "Promise"
                        ], promiseFn);
                        return Promise.resolve().then(function() {
                            return resultPromise;
                        }).then(function() {
                            return NO_EXCEPTION_SENTINEL;
                        }).catch(function(e) {
                            return e;
                        });
                    });
                }
                function expectsError(stackStartFn, actual, error, message) {
                    if (typeof error === "string") {
                        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE("error", [
                            "Object",
                            "Error",
                            "Function",
                            "RegExp"
                        ], error);
                        if (_typeof(actual) === "object" && actual !== null) {
                            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
                        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
                        message = error;
                        error = undefined;
                    } else if (error != null && _typeof(error) !== "object" && typeof error !== "function") throw new ERR_INVALID_ARG_TYPE("error", [
                        "Object",
                        "Error",
                        "Function",
                        "RegExp"
                    ], error);
                    if (actual === NO_EXCEPTION_SENTINEL) {
                        var details = "";
                        if (error && error.name) details += " (".concat(error.name, ")");
                        details += message ? ": ".concat(message) : ".";
                        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
                        innerFail({
                            actual: undefined,
                            expected: error,
                            operator: stackStartFn.name,
                            message: "Missing expected ".concat(fnType).concat(details),
                            stackStartFn: stackStartFn
                        });
                    }
                    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
                }
                function expectsNoError(stackStartFn, actual, error, message) {
                    if (actual === NO_EXCEPTION_SENTINEL) return;
                    if (typeof error === "string") {
                        message = error;
                        error = undefined;
                    }
                    if (!error || expectedException(actual, error)) {
                        var details = message ? ": ".concat(message) : ".";
                        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
                        innerFail({
                            actual: actual,
                            expected: error,
                            operator: stackStartFn.name,
                            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
                            stackStartFn: stackStartFn
                        });
                    }
                    throw actual;
                }
                assert.throws = function throws(promiseFn) {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                    expectsError.apply(void 0, [
                        throws,
                        getActual(promiseFn)
                    ].concat(args));
                };
                assert.rejects = function rejects(promiseFn) {
                    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
                    return waitForActual(promiseFn).then(function(result) {
                        return expectsError.apply(void 0, [
                            rejects,
                            result
                        ].concat(args));
                    });
                };
                assert.doesNotThrow = function doesNotThrow(fn) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    expectsNoError.apply(void 0, [
                        doesNotThrow,
                        getActual(fn)
                    ].concat(args));
                };
                assert.doesNotReject = function doesNotReject(fn) {
                    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
                    return waitForActual(fn).then(function(result) {
                        return expectsNoError.apply(void 0, [
                            doesNotReject,
                            result
                        ].concat(args));
                    });
                };
                assert.ifError = function ifError(err) {
                    if (err !== null && err !== undefined) {
                        var message = "ifError got unwanted exception: ";
                        if (_typeof(err) === "object" && typeof err.message === "string") {
                            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
                            else message += err.message;
                        } else message += inspect(err);
                        var newErr = new AssertionError({
                            actual: err,
                            expected: null,
                            operator: "ifError",
                            message: message,
                            stackStartFn: ifError
                        });
                        // Make sure we actually have a stack trace!
                        var origStack = err.stack;
                        if (typeof origStack === "string") {
                            // This will remove any duplicated frames from the error frames taken
                            // from within `ifError` and add the original error frames to the newly
                            // created ones.
                            var tmp2 = origStack.split("\n");
                            tmp2.shift();
                            // Filter all frames existing in err.stack.
                            var tmp1 = newErr.stack.split("\n");
                            for(var i = 0; i < tmp2.length; i++){
                                // Find the first occurrence of the frame.
                                var pos = tmp1.indexOf(tmp2[i]);
                                if (pos !== -1) {
                                    // Only keep new frames.
                                    tmp1 = tmp1.slice(0, pos);
                                    break;
                                }
                            }
                            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
                        }
                        throw newErr;
                    }
                };
                // Currently in sync with Node.js lib/assert.js
                // https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
                function internalMatch(string, regexp, message, fn, fnName) {
                    if (!isRegExp(regexp)) throw new ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
                    var match = fnName === "match";
                    if (typeof string !== "string" || RegExpPrototypeTest(regexp, string) !== match) {
                        if (message instanceof Error) throw message;
                        var generatedMessage = !message;
                        // 'The input was expected to not match the regular expression ' +
                        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(_typeof(string), " (").concat(inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(inspect(regexp), ". Input:\n\n").concat(inspect(string), "\n"));
                        var err = new AssertionError({
                            actual: string,
                            expected: regexp,
                            message: message,
                            operator: fnName,
                            stackStartFn: fn
                        });
                        err.generatedMessage = generatedMessage;
                        throw err;
                    }
                }
                assert.match = function match(string, regexp, message) {
                    internalMatch(string, regexp, message, match, "match");
                };
                assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
                    internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
                };
                // Expose a strict only variant of assert
                function strict() {
                    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
                    innerOk.apply(void 0, [
                        strict,
                        args.length
                    ].concat(args));
                }
                assert.strict = objectAssign(strict, assert, {
                    equal: assert.strictEqual,
                    deepEqual: assert.deepStrictEqual,
                    notEqual: assert.notStrictEqual,
                    notDeepEqual: assert.notDeepStrictEqual
                });
                assert.strict.strict = assert.strict;
            /***/ },
            /***/ 66979: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                // Currently in sync with Node.js lib/internal/assert/assertion_error.js
                // https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            _defineProperty(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    Object.defineProperty(subClass, "prototype", {
                        writable: false
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _wrapNativeSuper(Class) {
                    var _cache = typeof Map === "function" ? new Map() : undefined;
                    _wrapNativeSuper = function _wrapNativeSuper(Class) {
                        if (Class === null || !_isNativeFunction(Class)) return Class;
                        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
                        if (typeof _cache !== "undefined") {
                            if (_cache.has(Class)) return _cache.get(Class);
                            _cache.set(Class, Wrapper);
                        }
                        function Wrapper() {
                            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
                        }
                        Wrapper.prototype = Object.create(Class.prototype, {
                            constructor: {
                                value: Wrapper,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                        return _setPrototypeOf(Wrapper, Class);
                    };
                    return _wrapNativeSuper(Class);
                }
                function _construct(Parent, args, Class) {
                    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
                    else _construct = function _construct(Parent, args, Class) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor();
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                    return _construct.apply(null, arguments);
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _isNativeFunction(fn) {
                    return Function.toString.call(fn).indexOf("[native code]") !== -1;
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                var _require = __webpack_require__(85663), inspect = _require.inspect;
                var _require2 = __webpack_require__(78619), ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
                function repeat(str, count) {
                    count = Math.floor(count);
                    if (str.length == 0 || count == 0) return "";
                    var maxCount = str.length * count;
                    count = Math.floor(Math.log(count) / Math.log(2));
                    while(count){
                        str += str;
                        count--;
                    }
                    str += str.substring(0, maxCount - str.length);
                    return str;
                }
                var blue = "";
                var green = "";
                var red = "";
                var white = "";
                var kReadableOperator = {
                    deepStrictEqual: "Expected values to be strictly deep-equal:",
                    strictEqual: "Expected values to be strictly equal:",
                    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                    deepEqual: "Expected values to be loosely deep-equal:",
                    equal: "Expected values to be loosely equal:",
                    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                    notEqual: 'Expected "actual" to be loosely unequal to:',
                    notIdentical: "Values identical but not reference-equal:"
                };
                // Comparing short primitives should just show === / !== instead of using the
                // diff.
                var kMaxShortLength = 10;
                function copyError(source) {
                    var keys = Object.keys(source);
                    var target = Object.create(Object.getPrototypeOf(source));
                    keys.forEach(function(key) {
                        target[key] = source[key];
                    });
                    Object.defineProperty(target, "message", {
                        value: source.message
                    });
                    return target;
                }
                function inspectValue(val) {
                    // The util.inspect default values could be changed. This makes sure the
                    // error messages contain the necessary information nevertheless.
                    return inspect(val, {
                        compact: false,
                        customInspect: false,
                        depth: 1000,
                        maxArrayLength: Infinity,
                        // Assert compares only enumerable properties (with a few exceptions).
                        showHidden: false,
                        // Having a long line as error is better than wrapping the line for
                        // comparison for now.
                        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
                        // have meta information about the inspected properties (i.e., know where
                        // in what line the property starts and ends).
                        breakLength: Infinity,
                        // Assert does not detect proxies currently.
                        showProxy: false,
                        sorted: true,
                        // Inspect getters as we also check them when comparing entries.
                        getters: true
                    });
                }
                function createErrDiff(actual, expected, operator) {
                    var other = "";
                    var res = "";
                    var lastPos = 0;
                    var end = "";
                    var skipped = false;
                    var actualInspected = inspectValue(actual);
                    var actualLines = actualInspected.split("\n");
                    var expectedLines = inspectValue(expected).split("\n");
                    var i = 0;
                    var indicator = "";
                    // In case both values are objects explicitly mark them as not reference equal
                    // for the `strictEqual` operator.
                    if (operator === "strictEqual" && _typeof(actual) === "object" && _typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
                    // If "actual" and "expected" fit on a single line and they are not strictly
                    // equal, check further special handling.
                    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
                        var inputLength = actualLines[0].length + expectedLines[0].length;
                        // If the character length of "actual" and "expected" together is less than
                        // kMaxShortLength and if neither is an object and at least one of them is
                        // not `zero`, use the strict equal comparison to visualize the output.
                        if (inputLength <= kMaxShortLength) {
                            if ((_typeof(actual) !== "object" || actual === null) && (_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
                            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
                        } else if (operator !== "strictEqualObject") {
                            // If the stderr is a tty and the input length is lower than the current
                            // columns per line, add a mismatch indicator below the output. If it is
                            // not a tty, use a default value of 80 characters.
                            var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
                            if (inputLength < maxLength) {
                                while(actualLines[0][i] === expectedLines[0][i])i++;
                                // Ignore the first characters.
                                if (i > 2) {
                                    // Add position indicator for the first mismatch in case it is a
                                    // single line and the input length is less than the column length.
                                    indicator = "\n  ".concat(repeat(" ", i), "^");
                                    i = 0;
                                }
                            }
                        }
                    }
                    // Remove all ending lines that match (this optimizes the output for
                    // readability by reducing the number of total changed lines).
                    var a = actualLines[actualLines.length - 1];
                    var b = expectedLines[expectedLines.length - 1];
                    while(a === b){
                        if (i++ < 2) end = "\n  ".concat(a).concat(end);
                        else other = a;
                        actualLines.pop();
                        expectedLines.pop();
                        if (actualLines.length === 0 || expectedLines.length === 0) break;
                        a = actualLines[actualLines.length - 1];
                        b = expectedLines[expectedLines.length - 1];
                    }
                    var maxLines = Math.max(actualLines.length, expectedLines.length);
                    // Strict equal with identical objects that are not identical by reference.
                    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
                    if (maxLines === 0) {
                        // We have to get the result again. The lines were all removed before.
                        var _actualLines = actualInspected.split("\n");
                        // Only remove lines in case it makes sense to collapse those.
                        // TODO: Accept env to always show the full error.
                        if (_actualLines.length > 30) {
                            _actualLines[26] = "".concat(blue, "...").concat(white);
                            while(_actualLines.length > 27)_actualLines.pop();
                        }
                        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
                    }
                    if (i > 3) {
                        end = "\n".concat(blue, "...").concat(white).concat(end);
                        skipped = true;
                    }
                    if (other !== "") {
                        end = "\n  ".concat(other).concat(end);
                        other = "";
                    }
                    var printedLines = 0;
                    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
                    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
                    for(i = 0; i < maxLines; i++){
                        // Only extra expected lines exist
                        var cur = i - lastPos;
                        if (actualLines.length < i + 1) {
                            // If the last diverging line is more than one line above and the
                            // current line is at least line three, add some of the former lines and
                            // also add dots to indicate skipped entries.
                            if (cur > 1 && i > 2) {
                                if (cur > 4) {
                                    res += "\n".concat(blue, "...").concat(white);
                                    skipped = true;
                                } else if (cur > 3) {
                                    res += "\n  ".concat(expectedLines[i - 2]);
                                    printedLines++;
                                }
                                res += "\n  ".concat(expectedLines[i - 1]);
                                printedLines++;
                            }
                            // Mark the current line as the last diverging one.
                            lastPos = i;
                            // Add the expected line to the cache.
                            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
                            printedLines++;
                        // Only extra actual lines exist
                        } else if (expectedLines.length < i + 1) {
                            // If the last diverging line is more than one line above and the
                            // current line is at least line three, add some of the former lines and
                            // also add dots to indicate skipped entries.
                            if (cur > 1 && i > 2) {
                                if (cur > 4) {
                                    res += "\n".concat(blue, "...").concat(white);
                                    skipped = true;
                                } else if (cur > 3) {
                                    res += "\n  ".concat(actualLines[i - 2]);
                                    printedLines++;
                                }
                                res += "\n  ".concat(actualLines[i - 1]);
                                printedLines++;
                            }
                            // Mark the current line as the last diverging one.
                            lastPos = i;
                            // Add the actual line to the result.
                            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
                            printedLines++;
                        // Lines diverge
                        } else {
                            var expectedLine = expectedLines[i];
                            var actualLine = actualLines[i];
                            // If the lines diverge, specifically check for lines that only diverge by
                            // a trailing comma. In that case it is actually identical and we should
                            // mark it as such.
                            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
                            // If the expected line has a trailing comma but is otherwise identical,
                            // add a comma at the end of the actual line. Otherwise the output could
                            // look weird as in:
                            //
                            //   [
                            //     1         // No comma at the end!
                            // +   2
                            //   ]
                            //
                            if (divergingLines && endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                                divergingLines = false;
                                actualLine += ",";
                            }
                            if (divergingLines) {
                                // If the last diverging line is more than one line above and the
                                // current line is at least line three, add some of the former lines and
                                // also add dots to indicate skipped entries.
                                if (cur > 1 && i > 2) {
                                    if (cur > 4) {
                                        res += "\n".concat(blue, "...").concat(white);
                                        skipped = true;
                                    } else if (cur > 3) {
                                        res += "\n  ".concat(actualLines[i - 2]);
                                        printedLines++;
                                    }
                                    res += "\n  ".concat(actualLines[i - 1]);
                                    printedLines++;
                                }
                                // Mark the current line as the last diverging one.
                                lastPos = i;
                                // Add the actual line to the result and cache the expected diverging
                                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                                printedLines += 2;
                            // Lines are identical
                            } else {
                                // Add all cached information to the result before adding other things
                                // and reset the cache.
                                res += other;
                                other = "";
                                // If the last diverging line is exactly one line above or if it is the
                                // very first line, add the line to the result.
                                if (cur === 1 || i === 0) {
                                    res += "\n  ".concat(actualLine);
                                    printedLines++;
                                }
                            }
                        }
                        // Inspected object to big (Show ~20 rows max)
                        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
                    }
                    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
                }
                var AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
                    _inherits(AssertionError, _Error);
                    var _super = _createSuper(AssertionError);
                    function AssertionError(options) {
                        var _this;
                        _classCallCheck(this, AssertionError);
                        if (_typeof(options) !== "object" || options === null) throw new ERR_INVALID_ARG_TYPE("options", "Object", options);
                        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
                        var actual = options.actual, expected = options.expected;
                        var limit = Error.stackTraceLimit;
                        Error.stackTraceLimit = 0;
                        if (message != null) _this = _super.call(this, String(message));
                        else {
                            if (process.stderr && process.stderr.isTTY) {
                                // Reset on each call to make sure we handle dynamically set environment
                                // variables correct.
                                if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
                                    blue = "\x1b[34m";
                                    green = "\x1b[32m";
                                    white = "\x1b[39m";
                                    red = "\x1b[31m";
                                } else {
                                    blue = "";
                                    green = "";
                                    white = "";
                                    red = "";
                                }
                            }
                            // Prevent the error stack from being visible by duplicating the error
                            // in a very close way to the original in case both sides are actually
                            // instances of Error.
                            if (_typeof(actual) === "object" && actual !== null && _typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                                actual = copyError(actual);
                                expected = copyError(expected);
                            }
                            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, createErrDiff(actual, expected, operator));
                            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                                // In case the objects are equal but the operator requires unequal, show
                                // the first object and say A equals B
                                var base = kReadableOperator[operator];
                                var res = inspectValue(actual).split("\n");
                                // In case "actual" is an object, it should not be reference equal.
                                if (operator === "notStrictEqual" && _typeof(actual) === "object" && actual !== null) base = kReadableOperator.notStrictEqualObject;
                                // Only remove lines in case it makes sense to collapse those.
                                // TODO: Accept env to always show the full error.
                                if (res.length > 30) {
                                    res[26] = "".concat(blue, "...").concat(white);
                                    while(res.length > 27)res.pop();
                                }
                                // Only print a single input.
                                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
                            } else {
                                var _res = inspectValue(actual);
                                var other = "";
                                var knownOperators = kReadableOperator[operator];
                                if (operator === "notDeepEqual" || operator === "notEqual") {
                                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                                } else {
                                    other = "".concat(inspectValue(expected));
                                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                                    else other = " ".concat(operator, " ").concat(other);
                                }
                                _this = _super.call(this, "".concat(_res).concat(other));
                            }
                        }
                        Error.stackTraceLimit = limit;
                        _this.generatedMessage = !message;
                        Object.defineProperty(_assertThisInitialized(_this), "name", {
                            value: "AssertionError [ERR_ASSERTION]",
                            enumerable: false,
                            writable: true,
                            configurable: true
                        });
                        _this.code = "ERR_ASSERTION";
                        _this.actual = actual;
                        _this.expected = expected;
                        _this.operator = operator;
                        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
                        Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
                        // Create error message including the error code in the name.
                        _this.stack;
                        // Reset the name.
                        _this.name = "AssertionError";
                        return _possibleConstructorReturn(_this);
                    }
                    _createClass(AssertionError, [
                        {
                            key: "toString",
                            value: function toString() {
                                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                            }
                        },
                        {
                            key: _inspect$custom,
                            value: function value(recurseTimes, ctx) {
                                // This limits the `actual` and `expected` property default inspection to
                                // the minimum depth. Otherwise those values would be too verbose compared
                                // to the actual error message which contains a combined view of these two
                                // input values.
                                return inspect(this, _objectSpread(_objectSpread({}, ctx), {}, {
                                    customInspect: false,
                                    depth: 0
                                }));
                            }
                        }
                    ]);
                    return AssertionError;
                }(/*#__PURE__*/ _wrapNativeSuper(Error), inspect.custom);
                module1.exports = AssertionError;
            /***/ },
            /***/ 78619: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Currently in sync with Node.js lib/internal/errors.js
                // https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
                /* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ // The whole point behind this internal module is to allow Node.js to no
                // longer be forced to treat every error message change as a semver-major
                // change. The NodeError classes here all expose a `code` property whose
                // value statically and permanently identifies the error. While the error
                // message may change, the code should not.
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    Object.defineProperty(subClass, "prototype", {
                        writable: false
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var codes = {};
                // Lazy loaded
                var assert;
                var util;
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === "string") return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inherits(NodeError, _Base);
                        var _super = _createSuper(NodeError);
                        function NodeError(arg1, arg2, arg3) {
                            var _this;
                            _classCallCheck(this, NodeError);
                            _this = _super.call(this, getMessage(arg1, arg2, arg3));
                            _this.code = code;
                            return _this;
                        }
                        return _createClass(NodeError);
                    }(Base);
                    codes[code] = NodeError;
                }
                // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== "number") start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
                createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
                    if (assert === undefined) assert = __webpack_require__(76118);
                    assert(typeof name === "string", "'name' must be a string");
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === "string" && startsWith(expected, "not ")) {
                        determiner = "must not be";
                        expected = expected.replace(/^not /, "");
                    } else determiner = "must be";
                    var msg;
                    if (endsWith(name, " argument")) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    else {
                        var type = includes(name, ".") ? "property" : "argument";
                        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    }
                    // TODO(BridgeAR): Improve the output by showing `null` and similar.
                    msg += ". Received type ".concat(_typeof(actual));
                    return msg;
                }, TypeError);
                createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
                    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
                    if (util === undefined) util = __webpack_require__(85663);
                    var inspected = util.inspect(value);
                    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
                    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
                }, TypeError, RangeError);
                createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
                    var type;
                    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
                    else type = "type ".concat(_typeof(value));
                    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
                }, TypeError);
                createErrorType("ERR_MISSING_ARGS", function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (assert === undefined) assert = __webpack_require__(76118);
                    assert(args.length > 0, "At least one arg needs to be specified");
                    var msg = "The ";
                    var len = args.length;
                    args = args.map(function(a) {
                        return '"'.concat(a, '"');
                    });
                    switch(len){
                        case 1:
                            msg += "".concat(args[0], " argument");
                            break;
                        case 2:
                            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
                            break;
                        default:
                            msg += args.slice(0, len - 1).join(", ");
                            msg += ", and ".concat(args[len - 1], " arguments");
                            break;
                    }
                    return "".concat(msg, " must be specified");
                }, TypeError);
                module1.exports.codes = codes;
            /***/ },
            /***/ 61667: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Currently in sync with Node.js lib/internal/util/comparisons.js
                // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(r, l) {
                    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (null != t) {
                        var e, n, i, u, a = [], f = !0, o = !1;
                        try {
                            if (i = (t = t.call(r)).next, 0 === l) {
                                if (Object(t) !== t) return;
                                f = !1;
                            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
                        } catch (r) {
                            o = !0, n = r;
                        } finally{
                            try {
                                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return a;
                    }
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                var regexFlagsSupported = /a/g.flags !== undefined;
                var arrayFromSet = function arrayFromSet(set) {
                    var array = [];
                    set.forEach(function(value) {
                        return array.push(value);
                    });
                    return array;
                };
                var arrayFromMap = function arrayFromMap(map) {
                    var array = [];
                    map.forEach(function(value, key) {
                        return array.push([
                            key,
                            value
                        ]);
                    });
                    return array;
                };
                var objectIs = Object.is ? Object.is : __webpack_require__(7402);
                var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                    return [];
                };
                var numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__(98622);
                function uncurryThis(f) {
                    return f.call.bind(f);
                }
                var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
                var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
                var objectToString = uncurryThis(Object.prototype.toString);
                var _require$types = __webpack_require__(85663).types, isAnyArrayBuffer = _require$types.isAnyArrayBuffer, isArrayBufferView = _require$types.isArrayBufferView, isDate = _require$types.isDate, isMap = _require$types.isMap, isRegExp = _require$types.isRegExp, isSet = _require$types.isSet, isNativeError = _require$types.isNativeError, isBoxedPrimitive = _require$types.isBoxedPrimitive, isNumberObject = _require$types.isNumberObject, isStringObject = _require$types.isStringObject, isBooleanObject = _require$types.isBooleanObject, isBigIntObject = _require$types.isBigIntObject, isSymbolObject = _require$types.isSymbolObject, isFloat32Array = _require$types.isFloat32Array, isFloat64Array = _require$types.isFloat64Array;
                function isNonIndex(key) {
                    if (key.length === 0 || key.length > 10) return true;
                    for(var i = 0; i < key.length; i++){
                        var code = key.charCodeAt(i);
                        if (code < 48 || code > 57) return true;
                    }
                    // The maximum size for an array is 2 ** 32 -1.
                    return key.length === 10 && key >= Math.pow(2, 32);
                }
                function getOwnNonIndexProperties(value) {
                    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
                }
                // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
                // original notice:
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                }
                var ONLY_ENUMERABLE = undefined;
                var kStrict = true;
                var kLoose = false;
                var kNoIterator = 0;
                var kIsArray = 1;
                var kIsSet = 2;
                var kIsMap = 3;
                // Check if they have the same source and flags
                function areSimilarRegExps(a, b) {
                    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
                }
                function areSimilarFloatArrays(a, b) {
                    if (a.byteLength !== b.byteLength) return false;
                    for(var offset = 0; offset < a.byteLength; offset++){
                        if (a[offset] !== b[offset]) return false;
                    }
                    return true;
                }
                function areSimilarTypedArrays(a, b) {
                    if (a.byteLength !== b.byteLength) return false;
                    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
                }
                function areEqualArrayBuffers(buf1, buf2) {
                    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
                }
                function isEqualBoxedPrimitive(val1, val2) {
                    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
                    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
                    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
                    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
                    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
                }
                // Notes: Type tags are historical [[Class]] properties that can be set by
                // FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
                // and retrieved using Object.prototype.toString.call(obj) in JS
                // See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
                // for a list of tags pre-defined in the spec.
                // There are some unspecified tags in the wild too (e.g. typed array tags).
                // Since tags can be altered, they only serve fast failures
                //
                // Typed arrays and buffers are checked by comparing the content in their
                // underlying ArrayBuffer. This optimization requires that it's
                // reasonable to interpret their underlying memory in the same way,
                // which is checked by comparing their type tags.
                // (e.g. a Uint8Array and a Uint16Array with the same memory content
                // could still be different because they will be interpreted differently).
                //
                // For strict comparison, objects should have
                // a) The same built-in type tags
                // b) The same prototypes.
                function innerDeepEqual(val1, val2, strict, memos) {
                    // All identical values are equivalent, as determined by ===.
                    if (val1 === val2) {
                        if (val1 !== 0) return true;
                        return strict ? objectIs(val1, val2) : true;
                    }
                    // Check more closely if val1 and val2 are equal.
                    if (strict) {
                        if (_typeof(val1) !== "object") return typeof val1 === "number" && numberIsNaN(val1) && numberIsNaN(val2);
                        if (_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
                        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
                    } else {
                        if (val1 === null || _typeof(val1) !== "object") {
                            if (val2 === null || _typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
                            return val1 == val2;
                            return false;
                        }
                        if (val2 === null || _typeof(val2) !== "object") return false;
                    }
                    var val1Tag = objectToString(val1);
                    var val2Tag = objectToString(val2);
                    if (val1Tag !== val2Tag) return false;
                    if (Array.isArray(val1)) {
                        // Check for sparse arrays and general fast path
                        if (val1.length !== val2.length) return false;
                        var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
                        var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
                        if (keys1.length !== keys2.length) return false;
                        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
                    }
                    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
                    // wan't to early return out of the rest of the checks. However we can check
                    // if the second value is one of these values and the first isn't.
                    if (val1Tag === "[object Object]") {
                        // return keyCheck(val1, val2, strict, memos, kNoIterator);
                        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
                    }
                    if (isDate(val1)) {
                        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
                    } else if (isRegExp(val1)) {
                        if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) return false;
                    } else if (isNativeError(val1) || val1 instanceof Error) {
                        // Do not compare the stack as it might differ even though the error itself
                        // is otherwise identical.
                        if (val1.message !== val2.message || val1.name !== val2.name) return false;
                    } else if (isArrayBufferView(val1)) {
                        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
                            if (!areSimilarFloatArrays(val1, val2)) return false;
                        } else if (!areSimilarTypedArrays(val1, val2)) return false;
                        // Buffer.compare returns true, so val1.length === val2.length. If they both
                        // only contain numeric keys, we don't need to exam further than checking
                        // the symbols.
                        var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
                        var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
                        if (_keys.length !== _keys2.length) return false;
                        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
                    } else if (isSet(val1)) {
                        if (!isSet(val2) || val1.size !== val2.size) return false;
                        return keyCheck(val1, val2, strict, memos, kIsSet);
                    } else if (isMap(val1)) {
                        if (!isMap(val2) || val1.size !== val2.size) return false;
                        return keyCheck(val1, val2, strict, memos, kIsMap);
                    } else if (isAnyArrayBuffer(val1)) {
                        if (!areEqualArrayBuffers(val1, val2)) return false;
                    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
                    return keyCheck(val1, val2, strict, memos, kNoIterator);
                }
                function getEnumerables(val, keys) {
                    return keys.filter(function(k) {
                        return propertyIsEnumerable(val, k);
                    });
                }
                function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
                    // For all remaining Object pairs, including Array, objects and Maps,
                    // equivalence is determined by having:
                    // a) The same number of owned enumerable properties
                    // b) The same set of keys/indexes (although not necessarily the same order)
                    // c) Equivalent values for every corresponding key/index
                    // d) For Sets and Maps, equal contents
                    // Note: this accounts for both named and indexed properties on Arrays.
                    if (arguments.length === 5) {
                        aKeys = Object.keys(val1);
                        var bKeys = Object.keys(val2);
                        // The pair must have the same number of owned properties.
                        if (aKeys.length !== bKeys.length) return false;
                    }
                    // Cheap key test
                    var i = 0;
                    for(; i < aKeys.length; i++){
                        if (!hasOwnProperty(val2, aKeys[i])) return false;
                    }
                    if (strict && arguments.length === 5) {
                        var symbolKeysA = objectGetOwnPropertySymbols(val1);
                        if (symbolKeysA.length !== 0) {
                            var count = 0;
                            for(i = 0; i < symbolKeysA.length; i++){
                                var key = symbolKeysA[i];
                                if (propertyIsEnumerable(val1, key)) {
                                    if (!propertyIsEnumerable(val2, key)) return false;
                                    aKeys.push(key);
                                    count++;
                                } else if (propertyIsEnumerable(val2, key)) return false;
                            }
                            var symbolKeysB = objectGetOwnPropertySymbols(val2);
                            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
                        } else {
                            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
                            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
                        }
                    }
                    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
                    // Use memos to handle cycles.
                    if (memos === undefined) memos = {
                        val1: new Map(),
                        val2: new Map(),
                        position: 0
                    };
                    else {
                        // We prevent up to two map.has(x) calls by directly retrieving the value
                        // and checking for undefined. The map can only contain numbers, so it is
                        // safe to check for undefined only.
                        var val2MemoA = memos.val1.get(val1);
                        if (val2MemoA !== undefined) {
                            var val2MemoB = memos.val2.get(val2);
                            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
                        }
                        memos.position++;
                    }
                    memos.val1.set(val1, memos.position);
                    memos.val2.set(val2, memos.position);
                    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
                    memos.val1.delete(val1);
                    memos.val2.delete(val2);
                    return areEq;
                }
                function setHasEqualElement(set, val1, strict, memo) {
                    // Go looking.
                    var setValues = arrayFromSet(set);
                    for(var i = 0; i < setValues.length; i++){
                        var val2 = setValues[i];
                        if (innerDeepEqual(val1, val2, strict, memo)) {
                            // Remove the matching element to make sure we do not check that again.
                            set.delete(val2);
                            return true;
                        }
                    }
                    return false;
                }
                // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
                // Sadly it is not possible to detect corresponding values properly in case the
                // type is a string, number, bigint or boolean. The reason is that those values
                // can match lots of different string values (e.g., 1n == '+00001').
                function findLooseMatchingPrimitives(prim) {
                    switch(_typeof(prim)){
                        case "undefined":
                            return null;
                        case "object":
                            // Only pass in null as object!
                            return undefined;
                        case "symbol":
                            return false;
                        case "string":
                            prim = +prim;
                        // Loose equal entries exist only if the string is possible to convert to
                        // a regular number and not NaN.
                        // Fall through
                        case "number":
                            if (numberIsNaN(prim)) return false;
                    }
                    return true;
                }
                function setMightHaveLoosePrim(a, b, prim) {
                    var altValue = findLooseMatchingPrimitives(prim);
                    if (altValue != null) return altValue;
                    return b.has(altValue) && !a.has(altValue);
                }
                function mapMightHaveLoosePrim(a, b, prim, item, memo) {
                    var altValue = findLooseMatchingPrimitives(prim);
                    if (altValue != null) return altValue;
                    var curB = b.get(altValue);
                    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
                    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
                }
                function setEquiv(a, b, strict, memo) {
                    // This is a lazily initiated Set of entries which have to be compared
                    // pairwise.
                    var set = null;
                    var aValues = arrayFromSet(a);
                    for(var i = 0; i < aValues.length; i++){
                        var val = aValues[i];
                        // Note: Checking for the objects first improves the performance for object
                        // heavy sets but it is a minor slow down for primitives. As they are fast
                        // to check this improves the worst case scenario instead.
                        if (_typeof(val) === "object" && val !== null) {
                            if (set === null) set = new Set();
                            // If the specified value doesn't exist in the second set its an not null
                            // object (or non strict only: a not matching primitive) we'll need to go
                            // hunting for something thats deep-(strict-)equal to it. To make this
                            // O(n log n) complexity we have to copy these values in a new set first.
                            set.add(val);
                        } else if (!b.has(val)) {
                            if (strict) return false;
                            // Fast path to detect missing string, symbol, undefined and null values.
                            if (!setMightHaveLoosePrim(a, b, val)) return false;
                            if (set === null) set = new Set();
                            set.add(val);
                        }
                    }
                    if (set !== null) {
                        var bValues = arrayFromSet(b);
                        for(var _i = 0; _i < bValues.length; _i++){
                            var _val = bValues[_i];
                            // We have to check if a primitive value is already
                            // matching and only if it's not, go hunting for it.
                            if (_typeof(_val) === "object" && _val !== null) {
                                if (!setHasEqualElement(set, _val, strict, memo)) return false;
                            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
                        }
                        return set.size === 0;
                    }
                    return true;
                }
                function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
                    // To be able to handle cases like:
                    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
                    // ... we need to consider *all* matching keys, not just the first we find.
                    var setValues = arrayFromSet(set);
                    for(var i = 0; i < setValues.length; i++){
                        var key2 = setValues[i];
                        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
                            set.delete(key2);
                            return true;
                        }
                    }
                    return false;
                }
                function mapEquiv(a, b, strict, memo) {
                    var set = null;
                    var aEntries = arrayFromMap(a);
                    for(var i = 0; i < aEntries.length; i++){
                        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
                        if (_typeof(key) === "object" && key !== null) {
                            if (set === null) set = new Set();
                            set.add(key);
                        } else {
                            // By directly retrieving the value we prevent another b.has(key) check in
                            // almost all possible cases.
                            var item2 = b.get(key);
                            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                                if (strict) return false;
                                // Fast path to detect missing string, symbol, undefined and null
                                // keys.
                                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                                if (set === null) set = new Set();
                                set.add(key);
                            }
                        }
                    }
                    if (set !== null) {
                        var bEntries = arrayFromMap(b);
                        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
                            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
                            if (_typeof(_key) === "object" && _key !== null) {
                                if (!mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
                            } else if (!strict && (!a.has(_key) || !innerDeepEqual(a.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
                        }
                        return set.size === 0;
                    }
                    return true;
                }
                function objEquiv(a, b, strict, keys, memos, iterationType) {
                    // Sets and maps don't have their entries accessible via normal object
                    // properties.
                    var i = 0;
                    if (iterationType === kIsSet) {
                        if (!setEquiv(a, b, strict, memos)) return false;
                    } else if (iterationType === kIsMap) {
                        if (!mapEquiv(a, b, strict, memos)) return false;
                    } else if (iterationType === kIsArray) for(; i < a.length; i++){
                        if (hasOwnProperty(a, i)) {
                            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
                        } else if (hasOwnProperty(b, i)) return false;
                        else {
                            // Array is sparse.
                            var keysA = Object.keys(a);
                            for(; i < keysA.length; i++){
                                var key = keysA[i];
                                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
                            }
                            if (keysA.length !== Object.keys(b).length) return false;
                            return true;
                        }
                    }
                    // The pair must have equivalent values for every corresponding key.
                    // Possibly expensive deep test:
                    for(i = 0; i < keys.length; i++){
                        var _key2 = keys[i];
                        if (!innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
                    }
                    return true;
                }
                function isDeepEqual(val1, val2) {
                    return innerDeepEqual(val1, val2, kLoose);
                }
                function isDeepStrictEqual(val1, val2) {
                    return innerDeepEqual(val1, val2, kStrict);
                }
                module1.exports = {
                    isDeepEqual: isDeepEqual,
                    isDeepStrictEqual: isDeepStrictEqual
                };
            /***/ },
            /***/ 5155: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
                var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup["-".charCodeAt(0)] = 62;
                revLookup["_".charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf("=");
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join("");
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
                    }
                    return parts.join("");
                }
            /***/ },
            /***/ 56887: /***/ function(module1) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var BROTLI_READ_SIZE = 4096;
                var BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32;
                var BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1;
                var kBitMask = new Uint32Array([
                    0,
                    1,
                    3,
                    7,
                    15,
                    31,
                    63,
                    127,
                    255,
                    511,
                    1023,
                    2047,
                    4095,
                    8191,
                    16383,
                    32767,
                    65535,
                    131071,
                    262143,
                    524287,
                    1048575,
                    2097151,
                    4194303,
                    8388607,
                    16777215
                ]);
                /* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function BrotliBitReader(input) {
                    this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
                    this.input_ = input; /* input callback */ 
                    this.reset();
                }
                BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
                BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
                BrotliBitReader.prototype.reset = function() {
                    this.buf_ptr_ = 0; /* next input will write here */ 
                    this.val_ = 0; /* pre-fetched bits */ 
                    this.pos_ = 0; /* byte position in stream */ 
                    this.bit_pos_ = 0; /* current bit-reading position in val_ */ 
                    this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */ 
                    this.eos_ = 0; /* input stream is finished */ 
                    this.readMoreInput();
                    for(var i = 0; i < 4; i++){
                        this.val_ |= this.buf_[this.pos_] << 8 * i;
                        ++this.pos_;
                    }
                    return this.bit_end_pos_ > 0;
                };
                /* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ BrotliBitReader.prototype.readMoreInput = function() {
                    if (this.bit_end_pos_ > 256) return;
                    else if (this.eos_) {
                        if (this.bit_pos_ > this.bit_end_pos_) throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
                    } else {
                        var dst = this.buf_ptr_;
                        var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
                        if (bytes_read < 0) throw new Error("Unexpected end of input");
                        if (bytes_read < BROTLI_READ_SIZE) {
                            this.eos_ = 1;
                            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
                        }
                        if (dst === 0) {
                            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
                            this.buf_ptr_ = BROTLI_READ_SIZE;
                        } else this.buf_ptr_ = 0;
                        this.bit_end_pos_ += bytes_read << 3;
                    }
                };
                /* Guarantees that there are at least 24 bits in the buffer. */ BrotliBitReader.prototype.fillBitWindow = function() {
                    while(this.bit_pos_ >= 8){
                        this.val_ >>>= 8;
                        this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
                        ++this.pos_;
                        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
                        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
                    }
                };
                /* Reads the specified number of bits from Read Buffer. */ BrotliBitReader.prototype.readBits = function(n_bits) {
                    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
                    var val = this.val_ >>> this.bit_pos_ & kBitMask[n_bits];
                    this.bit_pos_ += n_bits;
                    return val;
                };
                module1.exports = BrotliBitReader;
            /***/ },
            /***/ 52150: /***/ function(__unused_webpack_module, exports) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ var CONTEXT_LSB6 = 0;
                var CONTEXT_MSB6 = 1;
                var CONTEXT_UTF8 = 2;
                var CONTEXT_SIGNED = 3;
                /* Common context lookup table for all context modes. */ exports.lookup = new Uint8Array([
                    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4,
                    4,
                    0,
                    0,
                    4,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8,
                    12,
                    16,
                    12,
                    12,
                    20,
                    12,
                    16,
                    24,
                    28,
                    12,
                    12,
                    32,
                    12,
                    36,
                    12,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    32,
                    32,
                    24,
                    40,
                    28,
                    12,
                    12,
                    48,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    52,
                    52,
                    24,
                    12,
                    28,
                    12,
                    12,
                    12,
                    56,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    60,
                    60,
                    24,
                    12,
                    28,
                    12,
                    0,
                    /* UTF8 continuation byte range. */ 0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    /* UTF8 lead byte range. */ 2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    1,
                    1,
                    1,
                    1,
                    0,
                    /* UTF8 continuation byte range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    /* UTF8 lead byte range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    /* CONTEXT_SIGNED, second last byte. */ 0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    7,
                    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    56,
                    /* CONTEXT_LSB6, last byte. */ 0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    /* CONTEXT_MSB6, last byte. */ 0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    6,
                    6,
                    6,
                    6,
                    7,
                    7,
                    7,
                    7,
                    8,
                    8,
                    8,
                    8,
                    9,
                    9,
                    9,
                    9,
                    10,
                    10,
                    10,
                    10,
                    11,
                    11,
                    11,
                    11,
                    12,
                    12,
                    12,
                    12,
                    13,
                    13,
                    13,
                    13,
                    14,
                    14,
                    14,
                    14,
                    15,
                    15,
                    15,
                    15,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    22,
                    22,
                    22,
                    22,
                    23,
                    23,
                    23,
                    23,
                    24,
                    24,
                    24,
                    24,
                    25,
                    25,
                    25,
                    25,
                    26,
                    26,
                    26,
                    26,
                    27,
                    27,
                    27,
                    27,
                    28,
                    28,
                    28,
                    28,
                    29,
                    29,
                    29,
                    29,
                    30,
                    30,
                    30,
                    30,
                    31,
                    31,
                    31,
                    31,
                    32,
                    32,
                    32,
                    32,
                    33,
                    33,
                    33,
                    33,
                    34,
                    34,
                    34,
                    34,
                    35,
                    35,
                    35,
                    35,
                    36,
                    36,
                    36,
                    36,
                    37,
                    37,
                    37,
                    37,
                    38,
                    38,
                    38,
                    38,
                    39,
                    39,
                    39,
                    39,
                    40,
                    40,
                    40,
                    40,
                    41,
                    41,
                    41,
                    41,
                    42,
                    42,
                    42,
                    42,
                    43,
                    43,
                    43,
                    43,
                    44,
                    44,
                    44,
                    44,
                    45,
                    45,
                    45,
                    45,
                    46,
                    46,
                    46,
                    46,
                    47,
                    47,
                    47,
                    47,
                    48,
                    48,
                    48,
                    48,
                    49,
                    49,
                    49,
                    49,
                    50,
                    50,
                    50,
                    50,
                    51,
                    51,
                    51,
                    51,
                    52,
                    52,
                    52,
                    52,
                    53,
                    53,
                    53,
                    53,
                    54,
                    54,
                    54,
                    54,
                    55,
                    55,
                    55,
                    55,
                    56,
                    56,
                    56,
                    56,
                    57,
                    57,
                    57,
                    57,
                    58,
                    58,
                    58,
                    58,
                    59,
                    59,
                    59,
                    59,
                    60,
                    60,
                    60,
                    60,
                    61,
                    61,
                    61,
                    61,
                    62,
                    62,
                    62,
                    62,
                    63,
                    63,
                    63,
                    63,
                    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]);
                exports.lookupOffsets = new Uint16Array([
                    /* CONTEXT_LSB6 */ 1024,
                    1536,
                    /* CONTEXT_MSB6 */ 1280,
                    1536,
                    /* CONTEXT_UTF8 */ 0,
                    256,
                    /* CONTEXT_SIGNED */ 768,
                    512
                ]);
            /***/ },
            /***/ 17217: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __webpack_unused_export__;
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var BrotliInput = __webpack_require__(46170)/* .BrotliInput */ .g;
                var BrotliOutput = __webpack_require__(46170)/* .BrotliOutput */ .j;
                var BrotliBitReader = __webpack_require__(56887);
                var BrotliDictionary = __webpack_require__(50227);
                var HuffmanCode = __webpack_require__(33535)/* .HuffmanCode */ .h;
                var BrotliBuildHuffmanTable = __webpack_require__(33535)/* .BrotliBuildHuffmanTable */ .g;
                var Context = __webpack_require__(52150);
                var Prefix = __webpack_require__(4008);
                var Transform = __webpack_require__(22906);
                var kDefaultCodeLength = 8;
                var kCodeLengthRepeatCode = 16;
                var kNumLiteralCodes = 256;
                var kNumInsertAndCopyCodes = 704;
                var kNumBlockLengthCodes = 26;
                var kLiteralContextBits = 6;
                var kDistanceContextBits = 2;
                var HUFFMAN_TABLE_BITS = 8;
                var HUFFMAN_TABLE_MASK = 0xff;
                /* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var HUFFMAN_MAX_TABLE_SIZE = 1080;
                var CODE_LENGTH_CODES = 18;
                var kCodeLengthCodeOrder = new Uint8Array([
                    1,
                    2,
                    3,
                    4,
                    0,
                    5,
                    17,
                    6,
                    16,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15
                ]);
                var NUM_DISTANCE_SHORT_CODES = 16;
                var kDistanceShortCodeIndexOffset = new Uint8Array([
                    3,
                    2,
                    1,
                    0,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2
                ]);
                var kDistanceShortCodeValueOffset = new Int8Array([
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1,
                    -2,
                    2,
                    -3,
                    3,
                    -1,
                    1,
                    -2,
                    2,
                    -3,
                    3
                ]);
                var kMaxHuffmanTableSize = new Uint16Array([
                    256,
                    402,
                    436,
                    468,
                    500,
                    534,
                    566,
                    598,
                    630,
                    662,
                    694,
                    726,
                    758,
                    790,
                    822,
                    854,
                    886,
                    920,
                    952,
                    984,
                    1016,
                    1048,
                    1080
                ]);
                function DecodeWindowBits(br) {
                    var n;
                    if (br.readBits(1) === 0) return 16;
                    n = br.readBits(3);
                    if (n > 0) return 17 + n;
                    n = br.readBits(3);
                    if (n > 0) return 8 + n;
                    return 17;
                }
                /* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function DecodeVarLenUint8(br) {
                    if (br.readBits(1)) {
                        var nbits = br.readBits(3);
                        if (nbits === 0) return 1;
                        else return br.readBits(nbits) + (1 << nbits);
                    }
                    return 0;
                }
                function MetaBlockLength() {
                    this.meta_block_length = 0;
                    this.input_end = 0;
                    this.is_uncompressed = 0;
                    this.is_metadata = false;
                }
                function DecodeMetaBlockLength(br) {
                    var out = new MetaBlockLength;
                    var size_nibbles;
                    var size_bytes;
                    var i;
                    out.input_end = br.readBits(1);
                    if (out.input_end && br.readBits(1)) return out;
                    size_nibbles = br.readBits(2) + 4;
                    if (size_nibbles === 7) {
                        out.is_metadata = true;
                        if (br.readBits(1) !== 0) throw new Error("Invalid reserved bit");
                        size_bytes = br.readBits(2);
                        if (size_bytes === 0) return out;
                        for(i = 0; i < size_bytes; i++){
                            var next_byte = br.readBits(8);
                            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error("Invalid size byte");
                            out.meta_block_length |= next_byte << i * 8;
                        }
                    } else for(i = 0; i < size_nibbles; ++i){
                        var next_nibble = br.readBits(4);
                        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error("Invalid size nibble");
                        out.meta_block_length |= next_nibble << i * 4;
                    }
                    ++out.meta_block_length;
                    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
                    return out;
                }
                /* Decodes the next Huffman code from bit-stream. */ function ReadSymbol(table, index, br) {
                    var start_index = index;
                    var nbits;
                    br.fillBitWindow();
                    index += br.val_ >>> br.bit_pos_ & HUFFMAN_TABLE_MASK;
                    nbits = table[index].bits - HUFFMAN_TABLE_BITS;
                    if (nbits > 0) {
                        br.bit_pos_ += HUFFMAN_TABLE_BITS;
                        index += table[index].value;
                        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
                    }
                    br.bit_pos_ += table[index].bits;
                    return table[index].value;
                }
                function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
                    var symbol = 0;
                    var prev_code_len = kDefaultCodeLength;
                    var repeat = 0;
                    var repeat_code_len = 0;
                    var space = 32768;
                    var table = [];
                    for(var i = 0; i < 32; i++)table.push(new HuffmanCode(0, 0));
                    BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);
                    while(symbol < num_symbols && space > 0){
                        var p = 0;
                        var code_len;
                        br.readMoreInput();
                        br.fillBitWindow();
                        p += br.val_ >>> br.bit_pos_ & 31;
                        br.bit_pos_ += table[p].bits;
                        code_len = table[p].value & 0xff;
                        if (code_len < kCodeLengthRepeatCode) {
                            repeat = 0;
                            code_lengths[symbol++] = code_len;
                            if (code_len !== 0) {
                                prev_code_len = code_len;
                                space -= 32768 >> code_len;
                            }
                        } else {
                            var extra_bits = code_len - 14;
                            var old_repeat;
                            var repeat_delta;
                            var new_len = 0;
                            if (code_len === kCodeLengthRepeatCode) new_len = prev_code_len;
                            if (repeat_code_len !== new_len) {
                                repeat = 0;
                                repeat_code_len = new_len;
                            }
                            old_repeat = repeat;
                            if (repeat > 0) {
                                repeat -= 2;
                                repeat <<= extra_bits;
                            }
                            repeat += br.readBits(extra_bits) + 3;
                            repeat_delta = repeat - old_repeat;
                            if (symbol + repeat_delta > num_symbols) throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
                            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
                            symbol += repeat_delta;
                            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
                        }
                    }
                    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
                    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
                }
                function ReadHuffmanCode(alphabet_size, tables, table, br) {
                    var table_size = 0;
                    var simple_code_or_skip;
                    var code_lengths = new Uint8Array(alphabet_size);
                    br.readMoreInput();
                    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
                    if (simple_code_or_skip === 1) {
                        /* Read symbols, codes & code lengths directly. */ var i;
                        var max_bits_counter = alphabet_size - 1;
                        var max_bits = 0;
                        var symbols = new Int32Array(4);
                        var num_symbols = br.readBits(2) + 1;
                        while(max_bits_counter){
                            max_bits_counter >>= 1;
                            ++max_bits;
                        }
                        for(i = 0; i < num_symbols; ++i){
                            symbols[i] = br.readBits(max_bits) % alphabet_size;
                            code_lengths[symbols[i]] = 2;
                        }
                        code_lengths[symbols[0]] = 1;
                        switch(num_symbols){
                            case 1:
                                break;
                            case 3:
                                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error("[ReadHuffmanCode] invalid symbols");
                                break;
                            case 2:
                                if (symbols[0] === symbols[1]) throw new Error("[ReadHuffmanCode] invalid symbols");
                                code_lengths[symbols[1]] = 1;
                                break;
                            case 4:
                                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error("[ReadHuffmanCode] invalid symbols");
                                if (br.readBits(1)) {
                                    code_lengths[symbols[2]] = 3;
                                    code_lengths[symbols[3]] = 3;
                                } else code_lengths[symbols[0]] = 2;
                                break;
                        }
                    } else {
                        var i;
                        var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
                        var space = 32;
                        var num_codes = 0;
                        /* Static Huffman code for the code length code lengths */ var huff = [
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(3, 2),
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(4, 1),
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(3, 2),
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(4, 5)
                        ];
                        for(i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i){
                            var code_len_idx = kCodeLengthCodeOrder[i];
                            var p = 0;
                            var v;
                            br.fillBitWindow();
                            p += br.val_ >>> br.bit_pos_ & 15;
                            br.bit_pos_ += huff[p].bits;
                            v = huff[p].value;
                            code_length_code_lengths[code_len_idx] = v;
                            if (v !== 0) {
                                space -= 32 >> v;
                                ++num_codes;
                            }
                        }
                        if (!(num_codes === 1 || space === 0)) throw new Error("[ReadHuffmanCode] invalid num_codes or space");
                        ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
                    }
                    table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
                    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
                    return table_size;
                }
                function ReadBlockLength(table, index, br) {
                    var code;
                    var nbits;
                    code = ReadSymbol(table, index, br);
                    nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
                    return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
                }
                function TranslateShortCodes(code, ringbuffer, index) {
                    var val;
                    if (code < NUM_DISTANCE_SHORT_CODES) {
                        index += kDistanceShortCodeIndexOffset[code];
                        index &= 3;
                        val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
                    } else val = code - NUM_DISTANCE_SHORT_CODES + 1;
                    return val;
                }
                function MoveToFront(v, index) {
                    var value = v[index];
                    var i = index;
                    for(; i; --i)v[i] = v[i - 1];
                    v[0] = value;
                }
                function InverseMoveToFrontTransform(v, v_len) {
                    var mtf = new Uint8Array(256);
                    var i;
                    for(i = 0; i < 256; ++i)mtf[i] = i;
                    for(i = 0; i < v_len; ++i){
                        var index = v[i];
                        v[i] = mtf[index];
                        if (index) MoveToFront(mtf, index);
                    }
                }
                /* Contains a collection of huffman trees with the same alphabet size. */ function HuffmanTreeGroup(alphabet_size, num_htrees) {
                    this.alphabet_size = alphabet_size;
                    this.num_htrees = num_htrees;
                    this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
                    this.htrees = new Uint32Array(num_htrees);
                }
                HuffmanTreeGroup.prototype.decode = function(br) {
                    var i;
                    var table_size;
                    var next = 0;
                    for(i = 0; i < this.num_htrees; ++i){
                        this.htrees[i] = next;
                        table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
                        next += table_size;
                    }
                };
                function DecodeContextMap(context_map_size, br) {
                    var out = {
                        num_htrees: null,
                        context_map: null
                    };
                    var use_rle_for_zeros;
                    var max_run_length_prefix = 0;
                    var table;
                    var i;
                    br.readMoreInput();
                    var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;
                    var context_map = out.context_map = new Uint8Array(context_map_size);
                    if (num_htrees <= 1) return out;
                    use_rle_for_zeros = br.readBits(1);
                    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
                    table = [];
                    for(i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new HuffmanCode(0, 0);
                    ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
                    for(i = 0; i < context_map_size;){
                        var code;
                        br.readMoreInput();
                        code = ReadSymbol(table, 0, br);
                        if (code === 0) {
                            context_map[i] = 0;
                            ++i;
                        } else if (code <= max_run_length_prefix) {
                            var reps = 1 + (1 << code) + br.readBits(code);
                            while(--reps){
                                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                                context_map[i] = 0;
                                ++i;
                            }
                        } else {
                            context_map[i] = code - max_run_length_prefix;
                            ++i;
                        }
                    }
                    if (br.readBits(1)) InverseMoveToFrontTransform(context_map, context_map_size);
                    return out;
                }
                function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
                    var ringbuffer = tree_type * 2;
                    var index = tree_type;
                    var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
                    var block_type;
                    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
                    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
                    else block_type = type_code - 2;
                    if (block_type >= max_block_type) block_type -= max_block_type;
                    block_types[tree_type] = block_type;
                    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
                    ++indexes[index];
                }
                function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
                    var rb_size = ringbuffer_mask + 1;
                    var rb_pos = pos & ringbuffer_mask;
                    var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
                    var nbytes;
                    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
                        while(len-- > 0){
                            br.readMoreInput();
                            ringbuffer[rb_pos++] = br.readBits(8);
                            if (rb_pos === rb_size) {
                                output.write(ringbuffer, rb_size);
                                rb_pos = 0;
                            }
                        }
                        return;
                    }
                    if (br.bit_end_pos_ < 32) throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
                    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
                        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
                        br.bit_pos_ += 8;
                        ++rb_pos;
                        --len;
                    }
                    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
                    if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
                        var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
                        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
                        nbytes -= tail;
                        rb_pos += tail;
                        len -= tail;
                        br_pos = 0;
                    }
                    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
                    rb_pos += nbytes;
                    len -= nbytes;
                    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
                        output.write(ringbuffer, rb_size);
                        rb_pos -= rb_size;
                        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
                    }
                    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
                        nbytes = rb_size - rb_pos;
                        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
                        output.write(ringbuffer, rb_size);
                        len -= nbytes;
                        rb_pos = 0;
                    }
                    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
                    /* Restore the state of the bit reader. */ br.reset();
                }
                /* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function JumpToByteBoundary(br) {
                    var new_bit_pos = br.bit_pos_ + 7 & -8;
                    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
                    return pad_bits == 0;
                }
                function BrotliDecompressedSize(buffer) {
                    var input = new BrotliInput(buffer);
                    var br = new BrotliBitReader(input);
                    DecodeWindowBits(br);
                    var out = DecodeMetaBlockLength(br);
                    return out.meta_block_length;
                }
                __webpack_unused_export__ = BrotliDecompressedSize;
                function BrotliDecompressBuffer(buffer, output_size) {
                    var input = new BrotliInput(buffer);
                    if (output_size == null) output_size = BrotliDecompressedSize(buffer);
                    var output_buffer = new Uint8Array(output_size);
                    var output = new BrotliOutput(output_buffer);
                    BrotliDecompress(input, output);
                    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
                    return output.buffer;
                }
                exports.BrotliDecompressBuffer = BrotliDecompressBuffer;
                function BrotliDecompress(input, output) {
                    var i;
                    var pos = 0;
                    var input_end = 0;
                    var window_bits = 0;
                    var max_backward_distance;
                    var max_distance = 0;
                    var ringbuffer_size;
                    var ringbuffer_mask;
                    var ringbuffer;
                    var ringbuffer_end;
                    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
                        16,
                        15,
                        11,
                        4
                    ];
                    var dist_rb_idx = 0;
                    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
                    var prev_byte2 = 0;
                    var hgroup = [
                        new HuffmanTreeGroup(0, 0),
                        new HuffmanTreeGroup(0, 0),
                        new HuffmanTreeGroup(0, 0)
                    ];
                    var block_type_trees;
                    var block_len_trees;
                    var br;
                    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
                    br = new BrotliBitReader(input);
                    /* Decode window size. */ window_bits = DecodeWindowBits(br);
                    max_backward_distance = (1 << window_bits) - 16;
                    ringbuffer_size = 1 << window_bits;
                    ringbuffer_mask = ringbuffer_size - 1;
                    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
                    ringbuffer_end = ringbuffer_size;
                    block_type_trees = [];
                    block_len_trees = [];
                    for(var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++){
                        block_type_trees[x] = new HuffmanCode(0, 0);
                        block_len_trees[x] = new HuffmanCode(0, 0);
                    }
                    while(!input_end){
                        var meta_block_remaining_len = 0;
                        var is_uncompressed;
                        var block_length = [
                            268435456,
                            268435456,
                            268435456
                        ];
                        var block_type = [
                            0
                        ];
                        var num_block_types = [
                            1,
                            1,
                            1
                        ];
                        var block_type_rb = [
                            0,
                            1,
                            0,
                            1,
                            0,
                            1
                        ];
                        var block_type_rb_index = [
                            0
                        ];
                        var distance_postfix_bits;
                        var num_direct_distance_codes;
                        var distance_postfix_mask;
                        var num_distance_codes;
                        var context_map = null;
                        var context_modes = null;
                        var num_literal_htrees;
                        var dist_context_map = null;
                        var num_dist_htrees;
                        var context_offset = 0;
                        var context_map_slice = null;
                        var literal_htree_index = 0;
                        var dist_context_offset = 0;
                        var dist_context_map_slice = null;
                        var dist_htree_index = 0;
                        var context_lookup_offset1 = 0;
                        var context_lookup_offset2 = 0;
                        var context_mode;
                        var htree_command;
                        for(i = 0; i < 3; ++i){
                            hgroup[i].codes = null;
                            hgroup[i].htrees = null;
                        }
                        br.readMoreInput();
                        var _out = DecodeMetaBlockLength(br);
                        meta_block_remaining_len = _out.meta_block_length;
                        if (pos + meta_block_remaining_len > output.buffer.length) {
                            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
                            tmp.set(output.buffer);
                            output.buffer = tmp;
                        }
                        input_end = _out.input_end;
                        is_uncompressed = _out.is_uncompressed;
                        if (_out.is_metadata) {
                            JumpToByteBoundary(br);
                            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                                br.readMoreInput();
                                /* Read one byte and ignore it. */ br.readBits(8);
                            }
                            continue;
                        }
                        if (meta_block_remaining_len === 0) continue;
                        if (is_uncompressed) {
                            br.bit_pos_ = br.bit_pos_ + 7 & -8;
                            CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
                            pos += meta_block_remaining_len;
                            continue;
                        }
                        for(i = 0; i < 3; ++i){
                            num_block_types[i] = DecodeVarLenUint8(br) + 1;
                            if (num_block_types[i] >= 2) {
                                ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                                ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                                block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                                block_type_rb_index[i] = 1;
                            }
                        }
                        br.readMoreInput();
                        distance_postfix_bits = br.readBits(2);
                        num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
                        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
                        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
                        context_modes = new Uint8Array(num_block_types[0]);
                        for(i = 0; i < num_block_types[0]; ++i){
                            br.readMoreInput();
                            context_modes[i] = br.readBits(2) << 1;
                        }
                        var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
                        num_literal_htrees = _o1.num_htrees;
                        context_map = _o1.context_map;
                        var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
                        num_dist_htrees = _o2.num_htrees;
                        dist_context_map = _o2.context_map;
                        hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
                        hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
                        hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
                        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
                        context_map_slice = 0;
                        dist_context_map_slice = 0;
                        context_mode = context_modes[block_type[0]];
                        context_lookup_offset1 = Context.lookupOffsets[context_mode];
                        context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                        htree_command = hgroup[1].htrees[0];
                        while(meta_block_remaining_len > 0){
                            var cmd_code;
                            var range_idx;
                            var insert_code;
                            var copy_code;
                            var insert_length;
                            var copy_length;
                            var distance_code;
                            var distance;
                            var context;
                            var j;
                            var copy_dst;
                            br.readMoreInput();
                            if (block_length[1] === 0) {
                                DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                                block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
                                htree_command = hgroup[1].htrees[block_type[1]];
                            }
                            --block_length[1];
                            cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
                            range_idx = cmd_code >> 6;
                            if (range_idx >= 2) {
                                range_idx -= 2;
                                distance_code = -1;
                            } else distance_code = 0;
                            insert_code = Prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
                            copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
                            insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
                            copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
                            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
                            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
                            for(j = 0; j < insert_length; ++j){
                                br.readMoreInput();
                                if (block_length[0] === 0) {
                                    DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                                    block_length[0] = ReadBlockLength(block_len_trees, 0, br);
                                    context_offset = block_type[0] << kLiteralContextBits;
                                    context_map_slice = context_offset;
                                    context_mode = context_modes[block_type[0]];
                                    context_lookup_offset1 = Context.lookupOffsets[context_mode];
                                    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                                }
                                context = Context.lookup[context_lookup_offset1 + prev_byte1] | Context.lookup[context_lookup_offset2 + prev_byte2];
                                literal_htree_index = context_map[context_map_slice + context];
                                --block_length[0];
                                prev_byte2 = prev_byte1;
                                prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                                ++pos;
                            }
                            meta_block_remaining_len -= insert_length;
                            if (meta_block_remaining_len <= 0) break;
                            if (distance_code < 0) {
                                var context;
                                br.readMoreInput();
                                if (block_length[2] === 0) {
                                    DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                                    block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
                                    dist_context_offset = block_type[2] << kDistanceContextBits;
                                    dist_context_map_slice = dist_context_offset;
                                }
                                --block_length[2];
                                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                                distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                                if (distance_code >= num_direct_distance_codes) {
                                    var nbits;
                                    var postfix;
                                    var offset;
                                    distance_code -= num_direct_distance_codes;
                                    postfix = distance_code & distance_postfix_mask;
                                    distance_code >>= distance_postfix_bits;
                                    nbits = (distance_code >> 1) + 1;
                                    offset = (2 + (distance_code & 1) << nbits) - 4;
                                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                                }
                            }
                            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
                            if (distance < 0) throw new Error("[BrotliDecompress] invalid distance");
                            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
                            else max_distance = max_backward_distance;
                            copy_dst = pos & ringbuffer_mask;
                            if (distance > max_distance) {
                                if (copy_length >= BrotliDictionary.minDictionaryWordLength && copy_length <= BrotliDictionary.maxDictionaryWordLength) {
                                    var offset = BrotliDictionary.offsetsByLength[copy_length];
                                    var word_id = distance - max_distance - 1;
                                    var shift = BrotliDictionary.sizeBitsByLength[copy_length];
                                    var mask = (1 << shift) - 1;
                                    var word_idx = word_id & mask;
                                    var transform_idx = word_id >> shift;
                                    offset += word_idx * copy_length;
                                    if (transform_idx < Transform.kNumTransforms) {
                                        var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                                        copy_dst += len;
                                        pos += len;
                                        meta_block_remaining_len -= len;
                                        if (copy_dst >= ringbuffer_end) {
                                            output.write(ringbuffer, ringbuffer_size);
                                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                                        }
                                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                            } else {
                                if (distance_code > 0) {
                                    dist_rb[dist_rb_idx & 3] = distance;
                                    ++dist_rb_idx;
                                }
                                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                                for(j = 0; j < copy_length; ++j){
                                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                                    ++pos;
                                    --meta_block_remaining_len;
                                }
                            }
                            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
                            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
                        }
                        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
                    }
                    output.write(ringbuffer, pos & ringbuffer_mask);
                }
                __webpack_unused_export__ = BrotliDecompress;
                BrotliDictionary.init();
            /***/ },
            /***/ 99373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var base64 = __webpack_require__(5155);
                /**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */ exports.init = function() {
                    var BrotliDecompressBuffer = __webpack_require__(17217).BrotliDecompressBuffer;
                    var compressed = base64.toByteArray(__webpack_require__(13019));
                    return BrotliDecompressBuffer(compressed);
                };
            /***/ },
            /***/ 13019: /***/ function(module1) {
                module1.exports = "W5/fcQLn5gKf2XUbAiQ1XULX+TZz6ADToDsgqk6qVfeC0e4m6OO2wcQ1J76ZBVRV1fRkEsdu//62zQsFEZWSTCnMhcsQKlS2qOhuVYYMGCkV0fXWEoMFbESXrKEZ9wdUEsyw9g4bJlEt1Y6oVMxMRTEVbCIwZzJzboK5j8m4YH02qgXYhv1V+PM435sLVxyHJihaJREEhZGqL03txGFQLm76caGO/ovxKvzCby/3vMTtX/459f0igi7WutnKiMQ6wODSoRh/8Lx1V3Q99MvKtwB6bHdERYRY0hStJoMjNeTsNX7bn+Y7e4EQ3bf8xBc7L0BsyfFPK43dGSXpL6clYC/I328h54/VYrQ5i0648FgbGtl837svJ35L3Mot/+nPlNpWgKx1gGXQYqX6n+bbZ7wuyCHKcUok12Xjqub7NXZGzqBx0SD+uziNf87t7ve42jxSKQoW3nyxVrWIGlFShhCKxjpZZ5MeGna0+lBkk+kaN8F9qFBAFgEogyMBdcX/T1W/WnMOi/7ycWUQloEBKGeC48MkiwqJkJO+12eQiOFHMmck6q/IjWW3RZlany23TBm+cNr/84/oi5GGmGBZWrZ6j+zykVozz5fT/QH/Da6WTbZYYPynVNO7kxzuNN2kxKKWche5WveitPKAecB8YcAHz/+zXLjcLzkdDSktNIDwZE9J9X+tto43oJy65wApM3mDzYtCwX9lM+N5VR3kXYo0Z3t0TtXfgBFg7gU8oN0Dgl7fZlUbhNll+0uuohRVKjrEd8egrSndy5/Tgd2gqjA4CAVuC7ESUmL3DZoGnfhQV8uwnpi8EGvAVVsowNRxPudck7+oqAUDkwZopWqFnW1riss0t1z6iCISVKreYGNvQcXv+1L9+jbP8cd/dPUiqBso2q+7ZyFBvENCkkVr44iyPbtOoOoCecWsiuqMSML5lv+vN5MzUr+Dnh73G7Q1YnRYJVYXHRJaNAOByiaK6CusgFdBPE40r0rvqXV7tksKO2DrHYXBTv8P5ysqxEx8VDXUDDqkPH6NNOV/a2WH8zlkXRELSa8P+heNyJBBP7PgsG1EtWtNef6/i+lcayzQwQCsduidpbKfhWUDgAEmyhGu/zVTacI6RS0zTABrOYueemnVa19u9fT23N/Ta6RvTpof5DWygqreCqrDAgM4LID1+1T/taU6yTFVLqXOv+/MuQOFnaF8vLMKD7tKWDoBdALgxF33zQccCcdHx8fKIVdW69O7qHtXpeGr9jbbpFA+qRMWr5hp0s67FPc7HAiLV0g0/peZlW7hJPYEhZyhpSwahnf93/tZgfqZWXFdmdXBzqxGHLrQKxoAY6fRoBhgCRPmmGueYZ5JexTVDKUIXzkG/fqp/0U3hAgQdJ9zumutK6nqWbaqvm1pgu03IYR+G+8s0jDBBz8cApZFSBeuWasyqo2OMDKAZCozS+GWSvL/HsE9rHxooe17U3s/lTE+VZAk4j3dp6uIGaC0JMiqR5CUsabPyM0dOYDR7Ea7ip4USZlya38YfPtvrX/tBlhHilj55nZ1nfN24AOAi9BVtz/Mbn8AEDJCqJgsVUa6nQnSxv2Fs7l/NlCzpfYEjmPrNyib/+t0ei2eEMjvNhLkHCZlci4WhBe7ePZTmzYqlY9+1pxtS4GB+5lM1BHT9tS270EWUDYFq1I0yY/fNiAk4bk9yBgmef/f2k6AlYQZHsNFnW8wBQxCd68iWv7/35bXfz3JZmfGligWAKRjIs3IpzxQ27vAglHSiOzCYzJ9L9A1CdiyFvyR66ucA4jKifu5ehwER26yV7HjKqn5Mfozo7Coxxt8LWWPT47BeMxX8p0Pjb7hZn+6bw7z3Lw+7653j5sI8CLu5kThpMlj1m4c2ch3jGcP1FsT13vuK3qjecKTZk2kHcOZY40UX+qdaxstZqsqQqgXz+QGF99ZJLqr3VYu4aecl1Ab5GmqS8k/GV5b95zxQ5d4EfXUJ6kTS/CXF/aiqKDOT1T7Jz5z0PwDUcwr9clLN1OJGCiKfqvah+h3XzrBOiLOW8wvn8gW6qE8vPxi+Efv+UH55T7PQFVMh6cZ1pZQlzJpKZ7P7uWvwPGJ6DTlR6wbyj3Iv2HyefnRo/dv7dNx+qaa0N38iBsR++Uil7Wd4afwDNsrzDAK4fXZwvEY/jdKuIKXlfrQd2C39dW7ntnRbIp9OtGy9pPBn/V2ASoi/2UJZfS+xuGLH8bnLuPlzdTNS6zdyk8Dt/h6sfOW5myxh1f+zf3zZ3MX/mO9cQPp5pOx967ZA6/pqHvclNfnUFF+rq+Vd7alKr6KWPcIDhpn6v2K6NlUu6LrKo8b/pYpU/Gazfvtwhn7tEOUuXht5rUJdSf6sLjYf0VTYDgwJ81yaqKTUYej/tbHckSRb/HZicwGJqh1mAHB/IuNs9dc9yuvF3D5Xocm3elWFdq5oEy70dYFit79yaLiNjPj5UUcVmZUVhQEhW5V2Z6Cm4HVH/R8qlamRYwBileuh07CbEce3TXa2JmXWBf+ozt319psboobeZhVnwhMZzOeQJzhpTDbP71Tv8HuZxxUI/+ma3XW6DFDDs4+qmpERwHGBd2edxwUKlODRdUWZ/g0GOezrbzOZauFMai4QU6GVHV6aPNBiBndHSsV4IzpvUiiYyg6OyyrL4Dj5q/Lw3N5kAwftEVl9rNd7Jk5PDij2hTH6wIXnsyXkKePxbmHYgC8A6an5Fob/KH5GtC0l4eFso+VpxedtJHdHpNm+Bvy4C79yVOkrZsLrQ3OHCeB0Ra+kBIRldUGlDCEmq2RwXnfyh6Dz+alk6eftI2n6sastRrGwbwszBeDRS/Fa/KwRJkCzTsLr/JCs5hOPE/MPLYdZ1F1fv7D+VmysX6NpOC8aU9F4Qs6HvDyUy9PvFGDKZ/P5101TYHFl8pjj6wm/qyS75etZhhfg0UEL4OYmHk6m6dO192AzoIyPSV9QedDA4Ml23rRbqxMPMxf7FJnDc5FTElVS/PyqgePzmwVZ26NWhRDQ+oaT7ly7ell4s3DypS1s0g+tOr7XHrrkZj9+x/mJBttrLx98lFIaRZzHz4aC7r52/JQ4VjHahY2/YVXZn/QC2ztQb/sY3uRlyc5vQS8nLPGT/n27495i8HPA152z7Fh5aFpyn1GPJKHuPL8Iw94DuW3KjkURAWZXn4EQy89xiKEHN1mk/tkM4gYDBxwNoYvRfE6LFqsxWJtPrDGbsnLMap3Ka3MUoytW0cvieozOmdERmhcqzG+3HmZv2yZeiIeQTKGdRT4HHNxekm1tY+/n06rGmFleqLscSERzctTKM6G9P0Pc1RmVvrascIxaO1CQCiYPE15bD7c3xSeW7gXxYjgxcrUlcbIvO0r+Yplhx0kTt3qafDOmFyMjgGxXu73rddMHpV1wMubyAGcf/v5dLr5P72Ta9lBF+fzMJrMycwv+9vnU3ANIl1cH9tfW7af8u0/HG0vV47jNFXzFTtaha1xvze/s8KMtCYucXc1nzfd/MQydUXn/b72RBt5wO/3jRcMH9BdhC/yctKBIveRYPrNpDWqBsO8VMmP+WvRaOcA4zRMR1PvSoO92rS7pYEv+fZfEfTMzEdM+6X5tLlyxExhqLRkms5EuLovLfx66de5fL2/yX02H52FPVwahrPqmN/E0oVXnsCKhbi/yRxX83nRbUKWhzYceXOntfuXn51NszJ6MO73pQf5Pl4in3ec4JU8hF7ppV34+mm9r1LY0ee/i1O1wpd8+zfLztE0cqBxggiBi5Bu95v9l3r9r/U5hweLn+TbfxowrWDqdJauKd8+q/dH8sbPkc9ttuyO94f7/XK/nHX46MPFLEb5qQlNPvhJ50/59t9ft3LXu7uVaWaO2bDrDCnRSzZyWvFKxO1+vT8MwwunR3bX0CkfPjqb4K9O19tn5X50PvmYpEwHtiW9WtzuV/s76B1zvLLNkViNd8ySxIl/3orfqP90TyTGaf7/rx8jQzeHJXdmh/N6YDvbvmTBwCdxfEQ1NcL6wNMdSIXNq7b1EUzRy1/Axsyk5p22GMG1b+GxFgbHErZh92wuvco0AuOLXct9hvw2nw/LqIcDRRmJmmZzcgUa7JpM/WV/S9IUfbF56TL2orzqwebdRD8nIYNJ41D/hz37Fo11p2Y21wzPcn713qVGhqtevStYfGH4n69OEJtPvbbLYWvscDqc3Hgnu166+tAyLnxrX0Y5zoYjV++1sI7t5kMr02KT/+uwtkc+rZLOf/qn/s3nYCf13Dg8/sB2diJgjGqjQ+TLhxbzyue2Ob7X6/9lUwW7a+lbznHzOYy8LKW1C/uRPbQY3KW/0gO9LXunHLvPL97afba9bFtc9hmz7GAttjVYlCvQAiOwAk/gC5+hkLEs6tr3AZKxLJtOEwk2dLxTYWsIB/j/ToWtIWzo906FrSG8iaqqqqqqiIiIiAgzMzMzNz+AyK+01/zi8n8S+Y1MjoRaQ80WU/G8MBlO+53VPXANrWm4wzGUVZUjjBJZVdhpcfkjsmcWaO+UEldXi1e+zq+HOsCpknYshuh8pOLISJun7TN0EIGW2xTnlOImeecnoGW4raxe2G1T3HEvfYUYMhG+gAFOAwh5nK8mZhwJMmN7r224QVsNFvZ87Z0qatvknklyPDK3Hy45PgVKXji52Wen4d4PlFVVYGnNap+fSpFbK90rYnhUc6n91Q3AY9E0tJOFrcfZtm/491XbcG/jsViUPPX76qmeuiz+qY1Hk7/1VPM405zWVuoheLUimpWYdVzCmUdKHebMdzgrYrb8mL2eeLSnRWHdonfZa8RsOU9F37w+591l5FLYHiOqWeHtE/lWrBHcRKp3uhtr8yXm8LU/5ms+NM6ZKsqu90cFZ4o58+k4rdrtB97NADFbwmEG7lXqvirhOTOqU14xuUF2myIjURcPHrPOQ4lmM3PeMg7bUuk0nnZi67bXsU6H8lhqIo8TaOrEafCO1ARK9PjC0QOoq2BxmMdgYB9G/lIb9++fqNJ2s7BHGFyBNmZAR8J3KCo012ikaSP8BCrf6VI0X5xdnbhHIO+B5rbOyB54zXkzfObyJ4ecwxfqBJMLFc7m59rNcw7hoHnFZ0b00zee+gTqvjm61Pb4xn0kcDX4jvHM0rBXZypG3DCKnD/Waa/ZtHmtFPgO5eETx+k7RrVg3aSwm2YoNXnCs3XPQDhNn+Fia6IlOOuIG6VJH7TP6ava26ehKHQa2T4N0tcZ9dPCGo3ZdnNltsHQbeYt5vPnJezV/cAeNypdml1vCHI8M81nSRP5Qi2+mI8v/sxiZru9187nRtp3f/42NemcONa+4eVC3PCZzc88aZh851CqSsshe70uPxeN/dmYwlwb3trwMrN1Gq8jbnApcVDx/yDPeYs5/7r62tsQ6lLg+DiFXTEhzR9dHqv0iT4tgj825W+H3XiRUNUZT2kR9Ri0+lp+UM3iQtS8uOE23Ly4KYtvqH13jghUntJRAewuzNLDXp8RxdcaA3cMY6TO2IeSFRXezeWIjCqyhsUdMYuCgYTZSKpBype1zRfq8FshvfBPc6BAQWl7/QxIDp3VGo1J3vn42OEs3qznws+YLRXbymyB19a9XBx6n/owcyxlEYyFWCi+kG9F+EyD/4yn80+agaZ9P7ay2Dny99aK2o91FkfEOY8hBwyfi5uwx2y5SaHmG+oq/zl1FX/8irOf8Y3vAcX/6uLP6A6nvMO24edSGPjQc827Rw2atX+z2bKq0CmW9mOtYnr5/AfDa1ZfPaXnKtlWborup7QYx+Or2uWb+N3N//2+yDcXMqIJdf55xl7/vsj4WoPPlxLxtVrkJ4w/tTe3mLdATOOYwxcq52w5Wxz5MbPdVs5O8/lhfE7dPj0bIiPQ3QV0iqm4m3YX8hRfc6jQ3fWepevMqUDJd86Z4vwM40CWHnn+WphsGHfieF02D3tmZvpWD+kBpNCFcLnZhcmmrhpGzzbdA+sQ1ar18OJD87IOKOFoRNznaHPNHUfUNhvY1iU+uhvEvpKHaUn3qK3exVVyX4joipp3um7FmYJWmA+WbIDshRpbVRx5/nqstCgy87FGbfVB8yDGCqS+2qCsnRwnSAN6zgzxfdB2nBT/vZ4/6uxb6oH8b4VBRxiIB93wLa47hG3w2SL/2Z27yOXJFwZpSJaBYyvajA7vRRYNKqljXKpt/CFD/tSMr18DKKbwB0xggBePatl1nki0yvqW5zchlyZmJ0OTxJ3D+fsYJs/mxYN5+Le5oagtcl+YsVvy8kSjI2YGvGjvmpkRS9W2dtXqWnVuxUhURm1lKtou/hdEq19VBp9OjGvHEQSmrpuf2R24mXGheil8KeiANY8fW1VERUfBImb64j12caBZmRViZHbeVMjCrPDg9A90IXrtnsYCuZtRQ0PyrKDjBNOsPfKsg1pA02gHlVr0OXiFhtp6nJqXVzcbfM0KnzC3ggOENPE9VBdmHKN6LYaijb4wXxJn5A0FSDF5j+h1ooZx885Jt3ZKzO5n7Z5WfNEOtyyPqQEnn7WLv5Fis3PdgMshjF1FRydbNyeBbyKI1oN1TRVrVK7kgsb/zjX4NDPIRMctVeaxVB38Vh1x5KbeJbU138AM5KzmZu3uny0ErygxiJF7GVXUrPzFxrlx1uFdAaZFDN9cvIb74qD9tzBMo7L7WIEYK+sla1DVMHpF0F7b3+Y6S+zjvLeDMCpapmJo1weBWuxKF3rOocih1gun4BoJh1kWnV/Jmiq6uOhK3VfKxEHEkafjLgK3oujaPzY6SXg8phhL4TNR1xvJd1Wa0aYFfPUMLrNBDCh4AuGRTbtKMc6Z1Udj8evY/ZpCuMAUefdo69DZUngoqE1P9A3PJfOf7WixCEj+Y6t7fYeHbbxUAoFV3M89cCKfma3fc1+jKRe7MFWEbQqEfyzO2x/wrO2VYH7iYdQ9BkPyI8/3kXBpLaCpU7eC0Yv/am/tEDu7HZpqg0EvHo0nf/R/gRzUWy33/HXMJQeu1GylKmOkXzlCfGFruAcPPhaGqZOtu19zsJ1SO2Jz4Ztth5cBX6mRQwWmDwryG9FUMlZzNckMdK+IoMJv1rOWnBamS2w2KHiaPMPLC15hCZm4KTpoZyj4E2TqC/P6r7/EhnDMhKicZZ1ZwxuC7DPzDGs53q8gXaI9kFTK+2LTq7bhwsTbrMV8Rsfua5lMS0FwbTitUVnVa1yTb5IX51mmYnUcP9wPr8Ji1tiYJeJV9GZTrQhF7vvdU2OTU42ogJ9FDwhmycI2LIg++03C6scYhUyUuMV5tkw6kGUoL+mjNC38+wMdWNljn6tGPpRES7veqrSn5TRuv+dh6JVL/iDHU1db4c9WK3++OrH3PqziF916UMUKn8G67nN60GfWiHrXYhUG3yVWmyYak59NHj8t1smG4UDiWz2rPHNrKnN4Zo1LBbr2/eF9YZ0n0blx2nG4X+EKFxvS3W28JESD+FWk61VCD3z/URGHiJl++7TdBwkCj6tGOH3qDb0QqcOF9Kzpj0HUb/KyFW3Yhj2VMKJqGZleFBH7vqvf7WqLC3XMuHV8q8a4sTFuxUtkD/6JIBvKaVjv96ndgruKZ1k/BHzqf2K9fLk7HGXANyLDd1vxkK/i055pnzl+zw6zLnwXlVYVtfmacJgEpRP1hbGgrYPVN6v2lG+idQNGmwcKXu/8xEj/P6qe/sB2WmwNp6pp8jaISMkwdleFXYK55NHWLTTbutSUqjBfDGWo/Yg918qQ+8BRZSAHZbfuNZz2O0sov1Ue4CWlVg3rFhM3Kljj9ksGd/NUhk4nH+a5UN2+1i8+NM3vRNp7uQ6sqexSCukEVlVZriHNqFi5rLm9TMWa4qm3idJqppQACol2l4VSuvWLfta4JcXy3bROPNbXOgdOhG47LC0CwW/dMlSx4Jf17aEU3yA1x9p+Yc0jupXgcMuYNku64iYOkGToVDuJvlbEKlJqsmiHbvNrIVZEH+yFdF8DbleZ6iNiWwMqvtMp/mSpwx5KxRrT9p3MAPTHGtMbfvdFhyj9vhaKcn3At8Lc16Ai+vBcSp1ztXi7rCJZx/ql7TXcclq6Q76UeKWDy9boS0WHIjUuWhPG8LBmW5y2rhuTpM5vsLt+HOLh1Yf0DqXa9tsfC+kaKt2htA0ai/L2i7RKoNjEwztkmRU0GfgW1TxUvPFhg0V7DdfWJk5gfrccpYv+MA9M0dkGTLECeYwUixRzjRFdmjG7zdZIl3XKB9YliNKI31lfa7i2JG5C8Ss+rHe0D7Z696/V3DEAOWHnQ9yNahMUl5kENWS6pHKKp2D1BaSrrHdE1w2qNxIztpXgUIrF0bm15YML4b6V1k+GpNysTahKMVrrS85lTVo9OGJ96I47eAy5rYWpRf/mIzeoYU1DKaQCTUVwrhHeyNoDqHel+lLxr9WKzhSYw7vrR6+V5q0pfi2k3L1zqkubY6rrd9ZLvSuWNf0uqnkY+FpTvFzSW9Fp0b9l8JA7THV9eCi/PY/SCZIUYx3BU2alj7Cm3VV6eYpios4b6WuNOJdYXUK3zTqj5CVG2FqYM4Z7CuIU0qO05XR0d71FHM0YhZmJmTRfLlXEumN82BGtzdX0S19t1e+bUieK8zRmqpa4Qc5TSjifmaQsY2ETLjhI36gMR1+7qpjdXXHiceUekfBaucHShAOiFXmv3sNmGQyU5iVgnoocuonQXEPTFwslHtS8R+A47StI9wj0iSrtbi5rMysczFiImsQ+bdFClnFjjpXXwMy6O7qfjOr8Fb0a7ODItisjnn3EQO16+ypd1cwyaAW5Yzxz5QknfMO7643fXW/I9y3U2xH27Oapqr56Z/tEzglj6IbT6HEHjopiXqeRbe5mQQvxtcbDOVverN0ZgMdzqRYRjaXtMRd56Q4cZSmdPvZJdSrhJ1D9zNXPqAEqPIavPdfubt5oke2kmv0dztIszSv2VYuoyf1UuopbsYb+uX9h6WpwjpgtZ6fNNawNJ4q8O3CFoSbioAaOSZMx2GYaPYB+rEb6qjQiNRFQ76TvwNFVKD+BhH9VhcKGsXzmMI7BptU/CNWolM7YzROvpFAntsiWJp6eR2d3GarcYShVYSUqhmYOWj5E96NK2WvmYNTeY7Zs4RUEdv9h9QT4EseKt6LzLrqEOs3hxAY1MaNWpSa6zZx8F3YOVeCYMS88W+CYHDuWe4yoc6YK+djDuEOrBR5lvh0r+Q9uM88lrjx9x9AtgpQVNE8r+3O6Gvw59D+kBF/UMXyhliYUtPjmvXGY6Dk3x+kEOW+GtdMVC4EZTqoS/jmR0P0LS75DOc/w2vnri97M4SdbZ8qeU7gg8DVbERkU5geaMQO3mYrSYyAngeUQqrN0C0/vsFmcgWNXNeidsTAj7/4MncJR0caaBUpbLK1yBCBNRjEv6KvuVSdpPnEMJdsRRtqJ+U8tN1gXA4ePHc6ZT0eviI73UOJF0fEZ8YaneAQqQdGphNvwM4nIqPnXxV0xA0fnCT+oAhJuyw/q8jO0y8CjSteZExwBpIN6SvNp6A5G/abi6egeND/1GTguhuNjaUbbnSbGd4L8937Ezm34Eyi6n1maeOBxh3PI0jzJDf5mh/BsLD7F2GOKvlA/5gtvxI3/eV4sLfKW5Wy+oio+es/u6T8UU+nsofy57Icb/JlZHPFtCgd/x+bwt3ZT+xXTtTtTrGAb4QehC6X9G+8YT+ozcLxDsdCjsuOqwPFnrdLYaFc92Ui0m4fr39lYmlCaqTit7G6O/3kWDkgtXjNH4BiEm/+jegQnihOtfffn33WxsFjhfMd48HT+f6o6X65j7XR8WLSHMFkxbvOYsrRsF1bowDuSQ18Mkxk4qz2zoGPL5fu9h2Hqmt1asl3Q3Yu3szOc+spiCmX4AETBM3pLoTYSp3sVxahyhL8eC4mPN9k2x3o0xkiixIzM3CZFzf5oR4mecQ5+ax2wCah3/crmnHoqR0+KMaOPxRif1oEFRFOO/kTPPmtww+NfMXxEK6gn6iU32U6fFruIz8Q4WgljtnaCVTBgWx7diUdshC9ZEa5yKpRBBeW12r/iNc/+EgNqmhswNB8SBoihHXeDF7rrWDLcmt3V8GYYN7pXRy4DZjj4DJuUBL5iC3DQAaoo4vkftqVTYRGLS3mHZ7gdmdTTqbgNN/PTdTCOTgXolc88MhXAEUMdX0iy1JMuk5wLsgeu0QUYlz2S4skTWwJz6pOm/8ihrmgGfFgri+ZWUK2gAPHgbWa8jaocdSuM4FJYoKicYX/ZSENkg9Q1ZzJfwScfVnR2DegOGwCvmogaWJCLQepv9WNlU6QgsmOwICquU28Mlk3d9W5E81lU/5Ez0LcX6lwKMWDNluNKfBDUy/phJgBcMnfkh9iRxrdOzgs08JdPB85Lwo+GUSb4t3nC+0byqMZtO2fQJ4U2zGIr49t/28qmmGv2RanDD7a3FEcdtutkW8twwwlUSpb8QalodddbBfNHKDQ828BdE7OBgFdiKYohLawFYqpybQoxATZrheLhdI7+0Zlu9Q1myRcd15r9UIm8K2LGJxqTegntqNVMKnf1a8zQiyUR1rxoqjiFxeHxqFcYUTHfDu7rhbWng6qOxOsI+5A1p9mRyEPdVkTlE24vY54W7bWc6jMgZvNXdfC9/9q7408KDsbdL7Utz7QFSDetz2picArzrdpL8OaCHC9V26RroemtDZ5yNM/KGkWMyTmfnInEvwtSD23UcFcjhaE3VKzkoaEMKGBft4XbIO6forTY1lmGQwVmKicBCiArDzE+1oIxE08fWeviIOD5TznqH+OoHadvoOP20drMPe5Irg3XBQziW2XDuHYzjqQQ4wySssjXUs5H+t3FWYMHppUnBHMx/nYIT5d7OmjDbgD9F6na3m4l7KdkeSO3kTEPXafiWinogag7b52taiZhL1TSvBFmEZafFq2H8khQaZXuitCewT5FBgVtPK0j4xUHPfUz3Q28eac1Z139DAP23dgki94EC8vbDPTQC97HPPSWjUNG5tWKMsaxAEMKC0665Xvo1Ntd07wCLNf8Q56mrEPVpCxlIMVlQlWRxM3oAfpgIc+8KC3rEXUog5g06vt7zgXY8grH7hhwVSaeuvC06YYRAwpbyk/Unzj9hLEZNs2oxPQB9yc+GnL6zTgq7rI++KDJwX2SP8Sd6YzTuw5lV/kU6eQxRD12omfQAW6caTR4LikYkBB1CMOrvgRr/VY75+NSB40Cni6bADAtaK+vyxVWpf9NeKJxN2KYQ8Q2xPB3K1s7fuhvWbr2XpgW044VD6DRs0qXoqKf1NFsaGvKJc47leUV3pppP/5VTKFhaGuol4Esfjf5zyCyUHmHthChcYh4hYLQF+AFWsuq4t0wJyWgdwQVOZiV0efRHPoK5+E1vjz9wTJmVkITC9oEstAsyZSgE/dbicwKr89YUxKZI+owD205Tm5lnnmDRuP/JnzxX3gMtlrcX0UesZdxyQqYQuEW4R51vmQ5xOZteUd8SJruMlTUzhtVw/Nq7eUBcqN2/HVotgfngif60yKEtoUx3WYOZlVJuJOh8u59fzSDPFYtQgqDUAGyGhQOAvKroXMcOYY0qjnStJR/G3aP+Jt1sLVlGV8POwr/6OGsqetnyF3TmTqZjENfnXh51oxe9qVUw2M78EzAJ+IM8lZ1MBPQ9ZWSVc4J3mWSrLKrMHReA5qdGoz0ODRsaA+vwxXA2cAM4qlfzBJA6581m4hzxItQw5dxrrBL3Y6kCbUcFxo1S8jyV44q//+7ASNNudZ6xeaNOSIUffqMn4A9lIjFctYn2gpEPAb3f7p3iIBN8H14FUGQ9ct2hPsL+cEsTgUrR47uJVN4n4wt/wgfwwHuOnLd4yobkofy8JvxSQTA7rMpDIc608SlZFJfZYcmbT0tAHpPE8MrtQ42siTUNWxqvWZOmvu9f0JPoQmg+6l7sZWwyfi6PXkxJnwBraUG0MYG4zYHQz3igy/XsFkx5tNQxw43qvI9dU3f0DdhOUlHKjmi1VAr2Kiy0HZwD8VeEbhh0OiDdMYspolQsYdSwjCcjeowIXNZVUPmL2wwIkYhmXKhGozdCJ4lRKbsf4NBh/XnQoS92NJEWOVOFs2YhN8c5QZFeK0pRdAG40hqvLbmoSA8xQmzOOEc7wLcme9JOsjPCEgpCwUs9E2DohMHRhUeyGIN6TFvrbny8nDuilsDpzrH5mS76APoIEJmItS67sQJ+nfwddzmjPxcBEBBCw0kWDwd0EZCkNeOD7NNQhtBm7KHL9mRxj6U1yWU2puzlIDtpYxdH4ZPeXBJkTGAJfUr/oTCz/iypY6uXaR2V1doPxJYlrw2ghH0D5gbrhFcIxzYwi4a/4hqVdf2DdxBp6vGYDjavxMAAoy+1+3aiO6S3W/QAKNVXagDtvsNtx7Ks+HKgo6U21B+QSZgIogV5Bt+BnXisdVfy9VyXV+2P5fMuvdpAjM1o/K9Z+XnE4EOCrue+kcdYHqAQ0/Y/OmNlQ6OI33jH/uD1RalPaHpJAm2av0/xtpqdXVKNDrc9F2izo23Wu7firgbURFDNX9eGGeYBhiypyXZft2j3hTvzE6PMWKsod//rEILDkzBXfi7xh0eFkfb3/1zzPK/PI5Nk3FbZyTl4mq5BfBoVoqiPHO4Q4QKZAlrQ3MdNfi3oxIjvsM3kAFv3fdufurqYR3PSwX/mpGy/GFI/B2MNPiNdOppWVbs/gjF3YH+QA9jMhlAbhvasAHstB0IJew09iAkmXHl1/TEj+jvHOpOGrPRQXbPADM+Ig2/OEcUcpgPTItMtW4DdqgfYVI/+4hAFWYjUGpOP/UwNuB7+BbKOcALbjobdgzeBQfjgNSp2GOpxzGLj70Vvq5cw2AoYENwKLUtJUX8sGRox4dVa/TN4xKwaKcl9XawQR/uNus700Hf17pyNnezrUgaY9e4MADhEDBpsJT6y1gDJs1q6wlwGhuUzGR7C8kgpjPyHWwsvrf3yn1zJEIRa5eSxoLAZOCR9xbuztxFRJW9ZmMYfCFJ0evm9F2fVnuje92Rc4Pl6A8bluN8MZyyJGZ0+sNSb//DvAFxC2BqlEsFwccWeAl6CyBcQV1bx4mQMBP1Jxqk1EUADNLeieS2dUFbQ/c/kvwItbZ7tx0st16viqd53WsRmPTKv2AD8CUnhtPWg5aUegNpsYgasaw2+EVooeNKmrW3MFtj76bYHJm5K9gpAXZXsE5U8DM8XmVOSJ1F1WnLy6nQup+jx52bAb+rCq6y9WXl2B2oZDhfDkW7H3oYfT/4xx5VncBuxMXP2lNfhUVQjSSzSRbuZFE4vFawlzveXxaYKVs8LpvAb8IRYF3ZHiRnm0ADeNPWocwxSzNseG7NrSEVZoHdKWqaGEBz1N8Pt7kFbqh3LYmAbm9i1IChIpLpM5AS6mr6OAPHMwwznVy61YpBYX8xZDN/a+lt7n+x5j4bNOVteZ8lj3hpAHSx1VR8vZHec4AHO9XFCdjZ9eRkSV65ljMmZVzaej2qFn/qt1lvWzNZEfHxK3qOJrHL6crr0CRzMox5f2e8ALBB4UGFZKA3tN6F6IXd32GTJXGQ7DTi9j/dNcLF9jCbDcWGKxoKTYblIwbLDReL00LRcDPMcQuXLMh5YzgtfjkFK1DP1iDzzYYVZz5M/kWYRlRpig1htVRjVCknm+h1M5LiEDXOyHREhvzCGpFZjHS0RsK27o2avgdilrJkalWqPW3D9gmwV37HKmfM3F8YZj2ar+vHFvf3B8CRoH4kDHIK9mrAg+owiEwNjjd9V+FsQKYR8czJrUkf7Qoi2YaW6EVDZp5zYlqiYtuXOTHk4fAcZ7qBbdLDiJq0WNV1l2+Hntk1mMWvxrYmc8kIx8G3rW36J6Ra4lLrTOCgiOihmow+YnzUT19jbV2B3RWqSHyxkhmgsBqMYWvOcUom1jDQ436+fcbu3xf2bbeqU/ca+C4DOKE+e3qvmeMqW3AxejfzBRFVcwVYPq4L0APSWWoJu+5UYX4qg5U6YTioqQGPG9XrnuZ/BkxuYpe6Li87+18EskyQW/uA+uk2rpHpr6hut2TlVbKgWkFpx+AZffweiw2+VittkEyf/ifinS/0ItRL2Jq3tQOcxPaWO2xrG68GdFoUpZgFXaP2wYVtRc6xYCfI1CaBqyWpg4bx8OHBQwsV4XWMibZZ0LYjWEy2IxQ1mZrf1/UNbYCJplWu3nZ4WpodIGVA05d+RWSS+ET9tH3RfGGmNI1cIY7evZZq7o+a0bjjygpmR3mVfalkT/SZGT27Q8QGalwGlDOS9VHCyFAIL0a1Q7JiW3saz9gqY8lqKynFrPCzxkU4SIfLc9VfCI5edgRhDXs0edO992nhTKHriREP1NJC6SROMgQ0xO5kNNZOhMOIT99AUElbxqeZF8A3xrfDJsWtDnUenAHdYWSwAbYjFqQZ+D5gi3hNK8CSxU9i6f6ClL9IGlj1OPMQAsr84YG6ijsJpCaGWj75c3yOZKBB9mNpQNPUKkK0D6wgLH8MGoyRxTX6Y05Q4AnYNXMZwXM4eij/9WpsM/9CoRnFQXGR6MEaY+FXvXEO3RO0JaStk6OXuHVATHJE+1W+TU3bSZ2ksMtqjO0zfSJCdBv7y2d8DMx6TfVme3q0ZpTKMMu4YL/t7ciTNtdDkwPogh3Cnjx7qk08SHwf+dksZ7M2vCOlfsF0hQ6J4ehPCaHTNrM/zBSOqD83dBEBCW/F/LEmeh0nOHd7oVl3/Qo/9GUDkkbj7yz+9cvvu+dDAtx8NzCDTP4iKdZvk9MWiizvtILLepysflSvTLFBZ37RLwiriqyRxYv/zrgFd/9XVHh/OmzBvDX4mitMR/lUavs2Vx6cR94lzAkplm3IRNy4TFfu47tuYs9EQPIPVta4P64tV+sZ7n3ued3cgEx2YK+QL5+xms6osk8qQbTyuKVGdaX9FQqk6qfDnT5ykxk0VK7KZ62b6DNDUfQlqGHxSMKv1P0XN5BqMeKG1P4Wp5QfZDUCEldppoX0U6ss2jIko2XpURKCIhfaOqLPfShdtS37ZrT+jFRSH2xYVV1rmT/MBtRQhxiO4MQ3iAGlaZi+9PWBEIXOVnu9jN1f921lWLZky9bqbM3J2MAAI9jmuAx3gyoEUa6P2ivs0EeNv/OR+AX6q5SW6l5HaoFuS6jr6yg9limu+P0KYKzfMXWcQSfTXzpOzKEKpwI3YGXZpSSy2LTlMgfmFA3CF6R5c9xWEtRuCg2ZPUQ2Nb6dRFTNd4TfGHrnEWSKHPuRyiJSDAZ+KX0VxmSHjGPbQTLVpqixia2uyhQ394gBMt7C3ZAmxn/DJS+l1fBsAo2Eir/C0jG9csd4+/tp12pPc/BVJGaK9mfvr7M/CeztrmCO5qY06Edi4xAGtiEhnWAbzLy2VEyazE1J5nPmgU4RpW4Sa0TnOT6w5lgt3/tMpROigHHmexBGAMY0mdcDbDxWIz41NgdD6oxgHsJRgr5RnT6wZAkTOcStU4NMOQNemSO7gxGahdEsC+NRVGxMUhQmmM0llWRbbmFGHzEqLM4Iw0H7577Kyo+Zf+2cUFIOw93gEY171vQaM0HLwpjpdRR6Jz7V0ckE7XzYJ0TmY9znLdzkva0vNrAGGT5SUZ5uaHDkcGvI0ySpwkasEgZPMseYcu85w8HPdSNi+4T6A83iAwDbxgeFcB1ZM2iGXzFcEOUlYVrEckaOyodfvaYSQ7GuB4ISE0nYJc15X/1ciDTPbPCgYJK55VkEor4LvzL9S2WDy4xj+6FOqVyTAC2ZNowheeeSI5hA/02l8UYkv4nk9iaVn+kCVEUstgk5Hyq+gJm6R9vG3rhuM904he/hFmNQaUIATB1y3vw+OmxP4X5Yi6A5I5jJufHCjF9+AGNwnEllZjUco6XhsO5T5+R3yxz5yLVOnAn0zuS+6zdj0nTJbEZCbXJdtpfYZfCeCOqJHoE2vPPFS6eRLjIJlG69X93nfR0mxSFXzp1Zc0lt/VafDaImhUMtbnqWVb9M4nGNQLN68BHP7AR8Il9dkcxzmBv8PCZlw9guY0lurbBsmNYlwJZsA/B15/HfkbjbwPddaVecls/elmDHNW2r4crAx43feNkfRwsaNq/yyJ0d/p5hZ6AZajz7DBfUok0ZU62gCzz7x8eVfJTKA8IWn45vINLSM1q+HF9CV9qF3zP6Ml21kPPL3CXzkuYUlnSqT+Ij4tI/od5KwIs+tDajDs64owN7tOAd6eucGz+KfO26iNcBFpbWA5732bBNWO4kHNpr9D955L61bvHCF/mwSrz6eQaDjfDEANqGMkFc+NGxpKZzCD2sj/JrHd+zlPQ8Iz7Q+2JVIiVCuCKoK/hlAEHzvk/Piq3mRL1rT/fEh9hoT5GJmeYswg1otiKydizJ/fS2SeKHVu6Z3JEHjiW8NaTQgP5xdBli8nC57XiN9hrquBu99hn9zqwo92+PM2JXtpeVZS0PdqR5mDyDreMMtEws+CpwaRyyzoYtfcvt9PJIW0fJVNNi/FFyRsea7peLvJrL+5b4GOXJ8tAr+ATk9f8KmiIsRhqRy0vFzwRV3Z5dZ3QqIU8JQ/uQpkJbjMUMFj2F9sCFeaBjI4+fL/oN3+LQgjI4zuAfQ+3IPIPFQBccf0clJpsfpnBxD84atwtupkGqKvrH7cGNl/QcWcSi6wcVDML6ljOgYbo+2BOAWNNjlUBPiyitUAwbnhFvLbnqw42kR3Yp2kv2dMeDdcGOX5kT4S6M44KHEB/SpCfl7xgsUvs+JNY9G3O2X/6FEt9FyAn57lrbiu+tl83sCymSvq9eZbe9mchL7MTf/Ta78e80zSf0hYY5eUU7+ff14jv7Xy8qjzfzzzvaJnrIdvFb5BLWKcWGy5/w7+vV2cvIfwHqdTB+RuJK5oj9mbt0Hy94AmjMjjwYNZlNS6uiyxNnwNyt3gdreLb64p/3+08nXkb92LTkkRgFOwk1oGEVllcOj5lv1hfAZywDows0944U8vUFw+A/nuVq/UCygsrmWIBnHyU01d0XJPwriEOvx/ISK6Pk4y2w0gmojZs7lU8TtakBAdne4v/aNxmMpK4VcGMp7si0yqsiolXRuOi1Z1P7SqD3Zmp0CWcyK4Ubmp2SXiXuI5nGLCieFHKHNRIlcY3Pys2dwMTYCaqlyWSITwr2oGXvyU3h1Pf8eQ3w1bnD7ilocVjYDkcXR3Oo1BXgMLTUjNw2xMVwjtp99NhSVc5aIWrDQT5DHPKtCtheBP4zHcw4dz2eRdTMamhlHhtfgqJJHI7NGDUw1XL8vsSeSHyKqDtqoAmrQqsYwvwi7HW3ojWyhIa5oz5xJTaq14NAzFLjVLR12rRNUQ6xohDnrWFb5bG9yf8aCD8d5phoackcNJp+Dw3Due3RM+5Rid7EuIgsnwgpX0rUWh/nqPtByMhMZZ69NpgvRTKZ62ViZ+Q7Dp5r4K0d7EfJuiy06KuIYauRh5Ecrhdt2QpTS1k1AscEHvapNbU3HL1F2TFyR33Wxb5MvH5iZsrn3SDcsxlnnshO8PLwmdGN+paWnQuORtZGX37uhFT64SeuPsx8UOokY6ON85WdQ1dki5zErsJGazcBOddWJEKqNPiJpsMD1GrVLrVY+AOdPWQneTyyP1hRX/lMM4ZogGGOhYuAdr7F/DOiAoc++cn5vlf0zkMUJ40Z1rlgv9BelPqVOpxKeOpzKdF8maK+1Vv23MO9k/8+qpLoxrIGH2EDQlnGmH8CD31G8QqlyQIcpmR5bwmSVw9/Ns6IHgulCRehvZ/+VrM60Cu/r3AontFfrljew74skYe2uyn7JKQtFQBQRJ9ryGic/zQOsbS4scUBctA8cPToQ3x6ZBQu6DPu5m1bnCtP8TllLYA0UTQNVqza5nfew3Mopy1GPUwG5jsl0OVXniPmAcmLqO5HG8Hv3nSLecE9oOjPDXcsTxoCBxYyzBdj4wmnyEV4kvFDunipS8SSkvdaMnTBN9brHUR8xdmmEAp/Pdqk9uextp1t+JrtXwpN/MG2w/qhRMpSNxQ1uhg/kKO30eQ/FyHUDkWHT8V6gGRU4DhDMxZu7xXij9Ui6jlpWmQCqJg3FkOTq3WKneCRYZxBXMNAVLQgHXSCGSqNdjebY94oyIpVjMYehAiFx/tqzBXFHZaL5PeeD74rW5OysFoUXY8sebUZleFTUa/+zBKVTFDopTReXNuZq47QjkWnxjirCommO4L/GrFtVV21EpMyw8wyThL5Y59d88xtlx1g1ttSICDwnof6lt/6zliPzgVUL8jWBjC0o2D6Kg+jNuThkAlaDJsq/AG2aKA//A76avw2KNqtv223P+Wq3StRDDNKFFgtsFukYt1GFDWooFVXitaNhb3RCyJi4cMeNjROiPEDb4k+G3+hD8tsg+5hhmSc/8t2JTSwYoCzAI75doq8QTHe+E/Tw0RQSUDlU+6uBeNN3h6jJGX/mH8oj0i3caCNsjvTnoh73BtyZpsflHLq6AfwJNCDX4S98h4+pCOhGKDhV3rtkKHMa3EG4J9y8zFWI4UsfNzC/Rl5midNn7gwoN9j23HGCQQ+OAZpTTPMdiVow740gIyuEtd0qVxMyNXhHcnuXRKdw5wDUSL358ktjMXmAkvIB73BLa1vfF9BAUZInPYJiwxqFWQQBVk7gQH4ojfUQ/KEjn+A/WR6EEe4CtbpoLe1mzHkajgTIoE0SLDHVauKhrq12zrAXBGbPPWKCt4DGedq3JyGRbmPFW32bE7T20+73BatV/qQhhBWfWBFHfhYWXjALts38FemnoT+9bn1jDBMcUMmYgSc0e7GQjv2MUBwLU8ionCpgV+Qrhg7iUIfUY6JFxR0Y+ZTCPM+rVuq0GNLyJXX6nrUTt8HzFBRY1E/FIm2EeVA9NcXrj7S6YYIChVQCWr/m2fYUjC4j0XLkzZ8GCSLfmkW3PB/xq+nlXsKVBOj7vTvqKCOMq7Ztqr3cQ+N8gBnPaAps+oGwWOkbuxnRYj/x/WjiDclVrs22xMK4qArE1Ztk1456kiJriw6abkNeRHogaPRBgbgF9Z8i/tbzWELN4CvbqtrqV9TtGSnmPS2F9kqOIBaazHYaJ9bi3AoDBvlZasMluxt0BDXfhp02Jn411aVt6S4TUB8ZgFDkI6TP6gwPY85w+oUQSsjIeXVminrwIdK2ZAawb8Se6XOJbOaliQxHSrnAeONDLuCnFejIbp4YDtBcQCwMsYiRZfHefuEJqJcwKTTJ8sx5hjHmJI1sPFHOr6W9AhZ2NAod38mnLQk1gOz2LCAohoQbgMbUK9RMEA3LkiF7Sr9tLZp6lkciIGhE2V546w3Mam53VtVkGbB9w0Yk2XiRnCmbpxmHr2k4eSC0RuNbjNsUfDIfc8DZvRvgUDe1IlKdZTzcT4ZGEb53dp8VtsoZlyXzLHOdAbsp1LPTVaHvLA0GYDFMbAW/WUBfUAdHwqLFAV+3uHvYWrCfhUOR2i89qvCBoOb48usAGdcF2M4aKn79k/43WzBZ+xR1L0uZfia70XP9soQReeuhZiUnXFDG1T8/OXNmssTSnYO+3kVLAgeiY719uDwL9FQycgLPessNihMZbAKG7qwPZyG11G1+ZA3jAX2yddpYfmaKBlmfcK/V0mwIRUDC0nJSOPUl2KB8h13F4dlVZiRhdGY5farwN+f9hEb1cRi41ZcGDn6Xe9MMSTOY81ULJyXIHSWFIQHstVYLiJEiUjktlHiGjntN5/btB8Fu+vp28zl2fZXN+dJDyN6EXhS+0yzqpl/LSJNEUVxmu7BsNdjAY0jVsAhkNuuY0E1G48ej25mSt+00yPbQ4SRCVkIwb6ISvYtmJRPz9Zt5dk76blf+lJwAPH5KDF+vHAmACLoCdG2Adii6dOHnNJnTmZtoOGO8Q1jy1veMw6gbLFToQmfJa7nT7Al89mRbRkZZQxJTKgK5Kc9INzmTJFp0tpAPzNmyL/F08bX3nhCumM/cR/2RPn9emZ3VljokttZD1zVWXlUIqEU7SLk5I0lFRU0AcENXBYazNaVzsVHA/sD3o9hm42wbHIRb/BBQTKzAi8s3+bMtpOOZgLdQzCYPfX3UUxKd1WYVkGH7lh/RBBgMZZwXzU9+GYxdBqlGs0LP+DZ5g2BWNh6FAcR944B+K/JTWI3t9YyVyRhlP4CCoUk/mmF7+r2pilVBjxXBHFaBfBtr9hbVn2zDuI0kEOG3kBx8CGdPOjX1ph1POOZJUO1JEGG0jzUy2tK4X0CgVNYhmkqqQysRNtKuPdCJqK3WW57kaV17vXgiyPrl4KEEWgiGF1euI4QkSFHFf0TDroQiLNKJiLbdhH0YBhriRNCHPxSqJmNNoketaioohqMglh6wLtEGWSM1EZbQg72h0UJAIPVFCAJOThpQGGdKfFovcwEeiBuZHN2Ob4uVM7+gwZLz1D9E7ta4RmMZ24OBBAg7Eh6dLXGofZ4U2TFOCQMKjwhVckjrydRS+YaqCw1kYt6UexuzbNEDyYLTZnrY1PzsHZJT4U+awO2xlqTSYu6n/U29O2wPXgGOEKDMSq+zTUtyc8+6iLp0ivav4FKx+xxVy4FxhIF/pucVDqpsVe2jFOfdZhTzLz2QjtzvsTCvDPU7bzDH2eXVKUV9TZ+qFtaSSxnYgYdXKwVreIgvWhT9eGDB2OvnWyPLfIIIfNnfIxU8nW7MbcH05nhlsYtaW9EZRsxWcKdEqInq1DiZPKCz7iGmAU9/ccnnQud2pNgIGFYOTAWjhIrd63aPDgfj8/sdlD4l+UTlcxTI9jbaMqqN0gQxSHs60IAcW3cH4p3V1aSciTKB29L1tz2eUQhRiTgTvmqc+sGtBNh4ky0mQJGsdycBREP+fAaSs1EREDVo5gvgi5+aCN7NECw30owbCc1mSpjiahyNVwJd1jiGgzSwfTpzf2c5XJvG/g1n0fH88KHNnf+u7ZiRMlXueSIsloJBUtW9ezvsx9grfsX/FNxnbxU1Lvg0hLxixypHKGFAaPu0xCD8oDTeFSyfRT6s8109GMUZL8m2xXp8X2dpPCWWdX84iga4BrTlOfqox4shqEgh/Ht4qRst52cA1xOIUuOxgfUivp6v5f8IVyaryEdpVk72ERAwdT4aoY1usBgmP+0m06Q216H/nubtNYxHaOIYjcach3A8Ez/zc0KcShhel0HCYjFsA0FjYqyJ5ZUH1aZw3+zWC0hLpM6GDfcAdn9fq2orPmZbW6XXrf+Krc9RtvII5jeD3dFoT1KwZJwxfUMvc5KLfn8rROW23Jw89sJ2a5dpB3qWDUBWF2iX8OCuKprHosJ2mflBR+Wqs86VvgI/XMnsqb97+VlKdPVysczPj8Jhzf+WCvGBHijAqYlavbF60soMWlHbvKT+ScvhprgeTln51xX0sF+Eadc/l2s2a5BgkVbHYyz0E85p0LstqH+gEGiR84nBRRFIn8hLSZrGwqjZ3E29cuGi+5Z5bp7EM8MWFa9ssS/vy4VrDfECSv7DSU84DaP0sXI3Ap4lWznQ65nQoTKRWU30gd7Nn8ZowUvGIx4aqyXGwmA/PB4qN8msJUODezUHEl0VP9uo+cZ8vPFodSIB4C7lQYjEFj8yu49C2KIV3qxMFYTevG8KqAr0TPlkbzHHnTpDpvpzziAiNFh8xiT7C/TiyH0EguUw4vxAgpnE27WIypV+uFN2zW7xniF/n75trs9IJ5amB1zXXZ1LFkJ6GbS/dFokzl4cc2mamVwhL4XU0Av5gDWAl+aEWhAP7t2VIwU+EpvfOPDcLASX7H7lZpXA2XQfbSlD4qU18NffNPoAKMNSccBfO9YVVgmlW4RydBqfHAV7+hrZ84WJGho6bNT0YMhxxLdOx/dwGj0oyak9aAkNJ8lRJzUuA8sR+fPyiyTgUHio5+Pp+YaKlHrhR41jY5NESPS3x+zTMe0S2HnLOKCOQPpdxKyviBvdHrCDRqO+l96HhhNBLXWv4yEMuEUYo8kXnYJM8oIgVM4XJ+xXOev4YbWeqsvgq0lmw4/PiYr9sYLt+W5EAuYSFnJEan8CwJwbtASBfLBBpJZiRPor/aCJBZsM+MhvS7ZepyHvU8m5WSmaZnxuLts8ojl6KkS8oSAHkq5GWlCB/NgJ5W3rO2Cj1MK7ahxsCrbTT3a0V/QQH+sErxV4XUWDHx0kkFy25bPmBMBQ6BU3HoHhhYcJB9JhP6NXUWKxnE0raXHB6U9KHpWdQCQI72qevp5fMzcm+AvC85rsynVQhruDA9fp9COe7N56cg1UKGSas89vrN+WlGLYTwi5W+0xYdKEGtGCeNJwXKDU0XqU5uQYnWsMwTENLGtbQMvoGjIFIEMzCRal4rnBAg7D/CSn8MsCvS+FDJJAzoiioJEhZJgAp9n2+1Yznr7H+6eT4YkJ9Mpj60ImcW4i4iHDLn9RydB8dx3QYm3rsX6n4VRrZDsYK6DCGwkwd5n3/INFEpk16fYpP6JtMQpqEMzcOfQGAHXBTEGzuLJ03GYQL9bmV2/7ExDlRf+Uvf1sM2frRtCWmal12pMgtonvSCtR4n1CLUZRdTHDHP1Otwqd+rcdlavnKjUB/OYXQHUJzpNyFoKpQK+2OgrEKpGyIgIBgn2y9QHnTJihZOpEvOKIoHAMGAXHmj21Lym39Mbiow4IF+77xNuewziNVBxr6KD5e+9HzZSBIlUa/AmsDFJFXeyrQakR3FwowTGcADJHcEfhGkXYNGSYo4dh4bxwLM+28xjiqkdn0/3R4UEkvcBrBfn/SzBc1XhKM2VPlJgKSorjDac96V2UnQYXl1/yZPT4DVelgO+soMjexXwYO58VLl5xInQUZI8jc3H2CPnCNb9X05nOxIy4MlecasTqGK6s2az4RjpF2cQP2G28R+7wDPsZDZC/kWtjdoHC7SpdPmqQrUAhMwKVuxCmYTiD9q/O7GHtZvPSN0CAUQN/rymXZNniYLlJDE70bsk6Xxsh4kDOdxe7A2wo7P9F5YvqqRDI6brf79yPCSp4I0jVoO4YnLYtX5nzspR5WB4AKOYtR1ujXbOQpPyYDvfRE3FN5zw0i7reehdi7yV0YDRKRllGCGRk5Yz+Uv1fYl2ZwrnGsqsjgAVo0xEUba8ohjaNMJNwTwZA/wBDWFSCpg1eUH8MYL2zdioxRTqgGQrDZxQyNzyBJPXZF0+oxITJAbj7oNC5JwgDMUJaM5GqlGCWc//KCIrI+aclEe4IA0uzv7cuj6GCdaJONpi13O544vbtIHBF+A+JeDFUQNy61Gki3rtyQ4aUywn6ru314/dkGiP8Iwjo0J/2Txs49ZkwEl4mx+iYUUO55I6pJzU4P+7RRs+DXZkyKUYZqVWrPF4I94m4Wx1tXeE74o9GuX977yvJ/jkdak8+AmoHVjI15V+WwBdARFV2IPirJgVMdsg1Pez2VNHqa7EHWdTkl3XTcyjG9BiueWFvQfXI8aWSkuuRmqi/HUuzqyvLJfNfs0txMqldYYflWB1BS31WkuPJGGwXUCpjiQSktkuBMWwHjSkQxeehqw1Kgz0Trzm7QbtgxiEPDVmWCNCAeCfROTphd1ZNOhzLy6XfJyG6Xgd5MCAZw4xie0Sj5AnY1/akDgNS9YFl3Y06vd6FAsg2gVQJtzG7LVq1OH2frbXNHWH/NY89NNZ4QUSJqL2yEcGADbT38X0bGdukqYlSoliKOcsSTuqhcaemUeYLLoI8+MZor2RxXTRThF1LrHfqf/5LcLAjdl4EERgUysYS2geE+yFdasU91UgUDsc2cSQ1ZoT9+uLOwdgAmifwQqF028INc2IQEDfTmUw3eZxvz7Ud1z3xc1PQfeCvfKsB9jOhRj7rFyb9XcDWLcYj0bByosychMezMLVkFiYcdBBQtvI6K0KRuOZQH2kBsYHJaXTkup8F0eIhO1/GcIwWKpr2mouB7g5TUDJNvORXPXa/mU8bh27TAZYBe2sKx4NSv5OjnHIWD2RuysCzBlUfeNXhDd2jxnHoUlheJ3jBApzURy0fwm2FwwsSU0caQGl0Kv8hopRQE211NnvtLRsmCNrhhpEDoNiZEzD2QdJWKbRRWnaFedXHAELSN0t0bfsCsMf0ktfBoXBoNA+nZN9+pSlmuzspFevmsqqcMllzzvkyXrzoA+Ryo1ePXpdGOoJvhyru+EBRsmOp7MXZ0vNUMUqHLUoKglg1p73sWeZmPc+KAw0pE2zIsFFE5H4192KwDvDxdxEYoDBDNZjbg2bmADTeUKK57IPD4fTYF4c6EnXx/teYMORBDtIhPJneiZny7Nv/zG+YmekIKCoxr6kauE2bZtBLufetNG0BtBY7f+/ImUypMBvdWu/Q7vTMRzw5aQGZWuc1V0HEsItFYMIBnoKGZ0xcarba/TYZq50kCaflFysYjA4EDKHqGdpYWdKYmm+a7TADmW35yfnOYpZYrkpVEtiqF0EujI00aeplNs2k+qyFZNeE3CDPL9P6b4PQ/kataHkVpLSEVGK7EX6rAa7IVNrvZtFvOA6okKvBgMtFDAGZOx88MeBcJ8AR3AgUUeIznAN6tjCUipGDZONm1FjWJp4A3QIzSaIOmZ7DvF/ysYYbM/fFDOV0jntAjRdapxJxL0eThpEhKOjCDDq2ks+3GrwxqIFKLe1WdOzII8XIOPGnwy6LKXVfpSDOTEfaRsGujhpS4hBIsMOqHbl16PJxc4EkaVu9wpEYlF/84NSv5Zum4drMfp9yXbzzAOJqqS4YkI4cBrFrC7bMPiCfgI3nNZAqkk3QOZqR+yyqx+nDQKBBBZ7QKrfGMCL+XpqFaBJU0wpkBdAhbR4hJsmT5aynlvkouoxm/NjD5oe6BzVIO9uktM+/5dEC5P7vZvarmuO/lKXz4sBabVPIATuKTrwbJP8XUkdM6uEctHKXICUJGjaZIWRbZp8czquQYfY6ynBUCfIU+gG6wqSIBmYIm9pZpXdaL121V7q0VjDjmQnXvMe7ysoEZnZL15B0SpxS1jjd83uNIOKZwu5MPzg2NhOx3xMOPYwEn2CUzbSrwAs5OAtrz3GAaUkJOU74XwjaYUmGJdZBS1NJVkGYrToINLKDjxcuIlyfVsKQSG/G4DyiO2SlQvJ0d0Ot1uOG5IFSAkq+PRVMgVMDvOIJMdqjeCFKUGRWBW9wigYvcbU7CQL/7meF2KZAaWl+4y9uhowAX7elogAvItAAxo2+SFxGRsHGEW9BnhlTuWigYxRcnVUBRQHV41LV+Fr5CJYV7sHfeywswx4XMtUx6EkBhR+q8AXXUA8uPJ73Pb49i9KG9fOljvXeyFj9ixgbo6CcbAJ7WHWqKHy/h+YjBwp6VcN7M89FGzQ04qbrQtgrOFybg3gQRTYG5xn73ArkfQWjCJROwy3J38Dx/D7jOa6BBNsitEw1wGq780EEioOeD+ZGp2J66ADiVGMayiHYucMk8nTK2zzT9CnEraAk95kQjy4k0GRElLL5YAKLQErJ5rp1eay9O4Fb6yJGm9U4FaMwPGxtKD6odIIHKoWnhKo1U8KIpFC+MVn59ZXmc7ZTBZfsg6FQ8W10YfTr4u0nYrpHZbZ1jXiLmooF0cOm0+mPnJBXQtepc7n0BqOipNCqI6yyloTeRShNKH04FIo0gcMk0H/xThyN4pPAWjDDkEp3lNNPRNVfpMI44CWRlRgViP64eK0JSRp0WUvCWYumlW/c58Vcz/yMwVcW5oYb9+26TEhwvbxiNg48hl1VI1UXTU//Eta+BMKnGUivctfL5wINDD0giQL1ipt6U7C9cd4+lgqY2lMUZ02Uv6Prs+ZEZer7ZfWBXVghlfOOrClwsoOFKzWEfz6RZu1eCs+K8fLvkts5+BX0gyrFYve0C3qHrn5U/Oh6D/CihmWIrY7HUZRhJaxde+tldu6adYJ+LeXupQw0XExC36RETdNFxcq9glMu4cNQSX9cqR/GQYp+IxUkIcNGWVU7ZtGa6P3XAyodRt0XeS3Tp01AnCh0ZbUh4VrSZeV9RWfSoWyxnY3hzcZ30G/InDq4wxRrEejreBxnhIQbkxenxkaxl+k7eLUQkUR6vKJ2iDFNGX3WmVA1yaOH+mvhBd+sE6vacQzFobwY5BqEAFmejwW5ne7HtVNolOUgJc8CsUxmc/LBi8N5mu9VsIA5HyErnS6zeCz7VLI9+n/hbT6hTokMXTVyXJRKSG2hd2labXTbtmK4fNH3IZBPreSA4FMeVouVN3zG5x9CiGpLw/3pceo4qGqp+rVp+z+7yQ98oEf+nyH4F3+J9IheDBa94Wi63zJbLBCIZm7P0asHGpIJt3PzE3m0S4YIWyXBCVXGikj8MudDPB/6Nm2v4IxJ5gU0ii0guy5SUHqGUYzTP0jIJU5E82RHUXtX4lDdrihBLdP1YaG1AGUC12rQKuIaGvCpMjZC9bWSCYnjDlvpWbkdXMTNeBHLKiuoozMGIvkczmP0aRJSJ8PYnLCVNhKHXBNckH79e8Z8Kc2wUej4sQZoH8qDRGkg86maW/ZQWGNnLcXmq3FlXM6ssR/3P6E/bHMvm6HLrv1yRixit25JsH3/IOr2UV4BWJhxXW5BJ6Xdr07n9kF3ZNAk6/Xpc5MSFmYJ2R7bdL8Kk7q1OU9Elg/tCxJ8giT27wSTySF0GOxg4PbYJdi/Nyia9Nn89CGDulfJemm1aiEr/eleGSN+5MRrVJ4K6lgyTTIW3i9cQ0dAi6FHt0YMbH3wDSAtGLSAccezzxHitt1QdhW36CQgPcA8vIIBh3/JNjf/Obmc2yzpk8edSlS4lVdwgW5vzbYEyFoF4GCBBby1keVNueHAH+evi+H7oOVfS3XuPQSNTXOONAbzJeSb5stwdQHl1ZjrGoE49I8+A9j3t+ahhQj74FCSWpZrj7wRSFJJnnwi1T9HL5qrCFW/JZq6P62XkMWTb+u4lGpKfmmwiJWx178GOG7KbrZGqyWwmuyKWPkNswkZ1q8uptUlviIi+AXh2bOOTOLsrtNkfqbQJeh24reebkINLkjut5r4d9GR/r8CBa9SU0UQhsnZp5cP+RqWCixRm7i4YRFbtZ4EAkhtNa6jHb6gPYQv7MKqkPLRmX3dFsK8XsRLVZ6IEVrCbmNDc8o5mqsogjAQfoC9Bc7R6gfw03m+lQpv6kTfhxscDIX6s0w+fBxtkhjXAXr10UouWCx3C/p/FYwJRS/AXRKkjOb5CLmK4XRe0+xeDDwVkJPZau52bzLEDHCqV0f44pPgKOkYKgTZJ33fmk3Tu8SdxJ02SHM8Fem5SMsWqRyi2F1ynfRJszcFKykdWlNqgDA/L9lKYBmc7Zu/q9ii1FPF47VJkqhirUob53zoiJtVVRVwMR34gV9iqcBaHbRu9kkvqk3yMpfRFG49pKKjIiq7h/VpRwPGTHoY4cg05X5028iHsLvUW/uz+kjPyIEhhcKUwCkJAwbR9pIEGOn8z6svAO8i89sJ3dL5qDWFYbS+HGPRMxYwJItFQN86YESeJQhn2urGiLRffQeLptDl8dAgb+Tp47UQPxWOw17OeChLN1WnzlkPL1T5O+O3Menpn4C3IY5LEepHpnPeZHbvuWfeVtPlkH4LZjPbBrkJT3NoRJzBt86CO0Xq59oQ+8dsm0ymRcmQyn8w71mhmcuEI5byuF+C88VPYly2sEzjlzAQ3vdn/1+Hzguw6qFNNbqenhZGbdiG6RwZaTG7jTA2X9RdXjDN9yj1uQpyO4Lx8KRAcZcbZMafp4wPOd5MdXoFY52V1A8M9hi3sso93+uprE0qYNMjkE22CvK4HuUxqN7oIz5pWuETq1lQAjqlSlqdD2Rnr/ggp/TVkQYjn9lMfYelk2sH5HPdopYo7MHwlV1or9Bxf+QCyLzm92vzG2wjiIjC/ZHEJzeroJl6bdFPTpZho5MV2U86fLQqxNlGIMqCGy+9WYhJ8ob1r0+Whxde9L2PdysETv97O+xVw+VNN1TZSQN5I6l9m5Ip6pLIqLm4a1B1ffH6gHyqT9p82NOjntRWGIofO3bJz5GhkvSWbsXueTAMaJDou99kGLqDlhwBZNEQ4mKPuDvVwSK4WmLluHyhA97pZiVe8g+JxmnJF8IkV/tCs4Jq/HgOoAEGR9tCDsDbDmi3OviUQpG5D8XmKcSAUaFLRXb2lmJTNYdhtYyfjBYZQmN5qT5CNuaD3BVnlkCk7bsMW3AtXkNMMTuW4HjUERSJnVQ0vsBGa1wo3Qh7115XGeTF3NTz8w0440AgU7c3bSXO/KMINaIWXd0oLpoq/0/QJxCQSJ9XnYy1W7TYLBJpHsVWD1ahsA7FjNvRd6mxCiHsm8g6Z0pnzqIpF1dHUtP2ITU5Z1hZHbu+L3BEEStBbL9XYvGfEakv1bmf+bOZGnoiuHEdlBnaChxYKNzB23b8sw8YyT7Ajxfk49eJIAvdbVkdFCe2J0gMefhQ0bIZxhx3fzMIysQNiN8PgOUKxOMur10LduigREDRMZyP4oGWrP1GFY4t6groASsZ421os48wAdnrbovNhLt7ScNULkwZ5AIZJTrbaKYTLjA1oJ3sIuN/aYocm/9uoQHEIlacF1s/TM1fLcPTL38O9fOsjMEIwoPKfvt7opuI9G2Hf/PR4aCLDQ7wNmIdEuXJ/QNL72k5q4NejAldPfe3UVVqzkys8YZ/jYOGOp6c+YzRCrCuq0M11y7TiN6qk7YXRMn/gukxrEimbMQjr3jwRM6dKVZ4RUfWQr8noPXLJq6yh5R3EH1IVOHESst/LItbG2D2vRsZRkAObzvQAAD3mb3/G4NzopI0FAiHfbpq0X72adg6SRj+8OHMShtFxxLZlf/nLgRLbClwl5WmaYSs+yEjkq48tY7Z2bE0N91mJwt+ua0NlRJIDh0HikF4UvSVorFj2YVu9YeS5tfvlVjPSoNu/Zu6dEUfBOT555hahBdN3Sa5Xuj2Rvau1lQNIaC944y0RWj9UiNDskAK1WoL+EfXcC6IbBXFRyVfX/WKXxPAwUyIAGW8ggZ08hcijKTt1YKnUO6QPvcrmDVAb0FCLIXn5id4fD/Jx4tw/gbXs7WF9b2RgXtPhLBG9vF5FEkdHAKrQHZAJC/HWvk7nvzzDzIXZlfFTJoC3JpGgLPBY7SQTjGlUvG577yNutZ1hTfs9/1nkSXK9zzKLRZ3VODeKUovJe0WCq1zVMYxCJMenmNzPIU2S8TA4E7wWmbNkxq9rI2dd6v0VpcAPVMxnDsvWTWFayyqvKZO7Z08a62i/oH2/jxf8rpmfO64in3FLiL1GX8IGtVE9M23yGsIqJbxDTy+LtaMWDaPqkymb5VrQdzOvqldeU0SUi6IirG8UZ3jcpRbwHa1C0Dww9G/SFX3gPvTJQE+kyz+g1BeMILKKO+olcHzctOWgzxYHnOD7dpCRtuZEXACjgqesZMasoPgnuDC4nUviAAxDc5pngjoAITIkvhKwg5d608pdrZcA+qn5TMT6Uo/QzBaOxBCLTJX3Mgk85rMfsnWx86oLxf7p2PX5ONqieTa/qM3tPw4ZXvlAp83NSD8F7+ZgctK1TpoYwtiU2h02HCGioH5tkVCqNVTMH5p00sRy2JU1qyDBP2CII/Dg4WDsIl+zgeX7589srx6YORRQMBfKbodbB743Tl4WLKOEnwWUVBsm94SOlCracU72MSyj068wdpYjyz1FwC2bjQnxnB6Mp/pZ+yyZXtguEaYB+kqhjQ6UUmwSFazOb+rhYjLaoiM+aN9/8KKn0zaCTFpN9eKwWy7/u4EHzO46TdFSNjMfn2iPSJwDPCFHc0I1+vjdAZw5ZjqR/uzi9Zn20oAa5JnLEk/EA3VRWE7J/XrupfFJPtCUuqHPpnlL7ISJtRpSVcB8qsZCm2QEkWoROtCKKxUh3yEcMbWYJwk6DlEBG0bZP6eg06FL3v6RPb7odGuwm7FN8fG4woqtB8e7M5klPpo97GoObNwt+ludTAmxyC5hmcFx+dIvEZKI6igFKHqLH01iY1o7903VzG9QGetyVx5RNmBYUU+zIuSva/yIcECUi4pRmE3VkF2avqulQEUY4yZ/wmNboBzPmAPey3+dSYtBZUjeWWT0pPwCz4Vozxp9xeClIU60qvEFMQCaPvPaA70WlOP9f/ey39macvpGCVa+zfa8gO44wbxpJUlC8GN/pRMTQtzY8Z8/hiNrU+Zq64ZfFGIkdj7m7abcK1EBtws1X4J/hnqvasPvvDSDYWN+QcQVGMqXalkDtTad5rYY0TIR1Eqox3czwPMjKPvF5sFv17Thujr1IZ1Ytl4VX1J0vjXKmLY4lmXipRAro0qVGEcXxEVMMEl54jQMd4J7RjgomU0j1ptjyxY+cLiSyXPfiEcIS2lWDK3ISAy6UZ3Hb5vnPncA94411jcy75ay6B6DSTzK6UTCZR9uDANtPBrvIDgjsfarMiwoax2OlLxaSoYn4iRgkpEGqEkwox5tyI8aKkLlfZ12lO11TxsqRMY89j5JaO55XfPJPDL1LGSnC88Re9Ai+Nu5bZjtwRrvFITUFHPR4ZmxGslQMecgbZO7nHk32qHxYkdvWpup07ojcMCaVrpFAyFZJJbNvBpZfdf39Hdo2kPtT7v0/f8R/B5Nz4f1t9/3zNM/7n6SUHfcWk5dfQFJvcJMgPolGCpOFb/WC0FGWU2asuQyT+rm88ZKZ78Cei/CAh939CH0JYbpZIPtxc2ufXqjS3pHH9lnWK4iJ7OjR/EESpCo2R3MYKyE7rHfhTvWho4cL1QdN4jFTyR6syMwFm124TVDDRXMNveI1Dp/ntwdz8k8kxw7iFSx6+Yx6O+1LzMVrN0BBzziZi9kneZSzgollBnVwBh6oSOPHXrglrOj+QmR/AESrhDpKrWT+8/AiMDxS/5wwRNuGQPLlJ9ovomhJWn8sMLVItQ8N/7IXvtD8kdOoHaw+vBSbFImQsv/OCAIui99E+YSIOMlMvBXkAt+NAZK8wB9Jf8CPtB+TOUOR+z71d/AFXpPBT6+A5FLjxMjLIEoJzrQfquvxEIi+WoUzGR1IzQFNvbYOnxb2PyQ0kGdyXKzW2axQL8lNAXPk6NEjqrRD1oZtKLlFoofrXw0dCNWASHzy+7PSzOUJ3XtaPZsxLDjr+o41fKuKWNmjiZtfkOzItvlV2MDGSheGF0ma04qE3TUEfqJMrXFm7DpK+27DSvCUVf7rbNoljPhha5W7KBqVq0ShUSTbRmuqPtQreVWH4JET5yMhuqMoSd4r/N8sDmeQiQQvi1tcZv7Moc7dT5X5AtCD6kNEGZOzVcNYlpX4AbTsLgSYYliiPyVoniuYYySxsBy5cgb3pD+EK0Gpb0wJg031dPgaL8JZt6sIvzNPEHfVPOjXmaXj4bd4voXzpZ5GApMhILgMbCEWZ2zwgdeQgjNHLbPIt+KqxRwWPLTN6HwZ0Ouijj4UF+Sg0Au8XuIKW0WxlexdrFrDcZJ8Shauat3X0XmHygqgL1nAu2hrJFb4wZXkcS+i36KMyU1yFvYv23bQUJi/3yQpqr/naUOoiEWOxckyq/gq43dFou1DVDaYMZK9tho7+IXXokBCs5GRfOcBK7g3A+jXQ39K4YA8PBRW4m5+yR0ZAxWJncjRVbITvIAPHYRt1EJ3YLiUbqIvoKHtzHKtUy1ddRUQ0AUO41vonZDUOW+mrszw+SW/6Q/IUgNpcXFjkM7F4CSSQ2ExZg85otsMs7kqsQD4OxYeBNDcSpifjMoLb7GEbGWTwasVObmB/bfPcUlq0wYhXCYEDWRW02TP5bBrYsKTGWjnWDDJ1F7zWai0zW/2XsCuvBQjPFcTYaQX3tSXRSm8hsAoDdjArK/OFp6vcWYOE7lizP0Yc+8p16i7/NiXIiiQTp7c7Xus925VEtlKAjUdFhyaiLT7VxDagprMFwix4wZ05u0qj7cDWFd0W9OYHIu3JbJKMXRJ1aYNovugg+QqRN7fNHSi26VSgBpn+JfMuPo3aeqPWik/wI5Rz3BWarPQX4i5+dM0npwVOsX+KsOhC7vDg+OJsz4Q5zlnIeflUWL6QYMbf9WDfLmosLF4Qev3mJiOuHjoor/dMeBpA9iKDkMjYBNbRo414HCxjsHrB4EXNbHzNMDHCLuNBG6Sf+J4MZ/ElVsDSLxjIiGsTPhw8BPjxbfQtskj+dyNMKOOcUYIRBEIqbazz3lmjlRQhplxq673VklMMY6597vu+d89ec/zq7Mi4gQvh87ehYbpOuZEXj5g/Q7S7BFDAAB9DzG35SC853xtWVcnZQoH54jeOqYLR9NDuwxsVthTV7V99n/B7HSbAytbEyVTz/5NhJ8gGIjG0E5j3griULUd5Rg7tQR+90hJgNQKQH2btbSfPcaTOfIexc1db1BxUOhM1vWCpLaYuKr3FdNTt/T3PWCpEUWDKEtzYrjpzlL/wri3MITKsFvtF8QVV/NhVo97aKIBgdliNc10dWdXVDpVtsNn+2UIolrgqdWA4EY8so0YvB4a+aLzMXiMAuOHQrXY0tr+CL10JbvZzgjJJuB1cRkdT7DUqTvnswVUp5kkUSFVtIIFYK05+tQxT6992HHNWVhWxUsD1PkceIrlXuUVRogwmfdhyrf6zzaL8+c0L7GXMZOteAhAVQVwdJh+7nrX7x4LaIIfz2F2v7Dg/uDfz2Fa+4gFm2zHAor8UqimJG3VTJtZEoFXhnDYXvxMJFc6ku2bhbCxzij2z5UNuK0jmp1mnvkVNUfR+SEmj1Lr94Lym75PO7Fs0MIr3GdsWXRXSfgLTVY0FLqba97u1In8NAcY7IC6TjWLigwKEIm43NxTdaVTv9mcKkzuzBkKd8x/xt1p/9BbP7Wyb4bpo1K1gnOpbLvKz58pWl3B55RJ/Z5mRDLPtNQg14jdOEs9+h/V5UVpwrAI8kGbX8KPVPDIMfIqKDjJD9UyDOPhjZ3vFAyecwyq4akUE9mDOtJEK1hpDyi6Ae87sWAClXGTiwPwN7PXWwjxaR79ArHRIPeYKTunVW24sPr/3HPz2IwH8oKH4OlWEmt4BLM6W5g4kMcYbLwj2usodD1088stZA7VOsUSpEVl4w7NMb1EUHMRxAxLF0CIV+0L3iZb+ekB1vSDSFjAZ3hfLJf7gFaXrOKn+mhR+rWw/eTXIcAgl4HvFuBg1LOmOAwJH3eoVEjjwheKA4icbrQCmvAtpQ0mXG0agYp5mj4Rb6mdQ+RV4QBPbxMqh9C7o8nP0Wko2ocnCHeRGhN1XVyT2b9ACsL+6ylUy+yC3QEnaKRIJK91YtaoSrcWZMMwxuM0E9J68Z+YyjA0g8p1PfHAAIROy6Sa04VXOuT6A351FOWhKfTGsFJ3RTJGWYPoLk5FVK4OaYR9hkJvezwF9vQN1126r6isMGXWTqFW+3HL3I/jurlIdDWIVvYY+s6yq7lrFSPAGRdnU7PVwY/SvWbZGpXzy3BQ2LmAJlrONUsZs4oGkly0V267xbD5KMY8woNNsmWG1VVgLCra8aQBBcI4DP2BlNwxhiCtHlaz6OWFoCW0vMR3ErrG7JyMjTSCnvRcsEHgmPnwA6iNpJ2DrFb4gLlhKJyZGaWkA97H6FFdwEcLT6DRQQL++fOkVC4cYGW1TG/3iK5dShRSuiBulmihqgjR45Vi03o2RbQbP3sxt90VxQ6vzdlGfkXmmKmjOi080JSHkLntjvsBJnv7gKscOaTOkEaRQqAnCA4HWtB4XnMtOhpRmH2FH8tTXrIjAGNWEmudQLCkcVlGTQ965Kh0H6ixXbgImQP6b42B49sO5C8pc7iRlgyvSYvcnH9FgQ3azLbQG2cUW96SDojTQStxkOJyOuDGTHAnnWkz29aEwN9FT8EJ4yhXOg+jLTrCPKeEoJ9a7lDXOjEr8AgX4BmnMQ668oW0zYPyQiVMPxKRHtpfnEEyaKhdzNVThlxxDQNdrHeZiUFb6NoY2KwvSb7BnRcpJy+/g/zAYx3fYSN5QEaVD2Y1VsNWxB0BSO12MRsRY8JLfAezRMz5lURuLUnG1ToKk6Q30FughqWN6gBNcFxP/nY/iv+iaUQOa+2Nuym46wtI/DvSfzSp1jEi4SdYBE7YhTiVV5cX9gwboVDMVgZp5YBQlHOQvaDNfcCoCJuYhf5kz5kwiIKPjzgpcRJHPbOhJajeoeRL53cuMahhV8Z7IRr6M4hW0JzT7mzaMUzQpm866zwM7Cs07fJYXuWvjAMkbe5O6V4bu71sOG6JQ4oL8zIeXHheFVavzxmlIyBkgc9IZlEDplMPr8xlcyss4pVUdwK1e7CK2kTsSdq7g5SHRAl3pYUB9Ko4fsh4qleOyJv1z3KFSTSvwEcRO/Ew8ozEDYZSqpfoVW9uhJfYrNAXR0Z3VmeoAD+rVWtwP/13sE/3ICX3HhDG3CMc476dEEC0K3umSAD4j+ZQLVdFOsWL2C1TH5+4KiSWH+lMibo+B55hR3Gq40G1n25sGcN0mEcoU2wN9FCVyQLBhYOu9aHVLWjEKx2JIUZi5ySoHUAI9b8hGzaLMxCZDMLhv8MkcpTqEwz9KFDpCpqQhVmsGQN8m24wyB82FAKNmjgfKRsXRmsSESovAwXjBIoMKSG51p6Um8b3i7GISs7kjTq/PZoioCfJzfKdJTN0Q45kQEQuh9H88M3yEs3DbtRTKALraM0YC8laiMiOOe6ADmTcCiREeAWZelBaEXRaSuj2lx0xHaRYqF65O0Lo5OCFU18A8cMDE4MLYm9w2QSr9NgQAIcRxZsNpA7UJR0e71JL+VU+ISWFk5I97lra8uGg7GlQYhGd4Gc6rxsLFRiIeGO4abP4S4ekQ1fiqDCy87GZHd52fn5aaDGuvOmIofrzpVwMvtbreZ/855OaXTRcNiNE0wzGZSxbjg26v8ko8L537v/XCCWP2MFaArJpvnkep0pA+O86MWjRAZPQRfznZiSIaTppy6m3p6HrNSsY7fDtz7Cl4V/DJAjQDoyiL2uwf1UHVd2AIrzBUSlJaTj4k6NL97a/GqhWKU9RUmjnYKpm2r+JYUcrkCuZKvcYvrg8pDoUKQywY9GDWg03DUFSirlUXBS5SWn/KAntnf0IdHGL/7mwXqDG+LZYjbEdQmqUqq4y54TNmWUP7IgcAw5816YBzwiNIJiE9M4lPCzeI/FGBeYy3p6IAmH4AjXXmvQ4Iy0Y82NTobcAggT2Cdqz6Mx4TdGoq9fn2etrWKUNFyatAHydQTVUQ2S5OWVUlugcNvoUrlA8cJJz9MqOa/W3iVno4zDHfE7zhoY5f5lRTVZDhrQbR8LS4eRLz8iPMyBL6o4PiLlp89FjdokQLaSBmKHUwWp0na5fE3v9zny2YcDXG/jfI9sctulHRbdkI5a4GOPJx4oAJQzVZ/yYAado8KNZUdEFs9ZPiBsausotXMNebEgr0dyopuqfScFJ3ODNPHgclACPdccwv0YJGQdsN2lhoV4HVGBxcEUeUX/alr4nqpcc1CCR3vR7g40zteQg/JvWmFlUE4mAiTpHlYGrB7w+U2KdSwQz2QJKBe/5eiixWipmfP15AFWrK8Sh1GBBYLgzki1wTMhGQmagXqJ2+FuqJ8f0XzXCVJFHQdMAw8xco11HhM347alrAu+wmX3pDFABOvkC+WPX0Uhg1Z5MVHKNROxaR84YV3s12UcM+70cJ460SzEaKLyh472vOMD3XnaK7zxZcXlWqenEvcjmgGNR2OKbI1s8U+iwiW+HotHalp3e1MGDy6BMVIvajnAzkFHbeVsgjmJUkrP9OAwnEHYXVBqYx3q7LvXjoVR0mY8h+ZaOnh053pdsGkmbqhyryN01eVHySr+CkDYkSMeZ1xjPNVM+gVLTDKu2VGsMUJqWO4TwPDP0VOg2/8ITbAUaMGb4LjL7L+Pi11lEVMXTYIlAZ/QHmTENjyx3kDkBdfcvvQt6tKk6jYFM4EG5UXDTaF5+1ZjRz6W7MdJPC+wTkbDUim4p5QQH3b9kGk2Bkilyeur8Bc20wm5uJSBO95GfYDI1EZipoRaH7uVveneqz43tlTZGRQ4a7CNmMHgXyOQQOL6WQkgMUTQDT8vh21aSdz7ERiZT1jK9F+v6wgFvuEmGngSvIUR2CJkc5tx1QygfZnAruONobB1idCLB1FCfO7N1ZdRocT8/Wye+EnDiO9pzqIpnLDl4bkaRKW+ekBVwHn46Shw1X0tclt/0ROijuUB4kIInrVJU4buWf4YITJtjOJ6iKdr1u+flgQeFH70GxKjhdgt/MrwfB4K/sXczQ+9zYcrD4dhY6qZhZ010rrxggWA8JaZyg2pYij8ieYEg1aZJkZK9O1Re7sB0iouf60rK0Gd+AYlp7soqCBCDGwfKeUQhCBn0E0o0GS6PdmjLi0TtCYZeqazqwN+yNINIA8Lk3iPDnWUiIPLGNcHmZDxfeK0iAdxm/T7LnN+gemRL61hHIc0NCAZaiYJR+OHnLWSe8sLrK905B5eEJHNlWq4RmEXIaFTmo49f8w61+NwfEUyuJAwVqZCLFcyHBKAcIVj3sNzfEOXzVKIndxHw+AR93owhbCxUZf6Gs8cz6/1VdrFEPrv330+9s6BtMVPJ3zl/Uf9rUi0Z/opexfdL3ykF76e999GPfVv8fJv/Y/+/5hEMon1tqNFyVRevV9y9/uIvsG3dbB8GRRrgaEXfhx+2xeOFt+cEn3RZanNxdEe2+B6MHpNbrRE53PlDifPvFcp4kO78ILR0T4xyW/WGPyBsqGdoA7zJJCu1TKbGfhnqgnRbxbB2B3UZoeQ2bz2sTVnUwokTcTU21RxN1PYPS3Sar7T0eRIsyCNowr9amwoMU/od9s2APtiKNL6ENOlyKADstAEWKA+sdKDhrJ6BOhRJmZ+QJbAaZ3/5Fq0/lumCgEzGEbu3yi0Y4I4EgVAjqxh4HbuQn0GrRhOWyAfsglQJAVL1y/6yezS2k8RE2MstJLh92NOB3GCYgFXznF4d25qiP4ZCyI4RYGesut6FXK6GwPpKK8WHEkhYui0AyEmr5Ml3uBFtPFdnioI8RiCooa7Z1G1WuyIi3nSNglutc+xY8BkeW3JJXPK6jd2VIMpaSxpVtFq+R+ySK9J6WG5Qvt+C+QH1hyYUOVK7857nFmyDBYgZ/o+AnibzNVqyYCJQvyDXDTK+iXdkA71bY7TL3bvuLxLBQ8kbTvTEY9aqkQ3+MiLWbEgjLzOH+lXgco1ERgzd80rDCymlpaRQbOYnKG/ODoFl46lzT0cjM5FYVvv0qLUbD5lyJtMUaC1pFlTkNONx6lliaX9o0i/1vws5bNKn5OuENQEKmLlcP4o2ZmJjD4zzd3Fk32uQ4uRWkPSUqb4LBe3EXHdORNB2BWsws5daRnMfNVX7isPSb1hMQdAJi1/qmDMfRUlCU74pmnzjbXfL8PVG8NsW6IQM2Ne23iCPIpryJjYbVnm5hCvKpMa7HLViNiNc+xTfDIaKm3jctViD8A1M9YPJNk003VVr4Zo2MuGW8vil8SLaGpPXqG7I4DLdtl8a4Rbx1Lt4w5Huqaa1XzZBtj208EJVGcmKYEuaeN27zT9EE6a09JerXdEbpaNgNqYJdhP1NdqiPKsbDRUi86XvvNC7rME5mrSQtrzAZVndtSjCMqd8BmaeGR4l4YFULGRBeXIV9Y4yxLFdyoUNpiy2IhePSWzBofYPP0eIa2q5JP4j9G8at/AqoSsLAUuRXtvgsqX/zYwsE+of6oSDbUOo4RMJw+DOUTJq+hnqwKim9Yy/napyZNTc2rCq6V9jHtJbxGPDwlzWj/Sk3zF/BHOlT/fSjSq7FqlPI1q6J+ru8Aku008SFINXZfOfnZNOvGPMtEmn2gLPt+H4QLA+/SYe4j398auzhKIp2Pok3mPC5q1IN1HgR+mnEfc4NeeHYwd2/kpszR3cBn7ni9NbIqhtSWFW8xbUJuUPVOeeXu3j0IGZmFNiwaNZ6rH4/zQ2ODz6tFxRLsUYZu1bfd1uIvfQDt4YD/efKYv8VF8bHGDgK22w2Wqwpi43vNCOXFJZCGMqWiPbL8mil6tsmOTXAWCyMCw73e2rADZj2IK6rqksM3EXF2cbLb4vjB14wa/yXK5vwU+05MzERJ5nXsXsW21o7M+gO0js2OyKciP5uF2iXyb2DiptwQeHeqygkrNsqVCSlldxBMpwHi1vfc8RKpP/4L3Lmpq6DZcvhDDfxTCE3splacTcOtXdK2g303dIWBVe2wD/Gvja1cClFQ67gw0t1ZUttsUgQ1Veky8oOpS6ksYEc4bqseCbZy766SvL3FodmnahlWJRgVCNjPxhL/fk2wyvlKhITH/VQCipOI0dNcRa5B1M5HmOBjTLeZQJy237e2mobwmDyJNHePhdDmiknvLKaDbShL+Is1XTCJuLQd2wmdJL7+mKvs294whXQD+vtd88KKk0DXP8B1Xu9J+xo69VOuFgexgTrcvI6SyltuLix9OPuE6/iRJYoBMEXxU4shQMf4Fjqwf1PtnJ/wWSZd29rhZjRmTGgiGTAUQqRz+nCdjeMfYhsBD5Lv60KILWEvNEHfmsDs2L0A252351eUoYxAysVaCJVLdH9QFWAmqJDCODUcdoo12+gd6bW2boY0pBVHWL6LQDK5bYWh1V8vFvi0cRpfwv7cJiMX3AZNJuTddHehTIdU0YQ/sQ1dLoF2xQPcCuHKiuCWOY30DHe1OwcClLAhqAKyqlnIbH/8u9ScJpcS4kgp6HKDUdiOgRaRGSiUCRBjzI5gSksMZKqy7Sd51aeg0tgJ+x0TH9YH2Mgsap9N7ENZdEB0bey2DMTrBA1hn56SErNHf3tKtqyL9b6yXEP97/rc+jgD2N1LNUH6RM9AzP3kSipr06RkKOolR7HO768jjWiH1X92jA7dkg7gcNcjqsZCgfqWw0tPXdLg20cF6vnQypg7gLtkazrHAodyYfENPQZsdfnjMZiNu4nJO97D1/sQE+3vNFzrSDOKw+keLECYf7RJwVHeP/j79833oZ0egonYB2FlFE5qj02B/LVOMJQlsB8uNg3Leg4qtZwntsOSNidR0abbZmAK4sCzvt8Yiuz2yrNCJoH5O8XvX/vLeR/BBYTWj0sOPYM/jyxRd5+/JziKAABaPcw/34UA3aj/gLZxZgRCWN6m4m3demanNgsx0P237/Q+Ew5VYnJPkyCY0cIVHoFn2Ay/e7U4P19APbPFXEHX94N6KhEMPG7iwB3+I+O1jd5n6VSgHegxgaSawO6iQCYFgDsPSMsNOcUj4q3sF6KzGaH/0u5PQoAj/8zq6Uc9MoNrGqhYeb2jQo0WlGlXjxtanZLS24/OIN5Gx/2g684BPDQpwlqnkFcxpmP/osnOXrFuu4PqifouQH0eF5qCkvITQbJw/Zvy5mAHWC9oU+cTiYhJmSfKsCyt1cGVxisKu+NymEQIAyaCgud/V09qT3nk/9s/SWsYtha7yNpzBIMM40rCSGaJ9u6lEkl00vXBiEt7p9P5IBCiavynEOv7FgLqPdeqxRiCwuFVMolSIUBcoyfUC2e2FJSAUgYdVGFf0b0Kn2EZlK97yyxrT2MVgvtRikfdaAW8RwEEfN+B7/eK8bBdp7URpbqn1xcrC6d2UjdsKbzCjBFqkKkoZt7Mrhg6YagE7spkqj0jOrWM+UGQ0MUlG2evP1uE1p2xSv4dMK0dna6ENcNUF+xkaJ7B764NdxLCpuvhblltVRAf7vK5qPttJ/9RYFUUSGcLdibnz6mf7WkPO3MkUUhR2mAOuGv8IWw5XG1ZvoVMnjSAZe6T7WYA99GENxoHkMiKxHlCuK5Gd0INrISImHQrQmv6F4mqU/TTQ8nHMDzCRivKySQ8dqkpQgnUMnwIkaAuc6/FGq1hw3b2Sba398BhUwUZSAIO8XZvnuLdY2n6hOXws+gq9BHUKcKFA6kz6FDnpxLPICa3qGhnc97bo1FT/XJk48LrkHJ2CAtBv0RtN97N21plfpXHvZ8gMJb7Zc4cfI6MbPwsW7AilCSXMFIEUEmir8XLEklA0ztYbGpTTGqttp5hpFTTIqUyaAIqvMT9A/x+Ji5ejA4Bhxb/cl1pUdOD6epd3yilIdO6j297xInoiBPuEDW2/UfslDyhGkQs7Wy253bVnlT+SWg89zYIK/9KXFl5fe+jow2rd5FXv8zDPrmfMXiUPt9QBO/iK4QGbX5j/7Rx1c1vzsY8ONbP3lVIaPrhL4+1QrECTN3nyKavGG0gBBtHvTKhGoBHgMXHStFowN+HKrPriYu+OZ05Frn8okQrPaaxoKP1ULCS/cmKFN3gcH7HQlVjraCeQmtjg1pSQxeuqXiSKgLpxc/1OiZsU4+n4lz4hpahGyWBURLi4642n1gn9qz9bIsaCeEPJ0uJmenMWp2tJmIwLQ6VSgDYErOeBCfSj9P4G/vI7oIF+l/n5fp956QgxGvur77ynawAu3G9MdFbJbu49NZnWnnFcQHjxRuhUYvg1U/e84N4JTecciDAKb/KYIFXzloyuE1eYXf54MmhjTq7B/yBToDzzpx3tJCTo3HCmVPYfmtBRe3mPYEE/6RlTIxbf4fSOcaKFGk4gbaUWe44hVk9SZzhW80yfW5QWBHxmtUzvMhfVQli4gZTktIOZd9mjJ5hsbmzttaHQB29Am3dZkmx3g/qvYocyhZ2PXAWsNQiIaf+Q8W/MWPIK7/TjvCx5q2XRp4lVWydMc2wIQkhadDB0xsnw/kSEyGjLKjI4coVIwtubTF3E7MJ6LS6UOsJKj82XVAVPJJcepfewbzE91ivXZvOvYfsmMevwtPpfMzGmC7WJlyW2j0jh7AF1JLmwEJSKYwIvu6DHc3YnyLH9ZdIBnQ+nOVDRiP+REpqv++typYHIvoJyICGA40d8bR7HR2k7do6UQTHF4oriYeIQbxKe4Th6+/l1BjUtS9hqORh3MbgvYrStXTfSwaBOmAVQZzpYNqsAmQyjY56MUqty3c/xH6GuhNvNaG9vGbG6cPtBM8UA3e8r51D0AR9kozKuGGSMgLz3nAHxDNnc7GTwpLj7/6HeWp1iksDeTjwCLpxejuMtpMnGJgsiku1sOACwQ9ukzESiDRN77YNESxR5LphOlcASXA5uIts1LnBIcn1J7BLWs49DMALSnuz95gdOrTZr0u1SeYHinno/pE58xYoXbVO/S+FEMMs5qyWkMnp8Q3ClyTlZP52Y9nq7b8fITPuVXUk9ohG5EFHw4gAEcjFxfKb3xuAsEjx2z1wxNbSZMcgS9GKyW3R6KwJONgtA64LTyxWm8Bvudp0M1FdJPEGopM4Fvg7G/hsptkhCfHFegv4ENwxPeXmYhxwZy7js+BeM27t9ODBMynVCLJ7RWcBMteZJtvjOYHb5lOnCLYWNEMKC59BA7covu1cANa2PXL05iGdufOzkgFqqHBOrgQVUmLEc+Mkz4Rq8O6WkNr7atNkH4M8d+SD1t/tSzt3oFql+neVs+AwEI5JaBJaxARtY2Z4mKoUqxds4UpZ0sv3zIbNoo0J4fihldQTX3XNcuNcZmcrB5LTWMdzeRuAtBk3cZHYQF6gTi3PNuDJ0nmR+4LPLoHvxQIxRgJ9iNNXqf2SYJhcvCtJiVWo85TsyFOuq7EyBPJrAdhEgE0cTq16FQXhYPJFqSfiVn0IQnPOy0LbU4BeG94QjdYNB0CiQ3QaxQqD2ebSMiNjaVaw8WaM4Z5WnzcVDsr4eGweSLa2DE3BWViaxhZFIcSTjgxNCAfelg+hznVOYoe5VqTYs1g7WtfTm3e4/WduC6p+qqAM8H4ZyrJCGpewThTDPe6H7CzX/zQ8Tm+r65HeZn+MsmxUciEWPlAVaK/VBaQBWfoG/aRL/jSZIQfep/89GjasWmbaWzeEZ2R1FOjvyJT37O9B8046SRSKVEnXWlBqbkb5XCS3qFeuE9xb9+frEknxWB5h1D/hruz2iVDEAS7+qkEz5Ot5agHJc7WCdY94Ws61sURcX5nG8UELGBAHZ3i+3VulAyT0nKNNz4K2LBHBWJcTBX1wzf+//u/j/9+//v87+9/l9Lbh/L/uyNYiTsWV2LwsjaA6MxTuzFMqmxW8Jw/+IppdX8t/Clgi1rI1SN0UC/r6tX/4lUc2VV1OQReSeCsjUpKZchw4XUcjHfw6ryCV3R8s6VXm67vp4n+lcPV9gJwmbKQEsmrJi9c2vkwrm8HFbVYNTaRGq8D91t9n5+U+aD/hNtN3HjC/nC/vUoGFSCkXP+NlRcmLUqLbiUBl4LYf1U/CCvwtd3ryCH8gUmGITAxiH1O5rnGTz7y1LuFjmnFGQ1UWuM7HwfXtWl2fPFKklYwNUpF2IL/TmaRETjQiM5SJacI+3Gv5MBU8lP5Io6gWkawpyzNEVGqOdx4YlO1dCvjbWFZWbCmeiFKPSlMKtKcMFLs/KQxtgAHi7NZNCQ32bBAW2mbHflVZ8wXKi1JKVHkW20bnYnl3dKWJeWJOiX3oKPBD6Zbi0ZvSIuWktUHB8qDR8DMMh1ZfkBL9FS9x5r0hBGLJ8pUCJv3NYH+Ae8p40mZWd5m5fhobFjQeQvqTT4VKWIYfRL0tfaXKiVl75hHReuTJEcqVlug+eOIIc4bdIydtn2K0iNZPsYWQvQio2qbO3OqAlPHDDOB7DfjGEfVF51FqqNacd6QmgFKJpMfLp5DHTv4wXlONKVXF9zTJpDV4m1sYZqJPhotcsliZM8yksKkCkzpiXt+EcRQvSQqmBS9WdWkxMTJXPSw94jqI3varCjQxTazjlMH8jTS8ilaW8014/vwA/LNa+YiFoyyx3s/KswP3O8QW1jtq45yTM/DX9a8M4voTVaO2ebvw1EooDw/yg6Y1faY+WwrdVs5Yt0hQ5EwRfYXSFxray1YvSM+kYmlpLG2/9mm1MfmbKHXr44Ih8nVKb1M537ZANUkCtdsPZ80JVKVKabVHCadaLXg+IV8i5GSwpZti0h6diTaKs9sdpUKEpd7jDUpYmHtiX33SKiO3tuydkaxA7pEc9XIQEOfWJlszj5YpL5bKeQyT7aZSBOamvSHl8xsWvgo26IP/bqk+0EJUz+gkkcvlUlyPp2kdKFtt7y5aCdks9ZJJcFp5ZWeaWKgtnXMN3ORwGLBE0PtkEIek5FY2aVssUZHtsWIvnljMVJtuVIjpZup/5VL1yPOHWWHkOMc6YySWMckczD5jUj2mlLVquFaMU8leGVaqeXis+aRRL8zm4WuBk6cyWfGMxgtr8useQEx7k/PvRoZyd9nde1GUCV84gMX8Ogu/BWezYPSR27llzQnA97oo0pYyxobYUJfsj+ysTm9zJ+S4pk0TGo9VTG0KjqYhTmALfoDZVKla2b5yhv241PxFaLJs3i05K0AAIdcGxCJZmT3ZdT7CliR7q+kur7WdQjygYtOWRL9B8E4s4LI8KpAj7bE0dg7DLOaX+MGeAi0hMMSSWZEz+RudXbZCsGYS0QqiXjH9XQbd8sCB+nIVTq7/T/FDS+zWY9q7Z2fdq1tdLb6v3hKKVDAw5gjj6o9r1wHFROdHc18MJp4SJ2Ucvu+iQ9EgkekW8VCM+psM6y+/2SBy8tNN4a3L1MzP+OLsyvESo5gS7IQOnIqMmviJBVc6zbVG1n8eXiA3j46kmvvtJlewwNDrxk4SbJOtP/TV/lIVK9ueShNbbMHfwnLTLLhbZuO79ec5XvfgRwLFK+w1r5ZWW15rVFZrE+wKqNRv5KqsLNfpGgnoUU6Y71NxEmN7MyqwqAQqoIULOw/LbuUB2+uE75gJt+kq1qY4LoxV+qR/zalupea3D5+WMeaRIn0sAI6DDWDh158fqUb4YhAxhREbUN0qyyJYkBU4V2KARXDT65gW3gRsiv7xSPYEKLwzgriWcWgPr0sbZnv7m1XHNFW6xPdGNZUdxFiUYlmXNjDVWuu7LCkX/nVkrXaJhiYktBISC2xgBXQnNEP+cptWl1eG62a7CPXrnrkTQ5BQASbEqUZWMDiZUisKyHDeLFOaJILUo5f6iDt4ZO8MlqaKLto0AmTHVVbkGuyPa1R/ywZsWRoRDoRdNMMHwYTsklMVnlAd2S0282bgMI8fiJpDh69OSL6K3qbo20KfpNMurnYGQSr/stFqZ7hYsxKlLnKAKhsmB8AIpEQ4bd/NrTLTXefsE6ChRmKWjXKVgpGoPs8GAicgKVw4K0qgDgy1A6hFq1WRat3fHF+FkU+b6H4NWpOU3KXTxrIb2qSHAb+qhm8hiSROi/9ofapjxhyKxxntPpge6KL5Z4+WBMYkAcE6+0Hd3Yh2zBsK2MV3iW0Y6cvOCroXlRb2MMJtdWx+3dkFzGh2Pe3DZ9QpSqpaR/rE1ImOrHqYYyccpiLC22amJIjRWVAherTfpQLmo6/K2pna85GrDuQPlH1Tsar8isAJbXLafSwOof4gg9RkAGm/oYpBQQiPUoyDk2BCQ1k+KILq48ErFo4WSRhHLq/y7mgw3+L85PpP6xWr6cgp9sOjYjKagOrxF148uhuaWtjet953fh1IQiEzgC+d2IgBCcUZqgTAICm2bR8oCjDLBsmg+ThyhfD+zBalsKBY1Ce54Y/t9cwfbLu9SFwEgphfopNA3yNxgyDafUM3mYTovZNgPGdd4ZFFOj1vtfFW3u7N+iHEN1HkeesDMXKPyoCDCGVMo4GCCD6PBhQ3dRZIHy0Y/3MaE5zU9mTCrwwnZojtE+qNpMSkJSpmGe0EzLyFelMJqhfFQ7a50uXxZ8pCc2wxtAKWgHoeamR2O7R+bq7IbPYItO0esdRgoTaY38hZLJ5y02oIVwoPokGIzxAMDuanQ1vn2WDQ00Rh6o5QOaCRu99fwDbQcN0XAuqkFpxT/cfz3slGRVokrNU0iqiMAJFEbKScZdmSkTUznC0U+MfwFOGdLgsewRyPKwBZYSmy6U325iUhBQNxbAC3FLKDV9VSOuQpOOukJ/GAmu/tyEbX9DgEp6dv1zoU0IqzpG6gssSjIYRVPGgU1QAQYRgIT8gEV0EXr1sqeh2I6rXjtmoCYyEDCe/PkFEi/Q48FuT29p557iN+LCwk5CK/CZ2WdAdfQZh2Z9QGrzPLSNRj5igUWzl9Vi0rCqH8G1Kp4QMLkuwMCAypdviDXyOIk0AHTM8HBYKh3b0/F+DxoNj4ZdoZfCpQVdnZarqoMaHWnMLNVcyevytGsrXQEoIbubqWYNo7NRHzdc0zvT21fWVirj7g36iy6pxogfvgHp1xH1Turbz8QyyHnXeBJicpYUctbzApwzZ1HT+FPEXMAgUZetgeGMwt4G+DHiDT2Lu+PT21fjJCAfV16a/Wu1PqOkUHSTKYhWW6PhhHUlNtWzFnA7MbY+r64vkwdpfNB2JfWgWXAvkzd42K4lN9x7Wrg4kIKgXCb4mcW595MCPJ/cTfPAMQMFWwnqwde4w8HZYJFpQwcSMhjVz4B8p6ncSCN1X4klxoIH4BN2J6taBMj6lHkAOs8JJAmXq5xsQtrPIPIIp/HG6i21xMGcFgqDXSRF0xQg14d2uy6HgKE13LSvQe52oShF5Jx1R6avyL4thhXQZHfC94oZzuPUBKFYf1VvDaxIrtV6dNGSx7DO0i1p6CzBkuAmEqyWceQY7F9+U0ObYDzoa1iKao/cOD/v6Q9gHrrr1uCeOk8fST9MG23Ul0KmM3r+Wn6Hi6WAcL7gEeaykicvgjzkjSwFsAXIR81Zx4QJ6oosVyJkCcT+4xAldCcihqvTf94HHUPXYp3REIaR4dhpQF6+FK1H0i9i7Pvh8owu3lO4PT1iuqu+DkL2Bj9+kdfGAg2TXw03iNHyobxofLE2ibjsYDPgeEQlRMR7afXbSGQcnPjI2D+sdtmuQ771dbASUsDndU7t58jrrNGRzISvwioAlHs5FA+cBE5Ccznkd8NMV6BR6ksnKLPZnMUawRDU1MZ/ib3xCdkTblHKu4blNiylH5n213yM0zubEie0o4JhzcfAy3H5qh2l17uLooBNLaO+gzonTH2uF8PQu9EyH+pjGsACTMy4cHzsPdymUSXYJOMP3yTkXqvO/lpvt0cX5ekDEu9PUfBeZODkFuAjXCaGdi6ew4qxJ8PmFfwmPpkgQjQlWqomFY6UkjmcnAtJG75EVR+NpzGpP1Ef5qUUbfowrC3zcSLX3BxgWEgEx/v9cP8H8u1Mvt9/rMDYf6sjwU1xSOPBgzFEeJLMRVFtKo5QHsUYT8ZRLCah27599EuqoC9PYjYO6aoAMHB8X1OHwEAYouHfHB3nyb2B+SnZxM/vw/bCtORjLMSy5aZoEpvgdGvlJfNPFUu/p7Z4VVK1hiI0/UTuB3ZPq4ohEbm7Mntgc1evEtknaosgZSwnDC2BdMmibpeg48X8Ixl+/8+xXdbshQXUPPvx8jT3fkELivHSmqbhblfNFShWAyQnJ3WBU6SMYSIpTDmHjdLVAdlADdz9gCplZw6mTiHqDwIsxbm9ErGusiVpg2w8Q3khKV/R9Oj8PFeF43hmW/nSd99nZzhyjCX3QOZkkB6BsH4H866WGyv9E0hVAzPYah2tkRfQZMmP2rinfOeQalge0ovhduBjJs9a1GBwReerceify49ctOh5/65ATYuMsAkVltmvTLBk4oHpdl6i+p8DoNj4Fb2vhdFYer2JSEilEwPd5n5zNoGBXEjreg/wh2NFnNRaIUHSOXa4eJRwygZoX6vnWnqVdCRT1ARxeFrNBJ+tsdooMwqnYhE7zIxnD8pZH+P0Nu1wWxCPTADfNWmqx626IBJJq6NeapcGeOmbtXvl0TeWG0Y7OGGV4+EHTtNBIT5Wd0Bujl7inXgZgfXTM5efD3qDTJ54O9v3Bkv+tdIRlq1kXcVD0BEMirmFxglNPt5pedb1AnxuCYMChUykwsTIWqT23XDpvTiKEru1cTcEMeniB+HQDehxPXNmkotFdwUPnilB/u4Nx5Xc6l8J9jH1EgKZUUt8t8cyoZleDBEt8oibDmJRAoMKJ5Oe9CSWS5ZMEJvacsGVdXDWjp/Ype5x0p9PXB2PAwt2LRD3d+ftNgpuyvxlP8pB84oB1i73vAVpwyrmXW72hfW6Dzn9Jkj4++0VQ4d0KSx1AsDA4OtXXDo63/w+GD+zC7w5SJaxsmnlYRQ4dgdjA7tTl2KNLnpJ+mvkoDxtt1a4oPaX3EVqj96o9sRKBQqU7ZOiupeAIyLMD+Y3YwHx30XWHB5CQiw7q3mj1EDlP2eBsZbz79ayUMbyHQ7s8gu4Lgip1LiGJj7NQj905/+rgUYKAA5qdrlHKIknWmqfuR+PB8RdBkDg/NgnlT89G72h2NvySnj7UyBwD+mi/IWs1xWbxuVwUIVXun5cMqBtFbrccI+DILjsVQg6eeq0itiRfedn89CvyFtpkxaauEvSANuZmB1p8FGPbU94J9medwsZ9HkUYjmI7OH5HuxendLbxTaYrPuIfE2ffXFKhoNBUp33HsFAXmCV/Vxpq5AYgFoRr5Ay93ZLRlgaIPjhZjXZZChT+aE5iWAXMX0oSFQEtwjiuhQQItTQX5IYrKfKB+queTNplR1Hoflo5/I6aPPmACwQCE2jTOYo5Dz1cs7Sod0KTG/3kEDGk3kUaUCON19xSJCab3kNpWZhSWkO8l+SpW70Wn3g0ciOIJO5JXma6dbos6jyisuxXwUUhj2+1uGhcvuliKtWwsUTw4gi1c/diEEpZHoKoxTBeMDmhPhKTx7TXWRakV8imJR355DcIHkR9IREHxohP4TbyR5LtFU24umRPRmEYHbpe1LghyxPx7YgUHjNbbQFRQhh4KeU1EabXx8FS3JAxp2rwRDoeWkJgWRUSKw6gGP5U2PuO9V4ZuiKXGGzFQuRuf+tkSSsbBtRJKhCi3ENuLlXhPbjTKD4djXVnfXFds6Zb+1XiUrRfyayGxJq1+SYBEfbKlgjiSmk0orgTqzSS+DZ5rTqsJbttiNtp+KMqGE2AHGFw6jQqM5vD6vMptmXV9OAjq49Uf/Lx9Opam+Hn5O9p8qoBBAQixzQZ4eNVkO9sPzJAMyR1y4/RCQQ1s0pV5KAU5sKLw3tkcFbI/JqrjCsK4Mw+W8aod4lioYuawUiCyVWBE/qPaFi5bnkgpfu/ae47174rI1fqQoTbW0HrU6FAejq7ByM0V4zkZTg02/YJK2N7hUQRCeZ4BIgSEqgD8XsjzG6LIsSbuHoIdz/LhFzbNn1clci1NHWJ0/6/O8HJMdIpEZbqi1RrrFfoo/rI/7ufm2MPG5lUI0IYJ4MAiHRTSOFJ2oTverFHYXThkYFIoyFx6rMYFgaOKM4xNWdlOnIcKb/suptptgTOTdVIf4YgdaAjJnIAm4qNNHNQqqAzvi53GkyRCEoseUBrHohZsjUbkR8gfKtc/+Oa72lwxJ8Mq6HDfDATbfbJhzeIuFQJSiw1uZprHlzUf90WgqG76zO0eCB1WdPv1IT6sNxxh91GEL2YpgC97ikFHyoaH92ndwduqZ6IYjkg20DX33MWdoZk7QkcKUCgisIYslOaaLyvIIqRKWQj16jE1DlQWJJaPopWTJjXfixEjRJJo8g4++wuQjbq+WVYjsqCuNIQW3YjnxKe2M5ZKEqq+cX7ZVgnkbsU3RWIyXA1rxv4kGersYJjD//auldXGmcEbcfTeF16Y1708FB1HIfmWv6dSFi6oD4E+RIjCsEZ+kY7dKnwReJJw3xCjKvi3kGN42rvyhUlIz0Bp+fNSV5xwFiuBzG296e5s/oHoFtUyUplmPulIPl+e1CQIQVtjlzLzzzbV+D/OVQtYzo5ixtMi5BmHuG4N/uKfJk5UIREp7+12oZlKtPBomXSzAY0KgtbPzzZoHQxujnREUgBU+O/jKKhgxVhRPtbqyHiUaRwRpHv7pgRPyUrnE7fYkVblGmfTY28tFCvlILC04Tz3ivkNWVazA+OsYrxvRM/hiNn8Fc4bQBeUZABGx5S/xFf9Lbbmk298X7iFg2yeimvsQqqJ+hYbt6uq+Zf9jC+Jcwiccd61NKQtFvGWrgJiHB5lwi6fR8KzYS7EaEHf/ka9EC7H8D+WEa3TEACHBkNSj/cXxFeq4RllC+fUFm2xtstYLL2nos1DfzsC9vqDDdRVcPA3Ho95aEQHvExVThXPqym65llkKlfRXbPTRiDepdylHjmV9YTWAEjlD9DdQnCem7Aj/ml58On366392214B5zrmQz/9ySG2mFqEwjq5sFl5tYJPw5hNz8lyZPUTsr5E0F2C9VMPnZckWP7+mbwp/BiN7f4kf7vtGnZF2JGvjK/sDX1RtcFY5oPQnE4lIAYV49U3C9SP0LCY/9i/WIFK9ORjzM9kG/KGrAuwFmgdEpdLaiqQNpCTGZVuAO65afkY1h33hrqyLjZy92JK3/twdj9pafFcwfXONmPQWldPlMe7jlP24Js0v9m8bIJ9TgS2IuRvE9ZVRaCwSJYOtAfL5H/YS4FfzKWKbek+GFulheyKtDNlBtrdmr+KU+ibHTdalzFUmMfxw3f36x+3cQbJLItSilW9cuvZEMjKw987jykZRlsH/UI+HlKfo2tLwemBEeBFtmxF2xmItA/dAIfQ+rXnm88dqvXa+GapOYVt/2waFimXFx3TC2MUiOi5/Ml+3rj/YU6Ihx2hXgiDXFsUeQkRAD6wF3SCPi2flk7XwKAA4zboqynuELD312EJ88lmDEVOMa1W/K/a8tGylZRMrMoILyoMQzzbDJHNZrhH77L9qSC42HVmKiZ5S0016UTp83gOhCwz9XItK9fgXfK3F5d7nZCBUekoLxrutQaPHa16Rjsa0gTrzyjqTnmcIcrxg6X6dkKiucudc0DD5W4pJPf0vuDW8r5/uw24YfMuxFRpD2ovT2mFX79xH6Jf+MVdv2TYqR6/955QgVPe3JCD/WjAYcLA9tpXgFiEjge2J5ljeI/iUzg91KQuHkII4mmHZxC3XQORLAC6G7uFn5LOmlnXkjFdoO976moNTxElS8HdxWoPAkjjocDR136m2l+f5t6xaaNgdodOvTu0rievnhNAB79WNrVs6EsPgkgfahF9gSFzzAd+rJSraw5Mllit7vUP5YxA843lUpu6/5jAR0RvH4rRXkSg3nE+O5GFyfe+L0s5r3k05FyghSFnKo4TTgs07qj4nTLqOYj6qaW9knJTDkF5OFMYbmCP+8H16Ty482OjvERV6OFyw043L9w3hoJi408sR+SGo1WviXUu8d7qS+ehKjpKwxeCthsm2LBFSFeetx0x4AaKPxtp3CxdWqCsLrB1s/j5TAhc1jNZsXWl6tjo/WDoewxzg8T8NnhZ1niUwL/nhfygLanCnRwaFGDyLw+sfZhyZ1UtYTp8TYB6dE7R3VsKKH95CUxJ8u8N+9u2/9HUNKHW3x3w5GQrfOPafk2w5qZq8MaHT0ebeY3wIsp3rN9lrpIsW9c1ws3VNV+JwNz0Lo9+V7zZr6GD56We6gWVIvtmam5GPPkVAbr74r6SwhuL+TRXtW/0pgyX16VNl4/EAD50TnUPuwrW6OcUO2VlWXS0inq872kk7GUlW6o/ozFKq+Sip6LcTtSDfDrPTcCHhx75H8BeRon+KG2wRwzfDgWhALmiWOMO6h3pm1UCZEPEjScyk7tdLx6WrdA2N1QTPENvNnhCQjW6kl057/qv7IwRryHrZBCwVSbLLnFRiHdTwk8mlYixFt1slEcPD7FVht13HyqVeyD55HOXrh2ElAxJyinGeoFzwKA91zfrdLvDxJSjzmImfvTisreI25EDcVfGsmxLVbfU8PGe/7NmWWKjXcdTJ11jAlVIY/Bv/mcxg/Q10vCHwKG1GW/XbJq5nxDhyLqiorn7Wd7VEVL8UgVzpHMjQ+Z8DUgSukiVwWAKkeTlVVeZ7t1DGnCgJVIdBPZAEK5f8CDyDNo7tK4/5DBjdD5MPV86TaEhGsLVFPQSI68KlBYy84FievdU9gWh6XZrugvtCZmi9vfd6db6V7FmoEcRHnG36VZH8N4aZaldq9zZawt1uBFgxYYx+Gs/qW1jwANeFy+LCoymyM6zgG7j8bGzUyLhvrbJkTYAEdICEb4kMKusKT9V3eIwMLsjdUdgijMc+7iKrr+TxrVWG0U+W95SGrxnxGrE4eaJFfgvAjUM4SAy8UaRwE9j6ZQH5qYAWGtXByvDiLSDfOD0yFA3UCMKSyQ30fyy1mIRg4ZcgZHLNHWl+c9SeijOvbOJxoQy7lTN2r3Y8p6ovxvUY74aOYbuVezryqXA6U+fcp6wSV9X5/OZKP18tB56Ua0gMyxJI7XyNT7IrqN8GsB9rL/kP5KMrjXxgqKLDa+V5OCH6a5hmOWemMUsea9vQl9t5Oce76PrTyTv50ExOqngE3PHPfSL//AItPdB7kGnyTRhVUUFNdJJ2z7RtktZwgmQzhBG/G7QsjZmJfCE7k75EmdIKH7xlnmDrNM/XbTT6FzldcH/rcRGxlPrv4qDScqE7JSmQABJWqRT/TUcJSwoQM+1jvDigvrjjH8oeK2in1S+/yO1j8xAws/T5u0VnIvAPqaE1atNuN0cuRliLcH2j0nTL4JpcR7w9Qya0JoaHgsOiALLCCzRkl1UUESz+ze/gIXHGtDwgYrK6pCFKJ1webSDog4zTlPkgXZqxlQDiYMjhDpwTtBW2WxthWbov9dt2X9XFLFmcF+eEc1UaQ74gqZiZsdj63pH1qcv3Vy8JYciogIVKsJ8Yy3J9w/GhjWVSQAmrS0BPOWK+RKV+0lWqXgYMnIFwpcZVD7zPSp547i9HlflB8gVnSTGmmq1ClO081OW/UH11pEQMfkEdDFzjLC1Cdo/BdL3s7cXb8J++Hzz1rhOUVZFIPehRiZ8VYu6+7Er7j5PSZu9g/GBdmNzJmyCD9wiswj9BZw+T3iBrg81re36ihMLjoVLoWc+62a1U/7qVX5CpvTVF7rocSAKwv4cBVqZm7lLDS/qoXs4fMs/VQi6BtVbNA3uSzKpQfjH1o3x4LrvkOn40zhm6hjduDglzJUwA0POabgdXIndp9fzhOo23Pe+Rk9GSLX0d71Poqry8NQDTzNlsa+JTNG9+UrEf+ngxCjGEsDCc0bz+udVRyHQI1jmEO3S+IOQycEq7XwB6z3wfMfa73m8PVRp+iOgtZfeSBl01xn03vMaQJkyj7vnhGCklsCWVRUl4y+5oNUzQ63B2dbjDF3vikd/3RUMifPYnX5Glfuk2FsV/7RqjI9yKTbE8wJY+74p7qXO8+dIYgjtLD/N8TJtRh04N9tXJA4H59IkMmLElgvr0Q5OCeVfdAt+5hkh4pQgfRMHpL74XatLQpPiOyHRs/OdmHtBf8nOZcxVKzdGclIN16lE7kJ+pVMjspOI+5+TqLRO6m0ZpNXJoZRv9MPDRcAfJUtNZHyig/s2wwReakFgPPJwCQmu1I30/tcBbji+Na53i1W1N+BqoY7Zxo+U/M9XyJ4Ok2SSkBtoOrwuhAY3a03Eu6l8wFdIG1cN+e8hopTkiKF093KuH/BcB39rMiGDLn6XVhGKEaaT/vqb/lufuAdpGExevF1+J9itkFhCfymWr9vGb3BTK4j598zRH7+e+MU9maruZqb0pkGxRDRE1CD4Z8LV4vhgPidk5w2Bq816g3nHw1//j3JStz7NR9HIWELO8TMn3QrP/zZp//+Dv9p429/ogv+GATR+n/UdF+ns9xNkXZQJXY4t9jMkJNUFygAtzndXwjss+yWH9HAnLQQfhAskdZS2l01HLWv7L7us5uTH409pqitvfSOQg/c+Zt7k879P3K9+WV68n7+3cZfuRd/dDPP/03rn+d+/nBvWfgDlt8+LzjqJ/vx3CnNOwiXhho778C96iD+1TBvRZYeP+EH81LE0vVwOOrmCLB3iKzI1x+vJEsrPH4uF0UB4TJ4X3uDfOCo3PYpYe0MF4bouh0DQ/l43fxUF7Y+dpWuvTSffB0yO2UQUETI/LwCZE3BvnevJ7c9zUlY3H58xzke6DNFDQG8n0WtDN4LAYN4nogKav1ezOfK/z+t6tsCTp+dhx4ymjWuCJk1dEUifDP+HyS4iP/Vg9B2jTo9L4NbiBuDS4nuuHW6H+JDQn2JtqRKGkEQPEYE7uzazXIkcxIAqUq1esasZBETlEZY7y7Jo+RoV/IsjY9eIMkUvr42Hc0xqtsavZvhz1OLwSxMOTuqzlhb0WbdOwBH9EYiyBjatz40bUxTHbiWxqJ0uma19qhPruvcWJlbiSSH48OLDDpaHPszvyct41ZfTu10+vjox6kOqK6v0K/gEPphEvMl/vwSv+A4Hhm36JSP9IXTyCZDm4kKsqD5ay8b1Sad/vaiyO5N/sDfEV6Z4q95E+yfjxpqBoBETW2C7xl4pIO2bDODDFurUPwE7EWC2Uplq+AHmBHvir2PSgkR12/Ry65O0aZtQPeXi9mTlF/Wj5GQ+vFkYyhXsLTjrBSP9hwk4GPqDP5rBn5/l8b0mLRAvRSzXHc293bs3s8EsdE3m2exxidWVB4joHR+S+dz5/W+v00K3TqN14CDBth8eWcsTbiwXPsygHdGid0PEdy6HHm2v/IUuV5RVapYmzGsX90mpnIdNGcOOq64Dbc5GUbYpD9M7S+6cLY//QmjxFLP5cuTFRm3vA5rkFZroFnO3bjHF35uU3s8mvL7Tp9nyTc4mymTJ5sLIp7umSnGkO23faehtz3mmTS7fbVx5rP7x3HXIjRNeq/A3xCs9JNB08c9S9BF2O3bOur0ItslFxXgRPdaapBIi4dRpKGxVz7ir69t/bc9qTxjvtOyGOfiLGDhR4fYywHv1WdOplxIV87TpLBy3Wc0QP0P9s4G7FBNOdITS/tep3o3h1TEa5XDDii7fWtqRzUEReP2fbxz7bHWWJdbIOxOUJZtItNZpTFRfj6vm9sYjRxQVO+WTdiOhdPeTJ+8YirPvoeL88l5iLYOHd3b/Imkq+1ZN1El3UikhftuteEYxf1Wujof8Pr4ICTu5ezZyZ4tHQMxlzUHLYO2VMOoNMGL/20S5i2o2obfk+8qqdR7xzbRDbgU0lnuIgz4LelQ5XS7xbLuSQtNS95v3ZUOdaUx/Qd8qxCt6xf2E62yb/HukLO6RyorV8KgYl5YNc75y+KvefrxY+lc/64y9kvWP0a0bDz/rojq+RWjO06WeruWqNFU7r3HPIcLWRql8ICZsz2Ls/qOm/CLn6++X+Qf7mGspYCrZod/lpl6Rw4xN/yuq8gqV4B6aHk1hVE1SfILxWu5gvXqbfARYQpspcxKp1F/c8XOPzkZvmoSw+vEqBLdrq1fr3wAPv5NnM9i8F+jdAuxkP5Z71c6uhK3enlnGymr7UsWZKC12qgUiG8XXGQ9mxnqz4GSIlybF9eXmbqj2sHX+a1jf0gRoONHRdRSrIq03Ty89eQ1GbV/Bk+du4+V15zls+vvERvZ4E7ZbnxWTVjDjb4o/k8jlw44pTIrUGxxuJvBeO+heuhOjpFsO6lVJ/aXnJDa/bM0Ql1cLbXE/Pbv3EZ3vj3iVrB5irjupZTzlnv677NrI9UNYNqbPgp/HZXS+lJmk87wec+7YOxTDo2aw2l3NfDr34VNlvqWJBknuK7oSlZ6/T10zuOoPZOeoIk81N+sL843WJ2Q4Z0fZ3scsqC/JV2fuhWi1jGURSKZV637lf53Xnnx16/vKEXY89aVJ0fv91jGdfG+G4+sniwHes4hS+udOr4RfhFhG/F5gUG35QaU+McuLmclb5ZWmR+sG5V6nf+PxYzlrnFGxpZaK8eqqVo0NfmAWoGfXDiT/FnUbWvzGDOTr8aktOZWg4BYvz5YH12ZbfCcGtNk+dDAZNGWvHov+PIOnY9Prjg8h/wLRrT69suaMVZ5bNuK00lSVpnqSX1NON/81FoP92rYndionwgOiA8WMf4vc8l15KqEEG4yAm2+WAN5Brfu1sq9suWYqgoajgOYt/JCk1gC8wPkK+XKCtRX6TAtgvrnuBgNRmn6I8lVDipOVB9kX6Oxkp4ZKyd1M6Gj8/v2U7k+YQBL95Kb9PQENucJb0JlW3b5tObN7m/Z1j1ev388d7o15zgXsI9CikAGAViR6lkJv7nb4Ak40M2G8TJ447kN+pvfHiOFjSUSP6PM+QfbAywKJCBaxSVxpizHseZUyUBhq59vFwrkyGoRiHbo0apweEZeSLuNiQ+HAekOnarFg00dZNXaPeoHPTRR0FmEyqYExOVaaaO8c0uFUh7U4e/UxdBmthlBDgg257Q33j1hA7HTxSeTTSuVnPZbgW1nodwmG16aKBDKxEetv7D9OjO0JhrbJTnoe+kcGoDJazFSO8/fUN9Jy/g4XK5PUkw2dgPDGpJqBfhe7GA+cjzfE/EGsMM+FV9nj9IAhrSfT/J3QE5TEIYyk5UjsI6ZZcCPr6A8FZUF4g9nnpVmjX90MLSQysIPD0nFzqwCcSJmIb5mYv2Cmk+C1MDFkZQyCBq4c/Yai9LJ6xYkGS/x2s5/frIW2vmG2Wrv0APpCdgCA9snFvfpe8uc0OwdRs4G9973PGEBnQB5qKrCQ6m6X/H7NInZ7y/1674/ZXOVp7OeuCRk8JFS516VHrnH1HkIUIlTIljjHaQtEtkJtosYul77cVwjk3gW1Ajaa6zWeyHGLlpk3VHE2VFzT2yI/EvlGUSz2H9zYE1s4nsKMtMqNyKNtL/59CpFJki5Fou6VXGm8vWATEPwrUVOLvoA8jLuwOzVBCgHB2Cr5V6OwEWtJEKokJkfc87h+sNHTvMb0KVTp5284QTPupoWvQVUwUeogZR3kBMESYo0mfukewRVPKh5+rzLQb7HKjFFIgWhj1w3yN/qCNoPI8XFiUgBNT1hCHBsAz8L7Oyt8wQWUFj92ONn/APyJFg8hzueqoJdNj57ROrFbffuS/XxrSXLTRgj5uxZjpgQYceeMc2wJrahReSKpm3QjHfqExTLAB2ipVumE8pqcZv8LYXQiPHHsgb5BMW8zM5pvQit+mQx8XGaVDcfVbLyMTlY8xcfmm/RSAT/H09UQol5gIz7rESDmnrQ4bURIB4iRXMDQwxgex1GgtDxKp2HayIkR+E/aDmCttNm2C6lytWdfOVzD6X2SpDWjQDlMRvAp1symWv4my1bPCD+E1EmGnMGWhNwmycJnDV2WrQNxO45ukEb08AAffizYKVULp15I4vbNK5DzWwCSUADfmKhfGSUqii1L2UsE8rB7mLuHuUJZOx4+WiizHBJ/hwboaBzhpNOVvgFTf5cJsHef7L1HCI9dOUUbb+YxUJWn6dYOLz+THi91kzY5dtO5c+grX7v0jEbsuoOGnoIreDIg/sFMyG+TyCLIcAWd1IZ1UNFxE8Uie13ucm40U2fcxC0u3WLvLOxwu+F7MWUsHsdtFQZ7W+nlfCASiAKyh8rnP3EyDByvtJb6Kax6/HkLzT9SyEyTMVM1zPtM0MJY14DmsWh4MgD15Ea9Hd00AdkTZ0EiG5NAGuIBzQJJ0JR0na+OB7lQA6UKxMfihIQ7GCCnVz694QvykWXTxpS2soDu+smru1UdIxSvAszBFD1c8c6ZOobA8bJiJIvuycgIXBQIXWwhyTgZDQxJTRXgEwRNAawGSXO0a1DKjdihLVNp/taE/xYhsgwe+VpKEEB4LlraQyE84gEihxCnbfoyOuJIEXy2FIYw+JjRusybKlU2g/vhTSGTydvCvXhYBdtAXtS2v7LkHtmXh/8fly1do8FI/D0f8UbzVb5h+KRhMGSAmR2mhi0YG/uj7wgxcfzCrMvdjitUIpXDX8ae2JcF/36qUWIMwN6JsjaRGNj+jEteGDcFyTUb8X/NHSucKMJp7pduxtD6KuxVlyxxwaeiC1FbGBESO84lbyrAugYxdl+2N8/6AgWpo/IeoAOcsG35IA/b3AuSyoa55L7llBLlaWlEWvuCFd8f8NfcTUgzJv6CbB+6ohWwodlk9nGWFpBAOaz5uEW5xBvmjnHFeDsb0mXwayj3mdYq5gxxNf3H3/tnCgHwjSrpSgVxLmiTtuszdRUFIsn6LiMPjL808vL1uQhDbM7aA43mISXReqjSskynIRcHCJ9qeFopJfx9tqyUoGbSwJex/0aDE3plBPGtNBYgWbdLom3+Q/bjdizR2/AS/c/dH/d3G7pyl1qDXgtOFtEqidwLqxPYtrNEveasWq3vPUUtqTeu8gpov4bdOQRI2kneFvRNMrShyVeEupK1PoLDPMSfWMIJcs267mGB8X9CehQCF0gIyhpP10mbyM7lwW1e6TGvHBV1sg/UyTghHPGRqMyaebC6pbB1WKNCQtlai1GGvmq9zUKaUzLaXsXEBYtHxmFbEZ2kJhR164LhWW2Tlp1dhsGE7ZgIWRBOx3Zcu2DxgH+G83WTPceKG0TgQKKiiNNOlWgvqNEbnrk6fVD+AqRam2OguZb0YWSTX88N+i/ELSxbaUUpPx4vJUzYg/WonSeA8xUK6u7DPHgpqWpEe6D4cXg5uK9FIYVba47V/nb+wyOtk+zG8RrS4EA0ouwa04iByRLSvoJA2FzaobbZtXnq8GdbfqEp5I2dpfpj59TCVif6+E75p665faiX8gS213RqBxTZqfHP46nF6NSenOneuT+vgbLUbdTH2/t0REFXZJOEB6DHvx6N6g9956CYrY/AYcm9gELJXYkrSi+0F0geKDZgOCIYkLU/+GOW5aGj8mvLFgtFH5+XC8hvAE3CvHRfl4ofM/Qwk4x2A+R+nyc9gNu/9Tem7XW4XRnyRymf52z09cTOdr+PG6+P/Vb4QiXlwauc5WB1z3o+IJjlbxI8MyWtSzT+k4sKVbhF3xa+vDts3NxXa87iiu+xRH9cAprnOL2h6vV54iQRXuOAj1s8nLFK8gZ70ThIQcWdF19/2xaJmT0efrkNDkWbpAQPdo92Z8+Hn/aLjbOzB9AI/k12fPs9HhUNDJ1u6ax2VxD3R6PywN7BrLJ26z6s3QoMp76qzzwetrDABKSGkfW5PwS1GvYNUbK6uRqxfyVGNyFB0E+OugMM8kKwmJmupuRWO8XkXXXQECyRVw9UyIrtCtcc4oNqXqr7AURBmKn6Khz3eBN96LwIJrAGP9mr/59uTOSx631suyT+QujDd4beUFpZ0kJEEnjlP+X/Kr2kCKhnENTg4BsMTOmMqlj2WMFLRUlVG0fzdCBgUta9odrJfpVdFomTi6ak0tFjXTcdqqvWBAzjY6hVrH9sbt3Z9gn+AVDpTcQImefbB4edirjzrsNievve4ZT4EUZWV3TxEsIW+9MT/RJoKfZZYSRGfC1CwPG/9rdMOM8qR/LUYvw5f/emUSoD7YSFuOoqchdUg2UePd1eCtFSKgxLSZ764oy4lvRCIH6bowPxZWwxNFctksLeil47pfevcBipkkBIc4ngZG+kxGZ71a72KQ7VaZ6MZOZkQJZXM6kb/Ac0/XkJx8dvyfJcWbI3zONEaEPIW8GbkYjsZcwy+eMoKrYjDmvEEixHzkCSCRPRzhOfJZuLdcbx19EL23MA8rnjTZZ787FGMnkqnpuzB5/90w1gtUSRaWcb0eta8198VEeZMUSfIhyuc4/nywFQ9uqn7jdqXh+5wwv+RK9XouNPbYdoEelNGo34KyySwigsrfCe0v/PlWPvQvQg8R0KgHO18mTVThhQrlbEQ0Kp/JxPdjHyR7E1QPw/ut0r+HDDG7BwZFm9IqEUZRpv2WpzlMkOemeLcAt5CsrzskLGaVOAxyySzZV/D2EY7ydNZMf8e8VhHcKGHAWNszf1EOq8fNstijMY4JXyATwTdncFFqcNDfDo+mWFvxJJpc4sEZtjXyBdoFcxbUmniCoKq5jydUHNjYJxMqN1KzYV62MugcELVhS3Bnd+TLLOh7dws/zSXWzxEb4Nj4aFun5x4kDWLK5TUF/yCXB/cZYvI9kPgVsG2jShtXkxfgT+xzjJofXqPEnIXIQ1lnIdmVzBOM90EXvJUW6a0nZ/7XjJGl8ToO3H/fdxnxmTNKBZxnkpXLVgLXCZywGT3YyS75w/PAH5I/jMuRspej8xZObU9kREbRA+kqjmKRFaKGWAmFQspC+QLbKPf0RaK3OXvBSWqo46p70ws/eZpu6jCtZUgQy6r4tHMPUdAgWGGUYNbuv/1a6K+MVFsd3T183+T8capSo6m0+Sh57fEeG/95dykGJBQMj09DSW2bY0mUonDy9a8trLnnL5B5LW3Nl8rJZNysO8Zb+80zXxqUGFpud3Qzwb7bf+8mq6x0TAnJU9pDQR9YQmZhlna2xuxJt0aCO/f1SU8gblOrbIyMsxTlVUW69VJPzYU2HlRXcqE2lLLxnObZuz2tT9CivfTAUYfmzJlt/lOPgsR6VN64/xQd4Jlk/RV7UKVv2Gx/AWsmTAuCWKhdwC+4HmKEKYZh2Xis4KsUR1BeObs1c13wqFRnocdmuheaTV30gvVXZcouzHKK5zwrN52jXJEuX6dGx3BCpV/++4f3hyaW/cQJLFKqasjsMuO3B3WlMq2gyYfdK1e7L2pO/tRye2mwzwZPfdUMrl5wdLqdd2Kv/wVtnpyWYhd49L6rsOV+8HXPrWH2Kup89l2tz6bf80iYSd+V4LROSOHeamvexR524q4r43rTmtFzQvArpvWfLYFZrbFspBsXNUqqenjxNNsFXatZvlIhk7teUPfK+YL32F8McTnjv0BZNppb+vshoCrtLXjIWq3EJXpVXIlG6ZNL0dh6qEm2WMwDjD3LfOfkGh1/czYc/0qhiD2ozNnH4882MVVt3JbVFkbwowNCO3KL5IoYW5wlVeGCViOuv1svZx7FbzxKzA4zGqBlRRaRWCobXaVq4yYCWbZf8eiJwt3OY+MFiSJengcFP2t0JMfzOiJ7cECvpx7neg1Rc5x+7myPJOXt2FohVRyXtD+/rDoTOyGYInJelZMjolecVHUhUNqvdZWg2J2t0jPmiLFeRD/8fOT4o+NGILb+TufCo9ceBBm3JLVn+MO2675n7qiEX/6W+188cYg3Zn5NSTjgOKfWFSAANa6raCxSoVU851oJLY11WIoYK0du0ec5E4tCnAPoKh71riTsjVIp3gKvBbEYQiNYrmH22oLQWA2AdwMnID6PX9b58dR2QKo4qag1D1Z+L/FwEKTR7osOZPWECPJIHQqPUsM5i/CH5YupVPfFA5pHUBcsesh8eO5YhyWnaVRPZn/BmdXVumZWPxMP5e28zm2uqHgFoT9CymHYNNrzrrjlXZM06HnzDxYNlI5b/QosxLmmrqDFqmogQdqk0WLkUceoAvQxHgkIyvWU69BPFr24VB6+lx75Rna6dGtrmOxDnvBojvi1/4dHjVeg8owofPe1cOnxU1ioh016s/Vudv9mhV9f35At+Sh28h1bpp8xhr09+vf47Elx3Ms6hyp6QvB3t0vnLbOhwo660cp7K0vvepabK7YJfxEWWfrC2YzJfYOjygPwfwd/1amTqa0hZ5ueebhWYVMubRTwIjj+0Oq0ohU3zfRfuL8gt59XsHdwKtxTQQ4Y2qz6gisxnm2UdlmpEkgOsZz7iEk6QOt8BuPwr+NR01LTqXmJo1C76o1N274twJvl+I069TiLpenK/miRxhyY8jvYV6W1WuSwhH9q7kuwnJMtm7IWcqs7HsnyHSqWXLSpYtZGaR1V3t0gauninFPZGtWskF65rtti48UV9uV9KM8kfDYs0pgB00S+TlzTXV6P8mxq15b9En8sz3jWSszcifZa/NuufPNnNTb031pptt0+sRSH/7UG8pzbsgtt3OG3ut7B9JzDMt2mTZuyRNIV8D54TuTrpNcHtgmMlYJeiY9XS83NYJicjRjtJSf9BZLsQv629QdDsKQhTK5CnXhpk7vMNkHzPhm0ExW/VCGApHfPyBagtZQTQmPHx7g5IXXsrQDPzIVhv2LB6Ih138iSDww1JNHrDvzUxvp73MsQBVhW8EbrReaVUcLB1R3PUXyaYG4HpJUcLVxMgDxcPkVRQpL7VTAGabDzbKcvg12t5P8TSGQkrj/gOrpnbiDHwluA73xbXts/L7u468cRWSWRtgTwlQnA47EKg0OiZDgFxAKQQUcsbGomITgeXUAAyKe03eA7Mp4gnyKQmm0LXJtEk6ddksMJCuxDmmHzmVhO+XaN2A54MIh3niw5CF7PwiXFZrnA8wOdeHLvvhdoqIDG9PDI7UnWWHq526T8y6ixJPhkuVKZnoUruOpUgOOp3iIKBjk+yi1vHo5cItHXb1PIKzGaZlRS0g5d3MV2pD8FQdGYLZ73aae/eEIUePMc4NFz8pIUfLCrrF4jVWH5gQneN3S8vANBmUXrEcKGn6hIUN95y1vpsvLwbGpzV9L0ZKTan6TDXM05236uLJcIEMKVAxKNT0K8WljuwNny3BNQRfzovA85beI9zr1AGNYnYCVkR1aGngWURUrgqR+gRrQhxW81l3CHevjvGEPzPMTxdsIfB9dfGRbZU0cg/1mcubtECX4tvaedmNAvTxCJtc2QaoUalGfENCGK7IS/O8CRpdOVca8EWCRwv2sSWE8CJPW5PCugjCXPd3h6U60cPD+bdhtXZuYB6stcoveE7Sm5MM2yvfUHXFSW7KzLmi7/EeEWL0wqcOH9MOSKjhCHHmw+JGLcYE/7SBZQCRggox0ZZTAxrlzNNXYXL5fNIjkdT4YMqVUz6p8YDt049v4OXGdg3qTrtLBUXOZf7ahPlZAY/O+7Sp0bvGSHdyQ8B1LOsplqMb9Se8VAE7gIdSZvxbRSrfl+Lk5Qaqi5QJceqjitdErcHXg/3MryljPSIAMaaloFm1cVwBJ8DNmkDqoGROSHFetrgjQ5CahuKkdH5pRPigMrgTtlFI8ufJPJSUlGgTjbBSvpRc0zypiUn6U5KZqcRoyrtzhmJ7/caeZkmVRwJQeLOG8LY6vP5ChpKhc8Js0El+n6FXqbx9ItdtLtYP92kKfaTLtCi8StLZdENJa9Ex1nOoz1kQ7qxoiZFKRyLf4O4CHRT0T/0W9F8epNKVoeyxUXhy3sQMMsJjQJEyMOjmOhMFgOmmlscV4eFi1CldU92yjwleirEKPW3bPAuEhRZV7JsKV3Lr5cETAiFuX5Nw5UlF7d2HZ96Bh0sgFIL5KGaKSoVYVlvdKpZJVP5+NZ7xDEkQhmDgsDKciazJCXJ6ZN2B3FY2f6VZyGl/t4aunGIAk/BHaS+i+SpdRfnB/OktOvyjinWNfM9Ksr6WwtCa1hCmeRI6icpFM4o8quCLsikU0tMoZI/9EqXRMpKGaWzofl4nQuVQm17d5fU5qXCQeCDqVaL9XJ9qJ08n3G3EFZS28SHEb3cdRBdtO0YcTzil3QknNKEe/smQ1fTb0XbpyNB5xAeuIlf+5KWlEY0DqJbsnzJlQxJPOVyHiKMx5Xu9FcEv1Fbg6Fhm4t+Jyy5JC1W3YO8dYLsO0PXPbxodBgttTbH3rt9Cp1lJIk2r3O1Zqu94eRbnIz2f50lWolYzuKsj4PMok4abHLO8NAC884hiXx5Fy5pWKO0bWL7uEGXaJCtznhP67SlQ4xjWIfgq6EpZ28QMtuZK7JC0RGbl9nA4XtFLug/NLMoH1pGt9IonAJqcEDLyH6TDROcbsmGPaGIxMo41IUAnQVPMPGByp4mOmh9ZQMkBAcksUK55LsZj7E5z5XuZoyWCKu6nHmDq22xI/9Z8YdxJy4kWpD16jLVrpwGLWfyOD0Wd+cBzFBxVaGv7S5k9qwh/5t/LQEXsRqI3Q9Rm3QIoaZW9GlsDaKOUyykyWuhNOprSEi0s1G4rgoiX1V743EELti+pJu5og6X0g6oTynUqlhH9k6ezyRi05NGZHz0nvp3HOJr7ebrAUFrDjbkFBObEvdQWkkUbL0pEvMU46X58vF9j9F3j6kpyetNUBItrEubW9ZvMPM4qNqLlsSBJqOH3XbNwv/cXDXNxN8iFLzUhteisYY+RlHYOuP29/Cb+L+xv+35Rv7xudnZ6ohK4cMPfCG8KI7dNmjNk/H4e84pOxn/sZHK9psfvj8ncA8qJz7O8xqbxESDivGJOZzF7o5PJLQ7g34qAWoyuA+x3btU98LT6ZyGyceIXjrqob2CAVql4VOTQPUQYvHV/g4zAuCZGvYQBtf0wmd5lilrvuEn1BXLny01B4h4SMDlYsnNpm9d7m9h578ufpef9Z4WplqWQvqo52fyUA7J24eZD5av6SyGIV9kpmHNqyvdfzcpEMw97BvknV2fq+MFHun9BT3Lsf8pbzvisWiIQvYkng+8Vxk1V+dli1u56kY50LRjaPdotvT5BwqtwyF+emo/z9J3yVUVGfKrxQtJMOAQWoQii/4dp9wgybSa5mkucmRLtEQZ/pz0tL/NVcgWAd95nEQ3Tg6tNbuyn3Iepz65L3huMUUBntllWuu4DbtOFSMSbpILV4fy6wlM0SOvi6CpLh81c1LreIvKd61uEWBcDw1lUBUW1I0Z+m/PaRlX+PQ/oxg0Ye6KUiIiTF4ADNk59Ydpt5/rkxmq9tV5Kcp/eQLUVVmBzQNVuytQCP6Ezd0G8eLxWyHpmZWJ3bAzkWTtg4lZlw42SQezEmiUPaJUuR/qklVA/87S4ArFCpALdY3QRdUw3G3XbWUp6aq9z0zUizcPa7351p9JXOZyfdZBFnqt90VzQndXB/mwf8LC9STj5kenVpNuqOQQP3mIRJj7eV21FxG8VAxKrEn3c+XfmZ800EPb9/5lIlijscUbB6da0RQaMook0zug1G0tKi/JBC4rw7/D3m4ARzAkzMcVrDcT2SyFtUdWAsFlsPDFqV3N+EjyXaoEePwroaZCiLqEzb8MW+PNE9TmTC01EzWli51PzZvUqkmyuROU+V6ik+Le/9qT6nwzUzf9tP68tYei0YaDGx6kAd7jn1cKqOCuYbiELH9zYqcc4MnRJjkeGiqaGwLImhyeKs+xKJMBlOJ05ow9gGCKZ1VpnMKoSCTbMS+X+23y042zOb5MtcY/6oBeAo1Vy89OTyhpavFP78jXCcFH0t7Gx24hMEOm2gsEfGabVpQgvFqbQKMsknFRRmuPHcZu0Su/WMFphZvB2r/EGbG72rpGGho3h+Msz0uGzJ7hNK2uqQiE1qmn0zgacKYYZBCqsxV+sjbpoVdSilW/b94n2xNb648VmNIoizqEWhBnsen+d0kbCPmRItfWqSBeOd9Wne3c6bcd6uvXOJ6WdiSsuXq0ndhqrQ4QoWUjCjYtZ0EAhnSOP1m44xkf0O7jXghrzSJWxP4a/t72jU29Vu2rvu4n7HfHkkmQOMGSS+NPeLGO5I73mC2B7+lMiBQQZRM9/9liLIfowupUFAbPBbR+lxDM6M8Ptgh1paJq5Rvs7yEuLQv/7d1oU2woFSb3FMPWQOKMuCuJ7pDDjpIclus5TeEoMBy2YdVB4fxmesaCeMNsEgTHKS5WDSGyNUOoEpcC2OFWtIRf0w27ck34/DjxRTVIcc9+kqZE6iMSiVDsiKdP/Xz5XfEhm/sBhO50p1rvJDlkyyxuJ9SPgs7YeUJBjXdeAkE+P9OQJm6SZnn1svcduI78dYmbkE2mtziPrcjVisXG78spLvbZaSFx/Rks9zP4LKn0Cdz/3JsetkT06A8f/yCgMO6Mb1Hme0JJ7b2wZz1qleqTuKBGokhPVUZ0dVu+tnQYNEY1fmkZSz6+EGZ5EzL7657mreZGR3jUfaEk458PDniBzsSmBKhDRzfXameryJv9/D5m6HIqZ0R+ouCE54Dzp4IJuuD1e4Dc5i+PpSORJfG23uVgqixAMDvchMR0nZdH5brclYwRoJRWv/rlxGRI5ffD5NPGmIDt7vDE1434pYdVZIFh89Bs94HGGJbTwrN8T6lh1HZFTOB4lWzWj6EVqxSMvC0/ljWBQ3F2kc/mO2b6tWonT2JEqEwFts8rz2h+oWNds9ceR2cb7zZvJTDppHaEhK5avWqsseWa2Dt5BBhabdWSktS80oMQrL4TvAM9b5HMmyDnO+OkkbMXfUJG7eXqTIG6lqSOEbqVR+qYdP7uWb57WEJqzyh411GAVsDinPs7KvUeXItlcMdOUWzXBH6zscymV1LLVCtc8IePojzXHF9m5b5zGwBRdzcyUJkiu938ApmAayRdJrX1PmVguWUvt2ThQ62czItTyWJMW2An/hdDfMK7SiFQlGIdAbltHz3ycoh7j9V7GxNWBpbtcSdqm4XxRwTawc3cbZ+xfSv9qQfEkDKfZTwCkqWGI/ur250ItXlMlh6vUNWEYIg9A3GzbgmbqvTN8js2YMo87CU5y6nZ4dbJLDQJj9fc7yM7tZzJDZFtqOcU8+mZjYlq4VmifI23iHb1ZoT9E+kT2dolnP1AfiOkt7PQCSykBiXy5mv637IegWSKj9IKrYZf4Lu9+I7ub+mkRdlvYzehh/jaJ9n7HUH5b2IbgeNdkY7wx1yVzxS7pbvky6+nmVUtRllEFfweUQ0/nG017WoUYSxs+j2B4FV/F62EtHlMWZXYrjGHpthnNb1x66LKZ0Qe92INWHdfR/vqp02wMS8r1G4dJqHok8KmQ7947G13a4YXbsGgHcBvRuVu1eAi4/A5+ZixmdSXM73LupB/LH7O9yxLTVXJTyBbI1S49TIROrfVCOb/czZ9pM4JsZx8kUz8dQGv7gUWKxXvTH7QM/3J2OuXXgciUhqY+cgtaOliQQVOYthBLV3xpESZT3rmfEYNZxmpBbb24CRao86prn+i9TNOh8VxRJGXJfXHATJHs1T5txgc/opYrY8XjlGQQbRcoxIBcnVsMjmU1ymmIUL4dviJXndMAJ0Yet+c7O52/p98ytlmAsGBaTAmMhimAnvp1TWNGM9BpuitGj+t810CU2UhorrjPKGtThVC8WaXw04WFnT5fTjqmPyrQ0tN3CkLsctVy2xr0ZWgiWVZ1OrlFjjxJYsOiZv2cAoOvE+7sY0I/TwWcZqMoyIKNOftwP7w++Rfg67ljfovKYa50if3fzE/8aPYVey/Nq35+nH2sLPh/fP5TsylSKGOZ4k69d2PnH43+kq++sRXHQqGArWdwhx+hpwQC6JgT2uxehYU4Zbw7oNb6/HLikPyJROGK2ouyr+vzseESp9G50T4AyFrSqOQ0rroCYP4sMDFBrHn342EyZTMlSyk47rHSq89Y9/nI3zG5lX16Z5lxphguLOcZUndL8wNcrkyjH82jqg8Bo8OYkynrxZvbFno5lUS3OPr8Ko3mX9NoRPdYOKKjD07bvgFgpZ/RF+YzkWvJ/Hs/tUbfeGzGWLxNAjfDzHHMVSDwB5SabQLsIZHiBp43FjGkaienYoDd18hu2BGwOK7U3o70K/WY/kuuKdmdrykIBUdG2mvE91L1JtTbh20mOLbk1vCAamu7utlXeGU2ooVikbU/actcgmsC1FKk2qmj3GWeIWbj4tGIxE7BLcBWUvvcnd/lYxsMV4F917fWeFB/XbINN3qGvIyTpCalz1lVewdIGqeAS/gB8Mi+sA+BqDiX3VGD2eUunTRbSY+AuDy4E3Qx3hAhwnSXX+B0zuj3eQ1miS8Vux2z/l6/BkWtjKGU72aJkOCWhGcSf3+kFkkB15vGOsQrSdFr6qTj0gBYiOlnBO41170gOWHSUoBVRU2JjwppYdhIFDfu7tIRHccSNM5KZOFDPz0TGMAjzzEpeLwTWp+kn201kU6NjbiMQJx83+LX1e1tZ10kuChJZ/XBUQ1dwaBHjTDJDqOympEk8X2M3VtVw21JksChA8w1tTefO3RJ1FMbqZ01bHHkudDB/OhLfe7P5GOHaI28ZXKTMuqo0hLWQ4HabBsGG7NbP1RiXtETz074er6w/OerJWEqjmkq2y51q1BVI+JUudnVa3ogBpzdhFE7fC7kybrAt2Z6RqDjATAUEYeYK45WMupBKQRtQlU+uNsjnzj6ZmGrezA+ASrWxQ6LMkHRXqXwNq7ftv28dUx/ZSJciDXP2SWJsWaN0FjPX9Yko6LobZ7aYW/IdUktI9apTLyHS8DyWPyuoZyxN1TK/vtfxk3HwWh6JczZC8Ftn0bIJay2g+n5wd7lm9rEsKO+svqVmi+c1j88hSCxbzrg4+HEP0Nt1/B6YW1XVm09T1CpAKjc9n18hjqsaFGdfyva1ZG0Xu3ip6N6JGpyTSqY5h4BOlpLPaOnyw45PdXTN+DtAKg7DLrLFTnWusoSBHk3s0d7YouJHq85/R09Tfc37ENXZF48eAYLnq9GLioNcwDZrC6FW6godB8JnqYUPvn0pWLfQz0lM0Yy8Mybgn84Ds3Q9bDP10bLyOV+qzxa4Rd9Dhu7cju8mMaONXK3UqmBQ9qIg7etIwEqM/kECk/Dzja4Bs1xR+Q/tCbc8IKrSGsTdJJ0vge7IG20W687uVmK6icWQ6cD3lwFzgNMGtFvO5qyJeKflGLAAcQZOrkxVwy3cWvqlGpvjmf9Qe6Ap20MPbV92DPV0OhFM4kz8Yr0ffC2zLWSQ1kqY6QdQrttR3kh1YLtQd1kCEv5hVoPIRWl5ERcUTttBIrWp6Xs5Ehh5OUUwI5aEBvuiDmUoENmnVw1FohCrbRp1A1E+XSlWVOTi7ADW+5Ohb9z1vK4qx5R5lPdGCPBJZ00mC+Ssp8VUbgpGAvXWMuWQQRbCqI6Rr2jtxZxtfP7W/8onz+yz0Gs76LaT5HX9ecyiZCB/ZR/gFtMxPsDwohoeCRtiuLxE1GM1vUEUgBv86+eehL58/P56QFGQ/MqOe/vC76L63jzmeax4exd/OKTUvkXg+fOJUHych9xt/9goJMrapSgvXrj8+8vk/N80f22Sewj6cyGqt1B6mztoeklVHHraouhvHJaG/OuBz6DHKMpFmQULU1bRWlyYE0RPXYYkUycIemN7TLtgNCJX6BqdyxDKkegO7nJK5xQ7OVYDZTMf9bVHidtk6DQX9Et+V9M7esgbsYBdEeUpsB0Xvw2kd9+rI7V+m47u+O/tq7mw7262HU1WlS9uFzsV6JxIHNmUCy0QS9e077JGRFbG65z3/dOKB/Zk+yDdKpUmdXjn/aS3N5nv4fK7bMHHmPlHd4E2+iTbV5rpzScRnxk6KARuDTJ8Q1LpK2mP8gj1EbuJ9RIyY+EWK4hCiIDBAS1Tm2IEXAFfgKPgdL9O6mAa06wjCcUAL6EsxPQWO9VNegBPm/0GgkZbDxCynxujX/92vmGcjZRMAY45puak2sFLCLSwXpEsyy5fnF0jGJBhm+fNSHKKUUfy+276A7/feLOFxxUuHRNJI2Osenxyvf8DAGObT60pfTTlhEg9u/KKkhJqm5U1/+BEcSkpFDA5XeCqxwXmPac1jcuZ3JWQ+p0NdWzb/5v1ZvF8GtMTFFEdQjpLO0bwPb0BHNWnip3liDXI2fXf05jjvfJ0NpjLCUgfTh9CMFYVFKEd4Z/OG/2C+N435mnK+9t1gvCiVcaaH7rK4+PjCvpVNiz+t2QyqH1O8x3JKZVl6Q+Lp/XK8wMjVMslOq9FdSw5FtUs/CptXH9PW+wbWHgrV17R5jTVOtGtKFu3nb80T+E0tv9QkzW3J2dbaw/8ddAKZ0pxIaEqLjlPrji3VgJ3GvdFvlqD8075woxh4fVt0JZE0KVFsAvqhe0dqN9b35jtSpnYMXkU+vZq+IAHad3IHc2s/LYrnD1anfG46IFiMIr9oNbZDWvwthqYNqOigaKd/XlLU4XHfk/PXIjPsLy/9/kAtQ+/wKH+hI/IROWj5FPvTZAT9f7j4ZXQyG4M0TujMAFXYkKvEHv1xhySekgXGGqNxWeWKlf8dDAlLuB1cb/qOD+rk7cmwt+1yKpk9cudqBanTi6zTbXRtV8qylNtjyOVKy1HTz0GW9rjt6sSjAZcT5R+KdtyYb0zyqG9pSLuCw5WBwAn7fjBjKLLoxLXMI+52L9cLwIR2B6OllJZLHJ8vDxmWdtF+QJnmt1rsHPIWY20lftk8fYePkAIg6Hgn532QoIpegMxiWgAOfe5/U44APR8Ac0NeZrVh3gEhs12W+tVSiWiUQekf/YBECUy5fdYbA08dd7VzPAP9aiVcIB9k6tY7WdJ1wNV+bHeydNtmC6G5ICtFC1ZwmJU/j8hf0I8TRVKSiz5oYIa93EpUI78X8GYIAZabx47/n8LDAAJ0nNtP1rpROprqKMBRecShca6qXuTSI3jZBLOB3Vp381B5rCGhjSvh/NSVkYp2qIdP/Bg=";
            /***/ },
            /***/ 50227: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/ var data = __webpack_require__(99373);
                exports.init = function() {
                    exports.dictionary = data.init();
                };
                exports.offsetsByLength = new Uint32Array([
                    0,
                    0,
                    0,
                    0,
                    0,
                    4096,
                    9216,
                    21504,
                    35840,
                    44032,
                    53248,
                    63488,
                    74752,
                    87040,
                    93696,
                    100864,
                    104704,
                    106752,
                    108928,
                    113536,
                    115968,
                    118528,
                    119872,
                    121280,
                    122016
                ]);
                exports.sizeBitsByLength = new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    10,
                    10,
                    11,
                    11,
                    10,
                    10,
                    10,
                    10,
                    10,
                    9,
                    9,
                    8,
                    7,
                    7,
                    8,
                    7,
                    7,
                    6,
                    6,
                    5,
                    5
                ]);
                exports.minDictionaryWordLength = 4;
                exports.maxDictionaryWordLength = 24;
            /***/ },
            /***/ 33535: /***/ function(__unused_webpack_module, exports) {
                function HuffmanCode(bits, value) {
                    this.bits = bits; /* number of bits used for this symbol */ 
                    this.value = value; /* symbol value or table offset */ 
                }
                exports.h = HuffmanCode;
                var MAX_LENGTH = 15;
                /* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function GetNextKey(key, len) {
                    var step = 1 << len - 1;
                    while(key & step)step >>= 1;
                    return (key & step - 1) + step;
                }
                /* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function ReplicateValue(table, i, step, end, code) {
                    do {
                        end -= step;
                        table[i + end] = new HuffmanCode(code.bits, code.value);
                    }while (end > 0);
                }
                /* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function NextTableBitSize(count, len, root_bits) {
                    var left = 1 << len - root_bits;
                    while(len < MAX_LENGTH){
                        left -= count[len];
                        if (left <= 0) break;
                        ++len;
                        left <<= 1;
                    }
                    return len - root_bits;
                }
                exports.g = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
                    var start_table = table;
                    var code; /* current table entry */ 
                    var len; /* current code length */ 
                    var symbol; /* symbol index in original or sorted table */ 
                    var key; /* reversed prefix code */ 
                    var step; /* step size to replicate values in current table */ 
                    var low; /* low bits for current root entry */ 
                    var mask; /* mask for low bits */ 
                    var table_bits; /* key length of current table */ 
                    var table_size; /* size of current table */ 
                    var total_size; /* sum of root table size and 2nd level table sizes */ 
                    var sorted; /* symbols sorted by code length */ 
                    var count = new Int32Array(MAX_LENGTH + 1); /* number of codes of each length */ 
                    var offset = new Int32Array(MAX_LENGTH + 1); /* offsets in sorted table for each length */ 
                    sorted = new Int32Array(code_lengths_size);
                    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
                    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
                    for(len = 1; len < MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
                    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
                    table_bits = root_bits;
                    table_size = 1 << table_bits;
                    total_size = table_size;
                    /* special case code with only one value */ if (offset[MAX_LENGTH] === 1) {
                        for(key = 0; key < total_size; ++key)root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
                        return total_size;
                    }
                    /* fill in root table */ key = 0;
                    symbol = 0;
                    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
                        code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
                        ReplicateValue(root_table, table + key, step, table_size, code);
                        key = GetNextKey(key, len);
                    }
                    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
                    low = -1;
                    for(len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
                        if ((key & mask) !== low) {
                            table += table_size;
                            table_bits = NextTableBitSize(count, len, root_bits);
                            table_size = 1 << table_bits;
                            total_size += table_size;
                            low = key & mask;
                            root_table[start_table + low] = new HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
                        }
                        code = new HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
                        ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
                        key = GetNextKey(key, len);
                    }
                    return total_size;
                };
            /***/ },
            /***/ 4008: /***/ function(__unused_webpack_module, exports) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ function PrefixCodeRange(offset, nbits) {
                    this.offset = offset;
                    this.nbits = nbits;
                }
                exports.kBlockLengthPrefixCode = [
                    new PrefixCodeRange(1, 2),
                    new PrefixCodeRange(5, 2),
                    new PrefixCodeRange(9, 2),
                    new PrefixCodeRange(13, 2),
                    new PrefixCodeRange(17, 3),
                    new PrefixCodeRange(25, 3),
                    new PrefixCodeRange(33, 3),
                    new PrefixCodeRange(41, 3),
                    new PrefixCodeRange(49, 4),
                    new PrefixCodeRange(65, 4),
                    new PrefixCodeRange(81, 4),
                    new PrefixCodeRange(97, 4),
                    new PrefixCodeRange(113, 5),
                    new PrefixCodeRange(145, 5),
                    new PrefixCodeRange(177, 5),
                    new PrefixCodeRange(209, 5),
                    new PrefixCodeRange(241, 6),
                    new PrefixCodeRange(305, 6),
                    new PrefixCodeRange(369, 7),
                    new PrefixCodeRange(497, 8),
                    new PrefixCodeRange(753, 9),
                    new PrefixCodeRange(1265, 10),
                    new PrefixCodeRange(2289, 11),
                    new PrefixCodeRange(4337, 12),
                    new PrefixCodeRange(8433, 13),
                    new PrefixCodeRange(16625, 24)
                ];
                exports.kInsertLengthPrefixCode = [
                    new PrefixCodeRange(0, 0),
                    new PrefixCodeRange(1, 0),
                    new PrefixCodeRange(2, 0),
                    new PrefixCodeRange(3, 0),
                    new PrefixCodeRange(4, 0),
                    new PrefixCodeRange(5, 0),
                    new PrefixCodeRange(6, 1),
                    new PrefixCodeRange(8, 1),
                    new PrefixCodeRange(10, 2),
                    new PrefixCodeRange(14, 2),
                    new PrefixCodeRange(18, 3),
                    new PrefixCodeRange(26, 3),
                    new PrefixCodeRange(34, 4),
                    new PrefixCodeRange(50, 4),
                    new PrefixCodeRange(66, 5),
                    new PrefixCodeRange(98, 5),
                    new PrefixCodeRange(130, 6),
                    new PrefixCodeRange(194, 7),
                    new PrefixCodeRange(322, 8),
                    new PrefixCodeRange(578, 9),
                    new PrefixCodeRange(1090, 10),
                    new PrefixCodeRange(2114, 12),
                    new PrefixCodeRange(6210, 14),
                    new PrefixCodeRange(22594, 24)
                ];
                exports.kCopyLengthPrefixCode = [
                    new PrefixCodeRange(2, 0),
                    new PrefixCodeRange(3, 0),
                    new PrefixCodeRange(4, 0),
                    new PrefixCodeRange(5, 0),
                    new PrefixCodeRange(6, 0),
                    new PrefixCodeRange(7, 0),
                    new PrefixCodeRange(8, 0),
                    new PrefixCodeRange(9, 0),
                    new PrefixCodeRange(10, 1),
                    new PrefixCodeRange(12, 1),
                    new PrefixCodeRange(14, 2),
                    new PrefixCodeRange(18, 2),
                    new PrefixCodeRange(22, 3),
                    new PrefixCodeRange(30, 3),
                    new PrefixCodeRange(38, 4),
                    new PrefixCodeRange(54, 4),
                    new PrefixCodeRange(70, 5),
                    new PrefixCodeRange(102, 5),
                    new PrefixCodeRange(134, 6),
                    new PrefixCodeRange(198, 7),
                    new PrefixCodeRange(326, 8),
                    new PrefixCodeRange(582, 9),
                    new PrefixCodeRange(1094, 10),
                    new PrefixCodeRange(2118, 24)
                ];
                exports.kInsertRangeLut = [
                    0,
                    0,
                    8,
                    8,
                    0,
                    16,
                    8,
                    16,
                    16
                ];
                exports.kCopyRangeLut = [
                    0,
                    8,
                    0,
                    8,
                    16,
                    0,
                    16,
                    8,
                    16
                ];
            /***/ },
            /***/ 46170: /***/ function(__unused_webpack_module, exports) {
                function BrotliInput(buffer) {
                    this.buffer = buffer;
                    this.pos = 0;
                }
                BrotliInput.prototype.read = function(buf, i, count) {
                    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
                    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
                    this.pos += count;
                    return count;
                };
                exports.g = BrotliInput;
                function BrotliOutput(buf) {
                    this.buffer = buf;
                    this.pos = 0;
                }
                BrotliOutput.prototype.write = function(buf, count) {
                    if (this.pos + count > this.buffer.length) throw new Error("Output buffer is not large enough");
                    this.buffer.set(buf.subarray(0, count), this.pos);
                    this.pos += count;
                    return count;
                };
                exports.j = BrotliOutput;
            /***/ },
            /***/ 22906: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var BrotliDictionary = __webpack_require__(50227);
                var kIdentity = 0;
                var kOmitLast1 = 1;
                var kOmitLast2 = 2;
                var kOmitLast3 = 3;
                var kOmitLast4 = 4;
                var kOmitLast5 = 5;
                var kOmitLast6 = 6;
                var kOmitLast7 = 7;
                var kOmitLast8 = 8;
                var kOmitLast9 = 9;
                var kUppercaseFirst = 10;
                var kUppercaseAll = 11;
                var kOmitFirst1 = 12;
                var kOmitFirst2 = 13;
                var kOmitFirst3 = 14;
                var kOmitFirst4 = 15;
                var kOmitFirst5 = 16;
                var kOmitFirst6 = 17;
                var kOmitFirst7 = 18;
                var kOmitFirst8 = 19;
                var kOmitFirst9 = 20;
                function Transform(prefix, transform, suffix) {
                    this.prefix = new Uint8Array(prefix.length);
                    this.transform = transform;
                    this.suffix = new Uint8Array(suffix.length);
                    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
                    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
                }
                var kTransforms = [
                    new Transform("", kIdentity, ""),
                    new Transform("", kIdentity, " "),
                    new Transform(" ", kIdentity, " "),
                    new Transform("", kOmitFirst1, ""),
                    new Transform("", kUppercaseFirst, " "),
                    new Transform("", kIdentity, " the "),
                    new Transform(" ", kIdentity, ""),
                    new Transform("s ", kIdentity, " "),
                    new Transform("", kIdentity, " of "),
                    new Transform("", kUppercaseFirst, ""),
                    new Transform("", kIdentity, " and "),
                    new Transform("", kOmitFirst2, ""),
                    new Transform("", kOmitLast1, ""),
                    new Transform(", ", kIdentity, " "),
                    new Transform("", kIdentity, ", "),
                    new Transform(" ", kUppercaseFirst, " "),
                    new Transform("", kIdentity, " in "),
                    new Transform("", kIdentity, " to "),
                    new Transform("e ", kIdentity, " "),
                    new Transform("", kIdentity, '"'),
                    new Transform("", kIdentity, "."),
                    new Transform("", kIdentity, '">'),
                    new Transform("", kIdentity, "\n"),
                    new Transform("", kOmitLast3, ""),
                    new Transform("", kIdentity, "]"),
                    new Transform("", kIdentity, " for "),
                    new Transform("", kOmitFirst3, ""),
                    new Transform("", kOmitLast2, ""),
                    new Transform("", kIdentity, " a "),
                    new Transform("", kIdentity, " that "),
                    new Transform(" ", kUppercaseFirst, ""),
                    new Transform("", kIdentity, ". "),
                    new Transform(".", kIdentity, ""),
                    new Transform(" ", kIdentity, ", "),
                    new Transform("", kOmitFirst4, ""),
                    new Transform("", kIdentity, " with "),
                    new Transform("", kIdentity, "'"),
                    new Transform("", kIdentity, " from "),
                    new Transform("", kIdentity, " by "),
                    new Transform("", kOmitFirst5, ""),
                    new Transform("", kOmitFirst6, ""),
                    new Transform(" the ", kIdentity, ""),
                    new Transform("", kOmitLast4, ""),
                    new Transform("", kIdentity, ". The "),
                    new Transform("", kUppercaseAll, ""),
                    new Transform("", kIdentity, " on "),
                    new Transform("", kIdentity, " as "),
                    new Transform("", kIdentity, " is "),
                    new Transform("", kOmitLast7, ""),
                    new Transform("", kOmitLast1, "ing "),
                    new Transform("", kIdentity, "\n	"),
                    new Transform("", kIdentity, ":"),
                    new Transform(" ", kIdentity, ". "),
                    new Transform("", kIdentity, "ed "),
                    new Transform("", kOmitFirst9, ""),
                    new Transform("", kOmitFirst7, ""),
                    new Transform("", kOmitLast6, ""),
                    new Transform("", kIdentity, "("),
                    new Transform("", kUppercaseFirst, ", "),
                    new Transform("", kOmitLast8, ""),
                    new Transform("", kIdentity, " at "),
                    new Transform("", kIdentity, "ly "),
                    new Transform(" the ", kIdentity, " of "),
                    new Transform("", kOmitLast5, ""),
                    new Transform("", kOmitLast9, ""),
                    new Transform(" ", kUppercaseFirst, ", "),
                    new Transform("", kUppercaseFirst, '"'),
                    new Transform(".", kIdentity, "("),
                    new Transform("", kUppercaseAll, " "),
                    new Transform("", kUppercaseFirst, '">'),
                    new Transform("", kIdentity, '="'),
                    new Transform(" ", kIdentity, "."),
                    new Transform(".com/", kIdentity, ""),
                    new Transform(" the ", kIdentity, " of the "),
                    new Transform("", kUppercaseFirst, "'"),
                    new Transform("", kIdentity, ". This "),
                    new Transform("", kIdentity, ","),
                    new Transform(".", kIdentity, " "),
                    new Transform("", kUppercaseFirst, "("),
                    new Transform("", kUppercaseFirst, "."),
                    new Transform("", kIdentity, " not "),
                    new Transform(" ", kIdentity, '="'),
                    new Transform("", kIdentity, "er "),
                    new Transform(" ", kUppercaseAll, " "),
                    new Transform("", kIdentity, "al "),
                    new Transform(" ", kUppercaseAll, ""),
                    new Transform("", kIdentity, "='"),
                    new Transform("", kUppercaseAll, '"'),
                    new Transform("", kUppercaseFirst, ". "),
                    new Transform(" ", kIdentity, "("),
                    new Transform("", kIdentity, "ful "),
                    new Transform(" ", kUppercaseFirst, ". "),
                    new Transform("", kIdentity, "ive "),
                    new Transform("", kIdentity, "less "),
                    new Transform("", kUppercaseAll, "'"),
                    new Transform("", kIdentity, "est "),
                    new Transform(" ", kUppercaseFirst, "."),
                    new Transform("", kUppercaseAll, '">'),
                    new Transform(" ", kIdentity, "='"),
                    new Transform("", kUppercaseFirst, ","),
                    new Transform("", kIdentity, "ize "),
                    new Transform("", kUppercaseAll, "."),
                    new Transform("\xc2\xa0", kIdentity, ""),
                    new Transform(" ", kIdentity, ","),
                    new Transform("", kUppercaseFirst, '="'),
                    new Transform("", kUppercaseAll, '="'),
                    new Transform("", kIdentity, "ous "),
                    new Transform("", kUppercaseAll, ", "),
                    new Transform("", kUppercaseFirst, "='"),
                    new Transform(" ", kUppercaseFirst, ","),
                    new Transform(" ", kUppercaseAll, '="'),
                    new Transform(" ", kUppercaseAll, ", "),
                    new Transform("", kUppercaseAll, ","),
                    new Transform("", kUppercaseAll, "("),
                    new Transform("", kUppercaseAll, ". "),
                    new Transform(" ", kUppercaseAll, "."),
                    new Transform("", kUppercaseAll, "='"),
                    new Transform(" ", kUppercaseAll, ". "),
                    new Transform(" ", kUppercaseFirst, '="'),
                    new Transform(" ", kUppercaseAll, "='"),
                    new Transform(" ", kUppercaseFirst, "='")
                ];
                exports.kTransforms = kTransforms;
                exports.kNumTransforms = kTransforms.length;
                function ToUpperCase(p, i) {
                    if (p[i] < 0xc0) {
                        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
                        return 1;
                    }
                    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
                        p[i + 1] ^= 32;
                        return 2;
                    }
                    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
                    return 3;
                }
                exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
                    var prefix = kTransforms[transform].prefix;
                    var suffix = kTransforms[transform].suffix;
                    var t = kTransforms[transform].transform;
                    var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
                    var i = 0;
                    var start_idx = idx;
                    var uppercase;
                    if (skip > len) skip = len;
                    var prefix_pos = 0;
                    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
                    word += skip;
                    len -= skip;
                    if (t <= kOmitLast9) len -= t;
                    for(i = 0; i < len; i++)dst[idx++] = BrotliDictionary.dictionary[word + i];
                    uppercase = idx - len;
                    if (t === kUppercaseFirst) ToUpperCase(dst, uppercase);
                    else if (t === kUppercaseAll) while(len > 0){
                        var step = ToUpperCase(dst, uppercase);
                        uppercase += step;
                        len -= step;
                    }
                    var suffix_pos = 0;
                    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
                    return idx - start_idx;
                };
            /***/ },
            /***/ 49435: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                module1.exports = __webpack_require__(17217).BrotliDecompressBuffer;
            /***/ },
            /***/ 30539: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                /* provided dependency */ var process = __webpack_require__(82530);
                /* eslint camelcase: "off" */ var assert = __webpack_require__(76118);
                var Zstream = __webpack_require__(28755);
                var zlib_deflate = __webpack_require__(24349);
                var zlib_inflate = __webpack_require__(3386);
                var constants = __webpack_require__(40549);
                for(var key in constants)exports[key] = constants[key];
                // zlib modes
                exports.NONE = 0;
                exports.DEFLATE = 1;
                exports.INFLATE = 2;
                exports.GZIP = 3;
                exports.GUNZIP = 4;
                exports.DEFLATERAW = 5;
                exports.INFLATERAW = 6;
                exports.UNZIP = 7;
                var GZIP_HEADER_ID1 = 0x1f;
                var GZIP_HEADER_ID2 = 0x8b;
                /**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function Zlib(mode) {
                    if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
                    this.dictionary = null;
                    this.err = 0;
                    this.flush = 0;
                    this.init_done = false;
                    this.level = 0;
                    this.memLevel = 0;
                    this.mode = mode;
                    this.strategy = 0;
                    this.windowBits = 0;
                    this.write_in_progress = false;
                    this.pending_close = false;
                    this.gzip_id_bytes_read = 0;
                }
                Zlib.prototype.close = function() {
                    if (this.write_in_progress) {
                        this.pending_close = true;
                        return;
                    }
                    this.pending_close = false;
                    assert(this.init_done, "close before init");
                    assert(this.mode <= exports.UNZIP);
                    if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
                    else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
                    this.mode = exports.NONE;
                    this.dictionary = null;
                };
                Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
                    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
                };
                Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
                    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
                };
                Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
                    assert.equal(arguments.length, 8);
                    assert(this.init_done, "write before init");
                    assert(this.mode !== exports.NONE, "already finalized");
                    assert.equal(false, this.write_in_progress, "write already in progress");
                    assert.equal(false, this.pending_close, "close is pending");
                    this.write_in_progress = true;
                    assert.equal(false, flush === undefined, "must provide flush value");
                    this.write_in_progress = true;
                    if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
                    if (input == null) {
                        input = Buffer.alloc(0);
                        in_len = 0;
                        in_off = 0;
                    }
                    this.strm.avail_in = in_len;
                    this.strm.input = input;
                    this.strm.next_in = in_off;
                    this.strm.avail_out = out_len;
                    this.strm.output = out;
                    this.strm.next_out = out_off;
                    this.flush = flush;
                    if (!async) {
                        // sync version
                        this._process();
                        if (this._checkError()) return this._afterSync();
                        return;
                    }
                    // async version
                    var self1 = this;
                    process.nextTick(function() {
                        self1._process();
                        self1._after();
                    });
                    return this;
                };
                Zlib.prototype._afterSync = function() {
                    var avail_out = this.strm.avail_out;
                    var avail_in = this.strm.avail_in;
                    this.write_in_progress = false;
                    return [
                        avail_in,
                        avail_out
                    ];
                };
                Zlib.prototype._process = function() {
                    var next_expected_header_byte = null;
                    // If the avail_out is left at 0, then it means that it ran out
                    // of room.  If there was avail_out left over, then it means
                    // that all of the input was consumed.
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.GZIP:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflate(this.strm, this.flush);
                            break;
                        case exports.UNZIP:
                            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                            switch(this.gzip_id_bytes_read){
                                case 0:
                                    if (next_expected_header_byte === null) break;
                                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                                        this.gzip_id_bytes_read = 1;
                                        next_expected_header_byte++;
                                        if (this.strm.avail_in === 1) break;
                                    } else {
                                        this.mode = exports.INFLATE;
                                        break;
                                    }
                                // fallthrough
                                case 1:
                                    if (next_expected_header_byte === null) break;
                                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                                        this.gzip_id_bytes_read = 2;
                                        this.mode = exports.GUNZIP;
                                    } else // There is no actual difference between INFLATE and INFLATERAW
                                    // (after initialization).
                                    this.mode = exports.INFLATE;
                                    break;
                                default:
                                    throw new Error("invalid number of gzip magic number bytes read");
                            }
                        // fallthrough
                        case exports.INFLATE:
                        case exports.GUNZIP:
                        case exports.INFLATERAW:
                            this.err = zlib_inflate.inflate(this.strm, this.flush);
                            if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                                // Load it
                                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                                if (this.err === exports.Z_OK) // And try to decode again
                                this.err = zlib_inflate.inflate(this.strm, this.flush);
                                else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                                // Make it possible for After() to tell a bad dictionary from bad
                                // input.
                                this.err = exports.Z_NEED_DICT;
                            }
                            while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                                // Bytes remain in input buffer. Perhaps this is another compressed
                                // member in the same archive, or just trailing garbage.
                                // Trailing zero bytes are okay, though, since they are frequently
                                // used for padding.
                                this.reset();
                                this.err = zlib_inflate.inflate(this.strm, this.flush);
                            }
                            break;
                        default:
                            throw new Error("Unknown mode " + this.mode);
                    }
                };
                Zlib.prototype._checkError = function() {
                    // Acceptable error states depend on the type of zlib stream.
                    switch(this.err){
                        case exports.Z_OK:
                        case exports.Z_BUF_ERROR:
                            if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                                this._error("unexpected end of file");
                                return false;
                            }
                            break;
                        case exports.Z_STREAM_END:
                            break;
                        case exports.Z_NEED_DICT:
                            if (this.dictionary == null) this._error("Missing dictionary");
                            else this._error("Bad dictionary");
                            return false;
                        default:
                            // something else.
                            this._error("Zlib error");
                            return false;
                    }
                    return true;
                };
                Zlib.prototype._after = function() {
                    if (!this._checkError()) return;
                    var avail_out = this.strm.avail_out;
                    var avail_in = this.strm.avail_in;
                    this.write_in_progress = false;
                    // call the write() cb
                    this.callback(avail_in, avail_out);
                    if (this.pending_close) this.close();
                };
                Zlib.prototype._error = function(message) {
                    if (this.strm.msg) message = this.strm.msg;
                    this.onerror(message, this.err);
                    this.write_in_progress = false;
                    if (this.pending_close) this.close();
                };
                Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
                    assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
                    assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
                    assert(level >= -1 && level <= 9, "invalid compression level");
                    assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
                    assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
                    this._init(level, windowBits, memLevel, strategy, dictionary);
                    this._setDictionary();
                };
                Zlib.prototype.params = function() {
                    throw new Error("deflateParams Not supported");
                };
                Zlib.prototype.reset = function() {
                    this._reset();
                    this._setDictionary();
                };
                Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
                    this.level = level;
                    this.windowBits = windowBits;
                    this.memLevel = memLevel;
                    this.strategy = strategy;
                    this.flush = exports.Z_NO_FLUSH;
                    this.err = exports.Z_OK;
                    if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
                    if (this.mode === exports.UNZIP) this.windowBits += 32;
                    if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
                    this.strm = new Zstream();
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.GZIP:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                            break;
                        case exports.INFLATE:
                        case exports.GUNZIP:
                        case exports.INFLATERAW:
                        case exports.UNZIP:
                            this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                            break;
                        default:
                            throw new Error("Unknown mode " + this.mode);
                    }
                    if (this.err !== exports.Z_OK) this._error("Init error");
                    this.dictionary = dictionary;
                    this.write_in_progress = false;
                    this.init_done = true;
                };
                Zlib.prototype._setDictionary = function() {
                    if (this.dictionary == null) return;
                    this.err = exports.Z_OK;
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                            break;
                        default:
                            break;
                    }
                    if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
                };
                Zlib.prototype._reset = function() {
                    this.err = exports.Z_OK;
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.DEFLATERAW:
                        case exports.GZIP:
                            this.err = zlib_deflate.deflateReset(this.strm);
                            break;
                        case exports.INFLATE:
                        case exports.INFLATERAW:
                        case exports.GUNZIP:
                            this.err = zlib_inflate.inflateReset(this.strm);
                            break;
                        default:
                            break;
                    }
                    if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
                };
                exports.Zlib = Zlib;
            /***/ },
            /***/ 63339: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                var Buffer = __webpack_require__(43060).Buffer;
                var Transform = __webpack_require__(20202).Transform;
                var binding = __webpack_require__(30539);
                var util = __webpack_require__(85663);
                var assert = __webpack_require__(76118).ok;
                var kMaxLength = __webpack_require__(43060).kMaxLength;
                var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes";
                // zlib doesn't provide these, so kludge them in following the same
                // const naming scheme zlib uses.
                binding.Z_MIN_WINDOWBITS = 8;
                binding.Z_MAX_WINDOWBITS = 15;
                binding.Z_DEFAULT_WINDOWBITS = 15;
                // fewer than 64 bytes per chunk is stupid.
                // technically it could work with as few as 8, but even 64 bytes
                // is absurdly low.  Usually a MB or more is best.
                binding.Z_MIN_CHUNK = 64;
                binding.Z_MAX_CHUNK = Infinity;
                binding.Z_DEFAULT_CHUNK = 16384;
                binding.Z_MIN_MEMLEVEL = 1;
                binding.Z_MAX_MEMLEVEL = 9;
                binding.Z_DEFAULT_MEMLEVEL = 8;
                binding.Z_MIN_LEVEL = -1;
                binding.Z_MAX_LEVEL = 9;
                binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
                // expose all the zlib constants
                var bkeys = Object.keys(binding);
                for(var bk = 0; bk < bkeys.length; bk++){
                    var bkey = bkeys[bk];
                    if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
                        enumerable: true,
                        value: binding[bkey],
                        writable: false
                    });
                }
                // translation table for return codes.
                var codes = {
                    Z_OK: binding.Z_OK,
                    Z_STREAM_END: binding.Z_STREAM_END,
                    Z_NEED_DICT: binding.Z_NEED_DICT,
                    Z_ERRNO: binding.Z_ERRNO,
                    Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
                    Z_DATA_ERROR: binding.Z_DATA_ERROR,
                    Z_MEM_ERROR: binding.Z_MEM_ERROR,
                    Z_BUF_ERROR: binding.Z_BUF_ERROR,
                    Z_VERSION_ERROR: binding.Z_VERSION_ERROR
                };
                var ckeys = Object.keys(codes);
                for(var ck = 0; ck < ckeys.length; ck++){
                    var ckey = ckeys[ck];
                    codes[codes[ckey]] = ckey;
                }
                Object.defineProperty(exports, "codes", {
                    enumerable: true,
                    value: Object.freeze(codes),
                    writable: false
                });
                exports.Deflate = Deflate;
                exports.Inflate = Inflate;
                exports.Gzip = Gzip;
                exports.Gunzip = Gunzip;
                exports.DeflateRaw = DeflateRaw;
                exports.InflateRaw = InflateRaw;
                exports.Unzip = Unzip;
                exports.createDeflate = function(o) {
                    return new Deflate(o);
                };
                exports.createInflate = function(o) {
                    return new Inflate(o);
                };
                exports.createDeflateRaw = function(o) {
                    return new DeflateRaw(o);
                };
                exports.createInflateRaw = function(o) {
                    return new InflateRaw(o);
                };
                exports.createGzip = function(o) {
                    return new Gzip(o);
                };
                exports.createGunzip = function(o) {
                    return new Gunzip(o);
                };
                exports.createUnzip = function(o) {
                    return new Unzip(o);
                };
                // Convenience methods.
                // compress/decompress a string or buffer in one step.
                exports.deflate = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Deflate(opts), buffer, callback);
                };
                exports.deflateSync = function(buffer, opts) {
                    return zlibBufferSync(new Deflate(opts), buffer);
                };
                exports.gzip = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Gzip(opts), buffer, callback);
                };
                exports.gzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Gzip(opts), buffer);
                };
                exports.deflateRaw = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new DeflateRaw(opts), buffer, callback);
                };
                exports.deflateRawSync = function(buffer, opts) {
                    return zlibBufferSync(new DeflateRaw(opts), buffer);
                };
                exports.unzip = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Unzip(opts), buffer, callback);
                };
                exports.unzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Unzip(opts), buffer);
                };
                exports.inflate = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Inflate(opts), buffer, callback);
                };
                exports.inflateSync = function(buffer, opts) {
                    return zlibBufferSync(new Inflate(opts), buffer);
                };
                exports.gunzip = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Gunzip(opts), buffer, callback);
                };
                exports.gunzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Gunzip(opts), buffer);
                };
                exports.inflateRaw = function(buffer, opts, callback) {
                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new InflateRaw(opts), buffer, callback);
                };
                exports.inflateRawSync = function(buffer, opts) {
                    return zlibBufferSync(new InflateRaw(opts), buffer);
                };
                function zlibBuffer(engine, buffer, callback) {
                    var buffers = [];
                    var nread = 0;
                    engine.on("error", onError);
                    engine.on("end", onEnd);
                    engine.end(buffer);
                    flow();
                    function flow() {
                        var chunk;
                        while(null !== (chunk = engine.read())){
                            buffers.push(chunk);
                            nread += chunk.length;
                        }
                        engine.once("readable", flow);
                    }
                    function onError(err) {
                        engine.removeListener("end", onEnd);
                        engine.removeListener("readable", flow);
                        callback(err);
                    }
                    function onEnd() {
                        var buf;
                        var err = null;
                        if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
                        else buf = Buffer.concat(buffers, nread);
                        buffers = [];
                        engine.close();
                        callback(err, buf);
                    }
                }
                function zlibBufferSync(engine, buffer) {
                    if (typeof buffer === "string") buffer = Buffer.from(buffer);
                    if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
                    var flushFlag = engine._finishFlushFlag;
                    return engine._processChunk(buffer, flushFlag);
                }
                // generic zlib
                // minimal 2-byte header
                function Deflate(opts) {
                    if (!(this instanceof Deflate)) return new Deflate(opts);
                    Zlib.call(this, opts, binding.DEFLATE);
                }
                function Inflate(opts) {
                    if (!(this instanceof Inflate)) return new Inflate(opts);
                    Zlib.call(this, opts, binding.INFLATE);
                }
                // gzip - bigger header, same deflate compression
                function Gzip(opts) {
                    if (!(this instanceof Gzip)) return new Gzip(opts);
                    Zlib.call(this, opts, binding.GZIP);
                }
                function Gunzip(opts) {
                    if (!(this instanceof Gunzip)) return new Gunzip(opts);
                    Zlib.call(this, opts, binding.GUNZIP);
                }
                // raw - no header
                function DeflateRaw(opts) {
                    if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
                    Zlib.call(this, opts, binding.DEFLATERAW);
                }
                function InflateRaw(opts) {
                    if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
                    Zlib.call(this, opts, binding.INFLATERAW);
                }
                // auto-detect header.
                function Unzip(opts) {
                    if (!(this instanceof Unzip)) return new Unzip(opts);
                    Zlib.call(this, opts, binding.UNZIP);
                }
                function isValidFlushFlag(flag) {
                    return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
                }
                // the Zlib class they all inherit from
                // This thing manages the queue of requests, and returns
                // true or false if there is anything in the queue when
                // you call the .write() method.
                function Zlib(opts, mode) {
                    var _this = this;
                    this._opts = opts = opts || {};
                    this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
                    Transform.call(this, opts);
                    if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
                    if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
                    this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
                    this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding.Z_FINISH;
                    if (opts.chunkSize) {
                        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
                    }
                    if (opts.windowBits) {
                        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
                    }
                    if (opts.level) {
                        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
                    }
                    if (opts.memLevel) {
                        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
                    }
                    if (opts.strategy) {
                        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
                    }
                    if (opts.dictionary) {
                        if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
                    }
                    this._handle = new binding.Zlib(mode);
                    var self1 = this;
                    this._hadError = false;
                    this._handle.onerror = function(message, errno) {
                        // there is no way to cleanly recover.
                        // continuing only obscures problems.
                        _close(self1);
                        self1._hadError = true;
                        var error = new Error(message);
                        error.errno = errno;
                        error.code = exports.codes[errno];
                        self1.emit("error", error);
                    };
                    var level = exports.Z_DEFAULT_COMPRESSION;
                    if (typeof opts.level === "number") level = opts.level;
                    var strategy = exports.Z_DEFAULT_STRATEGY;
                    if (typeof opts.strategy === "number") strategy = opts.strategy;
                    this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
                    this._buffer = Buffer.allocUnsafe(this._chunkSize);
                    this._offset = 0;
                    this._level = level;
                    this._strategy = strategy;
                    this.once("end", this.close);
                    Object.defineProperty(this, "_closed", {
                        get: function() {
                            return !_this._handle;
                        },
                        configurable: true,
                        enumerable: true
                    });
                }
                util.inherits(Zlib, Transform);
                Zlib.prototype.params = function(level, strategy, callback) {
                    if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
                    if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
                    if (this._level !== level || this._strategy !== strategy) {
                        var self1 = this;
                        this.flush(binding.Z_SYNC_FLUSH, function() {
                            assert(self1._handle, "zlib binding closed");
                            self1._handle.params(level, strategy);
                            if (!self1._hadError) {
                                self1._level = level;
                                self1._strategy = strategy;
                                if (callback) callback();
                            }
                        });
                    } else process.nextTick(callback);
                };
                Zlib.prototype.reset = function() {
                    assert(this._handle, "zlib binding closed");
                    return this._handle.reset();
                };
                // This is the _flush function called by the transform class,
                // internally, when the last chunk has been written.
                Zlib.prototype._flush = function(callback) {
                    this._transform(Buffer.alloc(0), "", callback);
                };
                Zlib.prototype.flush = function(kind, callback) {
                    var _this2 = this;
                    var ws = this._writableState;
                    if (typeof kind === "function" || kind === undefined && !callback) {
                        callback = kind;
                        kind = binding.Z_FULL_FLUSH;
                    }
                    if (ws.ended) {
                        if (callback) process.nextTick(callback);
                    } else if (ws.ending) {
                        if (callback) this.once("end", callback);
                    } else if (ws.needDrain) {
                        if (callback) this.once("drain", function() {
                            return _this2.flush(kind, callback);
                        });
                    } else {
                        this._flushFlag = kind;
                        this.write(Buffer.alloc(0), "", callback);
                    }
                };
                Zlib.prototype.close = function(callback) {
                    _close(this, callback);
                    process.nextTick(emitCloseNT, this);
                };
                function _close(engine, callback) {
                    if (callback) process.nextTick(callback);
                    // Caller may invoke .close after a zlib error (which will null _handle).
                    if (!engine._handle) return;
                    engine._handle.close();
                    engine._handle = null;
                }
                function emitCloseNT(self1) {
                    self1.emit("close");
                }
                Zlib.prototype._transform = function(chunk, encoding, cb) {
                    var flushFlag;
                    var ws = this._writableState;
                    var ending = ws.ending || ws.ended;
                    var last = ending && (!chunk || ws.length === chunk.length);
                    if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
                    if (!this._handle) return cb(new Error("zlib binding closed"));
                    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
                    // (or whatever flag was provided using opts.finishFlush).
                    // If it's explicitly flushing at some other time, then we use
                    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
                    // goodness.
                    if (last) flushFlag = this._finishFlushFlag;
                    else {
                        flushFlag = this._flushFlag;
                        // once we've flushed the last of the queue, stop flushing and
                        // go back to the normal behavior.
                        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
                    }
                    this._processChunk(chunk, flushFlag, cb);
                };
                Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
                    var availInBefore = chunk && chunk.length;
                    var availOutBefore = this._chunkSize - this._offset;
                    var inOff = 0;
                    var self1 = this;
                    var async = typeof cb === "function";
                    if (!async) {
                        var buffers = [];
                        var nread = 0;
                        var error;
                        this.on("error", function(er) {
                            error = er;
                        });
                        assert(this._handle, "zlib binding closed");
                        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
                        while (!this._hadError && callback(res[0], res[1]));
                        if (this._hadError) throw error;
                        if (nread >= kMaxLength) {
                            _close(this);
                            throw new RangeError(kRangeErrorMessage);
                        }
                        var buf = Buffer.concat(buffers, nread);
                        _close(this);
                        return buf;
                    }
                    assert(this._handle, "zlib binding closed");
                    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
                    req.buffer = chunk;
                    req.callback = callback;
                    function callback(availInAfter, availOutAfter) {
                        // When the callback is used in an async write, the callback's
                        // context is the `req` object that was created. The req object
                        // is === this._handle, and that's why it's important to null
                        // out the values after they are done being used. `this._handle`
                        // can stay in memory longer than the callback and buffer are needed.
                        if (this) {
                            this.buffer = null;
                            this.callback = null;
                        }
                        if (self1._hadError) return;
                        var have = availOutBefore - availOutAfter;
                        assert(have >= 0, "have should not go down");
                        if (have > 0) {
                            var out = self1._buffer.slice(self1._offset, self1._offset + have);
                            self1._offset += have;
                            // serve some output to the consumer.
                            if (async) self1.push(out);
                            else {
                                buffers.push(out);
                                nread += out.length;
                            }
                        }
                        // exhausted the output buffer, or used all the input create a new one.
                        if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                            availOutBefore = self1._chunkSize;
                            self1._offset = 0;
                            self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
                        }
                        if (availOutAfter === 0) {
                            // Not actually done.  Need to reprocess.
                            // Also, update the availInBefore to the availInAfter value,
                            // so that if we have to hit it a third (fourth, etc.) time,
                            // it'll have the correct byte counts.
                            inOff += availInBefore - availInAfter;
                            availInBefore = availInAfter;
                            if (!async) return true;
                            var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                            newReq.callback = callback; // this same function
                            newReq.buffer = chunk;
                            return;
                        }
                        if (!async) return false;
                        // finished with the chunk.
                        cb();
                    }
                };
                util.inherits(Deflate, Zlib);
                util.inherits(Inflate, Zlib);
                util.inherits(Gzip, Zlib);
                util.inherits(Gunzip, Zlib);
                util.inherits(DeflateRaw, Zlib);
                util.inherits(InflateRaw, Zlib);
                util.inherits(Unzip, Zlib);
            /***/ },
            /***/ 97615: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(31801);
                var callBind = __webpack_require__(12550);
                var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
                module1.exports = function callBoundIntrinsic(name, allowMissing) {
                    var intrinsic = GetIntrinsic(name, !!allowMissing);
                    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
                    return intrinsic;
                };
            /***/ },
            /***/ 12550: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(21930);
                var GetIntrinsic = __webpack_require__(31801);
                var setFunctionLength = __webpack_require__(34521);
                var $TypeError = GetIntrinsic("%TypeError%");
                var $apply = GetIntrinsic("%Function.prototype.apply%");
                var $call = GetIntrinsic("%Function.prototype.call%");
                var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
                var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
                var $max = GetIntrinsic("%Math.max%");
                if ($defineProperty) try {
                    $defineProperty({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    // IE 8 has a broken defineProperty
                    $defineProperty = null;
                }
                module1.exports = function callBind(originalFunction) {
                    if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
                    var func = $reflectApply(bind, $call, arguments);
                    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
                };
                var applyBind = function applyBind() {
                    return $reflectApply(bind, $apply, arguments);
                };
                if ($defineProperty) $defineProperty(module1.exports, "apply", {
                    value: applyBind
                });
                else module1.exports.apply = applyBind;
            /***/ },
            /***/ 72986: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                var clone = function() {
                    "use strict";
                    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/ function clone(parent, circular, depth, prototype) {
                        var filter;
                        if (typeof circular === "object") {
                            depth = circular.depth;
                            prototype = circular.prototype;
                            filter = circular.filter;
                            circular = circular.circular;
                        }
                        // maintain two arrays for circular references, where corresponding parents
                        // and children have the same index
                        var allParents = [];
                        var allChildren = [];
                        var useBuffer = typeof Buffer != "undefined";
                        if (typeof circular == "undefined") circular = true;
                        if (typeof depth == "undefined") depth = Infinity;
                        // recurse this function so we don't reset allParents and allChildren
                        function _clone(parent, depth) {
                            // cloning null always returns null
                            if (parent === null) return null;
                            if (depth == 0) return parent;
                            var child;
                            var proto;
                            if (typeof parent != "object") return parent;
                            if (clone.__isArray(parent)) child = [];
                            else if (clone.__isRegExp(parent)) {
                                child = new RegExp(parent.source, __getRegExpFlags(parent));
                                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                            else if (useBuffer && Buffer.isBuffer(parent)) {
                                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                                child = Buffer.allocUnsafe(parent.length);
                                else // Older Node.js versions
                                child = new Buffer(parent.length);
                                parent.copy(child);
                                return child;
                            } else if (typeof prototype == "undefined") {
                                proto = Object.getPrototypeOf(parent);
                                child = Object.create(proto);
                            } else {
                                child = Object.create(prototype);
                                proto = prototype;
                            }
                            if (circular) {
                                var index = allParents.indexOf(parent);
                                if (index != -1) return allChildren[index];
                                allParents.push(parent);
                                allChildren.push(child);
                            }
                            for(var i in parent){
                                var attrs;
                                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                                if (attrs && attrs.set == null) continue;
                                child[i] = _clone(parent[i], depth - 1);
                            }
                            return child;
                        }
                        return _clone(parent, depth);
                    }
                    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                        if (parent === null) return null;
                        var c = function() {};
                        c.prototype = parent;
                        return new c();
                    };
                    // private utility functions
                    function __objToStr(o) {
                        return Object.prototype.toString.call(o);
                    }
                    clone.__objToStr = __objToStr;
                    function __isDate(o) {
                        return typeof o === "object" && __objToStr(o) === "[object Date]";
                    }
                    clone.__isDate = __isDate;
                    function __isArray(o) {
                        return typeof o === "object" && __objToStr(o) === "[object Array]";
                    }
                    clone.__isArray = __isArray;
                    function __isRegExp(o) {
                        return typeof o === "object" && __objToStr(o) === "[object RegExp]";
                    }
                    clone.__isRegExp = __isRegExp;
                    function __getRegExpFlags(re) {
                        var flags = "";
                        if (re.global) flags += "g";
                        if (re.ignoreCase) flags += "i";
                        if (re.multiline) flags += "m";
                        return flags;
                    }
                    clone.__getRegExpFlags = __getRegExpFlags;
                    return clone;
                }();
                if (0, module1.exports) module1.exports = clone;
            /***/ },
            /***/ 67367: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                __webpack_require__(19457);
                var path = __webpack_require__(67290);
                module1.exports = path.Object.values;
            /***/ },
            /***/ 55047: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                __webpack_require__(55739);
                __webpack_require__(54883);
                __webpack_require__(10853);
                __webpack_require__(35054);
                __webpack_require__(12382);
                __webpack_require__(487);
                __webpack_require__(27138);
                __webpack_require__(45007);
                var path = __webpack_require__(67290);
                module1.exports = path.Promise;
            /***/ },
            /***/ 46121: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var parent = __webpack_require__(80623);
                __webpack_require__(85506);
                // TODO: Remove from `core-js@4`
                __webpack_require__(38634);
                __webpack_require__(8108);
                __webpack_require__(67298);
                module1.exports = parent;
            /***/ },
            /***/ 97676: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isCallable = __webpack_require__(75277);
                var tryToString = __webpack_require__(28768);
                var TypeError1 = global.TypeError;
                // `Assert: IsCallable(argument) is true`
                module1.exports = function(argument) {
                    if (isCallable(argument)) return argument;
                    throw TypeError1(tryToString(argument) + " is not a function");
                };
            /***/ },
            /***/ 43327: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isConstructor = __webpack_require__(31536);
                var tryToString = __webpack_require__(28768);
                var TypeError1 = global.TypeError;
                // `Assert: IsConstructor(argument) is true`
                module1.exports = function(argument) {
                    if (isConstructor(argument)) return argument;
                    throw TypeError1(tryToString(argument) + " is not a constructor");
                };
            /***/ },
            /***/ 75017: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isCallable = __webpack_require__(75277);
                var String1 = global.String;
                var TypeError1 = global.TypeError;
                module1.exports = function(argument) {
                    if (typeof argument == "object" || isCallable(argument)) return argument;
                    throw TypeError1("Can't set " + String1(argument) + " as a prototype");
                };
            /***/ },
            /***/ 6677: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(52280);
                var create = __webpack_require__(51569);
                var definePropertyModule = __webpack_require__(86385);
                var UNSCOPABLES = wellKnownSymbol("unscopables");
                var ArrayPrototype = Array.prototype;
                // Array.prototype[@@unscopables]
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                if (ArrayPrototype[UNSCOPABLES] == undefined) definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
                    configurable: true,
                    value: create(null)
                });
                // add a key to Array.prototype[@@unscopables]
                module1.exports = function(key) {
                    ArrayPrototype[UNSCOPABLES][key] = true;
                };
            /***/ },
            /***/ 13350: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__(91140).charAt;
                // `AdvanceStringIndex` abstract operation
                // https://tc39.es/ecma262/#sec-advancestringindex
                module1.exports = function(S, index, unicode) {
                    return index + (unicode ? charAt(S, index).length : 1);
                };
            /***/ },
            /***/ 9519: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isPrototypeOf = __webpack_require__(32010);
                var TypeError1 = global.TypeError;
                module1.exports = function(it, Prototype) {
                    if (isPrototypeOf(Prototype, it)) return it;
                    throw TypeError1("Incorrect invocation");
                };
            /***/ },
            /***/ 83875: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isObject = __webpack_require__(52786);
                var String1 = global.String;
                var TypeError1 = global.TypeError;
                // `Assert: Type(argument) is Object`
                module1.exports = function(argument) {
                    if (isObject(argument)) return argument;
                    throw TypeError1(String1(argument) + " is not an object");
                };
            /***/ },
            /***/ 28794: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toObject = __webpack_require__(30744);
                var toAbsoluteIndex = __webpack_require__(32565);
                var lengthOfArrayLike = __webpack_require__(47046);
                var min = Math.min;
                // `Array.prototype.copyWithin` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.copywithin
                // eslint-disable-next-line es/no-array-prototype-copywithin -- safe
                module1.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
                    var O = toObject(this);
                    var len = lengthOfArrayLike(O);
                    var to = toAbsoluteIndex(target, len);
                    var from = toAbsoluteIndex(start, len);
                    var end = arguments.length > 2 ? arguments[2] : undefined;
                    var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
                    var inc = 1;
                    if (from < to && to < from + count) {
                        inc = -1;
                        from += count - 1;
                        to += count - 1;
                    }
                    while(count-- > 0){
                        if (from in O) O[to] = O[from];
                        else delete O[to];
                        to += inc;
                        from += inc;
                    }
                    return O;
                };
            /***/ },
            /***/ 55522: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toObject = __webpack_require__(30744);
                var toAbsoluteIndex = __webpack_require__(32565);
                var lengthOfArrayLike = __webpack_require__(47046);
                // `Array.prototype.fill` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.fill
                module1.exports = function fill(value /* , start = 0, end = @length */ ) {
                    var O = toObject(this);
                    var length = lengthOfArrayLike(O);
                    var argumentsLength = arguments.length;
                    var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
                    var end = argumentsLength > 2 ? arguments[2] : undefined;
                    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
                    while(endPos > index)O[index++] = value;
                    return O;
                };
            /***/ },
            /***/ 20379: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $forEach = __webpack_require__(68671).forEach;
                var arrayMethodIsStrict = __webpack_require__(54324);
                var STRICT_METHOD = arrayMethodIsStrict("forEach");
                // `Array.prototype.forEach` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.foreach
                module1.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
                    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                // eslint-disable-next-line es/no-array-prototype-foreach -- safe
                } : [].forEach;
            /***/ },
            /***/ 65626: /***/ function(module1) {
                module1.exports = function(Constructor, list) {
                    var index = 0;
                    var length = list.length;
                    var result = new Constructor(length);
                    while(length > index)result[index] = list[index++];
                    return result;
                };
            /***/ },
            /***/ 84899: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var bind = __webpack_require__(98166);
                var call = __webpack_require__(79611);
                var toObject = __webpack_require__(30744);
                var callWithSafeIterationClosing = __webpack_require__(9637);
                var isArrayIteratorMethod = __webpack_require__(68089);
                var isConstructor = __webpack_require__(31536);
                var lengthOfArrayLike = __webpack_require__(47046);
                var createProperty = __webpack_require__(35039);
                var getIterator = __webpack_require__(11805);
                var getIteratorMethod = __webpack_require__(77193);
                var Array1 = global.Array;
                // `Array.from` method implementation
                // https://tc39.es/ecma262/#sec-array.from
                module1.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
                    var O = toObject(arrayLike);
                    var IS_CONSTRUCTOR = isConstructor(this);
                    var argumentsLength = arguments.length;
                    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
                    var iteratorMethod = getIteratorMethod(O);
                    var index = 0;
                    var length, result, step, iterator, next, value;
                    // if the target is not iterable or it's an array with the default iterator - use a simple case
                    if (iteratorMethod && !(this == Array1 && isArrayIteratorMethod(iteratorMethod))) {
                        iterator = getIterator(O, iteratorMethod);
                        next = iterator.next;
                        result = IS_CONSTRUCTOR ? new this() : [];
                        for(; !(step = call(next, iterator)).done; index++){
                            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                                step.value,
                                index
                            ], true) : step.value;
                            createProperty(result, index, value);
                        }
                    } else {
                        length = lengthOfArrayLike(O);
                        result = IS_CONSTRUCTOR ? new this(length) : Array1(length);
                        for(; length > index; index++){
                            value = mapping ? mapfn(O[index], index) : O[index];
                            createProperty(result, index, value);
                        }
                    }
                    result.length = index;
                    return result;
                };
            /***/ },
            /***/ 37190: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toIndexedObject = __webpack_require__(29580);
                var toAbsoluteIndex = __webpack_require__(32565);
                var lengthOfArrayLike = __webpack_require__(47046);
                // `Array.prototype.{ indexOf, includes }` methods implementation
                var createMethod = function(IS_INCLUDES) {
                    return function($this, el, fromIndex) {
                        var O = toIndexedObject($this);
                        var length = lengthOfArrayLike(O);
                        var index = toAbsoluteIndex(fromIndex, length);
                        var value;
                        // Array#includes uses SameValueZero equality algorithm
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (IS_INCLUDES && el != el) while(length > index){
                            value = O[index++];
                            // eslint-disable-next-line no-self-compare -- NaN check
                            if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                        }
                        else for(; length > index; index++){
                            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                        }
                        return !IS_INCLUDES && -1;
                    };
                };
                module1.exports = {
                    // `Array.prototype.includes` method
                    // https://tc39.es/ecma262/#sec-array.prototype.includes
                    includes: createMethod(true),
                    // `Array.prototype.indexOf` method
                    // https://tc39.es/ecma262/#sec-array.prototype.indexof
                    indexOf: createMethod(false)
                };
            /***/ },
            /***/ 68671: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var bind = __webpack_require__(98166);
                var uncurryThis = __webpack_require__(88697);
                var IndexedObject = __webpack_require__(78609);
                var toObject = __webpack_require__(30744);
                var lengthOfArrayLike = __webpack_require__(47046);
                var arraySpeciesCreate = __webpack_require__(80150);
                var push = uncurryThis([].push);
                // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
                var createMethod = function(TYPE) {
                    var IS_MAP = TYPE == 1;
                    var IS_FILTER = TYPE == 2;
                    var IS_SOME = TYPE == 3;
                    var IS_EVERY = TYPE == 4;
                    var IS_FIND_INDEX = TYPE == 6;
                    var IS_FILTER_REJECT = TYPE == 7;
                    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
                    return function($this, callbackfn, that, specificCreate) {
                        var O = toObject($this);
                        var self1 = IndexedObject(O);
                        var boundFunction = bind(callbackfn, that);
                        var length = lengthOfArrayLike(self1);
                        var index = 0;
                        var create = specificCreate || arraySpeciesCreate;
                        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
                        var value, result;
                        for(; length > index; index++)if (NO_HOLES || index in self1) {
                            value = self1[index];
                            result = boundFunction(value, index, O);
                            if (TYPE) {
                                if (IS_MAP) target[index] = result; // map
                                else if (result) switch(TYPE){
                                    case 3:
                                        return true; // some
                                    case 5:
                                        return value; // find
                                    case 6:
                                        return index; // findIndex
                                    case 2:
                                        push(target, value); // filter
                                }
                                else switch(TYPE){
                                    case 4:
                                        return false; // every
                                    case 7:
                                        push(target, value); // filterReject
                                }
                            }
                        }
                        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
                    };
                };
                module1.exports = {
                    // `Array.prototype.forEach` method
                    // https://tc39.es/ecma262/#sec-array.prototype.foreach
                    forEach: createMethod(0),
                    // `Array.prototype.map` method
                    // https://tc39.es/ecma262/#sec-array.prototype.map
                    map: createMethod(1),
                    // `Array.prototype.filter` method
                    // https://tc39.es/ecma262/#sec-array.prototype.filter
                    filter: createMethod(2),
                    // `Array.prototype.some` method
                    // https://tc39.es/ecma262/#sec-array.prototype.some
                    some: createMethod(3),
                    // `Array.prototype.every` method
                    // https://tc39.es/ecma262/#sec-array.prototype.every
                    every: createMethod(4),
                    // `Array.prototype.find` method
                    // https://tc39.es/ecma262/#sec-array.prototype.find
                    find: createMethod(5),
                    // `Array.prototype.findIndex` method
                    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
                    findIndex: createMethod(6),
                    // `Array.prototype.filterReject` method
                    // https://github.com/tc39/proposal-array-filtering
                    filterReject: createMethod(7)
                };
            /***/ },
            /***/ 27837: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-array-prototype-lastindexof -- safe */ var apply = __webpack_require__(63530);
                var toIndexedObject = __webpack_require__(29580);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var lengthOfArrayLike = __webpack_require__(47046);
                var arrayMethodIsStrict = __webpack_require__(54324);
                var min = Math.min;
                var $lastIndexOf = [].lastIndexOf;
                var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [
                    1
                ].lastIndexOf(1, -0) < 0;
                var STRICT_METHOD = arrayMethodIsStrict("lastIndexOf");
                var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
                // `Array.prototype.lastIndexOf` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.lastindexof
                module1.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
                    // convert -0 to +0
                    if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
                    var O = toIndexedObject(this);
                    var length = lengthOfArrayLike(O);
                    var index = length - 1;
                    if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
                    if (index < 0) index = length + index;
                    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
                    return -1;
                } : $lastIndexOf;
            /***/ },
            /***/ 82091: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                var wellKnownSymbol = __webpack_require__(52280);
                var V8_VERSION = __webpack_require__(11197);
                var SPECIES = wellKnownSymbol("species");
                module1.exports = function(METHOD_NAME) {
                    // We can't use this feature detection in V8 since it causes
                    // deoptimization and serious performance degradation
                    // https://github.com/zloirock/core-js/issues/677
                    return V8_VERSION >= 51 || !fails(function() {
                        var array = [];
                        var constructor = array.constructor = {};
                        constructor[SPECIES] = function() {
                            return {
                                foo: 1
                            };
                        };
                        return array[METHOD_NAME](Boolean).foo !== 1;
                    });
                };
            /***/ },
            /***/ 54324: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(79044);
                module1.exports = function(METHOD_NAME, argument) {
                    var method = [][METHOD_NAME];
                    return !!method && fails(function() {
                        // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
                        method.call(null, argument || function() {
                            throw 1;
                        }, 1);
                    });
                };
            /***/ },
            /***/ 86596: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var aCallable = __webpack_require__(97676);
                var toObject = __webpack_require__(30744);
                var IndexedObject = __webpack_require__(78609);
                var lengthOfArrayLike = __webpack_require__(47046);
                var TypeError1 = global.TypeError;
                // `Array.prototype.{ reduce, reduceRight }` methods implementation
                var createMethod = function(IS_RIGHT) {
                    return function(that, callbackfn, argumentsLength, memo) {
                        aCallable(callbackfn);
                        var O = toObject(that);
                        var self1 = IndexedObject(O);
                        var length = lengthOfArrayLike(O);
                        var index = IS_RIGHT ? length - 1 : 0;
                        var i = IS_RIGHT ? -1 : 1;
                        if (argumentsLength < 2) while(true){
                            if (index in self1) {
                                memo = self1[index];
                                index += i;
                                break;
                            }
                            index += i;
                            if (IS_RIGHT ? index < 0 : length <= index) throw TypeError1("Reduce of empty array with no initial value");
                        }
                        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
                        return memo;
                    };
                };
                module1.exports = {
                    // `Array.prototype.reduce` method
                    // https://tc39.es/ecma262/#sec-array.prototype.reduce
                    left: createMethod(false),
                    // `Array.prototype.reduceRight` method
                    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
                    right: createMethod(true)
                };
            /***/ },
            /***/ 15629: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                module1.exports = uncurryThis([].slice);
            /***/ },
            /***/ 2013: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arraySlice = __webpack_require__(15629);
                var floor = Math.floor;
                var mergeSort = function(array, comparefn) {
                    var length = array.length;
                    var middle = floor(length / 2);
                    return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
                };
                var insertionSort = function(array, comparefn) {
                    var length = array.length;
                    var i = 1;
                    var element, j;
                    while(i < length){
                        j = i;
                        element = array[i];
                        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
                        if (j !== i++) array[j] = element;
                    }
                    return array;
                };
                var merge = function(array, left, right, comparefn) {
                    var llength = left.length;
                    var rlength = right.length;
                    var lindex = 0;
                    var rindex = 0;
                    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
                    return array;
                };
                module1.exports = mergeSort;
            /***/ },
            /***/ 30765: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isArray = __webpack_require__(71982);
                var isConstructor = __webpack_require__(31536);
                var isObject = __webpack_require__(52786);
                var wellKnownSymbol = __webpack_require__(52280);
                var SPECIES = wellKnownSymbol("species");
                var Array1 = global.Array;
                // a part of `ArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#sec-arrayspeciescreate
                module1.exports = function(originalArray) {
                    var C;
                    if (isArray(originalArray)) {
                        C = originalArray.constructor;
                        // cross-realm fallback
                        if (isConstructor(C) && (C === Array1 || isArray(C.prototype))) C = undefined;
                        else if (isObject(C)) {
                            C = C[SPECIES];
                            if (C === null) C = undefined;
                        }
                    }
                    return C === undefined ? Array1 : C;
                };
            /***/ },
            /***/ 80150: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arraySpeciesConstructor = __webpack_require__(30765);
                // `ArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#sec-arrayspeciescreate
                module1.exports = function(originalArray, length) {
                    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
                };
            /***/ },
            /***/ 9637: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var anObject = __webpack_require__(83875);
                var iteratorClose = __webpack_require__(18744);
                // call something on iterator step with safe closing on error
                module1.exports = function(iterator, fn, value, ENTRIES) {
                    try {
                        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                    } catch (error) {
                        iteratorClose(iterator, "throw", error);
                    }
                };
            /***/ },
            /***/ 8662: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(52280);
                var ITERATOR = wellKnownSymbol("iterator");
                var SAFE_CLOSING = false;
                try {
                    var called = 0;
                    var iteratorWithReturn = {
                        next: function() {
                            return {
                                done: !!called++
                            };
                        },
                        "return": function() {
                            SAFE_CLOSING = true;
                        }
                    };
                    iteratorWithReturn[ITERATOR] = function() {
                        return this;
                    };
                    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
                    Array.from(iteratorWithReturn, function() {
                        throw 2;
                    });
                } catch (error) {}
                module1.exports = function(exec, SKIP_CLOSING) {
                    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                    var ITERATION_SUPPORT = false;
                    try {
                        var object = {};
                        object[ITERATOR] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: ITERATION_SUPPORT = true
                                    };
                                }
                            };
                        };
                        exec(object);
                    } catch (error) {}
                    return ITERATION_SUPPORT;
                };
            /***/ },
            /***/ 79159: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var toString = uncurryThis({}.toString);
                var stringSlice = uncurryThis("".slice);
                module1.exports = function(it) {
                    return stringSlice(toString(it), 8, -1);
                };
            /***/ },
            /***/ 36994: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var TO_STRING_TAG_SUPPORT = __webpack_require__(57301);
                var isCallable = __webpack_require__(75277);
                var classofRaw = __webpack_require__(79159);
                var wellKnownSymbol = __webpack_require__(52280);
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var Object1 = global.Object;
                // ES3 wrong here
                var CORRECT_ARGUMENTS = classofRaw(function() {
                    return arguments;
                }()) == "Arguments";
                // fallback for IE11 Script Access Denied error
                var tryGet = function(it, key) {
                    try {
                        return it[key];
                    } catch (error) {}
                };
                // getting tag from ES6+ `Object.prototype.toString`
                module1.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                    var O, tag, result;
                    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object1(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable(O.callee) ? "Arguments" : result;
                };
            /***/ },
            /***/ 8457: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var arraySlice = __webpack_require__(15629);
                var replace = uncurryThis("".replace);
                var split = uncurryThis("".split);
                var join = uncurryThis([].join);
                var TEST = function(arg) {
                    return String(Error(arg).stack);
                }("zxcasd");
                var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
                var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
                var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);
                module1.exports = function(stack, dropEntries) {
                    if (typeof stack != "string") return stack;
                    if (IS_V8_OR_CHAKRA_STACK) while(dropEntries--)stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, "");
                    else if (IS_FIREFOX_OR_SAFARI_STACK) return join(arraySlice(split(stack, "\n"), dropEntries), "\n");
                    return stack;
                };
            /***/ },
            /***/ 33513: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var defineProperty = __webpack_require__(86385).f;
                var create = __webpack_require__(51569);
                var redefineAll = __webpack_require__(7592);
                var bind = __webpack_require__(98166);
                var anInstance = __webpack_require__(9519);
                var iterate = __webpack_require__(5166);
                var defineIterator = __webpack_require__(61495);
                var setSpecies = __webpack_require__(57323);
                var DESCRIPTORS = __webpack_require__(7493);
                var fastKey = __webpack_require__(44296).fastKey;
                var InternalStateModule = __webpack_require__(20821);
                var setInternalState = InternalStateModule.set;
                var internalStateGetterFor = InternalStateModule.getterFor;
                module1.exports = {
                    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
                        var Constructor = wrapper(function(that, iterable) {
                            anInstance(that, Prototype);
                            setInternalState(that, {
                                type: CONSTRUCTOR_NAME,
                                index: create(null),
                                first: undefined,
                                last: undefined,
                                size: 0
                            });
                            if (!DESCRIPTORS) that.size = 0;
                            if (iterable != undefined) iterate(iterable, that[ADDER], {
                                that: that,
                                AS_ENTRIES: IS_MAP
                            });
                        });
                        var Prototype = Constructor.prototype;
                        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
                        var define = function(that, key, value) {
                            var state = getInternalState(that);
                            var entry = getEntry(that, key);
                            var previous, index;
                            // change existing entry
                            if (entry) entry.value = value;
                            else {
                                state.last = entry = {
                                    index: index = fastKey(key, true),
                                    key: key,
                                    value: value,
                                    previous: previous = state.last,
                                    next: undefined,
                                    removed: false
                                };
                                if (!state.first) state.first = entry;
                                if (previous) previous.next = entry;
                                if (DESCRIPTORS) state.size++;
                                else that.size++;
                                // add to index
                                if (index !== "F") state.index[index] = entry;
                            }
                            return that;
                        };
                        var getEntry = function(that, key) {
                            var state = getInternalState(that);
                            // fast case
                            var index = fastKey(key);
                            var entry;
                            if (index !== "F") return state.index[index];
                            // frozen object case
                            for(entry = state.first; entry; entry = entry.next){
                                if (entry.key == key) return entry;
                            }
                        };
                        redefineAll(Prototype, {
                            // `{ Map, Set }.prototype.clear()` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.clear
                            // https://tc39.es/ecma262/#sec-set.prototype.clear
                            clear: function clear() {
                                var that = this;
                                var state = getInternalState(that);
                                var data = state.index;
                                var entry = state.first;
                                while(entry){
                                    entry.removed = true;
                                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                                    delete data[entry.index];
                                    entry = entry.next;
                                }
                                state.first = state.last = undefined;
                                if (DESCRIPTORS) state.size = 0;
                                else that.size = 0;
                            },
                            // `{ Map, Set }.prototype.delete(key)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.delete
                            // https://tc39.es/ecma262/#sec-set.prototype.delete
                            "delete": function(key) {
                                var that = this;
                                var state = getInternalState(that);
                                var entry = getEntry(that, key);
                                if (entry) {
                                    var next = entry.next;
                                    var prev = entry.previous;
                                    delete state.index[entry.index];
                                    entry.removed = true;
                                    if (prev) prev.next = next;
                                    if (next) next.previous = prev;
                                    if (state.first == entry) state.first = next;
                                    if (state.last == entry) state.last = prev;
                                    if (DESCRIPTORS) state.size--;
                                    else that.size--;
                                }
                                return !!entry;
                            },
                            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.foreach
                            // https://tc39.es/ecma262/#sec-set.prototype.foreach
                            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                                var state = getInternalState(this);
                                var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                                var entry;
                                while(entry = entry ? entry.next : state.first){
                                    boundFunction(entry.value, entry.key, this);
                                    // revert to the last existing entry
                                    while(entry && entry.removed)entry = entry.previous;
                                }
                            },
                            // `{ Map, Set}.prototype.has(key)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.has
                            // https://tc39.es/ecma262/#sec-set.prototype.has
                            has: function has(key) {
                                return !!getEntry(this, key);
                            }
                        });
                        redefineAll(Prototype, IS_MAP ? {
                            // `Map.prototype.get(key)` method
                            // https://tc39.es/ecma262/#sec-map.prototype.get
                            get: function get(key) {
                                var entry = getEntry(this, key);
                                return entry && entry.value;
                            },
                            // `Map.prototype.set(key, value)` method
                            // https://tc39.es/ecma262/#sec-map.prototype.set
                            set: function set(key, value) {
                                return define(this, key === 0 ? 0 : key, value);
                            }
                        } : {
                            // `Set.prototype.add(value)` method
                            // https://tc39.es/ecma262/#sec-set.prototype.add
                            add: function add(value) {
                                return define(this, value = value === 0 ? 0 : value, value);
                            }
                        });
                        if (DESCRIPTORS) defineProperty(Prototype, "size", {
                            get: function() {
                                return getInternalState(this).size;
                            }
                        });
                        return Constructor;
                    },
                    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
                        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
                        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
                        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
                        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
                        // https://tc39.es/ecma262/#sec-map.prototype.entries
                        // https://tc39.es/ecma262/#sec-map.prototype.keys
                        // https://tc39.es/ecma262/#sec-map.prototype.values
                        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
                        // https://tc39.es/ecma262/#sec-set.prototype.entries
                        // https://tc39.es/ecma262/#sec-set.prototype.keys
                        // https://tc39.es/ecma262/#sec-set.prototype.values
                        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
                        defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
                            setInternalState(this, {
                                type: ITERATOR_NAME,
                                target: iterated,
                                state: getInternalCollectionState(iterated),
                                kind: kind,
                                last: undefined
                            });
                        }, function() {
                            var state = getInternalIteratorState(this);
                            var kind = state.kind;
                            var entry = state.last;
                            // revert to the last existing entry
                            while(entry && entry.removed)entry = entry.previous;
                            // get next entry
                            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                                // or finish the iteration
                                state.target = undefined;
                                return {
                                    value: undefined,
                                    done: true
                                };
                            }
                            // return step by kind
                            if (kind == "keys") return {
                                value: entry.key,
                                done: false
                            };
                            if (kind == "values") return {
                                value: entry.value,
                                done: false
                            };
                            return {
                                value: [
                                    entry.key,
                                    entry.value
                                ],
                                done: false
                            };
                        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
                        // `{ Map, Set }.prototype[@@species]` accessors
                        // https://tc39.es/ecma262/#sec-get-map-@@species
                        // https://tc39.es/ecma262/#sec-get-set-@@species
                        setSpecies(CONSTRUCTOR_NAME);
                    }
                };
            /***/ },
            /***/ 9121: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var isForced = __webpack_require__(86291);
                var redefine = __webpack_require__(35974);
                var InternalMetadataModule = __webpack_require__(44296);
                var iterate = __webpack_require__(5166);
                var anInstance = __webpack_require__(9519);
                var isCallable = __webpack_require__(75277);
                var isObject = __webpack_require__(52786);
                var fails = __webpack_require__(79044);
                var checkCorrectnessOfIteration = __webpack_require__(8662);
                var setToStringTag = __webpack_require__(60878);
                var inheritIfRequired = __webpack_require__(59250);
                module1.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
                    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
                    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
                    var ADDER = IS_MAP ? "set" : "add";
                    var NativeConstructor = global[CONSTRUCTOR_NAME];
                    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
                    var Constructor = NativeConstructor;
                    var exported = {};
                    var fixMethod = function(KEY) {
                        var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
                        redefine(NativePrototype, KEY, KEY == "add" ? function add(value) {
                            uncurriedNativeMethod(this, value === 0 ? 0 : value);
                            return this;
                        } : KEY == "delete" ? function(key) {
                            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : KEY == "get" ? function get(key) {
                            return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : KEY == "has" ? function has(key) {
                            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : function set(key, value) {
                            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
                            return this;
                        });
                    };
                    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
                        new NativeConstructor().entries().next();
                    })));
                    if (REPLACE) {
                        // create collection constructor
                        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
                        InternalMetadataModule.enable();
                    } else if (isForced(CONSTRUCTOR_NAME, true)) {
                        var instance = new Constructor();
                        // early implementations not supports chaining
                        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
                        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
                        var THROWS_ON_PRIMITIVES = fails(function() {
                            instance.has(1);
                        });
                        // most early implementations doesn't supports iterables, most modern - not close it correctly
                        // eslint-disable-next-line no-new -- required for testing
                        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
                            new NativeConstructor(iterable);
                        });
                        // for early implementations -0 and +0 not the same
                        var BUGGY_ZERO = !IS_WEAK && fails(function() {
                            // V8 ~ Chromium 42- fails only with 5+ elements
                            var $instance = new NativeConstructor();
                            var index = 5;
                            while(index--)$instance[ADDER](index, index);
                            return !$instance.has(-0);
                        });
                        if (!ACCEPT_ITERABLES) {
                            Constructor = wrapper(function(dummy, iterable) {
                                anInstance(dummy, NativePrototype);
                                var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                                if (iterable != undefined) iterate(iterable, that[ADDER], {
                                    that: that,
                                    AS_ENTRIES: IS_MAP
                                });
                                return that;
                            });
                            Constructor.prototype = NativePrototype;
                            NativePrototype.constructor = Constructor;
                        }
                        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
                            fixMethod("delete");
                            fixMethod("has");
                            IS_MAP && fixMethod("get");
                        }
                        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
                        // weak collections should not contains .clear method
                        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
                    }
                    exported[CONSTRUCTOR_NAME] = Constructor;
                    $({
                        global: true,
                        forced: Constructor != NativeConstructor
                    }, exported);
                    setToStringTag(Constructor, CONSTRUCTOR_NAME);
                    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
                    return Constructor;
                };
            /***/ },
            /***/ 73870: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var hasOwn = __webpack_require__(24792);
                var ownKeys = __webpack_require__(31561);
                var getOwnPropertyDescriptorModule = __webpack_require__(66012);
                var definePropertyModule = __webpack_require__(86385);
                module1.exports = function(target, source) {
                    var keys = ownKeys(source);
                    var defineProperty = definePropertyModule.f;
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                    }
                };
            /***/ },
            /***/ 15454: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(52280);
                var MATCH = wellKnownSymbol("match");
                module1.exports = function(METHOD_NAME) {
                    var regexp = /./;
                    try {
                        "/./"[METHOD_NAME](regexp);
                    } catch (error1) {
                        try {
                            regexp[MATCH] = false;
                            return "/./"[METHOD_NAME](regexp);
                        } catch (error2) {}
                    }
                    return false;
                };
            /***/ },
            /***/ 25115: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                module1.exports = !fails(function() {
                    function F() {}
                    F.prototype.constructor = null;
                    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
                    return Object.getPrototypeOf(new F()) !== F.prototype;
                });
            /***/ },
            /***/ 75304: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var requireObjectCoercible = __webpack_require__(96411);
                var toString = __webpack_require__(28967);
                var quot = /"/g;
                var replace = uncurryThis("".replace);
                // `CreateHTML` abstract operation
                // https://tc39.es/ecma262/#sec-createhtml
                module1.exports = function(string, tag, attribute, value) {
                    var S = toString(requireObjectCoercible(string));
                    var p1 = "<" + tag;
                    if (attribute !== "") p1 += " " + attribute + '="' + replace(toString(value), quot, "&quot;") + '"';
                    return p1 + ">" + S + "</" + tag + ">";
                };
            /***/ },
            /***/ 6181: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var IteratorPrototype = __webpack_require__(97022).IteratorPrototype;
                var create = __webpack_require__(51569);
                var createPropertyDescriptor = __webpack_require__(69199);
                var setToStringTag = __webpack_require__(60878);
                var Iterators = __webpack_require__(44818);
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(IteratorConstructor, NAME, next) {
                    var TO_STRING_TAG = NAME + " Iterator";
                    IteratorConstructor.prototype = create(IteratorPrototype, {
                        next: createPropertyDescriptor(1, next)
                    });
                    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                    Iterators[TO_STRING_TAG] = returnThis;
                    return IteratorConstructor;
                };
            /***/ },
            /***/ 45899: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var definePropertyModule = __webpack_require__(86385);
                var createPropertyDescriptor = __webpack_require__(69199);
                module1.exports = DESCRIPTORS ? function(object, key, value) {
                    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                } : function(object, key, value) {
                    object[key] = value;
                    return object;
                };
            /***/ },
            /***/ 69199: /***/ function(module1) {
                module1.exports = function(bitmap, value) {
                    return {
                        enumerable: !(bitmap & 1),
                        configurable: !(bitmap & 2),
                        writable: !(bitmap & 4),
                        value: value
                    };
                };
            /***/ },
            /***/ 35039: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toPropertyKey = __webpack_require__(383);
                var definePropertyModule = __webpack_require__(86385);
                var createPropertyDescriptor = __webpack_require__(69199);
                module1.exports = function(object, key, value) {
                    var propertyKey = toPropertyKey(key);
                    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                    else object[propertyKey] = value;
                };
            /***/ },
            /***/ 67707: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var anObject = __webpack_require__(83875);
                var ordinaryToPrimitive = __webpack_require__(17141);
                var TypeError1 = global.TypeError;
                // `Date.prototype[@@toPrimitive](hint)` method implementation
                // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
                module1.exports = function(hint) {
                    anObject(this);
                    if (hint === "string" || hint === "default") hint = "string";
                    else if (hint !== "number") throw TypeError1("Incorrect hint");
                    return ordinaryToPrimitive(this, hint);
                };
            /***/ },
            /***/ 61495: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var call = __webpack_require__(79611);
                var IS_PURE = __webpack_require__(21178);
                var FunctionName = __webpack_require__(55316);
                var isCallable = __webpack_require__(75277);
                var createIteratorConstructor = __webpack_require__(6181);
                var getPrototypeOf = __webpack_require__(12654);
                var setPrototypeOf = __webpack_require__(22412);
                var setToStringTag = __webpack_require__(60878);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var redefine = __webpack_require__(35974);
                var wellKnownSymbol = __webpack_require__(52280);
                var Iterators = __webpack_require__(44818);
                var IteratorsCore = __webpack_require__(97022);
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol("iterator");
                var KEYS = "keys";
                var VALUES = "values";
                var ENTRIES = "entries";
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                    createIteratorConstructor(IteratorConstructor, NAME, next);
                    var getIterationMethod = function(KIND) {
                        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                        switch(KIND){
                            case KEYS:
                                return function keys() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case VALUES:
                                return function values() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case ENTRIES:
                                return function entries() {
                                    return new IteratorConstructor(this, KIND);
                                };
                        }
                        return function() {
                            return new IteratorConstructor(this);
                        };
                    };
                    var TO_STRING_TAG = NAME + " Iterator";
                    var INCORRECT_VALUES_NAME = false;
                    var IterablePrototype = Iterable.prototype;
                    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
                    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
                    var CurrentIteratorPrototype, methods, KEY;
                    // fix native
                    if (anyNativeIterator) {
                        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
                            }
                            // Set @@toStringTag to native iterators
                            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                        }
                    }
                    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
                    if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, "name", VALUES);
                        else {
                            INCORRECT_VALUES_NAME = true;
                            defaultIterator = function values() {
                                return call(nativeIterator, this);
                            };
                        }
                    }
                    // export additional methods
                    if (DEFAULT) {
                        methods = {
                            values: getIterationMethod(VALUES),
                            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                            entries: getIterationMethod(ENTRIES)
                        };
                        if (FORCED) {
                            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
                        } else $({
                            target: NAME,
                            proto: true,
                            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                        }, methods);
                    }
                    // define iterator
                    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) redefine(IterablePrototype, ITERATOR, defaultIterator, {
                        name: DEFAULT
                    });
                    Iterators[NAME] = defaultIterator;
                    return methods;
                };
            /***/ },
            /***/ 68308: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var path = __webpack_require__(67290);
                var hasOwn = __webpack_require__(24792);
                var wrappedWellKnownSymbolModule = __webpack_require__(20127);
                var defineProperty = __webpack_require__(86385).f;
                module1.exports = function(NAME) {
                    var Symbol1 = path.Symbol || (path.Symbol = {});
                    if (!hasOwn(Symbol1, NAME)) defineProperty(Symbol1, NAME, {
                        value: wrappedWellKnownSymbolModule.f(NAME)
                    });
                };
            /***/ },
            /***/ 7493: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                // Detect IE8's incomplete defineProperty implementation
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                    return Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1] != 7;
                });
            /***/ },
            /***/ 92750: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isObject = __webpack_require__(52786);
                var document1 = global.document;
                // typeof document.createElement is 'object' in old IE
                var EXISTS = isObject(document1) && isObject(document1.createElement);
                module1.exports = function(it) {
                    return EXISTS ? document1.createElement(it) : {};
                };
            /***/ },
            /***/ 12848: /***/ function(module1) {
                // iterable DOM collections
                // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
                module1.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            /***/ },
            /***/ 79189: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
                var documentCreateElement = __webpack_require__(92750);
                var classList = documentCreateElement("span").classList;
                var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
                module1.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
            /***/ },
            /***/ 34631: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(82647);
                var firefox = userAgent.match(/firefox\/(\d+)/i);
                module1.exports = !!firefox && +firefox[1];
            /***/ },
            /***/ 47923: /***/ function(module1) {
                module1.exports = typeof window == "object";
            /***/ },
            /***/ 80442: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var UA = __webpack_require__(82647);
                module1.exports = /MSIE|Trident/.test(UA);
            /***/ },
            /***/ 55357: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(82647);
                var global = __webpack_require__(98363);
                module1.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;
            /***/ },
            /***/ 53121: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(82647);
                module1.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
            /***/ },
            /***/ 93921: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var classof = __webpack_require__(79159);
                var global = __webpack_require__(98363);
                module1.exports = classof(global.process) == "process";
            /***/ },
            /***/ 14402: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(82647);
                module1.exports = /web0s(?!.*chrome)/i.test(userAgent);
            /***/ },
            /***/ 82647: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var getBuiltIn = __webpack_require__(22773);
                module1.exports = getBuiltIn("navigator", "userAgent") || "";
            /***/ },
            /***/ 11197: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var userAgent = __webpack_require__(82647);
                var process = global.process;
                var Deno = global.Deno;
                var versions = process && process.versions || Deno && Deno.version;
                var v8 = versions && versions.v8;
                var match, version;
                if (v8) {
                    match = v8.split(".");
                    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
                    // but their correct versions are not interesting for us
                    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
                }
                // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
                // so check `userAgent` even if `.v8` exists, but 0
                if (!version && userAgent) {
                    match = userAgent.match(/Edge\/(\d+)/);
                    if (!match || match[1] >= 74) {
                        match = userAgent.match(/Chrome\/(\d+)/);
                        if (match) version = +match[1];
                    }
                }
                module1.exports = version;
            /***/ },
            /***/ 76929: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(82647);
                var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
                module1.exports = !!webkit && +webkit[1];
            /***/ },
            /***/ 48869: /***/ function(module1) {
                // IE8- don't enum bug keys
                module1.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            /***/ },
            /***/ 67679: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                var createPropertyDescriptor = __webpack_require__(69199);
                module1.exports = !fails(function() {
                    var error = Error("a");
                    if (!("stack" in error)) return true;
                    // eslint-disable-next-line es/no-object-defineproperty -- safe
                    Object.defineProperty(error, "stack", createPropertyDescriptor(1, 7));
                    return error.stack !== 7;
                });
            /***/ },
            /***/ 19882: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var getOwnPropertyDescriptor = __webpack_require__(66012).f;
                var createNonEnumerableProperty = __webpack_require__(45899);
                var redefine = __webpack_require__(35974);
                var setGlobal = __webpack_require__(51621);
                var copyConstructorProperties = __webpack_require__(73870);
                var isForced = __webpack_require__(86291);
                /*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/ module1.exports = function(options, source) {
                    var TARGET = options.target;
                    var GLOBAL = options.global;
                    var STATIC = options.stat;
                    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                    if (GLOBAL) target = global;
                    else if (STATIC) target = global[TARGET] || setGlobal(TARGET, {});
                    else target = (global[TARGET] || {}).prototype;
                    if (target) for(key in source){
                        sourceProperty = source[key];
                        if (options.noTargetGet) {
                            descriptor = getOwnPropertyDescriptor(target, key);
                            targetProperty = descriptor && descriptor.value;
                        } else targetProperty = target[key];
                        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                        // contained in target
                        if (!FORCED && targetProperty !== undefined) {
                            if (typeof sourceProperty == typeof targetProperty) continue;
                            copyConstructorProperties(sourceProperty, targetProperty);
                        }
                        // add a flag to not completely full polyfills
                        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
                        // extend global
                        redefine(target, key, sourceProperty, options);
                    }
                };
            /***/ },
            /***/ 79044: /***/ function(module1) {
                module1.exports = function(exec) {
                    try {
                        return !!exec();
                    } catch (error) {
                        return true;
                    }
                };
            /***/ },
            /***/ 81492: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4` since it's moved to entry points
                __webpack_require__(39275);
                var uncurryThis = __webpack_require__(88697);
                var redefine = __webpack_require__(35974);
                var regexpExec = __webpack_require__(99749);
                var fails = __webpack_require__(79044);
                var wellKnownSymbol = __webpack_require__(52280);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var SPECIES = wellKnownSymbol("species");
                var RegExpPrototype = RegExp.prototype;
                module1.exports = function(KEY, exec, FORCED, SHAM) {
                    var SYMBOL = wellKnownSymbol(KEY);
                    var DELEGATES_TO_SYMBOL = !fails(function() {
                        // String methods call symbol-named RegEp methods
                        var O = {};
                        O[SYMBOL] = function() {
                            return 7;
                        };
                        return ""[KEY](O) != 7;
                    });
                    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                        // Symbol-named RegExp methods call .exec
                        var execCalled = false;
                        var re = /a/;
                        if (KEY === "split") {
                            // We can't use real regex here since it causes deoptimization
                            // and serious performance degradation in V8
                            // https://github.com/zloirock/core-js/issues/306
                            re = {};
                            // RegExp[@@split] doesn't call the regex's exec method, but first creates
                            // a new one. We need to return the patched regex when creating the new one.
                            re.constructor = {};
                            re.constructor[SPECIES] = function() {
                                return re;
                            };
                            re.flags = "";
                            re[SYMBOL] = /./[SYMBOL];
                        }
                        re.exec = function() {
                            execCalled = true;
                            return null;
                        };
                        re[SYMBOL]("");
                        return !execCalled;
                    });
                    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
                        var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
                        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                            var uncurriedNativeMethod = uncurryThis(nativeMethod);
                            var $exec = regexp.exec;
                            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                                // polyfilled function), leasing to infinite recursion.
                                // We avoid it by directly calling the native @@method method.
                                return {
                                    done: true,
                                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                                };
                                return {
                                    done: true,
                                    value: uncurriedNativeMethod(str, regexp, arg2)
                                };
                            }
                            return {
                                done: false
                            };
                        });
                        redefine(String.prototype, KEY, methods[0]);
                        redefine(RegExpPrototype, SYMBOL, methods[1]);
                    }
                    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], "sham", true);
                };
            /***/ },
            /***/ 51207: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            /***/ },
            /***/ 63530: /***/ function(module1) {
                var FunctionPrototype = Function.prototype;
                var apply = FunctionPrototype.apply;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                // eslint-disable-next-line es/no-reflect -- safe
                module1.exports = typeof Reflect == "object" && Reflect.apply || (bind ? call.bind(apply) : function() {
                    return call.apply(apply, arguments);
                });
            /***/ },
            /***/ 98166: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var aCallable = __webpack_require__(97676);
                var bind = uncurryThis(uncurryThis.bind);
                // optional / simple context binding
                module1.exports = function(fn, that) {
                    aCallable(fn);
                    return that === undefined ? fn : bind ? bind(fn, that) : function() {
                        return fn.apply(that, arguments);
                    };
                };
            /***/ },
            /***/ 52381: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var aCallable = __webpack_require__(97676);
                var isObject = __webpack_require__(52786);
                var hasOwn = __webpack_require__(24792);
                var arraySlice = __webpack_require__(15629);
                var Function1 = global.Function;
                var concat = uncurryThis([].concat);
                var join = uncurryThis([].join);
                var factories = {};
                var construct = function(C, argsLength, args) {
                    if (!hasOwn(factories, argsLength)) {
                        for(var list = [], i = 0; i < argsLength; i++)list[i] = "a[" + i + "]";
                        factories[argsLength] = Function1("C,a", "return new C(" + join(list, ",") + ")");
                    }
                    return factories[argsLength](C, args);
                };
                // `Function.prototype.bind` method implementation
                // https://tc39.es/ecma262/#sec-function.prototype.bind
                module1.exports = Function1.bind || function bind(that /* , ...args */ ) {
                    var F = aCallable(this);
                    var Prototype = F.prototype;
                    var partArgs = arraySlice(arguments, 1);
                    var boundFunction = function bound() {
                        var args = concat(partArgs, arraySlice(arguments));
                        return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
                    };
                    if (isObject(Prototype)) boundFunction.prototype = Prototype;
                    return boundFunction;
                };
            /***/ },
            /***/ 79611: /***/ function(module1) {
                var call = Function.prototype.call;
                module1.exports = call.bind ? call.bind(call) : function() {
                    return call.apply(call, arguments);
                };
            /***/ },
            /***/ 55316: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var hasOwn = __webpack_require__(24792);
                var FunctionPrototype = Function.prototype;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
                var EXISTS = hasOwn(FunctionPrototype, "name");
                // additional protection from minified / mangled / dropped function names
                var PROPER = EXISTS && (function something() {}).name === "something";
                var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
                module1.exports = {
                    EXISTS: EXISTS,
                    PROPER: PROPER,
                    CONFIGURABLE: CONFIGURABLE
                };
            /***/ },
            /***/ 88697: /***/ function(module1) {
                var FunctionPrototype = Function.prototype;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                var callBind = bind && bind.bind(call);
                module1.exports = bind ? function(fn) {
                    return fn && callBind(call, fn);
                } : function(fn) {
                    return fn && function() {
                        return call.apply(fn, arguments);
                    };
                };
            /***/ },
            /***/ 22773: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isCallable = __webpack_require__(75277);
                var aFunction = function(argument) {
                    return isCallable(argument) ? argument : undefined;
                };
                module1.exports = function(namespace, method) {
                    return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
                };
            /***/ },
            /***/ 77193: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var classof = __webpack_require__(36994);
                var getMethod = __webpack_require__(97219);
                var Iterators = __webpack_require__(44818);
                var wellKnownSymbol = __webpack_require__(52280);
                var ITERATOR = wellKnownSymbol("iterator");
                module1.exports = function(it) {
                    if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, "@@iterator") || Iterators[classof(it)];
                };
            /***/ },
            /***/ 11805: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var call = __webpack_require__(79611);
                var aCallable = __webpack_require__(97676);
                var anObject = __webpack_require__(83875);
                var tryToString = __webpack_require__(28768);
                var getIteratorMethod = __webpack_require__(77193);
                var TypeError1 = global.TypeError;
                module1.exports = function(argument, usingIterator) {
                    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
                    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
                    throw TypeError1(tryToString(argument) + " is not iterable");
                };
            /***/ },
            /***/ 97219: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var aCallable = __webpack_require__(97676);
                // `GetMethod` abstract operation
                // https://tc39.es/ecma262/#sec-getmethod
                module1.exports = function(V, P) {
                    var func = V[P];
                    return func == null ? undefined : aCallable(func);
                };
            /***/ },
            /***/ 81373: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var toObject = __webpack_require__(30744);
                var floor = Math.floor;
                var charAt = uncurryThis("".charAt);
                var replace = uncurryThis("".replace);
                var stringSlice = uncurryThis("".slice);
                var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
                var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
                // `GetSubstitution` abstract operation
                // https://tc39.es/ecma262/#sec-getsubstitution
                module1.exports = function(matched, str, position, captures, namedCaptures, replacement) {
                    var tailPos = position + matched.length;
                    var m = captures.length;
                    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
                    if (namedCaptures !== undefined) {
                        namedCaptures = toObject(namedCaptures);
                        symbols = SUBSTITUTION_SYMBOLS;
                    }
                    return replace(replacement, symbols, function(match, ch) {
                        var capture;
                        switch(charAt(ch, 0)){
                            case "$":
                                return "$";
                            case "&":
                                return matched;
                            case "`":
                                return stringSlice(str, 0, position);
                            case "'":
                                return stringSlice(str, tailPos);
                            case "<":
                                capture = namedCaptures[stringSlice(ch, 1, -1)];
                                break;
                            default:
                                var n = +ch;
                                if (n === 0) return match;
                                if (n > m) {
                                    var f = floor(n / 10);
                                    if (f === 0) return match;
                                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                                    return match;
                                }
                                capture = captures[n - 1];
                        }
                        return capture === undefined ? "" : capture;
                    });
                };
            /***/ },
            /***/ 98363: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var check = function(it) {
                    return it && it.Math == Math && it;
                };
                // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                module1.exports = // eslint-disable-next-line es/no-global-this -- safe
                check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
                check(typeof self == "object" && self) || check(typeof __webpack_require__.g == "object" && __webpack_require__.g) || // eslint-disable-next-line no-new-func -- fallback
                function() {
                    return this;
                }() || Function("return this")();
            /***/ },
            /***/ 24792: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var toObject = __webpack_require__(30744);
                var hasOwnProperty = uncurryThis({}.hasOwnProperty);
                // `HasOwnProperty` abstract operation
                // https://tc39.es/ecma262/#sec-hasownproperty
                module1.exports = Object.hasOwn || function hasOwn(it, key) {
                    return hasOwnProperty(toObject(it), key);
                };
            /***/ },
            /***/ 47505: /***/ function(module1) {
                module1.exports = {};
            /***/ },
            /***/ 46271: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                module1.exports = function(a, b) {
                    var console1 = global.console;
                    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
                };
            /***/ },
            /***/ 47055: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var getBuiltIn = __webpack_require__(22773);
                module1.exports = getBuiltIn("document", "documentElement");
            /***/ },
            /***/ 67548: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var fails = __webpack_require__(79044);
                var createElement = __webpack_require__(92750);
                // Thank's IE8 for his funny defineProperty
                module1.exports = !DESCRIPTORS && !fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
                    return Object.defineProperty(createElement("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a != 7;
                });
            /***/ },
            /***/ 45489: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // IEEE754 conversions based on https://github.com/feross/ieee754
                var global = __webpack_require__(98363);
                var Array1 = global.Array;
                var abs = Math.abs;
                var pow = Math.pow;
                var floor = Math.floor;
                var log = Math.log;
                var LN2 = Math.LN2;
                var pack = function(number, mantissaLength, bytes) {
                    var buffer = Array1(bytes);
                    var exponentLength = bytes * 8 - mantissaLength - 1;
                    var eMax = (1 << exponentLength) - 1;
                    var eBias = eMax >> 1;
                    var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
                    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
                    var index = 0;
                    var exponent, mantissa, c;
                    number = abs(number);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (number != number || number === Infinity) {
                        // eslint-disable-next-line no-self-compare -- NaN check
                        mantissa = number != number ? 1 : 0;
                        exponent = eMax;
                    } else {
                        exponent = floor(log(number) / LN2);
                        if (number * (c = pow(2, -exponent)) < 1) {
                            exponent--;
                            c *= 2;
                        }
                        if (exponent + eBias >= 1) number += rt / c;
                        else number += rt * pow(2, 1 - eBias);
                        if (number * c >= 2) {
                            exponent++;
                            c /= 2;
                        }
                        if (exponent + eBias >= eMax) {
                            mantissa = 0;
                            exponent = eMax;
                        } else if (exponent + eBias >= 1) {
                            mantissa = (number * c - 1) * pow(2, mantissaLength);
                            exponent = exponent + eBias;
                        } else {
                            mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
                            exponent = 0;
                        }
                    }
                    for(; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
                    exponent = exponent << mantissaLength | mantissa;
                    exponentLength += mantissaLength;
                    for(; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
                    buffer[--index] |= sign * 128;
                    return buffer;
                };
                var unpack = function(buffer, mantissaLength) {
                    var bytes = buffer.length;
                    var exponentLength = bytes * 8 - mantissaLength - 1;
                    var eMax = (1 << exponentLength) - 1;
                    var eBias = eMax >> 1;
                    var nBits = exponentLength - 7;
                    var index = bytes - 1;
                    var sign = buffer[index--];
                    var exponent = sign & 127;
                    var mantissa;
                    sign >>= 7;
                    for(; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
                    mantissa = exponent & (1 << -nBits) - 1;
                    exponent >>= -nBits;
                    nBits += mantissaLength;
                    for(; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
                    if (exponent === 0) exponent = 1 - eBias;
                    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
                    else {
                        mantissa = mantissa + pow(2, mantissaLength);
                        exponent = exponent - eBias;
                    }
                    return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
                };
                module1.exports = {
                    pack: pack,
                    unpack: unpack
                };
            /***/ },
            /***/ 78609: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var fails = __webpack_require__(79044);
                var classof = __webpack_require__(79159);
                var Object1 = global.Object;
                var split = uncurryThis("".split);
                // fallback for non-array-like ES3 and non-enumerable old V8 strings
                module1.exports = fails(function() {
                    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                    // eslint-disable-next-line no-prototype-builtins -- safe
                    return !Object1("z").propertyIsEnumerable(0);
                }) ? function(it) {
                    return classof(it) == "String" ? split(it, "") : Object1(it);
                } : Object1;
            /***/ },
            /***/ 59250: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isCallable = __webpack_require__(75277);
                var isObject = __webpack_require__(52786);
                var setPrototypeOf = __webpack_require__(22412);
                // makes subclassing work correct for wrapped built-ins
                module1.exports = function($this, dummy, Wrapper) {
                    var NewTarget, NewTargetPrototype;
                    if (// it can work only with native `setPrototypeOf`
                    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
                    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
                    return $this;
                };
            /***/ },
            /***/ 56429: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var isCallable = __webpack_require__(75277);
                var store = __webpack_require__(49415);
                var functionToString = uncurryThis(Function.toString);
                // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
                if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
                    return functionToString(it);
                };
                module1.exports = store.inspectSource;
            /***/ },
            /***/ 58323: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isObject = __webpack_require__(52786);
                var createNonEnumerableProperty = __webpack_require__(45899);
                // `InstallErrorCause` abstract operation
                // https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
                module1.exports = function(O, options) {
                    if (isObject(options) && "cause" in options) createNonEnumerableProperty(O, "cause", options.cause);
                };
            /***/ },
            /***/ 44296: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var uncurryThis = __webpack_require__(88697);
                var hiddenKeys = __webpack_require__(47505);
                var isObject = __webpack_require__(52786);
                var hasOwn = __webpack_require__(24792);
                var defineProperty = __webpack_require__(86385).f;
                var getOwnPropertyNamesModule = __webpack_require__(87994);
                var getOwnPropertyNamesExternalModule = __webpack_require__(74938);
                var uid = __webpack_require__(34524);
                var FREEZING = __webpack_require__(51207);
                var REQUIRED = false;
                var METADATA = uid("meta");
                var id = 0;
                // eslint-disable-next-line es/no-object-isextensible -- safe
                var isExtensible = Object.isExtensible || function() {
                    return true;
                };
                var setMetadata = function(it) {
                    defineProperty(it, METADATA, {
                        value: {
                            objectID: "O" + id++,
                            weakData: {} // weak collections IDs
                        }
                    });
                };
                var fastKey = function(it, create) {
                    // return a primitive with prefix
                    if (!isObject(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
                    if (!hasOwn(it, METADATA)) {
                        // can't set metadata to uncaught frozen object
                        if (!isExtensible(it)) return "F";
                        // not necessary to add metadata
                        if (!create) return "E";
                        // add missing metadata
                        setMetadata(it);
                    // return object ID
                    }
                    return it[METADATA].objectID;
                };
                var getWeakData = function(it, create) {
                    if (!hasOwn(it, METADATA)) {
                        // can't set metadata to uncaught frozen object
                        if (!isExtensible(it)) return true;
                        // not necessary to add metadata
                        if (!create) return false;
                        // add missing metadata
                        setMetadata(it);
                    // return the store of weak collections IDs
                    }
                    return it[METADATA].weakData;
                };
                // add metadata on freeze-family methods calling
                var onFreeze = function(it) {
                    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
                    return it;
                };
                var enable = function() {
                    meta.enable = function() {};
                    REQUIRED = true;
                    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
                    var splice = uncurryThis([].splice);
                    var test = {};
                    test[METADATA] = 1;
                    // prevent exposing of metadata key
                    if (getOwnPropertyNames(test).length) {
                        getOwnPropertyNamesModule.f = function(it) {
                            var result = getOwnPropertyNames(it);
                            for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                                splice(result, i, 1);
                                break;
                            }
                            return result;
                        };
                        $({
                            target: "Object",
                            stat: true,
                            forced: true
                        }, {
                            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
                        });
                    }
                };
                var meta = module1.exports = {
                    enable: enable,
                    fastKey: fastKey,
                    getWeakData: getWeakData,
                    onFreeze: onFreeze
                };
                hiddenKeys[METADATA] = true;
            /***/ },
            /***/ 20821: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var NATIVE_WEAK_MAP = __webpack_require__(36830);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var isObject = __webpack_require__(52786);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var hasOwn = __webpack_require__(24792);
                var shared = __webpack_require__(49415);
                var sharedKey = __webpack_require__(50466);
                var hiddenKeys = __webpack_require__(47505);
                var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
                var TypeError1 = global.TypeError;
                var WeakMap1 = global.WeakMap;
                var set, get, has;
                var enforce = function(it) {
                    return has(it) ? get(it) : set(it, {});
                };
                var getterFor = function(TYPE) {
                    return function(it) {
                        var state;
                        if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError1("Incompatible receiver, " + TYPE + " required");
                        return state;
                    };
                };
                if (NATIVE_WEAK_MAP || shared.state) {
                    var store = shared.state || (shared.state = new WeakMap1());
                    var wmget = uncurryThis(store.get);
                    var wmhas = uncurryThis(store.has);
                    var wmset = uncurryThis(store.set);
                    set = function(it, metadata) {
                        if (wmhas(store, it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        wmset(store, it, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return wmget(store, it) || {};
                    };
                    has = function(it) {
                        return wmhas(store, it);
                    };
                } else {
                    var STATE = sharedKey("state");
                    hiddenKeys[STATE] = true;
                    set = function(it, metadata) {
                        if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        createNonEnumerableProperty(it, STATE, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return hasOwn(it, STATE) ? it[STATE] : {};
                    };
                    has = function(it) {
                        return hasOwn(it, STATE);
                    };
                }
                module1.exports = {
                    set: set,
                    get: get,
                    has: has,
                    enforce: enforce,
                    getterFor: getterFor
                };
            /***/ },
            /***/ 68089: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(52280);
                var Iterators = __webpack_require__(44818);
                var ITERATOR = wellKnownSymbol("iterator");
                var ArrayPrototype = Array.prototype;
                // check on default Array iterator
                module1.exports = function(it) {
                    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                };
            /***/ },
            /***/ 71982: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var classof = __webpack_require__(79159);
                // `IsArray` abstract operation
                // https://tc39.es/ecma262/#sec-isarray
                // eslint-disable-next-line es/no-array-isarray -- safe
                module1.exports = Array.isArray || function isArray(argument) {
                    return classof(argument) == "Array";
                };
            /***/ },
            /***/ 75277: /***/ function(module1) {
                // `IsCallable` abstract operation
                // https://tc39.es/ecma262/#sec-iscallable
                module1.exports = function(argument) {
                    return typeof argument == "function";
                };
            /***/ },
            /***/ 31536: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var fails = __webpack_require__(79044);
                var isCallable = __webpack_require__(75277);
                var classof = __webpack_require__(36994);
                var getBuiltIn = __webpack_require__(22773);
                var inspectSource = __webpack_require__(56429);
                var noop = function() {};
                var empty = [];
                var construct = getBuiltIn("Reflect", "construct");
                var constructorRegExp = /^\s*(?:class|function)\b/;
                var exec = uncurryThis(constructorRegExp.exec);
                var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
                var isConstructorModern = function(argument) {
                    if (!isCallable(argument)) return false;
                    try {
                        construct(noop, empty, argument);
                        return true;
                    } catch (error) {
                        return false;
                    }
                };
                var isConstructorLegacy = function(argument) {
                    if (!isCallable(argument)) return false;
                    switch(classof(argument)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return false;
                    }
                    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
                };
                // `IsConstructor` abstract operation
                // https://tc39.es/ecma262/#sec-isconstructor
                module1.exports = !construct || fails(function() {
                    var called;
                    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                        called = true;
                    }) || called;
                }) ? isConstructorLegacy : isConstructorModern;
            /***/ },
            /***/ 86291: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                var isCallable = __webpack_require__(75277);
                var replacement = /#|\.prototype\./;
                var isForced = function(feature, detection) {
                    var value = data[normalize(feature)];
                    return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
                };
                var normalize = isForced.normalize = function(string) {
                    return String(string).replace(replacement, ".").toLowerCase();
                };
                var data = isForced.data = {};
                var NATIVE = isForced.NATIVE = "N";
                var POLYFILL = isForced.POLYFILL = "P";
                module1.exports = isForced;
            /***/ },
            /***/ 57507: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isObject = __webpack_require__(52786);
                var floor = Math.floor;
                // `IsIntegralNumber` abstract operation
                // https://tc39.es/ecma262/#sec-isintegralnumber
                // eslint-disable-next-line es/no-number-isinteger -- safe
                module1.exports = Number.isInteger || function isInteger(it) {
                    return !isObject(it) && isFinite(it) && floor(it) === it;
                };
            /***/ },
            /***/ 52786: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isCallable = __webpack_require__(75277);
                module1.exports = function(it) {
                    return typeof it == "object" ? it !== null : isCallable(it);
                };
            /***/ },
            /***/ 21178: /***/ function(module1) {
                module1.exports = false;
            /***/ },
            /***/ 42622: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isObject = __webpack_require__(52786);
                var classof = __webpack_require__(79159);
                var wellKnownSymbol = __webpack_require__(52280);
                var MATCH = wellKnownSymbol("match");
                // `IsRegExp` abstract operation
                // https://tc39.es/ecma262/#sec-isregexp
                module1.exports = function(it) {
                    var isRegExp;
                    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == "RegExp");
                };
            /***/ },
            /***/ 66681: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var getBuiltIn = __webpack_require__(22773);
                var isCallable = __webpack_require__(75277);
                var isPrototypeOf = __webpack_require__(32010);
                var USE_SYMBOL_AS_UID = __webpack_require__(189);
                var Object1 = global.Object;
                module1.exports = USE_SYMBOL_AS_UID ? function(it) {
                    return typeof it == "symbol";
                } : function(it) {
                    var $Symbol = getBuiltIn("Symbol");
                    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object1(it));
                };
            /***/ },
            /***/ 5166: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var bind = __webpack_require__(98166);
                var call = __webpack_require__(79611);
                var anObject = __webpack_require__(83875);
                var tryToString = __webpack_require__(28768);
                var isArrayIteratorMethod = __webpack_require__(68089);
                var lengthOfArrayLike = __webpack_require__(47046);
                var isPrototypeOf = __webpack_require__(32010);
                var getIterator = __webpack_require__(11805);
                var getIteratorMethod = __webpack_require__(77193);
                var iteratorClose = __webpack_require__(18744);
                var TypeError1 = global.TypeError;
                var Result = function(stopped, result) {
                    this.stopped = stopped;
                    this.result = result;
                };
                var ResultPrototype = Result.prototype;
                module1.exports = function(iterable, unboundFunction, options) {
                    var that = options && options.that;
                    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
                    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
                    var INTERRUPTED = !!(options && options.INTERRUPTED);
                    var fn = bind(unboundFunction, that);
                    var iterator, iterFn, index, length, result, next, step;
                    var stop = function(condition) {
                        if (iterator) iteratorClose(iterator, "normal", condition);
                        return new Result(true, condition);
                    };
                    var callFn = function(value) {
                        if (AS_ENTRIES) {
                            anObject(value);
                            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                        }
                        return INTERRUPTED ? fn(value, stop) : fn(value);
                    };
                    if (IS_ITERATOR) iterator = iterable;
                    else {
                        iterFn = getIteratorMethod(iterable);
                        if (!iterFn) throw TypeError1(tryToString(iterable) + " is not iterable");
                        // optimisation for array iterators
                        if (isArrayIteratorMethod(iterFn)) {
                            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                                result = callFn(iterable[index]);
                                if (result && isPrototypeOf(ResultPrototype, result)) return result;
                            }
                            return new Result(false);
                        }
                        iterator = getIterator(iterable, iterFn);
                    }
                    next = iterator.next;
                    while(!(step = call(next, iterator)).done){
                        try {
                            result = callFn(step.value);
                        } catch (error) {
                            iteratorClose(iterator, "throw", error);
                        }
                        if (typeof result == "object" && result && isPrototypeOf(ResultPrototype, result)) return result;
                    }
                    return new Result(false);
                };
            /***/ },
            /***/ 18744: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var call = __webpack_require__(79611);
                var anObject = __webpack_require__(83875);
                var getMethod = __webpack_require__(97219);
                module1.exports = function(iterator, kind, value) {
                    var innerResult, innerError;
                    anObject(iterator);
                    try {
                        innerResult = getMethod(iterator, "return");
                        if (!innerResult) {
                            if (kind === "throw") throw value;
                            return value;
                        }
                        innerResult = call(innerResult, iterator);
                    } catch (error) {
                        innerError = true;
                        innerResult = error;
                    }
                    if (kind === "throw") throw value;
                    if (innerError) throw innerResult;
                    anObject(innerResult);
                    return value;
                };
            /***/ },
            /***/ 97022: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(79044);
                var isCallable = __webpack_require__(75277);
                var create = __webpack_require__(51569);
                var getPrototypeOf = __webpack_require__(12654);
                var redefine = __webpack_require__(35974);
                var wellKnownSymbol = __webpack_require__(52280);
                var IS_PURE = __webpack_require__(21178);
                var ITERATOR = wellKnownSymbol("iterator");
                var BUGGY_SAFARI_ITERATORS = false;
                // `%IteratorPrototype%` object
                // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
                var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
                /* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
                    arrayIterator = [].keys();
                    // Safari 8 has buggy iterators w/o `next`
                    if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                    else {
                        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                    }
                }
                var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function() {
                    var test = {};
                    // FF44- legacy iterators case
                    return IteratorPrototype[ITERATOR].call(test) !== test;
                });
                if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
                else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
                // `%IteratorPrototype%[@@iterator]()` method
                // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
                if (!isCallable(IteratorPrototype[ITERATOR])) redefine(IteratorPrototype, ITERATOR, function() {
                    return this;
                });
                module1.exports = {
                    IteratorPrototype: IteratorPrototype,
                    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
                };
            /***/ },
            /***/ 44818: /***/ function(module1) {
                module1.exports = {};
            /***/ },
            /***/ 47046: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toLength = __webpack_require__(35108);
                // `LengthOfArrayLike` abstract operation
                // https://tc39.es/ecma262/#sec-lengthofarraylike
                module1.exports = function(obj) {
                    return toLength(obj.length);
                };
            /***/ },
            /***/ 71800: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var bind = __webpack_require__(98166);
                var getOwnPropertyDescriptor = __webpack_require__(66012).f;
                var macrotask = __webpack_require__(84643).set;
                var IS_IOS = __webpack_require__(53121);
                var IS_IOS_PEBBLE = __webpack_require__(55357);
                var IS_WEBOS_WEBKIT = __webpack_require__(14402);
                var IS_NODE = __webpack_require__(93921);
                var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
                var document1 = global.document;
                var process = global.process;
                var Promise1 = global.Promise;
                // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
                var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, "queueMicrotask");
                var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
                var flush, head, last, notify, toggle, node, promise, then;
                // modern engines have queueMicrotask method
                if (!queueMicrotask) {
                    flush = function() {
                        var parent, fn;
                        if (IS_NODE && (parent = process.domain)) parent.exit();
                        while(head){
                            fn = head.fn;
                            head = head.next;
                            try {
                                fn();
                            } catch (error) {
                                if (head) notify();
                                else last = undefined;
                                throw error;
                            }
                        }
                        last = undefined;
                        if (parent) parent.enter();
                    };
                    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
                    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
                    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document1) {
                        toggle = true;
                        node = document1.createTextNode("");
                        new MutationObserver(flush).observe(node, {
                            characterData: true
                        });
                        notify = function() {
                            node.data = toggle = !toggle;
                        };
                    // environments with maybe non-completely correct, but existent Promise
                    } else if (!IS_IOS_PEBBLE && Promise1 && Promise1.resolve) {
                        // Promise.resolve without an argument throws an error in LG WebOS 2
                        promise = Promise1.resolve(undefined);
                        // workaround of WebKit ~ iOS Safari 10.1 bug
                        promise.constructor = Promise1;
                        then = bind(promise.then, promise);
                        notify = function() {
                            then(flush);
                        };
                    // Node.js without promises
                    } else if (IS_NODE) notify = function() {
                        process.nextTick(flush);
                    };
                    else {
                        // strange IE + webpack dev server bug - use .bind(global)
                        macrotask = bind(macrotask, global);
                        notify = function() {
                            macrotask(flush);
                        };
                    }
                }
                module1.exports = queueMicrotask || function(fn) {
                    var task = {
                        fn: fn,
                        next: undefined
                    };
                    if (last) last.next = task;
                    if (!head) {
                        head = task;
                        notify();
                    }
                    last = task;
                };
            /***/ },
            /***/ 58369: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                module1.exports = global.Promise;
            /***/ },
            /***/ 3850: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = __webpack_require__(11197);
                var fails = __webpack_require__(79044);
                // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
                module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                    var symbol = Symbol();
                    // Chrome 38 Symbol has incorrect toString conversion
                    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
                    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
                    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
                });
            /***/ },
            /***/ 36830: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isCallable = __webpack_require__(75277);
                var inspectSource = __webpack_require__(56429);
                var WeakMap1 = global.WeakMap;
                module1.exports = isCallable(WeakMap1) && /native code/.test(inspectSource(WeakMap1));
            /***/ },
            /***/ 29269: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aCallable = __webpack_require__(97676);
                var PromiseCapability = function(C) {
                    var resolve, reject;
                    this.promise = new C(function($$resolve, $$reject) {
                        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
                        resolve = $$resolve;
                        reject = $$reject;
                    });
                    this.resolve = aCallable(resolve);
                    this.reject = aCallable(reject);
                };
                // `NewPromiseCapability` abstract operation
                // https://tc39.es/ecma262/#sec-newpromisecapability
                module1.exports.f = function(C) {
                    return new PromiseCapability(C);
                };
            /***/ },
            /***/ 654: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toString = __webpack_require__(28967);
                module1.exports = function(argument, $default) {
                    return argument === undefined ? arguments.length < 2 ? "" : $default : toString(argument);
                };
            /***/ },
            /***/ 21049: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isRegExp = __webpack_require__(42622);
                var TypeError1 = global.TypeError;
                module1.exports = function(it) {
                    if (isRegExp(it)) throw TypeError1("The method doesn't accept regular expressions");
                    return it;
                };
            /***/ },
            /***/ 5310: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var globalIsFinite = global.isFinite;
                // `Number.isFinite` method
                // https://tc39.es/ecma262/#sec-number.isfinite
                // eslint-disable-next-line es/no-number-isfinite -- safe
                module1.exports = Number.isFinite || function isFinite1(it) {
                    return typeof it == "number" && globalIsFinite(it);
                };
            /***/ },
            /***/ 45856: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(7493);
                var uncurryThis = __webpack_require__(88697);
                var call = __webpack_require__(79611);
                var fails = __webpack_require__(79044);
                var objectKeys = __webpack_require__(60667);
                var getOwnPropertySymbolsModule = __webpack_require__(89612);
                var propertyIsEnumerableModule = __webpack_require__(81513);
                var toObject = __webpack_require__(30744);
                var IndexedObject = __webpack_require__(78609);
                // eslint-disable-next-line es/no-object-assign -- safe
                var $assign = Object.assign;
                // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                var defineProperty = Object.defineProperty;
                var concat = uncurryThis([].concat);
                // `Object.assign` method
                // https://tc39.es/ecma262/#sec-object.assign
                module1.exports = !$assign || fails(function() {
                    // should have correct order of operations (Edge bug)
                    if (DESCRIPTORS && $assign({
                        b: 1
                    }, $assign(defineProperty({}, "a", {
                        enumerable: true,
                        get: function() {
                            defineProperty(this, "b", {
                                value: 3,
                                enumerable: false
                            });
                        }
                    }), {
                        b: 2
                    })).b !== 1) return true;
                    // should work with symbols and should have deterministic property order (V8 bug)
                    var A = {};
                    var B = {};
                    // eslint-disable-next-line es/no-symbol -- safe
                    var symbol = Symbol();
                    var alphabet = "abcdefghijklmnopqrst";
                    A[symbol] = 7;
                    alphabet.split("").forEach(function(chr) {
                        B[chr] = chr;
                    });
                    return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join("") != alphabet;
                }) ? function assign(target, source) {
                    var T = toObject(target);
                    var argumentsLength = arguments.length;
                    var index = 1;
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    var propertyIsEnumerable = propertyIsEnumerableModule.f;
                    while(argumentsLength > index){
                        var S = IndexedObject(arguments[index++]);
                        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
                        var length = keys.length;
                        var j = 0;
                        var key;
                        while(length > j){
                            key = keys[j++];
                            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
                        }
                    }
                    return T;
                } : $assign;
            /***/ },
            /***/ 51569: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* global ActiveXObject -- old IE, WSH */ var anObject = __webpack_require__(83875);
                var defineProperties = __webpack_require__(17840);
                var enumBugKeys = __webpack_require__(48869);
                var hiddenKeys = __webpack_require__(47505);
                var html = __webpack_require__(47055);
                var documentCreateElement = __webpack_require__(92750);
                var sharedKey = __webpack_require__(50466);
                var GT = ">";
                var LT = "<";
                var PROTOTYPE = "prototype";
                var SCRIPT = "script";
                var IE_PROTO = sharedKey("IE_PROTO");
                var EmptyConstructor = function() {};
                var scriptTag = function(content) {
                    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
                };
                // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
                var NullProtoObjectViaActiveX = function(activeXDocument) {
                    activeXDocument.write(scriptTag(""));
                    activeXDocument.close();
                    var temp = activeXDocument.parentWindow.Object;
                    activeXDocument = null; // avoid memory leak
                    return temp;
                };
                // Create object with fake `null` prototype: use iframe Object with cleared prototype
                var NullProtoObjectViaIFrame = function() {
                    // Thrash, waste and sodomy: IE GC bug
                    var iframe = documentCreateElement("iframe");
                    var JS = "java" + SCRIPT + ":";
                    var iframeDocument;
                    iframe.style.display = "none";
                    html.appendChild(iframe);
                    // https://github.com/zloirock/core-js/issues/475
                    iframe.src = String(JS);
                    iframeDocument = iframe.contentWindow.document;
                    iframeDocument.open();
                    iframeDocument.write(scriptTag("document.F=Object"));
                    iframeDocument.close();
                    return iframeDocument.F;
                };
                // Check for document.domain and active x support
                // No need to use active x approach when document.domain is not set
                // see https://github.com/es-shims/es5-shim/issues/150
                // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
                // avoid IE GC bug
                var activeXDocument;
                var NullProtoObject = function() {
                    try {
                        activeXDocument = new ActiveXObject("htmlfile");
                    } catch (error) {}
                    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
                     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
                    var length = enumBugKeys.length;
                    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                    return NullProtoObject();
                };
                hiddenKeys[IE_PROTO] = true;
                // `Object.create` method
                // https://tc39.es/ecma262/#sec-object.create
                module1.exports = Object.create || function create(O, Properties) {
                    var result;
                    if (O !== null) {
                        EmptyConstructor[PROTOTYPE] = anObject(O);
                        result = new EmptyConstructor();
                        EmptyConstructor[PROTOTYPE] = null;
                        // add "__proto__" for Object.getPrototypeOf polyfill
                        result[IE_PROTO] = O;
                    } else result = NullProtoObject();
                    return Properties === undefined ? result : defineProperties(result, Properties);
                };
            /***/ },
            /***/ 17840: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var definePropertyModule = __webpack_require__(86385);
                var anObject = __webpack_require__(83875);
                var toIndexedObject = __webpack_require__(29580);
                var objectKeys = __webpack_require__(60667);
                // `Object.defineProperties` method
                // https://tc39.es/ecma262/#sec-object.defineproperties
                // eslint-disable-next-line es/no-object-defineproperties -- safe
                module1.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                    anObject(O);
                    var props = toIndexedObject(Properties);
                    var keys = objectKeys(Properties);
                    var length = keys.length;
                    var index = 0;
                    var key;
                    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
                    return O;
                };
            /***/ },
            /***/ 86385: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var DESCRIPTORS = __webpack_require__(7493);
                var IE8_DOM_DEFINE = __webpack_require__(67548);
                var anObject = __webpack_require__(83875);
                var toPropertyKey = __webpack_require__(383);
                var TypeError1 = global.TypeError;
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var $defineProperty = Object.defineProperty;
                // `Object.defineProperty` method
                // https://tc39.es/ecma262/#sec-object.defineproperty
                exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPropertyKey(P);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE) try {
                        return $defineProperty(O, P, Attributes);
                    } catch (error) {}
                    if ("get" in Attributes || "set" in Attributes) throw TypeError1("Accessors not supported");
                    if ("value" in Attributes) O[P] = Attributes.value;
                    return O;
                };
            /***/ },
            /***/ 66012: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var call = __webpack_require__(79611);
                var propertyIsEnumerableModule = __webpack_require__(81513);
                var createPropertyDescriptor = __webpack_require__(69199);
                var toIndexedObject = __webpack_require__(29580);
                var toPropertyKey = __webpack_require__(383);
                var hasOwn = __webpack_require__(24792);
                var IE8_DOM_DEFINE = __webpack_require__(67548);
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
                exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                    O = toIndexedObject(O);
                    P = toPropertyKey(P);
                    if (IE8_DOM_DEFINE) try {
                        return $getOwnPropertyDescriptor(O, P);
                    } catch (error) {}
                    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
                };
            /***/ },
            /***/ 74938: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable es/no-object-getownpropertynames -- safe */ var classof = __webpack_require__(79159);
                var toIndexedObject = __webpack_require__(29580);
                var $getOwnPropertyNames = __webpack_require__(87994).f;
                var arraySlice = __webpack_require__(15629);
                var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                var getWindowNames = function(it) {
                    try {
                        return $getOwnPropertyNames(it);
                    } catch (error) {
                        return arraySlice(windowNames);
                    }
                };
                // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
                module1.exports.f = function getOwnPropertyNames(it) {
                    return windowNames && classof(it) == "Window" ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
                };
            /***/ },
            /***/ 87994: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var internalObjectKeys = __webpack_require__(18794);
                var enumBugKeys = __webpack_require__(48869);
                var hiddenKeys = enumBugKeys.concat("length", "prototype");
                // `Object.getOwnPropertyNames` method
                // https://tc39.es/ecma262/#sec-object.getownpropertynames
                // eslint-disable-next-line es/no-object-getownpropertynames -- safe
                exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                };
            /***/ },
            /***/ 89612: /***/ function(__unused_webpack_module, exports) {
                // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
                exports.f = Object.getOwnPropertySymbols;
            /***/ },
            /***/ 12654: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var hasOwn = __webpack_require__(24792);
                var isCallable = __webpack_require__(75277);
                var toObject = __webpack_require__(30744);
                var sharedKey = __webpack_require__(50466);
                var CORRECT_PROTOTYPE_GETTER = __webpack_require__(25115);
                var IE_PROTO = sharedKey("IE_PROTO");
                var Object1 = global.Object;
                var ObjectPrototype = Object1.prototype;
                // `Object.getPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.getprototypeof
                module1.exports = CORRECT_PROTOTYPE_GETTER ? Object1.getPrototypeOf : function(O) {
                    var object = toObject(O);
                    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
                    var constructor = object.constructor;
                    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
                    return object instanceof Object1 ? ObjectPrototype : null;
                };
            /***/ },
            /***/ 32010: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                module1.exports = uncurryThis({}.isPrototypeOf);
            /***/ },
            /***/ 18794: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var hasOwn = __webpack_require__(24792);
                var toIndexedObject = __webpack_require__(29580);
                var indexOf = __webpack_require__(37190).indexOf;
                var hiddenKeys = __webpack_require__(47505);
                var push = uncurryThis([].push);
                module1.exports = function(object, names) {
                    var O = toIndexedObject(object);
                    var i = 0;
                    var result = [];
                    var key;
                    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
                    // Don't enum bug & hidden keys
                    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
                    return result;
                };
            /***/ },
            /***/ 60667: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var internalObjectKeys = __webpack_require__(18794);
                var enumBugKeys = __webpack_require__(48869);
                // `Object.keys` method
                // https://tc39.es/ecma262/#sec-object.keys
                // eslint-disable-next-line es/no-object-keys -- safe
                module1.exports = Object.keys || function keys(O) {
                    return internalObjectKeys(O, enumBugKeys);
                };
            /***/ },
            /***/ 81513: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var $propertyIsEnumerable = {}.propertyIsEnumerable;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // Nashorn ~ JDK8 bug
                var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
                    1: 2
                }, 1);
                // `Object.prototype.propertyIsEnumerable` method implementation
                // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
                exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                    var descriptor = getOwnPropertyDescriptor(this, V);
                    return !!descriptor && descriptor.enumerable;
                } : $propertyIsEnumerable;
            /***/ },
            /***/ 22412: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable no-proto -- safe */ var uncurryThis = __webpack_require__(88697);
                var anObject = __webpack_require__(83875);
                var aPossiblePrototype = __webpack_require__(75017);
                // `Object.setPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.setprototypeof
                // Works with __proto__ only. Old v8 can't work with null proto objects.
                // eslint-disable-next-line es/no-object-setprototypeof -- safe
                module1.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var CORRECT_SETTER = false;
                    var test = {};
                    var setter;
                    try {
                        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                        setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
                        setter(test, []);
                        CORRECT_SETTER = test instanceof Array;
                    } catch (error) {}
                    return function setPrototypeOf(O, proto) {
                        anObject(O);
                        aPossiblePrototype(proto);
                        if (CORRECT_SETTER) setter(O, proto);
                        else O.__proto__ = proto;
                        return O;
                    };
                }() : undefined);
            /***/ },
            /***/ 8765: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var uncurryThis = __webpack_require__(88697);
                var objectKeys = __webpack_require__(60667);
                var toIndexedObject = __webpack_require__(29580);
                var $propertyIsEnumerable = __webpack_require__(81513).f;
                var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
                var push = uncurryThis([].push);
                // `Object.{ entries, values }` methods implementation
                var createMethod = function(TO_ENTRIES) {
                    return function(it) {
                        var O = toIndexedObject(it);
                        var keys = objectKeys(O);
                        var length = keys.length;
                        var i = 0;
                        var result = [];
                        var key;
                        while(length > i){
                            key = keys[i++];
                            if (!DESCRIPTORS || propertyIsEnumerable(O, key)) push(result, TO_ENTRIES ? [
                                key,
                                O[key]
                            ] : O[key]);
                        }
                        return result;
                    };
                };
                module1.exports = {
                    // `Object.entries` method
                    // https://tc39.es/ecma262/#sec-object.entries
                    entries: createMethod(true),
                    // `Object.values` method
                    // https://tc39.es/ecma262/#sec-object.values
                    values: createMethod(false)
                };
            /***/ },
            /***/ 36699: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TO_STRING_TAG_SUPPORT = __webpack_require__(57301);
                var classof = __webpack_require__(36994);
                // `Object.prototype.toString` method implementation
                // https://tc39.es/ecma262/#sec-object.prototype.tostring
                module1.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
                    return "[object " + classof(this) + "]";
                };
            /***/ },
            /***/ 17141: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var call = __webpack_require__(79611);
                var isCallable = __webpack_require__(75277);
                var isObject = __webpack_require__(52786);
                var TypeError1 = global.TypeError;
                // `OrdinaryToPrimitive` abstract operation
                // https://tc39.es/ecma262/#sec-ordinarytoprimitive
                module1.exports = function(input, pref) {
                    var fn, val;
                    if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
                    if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    throw TypeError1("Can't convert object to primitive value");
                };
            /***/ },
            /***/ 31561: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var getBuiltIn = __webpack_require__(22773);
                var uncurryThis = __webpack_require__(88697);
                var getOwnPropertyNamesModule = __webpack_require__(87994);
                var getOwnPropertySymbolsModule = __webpack_require__(89612);
                var anObject = __webpack_require__(83875);
                var concat = uncurryThis([].concat);
                // all object keys, includes non-enumerable and symbols
                module1.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
                };
            /***/ },
            /***/ 67290: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                module1.exports = global;
            /***/ },
            /***/ 74443: /***/ function(module1) {
                module1.exports = function(exec) {
                    try {
                        return {
                            error: false,
                            value: exec()
                        };
                    } catch (error) {
                        return {
                            error: true,
                            value: error
                        };
                    }
                };
            /***/ },
            /***/ 11621: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var anObject = __webpack_require__(83875);
                var isObject = __webpack_require__(52786);
                var newPromiseCapability = __webpack_require__(29269);
                module1.exports = function(C, x) {
                    anObject(C);
                    if (isObject(x) && x.constructor === C) return x;
                    var promiseCapability = newPromiseCapability.f(C);
                    var resolve = promiseCapability.resolve;
                    resolve(x);
                    return promiseCapability.promise;
                };
            /***/ },
            /***/ 7592: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var redefine = __webpack_require__(35974);
                module1.exports = function(target, src, options) {
                    for(var key in src)redefine(target, key, src[key], options);
                    return target;
                };
            /***/ },
            /***/ 35974: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var isCallable = __webpack_require__(75277);
                var hasOwn = __webpack_require__(24792);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var setGlobal = __webpack_require__(51621);
                var inspectSource = __webpack_require__(56429);
                var InternalStateModule = __webpack_require__(20821);
                var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(55316).CONFIGURABLE;
                var getInternalState = InternalStateModule.get;
                var enforceInternalState = InternalStateModule.enforce;
                var TEMPLATE = String(String).split("String");
                (module1.exports = function(O, key, value, options) {
                    var unsafe = options ? !!options.unsafe : false;
                    var simple = options ? !!options.enumerable : false;
                    var noTargetGet = options ? !!options.noTargetGet : false;
                    var name = options && options.name !== undefined ? options.name : key;
                    var state;
                    if (isCallable(value)) {
                        if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
                        if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) createNonEnumerableProperty(value, "name", name);
                        state = enforceInternalState(value);
                        if (!state.source) state.source = TEMPLATE.join(typeof name == "string" ? name : "");
                    }
                    if (O === global) {
                        if (simple) O[key] = value;
                        else setGlobal(key, value);
                        return;
                    } else if (!unsafe) delete O[key];
                    else if (!noTargetGet && O[key]) simple = true;
                    if (simple) O[key] = value;
                    else createNonEnumerableProperty(O, key, value);
                // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
                })(Function.prototype, "toString", function toString() {
                    return isCallable(this) && getInternalState(this).source || inspectSource(this);
                });
            /***/ },
            /***/ 94088: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var call = __webpack_require__(79611);
                var anObject = __webpack_require__(83875);
                var isCallable = __webpack_require__(75277);
                var classof = __webpack_require__(79159);
                var regexpExec = __webpack_require__(99749);
                var TypeError1 = global.TypeError;
                // `RegExpExec` abstract operation
                // https://tc39.es/ecma262/#sec-regexpexec
                module1.exports = function(R, S) {
                    var exec = R.exec;
                    if (isCallable(exec)) {
                        var result = call(exec, R, S);
                        if (result !== null) anObject(result);
                        return result;
                    }
                    if (classof(R) === "RegExp") return call(regexpExec, R, S);
                    throw TypeError1("RegExp#exec called on incompatible receiver");
                };
            /***/ },
            /***/ 99749: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = __webpack_require__(79611);
                var uncurryThis = __webpack_require__(88697);
                var toString = __webpack_require__(28967);
                var regexpFlags = __webpack_require__(58083);
                var stickyHelpers = __webpack_require__(97047);
                var shared = __webpack_require__(53580);
                var create = __webpack_require__(51569);
                var getInternalState = __webpack_require__(20821).get;
                var UNSUPPORTED_DOT_ALL = __webpack_require__(41669);
                var UNSUPPORTED_NCG = __webpack_require__(1638);
                var nativeReplace = shared("native-string-replace", String.prototype.replace);
                var nativeExec = RegExp.prototype.exec;
                var patchedExec = nativeExec;
                var charAt = uncurryThis("".charAt);
                var indexOf = uncurryThis("".indexOf);
                var replace = uncurryThis("".replace);
                var stringSlice = uncurryThis("".slice);
                var UPDATES_LAST_INDEX_WRONG = function() {
                    var re1 = /a/;
                    var re2 = /b*/g;
                    call(nativeExec, re1, "a");
                    call(nativeExec, re2, "a");
                    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
                }();
                var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;
                // nonparticipating capturing group, copied from es5-shim's String#split patch.
                var NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
                var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
                if (PATCH) // eslint-disable-next-line max-statements -- TODO
                patchedExec = function exec(string) {
                    var re = this;
                    var state = getInternalState(re);
                    var str = toString(string);
                    var raw = state.raw;
                    var result, reCopy, lastIndex, match, i, object, group;
                    if (raw) {
                        raw.lastIndex = re.lastIndex;
                        result = call(patchedExec, raw, str);
                        re.lastIndex = raw.lastIndex;
                        return result;
                    }
                    var groups = state.groups;
                    var sticky = UNSUPPORTED_Y && re.sticky;
                    var flags = call(regexpFlags, re);
                    var source = re.source;
                    var charsAdded = 0;
                    var strCopy = str;
                    if (sticky) {
                        flags = replace(flags, "y", "");
                        if (indexOf(flags, "g") === -1) flags += "g";
                        strCopy = stringSlice(str, re.lastIndex);
                        // Support anchored sticky behavior.
                        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== "\n")) {
                            source = "(?: " + source + ")";
                            strCopy = " " + strCopy;
                            charsAdded++;
                        }
                        // ^(? + rx + ) is needed, in combination with some str slicing, to
                        // simulate the 'y' flag.
                        reCopy = new RegExp("^(?:" + source + ")", flags);
                    }
                    if (NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
                    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
                    match = call(nativeExec, sticky ? reCopy : re, strCopy);
                    if (sticky) {
                        if (match) {
                            match.input = stringSlice(match.input, charsAdded);
                            match[0] = stringSlice(match[0], charsAdded);
                            match.index = re.lastIndex;
                            re.lastIndex += match[0].length;
                        } else re.lastIndex = 0;
                    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
                    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
                    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
                    call(nativeReplace, match[0], reCopy, function() {
                        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
                    });
                    if (match && groups) {
                        match.groups = object = create(null);
                        for(i = 0; i < groups.length; i++){
                            group = groups[i];
                            object[group[0]] = match[group[1]];
                        }
                    }
                    return match;
                };
                module1.exports = patchedExec;
            /***/ },
            /***/ 58083: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__(83875);
                // `RegExp.prototype.flags` getter implementation
                // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
                module1.exports = function() {
                    var that = anObject(this);
                    var result = "";
                    if (that.global) result += "g";
                    if (that.ignoreCase) result += "i";
                    if (that.multiline) result += "m";
                    if (that.dotAll) result += "s";
                    if (that.unicode) result += "u";
                    if (that.sticky) result += "y";
                    return result;
                };
            /***/ },
            /***/ 97047: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                var global = __webpack_require__(98363);
                // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
                var $RegExp = global.RegExp;
                exports.UNSUPPORTED_Y = fails(function() {
                    var re = $RegExp("a", "y");
                    re.lastIndex = 2;
                    return re.exec("abcd") != null;
                });
                exports.BROKEN_CARET = fails(function() {
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
                    var re = $RegExp("^r", "gy");
                    re.lastIndex = 2;
                    return re.exec("str") != null;
                });
            /***/ },
            /***/ 41669: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                var global = __webpack_require__(98363);
                // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
                var $RegExp = global.RegExp;
                module1.exports = fails(function() {
                    var re = $RegExp(".", "s");
                    return !(re.dotAll && re.exec("\n") && re.flags === "s");
                });
            /***/ },
            /***/ 1638: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                var global = __webpack_require__(98363);
                // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
                var $RegExp = global.RegExp;
                module1.exports = fails(function() {
                    var re = $RegExp("(?<a>b)", "g");
                    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
                });
            /***/ },
            /***/ 96411: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var TypeError1 = global.TypeError;
                // `RequireObjectCoercible` abstract operation
                // https://tc39.es/ecma262/#sec-requireobjectcoercible
                module1.exports = function(it) {
                    if (it == undefined) throw TypeError1("Can't call method on " + it);
                    return it;
                };
            /***/ },
            /***/ 51621: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var defineProperty = Object.defineProperty;
                module1.exports = function(key, value) {
                    try {
                        defineProperty(global, key, {
                            value: value,
                            configurable: true,
                            writable: true
                        });
                    } catch (error) {
                        global[key] = value;
                    }
                    return value;
                };
            /***/ },
            /***/ 57323: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(22773);
                var definePropertyModule = __webpack_require__(86385);
                var wellKnownSymbol = __webpack_require__(52280);
                var DESCRIPTORS = __webpack_require__(7493);
                var SPECIES = wellKnownSymbol("species");
                module1.exports = function(CONSTRUCTOR_NAME) {
                    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
                    var defineProperty = definePropertyModule.f;
                    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineProperty(Constructor, SPECIES, {
                        configurable: true,
                        get: function() {
                            return this;
                        }
                    });
                };
            /***/ },
            /***/ 60878: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var defineProperty = __webpack_require__(86385).f;
                var hasOwn = __webpack_require__(24792);
                var wellKnownSymbol = __webpack_require__(52280);
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                module1.exports = function(it, TAG, STATIC) {
                    if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
                        configurable: true,
                        value: TAG
                    });
                };
            /***/ },
            /***/ 50466: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var shared = __webpack_require__(53580);
                var uid = __webpack_require__(34524);
                var keys = shared("keys");
                module1.exports = function(key) {
                    return keys[key] || (keys[key] = uid(key));
                };
            /***/ },
            /***/ 49415: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var setGlobal = __webpack_require__(51621);
                var SHARED = "__core-js_shared__";
                var store = global[SHARED] || setGlobal(SHARED, {});
                module1.exports = store;
            /***/ },
            /***/ 53580: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var IS_PURE = __webpack_require__(21178);
                var store = __webpack_require__(49415);
                (module1.exports = function(key, value) {
                    return store[key] || (store[key] = value !== undefined ? value : {});
                })("versions", []).push({
                    version: "3.19.0",
                    mode: IS_PURE ? "pure" : "global",
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            /***/ },
            /***/ 7270: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var anObject = __webpack_require__(83875);
                var aConstructor = __webpack_require__(43327);
                var wellKnownSymbol = __webpack_require__(52280);
                var SPECIES = wellKnownSymbol("species");
                // `SpeciesConstructor` abstract operation
                // https://tc39.es/ecma262/#sec-speciesconstructor
                module1.exports = function(O, defaultConstructor) {
                    var C = anObject(O).constructor;
                    var S;
                    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
                };
            /***/ },
            /***/ 13881: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(79044);
                // check the existence of a method, lowercase
                // of a tag and escaping quotes in arguments
                module1.exports = function(METHOD_NAME) {
                    return fails(function() {
                        var test = ""[METHOD_NAME]('"');
                        return test !== test.toLowerCase() || test.split('"').length > 3;
                    });
                };
            /***/ },
            /***/ 91140: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var toString = __webpack_require__(28967);
                var requireObjectCoercible = __webpack_require__(96411);
                var charAt = uncurryThis("".charAt);
                var charCodeAt = uncurryThis("".charCodeAt);
                var stringSlice = uncurryThis("".slice);
                var createMethod = function(CONVERT_TO_STRING) {
                    return function($this, pos) {
                        var S = toString(requireObjectCoercible($this));
                        var position = toIntegerOrInfinity(pos);
                        var size = S.length;
                        var first, second;
                        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
                        first = charCodeAt(S, position);
                        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
                    };
                };
                module1.exports = {
                    // `String.prototype.codePointAt` method
                    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                    codeAt: createMethod(false),
                    // `String.prototype.at` method
                    // https://github.com/mathiasbynens/String.prototype.at
                    charAt: createMethod(true)
                };
            /***/ },
            /***/ 26031: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var toString = __webpack_require__(28967);
                var requireObjectCoercible = __webpack_require__(96411);
                var RangeError1 = global.RangeError;
                // `String.prototype.repeat` method implementation
                // https://tc39.es/ecma262/#sec-string.prototype.repeat
                module1.exports = function repeat(count) {
                    var str = toString(requireObjectCoercible(this));
                    var result = "";
                    var n = toIntegerOrInfinity(count);
                    if (n < 0 || n == Infinity) throw RangeError1("Wrong number of repetitions");
                    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
                    return result;
                };
            /***/ },
            /***/ 68487: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var PROPER_FUNCTION_NAME = __webpack_require__(55316).PROPER;
                var fails = __webpack_require__(79044);
                var whitespaces = __webpack_require__(2569);
                var non = "\u200B\x85\u180E";
                // check that a method works with the correct list
                // of whitespaces and has a correct name
                module1.exports = function(METHOD_NAME) {
                    return fails(function() {
                        return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
                    });
                };
            /***/ },
            /***/ 10287: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var requireObjectCoercible = __webpack_require__(96411);
                var toString = __webpack_require__(28967);
                var whitespaces = __webpack_require__(2569);
                var replace = uncurryThis("".replace);
                var whitespace = "[" + whitespaces + "]";
                var ltrim = RegExp("^" + whitespace + whitespace + "*");
                var rtrim = RegExp(whitespace + whitespace + "*$");
                // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
                var createMethod = function(TYPE) {
                    return function($this) {
                        var string = toString(requireObjectCoercible($this));
                        if (TYPE & 1) string = replace(string, ltrim, "");
                        if (TYPE & 2) string = replace(string, rtrim, "");
                        return string;
                    };
                };
                module1.exports = {
                    // `String.prototype.{ trimLeft, trimStart }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                    start: createMethod(1),
                    // `String.prototype.{ trimRight, trimEnd }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimend
                    end: createMethod(2),
                    // `String.prototype.trim` method
                    // https://tc39.es/ecma262/#sec-string.prototype.trim
                    trim: createMethod(3)
                };
            /***/ },
            /***/ 84643: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var apply = __webpack_require__(63530);
                var bind = __webpack_require__(98166);
                var isCallable = __webpack_require__(75277);
                var hasOwn = __webpack_require__(24792);
                var fails = __webpack_require__(79044);
                var html = __webpack_require__(47055);
                var arraySlice = __webpack_require__(15629);
                var createElement = __webpack_require__(92750);
                var IS_IOS = __webpack_require__(53121);
                var IS_NODE = __webpack_require__(93921);
                var set = global.setImmediate;
                var clear = global.clearImmediate;
                var process = global.process;
                var Dispatch = global.Dispatch;
                var Function1 = global.Function;
                var MessageChannel = global.MessageChannel;
                var String1 = global.String;
                var counter = 0;
                var queue = {};
                var ONREADYSTATECHANGE = "onreadystatechange";
                var location1, defer, channel, port;
                try {
                    // Deno throws a ReferenceError on `location` access without `--location` flag
                    location1 = global.location;
                } catch (error) {}
                var run = function(id) {
                    if (hasOwn(queue, id)) {
                        var fn = queue[id];
                        delete queue[id];
                        fn();
                    }
                };
                var runner = function(id) {
                    return function() {
                        run(id);
                    };
                };
                var listener = function(event) {
                    run(event.data);
                };
                var post = function(id) {
                    // old engines have not location.origin
                    global.postMessage(String1(id), location1.protocol + "//" + location1.host);
                };
                // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
                if (!set || !clear) {
                    set = function setImmediate(fn) {
                        var args = arraySlice(arguments, 1);
                        queue[++counter] = function() {
                            apply(isCallable(fn) ? fn : Function1(fn), undefined, args);
                        };
                        defer(counter);
                        return counter;
                    };
                    clear = function clearImmediate(id) {
                        delete queue[id];
                    };
                    // Node.js 0.8-
                    if (IS_NODE) defer = function(id) {
                        process.nextTick(runner(id));
                    };
                    else if (Dispatch && Dispatch.now) defer = function(id) {
                        Dispatch.now(runner(id));
                    };
                    else if (MessageChannel && !IS_IOS) {
                        channel = new MessageChannel();
                        port = channel.port2;
                        channel.port1.onmessage = listener;
                        defer = bind(port.postMessage, port);
                    // Browsers with postMessage, skip WebWorkers
                    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
                    } else if (global.addEventListener && isCallable(global.postMessage) && !global.importScripts && location1 && location1.protocol !== "file:" && !fails(post)) {
                        defer = post;
                        global.addEventListener("message", listener, false);
                    // IE8-
                    } else if (ONREADYSTATECHANGE in createElement("script")) defer = function(id) {
                        html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
                            html.removeChild(this);
                            run(id);
                        };
                    };
                    else defer = function(id) {
                        setTimeout(runner(id), 0);
                    };
                }
                module1.exports = {
                    set: set,
                    clear: clear
                };
            /***/ },
            /***/ 41655: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                // `thisNumberValue` abstract operation
                // https://tc39.es/ecma262/#sec-thisnumbervalue
                module1.exports = uncurryThis(1.0.valueOf);
            /***/ },
            /***/ 32565: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toIntegerOrInfinity = __webpack_require__(14229);
                var max = Math.max;
                var min = Math.min;
                // Helper for a popular repeating case of the spec:
                // Let integer be ? ToInteger(index).
                // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
                module1.exports = function(index, length) {
                    var integer = toIntegerOrInfinity(index);
                    return integer < 0 ? max(integer + length, 0) : min(integer, length);
                };
            /***/ },
            /***/ 27302: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var toLength = __webpack_require__(35108);
                var RangeError1 = global.RangeError;
                // `ToIndex` abstract operation
                // https://tc39.es/ecma262/#sec-toindex
                module1.exports = function(it) {
                    if (it === undefined) return 0;
                    var number = toIntegerOrInfinity(it);
                    var length = toLength(number);
                    if (number !== length) throw RangeError1("Wrong length or index");
                    return length;
                };
            /***/ },
            /***/ 29580: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // toObject with fallback for non-array-like ES3 strings
                var IndexedObject = __webpack_require__(78609);
                var requireObjectCoercible = __webpack_require__(96411);
                module1.exports = function(it) {
                    return IndexedObject(requireObjectCoercible(it));
                };
            /***/ },
            /***/ 14229: /***/ function(module1) {
                var ceil = Math.ceil;
                var floor = Math.floor;
                // `ToIntegerOrInfinity` abstract operation
                // https://tc39.es/ecma262/#sec-tointegerorinfinity
                module1.exports = function(argument) {
                    var number = +argument;
                    // eslint-disable-next-line no-self-compare -- safe
                    return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
                };
            /***/ },
            /***/ 35108: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toIntegerOrInfinity = __webpack_require__(14229);
                var min = Math.min;
                // `ToLength` abstract operation
                // https://tc39.es/ecma262/#sec-tolength
                module1.exports = function(argument) {
                    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
                };
            /***/ },
            /***/ 30744: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var requireObjectCoercible = __webpack_require__(96411);
                var Object1 = global.Object;
                // `ToObject` abstract operation
                // https://tc39.es/ecma262/#sec-toobject
                module1.exports = function(argument) {
                    return Object1(requireObjectCoercible(argument));
                };
            /***/ },
            /***/ 65758: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var toPositiveInteger = __webpack_require__(83786);
                var RangeError1 = global.RangeError;
                module1.exports = function(it, BYTES) {
                    var offset = toPositiveInteger(it);
                    if (offset % BYTES) throw RangeError1("Wrong offset");
                    return offset;
                };
            /***/ },
            /***/ 83786: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var RangeError1 = global.RangeError;
                module1.exports = function(it) {
                    var result = toIntegerOrInfinity(it);
                    if (result < 0) throw RangeError1("The argument can't be less than 0");
                    return result;
                };
            /***/ },
            /***/ 21893: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var call = __webpack_require__(79611);
                var isObject = __webpack_require__(52786);
                var isSymbol = __webpack_require__(66681);
                var getMethod = __webpack_require__(97219);
                var ordinaryToPrimitive = __webpack_require__(17141);
                var wellKnownSymbol = __webpack_require__(52280);
                var TypeError1 = global.TypeError;
                var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
                // `ToPrimitive` abstract operation
                // https://tc39.es/ecma262/#sec-toprimitive
                module1.exports = function(input, pref) {
                    if (!isObject(input) || isSymbol(input)) return input;
                    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
                    var result;
                    if (exoticToPrim) {
                        if (pref === undefined) pref = "default";
                        result = call(exoticToPrim, input, pref);
                        if (!isObject(result) || isSymbol(result)) return result;
                        throw TypeError1("Can't convert object to primitive value");
                    }
                    if (pref === undefined) pref = "number";
                    return ordinaryToPrimitive(input, pref);
                };
            /***/ },
            /***/ 383: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toPrimitive = __webpack_require__(21893);
                var isSymbol = __webpack_require__(66681);
                // `ToPropertyKey` abstract operation
                // https://tc39.es/ecma262/#sec-topropertykey
                module1.exports = function(argument) {
                    var key = toPrimitive(argument, "string");
                    return isSymbol(key) ? key : key + "";
                };
            /***/ },
            /***/ 57301: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(52280);
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var test = {};
                test[TO_STRING_TAG] = "z";
                module1.exports = String(test) === "[object z]";
            /***/ },
            /***/ 28967: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var classof = __webpack_require__(36994);
                var String1 = global.String;
                module1.exports = function(argument) {
                    if (classof(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
                    return String1(argument);
                };
            /***/ },
            /***/ 28768: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var String1 = global.String;
                module1.exports = function(argument) {
                    try {
                        return String1(argument);
                    } catch (error) {
                        return "Object";
                    }
                };
            /***/ },
            /***/ 26764: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var call = __webpack_require__(79611);
                var DESCRIPTORS = __webpack_require__(7493);
                var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(63231);
                var ArrayBufferViewCore = __webpack_require__(32590);
                var ArrayBufferModule = __webpack_require__(74510);
                var anInstance = __webpack_require__(9519);
                var createPropertyDescriptor = __webpack_require__(69199);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var isIntegralNumber = __webpack_require__(57507);
                var toLength = __webpack_require__(35108);
                var toIndex = __webpack_require__(27302);
                var toOffset = __webpack_require__(65758);
                var toPropertyKey = __webpack_require__(383);
                var hasOwn = __webpack_require__(24792);
                var classof = __webpack_require__(36994);
                var isObject = __webpack_require__(52786);
                var isSymbol = __webpack_require__(66681);
                var create = __webpack_require__(51569);
                var isPrototypeOf = __webpack_require__(32010);
                var setPrototypeOf = __webpack_require__(22412);
                var getOwnPropertyNames = __webpack_require__(87994).f;
                var typedArrayFrom = __webpack_require__(66503);
                var forEach = __webpack_require__(68671).forEach;
                var setSpecies = __webpack_require__(57323);
                var definePropertyModule = __webpack_require__(86385);
                var getOwnPropertyDescriptorModule = __webpack_require__(66012);
                var InternalStateModule = __webpack_require__(20821);
                var inheritIfRequired = __webpack_require__(59250);
                var getInternalState = InternalStateModule.get;
                var setInternalState = InternalStateModule.set;
                var nativeDefineProperty = definePropertyModule.f;
                var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                var round = Math.round;
                var RangeError1 = global.RangeError;
                var ArrayBuffer1 = ArrayBufferModule.ArrayBuffer;
                var ArrayBufferPrototype = ArrayBuffer1.prototype;
                var DataView1 = ArrayBufferModule.DataView;
                var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
                var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
                var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
                var TypedArray = ArrayBufferViewCore.TypedArray;
                var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
                var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
                var isTypedArray = ArrayBufferViewCore.isTypedArray;
                var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
                var WRONG_LENGTH = "Wrong length";
                var fromList = function(C, list) {
                    aTypedArrayConstructor(C);
                    var index = 0;
                    var length = list.length;
                    var result = new C(length);
                    while(length > index)result[index] = list[index++];
                    return result;
                };
                var addGetter = function(it, key) {
                    nativeDefineProperty(it, key, {
                        get: function() {
                            return getInternalState(this)[key];
                        }
                    });
                };
                var isArrayBuffer = function(it) {
                    var klass;
                    return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == "ArrayBuffer" || klass == "SharedArrayBuffer";
                };
                var isTypedArrayIndex = function(target, key) {
                    return isTypedArray(target) && !isSymbol(key) && key in target && isIntegralNumber(+key) && key >= 0;
                };
                var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
                    key = toPropertyKey(key);
                    return isTypedArrayIndex(target, key) ? createPropertyDescriptor(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
                };
                var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
                    key = toPropertyKey(key);
                    if (isTypedArrayIndex(target, key) && isObject(descriptor) && hasOwn(descriptor, "value") && !hasOwn(descriptor, "get") && !hasOwn(descriptor, "set") && !descriptor.configurable && (!hasOwn(descriptor, "writable") || descriptor.writable) && (!hasOwn(descriptor, "enumerable") || descriptor.enumerable)) {
                        target[key] = descriptor.value;
                        return target;
                    }
                    return nativeDefineProperty(target, key, descriptor);
                };
                if (DESCRIPTORS) {
                    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
                        getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
                        definePropertyModule.f = wrappedDefineProperty;
                        addGetter(TypedArrayPrototype, "buffer");
                        addGetter(TypedArrayPrototype, "byteOffset");
                        addGetter(TypedArrayPrototype, "byteLength");
                        addGetter(TypedArrayPrototype, "length");
                    }
                    $({
                        target: "Object",
                        stat: true,
                        forced: !NATIVE_ARRAY_BUFFER_VIEWS
                    }, {
                        getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
                        defineProperty: wrappedDefineProperty
                    });
                    module1.exports = function(TYPE, wrapper, CLAMPED) {
                        var BYTES = TYPE.match(/\d+$/)[0] / 8;
                        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
                        var GETTER = "get" + TYPE;
                        var SETTER = "set" + TYPE;
                        var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
                        var TypedArrayConstructor = NativeTypedArrayConstructor;
                        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
                        var exported = {};
                        var getter = function(that, index) {
                            var data = getInternalState(that);
                            return data.view[GETTER](index * BYTES + data.byteOffset, true);
                        };
                        var setter = function(that, index, value) {
                            var data = getInternalState(that);
                            if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
                            data.view[SETTER](index * BYTES + data.byteOffset, value, true);
                        };
                        var addElement = function(that, index) {
                            nativeDefineProperty(that, index, {
                                get: function() {
                                    return getter(this, index);
                                },
                                set: function(value) {
                                    return setter(this, index, value);
                                },
                                enumerable: true
                            });
                        };
                        if (!NATIVE_ARRAY_BUFFER_VIEWS) {
                            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                                anInstance(that, TypedArrayConstructorPrototype);
                                var index = 0;
                                var byteOffset = 0;
                                var buffer, byteLength, length;
                                if (!isObject(data)) {
                                    length = toIndex(data);
                                    byteLength = length * BYTES;
                                    buffer = new ArrayBuffer1(byteLength);
                                } else if (isArrayBuffer(data)) {
                                    buffer = data;
                                    byteOffset = toOffset(offset, BYTES);
                                    var $len = data.byteLength;
                                    if ($length === undefined) {
                                        if ($len % BYTES) throw RangeError1(WRONG_LENGTH);
                                        byteLength = $len - byteOffset;
                                        if (byteLength < 0) throw RangeError1(WRONG_LENGTH);
                                    } else {
                                        byteLength = toLength($length) * BYTES;
                                        if (byteLength + byteOffset > $len) throw RangeError1(WRONG_LENGTH);
                                    }
                                    length = byteLength / BYTES;
                                } else if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
                                else return call(typedArrayFrom, TypedArrayConstructor, data);
                                setInternalState(that, {
                                    buffer: buffer,
                                    byteOffset: byteOffset,
                                    byteLength: byteLength,
                                    length: length,
                                    view: new DataView1(buffer)
                                });
                                while(index < length)addElement(that, index++);
                            });
                            if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
                            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
                        } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
                            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                                anInstance(dummy, TypedArrayConstructorPrototype);
                                return inheritIfRequired(function() {
                                    if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
                                    if (isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                                    if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
                                    return call(typedArrayFrom, TypedArrayConstructor, data);
                                }(), dummy, TypedArrayConstructor);
                            });
                            if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
                            forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                                if (!(key in TypedArrayConstructor)) createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
                            });
                            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
                        }
                        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) createNonEnumerableProperty(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
                        createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);
                        if (TYPED_ARRAY_TAG) createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
                        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
                        $({
                            global: true,
                            forced: TypedArrayConstructor != NativeTypedArrayConstructor,
                            sham: !NATIVE_ARRAY_BUFFER_VIEWS
                        }, exported);
                        if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
                        if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
                        setSpecies(CONSTRUCTOR_NAME);
                    };
                } else module1.exports = function() {};
            /***/ },
            /***/ 63231: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable no-new -- required for testing */ var global = __webpack_require__(98363);
                var fails = __webpack_require__(79044);
                var checkCorrectnessOfIteration = __webpack_require__(8662);
                var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(32590).NATIVE_ARRAY_BUFFER_VIEWS;
                var ArrayBuffer1 = global.ArrayBuffer;
                var Int8Array1 = global.Int8Array;
                module1.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function() {
                    Int8Array1(1);
                }) || !fails(function() {
                    new Int8Array1(-1);
                }) || !checkCorrectnessOfIteration(function(iterable) {
                    new Int8Array1();
                    new Int8Array1(null);
                    new Int8Array1(1.5);
                    new Int8Array1(iterable);
                }, true) || fails(function() {
                    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
                    return new Int8Array1(new ArrayBuffer1(2), 1, undefined).length !== 1;
                });
            /***/ },
            /***/ 53687: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arrayFromConstructorAndList = __webpack_require__(65626);
                var typedArraySpeciesConstructor = __webpack_require__(36107);
                module1.exports = function(instance, list) {
                    return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
                };
            /***/ },
            /***/ 66503: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var bind = __webpack_require__(98166);
                var call = __webpack_require__(79611);
                var aConstructor = __webpack_require__(43327);
                var toObject = __webpack_require__(30744);
                var lengthOfArrayLike = __webpack_require__(47046);
                var getIterator = __webpack_require__(11805);
                var getIteratorMethod = __webpack_require__(77193);
                var isArrayIteratorMethod = __webpack_require__(68089);
                var aTypedArrayConstructor = __webpack_require__(32590).aTypedArrayConstructor;
                module1.exports = function from(source /* , mapfn, thisArg */ ) {
                    var C = aConstructor(this);
                    var O = toObject(source);
                    var argumentsLength = arguments.length;
                    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    var iteratorMethod = getIteratorMethod(O);
                    var i, length, result, step, iterator, next;
                    if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
                        iterator = getIterator(O, iteratorMethod);
                        next = iterator.next;
                        O = [];
                        while(!(step = call(next, iterator)).done)O.push(step.value);
                    }
                    if (mapping && argumentsLength > 2) mapfn = bind(mapfn, arguments[2]);
                    length = lengthOfArrayLike(O);
                    result = new (aTypedArrayConstructor(C))(length);
                    for(i = 0; length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
                    return result;
                };
            /***/ },
            /***/ 36107: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var ArrayBufferViewCore = __webpack_require__(32590);
                var speciesConstructor = __webpack_require__(7270);
                var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
                var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
                // a part of `TypedArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#typedarray-species-create
                module1.exports = function(originalArray) {
                    return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
                };
            /***/ },
            /***/ 34524: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(88697);
                var id = 0;
                var postfix = Math.random();
                var toString = uncurryThis(1.0.toString);
                module1.exports = function(key) {
                    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
                };
            /***/ },
            /***/ 189: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = __webpack_require__(3850);
                module1.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
            /***/ },
            /***/ 20127: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(52280);
                exports.f = wellKnownSymbol;
            /***/ },
            /***/ 52280: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var shared = __webpack_require__(53580);
                var hasOwn = __webpack_require__(24792);
                var uid = __webpack_require__(34524);
                var NATIVE_SYMBOL = __webpack_require__(3850);
                var USE_SYMBOL_AS_UID = __webpack_require__(189);
                var WellKnownSymbolsStore = shared("wks");
                var Symbol1 = global.Symbol;
                var symbolFor = Symbol1 && Symbol1["for"];
                var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
                module1.exports = function(name) {
                    if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
                        var description = "Symbol." + name;
                        if (NATIVE_SYMBOL && hasOwn(Symbol1, name)) WellKnownSymbolsStore[name] = Symbol1[name];
                        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
                        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
                    }
                    return WellKnownSymbolsStore[name];
                };
            /***/ },
            /***/ 2569: /***/ function(module1) {
                // a string of all valid unicode whitespaces
                module1.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            /***/ },
            /***/ 55739: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var isPrototypeOf = __webpack_require__(32010);
                var getPrototypeOf = __webpack_require__(12654);
                var setPrototypeOf = __webpack_require__(22412);
                var copyConstructorProperties = __webpack_require__(73870);
                var create = __webpack_require__(51569);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var createPropertyDescriptor = __webpack_require__(69199);
                var clearErrorStack = __webpack_require__(8457);
                var installErrorCause = __webpack_require__(58323);
                var iterate = __webpack_require__(5166);
                var normalizeStringArgument = __webpack_require__(654);
                var ERROR_STACK_INSTALLABLE = __webpack_require__(67679);
                var Error1 = global.Error;
                var push = [].push;
                var $AggregateError = function AggregateError1(errors, message /* , options */ ) {
                    var that = isPrototypeOf(AggregateErrorPrototype, this) ? this : create(AggregateErrorPrototype);
                    var options = arguments.length > 2 ? arguments[2] : undefined;
                    if (setPrototypeOf) that = setPrototypeOf(new Error1(undefined), getPrototypeOf(that));
                    createNonEnumerableProperty(that, "message", normalizeStringArgument(message, ""));
                    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, "stack", clearErrorStack(that.stack, 1));
                    installErrorCause(that, options);
                    var errorsArray = [];
                    iterate(errors, push, {
                        that: errorsArray
                    });
                    createNonEnumerableProperty(that, "errors", errorsArray);
                    return that;
                };
                if (setPrototypeOf) setPrototypeOf($AggregateError, Error1);
                else copyConstructorProperties($AggregateError, Error1);
                var AggregateErrorPrototype = $AggregateError.prototype = create(Error1.prototype, {
                    constructor: createPropertyDescriptor(1, $AggregateError),
                    message: createPropertyDescriptor(1, ""),
                    name: createPropertyDescriptor(1, "AggregateError")
                });
                // `AggregateError` constructor
                // https://tc39.es/ecma262/#sec-aggregate-error-constructor
                $({
                    global: true
                }, {
                    AggregateError: $AggregateError
                });
            /***/ },
            /***/ 55862: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var fails = __webpack_require__(79044);
                var isArray = __webpack_require__(71982);
                var isObject = __webpack_require__(52786);
                var toObject = __webpack_require__(30744);
                var lengthOfArrayLike = __webpack_require__(47046);
                var createProperty = __webpack_require__(35039);
                var arraySpeciesCreate = __webpack_require__(80150);
                var arrayMethodHasSpeciesSupport = __webpack_require__(82091);
                var wellKnownSymbol = __webpack_require__(52280);
                var V8_VERSION = __webpack_require__(11197);
                var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
                var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
                var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
                var TypeError1 = global.TypeError;
                // We can't use this feature detection in V8 since it causes
                // deoptimization and serious performance degradation
                // https://github.com/zloirock/core-js/issues/679
                var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
                    var array = [];
                    array[IS_CONCAT_SPREADABLE] = false;
                    return array.concat()[0] !== array;
                });
                var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");
                var isConcatSpreadable = function(O) {
                    if (!isObject(O)) return false;
                    var spreadable = O[IS_CONCAT_SPREADABLE];
                    return spreadable !== undefined ? !!spreadable : isArray(O);
                };
                var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
                // `Array.prototype.concat` method
                // https://tc39.es/ecma262/#sec-array.prototype.concat
                // with adding support of @@isConcatSpreadable and @@species
                $({
                    target: "Array",
                    proto: true,
                    forced: FORCED
                }, {
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    concat: function concat(arg) {
                        var O = toObject(this);
                        var A = arraySpeciesCreate(O, 0);
                        var n = 0;
                        var i, k, length, len, E;
                        for(i = -1, length = arguments.length; i < length; i++){
                            E = i === -1 ? O : arguments[i];
                            if (isConcatSpreadable(E)) {
                                len = lengthOfArrayLike(E);
                                if (n + len > MAX_SAFE_INTEGER) throw TypeError1(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                                for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                            } else {
                                if (n >= MAX_SAFE_INTEGER) throw TypeError1(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                                createProperty(A, n++, E);
                            }
                        }
                        A.length = n;
                        return A;
                    }
                });
            /***/ },
            /***/ 42833: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var copyWithin = __webpack_require__(28794);
                var addToUnscopables = __webpack_require__(6677);
                // `Array.prototype.copyWithin` method
                // https://tc39.es/ecma262/#sec-array.prototype.copywithin
                $({
                    target: "Array",
                    proto: true
                }, {
                    copyWithin: copyWithin
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables("copyWithin");
            /***/ },
            /***/ 83382: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var fill = __webpack_require__(55522);
                var addToUnscopables = __webpack_require__(6677);
                // `Array.prototype.fill` method
                // https://tc39.es/ecma262/#sec-array.prototype.fill
                $({
                    target: "Array",
                    proto: true
                }, {
                    fill: fill
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables("fill");
            /***/ },
            /***/ 19701: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var $filter = __webpack_require__(68671).filter;
                var arrayMethodHasSpeciesSupport = __webpack_require__(82091);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
                // `Array.prototype.filter` method
                // https://tc39.es/ecma262/#sec-array.prototype.filter
                // with adding support of @@species
                $({
                    target: "Array",
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    filter: function filter(callbackfn /* , thisArg */ ) {
                        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ 4845: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var from = __webpack_require__(84899);
                var checkCorrectnessOfIteration = __webpack_require__(8662);
                var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
                    // eslint-disable-next-line es/no-array-from -- required for testing
                    Array.from(iterable);
                });
                // `Array.from` method
                // https://tc39.es/ecma262/#sec-array.from
                $({
                    target: "Array",
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    from: from
                });
            /***/ },
            /***/ 18183: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var $includes = __webpack_require__(37190).includes;
                var addToUnscopables = __webpack_require__(6677);
                // `Array.prototype.includes` method
                // https://tc39.es/ecma262/#sec-array.prototype.includes
                $({
                    target: "Array",
                    proto: true
                }, {
                    includes: function includes(el /* , fromIndex = 0 */ ) {
                        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables("includes");
            /***/ },
            /***/ 54883: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toIndexedObject = __webpack_require__(29580);
                var addToUnscopables = __webpack_require__(6677);
                var Iterators = __webpack_require__(44818);
                var InternalStateModule = __webpack_require__(20821);
                var defineIterator = __webpack_require__(61495);
                var ARRAY_ITERATOR = "Array Iterator";
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
                // `Array.prototype.entries` method
                // https://tc39.es/ecma262/#sec-array.prototype.entries
                // `Array.prototype.keys` method
                // https://tc39.es/ecma262/#sec-array.prototype.keys
                // `Array.prototype.values` method
                // https://tc39.es/ecma262/#sec-array.prototype.values
                // `Array.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
                // `CreateArrayIterator` internal method
                // https://tc39.es/ecma262/#sec-createarrayiterator
                module1.exports = defineIterator(Array, "Array", function(iterated, kind) {
                    setInternalState(this, {
                        type: ARRAY_ITERATOR,
                        target: toIndexedObject(iterated),
                        index: 0,
                        kind: kind // kind
                    });
                // `%ArrayIteratorPrototype%.next` method
                // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
                }, function() {
                    var state = getInternalState(this);
                    var target = state.target;
                    var kind = state.kind;
                    var index = state.index++;
                    if (!target || index >= target.length) {
                        state.target = undefined;
                        return {
                            value: undefined,
                            done: true
                        };
                    }
                    if (kind == "keys") return {
                        value: index,
                        done: false
                    };
                    if (kind == "values") return {
                        value: target[index],
                        done: false
                    };
                    return {
                        value: [
                            index,
                            target[index]
                        ],
                        done: false
                    };
                }, "values");
                // argumentsList[@@iterator] is %ArrayProto_values%
                // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
                // https://tc39.es/ecma262/#sec-createmappedargumentsobject
                Iterators.Arguments = Iterators.Array;
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables("keys");
                addToUnscopables("values");
                addToUnscopables("entries");
            /***/ },
            /***/ 85005: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var uncurryThis = __webpack_require__(88697);
                var IndexedObject = __webpack_require__(78609);
                var toIndexedObject = __webpack_require__(29580);
                var arrayMethodIsStrict = __webpack_require__(54324);
                var un$Join = uncurryThis([].join);
                var ES3_STRINGS = IndexedObject != Object;
                var STRICT_METHOD = arrayMethodIsStrict("join", ",");
                // `Array.prototype.join` method
                // https://tc39.es/ecma262/#sec-array.prototype.join
                $({
                    target: "Array",
                    proto: true,
                    forced: ES3_STRINGS || !STRICT_METHOD
                }, {
                    join: function join(separator) {
                        return un$Join(toIndexedObject(this), separator === undefined ? "," : separator);
                    }
                });
            /***/ },
            /***/ 73214: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var $map = __webpack_require__(68671).map;
                var arrayMethodHasSpeciesSupport = __webpack_require__(82091);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
                // `Array.prototype.map` method
                // https://tc39.es/ecma262/#sec-array.prototype.map
                // with adding support of @@species
                $({
                    target: "Array",
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    map: function map(callbackfn /* , thisArg */ ) {
                        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ 18821: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var isArray = __webpack_require__(71982);
                var isConstructor = __webpack_require__(31536);
                var isObject = __webpack_require__(52786);
                var toAbsoluteIndex = __webpack_require__(32565);
                var lengthOfArrayLike = __webpack_require__(47046);
                var toIndexedObject = __webpack_require__(29580);
                var createProperty = __webpack_require__(35039);
                var wellKnownSymbol = __webpack_require__(52280);
                var arrayMethodHasSpeciesSupport = __webpack_require__(82091);
                var un$Slice = __webpack_require__(15629);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice");
                var SPECIES = wellKnownSymbol("species");
                var Array1 = global.Array;
                var max = Math.max;
                // `Array.prototype.slice` method
                // https://tc39.es/ecma262/#sec-array.prototype.slice
                // fallback for not array-like ES3 strings and DOM objects
                $({
                    target: "Array",
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    slice: function slice(start, end) {
                        var O = toIndexedObject(this);
                        var length = lengthOfArrayLike(O);
                        var k = toAbsoluteIndex(start, length);
                        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
                        var Constructor, result, n;
                        if (isArray(O)) {
                            Constructor = O.constructor;
                            // cross-realm fallback
                            if (isConstructor(Constructor) && (Constructor === Array1 || isArray(Constructor.prototype))) Constructor = undefined;
                            else if (isObject(Constructor)) {
                                Constructor = Constructor[SPECIES];
                                if (Constructor === null) Constructor = undefined;
                            }
                            if (Constructor === Array1 || Constructor === undefined) return un$Slice(O, k, fin);
                        }
                        result = new (Constructor === undefined ? Array1 : Constructor)(max(fin - k, 0));
                        for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
                        result.length = n;
                        return result;
                    }
                });
            /***/ },
            /***/ 55281: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var uncurryThis = __webpack_require__(88697);
                var aCallable = __webpack_require__(97676);
                var toObject = __webpack_require__(30744);
                var lengthOfArrayLike = __webpack_require__(47046);
                var toString = __webpack_require__(28967);
                var fails = __webpack_require__(79044);
                var internalSort = __webpack_require__(2013);
                var arrayMethodIsStrict = __webpack_require__(54324);
                var FF = __webpack_require__(34631);
                var IE_OR_EDGE = __webpack_require__(80442);
                var V8 = __webpack_require__(11197);
                var WEBKIT = __webpack_require__(76929);
                var test = [];
                var un$Sort = uncurryThis(test.sort);
                var push = uncurryThis(test.push);
                // IE8-
                var FAILS_ON_UNDEFINED = fails(function() {
                    test.sort(undefined);
                });
                // V8 bug
                var FAILS_ON_NULL = fails(function() {
                    test.sort(null);
                });
                // Old WebKit
                var STRICT_METHOD = arrayMethodIsStrict("sort");
                var STABLE_SORT = !fails(function() {
                    // feature detection can be too slow, so check engines versions
                    if (V8) return V8 < 70;
                    if (FF && FF > 3) return;
                    if (IE_OR_EDGE) return true;
                    if (WEBKIT) return WEBKIT < 603;
                    var result = "";
                    var code, chr, value, index;
                    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
                    for(code = 65; code < 76; code++){
                        chr = String.fromCharCode(code);
                        switch(code){
                            case 66:
                            case 69:
                            case 70:
                            case 72:
                                value = 3;
                                break;
                            case 68:
                            case 71:
                                value = 4;
                                break;
                            default:
                                value = 2;
                        }
                        for(index = 0; index < 47; index++)test.push({
                            k: chr + index,
                            v: value
                        });
                    }
                    test.sort(function(a, b) {
                        return b.v - a.v;
                    });
                    for(index = 0; index < test.length; index++){
                        chr = test[index].k.charAt(0);
                        if (result.charAt(result.length - 1) !== chr) result += chr;
                    }
                    return result !== "DGBEFHACIJK";
                });
                var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
                var getSortCompare = function(comparefn) {
                    return function(x, y) {
                        if (y === undefined) return -1;
                        if (x === undefined) return 1;
                        if (comparefn !== undefined) return +comparefn(x, y) || 0;
                        return toString(x) > toString(y) ? 1 : -1;
                    };
                };
                // `Array.prototype.sort` method
                // https://tc39.es/ecma262/#sec-array.prototype.sort
                $({
                    target: "Array",
                    proto: true,
                    forced: FORCED
                }, {
                    sort: function sort(comparefn) {
                        if (comparefn !== undefined) aCallable(comparefn);
                        var array = toObject(this);
                        if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);
                        var items = [];
                        var arrayLength = lengthOfArrayLike(array);
                        var itemsLength, index;
                        for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
                        internalSort(items, getSortCompare(comparefn));
                        itemsLength = items.length;
                        index = 0;
                        while(index < itemsLength)array[index] = items[index++];
                        while(index < arrayLength)delete array[index++];
                        return array;
                    }
                });
            /***/ },
            /***/ 45550: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var toAbsoluteIndex = __webpack_require__(32565);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var lengthOfArrayLike = __webpack_require__(47046);
                var toObject = __webpack_require__(30744);
                var arraySpeciesCreate = __webpack_require__(80150);
                var createProperty = __webpack_require__(35039);
                var arrayMethodHasSpeciesSupport = __webpack_require__(82091);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("splice");
                var TypeError1 = global.TypeError;
                var max = Math.max;
                var min = Math.min;
                var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
                var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = "Maximum allowed length exceeded";
                // `Array.prototype.splice` method
                // https://tc39.es/ecma262/#sec-array.prototype.splice
                // with adding support of @@species
                $({
                    target: "Array",
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    splice: function splice(start, deleteCount /* , ...items */ ) {
                        var O = toObject(this);
                        var len = lengthOfArrayLike(O);
                        var actualStart = toAbsoluteIndex(start, len);
                        var argumentsLength = arguments.length;
                        var insertCount, actualDeleteCount, A, k, from, to;
                        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
                        else if (argumentsLength === 1) {
                            insertCount = 0;
                            actualDeleteCount = len - actualStart;
                        } else {
                            insertCount = argumentsLength - 2;
                            actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
                        }
                        if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) throw TypeError1(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
                        A = arraySpeciesCreate(O, actualDeleteCount);
                        for(k = 0; k < actualDeleteCount; k++){
                            from = actualStart + k;
                            if (from in O) createProperty(A, k, O[from]);
                        }
                        A.length = actualDeleteCount;
                        if (insertCount < actualDeleteCount) {
                            for(k = actualStart; k < len - actualDeleteCount; k++){
                                from = k + actualDeleteCount;
                                to = k + insertCount;
                                if (from in O) O[to] = O[from];
                                else delete O[to];
                            }
                            for(k = len; k > len - actualDeleteCount + insertCount; k--)delete O[k - 1];
                        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
                            from = k + actualDeleteCount - 1;
                            to = k + insertCount - 1;
                            if (from in O) O[to] = O[from];
                            else delete O[to];
                        }
                        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
                        O.length = len - actualDeleteCount + insertCount;
                        return A;
                    }
                });
            /***/ },
            /***/ 33142: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var hasOwn = __webpack_require__(24792);
                var redefine = __webpack_require__(35974);
                var dateToPrimitive = __webpack_require__(67707);
                var wellKnownSymbol = __webpack_require__(52280);
                var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
                var DatePrototype = Date.prototype;
                // `Date.prototype[@@toPrimitive]` method
                // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
                if (!hasOwn(DatePrototype, TO_PRIMITIVE)) redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
            /***/ },
            /***/ 54994: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var FUNCTION_NAME_EXISTS = __webpack_require__(55316).EXISTS;
                var uncurryThis = __webpack_require__(88697);
                var defineProperty = __webpack_require__(86385).f;
                var FunctionPrototype = Function.prototype;
                var functionToString = uncurryThis(FunctionPrototype.toString);
                var nameRE = /^\s*function ([^ (]*)/;
                var regExpExec = uncurryThis(nameRE.exec);
                var NAME = "name";
                // Function instances `.name` property
                // https://tc39.es/ecma262/#sec-function-instances-name
                if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) defineProperty(FunctionPrototype, NAME, {
                    configurable: true,
                    get: function() {
                        try {
                            return regExpExec(nameRE, functionToString(this))[1];
                        } catch (error) {
                            return "";
                        }
                    }
                });
            /***/ },
            /***/ 62688: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                // `globalThis` object
                // https://tc39.es/ecma262/#sec-globalthis
                $({
                    global: true
                }, {
                    globalThis: global
                });
            /***/ },
            /***/ 44063: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var setToStringTag = __webpack_require__(60878);
                // JSON[@@toStringTag] property
                // https://tc39.es/ecma262/#sec-json-@@tostringtag
                setToStringTag(global.JSON, "JSON", true);
            /***/ },
            /***/ 30644: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var collection = __webpack_require__(9121);
                var collectionStrong = __webpack_require__(33513);
                // `Map` constructor
                // https://tc39.es/ecma262/#sec-map-objects
                collection("Map", function(init) {
                    return function Map1() {
                        return init(this, arguments.length ? arguments[0] : undefined);
                    };
                }, collectionStrong);
            /***/ },
            /***/ 62031: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var setToStringTag = __webpack_require__(60878);
                // Math[@@toStringTag] property
                // https://tc39.es/ecma262/#sec-math-@@tostringtag
                setToStringTag(Math, "Math", true);
            /***/ },
            /***/ 80174: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(7493);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var isForced = __webpack_require__(86291);
                var redefine = __webpack_require__(35974);
                var hasOwn = __webpack_require__(24792);
                var inheritIfRequired = __webpack_require__(59250);
                var isPrototypeOf = __webpack_require__(32010);
                var isSymbol = __webpack_require__(66681);
                var toPrimitive = __webpack_require__(21893);
                var fails = __webpack_require__(79044);
                var getOwnPropertyNames = __webpack_require__(87994).f;
                var getOwnPropertyDescriptor = __webpack_require__(66012).f;
                var defineProperty = __webpack_require__(86385).f;
                var thisNumberValue = __webpack_require__(41655);
                var trim = __webpack_require__(10287).trim;
                var NUMBER = "Number";
                var NativeNumber = global[NUMBER];
                var NumberPrototype = NativeNumber.prototype;
                var TypeError1 = global.TypeError;
                var arraySlice = uncurryThis("".slice);
                var charCodeAt = uncurryThis("".charCodeAt);
                // `ToNumeric` abstract operation
                // https://tc39.es/ecma262/#sec-tonumeric
                var toNumeric = function(value) {
                    var primValue = toPrimitive(value, "number");
                    return typeof primValue == "bigint" ? primValue : toNumber(primValue);
                };
                // `ToNumber` abstract operation
                // https://tc39.es/ecma262/#sec-tonumber
                var toNumber = function(argument) {
                    var it = toPrimitive(argument, "number");
                    var first, third, radix, maxCode, digits, length, index, code;
                    if (isSymbol(it)) throw TypeError1("Cannot convert a Symbol value to a number");
                    if (typeof it == "string" && it.length > 2) {
                        it = trim(it);
                        first = charCodeAt(it, 0);
                        if (first === 43 || first === 45) {
                            third = charCodeAt(it, 2);
                            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
                        } else if (first === 48) {
                            switch(charCodeAt(it, 1)){
                                case 66:
                                case 98:
                                    radix = 2;
                                    maxCode = 49;
                                    break; // fast equal of /^0b[01]+$/i
                                case 79:
                                case 111:
                                    radix = 8;
                                    maxCode = 55;
                                    break; // fast equal of /^0o[0-7]+$/i
                                default:
                                    return +it;
                            }
                            digits = arraySlice(it, 2);
                            length = digits.length;
                            for(index = 0; index < length; index++){
                                code = charCodeAt(digits, index);
                                // parseInt parses a string to a first unavailable symbol
                                // but ToNumber should return NaN if a string contains unavailable symbols
                                if (code < 48 || code > maxCode) return NaN;
                            }
                            return parseInt(digits, radix);
                        }
                    }
                    return +it;
                };
                // `Number` constructor
                // https://tc39.es/ecma262/#sec-number-constructor
                if (isForced(NUMBER, !NativeNumber(" 0o1") || !NativeNumber("0b1") || NativeNumber("+0x1"))) {
                    var NumberWrapper = function Number1(value) {
                        var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
                        var dummy = this;
                        // check on 1..constructor(foo) case
                        return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
                            thisNumberValue(dummy);
                        }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
                    };
                    for(var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : // ES3:
                    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), j = 0, key; keys.length > j; j++)if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
                    NumberWrapper.prototype = NumberPrototype;
                    NumberPrototype.constructor = NumberWrapper;
                    redefine(global, NUMBER, NumberWrapper);
                }
            /***/ },
            /***/ 27013: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                // `Number.EPSILON` constant
                // https://tc39.es/ecma262/#sec-number.epsilon
                $({
                    target: "Number",
                    stat: true
                }, {
                    EPSILON: Math.pow(2, -52)
                });
            /***/ },
            /***/ 14686: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var numberIsFinite = __webpack_require__(5310);
                // `Number.isFinite` method
                // https://tc39.es/ecma262/#sec-number.isfinite
                $({
                    target: "Number",
                    stat: true
                }, {
                    isFinite: numberIsFinite
                });
            /***/ },
            /***/ 35727: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var isIntegralNumber = __webpack_require__(57507);
                // `Number.isInteger` method
                // https://tc39.es/ecma262/#sec-number.isinteger
                $({
                    target: "Number",
                    stat: true
                }, {
                    isInteger: isIntegralNumber
                });
            /***/ },
            /***/ 12798: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var thisNumberValue = __webpack_require__(41655);
                var $repeat = __webpack_require__(26031);
                var fails = __webpack_require__(79044);
                var RangeError1 = global.RangeError;
                var String1 = global.String;
                var floor = Math.floor;
                var repeat = uncurryThis($repeat);
                var stringSlice = uncurryThis("".slice);
                var un$ToFixed = uncurryThis(1.0.toFixed);
                var pow = function(x, n, acc) {
                    return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
                };
                var log = function(x) {
                    var n = 0;
                    var x2 = x;
                    while(x2 >= 4096){
                        n += 12;
                        x2 /= 4096;
                    }
                    while(x2 >= 2){
                        n += 1;
                        x2 /= 2;
                    }
                    return n;
                };
                var multiply = function(data, n, c) {
                    var index = -1;
                    var c2 = c;
                    while(++index < 6){
                        c2 += n * data[index];
                        data[index] = c2 % 1e7;
                        c2 = floor(c2 / 1e7);
                    }
                };
                var divide = function(data, n) {
                    var index = 6;
                    var c = 0;
                    while(--index >= 0){
                        c += data[index];
                        data[index] = floor(c / n);
                        c = c % n * 1e7;
                    }
                };
                var dataToString = function(data) {
                    var index = 6;
                    var s = "";
                    while(--index >= 0)if (s !== "" || index === 0 || data[index] !== 0) {
                        var t = String1(data[index]);
                        s = s === "" ? t : s + repeat("0", 7 - t.length) + t;
                    }
                    return s;
                };
                var FORCED = fails(function() {
                    return un$ToFixed(0.00008, 3) !== "0.000" || un$ToFixed(0.9, 0) !== "1" || un$ToFixed(1.255, 2) !== "1.25" || un$ToFixed(1000000000000000128.0, 0) !== "1000000000000000128";
                }) || !fails(function() {
                    // V8 ~ Android 4.3-
                    un$ToFixed({});
                });
                // `Number.prototype.toFixed` method
                // https://tc39.es/ecma262/#sec-number.prototype.tofixed
                $({
                    target: "Number",
                    proto: true,
                    forced: FORCED
                }, {
                    toFixed: function toFixed(fractionDigits) {
                        var number = thisNumberValue(this);
                        var fractDigits = toIntegerOrInfinity(fractionDigits);
                        var data = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ];
                        var sign = "";
                        var result = "0";
                        var e, z, j, k;
                        if (fractDigits < 0 || fractDigits > 20) throw RangeError1("Incorrect fraction digits");
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (number != number) return "NaN";
                        if (number <= -1000000000000000000000 || number >= 1e21) return String1(number);
                        if (number < 0) {
                            sign = "-";
                            number = -number;
                        }
                        if (number > 1e-21) {
                            e = log(number * pow(2, 69, 1)) - 69;
                            z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
                            z *= 0x10000000000000;
                            e = 52 - e;
                            if (e > 0) {
                                multiply(data, 0, z);
                                j = fractDigits;
                                while(j >= 7){
                                    multiply(data, 1e7, 0);
                                    j -= 7;
                                }
                                multiply(data, pow(10, j, 1), 0);
                                j = e - 1;
                                while(j >= 23){
                                    divide(data, 8388608);
                                    j -= 23;
                                }
                                divide(data, 1 << j);
                                multiply(data, 1, 1);
                                divide(data, 2);
                                result = dataToString(data);
                            } else {
                                multiply(data, 0, z);
                                multiply(data, 1 << -e, 0);
                                result = dataToString(data) + repeat("0", fractDigits);
                            }
                        }
                        if (fractDigits > 0) {
                            k = result.length;
                            result = sign + (k <= fractDigits ? "0." + repeat("0", fractDigits - k) + result : stringSlice(result, 0, k - fractDigits) + "." + stringSlice(result, k - fractDigits));
                        } else result = sign + result;
                        return result;
                    }
                });
            /***/ },
            /***/ 33130: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var assign = __webpack_require__(45856);
                // `Object.assign` method
                // https://tc39.es/ecma262/#sec-object.assign
                // eslint-disable-next-line es/no-object-assign -- required for testing
                $({
                    target: "Object",
                    stat: true,
                    forced: Object.assign !== assign
                }, {
                    assign: assign
                });
            /***/ },
            /***/ 63815: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var FREEZING = __webpack_require__(51207);
                var fails = __webpack_require__(79044);
                var isObject = __webpack_require__(52786);
                var onFreeze = __webpack_require__(44296).onFreeze;
                // eslint-disable-next-line es/no-object-freeze -- safe
                var $freeze = Object.freeze;
                var FAILS_ON_PRIMITIVES = fails(function() {
                    $freeze(1);
                });
                // `Object.freeze` method
                // https://tc39.es/ecma262/#sec-object.freeze
                $({
                    target: "Object",
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES,
                    sham: !FREEZING
                }, {
                    freeze: function freeze(it) {
                        return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
                    }
                });
            /***/ },
            /***/ 80238: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var fails = __webpack_require__(79044);
                var toIndexedObject = __webpack_require__(29580);
                var nativeGetOwnPropertyDescriptor = __webpack_require__(66012).f;
                var DESCRIPTORS = __webpack_require__(7493);
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeGetOwnPropertyDescriptor(1);
                });
                var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
                $({
                    target: "Object",
                    stat: true,
                    forced: FORCED,
                    sham: !DESCRIPTORS
                }, {
                    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
                        return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
                    }
                });
            /***/ },
            /***/ 12938: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var DESCRIPTORS = __webpack_require__(7493);
                var ownKeys = __webpack_require__(31561);
                var toIndexedObject = __webpack_require__(29580);
                var getOwnPropertyDescriptorModule = __webpack_require__(66012);
                var createProperty = __webpack_require__(35039);
                // `Object.getOwnPropertyDescriptors` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                $({
                    target: "Object",
                    stat: true,
                    sham: !DESCRIPTORS
                }, {
                    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                        var O = toIndexedObject(object);
                        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                        var keys = ownKeys(O);
                        var result = {};
                        var index = 0;
                        var key, descriptor;
                        while(keys.length > index){
                            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                            if (descriptor !== undefined) createProperty(result, key, descriptor);
                        }
                        return result;
                    }
                });
            /***/ },
            /***/ 56908: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var fails = __webpack_require__(79044);
                var toObject = __webpack_require__(30744);
                var nativeGetPrototypeOf = __webpack_require__(12654);
                var CORRECT_PROTOTYPE_GETTER = __webpack_require__(25115);
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeGetPrototypeOf(1);
                });
                // `Object.getPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.getprototypeof
                $({
                    target: "Object",
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES,
                    sham: !CORRECT_PROTOTYPE_GETTER
                }, {
                    getPrototypeOf: function getPrototypeOf(it) {
                        return nativeGetPrototypeOf(toObject(it));
                    }
                });
            /***/ },
            /***/ 80044: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var toObject = __webpack_require__(30744);
                var nativeKeys = __webpack_require__(60667);
                var fails = __webpack_require__(79044);
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeKeys(1);
                });
                // `Object.keys` method
                // https://tc39.es/ecma262/#sec-object.keys
                $({
                    target: "Object",
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES
                }, {
                    keys: function keys(it) {
                        return nativeKeys(toObject(it));
                    }
                });
            /***/ },
            /***/ 10853: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var TO_STRING_TAG_SUPPORT = __webpack_require__(57301);
                var redefine = __webpack_require__(35974);
                var toString = __webpack_require__(36699);
                // `Object.prototype.toString` method
                // https://tc39.es/ecma262/#sec-object.prototype.tostring
                if (!TO_STRING_TAG_SUPPORT) redefine(Object.prototype, "toString", toString, {
                    unsafe: true
                });
            /***/ },
            /***/ 19457: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var $values = __webpack_require__(8765).values;
                // `Object.values` method
                // https://tc39.es/ecma262/#sec-object.values
                $({
                    target: "Object",
                    stat: true
                }, {
                    values: function values(O) {
                        return $values(O);
                    }
                });
            /***/ },
            /***/ 12382: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var call = __webpack_require__(79611);
                var aCallable = __webpack_require__(97676);
                var newPromiseCapabilityModule = __webpack_require__(29269);
                var perform = __webpack_require__(74443);
                var iterate = __webpack_require__(5166);
                // `Promise.allSettled` method
                // https://tc39.es/ecma262/#sec-promise.allsettled
                $({
                    target: "Promise",
                    stat: true
                }, {
                    allSettled: function allSettled(iterable) {
                        var C = this;
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: "fulfilled",
                                        value: value
                                    };
                                    --remaining || resolve(values);
                                }, function(error) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: "rejected",
                                        reason: error
                                    };
                                    --remaining || resolve(values);
                                });
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ 487: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var aCallable = __webpack_require__(97676);
                var getBuiltIn = __webpack_require__(22773);
                var call = __webpack_require__(79611);
                var newPromiseCapabilityModule = __webpack_require__(29269);
                var perform = __webpack_require__(74443);
                var iterate = __webpack_require__(5166);
                var PROMISE_ANY_ERROR = "No one promise resolved";
                // `Promise.any` method
                // https://tc39.es/ecma262/#sec-promise.any
                $({
                    target: "Promise",
                    stat: true
                }, {
                    any: function any(iterable) {
                        var C = this;
                        var AggregateError1 = getBuiltIn("AggregateError");
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var errors = [];
                            var counter = 0;
                            var remaining = 1;
                            var alreadyResolved = false;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyRejected = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyResolved = true;
                                    resolve(value);
                                }, function(error) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyRejected = true;
                                    errors[index] = error;
                                    --remaining || reject(new AggregateError1(errors, PROMISE_ANY_ERROR));
                                });
                            });
                            --remaining || reject(new AggregateError1(errors, PROMISE_ANY_ERROR));
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ 27138: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var IS_PURE = __webpack_require__(21178);
                var NativePromise = __webpack_require__(58369);
                var fails = __webpack_require__(79044);
                var getBuiltIn = __webpack_require__(22773);
                var isCallable = __webpack_require__(75277);
                var speciesConstructor = __webpack_require__(7270);
                var promiseResolve = __webpack_require__(11621);
                var redefine = __webpack_require__(35974);
                // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
                var NON_GENERIC = !!NativePromise && fails(function() {
                    NativePromise.prototype["finally"].call({
                        then: function() {}
                    }, function() {});
                });
                // `Promise.prototype.finally` method
                // https://tc39.es/ecma262/#sec-promise.prototype.finally
                $({
                    target: "Promise",
                    proto: true,
                    real: true,
                    forced: NON_GENERIC
                }, {
                    "finally": function(onFinally) {
                        var C = speciesConstructor(this, getBuiltIn("Promise"));
                        var isFunction = isCallable(onFinally);
                        return this.then(isFunction ? function(x) {
                            return promiseResolve(C, onFinally()).then(function() {
                                return x;
                            });
                        } : onFinally, isFunction ? function(e) {
                            return promiseResolve(C, onFinally()).then(function() {
                                throw e;
                            });
                        } : onFinally);
                    }
                });
                // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
                if (!IS_PURE && isCallable(NativePromise)) {
                    var method = getBuiltIn("Promise").prototype["finally"];
                    if (NativePromise.prototype["finally"] !== method) redefine(NativePromise.prototype, "finally", method, {
                        unsafe: true
                    });
                }
            /***/ },
            /***/ 35054: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var IS_PURE = __webpack_require__(21178);
                var global = __webpack_require__(98363);
                var getBuiltIn = __webpack_require__(22773);
                var call = __webpack_require__(79611);
                var NativePromise = __webpack_require__(58369);
                var redefine = __webpack_require__(35974);
                var redefineAll = __webpack_require__(7592);
                var setPrototypeOf = __webpack_require__(22412);
                var setToStringTag = __webpack_require__(60878);
                var setSpecies = __webpack_require__(57323);
                var aCallable = __webpack_require__(97676);
                var isCallable = __webpack_require__(75277);
                var isObject = __webpack_require__(52786);
                var anInstance = __webpack_require__(9519);
                var inspectSource = __webpack_require__(56429);
                var iterate = __webpack_require__(5166);
                var checkCorrectnessOfIteration = __webpack_require__(8662);
                var speciesConstructor = __webpack_require__(7270);
                var task = __webpack_require__(84643).set;
                var microtask = __webpack_require__(71800);
                var promiseResolve = __webpack_require__(11621);
                var hostReportErrors = __webpack_require__(46271);
                var newPromiseCapabilityModule = __webpack_require__(29269);
                var perform = __webpack_require__(74443);
                var InternalStateModule = __webpack_require__(20821);
                var isForced = __webpack_require__(86291);
                var wellKnownSymbol = __webpack_require__(52280);
                var IS_BROWSER = __webpack_require__(47923);
                var IS_NODE = __webpack_require__(93921);
                var V8_VERSION = __webpack_require__(11197);
                var SPECIES = wellKnownSymbol("species");
                var PROMISE = "Promise";
                var getInternalState = InternalStateModule.get;
                var setInternalState = InternalStateModule.set;
                var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
                var NativePromisePrototype = NativePromise && NativePromise.prototype;
                var PromiseConstructor = NativePromise;
                var PromisePrototype = NativePromisePrototype;
                var TypeError1 = global.TypeError;
                var document1 = global.document;
                var process = global.process;
                var newPromiseCapability = newPromiseCapabilityModule.f;
                var newGenericPromiseCapability = newPromiseCapability;
                var DISPATCH_EVENT = !!(document1 && document1.createEvent && global.dispatchEvent);
                var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
                var UNHANDLED_REJECTION = "unhandledrejection";
                var REJECTION_HANDLED = "rejectionhandled";
                var PENDING = 0;
                var FULFILLED = 1;
                var REJECTED = 2;
                var HANDLED = 1;
                var UNHANDLED = 2;
                var SUBCLASSING = false;
                var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
                var FORCED = isForced(PROMISE, function() {
                    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
                    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
                    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
                    // We can't detect it synchronously, so just check versions
                    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
                    // We need Promise#finally in the pure version for preventing prototype pollution
                    if (IS_PURE && !PromisePrototype["finally"]) return true;
                    // We can't use @@species feature detection in V8 since it causes
                    // deoptimization and performance degradation
                    // https://github.com/zloirock/core-js/issues/679
                    if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
                    // Detect correctness of subclassing with @@species support
                    var promise = new PromiseConstructor(function(resolve) {
                        resolve(1);
                    });
                    var FakePromise = function(exec) {
                        exec(function() {}, function() {});
                    };
                    var constructor = promise.constructor = {};
                    constructor[SPECIES] = FakePromise;
                    SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
                    if (!SUBCLASSING) return true;
                    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
                    return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
                });
                var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
                    PromiseConstructor.all(iterable)["catch"](function() {});
                });
                // helpers
                var isThenable = function(it) {
                    var then;
                    return isObject(it) && isCallable(then = it.then) ? then : false;
                };
                var notify = function(state, isReject) {
                    if (state.notified) return;
                    state.notified = true;
                    var chain = state.reactions;
                    microtask(function() {
                        var value = state.value;
                        var ok = state.state == FULFILLED;
                        var index = 0;
                        // variable length - can't use forEach
                        while(chain.length > index){
                            var reaction = chain[index++];
                            var handler = ok ? reaction.ok : reaction.fail;
                            var resolve = reaction.resolve;
                            var reject = reaction.reject;
                            var domain = reaction.domain;
                            var result, then, exited;
                            try {
                                if (handler) {
                                    if (!ok) {
                                        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                                        state.rejection = HANDLED;
                                    }
                                    if (handler === true) result = value;
                                    else {
                                        if (domain) domain.enter();
                                        result = handler(value); // can throw
                                        if (domain) {
                                            domain.exit();
                                            exited = true;
                                        }
                                    }
                                    if (result === reaction.promise) reject(TypeError1("Promise-chain cycle"));
                                    else if (then = isThenable(result)) call(then, result, resolve, reject);
                                    else resolve(result);
                                } else reject(value);
                            } catch (error) {
                                if (domain && !exited) domain.exit();
                                reject(error);
                            }
                        }
                        state.reactions = [];
                        state.notified = false;
                        if (isReject && !state.rejection) onUnhandled(state);
                    });
                };
                var dispatchEvent = function(name, promise, reason) {
                    var event, handler;
                    if (DISPATCH_EVENT) {
                        event = document1.createEvent("Event");
                        event.promise = promise;
                        event.reason = reason;
                        event.initEvent(name, false, true);
                        global.dispatchEvent(event);
                    } else event = {
                        promise: promise,
                        reason: reason
                    };
                    if (!NATIVE_REJECTION_EVENT && (handler = global["on" + name])) handler(event);
                    else if (name === UNHANDLED_REJECTION) hostReportErrors("Unhandled promise rejection", reason);
                };
                var onUnhandled = function(state) {
                    call(task, global, function() {
                        var promise = state.facade;
                        var value = state.value;
                        var IS_UNHANDLED = isUnhandled(state);
                        var result;
                        if (IS_UNHANDLED) {
                            result = perform(function() {
                                if (IS_NODE) process.emit("unhandledRejection", value, promise);
                                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                            });
                            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                            if (result.error) throw result.value;
                        }
                    });
                };
                var isUnhandled = function(state) {
                    return state.rejection !== HANDLED && !state.parent;
                };
                var onHandleUnhandled = function(state) {
                    call(task, global, function() {
                        var promise = state.facade;
                        if (IS_NODE) process.emit("rejectionHandled", promise);
                        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
                    });
                };
                var bind = function(fn, state, unwrap) {
                    return function(value) {
                        fn(state, value, unwrap);
                    };
                };
                var internalReject = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    state.value = value;
                    state.state = REJECTED;
                    notify(state, true);
                };
                var internalResolve = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    try {
                        if (state.facade === value) throw TypeError1("Promise can't be resolved itself");
                        var then = isThenable(value);
                        if (then) microtask(function() {
                            var wrapper = {
                                done: false
                            };
                            try {
                                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
                            } catch (error) {
                                internalReject(wrapper, error, state);
                            }
                        });
                        else {
                            state.value = value;
                            state.state = FULFILLED;
                            notify(state, false);
                        }
                    } catch (error) {
                        internalReject({
                            done: false
                        }, error, state);
                    }
                };
                // constructor polyfill
                if (FORCED) {
                    // 25.4.3.1 Promise(executor)
                    PromiseConstructor = function Promise1(executor) {
                        anInstance(this, PromisePrototype);
                        aCallable(executor);
                        call(Internal, this);
                        var state = getInternalState(this);
                        try {
                            executor(bind(internalResolve, state), bind(internalReject, state));
                        } catch (error) {
                            internalReject(state, error);
                        }
                    };
                    PromisePrototype = PromiseConstructor.prototype;
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    Internal = function Promise1(executor) {
                        setInternalState(this, {
                            type: PROMISE,
                            done: false,
                            notified: false,
                            parent: false,
                            reactions: [],
                            rejection: false,
                            state: PENDING,
                            value: undefined
                        });
                    };
                    Internal.prototype = redefineAll(PromisePrototype, {
                        // `Promise.prototype.then` method
                        // https://tc39.es/ecma262/#sec-promise.prototype.then
                        then: function then(onFulfilled, onRejected) {
                            var state = getInternalPromiseState(this);
                            var reactions = state.reactions;
                            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                            reaction.fail = isCallable(onRejected) && onRejected;
                            reaction.domain = IS_NODE ? process.domain : undefined;
                            state.parent = true;
                            reactions[reactions.length] = reaction;
                            if (state.state != PENDING) notify(state, false);
                            return reaction.promise;
                        },
                        // `Promise.prototype.catch` method
                        // https://tc39.es/ecma262/#sec-promise.prototype.catch
                        "catch": function(onRejected) {
                            return this.then(undefined, onRejected);
                        }
                    });
                    OwnPromiseCapability = function() {
                        var promise = new Internal();
                        var state = getInternalState(promise);
                        this.promise = promise;
                        this.resolve = bind(internalResolve, state);
                        this.reject = bind(internalReject, state);
                    };
                    newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
                        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
                    };
                    if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
                        nativeThen = NativePromisePrototype.then;
                        if (!SUBCLASSING) {
                            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
                            redefine(NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
                                var that = this;
                                return new PromiseConstructor(function(resolve, reject) {
                                    call(nativeThen, that, resolve, reject);
                                }).then(onFulfilled, onRejected);
                            // https://github.com/zloirock/core-js/issues/640
                            }, {
                                unsafe: true
                            });
                            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
                            redefine(NativePromisePrototype, "catch", PromisePrototype["catch"], {
                                unsafe: true
                            });
                        }
                        // make `.constructor === Promise` work for native promise-based APIs
                        try {
                            delete NativePromisePrototype.constructor;
                        } catch (error) {}
                        // make `instanceof Promise` work for native promise-based APIs
                        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
                    }
                }
                $({
                    global: true,
                    wrap: true,
                    forced: FORCED
                }, {
                    Promise: PromiseConstructor
                });
                setToStringTag(PromiseConstructor, PROMISE, false, true);
                setSpecies(PROMISE);
                PromiseWrapper = getBuiltIn(PROMISE);
                // statics
                $({
                    target: PROMISE,
                    stat: true,
                    forced: FORCED
                }, {
                    // `Promise.reject` method
                    // https://tc39.es/ecma262/#sec-promise.reject
                    reject: function reject(r) {
                        var capability = newPromiseCapability(this);
                        call(capability.reject, undefined, r);
                        return capability.promise;
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: IS_PURE || FORCED
                }, {
                    // `Promise.resolve` method
                    // https://tc39.es/ecma262/#sec-promise.resolve
                    resolve: function resolve(x) {
                        return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    // `Promise.all` method
                    // https://tc39.es/ecma262/#sec-promise.all
                    all: function all(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call($promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = value;
                                    --remaining || resolve(values);
                                }, reject);
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    },
                    // `Promise.race` method
                    // https://tc39.es/ecma262/#sec-promise.race
                    race: function race(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            iterate(iterable, function(promise) {
                                call($promiseResolve, C, promise).then(capability.resolve, reject);
                            });
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ 54130: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var getBuiltIn = __webpack_require__(22773);
                var apply = __webpack_require__(63530);
                var bind = __webpack_require__(52381);
                var aConstructor = __webpack_require__(43327);
                var anObject = __webpack_require__(83875);
                var isObject = __webpack_require__(52786);
                var create = __webpack_require__(51569);
                var fails = __webpack_require__(79044);
                var nativeConstruct = getBuiltIn("Reflect", "construct");
                var ObjectPrototype = Object.prototype;
                var push = [].push;
                // `Reflect.construct` method
                // https://tc39.es/ecma262/#sec-reflect.construct
                // MS Edge supports only 2 arguments and argumentsList argument is optional
                // FF Nightly sets third argument as `new.target`, but does not create `this` from it
                var NEW_TARGET_BUG = fails(function() {
                    function F() {}
                    return !(nativeConstruct(function() {}, [], F) instanceof F);
                });
                var ARGS_BUG = !fails(function() {
                    nativeConstruct(function() {});
                });
                var FORCED = NEW_TARGET_BUG || ARGS_BUG;
                $({
                    target: "Reflect",
                    stat: true,
                    forced: FORCED,
                    sham: FORCED
                }, {
                    construct: function construct(Target, args /* , newTarget */ ) {
                        aConstructor(Target);
                        anObject(args);
                        var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
                        if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
                        if (Target == newTarget) {
                            // w/o altered newTarget, optimization for 0-4 arguments
                            switch(args.length){
                                case 0:
                                    return new Target();
                                case 1:
                                    return new Target(args[0]);
                                case 2:
                                    return new Target(args[0], args[1]);
                                case 3:
                                    return new Target(args[0], args[1], args[2]);
                                case 4:
                                    return new Target(args[0], args[1], args[2], args[3]);
                            }
                            // w/o altered newTarget, lot of arguments case
                            var $args = [
                                null
                            ];
                            apply(push, $args, args);
                            return new (apply(bind, Target, $args))();
                        }
                        // with altered newTarget, not support built-in constructors
                        var proto = newTarget.prototype;
                        var instance = create(isObject(proto) ? proto : ObjectPrototype);
                        var result = apply(Target, instance, args);
                        return isObject(result) ? result : instance;
                    }
                });
            /***/ },
            /***/ 39275: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var exec = __webpack_require__(99749);
                // `RegExp.prototype.exec` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.exec
                $({
                    target: "RegExp",
                    proto: true,
                    forced: /./.exec !== exec
                }, {
                    exec: exec
                });
            /***/ },
            /***/ 15158: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(7493);
                var objectDefinePropertyModule = __webpack_require__(86385);
                var regExpFlags = __webpack_require__(58083);
                var fails = __webpack_require__(79044);
                var RegExpPrototype = RegExp.prototype;
                var FORCED = DESCRIPTORS && fails(function() {
                    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                    return Object.getOwnPropertyDescriptor(RegExpPrototype, "flags").get.call({
                        dotAll: true,
                        sticky: true
                    }) !== "sy";
                });
                // `RegExp.prototype.flags` getter
                // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
                if (FORCED) objectDefinePropertyModule.f(RegExpPrototype, "flags", {
                    configurable: true,
                    get: regExpFlags
                });
            /***/ },
            /***/ 33290: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(88697);
                var PROPER_FUNCTION_NAME = __webpack_require__(55316).PROPER;
                var redefine = __webpack_require__(35974);
                var anObject = __webpack_require__(83875);
                var isPrototypeOf = __webpack_require__(32010);
                var $toString = __webpack_require__(28967);
                var fails = __webpack_require__(79044);
                var regExpFlags = __webpack_require__(58083);
                var TO_STRING = "toString";
                var RegExpPrototype = RegExp.prototype;
                var n$ToString = RegExpPrototype[TO_STRING];
                var getFlags = uncurryThis(regExpFlags);
                var NOT_GENERIC = fails(function() {
                    return n$ToString.call({
                        source: "a",
                        flags: "b"
                    }) != "/a/b";
                });
                // FF44- RegExp#toString has a wrong name
                var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;
                // `RegExp.prototype.toString` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
                if (NOT_GENERIC || INCORRECT_NAME) redefine(RegExp.prototype, TO_STRING, function toString() {
                    var R = anObject(this);
                    var p = $toString(R.source);
                    var rf = R.flags;
                    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !("flags" in RegExpPrototype) ? getFlags(R) : rf);
                    return "/" + p + "/" + f;
                }, {
                    unsafe: true
                });
            /***/ },
            /***/ 99041: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var collection = __webpack_require__(9121);
                var collectionStrong = __webpack_require__(33513);
                // `Set` constructor
                // https://tc39.es/ecma262/#sec-set-objects
                collection("Set", function(init) {
                    return function Set1() {
                        return init(this, arguments.length ? arguments[0] : undefined);
                    };
                }, collectionStrong);
            /***/ },
            /***/ 18481: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var codeAt = __webpack_require__(91140).codeAt;
                // `String.prototype.codePointAt` method
                // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                $({
                    target: "String",
                    proto: true
                }, {
                    codePointAt: function codePointAt(pos) {
                        return codeAt(this, pos);
                    }
                });
            /***/ },
            /***/ 66923: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var toAbsoluteIndex = __webpack_require__(32565);
                var RangeError1 = global.RangeError;
                var fromCharCode = String.fromCharCode;
                // eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
                var $fromCodePoint = String.fromCodePoint;
                var join = uncurryThis([].join);
                // length should be 1, old FF problem
                var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;
                // `String.fromCodePoint` method
                // https://tc39.es/ecma262/#sec-string.fromcodepoint
                $({
                    target: "String",
                    stat: true,
                    forced: INCORRECT_LENGTH
                }, {
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    fromCodePoint: function fromCodePoint(x) {
                        var elements = [];
                        var length = arguments.length;
                        var i = 0;
                        var code;
                        while(length > i){
                            code = +arguments[i++];
                            if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError1(code + " is not a valid code point");
                            elements[i] = code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
                        }
                        return join(elements, "");
                    }
                });
            /***/ },
            /***/ 19985: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var uncurryThis = __webpack_require__(88697);
                var notARegExp = __webpack_require__(21049);
                var requireObjectCoercible = __webpack_require__(96411);
                var toString = __webpack_require__(28967);
                var correctIsRegExpLogic = __webpack_require__(15454);
                var stringIndexOf = uncurryThis("".indexOf);
                // `String.prototype.includes` method
                // https://tc39.es/ecma262/#sec-string.prototype.includes
                $({
                    target: "String",
                    proto: true,
                    forced: !correctIsRegExpLogic("includes")
                }, {
                    includes: function includes(searchString /* , position = 0 */ ) {
                        return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ 67666: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var createHTML = __webpack_require__(75304);
                var forcedStringHTMLMethod = __webpack_require__(13881);
                // `String.prototype.italics` method
                // https://tc39.es/ecma262/#sec-string.prototype.italics
                $({
                    target: "String",
                    proto: true,
                    forced: forcedStringHTMLMethod("italics")
                }, {
                    italics: function italics() {
                        return createHTML(this, "i", "", "");
                    }
                });
            /***/ },
            /***/ 45007: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__(91140).charAt;
                var toString = __webpack_require__(28967);
                var InternalStateModule = __webpack_require__(20821);
                var defineIterator = __webpack_require__(61495);
                var STRING_ITERATOR = "String Iterator";
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
                // `String.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
                defineIterator(String, "String", function(iterated) {
                    setInternalState(this, {
                        type: STRING_ITERATOR,
                        string: toString(iterated),
                        index: 0
                    });
                // `%StringIteratorPrototype%.next` method
                // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
                }, function next() {
                    var state = getInternalState(this);
                    var string = state.string;
                    var index = state.index;
                    var point;
                    if (index >= string.length) return {
                        value: undefined,
                        done: true
                    };
                    point = charAt(string, index);
                    state.index += point.length;
                    return {
                        value: point,
                        done: false
                    };
                });
            /***/ },
            /***/ 86125: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var createHTML = __webpack_require__(75304);
                var forcedStringHTMLMethod = __webpack_require__(13881);
                // `String.prototype.link` method
                // https://tc39.es/ecma262/#sec-string.prototype.link
                $({
                    target: "String",
                    proto: true,
                    forced: forcedStringHTMLMethod("link")
                }, {
                    link: function link(url) {
                        return createHTML(this, "a", "href", url);
                    }
                });
            /***/ },
            /***/ 55797: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-string-prototype-matchall -- safe */ var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var call = __webpack_require__(79611);
                var uncurryThis = __webpack_require__(88697);
                var createIteratorConstructor = __webpack_require__(6181);
                var requireObjectCoercible = __webpack_require__(96411);
                var toLength = __webpack_require__(35108);
                var toString = __webpack_require__(28967);
                var anObject = __webpack_require__(83875);
                var classof = __webpack_require__(79159);
                var isPrototypeOf = __webpack_require__(32010);
                var isRegExp = __webpack_require__(42622);
                var regExpFlags = __webpack_require__(58083);
                var getMethod = __webpack_require__(97219);
                var redefine = __webpack_require__(35974);
                var fails = __webpack_require__(79044);
                var wellKnownSymbol = __webpack_require__(52280);
                var speciesConstructor = __webpack_require__(7270);
                var advanceStringIndex = __webpack_require__(13350);
                var regExpExec = __webpack_require__(94088);
                var InternalStateModule = __webpack_require__(20821);
                var IS_PURE = __webpack_require__(21178);
                var MATCH_ALL = wellKnownSymbol("matchAll");
                var REGEXP_STRING = "RegExp String";
                var REGEXP_STRING_ITERATOR = REGEXP_STRING + " Iterator";
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
                var RegExpPrototype = RegExp.prototype;
                var TypeError1 = global.TypeError;
                var getFlags = uncurryThis(regExpFlags);
                var stringIndexOf = uncurryThis("".indexOf);
                var un$MatchAll = uncurryThis("".matchAll);
                var WORKS_WITH_NON_GLOBAL_REGEX = !!un$MatchAll && !fails(function() {
                    un$MatchAll("a", /./);
                });
                var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
                    setInternalState(this, {
                        type: REGEXP_STRING_ITERATOR,
                        regexp: regexp,
                        string: string,
                        global: $global,
                        unicode: fullUnicode,
                        done: false
                    });
                }, REGEXP_STRING, function next() {
                    var state = getInternalState(this);
                    if (state.done) return {
                        value: undefined,
                        done: true
                    };
                    var R = state.regexp;
                    var S = state.string;
                    var match = regExpExec(R, S);
                    if (match === null) return {
                        value: undefined,
                        done: state.done = true
                    };
                    if (state.global) {
                        if (toString(match[0]) === "") R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
                        return {
                            value: match,
                            done: false
                        };
                    }
                    state.done = true;
                    return {
                        value: match,
                        done: false
                    };
                });
                var $matchAll = function(string) {
                    var R = anObject(this);
                    var S = toString(string);
                    var C, flagsValue, flags, matcher, $global, fullUnicode;
                    C = speciesConstructor(R, RegExp);
                    flagsValue = R.flags;
                    if (flagsValue === undefined && isPrototypeOf(RegExpPrototype, R) && !("flags" in RegExpPrototype)) flagsValue = getFlags(R);
                    flags = flagsValue === undefined ? "" : toString(flagsValue);
                    matcher = new C(C === RegExp ? R.source : R, flags);
                    $global = !!~stringIndexOf(flags, "g");
                    fullUnicode = !!~stringIndexOf(flags, "u");
                    matcher.lastIndex = toLength(R.lastIndex);
                    return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
                };
                // `String.prototype.matchAll` method
                // https://tc39.es/ecma262/#sec-string.prototype.matchall
                $({
                    target: "String",
                    proto: true,
                    forced: WORKS_WITH_NON_GLOBAL_REGEX
                }, {
                    matchAll: function matchAll(regexp) {
                        var O = requireObjectCoercible(this);
                        var flags, S, matcher, rx;
                        if (regexp != null) {
                            if (isRegExp(regexp)) {
                                flags = toString(requireObjectCoercible("flags" in RegExpPrototype ? regexp.flags : getFlags(regexp)));
                                if (!~stringIndexOf(flags, "g")) throw TypeError1("`.matchAll` does not allow non-global regexes");
                            }
                            if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
                            matcher = getMethod(regexp, MATCH_ALL);
                            if (matcher === undefined && IS_PURE && classof(regexp) == "RegExp") matcher = $matchAll;
                            if (matcher) return call(matcher, regexp, O);
                        } else if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
                        S = toString(O);
                        rx = new RegExp(regexp, "g");
                        return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
                    }
                });
                IS_PURE || MATCH_ALL in RegExpPrototype || redefine(RegExpPrototype, MATCH_ALL, $matchAll);
            /***/ },
            /***/ 75668: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(79611);
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(81492);
                var anObject = __webpack_require__(83875);
                var toLength = __webpack_require__(35108);
                var toString = __webpack_require__(28967);
                var requireObjectCoercible = __webpack_require__(96411);
                var getMethod = __webpack_require__(97219);
                var advanceStringIndex = __webpack_require__(13350);
                var regExpExec = __webpack_require__(94088);
                // @@match logic
                fixRegExpWellKnownSymbolLogic("match", function(MATCH, nativeMatch, maybeCallNative) {
                    return [
                        // `String.prototype.match` method
                        // https://tc39.es/ecma262/#sec-string.prototype.match
                        function match(regexp) {
                            var O = requireObjectCoercible(this);
                            var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
                            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
                        },
                        // `RegExp.prototype[@@match]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
                        function(string) {
                            var rx = anObject(this);
                            var S = toString(string);
                            var res = maybeCallNative(nativeMatch, rx, S);
                            if (res.done) return res.value;
                            if (!rx.global) return regExpExec(rx, S);
                            var fullUnicode = rx.unicode;
                            rx.lastIndex = 0;
                            var A = [];
                            var n = 0;
                            var result;
                            while((result = regExpExec(rx, S)) !== null){
                                var matchStr = toString(result[0]);
                                A[n] = matchStr;
                                if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                                n++;
                            }
                            return n === 0 ? null : A;
                        }
                    ];
                });
            /***/ },
            /***/ 84750: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(19882);
                var repeat = __webpack_require__(26031);
                // `String.prototype.repeat` method
                // https://tc39.es/ecma262/#sec-string.prototype.repeat
                $({
                    target: "String",
                    proto: true
                }, {
                    repeat: repeat
                });
            /***/ },
            /***/ 22321: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var apply = __webpack_require__(63530);
                var call = __webpack_require__(79611);
                var uncurryThis = __webpack_require__(88697);
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(81492);
                var fails = __webpack_require__(79044);
                var anObject = __webpack_require__(83875);
                var isCallable = __webpack_require__(75277);
                var toIntegerOrInfinity = __webpack_require__(14229);
                var toLength = __webpack_require__(35108);
                var toString = __webpack_require__(28967);
                var requireObjectCoercible = __webpack_require__(96411);
                var advanceStringIndex = __webpack_require__(13350);
                var getMethod = __webpack_require__(97219);
                var getSubstitution = __webpack_require__(81373);
                var regExpExec = __webpack_require__(94088);
                var wellKnownSymbol = __webpack_require__(52280);
                var REPLACE = wellKnownSymbol("replace");
                var max = Math.max;
                var min = Math.min;
                var concat = uncurryThis([].concat);
                var push = uncurryThis([].push);
                var stringIndexOf = uncurryThis("".indexOf);
                var stringSlice = uncurryThis("".slice);
                var maybeToString = function(it) {
                    return it === undefined ? it : String(it);
                };
                // IE <= 11 replaces $0 with the whole match, as if it was $&
                // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
                var REPLACE_KEEPS_$0 = function() {
                    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
                    return "a".replace(/./, "$0") === "$0";
                }();
                // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
                var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
                    if (/./[REPLACE]) return /./[REPLACE]("a", "$0") === "";
                    return false;
                }();
                var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
                    var re = /./;
                    re.exec = function() {
                        var result = [];
                        result.groups = {
                            a: "7"
                        };
                        return result;
                    };
                    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
                    return "".replace(re, "$<a>") !== "7";
                });
                // @@replace logic
                fixRegExpWellKnownSymbolLogic("replace", function(_, nativeReplace, maybeCallNative) {
                    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
                    return [
                        // `String.prototype.replace` method
                        // https://tc39.es/ecma262/#sec-string.prototype.replace
                        function replace(searchValue, replaceValue) {
                            var O = requireObjectCoercible(this);
                            var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
                            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
                        },
                        // `RegExp.prototype[@@replace]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
                        function(string, replaceValue) {
                            var rx = anObject(this);
                            var S = toString(string);
                            if (typeof replaceValue == "string" && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, "$<") === -1) {
                                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                                if (res.done) return res.value;
                            }
                            var functionalReplace = isCallable(replaceValue);
                            if (!functionalReplace) replaceValue = toString(replaceValue);
                            var global = rx.global;
                            if (global) {
                                var fullUnicode = rx.unicode;
                                rx.lastIndex = 0;
                            }
                            var results = [];
                            while(true){
                                var result = regExpExec(rx, S);
                                if (result === null) break;
                                push(results, result);
                                if (!global) break;
                                var matchStr = toString(result[0]);
                                if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                            }
                            var accumulatedResult = "";
                            var nextSourcePosition = 0;
                            for(var i = 0; i < results.length; i++){
                                result = results[i];
                                var matched = toString(result[0]);
                                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                                var captures = [];
                                // NOTE: This is equivalent to
                                //   captures = result.slice(1).map(maybeToString)
                                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                                var namedCaptures = result.groups;
                                if (functionalReplace) {
                                    var replacerArgs = concat([
                                        matched
                                    ], captures, position, S);
                                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                                    var replacement = toString(apply(replaceValue, undefined, replacerArgs));
                                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                                if (position >= nextSourcePosition) {
                                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                                    nextSourcePosition = position + matched.length;
                                }
                            }
                            return accumulatedResult + stringSlice(S, nextSourcePosition);
                        }
                    ];
                }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
            /***/ },
            /***/ 67838: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var apply = __webpack_require__(63530);
                var call = __webpack_require__(79611);
                var uncurryThis = __webpack_require__(88697);
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(81492);
                var isRegExp = __webpack_require__(42622);
                var anObject = __webpack_require__(83875);
                var requireObjectCoercible = __webpack_require__(96411);
                var speciesConstructor = __webpack_require__(7270);
                var advanceStringIndex = __webpack_require__(13350);
                var toLength = __webpack_require__(35108);
                var toString = __webpack_require__(28967);
                var getMethod = __webpack_require__(97219);
                var arraySlice = __webpack_require__(15629);
                var callRegExpExec = __webpack_require__(94088);
                var regexpExec = __webpack_require__(99749);
                var stickyHelpers = __webpack_require__(97047);
                var fails = __webpack_require__(79044);
                var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
                var MAX_UINT32 = 0xFFFFFFFF;
                var min = Math.min;
                var $push = [].push;
                var exec = uncurryThis(/./.exec);
                var push = uncurryThis($push);
                var stringSlice = uncurryThis("".slice);
                // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
                // Weex JS has frozen built-in prototypes, so use try / catch wrapper
                var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
                    // eslint-disable-next-line regexp/no-empty-group -- required for testing
                    var re = /(?:)/;
                    var originalExec = re.exec;
                    re.exec = function() {
                        return originalExec.apply(this, arguments);
                    };
                    var result = "ab".split(re);
                    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
                });
                // @@split logic
                fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
                    var internalSplit;
                    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
                    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
                    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
                    internalSplit = function(separator, limit) {
                        var string = toString(requireObjectCoercible(this));
                        var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                        if (lim === 0) return [];
                        if (separator === undefined) return [
                            string
                        ];
                        // If `separator` is not a regex, use native split
                        if (!isRegExp(separator)) return call(nativeSplit, string, separator, lim);
                        var output = [];
                        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
                        var lastLastIndex = 0;
                        // Make `global` and avoid `lastIndex` issues by working with a copy
                        var separatorCopy = new RegExp(separator.source, flags + "g");
                        var match, lastIndex, lastLength;
                        while(match = call(regexpExec, separatorCopy, string)){
                            lastIndex = separatorCopy.lastIndex;
                            if (lastIndex > lastLastIndex) {
                                push(output, stringSlice(string, lastLastIndex, match.index));
                                if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
                                lastLength = match[0].length;
                                lastLastIndex = lastIndex;
                                if (output.length >= lim) break;
                            }
                            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
                        }
                        if (lastLastIndex === string.length) {
                            if (lastLength || !exec(separatorCopy, "")) push(output, "");
                        } else push(output, stringSlice(string, lastLastIndex));
                        return output.length > lim ? arraySlice(output, 0, lim) : output;
                    };
                    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
                        return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
                    };
                    else internalSplit = nativeSplit;
                    return [
                        // `String.prototype.split` method
                        // https://tc39.es/ecma262/#sec-string.prototype.split
                        function split(separator, limit) {
                            var O = requireObjectCoercible(this);
                            var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
                            return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
                        },
                        // `RegExp.prototype[@@split]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
                        //
                        // NOTE: This cannot be properly polyfilled in engines that don't support
                        // the 'y' flag.
                        function(string, limit) {
                            var rx = anObject(this);
                            var S = toString(string);
                            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                            if (res.done) return res.value;
                            var C = speciesConstructor(rx, RegExp);
                            var unicodeMatching = rx.unicode;
                            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (UNSUPPORTED_Y ? "g" : "y");
                            // ^(? + rx + ) is needed, in combination with some S slicing, to
                            // simulate the 'y' flag.
                            var splitter = new C(UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
                            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                            if (lim === 0) return [];
                            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [
                                S
                            ] : [];
                            var p = 0;
                            var q = 0;
                            var A = [];
                            while(q < S.length){
                                splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                                var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                                var e;
                                if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                                else {
                                    push(A, stringSlice(S, p, q));
                                    if (A.length === lim) return A;
                                    for(var i = 1; i <= z.length - 1; i++){
                                        push(A, z[i]);
                                        if (A.length === lim) return A;
                                    }
                                    q = p = e;
                                }
                            }
                            push(A, stringSlice(S, p));
                            return A;
                        }
                    ];
                }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
            /***/ },
            /***/ 54902: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var createHTML = __webpack_require__(75304);
                var forcedStringHTMLMethod = __webpack_require__(13881);
                // `String.prototype.strike` method
                // https://tc39.es/ecma262/#sec-string.prototype.strike
                $({
                    target: "String",
                    proto: true,
                    forced: forcedStringHTMLMethod("strike")
                }, {
                    strike: function strike() {
                        return createHTML(this, "strike", "", "");
                    }
                });
            /***/ },
            /***/ 29897: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var $trim = __webpack_require__(10287).trim;
                var forcedStringTrimMethod = __webpack_require__(68487);
                // `String.prototype.trim` method
                // https://tc39.es/ecma262/#sec-string.prototype.trim
                $({
                    target: "String",
                    proto: true,
                    forced: forcedStringTrimMethod("trim")
                }, {
                    trim: function trim() {
                        return $trim(this);
                    }
                });
            /***/ },
            /***/ 52729: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__(68308);
                // `Symbol.asyncIterator` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.asynciterator
                defineWellKnownSymbol("asyncIterator");
            /***/ },
            /***/ 86632: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // `Symbol.prototype.description` getter
                // https://tc39.es/ecma262/#sec-symbol.prototype.description
                var $ = __webpack_require__(19882);
                var DESCRIPTORS = __webpack_require__(7493);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var hasOwn = __webpack_require__(24792);
                var isCallable = __webpack_require__(75277);
                var isPrototypeOf = __webpack_require__(32010);
                var toString = __webpack_require__(28967);
                var defineProperty = __webpack_require__(86385).f;
                var copyConstructorProperties = __webpack_require__(73870);
                var NativeSymbol = global.Symbol;
                var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
                if (DESCRIPTORS && isCallable(NativeSymbol) && (!("description" in SymbolPrototype) || // Safari 12 bug
                NativeSymbol().description !== undefined)) {
                    var EmptyStringDescriptionStore = {};
                    // wrap Symbol constructor for correct work with undefined description
                    var SymbolWrapper = function Symbol1() {
                        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
                        var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
                        if (description === "") EmptyStringDescriptionStore[result] = true;
                        return result;
                    };
                    copyConstructorProperties(SymbolWrapper, NativeSymbol);
                    SymbolWrapper.prototype = SymbolPrototype;
                    SymbolPrototype.constructor = SymbolWrapper;
                    var NATIVE_SYMBOL = String(NativeSymbol("test")) == "Symbol(test)";
                    var symbolToString = uncurryThis(SymbolPrototype.toString);
                    var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
                    var regexp = /^Symbol\((.*)\)[^)]+$/;
                    var replace = uncurryThis("".replace);
                    var stringSlice = uncurryThis("".slice);
                    defineProperty(SymbolPrototype, "description", {
                        configurable: true,
                        get: function description() {
                            var symbol = symbolValueOf(this);
                            var string = symbolToString(symbol);
                            if (hasOwn(EmptyStringDescriptionStore, symbol)) return "";
                            var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, "$1");
                            return desc === "" ? undefined : desc;
                        }
                    });
                    $({
                        global: true,
                        forced: true
                    }, {
                        Symbol: SymbolWrapper
                    });
                }
            /***/ },
            /***/ 61928: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__(68308);
                // `Symbol.iterator` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.iterator
                defineWellKnownSymbol("iterator");
            /***/ },
            /***/ 26364: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var global = __webpack_require__(98363);
                var getBuiltIn = __webpack_require__(22773);
                var apply = __webpack_require__(63530);
                var call = __webpack_require__(79611);
                var uncurryThis = __webpack_require__(88697);
                var IS_PURE = __webpack_require__(21178);
                var DESCRIPTORS = __webpack_require__(7493);
                var NATIVE_SYMBOL = __webpack_require__(3850);
                var fails = __webpack_require__(79044);
                var hasOwn = __webpack_require__(24792);
                var isArray = __webpack_require__(71982);
                var isCallable = __webpack_require__(75277);
                var isObject = __webpack_require__(52786);
                var isPrototypeOf = __webpack_require__(32010);
                var isSymbol = __webpack_require__(66681);
                var anObject = __webpack_require__(83875);
                var toObject = __webpack_require__(30744);
                var toIndexedObject = __webpack_require__(29580);
                var toPropertyKey = __webpack_require__(383);
                var $toString = __webpack_require__(28967);
                var createPropertyDescriptor = __webpack_require__(69199);
                var nativeObjectCreate = __webpack_require__(51569);
                var objectKeys = __webpack_require__(60667);
                var getOwnPropertyNamesModule = __webpack_require__(87994);
                var getOwnPropertyNamesExternal = __webpack_require__(74938);
                var getOwnPropertySymbolsModule = __webpack_require__(89612);
                var getOwnPropertyDescriptorModule = __webpack_require__(66012);
                var definePropertyModule = __webpack_require__(86385);
                var propertyIsEnumerableModule = __webpack_require__(81513);
                var arraySlice = __webpack_require__(15629);
                var redefine = __webpack_require__(35974);
                var shared = __webpack_require__(53580);
                var sharedKey = __webpack_require__(50466);
                var hiddenKeys = __webpack_require__(47505);
                var uid = __webpack_require__(34524);
                var wellKnownSymbol = __webpack_require__(52280);
                var wrappedWellKnownSymbolModule = __webpack_require__(20127);
                var defineWellKnownSymbol = __webpack_require__(68308);
                var setToStringTag = __webpack_require__(60878);
                var InternalStateModule = __webpack_require__(20821);
                var $forEach = __webpack_require__(68671).forEach;
                var HIDDEN = sharedKey("hidden");
                var SYMBOL = "Symbol";
                var PROTOTYPE = "prototype";
                var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(SYMBOL);
                var ObjectPrototype = Object[PROTOTYPE];
                var $Symbol = global.Symbol;
                var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
                var TypeError1 = global.TypeError;
                var QObject = global.QObject;
                var $stringify = getBuiltIn("JSON", "stringify");
                var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                var nativeDefineProperty = definePropertyModule.f;
                var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
                var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
                var push = uncurryThis([].push);
                var AllSymbols = shared("symbols");
                var ObjectPrototypeSymbols = shared("op-symbols");
                var StringToSymbolRegistry = shared("string-to-symbol-registry");
                var SymbolToStringRegistry = shared("symbol-to-string-registry");
                var WellKnownSymbolsStore = shared("wks");
                // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
                var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
                // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
                var setSymbolDescriptor = DESCRIPTORS && fails(function() {
                    return nativeObjectCreate(nativeDefineProperty({}, "a", {
                        get: function() {
                            return nativeDefineProperty(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a != 7;
                }) ? function(O, P, Attributes) {
                    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
                    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
                    nativeDefineProperty(O, P, Attributes);
                    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
                } : nativeDefineProperty;
                var wrap = function(tag, description) {
                    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
                    setInternalState(symbol, {
                        type: SYMBOL,
                        tag: tag,
                        description: description
                    });
                    if (!DESCRIPTORS) symbol.description = description;
                    return symbol;
                };
                var $defineProperty = function defineProperty(O, P, Attributes) {
                    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
                    anObject(O);
                    var key = toPropertyKey(P);
                    anObject(Attributes);
                    if (hasOwn(AllSymbols, key)) {
                        if (!Attributes.enumerable) {
                            if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
                            O[HIDDEN][key] = true;
                        } else {
                            if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                            Attributes = nativeObjectCreate(Attributes, {
                                enumerable: createPropertyDescriptor(0, false)
                            });
                        }
                        return setSymbolDescriptor(O, key, Attributes);
                    }
                    return nativeDefineProperty(O, key, Attributes);
                };
                var $defineProperties = function defineProperties(O, Properties) {
                    anObject(O);
                    var properties = toIndexedObject(Properties);
                    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
                    $forEach(keys, function(key) {
                        if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
                    });
                    return O;
                };
                var $create = function create(O, Properties) {
                    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
                };
                var $propertyIsEnumerable = function propertyIsEnumerable(V) {
                    var P = toPropertyKey(V);
                    var enumerable = call(nativePropertyIsEnumerable, this, P);
                    if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
                    return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
                };
                var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
                    var it = toIndexedObject(O);
                    var key = toPropertyKey(P);
                    if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
                    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
                    if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
                    return descriptor;
                };
                var $getOwnPropertyNames = function getOwnPropertyNames(O) {
                    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
                    var result = [];
                    $forEach(names, function(key) {
                        if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
                    });
                    return result;
                };
                var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
                    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
                    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
                    var result = [];
                    $forEach(names, function(key) {
                        if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) push(result, AllSymbols[key]);
                    });
                    return result;
                };
                // `Symbol` constructor
                // https://tc39.es/ecma262/#sec-symbol-constructor
                if (!NATIVE_SYMBOL) {
                    $Symbol = function Symbol1() {
                        if (isPrototypeOf(SymbolPrototype, this)) throw TypeError1("Symbol is not a constructor");
                        var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
                        var tag = uid(description);
                        var setter = function(value) {
                            if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
                            if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                            setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
                        };
                        if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                            configurable: true,
                            set: setter
                        });
                        return wrap(tag, description);
                    };
                    SymbolPrototype = $Symbol[PROTOTYPE];
                    redefine(SymbolPrototype, "toString", function toString() {
                        return getInternalState(this).tag;
                    });
                    redefine($Symbol, "withoutSetter", function(description) {
                        return wrap(uid(description), description);
                    });
                    propertyIsEnumerableModule.f = $propertyIsEnumerable;
                    definePropertyModule.f = $defineProperty;
                    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
                    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
                    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
                    wrappedWellKnownSymbolModule.f = function(name) {
                        return wrap(wellKnownSymbol(name), name);
                    };
                    if (DESCRIPTORS) {
                        // https://github.com/tc39/proposal-Symbol-description
                        nativeDefineProperty(SymbolPrototype, "description", {
                            configurable: true,
                            get: function description() {
                                return getInternalState(this).description;
                            }
                        });
                        if (!IS_PURE) redefine(ObjectPrototype, "propertyIsEnumerable", $propertyIsEnumerable, {
                            unsafe: true
                        });
                    }
                }
                $({
                    global: true,
                    wrap: true,
                    forced: !NATIVE_SYMBOL,
                    sham: !NATIVE_SYMBOL
                }, {
                    Symbol: $Symbol
                });
                $forEach(objectKeys(WellKnownSymbolsStore), function(name) {
                    defineWellKnownSymbol(name);
                });
                $({
                    target: SYMBOL,
                    stat: true,
                    forced: !NATIVE_SYMBOL
                }, {
                    // `Symbol.for` method
                    // https://tc39.es/ecma262/#sec-symbol.for
                    "for": function(key) {
                        var string = $toString(key);
                        if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
                        var symbol = $Symbol(string);
                        StringToSymbolRegistry[string] = symbol;
                        SymbolToStringRegistry[symbol] = string;
                        return symbol;
                    },
                    // `Symbol.keyFor` method
                    // https://tc39.es/ecma262/#sec-symbol.keyfor
                    keyFor: function keyFor(sym) {
                        if (!isSymbol(sym)) throw TypeError1(sym + " is not a symbol");
                        if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
                    },
                    useSetter: function() {
                        USE_SETTER = true;
                    },
                    useSimple: function() {
                        USE_SETTER = false;
                    }
                });
                $({
                    target: "Object",
                    stat: true,
                    forced: !NATIVE_SYMBOL,
                    sham: !DESCRIPTORS
                }, {
                    // `Object.create` method
                    // https://tc39.es/ecma262/#sec-object.create
                    create: $create,
                    // `Object.defineProperty` method
                    // https://tc39.es/ecma262/#sec-object.defineproperty
                    defineProperty: $defineProperty,
                    // `Object.defineProperties` method
                    // https://tc39.es/ecma262/#sec-object.defineproperties
                    defineProperties: $defineProperties,
                    // `Object.getOwnPropertyDescriptor` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
                });
                $({
                    target: "Object",
                    stat: true,
                    forced: !NATIVE_SYMBOL
                }, {
                    // `Object.getOwnPropertyNames` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertynames
                    getOwnPropertyNames: $getOwnPropertyNames,
                    // `Object.getOwnPropertySymbols` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
                    getOwnPropertySymbols: $getOwnPropertySymbols
                });
                // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
                // https://bugs.chromium.org/p/v8/issues/detail?id=3443
                $({
                    target: "Object",
                    stat: true,
                    forced: fails(function() {
                        getOwnPropertySymbolsModule.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                        return getOwnPropertySymbolsModule.f(toObject(it));
                    }
                });
                // `JSON.stringify` method behavior with symbols
                // https://tc39.es/ecma262/#sec-json.stringify
                if ($stringify) {
                    var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function() {
                        var symbol = $Symbol();
                        // MS Edge converts symbol values to JSON as {}
                        return $stringify([
                            symbol
                        ]) != "[null]" || $stringify({
                            a: symbol
                        }) != "{}" || $stringify(Object(symbol)) != "{}";
                    });
                    $({
                        target: "JSON",
                        stat: true,
                        forced: FORCED_JSON_STRINGIFY
                    }, {
                        // eslint-disable-next-line no-unused-vars -- required for `.length`
                        stringify: function stringify(it, replacer, space) {
                            var args = arraySlice(arguments);
                            var $replacer = replacer;
                            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                            if (!isArray(replacer)) replacer = function(key, value) {
                                if (isCallable($replacer)) value = call($replacer, this, key, value);
                                if (!isSymbol(value)) return value;
                            };
                            args[1] = replacer;
                            return apply($stringify, null, args);
                        }
                    });
                }
                // `Symbol.prototype[@@toPrimitive]` method
                // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
                if (!SymbolPrototype[TO_PRIMITIVE]) {
                    var valueOf = SymbolPrototype.valueOf;
                    // eslint-disable-next-line no-unused-vars -- required for .length
                    redefine(SymbolPrototype, TO_PRIMITIVE, function(hint) {
                        // TODO: improve hint logic
                        return call(valueOf, this);
                    });
                }
                // `Symbol.prototype[@@toStringTag]` property
                // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
                setToStringTag($Symbol, SYMBOL);
                hiddenKeys[HIDDEN] = true;
            /***/ },
            /***/ 16543: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__(68308);
                // `Symbol.toPrimitive` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.toprimitive
                defineWellKnownSymbol("toPrimitive");
            /***/ },
            /***/ 33694: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__(68308);
                // `Symbol.toStringTag` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.tostringtag
                defineWellKnownSymbol("toStringTag");
            /***/ },
            /***/ 21358: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(88697);
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $ArrayCopyWithin = __webpack_require__(28794);
                var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.copyWithin` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
                exportTypedArrayMethod("copyWithin", function copyWithin(target, start /* , end */ ) {
                    return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
                });
            /***/ },
            /***/ 66887: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $every = __webpack_require__(68671).every;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.every` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
                exportTypedArrayMethod("every", function every(callbackfn /* , thisArg */ ) {
                    return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 77353: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var call = __webpack_require__(79611);
                var $fill = __webpack_require__(55522);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.fill` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
                exportTypedArrayMethod("fill", function fill(value /* , start, end */ ) {
                    var length = arguments.length;
                    return call($fill, aTypedArray(this), value, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
                });
            /***/ },
            /***/ 6366: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $filter = __webpack_require__(68671).filter;
                var fromSpeciesAndList = __webpack_require__(53687);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.filter` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
                exportTypedArrayMethod("filter", function filter(callbackfn /* , thisArg */ ) {
                    var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    return fromSpeciesAndList(this, list);
                });
            /***/ },
            /***/ 65056: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $findIndex = __webpack_require__(68671).findIndex;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.findIndex` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
                exportTypedArrayMethod("findIndex", function findIndex(predicate /* , thisArg */ ) {
                    return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 52372: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $find = __webpack_require__(68671).find;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.find` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
                exportTypedArrayMethod("find", function find(predicate /* , thisArg */ ) {
                    return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 31120: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Float32Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Float32", function(init) {
                    return function Float32Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 85569: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Float64Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Float64", function(init) {
                    return function Float64Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 53677: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $forEach = __webpack_require__(68671).forEach;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.forEach` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
                exportTypedArrayMethod("forEach", function forEach(callbackfn /* , thisArg */ ) {
                    $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 26875: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(63231);
                var exportTypedArrayStaticMethod = __webpack_require__(32590).exportTypedArrayStaticMethod;
                var typedArrayFrom = __webpack_require__(66503);
                // `%TypedArray%.from` method
                // https://tc39.es/ecma262/#sec-%typedarray%.from
                exportTypedArrayStaticMethod("from", typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
            /***/ },
            /***/ 77355: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $includes = __webpack_require__(37190).includes;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.includes` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
                exportTypedArrayMethod("includes", function includes(searchElement /* , fromIndex */ ) {
                    return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 28784: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $indexOf = __webpack_require__(37190).indexOf;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.indexOf` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
                exportTypedArrayMethod("indexOf", function indexOf(searchElement /* , fromIndex */ ) {
                    return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 100: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Int16Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Int16", function(init) {
                    return function Int16Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 26770: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Int32Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Int32", function(init) {
                    return function Int32Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 33324: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Int8Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Int8", function(init) {
                    return function Int8Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 98554: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var PROPER_FUNCTION_NAME = __webpack_require__(55316).PROPER;
                var ArrayBufferViewCore = __webpack_require__(32590);
                var ArrayIterators = __webpack_require__(54883);
                var wellKnownSymbol = __webpack_require__(52280);
                var ITERATOR = wellKnownSymbol("iterator");
                var Uint8Array1 = global.Uint8Array;
                var arrayValues = uncurryThis(ArrayIterators.values);
                var arrayKeys = uncurryThis(ArrayIterators.keys);
                var arrayEntries = uncurryThis(ArrayIterators.entries);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var nativeTypedArrayIterator = Uint8Array1 && Uint8Array1.prototype[ITERATOR];
                var PROPER_ARRAY_VALUES_NAME = !!nativeTypedArrayIterator && nativeTypedArrayIterator.name === "values";
                var typedArrayValues = function values() {
                    return arrayValues(aTypedArray(this));
                };
                // `%TypedArray%.prototype.entries` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
                exportTypedArrayMethod("entries", function entries() {
                    return arrayEntries(aTypedArray(this));
                });
                // `%TypedArray%.prototype.keys` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
                exportTypedArrayMethod("keys", function keys() {
                    return arrayKeys(aTypedArray(this));
                });
                // `%TypedArray%.prototype.values` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
                exportTypedArrayMethod("values", typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
                // `%TypedArray%.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
                exportTypedArrayMethod(ITERATOR, typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
            /***/ },
            /***/ 72403: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var uncurryThis = __webpack_require__(88697);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var $join = uncurryThis([].join);
                // `%TypedArray%.prototype.join` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
                exportTypedArrayMethod("join", function join(separator) {
                    return $join(aTypedArray(this), separator);
                });
            /***/ },
            /***/ 14312: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var apply = __webpack_require__(63530);
                var $lastIndexOf = __webpack_require__(27837);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.lastIndexOf` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
                exportTypedArrayMethod("lastIndexOf", function lastIndexOf(searchElement /* , fromIndex */ ) {
                    var length = arguments.length;
                    return apply($lastIndexOf, aTypedArray(this), length > 1 ? [
                        searchElement,
                        arguments[1]
                    ] : [
                        searchElement
                    ]);
                });
            /***/ },
            /***/ 63444: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $map = __webpack_require__(68671).map;
                var typedArraySpeciesConstructor = __webpack_require__(36107);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.map` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
                exportTypedArrayMethod("map", function map(mapfn /* , thisArg */ ) {
                    return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function(O, length) {
                        return new (typedArraySpeciesConstructor(O))(length);
                    });
                });
            /***/ },
            /***/ 36798: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $reduceRight = __webpack_require__(86596).right;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.reduceRicht` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
                exportTypedArrayMethod("reduceRight", function reduceRight(callbackfn /* , initialValue */ ) {
                    var length = arguments.length;
                    return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 40070: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $reduce = __webpack_require__(86596).left;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.reduce` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
                exportTypedArrayMethod("reduce", function reduce(callbackfn /* , initialValue */ ) {
                    var length = arguments.length;
                    return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 58036: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var floor = Math.floor;
                // `%TypedArray%.prototype.reverse` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
                exportTypedArrayMethod("reverse", function reverse() {
                    var that = this;
                    var length = aTypedArray(that).length;
                    var middle = floor(length / 2);
                    var index = 0;
                    var value;
                    while(index < middle){
                        value = that[index];
                        that[index++] = that[--length];
                        that[length] = value;
                    }
                    return that;
                });
            /***/ },
            /***/ 27578: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var ArrayBufferViewCore = __webpack_require__(32590);
                var lengthOfArrayLike = __webpack_require__(47046);
                var toOffset = __webpack_require__(65758);
                var toObject = __webpack_require__(30744);
                var fails = __webpack_require__(79044);
                var RangeError1 = global.RangeError;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var FORCED = fails(function() {
                    // eslint-disable-next-line es/no-typed-arrays -- required for testing
                    new Int8Array(1).set({});
                });
                // `%TypedArray%.prototype.set` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
                exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
                    aTypedArray(this);
                    var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
                    var length = this.length;
                    var src = toObject(arrayLike);
                    var len = lengthOfArrayLike(src);
                    var index = 0;
                    if (len + offset > length) throw RangeError1("Wrong length");
                    while(index < len)this[offset + index] = src[index++];
                }, FORCED);
            /***/ },
            /***/ 99641: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var typedArraySpeciesConstructor = __webpack_require__(36107);
                var fails = __webpack_require__(79044);
                var arraySlice = __webpack_require__(15629);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var FORCED = fails(function() {
                    // eslint-disable-next-line es/no-typed-arrays -- required for testing
                    new Int8Array(1).slice();
                });
                // `%TypedArray%.prototype.slice` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
                exportTypedArrayMethod("slice", function slice(start, end) {
                    var list = arraySlice(aTypedArray(this), start, end);
                    var C = typedArraySpeciesConstructor(this);
                    var index = 0;
                    var length = list.length;
                    var result = new C(length);
                    while(length > index)result[index] = list[index++];
                    return result;
                }, FORCED);
            /***/ },
            /***/ 12298: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var $some = __webpack_require__(68671).some;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.some` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
                exportTypedArrayMethod("some", function some(callbackfn /* , thisArg */ ) {
                    return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 97306: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var fails = __webpack_require__(79044);
                var aCallable = __webpack_require__(97676);
                var internalSort = __webpack_require__(2013);
                var ArrayBufferViewCore = __webpack_require__(32590);
                var FF = __webpack_require__(34631);
                var IE_OR_EDGE = __webpack_require__(80442);
                var V8 = __webpack_require__(11197);
                var WEBKIT = __webpack_require__(76929);
                var Array1 = global.Array;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var Uint16Array1 = global.Uint16Array;
                var un$Sort = Uint16Array1 && uncurryThis(Uint16Array1.prototype.sort);
                // WebKit
                var ACCEPT_INCORRECT_ARGUMENTS = !!un$Sort && !(fails(function() {
                    un$Sort(new Uint16Array1(2), null);
                }) && fails(function() {
                    un$Sort(new Uint16Array1(2), {});
                }));
                var STABLE_SORT = !!un$Sort && !fails(function() {
                    // feature detection can be too slow, so check engines versions
                    if (V8) return V8 < 74;
                    if (FF) return FF < 67;
                    if (IE_OR_EDGE) return true;
                    if (WEBKIT) return WEBKIT < 602;
                    var array = new Uint16Array1(516);
                    var expected = Array1(516);
                    var index, mod;
                    for(index = 0; index < 516; index++){
                        mod = index % 4;
                        array[index] = 515 - index;
                        expected[index] = index - 2 * mod + 3;
                    }
                    un$Sort(array, function(a, b) {
                        return (a / 4 | 0) - (b / 4 | 0);
                    });
                    for(index = 0; index < 516; index++){
                        if (array[index] !== expected[index]) return true;
                    }
                });
                var getSortCompare = function(comparefn) {
                    return function(x, y) {
                        if (comparefn !== undefined) return +comparefn(x, y) || 0;
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (y !== y) return -1;
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (x !== x) return 1;
                        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
                        return x > y;
                    };
                };
                // `%TypedArray%.prototype.sort` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
                exportTypedArrayMethod("sort", function sort(comparefn) {
                    if (comparefn !== undefined) aCallable(comparefn);
                    if (STABLE_SORT) return un$Sort(this, comparefn);
                    return internalSort(aTypedArray(this), getSortCompare(comparefn));
                }, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
            /***/ },
            /***/ 25480: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(32590);
                var toLength = __webpack_require__(35108);
                var toAbsoluteIndex = __webpack_require__(32565);
                var typedArraySpeciesConstructor = __webpack_require__(36107);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.subarray` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
                exportTypedArrayMethod("subarray", function subarray(begin, end) {
                    var O = aTypedArray(this);
                    var length = O.length;
                    var beginIndex = toAbsoluteIndex(begin, length);
                    var C = typedArraySpeciesConstructor(O);
                    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex));
                });
            /***/ },
            /***/ 14314: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(98363);
                var apply = __webpack_require__(63530);
                var ArrayBufferViewCore = __webpack_require__(32590);
                var fails = __webpack_require__(79044);
                var arraySlice = __webpack_require__(15629);
                var Int8Array1 = global.Int8Array;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var $toLocaleString = [].toLocaleString;
                // iOS Safari 6.x fails here
                var TO_LOCALE_STRING_BUG = !!Int8Array1 && fails(function() {
                    $toLocaleString.call(new Int8Array1(1));
                });
                var FORCED = fails(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new Int8Array1([
                        1,
                        2
                    ]).toLocaleString();
                }) || !fails(function() {
                    Int8Array1.prototype.toLocaleString.call([
                        1,
                        2
                    ]);
                });
                // `%TypedArray%.prototype.toLocaleString` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
                exportTypedArrayMethod("toLocaleString", function toLocaleString() {
                    return apply($toLocaleString, TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this), arraySlice(arguments));
                }, FORCED);
            /***/ },
            /***/ 10572: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var exportTypedArrayMethod = __webpack_require__(32590).exportTypedArrayMethod;
                var fails = __webpack_require__(79044);
                var global = __webpack_require__(98363);
                var uncurryThis = __webpack_require__(88697);
                var Uint8Array1 = global.Uint8Array;
                var Uint8ArrayPrototype = Uint8Array1 && Uint8Array1.prototype || {};
                var arrayToString = [].toString;
                var join = uncurryThis([].join);
                if (fails(function() {
                    arrayToString.call({});
                })) arrayToString = function toString() {
                    return join(this);
                };
                var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;
                // `%TypedArray%.prototype.toString` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
                exportTypedArrayMethod("toString", arrayToString, IS_NOT_ARRAY_METHOD);
            /***/ },
            /***/ 51360: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Uint16Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Uint16", function(init) {
                    return function Uint16Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 35779: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Uint32Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Uint32", function(init) {
                    return function Uint32Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 79627: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Uint8Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Uint8", function(init) {
                    return function Uint8Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 71228: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(26764);
                // `Uint8ClampedArray` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor("Uint8", function(init) {
                    return function Uint8ClampedArray1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                }, true);
            /***/ },
            /***/ 85506: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(55739);
            /***/ },
            /***/ 4116: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(62688);
            /***/ },
            /***/ 38634: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(12382);
            /***/ },
            /***/ 67298: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(487);
            /***/ },
            /***/ 8108: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var newPromiseCapabilityModule = __webpack_require__(29269);
                var perform = __webpack_require__(74443);
                // `Promise.try` method
                // https://github.com/tc39/proposal-promise-try
                $({
                    target: "Promise",
                    stat: true
                }, {
                    "try": function(callbackfn) {
                        var promiseCapability = newPromiseCapabilityModule.f(this);
                        var result = perform(callbackfn);
                        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
                        return promiseCapability.promise;
                    }
                });
            /***/ },
            /***/ 47639: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(55797);
            /***/ },
            /***/ 6208: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var DOMIterables = __webpack_require__(12848);
                var DOMTokenListPrototype = __webpack_require__(79189);
                var forEach = __webpack_require__(20379);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var handlePrototype = function(CollectionPrototype) {
                    // some Chrome versions have non-configurable methods on DOMTokenList
                    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
                        createNonEnumerableProperty(CollectionPrototype, "forEach", forEach);
                    } catch (error) {
                        CollectionPrototype.forEach = forEach;
                    }
                };
                for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
                handlePrototype(DOMTokenListPrototype);
            /***/ },
            /***/ 68995: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(98363);
                var DOMIterables = __webpack_require__(12848);
                var DOMTokenListPrototype = __webpack_require__(79189);
                var ArrayIteratorMethods = __webpack_require__(54883);
                var createNonEnumerableProperty = __webpack_require__(45899);
                var wellKnownSymbol = __webpack_require__(52280);
                var ITERATOR = wellKnownSymbol("iterator");
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var ArrayValues = ArrayIteratorMethods.values;
                var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
                    if (CollectionPrototype) {
                        // some Chrome versions have non-configurable methods on DOMTokenList
                        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
                            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
                        } catch (error) {
                            CollectionPrototype[ITERATOR] = ArrayValues;
                        }
                        if (!CollectionPrototype[TO_STRING_TAG]) createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
                        if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
                            // some Chrome versions have non-configurable methods on DOMTokenList
                            if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                            } catch (error) {
                                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                            }
                        }
                    }
                };
                for(var COLLECTION_NAME in DOMIterables)handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
                handlePrototype(DOMTokenListPrototype, "DOMTokenList");
            /***/ },
            /***/ 87191: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(19882);
                var call = __webpack_require__(79611);
                // `URL.prototype.toJSON` method
                // https://url.spec.whatwg.org/#dom-url-tojson
                $({
                    target: "URL",
                    proto: true,
                    enumerable: true
                }, {
                    toJSON: function toJSON() {
                        return call(URL.prototype.toString, this);
                    }
                });
            /***/ },
            /***/ 80623: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var parent = __webpack_require__(55047);
                __webpack_require__(68995);
                module1.exports = parent;
            /***/ },
            /***/ 27074: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var objectKeys = __webpack_require__(806);
                var isArguments = __webpack_require__(77092);
                var is = __webpack_require__(7402);
                var isRegex = __webpack_require__(55278);
                var flags = __webpack_require__(80251);
                var isDate = __webpack_require__(28659);
                var getTime = Date.prototype.getTime;
                function deepEqual(actual, expected, options) {
                    var opts = options || {};
                    // 7.1. All identical values are equivalent, as determined by ===.
                    if (opts.strict ? is(actual, expected) : actual === expected) return true;
                    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
                    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? is(actual, expected) : actual == expected;
                    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
                    return objEquiv(actual, expected, opts);
                }
                function isUndefinedOrNull(value) {
                    return value === null || value === undefined;
                }
                function isBuffer(x) {
                    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
                    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
                    if (x.length > 0 && typeof x[0] !== "number") return false;
                    return true;
                }
                function objEquiv(a, b, opts) {
                    /* eslint max-statements: [2, 50] */ var i, key;
                    if (typeof a !== typeof b) return false;
                    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                    // an identical 'prototype' property.
                    if (a.prototype !== b.prototype) return false;
                    if (isArguments(a) !== isArguments(b)) return false;
                    var aIsRegex = isRegex(a);
                    var bIsRegex = isRegex(b);
                    if (aIsRegex !== bIsRegex) return false;
                    if (aIsRegex || bIsRegex) return a.source === b.source && flags(a) === flags(b);
                    if (isDate(a) && isDate(b)) return getTime.call(a) === getTime.call(b);
                    var aIsBuffer = isBuffer(a);
                    var bIsBuffer = isBuffer(b);
                    if (aIsBuffer !== bIsBuffer) return false;
                    if (aIsBuffer || bIsBuffer) {
                        if (a.length !== b.length) return false;
                        for(i = 0; i < a.length; i++){
                            if (a[i] !== b[i]) return false;
                        }
                        return true;
                    }
                    if (typeof a !== typeof b) return false;
                    try {
                        var ka = objectKeys(a);
                        var kb = objectKeys(b);
                    } catch (e) {
                        return false;
                    }
                    // having the same number of owned properties (keys incorporates hasOwnProperty)
                    if (ka.length !== kb.length) return false;
                    // the same set of keys (although not necessarily the same order),
                    ka.sort();
                    kb.sort();
                    // ~~~cheap key test
                    for(i = ka.length - 1; i >= 0; i--){
                        if (ka[i] != kb[i]) return false;
                    }
                    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
                    for(i = ka.length - 1; i >= 0; i--){
                        key = ka[i];
                        if (!deepEqual(a[key], b[key], opts)) return false;
                    }
                    return true;
                }
                module1.exports = deepEqual;
            /***/ },
            /***/ 72656: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasPropertyDescriptors = __webpack_require__(28198)();
                var GetIntrinsic = __webpack_require__(31801);
                var $defineProperty = hasPropertyDescriptors && GetIntrinsic("%Object.defineProperty%", true);
                if ($defineProperty) try {
                    $defineProperty({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    // IE 8 has a broken defineProperty
                    $defineProperty = false;
                }
                var $SyntaxError = GetIntrinsic("%SyntaxError%");
                var $TypeError = GetIntrinsic("%TypeError%");
                var gopd = __webpack_require__(93828);
                /** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module1.exports = function defineDataProperty(obj, property, value) {
                    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
                    if (typeof property !== "string" && typeof property !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
                    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
                    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
                    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
                    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
                    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
                    var nonWritable = arguments.length > 4 ? arguments[4] : null;
                    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
                    var loose = arguments.length > 6 ? arguments[6] : false;
                    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
                    if ($defineProperty) $defineProperty(obj, property, {
                        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
                        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
                        value: value,
                        writable: nonWritable === null && desc ? desc.writable : !nonWritable
                    });
                    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
                    obj[property] = value; // eslint-disable-line no-param-reassign
                    else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
                };
            /***/ },
            /***/ 19170: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var keys = __webpack_require__(806);
                var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
                var toStr = Object.prototype.toString;
                var concat = Array.prototype.concat;
                var defineDataProperty = __webpack_require__(72656);
                var isFunction = function(fn) {
                    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
                };
                var supportsDescriptors = __webpack_require__(28198)();
                var defineProperty = function(object, name, value, predicate) {
                    if (name in object) {
                        if (predicate === true) {
                            if (object[name] === value) return;
                        } else if (!isFunction(predicate) || !predicate()) return;
                    }
                    if (supportsDescriptors) defineDataProperty(object, name, value, true);
                    else defineDataProperty(object, name, value);
                };
                var defineProperties = function(object, map) {
                    var predicates = arguments.length > 2 ? arguments[2] : {};
                    var props = keys(map);
                    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
                    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
                };
                defineProperties.supportsDescriptors = !!supportsDescriptors;
                module1.exports = defineProperties;
            /***/ },
            /***/ 5939: /***/ function(module1) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var R = typeof Reflect === "object" ? Reflect : null;
                var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
                    return Function.prototype.apply.call(target, receiver, args);
                };
                var ReflectOwnKeys;
                if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
                else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
                };
                else ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target);
                };
                function ProcessEmitWarning(warning) {
                    if (console && console.warn) console.warn(warning);
                }
                var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
                    return value !== value;
                };
                function EventEmitter() {
                    EventEmitter.init.call(this);
                }
                module1.exports = EventEmitter;
                module1.exports.once = once;
                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._eventsCount = 0;
                EventEmitter.prototype._maxListeners = undefined;
                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                var defaultMaxListeners = 10;
                function checkListener(listener) {
                    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
                }
                Object.defineProperty(EventEmitter, "defaultMaxListeners", {
                    enumerable: true,
                    get: function() {
                        return defaultMaxListeners;
                    },
                    set: function(arg) {
                        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
                        defaultMaxListeners = arg;
                    }
                });
                EventEmitter.init = function() {
                    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                    }
                    this._maxListeners = this._maxListeners || undefined;
                };
                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
                    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
                    this._maxListeners = n;
                    return this;
                };
                function _getMaxListeners(that) {
                    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
                    return that._maxListeners;
                }
                EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
                    return _getMaxListeners(this);
                };
                EventEmitter.prototype.emit = function emit(type) {
                    var args = [];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var doError = type === "error";
                    var events = this._events;
                    if (events !== undefined) doError = doError && events.error === undefined;
                    else if (!doError) return false;
                    // If there is no 'error' event listener then throw.
                    if (doError) {
                        var er;
                        if (args.length > 0) er = args[0];
                        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
                        // up in Node's output if this results in an unhandled exception.
                        throw er; // Unhandled 'error' event
                        // At least give some kind of context to the user
                        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
                        err.context = er;
                        throw err; // Unhandled 'error' event
                    }
                    var handler = events[type];
                    if (handler === undefined) return false;
                    if (typeof handler === "function") ReflectApply(handler, this, args);
                    else {
                        var len = handler.length;
                        var listeners = arrayClone(handler, len);
                        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
                    }
                    return true;
                };
                function _addListener(target, type, listener, prepend) {
                    var m;
                    var events;
                    var existing;
                    checkListener(listener);
                    events = target._events;
                    if (events === undefined) {
                        events = target._events = Object.create(null);
                        target._eventsCount = 0;
                    } else {
                        // To avoid recursion in the case that type === "newListener"! Before
                        // adding it to the listeners, first emit "newListener".
                        if (events.newListener !== undefined) {
                            target.emit("newListener", type, listener.listener ? listener.listener : listener);
                            // Re-assign `events` because a newListener handler could have caused the
                            // this._events to be assigned to a new object
                            events = target._events;
                        }
                        existing = events[type];
                    }
                    if (existing === undefined) {
                        // Optimize the case of one listener. Don't need the extra array object.
                        existing = events[type] = listener;
                        ++target._eventsCount;
                    } else {
                        if (typeof existing === "function") // Adding the second element, need to change to array.
                        existing = events[type] = prepend ? [
                            listener,
                            existing
                        ] : [
                            existing,
                            listener
                        ];
                        else if (prepend) existing.unshift(listener);
                        else existing.push(listener);
                        // Check for listener leak
                        m = _getMaxListeners(target);
                        if (m > 0 && existing.length > m && !existing.warned) {
                            existing.warned = true;
                            // No error code for this since it is a Warning
                            // eslint-disable-next-line no-restricted-syntax
                            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
                            w.name = "MaxListenersExceededWarning";
                            w.emitter = target;
                            w.type = type;
                            w.count = existing.length;
                            ProcessEmitWarning(w);
                        }
                    }
                    return target;
                }
                EventEmitter.prototype.addListener = function addListener(type, listener) {
                    return _addListener(this, type, listener, false);
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.prependListener = function prependListener(type, listener) {
                    return _addListener(this, type, listener, true);
                };
                function onceWrapper() {
                    if (!this.fired) {
                        this.target.removeListener(this.type, this.wrapFn);
                        this.fired = true;
                        if (arguments.length === 0) return this.listener.call(this.target);
                        return this.listener.apply(this.target, arguments);
                    }
                }
                function _onceWrap(target, type, listener) {
                    var state = {
                        fired: false,
                        wrapFn: undefined,
                        target: target,
                        type: type,
                        listener: listener
                    };
                    var wrapped = onceWrapper.bind(state);
                    wrapped.listener = listener;
                    state.wrapFn = wrapped;
                    return wrapped;
                }
                EventEmitter.prototype.once = function once(type, listener) {
                    checkListener(listener);
                    this.on(type, _onceWrap(this, type, listener));
                    return this;
                };
                EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
                    checkListener(listener);
                    this.prependListener(type, _onceWrap(this, type, listener));
                    return this;
                };
                // Emits a 'removeListener' event if and only if the listener was removed.
                EventEmitter.prototype.removeListener = function removeListener(type, listener) {
                    var list, events, position, i, originalListener;
                    checkListener(listener);
                    events = this._events;
                    if (events === undefined) return this;
                    list = events[type];
                    if (list === undefined) return this;
                    if (list === listener || list.listener === listener) {
                        if (--this._eventsCount === 0) this._events = Object.create(null);
                        else {
                            delete events[type];
                            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
                        }
                    } else if (typeof list !== "function") {
                        position = -1;
                        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                            originalListener = list[i].listener;
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (position === 0) list.shift();
                        else spliceOne(list, position);
                        if (list.length === 1) events[type] = list[0];
                        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
                    }
                    return this;
                };
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
                    var listeners, events, i;
                    events = this._events;
                    if (events === undefined) return this;
                    // not listening for removeListener, no need to emit
                    if (events.removeListener === undefined) {
                        if (arguments.length === 0) {
                            this._events = Object.create(null);
                            this._eventsCount = 0;
                        } else if (events[type] !== undefined) {
                            if (--this._eventsCount === 0) this._events = Object.create(null);
                            else delete events[type];
                        }
                        return this;
                    }
                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        var keys = Object.keys(events);
                        var key;
                        for(i = 0; i < keys.length; ++i){
                            key = keys[i];
                            if (key === "removeListener") continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners("removeListener");
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                        return this;
                    }
                    listeners = events[type];
                    if (typeof listeners === "function") this.removeListener(type, listeners);
                    else if (listeners !== undefined) // LIFO order
                    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
                    return this;
                };
                function _listeners(target, type, unwrap) {
                    var events = target._events;
                    if (events === undefined) return [];
                    var evlistener = events[type];
                    if (evlistener === undefined) return [];
                    if (typeof evlistener === "function") return unwrap ? [
                        evlistener.listener || evlistener
                    ] : [
                        evlistener
                    ];
                    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
                }
                EventEmitter.prototype.listeners = function listeners(type) {
                    return _listeners(this, type, true);
                };
                EventEmitter.prototype.rawListeners = function rawListeners(type) {
                    return _listeners(this, type, false);
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
                    else return listenerCount.call(emitter, type);
                };
                EventEmitter.prototype.listenerCount = listenerCount;
                function listenerCount(type) {
                    var events = this._events;
                    if (events !== undefined) {
                        var evlistener = events[type];
                        if (typeof evlistener === "function") return 1;
                        else if (evlistener !== undefined) return evlistener.length;
                    }
                    return 0;
                }
                EventEmitter.prototype.eventNames = function eventNames() {
                    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
                };
                function arrayClone(arr, n) {
                    var copy = new Array(n);
                    for(var i = 0; i < n; ++i)copy[i] = arr[i];
                    return copy;
                }
                function spliceOne(list, index) {
                    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
                    list.pop();
                }
                function unwrapListeners(arr) {
                    var ret = new Array(arr.length);
                    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
                    return ret;
                }
                function once(emitter, name) {
                    return new Promise(function(resolve, reject) {
                        function errorListener(err) {
                            emitter.removeListener(name, resolver);
                            reject(err);
                        }
                        function resolver() {
                            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
                            resolve([].slice.call(arguments));
                        }
                        eventTargetAgnosticAddListener(emitter, name, resolver, {
                            once: true
                        });
                        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
                            once: true
                        });
                    });
                }
                function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
                    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
                }
                function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
                    if (typeof emitter.on === "function") {
                        if (flags.once) emitter.once(name, listener);
                        else emitter.on(name, listener);
                    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
                    // EventEmitters, we do not listen for `error` events here.
                    emitter.addEventListener(name, function wrapListener(arg) {
                        // IE does not have builtin `{ once: true }` support so we
                        // have to do it manually.
                        if (flags.once) emitter.removeEventListener(name, wrapListener);
                        listener(arg);
                    });
                    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
                }
            /***/ },
            /***/ 88706: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // eslint-disable-next-line func-names
                module1.exports = function() {
                    if (typeof globalThis === "object") return globalThis;
                    var g;
                    try {
                        // This works if eval is allowed (see CSP)
                        // eslint-disable-next-line no-new-func
                        g = this || new Function("return this")();
                    } catch (e) {
                        // This works if the window reference is available
                        if (typeof window === "object") return window;
                         // This works if the self reference is available
                        if (typeof self === "object") return self;
                         // This works if the global reference is available
                        if (typeof __webpack_require__.g !== "undefined") return __webpack_require__.g;
                    }
                    return g;
                }();
            /***/ },
            /***/ 94843: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isCallable = __webpack_require__(5443);
                var toStr = Object.prototype.toString;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var forEachArray = function forEachArray(array, iterator, receiver) {
                    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
                        if (receiver == null) iterator(array[i], i, array);
                        else iterator.call(receiver, array[i], i, array);
                    }
                };
                var forEachString = function forEachString(string, iterator, receiver) {
                    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
                    if (receiver == null) iterator(string.charAt(i), i, string);
                    else iterator.call(receiver, string.charAt(i), i, string);
                };
                var forEachObject = function forEachObject(object, iterator, receiver) {
                    for(var k in object)if (hasOwnProperty.call(object, k)) {
                        if (receiver == null) iterator(object[k], k, object);
                        else iterator.call(receiver, object[k], k, object);
                    }
                };
                var forEach = function forEach(list, iterator, thisArg) {
                    if (!isCallable(iterator)) throw new TypeError("iterator must be a function");
                    var receiver;
                    if (arguments.length >= 3) receiver = thisArg;
                    if (toStr.call(list) === "[object Array]") forEachArray(list, iterator, receiver);
                    else if (typeof list === "string") forEachString(list, iterator, receiver);
                    else forEachObject(list, iterator, receiver);
                };
                module1.exports = forEach;
            /***/ },
            /***/ 19930: /***/ function(module1) {
                "use strict";
                /* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
                var toStr = Object.prototype.toString;
                var max = Math.max;
                var funcType = "[object Function]";
                var concatty = function concatty(a, b) {
                    var arr = [];
                    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
                    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
                    return arr;
                };
                var slicy = function slicy(arrLike, offset) {
                    var arr = [];
                    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
                    return arr;
                };
                var joiny = function(arr, joiner) {
                    var str = "";
                    for(var i = 0; i < arr.length; i += 1){
                        str += arr[i];
                        if (i + 1 < arr.length) str += joiner;
                    }
                    return str;
                };
                module1.exports = function bind(that) {
                    var target = this;
                    if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
                    var args = slicy(arguments, 1);
                    var bound;
                    var binder = function() {
                        if (this instanceof bound) {
                            var result = target.apply(this, concatty(args, arguments));
                            if (Object(result) === result) return result;
                            return this;
                        }
                        return target.apply(that, concatty(args, arguments));
                    };
                    var boundLength = max(0, target.length - args.length);
                    var boundArgs = [];
                    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
                    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
                    if (target.prototype) {
                        var Empty = function Empty() {};
                        Empty.prototype = target.prototype;
                        bound.prototype = new Empty();
                        Empty.prototype = null;
                    }
                    return bound;
                };
            /***/ },
            /***/ 21930: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(19930);
                module1.exports = Function.prototype.bind || implementation;
            /***/ },
            /***/ 87105: /***/ function(module1) {
                "use strict";
                var functionsHaveNames = function functionsHaveNames() {
                    return typeof (function f() {}).name === "string";
                };
                var gOPD = Object.getOwnPropertyDescriptor;
                if (gOPD) try {
                    gOPD([], "length");
                } catch (e) {
                    // IE 8 has a broken gOPD
                    gOPD = null;
                }
                functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
                    if (!functionsHaveNames() || !gOPD) return false;
                    var desc = gOPD(function() {}, "name");
                    return !!desc && !!desc.configurable;
                };
                var $bind = Function.prototype.bind;
                functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
                    return functionsHaveNames() && typeof $bind === "function" && (function f() {}).bind().name !== "";
                };
                module1.exports = functionsHaveNames;
            /***/ },
            /***/ 31801: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var undefined1;
                var $SyntaxError = SyntaxError;
                var $Function = Function;
                var $TypeError = TypeError;
                // eslint-disable-next-line consistent-return
                var getEvalledConstructor = function(expressionSyntax) {
                    try {
                        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
                    } catch (e) {}
                };
                var $gOPD = Object.getOwnPropertyDescriptor;
                if ($gOPD) try {
                    $gOPD({}, "");
                } catch (e) {
                    $gOPD = null; // this is IE 8, which has a broken gOPD
                }
                var throwTypeError = function() {
                    throw new $TypeError();
                };
                var ThrowTypeError = $gOPD ? function() {
                    try {
                        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
                        arguments.callee; // IE 8 does not throw here
                        return throwTypeError;
                    } catch (calleeThrows) {
                        try {
                            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                            return $gOPD(arguments, "callee").get;
                        } catch (gOPDthrows) {
                            return throwTypeError;
                        }
                    }
                }() : throwTypeError;
                var hasSymbols = __webpack_require__(99905)();
                var hasProto = __webpack_require__(11856)();
                var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
                    return x.__proto__;
                } // eslint-disable-line no-proto
                 : null);
                var needsEval = {};
                var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined1 : getProto(Uint8Array);
                var INTRINSICS = {
                    "%AggregateError%": typeof AggregateError === "undefined" ? undefined1 : AggregateError,
                    "%Array%": Array,
                    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined1 : ArrayBuffer,
                    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined1,
                    "%AsyncFromSyncIteratorPrototype%": undefined1,
                    "%AsyncFunction%": needsEval,
                    "%AsyncGenerator%": needsEval,
                    "%AsyncGeneratorFunction%": needsEval,
                    "%AsyncIteratorPrototype%": needsEval,
                    "%Atomics%": typeof Atomics === "undefined" ? undefined1 : Atomics,
                    "%BigInt%": typeof BigInt === "undefined" ? undefined1 : BigInt,
                    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined1 : BigInt64Array,
                    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined1 : BigUint64Array,
                    "%Boolean%": Boolean,
                    "%DataView%": typeof DataView === "undefined" ? undefined1 : DataView,
                    "%Date%": Date,
                    "%decodeURI%": decodeURI,
                    "%decodeURIComponent%": decodeURIComponent,
                    "%encodeURI%": encodeURI,
                    "%encodeURIComponent%": encodeURIComponent,
                    "%Error%": Error,
                    "%eval%": eval,
                    "%EvalError%": EvalError,
                    "%Float32Array%": typeof Float32Array === "undefined" ? undefined1 : Float32Array,
                    "%Float64Array%": typeof Float64Array === "undefined" ? undefined1 : Float64Array,
                    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined1 : FinalizationRegistry,
                    "%Function%": $Function,
                    "%GeneratorFunction%": needsEval,
                    "%Int8Array%": typeof Int8Array === "undefined" ? undefined1 : Int8Array,
                    "%Int16Array%": typeof Int16Array === "undefined" ? undefined1 : Int16Array,
                    "%Int32Array%": typeof Int32Array === "undefined" ? undefined1 : Int32Array,
                    "%isFinite%": isFinite,
                    "%isNaN%": isNaN,
                    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined1,
                    "%JSON%": typeof JSON === "object" ? JSON : undefined1,
                    "%Map%": typeof Map === "undefined" ? undefined1 : Map,
                    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined1 : getProto(new Map()[Symbol.iterator]()),
                    "%Math%": Math,
                    "%Number%": Number,
                    "%Object%": Object,
                    "%parseFloat%": parseFloat,
                    "%parseInt%": parseInt,
                    "%Promise%": typeof Promise === "undefined" ? undefined1 : Promise,
                    "%Proxy%": typeof Proxy === "undefined" ? undefined1 : Proxy,
                    "%RangeError%": RangeError,
                    "%ReferenceError%": ReferenceError,
                    "%Reflect%": typeof Reflect === "undefined" ? undefined1 : Reflect,
                    "%RegExp%": RegExp,
                    "%Set%": typeof Set === "undefined" ? undefined1 : Set,
                    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined1 : getProto(new Set()[Symbol.iterator]()),
                    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined1 : SharedArrayBuffer,
                    "%String%": String,
                    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined1,
                    "%Symbol%": hasSymbols ? Symbol : undefined1,
                    "%SyntaxError%": $SyntaxError,
                    "%ThrowTypeError%": ThrowTypeError,
                    "%TypedArray%": TypedArray,
                    "%TypeError%": $TypeError,
                    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined1 : Uint8Array,
                    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined1 : Uint8ClampedArray,
                    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined1 : Uint16Array,
                    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined1 : Uint32Array,
                    "%URIError%": URIError,
                    "%WeakMap%": typeof WeakMap === "undefined" ? undefined1 : WeakMap,
                    "%WeakRef%": typeof WeakRef === "undefined" ? undefined1 : WeakRef,
                    "%WeakSet%": typeof WeakSet === "undefined" ? undefined1 : WeakSet
                };
                if (getProto) try {
                    null.error; // eslint-disable-line no-unused-expressions
                } catch (e) {
                    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
                    var errorProto = getProto(getProto(e));
                    INTRINSICS["%Error.prototype%"] = errorProto;
                }
                var doEval = function doEval(name) {
                    var value;
                    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
                    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
                    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
                    else if (name === "%AsyncGenerator%") {
                        var fn = doEval("%AsyncGeneratorFunction%");
                        if (fn) value = fn.prototype;
                    } else if (name === "%AsyncIteratorPrototype%") {
                        var gen = doEval("%AsyncGenerator%");
                        if (gen && getProto) value = getProto(gen.prototype);
                    }
                    INTRINSICS[name] = value;
                    return value;
                };
                var LEGACY_ALIASES = {
                    "%ArrayBufferPrototype%": [
                        "ArrayBuffer",
                        "prototype"
                    ],
                    "%ArrayPrototype%": [
                        "Array",
                        "prototype"
                    ],
                    "%ArrayProto_entries%": [
                        "Array",
                        "prototype",
                        "entries"
                    ],
                    "%ArrayProto_forEach%": [
                        "Array",
                        "prototype",
                        "forEach"
                    ],
                    "%ArrayProto_keys%": [
                        "Array",
                        "prototype",
                        "keys"
                    ],
                    "%ArrayProto_values%": [
                        "Array",
                        "prototype",
                        "values"
                    ],
                    "%AsyncFunctionPrototype%": [
                        "AsyncFunction",
                        "prototype"
                    ],
                    "%AsyncGenerator%": [
                        "AsyncGeneratorFunction",
                        "prototype"
                    ],
                    "%AsyncGeneratorPrototype%": [
                        "AsyncGeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%BooleanPrototype%": [
                        "Boolean",
                        "prototype"
                    ],
                    "%DataViewPrototype%": [
                        "DataView",
                        "prototype"
                    ],
                    "%DatePrototype%": [
                        "Date",
                        "prototype"
                    ],
                    "%ErrorPrototype%": [
                        "Error",
                        "prototype"
                    ],
                    "%EvalErrorPrototype%": [
                        "EvalError",
                        "prototype"
                    ],
                    "%Float32ArrayPrototype%": [
                        "Float32Array",
                        "prototype"
                    ],
                    "%Float64ArrayPrototype%": [
                        "Float64Array",
                        "prototype"
                    ],
                    "%FunctionPrototype%": [
                        "Function",
                        "prototype"
                    ],
                    "%Generator%": [
                        "GeneratorFunction",
                        "prototype"
                    ],
                    "%GeneratorPrototype%": [
                        "GeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%Int8ArrayPrototype%": [
                        "Int8Array",
                        "prototype"
                    ],
                    "%Int16ArrayPrototype%": [
                        "Int16Array",
                        "prototype"
                    ],
                    "%Int32ArrayPrototype%": [
                        "Int32Array",
                        "prototype"
                    ],
                    "%JSONParse%": [
                        "JSON",
                        "parse"
                    ],
                    "%JSONStringify%": [
                        "JSON",
                        "stringify"
                    ],
                    "%MapPrototype%": [
                        "Map",
                        "prototype"
                    ],
                    "%NumberPrototype%": [
                        "Number",
                        "prototype"
                    ],
                    "%ObjectPrototype%": [
                        "Object",
                        "prototype"
                    ],
                    "%ObjProto_toString%": [
                        "Object",
                        "prototype",
                        "toString"
                    ],
                    "%ObjProto_valueOf%": [
                        "Object",
                        "prototype",
                        "valueOf"
                    ],
                    "%PromisePrototype%": [
                        "Promise",
                        "prototype"
                    ],
                    "%PromiseProto_then%": [
                        "Promise",
                        "prototype",
                        "then"
                    ],
                    "%Promise_all%": [
                        "Promise",
                        "all"
                    ],
                    "%Promise_reject%": [
                        "Promise",
                        "reject"
                    ],
                    "%Promise_resolve%": [
                        "Promise",
                        "resolve"
                    ],
                    "%RangeErrorPrototype%": [
                        "RangeError",
                        "prototype"
                    ],
                    "%ReferenceErrorPrototype%": [
                        "ReferenceError",
                        "prototype"
                    ],
                    "%RegExpPrototype%": [
                        "RegExp",
                        "prototype"
                    ],
                    "%SetPrototype%": [
                        "Set",
                        "prototype"
                    ],
                    "%SharedArrayBufferPrototype%": [
                        "SharedArrayBuffer",
                        "prototype"
                    ],
                    "%StringPrototype%": [
                        "String",
                        "prototype"
                    ],
                    "%SymbolPrototype%": [
                        "Symbol",
                        "prototype"
                    ],
                    "%SyntaxErrorPrototype%": [
                        "SyntaxError",
                        "prototype"
                    ],
                    "%TypedArrayPrototype%": [
                        "TypedArray",
                        "prototype"
                    ],
                    "%TypeErrorPrototype%": [
                        "TypeError",
                        "prototype"
                    ],
                    "%Uint8ArrayPrototype%": [
                        "Uint8Array",
                        "prototype"
                    ],
                    "%Uint8ClampedArrayPrototype%": [
                        "Uint8ClampedArray",
                        "prototype"
                    ],
                    "%Uint16ArrayPrototype%": [
                        "Uint16Array",
                        "prototype"
                    ],
                    "%Uint32ArrayPrototype%": [
                        "Uint32Array",
                        "prototype"
                    ],
                    "%URIErrorPrototype%": [
                        "URIError",
                        "prototype"
                    ],
                    "%WeakMapPrototype%": [
                        "WeakMap",
                        "prototype"
                    ],
                    "%WeakSetPrototype%": [
                        "WeakSet",
                        "prototype"
                    ]
                };
                var bind = __webpack_require__(21930);
                var hasOwn = __webpack_require__(89429);
                var $concat = bind.call(Function.call, Array.prototype.concat);
                var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
                var $replace = bind.call(Function.call, String.prototype.replace);
                var $strSlice = bind.call(Function.call, String.prototype.slice);
                var $exec = bind.call(Function.call, RegExp.prototype.exec);
                /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
                var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
                var stringToPath = function stringToPath(string) {
                    var first = $strSlice(string, 0, 1);
                    var last = $strSlice(string, -1);
                    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
                    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
                    var result = [];
                    $replace(string, rePropName, function(match, number, quote, subString) {
                        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
                    });
                    return result;
                };
                /* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
                    var intrinsicName = name;
                    var alias;
                    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
                        alias = LEGACY_ALIASES[intrinsicName];
                        intrinsicName = "%" + alias[0] + "%";
                    }
                    if (hasOwn(INTRINSICS, intrinsicName)) {
                        var value = INTRINSICS[intrinsicName];
                        if (value === needsEval) value = doEval(intrinsicName);
                        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
                        return {
                            alias: alias,
                            name: intrinsicName,
                            value: value
                        };
                    }
                    throw new $SyntaxError("intrinsic " + name + " does not exist!");
                };
                module1.exports = function GetIntrinsic(name, allowMissing) {
                    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
                    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
                    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                    var parts = stringToPath(name);
                    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
                    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
                    var intrinsicRealName = intrinsic.name;
                    var value = intrinsic.value;
                    var skipFurtherCaching = false;
                    var alias = intrinsic.alias;
                    if (alias) {
                        intrinsicBaseName = alias[0];
                        $spliceApply(parts, $concat([
                            0,
                            1
                        ], alias));
                    }
                    for(var i = 1, isOwn = true; i < parts.length; i += 1){
                        var part = parts[i];
                        var first = $strSlice(part, 0, 1);
                        var last = $strSlice(part, -1);
                        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
                        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
                        intrinsicBaseName += "." + part;
                        intrinsicRealName = "%" + intrinsicBaseName + "%";
                        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
                        else if (value != null) {
                            if (!(part in value)) {
                                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                                return void 0;
                            }
                            if ($gOPD && i + 1 >= parts.length) {
                                var desc = $gOPD(value, part);
                                isOwn = !!desc;
                                // By convention, when a data property is converted to an accessor
                                // property to emulate a data property that does not suffer from
                                // the override mistake, that accessor's getter is marked with
                                // an `originalValue` property. Here, when we detect this, we
                                // uphold the illusion by pretending to see that original data
                                // property, i.e., returning the value rather than the getter
                                // itself.
                                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                                else value = value[part];
                            } else {
                                isOwn = hasOwn(value, part);
                                value = value[part];
                            }
                            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
                        }
                    }
                    return value;
                };
            /***/ },
            /***/ 93828: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(31801);
                var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
                if ($gOPD) try {
                    $gOPD([], "length");
                } catch (e) {
                    // IE 8 has a broken gOPD
                    $gOPD = null;
                }
                module1.exports = $gOPD;
            /***/ },
            /***/ 28198: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(31801);
                var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
                var hasPropertyDescriptors = function hasPropertyDescriptors() {
                    if ($defineProperty) try {
                        $defineProperty({}, "a", {
                            value: 1
                        });
                        return true;
                    } catch (e) {
                        // IE 8 has a broken defineProperty
                        return false;
                    }
                    return false;
                };
                hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
                    // node v0.6 has a bug where array lengths can be Set but not Defined
                    if (!hasPropertyDescriptors()) return null;
                    try {
                        return $defineProperty([], "length", {
                            value: 1
                        }).length !== 1;
                    } catch (e) {
                        // In Firefox 4-22, defining length on an array throws an exception.
                        return true;
                    }
                };
                module1.exports = hasPropertyDescriptors;
            /***/ },
            /***/ 11856: /***/ function(module1) {
                "use strict";
                var test = {
                    foo: {}
                };
                var $Object = Object;
                module1.exports = function hasProto() {
                    return ({
                        __proto__: test
                    }).foo === test.foo && !(({
                        __proto__: null
                    }) instanceof $Object);
                };
            /***/ },
            /***/ 99905: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var origSymbol = typeof Symbol !== "undefined" && Symbol;
                var hasSymbolSham = __webpack_require__(65682);
                module1.exports = function hasNativeSymbols() {
                    if (typeof origSymbol !== "function") return false;
                    if (typeof Symbol !== "function") return false;
                    if (typeof origSymbol("foo") !== "symbol") return false;
                    if (typeof Symbol("bar") !== "symbol") return false;
                    return hasSymbolSham();
                };
            /***/ },
            /***/ 65682: /***/ function(module1) {
                "use strict";
                /* eslint complexity: [2, 18], max-statements: [2, 33] */ module1.exports = function hasSymbols() {
                    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
                    if (typeof Symbol.iterator === "symbol") return true;
                    var obj = {};
                    var sym = Symbol("test");
                    var symObj = Object(sym);
                    if (typeof sym === "string") return false;
                    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
                    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
                    // temp disabled per https://github.com/ljharb/object.assign/issues/17
                    // if (sym instanceof Symbol) { return false; }
                    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
                    // if (!(symObj instanceof Symbol)) { return false; }
                    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
                    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
                    var symVal = 42;
                    obj[sym] = symVal;
                    for(sym in obj)return false;
                     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
                    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
                    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
                    var syms = Object.getOwnPropertySymbols(obj);
                    if (syms.length !== 1 || syms[0] !== sym) return false;
                    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
                    if (typeof Object.getOwnPropertyDescriptor === "function") {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
                        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
                    }
                    return true;
                };
            /***/ },
            /***/ 44111: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasSymbols = __webpack_require__(65682);
                module1.exports = function hasToStringTagShams() {
                    return hasSymbols() && !!Symbol.toStringTag;
                };
            /***/ },
            /***/ 89429: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = Function.prototype.call;
                var $hasOwn = Object.prototype.hasOwnProperty;
                var bind = __webpack_require__(21930);
                /** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module1.exports = bind.call(call, $hasOwn);
            /***/ },
            /***/ 72959: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
                // Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
                // To save memory and loading time, we read table files only when requested.
                exports._dbcs = DBCSCodec;
                var UNASSIGNED = -1, GB18030_CODE = -2, SEQ_START = -10, NODE_START = -1000, UNASSIGNED_NODE = new Array(0x100), DEF_CHAR = -1;
                for(var i = 0; i < 0x100; i++)UNASSIGNED_NODE[i] = UNASSIGNED;
                // Class DBCSCodec reads and initializes mapping tables.
                function DBCSCodec(codecOptions, iconv) {
                    this.encodingName = codecOptions.encodingName;
                    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
                    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
                    // Load tables.
                    var mappingTable = codecOptions.table();
                    // Decode tables: MBCS -> Unicode.
                    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
                    // Trie root is decodeTables[0].
                    // Values: >=  0 -> unicode character code. can be > 0xFFFF
                    //         == UNASSIGNED -> unknown/unassigned sequence.
                    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
                    //         <= NODE_START -> index of the next node in our trie to process next byte.
                    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
                    this.decodeTables = [];
                    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.
                    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
                    this.decodeTableSeq = [];
                    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
                    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
                    // Load & create GB18030 tables when needed.
                    if (typeof codecOptions.gb18030 === "function") {
                        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
                        // Add GB18030 common decode nodes.
                        var commonThirdByteNodeIdx = this.decodeTables.length;
                        this.decodeTables.push(UNASSIGNED_NODE.slice(0));
                        var commonFourthByteNodeIdx = this.decodeTables.length;
                        this.decodeTables.push(UNASSIGNED_NODE.slice(0));
                        // Fill out the tree
                        var firstByteNode = this.decodeTables[0];
                        for(var i = 0x81; i <= 0xFE; i++){
                            var secondByteNode = this.decodeTables[NODE_START - firstByteNode[i]];
                            for(var j = 0x30; j <= 0x39; j++){
                                if (secondByteNode[j] === UNASSIGNED) secondByteNode[j] = NODE_START - commonThirdByteNodeIdx;
                                else if (secondByteNode[j] > NODE_START) throw new Error("gb18030 decode tables conflict at byte 2");
                                var thirdByteNode = this.decodeTables[NODE_START - secondByteNode[j]];
                                for(var k = 0x81; k <= 0xFE; k++){
                                    if (thirdByteNode[k] === UNASSIGNED) thirdByteNode[k] = NODE_START - commonFourthByteNodeIdx;
                                    else if (thirdByteNode[k] === NODE_START - commonFourthByteNodeIdx) continue;
                                    else if (thirdByteNode[k] > NODE_START) throw new Error("gb18030 decode tables conflict at byte 3");
                                    var fourthByteNode = this.decodeTables[NODE_START - thirdByteNode[k]];
                                    for(var l = 0x30; l <= 0x39; l++)if (fourthByteNode[l] === UNASSIGNED) fourthByteNode[l] = GB18030_CODE;
                                }
                            }
                        }
                    }
                    this.defaultCharUnicode = iconv.defaultCharUnicode;
                    // Encode tables: Unicode -> DBCS.
                    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
                    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
                    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
                    //         == UNASSIGNED -> no conversion found. Output a default char.
                    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
                    this.encodeTable = [];
                    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
                    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
                    // means end of sequence (needed when one sequence is a strict subsequence of another).
                    // Objects are kept separately from encodeTable to increase performance.
                    this.encodeTableSeq = [];
                    // Some chars can be decoded, but need not be encoded.
                    var skipEncodeChars = {};
                    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
                        var val = codecOptions.encodeSkipVals[i];
                        if (typeof val === "number") skipEncodeChars[val] = true;
                        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
                    }
                    // Use decode trie to recursively fill out encode tables.
                    this._fillEncodeTable(0, 0, skipEncodeChars);
                    // Add more encoding pairs when needed.
                    if (codecOptions.encodeAdd) {
                        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
                    }
                    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
                    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]["?"];
                    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
                }
                DBCSCodec.prototype.encoder = DBCSEncoder;
                DBCSCodec.prototype.decoder = DBCSDecoder;
                // Decoder helpers
                DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
                    var bytes = [];
                    for(; addr > 0; addr >>>= 8)bytes.push(addr & 0xFF);
                    if (bytes.length == 0) bytes.push(0);
                    var node = this.decodeTables[0];
                    for(var i = bytes.length - 1; i > 0; i--){
                        var val = node[bytes[i]];
                        if (val == UNASSIGNED) {
                            node[bytes[i]] = NODE_START - this.decodeTables.length;
                            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
                        } else if (val <= NODE_START) node = this.decodeTables[NODE_START - val];
                        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
                    }
                    return node;
                };
                DBCSCodec.prototype._addDecodeChunk = function(chunk) {
                    // First element of chunk is the hex mbcs code where we start.
                    var curAddr = parseInt(chunk[0], 16);
                    // Choose the decoding node where we'll write our chars.
                    var writeTable = this._getDecodeTrieNode(curAddr);
                    curAddr = curAddr & 0xFF;
                    // Write all other elements of the chunk to the table.
                    for(var k = 1; k < chunk.length; k++){
                        var part = chunk[k];
                        if (typeof part === "string") for(var l = 0; l < part.length;){
                            var code = part.charCodeAt(l++);
                            if (0xD800 <= code && code < 0xDC00) {
                                var codeTrail = part.charCodeAt(l++);
                                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
                            } else if (0x0FF0 < code && code <= 0x0FFF) {
                                var len = 0xFFF - code + 2;
                                var seq = [];
                                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
                                writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                                this.decodeTableSeq.push(seq);
                            } else writeTable[curAddr++] = code; // Basic char
                        }
                        else if (typeof part === "number") {
                            var charCode = writeTable[curAddr - 1] + 1;
                            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
                        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
                    }
                    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
                };
                // Encoder helpers
                DBCSCodec.prototype._getEncodeBucket = function(uCode) {
                    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
                    if (this.encodeTable[high] === undefined) this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
                    return this.encodeTable[high];
                };
                DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
                    var bucket = this._getEncodeBucket(uCode);
                    var low = uCode & 0xFF;
                    if (bucket[low] <= SEQ_START) this.encodeTableSeq[SEQ_START - bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
                    else if (bucket[low] == UNASSIGNED) bucket[low] = dbcsCode;
                };
                DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
                    // Get the root of character tree according to first character of the sequence.
                    var uCode = seq[0];
                    var bucket = this._getEncodeBucket(uCode);
                    var low = uCode & 0xFF;
                    var node;
                    if (bucket[low] <= SEQ_START) // There's already a sequence with  - use it.
                    node = this.encodeTableSeq[SEQ_START - bucket[low]];
                    else {
                        // There was no sequence object - allocate a new one.
                        node = {};
                        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
                        bucket[low] = SEQ_START - this.encodeTableSeq.length;
                        this.encodeTableSeq.push(node);
                    }
                    // Traverse the character tree, allocating new nodes as needed.
                    for(var j = 1; j < seq.length - 1; j++){
                        var oldVal = node[uCode];
                        if (typeof oldVal === "object") node = oldVal;
                        else {
                            node = node[uCode] = {};
                            if (oldVal !== undefined) node[DEF_CHAR] = oldVal;
                        }
                    }
                    // Set the leaf to given dbcsCode.
                    uCode = seq[seq.length - 1];
                    node[uCode] = dbcsCode;
                };
                DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
                    var node = this.decodeTables[nodeIdx];
                    var hasValues = false;
                    var subNodeEmpty = {};
                    for(var i = 0; i < 0x100; i++){
                        var uCode = node[i];
                        var mbCode = prefix + i;
                        if (skipEncodeChars[mbCode]) continue;
                        if (uCode >= 0) {
                            this._setEncodeChar(uCode, mbCode);
                            hasValues = true;
                        } else if (uCode <= NODE_START) {
                            var subNodeIdx = NODE_START - uCode;
                            if (!subNodeEmpty[subNodeIdx]) {
                                var newPrefix = mbCode << 8 >>> 0; // NOTE: '>>> 0' keeps 32-bit num positive.
                                if (this._fillEncodeTable(subNodeIdx, newPrefix, skipEncodeChars)) hasValues = true;
                                else subNodeEmpty[subNodeIdx] = true;
                            }
                        } else if (uCode <= SEQ_START) {
                            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
                            hasValues = true;
                        }
                    }
                    return hasValues;
                };
                // == Encoder ==================================================================
                function DBCSEncoder(options, codec) {
                    // Encoder state
                    this.leadSurrogate = -1;
                    this.seqObj = undefined;
                    // Static data
                    this.encodeTable = codec.encodeTable;
                    this.encodeTableSeq = codec.encodeTableSeq;
                    this.defaultCharSingleByte = codec.defCharSB;
                    this.gb18030 = codec.gb18030;
                }
                DBCSEncoder.prototype.write = function(str) {
                    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
                    while(true){
                        // 0. Get next character.
                        if (nextChar === -1) {
                            if (i == str.length) break;
                            var uCode = str.charCodeAt(i++);
                        } else {
                            var uCode = nextChar;
                            nextChar = -1;
                        }
                        // 1. Handle surrogates.
                        if (0xD800 <= uCode && uCode < 0xE000) {
                            if (uCode < 0xDC00) {
                                if (leadSurrogate === -1) {
                                    leadSurrogate = uCode;
                                    continue;
                                } else {
                                    leadSurrogate = uCode;
                                    // Double lead surrogate found.
                                    uCode = UNASSIGNED;
                                }
                            } else if (leadSurrogate !== -1) {
                                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                                leadSurrogate = -1;
                            } else // Incomplete surrogate pair - only trail surrogate found.
                            uCode = UNASSIGNED;
                        } else if (leadSurrogate !== -1) {
                            // Incomplete surrogate pair - only lead surrogate found.
                            nextChar = uCode;
                            uCode = UNASSIGNED; // Write an error, then current char.
                            leadSurrogate = -1;
                        }
                        // 2. Convert uCode character.
                        var dbcsCode = UNASSIGNED;
                        if (seqObj !== undefined && uCode != UNASSIGNED) {
                            var resCode = seqObj[uCode];
                            if (typeof resCode === "object") {
                                seqObj = resCode;
                                continue;
                            } else if (typeof resCode == "number") dbcsCode = resCode;
                            else if (resCode == undefined) {
                                // Try default character for this sequence
                                resCode = seqObj[DEF_CHAR];
                                if (resCode !== undefined) {
                                    dbcsCode = resCode; // Found. Write it.
                                    nextChar = uCode; // Current character will be written too in the next iteration.
                                }
                            }
                            seqObj = undefined;
                        } else if (uCode >= 0) {
                            var subtable = this.encodeTable[uCode >> 8];
                            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
                            if (dbcsCode <= SEQ_START) {
                                seqObj = this.encodeTableSeq[SEQ_START - dbcsCode];
                                continue;
                            }
                            if (dbcsCode == UNASSIGNED && this.gb18030) {
                                // Use GB18030 algorithm to find character(s) to write.
                                var idx = findIdx(this.gb18030.uChars, uCode);
                                if (idx != -1) {
                                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                                    dbcsCode = dbcsCode % 12600;
                                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                                    dbcsCode = dbcsCode % 1260;
                                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                                    dbcsCode = dbcsCode % 10;
                                    newBuf[j++] = 0x30 + dbcsCode;
                                    continue;
                                }
                            }
                        }
                        // 3. Write dbcsCode character.
                        if (dbcsCode === UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
                        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
                        else if (dbcsCode < 0x10000) {
                            newBuf[j++] = dbcsCode >> 8; // high byte
                            newBuf[j++] = dbcsCode & 0xFF; // low byte
                        } else if (dbcsCode < 0x1000000) {
                            newBuf[j++] = dbcsCode >> 16;
                            newBuf[j++] = dbcsCode >> 8 & 0xFF;
                            newBuf[j++] = dbcsCode & 0xFF;
                        } else {
                            newBuf[j++] = dbcsCode >>> 24;
                            newBuf[j++] = dbcsCode >>> 16 & 0xFF;
                            newBuf[j++] = dbcsCode >>> 8 & 0xFF;
                            newBuf[j++] = dbcsCode & 0xFF;
                        }
                    }
                    this.seqObj = seqObj;
                    this.leadSurrogate = leadSurrogate;
                    return newBuf.slice(0, j);
                };
                DBCSEncoder.prototype.end = function() {
                    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
                    var newBuf = Buffer.alloc(10), j = 0;
                    if (this.seqObj) {
                        var dbcsCode = this.seqObj[DEF_CHAR];
                        if (dbcsCode !== undefined) {
                            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
                            else {
                                newBuf[j++] = dbcsCode >> 8; // high byte
                                newBuf[j++] = dbcsCode & 0xFF; // low byte
                            }
                        } else ;
                        this.seqObj = undefined;
                    }
                    if (this.leadSurrogate !== -1) {
                        // Incomplete surrogate pair - only lead surrogate found.
                        newBuf[j++] = this.defaultCharSingleByte;
                        this.leadSurrogate = -1;
                    }
                    return newBuf.slice(0, j);
                };
                // Export for testing
                DBCSEncoder.prototype.findIdx = findIdx;
                // == Decoder ==================================================================
                function DBCSDecoder(options, codec) {
                    // Decoder state
                    this.nodeIdx = 0;
                    this.prevBytes = [];
                    // Static data
                    this.decodeTables = codec.decodeTables;
                    this.decodeTableSeq = codec.decodeTableSeq;
                    this.defaultCharUnicode = codec.defaultCharUnicode;
                    this.gb18030 = codec.gb18030;
                }
                DBCSDecoder.prototype.write = function(buf) {
                    var newBuf = Buffer.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBytes = this.prevBytes, prevOffset = this.prevBytes.length, seqStart = -this.prevBytes.length, uCode;
                    for(var i = 0, j = 0; i < buf.length; i++){
                        var curByte = i >= 0 ? buf[i] : prevBytes[i + prevOffset];
                        // Lookup in current trie node.
                        var uCode = this.decodeTables[nodeIdx][curByte];
                        if (uCode >= 0) ;
                        else if (uCode === UNASSIGNED) {
                            // TODO: Callback with seq.
                            uCode = this.defaultCharUnicode.charCodeAt(0);
                            i = seqStart; // Skip one byte ('i' will be incremented by the for loop) and try to parse again.
                        } else if (uCode === GB18030_CODE) {
                            if (i >= 3) var ptr = (buf[i - 3] - 0x81) * 12600 + (buf[i - 2] - 0x30) * 1260 + (buf[i - 1] - 0x81) * 10 + (curByte - 0x30);
                            else var ptr = (prevBytes[i - 3 + prevOffset] - 0x81) * 12600 + ((i - 2 >= 0 ? buf[i - 2] : prevBytes[i - 2 + prevOffset]) - 0x30) * 1260 + ((i - 1 >= 0 ? buf[i - 1] : prevBytes[i - 1 + prevOffset]) - 0x81) * 10 + (curByte - 0x30);
                            var idx = findIdx(this.gb18030.gbChars, ptr);
                            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
                        } else if (uCode <= NODE_START) {
                            nodeIdx = NODE_START - uCode;
                            continue;
                        } else if (uCode <= SEQ_START) {
                            var seq = this.decodeTableSeq[SEQ_START - uCode];
                            for(var k = 0; k < seq.length - 1; k++){
                                uCode = seq[k];
                                newBuf[j++] = uCode & 0xFF;
                                newBuf[j++] = uCode >> 8;
                            }
                            uCode = seq[seq.length - 1];
                        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
                        // Write the character to buffer, handling higher planes using surrogate pair.
                        if (uCode >= 0x10000) {
                            uCode -= 0x10000;
                            var uCodeLead = 0xD800 | uCode >> 10;
                            newBuf[j++] = uCodeLead & 0xFF;
                            newBuf[j++] = uCodeLead >> 8;
                            uCode = 0xDC00 | uCode & 0x3FF;
                        }
                        newBuf[j++] = uCode & 0xFF;
                        newBuf[j++] = uCode >> 8;
                        // Reset trie node.
                        nodeIdx = 0;
                        seqStart = i + 1;
                    }
                    this.nodeIdx = nodeIdx;
                    this.prevBytes = seqStart >= 0 ? Array.prototype.slice.call(buf, seqStart) : prevBytes.slice(seqStart + prevOffset).concat(Array.prototype.slice.call(buf));
                    return newBuf.slice(0, j).toString("ucs2");
                };
                DBCSDecoder.prototype.end = function() {
                    var ret = "";
                    // Try to parse all remaining chars.
                    while(this.prevBytes.length > 0){
                        // Skip 1 character in the buffer.
                        ret += this.defaultCharUnicode;
                        var bytesArr = this.prevBytes.slice(1);
                        // Parse remaining as usual.
                        this.prevBytes = [];
                        this.nodeIdx = 0;
                        if (bytesArr.length > 0) ret += this.write(bytesArr);
                    }
                    this.prevBytes = [];
                    this.nodeIdx = 0;
                    return ret;
                };
                // Binary search for GB18030. Returns largest i such that table[i] <= val.
                function findIdx(table, val) {
                    if (table[0] > val) return -1;
                    var l = 0, r = table.length;
                    while(l < r - 1){
                        var mid = l + (r - l + 1 >> 1);
                        if (table[mid] <= val) l = mid;
                        else r = mid;
                    }
                    return l;
                }
            /***/ },
            /***/ 27479: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Description of supported double byte encodings and aliases.
                // Tables are not require()-d until they are needed to speed up library load.
                // require()-s are direct to support Browserify.
                module1.exports = {
                    // == Japanese/ShiftJIS ====================================================
                    // All japanese encodings are based on JIS X set of standards:
                    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
                    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
                    //              Has several variations in 1978, 1983, 1990 and 1997.
                    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
                    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
                    //              2 planes, first is superset of 0208, second - revised 0212.
                    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
                    // Byte encodings are:
                    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
                    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
                    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
                    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
                    //               0x00-0x7F       - lower part of 0201
                    //               0x8E, 0xA1-0xDF - upper part of 0201
                    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
                    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
                    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
                    //               Used as-is in ISO2022 family.
                    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
                    //                0201-1976 Roman, 0208-1978, 0208-1983.
                    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
                    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
                    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
                    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
                    //
                    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
                    //
                    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
                    "shiftjis": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(27014);
                        },
                        encodeAdd: {
                            "\xa5": 0x5C,
                            "\u203E": 0x7E
                        },
                        encodeSkipVals: [
                            {
                                from: 0xED40,
                                to: 0xF940
                            }
                        ]
                    },
                    "csshiftjis": "shiftjis",
                    "mskanji": "shiftjis",
                    "sjis": "shiftjis",
                    "windows31j": "shiftjis",
                    "ms31j": "shiftjis",
                    "xsjis": "shiftjis",
                    "windows932": "shiftjis",
                    "ms932": "shiftjis",
                    "932": "shiftjis",
                    "cp932": "shiftjis",
                    "eucjp": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(31532);
                        },
                        encodeAdd: {
                            "\xa5": 0x5C,
                            "\u203E": 0x7E
                        }
                    },
                    // TODO: KDDI extension to Shift_JIS
                    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
                    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
                    // == Chinese/GBK ==========================================================
                    // http://en.wikipedia.org/wiki/GBK
                    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
                    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
                    "gb2312": "cp936",
                    "gb231280": "cp936",
                    "gb23121980": "cp936",
                    "csgb2312": "cp936",
                    "csiso58gb231280": "cp936",
                    "euccn": "cp936",
                    // Microsoft's CP936 is a subset and approximation of GBK.
                    "windows936": "cp936",
                    "ms936": "cp936",
                    "936": "cp936",
                    "cp936": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(13336);
                        }
                    },
                    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
                    "gbk": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(13336).concat(__webpack_require__(44346));
                        }
                    },
                    "xgbk": "gbk",
                    "isoir58": "gbk",
                    // GB18030 is an algorithmic extension of GBK.
                    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
                    // http://icu-project.org/docs/papers/gb18030.html
                    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
                    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
                    "gb18030": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(13336).concat(__webpack_require__(44346));
                        },
                        gb18030: function() {
                            return __webpack_require__(36258);
                        },
                        encodeSkipVals: [
                            0x80
                        ],
                        encodeAdd: {
                            "\u20AC": 0xA2E3
                        }
                    },
                    "chinese": "gb18030",
                    // == Korean ===============================================================
                    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
                    "windows949": "cp949",
                    "ms949": "cp949",
                    "949": "cp949",
                    "cp949": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(77348);
                        }
                    },
                    "cseuckr": "cp949",
                    "csksc56011987": "cp949",
                    "euckr": "cp949",
                    "isoir149": "cp949",
                    "korean": "cp949",
                    "ksc56011987": "cp949",
                    "ksc56011989": "cp949",
                    "ksc5601": "cp949",
                    // == Big5/Taiwan/Hong Kong ================================================
                    // There are lots of tables for Big5 and cp950. Please see the following links for history:
                    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
                    // Variations, in roughly number of defined chars:
                    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
                    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
                    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
                    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
                    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
                    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
                    //    Plus, it has 4 combining sequences.
                    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
                    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
                    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
                    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
                    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
                    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
                    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
                    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
                    // 
                    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
                    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
                    "windows950": "cp950",
                    "ms950": "cp950",
                    "950": "cp950",
                    "cp950": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(74284);
                        }
                    },
                    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
                    "big5": "big5hkscs",
                    "big5hkscs": {
                        type: "_dbcs",
                        table: function() {
                            return __webpack_require__(74284).concat(__webpack_require__(63480));
                        },
                        encodeSkipVals: [
                            // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
                            // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
                            // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
                            0x8e69,
                            0x8e6f,
                            0x8e7e,
                            0x8eab,
                            0x8eb4,
                            0x8ecd,
                            0x8ed0,
                            0x8f57,
                            0x8f69,
                            0x8f6e,
                            0x8fcb,
                            0x8ffe,
                            0x906d,
                            0x907a,
                            0x90c4,
                            0x90dc,
                            0x90f1,
                            0x91bf,
                            0x92af,
                            0x92b0,
                            0x92b1,
                            0x92b2,
                            0x92d1,
                            0x9447,
                            0x94ca,
                            0x95d9,
                            0x96fc,
                            0x9975,
                            0x9b76,
                            0x9b78,
                            0x9b7b,
                            0x9bc6,
                            0x9bde,
                            0x9bec,
                            0x9bf6,
                            0x9c42,
                            0x9c53,
                            0x9c62,
                            0x9c68,
                            0x9c6b,
                            0x9c77,
                            0x9cbc,
                            0x9cbd,
                            0x9cd0,
                            0x9d57,
                            0x9d5a,
                            0x9dc4,
                            0x9def,
                            0x9dfb,
                            0x9ea9,
                            0x9eef,
                            0x9efd,
                            0x9f60,
                            0x9fcb,
                            0xa077,
                            0xa0dc,
                            0xa0df,
                            0x8fcc,
                            0x92c8,
                            0x9644,
                            0x96ed,
                            // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
                            0xa2a4,
                            0xa2a5,
                            0xa2a7,
                            0xa2a6,
                            0xa2cc,
                            0xa2ce
                        ]
                    },
                    "cnbig5": "big5hkscs",
                    "csbig5": "big5hkscs",
                    "xxbig5": "big5hkscs"
                };
            /***/ },
            /***/ 88069: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // Update this array if you add/rename/remove files in this directory.
                // We support Browserify by skipping automatic module discovery and requiring modules directly.
                var modules = [
                    __webpack_require__(95907),
                    __webpack_require__(89252),
                    __webpack_require__(1710),
                    __webpack_require__(92307),
                    __webpack_require__(72542),
                    __webpack_require__(26518),
                    __webpack_require__(34732),
                    __webpack_require__(72959),
                    __webpack_require__(27479)
                ];
                // Put all encoding/alias/codec definitions to single object and export it.
                for(var i = 0; i < modules.length; i++){
                    var module1 = modules[i];
                    for(var enc in module1)if (Object.prototype.hasOwnProperty.call(module1, enc)) exports[enc] = module1[enc];
                }
            /***/ },
            /***/ 95907: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // Export Node.js internal encodings.
                module1.exports = {
                    // Encodings
                    utf8: {
                        type: "_internal",
                        bomAware: true
                    },
                    cesu8: {
                        type: "_internal",
                        bomAware: true
                    },
                    unicode11utf8: "utf8",
                    ucs2: {
                        type: "_internal",
                        bomAware: true
                    },
                    utf16le: "ucs2",
                    binary: {
                        type: "_internal"
                    },
                    base64: {
                        type: "_internal"
                    },
                    hex: {
                        type: "_internal"
                    },
                    // Codec.
                    _internal: InternalCodec
                };
                //------------------------------------------------------------------------------
                function InternalCodec(codecOptions, iconv) {
                    this.enc = codecOptions.encodingName;
                    this.bomAware = codecOptions.bomAware;
                    if (this.enc === "base64") this.encoder = InternalEncoderBase64;
                    else if (this.enc === "cesu8") {
                        this.enc = "utf8"; // Use utf8 for decoding.
                        this.encoder = InternalEncoderCesu8;
                        // Add decoder for versions of Node not supporting CESU-8
                        if (Buffer.from("eda0bdedb2a9", "hex").toString() !== "\uD83D\uDCA9") {
                            this.decoder = InternalDecoderCesu8;
                            this.defaultCharUnicode = iconv.defaultCharUnicode;
                        }
                    }
                }
                InternalCodec.prototype.encoder = InternalEncoder;
                InternalCodec.prototype.decoder = InternalDecoder;
                //------------------------------------------------------------------------------
                // We use node.js internal decoder. Its signature is the same as ours.
                var StringDecoder = __webpack_require__(10301)/* .StringDecoder */ .s;
                if (!StringDecoder.prototype.end) StringDecoder.prototype.end = function() {};
                function InternalDecoder(options, codec) {
                    this.decoder = new StringDecoder(codec.enc);
                }
                InternalDecoder.prototype.write = function(buf) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    return this.decoder.write(buf);
                };
                InternalDecoder.prototype.end = function() {
                    return this.decoder.end();
                };
                //------------------------------------------------------------------------------
                // Encoder is mostly trivial
                function InternalEncoder(options, codec) {
                    this.enc = codec.enc;
                }
                InternalEncoder.prototype.write = function(str) {
                    return Buffer.from(str, this.enc);
                };
                InternalEncoder.prototype.end = function() {};
                //------------------------------------------------------------------------------
                // Except base64 encoder, which must keep its state.
                function InternalEncoderBase64(options, codec) {
                    this.prevStr = "";
                }
                InternalEncoderBase64.prototype.write = function(str) {
                    str = this.prevStr + str;
                    var completeQuads = str.length - str.length % 4;
                    this.prevStr = str.slice(completeQuads);
                    str = str.slice(0, completeQuads);
                    return Buffer.from(str, "base64");
                };
                InternalEncoderBase64.prototype.end = function() {
                    return Buffer.from(this.prevStr, "base64");
                };
                //------------------------------------------------------------------------------
                // CESU-8 encoder is also special.
                function InternalEncoderCesu8(options, codec) {}
                InternalEncoderCesu8.prototype.write = function(str) {
                    var buf = Buffer.alloc(str.length * 3), bufIdx = 0;
                    for(var i = 0; i < str.length; i++){
                        var charCode = str.charCodeAt(i);
                        // Naive implementation, but it works because CESU-8 is especially easy
                        // to convert from UTF-16 (which all JS strings are encoded in).
                        if (charCode < 0x80) buf[bufIdx++] = charCode;
                        else if (charCode < 0x800) {
                            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
                            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
                        } else {
                            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
                            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
                            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
                        }
                    }
                    return buf.slice(0, bufIdx);
                };
                InternalEncoderCesu8.prototype.end = function() {};
                //------------------------------------------------------------------------------
                // CESU-8 decoder is not implemented in Node v4.0+
                function InternalDecoderCesu8(options, codec) {
                    this.acc = 0;
                    this.contBytes = 0;
                    this.accBytes = 0;
                    this.defaultCharUnicode = codec.defaultCharUnicode;
                }
                InternalDecoderCesu8.prototype.write = function(buf) {
                    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = "";
                    for(var i = 0; i < buf.length; i++){
                        var curByte = buf[i];
                        if ((curByte & 0xC0) !== 0x80) {
                            if (contBytes > 0) {
                                res += this.defaultCharUnicode;
                                contBytes = 0;
                            }
                            if (curByte < 0x80) res += String.fromCharCode(curByte);
                            else if (curByte < 0xE0) {
                                acc = curByte & 0x1F;
                                contBytes = 1;
                                accBytes = 1;
                            } else if (curByte < 0xF0) {
                                acc = curByte & 0x0F;
                                contBytes = 2;
                                accBytes = 1;
                            } else res += this.defaultCharUnicode;
                        } else if (contBytes > 0) {
                            acc = acc << 6 | curByte & 0x3f;
                            contBytes--;
                            accBytes++;
                            if (contBytes === 0) {
                                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                                else // Actually add character.
                                res += String.fromCharCode(acc);
                            }
                        } else res += this.defaultCharUnicode;
                    }
                    this.acc = acc;
                    this.contBytes = contBytes;
                    this.accBytes = accBytes;
                    return res;
                };
                InternalDecoderCesu8.prototype.end = function() {
                    var res = 0;
                    if (this.contBytes > 0) res += this.defaultCharUnicode;
                    return res;
                };
            /***/ },
            /***/ 72542: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
                // correspond to encoded bytes (if 128 - then lower half is ASCII). 
                exports._sbcs = SBCSCodec;
                function SBCSCodec(codecOptions, iconv) {
                    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
                    // Prepare char buffer for decoding.
                    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
                    if (codecOptions.chars.length === 128) {
                        var asciiString = "";
                        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
                        codecOptions.chars = asciiString + codecOptions.chars;
                    }
                    this.decodeBuf = Buffer.from(codecOptions.chars, "ucs2");
                    // Encoding buffer.
                    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
                    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
                    this.encodeBuf = encodeBuf;
                }
                SBCSCodec.prototype.encoder = SBCSEncoder;
                SBCSCodec.prototype.decoder = SBCSDecoder;
                function SBCSEncoder(options, codec) {
                    this.encodeBuf = codec.encodeBuf;
                }
                SBCSEncoder.prototype.write = function(str) {
                    var buf = Buffer.alloc(str.length);
                    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
                    return buf;
                };
                SBCSEncoder.prototype.end = function() {};
                function SBCSDecoder(options, codec) {
                    this.decodeBuf = codec.decodeBuf;
                }
                SBCSDecoder.prototype.write = function(buf) {
                    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
                    var decodeBuf = this.decodeBuf;
                    var newBuf = Buffer.alloc(buf.length * 2);
                    var idx1 = 0, idx2 = 0;
                    for(var i = 0; i < buf.length; i++){
                        idx1 = buf[i] * 2;
                        idx2 = i * 2;
                        newBuf[idx2] = decodeBuf[idx1];
                        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
                    }
                    return newBuf.toString("ucs2");
                };
                SBCSDecoder.prototype.end = function() {};
            /***/ },
            /***/ 34732: /***/ function(module1) {
                "use strict";
                // Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
                module1.exports = {
                    "437": "cp437",
                    "737": "cp737",
                    "775": "cp775",
                    "850": "cp850",
                    "852": "cp852",
                    "855": "cp855",
                    "856": "cp856",
                    "857": "cp857",
                    "858": "cp858",
                    "860": "cp860",
                    "861": "cp861",
                    "862": "cp862",
                    "863": "cp863",
                    "864": "cp864",
                    "865": "cp865",
                    "866": "cp866",
                    "869": "cp869",
                    "874": "windows874",
                    "922": "cp922",
                    "1046": "cp1046",
                    "1124": "cp1124",
                    "1125": "cp1125",
                    "1129": "cp1129",
                    "1133": "cp1133",
                    "1161": "cp1161",
                    "1162": "cp1162",
                    "1163": "cp1163",
                    "1250": "windows1250",
                    "1251": "windows1251",
                    "1252": "windows1252",
                    "1253": "windows1253",
                    "1254": "windows1254",
                    "1255": "windows1255",
                    "1256": "windows1256",
                    "1257": "windows1257",
                    "1258": "windows1258",
                    "28591": "iso88591",
                    "28592": "iso88592",
                    "28593": "iso88593",
                    "28594": "iso88594",
                    "28595": "iso88595",
                    "28596": "iso88596",
                    "28597": "iso88597",
                    "28598": "iso88598",
                    "28599": "iso88599",
                    "28600": "iso885910",
                    "28601": "iso885911",
                    "28603": "iso885913",
                    "28604": "iso885914",
                    "28605": "iso885915",
                    "28606": "iso885916",
                    "windows874": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "win874": "windows874",
                    "cp874": "windows874",
                    "windows1250": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
                    },
                    "win1250": "windows1250",
                    "cp1250": "windows1250",
                    "windows1251": {
                        "type": "_sbcs",
                        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
                    },
                    "win1251": "windows1251",
                    "cp1251": "windows1251",
                    "windows1252": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "win1252": "windows1252",
                    "cp1252": "windows1252",
                    "windows1253": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
                    },
                    "win1253": "windows1253",
                    "cp1253": "windows1253",
                    "windows1254": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
                    },
                    "win1254": "windows1254",
                    "cp1254": "windows1254",
                    "windows1255": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
                    },
                    "win1255": "windows1255",
                    "cp1255": "windows1255",
                    "windows1256": {
                        "type": "_sbcs",
                        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
                    },
                    "win1256": "windows1256",
                    "cp1256": "windows1256",
                    "windows1257": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
                    },
                    "win1257": "windows1257",
                    "cp1257": "windows1257",
                    "windows1258": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
                    },
                    "win1258": "windows1258",
                    "cp1258": "windows1258",
                    "iso88591": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "cp28591": "iso88591",
                    "iso88592": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
                    },
                    "cp28592": "iso88592",
                    "iso88593": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
                    },
                    "cp28593": "iso88593",
                    "iso88594": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
                    },
                    "cp28594": "iso88594",
                    "iso88595": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
                    },
                    "cp28595": "iso88595",
                    "iso88596": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "cp28596": "iso88596",
                    "iso88597": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
                    },
                    "cp28597": "iso88597",
                    "iso88598": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
                    },
                    "cp28598": "iso88598",
                    "iso88599": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
                    },
                    "cp28599": "iso88599",
                    "iso885910": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
                    },
                    "cp28600": "iso885910",
                    "iso885911": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "cp28601": "iso885911",
                    "iso885913": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
                    },
                    "cp28603": "iso885913",
                    "iso885914": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
                    },
                    "cp28604": "iso885914",
                    "iso885915": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "cp28605": "iso885915",
                    "iso885916": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
                    },
                    "cp28606": "iso885916",
                    "cp437": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm437": "cp437",
                    "csibm437": "cp437",
                    "cp737": {
                        "type": "_sbcs",
                        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm737": "cp737",
                    "csibm737": "cp737",
                    "cp775": {
                        "type": "_sbcs",
                        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm775": "cp775",
                    "csibm775": "cp775",
                    "cp850": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm850": "cp850",
                    "csibm850": "cp850",
                    "cp852": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
                    },
                    "ibm852": "cp852",
                    "csibm852": "cp852",
                    "cp855": {
                        "type": "_sbcs",
                        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
                    },
                    "ibm855": "cp855",
                    "csibm855": "cp855",
                    "cp856": {
                        "type": "_sbcs",
                        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm856": "cp856",
                    "csibm856": "cp856",
                    "cp857": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm857": "cp857",
                    "csibm857": "cp857",
                    "cp858": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm858": "cp858",
                    "csibm858": "cp858",
                    "cp860": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm860": "cp860",
                    "csibm860": "cp860",
                    "cp861": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm861": "cp861",
                    "csibm861": "cp861",
                    "cp862": {
                        "type": "_sbcs",
                        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm862": "cp862",
                    "csibm862": "cp862",
                    "cp863": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm863": "cp863",
                    "csibm863": "cp863",
                    "cp864": {
                        "type": "_sbcs",
                        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xb1\xbd\xbc\u2248\xab\xbb\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xa0\xad\uFE82\xa3\xa4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xa2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xa6\xac\xf7\xd7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
                    },
                    "ibm864": "cp864",
                    "csibm864": "cp864",
                    "cp865": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm865": "cp865",
                    "csibm865": "cp865",
                    "cp866": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
                    },
                    "ibm866": "cp866",
                    "csibm866": "cp866",
                    "cp869": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
                    },
                    "ibm869": "cp869",
                    "csibm869": "cp869",
                    "cp922": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
                    },
                    "ibm922": "cp922",
                    "csibm922": "cp922",
                    "cp1046": {
                        "type": "_sbcs",
                        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
                    },
                    "ibm1046": "cp1046",
                    "csibm1046": "cp1046",
                    "cp1124": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
                    },
                    "ibm1124": "cp1124",
                    "csibm1124": "cp1124",
                    "cp1125": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
                    },
                    "ibm1125": "cp1125",
                    "csibm1125": "cp1125",
                    "cp1129": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
                    },
                    "ibm1129": "cp1129",
                    "csibm1129": "cp1129",
                    "cp1133": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
                    },
                    "ibm1133": "cp1133",
                    "csibm1133": "cp1133",
                    "cp1161": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
                    },
                    "ibm1161": "cp1161",
                    "csibm1161": "cp1161",
                    "cp1162": {
                        "type": "_sbcs",
                        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "ibm1162": "cp1162",
                    "csibm1162": "cp1162",
                    "cp1163": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
                    },
                    "ibm1163": "cp1163",
                    "csibm1163": "cp1163",
                    "maccroatian": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
                    },
                    "maccyrillic": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
                    },
                    "macgreek": {
                        "type": "_sbcs",
                        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
                    },
                    "maciceland": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macroman": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macromania": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macthai": {
                        "type": "_sbcs",
                        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "macturkish": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macukraine": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
                    },
                    "koi8r": {
                        "type": "_sbcs",
                        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "koi8u": {
                        "type": "_sbcs",
                        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "koi8ru": {
                        "type": "_sbcs",
                        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "koi8t": {
                        "type": "_sbcs",
                        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "armscii8": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
                    },
                    "rk1048": {
                        "type": "_sbcs",
                        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
                    },
                    "tcvn": {
                        "type": "_sbcs",
                        "chars": "\0\xda\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b	\n\v\f\r\x0e\x0f\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xdd\u1EF4\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0\u1EA2\xc3\xc1\u1EA0\u1EB6\u1EAC\xc8\u1EBA\u1EBC\xc9\u1EB8\u1EC6\xcc\u1EC8\u0128\xcd\u1ECA\xd2\u1ECE\xd5\xd3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xd9\u1EE6\u0168\xa0\u0102\xc2\xca\xd4\u01A0\u01AF\u0110\u0103\xe2\xea\xf4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xe0\u1EA3\xe3\xe1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xe8\u1EC2\u1EBB\u1EBD\xe9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xec\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xed\u1ECB\xf2\u1ED4\u1ECF\xf5\xf3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xf9\u1ED6\u1EE7\u0169\xfa\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xfd\u1EF5\u1ED0"
                    },
                    "georgianacademy": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "georgianps": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "pt154": {
                        "type": "_sbcs",
                        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
                    },
                    "viscii": {
                        "type": "_sbcs",
                        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1a\x1b\x1c\x1d\u1EF4\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xd5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xc0\xc1\xc2\xc3\u1EA2\u0102\u1EB3\u1EB5\xc8\xc9\xca\u1EBA\xcc\xcd\u0128\u1EF3\u0110\u1EE9\xd2\xd3\xd4\u1EA1\u1EF7\u1EEB\u1EED\xd9\xda\u1EF9\u1EF5\xdd\u1EE1\u01B0\xe0\xe1\xe2\xe3\u1EA3\u0103\u1EEF\u1EAB\xe8\xe9\xea\u1EBB\xec\xed\u0129\u1EC9\u0111\u1EF1\xf2\xf3\xf4\xf5\u1ECF\u1ECD\u1EE5\xf9\xfa\u0169\u1EE7\xfd\u1EE3\u1EEE"
                    },
                    "iso646cn": {
                        "type": "_sbcs",
                        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "iso646jp": {
                        "type": "_sbcs",
                        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "hproman8": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
                    },
                    "macintosh": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "ascii": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "tis620": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    }
                };
            /***/ },
            /***/ 26518: /***/ function(module1) {
                "use strict";
                // Manually added data to be used by sbcs codec in addition to generated one.
                module1.exports = {
                    // Not supported by iconv, not sure why.
                    "10029": "maccenteuro",
                    "maccenteuro": {
                        "type": "_sbcs",
                        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
                    },
                    "808": "cp808",
                    "ibm808": "cp808",
                    "cp808": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
                    },
                    "mik": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "cp720": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\xe9\xe2\x84\xe0\x86\xe7\xea\xeb\xe8\xef\xee\x8d\x8e\x8f\x90\u0651\u0652\xf4\xa4\u0640\xfb\xf9\u0621\u0622\u0623\u0624\xa3\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0636\u0637\u0638\u0639\u063A\u0641\xb5\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u2261\u064B\u064C\u064D\u064E\u064F\u0650\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    // Aliases of generated encodings.
                    "ascii8bit": "ascii",
                    "usascii": "ascii",
                    "ansix34": "ascii",
                    "ansix341968": "ascii",
                    "ansix341986": "ascii",
                    "csascii": "ascii",
                    "cp367": "ascii",
                    "ibm367": "ascii",
                    "isoir6": "ascii",
                    "iso646us": "ascii",
                    "iso646irv": "ascii",
                    "us": "ascii",
                    "latin1": "iso88591",
                    "latin2": "iso88592",
                    "latin3": "iso88593",
                    "latin4": "iso88594",
                    "latin5": "iso88599",
                    "latin6": "iso885910",
                    "latin7": "iso885913",
                    "latin8": "iso885914",
                    "latin9": "iso885915",
                    "latin10": "iso885916",
                    "csisolatin1": "iso88591",
                    "csisolatin2": "iso88592",
                    "csisolatin3": "iso88593",
                    "csisolatin4": "iso88594",
                    "csisolatincyrillic": "iso88595",
                    "csisolatinarabic": "iso88596",
                    "csisolatingreek": "iso88597",
                    "csisolatinhebrew": "iso88598",
                    "csisolatin5": "iso88599",
                    "csisolatin6": "iso885910",
                    "l1": "iso88591",
                    "l2": "iso88592",
                    "l3": "iso88593",
                    "l4": "iso88594",
                    "l5": "iso88599",
                    "l6": "iso885910",
                    "l7": "iso885913",
                    "l8": "iso885914",
                    "l9": "iso885915",
                    "l10": "iso885916",
                    "isoir14": "iso646jp",
                    "isoir57": "iso646cn",
                    "isoir100": "iso88591",
                    "isoir101": "iso88592",
                    "isoir109": "iso88593",
                    "isoir110": "iso88594",
                    "isoir144": "iso88595",
                    "isoir127": "iso88596",
                    "isoir126": "iso88597",
                    "isoir138": "iso88598",
                    "isoir148": "iso88599",
                    "isoir157": "iso885910",
                    "isoir166": "tis620",
                    "isoir179": "iso885913",
                    "isoir199": "iso885914",
                    "isoir203": "iso885915",
                    "isoir226": "iso885916",
                    "cp819": "iso88591",
                    "ibm819": "iso88591",
                    "cyrillic": "iso88595",
                    "arabic": "iso88596",
                    "arabic8": "iso88596",
                    "ecma114": "iso88596",
                    "asmo708": "iso88596",
                    "greek": "iso88597",
                    "greek8": "iso88597",
                    "ecma118": "iso88597",
                    "elot928": "iso88597",
                    "hebrew": "iso88598",
                    "hebrew8": "iso88598",
                    "turkish": "iso88599",
                    "turkish8": "iso88599",
                    "thai": "iso885911",
                    "thai8": "iso885911",
                    "celtic": "iso885914",
                    "celtic8": "iso885914",
                    "isoceltic": "iso885914",
                    "tis6200": "tis620",
                    "tis62025291": "tis620",
                    "tis62025330": "tis620",
                    "10000": "macroman",
                    "10006": "macgreek",
                    "10007": "maccyrillic",
                    "10079": "maciceland",
                    "10081": "macturkish",
                    "cspc8codepage437": "cp437",
                    "cspc775baltic": "cp775",
                    "cspc850multilingual": "cp850",
                    "cspcp852": "cp852",
                    "cspc862latinhebrew": "cp862",
                    "cpgr": "cp869",
                    "msee": "cp1250",
                    "mscyrl": "cp1251",
                    "msansi": "cp1252",
                    "msgreek": "cp1253",
                    "msturk": "cp1254",
                    "mshebr": "cp1255",
                    "msarab": "cp1256",
                    "winbaltrim": "cp1257",
                    "cp20866": "koi8r",
                    "20866": "koi8r",
                    "ibm878": "koi8r",
                    "cskoi8r": "koi8r",
                    "cp21866": "koi8u",
                    "21866": "koi8u",
                    "ibm1168": "koi8u",
                    "strk10482002": "rk1048",
                    "tcvn5712": "tcvn",
                    "tcvn57121": "tcvn",
                    "gb198880": "iso646cn",
                    "cn": "iso646cn",
                    "csiso14jisc6220ro": "iso646jp",
                    "jisc62201969ro": "iso646jp",
                    "jp": "iso646jp",
                    "cshproman8": "hproman8",
                    "r8": "hproman8",
                    "roman8": "hproman8",
                    "xroman8": "hproman8",
                    "ibm1051": "hproman8",
                    "mac": "macintosh",
                    "csmacintosh": "macintosh"
                };
            /***/ },
            /***/ 1710: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
                // == UTF16-BE codec. ==========================================================
                exports.utf16be = Utf16BECodec;
                function Utf16BECodec() {}
                Utf16BECodec.prototype.encoder = Utf16BEEncoder;
                Utf16BECodec.prototype.decoder = Utf16BEDecoder;
                Utf16BECodec.prototype.bomAware = true;
                // -- Encoding
                function Utf16BEEncoder() {}
                Utf16BEEncoder.prototype.write = function(str) {
                    var buf = Buffer.from(str, "ucs2");
                    for(var i = 0; i < buf.length; i += 2){
                        var tmp = buf[i];
                        buf[i] = buf[i + 1];
                        buf[i + 1] = tmp;
                    }
                    return buf;
                };
                Utf16BEEncoder.prototype.end = function() {};
                // -- Decoding
                function Utf16BEDecoder() {
                    this.overflowByte = -1;
                }
                Utf16BEDecoder.prototype.write = function(buf) {
                    if (buf.length == 0) return "";
                    var buf2 = Buffer.alloc(buf.length + 1), i = 0, j = 0;
                    if (this.overflowByte !== -1) {
                        buf2[0] = buf[0];
                        buf2[1] = this.overflowByte;
                        i = 1;
                        j = 2;
                    }
                    for(; i < buf.length - 1; i += 2, j += 2){
                        buf2[j] = buf[i + 1];
                        buf2[j + 1] = buf[i];
                    }
                    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
                    return buf2.slice(0, j).toString("ucs2");
                };
                Utf16BEDecoder.prototype.end = function() {
                    this.overflowByte = -1;
                };
                // == UTF-16 codec =============================================================
                // Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
                // Defaults to UTF-16LE, as it's prevalent and default in Node.
                // http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
                // Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
                // Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
                exports.utf16 = Utf16Codec;
                function Utf16Codec(codecOptions, iconv) {
                    this.iconv = iconv;
                }
                Utf16Codec.prototype.encoder = Utf16Encoder;
                Utf16Codec.prototype.decoder = Utf16Decoder;
                // -- Encoding (pass-through)
                function Utf16Encoder(options, codec) {
                    options = options || {};
                    if (options.addBOM === undefined) options.addBOM = true;
                    this.encoder = codec.iconv.getEncoder("utf-16le", options);
                }
                Utf16Encoder.prototype.write = function(str) {
                    return this.encoder.write(str);
                };
                Utf16Encoder.prototype.end = function() {
                    return this.encoder.end();
                };
                // -- Decoding
                function Utf16Decoder(options, codec) {
                    this.decoder = null;
                    this.initialBufs = [];
                    this.initialBufsLen = 0;
                    this.options = options || {};
                    this.iconv = codec.iconv;
                }
                Utf16Decoder.prototype.write = function(buf) {
                    if (!this.decoder) {
                        // Codec is not chosen yet. Accumulate initial bytes.
                        this.initialBufs.push(buf);
                        this.initialBufsLen += buf.length;
                        if (this.initialBufsLen < 16) return "";
                        // We have enough bytes -> detect endianness.
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = "";
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.write(buf);
                };
                Utf16Decoder.prototype.end = function() {
                    if (!this.decoder) {
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = "";
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        var trail = this.decoder.end();
                        if (trail) resStr += trail;
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.end();
                };
                function detectEncoding(bufs, defaultEncoding) {
                    var b = [];
                    var charsProcessed = 0;
                    var asciiCharsLE = 0, asciiCharsBE = 0; // Number of ASCII chars when decoded as LE or BE.
                    outer_loop: for(var i = 0; i < bufs.length; i++){
                        var buf = bufs[i];
                        for(var j = 0; j < buf.length; j++){
                            b.push(buf[j]);
                            if (b.length === 2) {
                                if (charsProcessed === 0) {
                                    // Check BOM first.
                                    if (b[0] === 0xFF && b[1] === 0xFE) return "utf-16le";
                                    if (b[0] === 0xFE && b[1] === 0xFF) return "utf-16be";
                                }
                                if (b[0] === 0 && b[1] !== 0) asciiCharsBE++;
                                if (b[0] !== 0 && b[1] === 0) asciiCharsLE++;
                                b.length = 0;
                                charsProcessed++;
                                if (charsProcessed >= 100) break outer_loop;
                            }
                        }
                    }
                    // Make decisions.
                    // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
                    // So, we count ASCII as if it was LE or BE, and decide from that.
                    if (asciiCharsBE > asciiCharsLE) return "utf-16be";
                    if (asciiCharsBE < asciiCharsLE) return "utf-16le";
                    // Couldn't decide (likely all zeros or not enough data).
                    return defaultEncoding || "utf-16le";
                }
            /***/ },
            /***/ 89252: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // == UTF32-LE/BE codec. ==========================================================
                exports._utf32 = Utf32Codec;
                function Utf32Codec(codecOptions, iconv) {
                    this.iconv = iconv;
                    this.bomAware = true;
                    this.isLE = codecOptions.isLE;
                }
                exports.utf32le = {
                    type: "_utf32",
                    isLE: true
                };
                exports.utf32be = {
                    type: "_utf32",
                    isLE: false
                };
                // Aliases
                exports.ucs4le = "utf32le";
                exports.ucs4be = "utf32be";
                Utf32Codec.prototype.encoder = Utf32Encoder;
                Utf32Codec.prototype.decoder = Utf32Decoder;
                // -- Encoding
                function Utf32Encoder(options, codec) {
                    this.isLE = codec.isLE;
                    this.highSurrogate = 0;
                }
                Utf32Encoder.prototype.write = function(str) {
                    var src = Buffer.from(str, "ucs2");
                    var dst = Buffer.alloc(src.length * 2);
                    var write32 = this.isLE ? dst.writeUInt32LE : dst.writeUInt32BE;
                    var offset = 0;
                    for(var i = 0; i < src.length; i += 2){
                        var code = src.readUInt16LE(i);
                        var isHighSurrogate = 0xD800 <= code && code < 0xDC00;
                        var isLowSurrogate = 0xDC00 <= code && code < 0xE000;
                        if (this.highSurrogate) {
                            if (isHighSurrogate || !isLowSurrogate) {
                                // There shouldn't be two high surrogates in a row, nor a high surrogate which isn't followed by a low
                                // surrogate. If this happens, keep the pending high surrogate as a stand-alone semi-invalid character
                                // (technically wrong, but expected by some applications, like Windows file names).
                                write32.call(dst, this.highSurrogate, offset);
                                offset += 4;
                            } else {
                                // Create 32-bit value from high and low surrogates;
                                var codepoint = (this.highSurrogate - 0xD800 << 10 | code - 0xDC00) + 0x10000;
                                write32.call(dst, codepoint, offset);
                                offset += 4;
                                this.highSurrogate = 0;
                                continue;
                            }
                        }
                        if (isHighSurrogate) this.highSurrogate = code;
                        else {
                            // Even if the current character is a low surrogate, with no previous high surrogate, we'll
                            // encode it as a semi-invalid stand-alone character for the same reasons expressed above for
                            // unpaired high surrogates.
                            write32.call(dst, code, offset);
                            offset += 4;
                            this.highSurrogate = 0;
                        }
                    }
                    if (offset < dst.length) dst = dst.slice(0, offset);
                    return dst;
                };
                Utf32Encoder.prototype.end = function() {
                    // Treat any leftover high surrogate as a semi-valid independent character.
                    if (!this.highSurrogate) return;
                    var buf = Buffer.alloc(4);
                    if (this.isLE) buf.writeUInt32LE(this.highSurrogate, 0);
                    else buf.writeUInt32BE(this.highSurrogate, 0);
                    this.highSurrogate = 0;
                    return buf;
                };
                // -- Decoding
                function Utf32Decoder(options, codec) {
                    this.isLE = codec.isLE;
                    this.badChar = codec.iconv.defaultCharUnicode.charCodeAt(0);
                    this.overflow = [];
                }
                Utf32Decoder.prototype.write = function(src) {
                    if (src.length === 0) return "";
                    var i = 0;
                    var codepoint = 0;
                    var dst = Buffer.alloc(src.length + 4);
                    var offset = 0;
                    var isLE = this.isLE;
                    var overflow = this.overflow;
                    var badChar = this.badChar;
                    if (overflow.length > 0) {
                        for(; i < src.length && overflow.length < 4; i++)overflow.push(src[i]);
                        if (overflow.length === 4) {
                            // NOTE: codepoint is a signed int32 and can be negative.
                            // NOTE: We copied this block from below to help V8 optimize it (it works with array, not buffer).
                            if (isLE) codepoint = overflow[i] | overflow[i + 1] << 8 | overflow[i + 2] << 16 | overflow[i + 3] << 24;
                            else codepoint = overflow[i + 3] | overflow[i + 2] << 8 | overflow[i + 1] << 16 | overflow[i] << 24;
                            overflow.length = 0;
                            offset = _writeCodepoint(dst, offset, codepoint, badChar);
                        }
                    }
                    // Main loop. Should be as optimized as possible.
                    for(; i < src.length - 3; i += 4){
                        // NOTE: codepoint is a signed int32 and can be negative.
                        if (isLE) codepoint = src[i] | src[i + 1] << 8 | src[i + 2] << 16 | src[i + 3] << 24;
                        else codepoint = src[i + 3] | src[i + 2] << 8 | src[i + 1] << 16 | src[i] << 24;
                        offset = _writeCodepoint(dst, offset, codepoint, badChar);
                    }
                    // Keep overflowing bytes.
                    for(; i < src.length; i++)overflow.push(src[i]);
                    return dst.slice(0, offset).toString("ucs2");
                };
                function _writeCodepoint(dst, offset, codepoint, badChar) {
                    // NOTE: codepoint is signed int32 and can be negative. We keep it that way to help V8 with optimizations.
                    if (codepoint < 0 || codepoint > 0x10FFFF) // Not a valid Unicode codepoint
                    codepoint = badChar;
                    // Ephemeral Planes: Write high surrogate.
                    if (codepoint >= 0x10000) {
                        codepoint -= 0x10000;
                        var high = 0xD800 | codepoint >> 10;
                        dst[offset++] = high & 0xff;
                        dst[offset++] = high >> 8;
                        // Low surrogate is written below.
                        var codepoint = 0xDC00 | codepoint & 0x3FF;
                    }
                    // Write BMP char or low surrogate.
                    dst[offset++] = codepoint & 0xff;
                    dst[offset++] = codepoint >> 8;
                    return offset;
                }
                Utf32Decoder.prototype.end = function() {
                    this.overflow.length = 0;
                };
                // == UTF-32 Auto codec =============================================================
                // Decoder chooses automatically from UTF-32LE and UTF-32BE using BOM and space-based heuristic.
                // Defaults to UTF-32LE. http://en.wikipedia.org/wiki/UTF-32
                // Encoder/decoder default can be changed: iconv.decode(buf, 'utf32', {defaultEncoding: 'utf-32be'});
                // Encoder prepends BOM (which can be overridden with (addBOM: false}).
                exports.utf32 = Utf32AutoCodec;
                exports.ucs4 = "utf32";
                function Utf32AutoCodec(options, iconv) {
                    this.iconv = iconv;
                }
                Utf32AutoCodec.prototype.encoder = Utf32AutoEncoder;
                Utf32AutoCodec.prototype.decoder = Utf32AutoDecoder;
                // -- Encoding
                function Utf32AutoEncoder(options, codec) {
                    options = options || {};
                    if (options.addBOM === undefined) options.addBOM = true;
                    this.encoder = codec.iconv.getEncoder(options.defaultEncoding || "utf-32le", options);
                }
                Utf32AutoEncoder.prototype.write = function(str) {
                    return this.encoder.write(str);
                };
                Utf32AutoEncoder.prototype.end = function() {
                    return this.encoder.end();
                };
                // -- Decoding
                function Utf32AutoDecoder(options, codec) {
                    this.decoder = null;
                    this.initialBufs = [];
                    this.initialBufsLen = 0;
                    this.options = options || {};
                    this.iconv = codec.iconv;
                }
                Utf32AutoDecoder.prototype.write = function(buf) {
                    if (!this.decoder) {
                        // Codec is not chosen yet. Accumulate initial bytes.
                        this.initialBufs.push(buf);
                        this.initialBufsLen += buf.length;
                        if (this.initialBufsLen < 32) return "";
                        // We have enough bytes -> detect endianness.
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = "";
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.write(buf);
                };
                Utf32AutoDecoder.prototype.end = function() {
                    if (!this.decoder) {
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = "";
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        var trail = this.decoder.end();
                        if (trail) resStr += trail;
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.end();
                };
                function detectEncoding(bufs, defaultEncoding) {
                    var b = [];
                    var charsProcessed = 0;
                    var invalidLE = 0, invalidBE = 0; // Number of invalid chars when decoded as LE or BE.
                    var bmpCharsLE = 0, bmpCharsBE = 0; // Number of BMP chars when decoded as LE or BE.
                    outer_loop: for(var i = 0; i < bufs.length; i++){
                        var buf = bufs[i];
                        for(var j = 0; j < buf.length; j++){
                            b.push(buf[j]);
                            if (b.length === 4) {
                                if (charsProcessed === 0) {
                                    // Check BOM first.
                                    if (b[0] === 0xFF && b[1] === 0xFE && b[2] === 0 && b[3] === 0) return "utf-32le";
                                    if (b[0] === 0 && b[1] === 0 && b[2] === 0xFE && b[3] === 0xFF) return "utf-32be";
                                }
                                if (b[0] !== 0 || b[1] > 0x10) invalidBE++;
                                if (b[3] !== 0 || b[2] > 0x10) invalidLE++;
                                if (b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0)) bmpCharsBE++;
                                if ((b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0) bmpCharsLE++;
                                b.length = 0;
                                charsProcessed++;
                                if (charsProcessed >= 100) break outer_loop;
                            }
                        }
                    }
                    // Make decisions.
                    if (bmpCharsBE - invalidBE > bmpCharsLE - invalidLE) return "utf-32be";
                    if (bmpCharsBE - invalidBE < bmpCharsLE - invalidLE) return "utf-32le";
                    // Couldn't decide (likely all zeros or not enough data).
                    return defaultEncoding || "utf-32le";
                }
            /***/ },
            /***/ 92307: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
                // See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
                exports.utf7 = Utf7Codec;
                exports.unicode11utf7 = "utf7"; // Alias UNICODE-1-1-UTF-7
                function Utf7Codec(codecOptions, iconv) {
                    this.iconv = iconv;
                }
                Utf7Codec.prototype.encoder = Utf7Encoder;
                Utf7Codec.prototype.decoder = Utf7Decoder;
                Utf7Codec.prototype.bomAware = true;
                // -- Encoding
                var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
                function Utf7Encoder(options, codec) {
                    this.iconv = codec.iconv;
                }
                Utf7Encoder.prototype.write = function(str) {
                    // Naive implementation.
                    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
                    return Buffer.from(str.replace(nonDirectChars, (function(chunk) {
                        return "+" + (chunk === "+" ? "" : this.iconv.encode(chunk, "utf16-be").toString("base64").replace(/=+$/, "")) + "-";
                    }).bind(this)));
                };
                Utf7Encoder.prototype.end = function() {};
                // -- Decoding
                function Utf7Decoder(options, codec) {
                    this.iconv = codec.iconv;
                    this.inBase64 = false;
                    this.base64Accum = "";
                }
                var base64Regex = /[A-Za-z0-9\/+]/;
                var base64Chars = [];
                for(var i = 0; i < 256; i++)base64Chars[i] = base64Regex.test(String.fromCharCode(i));
                var plusChar = "+".charCodeAt(0), minusChar = "-".charCodeAt(0), andChar = "&".charCodeAt(0);
                Utf7Decoder.prototype.write = function(buf) {
                    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
                    // The decoder is more involved as we must handle chunks in stream.
                    for(var i = 0; i < buf.length; i++){
                        if (!inBase64) // Write direct chars until '+'
                        {
                            if (buf[i] == plusChar) {
                                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                                lastI = i + 1;
                                inBase64 = true;
                            }
                        } else if (!base64Chars[buf[i]]) {
                            if (i == lastI && buf[i] == minusChar) res += "+";
                            else {
                                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii");
                                res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
                            }
                            if (buf[i] != minusChar) i--;
                            lastI = i + 1;
                            inBase64 = false;
                            base64Accum = "";
                        }
                    }
                    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
                    else {
                        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii");
                        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
                        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
                        b64str = b64str.slice(0, canBeDecoded);
                        res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
                    }
                    this.inBase64 = inBase64;
                    this.base64Accum = base64Accum;
                    return res;
                };
                Utf7Decoder.prototype.end = function() {
                    var res = "";
                    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, "base64"), "utf16-be");
                    this.inBase64 = false;
                    this.base64Accum = "";
                    return res;
                };
                // UTF-7-IMAP codec.
                // RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
                // Differences:
                //  * Base64 part is started by "&" instead of "+"
                //  * Direct characters are 0x20-0x7E, except "&" (0x26)
                //  * In Base64, "," is used instead of "/"
                //  * Base64 must not be used to represent direct characters.
                //  * No implicit shift back from Base64 (should always end with '-')
                //  * String must end in non-shifted position.
                //  * "-&" while in base64 is not allowed.
                exports.utf7imap = Utf7IMAPCodec;
                function Utf7IMAPCodec(codecOptions, iconv) {
                    this.iconv = iconv;
                }
                Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
                Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
                Utf7IMAPCodec.prototype.bomAware = true;
                // -- Encoding
                function Utf7IMAPEncoder(options, codec) {
                    this.iconv = codec.iconv;
                    this.inBase64 = false;
                    this.base64Accum = Buffer.alloc(6);
                    this.base64AccumIdx = 0;
                }
                Utf7IMAPEncoder.prototype.write = function(str) {
                    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = Buffer.alloc(str.length * 5 + 10), bufIdx = 0;
                    for(var i = 0; i < str.length; i++){
                        var uChar = str.charCodeAt(i);
                        if (0x20 <= uChar && uChar <= 0x7E) {
                            if (inBase64) {
                                if (base64AccumIdx > 0) {
                                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), bufIdx);
                                    base64AccumIdx = 0;
                                }
                                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                                inBase64 = false;
                            }
                            if (!inBase64) {
                                buf[bufIdx++] = uChar; // Write direct character
                                if (uChar === andChar) buf[bufIdx++] = minusChar;
                            }
                        } else {
                            if (!inBase64) {
                                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
                                inBase64 = true;
                            }
                            if (inBase64) {
                                base64Accum[base64AccumIdx++] = uChar >> 8;
                                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                                if (base64AccumIdx == base64Accum.length) {
                                    bufIdx += buf.write(base64Accum.toString("base64").replace(/\//g, ","), bufIdx);
                                    base64AccumIdx = 0;
                                }
                            }
                        }
                    }
                    this.inBase64 = inBase64;
                    this.base64AccumIdx = base64AccumIdx;
                    return buf.slice(0, bufIdx);
                };
                Utf7IMAPEncoder.prototype.end = function() {
                    var buf = Buffer.alloc(10), bufIdx = 0;
                    if (this.inBase64) {
                        if (this.base64AccumIdx > 0) {
                            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), bufIdx);
                            this.base64AccumIdx = 0;
                        }
                        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                        this.inBase64 = false;
                    }
                    return buf.slice(0, bufIdx);
                };
                // -- Decoding
                function Utf7IMAPDecoder(options, codec) {
                    this.iconv = codec.iconv;
                    this.inBase64 = false;
                    this.base64Accum = "";
                }
                var base64IMAPChars = base64Chars.slice();
                base64IMAPChars[",".charCodeAt(0)] = true;
                Utf7IMAPDecoder.prototype.write = function(buf) {
                    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
                    // The decoder is more involved as we must handle chunks in stream.
                    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
                    for(var i = 0; i < buf.length; i++){
                        if (!inBase64) // Write direct chars until '&'
                        {
                            if (buf[i] == andChar) {
                                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                                lastI = i + 1;
                                inBase64 = true;
                            }
                        } else if (!base64IMAPChars[buf[i]]) {
                            if (i == lastI && buf[i] == minusChar) res += "&";
                            else {
                                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii").replace(/,/g, "/");
                                res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
                            }
                            if (buf[i] != minusChar) i--;
                            lastI = i + 1;
                            inBase64 = false;
                            base64Accum = "";
                        }
                    }
                    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
                    else {
                        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii").replace(/,/g, "/");
                        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
                        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
                        b64str = b64str.slice(0, canBeDecoded);
                        res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
                    }
                    this.inBase64 = inBase64;
                    this.base64Accum = base64Accum;
                    return res;
                };
                Utf7IMAPDecoder.prototype.end = function() {
                    var res = "";
                    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, "base64"), "utf16-be");
                    this.inBase64 = false;
                    this.base64Accum = "";
                    return res;
                };
            /***/ },
            /***/ 59203: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var BOMChar = "\uFEFF";
                exports.PrependBOM = PrependBOMWrapper;
                function PrependBOMWrapper(encoder, options) {
                    this.encoder = encoder;
                    this.addBOM = true;
                }
                PrependBOMWrapper.prototype.write = function(str) {
                    if (this.addBOM) {
                        str = BOMChar + str;
                        this.addBOM = false;
                    }
                    return this.encoder.write(str);
                };
                PrependBOMWrapper.prototype.end = function() {
                    return this.encoder.end();
                };
                //------------------------------------------------------------------------------
                exports.StripBOM = StripBOMWrapper;
                function StripBOMWrapper(decoder, options) {
                    this.decoder = decoder;
                    this.pass = false;
                    this.options = options || {};
                }
                StripBOMWrapper.prototype.write = function(buf) {
                    var res = this.decoder.write(buf);
                    if (this.pass || !res) return res;
                    if (res[0] === BOMChar) {
                        res = res.slice(1);
                        if (typeof this.options.stripBOM === "function") this.options.stripBOM();
                    }
                    this.pass = true;
                    return res;
                };
                StripBOMWrapper.prototype.end = function() {
                    return this.decoder.end();
                };
            /***/ },
            /***/ 32766: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                var bomHandling = __webpack_require__(59203), iconv = module1.exports;
                // All codecs and aliases are kept here, keyed by encoding name/alias.
                // They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
                iconv.encodings = null;
                // Characters emitted in case of error.
                iconv.defaultCharUnicode = "\uFFFD";
                iconv.defaultCharSingleByte = "?";
                // Public API.
                iconv.encode = function encode(str, encoding, options) {
                    str = "" + (str || ""); // Ensure string.
                    var encoder = iconv.getEncoder(encoding, options);
                    var res = encoder.write(str);
                    var trail = encoder.end();
                    return trail && trail.length > 0 ? Buffer.concat([
                        res,
                        trail
                    ]) : res;
                };
                iconv.decode = function decode(buf, encoding, options) {
                    if (typeof buf === "string") {
                        if (!iconv.skipDecodeWarning) {
                            console.error("Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding");
                            iconv.skipDecodeWarning = true;
                        }
                        buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
                    }
                    var decoder = iconv.getDecoder(encoding, options);
                    var res = decoder.write(buf);
                    var trail = decoder.end();
                    return trail ? res + trail : res;
                };
                iconv.encodingExists = function encodingExists(enc) {
                    try {
                        iconv.getCodec(enc);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                // Legacy aliases to convert functions
                iconv.toEncoding = iconv.encode;
                iconv.fromEncoding = iconv.decode;
                // Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
                iconv._codecDataCache = {};
                iconv.getCodec = function getCodec(encoding) {
                    if (!iconv.encodings) iconv.encodings = __webpack_require__(88069); // Lazy load all encoding definitions.
                    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
                    var enc = iconv._canonicalizeEncoding(encoding);
                    // Traverse iconv.encodings to find actual codec.
                    var codecOptions = {};
                    while(true){
                        var codec = iconv._codecDataCache[enc];
                        if (codec) return codec;
                        var codecDef = iconv.encodings[enc];
                        switch(typeof codecDef){
                            case "string":
                                enc = codecDef;
                                break;
                            case "object":
                                for(var key in codecDef)codecOptions[key] = codecDef[key];
                                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                                enc = codecDef.type;
                                break;
                            case "function":
                                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                                // The codec function must load all tables and return object with .encoder and .decoder methods.
                                // It'll be called only once (for each different options object).
                                codec = new codecDef(codecOptions, iconv);
                                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                                return codec;
                            default:
                                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
                        }
                    }
                };
                iconv._canonicalizeEncoding = function(encoding) {
                    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
                    return ("" + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
                };
                iconv.getEncoder = function getEncoder(encoding, options) {
                    var codec = iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
                    if (codec.bomAware && options && options.addBOM) encoder = new bomHandling.PrependBOM(encoder, options);
                    return encoder;
                };
                iconv.getDecoder = function getDecoder(encoding, options) {
                    var codec = iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
                    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new bomHandling.StripBOM(decoder, options);
                    return decoder;
                };
                // Streaming API
                // NOTE: Streaming API naturally depends on 'stream' module from Node.js. Unfortunately in browser environments this module can add
                // up to 100Kb to the output bundle. To avoid unnecessary code bloat, we don't enable Streaming API in browser by default.
                // If you would like to enable it explicitly, please add the following code to your app:
                // > iconv.enableStreamingAPI(require('stream'));
                iconv.enableStreamingAPI = function enableStreamingAPI(stream_module) {
                    if (iconv.supportsStreams) return;
                    // Dependency-inject stream module to create IconvLite stream classes.
                    var streams = __webpack_require__(44690)(stream_module);
                    // Not public API yet, but expose the stream classes.
                    iconv.IconvLiteEncoderStream = streams.IconvLiteEncoderStream;
                    iconv.IconvLiteDecoderStream = streams.IconvLiteDecoderStream;
                    // Streaming API.
                    iconv.encodeStream = function encodeStream(encoding, options) {
                        return new iconv.IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
                    };
                    iconv.decodeStream = function decodeStream(encoding, options) {
                        return new iconv.IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
                    };
                    iconv.supportsStreams = true;
                };
                // Enable Streaming API automatically if 'stream' module is available and non-empty (the majority of environments).
                var stream_module;
                try {
                    stream_module = __webpack_require__(25832);
                } catch (e) {}
                if (stream_module && stream_module.Transform) iconv.enableStreamingAPI(stream_module);
                else // In rare cases where 'stream' module is not available by default, throw a helpful exception.
                iconv.encodeStream = iconv.decodeStream = function() {
                    throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
                };
            /***/ },
            /***/ 44690: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(85543).Buffer;
                // NOTE: Due to 'stream' module being pretty large (~100Kb, significant in browser environments), 
                // we opt to dependency-inject it instead of creating a hard dependency.
                module1.exports = function(stream_module) {
                    var Transform = stream_module.Transform;
                    // == Encoder stream =======================================================
                    function IconvLiteEncoderStream(conv, options) {
                        this.conv = conv;
                        options = options || {};
                        options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
                        Transform.call(this, options);
                    }
                    IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
                        constructor: {
                            value: IconvLiteEncoderStream
                        }
                    });
                    IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
                        if (typeof chunk != "string") return done(new Error("Iconv encoding stream needs strings as its input."));
                        try {
                            var res = this.conv.write(chunk);
                            if (res && res.length) this.push(res);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteEncoderStream.prototype._flush = function(done) {
                        try {
                            var res = this.conv.end();
                            if (res && res.length) this.push(res);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteEncoderStream.prototype.collect = function(cb) {
                        var chunks = [];
                        this.on("error", cb);
                        this.on("data", function(chunk) {
                            chunks.push(chunk);
                        });
                        this.on("end", function() {
                            cb(null, Buffer.concat(chunks));
                        });
                        return this;
                    };
                    // == Decoder stream =======================================================
                    function IconvLiteDecoderStream(conv, options) {
                        this.conv = conv;
                        options = options || {};
                        options.encoding = this.encoding = "utf8"; // We output strings.
                        Transform.call(this, options);
                    }
                    IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
                        constructor: {
                            value: IconvLiteDecoderStream
                        }
                    });
                    IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
                        if (!Buffer.isBuffer(chunk) && !(chunk instanceof Uint8Array)) return done(new Error("Iconv decoding stream needs buffers as its input."));
                        try {
                            var res = this.conv.write(chunk);
                            if (res && res.length) this.push(res, this.encoding);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteDecoderStream.prototype._flush = function(done) {
                        try {
                            var res = this.conv.end();
                            if (res && res.length) this.push(res, this.encoding);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteDecoderStream.prototype.collect = function(cb) {
                        var res = "";
                        this.on("error", cb);
                        this.on("data", function(chunk) {
                            res += chunk;
                        });
                        this.on("end", function() {
                            cb(null, res);
                        });
                        return this;
                    };
                    return {
                        IconvLiteEncoderStream: IconvLiteEncoderStream,
                        IconvLiteDecoderStream: IconvLiteDecoderStream
                    };
                };
            /***/ },
            /***/ 74525: /***/ function(__unused_webpack_module, exports) {
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            /***/ },
            /***/ 48575: /***/ function(module1) {
                if (typeof Object.create === "function") // implementation from standard node.js 'util' module
                module1.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                    }
                };
                else // old school shim for old browsers
                module1.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                };
            /***/ },
            /***/ 77092: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasToStringTag = __webpack_require__(44111)();
                var callBound = __webpack_require__(97615);
                var $toString = callBound("Object.prototype.toString");
                var isStandardArguments = function isArguments(value) {
                    if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
                    return $toString(value) === "[object Arguments]";
                };
                var isLegacyArguments = function isArguments(value) {
                    if (isStandardArguments(value)) return true;
                    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
                };
                var supportsStandardArguments = function() {
                    return isStandardArguments(arguments);
                }();
                isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
                module1.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
            /***/ },
            /***/ 5443: /***/ function(module1) {
                "use strict";
                var fnToStr = Function.prototype.toString;
                var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
                var badArrayLike;
                var isCallableMarker;
                if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") try {
                    badArrayLike = Object.defineProperty({}, "length", {
                        get: function() {
                            throw isCallableMarker;
                        }
                    });
                    isCallableMarker = {};
                    // eslint-disable-next-line no-throw-literal
                    reflectApply(function() {
                        throw 42;
                    }, null, badArrayLike);
                } catch (_) {
                    if (_ !== isCallableMarker) reflectApply = null;
                }
                else reflectApply = null;
                var constructorRegex = /^\s*class\b/;
                var isES6ClassFn = function isES6ClassFunction(value) {
                    try {
                        var fnStr = fnToStr.call(value);
                        return constructorRegex.test(fnStr);
                    } catch (e) {
                        return false; // not a function
                    }
                };
                var tryFunctionObject = function tryFunctionToStr(value) {
                    try {
                        if (isES6ClassFn(value)) return false;
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                var toStr = Object.prototype.toString;
                var objectClass = "[object Object]";
                var fnClass = "[object Function]";
                var genClass = "[object GeneratorFunction]";
                var ddaClass = "[object HTMLAllCollection]"; // IE 11
                var ddaClass2 = "[object HTML document.all class]";
                var ddaClass3 = "[object HTMLCollection]"; // IE 9-10
                var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
                var isIE68 = !(0 in [
                    , 
                ]); // eslint-disable-line no-sparse-arrays, comma-spacing
                var isDDA = function isDocumentDotAll() {
                    return false;
                };
                if (typeof document === "object") {
                    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
                    var all = document.all;
                    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
                        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
                        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
                            var str = toStr.call(value);
                            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
                             || str === objectClass // IE 6-8
                            ) && value("") == null; // eslint-disable-line eqeqeq
                        } catch (e) {}
                        return false;
                    };
                }
                module1.exports = reflectApply ? function isCallable(value) {
                    if (isDDA(value)) return true;
                    if (!value) return false;
                    if (typeof value !== "function" && typeof value !== "object") return false;
                    try {
                        reflectApply(value, null, badArrayLike);
                    } catch (e) {
                        if (e !== isCallableMarker) return false;
                    }
                    return !isES6ClassFn(value) && tryFunctionObject(value);
                } : function isCallable(value) {
                    if (isDDA(value)) return true;
                    if (!value) return false;
                    if (typeof value !== "function" && typeof value !== "object") return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    if (isES6ClassFn(value)) return false;
                    var strClass = toStr.call(value);
                    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
                    return tryFunctionObject(value);
                };
            /***/ },
            /***/ 28659: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getDay = Date.prototype.getDay;
                var tryDateObject = function tryDateGetDayCall(value) {
                    try {
                        getDay.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                var toStr = Object.prototype.toString;
                var dateClass = "[object Date]";
                var hasToStringTag = __webpack_require__(44111)();
                module1.exports = function isDateObject(value) {
                    if (typeof value !== "object" || value === null) return false;
                    return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
                };
            /***/ },
            /***/ 97427: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toStr = Object.prototype.toString;
                var fnToStr = Function.prototype.toString;
                var isFnRegex = /^\s*(?:function)?\*/;
                var hasToStringTag = __webpack_require__(44111)();
                var getProto = Object.getPrototypeOf;
                var getGeneratorFunc = function() {
                    if (!hasToStringTag) return false;
                    try {
                        return Function("return function*() {}")();
                    } catch (e) {}
                };
                var GeneratorFunction;
                module1.exports = function isGeneratorFunction(fn) {
                    if (typeof fn !== "function") return false;
                    if (isFnRegex.test(fnToStr.call(fn))) return true;
                    if (!hasToStringTag) {
                        var str = toStr.call(fn);
                        return str === "[object GeneratorFunction]";
                    }
                    if (!getProto) return false;
                    if (typeof GeneratorFunction === "undefined") {
                        var generatorFunc = getGeneratorFunc();
                        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
                    }
                    return getProto(fn) === GeneratorFunction;
                };
            /***/ },
            /***/ 82100: /***/ function(module1) {
                "use strict";
                /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module1.exports = function isNaN1(value) {
                    return value !== value;
                };
            /***/ },
            /***/ 98622: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBind = __webpack_require__(12550);
                var define = __webpack_require__(19170);
                var implementation = __webpack_require__(82100);
                var getPolyfill = __webpack_require__(64358);
                var shim = __webpack_require__(6232);
                var polyfill = callBind(getPolyfill(), Number);
                /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
                    getPolyfill: getPolyfill,
                    implementation: implementation,
                    shim: shim
                });
                module1.exports = polyfill;
            /***/ },
            /***/ 64358: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(82100);
                module1.exports = function getPolyfill() {
                    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
                    return implementation;
                };
            /***/ },
            /***/ 6232: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(19170);
                var getPolyfill = __webpack_require__(64358);
                /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module1.exports = function shimNumberIsNaN() {
                    var polyfill = getPolyfill();
                    define(Number, {
                        isNaN: polyfill
                    }, {
                        isNaN: function testIsNaN() {
                            return Number.isNaN !== polyfill;
                        }
                    });
                    return polyfill;
                };
            /***/ },
            /***/ 55278: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBound = __webpack_require__(97615);
                var hasToStringTag = __webpack_require__(44111)();
                var has;
                var $exec;
                var isRegexMarker;
                var badStringifier;
                if (hasToStringTag) {
                    has = callBound("Object.prototype.hasOwnProperty");
                    $exec = callBound("RegExp.prototype.exec");
                    isRegexMarker = {};
                    var throwRegexMarker = function() {
                        throw isRegexMarker;
                    };
                    badStringifier = {
                        toString: throwRegexMarker,
                        valueOf: throwRegexMarker
                    };
                    if (typeof Symbol.toPrimitive === "symbol") badStringifier[Symbol.toPrimitive] = throwRegexMarker;
                }
                var $toString = callBound("Object.prototype.toString");
                var gOPD = Object.getOwnPropertyDescriptor;
                var regexClass = "[object RegExp]";
                module1.exports = hasToStringTag ? function isRegex(value) {
                    if (!value || typeof value !== "object") return false;
                    var descriptor = gOPD(value, "lastIndex");
                    var hasLastIndexDataProperty = descriptor && has(descriptor, "value");
                    if (!hasLastIndexDataProperty) return false;
                    try {
                        $exec(value, badStringifier);
                    } catch (e) {
                        return e === isRegexMarker;
                    }
                } : function isRegex(value) {
                    // In older browsers, typeof regex incorrectly returns 'function'
                    if (!value || typeof value !== "object" && typeof value !== "function") return false;
                    return $toString(value) === regexClass;
                };
            /***/ },
            /***/ 82527: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var whichTypedArray = __webpack_require__(54010);
                module1.exports = function isTypedArray(value) {
                    return !!whichTypedArray(value);
                };
            /***/ },
            /***/ 98720: /***/ function(module1) {
                "use strict";
                var numberIsNaN = function(value) {
                    return value !== value;
                };
                module1.exports = function is(a, b) {
                    if (a === 0 && b === 0) return 1 / a === 1 / b;
                    if (a === b) return true;
                    if (numberIsNaN(a) && numberIsNaN(b)) return true;
                    return false;
                };
            /***/ },
            /***/ 7402: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(19170);
                var callBind = __webpack_require__(12550);
                var implementation = __webpack_require__(98720);
                var getPolyfill = __webpack_require__(25280);
                var shim = __webpack_require__(49129);
                var polyfill = callBind(getPolyfill(), Object);
                define(polyfill, {
                    getPolyfill: getPolyfill,
                    implementation: implementation,
                    shim: shim
                });
                module1.exports = polyfill;
            /***/ },
            /***/ 25280: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(98720);
                module1.exports = function getPolyfill() {
                    return typeof Object.is === "function" ? Object.is : implementation;
                };
            /***/ },
            /***/ 49129: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getPolyfill = __webpack_require__(25280);
                var define = __webpack_require__(19170);
                module1.exports = function shimObjectIs() {
                    var polyfill = getPolyfill();
                    define(Object, {
                        is: polyfill
                    }, {
                        is: function testObjectIs() {
                            return Object.is !== polyfill;
                        }
                    });
                    return polyfill;
                };
            /***/ },
            /***/ 78383: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var keysShim;
                if (!Object.keys) {
                    // modified from https://github.com/es-shims/es5-shim
                    var has = Object.prototype.hasOwnProperty;
                    var toStr = Object.prototype.toString;
                    var isArgs = __webpack_require__(84418); // eslint-disable-line global-require
                    var isEnumerable = Object.prototype.propertyIsEnumerable;
                    var hasDontEnumBug = !isEnumerable.call({
                        toString: null
                    }, "toString");
                    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
                    var dontEnums = [
                        "toString",
                        "toLocaleString",
                        "valueOf",
                        "hasOwnProperty",
                        "isPrototypeOf",
                        "propertyIsEnumerable",
                        "constructor"
                    ];
                    var equalsConstructorPrototype = function(o) {
                        var ctor = o.constructor;
                        return ctor && ctor.prototype === o;
                    };
                    var excludedKeys = {
                        $applicationCache: true,
                        $console: true,
                        $external: true,
                        $frame: true,
                        $frameElement: true,
                        $frames: true,
                        $innerHeight: true,
                        $innerWidth: true,
                        $onmozfullscreenchange: true,
                        $onmozfullscreenerror: true,
                        $outerHeight: true,
                        $outerWidth: true,
                        $pageXOffset: true,
                        $pageYOffset: true,
                        $parent: true,
                        $scrollLeft: true,
                        $scrollTop: true,
                        $scrollX: true,
                        $scrollY: true,
                        $self: true,
                        $webkitIndexedDB: true,
                        $webkitStorageInfo: true,
                        $window: true
                    };
                    var hasAutomationEqualityBug = function() {
                        /* global window */ if (typeof window === "undefined") return false;
                        for(var k in window)try {
                            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                                equalsConstructorPrototype(window[k]);
                            } catch (e) {
                                return true;
                            }
                        } catch (e) {
                            return true;
                        }
                        return false;
                    }();
                    var equalsConstructorPrototypeIfNotBuggy = function(o) {
                        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
                        try {
                            return equalsConstructorPrototype(o);
                        } catch (e) {
                            return false;
                        }
                    };
                    keysShim = function keys(object) {
                        var isObject = object !== null && typeof object === "object";
                        var isFunction = toStr.call(object) === "[object Function]";
                        var isArguments = isArgs(object);
                        var isString = isObject && toStr.call(object) === "[object String]";
                        var theKeys = [];
                        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
                        var skipProto = hasProtoEnumBug && isFunction;
                        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
                        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
                        else {
                            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
                        }
                        if (hasDontEnumBug) {
                            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
                            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
                        }
                        return theKeys;
                    };
                }
                module1.exports = keysShim;
            /***/ },
            /***/ 806: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var slice = Array.prototype.slice;
                var isArgs = __webpack_require__(84418);
                var origKeys = Object.keys;
                var keysShim = origKeys ? function keys(o) {
                    return origKeys(o);
                } : __webpack_require__(78383);
                var originalKeys = Object.keys;
                keysShim.shim = function shimObjectKeys() {
                    if (Object.keys) {
                        var keysWorksWithArguments = function() {
                            // Safari 5.0 bug
                            var args = Object.keys(arguments);
                            return args && args.length === arguments.length;
                        }(1, 2);
                        if (!keysWorksWithArguments) Object.keys = function keys(object) {
                            if (isArgs(object)) return originalKeys(slice.call(object));
                            return originalKeys(object);
                        };
                    } else Object.keys = keysShim;
                    return Object.keys || keysShim;
                };
                module1.exports = keysShim;
            /***/ },
            /***/ 84418: /***/ function(module1) {
                "use strict";
                var toStr = Object.prototype.toString;
                module1.exports = function isArguments(value) {
                    var str = toStr.call(value);
                    var isArgs = str === "[object Arguments]";
                    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
                    return isArgs;
                };
            /***/ },
            /***/ 22148: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // modified from https://github.com/es-shims/es6-shim
                var objectKeys = __webpack_require__(806);
                var hasSymbols = __webpack_require__(65682)();
                var callBound = __webpack_require__(97615);
                var toObject = Object;
                var $push = callBound("Array.prototype.push");
                var $propIsEnumerable = callBound("Object.prototype.propertyIsEnumerable");
                var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
                // eslint-disable-next-line no-unused-vars
                module1.exports = function assign(target, source1) {
                    if (target == null) throw new TypeError("target must be an object");
                    var to = toObject(target); // step 1
                    if (arguments.length === 1) return to; // step 2
                    for(var s = 1; s < arguments.length; ++s){
                        var from = toObject(arguments[s]); // step 3.a.i
                        // step 3.a.ii:
                        var keys = objectKeys(from);
                        var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
                        if (getSymbols) {
                            var syms = getSymbols(from);
                            for(var j = 0; j < syms.length; ++j){
                                var key = syms[j];
                                if ($propIsEnumerable(from, key)) $push(keys, key);
                            }
                        }
                        // step 3.a.iii:
                        for(var i = 0; i < keys.length; ++i){
                            var nextKey = keys[i];
                            if ($propIsEnumerable(from, nextKey)) {
                                var propValue = from[nextKey]; // step 3.a.iii.2.a
                                to[nextKey] = propValue; // step 3.a.iii.2.b
                            }
                        }
                    }
                    return to; // step 4
                };
            /***/ },
            /***/ 10293: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(22148);
                var lacksProperEnumerationOrder = function() {
                    if (!Object.assign) return false;
                    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
                    var letters = str.split("");
                    var map = {};
                    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
                    var obj = Object.assign({}, map);
                    var actual = "";
                    for(var k in obj)actual += k;
                    return str !== actual;
                };
                var assignHasPendingExceptions = function() {
                    if (!Object.assign || !Object.preventExtensions) return false;
                    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
                        1: 2
                    });
                    try {
                        Object.assign(thrower, "xy");
                    } catch (e) {
                        return thrower[1] === "y";
                    }
                    return false;
                };
                module1.exports = function getPolyfill() {
                    if (!Object.assign) return implementation;
                    if (lacksProperEnumerationOrder()) return implementation;
                    if (assignHasPendingExceptions()) return implementation;
                    return Object.assign;
                };
            /***/ },
            /***/ 69034: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
                function _has(obj, key) {
                    return Object.prototype.hasOwnProperty.call(obj, key);
                }
                exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
                    var sources = Array.prototype.slice.call(arguments, 1);
                    while(sources.length){
                        var source = sources.shift();
                        if (!source) continue;
                        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
                        for(var p in source)if (_has(source, p)) obj[p] = source[p];
                    }
                    return obj;
                };
                // reduce buffer size, avoiding mem copy
                exports.shrinkBuf = function(buf, size) {
                    if (buf.length === size) return buf;
                    if (buf.subarray) return buf.subarray(0, size);
                    buf.length = size;
                    return buf;
                };
                var fnTyped = {
                    arraySet: function(dest, src, src_offs, len, dest_offs) {
                        if (src.subarray && dest.subarray) {
                            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                            return;
                        }
                        // Fallback to ordinary array
                        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                    },
                    // Join array of chunks to single array.
                    flattenChunks: function(chunks) {
                        var i, l, len, pos, chunk, result;
                        // calculate data length
                        len = 0;
                        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
                        // join chunks
                        result = new Uint8Array(len);
                        pos = 0;
                        for(i = 0, l = chunks.length; i < l; i++){
                            chunk = chunks[i];
                            result.set(chunk, pos);
                            pos += chunk.length;
                        }
                        return result;
                    }
                };
                var fnUntyped = {
                    arraySet: function(dest, src, src_offs, len, dest_offs) {
                        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                    },
                    // Join array of chunks to single array.
                    flattenChunks: function(chunks) {
                        return [].concat.apply([], chunks);
                    }
                };
                // Enable/Disable typed arrays use, for testing
                //
                exports.setTyped = function(on) {
                    if (on) {
                        exports.Buf8 = Uint8Array;
                        exports.Buf16 = Uint16Array;
                        exports.Buf32 = Int32Array;
                        exports.assign(exports, fnTyped);
                    } else {
                        exports.Buf8 = Array;
                        exports.Buf16 = Array;
                        exports.Buf32 = Array;
                        exports.assign(exports, fnUntyped);
                    }
                };
                exports.setTyped(TYPED_OK);
            /***/ },
            /***/ 51475: /***/ function(module1) {
                "use strict";
                // Note: adler32 takes 12% for level 0 and 2% for level 6.
                // It isn't worth it to make additional optimizations as in original.
                // Small size is preferable.
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                function adler32(adler, buf, len, pos) {
                    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
                    while(len !== 0){
                        // Set limit ~ twice less than 5552, to keep
                        // s2 in 31-bits, because we force signed ints.
                        // in other case %= will fail.
                        n = len > 2000 ? 2000 : len;
                        len -= n;
                        do {
                            s1 = s1 + buf[pos++] | 0;
                            s2 = s2 + s1 | 0;
                        }while (--n);
                        s1 %= 65521;
                        s2 %= 65521;
                    }
                    return s1 | s2 << 16 | 0;
                }
                module1.exports = adler32;
            /***/ },
            /***/ 40549: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                module1.exports = {
                    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    //Z_MEM_ERROR:     -4,
                    Z_BUF_ERROR: -5,
                    //Z_VERSION_ERROR: -6,
                    /* compression levels */ Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
                    Z_TEXT: 1,
                    //Z_ASCII:                1, // = Z_TEXT (deprecated)
                    Z_UNKNOWN: 2,
                    /* The deflate compression method */ Z_DEFLATED: 8
                };
            /***/ },
            /***/ 38621: /***/ function(module1) {
                "use strict";
                // Note: we can't get significant speed boost here.
                // So write code to minimize size - no pregenerated tables
                // and array tools dependencies.
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                // Use ordinary array, since untyped makes no boost here
                function makeTable() {
                    var c, table = [];
                    for(var n = 0; n < 256; n++){
                        c = n;
                        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
                        table[n] = c;
                    }
                    return table;
                }
                // Create table on load. Just 255 signed longs. Not a problem.
                var crcTable = makeTable();
                function crc32(crc, buf, len, pos) {
                    var t = crcTable, end = pos + len;
                    crc ^= -1;
                    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
                    return crc ^ -1; // >>> 0;
                }
                module1.exports = crc32;
            /***/ },
            /***/ 24349: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var utils = __webpack_require__(69034);
                var trees = __webpack_require__(70376);
                var adler32 = __webpack_require__(51475);
                var crc32 = __webpack_require__(38621);
                var msg = __webpack_require__(44594);
                /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
                var Z_PARTIAL_FLUSH = 1;
                //var Z_SYNC_FLUSH    = 2;
                var Z_FULL_FLUSH = 3;
                var Z_FINISH = 4;
                var Z_BLOCK = 5;
                //var Z_TREES         = 6;
                /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
                var Z_STREAM_END = 1;
                //var Z_NEED_DICT     = 2;
                //var Z_ERRNO         = -1;
                var Z_STREAM_ERROR = -2;
                var Z_DATA_ERROR = -3;
                //var Z_MEM_ERROR     = -4;
                var Z_BUF_ERROR = -5;
                //var Z_VERSION_ERROR = -6;
                /* compression levels */ //var Z_NO_COMPRESSION      = 0;
                //var Z_BEST_SPEED          = 1;
                //var Z_BEST_COMPRESSION    = 9;
                var Z_DEFAULT_COMPRESSION = -1;
                var Z_FILTERED = 1;
                var Z_HUFFMAN_ONLY = 2;
                var Z_RLE = 3;
                var Z_FIXED = 4;
                var Z_DEFAULT_STRATEGY = 0;
                /* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
                //var Z_TEXT                = 1;
                //var Z_ASCII               = 1; // = Z_TEXT
                var Z_UNKNOWN = 2;
                /* The deflate compression method */ var Z_DEFLATED = 8;
                /*============================================================================*/ var MAX_MEM_LEVEL = 9;
                /* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
                /* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
                var LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
                /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
                /* number of distance codes */ var BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ var MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
                var MAX_MATCH = 258;
                var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
                var PRESET_DICT = 0x20;
                var INIT_STATE = 42;
                var EXTRA_STATE = 69;
                var NAME_STATE = 73;
                var COMMENT_STATE = 91;
                var HCRC_STATE = 103;
                var BUSY_STATE = 113;
                var FINISH_STATE = 666;
                var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
                var BS_BLOCK_DONE = 2; /* block flush performed */ 
                var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
                var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
                var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
                function err(strm, errorCode) {
                    strm.msg = msg[errorCode];
                    return errorCode;
                }
                function rank(f) {
                    return (f << 1) - (f > 4 ? 9 : 0);
                }
                function zero(buf) {
                    var len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                /* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
                    var s = strm.state;
                    //_tr_flush_bits(s);
                    var len = s.pending;
                    if (len > strm.avail_out) len = strm.avail_out;
                    if (len === 0) return;
                    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
                    strm.next_out += len;
                    s.pending_out += len;
                    strm.total_out += len;
                    strm.avail_out -= len;
                    s.pending -= len;
                    if (s.pending === 0) s.pending_out = 0;
                }
                function flush_block_only(s, last) {
                    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
                    s.block_start = s.strstart;
                    flush_pending(s.strm);
                }
                function put_byte(s, b) {
                    s.pending_buf[s.pending++] = b;
                }
                /* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
                    //  put_byte(s, (Byte)(b >> 8));
                    //  put_byte(s, (Byte)(b & 0xff));
                    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
                    s.pending_buf[s.pending++] = b & 0xff;
                }
                /* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
                    var len = strm.avail_in;
                    if (len > size) len = size;
                    if (len === 0) return 0;
                    strm.avail_in -= len;
                    // zmemcpy(buf, strm->next_in, len);
                    utils.arraySet(buf, strm.input, strm.next_in, len, start);
                    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
                    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
                    strm.next_in += len;
                    strm.total_in += len;
                    return len;
                }
                /* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
                    var chain_length = s.max_chain_length; /* max hash chain length */ 
                    var scan = s.strstart; /* current string */ 
                    var match; /* matched string */ 
                    var len; /* length of current match */ 
                    var best_len = s.prev_length; /* best match length so far */ 
                    var nice_match = s.nice_match; /* stop if match long enough */ 
                    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
                    var _win = s.window; // shortcut
                    var wmask = s.w_mask;
                    var prev = s.prev;
                    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
                    var scan_end1 = _win[scan + best_len - 1];
                    var scan_end = _win[scan + best_len];
                    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
                    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
                    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
                    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
                    do {
                        // Assert(cur_match < s->strstart, "no future");
                        match = cur_match;
                        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
                        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
                        match++;
                        // Assert(*scan == *match, "match[2]?");
                        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
                        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
                        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                        len = MAX_MATCH - (strend - scan);
                        scan = strend - MAX_MATCH;
                        if (len > best_len) {
                            s.match_start = cur_match;
                            best_len = len;
                            if (len >= nice_match) break;
                            scan_end1 = _win[scan + best_len - 1];
                            scan_end = _win[scan + best_len];
                        }
                    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
                    if (best_len <= s.lookahead) return best_len;
                    return s.lookahead;
                }
                /* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
                    var _w_size = s.w_size;
                    var p, n, m, more, str;
                    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
                    do {
                        more = s.window_size - s.lookahead - s.strstart;
                        // JS ints have 32 bit, block below not needed
                        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
                        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                        //        more = wsize;
                        //
                        //  } else if (more == (unsigned)(-1)) {
                        //        /* Very unlikely, but possible on 16 bit machine if
                        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                        //         */
                        //        more--;
                        //    }
                        //}
                        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
                            s.match_start -= _w_size;
                            s.strstart -= _w_size;
                            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
                            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
                            p = n;
                            do {
                                m = s.head[--p];
                                s.head[p] = m >= _w_size ? m - _w_size : 0;
                            }while (--n);
                            n = _w_size;
                            p = n;
                            do {
                                m = s.prev[--p];
                                s.prev[p] = m >= _w_size ? m - _w_size : 0;
                            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
                            more += _w_size;
                        }
                        if (s.strm.avail_in === 0) break;
                        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
                        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                        s.lookahead += n;
                        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
                            str = s.strstart - s.insert;
                            s.ins_h = s.window[str];
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
                            //#if MIN_MATCH != 3
                            //        Call update_hash() MIN_MATCH-3 more times
                            //#endif
                            while(s.insert){
                                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                                s.prev[str & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = str;
                                str++;
                                s.insert--;
                                if (s.lookahead + s.insert < MIN_MATCH) break;
                            }
                        }
                    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
                /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
                //    var curr = s.strstart + s.lookahead;
                //    var init = 0;
                //
                //    if (s.high_water < curr) {
                //      /* Previous high water mark below current data -- zero WIN_INIT
                //       * bytes or up to end of window, whichever is less.
                //       */
                //      init = s.window_size - curr;
                //      if (init > WIN_INIT)
                //        init = WIN_INIT;
                //      zmemzero(s->window + curr, (unsigned)init);
                //      s->high_water = curr + init;
                //    }
                //    else if (s->high_water < (ulg)curr + WIN_INIT) {
                //      /* High water mark at or above current data, but below current data
                //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
                //       * to end of window, whichever is less.
                //       */
                //      init = (ulg)curr + WIN_INIT - s->high_water;
                //      if (init > s->window_size - s->high_water)
                //        init = s->window_size - s->high_water;
                //      zmemzero(s->window + s->high_water, (unsigned)init);
                //      s->high_water += init;
                //    }
                //  }
                //
                //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
                //    "not enough room for search");
                }
                /* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
                    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
                    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
                    /* Copy as much as possible from input to output: */ for(;;){
                        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
                            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                            //  s->block_start >= (long)s->w_size, "slide too late");
                            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                            //        s.block_start >= s.w_size)) {
                            //        throw  new Error("slide too late");
                            //      }
                            fill_window(s);
                            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                        /* flush the current block */ }
                        //Assert(s->block_start >= 0L, "block gone");
                        //    if (s.block_start < 0) throw new Error("block gone");
                        s.strstart += s.lookahead;
                        s.lookahead = 0;
                        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
                        if (s.strstart === 0 || s.strstart >= max_start) {
                            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
                            s.strstart = max_start;
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.strstart > s.block_start) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_NEED_MORE;
                }
                /* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
                    var hash_head; /* head of the hash chain */ 
                    var bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break; /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                        if (s.match_length >= MIN_MATCH) {
                            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                                s.match_length--; /* string at strstart already in table */ 
                                do {
                                    s.strstart++;
                                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                    s.head[s.ins_h] = s.strstart;
                                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                                s.strstart++;
                            } else {
                                s.strstart += s.match_length;
                                s.match_length = 0;
                                s.ins_h = s.window[s.strstart];
                                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
                            //#if MIN_MATCH != 3
                            //                Call UPDATE_HASH() MIN_MATCH-3 more times
                            //#endif
                            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
                    var hash_head; /* head of hash chain */ 
                    var bflush; /* set if current block must be flushed */ 
                    var max_insert;
                    /* Process the input block. */ for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
                        s.prev_match = s.match_start;
                        s.match_length = MIN_MATCH - 1;
                        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
                        }
                        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
                            max_insert = s.strstart + s.lookahead - MIN_MATCH;
                            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
                            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
                            s.prev_length -= 2;
                            do if (++s.strstart <= max_insert) {
                                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = s.strstart;
                            /***/ }
                            while (--s.prev_length !== 0);
                            s.match_available = 0;
                            s.match_length = MIN_MATCH - 1;
                            s.strstart++;
                            if (bflush) {
                                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                                if (s.strm.avail_out === 0) return BS_NEED_MORE;
                            /***/ }
                        } else if (s.match_available) {
                            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
                            s.strstart++;
                            s.lookahead--;
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        } else {
                            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
                            s.strstart++;
                            s.lookahead--;
                        }
                    }
                    //Assert (flush != Z_NO_FLUSH, "no flush?");
                    if (s.match_available) {
                        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                        s.match_available = 0;
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
                    var bflush; /* set if current block must be flushed */ 
                    var prev; /* byte at distance one to match */ 
                    var scan, strend; /* scan goes up to strend for length of run */ 
                    var _win = s.window;
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
                            fill_window(s);
                            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* See how many times the previous byte repeats */ s.match_length = 0;
                        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                            scan = s.strstart - 1;
                            prev = _win[scan];
                            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                                strend = s.strstart + MAX_MATCH;
                                do ;
                                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                                s.match_length = MAX_MATCH - (strend - scan);
                                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
                            }
                        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                        }
                        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
                            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
                            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            s.strstart += s.match_length;
                            s.match_length = 0;
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
                    var bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
                            fill_window(s);
                            if (s.lookahead === 0) {
                                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                                break; /* flush the current block */ 
                            }
                        }
                        /* Output a literal byte */ s.match_length = 0;
                        //Tracevv((stderr,"%c", s->window[s->strstart]));
                        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                        s.lookahead--;
                        s.strstart++;
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
                    this.good_length = good_length;
                    this.max_lazy = max_lazy;
                    this.nice_length = nice_length;
                    this.max_chain = max_chain;
                    this.func = func;
                }
                var configuration_table;
                configuration_table = [
                    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
                    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
                    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
                    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
                    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
                    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
                    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
                    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
                    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
                    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
                ];
                /* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
                    s.window_size = 2 * s.w_size;
                    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
                    s.good_match = configuration_table[s.level].good_length;
                    s.nice_match = configuration_table[s.level].nice_length;
                    s.max_chain_length = configuration_table[s.level].max_chain;
                    s.strstart = 0;
                    s.block_start = 0;
                    s.lookahead = 0;
                    s.insert = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    s.ins_h = 0;
                }
                function DeflateState() {
                    this.strm = null; /* pointer back to this zlib stream */ 
                    this.status = 0; /* as the name implies */ 
                    this.pending_buf = null; /* output still pending */ 
                    this.pending_buf_size = 0; /* size of pending_buf */ 
                    this.pending_out = 0; /* next pending byte to output to the stream */ 
                    this.pending = 0; /* nb of bytes in the pending buffer */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.gzhead = null; /* gzip header information to write */ 
                    this.gzindex = 0; /* where in extra, name, or comment */ 
                    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
                    this.last_flush = -1; /* value of flush param for previous deflate call */ 
                    this.w_size = 0; /* LZ77 window size (32K by default) */ 
                    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
                    this.w_mask = 0; /* w_size - 1 */ 
                    this.window = null;
                    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
                    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
                    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
                    this.ins_h = 0; /* hash index of string to be inserted */ 
                    this.hash_size = 0; /* number of elements in hash table */ 
                    this.hash_bits = 0; /* log2(hash_size) */ 
                    this.hash_mask = 0; /* hash_size-1 */ 
                    this.hash_shift = 0;
                    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
                    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
                    this.prev_match = 0; /* previous match */ 
                    this.match_available = 0; /* set if previous match exists */ 
                    this.strstart = 0; /* start of string to insert */ 
                    this.match_start = 0; /* start of matching string */ 
                    this.lookahead = 0; /* number of valid bytes ahead in window */ 
                    this.prev_length = 0;
                    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
                    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
                    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
                    //this.max_insert_length = 0;
                    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
                    this.strategy = 0; /* favor or force Huffman coding*/ 
                    this.good_match = 0;
                    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
                    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
                    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
                    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
                    // Use flat array of DOUBLE size, with interleaved fata,
                    // because JS does not support effective
                    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
                    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
                    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
                    zero(this.dyn_ltree);
                    zero(this.dyn_dtree);
                    zero(this.bl_tree);
                    this.l_desc = null; /* desc. for literal tree */ 
                    this.d_desc = null; /* desc. for distance tree */ 
                    this.bl_desc = null; /* desc. for bit length tree */ 
                    //ush bl_count[MAX_BITS+1];
                    this.bl_count = new utils.Buf16(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
                    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
                    zero(this.heap);
                    this.heap_len = 0; /* number of elements in the heap */ 
                    this.heap_max = 0; /* element of largest frequency */ 
                    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
                    zero(this.depth);
                    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
                    this.lit_bufsize = 0;
                    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
                    this.d_buf = 0;
                    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
                    this.static_len = 0; /* bit length of current block with static trees */ 
                    this.matches = 0; /* number of string matches in current block */ 
                    this.insert = 0; /* bytes at end of window left to insert */ 
                    this.bi_buf = 0;
                    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
                /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
                // sense only for pointers and memory check tools.
                //this.high_water = 0;
                /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
                function deflateResetKeep(strm) {
                    var s;
                    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
                    strm.total_in = strm.total_out = 0;
                    strm.data_type = Z_UNKNOWN;
                    s = strm.state;
                    s.pending = 0;
                    s.pending_out = 0;
                    if (s.wrap < 0) s.wrap = -s.wrap;
                    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
                    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
                     : 1; // adler32(0, Z_NULL, 0)
                    s.last_flush = Z_NO_FLUSH;
                    trees._tr_init(s);
                    return Z_OK;
                }
                function deflateReset(strm) {
                    var ret = deflateResetKeep(strm);
                    if (ret === Z_OK) lm_init(strm.state);
                    return ret;
                }
                function deflateSetHeader(strm, head) {
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
                    strm.state.gzhead = head;
                    return Z_OK;
                }
                function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
                    if (!strm) return Z_STREAM_ERROR;
                    var wrap = 1;
                    if (level === Z_DEFAULT_COMPRESSION) level = 6;
                    if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else if (windowBits > 15) {
                        wrap = 2; /* write gzip wrapper instead */ 
                        windowBits -= 16;
                    }
                    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
                    if (windowBits === 8) windowBits = 9;
                    /* until 256-byte window bug fixed */ var s = new DeflateState();
                    strm.state = s;
                    s.strm = strm;
                    s.wrap = wrap;
                    s.gzhead = null;
                    s.w_bits = windowBits;
                    s.w_size = 1 << s.w_bits;
                    s.w_mask = s.w_size - 1;
                    s.hash_bits = memLevel + 7;
                    s.hash_size = 1 << s.hash_bits;
                    s.hash_mask = s.hash_size - 1;
                    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
                    s.window = new utils.Buf8(s.w_size * 2);
                    s.head = new utils.Buf16(s.hash_size);
                    s.prev = new utils.Buf16(s.w_size);
                    // Don't need mem init magic for JS.
                    //s.high_water = 0;  /* nothing written to s->window yet */
                    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
                    s.pending_buf_size = s.lit_bufsize * 4;
                    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
                    //s->pending_buf = (uchf *) overlay;
                    s.pending_buf = new utils.Buf8(s.pending_buf_size);
                    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
                    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
                    s.d_buf = 1 * s.lit_bufsize;
                    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
                    s.l_buf = 3 * s.lit_bufsize;
                    s.level = level;
                    s.strategy = strategy;
                    s.method = method;
                    return deflateReset(strm);
                }
                function deflateInit(strm, level) {
                    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
                }
                function deflate(strm, flush) {
                    var old_flush, s;
                    var beg, val; // for gzip header write only
                    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
                    s = strm.state;
                    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
                    s.strm = strm; /* just in case */ 
                    old_flush = s.last_flush;
                    s.last_flush = flush;
                    /* Write the header */ if (s.status === INIT_STATE) {
                        if (s.wrap === 2) {
                            strm.adler = 0; //crc32(0L, Z_NULL, 0);
                            put_byte(s, 31);
                            put_byte(s, 139);
                            put_byte(s, 8);
                            if (!s.gzhead) {
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                                put_byte(s, OS_CODE);
                                s.status = BUSY_STATE;
                            } else {
                                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                                put_byte(s, s.gzhead.time & 0xff);
                                put_byte(s, s.gzhead.time >> 8 & 0xff);
                                put_byte(s, s.gzhead.time >> 16 & 0xff);
                                put_byte(s, s.gzhead.time >> 24 & 0xff);
                                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                                put_byte(s, s.gzhead.os & 0xff);
                                if (s.gzhead.extra && s.gzhead.extra.length) {
                                    put_byte(s, s.gzhead.extra.length & 0xff);
                                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                                }
                                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                                s.gzindex = 0;
                                s.status = EXTRA_STATE;
                            }
                        } else {
                            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
                            var level_flags = -1;
                            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
                            else if (s.level < 6) level_flags = 1;
                            else if (s.level === 6) level_flags = 2;
                            else level_flags = 3;
                            header |= level_flags << 6;
                            if (s.strstart !== 0) header |= PRESET_DICT;
                            header += 31 - header % 31;
                            s.status = BUSY_STATE;
                            putShortMSB(s, header);
                            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                                putShortMSB(s, strm.adler >>> 16);
                                putShortMSB(s, strm.adler & 0xffff);
                            }
                            strm.adler = 1; // adler32(0L, Z_NULL, 0);
                        }
                    }
                    //#ifdef GZIP
                    if (s.status === EXTRA_STATE) {
                        if (s.gzhead.extra /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) break;
                                }
                                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                                s.gzindex++;
                            }
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (s.gzindex === s.gzhead.extra.length) {
                                s.gzindex = 0;
                                s.status = NAME_STATE;
                            }
                        } else s.status = NAME_STATE;
                    }
                    if (s.status === NAME_STATE) {
                        if (s.gzhead.name /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            //int val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) {
                                        val = 1;
                                        break;
                                    }
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (val === 0) {
                                s.gzindex = 0;
                                s.status = COMMENT_STATE;
                            }
                        } else s.status = COMMENT_STATE;
                    }
                    if (s.status === COMMENT_STATE) {
                        if (s.gzhead.comment /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            //int val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) {
                                        val = 1;
                                        break;
                                    }
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (val === 0) s.status = HCRC_STATE;
                        } else s.status = HCRC_STATE;
                    }
                    if (s.status === HCRC_STATE) {
                        if (s.gzhead.hcrc) {
                            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
                            if (s.pending + 2 <= s.pending_buf_size) {
                                put_byte(s, strm.adler & 0xff);
                                put_byte(s, strm.adler >> 8 & 0xff);
                                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                                s.status = BUSY_STATE;
                            }
                        } else s.status = BUSY_STATE;
                    }
                    //#endif
                    /* Flush as much pending output as possible */ if (s.pending !== 0) {
                        flush_pending(strm);
                        if (strm.avail_out === 0) {
                            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
                            return Z_OK;
                        }
                    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
                    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
                    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
                        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
                        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
                        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                            if (strm.avail_out === 0) s.last_flush = -1;
                            return Z_OK;
                        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
                        if (bstate === BS_BLOCK_DONE) {
                            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
                            else if (flush !== Z_BLOCK) {
                                trees._tr_stored_block(s, 0, 0, false);
                                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                                    if (s.lookahead === 0) {
                                        s.strstart = 0;
                                        s.block_start = 0;
                                        s.insert = 0;
                                    }
                                }
                            }
                            flush_pending(strm);
                            if (strm.avail_out === 0) {
                                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                                return Z_OK;
                            }
                        }
                    }
                    //Assert(strm->avail_out > 0, "bug2");
                    //if (strm.avail_out <= 0) { throw new Error("bug2");}
                    if (flush !== Z_FINISH) return Z_OK;
                    if (s.wrap <= 0) return Z_STREAM_END;
                    /* Write the trailer */ if (s.wrap === 2) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, strm.adler >> 8 & 0xff);
                        put_byte(s, strm.adler >> 16 & 0xff);
                        put_byte(s, strm.adler >> 24 & 0xff);
                        put_byte(s, strm.total_in & 0xff);
                        put_byte(s, strm.total_in >> 8 & 0xff);
                        put_byte(s, strm.total_in >> 16 & 0xff);
                        put_byte(s, strm.total_in >> 24 & 0xff);
                    } else {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    flush_pending(strm);
                    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
                    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
                }
                function deflateEnd(strm) {
                    var status;
                    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                    status = strm.state.status;
                    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
                    strm.state = null;
                    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
                }
                /* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
                    var dictLength = dictionary.length;
                    var s;
                    var str, n;
                    var wrap;
                    var avail;
                    var next;
                    var input;
                    var tmpDict;
                    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                    s = strm.state;
                    wrap = s.wrap;
                    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
                    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
                    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
                    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
                        if (wrap === 0) {
                            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                            s.strstart = 0;
                            s.block_start = 0;
                            s.insert = 0;
                        }
                        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
                        tmpDict = new utils.Buf8(s.w_size);
                        utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
                        dictionary = tmpDict;
                        dictLength = s.w_size;
                    }
                    /* insert dictionary into window and hash */ avail = strm.avail_in;
                    next = strm.next_in;
                    input = strm.input;
                    strm.avail_in = dictLength;
                    strm.next_in = 0;
                    strm.input = dictionary;
                    fill_window(s);
                    while(s.lookahead >= MIN_MATCH){
                        str = s.strstart;
                        n = s.lookahead - (MIN_MATCH - 1);
                        do {
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                            s.prev[str & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = str;
                            str++;
                        }while (--n);
                        s.strstart = str;
                        s.lookahead = MIN_MATCH - 1;
                        fill_window(s);
                    }
                    s.strstart += s.lookahead;
                    s.block_start = s.strstart;
                    s.insert = s.lookahead;
                    s.lookahead = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    strm.next_in = next;
                    strm.input = input;
                    strm.avail_in = avail;
                    s.wrap = wrap;
                    return Z_OK;
                }
                exports.deflateInit = deflateInit;
                exports.deflateInit2 = deflateInit2;
                exports.deflateReset = deflateReset;
                exports.deflateResetKeep = deflateResetKeep;
                exports.deflateSetHeader = deflateSetHeader;
                exports.deflate = deflate;
                exports.deflateEnd = deflateEnd;
                exports.deflateSetDictionary = deflateSetDictionary;
                exports.deflateInfo = "pako deflate (from Nodeca project)";
            /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ /***/ },
            /***/ 63394: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                // See state defs from inflate.js
                var BAD = 30; /* got a data error -- remain here until reset */ 
                var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
                /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module1.exports = function inflate_fast(strm, start) {
                    var state;
                    var _in; /* local strm.input */ 
                    var last; /* have enough input while in < last */ 
                    var _out; /* local strm.output */ 
                    var beg; /* inflate()'s initial strm.output */ 
                    var end; /* while out < end, enough space available */ 
                    //#ifdef INFLATE_STRICT
                    var dmax; /* maximum distance from zlib header */ 
                    //#endif
                    var wsize; /* window size or zero if not using window */ 
                    var whave; /* valid bytes in the window */ 
                    var wnext; /* window write index */ 
                    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
                    var s_window; /* allocated sliding window, if wsize != 0 */ 
                    var hold; /* local strm.hold */ 
                    var bits; /* local strm.bits */ 
                    var lcode; /* local strm.lencode */ 
                    var dcode; /* local strm.distcode */ 
                    var lmask; /* mask for first level of length codes */ 
                    var dmask; /* mask for first level of distance codes */ 
                    var here; /* retrieved table entry */ 
                    var op; /* code bits, operation, extra bits, or */ 
                    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
                    var dist; /* match distance */ 
                    var from; /* where to copy match from */ 
                    var from_source;
                    var input, output; // JS specific, because we have no pointers
                    /* copy state to local variables */ state = strm.state;
                    //here = state.here;
                    _in = strm.next_in;
                    input = strm.input;
                    last = _in + (strm.avail_in - 5);
                    _out = strm.next_out;
                    output = strm.output;
                    beg = _out - (start - strm.avail_out);
                    end = _out + (strm.avail_out - 257);
                    //#ifdef INFLATE_STRICT
                    dmax = state.dmax;
                    //#endif
                    wsize = state.wsize;
                    whave = state.whave;
                    wnext = state.wnext;
                    s_window = state.window;
                    hold = state.hold;
                    bits = state.bits;
                    lcode = state.lencode;
                    dcode = state.distcode;
                    lmask = (1 << state.lenbits) - 1;
                    dmask = (1 << state.distbits) - 1;
                    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
                        if (bits < 15) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            hold += input[_in++] << bits;
                            bits += 8;
                        }
                        here = lcode[hold & lmask];
                        dolen: for(;;){
                            op = here >>> 24 /*here.bits*/ ;
                            hold >>>= op;
                            bits -= op;
                            op = here >>> 16 & 0xff /*here.op*/ ;
                            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                            //        "inflate:         literal '%c'\n" :
                            //        "inflate:         literal 0x%02x\n", here.val));
                            output[_out++] = here & 0xffff /*here.val*/ ;
                            else if (op & 16) {
                                len = here & 0xffff /*here.val*/ ;
                                op &= 15; /* number of extra bits */ 
                                if (op) {
                                    if (bits < op) {
                                        hold += input[_in++] << bits;
                                        bits += 8;
                                    }
                                    len += hold & (1 << op) - 1;
                                    hold >>>= op;
                                    bits -= op;
                                }
                                //Tracevv((stderr, "inflate:         length %u\n", len));
                                if (bits < 15) {
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                }
                                here = dcode[hold & dmask];
                                dodist: for(;;){
                                    op = here >>> 24 /*here.bits*/ ;
                                    hold >>>= op;
                                    bits -= op;
                                    op = here >>> 16 & 0xff /*here.op*/ ;
                                    if (op & 16) {
                                        dist = here & 0xffff /*here.val*/ ;
                                        op &= 15; /* number of extra bits */ 
                                        if (bits < op) {
                                            hold += input[_in++] << bits;
                                            bits += 8;
                                            if (bits < op) {
                                                hold += input[_in++] << bits;
                                                bits += 8;
                                            }
                                        }
                                        dist += hold & (1 << op) - 1;
                                        //#ifdef INFLATE_STRICT
                                        if (dist > dmax) {
                                            strm.msg = "invalid distance too far back";
                                            state.mode = BAD;
                                            break top;
                                        }
                                        //#endif
                                        hold >>>= op;
                                        bits -= op;
                                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                                        op = _out - beg; /* max distance in output */ 
                                        if (dist > op) {
                                            op = dist - op; /* distance back in window */ 
                                            if (op > whave) {
                                                if (state.sane) {
                                                    strm.msg = "invalid distance too far back";
                                                    state.mode = BAD;
                                                    break top;
                                                }
                                            }
                                            from = 0; // window index
                                            from_source = s_window;
                                            if (wnext === 0) {
                                                from += wsize - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            } else if (wnext < op) {
                                                from += wsize + wnext - op;
                                                op -= wnext;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = 0;
                                                    if (wnext < len) {
                                                        op = wnext;
                                                        len -= op;
                                                        do output[_out++] = s_window[from++];
                                                        while (--op);
                                                        from = _out - dist; /* rest from output */ 
                                                        from_source = output;
                                                    }
                                                }
                                            } else {
                                                from += wnext - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            }
                                            while(len > 2){
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                len -= 3;
                                            }
                                            if (len) {
                                                output[_out++] = from_source[from++];
                                                if (len > 1) output[_out++] = from_source[from++];
                                            }
                                        } else {
                                            from = _out - dist; /* copy direct from output */ 
                                            do {
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                len -= 3;
                                            }while (len > 2);
                                            if (len) {
                                                output[_out++] = output[from++];
                                                if (len > 1) output[_out++] = output[from++];
                                            }
                                        }
                                    } else if ((op & 64) === 0) {
                                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                        continue dodist;
                                    } else {
                                        strm.msg = "invalid distance code";
                                        state.mode = BAD;
                                        break top;
                                    }
                                    break; // need to emulate goto via "continue"
                                }
                            } else if ((op & 64) === 0) {
                                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                continue dolen;
                            } else if (op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.mode = TYPE;
                                break top;
                            } else {
                                strm.msg = "invalid literal/length code";
                                state.mode = BAD;
                                break top;
                            }
                            break; // need to emulate goto via "continue"
                        }
                    }while (_in < last && _out < end);
                    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
                    _in -= len;
                    bits -= len << 3;
                    hold &= (1 << bits) - 1;
                    /* update state and return */ strm.next_in = _in;
                    strm.next_out = _out;
                    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
                    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
                    state.hold = hold;
                    state.bits = bits;
                    return;
                };
            /***/ },
            /***/ 3386: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var utils = __webpack_require__(69034);
                var adler32 = __webpack_require__(51475);
                var crc32 = __webpack_require__(38621);
                var inflate_fast = __webpack_require__(63394);
                var inflate_table = __webpack_require__(20598);
                var CODES = 0;
                var LENS = 1;
                var DISTS = 2;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
                //var Z_PARTIAL_FLUSH = 1;
                //var Z_SYNC_FLUSH    = 2;
                //var Z_FULL_FLUSH    = 3;
                var Z_FINISH = 4;
                var Z_BLOCK = 5;
                var Z_TREES = 6;
                /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
                var Z_STREAM_END = 1;
                var Z_NEED_DICT = 2;
                //var Z_ERRNO         = -1;
                var Z_STREAM_ERROR = -2;
                var Z_DATA_ERROR = -3;
                var Z_MEM_ERROR = -4;
                var Z_BUF_ERROR = -5;
                //var Z_VERSION_ERROR = -6;
                /* The deflate compression method */ var Z_DEFLATED = 8;
                /* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
                var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
                var TIME = 3; /* i: waiting for modification time (gzip) */ 
                var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
                var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
                var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
                var NAME = 7; /* i: waiting for end of file name (gzip) */ 
                var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
                var HCRC = 9; /* i: waiting for header crc (gzip) */ 
                var DICTID = 10; /* i: waiting for dictionary check value */ 
                var DICT = 11; /* waiting for inflateSetDictionary() call */ 
                var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
                var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
                var STORED = 14; /* i: waiting for stored size (length and complement) */ 
                var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
                var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
                var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
                var LENLENS = 18; /* i: waiting for code length code lengths */ 
                var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
                var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
                var LEN = 21; /* i: waiting for length/lit/eob code */ 
                var LENEXT = 22; /* i: waiting for length extra bits */ 
                var DIST = 23; /* i: waiting for distance code */ 
                var DISTEXT = 24; /* i: waiting for distance extra bits */ 
                var MATCH = 25; /* o: waiting for output space to copy string */ 
                var LIT = 26; /* o: waiting for output space to write literal */ 
                var CHECK = 27; /* i: waiting for 32-bit check value */ 
                var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
                var DONE = 29; /* finished check, done -- remain here until reset */ 
                var BAD = 30; /* got a data error -- remain here until reset */ 
                var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
                var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
                /* ===========================================================================*/ var ENOUGH_LENS = 852;
                var ENOUGH_DISTS = 592;
                //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
                var MAX_WBITS = 15;
                /* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
                function zswap32(q) {
                    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
                }
                function InflateState() {
                    this.mode = 0; /* current inflate mode */ 
                    this.last = false; /* true if processing last block */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.havedict = false; /* true if dictionary provided */ 
                    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
                    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
                    this.check = 0; /* protected copy of check value */ 
                    this.total = 0; /* protected copy of output count */ 
                    // TODO: may be {}
                    this.head = null; /* where to save gzip header information */ 
                    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
                    this.wsize = 0; /* window size or zero if not using window */ 
                    this.whave = 0; /* valid bytes in the window */ 
                    this.wnext = 0; /* window write index */ 
                    this.window = null; /* allocated sliding window, if needed */ 
                    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
                    this.bits = 0; /* number of bits in "in" */ 
                    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
                    this.offset = 0; /* distance back to copy string from */ 
                    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
                    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
                    this.distcode = null; /* starting table for distance codes */ 
                    this.lenbits = 0; /* index bits for lencode */ 
                    this.distbits = 0; /* index bits for distcode */ 
                    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
                    this.nlen = 0; /* number of length code lengths */ 
                    this.ndist = 0; /* number of distance code lengths */ 
                    this.have = 0; /* number of code lengths in lens[] */ 
                    this.next = null; /* next available space in codes[] */ 
                    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
                    this.work = new utils.Buf16(288); /* work area for code table building */ 
                    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
                    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
                    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
                    this.sane = 0; /* if false, allow invalid distance too far */ 
                    this.back = 0; /* bits back of last unprocessed length/lit */ 
                    this.was = 0; /* initial length of match */ 
                }
                function inflateResetKeep(strm) {
                    var state;
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    strm.total_in = strm.total_out = state.total = 0;
                    strm.msg = ""; /*Z_NULL*/ 
                    if (state.wrap) strm.adler = state.wrap & 1;
                    state.mode = HEAD;
                    state.last = 0;
                    state.havedict = 0;
                    state.dmax = 32768;
                    state.head = null /*Z_NULL*/ ;
                    state.hold = 0;
                    state.bits = 0;
                    //state.lencode = state.distcode = state.next = state.codes;
                    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
                    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
                    state.sane = 1;
                    state.back = -1;
                    //Tracev((stderr, "inflate: reset\n"));
                    return Z_OK;
                }
                function inflateReset(strm) {
                    var state;
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    state.wsize = 0;
                    state.whave = 0;
                    state.wnext = 0;
                    return inflateResetKeep(strm);
                }
                function inflateReset2(strm, windowBits) {
                    var wrap;
                    var state;
                    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else {
                        wrap = (windowBits >> 4) + 1;
                        if (windowBits < 48) windowBits &= 15;
                    }
                    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
                    if (state.window !== null && state.wbits !== windowBits) state.window = null;
                    /* update state and reset the rest of it */ state.wrap = wrap;
                    state.wbits = windowBits;
                    return inflateReset(strm);
                }
                function inflateInit2(strm, windowBits) {
                    var ret;
                    var state;
                    if (!strm) return Z_STREAM_ERROR;
                    //strm.msg = Z_NULL;                 /* in case we return an error */
                    state = new InflateState();
                    //if (state === Z_NULL) return Z_MEM_ERROR;
                    //Tracev((stderr, "inflate: allocated\n"));
                    strm.state = state;
                    state.window = null /*Z_NULL*/ ;
                    ret = inflateReset2(strm, windowBits);
                    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
                    return ret;
                }
                function inflateInit(strm) {
                    return inflateInit2(strm, DEF_WBITS);
                }
                /*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
                var lenfix, distfix; // We have no pointers in JS, so keep tables separate
                function fixedtables(state) {
                    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
                        var sym;
                        lenfix = new utils.Buf32(512);
                        distfix = new utils.Buf32(32);
                        /* literal/length table */ sym = 0;
                        while(sym < 144)state.lens[sym++] = 8;
                        while(sym < 256)state.lens[sym++] = 9;
                        while(sym < 280)state.lens[sym++] = 7;
                        while(sym < 288)state.lens[sym++] = 8;
                        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                            bits: 9
                        });
                        /* distance table */ sym = 0;
                        while(sym < 32)state.lens[sym++] = 5;
                        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                            bits: 5
                        });
                        /* do this just once */ virgin = false;
                    }
                    state.lencode = lenfix;
                    state.lenbits = 9;
                    state.distcode = distfix;
                    state.distbits = 5;
                }
                /*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
                    var dist;
                    var state = strm.state;
                    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
                        state.wsize = 1 << state.wbits;
                        state.wnext = 0;
                        state.whave = 0;
                        state.window = new utils.Buf8(state.wsize);
                    }
                    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
                        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
                        state.wnext = 0;
                        state.whave = state.wsize;
                    } else {
                        dist = state.wsize - state.wnext;
                        if (dist > copy) dist = copy;
                        //zmemcpy(state->window + state->wnext, end - copy, dist);
                        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
                        copy -= dist;
                        if (copy) {
                            //zmemcpy(state->window, end - copy, copy);
                            utils.arraySet(state.window, src, end - copy, copy, 0);
                            state.wnext = copy;
                            state.whave = state.wsize;
                        } else {
                            state.wnext += dist;
                            if (state.wnext === state.wsize) state.wnext = 0;
                            if (state.whave < state.wsize) state.whave += dist;
                        }
                    }
                    return 0;
                }
                function inflate(strm, flush) {
                    var state;
                    var input, output; // input/output buffers
                    var next; /* next input INDEX */ 
                    var put; /* next output INDEX */ 
                    var have, left; /* available input and output */ 
                    var hold; /* bit buffer */ 
                    var bits; /* bits in bit buffer */ 
                    var _in, _out; /* save starting available input and output */ 
                    var copy; /* number of stored or match bytes to copy */ 
                    var from; /* where to copy match bytes from */ 
                    var from_source;
                    var here = 0; /* current decoding table entry */ 
                    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
                    //var last;                   /* parent table entry */
                    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
                    var len; /* length to copy for repeats, bits to drop */ 
                    var ret; /* return code */ 
                    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
                    var opts;
                    var n; // temporary var for NEED_BITS
                    var order = /* permutation of code lengths */ [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
                    state = strm.state;
                    if (state.mode === TYPE) state.mode = TYPEDO;
                     /* skip check */ 
                    //--- LOAD() ---
                    put = strm.next_out;
                    output = strm.output;
                    left = strm.avail_out;
                    next = strm.next_in;
                    input = strm.input;
                    have = strm.avail_in;
                    hold = state.hold;
                    bits = state.bits;
                    //---
                    _in = have;
                    _out = left;
                    ret = Z_OK;
                    inf_leave: for(;;)switch(state.mode){
                        case HEAD:
                            if (state.wrap === 0) {
                                state.mode = TYPEDO;
                                break;
                            }
                            //=== NEEDBITS(16);
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.wrap & 2 && hold === 0x8b1f) {
                                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                                //===//
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                                //===//
                                state.mode = FLAGS;
                                break;
                            }
                            state.flags = 0; /* expect zlib header */ 
                            if (state.head) state.head.done = false;
                            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                                strm.msg = "incorrect header check";
                                state.mode = BAD;
                                break;
                            }
                            if ((hold & 0x0f) !== Z_DEFLATED) {
                                strm.msg = "unknown compression method";
                                state.mode = BAD;
                                break;
                            }
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            len = (hold & 0x0f) + 8;
                            if (state.wbits === 0) state.wbits = len;
                            else if (len > state.wbits) {
                                strm.msg = "invalid window size";
                                state.mode = BAD;
                                break;
                            }
                            state.dmax = 1 << len;
                            //Tracev((stderr, "inflate:   zlib header ok\n"));
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = hold & 0x200 ? DICTID : TYPE;
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            break;
                        case FLAGS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.flags = hold;
                            if ((state.flags & 0xff) !== Z_DEFLATED) {
                                strm.msg = "unknown compression method";
                                state.mode = BAD;
                                break;
                            }
                            if (state.flags & 0xe000) {
                                strm.msg = "unknown header flags set";
                                state.mode = BAD;
                                break;
                            }
                            if (state.head) state.head.text = hold >> 8 & 1;
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = TIME;
                        /* falls through */ case TIME:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) state.head.time = hold;
                            if (state.flags & 0x0200) {
                                //=== CRC4(state.check, hold)
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                hbuf[2] = hold >>> 16 & 0xff;
                                hbuf[3] = hold >>> 24 & 0xff;
                                state.check = crc32(state.check, hbuf, 4, 0);
                            //===
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = OS;
                        /* falls through */ case OS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) {
                                state.head.xflags = hold & 0xff;
                                state.head.os = hold >> 8;
                            }
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = EXLEN;
                        /* falls through */ case EXLEN:
                            if (state.flags & 0x0400) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length = hold;
                                if (state.head) state.head.extra_len = hold;
                                if (state.flags & 0x0200) {
                                    //=== CRC2(state.check, hold);
                                    hbuf[0] = hold & 0xff;
                                    hbuf[1] = hold >>> 8 & 0xff;
                                    state.check = crc32(state.check, hbuf, 2, 0);
                                //===//
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
                            state.mode = EXTRA;
                        /* falls through */ case EXTRA:
                            if (state.flags & 0x0400) {
                                copy = state.length;
                                if (copy > have) copy = have;
                                if (copy) {
                                    if (state.head) {
                                        len = state.head.extra_len - state.length;
                                        if (!state.head.extra) // Use untyped array for more convenient processing later
                                        state.head.extra = new Array(state.head.extra_len);
                                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                                        // - no need for additional size check
                                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                                    //zmemcpy(state.head.extra + len, next,
                                    //        len + copy > state.head.extra_max ?
                                    //        state.head.extra_max - len : copy);
                                    }
                                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                    have -= copy;
                                    next += copy;
                                    state.length -= copy;
                                }
                                if (state.length) break inf_leave;
                            }
                            state.length = 0;
                            state.mode = NAME;
                        /* falls through */ case NAME:
                            if (state.flags & 0x0800) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    // TODO: 2 or 1 bytes?
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.name = null;
                            state.length = 0;
                            state.mode = COMMENT;
                        /* falls through */ case COMMENT:
                            if (state.flags & 0x1000) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.comment = null;
                            state.mode = HCRC;
                        /* falls through */ case HCRC:
                            if (state.flags & 0x0200) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (hold !== (state.check & 0xffff)) {
                                    strm.msg = "header crc mismatch";
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            }
                            if (state.head) {
                                state.head.hcrc = state.flags >> 9 & 1;
                                state.head.done = true;
                            }
                            strm.adler = state.check = 0;
                            state.mode = TYPE;
                            break;
                        case DICTID:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            strm.adler = state.check = zswap32(hold);
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = DICT;
                        /* falls through */ case DICT:
                            if (state.havedict === 0) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                return Z_NEED_DICT;
                            }
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = TYPE;
                        /* falls through */ case TYPE:
                            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
                        /* falls through */ case TYPEDO:
                            if (state.last) {
                                //--- BYTEBITS() ---//
                                hold >>>= bits & 7;
                                bits -= bits & 7;
                                //---//
                                state.mode = CHECK;
                                break;
                            }
                            //=== NEEDBITS(3); */
                            while(bits < 3){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.last = hold & 0x01 /*BITS(1)*/ ;
                            //--- DROPBITS(1) ---//
                            hold >>>= 1;
                            bits -= 1;
                            //---//
                            switch(hold & 0x03){
                                case 0:
                                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = STORED;
                                    break;
                                case 1:
                                    /* fixed block */ fixedtables(state);
                                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = LEN_; /* decode codes */ 
                                    if (flush === Z_TREES) {
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                        break inf_leave;
                                    }
                                    break;
                                case 2:
                                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = TABLE;
                                    break;
                                case 3:
                                    strm.msg = "invalid block type";
                                    state.mode = BAD;
                            }
                            //--- DROPBITS(2) ---//
                            hold >>>= 2;
                            bits -= 2;
                            break;
                        case STORED:
                            //--- BYTEBITS() ---// /* go to byte boundary */
                            hold >>>= bits & 7;
                            bits -= bits & 7;
                            //---//
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                                strm.msg = "invalid stored block lengths";
                                state.mode = BAD;
                                break;
                            }
                            state.length = hold & 0xffff;
                            //Tracev((stderr, "inflate:       stored length %u\n",
                            //        state.length));
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = COPY_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case COPY_:
                            state.mode = COPY;
                        /* falls through */ case COPY:
                            copy = state.length;
                            if (copy) {
                                if (copy > have) copy = have;
                                if (copy > left) copy = left;
                                if (copy === 0) break inf_leave;
                                //--- zmemcpy(put, next, copy); ---
                                utils.arraySet(output, input, next, copy, put);
                                //---//
                                have -= copy;
                                next += copy;
                                left -= copy;
                                put += copy;
                                state.length -= copy;
                                break;
                            }
                            //Tracev((stderr, "inflate:       stored end\n"));
                            state.mode = TYPE;
                            break;
                        case TABLE:
                            //=== NEEDBITS(14); */
                            while(bits < 14){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.nlen = (hold & 0x1f) + 257;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ndist = (hold & 0x1f) + 1;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ncode = (hold & 0x0f) + 4;
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            //#ifndef PKZIP_BUG_WORKAROUND
                            if (state.nlen > 286 || state.ndist > 30) {
                                strm.msg = "too many length or distance symbols";
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracev((stderr, "inflate:       table sizes ok\n"));
                            state.have = 0;
                            state.mode = LENLENS;
                        /* falls through */ case LENLENS:
                            while(state.have < state.ncode){
                                //=== NEEDBITS(3);
                                while(bits < 3){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                                //--- DROPBITS(3) ---//
                                hold >>>= 3;
                                bits -= 3;
                            //---//
                            }
                            while(state.have < 19)state.lens[order[state.have++]] = 0;
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            //state.next = state.codes;
                            //state.lencode = state.next;
                            // Switch to use dynamic table
                            state.lencode = state.lendyn;
                            state.lenbits = 7;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                            state.lenbits = opts.bits;
                            if (ret) {
                                strm.msg = "invalid code lengths set";
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, "inflate:       code lengths ok\n"));
                            state.have = 0;
                            state.mode = CODELENS;
                        /* falls through */ case CODELENS:
                            while(state.have < state.nlen + state.ndist){
                                for(;;){
                                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                if (here_val < 16) {
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    state.lens[state.have++] = here_val;
                                } else {
                                    if (here_val === 16) {
                                        //=== NEEDBITS(here.bits + 2);
                                        n = here_bits + 2;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        if (state.have === 0) {
                                            strm.msg = "invalid bit length repeat";
                                            state.mode = BAD;
                                            break;
                                        }
                                        len = state.lens[state.have - 1];
                                        copy = 3 + (hold & 0x03); //BITS(2);
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                    //---//
                                    } else if (here_val === 17) {
                                        //=== NEEDBITS(here.bits + 3);
                                        n = here_bits + 3;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 3 + (hold & 0x07); //BITS(3);
                                        //--- DROPBITS(3) ---//
                                        hold >>>= 3;
                                        bits -= 3;
                                    //---//
                                    } else {
                                        //=== NEEDBITS(here.bits + 7);
                                        n = here_bits + 7;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 11 + (hold & 0x7f); //BITS(7);
                                        //--- DROPBITS(7) ---//
                                        hold >>>= 7;
                                        bits -= 7;
                                    //---//
                                    }
                                    if (state.have + copy > state.nlen + state.ndist) {
                                        strm.msg = "invalid bit length repeat";
                                        state.mode = BAD;
                                        break;
                                    }
                                    while(copy--)state.lens[state.have++] = len;
                                }
                            }
                            /* handle error breaks in while */ if (state.mode === BAD) break;
                            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                                strm.msg = "invalid code -- missing end-of-block";
                                state.mode = BAD;
                                break;
                            }
                            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.lenbits = opts.bits;
                            // state.lencode = state.next;
                            if (ret) {
                                strm.msg = "invalid literal/lengths set";
                                state.mode = BAD;
                                break;
                            }
                            state.distbits = 6;
                            //state.distcode.copy(state.codes);
                            // Switch to use dynamic table
                            state.distcode = state.distdyn;
                            opts = {
                                bits: state.distbits
                            };
                            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.distbits = opts.bits;
                            // state.distcode = state.next;
                            if (ret) {
                                strm.msg = "invalid distances set";
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, 'inflate:       codes ok\n'));
                            state.mode = LEN_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case LEN_:
                            state.mode = LEN;
                        /* falls through */ case LEN:
                            if (have >= 6 && left >= 258) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                inflate_fast(strm, _out);
                                //--- LOAD() ---
                                put = strm.next_out;
                                output = strm.output;
                                left = strm.avail_out;
                                next = strm.next_in;
                                input = strm.input;
                                have = strm.avail_in;
                                hold = state.hold;
                                bits = state.bits;
                                //---
                                if (state.mode === TYPE) state.back = -1;
                                break;
                            }
                            state.back = 0;
                            for(;;){
                                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if (here_op && (here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            state.length = here_val;
                            if (here_op === 0) {
                                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                                //        "inflate:         literal '%c'\n" :
                                //        "inflate:         literal 0x%02x\n", here.val));
                                state.mode = LIT;
                                break;
                            }
                            if (here_op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.back = -1;
                                state.mode = TYPE;
                                break;
                            }
                            if (here_op & 64) {
                                strm.msg = "invalid literal/length code";
                                state.mode = BAD;
                                break;
                            }
                            state.extra = here_op & 15;
                            state.mode = LENEXT;
                        /* falls through */ case LENEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //Tracevv((stderr, "inflate:         length %u\n", state.length));
                            state.was = state.length;
                            state.mode = DIST;
                        /* falls through */ case DIST:
                            for(;;){
                                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if ((here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            if (here_op & 64) {
                                strm.msg = "invalid distance code";
                                state.mode = BAD;
                                break;
                            }
                            state.offset = here_val;
                            state.extra = here_op & 15;
                            state.mode = DISTEXT;
                        /* falls through */ case DISTEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //#ifdef INFLATE_STRICT
                            if (state.offset > state.dmax) {
                                strm.msg = "invalid distance too far back";
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                            state.mode = MATCH;
                        /* falls through */ case MATCH:
                            if (left === 0) break inf_leave;
                            copy = _out - left;
                            if (state.offset > copy) {
                                copy = state.offset - copy;
                                if (copy > state.whave) {
                                    if (state.sane) {
                                        strm.msg = "invalid distance too far back";
                                        state.mode = BAD;
                                        break;
                                    }
                                }
                                if (copy > state.wnext) {
                                    copy -= state.wnext;
                                    from = state.wsize - copy;
                                } else from = state.wnext - copy;
                                if (copy > state.length) copy = state.length;
                                from_source = state.window;
                            } else {
                                from_source = output;
                                from = put - state.offset;
                                copy = state.length;
                            }
                            if (copy > left) copy = left;
                            left -= copy;
                            state.length -= copy;
                            do output[put++] = from_source[from++];
                            while (--copy);
                            if (state.length === 0) state.mode = LEN;
                            break;
                        case LIT:
                            if (left === 0) break inf_leave;
                            output[put++] = state.length;
                            left--;
                            state.mode = LEN;
                            break;
                        case CHECK:
                            if (state.wrap) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    // Use '|' instead of '+' to make sure that result is signed
                                    hold |= input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                _out -= left;
                                strm.total_out += _out;
                                state.total += _out;
                                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                                _out = left;
                                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                                    strm.msg = "incorrect data check";
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   check matches trailer\n"));
                            }
                            state.mode = LENGTH;
                        /* falls through */ case LENGTH:
                            if (state.wrap && state.flags) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (hold !== (state.total & 0xffffffff)) {
                                    strm.msg = "incorrect length check";
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   length matches trailer\n"));
                            }
                            state.mode = DONE;
                        /* falls through */ case DONE:
                            ret = Z_STREAM_END;
                            break inf_leave;
                        case BAD:
                            ret = Z_DATA_ERROR;
                            break inf_leave;
                        case MEM:
                            return Z_MEM_ERROR;
                        case SYNC:
                        /* falls through */ default:
                            return Z_STREAM_ERROR;
                    }
                    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
                    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
                    strm.next_out = put;
                    strm.avail_out = left;
                    strm.next_in = next;
                    strm.avail_in = have;
                    state.hold = hold;
                    state.bits = bits;
                    //---
                    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
                        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
                            state.mode = MEM;
                            return Z_MEM_ERROR;
                        }
                    }
                    _in -= strm.avail_in;
                    _out -= strm.avail_out;
                    strm.total_in += _in;
                    strm.total_out += _out;
                    state.total += _out;
                    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
                    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
                    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
                    return ret;
                }
                function inflateEnd(strm) {
                    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
                    var state = strm.state;
                    if (state.window) state.window = null;
                    strm.state = null;
                    return Z_OK;
                }
                function inflateGetHeader(strm, head) {
                    var state;
                    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
                    /* save header structure */ state.head = head;
                    head.done = false;
                    return Z_OK;
                }
                function inflateSetDictionary(strm, dictionary) {
                    var dictLength = dictionary.length;
                    var state;
                    var dictid;
                    var ret;
                    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
                    state = strm.state;
                    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
                    /* check for correct dictionary identifier */ if (state.mode === DICT) {
                        dictid = 1; /* adler32(0, null, 0)*/ 
                        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
                        if (dictid !== state.check) return Z_DATA_ERROR;
                    }
                    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
                    if (ret) {
                        state.mode = MEM;
                        return Z_MEM_ERROR;
                    }
                    state.havedict = 1;
                    // Tracev((stderr, "inflate:   dictionary set\n"));
                    return Z_OK;
                }
                exports.inflateReset = inflateReset;
                exports.inflateReset2 = inflateReset2;
                exports.inflateResetKeep = inflateResetKeep;
                exports.inflateInit = inflateInit;
                exports.inflateInit2 = inflateInit2;
                exports.inflate = inflate;
                exports.inflateEnd = inflateEnd;
                exports.inflateGetHeader = inflateGetHeader;
                exports.inflateSetDictionary = inflateSetDictionary;
                exports.inflateInfo = "pako inflate (from Nodeca project)";
            /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ /***/ },
            /***/ 20598: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var utils = __webpack_require__(69034);
                var MAXBITS = 15;
                var ENOUGH_LENS = 852;
                var ENOUGH_DISTS = 592;
                //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
                var CODES = 0;
                var LENS = 1;
                var DISTS = 2;
                var lbase = [
                    /* Length codes 257..285 base */ 3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ];
                var lext = [
                    /* Length codes 257..285 extra */ 16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ];
                var dbase = [
                    /* Distance codes 0..29 base */ 1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ];
                var dext = [
                    /* Distance codes 0..29 extra */ 16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                module1.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
                    var bits = opts.bits;
                    //here = opts.here; /* table entry for duplication */
                    var len = 0; /* a code's length in bits */ 
                    var sym = 0; /* index of code symbols */ 
                    var min = 0, max = 0; /* minimum and maximum code lengths */ 
                    var root = 0; /* number of index bits for root table */ 
                    var curr = 0; /* number of index bits for current table */ 
                    var drop = 0; /* code bits to drop for sub-table */ 
                    var left = 0; /* number of prefix codes available */ 
                    var used = 0; /* code entries in table used */ 
                    var huff = 0; /* Huffman code */ 
                    var incr; /* for incrementing code, index */ 
                    var fill; /* index for replicating entries */ 
                    var low; /* low bits for current root entry */ 
                    var mask; /* mask for low root bits */ 
                    var next; /* next available space in table */ 
                    var base = null; /* base value table to use */ 
                    var base_index = 0;
                    //  var shoextra;    /* extra bits table to use */
                    var end; /* use base and extra for symbol > end */ 
                    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
                    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
                    var extra = null;
                    var extra_index = 0;
                    var here_bits, here_op, here_val;
                    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
                    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
                    /* bound code lengths, force root to be within code lengths */ root = bits;
                    for(max = MAXBITS; max >= 1; max--){
                        if (count[max] !== 0) break;
                    }
                    if (root > max) root = max;
                    if (max === 0) {
                        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
                        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
                        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
                        table[table_index++] = 20971520;
                        //table.op[opts.table_index] = 64;
                        //table.bits[opts.table_index] = 1;
                        //table.val[opts.table_index++] = 0;
                        table[table_index++] = 20971520;
                        opts.bits = 1;
                        return 0; /* no symbols, but wait for decoding to report error */ 
                    }
                    for(min = 1; min < max; min++){
                        if (count[min] !== 0) break;
                    }
                    if (root < min) root = min;
                    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
                    for(len = 1; len <= MAXBITS; len++){
                        left <<= 1;
                        left -= count[len];
                        if (left < 0) return -1;
                         /* over-subscribed */ 
                    }
                    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
                    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
                    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
                    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
                    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
                    // to avoid deopts in old v8
                    if (type === CODES) {
                        base = extra = work; /* dummy value--not used */ 
                        end = 19;
                    } else if (type === LENS) {
                        base = lbase;
                        base_index -= 257;
                        extra = lext;
                        extra_index -= 257;
                        end = 256;
                    } else {
                        base = dbase;
                        extra = dext;
                        end = -1;
                    }
                    /* initialize opts for loop */ huff = 0; /* starting code */ 
                    sym = 0; /* starting code symbol */ 
                    len = min; /* starting code length */ 
                    next = table_index; /* current table to fill in */ 
                    curr = root; /* current table index bits */ 
                    drop = 0; /* current bits to drop from code for index */ 
                    low = -1; /* trigger new sub-table when len > root */ 
                    used = 1 << root; /* use root table entries */ 
                    mask = used - 1; /* mask for comparing low */ 
                    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                    /* process all codes and make table entries */ for(;;){
                        /* create table entry */ here_bits = len - drop;
                        if (work[sym] < end) {
                            here_op = 0;
                            here_val = work[sym];
                        } else if (work[sym] > end) {
                            here_op = extra[extra_index + work[sym]];
                            here_val = base[base_index + work[sym]];
                        } else {
                            here_op = 96; /* end of block */ 
                            here_val = 0;
                        }
                        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
                        fill = 1 << curr;
                        min = fill; /* save offset to next table */ 
                        do {
                            fill -= incr;
                            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
                        }while (fill !== 0);
                        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
                        while(huff & incr)incr >>= 1;
                        if (incr !== 0) {
                            huff &= incr - 1;
                            huff += incr;
                        } else huff = 0;
                        /* go to next symbol, update count, len */ sym++;
                        if (--count[len] === 0) {
                            if (len === max) break;
                            len = lens[lens_index + work[sym]];
                        }
                        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
                            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
                            /* increment past last table */ next += min; /* here min is 1 << curr */ 
                            /* determine length of next table */ curr = len - drop;
                            left = 1 << curr;
                            while(curr + drop < max){
                                left -= count[curr + drop];
                                if (left <= 0) break;
                                curr++;
                                left <<= 1;
                            }
                            /* check for enough space */ used += 1 << curr;
                            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                            /* point entry in root table to sub-table */ low = huff & mask;
                            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
                        }
                    }
                    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
                    //table.bits[next + huff] = len - drop;
                    //table.val[next + huff] = 0;
                    table[next + huff] = len - drop << 24 | 4194304;
                    /* set return parameters */ //opts.table_index += used;
                    opts.bits = root;
                    return 0;
                };
            /***/ },
            /***/ 44594: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                module1.exports = {
                    2: "need dictionary",
                    /* Z_NEED_DICT       2  */ 1: "stream end",
                    /* Z_STREAM_END      1  */ 0: "",
                    /* Z_OK              0  */ "-1": "file error",
                    /* Z_ERRNO         (-1) */ "-2": "stream error",
                    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
                    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
                    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
                    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
                };
            /***/ },
            /***/ 70376: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                /* eslint-disable space-unary-ops */ var utils = __webpack_require__(69034);
                /* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
                //var Z_HUFFMAN_ONLY      = 2;
                //var Z_RLE               = 3;
                var Z_FIXED = 4;
                //var Z_DEFAULT_STRATEGY  = 0;
                /* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
                var Z_TEXT = 1;
                //var Z_ASCII             = 1; // = Z_TEXT
                var Z_UNKNOWN = 2;
                /*============================================================================*/ function zero(buf) {
                    var len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                // From zutil.h
                var STORED_BLOCK = 0;
                var STATIC_TREES = 1;
                var DYN_TREES = 2;
                /* The three kinds of block type */ var MIN_MATCH = 3;
                var MAX_MATCH = 258;
                /* The minimum and maximum match lengths */ // From deflate.h
                /* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
                /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
                /* number of distance codes */ var BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ var MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
                /* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
                /* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
                /* end of block literal code */ var REP_3_6 = 16;
                /* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
                /* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
                /* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ];
                var extra_dbits = /* extra bits for each distance code */ [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ];
                var extra_blbits = /* extra bits for each bit length code */ [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ];
                var bl_order = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ];
                /* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
                var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
                // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
                var static_ltree = new Array((L_CODES + 2) * 2);
                zero(static_ltree);
                /* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
                zero(static_dtree);
                /* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
                zero(_dist_code);
                /* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
                zero(_length_code);
                /* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
                zero(base_length);
                /* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
                zero(base_dist);
                /* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
                    this.static_tree = static_tree; /* static tree or NULL */ 
                    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
                    this.extra_base = extra_base; /* base index for extra_bits */ 
                    this.elems = elems; /* max number of elements in the tree */ 
                    this.max_length = max_length; /* max bit length for the codes */ 
                    // show if `static_tree` has data or dummy - needed for monomorphic objects
                    this.has_stree = static_tree && static_tree.length;
                }
                var static_l_desc;
                var static_d_desc;
                var static_bl_desc;
                function TreeDesc(dyn_tree, stat_desc) {
                    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
                    this.max_code = 0; /* largest code with non zero frequency */ 
                    this.stat_desc = stat_desc; /* the corresponding static tree */ 
                }
                function d_code(dist) {
                    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
                }
                /* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
                    //    put_byte(s, (uch)((w) & 0xff));
                    //    put_byte(s, (uch)((ush)(w) >> 8));
                    s.pending_buf[s.pending++] = w & 0xff;
                    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
                }
                /* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
                    if (s.bi_valid > Buf_size - length) {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        put_short(s, s.bi_buf);
                        s.bi_buf = value >> Buf_size - s.bi_valid;
                        s.bi_valid += length - Buf_size;
                    } else {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        s.bi_valid += length;
                    }
                }
                function send_code(s, c, tree) {
                    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
                }
                /* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
                    var res = 0;
                    do {
                        res |= code & 1;
                        code >>>= 1;
                        res <<= 1;
                    }while (--len > 0);
                    return res >>> 1;
                }
                /* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
                    if (s.bi_valid === 16) {
                        put_short(s, s.bi_buf);
                        s.bi_buf = 0;
                        s.bi_valid = 0;
                    } else if (s.bi_valid >= 8) {
                        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                        s.bi_buf >>= 8;
                        s.bi_valid -= 8;
                    }
                }
                /* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
                //    tree_desc *desc;    /* the tree descriptor */
                {
                    var tree = desc.dyn_tree;
                    var max_code = desc.max_code;
                    var stree = desc.stat_desc.static_tree;
                    var has_stree = desc.stat_desc.has_stree;
                    var extra = desc.stat_desc.extra_bits;
                    var base = desc.stat_desc.extra_base;
                    var max_length = desc.stat_desc.max_length;
                    var h; /* heap index */ 
                    var n, m; /* iterate over the tree elements */ 
                    var bits; /* bit length */ 
                    var xbits; /* extra bits */ 
                    var f; /* frequency */ 
                    var overflow = 0; /* number of elements with bit length too large */ 
                    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
                    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
                    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
                        n = s.heap[h];
                        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
                        if (bits > max_length) {
                            bits = max_length;
                            overflow++;
                        }
                        tree[n * 2 + 1] = bits;
                        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
                         /* not a leaf node */ 
                        s.bl_count[bits]++;
                        xbits = 0;
                        if (n >= base) xbits = extra[n - base];
                        f = tree[n * 2] /*.Freq*/ ;
                        s.opt_len += f * (bits + xbits);
                        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
                    }
                    if (overflow === 0) return;
                    // Trace((stderr,"\nbit length overflow\n"));
                    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
                        bits = max_length - 1;
                        while(s.bl_count[bits] === 0)bits--;
                        s.bl_count[bits]--; /* move one leaf down the tree */ 
                        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
                        s.bl_count[max_length]--;
                        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
                    }while (overflow > 0);
                    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
                        n = s.bl_count[bits];
                        while(n !== 0){
                            m = s.heap[--h];
                            if (m > max_code) continue;
                            if (tree[m * 2 + 1] !== bits) {
                                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                                tree[m * 2 + 1] = bits;
                            }
                            n--;
                        }
                    }
                }
                /* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
                //    int max_code;              /* largest code with non zero frequency */
                //    ushf *bl_count;            /* number of codes at each bit length */
                {
                    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
                    var code = 0; /* running code value */ 
                    var bits; /* bit index */ 
                    var n; /* code index */ 
                    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
                    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
                    //        "inconsistent bit counts");
                    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
                    for(n = 0; n <= max_code; n++){
                        var len = tree[n * 2 + 1] /*.Len*/ ;
                        if (len === 0) continue;
                        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
                    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
                    }
                }
                /* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
                    var n; /* iterates over tree elements */ 
                    var bits; /* bit counter */ 
                    var length; /* length value */ 
                    var code; /* code value */ 
                    var dist; /* distance index */ 
                    var bl_count = new Array(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
                    //if (static_init_done) return;
                    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
                    for(code = 0; code < LENGTH_CODES - 1; code++){
                        base_length[code] = length;
                        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
                    }
                    //Assert (length == 256, "tr_static_init: length != 256");
                    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
                    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
                    for(code = 0; code < 16; code++){
                        base_dist[code] = dist;
                        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: dist != 256");
                    dist >>= 7; /* from now on, all distances are divided by 128 */ 
                    for(; code < D_CODES; code++){
                        base_dist[code] = dist << 7;
                        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
                    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
                    n = 0;
                    while(n <= 143){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    while(n <= 255){
                        static_ltree[n * 2 + 1] = 9;
                        n++;
                        bl_count[9]++;
                    }
                    while(n <= 279){
                        static_ltree[n * 2 + 1] = 7;
                        n++;
                        bl_count[7]++;
                    }
                    while(n <= 287){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
                    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
                        static_dtree[n * 2 + 1] = 5;
                        static_dtree[n * 2] = bi_reverse(n, 5);
                    }
                    // Now data ready and we can init static trees
                    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
                    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
                    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
                //static_init_done = true;
                }
                /* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
                    var n; /* iterates over tree elements */ 
                    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
                    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
                    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
                    s.dyn_ltree[END_BLOCK * 2] = 1;
                    s.opt_len = s.static_len = 0;
                    s.last_lit = s.matches = 0;
                }
                /* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
                    if (s.bi_valid > 8) put_short(s, s.bi_buf);
                    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
                    s.pending_buf[s.pending++] = s.bi_buf;
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                }
                /* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
                //charf    *buf;    /* the input data */
                //unsigned len;     /* its length */
                //int      header;  /* true if block header must be written */
                {
                    bi_windup(s); /* align on byte boundary */ 
                    if (header) {
                        put_short(s, len);
                        put_short(s, ~len);
                    }
                    //  while (len--) {
                    //    put_byte(s, *buf++);
                    //  }
                    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
                    s.pending += len;
                }
                /* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
                    var _n2 = n * 2;
                    var _m2 = m * 2;
                    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
                }
                /* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
                //    ct_data *tree;  /* the tree to restore */
                //    int k;               /* node to move down */
                {
                    var v = s.heap[k];
                    var j = k << 1; /* left son of k */ 
                    while(j <= s.heap_len){
                        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
                        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
                        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
                        k = j;
                        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
                    }
                    s.heap[k] = v;
                }
                // inlined manually
                // var SMALLEST = 1;
                /* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
                //    const ct_data *ltree; /* literal tree */
                //    const ct_data *dtree; /* distance tree */
                {
                    var dist; /* distance of matched string */ 
                    var lc; /* match length or unmatched char (if dist == 0) */ 
                    var lx = 0; /* running index in l_buf */ 
                    var code; /* the code to send */ 
                    var extra; /* number of extra bits to send */ 
                    if (s.last_lit !== 0) do {
                        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
                        lc = s.pending_buf[s.l_buf + lx];
                        lx++;
                        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
                        else {
                            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
                            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
                            extra = extra_lbits[code];
                            if (extra !== 0) {
                                lc -= base_length[code];
                                send_bits(s, lc, extra); /* send the extra length bits */ 
                            }
                            dist--; /* dist is now the match distance - 1 */ 
                            code = d_code(dist);
                            //Assert (code < D_CODES, "bad d_code");
                            send_code(s, code, dtree); /* send the distance code */ 
                            extra = extra_dbits[code];
                            if (extra !== 0) {
                                dist -= base_dist[code];
                                send_bits(s, dist, extra); /* send the extra distance bits */ 
                            }
                        } /* literal or match pair ? */ 
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                    }while (lx < s.last_lit);
                    send_code(s, END_BLOCK, ltree);
                }
                /* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
                //    tree_desc *desc; /* the tree descriptor */
                {
                    var tree = desc.dyn_tree;
                    var stree = desc.stat_desc.static_tree;
                    var has_stree = desc.stat_desc.has_stree;
                    var elems = desc.stat_desc.elems;
                    var n, m; /* iterate over heap elements */ 
                    var max_code = -1; /* largest code with non zero frequency */ 
                    var node; /* new node being created */ 
                    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
                    s.heap_max = HEAP_SIZE;
                    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
                        s.heap[++s.heap_len] = max_code = n;
                        s.depth[n] = 0;
                    } else tree[n * 2 + 1] = 0;
                    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
                        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                        tree[node * 2] = 1;
                        s.depth[node] = 0;
                        s.opt_len--;
                        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
                    /* node is 0 or 1 so it does not have extra bits */ }
                    desc.max_code = max_code;
                    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
                    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
                    do {
                        //pqremove(s, tree, n);  /* n = node of least frequency */
                        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
                        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
                        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
                        s.heap[--s.heap_max] = m;
                        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
                        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
                        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                    }while (s.heap_len >= 2);
                    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
                    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
                    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
                }
                /* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
                //    ct_data *tree;   /* the tree to be scanned */
                //    int max_code;    /* and its largest code of non zero frequency */
                {
                    var n; /* iterates over all tree elements */ 
                    var prevlen = -1; /* last emitted length */ 
                    var curlen; /* length of current code */ 
                    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    var count = 0; /* repeat count of the current code */ 
                    var max_count = 7; /* max repeat count */ 
                    var min_count = 4; /* min repeat count */ 
                    if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) s.bl_tree[curlen * 2] += count;
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
                            s.bl_tree[REP_3_6 * 2]++;
                        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
                        else s.bl_tree[REPZ_11_138 * 2]++;
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                }
                /* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
                //    ct_data *tree; /* the tree to be scanned */
                //    int max_code;       /* and its largest code of non zero frequency */
                {
                    var n; /* iterates over all tree elements */ 
                    var prevlen = -1; /* last emitted length */ 
                    var curlen; /* length of current code */ 
                    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    var count = 0; /* repeat count of the current code */ 
                    var max_count = 7; /* max repeat count */ 
                    var min_count = 4; /* min repeat count */ 
                    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
                        while (--count !== 0);
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) {
                                send_code(s, curlen, s.bl_tree);
                                count--;
                            }
                            //Assert(count >= 3 && count <= 6, " 3_6?");
                            send_code(s, REP_3_6, s.bl_tree);
                            send_bits(s, count - 3, 2);
                        } else if (count <= 10) {
                            send_code(s, REPZ_3_10, s.bl_tree);
                            send_bits(s, count - 3, 3);
                        } else {
                            send_code(s, REPZ_11_138, s.bl_tree);
                            send_bits(s, count - 11, 7);
                        }
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                }
                /* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
                    var max_blindex; /* index of last bit length code of non zero freq */ 
                    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
                    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
                    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
                    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
                        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
                    }
                    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
                    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
                    //        s->opt_len, s->static_len));
                    return max_blindex;
                }
                /* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
                //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
                {
                    var rank; /* index in bl_order */ 
                    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
                    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
                    //        "too many codes");
                    //Tracev((stderr, "\nbl counts: "));
                    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
                    send_bits(s, dcodes - 1, 5);
                    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
                    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
                    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
                    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
                //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
                }
                /* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
                    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
                    var n;
                    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
                        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
                    }
                    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
                    for(n = 32; n < LITERALS; n++){
                        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
                    }
                    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
                }
                var static_init_done = false;
                /* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
                    if (!static_init_done) {
                        tr_static_init();
                        static_init_done = true;
                    }
                    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
                    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
                    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                    /* Initialize the first block of the first file: */ init_block(s);
                }
                /* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
                //charf *buf;       /* input block */
                //ulg stored_len;   /* length of input block */
                //int last;         /* one if this is the last block for a file */
                {
                    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
                    copy_block(s, buf, stored_len, true); /* with header */ 
                }
                /* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
                    send_bits(s, STATIC_TREES << 1, 3);
                    send_code(s, END_BLOCK, static_ltree);
                    bi_flush(s);
                }
                /* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
                //charf *buf;       /* input block, or NULL if too old */
                //ulg stored_len;   /* length of input block */
                //int last;         /* one if this is the last block for a file */
                {
                    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
                    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
                    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
                        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
                        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
                        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        build_tree(s, s.d_desc);
                        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
                        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
                        static_lenb = s.static_len + 3 + 7 >>> 3;
                        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                        //        s->last_lit));
                        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
                    } else // Assert(buf != (char*)0, "lost buf");
                    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
                    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
                    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                        compress_block(s, static_ltree, static_dtree);
                    } else {
                        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                        compress_block(s, s.dyn_ltree, s.dyn_dtree);
                    }
                    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
                    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
                    if (last) bi_windup(s);
                // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
                //       s->compressed_len-7*last));
                }
                /* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
                //    unsigned dist;  /* distance of matched string */
                //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
                {
                    //var out_length, in_length, dcode;
                    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
                    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
                    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
                    s.last_lit++;
                    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
                    else {
                        s.matches++;
                        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
                        //Assert((ush)dist < (ush)MAX_DIST(s) &&
                        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
                        s.dyn_dtree[d_code(dist) * 2]++;
                    }
                    // (!) This block is disabled in zlib defaults,
                    // don't enable it for binary compatibility
                    //#ifdef TRUNCATE_BLOCK
                    //  /* Try to guess if it is profitable to stop the current block here */
                    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
                    //    /* Compute an upper bound for the compressed length */
                    //    out_length = s.last_lit*8;
                    //    in_length = s.strstart - s.block_start;
                    //
                    //    for (dcode = 0; dcode < D_CODES; dcode++) {
                    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
                    //    }
                    //    out_length >>>= 3;
                    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
                    //    //       s->last_lit, in_length, out_length,
                    //    //       100L - out_length*100L/in_length));
                    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
                    //      return true;
                    //    }
                    //  }
                    //#endif
                    return s.last_lit === s.lit_bufsize - 1;
                /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
                exports._tr_init = _tr_init;
                exports._tr_stored_block = _tr_stored_block;
                exports._tr_flush_block = _tr_flush_block;
                exports._tr_tally = _tr_tally;
                exports._tr_align = _tr_align;
            /***/ },
            /***/ 28755: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                function ZStream() {
                    /* next input byte */ this.input = null; // JS specific, because we have no pointers
                    this.next_in = 0;
                    /* number of bytes available at input */ this.avail_in = 0;
                    /* total number of input bytes read so far */ this.total_in = 0;
                    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
                    this.next_out = 0;
                    /* remaining free space at output */ this.avail_out = 0;
                    /* total number of bytes output so far */ this.total_out = 0;
                    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
                    /* not visible by applications */ this.state = null;
                    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
                    /* adler32 value of the uncompressed data */ this.adler = 0;
                }
                module1.exports = ZStream;
            /***/ },
            /***/ 82530: /***/ function(module1) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            /***/ },
            /***/ 73994: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var setFunctionName = __webpack_require__(25021);
                var $Object = Object;
                var $TypeError = TypeError;
                module1.exports = setFunctionName(function flags() {
                    if (this != null && this !== $Object(this)) throw new $TypeError("RegExp.prototype.flags getter called on non-object");
                    var result = "";
                    if (this.hasIndices) result += "d";
                    if (this.global) result += "g";
                    if (this.ignoreCase) result += "i";
                    if (this.multiline) result += "m";
                    if (this.dotAll) result += "s";
                    if (this.unicode) result += "u";
                    if (this.unicodeSets) result += "v";
                    if (this.sticky) result += "y";
                    return result;
                }, "get flags", true);
            /***/ },
            /***/ 80251: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(19170);
                var callBind = __webpack_require__(12550);
                var implementation = __webpack_require__(73994);
                var getPolyfill = __webpack_require__(71856);
                var shim = __webpack_require__(47278);
                var flagsBound = callBind(getPolyfill());
                define(flagsBound, {
                    getPolyfill: getPolyfill,
                    implementation: implementation,
                    shim: shim
                });
                module1.exports = flagsBound;
            /***/ },
            /***/ 71856: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(73994);
                var supportsDescriptors = __webpack_require__(19170).supportsDescriptors;
                var $gOPD = Object.getOwnPropertyDescriptor;
                module1.exports = function getPolyfill() {
                    if (supportsDescriptors && /a/mig.flags === "gim") {
                        var descriptor = $gOPD(RegExp.prototype, "flags");
                        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
                            /* eslint getter-return: 0 */ var calls = "";
                            var o = {};
                            Object.defineProperty(o, "hasIndices", {
                                get: function() {
                                    calls += "d";
                                }
                            });
                            Object.defineProperty(o, "sticky", {
                                get: function() {
                                    calls += "y";
                                }
                            });
                            if (calls === "dy") return descriptor.get;
                        }
                    }
                    return implementation;
                };
            /***/ },
            /***/ 47278: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var supportsDescriptors = __webpack_require__(19170).supportsDescriptors;
                var getPolyfill = __webpack_require__(71856);
                var gOPD = Object.getOwnPropertyDescriptor;
                var defineProperty = Object.defineProperty;
                var TypeErr = TypeError;
                var getProto = Object.getPrototypeOf;
                var regex = /a/;
                module1.exports = function shimFlags() {
                    if (!supportsDescriptors || !getProto) throw new TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
                    var polyfill = getPolyfill();
                    var proto = getProto(regex);
                    var descriptor = gOPD(proto, "flags");
                    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, "flags", {
                        configurable: true,
                        enumerable: false,
                        get: polyfill
                    });
                    return polyfill;
                };
            /***/ },
            /***/ 53407: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                (function(sax) {
                    sax.parser = function(strict, opt) {
                        return new SAXParser(strict, opt);
                    };
                    sax.SAXParser = SAXParser;
                    sax.SAXStream = SAXStream;
                    sax.createStream = createStream;
                    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
                    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
                    // since that's the earliest that a buffer overrun could occur.  This way, checks are
                    // as rare as required, but as often as necessary to ensure never crossing this bound.
                    // Furthermore, buffers are only tested at most once per write(), so passing a very
                    // large string into write() might have undesirable effects, but this is manageable by
                    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
                    // edge case, result in creating at most one complete copy of the string passed in.
                    // Set to Infinity to have unlimited buffers.
                    sax.MAX_BUFFER_LENGTH = 65536;
                    var buffers = [
                        "comment",
                        "sgmlDecl",
                        "textNode",
                        "tagName",
                        "doctype",
                        "procInstName",
                        "procInstBody",
                        "entity",
                        "attribName",
                        "attribValue",
                        "cdata",
                        "script"
                    ];
                    sax.EVENTS = [
                        "text",
                        "processinginstruction",
                        "sgmldeclaration",
                        "doctype",
                        "comment",
                        "opentagstart",
                        "attribute",
                        "opentag",
                        "closetag",
                        "opencdata",
                        "cdata",
                        "closecdata",
                        "error",
                        "end",
                        "ready",
                        "script",
                        "opennamespace",
                        "closenamespace"
                    ];
                    function SAXParser(strict, opt) {
                        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
                        var parser = this;
                        clearBuffers(parser);
                        parser.q = parser.c = "";
                        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
                        parser.opt = opt || {};
                        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
                        parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
                        parser.tags = [];
                        parser.closed = parser.closedRoot = parser.sawRoot = false;
                        parser.tag = parser.error = null;
                        parser.strict = !!strict;
                        parser.noscript = !!(strict || parser.opt.noscript);
                        parser.state = S.BEGIN;
                        parser.strictEntities = parser.opt.strictEntities;
                        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
                        parser.attribList = [];
                        // namespaces form a prototype chain.
                        // it always points at the current tag,
                        // which protos to its parent tag.
                        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
                        // mostly just for error reporting
                        parser.trackPosition = parser.opt.position !== false;
                        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
                        emit(parser, "onready");
                    }
                    if (!Object.create) Object.create = function(o) {
                        function F() {}
                        F.prototype = o;
                        var newf = new F();
                        return newf;
                    };
                    if (!Object.keys) Object.keys = function(o) {
                        var a = [];
                        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
                        return a;
                    };
                    function checkBufferLength(parser) {
                        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
                        var maxActual = 0;
                        for(var i = 0, l = buffers.length; i < l; i++){
                            var len = parser[buffers[i]].length;
                            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
                            // we can get here under normal conditions.
                            // Avoid issues by emitting the text node now,
                            // so at least it won't get any bigger.
                            switch(buffers[i]){
                                case "textNode":
                                    closeText(parser);
                                    break;
                                case "cdata":
                                    emitNode(parser, "oncdata", parser.cdata);
                                    parser.cdata = "";
                                    break;
                                case "script":
                                    emitNode(parser, "onscript", parser.script);
                                    parser.script = "";
                                    break;
                                default:
                                    error(parser, "Max buffer length exceeded: " + buffers[i]);
                            }
                            maxActual = Math.max(maxActual, len);
                        }
                        // schedule the next check for the earliest possible buffer overrun.
                        var m = sax.MAX_BUFFER_LENGTH - maxActual;
                        parser.bufferCheckPosition = m + parser.position;
                    }
                    function clearBuffers(parser) {
                        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
                    }
                    function flushBuffers(parser) {
                        closeText(parser);
                        if (parser.cdata !== "") {
                            emitNode(parser, "oncdata", parser.cdata);
                            parser.cdata = "";
                        }
                        if (parser.script !== "") {
                            emitNode(parser, "onscript", parser.script);
                            parser.script = "";
                        }
                    }
                    SAXParser.prototype = {
                        end: function() {
                            end(this);
                        },
                        write: write,
                        resume: function() {
                            this.error = null;
                            return this;
                        },
                        close: function() {
                            return this.write(null);
                        },
                        flush: function() {
                            flushBuffers(this);
                        }
                    };
                    var Stream;
                    try {
                        Stream = __webpack_require__(20202).Stream;
                    } catch (ex) {
                        Stream = function() {};
                    }
                    if (!Stream) Stream = function() {};
                    var streamWraps = sax.EVENTS.filter(function(ev) {
                        return ev !== "error" && ev !== "end";
                    });
                    function createStream(strict, opt) {
                        return new SAXStream(strict, opt);
                    }
                    function SAXStream(strict, opt) {
                        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
                        Stream.apply(this);
                        this._parser = new SAXParser(strict, opt);
                        this.writable = true;
                        this.readable = true;
                        var me = this;
                        this._parser.onend = function() {
                            me.emit("end");
                        };
                        this._parser.onerror = function(er) {
                            me.emit("error", er);
                            // if didn't throw, then means error was handled.
                            // go ahead and clear error, so we can write again.
                            me._parser.error = null;
                        };
                        this._decoder = null;
                        streamWraps.forEach(function(ev) {
                            Object.defineProperty(me, "on" + ev, {
                                get: function() {
                                    return me._parser["on" + ev];
                                },
                                set: function(h) {
                                    if (!h) {
                                        me.removeAllListeners(ev);
                                        me._parser["on" + ev] = h;
                                        return h;
                                    }
                                    me.on(ev, h);
                                },
                                enumerable: true,
                                configurable: false
                            });
                        });
                    }
                    SAXStream.prototype = Object.create(Stream.prototype, {
                        constructor: {
                            value: SAXStream
                        }
                    });
                    SAXStream.prototype.write = function(data) {
                        if (typeof Buffer === "function" && typeof Buffer.isBuffer === "function" && Buffer.isBuffer(data)) {
                            if (!this._decoder) {
                                var SD = __webpack_require__(10301)/* .StringDecoder */ .s;
                                this._decoder = new SD("utf8");
                            }
                            data = this._decoder.write(data);
                        }
                        this._parser.write(data.toString());
                        this.emit("data", data);
                        return true;
                    };
                    SAXStream.prototype.end = function(chunk) {
                        if (chunk && chunk.length) this.write(chunk);
                        this._parser.end();
                        return true;
                    };
                    SAXStream.prototype.on = function(ev, handler) {
                        var me = this;
                        if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
                            var args = arguments.length === 1 ? [
                                arguments[0]
                            ] : Array.apply(null, arguments);
                            args.splice(0, 0, ev);
                            me.emit.apply(me, args);
                        };
                        return Stream.prototype.on.call(me, ev, handler);
                    };
                    // this really needs to be replaced with character classes.
                    // XML allows all manner of ridiculous numbers and digits.
                    var CDATA = "[CDATA[";
                    var DOCTYPE = "DOCTYPE";
                    var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
                    var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
                    var rootNS = {
                        xml: XML_NAMESPACE,
                        xmlns: XMLNS_NAMESPACE
                    };
                    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
                    // This implementation works on strings, a single character at a time
                    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
                    // without a significant breaking change to either this  parser, or the
                    // JavaScript language.  Implementation of an emoji-capable xml parser
                    // is left as an exercise for the reader.
                    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
                    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
                    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
                    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
                    function isWhitespace(c) {
                        return c === " " || c === "\n" || c === "\r" || c === "	";
                    }
                    function isQuote(c) {
                        return c === '"' || c === "'";
                    }
                    function isAttribEnd(c) {
                        return c === ">" || isWhitespace(c);
                    }
                    function isMatch(regex, c) {
                        return regex.test(c);
                    }
                    function notMatch(regex, c) {
                        return !isMatch(regex, c);
                    }
                    var S = 0;
                    sax.STATE = {
                        BEGIN: S++,
                        BEGIN_WHITESPACE: S++,
                        TEXT: S++,
                        TEXT_ENTITY: S++,
                        OPEN_WAKA: S++,
                        SGML_DECL: S++,
                        SGML_DECL_QUOTED: S++,
                        DOCTYPE: S++,
                        DOCTYPE_QUOTED: S++,
                        DOCTYPE_DTD: S++,
                        DOCTYPE_DTD_QUOTED: S++,
                        COMMENT_STARTING: S++,
                        COMMENT: S++,
                        COMMENT_ENDING: S++,
                        COMMENT_ENDED: S++,
                        CDATA: S++,
                        CDATA_ENDING: S++,
                        CDATA_ENDING_2: S++,
                        PROC_INST: S++,
                        PROC_INST_BODY: S++,
                        PROC_INST_ENDING: S++,
                        OPEN_TAG: S++,
                        OPEN_TAG_SLASH: S++,
                        ATTRIB: S++,
                        ATTRIB_NAME: S++,
                        ATTRIB_NAME_SAW_WHITE: S++,
                        ATTRIB_VALUE: S++,
                        ATTRIB_VALUE_QUOTED: S++,
                        ATTRIB_VALUE_CLOSED: S++,
                        ATTRIB_VALUE_UNQUOTED: S++,
                        ATTRIB_VALUE_ENTITY_Q: S++,
                        ATTRIB_VALUE_ENTITY_U: S++,
                        CLOSE_TAG: S++,
                        CLOSE_TAG_SAW_WHITE: S++,
                        SCRIPT: S++,
                        SCRIPT_ENDING: S++ // <script> ... <
                    };
                    sax.XML_ENTITIES = {
                        "amp": "&",
                        "gt": ">",
                        "lt": "<",
                        "quot": '"',
                        "apos": "'"
                    };
                    sax.ENTITIES = {
                        "amp": "&",
                        "gt": ">",
                        "lt": "<",
                        "quot": '"',
                        "apos": "'",
                        "AElig": 198,
                        "Aacute": 193,
                        "Acirc": 194,
                        "Agrave": 192,
                        "Aring": 197,
                        "Atilde": 195,
                        "Auml": 196,
                        "Ccedil": 199,
                        "ETH": 208,
                        "Eacute": 201,
                        "Ecirc": 202,
                        "Egrave": 200,
                        "Euml": 203,
                        "Iacute": 205,
                        "Icirc": 206,
                        "Igrave": 204,
                        "Iuml": 207,
                        "Ntilde": 209,
                        "Oacute": 211,
                        "Ocirc": 212,
                        "Ograve": 210,
                        "Oslash": 216,
                        "Otilde": 213,
                        "Ouml": 214,
                        "THORN": 222,
                        "Uacute": 218,
                        "Ucirc": 219,
                        "Ugrave": 217,
                        "Uuml": 220,
                        "Yacute": 221,
                        "aacute": 225,
                        "acirc": 226,
                        "aelig": 230,
                        "agrave": 224,
                        "aring": 229,
                        "atilde": 227,
                        "auml": 228,
                        "ccedil": 231,
                        "eacute": 233,
                        "ecirc": 234,
                        "egrave": 232,
                        "eth": 240,
                        "euml": 235,
                        "iacute": 237,
                        "icirc": 238,
                        "igrave": 236,
                        "iuml": 239,
                        "ntilde": 241,
                        "oacute": 243,
                        "ocirc": 244,
                        "ograve": 242,
                        "oslash": 248,
                        "otilde": 245,
                        "ouml": 246,
                        "szlig": 223,
                        "thorn": 254,
                        "uacute": 250,
                        "ucirc": 251,
                        "ugrave": 249,
                        "uuml": 252,
                        "yacute": 253,
                        "yuml": 255,
                        "copy": 169,
                        "reg": 174,
                        "nbsp": 160,
                        "iexcl": 161,
                        "cent": 162,
                        "pound": 163,
                        "curren": 164,
                        "yen": 165,
                        "brvbar": 166,
                        "sect": 167,
                        "uml": 168,
                        "ordf": 170,
                        "laquo": 171,
                        "not": 172,
                        "shy": 173,
                        "macr": 175,
                        "deg": 176,
                        "plusmn": 177,
                        "sup1": 185,
                        "sup2": 178,
                        "sup3": 179,
                        "acute": 180,
                        "micro": 181,
                        "para": 182,
                        "middot": 183,
                        "cedil": 184,
                        "ordm": 186,
                        "raquo": 187,
                        "frac14": 188,
                        "frac12": 189,
                        "frac34": 190,
                        "iquest": 191,
                        "times": 215,
                        "divide": 247,
                        "OElig": 338,
                        "oelig": 339,
                        "Scaron": 352,
                        "scaron": 353,
                        "Yuml": 376,
                        "fnof": 402,
                        "circ": 710,
                        "tilde": 732,
                        "Alpha": 913,
                        "Beta": 914,
                        "Gamma": 915,
                        "Delta": 916,
                        "Epsilon": 917,
                        "Zeta": 918,
                        "Eta": 919,
                        "Theta": 920,
                        "Iota": 921,
                        "Kappa": 922,
                        "Lambda": 923,
                        "Mu": 924,
                        "Nu": 925,
                        "Xi": 926,
                        "Omicron": 927,
                        "Pi": 928,
                        "Rho": 929,
                        "Sigma": 931,
                        "Tau": 932,
                        "Upsilon": 933,
                        "Phi": 934,
                        "Chi": 935,
                        "Psi": 936,
                        "Omega": 937,
                        "alpha": 945,
                        "beta": 946,
                        "gamma": 947,
                        "delta": 948,
                        "epsilon": 949,
                        "zeta": 950,
                        "eta": 951,
                        "theta": 952,
                        "iota": 953,
                        "kappa": 954,
                        "lambda": 955,
                        "mu": 956,
                        "nu": 957,
                        "xi": 958,
                        "omicron": 959,
                        "pi": 960,
                        "rho": 961,
                        "sigmaf": 962,
                        "sigma": 963,
                        "tau": 964,
                        "upsilon": 965,
                        "phi": 966,
                        "chi": 967,
                        "psi": 968,
                        "omega": 969,
                        "thetasym": 977,
                        "upsih": 978,
                        "piv": 982,
                        "ensp": 8194,
                        "emsp": 8195,
                        "thinsp": 8201,
                        "zwnj": 8204,
                        "zwj": 8205,
                        "lrm": 8206,
                        "rlm": 8207,
                        "ndash": 8211,
                        "mdash": 8212,
                        "lsquo": 8216,
                        "rsquo": 8217,
                        "sbquo": 8218,
                        "ldquo": 8220,
                        "rdquo": 8221,
                        "bdquo": 8222,
                        "dagger": 8224,
                        "Dagger": 8225,
                        "bull": 8226,
                        "hellip": 8230,
                        "permil": 8240,
                        "prime": 8242,
                        "Prime": 8243,
                        "lsaquo": 8249,
                        "rsaquo": 8250,
                        "oline": 8254,
                        "frasl": 8260,
                        "euro": 8364,
                        "image": 8465,
                        "weierp": 8472,
                        "real": 8476,
                        "trade": 8482,
                        "alefsym": 8501,
                        "larr": 8592,
                        "uarr": 8593,
                        "rarr": 8594,
                        "darr": 8595,
                        "harr": 8596,
                        "crarr": 8629,
                        "lArr": 8656,
                        "uArr": 8657,
                        "rArr": 8658,
                        "dArr": 8659,
                        "hArr": 8660,
                        "forall": 8704,
                        "part": 8706,
                        "exist": 8707,
                        "empty": 8709,
                        "nabla": 8711,
                        "isin": 8712,
                        "notin": 8713,
                        "ni": 8715,
                        "prod": 8719,
                        "sum": 8721,
                        "minus": 8722,
                        "lowast": 8727,
                        "radic": 8730,
                        "prop": 8733,
                        "infin": 8734,
                        "ang": 8736,
                        "and": 8743,
                        "or": 8744,
                        "cap": 8745,
                        "cup": 8746,
                        "int": 8747,
                        "there4": 8756,
                        "sim": 8764,
                        "cong": 8773,
                        "asymp": 8776,
                        "ne": 8800,
                        "equiv": 8801,
                        "le": 8804,
                        "ge": 8805,
                        "sub": 8834,
                        "sup": 8835,
                        "nsub": 8836,
                        "sube": 8838,
                        "supe": 8839,
                        "oplus": 8853,
                        "otimes": 8855,
                        "perp": 8869,
                        "sdot": 8901,
                        "lceil": 8968,
                        "rceil": 8969,
                        "lfloor": 8970,
                        "rfloor": 8971,
                        "lang": 9001,
                        "rang": 9002,
                        "loz": 9674,
                        "spades": 9824,
                        "clubs": 9827,
                        "hearts": 9829,
                        "diams": 9830
                    };
                    Object.keys(sax.ENTITIES).forEach(function(key) {
                        var e = sax.ENTITIES[key];
                        var s = typeof e === "number" ? String.fromCharCode(e) : e;
                        sax.ENTITIES[key] = s;
                    });
                    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
                    // shorthand
                    S = sax.STATE;
                    function emit(parser, event, data) {
                        parser[event] && parser[event](data);
                    }
                    function emitNode(parser, nodeType, data) {
                        if (parser.textNode) closeText(parser);
                        emit(parser, nodeType, data);
                    }
                    function closeText(parser) {
                        parser.textNode = textopts(parser.opt, parser.textNode);
                        if (parser.textNode) emit(parser, "ontext", parser.textNode);
                        parser.textNode = "";
                    }
                    function textopts(opt, text) {
                        if (opt.trim) text = text.trim();
                        if (opt.normalize) text = text.replace(/\s+/g, " ");
                        return text;
                    }
                    function error(parser, er) {
                        closeText(parser);
                        if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
                        er = new Error(er);
                        parser.error = er;
                        emit(parser, "onerror", er);
                        return parser;
                    }
                    function end(parser) {
                        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
                        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
                        closeText(parser);
                        parser.c = "";
                        parser.closed = true;
                        emit(parser, "onend");
                        SAXParser.call(parser, parser.strict, parser.opt);
                        return parser;
                    }
                    function strictFail(parser, message) {
                        if (typeof parser !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
                        if (parser.strict) error(parser, message);
                    }
                    function newTag(parser) {
                        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
                        var parent = parser.tags[parser.tags.length - 1] || parser;
                        var tag = parser.tag = {
                            name: parser.tagName,
                            attributes: {}
                        };
                        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
                        if (parser.opt.xmlns) tag.ns = parent.ns;
                        parser.attribList.length = 0;
                        emitNode(parser, "onopentagstart", tag);
                    }
                    function qname(name, attribute) {
                        var i = name.indexOf(":");
                        var qualName = i < 0 ? [
                            "",
                            name
                        ] : name.split(":");
                        var prefix = qualName[0];
                        var local = qualName[1];
                        // <x "xmlns"="http://foo">
                        if (attribute && name === "xmlns") {
                            prefix = "xmlns";
                            local = "";
                        }
                        return {
                            prefix: prefix,
                            local: local
                        };
                    }
                    function attrib(parser) {
                        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
                        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
                            parser.attribName = parser.attribValue = "";
                            return;
                        }
                        if (parser.opt.xmlns) {
                            var qn = qname(parser.attribName, true);
                            var prefix = qn.prefix;
                            var local = qn.local;
                            if (prefix === "xmlns") {
                                // namespace binding attribute. push the binding into scope
                                if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                                else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                                else {
                                    var tag = parser.tag;
                                    var parent = parser.tags[parser.tags.length - 1] || parser;
                                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                                    tag.ns[local] = parser.attribValue;
                                }
                            }
                            // defer onattribute events until all attributes have been seen
                            // so any new bindings can take effect. preserve attribute order
                            // so deferred events can be emitted in document order
                            parser.attribList.push([
                                parser.attribName,
                                parser.attribValue
                            ]);
                        } else {
                            // in non-xmlns mode, we can emit the event right away
                            parser.tag.attributes[parser.attribName] = parser.attribValue;
                            emitNode(parser, "onattribute", {
                                name: parser.attribName,
                                value: parser.attribValue
                            });
                        }
                        parser.attribName = parser.attribValue = "";
                    }
                    function openTag(parser, selfClosing) {
                        if (parser.opt.xmlns) {
                            // emit namespace binding events
                            var tag = parser.tag;
                            // add namespace info to tag
                            var qn = qname(parser.tagName);
                            tag.prefix = qn.prefix;
                            tag.local = qn.local;
                            tag.uri = tag.ns[qn.prefix] || "";
                            if (tag.prefix && !tag.uri) {
                                strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                                tag.uri = qn.prefix;
                            }
                            var parent = parser.tags[parser.tags.length - 1] || parser;
                            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                                emitNode(parser, "onopennamespace", {
                                    prefix: p,
                                    uri: tag.ns[p]
                                });
                            });
                            // handle deferred onattribute events
                            // Note: do not apply default ns to attributes:
                            //   http://www.w3.org/TR/REC-xml-names/#defaulting
                            for(var i = 0, l = parser.attribList.length; i < l; i++){
                                var nv = parser.attribList[i];
                                var name = nv[0];
                                var value = nv[1];
                                var qualName = qname(name, true);
                                var prefix = qualName.prefix;
                                var local = qualName.local;
                                var uri = prefix === "" ? "" : tag.ns[prefix] || "";
                                var a = {
                                    name: name,
                                    value: value,
                                    prefix: prefix,
                                    local: local,
                                    uri: uri
                                };
                                // if there's any attributes with an undefined namespace,
                                // then fail on them now.
                                if (prefix && prefix !== "xmlns" && !uri) {
                                    strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                                    a.uri = prefix;
                                }
                                parser.tag.attributes[name] = a;
                                emitNode(parser, "onattribute", a);
                            }
                            parser.attribList.length = 0;
                        }
                        parser.tag.isSelfClosing = !!selfClosing;
                        // process the tag
                        parser.sawRoot = true;
                        parser.tags.push(parser.tag);
                        emitNode(parser, "onopentag", parser.tag);
                        if (!selfClosing) {
                            // special case for <script> in non-strict mode.
                            if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
                            else parser.state = S.TEXT;
                            parser.tag = null;
                            parser.tagName = "";
                        }
                        parser.attribName = parser.attribValue = "";
                        parser.attribList.length = 0;
                    }
                    function closeTag(parser) {
                        if (!parser.tagName) {
                            strictFail(parser, "Weird empty close tag.");
                            parser.textNode += "</>";
                            parser.state = S.TEXT;
                            return;
                        }
                        if (parser.script) {
                            if (parser.tagName !== "script") {
                                parser.script += "</" + parser.tagName + ">";
                                parser.tagName = "";
                                parser.state = S.SCRIPT;
                                return;
                            }
                            emitNode(parser, "onscript", parser.script);
                            parser.script = "";
                        }
                        // first make sure that the closing tag actually exists.
                        // <a><b></c></b></a> will close everything, otherwise.
                        var t = parser.tags.length;
                        var tagName = parser.tagName;
                        if (!parser.strict) tagName = tagName[parser.looseCase]();
                        var closeTo = tagName;
                        while(t--){
                            var close = parser.tags[t];
                            if (close.name !== closeTo) // fail the first time in strict mode
                            strictFail(parser, "Unexpected close tag");
                            else break;
                        }
                        // didn't find it.  we already failed for strict, so just abort.
                        if (t < 0) {
                            strictFail(parser, "Unmatched closing tag: " + parser.tagName);
                            parser.textNode += "</" + parser.tagName + ">";
                            parser.state = S.TEXT;
                            return;
                        }
                        parser.tagName = tagName;
                        var s = parser.tags.length;
                        while(s-- > t){
                            var tag = parser.tag = parser.tags.pop();
                            parser.tagName = parser.tag.name;
                            emitNode(parser, "onclosetag", parser.tagName);
                            var x = {};
                            for(var i in tag.ns)x[i] = tag.ns[i];
                            var parent = parser.tags[parser.tags.length - 1] || parser;
                            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
                            Object.keys(tag.ns).forEach(function(p) {
                                var n = tag.ns[p];
                                emitNode(parser, "onclosenamespace", {
                                    prefix: p,
                                    uri: n
                                });
                            });
                        }
                        if (t === 0) parser.closedRoot = true;
                        parser.tagName = parser.attribValue = parser.attribName = "";
                        parser.attribList.length = 0;
                        parser.state = S.TEXT;
                    }
                    function parseEntity(parser) {
                        var entity = parser.entity;
                        var entityLC = entity.toLowerCase();
                        var num;
                        var numStr = "";
                        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
                        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
                        entity = entityLC;
                        if (entity.charAt(0) === "#") {
                            if (entity.charAt(1) === "x") {
                                entity = entity.slice(2);
                                num = parseInt(entity, 16);
                                numStr = num.toString(16);
                            } else {
                                entity = entity.slice(1);
                                num = parseInt(entity, 10);
                                numStr = num.toString(10);
                            }
                        }
                        entity = entity.replace(/^0+/, "");
                        if (isNaN(num) || numStr.toLowerCase() !== entity) {
                            strictFail(parser, "Invalid character entity");
                            return "&" + parser.entity + ";";
                        }
                        return String.fromCodePoint(num);
                    }
                    function beginWhiteSpace(parser, c) {
                        if (c === "<") {
                            parser.state = S.OPEN_WAKA;
                            parser.startTagPosition = parser.position;
                        } else if (!isWhitespace(c)) {
                            // have to process this as a text node.
                            // weird, but happens.
                            strictFail(parser, "Non-whitespace before first tag.");
                            parser.textNode = c;
                            parser.state = S.TEXT;
                        }
                    }
                    function charAt(chunk, i) {
                        var result = "";
                        if (i < chunk.length) result = chunk.charAt(i);
                        return result;
                    }
                    function write(chunk) {
                        var parser = this;
                        if (this.error) throw this.error;
                        if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
                        if (chunk === null) return end(parser);
                        if (typeof chunk === "object") chunk = chunk.toString();
                        var i = 0;
                        var c = "";
                        while(true){
                            c = charAt(chunk, i++);
                            parser.c = c;
                            if (!c) break;
                            if (parser.trackPosition) {
                                parser.position++;
                                if (c === "\n") {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                            switch(parser.state){
                                case S.BEGIN:
                                    parser.state = S.BEGIN_WHITESPACE;
                                    if (c === "\uFEFF") continue;
                                    beginWhiteSpace(parser, c);
                                    continue;
                                case S.BEGIN_WHITESPACE:
                                    beginWhiteSpace(parser, c);
                                    continue;
                                case S.TEXT:
                                    if (parser.sawRoot && !parser.closedRoot) {
                                        var starti = i - 1;
                                        while(c && c !== "<" && c !== "&"){
                                            c = charAt(chunk, i++);
                                            if (c && parser.trackPosition) {
                                                parser.position++;
                                                if (c === "\n") {
                                                    parser.line++;
                                                    parser.column = 0;
                                                } else parser.column++;
                                            }
                                        }
                                        parser.textNode += chunk.substring(starti, i - 1);
                                    }
                                    if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                                        parser.state = S.OPEN_WAKA;
                                        parser.startTagPosition = parser.position;
                                    } else {
                                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                                        if (c === "&") parser.state = S.TEXT_ENTITY;
                                        else parser.textNode += c;
                                    }
                                    continue;
                                case S.SCRIPT:
                                    // only non-strict
                                    if (c === "<") parser.state = S.SCRIPT_ENDING;
                                    else parser.script += c;
                                    continue;
                                case S.SCRIPT_ENDING:
                                    if (c === "/") parser.state = S.CLOSE_TAG;
                                    else {
                                        parser.script += "<" + c;
                                        parser.state = S.SCRIPT;
                                    }
                                    continue;
                                case S.OPEN_WAKA:
                                    // either a /, ?, !, or text is coming next.
                                    if (c === "!") {
                                        parser.state = S.SGML_DECL;
                                        parser.sgmlDecl = "";
                                    } else if (isWhitespace(c)) ;
                                    else if (isMatch(nameStart, c)) {
                                        parser.state = S.OPEN_TAG;
                                        parser.tagName = c;
                                    } else if (c === "/") {
                                        parser.state = S.CLOSE_TAG;
                                        parser.tagName = "";
                                    } else if (c === "?") {
                                        parser.state = S.PROC_INST;
                                        parser.procInstName = parser.procInstBody = "";
                                    } else {
                                        strictFail(parser, "Unencoded <");
                                        // if there was some whitespace, then add that in.
                                        if (parser.startTagPosition + 1 < parser.position) {
                                            var pad = parser.position - parser.startTagPosition;
                                            c = new Array(pad).join(" ") + c;
                                        }
                                        parser.textNode += "<" + c;
                                        parser.state = S.TEXT;
                                    }
                                    continue;
                                case S.SGML_DECL:
                                    if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                                        emitNode(parser, "onopencdata");
                                        parser.state = S.CDATA;
                                        parser.sgmlDecl = "";
                                        parser.cdata = "";
                                    } else if (parser.sgmlDecl + c === "--") {
                                        parser.state = S.COMMENT;
                                        parser.comment = "";
                                        parser.sgmlDecl = "";
                                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                                        parser.state = S.DOCTYPE;
                                        if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                                        parser.doctype = "";
                                        parser.sgmlDecl = "";
                                    } else if (c === ">") {
                                        emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                                        parser.sgmlDecl = "";
                                        parser.state = S.TEXT;
                                    } else if (isQuote(c)) {
                                        parser.state = S.SGML_DECL_QUOTED;
                                        parser.sgmlDecl += c;
                                    } else parser.sgmlDecl += c;
                                    continue;
                                case S.SGML_DECL_QUOTED:
                                    if (c === parser.q) {
                                        parser.state = S.SGML_DECL;
                                        parser.q = "";
                                    }
                                    parser.sgmlDecl += c;
                                    continue;
                                case S.DOCTYPE:
                                    if (c === ">") {
                                        parser.state = S.TEXT;
                                        emitNode(parser, "ondoctype", parser.doctype);
                                        parser.doctype = true // just remember that we saw it.
                                        ;
                                    } else {
                                        parser.doctype += c;
                                        if (c === "[") parser.state = S.DOCTYPE_DTD;
                                        else if (isQuote(c)) {
                                            parser.state = S.DOCTYPE_QUOTED;
                                            parser.q = c;
                                        }
                                    }
                                    continue;
                                case S.DOCTYPE_QUOTED:
                                    parser.doctype += c;
                                    if (c === parser.q) {
                                        parser.q = "";
                                        parser.state = S.DOCTYPE;
                                    }
                                    continue;
                                case S.DOCTYPE_DTD:
                                    parser.doctype += c;
                                    if (c === "]") parser.state = S.DOCTYPE;
                                    else if (isQuote(c)) {
                                        parser.state = S.DOCTYPE_DTD_QUOTED;
                                        parser.q = c;
                                    }
                                    continue;
                                case S.DOCTYPE_DTD_QUOTED:
                                    parser.doctype += c;
                                    if (c === parser.q) {
                                        parser.state = S.DOCTYPE_DTD;
                                        parser.q = "";
                                    }
                                    continue;
                                case S.COMMENT:
                                    if (c === "-") parser.state = S.COMMENT_ENDING;
                                    else parser.comment += c;
                                    continue;
                                case S.COMMENT_ENDING:
                                    if (c === "-") {
                                        parser.state = S.COMMENT_ENDED;
                                        parser.comment = textopts(parser.opt, parser.comment);
                                        if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                                        parser.comment = "";
                                    } else {
                                        parser.comment += "-" + c;
                                        parser.state = S.COMMENT;
                                    }
                                    continue;
                                case S.COMMENT_ENDED:
                                    if (c !== ">") {
                                        strictFail(parser, "Malformed comment");
                                        // allow <!-- blah -- bloo --> in non-strict mode,
                                        // which is a comment of " blah -- bloo "
                                        parser.comment += "--" + c;
                                        parser.state = S.COMMENT;
                                    } else parser.state = S.TEXT;
                                    continue;
                                case S.CDATA:
                                    if (c === "]") parser.state = S.CDATA_ENDING;
                                    else parser.cdata += c;
                                    continue;
                                case S.CDATA_ENDING:
                                    if (c === "]") parser.state = S.CDATA_ENDING_2;
                                    else {
                                        parser.cdata += "]" + c;
                                        parser.state = S.CDATA;
                                    }
                                    continue;
                                case S.CDATA_ENDING_2:
                                    if (c === ">") {
                                        if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                                        emitNode(parser, "onclosecdata");
                                        parser.cdata = "";
                                        parser.state = S.TEXT;
                                    } else if (c === "]") parser.cdata += "]";
                                    else {
                                        parser.cdata += "]]" + c;
                                        parser.state = S.CDATA;
                                    }
                                    continue;
                                case S.PROC_INST:
                                    if (c === "?") parser.state = S.PROC_INST_ENDING;
                                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                                    else parser.procInstName += c;
                                    continue;
                                case S.PROC_INST_BODY:
                                    if (!parser.procInstBody && isWhitespace(c)) continue;
                                    else if (c === "?") parser.state = S.PROC_INST_ENDING;
                                    else parser.procInstBody += c;
                                    continue;
                                case S.PROC_INST_ENDING:
                                    if (c === ">") {
                                        emitNode(parser, "onprocessinginstruction", {
                                            name: parser.procInstName,
                                            body: parser.procInstBody
                                        });
                                        parser.procInstName = parser.procInstBody = "";
                                        parser.state = S.TEXT;
                                    } else {
                                        parser.procInstBody += "?" + c;
                                        parser.state = S.PROC_INST_BODY;
                                    }
                                    continue;
                                case S.OPEN_TAG:
                                    if (isMatch(nameBody, c)) parser.tagName += c;
                                    else {
                                        newTag(parser);
                                        if (c === ">") openTag(parser);
                                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                                        else {
                                            if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                                            parser.state = S.ATTRIB;
                                        }
                                    }
                                    continue;
                                case S.OPEN_TAG_SLASH:
                                    if (c === ">") {
                                        openTag(parser, true);
                                        closeTag(parser);
                                    } else {
                                        strictFail(parser, "Forward-slash in opening tag not followed by >");
                                        parser.state = S.ATTRIB;
                                    }
                                    continue;
                                case S.ATTRIB:
                                    // haven't read the attribute name yet.
                                    if (isWhitespace(c)) continue;
                                    else if (c === ">") openTag(parser);
                                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                                    else if (isMatch(nameStart, c)) {
                                        parser.attribName = c;
                                        parser.attribValue = "";
                                        parser.state = S.ATTRIB_NAME;
                                    } else strictFail(parser, "Invalid attribute name");
                                    continue;
                                case S.ATTRIB_NAME:
                                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                                    else if (c === ">") {
                                        strictFail(parser, "Attribute without value");
                                        parser.attribValue = parser.attribName;
                                        attrib(parser);
                                        openTag(parser);
                                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                                    else if (isMatch(nameBody, c)) parser.attribName += c;
                                    else strictFail(parser, "Invalid attribute name");
                                    continue;
                                case S.ATTRIB_NAME_SAW_WHITE:
                                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                                    else if (isWhitespace(c)) continue;
                                    else {
                                        strictFail(parser, "Attribute without value");
                                        parser.tag.attributes[parser.attribName] = "";
                                        parser.attribValue = "";
                                        emitNode(parser, "onattribute", {
                                            name: parser.attribName,
                                            value: ""
                                        });
                                        parser.attribName = "";
                                        if (c === ">") openTag(parser);
                                        else if (isMatch(nameStart, c)) {
                                            parser.attribName = c;
                                            parser.state = S.ATTRIB_NAME;
                                        } else {
                                            strictFail(parser, "Invalid attribute name");
                                            parser.state = S.ATTRIB;
                                        }
                                    }
                                    continue;
                                case S.ATTRIB_VALUE:
                                    if (isWhitespace(c)) continue;
                                    else if (isQuote(c)) {
                                        parser.q = c;
                                        parser.state = S.ATTRIB_VALUE_QUOTED;
                                    } else {
                                        strictFail(parser, "Unquoted attribute value");
                                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                                        parser.attribValue = c;
                                    }
                                    continue;
                                case S.ATTRIB_VALUE_QUOTED:
                                    if (c !== parser.q) {
                                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                                        else parser.attribValue += c;
                                        continue;
                                    }
                                    attrib(parser);
                                    parser.q = "";
                                    parser.state = S.ATTRIB_VALUE_CLOSED;
                                    continue;
                                case S.ATTRIB_VALUE_CLOSED:
                                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                                    else if (c === ">") openTag(parser);
                                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                                    else if (isMatch(nameStart, c)) {
                                        strictFail(parser, "No whitespace between attributes");
                                        parser.attribName = c;
                                        parser.attribValue = "";
                                        parser.state = S.ATTRIB_NAME;
                                    } else strictFail(parser, "Invalid attribute name");
                                    continue;
                                case S.ATTRIB_VALUE_UNQUOTED:
                                    if (!isAttribEnd(c)) {
                                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                                        else parser.attribValue += c;
                                        continue;
                                    }
                                    attrib(parser);
                                    if (c === ">") openTag(parser);
                                    else parser.state = S.ATTRIB;
                                    continue;
                                case S.CLOSE_TAG:
                                    if (!parser.tagName) {
                                        if (isWhitespace(c)) continue;
                                        else if (notMatch(nameStart, c)) {
                                            if (parser.script) {
                                                parser.script += "</" + c;
                                                parser.state = S.SCRIPT;
                                            } else strictFail(parser, "Invalid tagname in closing tag.");
                                        } else parser.tagName = c;
                                    } else if (c === ">") closeTag(parser);
                                    else if (isMatch(nameBody, c)) parser.tagName += c;
                                    else if (parser.script) {
                                        parser.script += "</" + parser.tagName;
                                        parser.tagName = "";
                                        parser.state = S.SCRIPT;
                                    } else {
                                        if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                                    }
                                    continue;
                                case S.CLOSE_TAG_SAW_WHITE:
                                    if (isWhitespace(c)) continue;
                                    if (c === ">") closeTag(parser);
                                    else strictFail(parser, "Invalid characters in closing tag");
                                    continue;
                                case S.TEXT_ENTITY:
                                case S.ATTRIB_VALUE_ENTITY_Q:
                                case S.ATTRIB_VALUE_ENTITY_U:
                                    var returnState;
                                    var buffer;
                                    switch(parser.state){
                                        case S.TEXT_ENTITY:
                                            returnState = S.TEXT;
                                            buffer = "textNode";
                                            break;
                                        case S.ATTRIB_VALUE_ENTITY_Q:
                                            returnState = S.ATTRIB_VALUE_QUOTED;
                                            buffer = "attribValue";
                                            break;
                                        case S.ATTRIB_VALUE_ENTITY_U:
                                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                                            buffer = "attribValue";
                                            break;
                                    }
                                    if (c === ";") {
                                        if (parser.opt.unparsedEntities) {
                                            var parsedEntity = parseEntity(parser);
                                            parser.entity = "";
                                            parser.state = returnState;
                                            parser.write(parsedEntity);
                                        } else {
                                            parser[buffer] += parseEntity(parser);
                                            parser.entity = "";
                                            parser.state = returnState;
                                        }
                                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                                    else {
                                        strictFail(parser, "Invalid character in entity name");
                                        parser[buffer] += "&" + parser.entity + c;
                                        parser.entity = "";
                                        parser.state = returnState;
                                    }
                                    continue;
                                default:
                                    throw new Error(parser, "Unknown state: " + parser.state);
                            }
                        } // while
                        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
                        return parser;
                    }
                    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
                        var stringFromCharCode = String.fromCharCode;
                        var floor = Math.floor;
                        var fromCodePoint = function() {
                            var MAX_SIZE = 0x4000;
                            var codeUnits = [];
                            var highSurrogate;
                            var lowSurrogate;
                            var index = -1;
                            var length = arguments.length;
                            if (!length) return "";
                            var result = "";
                            while(++index < length){
                                var codePoint = Number(arguments[index]);
                                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                                codePoint < 0 || // not a valid Unicode code point
                                codePoint > 0x10FFFF || // not a valid Unicode code point
                                floor(codePoint) !== codePoint // not an integer
                                ) throw RangeError("Invalid code point: " + codePoint);
                                if (codePoint <= 0xFFFF) codeUnits.push(codePoint);
                                else {
                                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                                    codePoint -= 0x10000;
                                    highSurrogate = (codePoint >> 10) + 0xD800;
                                    lowSurrogate = codePoint % 0x400 + 0xDC00;
                                    codeUnits.push(highSurrogate, lowSurrogate);
                                }
                                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                                    result += stringFromCharCode.apply(null, codeUnits);
                                    codeUnits.length = 0;
                                }
                            }
                            return result;
                        };
                        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
                            value: fromCodePoint,
                            configurable: true,
                            writable: true
                        });
                        else String.fromCodePoint = fromCodePoint;
                    })();
                })(exports);
            /***/ },
            /***/ 34521: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(31801);
                var define = __webpack_require__(72656);
                var hasDescriptors = __webpack_require__(28198)();
                var gOPD = __webpack_require__(93828);
                var $TypeError = GetIntrinsic("%TypeError%");
                var $floor = GetIntrinsic("%Math.floor%");
                module1.exports = function setFunctionLength(fn, length) {
                    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
                    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
                    var loose = arguments.length > 2 && !!arguments[2];
                    var functionLengthIsConfigurable = true;
                    var functionLengthIsWritable = true;
                    if ("length" in fn && gOPD) {
                        var desc = gOPD(fn, "length");
                        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
                        if (desc && !desc.writable) functionLengthIsWritable = false;
                    }
                    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
                        if (hasDescriptors) define(fn, "length", length, true, true);
                        else define(fn, "length", length);
                    }
                    return fn;
                };
            /***/ },
            /***/ 25021: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(72656);
                var hasDescriptors = __webpack_require__(28198)();
                var functionsHaveConfigurableNames = __webpack_require__(87105).functionsHaveConfigurableNames();
                var $TypeError = TypeError;
                module1.exports = function setFunctionName(fn, name) {
                    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
                    var loose = arguments.length > 2 && !!arguments[2];
                    if (!loose || functionsHaveConfigurableNames) {
                        if (hasDescriptors) define(fn, "name", name, true, true);
                        else define(fn, "name", name);
                    }
                    return fn;
                };
            /***/ },
            /***/ 20202: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module1.exports = Stream;
                var EE = __webpack_require__(5939).EventEmitter;
                var inherits = __webpack_require__(48575);
                inherits(Stream, EE);
                Stream.Readable = __webpack_require__(28193);
                Stream.Writable = __webpack_require__(16667);
                Stream.Duplex = __webpack_require__(53551);
                Stream.Transform = __webpack_require__(10695);
                Stream.PassThrough = __webpack_require__(89371);
                Stream.finished = __webpack_require__(47549);
                Stream.pipeline = __webpack_require__(44858);
                // Backwards-compat with node 0.4.x
                Stream.Stream = Stream;
                // old-style streams.  Note that the pipe method (the only relevant
                // part of this class) is overridden in the Readable class.
                function Stream() {
                    EE.call(this);
                }
                Stream.prototype.pipe = function(dest, options) {
                    var source = this;
                    function ondata(chunk) {
                        if (dest.writable) {
                            if (false === dest.write(chunk) && source.pause) source.pause();
                        }
                    }
                    source.on("data", ondata);
                    function ondrain() {
                        if (source.readable && source.resume) source.resume();
                    }
                    dest.on("drain", ondrain);
                    // If the 'end' option is not supplied, dest.end() will be called when
                    // source gets the 'end' or 'close' events.  Only dest.end() once.
                    if (!dest._isStdio && (!options || options.end !== false)) {
                        source.on("end", onend);
                        source.on("close", onclose);
                    }
                    var didOnEnd = false;
                    function onend() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        dest.end();
                    }
                    function onclose() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        if (typeof dest.destroy === "function") dest.destroy();
                    }
                    // don't leave dangling pipes when there are errors.
                    function onerror(er) {
                        cleanup();
                        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
                    }
                    source.on("error", onerror);
                    dest.on("error", onerror);
                    // remove all the event listeners that were added.
                    function cleanup() {
                        source.removeListener("data", ondata);
                        dest.removeListener("drain", ondrain);
                        source.removeListener("end", onend);
                        source.removeListener("close", onclose);
                        source.removeListener("error", onerror);
                        dest.removeListener("error", onerror);
                        source.removeListener("end", cleanup);
                        source.removeListener("close", cleanup);
                        dest.removeListener("close", cleanup);
                    }
                    source.on("end", cleanup);
                    source.on("close", cleanup);
                    dest.on("close", cleanup);
                    dest.emit("pipe", source);
                    // Allow for unix-like usage: A.pipe(B).pipe(C)
                    return dest;
                };
            /***/ },
            /***/ 75065: /***/ function(module1) {
                "use strict";
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    subClass.__proto__ = superClass;
                }
                var codes = {};
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === "string") return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inheritsLoose(NodeError, _Base);
                        function NodeError(arg1, arg2, arg3) {
                            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
                        }
                        return NodeError;
                    }(Base);
                    NodeError.prototype.name = Base.name;
                    NodeError.prototype.code = code;
                    codes[code] = NodeError;
                } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== "number") start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
                    return 'The value "' + value + '" is invalid for option "' + name + '"';
                }, TypeError);
                createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === "string" && startsWith(expected, "not ")) {
                        determiner = "must not be";
                        expected = expected.replace(/^not /, "");
                    } else determiner = "must be";
                    var msg;
                    if (endsWith(name, " argument")) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    else {
                        var type = includes(name, ".") ? "property" : "argument";
                        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    }
                    msg += ". Received type ".concat(typeof actual);
                    return msg;
                }, TypeError);
                createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
                createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
                    return "The " + name + " method is not implemented";
                });
                createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
                createErrorType("ERR_STREAM_DESTROYED", function(name) {
                    return "Cannot call " + name + " after a stream was destroyed";
                });
                createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
                createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
                createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
                createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
                createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
                    return "Unknown encoding: " + arg;
                }, TypeError);
                createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
                module1.exports.q = codes;
            /***/ },
            /***/ 53551: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a duplex stream is just a stream that is both readable and writable.
                // Since JS doesn't have multiple prototypal inheritance, this class
                // prototypally inherits from Readable, and then parasitically from
                // Writable.
                /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
                    var keys = [];
                    for(var key in obj)keys.push(key);
                    return keys;
                };
                /*</replacement>*/ module1.exports = Duplex;
                var Readable = __webpack_require__(28193);
                var Writable = __webpack_require__(16667);
                __webpack_require__(48575)(Duplex, Readable);
                // Allow the keys array to be GC'ed.
                var keys = objectKeys(Writable.prototype);
                for(var v = 0; v < keys.length; v++){
                    var method = keys[v];
                    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
                }
                function Duplex(options) {
                    if (!(this instanceof Duplex)) return new Duplex(options);
                    Readable.call(this, options);
                    Writable.call(this, options);
                    this.allowHalfOpen = true;
                    if (options) {
                        if (options.readable === false) this.readable = false;
                        if (options.writable === false) this.writable = false;
                        if (options.allowHalfOpen === false) {
                            this.allowHalfOpen = false;
                            this.once("end", onend);
                        }
                    }
                }
                Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.highWaterMark;
                    }
                });
                Object.defineProperty(Duplex.prototype, "writableBuffer", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                });
                Object.defineProperty(Duplex.prototype, "writableLength", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.length;
                    }
                });
                // the no-half-open enforcer
                function onend() {
                    // If the writable side ended, then we're ok.
                    if (this._writableState.ended) return;
                    // no more data can be written.
                    // But allow more writes to happen in this tick.
                    process.nextTick(onEndNT, this);
                }
                function onEndNT(self1) {
                    self1.end();
                }
                Object.defineProperty(Duplex.prototype, "destroyed", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        if (this._readableState === undefined || this._writableState === undefined) return false;
                        return this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function set(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (this._readableState === undefined || this._writableState === undefined) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._readableState.destroyed = value;
                        this._writableState.destroyed = value;
                    }
                });
            /***/ },
            /***/ 89371: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a passthrough stream.
                // basically just the most minimal sort of Transform stream.
                // Every written chunk gets output as-is.
                module1.exports = PassThrough;
                var Transform = __webpack_require__(10695);
                __webpack_require__(48575)(PassThrough, Transform);
                function PassThrough(options) {
                    if (!(this instanceof PassThrough)) return new PassThrough(options);
                    Transform.call(this, options);
                }
                PassThrough.prototype._transform = function(chunk, encoding, cb) {
                    cb(null, chunk);
                };
            /***/ },
            /***/ 28193: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module1.exports = Readable;
                /*<replacement>*/ var Duplex;
                /*</replacement>*/ Readable.ReadableState = ReadableState;
                /*<replacement>*/ var EE = __webpack_require__(5939).EventEmitter;
                var EElistenerCount = function EElistenerCount(emitter, type) {
                    return emitter.listeners(type).length;
                };
                /*</replacement>*/ /*<replacement>*/ var Stream = __webpack_require__(5908);
                /*</replacement>*/ var Buffer = __webpack_require__(43060).Buffer;
                var OurUint8Array = (typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
                function _uint8ArrayToBuffer(chunk) {
                    return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
                /*<replacement>*/ var debugUtil = __webpack_require__(40964);
                var debug;
                if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
                else debug = function debug() {};
                /*</replacement>*/ var BufferList = __webpack_require__(55681);
                var destroyImpl = __webpack_require__(89930);
                var _require = __webpack_require__(39025), getHighWaterMark = _require.getHighWaterMark;
                var _require$codes = __webpack_require__(75065)/* .codes */ .q, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                // Lazy loaded to improve the startup performance.
                var StringDecoder;
                var createReadableStreamAsyncIterator;
                var from;
                __webpack_require__(48575)(Readable, Stream);
                var errorOrDestroy = destroyImpl.errorOrDestroy;
                var kProxyEvents = [
                    "error",
                    "close",
                    "destroy",
                    "pause",
                    "resume"
                ];
                function prependListener(emitter, event, fn) {
                    // Sadly this is not cacheable as some libraries bundle their own
                    // event emitter implementation with them.
                    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
                    // This is a hack to make sure that our error handler is attached before any
                    // userland ones.  NEVER DO THIS. This is here only because this code needs
                    // to continue to work with older versions of Node.js that do not include
                    // the prependListener() method. The goal is to eventually remove this hack.
                    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
                    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
                    else emitter._events[event] = [
                        fn,
                        emitter._events[event]
                    ];
                }
                function ReadableState(options, stream, isDuplex) {
                    Duplex = Duplex || __webpack_require__(53551);
                    options = options || {};
                    // Duplex streams are both readable and writable, but share
                    // the same options object.
                    // However, some cases require setting options to different
                    // values for the readable and the writable sides of the duplex stream.
                    // These options can be provided separately as readableXXX and writableXXX.
                    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
                    // object stream flag. Used to make read(n) ignore n and to
                    // make all the buffer merging and length checks go away
                    this.objectMode = !!options.objectMode;
                    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
                    // the point at which it stops calling _read() to fill the buffer
                    // Note: 0 is a valid value, means "don't call _read preemptively ever"
                    this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
                    // A linked list is used to store data chunks instead of an array because the
                    // linked list can remove elements from the beginning faster than
                    // array.shift()
                    this.buffer = new BufferList();
                    this.length = 0;
                    this.pipes = null;
                    this.pipesCount = 0;
                    this.flowing = null;
                    this.ended = false;
                    this.endEmitted = false;
                    this.reading = false;
                    // a flag to be able to tell if the event 'readable'/'data' is emitted
                    // immediately, or on a later tick.  We set this to true at first, because
                    // any actions that shouldn't happen until "later" should generally also
                    // not happen before the first read call.
                    this.sync = true;
                    // whenever we return null, then we set a flag to say
                    // that we're awaiting a 'readable' event emission.
                    this.needReadable = false;
                    this.emittedReadable = false;
                    this.readableListening = false;
                    this.resumeScheduled = false;
                    this.paused = true;
                    // Should close be emitted on destroy. Defaults to true.
                    this.emitClose = options.emitClose !== false;
                    // Should .destroy() be called after 'end' (and potentially 'finish')
                    this.autoDestroy = !!options.autoDestroy;
                    // has it been destroyed
                    this.destroyed = false;
                    // Crypto is kind of old and crusty.  Historically, its default string
                    // encoding is 'binary' so we have to make this configurable.
                    // Everything else in the universe uses 'utf8', though.
                    this.defaultEncoding = options.defaultEncoding || "utf8";
                    // the number of writers that are awaiting a drain event in .pipe()s
                    this.awaitDrain = 0;
                    // if true, a maybeReadMore has been scheduled
                    this.readingMore = false;
                    this.decoder = null;
                    this.encoding = null;
                    if (options.encoding) {
                        if (!StringDecoder) StringDecoder = __webpack_require__(10301)/* .StringDecoder */ .s;
                        this.decoder = new StringDecoder(options.encoding);
                        this.encoding = options.encoding;
                    }
                }
                function Readable(options) {
                    Duplex = Duplex || __webpack_require__(53551);
                    if (!(this instanceof Readable)) return new Readable(options);
                    // Checking for a Stream.Duplex instance is faster here instead of inside
                    // the ReadableState constructor, at least with V8 6.5
                    var isDuplex = this instanceof Duplex;
                    this._readableState = new ReadableState(options, this, isDuplex);
                    // legacy
                    this.readable = true;
                    if (options) {
                        if (typeof options.read === "function") this._read = options.read;
                        if (typeof options.destroy === "function") this._destroy = options.destroy;
                    }
                    Stream.call(this);
                }
                Object.defineProperty(Readable.prototype, "destroyed", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        if (this._readableState === undefined) return false;
                        return this._readableState.destroyed;
                    },
                    set: function set(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (!this._readableState) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._readableState.destroyed = value;
                    }
                });
                Readable.prototype.destroy = destroyImpl.destroy;
                Readable.prototype._undestroy = destroyImpl.undestroy;
                Readable.prototype._destroy = function(err, cb) {
                    cb(err);
                };
                // Manually shove something into the read() buffer.
                // This returns true if the highWaterMark has not been hit yet,
                // similar to how Writable.write() returns true if you should
                // write() some more.
                Readable.prototype.push = function(chunk, encoding) {
                    var state = this._readableState;
                    var skipChunkCheck;
                    if (!state.objectMode) {
                        if (typeof chunk === "string") {
                            encoding = encoding || state.defaultEncoding;
                            if (encoding !== state.encoding) {
                                chunk = Buffer.from(chunk, encoding);
                                encoding = "";
                            }
                            skipChunkCheck = true;
                        }
                    } else skipChunkCheck = true;
                    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
                };
                // Unshift should *always* be something directly out of read()
                Readable.prototype.unshift = function(chunk) {
                    return readableAddChunk(this, chunk, null, true, false);
                };
                function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
                    debug("readableAddChunk", chunk);
                    var state = stream._readableState;
                    if (chunk === null) {
                        state.reading = false;
                        onEofChunk(stream, state);
                    } else {
                        var er;
                        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                        if (er) errorOrDestroy(stream, er);
                        else if (state.objectMode || chunk && chunk.length > 0) {
                            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
                            if (addToFront) {
                                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                                else addChunk(stream, state, chunk, true);
                            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                            else if (state.destroyed) return false;
                            else {
                                state.reading = false;
                                if (state.decoder && !encoding) {
                                    chunk = state.decoder.write(chunk);
                                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                                    else maybeReadMore(stream, state);
                                } else addChunk(stream, state, chunk, false);
                            }
                        } else if (!addToFront) {
                            state.reading = false;
                            maybeReadMore(stream, state);
                        }
                    }
                    // We can push more data if we are below the highWaterMark.
                    // Also, if we have no data yet, we can stand some more bytes.
                    // This is to work around cases where hwm=0, such as the repl.
                    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
                }
                function addChunk(stream, state, chunk, addToFront) {
                    if (state.flowing && state.length === 0 && !state.sync) {
                        state.awaitDrain = 0;
                        stream.emit("data", chunk);
                    } else {
                        // update the buffer info.
                        state.length += state.objectMode ? 1 : chunk.length;
                        if (addToFront) state.buffer.unshift(chunk);
                        else state.buffer.push(chunk);
                        if (state.needReadable) emitReadable(stream);
                    }
                    maybeReadMore(stream, state);
                }
                function chunkInvalid(state, chunk) {
                    var er;
                    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
                        "string",
                        "Buffer",
                        "Uint8Array"
                    ], chunk);
                    return er;
                }
                Readable.prototype.isPaused = function() {
                    return this._readableState.flowing === false;
                };
                // backwards compatibility.
                Readable.prototype.setEncoding = function(enc) {
                    if (!StringDecoder) StringDecoder = __webpack_require__(10301)/* .StringDecoder */ .s;
                    var decoder = new StringDecoder(enc);
                    this._readableState.decoder = decoder;
                    // If setEncoding(null), decoder.encoding equals utf8
                    this._readableState.encoding = this._readableState.decoder.encoding;
                    // Iterate over current buffer to convert already stored Buffers:
                    var p = this._readableState.buffer.head;
                    var content = "";
                    while(p !== null){
                        content += decoder.write(p.data);
                        p = p.next;
                    }
                    this._readableState.buffer.clear();
                    if (content !== "") this._readableState.buffer.push(content);
                    this._readableState.length = content.length;
                    return this;
                };
                // Don't raise the hwm > 1GB
                var MAX_HWM = 0x40000000;
                function computeNewHighWaterMark(n) {
                    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
                    n = MAX_HWM;
                    else {
                        // Get the next highest power of 2 to prevent increasing hwm excessively in
                        // tiny amounts
                        n--;
                        n |= n >>> 1;
                        n |= n >>> 2;
                        n |= n >>> 4;
                        n |= n >>> 8;
                        n |= n >>> 16;
                        n++;
                    }
                    return n;
                }
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function howMuchToRead(n, state) {
                    if (n <= 0 || state.length === 0 && state.ended) return 0;
                    if (state.objectMode) return 1;
                    if (n !== n) {
                        // Only flow one buffer at a time
                        if (state.flowing && state.length) return state.buffer.head.data.length;
                        else return state.length;
                    }
                    // If we're asking for more than the current hwm, then raise the hwm.
                    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
                    if (n <= state.length) return n;
                    // Don't have enough
                    if (!state.ended) {
                        state.needReadable = true;
                        return 0;
                    }
                    return state.length;
                }
                // you can override either this method, or the async _read(n) below.
                Readable.prototype.read = function(n) {
                    debug("read", n);
                    n = parseInt(n, 10);
                    var state = this._readableState;
                    var nOrig = n;
                    if (n !== 0) state.emittedReadable = false;
                    // if we're doing read(0) to trigger a readable event, but we
                    // already have a bunch of data in the buffer, then just trigger
                    // the 'readable' event and move on.
                    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
                        debug("read: emitReadable", state.length, state.ended);
                        if (state.length === 0 && state.ended) endReadable(this);
                        else emitReadable(this);
                        return null;
                    }
                    n = howMuchToRead(n, state);
                    // if we've ended, and we're now clear, then finish it up.
                    if (n === 0 && state.ended) {
                        if (state.length === 0) endReadable(this);
                        return null;
                    }
                    // All the actual chunk generation logic needs to be
                    // *below* the call to _read.  The reason is that in certain
                    // synthetic stream cases, such as passthrough streams, _read
                    // may be a completely synchronous operation which may change
                    // the state of the read buffer, providing enough data when
                    // before there was *not* enough.
                    //
                    // So, the steps are:
                    // 1. Figure out what the state of things will be after we do
                    // a read from the buffer.
                    //
                    // 2. If that resulting state will trigger a _read, then call _read.
                    // Note that this may be asynchronous, or synchronous.  Yes, it is
                    // deeply ugly to write APIs this way, but that still doesn't mean
                    // that the Readable class should behave improperly, as streams are
                    // designed to be sync/async agnostic.
                    // Take note if the _read call is sync or async (ie, if the read call
                    // has returned yet), so that we know whether or not it's safe to emit
                    // 'readable' etc.
                    //
                    // 3. Actually pull the requested chunks out of the buffer and return.
                    // if we need a readable event, then we need to do some reading.
                    var doRead = state.needReadable;
                    debug("need readable", doRead);
                    // if we currently have less than the highWaterMark, then also read some
                    if (state.length === 0 || state.length - n < state.highWaterMark) {
                        doRead = true;
                        debug("length less than watermark", doRead);
                    }
                    // however, if we've ended, then there's no point, and if we're already
                    // reading, then it's unnecessary.
                    if (state.ended || state.reading) {
                        doRead = false;
                        debug("reading or ended", doRead);
                    } else if (doRead) {
                        debug("do read");
                        state.reading = true;
                        state.sync = true;
                        // if the length is currently zero, then we *need* a readable event.
                        if (state.length === 0) state.needReadable = true;
                        // call internal read method
                        this._read(state.highWaterMark);
                        state.sync = false;
                        // If _read pushed data synchronously, then `reading` will be false,
                        // and we need to re-evaluate how much data we can return to the user.
                        if (!state.reading) n = howMuchToRead(nOrig, state);
                    }
                    var ret;
                    if (n > 0) ret = fromList(n, state);
                    else ret = null;
                    if (ret === null) {
                        state.needReadable = state.length <= state.highWaterMark;
                        n = 0;
                    } else {
                        state.length -= n;
                        state.awaitDrain = 0;
                    }
                    if (state.length === 0) {
                        // If we have nothing in the buffer, then we want to know
                        // as soon as we *do* get something into the buffer.
                        if (!state.ended) state.needReadable = true;
                        // If we tried to read() past the EOF, then emit end on the next tick.
                        if (nOrig !== n && state.ended) endReadable(this);
                    }
                    if (ret !== null) this.emit("data", ret);
                    return ret;
                };
                function onEofChunk(stream, state) {
                    debug("onEofChunk");
                    if (state.ended) return;
                    if (state.decoder) {
                        var chunk = state.decoder.end();
                        if (chunk && chunk.length) {
                            state.buffer.push(chunk);
                            state.length += state.objectMode ? 1 : chunk.length;
                        }
                    }
                    state.ended = true;
                    if (state.sync) // if we are sync, wait until next tick to emit the data.
                    // Otherwise we risk emitting data in the flow()
                    // the readable code triggers during a read() call
                    emitReadable(stream);
                    else {
                        // emit 'readable' now to make sure it gets picked up.
                        state.needReadable = false;
                        if (!state.emittedReadable) {
                            state.emittedReadable = true;
                            emitReadable_(stream);
                        }
                    }
                }
                // Don't emit readable right away in sync mode, because this can trigger
                // another read() call => stack overflow.  This way, it might trigger
                // a nextTick recursion warning, but that's not so bad.
                function emitReadable(stream) {
                    var state = stream._readableState;
                    debug("emitReadable", state.needReadable, state.emittedReadable);
                    state.needReadable = false;
                    if (!state.emittedReadable) {
                        debug("emitReadable", state.flowing);
                        state.emittedReadable = true;
                        process.nextTick(emitReadable_, stream);
                    }
                }
                function emitReadable_(stream) {
                    var state = stream._readableState;
                    debug("emitReadable_", state.destroyed, state.length, state.ended);
                    if (!state.destroyed && (state.length || state.ended)) {
                        stream.emit("readable");
                        state.emittedReadable = false;
                    }
                    // The stream needs another readable event if
                    // 1. It is not flowing, as the flow mechanism will take
                    //    care of it.
                    // 2. It is not ended.
                    // 3. It is below the highWaterMark, so we can schedule
                    //    another readable later.
                    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
                    flow(stream);
                }
                // at this point, the user has presumably seen the 'readable' event,
                // and called read() to consume some data.  that may have triggered
                // in turn another _read(n) call, in which case reading = true if
                // it's in progress.
                // However, if we're not ended, or reading, and the length < hwm,
                // then go ahead and try to read some more preemptively.
                function maybeReadMore(stream, state) {
                    if (!state.readingMore) {
                        state.readingMore = true;
                        process.nextTick(maybeReadMore_, stream, state);
                    }
                }
                function maybeReadMore_(stream, state) {
                    // Attempt to read more data if we should.
                    //
                    // The conditions for reading more data are (one of):
                    // - Not enough data buffered (state.length < state.highWaterMark). The loop
                    //   is responsible for filling the buffer with enough data if such data
                    //   is available. If highWaterMark is 0 and we are not in the flowing mode
                    //   we should _not_ attempt to buffer any extra data. We'll get more data
                    //   when the stream consumer calls read() instead.
                    // - No data in the buffer, and the stream is in flowing mode. In this mode
                    //   the loop below is responsible for ensuring read() is called. Failing to
                    //   call read here would abort the flow and there's no other mechanism for
                    //   continuing the flow if the stream consumer has just subscribed to the
                    //   'data' event.
                    //
                    // In addition to the above conditions to keep reading data, the following
                    // conditions prevent the data from being read:
                    // - The stream has ended (state.ended).
                    // - There is already a pending 'read' operation (state.reading). This is a
                    //   case where the the stream has called the implementation defined _read()
                    //   method, but they are processing the call asynchronously and have _not_
                    //   called push() with new data. In this case we skip performing more
                    //   read()s. The execution ends in this method again after the _read() ends
                    //   up calling push() with more data.
                    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
                        var len = state.length;
                        debug("maybeReadMore read 0");
                        stream.read(0);
                        if (len === state.length) break;
                    }
                    state.readingMore = false;
                }
                // abstract method.  to be overridden in specific implementation classes.
                // call cb(er, data) where data is <= n in length.
                // for virtual (non-string, non-buffer) streams, "length" is somewhat
                // arbitrary, and perhaps not very meaningful.
                Readable.prototype._read = function(n) {
                    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
                };
                Readable.prototype.pipe = function(dest, pipeOpts) {
                    var src = this;
                    var state = this._readableState;
                    switch(state.pipesCount){
                        case 0:
                            state.pipes = dest;
                            break;
                        case 1:
                            state.pipes = [
                                state.pipes,
                                dest
                            ];
                            break;
                        default:
                            state.pipes.push(dest);
                            break;
                    }
                    state.pipesCount += 1;
                    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
                    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
                    var endFn = doEnd ? onend : unpipe;
                    if (state.endEmitted) process.nextTick(endFn);
                    else src.once("end", endFn);
                    dest.on("unpipe", onunpipe);
                    function onunpipe(readable, unpipeInfo) {
                        debug("onunpipe");
                        if (readable === src) {
                            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                                unpipeInfo.hasUnpiped = true;
                                cleanup();
                            }
                        }
                    }
                    function onend() {
                        debug("onend");
                        dest.end();
                    }
                    // when the dest drains, it reduces the awaitDrain counter
                    // on the source.  This would be more elegant with a .once()
                    // handler in flow(), but adding and removing repeatedly is
                    // too slow.
                    var ondrain = pipeOnDrain(src);
                    dest.on("drain", ondrain);
                    var cleanedUp = false;
                    function cleanup() {
                        debug("cleanup");
                        // cleanup event handlers once the pipe is broken
                        dest.removeListener("close", onclose);
                        dest.removeListener("finish", onfinish);
                        dest.removeListener("drain", ondrain);
                        dest.removeListener("error", onerror);
                        dest.removeListener("unpipe", onunpipe);
                        src.removeListener("end", onend);
                        src.removeListener("end", unpipe);
                        src.removeListener("data", ondata);
                        cleanedUp = true;
                        // if the reader is waiting for a drain event from this
                        // specific writer, then it would cause it to never start
                        // flowing again.
                        // So, if this is awaiting a drain, then we just call it now.
                        // If we don't know, then assume that we are waiting for one.
                        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
                    }
                    src.on("data", ondata);
                    function ondata(chunk) {
                        debug("ondata");
                        var ret = dest.write(chunk);
                        debug("dest.write", ret);
                        if (ret === false) {
                            // If the user unpiped during `dest.write()`, it is possible
                            // to get stuck in a permanently paused state if that write
                            // also returned false.
                            // => Check whether `dest` is still a piping destination.
                            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                                debug("false write response, pause", state.awaitDrain);
                                state.awaitDrain++;
                            }
                            src.pause();
                        }
                    }
                    // if the dest has an error, then stop piping into it.
                    // however, don't suppress the throwing behavior for this.
                    function onerror(er) {
                        debug("onerror", er);
                        unpipe();
                        dest.removeListener("error", onerror);
                        if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
                    }
                    // Make sure our error handler is attached before userland ones.
                    prependListener(dest, "error", onerror);
                    // Both close and finish should trigger unpipe, but only once.
                    function onclose() {
                        dest.removeListener("finish", onfinish);
                        unpipe();
                    }
                    dest.once("close", onclose);
                    function onfinish() {
                        debug("onfinish");
                        dest.removeListener("close", onclose);
                        unpipe();
                    }
                    dest.once("finish", onfinish);
                    function unpipe() {
                        debug("unpipe");
                        src.unpipe(dest);
                    }
                    // tell the dest that it's being piped to
                    dest.emit("pipe", src);
                    // start the flow if it hasn't been started already.
                    if (!state.flowing) {
                        debug("pipe resume");
                        src.resume();
                    }
                    return dest;
                };
                function pipeOnDrain(src) {
                    return function pipeOnDrainFunctionResult() {
                        var state = src._readableState;
                        debug("pipeOnDrain", state.awaitDrain);
                        if (state.awaitDrain) state.awaitDrain--;
                        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
                            state.flowing = true;
                            flow(src);
                        }
                    };
                }
                Readable.prototype.unpipe = function(dest) {
                    var state = this._readableState;
                    var unpipeInfo = {
                        hasUnpiped: false
                    };
                    // if we're not piping anywhere, then do nothing.
                    if (state.pipesCount === 0) return this;
                    // just one destination.  most common case.
                    if (state.pipesCount === 1) {
                        // passed in one, but it's not the right one.
                        if (dest && dest !== state.pipes) return this;
                        if (!dest) dest = state.pipes;
                        // got a match.
                        state.pipes = null;
                        state.pipesCount = 0;
                        state.flowing = false;
                        if (dest) dest.emit("unpipe", this, unpipeInfo);
                        return this;
                    }
                    // slow case. multiple pipe destinations.
                    if (!dest) {
                        // remove all.
                        var dests = state.pipes;
                        var len = state.pipesCount;
                        state.pipes = null;
                        state.pipesCount = 0;
                        state.flowing = false;
                        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
                            hasUnpiped: false
                        });
                        return this;
                    }
                    // try to find the right one.
                    var index = indexOf(state.pipes, dest);
                    if (index === -1) return this;
                    state.pipes.splice(index, 1);
                    state.pipesCount -= 1;
                    if (state.pipesCount === 1) state.pipes = state.pipes[0];
                    dest.emit("unpipe", this, unpipeInfo);
                    return this;
                };
                // set up data events if they are asked for
                // Ensure readable listeners eventually get something
                Readable.prototype.on = function(ev, fn) {
                    var res = Stream.prototype.on.call(this, ev, fn);
                    var state = this._readableState;
                    if (ev === "data") {
                        // update readableListening so that resume() may be a no-op
                        // a few lines down. This is needed to support once('readable').
                        state.readableListening = this.listenerCount("readable") > 0;
                        // Try start flowing on next tick if stream isn't explicitly paused
                        if (state.flowing !== false) this.resume();
                    } else if (ev === "readable") {
                        if (!state.endEmitted && !state.readableListening) {
                            state.readableListening = state.needReadable = true;
                            state.flowing = false;
                            state.emittedReadable = false;
                            debug("on readable", state.length, state.reading);
                            if (state.length) emitReadable(this);
                            else if (!state.reading) process.nextTick(nReadingNextTick, this);
                        }
                    }
                    return res;
                };
                Readable.prototype.addListener = Readable.prototype.on;
                Readable.prototype.removeListener = function(ev, fn) {
                    var res = Stream.prototype.removeListener.call(this, ev, fn);
                    if (ev === "readable") // We need to check if there is someone still listening to
                    // readable and reset the state. However this needs to happen
                    // after readable has been emitted but before I/O (nextTick) to
                    // support once('readable', fn) cycles. This means that calling
                    // resume within the same tick will have no
                    // effect.
                    process.nextTick(updateReadableListening, this);
                    return res;
                };
                Readable.prototype.removeAllListeners = function(ev) {
                    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
                    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
                    // readable and reset the state. However this needs to happen
                    // after readable has been emitted but before I/O (nextTick) to
                    // support once('readable', fn) cycles. This means that calling
                    // resume within the same tick will have no
                    // effect.
                    process.nextTick(updateReadableListening, this);
                    return res;
                };
                function updateReadableListening(self1) {
                    var state = self1._readableState;
                    state.readableListening = self1.listenerCount("readable") > 0;
                    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
                    // the upcoming resume will not flow.
                    state.flowing = true;
                    else if (self1.listenerCount("data") > 0) self1.resume();
                }
                function nReadingNextTick(self1) {
                    debug("readable nexttick read 0");
                    self1.read(0);
                }
                // pause() and resume() are remnants of the legacy readable stream API
                // If the user uses them, then switch into old mode.
                Readable.prototype.resume = function() {
                    var state = this._readableState;
                    if (!state.flowing) {
                        debug("resume");
                        // we flow only if there is no one listening
                        // for readable, but we still have to call
                        // resume()
                        state.flowing = !state.readableListening;
                        resume(this, state);
                    }
                    state.paused = false;
                    return this;
                };
                function resume(stream, state) {
                    if (!state.resumeScheduled) {
                        state.resumeScheduled = true;
                        process.nextTick(resume_, stream, state);
                    }
                }
                function resume_(stream, state) {
                    debug("resume", state.reading);
                    if (!state.reading) stream.read(0);
                    state.resumeScheduled = false;
                    stream.emit("resume");
                    flow(stream);
                    if (state.flowing && !state.reading) stream.read(0);
                }
                Readable.prototype.pause = function() {
                    debug("call pause flowing=%j", this._readableState.flowing);
                    if (this._readableState.flowing !== false) {
                        debug("pause");
                        this._readableState.flowing = false;
                        this.emit("pause");
                    }
                    this._readableState.paused = true;
                    return this;
                };
                function flow(stream) {
                    var state = stream._readableState;
                    debug("flow", state.flowing);
                    while(state.flowing && stream.read() !== null);
                }
                // wrap an old-style stream as the async data source.
                // This is *not* part of the readable stream interface.
                // It is an ugly unfortunate mess of history.
                Readable.prototype.wrap = function(stream) {
                    var _this = this;
                    var state = this._readableState;
                    var paused = false;
                    stream.on("end", function() {
                        debug("wrapped end");
                        if (state.decoder && !state.ended) {
                            var chunk = state.decoder.end();
                            if (chunk && chunk.length) _this.push(chunk);
                        }
                        _this.push(null);
                    });
                    stream.on("data", function(chunk) {
                        debug("wrapped data");
                        if (state.decoder) chunk = state.decoder.write(chunk);
                        // don't skip over falsy values in objectMode
                        if (state.objectMode && (chunk === null || chunk === undefined)) return;
                        else if (!state.objectMode && (!chunk || !chunk.length)) return;
                        var ret = _this.push(chunk);
                        if (!ret) {
                            paused = true;
                            stream.pause();
                        }
                    });
                    // proxy all the other methods.
                    // important when wrapping filters and duplexes.
                    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
                        return function methodWrapReturnFunction() {
                            return stream[method].apply(stream, arguments);
                        };
                    }(i);
                    // proxy certain important events.
                    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
                    // when we try to consume some more bytes, simply unpause the
                    // underlying stream.
                    this._read = function(n) {
                        debug("wrapped _read", n);
                        if (paused) {
                            paused = false;
                            stream.resume();
                        }
                    };
                    return this;
                };
                if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
                    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = __webpack_require__(90933);
                    return createReadableStreamAsyncIterator(this);
                };
                Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState.highWaterMark;
                    }
                });
                Object.defineProperty(Readable.prototype, "readableBuffer", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState && this._readableState.buffer;
                    }
                });
                Object.defineProperty(Readable.prototype, "readableFlowing", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState.flowing;
                    },
                    set: function set(state) {
                        if (this._readableState) this._readableState.flowing = state;
                    }
                });
                // exposed for testing purposes only.
                Readable._fromList = fromList;
                Object.defineProperty(Readable.prototype, "readableLength", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState.length;
                    }
                });
                // Pluck off n bytes from an array of buffers.
                // Length is the combined lengths of all the buffers in the list.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function fromList(n, state) {
                    // nothing buffered
                    if (state.length === 0) return null;
                    var ret;
                    if (state.objectMode) ret = state.buffer.shift();
                    else if (!n || n >= state.length) {
                        // read it all, truncate the list
                        if (state.decoder) ret = state.buffer.join("");
                        else if (state.buffer.length === 1) ret = state.buffer.first();
                        else ret = state.buffer.concat(state.length);
                        state.buffer.clear();
                    } else // read part of list
                    ret = state.buffer.consume(n, state.decoder);
                    return ret;
                }
                function endReadable(stream) {
                    var state = stream._readableState;
                    debug("endReadable", state.endEmitted);
                    if (!state.endEmitted) {
                        state.ended = true;
                        process.nextTick(endReadableNT, state, stream);
                    }
                }
                function endReadableNT(state, stream) {
                    debug("endReadableNT", state.endEmitted, state.length);
                    // Check that we didn't get one last unshift.
                    if (!state.endEmitted && state.length === 0) {
                        state.endEmitted = true;
                        stream.readable = false;
                        stream.emit("end");
                        if (state.autoDestroy) {
                            // In case of duplex streams we need a way to detect
                            // if the writable side is ready for autoDestroy as well
                            var wState = stream._writableState;
                            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
                        }
                    }
                }
                if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
                    if (from === undefined) from = __webpack_require__(24881);
                    return from(Readable, iterable, opts);
                };
                function indexOf(xs, x) {
                    for(var i = 0, l = xs.length; i < l; i++){
                        if (xs[i] === x) return i;
                    }
                    return -1;
                }
            /***/ },
            /***/ 10695: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a transform stream is a readable/writable stream where you do
                // something with the data.  Sometimes it's called a "filter",
                // but that's not a great name for it, since that implies a thing where
                // some bits pass through, and others are simply ignored.  (That would
                // be a valid example of a transform, of course.)
                //
                // While the output is causally related to the input, it's not a
                // necessarily symmetric or synchronous transformation.  For example,
                // a zlib stream might take multiple plain-text writes(), and then
                // emit a single compressed chunk some time in the future.
                //
                // Here's how this works:
                //
                // The Transform stream has all the aspects of the readable and writable
                // stream classes.  When you write(chunk), that calls _write(chunk,cb)
                // internally, and returns false if there's a lot of pending writes
                // buffered up.  When you call read(), that calls _read(n) until
                // there's enough pending readable data buffered up.
                //
                // In a transform stream, the written data is placed in a buffer.  When
                // _read(n) is called, it transforms the queued up data, calling the
                // buffered _write cb's as it consumes chunks.  If consuming a single
                // written chunk would result in multiple output chunks, then the first
                // outputted bit calls the readcb, and subsequent chunks just go into
                // the read buffer, and will cause it to emit 'readable' if necessary.
                //
                // This way, back-pressure is actually determined by the reading side,
                // since _read has to be called to start processing a new chunk.  However,
                // a pathological inflate type of transform can cause excessive buffering
                // here.  For example, imagine a stream where every byte of input is
                // interpreted as an integer from 0-255, and then results in that many
                // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
                // 1kb of data being output.  In this case, you could write a very small
                // amount of input, and end up with a very large amount of output.  In
                // such a pathological inflating mechanism, there'd be no way to tell
                // the system to stop doing the transform.  A single 4MB write could
                // cause the system to run out of memory.
                //
                // However, even in such a pathological case, only a single written chunk
                // would be consumed, and then the rest would wait (un-transformed) until
                // the results of the previous transformed chunk were consumed.
                module1.exports = Transform;
                var _require$codes = __webpack_require__(75065)/* .codes */ .q, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
                var Duplex = __webpack_require__(53551);
                __webpack_require__(48575)(Transform, Duplex);
                function afterTransform(er, data) {
                    var ts = this._transformState;
                    ts.transforming = false;
                    var cb = ts.writecb;
                    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
                    ts.writechunk = null;
                    ts.writecb = null;
                    if (data != null) // single equals check for both `null` and `undefined`
                    this.push(data);
                    cb(er);
                    var rs = this._readableState;
                    rs.reading = false;
                    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                }
                function Transform(options) {
                    if (!(this instanceof Transform)) return new Transform(options);
                    Duplex.call(this, options);
                    this._transformState = {
                        afterTransform: afterTransform.bind(this),
                        needTransform: false,
                        transforming: false,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    };
                    // start out asking for a readable event once data is transformed.
                    this._readableState.needReadable = true;
                    // we have implemented the _read method, and done the other things
                    // that Readable wants before the first _read call, so unset the
                    // sync guard flag.
                    this._readableState.sync = false;
                    if (options) {
                        if (typeof options.transform === "function") this._transform = options.transform;
                        if (typeof options.flush === "function") this._flush = options.flush;
                    }
                    // When the writable side finishes, then flush out anything remaining.
                    this.on("prefinish", prefinish);
                }
                function prefinish() {
                    var _this = this;
                    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
                        done(_this, er, data);
                    });
                    else done(this, null, null);
                }
                Transform.prototype.push = function(chunk, encoding) {
                    this._transformState.needTransform = false;
                    return Duplex.prototype.push.call(this, chunk, encoding);
                };
                // This is the part where you do stuff!
                // override this function in implementation classes.
                // 'chunk' is an input chunk.
                //
                // Call `push(newChunk)` to pass along transformed output
                // to the readable side.  You may call 'push' zero or more times.
                //
                // Call `cb(err)` when you are done with this chunk.  If you pass
                // an error, then that'll put the hurt on the whole operation.  If you
                // never call cb(), then you'll never get another chunk.
                Transform.prototype._transform = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
                };
                Transform.prototype._write = function(chunk, encoding, cb) {
                    var ts = this._transformState;
                    ts.writecb = cb;
                    ts.writechunk = chunk;
                    ts.writeencoding = encoding;
                    if (!ts.transforming) {
                        var rs = this._readableState;
                        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                    }
                };
                // Doesn't matter what the args are here.
                // _transform does all the work.
                // That we got here means that the readable side wants more data.
                Transform.prototype._read = function(n) {
                    var ts = this._transformState;
                    if (ts.writechunk !== null && !ts.transforming) {
                        ts.transforming = true;
                        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
                    } else // mark that we need a transform, so that any data that comes in
                    // will get processed, now that we've asked for it.
                    ts.needTransform = true;
                };
                Transform.prototype._destroy = function(err, cb) {
                    Duplex.prototype._destroy.call(this, err, function(err2) {
                        cb(err2);
                    });
                };
                function done(stream, er, data) {
                    if (er) return stream.emit("error", er);
                    if (data != null) // single equals check for both `null` and `undefined`
                    stream.push(data);
                    // TODO(BridgeAR): Write a test for these two error cases
                    // if there's nothing in the write buffer, then that means
                    // that nothing more will ever be provided
                    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
                    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
                    return stream.push(null);
                }
            /***/ },
            /***/ 16667: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // A bit simpler than readable streams.
                // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                // the drain event emission and buffering.
                module1.exports = Writable;
                /* <replacement> */ function WriteReq(chunk, encoding, cb) {
                    this.chunk = chunk;
                    this.encoding = encoding;
                    this.callback = cb;
                    this.next = null;
                }
                // It seems a linked list but it is not
                // there will be only 2 of these for each stream
                function CorkedRequest(state) {
                    var _this = this;
                    this.next = null;
                    this.entry = null;
                    this.finish = function() {
                        onCorkedFinish(_this, state);
                    };
                }
                /* </replacement> */ /*<replacement>*/ var Duplex;
                /*</replacement>*/ Writable.WritableState = WritableState;
                /*<replacement>*/ var internalUtil = {
                    deprecate: __webpack_require__(29440)
                };
                /*</replacement>*/ /*<replacement>*/ var Stream = __webpack_require__(5908);
                /*</replacement>*/ var Buffer = __webpack_require__(43060).Buffer;
                var OurUint8Array = (typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
                function _uint8ArrayToBuffer(chunk) {
                    return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
                var destroyImpl = __webpack_require__(89930);
                var _require = __webpack_require__(39025), getHighWaterMark = _require.getHighWaterMark;
                var _require$codes = __webpack_require__(75065)/* .codes */ .q, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
                var errorOrDestroy = destroyImpl.errorOrDestroy;
                __webpack_require__(48575)(Writable, Stream);
                function nop() {}
                function WritableState(options, stream, isDuplex) {
                    Duplex = Duplex || __webpack_require__(53551);
                    options = options || {};
                    // Duplex streams are both readable and writable, but share
                    // the same options object.
                    // However, some cases require setting options to different
                    // values for the readable and the writable sides of the duplex stream,
                    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
                    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
                    // object stream flag to indicate whether or not this stream
                    // contains buffers or objects.
                    this.objectMode = !!options.objectMode;
                    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
                    // the point at which write() starts returning false
                    // Note: 0 is a valid value, means that we always return false if
                    // the entire buffer is not flushed immediately on write()
                    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
                    // if _final has been called
                    this.finalCalled = false;
                    // drain event flag.
                    this.needDrain = false;
                    // at the start of calling end()
                    this.ending = false;
                    // when end() has been called, and returned
                    this.ended = false;
                    // when 'finish' is emitted
                    this.finished = false;
                    // has it been destroyed
                    this.destroyed = false;
                    // should we decode strings into buffers before passing to _write?
                    // this is here so that some node-core streams can optimize string
                    // handling at a lower level.
                    var noDecode = options.decodeStrings === false;
                    this.decodeStrings = !noDecode;
                    // Crypto is kind of old and crusty.  Historically, its default string
                    // encoding is 'binary' so we have to make this configurable.
                    // Everything else in the universe uses 'utf8', though.
                    this.defaultEncoding = options.defaultEncoding || "utf8";
                    // not an actual buffer we keep track of, but a measurement
                    // of how much we're waiting to get pushed to some underlying
                    // socket or file.
                    this.length = 0;
                    // a flag to see when we're in the middle of a write.
                    this.writing = false;
                    // when true all writes will be buffered until .uncork() call
                    this.corked = 0;
                    // a flag to be able to tell if the onwrite cb is called immediately,
                    // or on a later tick.  We set this to true at first, because any
                    // actions that shouldn't happen until "later" should generally also
                    // not happen before the first write call.
                    this.sync = true;
                    // a flag to know if we're processing previously buffered items, which
                    // may call the _write() callback in the same tick, so that we don't
                    // end up in an overlapped onwrite situation.
                    this.bufferProcessing = false;
                    // the callback that's passed to _write(chunk,cb)
                    this.onwrite = function(er) {
                        onwrite(stream, er);
                    };
                    // the callback that the user supplies to write(chunk,encoding,cb)
                    this.writecb = null;
                    // the amount that is being written when _write is called.
                    this.writelen = 0;
                    this.bufferedRequest = null;
                    this.lastBufferedRequest = null;
                    // number of pending user-supplied write callbacks
                    // this must be 0 before 'finish' can be emitted
                    this.pendingcb = 0;
                    // emit prefinish if the only thing we're waiting for is _write cbs
                    // This is relevant for synchronous Transform streams
                    this.prefinished = false;
                    // True if the error was already emitted and should not be thrown again
                    this.errorEmitted = false;
                    // Should close be emitted on destroy. Defaults to true.
                    this.emitClose = options.emitClose !== false;
                    // Should .destroy() be called after 'finish' (and potentially 'end')
                    this.autoDestroy = !!options.autoDestroy;
                    // count buffered requests
                    this.bufferedRequestCount = 0;
                    // allocate the first CorkedRequest, there is always
                    // one allocated and free to use, and we maintain at most two
                    this.corkedRequestsFree = new CorkedRequest(this);
                }
                WritableState.prototype.getBuffer = function getBuffer() {
                    var current = this.bufferedRequest;
                    var out = [];
                    while(current){
                        out.push(current);
                        current = current.next;
                    }
                    return out;
                };
                (function() {
                    try {
                        Object.defineProperty(WritableState.prototype, "buffer", {
                            get: internalUtil.deprecate(function writableStateBufferGetter() {
                                return this.getBuffer();
                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                        });
                    } catch (_) {}
                })();
                // Test _writableState for inheritance to account for Duplex streams,
                // whose prototype chain only points to Readable.
                var realHasInstance;
                if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
                    realHasInstance = Function.prototype[Symbol.hasInstance];
                    Object.defineProperty(Writable, Symbol.hasInstance, {
                        value: function value(object) {
                            if (realHasInstance.call(this, object)) return true;
                            if (this !== Writable) return false;
                            return object && object._writableState instanceof WritableState;
                        }
                    });
                } else realHasInstance = function realHasInstance(object) {
                    return object instanceof this;
                };
                function Writable(options) {
                    Duplex = Duplex || __webpack_require__(53551);
                    // Writable ctor is applied to Duplexes, too.
                    // `realHasInstance` is necessary because using plain `instanceof`
                    // would return false, as no `_writableState` property is attached.
                    // Trying to use the custom `instanceof` for Writable here will also break the
                    // Node.js LazyTransform implementation, which has a non-trivial getter for
                    // `_writableState` that would lead to infinite recursion.
                    // Checking for a Stream.Duplex instance is faster here instead of inside
                    // the WritableState constructor, at least with V8 6.5
                    var isDuplex = this instanceof Duplex;
                    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
                    this._writableState = new WritableState(options, this, isDuplex);
                    // legacy.
                    this.writable = true;
                    if (options) {
                        if (typeof options.write === "function") this._write = options.write;
                        if (typeof options.writev === "function") this._writev = options.writev;
                        if (typeof options.destroy === "function") this._destroy = options.destroy;
                        if (typeof options.final === "function") this._final = options.final;
                    }
                    Stream.call(this);
                }
                // Otherwise people can pipe Writable streams, which is just wrong.
                Writable.prototype.pipe = function() {
                    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
                };
                function writeAfterEnd(stream, cb) {
                    var er = new ERR_STREAM_WRITE_AFTER_END();
                    // TODO: defer error events consistently everywhere, not just the cb
                    errorOrDestroy(stream, er);
                    process.nextTick(cb, er);
                }
                // Checks that a user-supplied chunk is valid, especially for the particular
                // mode the stream is in. Currently this means that `null` is never accepted
                // and undefined/non-string values are only allowed in object mode.
                function validChunk(stream, state, chunk, cb) {
                    var er;
                    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
                    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
                        "string",
                        "Buffer"
                    ], chunk);
                    if (er) {
                        errorOrDestroy(stream, er);
                        process.nextTick(cb, er);
                        return false;
                    }
                    return true;
                }
                Writable.prototype.write = function(chunk, encoding, cb) {
                    var state = this._writableState;
                    var ret = false;
                    var isBuf = !state.objectMode && _isUint8Array(chunk);
                    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
                    if (typeof encoding === "function") {
                        cb = encoding;
                        encoding = null;
                    }
                    if (isBuf) encoding = "buffer";
                    else if (!encoding) encoding = state.defaultEncoding;
                    if (typeof cb !== "function") cb = nop;
                    if (state.ending) writeAfterEnd(this, cb);
                    else if (isBuf || validChunk(this, state, chunk, cb)) {
                        state.pendingcb++;
                        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                    }
                    return ret;
                };
                Writable.prototype.cork = function() {
                    this._writableState.corked++;
                };
                Writable.prototype.uncork = function() {
                    var state = this._writableState;
                    if (state.corked) {
                        state.corked--;
                        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
                    }
                };
                Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
                    // node::ParseEncoding() requires lower case.
                    if (typeof encoding === "string") encoding = encoding.toLowerCase();
                    if (!([
                        "hex",
                        "utf8",
                        "utf-8",
                        "ascii",
                        "binary",
                        "base64",
                        "ucs2",
                        "ucs-2",
                        "utf16le",
                        "utf-16le",
                        "raw"
                    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
                    this._writableState.defaultEncoding = encoding;
                    return this;
                };
                Object.defineProperty(Writable.prototype, "writableBuffer", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                });
                function decodeChunk(state, chunk, encoding) {
                    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
                    return chunk;
                }
                Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.highWaterMark;
                    }
                });
                // if we're already writing something, then just put this
                // in the queue, and wait our turn.  Otherwise, call _write
                // If we return false, then we need a drain event, so set that flag.
                function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
                    if (!isBuf) {
                        var newChunk = decodeChunk(state, chunk, encoding);
                        if (chunk !== newChunk) {
                            isBuf = true;
                            encoding = "buffer";
                            chunk = newChunk;
                        }
                    }
                    var len = state.objectMode ? 1 : chunk.length;
                    state.length += len;
                    var ret = state.length < state.highWaterMark;
                    // we must ensure that previous needDrain will not be reset to false.
                    if (!ret) state.needDrain = true;
                    if (state.writing || state.corked) {
                        var last = state.lastBufferedRequest;
                        state.lastBufferedRequest = {
                            chunk: chunk,
                            encoding: encoding,
                            isBuf: isBuf,
                            callback: cb,
                            next: null
                        };
                        if (last) last.next = state.lastBufferedRequest;
                        else state.bufferedRequest = state.lastBufferedRequest;
                        state.bufferedRequestCount += 1;
                    } else doWrite(stream, state, false, len, chunk, encoding, cb);
                    return ret;
                }
                function doWrite(stream, state, writev, len, chunk, encoding, cb) {
                    state.writelen = len;
                    state.writecb = cb;
                    state.writing = true;
                    state.sync = true;
                    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
                    else if (writev) stream._writev(chunk, state.onwrite);
                    else stream._write(chunk, encoding, state.onwrite);
                    state.sync = false;
                }
                function onwriteError(stream, state, sync, er, cb) {
                    --state.pendingcb;
                    if (sync) {
                        // defer the callback if we are being called synchronously
                        // to avoid piling up things on the stack
                        process.nextTick(cb, er);
                        // this can emit finish, and it will always happen
                        // after error
                        process.nextTick(finishMaybe, stream, state);
                        stream._writableState.errorEmitted = true;
                        errorOrDestroy(stream, er);
                    } else {
                        // the caller expect this to happen before if
                        // it is async
                        cb(er);
                        stream._writableState.errorEmitted = true;
                        errorOrDestroy(stream, er);
                        // this can emit finish, but finish must
                        // always follow error
                        finishMaybe(stream, state);
                    }
                }
                function onwriteStateUpdate(state) {
                    state.writing = false;
                    state.writecb = null;
                    state.length -= state.writelen;
                    state.writelen = 0;
                }
                function onwrite(stream, er) {
                    var state = stream._writableState;
                    var sync = state.sync;
                    var cb = state.writecb;
                    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
                    onwriteStateUpdate(state);
                    if (er) onwriteError(stream, state, sync, er, cb);
                    else {
                        // Check if we're actually ready to finish, but don't emit yet
                        var finished = needFinish(state) || stream.destroyed;
                        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
                        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
                        else afterWrite(stream, state, finished, cb);
                    }
                }
                function afterWrite(stream, state, finished, cb) {
                    if (!finished) onwriteDrain(stream, state);
                    state.pendingcb--;
                    cb();
                    finishMaybe(stream, state);
                }
                // Must force callback to be called on nextTick, so that we don't
                // emit 'drain' before the write() consumer gets the 'false' return
                // value, and has a chance to attach a 'drain' listener.
                function onwriteDrain(stream, state) {
                    if (state.length === 0 && state.needDrain) {
                        state.needDrain = false;
                        stream.emit("drain");
                    }
                }
                // if there's something in the buffer waiting, then process it
                function clearBuffer(stream, state) {
                    state.bufferProcessing = true;
                    var entry = state.bufferedRequest;
                    if (stream._writev && entry && entry.next) {
                        // Fast case, write everything using _writev()
                        var l = state.bufferedRequestCount;
                        var buffer = new Array(l);
                        var holder = state.corkedRequestsFree;
                        holder.entry = entry;
                        var count = 0;
                        var allBuffers = true;
                        while(entry){
                            buffer[count] = entry;
                            if (!entry.isBuf) allBuffers = false;
                            entry = entry.next;
                            count += 1;
                        }
                        buffer.allBuffers = allBuffers;
                        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
                        // doWrite is almost always async, defer these to save a bit of time
                        // as the hot path ends with doWrite
                        state.pendingcb++;
                        state.lastBufferedRequest = null;
                        if (holder.next) {
                            state.corkedRequestsFree = holder.next;
                            holder.next = null;
                        } else state.corkedRequestsFree = new CorkedRequest(state);
                        state.bufferedRequestCount = 0;
                    } else {
                        // Slow case, write chunks one-by-one
                        while(entry){
                            var chunk = entry.chunk;
                            var encoding = entry.encoding;
                            var cb = entry.callback;
                            var len = state.objectMode ? 1 : chunk.length;
                            doWrite(stream, state, false, len, chunk, encoding, cb);
                            entry = entry.next;
                            state.bufferedRequestCount--;
                            // if we didn't call the onwrite immediately, then
                            // it means that we need to wait until it does.
                            // also, that means that the chunk and cb are currently
                            // being processed, so move the buffer counter past them.
                            if (state.writing) break;
                        }
                        if (entry === null) state.lastBufferedRequest = null;
                    }
                    state.bufferedRequest = entry;
                    state.bufferProcessing = false;
                }
                Writable.prototype._write = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
                };
                Writable.prototype._writev = null;
                Writable.prototype.end = function(chunk, encoding, cb) {
                    var state = this._writableState;
                    if (typeof chunk === "function") {
                        cb = chunk;
                        chunk = null;
                        encoding = null;
                    } else if (typeof encoding === "function") {
                        cb = encoding;
                        encoding = null;
                    }
                    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
                    // .end() fully uncorks
                    if (state.corked) {
                        state.corked = 1;
                        this.uncork();
                    }
                    // ignore unnecessary end() calls.
                    if (!state.ending) endWritable(this, state, cb);
                    return this;
                };
                Object.defineProperty(Writable.prototype, "writableLength", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.length;
                    }
                });
                function needFinish(state) {
                    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
                }
                function callFinal(stream, state) {
                    stream._final(function(err) {
                        state.pendingcb--;
                        if (err) errorOrDestroy(stream, err);
                        state.prefinished = true;
                        stream.emit("prefinish");
                        finishMaybe(stream, state);
                    });
                }
                function prefinish(stream, state) {
                    if (!state.prefinished && !state.finalCalled) {
                        if (typeof stream._final === "function" && !state.destroyed) {
                            state.pendingcb++;
                            state.finalCalled = true;
                            process.nextTick(callFinal, stream, state);
                        } else {
                            state.prefinished = true;
                            stream.emit("prefinish");
                        }
                    }
                }
                function finishMaybe(stream, state) {
                    var need = needFinish(state);
                    if (need) {
                        prefinish(stream, state);
                        if (state.pendingcb === 0) {
                            state.finished = true;
                            stream.emit("finish");
                            if (state.autoDestroy) {
                                // In case of duplex streams we need a way to detect
                                // if the readable side is ready for autoDestroy as well
                                var rState = stream._readableState;
                                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                            }
                        }
                    }
                    return need;
                }
                function endWritable(stream, state, cb) {
                    state.ending = true;
                    finishMaybe(stream, state);
                    if (cb) {
                        if (state.finished) process.nextTick(cb);
                        else stream.once("finish", cb);
                    }
                    state.ended = true;
                    stream.writable = false;
                }
                function onCorkedFinish(corkReq, state, err) {
                    var entry = corkReq.entry;
                    corkReq.entry = null;
                    while(entry){
                        var cb = entry.callback;
                        state.pendingcb--;
                        cb(err);
                        entry = entry.next;
                    }
                    // reuse the free corkReq.
                    state.corkedRequestsFree.next = corkReq;
                }
                Object.defineProperty(Writable.prototype, "destroyed", {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        if (this._writableState === undefined) return false;
                        return this._writableState.destroyed;
                    },
                    set: function set(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (!this._writableState) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._writableState.destroyed = value;
                    }
                });
                Writable.prototype.destroy = destroyImpl.destroy;
                Writable.prototype._undestroy = destroyImpl.undestroy;
                Writable.prototype._destroy = function(err, cb) {
                    cb(err);
                };
            /***/ },
            /***/ 90933: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                var _Object$setPrototypeO;
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return typeof key === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (typeof input !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (typeof res !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                var finished = __webpack_require__(47549);
                var kLastResolve = Symbol("lastResolve");
                var kLastReject = Symbol("lastReject");
                var kError = Symbol("error");
                var kEnded = Symbol("ended");
                var kLastPromise = Symbol("lastPromise");
                var kHandlePromise = Symbol("handlePromise");
                var kStream = Symbol("stream");
                function createIterResult(value, done) {
                    return {
                        value: value,
                        done: done
                    };
                }
                function readAndResolve(iter) {
                    var resolve = iter[kLastResolve];
                    if (resolve !== null) {
                        var data = iter[kStream].read();
                        // we defer if data is null
                        // we can be expecting either 'end' or
                        // 'error'
                        if (data !== null) {
                            iter[kLastPromise] = null;
                            iter[kLastResolve] = null;
                            iter[kLastReject] = null;
                            resolve(createIterResult(data, false));
                        }
                    }
                }
                function onReadable(iter) {
                    // we wait for the next tick, because it might
                    // emit an error with process.nextTick
                    process.nextTick(readAndResolve, iter);
                }
                function wrapForNext(lastPromise, iter) {
                    return function(resolve, reject) {
                        lastPromise.then(function() {
                            if (iter[kEnded]) {
                                resolve(createIterResult(undefined, true));
                                return;
                            }
                            iter[kHandlePromise](resolve, reject);
                        }, reject);
                    };
                }
                var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
                var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
                    get stream () {
                        return this[kStream];
                    },
                    next: function next() {
                        var _this = this;
                        // if we have detected an error in the meanwhile
                        // reject straight away
                        var error = this[kError];
                        if (error !== null) return Promise.reject(error);
                        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
                        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
                        // called, the error will be emitted via nextTick, and
                        // we cannot guarantee that there is no error lingering around
                        // waiting to be emitted.
                        return new Promise(function(resolve, reject) {
                            process.nextTick(function() {
                                if (_this[kError]) reject(_this[kError]);
                                else resolve(createIterResult(undefined, true));
                            });
                        });
                        // if we have multiple next() calls
                        // we will wait for the previous Promise to finish
                        // this logic is optimized to support for await loops,
                        // where next() is only called once at a time
                        var lastPromise = this[kLastPromise];
                        var promise;
                        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
                        else {
                            // fast path needed to support multiple this.push()
                            // without triggering the next() queue
                            var data = this[kStream].read();
                            if (data !== null) return Promise.resolve(createIterResult(data, false));
                            promise = new Promise(this[kHandlePromise]);
                        }
                        this[kLastPromise] = promise;
                        return promise;
                    }
                }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
                    return this;
                }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
                    var _this2 = this;
                    // destroy(err, cb) is a private API
                    // we can guarantee we have that here, because we control the
                    // Readable class this is attached to
                    return new Promise(function(resolve, reject) {
                        _this2[kStream].destroy(null, function(err) {
                            if (err) {
                                reject(err);
                                return;
                            }
                            resolve(createIterResult(undefined, true));
                        });
                    });
                }), _Object$setPrototypeO), AsyncIteratorPrototype);
                var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
                    var _Object$create;
                    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
                        value: stream,
                        writable: true
                    }), _defineProperty(_Object$create, kLastResolve, {
                        value: null,
                        writable: true
                    }), _defineProperty(_Object$create, kLastReject, {
                        value: null,
                        writable: true
                    }), _defineProperty(_Object$create, kError, {
                        value: null,
                        writable: true
                    }), _defineProperty(_Object$create, kEnded, {
                        value: stream._readableState.endEmitted,
                        writable: true
                    }), _defineProperty(_Object$create, kHandlePromise, {
                        value: function value(resolve, reject) {
                            var data = iterator[kStream].read();
                            if (data) {
                                iterator[kLastPromise] = null;
                                iterator[kLastResolve] = null;
                                iterator[kLastReject] = null;
                                resolve(createIterResult(data, false));
                            } else {
                                iterator[kLastResolve] = resolve;
                                iterator[kLastReject] = reject;
                            }
                        },
                        writable: true
                    }), _Object$create));
                    iterator[kLastPromise] = null;
                    finished(stream, function(err) {
                        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                            var reject = iterator[kLastReject];
                            // reject if we are waiting for data in the Promise
                            // returned by next() and store the error
                            if (reject !== null) {
                                iterator[kLastPromise] = null;
                                iterator[kLastResolve] = null;
                                iterator[kLastReject] = null;
                                reject(err);
                            }
                            iterator[kError] = err;
                            return;
                        }
                        var resolve = iterator[kLastResolve];
                        if (resolve !== null) {
                            iterator[kLastPromise] = null;
                            iterator[kLastResolve] = null;
                            iterator[kLastReject] = null;
                            resolve(createIterResult(undefined, true));
                        }
                        iterator[kEnded] = true;
                    });
                    stream.on("readable", onReadable.bind(null, iterator));
                    return iterator;
                };
                module1.exports = createReadableStreamAsyncIterator;
            /***/ },
            /***/ 89930: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(82530);
                // undocumented cb() API, needed for core, not for public API
                function destroy(err, cb) {
                    var _this = this;
                    var readableDestroyed = this._readableState && this._readableState.destroyed;
                    var writableDestroyed = this._writableState && this._writableState.destroyed;
                    if (readableDestroyed || writableDestroyed) {
                        if (cb) cb(err);
                        else if (err) {
                            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
                            else if (!this._writableState.errorEmitted) {
                                this._writableState.errorEmitted = true;
                                process.nextTick(emitErrorNT, this, err);
                            }
                        }
                        return this;
                    }
                    // we set destroyed to true before firing error callbacks in order
                    // to make it re-entrance safe in case destroy() is called within callbacks
                    if (this._readableState) this._readableState.destroyed = true;
                    // if this is a duplex stream mark the writable part as destroyed as well
                    if (this._writableState) this._writableState.destroyed = true;
                    this._destroy(err || null, function(err) {
                        if (!cb && err) {
                            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
                            else if (!_this._writableState.errorEmitted) {
                                _this._writableState.errorEmitted = true;
                                process.nextTick(emitErrorAndCloseNT, _this, err);
                            } else process.nextTick(emitCloseNT, _this);
                        } else if (cb) {
                            process.nextTick(emitCloseNT, _this);
                            cb(err);
                        } else process.nextTick(emitCloseNT, _this);
                    });
                    return this;
                }
                function emitErrorAndCloseNT(self1, err) {
                    emitErrorNT(self1, err);
                    emitCloseNT(self1);
                }
                function emitCloseNT(self1) {
                    if (self1._writableState && !self1._writableState.emitClose) return;
                    if (self1._readableState && !self1._readableState.emitClose) return;
                    self1.emit("close");
                }
                function undestroy() {
                    if (this._readableState) {
                        this._readableState.destroyed = false;
                        this._readableState.reading = false;
                        this._readableState.ended = false;
                        this._readableState.endEmitted = false;
                    }
                    if (this._writableState) {
                        this._writableState.destroyed = false;
                        this._writableState.ended = false;
                        this._writableState.ending = false;
                        this._writableState.finalCalled = false;
                        this._writableState.prefinished = false;
                        this._writableState.finished = false;
                        this._writableState.errorEmitted = false;
                    }
                }
                function emitErrorNT(self1, err) {
                    self1.emit("error", err);
                }
                function errorOrDestroy(stream, err) {
                    // We have tests that rely on errors being emitted
                    // in the same tick, so changing this is semver major.
                    // For now when you opt-in to autoDestroy we allow
                    // the error to be emitted nextTick. In a future
                    // semver major update we should change the default to this.
                    var rState = stream._readableState;
                    var wState = stream._writableState;
                    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
                    else stream.emit("error", err);
                }
                module1.exports = {
                    destroy: destroy,
                    undestroy: undestroy,
                    errorOrDestroy: errorOrDestroy
                };
            /***/ },
            /***/ 47549: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Ported from https://github.com/mafintosh/end-of-stream with
                // permission from the author, Mathias Buus (@mafintosh).
                var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__(75065)/* .codes */ .q.ERR_STREAM_PREMATURE_CLOSE;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback.apply(this, args);
                    };
                }
                function noop() {}
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === "function";
                }
                function eos(stream, opts, callback) {
                    if (typeof opts === "function") return eos(stream, null, opts);
                    if (!opts) opts = {};
                    callback = once(callback || noop);
                    var readable = opts.readable || opts.readable !== false && stream.readable;
                    var writable = opts.writable || opts.writable !== false && stream.writable;
                    var onlegacyfinish = function onlegacyfinish() {
                        if (!stream.writable) onfinish();
                    };
                    var writableEnded = stream._writableState && stream._writableState.finished;
                    var onfinish = function onfinish() {
                        writable = false;
                        writableEnded = true;
                        if (!readable) callback.call(stream);
                    };
                    var readableEnded = stream._readableState && stream._readableState.endEmitted;
                    var onend = function onend() {
                        readable = false;
                        readableEnded = true;
                        if (!writable) callback.call(stream);
                    };
                    var onerror = function onerror(err) {
                        callback.call(stream, err);
                    };
                    var onclose = function onclose() {
                        var err;
                        if (readable && !readableEnded) {
                            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                        if (writable && !writableEnded) {
                            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                    };
                    var onrequest = function onrequest() {
                        stream.req.on("finish", onfinish);
                    };
                    if (isRequest(stream)) {
                        stream.on("complete", onfinish);
                        stream.on("abort", onclose);
                        if (stream.req) onrequest();
                        else stream.on("request", onrequest);
                    } else if (writable && !stream._writableState) {
                        // legacy streams
                        stream.on("end", onlegacyfinish);
                        stream.on("close", onlegacyfinish);
                    }
                    stream.on("end", onend);
                    stream.on("finish", onfinish);
                    if (opts.error !== false) stream.on("error", onerror);
                    stream.on("close", onclose);
                    return function() {
                        stream.removeListener("complete", onfinish);
                        stream.removeListener("abort", onclose);
                        stream.removeListener("request", onrequest);
                        if (stream.req) stream.req.removeListener("finish", onfinish);
                        stream.removeListener("end", onlegacyfinish);
                        stream.removeListener("close", onlegacyfinish);
                        stream.removeListener("finish", onfinish);
                        stream.removeListener("end", onend);
                        stream.removeListener("error", onerror);
                        stream.removeListener("close", onclose);
                    };
                }
                module1.exports = eos;
            /***/ },
            /***/ 24881: /***/ function(module1) {
                module1.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            /***/ },
            /***/ 44858: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Ported from https://github.com/mafintosh/pump with
                // permission from the author, Mathias Buus (@mafintosh).
                var eos;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        callback.apply(void 0, arguments);
                    };
                }
                var _require$codes = __webpack_require__(75065)/* .codes */ .q, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
                function noop(err) {
                    // Rethrow the error if it exists to avoid swallowing it
                    if (err) throw err;
                }
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === "function";
                }
                function destroyer(stream, reading, writing, callback) {
                    callback = once(callback);
                    var closed = false;
                    stream.on("close", function() {
                        closed = true;
                    });
                    if (eos === undefined) eos = __webpack_require__(47549);
                    eos(stream, {
                        readable: reading,
                        writable: writing
                    }, function(err) {
                        if (err) return callback(err);
                        closed = true;
                        callback();
                    });
                    var destroyed = false;
                    return function(err) {
                        if (closed) return;
                        if (destroyed) return;
                        destroyed = true;
                        // request.destroy just do .end - .abort is what we want
                        if (isRequest(stream)) return stream.abort();
                        if (typeof stream.destroy === "function") return stream.destroy();
                        callback(err || new ERR_STREAM_DESTROYED("pipe"));
                    };
                }
                function call(fn) {
                    fn();
                }
                function pipe(from, to) {
                    return from.pipe(to);
                }
                function popCallback(streams) {
                    if (!streams.length) return noop;
                    if (typeof streams[streams.length - 1] !== "function") return noop;
                    return streams.pop();
                }
                function pipeline() {
                    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
                    var callback = popCallback(streams);
                    if (Array.isArray(streams[0])) streams = streams[0];
                    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
                    var error;
                    var destroys = streams.map(function(stream, i) {
                        var reading = i < streams.length - 1;
                        var writing = i > 0;
                        return destroyer(stream, reading, writing, function(err) {
                            if (!error) error = err;
                            if (err) destroys.forEach(call);
                            if (reading) return;
                            destroys.forEach(call);
                            callback(error);
                        });
                    });
                    return streams.reduce(pipe);
                }
                module1.exports = pipeline;
            /***/ },
            /***/ 39025: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ERR_INVALID_OPT_VALUE = __webpack_require__(75065)/* .codes */ .q.ERR_INVALID_OPT_VALUE;
                function highWaterMarkFrom(options, isDuplex, duplexKey) {
                    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
                }
                function getHighWaterMark(state, options, duplexKey, isDuplex) {
                    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
                    if (hwm != null) {
                        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                            var name = isDuplex ? duplexKey : "highWaterMark";
                            throw new ERR_INVALID_OPT_VALUE(name, hwm);
                        }
                        return Math.floor(hwm);
                    }
                    // Default value
                    return state.objectMode ? 16 : 16384;
                }
                module1.exports = {
                    getHighWaterMark: getHighWaterMark
                };
            /***/ },
            /***/ 5908: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                module1.exports = __webpack_require__(5939).EventEmitter;
            /***/ },
            /***/ 10301: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                /*<replacement>*/ var Buffer = __webpack_require__(11504).Buffer;
                /*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
                    encoding = "" + encoding;
                    switch(encoding && encoding.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return true;
                        default:
                            return false;
                    }
                };
                function _normalizeEncoding(enc) {
                    if (!enc) return "utf8";
                    var retried;
                    while(true)switch(enc){
                        case "utf8":
                        case "utf-8":
                            return "utf8";
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return "utf16le";
                        case "latin1":
                        case "binary":
                            return "latin1";
                        case "base64":
                        case "ascii":
                        case "hex":
                            return enc;
                        default:
                            if (retried) return; // undefined
                            enc = ("" + enc).toLowerCase();
                            retried = true;
                    }
                }
                // Do not cache `Buffer.isEncoding` when checking encoding names as some
                // modules monkey-patch it to support additional encodings
                function normalizeEncoding(enc) {
                    var nenc = _normalizeEncoding(enc);
                    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
                    return nenc || enc;
                }
                // StringDecoder provides an interface for efficiently splitting a series of
                // buffers into a series of JS strings without breaking apart multi-byte
                // characters.
                exports.s = StringDecoder;
                function StringDecoder(encoding) {
                    this.encoding = normalizeEncoding(encoding);
                    var nb;
                    switch(this.encoding){
                        case "utf16le":
                            this.text = utf16Text;
                            this.end = utf16End;
                            nb = 4;
                            break;
                        case "utf8":
                            this.fillLast = utf8FillLast;
                            nb = 4;
                            break;
                        case "base64":
                            this.text = base64Text;
                            this.end = base64End;
                            nb = 3;
                            break;
                        default:
                            this.write = simpleWrite;
                            this.end = simpleEnd;
                            return;
                    }
                    this.lastNeed = 0;
                    this.lastTotal = 0;
                    this.lastChar = Buffer.allocUnsafe(nb);
                }
                StringDecoder.prototype.write = function(buf) {
                    if (buf.length === 0) return "";
                    var r;
                    var i;
                    if (this.lastNeed) {
                        r = this.fillLast(buf);
                        if (r === undefined) return "";
                        i = this.lastNeed;
                        this.lastNeed = 0;
                    } else i = 0;
                    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
                    return r || "";
                };
                StringDecoder.prototype.end = utf8End;
                // Returns only complete characters in a Buffer
                StringDecoder.prototype.text = utf8Text;
                // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
                StringDecoder.prototype.fillLast = function(buf) {
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
                    this.lastNeed -= buf.length;
                };
                // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
                // continuation byte. If an invalid byte is detected, -2 is returned.
                function utf8CheckByte(byte) {
                    if (byte <= 0x7F) return 0;
                    else if (byte >> 5 === 0x06) return 2;
                    else if (byte >> 4 === 0x0E) return 3;
                    else if (byte >> 3 === 0x1E) return 4;
                    return byte >> 6 === 0x02 ? -1 : -2;
                }
                // Checks at most 3 bytes at the end of a Buffer in order to detect an
                // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
                // needed to complete the UTF-8 character (if applicable) are returned.
                function utf8CheckIncomplete(self1, buf, i) {
                    var j = buf.length - 1;
                    if (j < i) return 0;
                    var nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 1;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 2;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) {
                            if (nb === 2) nb = 0;
                            else self1.lastNeed = nb - 3;
                        }
                        return nb;
                    }
                    return 0;
                }
                // Validates as many continuation bytes for a multi-byte UTF-8 character as
                // needed or are available. If we see a non-continuation byte where we expect
                // one, we "replace" the validated continuation bytes we've seen so far with
                // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
                // behavior. The continuation byte check is included three times in the case
                // where all of the continuation bytes for a character exist in the same buffer.
                // It is also done this way as a slight performance increase instead of using a
                // loop.
                function utf8CheckExtraBytes(self1, buf, p) {
                    if ((buf[0] & 0xC0) !== 0x80) {
                        self1.lastNeed = 0;
                        return "\uFFFD";
                    }
                    if (self1.lastNeed > 1 && buf.length > 1) {
                        if ((buf[1] & 0xC0) !== 0x80) {
                            self1.lastNeed = 1;
                            return "\uFFFD";
                        }
                        if (self1.lastNeed > 2 && buf.length > 2) {
                            if ((buf[2] & 0xC0) !== 0x80) {
                                self1.lastNeed = 2;
                                return "\uFFFD";
                            }
                        }
                    }
                }
                // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
                function utf8FillLast(buf) {
                    var p = this.lastTotal - this.lastNeed;
                    var r = utf8CheckExtraBytes(this, buf, p);
                    if (r !== undefined) return r;
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, p, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, p, 0, buf.length);
                    this.lastNeed -= buf.length;
                }
                // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
                // partial character, the character's bytes are buffered until the required
                // number of bytes are available.
                function utf8Text(buf, i) {
                    var total = utf8CheckIncomplete(this, buf, i);
                    if (!this.lastNeed) return buf.toString("utf8", i);
                    this.lastTotal = total;
                    var end = buf.length - (total - this.lastNeed);
                    buf.copy(this.lastChar, 0, end);
                    return buf.toString("utf8", i, end);
                }
                // For UTF-8, a replacement character is added when ending on a partial
                // character.
                function utf8End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) return r + "\uFFFD";
                    return r;
                }
                // UTF-16LE typically needs two bytes per character, but even if we have an even
                // number of bytes available, we need to check if we end on a leading/high
                // surrogate. In that case, we need to wait for the next two bytes in order to
                // decode the last character properly.
                function utf16Text(buf, i) {
                    if ((buf.length - i) % 2 === 0) {
                        var r = buf.toString("utf16le", i);
                        if (r) {
                            var c = r.charCodeAt(r.length - 1);
                            if (c >= 0xD800 && c <= 0xDBFF) {
                                this.lastNeed = 2;
                                this.lastTotal = 4;
                                this.lastChar[0] = buf[buf.length - 2];
                                this.lastChar[1] = buf[buf.length - 1];
                                return r.slice(0, -1);
                            }
                        }
                        return r;
                    }
                    this.lastNeed = 1;
                    this.lastTotal = 2;
                    this.lastChar[0] = buf[buf.length - 1];
                    return buf.toString("utf16le", i, buf.length - 1);
                }
                // For UTF-16LE we do not explicitly append special replacement characters if we
                // end on a partial character, we simply let v8 handle that.
                function utf16End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) {
                        var end = this.lastTotal - this.lastNeed;
                        return r + this.lastChar.toString("utf16le", 0, end);
                    }
                    return r;
                }
                function base64Text(buf, i) {
                    var n = (buf.length - i) % 3;
                    if (n === 0) return buf.toString("base64", i);
                    this.lastNeed = 3 - n;
                    this.lastTotal = 3;
                    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
                    else {
                        this.lastChar[0] = buf[buf.length - 2];
                        this.lastChar[1] = buf[buf.length - 1];
                    }
                    return buf.toString("base64", i, buf.length - n);
                }
                function base64End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
                    return r;
                }
                // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
                function simpleWrite(buf) {
                    return buf.toString(this.encoding);
                }
                function simpleEnd(buf) {
                    return buf && buf.length ? this.write(buf) : "";
                }
            /***/ },
            /***/ 84346: /***/ function(module1) {
                var TINF_OK = 0;
                var TINF_DATA_ERROR = -3;
                function Tree() {
                    this.table = new Uint16Array(16); /* table of code length counts */ 
                    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
                }
                function Data(source, dest) {
                    this.source = source;
                    this.sourceIndex = 0;
                    this.tag = 0;
                    this.bitcount = 0;
                    this.dest = dest;
                    this.destLen = 0;
                    this.ltree = new Tree(); /* dynamic length/symbol tree */ 
                    this.dtree = new Tree(); /* dynamic distance tree */ 
                }
                /* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var sltree = new Tree();
                var sdtree = new Tree();
                /* extra bits and base tables for length codes */ var length_bits = new Uint8Array(30);
                var length_base = new Uint16Array(30);
                /* extra bits and base tables for distance codes */ var dist_bits = new Uint8Array(30);
                var dist_base = new Uint16Array(30);
                /* special ordering of code length codes */ var clcidx = new Uint8Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                /* used by tinf_decode_trees, avoids allocations every call */ var code_tree = new Tree();
                var lengths = new Uint8Array(320);
                /* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function tinf_build_bits_base(bits, base, delta, first) {
                    var i, sum;
                    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
                    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
                    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
                        base[i] = sum;
                        sum += 1 << bits[i];
                    }
                }
                /* build the fixed huffman trees */ function tinf_build_fixed_trees(lt, dt) {
                    var i;
                    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
                    lt.table[7] = 24;
                    lt.table[8] = 152;
                    lt.table[9] = 112;
                    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
                    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
                    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
                    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
                    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
                    dt.table[5] = 32;
                    for(i = 0; i < 32; ++i)dt.trans[i] = i;
                }
                /* given an array of code lengths, build a tree */ var offs = new Uint16Array(16);
                function tinf_build_tree(t, lengths, off, num) {
                    var i, sum;
                    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
                    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
                    t.table[0] = 0;
                    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
                        offs[i] = sum;
                        sum += t.table[i];
                    }
                    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
                }
                /* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function tinf_getbit(d) {
                    /* check if tag is empty */ if (!d.bitcount--) {
                        /* load next tag */ d.tag = d.source[d.sourceIndex++];
                        d.bitcount = 7;
                    }
                    /* shift bit out of tag */ var bit = d.tag & 1;
                    d.tag >>>= 1;
                    return bit;
                }
                /* read a num bit value from a stream and add base */ function tinf_read_bits(d, num, base) {
                    if (!num) return base;
                    while(d.bitcount < 24){
                        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
                        d.bitcount += 8;
                    }
                    var val = d.tag & 0xffff >>> 16 - num;
                    d.tag >>>= num;
                    d.bitcount -= num;
                    return val + base;
                }
                /* given a data stream and a tree, decode a symbol */ function tinf_decode_symbol(d, t) {
                    while(d.bitcount < 24){
                        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
                        d.bitcount += 8;
                    }
                    var sum = 0, cur = 0, len = 0;
                    var tag = d.tag;
                    /* get more bits while code value is above sum */ do {
                        cur = 2 * cur + (tag & 1);
                        tag >>>= 1;
                        ++len;
                        sum += t.table[len];
                        cur -= t.table[len];
                    }while (cur >= 0);
                    d.tag = tag;
                    d.bitcount -= len;
                    return t.trans[sum + cur];
                }
                /* given a data stream, decode dynamic trees from it */ function tinf_decode_trees(d, lt, dt) {
                    var hlit, hdist, hclen;
                    var i, num, length;
                    /* get 5 bits HLIT (257-286) */ hlit = tinf_read_bits(d, 5, 257);
                    /* get 5 bits HDIST (1-32) */ hdist = tinf_read_bits(d, 5, 1);
                    /* get 4 bits HCLEN (4-19) */ hclen = tinf_read_bits(d, 4, 4);
                    for(i = 0; i < 19; ++i)lengths[i] = 0;
                    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
                        /* get 3 bits code length (0-7) */ var clen = tinf_read_bits(d, 3, 0);
                        lengths[clcidx[i]] = clen;
                    }
                    /* build code length tree */ tinf_build_tree(code_tree, lengths, 0, 19);
                    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
                        var sym = tinf_decode_symbol(d, code_tree);
                        switch(sym){
                            case 16:
                                /* copy previous code length 3-6 times (read 2 bits) */ var prev = lengths[num - 1];
                                for(length = tinf_read_bits(d, 2, 3); length; --length)lengths[num++] = prev;
                                break;
                            case 17:
                                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = tinf_read_bits(d, 3, 3); length; --length)lengths[num++] = 0;
                                break;
                            case 18:
                                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = tinf_read_bits(d, 7, 11); length; --length)lengths[num++] = 0;
                                break;
                            default:
                                /* values 0-15 represent the actual code lengths */ lengths[num++] = sym;
                                break;
                        }
                    }
                    /* build dynamic trees */ tinf_build_tree(lt, lengths, 0, hlit);
                    tinf_build_tree(dt, lengths, hlit, hdist);
                }
                /* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function tinf_inflate_block_data(d, lt, dt) {
                    while(true){
                        var sym = tinf_decode_symbol(d, lt);
                        /* check for end of block */ if (sym === 256) return TINF_OK;
                        if (sym < 256) d.dest[d.destLen++] = sym;
                        else {
                            var length, dist, offs;
                            var i;
                            sym -= 257;
                            /* possibly get more bits from length code */ length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
                            dist = tinf_decode_symbol(d, dt);
                            /* possibly get more bits from distance code */ offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
                            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
                        }
                    }
                }
                /* inflate an uncompressed block of data */ function tinf_inflate_uncompressed_block(d) {
                    var length, invlength;
                    var i;
                    /* unread from bitbuffer */ while(d.bitcount > 8){
                        d.sourceIndex--;
                        d.bitcount -= 8;
                    }
                    /* get length */ length = d.source[d.sourceIndex + 1];
                    length = 256 * length + d.source[d.sourceIndex];
                    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
                    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
                    /* check length */ if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;
                    d.sourceIndex += 4;
                    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
                    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
                    return TINF_OK;
                }
                /* inflate stream from source to dest */ function tinf_uncompress(source, dest) {
                    var d = new Data(source, dest);
                    var bfinal, btype, res;
                    do {
                        /* read final block flag */ bfinal = tinf_getbit(d);
                        /* read block type (2 bits) */ btype = tinf_read_bits(d, 2, 0);
                        /* decompress block */ switch(btype){
                            case 0:
                                /* decompress uncompressed block */ res = tinf_inflate_uncompressed_block(d);
                                break;
                            case 1:
                                /* decompress block with fixed huffman trees */ res = tinf_inflate_block_data(d, sltree, sdtree);
                                break;
                            case 2:
                                /* decompress block with dynamic huffman trees */ tinf_decode_trees(d, d.ltree, d.dtree);
                                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                                break;
                            default:
                                res = TINF_DATA_ERROR;
                        }
                        if (res !== TINF_OK) throw new Error("Data error");
                    }while (!bfinal);
                    if (d.destLen < d.dest.length) {
                        if (typeof d.dest.slice === "function") return d.dest.slice(0, d.destLen);
                        else return d.dest.subarray(0, d.destLen);
                    }
                    return d.dest;
                }
                /* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ tinf_build_fixed_trees(sltree, sdtree);
                /* build extra bits and base tables */ tinf_build_bits_base(length_bits, length_base, 4, 3);
                tinf_build_bits_base(dist_bits, dist_base, 2, 1);
                /* fix a special case */ length_bits[28] = 0;
                length_base[28] = 258;
                module1.exports = tinf_uncompress;
            /***/ },
            /***/ 29440: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /**
 * Module exports.
 */ module1.exports = deprecate;
                /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
                    if (config("noDeprecation")) return fn;
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (config("throwDeprecation")) throw new Error(msg);
                            else if (config("traceDeprecation")) console.trace(msg);
                            else console.warn(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                }
                /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
                    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                    try {
                        if (!__webpack_require__.g.localStorage) return false;
                    } catch (_) {
                        return false;
                    }
                    var val = __webpack_require__.g.localStorage[name];
                    if (null == val) return false;
                    return String(val).toLowerCase() === "true";
                }
            /***/ },
            /***/ 79397: /***/ function(module1) {
                module1.exports = function isBuffer(arg) {
                    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
                };
            /***/ },
            /***/ 64489: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // Currently in sync with Node.js lib/internal/util/types.js
                // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
                var isArgumentsObject = __webpack_require__(77092);
                var isGeneratorFunction = __webpack_require__(97427);
                var whichTypedArray = __webpack_require__(54010);
                var isTypedArray = __webpack_require__(82527);
                function uncurryThis(f) {
                    return f.call.bind(f);
                }
                var BigIntSupported = typeof BigInt !== "undefined";
                var SymbolSupported = typeof Symbol !== "undefined";
                var ObjectToString = uncurryThis(Object.prototype.toString);
                var numberValue = uncurryThis(Number.prototype.valueOf);
                var stringValue = uncurryThis(String.prototype.valueOf);
                var booleanValue = uncurryThis(Boolean.prototype.valueOf);
                if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
                if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
                function checkBoxedPrimitive(value, prototypeValueOf) {
                    if (typeof value !== "object") return false;
                    try {
                        prototypeValueOf(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                exports.isArgumentsObject = isArgumentsObject;
                exports.isGeneratorFunction = isGeneratorFunction;
                exports.isTypedArray = isTypedArray;
                // Taken from here and modified for better browser support
                // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
                function isPromise(input) {
                    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
                }
                exports.isPromise = isPromise;
                function isArrayBufferView(value) {
                    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
                    return isTypedArray(value) || isDataView(value);
                }
                exports.isArrayBufferView = isArrayBufferView;
                function isUint8Array(value) {
                    return whichTypedArray(value) === "Uint8Array";
                }
                exports.isUint8Array = isUint8Array;
                function isUint8ClampedArray(value) {
                    return whichTypedArray(value) === "Uint8ClampedArray";
                }
                exports.isUint8ClampedArray = isUint8ClampedArray;
                function isUint16Array(value) {
                    return whichTypedArray(value) === "Uint16Array";
                }
                exports.isUint16Array = isUint16Array;
                function isUint32Array(value) {
                    return whichTypedArray(value) === "Uint32Array";
                }
                exports.isUint32Array = isUint32Array;
                function isInt8Array(value) {
                    return whichTypedArray(value) === "Int8Array";
                }
                exports.isInt8Array = isInt8Array;
                function isInt16Array(value) {
                    return whichTypedArray(value) === "Int16Array";
                }
                exports.isInt16Array = isInt16Array;
                function isInt32Array(value) {
                    return whichTypedArray(value) === "Int32Array";
                }
                exports.isInt32Array = isInt32Array;
                function isFloat32Array(value) {
                    return whichTypedArray(value) === "Float32Array";
                }
                exports.isFloat32Array = isFloat32Array;
                function isFloat64Array(value) {
                    return whichTypedArray(value) === "Float64Array";
                }
                exports.isFloat64Array = isFloat64Array;
                function isBigInt64Array(value) {
                    return whichTypedArray(value) === "BigInt64Array";
                }
                exports.isBigInt64Array = isBigInt64Array;
                function isBigUint64Array(value) {
                    return whichTypedArray(value) === "BigUint64Array";
                }
                exports.isBigUint64Array = isBigUint64Array;
                function isMapToString(value) {
                    return ObjectToString(value) === "[object Map]";
                }
                isMapToString.working = typeof Map !== "undefined" && isMapToString(new Map());
                function isMap(value) {
                    if (typeof Map === "undefined") return false;
                    return isMapToString.working ? isMapToString(value) : value instanceof Map;
                }
                exports.isMap = isMap;
                function isSetToString(value) {
                    return ObjectToString(value) === "[object Set]";
                }
                isSetToString.working = typeof Set !== "undefined" && isSetToString(new Set());
                function isSet(value) {
                    if (typeof Set === "undefined") return false;
                    return isSetToString.working ? isSetToString(value) : value instanceof Set;
                }
                exports.isSet = isSet;
                function isWeakMapToString(value) {
                    return ObjectToString(value) === "[object WeakMap]";
                }
                isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(new WeakMap());
                function isWeakMap(value) {
                    if (typeof WeakMap === "undefined") return false;
                    return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
                }
                exports.isWeakMap = isWeakMap;
                function isWeakSetToString(value) {
                    return ObjectToString(value) === "[object WeakSet]";
                }
                isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(new WeakSet());
                function isWeakSet(value) {
                    return isWeakSetToString(value);
                }
                exports.isWeakSet = isWeakSet;
                function isArrayBufferToString(value) {
                    return ObjectToString(value) === "[object ArrayBuffer]";
                }
                isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
                function isArrayBuffer(value) {
                    if (typeof ArrayBuffer === "undefined") return false;
                    return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
                }
                exports.isArrayBuffer = isArrayBuffer;
                function isDataViewToString(value) {
                    return ObjectToString(value) === "[object DataView]";
                }
                isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
                function isDataView(value) {
                    if (typeof DataView === "undefined") return false;
                    return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
                }
                exports.isDataView = isDataView;
                // Store a copy of SharedArrayBuffer in case it's deleted elsewhere
                var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
                function isSharedArrayBufferToString(value) {
                    return ObjectToString(value) === "[object SharedArrayBuffer]";
                }
                function isSharedArrayBuffer(value) {
                    if (typeof SharedArrayBufferCopy === "undefined") return false;
                    if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
                    return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
                }
                exports.isSharedArrayBuffer = isSharedArrayBuffer;
                function isAsyncFunction(value) {
                    return ObjectToString(value) === "[object AsyncFunction]";
                }
                exports.isAsyncFunction = isAsyncFunction;
                function isMapIterator(value) {
                    return ObjectToString(value) === "[object Map Iterator]";
                }
                exports.isMapIterator = isMapIterator;
                function isSetIterator(value) {
                    return ObjectToString(value) === "[object Set Iterator]";
                }
                exports.isSetIterator = isSetIterator;
                function isGeneratorObject(value) {
                    return ObjectToString(value) === "[object Generator]";
                }
                exports.isGeneratorObject = isGeneratorObject;
                function isWebAssemblyCompiledModule(value) {
                    return ObjectToString(value) === "[object WebAssembly.Module]";
                }
                exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
                function isNumberObject(value) {
                    return checkBoxedPrimitive(value, numberValue);
                }
                exports.isNumberObject = isNumberObject;
                function isStringObject(value) {
                    return checkBoxedPrimitive(value, stringValue);
                }
                exports.isStringObject = isStringObject;
                function isBooleanObject(value) {
                    return checkBoxedPrimitive(value, booleanValue);
                }
                exports.isBooleanObject = isBooleanObject;
                function isBigIntObject(value) {
                    return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
                }
                exports.isBigIntObject = isBigIntObject;
                function isSymbolObject(value) {
                    return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
                }
                exports.isSymbolObject = isSymbolObject;
                function isBoxedPrimitive(value) {
                    return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
                }
                exports.isBoxedPrimitive = isBoxedPrimitive;
                function isAnyArrayBuffer(value) {
                    return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
                }
                exports.isAnyArrayBuffer = isAnyArrayBuffer;
                [
                    "isProxy",
                    "isExternal",
                    "isModuleNamespaceObject"
                ].forEach(function(method) {
                    Object.defineProperty(exports, method, {
                        enumerable: false,
                        value: function() {
                            throw new Error(method + " is not supported in userland");
                        }
                    });
                });
            /***/ },
            /***/ 85663: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* provided dependency */ var process = __webpack_require__(82530);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
                    var keys = Object.keys(obj);
                    var descriptors = {};
                    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
                    return descriptors;
                };
                var formatRegExp = /%[sdj%]/g;
                exports.format = function(f) {
                    if (!isString(f)) {
                        var objects = [];
                        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
                        return objects.join(" ");
                    }
                    var i = 1;
                    var args = arguments;
                    var len = args.length;
                    var str = String(f).replace(formatRegExp, function(x) {
                        if (x === "%%") return "%";
                        if (i >= len) return x;
                        switch(x){
                            case "%s":
                                return String(args[i++]);
                            case "%d":
                                return Number(args[i++]);
                            case "%j":
                                try {
                                    return JSON.stringify(args[i++]);
                                } catch (_) {
                                    return "[Circular]";
                                }
                            default:
                                return x;
                        }
                    });
                    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
                    else str += " " + inspect(x);
                    return str;
                };
                // Mark that a method should not be used.
                // Returns a modified function which warns once by default.
                // If --no-deprecation is set, then it is a no-op.
                exports.deprecate = function(fn, msg) {
                    if (typeof process !== "undefined" && process.noDeprecation === true) return fn;
                    // Allow for deprecating things in the process of starting up.
                    if (typeof process === "undefined") return function() {
                        return exports.deprecate(fn, msg).apply(this, arguments);
                    };
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (process.throwDeprecation) throw new Error(msg);
                            else if (process.traceDeprecation) console.trace(msg);
                            else console.error(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                };
                var debugs = {};
                var debugEnvRegex = /^$/;
                if (process.env.NODE_DEBUG) {
                    var debugEnv = process.env.NODE_DEBUG;
                    debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
                    debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
                }
                exports.debuglog = function(set) {
                    set = set.toUpperCase();
                    if (!debugs[set]) {
                        if (debugEnvRegex.test(set)) {
                            var pid = process.pid;
                            debugs[set] = function() {
                                var msg = exports.format.apply(exports, arguments);
                                console.error("%s %d: %s", set, pid, msg);
                            };
                        } else debugs[set] = function() {};
                    }
                    return debugs[set];
                };
                /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
                    // default options
                    var ctx = {
                        seen: [],
                        stylize: stylizeNoColor
                    };
                    // legacy...
                    if (arguments.length >= 3) ctx.depth = arguments[2];
                    if (arguments.length >= 4) ctx.colors = arguments[3];
                    if (isBoolean(opts)) // legacy...
                    ctx.showHidden = opts;
                    else if (opts) // got an "options" object
                    exports._extend(ctx, opts);
                    // set default options
                    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
                    if (isUndefined(ctx.depth)) ctx.depth = 2;
                    if (isUndefined(ctx.colors)) ctx.colors = false;
                    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
                    if (ctx.colors) ctx.stylize = stylizeWithColor;
                    return formatValue(ctx, obj, ctx.depth);
                }
                exports.inspect = inspect;
                // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
                inspect.colors = {
                    "bold": [
                        1,
                        22
                    ],
                    "italic": [
                        3,
                        23
                    ],
                    "underline": [
                        4,
                        24
                    ],
                    "inverse": [
                        7,
                        27
                    ],
                    "white": [
                        37,
                        39
                    ],
                    "grey": [
                        90,
                        39
                    ],
                    "black": [
                        30,
                        39
                    ],
                    "blue": [
                        34,
                        39
                    ],
                    "cyan": [
                        36,
                        39
                    ],
                    "green": [
                        32,
                        39
                    ],
                    "magenta": [
                        35,
                        39
                    ],
                    "red": [
                        31,
                        39
                    ],
                    "yellow": [
                        33,
                        39
                    ]
                };
                // Don't use 'blue' not visible on cmd.exe
                inspect.styles = {
                    "special": "cyan",
                    "number": "yellow",
                    "boolean": "yellow",
                    "undefined": "grey",
                    "null": "bold",
                    "string": "green",
                    "date": "magenta",
                    // "name": intentionally not styling
                    "regexp": "red"
                };
                function stylizeWithColor(str, styleType) {
                    var style = inspect.styles[styleType];
                    if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
                    else return str;
                }
                function stylizeNoColor(str, styleType) {
                    return str;
                }
                function arrayToHash(array) {
                    var hash = {};
                    array.forEach(function(val, idx) {
                        hash[val] = true;
                    });
                    return hash;
                }
                function formatValue(ctx, value, recurseTimes) {
                    // Provide a hook for user-specified inspect functions.
                    // Check that value is an object with an inspect function on it
                    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
                    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
                    !(value.constructor && value.constructor.prototype === value)) {
                        var ret = value.inspect(recurseTimes, ctx);
                        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
                        return ret;
                    }
                    // Primitive types cannot have properties
                    var primitive = formatPrimitive(ctx, value);
                    if (primitive) return primitive;
                    // Look up the keys of the object.
                    var keys = Object.keys(value);
                    var visibleKeys = arrayToHash(keys);
                    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
                    // IE doesn't make error fields non-enumerable
                    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
                    if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
                    // Some type of object without properties can be shortcutted.
                    if (keys.length === 0) {
                        if (isFunction(value)) {
                            var name = value.name ? ": " + value.name : "";
                            return ctx.stylize("[Function" + name + "]", "special");
                        }
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
                        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
                        if (isError(value)) return formatError(value);
                    }
                    var base = "", array = false, braces = [
                        "{",
                        "}"
                    ];
                    // Make Array say that they are Array
                    if (isArray(value)) {
                        array = true;
                        braces = [
                            "[",
                            "]"
                        ];
                    }
                    // Make functions say that they are functions
                    if (isFunction(value)) {
                        var n = value.name ? ": " + value.name : "";
                        base = " [Function" + n + "]";
                    }
                    // Make RegExps say that they are RegExps
                    if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
                    // Make dates with properties first say the date
                    if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
                    // Make error with message first say the error
                    if (isError(value)) base = " " + formatError(value);
                    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
                    if (recurseTimes < 0) {
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
                        else return ctx.stylize("[Object]", "special");
                    }
                    ctx.seen.push(value);
                    var output;
                    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
                    else output = keys.map(function(key) {
                        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
                    });
                    ctx.seen.pop();
                    return reduceToSingleString(output, base, braces);
                }
                function formatPrimitive(ctx, value) {
                    if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
                    if (isString(value)) {
                        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                        return ctx.stylize(simple, "string");
                    }
                    if (isNumber(value)) return ctx.stylize("" + value, "number");
                    if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
                    // For some reason typeof null is "object", so special case here.
                    if (isNull(value)) return ctx.stylize("null", "null");
                }
                function formatError(value) {
                    return "[" + Error.prototype.toString.call(value) + "]";
                }
                function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
                    var output = [];
                    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
                    else output.push("");
                    keys.forEach(function(key) {
                        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
                    });
                    return output;
                }
                function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
                    var name, str, desc;
                    desc = Object.getOwnPropertyDescriptor(value, key) || {
                        value: value[key]
                    };
                    if (desc.get) {
                        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
                        else str = ctx.stylize("[Getter]", "special");
                    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
                    if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
                    if (!str) {
                        if (ctx.seen.indexOf(desc.value) < 0) {
                            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                            else str = formatValue(ctx, desc.value, recurseTimes - 1);
                            if (str.indexOf("\n") > -1) {
                                if (array) str = str.split("\n").map(function(line) {
                                    return "  " + line;
                                }).join("\n").slice(2);
                                else str = "\n" + str.split("\n").map(function(line) {
                                    return "   " + line;
                                }).join("\n");
                            }
                        } else str = ctx.stylize("[Circular]", "special");
                    }
                    if (isUndefined(name)) {
                        if (array && key.match(/^\d+$/)) return str;
                        name = JSON.stringify("" + key);
                        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                            name = name.slice(1, -1);
                            name = ctx.stylize(name, "name");
                        } else {
                            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                            name = ctx.stylize(name, "string");
                        }
                    }
                    return name + ": " + str;
                }
                function reduceToSingleString(output, base, braces) {
                    var numLinesEst = 0;
                    var length = output.reduce(function(prev, cur) {
                        numLinesEst++;
                        if (cur.indexOf("\n") >= 0) numLinesEst++;
                        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
                    }, 0);
                    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
                    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
                }
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
                exports.types = __webpack_require__(64489);
                function isArray(ar) {
                    return Array.isArray(ar);
                }
                exports.isArray = isArray;
                function isBoolean(arg) {
                    return typeof arg === "boolean";
                }
                exports.isBoolean = isBoolean;
                function isNull(arg) {
                    return arg === null;
                }
                exports.isNull = isNull;
                function isNullOrUndefined(arg) {
                    return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
                function isNumber(arg) {
                    return typeof arg === "number";
                }
                exports.isNumber = isNumber;
                function isString(arg) {
                    return typeof arg === "string";
                }
                exports.isString = isString;
                function isSymbol(arg) {
                    return typeof arg === "symbol";
                }
                exports.isSymbol = isSymbol;
                function isUndefined(arg) {
                    return arg === void 0;
                }
                exports.isUndefined = isUndefined;
                function isRegExp(re) {
                    return isObject(re) && objectToString(re) === "[object RegExp]";
                }
                exports.isRegExp = isRegExp;
                exports.types.isRegExp = isRegExp;
                function isObject(arg) {
                    return typeof arg === "object" && arg !== null;
                }
                exports.isObject = isObject;
                function isDate(d) {
                    return isObject(d) && objectToString(d) === "[object Date]";
                }
                exports.isDate = isDate;
                exports.types.isDate = isDate;
                function isError(e) {
                    return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
                }
                exports.isError = isError;
                exports.types.isNativeError = isError;
                function isFunction(arg) {
                    return typeof arg === "function";
                }
                exports.isFunction = isFunction;
                function isPrimitive(arg) {
                    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
                    typeof arg === "undefined";
                }
                exports.isPrimitive = isPrimitive;
                exports.isBuffer = __webpack_require__(79397);
                function objectToString(o) {
                    return Object.prototype.toString.call(o);
                }
                function pad(n) {
                    return n < 10 ? "0" + n.toString(10) : n.toString(10);
                }
                var months = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                // 26 Feb 16:19:34
                function timestamp() {
                    var d = new Date();
                    var time = [
                        pad(d.getHours()),
                        pad(d.getMinutes()),
                        pad(d.getSeconds())
                    ].join(":");
                    return [
                        d.getDate(),
                        months[d.getMonth()],
                        time
                    ].join(" ");
                }
                // log is just a thin wrapper to console.log that prepends a timestamp
                exports.log = function() {
                    console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
                };
                /**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = __webpack_require__(48575);
                exports._extend = function(origin, add) {
                    // Don't do anything if add isn't an object
                    if (!add || !isObject(add)) return origin;
                    var keys = Object.keys(add);
                    var i = keys.length;
                    while(i--)origin[keys[i]] = add[keys[i]];
                    return origin;
                };
                function hasOwnProperty(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
                var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
                exports.promisify = function promisify(original) {
                    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
                    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
                        var fn = original[kCustomPromisifiedSymbol];
                        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                            value: fn,
                            enumerable: false,
                            writable: false,
                            configurable: true
                        });
                        return fn;
                    }
                    function fn() {
                        var promiseResolve, promiseReject;
                        var promise = new Promise(function(resolve, reject) {
                            promiseResolve = resolve;
                            promiseReject = reject;
                        });
                        var args = [];
                        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                        args.push(function(err, value) {
                            if (err) promiseReject(err);
                            else promiseResolve(value);
                        });
                        try {
                            original.apply(this, args);
                        } catch (err) {
                            promiseReject(err);
                        }
                        return promise;
                    }
                    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
                    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                        value: fn,
                        enumerable: false,
                        writable: false,
                        configurable: true
                    });
                    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
                };
                exports.promisify.custom = kCustomPromisifiedSymbol;
                function callbackifyOnRejected(reason, cb) {
                    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
                    // Because `null` is a special error value in callbacks which means "no error
                    // occurred", we error-wrap so the callback consumer can distinguish between
                    // "the promise rejected with null" or "the promise fulfilled with undefined".
                    if (!reason) {
                        var newReason = new Error("Promise was rejected with a falsy value");
                        newReason.reason = reason;
                        reason = newReason;
                    }
                    return cb(reason);
                }
                function callbackify(original) {
                    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
                    // We DO NOT return the promise as it gives the user a false sense that
                    // the promise is actually somehow related to the callback's execution
                    // and that the callback throwing will reject the promise.
                    function callbackified() {
                        var args = [];
                        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                        var maybeCb = args.pop();
                        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
                        var self1 = this;
                        var cb = function() {
                            return maybeCb.apply(self1, arguments);
                        };
                        // In true node style we process the callback on `nextTick` with all the
                        // implications (stack, `uncaughtException`, `async_hooks`)
                        original.apply(this, args).then(function(ret) {
                            process.nextTick(cb.bind(null, null, ret));
                        }, function(rej) {
                            process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
                        });
                    }
                    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
                    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
                    return callbackified;
                }
                exports.callbackify = callbackify;
            /***/ },
            /***/ 54010: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var forEach = __webpack_require__(94843);
                var availableTypedArrays = __webpack_require__(14343);
                var callBind = __webpack_require__(12550);
                var callBound = __webpack_require__(97615);
                var gOPD = __webpack_require__(93828);
                var $toString = callBound("Object.prototype.toString");
                var hasToStringTag = __webpack_require__(44111)();
                var g = typeof globalThis === "undefined" ? __webpack_require__.g : globalThis;
                var typedArrays = availableTypedArrays();
                var $slice = callBound("String.prototype.slice");
                var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
                var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf(array, value) {
                    for(var i = 0; i < array.length; i += 1){
                        if (array[i] === value) return i;
                    }
                    return -1;
                };
                var cache = {
                    __proto__: null
                };
                if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
                    var arr = new g[typedArray]();
                    if (Symbol.toStringTag in arr) {
                        var proto = getPrototypeOf(arr);
                        var descriptor = gOPD(proto, Symbol.toStringTag);
                        if (!descriptor) {
                            var superProto = getPrototypeOf(proto);
                            descriptor = gOPD(superProto, Symbol.toStringTag);
                        }
                        cache["$" + typedArray] = callBind(descriptor.get);
                    }
                });
                else forEach(typedArrays, function(typedArray) {
                    var arr = new g[typedArray]();
                    var fn = arr.slice || arr.set;
                    if (fn) cache["$" + typedArray] = callBind(fn);
                });
                var tryTypedArrays = function tryAllTypedArrays(value) {
                    var found = false;
                    forEach(cache, function(getter, typedArray) {
                        if (!found) try {
                            if ("$" + getter(value) === typedArray) found = $slice(typedArray, 1);
                        } catch (e) {}
                    });
                    return found;
                };
                var trySlices = function tryAllSlices(value) {
                    var found = false;
                    forEach(cache, function(getter, name) {
                        if (!found) try {
                            getter(value);
                            found = $slice(name, 1);
                        } catch (e) {}
                    });
                    return found;
                };
                module1.exports = function whichTypedArray(value) {
                    if (!value || typeof value !== "object") return false;
                    if (!hasToStringTag) {
                        var tag = $slice($toString(value), 8, -1);
                        if ($indexOf(typedArrays, tag) > -1) return tag;
                        if (tag !== "Object") return false;
                        // node < 0.6 hits here on real Typed Arrays
                        return trySlices(value);
                    }
                    if (!gOPD) return null;
                     // unknown engine
                    return tryTypedArrays(value);
                };
            /***/ },
            /***/ 26651: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // This file is just added for convenience so this repository can be
                // directly checked out into a project's deps folder
                module1.exports = __webpack_require__(91117);
            /***/ },
            /***/ 91117: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                (function() {
                    var sax;
                    if ((0, module1.exports) && !__webpack_require__.g.xmldocAssumeBrowser) // We're being used in a Node-like environment
                    sax = __webpack_require__(53407);
                    else {
                        // assume it's attached to the Window object in a browser
                        sax = this.sax;
                        if (!sax) // no sax for you!
                        throw new Error("Expected sax to be defined. Make sure you're including sax.js before this file.");
                    }
                    /**
   * XmlElement is our basic building block. Everything is an XmlElement; even XmlDocument
   * behaves like an XmlElement by inheriting its attributes and functions.
   */ function XmlElement(tag, parser) {
                        // If you didn't hand us a parser (common case) see if we can grab one
                        // from the current execution stack.
                        if (!parser) {
                            var delegate = delegates[delegates.length - 1];
                            if (delegate.parser) parser = delegate.parser;
                        }
                        this.name = tag.name;
                        this.attr = tag.attributes;
                        this.val = "";
                        this.children = [];
                        this.firstChild = null;
                        this.lastChild = null;
                        // Assign parse information
                        this.line = parser ? parser.line : null;
                        this.column = parser ? parser.column : null;
                        this.position = parser ? parser.position : null;
                        this.startTagPosition = parser ? parser.startTagPosition : null;
                    }
                    // Private methods
                    XmlElement.prototype._addChild = function(child) {
                        // add to our children array
                        this.children.push(child);
                        // update first/last pointers
                        if (!this.firstChild) this.firstChild = child;
                        this.lastChild = child;
                    };
                    // SaxParser handlers
                    XmlElement.prototype._opentag = function(tag) {
                        var child = new XmlElement(tag);
                        this._addChild(child);
                        delegates.unshift(child);
                    };
                    XmlElement.prototype._closetag = function() {
                        delegates.shift();
                    };
                    XmlElement.prototype._text = function(text) {
                        if (typeof this.children === "undefined") return;
                        this.val += text;
                        this._addChild(new XmlTextNode(text));
                    };
                    XmlElement.prototype._cdata = function(cdata) {
                        this.val += cdata;
                        this._addChild(new XmlCDataNode(cdata));
                    };
                    XmlElement.prototype._comment = function(comment) {
                        if (typeof this.children === "undefined") return;
                        this._addChild(new XmlCommentNode(comment));
                    };
                    XmlElement.prototype._error = function(err) {
                        throw err;
                    };
                    // Useful functions
                    XmlElement.prototype.eachChild = function(iterator, context) {
                        for(var i = 0, l = this.children.length; i < l; i++)if (this.children[i].type === "element") {
                            if (iterator.call(context, this.children[i], i, this.children) === false) return;
                        }
                    };
                    XmlElement.prototype.childNamed = function(name) {
                        for(var i = 0, l = this.children.length; i < l; i++){
                            var child = this.children[i];
                            if (child.name === name) return child;
                        }
                        return undefined;
                    };
                    XmlElement.prototype.childrenNamed = function(name) {
                        var matches = [];
                        for(var i = 0, l = this.children.length; i < l; i++)if (this.children[i].name === name) matches.push(this.children[i]);
                        return matches;
                    };
                    XmlElement.prototype.childWithAttribute = function(name, value) {
                        for(var i = 0, l = this.children.length; i < l; i++){
                            var child = this.children[i];
                            if (child.type === "element" && (value && child.attr[name] === value || !value && child.attr[name])) return child;
                        }
                        return undefined;
                    };
                    XmlElement.prototype.descendantsNamed = function(name) {
                        var matches = [];
                        for(var i = 0, l = this.children.length; i < l; i++){
                            var child = this.children[i];
                            if (child.type === "element") {
                                if (child.name === name) matches.push(child);
                                matches = matches.concat(child.descendantsNamed(name));
                            }
                        }
                        return matches;
                    };
                    XmlElement.prototype.descendantWithPath = function(path) {
                        var descendant = this;
                        var components = path.split(".");
                        for(var i = 0, l = components.length; i < l; i++)if (descendant && descendant.type === "element") descendant = descendant.childNamed(components[i]);
                        else return undefined;
                        return descendant;
                    };
                    XmlElement.prototype.valueWithPath = function(path) {
                        var components = path.split("@");
                        var descendant = this.descendantWithPath(components[0]);
                        if (descendant) return components.length > 1 ? descendant.attr[components[1]] : descendant.val;
                        else return undefined;
                    };
                    // String formatting (for debugging)
                    XmlElement.prototype.toString = function(options) {
                        return this.toStringWithIndent("", options);
                    };
                    XmlElement.prototype.toStringWithIndent = function(indent, options) {
                        var s = indent + "<" + this.name;
                        var linebreak = options && options.compressed ? "" : "\n";
                        var preserveWhitespace = options && options.preserveWhitespace;
                        for(var name in this.attr)if (Object.prototype.hasOwnProperty.call(this.attr, name)) s += " " + name + '="' + escapeXML(this.attr[name]) + '"';
                        if (this.children.length === 1 && this.children[0].type !== "element") s += ">" + this.children[0].toString(options) + "</" + this.name + ">";
                        else if (this.children.length) {
                            s += ">" + linebreak;
                            var childIndent = indent + (options && options.compressed ? "" : "  ");
                            for(var i = 0, l = this.children.length; i < l; i++)s += this.children[i].toStringWithIndent(childIndent, options) + linebreak;
                            s += indent + "</" + this.name + ">";
                        } else if (options && options.html) {
                            var whiteList = [
                                "area",
                                "base",
                                "br",
                                "col",
                                "embed",
                                "frame",
                                "hr",
                                "img",
                                "input",
                                "keygen",
                                "link",
                                "menuitem",
                                "meta",
                                "param",
                                "source",
                                "track",
                                "wbr"
                            ];
                            if (whiteList.indexOf(this.name) !== -1) s += "/>";
                            else s += "></" + this.name + ">";
                        } else s += "/>";
                        return s;
                    };
                    // Alternative XML nodes
                    function XmlTextNode(text) {
                        this.text = text;
                    }
                    XmlTextNode.prototype.toString = function(options) {
                        return formatText(escapeXML(this.text), options);
                    };
                    XmlTextNode.prototype.toStringWithIndent = function(indent, options) {
                        return indent + this.toString(options);
                    };
                    function XmlCDataNode(cdata) {
                        this.cdata = cdata;
                    }
                    XmlCDataNode.prototype.toString = function(options) {
                        return "<![CDATA[" + formatText(this.cdata, options) + "]]>";
                    };
                    XmlCDataNode.prototype.toStringWithIndent = function(indent, options) {
                        return indent + this.toString(options);
                    };
                    function XmlCommentNode(comment) {
                        this.comment = comment;
                    }
                    XmlCommentNode.prototype.toString = function(options) {
                        return "<!--" + formatText(escapeXML(this.comment), options) + "-->";
                    };
                    XmlCommentNode.prototype.toStringWithIndent = function(indent, options) {
                        return indent + this.toString(options);
                    };
                    // Node type tag
                    XmlElement.prototype.type = "element";
                    XmlTextNode.prototype.type = "text";
                    XmlCDataNode.prototype.type = "cdata";
                    XmlCommentNode.prototype.type = "comment";
                    /**
   * XmlDocument is the class we expose to the user; it uses the sax parser to create a hierarchy
   * of XmlElements.
   */ function XmlDocument(xml) {
                        xml && (xml = xml.toString().trim());
                        if (!xml) throw new Error("No XML to parse!");
                        // Stores doctype (if defined)
                        this.doctype = "";
                        // Expose the parser to the other delegates while the parser is running
                        this.parser = sax.parser(true); // strict
                        addParserEvents(this.parser);
                        // We'll use the file-scoped "delegates" var to remember what elements we're currently
                        // parsing; they will push and pop off the stack as we get deeper into the XML hierarchy.
                        // It's safe to use a global because JS is single-threaded.
                        delegates = [
                            this
                        ];
                        try {
                            this.parser.write(xml);
                        } finally{
                            // Remove the parser as it is no longer needed and should not be exposed to clients
                            delete this.parser;
                        }
                    }
                    // make XmlDocument inherit XmlElement's methods
                    extend(XmlDocument.prototype, XmlElement.prototype);
                    XmlDocument.prototype._opentag = function(tag) {
                        if (typeof this.children === "undefined") // the first tag we encounter should be the root - we'll "become" the root XmlElement
                        XmlElement.call(this, tag);
                        else XmlElement.prototype._opentag.apply(this, arguments);
                    };
                    XmlDocument.prototype._doctype = function(doctype) {
                        this.doctype += doctype;
                    };
                    // file-scoped global stack of delegates
                    var delegates = null;
                    /*
   * Helper functions
   */ function addParserEvents(parser) {
                        parser.onopentag = parser_opentag;
                        parser.onclosetag = parser_closetag;
                        parser.ontext = parser_text;
                        parser.oncdata = parser_cdata;
                        parser.oncomment = parser_comment;
                        parser.ondoctype = parser_doctype;
                        parser.onerror = parser_error;
                    }
                    // create these closures and cache them by keeping them file-scoped
                    function parser_opentag() {
                        delegates[0] && delegates[0]._opentag.apply(delegates[0], arguments);
                    }
                    function parser_closetag() {
                        delegates[0] && delegates[0]._closetag.apply(delegates[0], arguments);
                    }
                    function parser_text() {
                        delegates[0] && delegates[0]._text.apply(delegates[0], arguments);
                    }
                    function parser_cdata() {
                        delegates[0] && delegates[0]._cdata.apply(delegates[0], arguments);
                    }
                    function parser_comment() {
                        delegates[0] && delegates[0]._comment.apply(delegates[0], arguments);
                    }
                    function parser_doctype() {
                        delegates[0] && delegates[0]._doctype.apply(delegates[0], arguments);
                    }
                    function parser_error() {
                        delegates[0] && delegates[0]._error.apply(delegates[0], arguments);
                    }
                    // a relatively standard extend method
                    function extend(destination, source) {
                        for(var prop in source)if (source.hasOwnProperty(prop)) destination[prop] = source[prop];
                    }
                    // escapes XML entities like "<", "&", etc.
                    function escapeXML(value) {
                        return value.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;");
                    }
                    // formats some text for debugging given a few options
                    function formatText(text, options) {
                        var finalText = text;
                        if (options && options.trimmed && text.length > 25) finalText = finalText.substring(0, 25).trim() + "\u2026";
                        if (!(options && options.preserveWhitespace)) finalText = finalText.trim();
                        return finalText;
                    }
                    // Are we being used in a Node-like environment?
                    if ((0, module1.exports) && !__webpack_require__.g.xmldocAssumeBrowser) {
                        module1.exports.XmlDocument = XmlDocument;
                        module1.exports.XmlElement = XmlElement;
                        module1.exports.XmlTextNode = XmlTextNode;
                        module1.exports.XmlCDataNode = XmlCDataNode;
                        module1.exports.XmlCommentNode = XmlCommentNode;
                    } else {
                        this.XmlDocument = XmlDocument;
                        this.XmlElement = XmlElement;
                        this.XmlTextNode = XmlTextNode;
                        this.XmlCDataNode = XmlCDataNode;
                        this.XmlCommentNode = XmlCommentNode;
                    }
                })();
            /***/ },
            /***/ 30570: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Internet Explorer polyfills
                if (typeof window !== "undefined" && !window.Promise) __webpack_require__(46121);
                __webpack_require__(67367);
                var fetchUrl = function(url, headers) {
                    return new Promise(function(resolve, reject) {
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, true);
                        for(var headerName in headers)xhr.setRequestHeader(headerName, headers[headerName]);
                        xhr.responseType = "arraybuffer";
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState !== 4) return;
                            var ok = xhr.status >= 200 && xhr.status < 300;
                            if (!ok) setTimeout(function() {
                                reject(new TypeError('Failed to fetch (url: "' + url + '")'));
                            }, 0);
                        };
                        xhr.onload = function() {
                            var ok = xhr.status >= 200 && xhr.status < 300;
                            if (ok) resolve(xhr.response);
                        };
                        xhr.onerror = function() {
                            setTimeout(function() {
                                reject(new TypeError('Network request failed (url: "' + url + '")'));
                            }, 0);
                        };
                        xhr.ontimeout = function() {
                            setTimeout(function() {
                                reject(new TypeError('Network request failed (url: "' + url + '")'));
                            }, 0);
                        };
                        xhr.send();
                    });
                };
                function URLBrowserResolver(fs) {
                    this.fs = fs;
                    this.resolving = {};
                }
                URLBrowserResolver.prototype.resolve = function(url, headers) {
                    if (!this.resolving[url]) {
                        var _this = this;
                        this.resolving[url] = new Promise(function(resolve, reject) {
                            if (url.toLowerCase().indexOf("https://") === 0 || url.toLowerCase().indexOf("http://") === 0) {
                                if (_this.fs.existsSync(url)) // url was downloaded earlier
                                resolve();
                                else fetchUrl(url, headers).then(function(buffer) {
                                    _this.fs.writeFileSync(url, buffer);
                                    resolve();
                                }, function(result) {
                                    reject(result);
                                });
                            } else // cannot be resolved
                            resolve();
                        });
                    }
                    return this.resolving[url];
                };
                URLBrowserResolver.prototype.resolved = function() {
                    var _this = this;
                    return new Promise(function(resolve, reject) {
                        Promise.all(Object.values(_this.resolving)).then(function() {
                            resolve();
                        }, function(result) {
                            reject(result);
                        });
                    });
                };
                module1.exports = URLBrowserResolver;
            /***/ },
            /***/ 82669: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                var isFunction = __webpack_require__(16920).isFunction;
                var isUndefined = __webpack_require__(16920).isUndefined;
                var isNull = __webpack_require__(16920).isNull;
                var FileSaver = __webpack_require__(70457);
                var saveAs = FileSaver.saveAs;
                var defaultClientFonts = {
                    Roboto: {
                        normal: "Roboto-Regular.ttf",
                        bold: "Roboto-Medium.ttf",
                        italics: "Roboto-Italic.ttf",
                        bolditalics: "Roboto-MediumItalic.ttf"
                    }
                };
                function Document(docDefinition, tableLayouts, fonts, vfs) {
                    this.docDefinition = docDefinition;
                    this.tableLayouts = tableLayouts || null;
                    this.fonts = fonts || defaultClientFonts;
                    this.vfs = vfs;
                }
                function canCreatePdf() {
                    // Ensure the browser provides the level of support needed
                    try {
                        var arr = new Uint8Array(1);
                        var proto = {
                            foo: function() {
                                return 42;
                            }
                        };
                        Object.setPrototypeOf(proto, Uint8Array.prototype);
                        Object.setPrototypeOf(arr, proto);
                        return arr.foo() === 42;
                    } catch (e) {
                        return false;
                    }
                }
                Document.prototype._createDoc = function(options, cb) {
                    var getExtendedUrl = function(url) {
                        if (typeof url === "object") return {
                            url: url.url,
                            headers: url.headers
                        };
                        return {
                            url: url,
                            headers: {}
                        };
                    };
                    options = options || {};
                    if (this.tableLayouts) options.tableLayouts = this.tableLayouts;
                    var PdfPrinter = __webpack_require__(56498);
                    var printer = new PdfPrinter(this.fonts);
                    __webpack_require__(52773).bindFS(this.vfs); // bind virtual file system to file system
                    if (!isFunction(cb)) {
                        var doc = printer.createPdfKitDocument(this.docDefinition, options);
                        return doc;
                    }
                    var URLBrowserResolver = __webpack_require__(30570);
                    var urlResolver = new URLBrowserResolver(__webpack_require__(52773));
                    for(var font in this.fonts)if (this.fonts.hasOwnProperty(font)) {
                        if (this.fonts[font].normal) {
                            if (Array.isArray(this.fonts[font].normal)) {
                                var url = getExtendedUrl(this.fonts[font].normal[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].normal[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].normal);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].normal = url.url;
                            }
                        }
                        if (this.fonts[font].bold) {
                            if (Array.isArray(this.fonts[font].bold)) {
                                var url = getExtendedUrl(this.fonts[font].bold[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bold[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].bold);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bold = url.url;
                            }
                        }
                        if (this.fonts[font].italics) {
                            if (Array.isArray(this.fonts[font].italics)) {
                                var url = getExtendedUrl(this.fonts[font].italics[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].italics[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].italics);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].italics = url.url;
                            }
                        }
                        if (this.fonts[font].bolditalics) {
                            if (Array.isArray(this.fonts[font].bolditalics)) {
                                var url = getExtendedUrl(this.fonts[font].bolditalics[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bolditalics[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].bolditalics);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bolditalics = url.url;
                            }
                        }
                    }
                    if (this.docDefinition.images) {
                        for(var image in this.docDefinition.images)if (this.docDefinition.images.hasOwnProperty(image)) {
                            var url = getExtendedUrl(this.docDefinition.images[image]);
                            urlResolver.resolve(url.url, url.headers);
                            this.docDefinition.images[image] = url.url;
                        }
                    }
                    var _this = this;
                    urlResolver.resolved().then(function() {
                        var doc = printer.createPdfKitDocument(_this.docDefinition, options);
                        cb(doc);
                    }, function(result) {
                        throw result;
                    });
                };
                Document.prototype._flushDoc = function(doc, callback) {
                    var chunks = [];
                    var result;
                    doc.on("readable", function() {
                        var chunk;
                        while((chunk = doc.read(9007199254740991)) !== null)chunks.push(chunk);
                    });
                    doc.on("end", function() {
                        result = Buffer.concat(chunks);
                        callback(result, doc._pdfMakePages);
                    });
                    doc.end();
                };
                Document.prototype._getPages = function(options, cb) {
                    if (!cb) throw "_getPages is an async method and needs a callback argument";
                    var _this = this;
                    this._createDoc(options, function(doc) {
                        _this._flushDoc(doc, function(ignoreBuffer, pages) {
                            cb(pages);
                        });
                    });
                };
                Document.prototype._bufferToBlob = function(buffer) {
                    var blob;
                    try {
                        blob = new Blob([
                            buffer
                        ], {
                            type: "application/pdf"
                        });
                    } catch (e) {
                        // Old browser which can't handle it without making it an byte array (ie10)
                        if (e.name === "InvalidStateError") {
                            var byteArray = new Uint8Array(buffer);
                            blob = new Blob([
                                byteArray.buffer
                            ], {
                                type: "application/pdf"
                            });
                        }
                    }
                    if (!blob) throw "Could not generate blob";
                    return blob;
                };
                Document.prototype._openWindow = function() {
                    // we have to open the window immediately and store the reference
                    // otherwise popup blockers will stop us
                    var win = window.open("", "_blank");
                    if (win === null) throw "Open PDF in new window blocked by browser";
                    return win;
                };
                Document.prototype._openPdf = function(options, win) {
                    if (!win) win = this._openWindow();
                    try {
                        this.getBlob(function(result) {
                            var urlCreator = window.URL || window.webkitURL;
                            var pdfUrl = urlCreator.createObjectURL(result);
                            win.location.href = pdfUrl;
                        /* temporarily disabled
			if (win !== window) {
				setTimeout(function () {
					if (isNull(win.window)) { // is closed by AdBlock
						window.location.href = pdfUrl; // open in actual window
					}
				}, 500);
			}
			*/ }, options);
                    } catch (e) {
                        win.close();
                        throw e;
                    }
                };
                Document.prototype.open = function(options, win) {
                    options = options || {};
                    options.autoPrint = false;
                    win = win || null;
                    this._openPdf(options, win);
                };
                Document.prototype.print = function(options, win) {
                    options = options || {};
                    options.autoPrint = true;
                    win = win || null;
                    this._openPdf(options, win);
                };
                /**
 * download(defaultFileName = 'file.pdf', cb = null, options = {})
 * or
 * download(cb, options = {})
 */ Document.prototype.download = function(defaultFileName, cb, options) {
                    if (isFunction(defaultFileName)) {
                        if (!isUndefined(cb)) options = cb;
                        cb = defaultFileName;
                        defaultFileName = null;
                    }
                    defaultFileName = defaultFileName || "file.pdf";
                    this.getBlob(function(result) {
                        saveAs(result, defaultFileName);
                        if (isFunction(cb)) cb();
                    }, options);
                };
                Document.prototype.getBase64 = function(cb, options) {
                    if (!cb) throw "getBase64 is an async method and needs a callback argument";
                    this.getBuffer(function(buffer) {
                        cb(buffer.toString("base64"));
                    }, options);
                };
                Document.prototype.getDataUrl = function(cb, options) {
                    if (!cb) throw "getDataUrl is an async method and needs a callback argument";
                    this.getBuffer(function(buffer) {
                        cb("data:application/pdf;base64," + buffer.toString("base64"));
                    }, options);
                };
                Document.prototype.getBlob = function(cb, options) {
                    if (!cb) throw "getBlob is an async method and needs a callback argument";
                    var that = this;
                    this.getBuffer(function(result) {
                        var blob = that._bufferToBlob(result);
                        cb(blob);
                    }, options);
                };
                Document.prototype.getBuffer = function(cb, options) {
                    if (!cb) throw "getBuffer is an async method and needs a callback argument";
                    var _this = this;
                    this._createDoc(options, function(doc) {
                        _this._flushDoc(doc, function(buffer) {
                            cb(buffer);
                        });
                    });
                };
                Document.prototype.getStream = function(options, cb) {
                    if (!isFunction(cb)) {
                        var doc = this._createDoc(options);
                        return doc;
                    }
                    this._createDoc(options, function(doc) {
                        cb(doc);
                    });
                };
                module1.exports = {
                    createPdf: function(docDefinition, tableLayouts, fonts, vfs) {
                        if (!canCreatePdf()) throw "Your browser does not provide the level of support needed";
                        return new Document(docDefinition, tableLayouts || __webpack_require__.g.pdfMake.tableLayouts, fonts || __webpack_require__.g.pdfMake.fonts, vfs || __webpack_require__.g.pdfMake.vfs);
                    }
                };
            /***/ },
            /***/ 52773: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var __dirname = "/";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                function VirtualFileSystem() {
                    this.fileSystem = {};
                    this.dataSystem = {};
                }
                VirtualFileSystem.prototype.existsSync = function(filename) {
                    filename = fixFilename(filename);
                    return typeof this.fileSystem[filename] !== "undefined" || typeof this.dataSystem[filename] !== "undefined";
                };
                VirtualFileSystem.prototype.readFileSync = function(filename, options) {
                    filename = fixFilename(filename);
                    var dataContent = this.dataSystem[filename];
                    if (typeof dataContent === "string" && options === "utf8") return dataContent;
                    if (dataContent) return new Buffer(dataContent, typeof dataContent === "string" ? "base64" : undefined);
                    var content = this.fileSystem[filename];
                    if (content) return content;
                    throw "File '" + filename + "' not found in virtual file system";
                };
                VirtualFileSystem.prototype.writeFileSync = function(filename, content) {
                    this.fileSystem[fixFilename(filename)] = content;
                };
                VirtualFileSystem.prototype.bindFS = function(data) {
                    this.dataSystem = data || {};
                };
                function fixFilename(filename) {
                    if (filename.indexOf(__dirname) === 0) filename = filename.substring(__dirname.length);
                    if (filename.indexOf("/") === 0) filename = filename.substring(1);
                    return filename;
                }
                module1.exports = new VirtualFileSystem();
            /***/ },
            /***/ 65354: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isString = __webpack_require__(16920).isString;
                function buildColumnWidths(columns, availableWidth) {
                    var autoColumns = [], autoMin = 0, autoMax = 0, starColumns = [], starMaxMin = 0, starMaxMax = 0, fixedColumns = [], initial_availableWidth = availableWidth;
                    columns.forEach(function(column) {
                        if (isAutoColumn(column)) {
                            autoColumns.push(column);
                            autoMin += column._minWidth;
                            autoMax += column._maxWidth;
                        } else if (isStarColumn(column)) {
                            starColumns.push(column);
                            starMaxMin = Math.max(starMaxMin, column._minWidth);
                            starMaxMax = Math.max(starMaxMax, column._maxWidth);
                        } else fixedColumns.push(column);
                    });
                    fixedColumns.forEach(function(col) {
                        // width specified as %
                        if (isString(col.width) && /\d+%/.test(col.width)) col.width = parseFloat(col.width) * initial_availableWidth / 100;
                        if (col.width < col._minWidth && col.elasticWidth) col._calcWidth = col._minWidth;
                        else col._calcWidth = col.width;
                        availableWidth -= col._calcWidth;
                    });
                    // http://www.freesoft.org/CIE/RFC/1942/18.htm
                    // http://www.w3.org/TR/CSS2/tables.html#width-layout
                    // http://dev.w3.org/csswg/css3-tables-algorithms/Overview.src.htm
                    var minW = autoMin + starMaxMin * starColumns.length;
                    var maxW = autoMax + starMaxMax * starColumns.length;
                    if (minW >= availableWidth) {
                        // case 1 - there's no way to fit all columns within available width
                        // that's actually pretty bad situation with PDF as we have no horizontal scroll
                        // no easy workaround (unless we decide, in the future, to split single words)
                        // currently we simply use minWidths for all columns
                        autoColumns.forEach(function(col) {
                            col._calcWidth = col._minWidth;
                        });
                        starColumns.forEach(function(col) {
                            col._calcWidth = starMaxMin; // starMaxMin already contains padding
                        });
                    } else {
                        if (maxW < availableWidth) // case 2 - we can fit rest of the table within available space
                        autoColumns.forEach(function(col) {
                            col._calcWidth = col._maxWidth;
                            availableWidth -= col._calcWidth;
                        });
                        else {
                            // maxW is too large, but minW fits within available width
                            var W = availableWidth - minW;
                            var D = maxW - minW;
                            autoColumns.forEach(function(col) {
                                var d = col._maxWidth - col._minWidth;
                                col._calcWidth = col._minWidth + d * W / D;
                                availableWidth -= col._calcWidth;
                            });
                        }
                        if (starColumns.length > 0) {
                            var starSize = availableWidth / starColumns.length;
                            starColumns.forEach(function(col) {
                                col._calcWidth = starSize;
                            });
                        }
                    }
                }
                function isAutoColumn(column) {
                    return column.width === "auto";
                }
                function isStarColumn(column) {
                    return column.width === null || column.width === undefined || column.width === "*" || column.width === "star";
                }
                //TODO: refactor and reuse in measureTable
                function measureMinMax(columns) {
                    var result = {
                        min: 0,
                        max: 0
                    };
                    var maxStar = {
                        min: 0,
                        max: 0
                    };
                    var starCount = 0;
                    for(var i = 0, l = columns.length; i < l; i++){
                        var c = columns[i];
                        if (isStarColumn(c)) {
                            maxStar.min = Math.max(maxStar.min, c._minWidth);
                            maxStar.max = Math.max(maxStar.max, c._maxWidth);
                            starCount++;
                        } else if (isAutoColumn(c)) {
                            result.min += c._minWidth;
                            result.max += c._maxWidth;
                        } else {
                            result.min += c.width !== undefined && c.width || c._minWidth;
                            result.max += c.width !== undefined && c.width || c._maxWidth;
                        }
                    }
                    if (starCount) {
                        result.min += starCount * maxStar.min;
                        result.max += starCount * maxStar.max;
                    }
                    return result;
                }
                /**
 * Calculates column widths
 * @private
 */ module1.exports = {
                    buildColumnWidths: buildColumnWidths,
                    measureMinMax: measureMinMax,
                    isAutoColumn: isAutoColumn,
                    isStarColumn: isStarColumn
                };
            /***/ },
            /***/ 77077: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /*eslint no-unused-vars: ["error", {"args": "none"}]*/ var TextTools = __webpack_require__(28045);
                var StyleContextStack = __webpack_require__(28034);
                var ColumnCalculator = __webpack_require__(65354);
                var isString = __webpack_require__(16920).isString;
                var isNumber = __webpack_require__(16920).isNumber;
                var isObject = __webpack_require__(16920).isObject;
                var isArray = __webpack_require__(16920).isArray;
                var fontStringify = __webpack_require__(16920).fontStringify;
                var getNodeId = __webpack_require__(16920).getNodeId;
                var pack = __webpack_require__(16920).pack;
                var qrEncoder = __webpack_require__(86976);
                /**
 * @private
 */ function DocMeasure(fontProvider, styleDictionary, defaultStyle, imageMeasure, svgMeasure, tableLayouts, images) {
                    this.textTools = new TextTools(fontProvider);
                    this.styleStack = new StyleContextStack(styleDictionary, defaultStyle);
                    this.imageMeasure = imageMeasure;
                    this.svgMeasure = svgMeasure;
                    this.tableLayouts = tableLayouts;
                    this.images = images;
                    this.autoImageIndex = 1;
                }
                /**
 * Measures all nodes and sets min/max-width properties required for the second
 * layout-pass.
 * @param  {Object} docStructure document-definition-object
 * @return {Object}              document-measurement-object
 */ DocMeasure.prototype.measureDocument = function(docStructure) {
                    return this.measureNode(docStructure);
                };
                DocMeasure.prototype.measureNode = function(node) {
                    var self1 = this;
                    return this.styleStack.auto(node, function() {
                        // TODO: refactor + rethink whether this is the proper way to handle margins
                        node._margin = getNodeMargin(node);
                        if (node.columns) return extendMargins(self1.measureColumns(node));
                        else if (node.stack) return extendMargins(self1.measureVerticalContainer(node));
                        else if (node.ul) return extendMargins(self1.measureUnorderedList(node));
                        else if (node.ol) return extendMargins(self1.measureOrderedList(node));
                        else if (node.table) return extendMargins(self1.measureTable(node));
                        else if (node.text !== undefined) return extendMargins(self1.measureLeaf(node));
                        else if (node.toc) return extendMargins(self1.measureToc(node));
                        else if (node.image) return extendMargins(self1.measureImage(node));
                        else if (node.svg) return extendMargins(self1.measureSVG(node));
                        else if (node.canvas) return extendMargins(self1.measureCanvas(node));
                        else if (node.qr) return extendMargins(self1.measureQr(node));
                        else throw "Unrecognized document structure: " + JSON.stringify(node, fontStringify);
                    });
                    function extendMargins(node) {
                        var margin = node._margin;
                        if (margin) {
                            node._minWidth += margin[0] + margin[2];
                            node._maxWidth += margin[0] + margin[2];
                        }
                        return node;
                    }
                    function getNodeMargin() {
                        function processSingleMargins(node, currentMargin) {
                            if (node.marginLeft || node.marginTop || node.marginRight || node.marginBottom) return [
                                node.marginLeft || currentMargin[0] || 0,
                                node.marginTop || currentMargin[1] || 0,
                                node.marginRight || currentMargin[2] || 0,
                                node.marginBottom || currentMargin[3] || 0
                            ];
                            return currentMargin;
                        }
                        function flattenStyleArray(styleArray) {
                            var flattenedStyles = {};
                            for(var i = styleArray.length - 1; i >= 0; i--){
                                var styleName = styleArray[i];
                                var style = self1.styleStack.styleDictionary[styleName];
                                for(var key in style)if (style.hasOwnProperty(key)) flattenedStyles[key] = style[key];
                            }
                            return flattenedStyles;
                        }
                        function convertMargin(margin) {
                            if (isNumber(margin)) margin = [
                                margin,
                                margin,
                                margin,
                                margin
                            ];
                            else if (isArray(margin)) {
                                if (margin.length === 2) margin = [
                                    margin[0],
                                    margin[1],
                                    margin[0],
                                    margin[1]
                                ];
                            }
                            return margin;
                        }
                        var margin = [
                            undefined,
                            undefined,
                            undefined,
                            undefined
                        ];
                        if (node.style) {
                            var styleArray = isArray(node.style) ? node.style : [
                                node.style
                            ];
                            var flattenedStyleArray = flattenStyleArray(styleArray);
                            if (flattenedStyleArray) margin = processSingleMargins(flattenedStyleArray, margin);
                            if (flattenedStyleArray.margin) margin = convertMargin(flattenedStyleArray.margin);
                        }
                        margin = processSingleMargins(node, margin);
                        if (node.margin) margin = convertMargin(node.margin);
                        if (margin[0] === undefined && margin[1] === undefined && margin[2] === undefined && margin[3] === undefined) return null;
                        else return margin;
                    }
                };
                DocMeasure.prototype.convertIfBase64Image = function(node) {
                    if (/^data:image\/(jpeg|jpg|png);base64,/.test(node.image)) {
                        var label = "$$pdfmake$$" + this.autoImageIndex++;
                        this.images[label] = node.image;
                        node.image = label;
                    }
                };
                DocMeasure.prototype.measureImageWithDimensions = function(node, dimensions) {
                    if (node.fit) {
                        var factor = dimensions.width / dimensions.height > node.fit[0] / node.fit[1] ? node.fit[0] / dimensions.width : node.fit[1] / dimensions.height;
                        node._width = node._minWidth = node._maxWidth = dimensions.width * factor;
                        node._height = dimensions.height * factor;
                    } else if (node.cover) {
                        node._width = node._minWidth = node._maxWidth = node.cover.width;
                        node._height = node._minHeight = node._maxHeight = node.cover.height;
                    } else {
                        node._width = node._minWidth = node._maxWidth = node.width || dimensions.width;
                        node._height = node.height || dimensions.height * node._width / dimensions.width;
                        if (isNumber(node.maxWidth) && node.maxWidth < node._width) {
                            node._width = node._minWidth = node._maxWidth = node.maxWidth;
                            node._height = node._width * dimensions.height / dimensions.width;
                        }
                        if (isNumber(node.maxHeight) && node.maxHeight < node._height) {
                            node._height = node.maxHeight;
                            node._width = node._minWidth = node._maxWidth = node._height * dimensions.width / dimensions.height;
                        }
                        if (isNumber(node.minWidth) && node.minWidth > node._width) {
                            node._width = node._minWidth = node._maxWidth = node.minWidth;
                            node._height = node._width * dimensions.height / dimensions.width;
                        }
                        if (isNumber(node.minHeight) && node.minHeight > node._height) {
                            node._height = node.minHeight;
                            node._width = node._minWidth = node._maxWidth = node._height * dimensions.width / dimensions.height;
                        }
                    }
                    node._alignment = this.styleStack.getProperty("alignment");
                };
                DocMeasure.prototype.measureImage = function(node) {
                    if (this.images) this.convertIfBase64Image(node);
                    var dimensions = this.imageMeasure.measureImage(node.image);
                    this.measureImageWithDimensions(node, dimensions);
                    return node;
                };
                DocMeasure.prototype.measureSVG = function(node) {
                    var dimensions = this.svgMeasure.measureSVG(node.svg);
                    this.measureImageWithDimensions(node, dimensions);
                    node.font = this.styleStack.getProperty("font");
                    // scale SVG based on final dimension
                    node.svg = this.svgMeasure.writeDimensions(node.svg, {
                        width: node._width,
                        height: node._height
                    });
                    return node;
                };
                DocMeasure.prototype.measureLeaf = function(node) {
                    if (node._textRef && node._textRef._textNodeRef.text) node.text = node._textRef._textNodeRef.text;
                    // Make sure style properties of the node itself are considered when building inlines.
                    // We could also just pass [node] to buildInlines, but that fails for bullet points.
                    var styleStack = this.styleStack.clone();
                    styleStack.push(node);
                    var data = this.textTools.buildInlines(node.text, styleStack);
                    node._inlines = data.items;
                    node._minWidth = data.minWidth;
                    node._maxWidth = data.maxWidth;
                    return node;
                };
                DocMeasure.prototype.measureToc = function(node) {
                    if (node.toc.title) node.toc.title = this.measureNode(node.toc.title);
                    if (node.toc._items.length > 0) {
                        var body = [];
                        var textStyle = node.toc.textStyle || {};
                        var numberStyle = node.toc.numberStyle || textStyle;
                        var textMargin = node.toc.textMargin || [
                            0,
                            0,
                            0,
                            0
                        ];
                        for(var i = 0, l = node.toc._items.length; i < l; i++){
                            var item = node.toc._items[i];
                            var lineStyle = item._textNodeRef.tocStyle || textStyle;
                            var lineMargin = item._textNodeRef.tocMargin || textMargin;
                            var lineNumberStyle = item._textNodeRef.tocNumberStyle || numberStyle;
                            var destination = getNodeId(item._nodeRef);
                            body.push([
                                {
                                    text: item._textNodeRef.text,
                                    linkToDestination: destination,
                                    alignment: "left",
                                    style: lineStyle,
                                    margin: lineMargin
                                },
                                {
                                    text: "00000",
                                    linkToDestination: destination,
                                    alignment: "right",
                                    _tocItemRef: item._nodeRef,
                                    style: lineNumberStyle,
                                    margin: [
                                        0,
                                        lineMargin[1],
                                        0,
                                        lineMargin[3]
                                    ]
                                }
                            ]);
                        }
                        node.toc._table = {
                            table: {
                                dontBreakRows: true,
                                widths: [
                                    "*",
                                    "auto"
                                ],
                                body: body
                            },
                            layout: "noBorders"
                        };
                        node.toc._table = this.measureNode(node.toc._table);
                    }
                    return node;
                };
                DocMeasure.prototype.measureVerticalContainer = function(node) {
                    var items = node.stack;
                    node._minWidth = 0;
                    node._maxWidth = 0;
                    for(var i = 0, l = items.length; i < l; i++){
                        items[i] = this.measureNode(items[i]);
                        node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
                        node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
                    }
                    return node;
                };
                DocMeasure.prototype.gapSizeForList = function() {
                    return this.textTools.sizeOfString("9. ", this.styleStack);
                };
                DocMeasure.prototype.buildUnorderedMarker = function(styleStack, gapSize, type) {
                    function buildDisc(gapSize, color) {
                        // TODO: ascender-based calculations
                        var radius = gapSize.fontSize / 6;
                        return {
                            canvas: [
                                {
                                    x: radius,
                                    y: gapSize.height / gapSize.lineHeight + gapSize.descender - gapSize.fontSize / 3,
                                    r1: radius,
                                    r2: radius,
                                    type: "ellipse",
                                    color: color
                                }
                            ]
                        };
                    }
                    function buildSquare(gapSize, color) {
                        // TODO: ascender-based calculations
                        var size = gapSize.fontSize / 3;
                        return {
                            canvas: [
                                {
                                    x: 0,
                                    y: gapSize.height / gapSize.lineHeight + gapSize.descender - gapSize.fontSize / 3 - size / 2,
                                    h: size,
                                    w: size,
                                    type: "rect",
                                    color: color
                                }
                            ]
                        };
                    }
                    function buildCircle(gapSize, color) {
                        // TODO: ascender-based calculations
                        var radius = gapSize.fontSize / 6;
                        return {
                            canvas: [
                                {
                                    x: radius,
                                    y: gapSize.height / gapSize.lineHeight + gapSize.descender - gapSize.fontSize / 3,
                                    r1: radius,
                                    r2: radius,
                                    type: "ellipse",
                                    lineColor: color
                                }
                            ]
                        };
                    }
                    var marker;
                    var color = styleStack.getProperty("markerColor") || styleStack.getProperty("color") || "black";
                    switch(type){
                        case "circle":
                            marker = buildCircle(gapSize, color);
                            break;
                        case "square":
                            marker = buildSquare(gapSize, color);
                            break;
                        case "none":
                            marker = {};
                            break;
                        case "disc":
                        default:
                            marker = buildDisc(gapSize, color);
                            break;
                    }
                    marker._minWidth = marker._maxWidth = gapSize.width;
                    marker._minHeight = marker._maxHeight = gapSize.height;
                    return marker;
                };
                DocMeasure.prototype.buildOrderedMarker = function(counter, styleStack, type, separator) {
                    function prepareAlpha(counter) {
                        function toAlpha(num) {
                            return (num >= 26 ? toAlpha((num / 26 >> 0) - 1) : "") + "abcdefghijklmnopqrstuvwxyz"[num % 26 >> 0];
                        }
                        if (counter < 1) return counter.toString();
                        return toAlpha(counter - 1);
                    }
                    function prepareRoman(counter) {
                        if (counter < 1 || counter > 4999) return counter.toString();
                        var num = counter;
                        var lookup = {
                            M: 1000,
                            CM: 900,
                            D: 500,
                            CD: 400,
                            C: 100,
                            XC: 90,
                            L: 50,
                            XL: 40,
                            X: 10,
                            IX: 9,
                            V: 5,
                            IV: 4,
                            I: 1
                        }, roman = "", i;
                        for(i in lookup)while(num >= lookup[i]){
                            roman += i;
                            num -= lookup[i];
                        }
                        return roman;
                    }
                    function prepareDecimal(counter) {
                        return counter.toString();
                    }
                    var counterText;
                    switch(type){
                        case "none":
                            counterText = null;
                            break;
                        case "upper-alpha":
                            counterText = prepareAlpha(counter).toUpperCase();
                            break;
                        case "lower-alpha":
                            counterText = prepareAlpha(counter);
                            break;
                        case "upper-roman":
                            counterText = prepareRoman(counter);
                            break;
                        case "lower-roman":
                            counterText = prepareRoman(counter).toLowerCase();
                            break;
                        case "decimal":
                        default:
                            counterText = prepareDecimal(counter);
                            break;
                    }
                    if (counterText === null) return {};
                    if (separator) {
                        if (isArray(separator)) {
                            if (separator[0]) counterText = separator[0] + counterText;
                            if (separator[1]) counterText += separator[1];
                            counterText += " ";
                        } else counterText += separator + " ";
                    }
                    var textArray = {
                        text: counterText
                    };
                    var markerColor = styleStack.getProperty("markerColor");
                    if (markerColor) textArray.color = markerColor;
                    return {
                        _inlines: this.textTools.buildInlines(textArray, styleStack).items
                    };
                };
                DocMeasure.prototype.measureUnorderedList = function(node) {
                    var style = this.styleStack.clone();
                    var items = node.ul;
                    node.type = node.type || "disc";
                    node._gapSize = this.gapSizeForList();
                    node._minWidth = 0;
                    node._maxWidth = 0;
                    for(var i = 0, l = items.length; i < l; i++){
                        var item = items[i] = this.measureNode(items[i]);
                        if (!item.ol && !item.ul) item.listMarker = this.buildUnorderedMarker(style, node._gapSize, item.listType || node.type);
                        node._minWidth = Math.max(node._minWidth, items[i]._minWidth + node._gapSize.width);
                        node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth + node._gapSize.width);
                    }
                    return node;
                };
                DocMeasure.prototype.measureOrderedList = function(node) {
                    var style = this.styleStack.clone();
                    var items = node.ol;
                    node.type = node.type || "decimal";
                    node.separator = node.separator || ".";
                    node.reversed = node.reversed || false;
                    if (!isNumber(node.start)) node.start = node.reversed ? items.length : 1;
                    node._gapSize = this.gapSizeForList();
                    node._minWidth = 0;
                    node._maxWidth = 0;
                    var counter = node.start;
                    for(var i = 0, l = items.length; i < l; i++){
                        var item = items[i] = this.measureNode(items[i]);
                        if (!item.ol && !item.ul) {
                            var counterValue = isNumber(item.counter) ? item.counter : counter;
                            item.listMarker = this.buildOrderedMarker(counterValue, style, item.listType || node.type, node.separator);
                            if (item.listMarker._inlines) node._gapSize.width = Math.max(node._gapSize.width, item.listMarker._inlines[0].width);
                        } // TODO: else - nested lists numbering
                        node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
                        node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
                        if (node.reversed) counter--;
                        else counter++;
                    }
                    node._minWidth += node._gapSize.width;
                    node._maxWidth += node._gapSize.width;
                    for(var i = 0, l = items.length; i < l; i++){
                        var item = items[i];
                        if (!item.ol && !item.ul) item.listMarker._minWidth = item.listMarker._maxWidth = node._gapSize.width;
                    }
                    return node;
                };
                DocMeasure.prototype.measureColumns = function(node) {
                    var columns = node.columns;
                    node._gap = this.styleStack.getProperty("columnGap") || 0;
                    for(var i = 0, l = columns.length; i < l; i++)columns[i] = this.measureNode(columns[i]);
                    var measures = ColumnCalculator.measureMinMax(columns);
                    var numGaps = columns.length > 0 ? columns.length - 1 : 0;
                    node._minWidth = measures.min + node._gap * numGaps;
                    node._maxWidth = measures.max + node._gap * numGaps;
                    return node;
                };
                DocMeasure.prototype.measureTable = function(node) {
                    extendTableWidths(node);
                    node._layout = getLayout(this.tableLayouts);
                    node._offsets = getOffsets(node._layout);
                    var colSpans = [];
                    var col, row, cols, rows;
                    for(col = 0, cols = node.table.body[0].length; col < cols; col++){
                        var c = node.table.widths[col];
                        c._minWidth = 0;
                        c._maxWidth = 0;
                        for(row = 0, rows = node.table.body.length; row < rows; row++){
                            var rowData = node.table.body[row];
                            var data = rowData[col];
                            if (data === undefined) {
                                console.error("Malformed table row ", rowData, "in node ", node);
                                throw "Malformed table row, a cell is undefined.";
                            }
                            if (data === null) data = "";
                            if (!data._span) {
                                data = rowData[col] = this.styleStack.auto(data, measureCb(this, data));
                                if (data.colSpan && data.colSpan > 1) {
                                    markSpans(rowData, col, data.colSpan);
                                    colSpans.push({
                                        col: col,
                                        span: data.colSpan,
                                        minWidth: data._minWidth,
                                        maxWidth: data._maxWidth
                                    });
                                } else {
                                    c._minWidth = Math.max(c._minWidth, data._minWidth);
                                    c._maxWidth = Math.max(c._maxWidth, data._maxWidth);
                                }
                            }
                            if (data.rowSpan && data.rowSpan > 1) markVSpans(node.table, row, col, data.rowSpan);
                        }
                    }
                    extendWidthsForColSpans();
                    var measures = ColumnCalculator.measureMinMax(node.table.widths);
                    node._minWidth = measures.min + node._offsets.total;
                    node._maxWidth = measures.max + node._offsets.total;
                    return node;
                    function measureCb(_this, data) {
                        return function() {
                            if (isObject(data)) {
                                data.fillColor = _this.styleStack.getProperty("fillColor");
                                data.fillOpacity = _this.styleStack.getProperty("fillOpacity");
                            }
                            return _this.measureNode(data);
                        };
                    }
                    function getLayout(tableLayouts) {
                        var layout = node.layout;
                        if (isString(layout)) layout = tableLayouts[layout];
                        var defaultLayout = {
                            hLineWidth: function(i, node) {
                                return 1;
                            },
                            vLineWidth: function(i, node) {
                                return 1;
                            },
                            hLineColor: function(i, node) {
                                return "black";
                            },
                            vLineColor: function(i, node) {
                                return "black";
                            },
                            hLineStyle: function(i, node) {
                                return null;
                            },
                            vLineStyle: function(i, node) {
                                return null;
                            },
                            paddingLeft: function(i, node) {
                                return 4;
                            },
                            paddingRight: function(i, node) {
                                return 4;
                            },
                            paddingTop: function(i, node) {
                                return 2;
                            },
                            paddingBottom: function(i, node) {
                                return 2;
                            },
                            fillColor: function(i, node) {
                                return null;
                            },
                            fillOpacity: function(i, node) {
                                return 1;
                            },
                            defaultBorder: true
                        };
                        return pack(defaultLayout, layout);
                    }
                    function getOffsets(layout) {
                        var offsets = [];
                        var totalOffset = 0;
                        var prevRightPadding = 0;
                        for(var i = 0, l = node.table.widths.length; i < l; i++){
                            var lOffset = prevRightPadding + layout.vLineWidth(i, node) + layout.paddingLeft(i, node);
                            offsets.push(lOffset);
                            totalOffset += lOffset;
                            prevRightPadding = layout.paddingRight(i, node);
                        }
                        totalOffset += prevRightPadding + layout.vLineWidth(node.table.widths.length, node);
                        return {
                            total: totalOffset,
                            offsets: offsets
                        };
                    }
                    function extendWidthsForColSpans() {
                        var q, j;
                        for(var i = 0, l = colSpans.length; i < l; i++){
                            var span = colSpans[i];
                            var currentMinMax = getMinMax(span.col, span.span, node._offsets);
                            var minDifference = span.minWidth - currentMinMax.minWidth;
                            var maxDifference = span.maxWidth - currentMinMax.maxWidth;
                            if (minDifference > 0) {
                                q = minDifference / span.span;
                                for(j = 0; j < span.span; j++)node.table.widths[span.col + j]._minWidth += q;
                            }
                            if (maxDifference > 0) {
                                q = maxDifference / span.span;
                                for(j = 0; j < span.span; j++)node.table.widths[span.col + j]._maxWidth += q;
                            }
                        }
                    }
                    function getMinMax(col, span, offsets) {
                        var result = {
                            minWidth: 0,
                            maxWidth: 0
                        };
                        for(var i = 0; i < span; i++){
                            result.minWidth += node.table.widths[col + i]._minWidth + (i ? offsets.offsets[col + i] : 0);
                            result.maxWidth += node.table.widths[col + i]._maxWidth + (i ? offsets.offsets[col + i] : 0);
                        }
                        return result;
                    }
                    function markSpans(rowData, col, span) {
                        for(var i = 1; i < span; i++)rowData[col + i] = {
                            _span: true,
                            _minWidth: 0,
                            _maxWidth: 0,
                            rowSpan: rowData[col].rowSpan
                        };
                    }
                    function markVSpans(table, row, col, span) {
                        for(var i = 1; i < span; i++)table.body[row + i][col] = {
                            _span: true,
                            _minWidth: 0,
                            _maxWidth: 0,
                            fillColor: table.body[row][col].fillColor,
                            fillOpacity: table.body[row][col].fillOpacity
                        };
                    }
                    function extendTableWidths(node) {
                        if (!node.table.widths) node.table.widths = "auto";
                        if (isString(node.table.widths)) {
                            node.table.widths = [
                                node.table.widths
                            ];
                            while(node.table.widths.length < node.table.body[0].length)node.table.widths.push(node.table.widths[node.table.widths.length - 1]);
                        }
                        for(var i = 0, l = node.table.widths.length; i < l; i++){
                            var w = node.table.widths[i];
                            if (isNumber(w) || isString(w)) node.table.widths[i] = {
                                width: w
                            };
                        }
                    }
                };
                DocMeasure.prototype.measureCanvas = function(node) {
                    var w = 0, h = 0;
                    for(var i = 0, l = node.canvas.length; i < l; i++){
                        var vector = node.canvas[i];
                        switch(vector.type){
                            case "ellipse":
                                w = Math.max(w, vector.x + vector.r1);
                                h = Math.max(h, vector.y + vector.r2);
                                break;
                            case "rect":
                                w = Math.max(w, vector.x + vector.w);
                                h = Math.max(h, vector.y + vector.h);
                                break;
                            case "line":
                                w = Math.max(w, vector.x1, vector.x2);
                                h = Math.max(h, vector.y1, vector.y2);
                                break;
                            case "polyline":
                                for(var i2 = 0, l2 = vector.points.length; i2 < l2; i2++){
                                    w = Math.max(w, vector.points[i2].x);
                                    h = Math.max(h, vector.points[i2].y);
                                }
                                break;
                        }
                    }
                    node._minWidth = node._maxWidth = w;
                    node._minHeight = node._maxHeight = h;
                    node._alignment = this.styleStack.getProperty("alignment");
                    return node;
                };
                DocMeasure.prototype.measureQr = function(node) {
                    node = qrEncoder.measure(node);
                    node._alignment = this.styleStack.getProperty("alignment");
                    return node;
                };
                module1.exports = DocMeasure;
            /***/ },
            /***/ 78702: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                var isString = __webpack_require__(16920).isString;
                var isNumber = __webpack_require__(16920).isNumber;
                var isBoolean = __webpack_require__(16920).isBoolean;
                var isArray = __webpack_require__(16920).isArray;
                var isUndefined = __webpack_require__(16920).isUndefined;
                var fontStringify = __webpack_require__(16920).fontStringify;
                function DocPreprocessor() {}
                DocPreprocessor.prototype.preprocessDocument = function(docStructure) {
                    this.parentNode = null;
                    this.tocs = [];
                    this.nodeReferences = [];
                    return this.preprocessNode(docStructure);
                };
                DocPreprocessor.prototype.preprocessNode = function(node) {
                    // expand shortcuts and casting values
                    if (isArray(node)) node = {
                        stack: node
                    };
                    else if (isString(node)) node = {
                        text: node
                    };
                    else if (isNumber(node) || isBoolean(node)) node = {
                        text: node.toString()
                    };
                    else if (node === undefined || node === null) node = {
                        text: ""
                    };
                    else if (Object.keys(node).length === 0) node = {
                        text: ""
                    };
                    else if ("text" in node && (node.text === undefined || node.text === null)) node.text = "";
                    if (node.columns) return this.preprocessColumns(node);
                    else if (node.stack) return this.preprocessVerticalContainer(node);
                    else if (node.ul) return this.preprocessList(node);
                    else if (node.ol) return this.preprocessList(node);
                    else if (node.table) return this.preprocessTable(node);
                    else if (node.text !== undefined) return this.preprocessText(node);
                    else if (node.toc) return this.preprocessToc(node);
                    else if (node.image) return this.preprocessImage(node);
                    else if (node.svg) return this.preprocessSVG(node);
                    else if (node.canvas) return this.preprocessCanvas(node);
                    else if (node.qr) return this.preprocessQr(node);
                    else if (node.pageReference || node.textReference) return this.preprocessText(node);
                    else throw "Unrecognized document structure: " + JSON.stringify(node, fontStringify);
                };
                DocPreprocessor.prototype.preprocessColumns = function(node) {
                    var columns = node.columns;
                    for(var i = 0, l = columns.length; i < l; i++)columns[i] = this.preprocessNode(columns[i]);
                    return node;
                };
                DocPreprocessor.prototype.preprocessVerticalContainer = function(node) {
                    var items = node.stack;
                    for(var i = 0, l = items.length; i < l; i++)items[i] = this.preprocessNode(items[i]);
                    return node;
                };
                DocPreprocessor.prototype.preprocessList = function(node) {
                    var items = node.ul || node.ol;
                    for(var i = 0, l = items.length; i < l; i++)items[i] = this.preprocessNode(items[i]);
                    return node;
                };
                DocPreprocessor.prototype.preprocessTable = function(node) {
                    var col, row, cols, rows;
                    for(col = 0, cols = node.table.body[0].length; col < cols; col++)for(row = 0, rows = node.table.body.length; row < rows; row++){
                        var rowData = node.table.body[row];
                        var data = rowData[col];
                        if (data !== undefined) {
                            if (data === null) data = "";
                            if (!data._span) rowData[col] = this.preprocessNode(data);
                        }
                    }
                    return node;
                };
                DocPreprocessor.prototype.preprocessText = function(node) {
                    if (node.tocItem) {
                        if (!isArray(node.tocItem)) node.tocItem = [
                            node.tocItem
                        ];
                        for(var i = 0, l = node.tocItem.length; i < l; i++){
                            if (!isString(node.tocItem[i])) node.tocItem[i] = "_default_";
                            var tocItemId = node.tocItem[i];
                            if (!this.tocs[tocItemId]) this.tocs[tocItemId] = {
                                toc: {
                                    _items: [],
                                    _pseudo: true
                                }
                            };
                            if (!node.id) node.id = "toc-" + tocItemId + "-" + this.tocs[tocItemId].toc._items.length;
                            var tocItemRef = {
                                _nodeRef: this._getNodeForNodeRef(node),
                                _textNodeRef: node
                            };
                            this.tocs[tocItemId].toc._items.push(tocItemRef);
                        }
                    }
                    if (node.id) {
                        if (this.nodeReferences[node.id]) {
                            if (!this.nodeReferences[node.id]._pseudo) throw "Node id '" + node.id + "' already exists";
                            this.nodeReferences[node.id]._nodeRef = this._getNodeForNodeRef(node);
                            this.nodeReferences[node.id]._textNodeRef = node;
                            this.nodeReferences[node.id]._pseudo = false;
                        } else this.nodeReferences[node.id] = {
                            _nodeRef: this._getNodeForNodeRef(node),
                            _textNodeRef: node
                        };
                    }
                    if (node.pageReference) {
                        if (!this.nodeReferences[node.pageReference]) this.nodeReferences[node.pageReference] = {
                            _nodeRef: {},
                            _textNodeRef: {},
                            _pseudo: true
                        };
                        node.text = "00000";
                        node.linkToDestination = node.pageReference;
                        node._pageRef = this.nodeReferences[node.pageReference];
                    }
                    if (node.textReference) {
                        if (!this.nodeReferences[node.textReference]) this.nodeReferences[node.textReference] = {
                            _nodeRef: {},
                            _pseudo: true
                        };
                        node.text = "";
                        node.linkToDestination = node.textReference;
                        node._textRef = this.nodeReferences[node.textReference];
                    }
                    if (node.text && node.text.text) node.text = [
                        this.preprocessNode(node.text)
                    ];
                    else if (isArray(node.text)) {
                        var isSetParentNode = false;
                        if (this.parentNode === null) {
                            this.parentNode = node;
                            isSetParentNode = true;
                        }
                        for(var i = 0, l = node.text.length; i < l; i++)node.text[i] = this.preprocessNode(node.text[i]);
                        if (isSetParentNode) this.parentNode = null;
                    }
                    return node;
                };
                DocPreprocessor.prototype.preprocessToc = function(node) {
                    if (!node.toc.id) node.toc.id = "_default_";
                    node.toc.title = node.toc.title ? this.preprocessNode(node.toc.title) : null;
                    node.toc._items = [];
                    if (this.tocs[node.toc.id]) {
                        if (!this.tocs[node.toc.id].toc._pseudo) throw "TOC '" + node.toc.id + "' already exists";
                        node.toc._items = this.tocs[node.toc.id].toc._items;
                    }
                    this.tocs[node.toc.id] = node;
                    return node;
                };
                DocPreprocessor.prototype.preprocessImage = function(node) {
                    if (!isUndefined(node.image.type) && !isUndefined(node.image.data) && node.image.type === "Buffer" && isArray(node.image.data)) node.image = Buffer.from(node.image.data);
                    return node;
                };
                DocPreprocessor.prototype.preprocessSVG = function(node) {
                    return node;
                };
                DocPreprocessor.prototype.preprocessCanvas = function(node) {
                    return node;
                };
                DocPreprocessor.prototype.preprocessQr = function(node) {
                    return node;
                };
                DocPreprocessor.prototype._getNodeForNodeRef = function(node) {
                    if (this.parentNode) return this.parentNode;
                    return node;
                };
                module1.exports = DocPreprocessor;
            /***/ },
            /***/ 79833: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TraversalTracker = __webpack_require__(73602);
                var isString = __webpack_require__(16920).isString;
                /**
 * Creates an instance of DocumentContext - a store for current x, y positions and available width/height.
 * It facilitates column divisions and vertical sync
 */ function DocumentContext(pageSize, pageMargins) {
                    this.pages = [];
                    this.pageMargins = pageMargins;
                    this.x = pageMargins.left;
                    this.availableWidth = pageSize.width - pageMargins.left - pageMargins.right;
                    this.availableHeight = 0;
                    this.page = -1;
                    this.snapshots = [];
                    this.endingCell = null;
                    this.tracker = new TraversalTracker();
                    this.backgroundLength = [];
                    this.addPage(pageSize);
                }
                DocumentContext.prototype.beginColumnGroup = function() {
                    this.snapshots.push({
                        x: this.x,
                        y: this.y,
                        availableHeight: this.availableHeight,
                        availableWidth: this.availableWidth,
                        page: this.page,
                        bottomMost: {
                            x: this.x,
                            y: this.y,
                            availableHeight: this.availableHeight,
                            availableWidth: this.availableWidth,
                            page: this.page
                        },
                        endingCell: this.endingCell,
                        lastColumnWidth: this.lastColumnWidth
                    });
                    this.lastColumnWidth = 0;
                };
                DocumentContext.prototype.beginColumn = function(width, offset, endingCell) {
                    var saved = this.snapshots[this.snapshots.length - 1];
                    this.calculateBottomMost(saved);
                    this.endingCell = endingCell;
                    this.page = saved.page;
                    this.x = this.x + this.lastColumnWidth + (offset || 0);
                    this.y = saved.y;
                    this.availableWidth = width; //saved.availableWidth - offset;
                    this.availableHeight = saved.availableHeight;
                    this.lastColumnWidth = width;
                };
                DocumentContext.prototype.calculateBottomMost = function(destContext) {
                    if (this.endingCell) {
                        this.saveContextInEndingCell(this.endingCell);
                        this.endingCell = null;
                    } else destContext.bottomMost = bottomMostContext(this, destContext.bottomMost);
                };
                DocumentContext.prototype.markEnding = function(endingCell) {
                    this.page = endingCell._columnEndingContext.page;
                    this.x = endingCell._columnEndingContext.x;
                    this.y = endingCell._columnEndingContext.y;
                    this.availableWidth = endingCell._columnEndingContext.availableWidth;
                    this.availableHeight = endingCell._columnEndingContext.availableHeight;
                    this.lastColumnWidth = endingCell._columnEndingContext.lastColumnWidth;
                };
                DocumentContext.prototype.saveContextInEndingCell = function(endingCell) {
                    endingCell._columnEndingContext = {
                        page: this.page,
                        x: this.x,
                        y: this.y,
                        availableHeight: this.availableHeight,
                        availableWidth: this.availableWidth,
                        lastColumnWidth: this.lastColumnWidth
                    };
                };
                DocumentContext.prototype.completeColumnGroup = function(height) {
                    var saved = this.snapshots.pop();
                    this.calculateBottomMost(saved);
                    this.endingCell = null;
                    this.x = saved.x;
                    var y = saved.bottomMost.y;
                    if (height) {
                        if (saved.page === saved.bottomMost.page) {
                            if (saved.y + height > y) y = saved.y + height;
                        } else y += height;
                    }
                    this.y = y;
                    this.page = saved.bottomMost.page;
                    this.availableWidth = saved.availableWidth;
                    this.availableHeight = saved.bottomMost.availableHeight;
                    if (height) this.availableHeight -= y - saved.bottomMost.y;
                    this.lastColumnWidth = saved.lastColumnWidth;
                };
                DocumentContext.prototype.addMargin = function(left, right) {
                    this.x += left;
                    this.availableWidth -= left + (right || 0);
                };
                DocumentContext.prototype.moveDown = function(offset) {
                    this.y += offset;
                    this.availableHeight -= offset;
                    return this.availableHeight > 0;
                };
                DocumentContext.prototype.initializePage = function() {
                    this.y = this.pageMargins.top;
                    this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
                    this.pageSnapshot().availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
                };
                DocumentContext.prototype.pageSnapshot = function() {
                    if (this.snapshots[0]) return this.snapshots[0];
                    else return this;
                };
                DocumentContext.prototype.moveTo = function(x, y) {
                    if (x !== undefined && x !== null) {
                        this.x = x;
                        this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right;
                    }
                    if (y !== undefined && y !== null) {
                        this.y = y;
                        this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom;
                    }
                };
                DocumentContext.prototype.moveToRelative = function(x, y) {
                    if (x !== undefined && x !== null) this.x = this.x + x;
                    if (y !== undefined && y !== null) this.y = this.y + y;
                };
                DocumentContext.prototype.beginDetachedBlock = function() {
                    this.snapshots.push({
                        x: this.x,
                        y: this.y,
                        availableHeight: this.availableHeight,
                        availableWidth: this.availableWidth,
                        page: this.page,
                        endingCell: this.endingCell,
                        lastColumnWidth: this.lastColumnWidth
                    });
                };
                DocumentContext.prototype.endDetachedBlock = function() {
                    var saved = this.snapshots.pop();
                    this.x = saved.x;
                    this.y = saved.y;
                    this.availableWidth = saved.availableWidth;
                    this.availableHeight = saved.availableHeight;
                    this.page = saved.page;
                    this.endingCell = saved.endingCell;
                    this.lastColumnWidth = saved.lastColumnWidth;
                };
                function pageOrientation(pageOrientationString, currentPageOrientation) {
                    if (pageOrientationString === undefined) return currentPageOrientation;
                    else if (isString(pageOrientationString) && pageOrientationString.toLowerCase() === "landscape") return "landscape";
                    else return "portrait";
                }
                var getPageSize = function(currentPage, newPageOrientation) {
                    newPageOrientation = pageOrientation(newPageOrientation, currentPage.pageSize.orientation);
                    if (newPageOrientation !== currentPage.pageSize.orientation) return {
                        orientation: newPageOrientation,
                        width: currentPage.pageSize.height,
                        height: currentPage.pageSize.width
                    };
                    else return {
                        orientation: currentPage.pageSize.orientation,
                        width: currentPage.pageSize.width,
                        height: currentPage.pageSize.height
                    };
                };
                DocumentContext.prototype.moveToNextPage = function(pageOrientation) {
                    var nextPageIndex = this.page + 1;
                    var prevPage = this.page;
                    var prevY = this.y;
                    var createNewPage = nextPageIndex >= this.pages.length;
                    if (createNewPage) {
                        var currentAvailableWidth = this.availableWidth;
                        var currentPageOrientation = this.getCurrentPage().pageSize.orientation;
                        var pageSize = getPageSize(this.getCurrentPage(), pageOrientation);
                        this.addPage(pageSize);
                        if (currentPageOrientation === pageSize.orientation) this.availableWidth = currentAvailableWidth;
                    } else {
                        this.page = nextPageIndex;
                        this.initializePage();
                    }
                    return {
                        newPageCreated: createNewPage,
                        prevPage: prevPage,
                        prevY: prevY,
                        y: this.y
                    };
                };
                DocumentContext.prototype.addPage = function(pageSize) {
                    var page = {
                        items: [],
                        pageSize: pageSize
                    };
                    this.pages.push(page);
                    this.backgroundLength.push(0);
                    this.page = this.pages.length - 1;
                    this.initializePage();
                    this.tracker.emit("pageAdded");
                    return page;
                };
                DocumentContext.prototype.getCurrentPage = function() {
                    if (this.page < 0 || this.page >= this.pages.length) return null;
                    return this.pages[this.page];
                };
                DocumentContext.prototype.getCurrentPosition = function() {
                    var pageSize = this.getCurrentPage().pageSize;
                    var innerHeight = pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
                    var innerWidth = pageSize.width - this.pageMargins.left - this.pageMargins.right;
                    return {
                        pageNumber: this.page + 1,
                        pageOrientation: pageSize.orientation,
                        pageInnerHeight: innerHeight,
                        pageInnerWidth: innerWidth,
                        left: this.x,
                        top: this.y,
                        verticalRatio: (this.y - this.pageMargins.top) / innerHeight,
                        horizontalRatio: (this.x - this.pageMargins.left) / innerWidth
                    };
                };
                function bottomMostContext(c1, c2) {
                    var r;
                    if (c1.page > c2.page) r = c1;
                    else if (c2.page > c1.page) r = c2;
                    else r = c1.y > c2.y ? c1 : c2;
                    return {
                        page: r.page,
                        x: r.x,
                        y: r.y,
                        availableHeight: r.availableHeight,
                        availableWidth: r.availableWidth
                    };
                }
                module1.exports = DocumentContext;
            /***/ },
            /***/ 84786: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Line = __webpack_require__(79547);
                var isNumber = __webpack_require__(16920).isNumber;
                var pack = __webpack_require__(16920).pack;
                var offsetVector = __webpack_require__(16920).offsetVector;
                var DocumentContext = __webpack_require__(79833);
                /**
 * Creates an instance of ElementWriter - a line/vector writer, which adds
 * elements to current page and sets their positions based on the context
 */ function ElementWriter(context, tracker) {
                    this.context = context;
                    this.contextStack = [];
                    this.tracker = tracker;
                }
                function addPageItem(page, item, index) {
                    if (index === null || index === undefined || index < 0 || index > page.items.length) page.items.push(item);
                    else page.items.splice(index, 0, item);
                }
                ElementWriter.prototype.addLine = function(line, dontUpdateContextPosition, index) {
                    var height = line.getHeight();
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (context.availableHeight < height || !page) return false;
                    line.x = context.x + (line.x || 0);
                    line.y = context.y + (line.y || 0);
                    this.alignLine(line);
                    addPageItem(page, {
                        type: "line",
                        item: line
                    }, index);
                    this.tracker.emit("lineAdded", line);
                    if (!dontUpdateContextPosition) context.moveDown(height);
                    return position;
                };
                ElementWriter.prototype.alignLine = function(line) {
                    var width = this.context.availableWidth;
                    var lineWidth = line.getWidth();
                    var alignment = line.inlines && line.inlines.length > 0 && line.inlines[0].alignment;
                    var offset = 0;
                    switch(alignment){
                        case "right":
                            offset = width - lineWidth;
                            break;
                        case "center":
                            offset = (width - lineWidth) / 2;
                            break;
                    }
                    if (offset) line.x = (line.x || 0) + offset;
                    if (alignment === "justify" && !line.newLineForced && !line.lastLineInParagraph && line.inlines.length > 1) {
                        var additionalSpacing = (width - lineWidth) / (line.inlines.length - 1);
                        for(var i = 1, l = line.inlines.length; i < l; i++){
                            offset = i * additionalSpacing;
                            line.inlines[i].x += offset;
                            line.inlines[i].justifyShift = additionalSpacing;
                        }
                    }
                };
                ElementWriter.prototype.addImage = function(image, index, type) {
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (!page || image.absolutePosition === undefined && context.availableHeight < image._height && page.items.length > 0) return false;
                    if (image._x === undefined) image._x = image.x || 0;
                    image.x = context.x + image._x;
                    image.y = context.y;
                    this.alignImage(image);
                    addPageItem(page, {
                        type: type || "image",
                        item: image
                    }, index);
                    context.moveDown(image._height);
                    return position;
                };
                ElementWriter.prototype.addSVG = function(image, index) {
                    return this.addImage(image, index, "svg");
                };
                ElementWriter.prototype.addQr = function(qr, index) {
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (!page || qr.absolutePosition === undefined && context.availableHeight < qr._height) return false;
                    if (qr._x === undefined) qr._x = qr.x || 0;
                    qr.x = context.x + qr._x;
                    qr.y = context.y;
                    this.alignImage(qr);
                    for(var i = 0, l = qr._canvas.length; i < l; i++){
                        var vector = qr._canvas[i];
                        vector.x += qr.x;
                        vector.y += qr.y;
                        this.addVector(vector, true, true, index);
                    }
                    context.moveDown(qr._height);
                    return position;
                };
                ElementWriter.prototype.alignImage = function(image) {
                    var width = this.context.availableWidth;
                    var imageWidth = image._minWidth;
                    var offset = 0;
                    switch(image._alignment){
                        case "right":
                            offset = width - imageWidth;
                            break;
                        case "center":
                            offset = (width - imageWidth) / 2;
                            break;
                    }
                    if (offset) image.x = (image.x || 0) + offset;
                };
                ElementWriter.prototype.alignCanvas = function(node) {
                    var width = this.context.availableWidth;
                    var canvasWidth = node._minWidth;
                    var offset = 0;
                    switch(node._alignment){
                        case "right":
                            offset = width - canvasWidth;
                            break;
                        case "center":
                            offset = (width - canvasWidth) / 2;
                            break;
                    }
                    if (offset) node.canvas.forEach(function(vector) {
                        offsetVector(vector, offset, 0);
                    });
                };
                ElementWriter.prototype.addVector = function(vector, ignoreContextX, ignoreContextY, index) {
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (page) {
                        offsetVector(vector, ignoreContextX ? 0 : context.x, ignoreContextY ? 0 : context.y);
                        addPageItem(page, {
                            type: "vector",
                            item: vector
                        }, index);
                        return position;
                    }
                };
                ElementWriter.prototype.beginClip = function(width, height) {
                    var ctx = this.context;
                    var page = ctx.getCurrentPage();
                    page.items.push({
                        type: "beginClip",
                        item: {
                            x: ctx.x,
                            y: ctx.y,
                            width: width,
                            height: height
                        }
                    });
                    return true;
                };
                ElementWriter.prototype.endClip = function() {
                    var ctx = this.context;
                    var page = ctx.getCurrentPage();
                    page.items.push({
                        type: "endClip"
                    });
                    return true;
                };
                function cloneLine(line) {
                    var result = new Line(line.maxWidth);
                    for(var key in line)if (line.hasOwnProperty(key)) result[key] = line[key];
                    return result;
                }
                ElementWriter.prototype.addFragment = function(block, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
                    var ctx = this.context;
                    var page = ctx.getCurrentPage();
                    if (!useBlockXOffset && block.height > ctx.availableHeight) return false;
                    block.items.forEach(function(item) {
                        switch(item.type){
                            case "line":
                                var l = cloneLine(item.item);
                                if (l._node) l._node.positions[0].pageNumber = ctx.page + 1;
                                l.x = (l.x || 0) + (useBlockXOffset ? block.xOffset || 0 : ctx.x);
                                l.y = (l.y || 0) + (useBlockYOffset ? block.yOffset || 0 : ctx.y);
                                page.items.push({
                                    type: "line",
                                    item: l
                                });
                                break;
                            case "vector":
                                var v = pack(item.item);
                                offsetVector(v, useBlockXOffset ? block.xOffset || 0 : ctx.x, useBlockYOffset ? block.yOffset || 0 : ctx.y);
                                page.items.push({
                                    type: "vector",
                                    item: v
                                });
                                break;
                            case "image":
                            case "svg":
                                var img = pack(item.item);
                                img.x = (img.x || 0) + (useBlockXOffset ? block.xOffset || 0 : ctx.x);
                                img.y = (img.y || 0) + (useBlockYOffset ? block.yOffset || 0 : ctx.y);
                                page.items.push({
                                    type: item.type,
                                    item: img
                                });
                                break;
                        }
                    });
                    if (!dontUpdateContextPosition) ctx.moveDown(block.height);
                    return true;
                };
                /**
 * Pushes the provided context onto the stack or creates a new one
 *
 * pushContext(context) - pushes the provided context and makes it current
 * pushContext(width, height) - creates and pushes a new context with the specified width and height
 * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
 */ ElementWriter.prototype.pushContext = function(contextOrWidth, height) {
                    if (contextOrWidth === undefined) {
                        height = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom;
                        contextOrWidth = this.context.availableWidth;
                    }
                    if (isNumber(contextOrWidth)) contextOrWidth = new DocumentContext({
                        width: contextOrWidth,
                        height: height
                    }, {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    });
                    this.contextStack.push(this.context);
                    this.context = contextOrWidth;
                };
                ElementWriter.prototype.popContext = function() {
                    this.context = this.contextStack.pop();
                };
                ElementWriter.prototype.getCurrentPositionOnPage = function() {
                    return (this.contextStack[0] || this.context).getCurrentPosition();
                };
                module1.exports = ElementWriter;
            /***/ },
            /***/ 98875: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isArray = __webpack_require__(16920).isArray;
                function typeName(bold, italics) {
                    var type = "normal";
                    if (bold && italics) type = "bolditalics";
                    else if (bold) type = "bold";
                    else if (italics) type = "italics";
                    return type;
                }
                function FontProvider(fontDescriptors, pdfKitDoc) {
                    this.fonts = {};
                    this.pdfKitDoc = pdfKitDoc;
                    this.fontCache = {};
                    for(var font in fontDescriptors)if (fontDescriptors.hasOwnProperty(font)) {
                        var fontDef = fontDescriptors[font];
                        this.fonts[font] = {
                            normal: fontDef.normal,
                            bold: fontDef.bold,
                            italics: fontDef.italics,
                            bolditalics: fontDef.bolditalics
                        };
                    }
                }
                FontProvider.prototype.getFontType = function(bold, italics) {
                    return typeName(bold, italics);
                };
                FontProvider.prototype.getFontFile = function(familyName, bold, italics) {
                    var type = this.getFontType(bold, italics);
                    if (!this.fonts[familyName] || !this.fonts[familyName][type]) return null;
                    return this.fonts[familyName][type];
                };
                FontProvider.prototype.provideFont = function(familyName, bold, italics) {
                    var type = this.getFontType(bold, italics);
                    if (this.getFontFile(familyName, bold, italics) === null) throw new Error("Font '" + familyName + "' in style '" + type + "' is not defined in the font section of the document definition.");
                    this.fontCache[familyName] = this.fontCache[familyName] || {};
                    if (!this.fontCache[familyName][type]) {
                        var def = this.fonts[familyName][type];
                        if (!isArray(def)) def = [
                            def
                        ];
                        this.fontCache[familyName][type] = this.pdfKitDoc.font.apply(this.pdfKitDoc, def)._font;
                    }
                    return this.fontCache[familyName][type];
                };
                module1.exports = FontProvider;
            /***/ },
            /***/ 16920: /***/ function(module1) {
                "use strict";
                function isString(variable) {
                    return typeof variable === "string" || variable instanceof String;
                }
                function isNumber(variable) {
                    return typeof variable === "number" || variable instanceof Number;
                }
                function isBoolean(variable) {
                    return typeof variable === "boolean";
                }
                function isArray(variable) {
                    return Array.isArray(variable);
                }
                function isFunction(variable) {
                    return typeof variable === "function";
                }
                function isObject(variable) {
                    return variable !== null && typeof variable === "object";
                }
                function isNull(variable) {
                    return variable === null;
                }
                function isUndefined(variable) {
                    return variable === undefined;
                }
                function pack() {
                    var result = {};
                    for(var i = 0, l = arguments.length; i < l; i++){
                        var obj = arguments[i];
                        if (obj) {
                            for(var key in obj)if (obj.hasOwnProperty(key)) result[key] = obj[key];
                        }
                    }
                    return result;
                }
                function offsetVector(vector, x, y) {
                    switch(vector.type){
                        case "ellipse":
                        case "rect":
                            vector.x += x;
                            vector.y += y;
                            break;
                        case "line":
                            vector.x1 += x;
                            vector.x2 += x;
                            vector.y1 += y;
                            vector.y2 += y;
                            break;
                        case "polyline":
                            for(var i = 0, l = vector.points.length; i < l; i++){
                                vector.points[i].x += x;
                                vector.points[i].y += y;
                            }
                            break;
                    }
                }
                function fontStringify(key, val) {
                    if (key === "font") return "font";
                    return val;
                }
                function getNodeId(node) {
                    if (node.id) return node.id;
                    if (isArray(node.text)) for(var i = 0, l = node.text.length; i < l; i++){
                        var n = node.text[i];
                        var nodeId = getNodeId(n);
                        if (nodeId) return nodeId;
                    }
                    return null;
                }
                function isPattern(color) {
                    return isArray(color) && color.length === 2;
                }
                // converts from a [<pattern name>, <color>] as used by pdfmake
                // into [<pattern object>, <color>] as used by pdfkit
                // (the pattern has to be registered in the doc definition of course)
                function getPattern(color, patterns) {
                    return [
                        patterns[color[0]],
                        color[1]
                    ];
                }
                module1.exports = {
                    isString: isString,
                    isNumber: isNumber,
                    isBoolean: isBoolean,
                    isArray: isArray,
                    isFunction: isFunction,
                    isObject: isObject,
                    isNull: isNull,
                    isUndefined: isUndefined,
                    pack: pack,
                    fontStringify: fontStringify,
                    offsetVector: offsetVector,
                    getNodeId: getNodeId,
                    isPattern: isPattern,
                    getPattern: getPattern
                };
            /***/ },
            /***/ 41125: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                var fs = __webpack_require__(52773);
                function ImageMeasure(pdfKitDoc, imageDictionary) {
                    this.pdfKitDoc = pdfKitDoc;
                    this.imageDictionary = imageDictionary || {};
                }
                ImageMeasure.prototype.measureImage = function(src) {
                    var image;
                    var that = this;
                    if (!this.pdfKitDoc._imageRegistry[src]) {
                        try {
                            image = this.pdfKitDoc.openImage(realImageSrc(src));
                            if (!image) throw "No image";
                        } catch (error) {
                            throw "Invalid image: " + error.toString() + "\nImages dictionary should contain dataURL entries (or local file paths in node.js)";
                        }
                        image.embed(this.pdfKitDoc);
                        this.pdfKitDoc._imageRegistry[src] = image;
                    } else image = this.pdfKitDoc._imageRegistry[src];
                    return {
                        width: image.width,
                        height: image.height
                    };
                    function realImageSrc(src) {
                        var img = that.imageDictionary[src];
                        if (!img) return src;
                        if (fs.existsSync(img)) return fs.readFileSync(img);
                        var index = img.indexOf("base64,");
                        if (index < 0) return that.imageDictionary[src];
                        return Buffer.from(img.substring(index + 7), "base64");
                    }
                };
                module1.exports = ImageMeasure;
            /***/ },
            /***/ 47626: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TraversalTracker = __webpack_require__(73602);
                var DocPreprocessor = __webpack_require__(78702);
                var DocMeasure = __webpack_require__(77077);
                var DocumentContext = __webpack_require__(79833);
                var PageElementWriter = __webpack_require__(52183);
                var ColumnCalculator = __webpack_require__(65354);
                var TableProcessor = __webpack_require__(41729);
                var Line = __webpack_require__(79547);
                var isString = __webpack_require__(16920).isString;
                var isArray = __webpack_require__(16920).isArray;
                var isUndefined = __webpack_require__(16920).isUndefined;
                var isNull = __webpack_require__(16920).isNull;
                var pack = __webpack_require__(16920).pack;
                var offsetVector = __webpack_require__(16920).offsetVector;
                var fontStringify = __webpack_require__(16920).fontStringify;
                var getNodeId = __webpack_require__(16920).getNodeId;
                var isFunction = __webpack_require__(16920).isFunction;
                var TextTools = __webpack_require__(28045);
                var StyleContextStack = __webpack_require__(28034);
                var isNumber = __webpack_require__(16920).isNumber;
                function addAll(target, otherArray) {
                    otherArray.forEach(function(item) {
                        target.push(item);
                    });
                }
                /**
 * Creates an instance of LayoutBuilder - layout engine which turns document-definition-object
 * into a set of pages, lines, inlines and vectors ready to be rendered into a PDF
 *
 * @param {Object} pageSize - an object defining page width and height
 * @param {Object} pageMargins - an object defining top, left, right and bottom margins
 */ function LayoutBuilder(pageSize, pageMargins, imageMeasure, svgMeasure) {
                    this.pageSize = pageSize;
                    this.pageMargins = pageMargins;
                    this.tracker = new TraversalTracker();
                    this.imageMeasure = imageMeasure;
                    this.svgMeasure = svgMeasure;
                    this.tableLayouts = {};
                }
                LayoutBuilder.prototype.registerTableLayouts = function(tableLayouts) {
                    this.tableLayouts = pack(this.tableLayouts, tableLayouts);
                };
                /**
 * Executes layout engine on document-definition-object and creates an array of pages
 * containing positioned Blocks, Lines and inlines
 *
 * @param {Object} docStructure document-definition-object
 * @param {Object} fontProvider font provider
 * @param {Object} styleDictionary dictionary with style definitions
 * @param {Object} defaultStyle default style definition
 * @return {Array} an array of pages
 */ LayoutBuilder.prototype.layoutDocument = function(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
                    function addPageBreaksIfNecessary(linearNodeList, pages) {
                        if (!isFunction(pageBreakBeforeFct)) return false;
                        linearNodeList = linearNodeList.filter(function(node) {
                            return node.positions.length > 0;
                        });
                        linearNodeList.forEach(function(node) {
                            var nodeInfo = {};
                            [
                                "id",
                                "text",
                                "ul",
                                "ol",
                                "table",
                                "image",
                                "qr",
                                "canvas",
                                "svg",
                                "columns",
                                "headlineLevel",
                                "style",
                                "pageBreak",
                                "pageOrientation",
                                "width",
                                "height"
                            ].forEach(function(key) {
                                if (node[key] !== undefined) nodeInfo[key] = node[key];
                            });
                            nodeInfo.startPosition = node.positions[0];
                            nodeInfo.pageNumbers = Array.from(new Set(node.positions.map(function(node) {
                                return node.pageNumber;
                            })));
                            nodeInfo.pages = pages.length;
                            nodeInfo.stack = isArray(node.stack);
                            node.nodeInfo = nodeInfo;
                        });
                        for(var index = 0; index < linearNodeList.length; index++){
                            var node = linearNodeList[index];
                            if (node.pageBreak !== "before" && !node.pageBreakCalculated) {
                                node.pageBreakCalculated = true;
                                var pageNumber = node.nodeInfo.pageNumbers[0];
                                var followingNodesOnPage = [];
                                var nodesOnNextPage = [];
                                var previousNodesOnPage = [];
                                if (pageBreakBeforeFct.length > 1) for(var ii = index + 1, l = linearNodeList.length; ii < l; ii++){
                                    if (linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber) > -1) followingNodesOnPage.push(linearNodeList[ii].nodeInfo);
                                    if (pageBreakBeforeFct.length > 2 && linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber + 1) > -1) nodesOnNextPage.push(linearNodeList[ii].nodeInfo);
                                }
                                if (pageBreakBeforeFct.length > 3) {
                                    for(var ii = 0; ii < index; ii++)if (linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber) > -1) previousNodesOnPage.push(linearNodeList[ii].nodeInfo);
                                }
                                if (pageBreakBeforeFct(node.nodeInfo, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage)) {
                                    node.pageBreak = "before";
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    this.docPreprocessor = new DocPreprocessor();
                    this.docMeasure = new DocMeasure(fontProvider, styleDictionary, defaultStyle, this.imageMeasure, this.svgMeasure, this.tableLayouts, images);
                    function resetXYs(result) {
                        result.linearNodeList.forEach(function(node) {
                            node.resetXY();
                        });
                    }
                    var result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
                    while(addPageBreaksIfNecessary(result.linearNodeList, result.pages)){
                        resetXYs(result);
                        result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
                    }
                    return result.pages;
                };
                LayoutBuilder.prototype.tryLayoutDocument = function(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
                    this.linearNodeList = [];
                    docStructure = this.docPreprocessor.preprocessDocument(docStructure);
                    docStructure = this.docMeasure.measureDocument(docStructure);
                    this.writer = new PageElementWriter(new DocumentContext(this.pageSize, this.pageMargins), this.tracker);
                    var _this = this;
                    this.writer.context().tracker.startTracking("pageAdded", function() {
                        _this.addBackground(background);
                    });
                    this.addBackground(background);
                    this.processNode(docStructure);
                    this.addHeadersAndFooters(header, footer);
                    if (watermark != null) this.addWatermark(watermark, fontProvider, defaultStyle);
                    return {
                        pages: this.writer.context().pages,
                        linearNodeList: this.linearNodeList
                    };
                };
                LayoutBuilder.prototype.addBackground = function(background) {
                    var backgroundGetter = isFunction(background) ? background : function() {
                        return background;
                    };
                    var context = this.writer.context();
                    var pageSize = context.getCurrentPage().pageSize;
                    var pageBackground = backgroundGetter(context.page + 1, pageSize);
                    if (pageBackground) {
                        this.writer.beginUnbreakableBlock(pageSize.width, pageSize.height);
                        pageBackground = this.docPreprocessor.preprocessDocument(pageBackground);
                        this.processNode(this.docMeasure.measureDocument(pageBackground));
                        this.writer.commitUnbreakableBlock(0, 0);
                        context.backgroundLength[context.page] += pageBackground.positions.length;
                    }
                };
                LayoutBuilder.prototype.addStaticRepeatable = function(headerOrFooter, sizeFunction) {
                    this.addDynamicRepeatable(function() {
                        return JSON.parse(JSON.stringify(headerOrFooter)); // copy to new object
                    }, sizeFunction);
                };
                LayoutBuilder.prototype.addDynamicRepeatable = function(nodeGetter, sizeFunction) {
                    var pages = this.writer.context().pages;
                    for(var pageIndex = 0, l = pages.length; pageIndex < l; pageIndex++){
                        this.writer.context().page = pageIndex;
                        var node = nodeGetter(pageIndex + 1, l, this.writer.context().pages[pageIndex].pageSize);
                        if (node) {
                            var sizes = sizeFunction(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
                            this.writer.beginUnbreakableBlock(sizes.width, sizes.height);
                            node = this.docPreprocessor.preprocessDocument(node);
                            this.processNode(this.docMeasure.measureDocument(node));
                            this.writer.commitUnbreakableBlock(sizes.x, sizes.y);
                        }
                    }
                };
                LayoutBuilder.prototype.addHeadersAndFooters = function(header, footer) {
                    var headerSizeFct = function(pageSize, pageMargins) {
                        return {
                            x: 0,
                            y: 0,
                            width: pageSize.width,
                            height: pageMargins.top
                        };
                    };
                    var footerSizeFct = function(pageSize, pageMargins) {
                        return {
                            x: 0,
                            y: pageSize.height - pageMargins.bottom,
                            width: pageSize.width,
                            height: pageMargins.bottom
                        };
                    };
                    if (isFunction(header)) this.addDynamicRepeatable(header, headerSizeFct);
                    else if (header) this.addStaticRepeatable(header, headerSizeFct);
                    if (isFunction(footer)) this.addDynamicRepeatable(footer, footerSizeFct);
                    else if (footer) this.addStaticRepeatable(footer, footerSizeFct);
                };
                LayoutBuilder.prototype.addWatermark = function(watermark, fontProvider, defaultStyle) {
                    if (isString(watermark)) watermark = {
                        "text": watermark
                    };
                    if (!watermark.text) return;
                    watermark.font = watermark.font || defaultStyle.font || "Roboto";
                    watermark.fontSize = watermark.fontSize || "auto";
                    watermark.color = watermark.color || "black";
                    watermark.opacity = isNumber(watermark.opacity) ? watermark.opacity : 0.6;
                    watermark.bold = watermark.bold || false;
                    watermark.italics = watermark.italics || false;
                    watermark.angle = !isUndefined(watermark.angle) && !isNull(watermark.angle) ? watermark.angle : null;
                    if (watermark.angle === null) watermark.angle = Math.atan2(this.pageSize.height, this.pageSize.width) * -180 / Math.PI;
                    if (watermark.fontSize === "auto") watermark.fontSize = getWatermarkFontSize(this.pageSize, watermark, fontProvider);
                    var watermarkObject = {
                        text: watermark.text,
                        font: fontProvider.provideFont(watermark.font, watermark.bold, watermark.italics),
                        fontSize: watermark.fontSize,
                        color: watermark.color,
                        opacity: watermark.opacity,
                        angle: watermark.angle
                    };
                    watermarkObject._size = getWatermarkSize(watermark, fontProvider);
                    var pages = this.writer.context().pages;
                    for(var i = 0, l = pages.length; i < l; i++)pages[i].watermark = watermarkObject;
                    function getWatermarkSize(watermark, fontProvider) {
                        var textTools = new TextTools(fontProvider);
                        var styleContextStack = new StyleContextStack(null, {
                            font: watermark.font,
                            bold: watermark.bold,
                            italics: watermark.italics
                        });
                        styleContextStack.push({
                            fontSize: watermark.fontSize
                        });
                        var size = textTools.sizeOfString(watermark.text, styleContextStack);
                        var rotatedSize = textTools.sizeOfRotatedText(watermark.text, watermark.angle, styleContextStack);
                        return {
                            size: size,
                            rotatedSize: rotatedSize
                        };
                    }
                    function getWatermarkFontSize(pageSize, watermark, fontProvider) {
                        var textTools = new TextTools(fontProvider);
                        var styleContextStack = new StyleContextStack(null, {
                            font: watermark.font,
                            bold: watermark.bold,
                            italics: watermark.italics
                        });
                        var rotatedSize;
                        /**
		 * Binary search the best font size.
		 * Initial bounds [0, 1000]
		 * Break when range < 1
		 */ var a = 0;
                        var b = 1000;
                        var c = (a + b) / 2;
                        while(Math.abs(a - b) > 1){
                            styleContextStack.push({
                                fontSize: c
                            });
                            rotatedSize = textTools.sizeOfRotatedText(watermark.text, watermark.angle, styleContextStack);
                            if (rotatedSize.width > pageSize.width) {
                                b = c;
                                c = (a + b) / 2;
                            } else if (rotatedSize.width < pageSize.width) {
                                if (rotatedSize.height > pageSize.height) {
                                    b = c;
                                    c = (a + b) / 2;
                                } else {
                                    a = c;
                                    c = (a + b) / 2;
                                }
                            }
                            styleContextStack.pop();
                        }
                        /*
		 End binary search
		 */ return c;
                    }
                };
                function decorateNode(node) {
                    var x = node.x, y = node.y;
                    node.positions = [];
                    if (isArray(node.canvas)) node.canvas.forEach(function(vector) {
                        var x = vector.x, y = vector.y, x1 = vector.x1, y1 = vector.y1, x2 = vector.x2, y2 = vector.y2;
                        vector.resetXY = function() {
                            vector.x = x;
                            vector.y = y;
                            vector.x1 = x1;
                            vector.y1 = y1;
                            vector.x2 = x2;
                            vector.y2 = y2;
                        };
                    });
                    node.resetXY = function() {
                        node.x = x;
                        node.y = y;
                        if (isArray(node.canvas)) node.canvas.forEach(function(vector) {
                            vector.resetXY();
                        });
                    };
                }
                LayoutBuilder.prototype.processNode = function(node) {
                    var self1 = this;
                    this.linearNodeList.push(node);
                    decorateNode(node);
                    applyMargins(function() {
                        var unbreakable = node.unbreakable;
                        if (unbreakable) self1.writer.beginUnbreakableBlock();
                        var absPosition = node.absolutePosition;
                        if (absPosition) {
                            self1.writer.context().beginDetachedBlock();
                            self1.writer.context().moveTo(absPosition.x || 0, absPosition.y || 0);
                        }
                        var relPosition = node.relativePosition;
                        if (relPosition) {
                            self1.writer.context().beginDetachedBlock();
                            self1.writer.context().moveToRelative(relPosition.x || 0, relPosition.y || 0);
                        }
                        if (node.stack) self1.processVerticalContainer(node);
                        else if (node.columns) self1.processColumns(node);
                        else if (node.ul) self1.processList(false, node);
                        else if (node.ol) self1.processList(true, node);
                        else if (node.table) self1.processTable(node);
                        else if (node.text !== undefined) self1.processLeaf(node);
                        else if (node.toc) self1.processToc(node);
                        else if (node.image) self1.processImage(node);
                        else if (node.svg) self1.processSVG(node);
                        else if (node.canvas) self1.processCanvas(node);
                        else if (node.qr) self1.processQr(node);
                        else if (!node._span) throw "Unrecognized document structure: " + JSON.stringify(node, fontStringify);
                        if (absPosition || relPosition) self1.writer.context().endDetachedBlock();
                        if (unbreakable) self1.writer.commitUnbreakableBlock();
                    });
                    function applyMargins(callback) {
                        var margin = node._margin;
                        if (node.pageBreak === "before") self1.writer.moveToNextPage(node.pageOrientation);
                        else if (node.pageBreak === "beforeOdd") {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 1) self1.writer.moveToNextPage(node.pageOrientation);
                        } else if (node.pageBreak === "beforeEven") {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 0) self1.writer.moveToNextPage(node.pageOrientation);
                        }
                        if (margin) {
                            self1.writer.context().moveDown(margin[1]);
                            self1.writer.context().addMargin(margin[0], margin[2]);
                        }
                        callback();
                        if (margin) {
                            self1.writer.context().addMargin(-margin[0], -margin[2]);
                            self1.writer.context().moveDown(margin[3]);
                        }
                        if (node.pageBreak === "after") self1.writer.moveToNextPage(node.pageOrientation);
                        else if (node.pageBreak === "afterOdd") {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 1) self1.writer.moveToNextPage(node.pageOrientation);
                        } else if (node.pageBreak === "afterEven") {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 0) self1.writer.moveToNextPage(node.pageOrientation);
                        }
                    }
                };
                // vertical container
                LayoutBuilder.prototype.processVerticalContainer = function(node) {
                    var self1 = this;
                    node.stack.forEach(function(item) {
                        self1.processNode(item);
                        addAll(node.positions, item.positions);
                    //TODO: paragraph gap
                    });
                };
                // columns
                LayoutBuilder.prototype.processColumns = function(columnNode) {
                    var columns = columnNode.columns;
                    var availableWidth = this.writer.context().availableWidth;
                    var gaps = gapArray(columnNode._gap);
                    if (gaps) availableWidth -= (gaps.length - 1) * columnNode._gap;
                    ColumnCalculator.buildColumnWidths(columns, availableWidth);
                    var result = this.processRow(columns, columns, gaps);
                    addAll(columnNode.positions, result.positions);
                    function gapArray(gap) {
                        if (!gap) return null;
                        var gaps = [];
                        gaps.push(0);
                        for(var i = columns.length - 1; i > 0; i--)gaps.push(gap);
                        return gaps;
                    }
                };
                LayoutBuilder.prototype.processRow = function(columns, widths, gaps, tableBody, tableRow, height) {
                    var self1 = this;
                    var pageBreaks = [], positions = [];
                    this.tracker.auto("pageChanged", storePageBreakData, function() {
                        widths = widths || columns;
                        self1.writer.context().beginColumnGroup();
                        for(var i = 0, l = columns.length; i < l; i++){
                            var column = columns[i];
                            var width = widths[i]._calcWidth;
                            var leftOffset = colLeftOffset(i);
                            if (column.colSpan && column.colSpan > 1) for(var j = 1; j < column.colSpan; j++)width += widths[++i]._calcWidth + gaps[i];
                            self1.writer.context().beginColumn(width, leftOffset, getEndingCell(column, i));
                            if (!column._span) {
                                self1.processNode(column);
                                addAll(positions, column.positions);
                            } else if (column._columnEndingContext) // row-span ending
                            self1.writer.context().markEnding(column);
                        }
                        self1.writer.context().completeColumnGroup(height);
                    });
                    return {
                        pageBreaks: pageBreaks,
                        positions: positions
                    };
                    function storePageBreakData(data) {
                        var pageDesc;
                        for(var i = 0, l = pageBreaks.length; i < l; i++){
                            var desc = pageBreaks[i];
                            if (desc.prevPage === data.prevPage) {
                                pageDesc = desc;
                                break;
                            }
                        }
                        if (!pageDesc) {
                            pageDesc = data;
                            pageBreaks.push(pageDesc);
                        }
                        pageDesc.prevY = Math.max(pageDesc.prevY, data.prevY);
                        pageDesc.y = Math.min(pageDesc.y, data.y);
                    }
                    function colLeftOffset(i) {
                        if (gaps && gaps.length > i) return gaps[i];
                        return 0;
                    }
                    function getEndingCell(column, columnIndex) {
                        if (column.rowSpan && column.rowSpan > 1) {
                            var endingRow = tableRow + column.rowSpan - 1;
                            if (endingRow >= tableBody.length) throw "Row span for column " + columnIndex + " (with indexes starting from 0) exceeded row count";
                            return tableBody[endingRow][columnIndex];
                        }
                        return null;
                    }
                };
                // lists
                LayoutBuilder.prototype.processList = function(orderedList, node) {
                    var self1 = this, items = orderedList ? node.ol : node.ul, gapSize = node._gapSize;
                    this.writer.context().addMargin(gapSize.width);
                    var nextMarker;
                    this.tracker.auto("lineAdded", addMarkerToFirstLeaf, function() {
                        items.forEach(function(item) {
                            nextMarker = item.listMarker;
                            self1.processNode(item);
                            addAll(node.positions, item.positions);
                        });
                    });
                    this.writer.context().addMargin(-gapSize.width);
                    function addMarkerToFirstLeaf(line) {
                        // I'm not very happy with the way list processing is implemented
                        // (both code and algorithm should be rethinked)
                        if (nextMarker) {
                            var marker = nextMarker;
                            nextMarker = null;
                            if (marker.canvas) {
                                var vector = marker.canvas[0];
                                offsetVector(vector, -marker._minWidth, 0);
                                self1.writer.addVector(vector);
                            } else if (marker._inlines) {
                                var markerLine = new Line(self1.pageSize.width);
                                markerLine.addInline(marker._inlines[0]);
                                markerLine.x = -marker._minWidth;
                                markerLine.y = line.getAscenderHeight() - markerLine.getAscenderHeight();
                                self1.writer.addLine(markerLine, true);
                            }
                        }
                    }
                };
                // tables
                LayoutBuilder.prototype.processTable = function(tableNode) {
                    var processor = new TableProcessor(tableNode);
                    processor.beginTable(this.writer);
                    var rowHeights = tableNode.table.heights;
                    for(var i = 0, l = tableNode.table.body.length; i < l; i++){
                        processor.beginRow(i, this.writer);
                        var height;
                        if (isFunction(rowHeights)) height = rowHeights(i);
                        else if (isArray(rowHeights)) height = rowHeights[i];
                        else height = rowHeights;
                        if (height === "auto") height = undefined;
                        var result = this.processRow(tableNode.table.body[i], tableNode.table.widths, tableNode._offsets.offsets, tableNode.table.body, i, height);
                        addAll(tableNode.positions, result.positions);
                        processor.endRow(i, this.writer, result.pageBreaks);
                    }
                    processor.endTable(this.writer);
                };
                // leafs (texts)
                LayoutBuilder.prototype.processLeaf = function(node) {
                    var line = this.buildNextLine(node);
                    if (line && (node.tocItem || node.id)) line._node = node;
                    var currentHeight = line ? line.getHeight() : 0;
                    var maxHeight = node.maxHeight || -1;
                    if (line) {
                        var nodeId = getNodeId(node);
                        if (nodeId) line.id = nodeId;
                    }
                    if (node._tocItemRef) line._pageNodeRef = node._tocItemRef;
                    if (node._pageRef) line._pageNodeRef = node._pageRef._nodeRef;
                    if (line && line.inlines && isArray(line.inlines)) for(var i = 0, l = line.inlines.length; i < l; i++){
                        if (line.inlines[i]._tocItemRef) line.inlines[i]._pageNodeRef = line.inlines[i]._tocItemRef;
                        if (line.inlines[i]._pageRef) line.inlines[i]._pageNodeRef = line.inlines[i]._pageRef._nodeRef;
                    }
                    while(line && (maxHeight === -1 || currentHeight < maxHeight)){
                        var positions = this.writer.addLine(line);
                        node.positions.push(positions);
                        line = this.buildNextLine(node);
                        if (line) currentHeight += line.getHeight();
                    }
                };
                LayoutBuilder.prototype.processToc = function(node) {
                    if (node.toc.title) this.processNode(node.toc.title);
                    if (node.toc._table) this.processNode(node.toc._table);
                };
                LayoutBuilder.prototype.buildNextLine = function(textNode) {
                    function cloneInline(inline) {
                        var newInline = inline.constructor();
                        for(var key in inline)newInline[key] = inline[key];
                        return newInline;
                    }
                    if (!textNode._inlines || textNode._inlines.length === 0) return null;
                    var line = new Line(this.writer.context().availableWidth);
                    var textTools = new TextTools(null);
                    var isForceContinue = false;
                    while(textNode._inlines && textNode._inlines.length > 0 && (line.hasEnoughSpaceForInline(textNode._inlines[0], textNode._inlines.slice(1)) || isForceContinue)){
                        var isHardWrap = false;
                        var inline = textNode._inlines.shift();
                        isForceContinue = false;
                        if (!inline.noWrap && inline.text.length > 1 && inline.width > line.getAvailableWidth()) {
                            var widthPerChar = inline.width / inline.text.length;
                            var maxChars = Math.floor(line.getAvailableWidth() / widthPerChar);
                            if (maxChars < 1) maxChars = 1;
                            if (maxChars < inline.text.length) {
                                var newInline = cloneInline(inline);
                                newInline.text = inline.text.substr(maxChars);
                                inline.text = inline.text.substr(0, maxChars);
                                newInline.width = textTools.widthOfString(newInline.text, newInline.font, newInline.fontSize, newInline.characterSpacing, newInline.fontFeatures);
                                inline.width = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
                                textNode._inlines.unshift(newInline);
                                isHardWrap = true;
                            }
                        }
                        line.addInline(inline);
                        isForceContinue = inline.noNewLine && !isHardWrap;
                    }
                    line.lastLineInParagraph = textNode._inlines.length === 0;
                    return line;
                };
                // images
                LayoutBuilder.prototype.processImage = function(node) {
                    var position = this.writer.addImage(node);
                    node.positions.push(position);
                };
                LayoutBuilder.prototype.processSVG = function(node) {
                    var position = this.writer.addSVG(node);
                    node.positions.push(position);
                };
                LayoutBuilder.prototype.processCanvas = function(node) {
                    var height = node._minHeight;
                    if (node.absolutePosition === undefined && this.writer.context().availableHeight < height) // TODO: support for canvas larger than a page
                    // TODO: support for other overflow methods
                    this.writer.moveToNextPage();
                    this.writer.alignCanvas(node);
                    node.canvas.forEach(function(vector) {
                        var position = this.writer.addVector(vector);
                        node.positions.push(position);
                    }, this);
                    this.writer.context().moveDown(height);
                };
                LayoutBuilder.prototype.processQr = function(node) {
                    var position = this.writer.addQr(node);
                    node.positions.push(position);
                };
                module1.exports = LayoutBuilder;
            /***/ },
            /***/ 79547: /***/ function(module1) {
                "use strict";
                /**
 * Creates an instance of Line
 *
 * @constructor
 * @this {Line}
 * @param {Number} Maximum width this line can have
 */ function Line(maxWidth) {
                    this.maxWidth = maxWidth;
                    this.leadingCut = 0;
                    this.trailingCut = 0;
                    this.inlineWidths = 0;
                    this.inlines = [];
                }
                Line.prototype.getAscenderHeight = function() {
                    var y = 0;
                    this.inlines.forEach(function(inline) {
                        y = Math.max(y, inline.font.ascender / 1000 * inline.fontSize);
                    });
                    return y;
                };
                Line.prototype.hasEnoughSpaceForInline = function(inline, nextInlines) {
                    nextInlines = nextInlines || [];
                    if (this.inlines.length === 0) return true;
                    if (this.newLineForced) return false;
                    var inlineWidth = inline.width;
                    var inlineTrailingCut = inline.trailingCut || 0;
                    if (inline.noNewLine) for(var i = 0, l = nextInlines.length; i < l; i++){
                        var nextInline = nextInlines[i];
                        inlineWidth += nextInline.width;
                        inlineTrailingCut += nextInline.trailingCut || 0;
                        if (!nextInline.noNewLine) break;
                    }
                    return this.inlineWidths + inlineWidth - this.leadingCut - inlineTrailingCut <= this.maxWidth;
                };
                Line.prototype.addInline = function(inline) {
                    if (this.inlines.length === 0) this.leadingCut = inline.leadingCut || 0;
                    this.trailingCut = inline.trailingCut || 0;
                    inline.x = this.inlineWidths - this.leadingCut;
                    this.inlines.push(inline);
                    this.inlineWidths += inline.width;
                    if (inline.lineEnd) this.newLineForced = true;
                };
                Line.prototype.getWidth = function() {
                    return this.inlineWidths - this.leadingCut - this.trailingCut;
                };
                Line.prototype.getAvailableWidth = function() {
                    return this.maxWidth - this.getWidth();
                };
                /**
 * Returns line height
 * @return {Number}
 */ Line.prototype.getHeight = function() {
                    var max = 0;
                    this.inlines.forEach(function(item) {
                        max = Math.max(max, item.height || 0);
                    });
                    return max;
                };
                module1.exports = Line;
            /***/ },
            /***/ 52183: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isUndefined = __webpack_require__(16920).isUndefined;
                var ElementWriter = __webpack_require__(84786);
                /**
 * Creates an instance of PageElementWriter - an extended ElementWriter
 * which can handle:
 * - page-breaks (it adds new pages when there's not enough space left),
 * - repeatable fragments (like table-headers, which are repeated everytime
 *                         a page-break occurs)
 * - transactions (used for unbreakable-blocks when we want to make sure
 *                 whole block will be rendered on the same page)
 */ function PageElementWriter(context, tracker) {
                    this.transactionLevel = 0;
                    this.repeatables = [];
                    this.tracker = tracker;
                    this.writer = new ElementWriter(context, tracker);
                }
                function fitOnPage(self1, addFct) {
                    var position = addFct(self1);
                    if (!position) {
                        self1.moveToNextPage();
                        position = addFct(self1);
                    }
                    return position;
                }
                PageElementWriter.prototype.addLine = function(line, dontUpdateContextPosition, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addLine(line, dontUpdateContextPosition, index);
                    });
                };
                PageElementWriter.prototype.addImage = function(image, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addImage(image, index);
                    });
                };
                PageElementWriter.prototype.addSVG = function(image, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addSVG(image, index);
                    });
                };
                PageElementWriter.prototype.addQr = function(qr, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addQr(qr, index);
                    });
                };
                PageElementWriter.prototype.addVector = function(vector, ignoreContextX, ignoreContextY, index) {
                    return this.writer.addVector(vector, ignoreContextX, ignoreContextY, index);
                };
                PageElementWriter.prototype.beginClip = function(width, height) {
                    return this.writer.beginClip(width, height);
                };
                PageElementWriter.prototype.endClip = function() {
                    return this.writer.endClip();
                };
                PageElementWriter.prototype.alignCanvas = function(node) {
                    this.writer.alignCanvas(node);
                };
                PageElementWriter.prototype.addFragment = function(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
                    if (!this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition)) {
                        this.moveToNextPage();
                        this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition);
                    }
                };
                PageElementWriter.prototype.moveToNextPage = function(pageOrientation) {
                    var nextPage = this.writer.context.moveToNextPage(pageOrientation);
                    // moveToNextPage is called multiple times for table, because is called for each column
                    // and repeatables are inserted only in the first time. If columns are used, is needed
                    // call for table in first column and then for table in the second column (is other repeatables).
                    this.repeatables.forEach(function(rep) {
                        if (isUndefined(rep.insertedOnPages[this.writer.context.page])) {
                            rep.insertedOnPages[this.writer.context.page] = true;
                            this.writer.addFragment(rep, true);
                        } else this.writer.context.moveDown(rep.height);
                    }, this);
                    this.writer.tracker.emit("pageChanged", {
                        prevPage: nextPage.prevPage,
                        prevY: nextPage.prevY,
                        y: this.writer.context.y
                    });
                };
                PageElementWriter.prototype.beginUnbreakableBlock = function(width, height) {
                    if (this.transactionLevel++ === 0) {
                        this.originalX = this.writer.context.x;
                        this.writer.pushContext(width, height);
                    }
                };
                PageElementWriter.prototype.commitUnbreakableBlock = function(forcedX, forcedY) {
                    if (--this.transactionLevel === 0) {
                        var unbreakableContext = this.writer.context;
                        this.writer.popContext();
                        var nbPages = unbreakableContext.pages.length;
                        if (nbPages > 0) {
                            // no support for multi-page unbreakableBlocks
                            var fragment = unbreakableContext.pages[0];
                            fragment.xOffset = forcedX;
                            fragment.yOffset = forcedY;
                            //TODO: vectors can influence height in some situations
                            if (nbPages > 1) {
                                // on out-of-context blocs (headers, footers, background) height should be the whole DocumentContext height
                                if (forcedX !== undefined || forcedY !== undefined) fragment.height = unbreakableContext.getCurrentPage().pageSize.height - unbreakableContext.pageMargins.top - unbreakableContext.pageMargins.bottom;
                                else {
                                    fragment.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
                                    for(var i = 0, l = this.repeatables.length; i < l; i++)fragment.height -= this.repeatables[i].height;
                                }
                            } else fragment.height = unbreakableContext.y;
                            if (forcedX !== undefined || forcedY !== undefined) this.writer.addFragment(fragment, true, true, true);
                            else this.addFragment(fragment);
                        }
                    }
                };
                PageElementWriter.prototype.currentBlockToRepeatable = function() {
                    var unbreakableContext = this.writer.context;
                    var rep = {
                        items: []
                    };
                    unbreakableContext.pages[0].items.forEach(function(item) {
                        rep.items.push(item);
                    });
                    rep.xOffset = this.originalX;
                    //TODO: vectors can influence height in some situations
                    rep.height = unbreakableContext.y;
                    rep.insertedOnPages = [];
                    return rep;
                };
                PageElementWriter.prototype.pushToRepeatables = function(rep) {
                    this.repeatables.push(rep);
                };
                PageElementWriter.prototype.popFromRepeatables = function() {
                    this.repeatables.pop();
                };
                PageElementWriter.prototype.context = function() {
                    return this.writer.context;
                };
                module1.exports = PageElementWriter;
            /***/ },
            /***/ 85822: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                function _interopDefault(ex) {
                    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
                }
                var PdfKit = _interopDefault(__webpack_require__(83036));
                function getEngineInstance() {
                    return PdfKit;
                }
                function createPdfDocument(options) {
                    options = options || {};
                    return new PdfKit(options);
                }
                module1.exports = {
                    getEngineInstance: getEngineInstance,
                    createPdfDocument: createPdfDocument
                };
            /***/ },
            /***/ 56498: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /*eslint no-unused-vars: ["error", {"args": "none"}]*/ var PdfKitEngine = __webpack_require__(85822);
                var FontProvider = __webpack_require__(98875);
                var LayoutBuilder = __webpack_require__(47626);
                var sizes = __webpack_require__(58050);
                var ImageMeasure = __webpack_require__(41125);
                var SVGMeasure = __webpack_require__(48730);
                var textDecorator = __webpack_require__(4986);
                var TextTools = __webpack_require__(28045);
                var isFunction = __webpack_require__(16920).isFunction;
                var isString = __webpack_require__(16920).isString;
                var isNumber = __webpack_require__(16920).isNumber;
                var isBoolean = __webpack_require__(16920).isBoolean;
                var isArray = __webpack_require__(16920).isArray;
                var isUndefined = __webpack_require__(16920).isUndefined;
                var isPattern = __webpack_require__(16920).isPattern;
                var getPattern = __webpack_require__(16920).getPattern;
                var SVGtoPDF = __webpack_require__(31589);
                var findFont = function(fonts, requiredFonts, defaultFont) {
                    for(var i = 0; i < requiredFonts.length; i++){
                        var requiredFont = requiredFonts[i].toLowerCase();
                        for(var font in fonts){
                            if (font.toLowerCase() === requiredFont) return font;
                        }
                    }
                    return defaultFont;
                };
                ////////////////////////////////////////
                // PdfPrinter
                /**
 * @class Creates an instance of a PdfPrinter which turns document definition into a pdf
 *
 * @param {Object} fontDescriptors font definition dictionary
 *
 * @example
 * var fontDescriptors = {
 *	Roboto: {
 *		normal: 'fonts/Roboto-Regular.ttf',
 *		bold: 'fonts/Roboto-Medium.ttf',
 *		italics: 'fonts/Roboto-Italic.ttf',
 *		bolditalics: 'fonts/Roboto-MediumItalic.ttf'
 *	}
 * };
 *
 * var printer = new PdfPrinter(fontDescriptors);
 */ function PdfPrinter(fontDescriptors) {
                    this.fontDescriptors = fontDescriptors;
                }
                /**
 * Executes layout engine for the specified document and renders it into a pdfkit document
 * ready to be saved.
 *
 * @param {Object} docDefinition document definition
 * @param {Object} docDefinition.content an array describing the pdf structure (for more information take a look at the examples in the /examples folder)
 * @param {Object} [docDefinition.defaultStyle] default (implicit) style definition
 * @param {Object} [docDefinition.styles] dictionary defining all styles which can be used in the document
 * @param {Object} [docDefinition.pageSize] page size (pdfkit units, A4 dimensions by default)
 * @param {Number} docDefinition.pageSize.width width
 * @param {Number} docDefinition.pageSize.height height
 * @param {Object} [docDefinition.pageMargins] page margins (pdfkit units)
 * @param {Number} docDefinition.maxPagesNumber maximum number of pages to render
 *
 * @example
 *
 * var docDefinition = {
 * 	info: {
 *		title: 'awesome Document',
 *		author: 'john doe',
 *		subject: 'subject of document',
 *		keywords: 'keywords for document',
 * 	},
 *	content: [
 *		'First paragraph',
 *		'Second paragraph, this time a little bit longer',
 *		{ text: 'Third paragraph, slightly bigger font size', fontSize: 20 },
 *		{ text: 'Another paragraph using a named style', style: 'header' },
 *		{ text: ['playing with ', 'inlines' ] },
 *		{ text: ['and ', { text: 'restyling ', bold: true }, 'them'] },
 *	],
 *	styles: {
 *		header: { fontSize: 30, bold: true }
 *	},
 *	patterns: {
 *		stripe45d: {
 *			boundingBox: [1, 1, 4, 4],
 *			xStep: 3,
 *			yStep: 3,
 *			pattern: '1 w 0 1 m 4 5 l s 2 0 m 5 3 l s'
 *		}
 *	}
 * };
 *
 * var pdfKitDoc = printer.createPdfKitDocument(docDefinition);
 *
 * pdfKitDoc.pipe(fs.createWriteStream('sample.pdf'));
 * pdfKitDoc.end();
 *
 * @return {Object} a pdfKit document object which can be saved or encode to data-url
 */ PdfPrinter.prototype.createPdfKitDocument = function(docDefinition, options) {
                    options = options || {};
                    docDefinition.version = docDefinition.version || "1.3";
                    docDefinition.compress = isBoolean(docDefinition.compress) ? docDefinition.compress : true;
                    docDefinition.images = docDefinition.images || {};
                    docDefinition.pageMargins = docDefinition.pageMargins !== undefined && docDefinition.pageMargins !== null ? docDefinition.pageMargins : 40;
                    var pageSize = fixPageSize(docDefinition.pageSize, docDefinition.pageOrientation);
                    var pdfOptions = {
                        size: [
                            pageSize.width,
                            pageSize.height
                        ],
                        pdfVersion: docDefinition.version,
                        compress: docDefinition.compress,
                        userPassword: docDefinition.userPassword,
                        ownerPassword: docDefinition.ownerPassword,
                        permissions: docDefinition.permissions,
                        lang: docDefinition.language,
                        fontLayoutCache: isBoolean(options.fontLayoutCache) ? options.fontLayoutCache : true,
                        bufferPages: options.bufferPages || false,
                        autoFirstPage: false,
                        info: createMetadata(docDefinition),
                        font: null
                    };
                    this.pdfKitDoc = PdfKitEngine.createPdfDocument(pdfOptions);
                    this.fontProvider = new FontProvider(this.fontDescriptors, this.pdfKitDoc);
                    var builder = new LayoutBuilder(pageSize, fixPageMargins(docDefinition.pageMargins), new ImageMeasure(this.pdfKitDoc, docDefinition.images), new SVGMeasure());
                    registerDefaultTableLayouts(builder);
                    if (options.tableLayouts) builder.registerTableLayouts(options.tableLayouts);
                    var pages = builder.layoutDocument(docDefinition.content, this.fontProvider, docDefinition.styles || {}, docDefinition.defaultStyle || {
                        fontSize: 12,
                        font: "Roboto"
                    }, docDefinition.background, docDefinition.header, docDefinition.footer, docDefinition.images, docDefinition.watermark, docDefinition.pageBreakBefore);
                    var maxNumberPages = docDefinition.maxPagesNumber || -1;
                    if (isNumber(maxNumberPages) && maxNumberPages > -1) pages = pages.slice(0, maxNumberPages);
                    // if pageSize.height is set to Infinity, calculate the actual height of the page that
                    // was laid out using the height of each of the items in the page.
                    if (pageSize.height === Infinity) {
                        var pageHeight = calculatePageHeight(pages, docDefinition.pageMargins);
                        this.pdfKitDoc.options.size = [
                            pageSize.width,
                            pageHeight
                        ];
                    }
                    var patterns = createPatterns(docDefinition.patterns || {}, this.pdfKitDoc);
                    renderPages(pages, this.fontProvider, this.pdfKitDoc, patterns, options.progressCallback);
                    if (options.autoPrint) {
                        var printActionRef = this.pdfKitDoc.ref({
                            Type: "Action",
                            S: "Named",
                            N: "Print"
                        });
                        this.pdfKitDoc._root.data.OpenAction = printActionRef;
                        printActionRef.end();
                    }
                    return this.pdfKitDoc;
                };
                function createMetadata(docDefinition) {
                    // PDF standard has these properties reserved: Title, Author, Subject, Keywords,
                    // Creator, Producer, CreationDate, ModDate, Trapped.
                    // To keep the pdfmake api consistent, the info field are defined lowercase.
                    // Custom properties don't contain a space.
                    function standardizePropertyKey(key) {
                        var standardProperties = [
                            "Title",
                            "Author",
                            "Subject",
                            "Keywords",
                            "Creator",
                            "Producer",
                            "CreationDate",
                            "ModDate",
                            "Trapped"
                        ];
                        var standardizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                        if (standardProperties.indexOf(standardizedKey) !== -1) return standardizedKey;
                        return key.replace(/\s+/g, "");
                    }
                    var info = {
                        Producer: "pdfmake",
                        Creator: "pdfmake"
                    };
                    if (docDefinition.info) for(var key in docDefinition.info){
                        var value = docDefinition.info[key];
                        if (value) {
                            key = standardizePropertyKey(key);
                            info[key] = value;
                        }
                    }
                    return info;
                }
                function calculatePageHeight(pages, margins) {
                    function getItemHeight(item) {
                        if (isFunction(item.item.getHeight)) return item.item.getHeight();
                        else if (item.item._height) return item.item._height;
                        else if (item.type === "vector") {
                            if (typeof item.item.y1 !== "undefined") return item.item.y1 > item.item.y2 ? item.item.y1 : item.item.y2;
                            else return item.item.h;
                        } else // TODO: add support for next item types
                        return 0;
                    }
                    function getBottomPosition(item) {
                        var top = item.item.y || 0;
                        var height = getItemHeight(item);
                        return top + height;
                    }
                    var fixedMargins = fixPageMargins(margins || 40);
                    var height = fixedMargins.top;
                    pages.forEach(function(page) {
                        page.items.forEach(function(item) {
                            var bottomPosition = getBottomPosition(item);
                            if (bottomPosition > height) height = bottomPosition;
                        });
                    });
                    height += fixedMargins.bottom;
                    return height;
                }
                function fixPageSize(pageSize, pageOrientation) {
                    function isNeedSwapPageSizes(pageOrientation) {
                        if (isString(pageOrientation)) {
                            pageOrientation = pageOrientation.toLowerCase();
                            return pageOrientation === "portrait" && size.width > size.height || pageOrientation === "landscape" && size.width < size.height;
                        }
                        return false;
                    }
                    // if pageSize.height is set to auto, set the height to infinity so there are no page breaks.
                    if (pageSize && pageSize.height === "auto") pageSize.height = Infinity;
                    var size = pageSize2widthAndHeight(pageSize || "A4");
                    if (isNeedSwapPageSizes(pageOrientation)) size = {
                        width: size.height,
                        height: size.width
                    };
                    size.orientation = size.width > size.height ? "landscape" : "portrait";
                    return size;
                }
                function fixPageMargins(margin) {
                    if (isNumber(margin)) margin = {
                        left: margin,
                        right: margin,
                        top: margin,
                        bottom: margin
                    };
                    else if (isArray(margin)) {
                        if (margin.length === 2) margin = {
                            left: margin[0],
                            top: margin[1],
                            right: margin[0],
                            bottom: margin[1]
                        };
                        else if (margin.length === 4) margin = {
                            left: margin[0],
                            top: margin[1],
                            right: margin[2],
                            bottom: margin[3]
                        };
                        else throw "Invalid pageMargins definition";
                    }
                    return margin;
                }
                function registerDefaultTableLayouts(layoutBuilder) {
                    layoutBuilder.registerTableLayouts({
                        noBorders: {
                            hLineWidth: function(i) {
                                return 0;
                            },
                            vLineWidth: function(i) {
                                return 0;
                            },
                            paddingLeft: function(i) {
                                return i && 4 || 0;
                            },
                            paddingRight: function(i, node) {
                                return i < node.table.widths.length - 1 ? 4 : 0;
                            }
                        },
                        headerLineOnly: {
                            hLineWidth: function(i, node) {
                                if (i === 0 || i === node.table.body.length) return 0;
                                return i === node.table.headerRows ? 2 : 0;
                            },
                            vLineWidth: function(i) {
                                return 0;
                            },
                            paddingLeft: function(i) {
                                return i === 0 ? 0 : 8;
                            },
                            paddingRight: function(i, node) {
                                return i === node.table.widths.length - 1 ? 0 : 8;
                            }
                        },
                        lightHorizontalLines: {
                            hLineWidth: function(i, node) {
                                if (i === 0 || i === node.table.body.length) return 0;
                                return i === node.table.headerRows ? 2 : 1;
                            },
                            vLineWidth: function(i) {
                                return 0;
                            },
                            hLineColor: function(i) {
                                return i === 1 ? "black" : "#aaa";
                            },
                            paddingLeft: function(i) {
                                return i === 0 ? 0 : 8;
                            },
                            paddingRight: function(i, node) {
                                return i === node.table.widths.length - 1 ? 0 : 8;
                            }
                        }
                    });
                }
                function pageSize2widthAndHeight(pageSize) {
                    if (isString(pageSize)) {
                        var size = sizes[pageSize.toUpperCase()];
                        if (!size) throw "Page size " + pageSize + " not recognized";
                        return {
                            width: size[0],
                            height: size[1]
                        };
                    }
                    return pageSize;
                }
                function updatePageOrientationInOptions(currentPage, pdfKitDoc) {
                    var previousPageOrientation = pdfKitDoc.options.size[0] > pdfKitDoc.options.size[1] ? "landscape" : "portrait";
                    if (currentPage.pageSize.orientation !== previousPageOrientation) {
                        var width = pdfKitDoc.options.size[0];
                        var height = pdfKitDoc.options.size[1];
                        pdfKitDoc.options.size = [
                            height,
                            width
                        ];
                    }
                }
                function renderPages(pages, fontProvider, pdfKitDoc, patterns, progressCallback) {
                    pdfKitDoc._pdfMakePages = pages;
                    pdfKitDoc.addPage();
                    var totalItems = 0;
                    if (progressCallback) pages.forEach(function(page) {
                        totalItems += page.items.length;
                    });
                    var renderedItems = 0;
                    progressCallback = progressCallback || function() {};
                    for(var i = 0; i < pages.length; i++){
                        if (i > 0) {
                            updatePageOrientationInOptions(pages[i], pdfKitDoc);
                            pdfKitDoc.addPage(pdfKitDoc.options);
                        }
                        var page = pages[i];
                        for(var ii = 0, il = page.items.length; ii < il; ii++){
                            var item = page.items[ii];
                            switch(item.type){
                                case "vector":
                                    renderVector(item.item, patterns, pdfKitDoc);
                                    break;
                                case "line":
                                    renderLine(item.item, item.item.x, item.item.y, patterns, pdfKitDoc);
                                    break;
                                case "image":
                                    renderImage(item.item, item.item.x, item.item.y, pdfKitDoc);
                                    break;
                                case "svg":
                                    renderSVG(item.item, item.item.x, item.item.y, pdfKitDoc, fontProvider);
                                    break;
                                case "beginClip":
                                    beginClip(item.item, pdfKitDoc);
                                    break;
                                case "endClip":
                                    endClip(pdfKitDoc);
                                    break;
                            }
                            renderedItems++;
                            progressCallback(renderedItems / totalItems);
                        }
                        if (page.watermark) renderWatermark(page, pdfKitDoc);
                    }
                }
                /**
 * Shift the "y" height of the text baseline up or down (superscript or subscript,
 * respectively). The exact shift can / should be changed according to standard
 * conventions.
 *
 * @param {number} y
 * @param {any} inline
 */ function offsetText(y, inline) {
                    var newY = y;
                    if (inline.sup) newY -= inline.fontSize * 0.75;
                    if (inline.sub) newY += inline.fontSize * 0.35;
                    return newY;
                }
                function renderLine(line, x, y, patterns, pdfKitDoc) {
                    function preparePageNodeRefLine(_pageNodeRef, inline) {
                        var newWidth;
                        var diffWidth;
                        var textTools = new TextTools(null);
                        if (isUndefined(_pageNodeRef.positions)) throw "Page reference id not found";
                        var pageNumber = _pageNodeRef.positions[0].pageNumber.toString();
                        inline.text = pageNumber;
                        newWidth = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
                        diffWidth = inline.width - newWidth;
                        inline.width = newWidth;
                        switch(inline.alignment){
                            case "right":
                                inline.x += diffWidth;
                                break;
                            case "center":
                                inline.x += diffWidth / 2;
                                break;
                        }
                    }
                    if (line._pageNodeRef) preparePageNodeRefLine(line._pageNodeRef, line.inlines[0]);
                    x = x || 0;
                    y = y || 0;
                    var lineHeight = line.getHeight();
                    var ascenderHeight = line.getAscenderHeight();
                    var descent = lineHeight - ascenderHeight;
                    textDecorator.drawBackground(line, x, y, patterns, pdfKitDoc);
                    //TODO: line.optimizeInlines();
                    for(var i = 0, l = line.inlines.length; i < l; i++){
                        var inline = line.inlines[i];
                        var shiftToBaseline = lineHeight - inline.font.ascender / 1000 * inline.fontSize - descent;
                        if (inline._pageNodeRef) preparePageNodeRefLine(inline._pageNodeRef, inline);
                        var options = {
                            lineBreak: false,
                            textWidth: inline.width,
                            characterSpacing: inline.characterSpacing,
                            wordCount: 1,
                            link: inline.link
                        };
                        if (inline.linkToDestination) options.goTo = inline.linkToDestination;
                        if (line.id && i === 0) options.destination = line.id;
                        if (inline.fontFeatures) options.features = inline.fontFeatures;
                        var opacity = isNumber(inline.opacity) ? inline.opacity : 1;
                        pdfKitDoc.opacity(opacity);
                        pdfKitDoc.fill(inline.color || "black");
                        pdfKitDoc._font = inline.font;
                        pdfKitDoc.fontSize(inline.fontSize);
                        var shiftedY = offsetText(y + shiftToBaseline, inline);
                        pdfKitDoc.text(inline.text, x + inline.x, shiftedY, options);
                        if (inline.linkToPage) {
                            var _ref = pdfKitDoc.ref({
                                Type: "Action",
                                S: "GoTo",
                                D: [
                                    inline.linkToPage,
                                    0,
                                    0
                                ]
                            }).end();
                            pdfKitDoc.annotate(x + inline.x, shiftedY, inline.width, inline.height, {
                                Subtype: "Link",
                                Dest: [
                                    inline.linkToPage - 1,
                                    "XYZ",
                                    null,
                                    null,
                                    null
                                ]
                            });
                        }
                    }
                    // Decorations won't draw correctly for superscript
                    textDecorator.drawDecorations(line, x, y, pdfKitDoc);
                }
                function renderWatermark(page, pdfKitDoc) {
                    var watermark = page.watermark;
                    pdfKitDoc.fill(watermark.color);
                    pdfKitDoc.opacity(watermark.opacity);
                    pdfKitDoc.save();
                    pdfKitDoc.rotate(watermark.angle, {
                        origin: [
                            pdfKitDoc.page.width / 2,
                            pdfKitDoc.page.height / 2
                        ]
                    });
                    var x = pdfKitDoc.page.width / 2 - watermark._size.size.width / 2;
                    var y = pdfKitDoc.page.height / 2 - watermark._size.size.height / 2;
                    pdfKitDoc._font = watermark.font;
                    pdfKitDoc.fontSize(watermark.fontSize);
                    pdfKitDoc.text(watermark.text, x, y, {
                        lineBreak: false
                    });
                    pdfKitDoc.restore();
                }
                function renderVector(vector, patterns, pdfKitDoc) {
                    //TODO: pdf optimization (there's no need to write all properties everytime)
                    pdfKitDoc.lineWidth(vector.lineWidth || 1);
                    if (vector.dash) pdfKitDoc.dash(vector.dash.length, {
                        space: vector.dash.space || vector.dash.length,
                        phase: vector.dash.phase || 0
                    });
                    else pdfKitDoc.undash();
                    pdfKitDoc.lineJoin(vector.lineJoin || "miter");
                    pdfKitDoc.lineCap(vector.lineCap || "butt");
                    //TODO: clipping
                    var gradient = null;
                    switch(vector.type){
                        case "ellipse":
                            pdfKitDoc.ellipse(vector.x, vector.y, vector.r1, vector.r2);
                            if (vector.linearGradient) gradient = pdfKitDoc.linearGradient(vector.x - vector.r1, vector.y, vector.x + vector.r1, vector.y);
                            break;
                        case "rect":
                            if (vector.r) pdfKitDoc.roundedRect(vector.x, vector.y, vector.w, vector.h, vector.r);
                            else pdfKitDoc.rect(vector.x, vector.y, vector.w, vector.h);
                            if (vector.linearGradient) gradient = pdfKitDoc.linearGradient(vector.x, vector.y, vector.x + vector.w, vector.y);
                            break;
                        case "line":
                            pdfKitDoc.moveTo(vector.x1, vector.y1);
                            pdfKitDoc.lineTo(vector.x2, vector.y2);
                            break;
                        case "polyline":
                            if (vector.points.length === 0) break;
                            pdfKitDoc.moveTo(vector.points[0].x, vector.points[0].y);
                            for(var i = 1, l = vector.points.length; i < l; i++)pdfKitDoc.lineTo(vector.points[i].x, vector.points[i].y);
                            if (vector.points.length > 1) {
                                var p1 = vector.points[0];
                                var pn = vector.points[vector.points.length - 1];
                                if (vector.closePath || p1.x === pn.x && p1.y === pn.y) pdfKitDoc.closePath();
                            }
                            break;
                        case "path":
                            pdfKitDoc.path(vector.d);
                            break;
                    }
                    if (vector.linearGradient && gradient) {
                        var step = 1 / (vector.linearGradient.length - 1);
                        for(var i = 0; i < vector.linearGradient.length; i++)gradient.stop(i * step, vector.linearGradient[i]);
                        vector.color = gradient;
                    }
                    if (isPattern(vector.color)) vector.color = getPattern(vector.color, patterns);
                    var fillOpacity = isNumber(vector.fillOpacity) ? vector.fillOpacity : 1;
                    var strokeOpacity = isNumber(vector.strokeOpacity) ? vector.strokeOpacity : 1;
                    if (vector.color && vector.lineColor) {
                        pdfKitDoc.fillColor(vector.color, fillOpacity);
                        pdfKitDoc.strokeColor(vector.lineColor, strokeOpacity);
                        pdfKitDoc.fillAndStroke();
                    } else if (vector.color) {
                        pdfKitDoc.fillColor(vector.color, fillOpacity);
                        pdfKitDoc.fill();
                    } else {
                        pdfKitDoc.strokeColor(vector.lineColor || "black", strokeOpacity);
                        pdfKitDoc.stroke();
                    }
                }
                function renderImage(image, x, y, pdfKitDoc) {
                    var opacity = isNumber(image.opacity) ? image.opacity : 1;
                    pdfKitDoc.opacity(opacity);
                    if (image.cover) {
                        var align = image.cover.align || "center";
                        var valign = image.cover.valign || "center";
                        var width = image.cover.width ? image.cover.width : image.width;
                        var height = image.cover.height ? image.cover.height : image.height;
                        pdfKitDoc.save();
                        pdfKitDoc.rect(image.x, image.y, width, height).clip();
                        pdfKitDoc.image(image.image, image.x, image.y, {
                            cover: [
                                width,
                                height
                            ],
                            align: align,
                            valign: valign
                        });
                        pdfKitDoc.restore();
                    } else pdfKitDoc.image(image.image, image.x, image.y, {
                        width: image._width,
                        height: image._height
                    });
                    if (image.link) pdfKitDoc.link(image.x, image.y, image._width, image._height, image.link);
                    if (image.linkToPage) {
                        pdfKitDoc.ref({
                            Type: "Action",
                            S: "GoTo",
                            D: [
                                image.linkToPage,
                                0,
                                0
                            ]
                        }).end();
                        pdfKitDoc.annotate(image.x, image.y, image._width, image._height, {
                            Subtype: "Link",
                            Dest: [
                                image.linkToPage - 1,
                                "XYZ",
                                null,
                                null,
                                null
                            ]
                        });
                    }
                    if (image.linkToDestination) pdfKitDoc.goTo(image.x, image.y, image._width, image._height, image.linkToDestination);
                }
                function renderSVG(svg, x, y, pdfKitDoc, fontProvider) {
                    var options = Object.assign({
                        width: svg._width,
                        height: svg._height,
                        assumePt: true
                    }, svg.options);
                    options.fontCallback = function(family, bold, italic) {
                        var fontsFamily = family.split(",").map(function(f) {
                            return f.trim().replace(/('|")/g, "");
                        });
                        var font = findFont(fontProvider.fonts, fontsFamily, svg.font || "Roboto");
                        var fontFile = fontProvider.getFontFile(font, bold, italic);
                        if (fontFile === null) {
                            var type = fontProvider.getFontType(bold, italic);
                            throw new Error("Font '" + font + "' in style '" + type + "' is not defined in the font section of the document definition.");
                        }
                        return fontFile;
                    };
                    SVGtoPDF(pdfKitDoc, svg.svg, svg.x, svg.y, options);
                }
                function beginClip(rect, pdfKitDoc) {
                    pdfKitDoc.save();
                    pdfKitDoc.addContent("" + rect.x + " " + rect.y + " " + rect.width + " " + rect.height + " re");
                    pdfKitDoc.clip();
                }
                function endClip(pdfKitDoc) {
                    pdfKitDoc.restore();
                }
                function createPatterns(patternDefinitions, pdfKitDoc) {
                    var patterns = {};
                    Object.keys(patternDefinitions).forEach(function(p) {
                        var pattern = patternDefinitions[p];
                        patterns[p] = pdfKitDoc.pattern(pattern.boundingBox, pattern.xStep, pattern.yStep, pattern.pattern, pattern.colored);
                    });
                    return patterns;
                }
                module1.exports = PdfPrinter;
            /***/ },
            /***/ 86976: /***/ function(module1) {
                "use strict";
                /*eslint no-unused-vars: ["error", {"args": "none"}]*/ /*eslint no-redeclare: "off"*/ /* qr.js -- QR code generator in Javascript (revision 2011-01-19)
 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
 *
 * This source code is in the public domain; if your jurisdiction does not
 * recognize the public domain the terms of Creative Commons CC0 license
 * apply. In the other words, you can always do what you want.
 */ // per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
                //
                // [0]: the degree of generator polynomial by ECC levels
                // [1]: # of code blocks by ECC levels
                // [2]: left-top positions of alignment patterns
                //
                // the number in this table (in particular, [0]) does not exactly match with
                // the numbers in the specficiation. see augumenteccs below for the reason.
                var VERSIONS = [
                    null,
                    [
                        [
                            10,
                            7,
                            17,
                            13
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        []
                    ],
                    [
                        [
                            16,
                            10,
                            28,
                            22
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            4,
                            16
                        ]
                    ],
                    [
                        [
                            26,
                            15,
                            22,
                            18
                        ],
                        [
                            1,
                            1,
                            2,
                            2
                        ],
                        [
                            4,
                            20
                        ]
                    ],
                    [
                        [
                            18,
                            20,
                            16,
                            26
                        ],
                        [
                            2,
                            1,
                            4,
                            2
                        ],
                        [
                            4,
                            24
                        ]
                    ],
                    [
                        [
                            24,
                            26,
                            22,
                            18
                        ],
                        [
                            2,
                            1,
                            4,
                            4
                        ],
                        [
                            4,
                            28
                        ]
                    ],
                    [
                        [
                            16,
                            18,
                            28,
                            24
                        ],
                        [
                            4,
                            2,
                            4,
                            4
                        ],
                        [
                            4,
                            32
                        ]
                    ],
                    [
                        [
                            18,
                            20,
                            26,
                            18
                        ],
                        [
                            4,
                            2,
                            5,
                            6
                        ],
                        [
                            4,
                            20,
                            36
                        ]
                    ],
                    [
                        [
                            22,
                            24,
                            26,
                            22
                        ],
                        [
                            4,
                            2,
                            6,
                            6
                        ],
                        [
                            4,
                            22,
                            40
                        ]
                    ],
                    [
                        [
                            22,
                            30,
                            24,
                            20
                        ],
                        [
                            5,
                            2,
                            8,
                            8
                        ],
                        [
                            4,
                            24,
                            44
                        ]
                    ],
                    [
                        [
                            26,
                            18,
                            28,
                            24
                        ],
                        [
                            5,
                            4,
                            8,
                            8
                        ],
                        [
                            4,
                            26,
                            48
                        ]
                    ],
                    [
                        [
                            30,
                            20,
                            24,
                            28
                        ],
                        [
                            5,
                            4,
                            11,
                            8
                        ],
                        [
                            4,
                            28,
                            52
                        ]
                    ],
                    [
                        [
                            22,
                            24,
                            28,
                            26
                        ],
                        [
                            8,
                            4,
                            11,
                            10
                        ],
                        [
                            4,
                            30,
                            56
                        ]
                    ],
                    [
                        [
                            22,
                            26,
                            22,
                            24
                        ],
                        [
                            9,
                            4,
                            16,
                            12
                        ],
                        [
                            4,
                            32,
                            60
                        ]
                    ],
                    [
                        [
                            24,
                            30,
                            24,
                            20
                        ],
                        [
                            9,
                            4,
                            16,
                            16
                        ],
                        [
                            4,
                            24,
                            44,
                            64
                        ]
                    ],
                    [
                        [
                            24,
                            22,
                            24,
                            30
                        ],
                        [
                            10,
                            6,
                            18,
                            12
                        ],
                        [
                            4,
                            24,
                            46,
                            68
                        ]
                    ],
                    [
                        [
                            28,
                            24,
                            30,
                            24
                        ],
                        [
                            10,
                            6,
                            16,
                            17
                        ],
                        [
                            4,
                            24,
                            48,
                            72
                        ]
                    ],
                    [
                        [
                            28,
                            28,
                            28,
                            28
                        ],
                        [
                            11,
                            6,
                            19,
                            16
                        ],
                        [
                            4,
                            28,
                            52,
                            76
                        ]
                    ],
                    [
                        [
                            26,
                            30,
                            28,
                            28
                        ],
                        [
                            13,
                            6,
                            21,
                            18
                        ],
                        [
                            4,
                            28,
                            54,
                            80
                        ]
                    ],
                    [
                        [
                            26,
                            28,
                            26,
                            26
                        ],
                        [
                            14,
                            7,
                            25,
                            21
                        ],
                        [
                            4,
                            28,
                            56,
                            84
                        ]
                    ],
                    [
                        [
                            26,
                            28,
                            28,
                            30
                        ],
                        [
                            16,
                            8,
                            25,
                            20
                        ],
                        [
                            4,
                            32,
                            60,
                            88
                        ]
                    ],
                    [
                        [
                            26,
                            28,
                            30,
                            28
                        ],
                        [
                            17,
                            8,
                            25,
                            23
                        ],
                        [
                            4,
                            26,
                            48,
                            70,
                            92
                        ]
                    ],
                    [
                        [
                            28,
                            28,
                            24,
                            30
                        ],
                        [
                            17,
                            9,
                            34,
                            23
                        ],
                        [
                            4,
                            24,
                            48,
                            72,
                            96
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            18,
                            9,
                            30,
                            25
                        ],
                        [
                            4,
                            28,
                            52,
                            76,
                            100
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            20,
                            10,
                            32,
                            27
                        ],
                        [
                            4,
                            26,
                            52,
                            78,
                            104
                        ]
                    ],
                    [
                        [
                            28,
                            26,
                            30,
                            30
                        ],
                        [
                            21,
                            12,
                            35,
                            29
                        ],
                        [
                            4,
                            30,
                            56,
                            82,
                            108
                        ]
                    ],
                    [
                        [
                            28,
                            28,
                            30,
                            28
                        ],
                        [
                            23,
                            12,
                            37,
                            34
                        ],
                        [
                            4,
                            28,
                            56,
                            84,
                            112
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            25,
                            12,
                            40,
                            34
                        ],
                        [
                            4,
                            32,
                            60,
                            88,
                            116
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            26,
                            13,
                            42,
                            35
                        ],
                        [
                            4,
                            24,
                            48,
                            72,
                            96,
                            120
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            28,
                            14,
                            45,
                            38
                        ],
                        [
                            4,
                            28,
                            52,
                            76,
                            100,
                            124
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            29,
                            15,
                            48,
                            40
                        ],
                        [
                            4,
                            24,
                            50,
                            76,
                            102,
                            128
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            31,
                            16,
                            51,
                            43
                        ],
                        [
                            4,
                            28,
                            54,
                            80,
                            106,
                            132
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            33,
                            17,
                            54,
                            45
                        ],
                        [
                            4,
                            32,
                            58,
                            84,
                            110,
                            136
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            35,
                            18,
                            57,
                            48
                        ],
                        [
                            4,
                            28,
                            56,
                            84,
                            112,
                            140
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            37,
                            19,
                            60,
                            51
                        ],
                        [
                            4,
                            32,
                            60,
                            88,
                            116,
                            144
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            38,
                            19,
                            63,
                            53
                        ],
                        [
                            4,
                            28,
                            52,
                            76,
                            100,
                            124,
                            148
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            40,
                            20,
                            66,
                            56
                        ],
                        [
                            4,
                            22,
                            48,
                            74,
                            100,
                            126,
                            152
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            43,
                            21,
                            70,
                            59
                        ],
                        [
                            4,
                            26,
                            52,
                            78,
                            104,
                            130,
                            156
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            45,
                            22,
                            74,
                            62
                        ],
                        [
                            4,
                            30,
                            56,
                            82,
                            108,
                            134,
                            160
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            47,
                            24,
                            77,
                            65
                        ],
                        [
                            4,
                            24,
                            52,
                            80,
                            108,
                            136,
                            164
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            49,
                            25,
                            81,
                            68
                        ],
                        [
                            4,
                            28,
                            56,
                            84,
                            112,
                            140,
                            168
                        ]
                    ]
                ];
                // mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
                var MODE_TERMINATOR = 0;
                var MODE_NUMERIC = 1, MODE_ALPHANUMERIC = 2, MODE_OCTET = 4, MODE_KANJI = 8;
                // validation regexps
                var NUMERIC_REGEXP = /^\d*$/;
                var ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
                var ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;
                // ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
                var ECCLEVEL_L = 1, ECCLEVEL_M = 0, ECCLEVEL_Q = 3, ECCLEVEL_H = 2;
                // GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
                // invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
                var GF256_MAP = [], GF256_INVMAP = [
                    -1
                ];
                for(var i = 0, v = 1; i < 255; ++i){
                    GF256_MAP.push(v);
                    GF256_INVMAP[v] = i;
                    v = v * 2 ^ (v >= 128 ? 0x11d : 0);
                }
                // generator polynomials up to degree 30
                // (should match with polynomials in JIS X 0510:2004 Appendix A)
                //
                // generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
                // ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
                // from the result; also other coefficients are written in terms of the exponent
                // to \alpha to avoid the redundant calculation. (see also calculateecc below.)
                var GF256_GENPOLY = [
                    []
                ];
                for(var i = 0; i < 30; ++i){
                    var prevpoly = GF256_GENPOLY[i], poly = [];
                    for(var j = 0; j <= i; ++j){
                        var a = j < i ? GF256_MAP[prevpoly[j]] : 0;
                        var b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
                        poly.push(GF256_INVMAP[a ^ b]);
                    }
                    GF256_GENPOLY.push(poly);
                }
                // alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
                var ALPHANUMERIC_MAP = {};
                for(var i = 0; i < 45; ++i)ALPHANUMERIC_MAP["0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:".charAt(i)] = i;
                // mask functions in terms of row # and column #
                // (cf. Table 20 in JIS X 0510:2004 p. 42)
                /*jshint unused: false */ var MASKFUNCS = [
                    function(i, j) {
                        return (i + j) % 2 === 0;
                    },
                    function(i, j) {
                        return i % 2 === 0;
                    },
                    function(i, j) {
                        return j % 3 === 0;
                    },
                    function(i, j) {
                        return (i + j) % 3 === 0;
                    },
                    function(i, j) {
                        return ((i / 2 | 0) + (j / 3 | 0)) % 2 === 0;
                    },
                    function(i, j) {
                        return i * j % 2 + i * j % 3 === 0;
                    },
                    function(i, j) {
                        return (i * j % 2 + i * j % 3) % 2 === 0;
                    },
                    function(i, j) {
                        return ((i + j) % 2 + i * j % 3) % 2 === 0;
                    }
                ];
                // returns true when the version information has to be embeded.
                var needsverinfo = function(ver) {
                    return ver > 6;
                };
                // returns the size of entire QR code for given version.
                var getsizebyver = function(ver) {
                    return 4 * ver + 17;
                };
                // returns the number of bits available for code words in this version.
                var nfullbits = function(ver) {
                    /*
	 * |<--------------- n --------------->|
	 * |        |<----- n-17 ---->|        |
	 * +-------+                ///+-------+ ----
	 * |       |                ///|       |    ^
	 * |  9x9  |       @@@@@    ///|  9x8  |    |
	 * |       | # # # @5x5@ # # # |       |    |
	 * +-------+       @@@@@       +-------+    |
	 *       #                               ---|
	 *                                        ^ |
	 *       #                                |
	 *     @@@@@       @@@@@       @@@@@      | n
	 *     @5x5@       @5x5@       @5x5@   n-17
	 *     @@@@@       @@@@@       @@@@@      | |
	 *       #                                | |
	 * //////                                 v |
	 * //////#                               ---|
	 * +-------+       @@@@@       @@@@@        |
	 * |       |       @5x5@       @5x5@        |
	 * |  8x9  |       @@@@@       @@@@@        |
	 * |       |                                v
	 * +-------+                             ----
	 *
	 * when the entire code has n^2 modules and there are m^2-3 alignment
	 * patterns, we have:
	 * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
	 *   format information;
	 * - 2n-34 (= 2(n-17)) modules for timing patterns;
	 * - 36 (= 3x6 + 6x3) modules for version information, if any;
	 * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
	 *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
	 *   timing patterns.
	 */ var v = VERSIONS[ver];
                    var nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
                    if (needsverinfo(ver)) nbits -= 36; // version information
                    if (v[2].length) nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
                    return nbits;
                };
                // returns the number of bits available for data portions (i.e. excludes ECC
                // bits but includes mode and length bits) in this version and ECC level.
                var ndatabits = function(ver, ecclevel) {
                    var nbits = nfullbits(ver) & -8; // no sub-octet code words
                    var v = VERSIONS[ver];
                    nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
                    return nbits;
                };
                // returns the number of bits required for the length of data.
                // (cf. Table 3 in JIS X 0510:2004 p. 16)
                var ndatalenbits = function(ver, mode) {
                    switch(mode){
                        case MODE_NUMERIC:
                            return ver < 10 ? 10 : ver < 27 ? 12 : 14;
                        case MODE_ALPHANUMERIC:
                            return ver < 10 ? 9 : ver < 27 ? 11 : 13;
                        case MODE_OCTET:
                            return ver < 10 ? 8 : 16;
                        case MODE_KANJI:
                            return ver < 10 ? 8 : ver < 27 ? 10 : 12;
                    }
                };
                // returns the maximum length of data possible in given configuration.
                var getmaxdatalen = function(ver, mode, ecclevel) {
                    var nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
                    switch(mode){
                        case MODE_NUMERIC:
                            return (nbits / 10 | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
                        case MODE_ALPHANUMERIC:
                            return (nbits / 11 | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
                        case MODE_OCTET:
                            return nbits / 8 | 0;
                        case MODE_KANJI:
                            return nbits / 13 | 0;
                    }
                };
                // checks if the given data can be encoded in given mode, and returns
                // the converted data for the further processing if possible. otherwise
                // returns null.
                //
                // this function does not check the length of data; it is a duty of
                // encode function below (as it depends on the version and ECC level too).
                var validatedata = function(mode, data) {
                    switch(mode){
                        case MODE_NUMERIC:
                            if (!data.match(NUMERIC_REGEXP)) return null;
                            return data;
                        case MODE_ALPHANUMERIC:
                            if (!data.match(ALPHANUMERIC_REGEXP)) return null;
                            return data.toUpperCase();
                        case MODE_OCTET:
                            if (typeof data === "string") {
                                var newdata = [];
                                for(var i = 0; i < data.length; ++i){
                                    var ch = data.charCodeAt(i);
                                    if (ch < 0x80) newdata.push(ch);
                                    else if (ch < 0x800) newdata.push(0xc0 | ch >> 6, 0x80 | ch & 0x3f);
                                    else if (ch < 0x10000) newdata.push(0xe0 | ch >> 12, 0x80 | ch >> 6 & 0x3f, 0x80 | ch & 0x3f);
                                    else newdata.push(0xf0 | ch >> 18, 0x80 | ch >> 12 & 0x3f, 0x80 | ch >> 6 & 0x3f, 0x80 | ch & 0x3f);
                                }
                                return newdata;
                            } else return data;
                    }
                };
                // returns the code words (sans ECC bits) for given data and configurations.
                // requires data to be preprocessed by validatedata. no length check is
                // performed, and everything has to be checked before calling this function.
                var encode = function(ver, mode, data, maxbuflen) {
                    var buf = [];
                    var bits = 0, remaining = 8;
                    var datalen = data.length;
                    // this function is intentionally no-op when n=0.
                    var pack = function(x, n) {
                        if (n >= remaining) {
                            buf.push(bits | x >> (n -= remaining));
                            while(n >= 8)buf.push(x >> (n -= 8) & 255);
                            bits = 0;
                            remaining = 8;
                        }
                        if (n > 0) bits |= (x & (1 << n) - 1) << (remaining -= n);
                    };
                    var nlenbits = ndatalenbits(ver, mode);
                    pack(mode, 4);
                    pack(datalen, nlenbits);
                    switch(mode){
                        case MODE_NUMERIC:
                            for(var i = 2; i < datalen; i += 3)pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
                            pack(parseInt(data.substring(i - 2), 10), [
                                0,
                                4,
                                7
                            ][datalen % 3]);
                            break;
                        case MODE_ALPHANUMERIC:
                            for(var i = 1; i < datalen; i += 2)pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45 + ALPHANUMERIC_MAP[data.charAt(i)], 11);
                            if (datalen % 2 == 1) pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
                            break;
                        case MODE_OCTET:
                            for(var i = 0; i < datalen; ++i)pack(data[i], 8);
                            break;
                    }
                    // final bits. it is possible that adding terminator causes the buffer
                    // to overflow, but then the buffer truncated to the maximum size will
                    // be valid as the truncated terminator mode bits and padding is
                    // identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
                    pack(MODE_TERMINATOR, 4);
                    if (remaining < 8) buf.push(bits);
                    // the padding to fill up the remaining space. we should not add any
                    // words when the overflow already occurred.
                    while(buf.length + 1 < maxbuflen)buf.push(0xec, 0x11);
                    if (buf.length < maxbuflen) buf.push(0xec);
                    return buf;
                };
                // calculates ECC code words for given code words and generator polynomial.
                //
                // this is quite similar to CRC calculation as both Reed-Solomon and CRC use
                // the certain kind of cyclic codes, which is effectively the division of
                // zero-augumented polynomial by the generator polynomial. the only difference
                // is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
                // uses the different generator polynomial than CRC's.
                var calculateecc = function(poly, genpoly) {
                    var modulus = poly.slice(0);
                    var polylen = poly.length, genpolylen = genpoly.length;
                    for(var i = 0; i < genpolylen; ++i)modulus.push(0);
                    for(var i = 0; i < polylen;){
                        var quotient = GF256_INVMAP[modulus[i++]];
                        if (quotient >= 0) for(var j = 0; j < genpolylen; ++j)modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
                    }
                    return modulus.slice(polylen);
                };
                // auguments ECC code words to given code words. the resulting words are
                // ready to be encoded in the matrix.
                //
                // the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
                // the code is simplified using the fact that the size of each code & ECC
                // blocks is almost same; for example, when we have 4 blocks and 46 data words
                // the number of code words in those blocks are 11, 11, 12, 12 respectively.
                var augumenteccs = function(poly, nblocks, genpoly) {
                    var subsizes = [];
                    var subsize = poly.length / nblocks | 0, subsize0 = 0;
                    var pivot = nblocks - poly.length % nblocks;
                    for(var i = 0; i < pivot; ++i){
                        subsizes.push(subsize0);
                        subsize0 += subsize;
                    }
                    for(var i = pivot; i < nblocks; ++i){
                        subsizes.push(subsize0);
                        subsize0 += subsize + 1;
                    }
                    subsizes.push(subsize0);
                    var eccs = [];
                    for(var i = 0; i < nblocks; ++i)eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
                    var result = [];
                    var nitemsperblock = poly.length / nblocks | 0;
                    for(var i = 0; i < nitemsperblock; ++i)for(var j = 0; j < nblocks; ++j)result.push(poly[subsizes[j] + i]);
                    for(var j = pivot; j < nblocks; ++j)result.push(poly[subsizes[j + 1] - 1]);
                    for(var i = 0; i < genpoly.length; ++i)for(var j = 0; j < nblocks; ++j)result.push(eccs[j][i]);
                    return result;
                };
                // auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
                // genpoly. the both input and output are in binary numbers, and unlike
                // calculateecc genpoly should include the 1 bit for the highest degree.
                //
                // actual polynomials used for this procedure are as follows:
                // - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
                // - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
                var augumentbch = function(poly, p, genpoly, q) {
                    var modulus = poly << q;
                    for(var i = p - 1; i >= 0; --i)if (modulus >> q + i & 1) modulus ^= genpoly << i;
                    return poly << q | modulus;
                };
                // creates the base matrix for given version. it returns two matrices, one of
                // them is the actual one and the another represents the "reserved" portion
                // (e.g. finder and timing patterns) of the matrix.
                //
                // some entries in the matrix may be undefined, rather than 0 or 1. this is
                // intentional (no initialization needed!), and putdata below will fill
                // the remaining ones.
                var makebasematrix = function(ver) {
                    var v = VERSIONS[ver], n = getsizebyver(ver);
                    var matrix = [], reserved = [];
                    for(var i = 0; i < n; ++i){
                        matrix.push([]);
                        reserved.push([]);
                    }
                    var blit = function(y, x, h, w, bits) {
                        for(var i = 0; i < h; ++i)for(var j = 0; j < w; ++j){
                            matrix[y + i][x + j] = bits[i] >> j & 1;
                            reserved[y + i][x + j] = 1;
                        }
                    };
                    // finder patterns and a part of timing patterns
                    // will also mark the format information area (not yet written) as reserved.
                    blit(0, 0, 9, 9, [
                        0x7f,
                        0x41,
                        0x5d,
                        0x5d,
                        0x5d,
                        0x41,
                        0x17f,
                        0x00,
                        0x40
                    ]);
                    blit(n - 8, 0, 8, 9, [
                        0x100,
                        0x7f,
                        0x41,
                        0x5d,
                        0x5d,
                        0x5d,
                        0x41,
                        0x7f
                    ]);
                    blit(0, n - 8, 9, 8, [
                        0xfe,
                        0x82,
                        0xba,
                        0xba,
                        0xba,
                        0x82,
                        0xfe,
                        0x00,
                        0x00
                    ]);
                    // the rest of timing patterns
                    for(var i = 9; i < n - 8; ++i){
                        matrix[6][i] = matrix[i][6] = ~i & 1;
                        reserved[6][i] = reserved[i][6] = 1;
                    }
                    // alignment patterns
                    var aligns = v[2], m = aligns.length;
                    for(var i = 0; i < m; ++i){
                        var minj = i === 0 || i === m - 1 ? 1 : 0, maxj = i === 0 ? m - 1 : m;
                        for(var j = minj; j < maxj; ++j)blit(aligns[i], aligns[j], 5, 5, [
                            0x1f,
                            0x11,
                            0x15,
                            0x11,
                            0x1f
                        ]);
                    }
                    // version information
                    if (needsverinfo(ver)) {
                        var code = augumentbch(ver, 6, 0x1f25, 12);
                        var k = 0;
                        for(var i = 0; i < 6; ++i)for(var j = 0; j < 3; ++j){
                            matrix[i][n - 11 + j] = matrix[n - 11 + j][i] = code >> k++ & 1;
                            reserved[i][n - 11 + j] = reserved[n - 11 + j][i] = 1;
                        }
                    }
                    return {
                        matrix: matrix,
                        reserved: reserved
                    };
                };
                // fills the data portion (i.e. unmarked in reserved) of the matrix with given
                // code words. the size of code words should be no more than available bits,
                // and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
                var putdata = function(matrix, reserved, buf) {
                    var n = matrix.length;
                    var k = 0, dir = -1;
                    for(var i = n - 1; i >= 0; i -= 2){
                        if (i == 6) --i; // skip the entire timing pattern column
                        var jj = dir < 0 ? n - 1 : 0;
                        for(var j = 0; j < n; ++j){
                            for(var ii = i; ii > i - 2; --ii)if (!reserved[jj][ii]) {
                                // may overflow, but (undefined >> x)
                                // is 0 so it will auto-pad to zero.
                                matrix[jj][ii] = buf[k >> 3] >> (~k & 7) & 1;
                                ++k;
                            }
                            jj += dir;
                        }
                        dir = -dir;
                    }
                    return matrix;
                };
                // XOR-masks the data portion of the matrix. repeating the call with the same
                // arguments will revert the prior call (convenient in the matrix evaluation).
                var maskdata = function(matrix, reserved, mask) {
                    var maskf = MASKFUNCS[mask];
                    var n = matrix.length;
                    for(var i = 0; i < n; ++i){
                        for(var j = 0; j < n; ++j)if (!reserved[i][j]) matrix[i][j] ^= maskf(i, j);
                    }
                    return matrix;
                };
                // puts the format information.
                var putformatinfo = function(matrix, reserved, ecclevel, mask) {
                    var n = matrix.length;
                    var code = augumentbch(ecclevel << 3 | mask, 5, 0x537, 10) ^ 0x5412;
                    for(var i = 0; i < 15; ++i){
                        var r = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            7,
                            8,
                            n - 7,
                            n - 6,
                            n - 5,
                            n - 4,
                            n - 3,
                            n - 2,
                            n - 1
                        ][i];
                        var c = [
                            n - 1,
                            n - 2,
                            n - 3,
                            n - 4,
                            n - 5,
                            n - 6,
                            n - 7,
                            n - 8,
                            7,
                            5,
                            4,
                            3,
                            2,
                            1,
                            0
                        ][i];
                        matrix[r][8] = matrix[8][c] = code >> i & 1;
                    // we don't have to mark those bits reserved; always done
                    // in makebasematrix above.
                    }
                    return matrix;
                };
                // evaluates the resulting matrix and returns the score (lower is better).
                // (cf. JIS X 0510:2004 sec 8.8.2)
                //
                // the evaluation procedure tries to avoid the problematic patterns naturally
                // occuring from the original matrix. for example, it penaltizes the patterns
                // which just look like the finder pattern which will confuse the decoder.
                // we choose the mask which results in the lowest score among 8 possible ones.
                //
                // note: zxing seems to use the same procedure and in many cases its choice
                // agrees to ours, but sometimes it does not. practically it doesn't matter.
                var evaluatematrix = function(matrix) {
                    // N1+(k-5) points for each consecutive row of k same-colored modules,
                    // where k >= 5. no overlapping row counts.
                    var PENALTY_CONSECUTIVE = 3;
                    // N2 points for each 2x2 block of same-colored modules.
                    // overlapping block does count.
                    var PENALTY_TWOBYTWO = 3;
                    // N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
                    // 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
                    // but 13W:3B:3W:9B:3W:3B counts).
                    var PENALTY_FINDERLIKE = 40;
                    // N4*k points for every (5*k)% deviation from 50% black density.
                    // i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
                    var PENALTY_DENSITY = 10;
                    var evaluategroup = function(groups) {
                        var score = 0;
                        for(var i = 0; i < groups.length; ++i)if (groups[i] >= 5) score += PENALTY_CONSECUTIVE + (groups[i] - 5);
                        for(var i = 5; i < groups.length; i += 2){
                            var p = groups[i];
                            if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p && groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) // this part differs from zxing...
                            score += PENALTY_FINDERLIKE;
                        }
                        return score;
                    };
                    var n = matrix.length;
                    var score = 0, nblacks = 0;
                    for(var i = 0; i < n; ++i){
                        var row = matrix[i];
                        var groups;
                        // evaluate the current row
                        groups = [
                            0
                        ]; // the first empty group of white
                        for(var j = 0; j < n;){
                            var k;
                            for(k = 0; j < n && row[j]; ++k)++j;
                            groups.push(k);
                            for(k = 0; j < n && !row[j]; ++k)++j;
                            groups.push(k);
                        }
                        score += evaluategroup(groups);
                        // evaluate the current column
                        groups = [
                            0
                        ];
                        for(var j = 0; j < n;){
                            var k;
                            for(k = 0; j < n && matrix[j][i]; ++k)++j;
                            groups.push(k);
                            for(k = 0; j < n && !matrix[j][i]; ++k)++j;
                            groups.push(k);
                        }
                        score += evaluategroup(groups);
                        // check the 2x2 box and calculate the density
                        var nextrow = matrix[i + 1] || [];
                        nblacks += row[0];
                        for(var j = 1; j < n; ++j){
                            var p = row[j];
                            nblacks += p;
                            // at least comparison with next row should be strict...
                            if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) score += PENALTY_TWOBYTWO;
                        }
                    }
                    score += PENALTY_DENSITY * (Math.abs(nblacks / n / n - 0.5) / 0.05 | 0);
                    return score;
                };
                // returns the fully encoded QR code matrix which contains given data.
                // it also chooses the best mask automatically when mask is -1.
                var generate = function(data, ver, mode, ecclevel, mask) {
                    var v = VERSIONS[ver];
                    var buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
                    buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);
                    var result = makebasematrix(ver);
                    var matrix = result.matrix, reserved = result.reserved;
                    putdata(matrix, reserved, buf);
                    if (mask < 0) {
                        // find the best mask
                        maskdata(matrix, reserved, 0);
                        putformatinfo(matrix, reserved, ecclevel, 0);
                        var bestmask = 0, bestscore = evaluatematrix(matrix);
                        maskdata(matrix, reserved, 0);
                        for(mask = 1; mask < 8; ++mask){
                            maskdata(matrix, reserved, mask);
                            putformatinfo(matrix, reserved, ecclevel, mask);
                            var score = evaluatematrix(matrix);
                            if (bestscore > score) {
                                bestscore = score;
                                bestmask = mask;
                            }
                            maskdata(matrix, reserved, mask);
                        }
                        mask = bestmask;
                    }
                    maskdata(matrix, reserved, mask);
                    putformatinfo(matrix, reserved, ecclevel, mask);
                    return matrix;
                };
                // the public interface is trivial; the options available are as follows:
                //
                // - version: an integer in [1,40]. when omitted (or -1) the smallest possible
                //   version is chosen.
                // - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
                //   possible mode is chosen.
                // - eccLevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
                // - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
                //
                function generateFrame(data, options) {
                    var MODES = {
                        "numeric": MODE_NUMERIC,
                        "alphanumeric": MODE_ALPHANUMERIC,
                        "octet": MODE_OCTET
                    };
                    var ECCLEVELS = {
                        "L": ECCLEVEL_L,
                        "M": ECCLEVEL_M,
                        "Q": ECCLEVEL_Q,
                        "H": ECCLEVEL_H
                    };
                    options = options || {};
                    var ver = options.version || -1;
                    var ecclevel = ECCLEVELS[(options.eccLevel || "L").toUpperCase()];
                    var mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
                    var mask = "mask" in options ? options.mask : -1;
                    if (mode < 0) {
                        if (typeof data === "string") {
                            if (data.match(NUMERIC_REGEXP)) mode = MODE_NUMERIC;
                            else if (data.match(ALPHANUMERIC_OUT_REGEXP)) // while encode supports case-insensitive encoding, we restrict the data to be uppercased when auto-selecting the mode.
                            mode = MODE_ALPHANUMERIC;
                            else mode = MODE_OCTET;
                        } else mode = MODE_OCTET;
                    } else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC || mode == MODE_OCTET)) throw "invalid or unsupported mode";
                    data = validatedata(mode, data);
                    if (data === null) throw "invalid data format";
                    if (ecclevel < 0 || ecclevel > 3) throw "invalid ECC level";
                    if (ver < 0) {
                        for(ver = 1; ver <= 40; ++ver){
                            if (data.length <= getmaxdatalen(ver, mode, ecclevel)) break;
                        }
                        if (ver > 40) throw "too large data for the Qr format";
                    } else if (ver < 1 || ver > 40) throw "invalid Qr version! should be between 1 and 40";
                    if (mask != -1 && (mask < 0 || mask > 8)) throw "invalid mask";
                    //console.log('version:', ver, 'mode:', mode, 'ECC:', ecclevel, 'mask:', mask )
                    return generate(data, ver, mode, ecclevel, mask);
                }
                // options
                // - modulesize: a number. this is a size of each modules in pixels, and
                //   defaults to 5px.
                // - margin: a number. this is a size of margin in *modules*, and defaults to
                //   4 (white modules). the specficiation mandates the margin no less than 4
                //   modules, so it is better not to alter this value unless you know what
                //   you're doing.
                function buildCanvas(data, options) {
                    var canvas = [];
                    var background = options.background || "#fff";
                    var foreground = options.foreground || "#000";
                    var padding = options.padding || 0;
                    //var margin = options.margin || 4;
                    var matrix = generateFrame(data, options);
                    var n = matrix.length;
                    var modSize = Math.floor(options.fit ? options.fit / n : 5);
                    var size = n * modSize + modSize * padding * 2;
                    var paddingXY = modSize * padding;
                    canvas.push({
                        type: "rect",
                        x: 0,
                        y: 0,
                        w: size,
                        h: size,
                        lineWidth: 0,
                        color: background
                    });
                    for(var i = 0; i < n; ++i){
                        for(var j = 0; j < n; ++j)if (matrix[i][j]) canvas.push({
                            type: "rect",
                            x: modSize * j + paddingXY,
                            y: modSize * i + paddingXY,
                            w: modSize,
                            h: modSize,
                            lineWidth: 0,
                            color: foreground
                        });
                    }
                    return {
                        canvas: canvas,
                        size: size
                    };
                }
                function measure(node) {
                    var cd = buildCanvas(node.qr, node);
                    node._canvas = cd.canvas;
                    node._width = node._height = node._minWidth = node._maxWidth = node._minHeight = node._maxHeight = cd.size;
                    return node;
                }
                module1.exports = {
                    measure: measure
                };
            /***/ },
            /***/ 58050: /***/ function(module1) {
                "use strict";
                module1.exports = {
                    "4A0": [
                        4767.87,
                        6740.79
                    ],
                    "2A0": [
                        3370.39,
                        4767.87
                    ],
                    A0: [
                        2383.94,
                        3370.39
                    ],
                    A1: [
                        1683.78,
                        2383.94
                    ],
                    A2: [
                        1190.55,
                        1683.78
                    ],
                    A3: [
                        841.89,
                        1190.55
                    ],
                    A4: [
                        595.28,
                        841.89
                    ],
                    A5: [
                        419.53,
                        595.28
                    ],
                    A6: [
                        297.64,
                        419.53
                    ],
                    A7: [
                        209.76,
                        297.64
                    ],
                    A8: [
                        147.40,
                        209.76
                    ],
                    A9: [
                        104.88,
                        147.40
                    ],
                    A10: [
                        73.70,
                        104.88
                    ],
                    B0: [
                        2834.65,
                        4008.19
                    ],
                    B1: [
                        2004.09,
                        2834.65
                    ],
                    B2: [
                        1417.32,
                        2004.09
                    ],
                    B3: [
                        1000.63,
                        1417.32
                    ],
                    B4: [
                        708.66,
                        1000.63
                    ],
                    B5: [
                        498.90,
                        708.66
                    ],
                    B6: [
                        354.33,
                        498.90
                    ],
                    B7: [
                        249.45,
                        354.33
                    ],
                    B8: [
                        175.75,
                        249.45
                    ],
                    B9: [
                        124.72,
                        175.75
                    ],
                    B10: [
                        87.87,
                        124.72
                    ],
                    C0: [
                        2599.37,
                        3676.54
                    ],
                    C1: [
                        1836.85,
                        2599.37
                    ],
                    C2: [
                        1298.27,
                        1836.85
                    ],
                    C3: [
                        918.43,
                        1298.27
                    ],
                    C4: [
                        649.13,
                        918.43
                    ],
                    C5: [
                        459.21,
                        649.13
                    ],
                    C6: [
                        323.15,
                        459.21
                    ],
                    C7: [
                        229.61,
                        323.15
                    ],
                    C8: [
                        161.57,
                        229.61
                    ],
                    C9: [
                        113.39,
                        161.57
                    ],
                    C10: [
                        79.37,
                        113.39
                    ],
                    RA0: [
                        2437.80,
                        3458.27
                    ],
                    RA1: [
                        1729.13,
                        2437.80
                    ],
                    RA2: [
                        1218.90,
                        1729.13
                    ],
                    RA3: [
                        864.57,
                        1218.90
                    ],
                    RA4: [
                        609.45,
                        864.57
                    ],
                    SRA0: [
                        2551.18,
                        3628.35
                    ],
                    SRA1: [
                        1814.17,
                        2551.18
                    ],
                    SRA2: [
                        1275.59,
                        1814.17
                    ],
                    SRA3: [
                        907.09,
                        1275.59
                    ],
                    SRA4: [
                        637.80,
                        907.09
                    ],
                    EXECUTIVE: [
                        521.86,
                        756.00
                    ],
                    FOLIO: [
                        612.00,
                        936.00
                    ],
                    LEGAL: [
                        612.00,
                        1008.00
                    ],
                    LETTER: [
                        612.00,
                        792.00
                    ],
                    TABLOID: [
                        792.00,
                        1224.00
                    ]
                };
            /***/ },
            /***/ 28034: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isString = __webpack_require__(16920).isString;
                var isArray = __webpack_require__(16920).isArray;
                var isUndefined = __webpack_require__(16920).isUndefined;
                var isNull = __webpack_require__(16920).isNull;
                /**
 * Creates an instance of StyleContextStack used for style inheritance and style overrides
 *
 * @constructor
 * @this {StyleContextStack}
 * @param {Object} named styles dictionary
 * @param {Object} optional default style definition
 */ function StyleContextStack(styleDictionary, defaultStyle) {
                    this.defaultStyle = defaultStyle || {};
                    this.styleDictionary = styleDictionary;
                    this.styleOverrides = [];
                }
                /**
 * Creates cloned version of current stack
 * @return {StyleContextStack} current stack snapshot
 */ StyleContextStack.prototype.clone = function() {
                    var stack = new StyleContextStack(this.styleDictionary, this.defaultStyle);
                    this.styleOverrides.forEach(function(item) {
                        stack.styleOverrides.push(item);
                    });
                    return stack;
                };
                /**
 * Pushes style-name or style-overrides-object onto the stack for future evaluation
 *
 * @param {String|Object} styleNameOrOverride style-name (referring to styleDictionary) or
 *                                            a new dictionary defining overriding properties
 */ StyleContextStack.prototype.push = function(styleNameOrOverride) {
                    this.styleOverrides.push(styleNameOrOverride);
                };
                /**
 * Removes last style-name or style-overrides-object from the stack
 *
 * @param {Number} howMany - optional number of elements to be popped (if not specified,
 *                           one element will be removed from the stack)
 */ StyleContextStack.prototype.pop = function(howMany) {
                    howMany = howMany || 1;
                    while(howMany-- > 0)this.styleOverrides.pop();
                };
                /**
 * Creates a set of named styles or/and a style-overrides-object based on the item,
 * pushes those elements onto the stack for future evaluation and returns the number
 * of elements pushed, so they can be easily poped then.
 *
 * @param {Object} item - an object with optional style property and/or style overrides
 * @return the number of items pushed onto the stack
 */ StyleContextStack.prototype.autopush = function(item) {
                    if (isString(item)) return 0;
                    var styleNames = [];
                    if (item.style) {
                        if (isArray(item.style)) styleNames = item.style;
                        else styleNames = [
                            item.style
                        ];
                    }
                    for(var i = 0, l = styleNames.length; i < l; i++)this.push(styleNames[i]);
                    var styleProperties = [
                        "font",
                        "fontSize",
                        "fontFeatures",
                        "bold",
                        "italics",
                        "alignment",
                        "color",
                        "columnGap",
                        "fillColor",
                        "fillOpacity",
                        "decoration",
                        "decorationStyle",
                        "decorationColor",
                        "background",
                        "lineHeight",
                        "characterSpacing",
                        "noWrap",
                        "markerColor",
                        "leadingIndent",
                        "sup",
                        "sub"
                    ];
                    var styleOverrideObject = {};
                    var pushStyleOverrideObject = false;
                    styleProperties.forEach(function(key) {
                        if (!isUndefined(item[key]) && !isNull(item[key])) {
                            styleOverrideObject[key] = item[key];
                            pushStyleOverrideObject = true;
                        }
                    });
                    if (pushStyleOverrideObject) this.push(styleOverrideObject);
                    return styleNames.length + (pushStyleOverrideObject ? 1 : 0);
                };
                /**
 * Automatically pushes elements onto the stack, using autopush based on item,
 * executes callback and then pops elements back. Returns value returned by callback
 *
 * @param  {Object}   item - an object with optional style property and/or style overrides
 * @param  {Function} function to be called between autopush and pop
 * @return {Object} value returned by callback
 */ StyleContextStack.prototype.auto = function(item, callback) {
                    var pushedItems = this.autopush(item);
                    var result = callback();
                    if (pushedItems > 0) this.pop(pushedItems);
                    return result;
                };
                /**
 * Evaluates stack and returns value of a named property
 *
 * @param {String} property - property name
 * @return property value or null if not found
 */ StyleContextStack.prototype.getProperty = function(property) {
                    if (this.styleOverrides) for(var i = this.styleOverrides.length - 1; i >= 0; i--){
                        var item = this.styleOverrides[i];
                        if (isString(item)) {
                            // named-style-override
                            var style = this.styleDictionary[item];
                            if (style && !isUndefined(style[property]) && !isNull(style[property])) return style[property];
                        } else if (!isUndefined(item[property]) && !isNull(item[property])) // style-overrides-object
                        return item[property];
                    }
                    return this.defaultStyle && this.defaultStyle[property];
                };
                module1.exports = StyleContextStack;
            /***/ },
            /***/ 48730: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var xmldoc = __webpack_require__(26651);
                /** Strip unit postfix, parse number, but return undefined instead of NaN for bad input */ function stripUnits(textVal) {
                    var n = parseFloat(textVal);
                    if (typeof n !== "number" || isNaN(n)) return undefined;
                    return n;
                }
                /** Make sure it's valid XML and the root tage is <svg/>, returns xmldoc DOM */ function parseSVG(svgString) {
                    var doc;
                    try {
                        doc = new xmldoc.XmlDocument(svgString);
                    } catch (err) {
                        throw new Error("SVGMeasure: " + err);
                    }
                    if (doc.name !== "svg") throw new Error("SVGMeasure: expected <svg> document");
                    return doc;
                }
                function SVGMeasure() {}
                SVGMeasure.prototype.measureSVG = function(svgString) {
                    var doc = parseSVG(svgString);
                    var docWidth = stripUnits(doc.attr.width);
                    var docHeight = stripUnits(doc.attr.height);
                    if ((docWidth == undefined || docHeight == undefined) && typeof doc.attr.viewBox == "string") {
                        var viewBoxParts = doc.attr.viewBox.split(/[,\s]+/);
                        if (viewBoxParts.length !== 4) throw new Error("Unexpected svg viewbox format, should have 4 entries but found: '" + doc.attr.viewBox + "'");
                        if (docWidth == undefined) docWidth = stripUnits(viewBoxParts[2]);
                        if (docHeight == undefined) docHeight = stripUnits(viewBoxParts[3]);
                    }
                    return {
                        width: docWidth,
                        height: docHeight
                    };
                };
                SVGMeasure.prototype.writeDimensions = function(svgString, dimensions) {
                    var doc = parseSVG(svgString);
                    doc.attr.width = "" + dimensions.width;
                    doc.attr.height = "" + dimensions.height;
                    return doc.toString();
                };
                module1.exports = SVGMeasure;
            /***/ },
            /***/ 41729: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ColumnCalculator = __webpack_require__(65354);
                var isFunction = __webpack_require__(16920).isFunction;
                var isNumber = __webpack_require__(16920).isNumber;
                function TableProcessor(tableNode) {
                    this.tableNode = tableNode;
                }
                TableProcessor.prototype.beginTable = function(writer) {
                    var tableNode;
                    var availableWidth;
                    var self1 = this;
                    tableNode = this.tableNode;
                    this.offsets = tableNode._offsets;
                    this.layout = tableNode._layout;
                    availableWidth = writer.context().availableWidth - this.offsets.total;
                    ColumnCalculator.buildColumnWidths(tableNode.table.widths, availableWidth);
                    this.tableWidth = tableNode._offsets.total + getTableInnerContentWidth();
                    this.rowSpanData = prepareRowSpanData();
                    this.cleanUpRepeatables = false;
                    this.headerRows = tableNode.table.headerRows || 0;
                    if (this.headerRows > tableNode.table.body.length) throw new Error(`Too few rows in the table. Property headerRows requires at least ${this.headerRows}, contains only ${tableNode.table.body.length}`);
                    this.rowsWithoutPageBreak = this.headerRows + (tableNode.table.keepWithHeaderRows || 0);
                    this.dontBreakRows = tableNode.table.dontBreakRows || false;
                    if (this.rowsWithoutPageBreak) writer.beginUnbreakableBlock();
                    // update the border properties of all cells before drawing any lines
                    prepareCellBorders(this.tableNode.table.body);
                    this.drawHorizontalLine(0, writer);
                    function getTableInnerContentWidth() {
                        var width = 0;
                        tableNode.table.widths.forEach(function(w) {
                            width += w._calcWidth;
                        });
                        return width;
                    }
                    function prepareRowSpanData() {
                        var rsd = [];
                        var x = 0;
                        var lastWidth = 0;
                        rsd.push({
                            left: 0,
                            rowSpan: 0
                        });
                        for(var i = 0, l = self1.tableNode.table.body[0].length; i < l; i++){
                            var paddings = self1.layout.paddingLeft(i, self1.tableNode) + self1.layout.paddingRight(i, self1.tableNode);
                            var lBorder = self1.layout.vLineWidth(i, self1.tableNode);
                            lastWidth = paddings + lBorder + self1.tableNode.table.widths[i]._calcWidth;
                            rsd[rsd.length - 1].width = lastWidth;
                            x += lastWidth;
                            rsd.push({
                                left: x,
                                rowSpan: 0,
                                width: 0
                            });
                        }
                        return rsd;
                    }
                    // Iterate through all cells. If the current cell is the start of a
                    // rowSpan/colSpan, update the border property of the cells on its
                    // bottom/right accordingly. This is needed since each iteration of the
                    // line-drawing loops draws lines for a single cell, not for an entire
                    // rowSpan/colSpan.
                    function prepareCellBorders(body) {
                        for(var rowIndex = 0; rowIndex < body.length; rowIndex++){
                            var row = body[rowIndex];
                            for(var colIndex = 0; colIndex < row.length; colIndex++){
                                var cell = row[colIndex];
                                if (cell.border) {
                                    var rowSpan = cell.rowSpan || 1;
                                    var colSpan = cell.colSpan || 1;
                                    for(var rowOffset = 0; rowOffset < rowSpan; rowOffset++){
                                        // set left border
                                        if (cell.border[0] !== undefined && rowOffset > 0) setBorder(rowIndex + rowOffset, colIndex, 0, cell.border[0]);
                                        // set right border
                                        if (cell.border[2] !== undefined) setBorder(rowIndex + rowOffset, colIndex + colSpan - 1, 2, cell.border[2]);
                                    }
                                    for(var colOffset = 0; colOffset < colSpan; colOffset++){
                                        // set top border
                                        if (cell.border[1] !== undefined && colOffset > 0) setBorder(rowIndex, colIndex + colOffset, 1, cell.border[1]);
                                        // set bottom border
                                        if (cell.border[3] !== undefined) setBorder(rowIndex + rowSpan - 1, colIndex + colOffset, 3, cell.border[3]);
                                    }
                                }
                            }
                        }
                        // helper function to set the border for a given cell
                        function setBorder(rowIndex, colIndex, borderIndex, borderValue) {
                            var cell = body[rowIndex][colIndex];
                            cell.border = cell.border || {};
                            cell.border[borderIndex] = borderValue;
                        }
                    }
                };
                TableProcessor.prototype.onRowBreak = function(rowIndex, writer) {
                    var self1 = this;
                    return function() {
                        var offset = self1.rowPaddingTop + (!self1.headerRows ? self1.topLineWidth : 0);
                        writer.context().availableHeight -= self1.reservedAtBottom;
                        writer.context().moveDown(offset);
                    };
                };
                TableProcessor.prototype.beginRow = function(rowIndex, writer) {
                    this.topLineWidth = this.layout.hLineWidth(rowIndex, this.tableNode);
                    this.rowPaddingTop = this.layout.paddingTop(rowIndex, this.tableNode);
                    this.bottomLineWidth = this.layout.hLineWidth(rowIndex + 1, this.tableNode);
                    this.rowPaddingBottom = this.layout.paddingBottom(rowIndex, this.tableNode);
                    this.rowCallback = this.onRowBreak(rowIndex, writer);
                    writer.tracker.startTracking("pageChanged", this.rowCallback);
                    if (this.dontBreakRows) writer.beginUnbreakableBlock();
                    this.rowTopY = writer.context().y;
                    this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom;
                    writer.context().availableHeight -= this.reservedAtBottom;
                    writer.context().moveDown(this.rowPaddingTop);
                };
                TableProcessor.prototype.drawHorizontalLine = function(lineIndex, writer, overrideY) {
                    var lineWidth = this.layout.hLineWidth(lineIndex, this.tableNode);
                    if (lineWidth) {
                        var style = this.layout.hLineStyle(lineIndex, this.tableNode);
                        var dash;
                        if (style && style.dash) dash = style.dash;
                        var offset = lineWidth / 2;
                        var currentLine = null;
                        var body = this.tableNode.table.body;
                        var cellAbove;
                        var currentCell;
                        var rowCellAbove;
                        for(var i = 0, l = this.rowSpanData.length; i < l; i++){
                            var data = this.rowSpanData[i];
                            var shouldDrawLine = !data.rowSpan;
                            var borderColor = null;
                            // draw only if the current cell requires a top border or the cell in the
                            // row above requires a bottom border
                            if (shouldDrawLine && i < l - 1) {
                                var topBorder = false, bottomBorder = false, rowBottomBorder = false;
                                // the cell in the row above
                                if (lineIndex > 0) {
                                    cellAbove = body[lineIndex - 1][i];
                                    bottomBorder = cellAbove.border ? cellAbove.border[3] : this.layout.defaultBorder;
                                    if (bottomBorder && cellAbove.borderColor) borderColor = cellAbove.borderColor[3];
                                }
                                // the current cell
                                if (lineIndex < body.length) {
                                    currentCell = body[lineIndex][i];
                                    topBorder = currentCell.border ? currentCell.border[1] : this.layout.defaultBorder;
                                    if (topBorder && borderColor == null && currentCell.borderColor) borderColor = currentCell.borderColor[1];
                                }
                                shouldDrawLine = topBorder || bottomBorder;
                            }
                            if (cellAbove && cellAbove._rowSpanCurrentOffset) {
                                rowCellAbove = body[lineIndex - 1 - cellAbove._rowSpanCurrentOffset][i];
                                rowBottomBorder = rowCellAbove && rowCellAbove.border ? rowCellAbove.border[3] : this.layout.defaultBorder;
                                if (rowBottomBorder && rowCellAbove && rowCellAbove.borderColor) borderColor = rowCellAbove.borderColor[3];
                            }
                            if (borderColor == null) borderColor = isFunction(this.layout.hLineColor) ? this.layout.hLineColor(lineIndex, this.tableNode, i) : this.layout.hLineColor;
                            if (!currentLine && shouldDrawLine) currentLine = {
                                left: data.left,
                                width: 0
                            };
                            if (shouldDrawLine) {
                                var colSpanIndex = 0;
                                if (rowCellAbove && rowCellAbove.colSpan && rowBottomBorder) {
                                    while(rowCellAbove.colSpan > colSpanIndex)currentLine.width += this.rowSpanData[i + colSpanIndex++].width || 0;
                                    i += colSpanIndex - 1;
                                } else if (cellAbove && cellAbove.colSpan && bottomBorder) {
                                    while(cellAbove.colSpan > colSpanIndex)currentLine.width += this.rowSpanData[i + colSpanIndex++].width || 0;
                                    i += colSpanIndex - 1;
                                } else if (currentCell && currentCell.colSpan && topBorder) {
                                    while(currentCell.colSpan > colSpanIndex)currentLine.width += this.rowSpanData[i + colSpanIndex++].width || 0;
                                    i += colSpanIndex - 1;
                                } else currentLine.width += this.rowSpanData[i].width || 0;
                            }
                            var y = (overrideY || 0) + offset;
                            if (shouldDrawLine) {
                                if (currentLine && currentLine.width) {
                                    writer.addVector({
                                        type: "line",
                                        x1: currentLine.left,
                                        x2: currentLine.left + currentLine.width,
                                        y1: y,
                                        y2: y,
                                        lineWidth: lineWidth,
                                        dash: dash,
                                        lineColor: borderColor
                                    }, false, overrideY);
                                    currentLine = null;
                                    borderColor = null;
                                    cellAbove = null;
                                    currentCell = null;
                                    rowCellAbove = null;
                                }
                            }
                        }
                        writer.context().moveDown(lineWidth);
                    }
                };
                TableProcessor.prototype.drawVerticalLine = function(x, y0, y1, vLineColIndex, writer, vLineRowIndex, beforeVLineColIndex) {
                    var width = this.layout.vLineWidth(vLineColIndex, this.tableNode);
                    if (width === 0) return;
                    var style = this.layout.vLineStyle(vLineColIndex, this.tableNode);
                    var dash;
                    if (style && style.dash) dash = style.dash;
                    var body = this.tableNode.table.body;
                    var cellBefore;
                    var currentCell;
                    var borderColor;
                    // the cell in the col before
                    if (vLineColIndex > 0) {
                        cellBefore = body[vLineRowIndex][beforeVLineColIndex];
                        if (cellBefore && cellBefore.borderColor) {
                            if (cellBefore.border ? cellBefore.border[2] : this.layout.defaultBorder) borderColor = cellBefore.borderColor[2];
                        }
                    }
                    // the current cell
                    if (borderColor == null && vLineColIndex < body.length) {
                        currentCell = body[vLineRowIndex][vLineColIndex];
                        if (currentCell && currentCell.borderColor) {
                            if (currentCell.border ? currentCell.border[0] : this.layout.defaultBorder) borderColor = currentCell.borderColor[0];
                        }
                    }
                    if (borderColor == null && cellBefore && cellBefore._rowSpanCurrentOffset) {
                        var rowCellBeforeAbove = body[vLineRowIndex - cellBefore._rowSpanCurrentOffset][beforeVLineColIndex];
                        if (rowCellBeforeAbove.borderColor) {
                            if (rowCellBeforeAbove.border ? rowCellBeforeAbove.border[2] : this.layout.defaultBorder) borderColor = rowCellBeforeAbove.borderColor[2];
                        }
                    }
                    if (borderColor == null && currentCell && currentCell._rowSpanCurrentOffset) {
                        var rowCurrentCellAbove = body[vLineRowIndex - currentCell._rowSpanCurrentOffset][vLineColIndex];
                        if (rowCurrentCellAbove.borderColor) {
                            if (rowCurrentCellAbove.border ? rowCurrentCellAbove.border[2] : this.layout.defaultBorder) borderColor = rowCurrentCellAbove.borderColor[2];
                        }
                    }
                    if (borderColor == null) borderColor = isFunction(this.layout.vLineColor) ? this.layout.vLineColor(vLineColIndex, this.tableNode, vLineRowIndex) : this.layout.vLineColor;
                    writer.addVector({
                        type: "line",
                        x1: x + width / 2,
                        x2: x + width / 2,
                        y1: y0,
                        y2: y1,
                        lineWidth: width,
                        dash: dash,
                        lineColor: borderColor
                    }, false, true);
                    cellBefore = null;
                    currentCell = null;
                    borderColor = null;
                };
                TableProcessor.prototype.endTable = function(writer) {
                    if (this.cleanUpRepeatables) writer.popFromRepeatables();
                };
                TableProcessor.prototype.endRow = function(rowIndex, writer, pageBreaks) {
                    var l, i;
                    var self1 = this;
                    writer.tracker.stopTracking("pageChanged", this.rowCallback);
                    writer.context().moveDown(this.layout.paddingBottom(rowIndex, this.tableNode));
                    writer.context().availableHeight += this.reservedAtBottom;
                    var endingPage = writer.context().page;
                    var endingY = writer.context().y;
                    var xs = getLineXs();
                    var ys = [];
                    var hasBreaks = pageBreaks && pageBreaks.length > 0;
                    var body = this.tableNode.table.body;
                    ys.push({
                        y0: this.rowTopY,
                        page: hasBreaks ? pageBreaks[0].prevPage : endingPage
                    });
                    if (hasBreaks) for(i = 0, l = pageBreaks.length; i < l; i++){
                        var pageBreak = pageBreaks[i];
                        ys[ys.length - 1].y1 = pageBreak.prevY;
                        ys.push({
                            y0: pageBreak.y,
                            page: pageBreak.prevPage + 1
                        });
                    }
                    ys[ys.length - 1].y1 = endingY;
                    var skipOrphanePadding = ys[0].y1 - ys[0].y0 === this.rowPaddingTop;
                    for(var yi = skipOrphanePadding ? 1 : 0, yl = ys.length; yi < yl; yi++){
                        var willBreak = yi < ys.length - 1;
                        var rowBreakWithoutHeader = yi > 0 && !this.headerRows;
                        var hzLineOffset = rowBreakWithoutHeader ? 0 : this.topLineWidth;
                        var y1 = ys[yi].y0;
                        var y2 = ys[yi].y1;
                        if (willBreak) y2 = y2 + this.rowPaddingBottom;
                        if (writer.context().page != ys[yi].page) {
                            writer.context().page = ys[yi].page;
                            //TODO: buggy, availableHeight should be updated on every pageChanged event
                            // TableProcessor should be pageChanged listener, instead of processRow
                            this.reservedAtBottom = 0;
                        }
                        for(i = 0, l = xs.length; i < l; i++){
                            var leftCellBorder = false;
                            var rightCellBorder = false;
                            var colIndex = xs[i].index;
                            // current cell
                            if (colIndex < body[rowIndex].length) {
                                var cell = body[rowIndex][colIndex];
                                leftCellBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
                                rightCellBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
                            }
                            // before cell
                            if (colIndex > 0 && !leftCellBorder) {
                                var cell = body[rowIndex][colIndex - 1];
                                leftCellBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
                            }
                            // after cell
                            if (colIndex + 1 < body[rowIndex].length && !rightCellBorder) {
                                var cell = body[rowIndex][colIndex + 1];
                                rightCellBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
                            }
                            if (leftCellBorder) this.drawVerticalLine(xs[i].x, y1 - hzLineOffset, y2 + this.bottomLineWidth, xs[i].index, writer, rowIndex, xs[i - 1] ? xs[i - 1].index : null);
                            if (i < l - 1) {
                                var fillColor = body[rowIndex][colIndex].fillColor;
                                var fillOpacity = body[rowIndex][colIndex].fillOpacity;
                                if (!fillColor) fillColor = isFunction(this.layout.fillColor) ? this.layout.fillColor(rowIndex, this.tableNode, colIndex) : this.layout.fillColor;
                                if (!isNumber(fillOpacity)) fillOpacity = isFunction(this.layout.fillOpacity) ? this.layout.fillOpacity(rowIndex, this.tableNode, colIndex) : this.layout.fillOpacity;
                                var overlayPattern = body[rowIndex][colIndex].overlayPattern;
                                var overlayOpacity = body[rowIndex][colIndex].overlayOpacity;
                                if (fillColor || overlayPattern) {
                                    var widthLeftBorder = leftCellBorder ? this.layout.vLineWidth(colIndex, this.tableNode) : 0;
                                    var widthRightBorder;
                                    if ((colIndex === 0 || colIndex + 1 == body[rowIndex].length) && !rightCellBorder) widthRightBorder = this.layout.vLineWidth(colIndex + 1, this.tableNode);
                                    else if (rightCellBorder) widthRightBorder = this.layout.vLineWidth(colIndex + 1, this.tableNode) / 2;
                                    else widthRightBorder = 0;
                                    var x1f = this.dontBreakRows ? xs[i].x + widthLeftBorder : xs[i].x + widthLeftBorder / 2;
                                    var y1f = this.dontBreakRows ? y1 : y1 - hzLineOffset / 2;
                                    var x2f = xs[i + 1].x + widthRightBorder;
                                    var y2f = this.dontBreakRows ? y2 + this.bottomLineWidth : y2 + this.bottomLineWidth / 2;
                                    var bgWidth = x2f - x1f;
                                    var bgHeight = y2f - y1f;
                                    if (fillColor) writer.addVector({
                                        type: "rect",
                                        x: x1f,
                                        y: y1f,
                                        w: bgWidth,
                                        h: bgHeight,
                                        lineWidth: 0,
                                        color: fillColor,
                                        fillOpacity: fillOpacity
                                    }, false, true, writer.context().backgroundLength[writer.context().page]);
                                    if (overlayPattern) writer.addVector({
                                        type: "rect",
                                        x: x1f,
                                        y: y1f,
                                        w: bgWidth,
                                        h: bgHeight,
                                        lineWidth: 0,
                                        color: overlayPattern,
                                        fillOpacity: overlayOpacity
                                    }, false, true);
                                }
                            }
                        }
                        if (willBreak && this.layout.hLineWhenBroken !== false) this.drawHorizontalLine(rowIndex + 1, writer, y2);
                        if (rowBreakWithoutHeader && this.layout.hLineWhenBroken !== false) this.drawHorizontalLine(rowIndex, writer, y1);
                    }
                    writer.context().page = endingPage;
                    writer.context().y = endingY;
                    var row = this.tableNode.table.body[rowIndex];
                    for(i = 0, l = row.length; i < l; i++){
                        if (row[i].rowSpan) {
                            this.rowSpanData[i].rowSpan = row[i].rowSpan;
                            // fix colSpans
                            if (row[i].colSpan && row[i].colSpan > 1) for(var j = 1; j < row[i].rowSpan; j++)this.tableNode.table.body[rowIndex + j][i]._colSpan = row[i].colSpan;
                            // fix rowSpans
                            if (row[i].rowSpan && row[i].rowSpan > 1) for(var j = 1; j < row[i].rowSpan; j++)this.tableNode.table.body[rowIndex + j][i]._rowSpanCurrentOffset = j;
                        }
                        if (this.rowSpanData[i].rowSpan > 0) this.rowSpanData[i].rowSpan--;
                    }
                    this.drawHorizontalLine(rowIndex + 1, writer);
                    if (this.headerRows && rowIndex === this.headerRows - 1) this.headerRepeatable = writer.currentBlockToRepeatable();
                    if (this.dontBreakRows) writer.tracker.auto("pageChanged", function() {
                        if (!self1.headerRows && self1.layout.hLineWhenBroken !== false) self1.drawHorizontalLine(rowIndex, writer);
                    }, function() {
                        writer.commitUnbreakableBlock();
                    });
                    if (this.headerRepeatable && (rowIndex === this.rowsWithoutPageBreak - 1 || rowIndex === this.tableNode.table.body.length - 1)) {
                        writer.commitUnbreakableBlock();
                        writer.pushToRepeatables(this.headerRepeatable);
                        this.cleanUpRepeatables = true;
                        this.headerRepeatable = null;
                    }
                    function getLineXs() {
                        var result = [];
                        var cols = 0;
                        for(var i = 0, l = self1.tableNode.table.body[rowIndex].length; i < l; i++){
                            if (!cols) {
                                result.push({
                                    x: self1.rowSpanData[i].left,
                                    index: i
                                });
                                var item = self1.tableNode.table.body[rowIndex][i];
                                cols = item._colSpan || item.colSpan || 0;
                            }
                            if (cols > 0) cols--;
                        }
                        result.push({
                            x: self1.rowSpanData[self1.rowSpanData.length - 1].left,
                            index: self1.rowSpanData.length - 1
                        });
                        return result;
                    }
                };
                module1.exports = TableProcessor;
            /***/ },
            /***/ 4986: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isArray = __webpack_require__(16920).isArray;
                var isPattern = __webpack_require__(16920).isPattern;
                var getPattern = __webpack_require__(16920).getPattern;
                function groupDecorations(line) {
                    var groups = [], currentGroup = null;
                    for(var i = 0, l = line.inlines.length; i < l; i++){
                        var inline = line.inlines[i];
                        var decoration = inline.decoration;
                        if (!decoration) {
                            currentGroup = null;
                            continue;
                        }
                        if (!isArray(decoration)) decoration = [
                            decoration
                        ];
                        var color = inline.decorationColor || inline.color || "black";
                        var style = inline.decorationStyle || "solid";
                        for(var ii = 0, ll = decoration.length; ii < ll; ii++){
                            var decorationItem = decoration[ii];
                            if (!currentGroup || decorationItem !== currentGroup.decoration || style !== currentGroup.decorationStyle || color !== currentGroup.decorationColor) {
                                currentGroup = {
                                    line: line,
                                    decoration: decorationItem,
                                    decorationColor: color,
                                    decorationStyle: style,
                                    inlines: [
                                        inline
                                    ]
                                };
                                groups.push(currentGroup);
                            } else currentGroup.inlines.push(inline);
                        }
                    }
                    return groups;
                }
                function drawDecoration(group, x, y, pdfKitDoc) {
                    function maxInline() {
                        var max = 0;
                        for(var i = 0, l = group.inlines.length; i < l; i++){
                            var inline = group.inlines[i];
                            max = inline.fontSize > max ? i : max;
                        }
                        return group.inlines[max];
                    }
                    function width() {
                        var sum = 0;
                        for(var i = 0, l = group.inlines.length; i < l; i++){
                            var justifyShift = group.inlines[i].justifyShift || 0;
                            sum += group.inlines[i].width + justifyShift;
                        }
                        return sum;
                    }
                    var firstInline = group.inlines[0], biggerInline = maxInline(), totalWidth = width(), lineAscent = group.line.getAscenderHeight(), ascent = biggerInline.font.ascender / 1000 * biggerInline.fontSize, height = biggerInline.height, descent = height - ascent;
                    var lw = 0.5 + Math.floor(Math.max(biggerInline.fontSize - 8, 0) / 2) * 0.12;
                    switch(group.decoration){
                        case "underline":
                            y += lineAscent + descent * 0.45;
                            break;
                        case "overline":
                            y += lineAscent - ascent * 0.85;
                            break;
                        case "lineThrough":
                            y += lineAscent - ascent * 0.25;
                            break;
                        default:
                            throw "Unknown decoration : " + group.decoration;
                    }
                    pdfKitDoc.save();
                    if (group.decorationStyle === "double") {
                        var gap = Math.max(0.5, lw * 2);
                        pdfKitDoc.fillColor(group.decorationColor).rect(x + firstInline.x, y - lw / 2, totalWidth, lw / 2).fill().rect(x + firstInline.x, y + gap - lw / 2, totalWidth, lw / 2).fill();
                    } else if (group.decorationStyle === "dashed") {
                        var nbDashes = Math.ceil(totalWidth / 6.8);
                        var rdx = x + firstInline.x;
                        pdfKitDoc.rect(rdx, y, totalWidth, lw).clip();
                        pdfKitDoc.fillColor(group.decorationColor);
                        for(var i = 0; i < nbDashes; i++){
                            pdfKitDoc.rect(rdx, y - lw / 2, 3.96, lw).fill();
                            rdx += 6.8;
                        }
                    } else if (group.decorationStyle === "dotted") {
                        var nbDots = Math.ceil(totalWidth / (lw * 3));
                        var rx = x + firstInline.x;
                        pdfKitDoc.rect(rx, y, totalWidth, lw).clip();
                        pdfKitDoc.fillColor(group.decorationColor);
                        for(var ii = 0; ii < nbDots; ii++){
                            pdfKitDoc.rect(rx, y - lw / 2, lw, lw).fill();
                            rx += lw * 3;
                        }
                    } else if (group.decorationStyle === "wavy") {
                        var sh = 0.7, sv = 1;
                        var nbWaves = Math.ceil(totalWidth / (sh * 2)) + 1;
                        var rwx = x + firstInline.x - 1;
                        pdfKitDoc.rect(x + firstInline.x, y - sv, totalWidth, y + sv).clip();
                        pdfKitDoc.lineWidth(0.24);
                        pdfKitDoc.moveTo(rwx, y);
                        for(var iii = 0; iii < nbWaves; iii++){
                            pdfKitDoc.bezierCurveTo(rwx + sh, y - sv, rwx + sh * 2, y - sv, rwx + sh * 3, y).bezierCurveTo(rwx + sh * 4, y + sv, rwx + sh * 5, y + sv, rwx + sh * 6, y);
                            rwx += sh * 6;
                        }
                        pdfKitDoc.stroke(group.decorationColor);
                    } else pdfKitDoc.fillColor(group.decorationColor).rect(x + firstInline.x, y - lw / 2, totalWidth, lw).fill();
                    pdfKitDoc.restore();
                }
                function drawDecorations(line, x, y, pdfKitDoc) {
                    var groups = groupDecorations(line);
                    for(var i = 0, l = groups.length; i < l; i++)drawDecoration(groups[i], x, y, pdfKitDoc);
                }
                function drawBackground(line, x, y, patterns, pdfKitDoc) {
                    var height = line.getHeight();
                    for(var i = 0, l = line.inlines.length; i < l; i++){
                        var inline = line.inlines[i];
                        if (!inline.background) continue;
                        var color = inline.background;
                        if (isPattern(inline.background)) color = getPattern(inline.background, patterns);
                        var justifyShift = inline.justifyShift || 0;
                        pdfKitDoc.fillColor(color).rect(x + inline.x - justifyShift, y, inline.width + justifyShift, height).fill();
                    }
                }
                module1.exports = {
                    drawBackground: drawBackground,
                    drawDecorations: drawDecorations
                };
            /***/ },
            /***/ 28045: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isString = __webpack_require__(16920).isString;
                var isNumber = __webpack_require__(16920).isNumber;
                var isObject = __webpack_require__(16920).isObject;
                var isArray = __webpack_require__(16920).isArray;
                var isUndefined = __webpack_require__(16920).isUndefined;
                var LineBreaker = __webpack_require__(46982);
                var LEADING = /^(\s)+/g;
                var TRAILING = /(\s)+$/g;
                /**
 * Creates an instance of TextTools - text measurement utility
 *
 * @constructor
 * @param {FontProvider} fontProvider
 */ function TextTools(fontProvider) {
                    this.fontProvider = fontProvider;
                }
                /**
 * Converts an array of strings (or inline-definition-objects) into a collection
 * of inlines and calculated minWidth/maxWidth.
 * and their min/max widths
 * @param  {Object} textArray - an array of inline-definition-objects (or strings)
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   collection of inlines, minWidth, maxWidth
 */ TextTools.prototype.buildInlines = function(textArray, styleContextStack) {
                    var measured = measure(this.fontProvider, textArray, styleContextStack);
                    var minWidth = 0, maxWidth = 0, currentLineWidth;
                    measured.forEach(function(inline) {
                        minWidth = Math.max(minWidth, inline.width - inline.leadingCut - inline.trailingCut);
                        if (!currentLineWidth) currentLineWidth = {
                            width: 0,
                            leadingCut: inline.leadingCut,
                            trailingCut: 0
                        };
                        currentLineWidth.width += inline.width;
                        currentLineWidth.trailingCut = inline.trailingCut;
                        maxWidth = Math.max(maxWidth, getTrimmedWidth(currentLineWidth));
                        if (inline.lineEnd) currentLineWidth = null;
                    });
                    if (getStyleProperty({}, styleContextStack, "noWrap", false)) minWidth = maxWidth;
                    return {
                        items: measured,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    };
                    function getTrimmedWidth(item) {
                        return Math.max(0, item.width - item.leadingCut - item.trailingCut);
                    }
                };
                /**
 * Returns size of the specified string (without breaking it) using the current style
 * @param  {String} text              text to be measured
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   size of the specified string
 */ TextTools.prototype.sizeOfString = function(text, styleContextStack) {
                    text = text ? text.toString().replace(/\t/g, "    ") : "";
                    //TODO: refactor - extract from measure
                    var fontName = getStyleProperty({}, styleContextStack, "font", "Roboto");
                    var fontSize = getStyleProperty({}, styleContextStack, "fontSize", 12);
                    var fontFeatures = getStyleProperty({}, styleContextStack, "fontFeatures", null);
                    var bold = getStyleProperty({}, styleContextStack, "bold", false);
                    var italics = getStyleProperty({}, styleContextStack, "italics", false);
                    var lineHeight = getStyleProperty({}, styleContextStack, "lineHeight", 1);
                    var characterSpacing = getStyleProperty({}, styleContextStack, "characterSpacing", 0);
                    var font = this.fontProvider.provideFont(fontName, bold, italics);
                    return {
                        width: widthOfString(text, font, fontSize, characterSpacing, fontFeatures),
                        height: font.lineHeight(fontSize) * lineHeight,
                        fontSize: fontSize,
                        lineHeight: lineHeight,
                        ascender: font.ascender / 1000 * fontSize,
                        descender: font.descender / 1000 * fontSize
                    };
                };
                /**
 * Returns size of the specified rotated string (without breaking it) using the current style
 *
 * @param  {string} text text to be measured
 * @param  {number} angle
 * @param  {object} styleContextStack current style stack
 * @returns {object} size of the specified string
 */ TextTools.prototype.sizeOfRotatedText = function(text, angle, styleContextStack) {
                    var angleRad = angle * Math.PI / -180;
                    var size = this.sizeOfString(text, styleContextStack);
                    return {
                        width: Math.abs(size.height * Math.sin(angleRad)) + Math.abs(size.width * Math.cos(angleRad)),
                        height: Math.abs(size.width * Math.sin(angleRad)) + Math.abs(size.height * Math.cos(angleRad))
                    };
                };
                TextTools.prototype.widthOfString = function(text, font, fontSize, characterSpacing, fontFeatures) {
                    return widthOfString(text, font, fontSize, characterSpacing, fontFeatures);
                };
                function splitWords(text, noWrap) {
                    var results = [];
                    text = text.replace(/\t/g, "    ");
                    if (noWrap) {
                        results.push({
                            text: text
                        });
                        return results;
                    }
                    var breaker = new LineBreaker(text);
                    var last = 0;
                    var bk;
                    while(bk = breaker.nextBreak()){
                        var word = text.slice(last, bk.position);
                        if (bk.required || word.match(/\r?\n$|\r$/)) {
                            word = word.replace(/\r?\n$|\r$/, "");
                            results.push({
                                text: word,
                                lineEnd: true
                            });
                        } else results.push({
                            text: word
                        });
                        last = bk.position;
                    }
                    return results;
                }
                function copyStyle(source, destination) {
                    destination = destination || {};
                    source = source || {}; //TODO: default style
                    for(var key in source)if (key != "text" && source.hasOwnProperty(key)) destination[key] = source[key];
                    return destination;
                }
                function normalizeTextArray(array, styleContextStack) {
                    function flatten(array) {
                        return array.reduce(function(prev, cur) {
                            var current = isArray(cur.text) ? flatten(cur.text) : cur;
                            var more = [].concat(current).some(Array.isArray);
                            return prev.concat(more ? flatten(current) : current);
                        }, []);
                    }
                    function getOneWord(index, words, noWrap) {
                        if (isUndefined(words[index])) return null;
                        if (words[index].lineEnd) return null;
                        var word = words[index].text;
                        if (noWrap) {
                            var tmpWords = splitWords(normalizeString(word), false);
                            if (isUndefined(tmpWords[tmpWords.length - 1])) return null;
                            word = tmpWords[tmpWords.length - 1].text;
                        }
                        return word;
                    }
                    var results = [];
                    if (!isArray(array)) array = [
                        array
                    ];
                    array = flatten(array);
                    var lastWord = null;
                    for(var i = 0, l = array.length; i < l; i++){
                        var item = array[i];
                        var style = null;
                        var words;
                        var noWrap = getStyleProperty(item || {}, styleContextStack, "noWrap", false);
                        if (isObject(item)) {
                            if (item._textRef && item._textRef._textNodeRef.text) item.text = item._textRef._textNodeRef.text;
                            words = splitWords(normalizeString(item.text), noWrap);
                            style = copyStyle(item);
                        } else words = splitWords(normalizeString(item), noWrap);
                        if (lastWord && words.length) {
                            var firstWord = getOneWord(0, words, noWrap);
                            var wrapWords = splitWords(normalizeString(lastWord + firstWord), false);
                            if (wrapWords.length === 1) results[results.length - 1].noNewLine = true;
                        }
                        for(var i2 = 0, l2 = words.length; i2 < l2; i2++){
                            var result = {
                                text: words[i2].text
                            };
                            if (words[i2].lineEnd) result.lineEnd = true;
                            copyStyle(style, result);
                            results.push(result);
                        }
                        lastWord = null;
                        if (i + 1 < l) lastWord = getOneWord(words.length - 1, words, noWrap);
                    }
                    return results;
                }
                function normalizeString(value) {
                    if (value === undefined || value === null) return "";
                    else if (isNumber(value)) return value.toString();
                    else if (isString(value)) return value;
                    else return value.toString();
                }
                function getStyleProperty(item, styleContextStack, property, defaultValue) {
                    var value;
                    if (item[property] !== undefined && item[property] !== null) // item defines this property
                    return item[property];
                    if (!styleContextStack) return defaultValue;
                    styleContextStack.auto(item, function() {
                        value = styleContextStack.getProperty(property);
                    });
                    if (value !== null && value !== undefined) return value;
                    else return defaultValue;
                }
                function measure(fontProvider, textArray, styleContextStack) {
                    var normalized = normalizeTextArray(textArray, styleContextStack);
                    if (normalized.length) {
                        var leadingIndent = getStyleProperty(normalized[0], styleContextStack, "leadingIndent", 0);
                        if (leadingIndent) {
                            normalized[0].leadingCut = -leadingIndent;
                            normalized[0].leadingIndent = leadingIndent;
                        }
                    }
                    normalized.forEach(function(item) {
                        var fontName = getStyleProperty(item, styleContextStack, "font", "Roboto");
                        var fontSize = getStyleProperty(item, styleContextStack, "fontSize", 12);
                        var fontFeatures = getStyleProperty(item, styleContextStack, "fontFeatures", null);
                        var bold = getStyleProperty(item, styleContextStack, "bold", false);
                        var italics = getStyleProperty(item, styleContextStack, "italics", false);
                        var color = getStyleProperty(item, styleContextStack, "color", "black");
                        var decoration = getStyleProperty(item, styleContextStack, "decoration", null);
                        var decorationColor = getStyleProperty(item, styleContextStack, "decorationColor", null);
                        var decorationStyle = getStyleProperty(item, styleContextStack, "decorationStyle", null);
                        var background = getStyleProperty(item, styleContextStack, "background", null);
                        var lineHeight = getStyleProperty(item, styleContextStack, "lineHeight", 1);
                        var characterSpacing = getStyleProperty(item, styleContextStack, "characterSpacing", 0);
                        var link = getStyleProperty(item, styleContextStack, "link", null);
                        var linkToPage = getStyleProperty(item, styleContextStack, "linkToPage", null);
                        var linkToDestination = getStyleProperty(item, styleContextStack, "linkToDestination", null);
                        var noWrap = getStyleProperty(item, styleContextStack, "noWrap", null);
                        var preserveLeadingSpaces = getStyleProperty(item, styleContextStack, "preserveLeadingSpaces", false);
                        var preserveTrailingSpaces = getStyleProperty(item, styleContextStack, "preserveTrailingSpaces", false);
                        var opacity = getStyleProperty(item, styleContextStack, "opacity", 1);
                        var sup = getStyleProperty(item, styleContextStack, "sup", false);
                        var sub = getStyleProperty(item, styleContextStack, "sub", false);
                        if ((sup || sub) && item.fontSize === undefined) // font size reduction taken from here: https://en.wikipedia.org/wiki/Subscript_and_superscript#Desktop_publishing
                        fontSize *= 0.58;
                        var font = fontProvider.provideFont(fontName, bold, italics);
                        item.width = widthOfString(item.text, font, fontSize, characterSpacing, fontFeatures);
                        item.height = font.lineHeight(fontSize) * lineHeight;
                        if (!item.leadingCut) item.leadingCut = 0;
                        var leadingSpaces;
                        if (!preserveLeadingSpaces && (leadingSpaces = item.text.match(LEADING))) item.leadingCut += widthOfString(leadingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
                        var trailingSpaces;
                        if (!preserveTrailingSpaces && (trailingSpaces = item.text.match(TRAILING))) item.trailingCut = widthOfString(trailingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
                        else item.trailingCut = 0;
                        item.alignment = getStyleProperty(item, styleContextStack, "alignment", "left");
                        item.font = font;
                        item.fontSize = fontSize;
                        item.fontFeatures = fontFeatures;
                        item.characterSpacing = characterSpacing;
                        item.color = color;
                        item.decoration = decoration;
                        item.decorationColor = decorationColor;
                        item.decorationStyle = decorationStyle;
                        item.background = background;
                        item.link = link;
                        item.linkToPage = linkToPage;
                        item.linkToDestination = linkToDestination;
                        item.noWrap = noWrap;
                        item.opacity = opacity;
                        item.sup = sup;
                        item.sub = sub;
                    });
                    return normalized;
                }
                function widthOfString(text, font, fontSize, characterSpacing, fontFeatures) {
                    return font.widthOfString(text, fontSize, fontFeatures) + (characterSpacing || 0) * (text.length - 1);
                }
                module1.exports = TextTools;
            /***/ },
            /***/ 73602: /***/ function(module1) {
                "use strict";
                function TraversalTracker() {
                    this.events = {};
                }
                TraversalTracker.prototype.startTracking = function(event, callback) {
                    var callbacks = this.events[event] || (this.events[event] = []);
                    if (callbacks.indexOf(callback) < 0) callbacks.push(callback);
                };
                TraversalTracker.prototype.stopTracking = function(event, callback) {
                    var callbacks = this.events[event];
                    if (!callbacks) return;
                    var index = callbacks.indexOf(callback);
                    if (index >= 0) callbacks.splice(index, 1);
                };
                TraversalTracker.prototype.emit = function(event) {
                    var args = Array.prototype.slice.call(arguments, 1);
                    var callbacks = this.events[event];
                    if (!callbacks) return;
                    callbacks.forEach(function(callback) {
                        callback.apply(this, args);
                    });
                };
                TraversalTracker.prototype.auto = function(event, callback, innerFunction) {
                    this.startTracking(event, callback);
                    innerFunction();
                    this.stopTracking(event, callback);
                };
                module1.exports = TraversalTracker;
            /***/ },
            /***/ 70457: /***/ function(module1, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
                (function(a, b) {
                    __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = b, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this, function() {
                    "use strict";
                    function b(a, b) {
                        return "undefined" == typeof b ? b = {
                            autoBom: !1
                        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
                            autoBom: !b
                        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
                            "\uFEFF",
                            a
                        ], {
                            type: a.type
                        }) : a;
                    }
                    function c(a, b, c) {
                        var d = new XMLHttpRequest;
                        d.open("GET", a), d.responseType = "blob", d.onload = function() {
                            g(d.response, b, c);
                        }, d.onerror = function() {
                            console.error("could not download file");
                        }, d.send();
                    }
                    function d(a) {
                        var b = new XMLHttpRequest;
                        b.open("HEAD", a, !1);
                        try {
                            b.send();
                        } catch (a) {}
                        return 200 <= b.status && 299 >= b.status;
                    }
                    function e(a) {
                        try {
                            a.dispatchEvent(new MouseEvent("click"));
                        } catch (c) {
                            var b = document.createEvent("MouseEvents");
                            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
                        }
                    }
                    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof __webpack_require__.g && __webpack_require__.g.global === __webpack_require__.g ? __webpack_require__.g : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
                        var i = f.URL || f.webkitURL, j = document.createElement("a");
                        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
                            i.revokeObjectURL(j.href);
                        }, 4E4), setTimeout(function() {
                            e(j);
                        }, 0));
                    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
                        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
                        else if (d(f)) c(f, g, h);
                        else {
                            var i = document.createElement("a");
                            i.href = f, i.target = "_blank", setTimeout(function() {
                                e(i);
                            });
                        }
                    } : function(b, d, e, g) {
                        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
                        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
                        if ((j || h && i || a) && "undefined" != typeof FileReader) {
                            var k = new FileReader;
                            k.onloadend = function() {
                                var a = k.result;
                                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
                            }, k.readAsDataURL(b);
                        } else {
                            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
                            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                                l.revokeObjectURL(m);
                            }, 4E4);
                        }
                    });
                    f.saveAs = g.saveAs = g, module1.exports = g;
                });
            /***/ },
            /***/ 89233: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(43060)["Buffer"];
                __webpack_require__(26364);
                __webpack_require__(86632);
                __webpack_require__(61928);
                __webpack_require__(16543);
                __webpack_require__(33142);
                __webpack_require__(10853);
                __webpack_require__(6208);
                __webpack_require__(80044);
                __webpack_require__(18821);
                __webpack_require__(54883);
                __webpack_require__(30644);
                __webpack_require__(45007);
                __webpack_require__(68995);
                __webpack_require__(55862);
                __webpack_require__(80174);
                __webpack_require__(73214);
                __webpack_require__(15158);
                __webpack_require__(54994);
                __webpack_require__(33130);
                __webpack_require__(66923);
                __webpack_require__(35054);
                __webpack_require__(80238);
                __webpack_require__(99041);
                __webpack_require__(45550);
                __webpack_require__(84750);
                __webpack_require__(55281);
                __webpack_require__(39275);
                __webpack_require__(75668);
                __webpack_require__(4845);
                __webpack_require__(85005);
                __webpack_require__(63815);
                __webpack_require__(83382);
                __webpack_require__(27013);
                __webpack_require__(51360);
                __webpack_require__(21358);
                __webpack_require__(66887);
                __webpack_require__(77353);
                __webpack_require__(6366);
                __webpack_require__(52372);
                __webpack_require__(65056);
                __webpack_require__(53677);
                __webpack_require__(77355);
                __webpack_require__(28784);
                __webpack_require__(98554);
                __webpack_require__(72403);
                __webpack_require__(14312);
                __webpack_require__(63444);
                __webpack_require__(40070);
                __webpack_require__(36798);
                __webpack_require__(58036);
                __webpack_require__(27578);
                __webpack_require__(99641);
                __webpack_require__(12298);
                __webpack_require__(97306);
                __webpack_require__(25480);
                __webpack_require__(14314);
                __webpack_require__(10572);
                __webpack_require__(100);
                __webpack_require__(33290);
                __webpack_require__(29897);
                var _;
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == typeof i ? i : String(i);
                }
                function _toPrimitive(t, r) {
                    if ("object" != typeof t || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createForOfIteratorHelperLoose(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (it) return (it = it.call(o)).next.bind(it);
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        return function() {
                            if (i >= o.length) return {
                                done: true
                            };
                            return {
                                done: false,
                                value: o[i++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _interopDefault(ex) {
                    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
                }
                var r = _interopDefault(__webpack_require__(27398));
                var utils = __webpack_require__(76959);
                var isEqual = _interopDefault(__webpack_require__(27074));
                var unicode = _interopDefault(__webpack_require__(51348));
                var UnicodeTrie = _interopDefault(__webpack_require__(67827));
                var StateMachine = _interopDefault(__webpack_require__(41966));
                var cloneDeep = _interopDefault(__webpack_require__(72986));
                var inflate = _interopDefault(__webpack_require__(84346));
                var brotli = _interopDefault(__webpack_require__(49435));
                var fs = __webpack_require__(52773);
                var fontkit = {};
                fontkit.logErrors = false;
                var formats = [];
                fontkit.registerFormat = function(format) {
                    formats.push(format);
                };
                fontkit.openSync = function(filename, postscriptName) {
                    var buffer = fs.readFileSync(filename);
                    return fontkit.create(buffer, postscriptName);
                };
                fontkit.open = function(filename, postscriptName, callback) {
                    if (typeof postscriptName === "function") {
                        callback = postscriptName;
                        postscriptName = null;
                    }
                    fs.readFile(filename, function(err, buffer) {
                        if (err) return callback(err);
                        try {
                            var font = fontkit.create(buffer, postscriptName);
                        } catch (e) {
                            return callback(e);
                        }
                        return callback(null, font);
                    });
                    return;
                };
                fontkit.create = function(buffer, postscriptName) {
                    for(var i = 0; i < formats.length; i++){
                        var format = formats[i];
                        if (format.probe(buffer)) {
                            var font = new format(new r.DecodeStream(buffer));
                            if (postscriptName) return font.getFont(postscriptName);
                            return font;
                        }
                    }
                    throw new Error("Unknown font format");
                };
                fontkit.defaultLanguage = "en";
                fontkit.setDefaultLanguage = function(lang) {
                    if (lang === void 0) lang = "en";
                    fontkit.defaultLanguage = lang;
                };
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
                    var desc = {};
                    Object.keys(descriptor).forEach(function(key) {
                        desc[key] = descriptor[key];
                    });
                    desc.enumerable = !!desc.enumerable;
                    desc.configurable = !!desc.configurable;
                    if ("value" in desc || desc.initializer) desc.writable = true;
                    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
                        return decorator(target, property, desc) || desc;
                    }, desc);
                    if (context && desc.initializer !== void 0) {
                        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                        desc.initializer = undefined;
                    }
                    if (desc.initializer === void 0) {
                        Object.defineProperty(target, property, desc);
                        desc = null;
                    }
                    return desc;
                }
                /**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function cache(target, key, descriptor) {
                    if (descriptor.get) {
                        var get = descriptor.get;
                        descriptor.get = function() {
                            var value = get.call(this);
                            Object.defineProperty(this, key, {
                                value: value
                            });
                            return value;
                        };
                    } else if (typeof descriptor.value === "function") {
                        var fn = descriptor.value;
                        return {
                            get: function get() {
                                var cache = new Map();
                                function memoized() {
                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                    var key = args.length > 0 ? args[0] : "value";
                                    if (cache.has(key)) return cache.get(key);
                                    var result = fn.apply(this, args);
                                    cache.set(key, result);
                                    return result;
                                }
                                Object.defineProperty(this, key, {
                                    value: memoized
                                });
                                return memoized;
                            }
                        };
                    }
                }
                var SubHeader = new r.Struct({
                    firstCode: r.uint16,
                    entryCount: r.uint16,
                    idDelta: r.int16,
                    idRangeOffset: r.uint16
                });
                var CmapGroup = new r.Struct({
                    startCharCode: r.uint32,
                    endCharCode: r.uint32,
                    glyphID: r.uint32
                });
                var UnicodeValueRange = new r.Struct({
                    startUnicodeValue: r.uint24,
                    additionalCount: r.uint8
                });
                var UVSMapping = new r.Struct({
                    unicodeValue: r.uint24,
                    glyphID: r.uint16
                });
                var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
                var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);
                var VarSelectorRecord = new r.Struct({
                    varSelector: r.uint24,
                    defaultUVS: new r.Pointer(r.uint32, DefaultUVS, {
                        type: "parent"
                    }),
                    nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, {
                        type: "parent"
                    })
                });
                var CmapSubtable = new r.VersionedStruct(r.uint16, {
                    0: {
                        // Byte encoding
                        length: r.uint16,
                        // Total table length in bytes (set to 262 for format 0)
                        language: r.uint16,
                        // Language code for this encoding subtable, or zero if language-independent
                        codeMap: new r.LazyArray(r.uint8, 256)
                    },
                    2: {
                        // High-byte mapping (CJK)
                        length: r.uint16,
                        language: r.uint16,
                        subHeaderKeys: new r.Array(r.uint16, 256),
                        subHeaderCount: function subHeaderCount(t) {
                            return Math.max.apply(Math, t.subHeaderKeys);
                        },
                        subHeaders: new r.LazyArray(SubHeader, "subHeaderCount"),
                        glyphIndexArray: new r.LazyArray(r.uint16, "subHeaderCount")
                    },
                    4: {
                        // Segment mapping to delta values
                        length: r.uint16,
                        // Total table length in bytes
                        language: r.uint16,
                        // Language code
                        segCountX2: r.uint16,
                        segCount: function segCount(t) {
                            return t.segCountX2 >> 1;
                        },
                        searchRange: r.uint16,
                        entrySelector: r.uint16,
                        rangeShift: r.uint16,
                        endCode: new r.LazyArray(r.uint16, "segCount"),
                        reservedPad: new r.Reserved(r.uint16),
                        // This value should be zero
                        startCode: new r.LazyArray(r.uint16, "segCount"),
                        idDelta: new r.LazyArray(r.int16, "segCount"),
                        idRangeOffset: new r.LazyArray(r.uint16, "segCount"),
                        glyphIndexArray: new r.LazyArray(r.uint16, function(t) {
                            return (t.length - t._currentOffset) / 2;
                        })
                    },
                    6: {
                        // Trimmed table
                        length: r.uint16,
                        language: r.uint16,
                        firstCode: r.uint16,
                        entryCount: r.uint16,
                        glyphIndices: new r.LazyArray(r.uint16, "entryCount")
                    },
                    8: {
                        // mixed 16-bit and 32-bit coverage
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint16,
                        is32: new r.LazyArray(r.uint8, 8192),
                        nGroups: r.uint32,
                        groups: new r.LazyArray(CmapGroup, "nGroups")
                    },
                    10: {
                        // Trimmed Array
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint32,
                        firstCode: r.uint32,
                        entryCount: r.uint32,
                        glyphIndices: new r.LazyArray(r.uint16, "numChars")
                    },
                    12: {
                        // Segmented coverage
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint32,
                        nGroups: r.uint32,
                        groups: new r.LazyArray(CmapGroup, "nGroups")
                    },
                    13: {
                        // Many-to-one range mappings (same as 12 except for group.startGlyphID)
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint32,
                        nGroups: r.uint32,
                        groups: new r.LazyArray(CmapGroup, "nGroups")
                    },
                    14: {
                        // Unicode Variation Sequences
                        length: r.uint32,
                        numRecords: r.uint32,
                        varSelectors: new r.LazyArray(VarSelectorRecord, "numRecords")
                    }
                });
                var CmapEntry = new r.Struct({
                    platformID: r.uint16,
                    // Platform identifier
                    encodingID: r.uint16,
                    // Platform-specific encoding identifier
                    table: new r.Pointer(r.uint32, CmapSubtable, {
                        type: "parent",
                        lazy: true
                    })
                }); // character to glyph mapping
                var cmap = new r.Struct({
                    version: r.uint16,
                    numSubtables: r.uint16,
                    tables: new r.Array(CmapEntry, "numSubtables")
                });
                var head = new r.Struct({
                    version: r.int32,
                    // 0x00010000 (version 1.0)
                    revision: r.int32,
                    // set by font manufacturer
                    checkSumAdjustment: r.uint32,
                    magicNumber: r.uint32,
                    // set to 0x5F0F3CF5
                    flags: r.uint16,
                    unitsPerEm: r.uint16,
                    // range from 64 to 16384
                    created: new r.Array(r.int32, 2),
                    modified: new r.Array(r.int32, 2),
                    xMin: r.int16,
                    // for all glyph bounding boxes
                    yMin: r.int16,
                    // for all glyph bounding boxes
                    xMax: r.int16,
                    // for all glyph bounding boxes
                    yMax: r.int16,
                    // for all glyph bounding boxes
                    macStyle: new r.Bitfield(r.uint16, [
                        "bold",
                        "italic",
                        "underline",
                        "outline",
                        "shadow",
                        "condensed",
                        "extended"
                    ]),
                    lowestRecPPEM: r.uint16,
                    // smallest readable size in pixels
                    fontDirectionHint: r.int16,
                    indexToLocFormat: r.int16,
                    // 0 for short offsets, 1 for long
                    glyphDataFormat: r.int16 // 0 for current format
                });
                var hhea = new r.Struct({
                    version: r.int32,
                    ascent: r.int16,
                    // Distance from baseline of highest ascender
                    descent: r.int16,
                    // Distance from baseline of lowest descender
                    lineGap: r.int16,
                    // Typographic line gap
                    advanceWidthMax: r.uint16,
                    // Maximum advance width value in 'hmtx' table
                    minLeftSideBearing: r.int16,
                    // Maximum advance width value in 'hmtx' table
                    minRightSideBearing: r.int16,
                    // Minimum right sidebearing value
                    xMaxExtent: r.int16,
                    caretSlopeRise: r.int16,
                    // Used to calculate the slope of the cursor (rise/run); 1 for vertical
                    caretSlopeRun: r.int16,
                    // 0 for vertical
                    caretOffset: r.int16,
                    // Set to 0 for non-slanted fonts
                    reserved: new r.Reserved(r.int16, 4),
                    metricDataFormat: r.int16,
                    // 0 for current format
                    numberOfMetrics: r.uint16 // Number of advance widths in 'hmtx' table
                });
                var HmtxEntry = new r.Struct({
                    advance: r.uint16,
                    bearing: r.int16
                });
                var hmtx = new r.Struct({
                    metrics: new r.LazyArray(HmtxEntry, function(t) {
                        return t.parent.hhea.numberOfMetrics;
                    }),
                    bearings: new r.LazyArray(r.int16, function(t) {
                        return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
                    })
                });
                var maxp = new r.Struct({
                    version: r.int32,
                    numGlyphs: r.uint16,
                    // The number of glyphs in the font
                    maxPoints: r.uint16,
                    // Maximum points in a non-composite glyph
                    maxContours: r.uint16,
                    // Maximum contours in a non-composite glyph
                    maxComponentPoints: r.uint16,
                    // Maximum points in a composite glyph
                    maxComponentContours: r.uint16,
                    // Maximum contours in a composite glyph
                    maxZones: r.uint16,
                    // 1 if instructions do not use the twilight zone, 2 otherwise
                    maxTwilightPoints: r.uint16,
                    // Maximum points used in Z0
                    maxStorage: r.uint16,
                    // Number of Storage Area locations
                    maxFunctionDefs: r.uint16,
                    // Number of FDEFs
                    maxInstructionDefs: r.uint16,
                    // Number of IDEFs
                    maxStackElements: r.uint16,
                    // Maximum stack depth
                    maxSizeOfInstructions: r.uint16,
                    // Maximum byte count for glyph instructions
                    maxComponentElements: r.uint16,
                    // Maximum number of components referenced at “top level” for any composite glyph
                    maxComponentDepth: r.uint16 // Maximum levels of recursion; 1 for simple components
                });
                /**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function getEncoding(platformID, encodingID, languageID) {
                    if (languageID === void 0) languageID = 0;
                    if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) return MAC_LANGUAGE_ENCODINGS[languageID];
                    return ENCODINGS[platformID][encodingID];
                } // Map of platform ids to encoding ids.
                var ENCODINGS = [
                    // unicode
                    [
                        "utf16be",
                        "utf16be",
                        "utf16be",
                        "utf16be",
                        "utf16be",
                        "utf16be"
                    ],
                    // macintosh
                    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
                    // 0	Roman                 17	Malayalam
                    // 1	Japanese	            18	Sinhalese
                    // 2	Traditional Chinese	  19	Burmese
                    // 3	Korean	              20	Khmer
                    // 4	Arabic	              21	Thai
                    // 5	Hebrew	              22	Laotian
                    // 6	Greek	                23	Georgian
                    // 7	Russian	              24	Armenian
                    // 8	RSymbol	              25	Simplified Chinese
                    // 9	Devanagari	          26	Tibetan
                    // 10	Gurmukhi	            27	Mongolian
                    // 11	Gujarati	            28	Geez
                    // 12	Oriya	                29	Slavic
                    // 13	Bengali	              30	Vietnamese
                    // 14	Tamil	                31	Sindhi
                    // 15	Telugu	              32	(Uninterpreted)
                    // 16	Kannada
                    [
                        "macroman",
                        "shift-jis",
                        "big5",
                        "euc-kr",
                        "iso-8859-6",
                        "iso-8859-8",
                        "macgreek",
                        "maccyrillic",
                        "symbol",
                        "Devanagari",
                        "Gurmukhi",
                        "Gujarati",
                        "Oriya",
                        "Bengali",
                        "Tamil",
                        "Telugu",
                        "Kannada",
                        "Malayalam",
                        "Sinhalese",
                        "Burmese",
                        "Khmer",
                        "macthai",
                        "Laotian",
                        "Georgian",
                        "Armenian",
                        "gb-2312-80",
                        "Tibetan",
                        "Mongolian",
                        "Geez",
                        "maccenteuro",
                        "Vietnamese",
                        "Sindhi"
                    ],
                    // ISO (deprecated)
                    [
                        "ascii"
                    ],
                    // windows
                    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
                    [
                        "symbol",
                        "utf16be",
                        "shift-jis",
                        "gb18030",
                        "big5",
                        "wansung",
                        "johab",
                        null,
                        null,
                        null,
                        "utf16be"
                    ]
                ]; // Overrides for Mac scripts by language id.
                // See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
                var MAC_LANGUAGE_ENCODINGS = {
                    15: "maciceland",
                    17: "macturkish",
                    18: "maccroatian",
                    24: "maccenteuro",
                    25: "maccenteuro",
                    26: "maccenteuro",
                    27: "maccenteuro",
                    28: "maccenteuro",
                    30: "maciceland",
                    37: "macromania",
                    38: "maccenteuro",
                    39: "maccenteuro",
                    40: "maccenteuro",
                    143: "macinuit",
                    // Unsupported by iconv-lite
                    146: "macgaelic" // Unsupported by iconv-lite
                }; // Map of platform ids to BCP-47 language codes.
                var LANGUAGES = [
                    // unicode
                    [],
                    {
                        // macintosh
                        0: "en",
                        30: "fo",
                        60: "ks",
                        90: "rw",
                        1: "fr",
                        31: "fa",
                        61: "ku",
                        91: "rn",
                        2: "de",
                        32: "ru",
                        62: "sd",
                        92: "ny",
                        3: "it",
                        33: "zh",
                        63: "bo",
                        93: "mg",
                        4: "nl",
                        34: "nl-BE",
                        64: "ne",
                        94: "eo",
                        5: "sv",
                        35: "ga",
                        65: "sa",
                        128: "cy",
                        6: "es",
                        36: "sq",
                        66: "mr",
                        129: "eu",
                        7: "da",
                        37: "ro",
                        67: "bn",
                        130: "ca",
                        8: "pt",
                        38: "cz",
                        68: "as",
                        131: "la",
                        9: "no",
                        39: "sk",
                        69: "gu",
                        132: "qu",
                        10: "he",
                        40: "si",
                        70: "pa",
                        133: "gn",
                        11: "ja",
                        41: "yi",
                        71: "or",
                        134: "ay",
                        12: "ar",
                        42: "sr",
                        72: "ml",
                        135: "tt",
                        13: "fi",
                        43: "mk",
                        73: "kn",
                        136: "ug",
                        14: "el",
                        44: "bg",
                        74: "ta",
                        137: "dz",
                        15: "is",
                        45: "uk",
                        75: "te",
                        138: "jv",
                        16: "mt",
                        46: "be",
                        76: "si",
                        139: "su",
                        17: "tr",
                        47: "uz",
                        77: "my",
                        140: "gl",
                        18: "hr",
                        48: "kk",
                        78: "km",
                        141: "af",
                        19: "zh-Hant",
                        49: "az-Cyrl",
                        79: "lo",
                        142: "br",
                        20: "ur",
                        50: "az-Arab",
                        80: "vi",
                        143: "iu",
                        21: "hi",
                        51: "hy",
                        81: "id",
                        144: "gd",
                        22: "th",
                        52: "ka",
                        82: "tl",
                        145: "gv",
                        23: "ko",
                        53: "mo",
                        83: "ms",
                        146: "ga",
                        24: "lt",
                        54: "ky",
                        84: "ms-Arab",
                        147: "to",
                        25: "pl",
                        55: "tg",
                        85: "am",
                        148: "el-polyton",
                        26: "hu",
                        56: "tk",
                        86: "ti",
                        149: "kl",
                        27: "es",
                        57: "mn-CN",
                        87: "om",
                        150: "az",
                        28: "lv",
                        58: "mn",
                        88: "so",
                        151: "nn",
                        29: "se",
                        59: "ps",
                        89: "sw"
                    },
                    // ISO (deprecated)
                    [],
                    {
                        // windows                                        
                        0x0436: "af",
                        0x4009: "en-IN",
                        0x0487: "rw",
                        0x0432: "tn",
                        0x041C: "sq",
                        0x1809: "en-IE",
                        0x0441: "sw",
                        0x045B: "si",
                        0x0484: "gsw",
                        0x2009: "en-JM",
                        0x0457: "kok",
                        0x041B: "sk",
                        0x045E: "am",
                        0x4409: "en-MY",
                        0x0412: "ko",
                        0x0424: "sl",
                        0x1401: "ar-DZ",
                        0x1409: "en-NZ",
                        0x0440: "ky",
                        0x2C0A: "es-AR",
                        0x3C01: "ar-BH",
                        0x3409: "en-PH",
                        0x0454: "lo",
                        0x400A: "es-BO",
                        0x0C01: "ar",
                        0x4809: "en-SG",
                        0x0426: "lv",
                        0x340A: "es-CL",
                        0x0801: "ar-IQ",
                        0x1C09: "en-ZA",
                        0x0427: "lt",
                        0x240A: "es-CO",
                        0x2C01: "ar-JO",
                        0x2C09: "en-TT",
                        0x082E: "dsb",
                        0x140A: "es-CR",
                        0x3401: "ar-KW",
                        0x0809: "en-GB",
                        0x046E: "lb",
                        0x1C0A: "es-DO",
                        0x3001: "ar-LB",
                        0x0409: "en",
                        0x042F: "mk",
                        0x300A: "es-EC",
                        0x1001: "ar-LY",
                        0x3009: "en-ZW",
                        0x083E: "ms-BN",
                        0x440A: "es-SV",
                        0x1801: "ary",
                        0x0425: "et",
                        0x043E: "ms",
                        0x100A: "es-GT",
                        0x2001: "ar-OM",
                        0x0438: "fo",
                        0x044C: "ml",
                        0x480A: "es-HN",
                        0x4001: "ar-QA",
                        0x0464: "fil",
                        0x043A: "mt",
                        0x080A: "es-MX",
                        0x0401: "ar-SA",
                        0x040B: "fi",
                        0x0481: "mi",
                        0x4C0A: "es-NI",
                        0x2801: "ar-SY",
                        0x080C: "fr-BE",
                        0x047A: "arn",
                        0x180A: "es-PA",
                        0x1C01: "aeb",
                        0x0C0C: "fr-CA",
                        0x044E: "mr",
                        0x3C0A: "es-PY",
                        0x3801: "ar-AE",
                        0x040C: "fr",
                        0x047C: "moh",
                        0x280A: "es-PE",
                        0x2401: "ar-YE",
                        0x140C: "fr-LU",
                        0x0450: "mn",
                        0x500A: "es-PR",
                        0x042B: "hy",
                        0x180C: "fr-MC",
                        0x0850: "mn-CN",
                        0x0C0A: "es",
                        0x044D: "as",
                        0x100C: "fr-CH",
                        0x0461: "ne",
                        0x040A: "es",
                        0x082C: "az-Cyrl",
                        0x0462: "fy",
                        0x0414: "nb",
                        0x540A: "es-US",
                        0x042C: "az",
                        0x0456: "gl",
                        0x0814: "nn",
                        0x380A: "es-UY",
                        0x046D: "ba",
                        0x0437: "ka",
                        0x0482: "oc",
                        0x200A: "es-VE",
                        0x042D: "eu",
                        0x0C07: "de-AT",
                        0x0448: "or",
                        0x081D: "sv-FI",
                        0x0423: "be",
                        0x0407: "de",
                        0x0463: "ps",
                        0x041D: "sv",
                        0x0845: "bn",
                        0x1407: "de-LI",
                        0x0415: "pl",
                        0x045A: "syr",
                        0x0445: "bn-IN",
                        0x1007: "de-LU",
                        0x0416: "pt",
                        0x0428: "tg",
                        0x201A: "bs-Cyrl",
                        0x0807: "de-CH",
                        0x0816: "pt-PT",
                        0x085F: "tzm",
                        0x141A: "bs",
                        0x0408: "el",
                        0x0446: "pa",
                        0x0449: "ta",
                        0x047E: "br",
                        0x046F: "kl",
                        0x046B: "qu-BO",
                        0x0444: "tt",
                        0x0402: "bg",
                        0x0447: "gu",
                        0x086B: "qu-EC",
                        0x044A: "te",
                        0x0403: "ca",
                        0x0468: "ha",
                        0x0C6B: "qu",
                        0x041E: "th",
                        0x0C04: "zh-HK",
                        0x040D: "he",
                        0x0418: "ro",
                        0x0451: "bo",
                        0x1404: "zh-MO",
                        0x0439: "hi",
                        0x0417: "rm",
                        0x041F: "tr",
                        0x0804: "zh",
                        0x040E: "hu",
                        0x0419: "ru",
                        0x0442: "tk",
                        0x1004: "zh-SG",
                        0x040F: "is",
                        0x243B: "smn",
                        0x0480: "ug",
                        0x0404: "zh-TW",
                        0x0470: "ig",
                        0x103B: "smj-NO",
                        0x0422: "uk",
                        0x0483: "co",
                        0x0421: "id",
                        0x143B: "smj",
                        0x042E: "hsb",
                        0x041A: "hr",
                        0x045D: "iu",
                        0x0C3B: "se-FI",
                        0x0420: "ur",
                        0x101A: "hr-BA",
                        0x085D: "iu-Latn",
                        0x043B: "se",
                        0x0843: "uz-Cyrl",
                        0x0405: "cs",
                        0x083C: "ga",
                        0x083B: "se-SE",
                        0x0443: "uz",
                        0x0406: "da",
                        0x0434: "xh",
                        0x203B: "sms",
                        0x042A: "vi",
                        0x048C: "prs",
                        0x0435: "zu",
                        0x183B: "sma-NO",
                        0x0452: "cy",
                        0x0465: "dv",
                        0x0410: "it",
                        0x1C3B: "sms",
                        0x0488: "wo",
                        0x0813: "nl-BE",
                        0x0810: "it-CH",
                        0x044F: "sa",
                        0x0485: "sah",
                        0x0413: "nl",
                        0x0411: "ja",
                        0x1C1A: "sr-Cyrl-BA",
                        0x0478: "ii",
                        0x0C09: "en-AU",
                        0x044B: "kn",
                        0x0C1A: "sr",
                        0x046A: "yo",
                        0x2809: "en-BZ",
                        0x043F: "kk",
                        0x181A: "sr-Latn-BA",
                        0x1009: "en-CA",
                        0x0453: "km",
                        0x081A: "sr-Latn",
                        0x2409: "en-029",
                        0x0486: "quc",
                        0x046C: "nso"
                    }
                ];
                var NameRecord = new r.Struct({
                    platformID: r.uint16,
                    encodingID: r.uint16,
                    languageID: r.uint16,
                    nameID: r.uint16,
                    length: r.uint16,
                    string: new r.Pointer(r.uint16, new r.String("length", function(t) {
                        return getEncoding(t.platformID, t.encodingID, t.languageID);
                    }), {
                        type: "parent",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.parent.stringOffset;
                        },
                        allowNull: false
                    })
                });
                var LangTagRecord = new r.Struct({
                    length: r.uint16,
                    tag: new r.Pointer(r.uint16, new r.String("length", "utf16be"), {
                        type: "parent",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.stringOffset;
                        }
                    })
                });
                var NameTable = new r.VersionedStruct(r.uint16, {
                    0: {
                        count: r.uint16,
                        stringOffset: r.uint16,
                        records: new r.Array(NameRecord, "count")
                    },
                    1: {
                        count: r.uint16,
                        stringOffset: r.uint16,
                        records: new r.Array(NameRecord, "count"),
                        langTagCount: r.uint16,
                        langTags: new r.Array(LangTagRecord, "langTagCount")
                    }
                });
                var NAMES = [
                    "copyright",
                    "fontFamily",
                    "fontSubfamily",
                    "uniqueSubfamily",
                    "fullName",
                    "version",
                    "postscriptName",
                    // Note: A font may have only one PostScript name and that name must be ASCII.
                    "trademark",
                    "manufacturer",
                    "designer",
                    "description",
                    "vendorURL",
                    "designerURL",
                    "license",
                    "licenseURL",
                    null,
                    // reserved
                    "preferredFamily",
                    "preferredSubfamily",
                    "compatibleFull",
                    "sampleText",
                    "postscriptCIDFontName",
                    "wwsFamilyName",
                    "wwsSubfamilyName"
                ];
                NameTable.process = function(stream) {
                    var records = {};
                    for(var _iterator = _createForOfIteratorHelperLoose(this.records), _step; !(_step = _iterator()).done;){
                        var record = _step.value;
                        // find out what language this is for
                        var language = LANGUAGES[record.platformID][record.languageID];
                        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
                        if (language == null) language = record.platformID + "-" + record.languageID;
                         // if the nameID is >= 256, it is a font feature record (AAT)
                        var key = record.nameID >= 256 ? "fontFeatures" : NAMES[record.nameID] || record.nameID;
                        if (records[key] == null) records[key] = {};
                        var obj = records[key];
                        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
                        if (typeof record.string === "string" || typeof obj[language] !== "string") obj[language] = record.string;
                    }
                    this.records = records;
                };
                NameTable.preEncode = function() {
                    if (Array.isArray(this.records)) return;
                    this.version = 0;
                    var records = [];
                    for(var key in this.records){
                        var val = this.records[key];
                        if (key === "fontFeatures") continue;
                        records.push({
                            platformID: 3,
                            encodingID: 1,
                            languageID: 0x409,
                            nameID: NAMES.indexOf(key),
                            length: Buffer.byteLength(val.en, "utf16le"),
                            string: val.en
                        });
                        if (key === "postscriptName") records.push({
                            platformID: 1,
                            encodingID: 0,
                            languageID: 0,
                            nameID: NAMES.indexOf(key),
                            length: val.en.length,
                            string: val.en
                        });
                    }
                    this.records = records;
                    this.count = records.length;
                    this.stringOffset = NameTable.size(this, null, false);
                };
                var OS2 = new r.VersionedStruct(r.uint16, {
                    header: {
                        xAvgCharWidth: r.int16,
                        // average weighted advance width of lower case letters and space
                        usWeightClass: r.uint16,
                        // visual weight of stroke in glyphs
                        usWidthClass: r.uint16,
                        // relative change from the normal aspect ratio (width to height ratio)
                        fsType: new r.Bitfield(r.uint16, [
                            // Indicates font embedding licensing rights
                            null,
                            "noEmbedding",
                            "viewOnly",
                            "editable",
                            null,
                            null,
                            null,
                            null,
                            "noSubsetting",
                            "bitmapOnly"
                        ]),
                        ySubscriptXSize: r.int16,
                        // recommended horizontal size in pixels for subscripts
                        ySubscriptYSize: r.int16,
                        // recommended vertical size in pixels for subscripts
                        ySubscriptXOffset: r.int16,
                        // recommended horizontal offset for subscripts
                        ySubscriptYOffset: r.int16,
                        // recommended vertical offset form the baseline for subscripts
                        ySuperscriptXSize: r.int16,
                        // recommended horizontal size in pixels for superscripts
                        ySuperscriptYSize: r.int16,
                        // recommended vertical size in pixels for superscripts
                        ySuperscriptXOffset: r.int16,
                        // recommended horizontal offset for superscripts
                        ySuperscriptYOffset: r.int16,
                        // recommended vertical offset from the baseline for superscripts
                        yStrikeoutSize: r.int16,
                        // width of the strikeout stroke
                        yStrikeoutPosition: r.int16,
                        // position of the strikeout stroke relative to the baseline
                        sFamilyClass: r.int16,
                        // classification of font-family design
                        panose: new r.Array(r.uint8, 10),
                        // describe the visual characteristics of a given typeface
                        ulCharRange: new r.Array(r.uint32, 4),
                        vendorID: new r.String(4),
                        // four character identifier for the font vendor
                        fsSelection: new r.Bitfield(r.uint16, [
                            // bit field containing information about the font
                            "italic",
                            "underscore",
                            "negative",
                            "outlined",
                            "strikeout",
                            "bold",
                            "regular",
                            "useTypoMetrics",
                            "wws",
                            "oblique"
                        ]),
                        usFirstCharIndex: r.uint16,
                        // The minimum Unicode index in this font
                        usLastCharIndex: r.uint16 // The maximum Unicode index in this font
                    },
                    // The Apple version of this table ends here, but the Microsoft one continues on...
                    0: {},
                    1: {
                        typoAscender: r.int16,
                        typoDescender: r.int16,
                        typoLineGap: r.int16,
                        winAscent: r.uint16,
                        winDescent: r.uint16,
                        codePageRange: new r.Array(r.uint32, 2)
                    },
                    2: {
                        // these should be common with version 1 somehow
                        typoAscender: r.int16,
                        typoDescender: r.int16,
                        typoLineGap: r.int16,
                        winAscent: r.uint16,
                        winDescent: r.uint16,
                        codePageRange: new r.Array(r.uint32, 2),
                        xHeight: r.int16,
                        capHeight: r.int16,
                        defaultChar: r.uint16,
                        breakChar: r.uint16,
                        maxContent: r.uint16
                    },
                    5: {
                        typoAscender: r.int16,
                        typoDescender: r.int16,
                        typoLineGap: r.int16,
                        winAscent: r.uint16,
                        winDescent: r.uint16,
                        codePageRange: new r.Array(r.uint32, 2),
                        xHeight: r.int16,
                        capHeight: r.int16,
                        defaultChar: r.uint16,
                        breakChar: r.uint16,
                        maxContent: r.uint16,
                        usLowerOpticalPointSize: r.uint16,
                        usUpperOpticalPointSize: r.uint16
                    }
                });
                var versions = OS2.versions;
                versions[3] = versions[4] = versions[2];
                var post = new r.VersionedStruct(r.fixed32, {
                    header: {
                        // these fields exist at the top of all versions
                        italicAngle: r.fixed32,
                        // Italic angle in counter-clockwise degrees from the vertical.
                        underlinePosition: r.int16,
                        // Suggested distance of the top of the underline from the baseline
                        underlineThickness: r.int16,
                        // Suggested values for the underline thickness
                        isFixedPitch: r.uint32,
                        // Whether the font is monospaced
                        minMemType42: r.uint32,
                        // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
                        maxMemType42: r.uint32,
                        // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
                        minMemType1: r.uint32,
                        // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
                        maxMemType1: r.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
                    },
                    1: {},
                    // version 1 has no additional fields
                    2: {
                        numberOfGlyphs: r.uint16,
                        glyphNameIndex: new r.Array(r.uint16, "numberOfGlyphs"),
                        names: new r.Array(new r.String(r.uint8))
                    },
                    2.5: {
                        numberOfGlyphs: r.uint16,
                        offsets: new r.Array(r.uint8, "numberOfGlyphs")
                    },
                    3: {},
                    // version 3 has no additional fields
                    4: {
                        map: new r.Array(r.uint32, function(t) {
                            return t.parent.maxp.numGlyphs;
                        })
                    }
                });
                var cvt = new r.Struct({
                    controlValues: new r.Array(r.int16)
                });
                // These instructions are known as the font program. The main use of this table
                // is for the definition of functions that are used in many different glyph programs.
                var fpgm = new r.Struct({
                    instructions: new r.Array(r.uint8)
                });
                var loca = new r.VersionedStruct("head.indexToLocFormat", {
                    0: {
                        offsets: new r.Array(r.uint16)
                    },
                    1: {
                        offsets: new r.Array(r.uint32)
                    }
                });
                loca.process = function() {
                    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
                };
                loca.preEncode = function() {
                    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
                };
                var prep = new r.Struct({
                    controlValueProgram: new r.Array(r.uint8)
                });
                var glyf = new r.Array(new r.Buffer());
                var CFFIndex = /*#__PURE__*/ function() {
                    function CFFIndex(type) {
                        this.type = type;
                    }
                    var _proto = CFFIndex.prototype;
                    _proto.getCFFVersion = function getCFFVersion(ctx) {
                        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
                        return ctx ? ctx.version : -1;
                    };
                    _proto.decode = function decode(stream, parent) {
                        var version = this.getCFFVersion(parent);
                        var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
                        if (count === 0) return [];
                        var offSize = stream.readUInt8();
                        var offsetType;
                        if (offSize === 1) offsetType = r.uint8;
                        else if (offSize === 2) offsetType = r.uint16;
                        else if (offSize === 3) offsetType = r.uint24;
                        else if (offSize === 4) offsetType = r.uint32;
                        else throw new Error("Bad offset size in CFFIndex: ".concat(offSize, " ").concat(stream.pos));
                        var ret = [];
                        var startPos = stream.pos + (count + 1) * offSize - 1;
                        var start = offsetType.decode(stream);
                        for(var i = 0; i < count; i++){
                            var end = offsetType.decode(stream);
                            if (this.type != null) {
                                var pos = stream.pos;
                                stream.pos = startPos + start;
                                parent.length = end - start;
                                ret.push(this.type.decode(stream, parent));
                                stream.pos = pos;
                            } else ret.push({
                                offset: startPos + start,
                                length: end - start
                            });
                            start = end;
                        }
                        stream.pos = startPos + start;
                        return ret;
                    };
                    _proto.size = function size(arr, parent) {
                        var size = 2;
                        if (arr.length === 0) return size;
                        var type = this.type || new r.Buffer(); // find maximum offset to detminine offset type
                        var offset = 1;
                        for(var i = 0; i < arr.length; i++){
                            var item = arr[i];
                            offset += type.size(item, parent);
                        }
                        var offsetType;
                        if (offset <= 0xff) offsetType = r.uint8;
                        else if (offset <= 0xffff) offsetType = r.uint16;
                        else if (offset <= 0xffffff) offsetType = r.uint24;
                        else if (offset <= 0xffffffff) offsetType = r.uint32;
                        else throw new Error("Bad offset in CFFIndex");
                        size += 1 + offsetType.size() * (arr.length + 1);
                        size += offset - 1;
                        return size;
                    };
                    _proto.encode = function encode(stream, arr, parent) {
                        stream.writeUInt16BE(arr.length);
                        if (arr.length === 0) return;
                        var type = this.type || new r.Buffer(); // find maximum offset to detminine offset type
                        var sizes = [];
                        var offset = 1;
                        for(var _iterator2 = _createForOfIteratorHelperLoose(arr), _step2; !(_step2 = _iterator2()).done;){
                            var item = _step2.value;
                            var s = type.size(item, parent);
                            sizes.push(s);
                            offset += s;
                        }
                        var offsetType;
                        if (offset <= 0xff) offsetType = r.uint8;
                        else if (offset <= 0xffff) offsetType = r.uint16;
                        else if (offset <= 0xffffff) offsetType = r.uint24;
                        else if (offset <= 0xffffffff) offsetType = r.uint32;
                        else throw new Error("Bad offset in CFFIndex");
                         // write offset size
                        stream.writeUInt8(offsetType.size()); // write elements
                        offset = 1;
                        offsetType.encode(stream, offset);
                        for(var _i22 = 0, _sizes = sizes; _i22 < _sizes.length; _i22++){
                            var size = _sizes[_i22];
                            offset += size;
                            offsetType.encode(stream, offset);
                        }
                        for(var _iterator3 = _createForOfIteratorHelperLoose(arr), _step3; !(_step3 = _iterator3()).done;){
                            var _item = _step3.value;
                            type.encode(stream, _item, parent);
                        }
                        return;
                    };
                    return CFFIndex;
                }();
                var FLOAT_EOF = 0xf;
                var FLOAT_LOOKUP = [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    ".",
                    "E",
                    "E-",
                    null,
                    "-"
                ];
                var FLOAT_ENCODE_LOOKUP = {
                    ".": 10,
                    "E": 11,
                    "E-": 12,
                    "-": 14
                };
                var CFFOperand = /*#__PURE__*/ function() {
                    function CFFOperand() {}
                    CFFOperand.decode = function decode(stream, value) {
                        if (32 <= value && value <= 246) return value - 139;
                        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
                        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
                        if (value === 28) return stream.readInt16BE();
                        if (value === 29) return stream.readInt32BE();
                        if (value === 30) {
                            var str = "";
                            while(true){
                                var b = stream.readUInt8();
                                var n1 = b >> 4;
                                if (n1 === FLOAT_EOF) break;
                                str += FLOAT_LOOKUP[n1];
                                var n2 = b & 15;
                                if (n2 === FLOAT_EOF) break;
                                str += FLOAT_LOOKUP[n2];
                            }
                            return parseFloat(str);
                        }
                        return null;
                    };
                    CFFOperand.size = function size(value) {
                        // if the value needs to be forced to the largest size (32 bit)
                        // e.g. for unknown pointers, set to 32768
                        if (value.forceLarge) value = 32768;
                        if ((value | 0) !== value) {
                            // floating point
                            var str = "" + value;
                            return 1 + Math.ceil((str.length + 1) / 2);
                        } else if (-107 <= value && value <= 107) return 1;
                        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
                        else if (-32768 <= value && value <= 32767) return 3;
                        else return 5;
                    };
                    CFFOperand.encode = function encode(stream, value) {
                        // if the value needs to be forced to the largest size (32 bit)
                        // e.g. for unknown pointers, save the old value and set to 32768
                        var val = Number(value);
                        if (value.forceLarge) {
                            stream.writeUInt8(29);
                            return stream.writeInt32BE(val);
                        } else if ((val | 0) !== val) {
                            // floating point
                            stream.writeUInt8(30);
                            var str = "" + val;
                            for(var i = 0; i < str.length; i += 2){
                                var c1 = str[i];
                                var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;
                                if (i === str.length - 1) var n2 = FLOAT_EOF;
                                else {
                                    var c2 = str[i + 1];
                                    var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
                                }
                                stream.writeUInt8(n1 << 4 | n2 & 15);
                            }
                            if (n2 !== FLOAT_EOF) return stream.writeUInt8(FLOAT_EOF << 4);
                        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
                        else if (108 <= val && val <= 1131) {
                            val -= 108;
                            stream.writeUInt8((val >> 8) + 247);
                            return stream.writeUInt8(val & 0xff);
                        } else if (-1131 <= val && val <= -108) {
                            val = -val - 108;
                            stream.writeUInt8((val >> 8) + 251);
                            return stream.writeUInt8(val & 0xff);
                        } else if (-32768 <= val && val <= 32767) {
                            stream.writeUInt8(28);
                            return stream.writeInt16BE(val);
                        } else {
                            stream.writeUInt8(29);
                            return stream.writeInt32BE(val);
                        }
                    };
                    return CFFOperand;
                }();
                var CFFDict = /*#__PURE__*/ function() {
                    function CFFDict(ops) {
                        if (ops === void 0) ops = [];
                        this.ops = ops;
                        this.fields = {};
                        for(var _iterator4 = _createForOfIteratorHelperLoose(ops), _step4; !(_step4 = _iterator4()).done;){
                            var field = _step4.value;
                            var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
                            this.fields[key] = field;
                        }
                    }
                    var _proto2 = CFFDict.prototype;
                    _proto2.decodeOperands = function decodeOperands(type, stream, ret, operands) {
                        var _this = this;
                        if (Array.isArray(type)) return operands.map(function(op, i) {
                            return _this.decodeOperands(type[i], stream, ret, [
                                op
                            ]);
                        });
                        else if (type.decode != null) return type.decode(stream, ret, operands);
                        else switch(type){
                            case "number":
                            case "offset":
                            case "sid":
                                return operands[0];
                            case "boolean":
                                return !!operands[0];
                            default:
                                return operands;
                        }
                    };
                    _proto2.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
                        var _this2 = this;
                        if (Array.isArray(type)) return operands.map(function(op, i) {
                            return _this2.encodeOperands(type[i], stream, ctx, op)[0];
                        });
                        else if (type.encode != null) return type.encode(stream, operands, ctx);
                        else if (typeof operands === "number") return [
                            operands
                        ];
                        else if (typeof operands === "boolean") return [
                            +operands
                        ];
                        else if (Array.isArray(operands)) return operands;
                        else return [
                            operands
                        ];
                    };
                    _proto2.decode = function decode(stream, parent) {
                        var end = stream.pos + parent.length;
                        var ret = {};
                        var operands = []; // define hidden properties
                        Object.defineProperties(ret, {
                            parent: {
                                value: parent
                            },
                            _startOffset: {
                                value: stream.pos
                            }
                        }); // fill in defaults
                        for(var key in this.fields){
                            var field = this.fields[key];
                            ret[field[1]] = field[3];
                        }
                        while(stream.pos < end){
                            var b = stream.readUInt8();
                            if (b < 28) {
                                if (b === 12) b = b << 8 | stream.readUInt8();
                                var _field = this.fields[b];
                                if (!_field) throw new Error("Unknown operator ".concat(b));
                                var val = this.decodeOperands(_field[2], stream, ret, operands);
                                if (val != null) {
                                    if (val instanceof utils.PropertyDescriptor) Object.defineProperty(ret, _field[1], val);
                                    else ret[_field[1]] = val;
                                }
                                operands = [];
                            } else operands.push(CFFOperand.decode(stream, b));
                        }
                        return ret;
                    };
                    _proto2.size = function size(dict, parent, includePointers) {
                        if (includePointers === void 0) includePointers = true;
                        var ctx = {
                            parent: parent,
                            val: dict,
                            pointerSize: 0,
                            startOffset: parent.startOffset || 0
                        };
                        var len = 0;
                        for(var k in this.fields){
                            var field = this.fields[k];
                            var val = dict[field[1]];
                            if (val == null || isEqual(val, field[3])) continue;
                            var operands = this.encodeOperands(field[2], null, ctx, val);
                            for(var _iterator5 = _createForOfIteratorHelperLoose(operands), _step5; !(_step5 = _iterator5()).done;){
                                var op = _step5.value;
                                len += CFFOperand.size(op);
                            }
                            var key = Array.isArray(field[0]) ? field[0] : [
                                field[0]
                            ];
                            len += key.length;
                        }
                        if (includePointers) len += ctx.pointerSize;
                        return len;
                    };
                    _proto2.encode = function encode(stream, dict, parent) {
                        var ctx = {
                            pointers: [],
                            startOffset: stream.pos,
                            parent: parent,
                            val: dict,
                            pointerSize: 0
                        };
                        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
                        for(var _iterator6 = _createForOfIteratorHelperLoose(this.ops), _step6; !(_step6 = _iterator6()).done;){
                            var field = _step6.value;
                            var val = dict[field[1]];
                            if (val == null || isEqual(val, field[3])) continue;
                            var operands = this.encodeOperands(field[2], stream, ctx, val);
                            for(var _iterator7 = _createForOfIteratorHelperLoose(operands), _step7; !(_step7 = _iterator7()).done;){
                                var op = _step7.value;
                                CFFOperand.encode(stream, op);
                            }
                            var key = Array.isArray(field[0]) ? field[0] : [
                                field[0]
                            ];
                            for(var _iterator8 = _createForOfIteratorHelperLoose(key), _step8; !(_step8 = _iterator8()).done;){
                                var _op = _step8.value;
                                stream.writeUInt8(_op);
                            }
                        }
                        var i = 0;
                        while(i < ctx.pointers.length){
                            var ptr = ctx.pointers[i++];
                            ptr.type.encode(stream, ptr.val, ptr.parent);
                        }
                        return;
                    };
                    return CFFDict;
                }();
                var CFFPointer = /*#__PURE__*/ function(_r$Pointer) {
                    _inheritsLoose(CFFPointer, _r$Pointer);
                    function CFFPointer(type, options) {
                        if (options === void 0) options = {};
                        if (options.type == null) options.type = "global";
                        return _r$Pointer.call(this, null, type, options) || this;
                    }
                    var _proto3 = CFFPointer.prototype;
                    _proto3.decode = function decode(stream, parent, operands) {
                        this.offsetType = {
                            decode: function decode() {
                                return operands[0];
                            }
                        };
                        return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
                    };
                    _proto3.encode = function encode(stream, value, ctx) {
                        if (!stream) {
                            // compute the size (so ctx.pointerSize is correct)
                            this.offsetType = {
                                size: function size() {
                                    return 0;
                                }
                            };
                            this.size(value, ctx);
                            return [
                                new Ptr(0)
                            ];
                        }
                        var ptr = null;
                        this.offsetType = {
                            encode: function encode(stream, val) {
                                return ptr = val;
                            }
                        };
                        _r$Pointer.prototype.encode.call(this, stream, value, ctx);
                        return [
                            new Ptr(ptr)
                        ];
                    };
                    return CFFPointer;
                }(r.Pointer);
                var Ptr = /*#__PURE__*/ function() {
                    function Ptr(val) {
                        this.val = val;
                        this.forceLarge = true;
                    }
                    var _proto4 = Ptr.prototype;
                    _proto4.valueOf = function valueOf() {
                        return this.val;
                    };
                    return Ptr;
                }();
                var CFFBlendOp = /*#__PURE__*/ function() {
                    function CFFBlendOp() {}
                    CFFBlendOp.decode = function decode(stream, parent, operands) {
                        var numBlends = operands.pop(); // TODO: actually blend. For now just consume the deltas
                        // since we don't use any of the values anyway.
                        while(operands.length > numBlends)operands.pop();
                    };
                    return CFFBlendOp;
                }();
                var CFFPrivateDict = new CFFDict([
                    // key       name                    type                                          default
                    [
                        6,
                        "BlueValues",
                        "delta",
                        null
                    ],
                    [
                        7,
                        "OtherBlues",
                        "delta",
                        null
                    ],
                    [
                        8,
                        "FamilyBlues",
                        "delta",
                        null
                    ],
                    [
                        9,
                        "FamilyOtherBlues",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            9
                        ],
                        "BlueScale",
                        "number",
                        0.039625
                    ],
                    [
                        [
                            12,
                            10
                        ],
                        "BlueShift",
                        "number",
                        7
                    ],
                    [
                        [
                            12,
                            11
                        ],
                        "BlueFuzz",
                        "number",
                        1
                    ],
                    [
                        10,
                        "StdHW",
                        "number",
                        null
                    ],
                    [
                        11,
                        "StdVW",
                        "number",
                        null
                    ],
                    [
                        [
                            12,
                            12
                        ],
                        "StemSnapH",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            13
                        ],
                        "StemSnapV",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            14
                        ],
                        "ForceBold",
                        "boolean",
                        false
                    ],
                    [
                        [
                            12,
                            17
                        ],
                        "LanguageGroup",
                        "number",
                        0
                    ],
                    [
                        [
                            12,
                            18
                        ],
                        "ExpansionFactor",
                        "number",
                        0.06
                    ],
                    [
                        [
                            12,
                            19
                        ],
                        "initialRandomSeed",
                        "number",
                        0
                    ],
                    [
                        20,
                        "defaultWidthX",
                        "number",
                        0
                    ],
                    [
                        21,
                        "nominalWidthX",
                        "number",
                        0
                    ],
                    [
                        22,
                        "vsindex",
                        "number",
                        0
                    ],
                    [
                        23,
                        "blend",
                        CFFBlendOp,
                        null
                    ],
                    [
                        19,
                        "Subrs",
                        new CFFPointer(new CFFIndex(), {
                            type: "local"
                        }),
                        null
                    ]
                ]);
                // Automatically generated from Appendix A of the CFF specification; do
                // not edit. Length should be 391.
                var standardStrings = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall",
                    "001.000",
                    "001.001",
                    "001.002",
                    "001.003",
                    "Black",
                    "Bold",
                    "Book",
                    "Light",
                    "Medium",
                    "Regular",
                    "Roman",
                    "Semibold"
                ];
                var StandardEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "",
                    "questiondown",
                    "",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "",
                    "ring",
                    "cedilla",
                    "",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "AE",
                    "",
                    "ordfeminine",
                    "",
                    "",
                    "",
                    "",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ae",
                    "",
                    "",
                    "",
                    "dotlessi",
                    "",
                    "",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls"
                ];
                var ExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "",
                    "",
                    "isuperior",
                    "",
                    "",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "",
                    "",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "",
                    "",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "",
                    "Dotaccentsmall",
                    "",
                    "",
                    "Macronsmall",
                    "",
                    "",
                    "figuredash",
                    "hypheninferior",
                    "",
                    "",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                var ISOAdobeCharset = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron"
                ];
                var ExpertCharset = [
                    ".notdef",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                var ExpertSubsetCharset = [
                    ".notdef",
                    "space",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "hyphensuperior",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "centoldstyle",
                    "figuredash",
                    "hypheninferior",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior"
                ];
                // Scripts and Languages #
                //########################
                var LangSysTable = new r.Struct({
                    reserved: new r.Reserved(r.uint16),
                    reqFeatureIndex: r.uint16,
                    featureCount: r.uint16,
                    featureIndexes: new r.Array(r.uint16, "featureCount")
                });
                var LangSysRecord = new r.Struct({
                    tag: new r.String(4),
                    langSys: new r.Pointer(r.uint16, LangSysTable, {
                        type: "parent"
                    })
                });
                var Script = new r.Struct({
                    defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
                    count: r.uint16,
                    langSysRecords: new r.Array(LangSysRecord, "count")
                });
                var ScriptRecord = new r.Struct({
                    tag: new r.String(4),
                    script: new r.Pointer(r.uint16, Script, {
                        type: "parent"
                    })
                });
                var ScriptList = new r.Array(ScriptRecord, r.uint16); //#######################
                // Features and Lookups #
                //#######################
                var Feature = new r.Struct({
                    featureParams: r.uint16,
                    // pointer
                    lookupCount: r.uint16,
                    lookupListIndexes: new r.Array(r.uint16, "lookupCount")
                });
                var FeatureRecord = new r.Struct({
                    tag: new r.String(4),
                    feature: new r.Pointer(r.uint16, Feature, {
                        type: "parent"
                    })
                });
                var FeatureList = new r.Array(FeatureRecord, r.uint16);
                var LookupFlags = new r.Struct({
                    markAttachmentType: r.uint8,
                    flags: new r.Bitfield(r.uint8, [
                        "rightToLeft",
                        "ignoreBaseGlyphs",
                        "ignoreLigatures",
                        "ignoreMarks",
                        "useMarkFilteringSet"
                    ])
                });
                function LookupList(SubTable) {
                    var Lookup = new r.Struct({
                        lookupType: r.uint16,
                        flags: LookupFlags,
                        subTableCount: r.uint16,
                        subTables: new r.Array(new r.Pointer(r.uint16, SubTable), "subTableCount"),
                        markFilteringSet: new r.Optional(r.uint16, function(t) {
                            return t.flags.flags.useMarkFilteringSet;
                        })
                    });
                    return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
                } //#################
                // Coverage Table #
                //#################
                var RangeRecord = new r.Struct({
                    start: r.uint16,
                    end: r.uint16,
                    startCoverageIndex: r.uint16
                });
                var Coverage = new r.VersionedStruct(r.uint16, {
                    1: {
                        glyphCount: r.uint16,
                        glyphs: new r.Array(r.uint16, "glyphCount")
                    },
                    2: {
                        rangeCount: r.uint16,
                        rangeRecords: new r.Array(RangeRecord, "rangeCount")
                    }
                }); //#########################
                // Class Definition Table #
                //#########################
                var ClassRangeRecord = new r.Struct({
                    start: r.uint16,
                    end: r.uint16,
                    class: r.uint16
                });
                var ClassDef = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Class array
                        startGlyph: r.uint16,
                        glyphCount: r.uint16,
                        classValueArray: new r.Array(r.uint16, "glyphCount")
                    },
                    2: {
                        // Class ranges
                        classRangeCount: r.uint16,
                        classRangeRecord: new r.Array(ClassRangeRecord, "classRangeCount")
                    }
                }); //###############
                // Device Table #
                //###############
                var Device = new r.Struct({
                    a: r.uint16,
                    // startSize for hinting Device, outerIndex for VariationIndex
                    b: r.uint16,
                    // endSize for Device, innerIndex for VariationIndex
                    deltaFormat: r.uint16
                }); //#############################################
                // Contextual Substitution/Positioning Tables #
                //#############################################
                var LookupRecord = new r.Struct({
                    sequenceIndex: r.uint16,
                    lookupListIndex: r.uint16
                });
                var Rule = new r.Struct({
                    glyphCount: r.uint16,
                    lookupCount: r.uint16,
                    input: new r.Array(r.uint16, function(t) {
                        return t.glyphCount - 1;
                    }),
                    lookupRecords: new r.Array(LookupRecord, "lookupCount")
                });
                var RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);
                var ClassRule = new r.Struct({
                    glyphCount: r.uint16,
                    lookupCount: r.uint16,
                    classes: new r.Array(r.uint16, function(t) {
                        return t.glyphCount - 1;
                    }),
                    lookupRecords: new r.Array(LookupRecord, "lookupCount")
                });
                var ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);
                var Context = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Simple context
                        coverage: new r.Pointer(r.uint16, Coverage),
                        ruleSetCount: r.uint16,
                        ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), "ruleSetCount")
                    },
                    2: {
                        // Class-based context
                        coverage: new r.Pointer(r.uint16, Coverage),
                        classDef: new r.Pointer(r.uint16, ClassDef),
                        classSetCnt: r.uint16,
                        classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), "classSetCnt")
                    },
                    3: {
                        glyphCount: r.uint16,
                        lookupCount: r.uint16,
                        coverages: new r.Array(new r.Pointer(r.uint16, Coverage), "glyphCount"),
                        lookupRecords: new r.Array(LookupRecord, "lookupCount")
                    }
                }); //######################################################
                // Chaining Contextual Substitution/Positioning Tables #
                //######################################################
                var ChainRule = new r.Struct({
                    backtrackGlyphCount: r.uint16,
                    backtrack: new r.Array(r.uint16, "backtrackGlyphCount"),
                    inputGlyphCount: r.uint16,
                    input: new r.Array(r.uint16, function(t) {
                        return t.inputGlyphCount - 1;
                    }),
                    lookaheadGlyphCount: r.uint16,
                    lookahead: new r.Array(r.uint16, "lookaheadGlyphCount"),
                    lookupCount: r.uint16,
                    lookupRecords: new r.Array(LookupRecord, "lookupCount")
                });
                var ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);
                var ChainingContext = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Simple context glyph substitution
                        coverage: new r.Pointer(r.uint16, Coverage),
                        chainCount: r.uint16,
                        chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), "chainCount")
                    },
                    2: {
                        // Class-based chaining context
                        coverage: new r.Pointer(r.uint16, Coverage),
                        backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
                        inputClassDef: new r.Pointer(r.uint16, ClassDef),
                        lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
                        chainCount: r.uint16,
                        chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), "chainCount")
                    },
                    3: {
                        // Coverage-based chaining context
                        backtrackGlyphCount: r.uint16,
                        backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), "backtrackGlyphCount"),
                        inputGlyphCount: r.uint16,
                        inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), "inputGlyphCount"),
                        lookaheadGlyphCount: r.uint16,
                        lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), "lookaheadGlyphCount"),
                        lookupCount: r.uint16,
                        lookupRecords: new r.Array(LookupRecord, "lookupCount")
                    }
                });
                /*******************
 * Variation Store *
 *******************/ var F2DOT14 = new r.Fixed(16, "BE", 14);
                var RegionAxisCoordinates = new r.Struct({
                    startCoord: F2DOT14,
                    peakCoord: F2DOT14,
                    endCoord: F2DOT14
                });
                var VariationRegionList = new r.Struct({
                    axisCount: r.uint16,
                    regionCount: r.uint16,
                    variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, "axisCount"), "regionCount")
                });
                var DeltaSet = new r.Struct({
                    shortDeltas: new r.Array(r.int16, function(t) {
                        return t.parent.shortDeltaCount;
                    }),
                    regionDeltas: new r.Array(r.int8, function(t) {
                        return t.parent.regionIndexCount - t.parent.shortDeltaCount;
                    }),
                    deltas: function deltas(t) {
                        return t.shortDeltas.concat(t.regionDeltas);
                    }
                });
                var ItemVariationData = new r.Struct({
                    itemCount: r.uint16,
                    shortDeltaCount: r.uint16,
                    regionIndexCount: r.uint16,
                    regionIndexes: new r.Array(r.uint16, "regionIndexCount"),
                    deltaSets: new r.Array(DeltaSet, "itemCount")
                });
                var ItemVariationStore = new r.Struct({
                    format: r.uint16,
                    variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
                    variationDataCount: r.uint16,
                    itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), "variationDataCount")
                });
                /**********************
 * Feature Variations *
 **********************/ var ConditionTable = new r.VersionedStruct(r.uint16, {
                    1: (_ = {
                        axisIndex: r.uint16
                    }, _["axisIndex"] = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _)
                });
                var ConditionSet = new r.Struct({
                    conditionCount: r.uint16,
                    conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), "conditionCount")
                });
                var FeatureTableSubstitutionRecord = new r.Struct({
                    featureIndex: r.uint16,
                    alternateFeatureTable: new r.Pointer(r.uint32, Feature, {
                        type: "parent"
                    })
                });
                var FeatureTableSubstitution = new r.Struct({
                    version: r.fixed32,
                    substitutionCount: r.uint16,
                    substitutions: new r.Array(FeatureTableSubstitutionRecord, "substitutionCount")
                });
                var FeatureVariationRecord = new r.Struct({
                    conditionSet: new r.Pointer(r.uint32, ConditionSet, {
                        type: "parent"
                    }),
                    featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, {
                        type: "parent"
                    })
                });
                var FeatureVariations = new r.Struct({
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    featureVariationRecordCount: r.uint32,
                    featureVariationRecords: new r.Array(FeatureVariationRecord, "featureVariationRecordCount")
                });
                // otherwise delegates to the provided type.
                var PredefinedOp = /*#__PURE__*/ function() {
                    function PredefinedOp(predefinedOps, type) {
                        this.predefinedOps = predefinedOps;
                        this.type = type;
                    }
                    var _proto5 = PredefinedOp.prototype;
                    _proto5.decode = function decode(stream, parent, operands) {
                        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
                        return this.type.decode(stream, parent, operands);
                    };
                    _proto5.size = function size(value, ctx) {
                        return this.type.size(value, ctx);
                    };
                    _proto5.encode = function encode(stream, value, ctx) {
                        var index = this.predefinedOps.indexOf(value);
                        if (index !== -1) return index;
                        return this.type.encode(stream, value, ctx);
                    };
                    return PredefinedOp;
                }();
                var CFFEncodingVersion = /*#__PURE__*/ function(_r$Number) {
                    _inheritsLoose(CFFEncodingVersion, _r$Number);
                    function CFFEncodingVersion() {
                        return _r$Number.call(this, "UInt8") || this;
                    }
                    var _proto6 = CFFEncodingVersion.prototype;
                    _proto6.decode = function decode(stream) {
                        return r.uint8.decode(stream) & 0x7f;
                    };
                    return CFFEncodingVersion;
                }(r.Number);
                var Range1 = new r.Struct({
                    first: r.uint16,
                    nLeft: r.uint8
                });
                var Range2 = new r.Struct({
                    first: r.uint16,
                    nLeft: r.uint16
                });
                var CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
                    0: {
                        nCodes: r.uint8,
                        codes: new r.Array(r.uint8, "nCodes")
                    },
                    1: {
                        nRanges: r.uint8,
                        ranges: new r.Array(Range1, "nRanges")
                    } // TODO: supplement?
                });
                var CFFEncoding = new PredefinedOp([
                    StandardEncoding,
                    ExpertEncoding
                ], new CFFPointer(CFFCustomEncoding, {
                    lazy: true
                })); // Decodes an array of ranges until the total
                // length is equal to the provided length.
                var RangeArray = /*#__PURE__*/ function(_r$Array) {
                    _inheritsLoose(RangeArray, _r$Array);
                    function RangeArray() {
                        return _r$Array.apply(this, arguments) || this;
                    }
                    var _proto7 = RangeArray.prototype;
                    _proto7.decode = function decode(stream, parent) {
                        var length = utils.resolveLength(this.length, stream, parent);
                        var count = 0;
                        var res = [];
                        while(count < length){
                            var range = this.type.decode(stream, parent);
                            range.offset = count;
                            count += range.nLeft + 1;
                            res.push(range);
                        }
                        return res;
                    };
                    return RangeArray;
                }(r.Array);
                var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
                    0: {
                        glyphs: new r.Array(r.uint16, function(t) {
                            return t.parent.CharStrings.length - 1;
                        })
                    },
                    1: {
                        ranges: new RangeArray(Range1, function(t) {
                            return t.parent.CharStrings.length - 1;
                        })
                    },
                    2: {
                        ranges: new RangeArray(Range2, function(t) {
                            return t.parent.CharStrings.length - 1;
                        })
                    }
                });
                var CFFCharset = new PredefinedOp([
                    ISOAdobeCharset,
                    ExpertCharset,
                    ExpertSubsetCharset
                ], new CFFPointer(CFFCustomCharset, {
                    lazy: true
                }));
                var FDRange3 = new r.Struct({
                    first: r.uint16,
                    fd: r.uint8
                });
                var FDRange4 = new r.Struct({
                    first: r.uint32,
                    fd: r.uint16
                });
                var FDSelect = new r.VersionedStruct(r.uint8, {
                    0: {
                        fds: new r.Array(r.uint8, function(t) {
                            return t.parent.CharStrings.length;
                        })
                    },
                    3: {
                        nRanges: r.uint16,
                        ranges: new r.Array(FDRange3, "nRanges"),
                        sentinel: r.uint16
                    },
                    4: {
                        nRanges: r.uint32,
                        ranges: new r.Array(FDRange4, "nRanges"),
                        sentinel: r.uint32
                    }
                });
                var ptr = new CFFPointer(CFFPrivateDict);
                var CFFPrivateOp = /*#__PURE__*/ function() {
                    function CFFPrivateOp() {}
                    var _proto8 = CFFPrivateOp.prototype;
                    _proto8.decode = function decode(stream, parent, operands) {
                        parent.length = operands[0];
                        return ptr.decode(stream, parent, [
                            operands[1]
                        ]);
                    };
                    _proto8.size = function size(dict, ctx) {
                        return [
                            CFFPrivateDict.size(dict, ctx, false),
                            ptr.size(dict, ctx)[0]
                        ];
                    };
                    _proto8.encode = function encode(stream, dict, ctx) {
                        return [
                            CFFPrivateDict.size(dict, ctx, false),
                            ptr.encode(stream, dict, ctx)[0]
                        ];
                    };
                    return CFFPrivateOp;
                }();
                var FontDict = new CFFDict([
                    // key       name                   type(s)                                 default
                    [
                        18,
                        "Private",
                        new CFFPrivateOp(),
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        "FontName",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        "FontMatrix",
                        "array",
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        "PaintType",
                        "number",
                        0
                    ]
                ]);
                var CFFTopDict = new CFFDict([
                    // key       name                   type(s)                                 default
                    [
                        [
                            12,
                            30
                        ],
                        "ROS",
                        [
                            "sid",
                            "sid",
                            "number"
                        ],
                        null
                    ],
                    [
                        0,
                        "version",
                        "sid",
                        null
                    ],
                    [
                        1,
                        "Notice",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            0
                        ],
                        "Copyright",
                        "sid",
                        null
                    ],
                    [
                        2,
                        "FullName",
                        "sid",
                        null
                    ],
                    [
                        3,
                        "FamilyName",
                        "sid",
                        null
                    ],
                    [
                        4,
                        "Weight",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            1
                        ],
                        "isFixedPitch",
                        "boolean",
                        false
                    ],
                    [
                        [
                            12,
                            2
                        ],
                        "ItalicAngle",
                        "number",
                        0
                    ],
                    [
                        [
                            12,
                            3
                        ],
                        "UnderlinePosition",
                        "number",
                        -100
                    ],
                    [
                        [
                            12,
                            4
                        ],
                        "UnderlineThickness",
                        "number",
                        50
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        "PaintType",
                        "number",
                        0
                    ],
                    [
                        [
                            12,
                            6
                        ],
                        "CharstringType",
                        "number",
                        2
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        "FontMatrix",
                        "array",
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        13,
                        "UniqueID",
                        "number",
                        null
                    ],
                    [
                        5,
                        "FontBBox",
                        "array",
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            8
                        ],
                        "StrokeWidth",
                        "number",
                        0
                    ],
                    [
                        14,
                        "XUID",
                        "array",
                        null
                    ],
                    [
                        15,
                        "charset",
                        CFFCharset,
                        ISOAdobeCharset
                    ],
                    [
                        16,
                        "Encoding",
                        CFFEncoding,
                        StandardEncoding
                    ],
                    [
                        17,
                        "CharStrings",
                        new CFFPointer(new CFFIndex()),
                        null
                    ],
                    [
                        18,
                        "Private",
                        new CFFPrivateOp(),
                        null
                    ],
                    [
                        [
                            12,
                            20
                        ],
                        "SyntheticBase",
                        "number",
                        null
                    ],
                    [
                        [
                            12,
                            21
                        ],
                        "PostScript",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            22
                        ],
                        "BaseFontName",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            23
                        ],
                        "BaseFontBlend",
                        "delta",
                        null
                    ],
                    // CID font specific
                    [
                        [
                            12,
                            31
                        ],
                        "CIDFontVersion",
                        "number",
                        0
                    ],
                    [
                        [
                            12,
                            32
                        ],
                        "CIDFontRevision",
                        "number",
                        0
                    ],
                    [
                        [
                            12,
                            33
                        ],
                        "CIDFontType",
                        "number",
                        0
                    ],
                    [
                        [
                            12,
                            34
                        ],
                        "CIDCount",
                        "number",
                        8720
                    ],
                    [
                        [
                            12,
                            35
                        ],
                        "UIDBase",
                        "number",
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        "FDSelect",
                        new CFFPointer(FDSelect),
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        "FDArray",
                        new CFFPointer(new CFFIndex(FontDict)),
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        "FontName",
                        "sid",
                        null
                    ]
                ]);
                var VariationStore = new r.Struct({
                    length: r.uint16,
                    itemVariationStore: ItemVariationStore
                });
                var CFF2TopDict = new CFFDict([
                    [
                        [
                            12,
                            7
                        ],
                        "FontMatrix",
                        "array",
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        17,
                        "CharStrings",
                        new CFFPointer(new CFFIndex()),
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        "FDSelect",
                        new CFFPointer(FDSelect),
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        "FDArray",
                        new CFFPointer(new CFFIndex(FontDict)),
                        null
                    ],
                    [
                        24,
                        "vstore",
                        new CFFPointer(VariationStore),
                        null
                    ],
                    [
                        25,
                        "maxstack",
                        "number",
                        193
                    ]
                ]);
                var CFFTop = new r.VersionedStruct(r.fixed16, {
                    1: {
                        hdrSize: r.uint8,
                        offSize: r.uint8,
                        nameIndex: new CFFIndex(new r.String("length")),
                        topDictIndex: new CFFIndex(CFFTopDict),
                        stringIndex: new CFFIndex(new r.String("length")),
                        globalSubrIndex: new CFFIndex()
                    },
                    2: {
                        hdrSize: r.uint8,
                        length: r.uint16,
                        topDict: CFF2TopDict,
                        globalSubrIndex: new CFFIndex()
                    }
                });
                var CFFFont = /*#__PURE__*/ function() {
                    function CFFFont(stream) {
                        this.stream = stream;
                        this.decode();
                    }
                    CFFFont.decode = function decode(stream) {
                        return new CFFFont(stream);
                    };
                    var _proto9 = CFFFont.prototype;
                    _proto9.decode = function decode() {
                        var start = this.stream.pos;
                        var top = CFFTop.decode(this.stream);
                        for(var key in top){
                            var val = top[key];
                            this[key] = val;
                        }
                        if (this.version < 2) {
                            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
                            this.topDict = this.topDictIndex[0];
                        }
                        this.isCIDFont = this.topDict.ROS != null;
                        return this;
                    };
                    _proto9.string = function string(sid) {
                        if (this.version >= 2) return null;
                        if (sid < standardStrings.length) return standardStrings[sid];
                        return this.stringIndex[sid - standardStrings.length];
                    };
                    _proto9.getCharString = function getCharString(glyph) {
                        this.stream.pos = this.topDict.CharStrings[glyph].offset;
                        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
                    };
                    _proto9.getGlyphName = function getGlyphName(gid) {
                        // CFF2 glyph names are in the post table.
                        if (this.version >= 2) return null;
                         // CID-keyed fonts don't have glyph names
                        if (this.isCIDFont) return null;
                        var charset = this.topDict.charset;
                        if (Array.isArray(charset)) return charset[gid];
                        if (gid === 0) return ".notdef";
                        gid -= 1;
                        switch(charset.version){
                            case 0:
                                return this.string(charset.glyphs[gid]);
                            case 1:
                            case 2:
                                for(var i = 0; i < charset.ranges.length; i++){
                                    var range = charset.ranges[i];
                                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                                }
                                break;
                        }
                        return null;
                    };
                    _proto9.fdForGlyph = function fdForGlyph(gid) {
                        if (!this.topDict.FDSelect) return null;
                        switch(this.topDict.FDSelect.version){
                            case 0:
                                return this.topDict.FDSelect.fds[gid];
                            case 3:
                            case 4:
                                var ranges = this.topDict.FDSelect.ranges;
                                var low = 0;
                                var high = ranges.length - 1;
                                while(low <= high){
                                    var mid = low + high >> 1;
                                    if (gid < ranges[mid].first) high = mid - 1;
                                    else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
                                    else return ranges[mid].fd;
                                }
                            default:
                                throw new Error("Unknown FDSelect version: ".concat(this.topDict.FDSelect.version));
                        }
                    };
                    _proto9.privateDictForGlyph = function privateDictForGlyph(gid) {
                        if (this.topDict.FDSelect) {
                            var fd = this.fdForGlyph(gid);
                            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
                            return null;
                        }
                        if (this.version < 2) return this.topDict.Private;
                        return this.topDict.FDArray[0].Private;
                    };
                    _createClass(CFFFont, [
                        {
                            key: "postscriptName",
                            get: function get() {
                                if (this.version < 2) return this.nameIndex[0];
                                return null;
                            }
                        },
                        {
                            key: "fullName",
                            get: function get() {
                                return this.string(this.topDict.FullName);
                            }
                        },
                        {
                            key: "familyName",
                            get: function get() {
                                return this.string(this.topDict.FamilyName);
                            }
                        }
                    ]);
                    return CFFFont;
                }();
                var VerticalOrigin = new r.Struct({
                    glyphIndex: r.uint16,
                    vertOriginY: r.int16
                });
                var VORG = new r.Struct({
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    defaultVertOriginY: r.int16,
                    numVertOriginYMetrics: r.uint16,
                    metrics: new r.Array(VerticalOrigin, "numVertOriginYMetrics")
                });
                var BigMetrics = new r.Struct({
                    height: r.uint8,
                    width: r.uint8,
                    horiBearingX: r.int8,
                    horiBearingY: r.int8,
                    horiAdvance: r.uint8,
                    vertBearingX: r.int8,
                    vertBearingY: r.int8,
                    vertAdvance: r.uint8
                });
                var SmallMetrics = new r.Struct({
                    height: r.uint8,
                    width: r.uint8,
                    bearingX: r.int8,
                    bearingY: r.int8,
                    advance: r.uint8
                });
                var EBDTComponent = new r.Struct({
                    glyph: r.uint16,
                    xOffset: r.int8,
                    yOffset: r.int8
                });
                var ByteAligned = function ByteAligned() {};
                var BitAligned = function BitAligned() {};
                var glyph = new r.VersionedStruct("version", {
                    1: {
                        metrics: SmallMetrics,
                        data: ByteAligned
                    },
                    2: {
                        metrics: SmallMetrics,
                        data: BitAligned
                    },
                    // format 3 is deprecated
                    // format 4 is not supported by Microsoft
                    5: {
                        data: BitAligned
                    },
                    6: {
                        metrics: BigMetrics,
                        data: ByteAligned
                    },
                    7: {
                        metrics: BigMetrics,
                        data: BitAligned
                    },
                    8: {
                        metrics: SmallMetrics,
                        pad: new r.Reserved(r.uint8),
                        numComponents: r.uint16,
                        components: new r.Array(EBDTComponent, "numComponents")
                    },
                    9: {
                        metrics: BigMetrics,
                        pad: new r.Reserved(r.uint8),
                        numComponents: r.uint16,
                        components: new r.Array(EBDTComponent, "numComponents")
                    },
                    17: {
                        metrics: SmallMetrics,
                        dataLen: r.uint32,
                        data: new r.Buffer("dataLen")
                    },
                    18: {
                        metrics: BigMetrics,
                        dataLen: r.uint32,
                        data: new r.Buffer("dataLen")
                    },
                    19: {
                        dataLen: r.uint32,
                        data: new r.Buffer("dataLen")
                    }
                });
                var SBitLineMetrics = new r.Struct({
                    ascender: r.int8,
                    descender: r.int8,
                    widthMax: r.uint8,
                    caretSlopeNumerator: r.int8,
                    caretSlopeDenominator: r.int8,
                    caretOffset: r.int8,
                    minOriginSB: r.int8,
                    minAdvanceSB: r.int8,
                    maxBeforeBL: r.int8,
                    minAfterBL: r.int8,
                    pad: new r.Reserved(r.int8, 2)
                });
                var CodeOffsetPair = new r.Struct({
                    glyphCode: r.uint16,
                    offset: r.uint16
                });
                var IndexSubtable = new r.VersionedStruct(r.uint16, {
                    header: {
                        imageFormat: r.uint16,
                        imageDataOffset: r.uint32
                    },
                    1: {
                        offsetArray: new r.Array(r.uint32, function(t) {
                            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
                        })
                    },
                    2: {
                        imageSize: r.uint32,
                        bigMetrics: BigMetrics
                    },
                    3: {
                        offsetArray: new r.Array(r.uint16, function(t) {
                            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
                        })
                    },
                    4: {
                        numGlyphs: r.uint32,
                        glyphArray: new r.Array(CodeOffsetPair, function(t) {
                            return t.numGlyphs + 1;
                        })
                    },
                    5: {
                        imageSize: r.uint32,
                        bigMetrics: BigMetrics,
                        numGlyphs: r.uint32,
                        glyphCodeArray: new r.Array(r.uint16, "numGlyphs")
                    }
                });
                var IndexSubtableArray = new r.Struct({
                    firstGlyphIndex: r.uint16,
                    lastGlyphIndex: r.uint16,
                    subtable: new r.Pointer(r.uint32, IndexSubtable)
                });
                var BitmapSizeTable = new r.Struct({
                    indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), {
                        type: "parent"
                    }),
                    indexTablesSize: r.uint32,
                    numberOfIndexSubTables: r.uint32,
                    colorRef: r.uint32,
                    hori: SBitLineMetrics,
                    vert: SBitLineMetrics,
                    startGlyphIndex: r.uint16,
                    endGlyphIndex: r.uint16,
                    ppemX: r.uint8,
                    ppemY: r.uint8,
                    bitDepth: r.uint8,
                    flags: new r.Bitfield(r.uint8, [
                        "horizontal",
                        "vertical"
                    ])
                });
                var EBLC = new r.Struct({
                    version: r.uint32,
                    // 0x00020000
                    numSizes: r.uint32,
                    sizes: new r.Array(BitmapSizeTable, "numSizes")
                });
                var ImageTable = new r.Struct({
                    ppem: r.uint16,
                    resolution: r.uint16,
                    imageOffsets: new r.Array(new r.Pointer(r.uint32, "void"), function(t) {
                        return t.parent.parent.maxp.numGlyphs + 1;
                    })
                }); // This is the Apple sbix table, used by the "Apple Color Emoji" font.
                // It includes several image tables with images for each bitmap glyph
                // of several different sizes.
                var sbix = new r.Struct({
                    version: r.uint16,
                    flags: new r.Bitfield(r.uint16, [
                        "renderOutlines"
                    ]),
                    numImgTables: r.uint32,
                    imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), "numImgTables")
                });
                var LayerRecord = new r.Struct({
                    gid: r.uint16,
                    // Glyph ID of layer glyph (must be in z-order from bottom to top).
                    paletteIndex: r.uint16 // Index value to use in the appropriate palette. This value must
                }); // be less than numPaletteEntries in the CPAL table, except for
                // the special case noted below. Each palette entry is 16 bits.
                // A palette index of 0xFFFF is a special case indicating that
                // the text foreground color should be used.
                var BaseGlyphRecord = new r.Struct({
                    gid: r.uint16,
                    // Glyph ID of reference glyph. This glyph is for reference only
                    // and is not rendered for color.
                    firstLayerIndex: r.uint16,
                    // Index (from beginning of the Layer Records) to the layer record.
                    // There will be numLayers consecutive entries for this base glyph.
                    numLayers: r.uint16
                });
                var COLR = new r.Struct({
                    version: r.uint16,
                    numBaseGlyphRecords: r.uint16,
                    baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, "numBaseGlyphRecords")),
                    layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, "numLayerRecords"), {
                        lazy: true
                    }),
                    numLayerRecords: r.uint16
                });
                var ColorRecord = new r.Struct({
                    blue: r.uint8,
                    green: r.uint8,
                    red: r.uint8,
                    alpha: r.uint8
                });
                var CPAL = new r.VersionedStruct(r.uint16, {
                    header: {
                        numPaletteEntries: r.uint16,
                        numPalettes: r.uint16,
                        numColorRecords: r.uint16,
                        colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, "numColorRecords")),
                        colorRecordIndices: new r.Array(r.uint16, "numPalettes")
                    },
                    0: {},
                    1: {
                        offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, "numPalettes")),
                        offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, "numPalettes")),
                        offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, "numPaletteEntries"))
                    }
                });
                var BaseCoord = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Design units only
                        coordinate: r.int16 // X or Y value, in design units
                    },
                    2: {
                        // Design units plus contour point
                        coordinate: r.int16,
                        // X or Y value, in design units
                        referenceGlyph: r.uint16,
                        // GlyphID of control glyph
                        baseCoordPoint: r.uint16 // Index of contour point on the referenceGlyph
                    },
                    3: {
                        // Design units plus Device table
                        coordinate: r.int16,
                        // X or Y value, in design units
                        deviceTable: new r.Pointer(r.uint16, Device) // Device table for X or Y value
                    }
                });
                var BaseValues = new r.Struct({
                    defaultIndex: r.uint16,
                    // Index of default baseline for this script-same index in the BaseTagList
                    baseCoordCount: r.uint16,
                    baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), "baseCoordCount")
                });
                var FeatMinMaxRecord = new r.Struct({
                    tag: new r.String(4),
                    // 4-byte feature identification tag-must match FeatureTag in FeatureList
                    minCoord: new r.Pointer(r.uint16, BaseCoord, {
                        type: "parent"
                    }),
                    // May be NULL
                    maxCoord: new r.Pointer(r.uint16, BaseCoord, {
                        type: "parent"
                    }) // May be NULL
                });
                var MinMax = new r.Struct({
                    minCoord: new r.Pointer(r.uint16, BaseCoord),
                    // May be NULL
                    maxCoord: new r.Pointer(r.uint16, BaseCoord),
                    // May be NULL
                    featMinMaxCount: r.uint16,
                    // May be 0
                    featMinMaxRecords: new r.Array(FeatMinMaxRecord, "featMinMaxCount") // In alphabetical order
                });
                var BaseLangSysRecord = new r.Struct({
                    tag: new r.String(4),
                    // 4-byte language system identification tag
                    minMax: new r.Pointer(r.uint16, MinMax, {
                        type: "parent"
                    })
                });
                var BaseScript = new r.Struct({
                    baseValues: new r.Pointer(r.uint16, BaseValues),
                    // May be NULL
                    defaultMinMax: new r.Pointer(r.uint16, MinMax),
                    // May be NULL
                    baseLangSysCount: r.uint16,
                    // May be 0
                    baseLangSysRecords: new r.Array(BaseLangSysRecord, "baseLangSysCount") // in alphabetical order by BaseLangSysTag
                });
                var BaseScriptRecord = new r.Struct({
                    tag: new r.String(4),
                    // 4-byte script identification tag
                    script: new r.Pointer(r.uint16, BaseScript, {
                        type: "parent"
                    })
                });
                var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16); // Array of 4-byte baseline identification tags-must be in alphabetical order
                var BaseTagList = new r.Array(new r.String(4), r.uint16);
                var Axis = new r.Struct({
                    baseTagList: new r.Pointer(r.uint16, BaseTagList),
                    // May be NULL
                    baseScriptList: new r.Pointer(r.uint16, BaseScriptList)
                });
                var BASE = new r.VersionedStruct(r.uint32, {
                    header: {
                        horizAxis: new r.Pointer(r.uint16, Axis),
                        // May be NULL
                        vertAxis: new r.Pointer(r.uint16, Axis) // May be NULL
                    },
                    0x00010000: {},
                    0x00010001: {
                        itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
                    }
                });
                var AttachPoint = new r.Array(r.uint16, r.uint16);
                var AttachList = new r.Struct({
                    coverage: new r.Pointer(r.uint16, Coverage),
                    glyphCount: r.uint16,
                    attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), "glyphCount")
                });
                var CaretValue = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Design units only
                        coordinate: r.int16
                    },
                    2: {
                        // Contour point
                        caretValuePoint: r.uint16
                    },
                    3: {
                        // Design units plus Device table
                        coordinate: r.int16,
                        deviceTable: new r.Pointer(r.uint16, Device)
                    }
                });
                var LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);
                var LigCaretList = new r.Struct({
                    coverage: new r.Pointer(r.uint16, Coverage),
                    ligGlyphCount: r.uint16,
                    ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), "ligGlyphCount")
                });
                var MarkGlyphSetsDef = new r.Struct({
                    markSetTableFormat: r.uint16,
                    markSetCount: r.uint16,
                    coverage: new r.Array(new r.Pointer(r.uint32, Coverage), "markSetCount")
                });
                var GDEF = new r.VersionedStruct(r.uint32, {
                    header: {
                        glyphClassDef: new r.Pointer(r.uint16, ClassDef),
                        attachList: new r.Pointer(r.uint16, AttachList),
                        ligCaretList: new r.Pointer(r.uint16, LigCaretList),
                        markAttachClassDef: new r.Pointer(r.uint16, ClassDef)
                    },
                    0x00010000: {},
                    0x00010002: {
                        markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef)
                    },
                    0x00010003: {
                        markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
                        itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
                    }
                });
                var ValueFormat = new r.Bitfield(r.uint16, [
                    "xPlacement",
                    "yPlacement",
                    "xAdvance",
                    "yAdvance",
                    "xPlaDevice",
                    "yPlaDevice",
                    "xAdvDevice",
                    "yAdvDevice"
                ]);
                var types = {
                    xPlacement: r.int16,
                    yPlacement: r.int16,
                    xAdvance: r.int16,
                    yAdvance: r.int16,
                    xPlaDevice: new r.Pointer(r.uint16, Device, {
                        type: "global",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    }),
                    yPlaDevice: new r.Pointer(r.uint16, Device, {
                        type: "global",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    }),
                    xAdvDevice: new r.Pointer(r.uint16, Device, {
                        type: "global",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    }),
                    yAdvDevice: new r.Pointer(r.uint16, Device, {
                        type: "global",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    })
                };
                var ValueRecord = /*#__PURE__*/ function() {
                    function ValueRecord(key) {
                        if (key === void 0) key = "valueFormat";
                        this.key = key;
                    }
                    var _proto10 = ValueRecord.prototype;
                    _proto10.buildStruct = function buildStruct(parent) {
                        var struct = parent;
                        while(!struct[this.key] && struct.parent)struct = struct.parent;
                        if (!struct[this.key]) return;
                        var fields = {};
                        fields.rel = function() {
                            return struct._startOffset;
                        };
                        var format = struct[this.key];
                        for(var key in format)if (format[key]) fields[key] = types[key];
                        return new r.Struct(fields);
                    };
                    _proto10.size = function size(val, ctx) {
                        return this.buildStruct(ctx).size(val, ctx);
                    };
                    _proto10.decode = function decode(stream, parent) {
                        var res = this.buildStruct(parent).decode(stream, parent);
                        delete res.rel;
                        return res;
                    };
                    return ValueRecord;
                }();
                var PairValueRecord = new r.Struct({
                    secondGlyph: r.uint16,
                    value1: new ValueRecord("valueFormat1"),
                    value2: new ValueRecord("valueFormat2")
                });
                var PairSet = new r.Array(PairValueRecord, r.uint16);
                var Class2Record = new r.Struct({
                    value1: new ValueRecord("valueFormat1"),
                    value2: new ValueRecord("valueFormat2")
                });
                var Anchor = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Design units only
                        xCoordinate: r.int16,
                        yCoordinate: r.int16
                    },
                    2: {
                        // Design units plus contour point
                        xCoordinate: r.int16,
                        yCoordinate: r.int16,
                        anchorPoint: r.uint16
                    },
                    3: {
                        // Design units plus Device tables
                        xCoordinate: r.int16,
                        yCoordinate: r.int16,
                        xDeviceTable: new r.Pointer(r.uint16, Device),
                        yDeviceTable: new r.Pointer(r.uint16, Device)
                    }
                });
                var EntryExitRecord = new r.Struct({
                    entryAnchor: new r.Pointer(r.uint16, Anchor, {
                        type: "parent"
                    }),
                    exitAnchor: new r.Pointer(r.uint16, Anchor, {
                        type: "parent"
                    })
                });
                var MarkRecord = new r.Struct({
                    class: r.uint16,
                    markAnchor: new r.Pointer(r.uint16, Anchor, {
                        type: "parent"
                    })
                });
                var MarkArray = new r.Array(MarkRecord, r.uint16);
                var BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function(t) {
                    return t.parent.classCount;
                });
                var BaseArray = new r.Array(BaseRecord, r.uint16);
                var ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function(t) {
                    return t.parent.parent.classCount;
                });
                var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
                var LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);
                var GPOSLookup = new r.VersionedStruct("lookupType", {
                    1: new r.VersionedStruct(r.uint16, {
                        // Single Adjustment
                        1: {
                            // Single positioning value
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat: ValueFormat,
                            value: new ValueRecord()
                        },
                        2: {
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat: ValueFormat,
                            valueCount: r.uint16,
                            values: new r.LazyArray(new ValueRecord(), "valueCount")
                        }
                    }),
                    2: new r.VersionedStruct(r.uint16, {
                        // Pair Adjustment Positioning
                        1: {
                            // Adjustments for glyph pairs
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat1: ValueFormat,
                            valueFormat2: ValueFormat,
                            pairSetCount: r.uint16,
                            pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), "pairSetCount")
                        },
                        2: {
                            // Class pair adjustment
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat1: ValueFormat,
                            valueFormat2: ValueFormat,
                            classDef1: new r.Pointer(r.uint16, ClassDef),
                            classDef2: new r.Pointer(r.uint16, ClassDef),
                            class1Count: r.uint16,
                            class2Count: r.uint16,
                            classRecords: new r.LazyArray(new r.LazyArray(Class2Record, "class2Count"), "class1Count")
                        }
                    }),
                    3: {
                        // Cursive Attachment Positioning
                        format: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        entryExitCount: r.uint16,
                        entryExitRecords: new r.Array(EntryExitRecord, "entryExitCount")
                    },
                    4: {
                        // MarkToBase Attachment Positioning
                        format: r.uint16,
                        markCoverage: new r.Pointer(r.uint16, Coverage),
                        baseCoverage: new r.Pointer(r.uint16, Coverage),
                        classCount: r.uint16,
                        markArray: new r.Pointer(r.uint16, MarkArray),
                        baseArray: new r.Pointer(r.uint16, BaseArray)
                    },
                    5: {
                        // MarkToLigature Attachment Positioning
                        format: r.uint16,
                        markCoverage: new r.Pointer(r.uint16, Coverage),
                        ligatureCoverage: new r.Pointer(r.uint16, Coverage),
                        classCount: r.uint16,
                        markArray: new r.Pointer(r.uint16, MarkArray),
                        ligatureArray: new r.Pointer(r.uint16, LigatureArray)
                    },
                    6: {
                        // MarkToMark Attachment Positioning
                        format: r.uint16,
                        mark1Coverage: new r.Pointer(r.uint16, Coverage),
                        mark2Coverage: new r.Pointer(r.uint16, Coverage),
                        classCount: r.uint16,
                        mark1Array: new r.Pointer(r.uint16, MarkArray),
                        mark2Array: new r.Pointer(r.uint16, BaseArray)
                    },
                    7: Context,
                    // Contextual positioning
                    8: ChainingContext,
                    // Chaining contextual positioning
                    9: {
                        // Extension Positioning
                        posFormat: r.uint16,
                        lookupType: r.uint16,
                        // cannot also be 9
                        extension: new r.Pointer(r.uint32, GPOSLookup)
                    }
                }); // Fix circular reference
                GPOSLookup.versions[9].extension.type = GPOSLookup;
                var GPOS = new r.VersionedStruct(r.uint32, {
                    header: {
                        scriptList: new r.Pointer(r.uint16, ScriptList),
                        featureList: new r.Pointer(r.uint16, FeatureList),
                        lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
                    },
                    0x00010000: {},
                    0x00010001: {
                        featureVariations: new r.Pointer(r.uint32, FeatureVariations)
                    }
                }); // export GPOSLookup for JSTF table
                var Sequence = new r.Array(r.uint16, r.uint16);
                var AlternateSet = Sequence;
                var Ligature = new r.Struct({
                    glyph: r.uint16,
                    compCount: r.uint16,
                    components: new r.Array(r.uint16, function(t) {
                        return t.compCount - 1;
                    })
                });
                var LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);
                var GSUBLookup = new r.VersionedStruct("lookupType", {
                    1: new r.VersionedStruct(r.uint16, {
                        // Single Substitution
                        1: {
                            coverage: new r.Pointer(r.uint16, Coverage),
                            deltaGlyphID: r.int16
                        },
                        2: {
                            coverage: new r.Pointer(r.uint16, Coverage),
                            glyphCount: r.uint16,
                            substitute: new r.LazyArray(r.uint16, "glyphCount")
                        }
                    }),
                    2: {
                        // Multiple Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        count: r.uint16,
                        sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), "count")
                    },
                    3: {
                        // Alternate Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        count: r.uint16,
                        alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), "count")
                    },
                    4: {
                        // Ligature Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        count: r.uint16,
                        ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), "count")
                    },
                    5: Context,
                    // Contextual Substitution
                    6: ChainingContext,
                    // Chaining Contextual Substitution
                    7: {
                        // Extension Substitution
                        substFormat: r.uint16,
                        lookupType: r.uint16,
                        // cannot also be 7
                        extension: new r.Pointer(r.uint32, GSUBLookup)
                    },
                    8: {
                        // Reverse Chaining Contextual Single Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), "backtrackGlyphCount"),
                        lookaheadGlyphCount: r.uint16,
                        lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), "lookaheadGlyphCount"),
                        glyphCount: r.uint16,
                        substitutes: new r.Array(r.uint16, "glyphCount")
                    }
                }); // Fix circular reference
                GSUBLookup.versions[7].extension.type = GSUBLookup;
                var GSUB = new r.VersionedStruct(r.uint32, {
                    header: {
                        scriptList: new r.Pointer(r.uint16, ScriptList),
                        featureList: new r.Pointer(r.uint16, FeatureList),
                        lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup))
                    },
                    0x00010000: {},
                    0x00010001: {
                        featureVariations: new r.Pointer(r.uint32, FeatureVariations)
                    }
                });
                var JstfGSUBModList = new r.Array(r.uint16, r.uint16);
                var JstfPriority = new r.Struct({
                    shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
                    extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
                });
                var JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);
                var JstfLangSysRecord = new r.Struct({
                    tag: new r.String(4),
                    jstfLangSys: new r.Pointer(r.uint16, JstfLangSys)
                });
                var JstfScript = new r.Struct({
                    extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)),
                    // array of glyphs to extend line length
                    defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
                    langSysCount: r.uint16,
                    langSysRecords: new r.Array(JstfLangSysRecord, "langSysCount")
                });
                var JstfScriptRecord = new r.Struct({
                    tag: new r.String(4),
                    script: new r.Pointer(r.uint16, JstfScript, {
                        type: "parent"
                    })
                });
                var JSTF = new r.Struct({
                    version: r.uint32,
                    // should be 0x00010000
                    scriptCount: r.uint16,
                    scriptList: new r.Array(JstfScriptRecord, "scriptCount")
                });
                var VariableSizeNumber = /*#__PURE__*/ function() {
                    function VariableSizeNumber(size) {
                        this._size = size;
                    }
                    var _proto11 = VariableSizeNumber.prototype;
                    _proto11.decode = function decode(stream, parent) {
                        switch(this.size(0, parent)){
                            case 1:
                                return stream.readUInt8();
                            case 2:
                                return stream.readUInt16BE();
                            case 3:
                                return stream.readUInt24BE();
                            case 4:
                                return stream.readUInt32BE();
                        }
                    };
                    _proto11.size = function size(val, parent) {
                        return utils.resolveLength(this._size, null, parent);
                    };
                    return VariableSizeNumber;
                }();
                var MapDataEntry = new r.Struct({
                    entry: new VariableSizeNumber(function(t) {
                        return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
                    }),
                    outerIndex: function outerIndex(t) {
                        return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
                    },
                    innerIndex: function innerIndex(t) {
                        return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
                    }
                });
                var DeltaSetIndexMap = new r.Struct({
                    entryFormat: r.uint16,
                    mapCount: r.uint16,
                    mapData: new r.Array(MapDataEntry, "mapCount")
                });
                var HVAR = new r.Struct({
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
                    advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                    LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                    RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap)
                });
                var Signature = new r.Struct({
                    format: r.uint32,
                    length: r.uint32,
                    offset: r.uint32
                });
                var SignatureBlock = new r.Struct({
                    reserved: new r.Reserved(r.uint16, 2),
                    cbSignature: r.uint32,
                    // Length (in bytes) of the PKCS#7 packet in pbSignature
                    signature: new r.Buffer("cbSignature")
                });
                var DSIG = new r.Struct({
                    ulVersion: r.uint32,
                    // Version number of the DSIG table (0x00000001)
                    usNumSigs: r.uint16,
                    // Number of signatures in the table
                    usFlag: r.uint16,
                    // Permission flags
                    signatures: new r.Array(Signature, "usNumSigs"),
                    signatureBlocks: new r.Array(SignatureBlock, "usNumSigs")
                });
                var GaspRange = new r.Struct({
                    rangeMaxPPEM: r.uint16,
                    // Upper limit of range, in ppem
                    rangeGaspBehavior: new r.Bitfield(r.uint16, [
                        // Flags describing desired rasterizer behavior
                        "grayscale",
                        "gridfit",
                        "symmetricSmoothing",
                        "symmetricGridfit" // only in version 1, for ClearType
                    ])
                });
                var gasp = new r.Struct({
                    version: r.uint16,
                    // set to 0
                    numRanges: r.uint16,
                    gaspRanges: new r.Array(GaspRange, "numRanges") // Sorted by ppem
                });
                var DeviceRecord = new r.Struct({
                    pixelSize: r.uint8,
                    maximumWidth: r.uint8,
                    widths: new r.Array(r.uint8, function(t) {
                        return t.parent.parent.maxp.numGlyphs;
                    })
                }); // The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
                var hdmx = new r.Struct({
                    version: r.uint16,
                    numRecords: r.int16,
                    sizeDeviceRecord: r.int32,
                    records: new r.Array(DeviceRecord, "numRecords")
                });
                var KernPair = new r.Struct({
                    left: r.uint16,
                    right: r.uint16,
                    value: r.int16
                });
                var ClassTable = new r.Struct({
                    firstGlyph: r.uint16,
                    nGlyphs: r.uint16,
                    offsets: new r.Array(r.uint16, "nGlyphs"),
                    max: function max(t) {
                        return t.offsets.length && Math.max.apply(Math, t.offsets);
                    }
                });
                var Kern2Array = new r.Struct({
                    off: function off(t) {
                        return t._startOffset - t.parent.parent._startOffset;
                    },
                    len: function len(t) {
                        return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
                    },
                    values: new r.LazyArray(r.int16, "len")
                });
                var KernSubtable = new r.VersionedStruct("format", {
                    0: {
                        nPairs: r.uint16,
                        searchRange: r.uint16,
                        entrySelector: r.uint16,
                        rangeShift: r.uint16,
                        pairs: new r.Array(KernPair, "nPairs")
                    },
                    2: {
                        rowWidth: r.uint16,
                        leftTable: new r.Pointer(r.uint16, ClassTable, {
                            type: "parent"
                        }),
                        rightTable: new r.Pointer(r.uint16, ClassTable, {
                            type: "parent"
                        }),
                        array: new r.Pointer(r.uint16, Kern2Array, {
                            type: "parent"
                        })
                    },
                    3: {
                        glyphCount: r.uint16,
                        kernValueCount: r.uint8,
                        leftClassCount: r.uint8,
                        rightClassCount: r.uint8,
                        flags: r.uint8,
                        kernValue: new r.Array(r.int16, "kernValueCount"),
                        leftClass: new r.Array(r.uint8, "glyphCount"),
                        rightClass: new r.Array(r.uint8, "glyphCount"),
                        kernIndex: new r.Array(r.uint8, function(t) {
                            return t.leftClassCount * t.rightClassCount;
                        })
                    }
                });
                var KernTable = new r.VersionedStruct("version", {
                    0: {
                        // Microsoft uses this format
                        subVersion: r.uint16,
                        // Microsoft has an extra sub-table version number
                        length: r.uint16,
                        // Length of the subtable, in bytes
                        format: r.uint8,
                        // Format of subtable
                        coverage: new r.Bitfield(r.uint8, [
                            "horizontal",
                            // 1 if table has horizontal data, 0 if vertical
                            "minimum",
                            // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
                            "crossStream",
                            // If set to 1, kerning is perpendicular to the flow of the text
                            "override" // If set to 1 the value in this table replaces the accumulated value
                        ]),
                        subtable: KernSubtable,
                        padding: new r.Reserved(r.uint8, function(t) {
                            return t.length - t._currentOffset;
                        })
                    },
                    1: {
                        // Apple uses this format
                        length: r.uint32,
                        coverage: new r.Bitfield(r.uint8, [
                            null,
                            null,
                            null,
                            null,
                            null,
                            "variation",
                            // Set if table has variation kerning values
                            "crossStream",
                            // Set if table has cross-stream kerning values
                            "vertical" // Set if table has vertical kerning values
                        ]),
                        format: r.uint8,
                        tupleIndex: r.uint16,
                        subtable: KernSubtable,
                        padding: new r.Reserved(r.uint8, function(t) {
                            return t.length - t._currentOffset;
                        })
                    }
                });
                var kern = new r.VersionedStruct(r.uint16, {
                    0: {
                        // Microsoft Version
                        nTables: r.uint16,
                        tables: new r.Array(KernTable, "nTables")
                    },
                    1: {
                        // Apple Version
                        reserved: new r.Reserved(r.uint16),
                        // the other half of the version number
                        nTables: r.uint32,
                        tables: new r.Array(KernTable, "nTables")
                    }
                });
                // Records the ppem for each glyph at which the scaling becomes linear again,
                // despite instructions effecting the advance width
                var LTSH = new r.Struct({
                    version: r.uint16,
                    numGlyphs: r.uint16,
                    yPels: new r.Array(r.uint8, "numGlyphs")
                });
                // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
                var PCLT = new r.Struct({
                    version: r.uint16,
                    fontNumber: r.uint32,
                    pitch: r.uint16,
                    xHeight: r.uint16,
                    style: r.uint16,
                    typeFamily: r.uint16,
                    capHeight: r.uint16,
                    symbolSet: r.uint16,
                    typeface: new r.String(16),
                    characterComplement: new r.String(8),
                    fileName: new r.String(6),
                    strokeWeight: new r.String(1),
                    widthType: new r.String(1),
                    serifStyle: r.uint8,
                    reserved: new r.Reserved(r.uint8)
                });
                // sizes. This is needed in order to match font metrics on Windows.
                var Ratio = new r.Struct({
                    bCharSet: r.uint8,
                    // Character set
                    xRatio: r.uint8,
                    // Value to use for x-Ratio
                    yStartRatio: r.uint8,
                    // Starting y-Ratio value
                    yEndRatio: r.uint8 // Ending y-Ratio value
                });
                var vTable = new r.Struct({
                    yPelHeight: r.uint16,
                    // yPelHeight to which values apply
                    yMax: r.int16,
                    // Maximum value (in pels) for this yPelHeight
                    yMin: r.int16 // Minimum value (in pels) for this yPelHeight
                });
                var VdmxGroup = new r.Struct({
                    recs: r.uint16,
                    // Number of height records in this group
                    startsz: r.uint8,
                    // Starting yPelHeight
                    endsz: r.uint8,
                    // Ending yPelHeight
                    entries: new r.Array(vTable, "recs") // The VDMX records
                });
                var VDMX = new r.Struct({
                    version: r.uint16,
                    // Version number (0 or 1)
                    numRecs: r.uint16,
                    // Number of VDMX groups present
                    numRatios: r.uint16,
                    // Number of aspect ratio groupings
                    ratioRanges: new r.Array(Ratio, "numRatios"),
                    // Ratio ranges
                    offsets: new r.Array(r.uint16, "numRatios"),
                    // Offset to the VDMX group for this ratio range
                    groups: new r.Array(VdmxGroup, "numRecs") // The actual VDMX groupings
                });
                var vhea = new r.Struct({
                    version: r.uint16,
                    // Version number of the Vertical Header Table
                    ascent: r.int16,
                    // The vertical typographic ascender for this font
                    descent: r.int16,
                    // The vertical typographic descender for this font
                    lineGap: r.int16,
                    // The vertical typographic line gap for this font
                    advanceHeightMax: r.int16,
                    // The maximum advance height measurement found in the font
                    minTopSideBearing: r.int16,
                    // The minimum top side bearing measurement found in the font
                    minBottomSideBearing: r.int16,
                    // The minimum bottom side bearing measurement found in the font
                    yMaxExtent: r.int16,
                    caretSlopeRise: r.int16,
                    // Caret slope (rise/run)
                    caretSlopeRun: r.int16,
                    caretOffset: r.int16,
                    // Set value equal to 0 for nonslanted fonts
                    reserved: new r.Reserved(r.int16, 4),
                    metricDataFormat: r.int16,
                    // Set to 0
                    numberOfMetrics: r.uint16 // Number of advance heights in the Vertical Metrics table
                });
                var VmtxEntry = new r.Struct({
                    advance: r.uint16,
                    // The advance height of the glyph
                    bearing: r.int16 // The top sidebearing of the glyph
                }); // Vertical Metrics Table
                var vmtx = new r.Struct({
                    metrics: new r.LazyArray(VmtxEntry, function(t) {
                        return t.parent.vhea.numberOfMetrics;
                    }),
                    bearings: new r.LazyArray(r.int16, function(t) {
                        return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
                    })
                });
                var shortFrac = new r.Fixed(16, "BE", 14);
                var Correspondence = new r.Struct({
                    fromCoord: shortFrac,
                    toCoord: shortFrac
                });
                var Segment = new r.Struct({
                    pairCount: r.uint16,
                    correspondence: new r.Array(Correspondence, "pairCount")
                });
                var avar = new r.Struct({
                    version: r.fixed32,
                    axisCount: r.uint32,
                    segment: new r.Array(Segment, "axisCount")
                });
                var UnboundedArrayAccessor = /*#__PURE__*/ function() {
                    function UnboundedArrayAccessor(type, stream, parent) {
                        this.type = type;
                        this.stream = stream;
                        this.parent = parent;
                        this.base = this.stream.pos;
                        this._items = [];
                    }
                    var _proto12 = UnboundedArrayAccessor.prototype;
                    _proto12.getItem = function getItem(index) {
                        if (this._items[index] == null) {
                            var pos = this.stream.pos;
                            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
                            this._items[index] = this.type.decode(this.stream, this.parent);
                            this.stream.pos = pos;
                        }
                        return this._items[index];
                    };
                    _proto12.inspect = function inspect() {
                        return "[UnboundedArray ".concat(this.type.constructor.name, "]");
                    };
                    return UnboundedArrayAccessor;
                }();
                var UnboundedArray = /*#__PURE__*/ function(_r$Array2) {
                    _inheritsLoose(UnboundedArray, _r$Array2);
                    function UnboundedArray(type) {
                        return _r$Array2.call(this, type, 0) || this;
                    }
                    var _proto13 = UnboundedArray.prototype;
                    _proto13.decode = function decode(stream, parent) {
                        return new UnboundedArrayAccessor(this.type, stream, parent);
                    };
                    return UnboundedArray;
                }(r.Array);
                var LookupTable = function LookupTable(ValueType) {
                    if (ValueType === void 0) ValueType = r.uint16;
                    // Helper class that makes internal structures invisible to pointers
                    var Shadow = /*#__PURE__*/ function() {
                        function Shadow(type) {
                            this.type = type;
                        }
                        var _proto14 = Shadow.prototype;
                        _proto14.decode = function decode(stream, ctx) {
                            ctx = ctx.parent.parent;
                            return this.type.decode(stream, ctx);
                        };
                        _proto14.size = function size(val, ctx) {
                            ctx = ctx.parent.parent;
                            return this.type.size(val, ctx);
                        };
                        _proto14.encode = function encode(stream, val, ctx) {
                            ctx = ctx.parent.parent;
                            return this.type.encode(stream, val, ctx);
                        };
                        return Shadow;
                    }();
                    ValueType = new Shadow(ValueType);
                    var BinarySearchHeader = new r.Struct({
                        unitSize: r.uint16,
                        nUnits: r.uint16,
                        searchRange: r.uint16,
                        entrySelector: r.uint16,
                        rangeShift: r.uint16
                    });
                    var LookupSegmentSingle = new r.Struct({
                        lastGlyph: r.uint16,
                        firstGlyph: r.uint16,
                        value: ValueType
                    });
                    var LookupSegmentArray = new r.Struct({
                        lastGlyph: r.uint16,
                        firstGlyph: r.uint16,
                        values: new r.Pointer(r.uint16, new r.Array(ValueType, function(t) {
                            return t.lastGlyph - t.firstGlyph + 1;
                        }), {
                            type: "parent"
                        })
                    });
                    var LookupSingle = new r.Struct({
                        glyph: r.uint16,
                        value: ValueType
                    });
                    return new r.VersionedStruct(r.uint16, {
                        0: {
                            values: new UnboundedArray(ValueType) // length == number of glyphs maybe?
                        },
                        2: {
                            binarySearchHeader: BinarySearchHeader,
                            segments: new r.Array(LookupSegmentSingle, function(t) {
                                return t.binarySearchHeader.nUnits;
                            })
                        },
                        4: {
                            binarySearchHeader: BinarySearchHeader,
                            segments: new r.Array(LookupSegmentArray, function(t) {
                                return t.binarySearchHeader.nUnits;
                            })
                        },
                        6: {
                            binarySearchHeader: BinarySearchHeader,
                            segments: new r.Array(LookupSingle, function(t) {
                                return t.binarySearchHeader.nUnits;
                            })
                        },
                        8: {
                            firstGlyph: r.uint16,
                            count: r.uint16,
                            values: new r.Array(ValueType, "count")
                        }
                    });
                };
                function StateTable(entryData, lookupType) {
                    if (entryData === void 0) entryData = {};
                    if (lookupType === void 0) lookupType = r.uint16;
                    var entry = Object.assign({
                        newState: r.uint16,
                        flags: r.uint16
                    }, entryData);
                    var Entry = new r.Struct(entry);
                    var StateArray = new UnboundedArray(new r.Array(r.uint16, function(t) {
                        return t.nClasses;
                    }));
                    var StateHeader = new r.Struct({
                        nClasses: r.uint32,
                        classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
                        stateArray: new r.Pointer(r.uint32, StateArray),
                        entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry))
                    });
                    return StateHeader;
                } // This is the old version of the StateTable structure
                function StateTable1(entryData, lookupType) {
                    if (entryData === void 0) entryData = {};
                    if (lookupType === void 0) lookupType = r.uint16;
                    var ClassLookupTable = new r.Struct({
                        version: function version() {
                            return 8;
                        },
                        // simulate LookupTable
                        firstGlyph: r.uint16,
                        values: new r.Array(r.uint8, r.uint16)
                    });
                    var entry = Object.assign({
                        newStateOffset: r.uint16,
                        // convert offset to stateArray index
                        newState: function newState(t) {
                            return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
                        },
                        flags: r.uint16
                    }, entryData);
                    var Entry = new r.Struct(entry);
                    var StateArray = new UnboundedArray(new r.Array(r.uint8, function(t) {
                        return t.nClasses;
                    }));
                    var StateHeader1 = new r.Struct({
                        nClasses: r.uint16,
                        classTable: new r.Pointer(r.uint16, ClassLookupTable),
                        stateArray: new r.Pointer(r.uint16, StateArray),
                        entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry))
                    });
                    return StateHeader1;
                }
                var BslnSubtable = new r.VersionedStruct("format", {
                    0: {
                        // Distance-based, no mapping
                        deltas: new r.Array(r.int16, 32)
                    },
                    1: {
                        // Distance-based, with mapping
                        deltas: new r.Array(r.int16, 32),
                        mappingData: new LookupTable(r.uint16)
                    },
                    2: {
                        // Control point-based, no mapping
                        standardGlyph: r.uint16,
                        controlPoints: new r.Array(r.uint16, 32)
                    },
                    3: {
                        // Control point-based, with mapping
                        standardGlyph: r.uint16,
                        controlPoints: new r.Array(r.uint16, 32),
                        mappingData: new LookupTable(r.uint16)
                    }
                });
                var bsln = new r.Struct({
                    version: r.fixed32,
                    format: r.uint16,
                    defaultBaseline: r.uint16,
                    subtable: BslnSubtable
                });
                var Setting = new r.Struct({
                    setting: r.uint16,
                    nameIndex: r.int16,
                    name: function name(t) {
                        return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
                    }
                });
                var FeatureName = new r.Struct({
                    feature: r.uint16,
                    nSettings: r.uint16,
                    settingTable: new r.Pointer(r.uint32, new r.Array(Setting, "nSettings"), {
                        type: "parent"
                    }),
                    featureFlags: new r.Bitfield(r.uint8, [
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        "hasDefault",
                        "exclusive"
                    ]),
                    defaultSetting: r.uint8,
                    nameIndex: r.int16,
                    name: function name(t) {
                        return t.parent.parent.name.records.fontFeatures[t.nameIndex];
                    }
                });
                var feat = new r.Struct({
                    version: r.fixed32,
                    featureNameCount: r.uint16,
                    reserved1: new r.Reserved(r.uint16),
                    reserved2: new r.Reserved(r.uint32),
                    featureNames: new r.Array(FeatureName, "featureNameCount")
                });
                var Axis$1 = new r.Struct({
                    axisTag: new r.String(4),
                    minValue: r.fixed32,
                    defaultValue: r.fixed32,
                    maxValue: r.fixed32,
                    flags: r.uint16,
                    nameID: r.uint16,
                    name: function name(t) {
                        return t.parent.parent.name.records.fontFeatures[t.nameID];
                    }
                });
                var Instance = new r.Struct({
                    nameID: r.uint16,
                    name: function name(t) {
                        return t.parent.parent.name.records.fontFeatures[t.nameID];
                    },
                    flags: r.uint16,
                    coord: new r.Array(r.fixed32, function(t) {
                        return t.parent.axisCount;
                    }),
                    postscriptNameID: new r.Optional(r.uint16, function(t) {
                        return t.parent.instanceSize - t._currentOffset > 0;
                    })
                });
                var fvar = new r.Struct({
                    version: r.fixed32,
                    offsetToData: r.uint16,
                    countSizePairs: r.uint16,
                    axisCount: r.uint16,
                    axisSize: r.uint16,
                    instanceCount: r.uint16,
                    instanceSize: r.uint16,
                    axis: new r.Array(Axis$1, "axisCount"),
                    instance: new r.Array(Instance, "instanceCount")
                });
                var shortFrac$1 = new r.Fixed(16, "BE", 14);
                var Offset = /*#__PURE__*/ function() {
                    function Offset() {}
                    Offset.decode = function decode(stream, parent) {
                        // In short format, offsets are multiplied by 2.
                        // This doesn't seem to be documented by Apple, but it
                        // is implemented this way in Freetype.
                        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
                    };
                    return Offset;
                }();
                var gvar = new r.Struct({
                    version: r.uint16,
                    reserved: new r.Reserved(r.uint16),
                    axisCount: r.uint16,
                    globalCoordCount: r.uint16,
                    globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, "axisCount"), "globalCoordCount")),
                    glyphCount: r.uint16,
                    flags: r.uint16,
                    offsetToData: r.uint32,
                    offsets: new r.Array(new r.Pointer(Offset, "void", {
                        relativeTo: function relativeTo(ctx) {
                            return ctx.offsetToData;
                        },
                        allowNull: false
                    }), function(t) {
                        return t.glyphCount + 1;
                    })
                });
                var ClassTable$1 = new r.Struct({
                    length: r.uint16,
                    coverage: r.uint16,
                    subFeatureFlags: r.uint32,
                    stateTable: new StateTable1()
                });
                var WidthDeltaRecord = new r.Struct({
                    justClass: r.uint32,
                    beforeGrowLimit: r.fixed32,
                    beforeShrinkLimit: r.fixed32,
                    afterGrowLimit: r.fixed32,
                    afterShrinkLimit: r.fixed32,
                    growFlags: r.uint16,
                    shrinkFlags: r.uint16
                });
                var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);
                var ActionData = new r.VersionedStruct("actionType", {
                    0: {
                        // Decomposition action
                        lowerLimit: r.fixed32,
                        upperLimit: r.fixed32,
                        order: r.uint16,
                        glyphs: new r.Array(r.uint16, r.uint16)
                    },
                    1: {
                        // Unconditional add glyph action
                        addGlyph: r.uint16
                    },
                    2: {
                        // Conditional add glyph action
                        substThreshold: r.fixed32,
                        addGlyph: r.uint16,
                        substGlyph: r.uint16
                    },
                    3: {},
                    // Stretch glyph action (no data, not supported by CoreText)
                    4: {
                        // Ductile glyph action (not supported by CoreText)
                        variationAxis: r.uint32,
                        minimumLimit: r.fixed32,
                        noStretchValue: r.fixed32,
                        maximumLimit: r.fixed32
                    },
                    5: {
                        // Repeated add glyph action
                        flags: r.uint16,
                        glyph: r.uint16
                    }
                });
                var Action = new r.Struct({
                    actionClass: r.uint16,
                    actionType: r.uint16,
                    actionLength: r.uint32,
                    actionData: ActionData,
                    padding: new r.Reserved(r.uint8, function(t) {
                        return t.actionLength - t._currentOffset;
                    })
                });
                var PostcompensationAction = new r.Array(Action, r.uint32);
                var PostCompensationTable = new r.Struct({
                    lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction))
                });
                var JustificationTable = new r.Struct({
                    classTable: new r.Pointer(r.uint16, ClassTable$1, {
                        type: "parent"
                    }),
                    wdcOffset: r.uint16,
                    postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, {
                        type: "parent"
                    }),
                    widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, {
                        type: "parent",
                        relativeTo: function relativeTo(ctx) {
                            return ctx.wdcOffset;
                        }
                    }))
                });
                var just = new r.Struct({
                    version: r.uint32,
                    format: r.uint16,
                    horizontal: new r.Pointer(r.uint16, JustificationTable),
                    vertical: new r.Pointer(r.uint16, JustificationTable)
                });
                var LigatureData = {
                    action: r.uint16
                };
                var ContextualData = {
                    markIndex: r.uint16,
                    currentIndex: r.uint16
                };
                var InsertionData = {
                    currentInsertIndex: r.uint16,
                    markedInsertIndex: r.uint16
                };
                var SubstitutionTable = new r.Struct({
                    items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable()))
                });
                var SubtableData = new r.VersionedStruct("type", {
                    0: {
                        // Indic Rearrangement Subtable
                        stateTable: new StateTable()
                    },
                    1: {
                        // Contextual Glyph Substitution Subtable
                        stateTable: new StateTable(ContextualData),
                        substitutionTable: new r.Pointer(r.uint32, SubstitutionTable)
                    },
                    2: {
                        // Ligature subtable
                        stateTable: new StateTable(LigatureData),
                        ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
                        components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
                        ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
                    },
                    4: {
                        // Non-contextual Glyph Substitution Subtable
                        lookupTable: new LookupTable()
                    },
                    5: {
                        // Glyph Insertion Subtable
                        stateTable: new StateTable(InsertionData),
                        insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
                    }
                });
                var Subtable = new r.Struct({
                    length: r.uint32,
                    coverage: r.uint24,
                    type: r.uint8,
                    subFeatureFlags: r.uint32,
                    table: SubtableData,
                    padding: new r.Reserved(r.uint8, function(t) {
                        return t.length - t._currentOffset;
                    })
                });
                var FeatureEntry = new r.Struct({
                    featureType: r.uint16,
                    featureSetting: r.uint16,
                    enableFlags: r.uint32,
                    disableFlags: r.uint32
                });
                var MorxChain = new r.Struct({
                    defaultFlags: r.uint32,
                    chainLength: r.uint32,
                    nFeatureEntries: r.uint32,
                    nSubtables: r.uint32,
                    features: new r.Array(FeatureEntry, "nFeatureEntries"),
                    subtables: new r.Array(Subtable, "nSubtables")
                });
                var morx = new r.Struct({
                    version: r.uint16,
                    unused: new r.Reserved(r.uint16),
                    nChains: r.uint32,
                    chains: new r.Array(MorxChain, "nChains")
                });
                var OpticalBounds = new r.Struct({
                    left: r.int16,
                    top: r.int16,
                    right: r.int16,
                    bottom: r.int16
                });
                var opbd = new r.Struct({
                    version: r.fixed32,
                    format: r.uint16,
                    lookupTable: new LookupTable(OpticalBounds)
                });
                var tables = {};
                tables.cmap = cmap;
                tables.head = head;
                tables.hhea = hhea;
                tables.hmtx = hmtx;
                tables.maxp = maxp;
                tables.name = NameTable;
                tables["OS/2"] = OS2;
                tables.post = post; // TrueType Outlines
                tables.fpgm = fpgm;
                tables.loca = loca;
                tables.prep = prep;
                tables["cvt "] = cvt;
                tables.glyf = glyf; // PostScript Outlines
                tables["CFF "] = CFFFont;
                tables["CFF2"] = CFFFont;
                tables.VORG = VORG; // Bitmap Glyphs
                tables.EBLC = EBLC;
                tables.CBLC = tables.EBLC;
                tables.sbix = sbix;
                tables.COLR = COLR;
                tables.CPAL = CPAL; // Advanced OpenType Tables
                tables.BASE = BASE;
                tables.GDEF = GDEF;
                tables.GPOS = GPOS;
                tables.GSUB = GSUB;
                tables.JSTF = JSTF; // OpenType variations tables
                tables.HVAR = HVAR; // Other OpenType Tables
                tables.DSIG = DSIG;
                tables.gasp = gasp;
                tables.hdmx = hdmx;
                tables.kern = kern;
                tables.LTSH = LTSH;
                tables.PCLT = PCLT;
                tables.VDMX = VDMX;
                tables.vhea = vhea;
                tables.vmtx = vmtx; // Apple Advanced Typography Tables
                tables.avar = avar;
                tables.bsln = bsln;
                tables.feat = feat;
                tables.fvar = fvar;
                tables.gvar = gvar;
                tables.just = just;
                tables.morx = morx;
                tables.opbd = opbd;
                var TableEntry = new r.Struct({
                    tag: new r.String(4),
                    checkSum: r.uint32,
                    offset: new r.Pointer(r.uint32, "void", {
                        type: "global"
                    }),
                    length: r.uint32
                });
                var Directory = new r.Struct({
                    tag: new r.String(4),
                    numTables: r.uint16,
                    searchRange: r.uint16,
                    entrySelector: r.uint16,
                    rangeShift: r.uint16,
                    tables: new r.Array(TableEntry, "numTables")
                });
                Directory.process = function() {
                    var tables = {};
                    for(var _iterator9 = _createForOfIteratorHelperLoose(this.tables), _step9; !(_step9 = _iterator9()).done;){
                        var table = _step9.value;
                        tables[table.tag] = table;
                    }
                    this.tables = tables;
                };
                Directory.preEncode = function(stream) {
                    var tables$1 = [];
                    for(var tag in this.tables){
                        var table = this.tables[tag];
                        if (table) tables$1.push({
                            tag: tag,
                            checkSum: 0,
                            offset: new r.VoidPointer(tables[tag], table),
                            length: tables[tag].size(table)
                        });
                    }
                    this.tag = "true";
                    this.numTables = tables$1.length;
                    this.tables = tables$1;
                    var maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
                    var maxPowerOf2 = Math.pow(2, maxExponentFor2);
                    this.searchRange = maxPowerOf2 * 16;
                    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
                    this.rangeShift = this.numTables * 16 - this.searchRange;
                };
                function binarySearch(arr, cmp) {
                    var min = 0;
                    var max = arr.length - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var res = cmp(arr[mid]);
                        if (res < 0) max = mid - 1;
                        else if (res > 0) min = mid + 1;
                        else return mid;
                    }
                    return -1;
                }
                function range(index, end) {
                    var range = [];
                    while(index < end)range.push(index++);
                    return range;
                }
                var _class;
                try {
                    var iconv = __webpack_require__(32766);
                } catch (err) {}
                var CmapProcessor = (_class = /*#__PURE__*/ function() {
                    function CmapProcessor(cmapTable) {
                        // Attempt to find a Unicode cmap first
                        this.encoding = null;
                        this.cmap = this.findSubtable(cmapTable, [
                            // 32-bit subtables
                            [
                                3,
                                10
                            ],
                            [
                                0,
                                6
                            ],
                            [
                                0,
                                4
                            ],
                            // 16-bit subtables
                            [
                                3,
                                1
                            ],
                            [
                                0,
                                3
                            ],
                            [
                                0,
                                2
                            ],
                            [
                                0,
                                1
                            ],
                            [
                                0,
                                0
                            ]
                        ]); // If not unicode cmap was found, and iconv-lite is installed,
                        // take the first table with a supported encoding.
                        if (!this.cmap && iconv) for(var _iterator10 = _createForOfIteratorHelperLoose(cmapTable.tables), _step10; !(_step10 = _iterator10()).done;){
                            var cmap = _step10.value;
                            var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
                            if (iconv.encodingExists(encoding)) {
                                this.cmap = cmap.table;
                                this.encoding = encoding;
                            }
                        }
                        if (!this.cmap) throw new Error("Could not find a supported cmap table");
                        this.uvs = this.findSubtable(cmapTable, [
                            [
                                0,
                                5
                            ]
                        ]);
                        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
                    }
                    var _proto15 = CmapProcessor.prototype;
                    _proto15.findSubtable = function findSubtable(cmapTable, pairs) {
                        for(var _iterator11 = _createForOfIteratorHelperLoose(pairs), _step11; !(_step11 = _iterator11()).done;){
                            var _step11$value = _step11.value, platformID = _step11$value[0], encodingID = _step11$value[1];
                            for(var _iterator12 = _createForOfIteratorHelperLoose(cmapTable.tables), _step12; !(_step12 = _iterator12()).done;){
                                var cmap = _step12.value;
                                if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
                            }
                        }
                        return null;
                    };
                    _proto15.lookup = function lookup(codepoint, variationSelector) {
                        // If there is no Unicode cmap in this font, we need to re-encode
                        // the codepoint in the encoding that the cmap supports.
                        if (this.encoding) {
                            var buf = iconv.encode(String.fromCodePoint(codepoint), this.encoding);
                            codepoint = 0;
                            for(var i = 0; i < buf.length; i++)codepoint = codepoint << 8 | buf[i];
                             // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
                        } else if (variationSelector) {
                            var gid = this.getVariationSelector(codepoint, variationSelector);
                            if (gid) return gid;
                        }
                        var cmap = this.cmap;
                        switch(cmap.version){
                            case 0:
                                return cmap.codeMap.get(codepoint) || 0;
                            case 4:
                                var min = 0;
                                var max = cmap.segCount - 1;
                                while(min <= max){
                                    var mid = min + max >> 1;
                                    if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                                    else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                                    else {
                                        var rangeOffset = cmap.idRangeOffset.get(mid);
                                        var _gid = void 0;
                                        if (rangeOffset === 0) _gid = codepoint + cmap.idDelta.get(mid);
                                        else {
                                            var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                            _gid = cmap.glyphIndexArray.get(index) || 0;
                                            if (_gid !== 0) _gid += cmap.idDelta.get(mid);
                                        }
                                        return _gid & 0xffff;
                                    }
                                }
                                return 0;
                            case 8:
                                throw new Error("TODO: cmap format 8");
                            case 6:
                            case 10:
                                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
                            case 12:
                            case 13:
                                var _min = 0;
                                var _max = cmap.nGroups - 1;
                                while(_min <= _max){
                                    var _mid = _min + _max >> 1;
                                    var group = cmap.groups.get(_mid);
                                    if (codepoint < group.startCharCode) _max = _mid - 1;
                                    else if (codepoint > group.endCharCode) _min = _mid + 1;
                                    else {
                                        if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                                        else return group.glyphID;
                                    }
                                }
                                return 0;
                            case 14:
                                throw new Error("TODO: cmap format 14");
                            default:
                                throw new Error("Unknown cmap format ".concat(cmap.version));
                        }
                    };
                    _proto15.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
                        if (!this.uvs) return 0;
                        var selectors = this.uvs.varSelectors.toArray();
                        var i = binarySearch(selectors, function(x) {
                            return variationSelector - x.varSelector;
                        });
                        var sel = selectors[i];
                        if (i !== -1 && sel.defaultUVS) i = binarySearch(sel.defaultUVS, function(x) {
                            return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0;
                        });
                        if (i !== -1 && sel.nonDefaultUVS) {
                            i = binarySearch(sel.nonDefaultUVS, function(x) {
                                return codepoint - x.unicodeValue;
                            });
                            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
                        }
                        return 0;
                    };
                    _proto15.getCharacterSet = function getCharacterSet() {
                        var cmap = this.cmap;
                        switch(cmap.version){
                            case 0:
                                return range(0, cmap.codeMap.length);
                            case 4:
                                var res = [];
                                var endCodes = cmap.endCode.toArray();
                                for(var i = 0; i < endCodes.length; i++){
                                    var tail = endCodes[i] + 1;
                                    var start = cmap.startCode.get(i);
                                    res.push.apply(res, range(start, tail));
                                }
                                return res;
                            case 8:
                                throw new Error("TODO: cmap format 8");
                            case 6:
                            case 10:
                                return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
                            case 12:
                            case 13:
                                var _res = [];
                                for(var _iterator13 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step13; !(_step13 = _iterator13()).done;){
                                    var group = _step13.value;
                                    _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
                                }
                                return _res;
                            case 14:
                                throw new Error("TODO: cmap format 14");
                            default:
                                throw new Error("Unknown cmap format ".concat(cmap.version));
                        }
                    };
                    _proto15.codePointsForGlyph = function codePointsForGlyph(gid) {
                        var cmap = this.cmap;
                        switch(cmap.version){
                            case 0:
                                var res = [];
                                for(var i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                                return res;
                            case 4:
                                var _res2 = [];
                                for(var _i = 0; _i < cmap.segCount; _i++){
                                    var end = cmap.endCode.get(_i);
                                    var start = cmap.startCode.get(_i);
                                    var rangeOffset = cmap.idRangeOffset.get(_i);
                                    var delta = cmap.idDelta.get(_i);
                                    for(var c = start; c <= end; c++){
                                        var g = 0;
                                        if (rangeOffset === 0) g = c + delta;
                                        else {
                                            var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i);
                                            g = cmap.glyphIndexArray.get(index) || 0;
                                            if (g !== 0) g += delta;
                                        }
                                        if (g === gid) _res2.push(c);
                                    }
                                }
                                return _res2;
                            case 12:
                                var _res3 = [];
                                for(var _iterator14 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step14; !(_step14 = _iterator14()).done;){
                                    var group = _step14.value;
                                    if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) _res3.push(group.startCharCode + (gid - group.glyphID));
                                }
                                return _res3;
                            case 13:
                                var _res4 = [];
                                for(var _iterator15 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step15; !(_step15 = _iterator15()).done;){
                                    var _group = _step15.value;
                                    if (gid === _group.glyphID) _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
                                }
                                return _res4;
                            default:
                                throw new Error("Unknown cmap format ".concat(cmap.version));
                        }
                    };
                    return CmapProcessor;
                }(), _applyDecoratedDescriptor(_class.prototype, "getCharacterSet", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class.prototype, "getCharacterSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "codePointsForGlyph", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class.prototype, "codePointsForGlyph"), _class.prototype), _class);
                var KernProcessor = /*#__PURE__*/ function() {
                    function KernProcessor(font) {
                        this.kern = font.kern;
                    }
                    var _proto16 = KernProcessor.prototype;
                    _proto16.process = function process(glyphs, positions) {
                        for(var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
                            var left = glyphs[glyphIndex].id;
                            var right = glyphs[glyphIndex + 1].id;
                            positions[glyphIndex].xAdvance += this.getKerning(left, right);
                        }
                    };
                    _proto16.getKerning = function getKerning(left, right) {
                        var res = 0;
                        for(var _iterator16 = _createForOfIteratorHelperLoose(this.kern.tables), _step16; !(_step16 = _iterator16()).done;){
                            var table = _step16.value;
                            if (table.coverage.crossStream) continue;
                            switch(table.version){
                                case 0:
                                    if (!table.coverage.horizontal) continue;
                                    break;
                                case 1:
                                    if (table.coverage.vertical || table.coverage.variation) continue;
                                    break;
                                default:
                                    throw new Error("Unsupported kerning table version ".concat(table.version));
                            }
                            var val = 0;
                            var s = table.subtable;
                            switch(table.format){
                                case 0:
                                    var pairIdx = binarySearch(s.pairs, function(pair) {
                                        return left - pair.left || right - pair.right;
                                    });
                                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                                    break;
                                case 2:
                                    var leftOffset = 0, rightOffset = 0;
                                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                                    else leftOffset = s.array.off;
                                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                                    var index = (leftOffset + rightOffset - s.array.off) / 2;
                                    val = s.array.values.get(index);
                                    break;
                                case 3:
                                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                                    break;
                                default:
                                    throw new Error("Unsupported kerning sub-table format ".concat(table.format));
                            } // Microsoft supports the override flag, which resets the result
                            // Otherwise, the sum of the results from all subtables is returned
                            if (table.coverage.override) res = val;
                            else res += val;
                        }
                        return res;
                    };
                    return KernProcessor;
                }();
                /**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */ var UnicodeLayoutEngine = /*#__PURE__*/ function() {
                    function UnicodeLayoutEngine(font) {
                        this.font = font;
                    }
                    var _proto17 = UnicodeLayoutEngine.prototype;
                    _proto17.positionGlyphs = function positionGlyphs(glyphs, positions) {
                        // find each base + mark cluster, and position the marks relative to the base
                        var clusterStart = 0;
                        var clusterEnd = 0;
                        for(var index = 0; index < glyphs.length; index++){
                            var glyph = glyphs[index];
                            if (glyph.isMark) // TODO: handle ligatures
                            clusterEnd = index;
                            else {
                                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                                clusterStart = clusterEnd = index;
                            }
                        }
                        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                        return positions;
                    };
                    _proto17.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
                        var base = glyphs[clusterStart];
                        var baseBox = base.cbox.copy(); // adjust bounding box for ligature glyphs
                        if (base.codePoints.length > 1) // LTR. TODO: RTL support.
                        baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
                        var xOffset = -positions[clusterStart].xAdvance;
                        var yOffset = 0;
                        var yGap = this.font.unitsPerEm / 16; // position each of the mark glyphs relative to the base glyph
                        for(var index = clusterStart + 1; index <= clusterEnd; index++){
                            var mark = glyphs[index];
                            var markBox = mark.cbox;
                            var position = positions[index];
                            var combiningClass = this.getCombiningClass(mark.codePoints[0]);
                            if (combiningClass !== "Not_Reordered") {
                                position.xOffset = position.yOffset = 0; // x positioning
                                switch(combiningClass){
                                    case "Double_Above":
                                    case "Double_Below":
                                        // LTR. TODO: RTL support.
                                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                                        break;
                                    case "Attached_Below_Left":
                                    case "Below_Left":
                                    case "Above_Left":
                                        // left align
                                        position.xOffset += baseBox.minX - markBox.minX;
                                        break;
                                    case "Attached_Above_Right":
                                    case "Below_Right":
                                    case "Above_Right":
                                        // right align
                                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                                        break;
                                    default:
                                        // Attached_Below, Attached_Above, Below, Above, other
                                        // center align
                                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                                } // y positioning
                                switch(combiningClass){
                                    case "Double_Below":
                                    case "Below_Left":
                                    case "Below":
                                    case "Below_Right":
                                    case "Attached_Below_Left":
                                    case "Attached_Below":
                                        // add a small gap between the glyphs if they are not attached
                                        if (combiningClass === "Attached_Below_Left" || combiningClass === "Attached_Below") baseBox.minY += yGap;
                                        position.yOffset = -baseBox.minY - markBox.maxY;
                                        baseBox.minY += markBox.height;
                                        break;
                                    case "Double_Above":
                                    case "Above_Left":
                                    case "Above":
                                    case "Above_Right":
                                    case "Attached_Above":
                                    case "Attached_Above_Right":
                                        // add a small gap between the glyphs if they are not attached
                                        if (combiningClass === "Attached_Above" || combiningClass === "Attached_Above_Right") baseBox.maxY += yGap;
                                        position.yOffset = baseBox.maxY - markBox.minY;
                                        baseBox.maxY += markBox.height;
                                        break;
                                }
                                position.xAdvance = position.yAdvance = 0;
                                position.xOffset += xOffset;
                                position.yOffset += yOffset;
                            } else {
                                xOffset -= position.xAdvance;
                                yOffset -= position.yAdvance;
                            }
                        }
                        return;
                    };
                    _proto17.getCombiningClass = function getCombiningClass(codePoint) {
                        var combiningClass = unicode.getCombiningClass(codePoint); // Thai / Lao need some per-character work
                        if ((codePoint & -256) === 0x0e00) {
                            if (combiningClass === "Not_Reordered") switch(codePoint){
                                case 0x0e31:
                                case 0x0e34:
                                case 0x0e35:
                                case 0x0e36:
                                case 0x0e37:
                                case 0x0e47:
                                case 0x0e4c:
                                case 0x0e3d:
                                case 0x0e4e:
                                    return "Above_Right";
                                case 0x0eb1:
                                case 0x0eb4:
                                case 0x0eb5:
                                case 0x0eb6:
                                case 0x0eb7:
                                case 0x0ebb:
                                case 0x0ecc:
                                case 0x0ecd:
                                    return "Above";
                                case 0x0ebc:
                                    return "Below";
                            }
                            else if (codePoint === 0x0e3a) // virama
                            return "Below_Right";
                        }
                        switch(combiningClass){
                            // Hebrew
                            case "CCC10":
                            case "CCC11":
                            case "CCC12":
                            case "CCC13":
                            case "CCC14":
                            case "CCC15":
                            case "CCC16":
                            case "CCC17":
                            case "CCC18":
                            case "CCC20":
                            case "CCC22":
                                // meteg
                                return "Below";
                            case "CCC23":
                                // rafe
                                return "Attached_Above";
                            case "CCC24":
                                // shin dot
                                return "Above_Right";
                            case "CCC25":
                            case "CCC19":
                                // holam
                                return "Above_Left";
                            case "CCC26":
                                // point varika
                                return "Above";
                            case "CCC21":
                                break;
                            // Arabic and Syriac
                            case "CCC27":
                            case "CCC28":
                            case "CCC30":
                            case "CCC31":
                            case "CCC33":
                            case "CCC34":
                            case "CCC35":
                            case "CCC36":
                                // superscript alaph
                                return "Above";
                            case "CCC29":
                            case "CCC32":
                                // kasra
                                return "Below";
                            // Thai
                            case "CCC103":
                                // sara u / sara uu
                                return "Below_Right";
                            case "CCC107":
                                // mai
                                return "Above_Right";
                            // Lao
                            case "CCC118":
                                // sign u / sign uu
                                return "Below";
                            case "CCC122":
                                // mai
                                return "Above";
                            // Tibetan
                            case "CCC129":
                            case "CCC132":
                                // sign u
                                return "Below";
                            case "CCC130":
                                // sign i
                                return "Above";
                        }
                        return combiningClass;
                    };
                    return UnicodeLayoutEngine;
                }();
                /**
 * Represents a glyph bounding box
 */ var BBox = /*#__PURE__*/ function() {
                    function BBox(minX, minY, maxX, maxY) {
                        if (minX === void 0) minX = Infinity;
                        if (minY === void 0) minY = Infinity;
                        if (maxX === void 0) maxX = -Infinity;
                        if (maxY === void 0) maxY = -Infinity;
                        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
                        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
                        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
                        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
                    }
                    /**
   * The width of the bounding box
   * @type {number}
   */ var _proto18 = BBox.prototype;
                    _proto18.addPoint = function addPoint(x, y) {
                        if (Math.abs(x) !== Infinity) {
                            if (x < this.minX) this.minX = x;
                            if (x > this.maxX) this.maxX = x;
                        }
                        if (Math.abs(y) !== Infinity) {
                            if (y < this.minY) this.minY = y;
                            if (y > this.maxY) this.maxY = y;
                        }
                    };
                    _proto18.copy = function copy() {
                        return new BBox(this.minX, this.minY, this.maxX, this.maxY);
                    };
                    _createClass(BBox, [
                        {
                            key: "width",
                            get: function get() {
                                return this.maxX - this.minX;
                            }
                        },
                        {
                            key: "height",
                            get: function get() {
                                return this.maxY - this.minY;
                            }
                        }
                    ]);
                    return BBox;
                }(); // Data from http://www.microsoft.com/typography/otspec/scripttags.htm
                // and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
                var UNICODE_SCRIPTS = {
                    Caucasian_Albanian: "aghb",
                    Arabic: "arab",
                    Imperial_Aramaic: "armi",
                    Armenian: "armn",
                    Avestan: "avst",
                    Balinese: "bali",
                    Bamum: "bamu",
                    Bassa_Vah: "bass",
                    Batak: "batk",
                    Bengali: [
                        "bng2",
                        "beng"
                    ],
                    Bopomofo: "bopo",
                    Brahmi: "brah",
                    Braille: "brai",
                    Buginese: "bugi",
                    Buhid: "buhd",
                    Chakma: "cakm",
                    Canadian_Aboriginal: "cans",
                    Carian: "cari",
                    Cham: "cham",
                    Cherokee: "cher",
                    Coptic: "copt",
                    Cypriot: "cprt",
                    Cyrillic: "cyrl",
                    Devanagari: [
                        "dev2",
                        "deva"
                    ],
                    Deseret: "dsrt",
                    Duployan: "dupl",
                    Egyptian_Hieroglyphs: "egyp",
                    Elbasan: "elba",
                    Ethiopic: "ethi",
                    Georgian: "geor",
                    Glagolitic: "glag",
                    Gothic: "goth",
                    Grantha: "gran",
                    Greek: "grek",
                    Gujarati: [
                        "gjr2",
                        "gujr"
                    ],
                    Gurmukhi: [
                        "gur2",
                        "guru"
                    ],
                    Hangul: "hang",
                    Han: "hani",
                    Hanunoo: "hano",
                    Hebrew: "hebr",
                    Hiragana: "hira",
                    Pahawh_Hmong: "hmng",
                    Katakana_Or_Hiragana: "hrkt",
                    Old_Italic: "ital",
                    Javanese: "java",
                    Kayah_Li: "kali",
                    Katakana: "kana",
                    Kharoshthi: "khar",
                    Khmer: "khmr",
                    Khojki: "khoj",
                    Kannada: [
                        "knd2",
                        "knda"
                    ],
                    Kaithi: "kthi",
                    Tai_Tham: "lana",
                    Lao: "lao ",
                    Latin: "latn",
                    Lepcha: "lepc",
                    Limbu: "limb",
                    Linear_A: "lina",
                    Linear_B: "linb",
                    Lisu: "lisu",
                    Lycian: "lyci",
                    Lydian: "lydi",
                    Mahajani: "mahj",
                    Mandaic: "mand",
                    Manichaean: "mani",
                    Mende_Kikakui: "mend",
                    Meroitic_Cursive: "merc",
                    Meroitic_Hieroglyphs: "mero",
                    Malayalam: [
                        "mlm2",
                        "mlym"
                    ],
                    Modi: "modi",
                    Mongolian: "mong",
                    Mro: "mroo",
                    Meetei_Mayek: "mtei",
                    Myanmar: [
                        "mym2",
                        "mymr"
                    ],
                    Old_North_Arabian: "narb",
                    Nabataean: "nbat",
                    Nko: "nko ",
                    Ogham: "ogam",
                    Ol_Chiki: "olck",
                    Old_Turkic: "orkh",
                    Oriya: [
                        "ory2",
                        "orya"
                    ],
                    Osmanya: "osma",
                    Palmyrene: "palm",
                    Pau_Cin_Hau: "pauc",
                    Old_Permic: "perm",
                    Phags_Pa: "phag",
                    Inscriptional_Pahlavi: "phli",
                    Psalter_Pahlavi: "phlp",
                    Phoenician: "phnx",
                    Miao: "plrd",
                    Inscriptional_Parthian: "prti",
                    Rejang: "rjng",
                    Runic: "runr",
                    Samaritan: "samr",
                    Old_South_Arabian: "sarb",
                    Saurashtra: "saur",
                    Shavian: "shaw",
                    Sharada: "shrd",
                    Siddham: "sidd",
                    Khudawadi: "sind",
                    Sinhala: "sinh",
                    Sora_Sompeng: "sora",
                    Sundanese: "sund",
                    Syloti_Nagri: "sylo",
                    Syriac: "syrc",
                    Tagbanwa: "tagb",
                    Takri: "takr",
                    Tai_Le: "tale",
                    New_Tai_Lue: "talu",
                    Tamil: [
                        "tml2",
                        "taml"
                    ],
                    Tai_Viet: "tavt",
                    Telugu: [
                        "tel2",
                        "telu"
                    ],
                    Tifinagh: "tfng",
                    Tagalog: "tglg",
                    Thaana: "thaa",
                    Thai: "thai",
                    Tibetan: "tibt",
                    Tirhuta: "tirh",
                    Ugaritic: "ugar",
                    Vai: "vai ",
                    Warang_Citi: "wara",
                    Old_Persian: "xpeo",
                    Cuneiform: "xsux",
                    Yi: "yi  ",
                    Inherited: "zinh",
                    Common: "zyyy",
                    Unknown: "zzzz"
                };
                var OPENTYPE_SCRIPTS = {};
                for(var script in UNICODE_SCRIPTS){
                    var tag = UNICODE_SCRIPTS[script];
                    if (Array.isArray(tag)) for(var _iterator17 = _createForOfIteratorHelperLoose(tag), _step17; !(_step17 = _iterator17()).done;){
                        var t = _step17.value;
                        OPENTYPE_SCRIPTS[t] = script;
                    }
                    else OPENTYPE_SCRIPTS[tag] = script;
                }
                function fromOpenType(tag) {
                    return OPENTYPE_SCRIPTS[tag];
                }
                function forString(string) {
                    var len = string.length;
                    var idx = 0;
                    while(idx < len){
                        var code = string.charCodeAt(idx++); // Check if this is a high surrogate
                        if (0xd800 <= code && code <= 0xdbff && idx < len) {
                            var next = string.charCodeAt(idx); // Check if this is a low surrogate
                            if (0xdc00 <= next && next <= 0xdfff) {
                                idx++;
                                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
                            }
                        }
                        var _script = unicode.getScript(code);
                        if (_script !== "Common" && _script !== "Inherited" && _script !== "Unknown") return UNICODE_SCRIPTS[_script];
                    }
                    return UNICODE_SCRIPTS.Unknown;
                }
                function forCodePoints(codePoints) {
                    for(var i = 0; i < codePoints.length; i++){
                        var codePoint = codePoints[i];
                        var _script2 = unicode.getScript(codePoint);
                        if (_script2 !== "Common" && _script2 !== "Inherited" && _script2 !== "Unknown") return UNICODE_SCRIPTS[_script2];
                    }
                    return UNICODE_SCRIPTS.Unknown;
                } // The scripts in this map are written from right to left
                var RTL = {
                    arab: true,
                    // Arabic
                    hebr: true,
                    // Hebrew
                    syrc: true,
                    // Syriac
                    thaa: true,
                    // Thaana
                    cprt: true,
                    // Cypriot Syllabary
                    khar: true,
                    // Kharosthi
                    phnx: true,
                    // Phoenician
                    "nko ": true,
                    // N'Ko
                    lydi: true,
                    // Lydian
                    avst: true,
                    // Avestan
                    armi: true,
                    // Imperial Aramaic
                    phli: true,
                    // Inscriptional Pahlavi
                    prti: true,
                    // Inscriptional Parthian
                    sarb: true,
                    // Old South Arabian
                    orkh: true,
                    // Old Turkic, Orkhon Runic
                    samr: true,
                    // Samaritan
                    mand: true,
                    // Mandaic, Mandaean
                    merc: true,
                    // Meroitic Cursive
                    mero: true,
                    // Meroitic Hieroglyphs
                    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
                    mani: true,
                    // Manichaean
                    mend: true,
                    // Mende Kikakui
                    nbat: true,
                    // Nabataean
                    narb: true,
                    // Old North Arabian
                    palm: true,
                    // Palmyrene
                    phlp: true // Psalter Pahlavi
                };
                function direction(script) {
                    if (RTL[script]) return "rtl";
                    return "ltr";
                }
                /**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */ var GlyphRun = /*#__PURE__*/ function() {
                    function GlyphRun(glyphs, features, script, language, direction$1) {
                        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
                        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
                        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
                        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
                        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction$1 || direction(script);
                        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {}; // Convert features to an object
                        if (Array.isArray(features)) for(var _iterator18 = _createForOfIteratorHelperLoose(features), _step18; !(_step18 = _iterator18()).done;){
                            var tag = _step18.value;
                            this.features[tag] = true;
                        }
                        else if (typeof features === "object") this.features = features;
                    }
                    /**
   * The total advance width of the run.
   * @type {number}
   */ _createClass(GlyphRun, [
                        {
                            key: "advanceWidth",
                            get: function get() {
                                var width = 0;
                                for(var _iterator19 = _createForOfIteratorHelperLoose(this.positions), _step19; !(_step19 = _iterator19()).done;){
                                    var position = _step19.value;
                                    width += position.xAdvance;
                                }
                                return width;
                            }
                        },
                        {
                            key: "advanceHeight",
                            get: function get() {
                                var height = 0;
                                for(var _iterator20 = _createForOfIteratorHelperLoose(this.positions), _step20; !(_step20 = _iterator20()).done;){
                                    var position = _step20.value;
                                    height += position.yAdvance;
                                }
                                return height;
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                var bbox = new BBox();
                                var x = 0;
                                var y = 0;
                                for(var index = 0; index < this.glyphs.length; index++){
                                    var glyph = this.glyphs[index];
                                    var p = this.positions[index];
                                    var b = glyph.bbox;
                                    bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                                    bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                                    x += p.xAdvance;
                                    y += p.yAdvance;
                                }
                                return bbox;
                            }
                        }
                    ]);
                    return GlyphRun;
                }();
                /**
 * Represents positioning information for a glyph in a GlyphRun.
 */ var GlyphPosition = function GlyphPosition(xAdvance, yAdvance, xOffset, yOffset) {
                    if (xAdvance === void 0) xAdvance = 0;
                    if (yAdvance === void 0) yAdvance = 0;
                    if (xOffset === void 0) xOffset = 0;
                    if (yOffset === void 0) yOffset = 0;
                    /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */ this.xAdvance = xAdvance;
                    /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */ this.yAdvance = yAdvance;
                    /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */ this.xOffset = xOffset;
                    /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */ this.yOffset = yOffset;
                }; // see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
                // and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
                var features = {
                    allTypographicFeatures: {
                        code: 0,
                        exclusive: false,
                        allTypeFeatures: 0
                    },
                    ligatures: {
                        code: 1,
                        exclusive: false,
                        requiredLigatures: 0,
                        commonLigatures: 2,
                        rareLigatures: 4,
                        // logos: 6
                        rebusPictures: 8,
                        diphthongLigatures: 10,
                        squaredLigatures: 12,
                        abbrevSquaredLigatures: 14,
                        symbolLigatures: 16,
                        contextualLigatures: 18,
                        historicalLigatures: 20
                    },
                    cursiveConnection: {
                        code: 2,
                        exclusive: true,
                        unconnected: 0,
                        partiallyConnected: 1,
                        cursive: 2
                    },
                    letterCase: {
                        code: 3,
                        exclusive: true
                    },
                    // upperAndLowerCase: 0          # deprecated
                    // allCaps: 1                    # deprecated
                    // allLowerCase: 2               # deprecated
                    // smallCaps: 3                  # deprecated
                    // initialCaps: 4                # deprecated
                    // initialCapsAndSmallCaps: 5    # deprecated
                    verticalSubstitution: {
                        code: 4,
                        exclusive: false,
                        substituteVerticalForms: 0
                    },
                    linguisticRearrangement: {
                        code: 5,
                        exclusive: false,
                        linguisticRearrangement: 0
                    },
                    numberSpacing: {
                        code: 6,
                        exclusive: true,
                        monospacedNumbers: 0,
                        proportionalNumbers: 1,
                        thirdWidthNumbers: 2,
                        quarterWidthNumbers: 3
                    },
                    smartSwash: {
                        code: 8,
                        exclusive: false,
                        wordInitialSwashes: 0,
                        wordFinalSwashes: 2,
                        // lineInitialSwashes: 4
                        // lineFinalSwashes: 6
                        nonFinalSwashes: 8
                    },
                    diacritics: {
                        code: 9,
                        exclusive: true,
                        showDiacritics: 0,
                        hideDiacritics: 1,
                        decomposeDiacritics: 2
                    },
                    verticalPosition: {
                        code: 10,
                        exclusive: true,
                        normalPosition: 0,
                        superiors: 1,
                        inferiors: 2,
                        ordinals: 3,
                        scientificInferiors: 4
                    },
                    fractions: {
                        code: 11,
                        exclusive: true,
                        noFractions: 0,
                        verticalFractions: 1,
                        diagonalFractions: 2
                    },
                    overlappingCharacters: {
                        code: 13,
                        exclusive: false,
                        preventOverlap: 0
                    },
                    typographicExtras: {
                        code: 14,
                        exclusive: false,
                        // hyphensToEmDash: 0
                        // hyphenToEnDash: 2
                        slashedZero: 4
                    },
                    // formInterrobang: 6
                    // smartQuotes: 8
                    // periodsToEllipsis: 10
                    mathematicalExtras: {
                        code: 15,
                        exclusive: false,
                        // hyphenToMinus: 0
                        // asteristoMultiply: 2
                        // slashToDivide: 4
                        // inequalityLigatures: 6
                        // exponents: 8
                        mathematicalGreek: 10
                    },
                    ornamentSets: {
                        code: 16,
                        exclusive: true,
                        noOrnaments: 0,
                        dingbats: 1,
                        piCharacters: 2,
                        fleurons: 3,
                        decorativeBorders: 4,
                        internationalSymbols: 5,
                        mathSymbols: 6
                    },
                    characterAlternatives: {
                        code: 17,
                        exclusive: true,
                        noAlternates: 0
                    },
                    // user defined options
                    designComplexity: {
                        code: 18,
                        exclusive: true,
                        designLevel1: 0,
                        designLevel2: 1,
                        designLevel3: 2,
                        designLevel4: 3,
                        designLevel5: 4
                    },
                    styleOptions: {
                        code: 19,
                        exclusive: true,
                        noStyleOptions: 0,
                        displayText: 1,
                        engravedText: 2,
                        illuminatedCaps: 3,
                        titlingCaps: 4,
                        tallCaps: 5
                    },
                    characterShape: {
                        code: 20,
                        exclusive: true,
                        traditionalCharacters: 0,
                        simplifiedCharacters: 1,
                        JIS1978Characters: 2,
                        JIS1983Characters: 3,
                        JIS1990Characters: 4,
                        traditionalAltOne: 5,
                        traditionalAltTwo: 6,
                        traditionalAltThree: 7,
                        traditionalAltFour: 8,
                        traditionalAltFive: 9,
                        expertCharacters: 10,
                        JIS2004Characters: 11,
                        hojoCharacters: 12,
                        NLCCharacters: 13,
                        traditionalNamesCharacters: 14
                    },
                    numberCase: {
                        code: 21,
                        exclusive: true,
                        lowerCaseNumbers: 0,
                        upperCaseNumbers: 1
                    },
                    textSpacing: {
                        code: 22,
                        exclusive: true,
                        proportionalText: 0,
                        monospacedText: 1,
                        halfWidthText: 2,
                        thirdWidthText: 3,
                        quarterWidthText: 4,
                        altProportionalText: 5,
                        altHalfWidthText: 6
                    },
                    transliteration: {
                        code: 23,
                        exclusive: true,
                        noTransliteration: 0
                    },
                    // hanjaToHangul: 1
                    // hiraganaToKatakana: 2
                    // katakanaToHiragana: 3
                    // kanaToRomanization: 4
                    // romanizationToHiragana: 5
                    // romanizationToKatakana: 6
                    // hanjaToHangulAltOne: 7
                    // hanjaToHangulAltTwo: 8
                    // hanjaToHangulAltThree: 9
                    annotation: {
                        code: 24,
                        exclusive: true,
                        noAnnotation: 0,
                        boxAnnotation: 1,
                        roundedBoxAnnotation: 2,
                        circleAnnotation: 3,
                        invertedCircleAnnotation: 4,
                        parenthesisAnnotation: 5,
                        periodAnnotation: 6,
                        romanNumeralAnnotation: 7,
                        diamondAnnotation: 8,
                        invertedBoxAnnotation: 9,
                        invertedRoundedBoxAnnotation: 10
                    },
                    kanaSpacing: {
                        code: 25,
                        exclusive: true,
                        fullWidthKana: 0,
                        proportionalKana: 1
                    },
                    ideographicSpacing: {
                        code: 26,
                        exclusive: true,
                        fullWidthIdeographs: 0,
                        proportionalIdeographs: 1,
                        halfWidthIdeographs: 2
                    },
                    unicodeDecomposition: {
                        code: 27,
                        exclusive: false,
                        canonicalComposition: 0,
                        compatibilityComposition: 2,
                        transcodingComposition: 4
                    },
                    rubyKana: {
                        code: 28,
                        exclusive: false,
                        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
                        // rubyKana: 1     # deprecated - use rubyKanaOn instead
                        rubyKana: 2
                    },
                    CJKSymbolAlternatives: {
                        code: 29,
                        exclusive: true,
                        noCJKSymbolAlternatives: 0,
                        CJKSymbolAltOne: 1,
                        CJKSymbolAltTwo: 2,
                        CJKSymbolAltThree: 3,
                        CJKSymbolAltFour: 4,
                        CJKSymbolAltFive: 5
                    },
                    ideographicAlternatives: {
                        code: 30,
                        exclusive: true,
                        noIdeographicAlternatives: 0,
                        ideographicAltOne: 1,
                        ideographicAltTwo: 2,
                        ideographicAltThree: 3,
                        ideographicAltFour: 4,
                        ideographicAltFive: 5
                    },
                    CJKVerticalRomanPlacement: {
                        code: 31,
                        exclusive: true,
                        CJKVerticalRomanCentered: 0,
                        CJKVerticalRomanHBaseline: 1
                    },
                    italicCJKRoman: {
                        code: 32,
                        exclusive: false,
                        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
                        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
                        CJKItalicRoman: 2
                    },
                    caseSensitiveLayout: {
                        code: 33,
                        exclusive: false,
                        caseSensitiveLayout: 0,
                        caseSensitiveSpacing: 2
                    },
                    alternateKana: {
                        code: 34,
                        exclusive: false,
                        alternateHorizKana: 0,
                        alternateVertKana: 2
                    },
                    stylisticAlternatives: {
                        code: 35,
                        exclusive: false,
                        noStylisticAlternates: 0,
                        stylisticAltOne: 2,
                        stylisticAltTwo: 4,
                        stylisticAltThree: 6,
                        stylisticAltFour: 8,
                        stylisticAltFive: 10,
                        stylisticAltSix: 12,
                        stylisticAltSeven: 14,
                        stylisticAltEight: 16,
                        stylisticAltNine: 18,
                        stylisticAltTen: 20,
                        stylisticAltEleven: 22,
                        stylisticAltTwelve: 24,
                        stylisticAltThirteen: 26,
                        stylisticAltFourteen: 28,
                        stylisticAltFifteen: 30,
                        stylisticAltSixteen: 32,
                        stylisticAltSeventeen: 34,
                        stylisticAltEighteen: 36,
                        stylisticAltNineteen: 38,
                        stylisticAltTwenty: 40
                    },
                    contextualAlternates: {
                        code: 36,
                        exclusive: false,
                        contextualAlternates: 0,
                        swashAlternates: 2,
                        contextualSwashAlternates: 4
                    },
                    lowerCase: {
                        code: 37,
                        exclusive: true,
                        defaultLowerCase: 0,
                        lowerCaseSmallCaps: 1,
                        lowerCasePetiteCaps: 2
                    },
                    upperCase: {
                        code: 38,
                        exclusive: true,
                        defaultUpperCase: 0,
                        upperCaseSmallCaps: 1,
                        upperCasePetiteCaps: 2
                    },
                    languageTag: {
                        // indices into ltag table
                        code: 39,
                        exclusive: true
                    },
                    CJKRomanSpacing: {
                        code: 103,
                        exclusive: true,
                        halfWidthCJKRoman: 0,
                        proportionalCJKRoman: 1,
                        defaultCJKRoman: 2,
                        fullWidthCJKRoman: 3
                    }
                };
                var feature = function feature(name, selector) {
                    return [
                        features[name].code,
                        features[name][selector]
                    ];
                };
                var OTMapping = {
                    rlig: feature("ligatures", "requiredLigatures"),
                    clig: feature("ligatures", "contextualLigatures"),
                    dlig: feature("ligatures", "rareLigatures"),
                    hlig: feature("ligatures", "historicalLigatures"),
                    liga: feature("ligatures", "commonLigatures"),
                    hist: feature("ligatures", "historicalLigatures"),
                    // ??
                    smcp: feature("lowerCase", "lowerCaseSmallCaps"),
                    pcap: feature("lowerCase", "lowerCasePetiteCaps"),
                    frac: feature("fractions", "diagonalFractions"),
                    dnom: feature("fractions", "diagonalFractions"),
                    // ??
                    numr: feature("fractions", "diagonalFractions"),
                    // ??
                    afrc: feature("fractions", "verticalFractions"),
                    // aalt
                    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
                    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
                    // unic, vatu, vhal, vjmo, vpal, vrt2
                    // dist -> trak table?
                    // kern, vkrn -> kern table
                    // lfbd + opbd + rtbd -> opbd table?
                    // mark, mkmk -> acnt table?
                    // locl -> languageTag + ltag table
                    case: feature("caseSensitiveLayout", "caseSensitiveLayout"),
                    // also caseSensitiveSpacing
                    ccmp: feature("unicodeDecomposition", "canonicalComposition"),
                    // compatibilityComposition?
                    cpct: feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
                    // guess..., probably not given below
                    valt: feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
                    swsh: feature("contextualAlternates", "swashAlternates"),
                    cswh: feature("contextualAlternates", "contextualSwashAlternates"),
                    curs: feature("cursiveConnection", "cursive"),
                    // ??
                    c2pc: feature("upperCase", "upperCasePetiteCaps"),
                    c2sc: feature("upperCase", "upperCaseSmallCaps"),
                    init: feature("smartSwash", "wordInitialSwashes"),
                    // ??
                    fin2: feature("smartSwash", "wordFinalSwashes"),
                    // ??
                    medi: feature("smartSwash", "nonFinalSwashes"),
                    // ??
                    med2: feature("smartSwash", "nonFinalSwashes"),
                    // ??
                    fin3: feature("smartSwash", "wordFinalSwashes"),
                    // ??
                    fina: feature("smartSwash", "wordFinalSwashes"),
                    // ??
                    pkna: feature("kanaSpacing", "proportionalKana"),
                    half: feature("textSpacing", "halfWidthText"),
                    // also HalfWidthCJKRoman, HalfWidthIdeographs?
                    halt: feature("textSpacing", "altHalfWidthText"),
                    hkna: feature("alternateKana", "alternateHorizKana"),
                    vkna: feature("alternateKana", "alternateVertKana"),
                    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
                    ital: feature("italicCJKRoman", "CJKItalicRoman"),
                    lnum: feature("numberCase", "upperCaseNumbers"),
                    onum: feature("numberCase", "lowerCaseNumbers"),
                    mgrk: feature("mathematicalExtras", "mathematicalGreek"),
                    // nalt: not enough info. what type of annotation?
                    // ornm: ditto, which ornament style?
                    calt: feature("contextualAlternates", "contextualAlternates"),
                    // or more?
                    vrt2: feature("verticalSubstitution", "substituteVerticalForms"),
                    // oh... below?
                    vert: feature("verticalSubstitution", "substituteVerticalForms"),
                    tnum: feature("numberSpacing", "monospacedNumbers"),
                    pnum: feature("numberSpacing", "proportionalNumbers"),
                    sups: feature("verticalPosition", "superiors"),
                    subs: feature("verticalPosition", "inferiors"),
                    ordn: feature("verticalPosition", "ordinals"),
                    pwid: feature("textSpacing", "proportionalText"),
                    hwid: feature("textSpacing", "halfWidthText"),
                    qwid: feature("textSpacing", "quarterWidthText"),
                    // also QuarterWidthNumbers?
                    twid: feature("textSpacing", "thirdWidthText"),
                    // also ThirdWidthNumbers?
                    fwid: feature("textSpacing", "proportionalText"),
                    //??
                    palt: feature("textSpacing", "altProportionalText"),
                    trad: feature("characterShape", "traditionalCharacters"),
                    smpl: feature("characterShape", "simplifiedCharacters"),
                    jp78: feature("characterShape", "JIS1978Characters"),
                    jp83: feature("characterShape", "JIS1983Characters"),
                    jp90: feature("characterShape", "JIS1990Characters"),
                    jp04: feature("characterShape", "JIS2004Characters"),
                    expt: feature("characterShape", "expertCharacters"),
                    hojo: feature("characterShape", "hojoCharacters"),
                    nlck: feature("characterShape", "NLCCharacters"),
                    tnam: feature("characterShape", "traditionalNamesCharacters"),
                    ruby: feature("rubyKana", "rubyKana"),
                    titl: feature("styleOptions", "titlingCaps"),
                    zero: feature("typographicExtras", "slashedZero"),
                    ss01: feature("stylisticAlternatives", "stylisticAltOne"),
                    ss02: feature("stylisticAlternatives", "stylisticAltTwo"),
                    ss03: feature("stylisticAlternatives", "stylisticAltThree"),
                    ss04: feature("stylisticAlternatives", "stylisticAltFour"),
                    ss05: feature("stylisticAlternatives", "stylisticAltFive"),
                    ss06: feature("stylisticAlternatives", "stylisticAltSix"),
                    ss07: feature("stylisticAlternatives", "stylisticAltSeven"),
                    ss08: feature("stylisticAlternatives", "stylisticAltEight"),
                    ss09: feature("stylisticAlternatives", "stylisticAltNine"),
                    ss10: feature("stylisticAlternatives", "stylisticAltTen"),
                    ss11: feature("stylisticAlternatives", "stylisticAltEleven"),
                    ss12: feature("stylisticAlternatives", "stylisticAltTwelve"),
                    ss13: feature("stylisticAlternatives", "stylisticAltThirteen"),
                    ss14: feature("stylisticAlternatives", "stylisticAltFourteen"),
                    ss15: feature("stylisticAlternatives", "stylisticAltFifteen"),
                    ss16: feature("stylisticAlternatives", "stylisticAltSixteen"),
                    ss17: feature("stylisticAlternatives", "stylisticAltSeventeen"),
                    ss18: feature("stylisticAlternatives", "stylisticAltEighteen"),
                    ss19: feature("stylisticAlternatives", "stylisticAltNineteen"),
                    ss20: feature("stylisticAlternatives", "stylisticAltTwenty")
                }; // salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
                // Add cv01-cv99 features
                for(var i = 1; i <= 99; i++)OTMapping["cv".concat("00".concat(i).slice(-2))] = [
                    features.characterAlternatives.code,
                    i
                ];
                 // create inverse mapping
                var AATMapping = {};
                for(var ot in OTMapping){
                    var aat = OTMapping[ot];
                    if (AATMapping[aat[0]] == null) AATMapping[aat[0]] = {};
                    AATMapping[aat[0]][aat[1]] = ot;
                } // Maps an array of OpenType features to AAT features
                // in the form of {featureType:{featureSetting:true}}
                function mapOTToAAT(features) {
                    var res = {};
                    for(var k in features){
                        var r = void 0;
                        if (r = OTMapping[k]) {
                            if (res[r[0]] == null) res[r[0]] = {};
                            res[r[0]][r[1]] = features[k];
                        }
                    }
                    return res;
                } // Maps strings in a [featureType, featureSetting]
                // to their equivalent number codes
                function mapFeatureStrings(f) {
                    var type = f[0], setting = f[1];
                    if (isNaN(type)) var typeCode = features[type] && features[type].code;
                    else var typeCode = type;
                    if (isNaN(setting)) var settingCode = features[type] && features[type][setting];
                    else var settingCode = setting;
                    return [
                        typeCode,
                        settingCode
                    ];
                } // Maps AAT features to an array of OpenType features
                // Supports both arrays in the form of [[featureType, featureSetting]]
                // and objects in the form of {featureType:{featureSetting:true}}
                // featureTypes and featureSettings can be either strings or number codes
                function mapAATToOT(features) {
                    var res = {};
                    if (Array.isArray(features)) for(var k = 0; k < features.length; k++){
                        var r = void 0;
                        var f = mapFeatureStrings(features[k]);
                        if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) res[r] = true;
                    }
                    else if (typeof features === "object") for(var type in features){
                        var _feature = features[type];
                        for(var setting in _feature){
                            var _r = void 0;
                            var _f = mapFeatureStrings([
                                type,
                                setting
                            ]);
                            if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) res[_r] = true;
                        }
                    }
                    return Object.keys(res);
                }
                var _class$1;
                var AATLookupTable = (_class$1 = /*#__PURE__*/ function() {
                    function AATLookupTable(table) {
                        this.table = table;
                    }
                    var _proto19 = AATLookupTable.prototype;
                    _proto19.lookup = function lookup(glyph) {
                        switch(this.table.version){
                            case 0:
                                // simple array format
                                return this.table.values.getItem(glyph);
                            case 2:
                            case 4:
                                var min = 0;
                                var max = this.table.binarySearchHeader.nUnits - 1;
                                while(min <= max){
                                    var mid = min + max >> 1;
                                    var seg = this.table.segments[mid]; // special end of search value
                                    if (seg.firstGlyph === 0xffff) return null;
                                    if (glyph < seg.firstGlyph) max = mid - 1;
                                    else if (glyph > seg.lastGlyph) min = mid + 1;
                                    else {
                                        if (this.table.version === 2) return seg.value;
                                        else return seg.values[glyph - seg.firstGlyph];
                                    }
                                }
                                return null;
                            case 6:
                                // lookup single
                                var _min = 0;
                                var _max = this.table.binarySearchHeader.nUnits - 1;
                                while(_min <= _max){
                                    var mid = _min + _max >> 1;
                                    var seg = this.table.segments[mid]; // special end of search value
                                    if (seg.glyph === 0xffff) return null;
                                    if (glyph < seg.glyph) _max = mid - 1;
                                    else if (glyph > seg.glyph) _min = mid + 1;
                                    else return seg.value;
                                }
                                return null;
                            case 8:
                                // lookup trimmed
                                return this.table.values[glyph - this.table.firstGlyph];
                            default:
                                throw new Error("Unknown lookup table format: ".concat(this.table.version));
                        }
                    };
                    _proto19.glyphsForValue = function glyphsForValue(classValue) {
                        var res = [];
                        switch(this.table.version){
                            case 2:
                            case 4:
                                for(var _iterator21 = _createForOfIteratorHelperLoose(this.table.segments), _step21; !(_step21 = _iterator21()).done;){
                                    var segment = _step21.value;
                                    if (this.table.version === 2 && segment.value === classValue) res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
                                    else {
                                        for(var index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                                    }
                                }
                                break;
                            case 6:
                                // lookup single
                                for(var _iterator22 = _createForOfIteratorHelperLoose(this.table.segments), _step22; !(_step22 = _iterator22()).done;){
                                    var _segment = _step22.value;
                                    if (_segment.value === classValue) res.push(_segment.glyph);
                                }
                                break;
                            case 8:
                                // lookup trimmed
                                for(var i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                                break;
                            default:
                                throw new Error("Unknown lookup table format: ".concat(this.table.version));
                        }
                        return res;
                    };
                    return AATLookupTable;
                }(), _applyDecoratedDescriptor(_class$1.prototype, "glyphsForValue", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$1.prototype, "glyphsForValue"), _class$1.prototype), _class$1);
                var START_OF_TEXT_STATE = 0;
                var END_OF_TEXT_CLASS = 0;
                var OUT_OF_BOUNDS_CLASS = 1;
                var DELETED_GLYPH_CLASS = 2;
                var DONT_ADVANCE = 0x4000;
                var AATStateMachine = /*#__PURE__*/ function() {
                    function AATStateMachine(stateTable) {
                        this.stateTable = stateTable;
                        this.lookupTable = new AATLookupTable(stateTable.classTable);
                    }
                    var _proto20 = AATStateMachine.prototype;
                    _proto20.process = function process(glyphs, reverse, processEntry) {
                        var currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
                        var index = reverse ? glyphs.length - 1 : 0;
                        var dir = reverse ? -1 : 1;
                        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
                            var glyph = null;
                            var classCode = OUT_OF_BOUNDS_CLASS;
                            var shouldAdvance = true;
                            if (index === glyphs.length || index === -1) classCode = END_OF_TEXT_CLASS;
                            else {
                                glyph = glyphs[index];
                                if (glyph.id === 0xffff) // deleted glyph
                                classCode = DELETED_GLYPH_CLASS;
                                else {
                                    classCode = this.lookupTable.lookup(glyph.id);
                                    if (classCode == null) classCode = OUT_OF_BOUNDS_CLASS;
                                }
                            }
                            var row = this.stateTable.stateArray.getItem(currentState);
                            var entryIndex = row[classCode];
                            var entry = this.stateTable.entryTable.getItem(entryIndex);
                            if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
                                processEntry(glyph, entry, index);
                                shouldAdvance = !(entry.flags & DONT_ADVANCE);
                            }
                            currentState = entry.newState;
                            if (shouldAdvance) index += dir;
                        }
                        return glyphs;
                    } /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ ;
                    _proto20.traverse = function traverse(opts, state, visited) {
                        if (state === void 0) state = 0;
                        if (visited === void 0) visited = new Set();
                        if (visited.has(state)) return;
                        visited.add(state);
                        var _this$stateTable = this.stateTable, nClasses = _this$stateTable.nClasses, stateArray = _this$stateTable.stateArray, entryTable = _this$stateTable.entryTable;
                        var row = stateArray.getItem(state); // Skip predefined classes
                        for(var classCode = 4; classCode < nClasses; classCode++){
                            var entryIndex = row[classCode];
                            var entry = entryTable.getItem(entryIndex); // Try all glyphs in the class
                            for(var _iterator23 = _createForOfIteratorHelperLoose(this.lookupTable.glyphsForValue(classCode)), _step23; !(_step23 = _iterator23()).done;){
                                var glyph = _step23.value;
                                if (opts.enter) opts.enter(glyph, entry);
                                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                                if (opts.exit) opts.exit(glyph, entry);
                            }
                        }
                    };
                    return AATStateMachine;
                }();
                var _class$2;
                var MARK_FIRST = 0x8000;
                var MARK_LAST = 0x2000;
                var VERB = 0x000F; // contextual substitution and glyph insertion flag
                var SET_MARK = 0x8000; // ligature entry flags
                var SET_COMPONENT = 0x8000;
                var PERFORM_ACTION = 0x2000; // ligature action masks
                var LAST_MASK = 0x80000000;
                var STORE_MASK = 0x40000000;
                var OFFSET_MASK = 0x3FFFFFFF;
                var REVERSE_DIRECTION = 0x400000;
                var CURRENT_INSERT_BEFORE = 0x0800;
                var MARKED_INSERT_BEFORE = 0x0400;
                var CURRENT_INSERT_COUNT = 0x03E0;
                var MARKED_INSERT_COUNT = 0x001F;
                var AATMorxProcessor = (_class$2 = /*#__PURE__*/ function() {
                    function AATMorxProcessor(font) {
                        this.processIndicRearragement = this.processIndicRearragement.bind(this);
                        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
                        this.processLigature = this.processLigature.bind(this);
                        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
                        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
                        this.font = font;
                        this.morx = font.morx;
                        this.inputCache = null;
                    } // Processes an array of glyphs and applies the specified features
                    // Features should be in the form of {featureType:{featureSetting:boolean}}
                    var _proto21 = AATMorxProcessor.prototype;
                    _proto21.process = function process(glyphs, features) {
                        if (features === void 0) features = {};
                        for(var _iterator24 = _createForOfIteratorHelperLoose(this.morx.chains), _step24; !(_step24 = _iterator24()).done;){
                            var chain = _step24.value;
                            var flags = chain.defaultFlags; // enable/disable the requested features
                            for(var _iterator25 = _createForOfIteratorHelperLoose(chain.features), _step25; !(_step25 = _iterator25()).done;){
                                var feature = _step25.value;
                                var f = void 0;
                                if (f = features[feature.featureType]) {
                                    if (f[feature.featureSetting]) {
                                        flags &= feature.disableFlags;
                                        flags |= feature.enableFlags;
                                    } else if (f[feature.featureSetting] === false) {
                                        flags |= ~feature.disableFlags;
                                        flags &= ~feature.enableFlags;
                                    }
                                }
                            }
                            for(var _iterator26 = _createForOfIteratorHelperLoose(chain.subtables), _step26; !(_step26 = _iterator26()).done;){
                                var subtable = _step26.value;
                                if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
                            }
                        } // remove deleted glyphs
                        var index = glyphs.length - 1;
                        while(index >= 0){
                            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
                            index--;
                        }
                        return glyphs;
                    };
                    _proto21.processSubtable = function processSubtable(subtable, glyphs) {
                        this.subtable = subtable;
                        this.glyphs = glyphs;
                        if (this.subtable.type === 4) {
                            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
                            return;
                        }
                        this.ligatureStack = [];
                        this.markedGlyph = null;
                        this.firstGlyph = null;
                        this.lastGlyph = null;
                        this.markedIndex = null;
                        var stateMachine = this.getStateMachine(subtable);
                        var process = this.getProcessor();
                        var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
                        return stateMachine.process(this.glyphs, reverse, process);
                    };
                    _proto21.getStateMachine = function getStateMachine(subtable) {
                        return new AATStateMachine(subtable.table.stateTable);
                    };
                    _proto21.getProcessor = function getProcessor() {
                        switch(this.subtable.type){
                            case 0:
                                return this.processIndicRearragement;
                            case 1:
                                return this.processContextualSubstitution;
                            case 2:
                                return this.processLigature;
                            case 4:
                                return this.processNoncontextualSubstitutions;
                            case 5:
                                return this.processGlyphInsertion;
                            default:
                                throw new Error("Invalid morx subtable type: ".concat(this.subtable.type));
                        }
                    };
                    _proto21.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
                        if (entry.flags & MARK_FIRST) this.firstGlyph = index;
                        if (entry.flags & MARK_LAST) this.lastGlyph = index;
                        reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
                    };
                    _proto21.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
                        var subsitutions = this.subtable.table.substitutionTable.items;
                        if (entry.markIndex !== 0xffff) {
                            var lookup = subsitutions.getItem(entry.markIndex);
                            var lookupTable = new AATLookupTable(lookup);
                            glyph = this.glyphs[this.markedGlyph];
                            var gid = lookupTable.lookup(glyph.id);
                            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
                        }
                        if (entry.currentIndex !== 0xffff) {
                            var _lookup = subsitutions.getItem(entry.currentIndex);
                            var _lookupTable = new AATLookupTable(_lookup);
                            glyph = this.glyphs[index];
                            var gid = _lookupTable.lookup(glyph.id);
                            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                        }
                        if (entry.flags & SET_MARK) this.markedGlyph = index;
                    };
                    _proto21.processLigature = function processLigature(glyph, entry, index) {
                        if (entry.flags & SET_COMPONENT) this.ligatureStack.push(index);
                        if (entry.flags & PERFORM_ACTION) {
                            var _this$ligatureStack;
                            var actions = this.subtable.table.ligatureActions;
                            var components = this.subtable.table.components;
                            var ligatureList = this.subtable.table.ligatureList;
                            var actionIndex = entry.action;
                            var last = false;
                            var ligatureIndex = 0;
                            var codePoints = [];
                            var ligatureGlyphs = [];
                            while(!last){
                                var _codePoints;
                                var componentGlyph = this.ligatureStack.pop();
                                (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
                                var action = actions.getItem(actionIndex++);
                                last = !!(action & LAST_MASK);
                                var store = !!(action & STORE_MASK);
                                var offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                                offset += this.glyphs[componentGlyph].id;
                                var component = components.getItem(offset);
                                ligatureIndex += component;
                                if (last || store) {
                                    var ligatureEntry = ligatureList.getItem(ligatureIndex);
                                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                                    ligatureGlyphs.push(componentGlyph);
                                    ligatureIndex = 0;
                                    codePoints = [];
                                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
                            } // Put ligature glyph indexes back on the stack
                            (_this$ligatureStack = this.ligatureStack).push.apply(_this$ligatureStack, ligatureGlyphs);
                        }
                    };
                    _proto21.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
                        var lookupTable = new AATLookupTable(subtable.table.lookupTable);
                        for(index = 0; index < glyphs.length; index++){
                            var glyph = glyphs[index];
                            if (glyph.id !== 0xffff) {
                                var gid = lookupTable.lookup(glyph.id);
                                if (gid) // 0 means do nothing
                                glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                            }
                        }
                    };
                    _proto21._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
                        var _this$glyphs;
                        var insertions = [];
                        while(count--){
                            var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
                            insertions.push(this.font.getGlyph(gid));
                        }
                        if (!isBefore) glyphIndex++;
                        (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [
                            glyphIndex,
                            0
                        ].concat(insertions));
                    };
                    _proto21.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
                        if (entry.flags & SET_MARK) this.markedIndex = index;
                        if (entry.markedInsertIndex !== 0xffff) {
                            var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
                            var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
                            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
                        }
                        if (entry.currentInsertIndex !== 0xffff) {
                            var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
                            var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
                            this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
                        }
                    };
                    _proto21.getSupportedFeatures = function getSupportedFeatures() {
                        var features = [];
                        for(var _iterator27 = _createForOfIteratorHelperLoose(this.morx.chains), _step27; !(_step27 = _iterator27()).done;){
                            var chain = _step27.value;
                            for(var _iterator28 = _createForOfIteratorHelperLoose(chain.features), _step28; !(_step28 = _iterator28()).done;){
                                var feature = _step28.value;
                                features.push([
                                    feature.featureType,
                                    feature.featureSetting
                                ]);
                            }
                        }
                        return features;
                    };
                    _proto21.generateInputs = function generateInputs(gid) {
                        if (!this.inputCache) this.generateInputCache();
                        return this.inputCache[gid] || [];
                    };
                    _proto21.generateInputCache = function generateInputCache() {
                        this.inputCache = {};
                        for(var _iterator29 = _createForOfIteratorHelperLoose(this.morx.chains), _step29; !(_step29 = _iterator29()).done;){
                            var chain = _step29.value;
                            var flags = chain.defaultFlags;
                            for(var _iterator30 = _createForOfIteratorHelperLoose(chain.subtables), _step30; !(_step30 = _iterator30()).done;){
                                var subtable = _step30.value;
                                if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
                            }
                        }
                    };
                    _proto21.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
                        var _this3 = this;
                        // Currently, only supporting ligature subtables.
                        if (subtable.type !== 2) return;
                        var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
                        if (reverse) throw new Error("Reverse subtable, not supported.");
                        this.subtable = subtable;
                        this.ligatureStack = [];
                        var stateMachine = this.getStateMachine(subtable);
                        var process = this.getProcessor();
                        var input = [];
                        var stack = [];
                        this.glyphs = [];
                        stateMachine.traverse({
                            enter: function enter(glyph, entry) {
                                var glyphs = _this3.glyphs;
                                stack.push({
                                    glyphs: glyphs.slice(),
                                    ligatureStack: _this3.ligatureStack.slice()
                                }); // Add glyph to input and glyphs to process.
                                var g = _this3.font.getGlyph(glyph);
                                input.push(g);
                                glyphs.push(input[input.length - 1]); // Process ligature substitution
                                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1); // Add input to result if only one matching (non-deleted) glyph remains.
                                var count = 0;
                                var found = 0;
                                for(var i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                                    count++;
                                    found = glyphs[i].id;
                                }
                                if (count === 1) {
                                    var result = input.map(function(g) {
                                        return g.id;
                                    });
                                    var _cache = _this3.inputCache[found];
                                    if (_cache) _cache.push(result);
                                    else _this3.inputCache[found] = [
                                        result
                                    ];
                                }
                            },
                            exit: function exit() {
                                var _stack$pop = stack.pop();
                                _this3.glyphs = _stack$pop.glyphs;
                                _this3.ligatureStack = _stack$pop.ligatureStack;
                                input.pop();
                            }
                        });
                    };
                    return AATMorxProcessor;
                }(), _applyDecoratedDescriptor(_class$2.prototype, "getStateMachine", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$2.prototype, "getStateMachine"), _class$2.prototype), _class$2);
                // reverse the glyphs inside those ranges if specified
                // ranges are in [offset, length] format
                function swap(glyphs, rangeA, rangeB, reverseA, reverseB) {
                    if (reverseA === void 0) reverseA = false;
                    if (reverseB === void 0) reverseB = false;
                    var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
                    if (reverseB) end.reverse();
                    var start = glyphs.splice.apply(glyphs, [
                        rangeA[0],
                        rangeA[1]
                    ].concat(end));
                    if (reverseA) start.reverse();
                    glyphs.splice.apply(glyphs, [
                        rangeB[0] - (rangeA[1] - 1),
                        0
                    ].concat(start));
                    return glyphs;
                }
                function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
                    switch(verb){
                        case 0:
                            // no change
                            return glyphs;
                        case 1:
                            // Ax => xA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                0
                            ]);
                        case 2:
                            // xD => Dx
                            return swap(glyphs, [
                                firstGlyph,
                                0
                            ], [
                                lastGlyph,
                                1
                            ]);
                        case 3:
                            // AxD => DxA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                1
                            ]);
                        case 4:
                            // ABx => xAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                0
                            ]);
                        case 5:
                            // ABx => xBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                0
                            ], true, false);
                        case 6:
                            // xCD => CDx
                            return swap(glyphs, [
                                firstGlyph,
                                0
                            ], [
                                lastGlyph,
                                2
                            ]);
                        case 7:
                            // xCD => DCx
                            return swap(glyphs, [
                                firstGlyph,
                                0
                            ], [
                                lastGlyph,
                                2
                            ], false, true);
                        case 8:
                            // AxCD => CDxA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                2
                            ]);
                        case 9:
                            // AxCD => DCxA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                2
                            ], false, true);
                        case 10:
                            // ABxD => DxAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                1
                            ]);
                        case 11:
                            // ABxD => DxBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                1
                            ], true, false);
                        case 12:
                            // ABxCD => CDxAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ]);
                        case 13:
                            // ABxCD => CDxBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ], true, false);
                        case 14:
                            // ABxCD => DCxAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ], false, true);
                        case 15:
                            // ABxCD => DCxBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ], true, true);
                        default:
                            throw new Error("Unknown verb: ".concat(verb));
                    }
                }
                var AATLayoutEngine = /*#__PURE__*/ function() {
                    function AATLayoutEngine(font) {
                        this.font = font;
                        this.morxProcessor = new AATMorxProcessor(font);
                        this.fallbackPosition = false;
                    }
                    var _proto22 = AATLayoutEngine.prototype;
                    _proto22.substitute = function substitute(glyphRun) {
                        // AAT expects the glyphs to be in visual order prior to morx processing,
                        // so reverse the glyphs if the script is right-to-left.
                        if (glyphRun.direction === "rtl") glyphRun.glyphs.reverse();
                        this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
                    };
                    _proto22.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        return mapAATToOT(this.morxProcessor.getSupportedFeatures());
                    };
                    _proto22.stringsForGlyph = function stringsForGlyph(gid) {
                        var glyphStrings = this.morxProcessor.generateInputs(gid);
                        var result = new Set();
                        for(var _iterator31 = _createForOfIteratorHelperLoose(glyphStrings), _step31; !(_step31 = _iterator31()).done;){
                            var glyphs = _step31.value;
                            this._addStrings(glyphs, 0, result, "");
                        }
                        return result;
                    };
                    _proto22._addStrings = function _addStrings(glyphs, index, strings, string) {
                        var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
                        for(var _iterator32 = _createForOfIteratorHelperLoose(codePoints), _step32; !(_step32 = _iterator32()).done;){
                            var codePoint = _step32.value;
                            var s = string + String.fromCodePoint(codePoint);
                            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
                            else strings.add(s);
                        }
                    };
                    return AATLayoutEngine;
                }();
                /**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */ var ShapingPlan = /*#__PURE__*/ function() {
                    function ShapingPlan(font, script, direction) {
                        this.font = font;
                        this.script = script;
                        this.direction = direction;
                        this.stages = [];
                        this.globalFeatures = {};
                        this.allFeatures = {};
                    }
                    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ var _proto23 = ShapingPlan.prototype;
                    _proto23._addFeatures = function _addFeatures(features, global) {
                        var stageIndex = this.stages.length - 1;
                        var stage = this.stages[stageIndex];
                        for(var _iterator33 = _createForOfIteratorHelperLoose(features), _step33; !(_step33 = _iterator33()).done;){
                            var feature = _step33.value;
                            if (this.allFeatures[feature] == null) {
                                stage.push(feature);
                                this.allFeatures[feature] = stageIndex;
                                if (global) this.globalFeatures[feature] = true;
                            }
                        }
                    } /**
   * Add features to the last stage
   */ ;
                    _proto23.add = function add(arg, global) {
                        if (global === void 0) global = true;
                        if (this.stages.length === 0) this.stages.push([]);
                        if (typeof arg === "string") arg = [
                            arg
                        ];
                        if (Array.isArray(arg)) this._addFeatures(arg, global);
                        else if (typeof arg === "object") {
                            this._addFeatures(arg.global || [], true);
                            this._addFeatures(arg.local || [], false);
                        } else throw new Error("Unsupported argument to ShapingPlan#add");
                    } /**
   * Add a new stage
   */ ;
                    _proto23.addStage = function addStage(arg, global) {
                        if (typeof arg === "function") this.stages.push(arg, []);
                        else {
                            this.stages.push([]);
                            this.add(arg, global);
                        }
                    };
                    _proto23.setFeatureOverrides = function setFeatureOverrides(features) {
                        if (Array.isArray(features)) this.add(features);
                        else if (typeof features === "object") for(var tag in features){
                            if (features[tag]) this.add(tag);
                            else if (this.allFeatures[tag] != null) {
                                var stage = this.stages[this.allFeatures[tag]];
                                stage.splice(stage.indexOf(tag), 1);
                                delete this.allFeatures[tag];
                                delete this.globalFeatures[tag];
                            }
                        }
                    } /**
   * Assigns the global features to the given glyphs
   */ ;
                    _proto23.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
                        for(var _iterator34 = _createForOfIteratorHelperLoose(glyphs), _step34; !(_step34 = _iterator34()).done;){
                            var glyph = _step34.value;
                            for(var feature in this.globalFeatures)glyph.features[feature] = true;
                        }
                    } /**
   * Executes the planned stages using the given OTProcessor
   */ ;
                    _proto23.process = function process(processor, glyphs, positions) {
                        for(var _iterator35 = _createForOfIteratorHelperLoose(this.stages), _step35; !(_step35 = _iterator35()).done;){
                            var stage = _step35.value;
                            if (typeof stage === "function") {
                                if (!positions) stage(this.font, glyphs, this);
                            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
                        }
                    };
                    return ShapingPlan;
                }();
                var VARIATION_FEATURES = [
                    "rvrn"
                ];
                var COMMON_FEATURES = [
                    "ccmp",
                    "locl",
                    "rlig",
                    "mark",
                    "mkmk"
                ];
                var FRACTIONAL_FEATURES = [
                    "frac",
                    "numr",
                    "dnom"
                ];
                var HORIZONTAL_FEATURES = [
                    "calt",
                    "clig",
                    "liga",
                    "rclt",
                    "curs",
                    "kern"
                ];
                var DIRECTIONAL_FEATURES = {
                    ltr: [
                        "ltra",
                        "ltrm"
                    ],
                    rtl: [
                        "rtla",
                        "rtlm"
                    ]
                };
                var DefaultShaper = /*#__PURE__*/ function() {
                    function DefaultShaper() {}
                    DefaultShaper.plan = function plan(_plan, glyphs, features) {
                        // Plan the features we want to apply
                        this.planPreprocessing(_plan);
                        this.planFeatures(_plan);
                        this.planPostprocessing(_plan, features); // Assign the global features to all the glyphs
                        _plan.assignGlobalFeatures(glyphs); // Assign local features to glyphs
                        this.assignFeatures(_plan, glyphs);
                    };
                    DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
                        plan.add({
                            global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
                            local: FRACTIONAL_FEATURES
                        });
                    };
                    DefaultShaper.planFeatures = function planFeatures(plan) {};
                    DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
                        plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
                        plan.setFeatureOverrides(userFeatures);
                    };
                    DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        // Enable contextual fractions
                        for(var i = 0; i < glyphs.length; i++){
                            var glyph = glyphs[i];
                            if (glyph.codePoints[0] === 0x2044) {
                                // fraction slash
                                var start = i;
                                var end = i + 1; // Apply numerator
                                while(start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])){
                                    glyphs[start - 1].features.numr = true;
                                    glyphs[start - 1].features.frac = true;
                                    start--;
                                } // Apply denominator
                                while(end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])){
                                    glyphs[end].features.dnom = true;
                                    glyphs[end].features.frac = true;
                                    end++;
                                } // Apply fraction slash
                                glyph.features.frac = true;
                                i = end - 1;
                            }
                        }
                    };
                    return DefaultShaper;
                }();
                _defineProperty(DefaultShaper, "zeroMarkWidths", "AFTER_GPOS");
                var trie = new UnicodeTrie(Buffer("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==", "base64"));
                var FEATURES = [
                    "isol",
                    "fina",
                    "fin2",
                    "fin3",
                    "medi",
                    "med2",
                    "init"
                ];
                var ShapingClasses = {
                    Non_Joining: 0,
                    Left_Joining: 1,
                    Right_Joining: 2,
                    Dual_Joining: 3,
                    Join_Causing: 3,
                    ALAPH: 4,
                    "DALATH RISH": 5,
                    Transparent: 6
                };
                var ISOL = "isol";
                var FINA = "fina";
                var FIN2 = "fin2";
                var FIN3 = "fin3";
                var MEDI = "medi";
                var MED2 = "med2";
                var INIT = "init";
                var NONE = null; // Each entry is [prevAction, curAction, nextState]
                var STATE_TABLE = [
                    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
                    // State 0: prev was U,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            6
                        ]
                    ],
                    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            FIN2,
                            5
                        ],
                        [
                            NONE,
                            ISOL,
                            6
                        ]
                    ],
                    // State 2: prev was D/L in ISOL form,  willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            INIT,
                            FINA,
                            1
                        ],
                        [
                            INIT,
                            FINA,
                            3
                        ],
                        [
                            INIT,
                            FINA,
                            4
                        ],
                        [
                            INIT,
                            FINA,
                            6
                        ]
                    ],
                    // State 3: prev was D in FINA form,  willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            MEDI,
                            FINA,
                            1
                        ],
                        [
                            MEDI,
                            FINA,
                            3
                        ],
                        [
                            MEDI,
                            FINA,
                            4
                        ],
                        [
                            MEDI,
                            FINA,
                            6
                        ]
                    ],
                    // State 4: prev was FINA ALAPH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            MED2,
                            ISOL,
                            1
                        ],
                        [
                            MED2,
                            ISOL,
                            2
                        ],
                        [
                            MED2,
                            FIN2,
                            5
                        ],
                        [
                            MED2,
                            ISOL,
                            6
                        ]
                    ],
                    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            ISOL,
                            ISOL,
                            1
                        ],
                        [
                            ISOL,
                            ISOL,
                            2
                        ],
                        [
                            ISOL,
                            FIN2,
                            5
                        ],
                        [
                            ISOL,
                            ISOL,
                            6
                        ]
                    ],
                    // State 6: prev was DALATH/RISH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            FIN3,
                            5
                        ],
                        [
                            NONE,
                            ISOL,
                            6
                        ]
                    ]
                ];
                /**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */ var ArabicShaper = /*#__PURE__*/ function(_DefaultShaper) {
                    _inheritsLoose(ArabicShaper, _DefaultShaper);
                    function ArabicShaper() {
                        return _DefaultShaper.apply(this, arguments) || this;
                    }
                    ArabicShaper.planFeatures = function planFeatures(plan) {
                        plan.add([
                            "ccmp",
                            "locl"
                        ]);
                        for(var i = 0; i < FEATURES.length; i++){
                            var feature = FEATURES[i];
                            plan.addStage(feature, false);
                        }
                        plan.addStage("mset");
                    };
                    ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        _DefaultShaper.assignFeatures.call(this, plan, glyphs);
                        var prev = -1;
                        var state = 0;
                        var actions = []; // Apply the state machine to map glyphs to features
                        for(var i = 0; i < glyphs.length; i++){
                            var curAction = void 0, prevAction = void 0;
                            var glyph = glyphs[i];
                            var type = getShapingClass(glyph.codePoints[0]);
                            if (type === ShapingClasses.Transparent) {
                                actions[i] = NONE;
                                continue;
                            }
                            var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
                            prevAction = _STATE_TABLE$state$ty[0];
                            curAction = _STATE_TABLE$state$ty[1];
                            state = _STATE_TABLE$state$ty[2];
                            if (prevAction !== NONE && prev !== -1) actions[prev] = prevAction;
                            actions[i] = curAction;
                            prev = i;
                        } // Apply the chosen features to their respective glyphs
                        for(var index = 0; index < glyphs.length; index++){
                            var feature = void 0;
                            var glyph = glyphs[index];
                            if (feature = actions[index]) glyph.features[feature] = true;
                        }
                    };
                    return ArabicShaper;
                }(DefaultShaper);
                function getShapingClass(codePoint) {
                    var res = trie.get(codePoint);
                    if (res) return res - 1;
                    var category = unicode.getCategory(codePoint);
                    if (category === "Mn" || category === "Me" || category === "Cf") return ShapingClasses.Transparent;
                    return ShapingClasses.Non_Joining;
                }
                var GlyphIterator = /*#__PURE__*/ function() {
                    function GlyphIterator(glyphs, options) {
                        this.glyphs = glyphs;
                        this.reset(options);
                    }
                    var _proto24 = GlyphIterator.prototype;
                    _proto24.reset = function reset(options, index) {
                        if (options === void 0) options = {};
                        if (index === void 0) index = 0;
                        this.options = options;
                        this.flags = options.flags || {};
                        this.markAttachmentType = options.markAttachmentType || 0;
                        this.index = index;
                    };
                    _proto24.shouldIgnore = function shouldIgnore(glyph) {
                        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
                    };
                    _proto24.move = function move(dir) {
                        this.index += dir;
                        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
                        if (0 > this.index || this.index >= this.glyphs.length) return null;
                        return this.glyphs[this.index];
                    };
                    _proto24.next = function next() {
                        return this.move(1);
                    };
                    _proto24.prev = function prev() {
                        return this.move(-1);
                    };
                    _proto24.peek = function peek(count) {
                        if (count === void 0) count = 1;
                        var idx = this.index;
                        var res = this.increment(count);
                        this.index = idx;
                        return res;
                    };
                    _proto24.peekIndex = function peekIndex(count) {
                        if (count === void 0) count = 1;
                        var idx = this.index;
                        this.increment(count);
                        var res = this.index;
                        this.index = idx;
                        return res;
                    };
                    _proto24.increment = function increment(count) {
                        if (count === void 0) count = 1;
                        var dir = count < 0 ? -1 : 1;
                        count = Math.abs(count);
                        while(count--)this.move(dir);
                        return this.glyphs[this.index];
                    };
                    _createClass(GlyphIterator, [
                        {
                            key: "cur",
                            get: function get() {
                                return this.glyphs[this.index] || null;
                            }
                        }
                    ]);
                    return GlyphIterator;
                }();
                var DEFAULT_SCRIPTS = [
                    "DFLT",
                    "dflt",
                    "latn"
                ];
                var OTProcessor = /*#__PURE__*/ function() {
                    function OTProcessor(font, table) {
                        this.font = font;
                        this.table = table;
                        this.script = null;
                        this.scriptTag = null;
                        this.language = null;
                        this.languageTag = null;
                        this.features = {};
                        this.lookups = {}; // Setup variation substitutions
                        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1; // initialize to default script + language
                        this.selectScript(); // current context (set by applyFeatures)
                        this.glyphs = [];
                        this.positions = []; // only used by GPOS
                        this.ligatureID = 1;
                        this.currentFeature = null;
                    }
                    var _proto25 = OTProcessor.prototype;
                    _proto25.findScript = function findScript(script) {
                        if (this.table.scriptList == null) return null;
                        if (!Array.isArray(script)) script = [
                            script
                        ];
                        for(var _iterator36 = _createForOfIteratorHelperLoose(script), _step36; !(_step36 = _iterator36()).done;){
                            var s = _step36.value;
                            for(var _iterator37 = _createForOfIteratorHelperLoose(this.table.scriptList), _step37; !(_step37 = _iterator37()).done;){
                                var entry = _step37.value;
                                if (entry.tag === s) return entry;
                            }
                        }
                        return null;
                    };
                    _proto25.selectScript = function selectScript(script, language, direction$1) {
                        var changed = false;
                        var entry;
                        if (!this.script || script !== this.scriptTag) {
                            entry = this.findScript(script);
                            if (!entry) entry = this.findScript(DEFAULT_SCRIPTS);
                            if (!entry) return this.scriptTag;
                            this.scriptTag = entry.tag;
                            this.script = entry.script;
                            this.language = null;
                            this.languageTag = null;
                            changed = true;
                        }
                        if (!direction$1 || direction$1 !== this.direction) this.direction = direction$1 || direction(script);
                        if (language && language.length < 4) language += " ".repeat(4 - language.length);
                        if (!language || language !== this.languageTag) {
                            this.language = null;
                            for(var _iterator38 = _createForOfIteratorHelperLoose(this.script.langSysRecords), _step38; !(_step38 = _iterator38()).done;){
                                var lang = _step38.value;
                                if (lang.tag === language) {
                                    this.language = lang.langSys;
                                    this.languageTag = lang.tag;
                                    break;
                                }
                            }
                            if (!this.language) {
                                this.language = this.script.defaultLangSys;
                                this.languageTag = null;
                            }
                            changed = true;
                        } // Build a feature lookup table
                        if (changed) {
                            this.features = {};
                            if (this.language) for(var _iterator39 = _createForOfIteratorHelperLoose(this.language.featureIndexes), _step39; !(_step39 = _iterator39()).done;){
                                var featureIndex = _step39.value;
                                var record = this.table.featureList[featureIndex];
                                var substituteFeature = this.substituteFeatureForVariations(featureIndex);
                                this.features[record.tag] = substituteFeature || record.feature;
                            }
                        }
                        return this.scriptTag;
                    };
                    _proto25.lookupsForFeatures = function lookupsForFeatures(userFeatures, exclude) {
                        if (userFeatures === void 0) userFeatures = [];
                        var lookups = [];
                        for(var _iterator40 = _createForOfIteratorHelperLoose(userFeatures), _step40; !(_step40 = _iterator40()).done;){
                            var tag = _step40.value;
                            var feature = this.features[tag];
                            if (!feature) continue;
                            for(var _iterator41 = _createForOfIteratorHelperLoose(feature.lookupListIndexes), _step41; !(_step41 = _iterator41()).done;){
                                var lookupIndex = _step41.value;
                                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                                lookups.push({
                                    feature: tag,
                                    index: lookupIndex,
                                    lookup: this.table.lookupList.get(lookupIndex)
                                });
                            }
                        }
                        lookups.sort(function(a, b) {
                            return a.index - b.index;
                        });
                        return lookups;
                    };
                    _proto25.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
                        if (this.variationsIndex === -1) return null;
                        var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
                        var substitutions = record.featureTableSubstitution.substitutions;
                        for(var _iterator42 = _createForOfIteratorHelperLoose(substitutions), _step42; !(_step42 = _iterator42()).done;){
                            var substitution = _step42.value;
                            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
                        }
                        return null;
                    };
                    _proto25.findVariationsIndex = function findVariationsIndex(coords) {
                        var variations = this.table.featureVariations;
                        if (!variations) return -1;
                        var records = variations.featureVariationRecords;
                        for(var i = 0; i < records.length; i++){
                            var conditions = records[i].conditionSet.conditionTable;
                            if (this.variationConditionsMatch(conditions, coords)) return i;
                        }
                        return -1;
                    };
                    _proto25.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
                        return conditions.every(function(condition) {
                            var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
                            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
                        });
                    };
                    _proto25.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
                        var lookups = this.lookupsForFeatures(userFeatures);
                        this.applyLookups(lookups, glyphs, advances);
                    };
                    _proto25.applyLookups = function applyLookups(lookups, glyphs, positions) {
                        this.glyphs = glyphs;
                        this.positions = positions;
                        this.glyphIterator = new GlyphIterator(glyphs);
                        for(var _iterator43 = _createForOfIteratorHelperLoose(lookups), _step43; !(_step43 = _iterator43()).done;){
                            var _step43$value = _step43.value, feature = _step43$value.feature, lookup = _step43$value.lookup;
                            this.currentFeature = feature;
                            this.glyphIterator.reset(lookup.flags);
                            while(this.glyphIterator.index < glyphs.length){
                                if (!(feature in this.glyphIterator.cur.features)) {
                                    this.glyphIterator.next();
                                    continue;
                                }
                                for(var _iterator44 = _createForOfIteratorHelperLoose(lookup.subTables), _step44; !(_step44 = _iterator44()).done;){
                                    var table = _step44.value;
                                    var res = this.applyLookup(lookup.lookupType, table);
                                    if (res) break;
                                }
                                this.glyphIterator.next();
                            }
                        }
                    };
                    _proto25.applyLookup = function applyLookup(lookup, table) {
                        throw new Error("applyLookup must be implemented by subclasses");
                    };
                    _proto25.applyLookupList = function applyLookupList(lookupRecords) {
                        var options = this.glyphIterator.options;
                        var glyphIndex = this.glyphIterator.index;
                        for(var _iterator45 = _createForOfIteratorHelperLoose(lookupRecords), _step45; !(_step45 = _iterator45()).done;){
                            var lookupRecord = _step45.value;
                            // Reset flags and find glyph index for this lookup record
                            this.glyphIterator.reset(options, glyphIndex);
                            this.glyphIterator.increment(lookupRecord.sequenceIndex); // Get the lookup and setup flags for subtables
                            var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
                            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index); // Apply lookup subtables until one matches
                            for(var _iterator46 = _createForOfIteratorHelperLoose(lookup.subTables), _step46; !(_step46 = _iterator46()).done;){
                                var table = _step46.value;
                                if (this.applyLookup(lookup.lookupType, table)) break;
                            }
                        }
                        this.glyphIterator.reset(options, glyphIndex);
                        return true;
                    };
                    _proto25.coverageIndex = function coverageIndex(coverage, glyph) {
                        if (glyph == null) glyph = this.glyphIterator.cur.id;
                        switch(coverage.version){
                            case 1:
                                return coverage.glyphs.indexOf(glyph);
                            case 2:
                                for(var _iterator47 = _createForOfIteratorHelperLoose(coverage.rangeRecords), _step47; !(_step47 = _iterator47()).done;){
                                    var range = _step47.value;
                                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                                }
                                break;
                        }
                        return -1;
                    };
                    _proto25.match = function match(sequenceIndex, sequence, fn, matched) {
                        var pos = this.glyphIterator.index;
                        var glyph = this.glyphIterator.increment(sequenceIndex);
                        var idx = 0;
                        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
                            if (matched) matched.push(this.glyphIterator.index);
                            idx++;
                            glyph = this.glyphIterator.next();
                        }
                        this.glyphIterator.index = pos;
                        if (idx < sequence.length) return false;
                        return matched || true;
                    };
                    _proto25.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
                        return this.match(sequenceIndex, sequence, function(component, glyph) {
                            return component === glyph.id;
                        });
                    };
                    _proto25.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
                        var _this4 = this;
                        return this.match(sequenceIndex, sequence, function(component, glyph) {
                            // If the current feature doesn't apply to this glyph,
                            if (!(_this4.currentFeature in glyph.features)) return false;
                            return component === glyph.id;
                        }, []);
                    };
                    _proto25.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
                        var _this5 = this;
                        return this.match(sequenceIndex, sequence, function(coverage, glyph) {
                            return _this5.coverageIndex(coverage, glyph.id) >= 0;
                        });
                    };
                    _proto25.getClassID = function getClassID(glyph, classDef) {
                        switch(classDef.version){
                            case 1:
                                // Class array
                                var i = glyph - classDef.startGlyph;
                                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                                break;
                            case 2:
                                for(var _iterator48 = _createForOfIteratorHelperLoose(classDef.classRangeRecord), _step48; !(_step48 = _iterator48()).done;){
                                    var range = _step48.value;
                                    if (range.start <= glyph && glyph <= range.end) return range.class;
                                }
                                break;
                        }
                        return 0;
                    };
                    _proto25.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
                        var _this6 = this;
                        return this.match(sequenceIndex, sequence, function(classID, glyph) {
                            return classID === _this6.getClassID(glyph.id, classDef);
                        });
                    };
                    _proto25.applyContext = function applyContext(table) {
                        switch(table.version){
                            case 1:
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                var set = table.ruleSets[index];
                                for(var _iterator49 = _createForOfIteratorHelperLoose(set), _step49; !(_step49 = _iterator49()).done;){
                                    var rule = _step49.value;
                                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                                }
                                break;
                            case 2:
                                if (this.coverageIndex(table.coverage) === -1) return false;
                                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                                if (index === -1) return false;
                                set = table.classSet[index];
                                for(var _iterator50 = _createForOfIteratorHelperLoose(set), _step50; !(_step50 = _iterator50()).done;){
                                    var _rule = _step50.value;
                                    if (this.classSequenceMatches(1, _rule.classes, table.classDef)) return this.applyLookupList(_rule.lookupRecords);
                                }
                                break;
                            case 3:
                                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                                break;
                        }
                        return false;
                    };
                    _proto25.applyChainingContext = function applyChainingContext(table) {
                        switch(table.version){
                            case 1:
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                var set = table.chainRuleSets[index];
                                for(var _iterator51 = _createForOfIteratorHelperLoose(set), _step51; !(_step51 = _iterator51()).done;){
                                    var rule = _step51.value;
                                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                                }
                                break;
                            case 2:
                                if (this.coverageIndex(table.coverage) === -1) return false;
                                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                                var rules = table.chainClassSet[index];
                                if (!rules) return false;
                                for(var _iterator52 = _createForOfIteratorHelperLoose(rules), _step52; !(_step52 = _iterator52()).done;){
                                    var _rule2 = _step52.value;
                                    if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(_rule2.lookupRecords);
                                }
                                break;
                            case 3:
                                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                                break;
                        }
                        return false;
                    };
                    return OTProcessor;
                }();
                var GlyphInfo = /*#__PURE__*/ function() {
                    function GlyphInfo(font, id, codePoints, features) {
                        if (codePoints === void 0) codePoints = [];
                        this._font = font;
                        this.codePoints = codePoints;
                        this.id = id;
                        this.features = {};
                        if (Array.isArray(features)) for(var i = 0; i < features.length; i++){
                            var feature = features[i];
                            this.features[feature] = true;
                        }
                        else if (typeof features === "object") Object.assign(this.features, features);
                        this.ligatureID = null;
                        this.ligatureComponent = null;
                        this.isLigated = false;
                        this.cursiveAttachment = null;
                        this.markAttachment = null;
                        this.shaperInfo = null;
                        this.substituted = false;
                        this.isMultiplied = false;
                    }
                    var _proto26 = GlyphInfo.prototype;
                    _proto26.copy = function copy() {
                        return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
                    };
                    _createClass(GlyphInfo, [
                        {
                            key: "id",
                            get: function get() {
                                return this._id;
                            },
                            set: function set(id) {
                                this._id = id;
                                this.substituted = true;
                                var GDEF = this._font.GDEF;
                                if (GDEF && GDEF.glyphClassDef) {
                                    // TODO: clean this up
                                    var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                                    this.isBase = classID === 1;
                                    this.isLigature = classID === 2;
                                    this.isMark = classID === 3;
                                    this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
                                } else {
                                    this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
                                    this.isBase = !this.isMark;
                                    this.isLigature = this.codePoints.length > 1;
                                    this.markAttachmentType = 0;
                                }
                            }
                        }
                    ]);
                    return GlyphInfo;
                }();
                /**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */ var HangulShaper = /*#__PURE__*/ function(_DefaultShaper2) {
                    _inheritsLoose(HangulShaper, _DefaultShaper2);
                    function HangulShaper() {
                        return _DefaultShaper2.apply(this, arguments) || this;
                    }
                    HangulShaper.planFeatures = function planFeatures(plan) {
                        plan.add([
                            "ljmo",
                            "vjmo",
                            "tjmo"
                        ], false);
                    };
                    HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        var state = 0;
                        var i = 0;
                        while(i < glyphs.length){
                            var action = void 0;
                            var glyph = glyphs[i];
                            var code = glyph.codePoints[0];
                            var type = getType(code);
                            var _STATE_TABLE$1$state$ = STATE_TABLE$1[state][type];
                            action = _STATE_TABLE$1$state$[0];
                            state = _STATE_TABLE$1$state$[1];
                            switch(action){
                                case DECOMPOSE:
                                    // Decompose the composed syllable if it is not supported by the font.
                                    if (!plan.font.hasGlyphForCodePoint(code)) i = decompose(glyphs, i, plan.font);
                                    break;
                                case COMPOSE:
                                    // Found a decomposed syllable. Try to compose if supported by the font.
                                    i = compose(glyphs, i, plan.font);
                                    break;
                                case TONE_MARK:
                                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                                    reorderToneMark(glyphs, i, plan.font);
                                    break;
                                case INVALID:
                                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                                    i = insertDottedCircle(glyphs, i, plan.font);
                                    break;
                            }
                            i++;
                        }
                    };
                    return HangulShaper;
                }(DefaultShaper);
                _defineProperty(HangulShaper, "zeroMarkWidths", "NONE");
                var HANGUL_BASE = 0xac00;
                var HANGUL_END = 0xd7a4;
                var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
                var L_BASE = 0x1100; // lead
                var V_BASE = 0x1161; // vowel
                var T_BASE = 0x11a7; // trail
                var L_COUNT = 19;
                var V_COUNT = 21;
                var T_COUNT = 28;
                var L_END = L_BASE + L_COUNT - 1;
                var V_END = V_BASE + V_COUNT - 1;
                var T_END = T_BASE + T_COUNT - 1;
                var DOTTED_CIRCLE = 0x25cc;
                var isL = function isL(code) {
                    return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
                };
                var isV = function isV(code) {
                    return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
                };
                var isT = function isT(code) {
                    return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
                };
                var isTone = function isTone(code) {
                    return 0x302e <= code && code <= 0x302f;
                };
                var isLVT = function isLVT(code) {
                    return HANGUL_BASE <= code && code <= HANGUL_END;
                };
                var isLV = function isLV(code) {
                    return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
                };
                var isCombiningL = function isCombiningL(code) {
                    return L_BASE <= code && code <= L_END;
                };
                var isCombiningV = function isCombiningV(code) {
                    return V_BASE <= code && code <= V_END;
                };
                var isCombiningT = function isCombiningT(code) {
                    return 1 <= code && code <= T_END;
                }; // Character categories
                var X = 0; // Other character
                var L = 1; // Leading consonant
                var V = 2; // Medial vowel
                var T = 3; // Trailing consonant
                var LV = 4; // Composed <LV> syllable
                var LVT = 5; // Composed <LVT> syllable
                var M = 6; // Tone mark
                // This function classifies a character using the above categories.
                function getType(code) {
                    if (isL(code)) return L;
                    if (isV(code)) return V;
                    if (isT(code)) return T;
                    if (isLV(code)) return LV;
                    if (isLVT(code)) return LVT;
                    if (isTone(code)) return M;
                    return X;
                } // State machine actions
                var NO_ACTION = 0;
                var DECOMPOSE = 1;
                var COMPOSE = 2;
                var TONE_MARK = 4;
                var INVALID = 5; // Build a state machine that accepts valid syllables, and applies actions along the way.
                // The logic this is implementing is documented at the top of the file.
                var STATE_TABLE$1 = [
                    //       X                 L                 V                T                  LV                LVT               M
                    // State 0: start state
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            INVALID,
                            0
                        ]
                    ],
                    // State 1: <L>
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            COMPOSE,
                            2
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            INVALID,
                            0
                        ]
                    ],
                    // State 2: <L,V> or <LV>
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            COMPOSE,
                            3
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            TONE_MARK,
                            0
                        ]
                    ],
                    // State 3: <L,V,T> or <LVT>
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            TONE_MARK,
                            0
                        ]
                    ]
                ];
                function getGlyph(font, code, features) {
                    return new GlyphInfo(font, font.glyphForCodePoint(code).id, [
                        code
                    ], features);
                }
                function decompose(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyph.codePoints[0];
                    var s = code - HANGUL_BASE;
                    var t = T_BASE + s % T_COUNT;
                    s = s / T_COUNT | 0;
                    var l = L_BASE + s / V_COUNT | 0;
                    var v = V_BASE + s % V_COUNT; // Don't decompose if all of the components are not available
                    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) return i;
                     // Replace the current glyph with decomposed L, V, and T glyphs,
                    // and apply the proper OpenType features to each component.
                    var ljmo = getGlyph(font, l, glyph.features);
                    ljmo.features.ljmo = true;
                    var vjmo = getGlyph(font, v, glyph.features);
                    vjmo.features.vjmo = true;
                    var insert = [
                        ljmo,
                        vjmo
                    ];
                    if (t > T_BASE) {
                        var tjmo = getGlyph(font, t, glyph.features);
                        tjmo.features.tjmo = true;
                        insert.push(tjmo);
                    }
                    glyphs.splice.apply(glyphs, [
                        i,
                        1
                    ].concat(insert));
                    return i + insert.length - 1;
                }
                function compose(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyphs[i].codePoints[0];
                    var type = getType(code);
                    var prev = glyphs[i - 1].codePoints[0];
                    var prevType = getType(prev); // Figure out what type of syllable we're dealing with
                    var lv, ljmo, vjmo, tjmo;
                    if (prevType === LV && type === T) {
                        // <LV,T>
                        lv = prev;
                        tjmo = glyph;
                    } else {
                        if (type === V) {
                            // <L,V>
                            ljmo = glyphs[i - 1];
                            vjmo = glyph;
                        } else {
                            // <L,V,T>
                            ljmo = glyphs[i - 2];
                            vjmo = glyphs[i - 1];
                            tjmo = glyph;
                        }
                        var l = ljmo.codePoints[0];
                        var v = vjmo.codePoints[0]; // Make sure L and V are combining characters
                        if (isCombiningL(l) && isCombiningV(v)) lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
                    }
                    var t = tjmo && tjmo.codePoints[0] || T_BASE;
                    if (lv != null && (t === T_BASE || isCombiningT(t))) {
                        var s = lv + (t - T_BASE); // Replace with a composed glyph if supported by the font,
                        // otherwise apply the proper OpenType features to each component.
                        if (font.hasGlyphForCodePoint(s)) {
                            var del = prevType === V ? 3 : 2;
                            glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
                            return i - del + 1;
                        }
                    } // Didn't compose (either a non-combining component or unsupported by font).
                    if (ljmo) ljmo.features.ljmo = true;
                    if (vjmo) vjmo.features.vjmo = true;
                    if (tjmo) tjmo.features.tjmo = true;
                    if (prevType === LV) {
                        // Sequence was originally <L,V>, which got combined earlier.
                        // Either the T was non-combining, or the LVT glyph wasn't supported.
                        // Decompose the glyph again and apply OT features.
                        decompose(glyphs, i - 1, font);
                        return i + 1;
                    }
                    return i;
                }
                function getLength(code) {
                    switch(getType(code)){
                        case LV:
                        case LVT:
                            return 1;
                        case V:
                            return 2;
                        case T:
                            return 3;
                    }
                }
                function reorderToneMark(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyphs[i].codePoints[0]; // Move tone mark to the beginning of the previous syllable, unless it is zero width
                    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
                    var prev = glyphs[i - 1].codePoints[0];
                    var len = getLength(prev);
                    glyphs.splice(i, 1);
                    return glyphs.splice(i - len, 0, glyph);
                }
                function insertDottedCircle(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyphs[i].codePoints[0];
                    if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
                        var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features); // If the tone mark is zero width, insert the dotted circle before, otherwise after
                        var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
                        glyphs.splice(idx, 0, dottedCircle);
                        i++;
                    }
                    return i;
                }
                var stateTable = [
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        0,
                        10,
                        11,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        25,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        35,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        38,
                        5,
                        7,
                        7,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        13,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        0,
                        0,
                        40,
                        41,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        12,
                        43,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        45,
                        46,
                        47,
                        48,
                        49,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        0,
                        51,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        52,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        60,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        4,
                        5,
                        7,
                        7,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        13,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        63,
                        64,
                        0,
                        0,
                        40,
                        41,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        63,
                        0,
                        0
                    ],
                    [
                        0,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        0,
                        10,
                        11,
                        11,
                        12,
                        13,
                        0,
                        2,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        65,
                        20,
                        21,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        25,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        69,
                        0,
                        70,
                        70,
                        0,
                        71,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        73,
                        19,
                        74,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        0,
                        0,
                        76,
                        77,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        79,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        25,
                        79,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        19,
                        20,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        25,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        81,
                        82,
                        83,
                        84,
                        85,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        86,
                        0,
                        0,
                        87,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        88,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        19,
                        74,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        89,
                        90,
                        0,
                        0,
                        76,
                        77,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        89,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        94,
                        29,
                        95,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        0,
                        0,
                        97,
                        98,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        100,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        35,
                        100,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        100,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        100,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        102,
                        103,
                        104,
                        105,
                        106,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        107,
                        0,
                        0,
                        108,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        109,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        28,
                        29,
                        95,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        110,
                        111,
                        0,
                        0,
                        97,
                        98,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        110,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        5,
                        7,
                        7,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        13,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        115,
                        116,
                        117,
                        118,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        119,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        122,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        124,
                        64,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        124,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        0,
                        0,
                        121,
                        125,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        126,
                        126,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        46,
                        47,
                        48,
                        49,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        47,
                        47,
                        49,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        127,
                        127,
                        49,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        128,
                        127,
                        127,
                        49,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        129,
                        130,
                        131,
                        132,
                        133,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        0,
                        0,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        134,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        135,
                        54,
                        56,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        0,
                        0,
                        137,
                        138,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        140,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        60,
                        140,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        140,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        140,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        142,
                        143,
                        144,
                        145,
                        146,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        147,
                        0,
                        0,
                        148,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        149,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        53,
                        54,
                        56,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        150,
                        151,
                        0,
                        0,
                        137,
                        138,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        150,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        155,
                        116,
                        156,
                        157,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        158,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        3,
                        4,
                        5,
                        159,
                        160,
                        8,
                        161,
                        0,
                        162,
                        0,
                        11,
                        12,
                        163,
                        0,
                        75,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        40,
                        164,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        165,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        165,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        124,
                        64,
                        0,
                        0,
                        40,
                        164,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        124,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        70,
                        70,
                        0,
                        71,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        71,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        166,
                        0,
                        0,
                        167,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        168,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        19,
                        74,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        79,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        79,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        169,
                        170,
                        171,
                        172,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        173,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        176,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        178,
                        90,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        178,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        0,
                        0,
                        175,
                        179,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        180,
                        180,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        82,
                        83,
                        84,
                        85,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        83,
                        83,
                        85,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        181,
                        181,
                        85,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        182,
                        181,
                        181,
                        85,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        183,
                        184,
                        185,
                        186,
                        187,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        86,
                        0,
                        0,
                        0,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        188,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        189,
                        170,
                        190,
                        191,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        192,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        76,
                        193,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        194,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        194,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        178,
                        90,
                        0,
                        0,
                        76,
                        193,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        178,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        29,
                        95,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        100,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        100,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        195,
                        196,
                        197,
                        198,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        199,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        202,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        204,
                        111,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        204,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        0,
                        0,
                        201,
                        205,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        206,
                        206,
                        32,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        103,
                        104,
                        105,
                        106,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        104,
                        104,
                        106,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        207,
                        207,
                        106,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        208,
                        207,
                        207,
                        106,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        209,
                        210,
                        211,
                        212,
                        213,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        107,
                        0,
                        0,
                        0,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        214,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        215,
                        196,
                        216,
                        217,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        218,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        97,
                        219,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        220,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        220,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        204,
                        111,
                        0,
                        0,
                        97,
                        219,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        204,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        221,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        0,
                        0,
                        40,
                        224,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        119,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        115,
                        116,
                        117,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        119,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        115,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        226,
                        64,
                        0,
                        0,
                        40,
                        224,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        226,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        227,
                        0,
                        228,
                        229,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        230,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        122,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        231,
                        231,
                        49,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        232,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        130,
                        131,
                        132,
                        133,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        131,
                        131,
                        133,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        233,
                        233,
                        133,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        234,
                        233,
                        233,
                        133,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        235,
                        236,
                        237,
                        238,
                        239,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        54,
                        56,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        240,
                        241,
                        242,
                        243,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        244,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        247,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        249,
                        151,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        249,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        0,
                        0,
                        246,
                        250,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        251,
                        251,
                        57,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        143,
                        144,
                        145,
                        146,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        144,
                        144,
                        146,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        252,
                        252,
                        146,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        253,
                        252,
                        252,
                        146,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        254,
                        255,
                        256,
                        257,
                        258,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        147,
                        0,
                        0,
                        0,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        259,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        260,
                        241,
                        261,
                        262,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        263,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        137,
                        264,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        265,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        265,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        249,
                        151,
                        0,
                        0,
                        137,
                        264,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        249,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        221,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        158,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        155,
                        116,
                        156,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        158,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        155,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        43,
                        266,
                        266,
                        8,
                        161,
                        0,
                        24,
                        0,
                        0,
                        12,
                        267,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        176,
                        43,
                        268,
                        268,
                        269,
                        161,
                        0,
                        24,
                        0,
                        0,
                        0,
                        267,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        270,
                        0,
                        0,
                        271,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        272,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        273,
                        274,
                        0,
                        0,
                        40,
                        41,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        273,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        40,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        121,
                        275,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        166,
                        0,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        276,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        277,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        0,
                        0,
                        76,
                        280,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        281,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        173,
                        281,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        169,
                        170,
                        171,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        173,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        169,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        282,
                        90,
                        0,
                        0,
                        76,
                        280,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        282,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        283,
                        0,
                        284,
                        285,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        286,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        176,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        287,
                        287,
                        85,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        288,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        184,
                        185,
                        186,
                        187,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        185,
                        185,
                        187,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        289,
                        289,
                        187,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        290,
                        289,
                        289,
                        187,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        291,
                        292,
                        293,
                        294,
                        295,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        277,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        281,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        192,
                        281,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        189,
                        170,
                        190,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        192,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        189,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        76,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        175,
                        296,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        297,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        0,
                        0,
                        97,
                        300,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        301,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        199,
                        301,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        195,
                        196,
                        197,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        199,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        195,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        302,
                        111,
                        0,
                        0,
                        97,
                        300,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        302,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        303,
                        0,
                        304,
                        305,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        306,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        202,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        32,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        307,
                        307,
                        106,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        308,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        210,
                        211,
                        212,
                        213,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        211,
                        211,
                        213,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        309,
                        309,
                        213,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        310,
                        309,
                        309,
                        213,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        311,
                        312,
                        313,
                        314,
                        315,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        297,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        301,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        218,
                        301,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        215,
                        196,
                        216,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        218,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        215,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        97,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        201,
                        316,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        317,
                        318,
                        319,
                        320,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        321,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        323,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        0,
                        0,
                        121,
                        324,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        325,
                        318,
                        326,
                        327,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        328,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        64,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        230,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        227,
                        0,
                        228,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        230,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        227,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        49,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        329,
                        329,
                        133,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        330,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        236,
                        237,
                        238,
                        239,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        237,
                        237,
                        239,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        331,
                        331,
                        239,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        332,
                        331,
                        331,
                        239,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        333,
                        40,
                        121,
                        334,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        335,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        0,
                        0,
                        137,
                        338,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        339,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        244,
                        339,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        240,
                        241,
                        242,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        244,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        240,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        340,
                        151,
                        0,
                        0,
                        137,
                        338,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        340,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        341,
                        0,
                        342,
                        343,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        344,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        247,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        57,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        345,
                        345,
                        146,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        346,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        255,
                        256,
                        257,
                        258,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        256,
                        256,
                        258,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        347,
                        347,
                        258,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        348,
                        347,
                        347,
                        258,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        349,
                        350,
                        351,
                        352,
                        353,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        335,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        339,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        263,
                        339,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        260,
                        241,
                        261,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        263,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        260,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        137,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        246,
                        354,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        126,
                        126,
                        8,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        355,
                        90,
                        0,
                        0,
                        121,
                        125,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        355,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        356,
                        356,
                        269,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        357,
                        358,
                        359,
                        360,
                        361,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        270,
                        0,
                        0,
                        0,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        363,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        364,
                        116,
                        365,
                        366,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        367,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        40,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        281,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        281,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        369,
                        370,
                        371,
                        372,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        373,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        375,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        0,
                        0,
                        175,
                        376,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        377,
                        370,
                        378,
                        379,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        380,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        90,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        286,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        283,
                        0,
                        284,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        286,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        283,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        85,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        82,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        381,
                        381,
                        187,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        382,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        292,
                        293,
                        294,
                        295,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        293,
                        293,
                        295,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        383,
                        383,
                        295,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        384,
                        383,
                        383,
                        295,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        385,
                        76,
                        175,
                        386,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        76,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        301,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        301,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        387,
                        388,
                        389,
                        390,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        391,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        393,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        0,
                        0,
                        201,
                        394,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        395,
                        388,
                        396,
                        397,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        398,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        111,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        306,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        303,
                        0,
                        304,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        306,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        303,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        106,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        103,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        399,
                        399,
                        213,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        400,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        312,
                        313,
                        314,
                        315,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        313,
                        313,
                        315,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        401,
                        401,
                        315,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        402,
                        401,
                        401,
                        315,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        403,
                        97,
                        201,
                        404,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        97,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        405,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        0,
                        0,
                        40,
                        408,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        409,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        321,
                        409,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        317,
                        318,
                        319,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        321,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        317,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        410,
                        64,
                        0,
                        0,
                        40,
                        408,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        410,
                        0,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        323,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        405,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        409,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        328,
                        409,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        325,
                        318,
                        326,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        328,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        325,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        133,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        130,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        411,
                        411,
                        239,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        412,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        40,
                        121,
                        334,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        413,
                        0,
                        0,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        339,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        339,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        414,
                        415,
                        416,
                        417,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        418,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        420,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        0,
                        0,
                        246,
                        421,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        422,
                        415,
                        423,
                        424,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        425,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        151,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        58,
                        0,
                        0,
                        0,
                        0,
                        344,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        341,
                        0,
                        342,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        344,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        341,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        146,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        143,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        426,
                        426,
                        258,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        427,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        350,
                        351,
                        352,
                        353,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        351,
                        351,
                        353,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        428,
                        428,
                        353,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        429,
                        428,
                        428,
                        353,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        430,
                        137,
                        246,
                        431,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        137,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        432,
                        116,
                        433,
                        434,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        435,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        180,
                        180,
                        269,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        358,
                        359,
                        360,
                        361,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        359,
                        359,
                        361,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        436,
                        436,
                        361,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        437,
                        436,
                        436,
                        361,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        438,
                        439,
                        440,
                        441,
                        442,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        443,
                        274,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        443,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        444,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        161,
                        0,
                        0,
                        0,
                        0,
                        367,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        364,
                        116,
                        365,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        367,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        364,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        446,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        0,
                        0,
                        76,
                        449,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        450,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        373,
                        450,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        369,
                        370,
                        371,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        373,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        369,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        451,
                        90,
                        0,
                        0,
                        76,
                        449,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        451,
                        0,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        375,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        446,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        450,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        380,
                        450,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        377,
                        370,
                        378,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        380,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        377,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        187,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        184,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        452,
                        452,
                        295,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        453,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        76,
                        175,
                        386,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        454,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        455,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        0,
                        0,
                        97,
                        458,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        459,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        391,
                        459,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        387,
                        388,
                        389,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        391,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        387,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        460,
                        111,
                        0,
                        0,
                        97,
                        458,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        460,
                        0,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        393,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        455,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        459,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        398,
                        459,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        395,
                        388,
                        396,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        398,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        395,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        213,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        210,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        461,
                        461,
                        315,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        462,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        97,
                        201,
                        404,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        463,
                        0,
                        0,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        409,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        409,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        464,
                        465,
                        466,
                        467,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        468,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        470,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        0,
                        0,
                        121,
                        471,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        472,
                        465,
                        473,
                        474,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        475,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        239,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        236,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        476,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        477,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        0,
                        0,
                        137,
                        480,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        481,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        418,
                        481,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        414,
                        415,
                        416,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        418,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        414,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        482,
                        151,
                        0,
                        0,
                        137,
                        480,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        482,
                        0,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        420,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        477,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        481,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        425,
                        481,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        422,
                        415,
                        423,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        425,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        422,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        258,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        255,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        483,
                        483,
                        353,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        484,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        137,
                        246,
                        431,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        485,
                        0,
                        0,
                        0,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        444,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        161,
                        0,
                        0,
                        0,
                        0,
                        435,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        432,
                        116,
                        433,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        435,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        432,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        486,
                        486,
                        361,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        487,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        439,
                        440,
                        441,
                        442,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        440,
                        440,
                        442,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        488,
                        488,
                        442,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        489,
                        488,
                        488,
                        442,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        490,
                        491,
                        492,
                        493,
                        494,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        495,
                        0,
                        496,
                        497,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        498,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        450,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        450,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        499,
                        500,
                        501,
                        502,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        503,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        505,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        0,
                        0,
                        175,
                        506,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        507,
                        500,
                        508,
                        509,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        510,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        295,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        292,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        511,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        459,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        459,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        512,
                        513,
                        514,
                        515,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        516,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        518,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        0,
                        0,
                        201,
                        519,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        520,
                        513,
                        521,
                        522,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        523,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        315,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        312,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        524,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        525,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        0,
                        0,
                        40,
                        528,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        529,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        468,
                        529,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        464,
                        465,
                        466,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        468,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        464,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        530,
                        64,
                        0,
                        0,
                        40,
                        528,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        530,
                        0,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        470,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        525,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        529,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        475,
                        529,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        472,
                        465,
                        473,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        475,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        472,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        40,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        481,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        481,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        531,
                        532,
                        533,
                        534,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        535,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        537,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        0,
                        0,
                        246,
                        538,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        539,
                        532,
                        540,
                        541,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        542,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        353,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        350,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        543,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        361,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        358,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        544,
                        544,
                        442,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        545,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        491,
                        492,
                        493,
                        494,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        492,
                        492,
                        494,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        546,
                        546,
                        494,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        547,
                        546,
                        546,
                        494,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        548,
                        549,
                        368,
                        550,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        274,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        161,
                        0,
                        0,
                        0,
                        0,
                        498,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        495,
                        0,
                        496,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        498,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        495,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        551,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        0,
                        0,
                        76,
                        554,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        555,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        503,
                        555,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        499,
                        500,
                        501,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        503,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        499,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        556,
                        90,
                        0,
                        0,
                        76,
                        554,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        556,
                        0,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        505,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        551,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        555,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        510,
                        555,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        507,
                        500,
                        508,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        510,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        507,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        76,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        557,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        0,
                        0,
                        97,
                        560,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        561,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        516,
                        561,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        512,
                        513,
                        514,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        516,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        512,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        562,
                        111,
                        0,
                        0,
                        97,
                        560,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        562,
                        0,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        518,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        557,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        561,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        523,
                        561,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        520,
                        513,
                        521,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        523,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        520,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        97,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        529,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        529,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        563,
                        66,
                        564,
                        565,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        566,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        567,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        0,
                        0,
                        121,
                        568,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        569,
                        66,
                        570,
                        571,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        572,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        573,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        0,
                        0,
                        137,
                        576,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        577,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        535,
                        577,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        531,
                        532,
                        533,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        535,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        531,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        578,
                        151,
                        0,
                        0,
                        137,
                        576,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        578,
                        0,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        537,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        573,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        577,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        542,
                        577,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        539,
                        532,
                        540,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        542,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        539,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        137,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        442,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        439,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        579,
                        579,
                        494,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        580,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        549,
                        368,
                        550,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        581,
                        0,
                        0,
                        0,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        555,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        555,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        582,
                        91,
                        583,
                        584,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        585,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        586,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        0,
                        0,
                        175,
                        587,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        588,
                        91,
                        589,
                        590,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        591,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        561,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        561,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        592,
                        112,
                        593,
                        594,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        595,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        596,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        0,
                        0,
                        201,
                        597,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        598,
                        112,
                        599,
                        600,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        601,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        602,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        165,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        566,
                        165,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        563,
                        66,
                        564,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        566,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        563,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        567,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        602,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        165,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        572,
                        165,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        569,
                        66,
                        570,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        572,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        569,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        577,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        577,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        603,
                        152,
                        604,
                        605,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        606,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        607,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        0,
                        0,
                        246,
                        608,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        609,
                        152,
                        610,
                        611,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        612,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        494,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        491,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        613,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        614,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        194,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        585,
                        194,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        582,
                        91,
                        583,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        585,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        582,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        586,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        614,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        194,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        591,
                        194,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        588,
                        91,
                        589,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        591,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        588,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        615,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        220,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        595,
                        220,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        592,
                        112,
                        593,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        595,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        592,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        596,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        615,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        220,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        601,
                        220,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        598,
                        112,
                        599,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        601,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        598,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        616,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        265,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        606,
                        265,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        603,
                        152,
                        604,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        606,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        603,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        607,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        616,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        265,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        612,
                        265,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        609,
                        152,
                        610,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        612,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        609,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        549,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ]
                ];
                var accepting = [
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true
                ];
                var tags = [
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "standalone_cluster"
                    ]
                ];
                var indicMachine = {
                    stateTable: stateTable,
                    accepting: accepting,
                    tags: tags
                };
                var categories = [
                    "O",
                    "IND",
                    "S",
                    "GB",
                    "B",
                    "FM",
                    "CGJ",
                    "VMAbv",
                    "VMPst",
                    "VAbv",
                    "VPst",
                    "CMBlw",
                    "VPre",
                    "VBlw",
                    "H",
                    "VMBlw",
                    "CMAbv",
                    "MBlw",
                    "CS",
                    "R",
                    "SUB",
                    "MPst",
                    "MPre",
                    "FAbv",
                    "FPst",
                    "FBlw",
                    "null",
                    "SMAbv",
                    "SMBlw",
                    "VMPre",
                    "ZWNJ",
                    "ZWJ",
                    "WJ",
                    "M",
                    "VS",
                    "N",
                    "HN",
                    "MAbv"
                ];
                var decompositions = {
                    "2507": [
                        2503,
                        2494
                    ],
                    "2508": [
                        2503,
                        2519
                    ],
                    "2888": [
                        2887,
                        2902
                    ],
                    "2891": [
                        2887,
                        2878
                    ],
                    "2892": [
                        2887,
                        2903
                    ],
                    "3018": [
                        3014,
                        3006
                    ],
                    "3019": [
                        3015,
                        3006
                    ],
                    "3020": [
                        3014,
                        3031
                    ],
                    "3144": [
                        3142,
                        3158
                    ],
                    "3264": [
                        3263,
                        3285
                    ],
                    "3271": [
                        3270,
                        3285
                    ],
                    "3272": [
                        3270,
                        3286
                    ],
                    "3274": [
                        3270,
                        3266
                    ],
                    "3275": [
                        3270,
                        3266,
                        3285
                    ],
                    "3402": [
                        3398,
                        3390
                    ],
                    "3403": [
                        3399,
                        3390
                    ],
                    "3404": [
                        3398,
                        3415
                    ],
                    "3546": [
                        3545,
                        3530
                    ],
                    "3548": [
                        3545,
                        3535
                    ],
                    "3549": [
                        3545,
                        3535,
                        3530
                    ],
                    "3550": [
                        3545,
                        3551
                    ],
                    "3635": [
                        3661,
                        3634
                    ],
                    "3763": [
                        3789,
                        3762
                    ],
                    "3955": [
                        3953,
                        3954
                    ],
                    "3957": [
                        3953,
                        3956
                    ],
                    "3958": [
                        4018,
                        3968
                    ],
                    "3959": [
                        4018,
                        3953,
                        3968
                    ],
                    "3960": [
                        4019,
                        3968
                    ],
                    "3961": [
                        4019,
                        3953,
                        3968
                    ],
                    "3969": [
                        3953,
                        3968
                    ],
                    "6971": [
                        6970,
                        6965
                    ],
                    "6973": [
                        6972,
                        6965
                    ],
                    "6976": [
                        6974,
                        6965
                    ],
                    "6977": [
                        6975,
                        6965
                    ],
                    "6979": [
                        6978,
                        6965
                    ],
                    "69934": [
                        69937,
                        69927
                    ],
                    "69935": [
                        69938,
                        69927
                    ],
                    "70475": [
                        70471,
                        70462
                    ],
                    "70476": [
                        70471,
                        70487
                    ],
                    "70843": [
                        70841,
                        70842
                    ],
                    "70844": [
                        70841,
                        70832
                    ],
                    "70846": [
                        70841,
                        70845
                    ],
                    "71098": [
                        71096,
                        71087
                    ],
                    "71099": [
                        71097,
                        71087
                    ]
                };
                var stateTable$1 = [
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        2,
                        2,
                        3,
                        4,
                        4,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        0,
                        17,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        2,
                        0,
                        0,
                        24,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        27,
                        28,
                        0,
                        0,
                        0,
                        0,
                        0,
                        27,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        39,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        0,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        0,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        9,
                        0,
                        0,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        18,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        11,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        4,
                        4,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        48,
                        11,
                        12,
                        13,
                        14,
                        48,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        49,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        16,
                        0,
                        0,
                        0,
                        11,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        21,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        51,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        16,
                        0,
                        0,
                        0,
                        11,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        27,
                        28,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        28,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        0,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        0,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        33,
                        0,
                        0,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        41,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        35,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        52,
                        35,
                        36,
                        37,
                        38,
                        52,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        53,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        40,
                        0,
                        0,
                        0,
                        35,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        44,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        40,
                        0,
                        0,
                        0,
                        35,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        48,
                        11,
                        12,
                        13,
                        14,
                        0,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        48,
                        11,
                        12,
                        13,
                        14,
                        48,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        51,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        54,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        52,
                        35,
                        36,
                        37,
                        38,
                        0,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        52,
                        35,
                        36,
                        37,
                        38,
                        52,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        51,
                        0
                    ]
                ];
                var accepting$1 = [
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true
                ];
                var tags$1 = [
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "independent_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "numeral_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "independent_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "virama_terminated_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "numeral_cluster"
                    ],
                    [
                        "number_joiner_terminated_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "numeral_cluster"
                    ]
                ];
                var useData = {
                    categories: categories,
                    decompositions: decompositions,
                    stateTable: stateTable$1,
                    accepting: accepting$1,
                    tags: tags$1
                };
                // Cateories used in the OpenType spec:
                // https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
                var CATEGORIES = {
                    X: 1,
                    C: 2,
                    V: 4,
                    N: 8,
                    H: 16,
                    ZWNJ: 32,
                    ZWJ: 64,
                    M: 128,
                    SM: 256,
                    VD: 512,
                    A: 1024,
                    Placeholder: 2048,
                    Dotted_Circle: 4096,
                    RS: 8192,
                    // Register Shifter, used in Khmer OT spec.
                    Coeng: 16384,
                    // Khmer-style Virama.
                    Repha: 32768,
                    // Atomically-encoded logical or visual repha.
                    Ra: 65536,
                    CM: 131072,
                    // Consonant-Medial.
                    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
                }; // Visual positions in a syllable from left to right.
                var POSITIONS = {
                    Start: 1,
                    Ra_To_Become_Reph: 2,
                    Pre_M: 4,
                    Pre_C: 8,
                    Base_C: 16,
                    After_Main: 32,
                    Above_C: 64,
                    Before_Sub: 128,
                    Below_C: 256,
                    After_Sub: 512,
                    Before_Post: 1024,
                    Post_C: 2048,
                    After_Post: 4096,
                    Final_C: 8192,
                    SMVD: 16384,
                    End: 32768
                };
                var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
                var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
                var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
                var INDIC_CONFIGS = {
                    Default: {
                        hasOldSpec: false,
                        virama: 0,
                        basePos: "Last",
                        rephPos: POSITIONS.Before_Post,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Devanagari: {
                        hasOldSpec: true,
                        virama: 0x094D,
                        basePos: "Last",
                        rephPos: POSITIONS.Before_Post,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Bengali: {
                        hasOldSpec: true,
                        virama: 0x09CD,
                        basePos: "Last",
                        rephPos: POSITIONS.After_Sub,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Gurmukhi: {
                        hasOldSpec: true,
                        virama: 0x0A4D,
                        basePos: "Last",
                        rephPos: POSITIONS.Before_Sub,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Gujarati: {
                        hasOldSpec: true,
                        virama: 0x0ACD,
                        basePos: "Last",
                        rephPos: POSITIONS.Before_Post,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Oriya: {
                        hasOldSpec: true,
                        virama: 0x0B4D,
                        basePos: "Last",
                        rephPos: POSITIONS.After_Main,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Tamil: {
                        hasOldSpec: true,
                        virama: 0x0BCD,
                        basePos: "Last",
                        rephPos: POSITIONS.After_Post,
                        rephMode: "Implicit",
                        blwfMode: "Pre_And_Post"
                    },
                    Telugu: {
                        hasOldSpec: true,
                        virama: 0x0C4D,
                        basePos: "Last",
                        rephPos: POSITIONS.After_Post,
                        rephMode: "Explicit",
                        blwfMode: "Post_Only"
                    },
                    Kannada: {
                        hasOldSpec: true,
                        virama: 0x0CCD,
                        basePos: "Last",
                        rephPos: POSITIONS.After_Post,
                        rephMode: "Implicit",
                        blwfMode: "Post_Only"
                    },
                    Malayalam: {
                        hasOldSpec: true,
                        virama: 0x0D4D,
                        basePos: "Last",
                        rephPos: POSITIONS.After_Main,
                        rephMode: "Log_Repha",
                        blwfMode: "Pre_And_Post"
                    },
                    // Handled by UniversalShaper
                    // Sinhala: {
                    //   hasOldSpec: false,
                    //   virama: 0x0DCA,
                    //   basePos: 'Last_Sinhala',
                    //   rephPos: POSITIONS.After_Main,
                    //   rephMode: 'Explicit',
                    //   blwfMode: 'Pre_And_Post'
                    // },
                    Khmer: {
                        hasOldSpec: false,
                        virama: 0x17D2,
                        basePos: "First",
                        rephPos: POSITIONS.Ra_To_Become_Reph,
                        rephMode: "Vis_Repha",
                        blwfMode: "Pre_And_Post"
                    }
                }; // Additional decompositions that aren't in Unicode
                var INDIC_DECOMPOSITIONS = {
                    // Khmer
                    0x17BE: [
                        0x17C1,
                        0x17BE
                    ],
                    0x17BF: [
                        0x17C1,
                        0x17BF
                    ],
                    0x17C0: [
                        0x17C1,
                        0x17C0
                    ],
                    0x17C4: [
                        0x17C1,
                        0x17C4
                    ],
                    0x17C5: [
                        0x17C1,
                        0x17C5
                    ]
                };
                var decompositions$1 = useData.decompositions;
                var trie$1 = new UnicodeTrie(Buffer("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", "base64"));
                var stateMachine = new StateMachine(indicMachine);
                /**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */ var IndicShaper = /*#__PURE__*/ function(_DefaultShaper3) {
                    _inheritsLoose(IndicShaper, _DefaultShaper3);
                    function IndicShaper() {
                        return _DefaultShaper3.apply(this, arguments) || this;
                    }
                    IndicShaper.planFeatures = function planFeatures(plan) {
                        plan.addStage(setupSyllables);
                        plan.addStage([
                            "locl",
                            "ccmp"
                        ]);
                        plan.addStage(initialReordering);
                        plan.addStage("nukt");
                        plan.addStage("akhn");
                        plan.addStage("rphf", false);
                        plan.addStage("rkrf");
                        plan.addStage("pref", false);
                        plan.addStage("blwf", false);
                        plan.addStage("abvf", false);
                        plan.addStage("half", false);
                        plan.addStage("pstf", false);
                        plan.addStage("vatu");
                        plan.addStage("cjct");
                        plan.addStage("cfar", false);
                        plan.addStage(finalReordering);
                        plan.addStage({
                            local: [
                                "init"
                            ],
                            global: [
                                "pres",
                                "abvs",
                                "blws",
                                "psts",
                                "haln",
                                "dist",
                                "abvm",
                                "blwm",
                                "calt",
                                "clig"
                            ]
                        }); // Setup the indic config for the selected script
                        plan.unicodeScript = fromOpenType(plan.script);
                        plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
                        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== "2"; // TODO: turn off kern (Khmer) and liga features.
                    };
                    IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        var _loop = function _loop(i) {
                            var codepoint = glyphs[i].codePoints[0];
                            var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions$1[codepoint];
                            if (d) {
                                var decomposed = d.map(function(c) {
                                    var g = plan.font.glyphForCodePoint(c);
                                    return new GlyphInfo(plan.font, g.id, [
                                        c
                                    ], glyphs[i].features);
                                });
                                glyphs.splice.apply(glyphs, [
                                    i,
                                    1
                                ].concat(decomposed));
                            }
                        };
                        // Decompose split matras
                        // TODO: do this in a more general unicode normalizer
                        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
                    };
                    return IndicShaper;
                }(DefaultShaper);
                _defineProperty(IndicShaper, "zeroMarkWidths", "NONE");
                function indicCategory(glyph) {
                    return trie$1.get(glyph.codePoints[0]) >> 8;
                }
                function indicPosition(glyph) {
                    return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
                }
                var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
                    this.category = category;
                    this.position = position;
                    this.syllableType = syllableType;
                    this.syllable = syllable;
                };
                function setupSyllables(font, glyphs) {
                    var syllable = 0;
                    var last = 0;
                    for(var _iterator53 = _createForOfIteratorHelperLoose(stateMachine.match(glyphs.map(indicCategory))), _step53; !(_step53 = _iterator53()).done;){
                        var _step53$value = _step53.value, start = _step53$value[0], end = _step53$value[1], tags = _step53$value[2];
                        if (start > last) {
                            ++syllable;
                            for(var i = last; i < start; i++)glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, "non_indic_cluster", syllable);
                        }
                        ++syllable; // Create shaper info
                        for(var _i = start; _i <= end; _i++)glyphs[_i].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i]), indicPosition(glyphs[_i]), tags[0], syllable);
                        last = end + 1;
                    }
                    if (last < glyphs.length) {
                        ++syllable;
                        for(var _i2 = last; _i2 < glyphs.length; _i2++)glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, "non_indic_cluster", syllable);
                    }
                }
                function isConsonant(glyph) {
                    return glyph.shaperInfo.category & CONSONANT_FLAGS;
                }
                function isJoiner(glyph) {
                    return glyph.shaperInfo.category & JOINER_FLAGS;
                }
                function isHalantOrCoeng(glyph) {
                    return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
                }
                function wouldSubstitute(glyphs, feature) {
                    for(var _iterator54 = _createForOfIteratorHelperLoose(glyphs), _step54; !(_step54 = _iterator54()).done;){
                        var _glyph$features;
                        var glyph = _step54.value;
                        glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
                    }
                    var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
                    GSUB.applyFeatures([
                        feature
                    ], glyphs);
                    return glyphs.length === 1;
                }
                function consonantPosition(font, consonant, virama) {
                    var glyphs = [
                        virama,
                        consonant,
                        virama
                    ];
                    if (wouldSubstitute(glyphs.slice(0, 2), "blwf") || wouldSubstitute(glyphs.slice(1, 3), "blwf")) return POSITIONS.Below_C;
                    else if (wouldSubstitute(glyphs.slice(0, 2), "pstf") || wouldSubstitute(glyphs.slice(1, 3), "pstf")) return POSITIONS.Post_C;
                    else if (wouldSubstitute(glyphs.slice(0, 2), "pref") || wouldSubstitute(glyphs.slice(1, 3), "pref")) return POSITIONS.Post_C;
                    return POSITIONS.Base_C;
                }
                function initialReordering(font, glyphs, plan) {
                    var indicConfig = plan.indicConfig;
                    var features = font._layoutEngine.engine.GSUBProcessor.features;
                    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
                    var virama = font.glyphForCodePoint(indicConfig.virama).id;
                    if (virama) {
                        var info = new GlyphInfo(font, virama, [
                            indicConfig.virama
                        ]);
                        for(var i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
                    }
                    for(var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)){
                        var _glyphs$start$shaperI = glyphs[start].shaperInfo, category = _glyphs$start$shaperI.category, syllableType = _glyphs$start$shaperI.syllableType;
                        if (syllableType === "symbol_cluster" || syllableType === "non_indic_cluster") continue;
                        if (syllableType === "broken_cluster" && dottedCircle) {
                            var g = new GlyphInfo(font, dottedCircle, [
                                0x25cc
                            ]);
                            g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable); // Insert after possible Repha.
                            var _i3 = start;
                            while(_i3 < end && glyphs[_i3].shaperInfo.category === CATEGORIES.Repha)_i3++;
                            glyphs.splice(_i3++, 0, g);
                            end++;
                        } // 1. Find base consonant:
                        //
                        // The shaping engine finds the base consonant of the syllable, using the
                        // following algorithm: starting from the end of the syllable, move backwards
                        // until a consonant is found that does not have a below-base or post-base
                        // form (post-base forms have to follow below-base forms), or that is not a
                        // pre-base reordering Ra, or arrive at the first consonant. The consonant
                        // stopped at will be the base.
                        var base = end;
                        var limit = start;
                        var hasReph = false; // If the syllable starts with Ra + Halant (in a script that has Reph)
                        // and has more than one consonant, Ra is excluded from candidates for
                        // base consonants.
                        if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === "Implicit" && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === "Explicit" && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                            // See if it matches the 'rphf' feature.
                            var _g = [
                                glyphs[start].copy(),
                                glyphs[start + 1].copy(),
                                glyphs[start + 2].copy()
                            ];
                            if (wouldSubstitute(_g.slice(0, 2), "rphf") || indicConfig.rephMode === "Explicit" && wouldSubstitute(_g, "rphf")) {
                                limit += 2;
                                while(limit < end && isJoiner(glyphs[limit]))limit++;
                                base = start;
                                hasReph = true;
                            }
                        } else if (indicConfig.rephMode === "Log_Repha" && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
                            limit++;
                            while(limit < end && isJoiner(glyphs[limit]))limit++;
                            base = start;
                            hasReph = true;
                        }
                        switch(indicConfig.basePos){
                            case "Last":
                                // starting from the end of the syllable, move backwards
                                var _i4 = end;
                                var seenBelow = false;
                                do {
                                    var _info = glyphs[--_i4].shaperInfo; // until a consonant is found
                                    if (isConsonant(glyphs[_i4])) {
                                        // that does not have a below-base or post-base form
                                        // (post-base forms have to follow below-base forms),
                                        if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
                                            base = _i4;
                                            break;
                                        } // or that is not a pre-base reordering Ra,
                                        //
                                        // IMPLEMENTATION NOTES:
                                        //
                                        // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                                        // by the logic above already.
                                        //
                                        // or arrive at the first consonant. The consonant stopped at will
                                        // be the base.
                                        if (_info.position === POSITIONS.Below_C) seenBelow = true;
                                        base = _i4;
                                    } else if (start < _i4 && _info.category === CATEGORIES.ZWJ && glyphs[_i4 - 1].shaperInfo.category === CATEGORIES.H) break;
                                }while (_i4 > limit);
                                break;
                            case "First":
                                // The first consonant is always the base.
                                base = start; // Mark all subsequent consonants as below.
                                for(var _i5 = base + 1; _i5 < end; _i5++)if (isConsonant(glyphs[_i5])) glyphs[_i5].shaperInfo.position = POSITIONS.Below_C;
                        } // If the syllable starts with Ra + Halant (in a script that has Reph)
                        // and has more than one consonant, Ra is excluded from candidates for
                        // base consonants.
                        //
                        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
                        if (hasReph && base === start && limit - base <= 2) hasReph = false;
                         // 2. Decompose and reorder Matras:
                        //
                        // Each matra and any syllable modifier sign in the cluster are moved to the
                        // appropriate position relative to the consonant(s) in the cluster. The
                        // shaping engine decomposes two- or three-part matras into their constituent
                        // parts before any repositioning. Matra characters are classified by which
                        // consonant in a conjunct they have affinity for and are reordered to the
                        // following positions:
                        //
                        //   o Before first half form in the syllable
                        //   o After subjoined consonants
                        //   o After post-form consonant
                        //   o After main consonant (for above marks)
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // The normalize() routine has already decomposed matras for us, so we don't
                        // need to worry about that.
                        // 3.  Reorder marks to canonical order:
                        //
                        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
                        // if necessary, so that the nukta is first.
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // We don't need to do this: the normalize() routine already did this for us.
                        // Reorder characters
                        for(var _i6 = start; _i6 < base; _i6++){
                            var _info2 = glyphs[_i6].shaperInfo;
                            _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
                        }
                        if (base < end) glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                         // Mark final consonants.  A final consonant is one appearing after a matra,
                        // like in Khmer.
                        for(var _i7 = base + 1; _i7 < end; _i7++)if (glyphs[_i7].shaperInfo.category === CATEGORIES.M) {
                            for(var j = _i7 + 1; j < end; j++)if (isConsonant(glyphs[j])) {
                                glyphs[j].shaperInfo.position = POSITIONS.Final_C;
                                break;
                            }
                            break;
                        }
                         // Handle beginning Ra
                        if (hasReph) glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
                         // For old-style Indic script tags, move the first post-base Halant after
                        // last consonant.
                        //
                        // Reports suggest that in some scripts Uniscribe does this only if there
                        // is *not* a Halant after last consonant already (eg. Kannada), while it
                        // does it unconditionally in other scripts (eg. Malayalam).  We don't
                        // currently know about other scripts, so we single out Malayalam for now.
                        //
                        // Kannada test case:
                        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
                        // With some versions of Lohit Kannada.
                        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
                        //
                        // Malayalam test case:
                        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
                        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
                        if (plan.isOldSpec) {
                            var disallowDoubleHalants = plan.unicodeScript !== "Malayalam";
                            for(var _i8 = base + 1; _i8 < end; _i8++)if (glyphs[_i8].shaperInfo.category === CATEGORIES.H) {
                                var _j = void 0;
                                for(_j = end - 1; _j > _i8; _j--){
                                    if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) break;
                                }
                                if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i8) {
                                    // Move Halant to after last consonant.
                                    var t = glyphs[_i8];
                                    glyphs.splice.apply(glyphs, [
                                        _i8,
                                        0
                                    ].concat(glyphs.splice(_i8 + 1, _j - _i8)));
                                    glyphs[_j] = t;
                                }
                                break;
                            }
                        } // Attach misc marks to previous char to move with them.
                        var lastPos = POSITIONS.Start;
                        for(var _i9 = start; _i9 < end; _i9++){
                            var _info3 = glyphs[_i9].shaperInfo;
                            if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
                                _info3.position = lastPos;
                                if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
                                    // Uniscribe doesn't move the Halant with Left Matra.
                                    // TEST: U+092B,U+093F,U+094DE
                                    // We follow.  This is important for the Sinhala
                                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                                    // We don't want to move the virama with the left matra.
                                    // TEST: U+0D9A,U+0DDA
                                    for(var _j2 = _i9; _j2 > start; _j2--)if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
                                        _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                                        break;
                                    }
                                }
                            } else if (_info3.position !== POSITIONS.SMVD) lastPos = _info3.position;
                        } // For post-base consonants let them own anything before them
                        // since the last consonant or matra.
                        var last = base;
                        for(var _i10 = base + 1; _i10 < end; _i10++){
                            if (isConsonant(glyphs[_i10])) {
                                for(var _j3 = last + 1; _j3 < _i10; _j3++)if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) glyphs[_j3].shaperInfo.position = glyphs[_i10].shaperInfo.position;
                                last = _i10;
                            } else if (glyphs[_i10].shaperInfo.category === CATEGORIES.M) last = _i10;
                        }
                        var arr = glyphs.slice(start, end);
                        arr.sort(function(a, b) {
                            return a.shaperInfo.position - b.shaperInfo.position;
                        });
                        glyphs.splice.apply(glyphs, [
                            start,
                            arr.length
                        ].concat(arr)); // Find base again
                        for(var _i11 = start; _i11 < end; _i11++)if (glyphs[_i11].shaperInfo.position === POSITIONS.Base_C) {
                            base = _i11;
                            break;
                        }
                         // Setup features now
                        // Reph
                        for(var _i12 = start; _i12 < end && glyphs[_i12].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i12++)glyphs[_i12].features.rphf = true;
                         // Pre-base
                        var blwf = !plan.isOldSpec && indicConfig.blwfMode === "Pre_And_Post";
                        for(var _i13 = start; _i13 < base; _i13++){
                            glyphs[_i13].features.half = true;
                            if (blwf) glyphs[_i13].features.blwf = true;
                        } // Post-base
                        for(var _i14 = base + 1; _i14 < end; _i14++){
                            glyphs[_i14].features.abvf = true;
                            glyphs[_i14].features.pstf = true;
                            glyphs[_i14].features.blwf = true;
                        }
                        if (plan.isOldSpec && plan.unicodeScript === "Devanagari") {
                            // Old-spec eye-lash Ra needs special handling.  From the
                            // spec:
                            //
                            // "The feature 'below-base form' is applied to consonants
                            // having below-base forms and following the base consonant.
                            // The exception is vattu, which may appear below half forms
                            // as well as below the base glyph. The feature 'below-base
                            // form' will be applied to all such occurrences of Ra as well."
                            //
                            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
                            // with Sanskrit 2003 font.
                            //
                            // However, note that Ra,Halant,ZWJ is the correct way to
                            // request eyelash form of Ra, so we wouldbn't inhibit it
                            // in that sequence.
                            //
                            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
                            for(var _i15 = start; _i15 + 1 < base; _i15++)if (glyphs[_i15].shaperInfo.category === CATEGORIES.Ra && glyphs[_i15 + 1].shaperInfo.category === CATEGORIES.H && (_i15 + 1 === base || glyphs[_i15 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                                glyphs[_i15].features.blwf = true;
                                glyphs[_i15 + 1].features.blwf = true;
                            }
                        }
                        var prefLen = 2;
                        if (features.pref && base + prefLen < end) // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
                        for(var _i16 = base + 1; _i16 + prefLen - 1 < end; _i16++){
                            var _g2 = [
                                glyphs[_i16].copy(),
                                glyphs[_i16 + 1].copy()
                            ];
                            if (wouldSubstitute(_g2, "pref")) {
                                for(var _j4 = 0; _j4 < prefLen; _j4++)glyphs[_i16++].features.pref = true;
                                 // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                                // Read the feature spec.
                                // This allows distinguishing the following cases with MS Khmer fonts:
                                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                                if (features.cfar) for(; _i16 < end; _i16++)glyphs[_i16].features.cfar = true;
                                break;
                            }
                        }
                         // Apply ZWJ/ZWNJ effects
                        for(var _i17 = start + 1; _i17 < end; _i17++)if (isJoiner(glyphs[_i17])) {
                            var nonJoiner = glyphs[_i17].shaperInfo.category === CATEGORIES.ZWNJ;
                            var _j5 = _i17;
                            do {
                                _j5--; // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                                // being there, since we don't skip them for the CJCT
                                // feature (ie. F_MANUAL_ZWJ)
                                // A ZWNJ disables HALF.
                                if (nonJoiner) delete glyphs[_j5].features.half;
                            }while (_j5 > start && !isConsonant(glyphs[_j5]));
                        }
                    }
                }
                function finalReordering(font, glyphs, plan) {
                    var indicConfig = plan.indicConfig;
                    var features = font._layoutEngine.engine.GSUBProcessor.features;
                    for(var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)){
                        // 4. Final reordering:
                        //
                        // After the localized forms and basic shaping forms GSUB features have been
                        // applied (see below), the shaping engine performs some final glyph
                        // reordering before applying all the remaining font features to the entire
                        // cluster.
                        var tryPref = !!features.pref; // Find base again
                        var base = start;
                        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
                            if (tryPref && base + 1 < end) {
                                for(var i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                                        // Ok, this was a 'pref' candidate but didn't form any.
                                        // Base is around here...
                                        base = i;
                                        while(base < end && isHalantOrCoeng(glyphs[base]))base++;
                                        glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
                                        tryPref = false;
                                    }
                                    break;
                                }
                            } // For Malayalam, skip over unformed below- (but NOT post-) forms.
                            if (plan.unicodeScript === "Malayalam") for(var _i18 = base + 1; _i18 < end; _i18++){
                                while(_i18 < end && isJoiner(glyphs[_i18]))_i18++;
                                if (_i18 === end || !isHalantOrCoeng(glyphs[_i18])) break;
                                _i18++; // Skip halant.
                                while(_i18 < end && isJoiner(glyphs[_i18]))_i18++;
                                if (_i18 < end && isConsonant(glyphs[_i18]) && glyphs[_i18].shaperInfo.position === POSITIONS.Below_C) {
                                    base = _i18;
                                    glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                                }
                            }
                            if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) base--;
                            break;
                        }
                        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) base--;
                        if (base < end) while(start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS))base--;
                         // o Reorder matras:
                        //
                        // If a pre-base matra character had been reordered before applying basic
                        // features, the glyph can be moved closer to the main consonant based on
                        // whether half-forms had been formed. Actual position for the matra is
                        // defined as “after last standalone halant glyph, after initial matra
                        // position and before the main consonant”. If ZWJ or ZWNJ follow this
                        // halant, position is moved after it.
                        //
                        if (start + 1 < end && start < base) {
                            // Otherwise there can't be any pre-base matra characters.
                            // If we lost track of base, alas, position before last thingy.
                            var newPos = base === end ? base - 2 : base - 1; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                            // We want to position matra after them.
                            if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
                                while(newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS)))newPos--;
                                 // If we found no Halant we are done.
                                // Otherwise only proceed if the Halant does
                                // not belong to the Matra itself!
                                if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) // If ZWJ or ZWNJ follow this halant, position is moved after it.
                                {
                                    if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) newPos++;
                                } else newPos = start; // No move.
                            }
                            if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                                // Now go see if there's actually any matras...
                                for(var _i19 = newPos; _i19 > start; _i19--)if (glyphs[_i19 - 1].shaperInfo.position === POSITIONS.Pre_M) {
                                    var oldPos = _i19 - 1;
                                    if (oldPos < base && base <= newPos) // Shouldn't actually happen.
                                    base--;
                                    var tmp = glyphs[oldPos];
                                    glyphs.splice.apply(glyphs, [
                                        oldPos,
                                        0
                                    ].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                                    glyphs[newPos] = tmp;
                                    newPos--;
                                }
                            }
                        } // o Reorder reph:
                        //
                        // Reph’s original position is always at the beginning of the syllable,
                        // (i.e. it is not reordered at the character reordering stage). However,
                        // it will be reordered according to the basic-forms shaping results.
                        // Possible positions for reph, depending on the script, are; after main,
                        // before post-base consonant forms, and after post-base consonant forms.
                        // Two cases:
                        //
                        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
                        //   we should only move it if the sequence ligated to the repha form.
                        //
                        // - If repha is encoded separately and in the logical position, we should only
                        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
                        //   to make it work without the reordering.
                        if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
                            var newRephPos = void 0;
                            var rephPos = indicConfig.rephPos;
                            var found = false; // 1. If reph should be positioned after post-base consonant forms,
                            //    proceed to step 5.
                            if (rephPos !== POSITIONS.After_Post) {
                                //  2. If the reph repositioning class is not after post-base: target
                                //     position is after the first explicit halant glyph between the
                                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                                //     are following this halant, position is moved after it. If such
                                //     position is found, this is the target position. Otherwise,
                                //     proceed to the next step.
                                //
                                //     Note: in old-implementation fonts, where classifications were
                                //     fixed in shaping engine, there was no case where reph position
                                //     will be found on this step.
                                newRephPos = start + 1;
                                while(newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                                    found = true;
                                } // 3. If reph should be repositioned after the main consonant: find the
                                //    first consonant not ligated with main, or find the first
                                //    consonant that is not a potential pre-base reordering Ra.
                                if (!found && rephPos === POSITIONS.After_Main) {
                                    newRephPos = base;
                                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main)newRephPos++;
                                    found = newRephPos < end;
                                } // 4. If reph should be positioned before post-base consonant, find
                                //    first post-base classified consonant not ligated with main. If no
                                //    consonant is found, the target position should be before the
                                //    first matra, syllable modifier sign or vedic sign.
                                //
                                // This is our take on what step 4 is trying to say (and failing, BADLY).
                                if (!found && rephPos === POSITIONS.After_Sub) {
                                    newRephPos = base;
                                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD)))newRephPos++;
                                    found = newRephPos < end;
                                }
                            } //  5. If no consonant is found in steps 3 or 4, move reph to a position
                            //     immediately before the first post-base matra, syllable modifier
                            //     sign or vedic sign that has a reordering class after the intended
                            //     reph position. For example, if the reordering position for reph
                            //     is post-main, it will skip above-base matras that also have a
                            //     post-main position.
                            if (!found) {
                                // Copied from step 2.
                                newRephPos = start + 1;
                                while(newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                                    found = true;
                                }
                            } // 6. Otherwise, reorder reph to the end of the syllable.
                            if (!found) {
                                newRephPos = end - 1;
                                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD)newRephPos--;
                                 // If the Reph is to be ending up after a Matra,Halant sequence,
                                // position it before that Halant so it can interact with the Matra.
                                // However, if it's a plain Consonant,Halant we shouldn't do that.
                                // Uniscribe doesn't do this.
                                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                                if (isHalantOrCoeng(glyphs[newRephPos])) {
                                    for(var _i20 = base + 1; _i20 < newRephPos; _i20++)if (glyphs[_i20].shaperInfo.category === CATEGORIES.M) newRephPos--;
                                }
                            }
                            var reph = glyphs[start];
                            glyphs.splice.apply(glyphs, [
                                start,
                                0
                            ].concat(glyphs.splice(start + 1, newRephPos - start)));
                            glyphs[newRephPos] = reph;
                            if (start < base && base <= newRephPos) base--;
                        } // o Reorder pre-base reordering consonants:
                        //
                        // If a pre-base reordering consonant is found, reorder it according to
                        // the following rules:
                        if (tryPref && base + 1 < end) {
                            for(var _i21 = base + 1; _i21 < end; _i21++)if (glyphs[_i21].features.pref) {
                                // 1. Only reorder a glyph produced by substitution during application
                                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                                //    the feature generally but block it in certain contexts.)
                                // Note: We just check that something got substituted.  We don't check that
                                // the <pref> feature actually did it...
                                //
                                // Reorder pref only if it ligated.
                                if (glyphs[_i21].isLigated && !glyphs[_i21].isMultiplied) {
                                    // 2. Try to find a target position the same way as for pre-base matra.
                                    //    If it is found, reorder pre-base consonant glyph.
                                    //
                                    // 3. If position is not found, reorder immediately before main
                                    //    consonant.
                                    var _newPos = base; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                                    // We want to position matra after them.
                                    if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
                                        while(_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS)))_newPos--;
                                         // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                                        // split matra, it should be reordered to *before* the left part of such matra.
                                        if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
                                            var _oldPos2 = _i21;
                                            for(var j = base + 1; j < _oldPos2; j++)if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
                                                _newPos--;
                                                break;
                                            }
                                        }
                                    }
                                    if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
                                    {
                                        if (_newPos < end && isJoiner(glyphs[_newPos])) _newPos++;
                                    }
                                    var _oldPos = _i21;
                                    var _tmp = glyphs[_oldPos];
                                    glyphs.splice.apply(glyphs, [
                                        _newPos + 1,
                                        0
                                    ].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                                    glyphs[_newPos] = _tmp;
                                    if (_newPos <= base && base < _oldPos) base++;
                                }
                                break;
                            }
                        } // Apply 'init' to the Left Matra if it's a word start.
                        if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
                    }
                }
                function nextSyllable(glyphs, start) {
                    if (start >= glyphs.length) return start;
                    var syllable = glyphs[start].shaperInfo.syllable;
                    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
                    return start;
                }
                var categories$1 = useData.categories, decompositions$2 = useData.decompositions;
                var trie$2 = new UnicodeTrie(Buffer("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", "base64"));
                var stateMachine$1 = new StateMachine(useData);
                /**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */ var UniversalShaper = /*#__PURE__*/ function(_DefaultShaper4) {
                    _inheritsLoose(UniversalShaper, _DefaultShaper4);
                    function UniversalShaper() {
                        return _DefaultShaper4.apply(this, arguments) || this;
                    }
                    UniversalShaper.planFeatures = function planFeatures(plan) {
                        plan.addStage(setupSyllables$1); // Default glyph pre-processing group
                        plan.addStage([
                            "locl",
                            "ccmp",
                            "nukt",
                            "akhn"
                        ]); // Reordering group
                        plan.addStage(clearSubstitutionFlags);
                        plan.addStage([
                            "rphf"
                        ], false);
                        plan.addStage(recordRphf);
                        plan.addStage(clearSubstitutionFlags);
                        plan.addStage([
                            "pref"
                        ]);
                        plan.addStage(recordPref); // Orthographic unit shaping group
                        plan.addStage([
                            "rkrf",
                            "abvf",
                            "blwf",
                            "half",
                            "pstf",
                            "vatu",
                            "cjct"
                        ]);
                        plan.addStage(reorder); // Topographical features
                        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
                        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
                        // Standard topographic presentation and positional feature application
                        plan.addStage([
                            "abvs",
                            "blws",
                            "pres",
                            "psts",
                            "dist",
                            "abvm",
                            "blwm"
                        ]);
                    };
                    UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        var _loop = function _loop(i) {
                            var codepoint = glyphs[i].codePoints[0];
                            if (decompositions$2[codepoint]) {
                                var decomposed = decompositions$2[codepoint].map(function(c) {
                                    var g = plan.font.glyphForCodePoint(c);
                                    return new GlyphInfo(plan.font, g.id, [
                                        c
                                    ], glyphs[i].features);
                                });
                                glyphs.splice.apply(glyphs, [
                                    i,
                                    1
                                ].concat(decomposed));
                            }
                        };
                        // Decompose split vowels
                        // TODO: do this in a more general unicode normalizer
                        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
                    };
                    return UniversalShaper;
                }(DefaultShaper);
                _defineProperty(UniversalShaper, "zeroMarkWidths", "BEFORE_GPOS");
                function useCategory(glyph) {
                    return trie$2.get(glyph.codePoints[0]);
                }
                var USEInfo = function USEInfo(category, syllableType, syllable) {
                    this.category = category;
                    this.syllableType = syllableType;
                    this.syllable = syllable;
                };
                function setupSyllables$1(font, glyphs) {
                    var syllable = 0;
                    for(var _iterator55 = _createForOfIteratorHelperLoose(stateMachine$1.match(glyphs.map(useCategory))), _step55; !(_step55 = _iterator55()).done;){
                        var _step55$value = _step55.value, start = _step55$value[0], end = _step55$value[1], tags = _step55$value[2];
                        ++syllable; // Create shaper info
                        for(var i = start; i <= end; i++)glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
                         // Assign rphf feature
                        var limit = glyphs[start].shaperInfo.category === "R" ? 1 : Math.min(3, end - start);
                        for(var _i = start; _i < start + limit; _i++)glyphs[_i].features.rphf = true;
                    }
                }
                function clearSubstitutionFlags(font, glyphs) {
                    for(var _iterator56 = _createForOfIteratorHelperLoose(glyphs), _step56; !(_step56 = _iterator56()).done;){
                        var glyph = _step56.value;
                        glyph.substituted = false;
                    }
                }
                function recordRphf(font, glyphs) {
                    for(var _iterator57 = _createForOfIteratorHelperLoose(glyphs), _step57; !(_step57 = _iterator57()).done;){
                        var glyph = _step57.value;
                        if (glyph.substituted && glyph.features.rphf) // Mark a substituted repha.
                        glyph.shaperInfo.category = "R";
                    }
                }
                function recordPref(font, glyphs) {
                    for(var _iterator58 = _createForOfIteratorHelperLoose(glyphs), _step58; !(_step58 = _iterator58()).done;){
                        var glyph = _step58.value;
                        if (glyph.substituted) // Mark a substituted pref as VPre, as they behave the same way.
                        glyph.shaperInfo.category = "VPre";
                    }
                }
                function reorder(font, glyphs) {
                    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
                    for(var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)){
                        var i = void 0, j = void 0;
                        var info = glyphs[start].shaperInfo;
                        var type = info.syllableType; // Only a few syllable types need reordering.
                        if (type !== "virama_terminated_cluster" && type !== "standard_cluster" && type !== "broken_cluster") continue;
                         // Insert a dotted circle glyph in broken clusters.
                        if (type === "broken_cluster" && dottedCircle) {
                            var g = new GlyphInfo(font, dottedCircle, [
                                0x25cc
                            ]);
                            g.shaperInfo = info; // Insert after possible Repha.
                            for(i = start; i < end && glyphs[i].shaperInfo.category === "R"; i++);
                            glyphs.splice(++i, 0, g);
                            end++;
                        } // Move things forward.
                        if (info.category === "R" && end - start > 1) // Got a repha. Reorder it to after first base, before first halant.
                        for(i = start + 1; i < end; i++){
                            info = glyphs[i].shaperInfo;
                            if (isBase(info) || isHalant(glyphs[i])) {
                                // If we hit a halant, move before it; otherwise it's a base: move to it's
                                // place, and shift things in between backward.
                                if (isHalant(glyphs[i])) i--;
                                glyphs.splice.apply(glyphs, [
                                    start,
                                    0
                                ].concat(glyphs.splice(start + 1, i - start), [
                                    glyphs[i]
                                ]));
                                break;
                            }
                        }
                         // Move things back.
                        for(i = start, j = end; i < end; i++){
                            info = glyphs[i].shaperInfo;
                            if (isBase(info) || isHalant(glyphs[i])) // If we hit a halant, move after it; otherwise it's a base: move to it's
                            // place, and shift things in between backward.
                            j = isHalant(glyphs[i]) ? i + 1 : i;
                            else if ((info.category === "VPre" || info.category === "VMPre") && j < i) glyphs.splice.apply(glyphs, [
                                j,
                                1,
                                glyphs[i]
                            ].concat(glyphs.splice(j, i - j)));
                        }
                    }
                }
                function nextSyllable$1(glyphs, start) {
                    if (start >= glyphs.length) return start;
                    var syllable = glyphs[start].shaperInfo.syllable;
                    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
                    return start;
                }
                function isHalant(glyph) {
                    return glyph.shaperInfo.category === "H" && !glyph.isLigated;
                }
                function isBase(info) {
                    return info.category === "B" || info.category === "GB";
                }
                var SHAPERS = {
                    arab: ArabicShaper,
                    // Arabic
                    mong: ArabicShaper,
                    // Mongolian
                    syrc: ArabicShaper,
                    // Syriac
                    "nko ": ArabicShaper,
                    // N'Ko
                    phag: ArabicShaper,
                    // Phags Pa
                    mand: ArabicShaper,
                    // Mandaic
                    mani: ArabicShaper,
                    // Manichaean
                    phlp: ArabicShaper,
                    // Psalter Pahlavi
                    hang: HangulShaper,
                    // Hangul
                    bng2: IndicShaper,
                    // Bengali
                    beng: IndicShaper,
                    // Bengali
                    dev2: IndicShaper,
                    // Devanagari
                    deva: IndicShaper,
                    // Devanagari
                    gjr2: IndicShaper,
                    // Gujarati
                    gujr: IndicShaper,
                    // Gujarati
                    guru: IndicShaper,
                    // Gurmukhi
                    gur2: IndicShaper,
                    // Gurmukhi
                    knda: IndicShaper,
                    // Kannada
                    knd2: IndicShaper,
                    // Kannada
                    mlm2: IndicShaper,
                    // Malayalam
                    mlym: IndicShaper,
                    // Malayalam
                    ory2: IndicShaper,
                    // Oriya
                    orya: IndicShaper,
                    // Oriya
                    taml: IndicShaper,
                    // Tamil
                    tml2: IndicShaper,
                    // Tamil
                    telu: IndicShaper,
                    // Telugu
                    tel2: IndicShaper,
                    // Telugu
                    khmr: IndicShaper,
                    // Khmer
                    bali: UniversalShaper,
                    // Balinese
                    batk: UniversalShaper,
                    // Batak
                    brah: UniversalShaper,
                    // Brahmi
                    bugi: UniversalShaper,
                    // Buginese
                    buhd: UniversalShaper,
                    // Buhid
                    cakm: UniversalShaper,
                    // Chakma
                    cham: UniversalShaper,
                    // Cham
                    dupl: UniversalShaper,
                    // Duployan
                    egyp: UniversalShaper,
                    // Egyptian Hieroglyphs
                    gran: UniversalShaper,
                    // Grantha
                    hano: UniversalShaper,
                    // Hanunoo
                    java: UniversalShaper,
                    // Javanese
                    kthi: UniversalShaper,
                    // Kaithi
                    kali: UniversalShaper,
                    // Kayah Li
                    khar: UniversalShaper,
                    // Kharoshthi
                    khoj: UniversalShaper,
                    // Khojki
                    sind: UniversalShaper,
                    // Khudawadi
                    lepc: UniversalShaper,
                    // Lepcha
                    limb: UniversalShaper,
                    // Limbu
                    mahj: UniversalShaper,
                    // Mahajani
                    // mand: UniversalShaper, // Mandaic
                    // mani: UniversalShaper, // Manichaean
                    mtei: UniversalShaper,
                    // Meitei Mayek
                    modi: UniversalShaper,
                    // Modi
                    // mong: UniversalShaper, // Mongolian
                    // 'nko ': UniversalShaper, // N’Ko
                    hmng: UniversalShaper,
                    // Pahawh Hmong
                    // phag: UniversalShaper, // Phags-pa
                    // phlp: UniversalShaper, // Psalter Pahlavi
                    rjng: UniversalShaper,
                    // Rejang
                    saur: UniversalShaper,
                    // Saurashtra
                    shrd: UniversalShaper,
                    // Sharada
                    sidd: UniversalShaper,
                    // Siddham
                    sinh: UniversalShaper,
                    // Sinhala
                    sund: UniversalShaper,
                    // Sundanese
                    sylo: UniversalShaper,
                    // Syloti Nagri
                    tglg: UniversalShaper,
                    // Tagalog
                    tagb: UniversalShaper,
                    // Tagbanwa
                    tale: UniversalShaper,
                    // Tai Le
                    lana: UniversalShaper,
                    // Tai Tham
                    tavt: UniversalShaper,
                    // Tai Viet
                    takr: UniversalShaper,
                    // Takri
                    tibt: UniversalShaper,
                    // Tibetan
                    tfng: UniversalShaper,
                    // Tifinagh
                    tirh: UniversalShaper,
                    // Tirhuta
                    latn: DefaultShaper,
                    // Latin
                    DFLT: DefaultShaper // Default
                };
                function choose(script) {
                    if (!Array.isArray(script)) script = [
                        script
                    ];
                    for(var _iterator59 = _createForOfIteratorHelperLoose(script), _step59; !(_step59 = _iterator59()).done;){
                        var s = _step59.value;
                        var shaper = SHAPERS[s];
                        if (shaper) return shaper;
                    }
                    return DefaultShaper;
                }
                var GSUBProcessor = /*#__PURE__*/ function(_OTProcessor) {
                    _inheritsLoose(GSUBProcessor, _OTProcessor);
                    function GSUBProcessor() {
                        return _OTProcessor.apply(this, arguments) || this;
                    }
                    var _proto27 = GSUBProcessor.prototype;
                    _proto27.applyLookup = function applyLookup(lookupType, table) {
                        var _this7 = this;
                        switch(lookupType){
                            case 1:
                                // Single Substitution
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                var glyph = this.glyphIterator.cur;
                                switch(table.version){
                                    case 1:
                                        glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                                        break;
                                    case 2:
                                        glyph.id = table.substitute.get(index);
                                        break;
                                }
                                return true;
                            case 2:
                                // Multiple Substitution
                                var _index = this.coverageIndex(table.coverage);
                                if (_index !== -1) {
                                    var _this$glyphs2;
                                    var sequence = table.sequences.get(_index);
                                    if (sequence.length === 0) {
                                        // If the sequence length is zero, delete the glyph.
                                        // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                                        this.glyphs.splice(this.glyphIterator.index, 1);
                                        return true;
                                    }
                                    this.glyphIterator.cur.id = sequence[0];
                                    this.glyphIterator.cur.ligatureComponent = 0;
                                    var features = this.glyphIterator.cur.features;
                                    var curGlyph = this.glyphIterator.cur;
                                    var replacement = sequence.slice(1).map(function(gid, i) {
                                        var glyph = new GlyphInfo(_this7.font, gid, undefined, features);
                                        glyph.shaperInfo = curGlyph.shaperInfo;
                                        glyph.isLigated = curGlyph.isLigated;
                                        glyph.ligatureComponent = i + 1;
                                        glyph.substituted = true;
                                        glyph.isMultiplied = true;
                                        return glyph;
                                    });
                                    (_this$glyphs2 = this.glyphs).splice.apply(_this$glyphs2, [
                                        this.glyphIterator.index + 1,
                                        0
                                    ].concat(replacement));
                                    return true;
                                }
                                return false;
                            case 3:
                                // Alternate Substitution
                                var _index2 = this.coverageIndex(table.coverage);
                                if (_index2 !== -1) {
                                    var USER_INDEX = 0; // TODO
                                    this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                                    return true;
                                }
                                return false;
                            case 4:
                                // Ligature Substitution
                                var _index3 = this.coverageIndex(table.coverage);
                                if (_index3 === -1) return false;
                                for(var _iterator60 = _createForOfIteratorHelperLoose(table.ligatureSets.get(_index3)), _step60; !(_step60 = _iterator60()).done;){
                                    var ligature = _step60.value;
                                    var matched = this.sequenceMatchIndices(1, ligature.components);
                                    if (!matched) continue;
                                    var _curGlyph = this.glyphIterator.cur; // Concatenate all of the characters the new ligature will represent
                                    var characters = _curGlyph.codePoints.slice();
                                    for(var _iterator61 = _createForOfIteratorHelperLoose(matched), _step61; !(_step61 = _iterator61()).done;){
                                        var _characters;
                                        var _index4 = _step61.value;
                                        (_characters = characters).push.apply(_characters, this.glyphs[_index4].codePoints);
                                    } // Create the replacement ligature glyph
                                    var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
                                    ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                                    ligatureGlyph.isLigated = true;
                                    ligatureGlyph.substituted = true; // From Harfbuzz:
                                    // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                                    //   the ligature to keep its old ligature id.  This will allow it to attach to
                                    //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                                    //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                                    //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                                    //   later, we don't want them to lose their ligature id/component, otherwise
                                    //   GPOS will fail to correctly position the mark ligature on top of the
                                    //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                                    //
                                    // - If a ligature is formed of components that some of which are also ligatures
                                    //   themselves, and those ligature components had marks attached to *their*
                                    //   components, we have to attach the marks to the new ligature component
                                    //   positions!  Now *that*'s tricky!  And these marks may be following the
                                    //   last component of the whole sequence, so we should loop forward looking
                                    //   for them and update them.
                                    //
                                    //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                                    //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                                    //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                                    //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                                    //   the new ligature with a component value of 2.
                                    //
                                    //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                                    var isMarkLigature = _curGlyph.isMark;
                                    for(var i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                                    ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                                    var lastLigID = _curGlyph.ligatureID;
                                    var lastNumComps = _curGlyph.codePoints.length;
                                    var curComps = lastNumComps;
                                    var idx = this.glyphIterator.index + 1; // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                                    // This allows GPOS to attach marks to the correct ligature components.
                                    for(var _iterator62 = _createForOfIteratorHelperLoose(matched), _step62; !(_step62 = _iterator62()).done;){
                                        var matchIndex = _step62.value;
                                        // Don't assign new ligature components for mark ligatures (see above)
                                        if (isMarkLigature) idx = matchIndex;
                                        else while(idx < matchIndex){
                                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                            this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                            this.glyphs[idx].ligatureComponent = ligatureComponent;
                                            idx++;
                                        }
                                        lastLigID = this.glyphs[idx].ligatureID;
                                        lastNumComps = this.glyphs[idx].codePoints.length;
                                        curComps += lastNumComps;
                                        idx++; // skip base glyph
                                    } // Adjust ligature components for any marks following
                                    if (lastLigID && !isMarkLigature) for(var _i = idx; _i < this.glyphs.length; _i++){
                                        if (this.glyphs[_i].ligatureID === lastLigID) {
                                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i].ligatureComponent || 1, lastNumComps);
                                            this.glyphs[_i].ligatureComponent = ligatureComponent;
                                        } else break;
                                    }
                                     // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                                    for(var _i2 = matched.length - 1; _i2 >= 0; _i2--)this.glyphs.splice(matched[_i2], 1);
                                    this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                                    return true;
                                }
                                return false;
                            case 5:
                                // Contextual Substitution
                                return this.applyContext(table);
                            case 6:
                                // Chaining Contextual Substitution
                                return this.applyChainingContext(table);
                            case 7:
                                // Extension Substitution
                                return this.applyLookup(table.lookupType, table.extension);
                            default:
                                throw new Error("GSUB lookupType ".concat(lookupType, " is not supported"));
                        }
                    };
                    return GSUBProcessor;
                }(OTProcessor);
                var GPOSProcessor = /*#__PURE__*/ function(_OTProcessor2) {
                    _inheritsLoose(GPOSProcessor, _OTProcessor2);
                    function GPOSProcessor() {
                        return _OTProcessor2.apply(this, arguments) || this;
                    }
                    var _proto28 = GPOSProcessor.prototype;
                    _proto28.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
                        var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
                        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
                        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
                        if (value.xPlacement != null) position.xOffset += value.xPlacement;
                        if (value.yPlacement != null) position.yOffset += value.yPlacement;
                         // Adjustments for font variations
                        var variationProcessor = this.font._variationProcessor;
                        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
                        if (variationProcessor && variationStore) {
                            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
                            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
                            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
                            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
                        } // TODO: device tables
                    };
                    _proto28.applyLookup = function applyLookup(lookupType, table) {
                        switch(lookupType){
                            case 1:
                                // Single positioning value
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                switch(table.version){
                                    case 1:
                                        this.applyPositionValue(0, table.value);
                                        break;
                                    case 2:
                                        this.applyPositionValue(0, table.values.get(index));
                                        break;
                                }
                                return true;
                            case 2:
                                // Pair Adjustment Positioning
                                var nextGlyph = this.glyphIterator.peek();
                                if (!nextGlyph) return false;
                                var _index = this.coverageIndex(table.coverage);
                                if (_index === -1) return false;
                                switch(table.version){
                                    case 1:
                                        // Adjustments for glyph pairs
                                        var set = table.pairSets.get(_index);
                                        for(var _iterator63 = _createForOfIteratorHelperLoose(set), _step63; !(_step63 = _iterator63()).done;){
                                            var _pair = _step63.value;
                                            if (_pair.secondGlyph === nextGlyph.id) {
                                                this.applyPositionValue(0, _pair.value1);
                                                this.applyPositionValue(1, _pair.value2);
                                                return true;
                                            }
                                        }
                                        return false;
                                    case 2:
                                        // Class pair adjustment
                                        var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                                        var class2 = this.getClassID(nextGlyph.id, table.classDef2);
                                        if (class1 === -1 || class2 === -1) return false;
                                        var pair = table.classRecords.get(class1).get(class2);
                                        this.applyPositionValue(0, pair.value1);
                                        this.applyPositionValue(1, pair.value2);
                                        return true;
                                }
                            case 3:
                                // Cursive Attachment Positioning
                                var nextIndex = this.glyphIterator.peekIndex();
                                var _nextGlyph = this.glyphs[nextIndex];
                                if (!_nextGlyph) return false;
                                var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                                if (!curRecord || !curRecord.exitAnchor) return false;
                                var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
                                if (!nextRecord || !nextRecord.entryAnchor) return false;
                                var entry = this.getAnchor(nextRecord.entryAnchor);
                                var exit = this.getAnchor(curRecord.exitAnchor);
                                var cur = this.positions[this.glyphIterator.index];
                                var next = this.positions[nextIndex];
                                switch(this.direction){
                                    case "ltr":
                                        cur.xAdvance = exit.x + cur.xOffset;
                                        var d = entry.x + next.xOffset;
                                        next.xAdvance -= d;
                                        next.xOffset -= d;
                                        break;
                                    case "rtl":
                                        d = exit.x + cur.xOffset;
                                        cur.xAdvance -= d;
                                        cur.xOffset -= d;
                                        next.xAdvance = entry.x + next.xOffset;
                                        break;
                                }
                                if (this.glyphIterator.flags.rightToLeft) {
                                    this.glyphIterator.cur.cursiveAttachment = nextIndex;
                                    cur.yOffset = entry.y - exit.y;
                                } else {
                                    _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                                    cur.yOffset = exit.y - entry.y;
                                }
                                return true;
                            case 4:
                                // Mark to base positioning
                                var markIndex = this.coverageIndex(table.markCoverage);
                                if (markIndex === -1) return false;
                                 // search backward for a base glyph
                                var baseGlyphIndex = this.glyphIterator.index;
                                while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                                if (baseGlyphIndex < 0) return false;
                                var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                                if (baseIndex === -1) return false;
                                var markRecord = table.markArray[markIndex];
                                var baseAnchor = table.baseArray[baseIndex][markRecord.class];
                                this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                                return true;
                            case 5:
                                // Mark to ligature positioning
                                var _markIndex = this.coverageIndex(table.markCoverage);
                                if (_markIndex === -1) return false;
                                 // search backward for a base glyph
                                var _baseGlyphIndex = this.glyphIterator.index;
                                while(--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark);
                                if (_baseGlyphIndex < 0) return false;
                                var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
                                if (ligIndex === -1) return false;
                                var ligAttach = table.ligatureArray[ligIndex];
                                var markGlyph = this.glyphIterator.cur;
                                var ligGlyph = this.glyphs[_baseGlyphIndex];
                                var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                                var _markRecord = table.markArray[_markIndex];
                                var _baseAnchor = ligAttach[compIndex][_markRecord.class];
                                this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                                return true;
                            case 6:
                                // Mark to mark positioning
                                var mark1Index = this.coverageIndex(table.mark1Coverage);
                                if (mark1Index === -1) return false;
                                 // get the previous mark to attach to
                                var prevIndex = this.glyphIterator.peekIndex(-1);
                                var prev = this.glyphs[prevIndex];
                                if (!prev || !prev.isMark) return false;
                                var _cur = this.glyphIterator.cur; // The following logic was borrowed from Harfbuzz
                                var good = false;
                                if (_cur.ligatureID === prev.ligatureID) {
                                    if (!_cur.ligatureID) // Marks belonging to the same base
                                    good = true;
                                    else if (_cur.ligatureComponent === prev.ligatureComponent) // Marks belonging to the same ligature component
                                    good = true;
                                } else // If ligature ids don't match, it may be the case that one of the marks
                                // itself is a ligature, in which case match.
                                if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                                if (!good) return false;
                                var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                                if (mark2Index === -1) return false;
                                var _markRecord2 = table.mark1Array[mark1Index];
                                var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
                                this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                                return true;
                            case 7:
                                // Contextual positioning
                                return this.applyContext(table);
                            case 8:
                                // Chaining contextual positioning
                                return this.applyChainingContext(table);
                            case 9:
                                // Extension positioning
                                return this.applyLookup(table.lookupType, table.extension);
                            default:
                                throw new Error("Unsupported GPOS table: ".concat(lookupType));
                        }
                    };
                    _proto28.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
                        var baseCoords = this.getAnchor(baseAnchor);
                        var markCoords = this.getAnchor(markRecord.markAnchor);
                        var basePos = this.positions[baseGlyphIndex];
                        var markPos = this.positions[this.glyphIterator.index];
                        markPos.xOffset = baseCoords.x - markCoords.x;
                        markPos.yOffset = baseCoords.y - markCoords.y;
                        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
                    };
                    _proto28.getAnchor = function getAnchor(anchor) {
                        // TODO: contour point, device tables
                        var x = anchor.xCoordinate;
                        var y = anchor.yCoordinate; // Adjustments for font variations
                        var variationProcessor = this.font._variationProcessor;
                        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
                        if (variationProcessor && variationStore) {
                            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
                            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
                        }
                        return {
                            x: x,
                            y: y
                        };
                    };
                    _proto28.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
                        _OTProcessor2.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
                        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
                        this.fixMarkAttachment();
                    };
                    _proto28.fixCursiveAttachment = function fixCursiveAttachment(i) {
                        var glyph = this.glyphs[i];
                        if (glyph.cursiveAttachment != null) {
                            var j = glyph.cursiveAttachment;
                            glyph.cursiveAttachment = null;
                            this.fixCursiveAttachment(j);
                            this.positions[i].yOffset += this.positions[j].yOffset;
                        }
                    };
                    _proto28.fixMarkAttachment = function fixMarkAttachment() {
                        for(var i = 0; i < this.glyphs.length; i++){
                            var glyph = this.glyphs[i];
                            if (glyph.markAttachment != null) {
                                var j = glyph.markAttachment;
                                this.positions[i].xOffset += this.positions[j].xOffset;
                                this.positions[i].yOffset += this.positions[j].yOffset;
                                if (this.direction === "ltr") for(var k = j; k < i; k++){
                                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                                }
                                else for(var _k = j + 1; _k < i + 1; _k++){
                                    this.positions[i].xOffset += this.positions[_k].xAdvance;
                                    this.positions[i].yOffset += this.positions[_k].yAdvance;
                                }
                            }
                        }
                    };
                    return GPOSProcessor;
                }(OTProcessor);
                var OTLayoutEngine = /*#__PURE__*/ function() {
                    function OTLayoutEngine(font) {
                        this.font = font;
                        this.glyphInfos = null;
                        this.plan = null;
                        this.GSUBProcessor = null;
                        this.GPOSProcessor = null;
                        this.fallbackPosition = true;
                        if (font.GSUB) this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
                        if (font.GPOS) this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
                    }
                    var _proto29 = OTLayoutEngine.prototype;
                    _proto29.setup = function setup(glyphRun) {
                        var _this8 = this;
                        // Map glyphs to GlyphInfo objects so data can be passed between
                        // GSUB and GPOS without mutating the real (shared) Glyph objects.
                        this.glyphInfos = glyphRun.glyphs.map(function(glyph) {
                            return new GlyphInfo(_this8.font, glyph.id, [].concat(glyph.codePoints));
                        }); // Select a script based on what is available in GSUB/GPOS.
                        var script = null;
                        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
                        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
                         // Choose a shaper based on the script, and setup a shaping plan.
                        // This determines which features to apply to which glyphs.
                        this.shaper = choose(script);
                        this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
                        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features); // Assign chosen features to output glyph run
                        for(var key in this.plan.allFeatures)glyphRun.features[key] = true;
                    };
                    _proto29.substitute = function substitute(glyphRun) {
                        var _this9 = this;
                        if (this.GSUBProcessor) {
                            this.plan.process(this.GSUBProcessor, this.glyphInfos); // Map glyph infos back to normal Glyph objects
                            glyphRun.glyphs = this.glyphInfos.map(function(glyphInfo) {
                                return _this9.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
                            });
                        }
                    };
                    _proto29.position = function position(glyphRun) {
                        if (this.shaper.zeroMarkWidths === "BEFORE_GPOS") this.zeroMarkAdvances(glyphRun.positions);
                        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
                        if (this.shaper.zeroMarkWidths === "AFTER_GPOS") this.zeroMarkAdvances(glyphRun.positions);
                         // Reverse the glyphs and positions if the script is right-to-left
                        if (glyphRun.direction === "rtl") {
                            glyphRun.glyphs.reverse();
                            glyphRun.positions.reverse();
                        }
                        return this.GPOSProcessor && this.GPOSProcessor.features;
                    };
                    _proto29.zeroMarkAdvances = function zeroMarkAdvances(positions) {
                        for(var i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
                            positions[i].xAdvance = 0;
                            positions[i].yAdvance = 0;
                        }
                    };
                    _proto29.cleanup = function cleanup() {
                        this.glyphInfos = null;
                        this.plan = null;
                        this.shaper = null;
                    };
                    _proto29.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        var features = [];
                        if (this.GSUBProcessor) {
                            this.GSUBProcessor.selectScript(script, language);
                            features.push.apply(features, Object.keys(this.GSUBProcessor.features));
                        }
                        if (this.GPOSProcessor) {
                            this.GPOSProcessor.selectScript(script, language);
                            features.push.apply(features, Object.keys(this.GPOSProcessor.features));
                        }
                        return features;
                    };
                    return OTLayoutEngine;
                }();
                var LayoutEngine = /*#__PURE__*/ function() {
                    function LayoutEngine(font) {
                        this.font = font;
                        this.unicodeLayoutEngine = null;
                        this.kernProcessor = null; // Choose an advanced layout engine. We try the AAT morx table first since more
                        // scripts are currently supported because the shaping logic is built into the font.
                        if (this.font.morx) this.engine = new AATLayoutEngine(this.font);
                        else if (this.font.GSUB || this.font.GPOS) this.engine = new OTLayoutEngine(this.font);
                    }
                    var _proto30 = LayoutEngine.prototype;
                    _proto30.layout = function layout(string, features, script, language, direction) {
                        // Make the features parameter optional
                        if (typeof features === "string") {
                            direction = language;
                            language = script;
                            script = features;
                            features = [];
                        } // Map string to glyphs if needed
                        if (typeof string === "string") {
                            // Attempt to detect the script from the string if not provided.
                            if (script == null) script = forString(string);
                            var glyphs = this.font.glyphsForString(string);
                        } else {
                            // Attempt to detect the script from the glyph code points if not provided.
                            if (script == null) {
                                var codePoints = [];
                                for(var _iterator64 = _createForOfIteratorHelperLoose(string), _step64; !(_step64 = _iterator64()).done;){
                                    var glyph = _step64.value;
                                    codePoints.push.apply(codePoints, glyph.codePoints);
                                }
                                script = forCodePoints(codePoints);
                            }
                            var glyphs = string;
                        }
                        var glyphRun = new GlyphRun(glyphs, features, script, language, direction); // Return early if there are no glyphs
                        if (glyphs.length === 0) {
                            glyphRun.positions = [];
                            return glyphRun;
                        } // Setup the advanced layout engine
                        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
                         // Substitute and position the glyphs
                        this.substitute(glyphRun);
                        this.position(glyphRun);
                        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions); // Let the layout engine clean up any state it might have
                        if (this.engine && this.engine.cleanup) this.engine.cleanup();
                        return glyphRun;
                    };
                    _proto30.substitute = function substitute(glyphRun) {
                        // Call the advanced layout engine to make substitutions
                        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
                    };
                    _proto30.position = function position(glyphRun) {
                        // Get initial glyph positions
                        glyphRun.positions = glyphRun.glyphs.map(function(glyph) {
                            return new GlyphPosition(glyph.advanceWidth);
                        });
                        var positioned = null; // Call the advanced layout engine. Returns the features applied.
                        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
                         // if there is no GPOS table, use unicode properties to position marks.
                        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
                            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
                            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
                        } // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
                        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
                            if (!this.kernProcessor) this.kernProcessor = new KernProcessor(this.font);
                            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
                            glyphRun.features.kern = true;
                        }
                    };
                    _proto30.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
                        var space = this.font.glyphForCodePoint(0x20);
                        for(var i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
                            glyphs[i] = space;
                            positions[i].xAdvance = 0;
                            positions[i].yAdvance = 0;
                        }
                    };
                    _proto30.isDefaultIgnorable = function isDefaultIgnorable(ch) {
                        // From DerivedCoreProperties.txt in the Unicode database,
                        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
                        // Harfbuzz and Uniscribe do.
                        var plane = ch >> 16;
                        if (plane === 0) // BMP
                        switch(ch >> 8){
                            case 0x00:
                                return ch === 0x00AD;
                            case 0x03:
                                return ch === 0x034F;
                            case 0x06:
                                return ch === 0x061C;
                            case 0x17:
                                return 0x17B4 <= ch && ch <= 0x17B5;
                            case 0x18:
                                return 0x180B <= ch && ch <= 0x180E;
                            case 0x20:
                                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
                            case 0xFE:
                                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
                            case 0xFF:
                                return 0xFFF0 <= ch && ch <= 0xFFF8;
                            default:
                                return false;
                        }
                        else // Other planes
                        switch(plane){
                            case 0x01:
                                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
                            case 0x0E:
                                return 0xE0000 <= ch && ch <= 0xE0FFF;
                            default:
                                return false;
                        }
                    };
                    _proto30.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        var features = [];
                        if (this.engine) features.push.apply(features, this.engine.getAvailableFeatures(script, language));
                        if (this.font.kern && features.indexOf("kern") === -1) features.push("kern");
                        return features;
                    };
                    _proto30.stringsForGlyph = function stringsForGlyph(gid) {
                        var result = new Set();
                        var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
                        for(var _iterator65 = _createForOfIteratorHelperLoose(codePoints), _step65; !(_step65 = _iterator65()).done;){
                            var codePoint = _step65.value;
                            result.add(String.fromCodePoint(codePoint));
                        }
                        if (this.engine && this.engine.stringsForGlyph) for(var _iterator66 = _createForOfIteratorHelperLoose(this.engine.stringsForGlyph(gid)), _step66; !(_step66 = _iterator66()).done;){
                            var string = _step66.value;
                            result.add(string);
                        }
                        return Array.from(result);
                    };
                    return LayoutEngine;
                }();
                var SVG_COMMANDS = {
                    moveTo: "M",
                    lineTo: "L",
                    quadraticCurveTo: "Q",
                    bezierCurveTo: "C",
                    closePath: "Z"
                };
                /**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */ var Path = /*#__PURE__*/ function() {
                    function Path() {
                        this.commands = [];
                        this._bbox = null;
                        this._cbox = null;
                    }
                    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ var _proto31 = Path.prototype;
                    _proto31.toFunction = function toFunction() {
                        var _this10 = this;
                        return function(ctx) {
                            _this10.commands.forEach(function(c) {
                                return ctx[c.command].apply(ctx, c.args);
                            });
                        };
                    } /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ ;
                    _proto31.toSVG = function toSVG() {
                        var cmds = this.commands.map(function(c) {
                            var args = c.args.map(function(arg) {
                                return Math.round(arg * 100) / 100;
                            });
                            return "".concat(SVG_COMMANDS[c.command]).concat(args.join(" "));
                        });
                        return cmds.join("");
                    } /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ ;
                    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ _proto31.mapPoints = function mapPoints(fn) {
                        var path = new Path();
                        for(var _iterator67 = _createForOfIteratorHelperLoose(this.commands), _step67; !(_step67 = _iterator67()).done;){
                            var c = _step67.value;
                            var args = [];
                            for(var i = 0; i < c.args.length; i += 2){
                                var _fn = fn(c.args[i], c.args[i + 1]), x = _fn[0], y = _fn[1];
                                args.push(x, y);
                            }
                            path[c.command].apply(path, args);
                        }
                        return path;
                    } /**
   * Transforms the path by the given matrix.
   */ ;
                    _proto31.transform = function transform(m0, m1, m2, m3, m4, m5) {
                        return this.mapPoints(function(x, y) {
                            x = m0 * x + m2 * y + m4;
                            y = m1 * x + m3 * y + m5;
                            return [
                                x,
                                y
                            ];
                        });
                    } /**
   * Translates the path by the given offset.
   */ ;
                    _proto31.translate = function translate(x, y) {
                        return this.transform(1, 0, 0, 1, x, y);
                    } /**
   * Rotates the path by the given angle (in radians).
   */ ;
                    _proto31.rotate = function rotate(angle) {
                        var cos = Math.cos(angle);
                        var sin = Math.sin(angle);
                        return this.transform(cos, sin, -sin, cos, 0, 0);
                    } /**
   * Scales the path.
   */ ;
                    _proto31.scale = function scale(scaleX, scaleY) {
                        if (scaleY === void 0) scaleY = scaleX;
                        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
                    };
                    _createClass(Path, [
                        {
                            key: "cbox",
                            get: function get() {
                                if (!this._cbox) {
                                    var cbox = new BBox();
                                    for(var _iterator68 = _createForOfIteratorHelperLoose(this.commands), _step68; !(_step68 = _iterator68()).done;){
                                        var command = _step68.value;
                                        for(var i = 0; i < command.args.length; i += 2)cbox.addPoint(command.args[i], command.args[i + 1]);
                                    }
                                    this._cbox = Object.freeze(cbox);
                                }
                                return this._cbox;
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                if (this._bbox) return this._bbox;
                                var bbox = new BBox();
                                var cx = 0, cy = 0;
                                var f = function f(t) {
                                    return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
                                };
                                for(var _iterator69 = _createForOfIteratorHelperLoose(this.commands), _step69; !(_step69 = _iterator69()).done;){
                                    var c = _step69.value;
                                    switch(c.command){
                                        case "moveTo":
                                        case "lineTo":
                                            var _c$args = c.args, x = _c$args[0], y = _c$args[1];
                                            bbox.addPoint(x, y);
                                            cx = x;
                                            cy = y;
                                            break;
                                        case "quadraticCurveTo":
                                        case "bezierCurveTo":
                                            if (c.command === "quadraticCurveTo") {
                                                // http://fontforge.org/bezier.html
                                                var _c$args2 = c.args, qp1x = _c$args2[0], qp1y = _c$args2[1], p3x = _c$args2[2], p3y = _c$args2[3];
                                                var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                                                var cp1y = cy + 2 / 3 * (qp1y - cy);
                                                var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                                                var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                                            } else var _c$args3 = c.args, cp1x = _c$args3[0], cp1y = _c$args3[1], cp2x = _c$args3[2], cp2y = _c$args3[3], p3x = _c$args3[4], p3y = _c$args3[5];
                                             // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                                            bbox.addPoint(p3x, p3y);
                                            var p0 = [
                                                cx,
                                                cy
                                            ];
                                            var p1 = [
                                                cp1x,
                                                cp1y
                                            ];
                                            var p2 = [
                                                cp2x,
                                                cp2y
                                            ];
                                            var p3 = [
                                                p3x,
                                                p3y
                                            ];
                                            for(var i = 0; i <= 1; i++){
                                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                                var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                                c = 3 * p1[i] - 3 * p0[i];
                                                if (a === 0) {
                                                    if (b === 0) continue;
                                                    var t = -c / b;
                                                    if (0 < t && t < 1) {
                                                        if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                                                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                                                    }
                                                    continue;
                                                }
                                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                                if (b2ac < 0) continue;
                                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                                if (0 < t1 && t1 < 1) {
                                                    if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                                                }
                                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                                if (0 < t2 && t2 < 1) {
                                                    if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                                                }
                                            }
                                            cx = p3x;
                                            cy = p3y;
                                            break;
                                    }
                                }
                                return this._bbox = Object.freeze(bbox);
                            }
                        }
                    ]);
                    return Path;
                }();
                var _loop = function _loop(command) {
                    Path.prototype[command] = function() {
                        this._bbox = this._cbox = null;
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        this.commands.push({
                            command: command,
                            args: args
                        });
                        return this;
                    };
                };
                for(var _i23 = 0, _arr = [
                    "moveTo",
                    "lineTo",
                    "quadraticCurveTo",
                    "bezierCurveTo",
                    "closePath"
                ]; _i23 < _arr.length; _i23++){
                    var command = _arr[_i23];
                    _loop(command);
                }
                var StandardNames = [
                    ".notdef",
                    ".null",
                    "nonmarkingreturn",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "nonbreakingspace",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "Lslash",
                    "lslash",
                    "Scaron",
                    "scaron",
                    "Zcaron",
                    "zcaron",
                    "brokenbar",
                    "Eth",
                    "eth",
                    "Yacute",
                    "yacute",
                    "Thorn",
                    "thorn",
                    "minus",
                    "multiply",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "onehalf",
                    "onequarter",
                    "threequarters",
                    "franc",
                    "Gbreve",
                    "gbreve",
                    "Idotaccent",
                    "Scedilla",
                    "scedilla",
                    "Cacute",
                    "cacute",
                    "Ccaron",
                    "ccaron",
                    "dcroat"
                ];
                var _class$3;
                /**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */ var Glyph = (_class$3 = /*#__PURE__*/ function() {
                    function Glyph(id, codePoints, font) {
                        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
                        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
                        this._font = font; // TODO: get this info from GDEF if available
                        this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
                        this.isLigature = this.codePoints.length > 1;
                    }
                    var _proto32 = Glyph.prototype;
                    _proto32._getPath = function _getPath() {
                        return new Path();
                    };
                    _proto32._getCBox = function _getCBox() {
                        return this.path.cbox;
                    };
                    _proto32._getBBox = function _getBBox() {
                        return this.path.bbox;
                    };
                    _proto32._getTableMetrics = function _getTableMetrics(table) {
                        if (this.id < table.metrics.length) return table.metrics.get(this.id);
                        var metric = table.metrics.get(table.metrics.length - 1);
                        var res = {
                            advance: metric ? metric.advance : 0,
                            bearing: table.bearings.get(this.id - table.metrics.length) || 0
                        };
                        return res;
                    };
                    _proto32._getMetrics = function _getMetrics(cbox) {
                        if (this._metrics) return this._metrics;
                        var _this$_getTableMetric = this._getTableMetrics(this._font.hmtx), advanceWidth = _this$_getTableMetric.advance, leftBearing = _this$_getTableMetric.bearing; // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
                        if (this._font.vmtx) var _this$_getTableMetric2 = this._getTableMetrics(this._font.vmtx), advanceHeight = _this$_getTableMetric2.advance, topBearing = _this$_getTableMetric2.bearing;
                        else {
                            var os2;
                            if (typeof cbox === "undefined" || cbox === null) cbox = this.cbox;
                            if ((os2 = this._font["OS/2"]) && os2.version > 0) {
                                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                                var topBearing = os2.typoAscender - cbox.maxY;
                            } else {
                                var hhea = this._font.hhea;
                                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                                var topBearing = hhea.ascent - cbox.maxY;
                            }
                        }
                        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
                        return this._metrics = {
                            advanceWidth: advanceWidth,
                            advanceHeight: advanceHeight,
                            leftBearing: leftBearing,
                            topBearing: topBearing
                        };
                    } /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ ;
                    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ _proto32.getScaledPath = function getScaledPath(size) {
                        var scale = 1 / this._font.unitsPerEm * size;
                        return this.path.scale(scale);
                    } /**
   * The glyph's advance width.
   * @type {number}
   */ ;
                    _proto32._getName = function _getName() {
                        var post = this._font.post;
                        if (!post) return null;
                        switch(post.version){
                            case 1:
                                return StandardNames[this.id];
                            case 2:
                                var id = post.glyphNameIndex[this.id];
                                if (id < StandardNames.length) return StandardNames[id];
                                return post.names[id - StandardNames.length];
                            case 2.5:
                                return StandardNames[this.id + post.offsets[this.id]];
                            case 4:
                                return String.fromCharCode(post.map[this.id]);
                        }
                    } /**
   * The glyph's name
   * @type {string}
   */ ;
                    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ _proto32.render = function render(ctx, size) {
                        ctx.save();
                        var scale = 1 / this._font.head.unitsPerEm * size;
                        ctx.scale(scale, scale);
                        var fn = this.path.toFunction();
                        fn(ctx);
                        ctx.fill();
                        ctx.restore();
                    };
                    _createClass(Glyph, [
                        {
                            key: "cbox",
                            get: function get() {
                                return this._getCBox();
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                return this._getBBox();
                            }
                        },
                        {
                            key: "path",
                            get: function get() {
                                // Cache the path so we only decode it once
                                // Decoding is actually performed by subclasses
                                return this._getPath();
                            }
                        },
                        {
                            key: "advanceWidth",
                            get: function get() {
                                return this._getMetrics().advanceWidth;
                            }
                        },
                        {
                            key: "advanceHeight",
                            get: function get() {
                                return this._getMetrics().advanceHeight;
                            }
                        },
                        {
                            key: "ligatureCaretPositions",
                            get: function get() {}
                        },
                        {
                            key: "name",
                            get: function get() {
                                return this._getName();
                            }
                        }
                    ]);
                    return Glyph;
                }(), _applyDecoratedDescriptor(_class$3.prototype, "cbox", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "cbox"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "bbox", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "bbox"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "path", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "path"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "advanceWidth", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "advanceWidth"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "advanceHeight", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "advanceHeight"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "name", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "name"), _class$3.prototype), _class$3);
                var GlyfHeader = new r.Struct({
                    numberOfContours: r.int16,
                    // if negative, this is a composite glyph
                    xMin: r.int16,
                    yMin: r.int16,
                    xMax: r.int16,
                    yMax: r.int16
                }); // Flags for simple glyphs
                var ON_CURVE = 1;
                var X_SHORT_VECTOR = 2;
                var Y_SHORT_VECTOR = 4;
                var REPEAT = 8;
                var SAME_X = 16;
                var SAME_Y = 32; // Flags for composite glyphs
                var ARG_1_AND_2_ARE_WORDS = 1;
                var WE_HAVE_A_SCALE = 8;
                var MORE_COMPONENTS = 32;
                var WE_HAVE_AN_X_AND_Y_SCALE = 64;
                var WE_HAVE_A_TWO_BY_TWO = 128;
                var WE_HAVE_INSTRUCTIONS = 256;
                var Point = /*#__PURE__*/ function() {
                    function Point(onCurve, endContour, x, y) {
                        if (x === void 0) x = 0;
                        if (y === void 0) y = 0;
                        this.onCurve = onCurve;
                        this.endContour = endContour;
                        this.x = x;
                        this.y = y;
                    }
                    var _proto33 = Point.prototype;
                    _proto33.copy = function copy() {
                        return new Point(this.onCurve, this.endContour, this.x, this.y);
                    };
                    return Point;
                }(); // Represents a component in a composite glyph
                var Component = function Component(glyphID, dx, dy) {
                    this.glyphID = glyphID;
                    this.dx = dx;
                    this.dy = dy;
                    this.pos = 0;
                    this.scaleX = this.scaleY = 1;
                    this.scale01 = this.scale10 = 0;
                };
                /**
 * Represents a TrueType glyph.
 */ var TTFGlyph = /*#__PURE__*/ function(_Glyph) {
                    _inheritsLoose(TTFGlyph, _Glyph);
                    function TTFGlyph() {
                        return _Glyph.apply(this, arguments) || this;
                    }
                    var _proto34 = TTFGlyph.prototype;
                    // Parses just the glyph header and returns the bounding box
                    _proto34._getCBox = function _getCBox(internal) {
                        // We need to decode the glyph if variation processing is requested,
                        // so it's easier just to recompute the path's cbox after decoding.
                        if (this._font._variationProcessor && !internal) return this.path.cbox;
                        var stream = this._font._getTableStream("glyf");
                        stream.pos += this._font.loca.offsets[this.id];
                        var glyph = GlyfHeader.decode(stream);
                        var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
                        return Object.freeze(cbox);
                    } // Parses a single glyph coordinate
                    ;
                    _proto34._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
                        if (short) {
                            var val = stream.readUInt8();
                            if (!same) val = -val;
                            val += prev;
                        } else if (same) var val = prev;
                        else var val = prev + stream.readInt16BE();
                        return val;
                    } // Decodes the glyph data into points for simple glyphs,
                    ;
                    _proto34._decode = function _decode() {
                        var glyfPos = this._font.loca.offsets[this.id];
                        var nextPos = this._font.loca.offsets[this.id + 1]; // Nothing to do if there is no data for this glyph
                        if (glyfPos === nextPos) return null;
                        var stream = this._font._getTableStream("glyf");
                        stream.pos += glyfPos;
                        var startPos = stream.pos;
                        var glyph = GlyfHeader.decode(stream);
                        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
                        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
                        return glyph;
                    };
                    _proto34._decodeSimple = function _decodeSimple(glyph, stream) {
                        // this is a simple glyph
                        glyph.points = [];
                        var endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
                        glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);
                        var flags = [];
                        var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
                        while(flags.length < numCoords){
                            var flag = stream.readUInt8();
                            flags.push(flag); // check for repeat flag
                            if (flag & REPEAT) {
                                var count = stream.readUInt8();
                                for(var j = 0; j < count; j++)flags.push(flag);
                            }
                        }
                        for(var i = 0; i < flags.length; i++){
                            var flag = flags[i];
                            var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
                            glyph.points.push(point);
                        }
                        var px = 0;
                        for(var i = 0; i < flags.length; i++){
                            var flag = flags[i];
                            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
                        }
                        var py = 0;
                        for(var i = 0; i < flags.length; i++){
                            var flag = flags[i];
                            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
                        }
                        if (this._font._variationProcessor) {
                            var points = glyph.points.slice();
                            points.push.apply(points, this._getPhantomPoints(glyph));
                            this._font._variationProcessor.transformPoints(this.id, points);
                            glyph.phantomPoints = points.slice(-4);
                        }
                        return;
                    };
                    _proto34._decodeComposite = function _decodeComposite(glyph, stream, offset) {
                        if (offset === void 0) offset = 0;
                        // this is a composite glyph
                        glyph.components = [];
                        var haveInstructions = false;
                        var flags = MORE_COMPONENTS;
                        while(flags & MORE_COMPONENTS){
                            flags = stream.readUInt16BE();
                            var gPos = stream.pos - offset;
                            var glyphID = stream.readUInt16BE();
                            if (!haveInstructions) haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
                            if (flags & ARG_1_AND_2_ARE_WORDS) {
                                var dx = stream.readInt16BE();
                                var dy = stream.readInt16BE();
                            } else {
                                var dx = stream.readInt8();
                                var dy = stream.readInt8();
                            }
                            var component = new Component(glyphID, dx, dy);
                            component.pos = gPos;
                            if (flags & WE_HAVE_A_SCALE) // fixed number with 14 bits of fraction
                            component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                            else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                            } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                            }
                            glyph.components.push(component);
                        }
                        if (this._font._variationProcessor) {
                            var points = [];
                            for(var j = 0; j < glyph.components.length; j++){
                                var component = glyph.components[j];
                                points.push(new Point(true, true, component.dx, component.dy));
                            }
                            points.push.apply(points, this._getPhantomPoints(glyph));
                            this._font._variationProcessor.transformPoints(this.id, points);
                            glyph.phantomPoints = points.splice(-4, 4);
                            for(var i = 0; i < points.length; i++){
                                var point = points[i];
                                glyph.components[i].dx = point.x;
                                glyph.components[i].dy = point.y;
                            }
                        }
                        return haveInstructions;
                    };
                    _proto34._getPhantomPoints = function _getPhantomPoints(glyph) {
                        var cbox = this._getCBox(true);
                        if (this._metrics == null) this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
                        var _this$_metrics = this._metrics, advanceWidth = _this$_metrics.advanceWidth, advanceHeight = _this$_metrics.advanceHeight, leftBearing = _this$_metrics.leftBearing, topBearing = _this$_metrics.topBearing;
                        return [
                            new Point(false, true, glyph.xMin - leftBearing, 0),
                            new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
                            new Point(false, true, 0, glyph.yMax + topBearing),
                            new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)
                        ];
                    } // Decodes font data, resolves composite glyphs, and returns an array of contours
                    ;
                    _proto34._getContours = function _getContours() {
                        var glyph = this._decode();
                        if (!glyph) return [];
                        var points = [];
                        if (glyph.numberOfContours < 0) // resolve composite glyphs
                        for(var _iterator70 = _createForOfIteratorHelperLoose(glyph.components), _step70; !(_step70 = _iterator70()).done;){
                            var component = _step70.value;
                            var _contours = this._font.getGlyph(component.glyphID)._getContours();
                            for(var i = 0; i < _contours.length; i++){
                                var contour = _contours[i];
                                for(var j = 0; j < contour.length; j++){
                                    var _point = contour[j];
                                    var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                                    var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                                    points.push(new Point(_point.onCurve, _point.endContour, x, y));
                                }
                            }
                        }
                        else points = glyph.points || [];
                         // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
                        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
                            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
                            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
                            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
                            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
                        }
                        var contours = [];
                        var cur = [];
                        for(var k = 0; k < points.length; k++){
                            var point = points[k];
                            cur.push(point);
                            if (point.endContour) {
                                contours.push(cur);
                                cur = [];
                            }
                        }
                        return contours;
                    };
                    _proto34._getMetrics = function _getMetrics() {
                        if (this._metrics) return this._metrics;
                        var cbox = this._getCBox(true);
                        _Glyph.prototype._getMetrics.call(this, cbox);
                        if (this._font._variationProcessor && !this._font.HVAR) // No HVAR table, decode the glyph. This triggers recomputation of metrics.
                        this.path;
                        return this._metrics;
                    } // Converts contours to a Path object that can be rendered
                    ;
                    _proto34._getPath = function _getPath() {
                        var contours = this._getContours();
                        var path = new Path();
                        for(var i = 0; i < contours.length; i++){
                            var contour = contours[i];
                            var firstPt = contour[0];
                            var lastPt = contour[contour.length - 1];
                            var start = 0;
                            if (firstPt.onCurve) {
                                // The first point will be consumed by the moveTo command, so skip in the loop
                                var curvePt = null;
                                start = 1;
                            } else {
                                if (lastPt.onCurve) // Start at the last point if the first point is off curve and the last point is on curve
                                firstPt = lastPt;
                                else // Start at the middle if both the first and last points are off curve
                                firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                                var curvePt = firstPt;
                            }
                            path.moveTo(firstPt.x, firstPt.y);
                            for(var j = start; j < contour.length; j++){
                                var pt = contour[j];
                                var prevPt = j === 0 ? firstPt : contour[j - 1];
                                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                                else if (!prevPt.onCurve && !pt.onCurve) {
                                    var midX = (prevPt.x + pt.x) / 2;
                                    var midY = (prevPt.y + pt.y) / 2;
                                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                                    var curvePt = pt;
                                } else if (!prevPt.onCurve && pt.onCurve) {
                                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                                    var curvePt = null;
                                } else throw new Error("Unknown TTF path state");
                            } // Connect the first and last points
                            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
                            path.closePath();
                        }
                        return path;
                    };
                    return TTFGlyph;
                }(Glyph);
                /**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */ var CFFGlyph = /*#__PURE__*/ function(_Glyph2) {
                    _inheritsLoose(CFFGlyph, _Glyph2);
                    function CFFGlyph() {
                        return _Glyph2.apply(this, arguments) || this;
                    }
                    var _proto35 = CFFGlyph.prototype;
                    _proto35._getName = function _getName() {
                        if (this._font.CFF2) return _Glyph2.prototype._getName.call(this);
                        return this._font["CFF "].getGlyphName(this.id);
                    };
                    _proto35.bias = function bias(s) {
                        if (s.length < 1240) return 107;
                        else if (s.length < 33900) return 1131;
                        else return 32768;
                    };
                    _proto35._getPath = function _getPath() {
                        var cff = this._font.CFF2 || this._font["CFF "];
                        var stream = cff.stream;
                        var str = cff.topDict.CharStrings[this.id];
                        var end = str.offset + str.length;
                        stream.pos = str.offset;
                        var path = new Path();
                        var stack = [];
                        var trans = [];
                        var width = null;
                        var nStems = 0;
                        var x = 0, y = 0;
                        var usedGsubrs;
                        var usedSubrs;
                        var open1 = false;
                        this._usedGsubrs = usedGsubrs = {};
                        this._usedSubrs = usedSubrs = {};
                        var gsubrs = cff.globalSubrIndex || [];
                        var gsubrsBias = this.bias(gsubrs);
                        var privateDict = cff.privateDictForGlyph(this.id) || {};
                        var subrs = privateDict.Subrs || [];
                        var subrsBias = this.bias(subrs);
                        var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
                        var vsindex = privateDict.vsindex;
                        var variationProcessor = this._font._variationProcessor;
                        function checkWidth() {
                            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
                        }
                        function parseStems() {
                            if (stack.length % 2 !== 0) checkWidth();
                            nStems += stack.length >> 1;
                            return stack.length = 0;
                        }
                        function moveTo(x, y) {
                            if (open1) path.closePath();
                            path.moveTo(x, y);
                            open1 = true;
                        }
                        var parse = function parse() {
                            while(stream.pos < end){
                                var op = stream.readUInt8();
                                if (op < 32) switch(op){
                                    case 1:
                                    case 3:
                                    case 18:
                                    case 23:
                                        // vstemhm
                                        parseStems();
                                        break;
                                    case 4:
                                        // vmoveto
                                        if (stack.length > 1) checkWidth();
                                        y += stack.shift();
                                        moveTo(x, y);
                                        break;
                                    case 5:
                                        // rlineto
                                        while(stack.length >= 2){
                                            x += stack.shift();
                                            y += stack.shift();
                                            path.lineTo(x, y);
                                        }
                                        break;
                                    case 6:
                                    case 7:
                                        // vlineto
                                        var phase = op === 6;
                                        while(stack.length >= 1){
                                            if (phase) x += stack.shift();
                                            else y += stack.shift();
                                            path.lineTo(x, y);
                                            phase = !phase;
                                        }
                                        break;
                                    case 8:
                                        // rrcurveto
                                        while(stack.length > 0){
                                            var c1x = x + stack.shift();
                                            var c1y = y + stack.shift();
                                            var c2x = c1x + stack.shift();
                                            var c2y = c1y + stack.shift();
                                            x = c2x + stack.shift();
                                            y = c2y + stack.shift();
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        break;
                                    case 10:
                                        // callsubr
                                        var index = stack.pop() + subrsBias;
                                        var subr = subrs[index];
                                        if (subr) {
                                            usedSubrs[index] = true;
                                            var p = stream.pos;
                                            var e = end;
                                            stream.pos = subr.offset;
                                            end = subr.offset + subr.length;
                                            parse();
                                            stream.pos = p;
                                            end = e;
                                        }
                                        break;
                                    case 11:
                                        // return
                                        if (cff.version >= 2) break;
                                        return;
                                    case 14:
                                        // endchar
                                        if (cff.version >= 2) break;
                                        if (stack.length > 0) checkWidth();
                                        if (open1) {
                                            path.closePath();
                                            open1 = false;
                                        }
                                        break;
                                    case 15:
                                        // vsindex
                                        if (cff.version < 2) throw new Error("vsindex operator not supported in CFF v1");
                                        vsindex = stack.pop();
                                        break;
                                    case 16:
                                        // blend
                                        if (cff.version < 2) throw new Error("blend operator not supported in CFF v1");
                                        if (!variationProcessor) throw new Error("blend operator in non-variation font");
                                        var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                        var numBlends = stack.pop();
                                        var numOperands = numBlends * blendVector.length;
                                        var delta = stack.length - numOperands;
                                        var base = delta - numBlends;
                                        for(var i = 0; i < numBlends; i++){
                                            var sum = stack[base + i];
                                            for(var j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                                            stack[base + i] = sum;
                                        }
                                        while(numOperands--)stack.pop();
                                        break;
                                    case 19:
                                    case 20:
                                        // cntrmask
                                        parseStems();
                                        stream.pos += nStems + 7 >> 3;
                                        break;
                                    case 21:
                                        // rmoveto
                                        if (stack.length > 2) checkWidth();
                                        x += stack.shift();
                                        y += stack.shift();
                                        moveTo(x, y);
                                        break;
                                    case 22:
                                        // hmoveto
                                        if (stack.length > 1) checkWidth();
                                        x += stack.shift();
                                        moveTo(x, y);
                                        break;
                                    case 24:
                                        // rcurveline
                                        while(stack.length >= 8){
                                            var c1x = x + stack.shift();
                                            var c1y = y + stack.shift();
                                            var c2x = c1x + stack.shift();
                                            var c2y = c1y + stack.shift();
                                            x = c2x + stack.shift();
                                            y = c2y + stack.shift();
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        x += stack.shift();
                                        y += stack.shift();
                                        path.lineTo(x, y);
                                        break;
                                    case 25:
                                        // rlinecurve
                                        while(stack.length >= 8){
                                            x += stack.shift();
                                            y += stack.shift();
                                            path.lineTo(x, y);
                                        }
                                        var c1x = x + stack.shift();
                                        var c1y = y + stack.shift();
                                        var c2x = c1x + stack.shift();
                                        var c2y = c1y + stack.shift();
                                        x = c2x + stack.shift();
                                        y = c2y + stack.shift();
                                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        break;
                                    case 26:
                                        // vvcurveto
                                        if (stack.length % 2) x += stack.shift();
                                        while(stack.length >= 4){
                                            c1x = x;
                                            c1y = y + stack.shift();
                                            c2x = c1x + stack.shift();
                                            c2y = c1y + stack.shift();
                                            x = c2x;
                                            y = c2y + stack.shift();
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        break;
                                    case 27:
                                        // hhcurveto
                                        if (stack.length % 2) y += stack.shift();
                                        while(stack.length >= 4){
                                            c1x = x + stack.shift();
                                            c1y = y;
                                            c2x = c1x + stack.shift();
                                            c2y = c1y + stack.shift();
                                            x = c2x + stack.shift();
                                            y = c2y;
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        break;
                                    case 28:
                                        // shortint
                                        stack.push(stream.readInt16BE());
                                        break;
                                    case 29:
                                        // callgsubr
                                        index = stack.pop() + gsubrsBias;
                                        subr = gsubrs[index];
                                        if (subr) {
                                            usedGsubrs[index] = true;
                                            var p = stream.pos;
                                            var e = end;
                                            stream.pos = subr.offset;
                                            end = subr.offset + subr.length;
                                            parse();
                                            stream.pos = p;
                                            end = e;
                                        }
                                        break;
                                    case 30:
                                    case 31:
                                        // hvcurveto
                                        phase = op === 31;
                                        while(stack.length >= 4){
                                            if (phase) {
                                                c1x = x + stack.shift();
                                                c1y = y;
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                y = c2y + stack.shift();
                                                x = c2x + (stack.length === 1 ? stack.shift() : 0);
                                            } else {
                                                c1x = x;
                                                c1y = y + stack.shift();
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                x = c2x + stack.shift();
                                                y = c2y + (stack.length === 1 ? stack.shift() : 0);
                                            }
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                            phase = !phase;
                                        }
                                        break;
                                    case 12:
                                        op = stream.readUInt8();
                                        switch(op){
                                            case 3:
                                                // and
                                                var a = stack.pop();
                                                var b = stack.pop();
                                                stack.push(a && b ? 1 : 0);
                                                break;
                                            case 4:
                                                // or
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a || b ? 1 : 0);
                                                break;
                                            case 5:
                                                // not
                                                a = stack.pop();
                                                stack.push(a ? 0 : 1);
                                                break;
                                            case 9:
                                                // abs
                                                a = stack.pop();
                                                stack.push(Math.abs(a));
                                                break;
                                            case 10:
                                                // add
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a + b);
                                                break;
                                            case 11:
                                                // sub
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a - b);
                                                break;
                                            case 12:
                                                // div
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a / b);
                                                break;
                                            case 14:
                                                // neg
                                                a = stack.pop();
                                                stack.push(-a);
                                                break;
                                            case 15:
                                                // eq
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a === b ? 1 : 0);
                                                break;
                                            case 18:
                                                // drop
                                                stack.pop();
                                                break;
                                            case 20:
                                                // put
                                                var val = stack.pop();
                                                var idx = stack.pop();
                                                trans[idx] = val;
                                                break;
                                            case 21:
                                                // get
                                                idx = stack.pop();
                                                stack.push(trans[idx] || 0);
                                                break;
                                            case 22:
                                                // ifelse
                                                var s1 = stack.pop();
                                                var s2 = stack.pop();
                                                var v1 = stack.pop();
                                                var v2 = stack.pop();
                                                stack.push(v1 <= v2 ? s1 : s2);
                                                break;
                                            case 23:
                                                // random
                                                stack.push(Math.random());
                                                break;
                                            case 24:
                                                // mul
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a * b);
                                                break;
                                            case 26:
                                                // sqrt
                                                a = stack.pop();
                                                stack.push(Math.sqrt(a));
                                                break;
                                            case 27:
                                                // dup
                                                a = stack.pop();
                                                stack.push(a, a);
                                                break;
                                            case 28:
                                                // exch
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(b, a);
                                                break;
                                            case 29:
                                                // index
                                                idx = stack.pop();
                                                if (idx < 0) idx = 0;
                                                else if (idx > stack.length - 1) idx = stack.length - 1;
                                                stack.push(stack[idx]);
                                                break;
                                            case 30:
                                                // roll
                                                var n = stack.pop();
                                                var _j = stack.pop();
                                                if (_j >= 0) while(_j > 0){
                                                    var t = stack[n - 1];
                                                    for(var _i = n - 2; _i >= 0; _i--)stack[_i + 1] = stack[_i];
                                                    stack[0] = t;
                                                    _j--;
                                                }
                                                else while(_j < 0){
                                                    var t = stack[0];
                                                    for(var _i2 = 0; _i2 <= n; _i2++)stack[_i2] = stack[_i2 + 1];
                                                    stack[n - 1] = t;
                                                    _j++;
                                                }
                                                break;
                                            case 34:
                                                // hflex
                                                c1x = x + stack.shift();
                                                c1y = y;
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                var c3x = c2x + stack.shift();
                                                var c3y = c2y;
                                                var c4x = c3x + stack.shift();
                                                var c4y = c3y;
                                                var c5x = c4x + stack.shift();
                                                var c5y = c4y;
                                                var c6x = c5x + stack.shift();
                                                var c6y = c5y;
                                                x = c6x;
                                                y = c6y;
                                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                                break;
                                            case 35:
                                                // flex
                                                var pts = [];
                                                for(var _i3 = 0; _i3 <= 5; _i3++){
                                                    x += stack.shift();
                                                    y += stack.shift();
                                                    pts.push(x, y);
                                                }
                                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                                path.bezierCurveTo.apply(path, pts.slice(6));
                                                stack.shift(); // fd
                                                break;
                                            case 36:
                                                // hflex1
                                                c1x = x + stack.shift();
                                                c1y = y + stack.shift();
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                c3x = c2x + stack.shift();
                                                c3y = c2y;
                                                c4x = c3x + stack.shift();
                                                c4y = c3y;
                                                c5x = c4x + stack.shift();
                                                c5y = c4y + stack.shift();
                                                c6x = c5x + stack.shift();
                                                c6y = c5y;
                                                x = c6x;
                                                y = c6y;
                                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                                break;
                                            case 37:
                                                // flex1
                                                var startx = x;
                                                var starty = y;
                                                pts = [];
                                                for(var _i4 = 0; _i4 <= 4; _i4++){
                                                    x += stack.shift();
                                                    y += stack.shift();
                                                    pts.push(x, y);
                                                }
                                                if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                                    // horizontal
                                                    x += stack.shift();
                                                    y = starty;
                                                } else {
                                                    x = startx;
                                                    y += stack.shift();
                                                }
                                                pts.push(x, y);
                                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                                path.bezierCurveTo.apply(path, pts.slice(6));
                                                break;
                                            default:
                                                throw new Error("Unknown op: 12 ".concat(op));
                                        }
                                        break;
                                    default:
                                        throw new Error("Unknown op: ".concat(op));
                                }
                                else if (op < 247) stack.push(op - 139);
                                else if (op < 251) {
                                    var b1 = stream.readUInt8();
                                    stack.push((op - 247) * 256 + b1 + 108);
                                } else if (op < 255) {
                                    var b1 = stream.readUInt8();
                                    stack.push(-(op - 251) * 256 - b1 - 108);
                                } else stack.push(stream.readInt32BE() / 65536);
                            }
                        };
                        parse();
                        if (open1) path.closePath();
                        return path;
                    };
                    return CFFGlyph;
                }(Glyph);
                var SBIXImage = new r.Struct({
                    originX: r.uint16,
                    originY: r.uint16,
                    type: new r.String(4),
                    data: new r.Buffer(function(t) {
                        return t.parent.buflen - t._currentOffset;
                    })
                });
                /**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */ var SBIXGlyph = /*#__PURE__*/ function(_TTFGlyph) {
                    _inheritsLoose(SBIXGlyph, _TTFGlyph);
                    function SBIXGlyph() {
                        return _TTFGlyph.apply(this, arguments) || this;
                    }
                    var _proto36 = SBIXGlyph.prototype;
                    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ _proto36.getImageForSize = function getImageForSize(size) {
                        for(var i = 0; i < this._font.sbix.imageTables.length; i++){
                            var table = this._font.sbix.imageTables[i];
                            if (table.ppem >= size) break;
                        }
                        var offsets = table.imageOffsets;
                        var start = offsets[this.id];
                        var end = offsets[this.id + 1];
                        if (start === end) return null;
                        this._font.stream.pos = start;
                        return SBIXImage.decode(this._font.stream, {
                            buflen: end - start
                        });
                    };
                    _proto36.render = function render(ctx, size) {
                        var img = this.getImageForSize(size);
                        if (img != null) {
                            var scale = size / this._font.unitsPerEm;
                            ctx.image(img.data, {
                                height: size,
                                x: img.originX,
                                y: (this.bbox.minY - img.originY) * scale
                            });
                        }
                        if (this._font.sbix.flags.renderOutlines) _TTFGlyph.prototype.render.call(this, ctx, size);
                    };
                    return SBIXGlyph;
                }(TTFGlyph);
                var COLRLayer = function COLRLayer(glyph, color) {
                    this.glyph = glyph;
                    this.color = color;
                };
                /**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */ var COLRGlyph = /*#__PURE__*/ function(_Glyph3) {
                    _inheritsLoose(COLRGlyph, _Glyph3);
                    function COLRGlyph() {
                        return _Glyph3.apply(this, arguments) || this;
                    }
                    var _proto37 = COLRGlyph.prototype;
                    _proto37._getBBox = function _getBBox() {
                        var bbox = new BBox();
                        for(var i = 0; i < this.layers.length; i++){
                            var layer = this.layers[i];
                            var b = layer.glyph.bbox;
                            bbox.addPoint(b.minX, b.minY);
                            bbox.addPoint(b.maxX, b.maxY);
                        }
                        return bbox;
                    } /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ ;
                    _proto37.render = function render(ctx, size) {
                        for(var _iterator71 = _createForOfIteratorHelperLoose(this.layers), _step71; !(_step71 = _iterator71()).done;){
                            var _step71$value = _step71.value, glyph = _step71$value.glyph, color = _step71$value.color;
                            ctx.fillColor([
                                color.red,
                                color.green,
                                color.blue
                            ], color.alpha / 255 * 100);
                            glyph.render(ctx, size);
                        }
                        return;
                    };
                    _createClass(COLRGlyph, [
                        {
                            key: "layers",
                            get: function get() {
                                var cpal = this._font.CPAL;
                                var colr = this._font.COLR;
                                var low = 0;
                                var high = colr.baseGlyphRecord.length - 1;
                                while(low <= high){
                                    var mid = low + high >> 1;
                                    var rec = colr.baseGlyphRecord[mid];
                                    if (this.id < rec.gid) high = mid - 1;
                                    else if (this.id > rec.gid) low = mid + 1;
                                    else {
                                        var baseLayer = rec;
                                        break;
                                    }
                                } // if base glyph not found in COLR table,
                                // default to normal glyph from glyf or CFF
                                if (baseLayer == null) {
                                    var g = this._font._getBaseGlyph(this.id);
                                    var color = {
                                        red: 0,
                                        green: 0,
                                        blue: 0,
                                        alpha: 255
                                    };
                                    return [
                                        new COLRLayer(g, color)
                                    ];
                                } // otherwise, return an array of all the layers
                                var layers = [];
                                for(var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
                                    var rec = colr.layerRecords[i];
                                    var color = cpal.colorRecords[rec.paletteIndex];
                                    var g = this._font._getBaseGlyph(rec.gid);
                                    layers.push(new COLRLayer(g, color));
                                }
                                return layers;
                            }
                        }
                    ]);
                    return COLRGlyph;
                }(Glyph);
                var TUPLES_SHARE_POINT_NUMBERS = 0x8000;
                var TUPLE_COUNT_MASK = 0x0fff;
                var EMBEDDED_TUPLE_COORD = 0x8000;
                var INTERMEDIATE_TUPLE = 0x4000;
                var PRIVATE_POINT_NUMBERS = 0x2000;
                var TUPLE_INDEX_MASK = 0x0fff;
                var POINTS_ARE_WORDS = 0x80;
                var POINT_RUN_COUNT_MASK = 0x7f;
                var DELTAS_ARE_ZERO = 0x80;
                var DELTAS_ARE_WORDS = 0x40;
                var DELTA_RUN_COUNT_MASK = 0x3f;
                /**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */ var GlyphVariationProcessor = /*#__PURE__*/ function() {
                    function GlyphVariationProcessor(font, coords) {
                        this.font = font;
                        this.normalizedCoords = this.normalizeCoords(coords);
                        this.blendVectors = new Map();
                    }
                    var _proto38 = GlyphVariationProcessor.prototype;
                    _proto38.normalizeCoords = function normalizeCoords(coords) {
                        // the default mapping is linear along each axis, in two segments:
                        // from the minValue to defaultValue, and from defaultValue to maxValue.
                        var normalized = [];
                        for(var i = 0; i < this.font.fvar.axis.length; i++){
                            var axis = this.font.fvar.axis[i];
                            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
                            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
                        } // if there is an avar table, the normalized value is calculated
                        // by interpolating between the two nearest mapped values.
                        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
                            var segment = this.font.avar.segment[i];
                            for(var j = 0; j < segment.correspondence.length; j++){
                                var pair = segment.correspondence[j];
                                if (j >= 1 && normalized[i] < pair.fromCoord) {
                                    var prev = segment.correspondence[j - 1];
                                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                                    break;
                                }
                            }
                        }
                        return normalized;
                    };
                    _proto38.transformPoints = function transformPoints(gid, glyphPoints) {
                        if (!this.font.fvar || !this.font.gvar) return;
                        var gvar = this.font.gvar;
                        if (gid >= gvar.glyphCount) return;
                        var offset = gvar.offsets[gid];
                        if (offset === gvar.offsets[gid + 1]) return;
                         // Read the gvar data for this glyph
                        var stream = this.font.stream;
                        stream.pos = offset;
                        if (stream.pos >= stream.length) return;
                        var tupleCount = stream.readUInt16BE();
                        var offsetToData = offset + stream.readUInt16BE();
                        if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
                            var here = stream.pos;
                            stream.pos = offsetToData;
                            var sharedPoints = this.decodePoints();
                            offsetToData = stream.pos;
                            stream.pos = here;
                        }
                        var origPoints = glyphPoints.map(function(pt) {
                            return pt.copy();
                        });
                        tupleCount &= TUPLE_COUNT_MASK;
                        for(var i = 0; i < tupleCount; i++){
                            var tupleDataSize = stream.readUInt16BE();
                            var tupleIndex = stream.readUInt16BE();
                            if (tupleIndex & EMBEDDED_TUPLE_COORD) {
                                var tupleCoords = [];
                                for(var a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
                            } else {
                                if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error("Invalid gvar table");
                                var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
                            }
                            if (tupleIndex & INTERMEDIATE_TUPLE) {
                                var startCoords = [];
                                for(var _a = 0; _a < gvar.axisCount; _a++)startCoords.push(stream.readInt16BE() / 16384);
                                var endCoords = [];
                                for(var _a2 = 0; _a2 < gvar.axisCount; _a2++)endCoords.push(stream.readInt16BE() / 16384);
                            } // Get the factor at which to apply this tuple
                            var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
                            if (factor === 0) {
                                offsetToData += tupleDataSize;
                                continue;
                            }
                            var here = stream.pos;
                            stream.pos = offsetToData;
                            if (tupleIndex & PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
                            else var points = sharedPoints;
                             // points.length = 0 means there are deltas for all points
                            var nPoints = points.length === 0 ? glyphPoints.length : points.length;
                            var xDeltas = this.decodeDeltas(nPoints);
                            var yDeltas = this.decodeDeltas(nPoints);
                            if (points.length === 0) // all points
                            for(var _i = 0; _i < glyphPoints.length; _i++){
                                var point = glyphPoints[_i];
                                point.x += Math.round(xDeltas[_i] * factor);
                                point.y += Math.round(yDeltas[_i] * factor);
                            }
                            else {
                                var outPoints = origPoints.map(function(pt) {
                                    return pt.copy();
                                });
                                var hasDelta = glyphPoints.map(function() {
                                    return false;
                                });
                                for(var _i2 = 0; _i2 < points.length; _i2++){
                                    var idx = points[_i2];
                                    if (idx < glyphPoints.length) {
                                        var _point = outPoints[idx];
                                        hasDelta[idx] = true;
                                        _point.x += Math.round(xDeltas[_i2] * factor);
                                        _point.y += Math.round(yDeltas[_i2] * factor);
                                    }
                                }
                                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                                for(var _i3 = 0; _i3 < glyphPoints.length; _i3++){
                                    var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                                    var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                                    glyphPoints[_i3].x += deltaX;
                                    glyphPoints[_i3].y += deltaY;
                                }
                            }
                            offsetToData += tupleDataSize;
                            stream.pos = here;
                        }
                    };
                    _proto38.decodePoints = function decodePoints() {
                        var stream = this.font.stream;
                        var count = stream.readUInt8();
                        if (count & POINTS_ARE_WORDS) count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
                        var points = new Uint16Array(count);
                        var i = 0;
                        var point = 0;
                        while(i < count){
                            var run = stream.readUInt8();
                            var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
                            var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
                            for(var j = 0; j < runCount && i < count; j++){
                                point += fn.call(stream);
                                points[i++] = point;
                            }
                        }
                        return points;
                    };
                    _proto38.decodeDeltas = function decodeDeltas(count) {
                        var stream = this.font.stream;
                        var i = 0;
                        var deltas = new Int16Array(count);
                        while(i < count){
                            var run = stream.readUInt8();
                            var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;
                            if (run & DELTAS_ARE_ZERO) i += runCount;
                            else {
                                var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                                for(var j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
                            }
                        }
                        return deltas;
                    };
                    _proto38.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
                        var normalized = this.normalizedCoords;
                        var gvar = this.font.gvar;
                        var factor = 1;
                        for(var i = 0; i < gvar.axisCount; i++){
                            if (tupleCoords[i] === 0) continue;
                            if (normalized[i] === 0) return 0;
                            if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
                                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
                            } else {
                                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
                            }
                        }
                        return factor;
                    } // Interpolates points without delta values.
                    ;
                    _proto38.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
                        if (points.length === 0) return;
                        var point = 0;
                        while(point < points.length){
                            var firstPoint = point; // find the end point of the contour
                            var endPoint = point;
                            var pt = points[endPoint];
                            while(!pt.endContour)pt = points[++endPoint];
                             // find the first point that has a delta
                            while(point <= endPoint && !hasDelta[point])point++;
                            if (point > endPoint) continue;
                            var firstDelta = point;
                            var curDelta = point;
                            point++;
                            while(point <= endPoint){
                                // find the next point with a delta, and interpolate intermediate points
                                if (hasDelta[point]) {
                                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                                    curDelta = point;
                                }
                                point++;
                            } // shift contour if we only have a single delta
                            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
                            else {
                                // otherwise, handle the remaining points at the end and beginning of the contour
                                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
                            }
                            point = endPoint + 1;
                        }
                    };
                    _proto38.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
                        if (p1 > p2) return;
                        var iterable = [
                            "x",
                            "y"
                        ];
                        for(var i = 0; i < iterable.length; i++){
                            var k = iterable[i];
                            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                                var p = ref1;
                                ref1 = ref2;
                                ref2 = p;
                            }
                            var in1 = inPoints[ref1][k];
                            var in2 = inPoints[ref2][k];
                            var out1 = outPoints[ref1][k];
                            var out2 = outPoints[ref2][k]; // If the reference points have the same coordinate but different
                            // delta, inferred delta is zero.  Otherwise interpolate.
                            if (in1 !== in2 || out1 === out2) {
                                var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                                for(var _p = p1; _p <= p2; _p++){
                                    var out = inPoints[_p][k];
                                    if (out <= in1) out += out1 - in1;
                                    else if (out >= in2) out += out2 - in2;
                                    else out = out1 + (out - in1) * scale;
                                    outPoints[_p][k] = out;
                                }
                            }
                        }
                    };
                    _proto38.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
                        var deltaX = outPoints[ref].x - inPoints[ref].x;
                        var deltaY = outPoints[ref].y - inPoints[ref].y;
                        if (deltaX === 0 && deltaY === 0) return;
                        for(var p = p1; p <= p2; p++)if (p !== ref) {
                            outPoints[p].x += deltaX;
                            outPoints[p].y += deltaY;
                        }
                    };
                    _proto38.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
                        var outerIndex, innerIndex;
                        if (table.advanceWidthMapping) {
                            var idx = gid;
                            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
                            var entryFormat = table.advanceWidthMapping.entryFormat;
                            var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
                            outerIndex = _table$advanceWidthMa.outerIndex;
                            innerIndex = _table$advanceWidthMa.innerIndex;
                        } else {
                            outerIndex = 0;
                            innerIndex = gid;
                        }
                        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
                    } // See pseudo code from `Font Variations Overview'
                    ;
                    _proto38.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
                        if (outerIndex >= itemStore.itemVariationData.length) return 0;
                        var varData = itemStore.itemVariationData[outerIndex];
                        if (innerIndex >= varData.deltaSets.length) return 0;
                        var deltaSet = varData.deltaSets[innerIndex];
                        var blendVector = this.getBlendVector(itemStore, outerIndex);
                        var netAdjustment = 0;
                        for(var master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
                        return netAdjustment;
                    };
                    _proto38.getBlendVector = function getBlendVector(itemStore, outerIndex) {
                        var varData = itemStore.itemVariationData[outerIndex];
                        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
                        var normalizedCoords = this.normalizedCoords;
                        var blendVector = []; // outer loop steps through master designs to be blended
                        for(var master = 0; master < varData.regionIndexCount; master++){
                            var scalar = 1;
                            var regionIndex = varData.regionIndexes[master];
                            var axes = itemStore.variationRegionList.variationRegions[regionIndex]; // inner loop steps through axes in this region
                            for(var j = 0; j < axes.length; j++){
                                var axis = axes[j];
                                var axisScalar = void 0; // compute the scalar contribution of this axis
                                // ignore invalid ranges
                                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1; // peak of 0 means ignore this axis
                                else if (axis.peakCoord === 0) axisScalar = 1; // ignore this region if coords are out of range
                                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0; // calculate a proportional factor
                                else {
                                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                                } // take product of all the axis scalars
                                scalar *= axisScalar;
                            }
                            blendVector[master] = scalar;
                        }
                        this.blendVectors.set(varData, blendVector);
                        return blendVector;
                    };
                    return GlyphVariationProcessor;
                }();
                var resolved = Promise.resolve();
                var Subset = /*#__PURE__*/ function() {
                    function Subset(font) {
                        this.font = font;
                        this.glyphs = [];
                        this.mapping = {}; // always include the missing glyph
                        this.includeGlyph(0);
                    }
                    var _proto39 = Subset.prototype;
                    _proto39.includeGlyph = function includeGlyph(glyph) {
                        if (typeof glyph === "object") glyph = glyph.id;
                        if (this.mapping[glyph] == null) {
                            this.glyphs.push(glyph);
                            this.mapping[glyph] = this.glyphs.length - 1;
                        }
                        return this.mapping[glyph];
                    };
                    _proto39.encodeStream = function encodeStream() {
                        var _this11 = this;
                        var s = new r.EncodeStream();
                        resolved.then(function() {
                            _this11.encode(s);
                            return s.end();
                        });
                        return s;
                    };
                    return Subset;
                }();
                var ON_CURVE$1 = 1;
                var X_SHORT_VECTOR$1 = 2;
                var Y_SHORT_VECTOR$1 = 4;
                var REPEAT$1 = 8;
                var SAME_X$1 = 16;
                var SAME_Y$1 = 32;
                var Point$1 = /*#__PURE__*/ function() {
                    function Point$1() {}
                    Point$1.size = function size(val) {
                        return val >= 0 && val <= 255 ? 1 : 2;
                    };
                    Point$1.encode = function encode(stream, value) {
                        if (value >= 0 && value <= 255) stream.writeUInt8(value);
                        else stream.writeInt16BE(value);
                    };
                    return Point$1;
                }();
                var Glyf = new r.Struct({
                    numberOfContours: r.int16,
                    // if negative, this is a composite glyph
                    xMin: r.int16,
                    yMin: r.int16,
                    xMax: r.int16,
                    yMax: r.int16,
                    endPtsOfContours: new r.Array(r.uint16, "numberOfContours"),
                    instructions: new r.Array(r.uint8, r.uint16),
                    flags: new r.Array(r.uint8, 0),
                    xPoints: new r.Array(Point$1, 0),
                    yPoints: new r.Array(Point$1, 0)
                });
                /**
 * Encodes TrueType glyph outlines
 */ var TTFGlyphEncoder = /*#__PURE__*/ function() {
                    function TTFGlyphEncoder() {}
                    var _proto40 = TTFGlyphEncoder.prototype;
                    _proto40.encodeSimple = function encodeSimple(path, instructions) {
                        if (instructions === void 0) instructions = [];
                        var endPtsOfContours = [];
                        var xPoints = [];
                        var yPoints = [];
                        var flags = [];
                        var same = 0;
                        var lastX = 0, lastY = 0, lastFlag = 0;
                        var pointCount = 0;
                        for(var i = 0; i < path.commands.length; i++){
                            var c = path.commands[i];
                            for(var j = 0; j < c.args.length; j += 2){
                                var x = c.args[j];
                                var y = c.args[j + 1];
                                var flag = 0; // If the ending point of a quadratic curve is the midpoint
                                // between the control point and the control point of the next
                                // quadratic curve, we can omit the ending point.
                                if (c.command === "quadraticCurveTo" && j === 2) {
                                    var next = path.commands[i + 1];
                                    if (next && next.command === "quadraticCurveTo") {
                                        var midX = (lastX + next.args[0]) / 2;
                                        var midY = (lastY + next.args[1]) / 2;
                                        if (x === midX && y === midY) continue;
                                    }
                                } // All points except control points are on curve.
                                if (!(c.command === "quadraticCurveTo" && j === 0)) flag |= ON_CURVE$1;
                                flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
                                flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);
                                if (flag === lastFlag && same < 255) {
                                    flags[flags.length - 1] |= REPEAT$1;
                                    same++;
                                } else {
                                    if (same > 0) {
                                        flags.push(same);
                                        same = 0;
                                    }
                                    flags.push(flag);
                                    lastFlag = flag;
                                }
                                lastX = x;
                                lastY = y;
                                pointCount++;
                            }
                            if (c.command === "closePath") endPtsOfContours.push(pointCount - 1);
                        } // Close the path if the last command didn't already
                        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== "closePath") endPtsOfContours.push(pointCount - 1);
                        var bbox = path.bbox;
                        var glyf = {
                            numberOfContours: endPtsOfContours.length,
                            xMin: bbox.minX,
                            yMin: bbox.minY,
                            xMax: bbox.maxX,
                            yMax: bbox.maxY,
                            endPtsOfContours: endPtsOfContours,
                            instructions: instructions,
                            flags: flags,
                            xPoints: xPoints,
                            yPoints: yPoints
                        };
                        var size = Glyf.size(glyf);
                        var tail = 4 - size % 4;
                        var stream = new r.EncodeStream(size + tail);
                        Glyf.encode(stream, glyf); // Align to 4-byte length
                        if (tail !== 0) stream.fill(0, tail);
                        return stream.buffer;
                    };
                    _proto40._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
                        var diff = value - last;
                        if (value === last) flag |= sameFlag;
                        else {
                            if (-255 <= diff && diff <= 255) {
                                flag |= shortFlag;
                                if (diff < 0) diff = -diff;
                                else flag |= sameFlag;
                            }
                            points.push(diff);
                        }
                        return flag;
                    };
                    return TTFGlyphEncoder;
                }();
                var TTFSubset = /*#__PURE__*/ function(_Subset) {
                    _inheritsLoose(TTFSubset, _Subset);
                    function TTFSubset(font) {
                        var _this12;
                        _this12 = _Subset.call(this, font) || this;
                        _this12.glyphEncoder = new TTFGlyphEncoder();
                        return _this12;
                    }
                    var _proto41 = TTFSubset.prototype;
                    _proto41._addGlyph = function _addGlyph(gid) {
                        var glyph = this.font.getGlyph(gid);
                        var glyf = glyph._decode(); // get the offset to the glyph from the loca table
                        var curOffset = this.font.loca.offsets[gid];
                        var nextOffset = this.font.loca.offsets[gid + 1];
                        var stream = this.font._getTableStream("glyf");
                        stream.pos += curOffset;
                        var buffer = stream.readBuffer(nextOffset - curOffset); // if it is a compound glyph, include its components
                        if (glyf && glyf.numberOfContours < 0) {
                            buffer = Buffer.from(buffer);
                            for(var _iterator72 = _createForOfIteratorHelperLoose(glyf.components), _step72; !(_step72 = _iterator72()).done;){
                                var component = _step72.value;
                                gid = this.includeGlyph(component.glyphID);
                                buffer.writeUInt16BE(gid, component.pos);
                            }
                        } else if (glyf && this.font._variationProcessor) // If this is a TrueType variation glyph, re-encode the path
                        buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
                        this.glyf.push(buffer);
                        this.loca.offsets.push(this.offset);
                        this.hmtx.metrics.push({
                            advance: glyph.advanceWidth,
                            bearing: glyph._getMetrics().leftBearing
                        });
                        this.offset += buffer.length;
                        return this.glyf.length - 1;
                    };
                    _proto41.encode = function encode(stream) {
                        // tables required by PDF spec:
                        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
                        //
                        // additional tables required for standalone fonts:
                        //   name, cmap, OS/2, post
                        this.glyf = [];
                        this.offset = 0;
                        this.loca = {
                            offsets: [],
                            version: this.font.loca.version
                        };
                        this.hmtx = {
                            metrics: [],
                            bearings: []
                        }; // include all the glyphs
                        // not using a for loop because we need to support adding more
                        // glyphs to the array as we go, and CoffeeScript caches the length.
                        var i = 0;
                        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
                        var maxp = cloneDeep(this.font.maxp);
                        maxp.numGlyphs = this.glyf.length;
                        this.loca.offsets.push(this.offset);
                        var head = cloneDeep(this.font.head);
                        head.indexToLocFormat = this.loca.version;
                        var hhea = cloneDeep(this.font.hhea);
                        hhea.numberOfMetrics = this.hmtx.metrics.length; // map = []
                        // for index in [0...256]
                        //     if index < @numGlyphs
                        //         map[index] = index
                        //     else
                        //         map[index] = 0
                        //
                        // cmapTable =
                        //     version: 0
                        //     length: 262
                        //     language: 0
                        //     codeMap: map
                        //
                        // cmap =
                        //     version: 0
                        //     numSubtables: 1
                        //     tables: [
                        //         platformID: 1
                        //         encodingID: 0
                        //         table: cmapTable
                        //     ]
                        // TODO: subset prep, cvt, fpgm?
                        Directory.encode(stream, {
                            tables: {
                                head: head,
                                hhea: hhea,
                                loca: this.loca,
                                maxp: maxp,
                                "cvt ": this.font["cvt "],
                                prep: this.font.prep,
                                glyf: this.glyf,
                                hmtx: this.hmtx,
                                fpgm: this.font.fpgm // name: clone @font.name
                            }
                        });
                    };
                    return TTFSubset;
                }(Subset);
                var CFFSubset = /*#__PURE__*/ function(_Subset2) {
                    _inheritsLoose(CFFSubset, _Subset2);
                    function CFFSubset(font) {
                        var _this13;
                        _this13 = _Subset2.call(this, font) || this;
                        _this13.cff = _this13.font["CFF "];
                        if (!_this13.cff) throw new Error("Not a CFF Font");
                        return _this13;
                    }
                    var _proto42 = CFFSubset.prototype;
                    _proto42.subsetCharstrings = function subsetCharstrings() {
                        this.charstrings = [];
                        var gsubrs = {};
                        for(var _iterator73 = _createForOfIteratorHelperLoose(this.glyphs), _step73; !(_step73 = _iterator73()).done;){
                            var gid = _step73.value;
                            this.charstrings.push(this.cff.getCharString(gid));
                            var glyph = this.font.getGlyph(gid);
                            var path = glyph.path; // this causes the glyph to be parsed
                            for(var subr in glyph._usedGsubrs)gsubrs[subr] = true;
                        }
                        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
                    };
                    _proto42.subsetSubrs = function subsetSubrs(subrs, used) {
                        var res = [];
                        for(var i = 0; i < subrs.length; i++){
                            var subr = subrs[i];
                            if (used[i]) {
                                this.cff.stream.pos = subr.offset;
                                res.push(this.cff.stream.readBuffer(subr.length));
                            } else res.push(Buffer.from([
                                11
                            ])); // return
                        }
                        return res;
                    };
                    _proto42.subsetFontdict = function subsetFontdict(topDict) {
                        topDict.FDArray = [];
                        topDict.FDSelect = {
                            version: 0,
                            fds: []
                        };
                        var used_fds = {};
                        var used_subrs = [];
                        var fd_select = {};
                        for(var _iterator74 = _createForOfIteratorHelperLoose(this.glyphs), _step74; !(_step74 = _iterator74()).done;){
                            var gid = _step74.value;
                            var fd = this.cff.fdForGlyph(gid);
                            if (fd == null) continue;
                            if (!used_fds[fd]) {
                                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                                used_subrs.push({});
                                fd_select[fd] = topDict.FDArray.length - 1;
                            }
                            used_fds[fd] = true;
                            topDict.FDSelect.fds.push(fd_select[fd]);
                            var glyph = this.font.getGlyph(gid);
                            var path = glyph.path; // this causes the glyph to be parsed
                            for(var subr in glyph._usedSubrs)used_subrs[fd_select[fd]][subr] = true;
                        }
                        for(var i = 0; i < topDict.FDArray.length; i++){
                            var dict = topDict.FDArray[i];
                            delete dict.FontName;
                            if (dict.Private && dict.Private.Subrs) {
                                dict.Private = Object.assign({}, dict.Private);
                                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
                            }
                        }
                        return;
                    };
                    _proto42.createCIDFontdict = function createCIDFontdict(topDict) {
                        var used_subrs = {};
                        for(var _iterator75 = _createForOfIteratorHelperLoose(this.glyphs), _step75; !(_step75 = _iterator75()).done;){
                            var gid = _step75.value;
                            var glyph = this.font.getGlyph(gid);
                            var path = glyph.path; // this causes the glyph to be parsed
                            for(var subr in glyph._usedSubrs)used_subrs[subr] = true;
                        }
                        var privateDict = Object.assign({}, this.cff.topDict.Private);
                        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
                        topDict.FDArray = [
                            {
                                Private: privateDict
                            }
                        ];
                        return topDict.FDSelect = {
                            version: 3,
                            nRanges: 1,
                            ranges: [
                                {
                                    first: 0,
                                    fd: 0
                                }
                            ],
                            sentinel: this.charstrings.length
                        };
                    };
                    _proto42.addString = function addString(string) {
                        if (!string) return null;
                        if (!this.strings) this.strings = [];
                        this.strings.push(string);
                        return standardStrings.length + this.strings.length - 1;
                    };
                    _proto42.encode = function encode(stream) {
                        this.subsetCharstrings();
                        var charset = {
                            version: this.charstrings.length > 255 ? 2 : 1,
                            ranges: [
                                {
                                    first: 1,
                                    nLeft: this.charstrings.length - 2
                                }
                            ]
                        };
                        var topDict = Object.assign({}, this.cff.topDict);
                        topDict.Private = null;
                        topDict.charset = charset;
                        topDict.Encoding = null;
                        topDict.CharStrings = this.charstrings;
                        for(var _i24 = 0, _arr2 = [
                            "version",
                            "Notice",
                            "Copyright",
                            "FullName",
                            "FamilyName",
                            "Weight",
                            "PostScript",
                            "BaseFontName",
                            "FontName"
                        ]; _i24 < _arr2.length; _i24++){
                            var key = _arr2[_i24];
                            topDict[key] = this.addString(this.cff.string(topDict[key]));
                        }
                        topDict.ROS = [
                            this.addString("Adobe"),
                            this.addString("Identity"),
                            0
                        ];
                        topDict.CIDCount = this.charstrings.length;
                        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
                        else this.createCIDFontdict(topDict);
                        var top = {
                            version: 1,
                            hdrSize: this.cff.hdrSize,
                            offSize: 4,
                            header: this.cff.header,
                            nameIndex: [
                                this.cff.postscriptName
                            ],
                            topDictIndex: [
                                topDict
                            ],
                            stringIndex: this.strings,
                            globalSubrIndex: this.gsubrs
                        };
                        CFFTop.encode(stream, top);
                    };
                    return CFFSubset;
                }(Subset);
                var _class$4;
                /**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */ var TTFFont = (_class$4 = /*#__PURE__*/ function() {
                    TTFFont.probe = function probe(buffer) {
                        var format = buffer.toString("ascii", 0, 4);
                        return format === "true" || format === "OTTO" || format === String.fromCharCode(0, 1, 0, 0);
                    };
                    function TTFFont(stream, variationCoords) {
                        if (variationCoords === void 0) variationCoords = null;
                        this.defaultLanguage = null;
                        this.stream = stream;
                        this.variationCoords = variationCoords;
                        this._directoryPos = this.stream.pos;
                        this._tables = {};
                        this._glyphs = {};
                        this._decodeDirectory(); // define properties for each table to lazily parse
                        for(var tag in this.directory.tables){
                            var table = this.directory.tables[tag];
                            if (tables[tag] && table.length > 0) Object.defineProperty(this, tag, {
                                get: this._getTable.bind(this, table)
                            });
                        }
                    }
                    var _proto43 = TTFFont.prototype;
                    _proto43.setDefaultLanguage = function setDefaultLanguage(lang) {
                        if (lang === void 0) lang = null;
                        this.defaultLanguage = lang;
                    };
                    _proto43._getTable = function _getTable(table) {
                        if (!(table.tag in this._tables)) try {
                            this._tables[table.tag] = this._decodeTable(table);
                        } catch (e) {
                            if (fontkit.logErrors) {
                                console.error("Error decoding table ".concat(table.tag));
                                console.error(e.stack);
                            }
                        }
                        return this._tables[table.tag];
                    };
                    _proto43._getTableStream = function _getTableStream(tag) {
                        var table = this.directory.tables[tag];
                        if (table) {
                            this.stream.pos = table.offset;
                            return this.stream;
                        }
                        return null;
                    };
                    _proto43._decodeDirectory = function _decodeDirectory() {
                        return this.directory = Directory.decode(this.stream, {
                            _startOffset: 0
                        });
                    };
                    _proto43._decodeTable = function _decodeTable(table) {
                        var pos = this.stream.pos;
                        var stream = this._getTableStream(table.tag);
                        var result = tables[table.tag].decode(stream, this, table.length);
                        this.stream.pos = pos;
                        return result;
                    } /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ ;
                    _proto43.getName = function getName(key, lang) {
                        if (lang === void 0) lang = this.defaultLanguage || fontkit.defaultLanguage;
                        var record = this.name && this.name.records[key];
                        if (record) // Attempt to retrieve the entry, depending on which translation is available:
                        return record[lang] || record[this.defaultLanguage] || record[fontkit.defaultLanguage] || record["en"] || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
                         || null;
                        return null;
                    } /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */ ;
                    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ _proto43.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
                        return !!this._cmapProcessor.lookup(codePoint);
                    } /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ ;
                    _proto43.glyphForCodePoint = function glyphForCodePoint(codePoint) {
                        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
                            codePoint
                        ]);
                    } /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ ;
                    _proto43.glyphsForString = function glyphsForString(string) {
                        var glyphs = [];
                        var len = string.length;
                        var idx = 0;
                        var last = -1;
                        var state = -1;
                        while(idx <= len){
                            var code = 0;
                            var nextState = 0;
                            if (idx < len) {
                                // Decode the next codepoint from UTF 16
                                code = string.charCodeAt(idx++);
                                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                                    var next = string.charCodeAt(idx);
                                    if (0xdc00 <= next && next <= 0xdfff) {
                                        idx++;
                                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                                    }
                                } // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
                            } else idx++;
                            if (state === 0 && nextState === 1) // Variation selector following normal codepoint.
                            glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                                last,
                                code
                            ]));
                            else if (state === 0 && nextState === 0) // Normal codepoint following normal codepoint.
                            glyphs.push(this.glyphForCodePoint(last));
                            last = code;
                            state = nextState;
                        }
                        return glyphs;
                    };
                    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ _proto43.layout = function layout(string, userFeatures, script, language, direction) {
                        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
                    } /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ ;
                    _proto43.stringsForGlyph = function stringsForGlyph(gid) {
                        return this._layoutEngine.stringsForGlyph(gid);
                    } /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ ;
                    _proto43.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        return this._layoutEngine.getAvailableFeatures(script, language);
                    };
                    _proto43._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
                        if (characters === void 0) characters = [];
                        if (!this._glyphs[glyph]) {
                            if (this.directory.tables.glyf) this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
                            else if (this.directory.tables["CFF "] || this.directory.tables.CFF2) this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
                        }
                        return this._glyphs[glyph] || null;
                    } /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ ;
                    _proto43.getGlyph = function getGlyph(glyph, characters) {
                        if (characters === void 0) characters = [];
                        if (!this._glyphs[glyph]) {
                            if (this.directory.tables.sbix) this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
                            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
                            else this._getBaseGlyph(glyph, characters);
                        }
                        return this._glyphs[glyph] || null;
                    } /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ ;
                    _proto43.createSubset = function createSubset() {
                        if (this.directory.tables["CFF "]) return new CFFSubset(this);
                        return new TTFSubset(this);
                    } /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ ;
                    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ _proto43.getVariation = function getVariation(settings) {
                        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
                        if (typeof settings === "string") settings = this.namedVariations[settings];
                        if (typeof settings !== "object") throw new Error("Variation settings must be either a variation name or settings object.");
                         // normalize the coordinates
                        var coords = this.fvar.axis.map(function(axis, i) {
                            var axisTag = axis.axisTag.trim();
                            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
                            else return axis.defaultValue;
                        });
                        var stream = new r.DecodeStream(this.stream.buffer);
                        stream.pos = this._directoryPos;
                        var font = new TTFFont(stream, coords);
                        font._tables = this._tables;
                        return font;
                    };
                    // Standardized format plugin API
                    _proto43.getFont = function getFont(name) {
                        return this.getVariation(name);
                    };
                    _createClass(TTFFont, [
                        {
                            key: "postscriptName",
                            get: function get() {
                                return this.getName("postscriptName");
                            }
                        },
                        {
                            key: "fullName",
                            get: function get() {
                                return this.getName("fullName");
                            }
                        },
                        {
                            key: "familyName",
                            get: function get() {
                                return this.getName("fontFamily");
                            }
                        },
                        {
                            key: "subfamilyName",
                            get: function get() {
                                return this.getName("fontSubfamily");
                            }
                        },
                        {
                            key: "copyright",
                            get: function get() {
                                return this.getName("copyright");
                            }
                        },
                        {
                            key: "version",
                            get: function get() {
                                return this.getName("version");
                            }
                        },
                        {
                            key: "ascent",
                            get: function get() {
                                return this.hhea.ascent;
                            }
                        },
                        {
                            key: "descent",
                            get: function get() {
                                return this.hhea.descent;
                            }
                        },
                        {
                            key: "lineGap",
                            get: function get() {
                                return this.hhea.lineGap;
                            }
                        },
                        {
                            key: "underlinePosition",
                            get: function get() {
                                return this.post.underlinePosition;
                            }
                        },
                        {
                            key: "underlineThickness",
                            get: function get() {
                                return this.post.underlineThickness;
                            }
                        },
                        {
                            key: "italicAngle",
                            get: function get() {
                                return this.post.italicAngle;
                            }
                        },
                        {
                            key: "capHeight",
                            get: function get() {
                                var os2 = this["OS/2"];
                                return os2 ? os2.capHeight : this.ascent;
                            }
                        },
                        {
                            key: "xHeight",
                            get: function get() {
                                var os2 = this["OS/2"];
                                return os2 ? os2.xHeight : 0;
                            }
                        },
                        {
                            key: "numGlyphs",
                            get: function get() {
                                return this.maxp.numGlyphs;
                            }
                        },
                        {
                            key: "unitsPerEm",
                            get: function get() {
                                return this.head.unitsPerEm;
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                return Object.freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
                            }
                        },
                        {
                            key: "_cmapProcessor",
                            get: function get() {
                                return new CmapProcessor(this.cmap);
                            }
                        },
                        {
                            key: "characterSet",
                            get: function get() {
                                return this._cmapProcessor.getCharacterSet();
                            }
                        },
                        {
                            key: "_layoutEngine",
                            get: function get() {
                                return new LayoutEngine(this);
                            }
                        },
                        {
                            key: "availableFeatures",
                            get: function get() {
                                return this._layoutEngine.getAvailableFeatures();
                            }
                        },
                        {
                            key: "variationAxes",
                            get: function get() {
                                var res = {};
                                if (!this.fvar) return res;
                                for(var _iterator76 = _createForOfIteratorHelperLoose(this.fvar.axis), _step76; !(_step76 = _iterator76()).done;){
                                    var axis = _step76.value;
                                    res[axis.axisTag.trim()] = {
                                        name: axis.name.en,
                                        min: axis.minValue,
                                        default: axis.defaultValue,
                                        max: axis.maxValue
                                    };
                                }
                                return res;
                            }
                        },
                        {
                            key: "namedVariations",
                            get: function get() {
                                var res = {};
                                if (!this.fvar) return res;
                                for(var _iterator77 = _createForOfIteratorHelperLoose(this.fvar.instance), _step77; !(_step77 = _iterator77()).done;){
                                    var instance = _step77.value;
                                    var settings = {};
                                    for(var i = 0; i < this.fvar.axis.length; i++){
                                        var axis = this.fvar.axis[i];
                                        settings[axis.axisTag.trim()] = instance.coord[i];
                                    }
                                    res[instance.name.en] = settings;
                                }
                                return res;
                            }
                        },
                        {
                            key: "_variationProcessor",
                            get: function get() {
                                if (!this.fvar) return null;
                                var variationCoords = this.variationCoords; // Ignore if no variation coords and not CFF2
                                if (!variationCoords && !this.CFF2) return null;
                                if (!variationCoords) variationCoords = this.fvar.axis.map(function(axis) {
                                    return axis.defaultValue;
                                });
                                return new GlyphVariationProcessor(this, variationCoords);
                            }
                        }
                    ]);
                    return TTFFont;
                }(), _applyDecoratedDescriptor(_class$4.prototype, "bbox", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "bbox"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "_cmapProcessor", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "_cmapProcessor"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "characterSet", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "characterSet"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "_layoutEngine", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "_layoutEngine"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "variationAxes", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "variationAxes"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "namedVariations", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "namedVariations"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "_variationProcessor", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "_variationProcessor"), _class$4.prototype), _class$4);
                var WOFFDirectoryEntry = new r.Struct({
                    tag: new r.String(4),
                    offset: new r.Pointer(r.uint32, "void", {
                        type: "global"
                    }),
                    compLength: r.uint32,
                    length: r.uint32,
                    origChecksum: r.uint32
                });
                var WOFFDirectory = new r.Struct({
                    tag: new r.String(4),
                    // should be 'wOFF'
                    flavor: r.uint32,
                    length: r.uint32,
                    numTables: r.uint16,
                    reserved: new r.Reserved(r.uint16),
                    totalSfntSize: r.uint32,
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    metaOffset: r.uint32,
                    metaLength: r.uint32,
                    metaOrigLength: r.uint32,
                    privOffset: r.uint32,
                    privLength: r.uint32,
                    tables: new r.Array(WOFFDirectoryEntry, "numTables")
                });
                WOFFDirectory.process = function() {
                    var tables = {};
                    for(var _iterator78 = _createForOfIteratorHelperLoose(this.tables), _step78; !(_step78 = _iterator78()).done;){
                        var table = _step78.value;
                        tables[table.tag] = table;
                    }
                    this.tables = tables;
                };
                var WOFFFont = /*#__PURE__*/ function(_TTFFont) {
                    _inheritsLoose(WOFFFont, _TTFFont);
                    function WOFFFont() {
                        return _TTFFont.apply(this, arguments) || this;
                    }
                    WOFFFont.probe = function probe(buffer) {
                        return buffer.toString("ascii", 0, 4) === "wOFF";
                    };
                    var _proto44 = WOFFFont.prototype;
                    _proto44._decodeDirectory = function _decodeDirectory() {
                        this.directory = WOFFDirectory.decode(this.stream, {
                            _startOffset: 0
                        });
                    };
                    _proto44._getTableStream = function _getTableStream(tag) {
                        var table = this.directory.tables[tag];
                        if (table) {
                            this.stream.pos = table.offset;
                            if (table.compLength < table.length) {
                                this.stream.pos += 2; // skip deflate header
                                var outBuffer = Buffer.alloc(table.length);
                                var buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
                                return new r.DecodeStream(buf);
                            } else return this.stream;
                        }
                        return null;
                    };
                    return WOFFFont;
                }(TTFFont);
                /**
 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
 */ var WOFF2Glyph = /*#__PURE__*/ function(_TTFGlyph2) {
                    _inheritsLoose(WOFF2Glyph, _TTFGlyph2);
                    function WOFF2Glyph() {
                        return _TTFGlyph2.apply(this, arguments) || this;
                    }
                    var _proto45 = WOFF2Glyph.prototype;
                    _proto45._decode = function _decode() {
                        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
                        return this._font._transformedGlyphs[this.id];
                    };
                    _proto45._getCBox = function _getCBox() {
                        return this.path.bbox;
                    };
                    return WOFF2Glyph;
                }(TTFGlyph);
                var Base128 = {
                    decode: function decode(stream) {
                        var result = 0;
                        var iterable = [
                            0,
                            1,
                            2,
                            3,
                            4
                        ];
                        for(var j = 0; j < iterable.length; j++){
                            var code = stream.readUInt8(); // If any of the top seven bits are set then we're about to overflow.
                            if (result & 0xe0000000) throw new Error("Overflow");
                            result = result << 7 | code & 0x7f;
                            if ((code & 0x80) === 0) return result;
                        }
                        throw new Error("Bad base 128 number");
                    }
                };
                var knownTags = [
                    "cmap",
                    "head",
                    "hhea",
                    "hmtx",
                    "maxp",
                    "name",
                    "OS/2",
                    "post",
                    "cvt ",
                    "fpgm",
                    "glyf",
                    "loca",
                    "prep",
                    "CFF ",
                    "VORG",
                    "EBDT",
                    "EBLC",
                    "gasp",
                    "hdmx",
                    "kern",
                    "LTSH",
                    "PCLT",
                    "VDMX",
                    "vhea",
                    "vmtx",
                    "BASE",
                    "GDEF",
                    "GPOS",
                    "GSUB",
                    "EBSC",
                    "JSTF",
                    "MATH",
                    "CBDT",
                    "CBLC",
                    "COLR",
                    "CPAL",
                    "SVG ",
                    "sbix",
                    "acnt",
                    "avar",
                    "bdat",
                    "bloc",
                    "bsln",
                    "cvar",
                    "fdsc",
                    "feat",
                    "fmtx",
                    "fvar",
                    "gvar",
                    "hsty",
                    "just",
                    "lcar",
                    "mort",
                    "morx",
                    "opbd",
                    "prop",
                    "trak",
                    "Zapf",
                    "Silf",
                    "Glat",
                    "Gloc",
                    "Feat",
                    "Sill"
                ];
                var WOFF2DirectoryEntry = new r.Struct({
                    flags: r.uint8,
                    customTag: new r.Optional(new r.String(4), function(t) {
                        return (t.flags & 0x3f) === 0x3f;
                    }),
                    tag: function tag(t) {
                        return t.customTag || knownTags[t.flags & 0x3f];
                    },
                    // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
                    length: Base128,
                    transformVersion: function transformVersion(t) {
                        return t.flags >>> 6 & 0x03;
                    },
                    transformed: function transformed(t) {
                        return t.tag === "glyf" || t.tag === "loca" ? t.transformVersion === 0 : t.transformVersion !== 0;
                    },
                    transformLength: new r.Optional(Base128, function(t) {
                        return t.transformed;
                    })
                });
                var WOFF2Directory = new r.Struct({
                    tag: new r.String(4),
                    // should be 'wOF2'
                    flavor: r.uint32,
                    length: r.uint32,
                    numTables: r.uint16,
                    reserved: new r.Reserved(r.uint16),
                    totalSfntSize: r.uint32,
                    totalCompressedSize: r.uint32,
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    metaOffset: r.uint32,
                    metaLength: r.uint32,
                    metaOrigLength: r.uint32,
                    privOffset: r.uint32,
                    privLength: r.uint32,
                    tables: new r.Array(WOFF2DirectoryEntry, "numTables")
                });
                WOFF2Directory.process = function() {
                    var tables = {};
                    for(var i = 0; i < this.tables.length; i++){
                        var table = this.tables[i];
                        tables[table.tag] = table;
                    }
                    return this.tables = tables;
                };
                /**
 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
 * See spec here: http://www.w3.org/TR/WOFF2/
 */ var WOFF2Font = /*#__PURE__*/ function(_TTFFont2) {
                    _inheritsLoose(WOFF2Font, _TTFFont2);
                    function WOFF2Font() {
                        return _TTFFont2.apply(this, arguments) || this;
                    }
                    WOFF2Font.probe = function probe(buffer) {
                        return buffer.toString("ascii", 0, 4) === "wOF2";
                    };
                    var _proto46 = WOFF2Font.prototype;
                    _proto46._decodeDirectory = function _decodeDirectory() {
                        this.directory = WOFF2Directory.decode(this.stream);
                        this._dataPos = this.stream.pos;
                    };
                    _proto46._decompress = function _decompress() {
                        // decompress data and setup table offsets if we haven't already
                        if (!this._decompressed) {
                            this.stream.pos = this._dataPos;
                            var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
                            var decompressedSize = 0;
                            for(var tag in this.directory.tables){
                                var entry = this.directory.tables[tag];
                                entry.offset = decompressedSize;
                                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
                            }
                            var decompressed = brotli(buffer, decompressedSize);
                            if (!decompressed) throw new Error("Error decoding compressed data in WOFF2");
                            this.stream = new r.DecodeStream(Buffer.from(decompressed));
                            this._decompressed = true;
                        }
                    };
                    _proto46._decodeTable = function _decodeTable(table) {
                        this._decompress();
                        return _TTFFont2.prototype._decodeTable.call(this, table);
                    } // Override this method to get a glyph and return our
                    ;
                    _proto46._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
                        if (characters === void 0) characters = [];
                        if (!this._glyphs[glyph]) {
                            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                                if (!this._transformedGlyphs) this._transformGlyfTable();
                                return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
                            } else return _TTFFont2.prototype._getBaseGlyph.call(this, glyph, characters);
                        }
                    };
                    _proto46._transformGlyfTable = function _transformGlyfTable() {
                        this._decompress();
                        this.stream.pos = this.directory.tables.glyf.offset;
                        var table = GlyfTable.decode(this.stream);
                        var glyphs = [];
                        for(var index = 0; index < table.numGlyphs; index++){
                            var glyph = {};
                            var nContours = table.nContours.readInt16BE();
                            glyph.numberOfContours = nContours;
                            if (nContours > 0) {
                                // simple glyph
                                var nPoints = [];
                                var totalPoints = 0;
                                for(var i = 0; i < nContours; i++){
                                    var _r = read255UInt16(table.nPoints);
                                    totalPoints += _r;
                                    nPoints.push(totalPoints);
                                }
                                glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);
                                for(var _i = 0; _i < nContours; _i++)glyph.points[nPoints[_i] - 1].endContour = true;
                                var instructionSize = read255UInt16(table.glyphs);
                            } else if (nContours < 0) {
                                // composite glyph
                                var haveInstructions = TTFGlyph.prototype._decodeComposite.call({
                                    _font: this
                                }, glyph, table.composites);
                                if (haveInstructions) var instructionSize = read255UInt16(table.glyphs);
                            }
                            glyphs.push(glyph);
                        }
                        this._transformedGlyphs = glyphs;
                    };
                    return WOFF2Font;
                }(TTFFont); // Special class that accepts a length and returns a sub-stream for that data
                var Substream = /*#__PURE__*/ function() {
                    function Substream(length) {
                        this.length = length;
                        this._buf = new r.Buffer(length);
                    }
                    var _proto47 = Substream.prototype;
                    _proto47.decode = function decode(stream, parent) {
                        return new r.DecodeStream(this._buf.decode(stream, parent));
                    };
                    return Substream;
                }(); // This struct represents the entire glyf table
                var GlyfTable = new r.Struct({
                    version: r.uint32,
                    numGlyphs: r.uint16,
                    indexFormat: r.uint16,
                    nContourStreamSize: r.uint32,
                    nPointsStreamSize: r.uint32,
                    flagStreamSize: r.uint32,
                    glyphStreamSize: r.uint32,
                    compositeStreamSize: r.uint32,
                    bboxStreamSize: r.uint32,
                    instructionStreamSize: r.uint32,
                    nContours: new Substream("nContourStreamSize"),
                    nPoints: new Substream("nPointsStreamSize"),
                    flags: new Substream("flagStreamSize"),
                    glyphs: new Substream("glyphStreamSize"),
                    composites: new Substream("compositeStreamSize"),
                    bboxes: new Substream("bboxStreamSize"),
                    instructions: new Substream("instructionStreamSize")
                });
                var WORD_CODE = 253;
                var ONE_MORE_BYTE_CODE2 = 254;
                var ONE_MORE_BYTE_CODE1 = 255;
                var LOWEST_U_CODE = 253;
                function read255UInt16(stream) {
                    var code = stream.readUInt8();
                    if (code === WORD_CODE) return stream.readUInt16BE();
                    if (code === ONE_MORE_BYTE_CODE1) return stream.readUInt8() + LOWEST_U_CODE;
                    if (code === ONE_MORE_BYTE_CODE2) return stream.readUInt8() + LOWEST_U_CODE * 2;
                    return code;
                }
                function withSign(flag, baseval) {
                    return flag & 1 ? baseval : -baseval;
                }
                function decodeTriplet(flags, glyphs, nPoints) {
                    var y;
                    var x = y = 0;
                    var res = [];
                    for(var i = 0; i < nPoints; i++){
                        var dx = 0, dy = 0;
                        var flag = flags.readUInt8();
                        var onCurve = !(flag >> 7);
                        flag &= 0x7f;
                        if (flag < 10) {
                            dx = 0;
                            dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
                        } else if (flag < 20) {
                            dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
                            dy = 0;
                        } else if (flag < 84) {
                            var b0 = flag - 20;
                            var b1 = glyphs.readUInt8();
                            dx = withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
                            dy = withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
                        } else if (flag < 120) {
                            var b0 = flag - 84;
                            dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
                            dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
                        } else if (flag < 124) {
                            var b1 = glyphs.readUInt8();
                            var b2 = glyphs.readUInt8();
                            dx = withSign(flag, (b1 << 4) + (b2 >> 4));
                            dy = withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
                        } else {
                            dx = withSign(flag, glyphs.readUInt16BE());
                            dy = withSign(flag >> 1, glyphs.readUInt16BE());
                        }
                        x += dx;
                        y += dy;
                        res.push(new Point(onCurve, false, x, y));
                    }
                    return res;
                }
                var TTCHeader = new r.VersionedStruct(r.uint32, {
                    0x00010000: {
                        numFonts: r.uint32,
                        offsets: new r.Array(r.uint32, "numFonts")
                    },
                    0x00020000: {
                        numFonts: r.uint32,
                        offsets: new r.Array(r.uint32, "numFonts"),
                        dsigTag: r.uint32,
                        dsigLength: r.uint32,
                        dsigOffset: r.uint32
                    }
                });
                var TrueTypeCollection = /*#__PURE__*/ function() {
                    TrueTypeCollection.probe = function probe(buffer) {
                        return buffer.toString("ascii", 0, 4) === "ttcf";
                    };
                    function TrueTypeCollection(stream) {
                        this.stream = stream;
                        if (stream.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
                        this.header = TTCHeader.decode(stream);
                    }
                    var _proto48 = TrueTypeCollection.prototype;
                    _proto48.getFont = function getFont(name) {
                        for(var _iterator79 = _createForOfIteratorHelperLoose(this.header.offsets), _step79; !(_step79 = _iterator79()).done;){
                            var offset = _step79.value;
                            var stream = new r.DecodeStream(this.stream.buffer);
                            stream.pos = offset;
                            var font = new TTFFont(stream);
                            if (font.postscriptName === name) return font;
                        }
                        return null;
                    };
                    _createClass(TrueTypeCollection, [
                        {
                            key: "fonts",
                            get: function get() {
                                var fonts = [];
                                for(var _iterator80 = _createForOfIteratorHelperLoose(this.header.offsets), _step80; !(_step80 = _iterator80()).done;){
                                    var offset = _step80.value;
                                    var stream = new r.DecodeStream(this.stream.buffer);
                                    stream.pos = offset;
                                    fonts.push(new TTFFont(stream));
                                }
                                return fonts;
                            }
                        }
                    ]);
                    return TrueTypeCollection;
                }();
                var DFontName = new r.String(r.uint8);
                var DFontData = new r.Struct({
                    len: r.uint32,
                    buf: new r.Buffer("len")
                });
                var Ref = new r.Struct({
                    id: r.uint16,
                    nameOffset: r.int16,
                    attr: r.uint8,
                    dataOffset: r.uint24,
                    handle: r.uint32
                });
                var Type = new r.Struct({
                    name: new r.String(4),
                    maxTypeIndex: r.uint16,
                    refList: new r.Pointer(r.uint16, new r.Array(Ref, function(t) {
                        return t.maxTypeIndex + 1;
                    }), {
                        type: "parent"
                    })
                });
                var TypeList = new r.Struct({
                    length: r.uint16,
                    types: new r.Array(Type, function(t) {
                        return t.length + 1;
                    })
                });
                var DFontMap = new r.Struct({
                    reserved: new r.Reserved(r.uint8, 24),
                    typeList: new r.Pointer(r.uint16, TypeList),
                    nameListOffset: new r.Pointer(r.uint16, "void")
                });
                var DFontHeader = new r.Struct({
                    dataOffset: r.uint32,
                    map: new r.Pointer(r.uint32, DFontMap),
                    dataLength: r.uint32,
                    mapLength: r.uint32
                });
                var DFont = /*#__PURE__*/ function() {
                    DFont.probe = function probe(buffer) {
                        var stream = new r.DecodeStream(buffer);
                        try {
                            var header = DFontHeader.decode(stream);
                        } catch (e) {
                            return false;
                        }
                        for(var _iterator81 = _createForOfIteratorHelperLoose(header.map.typeList.types), _step81; !(_step81 = _iterator81()).done;){
                            var type = _step81.value;
                            if (type.name === "sfnt") return true;
                        }
                        return false;
                    };
                    function DFont(stream) {
                        this.stream = stream;
                        this.header = DFontHeader.decode(this.stream);
                        for(var _iterator82 = _createForOfIteratorHelperLoose(this.header.map.typeList.types), _step82; !(_step82 = _iterator82()).done;){
                            var type = _step82.value;
                            for(var _iterator83 = _createForOfIteratorHelperLoose(type.refList), _step83; !(_step83 = _iterator83()).done;){
                                var ref = _step83.value;
                                if (ref.nameOffset >= 0) {
                                    this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                                    ref.name = DFontName.decode(this.stream);
                                } else ref.name = null;
                            }
                            if (type.name === "sfnt") this.sfnt = type;
                        }
                    }
                    var _proto49 = DFont.prototype;
                    _proto49.getFont = function getFont(name) {
                        if (!this.sfnt) return null;
                        for(var _iterator84 = _createForOfIteratorHelperLoose(this.sfnt.refList), _step84; !(_step84 = _iterator84()).done;){
                            var ref = _step84.value;
                            var pos = this.header.dataOffset + ref.dataOffset + 4;
                            var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                            var font = new TTFFont(stream);
                            if (font.postscriptName === name) return font;
                        }
                        return null;
                    };
                    _createClass(DFont, [
                        {
                            key: "fonts",
                            get: function get() {
                                var fonts = [];
                                for(var _iterator85 = _createForOfIteratorHelperLoose(this.sfnt.refList), _step85; !(_step85 = _iterator85()).done;){
                                    var ref = _step85.value;
                                    var pos = this.header.dataOffset + ref.dataOffset + 4;
                                    var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                                    fonts.push(new TTFFont(stream));
                                }
                                return fonts;
                            }
                        }
                    ]);
                    return DFont;
                }();
                fontkit.registerFormat(TTFFont);
                fontkit.registerFormat(WOFFFont);
                fontkit.registerFormat(WOFF2Font);
                fontkit.registerFormat(TrueTypeCollection);
                fontkit.registerFormat(DFont);
                module1.exports = fontkit;
            /***/ },
            /***/ 46982: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var UnicodeTrie = __webpack_require__(67827);
                var base64 = __webpack_require__(5155);
                var _require = __webpack_require__(71692), BK = _require.BK, CR = _require.CR, LF = _require.LF, NL = _require.NL, SG = _require.SG, WJ = _require.WJ, SP = _require.SP, ZWJ = _require.ZWJ, BA = _require.BA, HY = _require.HY, NS = _require.NS, AI = _require.AI, AL = _require.AL, CJ = _require.CJ, HL = _require.HL, RI = _require.RI, SA = _require.SA, XX = _require.XX;
                var _require2 = __webpack_require__(54069), DI_BRK = _require2.DI_BRK, IN_BRK = _require2.IN_BRK, CI_BRK = _require2.CI_BRK, CP_BRK = _require2.CP_BRK, PR_BRK = _require2.PR_BRK, pairTable = _require2.pairTable;
                var data = base64.toByteArray("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");
                var classTrie = new UnicodeTrie(data);
                var mapClass = function mapClass(c) {
                    switch(c){
                        case AI:
                            return AL;
                        case SA:
                        case SG:
                        case XX:
                            return AL;
                        case CJ:
                            return NS;
                        default:
                            return c;
                    }
                };
                var mapFirst = function mapFirst(c) {
                    switch(c){
                        case LF:
                        case NL:
                            return BK;
                        case SP:
                            return WJ;
                        default:
                            return c;
                    }
                };
                var Break = function Break(position, required) {
                    if (required === void 0) required = false;
                    this.position = position;
                    this.required = required;
                };
                var LineBreaker = /*#__PURE__*/ function() {
                    function LineBreaker(string) {
                        this.string = string;
                        this.pos = 0;
                        this.lastPos = 0;
                        this.curClass = null;
                        this.nextClass = null;
                        this.LB8a = false;
                        this.LB21a = false;
                        this.LB30a = 0;
                    }
                    var _proto = LineBreaker.prototype;
                    _proto.nextCodePoint = function nextCodePoint() {
                        var code = this.string.charCodeAt(this.pos++);
                        var next = this.string.charCodeAt(this.pos);
                        // If a surrogate pair
                        if (0xd800 <= code && code <= 0xdbff && 0xdc00 <= next && next <= 0xdfff) {
                            this.pos++;
                            return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
                        }
                        return code;
                    };
                    _proto.nextCharClass = function nextCharClass() {
                        return mapClass(classTrie.get(this.nextCodePoint()));
                    };
                    _proto.getSimpleBreak = function getSimpleBreak() {
                        // handle classes not handled by the pair table
                        switch(this.nextClass){
                            case SP:
                                return false;
                            case BK:
                            case LF:
                            case NL:
                                this.curClass = BK;
                                return false;
                            case CR:
                                this.curClass = CR;
                                return false;
                        }
                        return null;
                    };
                    _proto.getPairTableBreak = function getPairTableBreak(lastClass) {
                        // if not handled already, use the pair table
                        var shouldBreak = false;
                        switch(pairTable[this.curClass][this.nextClass]){
                            case DI_BRK:
                                // Direct break
                                shouldBreak = true;
                                break;
                            case IN_BRK:
                                // possible indirect break
                                shouldBreak = lastClass === SP;
                                break;
                            case CI_BRK:
                                shouldBreak = lastClass === SP;
                                if (!shouldBreak) {
                                    shouldBreak = false;
                                    return shouldBreak;
                                }
                                break;
                            case CP_BRK:
                                // prohibited for combining marks
                                if (lastClass !== SP) return shouldBreak;
                                break;
                            case PR_BRK:
                                break;
                        }
                        if (this.LB8a) shouldBreak = false;
                        // Rule LB21a
                        if (this.LB21a && (this.curClass === HY || this.curClass === BA)) {
                            shouldBreak = false;
                            this.LB21a = false;
                        } else this.LB21a = this.curClass === HL;
                        // Rule LB30a
                        if (this.curClass === RI) {
                            this.LB30a++;
                            if (this.LB30a == 2 && this.nextClass === RI) {
                                shouldBreak = true;
                                this.LB30a = 0;
                            }
                        } else this.LB30a = 0;
                        this.curClass = this.nextClass;
                        return shouldBreak;
                    };
                    _proto.nextBreak = function nextBreak() {
                        // get the first char if we're at the beginning of the string
                        if (this.curClass == null) {
                            var firstClass = this.nextCharClass();
                            this.curClass = mapFirst(firstClass);
                            this.nextClass = firstClass;
                            this.LB8a = firstClass === ZWJ;
                            this.LB30a = 0;
                        }
                        while(this.pos < this.string.length){
                            this.lastPos = this.pos;
                            var lastClass = this.nextClass;
                            this.nextClass = this.nextCharClass();
                            // explicit newline
                            if (this.curClass === BK || this.curClass === CR && this.nextClass !== LF) {
                                this.curClass = mapFirst(mapClass(this.nextClass));
                                return new Break(this.lastPos, true);
                            }
                            var shouldBreak = this.getSimpleBreak();
                            if (shouldBreak === null) shouldBreak = this.getPairTableBreak(lastClass);
                            // Rule LB8a
                            this.LB8a = this.nextClass === ZWJ;
                            if (shouldBreak) return new Break(this.lastPos);
                        }
                        if (this.lastPos < this.string.length) {
                            this.lastPos = this.string.length;
                            return new Break(this.string.length);
                        }
                        return null;
                    };
                    return LineBreaker;
                }();
                module1.exports = LineBreaker;
            /***/ },
            /***/ 42480: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 25832: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 69862: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 40964: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 14343: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var possibleNames = [
                    "BigInt64Array",
                    "BigUint64Array",
                    "Float32Array",
                    "Float64Array",
                    "Int16Array",
                    "Int32Array",
                    "Int8Array",
                    "Uint16Array",
                    "Uint32Array",
                    "Uint8Array",
                    "Uint8ClampedArray"
                ];
                var g = typeof globalThis === "undefined" ? __webpack_require__.g : globalThis;
                module1.exports = function availableTypedArrays() {
                    var out = [];
                    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === "function") out[out.length] = possibleNames[i];
                    return out;
                };
            /***/ },
            /***/ 51348: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var $c5L0i$base64js = __webpack_require__(5155);
                var $c5L0i$unicodetrie = __webpack_require__(67827);
                function $parcel$interopDefault(a) {
                    return a && a.__esModule ? a.default : a;
                }
                function $parcel$defineInteropFlag(a) {
                    Object.defineProperty(a, "__esModule", {
                        value: true,
                        configurable: true
                    });
                }
                function $parcel$export(e, n, v, s) {
                    Object.defineProperty(e, n, {
                        get: v,
                        set: s,
                        enumerable: true,
                        configurable: true
                    });
                }
                $parcel$defineInteropFlag(module1.exports);
                $parcel$export(module1.exports, "getCategory", ()=>$43d7963e56408b24$export$410364bbb673ddbc);
                $parcel$export(module1.exports, "getCombiningClass", ()=>$43d7963e56408b24$export$c03b919c6651ed55);
                $parcel$export(module1.exports, "getScript", ()=>$43d7963e56408b24$export$941569448d136665);
                $parcel$export(module1.exports, "getEastAsianWidth", ()=>$43d7963e56408b24$export$92f6187db8ca6d26);
                $parcel$export(module1.exports, "getNumericValue", ()=>$43d7963e56408b24$export$7d1258ebb7625a0d);
                $parcel$export(module1.exports, "isAlphabetic", ()=>$43d7963e56408b24$export$52c8ea63abd07594);
                $parcel$export(module1.exports, "isDigit", ()=>$43d7963e56408b24$export$727d9dbc4fbb948f);
                $parcel$export(module1.exports, "isPunctuation", ()=>$43d7963e56408b24$export$a5b49f4dc6a07d2c);
                $parcel$export(module1.exports, "isLowerCase", ()=>$43d7963e56408b24$export$7b6804e8df61fcf5);
                $parcel$export(module1.exports, "isUpperCase", ()=>$43d7963e56408b24$export$aebd617640818cda);
                $parcel$export(module1.exports, "isTitleCase", ()=>$43d7963e56408b24$export$de8b4ee23b2cf823);
                $parcel$export(module1.exports, "isWhiteSpace", ()=>$43d7963e56408b24$export$3c52dd84024ae72c);
                $parcel$export(module1.exports, "isBaseForm", ()=>$43d7963e56408b24$export$a11bdcffe109e74b);
                $parcel$export(module1.exports, "isMark", ()=>$43d7963e56408b24$export$e33ad6871e762338);
                $parcel$export(module1.exports, "default", ()=>$43d7963e56408b24$export$2e2bcd8739ae039);
                var $29668e65f2091c2c$exports = {};
                $29668e65f2091c2c$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
                const $43d7963e56408b24$var$trie = new ($parcel$interopDefault($c5L0i$unicodetrie))($parcel$interopDefault($c5L0i$base64js).toByteArray("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"));
                const $43d7963e56408b24$var$log2 = Math.log2 || ((n)=>Math.log(n) / Math.LN2);
                const $43d7963e56408b24$var$bits = (n)=>$43d7963e56408b24$var$log2(n) + 1 | 0;
                // compute the number of bits stored for each field
                const $43d7963e56408b24$var$CATEGORY_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).categories.length - 1);
                const $43d7963e56408b24$var$COMBINING_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).combiningClasses.length - 1);
                const $43d7963e56408b24$var$SCRIPT_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).scripts.length - 1);
                const $43d7963e56408b24$var$EAW_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).eaw.length - 1);
                const $43d7963e56408b24$var$NUMBER_BITS = 10;
                // compute shift and mask values for each field
                const $43d7963e56408b24$var$CATEGORY_SHIFT = $43d7963e56408b24$var$COMBINING_BITS + $43d7963e56408b24$var$SCRIPT_BITS + $43d7963e56408b24$var$EAW_BITS + $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$COMBINING_SHIFT = $43d7963e56408b24$var$SCRIPT_BITS + $43d7963e56408b24$var$EAW_BITS + $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$SCRIPT_SHIFT = $43d7963e56408b24$var$EAW_BITS + $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$EAW_SHIFT = $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$CATEGORY_MASK = (1 << $43d7963e56408b24$var$CATEGORY_BITS) - 1;
                const $43d7963e56408b24$var$COMBINING_MASK = (1 << $43d7963e56408b24$var$COMBINING_BITS) - 1;
                const $43d7963e56408b24$var$SCRIPT_MASK = (1 << $43d7963e56408b24$var$SCRIPT_BITS) - 1;
                const $43d7963e56408b24$var$EAW_MASK = (1 << $43d7963e56408b24$var$EAW_BITS) - 1;
                const $43d7963e56408b24$var$NUMBER_MASK = (1 << $43d7963e56408b24$var$NUMBER_BITS) - 1;
                function $43d7963e56408b24$export$410364bbb673ddbc(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).categories[val >> $43d7963e56408b24$var$CATEGORY_SHIFT & $43d7963e56408b24$var$CATEGORY_MASK];
                }
                function $43d7963e56408b24$export$c03b919c6651ed55(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).combiningClasses[val >> $43d7963e56408b24$var$COMBINING_SHIFT & $43d7963e56408b24$var$COMBINING_MASK];
                }
                function $43d7963e56408b24$export$941569448d136665(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).scripts[val >> $43d7963e56408b24$var$SCRIPT_SHIFT & $43d7963e56408b24$var$SCRIPT_MASK];
                }
                function $43d7963e56408b24$export$92f6187db8ca6d26(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).eaw[val >> $43d7963e56408b24$var$EAW_SHIFT & $43d7963e56408b24$var$EAW_MASK];
                }
                function $43d7963e56408b24$export$7d1258ebb7625a0d(codePoint) {
                    let val = $43d7963e56408b24$var$trie.get(codePoint);
                    let num = val & $43d7963e56408b24$var$NUMBER_MASK;
                    if (num === 0) return null;
                    else if (num <= 50) return num - 1;
                    else if (num < 0x1e0) {
                        const numerator = (num >> 4) - 12;
                        const denominator = (num & 0xf) + 1;
                        return numerator / denominator;
                    } else if (num < 0x300) {
                        val = (num >> 5) - 14;
                        let exp = (num & 0x1f) + 2;
                        while(exp > 0){
                            val *= 10;
                            exp--;
                        }
                        return val;
                    } else {
                        val = (num >> 2) - 0xbf;
                        let exp = (num & 3) + 1;
                        while(exp > 0){
                            val *= 60;
                            exp--;
                        }
                        return val;
                    }
                }
                function $43d7963e56408b24$export$52c8ea63abd07594(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Nl";
                }
                function $43d7963e56408b24$export$727d9dbc4fbb948f(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Nd";
                }
                function $43d7963e56408b24$export$a5b49f4dc6a07d2c(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Pc" || category === "Pd" || category === "Pe" || category === "Pf" || category === "Pi" || category === "Po" || category === "Ps";
                }
                function $43d7963e56408b24$export$7b6804e8df61fcf5(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Ll";
                }
                function $43d7963e56408b24$export$aebd617640818cda(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Lu";
                }
                function $43d7963e56408b24$export$de8b4ee23b2cf823(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Lt";
                }
                function $43d7963e56408b24$export$3c52dd84024ae72c(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Zs" || category === "Zl" || category === "Zp";
                }
                function $43d7963e56408b24$export$a11bdcffe109e74b(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Nd" || category === "No" || category === "Nl" || category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Me" || category === "Mc";
                }
                function $43d7963e56408b24$export$e33ad6871e762338(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Mn" || category === "Me" || category === "Mc";
                }
                var $43d7963e56408b24$export$2e2bcd8739ae039 = {
                    getCategory: $43d7963e56408b24$export$410364bbb673ddbc,
                    getCombiningClass: $43d7963e56408b24$export$c03b919c6651ed55,
                    getScript: $43d7963e56408b24$export$941569448d136665,
                    getEastAsianWidth: $43d7963e56408b24$export$92f6187db8ca6d26,
                    getNumericValue: $43d7963e56408b24$export$7d1258ebb7625a0d,
                    isAlphabetic: $43d7963e56408b24$export$52c8ea63abd07594,
                    isDigit: $43d7963e56408b24$export$727d9dbc4fbb948f,
                    isPunctuation: $43d7963e56408b24$export$a5b49f4dc6a07d2c,
                    isLowerCase: $43d7963e56408b24$export$7b6804e8df61fcf5,
                    isUpperCase: $43d7963e56408b24$export$aebd617640818cda,
                    isTitleCase: $43d7963e56408b24$export$de8b4ee23b2cf823,
                    isWhiteSpace: $43d7963e56408b24$export$3c52dd84024ae72c,
                    isBaseForm: $43d7963e56408b24$export$a11bdcffe109e74b,
                    isMark: $43d7963e56408b24$export$e33ad6871e762338
                };
            /***/ },
            /***/ 63480: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["8740","\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"],["8767","\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"],["87a1","\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"],["8840","\u31C0",4,"\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"],["88a1","\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","\u650A"],["8946","\u4E3D\u6EDD\u9D4E\u91DF"],["894c","\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"],["89a1","\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"],["89ab","\u918C\u78B8\u915E\u80BC"],["89b0","\u8D0B\u80F6\uD842\uDDE7"],["89b5","\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"],["89c1","\u6E9A\u823E\u7519"],["89c5","\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"],["8a40","\uD85F\uDD84\u5525"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"],["8a76","\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"],["8abb","\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"],["8b55","\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"],["8bde","\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"],["8c40","\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"],["8ca1","\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"],["8ca7","\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"],["8cc9","\u9868\u676B\u4276\u573D"],["8cce","\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"],["8ce6","\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"],["8da1","\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"],["8e40","\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"],["8ea1","\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"],["8f40","\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"],["8fa1","\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"],["9040","\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"],["91a1","\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"],["92a1","\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"],["9340","\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"],["9440","\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"],["94a1","\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"],["95a1","\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"],["9640","\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"],["96a1","\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"],["9740","\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"],["97a1","\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"],["98a1","\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"],["9940","\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"],["99a1","\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"],["9a40","\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"],["9aa1","\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"],["9ba1","\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"],["9c40","\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"],["9ca1","\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"],["9da1","\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"],["9ea1","\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"],["9ec5","\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"],["9ef5","\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"],["9f40","\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"],["9fa1","\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"],["9fae","\u9159\u9681\u915C"],["9fb2","\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"],["9fc9","\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"],["9fdb","\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"],["9fe7","\u6BFA\u8818\u7F78"],["9feb","\u5620\uD869\uDE4A\u8E77\u9F53"],["9ff0","\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"],["a040","\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","\u8A7E\uD849\uDD1B"],["a05b","\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"],["a063","\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"],["a073","\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"],["a0a1","\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"],["a0a6","\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"],["a0ae","\u77FE"],["a0b0","\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"],["a0d4","\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"],["a0e2","\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"],["a3c0","\u2400",31,"\u2421"],["c6a1","\u2460",9,"\u2474",9,"\u2170",9,"\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",23],["c740","\u3059",58,"\u30A1\u30A2\u30A3\u30A4"],["c7a1","\u30A5",81,"\u0410",5,"\u0401\u0416",4],["c840","\u041B",26,"\u0451\u0436",25,"\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"],["c8a1","\u9FB0\u5188\u9FB1\uD85D\uDE07"],["c8cd","\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"],["c8f5","\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"],["f9fe","\uFFED"],["fa40","\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"],["faa1","\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"],["fba1","\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"],["fc40","\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"],["fca1","\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"],["fd40","\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"],["fe40","\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"]]');
            /***/ },
            /***/ 13336: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["0","\\u0000",127,"\u20AC"],["8140","\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",5,"\u4E72\u4E74",9,"\u4E7F",6,"\u4E87\u4E8A"],["8180","\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",6,"\u4F0B\u4F0C\u4F12",4,"\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",4,"\u4F44\u4F45\u4F47",5,"\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"],["8240","\u4FA4\u4FAB\u4FAD\u4FB0",4,"\u4FB6",8,"\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",4,"\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",11],["8280","\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",10,"\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",4,"\u5056\u5057\u5058\u5059\u505B\u505D",7,"\u5066",5,"\u506D",8,"\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",20,"\u50A4\u50A6\u50AA\u50AB\u50AD",4,"\u50B3",6,"\u50BC"],["8340","\u50BD",17,"\u50D0",5,"\u50D7\u50D8\u50D9\u50DB",10,"\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",4,"\u50FC",9,"\u5108"],["8380","\u5109\u510A\u510C",5,"\u5113",13,"\u5122",28,"\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",4,"\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",4,"\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",5],["8440","\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",5,"\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",5,"\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"],["8480","\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",9,"\u527E\u5280\u5283",4,"\u5289",6,"\u5291\u5292\u5294",6,"\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",9,"\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",5,"\u52E0\u52E1\u52E2\u52E3\u52E5",10,"\u52F1",7,"\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"],["8540","\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",9,"\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"],["8580","\u5390",4,"\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",6,"\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",4,"\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",4,"\u5463\u5465\u5467\u5469",7,"\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"],["8640","\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",4,"\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",5,"\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",4,"\u5512\u5513\u5515",5,"\u551C\u551D\u551E\u551F\u5521\u5525\u5526"],["8680","\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",4,"\u5551\u5552\u5553\u5554\u5557",4,"\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",5,"\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",6,"\u55A8",8,"\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",4,"\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",4,"\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",4,"\u55FF\u5602\u5603\u5604\u5605"],["8740","\u5606\u5607\u560A\u560B\u560D\u5610",7,"\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",11,"\u564F",4,"\u5655\u5656\u565A\u565B\u565D",4],["8780","\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",7,"\u5687",6,"\u5690\u5691\u5692\u5694",14,"\u56A4",10,"\u56B0",6,"\u56B8\u56B9\u56BA\u56BB\u56BD",12,"\u56CB",8,"\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",5,"\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",6],["8840","\u5712",9,"\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",4,"\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",4,"\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"],["8880","\u5781\u5787\u5788\u5789\u578A\u578D",4,"\u5794",6,"\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",8,"\u57C4",6,"\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",7,"\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",4,"\u582B",4,"\u5831\u5832\u5833\u5834\u5836",7],["8940","\u583E",5,"\u5845",6,"\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",4,"\u585F",5,"\u5866",4,"\u586D",16,"\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"],["8980","\u588D",4,"\u5894",4,"\u589B\u589C\u589D\u58A0",7,"\u58AA",17,"\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",10,"\u58D2\u58D3\u58D4\u58D6",13,"\u58E5",5,"\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",7,"\u5903\u5905\u5906\u5908",4,"\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"],["8a40","\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",4,"\u5961\u5963\u5964\u5966",12,"\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"],["8a80","\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",5,"\u59BA\u59BC\u59BD\u59BF",6,"\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",4,"\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",11,"\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",6,"\u5A33\u5A35\u5A37",4,"\u5A3D\u5A3E\u5A3F\u5A41",4,"\u5A47\u5A48\u5A4B",9,"\u5A56\u5A57\u5A58\u5A59\u5A5B",5],["8b40","\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",8,"\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",17,"\u5A93",6,"\u5A9C",13,"\u5AAB\u5AAC"],["8b80","\u5AAD",4,"\u5AB4\u5AB6\u5AB7\u5AB9",4,"\u5ABF\u5AC0\u5AC3",5,"\u5ACA\u5ACB\u5ACD",4,"\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",4,"\u5AF2",22,"\u5B0A",11,"\u5B18",25,"\u5B33\u5B35\u5B36\u5B38",7,"\u5B41",6],["8c40","\u5B48",7,"\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"],["8c80","\u5BD1\u5BD4",8,"\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",4,"\u5BEF\u5BF1",6,"\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",6,"\u5C70\u5C72",6,"\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",4,"\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",4,"\u5CA4",4],["8d40","\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",5,"\u5CCC",5,"\u5CD3",5,"\u5CDA",6,"\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",9,"\u5CFC",4],["8d80","\u5D01\u5D04\u5D05\u5D08",5,"\u5D0F",4,"\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",4,"\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",4,"\u5D35",7,"\u5D3F",7,"\u5D48\u5D49\u5D4D",10,"\u5D59\u5D5A\u5D5C\u5D5E",10,"\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",12,"\u5D83",21,"\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"],["8e40","\u5DA1",21,"\u5DB8",12,"\u5DC6",6,"\u5DCE",12,"\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"],["8e80","\u5DF0\u5DF5\u5DF6\u5DF8",4,"\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",7,"\u5E28",4,"\u5E2F\u5E30\u5E32",4,"\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",5,"\u5E4D",6,"\u5E56",4,"\u5E5C\u5E5D\u5E5F\u5E60\u5E63",14,"\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",4,"\u5EAE",4,"\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",6],["8f40","\u5EC6\u5EC7\u5EC8\u5ECB",5,"\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",11,"\u5EE9\u5EEB",8,"\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"],["8f80","\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",6,"\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",14,"\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",5,"\u5FA9\u5FAB\u5FAC\u5FAF",5,"\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",4,"\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"],["9040","\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",4,"\u6036",4,"\u603D\u603E\u6040\u6044",6,"\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"],["9080","\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",7,"\u60C7\u60C8\u60C9\u60CC",4,"\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",4,"\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",4,"\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",4,"\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",18,"\u6140",6],["9140","\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",6,"\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",6,"\u6171\u6172\u6173\u6174\u6176\u6178",18,"\u618C\u618D\u618F",4,"\u6195"],["9180","\u6196",6,"\u619E",8,"\u61AA\u61AB\u61AD",9,"\u61B8",5,"\u61BF\u61C0\u61C1\u61C3",4,"\u61C9\u61CC",4,"\u61D3\u61D5",16,"\u61E7",13,"\u61F6",8,"\u6200",5,"\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",4,"\u6242\u6244\u6245\u6246\u624A"],["9240","\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",6,"\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",5,"\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"],["9280","\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",5,"\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",7,"\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",6,"\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"],["9340","\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",6,"\u63DF\u63E2\u63E4",4,"\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",4,"\u640D\u640E\u6411\u6412\u6415",5,"\u641D\u641F\u6422\u6423\u6424"],["9380","\u6425\u6427\u6428\u6429\u642B\u642E",5,"\u6435",4,"\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",6,"\u6453\u6455\u6456\u6457\u6459",4,"\u645F",7,"\u6468\u646A\u646B\u646C\u646E",9,"\u647B",6,"\u6483\u6486\u6488",8,"\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",4,"\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",6,"\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"],["9440","\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",24,"\u6501",7,"\u650A",7,"\u6513",4,"\u6519",8],["9480","\u6522\u6523\u6524\u6526",4,"\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",4,"\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",14,"\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",7,"\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",7,"\u65E1\u65E3\u65E4\u65EA\u65EB"],["9540","\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",4,"\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",4,"\u663D\u663F\u6640\u6642\u6644",6,"\u664D\u664E\u6650\u6651\u6658"],["9580","\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",4,"\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",4,"\u669E",8,"\u66A9",4,"\u66AF",4,"\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",25,"\u66DA\u66DE",7,"\u66E7\u66E8\u66EA",5,"\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"],["9640","\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",5,"\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",4,"\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"],["9680","\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",7,"\u67C2\u67C5",9,"\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",7,"\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",4,"\u681E\u681F\u6820\u6822",6,"\u682B",6,"\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",5],["9740","\u685C\u685D\u685E\u685F\u686A\u686C",7,"\u6875\u6878",8,"\u6882\u6884\u6887",7,"\u6890\u6891\u6892\u6894\u6895\u6896\u6898",9,"\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"],["9780","\u68B9",6,"\u68C1\u68C3",5,"\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",4,"\u68E1\u68E2\u68E4",9,"\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",4,"\u690C\u690F\u6911\u6913",11,"\u6921\u6922\u6923\u6925",7,"\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",16,"\u6955\u6956\u6958\u6959\u695B\u695C\u695F"],["9840","\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",4,"\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",5,"\u6996\u6997\u6999\u699A\u699D",9,"\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"],["9880","\u69BE\u69BF\u69C0\u69C2",7,"\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",5,"\u69DC\u69DD\u69DE\u69E1",11,"\u69EE\u69EF\u69F0\u69F1\u69F3",9,"\u69FE\u6A00",9,"\u6A0B",11,"\u6A19",5,"\u6A20\u6A22",5,"\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",6,"\u6A3F",4,"\u6A45\u6A46\u6A48",7,"\u6A51",6,"\u6A5A"],["9940","\u6A5C",4,"\u6A62\u6A63\u6A64\u6A66",10,"\u6A72",6,"\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",8,"\u6A8F\u6A92",4,"\u6A98",7,"\u6AA1",5],["9980","\u6AA7\u6AA8\u6AAA\u6AAD",114,"\u6B25\u6B26\u6B28",6],["9a40","\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",11,"\u6B5A",7,"\u6B68\u6B69\u6B6B",13,"\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"],["9a80","\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",4,"\u6BA2",7,"\u6BAB",7,"\u6BB6\u6BB8",6,"\u6BC0\u6BC3\u6BC4\u6BC6",4,"\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",4,"\u6BE2",7,"\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",6,"\u6C08",4,"\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",4,"\u6C51\u6C52\u6C53\u6C56\u6C58"],["9b40","\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",4,"\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"],["9b80","\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",5,"\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",4,"\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",4,"\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",5,"\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"],["9c40","\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",7,"\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"],["9c80","\u6E36\u6E37\u6E39\u6E3B",7,"\u6E45",7,"\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",10,"\u6E6C\u6E6D\u6E6F",14,"\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",4,"\u6E91",6,"\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",5],["9d40","\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",7,"\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",4,"\u6F10\u6F11\u6F12\u6F16",9,"\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",6,"\u6F3F\u6F40\u6F41\u6F42"],["9d80","\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",9,"\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",5,"\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",6,"\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",12,"\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",4,"\u6FA8",10,"\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",5,"\u6FC1\u6FC3",5,"\u6FCA",6,"\u6FD3",10,"\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"],["9e40","\u6FE6",7,"\u6FF0",32,"\u7012",7,"\u701C",6,"\u7024",6],["9e80","\u702B",9,"\u7036\u7037\u7038\u703A",17,"\u704D\u704E\u7050",13,"\u705F",11,"\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",12,"\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",12,"\u70DA"],["9f40","\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",6,"\u70F8\u70FA\u70FB\u70FC\u70FE",10,"\u710B",4,"\u7111\u7112\u7114\u7117\u711B",10,"\u7127",7,"\u7132\u7133\u7134"],["9f80","\u7135\u7137",13,"\u7146\u7147\u7148\u7149\u714B\u714D\u714F",12,"\u715D\u715F",4,"\u7165\u7169",4,"\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",5,"\u7185",4,"\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",4,"\u71A1",6,"\u71A9\u71AA\u71AB\u71AD",5,"\u71B4\u71B6\u71B7\u71B8\u71BA",8,"\u71C4",9,"\u71CF",4],["a040","\u71D6",9,"\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",5,"\u71EF",9,"\u71FA",11,"\u7207",19],["a080","\u721B\u721C\u721E",9,"\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",6,"\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",4,"\u728C\u728E\u7290\u7291\u7293",11,"\u72A0",11,"\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",6,"\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"],["a1a1","\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",7,"\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"],["a2a1","\u2170",9],["a2b1","\u2488",19,"\u2474",19,"\u2460",9],["a2e5","\u3220",9],["a2f1","\u2160",11],["a3a1","\uFF01\uFF02\uFF03\uFFE5\uFF05",88,"\uFFE3"],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a6e0","\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"],["a6ee","\uFE3B\uFE3C\uFE37\uFE38\uFE31"],["a6f4","\uFE33\uFE34"],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a840","\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",35,"\u2581",6],["a880","\u2588",7,"\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"],["a8a1","\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"],["a8bd","\u0144\u0148"],["a8c0","\u0261"],["a8c5","\u3105",36],["a940","\u3021",8,"\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"],["a959","\u2121\u3231"],["a95c","\u2010"],["a960","\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",9,"\uFE54\uFE55\uFE56\uFE57\uFE59",8],["a980","\uFE62",4,"\uFE68\uFE69\uFE6A\uFE6B"],["a996","\u3007"],["a9a4","\u2500",75],["aa40","\u72DC\u72DD\u72DF\u72E2",5,"\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",5,"\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",8],["aa80","\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",7,"\u7361",10,"\u736E\u7370\u7371"],["ab40","\u7372",11,"\u737F",4,"\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",5,"\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",4],["ab80","\u73CB\u73CC\u73CE\u73D2",6,"\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",4],["ac40","\u73F8",10,"\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",8,"\u741C",5,"\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",4,"\u743D\u743E\u743F\u7440\u7442",11],["ac80","\u744E",6,"\u7456\u7458\u745D\u7460",12,"\u746E\u746F\u7471",4,"\u7478\u7479\u747A"],["ad40","\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",10,"\u749D\u749F",7,"\u74AA",15,"\u74BB",12],["ad80","\u74C8",9,"\u74D3",8,"\u74DD\u74DF\u74E1\u74E5\u74E7",6,"\u74F0\u74F1\u74F2"],["ae40","\u74F3\u74F5\u74F8",6,"\u7500\u7501\u7502\u7503\u7505",7,"\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",4,"\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"],["ae80","\u755D",7,"\u7567\u7568\u7569\u756B",6,"\u7573\u7575\u7576\u7577\u757A",4,"\u7580\u7581\u7582\u7584\u7585\u7587"],["af40","\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",4,"\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"],["af80","\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"],["b040","\u7645",6,"\u764E",5,"\u7655\u7657",4,"\u765D\u765F\u7660\u7661\u7662\u7664",6,"\u766C\u766D\u766E\u7670",7,"\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"],["b080","\u769C",7,"\u76A5",8,"\u76AF\u76B0\u76B3\u76B5",9,"\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"],["b140","\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",4,"\u76E6",7,"\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",10,"\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"],["b180","\u772C\u772E\u7730",4,"\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",7,"\u7752",7,"\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"],["b240","\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",11,"\u777A\u777B\u777C\u7781\u7782\u7783\u7786",5,"\u778F\u7790\u7793",11,"\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",4],["b280","\u77BC\u77BE\u77C0",12,"\u77CE",8,"\u77D8\u77D9\u77DA\u77DD",4,"\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"],["b340","\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",5,"\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"],["b380","\u785B\u785C\u785E",11,"\u786F",7,"\u7878\u7879\u787A\u787B\u787D",6,"\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"],["b440","\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",7,"\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",9],["b480","\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",4,"\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",5,"\u7902\u7903\u7904\u7906",6,"\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"],["b540","\u790D",5,"\u7914",9,"\u791F",4,"\u7925",14,"\u7935",4,"\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",8,"\u7954\u7955\u7958\u7959\u7961\u7963"],["b580","\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",6,"\u7979\u797B",4,"\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"],["b640","\u7993",6,"\u799B",11,"\u79A8",10,"\u79B4",4,"\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",5,"\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"],["b680","\u79EC\u79EE\u79F1",6,"\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",4,"\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"],["b740","\u7A1D\u7A1F\u7A21\u7A22\u7A24",14,"\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",5,"\u7A47",9,"\u7A52",4,"\u7A58",16],["b780","\u7A69",6,"\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"],["b840","\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",4,"\u7AB4",10,"\u7AC0",10,"\u7ACC",9,"\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",5,"\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"],["b880","\u7AF4",4,"\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"],["b940","\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",5,"\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",10,"\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",6,"\u7B8E\u7B8F"],["b980","\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",7,"\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"],["ba40","\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",4,"\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",4,"\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",7,"\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",5,"\u7C17\u7C18\u7C19"],["ba80","\u7C1A",4,"\u7C20",5,"\u7C28\u7C29\u7C2B",12,"\u7C39",5,"\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"],["bb40","\u7C43",9,"\u7C4E",36,"\u7C75",5,"\u7C7E",9],["bb80","\u7C88\u7C8A",6,"\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",4,"\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"],["bc40","\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",6,"\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",6,"\u7CE9",5,"\u7CF0",7,"\u7CF9\u7CFA\u7CFC",13,"\u7D0B",5],["bc80","\u7D11",14,"\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",6,"\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"],["bd40","\u7D37",54,"\u7D6F",7],["bd80","\u7D78",32,"\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"],["be40","\u7D99",12,"\u7DA7",6,"\u7DAF",42],["be80","\u7DDA",32,"\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"],["bf40","\u7DFB",62],["bf80","\u7E3A\u7E3C",4,"\u7E42",4,"\u7E48",21,"\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"],["c040","\u7E5E",35,"\u7E83",23,"\u7E9C\u7E9D\u7E9E"],["c080","\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",6,"\u7F43\u7F46",9,"\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"],["c140","\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",4,"\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",7,"\u7F8B\u7F8D\u7F8F",4,"\u7F95",4,"\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",6,"\u7FB1"],["c180","\u7FB3",4,"\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",4,"\u7FD6\u7FD7\u7FD9",5,"\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"],["c240","\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",6,"\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",5,"\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"],["c280","\u8059\u805B",13,"\u806B",5,"\u8072",11,"\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"],["c340","\u807E\u8081\u8082\u8085\u8088\u808A\u808D",5,"\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",4,"\u80CF",6,"\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"],["c380","\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",12,"\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",4,"\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"],["c440","\u8140",5,"\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",4,"\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",4,"\u8189\u818B\u818C\u818D\u818E\u8190\u8192",5,"\u8199\u819A\u819E",4,"\u81A4\u81A5"],["c480","\u81A7\u81A9\u81AB",7,"\u81B4",5,"\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",6,"\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"],["c540","\u81D4",14,"\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",4,"\u81F5",5,"\u81FD\u81FF\u8203\u8207",4,"\u820E\u820F\u8211\u8213\u8215",5,"\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"],["c580","\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",7,"\u8259\u825B\u825C\u825D\u825E\u8260",7,"\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"],["c640","\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"],["c680","\u82FA\u82FC",4,"\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",9,"\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"],["c740","\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",4,"\u8353\u8355",4,"\u835D\u8362\u8370",6,"\u8379\u837A\u837E",6,"\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",6,"\u83AC\u83AD\u83AE"],["c780","\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"],["c840","\u83EE\u83EF\u83F3",4,"\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",5,"\u8419\u841A\u841B\u841E",5,"\u8429",7,"\u8432",5,"\u8439\u843A\u843B\u843E",7,"\u8447\u8448\u8449"],["c880","\u844A",6,"\u8452",4,"\u8458\u845D\u845E\u845F\u8460\u8462\u8464",4,"\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"],["c940","\u847D",4,"\u8483\u8484\u8485\u8486\u848A\u848D\u848F",7,"\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",12,"\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"],["c980","\u84D8",4,"\u84DE\u84E1\u84E2\u84E4\u84E7",4,"\u84ED\u84EE\u84EF\u84F1",10,"\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"],["ca40","\u8503",8,"\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",8,"\u852D",9,"\u853E",4,"\u8544\u8545\u8546\u8547\u854B",10],["ca80","\u8557\u8558\u855A\u855B\u855C\u855D\u855F",4,"\u8565\u8566\u8567\u8569",8,"\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"],["cb40","\u8582\u8583\u8586\u8588",6,"\u8590",10,"\u859D",6,"\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",5,"\u85B8\u85BA",6,"\u85C2",6,"\u85CA",4,"\u85D1\u85D2"],["cb80","\u85D4\u85D6",5,"\u85DD",6,"\u85E5\u85E6\u85E7\u85E8\u85EA",14,"\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"],["cc40","\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",4,"\u8606",10,"\u8612\u8613\u8614\u8615\u8617",15,"\u8628\u862A",13,"\u8639\u863A\u863B\u863D\u863E\u863F\u8640"],["cc80","\u8641",11,"\u8652\u8653\u8655",4,"\u865B\u865C\u865D\u865F\u8660\u8661\u8663",7,"\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"],["cd40","\u866D\u866F\u8670\u8672",6,"\u8683",6,"\u868E",4,"\u8694\u8696",5,"\u869E",4,"\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",4,"\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"],["cd80","\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"],["ce40","\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",6,"\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",5,"\u8761\u8762\u8766",7,"\u876F\u8771\u8772\u8773\u8775"],["ce80","\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",4,"\u8794\u8795\u8796\u8798",6,"\u87A0",4,"\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"],["cf40","\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",4,"\u87C7\u87C8\u87C9\u87CC",4,"\u87D4",6,"\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",9],["cf80","\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",5,"\u880B",7,"\u8814\u8817\u8818\u8819\u881A\u881C",4,"\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"],["d040","\u8824",13,"\u8833",5,"\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",5,"\u884E",5,"\u8855\u8856\u8858\u885A",6,"\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"],["d080","\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",4,"\u889D",4,"\u88A3\u88A5",5,"\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"],["d140","\u88AC\u88AE\u88AF\u88B0\u88B2",4,"\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",4,"\u88E0\u88E1\u88E6\u88E7\u88E9",6,"\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",5],["d180","\u8909\u890B",4,"\u8911\u8914",4,"\u891C",4,"\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"],["d240","\u8938",8,"\u8942\u8943\u8945",24,"\u8960",5,"\u8967",19,"\u897C"],["d280","\u897D\u897E\u8980\u8982\u8984\u8985\u8987",26,"\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"],["d340","\u89A2",30,"\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",6],["d380","\u89FB",4,"\u8A01",5,"\u8A08",21,"\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"],["d440","\u8A1E",31,"\u8A3F",8,"\u8A49",21],["d480","\u8A5F",25,"\u8A7A",6,"\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"],["d540","\u8A81",7,"\u8A8B",7,"\u8A94",46],["d580","\u8AC3",32,"\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"],["d640","\u8AE4",34,"\u8B08",27],["d680","\u8B24\u8B25\u8B27",30,"\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"],["d740","\u8B46",31,"\u8B67",4,"\u8B6D",25],["d780","\u8B87",24,"\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"],["d840","\u8C38",8,"\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",7,"\u8C56\u8C57\u8C58\u8C59\u8C5B",5,"\u8C63",6,"\u8C6C",6,"\u8C74\u8C75\u8C76\u8C77\u8C7B",6,"\u8C83\u8C84\u8C86\u8C87"],["d880","\u8C88\u8C8B\u8C8D",6,"\u8C95\u8C96\u8C97\u8C99",20,"\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"],["d940","\u8CAE",62],["d980","\u8CED",32,"\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"],["da40","\u8D0E",14,"\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",8,"\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",4,"\u8D92\u8D93\u8D95",9,"\u8DA0\u8DA1"],["da80","\u8DA2\u8DA4",12,"\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"],["db40","\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",6,"\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",7,"\u8E20\u8E21\u8E24",4,"\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"],["db80","\u8E3F\u8E43\u8E45\u8E46\u8E4C",4,"\u8E53",5,"\u8E5A",11,"\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"],["dc40","\u8E73\u8E75\u8E77",4,"\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",6,"\u8E91\u8E92\u8E93\u8E95",6,"\u8E9D\u8E9F",11,"\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",6,"\u8EBB",7],["dc80","\u8EC3",10,"\u8ECF",21,"\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"],["dd40","\u8EE5",62],["dd80","\u8F24",32,"\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"],["de40","\u8F45",32,"\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"],["de80","\u8FC9",4,"\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"],["df40","\u9019\u901C\u9023\u9024\u9025\u9027",5,"\u9030",4,"\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",4,"\u904E\u9054\u9055\u9056\u9059\u905A\u905C",5,"\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",4,"\u9076",6,"\u907E\u9081"],["df80","\u9084\u9085\u9086\u9087\u9089\u908A\u908C",4,"\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"],["e040","\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",19,"\u911A\u911B\u911C"],["e080","\u911D\u911F\u9120\u9121\u9124",10,"\u9130\u9132",6,"\u913A",8,"\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"],["e140","\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",4,"\u9186\u9188\u918A\u918E\u918F\u9193",6,"\u919C",5,"\u91A4",5,"\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"],["e180","\u91BC",10,"\u91C8\u91CB\u91D0\u91D2",9,"\u91DD",8,"\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"],["e240","\u91E6",62],["e280","\u9225",32,"\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",5,"\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"],["e340","\u9246",45,"\u9275",16],["e380","\u9286",7,"\u928F",24,"\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"],["e440","\u92A8",5,"\u92AF",24,"\u92C9",31],["e480","\u92E9",32,"\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"],["e540","\u930A",51,"\u933F",10],["e580","\u934A",31,"\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"],["e640","\u936C",34,"\u9390",27],["e680","\u93AC",29,"\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"],["e740","\u93CE",7,"\u93D7",54],["e780","\u940E",32,"\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",6,"\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",4,"\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"],["e840","\u942F",14,"\u943F",43,"\u946C\u946D\u946E\u946F"],["e880","\u9470",20,"\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"],["e940","\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",7,"\u9580",42],["e980","\u95AB",32,"\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"],["ea40","\u95CC",27,"\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",6,"\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"],["ea80","\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",4,"\u9673\u9678",12,"\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"],["eb40","\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",9,"\u96A8",7,"\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",9,"\u96E1",6,"\u96EB"],["eb80","\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",4,"\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"],["ec40","\u9721",8,"\u972B\u972C\u972E\u972F\u9731\u9733",4,"\u973A\u973B\u973C\u973D\u973F",18,"\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",7],["ec80","\u9772\u9775\u9777",4,"\u977D",7,"\u9786",4,"\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",4,"\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"],["ed40","\u979E\u979F\u97A1\u97A2\u97A4",6,"\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",46],["ed80","\u97E4\u97E5\u97E8\u97EE",4,"\u97F4\u97F7",23,"\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"],["ee40","\u980F",62],["ee80","\u984E",32,"\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",4,"\u94BC\u94BD\u94BF\u94C4\u94C8",6,"\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"],["ef40","\u986F",5,"\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",37,"\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",4],["ef80","\u98E5\u98E6\u98E9",30,"\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",4,"\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",8,"\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"],["f040","\u9908",4,"\u990E\u990F\u9911",28,"\u992F",26],["f080","\u994A",9,"\u9956",12,"\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",4,"\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",6,"\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"],["f140","\u998C\u998E\u999A",10,"\u99A6\u99A7\u99A9",47],["f180","\u99D9",32,"\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"],["f240","\u99FA",62],["f280","\u9A39",32,"\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"],["f340","\u9A5A",17,"\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",6,"\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",4,"\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"],["f380","\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",8,"\u9AFA\u9AFC",6,"\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"],["f440","\u9B07\u9B09",5,"\u9B10\u9B11\u9B12\u9B14",10,"\u9B20\u9B21\u9B22\u9B24",10,"\u9B30\u9B31\u9B33",7,"\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",5],["f480","\u9B5B",32,"\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"],["f540","\u9B7C",62],["f580","\u9BBB",32,"\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"],["f640","\u9BDC",62],["f680","\u9C1B",32,"\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",5,"\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",5,"\u9CA5",4,"\u9CAB\u9CAD\u9CAE\u9CB0",7,"\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"],["f740","\u9C3C",62],["f780","\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",4,"\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",4,"\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"],["f840","\u9CE3",62],["f880","\u9D22",32],["f940","\u9D43",62],["f980","\u9D82",32],["fa40","\u9DA3",62],["fa80","\u9DE2",32],["fb40","\u9E03",27,"\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",9,"\u9E80"],["fb80","\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",5,"\u9E94",8,"\u9E9E\u9EA0",5,"\u9EA7\u9EA8\u9EA9\u9EAA"],["fc40","\u9EAB",8,"\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",4,"\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",8,"\u9EFA\u9EFD\u9EFF",6],["fc80","\u9F06",4,"\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",5,"\u9F21\u9F23",8,"\u9F2D\u9F2E\u9F30\u9F31"],["fd40","\u9F32",4,"\u9F38\u9F3A\u9F3C\u9F3F",4,"\u9F45",10,"\u9F52",38],["fd80","\u9F79",5,"\u9F81\u9F82\u9F8D",11,"\u9F9C\u9F9D\u9F9E\u9FA1",4,"\uF92C\uF979\uF995\uF9E7\uF9F1"],["fe40","\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"]]');
            /***/ },
            /***/ 77348: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["0","\\u0000",127],["8141","\uAC02\uAC03\uAC05\uAC06\uAC0B",4,"\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",6,"\uAC2E\uAC32\uAC33\uAC34"],["8161","\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",9,"\uAC4C\uAC4E",5,"\uAC55"],["8181","\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",18,"\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",4,"\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",6,"\uAC9E\uACA2",5,"\uACAB\uACAD\uACAE\uACB1",6,"\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",7,"\uACD6\uACD8",7,"\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",4,"\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",4,"\uAD0E\uAD10\uAD12\uAD13"],["8241","\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",7,"\uAD2A\uAD2B\uAD2E",5],["8261","\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",6,"\uAD46\uAD48\uAD4A",5,"\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"],["8281","\uAD59",7,"\uAD62\uAD64",7,"\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",4,"\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",10,"\uAD9E",5,"\uADA5",17,"\uADB8",7,"\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",6,"\uADD2\uADD4",7,"\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",18],["8341","\uADFA\uADFB\uADFD\uADFE\uAE02",5,"\uAE0A\uAE0C\uAE0E",5,"\uAE15",7],["8361","\uAE1D",18,"\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"],["8381","\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",4,"\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",6,"\uAE7A\uAE7E",5,"\uAE86",5,"\uAE8D",46,"\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",6,"\uAECE\uAED2",5,"\uAEDA\uAEDB\uAEDD",8],["8441","\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",5,"\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",8],["8461","\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",18],["8481","\uAF24",7,"\uAF2E\uAF2F\uAF31\uAF33\uAF35",6,"\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",5,"\uAF51",10,"\uAF5E",5,"\uAF66",18,"\uAF7A",5,"\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",6,"\uAF92\uAF93\uAF94\uAF96",5,"\uAF9D",26,"\uAFBA\uAFBB\uAFBD\uAFBE"],["8541","\uAFBF\uAFC1",5,"\uAFCA\uAFCC\uAFCF",4,"\uAFD5",6,"\uAFDD",4],["8561","\uAFE2",5,"\uAFEA",5,"\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",6,"\uB002\uB003"],["8581","\uB005",6,"\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",6,"\uB01E",9,"\uB029",26,"\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",29,"\uB07E\uB07F\uB081\uB082\uB083\uB085",6,"\uB08E\uB090\uB092",5,"\uB09B\uB09D\uB09E\uB0A3\uB0A4"],["8641","\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",6,"\uB0C6\uB0CA",5,"\uB0D2"],["8661","\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",6,"\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",10],["8681","\uB0F1",22,"\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",4,"\uB126\uB127\uB129\uB12A\uB12B\uB12D",6,"\uB136\uB13A",5,"\uB142\uB143\uB145\uB146\uB147\uB149",6,"\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",22,"\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",4,"\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"],["8741","\uB19E",9,"\uB1A9",15],["8761","\uB1B9",18,"\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"],["8781","\uB1D6",5,"\uB1DE\uB1E0",7,"\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",7,"\uB1FA\uB1FC\uB1FE",5,"\uB206\uB207\uB209\uB20A\uB20D",6,"\uB216\uB218\uB21A",5,"\uB221",18,"\uB235",6,"\uB23D",26,"\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",6,"\uB26A",4],["8841","\uB26F",4,"\uB276",5,"\uB27D",6,"\uB286\uB287\uB288\uB28A",4],["8861","\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",4,"\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"],["8881","\uB2B8",15,"\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",4,"\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",6,"\uB312\uB316",5,"\uB31D",54,"\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"],["8941","\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",6,"\uB382\uB386",5,"\uB38D"],["8961","\uB38E\uB38F\uB391\uB392\uB393\uB395",10,"\uB3A2",5,"\uB3A9\uB3AA\uB3AB\uB3AD"],["8981","\uB3AE",21,"\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",18,"\uB3FD",18,"\uB411",6,"\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",6,"\uB42A\uB42C",7,"\uB435",15],["8a41","\uB445",10,"\uB452\uB453\uB455\uB456\uB457\uB459",6,"\uB462\uB464\uB466"],["8a61","\uB467",4,"\uB46D",18,"\uB481\uB482"],["8a81","\uB483",4,"\uB489",19,"\uB49E",5,"\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",7,"\uB4B6\uB4B8\uB4BA",5,"\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",6,"\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",5,"\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",4,"\uB4EE\uB4F0\uB4F2",5,"\uB4F9",26,"\uB516\uB517\uB519\uB51A\uB51D"],["8b41","\uB51E",5,"\uB526\uB52B",4,"\uB532\uB533\uB535\uB536\uB537\uB539",6,"\uB542\uB546"],["8b61","\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",6,"\uB55E\uB562",8],["8b81","\uB56B",52,"\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",4,"\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",6,"\uB5CE\uB5D2",5,"\uB5D9",18,"\uB5ED",18],["8c41","\uB600",15,"\uB612\uB613\uB615\uB616\uB617\uB619",4],["8c61","\uB61E",6,"\uB626",5,"\uB62D",6,"\uB635",5],["8c81","\uB63B",12,"\uB649",26,"\uB665\uB666\uB667\uB669",50,"\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",5,"\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",16],["8d41","\uB6C3",16,"\uB6D5",8],["8d61","\uB6DE",17,"\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"],["8d81","\uB6FB",4,"\uB702\uB703\uB704\uB706",33,"\uB72A\uB72B\uB72D\uB72E\uB731",6,"\uB73A\uB73C",7,"\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",6,"\uB756",9,"\uB761\uB762\uB763\uB765\uB766\uB767\uB769",6,"\uB772\uB774\uB776",5,"\uB77E\uB77F\uB781\uB782\uB783\uB785",6,"\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"],["8e41","\uB79F\uB7A1",6,"\uB7AA\uB7AE",5,"\uB7B6\uB7B7\uB7B9",8],["8e61","\uB7C2",4,"\uB7C8\uB7CA",19],["8e81","\uB7DE",13,"\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",6,"\uB7FE\uB802",4,"\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",6,"\uB81A\uB81C\uB81E",5,"\uB826\uB827\uB829\uB82A\uB82B\uB82D",6,"\uB836\uB83A",5,"\uB841\uB842\uB843\uB845",11,"\uB852\uB854",7,"\uB85E\uB85F\uB861\uB862\uB863\uB865",6,"\uB86E\uB870\uB872",5,"\uB879\uB87A\uB87B\uB87D",7],["8f41","\uB885",7,"\uB88E",17],["8f61","\uB8A0",7,"\uB8A9",6,"\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",4],["8f81","\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",5,"\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",7,"\uB8DE\uB8E0\uB8E2",5,"\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",6,"\uB8FA\uB8FC\uB8FE",5,"\uB905",18,"\uB919",6,"\uB921",26,"\uB93E\uB93F\uB941\uB942\uB943\uB945",6,"\uB94D\uB94E\uB950\uB952",5],["9041","\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",6,"\uB96A\uB96C\uB96E",5,"\uB976\uB977\uB979\uB97A\uB97B\uB97D"],["9061","\uB97E",5,"\uB986\uB988\uB98B\uB98C\uB98F",15],["9081","\uB99F",12,"\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",6,"\uB9BE\uB9C0\uB9C2",5,"\uB9CA\uB9CB\uB9CD\uB9D3",4,"\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",6,"\uB9F6\uB9FB",4,"\uBA02",5,"\uBA09",11,"\uBA16",33,"\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"],["9141","\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",6,"\uBA66\uBA6A",5],["9161","\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",9,"\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",5],["9181","\uBA93",20,"\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",4,"\uBABA\uBABC\uBABE",5,"\uBAC5\uBAC6\uBAC7\uBAC9",14,"\uBADA",33,"\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",7,"\uBB0E\uBB10\uBB12",5,"\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",6],["9241","\uBB28\uBB2A\uBB2C",7,"\uBB37\uBB39\uBB3A\uBB3F",4,"\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"],["9261","\uBB53\uBB55\uBB56\uBB57\uBB59",7,"\uBB62\uBB64",7,"\uBB6D",4],["9281","\uBB72",21,"\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",18,"\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",6,"\uBBB5\uBBB6\uBBB8",7,"\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",6,"\uBBD1\uBBD2\uBBD4",35,"\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"],["9341","\uBC03",4,"\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"],["9361","\uBC36\uBC37\uBC39",6,"\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",8],["9381","\uBC5A\uBC5B\uBC5C\uBC5E",37,"\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",4,"\uBC96\uBC98\uBC9B",4,"\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",6,"\uBCB2\uBCB6",5,"\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",7,"\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",22,"\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"],["9441","\uBCFE",5,"\uBD06\uBD08\uBD0A",5,"\uBD11\uBD12\uBD13\uBD15",8],["9461","\uBD1E",5,"\uBD25",6,"\uBD2D",12],["9481","\uBD3A",5,"\uBD41",6,"\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",6,"\uBD5A",9,"\uBD65\uBD66\uBD67\uBD69",22,"\uBD82\uBD83\uBD85\uBD86\uBD8B",4,"\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",6,"\uBDA5",10,"\uBDB1",6,"\uBDB9",24],["9541","\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",11,"\uBDEA",5,"\uBDF1"],["9561","\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",6,"\uBE01\uBE02\uBE04\uBE06",5,"\uBE0E\uBE0F\uBE11\uBE12\uBE13"],["9581","\uBE15",6,"\uBE1E\uBE20",35,"\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",4,"\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",4,"\uBE72\uBE76",4,"\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",6,"\uBE8E\uBE92",5,"\uBE9A",13,"\uBEA9",14],["9641","\uBEB8",23,"\uBED2\uBED3"],["9661","\uBED5\uBED6\uBED9",6,"\uBEE1\uBEE2\uBEE6",5,"\uBEED",8],["9681","\uBEF6",10,"\uBF02",5,"\uBF0A",13,"\uBF1A\uBF1E",33,"\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",6,"\uBF52\uBF53\uBF54\uBF56",44],["9741","\uBF83",16,"\uBF95",8],["9761","\uBF9E",17,"\uBFB1",7],["9781","\uBFB9",11,"\uBFC6",5,"\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",6,"\uBFDD\uBFDE\uBFE0\uBFE2",89,"\uC03D\uC03E\uC03F"],["9841","\uC040",16,"\uC052",5,"\uC059\uC05A\uC05B"],["9861","\uC05D\uC05E\uC05F\uC061",6,"\uC06A",15],["9881","\uC07A",21,"\uC092\uC093\uC095\uC096\uC097\uC099",6,"\uC0A2\uC0A4\uC0A6",5,"\uC0AE\uC0B1\uC0B2\uC0B7",4,"\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",6,"\uC0DA\uC0DE",5,"\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",6,"\uC0F6\uC0F8\uC0FA",5,"\uC101\uC102\uC103\uC105\uC106\uC107\uC109",6,"\uC111\uC112\uC113\uC114\uC116",5,"\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"],["9941","\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",6,"\uC14A\uC14E",5,"\uC156\uC157"],["9961","\uC159\uC15A\uC15B\uC15D",6,"\uC166\uC16A",5,"\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"],["9981","\uC17C",8,"\uC186",5,"\uC18F\uC191\uC192\uC193\uC195\uC197",4,"\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",11,"\uC1BE",5,"\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",6,"\uC1D5\uC1D6\uC1D9",6,"\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",6,"\uC1F2\uC1F4",7,"\uC1FE\uC1FF\uC201\uC202\uC203\uC205",6,"\uC20E\uC210\uC212",5,"\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"],["9a41","\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",16],["9a61","\uC246\uC247\uC249",6,"\uC252\uC253\uC255\uC256\uC257\uC259",6,"\uC261\uC262\uC263\uC264\uC266"],["9a81","\uC267",4,"\uC26E\uC26F\uC271\uC272\uC273\uC275",6,"\uC27E\uC280\uC282",5,"\uC28A",5,"\uC291",6,"\uC299\uC29A\uC29C\uC29E",5,"\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",5,"\uC2B6\uC2B8\uC2BA",33,"\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",5,"\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",6,"\uC30A\uC30B\uC30E\uC30F"],["9b41","\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",6,"\uC326\uC327\uC32A",8],["9b61","\uC333",17,"\uC346",7],["9b81","\uC34E",25,"\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",4,"\uC37A\uC37B\uC37E",5,"\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",50,"\uC3C1",22,"\uC3DA"],["9c41","\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",4,"\uC3EA\uC3EB\uC3EC\uC3EE",5,"\uC3F6\uC3F7\uC3F9",5],["9c61","\uC3FF",8,"\uC409",6,"\uC411",9],["9c81","\uC41B",8,"\uC425",6,"\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",6,"\uC43E",9,"\uC449",26,"\uC466\uC467\uC469\uC46A\uC46B\uC46D",6,"\uC476\uC477\uC478\uC47A",5,"\uC481",18,"\uC495",6,"\uC49D",12],["9d41","\uC4AA",13,"\uC4B9\uC4BA\uC4BB\uC4BD",8],["9d61","\uC4C6",25],["9d81","\uC4E0",8,"\uC4EA",5,"\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",9,"\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",6,"\uC51D",10,"\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",6,"\uC53A\uC53C\uC53E",5,"\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",6,"\uC572\uC576",5,"\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"],["9e41","\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",7,"\uC5AA",9,"\uC5B6"],["9e61","\uC5B7\uC5BA\uC5BF",4,"\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",6,"\uC5E2\uC5E4\uC5E6\uC5E7"],["9e81","\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",6,"\uC61A\uC61D",6,"\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",6,"\uC652\uC656",5,"\uC65E\uC65F\uC661",10,"\uC66D\uC66E\uC670\uC672",5,"\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",6,"\uC68A\uC68C\uC68E",5,"\uC696\uC697\uC699\uC69A\uC69B\uC69D",6,"\uC6A6"],["9f41","\uC6A8\uC6AA",5,"\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",4,"\uC6C2\uC6C4\uC6C6",5,"\uC6CE"],["9f61","\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",6,"\uC6DE\uC6DF\uC6E2",5,"\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"],["9f81","\uC6F3",4,"\uC6FA\uC6FB\uC6FC\uC6FE",5,"\uC706\uC707\uC709\uC70A\uC70B\uC70D",6,"\uC716\uC718\uC71A",5,"\uC722\uC723\uC725\uC726\uC727\uC729",6,"\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",4,"\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",6,"\uC769\uC76A\uC76C",7,"\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",4,"\uC7A2\uC7A7",4,"\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"],["a041","\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",5,"\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",6,"\uC7D9\uC7DA\uC7DB\uC7DC"],["a061","\uC7DE",5,"\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",13],["a081","\uC7FB",4,"\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",4,"\uC812\uC814\uC817",4,"\uC81E\uC81F\uC821\uC822\uC823\uC825",6,"\uC82E\uC830\uC832",5,"\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",6,"\uC84A\uC84B\uC84E",5,"\uC855",26,"\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",4,"\uC882\uC884\uC888\uC889\uC88A\uC88E",5,"\uC895",7,"\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"],["a141","\uC8A5\uC8A6\uC8A7\uC8A9",18,"\uC8BE\uC8BF\uC8C0\uC8C1"],["a161","\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",6,"\uC8D6\uC8D8\uC8DA",5,"\uC8E2\uC8E3\uC8E5"],["a181","\uC8E6",14,"\uC8F6",5,"\uC8FE\uC8FF\uC901\uC902\uC903\uC907",4,"\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",9,"\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"],["a241","\uC910\uC912",5,"\uC919",18],["a261","\uC92D",6,"\uC935",18],["a281","\uC948",7,"\uC952\uC953\uC955\uC956\uC957\uC959",6,"\uC962\uC964",7,"\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"],["a341","\uC971\uC972\uC973\uC975",6,"\uC97D",10,"\uC98A\uC98B\uC98D\uC98E\uC98F"],["a361","\uC991",6,"\uC99A\uC99C\uC99E",16],["a381","\uC9AF",16,"\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",4,"\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",58,"\uFFE6\uFF3D",32,"\uFFE3"],["a441","\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",5,"\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"],["a461","\uCA05\uCA06\uCA07\uCA0A\uCA0E",5,"\uCA15\uCA16\uCA17\uCA19",12],["a481","\uCA26\uCA27\uCA28\uCA2A",28,"\u3131",93],["a541","\uCA47",4,"\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",6,"\uCA5E\uCA62",5,"\uCA69\uCA6A"],["a561","\uCA6B",17,"\uCA7E",5,"\uCA85\uCA86"],["a581","\uCA87",16,"\uCA99",14,"\u2170",9],["a5b0","\u2160",9],["a5c1","\u0391",16,"\u03A3",6],["a5e1","\u03B1",16,"\u03C3",6],["a641","\uCAA8",19,"\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"],["a661","\uCAC6",5,"\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",5,"\uCAE1",6],["a681","\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",6,"\uCAF5",18,"\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",7],["a741","\uCB0B",4,"\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",6,"\uCB22",7],["a761","\uCB2A",22,"\uCB42\uCB43\uCB44"],["a781","\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",6,"\uCB5A\uCB5B\uCB5C\uCB5E",5,"\uCB65",7,"\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",9,"\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",9,"\u3380",4,"\u33BA",5,"\u3390",4,"\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"],["a841","\uCB6D",10,"\uCB7A",14],["a861","\uCB89",18,"\uCB9D",6],["a881","\uCBA4",19,"\uCBB9",11,"\xc6\xd0\xaa\u0126"],["a8a6","\u0132"],["a8a8","\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"],["a8b1","\u3260",27,"\u24D0",25,"\u2460",14,"\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"],["a941","\uCBC5",14,"\uCBD5",10],["a961","\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",18],["a981","\uCBFD",14,"\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",6,"\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",27,"\u249C",25,"\u2474",14,"\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"],["aa41","\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",6,"\uCC3A\uCC3F",4,"\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"],["aa61","\uCC4F",4,"\uCC56\uCC5A",5,"\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",6,"\uCC71\uCC72"],["aa81","\uCC73\uCC74\uCC76",29,"\u3041",82],["ab41","\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",6,"\uCCAA\uCCAE",5,"\uCCB6\uCCB7\uCCB9"],["ab61","\uCCBA\uCCBB\uCCBD",6,"\uCCC6\uCCC8\uCCCA",5,"\uCCD1\uCCD2\uCCD3\uCCD5",5],["ab81","\uCCDB",8,"\uCCE5",6,"\uCCED\uCCEE\uCCEF\uCCF1",12,"\u30A1",85],["ac41","\uCCFE\uCCFF\uCD00\uCD02",5,"\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",6,"\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"],["ac61","\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",11,"\uCD3A",4],["ac81","\uCD3F",28,"\uCD5D\uCD5E\uCD5F\u0410",5,"\u0401\u0416",25],["acd1","\u0430",5,"\u0451\u0436",25],["ad41","\uCD61\uCD62\uCD63\uCD65",6,"\uCD6E\uCD70\uCD72",5,"\uCD79",7],["ad61","\uCD81",6,"\uCD89",10,"\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"],["ad81","\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",5,"\uCDB1",18,"\uCDC5"],["ae41","\uCDC6",5,"\uCDCD\uCDCE\uCDCF\uCDD1",16],["ae61","\uCDE2",5,"\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",6,"\uCDFA\uCDFC\uCDFE",4],["ae81","\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",6,"\uCE15\uCE16\uCE17\uCE18\uCE1A",5,"\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"],["af41","\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",19],["af61","\uCE4A",13,"\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",5,"\uCE6A\uCE6C"],["af81","\uCE6E",5,"\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",6,"\uCE86\uCE88\uCE8A",5,"\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"],["b041","\uCE9A",5,"\uCEA2\uCEA6",5,"\uCEAE",12],["b061","\uCEBB",5,"\uCEC2",19],["b081","\uCED6",13,"\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",6,"\uCEF6\uCEFA",5,"\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",7,"\uAC19",4,"\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"],["b141","\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",6,"\uCF12\uCF14\uCF16",5,"\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"],["b161","\uCF25",6,"\uCF2E\uCF32",5,"\uCF39",11],["b181","\uCF45",14,"\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",6,"\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"],["b241","\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",6,"\uCF81\uCF82\uCF83\uCF84\uCF86",5,"\uCF8D"],["b261","\uCF8E",18,"\uCFA2",5,"\uCFA9"],["b281","\uCFAA",5,"\uCFB1",18,"\uCFC5",6,"\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"],["b341","\uCFCC",19,"\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"],["b361","\uCFEA",5,"\uCFF2\uCFF4\uCFF6",5,"\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",5],["b381","\uD00B",5,"\uD012",5,"\uD019",19,"\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",4,"\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"],["b441","\uD02E",5,"\uD036\uD037\uD039\uD03A\uD03B\uD03D",6,"\uD046\uD048\uD04A",5],["b461","\uD051\uD052\uD053\uD055\uD056\uD057\uD059",6,"\uD061",10,"\uD06E\uD06F"],["b481","\uD071\uD072\uD073\uD075",6,"\uD07E\uD07F\uD080\uD082",18,"\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",4,"\uB2F3\uB2F4\uB2F5\uB2F7",4,"\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"],["b541","\uD095",14,"\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",5],["b561","\uD0B3\uD0B6\uD0B8\uD0BA",5,"\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",5,"\uD0D2\uD0D6",4],["b581","\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",6,"\uD0EE\uD0F2",5,"\uD0F9",11,"\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"],["b641","\uD105",7,"\uD10E",17],["b661","\uD120",15,"\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"],["b681","\uD13F\uD142\uD146",5,"\uD14E\uD14F\uD151\uD152\uD153\uD155",6,"\uD15E\uD160\uD162",5,"\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"],["b741","\uD16E",13,"\uD17D",6,"\uD185\uD186\uD187\uD189\uD18A"],["b761","\uD18B",20,"\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"],["b781","\uD1A9",6,"\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",14,"\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"],["b841","\uD1D0",7,"\uD1D9",17],["b861","\uD1EB",8,"\uD1F5\uD1F6\uD1F7\uD1F9",13],["b881","\uD208\uD20A",5,"\uD211",24,"\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",4,"\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"],["b941","\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",6,"\uD23E\uD240\uD242",5,"\uD249\uD24A\uD24B\uD24C"],["b961","\uD24D",14,"\uD25D",6,"\uD265\uD266\uD267\uD268"],["b981","\uD269",22,"\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",4,"\uBC1B",4,"\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"],["ba41","\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",5,"\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",6,"\uD2AD"],["ba61","\uD2AE\uD2AF\uD2B0\uD2B2",5,"\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",4,"\uD2CA\uD2CC",5],["ba81","\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",6,"\uD2E6",9,"\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"],["bb41","\uD2FB",4,"\uD302\uD304\uD306",5,"\uD30F\uD311\uD312\uD313\uD315\uD317",4,"\uD31E\uD322\uD323"],["bb61","\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",6,"\uD33A\uD33E",5,"\uD346\uD347\uD348\uD349"],["bb81","\uD34A",31,"\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"],["bc41","\uD36A",17,"\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"],["bc61","\uD388\uD389\uD38A\uD38B\uD38E\uD392",5,"\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",6,"\uD3AA\uD3AC\uD3AE"],["bc81","\uD3AF",4,"\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",6,"\uD3C6\uD3C7\uD3CA",5,"\uD3D1",5,"\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",4,"\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"],["bd41","\uD3D7\uD3D9",7,"\uD3E2\uD3E4",7,"\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"],["bd61","\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",5,"\uD409",13],["bd81","\uD417",5,"\uD41E",25,"\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"],["be41","\uD438",7,"\uD441\uD442\uD443\uD445",14],["be61","\uD454",7,"\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",7,"\uD46E\uD470\uD471\uD472"],["be81","\uD473",4,"\uD47A\uD47B\uD47D\uD47E\uD481\uD483",4,"\uD48A\uD48C\uD48E",5,"\uD495",8,"\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",6,"\uC5CC\uC5CE"],["bf41","\uD49E",10,"\uD4AA",14],["bf61","\uD4B9",18,"\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"],["bf81","\uD4D6",5,"\uD4DD\uD4DE\uD4E0",7,"\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",6,"\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",5,"\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"],["c041","\uD4FE",5,"\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",6,"\uD516\uD518",5],["c061","\uD51E",25],["c081","\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",6,"\uD54E\uD550\uD552",5,"\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",7,"\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"],["c141","\uD564\uD566\uD567\uD56A\uD56C\uD56E",5,"\uD576\uD577\uD579\uD57A\uD57B\uD57D",6,"\uD586\uD58A\uD58B"],["c161","\uD58C\uD58D\uD58E\uD58F\uD591",19,"\uD5A6\uD5A7"],["c181","\uD5A8",31,"\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"],["c241","\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",4,"\uD5DA\uD5DC\uD5DE",5,"\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"],["c261","\uD5EF",4,"\uD5F6\uD5F8\uD5FA",5,"\uD602\uD603\uD605\uD606\uD607\uD609",6,"\uD612"],["c281","\uD616",5,"\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",7,"\uD62E",9,"\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"],["c341","\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",4],["c361","\uD662",4,"\uD668\uD66A",5,"\uD672\uD673\uD675",11],["c381","\uD681\uD682\uD684\uD686",5,"\uD68E\uD68F\uD691\uD692\uD693\uD695",7,"\uD69E\uD6A0\uD6A2",5,"\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"],["c441","\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",7,"\uD6BA\uD6BC",7,"\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"],["c461","\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",5,"\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",4],["c481","\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",5,"\uD6FE\uD6FF\uD701\uD702\uD703\uD705",11,"\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"],["c541","\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",6,"\uD72A\uD72C\uD72E",5,"\uD736\uD737\uD739"],["c561","\uD73A\uD73B\uD73D",6,"\uD745\uD746\uD748\uD74A",5,"\uD752\uD753\uD755\uD75A",4],["c581","\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",6,"\uD77E\uD77F\uD780\uD782",5,"\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"],["c641","\uD78D\uD78E\uD78F\uD791",6,"\uD79A\uD79C\uD79E",5],["c6a1","\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"],["c7a1","\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"],["c8a1","\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"],["caa1","\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"],["cba1","\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"],["cca1","\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"],["cda1","\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"],["cea1","\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"],["cfa1","\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"],["d0a1","\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"],["d1a1","\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",5,"\u90A3\uF914",4,"\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"],["d2a1","\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",4,"\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",5,"\u99D1\uF939",10,"\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",7,"\u5AE9\u8A25\u677B\u7D10\uF952",5,"\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"],["d3a1","\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"],["d4a1","\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"],["d5a1","\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"],["d6a1","\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"],["d7a1","\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"],["d8a1","\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"],["d9a1","\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"],["daa1","\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"],["dba1","\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"],["dca1","\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"],["dda1","\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"],["dea1","\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"],["dfa1","\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"],["e0a1","\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"],["e1a1","\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"],["e2a1","\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"],["e3a1","\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"],["e4a1","\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"],["e5a1","\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"],["e6a1","\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"],["e7a1","\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"],["e8a1","\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"],["e9a1","\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"],["eaa1","\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"],["eba1","\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"],["eca1","\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"],["eda1","\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"],["eea1","\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"],["efa1","\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"],["f0a1","\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"],["f1a1","\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"],["f2a1","\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"],["f3a1","\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"],["f4a1","\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"],["f5a1","\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"],["f6a1","\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"],["f7a1","\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"],["f8a1","\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"],["f9a1","\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"],["faa1","\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"],["fba1","\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"],["fca1","\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"],["fda1","\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"]]');
            /***/ },
            /***/ 74284: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["0","\\u0000",127],["a140","\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"],["a1a1","\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",4,"\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"],["a240","\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",7,"\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"],["a2a1","\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",9,"\u2160",9,"\u3021",8,"\u5341\u5344\u5345\uFF21",25,"\uFF41",21],["a340","\uFF57\uFF58\uFF59\uFF5A\u0391",16,"\u03A3",6,"\u03B1",16,"\u03C3",6,"\u3105",10],["a3a1","\u3110",25,"\u02D9\u02C9\u02CA\u02C7\u02CB"],["a3e1","\u20AC"],["a440","\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"],["a4a1","\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"],["a540","\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"],["a5a1","\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"],["a640","\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"],["a6a1","\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"],["a740","\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"],["a7a1","\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"],["a840","\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"],["a8a1","\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"],["a940","\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"],["a9a1","\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"],["aa40","\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"],["aaa1","\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"],["ab40","\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"],["aba1","\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"],["ac40","\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"],["aca1","\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"],["ad40","\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"],["ada1","\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"],["ae40","\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"],["aea1","\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"],["af40","\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"],["afa1","\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"],["b040","\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"],["b0a1","\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"],["b140","\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"],["b1a1","\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"],["b240","\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"],["b2a1","\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"],["b340","\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"],["b3a1","\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"],["b440","\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"],["b4a1","\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"],["b540","\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"],["b5a1","\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"],["b640","\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"],["b6a1","\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"],["b740","\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"],["b7a1","\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"],["b840","\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"],["b8a1","\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"],["b940","\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"],["b9a1","\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"],["ba40","\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"],["baa1","\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"],["bb40","\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"],["bba1","\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"],["bc40","\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"],["bca1","\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"],["bd40","\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"],["bda1","\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"],["be40","\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"],["bea1","\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"],["bf40","\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"],["bfa1","\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"],["c040","\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"],["c0a1","\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"],["c140","\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"],["c1a1","\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"],["c240","\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"],["c2a1","\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"],["c340","\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"],["c3a1","\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"],["c440","\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"],["c4a1","\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"],["c540","\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"],["c5a1","\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"],["c640","\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"],["c940","\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"],["c9a1","\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"],["ca40","\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"],["caa1","\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"],["cb40","\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"],["cba1","\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"],["cc40","\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"],["cca1","\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"],["cd40","\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"],["cda1","\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"],["ce40","\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"],["cea1","\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"],["cf40","\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"],["cfa1","\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"],["d040","\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"],["d0a1","\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"],["d140","\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"],["d1a1","\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"],["d240","\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"],["d2a1","\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"],["d340","\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"],["d3a1","\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"],["d440","\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"],["d4a1","\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"],["d540","\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"],["d5a1","\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"],["d640","\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"],["d6a1","\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"],["d740","\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"],["d7a1","\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"],["d840","\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"],["d8a1","\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"],["d940","\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"],["d9a1","\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"],["da40","\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"],["daa1","\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"],["db40","\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"],["dba1","\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"],["dc40","\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"],["dca1","\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"],["dd40","\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"],["dda1","\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"],["de40","\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"],["dea1","\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"],["df40","\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"],["dfa1","\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"],["e040","\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"],["e0a1","\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"],["e140","\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"],["e1a1","\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"],["e240","\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"],["e2a1","\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"],["e340","\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"],["e3a1","\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"],["e440","\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"],["e4a1","\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"],["e540","\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"],["e5a1","\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"],["e640","\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"],["e6a1","\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"],["e740","\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"],["e7a1","\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"],["e840","\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"],["e8a1","\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"],["e940","\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"],["e9a1","\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"],["ea40","\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"],["eaa1","\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"],["eb40","\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"],["eba1","\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"],["ec40","\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"],["eca1","\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"],["ed40","\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"],["eda1","\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"],["ee40","\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"],["eea1","\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"],["ef40","\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"],["efa1","\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"],["f040","\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"],["f0a1","\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"],["f140","\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"],["f1a1","\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"],["f240","\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"],["f2a1","\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"],["f340","\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"],["f3a1","\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"],["f440","\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"],["f4a1","\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"],["f540","\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"],["f5a1","\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"],["f640","\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"],["f6a1","\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"],["f740","\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"],["f7a1","\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"],["f840","\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"],["f8a1","\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"],["f940","\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"],["f9a1","\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"]]');
            /***/ },
            /***/ 31532: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["0","\\u0000",127],["8ea1","\uFF61",62],["a1a1","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"],["a2a1","\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["a2ba","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["a2ca","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["a2dc","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["a2f2","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["a2fe","\u25EF"],["a3b0","\uFF10",9],["a3c1","\uFF21",25],["a3e1","\uFF41",25],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a8a1","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["ada1","\u2460",19,"\u2160",9],["adc0","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["addf","\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["b0a1","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["b1a1","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"],["b2a1","\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["b3a1","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"],["b4a1","\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["b5a1","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"],["b6a1","\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["b7a1","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"],["b8a1","\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["b9a1","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"],["baa1","\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["bba1","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"],["bca1","\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["bda1","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"],["bea1","\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["bfa1","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"],["c0a1","\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["c1a1","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"],["c2a1","\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["c3a1","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"],["c4a1","\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["c5a1","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"],["c6a1","\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["c7a1","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"],["c8a1","\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["c9a1","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"],["caa1","\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["cba1","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"],["cca1","\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["cda1","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"],["cea1","\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["cfa1","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["d0a1","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["d1a1","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"],["d2a1","\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["d3a1","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"],["d4a1","\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["d5a1","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"],["d6a1","\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["d7a1","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"],["d8a1","\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["d9a1","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"],["daa1","\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["dba1","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"],["dca1","\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["dda1","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"],["dea1","\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["dfa1","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"],["e0a1","\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e1a1","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"],["e2a1","\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e3a1","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"],["e4a1","\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e5a1","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"],["e6a1","\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e7a1","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"],["e8a1","\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e9a1","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"],["eaa1","\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["eba1","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"],["eca1","\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["eda1","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"],["eea1","\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["efa1","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"],["f0a1","\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["f1a1","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"],["f2a1","\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["f3a1","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"],["f4a1","\u582F\u69C7\u9059\u7464\u51DC\u7199"],["f9a1","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"],["faa1","\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["fba1","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"],["fca1","\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["fcf1","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["8fa2af","\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae\u2122\xa4\u2116"],["8fa6e1","\u0386\u0388\u0389\u038A\u03AA"],["8fa6e7","\u038C"],["8fa6e9","\u038E\u03AB"],["8fa6ec","\u038F"],["8fa6f1","\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"],["8fa7c2","\u0402",10,"\u040E\u040F"],["8fa7f2","\u0452",10,"\u045E\u045F"],["8fa9a1","\xc6\u0110"],["8fa9a4","\u0126"],["8fa9a6","\u0132"],["8fa9a8","\u0141\u013F"],["8fa9ab","\u014A\xd8\u0152"],["8fa9af","\u0166\xde"],["8fa9c1","\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"],["8faaa1","\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"],["8faaba","\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"],["8faba1","\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"],["8fabbd","\u0121\u0125\xed\xec\xef\xee\u01D0"],["8fabc5","\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"],["8fb0a1","\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"],["8fb1a1","\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"],["8fb2a1","\u5092\u5093\u5094\u5096\u509B\u509C\u509E",4,"\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"],["8fb3a1","\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"],["8fb4a1","\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"],["8fb5a1","\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"],["8fb6a1","\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",5,"\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",4,"\u56F1\u56EB\u56ED"],["8fb7a1","\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",4,"\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"],["8fb8a1","\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"],["8fb9a1","\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"],["8fbaa1","\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",4,"\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"],["8fbba1","\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"],["8fbca1","\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",4,"\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"],["8fbda1","\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",4,"\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"],["8fbea1","\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",4,"\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"],["8fbfa1","\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"],["8fc0a1","\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"],["8fc1a1","\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"],["8fc2a1","\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"],["8fc3a1","\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",4,"\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"],["8fc4a1","\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"],["8fc5a1","\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"],["8fc6a1","\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"],["8fc7a1","\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"],["8fc8a1","\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"],["8fc9a1","\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",4,"\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",4,"\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"],["8fcaa1","\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"],["8fcba1","\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"],["8fcca1","\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",9,"\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"],["8fcda1","\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",5,"\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"],["8fcea1","\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",6,"\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"],["8fcfa1","\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"],["8fd0a1","\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"],["8fd1a1","\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"],["8fd2a1","\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",5],["8fd3a1","\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"],["8fd4a1","\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",4,"\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"],["8fd5a1","\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"],["8fd6a1","\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"],["8fd7a1","\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"],["8fd8a1","\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"],["8fd9a1","\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",4,"\u8556\u8559\u855C",6,"\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"],["8fdaa1","\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",4,"\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"],["8fdba1","\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",6,"\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"],["8fdca1","\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",4,"\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"],["8fdda1","\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",4,"\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"],["8fdea1","\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",4,"\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"],["8fdfa1","\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"],["8fe0a1","\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"],["8fe1a1","\u8F43\u8F47\u8F4F\u8F51",4,"\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"],["8fe2a1","\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"],["8fe3a1","\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",5,"\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",4,"\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"],["8fe4a1","\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",4,"\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"],["8fe5a1","\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",4,"\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"],["8fe6a1","\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"],["8fe7a1","\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"],["8fe8a1","\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",4,"\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"],["8fe9a1","\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",4],["8feaa1","\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",4,"\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"],["8feba1","\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",4,"\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"],["8feca1","\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"],["8feda1","\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",4,"\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",4,"\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"]]');
            /***/ },
            /***/ 36258: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('{"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}');
            /***/ },
            /***/ 44346: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["a140","\uE4C6",62],["a180","\uE505",32],["a240","\uE526",62],["a280","\uE565",32],["a2ab","\uE766",5],["a2e3","\u20AC\uE76D"],["a2ef","\uE76E\uE76F"],["a2fd","\uE770\uE771"],["a340","\uE586",62],["a380","\uE5C5",31,"\u3000"],["a440","\uE5E6",62],["a480","\uE625",32],["a4f4","\uE772",10],["a540","\uE646",62],["a580","\uE685",32],["a5f7","\uE77D",7],["a640","\uE6A6",62],["a680","\uE6E5",32],["a6b9","\uE785",7],["a6d9","\uE78D",6],["a6ec","\uE794\uE795"],["a6f3","\uE796"],["a6f6","\uE797",8],["a740","\uE706",62],["a780","\uE745",32],["a7c2","\uE7A0",14],["a7f2","\uE7AF",12],["a896","\uE7BC",10],["a8bc","\u1E3F"],["a8bf","\u01F9"],["a8c1","\uE7C9\uE7CA\uE7CB\uE7CC"],["a8ea","\uE7CD",20],["a958","\uE7E2"],["a95b","\uE7E3"],["a95d","\uE7E4\uE7E5\uE7E6"],["a989","\u303E\u2FF0",11],["a997","\uE7F4",12],["a9f0","\uE801",14],["aaa1","\uE000",93],["aba1","\uE05E",93],["aca1","\uE0BC",93],["ada1","\uE11A",93],["aea1","\uE178",93],["afa1","\uE1D6",93],["d7fa","\uE810",4],["f8a1","\uE234",93],["f9a1","\uE292",93],["faa1","\uE2F0",93],["fba1","\uE34E",93],["fca1","\uE3AC",93],["fda1","\uE40A",93],["fe50","\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"],["fe80","\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",6,"\u4DAE\uE864\uE468",93],["8135f437","\uE7C7"]]');
            /***/ },
            /***/ 27014: /***/ function(module1) {
                "use strict";
                module1.exports = JSON.parse('[["0","\\u0000",128],["a1","\uFF61",62],["8140","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7"],["8180","\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["81b8","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["81c8","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["81da","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["81f0","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["81fc","\u25EF"],["824f","\uFF10",9],["8260","\uFF21",25],["8281","\uFF41",25],["829f","\u3041",82],["8340","\u30A1",62],["8380","\u30E0",22],["839f","\u0391",16,"\u03A3",6],["83bf","\u03B1",16,"\u03C3",6],["8440","\u0410",5,"\u0401\u0416",25],["8470","\u0430",5,"\u0451\u0436",7],["8480","\u043E",17],["849f","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["8740","\u2460",19,"\u2160",9],["875f","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["877e","\u337B"],["8780","\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["889f","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["8940","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"],["8980","\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["8a40","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"],["8a80","\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["8b40","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"],["8b80","\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["8c40","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"],["8c80","\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["8d40","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"],["8d80","\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["8e40","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"],["8e80","\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["8f40","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"],["8f80","\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["9040","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"],["9080","\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["9140","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"],["9180","\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["9240","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"],["9280","\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["9340","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"],["9380","\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["9440","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"],["9480","\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["9540","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"],["9580","\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["9640","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"],["9680","\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["9740","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"],["9780","\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["9840","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["989f","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["9940","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"],["9980","\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["9a40","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"],["9a80","\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["9b40","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"],["9b80","\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["9c40","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"],["9c80","\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["9d40","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"],["9d80","\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["9e40","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"],["9e80","\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["9f40","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"],["9f80","\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["e040","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"],["e080","\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e140","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"],["e180","\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e240","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"],["e280","\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e340","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"],["e380","\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e440","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"],["e480","\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e540","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"],["e580","\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["e640","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"],["e680","\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["e740","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"],["e780","\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["e840","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"],["e880","\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["e940","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"],["e980","\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["ea40","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"],["ea80","\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"],["ed40","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"],["ed80","\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["ee40","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"],["ee80","\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["eeef","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["f040","\uE000",62],["f080","\uE03F",124],["f140","\uE0BC",62],["f180","\uE0FB",124],["f240","\uE178",62],["f280","\uE1B7",124],["f340","\uE234",62],["f380","\uE273",124],["f440","\uE2F0",62],["f480","\uE32F",124],["f540","\uE3AC",62],["f580","\uE3EB",124],["f640","\uE468",62],["f680","\uE4A7",124],["f740","\uE524",62],["f780","\uE563",124],["f840","\uE5E0",62],["f880","\uE61F",124],["f940","\uE69C"],["fa40","\u2170",9,"\u2160",9,"\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"],["fa80","\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"],["fb40","\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"],["fb80","\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"],["fc40","\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"]]');
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/global */ /******/ !function() {
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === "object") return globalThis;
                /******/ try {
                    /******/ return this || new Function("return this")();
                /******/ } catch (e) {
                    /******/ if (typeof window === "object") return window;
                /******/ }
            /******/ }();
        /******/ }();
        /******/ /******/ /* webpack/runtime/node module decorator */ /******/ !function() {
            /******/ __webpack_require__.nmd = function(module1) {
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(26949);
        /******/ /******/ return __webpack_exports__;
    /******/ }();
});

});

parcelRegister("7RXGR", function(module, exports) {

$parcel$export(module.exports, "pdfMake", function () { return $5babc8dea5c157de$export$4456d4944e951582; }, function (v) { return $5babc8dea5c157de$export$4456d4944e951582 = v; });
var $5babc8dea5c157de$export$4456d4944e951582;
$5babc8dea5c157de$export$4456d4944e951582 = $5babc8dea5c157de$export$4456d4944e951582 || {};
$5babc8dea5c157de$export$4456d4944e951582.vfs = {
    "Roboto-Italic.ttf": "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",
    "Roboto-Medium.ttf": "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",
    "Roboto-MediumItalic.ttf": "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",
    "Roboto-Regular.ttf": "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"
};

});

parcelRegister("jYTVM", function(module, exports) {

module.exports = (parcelRequire("28PFx")).getBundleURL("4temp") + "logo_size.fc7c0ced.jpg";

});

parcelRegister("d9ASo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9938b880d9762b7c$export$2e2bcd8739ae039; });
/* eslint-disable react/jsx-no-useless-fragment */ 
var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $ekoiq = parcelRequire("ekoiq");
var $cWJc2 = parcelRequire("cWJc2");
var $6wnIC = parcelRequire("6wnIC");
var $lqAG1 = parcelRequire("lqAG1");

var $h2Xtr = parcelRequire("h2Xtr");
const $9938b880d9762b7c$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(8)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        add: {
            alignContent: "right"
        },
        spaceLine: {
            whiteSpace: "post-line"
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        }
    }));
const $9938b880d9762b7c$var$ARSFilter = (props)=>{
    const classes = $9938b880d9762b7c$var$useStyles();
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fR5Jw.Fragment), {
        children: props.auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
            className: classes.formControl,
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                    id: "case-label",
                    children: "Filter by ARS"
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lqAG1.default), {
                    labelId: "case-label",
                    id: "case-select",
                    value: props.arsUser,
                    onChange: props.handleSetArsUser,
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: 0,
                            children: props.arsOnly ? "Show My Cases" : "Show All"
                        }, 0),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "UNASSIGNED",
                            children: "Need ARS Assignment"
                        }, "UNASSIGNED"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "PROGRAMMANAGED",
                            children: "Program Managed"
                        }, "PROGRAMMANAGED"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "NOTPROGRAMMANAGED",
                            children: "Not Program Managed"
                        }, "NOTPROGRAMMANAGED"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "RECENTINTAKE",
                            children: "Intake Last 10 Days"
                        }, "RECENTINTAKE"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "RECENTREGISTER",
                            children: "Registered Last 10 Days"
                        }, "RECENTREGISTER"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "RECENTDX",
                            children: "Discharged Last 10 Days"
                        }, "RECENTDX"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "LABTESTING",
                            children: "Lab Testing Members"
                        }, "LABTESTING"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "INSTANTTEST",
                            children: "Instant Testing Members"
                        }, "INSTANTTEST"),
                        !props.arsOnly && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                            value: "INSURANCECARRIER",
                            children: "Insurance Client"
                        }, "INSURANCECARRIER"),
                        props.filterByARS && props.filterByARS.map((user)=>{
                            return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $6wnIC.default), {
                                value: user._id,
                                children: [
                                    user.lastName,
                                    ", ",
                                    user.firstName
                                ]
                            }, user._id);
                        })
                    ]
                })
            ]
        })
    });
};
var $9938b880d9762b7c$export$2e2bcd8739ae039 = $9938b880d9762b7c$var$ARSFilter;

});
parcelRegister("6wnIC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf82142b2b347d0$export$2e2bcd8739ae039; });

var $gZz4Z = parcelRequire("gZz4Z");

var $bey4Q = parcelRequire("bey4Q");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $9cmSC = parcelRequire("9cmSC");
var $4bf82142b2b347d0$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $bh1oa.default)({}, theme.typography.body1, (0, $bey4Q.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: "border-box",
            width: "auto",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $bh1oa.default)({}, theme.typography.body2, {
            minHeight: "auto"
        })
    };
};
var $4bf82142b2b347d0$var$MenuItem = /*#__PURE__*/ $dgG1Y.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $dgG1Y.createElement((0, $9cmSC.default), (0, $bh1oa.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $bh1oa.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $cXVHi.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $4bf82142b2b347d0$export$2e2bcd8739ae039 = (0, $7xfqK.default)($4bf82142b2b347d0$export$9dd6ff9ea0189349, {
    name: "MuiMenuItem"
})($4bf82142b2b347d0$var$MenuItem);

});
parcelRegister("9cmSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b26fb881706b8f2$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $9tnMP = parcelRequire("9tnMP");

var $8GJwR = parcelRequire("8GJwR");

var $arbQ3 = parcelRequire("arbQ3");

var $1vdtn = parcelRequire("1vdtn");

var $8idXE = parcelRequire("8idXE");
var $6b26fb881706b8f2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": {
                backgroundColor: theme.palette.action.selected
            },
            "&$selected, &$selected:hover": {
                backgroundColor: theme.palette.action.selected
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: "relative"
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: "flex-start"
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: "padding-box"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $6b26fb881706b8f2$var$useEnhancedEffect = typeof window === "undefined" ? $dgG1Y.useEffect : $dgG1Y.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $6b26fb881706b8f2$var$ListItem = /*#__PURE__*/ $dgG1Y.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $gZz4Z.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $gZz4Z.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $dgG1Y.useContext((0, $1vdtn.default));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $dgG1Y.useRef(null);
    $6b26fb881706b8f2$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $dgG1Y.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $8GJwR.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    var handleOwnRef = $dgG1Y.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $8idXE.findDOMNode(instance);
    }, []);
    var handleRef = (0, $arbQ3.default)(handleOwnRef, ref);
    var componentProps = (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $cXVHi.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $9tnMP.default);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ $dgG1Y.createElement((0, $1vdtn.default).Provider, {
            value: childContext
        }, /*#__PURE__*/ $dgG1Y.createElement(ContainerComponent, (0, $bh1oa.default)({
            className: (0, $cXVHi.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $dgG1Y.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $dgG1Y.createElement((0, $1vdtn.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        ref: handleRef
    }, componentProps), children));
});
var $6b26fb881706b8f2$export$2e2bcd8739ae039 = (0, $7xfqK.default)($6b26fb881706b8f2$export$9dd6ff9ea0189349, {
    name: "MuiListItem"
})($6b26fb881706b8f2$var$ListItem);

});




parcelRegister("aviiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a5aff985d79b811$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $iJ8f3 = parcelRequire("iJ8f3");
var $9EE4V = parcelRequire("9EE4V");
var $3kUUy = parcelRequire("3kUUy");
var $2gTUh = parcelRequire("2gTUh");
var $9f741 = parcelRequire("9f741");
const $7a5aff985d79b811$var$ModalComponent = ({ size: size, open: open, title: title, fullWidth: fullWidth, variant: variant, close: close, buttonTitle: buttonTitle, ChildComponent: ChildComponent, ...otherProps })=>{
    const handleClose = ()=>{
        close();
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        fullWidth: true,
        maxWidth: "lg",
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9f741.default), {
                children: title
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2gTUh.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)(ChildComponent, {
                    ...otherProps
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3kUUy.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $iJ8f3.default), {
                    onClick: handleClose,
                    fullWidth: fullWidth || false,
                    variant: variant || "text",
                    color: "primary",
                    autoFocus: true,
                    children: [
                        buttonTitle || "Close",
                        " "
                    ]
                })
            })
        ]
    });
};
var $7a5aff985d79b811$export$2e2bcd8739ae039 = $7a5aff985d79b811$var$ModalComponent;

});

parcelRegister("EDk0j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $07a23d00506b6d81$export$2e2bcd8739ae039; });
/* eslint-disable no-use-before-define */ 
var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $h2Xtr = parcelRequire("h2Xtr");

var $4m0VC = parcelRequire("4m0VC");
var $7efta = parcelRequire("7efta");
var $hEZLG = parcelRequire("hEZLG");
var $jNIqE = parcelRequire("jNIqE");
var $gJFkA = parcelRequire("gJFkA");
var $hgbGA = parcelRequire("hgbGA");
var $1QHfa = parcelRequire("1QHfa");

var $8wOzK = parcelRequire("8wOzK");

var $cxFzf = parcelRequire("cxFzf");

var $biHHf = parcelRequire("biHHf");

var $cLr7D = parcelRequire("cLr7D");

var $5pCfH = parcelRequire("5pCfH");

var $en0cX = parcelRequire("en0cX");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");


var $hLaym = parcelRequire("hLaym");

var $b942t = parcelRequire("b942t");

var $gElWY = parcelRequire("gElWY");

var $T5LKB = parcelRequire("T5LKB");

var $hnyxZ = parcelRequire("hnyxZ");

var $cdQkG = parcelRequire("cdQkG");

var $hQyaT = parcelRequire("hQyaT");

var $d9ASo = parcelRequire("d9ASo");

var $jYTVM = parcelRequire("jYTVM");

var $h73EU = parcelRequire("h73EU");
const $07a23d00506b6d81$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(4)
        },
        button: {
            marginRight: theme.spacing(3)
        },
        content: {
            alignItems: "center",
            display: "flex"
        },
        title: {
            fontWeight: 700
        },
        divider: {
            margin: theme.spacing(2, 0)
        }
    }));
let $07a23d00506b6d81$var$clearRef = ()=>{};
function $07a23d00506b6d81$var$Sms(props) {
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const socket = (0, $h73EU.useWebSocket)();
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $07a23d00506b6d81$var$useStyles();
    const [showModal, setShowModal] = (0, $dgG1Y.useState)(false);
    const [typedMessage, setTypedMessage] = (0, $dgG1Y.useState)("");
    const inputRef = (0, $dgG1Y.useRef)();
    const [selectedUser, setSelectedUser] = (0, $dgG1Y.useState)();
    const [messages, setMessages] = (0, $dgG1Y.useState)();
    const [showReplyRequired, setShowReplyRequired] = (0, $dgG1Y.useState)(false);
    const [selectedMessage, setSelectedMessage] = (0, $dgG1Y.useState)();
    const [messageCount, setMessageCount] = (0, $dgG1Y.useState)(1);
    const [rerender, setReRender] = (0, $dgG1Y.useState)(false);
    const { adminUsers: adminUsers, getAdminUsers: getAdminUsers, setAdminUsers: setAdminUsers, setSelectedButton: setSelectedButton, selectedButton: selectedButton, filterByARS: filterByARS, handleSetArsUser: handleSetArsUser, arsUser: arsUser } = (0, $gElWY.useGetFilters)(sendRequest, auth, showModal, true, null, rerender, null, setReRender);
    const [showIntakeForm, setShowIntakeForm] = (0, $dgG1Y.useState)(false);
    const [intakeName, setIntakeName] = (0, $dgG1Y.useState)(false);
    const [notesFormName, setNotesFormName] = (0, $dgG1Y.useState)(false);
    const [showNotesForm, setShowNotesForm] = (0, $dgG1Y.useState)(false);
    const [careTeam, setCareTeam] = (0, $dgG1Y.useState)(false); // show care team
    const [careTeamName, setCareTeamName] = (0, $dgG1Y.useState)();
    const [careTeamID, setCareTeamID] = (0, $dgG1Y.useState)();
    const [filterText, setFilterText] = (0, $dgG1Y.useState)("");
    (0, $dgG1Y.useEffect)(()=>{
        if (props.selectedUser && adminUsers) {
            setSelectedButton(2);
            const user = adminUsers.find((users)=>users._id === props.selectedUser);
            if (user) {
                const myUser = {
                    alt: `${user.firstName} ${user.lastName}`,
                    title: `${user.firstName} ${user.lastName}`,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    subtitle: user.phoneNumber || "No Number Entered",
                    timeZone: user.timeZone || "No TZ Selected",
                    id: user._id,
                    formId: user.formId,
                    tenant: user.tenant,
                    toxes: user.toxes,
                    labScreens: user.labScreens,
                    unread: auth.accountableAdmin ? user.smsUnread : "0",
                    renewalDate: user.billingCycleEnd
                };
                setSelectedUser(myUser);
                getSMS(user._id, 1);
            }
        }
    }, [
        adminUsers,
        auth.accountableAdmin,
        props.selectedUser
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        if (!auth.accountableAdmin || !auth.provider) getCurrentUser();
    }, [
        sendRequest,
        showModal
    ]);
    const handleChange = (event)=>{
        const target = event.target.value;
        setFilterText(target);
        if (target.length > 2) getAdminUsers(target);
        else if (target.length < (filterText && filterText.length)) getAdminUsers(target);
    };
    const getCurrentUser = async ()=>{
        try {
            const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/accountable/getcurrentuser`, "GET", null, {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth.token}`
            });
            if (responseData && !responseData.message) {
                setSelectedUser({
                    avatar: (0, (/*@__PURE__*/$parcel$interopDefault($jYTVM))),
                    alt: `${responseData.firstName} ${responseData.lastName}`,
                    title: `${responseData.firstName} ${responseData.lastName}`,
                    subtitle: responseData.phoneNumber || "No Number Entered",
                    timeZone: responseData.timeZone || "No Timezone Selected",
                    id: responseData._id,
                    unread: 0
                });
                getSMS(responseData._id);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const getSMS = (0, $dgG1Y.useCallback)(async (id, messageCount)=>{
        try {
            const smsDataRequest = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/sms/getsms`, "POST", JSON.stringify({
                id: id,
                messageCount: messageCount
            }), {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth.token}`
            });
            const smsData = smsDataRequest || null;
            if (smsData) {
                setMessages(mapSmsDataToMessages(smsData));
                setTypedMessage("");
                if (auth.accountableAdmin) // no input for non admin
                $07a23d00506b6d81$var$clearRef();
            }
        } catch (err) {
            console.error(err);
        }
    }, [
        auth,
        sendRequest
    ]);
    const mapSmsDataToMessages = (smsData)=>{
        return smsData.map((sms)=>{
            var _sms_photoURL, _sms_videoURL;
            if (!sms.photoURL[0] && !sms.videoURL[0]) return {
                title: sms.accountable ? sms.UserFrom ? `${sms.UserFrom.firstName} ${sms.UserFrom.lastName}` : "Accountable" : `${sms.User.firstName} ${sms.User.lastName}`,
                position: sms.accountable ? "right" : "left",
                type: "text",
                text: sms.message,
                date: new Date(sms.date),
                mid: sms._id
            };
            if (sms.photoURL[0]) return {
                title: sms.accountable ? sms.UserFrom ? `${sms.UserFrom.firstName} ${sms.UserFrom.lastName}` : "Accountable" : `${sms.User.firstName} ${sms.User.lastName}`,
                position: sms.accountable ? "right" : "left",
                type: "photo",
                data: {
                    uri: sms.photoURL[0],
                    width: "200px",
                    height: "200px"
                },
                text: (_sms_photoURL = sms.photoURL) === null || _sms_photoURL === void 0 ? void 0 : _sms_photoURL.map((photo)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                        children: [
                            sms.message && sms.message !== "Media Message" && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                children: [
                                    sms.message,
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("a", {
                                href: photo,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Open Image"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                        ]
                    })),
                date: new Date(sms.date),
                mid: sms._id
            };
            if (sms.videoURL[0]) return {
                title: sms.accountable ? sms.UserFrom ? `${sms.UserFrom.firstName} ${sms.UserFrom.lastName}` : "Accountable" : `${sms.User.firstName} ${sms.User.lastName}`,
                position: sms.accountable ? "right" : "left",
                type: "video",
                data: {
                    uri: sms.videoURL[0],
                    width: "200px",
                    height: "200px",
                    videoURL: sms.videoURL[0]
                },
                text: (_sms_videoURL = sms.videoURL) === null || _sms_videoURL === void 0 ? void 0 : _sms_videoURL.map((video)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("a", {
                                href: video,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Open Video"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                        ]
                    })),
                date: new Date(sms.date),
                mid: sms._id
            };
        });
    };
    const getMoreMessages = (0, $dgG1Y.useCallback)(()=>{
        if (selectedUser) {
            getSMS(selectedUser.id, messageCount + 1);
            setMessageCount(messageCount + 1);
        }
    }, [
        selectedUser,
        getSMS,
        messageCount
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        const handleMessage = async (message)=>{
            const { data: data } = message;
            if (data === "PING") return;
            const { event: event, from: from } = JSON.parse(data);
            if (event === "sendMessage") {
                // update existing user with new unread count
                const users = [
                    ...adminUsers
                ]; // copy the array instead of mutating it
                const userIndex = users.findIndex((user)=>user._id === from);
                if (userIndex !== -1) {
                    users[userIndex].smsUnread = users[userIndex].smsUnread ? users[userIndex].smsUnread + 1 : 1;
                    setAdminUsers(users);
                }
                if (selectedUser.id === from) {
                    const response = await fetch(`${"https://apiv2.youareaccountable.com"}/api/sms/getsms`, {
                        method: "POST",
                        body: JSON.stringify({
                            id: selectedUser.id,
                            messageCount: 1
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${auth.token}`
                        }
                    });
                    const responseData = await response.json();
                    console.log(responseData);
                    if (responseData) {
                        const messages = mapSmsDataToMessages(responseData);
                        setMessages(messages);
                    }
                }
            }
        };
        if (!socket) return undefined;
        socket.addEventListener("message", handleMessage);
        return ()=>{
            socket.removeEventListener("message", handleMessage);
        };
    }, [
        socket,
        selectedUser,
        auth.token,
        adminUsers,
        setAdminUsers
    ]);
    const saveSelectedUser = async (event)=>{
        setSelectedUser(event);
        getSMS(event.id);
        setMessageCount(1);
        setTypedMessage("");
        if (auth.accountableAdmin) $07a23d00506b6d81$var$clearRef();
        await getAdminUsers(filterText); // refresh unread count
    };
    const sendMessage = async ()=>{
        try {
            const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/sms/sendsms`, "POST", JSON.stringify({
                text: typedMessage,
                to: selectedUser.subtitle,
                id: selectedUser.id,
                reply: true
            }), {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth.token}` // send the token
            });
            if (responseData.message) {
                setMessages((messages)=>[
                        ...messages,
                        {
                            title: "Accountable",
                            position: "right",
                            type: "text",
                            text: typedMessage,
                            date: new Date(),
                            mid: responseData.message
                        }
                    ]);
                setTypedMessage("");
                $07a23d00506b6d81$var$clearRef();
            }
        } catch (err) {
            console.error(err);
        }
    };
    const sendMessageNoReply = async ()=>{
        try {
            const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/sms/sendsms`, "POST", JSON.stringify({
                text: typedMessage,
                to: selectedUser.subtitle,
                id: selectedUser.id,
                reply: false
            }), {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth.token}`
            });
            if (responseData.message) {
                setMessages((messages)=>[
                        ...messages,
                        {
                            title: auth.tenant || "Accountable",
                            position: "right",
                            type: "text",
                            text: typedMessage,
                            date: new Date(),
                            mid: responseData.message
                        }
                    ]);
                setTypedMessage("");
                $07a23d00506b6d81$var$clearRef();
            }
        } catch (err) {
            console.error(err);
        }
    };
    const setTemplateValue = (event)=>{
        // Set the new value in your component state
        setTypedMessage(event.currentTarget.value);
        inputRef.current.value = event.currentTarget.value;
        inputRef.current.onChange({
            FAKE_EVENT: true,
            target: inputRef.current
        });
        inputRef.current.focus();
    };
    const closeReplyRequired = ()=>{
        setShowReplyRequired(false);
        setSelectedMessage(null);
    };
    const replyClick = (event)=>{
        setShowReplyRequired(event.mid);
        setSelectedMessage(`${new Date(event.date).toLocaleDateString()} ${new Date(event.date).toLocaleTimeString()}: ${event.text}`);
    };
    const closeIntakeForm = ()=>{
        setShowIntakeForm(false);
        setIntakeName(false);
    };
    const openIntakeForm = (event)=>{
        const values = event.currentTarget.value.split(",");
        setShowIntakeForm(values[0]);
        setIntakeName(values[1]);
    };
    const closeNotesForm = ()=>{
        setShowNotesForm(false);
        setNotesFormName(false);
    };
    const openNotesForm = (event)=>{
        const values = event.currentTarget.value.split(",");
        setShowNotesForm(values[0]);
        setNotesFormName(values[1]);
    };
    const showCareTeam = (event)=>{
        const values = event.currentTarget.value.split(",");
        setCareTeam(values[0]);
        setCareTeamName(values[1]);
        setCareTeamID(values[2]);
    };
    const clearCareTeam = ()=>{
        setCareTeam(null);
        setCareTeamName(null);
        setCareTeamID(null);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Cannot Retrieve Messages",
                alert: error,
                clearError: clearError
            }),
            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $b942t.default), {
                open: !!showReplyRequired,
                mid: showReplyRequired,
                message: selectedMessage,
                close: closeReplyRequired
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                className: classes.textField,
                label: "Filter By Last Name",
                name: "filter",
                onChange: handleChange,
                variant: "outlined"
            }),
            auth.accountableAdmin && showIntakeForm && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cdQkG.default), {
                open: !!showIntakeForm,
                id: showIntakeForm,
                close: closeIntakeForm,
                name: intakeName
            }),
            auth.accountableAdmin && showNotesForm && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hQyaT.default), {
                open: !!showNotesForm,
                id: showNotesForm,
                close: closeNotesForm,
                name: notesFormName
            }),
            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hnyxZ.default), {
                open: !!careTeam,
                id: careTeam,
                clear: clearCareTeam,
                name: careTeamName,
                uid: careTeamID
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                container: true,
                spacing: 4,
                children: [
                    (auth.accountableAdmin || auth.provider) && !props.selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        item: true,
                        lg: 3,
                        sm: 12,
                        xl: 3,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $T5LKB.default), {
                                        selectedButton: selectedButton,
                                        setSelectedButton: setSelectedButton,
                                        authContext: auth,
                                        sms: true
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        variant: "h4",
                                        color: "primary",
                                        children: "Members"
                                    }),
                                    auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $d9ASo.default), {
                                        auth: auth,
                                        arsUser: arsUser,
                                        handleSetArsUser: handleSetArsUser,
                                        filterByARS: filterByARS
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.ChatList), {
                                        onClick: saveSelectedUser,
                                        className: "chat-list",
                                        dataSource: adminUsers === null || adminUsers === void 0 ? void 0 : adminUsers.map((user)=>{
                                            return {
                                                avatar: (0, (/*@__PURE__*/$parcel$interopDefault($jYTVM))),
                                                alt: `${user.firstName} ${user.lastName}`,
                                                title: `${user.firstName} ${user.lastName}`,
                                                firstName: user.firstName,
                                                lastName: user.lastName,
                                                subtitle: user.phoneNumber || "No Number Entered",
                                                timeZone: user.timeZone || "No Timezone Selected",
                                                id: user._id,
                                                formId: user.formId,
                                                tenant: user.tenant,
                                                toxes: user.toxes,
                                                labScreens: user.labScreens,
                                                unread: auth.accountableAdmin ? user.smsUnread : "0",
                                                renewalDate: user.billingCycleEnd
                                            };
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                        item: true,
                        lg: props.selectedUser ? 12 : 7,
                        sm: 12,
                        xl: props.selectedUser ? 12 : 7,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                            gutterBottom: true,
                                            className: classes.title,
                                            color: "textSecondary",
                                            variant: "h3",
                                            children: [
                                                selectedUser ? `${selectedUser.title}'s Communication Log (${selectedUser.timeZone.toUpperCase()})` : "Please Select a User",
                                                selectedUser && selectedUser.toxes ? ` - ${selectedUser.toxes} Instant Tox Left` : "",
                                                selectedUser && selectedUser.labScreens ? ` - ${selectedUser.labScreens} Lab Test Left` : "",
                                                selectedUser && auth.accountableAdmin && selectedUser.renewalDate ? ` - Renewal Date: ${new Date(selectedUser.renewalDate).toLocaleDateString()}` : ""
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                            container: true,
                                            justify: "center",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    children: selectedUser && auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                        variant: "contained",
                                                        disabled: !selectedUser.formId,
                                                        color: "secondary",
                                                        value: [
                                                            selectedUser.id,
                                                            `${selectedUser.firstName} ${selectedUser.lastName}`
                                                        ],
                                                        onClick: openIntakeForm,
                                                        children: [
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cLr7D))), {}),
                                                            " Intake"
                                                        ]
                                                    }, selectedUser.id)
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    children: selectedUser && auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                        variant: "contained",
                                                        color: "secondary",
                                                        value: [
                                                            selectedUser.id,
                                                            `${selectedUser.firstName} ${selectedUser.lastName}`
                                                        ],
                                                        onClick: openNotesForm,
                                                        children: [
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($biHHf))), {}),
                                                            " Notes"
                                                        ]
                                                    }, selectedUser.id)
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    children: selectedUser && auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                        variant: "contained",
                                                        color: "secondary",
                                                        value: [
                                                            selectedUser.tenant,
                                                            `${selectedUser.firstName} ${selectedUser.lastName}`,
                                                            selectedUser.id
                                                        ],
                                                        onClick: showCareTeam,
                                                        children: [
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pCfH))), {}),
                                                            " Care Team"
                                                        ]
                                                    }, selectedUser.tenant)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jNIqE.default), {
                                            className: classes.divider
                                        }),
                                        selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                            container: true,
                                            justify: "center",
                                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                color: "primary",
                                                onClick: getMoreMessages,
                                                variant: "contained",
                                                children: [
                                                    "See Prior Messages\xa0\xa0",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cxFzf))), {
                                                        color: "secondary",
                                                        fontSize: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jNIqE.default), {
                                            className: classes.divider
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.MessageList), {
                                            className: "message-list",
                                            lockable: true,
                                            toBottomHeight: "100%",
                                            dataSource: messages || [],
                                            onClick: auth.accountableAdmin ? replyClick : null
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.Input), {
                                            placeholder: "Type here...",
                                            value: typedMessage,
                                            multiline: true,
                                            onChange: (e)=>setTypedMessage(e.target.value),
                                            referance: inputRef,
                                            // eslint-disable-next-line no-return-assign
                                            clear: (clear)=>$07a23d00506b6d81$var$clearRef = clear,
                                            rightButtons: auth.accountableAdmin ? /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.Button), {
                                                        onClick: sendMessage,
                                                        backgroundColor: "secondary",
                                                        text: "Send"
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.Button), {
                                                        onClick: sendMessageNoReply,
                                                        backgroundColor: "primary",
                                                        text: "Send No Response"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.Button), {
                                                onClick: sendMessageNoReply,
                                                backgroundColor: "secondary",
                                                text: "Send"
                                            })
                                        })
                                    ]
                                })
                            }),
                            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hLaym.default), {
                                setVal: setTemplateValue
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $07a23d00506b6d81$export$2e2bcd8739ae039 = $07a23d00506b6d81$var$Sms;

});
parcelRegister("jNIqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6a50e965e5d285a$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $4BFH5 = parcelRequire("4BFH5");
var $e6a50e965e5d285a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 1,
            margin: 0,
            // Reset browser default style.
            border: "none",
            flexShrink: 0,
            backgroundColor: theme.palette.divider
        },
        /* Styles applied to the root element if `absolute={true}`. */ absolute: {
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%"
        },
        /* Styles applied to the root element if `variant="inset"`. */ inset: {
            marginLeft: 72
        },
        /* Styles applied to the root element if `light={true}`. */ light: {
            backgroundColor: (0, $4BFH5.alpha)(theme.palette.divider, 0.08)
        },
        /* Styles applied to the root element if `variant="middle"`. */ middle: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2)
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            height: "100%",
            width: 1
        },
        /* Styles applied to the root element if `flexItem={true}`. */ flexItem: {
            alignSelf: "stretch",
            height: "auto"
        }
    };
};
var $e6a50e965e5d285a$var$Divider = /*#__PURE__*/ $dgG1Y.forwardRef(function Divider(props, ref) {
    var _props$absolute = props.absolute, absolute = _props$absolute === void 0 ? false : _props$absolute, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "hr" : _props$component, _props$flexItem = props.flexItem, flexItem = _props$flexItem === void 0 ? false : _props$flexItem, _props$light = props.light, light = _props$light === void 0 ? false : _props$light, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$role = props.role, role = _props$role === void 0 ? Component !== "hr" ? "separator" : undefined : _props$role, _props$variant = props.variant, variant = _props$variant === void 0 ? "fullWidth" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "absolute",
        "classes",
        "className",
        "component",
        "flexItem",
        "light",
        "orientation",
        "role",
        "variant"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement(Component, (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, variant !== "fullWidth" && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === "vertical" && classes.vertical),
        role: role,
        ref: ref
    }, other));
});
var $e6a50e965e5d285a$export$2e2bcd8739ae039 = (0, $7xfqK.default)($e6a50e965e5d285a$export$9dd6ff9ea0189349, {
    name: "MuiDivider"
})($e6a50e965e5d285a$var$Divider);

});

parcelRegister("biHHf", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83a3455d7ab4453c$var$React = $3kONX((parcelRequire("dgG1Y")));

var $83a3455d7ab4453c$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $83a3455d7ab4453c$var$_default = (0, $83a3455d7ab4453c$var$_createSvgIcon.default)(/*#__PURE__*/ $83a3455d7ab4453c$var$React.createElement("path", {
    d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
}), "Notes");
module.exports.default = $83a3455d7ab4453c$var$_default;

});

parcelRegister("cLr7D", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94aee9b25b2d369c$var$React = $3kONX((parcelRequire("dgG1Y")));

var $94aee9b25b2d369c$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $94aee9b25b2d369c$var$_default = (0, $94aee9b25b2d369c$var$_createSvgIcon.default)(/*#__PURE__*/ $94aee9b25b2d369c$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), "Info");
module.exports.default = $94aee9b25b2d369c$var$_default;

});

parcelRegister("5pCfH", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f0cf5a75d87459e$var$React = $3kONX((parcelRequire("dgG1Y")));

var $3f0cf5a75d87459e$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $3f0cf5a75d87459e$var$_default = (0, $3f0cf5a75d87459e$var$_createSvgIcon.default)(/*#__PURE__*/ $3f0cf5a75d87459e$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), "GroupWork");
module.exports.default = $3f0cf5a75d87459e$var$_default;

});

parcelRegister("hLaym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cedf0320675cb786$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $en0cX = parcelRequire("en0cX");

var $4m0VC = parcelRequire("4m0VC");
var $7efta = parcelRequire("7efta");
var $hEZLG = parcelRequire("hEZLG");
var $gJFkA = parcelRequire("gJFkA");
var $5MowX = parcelRequire("5MowX");
var $f2CoU = parcelRequire("f2CoU");
var $1u2lJ = parcelRequire("1u2lJ");
var $12a5h = parcelRequire("12a5h");
var $hMt12 = parcelRequire("hMt12");
var $k0kWg = parcelRequire("k0kWg");

var $h2Xtr = parcelRequire("h2Xtr");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $04Fi6 = parcelRequire("04Fi6");

var $JJTNt = parcelRequire("JJTNt");

var $6FpSS = parcelRequire("6FpSS");

var $hgbGA = parcelRequire("hgbGA");

var $1QHfa = parcelRequire("1QHfa");
const $cedf0320675cb786$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(3)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        add: {
            alignContent: "right"
        }
    }));
const $cedf0320675cb786$var$Templates = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $cedf0320675cb786$var$useStyles();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [showModal, setShowModal] = (0, $dgG1Y.useState)(false);
    const [templates, setTemplates] = (0, $dgG1Y.useState)([]);
    const [editTemplate, setEditTemplate] = (0, $dgG1Y.useState)(null); //for payer edit button
    (0, $dgG1Y.useEffect)(()=>{
        //get users for tenant
        const getTemplates = async ()=>{
            try {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/gettemplates", "GET", null, {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData && !responseData.message) setTemplates(responseData);
            } catch (err) {}
        };
        getTemplates();
    }, [
        sendRequest,
        showModal
    ]);
    const getTemplates = async (event)=>{
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/gettemplates", "GET", null, {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData && !responseData.message) setTemplates(responseData.filter((template)=>template.templateName.toLowerCase().includes(event.toLowerCase())));
        } catch (err) {}
    };
    const addTemplate = (event)=>{
        event.preventDefault();
        setEditTemplate(null);
        setShowModal(true);
    };
    const showEditModal = (event)=>{
        setEditTemplate(event.currentTarget.value);
        setShowModal(true);
    };
    const deleteTemplate = async (event)=>{
        event.preventDefault();
        let target = event.currentTarget.value; //current target gets lost on async. 
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/deletetemplate", "POST", JSON.stringify({
                templateid: event.currentTarget.value
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData.valid) setTemplates(templates.filter((template)=>template._id !== target)); //remove deleted object
        } catch (err) {}
    };
    const handleChange = (event)=>{
        let target = event.target.value;
        getTemplates(target);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Template",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                className: classes.textField,
                label: "Filter By Template",
                name: "filter",
                onChange: handleChange,
                variant: "outlined"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $JJTNt.default), {
                open: showModal,
                close: setShowModal,
                editVal: editTemplate
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                container: true,
                spacing: 4,
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                    item: true,
                    lg: 12,
                    sm: 12,
                    xl: 8,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                    gutterBottom: true,
                                    className: classes.title,
                                    color: "textSecondary",
                                    variant: "h3",
                                    children: "Templates"
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                    container: true,
                                    justify: "flex-end",
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                        color: "secondary",
                                        onClick: addTemplate,
                                        children: [
                                            "Add Template\xa0\xa0",
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04Fi6))), {
                                                color: "secondary",
                                                fontSize: "small"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $12a5h.default), {
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $5MowX.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hMt12.default), {
                                                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Text"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Delete"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f2CoU.default), {
                                                children: templates && templates.map((template)=>{
                                                    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                        button: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                style: {
                                                                    verticalAlign: "top"
                                                                },
                                                                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                                    color: "secondary",
                                                                    value: template.template,
                                                                    onClick: props.setVal,
                                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                                        color: "primary",
                                                                        variant: "h6",
                                                                        gutterBottom: true,
                                                                        children: template.templateName
                                                                    })
                                                                }, template._id)
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                style: {
                                                                    verticalAlign: "top"
                                                                },
                                                                children: template.template
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                style: {
                                                                    verticalAlign: "top"
                                                                },
                                                                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                                    variant: "contained",
                                                                    color: "secondary",
                                                                    value: template._id,
                                                                    onClick: deleteTemplate,
                                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6FpSS))), {})
                                                                }, template._id)
                                                            })
                                                        ]
                                                    }, template._id);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $cedf0320675cb786$export$2e2bcd8739ae039 = $cedf0320675cb786$var$Templates;

});
parcelRegister("JJTNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0897cea8efbe4d13$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $en0cX = parcelRequire("en0cX");

var $4m0VC = parcelRequire("4m0VC");

var $62uyF = parcelRequire("62uyF");

var $hgbGA = parcelRequire("hgbGA");

var $6UFAs = parcelRequire("6UFAs");

var $f4GCu = parcelRequire("f4GCu");

var $lqAxB = parcelRequire("lqAxB");

var $jUw8I = parcelRequire("jUw8I");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $h2Xtr = parcelRequire("h2Xtr");

var $htjEL = parcelRequire("htjEL");
const $0897cea8efbe4d13$var$schema = {
    template: [
        (0, $htjEL.required)
    ],
    templateName: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(64)
    ]
};
const $0897cea8efbe4d13$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(2)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        }
    }));
const $0897cea8efbe4d13$var$AddTemplate = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $0897cea8efbe4d13$var$useStyles();
    const { hasError: hasError, handleChange: handleChange, formState: formState } = (0, $jUw8I.useForm)($0897cea8efbe4d13$var$schema);
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [open, setOpen] = (0, $dgG1Y.useState)(false);
    const handleSave = async (event)=>{
        event.preventDefault();
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/addtemplate", "POST", JSON.stringify({
                template: formState.values.template,
                templateName: formState.values.templateName
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
        } catch (err) {}
        setOpen(false);
        props.close(false);
    };
    const handleCancel = (event)=>{
        event.preventDefault();
        setOpen(false);
        props.close(false);
    };
    (0, $dgG1Y.useEffect)(()=>{
        setOpen(props.open);
    }, [
        props.open
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Template",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $62uyF.default), {
                open: open,
                onClose: handleCancel,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                fullWidth: true,
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lqAxB.default), {
                        children: "Add a Template"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $f4GCu.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                className: classes.textField,
                                error: hasError("templateName"),
                                fullWidth: true,
                                helperText: hasError("templateName") ? formState.errors.templateName[0] : null,
                                label: "Template Name",
                                name: "templateName",
                                onChange: handleChange,
                                value: formState.values.templateName || "",
                                variant: "outlined"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                className: classes.textField,
                                error: hasError("template"),
                                fullWidth: true,
                                helperText: hasError("template") ? formState.errors.template[0] : null,
                                label: "Template",
                                name: "template",
                                onChange: handleChange,
                                value: formState.values.template || "",
                                variant: "outlined"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $6UFAs.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: handleSave,
                                variant: "contained",
                                color: "primary",
                                autoFocus: true,
                                disabled: !formState.isValid,
                                children: "Save Template"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: handleCancel,
                                variant: "contained",
                                color: "secondary",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0897cea8efbe4d13$export$2e2bcd8739ae039 = $0897cea8efbe4d13$var$AddTemplate;

});
parcelRegister("62uyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $465aa230bb0c027f$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $bey4Q = parcelRequire("bey4Q");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");


var $6bQBn = parcelRequire("6bQBn");

var $f1jnN = parcelRequire("f1jnN");

var $1eKt7 = parcelRequire("1eKt7");

var $frSQs = parcelRequire("frSQs");

var $2Po3a = parcelRequire("2Po3a");
var $465aa230bb0c027f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            "@media print": {
                // Use !important to override the Modal inline-style.
                position: "absolute !important"
            }
        },
        /* Styles applied to the container element if `scroll="paper"`. */ scrollPaper: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        /* Styles applied to the container element if `scroll="body"`. */ scrollBody: {
            overflowY: "auto",
            overflowX: "hidden",
            textAlign: "center",
            "&:after": {
                content: '""',
                display: "inline-block",
                verticalAlign: "middle",
                height: "100%",
                width: "0"
            }
        },
        /* Styles applied to the container element. */ container: {
            height: "100%",
            "@media print": {
                height: "auto"
            },
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0
        },
        /* Styles applied to the `Paper` component. */ paper: {
            margin: 32,
            position: "relative",
            overflowY: "auto",
            // Fix IE 11 issue, to remove at some point.
            "@media print": {
                overflowY: "visible",
                boxShadow: "none"
            }
        },
        /* Styles applied to the `Paper` component if `scroll="paper"`. */ paperScrollPaper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "calc(100% - 64px)"
        },
        /* Styles applied to the `Paper` component if `scroll="body"`. */ paperScrollBody: {
            display: "inline-block",
            verticalAlign: "middle",
            textAlign: "left" // 'initial' doesn't work on IE 11
        },
        /* Styles applied to the `Paper` component if `maxWidth=false`. */ paperWidthFalse: {
            maxWidth: "calc(100% - 64px)"
        },
        /* Styles applied to the `Paper` component if `maxWidth="xs"`. */ paperWidthXs: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444),
            "&$paperScrollBody": (0, $bey4Q.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64), {
                maxWidth: "calc(100% - 64px)"
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="sm"`. */ paperWidthSm: {
            maxWidth: theme.breakpoints.values.sm,
            "&$paperScrollBody": (0, $bey4Q.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 64), {
                maxWidth: "calc(100% - 64px)"
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="md"`. */ paperWidthMd: {
            maxWidth: theme.breakpoints.values.md,
            "&$paperScrollBody": (0, $bey4Q.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 64), {
                maxWidth: "calc(100% - 64px)"
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="lg"`. */ paperWidthLg: {
            maxWidth: theme.breakpoints.values.lg,
            "&$paperScrollBody": (0, $bey4Q.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 64), {
                maxWidth: "calc(100% - 64px)"
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="xl"`. */ paperWidthXl: {
            maxWidth: theme.breakpoints.values.xl,
            "&$paperScrollBody": (0, $bey4Q.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 64), {
                maxWidth: "calc(100% - 64px)"
            })
        },
        /* Styles applied to the `Paper` component if `fullWidth={true}`. */ paperFullWidth: {
            width: "calc(100% - 64px)"
        },
        /* Styles applied to the `Paper` component if `fullScreen={true}`. */ paperFullScreen: {
            margin: 0,
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "none",
            borderRadius: 0,
            "&$paperScrollBody": {
                margin: 0,
                maxWidth: "100%"
            }
        }
    };
};
var $465aa230bb0c027f$var$defaultTransitionDuration = {
    enter: (0, $frSQs.duration).enteringScreen,
    exit: (0, $frSQs.duration).leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ var $465aa230bb0c027f$var$Dialog = /*#__PURE__*/ $dgG1Y.forwardRef(function Dialog(props, ref) {
    var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? "sm" : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $2Po3a.default) : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? "paper" : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $1eKt7.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $465aa230bb0c027f$var$defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props["aria-describedby"], ariaLabelledby = props["aria-labelledby"], other = (0, $gZz4Z.default)(props, [
        "BackdropProps",
        "children",
        "classes",
        "className",
        "disableBackdropClick",
        "disableEscapeKeyDown",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onBackdropClick",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onEscapeKeyDown",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperComponent",
        "PaperProps",
        "scroll",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps",
        "aria-describedby",
        "aria-labelledby"
    ]);
    var mouseDownTarget = $dgG1Y.useRef();
    var handleMouseDown = function handleMouseDown(event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) return;
         // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) return;
        mouseDownTarget.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    return /*#__PURE__*/ $dgG1Y.createElement((0, $6bQBn.default), (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        BackdropComponent: (0, $f1jnN.default),
        BackdropProps: (0, $bh1oa.default)({
            transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true
    }, disableBackdropClick ? {
        disableBackdropClick: disableBackdropClick
    } : {}, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref
    }, other), /*#__PURE__*/ $dgG1Y.createElement(TransitionComponent, (0, $bh1oa.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        role: "none presentation"
    }, TransitionProps), /*#__PURE__*/ $dgG1Y.createElement("div", {
        className: (0, $cXVHi.default)(classes.container, classes["scroll".concat((0, $bdWPY.default)(scroll))]),
        onMouseUp: handleBackdropClick,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ $dgG1Y.createElement(PaperComponent, (0, $bh1oa.default)({
        elevation: 24,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
    }, PaperProps, {
        className: (0, $cXVHi.default)(classes.paper, classes["paperScroll".concat((0, $bdWPY.default)(scroll))], classes["paperWidth".concat((0, $bdWPY.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
    }), children))));
});
var $465aa230bb0c027f$export$2e2bcd8739ae039 = (0, $7xfqK.default)($465aa230bb0c027f$export$9dd6ff9ea0189349, {
    name: "MuiDialog"
})($465aa230bb0c027f$var$Dialog);

});

parcelRegister("6UFAs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50883b5cc43cc0d2$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");
var $50883b5cc43cc0d2$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        "& > :not(:first-child)": {
            marginLeft: 8
        }
    }
};
var $50883b5cc43cc0d2$var$DialogActions = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $gZz4Z.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $50883b5cc43cc0d2$export$2e2bcd8739ae039 = (0, $7xfqK.default)($50883b5cc43cc0d2$export$9dd6ff9ea0189349, {
    name: "MuiDialogActions"
})($50883b5cc43cc0d2$var$DialogActions);

});

parcelRegister("f4GCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af984a23833b8d6f$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");
var $af984a23833b8d6f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: "1 1 auto",
            WebkitOverflowScrolling: "touch",
            // Add iOS momentum scrolling.
            overflowY: "auto",
            padding: "8px 24px",
            "&:first-child": {
                // dialog without title
                paddingTop: 20
            }
        },
        /* Styles applied to the root element if `dividers={true}`. */ dividers: {
            padding: "16px 24px",
            borderTop: "1px solid ".concat(theme.palette.divider),
            borderBottom: "1px solid ".concat(theme.palette.divider)
        }
    };
};
var $af984a23833b8d6f$var$DialogContent = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogContent(props, ref) {
    var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "dividers"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, dividers && classes.dividers),
        ref: ref
    }, other));
});
var $af984a23833b8d6f$export$2e2bcd8739ae039 = (0, $7xfqK.default)($af984a23833b8d6f$export$9dd6ff9ea0189349, {
    name: "MuiDialogContent"
})($af984a23833b8d6f$var$DialogContent);

});

parcelRegister("lqAxB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9985ef8537577e6$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $1QHfa = parcelRequire("1QHfa");
var $f9985ef8537577e6$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        margin: 0,
        padding: "16px 24px",
        flex: "0 0 auto"
    }
};
var $f9985ef8537577e6$var$DialogTitle = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogTitle(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className),
        ref: ref
    }, other), disableTypography ? children : /*#__PURE__*/ $dgG1Y.createElement((0, $1QHfa.default), {
        component: "h2",
        variant: "h6"
    }, children));
});
var $f9985ef8537577e6$export$2e2bcd8739ae039 = (0, $7xfqK.default)($f9985ef8537577e6$export$9dd6ff9ea0189349, {
    name: "MuiDialogTitle"
})($f9985ef8537577e6$var$DialogTitle);

});


parcelRegister("6FpSS", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0140b01aaf6dcb24$var$React = $3kONX((parcelRequire("dgG1Y")));

var $0140b01aaf6dcb24$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $0140b01aaf6dcb24$var$_default = (0, $0140b01aaf6dcb24$var$_createSvgIcon.default)(/*#__PURE__*/ $0140b01aaf6dcb24$var$React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
module.exports.default = $0140b01aaf6dcb24$var$_default;

});


parcelRegister("b942t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81d3aafd116b71ec$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $iJ8f3 = parcelRequire("iJ8f3");
var $aKBfU = parcelRequire("aKBfU");
var $9EE4V = parcelRequire("9EE4V");
var $3kUUy = parcelRequire("3kUUy");
var $2gTUh = parcelRequire("2gTUh");
var $aXBMD = parcelRequire("aXBMD");
var $9f741 = parcelRequire("9f741");

var $ewdxp = parcelRequire("ewdxp");

var $56aO2 = parcelRequire("56aO2");
const $81d3aafd116b71ec$var$ReplyRequired = (props)=>{
    const { sendRequest: sendRequest } = (0, $56aO2.useHttpClient)();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const handleClose = ()=>{
        props.close();
    };
    const updateResponse = async (event)=>{
        event.preventDefault();
        const reply = event.currentTarget.value;
        try {
            await sendRequest("https://apiv2.youareaccountable.com/api/sms/replyrequired", "POST", JSON.stringify({
                mid: props.mid,
                replyrequired: reply
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
        } catch (err) {
            console.error(err);
        }
        props.close();
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
        open: props.open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9f741.default), {
                children: "Is a response required for this message?"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2gTUh.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aXBMD.default), {
                    sx: {
                        mb: 2
                    },
                    children: props.message
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3kUUy.default), {
                sx: {
                    justifyContent: "right",
                    pb: 2
                },
                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $aKBfU.default), {
                    variant: "contained",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                            onClick: updateResponse,
                            value: false,
                            sx: {
                                bgcolor: "primary.main",
                                "&:hover": {
                                    bgcolor: "primary.dark"
                                }
                            },
                            children: "No"
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                            onClick: updateResponse,
                            value: true,
                            autoFocus: true,
                            sx: {
                                bgcolor: "secondary.main",
                                "&:hover": {
                                    bgcolor: "secondary.dark"
                                }
                            },
                            children: "Yes"
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                            onClick: updateResponse,
                            value: 3,
                            sx: {
                                bgcolor: "secondary.main",
                                "&:hover": {
                                    bgcolor: "secondary.dark"
                                }
                            },
                            children: "Mark Unread"
                        })
                    ]
                })
            })
        ]
    });
};
var $81d3aafd116b71ec$export$2e2bcd8739ae039 = $81d3aafd116b71ec$var$ReplyRequired;

});
parcelRegister("aKBfU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d3b197730dea024$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $1vhm2 = parcelRequire("1vhm2");

var $9TQfG = parcelRequire("9TQfG");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $25OVu = parcelRequire("25OVu");

var $7ZAQE = parcelRequire("7ZAQE");

var $6G8aj = parcelRequire("6G8aj");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $7d3b197730dea024$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $25OVu.default).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $25OVu.default).grouped}`]: styles[`grouped${(0, $9TQfG.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $25OVu.default).grouped}`]: styles[`grouped${(0, $9TQfG.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $25OVu.default).grouped}`]: styles[`grouped${(0, $9TQfG.default)(ownerState.variant)}${(0, $9TQfG.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $25OVu.default).grouped}`]: styles[`grouped${(0, $9TQfG.default)(ownerState.variant)}${(0, $9TQfG.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $25OVu.default).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $25OVu.default).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $25OVu.default).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === "vertical" && styles.vertical
    ];
};
const $7d3b197730dea024$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            orientation,
            fullWidth && "fullWidth",
            disableElevation && "disableElevation",
            `color${(0, $9TQfG.default)(color)}`
        ],
        grouped: [
            "grouped",
            `grouped${(0, $9TQfG.default)(orientation)}`,
            `grouped${(0, $9TQfG.default)(variant)}`,
            `grouped${(0, $9TQfG.default)(variant)}${(0, $9TQfG.default)(orientation)}`,
            `grouped${(0, $9TQfG.default)(variant)}${(0, $9TQfG.default)(color)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $25OVu.getButtonGroupUtilityClass), classes);
};
const $7d3b197730dea024$var$ButtonGroupRoot = (0, $dTuzq.default)("div", {
    name: "MuiButtonGroup",
    slot: "Root",
    overridesResolver: $7d3b197730dea024$var$overridesResolver
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: "contained"
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: "none"
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: "100%"
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    flexDirection: "column",
                    [`& .${(0, $25OVu.default).lastButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $25OVu.default).lastButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: "text",
                    orientation: "horizontal"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
                        [`&.${(0, $25OVu.default).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: "text",
                    orientation: "vertical"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
                        [`&.${(0, $25OVu.default).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: "text",
                            color: color
                        },
                        style: {
                            [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                                borderColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $kqewD.alpha)(theme.palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: "outlined",
                    orientation: "horizontal"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderRightColor: "transparent",
                        "&:hover": {
                            borderRightColor: "currentColor"
                        }
                    },
                    [`& .${(0, $25OVu.default).lastButton},& .${(0, $25OVu.default).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: "outlined",
                    orientation: "vertical"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderBottomColor: "transparent",
                        "&:hover": {
                            borderBottomColor: "currentColor"
                        }
                    },
                    [`& .${(0, $25OVu.default).lastButton},& .${(0, $25OVu.default).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: "contained",
                    orientation: "horizontal"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $25OVu.default).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: "contained",
                    orientation: "vertical"
                },
                style: {
                    [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $25OVu.default).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)([
                "dark"
            ])).map(([color])=>({
                    props: {
                        variant: "contained",
                        color: color
                    },
                    style: {
                        [`& .${(0, $25OVu.default).firstButton},& .${(0, $25OVu.default).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $25OVu.default).grouped}`]: {
            minWidth: 40,
            boxShadow: "none",
            props: {
                variant: "contained"
            },
            style: {
                "&:hover": {
                    boxShadow: "none"
                }
            }
        }
    })));
const $7d3b197730dea024$var$ButtonGroup = /*#__PURE__*/ $dgG1Y.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiButtonGroup"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = "horizontal", size: size = "medium", variant: variant = "outlined", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $7d3b197730dea024$var$useUtilityClasses(ownerState);
    const context = $dgG1Y.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $1vhm2.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($7d3b197730dea024$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $8MGTi.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7ZAQE.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6G8aj.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $7d3b197730dea024$export$2e2bcd8739ae039 = $7d3b197730dea024$var$ButtonGroup;

});
parcelRegister("1vhm2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $118625ee5b788040$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
function $118625ee5b788040$export$2e2bcd8739ae039(children) {
    return $dgG1Y.Children.toArray(children).filter((child)=>/*#__PURE__*/ $dgG1Y.isValidElement(child));
}

});

parcelRegister("25OVu", function(module, exports) {

$parcel$export(module.exports, "getButtonGroupUtilityClass", function () { return $18638d44cf26d095$export$b85c003f960b1f3a; });
$parcel$export(module.exports, "default", function () { return $18638d44cf26d095$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $18638d44cf26d095$export$b85c003f960b1f3a(slot) {
    return (0, $5xHgF.default)("MuiButtonGroup", slot);
}
const $18638d44cf26d095$var$buttonGroupClasses = (0, $eFHYA.default)("MuiButtonGroup", [
    "root",
    "contained",
    "outlined",
    "text",
    "disableElevation",
    "disabled",
    "firstButton",
    "fullWidth",
    "horizontal",
    "vertical",
    "colorPrimary",
    "colorSecondary",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "groupedText",
    "groupedTextHorizontal",
    "groupedTextVertical",
    "groupedTextPrimary",
    "groupedTextSecondary",
    "groupedOutlined",
    "groupedOutlinedHorizontal",
    "groupedOutlinedVertical",
    "groupedOutlinedPrimary",
    "groupedOutlinedSecondary",
    "groupedContained",
    "groupedContainedHorizontal",
    "groupedContainedVertical",
    "groupedContainedPrimary",
    "groupedContainedSecondary",
    "lastButton",
    "middleButton"
]);
var $18638d44cf26d095$export$2e2bcd8739ae039 = $18638d44cf26d095$var$buttonGroupClasses;

});



parcelRegister("hnyxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6f61fd43e268c0$export$2e2bcd8739ae039; });
/* eslint-disable react/jsx-fragments */ /* eslint-disable react/jsx-no-useless-fragment */ 
var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $62uyF = parcelRequire("62uyF");

var $6UFAs = parcelRequire("6UFAs");

var $f4GCu = parcelRequire("f4GCu");

var $3teb5 = parcelRequire("3teb5");

var $lqAxB = parcelRequire("lqAxB");

var $4m0VC = parcelRequire("4m0VC");
var $5MowX = parcelRequire("5MowX");
var $f2CoU = parcelRequire("f2CoU");
var $1u2lJ = parcelRequire("1u2lJ");
var $12a5h = parcelRequire("12a5h");
var $hMt12 = parcelRequire("hMt12");
var $k0kWg = parcelRequire("k0kWg");

var $ewdxp = parcelRequire("ewdxp");

var $56aO2 = parcelRequire("56aO2");

var $aTbGF = parcelRequire("aTbGF");

var $1JpH9 = parcelRequire("1JpH9");

var $bocI1 = parcelRequire("bocI1");

var $6FpSS = parcelRequire("6FpSS");
const $ca6f61fd43e268c0$var$CareTeamModal = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [users, setUsers] = (0, $dgG1Y.useState)(null);
    (0, $dgG1Y.useEffect)(()=>{
        //get careteam for tenant
        const getUsers = async ()=>{
            try {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/getcareteam", "POST", JSON.stringify({
                    id: props.id
                }), {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData) setUsers(responseData);
            } catch (err) {}
        };
        if (props.id) getUsers();
    }, [
        props.id,
        sendRequest
    ]);
    const handleClose = ()=>{
        props.clear();
    };
    const deleteUser = async (event)=>{
        event.preventDefault();
        let target = event.currentTarget.value; //current target gets lost on async.
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/users/removecaseload", "POST", JSON.stringify({
                userId: props.uid,
                providerId: target
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData.valid) setUsers(users.filter((user)=>user._id !== target)); //remove deleted object
        } catch (err) {}
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).Fragment, {
        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $62uyF.default), {
            open: props.open,
            onClose: handleClose,
            "aria-labelledby": "alert-dialog-title",
            "aria-describedby": "alert-dialog-description",
            fullWidth: true,
            maxWidth: "md",
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lqAxB.default), {
                    children: [
                        props.name,
                        "'s Care Team"
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f4GCu.default), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3teb5.default), {
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $12a5h.default), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $5MowX.default), {
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hMt12.default), {
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "First Name"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Last Name"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Phone Number"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Relationship"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Share All Information"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Active"
                                                }),
                                                auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                    children: "Delete"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f2CoU.default), {
                                        children: users && users.map((user)=>{
                                            let relationship = "NA";
                                            if (user.relationship) switch(user.relationship){
                                                case "0":
                                                    relationship = "Friend/Family";
                                                    break;
                                                case "1":
                                                    relationship = "Therapist";
                                                    break;
                                                case "2":
                                                    relationship = "Psychiatrist";
                                                    break;
                                                case "3":
                                                    relationship = "IOP Counselor";
                                                    break;
                                                case "4":
                                                    relationship = "Alumni Coordinator";
                                                    break;
                                                case "5":
                                                    relationship = "Partner Program";
                                                    break;
                                                case "6":
                                                    relationship = "Recovery Coach";
                                                    break;
                                                case "7":
                                                    relationship = "Sober Living";
                                                    break;
                                                case "8":
                                                    relationship = "Case Manager";
                                                    break;
                                                case "9":
                                                    relationship = "Other";
                                                    break;
                                                case "10":
                                                    relationship = "Lawyer";
                                                    break;
                                                case "11":
                                                    relationship = "Probation Officer";
                                                    break;
                                                case "12":
                                                    relationship = "Employer";
                                                    break;
                                            }
                                            return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: user.email
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: user.firstName
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: user.lastName
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: user.phoneNumber
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: relationship
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: !user.toxOnly ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1JpH9))), {
                                                            alt: "Active",
                                                            color: "secondary"
                                                        }) : /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bocI1))), {
                                                            alt: "Only Tox Results",
                                                            color: "error"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: user.confirmEmail ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTbGF))), {
                                                            alt: "Registration Email Sent",
                                                            color: "error"
                                                        }) : /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1JpH9))), {
                                                            alt: "Active",
                                                            color: "secondary"
                                                        })
                                                    }),
                                                    auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                            variant: "contained",
                                                            color: "secondary",
                                                            value: user._id,
                                                            onClick: deleteUser,
                                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6FpSS))), {})
                                                        }, user._id)
                                                    })
                                                ]
                                            }, user._id);
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6UFAs.default), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                        onClick: handleClose,
                        color: "primary",
                        autoFocus: true,
                        children: "Close"
                    })
                })
            ]
        })
    });
};
var $ca6f61fd43e268c0$export$2e2bcd8739ae039 = $ca6f61fd43e268c0$var$CareTeamModal;

});
parcelRegister("3teb5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286f13f8e8ff3b33$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");


var $7xfqK = parcelRequire("7xfqK");

var $1QHfa = parcelRequire("1QHfa");
var $286f13f8e8ff3b33$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        marginBottom: 12
    }
};
var $286f13f8e8ff3b33$var$DialogContentText = /*#__PURE__*/ $dgG1Y.forwardRef(function DialogContentText(props, ref) {
    return /*#__PURE__*/ $dgG1Y.createElement((0, $1QHfa.default), (0, $bh1oa.default)({
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref
    }, props));
});
var $286f13f8e8ff3b33$export$2e2bcd8739ae039 = (0, $7xfqK.default)($286f13f8e8ff3b33$export$9dd6ff9ea0189349, {
    name: "MuiDialogContentText"
})($286f13f8e8ff3b33$var$DialogContentText);

});

parcelRegister("aTbGF", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ed81b45c64d40f5$var$React = $3kONX((parcelRequire("dgG1Y")));

var $7ed81b45c64d40f5$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $7ed81b45c64d40f5$var$_default = (0, $7ed81b45c64d40f5$var$_createSvgIcon.default)(/*#__PURE__*/ $7ed81b45c64d40f5$var$React.createElement("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
}), "Email");
module.exports.default = $7ed81b45c64d40f5$var$_default;

});

parcelRegister("1JpH9", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $142deced8062c9f3$var$React = $3kONX((parcelRequire("dgG1Y")));

var $142deced8062c9f3$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $142deced8062c9f3$var$_default = (0, $142deced8062c9f3$var$_createSvgIcon.default)(/*#__PURE__*/ $142deced8062c9f3$var$React.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
module.exports.default = $142deced8062c9f3$var$_default;

});


parcelRegister("cdQkG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95b60d3282505bce$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $iJ8f3 = parcelRequire("iJ8f3");
var $9EE4V = parcelRequire("9EE4V");
var $3kUUy = parcelRequire("3kUUy");
var $2gTUh = parcelRequire("2gTUh");
var $aXBMD = parcelRequire("aXBMD");
var $9f741 = parcelRequire("9f741");
var $jayBd = parcelRequire("jayBd");
var $f9Dhz = parcelRequire("f9Dhz");
var $8Zcdm = parcelRequire("8Zcdm");

var $ewdxp = parcelRequire("ewdxp");

var $giDLW = parcelRequire("giDLW");
const $95b60d3282505bce$var$Intake = (props)=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [intakeForm, setIntakeForm] = (0, $dgG1Y.useState)(null);
    const handleClose = ()=>{
        props.close();
    };
    const getIntake = (0, $dgG1Y.useCallback)(async ()=>{
        try {
            const responseData = await fetch(`${"https://apiv2.youareaccountable.com"}/api/accountable/getintake`, {
                method: "POST",
                body: JSON.stringify({
                    id: props.id
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${auth.token}`
                }
            });
            if (responseData) {
                var _intakeForm_intake;
                const intakeForm = await responseData.json();
                // Check if personalInfo key exists (only exists in new format)
                if (intakeForm === null || intakeForm === void 0 ? void 0 : (_intakeForm_intake = intakeForm.intake) === null || _intakeForm_intake === void 0 ? void 0 : _intakeForm_intake.personalInfo) // New format via mobile app
                setIntakeForm(intakeForm.intake);
                else // old format
                setIntakeForm((0, $giDLW.default)(Object.entries(intakeForm.intake)));
            }
        } catch (err) {
            console.error(err);
        }
    }, [
        props.id,
        auth.token
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        console.log("getting intake");
        getIntake();
    }, [
        getIntake
    ]);
    const formatDate = (dateString)=>{
        const date = new Date(dateString);
        return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
    };
    const styles = {
        section: {
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            padding: "24px",
            marginBottom: "24px",
            width: "100%"
        },
        question: {
            color: "#1a1a1a",
            fontSize: "16px",
            fontWeight: 600,
            marginBottom: "8px"
        },
        answer: {
            color: "#4a4a4a",
            fontSize: "16px",
            backgroundColor: "white",
            padding: "12px 16px",
            borderRadius: "4px",
            border: "1px solid #e0e0e0"
        },
        sectionHeader: {
            fontSize: "20px",
            fontWeight: 700,
            color: "#2c3e50",
            marginBottom: "20px",
            borderBottom: "2px solid #3f51b5",
            paddingBottom: "8px"
        }
    };
    const QuestionAnswer = ({ question: question, answer: answer })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
            style: {
                marginBottom: "20px"
            },
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                    style: styles.question,
                    children: question
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                    style: styles.answer,
                    children: typeof answer === "string" ? answer.replace(/other:\s*/gi, "") : answer
                })
            ]
        });
    const Section = ({ title: title, children: children })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
            style: styles.section,
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                    style: styles.sectionHeader,
                    children: title
                }),
                children
            ]
        });
    const renderNewIntakeFormat = (intake)=>{
        var _intake_recoveryInfo_substancesOfChoice, _intake_recoveryInfo_medications, _intake_recoveryInfo_supportTypes, _intake_recoveryInfo_currentServices;
        return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
            style: {
                width: "100%",
                padding: "16px"
            },
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Personal Information",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Email Address",
                            answer: intake.personalInfo.email
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Phone Number",
                            answer: intake.personalInfo.phone
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Date of Birth",
                            answer: formatDate(intake.personalInfo.dateOfBirth)
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Pronouns",
                            answer: intake.personalInfo.pronouns
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Sexual Orientation",
                            answer: intake.personalInfo.sexualOrientation
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Address",
                            answer: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                children: [
                                    `${intake.personalInfo.address.street} ${intake.personalInfo.address.street2 || ""}`,
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                    `${intake.personalInfo.address.city}, ${intake.personalInfo.address.state} ${intake.personalInfo.address.zipCode}`
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Recovery History",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Are you currently abstinent from non-prescribed mind-altering substances?",
                            answer: intake.recoveryInfo.isCurrentlyAbstinent ? "Yes" : "No"
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "When was your last use of non-prescribed mind altering substances?",
                            answer: formatDate(intake.recoveryInfo.lastUseDate)
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "What are your substances of choice?",
                            answer: (_intake_recoveryInfo_substancesOfChoice = intake.recoveryInfo.substancesOfChoice) === null || _intake_recoveryInfo_substancesOfChoice === void 0 ? void 0 : _intake_recoveryInfo_substancesOfChoice.join(", ")
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Are you on any medications to help treat your mental health or addiction?",
                            answer: (_intake_recoveryInfo_medications = intake.recoveryInfo.medications) === null || _intake_recoveryInfo_medications === void 0 ? void 0 : _intake_recoveryInfo_medications.join(", ")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Treatment Services",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "What type of support have you received in the last 6 months?",
                            answer: (_intake_recoveryInfo_supportTypes = intake.recoveryInfo.supportTypes) === null || _intake_recoveryInfo_supportTypes === void 0 ? void 0 : _intake_recoveryInfo_supportTypes.join(", ")
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "What services are you currently engaged with?",
                            answer: (_intake_recoveryInfo_currentServices = intake.recoveryInfo.currentServices) === null || _intake_recoveryInfo_currentServices === void 0 ? void 0 : _intake_recoveryInfo_currentServices.join(", ")
                        }),
                        intake.recoveryInfo.residentialDischargeDate && /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Residential Discharge Date",
                            answer: formatDate(intake.recoveryInfo.residentialDischargeDate)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Self Care",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "What does self care look like to you?",
                            answer: intake.recoveryInfo.selfCareDescription
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "If there was one thing you could improve around self care, what would it be?",
                            answer: intake.recoveryInfo.selfCareImprovement
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Do you have any physical health goals you are working towards?",
                            answer: intake.recoveryInfo.physicalHealthGoals
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Is exercise part of your self care routine?",
                            answer: intake.recoveryInfo.exerciseRoutineActive ? `Yes - ${intake.recoveryInfo.exerciseRoutineTimesPerWeek} times per week` : "No"
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Is meditation part of your self care routine?",
                            answer: intake.recoveryInfo.meditationRoutineActive ? `Yes - ${intake.recoveryInfo.meditationRoutineDaysPerWeek} days per week` : "No"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Support & Goals",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Do you attend 12 step meetings, or other peer support programs?",
                            answer: intake.recoveryInfo.attendsPeerSupport ? "Yes" : "No"
                        }),
                        intake.recoveryInfo.peerSupportDetails && /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: intake.recoveryInfo.attendsPeerSupport ? "Tell us about your program. How frequently you attend, what meetings, if you have a sponsor, or if there is anything else we can help with." : "Is this something you are interested in exploring? Why or why not?",
                            answer: intake.recoveryInfo.peerSupportDetails
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Occupation",
                            answer: intake.recoveryInfo.occupation
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "What goals do you have around your occupational life?",
                            answer: intake.recoveryInfo.occupationalGoals
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Personal Reflections",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Are there any current family dynamic goals you are working towards?",
                            answer: intake.recoveryInfo.familyDynamicGoals
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "What do you want to accomplish while enrolled in Accountable?",
                            answer: intake.recoveryInfo.accountableGoals
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Anything else we haven't covered that you would want us to know?",
                            answer: intake.recoveryInfo.additionalInformation
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsxs)(Section, {
                    title: "Emergency Planning",
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Emergency Contact Name",
                            answer: `${intake.emergencyContact.firstName} ${intake.emergencyContact.lastName}`
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)(QuestionAnswer, {
                            question: "Emergency Contact Phone",
                            answer: intake.emergencyContact.phone
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
        open: props.open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        fullWidth: true,
        maxWidth: "lg",
        PaperProps: {
            sx: {
                p: 2
            }
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9f741.default), {
                sx: {
                    pb: 2
                },
                children: [
                    props.name,
                    "'s Intake"
                ]
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2gTUh.default), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $aXBMD.default), {
                    component: "div",
                    children: intakeForm && (Array.isArray(intakeForm) ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jayBd.default), {
                        sx: {
                            width: "100%"
                        },
                        children: intakeForm.map((val)=>{
                            if (val) {
                                const newval = val.split(":");
                                return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f9Dhz.default), {
                                    sx: {
                                        flexDirection: "column",
                                        alignItems: "flex-start"
                                    },
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8Zcdm.default), {
                                        primary: newval[0],
                                        secondary: newval[1],
                                        primaryTypographyProps: {
                                            sx: {
                                                fontWeight: "bold"
                                            }
                                        }
                                    })
                                }, newval[0]);
                            }
                            return null;
                        })
                    }) : renderNewIntakeFormat(intakeForm))
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3kUUy.default), {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                    onClick: handleClose,
                    variant: "contained",
                    color: "primary",
                    sx: {
                        minWidth: 100
                    },
                    autoFocus: true,
                    children: "Close"
                })
            })
        ]
    });
};
var $95b60d3282505bce$export$2e2bcd8739ae039 = $95b60d3282505bce$var$Intake;

});
parcelRegister("giDLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ddd2b6ff44de634$export$2e2bcd8739ae039; });
const $8ddd2b6ff44de634$var$formatIntakeData = (data)=>{
    // If data is an array, it's the old format.
    if (Array.isArray(data)) {
        const intakeArray = data.map(([key, value])=>{
            try {
                switch(key){
                    case "q4_address":
                        return `Address: ${value.addr_line1}, ${value.addr_line2}, ${value.city}, ${value.state} ${value.postal}`;
                    case "q6_email":
                        return `Email: ${value}`;
                    case "q56_howDid":
                        return `Referred By: ${Array.isArray(value) ? value.join(", ") : value}`;
                    case "q63_areYou63":
                        return `Are you currently sober: ${value}`;
                    case "q67_whenWas":
                        return `Sober Date: ${value.month}/${value.day}/${value.year}`;
                    case "q95_whatAre":
                        return `What are your substances of choice: ${Array.isArray(value) ? value.join(", ") : (value === null || value === void 0 ? void 0 : value.other) || ""}`;
                    case "q97_areYou":
                        return `Are you currently on any medication: ${Object.values(value || {}).join(", ")}`;
                    case "q98_areYou98":
                        return `Are you currently in any treatment: ${Array.isArray(value) ? value.join(", ") : value}`;
                    case "q68_doYou68":
                        return `Physical Health Goals: ${value}`;
                    case "q70_occupation":
                        return `Occupation: ${value}`;
                    case "q71_whatGoals":
                        return `Occupational Goals: ${value}`;
                    case "q87_doYou":
                        return `12 Step or Other Peer Support Programs: ${value}`;
                    case "q88_ifYou88":
                        return `Peer Support Involvement: ${value}`;
                    case "q89_usExercise89":
                        return `Do you exercise: ${value}`;
                    case "q73_howMany":
                        return `Exercise frequency: ${value}`;
                    case "q90_isMeditation":
                        return `Do you meditate: ${value}`;
                    case "q76_howMany76":
                        return `Meditation frequency: ${value}`;
                    case "q77_whatDoes":
                        return `What does self care look like: ${value}`;
                    case "q79_ifThere":
                        return `How do you want to improve self care?: ${value}`;
                    case "q80_areThere80":
                        return `Family Dynamic Goals: ${value}`;
                    case "q92_whyDo":
                        return `Why do you want to get sober: ${value}`;
                    case "q78_isThere":
                        return `Is there anything else we should know: ${value}`;
                    case "q83_accountableEmergency":
                        return `Contact: ${value.last}, ${value.first}`;
                    case "q84_accountableEmergency84":
                        return `Contact Phone: ${value.full}`;
                    case "q85_doWe85":
                        return `Permission to contact with tox: ${value}`;
                    case "q86_doWe86":
                        return `Permission to contact with checkin: ${value}`;
                    case "q50_typeA":
                        return `Agreement Accepted: ${value}`;
                    case "q104_whatAre104":
                        return `Pronouns: ${value}`;
                    case "q105_whatIs":
                        return `Sexual Orientation: ${value}`;
                    case "q103_residentialDischarge":
                        return `Residential Discharge Date: ${value.month}/${value.day}/${value.year}`;
                    case "q52_signature":
                        return null;
                    case "q5_dateOf":
                        return `DOB: ${value.month}/${value.day}/${value.year}`;
                    case "q9_phone":
                        return `Phone: ${value.full}`;
                    case "q60_whatType":
                        return `What type of treatment have you received: ${Array.isArray(value) ? value.join(", ") : value}`;
                    default:
                        return null;
                }
            } catch (err) {
                console.log("Error processing intake field:", key, err);
                return null;
            }
        }).filter(Boolean); // Remove null values
        return intakeArray;
    }
    return data;
};
var $8ddd2b6ff44de634$export$2e2bcd8739ae039 = $8ddd2b6ff44de634$var$formatIntakeData;

});


parcelRegister("hQyaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe1cd648b6d32d8$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $4m0VC = parcelRequire("4m0VC");

var $62uyF = parcelRequire("62uyF");

var $6UFAs = parcelRequire("6UFAs");

var $f4GCu = parcelRequire("f4GCu");

var $jNIqE = parcelRequire("jNIqE");

var $9cmSC = parcelRequire("9cmSC");

var $hgbGA = parcelRequire("hgbGA");

var $e2odR = parcelRequire("e2odR");

var $3teb5 = parcelRequire("3teb5");

var $lqAxB = parcelRequire("lqAxB");

var $ewdxp = parcelRequire("ewdxp");

var $56aO2 = parcelRequire("56aO2");

var $4Lxv3 = parcelRequire("4Lxv3");
var $dObWN = parcelRequire("dObWN");

var $04Fi6 = parcelRequire("04Fi6");

var $lP7jz = parcelRequire("lP7jz");

var $gnvKK = parcelRequire("gnvKK");

var $aTbGF = parcelRequire("aTbGF");

var $9alxb = parcelRequire("9alxb");

var $cWJc2 = parcelRequire("cWJc2");

var $ekoiq = parcelRequire("ekoiq");

var $h2Xtr = parcelRequire("h2Xtr");

var $en0cX = parcelRequire("en0cX");

var $gb9ZN = parcelRequire("gb9ZN");

var $lvs1O = parcelRequire("lvs1O");
const $cfe1cd648b6d32d8$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(2)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        }
    }));
const $cfe1cd648b6d32d8$var$Notes = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [notes, setNotes] = (0, $dgG1Y.useState)(null);
    const [showAddNotes, setShowAddNotes] = (0, $dgG1Y.useState)(false);
    const [selectedNote, setSelectedNote] = (0, $dgG1Y.useState)();
    const [dateFilter, setDateFilter] = (0, $dgG1Y.useState)(false);
    const [callFilter, setCallFilter] = (0, $dgG1Y.useState)(false);
    const [emailFilter, setEmailFilter] = (0, $dgG1Y.useState)(false);
    const [notifyFilter, setNotifyFilter] = (0, $dgG1Y.useState)(false);
    const [meetingFilter, setMeetingFilter] = (0, $dgG1Y.useState)(false);
    const [fileFilter, setFileFilter] = (0, $dgG1Y.useState)(false);
    const [familyContactFilter, setFamilyContactFilter] = (0, $dgG1Y.useState)(false);
    const [clinicalContactFilter, setClinicalContactFilter] = (0, $dgG1Y.useState)(false);
    const [onboardingNotesFilter, setOnboardingNotesFilter] = (0, $dgG1Y.useState)(false);
    const [essentialInfoFilter, setEssentialInfoFilter] = (0, $dgG1Y.useState)(false);
    const classes = $cfe1cd648b6d32d8$var$useStyles();
    const handleClose = ()=>{
        props.close();
    };
    (0, $dgG1Y.useEffect)(()=>{
        const getIntake = async ()=>{
            try {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/getnotes", "POST", JSON.stringify({
                    id: props.id
                }), {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData && !responseData.message) {
                    let noteData = responseData;
                    if (dateFilter) noteData = noteData.filter((response)=>response.date > dateFilter);
                    if (callFilter) noteData = noteData.filter((response)=>response.call);
                    if (emailFilter) noteData = noteData.filter((response)=>response.email);
                    if (meetingFilter) noteData = noteData.filter((response)=>response.checkin);
                    if (fileFilter) noteData = noteData.filter((response)=>response.file);
                    if (clinicalContactFilter) noteData = noteData.filter((response)=>response.clinicalContact);
                    if (familyContactFilter) noteData = noteData.filter((response)=>response.familyContact);
                    if (essentialInfoFilter) noteData = noteData.filter((response)=>response.essentialInfo);
                    setNotes(noteData);
                }
            } catch (err) {
                console.error(err);
            }
        };
        getIntake();
    }, [
        props.id,
        sendRequest,
        callFilter,
        emailFilter,
        dateFilter,
        notifyFilter,
        meetingFilter,
        fileFilter,
        clinicalContactFilter,
        familyContactFilter,
        essentialInfoFilter,
        auth.token
    ]);
    const addNote = ()=>{
        setShowAddNotes(true);
    };
    const closeNote = (addNote)=>{
        if (addNote && addNote.delete) setNotes([
            ...notes.filter((oldNote)=>oldNote._id !== addNote.delete)
        ]);
        else if (addNote && !selectedNote) {
            const updatedNotes = [
                ...notes,
                addNote
            ].sort((a, b)=>new Date(b.date) - new Date(a.date));
            setNotes(updatedNotes);
        } else if (addNote) {
            const updatedNotes = [
                ...notes.filter((oldNote)=>oldNote._id !== addNote._id),
                addNote
            ].sort((a, b)=>new Date(b.date) - new Date(a.date));
            setNotes(updatedNotes);
        }
        setShowAddNotes(false);
        setSelectedNote(null);
    };
    const onNoteClick = (event)=>{
        setSelectedNote(event.currentTarget.attributes.value.nodeValue);
        setShowAddNotes(true);
    };
    const handleSendEmail = (event)=>{
        setEmailFilter(!emailFilter);
    };
    const handlePhoneCall = (event)=>{
        setCallFilter(!callFilter);
    };
    const handleMeetingFilter = (event)=>{
        setMeetingFilter(!meetingFilter);
    };
    const handleFileFilter = (event)=>{
        setFileFilter(!fileFilter);
    };
    const handleSetDate = (event)=>{
        setDateFilter(event.currentTarget.value);
    };
    const handleClinicalContactFilter = (event)=>{
        setClinicalContactFilter(!clinicalContactFilter);
    };
    const handleOnboardingNotesFilter = (event)=>{
        setOnboardingNotesFilter(!onboardingNotesFilter);
    };
    const handleFamilyContactFilter = (event)=>{
        setFamilyContactFilter(!familyContactFilter);
    };
    const handleEssentialInfoFilter = (event)=>{
        setEssentialInfoFilter(!essentialInfoFilter);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Access Denied",
                alert: error,
                clearError: ()=>{
                    clearError();
                    handleClose();
                }
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lP7jz.default), {
                open: showAddNotes,
                close: closeNote,
                editVal: selectedNote,
                uid: props.id,
                auth: auth
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $62uyF.default), {
                open: props.open,
                onClose: handleClose,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                fullWidth: true,
                maxWidth: "md",
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lqAxB.default), {
                        children: [
                            props.name,
                            "'s Notes"
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $f4GCu.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3teb5.default), {
                                align: "right",
                                children: (auth.accountableAdmin || auth.programProvider || auth.program || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                    color: "secondary",
                                    onClick: addNote,
                                    children: [
                                        "Add Note\xa0\xa0",
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04Fi6))), {
                                            color: "secondary",
                                            fontSize: "small"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Phone Calls"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Phone Call",
                                        name: "restrictedUser",
                                        onChange: handlePhoneCall,
                                        checked: callFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Email"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Email Sent",
                                        name: "restrictedUser",
                                        onChange: handleSendEmail,
                                        checked: emailFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Meetings"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Only Meetings",
                                        name: "restrictedUser",
                                        onChange: handleMeetingFilter,
                                        checked: meetingFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Files"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Only Files",
                                        name: "restrictedUser",
                                        onChange: handleFileFilter,
                                        checked: fileFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Clinical Contact"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Only Clinical Contact",
                                        name: "restrictedUser",
                                        onChange: handleClinicalContactFilter,
                                        checked: clinicalContactFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Family Contact"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Only Family Contact",
                                        name: "restrictedUser",
                                        onChange: handleFamilyContactFilter,
                                        checked: familyContactFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Onboarding"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Only onboarding notes",
                                        name: "restrictedUser",
                                        onChange: handleOnboardingNotesFilter,
                                        checked: onboardingNotesFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Only Essential Info"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Only Essential Info",
                                        name: "restrictedUser",
                                        onChange: handleEssentialInfoFilter,
                                        checked: essentialInfoFilter,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                    id: "date",
                                    label: "Start Date",
                                    type: "date",
                                    defaultValue: "",
                                    onChange: handleSetDate,
                                    className: classes.textField,
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jNIqE.default), {}),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3teb5.default), {
                                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $e2odR.default), {
                                    children: [
                                        notes && notes.length > 0 && notes.map((val)=>{
                                            if (val) return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9cmSC.default), {
                                                button: true,
                                                onClick: onNoteClick,
                                                value: val._id,
                                                children: [
                                                    val.call && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Lxv3.default), {
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gnvKK))), {})
                                                    }),
                                                    val.essentialInfo && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Lxv3.default), {
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lvs1O.default), {})
                                                    }),
                                                    val.email && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Lxv3.default), {
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTbGF))), {})
                                                    }),
                                                    val.file && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4Lxv3.default), {
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gb9ZN))), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $dObWN.default), {
                                                        primary: val.note.substr(0, 200) + " -Written By: " + val.Signature + "...",
                                                        secondary: new Date(val.date).toLocaleString() + " ...Click to Read More"
                                                    })
                                                ]
                                            }, val._id);
                                        }),
                                        notes && notes.length == 0 && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9cmSC.default), {
                                            button: true,
                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $dObWN.default), {
                                                primary: "No notes have been entered yet.",
                                                secondary: new Date().toLocaleString()
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6UFAs.default), {
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                            onClick: handleClose,
                            variant: "contained",
                            value: false,
                            color: "primary",
                            autoFocus: true,
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
};
var $cfe1cd648b6d32d8$export$2e2bcd8739ae039 = $cfe1cd648b6d32d8$var$Notes;

});
parcelRegister("4Lxv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $378589904b9a9e12$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $1vdtn = parcelRequire("1vdtn");
var $378589904b9a9e12$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            minWidth: 56,
            color: theme.palette.action.active,
            flexShrink: 0,
            display: "inline-flex"
        },
        /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
            marginTop: 8
        }
    };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ var $378589904b9a9e12$var$ListItemIcon = /*#__PURE__*/ $dgG1Y.forwardRef(function ListItemIcon(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className"
    ]);
    var context = $dgG1Y.useContext((0, $1vdtn.default));
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, context.alignItems === "flex-start" && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $378589904b9a9e12$export$2e2bcd8739ae039 = (0, $7xfqK.default)($378589904b9a9e12$export$9dd6ff9ea0189349, {
    name: "MuiListItemIcon"
})($378589904b9a9e12$var$ListItemIcon);

});

parcelRegister("dObWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d936584bf5a5f1$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $1QHfa = parcelRequire("1QHfa");

var $1vdtn = parcelRequire("1vdtn");
var $a0d936584bf5a5f1$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $a0d936584bf5a5f1$var$ListItemText = /*#__PURE__*/ $dgG1Y.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $gZz4Z.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $dgG1Y.useContext((0, $1vdtn.default)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $1QHfa.default) && !disableTypography) primary = /*#__PURE__*/ $dgG1Y.createElement((0, $1QHfa.default), (0, $bh1oa.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $1QHfa.default) && !disableTypography) secondary = /*#__PURE__*/ $dgG1Y.createElement((0, $1QHfa.default), (0, $bh1oa.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $dgG1Y.createElement("div", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $a0d936584bf5a5f1$export$2e2bcd8739ae039 = (0, $7xfqK.default)($a0d936584bf5a5f1$export$9dd6ff9ea0189349, {
    name: "MuiListItemText"
})($a0d936584bf5a5f1$var$ListItemText);

});

parcelRegister("lP7jz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe3408f2ad9dcc9e$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $en0cX = parcelRequire("en0cX");

var $4m0VC = parcelRequire("4m0VC");

var $i6p4h = parcelRequire("i6p4h");

var $62uyF = parcelRequire("62uyF");

var $hgbGA = parcelRequire("hgbGA");

var $6UFAs = parcelRequire("6UFAs");

var $f4GCu = parcelRequire("f4GCu");

var $9alxb = parcelRequire("9alxb");

var $cWJc2 = parcelRequire("cWJc2");

var $ekoiq = parcelRequire("ekoiq");

var $lqAxB = parcelRequire("lqAxB");

var $jUw8I = parcelRequire("jUw8I");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $h2Xtr = parcelRequire("h2Xtr");

var $lRVfF = parcelRequire("lRVfF");

var $gb9ZN = parcelRequire("gb9ZN");

var $75YVs = parcelRequire("75YVs");

var $8EQoK = parcelRequire("8EQoK");

var $htjEL = parcelRequire("htjEL");
const $fe3408f2ad9dcc9e$var$schema = {
    note: [
        (0, $htjEL.required)
    ]
};
const $fe3408f2ad9dcc9e$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(2)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        }
    }));
const $fe3408f2ad9dcc9e$var$AddNote = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $fe3408f2ad9dcc9e$var$useStyles();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const { hasError: hasError, handleChange: handleChange, formState: formState } = (0, $jUw8I.useForm)($fe3408f2ad9dcc9e$var$schema);
    const [open, setOpen] = (0, $dgG1Y.useState)(false);
    const [note, setNote] = (0, $dgG1Y.useState)(); //for edit
    const [phoneCall, setPhoneCall] = (0, $dgG1Y.useState)(false);
    const [checkin, setCheckin] = (0, $dgG1Y.useState)(false);
    const [sendNotification, setSendNotification] = (0, $dgG1Y.useState)(false);
    const [file, setFile] = (0, $dgG1Y.useState)();
    const [clinicalContact, setclinicalContact] = (0, $dgG1Y.useState)(false);
    const [familyContact, setfamilyContact] = (0, $dgG1Y.useState)(false);
    const [transcription, setTranscription] = (0, $dgG1Y.useState)("");
    const [recognizing, setRecognizing] = (0, $dgG1Y.useState)(false);
    const [key, setKey] = (0, $dgG1Y.useState)("");
    const [region, setRegion] = (0, $dgG1Y.useState)("");
    const [recognizers, setRecognizer] = (0, $dgG1Y.useState)("");
    const [email, setEmail] = (0, $dgG1Y.useState)(false);
    const [emailText, setEmailText] = (0, $dgG1Y.useState)("");
    const [openTemplate, setOpenTemplate] = (0, $dgG1Y.useState)(false);
    const [essentialInfo, setEssentialInfo] = (0, $dgG1Y.useState)(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = (0, $dgG1Y.useState)(false);
    const localToUTC = (dateString)=>{
        const date = new Date(dateString);
        return date.toISOString();
    };
    const UTCToLocal = (dateString)=>{
        const date = new Date(dateString);
        return date.toLocaleString("sv-SE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }).replace(" ", "T");
    };
    const [noteDate, setNoteDate] = (0, $dgG1Y.useState)(UTCToLocal(new Date()));
    const startRecognition = async ()=>{
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/gpt/getAWSKeys", "GET", null, {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            setKey(responseData.accessKeyId);
            setRegion(responseData.region);
            // Set up the Azure Speech SDK
            const speechConfig = (0, $8EQoK.SpeechConfig).fromSubscription(responseData.accessKeyId, responseData.region);
            const audioConfig = (0, $8EQoK.AudioConfig).fromDefaultMicrophoneInput();
            const recognizer = new (0, $8EQoK.SpeechRecognizer)(speechConfig, audioConfig);
            setRecognizer(recognizer);
            // Set recognizing to true to show the user that recognition has started
            setRecognizing(true);
            // Attach event handlers
            recognizer.recognizing = ()=>{
            //setTranscription(e.result.text);
            // console.log(e.result.text)
            };
            recognizer.recognized = (s, e)=>{
                if (e.result.text) setTranscription((prevTranscription)=>`${prevTranscription} ${e.result.text}`);
            //console.log(e.result.text)
            };
            recognizer.canceled = ()=>{
                recognizer.stopContinuousRecognitionAsync();
                setRecognizing(false);
            };
            recognizer.sessionStopped = ()=>{
                recognizer.stopContinuousRecognitionAsync();
                setRecognizing(false);
            };
            // Start recognizing
            recognizer.startContinuousRecognitionAsync();
            // Set a timeout to stop recognition after 1 hour and 15 minutes (4,500,000 milliseconds)
            setTimeout(()=>{
                if (recognizing) {
                    stopRecognition();
                    console.log("Speech recognition automatically stopped after 1 hour and 15 minutes.");
                }
            }, 4500000);
        } catch (err) {}
    };
    const stopRecognition = ()=>{
        recognizers.stopContinuousRecognitionAsync();
        setRecognizing(false);
    };
    (0, $dgG1Y.useEffect)(()=>{
        //check if this form is for editing
        const getMessage = async ()=>{
            try {
                if (props.editVal) {
                    const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/getnote", "POST", JSON.stringify({
                        id: props.editVal
                    }), {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + auth.token
                    });
                    if (responseData._id) {
                        setEmail(responseData.email);
                        setPhoneCall(responseData.call);
                        setclinicalContact(responseData.clinicalContact);
                        setfamilyContact(responseData.familyContact);
                        setNoteDate(UTCToLocal(responseData.date));
                        responseData.utcDate = responseData.date;
                        responseData.date = new Date(responseData.date).getUTCFullYear() + "-" + ("0" + (new Date(responseData.date).getUTCMonth() + 1)).slice(-2) + "-" + ("0" + new Date(responseData.date).getUTCDate()).slice(-2) + "T" + new Date(responseData.date).getUTCHours() + ":" + ("0" + new Date(responseData.date).getUTCMinutes()).slice(-2);
                        setNote(responseData);
                    }
                }
            } catch (err) {}
        };
        formState.values.note = "";
        setNote(null);
        setNoteDate(UTCToLocal(new Date()));
        getMessage();
    }, [
        open
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        //validate form from getgo.
        try {
            if (note) {
                const note = document.querySelector("input[name='note']");
                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                const nativeTextAreaValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value").set;
                nativeInputValueSetter.call(note, "is working");
                const inputEvent = new Event("input", {
                    bubbles: true
                });
                note.dispatchEvent(inputEvent);
            }
        } catch (err) {}
        if (recognizing) stopRecognition();
    }, [
        open,
        note
    ]);
    const generateNote = async ()=>{
        const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/gpt/generateNote", "POST", JSON.stringify({
            transcript: transcription
        }), {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token
        });
        if (responseData.response) setNote({
            note: responseData.response
        });
    };
    const generateEmail = async ()=>{
        const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/gpt/generateCoordinationNote", "POST", JSON.stringify({
            transcript: formState.values.note || note.note
        }), {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token
        });
        if (responseData.response) setEmailText(responseData.response);
    };
    (0, $dgG1Y.useEffect)(()=>{
        if (formState.values.note !== ((note === null || note === void 0 ? void 0 : note.note) || "")) setHasUnsavedChanges(true);
    }, [
        formState.values.note,
        note
    ]);
    const handleSave = async (event)=>{
        event.preventDefault();
        let responseData = null;
        try {
            const formData = new FormData();
            formData.append("file", file);
            responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/setnotes", "POST", JSON.stringify({
                id: props.editVal,
                member: props.uid,
                note: formState.values.note,
                date: localToUTC(noteDate),
                email: email || sendNotification,
                call: phoneCall,
                notify: sendNotification,
                essentialInfo: essentialInfo,
                checkin: checkin,
                meetingID: props.meetingID,
                clinicalContact: clinicalContact,
                familyContact: familyContact
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (file && responseData._id) try {
                formData.append("noteID", responseData._id);
                await sendRequest("https://apiv2.youareaccountable.com/api/upload/uploadDocs", "POST", formData, {
                    Authorization: "Bearer " + auth.token
                });
            } catch (err) {
                console.log(err);
            }
            setFile(null);
            setHasUnsavedChanges(false);
            setOpen(false);
            props.close(responseData);
        } catch (err) {
            console.log(err);
        }
    };
    const handleDelete = async (event)=>{
        event.preventDefault();
        try {
            const deleteNote = await (0, $75YVs.default)("Are you sure you would like to delete this note?");
            if (deleteNote) {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/deletenote", "POST", JSON.stringify({
                    noteid: props.editVal
                }), {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData.valid) props.close({
                    delete: props.editVal
                }); //remove deleted object
            }
        } catch (err) {}
    };
    const handleCancel = async (event)=>{
        event.preventDefault();
        if (hasUnsavedChanges) {
            const shouldClose = await (0, $75YVs.default)("You have unsaved changes. Are you sure you want to close?");
            if (!shouldClose) return;
        }
        setHasUnsavedChanges(false);
        setOpen(false);
        props.close(false);
    };
    (0, $dgG1Y.useEffect)(()=>{
        setOpen(props.open);
    }, [
        props.open
    ]);
    const handleSendEmail = ()=>{
        setEmail(!email);
    };
    const handlePhoneCall = ()=>{
        setPhoneCall(!phoneCall);
    };
    const handleNotify = ()=>{
        setSendNotification(!sendNotification);
    };
    const handleCheckin = ()=>{
        setCheckin(!checkin);
    };
    const handleClinicalContact = ()=>{
        setclinicalContact(!clinicalContact);
    };
    const handleFamilyContact = ()=>{
        setfamilyContact(!familyContact);
    };
    const resetTranscription = ()=>{
        setTranscription(null);
    };
    const handleEssentialInfo = ()=>{
        setEssentialInfo(!essentialInfo);
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Goal",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $62uyF.default), {
                open: open,
                onClose: handleCancel,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                fullWidth: true,
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lqAxB.default), {
                        children: "Add/Edit Note"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $f4GCu.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                className: classes.textField,
                                error: hasError("note"),
                                fullWidth: true,
                                helperText: hasError("note") ? formState.errors.note[0] : null,
                                label: "Note",
                                name: "note",
                                multiline: true,
                                onChange: handleChange,
                                value: formState.values.note || note && note.note || "",
                                variant: "outlined",
                                disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                            }),
                            note && note.Signature && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $cWJc2.default), {
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                    `Written By: ${note.Signature} on ${new Date(note.utcDate).toLocaleString()}`
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                className: classes.textField,
                                fullWidth: true,
                                label: "Date and Time (Local)",
                                name: "noteDate",
                                type: "datetime-local",
                                value: noteDate,
                                onChange: (e)=>setNoteDate(e.target.value),
                                InputLabelProps: {
                                    shrink: true
                                },
                                variant: "outlined"
                            }),
                            (!note || note && !note.file) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                className: classes.textField,
                                fullWidth: true,
                                label: "File",
                                name: "file",
                                onChange: (event)=>{
                                    setFile(event.target.files[0]);
                                },
                                type: "file",
                                variant: "outlined",
                                InputLabelProps: {
                                    shrink: true
                                }
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                            note && note.file && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                onClick: ()=>{
                                    window.open(note.file, "_blank");
                                },
                                children: [
                                    "Download File\xa0\xa0",
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gb9ZN))), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Phone Call"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        error: hasError("restrictedUser"),
                                        fullWidth: true,
                                        helperText: hasError("restrictedUser") ? formState.errors.phoneCall[0] : null,
                                        label: "Phone Call",
                                        name: "restrictedUser",
                                        onChange: handlePhoneCall,
                                        checked: phoneCall,
                                        variant: "outlined",
                                        disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Email Sent"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        error: hasError("restrictedUser"),
                                        fullWidth: true,
                                        helperText: hasError("restrictedUser") ? formState.errors.email[0] : null,
                                        label: "Email Sent",
                                        name: "restrictedUser",
                                        onChange: handleSendEmail,
                                        checked: email,
                                        variant: "outlined",
                                        disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Notify Care Team"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        error: hasError("restrictedUser"),
                                        fullWidth: true,
                                        helperText: hasError("restrictedUser") ? formState.errors.notify[0] : null,
                                        label: "Notify Care Team",
                                        name: "restrictedUser",
                                        onChange: handleNotify,
                                        checked: sendNotification,
                                        variant: "outlined",
                                        disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Check-in Meeting"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        error: hasError("restrictedUser"),
                                        fullWidth: true,
                                        helperText: hasError("restrictedUser") ? formState.errors.checkin[0] : null,
                                        label: "Notify Care Team",
                                        name: "restrictedUser",
                                        onChange: handleCheckin,
                                        checked: checkin,
                                        variant: "outlined",
                                        disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Family Contact"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        error: hasError("restrictedUser"),
                                        fullWidth: true,
                                        helperText: hasError("restrictedUser") ? formState.errors.checkin[0] : null,
                                        label: "Family Contact",
                                        name: "restrictedUser",
                                        onChange: handleFamilyContact,
                                        checked: familyContact,
                                        variant: "outlined",
                                        disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Clinical Contact"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        error: hasError("restrictedUser"),
                                        fullWidth: true,
                                        helperText: hasError("restrictedUser") ? formState.errors.checkin[0] : null,
                                        label: "Clinical Contact",
                                        name: "restrictedUser",
                                        onChange: handleClinicalContact,
                                        checked: clinicalContact,
                                        variant: "outlined",
                                        disabled: !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                className: classes.formControl,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                        id: "completedGoal-label",
                                        shrink: true,
                                        children: "Essential Info"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                        className: classes.textField,
                                        fullWidth: true,
                                        label: "Essential Info",
                                        name: "restrictedUser",
                                        onChange: handleEssentialInfo,
                                        checked: essentialInfo,
                                        variant: "outlined"
                                    })
                                ]
                            }),
                            props.auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $i6p4h.default), {
                                        size: "small",
                                        variant: "contained",
                                        color: "primary",
                                        "aria-label": "contained primary button group",
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: startRecognition,
                                                children: "Start"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: stopRecognition,
                                                children: "Stop"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: generateNote,
                                                children: "Generate Note"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: generateEmail,
                                                children: "Generate Coordination Email Note"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: resetTranscription,
                                                children: "Reset"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            transcription
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                        style: {
                                            "white-space": "pre-wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            emailText
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $6UFAs.default), {
                        children: [
                            (props.auth.accountableAdmin || props.auth.program || props.auth.programProvider || props.auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: handleSave,
                                variant: "contained",
                                color: "primary",
                                autoFocus: true,
                                disabled: !formState.isValid,
                                children: "Save Note"
                            }),
                            (props.auth.accountableAdmin || props.auth.program || props.auth.programProvider || props.auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: handleCancel,
                                variant: "contained",
                                color: "secondary",
                                children: "Cancel"
                            }),
                            !props.auth.accountableAdmin && !props.auth.program && !props.auth.programProvider && !props.auth.provider && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: handleCancel,
                                variant: "contained",
                                color: "secondary",
                                children: "Close"
                            }),
                            props.editVal && (props.auth.accountableAdmin || props.auth.program || props.auth.programProvider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: handleDelete,
                                variant: "contained",
                                style: {
                                    background: (0, $lRVfF).red[600],
                                    color: "white"
                                },
                                children: "Delete Note"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fe3408f2ad9dcc9e$export$2e2bcd8739ae039 = $fe3408f2ad9dcc9e$var$AddNote;

});
parcelRegister("9alxb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ac5c076fcb210bf$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $aaJYd = parcelRequire("aaJYd");

var $4u35b = parcelRequire("4u35b");

var $5YYV8 = parcelRequire("5YYV8");

var $4BFH5 = parcelRequire("4BFH5");

var $7ykI3 = parcelRequire("7ykI3");

var $bdWPY = parcelRequire("bdWPY");

var $7xfqK = parcelRequire("7xfqK");
var $6ac5c076fcb210bf$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $4BFH5.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $4BFH5.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $6ac5c076fcb210bf$var$defaultCheckedIcon = /*#__PURE__*/ $dgG1Y.createElement((0, $5YYV8.default), null);
var $6ac5c076fcb210bf$var$defaultIcon = /*#__PURE__*/ $dgG1Y.createElement((0, $4u35b.default), null);
var $6ac5c076fcb210bf$var$defaultIndeterminateIcon = /*#__PURE__*/ $dgG1Y.createElement((0, $7ykI3.default), null);
var $6ac5c076fcb210bf$var$Checkbox = /*#__PURE__*/ $dgG1Y.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $6ac5c076fcb210bf$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $6ac5c076fcb210bf$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $6ac5c076fcb210bf$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $gZz4Z.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $dgG1Y.createElement((0, $aaJYd.default), (0, $bh1oa.default)({
        type: "checkbox",
        classes: {
            root: (0, $cXVHi.default)(classes.root, classes["color".concat((0, $bdWPY.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $bh1oa.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $dgG1Y.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $dgG1Y.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $6ac5c076fcb210bf$export$2e2bcd8739ae039 = (0, $7xfqK.default)($6ac5c076fcb210bf$export$9dd6ff9ea0189349, {
    name: "MuiCheckbox"
})($6ac5c076fcb210bf$var$Checkbox);

});
parcelRegister("aaJYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $767e7f44cf6809d2$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $ckFPG = parcelRequire("ckFPG");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $ikQKD = parcelRequire("ikQKD");

var $fJyy2 = parcelRequire("fJyy2");

var $7xfqK = parcelRequire("7xfqK");

var $2aFzn = parcelRequire("2aFzn");
var $767e7f44cf6809d2$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: "inherit",
        position: "absolute",
        opacity: 0,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $767e7f44cf6809d2$var$SwitchBase = /*#__PURE__*/ $dgG1Y.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $gZz4Z.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $ikQKD.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    }), _useControlled2 = (0, $ckFPG.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $fJyy2.default)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === "checkbox" || type === "radio";
    return /*#__PURE__*/ $dgG1Y.createElement((0, $2aFzn.default), (0, $bh1oa.default)({
        component: "span",
        className: (0, $cXVHi.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $dgG1Y.createElement("input", (0, $bh1oa.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $767e7f44cf6809d2$export$2e2bcd8739ae039 = (0, $7xfqK.default)($767e7f44cf6809d2$export$9dd6ff9ea0189349, {
    name: "PrivateSwitchBase"
})($767e7f44cf6809d2$var$SwitchBase);

});
parcelRegister("2aFzn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194cc2cb88c42866$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $7xfqK = parcelRequire("7xfqK");

var $4BFH5 = parcelRequire("4BFH5");

var $9tnMP = parcelRequire("9tnMP");

var $bdWPY = parcelRequire("bdWPY");
var $194cc2cb88c42866$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $4BFH5.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $194cc2cb88c42866$var$IconButton = /*#__PURE__*/ $dgG1Y.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $gZz4Z.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $9tnMP.default), (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, color !== "default" && classes["color".concat((0, $bdWPY.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $bdWPY.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $dgG1Y.createElement("span", {
        className: classes.label
    }, children));
});
var $194cc2cb88c42866$export$2e2bcd8739ae039 = (0, $7xfqK.default)($194cc2cb88c42866$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($194cc2cb88c42866$var$IconButton);

});


parcelRegister("4u35b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $343c5ae933096615$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $6mYJl = parcelRequire("6mYJl");
var /**
 * @ignore - internal component.
 */ $343c5ae933096615$export$2e2bcd8739ae039 = (0, $6mYJl.default)(/*#__PURE__*/ $dgG1Y.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRegister("5YYV8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45b1cfe421616b4d$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $6mYJl = parcelRequire("6mYJl");
var /**
 * @ignore - internal component.
 */ $45b1cfe421616b4d$export$2e2bcd8739ae039 = (0, $6mYJl.default)(/*#__PURE__*/ $dgG1Y.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRegister("7ykI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57fbc5e3fcb129d7$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $6mYJl = parcelRequire("6mYJl");
var /**
 * @ignore - internal component.
 */ $57fbc5e3fcb129d7$export$2e2bcd8739ae039 = (0, $6mYJl.default)(/*#__PURE__*/ $dgG1Y.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});


parcelRegister("gb9ZN", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc756d5ff5cb0c59$var$React = $3kONX((parcelRequire("dgG1Y")));

var $bc756d5ff5cb0c59$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $bc756d5ff5cb0c59$var$_default = (0, $bc756d5ff5cb0c59$var$_createSvgIcon.default)(/*#__PURE__*/ $bc756d5ff5cb0c59$var$React.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
}), "CloudDownload");
module.exports.default = $bc756d5ff5cb0c59$var$_default;

});

parcelRegister("75YVs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86cab74f743cd702$export$2e2bcd8739ae039; });

var $jaG8V = parcelRequire("jaG8V");

var $izV8o = parcelRequire("izV8o");
const $86cab74f743cd702$var$confirm = (0, $izV8o.createConfirmation)((0, $jaG8V.default));
function $86cab74f743cd702$export$2e2bcd8739ae039(confirmation, options = {}) {
    return $86cab74f743cd702$var$confirm({
        confirmation: confirmation,
        ...options
    });
}

});
parcelRegister("jaG8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $955c3d3781cacdb8$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $iJ8f3 = parcelRequire("iJ8f3");
var $9EE4V = parcelRequire("9EE4V");
var $3kUUy = parcelRequire("3kUUy");
var $2gTUh = parcelRequire("2gTUh");
var $9f741 = parcelRequire("9f741");

var $izV8o = parcelRequire("izV8o");
const $955c3d3781cacdb8$var$Confirmation = ({ okLabel: okLabel = "Yes", cancelLabel: cancelLabel = "No", title: title = "Confirmation", confirmation: confirmation, show: show, proceed: proceed, dismiss: dismiss, cancel: cancel, modal: modal })=>{
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $9EE4V.default), {
        open: show,
        onClose: dismiss,
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9f741.default), {
                children: title
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2gTUh.default), {
                children: confirmation
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $3kUUy.default), {
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                        variant: "text",
                        onClick: cancel,
                        children: cancelLabel
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                        variant: "contained",
                        onClick: proceed,
                        children: okLabel
                    })
                ]
            })
        ]
    });
};
var $955c3d3781cacdb8$export$2e2bcd8739ae039 = (0, $izV8o.confirmable)($955c3d3781cacdb8$var$Confirmation);

});
parcelRegister("izV8o", function(module, exports) {
"use strict";
function $d867d09857be4ddf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d867d09857be4ddf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d867d09857be4ddf$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "confirmable", {
    enumerable: true,
    get: function get() {
        return $d867d09857be4ddf$var$_confirmable["default"];
    }
});
Object.defineProperty(module.exports, "createConfirmation", {
    enumerable: true,
    get: function get() {
        return $d867d09857be4ddf$var$_createConfirmation["default"];
    }
});
Object.defineProperty(module.exports, "createConfirmationCreater", {
    enumerable: true,
    get: function get() {
        return $d867d09857be4ddf$var$_createConfirmation.createConfirmationCreater;
    }
});
Object.defineProperty(module.exports, "createDomTreeMounter", {
    enumerable: true,
    get: function get() {
        return $7s4iH.createDomTreeMounter;
    }
});
Object.defineProperty(module.exports, "createMountPoint", {
    enumerable: true,
    get: function get() {
        return $da8IE.createMountPoint;
    }
});
Object.defineProperty(module.exports, "createReactTreeMounter", {
    enumerable: true,
    get: function get() {
        return $da8IE.createReactTreeMounter;
    }
});

var $d867d09857be4ddf$var$_confirmable = $d867d09857be4ddf$var$_interopRequireDefault((parcelRequire("dmrXA")));

var $d867d09857be4ddf$var$_createConfirmation = $d867d09857be4ddf$var$_interopRequireWildcard((parcelRequire("97Xlo")));

var $7s4iH = parcelRequire("7s4iH");

var $da8IE = parcelRequire("da8IE");
function $d867d09857be4ddf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d867d09857be4ddf$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d867d09857be4ddf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $d867d09857be4ddf$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $d867d09857be4ddf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d867d09857be4ddf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("dmrXA", function(module, exports) {
"use strict";
function $9ba304be49fe779f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9ba304be49fe779f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9ba304be49fe779f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9ba304be49fe779f$var$_react = $9ba304be49fe779f$var$_interopRequireWildcard((parcelRequire("dgG1Y")));
var $9ba304be49fe779f$var$_excluded = [
    "dispose",
    "reject",
    "resolve"
];
function $9ba304be49fe779f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9ba304be49fe779f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9ba304be49fe779f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9ba304be49fe779f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $9ba304be49fe779f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9ba304be49fe779f$var$_extends() {
    $9ba304be49fe779f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ba304be49fe779f$var$_extends.apply(this, arguments);
}
function $9ba304be49fe779f$var$_slicedToArray(arr, i) {
    return $9ba304be49fe779f$var$_arrayWithHoles(arr) || $9ba304be49fe779f$var$_iterableToArrayLimit(arr, i) || $9ba304be49fe779f$var$_unsupportedIterableToArray(arr, i) || $9ba304be49fe779f$var$_nonIterableRest();
}
function $9ba304be49fe779f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9ba304be49fe779f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9ba304be49fe779f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9ba304be49fe779f$var$_arrayLikeToArray(o, minLen);
}
function $9ba304be49fe779f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9ba304be49fe779f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9ba304be49fe779f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9ba304be49fe779f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9ba304be49fe779f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9ba304be49fe779f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9ba304be49fe779f$var$confirmable = function confirmable(Component) {
    return function(_ref) {
        var dispose = _ref.dispose, reject = _ref.reject, resolve = _ref.resolve, other = $9ba304be49fe779f$var$_objectWithoutProperties(_ref, $9ba304be49fe779f$var$_excluded);
        var _useState = (0, $9ba304be49fe779f$var$_react.useState)(true), _useState2 = $9ba304be49fe779f$var$_slicedToArray(_useState, 2), show = _useState2[0], setShow = _useState2[1];
        var dismiss = function dismiss() {
            setShow(false);
            dispose();
        };
        var cancel = function cancel(value) {
            setShow(false);
            reject(value);
        };
        var proceed = function proceed(value) {
            setShow(false);
            resolve(value);
        };
        return /*#__PURE__*/ $9ba304be49fe779f$var$_react["default"].createElement(Component, $9ba304be49fe779f$var$_extends({
            cancel: cancel,
            dismiss: dismiss,
            proceed: proceed,
            show: show
        }, other));
    };
};
var $9ba304be49fe779f$var$_default = $9ba304be49fe779f$var$confirmable;
module.exports["default"] = $9ba304be49fe779f$var$_default;

});

parcelRegister("97Xlo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.createConfirmationCreater = void 0;

var $7s4iH = parcelRequire("7s4iH");
function $6a52cd041dfa53a8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6a52cd041dfa53a8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6a52cd041dfa53a8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6a52cd041dfa53a8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6a52cd041dfa53a8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6a52cd041dfa53a8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6a52cd041dfa53a8$var$createConfirmationCreater = function createConfirmationCreater(mounter) {
    return function(Component) {
        var unmountDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
        var mountingNode = arguments.length > 2 ? arguments[2] : undefined;
        return function(props) {
            var mountId;
            var promise = new Promise(function(resolve, reject) {
                try {
                    mountId = mounter.mount(Component, $6a52cd041dfa53a8$var$_objectSpread({
                        reject: reject,
                        resolve: resolve,
                        dispose: dispose
                    }, props), mountingNode);
                } catch (e) {
                    console.error(e);
                    throw e;
                }
            });
            function dispose() {
                setTimeout(function() {
                    mounter.unmount(mountId);
                }, unmountDelay);
            }
            return promise.then(function(result) {
                dispose();
                return result;
            }, function(result) {
                dispose();
                return Promise.reject(result);
            });
        };
    };
};
module.exports.createConfirmationCreater = $6a52cd041dfa53a8$var$createConfirmationCreater;
var $6a52cd041dfa53a8$var$_default = $6a52cd041dfa53a8$var$createConfirmationCreater((0, $7s4iH.createDomTreeMounter)());
module.exports["default"] = $6a52cd041dfa53a8$var$_default;

});
parcelRegister("7s4iH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDomTreeMounter = $56ce7bf04112fbe7$var$createDomTreeMounter;

var $56ce7bf04112fbe7$var$_react = $56ce7bf04112fbe7$var$_interopRequireDefault((parcelRequire("dgG1Y")));

var $8iZJl = parcelRequire("8iZJl");
function $56ce7bf04112fbe7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $56ce7bf04112fbe7$var$createDomTreeMounter(defaultMountNode) {
    var confirms = {};
    var callbacks = {};
    function mount(Component, props, mountNode) {
        var key = Math.floor(Math.random() * 1073741824).toString(16);
        var wrapper = (mountNode || defaultMountNode || document.body).appendChild(document.createElement("div"));
        confirms[key] = wrapper;
        var root = (0, $8iZJl.createRoot)(wrapper);
        root.render(/*#__PURE__*/ $56ce7bf04112fbe7$var$_react["default"].createElement(Component, props));
        callbacks.mounted && callbacks.mounted();
        return key;
    }
    function unmount(key) {
        var wrapper = confirms[key];
        delete confirms[key];
        if (wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
    }
    return {
        mount: mount,
        unmount: unmount,
        options: {}
    };
}

});
parcelRegister("8iZJl", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $60bfe386a3c28e23$export$882461b6382ed46c; }, function (v) { return $60bfe386a3c28e23$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $60bfe386a3c28e23$export$757ceba2d55c277e; }, function (v) { return $60bfe386a3c28e23$export$757ceba2d55c277e = v; });
var $60bfe386a3c28e23$export$882461b6382ed46c;
var $60bfe386a3c28e23$export$757ceba2d55c277e;
"use strict";

var $8idXE = parcelRequire("8idXE");
var $60bfe386a3c28e23$var$i;
$60bfe386a3c28e23$export$882461b6382ed46c = $8idXE.createRoot;
$60bfe386a3c28e23$export$757ceba2d55c277e = $8idXE.hydrateRoot;

});



parcelRegister("da8IE", function(module, exports) {
"use strict";
function $9952f8ff1d41cd91$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9952f8ff1d41cd91$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9952f8ff1d41cd91$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMountPoint = $9952f8ff1d41cd91$var$createMountPoint;
module.exports.createReactTreeMounter = $9952f8ff1d41cd91$var$createReactTreeMounter;

var $9952f8ff1d41cd91$var$_react = $9952f8ff1d41cd91$var$_interopRequireWildcard((parcelRequire("dgG1Y")));

var $8idXE = parcelRequire("8idXE");
function $9952f8ff1d41cd91$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9952f8ff1d41cd91$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9952f8ff1d41cd91$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9952f8ff1d41cd91$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $9952f8ff1d41cd91$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9952f8ff1d41cd91$var$_extends() {
    $9952f8ff1d41cd91$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9952f8ff1d41cd91$var$_extends.apply(this, arguments);
}
function $9952f8ff1d41cd91$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9952f8ff1d41cd91$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9952f8ff1d41cd91$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9952f8ff1d41cd91$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9952f8ff1d41cd91$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9952f8ff1d41cd91$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9952f8ff1d41cd91$var$_slicedToArray(arr, i) {
    return $9952f8ff1d41cd91$var$_arrayWithHoles(arr) || $9952f8ff1d41cd91$var$_iterableToArrayLimit(arr, i) || $9952f8ff1d41cd91$var$_unsupportedIterableToArray(arr, i) || $9952f8ff1d41cd91$var$_nonIterableRest();
}
function $9952f8ff1d41cd91$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9952f8ff1d41cd91$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9952f8ff1d41cd91$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9952f8ff1d41cd91$var$_arrayLikeToArray(o, minLen);
}
function $9952f8ff1d41cd91$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9952f8ff1d41cd91$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9952f8ff1d41cd91$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9952f8ff1d41cd91$var$createReactTreeMounter(mountNode) {
    var confirms = {};
    var callbacks = {};
    function mount(Component, props) {
        var key = Math.floor(Math.random() * 1073741824).toString(16);
        confirms[key] = {
            Component: Component,
            props: props
        };
        callbacks.mounted && callbacks.mounted(confirms);
        return key;
    }
    function unmount(key) {
        delete confirms[key];
        callbacks.mounted && callbacks.mounted(confirms);
    }
    function setMountedCallback(func) {
        callbacks.mounted = func;
    }
    return {
        mount: mount,
        unmount: unmount,
        options: {
            setMountedCallback: setMountedCallback,
            mountNode: mountNode
        }
    };
}
function $9952f8ff1d41cd91$var$createMountPoint(reactTreeMounter) {
    return function() {
        var _useState = (0, $9952f8ff1d41cd91$var$_react.useState)({}), _useState2 = $9952f8ff1d41cd91$var$_slicedToArray(_useState, 2), confirmComponents = _useState2[0], setConfirmComponents = _useState2[1];
        (0, $9952f8ff1d41cd91$var$_react.useEffect)(function() {
            return reactTreeMounter.options.setMountedCallback(function(components) {
                setConfirmComponents($9952f8ff1d41cd91$var$_objectSpread({}, components));
            });
        }, []);
        var element = /*#__PURE__*/ $9952f8ff1d41cd91$var$_react["default"].createElement($9952f8ff1d41cd91$var$_react["default"].Fragment, null, Object.keys(confirmComponents).map(function(key) {
            var _confirmComponents$ke = confirmComponents[key], Component = _confirmComponents$ke.Component, props = _confirmComponents$ke.props;
            return /*#__PURE__*/ $9952f8ff1d41cd91$var$_react["default"].createElement(Component, $9952f8ff1d41cd91$var$_extends({
                key: key
            }, props));
        }));
        if (reactTreeMounter.options.mountNode) element = /*#__PURE__*/ (0, $8idXE.createPortal)(element, reactTreeMounter.options.mountNode);
        return element;
    };
}

});




parcelRegister("8EQoK", function(module, exports) {
"use strict";
var $64dab452745385d7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $64dab452745385d7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $64dab452745385d7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h6sQE = parcelRequire("h6sQE");
// Note: this instantiation ensures the above import isn't
// removed on compile. The import being absent causes an error on running
new $h6sQE.AgentConfig();

// Speech SDK API
$64dab452745385d7$var$__exportStar((parcelRequire("14iyq")), module.exports);

});
parcelRegister("h6sQE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c7395fdf492c0cfd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c7395fdf492c0cfd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $c7395fdf492c0cfd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = module.exports.ForceDictationPropertyName = module.exports.ServicePropertiesPropertyName = module.exports.CancellationErrorCodePropertyName = module.exports.OutputFormatPropertyName = void 0;

// Make sure not to export internal modules.
//
$c7395fdf492c0cfd$var$__exportStar((parcelRequire("6G3df")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("dfaJI")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("gjoHg")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("fkgaY")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("b57SX")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("1XoaE")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("fN7yD")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("1cFkL")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("g63fN")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("3oNx7")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("9t9fQ")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("1DrjR")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("dGNzn")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("iXxQM")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("poz4A")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("gC33x")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("eLwOj")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("jCyuG")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("1gp4n")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("gc2Gw")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("kmGSs")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("dClu3")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("j6U8n")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("kcYAa")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("i19Fr")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("4PUi4")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("63ysI")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("lXRrG")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("aK5bI")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("5Npd9")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("8fsM1")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("8jnyi")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("hrRlI")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("8ctu6")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("gzTst")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("g118i")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("esGkY")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("f6WX2")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("jrXqN")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("j0A3U")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("c4HeY")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("8Veus")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("4rM4i")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("5NtVi")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("8L7Ow")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("fLGdj")), module.exports);

var $lkoPP = parcelRequire("lkoPP");
Object.defineProperty(module.exports, "AvatarSynthesisAdapter", {
    enumerable: true,
    get: function() {
        return $lkoPP.AvatarSynthesisAdapter;
    }
});

var $8bhPC = parcelRequire("8bhPC");
Object.defineProperty(module.exports, "SpeechSynthesisAdapter", {
    enumerable: true,
    get: function() {
        return $8bhPC.SpeechSynthesisAdapter;
    }
});

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("av8Ig")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("6FV1U")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("bbI9p")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("kmU1B")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("1WVuz")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("kdfbc")), module.exports);

$c7395fdf492c0cfd$var$__exportStar((parcelRequire("ePv0n")), module.exports);
module.exports.OutputFormatPropertyName = "OutputFormat";
module.exports.CancellationErrorCodePropertyName = "CancellationErrorCode";
module.exports.ServicePropertiesPropertyName = "ServiceProperties";
module.exports.ForceDictationPropertyName = "ForceDictation";
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = "OpenRange";

});
parcelRegister("6G3df", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveSubscriptionKeyAuthentication = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $7Us8Y = parcelRequire("7Us8Y");

var $gjoHg = parcelRequire("gjoHg");
/**
 * @class
 */ class $4dc92844218c7ea4$var$CognitiveSubscriptionKeyAuthentication {
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchOnExpiry(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ constructor(subscriptionKey){
        if (!subscriptionKey) throw new $iLPPT.ArgumentNullError("subscriptionKey");
        this.privAuthInfo = new $gjoHg.AuthInfo($7Us8Y.HeaderNames.AuthKey, subscriptionKey);
    }
}
module.exports.CognitiveSubscriptionKeyAuthentication = $4dc92844218c7ea4$var$CognitiveSubscriptionKeyAuthentication;

});
parcelRegister("iLPPT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $daa4d3564be61dd4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $daa4d3564be61dd4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $daa4d3564be61dd4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$daa4d3564be61dd4$var$__exportStar((parcelRequire("36Ikb")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("bXmv4")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("7qWnh")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("9rMTD")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("uqsVP")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("8ejoP")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("8EMmR")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("8Tphd")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("d20V8")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("agQoA")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("1B2Rg")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("cIeKs")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("68Ry0")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("f8lla")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("kgxCS")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("cfO06")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("kInjw")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("gsZzn")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("1TPNn")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("fiJU0")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("eRy74")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("3JT5J")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("gHudN")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("6OtZK")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("j9sB0")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("h1vBW")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("aJQ1E")), module.exports);

var $8NfPo = parcelRequire("8NfPo");
Object.defineProperty(module.exports, "TranslationStatus", {
    enumerable: true,
    get: function() {
        return $8NfPo.TranslationStatus;
    }
});

$daa4d3564be61dd4$var$__exportStar((parcelRequire("dnqTX")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("5YtOm")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("fnSde")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("bwML7")), module.exports);

$daa4d3564be61dd4$var$__exportStar((parcelRequire("17C2x")), module.exports);

});
parcelRegister("36Ikb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamNodeErrorEvent = module.exports.AudioStreamNodeDetachedEvent = module.exports.AudioStreamNodeAttachedEvent = module.exports.AudioStreamNodeAttachingEvent = module.exports.AudioStreamNodeEvent = module.exports.AudioSourceErrorEvent = module.exports.AudioSourceOffEvent = module.exports.AudioSourceReadyEvent = module.exports.AudioSourceInitializingEvent = module.exports.AudioSourceEvent = void 0;

var $3JT5J = parcelRequire("3JT5J");
class $243450909290a736$var$AudioSourceEvent extends $3JT5J.PlatformEvent {
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    constructor(eventName, audioSourceId, eventType = $3JT5J.EventType.Info){
        super(eventName, eventType);
        this.privAudioSourceId = audioSourceId;
    }
}
module.exports.AudioSourceEvent = $243450909290a736$var$AudioSourceEvent;
class $243450909290a736$var$AudioSourceInitializingEvent extends $243450909290a736$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceInitializingEvent", audioSourceId);
    }
}
module.exports.AudioSourceInitializingEvent = $243450909290a736$var$AudioSourceInitializingEvent;
class $243450909290a736$var$AudioSourceReadyEvent extends $243450909290a736$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceReadyEvent", audioSourceId);
    }
}
module.exports.AudioSourceReadyEvent = $243450909290a736$var$AudioSourceReadyEvent;
class $243450909290a736$var$AudioSourceOffEvent extends $243450909290a736$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceOffEvent", audioSourceId);
    }
}
module.exports.AudioSourceOffEvent = $243450909290a736$var$AudioSourceOffEvent;
class $243450909290a736$var$AudioSourceErrorEvent extends $243450909290a736$var$AudioSourceEvent {
    get error() {
        return this.privError;
    }
    constructor(audioSourceId, error){
        super("AudioSourceErrorEvent", audioSourceId, $3JT5J.EventType.Error);
        this.privError = error;
    }
}
module.exports.AudioSourceErrorEvent = $243450909290a736$var$AudioSourceErrorEvent;
class $243450909290a736$var$AudioStreamNodeEvent extends $243450909290a736$var$AudioSourceEvent {
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    constructor(eventName, audioSourceId, audioNodeId){
        super(eventName, audioSourceId);
        this.privAudioNodeId = audioNodeId;
    }
}
module.exports.AudioStreamNodeEvent = $243450909290a736$var$AudioStreamNodeEvent;
class $243450909290a736$var$AudioStreamNodeAttachingEvent extends $243450909290a736$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeAttachingEvent = $243450909290a736$var$AudioStreamNodeAttachingEvent;
class $243450909290a736$var$AudioStreamNodeAttachedEvent extends $243450909290a736$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeAttachedEvent = $243450909290a736$var$AudioStreamNodeAttachedEvent;
class $243450909290a736$var$AudioStreamNodeDetachedEvent extends $243450909290a736$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeDetachedEvent = $243450909290a736$var$AudioStreamNodeDetachedEvent;
class $243450909290a736$var$AudioStreamNodeErrorEvent extends $243450909290a736$var$AudioStreamNodeEvent {
    get error() {
        return this.privError;
    }
    constructor(audioSourceId, audioNodeId, error){
        super("AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
        this.privError = error;
    }
}
module.exports.AudioStreamNodeErrorEvent = $243450909290a736$var$AudioStreamNodeErrorEvent;

});
parcelRegister("3JT5J", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlatformEvent = module.exports.EventType = void 0;

var $agQoA = parcelRequire("agQoA");
var $2b904f17c354bb22$var$EventType;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
    EventType[EventType["None"] = 4] = "None";
})($2b904f17c354bb22$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
class $2b904f17c354bb22$var$PlatformEvent {
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
    constructor(eventName, eventType){
        this.privName = eventName;
        this.privEventId = $agQoA.createNoDashGuid();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
}
module.exports.PlatformEvent = $2b904f17c354bb22$var$PlatformEvent;

});
parcelRegister("agQoA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNoDashGuid = module.exports.createGuid = void 0;

var $31Ssw = parcelRequire("31Ssw");
const $77a40aad54cb515f$var$createGuid = ()=>$31Ssw.default();
module.exports.createGuid = $77a40aad54cb515f$var$createGuid;
const $77a40aad54cb515f$var$createNoDashGuid = ()=>$77a40aad54cb515f$var$createGuid().replace(new RegExp("-", "g"), "").toUpperCase();
module.exports.createNoDashGuid = $77a40aad54cb515f$var$createNoDashGuid;

});
parcelRegister("31Ssw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $234bb58a6f4e7011$export$2e2bcd8739ae039; });

var $9Cv2Z = parcelRequire("9Cv2Z");

var $jvqyd = parcelRequire("jvqyd");

var $8d53v = parcelRequire("8d53v");
function $234bb58a6f4e7011$var$v4(options, buf, offset) {
    if ((0, $9Cv2Z.default).randomUUID && !buf && !options) return (0, $9Cv2Z.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $jvqyd.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8d53v.unsafeStringify)(rnds);
}
var $234bb58a6f4e7011$export$2e2bcd8739ae039 = $234bb58a6f4e7011$var$v4;

});
parcelRegister("9Cv2Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $700fbf04d60c694b$export$2e2bcd8739ae039; });
const $700fbf04d60c694b$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $700fbf04d60c694b$export$2e2bcd8739ae039 = {
    randomUUID: $700fbf04d60c694b$var$randomUUID
};

});

parcelRegister("jvqyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3358205092758c5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $e3358205092758c5$var$getRandomValues;
const $e3358205092758c5$var$rnds8 = new Uint8Array(16);
function $e3358205092758c5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e3358205092758c5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $e3358205092758c5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$e3358205092758c5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $e3358205092758c5$var$getRandomValues($e3358205092758c5$var$rnds8);
}

});

parcelRegister("8d53v", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $5fa3758d2f30f921$export$8fb373d660548968; });

var $5Qc1j = parcelRequire("5Qc1j");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $5fa3758d2f30f921$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5fa3758d2f30f921$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5fa3758d2f30f921$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $5fa3758d2f30f921$var$byteToHex[arr[offset + 0]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 1]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 2]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 3]] + "-" + $5fa3758d2f30f921$var$byteToHex[arr[offset + 4]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 5]] + "-" + $5fa3758d2f30f921$var$byteToHex[arr[offset + 6]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 7]] + "-" + $5fa3758d2f30f921$var$byteToHex[arr[offset + 8]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 9]] + "-" + $5fa3758d2f30f921$var$byteToHex[arr[offset + 10]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 11]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 12]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 13]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 14]] + $5fa3758d2f30f921$var$byteToHex[arr[offset + 15]];
}
function $5fa3758d2f30f921$var$stringify(arr, offset = 0) {
    const uuid = $5fa3758d2f30f921$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $5Qc1j.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5fa3758d2f30f921$export$2e2bcd8739ae039 = $5fa3758d2f30f921$var$stringify;

});
parcelRegister("5Qc1j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440b2207ad5ec6a7$export$2e2bcd8739ae039; });

var $9PBPu = parcelRequire("9PBPu");
function $440b2207ad5ec6a7$var$validate(uuid) {
    return typeof uuid === "string" && (0, $9PBPu.default).test(uuid);
}
var $440b2207ad5ec6a7$export$2e2bcd8739ae039 = $440b2207ad5ec6a7$var$validate;

});
parcelRegister("9PBPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7286389b7186cda2$export$2e2bcd8739ae039; });
var $7286389b7186cda2$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});







parcelRegister("bXmv4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageSentEvent = module.exports.ConnectionMessageReceivedEvent = module.exports.ConnectionEstablishErrorEvent = module.exports.ConnectionErrorEvent = module.exports.ConnectionClosedEvent = module.exports.ConnectionEstablishedEvent = module.exports.ConnectionStartEvent = module.exports.ConnectionEvent = module.exports.ServiceEvent = void 0;

var $3JT5J = parcelRequire("3JT5J");
class $8b46a86ed494e63b$var$ServiceEvent extends $3JT5J.PlatformEvent {
    get jsonString() {
        return this.privJsonResult;
    }
    constructor(eventName, jsonstring, eventType = $3JT5J.EventType.Info){
        super(eventName, eventType);
        this.privJsonResult = jsonstring;
    }
}
module.exports.ServiceEvent = $8b46a86ed494e63b$var$ServiceEvent;
class $8b46a86ed494e63b$var$ConnectionEvent extends $3JT5J.PlatformEvent {
    get connectionId() {
        return this.privConnectionId;
    }
    constructor(eventName, connectionId, eventType = $3JT5J.EventType.Info){
        super(eventName, eventType);
        this.privConnectionId = connectionId;
    }
}
module.exports.ConnectionEvent = $8b46a86ed494e63b$var$ConnectionEvent;
class $8b46a86ed494e63b$var$ConnectionStartEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
    constructor(connectionId, uri, headers){
        super("ConnectionStartEvent", connectionId);
        this.privUri = uri;
        this.privHeaders = headers;
    }
}
module.exports.ConnectionStartEvent = $8b46a86ed494e63b$var$ConnectionStartEvent;
class $8b46a86ed494e63b$var$ConnectionEstablishedEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    constructor(connectionId){
        super("ConnectionEstablishedEvent", connectionId);
    }
}
module.exports.ConnectionEstablishedEvent = $8b46a86ed494e63b$var$ConnectionEstablishedEvent;
class $8b46a86ed494e63b$var$ConnectionClosedEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    constructor(connectionId, statusCode, reason){
        super("ConnectionClosedEvent", connectionId, $3JT5J.EventType.Debug);
        this.privReason = reason;
        this.privStatusCode = statusCode;
    }
}
module.exports.ConnectionClosedEvent = $8b46a86ed494e63b$var$ConnectionClosedEvent;
class $8b46a86ed494e63b$var$ConnectionErrorEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
    constructor(connectionId, message, type){
        super("ConnectionErrorEvent", connectionId, $3JT5J.EventType.Debug);
        this.privMessage = message;
        this.privType = type;
    }
}
module.exports.ConnectionErrorEvent = $8b46a86ed494e63b$var$ConnectionErrorEvent;
class $8b46a86ed494e63b$var$ConnectionEstablishErrorEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    constructor(connectionId, statuscode, reason){
        super("ConnectionEstablishErrorEvent", connectionId, $3JT5J.EventType.Error);
        this.privStatusCode = statuscode;
        this.privReason = reason;
    }
}
module.exports.ConnectionEstablishErrorEvent = $8b46a86ed494e63b$var$ConnectionEstablishErrorEvent;
class $8b46a86ed494e63b$var$ConnectionMessageReceivedEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
    constructor(connectionId, networkReceivedTimeISO, message){
        super("ConnectionMessageReceivedEvent", connectionId);
        this.privNetworkReceivedTime = networkReceivedTimeISO;
        this.privMessage = message;
    }
}
module.exports.ConnectionMessageReceivedEvent = $8b46a86ed494e63b$var$ConnectionMessageReceivedEvent;
class $8b46a86ed494e63b$var$ConnectionMessageSentEvent extends $8b46a86ed494e63b$var$ConnectionEvent {
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
    constructor(connectionId, networkSentTimeISO, message){
        super("ConnectionMessageSentEvent", connectionId);
        this.privNetworkSentTime = networkSentTimeISO;
        this.privMessage = message;
    }
}
module.exports.ConnectionMessageSentEvent = $8b46a86ed494e63b$var$ConnectionMessageSentEvent;

});

parcelRegister("7qWnh", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-return */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessage = module.exports.MessageType = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $agQoA = parcelRequire("agQoA");
var $56983e0b9051a1ba$var$MessageType;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($56983e0b9051a1ba$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
class $56983e0b9051a1ba$var$ConnectionMessage {
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $56983e0b9051a1ba$var$MessageType.Binary) throw new $8EMmR.InvalidOperationError("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $56983e0b9051a1ba$var$MessageType.Text) throw new $8EMmR.InvalidOperationError("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
    constructor(messageType, body, headers, id){
        this.privBody = null;
        if (messageType === $56983e0b9051a1ba$var$MessageType.Text && body && !(typeof body === "string")) throw new $8EMmR.InvalidOperationError("Payload must be a string");
        if (messageType === $56983e0b9051a1ba$var$MessageType.Binary && body && !(body instanceof ArrayBuffer)) throw new $8EMmR.InvalidOperationError("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : $agQoA.createNoDashGuid();
        switch(this.messageType){
            case $56983e0b9051a1ba$var$MessageType.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $56983e0b9051a1ba$var$MessageType.Text:
                this.privSize = this.textBody.length;
        }
    }
}
module.exports.ConnectionMessage = $56983e0b9051a1ba$var$ConnectionMessage;

});
parcelRegister("8EMmR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectDisposedError = module.exports.InvalidOperationError = module.exports.ArgumentNullError = void 0;
/* eslint-disable max-classes-per-file */ /**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ class $64d793ff7cea0fba$var$ArgumentNullError extends Error {
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ constructor(argumentName){
        super(argumentName);
        this.name = "ArgumentNull";
        this.message = argumentName;
    }
}
module.exports.ArgumentNullError = $64d793ff7cea0fba$var$ArgumentNullError;
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */ class $64d793ff7cea0fba$var$InvalidOperationError extends Error {
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ constructor(error){
        super(error);
        this.name = "InvalidOperation";
        this.message = error;
    }
}
module.exports.InvalidOperationError = $64d793ff7cea0fba$var$InvalidOperationError;
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */ class $64d793ff7cea0fba$var$ObjectDisposedError extends Error {
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ constructor(objectName, error){
        super(error);
        this.name = objectName + "ObjectDisposed";
        this.message = error;
    }
}
module.exports.ObjectDisposedError = $64d793ff7cea0fba$var$ObjectDisposedError;

});


parcelRegister("9rMTD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionOpenResponse = void 0;
class $6e0c907663cf4651$var$ConnectionOpenResponse {
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
    constructor(statusCode, reason){
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
}
module.exports.ConnectionOpenResponse = $6e0c907663cf4651$var$ConnectionOpenResponse;

});

parcelRegister("uqsVP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeferralMap = void 0;
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class DefferalMap
 */ class $05b754fb59af5fe7$var$DeferralMap {
    add(id, deferral) {
        this.privMap[id] = deferral;
    }
    getId(id) {
        return this.privMap[id];
    }
    complete(id, result) {
        try {
            this.privMap[id].resolve(result);
        } catch (error) {
            this.privMap[id].reject(error);
        } finally{
            this.privMap[id] = undefined;
        }
    }
    constructor(){
        this.privMap = {};
    }
}
module.exports.DeferralMap = $05b754fb59af5fe7$var$DeferralMap;

});

parcelRegister("8ejoP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendingAgentContextMessageEvent = module.exports.DialogEvent = void 0;

var $3JT5J = parcelRequire("3JT5J");
class $5fdeadda9227e526$var$DialogEvent extends $3JT5J.PlatformEvent {
    constructor(eventName, eventType = $3JT5J.EventType.Info){
        super(eventName, eventType);
    }
}
module.exports.DialogEvent = $5fdeadda9227e526$var$DialogEvent;
class $5fdeadda9227e526$var$SendingAgentContextMessageEvent extends $5fdeadda9227e526$var$DialogEvent {
    get agentConfig() {
        return this.privAgentConfig;
    }
    constructor(agentConfig){
        super("SendingAgentContextMessageEvent");
        this.privAgentConfig = agentConfig;
    }
}
module.exports.SendingAgentContextMessageEvent = $5fdeadda9227e526$var$SendingAgentContextMessageEvent;

});

parcelRegister("8Tphd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $d20V8 = parcelRequire("d20V8");
class $679711387ca90d5f$var$Events {
    static setEventSource(eventSource) {
        if (!eventSource) throw new $8EMmR.ArgumentNullError("eventSource");
        $679711387ca90d5f$var$Events.privInstance = eventSource;
    }
    static get instance() {
        return $679711387ca90d5f$var$Events.privInstance;
    }
}
module.exports.Events = $679711387ca90d5f$var$Events;
$679711387ca90d5f$var$Events.privInstance = new $d20V8.EventSource();

});
parcelRegister("d20V8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSource = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $agQoA = parcelRequire("agQoA");
class $0272c6ebae50cd77$var$EventSource {
    onEvent(event) {
        if (this.isDisposed()) throw new $8EMmR.ObjectDisposedError("EventSource");
        if (this.metadata) {
            for(const paramName in this.metadata)if (paramName) {
                if (event.metadata) {
                    if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                }
            }
        }
        for(const eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
    }
    attach(onEventCallback) {
        const id = $agQoA.createNoDashGuid();
        this.privEventListeners[id] = onEventCallback;
        return {
            detach: ()=>{
                delete this.privEventListeners[id];
                return Promise.resolve();
            }
        };
    }
    attachListener(listener) {
        return this.attach((e)=>listener.onEvent(e));
    }
    attachConsoleListener(listener) {
        if (!!this.privConsoleListener) this.privConsoleListener.detach(); // Detach implementation for eventListeners is synchronous
        this.privConsoleListener = this.attach((e)=>listener.onEvent(e));
        return this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null;
        this.privIsDisposed = true;
    }
    get metadata() {
        return this.privMetadata;
    }
    constructor(metadata){
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.privConsoleListener = undefined;
        this.privMetadata = metadata;
    }
}
module.exports.EventSource = $0272c6ebae50cd77$var$EventSource;

});


parcelRegister("1B2Rg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cIeKs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionState = void 0;
var $941508d0df25f958$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($941508d0df25f958$var$ConnectionState = module.exports.ConnectionState || (module.exports.ConnectionState = {}));

});

parcelRegister("68Ry0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("f8lla", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kgxCS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cfO06", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kInjw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gsZzn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1TPNn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fiJU0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eRy74", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.List = void 0;

var $8EMmR = parcelRequire("8EMmR");
class $ad207a1270aa5efd$var$List {
    get(itemIndex) {
        this.throwIfDisposed();
        return this.privList[itemIndex];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(item) {
        this.throwIfDisposed();
        this.insertAt(this.privList.length, item);
    }
    insertAt(index, item) {
        this.throwIfDisposed();
        if (index === 0) this.privList.unshift(item);
        else if (index === this.privList.length) this.privList.push(item);
        else this.privList.splice(index, 0, item);
        this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        this.throwIfDisposed();
        return this.removeAt(0);
    }
    removeLast() {
        this.throwIfDisposed();
        return this.removeAt(this.length() - 1);
    }
    removeAt(index) {
        this.throwIfDisposed();
        return this.remove(index, 1)[0];
    }
    remove(index, count) {
        this.throwIfDisposed();
        const removedElements = this.privList.splice(index, count);
        this.triggerSubscriptions(this.privRemoveSubscriptions);
        return removedElements;
    }
    clear() {
        this.throwIfDisposed();
        this.remove(0, this.length());
    }
    length() {
        this.throwIfDisposed();
        return this.privList.length;
    }
    onAdded(addedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privAddSubscriptions[subscriptionId] = addedCallback;
        return {
            detach: ()=>{
                delete this.privAddSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onRemoved(removedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privRemoveSubscriptions[subscriptionId] = removedCallback;
        return {
            detach: ()=>{
                delete this.privRemoveSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onDisposed(disposedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
        return {
            detach: ()=>{
                delete this.privDisposedSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    join(seperator) {
        this.throwIfDisposed();
        return this.privList.join(seperator);
    }
    toArray() {
        const cloneCopy = Array();
        this.privList.forEach((val)=>{
            cloneCopy.push(val);
        });
        return cloneCopy;
    }
    any(callback) {
        this.throwIfDisposed();
        if (callback) return this.where(callback).length() > 0;
        else return this.length() > 0;
    }
    all(callback) {
        this.throwIfDisposed();
        return this.where(callback).length() === this.length();
    }
    forEach(callback) {
        this.throwIfDisposed();
        for(let i = 0; i < this.length(); i++)callback(this.privList[i], i);
    }
    select(callback) {
        this.throwIfDisposed();
        const selectList = [];
        for(let i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
        return new $ad207a1270aa5efd$var$List(selectList);
    }
    where(callback) {
        this.throwIfDisposed();
        const filteredList = new $ad207a1270aa5efd$var$List();
        for(let i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
        return filteredList;
    }
    orderBy(compareFn) {
        this.throwIfDisposed();
        const clonedArray = this.toArray();
        const orderedArray = clonedArray.sort(compareFn);
        return new $ad207a1270aa5efd$var$List(orderedArray);
    }
    orderByDesc(compareFn) {
        this.throwIfDisposed();
        return this.orderBy((a, b)=>compareFn(b, a));
    }
    clone() {
        this.throwIfDisposed();
        return new $ad207a1270aa5efd$var$List(this.toArray());
    }
    concat(list) {
        this.throwIfDisposed();
        return new $ad207a1270aa5efd$var$List(this.privList.concat(list.toArray()));
    }
    concatArray(array) {
        this.throwIfDisposed();
        return new $ad207a1270aa5efd$var$List(this.privList.concat(array));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(reason) {
        if (!this.isDisposed()) {
            this.privDisposeReason = reason;
            this.privList = null;
            this.privAddSubscriptions = null;
            this.privRemoveSubscriptions = null;
            this.triggerSubscriptions(this.privDisposedSubscriptions);
        }
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new $8EMmR.ObjectDisposedError("List", this.privDisposeReason);
    }
    triggerSubscriptions(subscriptions) {
        if (subscriptions) {
            for(const subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
        }
    }
    constructor(list){
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for (const item of list)this.privList.push(item);
    }
}
module.exports.List = $ad207a1270aa5efd$var$List;

});

parcelRegister("gHudN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marshalPromiseToCallbacks = module.exports.Sink = module.exports.Deferred = module.exports.PromiseResultEventSource = module.exports.PromiseResult = module.exports.PromiseState = void 0;
/* eslint-disable max-classes-per-file, @typescript-eslint/typedef */ var $c2881adaac307afe$var$PromiseState;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($c2881adaac307afe$var$PromiseState = module.exports.PromiseState || (module.exports.PromiseState = {}));
class $c2881adaac307afe$var$PromiseResult {
    get isCompleted() {
        return this.privIsCompleted;
    }
    get isError() {
        return this.privIsError;
    }
    get error() {
        return this.privError;
    }
    get result() {
        return this.privResult;
    }
    constructor(promiseResultEventSource){
        this.throwIfError = ()=>{
            if (this.isError) throw this.error;
        };
        promiseResultEventSource.on((result)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = false;
                this.privResult = result;
            }
        }, (error)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = true;
                this.privError = error;
            }
        });
    }
}
module.exports.PromiseResult = $c2881adaac307afe$var$PromiseResult;
class $c2881adaac307afe$var$PromiseResultEventSource {
    constructor(){
        this.setResult = (result)=>{
            this.privOnSetResult(result);
        };
        this.setError = (error)=>{
            this.privOnSetError(error);
        };
        this.on = (onSetResult, onSetError)=>{
            this.privOnSetResult = onSetResult;
            this.privOnSetError = onSetError;
        };
    }
}
module.exports.PromiseResultEventSource = $c2881adaac307afe$var$PromiseResultEventSource;
class $c2881adaac307afe$var$Deferred {
    get promise() {
        return this.privPromise;
    }
    constructor(){
        this.resolve = (result)=>{
            this.privResolve(result);
            return this;
        };
        this.reject = (error)=>{
            this.privReject(error);
            return this;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.privPromise = new Promise((resolve, reject)=>{
            this.privResolve = resolve;
            this.privReject = reject;
        });
    }
}
module.exports.Deferred = $c2881adaac307afe$var$Deferred;
class $c2881adaac307afe$var$Sink {
    get state() {
        return this.privState;
    }
    get result() {
        return this.privPromiseResult;
    }
    resolve(result) {
        if (this.privState !== $c2881adaac307afe$var$PromiseState.None) throw new Error("'Cannot resolve a completed promise'");
        this.privState = $c2881adaac307afe$var$PromiseState.Resolved;
        this.privPromiseResultEvents.setResult(result);
        for(let i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
        this.detachHandlers();
    }
    reject(error) {
        if (this.privState !== $c2881adaac307afe$var$PromiseState.None) throw new Error("'Cannot reject a completed promise'");
        this.privState = $c2881adaac307afe$var$PromiseState.Rejected;
        this.privPromiseResultEvents.setError(error);
        for (const errorHandler of this.privErrorHandlers)this.executeErrorCallback(error, errorHandler);
        this.detachHandlers();
    }
    on(successCallback, errorCallback) {
        if (successCallback == null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        successCallback = ()=>{};
        if (this.privState === $c2881adaac307afe$var$PromiseState.None) {
            this.privSuccessHandlers.push(successCallback);
            this.privErrorHandlers.push(errorCallback);
        } else {
            if (this.privState === $c2881adaac307afe$var$PromiseState.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
            else if (this.privState === $c2881adaac307afe$var$PromiseState.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
            this.detachHandlers();
        }
    }
    executeSuccessCallback(result, successCallback, errorCallback) {
        try {
            successCallback(result);
        } catch (e) {
            this.executeErrorCallback(`'Unhandled callback error: ${e}'`, errorCallback);
        }
    }
    executeErrorCallback(error, errorCallback) {
        if (errorCallback) try {
            errorCallback(error);
        } catch (e) {
            throw new Error(`'Unhandled callback error: ${e}. InnerError: ${error}'`);
        }
        else throw new Error(`'Unhandled error: ${error}'`);
    }
    detachHandlers() {
        this.privErrorHandlers = [];
        this.privSuccessHandlers = [];
    }
    constructor(){
        this.privState = $c2881adaac307afe$var$PromiseState.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.privPromiseResultEvents = new $c2881adaac307afe$var$PromiseResultEventSource();
        this.privPromiseResult = new $c2881adaac307afe$var$PromiseResult(this.privPromiseResultEvents);
    }
}
module.exports.Sink = $c2881adaac307afe$var$Sink;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function $c2881adaac307afe$var$marshalPromiseToCallbacks(promise, cb, err) {
    promise.then((val)=>{
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, (error)=>{
        if (!!err) try {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        // eslint-disable-next-line no-empty
        } catch (error) {}
    });
}
module.exports.marshalPromiseToCallbacks = $c2881adaac307afe$var$marshalPromiseToCallbacks;

});

parcelRegister("6OtZK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Queue = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $eRy74 = parcelRequire("eRy74");

var $gHudN = parcelRequire("gHudN");
var $4f5eadf25491ce80$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($4f5eadf25491ce80$var$SubscriberType || ($4f5eadf25491ce80$var$SubscriberType = {}));
class $4f5eadf25491ce80$var$Queue {
    enqueue(item) {
        this.throwIfDispose();
        this.enqueueFromPromise(new Promise((resolve)=>resolve(item)));
    }
    enqueueFromPromise(promise) {
        this.throwIfDispose();
        promise.then((val)=>{
            this.privList.add(val);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const deferredSubscriber = new $gHudN.Deferred();
        if (this.privSubscribers) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $4f5eadf25491ce80$var$SubscriberType.Dequeue
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    peek() {
        this.throwIfDispose();
        const deferredSubscriber = new $gHudN.Deferred();
        const subs = this.privSubscribers;
        if (subs) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $4f5eadf25491ce80$var$SubscriberType.Peek
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    length() {
        this.throwIfDispose();
        return this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    async drainAndDispose(pendingItemProcessor, reason) {
        if (!this.isDisposed() && !this.privIsDisposing) {
            this.privDisposeReason = reason;
            this.privIsDisposing = true;
            const subs = this.privSubscribers;
            if (subs) {
                while(subs.length() > 0){
                    const subscriber = subs.removeFirst();
                    // TODO: this needs work (Resolve(null) instead?).
                    subscriber.deferral.resolve(undefined);
                // subscriber.deferral.reject("Disposed");
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
            }
            for (const detachable of this.privDetachables)await detachable.detach();
            if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                const promiseArray = [];
                this.privPromiseStore.toArray().forEach((wrapper)=>{
                    promiseArray.push(wrapper);
                });
                return Promise.all(promiseArray).finally(()=>{
                    this.privSubscribers = null;
                    this.privList.forEach((item)=>{
                        pendingItemProcessor(item);
                    });
                    this.privList = null;
                    return;
                }).then();
            } else {
                this.privSubscribers = null;
                this.privList = null;
            }
        }
    }
    async dispose(reason) {
        await this.drainAndDispose(null, reason);
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = true;
            const subs = this.privSubscribers;
            const lists = this.privList;
            if (subs && lists) {
                while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                    const subscriber = subs.removeFirst();
                    if (subscriber.type === $4f5eadf25491ce80$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                    else {
                        const dequeuedItem = lists.removeFirst();
                        subscriber.deferral.resolve(dequeuedItem);
                    }
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privList === lists) this.privList = lists;
            }
            this.privIsDrainInProgress = false;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) {
            if (this.privDisposeReason) throw new $8EMmR.InvalidOperationError(this.privDisposeReason);
            throw new $8EMmR.ObjectDisposedError("Queue");
        } else if (this.privIsDisposing) throw new $8EMmR.InvalidOperationError("Queue disposing");
    }
    constructor(list){
        this.privPromiseStore = new $eRy74.List();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.privList = list ? list : new $eRy74.List();
        this.privDetachables = [];
        this.privSubscribers = new $eRy74.List();
        this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
}
module.exports.Queue = $4f5eadf25491ce80$var$Queue;

});

parcelRegister("j9sB0", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawWebsocketMessage = void 0;

var $7qWnh = parcelRequire("7qWnh");

var $8EMmR = parcelRequire("8EMmR");

var $agQoA = parcelRequire("agQoA");
class $df150a1b811e70d6$var$RawWebsocketMessage {
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === $7qWnh.MessageType.Binary) throw new $8EMmR.InvalidOperationError("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === $7qWnh.MessageType.Text) throw new $8EMmR.InvalidOperationError("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
    constructor(messageType, payload, id){
        this.privPayload = null;
        if (!payload) throw new $8EMmR.ArgumentNullError("payload");
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (messageType === $7qWnh.MessageType.Binary && Object.getPrototypeOf(payload).constructor.name !== "ArrayBuffer") throw new $8EMmR.InvalidOperationError("Payload must be ArrayBuffer");
        if (messageType === $7qWnh.MessageType.Text && !(typeof payload === "string")) throw new $8EMmR.InvalidOperationError("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : $agQoA.createNoDashGuid();
    }
}
module.exports.RawWebsocketMessage = $df150a1b811e70d6$var$RawWebsocketMessage;

});

parcelRegister("h1vBW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RiffPcmEncoder = void 0;
class $c64b0ceec6b18bf1$var$RiffPcmEncoder {
    encode(actualAudioFrame) {
        const audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!audioFrame) return null;
        const audioLength = audioFrame.length * 2;
        const buffer = new ArrayBuffer(audioLength);
        const view = new DataView(buffer);
        this.floatTo16BitPCM(view, 0, audioFrame);
        return buffer;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
    floatTo16BitPCM(view, offset, input) {
        for(let i = 0; i < input.length; i++, offset += 2){
            const s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    }
    downSampleAudioFrame(srcFrame, srcRate, dstRate) {
        if (!srcFrame) return null;
        if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
        const ratio = srcRate / dstRate;
        const dstLength = Math.round(srcFrame.length / ratio);
        const dstFrame = new Float32Array(dstLength);
        let srcOffset = 0;
        let dstOffset = 0;
        while(dstOffset < dstLength){
            const nextSrcOffset = Math.round((dstOffset + 1) * ratio);
            let accum = 0;
            let count = 0;
            while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                accum += srcFrame[srcOffset++];
                count++;
            }
            dstFrame[dstOffset++] = accum / count;
        }
        return dstFrame;
    }
    constructor(actualSampleRate, desiredSampleRate){
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
}
module.exports.RiffPcmEncoder = $c64b0ceec6b18bf1$var$RiffPcmEncoder;

});

parcelRegister("aJQ1E", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stream = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $agQoA = parcelRequire("agQoA");

var $6OtZK = parcelRequire("6OtZK");
class $7d167695684ce967$var$Stream {
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    }
    writeStreamChunk(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    }
    read() {
        if (this.privIsReadEnded) throw new $8EMmR.InvalidOperationError("Stream read has already finished");
        return this.privReaderQueue.dequeue().then(async (streamChunk)=>{
            if (streamChunk === undefined || streamChunk.isEnd) await this.privReaderQueue.dispose("End of stream reached");
            return streamChunk;
        });
    }
    readEnded() {
        if (!this.privIsReadEnded) {
            this.privIsReadEnded = true;
            this.privReaderQueue = new $6OtZK.Queue();
        }
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new $8EMmR.InvalidOperationError("Stream closed");
    }
    constructor(streamId){
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.privId = streamId ? streamId : $agQoA.createNoDashGuid();
        this.privReaderQueue = new $6OtZK.Queue();
    }
}
module.exports.Stream = $7d167695684ce967$var$Stream;

});

parcelRegister("8NfPo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationStatus = void 0;
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $666f2d6a7d82e884$var$TranslationStatus;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($666f2d6a7d82e884$var$TranslationStatus = module.exports.TranslationStatus || (module.exports.TranslationStatus = {}));

});

parcelRegister("dnqTX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedArrayBufferStream = void 0;

var $iLPPT = parcelRequire("iLPPT");
class $9bd24a6ca618cc99$var$ChunkedArrayBufferStream extends $iLPPT.Stream {
    writeStreamChunk(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(chunk);
            return;
        }
        let bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            const bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            const targetView = new Uint8Array(this.privNextBufferToWrite);
            const sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                super.writeStreamChunk({
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    }
    close() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        super.close();
    }
    constructor(targetChunkSize, streamId){
        super(streamId);
        this.privTargetChunkSize = targetChunkSize;
        this.privNextBufferReadyBytes = 0;
    }
}
module.exports.ChunkedArrayBufferStream = $9bd24a6ca618cc99$var$ChunkedArrayBufferStream;

});

parcelRegister("5YtOm", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fnSde", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
class $b3330e78b63ba9a7$var$Timeout {
    static load() {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        const scheduledTimeoutFunctions = new Map([
            [
                0,
                ()=>{}
            ]
        ]); // eslint-disable-line @typescript-eslint/no-empty-function
        const unhandledRequests = new Map();
        // eslint-disable-next-line
        const workerScript = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
        const workerUrl = "data:text/javascript;base64," + btoa(workerScript);
        const worker = new Worker(workerUrl);
        worker.addEventListener("message", ({ data: data })=>{
            if ($b3330e78b63ba9a7$var$Timeout.isCallNotification(data)) {
                const { params: { timerId: timerId } } = data;
                const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if ($b3330e78b63ba9a7$var$Timeout.isClearResponse(data)) {
                const { id: id } = data;
                const unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                const { error: { message: message } } = data;
                throw new Error(message);
            }
        });
        const clearTimeout = (timerId)=>{
            const id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        const setTimeout = (func, delay)=>{
            const timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    }
    static loadWorkerTimers() {
        return ()=>{
            if ($b3330e78b63ba9a7$var$Timeout.workerTimers !== null) return $b3330e78b63ba9a7$var$Timeout.workerTimers;
            $b3330e78b63ba9a7$var$Timeout.workerTimers = $b3330e78b63ba9a7$var$Timeout.load();
            return $b3330e78b63ba9a7$var$Timeout.workerTimers;
        };
    }
    static isCallNotification(message) {
        return message.method !== undefined && message.method === "call";
    }
    static isClearResponse(message) {
        return message.error === null && typeof message.id === "number";
    }
}
module.exports.Timeout = $b3330e78b63ba9a7$var$Timeout;
$b3330e78b63ba9a7$var$Timeout.workerTimers = null;
$b3330e78b63ba9a7$var$Timeout.clearTimeout = (timerId)=>$b3330e78b63ba9a7$var$Timeout.timers().clearTimeout(timerId);
$b3330e78b63ba9a7$var$Timeout.setTimeout = (func, delay)=>$b3330e78b63ba9a7$var$Timeout.timers().setTimeout(func, delay);
$b3330e78b63ba9a7$var$Timeout.timers = $b3330e78b63ba9a7$var$Timeout.loadWorkerTimers();

});

parcelRegister("bwML7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OCSPCacheUpdateErrorEvent = module.exports.OCSPResponseRetrievedEvent = module.exports.OCSPCacheFetchErrorEvent = module.exports.OCSPVerificationFailedEvent = module.exports.OCSPCacheHitEvent = module.exports.OCSPCacheEntryNeedsRefreshEvent = module.exports.OCSPCacheEntryExpiredEvent = module.exports.OCSPWSUpgradeStartedEvent = module.exports.OCSPStapleReceivedEvent = module.exports.OCSPCacheUpdateCompleteEvent = module.exports.OCSPDiskCacheStoreEvent = module.exports.OCSPMemoryCacheStoreEvent = module.exports.OCSPCacheUpdateNeededEvent = module.exports.OCSPDiskCacheHitEvent = module.exports.OCSPCacheMissEvent = module.exports.OCSPMemoryCacheHitEvent = module.exports.OCSPEvent = void 0;

var $3JT5J = parcelRequire("3JT5J");
class $86488162266bdf33$var$OCSPEvent extends $3JT5J.PlatformEvent {
    constructor(eventName, eventType, signature){
        super(eventName, eventType);
        this.privSignature = signature;
    }
}
module.exports.OCSPEvent = $86488162266bdf33$var$OCSPEvent;
class $86488162266bdf33$var$OCSPMemoryCacheHitEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPMemoryCacheHitEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPMemoryCacheHitEvent = $86488162266bdf33$var$OCSPMemoryCacheHitEvent;
class $86488162266bdf33$var$OCSPCacheMissEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheMissEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheMissEvent = $86488162266bdf33$var$OCSPCacheMissEvent;
class $86488162266bdf33$var$OCSPDiskCacheHitEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPDiskCacheHitEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPDiskCacheHitEvent = $86488162266bdf33$var$OCSPDiskCacheHitEvent;
class $86488162266bdf33$var$OCSPCacheUpdateNeededEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheUpdateNeededEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheUpdateNeededEvent = $86488162266bdf33$var$OCSPCacheUpdateNeededEvent;
class $86488162266bdf33$var$OCSPMemoryCacheStoreEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPMemoryCacheStoreEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPMemoryCacheStoreEvent = $86488162266bdf33$var$OCSPMemoryCacheStoreEvent;
class $86488162266bdf33$var$OCSPDiskCacheStoreEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPDiskCacheStoreEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPDiskCacheStoreEvent = $86488162266bdf33$var$OCSPDiskCacheStoreEvent;
class $86488162266bdf33$var$OCSPCacheUpdateCompleteEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheUpdateCompleteEvent", $3JT5J.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheUpdateCompleteEvent = $86488162266bdf33$var$OCSPCacheUpdateCompleteEvent;
class $86488162266bdf33$var$OCSPStapleReceivedEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(){
        super("OCSPStapleReceivedEvent", $3JT5J.EventType.Debug, "");
    }
}
module.exports.OCSPStapleReceivedEvent = $86488162266bdf33$var$OCSPStapleReceivedEvent;
class $86488162266bdf33$var$OCSPWSUpgradeStartedEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber){
        super("OCSPWSUpgradeStartedEvent", $3JT5J.EventType.Debug, serialNumber);
    }
}
module.exports.OCSPWSUpgradeStartedEvent = $86488162266bdf33$var$OCSPWSUpgradeStartedEvent;
class $86488162266bdf33$var$OCSPCacheEntryExpiredEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber, expireTime){
        super("OCSPCacheEntryExpiredEvent", $3JT5J.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
    }
}
module.exports.OCSPCacheEntryExpiredEvent = $86488162266bdf33$var$OCSPCacheEntryExpiredEvent;
class $86488162266bdf33$var$OCSPCacheEntryNeedsRefreshEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheEntryNeedsRefreshEvent", $3JT5J.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privStartTime = startTime;
    }
}
module.exports.OCSPCacheEntryNeedsRefreshEvent = $86488162266bdf33$var$OCSPCacheEntryNeedsRefreshEvent;
class $86488162266bdf33$var$OCSPCacheHitEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheHitEvent", $3JT5J.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privExpireTimeString = new Date(expireTime).toLocaleDateString();
        this.privStartTime = startTime;
        this.privStartTimeString = new Date(startTime).toLocaleTimeString();
    }
}
module.exports.OCSPCacheHitEvent = $86488162266bdf33$var$OCSPCacheHitEvent;
class $86488162266bdf33$var$OCSPVerificationFailedEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPVerificationFailedEvent", $3JT5J.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPVerificationFailedEvent = $86488162266bdf33$var$OCSPVerificationFailedEvent;
class $86488162266bdf33$var$OCSPCacheFetchErrorEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPCacheFetchErrorEvent", $3JT5J.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPCacheFetchErrorEvent = $86488162266bdf33$var$OCSPCacheFetchErrorEvent;
class $86488162266bdf33$var$OCSPResponseRetrievedEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber){
        super("OCSPResponseRetrievedEvent", $3JT5J.EventType.Debug, serialNumber);
    }
}
module.exports.OCSPResponseRetrievedEvent = $86488162266bdf33$var$OCSPResponseRetrievedEvent;
class $86488162266bdf33$var$OCSPCacheUpdateErrorEvent extends $86488162266bdf33$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPCacheUpdateErrorEvent", $3JT5J.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPCacheUpdateErrorEvent = $86488162266bdf33$var$OCSPCacheUpdateErrorEvent;

});

parcelRegister("17C2x", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundEvent = void 0;

var $iLPPT = parcelRequire("iLPPT");
class $0d13f3da9685fc78$var$BackgroundEvent extends $iLPPT.PlatformEvent {
    get error() {
        return this.privError;
    }
    constructor(error){
        super("BackgroundEvent", $iLPPT.EventType.Error);
        this.privError = error;
    }
}
module.exports.BackgroundEvent = $0d13f3da9685fc78$var$BackgroundEvent;

});


parcelRegister("7Us8Y", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeaderNames = void 0;
class $5c239821ad3d8136$var$HeaderNames {
}
module.exports.HeaderNames = $5c239821ad3d8136$var$HeaderNames;
$5c239821ad3d8136$var$HeaderNames.AuthKey = "Ocp-Apim-Subscription-Key";
$5c239821ad3d8136$var$HeaderNames.Authorization = "Authorization";
$5c239821ad3d8136$var$HeaderNames.SpIDAuthKey = "Apim-Subscription-Id";
$5c239821ad3d8136$var$HeaderNames.ConnectionId = "X-ConnectionId";
$5c239821ad3d8136$var$HeaderNames.ContentType = "Content-Type";
$5c239821ad3d8136$var$HeaderNames.CustomCommandsAppId = "X-CommandsAppId";
$5c239821ad3d8136$var$HeaderNames.Path = "Path";
$5c239821ad3d8136$var$HeaderNames.RequestId = "X-RequestId";
$5c239821ad3d8136$var$HeaderNames.RequestStreamId = "X-StreamId";
$5c239821ad3d8136$var$HeaderNames.RequestTimestamp = "X-Timestamp";

});

parcelRegister("gjoHg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthInfo = void 0;
class $be0193f42b29f142$var$AuthInfo {
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
    constructor(headerName, token){
        this.privHeaderName = headerName;
        this.privToken = token;
    }
}
module.exports.AuthInfo = $be0193f42b29f142$var$AuthInfo;

});


parcelRegister("dfaJI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveTokenAuthentication = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $gjoHg = parcelRequire("gjoHg");

var $7Us8Y = parcelRequire("7Us8Y");
class $9a45011aa8d6cd9b$var$CognitiveTokenAuthentication {
    fetch(authFetchEventId) {
        return this.privFetchCallback(authFetchEventId).then((token)=>new $gjoHg.AuthInfo($7Us8Y.HeaderNames.Authorization, token === undefined ? undefined : $9a45011aa8d6cd9b$var$CognitiveTokenAuthentication.privTokenPrefix + token));
    }
    fetchOnExpiry(authFetchEventId) {
        return this.privFetchOnExpiryCallback(authFetchEventId).then((token)=>new $gjoHg.AuthInfo($7Us8Y.HeaderNames.Authorization, token === undefined ? undefined : $9a45011aa8d6cd9b$var$CognitiveTokenAuthentication.privTokenPrefix + token));
    }
    constructor(fetchCallback, fetchOnExpiryCallback){
        if (!fetchCallback) throw new $iLPPT.ArgumentNullError("fetchCallback");
        if (!fetchOnExpiryCallback) throw new $iLPPT.ArgumentNullError("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
}
module.exports.CognitiveTokenAuthentication = $9a45011aa8d6cd9b$var$CognitiveTokenAuthentication;
$9a45011aa8d6cd9b$var$CognitiveTokenAuthentication.privTokenPrefix = "Bearer ";

});

parcelRegister("fkgaY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b57SX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1XoaE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");
class $16ce0cf21e737484$var$IntentConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint);
        if (!endpoint) {
            const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_IntentRegion);
            const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".sr.speech" + hostSuffix);
            endpoint = host + "/speech/recognition/interactive/cognitiveservices/v1";
        }
        const queryParams = {
            format: "simple",
            language: config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(config, queryParams, endpoint);
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    getSpeechRegionFromIntentRegion(intentRegion) {
        switch(intentRegion){
            case "West US":
            case "US West":
            case "westus":
                return "uswest";
            case "West US 2":
            case "US West 2":
            case "westus2":
                return "uswest2";
            case "South Central US":
            case "US South Central":
            case "southcentralus":
                return "ussouthcentral";
            case "West Central US":
            case "US West Central":
            case "westcentralus":
                return "uswestcentral";
            case "East US":
            case "US East":
            case "eastus":
                return "useast";
            case "East US 2":
            case "US East 2":
            case "eastus2":
                return "useast2";
            case "West Europe":
            case "Europe West":
            case "westeurope":
                return "europewest";
            case "North Europe":
            case "Europe North":
            case "northeurope":
                return "europenorth";
            case "Brazil South":
            case "South Brazil":
            case "southbrazil":
                return "brazilsouth";
            case "Australia East":
            case "East Australia":
            case "eastaustralia":
                return "australiaeast";
            case "Southeast Asia":
            case "Asia Southeast":
            case "southeastasia":
                return "asiasoutheast";
            case "East Asia":
            case "Asia East":
            case "eastasia":
                return "asiaeast";
            default:
                return intentRegion;
        }
    }
}
module.exports.IntentConnectionFactory = $16ce0cf21e737484$var$IntentConnectionFactory;

});
parcelRegister("1JzGB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1435acf69d7520b9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1435acf69d7520b9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $1435acf69d7520b9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1435acf69d7520b9$var$__exportStar((parcelRequire("6fLeU")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("crfV6")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("cygk0")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("6AdSK")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("7pUOg")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("ga2V1")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("4ixQI")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("hxOUO")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("aqoNk")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("kjmGU")), module.exports);

$1435acf69d7520b9$var$__exportStar((parcelRequire("8v5nd")), module.exports);

});
parcelRegister("6fLeU", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $48d8c9904897162a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $48d8c9904897162a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $48d8c9904897162a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $48d8c9904897162a$var$__createBinding(result, mod, k);
    }
    $48d8c9904897162a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleLoggingListener = void 0;

const $48d8c9904897162a$var$fs = $48d8c9904897162a$var$__importStar((parcelRequire("3rte6")));

var $7W454 = parcelRequire("7W454");

var $3afpL = parcelRequire("3afpL");
class $48d8c9904897162a$var$ConsoleLoggingListener {
    set logPath(path) {
        $3afpL.Contracts.throwIfNullOrUndefined($48d8c9904897162a$var$fs.openSync, "\nFile System access not available");
        this.privLogPath = path;
    }
    set enableConsoleOutput(enableOutput) {
        this.privEnableConsoleOutput = enableOutput;
    }
    onEvent(event) {
        if (event.eventType >= this.privLogLevelFilter) {
            const log = this.toString(event);
            if (!!this.logCallback) this.logCallback(log);
            if (!!this.privLogPath) $48d8c9904897162a$var$fs.writeFileSync(this.privLogPath, log + "\n", {
                flag: "a+"
            });
            if (this.privEnableConsoleOutput) switch(event.eventType){
                case $7W454.LogLevel.Debug:
                    // eslint-disable-next-line no-console
                    console.debug(log);
                    break;
                case $7W454.LogLevel.Info:
                    // eslint-disable-next-line no-console
                    console.info(log);
                    break;
                case $7W454.LogLevel.Warning:
                    // eslint-disable-next-line no-console
                    console.warn(log);
                    break;
                case $7W454.LogLevel.Error:
                    // eslint-disable-next-line no-console
                    console.error(log);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(log);
                    break;
            }
        }
    }
    toString(event) {
        const logFragments = [
            `${event.eventTime}`,
            `${event.name}`
        ];
        const e = event;
        for(const prop in e)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const value = e[prop];
            let valueToLog = "<NULL>";
            if (value !== undefined && value !== null) {
                if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                else valueToLog = JSON.stringify(value);
            }
            logFragments.push(`${prop}: ${valueToLog}`);
        }
        return logFragments.join(" | ");
    }
    constructor(logLevelFilter = $7W454.LogLevel.None){
        this.privLogPath = undefined;
        this.privEnableConsoleOutput = true;
        this.privLogLevelFilter = logLevelFilter;
    }
}
module.exports.ConsoleLoggingListener = $48d8c9904897162a$var$ConsoleLoggingListener;

});
parcelRegister("3rte6", function(module, exports) {
"use strict";

});

parcelRegister("7W454", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = void 0;

var $iLPPT = parcelRequire("iLPPT");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $iLPPT.EventType;
    }
});

});

parcelRegister("3afpL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contracts = void 0;
/**
 * @class Contracts
 * @private
 */ class $24de434d0b219c1b$var$Contracts {
    static throwIfNullOrUndefined(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    }
    static throwIfNull(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    }
    static throwIfNullOrWhitespace(param, name) {
        $24de434d0b219c1b$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    }
    static throwIfNullOrTooLong(param, name, maxLength) {
        $24de434d0b219c1b$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length > maxLength) throw new Error("throwIfNullOrTooLong:" + name + " (more than " + maxLength.toString() + " characters)");
    }
    static throwIfNullOrTooShort(param, name, minLength) {
        $24de434d0b219c1b$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length < minLength) throw new Error("throwIfNullOrTooShort:" + name + " (less than " + minLength.toString() + " characters)");
    }
    static throwIfDisposed(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(array, name) {
        $24de434d0b219c1b$var$Contracts.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for (const item of array)$24de434d0b219c1b$var$Contracts.throwIfNullOrWhitespace(item, name);
    }
    static throwIfFileDoesNotExist(param, name) {
        $24de434d0b219c1b$var$Contracts.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    }
    static throwIfNotUndefined(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    }
}
module.exports.Contracts = $24de434d0b219c1b$var$Contracts;

});


parcelRegister("crfV6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cygk0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicAudioSource = module.exports.AudioWorkletSourceURLPropertyName = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $9Xjoq = parcelRequire("9Xjoq");
module.exports.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
class $9235522480d91faf$var$MicAudioSource {
    get format() {
        return Promise.resolve($9235522480d91faf$var$MicAudioSource.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new $iLPPT.Deferred();
        try {
            this.createAudioContext();
        } catch (error) {
            if (error instanceof Error) {
                const typedError = error;
                this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
            } else this.privInitializeDeferral.reject(error);
            return this.privInitializeDeferral.promise;
        }
        const nav = window.navigator;
        let getUserMedia = // eslint-disable-next-line
        nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (!!nav.mediaDevices) getUserMedia = (constraints, successCallback, errorCallback)=>{
            nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
        if (!getUserMedia) {
            const errorMsg = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(errorMsg);
            this.onEvent(new $iLPPT.AudioSourceErrorEvent(errorMsg, "")); // mic initialized error - no streamid at this point
        } else {
            const next = ()=>{
                this.onEvent(new $iLPPT.AudioSourceInitializingEvent(this.privId)); // no stream id
                if (this.privMediaStream && this.privMediaStream.active) {
                    this.onEvent(new $iLPPT.AudioSourceReadyEvent(this.privId));
                    this.privInitializeDeferral.resolve();
                } else getUserMedia({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : true,
                    video: false
                }, (mediaStream)=>{
                    this.privMediaStream = mediaStream;
                    this.onEvent(new $iLPPT.AudioSourceReadyEvent(this.privId));
                    this.privInitializeDeferral.resolve();
                }, (error)=>{
                    const errorMsg = `Error occurred during microphone initialization: ${error}`;
                    this.privInitializeDeferral.reject(errorMsg);
                    this.onEvent(new $iLPPT.AudioSourceErrorEvent(this.privId, errorMsg));
                });
            };
            if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
            // https://github.com/WebAudio/web-audio-api/issues/790
            this.privContext.resume().then(next).catch((reason)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${reason}`);
            });
            else next();
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        this.onEvent(new $iLPPT.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        return this.listen(audioNodeId).then((stream)=>{
            this.onEvent(new $iLPPT.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
            return {
                detach: async ()=>{
                    stream.readEnded();
                    delete this.privStreams[audioNodeId];
                    this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                    return this.turnOff();
                },
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    }
    async turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream) stream.close();
        }
        this.onEvent(new $iLPPT.AudioSourceOffEvent(this.privId)); // no stream now
        if (this.privInitializeDeferral) {
            // Correctly handle when browser forces mic off before turnOn() completes
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await this.privInitializeDeferral;
            this.privInitializeDeferral = null;
        }
        await this.destroyAudioContext();
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((label)=>({
                bitspersample: $9235522480d91faf$var$MicAudioSource.AUDIOFORMAT.bitsPerSample,
                channelcount: $9235522480d91faf$var$MicAudioSource.AUDIOFORMAT.channels,
                connectivity: $h6sQE.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: label,
                samplerate: $9235522480d91faf$var$MicAudioSource.AUDIOFORMAT.samplesPerSec,
                type: $h6sQE.type.Microphones
            }));
    }
    setProperty(name, value) {
        if (name === module.exports.AudioWorkletSourceURLPropertyName) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        const microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        const deferred = new $iLPPT.Deferred();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            for (const device of devices)if (device.deviceId === microphoneDeviceId) {
                // Found the device
                this.privMicrophoneLabel = device.label;
                break;
            }
            deferred.resolve(this.privMicrophoneLabel);
        }, ()=>deferred.resolve(this.privMicrophoneLabel));
        return deferred.promise;
    }
    async listen(audioNodeId) {
        await this.turnOn();
        const stream = new $iLPPT.ChunkedArrayBufferStream(this.privOutputChunkSize, audioNodeId);
        this.privStreams[audioNodeId] = stream;
        try {
            this.privRecorder.record(this.privContext, this.privMediaStream, stream);
        } catch (error) {
            this.onEvent(new $iLPPT.AudioStreamNodeErrorEvent(this.privId, audioNodeId, error));
            throw error;
        }
        const result = stream;
        return result;
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    createAudioContext() {
        if (!!this.privContext) return;
        this.privContext = $9Xjoq.AudioStreamFormatImpl.getAudioContext($9235522480d91faf$var$MicAudioSource.AUDIOFORMAT.samplesPerSec);
    }
    async destroyAudioContext() {
        if (!this.privContext) return;
        this.privRecorder.releaseMediaResources(this.privContext);
        // This pattern brought to you by a bug in the TypeScript compiler where it
        // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
        // https://github.com/Microsoft/TypeScript/issues/11498
        let hasClose = false;
        if ("close" in this.privContext) hasClose = true;
        if (hasClose) {
            if (!this.privIsClosing) {
                // The audio context close may take enough time that the close is called twice
                this.privIsClosing = true;
                await this.privContext.close();
                this.privContext = null;
                this.privIsClosing = false;
            }
        } else if (null !== this.privContext && this.privContext.state === "running") // Suspend actually takes a callback, but analogous to the
        // resume method, it'll be only fired if suspend is called
        // in a direct response to a user action. The later is not always
        // the case, as TurnOff is also called, when we receive an
        // end-of-speech message from the service. So, doing a best effort
        // fire-and-forget here.
        await this.privContext.suspend();
    }
    constructor(privRecorder, deviceId, audioSourceId, mediaStream){
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.privOutputChunkSize = $9235522480d91faf$var$MicAudioSource.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : $iLPPT.createNoDashGuid();
        this.privEvents = new $iLPPT.EventSource();
        this.privMediaStream = mediaStream || null;
        this.privIsClosing = false;
    }
}
module.exports.MicAudioSource = $9235522480d91faf$var$MicAudioSource;
$9235522480d91faf$var$MicAudioSource.AUDIOFORMAT = $9Xjoq.AudioStreamFormat.getDefaultInputFormat();

});
parcelRegister("9Xjoq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamFormatImpl = module.exports.AudioStreamFormat = module.exports.AudioFormatTag = void 0;
// eslint-disable-next-line max-classes-per-file
var $73f8aac2169b2fcf$var$AudioFormatTag;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
    AudioFormatTag[AudioFormatTag["FLAC"] = 9] = "FLAC";
    AudioFormatTag[AudioFormatTag["OPUS"] = 10] = "OPUS";
    AudioFormatTag[AudioFormatTag["AMR_WB"] = 11] = "AMR_WB";
    AudioFormatTag[AudioFormatTag["G722"] = 12] = "G722";
})($73f8aac2169b2fcf$var$AudioFormatTag = module.exports.AudioFormatTag || (module.exports.AudioFormatTag = {}));
/**
 * Represents audio stream format used for custom audio input configurations.
 * @class AudioStreamFormat
 */ class $73f8aac2169b2fcf$var$AudioStreamFormat {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getDefaultInputFormat() {
        return $73f8aac2169b2fcf$var$AudioStreamFormatImpl.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormat(samplesPerSecond, bitsPerSample, channels, format) {
        return new $73f8aac2169b2fcf$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels, format);
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
        return new $73f8aac2169b2fcf$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels);
    }
}
module.exports.AudioStreamFormat = $73f8aac2169b2fcf$var$AudioStreamFormat;
/**
 * @private
 * @class AudioStreamFormatImpl
 */ class $73f8aac2169b2fcf$var$AudioStreamFormatImpl extends $73f8aac2169b2fcf$var$AudioStreamFormat {
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ static getDefaultInputFormat() {
        return new $73f8aac2169b2fcf$var$AudioStreamFormatImpl();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ /* eslint-disable */ static getAudioContext(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        const AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    get header() {
        return this.privHeader;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ constructor(samplesPerSec = 16000, bitsPerSample = 16, channels = 1, format = $73f8aac2169b2fcf$var$AudioFormatTag.PCM){
        super();
        let isWavFormat = true;
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $73f8aac2169b2fcf$var$AudioFormatTag.PCM:
                this.formatTag = 1;
                break;
            case $73f8aac2169b2fcf$var$AudioFormatTag.ALaw:
                this.formatTag = 6;
                break;
            case $73f8aac2169b2fcf$var$AudioFormatTag.MuLaw:
                this.formatTag = 7;
                break;
            default:
                isWavFormat = false;
        }
        this.bitsPerSample = bitsPerSample;
        this.samplesPerSec = samplesPerSec;
        this.channels = channels;
        this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8);
        this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8);
        if (isWavFormat) {
            this.privHeader = new ArrayBuffer(44);
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
            const view = new DataView(this.privHeader);
            /* RIFF identifier */ this.setString(view, 0, "RIFF");
            /* file length */ view.setUint32(4, 0, true);
            /* RIFF type & Format */ this.setString(view, 8, "WAVEfmt ");
            /* format chunk length */ view.setUint32(16, 16, true);
            /* audio format */ view.setUint16(20, this.formatTag, true);
            /* channel count */ view.setUint16(22, this.channels, true);
            /* sample rate */ view.setUint32(24, this.samplesPerSec, true);
            /* byte rate (sample rate * block align) */ view.setUint32(28, this.avgBytesPerSec, true);
            /* block align (channel count * bytes per sample) */ view.setUint16(32, this.channels * (this.bitsPerSample / 8), true);
            /* bits per sample */ view.setUint16(34, this.bitsPerSample, true);
            /* data chunk identifier */ this.setString(view, 36, "data");
            /* data chunk length */ view.setUint32(40, 0, true);
        }
    }
}
module.exports.AudioStreamFormatImpl = $73f8aac2169b2fcf$var$AudioStreamFormatImpl;

});


parcelRegister("6AdSK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileAudioSource = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $9Xjoq = parcelRequire("9Xjoq");
class $4cb0df917454b45e$var$FileAudioSource {
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            this.onEvent(new $iLPPT.AudioSourceErrorEvent(errorMsg, ""));
            return Promise.reject(errorMsg);
        }
        this.onEvent(new $iLPPT.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $iLPPT.AudioSourceReadyEvent(this.privId));
        return;
    }
    id() {
        return this.privId;
    }
    async attach(audioNodeId) {
        this.onEvent(new $iLPPT.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        const stream = await this.upload(audioNodeId);
        this.onEvent(new $iLPPT.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return Promise.resolve({
            detach: async ()=>{
                stream.readEnded();
                delete this.privStreams[audioNodeId];
                this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                await this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>stream.read()
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    }
    turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream && !stream.isClosed) stream.close();
        }
        this.onEvent(new $iLPPT.AudioSourceOffEvent(this.privId)); // no stream now
        return Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((result)=>Promise.resolve({
                bitspersample: result.bitsPerSample,
                channelcount: result.channels,
                connectivity: $h6sQE.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: result.samplesPerSec,
                type: $h6sQE.type.File
            }));
    }
    readHeader() {
        // Read the wave header.
        const maxHeaderSize = 4296;
        const header = this.privSource.slice(0, maxHeaderSize);
        const headerResult = new $iLPPT.Deferred();
        const processHeader = (header)=>{
            const view = new DataView(header);
            const getWord = (index)=>String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const formatSize = view.getInt32(16, true);
            const channelCount = view.getUint16(22, true);
            const sampleRate = view.getUint32(24, true);
            const bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            let pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = pos + 8;
            headerResult.resolve($9Xjoq.AudioStreamFormat.getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event)=>{
                const header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            const h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    }
    async upload(audioNodeId) {
        const onerror = (error)=>{
            const errorMsg = `Error occurred while processing '${this.privFilename}'. ${error}`;
            this.onEvent(new $iLPPT.AudioStreamNodeErrorEvent(this.privId, audioNodeId, errorMsg));
            throw new Error(errorMsg);
        };
        try {
            await this.turnOn();
            const format = await this.privAudioFormatPromise;
            const stream = new $iLPPT.ChunkedArrayBufferStream(format.avgBytesPerSec / 10, audioNodeId);
            this.privStreams[audioNodeId] = stream;
            const chunk = this.privSource.slice(this.privHeaderEnd);
            const processFile = (buff)=>{
                if (stream.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                stream.writeStreamChunk({
                    buffer: buff,
                    isEnd: false,
                    timeReceived: Date.now()
                });
                stream.close();
            };
            if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                const reader = new FileReader();
                reader.onerror = (ev)=>onerror(ev.toString());
                reader.onload = (event)=>{
                    const fileBuffer = event.target.result;
                    processFile(fileBuffer);
                };
                reader.readAsArrayBuffer(chunk);
            } else {
                const c = chunk;
                processFile(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
            }
            return stream;
        } catch (e) {
            onerror(e);
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    constructor(file, filename, audioSourceId){
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.privId = audioSourceId ? audioSourceId : $iLPPT.createNoDashGuid();
        this.privEvents = new $iLPPT.EventSource();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
}
module.exports.FileAudioSource = $4cb0df917454b45e$var$FileAudioSource;

});

parcelRegister("7pUOg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PcmRecorder = void 0;

var $iLPPT = parcelRequire("iLPPT");
class $5666ef6c9519d763$var$PcmRecorder {
    record(context, mediaStream, outputStream) {
        const desiredSampleRate = 16000;
        const waveStreamEncoder = new $iLPPT.RiffPcmEncoder(context.sampleRate, desiredSampleRate);
        const micInput = context.createMediaStreamSource(mediaStream);
        const attachScriptProcessor = ()=>{
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const scriptNode = (()=>{
                let bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    let audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            })();
            scriptNode.onaudioprocess = (event)=>{
                const inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(scriptNode);
            scriptNode.connect(context.destination);
            this.privMediaResources = {
                scriptProcessorNode: scriptNode,
                source: micInput,
                stream: mediaStream
            };
        };
        // https://webaudio.github.io/web-audio-api/#audioworklet
        // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
        const skipAudioWorklet = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
        if (!!context.audioWorklet && !skipAudioWorklet) {
            if (!this.privSpeechProcessorScript) {
                const workletScript = `class SP extends AudioWorkletProcessor {
                    constructor(options) {
                      super(options);
                    }
                    process(inputs, outputs) {
                      const input = inputs[0];
                      const output = [];
                      for (let channel = 0; channel < input.length; channel += 1) {
                        output[channel] = input[channel];
                      }
                      this.port.postMessage(output[0]);
                      return true;
                    }
                  }
                  registerProcessor('speech-processor', SP);`;
                const blob = new Blob([
                    workletScript
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                this.privSpeechProcessorScript = URL.createObjectURL(blob);
            }
            context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                const workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = (ev)=>{
                    const inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        const waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(()=>{
                attachScriptProcessor();
            });
        } else try {
            attachScriptProcessor();
        } catch (err) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${err}`);
        }
    }
    releaseMediaResources(context) {
        if (this.privMediaResources) {
            if (this.privMediaResources.scriptProcessorNode) {
                this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                this.privMediaResources.scriptProcessorNode = null;
            }
            if (this.privMediaResources.source) {
                this.privMediaResources.source.disconnect();
                if (this.privStopInputOnRelease) this.privMediaResources.stream.getTracks().forEach((track)=>track.stop());
                this.privMediaResources.source = null;
            }
        }
    }
    setWorkletUrl(url) {
        this.privSpeechProcessorScript = url;
    }
    constructor(stopInputOnRelease){
        this.privStopInputOnRelease = stopInputOnRelease;
    }
}
module.exports.PcmRecorder = $5666ef6c9519d763$var$PcmRecorder;

});

parcelRegister("ga2V1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketConnection = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $4ixQI = parcelRequire("4ixQI");
class $bc3fd815f4cbf7a2$var$WebsocketConnection {
    async dispose() {
        this.privIsDisposed = true;
        if (this.privConnectionMessageAdapter) await this.privConnectionMessageAdapter.close();
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(message) {
        return this.privConnectionMessageAdapter.send(message);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
    constructor(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression = false, connectionId){
        this.privIsDisposed = false;
        if (!uri) throw new $iLPPT.ArgumentNullError("uri");
        if (!messageFormatter) throw new $iLPPT.ArgumentNullError("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        let queryParams = "";
        let i = 0;
        if (queryParameters) {
            for(const paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const key = encodeURIComponent(paramName);
                queryParams += key;
                let val = queryParameters[paramName];
                if (val) {
                    val = encodeURIComponent(val);
                    queryParams += `=${val}`;
                }
                i++;
            }
        }
        if (headers) {
            for(const headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(headers[headerName]);
                queryParams += `${headerName}=${val}`;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : $iLPPT.createNoDashGuid();
        this.privConnectionMessageAdapter = new $4ixQI.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
}
module.exports.WebsocketConnection = $bc3fd815f4cbf7a2$var$WebsocketConnection;

});
parcelRegister("4ixQI", function(module, exports) {

var $i9xOC = parcelRequire("i9xOC");
var $321319a50378d6c4$require$Buffer = $i9xOC.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $321319a50378d6c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $321319a50378d6c4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $321319a50378d6c4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $321319a50378d6c4$var$__createBinding(result, mod, k);
    }
    $321319a50378d6c4$var$__setModuleDefault(result, mod);
    return result;
};
var $321319a50378d6c4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageAdapter = void 0;

const $321319a50378d6c4$var$net = $321319a50378d6c4$var$__importStar((parcelRequire("3rte6")));

const $321319a50378d6c4$var$tls = $321319a50378d6c4$var$__importStar((parcelRequire("3rte6")));

const $321319a50378d6c4$var$agent_base_1 = $321319a50378d6c4$var$__importDefault((parcelRequire("3rte6")));

const $321319a50378d6c4$var$https_proxy_agent_1 = $321319a50378d6c4$var$__importDefault((parcelRequire("3rte6")));

const $321319a50378d6c4$var$ws_1 = $321319a50378d6c4$var$__importDefault((parcelRequire("3rte6")));

var $7Us8Y = parcelRequire("7Us8Y");

var $iLPPT = parcelRequire("iLPPT");
class $321319a50378d6c4$var$WebsocketMessageAdapter {
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === $iLPPT.ConnectionState.Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new $iLPPT.Deferred();
        this.privCertificateValidatedDeferral = new $iLPPT.Deferred();
        this.privConnectionState = $iLPPT.ConnectionState.Connecting;
        try {
            if (typeof WebSocket !== "undefined" && !$321319a50378d6c4$var$WebsocketMessageAdapter.forceNpmWebSocket) {
                // Browser handles cert checks.
                this.privCertificateValidatedDeferral.resolve();
                this.privWebsocketClient = new WebSocket(this.privUri);
            } else {
                const options = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                // The ocsp library will handle validation for us and fail the connection if needed.
                this.privCertificateValidatedDeferral.resolve();
                options.agent = this.getAgent();
                // Workaround for https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/465
                // Which is root caused by https://github.com/TooTallNate/node-agent-base/issues/61
                const uri = new URL(this.privUri);
                let protocol = uri.protocol;
                if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "wss:") protocol = "https:";
                else if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "ws:") protocol = "http:";
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                options.agent.protocol = protocol;
                this.privWebsocketClient = new $321319a50378d6c4$var$ws_1.default(this.privUri, options);
            }
            this.privWebsocketClient.binaryType = "arraybuffer";
            this.privReceivingMessageQueue = new $iLPPT.Queue();
            this.privDisconnectDeferral = new $iLPPT.Deferred();
            this.privSendMessageQueue = new $iLPPT.Queue();
            this.processSendQueue().catch((reason)=>{
                $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
            });
        } catch (error) {
            this.privConnectionEstablishDeferral.resolve(new $iLPPT.ConnectionOpenResponse(500, error));
            return this.privConnectionEstablishDeferral.promise;
        }
        this.onEvent(new $iLPPT.ConnectionStartEvent(this.privConnectionId, this.privUri));
        this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = $iLPPT.ConnectionState.Connected;
                this.onEvent(new $iLPPT.ConnectionEstablishedEvent(this.privConnectionId));
                this.privConnectionEstablishDeferral.resolve(new $iLPPT.ConnectionOpenResponse(200, ""));
            }, (error)=>{
                this.privConnectionEstablishDeferral.reject(error);
            });
        };
        this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new $iLPPT.ConnectionErrorEvent(this.privConnectionId, e.message, e.type));
            this.privLastErrorReceived = e.message;
        };
        this.privWebsocketClient.onclose = (e)=>{
            if (this.privConnectionState === $iLPPT.ConnectionState.Connecting) {
                this.privConnectionState = $iLPPT.ConnectionState.Disconnected;
                // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                this.privConnectionEstablishDeferral.resolve(new $iLPPT.ConnectionOpenResponse(e.code, e.reason + " " + this.privLastErrorReceived));
            } else {
                this.privConnectionState = $iLPPT.ConnectionState.Disconnected;
                this.privWebsocketClient = null;
                this.onEvent(new $iLPPT.ConnectionClosedEvent(this.privConnectionId, e.code, e.reason));
            }
            this.onClose(e.code, e.reason).catch((reason)=>{
                $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
            });
        };
        this.privWebsocketClient.onmessage = (e)=>{
            const networkReceivedTime = new Date().toISOString();
            if (this.privConnectionState === $iLPPT.ConnectionState.Connected) {
                const deferred = new $iLPPT.Deferred();
                // let id = ++this.idCounter;
                this.privReceivingMessageQueue.enqueueFromPromise(deferred.promise);
                if (e.data instanceof ArrayBuffer) {
                    const rawMessage = new $iLPPT.RawWebsocketMessage($iLPPT.MessageType.Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new $iLPPT.ConnectionMessageReceivedEvent(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid binary message format. Error: ${error}`);
                    });
                } else {
                    const rawMessage = new $iLPPT.RawWebsocketMessage($iLPPT.MessageType.Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new $iLPPT.ConnectionMessageReceivedEvent(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid text message format. Error: ${error}`);
                    });
                }
            }
        };
        return this.privConnectionEstablishDeferral.promise;
    }
    send(message) {
        if (this.privConnectionState !== $iLPPT.ConnectionState.Connected) return Promise.reject(`Cannot send on connection that is in ${$iLPPT.ConnectionState[this.privConnectionState]} state`);
        const messageSendStatusDeferral = new $iLPPT.Deferred();
        const messageSendDeferral = new $iLPPT.Deferred();
        this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
        this.privMessageFormatter.fromConnectionMessage(message).then((rawMessage)=>{
            messageSendDeferral.resolve({
                Message: message,
                RawWebsocketMessage: rawMessage,
                sendStatusDeferral: messageSendStatusDeferral
            });
        }, (error)=>{
            messageSendDeferral.reject(`Error formatting the message. ${error}`);
        });
        return messageSendStatusDeferral.promise;
    }
    read() {
        if (this.privConnectionState !== $iLPPT.ConnectionState.Connected) return Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`);
        return this.privReceivingMessageQueue.dequeue();
    }
    close(reason) {
        if (this.privWebsocketClient) {
            if (this.privConnectionState !== $iLPPT.ConnectionState.Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
        } else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(sendItem) {
        try {
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return Promise.resolve();
            this.onEvent(new $iLPPT.ConnectionMessageSentEvent(this.privConnectionId, new Date().toISOString(), sendItem.Message));
            // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
            if (this.isWebsocketOpen) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(`websocket send error: ${e}`);
        }
    }
    async onClose(code, reason) {
        const closeReason = `Connection closed. ${code}: ${reason}`;
        this.privConnectionState = $iLPPT.ConnectionState.Disconnected;
        this.privDisconnectDeferral.resolve();
        await this.privReceivingMessageQueue.drainAndDispose(()=>{
        // TODO: Events for these ?
        // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
        }, closeReason);
        await this.privSendMessageQueue.drainAndDispose((pendingSendItem)=>{
            pendingSendItem.sendStatusDeferral.reject(closeReason);
        }, closeReason);
    }
    async processSendQueue() {
        while(true){
            const itemToSend = this.privSendMessageQueue.dequeue();
            const sendItem = await itemToSend;
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return;
            try {
                await this.sendRawMessage(sendItem);
                sendItem.sendStatusDeferral.resolve();
            } catch (sendError) {
                sendItem.sendStatusDeferral.reject(sendError);
            }
        }
    }
    onEvent(event) {
        this.privConnectionEvents.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const agent = new $321319a50378d6c4$var$agent_base_1.default.Agent(this.createConnection);
        if (this.proxyInfo !== undefined && this.proxyInfo.HostName !== undefined && this.proxyInfo.Port > 0) agent.proxyInfo = this.proxyInfo;
        return agent;
    }
    static GetProxyAgent(proxyInfo) {
        const httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $321319a50378d6c4$require$Buffer(`${proxyInfo.UserName}:${proxyInfo.Password === undefined ? "" : proxyInfo.Password}`).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        const httpProxyAgent = new $321319a50378d6c4$var$https_proxy_agent_1.default(httpProxyOptions);
        return httpProxyAgent;
    }
    createConnection(request, options) {
        let socketPromise;
        options = {
            ...options,
            requestOCSP: true,
            servername: options.host
        };
        if (!!this.proxyInfo) {
            const httpProxyAgent = $321319a50378d6c4$var$WebsocketMessageAdapter.GetProxyAgent(this.proxyInfo);
            const baseAgent = httpProxyAgent;
            socketPromise = new Promise((resolve, reject)=>{
                baseAgent.callback(request, options, (error, socket)=>{
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($321319a50378d6c4$var$tls.connect(options));
        else socketPromise = Promise.resolve($321319a50378d6c4$var$net.connect(options));
        return socketPromise;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
    constructor(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression){
        if (!uri) throw new $iLPPT.ArgumentNullError("uri");
        if (!messageFormatter) throw new $iLPPT.ArgumentNullError("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new $iLPPT.EventSource();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = $iLPPT.ConnectionState.None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[$7Us8Y.HeaderNames.ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
}
module.exports.WebsocketMessageAdapter = $321319a50378d6c4$var$WebsocketMessageAdapter;
$321319a50378d6c4$var$WebsocketMessageAdapter.forceNpmWebSocket = false;

});
parcelRegister("i9xOC", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d3734c49c6df7e8a$export$a143d493d941bafc; }, function (v) { return $d3734c49c6df7e8a$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d3734c49c6df7e8a$export$f99ded8fe4b79145; }, function (v) { return $d3734c49c6df7e8a$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d3734c49c6df7e8a$export$a143d493d941bafc;
var $d3734c49c6df7e8a$export$e4cf37d7f6fb9e0a;
var $d3734c49c6df7e8a$export$f99ded8fe4b79145;
var $d3734c49c6df7e8a$export$599f31c3813fae4d;
"use strict";

var $72V8v = parcelRequire("72V8v");

var $1ungg = parcelRequire("1ungg");
const $d3734c49c6df7e8a$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d3734c49c6df7e8a$export$a143d493d941bafc = $d3734c49c6df7e8a$var$Buffer;
$d3734c49c6df7e8a$export$e4cf37d7f6fb9e0a = $d3734c49c6df7e8a$var$SlowBuffer;
$d3734c49c6df7e8a$export$f99ded8fe4b79145 = 50;
const $d3734c49c6df7e8a$var$K_MAX_LENGTH = 0x7fffffff;
$d3734c49c6df7e8a$export$599f31c3813fae4d = $d3734c49c6df7e8a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d3734c49c6df7e8a$var$Buffer.TYPED_ARRAY_SUPPORT = $d3734c49c6df7e8a$var$typedArraySupport();
if (!$d3734c49c6df7e8a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d3734c49c6df7e8a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d3734c49c6df7e8a$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d3734c49c6df7e8a$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d3734c49c6df7e8a$var$createBuffer(length) {
    if (length > $d3734c49c6df7e8a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d3734c49c6df7e8a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d3734c49c6df7e8a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d3734c49c6df7e8a$var$allocUnsafe(arg);
    }
    return $d3734c49c6df7e8a$var$from(arg, encodingOrOffset, length);
}
$d3734c49c6df7e8a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d3734c49c6df7e8a$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d3734c49c6df7e8a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d3734c49c6df7e8a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d3734c49c6df7e8a$var$isInstance(value, ArrayBuffer) || value && $d3734c49c6df7e8a$var$isInstance(value.buffer, ArrayBuffer)) return $d3734c49c6df7e8a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d3734c49c6df7e8a$var$isInstance(value, SharedArrayBuffer) || value && $d3734c49c6df7e8a$var$isInstance(value.buffer, SharedArrayBuffer))) return $d3734c49c6df7e8a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d3734c49c6df7e8a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d3734c49c6df7e8a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d3734c49c6df7e8a$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d3734c49c6df7e8a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d3734c49c6df7e8a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d3734c49c6df7e8a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d3734c49c6df7e8a$var$Buffer, Uint8Array);
function $d3734c49c6df7e8a$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d3734c49c6df7e8a$var$alloc(size, fill, encoding) {
    $d3734c49c6df7e8a$var$assertSize(size);
    if (size <= 0) return $d3734c49c6df7e8a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d3734c49c6df7e8a$var$createBuffer(size).fill(fill, encoding) : $d3734c49c6df7e8a$var$createBuffer(size).fill(fill);
    return $d3734c49c6df7e8a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d3734c49c6df7e8a$var$Buffer.alloc = function(size, fill, encoding) {
    return $d3734c49c6df7e8a$var$alloc(size, fill, encoding);
};
function $d3734c49c6df7e8a$var$allocUnsafe(size) {
    $d3734c49c6df7e8a$var$assertSize(size);
    return $d3734c49c6df7e8a$var$createBuffer(size < 0 ? 0 : $d3734c49c6df7e8a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d3734c49c6df7e8a$var$Buffer.allocUnsafe = function(size) {
    return $d3734c49c6df7e8a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d3734c49c6df7e8a$var$Buffer.allocUnsafeSlow = function(size) {
    return $d3734c49c6df7e8a$var$allocUnsafe(size);
};
function $d3734c49c6df7e8a$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d3734c49c6df7e8a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $d3734c49c6df7e8a$var$byteLength(string, encoding) | 0;
    let buf = $d3734c49c6df7e8a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d3734c49c6df7e8a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d3734c49c6df7e8a$var$checked(array.length) | 0;
    const buf = $d3734c49c6df7e8a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d3734c49c6df7e8a$var$fromArrayView(arrayView) {
    if ($d3734c49c6df7e8a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d3734c49c6df7e8a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d3734c49c6df7e8a$var$fromArrayLike(arrayView);
}
function $d3734c49c6df7e8a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d3734c49c6df7e8a$var$Buffer.prototype);
    return buf;
}
function $d3734c49c6df7e8a$var$fromObject(obj) {
    if ($d3734c49c6df7e8a$var$Buffer.isBuffer(obj)) {
        const len = $d3734c49c6df7e8a$var$checked(obj.length) | 0;
        const buf = $d3734c49c6df7e8a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d3734c49c6df7e8a$var$numberIsNaN(obj.length)) return $d3734c49c6df7e8a$var$createBuffer(0);
        return $d3734c49c6df7e8a$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d3734c49c6df7e8a$var$fromArrayLike(obj.data);
}
function $d3734c49c6df7e8a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d3734c49c6df7e8a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d3734c49c6df7e8a$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d3734c49c6df7e8a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d3734c49c6df7e8a$var$Buffer.alloc(+length);
}
$d3734c49c6df7e8a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d3734c49c6df7e8a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d3734c49c6df7e8a$var$Buffer.compare = function compare(a, b) {
    if ($d3734c49c6df7e8a$var$isInstance(a, Uint8Array)) a = $d3734c49c6df7e8a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d3734c49c6df7e8a$var$isInstance(b, Uint8Array)) b = $d3734c49c6df7e8a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(a) || !$d3734c49c6df7e8a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d3734c49c6df7e8a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d3734c49c6df7e8a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d3734c49c6df7e8a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d3734c49c6df7e8a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d3734c49c6df7e8a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(buf)) buf = $d3734c49c6df7e8a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d3734c49c6df7e8a$var$byteLength(string, encoding) {
    if ($d3734c49c6df7e8a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d3734c49c6df7e8a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d3734c49c6df7e8a$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d3734c49c6df7e8a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d3734c49c6df7e8a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d3734c49c6df7e8a$var$Buffer.byteLength = $d3734c49c6df7e8a$var$byteLength;
function $d3734c49c6df7e8a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d3734c49c6df7e8a$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d3734c49c6df7e8a$var$utf8Slice(this, start, end);
        case "ascii":
            return $d3734c49c6df7e8a$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d3734c49c6df7e8a$var$latin1Slice(this, start, end);
        case "base64":
            return $d3734c49c6df7e8a$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d3734c49c6df7e8a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d3734c49c6df7e8a$var$Buffer.prototype._isBuffer = true;
function $d3734c49c6df7e8a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d3734c49c6df7e8a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$d3734c49c6df7e8a$var$swap(this, i, i + 1);
    return this;
};
$d3734c49c6df7e8a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $d3734c49c6df7e8a$var$swap(this, i, i + 3);
        $d3734c49c6df7e8a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d3734c49c6df7e8a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $d3734c49c6df7e8a$var$swap(this, i, i + 7);
        $d3734c49c6df7e8a$var$swap(this, i + 1, i + 6);
        $d3734c49c6df7e8a$var$swap(this, i + 2, i + 5);
        $d3734c49c6df7e8a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d3734c49c6df7e8a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d3734c49c6df7e8a$var$utf8Slice(this, 0, length);
    return $d3734c49c6df7e8a$var$slowToString.apply(this, arguments);
};
$d3734c49c6df7e8a$var$Buffer.prototype.toLocaleString = $d3734c49c6df7e8a$var$Buffer.prototype.toString;
$d3734c49c6df7e8a$var$Buffer.prototype.equals = function equals(b) {
    if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d3734c49c6df7e8a$var$Buffer.compare(this, b) === 0;
};
$d3734c49c6df7e8a$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $d3734c49c6df7e8a$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d3734c49c6df7e8a$var$customInspectSymbol) $d3734c49c6df7e8a$var$Buffer.prototype[$d3734c49c6df7e8a$var$customInspectSymbol] = $d3734c49c6df7e8a$var$Buffer.prototype.inspect;
$d3734c49c6df7e8a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d3734c49c6df7e8a$var$isInstance(target, Uint8Array)) target = $d3734c49c6df7e8a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d3734c49c6df7e8a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d3734c49c6df7e8a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d3734c49c6df7e8a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d3734c49c6df7e8a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d3734c49c6df7e8a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d3734c49c6df7e8a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d3734c49c6df7e8a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d3734c49c6df7e8a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d3734c49c6df7e8a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d3734c49c6df7e8a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d3734c49c6df7e8a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d3734c49c6df7e8a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d3734c49c6df7e8a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d3734c49c6df7e8a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d3734c49c6df7e8a$var$utf8Write(buf, string, offset, length) {
    return $d3734c49c6df7e8a$var$blitBuffer($d3734c49c6df7e8a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d3734c49c6df7e8a$var$asciiWrite(buf, string, offset, length) {
    return $d3734c49c6df7e8a$var$blitBuffer($d3734c49c6df7e8a$var$asciiToBytes(string), buf, offset, length);
}
function $d3734c49c6df7e8a$var$base64Write(buf, string, offset, length) {
    return $d3734c49c6df7e8a$var$blitBuffer($d3734c49c6df7e8a$var$base64ToBytes(string), buf, offset, length);
}
function $d3734c49c6df7e8a$var$ucs2Write(buf, string, offset, length) {
    return $d3734c49c6df7e8a$var$blitBuffer($d3734c49c6df7e8a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d3734c49c6df7e8a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d3734c49c6df7e8a$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d3734c49c6df7e8a$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d3734c49c6df7e8a$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d3734c49c6df7e8a$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d3734c49c6df7e8a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d3734c49c6df7e8a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d3734c49c6df7e8a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $72V8v.fromByteArray(buf);
    else return $72V8v.fromByteArray(buf.slice(start, end));
}
function $d3734c49c6df7e8a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d3734c49c6df7e8a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d3734c49c6df7e8a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d3734c49c6df7e8a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d3734c49c6df7e8a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d3734c49c6df7e8a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d3734c49c6df7e8a$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d3734c49c6df7e8a$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d3734c49c6df7e8a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $d3734c49c6df7e8a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d3734c49c6df7e8a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d3734c49c6df7e8a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d3734c49c6df7e8a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d3734c49c6df7e8a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d3734c49c6df7e8a$var$Buffer.prototype.readUintLE = $d3734c49c6df7e8a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readUintBE = $d3734c49c6df7e8a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readUint8 = $d3734c49c6df7e8a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d3734c49c6df7e8a$var$Buffer.prototype.readUint16LE = $d3734c49c6df7e8a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readUint16BE = $d3734c49c6df7e8a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d3734c49c6df7e8a$var$Buffer.prototype.readUint32LE = $d3734c49c6df7e8a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readUint32BE = $d3734c49c6df7e8a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d3734c49c6df7e8a$var$Buffer.prototype.readBigUInt64LE = $d3734c49c6df7e8a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d3734c49c6df7e8a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d3734c49c6df7e8a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d3734c49c6df7e8a$var$Buffer.prototype.readBigUInt64BE = $d3734c49c6df7e8a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d3734c49c6df7e8a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d3734c49c6df7e8a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d3734c49c6df7e8a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d3734c49c6df7e8a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d3734c49c6df7e8a$var$Buffer.prototype.readBigInt64LE = $d3734c49c6df7e8a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d3734c49c6df7e8a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d3734c49c6df7e8a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d3734c49c6df7e8a$var$Buffer.prototype.readBigInt64BE = $d3734c49c6df7e8a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d3734c49c6df7e8a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d3734c49c6df7e8a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d3734c49c6df7e8a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 4, this.length);
    return $1ungg.read(this, offset, true, 23, 4);
};
$d3734c49c6df7e8a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 4, this.length);
    return $1ungg.read(this, offset, false, 23, 4);
};
$d3734c49c6df7e8a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 8, this.length);
    return $1ungg.read(this, offset, true, 52, 8);
};
$d3734c49c6df7e8a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkOffset(offset, 8, this.length);
    return $1ungg.read(this, offset, false, 52, 8);
};
function $d3734c49c6df7e8a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d3734c49c6df7e8a$var$Buffer.prototype.writeUintLE = $d3734c49c6df7e8a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d3734c49c6df7e8a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeUintBE = $d3734c49c6df7e8a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d3734c49c6df7e8a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeUint8 = $d3734c49c6df7e8a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeUint16LE = $d3734c49c6df7e8a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeUint16BE = $d3734c49c6df7e8a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeUint32LE = $d3734c49c6df7e8a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeUint32BE = $d3734c49c6df7e8a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d3734c49c6df7e8a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d3734c49c6df7e8a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d3734c49c6df7e8a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d3734c49c6df7e8a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d3734c49c6df7e8a$var$Buffer.prototype.writeBigUInt64LE = $d3734c49c6df7e8a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d3734c49c6df7e8a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d3734c49c6df7e8a$var$Buffer.prototype.writeBigUInt64BE = $d3734c49c6df7e8a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d3734c49c6df7e8a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d3734c49c6df7e8a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d3734c49c6df7e8a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d3734c49c6df7e8a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeBigInt64LE = $d3734c49c6df7e8a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d3734c49c6df7e8a$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$d3734c49c6df7e8a$var$Buffer.prototype.writeBigInt64BE = $d3734c49c6df7e8a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d3734c49c6df7e8a$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $d3734c49c6df7e8a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d3734c49c6df7e8a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1ungg.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d3734c49c6df7e8a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d3734c49c6df7e8a$var$writeFloat(this, value, offset, true, noAssert);
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d3734c49c6df7e8a$var$writeFloat(this, value, offset, false, noAssert);
};
function $d3734c49c6df7e8a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3734c49c6df7e8a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1ungg.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d3734c49c6df7e8a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d3734c49c6df7e8a$var$writeDouble(this, value, offset, true, noAssert);
};
$d3734c49c6df7e8a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d3734c49c6df7e8a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d3734c49c6df7e8a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d3734c49c6df7e8a$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d3734c49c6df7e8a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d3734c49c6df7e8a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d3734c49c6df7e8a$var$Buffer.isBuffer(val) ? val : $d3734c49c6df7e8a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d3734c49c6df7e8a$var$errors = {};
function $d3734c49c6df7e8a$var$E(sym, getMessage, Base) {
    $d3734c49c6df7e8a$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$d3734c49c6df7e8a$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$d3734c49c6df7e8a$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d3734c49c6df7e8a$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d3734c49c6df7e8a$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d3734c49c6df7e8a$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d3734c49c6df7e8a$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d3734c49c6df7e8a$var$checkBounds(buf, offset, byteLength) {
    $d3734c49c6df7e8a$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d3734c49c6df7e8a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d3734c49c6df7e8a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d3734c49c6df7e8a$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $d3734c49c6df7e8a$var$checkBounds(buf, offset, byteLength);
}
function $d3734c49c6df7e8a$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $d3734c49c6df7e8a$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $d3734c49c6df7e8a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d3734c49c6df7e8a$var$validateNumber(value, type);
        throw new $d3734c49c6df7e8a$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $d3734c49c6df7e8a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d3734c49c6df7e8a$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d3734c49c6df7e8a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d3734c49c6df7e8a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d3734c49c6df7e8a$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d3734c49c6df7e8a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d3734c49c6df7e8a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d3734c49c6df7e8a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d3734c49c6df7e8a$var$base64ToBytes(str) {
    return $72V8v.toByteArray($d3734c49c6df7e8a$var$base64clean(str));
}
function $d3734c49c6df7e8a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d3734c49c6df7e8a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d3734c49c6df7e8a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d3734c49c6df7e8a$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d3734c49c6df7e8a$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $d3734c49c6df7e8a$var$BufferBigIntNotDefined : fn;
}
function $d3734c49c6df7e8a$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("72V8v", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $52150a57057d75a7$export$d622b2ad8d90c771; }, function (v) { return $52150a57057d75a7$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $52150a57057d75a7$export$6100ba28696e12de; }, function (v) { return $52150a57057d75a7$export$6100ba28696e12de = v; });
var $52150a57057d75a7$export$a48f0734ac7c2329;
var $52150a57057d75a7$export$d622b2ad8d90c771;
var $52150a57057d75a7$export$6100ba28696e12de;
"use strict";
$52150a57057d75a7$export$a48f0734ac7c2329 = $52150a57057d75a7$var$byteLength;
$52150a57057d75a7$export$d622b2ad8d90c771 = $52150a57057d75a7$var$toByteArray;
$52150a57057d75a7$export$6100ba28696e12de = $52150a57057d75a7$var$fromByteArray;
var $52150a57057d75a7$var$lookup = [];
var $52150a57057d75a7$var$revLookup = [];
var $52150a57057d75a7$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $52150a57057d75a7$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $52150a57057d75a7$var$i = 0, $52150a57057d75a7$var$len = $52150a57057d75a7$var$code.length; $52150a57057d75a7$var$i < $52150a57057d75a7$var$len; ++$52150a57057d75a7$var$i){
    $52150a57057d75a7$var$lookup[$52150a57057d75a7$var$i] = $52150a57057d75a7$var$code[$52150a57057d75a7$var$i];
    $52150a57057d75a7$var$revLookup[$52150a57057d75a7$var$code.charCodeAt($52150a57057d75a7$var$i)] = $52150a57057d75a7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$52150a57057d75a7$var$revLookup["-".charCodeAt(0)] = 62;
$52150a57057d75a7$var$revLookup["_".charCodeAt(0)] = 63;
function $52150a57057d75a7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $52150a57057d75a7$var$byteLength(b64) {
    var lens = $52150a57057d75a7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $52150a57057d75a7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $52150a57057d75a7$var$toByteArray(b64) {
    var tmp;
    var lens = $52150a57057d75a7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $52150a57057d75a7$var$Arr($52150a57057d75a7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $52150a57057d75a7$var$revLookup[b64.charCodeAt(i)] << 18 | $52150a57057d75a7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $52150a57057d75a7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $52150a57057d75a7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $52150a57057d75a7$var$revLookup[b64.charCodeAt(i)] << 2 | $52150a57057d75a7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $52150a57057d75a7$var$revLookup[b64.charCodeAt(i)] << 10 | $52150a57057d75a7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $52150a57057d75a7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $52150a57057d75a7$var$tripletToBase64(num) {
    return $52150a57057d75a7$var$lookup[num >> 18 & 0x3F] + $52150a57057d75a7$var$lookup[num >> 12 & 0x3F] + $52150a57057d75a7$var$lookup[num >> 6 & 0x3F] + $52150a57057d75a7$var$lookup[num & 0x3F];
}
function $52150a57057d75a7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($52150a57057d75a7$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $52150a57057d75a7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($52150a57057d75a7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($52150a57057d75a7$var$lookup[tmp >> 2] + $52150a57057d75a7$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($52150a57057d75a7$var$lookup[tmp >> 10] + $52150a57057d75a7$var$lookup[tmp >> 4 & 0x3F] + $52150a57057d75a7$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("1ungg", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $115aa3069262fc8c$export$aafa59e2e03f2942; }, function (v) { return $115aa3069262fc8c$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $115aa3069262fc8c$export$68d8715fc104d294; }, function (v) { return $115aa3069262fc8c$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $115aa3069262fc8c$export$aafa59e2e03f2942;
var $115aa3069262fc8c$export$68d8715fc104d294;
$115aa3069262fc8c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$115aa3069262fc8c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("hxOUO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReplayableAudioNode = void 0;
class $cc5d0374178f40ab$var$ReplayableAudioNode {
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            const offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            let i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((result)=>{
            if (result && result.buffer) {
                this.privBuffers.push(new $cc5d0374178f40ab$var$BufferEntry(result, this.privBufferSerial++, this.privBufferedBytes));
                this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    }
    detach() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    }
    replay() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        const offsetToSeek = offset - this.privBufferStartOffset;
        let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        let i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for (const value of this.privBuffers){
            const startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            const endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    }
    constructor(audioSource, bytesPerSecond){
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
}
module.exports.ReplayableAudioNode = $cc5d0374178f40ab$var$ReplayableAudioNode;
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
class $cc5d0374178f40ab$var$BufferEntry {
    constructor(chunk, serial, byteOffset){
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
}

});

parcelRegister("aqoNk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyInfo = void 0;

var $14iyq = parcelRequire("14iyq");
class $796f90c665e1ac39$var$ProxyInfo {
    static fromParameters(parameters) {
        return new $796f90c665e1ac39$var$ProxyInfo(parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyPort), 10), parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyUserName), parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(config) {
        return this.fromParameters(config.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
    constructor(proxyHostName, proxyPort, proxyUserName, proxyPassword){
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
}
module.exports.ProxyInfo = $796f90c665e1ac39$var$ProxyInfo;

});
parcelRegister("14iyq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2IfFc = parcelRequire("2IfFc");
Object.defineProperty(module.exports, "AudioConfig", {
    enumerable: true,
    get: function() {
        return $2IfFc.AudioConfig;
    }
});

var $9Xjoq = parcelRequire("9Xjoq");
Object.defineProperty(module.exports, "AudioStreamFormat", {
    enumerable: true,
    get: function() {
        return $9Xjoq.AudioStreamFormat;
    }
});
Object.defineProperty(module.exports, "AudioFormatTag", {
    enumerable: true,
    get: function() {
        return $9Xjoq.AudioFormatTag;
    }
});

var $lzD4B = parcelRequire("lzD4B");
Object.defineProperty(module.exports, "AudioInputStream", {
    enumerable: true,
    get: function() {
        return $lzD4B.AudioInputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioInputStream", {
    enumerable: true,
    get: function() {
        return $lzD4B.PullAudioInputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioInputStream", {
    enumerable: true,
    get: function() {
        return $lzD4B.PushAudioInputStream;
    }
});

var $lrnFA = parcelRequire("lrnFA");
Object.defineProperty(module.exports, "AudioOutputStream", {
    enumerable: true,
    get: function() {
        return $lrnFA.AudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $lrnFA.PullAudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $lrnFA.PushAudioOutputStream;
    }
});

var $RTp4P = parcelRequire("RTp4P");
Object.defineProperty(module.exports, "CancellationReason", {
    enumerable: true,
    get: function() {
        return $RTp4P.CancellationReason;
    }
});

var $8fwXZ = parcelRequire("8fwXZ");
Object.defineProperty(module.exports, "PullAudioInputStreamCallback", {
    enumerable: true,
    get: function() {
        return $8fwXZ.PullAudioInputStreamCallback;
    }
});

var $1SQq0 = parcelRequire("1SQq0");
Object.defineProperty(module.exports, "PushAudioOutputStreamCallback", {
    enumerable: true,
    get: function() {
        return $1SQq0.PushAudioOutputStreamCallback;
    }
});

var $iAVQB = parcelRequire("iAVQB");
Object.defineProperty(module.exports, "KeywordRecognitionModel", {
    enumerable: true,
    get: function() {
        return $iAVQB.KeywordRecognitionModel;
    }
});

var $kxxLS = parcelRequire("kxxLS");
Object.defineProperty(module.exports, "SessionEventArgs", {
    enumerable: true,
    get: function() {
        return $kxxLS.SessionEventArgs;
    }
});

var $bdtsh = parcelRequire("bdtsh");
Object.defineProperty(module.exports, "RecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $bdtsh.RecognitionEventArgs;
    }
});

var $iV64c = parcelRequire("iV64c");
Object.defineProperty(module.exports, "OutputFormat", {
    enumerable: true,
    get: function() {
        return $iV64c.OutputFormat;
    }
});

var $e1EuW = parcelRequire("e1EuW");
Object.defineProperty(module.exports, "IntentRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $e1EuW.IntentRecognitionEventArgs;
    }
});

var $4gtkb = parcelRequire("4gtkb");
Object.defineProperty(module.exports, "RecognitionResult", {
    enumerable: true,
    get: function() {
        return $4gtkb.RecognitionResult;
    }
});

var $dPRUc = parcelRequire("dPRUc");
Object.defineProperty(module.exports, "SpeechRecognitionResult", {
    enumerable: true,
    get: function() {
        return $dPRUc.SpeechRecognitionResult;
    }
});

var $jebMk = parcelRequire("jebMk");
Object.defineProperty(module.exports, "IntentRecognitionResult", {
    enumerable: true,
    get: function() {
        return $jebMk.IntentRecognitionResult;
    }
});

var $6XDXp = parcelRequire("6XDXp");
Object.defineProperty(module.exports, "LanguageUnderstandingModel", {
    enumerable: true,
    get: function() {
        return $6XDXp.LanguageUnderstandingModel;
    }
});

var $di7k4 = parcelRequire("di7k4");
Object.defineProperty(module.exports, "SpeechRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $di7k4.SpeechRecognitionEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $di7k4.ConversationTranscriptionEventArgs;
    }
});
Object.defineProperty(module.exports, "MeetingTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $di7k4.MeetingTranscriptionEventArgs;
    }
});

var $k8nTT = parcelRequire("k8nTT");
Object.defineProperty(module.exports, "SpeechRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $k8nTT.SpeechRecognitionCanceledEventArgs;
    }
});

var $lGm0I = parcelRequire("lGm0I");
Object.defineProperty(module.exports, "TranslationRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $lGm0I.TranslationRecognitionEventArgs;
    }
});

var $lmVuc = parcelRequire("lmVuc");
Object.defineProperty(module.exports, "TranslationSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $lmVuc.TranslationSynthesisEventArgs;
    }
});

var $6KTc5 = parcelRequire("6KTc5");
Object.defineProperty(module.exports, "TranslationRecognitionResult", {
    enumerable: true,
    get: function() {
        return $6KTc5.TranslationRecognitionResult;
    }
});

var $aTjcU = parcelRequire("aTjcU");
Object.defineProperty(module.exports, "TranslationSynthesisResult", {
    enumerable: true,
    get: function() {
        return $aTjcU.TranslationSynthesisResult;
    }
});

var $hQ5KG = parcelRequire("hQ5KG");
Object.defineProperty(module.exports, "ResultReason", {
    enumerable: true,
    get: function() {
        return $hQ5KG.ResultReason;
    }
});

var $4GxG1 = parcelRequire("4GxG1");
Object.defineProperty(module.exports, "SpeechConfig", {
    enumerable: true,
    get: function() {
        return $4GxG1.SpeechConfig;
    }
});
Object.defineProperty(module.exports, "SpeechConfigImpl", {
    enumerable: true,
    get: function() {
        return $4GxG1.SpeechConfigImpl;
    }
});

var $dXGsU = parcelRequire("dXGsU");
Object.defineProperty(module.exports, "SpeechTranslationConfig", {
    enumerable: true,
    get: function() {
        return $dXGsU.SpeechTranslationConfig;
    }
});
Object.defineProperty(module.exports, "SpeechTranslationConfigImpl", {
    enumerable: true,
    get: function() {
        return $dXGsU.SpeechTranslationConfigImpl;
    }
});

var $joXzx = parcelRequire("joXzx");
Object.defineProperty(module.exports, "PropertyCollection", {
    enumerable: true,
    get: function() {
        return $joXzx.PropertyCollection;
    }
});

var $1jqKG = parcelRequire("1jqKG");
Object.defineProperty(module.exports, "PropertyId", {
    enumerable: true,
    get: function() {
        return $1jqKG.PropertyId;
    }
});

var $ibcPP = parcelRequire("ibcPP");
Object.defineProperty(module.exports, "Recognizer", {
    enumerable: true,
    get: function() {
        return $ibcPP.Recognizer;
    }
});

var $aeqYX = parcelRequire("aeqYX");
Object.defineProperty(module.exports, "SpeechRecognizer", {
    enumerable: true,
    get: function() {
        return $aeqYX.SpeechRecognizer;
    }
});

var $fKjP1 = parcelRequire("fKjP1");
Object.defineProperty(module.exports, "IntentRecognizer", {
    enumerable: true,
    get: function() {
        return $fKjP1.IntentRecognizer;
    }
});

var $8LNu6 = parcelRequire("8LNu6");
Object.defineProperty(module.exports, "VoiceProfileType", {
    enumerable: true,
    get: function() {
        return $8LNu6.VoiceProfileType;
    }
});

var $38ihW = parcelRequire("38ihW");
Object.defineProperty(module.exports, "TranslationRecognizer", {
    enumerable: true,
    get: function() {
        return $38ihW.TranslationRecognizer;
    }
});

var $bR9JT = parcelRequire("bR9JT");
Object.defineProperty(module.exports, "Translations", {
    enumerable: true,
    get: function() {
        return $bR9JT.Translations;
    }
});

var $cnuSQ = parcelRequire("cnuSQ");
Object.defineProperty(module.exports, "NoMatchReason", {
    enumerable: true,
    get: function() {
        return $cnuSQ.NoMatchReason;
    }
});

var $7kjU5 = parcelRequire("7kjU5");
Object.defineProperty(module.exports, "NoMatchDetails", {
    enumerable: true,
    get: function() {
        return $7kjU5.NoMatchDetails;
    }
});

var $9mcGx = parcelRequire("9mcGx");
Object.defineProperty(module.exports, "TranslationRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $9mcGx.TranslationRecognitionCanceledEventArgs;
    }
});

var $1SlEV = parcelRequire("1SlEV");
Object.defineProperty(module.exports, "IntentRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $1SlEV.IntentRecognitionCanceledEventArgs;
    }
});

var $d5ckj = parcelRequire("d5ckj");
Object.defineProperty(module.exports, "CancellationDetailsBase", {
    enumerable: true,
    get: function() {
        return $d5ckj.CancellationDetailsBase;
    }
});

var $aSTrG = parcelRequire("aSTrG");
Object.defineProperty(module.exports, "CancellationDetails", {
    enumerable: true,
    get: function() {
        return $aSTrG.CancellationDetails;
    }
});

var $6ipDE = parcelRequire("6ipDE");
Object.defineProperty(module.exports, "CancellationErrorCode", {
    enumerable: true,
    get: function() {
        return $6ipDE.CancellationErrorCode;
    }
});

var $aWCaO = parcelRequire("aWCaO");
Object.defineProperty(module.exports, "ConnectionEventArgs", {
    enumerable: true,
    get: function() {
        return $aWCaO.ConnectionEventArgs;
    }
});

var $56I7a = parcelRequire("56I7a");
Object.defineProperty(module.exports, "ServiceEventArgs", {
    enumerable: true,
    get: function() {
        return $56I7a.ServiceEventArgs;
    }
});

var $lOcWU = parcelRequire("lOcWU");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $lOcWU.Connection;
    }
});

var $f0Mf4 = parcelRequire("f0Mf4");
Object.defineProperty(module.exports, "PhraseListGrammar", {
    enumerable: true,
    get: function() {
        return $f0Mf4.PhraseListGrammar;
    }
});

var $9pOty = parcelRequire("9pOty");
Object.defineProperty(module.exports, "DialogServiceConfig", {
    enumerable: true,
    get: function() {
        return $9pOty.DialogServiceConfig;
    }
});

var $j6e5o = parcelRequire("j6e5o");
Object.defineProperty(module.exports, "BotFrameworkConfig", {
    enumerable: true,
    get: function() {
        return $j6e5o.BotFrameworkConfig;
    }
});

var $dn3o0 = parcelRequire("dn3o0");
Object.defineProperty(module.exports, "CustomCommandsConfig", {
    enumerable: true,
    get: function() {
        return $dn3o0.CustomCommandsConfig;
    }
});

var $f52wp = parcelRequire("f52wp");
Object.defineProperty(module.exports, "DialogServiceConnector", {
    enumerable: true,
    get: function() {
        return $f52wp.DialogServiceConnector;
    }
});

var $gYeb1 = parcelRequire("gYeb1");
Object.defineProperty(module.exports, "ActivityReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $gYeb1.ActivityReceivedEventArgs;
    }
});

var $12LVS = parcelRequire("12LVS");
Object.defineProperty(module.exports, "TurnStatusReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $12LVS.TurnStatusReceivedEventArgs;
    }
});

var $38LHC = parcelRequire("38LHC");
Object.defineProperty(module.exports, "ServicePropertyChannel", {
    enumerable: true,
    get: function() {
        return $38LHC.ServicePropertyChannel;
    }
});

var $3W9cf = parcelRequire("3W9cf");
Object.defineProperty(module.exports, "ProfanityOption", {
    enumerable: true,
    get: function() {
        return $3W9cf.ProfanityOption;
    }
});

var $3hO9W = parcelRequire("3hO9W");
Object.defineProperty(module.exports, "BaseAudioPlayer", {
    enumerable: true,
    get: function() {
        return $3hO9W.BaseAudioPlayer;
    }
});

var $glNqD = parcelRequire("glNqD");
Object.defineProperty(module.exports, "ConnectionMessageEventArgs", {
    enumerable: true,
    get: function() {
        return $glNqD.ConnectionMessageEventArgs;
    }
});

var $297I0 = parcelRequire("297I0");
Object.defineProperty(module.exports, "ConnectionMessage", {
    enumerable: true,
    get: function() {
        return $297I0.ConnectionMessage;
    }
});

var $402sZ = parcelRequire("402sZ");
Object.defineProperty(module.exports, "VoiceProfile", {
    enumerable: true,
    get: function() {
        return $402sZ.VoiceProfile;
    }
});

var $7j8Ky = parcelRequire("7j8Ky");
Object.defineProperty(module.exports, "VoiceProfileEnrollmentResult", {
    enumerable: true,
    get: function() {
        return $7j8Ky.VoiceProfileEnrollmentResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileEnrollmentCancellationDetails", {
    enumerable: true,
    get: function() {
        return $7j8Ky.VoiceProfileEnrollmentCancellationDetails;
    }
});

var $34Zsr = parcelRequire("34Zsr");
Object.defineProperty(module.exports, "VoiceProfileResult", {
    enumerable: true,
    get: function() {
        return $34Zsr.VoiceProfileResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileCancellationDetails", {
    enumerable: true,
    get: function() {
        return $34Zsr.VoiceProfileCancellationDetails;
    }
});

var $4sLWV = parcelRequire("4sLWV");
Object.defineProperty(module.exports, "VoiceProfilePhraseResult", {
    enumerable: true,
    get: function() {
        return $4sLWV.VoiceProfilePhraseResult;
    }
});

var $4rYC0 = parcelRequire("4rYC0");
Object.defineProperty(module.exports, "VoiceProfileClient", {
    enumerable: true,
    get: function() {
        return $4rYC0.VoiceProfileClient;
    }
});

var $38YHD = parcelRequire("38YHD");
Object.defineProperty(module.exports, "SpeakerRecognizer", {
    enumerable: true,
    get: function() {
        return $38YHD.SpeakerRecognizer;
    }
});

var $dnueU = parcelRequire("dnueU");
Object.defineProperty(module.exports, "SpeakerIdentificationModel", {
    enumerable: true,
    get: function() {
        return $dnueU.SpeakerIdentificationModel;
    }
});

var $2aXFC = parcelRequire("2aXFC");
Object.defineProperty(module.exports, "SpeakerVerificationModel", {
    enumerable: true,
    get: function() {
        return $2aXFC.SpeakerVerificationModel;
    }
});

var $dHZMK = parcelRequire("dHZMK");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $dHZMK.AutoDetectSourceLanguageConfig;
    }
});

var $bMNw6 = parcelRequire("bMNw6");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageResult", {
    enumerable: true,
    get: function() {
        return $bMNw6.AutoDetectSourceLanguageResult;
    }
});

var $jyZfJ = parcelRequire("jyZfJ");
Object.defineProperty(module.exports, "SourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $jyZfJ.SourceLanguageConfig;
    }
});

var $aGEDK = parcelRequire("aGEDK");
Object.defineProperty(module.exports, "SpeakerRecognitionResult", {
    enumerable: true,
    get: function() {
        return $aGEDK.SpeakerRecognitionResult;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionResultType", {
    enumerable: true,
    get: function() {
        return $aGEDK.SpeakerRecognitionResultType;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionCancellationDetails", {
    enumerable: true,
    get: function() {
        return $aGEDK.SpeakerRecognitionCancellationDetails;
    }
});

var $1Prr7 = parcelRequire("1Prr7");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $1Prr7.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationExpirationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationParticipantsChangedEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationTranslationCanceledEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationTranslationResult;
    }
});
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationTranslator;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationTranscriber;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionResult", {
    enumerable: true,
    get: function() {
        return $1Prr7.ConversationTranscriptionResult;
    }
});
Object.defineProperty(module.exports, "Meeting", {
    enumerable: true,
    get: function() {
        return $1Prr7.Meeting;
    }
});
Object.defineProperty(module.exports, "MeetingTranscriber", {
    enumerable: true,
    get: function() {
        return $1Prr7.MeetingTranscriber;
    }
});
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $1Prr7.Participant;
    }
});
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $1Prr7.ParticipantChangedReason;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $1Prr7.User;
    }
});

var $aPoyg = parcelRequire("aPoyg");
Object.defineProperty(module.exports, "Synthesizer", {
    enumerable: true,
    get: function() {
        return $aPoyg.Synthesizer;
    }
});

var $6SWBJ = parcelRequire("6SWBJ");
Object.defineProperty(module.exports, "SpeechSynthesisOutputFormat", {
    enumerable: true,
    get: function() {
        return $6SWBJ.SpeechSynthesisOutputFormat;
    }
});

var $1XURZ = parcelRequire("1XURZ");
Object.defineProperty(module.exports, "SpeechSynthesizer", {
    enumerable: true,
    get: function() {
        return $1XURZ.SpeechSynthesizer;
    }
});

var $fVhXU = parcelRequire("fVhXU");
Object.defineProperty(module.exports, "SynthesisResult", {
    enumerable: true,
    get: function() {
        return $fVhXU.SynthesisResult;
    }
});

var $6LGF6 = parcelRequire("6LGF6");
Object.defineProperty(module.exports, "SpeechSynthesisResult", {
    enumerable: true,
    get: function() {
        return $6LGF6.SpeechSynthesisResult;
    }
});

var $cqWgr = parcelRequire("cqWgr");
Object.defineProperty(module.exports, "SpeechSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $cqWgr.SpeechSynthesisEventArgs;
    }
});

var $7cLP2 = parcelRequire("7cLP2");
Object.defineProperty(module.exports, "SpeechSynthesisWordBoundaryEventArgs", {
    enumerable: true,
    get: function() {
        return $7cLP2.SpeechSynthesisWordBoundaryEventArgs;
    }
});

var $dAftl = parcelRequire("dAftl");
Object.defineProperty(module.exports, "SpeechSynthesisBookmarkEventArgs", {
    enumerable: true,
    get: function() {
        return $dAftl.SpeechSynthesisBookmarkEventArgs;
    }
});

var $l9RGC = parcelRequire("l9RGC");
Object.defineProperty(module.exports, "SpeechSynthesisVisemeEventArgs", {
    enumerable: true,
    get: function() {
        return $l9RGC.SpeechSynthesisVisemeEventArgs;
    }
});

var $3AOJB = parcelRequire("3AOJB");
Object.defineProperty(module.exports, "SpeechSynthesisBoundaryType", {
    enumerable: true,
    get: function() {
        return $3AOJB.SpeechSynthesisBoundaryType;
    }
});

var $8SbXQ = parcelRequire("8SbXQ");
Object.defineProperty(module.exports, "SynthesisVoicesResult", {
    enumerable: true,
    get: function() {
        return $8SbXQ.SynthesisVoicesResult;
    }
});

var $16qp9 = parcelRequire("16qp9");
Object.defineProperty(module.exports, "VoiceInfo", {
    enumerable: true,
    get: function() {
        return $16qp9.VoiceInfo;
    }
});

var $hMgSu = parcelRequire("hMgSu");
Object.defineProperty(module.exports, "SpeakerAudioDestination", {
    enumerable: true,
    get: function() {
        return $hMgSu.SpeakerAudioDestination;
    }
});

var $EygK1 = parcelRequire("EygK1");
Object.defineProperty(module.exports, "ConversationTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $EygK1.ConversationTranscriptionCanceledEventArgs;
    }
});

var $4BpHU = parcelRequire("4BpHU");
Object.defineProperty(module.exports, "MeetingTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $4BpHU.MeetingTranscriptionCanceledEventArgs;
    }
});

var $2dw0X = parcelRequire("2dw0X");
Object.defineProperty(module.exports, "PronunciationAssessmentGradingSystem", {
    enumerable: true,
    get: function() {
        return $2dw0X.PronunciationAssessmentGradingSystem;
    }
});

var $3CEMv = parcelRequire("3CEMv");
Object.defineProperty(module.exports, "PronunciationAssessmentGranularity", {
    enumerable: true,
    get: function() {
        return $3CEMv.PronunciationAssessmentGranularity;
    }
});

var $2ZitX = parcelRequire("2ZitX");
Object.defineProperty(module.exports, "PronunciationAssessmentConfig", {
    enumerable: true,
    get: function() {
        return $2ZitX.PronunciationAssessmentConfig;
    }
});

var $jKfMR = parcelRequire("jKfMR");
Object.defineProperty(module.exports, "PronunciationAssessmentResult", {
    enumerable: true,
    get: function() {
        return $jKfMR.PronunciationAssessmentResult;
    }
});

var $lgher = parcelRequire("lgher");
Object.defineProperty(module.exports, "LanguageIdMode", {
    enumerable: true,
    get: function() {
        return $lgher.LanguageIdMode;
    }
});

var $2l6Lj = parcelRequire("2l6Lj");
Object.defineProperty(module.exports, "AvatarConfig", {
    enumerable: true,
    get: function() {
        return $2l6Lj.AvatarConfig;
    }
});

var $OMsU8 = parcelRequire("OMsU8");
Object.defineProperty(module.exports, "AvatarEventArgs", {
    enumerable: true,
    get: function() {
        return $OMsU8.AvatarEventArgs;
    }
});

var $9NbEP = parcelRequire("9NbEP");
Object.defineProperty(module.exports, "AvatarSynthesizer", {
    enumerable: true,
    get: function() {
        return $9NbEP.AvatarSynthesizer;
    }
});

var $9gmDv = parcelRequire("9gmDv");
Object.defineProperty(module.exports, "AvatarVideoFormat", {
    enumerable: true,
    get: function() {
        return $9gmDv.AvatarVideoFormat;
    }
});
Object.defineProperty(module.exports, "Coordinate", {
    enumerable: true,
    get: function() {
        return $9gmDv.Coordinate;
    }
});

var $1iS1y = parcelRequire("1iS1y");
Object.defineProperty(module.exports, "AvatarWebRTCConnectionResult", {
    enumerable: true,
    get: function() {
        return $1iS1y.AvatarWebRTCConnectionResult;
    }
});

var $ua2zW = parcelRequire("ua2zW");
Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return $ua2zW.Diagnostics;
    }
});

var $7W454 = parcelRequire("7W454");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $7W454.LogLevel;
    }
});

});
parcelRegister("2IfFc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputConfigImpl = module.exports.AudioConfigImpl = module.exports.AudioConfig = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $4Oa6i = parcelRequire("4Oa6i");

var $lzD4B = parcelRequire("lzD4B");

var $lrnFA = parcelRequire("lrnFA");
/**
 * Represents audio input configuration used for specifying what type of input to use (microphone, file, stream).
 * @class AudioConfig
 * Updated in version 1.11.0
 */ class $1f9bd7465d66b999$var$AudioConfig {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromDefaultMicrophoneInput() {
        const pcmRecorder = new $1JzGB.PcmRecorder(true);
        return new $1f9bd7465d66b999$var$AudioConfigImpl(new $1JzGB.MicAudioSource(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromMicrophoneInput(deviceId) {
        const pcmRecorder = new $1JzGB.PcmRecorder(true);
        return new $1f9bd7465d66b999$var$AudioConfigImpl(new $1JzGB.MicAudioSource(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromWavFileInput(file, name = "unnamedBuffer.wav") {
        return new $1f9bd7465d66b999$var$AudioConfigImpl(new $1JzGB.FileAudioSource(file, name));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromStreamInput(audioStream) {
        if (audioStream instanceof $14iyq.PullAudioInputStreamCallback) return new $1f9bd7465d66b999$var$AudioConfigImpl(new $lzD4B.PullAudioInputStreamImpl(audioStream));
        if (audioStream instanceof $14iyq.AudioInputStream) return new $1f9bd7465d66b999$var$AudioConfigImpl(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            const pcmRecorder = new $1JzGB.PcmRecorder(false);
            return new $1f9bd7465d66b999$var$AudioConfigImpl(new $1JzGB.MicAudioSource(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromDefaultSpeakerOutput() {
        return new $1f9bd7465d66b999$var$AudioOutputConfigImpl(new $14iyq.SpeakerAudioDestination());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ static fromSpeakerOutput(player) {
        if (player === undefined) return $1f9bd7465d66b999$var$AudioConfig.fromDefaultSpeakerOutput();
        if (player instanceof $14iyq.SpeakerAudioDestination) return new $1f9bd7465d66b999$var$AudioOutputConfigImpl(player);
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromAudioFileOutput(filename) {
        return new $1f9bd7465d66b999$var$AudioOutputConfigImpl(new $4Oa6i.AudioFileWriter(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromStreamOutput(audioStream) {
        if (audioStream instanceof $14iyq.PushAudioOutputStreamCallback) return new $1f9bd7465d66b999$var$AudioOutputConfigImpl(new $lrnFA.PushAudioOutputStreamImpl(audioStream));
        if (audioStream instanceof $14iyq.PushAudioOutputStream) return new $1f9bd7465d66b999$var$AudioOutputConfigImpl(audioStream);
        if (audioStream instanceof $14iyq.PullAudioOutputStream) return new $1f9bd7465d66b999$var$AudioOutputConfigImpl(audioStream);
        throw new Error("Not Supported Type");
    }
}
module.exports.AudioConfig = $1f9bd7465d66b999$var$AudioConfig;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class AudioConfigImpl
 */ class $1f9bd7465d66b999$var$AudioConfigImpl extends $1f9bd7465d66b999$var$AudioConfig {
    /**
     * Format information for the audio
     */ get format() {
        return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        this.privSource.turnOff().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ id() {
        return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ attach(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ detach(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */ get events() {
        return this.privSource.events;
    }
    setProperty(name, value) {
        $3afpL.Contracts.throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ constructor(source){
        super();
        this.privSource = source;
    }
}
module.exports.AudioConfigImpl = $1f9bd7465d66b999$var$AudioConfigImpl;
class $1f9bd7465d66b999$var$AudioOutputConfigImpl extends $1f9bd7465d66b999$var$AudioConfig {
    set format(format) {
        this.privDestination.format = format;
    }
    write(buffer) {
        this.privDestination.write(buffer);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ constructor(destination){
        super();
        this.privDestination = destination;
    }
}
module.exports.AudioOutputConfigImpl = $1f9bd7465d66b999$var$AudioOutputConfigImpl;

});
parcelRegister("4Oa6i", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $3803aab63fb0b430$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3803aab63fb0b430$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3803aab63fb0b430$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $3803aab63fb0b430$var$__createBinding(result, mod, k);
    }
    $3803aab63fb0b430$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioFileWriter = void 0;

const $3803aab63fb0b430$var$fs = $3803aab63fb0b430$var$__importStar((parcelRequire("3rte6")));

var $3afpL = parcelRequire("3afpL");
class $3803aab63fb0b430$var$AudioFileWriter {
    set format(format) {
        $3afpL.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set");
        this.privAudioFormat = format;
        let headerOffset = 0;
        if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
        if (this.privFd !== undefined) this.privWriteStream = $3803aab63fb0b430$var$fs.createWriteStream("", {
            fd: this.privFd,
            start: headerOffset,
            autoClose: false
        });
    }
    write(buffer) {
        $3afpL.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    }
    close() {
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", ()=>{
                if (this.privAudioFormat.hasHeader) {
                    this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten);
                    $3803aab63fb0b430$var$fs.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0);
                }
                $3803aab63fb0b430$var$fs.closeSync(this.privFd);
                this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    }
    id() {
        return this.privId;
    }
    constructor(filename){
        $3afpL.Contracts.throwIfNullOrUndefined($3803aab63fb0b430$var$fs.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $3803aab63fb0b430$var$fs.openSync(filename, "w");
    }
}
module.exports.AudioFileWriter = $3803aab63fb0b430$var$AudioFileWriter;

});

parcelRegister("lzD4B", function(module, exports) {

var $i9xOC = parcelRequire("i9xOC");
var $fb4b2cfb689786df$require$Buffer = $i9xOC.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamImpl = module.exports.PullAudioInputStream = module.exports.PushAudioInputStreamImpl = module.exports.PushAudioInputStream = module.exports.AudioInputStream = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $agQoA = parcelRequire("agQoA");

var $14iyq = parcelRequire("14iyq");

var $9Xjoq = parcelRequire("9Xjoq");
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */ class $fb4b2cfb689786df$var$AudioInputStream {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ static createPushStream(format) {
        return $fb4b2cfb689786df$var$PushAudioInputStream.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ static createPullStream(callback, format) {
        return $fb4b2cfb689786df$var$PullAudioInputStream.create(callback, format);
    // throw new Error("Oops");
    }
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
}
module.exports.AudioInputStream = $fb4b2cfb689786df$var$AudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PushAudioInputStream
 */ class $fb4b2cfb689786df$var$PushAudioInputStream extends $fb4b2cfb689786df$var$AudioInputStream {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ static create(format) {
        return new $fb4b2cfb689786df$var$PushAudioInputStreamImpl(format);
    }
}
module.exports.PushAudioInputStream = $fb4b2cfb689786df$var$PushAudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PushAudioInputStreamImpl
 */ class $fb4b2cfb689786df$var$PushAudioInputStreamImpl extends $fb4b2cfb689786df$var$PushAudioInputStream {
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $iLPPT.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $iLPPT.AudioSourceReadyEvent(this.privId));
        return;
    }
    async attach(audioNodeId) {
        this.onEvent(new $iLPPT.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        await this.turnOn();
        const stream = this.privStream;
        this.onEvent(new $iLPPT.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return {
            detach: async ()=>{
                this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                return this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>stream.read()
        };
    }
    detach(audioNodeId) {
        this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $h6sQE.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $h6sQE.type.Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    toBuffer(arrayBuffer) {
        const buf = $fb4b2cfb689786df$require$Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for(let i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    }
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ constructor(format){
        super();
        if (format === undefined) this.privFormat = $9Xjoq.AudioStreamFormatImpl.getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new $iLPPT.EventSource();
        this.privId = $agQoA.createNoDashGuid();
        this.privStream = new $iLPPT.ChunkedArrayBufferStream(this.privFormat.avgBytesPerSec / 10);
    }
}
module.exports.PushAudioInputStreamImpl = $fb4b2cfb689786df$var$PushAudioInputStreamImpl;
/*
 * Represents audio input stream used for custom audio input configurations.
 * @class PullAudioInputStream
 */ class $fb4b2cfb689786df$var$PullAudioInputStream extends $fb4b2cfb689786df$var$AudioInputStream {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ static create(callback, format) {
        return new $fb4b2cfb689786df$var$PullAudioInputStreamImpl(callback, format);
    }
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
}
module.exports.PullAudioInputStream = $fb4b2cfb689786df$var$PullAudioInputStream;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioInputStreamImpl
 */ class $fb4b2cfb689786df$var$PullAudioInputStreamImpl extends $fb4b2cfb689786df$var$PullAudioInputStream {
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privIsClosed = true;
        this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $iLPPT.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $iLPPT.AudioSourceReadyEvent(this.privId));
        return;
    }
    async attach(audioNodeId) {
        this.onEvent(new $iLPPT.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        await this.turnOn();
        this.onEvent(new $iLPPT.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return {
            detach: ()=>{
                this.privCallback.close();
                this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                return this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>{
                let totalBytes = 0;
                let transmitBuff;
                // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                while(totalBytes < this.privBufferSize){
                    // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                    // data back.
                    const readBuff = new ArrayBuffer(this.privBufferSize - totalBytes);
                    const pulledBytes = this.privCallback.read(readBuff);
                    // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                    // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                    // preferred size allocated.
                    if (undefined === transmitBuff) transmitBuff = readBuff;
                    else {
                        // Not the first bite at the apple, so fill the return buffer with the data we got back.
                        const intView = new Int8Array(transmitBuff);
                        intView.set(new Int8Array(readBuff), totalBytes);
                    }
                    // If there are no bytes to read, just break out and be done.
                    if (0 === pulledBytes) break;
                    totalBytes += pulledBytes;
                }
                return Promise.resolve({
                    buffer: transmitBuff.slice(0, totalBytes),
                    isEnd: this.privIsClosed || totalBytes === 0,
                    timeReceived: Date.now()
                });
            }
        };
    }
    detach(audioNodeId) {
        this.onEvent(new $iLPPT.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $h6sQE.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $h6sQE.type.Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ constructor(callback, format){
        super();
        if (undefined === format) this.privFormat = $14iyq.AudioStreamFormat.getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new $iLPPT.EventSource();
        this.privId = $agQoA.createNoDashGuid();
        this.privCallback = callback;
        this.privIsClosed = false;
        this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
}
module.exports.PullAudioInputStreamImpl = $fb4b2cfb689786df$var$PullAudioInputStreamImpl;

});

parcelRegister("lrnFA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamImpl = module.exports.PushAudioOutputStream = module.exports.PullAudioOutputStreamImpl = module.exports.PullAudioOutputStream = module.exports.AudioOutputStream = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $3R9Dx = parcelRequire("3R9Dx");
/**
 * Represents audio output stream used for custom audio output configurations.
 * @class AudioOutputStream
 */ class $f9be7aeb7db7403c$var$AudioOutputStream {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ static createPullStream() {
        return $f9be7aeb7db7403c$var$PullAudioOutputStream.create();
    }
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
}
module.exports.AudioOutputStream = $f9be7aeb7db7403c$var$AudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @class PullAudioOutputStream
 */ class $f9be7aeb7db7403c$var$PullAudioOutputStream extends $f9be7aeb7db7403c$var$AudioOutputStream {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ static create() {
        return new $f9be7aeb7db7403c$var$PullAudioOutputStreamImpl();
    }
}
module.exports.PullAudioOutputStream = $f9be7aeb7db7403c$var$PullAudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */ class $f9be7aeb7db7403c$var$PullAudioOutputStreamImpl extends $f9be7aeb7db7403c$var$PullAudioOutputStream {
    /**
     * Sets the format information to the stream. For internal use only.
     * @param {AudioStreamFormat} format - the format to be set.
     */ set format(format) {
        if (format === undefined || format === null) this.privFormat = $3R9Dx.AudioOutputFormatImpl.getDefaultOutputFormat();
        this.privFormat = format;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ id() {
        return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ async read(dataBuffer) {
        const intView = new Int8Array(dataBuffer);
        let totalBytes = 0;
        if (this.privLastChunkView !== undefined) {
            if (this.privLastChunkView.length > dataBuffer.byteLength) {
                intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                return Promise.resolve(dataBuffer.byteLength);
            }
            intView.set(this.privLastChunkView);
            totalBytes = this.privLastChunkView.length;
            this.privLastChunkView = undefined;
        }
        // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
        while(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded){
            const chunk = await this.privStream.read();
            if (chunk !== undefined && !chunk.isEnd) {
                let tmpBuffer;
                if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                    tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                    this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                } else tmpBuffer = chunk.buffer;
                intView.set(new Int8Array(tmpBuffer), totalBytes);
                totalBytes += tmpBuffer.byteLength;
            } else this.privStream.readEnded();
        }
        return totalBytes;
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        $3afpL.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ constructor(){
        super();
        this.privId = $iLPPT.createNoDashGuid();
        this.privStream = new $iLPPT.Stream();
    }
}
module.exports.PullAudioOutputStreamImpl = $f9be7aeb7db7403c$var$PullAudioOutputStreamImpl;
/*
 * Represents audio output stream used for custom audio output configurations.
 * @class PushAudioOutputStream
 */ class $f9be7aeb7db7403c$var$PushAudioOutputStream extends $f9be7aeb7db7403c$var$AudioOutputStream {
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ static create(callback) {
        return new $f9be7aeb7db7403c$var$PushAudioOutputStreamImpl(callback);
    }
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
}
module.exports.PushAudioOutputStream = $f9be7aeb7db7403c$var$PushAudioOutputStream;
/**
 * Represents audio output stream used for custom audio output configurations.
 * @private
 * @class PushAudioOutputStreamImpl
 */ class $f9be7aeb7db7403c$var$PushAudioOutputStreamImpl extends $f9be7aeb7db7403c$var$PushAudioOutputStream {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(format) {}
    write(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    }
    close() {
        if (!!this.privCallback.close) this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     */ constructor(callback){
        super();
        this.privId = $iLPPT.createNoDashGuid();
        this.privCallback = callback;
    }
}
module.exports.PushAudioOutputStreamImpl = $f9be7aeb7db7403c$var$PushAudioOutputStreamImpl;

});
parcelRegister("3R9Dx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputFormatImpl = void 0;

var $6SWBJ = parcelRequire("6SWBJ");

var $9Xjoq = parcelRequire("9Xjoq");
/**
 * @private
 * @class AudioOutputFormatImpl
 * Updated in version 1.17.0
 */ // eslint-disable-next-line max-classes-per-file
class $2cedcbfd5e64edf4$var$AudioOutputFormatImpl extends $9Xjoq.AudioStreamFormatImpl {
    static fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return $2cedcbfd5e64edf4$var$AudioOutputFormatImpl.getDefaultOutputFormat();
        return $2cedcbfd5e64edf4$var$AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString($2cedcbfd5e64edf4$var$AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
    static fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.WEBM_OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.WEBM_OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.WEBM_OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-mono-flac":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.FLAC, 1, 24000, 24000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-16bit-mono-flac":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.FLAC, 1, 48000, 30000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "raw-22050hz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-22050hz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, "raw-22050hz-16bit-mono-pcm", true);
            case "raw-44100hz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-44100hz-16bit-mono-pcm":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, "raw-44100hz-16bit-mono-pcm", true);
            case "amr-wb-16000h":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.AMR_WB, 1, 16000, 3052, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "g722-16khz-64kbps":
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.G722, 1, 16000, 8000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $2cedcbfd5e64edf4$var$AudioOutputFormatImpl($9Xjoq.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    }
    static getDefaultOutputFormat() {
        return $2cedcbfd5e64edf4$var$AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */ get header() {
        if (this.hasHeader) return this.privHeader;
        return undefined;
    }
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ updateHeader(audioLength) {
        if (this.priHasHeader) {
            const view = new DataView(this.privHeader);
            view.setUint32(4, audioLength + this.privHeader.byteLength - 8, true);
            view.setUint32(40, audioLength, true);
        }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
    /**
     * Adds audio header
     * @param audio the raw audio without header
     * @returns the audio with header if applicable
     */ addHeader(audio) {
        if (!this.hasHeader) return audio;
        this.updateHeader(audio.byteLength);
        const tmp = new Uint8Array(audio.byteLength + this.header.byteLength);
        tmp.set(new Uint8Array(this.header), 0);
        tmp.set(new Uint8Array(audio), this.header.byteLength);
        return tmp.buffer;
    }
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader){
        super(samplesPerSec, bitsPerSample, channels, formatTag);
        this.formatTag = formatTag;
        this.avgBytesPerSec = avgBytesPerSec;
        this.blockAlign = blockAlign;
        this.priAudioFormatString = audioFormatString;
        this.priRequestAudioFormatString = requestAudioFormatString;
        this.priHasHeader = hasHeader;
    }
}
module.exports.AudioOutputFormatImpl = $2cedcbfd5e64edf4$var$AudioOutputFormatImpl;
$2cedcbfd5e64edf4$var$AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString = {
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [$6SWBJ.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm",
    [$6SWBJ.SpeechSynthesisOutputFormat.AmrWb16000Hz]: "amr-wb-16000hz",
    [$6SWBJ.SpeechSynthesisOutputFormat.G72216Khz64Kbps]: "g722-16khz-64kbps"
};

});
parcelRegister("6SWBJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisOutputFormat = void 0;
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $50353f76ed9bb6bf$var$SpeechSynthesisOutputFormat;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
    /**
     * webm-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec in a webm container, with bitrate of 24kbps, optimized for IoT scenario.
     * Added in version 1.19.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16Bit24KbpsMonoOpus"] = 29] = "Webm24Khz16Bit24KbpsMonoOpus";
    /**
     * audio-16khz-16bit-32kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 32kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16Bit32KbpsMonoOpus"] = 30] = "Audio16Khz16Bit32KbpsMonoOpus";
    /**
     * audio-24khz-16bit-48kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 48kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit48KbpsMonoOpus"] = 31] = "Audio24Khz16Bit48KbpsMonoOpus";
    /**
     * audio-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 24kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit24KbpsMonoOpus"] = 32] = "Audio24Khz16Bit24KbpsMonoOpus";
    /**
     * raw-22050hz-16bit-mono-pcm
     * Raw PCM audio at 22050Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw22050Hz16BitMonoPcm"] = 33] = "Raw22050Hz16BitMonoPcm";
    /**
     * riff-22050hz-16bit-mono-pcm
     * PCM audio at 22050Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff22050Hz16BitMonoPcm"] = 34] = "Riff22050Hz16BitMonoPcm";
    /**
     * raw-44100hz-16bit-mono-pcm
     * Raw PCM audio at 44100Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw44100Hz16BitMonoPcm"] = 35] = "Raw44100Hz16BitMonoPcm";
    /**
     * riff-44100hz-16bit-mono-pcm
     * PCM audio at 44100Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff44100Hz16BitMonoPcm"] = 36] = "Riff44100Hz16BitMonoPcm";
    /**
     * amr-wb-16000hz
     * AMR-WB audio at 16kHz sampling rate.
     * Added in version 1.38.0
     * @member SpeechSynthesisOutputFormat.AmrWb16000Hz
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["AmrWb16000Hz"] = 37] = "AmrWb16000Hz";
    /**
     * g722-16khz-64kbps
     * G.722 audio at 16kHz sampling rate and 64kbps bitrate.
     * Added in version 1.38.0
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["G72216Khz64Kbps"] = 38] = "G72216Khz64Kbps";
})($50353f76ed9bb6bf$var$SpeechSynthesisOutputFormat = module.exports.SpeechSynthesisOutputFormat || (module.exports.SpeechSynthesisOutputFormat = {}));

});




parcelRegister("RTp4P", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationReason = void 0;
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $0a1fed536e4374e4$var$CancellationReason;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($0a1fed536e4374e4$var$CancellationReason = module.exports.CancellationReason || (module.exports.CancellationReason = {}));

});

parcelRegister("8fwXZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ class $60194be76342ba3b$var$PullAudioInputStreamCallback {
}
module.exports.PullAudioInputStreamCallback = $60194be76342ba3b$var$PullAudioInputStreamCallback;

});

parcelRegister("1SQq0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ class $15f37ed4039a0462$var$PushAudioOutputStreamCallback {
}
module.exports.PushAudioOutputStreamCallback = $15f37ed4039a0462$var$PushAudioOutputStreamCallback;

});

parcelRegister("iAVQB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeywordRecognitionModel = void 0;

var $3afpL = parcelRequire("3afpL");
/**
 * Represents a keyword recognition model for recognizing when
 * the user says a keyword to initiate further speech recognition.
 * @class KeywordRecognitionModel
 */ class $d8987616dac595c7$var$KeywordRecognitionModel {
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromFile
     * @function
     * @public
     * @param {string} fileName - A string that represents file name for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model
     * will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ static fromFile(fileName) {
        $3afpL.Contracts.throwIfFileDoesNotExist(fileName, "fileName");
        throw new Error("Not yet implemented.");
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromStream
     * @function
     * @public
     * @param {string} file - A File that represents file for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ static fromStream(file) {
        $3afpL.Contracts.throwIfNull(file, "file");
        throw new Error("Not yet implemented.");
    }
    /**
     * Dispose of associated resources.
     * @member KeywordRecognitionModel.prototype.close
     * @function
     * @public
     */ close() {
        if (this.privDisposed) return;
        this.privDisposed = true;
    }
    /**
     * Create and initializes a new instance.
     * @constructor
     */ constructor(){
        this.privDisposed = false;
        return;
    }
}
module.exports.KeywordRecognitionModel = $d8987616dac595c7$var$KeywordRecognitionModel;

});

parcelRegister("kxxLS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionEventArgs = void 0;
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ class $ef4115f8c21cd264$var$SessionEventArgs {
    /**
     * Represents the session identifier.
     * @member SessionEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} Represents the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ constructor(sessionId){
        this.privSessionId = sessionId;
    }
}
module.exports.SessionEventArgs = $ef4115f8c21cd264$var$SessionEventArgs;

});

parcelRegister("bdtsh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines payload for session events like Speech Start/End Detected
 * @class
 */ class $82a7c1c3ac090771$var$RecognitionEventArgs extends $14iyq.SessionEventArgs {
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(offset, sessionId){
        super(sessionId);
        this.privOffset = offset;
    }
}
module.exports.RecognitionEventArgs = $82a7c1c3ac090771$var$RecognitionEventArgs;

});

parcelRegister("iV64c", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OutputFormat = void 0;
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $dc62419c66d27a09$var$OutputFormat;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($dc62419c66d27a09$var$OutputFormat = module.exports.OutputFormat || (module.exports.OutputFormat = {}));

});

parcelRegister("e1EuW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Intent recognition result event arguments.
 * @class
 */ class $a36092c231a2d0e4$var$IntentRecognitionEventArgs extends $14iyq.RecognitionEventArgs {
    /**
     * Represents the intent recognition result.
     * @member IntentRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {IntentRecognitionResult} Represents the intent recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param result - The result of the intent recognition.
     * @param offset - The offset.
     * @param sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
}
module.exports.IntentRecognitionEventArgs = $a36092c231a2d0e4$var$IntentRecognitionEventArgs;

});

parcelRegister("4gtkb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionResult = void 0;
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ class $31af674c171e9a68$var$RecognitionResult {
    /**
     * Specifies the result identifier.
     * @member RecognitionResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member RecognitionResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Presents the recognized text in the result.
     * @member RecognitionResult.prototype.text
     * @function
     * @public
     * @returns {string} Presents the recognized text in the result.
     */ get text() {
        return this.privText;
    }
    /**
     * Duration of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.duration
     * @function
     * @public
     * @returns {number} Duration of recognized speech in 100 nano second increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Offset of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.offset
     * @function
     * @public
     * @returns {number} Offset of recognized speech in 100 nano second increments.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Primary Language detected.
     * @member RecognitionResult.prototype.language
     * @function
     * @public
     * @returns {string} language detected.
     */ get language() {
        return this.privLanguage;
    }
    /**
     * Primary Language detection confidence (Unknown, Low, Medium, High).
     * @member RecognitionResult.prototype.languageDetectionConfidence
     * @function
     * @public
     * @returns {string} detection confidence strength.
     */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member RecognitionResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * A string containing Json serialized recognition result as it was received from the service.
     * @member RecognitionResult.prototype.json
     * @function
     * @private
     * @returns {string} Json serialized representation of the result.
     */ get json() {
        return this.privJson;
    }
    /**
     * The set of properties exposed in the result.
     * @member RecognitionResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
}
module.exports.RecognitionResult = $31af674c171e9a68$var$RecognitionResult;

});

parcelRegister("dPRUc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines result of speech recognition.
 * @class SpeechRecognitionResult
 */ class $a129da43c25004bd$var$SpeechRecognitionResult extends $14iyq.RecognitionResult {
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
}
module.exports.SpeechRecognitionResult = $a129da43c25004bd$var$SpeechRecognitionResult;

});

parcelRegister("jebMk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Intent recognition result.
 * @class
 */ class $dff8761a82c5af75$var$IntentRecognitionResult extends $14iyq.SpeechRecognitionResult {
    /**
     * A String that represents the intent identifier being recognized.
     * @member IntentRecognitionResult.prototype.intentId
     * @function
     * @public
     * @returns {string} A String that represents the intent identifier being recognized.
     */ get intentId() {
        return this.privIntentId;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param intentId - The intent id.
     * @param resultId - The result id.
     * @param reason - The reason.
     * @param text - The recognized text.
     * @param duration - The duration.
     * @param offset - The offset into the stream.
     * @param language - Primary Language detected, if provided.
     * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param errorDetails - Error details, if provided.
     * @param json - Additional Json, if provided.
     * @param properties - Additional properties, if provided.
     */ constructor(intentId, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privIntentId = intentId;
    }
}
module.exports.IntentRecognitionResult = $dff8761a82c5af75$var$IntentRecognitionResult;

});

parcelRegister("6XDXp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageUnderstandingModelImpl = module.exports.LanguageUnderstandingModel = void 0;

var $3afpL = parcelRequire("3afpL");
/**
 * Language understanding model
 * @class LanguageUnderstandingModel
 */ class $51173f6a3b207ade$var$LanguageUnderstandingModel {
    /**
     * Creates an language understanding model using the specified endpoint.
     * @member LanguageUnderstandingModel.fromEndpoint
     * @function
     * @public
     * @param {URL} uri - A String that represents the endpoint of the language understanding model.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ static fromEndpoint(uri) {
        $3afpL.Contracts.throwIfNull(uri, "uri");
        $3afpL.Contracts.throwIfNullOrWhitespace(uri.hostname, "uri");
        const langModelImp = new $51173f6a3b207ade$var$LanguageUnderstandingModelImpl();
        // Need to extract the app ID from the URL.
        // URL is in the format: https://<region>.api.cognitive.microsoft.com/luis/v2.0/apps/<Guid>?subscription-key=<key>&timezoneOffset=-360
        // Start tearing the string apart.
        // region can be extracted from the host name.
        const firstDot = uri.host.indexOf(".");
        if (-1 === firstDot) throw new Error("Could not determine region from endpoint");
        langModelImp.region = uri.host.substr(0, firstDot);
        // Now the app ID.
        const lastSegment = uri.pathname.lastIndexOf("/") + 1;
        if (-1 === lastSegment) throw new Error("Could not determine appId from endpoint");
        langModelImp.appId = uri.pathname.substr(lastSegment);
        // And finally the key.
        langModelImp.subscriptionKey = uri.searchParams.get("subscription-key");
        if (undefined === langModelImp.subscriptionKey) throw new Error("Could not determine subscription key from endpoint");
        return langModelImp;
    }
    /**
     * Creates an language understanding model using the application id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromAppId
     * @function
     * @public
     * @param {string} appId - A String that represents the application id of Language Understanding service.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ static fromAppId(appId) {
        $3afpL.Contracts.throwIfNullOrWhitespace(appId, "appId");
        const langModelImp = new $51173f6a3b207ade$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        return langModelImp;
    }
    /**
     * Creates a language understanding model using hostname, subscription key and application
     * id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - A String that represents the subscription key of
     * Language Understanding service.
     * @param {string} appId - A String that represents the application id of Language
     * Understanding service.
     * @param {LanguageUnderstandingModel} region - A String that represents the region
     * of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ static fromSubscription(subscriptionKey, appId, region) {
        $3afpL.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $3afpL.Contracts.throwIfNullOrWhitespace(appId, "appId");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const langModelImp = new $51173f6a3b207ade$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        langModelImp.region = region;
        langModelImp.subscriptionKey = subscriptionKey;
        return langModelImp;
    }
    /**
     * Creates and initializes a new instance
     * @constructor
     */ constructor(){
        return;
    }
}
module.exports.LanguageUnderstandingModel = $51173f6a3b207ade$var$LanguageUnderstandingModel;
/**
 * @private
 * @class LanguageUnderstandingModelImpl
 */ class $51173f6a3b207ade$var$LanguageUnderstandingModelImpl extends $51173f6a3b207ade$var$LanguageUnderstandingModel {
}
module.exports.LanguageUnderstandingModelImpl = $51173f6a3b207ade$var$LanguageUnderstandingModelImpl;

});

parcelRegister("di7k4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionEventArgs = module.exports.ConversationTranscriptionEventArgs = module.exports.SpeechRecognitionEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines contents of speech recognizing/recognized event.
 * @class SpeechRecognitionEventArgs
 */ class $9ad2a2eb20fde527$var$SpeechRecognitionEventArgs extends $14iyq.RecognitionEventArgs {
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
}
module.exports.SpeechRecognitionEventArgs = $9ad2a2eb20fde527$var$SpeechRecognitionEventArgs;
/**
 * Defines contents of conversation transcribed/transcribing event.
 * @class ConversationTranscriptionEventArgs
 */ class $9ad2a2eb20fde527$var$ConversationTranscriptionEventArgs extends $14iyq.RecognitionEventArgs {
    /**
     * Specifies the transcription result.
     * @member ConversationTranscription1EventArgs.prototype.result
     * @function
     * @public
     * @returns {ConversationTranscriptionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranscriptionResult} result - The conversation transcription result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
}
module.exports.ConversationTranscriptionEventArgs = $9ad2a2eb20fde527$var$ConversationTranscriptionEventArgs;
/**
 * Defines contents of meeting transcribed/transcribing event.
 * @class MeetingTranscriptionEventArgs
 */ class $9ad2a2eb20fde527$var$MeetingTranscriptionEventArgs extends $9ad2a2eb20fde527$var$SpeechRecognitionEventArgs {
}
module.exports.MeetingTranscriptionEventArgs = $9ad2a2eb20fde527$var$MeetingTranscriptionEventArgs;

});

parcelRegister("k8nTT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionCanceledEventArgs = void 0;

var $kl0Sn = parcelRequire("kl0Sn");
class $ea871820fdddac67$var$SpeechRecognitionCanceledEventArgs extends $kl0Sn.CancellationEventArgsBase {
}
module.exports.SpeechRecognitionCanceledEventArgs = $ea871820fdddac67$var$SpeechRecognitionCanceledEventArgs;

});
parcelRegister("kl0Sn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationEventArgsBase = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines content of a CancellationEvent.
 * @class CancellationEventArgsBase
 */ class $ece672c3e6f823e3$var$CancellationEventArgsBase extends $14iyq.RecognitionEventArgs {
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, offset, sessionId){
        super(offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
}
module.exports.CancellationEventArgsBase = $ece672c3e6f823e3$var$CancellationEventArgsBase;

});


parcelRegister("lGm0I", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Translation text result event arguments.
 * @class TranslationRecognitionEventArgs
 */ class $fc8e980fdfabcdd6$var$TranslationRecognitionEventArgs extends $14iyq.RecognitionEventArgs {
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
}
module.exports.TranslationRecognitionEventArgs = $fc8e980fdfabcdd6$var$TranslationRecognitionEventArgs;

});

parcelRegister("lmVuc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Translation Synthesis event arguments
 * @class TranslationSynthesisEventArgs
 */ class $f8e83e9c219117d5$var$TranslationSynthesisEventArgs extends $14iyq.SessionEventArgs {
    /**
     * Specifies the translation synthesis result.
     * @member TranslationSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ constructor(result, sessionId){
        super(sessionId);
        this.privResult = result;
    }
}
module.exports.TranslationSynthesisEventArgs = $f8e83e9c219117d5$var$TranslationSynthesisEventArgs;

});

parcelRegister("6KTc5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Translation text result.
 * @class TranslationRecognitionResult
 */ class $4eb1da58094ee881$var$TranslationRecognitionResult extends $14iyq.SpeechRecognitionResult {
    static fromSpeechRecognitionResult(result) {
        return new $4eb1da58094ee881$var$TranslationRecognitionResult(undefined, result.resultId, result.reason, result.text, result.duration, result.offset, result.language, result.languageDetectionConfidence, result.errorDetails, result.json, result.properties);
    }
    /**
     * Presents the translation results. Each item in the dictionary represents
     * a translation result in one of target languages, where the key is the name
     * of the target language, in BCP-47 format, and the value is the translation
     * text in the specified language.
     * @member TranslationRecognitionResult.prototype.translations
     * @function
     * @public
     * @returns {Translations} the current translation map that holds all translations requested.
     */ get translations() {
        return this.privTranslations;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(translations, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privTranslations = translations;
    }
}
module.exports.TranslationRecognitionResult = $4eb1da58094ee881$var$TranslationRecognitionResult;

});

parcelRegister("aTjcU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisResult = void 0;
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ class $7eddf093b416f591$var$TranslationSynthesisResult {
    /**
     * Translated text in the target language.
     * @member TranslationSynthesisResult.prototype.audio
     * @function
     * @public
     * @returns {ArrayBuffer} Translated audio in the target language.
     */ get audio() {
        return this.privAudio;
    }
    /**
     * The synthesis status.
     * @member TranslationSynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} The synthesis status.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ constructor(reason, audio){
        this.privReason = reason;
        this.privAudio = audio;
    }
}
module.exports.TranslationSynthesisResult = $7eddf093b416f591$var$TranslationSynthesisResult;

});

parcelRegister("hQ5KG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResultReason = void 0;
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $cfcbc13997eb30ff$var$ResultReason;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
    /**
     * Indicates synthesis voices list has been successfully retrieved.
     * @member ResultReason.VoicesListRetrieved
     */ ResultReason[ResultReason["VoicesListRetrieved"] = 18] = "VoicesListRetrieved";
    /**
     * Indicates the transcription result contains hypothesis text and its translation(s) for
     * other participants in the conversation.
     * @member ResultReason.TranslatingParticipantSpeech
     */ ResultReason[ResultReason["TranslatingParticipantSpeech"] = 19] = "TranslatingParticipantSpeech";
    /**
     * Indicates the transcription result contains final text and corresponding translation(s)
     * for other participants in the conversation. Speech Recognition and Translation are now
     * complete for this phrase.
     * @member ResultReason.TranslatedParticipantSpeech
     */ ResultReason[ResultReason["TranslatedParticipantSpeech"] = 20] = "TranslatedParticipantSpeech";
    /**
     * <summary>
     * Indicates the transcription result contains the instant message and corresponding
     * translation(s).
     * @member ResultReason.TranslatedInstantMessage
     */ ResultReason[ResultReason["TranslatedInstantMessage"] = 21] = "TranslatedInstantMessage";
    /**
     * Indicates the transcription result contains the instant message for other participants
     * in the conversation and corresponding translation(s).
     * @member ResultReason.TranslatedParticipantInstantMessage
     */ ResultReason[ResultReason["TranslatedParticipantInstantMessage"] = 22] = "TranslatedParticipantInstantMessage";
})($cfcbc13997eb30ff$var$ResultReason = module.exports.ResultReason || (module.exports.ResultReason = {}));

});

parcelRegister("4GxG1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConfigImpl = module.exports.SpeechConfig = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Speech configuration.
 * @class SpeechConfig
 */ class $3695353191fa5dc8$var$SpeechConfig {
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ static fromSubscription(subscriptionKey, region) {
        $3afpL.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $3695353191fa5dc8$var$SpeechConfigImpl();
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     * and the effective language is "de-DE". Only the parameters that are not specified in the
     * endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $3afpL.Contracts.throwIfNull(endpoint, "endpoint");
        const speechImpl = new $3695353191fa5dc8$var$SpeechConfigImpl();
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        $3afpL.Contracts.throwIfNull(hostName, "hostName");
        const speechImpl = new $3695353191fa5dc8$var$SpeechConfigImpl();
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromAuthorizationToken(authorizationToken, region) {
        $3afpL.Contracts.throwIfNull(authorizationToken, "authorizationToken");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $3695353191fa5dc8$var$SpeechConfigImpl();
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
}
module.exports.SpeechConfig = $3695353191fa5dc8$var$SpeechConfig;
/**
 * @public
 * @class SpeechConfigImpl
 */ class $3695353191fa5dc8$var$SpeechConfigImpl extends $3695353191fa5dc8$var$SpeechConfig {
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(value) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(value) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, value);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(value) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, value);
    }
    get outputFormat() {
        return $14iyq.OutputFormat[this.privProperties.getProperty($h6sQE.OutputFormatPropertyName, undefined)];
    }
    set outputFormat(value) {
        this.privProperties.setProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[value]);
    }
    get endpointId() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId);
    }
    set endpointId(value) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, value);
    }
    setProperty(name, value) {
        $3afpL.Contracts.throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    }
    getProperty(name, def) {
        return this.privProperties.getProperty(name, def);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty($h6sQE.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($h6sQE.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceResponse_ProfanityOption, $14iyq.ProfanityOption[profanity]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty($h6sQE.ForceDictationPropertyName, "true");
    }
    clone() {
        const ret = new $3695353191fa5dc8$var$SpeechConfigImpl();
        ret.privProperties = this.privProperties.clone();
        return ret;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        return $14iyq.SpeechSynthesisOutputFormat[this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_SynthOutputFormat, $14iyq.SpeechSynthesisOutputFormat[format]);
    }
    constructor(){
        super();
        this.privProperties = new $14iyq.PropertyCollection();
        this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        this.outputFormat = $14iyq.OutputFormat.Simple;
    }
}
module.exports.SpeechConfigImpl = $3695353191fa5dc8$var$SpeechConfigImpl;

});

parcelRegister("dXGsU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechTranslationConfigImpl = module.exports.SpeechTranslationConfig = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Speech translation configuration.
 * @class SpeechTranslationConfig
 */ class $a2a1b9c1713e0287$var$SpeechTranslationConfig extends $14iyq.SpeechConfig {
    /**
     * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
     * @member SpeechTranslationConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ static fromSubscription(subscriptionKey, region) {
        $3afpL.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const ret = new $a2a1b9c1713e0287$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        ret.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by setting the property authorizationToken with a new
     * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
     * will encounter errors during recognition.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply
     * to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechTranslationConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ static fromAuthorizationToken(authorizationToken, region) {
        $3afpL.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const ret = new $a2a1b9c1713e0287$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        ret.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        $3afpL.Contracts.throwIfNull(hostName, "hostName");
        const speechImpl = new $a2a1b9c1713e0287$var$SpeechTranslationConfigImpl();
        speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech translation config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or paramters.
     * Note: The query properties specified in the endpoint URL are not changed, even if they are
     * set by any other APIs. For example, if language is defined in the uri as query parameter
     * "language=de-DE", and also set by the speechRecognitionLanguage property, the language
     * setting in uri takes precedence, and the effective language is "de-DE".
     * Only the properties that are not specified in the endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechTranslationConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key.
     * @returns {SpeechTranslationConfig} A speech config instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $3afpL.Contracts.throwIfNull(endpoint, "endpoint");
        $3afpL.Contracts.throwIfNull(subscriptionKey, "subscriptionKey");
        const ret = new $a2a1b9c1713e0287$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        ret.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return ret;
    }
    /**
     * Creates an instance of recognizer config.
     */ constructor(){
        super();
    }
}
module.exports.SpeechTranslationConfig = $a2a1b9c1713e0287$var$SpeechTranslationConfig;
/**
 * @private
 * @class SpeechTranslationConfigImpl
 */ class $a2a1b9c1713e0287$var$SpeechTranslationConfigImpl extends $a2a1b9c1713e0287$var$SpeechTranslationConfig {
    /**
     * Gets/Sets the authorization token.
     * If this is set, subscription key is ignored.
     * User needs to make sure the provided authorization token is valid and not expired.
     * @member SpeechTranslationConfigImpl.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - The authorization token.
     */ set authorizationToken(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * Sets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The authorization token.
     */ set speechRecognitionLanguage(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, value);
    }
    /**
     * Gets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @return {string} The speechRecognitionLanguage.
     */ get speechRecognitionLanguage() {
        return this.privSpeechProperties.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
     * @function
     * @public
     */ get subscriptionKey() {
        return this.privSpeechProperties.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_Key]);
    }
    /**
     * Gets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */ get outputFormat() {
        // eslint-disable-next-line
        return $14iyq.OutputFormat[this.privSpeechProperties.getProperty($h6sQE.OutputFormatPropertyName, undefined)];
    }
    /**
     * Gets/Sets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */ set outputFormat(value) {
        this.privSpeechProperties.setProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[value]);
    }
    /**
     * Gets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */ get endpointId() {
        return this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId);
    }
    /**
     * Gets/Sets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */ set endpointId(value) {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, value);
    }
    /**
     * Add a (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ addTargetLanguage(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "value");
        const languages = this.targetLanguages;
        if (!languages.includes(value)) {
            languages.push(value);
            this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
        }
    }
    /**
     * Gets the (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.targetLanguages
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ get targetLanguages() {
        if (this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) return this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
        else return [];
    }
    /**
     * Gets the voice name.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     */ get voiceName() {
        return this.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_TranslationVoice]);
    }
    /**
     * Gets/Sets the voice of the translated language, enable voice synthesis output.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     * @param {string} value - The name of the voice.
     */ set voiceName(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationVoice, value);
    }
    /**
     * Provides the region.
     * @member SpeechTranslationConfigImpl.prototype.region
     * @function
     * @public
     * @returns {string} The region.
     */ get region() {
        return this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    /**
     * Gets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} def - The default value of the property in case it is not set.
     * @returns {string} The value of the property.
     */ getProperty(name, def) {
        return this.privSpeechProperties.getProperty(name, def);
    }
    /**
     * Gets/Sets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {string | PropertyId} name - The name of the property to set.
     * @param {string} value - The value of the property.
     */ setProperty(name, value) {
        this.privSpeechProperties.setProperty(name, value);
    }
    /**
     * Provides access to custom properties.
     * @member SpeechTranslationConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechProperties;
    }
    /**
     * Dispose of associated resources.
     * @member SpeechTranslationConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privSpeechProperties.getProperty($h6sQE.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privSpeechProperties.setProperty($h6sQE.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceResponse_ProfanityOption, $14iyq.ProfanityOption[profanity]);
    }
    enableAudioLogging() {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privSpeechProperties.setProperty($h6sQE.ForceDictationPropertyName, "true");
    }
    get speechSynthesisLanguage() {
        return this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        // eslint-disable-next-line
        return $14iyq.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privSpeechProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_SynthOutputFormat, $14iyq.SpeechSynthesisOutputFormat[format]);
    }
    constructor(){
        super();
        this.privSpeechProperties = new $14iyq.PropertyCollection();
        this.outputFormat = $14iyq.OutputFormat.Simple;
    }
}
module.exports.SpeechTranslationConfigImpl = $a2a1b9c1713e0287$var$SpeechTranslationConfigImpl;

});

parcelRegister("joXzx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyCollection = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Represents collection of properties and their values.
 * @class PropertyCollection
 */ class $e1fe77fef536c559$var$PropertyCollection {
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */ getProperty(key, def) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $14iyq.PropertyId[key];
        for(let n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        if (def === undefined) return undefined;
        return String(def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ setProperty(key, value) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $14iyq.PropertyId[key];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ clone() {
        const clonedMap = new $e1fe77fef536c559$var$PropertyCollection();
        for(let n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */ mergeTo(destinationCollection) {
        this.privKeys.forEach((key)=>{
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                const value = this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    }
    /**
     * Get the keys in Property Collection.
     * @member PropertyCollection.prototype.keys
     * @function
     * @public
     * @returns {string []} Keys in the collection.
     */ get keys() {
        return this.privKeys;
    }
    constructor(){
        this.privKeys = [];
        this.privValues = [];
    }
}
module.exports.PropertyCollection = $e1fe77fef536c559$var$PropertyCollection;

});

parcelRegister("1jqKG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyId = void 0;
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $0f4c512cddf76a0f$var$PropertyId;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to
     * specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A duration of detected silence, measured in milliseconds, after which speech-to-text will determine a spoken
     * phrase has ended and generate a final Recognized result. Configuring this timeout may be helpful in situations
     * where spoken input is significantly faster or slower than usual and default segmentation behavior consistently
     * yields results that are too long or too short. Segmentation timeout values that are inappropriately high or low
     * can negatively affect speech-to-text accuracy; this property should be carefully configured and the resulting
     * behavior should be thoroughly validated as intended.
     *
     * For more information about timeout configuration that includes discussion of default behaviors, please visit
     * https://aka.ms/csspeech/timeouts.
     *
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["Speech_SegmentationSilenceTimeoutMs"] = 32] = "Speech_SegmentationSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Audio and content logs are stored either in Microsoft-owned storage, or in your own storage account linked
     * to your Cognitive Services subscription (Bring Your Own Storage (BYOS) enabled Speech resource).
     * The logs will be removed after 30 days.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 33] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The speech service connection language identifier mode.
     * Can be "AtStart" (the default), or "Continuous". See Language
     * Identification document https://aka.ms/speech/lid?pivots=programming-language-javascript
     * for more details.
     * Added in 1.25.0
     **/ PropertyId[PropertyId["SpeechServiceConnection_LanguageIdMode"] = 34] = "SpeechServiceConnection_LanguageIdMode";
    /**
     * A string value representing the desired endpoint version to target for Speech Recognition.
     * Added in version 1.21.0
     */ PropertyId[PropertyId["SpeechServiceConnection_RecognitionEndpointVersion"] = 35] = "SpeechServiceConnection_RecognitionEndpointVersion";
    /**
    /**
     * A string value the current speaker recognition scenario/mode (TextIndependentIdentification, etc.).
     * Added in version 1.23.0
     */ PropertyId[PropertyId["SpeechServiceConnection_SpeakerIdMode"] = 36] = "SpeechServiceConnection_SpeakerIdMode";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 37] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 38] = "SpeechServiceResponse_PostProcessingOption";
    /**
     * A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 40] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 41] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * A boolean value specifying whether to request WordBoundary events.
     * @member PropertyId.SpeechServiceResponse_RequestWordBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordBoundary"] = 43] = "SpeechServiceResponse_RequestWordBoundary";
    /**
     * A boolean value specifying whether to request punctuation boundary in WordBoundary Events. Default is true.
     * @member PropertyId.SpeechServiceResponse_RequestPunctuationBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestPunctuationBoundary"] = 44] = "SpeechServiceResponse_RequestPunctuationBoundary";
    /**
     * A boolean value specifying whether to request sentence boundary in WordBoundary Events. Default is false.
     * @member PropertyId.SpeechServiceResponse_RequestSentenceBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestSentenceBoundary"] = 45] = "SpeechServiceResponse_RequestSentenceBoundary";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 46] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 47] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 48] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 49] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 50] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 51] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 52] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 53] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 54] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 55] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 56] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 57] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 58] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 59] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 60] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 61] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 62] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 63] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 64] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 65] = "PronunciationAssessment_Params";
    /**
     * Version of Speaker Recognition API to use.
     * Added in version 1.18.0
     */ PropertyId[PropertyId["SpeakerRecognition_Api_Version"] = 66] = "SpeakerRecognition_Api_Version";
    /**
     * Specifies whether to allow load of data URL for web worker
     * Allowed values are "off" and "on". Default is "on".
     * Added in version 1.32.0
     */ PropertyId[PropertyId["WebWorkerLoadType"] = 67] = "WebWorkerLoadType";
    /**
     * Talking avatar service WebRTC session description protocol.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.33.0
     */ PropertyId[PropertyId["TalkingAvatarService_WebRTC_SDP"] = 68] = "TalkingAvatarService_WebRTC_SDP";
})($0f4c512cddf76a0f$var$PropertyId = module.exports.PropertyId || (module.exports.PropertyId = {}));

});

parcelRegister("ibcPP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Defines the base class Recognizer which mainly contains common event handlers.
 * @class Recognizer
 */ class $d3c335d246d9bb74$var$Recognizer {
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposed);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privReco;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ async dispose(disposing) {
        if (this.privDisposed) return;
        this.privDisposed = true;
        if (disposing) {
            if (this.privReco) {
                await this.privReco.audioSource.turnOff();
                await this.privReco.dispose();
            }
        }
    }
    /**
     * This method returns the current state of the telemetry setting.
     * @member Recognizer.prototype.telemetryEnabled
     * @function
     * @public
     * @returns true if the telemetry is enabled, false otherwise.
     */ static get telemetryEnabled() {
        return $h6sQE.ServiceRecognizerBase.telemetryDataEnabled;
    }
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ static enableTelemetry(enabled) {
        $h6sQE.ServiceRecognizerBase.telemetryDataEnabled = enabled;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const recognizerConfig = this.createRecognizerConfig(new $h6sQE.SpeechServiceConfig(new $h6sQE.Context(new $h6sQE.OS(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer($d3c335d246d9bb74$var$Recognizer.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    }
    async recognizeOnceAsyncImpl(recognitionMode) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposed);
        const ret = new $iLPPT.Deferred();
        await this.implRecognizerStop();
        await this.privReco.recognize(recognitionMode, ret.resolve, ret.reject);
        const result = await ret.promise;
        await this.implRecognizerStop();
        return result;
    }
    async startContinuousRecognitionAsyncImpl(recognitionMode) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposed);
        await this.implRecognizerStop();
        await this.privReco.recognize(recognitionMode, undefined, undefined);
    }
    async stopContinuousRecognitionAsyncImpl() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposed);
        await this.implRecognizerStop();
    }
    async implRecognizerStop() {
        if (this.privReco) await this.privReco.stopRecognizing();
        return;
    }
    static getAuthFromProperties(properties) {
        const subscriptionKey = properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new $h6sQE.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $h6sQE.CognitiveTokenAuthentication(()=>{
            const authorizationToken = properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        return authentication;
    }
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     * @param {PropertyCollection} properties - A set of properties to set on the recognizer
     * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
     */ constructor(audioConfig, properties, connectionFactory){
        this.audioConfig = audioConfig !== undefined ? audioConfig : $14iyq.AudioConfig.fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.implCommonRecognizerSetup();
    }
}
module.exports.Recognizer = $d3c335d246d9bb74$var$Recognizer;

});

parcelRegister("aeqYX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Performs speech recognition from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class SpeechRecognizer
 */ class $7730244e9c8e8b7b$var$SpeechRecognizer extends $14iyq.Recognizer {
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $7730244e9c8e8b7b$var$SpeechRecognizer(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for speech recognition.
     * @member SpeechRecognizer.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of recognition.
     * @member SpeechRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of recognition.
     * @member SpeechRecognizer.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of recognition.
     */ get outputFormat() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) === $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) return $14iyq.OutputFormat.Simple;
        else return $14iyq.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this SpeechRecognizer.
     * @member SpeechRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition
     * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($h6sQE.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($h6sQE.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     * specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startKeywordRecognitionAsync(model, cb, err) {
        $3afpL.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopKeywordRecognitionAsync(cb) {
        if (!!cb) cb();
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $h6sQE.SpeechServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $3afpL.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage), $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new $h6sQE.SpeechConnectionFactory());
        this.privDisposedRecognizer = false;
    }
}
module.exports.SpeechRecognizer = $7730244e9c8e8b7b$var$SpeechRecognizer;

});

parcelRegister("fKjP1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Intent recognizer.
 * @class
 */ class $b76a871c6b412901$var$IntentRecognizer extends $14iyq.Recognizer {
    /**
     * Gets the spoken language of recognition.
     * @member IntentRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} the spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member IntentRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
     * @member IntentRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */ set authorizationToken(value) {
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * The collection of properties and their values defined for this IntentRecognizer.
     * @member IntentRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their
     * values defined for this IntentRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts intent recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text and intent as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition like command or query.
     * For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member IntentRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            const context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            const intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $iLPPT.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($h6sQE.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            const context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            const intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $iLPPT.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($h6sQE.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous intent recognition.
     * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startKeywordRecognitionAsync(model, cb, err) {
        $3afpL.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopKeywordRecognitionAsync(cb, err) {
        if (!!cb) try {
            cb();
        } catch (e) {
            if (!!err) err(e);
        }
    }
    /**
     * Adds a phrase that should be recognized as intent.
     * @member IntentRecognizer.prototype.addIntent
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
     * @param {string} phrase - A String that specifies the phrase representing the intent.
     */ addIntent(simplePhrase, intentId) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $3afpL.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $3afpL.Contracts.throwIfNullOrWhitespace(simplePhrase, "simplePhrase");
        this.privAddedIntents.push([
            intentId,
            simplePhrase
        ]);
    }
    /**
     * Adds an intent from Language Understanding service for recognition.
     * @member IntentRecognizer.prototype.addIntentWithLanguageModel
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent
     * to be recognized. Ignored if intentName is empty.
     * @param {string} model - The intent model from Language Understanding service.
     * @param {string} intentName - The intent name defined in the intent model. If it
     * is empty, all intent names defined in the model will be added.
     */ addIntentWithLanguageModel(intentId, model, intentName) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $3afpL.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $3afpL.Contracts.throwIfNull(model, "model");
        const modelImpl = model;
        $3afpL.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privAddedLmIntents[intentId] = new $h6sQE.AddedLmIntent(modelImpl, intentName);
    }
    /**
     * @summary Adds all intents from the specified Language Understanding Model.
     * @member IntentRecognizer.prototype.addAllIntents
     * @function
     * @public
     * @function
     * @public
     * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
     * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
     */ addAllIntents(model, intentId) {
        $3afpL.Contracts.throwIfNull(model, "model");
        const modelImpl = model;
        $3afpL.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privUmbrellaIntent = new $h6sQE.AddedLmIntent(modelImpl, intentId);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member IntentRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioImpl = audioConfig;
        return new $h6sQE.IntentServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    }
    async dispose(disposing) {
        if (this.privDisposedIntentRecognizer) return;
        if (disposing) {
            this.privDisposedIntentRecognizer = true;
            await super.dispose(disposing);
        }
    }
    buildSpeechContext() {
        let appId;
        let region;
        let subscriptionKey;
        const refGrammers = [];
        if (undefined !== this.privUmbrellaIntent) {
            appId = this.privUmbrellaIntent.modelImpl.appId;
            region = this.privUmbrellaIntent.modelImpl.region;
            subscriptionKey = this.privUmbrellaIntent.modelImpl.subscriptionKey;
        }
        // Build the reference grammer array.
        for (const intentId of Object.keys(this.privAddedLmIntents)){
            const addedLmIntent = this.privAddedLmIntents[intentId];
            // validate all the same model, region, and key...
            if (appId === undefined) appId = addedLmIntent.modelImpl.appId;
            else {
                if (appId !== addedLmIntent.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
            }
            if (region === undefined) region = addedLmIntent.modelImpl.region;
            else {
                if (region !== addedLmIntent.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
            }
            if (subscriptionKey === undefined) subscriptionKey = addedLmIntent.modelImpl.subscriptionKey;
            else {
                if (subscriptionKey !== addedLmIntent.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
            }
            const grammer = "luis/" + appId + "-PRODUCTION#" + intentId;
            refGrammers.push(grammer);
        }
        return {
            Intent: {
                id: appId,
                key: subscriptionKey === undefined ? this.privProperties.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_Key]) : subscriptionKey,
                provider: "LUIS"
            },
            ReferenceGrammars: undefined === this.privUmbrellaIntent ? refGrammers : [
                "luis/" + appId + "-PRODUCTION"
            ]
        };
    }
    /**
     * Initializes an instance of the IntentRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        const configImpl = speechConfig;
        $3afpL.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, new $h6sQE.IntentConnectionFactory());
        this.privAddedIntents = [];
        this.privAddedLmIntents = {};
        this.privDisposedIntentRecognizer = false;
        this.privProperties = configImpl.properties;
        $3afpL.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage), $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
}
module.exports.IntentRecognizer = $b76a871c6b412901$var$IntentRecognizer;

});

parcelRegister("8LNu6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileType = void 0;
/**
 * Output format
 * @class VoiceProfileType
 */ var $66291918e86c8b26$var$VoiceProfileType;
(function(VoiceProfileType) {
    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */ VoiceProfileType[VoiceProfileType["TextIndependentIdentification"] = 0] = "TextIndependentIdentification";
    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */ VoiceProfileType[VoiceProfileType["TextDependentVerification"] = 1] = "TextDependentVerification";
    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */ VoiceProfileType[VoiceProfileType["TextIndependentVerification"] = 2] = "TextIndependentVerification";
})($66291918e86c8b26$var$VoiceProfileType = module.exports.VoiceProfileType || (module.exports.VoiceProfileType = {}));

});

parcelRegister("38ihW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $lOcWU = parcelRequire("lOcWU");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Translation recognizer
 * @class TranslationRecognizer
 */ class $24804e2008a48ef6$var$TranslationRecognizer extends $14iyq.Recognizer {
    /**
     * TranslationRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechTranslationConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechTranslationConfigImpl = speechTranslationConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechTranslationConfigImpl.properties);
        return new $24804e2008a48ef6$var$TranslationRecognizer(speechTranslationConfig, audioConfig);
    }
    /**
     * Gets the language name that was set when the recognizer was created.
     * @member TranslationRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} Gets the language name that was set when the recognizer was created.
     */ get speechRecognitionLanguage() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets target languages for translation that were set when the recognizer was created.
     * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
     * @member TranslationRecognizer.prototype.targetLanguages
     * @function
     * @public
     * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
     */ get targetLanguages() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    /**
     * Gets the name of output voice.
     * @member TranslationRecognizer.prototype.voiceName
     * @function
     * @public
     * @returns {string} the name of output voice.
     */ get voiceName() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
    }
    /**
     * The collection of properties and their values defined for this TranslationRecognizer.
     * @member TranslationRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */ set authorizationToken(value) {
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * Starts recognition and translation, and stops after the first utterance is recognized.
     * The task returns the translation text as result.
     * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
     * for single shot recognition like command or query. For long-running recognition,
     * use startContinuousRecognitionAsync() instead.
     * @member TranslationRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the translation has completed.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $iLPPT.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($h6sQE.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive translation results.
     * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($h6sQE.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous recognition and translation.
     * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * dynamically remove a language from list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.removeTargetLanguage
     * @function
     * @param lang - language to be removed
     * @public
     */ removeTargetLanguage(lang) {
        $3afpL.Contracts.throwIfNullOrUndefined(lang, "language to be removed");
        if (this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            const languages = this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            const index = languages.indexOf(lang);
            if (index > -1) {
                languages.splice(index, 1);
                this.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
                this.updateLanguages(languages);
            }
        }
    }
    /**
     * dynamically add a language to list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.addTargetLanguage
     * @function
     * @param lang - language to be added
     * @public
     */ addTargetLanguage(lang) {
        $3afpL.Contracts.throwIfNullOrUndefined(lang, "language to be added");
        let languages = [];
        if (this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            languages = this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            if (!languages.includes(lang)) {
                languages.push(lang);
                this.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
            }
        } else {
            this.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, lang);
            languages = [
                lang
            ];
        }
        this.updateLanguages(languages);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member TranslationRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * handles ConnectionEstablishedEvent for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onConnection
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    onConnection() {}
    async dispose(disposing) {
        if (this.privDisposedTranslationRecognizer) return;
        this.privDisposedTranslationRecognizer = true;
        if (disposing) {
            await this.implRecognizerStop();
            await super.dispose(disposing);
        }
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $h6sQE.TranslationServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
    updateLanguages(languages) {
        const conn = $lOcWU.Connection.fromRecognizer(this);
        if (!!conn) {
            conn.setMessageProperty("speech.context", "translationcontext", {
                to: languages
            });
            conn.sendMessageAsync("event", JSON.stringify({
                id: "translation",
                name: "updateLanguage",
                to: languages
            }));
        }
    }
    /**
     * Initializes an instance of the TranslationRecognizer.
     * @constructor
     * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
     */ constructor(speechConfig, audioConfig, connectionFactory){
        const configImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, connectionFactory || new $h6sQE.TranslationConnectionFactory());
        this.privDisposedTranslationRecognizer = false;
        if (this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) $3afpL.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationVoice), $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_TranslationVoice]);
        $3afpL.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages), $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages]);
        $3afpL.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage), $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
}
module.exports.TranslationRecognizer = $24804e2008a48ef6$var$TranslationRecognizer;

});
parcelRegister("lOcWU", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $297I0 = parcelRequire("297I0");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Connection is a proxy class for managing connection to the speech service of the specified Recognizer.
 * By default, a Recognizer autonomously manages connection to service when needed.
 * The Connection class provides additional methods for users to explicitly open or close a connection and
 * to subscribe to connection status changes.
 * The use of Connection is optional, and mainly for scenarios where fine tuning of application
 * behavior based on connection status is needed. Users can optionally call Open() to manually set up a connection
 * in advance before starting recognition on the Recognizer associated with this Connection.
 * If the Recognizer needs to connect or disconnect to service, it will
 * setup or shutdown the connection independently. In this case the Connection will be notified by change of connection
 * status via Connected/Disconnected events.
 * Added in version 1.2.1.
 */ class $fe084ff10dd3f0c3$var$Connection {
    /**
     * Gets the Connection instance from the specified recognizer.
     * @param recognizer The recognizer associated with the connection.
     * @return The Connection instance of the recognizer.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        const ret = new $fe084ff10dd3f0c3$var$Connection();
        ret.privInternalData = recoBase;
        ret.setupEvents();
        return ret;
    }
    /**
     * Gets the Connection instance from the specified synthesizer.
     * @param synthesizer The synthesizer associated with the connection.
     * @return The Connection instance of the synthesizer.
     */ static fromSynthesizer(synthesizer) {
        const synthBase = synthesizer.internalData;
        const ret = new $fe084ff10dd3f0c3$var$Connection();
        ret.privInternalData = synthBase;
        ret.setupEvents();
        return ret;
    }
    /**
     * Starts to set up connection to the service.
     * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
     * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     */ openConnection(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.privInternalData.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
     *
     * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
     */ closeConnection(cb, err) {
        if (this.privInternalData instanceof $h6sQE.SynthesisAdapterBase) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        else $iLPPT.marshalPromiseToCallbacks(this.privInternalData.disconnect(), cb, err);
    }
    /**
     * Appends a parameter in a message to service.
     * Added in version 1.12.1.
     * @param path The path of the network message.
     * @param propertyName Name of the property
     * @param propertyValue Value of the property. This is a json string.
     */ setMessageProperty(path, propertyName, propertyValue) {
        $3afpL.Contracts.throwIfNullOrWhitespace(propertyName, "propertyName");
        if (this.privInternalData instanceof $h6sQE.ServiceRecognizerBase) {
            if (path.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            else this.privInternalData.speechContext.setSection(propertyName, propertyValue);
        } else if (this.privInternalData instanceof $h6sQE.SynthesisAdapterBase) {
            if (path.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
            else this.privInternalData.synthesisContext.setSection(propertyName, propertyValue);
        }
    }
    /**
     * Sends a message to the speech service.
     * Added in version 1.13.0.
     * @param path The WebSocket path of the message
     * @param payload The payload of the message. This is a json string or a ArrayBuffer.
     * @param success A callback to indicate success.
     * @param error A callback to indicate an error.
     */ sendMessageAsync(path, payload, success, error) {
        $iLPPT.marshalPromiseToCallbacks(this.privInternalData.sendNetworkMessage(path, payload), success, error);
    }
    /**
     * Dispose of associated resources.
     */ close() {
    /* eslint-disable no-empty */ }
    setupEvents() {
        this.privEventListener = this.privInternalData.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") {
                if (!!this.connected) this.connected(new $14iyq.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionClosedEvent") {
                if (!!this.disconnected) this.disconnected(new $14iyq.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionMessageSentEvent") {
                if (!!this.messageSent) this.messageSent(new $14iyq.ConnectionMessageEventArgs(new $297I0.ConnectionMessageImpl(connectionEvent.message)));
            } else if (connectionEvent.name === "ConnectionMessageReceivedEvent") {
                if (!!this.messageReceived) this.messageReceived(new $14iyq.ConnectionMessageEventArgs(new $297I0.ConnectionMessageImpl(connectionEvent.message)));
            }
        });
        this.privServiceEventListener = this.privInternalData.serviceEvents.attach((e)=>{
            if (!!this.receivedServiceMessage) this.receivedServiceMessage(new $14iyq.ServiceEventArgs(e.jsonString, e.name));
        });
    }
}
module.exports.Connection = $fe084ff10dd3f0c3$var$Connection;

});
parcelRegister("297I0", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageImpl = module.exports.ConnectionMessage = void 0;

var $7Us8Y = parcelRequire("7Us8Y");

var $iLPPT = parcelRequire("iLPPT");

var $joXzx = parcelRequire("joXzx");

var $1jqKG = parcelRequire("1jqKG");
/**
 * ConnectionMessage represents implementation specific messages sent to and received from
 * the speech service. These messages are provided for debugging purposes and should not
 * be used for production use cases with the Azure Cognitive Services Speech Service.
 * Messages sent to and received from the Speech Service are subject to change without
 * notice. This includes message contents, headers, payloads, ordering, etc.
 * Added in version 1.11.0.
 */ class $190266d3976bfa94$var$ConnectionMessage {
}
module.exports.ConnectionMessage = $190266d3976bfa94$var$ConnectionMessage;
class $190266d3976bfa94$var$ConnectionMessageImpl {
    /**
     * The message path.
     */ get path() {
        return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((key)=>key.toLowerCase() === "path".toLowerCase())];
    }
    /**
     * Checks to see if the ConnectionMessage is a text message.
     * See also IsBinaryMessage().
     */ get isTextMessage() {
        return this.privConnectionMessage.messageType === $iLPPT.MessageType.Text;
    }
    /**
     * Checks to see if the ConnectionMessage is a binary message.
     * See also GetBinaryMessage().
     */ get isBinaryMessage() {
        return this.privConnectionMessage.messageType === $iLPPT.MessageType.Binary;
    }
    /**
     * Gets the text message payload. Typically the text message content-type is
     * application/json. To determine other content-types use
     * Properties.GetProperty("Content-Type").
     */ get TextMessage() {
        return this.privConnectionMessage.textBody;
    }
    /**
     * Gets the binary message payload.
     */ get binaryMessage() {
        return this.privConnectionMessage.binaryBody;
    }
    /**
     * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
     * Message headers can be accessed via this collection (e.g. "Content-Type").
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Returns a string that represents the connection message.
     */ toString() {
        return "";
    }
    constructor(message){
        this.privConnectionMessage = message;
        this.privProperties = new $joXzx.PropertyCollection();
        if (!!this.privConnectionMessage.headers[$7Us8Y.HeaderNames.ConnectionId]) this.privProperties.setProperty($1jqKG.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[$7Us8Y.HeaderNames.ConnectionId]);
        Object.keys(this.privConnectionMessage.headers).forEach((header)=>{
            this.privProperties.setProperty(header, this.privConnectionMessage.headers[header]);
        });
    }
}
module.exports.ConnectionMessageImpl = $190266d3976bfa94$var$ConnectionMessageImpl;

});



parcelRegister("bR9JT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translations = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Represents collection of parameters and their values.
 * @class Translations
 */ class $8a1c32f26b1fe542$var$Translations {
    /**
     * Get the languages in the object in a String array.
     * @member Translations.prototype.languages
     * @function
     * @public
     * @returns {string[]} languages in translations object.
     */ get languages() {
        return this.privMap.keys;
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translations.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ get(key, def) {
        return this.privMap.getProperty(key, def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translations.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ set(key, value) {
        this.privMap.setProperty(key, value);
    }
    constructor(){
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new $14iyq.PropertyCollection();
    }
}
module.exports.Translations = $8a1c32f26b1fe542$var$Translations;

});

parcelRegister("cnuSQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchReason = void 0;
/**
 * Defines the possible reasons a recognition result might not be recognized.
 * @class NoMatchReason
 */ var $02535924928f3060$var$NoMatchReason;
(function(NoMatchReason) {
    /**
     * Indicates that speech was detected, but not recognized.
     * @member NoMatchReason.NotRecognized
     */ NoMatchReason[NoMatchReason["NotRecognized"] = 0] = "NotRecognized";
    /**
     * Indicates that the start of the audio stream contained only silence,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialSilenceTimeout
     */ NoMatchReason[NoMatchReason["InitialSilenceTimeout"] = 1] = "InitialSilenceTimeout";
    /**
     * Indicates that the start of the audio stream contained only noise,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialBabbleTimeout
     */ NoMatchReason[NoMatchReason["InitialBabbleTimeout"] = 2] = "InitialBabbleTimeout";
})($02535924928f3060$var$NoMatchReason = module.exports.NoMatchReason || (module.exports.NoMatchReason = {}));

});

parcelRegister("7kjU5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchDetails = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $14iyq = parcelRequire("14iyq");
/**
 * Contains detailed information for NoMatch recognition results.
 * @class NoMatchDetails
 */ class $5559d71598191c3c$var$NoMatchDetails {
    /**
     * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
     * @member NoMatchDetails.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
     * result - The recognition result that was not recognized.
     * @returns {NoMatchDetails} The no match details object being created.
     */ static fromResult(result) {
        const simpleSpeech = $h6sQE.SimpleSpeechPhrase.fromJSON(result.json);
        let reason = $14iyq.NoMatchReason.NotRecognized;
        switch(simpleSpeech.RecognitionStatus){
            case $h6sQE.RecognitionStatus.BabbleTimeout:
                reason = $14iyq.NoMatchReason.InitialBabbleTimeout;
                break;
            case $h6sQE.RecognitionStatus.InitialSilenceTimeout:
                reason = $14iyq.NoMatchReason.InitialSilenceTimeout;
                break;
            default:
                reason = $14iyq.NoMatchReason.NotRecognized;
                break;
        }
        return new $5559d71598191c3c$var$NoMatchDetails(reason);
    }
    /**
     * The reason the recognition was canceled.
     * @member NoMatchDetails.prototype.reason
     * @function
     * @public
     * @returns {NoMatchReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {NoMatchReason} reason - The no-match reason.
     */ constructor(reason){
        this.privReason = reason;
    }
}
module.exports.NoMatchDetails = $5559d71598191c3c$var$NoMatchDetails;

});

parcelRegister("9mcGx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionCanceledEventArgs = void 0;
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ class $6d00021ccdaa1cfb$var$TranslationRecognitionCanceledEventArgs {
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionCanceledEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Specifies the session identifier.
     * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
    /**
     * The reason the recognition was canceled.
     * @member TranslationRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privCancelReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ constructor(sessionid, cancellationReason, errorDetails, errorCode, result){
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
}
module.exports.TranslationRecognitionCanceledEventArgs = $6d00021ccdaa1cfb$var$TranslationRecognitionCanceledEventArgs;

});

parcelRegister("1SlEV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionCanceledEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Define payload of intent recognition canceled result events.
 * @class IntentRecognitionCanceledEventArgs
 */ class $15dba2a07028b994$var$IntentRecognitionCanceledEventArgs extends $14iyq.IntentRecognitionEventArgs {
    /**
     * The reason the recognition was canceled.
     * @member IntentRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} result - The result of the intent recognition.
     * @param {string} offset - The offset.
     * @param {IntentRecognitionResult} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, result, offset, sessionId){
        super(result, offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
}
module.exports.IntentRecognitionCanceledEventArgs = $15dba2a07028b994$var$IntentRecognitionCanceledEventArgs;

});

parcelRegister("d5ckj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetailsBase = void 0;
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetailsBase
 */ class $98654dc85a9d7a4a$var$CancellationDetailsBase {
    /**
     * The reason the recognition was canceled.
     * @member CancellationDetailsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member CancellationDetailsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get ErrorCode() {
        return this.privErrorCode;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - The error details, if provided.
     */ constructor(reason, errorDetails, errorCode){
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
}
module.exports.CancellationDetailsBase = $98654dc85a9d7a4a$var$CancellationDetailsBase;

});

parcelRegister("aSTrG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetails = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $d5ckj = parcelRequire("d5ckj");

var $14iyq = parcelRequire("14iyq");
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetails
 */ class $7ec9f4d4c3254011$var$CancellationDetails extends $d5ckj.CancellationDetailsBase {
    /**
     * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
     * @member CancellationDetails.fromResult
     * @function
     * @public
     * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
     * @returns {CancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        let reason = $14iyq.CancellationReason.Error;
        let errorCode = $14iyq.CancellationErrorCode.NoError;
        if (result instanceof $14iyq.RecognitionResult && !!result.json) {
            const simpleSpeech = $h6sQE.SimpleSpeechPhrase.fromJSON(result.json);
            reason = $h6sQE.EnumTranslation.implTranslateCancelResult(simpleSpeech.RecognitionStatus);
        }
        if (!!result.properties) errorCode = $14iyq.CancellationErrorCode[result.properties.getProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[$14iyq.CancellationErrorCode.NoError])];
        return new $7ec9f4d4c3254011$var$CancellationDetails(reason, result.errorDetails || $h6sQE.EnumTranslation.implTranslateErrorDetails(errorCode), errorCode);
    }
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
}
module.exports.CancellationDetails = $7ec9f4d4c3254011$var$CancellationDetails;

});

parcelRegister("6ipDE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationErrorCode = void 0;
/**
 * Defines error code in case that CancellationReason is Error.
 * Added in version 1.1.0.
 */ var $49584fc7c50cab07$var$CancellationErrorCode;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
    /**
     * Indicates an quota overrun on existing key.
     */ CancellationErrorCode[CancellationErrorCode["Forbidden"] = 8] = "Forbidden";
})($49584fc7c50cab07$var$CancellationErrorCode = module.exports.CancellationErrorCode || (module.exports.CancellationErrorCode = {}));

});

parcelRegister("aWCaO", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */ class $7f7cee9857cff6a6$var$ConnectionEventArgs extends $14iyq.SessionEventArgs {
}
module.exports.ConnectionEventArgs = $7f7cee9857cff6a6$var$ConnectionEventArgs;

});

parcelRegister("56I7a", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines payload for any Service message event
 * Added in version 1.9.0
 */ class $3b7fbb8b2de66153$var$ServiceEventArgs extends $14iyq.SessionEventArgs {
    get jsonString() {
        return this.privJsonResult;
    }
    get eventName() {
        return this.privEventName;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} json - json payload of the USP message.
     */ constructor(json, name, sessionId){
        super(sessionId);
        this.privJsonResult = json;
        this.privEventName = name;
    }
}
module.exports.ServiceEventArgs = $3b7fbb8b2de66153$var$ServiceEventArgs;

});

parcelRegister("f0Mf4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhraseListGrammar = void 0;
/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */ class $aedc46fe7f8f01b9$var$PhraseListGrammar {
    /**
     * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
     * @param recognizer The recognizer to add phrase lists to.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        return new $aedc46fe7f8f01b9$var$PhraseListGrammar(recoBase);
    }
    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */ addPhrase(phrase) {
        this.privGrammerBuilder.addPhrase(phrase);
    }
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */ addPhrases(phrases) {
        this.privGrammerBuilder.addPhrase(phrases);
    }
    /**
     * Clears all phrases added to the current recognizer.
     */ clear() {
        this.privGrammerBuilder.clearPhrases();
    }
    constructor(recogBase){
        this.privGrammerBuilder = recogBase.dynamicGrammar;
    }
}
module.exports.PhraseListGrammar = $aedc46fe7f8f01b9$var$PhraseListGrammar;

});

parcelRegister("9pOty", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConfigImpl = module.exports.DialogServiceConfig = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Class that defines base configurations for dialog service connector
 * @class DialogServiceConfig
 */ class $6dad9a491373d0aa$var$DialogServiceConfig {
    /**
     * Sets the corresponding backend application identifier.
     * @member DialogServiceConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(value) {}
    static get DialogTypes() {
        return {
            BotFramework: "bot_framework",
            CustomCommands: "custom_commands"
        };
    }
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ constructor(){
        return;
    }
}
module.exports.DialogServiceConfig = $6dad9a491373d0aa$var$DialogServiceConfig;
/**
 * Dialog Service configuration.
 * @class DialogServiceConfigImpl
 */ class $6dad9a491373d0aa$var$DialogServiceConfigImpl extends $6dad9a491373d0aa$var$DialogServiceConfig {
    /**
     * Provides access to custom properties.
     * @member DialogServiceConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */ set speechRecognitionLanguage(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechConfig.speechRecognitionLanguage = value;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(value) {
        this.privSpeechConfig.outputFormat = value;
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ setProperty(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ getProperty(name, def) {
        return this.privSpeechConfig.getProperty(name);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyPort, `${proxyPort}`);
        if (proxyUserName) this.setProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty($14iyq.PropertyId.SpeechServiceConnection_ProxyPassword, proxyPassword);
    }
    setServiceProperty(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    /**
     * Creates an instance of dialogService config.
     */ constructor(){
        super();
        this.privSpeechConfig = new $14iyq.SpeechConfigImpl();
    }
}
module.exports.DialogServiceConfigImpl = $6dad9a491373d0aa$var$DialogServiceConfigImpl;

});

parcelRegister("j6e5o", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BotFrameworkConfig = void 0;

var $3afpL = parcelRequire("3afpL");

var $9pOty = parcelRequire("9pOty");

var $14iyq = parcelRequire("14iyq");
/**
 * Class that defines configurations for the dialog service connector object for using a Bot Framework backend.
 * @class BotFrameworkConfig
 */ class $de7981052b6453e3$var$BotFrameworkConfig extends $9pOty.DialogServiceConfigImpl {
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromSubscription(subscription, region, botId) {
        $3afpL.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new $9pOty.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($14iyq.PropertyId.Conversation_DialogType, $9pOty.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscription);
        botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($14iyq.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     * caller must refresh it by setting the authorizationToken property on the corresponding
     * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     * original configuration's authorization token. Create a new configuration instance or set the
     * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     * further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromAuthorizationToken(authorizationToken, region, botId) {
        $3afpL.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new $9pOty.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($14iyq.PropertyId.Conversation_DialogType, $9pOty.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($14iyq.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     * property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     * wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromHost(host, subscriptionKey, botId) {
        $3afpL.Contracts.throwIfNullOrUndefined(host, "host");
        const resolvedHost = host instanceof URL ? host : new URL(`wss://${host}.convai.speech.azure.us`);
        $3afpL.Contracts.throwIfNullOrUndefined(resolvedHost, "resolvedHost");
        const botFrameworkConfig = new $9pOty.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($14iyq.PropertyId.Conversation_DialogType, $9pOty.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Host, resolvedHost.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     * use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $3afpL.Contracts.throwIfNull(endpoint, "endpoint");
        const botFrameworkConfig = new $9pOty.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($14iyq.PropertyId.Conversation_DialogType, $9pOty.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, endpoint.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of BotFrameworkConfig.
     */ constructor(){
        super();
    }
}
module.exports.BotFrameworkConfig = $de7981052b6453e3$var$BotFrameworkConfig;

});

parcelRegister("dn3o0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomCommandsConfig = void 0;

var $3afpL = parcelRequire("3afpL");

var $9pOty = parcelRequire("9pOty");

var $14iyq = parcelRequire("14iyq");
/**
 * Class that defines configurations for the dialog service connector object for using a CustomCommands backend.
 * @class CustomCommandsConfig
 */ class $9bc00cc0025d6c34$var$CustomCommandsConfig extends $9pOty.DialogServiceConfigImpl {
    /**
     * Creates an instance of the bot framework config with the specified subscription and region.
     * @member CustomCommandsConfig.fromSubscription
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new bot framework config.
     */ static fromSubscription(applicationId, subscription, region) {
        $3afpL.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const customCommandsConfig = new $9pOty.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($14iyq.PropertyId.Conversation_DialogType, $9pOty.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($14iyq.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Key, subscription);
        customCommandsConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    }
    /**
     * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member CustomCommandsConfig.fromAuthorizationToken
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param authorizationToken The authorization token associated with the application.
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new speech commands config.
     */ static fromAuthorizationToken(applicationId, authorizationToken, region) {
        $3afpL.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $3afpL.Contracts.throwIfNullOrWhitespace(region, "region");
        const customCommandsConfig = new $9pOty.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($14iyq.PropertyId.Conversation_DialogType, $9pOty.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($14iyq.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        customCommandsConfig.setProperty($14iyq.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ set applicationId(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "value");
        this.setProperty($14iyq.PropertyId.Conversation_ApplicationId, value);
    }
    /**
     * Gets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to get.
     */ get applicationId() {
        return this.getProperty($14iyq.PropertyId.Conversation_ApplicationId);
    }
    /**
     * Creates an instance of CustomCommandsConfig.
     */ constructor(){
        super();
    }
}
module.exports.CustomCommandsConfig = $9bc00cc0025d6c34$var$CustomCommandsConfig;

});

parcelRegister("f52wp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConnector = void 0;

var $gQR1g = parcelRequire("gQR1g");

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $1jqKG = parcelRequire("1jqKG");
/**
 * Dialog Service Connector
 * @class DialogServiceConnector
 */ class $afa9476b1837ae1d$var$DialogServiceConnector extends $14iyq.Recognizer {
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */ connect(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.privReco.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */ disconnect(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.privReco.disconnect(), cb, err);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($1jqKG.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Sets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($1jqKG.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this DialogServiceConnector.
     * @member DialogServiceConnector.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
     */ get properties() {
        return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be empty
     */ get speechActivityTemplate() {
        return this.properties.getProperty($1jqKG.PropertyId.Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be null or empty.
     * Note: it has to be a valid Json object.
     */ set speechActivityTemplate(speechActivityTemplate) {
        this.properties.setProperty($1jqKG.PropertyId.Conversation_Speech_Activity_Template, speechActivityTemplate);
    }
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */ listenOnceAsync(cb, err) {
        if (this.isTurnComplete) {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            const callbackHolder = async ()=>{
                await this.privReco.connect();
                await this.implRecognizerStop();
                this.isTurnComplete = false;
                const ret = new $iLPPT.Deferred();
                await this.privReco.recognize($h6sQE.RecognitionMode.Conversation, ret.resolve, ret.reject);
                const e = await ret.promise;
                await this.implRecognizerStop();
                return e;
            };
            const retPromise = callbackHolder();
            retPromise.catch(()=>{
                // Destroy the recognizer.
                // We've done all we can here.
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                this.dispose(true).catch(()=>{});
            });
            $iLPPT.marshalPromiseToCallbacks(retPromise.finally(()=>{
                this.isTurnComplete = true;
            }), cb, err);
        }
    }
    sendActivityAsync(activity, cb, errCb) {
        $iLPPT.marshalPromiseToCallbacks(this.privReco.sendMessage(activity), cb, errCb);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    }
    async dispose(disposing) {
        if (this.privIsDisposed) return;
        if (disposing) {
            this.privIsDisposed = true;
            await this.implRecognizerStop();
            await super.dispose(disposing);
        }
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new $h6sQE.DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    buildAgentConfig() {
        const communicationType = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
            botInfo: {
                commType: communicationType,
                commandsCulture: undefined,
                connectionId: this.properties.getProperty($1jqKG.PropertyId.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($1jqKG.PropertyId.Conversation_Conversation_Id, undefined),
                fromId: this.properties.getProperty($1jqKG.PropertyId.Conversation_From_Id, undefined),
                ttsAudioFormat: this.properties.getProperty($1jqKG.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)
            },
            version: 0.2
        };
    }
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ constructor(dialogConfig, audioConfig){
        const dialogServiceConfigImpl = dialogConfig;
        $3afpL.Contracts.throwIfNull(dialogConfig, "dialogConfig");
        super(audioConfig, dialogServiceConfigImpl.properties, new $gQR1g.DialogConnectionFactory());
        this.isTurnComplete = true;
        this.privIsDisposed = false;
        this.privProperties = dialogServiceConfigImpl.properties.clone();
        const agentConfig = this.buildAgentConfig();
        this.privReco.agentConfig.set(agentConfig);
    }
}
module.exports.DialogServiceConnector = $afa9476b1837ae1d$var$DialogServiceConnector;

});
parcelRegister("gQR1g", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $h6sQE = parcelRequire("h6sQE");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");
class $c44aa13cfbd52a89$var$DialogConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const applicationId = config.parameters.getProperty($14iyq.PropertyId.Conversation_ApplicationId, "");
        const dialogType = config.parameters.getProperty($14iyq.PropertyId.Conversation_DialogType);
        const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region);
        const language = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
        const requestTurnStatus = config.parameters.getProperty($14iyq.PropertyId.Conversation_Request_Bot_Status_Messages, "true");
        const queryParams = {};
        queryParams[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        queryParams[$dq5v3.QueryParameterNames.Format] = config.parameters.getProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]).toLowerCase();
        queryParams[$dq5v3.QueryParameterNames.Language] = language;
        queryParams[$dq5v3.QueryParameterNames.RequestBotStatusMessages] = requestTurnStatus;
        if (applicationId) {
            queryParams[$dq5v3.QueryParameterNames.BotId] = applicationId;
            if (dialogType === $14iyq.DialogServiceConfig.DialogTypes.CustomCommands) queryParams[$7Us8Y.HeaderNames.CustomCommandsAppId] = applicationId;
        }
        const resourceInfix = dialogType === $14iyq.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "";
        const version = dialogType === $14iyq.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : dialogType === $14iyq.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0";
        const headers = {};
        if (authInfo.token != null && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        // The URL used for connection is chosen in a priority order of specification:
        //  1. If a custom endpoint is provided, that URL is used verbatim.
        //  2. If a custom host is provided (e.g. "wss://my.custom.endpoint.com:1123"), a URL is constructed from it.
        //  3. If no custom connection details are provided, a URL is constructed from default values.
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, "");
        if (!endpoint) {
            const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, `wss://${region}.${$c44aa13cfbd52a89$var$DialogConnectionFactory.BaseUrl}${hostSuffix}`);
            const standardizedHost = host.endsWith("/") ? host : host + "/";
            endpoint = `${standardizedHost}${resourceInfix}${$c44aa13cfbd52a89$var$DialogConnectionFactory.ApiKey}/${version}`;
        }
        this.setCommonUrlParams(config, queryParams, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
}
module.exports.DialogConnectionFactory = $c44aa13cfbd52a89$var$DialogConnectionFactory;
$c44aa13cfbd52a89$var$DialogConnectionFactory.ApiKey = "api";
$c44aa13cfbd52a89$var$DialogConnectionFactory.BaseUrl = "convai.speech";

});
parcelRegister("6wf4H", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionFactoryBase = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $14iyq = parcelRequire("14iyq");

var $dq5v3 = parcelRequire("dq5v3");
class $4bf16cc79302fdb1$var$ConnectionFactoryBase {
    static getHostSuffix(region) {
        if (!!region) {
            if (region.toLowerCase().startsWith("china")) return ".azure.cn";
            if (region.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    }
    setCommonUrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                $14iyq.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $dq5v3.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $14iyq.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $dq5v3.QueryParameterNames.EnableAudioLogging
            ],
            [
                $14iyq.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $dq5v3.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $14iyq.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $dq5v3.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $dq5v3.QueryParameterNames.Postprocessing
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_ProfanityOption,
                $dq5v3.QueryParameterNames.Profanity
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps,
                $dq5v3.QueryParameterNames.EnableWordLevelTimestamps
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $dq5v3.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty($h6sQE.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
    setUrlParameter(propId, parameterName, config, queryParams, endpoint) {
        const value = config.parameters.getProperty(propId, undefined);
        // FIXME: The .search() check will incorrectly match parameter name anywhere in the string
        //        including e.g. the path portion, or even as a substring of other query parameters
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    }
}
module.exports.ConnectionFactoryBase = $4bf16cc79302fdb1$var$ConnectionFactoryBase;

});
parcelRegister("dq5v3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryParameterNames = void 0;
class $9c51f839a77c8ac5$var$QueryParameterNames {
}
module.exports.QueryParameterNames = $9c51f839a77c8ac5$var$QueryParameterNames;
$9c51f839a77c8ac5$var$QueryParameterNames.BotId = "botid";
$9c51f839a77c8ac5$var$QueryParameterNames.CustomSpeechDeploymentId = "cid";
$9c51f839a77c8ac5$var$QueryParameterNames.CustomVoiceDeploymentId = "deploymentId";
$9c51f839a77c8ac5$var$QueryParameterNames.EnableAudioLogging = "storeAudio";
$9c51f839a77c8ac5$var$QueryParameterNames.EnableLanguageId = "lidEnabled";
$9c51f839a77c8ac5$var$QueryParameterNames.EnableWordLevelTimestamps = "wordLevelTimestamps";
$9c51f839a77c8ac5$var$QueryParameterNames.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$9c51f839a77c8ac5$var$QueryParameterNames.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
$9c51f839a77c8ac5$var$QueryParameterNames.Format = "format";
$9c51f839a77c8ac5$var$QueryParameterNames.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$9c51f839a77c8ac5$var$QueryParameterNames.Language = "language";
$9c51f839a77c8ac5$var$QueryParameterNames.Profanity = "profanity";
$9c51f839a77c8ac5$var$QueryParameterNames.RequestBotStatusMessages = "enableBotMessageStatus";
$9c51f839a77c8ac5$var$QueryParameterNames.StableIntermediateThreshold = "stableIntermediateThreshold";
$9c51f839a77c8ac5$var$QueryParameterNames.StableTranslation = "stableTranslation";
$9c51f839a77c8ac5$var$QueryParameterNames.TestHooks = "testhooks";
$9c51f839a77c8ac5$var$QueryParameterNames.Postprocessing = "postprocessing";
$9c51f839a77c8ac5$var$QueryParameterNames.CtsMeetingId = "meetingId";
$9c51f839a77c8ac5$var$QueryParameterNames.CtsDeviceId = "deviceId";
$9c51f839a77c8ac5$var$QueryParameterNames.CtsIsParticipant = "isParticipant";
$9c51f839a77c8ac5$var$QueryParameterNames.EnableAvatar = "enableTalkingAvatar";

});




parcelRegister("gYeb1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActivityReceivedEventArgs = void 0;
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ class $c5ad3f24020071c5$var$ActivityReceivedEventArgs {
    /**
     * Gets the received activity
     * @member ActivityReceivedEventArgs.prototype.activity
     * @function
     * @public
     * @returns {any} the received activity.
     */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ constructor(activity, audioStream){
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
}
module.exports.ActivityReceivedEventArgs = $c5ad3f24020071c5$var$ActivityReceivedEventArgs;

});

parcelRegister("12LVS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusReceivedEventArgs = void 0;

var $dS4ux = parcelRequire("dS4ux");
/**
 * Defines contents of received message/events.
 * @class TurnStatusReceivedEventArgs
 */ class $0c2b28bc06aecdce$var$TurnStatusReceivedEventArgs {
    /**
     * Gets the interaction identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.interactionId
     * @function
     * @public
     * @returns {any} the received interaction id.
     */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
     * Gets the conversation identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.conversationId
     * @function
     * @public
     * @returns {any} the received conversation id.
     */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
     * Gets the received turn status code.
     * @member TurnStatusReceivedEventArgs.prototype.statusCode
     * @function
     * @public
     * @returns {number} the received turn status.
     */ get statusCode() {
        return this.privTurnStatus.statusCode; // eslint-disable-line @typescript-eslint/no-unsafe-return
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ constructor(turnStatus){
        this.privTurnStatus = $dS4ux.TurnStatusResponsePayload.fromJSON(turnStatus);
    }
}
module.exports.TurnStatusReceivedEventArgs = $0c2b28bc06aecdce$var$TurnStatusReceivedEventArgs;

});
parcelRegister("dS4ux", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusResponsePayload = void 0;
class $a193cd6d129699f7$var$TurnStatusResponsePayload {
    static fromJSON(json) {
        return new $a193cd6d129699f7$var$TurnStatusResponsePayload(json);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        // Payloads may contain a limited set of textual representations or a numeric status
        // code. The textual values are here converted into numeric ones.
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return this.privMessageStatusResponse.statusCode;
        }
    }
    constructor(json){
        this.privMessageStatusResponse = JSON.parse(json);
    }
}
module.exports.TurnStatusResponsePayload = $a193cd6d129699f7$var$TurnStatusResponsePayload;

});


parcelRegister("38LHC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicePropertyChannel = void 0;
/**
 * Defines channels used to pass property settings to service.
 * Added in version 1.7.0.
 */ var $24971f2e633bf98e$var$ServicePropertyChannel;
(function(ServicePropertyChannel) {
    /**
     * Uses URI query parameter to pass property settings to service.
     */ ServicePropertyChannel[ServicePropertyChannel["UriQueryParameter"] = 0] = "UriQueryParameter";
})($24971f2e633bf98e$var$ServicePropertyChannel = module.exports.ServicePropertyChannel || (module.exports.ServicePropertyChannel = {}));

});

parcelRegister("3W9cf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfanityOption = void 0;
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $2dddec1ae4b257a1$var$ProfanityOption;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($2dddec1ae4b257a1$var$ProfanityOption = module.exports.ProfanityOption || (module.exports.ProfanityOption = {}));

});

parcelRegister("3hO9W", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAudioPlayer = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $14iyq = parcelRequire("14iyq");

var $9Xjoq = parcelRequire("9Xjoq");
/**
 * Base audio player class
 * TODO: Plays only PCM for now.
 * @class
 */ class $2649de3dfe5119f9$var$BaseAudioPlayer {
    /**
     * play Audio sample
     * @param newAudioData audio data to be played.
     */ playAudioSample(newAudioData, cb, err) {
        try {
            this.ensureInitializedContext();
            const audioData = this.formatAudioData(newAudioData);
            const newSamplesData = new Float32Array(this.samples.length + audioData.length);
            newSamplesData.set(this.samples, 0);
            newSamplesData.set(audioData, this.samples.length);
            this.samples = newSamplesData;
            if (!!cb) cb();
        } catch (e) {
            if (!!err) err(e);
        }
    }
    /**
     * stops audio and clears the buffers
     */ stopAudio(cb, err) {
        if (this.audioContext !== null) {
            this.samples = new Float32Array();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            clearInterval(this.autoUpdateBufferTimer);
            this.audioContext.close().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.audioContext = null;
        }
    }
    init(audioFormat) {
        this.audioFormat = audioFormat;
        this.samples = new Float32Array();
    }
    ensureInitializedContext() {
        if (this.audioContext === null) {
            this.createAudioContext();
            const timerPeriod = 200;
            this.autoUpdateBufferTimer = setInterval(()=>{
                this.updateAudioBuffer();
            }, timerPeriod);
        }
    }
    createAudioContext() {
        // new ((window as any).AudioContext || (window as any).webkitAudioContext)();
        this.audioContext = $9Xjoq.AudioStreamFormatImpl.getAudioContext();
        // TODO: Various examples shows this gain node, it does not seem to be needed unless we plan
        // to control the volume, not likely
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = 1;
        this.gainNode.connect(this.audioContext.destination);
        this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(audioData) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(audioData), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(audioData), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(audioData), 2147483648);
            default:
                throw new $8EMmR.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    }
    formatArrayBuffer(audioData, maxValue) {
        const float32Data = new Float32Array(audioData.length);
        for(let i = 0; i < audioData.length; i++)float32Data[i] = audioData[i] / maxValue;
        return float32Data;
    }
    updateAudioBuffer() {
        if (this.samples.length === 0) return;
        const channelCount = this.audioFormat.channels;
        const bufferSource = this.audioContext.createBufferSource();
        const frameCount = this.samples.length / channelCount;
        const audioBuffer = this.audioContext.createBuffer(channelCount, frameCount, this.audioFormat.samplesPerSec);
        // TODO: Should we do the conversion in the pushAudioSample instead?
        for(let channel = 0; channel < channelCount; channel++){
            // Fill in individual channel data
            let channelOffset = channel;
            const audioData = audioBuffer.getChannelData(channel);
            for(let i = 0; i < this.samples.length; i++, channelOffset += channelCount)audioData[i] = this.samples[channelOffset];
        }
        if (this.startTime < this.audioContext.currentTime) this.startTime = this.audioContext.currentTime;
        bufferSource.buffer = audioBuffer;
        bufferSource.connect(this.gainNode);
        bufferSource.start(this.startTime);
        // Make sure we play the next sample after the current one.
        this.startTime += audioBuffer.duration;
        // Clear the samples for the next pushed data.
        this.samples = new Float32Array();
    }
    async playAudio(audioData) {
        if (this.audioContext === null) this.createAudioContext();
        const source = this.audioContext.createBufferSource();
        const destination = this.audioContext.destination;
        await this.audioContext.decodeAudioData(audioData, (newBuffer)=>{
            source.buffer = newBuffer;
            source.connect(destination);
            source.start(0);
        });
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
     */ constructor(audioFormat){
        this.audioContext = null;
        this.gainNode = null;
        this.autoUpdateBufferTimer = 0;
        if (audioFormat === undefined) audioFormat = $14iyq.AudioStreamFormat.getDefaultInputFormat();
        this.init(audioFormat);
    }
}
module.exports.BaseAudioPlayer = $2649de3dfe5119f9$var$BaseAudioPlayer;

});

parcelRegister("glNqD", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageEventArgs = void 0;
class $be74f30324f4dc04$var$ConnectionMessageEventArgs {
    /**
     * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
     */ get message() {
        return this.privConnectionMessage;
    }
    /**
     * Returns a string that represents the connection message event.
     */ toString() {
        return "Message: " + this.privConnectionMessage.toString();
    }
    constructor(message){
        this.privConnectionMessage = message;
    }
}
module.exports.ConnectionMessageEventArgs = $be74f30324f4dc04$var$ConnectionMessageEventArgs;

});

parcelRegister("402sZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfile = void 0;
/**
 * Defines Voice Profile class for Speaker Recognition
 * @class VoiceProfile
 */ class $2e9913561ad25d1a$var$VoiceProfile {
    /**
     * profileId of this Voice Profile instance
     * @member VoiceProfile.prototype.profileId
     * @function
     * @public
     * @returns {string} profileId of this Voice Profile instance.
     */ get profileId() {
        return this.privId;
    }
    /**
     * profileType of this Voice Profile instance
     * @member VoiceProfile.prototype.profileType
     * @function
     * @public
     * @returns {VoiceProfileType} profile type of this Voice Profile instance.
     */ get profileType() {
        return this.privProfileType;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} profileId - profileId of this Voice Profile.
     * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
     */ constructor(profileId, profileType){
        this.privId = profileId;
        this.privProfileType = profileType;
    }
}
module.exports.VoiceProfile = $2e9913561ad25d1a$var$VoiceProfile;

});

parcelRegister("7j8Ky", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileEnrollmentCancellationDetails = module.exports.VoiceProfileEnrollmentResult = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $14iyq = parcelRequire("14iyq");
/**
 * Output format
 * @class VoiceProfileEnrollmentResult
 */ class $5521184bc00d2cc8$var$VoiceProfileEnrollmentResult {
    get reason() {
        return this.privReason;
    }
    get enrollmentsCount() {
        return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
        return this.privDetails.enrollmentsLength;
    }
    get properties() {
        return this.privProperties;
    }
    get enrollmentResultDetails() {
        return this.privDetails;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    static FromIdentificationProfileList(json) {
        const results = [];
        for (const item of json.value){
            const reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $14iyq.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $14iyq.ResultReason.EnrolledVoiceProfile : $14iyq.ResultReason.Canceled;
            const result = new $5521184bc00d2cc8$var$VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getIdentificationDetails(item);
            results.push(result);
        }
        return results;
    }
    static FromVerificationProfileList(json) {
        const results = [];
        for (const item of json.value){
            const reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $14iyq.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $14iyq.ResultReason.EnrolledVoiceProfile : $14iyq.ResultReason.Canceled;
            const result = new $5521184bc00d2cc8$var$VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getVerificationDetails(item);
            results.push(result);
        }
        return results;
    }
    static getIdentificationDetails(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount || 0,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.identificationProfileId,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    }
    static getVerificationDetails(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.verificationProfileId,
            remainingEnrollmentsCount: json.remainingEnrollments || json.remainingEnrollmentsCount,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    }
    constructor(reason, json, statusText){
        this.privReason = reason;
        this.privProperties = new $14iyq.PropertyCollection();
        if (this.privReason !== $14iyq.ResultReason.Canceled) {
            if (!!json) {
                this.privDetails = JSON.parse(json);
                if (this.privDetails.enrollmentStatus.toLowerCase() === "enrolling") this.privReason = $14iyq.ResultReason.EnrollingVoiceProfile;
            }
        } else {
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[$14iyq.CancellationErrorCode.ServiceError]);
        }
    }
}
module.exports.VoiceProfileEnrollmentResult = $5521184bc00d2cc8$var$VoiceProfileEnrollmentResult;
/**
 * @class VoiceProfileEnrollmentCancellationDetails
 */ class $5521184bc00d2cc8$var$VoiceProfileEnrollmentCancellationDetails extends $14iyq.CancellationDetailsBase {
    /**
     * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
     * @member VoiceProfileEnrollmentCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
     * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = $14iyq.CancellationReason.Error;
        let errorCode = $14iyq.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $14iyq.CancellationErrorCode[result.properties.getProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[$14iyq.CancellationErrorCode.NoError])]; //eslint-disable-line
        return new $5521184bc00d2cc8$var$VoiceProfileEnrollmentCancellationDetails(reason, result.errorDetails, errorCode);
    }
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
}
module.exports.VoiceProfileEnrollmentCancellationDetails = $5521184bc00d2cc8$var$VoiceProfileEnrollmentCancellationDetails;

});

parcelRegister("34Zsr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileCancellationDetails = module.exports.VoiceProfileResult = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Output format
 * @class VoiceProfileResult
 */ class $23e16b087edcb5c6$var$VoiceProfileResult {
    get reason() {
        return this.privReason;
    }
    get properties() {
        return this.privProperties;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    constructor(reason, statusText){
        this.privReason = reason;
        this.privProperties = new $14iyq.PropertyCollection();
        if (reason === $14iyq.ResultReason.Canceled) {
            $3afpL.Contracts.throwIfNullOrUndefined(statusText, "statusText");
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[$14iyq.CancellationErrorCode.ServiceError]);
        }
    }
}
module.exports.VoiceProfileResult = $23e16b087edcb5c6$var$VoiceProfileResult;
/**
 * @class VoiceProfileCancellationDetails
 */ class $23e16b087edcb5c6$var$VoiceProfileCancellationDetails extends $14iyq.CancellationDetailsBase {
    /**
     * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
     * @member VoiceProfileCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileResult} result - The result that was canceled.
     * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = $14iyq.CancellationReason.Error;
        let errorCode = $14iyq.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $14iyq.CancellationErrorCode[result.properties.getProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[$14iyq.CancellationErrorCode.NoError])]; //eslint-disable-line
        return new $23e16b087edcb5c6$var$VoiceProfileCancellationDetails(reason, result.errorDetails, errorCode);
    }
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
}
module.exports.VoiceProfileCancellationDetails = $23e16b087edcb5c6$var$VoiceProfileCancellationDetails;

});

parcelRegister("4sLWV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfilePhraseResult = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Output format
 * @class VoiceProfilePhraseResult
 */ class $33fef8aea75fcdd3$var$VoiceProfilePhraseResult extends $14iyq.VoiceProfileResult {
    get phrases() {
        return this.privPhrases;
    }
    get type() {
        return this.privType;
    }
    constructor(reason, statusText, type, phraseArray){
        super(reason, statusText);
        this.privPhrases = [];
        $3afpL.Contracts.throwIfNullOrUndefined(phraseArray, "phrase array");
        this.privType = type;
        if (!!phraseArray && !!phraseArray[0]) this.privPhrases = phraseArray;
    }
}
module.exports.VoiceProfilePhraseResult = $33fef8aea75fcdd3$var$VoiceProfilePhraseResult;

});

parcelRegister("4rYC0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileClient = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $2IfFc = parcelRequire("2IfFc");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Defines VoiceProfileClient class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class VoiceProfileClient
 */ class $33d8b3500ff5768c$var$VoiceProfileClient extends $14iyq.Recognizer {
    /**
     * The collection of properties and their values defined for this VoiceProfileClient.
     * @member VoiceProfileClient.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member VoiceProfileClient.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member VoiceProfileClient.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.createProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Type of Voice Profile to be created
     * @param {string} lang Language string (locale) for Voice Profile
     * @return {Promise<VoiceProfile>} - Promise of a VoiceProfile.
     */ async createProfileAsync(profileType, lang) {
        const profileIds = await this.privVoiceAdapter.createProfile(profileType, lang);
        return new $14iyq.VoiceProfile(profileIds[0], profileType);
    }
    /**
     * Get current information of a voice profile
     * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to retrieve info for
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */ async retrieveEnrollmentResultAsync(profile) {
        return this.privVoiceAdapter.retrieveEnrollmentResult(profile);
    }
    /**
     * Get all voice profiles on account with given voice profile type
     * @member VoiceProfileClient.prototype.getAllProfilesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
     * @return {Promise<VoiceProfileEnrollmentResult[]>} - Promise of an array of VoiceProfileEnrollmentResults.
     */ async getAllProfilesAsync(profileType) {
        return this.privVoiceAdapter.getAllProfiles(profileType);
    /*
        const result: { json: { value: EnrollmentResultJSON[] } } = await this.privAdapter.getProfiles(profileType);
        if (profileType === VoiceProfileType.TextIndependentIdentification) {
            return VoiceProfileEnrollmentResult.FromIdentificationProfileList(result.json);
        }
        return VoiceProfileEnrollmentResult.FromVerificationProfileList(result.json);
        */ }
    /**
     * Get valid authorization phrases for voice profile enrollment
     * @member VoiceProfileClient.prototype.getActivationPhrasesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Profile Type to get activation phrases for
     * @param {string} lang Language string (locale) for Voice Profile
     */ async getActivationPhrasesAsync(profileType, lang) {
        return this.privVoiceAdapter.getActivationPhrases(profileType, lang);
    }
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.enrollProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to create enrollment for
     * @param {AudioConfig} audioConfig source info from which to create enrollment
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */ async enrollProfileAsync(profile, audioConfig) {
        const configImpl = audioConfig;
        $3afpL.Contracts.throwIfNullOrUndefined(configImpl, "audioConfig");
        this.audioConfig = audioConfig;
        this.privVoiceAdapter.SpeakerAudioSource = configImpl;
        return this.privVoiceAdapter.enrollProfile(profile);
    }
    /**
     * Delete a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.deleteProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be deleted
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */ async deleteProfileAsync(profile) {
        return this.privVoiceAdapter.deleteProfile(profile);
    }
    /**
     * Remove all enrollments for a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.resetProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be reset
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */ async resetProfileAsync(profile) {
        return this.privVoiceAdapter.resetProfile(profile);
    }
    /**
     * Clean up object and close underlying connection
     * @member VoiceProfileClient.prototype.close
     * @function
     * @async
     * @public
     */ async close() {
        await this.dispose(true);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioImpl = audioConfig;
        return new $h6sQE.VoiceServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    }
    async dispose(disposing) {
        if (this.privDisposedVoiceAdapter) return;
        this.privDisposedVoiceAdapter = true;
        if (disposing) await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.properties);
    }
    getResult(result, successReason) {
        const response = new $14iyq.VoiceProfileResult(result.ok ? successReason : $14iyq.ResultReason.Canceled, result.statusText);
        return response;
    }
    /**
     * VoiceProfileClient constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
     */ constructor(speechConfig){
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        const speechConfigImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        super($2IfFc.AudioConfig.fromStreamInput($14iyq.AudioInputStream.createPushStream()), speechConfigImpl.properties, new $h6sQE.VoiceProfileConnectionFactory());
        this.privProperties = speechConfigImpl.properties.clone();
        this.privVoiceAdapter = this.privReco;
        this.privDisposedVoiceAdapter = false;
    }
}
module.exports.VoiceProfileClient = $33d8b3500ff5768c$var$VoiceProfileClient;

});

parcelRegister("38YHD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Defines SpeakerRecognizer class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class SpeakerRecognizer
 */ class $24a134c5c3413229$var$SpeakerRecognizer extends $14iyq.Recognizer {
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeakerRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeakerRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this SpeakerRecognizer.
     * @member SpeakerRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Get recognition result for model using given audio
     * @member SpeakerRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @async
     * @param {SpeakerIdentificationModel | SpeakerVerificationModel} model Model containing Voice Profiles to be identified
     * @param cb - Callback invoked once result is returned.
     * @param err - Callback invoked in case of an error.
     */ async recognizeOnceAsync(model) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
        return this.recognizeSpeakerOnceAsyncImpl(model);
    }
    /**
     * Included for compatibility
     * @member SpeakerRecognizer.prototype.close
     * @function
     * @public
     * @async
     */ async close() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
        await this.dispose(true);
    }
    async recognizeSpeakerOnceAsyncImpl(model) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
        await this.implRecognizerStop();
        const result = await this.privReco.recognizeSpeaker(model);
        await this.implRecognizerStop();
        return result;
    }
    async implRecognizerStop() {
        if (this.privReco) await this.privReco.stopRecognizing();
        return;
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioImpl = audioConfig;
        return new $h6sQE.SpeakerServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    }
    async dispose(disposing) {
        if (this.privDisposedSpeakerRecognizer) return;
        if (disposing) {
            this.privDisposedSpeakerRecognizer = true;
            await super.dispose(disposing);
        }
    }
    /**
     * Initializes an instance of the SpeakerRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        const configImpl = speechConfig;
        $3afpL.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, new $h6sQE.SpeakerRecognitionConnectionFactory());
        this.privAudioConfigImpl = audioConfig;
        $3afpL.Contracts.throwIfNull(this.privAudioConfigImpl, "audioConfig");
        this.privDisposedSpeakerRecognizer = false;
        this.privProperties = configImpl.properties;
    }
}
module.exports.SpeakerRecognizer = $24a134c5c3413229$var$SpeakerRecognizer;

});

parcelRegister("dnueU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerIdentificationModel = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Defines SpeakerIdentificationModel class for Speaker Recognition
 * Model contains a set of profiles against which to identify speaker(s)
 * @class SpeakerIdentificationModel
 */ class $9bd4e1417edaf7cd$var$SpeakerIdentificationModel {
    static fromProfiles(profiles) {
        return new $9bd4e1417edaf7cd$var$SpeakerIdentificationModel(profiles);
    }
    get voiceProfileIds() {
        return this.privProfileIds.join(",");
    }
    get profileIds() {
        return this.privProfileIds;
    }
    get scenario() {
        return "TextIndependentIdentification";
    }
    constructor(profiles){
        this.privVoiceProfiles = [];
        this.privProfileIds = [];
        $3afpL.Contracts.throwIfNullOrUndefined(profiles, "VoiceProfiles");
        if (profiles.length === 0) throw new Error("Empty Voice Profiles array");
        for (const profile of profiles){
            if (profile.profileType !== $14iyq.VoiceProfileType.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + profile.profileId);
            this.privVoiceProfiles.push(profile);
            this.privProfileIds.push(profile.profileId);
        }
    }
}
module.exports.SpeakerIdentificationModel = $9bd4e1417edaf7cd$var$SpeakerIdentificationModel;

});

parcelRegister("2aXFC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerVerificationModel = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Defines SpeakerVerificationModel class for Speaker Recognition
 * Model contains a profile against which to verify a speaker
 * @class SpeakerVerificationModel
 */ class $195acd3bd6ca5219$var$SpeakerVerificationModel {
    static fromProfile(profile) {
        return new $195acd3bd6ca5219$var$SpeakerVerificationModel(profile);
    }
    get voiceProfile() {
        return this.privVoiceProfile;
    }
    get profileIds() {
        return [
            this.voiceProfile.profileId
        ];
    }
    get scenario() {
        if (this.voiceProfile.profileType === $14iyq.VoiceProfileType.TextDependentVerification) return "TextDependentVerification";
        else return "TextIndependentVerification";
    }
    constructor(profile){
        $3afpL.Contracts.throwIfNullOrUndefined(profile, "VoiceProfile");
        if (profile.profileType === $14iyq.VoiceProfileType.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = profile;
    }
}
module.exports.SpeakerVerificationModel = $195acd3bd6ca5219$var$SpeakerVerificationModel;

});

parcelRegister("dHZMK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageConfig = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $lgher = parcelRequire("lgher");
/**
 * Language auto detect configuration.
 * @class AutoDetectSourceLanguageConfig
 * Added in version 1.13.0.
 */ class $9faf37cdafeabc31$var$AutoDetectSourceLanguageConfig {
    /**
     * @member AutoDetectSourceLanguageConfig.fromOpenRange
     * @function
     * @public
     * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
     * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
     */ static fromOpenRange() {
        const config = new $9faf37cdafeabc31$var$AutoDetectSourceLanguageConfig();
        config.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, $h6sQE.AutoDetectSourceLanguagesOpenRangeOptionName);
        return config;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromLanguages
     * @function
     * @public
     * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
     */ static fromLanguages(languages) {
        $3afpL.Contracts.throwIfArrayEmptyOrWhitespace(languages, "languages");
        const config = new $9faf37cdafeabc31$var$AutoDetectSourceLanguageConfig();
        config.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, languages.join());
        return config;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
     * @function
     * @public
     * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
     */ static fromSourceLanguageConfigs(configs) {
        if (configs.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        const autoConfig = new $9faf37cdafeabc31$var$AutoDetectSourceLanguageConfig();
        const langs = [];
        configs.forEach((config)=>{
            langs.push(config.language);
            if (config.endpointId !== undefined && config.endpointId !== "") {
                const customProperty = config.language + $14iyq.PropertyId.SpeechServiceConnection_EndpointId.toString();
                autoConfig.properties.setProperty(customProperty, config.endpointId);
            }
        });
        autoConfig.properties.setProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, langs.join());
        return autoConfig;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets an auto detected language config properties
     */ get properties() {
        return this.privProperties;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.mode
     * @function
     * @public
     * @param {LanguageIdMode} mode LID mode desired.
     * @summary Sets LID operation to desired mode
     */ set mode(mode) {
        if (mode === $lgher.LanguageIdMode.Continuous) {
            this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
            this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");
        } else {
            this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "1");
            this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        }
        this.privLanguageIdMode = mode;
    }
    constructor(){
        this.privProperties = new $14iyq.PropertyCollection();
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        this.privLanguageIdMode = $lgher.LanguageIdMode.AtStart;
    }
}
module.exports.AutoDetectSourceLanguageConfig = $9faf37cdafeabc31$var$AutoDetectSourceLanguageConfig;

});
parcelRegister("lgher", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageIdMode = void 0;
/**
 * Language Identification mode
 * @class LanguageIdMode
 */ var $f7a8757accfea1d0$var$LanguageIdMode;
(function(LanguageIdMode) {
    /**
     * Detect language at audio start
     * @member LanguageIdMode.AtStart
     */ LanguageIdMode[LanguageIdMode["AtStart"] = 0] = "AtStart";
    /**
     * Continuously detect language
     * @member LanguageIdMode.Continuous
     */ LanguageIdMode[LanguageIdMode["Continuous"] = 1] = "Continuous";
})($f7a8757accfea1d0$var$LanguageIdMode = module.exports.LanguageIdMode || (module.exports.LanguageIdMode = {}));

});


parcelRegister("bMNw6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageResult = void 0;

var $3afpL = parcelRequire("3afpL");
/**
 * Output format
 * @class AutoDetectSourceLanguageResult
 */ class $894a966ca0d1ff11$var$AutoDetectSourceLanguageResult {
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
     * @member AutoDetectSourceLanguageResult.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult} result - The recognition result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ static fromResult(result) {
        return new $894a966ca0d1ff11$var$AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a ConversationTranscriptionResult instance.
     * @member AutoDetectSourceLanguageResult.fromConversationTranscriptionResult
     * @function
     * @public
     * @param {ConversationTranscriptionResult} result - The transcription result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ static fromConversationTranscriptionResult(result) {
        return new $894a966ca0d1ff11$var$AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    }
    get language() {
        return this.privLanguage;
    }
    get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    constructor(language, languageDetectionConfidence){
        $3afpL.Contracts.throwIfNullOrUndefined(language, "language");
        $3afpL.Contracts.throwIfNullOrUndefined(languageDetectionConfidence, "languageDetectionConfidence");
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
    }
}
module.exports.AutoDetectSourceLanguageResult = $894a966ca0d1ff11$var$AutoDetectSourceLanguageResult;

});

parcelRegister("jyZfJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SourceLanguageConfig = void 0;

var $3afpL = parcelRequire("3afpL");
/**
 * Source Language configuration.
 * @class SourceLanguageConfig
 */ class $e3e0b4d28a725ae4$var$SourceLanguageConfig {
    /**
     * @member SourceLanguageConfig.fromLanguage
     * @function
     * @public
     * @param {string} language language (eg. "en-US") value of config.
     * @param {string?} endpointId endpointId of model bound to given language of config.
     * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
     * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
     * Added in version 1.13.0.
     */ static fromLanguage(language, endpointId) {
        return new $e3e0b4d28a725ae4$var$SourceLanguageConfig(language, endpointId);
    }
    get language() {
        return this.privLanguage;
    }
    get endpointId() {
        return this.privEndpointId;
    }
    constructor(language, endpointId){
        $3afpL.Contracts.throwIfNullOrUndefined(language, "language");
        this.privLanguage = language;
        this.privEndpointId = endpointId;
    }
}
module.exports.SourceLanguageConfig = $e3e0b4d28a725ae4$var$SourceLanguageConfig;

});

parcelRegister("aGEDK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionCancellationDetails = module.exports.SpeakerRecognitionResult = module.exports.SpeakerRecognitionResultType = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $14iyq = parcelRequire("14iyq");
var $7c7d59e9ab30be76$var$SpeakerRecognitionResultType;
(function(SpeakerRecognitionResultType) {
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Verify"] = 0] = "Verify";
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Identify"] = 1] = "Identify";
})($7c7d59e9ab30be76$var$SpeakerRecognitionResultType = module.exports.SpeakerRecognitionResultType || (module.exports.SpeakerRecognitionResultType = {}));
/**
 * Output format
 * @class SpeakerRecognitionResult
 */ class $7c7d59e9ab30be76$var$SpeakerRecognitionResult {
    get properties() {
        return this.privProperties;
    }
    get reason() {
        return this.privReason;
    }
    get profileId() {
        return this.privProfileId;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    get score() {
        return this.privScore;
    }
    constructor(response, resultReason = $14iyq.ResultReason.RecognizedSpeaker, cancellationErrorCode = $14iyq.CancellationErrorCode.NoError, errorDetails = ""){
        this.privProperties = new $14iyq.PropertyCollection();
        const resultType = response.scenario === "TextIndependentIdentification" ? $7c7d59e9ab30be76$var$SpeakerRecognitionResultType.Identify : $7c7d59e9ab30be76$var$SpeakerRecognitionResultType.Verify;
        this.privReason = resultReason;
        if (this.privReason !== $14iyq.ResultReason.Canceled) {
            if (resultType === $7c7d59e9ab30be76$var$SpeakerRecognitionResultType.Identify) {
                this.privProfileId = response.identificationResult.identifiedProfile.profileId;
                this.privScore = response.identificationResult.identifiedProfile.score;
                this.privReason = $14iyq.ResultReason.RecognizedSpeakers;
            } else {
                this.privScore = response.verificationResult.score;
                if (response.verificationResult.recognitionResult.toLowerCase() !== "accept") this.privReason = $14iyq.ResultReason.NoMatch;
                if (response.verificationResult.profileId !== undefined && response.verificationResult.profileId !== "") this.privProfileId = response.verificationResult.profileId;
            }
        } else {
            this.privErrorDetails = errorDetails;
            this.privProperties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[cancellationErrorCode]);
        }
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, JSON.stringify(response));
    }
}
module.exports.SpeakerRecognitionResult = $7c7d59e9ab30be76$var$SpeakerRecognitionResult;
/**
 * @class SpeakerRecognitionCancellationDetails
 */ class $7c7d59e9ab30be76$var$SpeakerRecognitionCancellationDetails extends $14iyq.CancellationDetailsBase {
    /**
     * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
     * @member SpeakerRecognitionCancellationDetails.fromResult
     * @function
     * @public
     * @param {SpeakerRecognitionResult} result - The result that was canceled.
     * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = $14iyq.CancellationReason.Error;
        let errorCode = $14iyq.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $14iyq.CancellationErrorCode[result.properties.getProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[$14iyq.CancellationErrorCode.NoError])];
        return new $7c7d59e9ab30be76$var$SpeakerRecognitionCancellationDetails(reason, result.errorDetails, errorCode);
    }
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
}
module.exports.SpeakerRecognitionCancellationDetails = $7c7d59e9ab30be76$var$SpeakerRecognitionCancellationDetails;

});

parcelRegister("1Prr7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2Ghbe = parcelRequire("2Ghbe");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $2Ghbe.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationImpl", {
    enumerable: true,
    get: function() {
        return $2Ghbe.ConversationImpl;
    }
});

var $bWq1n = parcelRequire("bWq1n");
Object.defineProperty(module.exports, "ConversationCommon", {
    enumerable: true,
    get: function() {
        return $bWq1n.ConversationCommon;
    }
});

var $RqZRh = parcelRequire("RqZRh");
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $RqZRh.ConversationExpirationEventArgs;
    }
});

var $6pxIf = parcelRequire("6pxIf");
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $6pxIf.ConversationParticipantsChangedEventArgs;
    }
});

var $b51pq = parcelRequire("b51pq");
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $b51pq.ConversationTranslationCanceledEventArgs;
    }
});

var $apwox = parcelRequire("apwox");
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $apwox.ConversationTranslationEventArgs;
    }
});

var $kfC10 = parcelRequire("kfC10");
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $kfC10.ConversationTranslationResult;
    }
});

var $dar80 = parcelRequire("dar80");
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $dar80.ConversationTranslator;
    }
});

var $bSLS8 = parcelRequire("bSLS8");
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $bSLS8.ConversationTranscriber;
    }
});

var $atb7P = parcelRequire("atb7P");
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $atb7P.Participant;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $atb7P.User;
    }
});

var $jynyX = parcelRequire("jynyX");
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $jynyX.ParticipantChangedReason;
    }
});

var $etElg = parcelRequire("etElg");
Object.defineProperty(module.exports, "Meeting", {
    enumerable: true,
    get: function() {
        return $etElg.Meeting;
    }
});
Object.defineProperty(module.exports, "MeetingImpl", {
    enumerable: true,
    get: function() {
        return $etElg.MeetingImpl;
    }
});

var $z8RSy = parcelRequire("z8RSy");
Object.defineProperty(module.exports, "MeetingTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $z8RSy.MeetingTranscriptionCanceledEventArgs;
    }
});

var $ivf4C = parcelRequire("ivf4C");
Object.defineProperty(module.exports, "MeetingTranscriber", {
    enumerable: true,
    get: function() {
        return $ivf4C.MeetingTranscriber;
    }
});

var $br10d = parcelRequire("br10d");
Object.defineProperty(module.exports, "ConversationTranscriptionResult", {
    enumerable: true,
    get: function() {
        return $br10d.ConversationTranscriptionResult;
    }
});

});
parcelRegister("2Ghbe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationImpl = module.exports.Conversation = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
class $1f3cd4a1debb201e$var$Conversation {
    /**
     * Create a conversation
     * @param speechConfig
     * @param cb
     * @param err
     */ static createConversationAsync(speechConfig, arg2, arg3, arg4) {
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig, $h6sQE.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig.region, $h6sQE.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceAuthorization_Token])) $3afpL.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $h6sQE.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        let conversationImpl;
        let cb;
        let err;
        if (typeof arg2 === "string") {
            conversationImpl = new $1f3cd4a1debb201e$var$ConversationImpl(speechConfig, arg2);
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            $iLPPT.marshalPromiseToCallbacks((async ()=>{})(), arg3, arg4);
        } else {
            conversationImpl = new $1f3cd4a1debb201e$var$ConversationImpl(speechConfig);
            cb = arg2;
            err = arg3;
            conversationImpl.createConversationAsync(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        }
        return conversationImpl;
    }
    constructor(){
        return;
    }
}
module.exports.Conversation = $1f3cd4a1debb201e$var$Conversation;
class $1f3cd4a1debb201e$var$ConversationImpl extends $1f3cd4a1debb201e$var$Conversation {
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer; // this.privConnection;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the conversation Id
    get conversationId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        var _this_privParticipants_me, _this_privParticipants_me1;
        return ((_this_privParticipants_me = this.privParticipants.me) === null || _this_privParticipants_me === void 0 ? void 0 : _this_privParticipants_me.isHost) ? false : (_this_privParticipants_me1 = this.privParticipants.me) === null || _this_privParticipants_me1 === void 0 ? void 0 : _this_privParticipants_me1.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(true);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get conversationInfo() {
        const convId = this.conversationId;
        const p = this.participants.map((part)=>({
                id: part.id,
                preferredLanguage: part.preferredLanguage,
                voice: part.voice
            }));
        const props = {};
        for (const key of $h6sQE.ConversationConnectionConfig.transcriptionEventKeys){
            const val = this.properties.getProperty(key, "");
            if (val !== "") props[key] = val;
        }
        const info = {
            id: convId,
            participants: p,
            conversationProperties: props
        };
        return info;
    }
    get canSend() {
        var _this_privParticipants_me;
        return this.privIsConnected && !((_this_privParticipants_me = this.privParticipants.me) === null || _this_privParticipants_me === void 0 ? void 0 : _this_privParticipants_me.isMuted);
    }
    get canSendAsHost() {
        var _this_privParticipants_me;
        return this.privIsConnected && ((_this_privParticipants_me = this.privParticipants.me) === null || _this_privParticipants_me === void 0 ? void 0 : _this_privParticipants_me.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
        this.privToken = value;
    }
    set conversationTranslator(conversationTranslator) {
        this.privConversationTranslator = conversationTranslator;
    }
    onToken(token) {
        this.privConversationTranslator.onToken(token);
    }
    /**
     * Create a new conversation as Host
     * @param cb
     * @param err
     */ createConversationAsync(cb, err) {
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, (room)=>{
                if (!room) this.handleError(new Error(this.privErrors.permissionDeniedConnect), err);
                this.privRoom = room;
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Starts a new conversation as host.
     * @param cb
     * @param err
     */ startConversationAsync(cb, err) {
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            this.privConversationRecognizer = $h6sQE.ConversationRecognizerFactory.fromConfig(this, this.privConfig);
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Join a conversation as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ addParticipantAsync(participant, cb, err) {
        $3afpL.Contracts.throwIfNullOrUndefined(participant, "Participant");
        $iLPPT.marshalPromiseToCallbacks(this.addParticipantImplAsync(participant), cb, err);
    }
    /**
     * Join a conversation as a participant.
     * @param conversation
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ joinConversationAsync(conversationId, nickname, lang, cb, err) {
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $3afpL.Contracts.throwIfNullOrWhitespace(conversationId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $3afpL.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3afpL.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, conversationId, (room)=>{
                $3afpL.Contracts.throwIfNullOrUndefined(room, this.privErrors.permissionDeniedConnect);
                this.privRoom = room;
                this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Deletes a conversation
     * @param cb
     * @param err
     */ deleteConversationAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.deleteConversationImplAsync(), cb, err);
    }
    async deleteConversationImplAsync() {
        $3afpL.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
        await this.privManager.leave(this.privProperties, this.privRoom.token);
        this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ endConversationAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.endConversationImplAsync(), cb, err);
    }
    endConversationImplAsync() {
        return this.close(true);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ lockConversationAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute the conversation
     * @param cb
     * @param err
     */ muteAllParticipantsAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ muteParticipantAsync(userId, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ removeParticipantAsync(userId, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            $iLPPT.marshalPromiseToCallbacks(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                let participantId = "";
                if (typeof userId === "string") participantId = userId;
                else if (userId.hasOwnProperty("id")) {
                    const participant = userId;
                    participantId = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    const user = userId;
                    participantId = user.userId;
                }
                $3afpL.Contracts.throwIfNullOrWhitespace(participantId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                const index = this.participants.findIndex((p)=>p.id === participantId);
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId), ()=>{
                    this.handleCallback(cb, err);
                }, (error)=>{
                    this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unlock the conversation
     * @param cb
     * @param err
     */ unlockConversationAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute all participants in the conversation
     * @param cb
     * @param err
     */ unmuteAllParticipantsAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ unmuteParticipantAsync(userId, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ setTranslatedLanguagesAsync(languages, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ changeNicknameAsync(nickname, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    }
    async connectTranscriberRecognizer(recognizer) {
        if (!!this.privTranscriberRecognizer) await this.privTranscriberRecognizer.close();
        await recognizer.enforceAudioGating();
        this.privTranscriberRecognizer = recognizer;
        this.privTranscriberRecognizer.conversation = this;
    }
    getKeepAlive() {
        const nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(participant) {
        const newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                const conversationInfo = this.conversationInfo;
                conversationInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "join");
            }
        }
    }
    removeParticipantImplAsync(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        const conversationInfo = this.conversationInfo;
        conversationInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "leave");
    }
    async close(dispose) {
        try {
            var _this_privConversationRecognizer;
            this.privIsConnected = false;
            await ((_this_privConversationRecognizer = this.privConversationRecognizer) === null || _this_privConversationRecognizer === void 0 ? void 0 : _this_privConversationRecognizer.close());
            this.privConversationRecognizer = undefined;
            if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
        } catch (e) {
            // ignore error
            throw e;
        }
        if (dispose) this.dispose();
    }
    /** Helpers */ handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    /** Participant Helpers */ toParticipants(includeHost) {
        const participants = this.privParticipants.participants.map((p)=>this.toParticipant(p));
        if (!includeHost) return participants.filter((p)=>p.isHost === false);
        else return participants;
    }
    toParticipant(p) {
        return new $14iyq.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    }
    getMuteAllCommand(isMuted) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getMuteCommand(participantId, isMuted) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getLockCommand(isLocked) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    }
    getEjectCommand(participantId) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(languages) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    }
    getChangeNicknameCommand(nickname) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    }
    getMessageCommand(message) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $3afpL.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $h6sQE.ConversationTranslatorMessageTypes.instantMessage
        });
    }
    /**
     * Create a conversation impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ constructor(speechConfig, id){
        super();
        this.privErrors = $h6sQE.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ this.onConnected = (e)=>{
            this.privIsConnected = true;
            try {
                var _this_privConversationTranslator;
                if (!!((_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.sessionStarted)) this.privConversationTranslator.sessionStarted(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onDisconnected = (e)=>{
            try {
                var _this_privConversationTranslator;
                if (!!((_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.sessionStopped)) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                this.close(false);
            }
        };
        this.onCanceled = (r, e)=>{
            try {
                var _this_privConversationTranslator;
                if (!!((_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.canceled)) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onParticipantUpdateCommandReceived = (r, e)=>{
            try {
                const updatedParticipant = this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $h6sQE.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.Updated, [
                        this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onLockRoomCommandReceived = ()=>{
        // TODO
        };
        this.onMuteAllCommandReceived = (r, e)=>{
            try {
                this.privParticipants.participants.forEach((p)=>p.isMuted = p.isHost ? false : e.isMuted);
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.Updated, this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        this.onParticipantJoinCommandReceived = (r, e)=>{
            try {
                const newParticipant = this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.JoinedConversation, [
                        this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantLeaveCommandReceived = (r, e)=>{
            try {
                const ejectedParticipant = this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.LeftConversation, [
                        this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onTranslationReceived = (r, e)=>{
            try {
                switch(e.command){
                    case $h6sQE.ConversationTranslatorMessageTypes.final:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribed(this.privConversationTranslator, new $14iyq.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $h6sQE.ConversationTranslatorMessageTypes.partial:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribing(this.privConversationTranslator, new $14iyq.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $h6sQE.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $14iyq.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantsListReceived = (r, e)=>{
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) this.privRoom.token = e.sessionToken;
                // save the participants
                this.privParticipants.participants = [
                    ...e.participants
                ];
                // enable the conversation
                if (this.privParticipants.me !== undefined) this.privIsReady = true;
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.JoinedConversation, this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (this.me.isHost) {
                    var _this_privConversationTranslator;
                    const nickname = (_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.properties.getProperty($14iyq.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== this.me.displayName) // issue a change nickname request
                    this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        this.onConversationExpiration = (r, e)=>{
            try {
                if (!!this.privConversationTranslator) this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.privIsConnected = false;
        this.privIsDisposed = false;
        this.privConversationId = "";
        this.privProperties = new $14iyq.PropertyCollection();
        this.privManager = new $h6sQE.ConversationManager();
        // check the speech language
        const language = speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage], $h6sQE.ConversationConnectionConfig.defaultLanguageCode);
        this.privLanguage = speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!id) {
            // check the target language(s)
            if (speechConfig.targetLanguages.length === 0) speechConfig.addTargetLanguage(this.privLanguage);
            // check the profanity setting: speech and conversationTranslator should be in sync
            const profanity = speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceResponse_ProfanityOption]);
            if (!profanity) speechConfig.setProfanity($14iyq.ProfanityOption.Masked);
            // check the nickname: it should pass this regex: ^\w+([\s-][\w\(\)]+)*$"
            // TODO: specify the regex required. Nicknames must be unique or get the duplicate nickname error
            // TODO: check what the max length is and if a truncation is required or if the service handles it without an error
            let hostNickname = speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.ConversationTranslator_Name]);
            if (hostNickname === undefined || hostNickname === null) hostNickname = "Host";
            $3afpL.Contracts.throwIfNullOrTooLong(hostNickname, "nickname", 50);
            $3afpL.Contracts.throwIfNullOrTooShort(hostNickname, "nickname", 2);
            speechConfig.setProperty($14iyq.PropertyId[$14iyq.PropertyId.ConversationTranslator_Name], hostNickname);
        } else this.privConversationId = id;
        // save the speech config for future usage
        this.privConfig = speechConfig;
        // save the config properties
        const configImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(configImpl, "speechConfig");
        this.privProperties = configImpl.properties.clone();
        this.privIsConnected = false;
        this.privParticipants = new $h6sQE.InternalParticipants();
        this.privIsReady = false;
        this.privTextMessageMaxLength = 1000;
    }
}
module.exports.ConversationImpl = $1f3cd4a1debb201e$var$ConversationImpl;

});

parcelRegister("bWq1n", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationCommon = void 0;
class $8b194bc72b7c063c$var$ConversationCommon {
    handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    constructor(audioConfig){
        this.privAudioConfig = audioConfig;
    }
}
module.exports.ConversationCommon = $8b194bc72b7c063c$var$ConversationCommon;

});

parcelRegister("RqZRh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationExpirationEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
class $0a09e456527f99e1$var$ConversationExpirationEventArgs extends $14iyq.SessionEventArgs {
    /** How much longer until the conversation expires (in minutes). */ get expirationTime() {
        return this.privExpirationTime;
    }
    constructor(expirationTime, sessionId){
        super(sessionId);
        this.privExpirationTime = expirationTime;
    }
}
module.exports.ConversationExpirationEventArgs = $0a09e456527f99e1$var$ConversationExpirationEventArgs;

});

parcelRegister("6pxIf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationParticipantsChangedEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
class $4aaf3a8212b71bc4$var$ConversationParticipantsChangedEventArgs extends $14iyq.SessionEventArgs {
    get reason() {
        return this.privReason;
    }
    get participants() {
        return this.privParticipant;
    }
    constructor(reason, participants, sessionId){
        super(sessionId);
        this.privReason = reason;
        this.privParticipant = participants;
    }
}
module.exports.ConversationParticipantsChangedEventArgs = $4aaf3a8212b71bc4$var$ConversationParticipantsChangedEventArgs;

});

parcelRegister("b51pq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationCanceledEventArgs = void 0;

var $kl0Sn = parcelRequire("kl0Sn");
class $81114125a4f2094a$var$ConversationTranslationCanceledEventArgs extends $kl0Sn.CancellationEventArgsBase {
}
module.exports.ConversationTranslationCanceledEventArgs = $81114125a4f2094a$var$ConversationTranslationCanceledEventArgs;

});

parcelRegister("apwox", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
class $79455e16ad351535$var$ConversationTranslationEventArgs extends $14iyq.RecognitionEventArgs {
    /**
     * Specifies the recognition result.
     * @returns {ConversationTranslationResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranslationResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
}
module.exports.ConversationTranslationEventArgs = $79455e16ad351535$var$ConversationTranslationEventArgs;

});

parcelRegister("kfC10", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationResult = void 0;

var $6KTc5 = parcelRequire("6KTc5");
class $ebe2b2697f54e3ac$var$ConversationTranslationResult extends $6KTc5.TranslationRecognitionResult {
    /**
     * The unique identifier for the participant this result is for.
     */ get participantId() {
        return this.privId;
    }
    /**
     * The original language this result was in.
     */ get originalLang() {
        return this.privOrigLang;
    }
    constructor(participantId, translations, originalLanguage, resultId, reason, text, duration, offset, errorDetails, json, properties){
        super(translations, resultId, reason, text, duration, offset, undefined, undefined, errorDetails, json, properties);
        this.privId = participantId;
        this.privOrigLang = originalLanguage;
    }
}
module.exports.ConversationTranslationResult = $ebe2b2697f54e3ac$var$ConversationTranslationResult;

});

parcelRegister("dar80", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslator = module.exports.SpeechState = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $lSrUQ = parcelRequire("lSrUQ");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $2Ghbe = parcelRequire("2Ghbe");

var $1Prr7 = parcelRequire("1Prr7");
var $9961409d92c09957$var$SpeechState;
(function(SpeechState) {
    SpeechState[SpeechState["Inactive"] = 0] = "Inactive";
    SpeechState[SpeechState["Connecting"] = 1] = "Connecting";
    SpeechState[SpeechState["Connected"] = 2] = "Connected";
})($9961409d92c09957$var$SpeechState = module.exports.SpeechState || (module.exports.SpeechState = {}));
// child class of TranslationRecognizer meant only for use with ConversationTranslator
class $9961409d92c09957$var$ConversationTranslationRecognizer extends $14iyq.TranslationRecognizer {
    get state() {
        return this.privSpeechState;
    }
    set state(newState) {
        this.privSpeechState = newState;
    }
    set authentication(token) {
        this.privReco.authentication = token;
    }
    onConnection() {
        this.privSpeechState = $9961409d92c09957$var$SpeechState.Connected;
    }
    async onCancelSpeech() {
        this.privSpeechState = $9961409d92c09957$var$SpeechState.Inactive;
        await this.cancelSpeech();
    }
    /**
     * Fire a cancel event
     * @param error
     */ fireCancelEvent(error) {
        try {
            if (!!this.privTranslator.canceled) {
                const cancelEvent = new $1Prr7.ConversationTranslationCanceledEventArgs($14iyq.CancellationReason.Error, error, $14iyq.CancellationErrorCode.RuntimeError);
                this.privTranslator.canceled(this.privTranslator, cancelEvent);
            }
        } catch (e) {
        //
        }
    }
    async cancelSpeech() {
        try {
            var _this_privReco;
            this.stopContinuousRecognitionAsync();
            await ((_this_privReco = this.privReco) === null || _this_privReco === void 0 ? void 0 : _this_privReco.disconnect());
            this.privSpeechState = $9961409d92c09957$var$SpeechState.Inactive;
        } catch (e) {
        // ignore the error
        }
    }
    constructor(speechConfig, audioConfig, translator, convGetter){
        super(speechConfig, audioConfig, new $lSrUQ.ConversationTranslatorConnectionFactory(convGetter));
        this.privSpeechState = $9961409d92c09957$var$SpeechState.Inactive;
        if (!!translator) {
            this.privTranslator = translator;
            this.sessionStarted = ()=>{
                this.privSpeechState = $9961409d92c09957$var$SpeechState.Connected;
            };
            this.sessionStopped = ()=>{
                this.privSpeechState = $9961409d92c09957$var$SpeechState.Inactive;
            };
            this.recognizing = (tr, e)=>{
                if (!!this.privTranslator.recognizing) this.privTranslator.recognizing(this.privTranslator, e);
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.recognized = async (tr, e)=>{
                var _e_result;
                // if there is an error connecting to the conversation service from the speech service the error will be returned in the ErrorDetails field.
                if ((_e_result = e.result) === null || _e_result === void 0 ? void 0 : _e_result.errorDetails) {
                    await this.cancelSpeech();
                    // TODO: format the error message contained in 'errorDetails'
                    this.fireCancelEvent(e.result.errorDetails);
                } else if (!!this.privTranslator.recognized) this.privTranslator.recognized(this.privTranslator, e);
                return;
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.canceled = async ()=>{
                if (this.privSpeechState !== $9961409d92c09957$var$SpeechState.Inactive) try {
                    await this.cancelSpeech();
                } catch (error) {
                    this.privSpeechState = $9961409d92c09957$var$SpeechState.Inactive;
                }
            };
        }
    }
}
/**
 * Join, leave or connect to a conversation.
 */ class $9961409d92c09957$var$ConversationTranslator extends $1Prr7.ConversationCommon {
    get properties() {
        return this.privProperties;
    }
    get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    get participants() {
        var _this_privConversation;
        return (_this_privConversation = this.privConversation) === null || _this_privConversation === void 0 ? void 0 : _this_privConversation.participants;
    }
    get canSpeak() {
        // is there a Conversation websocket available and has the Recognizer been set up
        if (!this.privConversation.isConnected || !this.privCTRecognizer) return false;
        // is the user already speaking
        if (this.privIsSpeaking || this.privCTRecognizer.state === $9961409d92c09957$var$SpeechState.Connected || this.privCTRecognizer.state === $9961409d92c09957$var$SpeechState.Connecting) return false;
        // is the user muted
        if (this.privConversation.isMutedByHost) return false;
        return true;
    }
    onToken(token) {
        this.privCTRecognizer.authentication = token;
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty($h6sQE.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($h6sQE.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    joinConversationAsync(conversation, nickname, param1, param2, param3) {
        try {
            if (typeof conversation === "string") {
                $3afpL.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $3afpL.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                if (!!this.privConversation) this.handleError(new Error(this.privErrors.permissionDeniedStart), param3);
                let lang = param1;
                if (lang === undefined || lang === null || lang === "") lang = $h6sQE.ConversationConnectionConfig.defaultLanguageCode;
                // create a placeholder config
                this.privSpeechTranslationConfig = $14iyq.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion);
                this.privSpeechTranslationConfig.setProfanity($14iyq.ProfanityOption.Masked);
                this.privSpeechTranslationConfig.addTargetLanguage(lang);
                this.privSpeechTranslationConfig.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage], lang);
                this.privSpeechTranslationConfig.setProperty($14iyq.PropertyId[$14iyq.PropertyId.ConversationTranslator_Name], nickname);
                const propertyIdsToCopy = [
                    $14iyq.PropertyId.SpeechServiceConnection_Host,
                    $14iyq.PropertyId.ConversationTranslator_Host,
                    $14iyq.PropertyId.SpeechServiceConnection_Endpoint,
                    $14iyq.PropertyId.SpeechServiceConnection_ProxyHostName,
                    $14iyq.PropertyId.SpeechServiceConnection_ProxyPassword,
                    $14iyq.PropertyId.SpeechServiceConnection_ProxyPort,
                    $14iyq.PropertyId.SpeechServiceConnection_ProxyUserName,
                    "ConversationTranslator_MultiChannelAudio",
                    "ConversationTranslator_Region"
                ];
                for (const prop of propertyIdsToCopy){
                    const value = this.privProperties.getProperty(prop);
                    if (value) {
                        const key = typeof prop === "string" ? prop : $14iyq.PropertyId[prop];
                        this.privSpeechTranslationConfig.setProperty(key, value);
                    }
                }
                const currentProperties = JSON.parse(this.privProperties.getProperty($h6sQE.ServicePropertiesPropertyName, "{}"));
                for (const prop of Object.keys(currentProperties))this.privSpeechTranslationConfig.setServiceProperty(prop, currentProperties[prop], $14iyq.ServicePropertyChannel.UriQueryParameter);
                // join the conversation
                this.privConversation = new $2Ghbe.ConversationImpl(this.privSpeechTranslationConfig);
                this.privConversation.conversationTranslator = this;
                this.privConversation.joinConversationAsync(conversation, nickname, lang, (result)=>{
                    if (!result) this.handleError(new Error(this.privErrors.permissionDeniedConnect), param3);
                    this.privSpeechTranslationConfig.authorizationToken = result;
                    this.privConversation.room.isHost = false;
                    // connect to the ws
                    this.privConversation.startConversationAsync(()=>{
                        this.handleCallback(param2, param3);
                    }, (error)=>{
                        this.handleError(error, param3);
                    });
                }, (error)=>{
                    this.handleError(error, param3);
                });
            } else if (typeof conversation === "object") {
                $3afpL.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $3afpL.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                // save the nickname
                this.privProperties.setProperty($14iyq.PropertyId.ConversationTranslator_Name, nickname);
                // ref the conversation object
                this.privConversation = conversation;
                // ref the conversation translator object
                this.privConversation.conversationTranslator = this;
                this.privConversation.room.isHost = true;
                $3afpL.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect);
                $3afpL.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                this.privSpeechTranslationConfig = conversation.config;
                this.handleCallback(param1, param2);
            } else this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), param2);
        } catch (error) {
            this.handleError(error, typeof param1 === "string" ? param3 : param2);
        }
    }
    /**
     * Leave the conversation
     * @param cb
     * @param err
     */ leaveConversationAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks((async ()=>{
            // stop the speech websocket
            await this.cancelSpeech();
            // stop the websocket
            await this.privConversation.endConversationImplAsync();
            // https delete request
            await this.privConversation.deleteConversationImplAsync();
            this.dispose();
        })(), cb, err);
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $3afpL.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
            $3afpL.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", message));
            this.privConversation.sendTextMessageAsync(message, cb, err);
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Start speaking
     * @param cb
     * @param err
     */ startTranscribingAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks((async ()=>{
            try {
                $3afpL.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
                $3afpL.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                if (this.privCTRecognizer === undefined) await this.connectTranslatorRecognizer();
                $3afpL.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend);
                if (!this.canSpeak) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
                await this.startContinuousRecognition();
                this.privIsSpeaking = true;
            } catch (error) {
                this.privIsSpeaking = false;
                await this.cancelSpeech();
                throw error;
            }
        })(), cb, err);
    }
    /**
     * Stop speaking
     * @param cb
     * @param err
     */ stopTranscribingAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks((async ()=>{
            try {
                if (!this.privIsSpeaking) {
                    // stop speech
                    await this.cancelSpeech();
                    return;
                }
                // stop the recognition but leave the websocket open
                this.privIsSpeaking = false;
                await new Promise((resolve, reject)=>{
                    this.privCTRecognizer.stopContinuousRecognitionAsync(resolve, reject);
                });
            } catch (error) {
                await this.cancelSpeech();
            }
        })(), cb, err);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason, success, err) {
        $iLPPT.marshalPromiseToCallbacks((async ()=>{
            if (this.isDisposed && !this.privIsSpeaking) return;
            await this.cancelSpeech();
            this.privIsDisposed = true;
            this.privSpeechTranslationConfig.close();
            this.privSpeechRecognitionLanguage = undefined;
            this.privProperties = undefined;
            this.privAudioConfig = undefined;
            this.privSpeechTranslationConfig = undefined;
            this.privConversation.dispose();
            this.privConversation = undefined;
        })(), success, err);
    }
    /**
     * Cancel the speech websocket
     */ async cancelSpeech() {
        try {
            var _this_privCTRecognizer;
            this.privIsSpeaking = false;
            await ((_this_privCTRecognizer = this.privCTRecognizer) === null || _this_privCTRecognizer === void 0 ? void 0 : _this_privCTRecognizer.onCancelSpeech());
            this.privCTRecognizer = undefined;
        } catch (e) {
        // ignore the error
        }
    }
    /**
     * Connect to the speech translation recognizer.
     * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
     * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
     * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
     */ async connectTranslatorRecognizer() {
        try {
            if (this.privAudioConfig === undefined) this.privAudioConfig = $14iyq.AudioConfig.fromDefaultMicrophoneInput();
            // clear the temp subscription key if it's a participant joining
            if (this.privSpeechTranslationConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey) this.privSpeechTranslationConfig.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_Key], "");
            const convGetter = ()=>this.privConversation;
            this.privCTRecognizer = new $9961409d92c09957$var$ConversationTranslationRecognizer(this.privSpeechTranslationConfig, this.privAudioConfig, this, convGetter);
        } catch (error) {
            await this.cancelSpeech();
            throw error;
        }
    }
    /**
     * Handle the start speaking request
     */ startContinuousRecognition() {
        return new Promise((resolve, reject)=>{
            this.privCTRecognizer.startContinuousRecognitionAsync(resolve, reject);
        });
    }
    constructor(audioConfig){
        super(audioConfig);
        this.privErrors = $h6sQE.ConversationConnectionConfig.restErrors;
        this.privIsDisposed = false;
        this.privIsSpeaking = false;
        this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345";
        this.privPlaceholderRegion = "westus";
        this.privProperties = new $14iyq.PropertyCollection();
    }
}
module.exports.ConversationTranslator = $9961409d92c09957$var$ConversationTranslator;

});
parcelRegister("lSrUQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $Ay9jt = parcelRequire("Ay9jt");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");
/**
 * Connection factory for the conversation translator. Handles connecting to the regular translator endpoint,
 * as well as the virtual microphone array transcription endpoint
 */ class $fed44ba5e2f41440$var$ConversationTranslatorConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const isVirtMicArrayEndpoint = config.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE";
        const convInfo = this.privConvGetter().room;
        const region = convInfo.cognitiveSpeechRegion || config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region, "");
        const replacementValues = {
            hostSuffix: $6wf4H.ConnectionFactoryBase.getHostSuffix(region),
            path: $fed44ba5e2f41440$var$ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH,
            region: encodeURIComponent(region)
        };
        replacementValues[$dq5v3.QueryParameterNames.Language] = encodeURIComponent(config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, ""));
        replacementValues[$dq5v3.QueryParameterNames.CtsMeetingId] = encodeURIComponent(convInfo.roomId);
        replacementValues[$dq5v3.QueryParameterNames.CtsDeviceId] = encodeURIComponent(convInfo.participantId);
        replacementValues[$dq5v3.QueryParameterNames.CtsIsParticipant] = convInfo.isHost ? "" : "&" + $dq5v3.QueryParameterNames.CtsIsParticipant;
        let endpointUrl = "";
        const queryParams = {};
        const headers = {};
        if (isVirtMicArrayEndpoint) {
            // connecting to the conversation transcription virtual microphone array endpoint
            endpointUrl = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint);
            if (!endpointUrl) {
                const hostName = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}");
                endpointUrl = "wss://" + hostName + "{path}";
            }
            // because the region can change during a session, we support being passed a format string which we can then
            // replace with the correct information.
            endpointUrl = $Ay9jt.StringUtils.formatString(endpointUrl, replacementValues);
            const parsedUrl = new URL(endpointUrl);
            parsedUrl.searchParams.forEach((val, key)=>{
                queryParams[key] = val;
            });
            const connFactory = new $h6sQE.TranscriberConnectionFactory();
            connFactory.setQueryParams(queryParams, config, endpointUrl);
            // Some query parameters are required for the CTS endpoint, let's explicity set them here
            queryParams[$dq5v3.QueryParameterNames.CtsMeetingId] = replacementValues[$dq5v3.QueryParameterNames.CtsMeetingId];
            queryParams[$dq5v3.QueryParameterNames.CtsDeviceId] = replacementValues[$dq5v3.QueryParameterNames.CtsDeviceId];
            if (!convInfo.isHost) queryParams[$dq5v3.QueryParameterNames.CtsIsParticipant] = ""; // this doesn't have a value so set to an empty string
            if (!($dq5v3.QueryParameterNames.Format in queryParams)) queryParams[$dq5v3.QueryParameterNames.Format] = "simple";
            parsedUrl.searchParams.forEach((val, key)=>{
                parsedUrl.searchParams.set(key, queryParams[key]);
                delete queryParams[key];
            });
            endpointUrl = parsedUrl.toString();
        } else {
            // connecting to regular translation endpoint
            const connFactory = new $h6sQE.TranslationConnectionFactory();
            endpointUrl = connFactory.getEndpointUrl(config, true);
            endpointUrl = $Ay9jt.StringUtils.formatString(endpointUrl, replacementValues);
            connFactory.setQueryParams(queryParams, config, endpointUrl);
        }
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        headers[$1JzGB.RestConfigBase.configParams.token] = convInfo.token;
        if (!!authInfo.token) headers[authInfo.headerName] = authInfo.token;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
        return new $1JzGB.WebsocketConnection(endpointUrl, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    constructor(convGetter){
        super();
        $3afpL.Contracts.throwIfNullOrUndefined(convGetter, "convGetter");
        this.privConvGetter = convGetter;
    }
}
module.exports.ConversationTranslatorConnectionFactory = $fed44ba5e2f41440$var$ConversationTranslatorConnectionFactory;
$fed44ba5e2f41440$var$ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio";

});
parcelRegister("Ay9jt", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StringUtils = void 0;
/**
 * String helper functions
 */ class $06ddda3ac04ef2df$var$StringUtils {
    /**
     * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
     * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
     * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
     * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
     * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
     */ static formatString(format, replacements) {
        if (!format) return "";
        if (!replacements) return format;
        let formatted = "";
        let key = "";
        const appendToFormatted = (str)=>{
            formatted += str;
        };
        const appendToKey = (str)=>{
            key += str;
        };
        let appendFunc = appendToFormatted;
        for(let i = 0; i < format.length; i++){
            const c = format[i];
            const next = i + 1 < format.length ? format[i + 1] : "";
            switch(c){
                case "{":
                    if (next === "{") {
                        appendFunc("{");
                        i++;
                    } else appendFunc = appendToKey;
                    break;
                case "}":
                    if (next === "}") {
                        appendFunc("}");
                        i++;
                    } else {
                        if (replacements.hasOwnProperty(key)) formatted += replacements[key];
                        appendFunc = appendToFormatted;
                        key = "";
                    }
                    break;
                default:
                    appendFunc(c);
                    break;
            }
        }
        return formatted;
    }
}
module.exports.StringUtils = $06ddda3ac04ef2df$var$StringUtils;

});



parcelRegister("bSLS8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriber = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Performs speech recognition with speaker separation from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class ConversationTranscriber
 */ class $8a69df488de5d8a9$var$ConversationTranscriber extends $14iyq.Recognizer {
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $8a69df488de5d8a9$var$ConversationTranscriber(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for transcription.
     * @member ConversationTranscriber.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of transcription.
     * @member ConversationTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of transcription.
     */ get speechRecognitionLanguage() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of transcription.
     * @member ConversationTranscriber.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of transcription.
     */ get outputFormat() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) === $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) return $14iyq.OutputFormat.Simple;
        else return $14iyq.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this conversation transcriber.
     * @member ConversationTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ startTranscribingAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($h6sQE.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops conversation transcription.
     * @member ConversationTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopTranscribingAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member ConversationTranscriber.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        recognizerConfig.isSpeakerDiarizationEnabled = true;
        return new $h6sQE.ConversationTranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $3afpL.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage), $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new $h6sQE.ConversationTranscriberConnectionFactory());
        this.privProperties.setProperty($14iyq.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
        this.privDisposedRecognizer = false;
    }
}
module.exports.ConversationTranscriber = $8a69df488de5d8a9$var$ConversationTranscriber;

});

parcelRegister("atb7P", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Participant = module.exports.User = void 0;

var $14iyq = parcelRequire("14iyq");
class $79f53e09f598c294$var$User {
    get userId() {
        return this.privUserId;
    }
    constructor(userId){
        this.privUserId = userId;
    }
}
module.exports.User = $79f53e09f598c294$var$User;
class $79f53e09f598c294$var$Participant {
    get avatar() {
        return this.privAvatar;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get id() {
        return this.privId;
    }
    get preferredLanguage() {
        return this.privPreferredLanguage;
    }
    get isHost() {
        return this.privIsHost;
    }
    get isMuted() {
        return this.privIsMuted;
    }
    get isUsingTts() {
        return this.privIsUsingTts;
    }
    get voice() {
        return this.privVoice;
    }
    get properties() {
        return this.privProperties;
    }
    static From(id, language, voice) {
        return new $79f53e09f598c294$var$Participant(id, "", id, false, false, false, language, voice);
    }
    constructor(id, avatar, displayName, isHost, isMuted, isUsingTts, preferredLanguage, voice){
        this.privId = id;
        this.privAvatar = avatar;
        this.privDisplayName = displayName;
        this.privIsHost = isHost;
        this.privIsMuted = isMuted;
        this.privIsUsingTts = isUsingTts;
        this.privPreferredLanguage = preferredLanguage;
        this.privVoice = voice;
        this.privProperties = new $14iyq.PropertyCollection();
    }
}
module.exports.Participant = $79f53e09f598c294$var$Participant;

});

parcelRegister("jynyX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantChangedReason = void 0;
var $03ac716cdef95684$var$ParticipantChangedReason;
(function(ParticipantChangedReason) {
    /** Participant has joined the conversation. */ ParticipantChangedReason[ParticipantChangedReason["JoinedConversation"] = 0] = "JoinedConversation";
    /** Participant has left the conversation. This could be voluntary, or involuntary
     * (e.g. they are experiencing networking issues).
     */ ParticipantChangedReason[ParticipantChangedReason["LeftConversation"] = 1] = "LeftConversation";
    /** The participants' state has changed (e.g. they became muted, changed their nickname). */ ParticipantChangedReason[ParticipantChangedReason["Updated"] = 2] = "Updated";
})($03ac716cdef95684$var$ParticipantChangedReason = module.exports.ParticipantChangedReason || (module.exports.ParticipantChangedReason = {}));

});

parcelRegister("etElg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingImpl = module.exports.Meeting = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
class $a8a31138a399a450$var$Meeting {
    /**
     * Create a meeting
     * @param speechConfig
     * @param meetingId
     * @param cb
     * @param err
     */ static createMeetingAsync(speechConfig, meetingId, arg3, arg4) {
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig, $h6sQE.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $3afpL.Contracts.throwIfNullOrUndefined(speechConfig.region, $h6sQE.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        $3afpL.Contracts.throwIfNull(meetingId, "meetingId");
        if (meetingId.length === 0) throw new Error("meetingId cannot be empty");
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceAuthorization_Token])) $3afpL.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $h6sQE.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        const meetingImpl = new $a8a31138a399a450$var$MeetingImpl(speechConfig, meetingId);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        $iLPPT.marshalPromiseToCallbacks((async ()=>{})(), arg3, arg4);
        return meetingImpl;
    }
    constructor(){
        return;
    }
}
module.exports.Meeting = $a8a31138a399a450$var$Meeting;
class $a8a31138a399a450$var$MeetingImpl extends $a8a31138a399a450$var$Meeting {
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer; // this.privConnection;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the meeting Id
    get meetingId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        var _this_privParticipants_me, _this_privParticipants_me1;
        return ((_this_privParticipants_me = this.privParticipants.me) === null || _this_privParticipants_me === void 0 ? void 0 : _this_privParticipants_me.isHost) ? false : (_this_privParticipants_me1 = this.privParticipants.me) === null || _this_privParticipants_me1 === void 0 ? void 0 : _this_privParticipants_me1.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(true);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get meetingInfo() {
        const convId = this.meetingId;
        const p = this.participants.map((part)=>({
                id: part.id,
                preferredLanguage: part.preferredLanguage,
                voice: part.voice
            }));
        const props = {};
        for (const key of $h6sQE.ConversationConnectionConfig.transcriptionEventKeys){
            const val = this.properties.getProperty(key, "");
            if (val !== "") props[key] = val;
        }
        const info = {
            id: convId,
            participants: p,
            meetingProperties: props
        };
        return info;
    }
    get canSend() {
        var _this_privParticipants_me;
        return this.privIsConnected && !((_this_privParticipants_me = this.privParticipants.me) === null || _this_privParticipants_me === void 0 ? void 0 : _this_privParticipants_me.isMuted);
    }
    get canSendAsHost() {
        var _this_privParticipants_me;
        return this.privIsConnected && ((_this_privParticipants_me = this.privParticipants.me) === null || _this_privParticipants_me === void 0 ? void 0 : _this_privParticipants_me.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(value) {
        $3afpL.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
        this.privToken = value;
    }
    /**
     * Create a new meeting as Host
     * @param cb
     * @param err
     */ createMeetingAsync(cb, err) {
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, (room)=>{
                if (!room) this.handleError(new Error(this.privErrors.permissionDeniedConnect), err);
                this.privRoom = room;
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Starts a new meeting as host.
     * @param cb
     * @param err
     */ startMeetingAsync(cb, err) {
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Join a meeting as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ addParticipantAsync(participant, cb, err) {
        $3afpL.Contracts.throwIfNullOrUndefined(participant, "Participant");
        $iLPPT.marshalPromiseToCallbacks(this.addParticipantImplAsync(participant), cb, err);
    }
    /**
     * Join a meeting as a participant.
     * @param meeting
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ joinMeetingAsync(meetingId, nickname, lang, cb, err) {
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $3afpL.Contracts.throwIfNullOrWhitespace(meetingId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $3afpL.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3afpL.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, meetingId, (room)=>{
                $3afpL.Contracts.throwIfNullOrUndefined(room, this.privErrors.permissionDeniedConnect);
                this.privRoom = room;
                this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Deletes a meeting
     * @param cb
     * @param err
     */ deleteMeetingAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.deleteMeetingImplAsync(), cb, err);
    }
    async deleteMeetingImplAsync() {
        $3afpL.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
        await this.privManager.leave(this.privProperties, this.privRoom.token);
        this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ endMeetingAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.endMeetingImplAsync(), cb, err);
    }
    endMeetingImplAsync() {
        return this.close(true);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ lockMeetingAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute the meeting
     * @param cb
     * @param err
     */ muteAllParticipantsAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */ muteParticipantAsync(userId, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ removeParticipantAsync(userId, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            $iLPPT.marshalPromiseToCallbacks(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                let participantId = "";
                if (typeof userId === "string") participantId = userId;
                else if (userId.hasOwnProperty("id")) {
                    const participant = userId;
                    participantId = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    const user = userId;
                    participantId = user.userId;
                }
                $3afpL.Contracts.throwIfNullOrWhitespace(participantId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                const index = this.participants.findIndex((p)=>p.id === participantId);
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId), ()=>{
                    this.handleCallback(cb, err);
                }, (error)=>{
                    this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unlock the meeting
     * @param cb
     * @param err
     */ unlockMeetingAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute all participants in the meeting
     * @param cb
     * @param err
     */ unmuteAllParticipantsAsync(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */ unmuteParticipantAsync(userId, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ setTranslatedLanguagesAsync(languages, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ changeNicknameAsync(nickname, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3afpL.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3afpL.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    }
    async connectTranscriberRecognizer(recognizer) {
        if (!!this.privTranscriberRecognizer) await this.privTranscriberRecognizer.close();
        await recognizer.enforceAudioGating();
        this.privTranscriberRecognizer = recognizer;
        this.privTranscriberRecognizer.meeting = this;
    }
    getKeepAlive() {
        const nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(participant) {
        const newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                const meetingInfo = this.meetingInfo;
                meetingInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushMeetingEvent(meetingInfo, "join");
            }
        }
    }
    removeParticipantImplAsync(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        const meetingInfo = this.meetingInfo;
        meetingInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushMeetingEvent(meetingInfo, "leave");
    }
    async close(dispose) {
        try {
            var _this_privConversationRecognizer;
            this.privIsConnected = false;
            await ((_this_privConversationRecognizer = this.privConversationRecognizer) === null || _this_privConversationRecognizer === void 0 ? void 0 : _this_privConversationRecognizer.close());
            this.privConversationRecognizer = undefined;
            if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
        } catch (e) {
            // ignore error
            throw e;
        }
        if (dispose) this.dispose();
    }
    /** Helpers */ handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    /** Participant Helpers */ toParticipants(includeHost) {
        const participants = this.privParticipants.participants.map((p)=>this.toParticipant(p));
        if (!includeHost) return participants.filter((p)=>p.isHost === false);
        else return participants;
    }
    toParticipant(p) {
        return new $14iyq.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    }
    getMuteAllCommand(isMuted) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingd");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getMuteCommand(participantId, isMuted) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3afpL.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getLockCommand(isLocked) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    }
    getEjectCommand(participantId) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3afpL.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(languages) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    }
    getChangeNicknameCommand(nickname) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3afpL.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $h6sQE.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $h6sQE.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    }
    getMessageCommand(message) {
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3afpL.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $3afpL.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $h6sQE.ConversationTranslatorMessageTypes.instantMessage
        });
    }
    /**
     * Create a Meeting impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ constructor(speechConfig, id){
        super();
        this.privErrors = $h6sQE.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ this.onConnected = (e)=>{
            this.privIsConnected = true;
            try {
                var _this_privConversationTranslator;
                if (!!((_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.sessionStarted)) this.privConversationTranslator.sessionStarted(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onDisconnected = (e)=>{
            try {
                var _this_privConversationTranslator;
                if (!!((_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.sessionStopped)) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                this.close(false);
            }
        };
        this.onCanceled = (r, e)=>{
            try {
                var _this_privConversationTranslator;
                if (!!((_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.canceled)) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onParticipantUpdateCommandReceived = (r, e)=>{
            try {
                const updatedParticipant = this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $h6sQE.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $h6sQE.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.Updated, [
                        this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onLockRoomCommandReceived = ()=>{
        // TODO
        };
        this.onMuteAllCommandReceived = (r, e)=>{
            try {
                this.privParticipants.participants.forEach((p)=>p.isMuted = p.isHost ? false : e.isMuted);
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.Updated, this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        this.onParticipantJoinCommandReceived = (r, e)=>{
            try {
                const newParticipant = this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.JoinedConversation, [
                        this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantLeaveCommandReceived = (r, e)=>{
            try {
                const ejectedParticipant = this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.LeftConversation, [
                        this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onTranslationReceived = (r, e)=>{
            try {
                switch(e.command){
                    case $h6sQE.ConversationTranslatorMessageTypes.final:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribed(this.privConversationTranslator, new $14iyq.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $h6sQE.ConversationTranslatorMessageTypes.partial:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribing(this.privConversationTranslator, new $14iyq.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $h6sQE.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $14iyq.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantsListReceived = (r, e)=>{
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) this.privRoom.token = e.sessionToken;
                // save the participants
                this.privParticipants.participants = [
                    ...e.participants
                ];
                // enable the conversation
                if (this.privParticipants.me !== undefined) this.privIsReady = true;
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $14iyq.ConversationParticipantsChangedEventArgs($14iyq.ParticipantChangedReason.JoinedConversation, this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (this.me.isHost) {
                    var _this_privConversationTranslator;
                    const nickname = (_this_privConversationTranslator = this.privConversationTranslator) === null || _this_privConversationTranslator === void 0 ? void 0 : _this_privConversationTranslator.properties.getProperty($14iyq.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== this.me.displayName) // issue a change nickname request
                    this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        this.onConversationExpiration = (r, e)=>{
            try {
                if (!!this.privConversationTranslator) this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.privIsConnected = false;
        this.privIsDisposed = false;
        this.privConversationId = "";
        this.privProperties = new $14iyq.PropertyCollection();
        this.privManager = new $h6sQE.ConversationManager();
        // check the speech language
        const language = speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage], $h6sQE.ConversationConnectionConfig.defaultLanguageCode);
        this.privLanguage = speechConfig.getProperty($14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        this.privConversationId = id;
        // save the speech config for future usage
        this.privConfig = speechConfig;
        // save the config properties
        const configImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(configImpl, "speechConfig");
        this.privProperties = configImpl.properties.clone();
        this.privIsConnected = false;
        this.privParticipants = new $h6sQE.InternalParticipants();
        this.privIsReady = false;
        this.privTextMessageMaxLength = 1000;
    }
}
module.exports.MeetingImpl = $a8a31138a399a450$var$MeetingImpl;

});

parcelRegister("z8RSy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionCanceledEventArgs = void 0;

var $kl0Sn = parcelRequire("kl0Sn");
class $069a2600a093bfb6$var$MeetingTranscriptionCanceledEventArgs extends $kl0Sn.CancellationEventArgsBase {
}
module.exports.MeetingTranscriptionCanceledEventArgs = $069a2600a093bfb6$var$MeetingTranscriptionCanceledEventArgs;

});

parcelRegister("ivf4C", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriber = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $1Prr7 = parcelRequire("1Prr7");
class $d786d08727fe1cd1$var$MeetingTranscriber {
    /**
     * Gets the spoken language of recognition.
     * @member MeetingTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * The collection of properties and their values defined for this MeetingTranscriber.
     * @member MeetingTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this MeetingTranscriber.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privRecognizer.internalData;
    }
    /**
     * @Deprecated
     * @Obsolete
     * Please use the Connection.fromRecognizer pattern to obtain a connection object
     */ get connection() {
        return $14iyq.Connection.fromRecognizer(this.privRecognizer);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * @param {Meeting} meeting - meeting to be recognized
     */ joinMeetingAsync(meeting, cb, err) {
        /* eslint-disable no-console */ // console.log(">> MeetingTranscriber::joinMeetingAsync");
        /* eslint-enable no-console */ const meetingImpl = meeting;
        $3afpL.Contracts.throwIfNullOrUndefined($1Prr7.MeetingImpl, "Meeting");
        // ref the meeting object
        // create recognizer and subscribe to recognizer events
        this.privRecognizer = new $h6sQE.TranscriberRecognizer(meeting.config, this.privAudioConfig);
        $3afpL.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer");
        this.privRecognizer.connectMeetingCallbacks(this);
        $iLPPT.marshalPromiseToCallbacks(meetingImpl.connectTranscriberRecognizer(this.privRecognizer), cb, err);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ startTranscribingAsync(cb, err) {
        this.privRecognizer.startContinuousRecognitionAsync(cb, err);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ stopTranscribingAsync(cb, err) {
        this.privRecognizer.stopContinuousRecognitionAsync(cb, err);
    }
    /**
     * Leave the current meeting. After this is called, you will no longer receive any events.
     */ leaveMeetingAsync(cb, err) {
        this.privRecognizer.disconnectCallbacks();
        // eslint-disable-next-line
        $iLPPT.marshalPromiseToCallbacks((async ()=>{
            return;
        })(), cb, err);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member MeetingTranscriber.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member MeetingTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (!!this.privRecognizer) {
            await this.privRecognizer.close();
            this.privRecognizer = undefined;
        }
        if (disposing) this.privDisposedRecognizer = true;
    }
    /**
     * MeetingTranscriber constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(audioConfig){
        this.privAudioConfig = audioConfig;
        this.privProperties = new $14iyq.PropertyCollection();
        this.privRecognizer = undefined;
        this.privDisposedRecognizer = false;
    }
}
module.exports.MeetingTranscriber = $d786d08727fe1cd1$var$MeetingTranscriber;

});

parcelRegister("br10d", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines result of conversation transcription.
 * @class ConversationTranscriptionResult
 */ class $8532fe66ccf20dc9$var$ConversationTranscriptionResult extends $14iyq.RecognitionResult {
    /**
     * speaker id
     * @member ConversationTranscriptionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
}
module.exports.ConversationTranscriptionResult = $8532fe66ccf20dc9$var$ConversationTranscriptionResult;

});


parcelRegister("aPoyg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRequest = module.exports.Synthesizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
class $7e21b639504638aa$var$Synthesizer {
    /**
     * Gets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this Synthesizer.
     * @member Synthesizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Indicates if auto detect source language is enabled
     * @member Synthesizer.prototype.autoDetectSourceLanguage
     * @function
     * @public
     * @returns {boolean} if auto detect source language is enabled
     */ get autoDetectSourceLanguage() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === $h6sQE.AutoDetectSourceLanguagesOpenRangeOptionName;
    }
    buildSsml(text) {
        const languageToDefaultVoice = {
            ["af-ZA"]: "af-ZA-AdriNeural",
            ["am-ET"]: "am-ET-AmehaNeural",
            ["ar-AE"]: "ar-AE-FatimaNeural",
            ["ar-BH"]: "ar-BH-AliNeural",
            ["ar-DZ"]: "ar-DZ-AminaNeural",
            ["ar-EG"]: "ar-EG-SalmaNeural",
            ["ar-IQ"]: "ar-IQ-BasselNeural",
            ["ar-JO"]: "ar-JO-SanaNeural",
            ["ar-KW"]: "ar-KW-FahedNeural",
            ["ar-LY"]: "ar-LY-ImanNeural",
            ["ar-MA"]: "ar-MA-JamalNeural",
            ["ar-QA"]: "ar-QA-AmalNeural",
            ["ar-SA"]: "ar-SA-HamedNeural",
            ["ar-SY"]: "ar-SY-AmanyNeural",
            ["ar-TN"]: "ar-TN-HediNeural",
            ["ar-YE"]: "ar-YE-MaryamNeural",
            ["bg-BG"]: "bg-BG-BorislavNeural",
            ["bn-BD"]: "bn-BD-NabanitaNeural",
            ["bn-IN"]: "bn-IN-BashkarNeural",
            ["ca-ES"]: "ca-ES-JoanaNeural",
            ["cs-CZ"]: "cs-CZ-AntoninNeural",
            ["cy-GB"]: "cy-GB-AledNeural",
            ["da-DK"]: "da-DK-ChristelNeural",
            ["de-AT"]: "de-AT-IngridNeural",
            ["de-CH"]: "de-CH-JanNeural",
            ["de-DE"]: "de-DE-KatjaNeural",
            ["el-GR"]: "el-GR-AthinaNeural",
            ["en-AU"]: "en-AU-NatashaNeural",
            ["en-CA"]: "en-CA-ClaraNeural",
            ["en-GB"]: "en-GB-LibbyNeural",
            ["en-HK"]: "en-HK-SamNeural",
            ["en-IE"]: "en-IE-ConnorNeural",
            ["en-IN"]: "en-IN-NeerjaNeural",
            ["en-KE"]: "en-KE-AsiliaNeural",
            ["en-NG"]: "en-NG-AbeoNeural",
            ["en-NZ"]: "en-NZ-MitchellNeural",
            ["en-PH"]: "en-PH-JamesNeural",
            ["en-SG"]: "en-SG-LunaNeural",
            ["en-TZ"]: "en-TZ-ElimuNeural",
            ["en-US"]: "en-US-AvaMultilingualNeural",
            ["en-ZA"]: "en-ZA-LeahNeural",
            ["es-AR"]: "es-AR-ElenaNeural",
            ["es-BO"]: "es-BO-MarceloNeural",
            ["es-CL"]: "es-CL-CatalinaNeural",
            ["es-CO"]: "es-CO-GonzaloNeural",
            ["es-CR"]: "es-CR-JuanNeural",
            ["es-CU"]: "es-CU-BelkysNeural",
            ["es-DO"]: "es-DO-EmilioNeural",
            ["es-EC"]: "es-EC-AndreaNeural",
            ["es-ES"]: "es-ES-AlvaroNeural",
            ["es-GQ"]: "es-GQ-JavierNeural",
            ["es-GT"]: "es-GT-AndresNeural",
            ["es-HN"]: "es-HN-CarlosNeural",
            ["es-MX"]: "es-MX-DaliaNeural",
            ["es-NI"]: "es-NI-FedericoNeural",
            ["es-PA"]: "es-PA-MargaritaNeural",
            ["es-PE"]: "es-PE-AlexNeural",
            ["es-PR"]: "es-PR-KarinaNeural",
            ["es-PY"]: "es-PY-MarioNeural",
            ["es-SV"]: "es-SV-LorenaNeural",
            ["es-US"]: "es-US-AlonsoNeural",
            ["es-UY"]: "es-UY-MateoNeural",
            ["es-VE"]: "es-VE-PaolaNeural",
            ["et-EE"]: "et-EE-AnuNeural",
            ["fa-IR"]: "fa-IR-DilaraNeural",
            ["fi-FI"]: "fi-FI-SelmaNeural",
            ["fil-PH"]: "fil-PH-AngeloNeural",
            ["fr-BE"]: "fr-BE-CharlineNeural",
            ["fr-CA"]: "fr-CA-SylvieNeural",
            ["fr-CH"]: "fr-CH-ArianeNeural",
            ["fr-FR"]: "fr-FR-DeniseNeural",
            ["ga-IE"]: "ga-IE-ColmNeural",
            ["gl-ES"]: "gl-ES-RoiNeural",
            ["gu-IN"]: "gu-IN-DhwaniNeural",
            ["he-IL"]: "he-IL-AvriNeural",
            ["hi-IN"]: "hi-IN-MadhurNeural",
            ["hr-HR"]: "hr-HR-GabrijelaNeural",
            ["hu-HU"]: "hu-HU-NoemiNeural",
            ["id-ID"]: "id-ID-ArdiNeural",
            ["is-IS"]: "is-IS-GudrunNeural",
            ["it-IT"]: "it-IT-IsabellaNeural",
            ["ja-JP"]: "ja-JP-NanamiNeural",
            ["jv-ID"]: "jv-ID-DimasNeural",
            ["kk-KZ"]: "kk-KZ-AigulNeural",
            ["km-KH"]: "km-KH-PisethNeural",
            ["kn-IN"]: "kn-IN-GaganNeural",
            ["ko-KR"]: "ko-KR-SunHiNeural",
            ["lo-LA"]: "lo-LA-ChanthavongNeural",
            ["lt-LT"]: "lt-LT-LeonasNeural",
            ["lv-LV"]: "lv-LV-EveritaNeural",
            ["mk-MK"]: "mk-MK-AleksandarNeural",
            ["ml-IN"]: "ml-IN-MidhunNeural",
            ["mr-IN"]: "mr-IN-AarohiNeural",
            ["ms-MY"]: "ms-MY-OsmanNeural",
            ["mt-MT"]: "mt-MT-GraceNeural",
            ["my-MM"]: "my-MM-NilarNeural",
            ["nb-NO"]: "nb-NO-PernilleNeural",
            ["nl-BE"]: "nl-BE-ArnaudNeural",
            ["nl-NL"]: "nl-NL-ColetteNeural",
            ["pl-PL"]: "pl-PL-AgnieszkaNeural",
            ["ps-AF"]: "ps-AF-GulNawazNeural",
            ["pt-BR"]: "pt-BR-FranciscaNeural",
            ["pt-PT"]: "pt-PT-DuarteNeural",
            ["ro-RO"]: "ro-RO-AlinaNeural",
            ["ru-RU"]: "ru-RU-SvetlanaNeural",
            ["si-LK"]: "si-LK-SameeraNeural",
            ["sk-SK"]: "sk-SK-LukasNeural",
            ["sl-SI"]: "sl-SI-PetraNeural",
            ["so-SO"]: "so-SO-MuuseNeural",
            ["sr-RS"]: "sr-RS-NicholasNeural",
            ["su-ID"]: "su-ID-JajangNeural",
            ["sv-SE"]: "sv-SE-SofieNeural",
            ["sw-KE"]: "sw-KE-RafikiNeural",
            ["sw-TZ"]: "sw-TZ-DaudiNeural",
            ["ta-IN"]: "ta-IN-PallaviNeural",
            ["ta-LK"]: "ta-LK-KumarNeural",
            ["ta-SG"]: "ta-SG-AnbuNeural",
            ["te-IN"]: "te-IN-MohanNeural",
            ["th-TH"]: "th-TH-PremwadeeNeural",
            ["tr-TR"]: "tr-TR-AhmetNeural",
            ["uk-UA"]: "uk-UA-OstapNeural",
            ["ur-IN"]: "ur-IN-GulNeural",
            ["ur-PK"]: "ur-PK-AsadNeural",
            ["uz-UZ"]: "uz-UZ-MadinaNeural",
            ["vi-VN"]: "vi-VN-HoaiMyNeural",
            ["zh-CN"]: "zh-CN-XiaoxiaoNeural",
            ["zh-HK"]: "zh-HK-HiuMaanNeural",
            ["zh-TW"]: "zh-TW-HsiaoChenNeural",
            ["zu-ZA"]: "zu-ZA-ThandoNeural"
        };
        let language = this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US");
        let voice = this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthVoice, "");
        let ssml = $7e21b639504638aa$var$Synthesizer.XMLEncode(text);
        if (this.autoDetectSourceLanguage) language = "en-US";
        else voice = voice || languageToDefaultVoice[language];
        if (voice) ssml = `<voice name='${voice}'>${ssml}</voice>`;
        ssml = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${language}'>${ssml}</speak>`;
        return ssml;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Synthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ async dispose(disposing) {
        if (this.privDisposed) return;
        if (disposing) {
            if (this.privAdapter) await this.privAdapter.dispose();
        }
        this.privDisposed = true;
    }
    async adapterSpeak() {
        if (!this.privDisposed && !this.privSynthesizing) {
            this.privSynthesizing = true;
            const request = await this.synthesisRequestQueue.dequeue();
            return this.privAdapter.Speak(request.text, request.isSSML, request.requestId, request.cb, request.err, request.dataStream);
        }
    }
    createSynthesizerConfig(speechConfig) {
        return new $h6sQE.SynthesizerConfig(speechConfig, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const synthesizerConfig = this.createSynthesizerConfig(new $h6sQE.SpeechServiceConfig(new $h6sQE.Context(new $h6sQE.OS(osPlatform, osName, osVersion))));
        const subscriptionKey = this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new $h6sQE.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $h6sQE.CognitiveTokenAuthentication(()=>{
            const authorizationToken = this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = this.privProperties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        this.privAdapter = this.createSynthesisAdapter(authentication, this.privConnectionFactory, synthesizerConfig);
        this.privRestAdapter = this.createRestSynthesisAdapter(authentication, synthesizerConfig);
    }
    static XMLEncode(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
     */ constructor(speechConfig){
        const speechConfigImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        this.privProperties = speechConfigImpl.properties.clone();
        this.privDisposed = false;
        this.privSynthesizing = false;
        this.synthesisRequestQueue = new $iLPPT.Queue();
    }
}
module.exports.Synthesizer = $7e21b639504638aa$var$Synthesizer;
class $7e21b639504638aa$var$SynthesisRequest {
    constructor(requestId, text, isSSML, cb, err, dataStream){
        this.requestId = requestId;
        this.text = text;
        this.isSSML = isSSML;
        this.cb = cb;
        this.err = err;
        this.dataStream = dataStream;
    }
}
module.exports.SynthesisRequest = $7e21b639504638aa$var$SynthesisRequest;

});

parcelRegister("1XURZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesizer = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $4Oa6i = parcelRequire("4Oa6i");

var $3R9Dx = parcelRequire("3R9Dx");

var $lrnFA = parcelRequire("lrnFA");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $aPoyg = parcelRequire("aPoyg");
/**
 * Defines the class SpeechSynthesizer for text to speech.
 * Updated in version 1.16.0
 * @class SpeechSynthesizer
 */ class $16e76a4d70b2e337$var$SpeechSynthesizer extends $14iyq.Synthesizer {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        return new $16e76a4d70b2e337$var$SpeechSynthesizer(speechConfig, audioConfig);
    }
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakTextAsync(text, cb, err, stream) {
        this.speakImpl(text, false, cb, err, stream);
    }
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakSsmlAsync(ssml, cb, err, stream) {
        this.speakImpl(ssml, true, cb, err, stream);
    }
    /**
     * Get list of synthesis voices available.
     * The task returns the synthesis voice result.
     * @member SpeechSynthesizer.prototype.getVoicesAsync
     * @function
     * @async
     * @public
     * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
     * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
     */ async getVoicesAsync(locale = "") {
        return this.getVoices(locale);
    }
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        $3afpL.Contracts.throwIfDisposed(this.privDisposed);
        $iLPPT.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    }
    /**
     * @Internal
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new $h6sQE.SpeechSynthesisAdapter(authentication, connectionFactory, synthesizerConfig, this, this.audioConfig);
    }
    createRestSynthesisAdapter(authentication, synthesizerConfig) {
        return new $h6sQE.SynthesisRestAdapter(synthesizerConfig, authentication);
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        this.privAdapter.audioOutputFormat = $3R9Dx.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($14iyq.SpeechSynthesisOutputFormat[this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)]);
    }
    speakImpl(text, IsSsml, cb, err, dataStream) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privDisposed);
            const requestId = $iLPPT.createNoDashGuid();
            let audioDestination;
            if (dataStream instanceof $14iyq.PushAudioOutputStreamCallback) audioDestination = new $lrnFA.PushAudioOutputStreamImpl(dataStream);
            else if (dataStream instanceof $14iyq.PullAudioOutputStream) audioDestination = dataStream;
            else if (dataStream !== undefined) audioDestination = new $4Oa6i.AudioFileWriter(dataStream);
            else audioDestination = undefined;
            this.synthesisRequestQueue.enqueue(new $aPoyg.SynthesisRequest(requestId, text, IsSsml, (e)=>{
                this.privSynthesizing = false;
                if (!!cb) try {
                    cb(e);
                } catch (e) {
                    if (!!err) err(e);
                }
                cb = undefined;
                /* eslint-disable no-empty */ this.adapterSpeak().catch(()=>{});
            }, (e)=>{
                if (!!err) err(e);
            }, audioDestination));
            /* eslint-disable no-empty-function */ this.adapterSpeak().catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the synthesizer.
            /* eslint-disable no-empty */ this.dispose(true).catch(()=>{});
        }
    }
    async getVoices(locale) {
        const requestId = $iLPPT.createNoDashGuid();
        const response = await this.privRestAdapter.getVoicesList(requestId);
        if (response.ok && Array.isArray(response.json)) {
            let json = response.json;
            if (!!locale && locale.length > 0) json = json.filter((item)=>!!item.Locale && item.Locale.toLowerCase() === locale.toLowerCase());
            return new $14iyq.SynthesisVoicesResult(requestId, json, undefined);
        } else return new $14iyq.SynthesisVoicesResult(requestId, undefined, `Error: ${response.status}: ${response.statusText}`);
    }
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */ constructor(speechConfig, audioConfig){
        super(speechConfig);
        if (audioConfig !== null) {
            if (audioConfig === undefined) this.audioConfig = typeof window === "undefined" ? undefined : $14iyq.AudioConfig.fromDefaultSpeakerOutput();
            else this.audioConfig = audioConfig;
        }
        this.privConnectionFactory = new $h6sQE.SpeechSynthesisConnectionFactory();
        this.implCommonSynthesizeSetup();
    }
}
module.exports.SpeechSynthesizer = $16e76a4d70b2e337$var$SpeechSynthesizer;

});

parcelRegister("fVhXU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisResult = void 0;
/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */ class $b97a1d6fc1c9361e$var$SynthesisResult {
    /**
     * Specifies the result identifier.
     * @member SynthesisResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The set of properties exposed in the result.
     * @member SynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, errorDetails, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
}
module.exports.SynthesisResult = $b97a1d6fc1c9361e$var$SynthesisResult;

});

parcelRegister("6LGF6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines result of speech synthesis.
 * @class SpeechSynthesisResult
 * Added in version 1.11.0
 */ class $4ed839a7f11dd67c$var$SpeechSynthesisResult extends $14iyq.SynthesisResult {
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */ get audioData() {
        return this.privAudioData;
    }
    /**
     * The time duration of synthesized audio, in ticks (100 nanoseconds).
     * @member SpeechSynthesisResult.prototype.audioDuration
     * @function
     * @public
     * @returns {number} The time duration of synthesized audio.
     */ get audioDuration() {
        return this.privAudioDuration;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */ constructor(resultId, reason, audioData, errorDetails, properties, audioDuration){
        super(resultId, reason, errorDetails, properties);
        this.privAudioData = audioData;
        this.privAudioDuration = audioDuration;
    }
}
module.exports.SpeechSynthesisResult = $4ed839a7f11dd67c$var$SpeechSynthesisResult;

});

parcelRegister("cqWgr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisEventArgs = void 0;
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ class $90d51bcc1f143b75$var$SpeechSynthesisEventArgs {
    /**
     * Specifies the synthesis result.
     * @member SpeechSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechSynthesisResult} the synthesis result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ constructor(result){
        this.privResult = result;
    }
}
module.exports.SpeechSynthesisEventArgs = $90d51bcc1f143b75$var$SpeechSynthesisEventArgs;

});

parcelRegister("7cLP2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisWordBoundaryEventArgs = void 0;
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ class $53eebfe7887c8965$var$SpeechSynthesisWordBoundaryEventArgs {
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the duration, in ticks (100 nanoseconds).
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
     * @function
     * @public
     * @returns {number} Duration in 100 nanosecond increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Specifies the text of the word boundary event.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the text.
     */ get text() {
        return this.privText;
    }
    /**
     * Specifies the word length
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
     * @function
     * @public
     * @returns {number} the word length
     */ get wordLength() {
        return this.privWordLength;
    }
    /**
     * Specifies the text offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
     * @function
     * @public
     * @returns {number} the text offset.
     */ get textOffset() {
        return this.privTextOffset;
    }
    /**
     * Specifies the boundary type.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
     * @function
     * @public
     * @returns {SpeechSynthesisBoundaryType} the boundary type.
     */ get boundaryType() {
        return this.privBoundaryType;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} duration - The audio duration.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
     */ constructor(audioOffset, duration, text, wordLength, textOffset, boundaryType){
        this.privAudioOffset = audioOffset;
        this.privDuration = duration;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
        this.privBoundaryType = boundaryType;
    }
}
module.exports.SpeechSynthesisWordBoundaryEventArgs = $53eebfe7887c8965$var$SpeechSynthesisWordBoundaryEventArgs;

});

parcelRegister("dAftl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBookmarkEventArgs = void 0;
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ class $9e3aa3a811b73c0c$var$SpeechSynthesisBookmarkEventArgs {
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the bookmark.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the bookmark text.
     */ get text() {
        return this.privText;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ constructor(audioOffset, text){
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
}
module.exports.SpeechSynthesisBookmarkEventArgs = $9e3aa3a811b73c0c$var$SpeechSynthesisBookmarkEventArgs;

});

parcelRegister("l9RGC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisVisemeEventArgs = void 0;
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ class $f67415437e5ba2b5$var$SpeechSynthesisVisemeEventArgs {
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the viseme ID.
     * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
     * @function
     * @public
     * @returns {number} the viseme ID.
     */ get visemeId() {
        return this.privVisemeId;
    }
    /**
     * Specifies the animation.
     * @member SpeechSynthesisVisemeEventArgs.prototype.animation
     * @function
     * @public
     * @returns {string} the animation, could be in svg or other format.
     */ get animation() {
        return this.privAnimation;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ constructor(audioOffset, visemeId, animation){
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
}
module.exports.SpeechSynthesisVisemeEventArgs = $f67415437e5ba2b5$var$SpeechSynthesisVisemeEventArgs;

});

parcelRegister("3AOJB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBoundaryType = void 0;
/**
 * Defines the boundary type of speech synthesis boundary event.
 * @class SpeechSynthesisBoundaryType
 * Added in version 1.21.0
 */ var $29dc16bc333c04bb$var$SpeechSynthesisBoundaryType;
(function(SpeechSynthesisBoundaryType) {
    /**
     * Indicates the boundary text is a word.
     * @member SpeechSynthesisBoundaryType.Word
     */ SpeechSynthesisBoundaryType["Word"] = "WordBoundary";
    /**
     * Indicates the boundary text is a punctuation.
     * @member SpeechSynthesisBoundaryType.Punctuation
     */ SpeechSynthesisBoundaryType["Punctuation"] = "PunctuationBoundary";
    /**
     * Indicates the boundary text is a sentence.
     * @member SpeechSynthesisBoundaryType.Sentence
     */ SpeechSynthesisBoundaryType["Sentence"] = "SentenceBoundary";
})($29dc16bc333c04bb$var$SpeechSynthesisBoundaryType = module.exports.SpeechSynthesisBoundaryType || (module.exports.SpeechSynthesisBoundaryType = {}));

});

parcelRegister("8SbXQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisVoicesResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines result of speech synthesis.
 * @class SynthesisVoicesResult
 * Added in version 1.20.0
 */ class $675ca5bf15bc2c31$var$SynthesisVoicesResult extends $14iyq.SynthesisResult {
    /**
     * The list of voices
     * @member SynthesisVoicesResult.prototype.voices
     * @function
     * @public
     * @returns {VoiceInfo[]} List of synthesized voices.
     */ get voices() {
        return this.privVoices;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param requestId - result id for request.
     * @param json - json payload from endpoint.
     */ constructor(requestId, json, errorDetails){
        if (Array.isArray(json)) {
            super(requestId, $14iyq.ResultReason.VoicesListRetrieved, undefined, new $14iyq.PropertyCollection());
            this.privVoices = [];
            for (const item of json)this.privVoices.push(new $14iyq.VoiceInfo(item));
        } else super(requestId, $14iyq.ResultReason.Canceled, errorDetails ? errorDetails : "Error information unavailable", new $14iyq.PropertyCollection());
    }
}
module.exports.SynthesisVoicesResult = $675ca5bf15bc2c31$var$SynthesisVoicesResult;

});

parcelRegister("16qp9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceInfo = module.exports.SynthesisVoiceType = module.exports.SynthesisVoiceGender = void 0;
/**
 * Defines the gender of synthesis voices.
 * Added in version 1.20.0.
 */ var $0cdad55f816f9742$var$SynthesisVoiceGender;
(function(SynthesisVoiceGender) {
    /** Gender unknown */ SynthesisVoiceGender[SynthesisVoiceGender["Unknown"] = 0] = "Unknown";
    /** Female voice */ SynthesisVoiceGender[SynthesisVoiceGender["Female"] = 1] = "Female";
    /** Male voice */ SynthesisVoiceGender[SynthesisVoiceGender["Male"] = 2] = "Male";
    /** Neutral voice */ SynthesisVoiceGender[SynthesisVoiceGender["Neutral"] = 3] = "Neutral";
})($0cdad55f816f9742$var$SynthesisVoiceGender = module.exports.SynthesisVoiceGender || (module.exports.SynthesisVoiceGender = {}));
var $0cdad55f816f9742$var$SynthesisVoiceType;
(function(SynthesisVoiceType) {
    SynthesisVoiceType[SynthesisVoiceType["OnlineNeural"] = 1] = "OnlineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OnlineStandard"] = 2] = "OnlineStandard";
    SynthesisVoiceType[SynthesisVoiceType["OfflineNeural"] = 3] = "OfflineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OfflineStandard"] = 4] = "OfflineStandard";
})($0cdad55f816f9742$var$SynthesisVoiceType = module.exports.SynthesisVoiceType || (module.exports.SynthesisVoiceType = {}));
const $0cdad55f816f9742$var$GENDER_LOOKUP = {
    [$0cdad55f816f9742$var$SynthesisVoiceGender[$0cdad55f816f9742$var$SynthesisVoiceGender.Neutral]]: $0cdad55f816f9742$var$SynthesisVoiceGender.Neutral,
    [$0cdad55f816f9742$var$SynthesisVoiceGender[$0cdad55f816f9742$var$SynthesisVoiceGender.Male]]: $0cdad55f816f9742$var$SynthesisVoiceGender.Male,
    [$0cdad55f816f9742$var$SynthesisVoiceGender[$0cdad55f816f9742$var$SynthesisVoiceGender.Female]]: $0cdad55f816f9742$var$SynthesisVoiceGender.Female
};
/**
 * Information about Speech Synthesis voice
 * Added in version 1.20.0.
 * @class VoiceInfo
 */ class $0cdad55f816f9742$var$VoiceInfo {
    get name() {
        return this.privName;
    }
    get locale() {
        return this.privLocale;
    }
    get shortName() {
        return this.privShortName;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get localName() {
        return this.privLocalName;
    }
    get localeName() {
        return this.privLocaleName;
    }
    get gender() {
        return this.privGender;
    }
    get voiceType() {
        return this.privVoiceType;
    }
    get styleList() {
        return this.privStyleList;
    }
    get sampleRateHertz() {
        return this.privSampleRateHertz;
    }
    get status() {
        return this.privStatus;
    }
    get extendedPropertyMap() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privExtendedPropertyMap;
    }
    get wordsPerMinute() {
        return this.privWordsPerMinute;
    }
    get secondaryLocaleList() {
        return this.privSecondaryLocaleList;
    }
    get rolePlayList() {
        return this.privRolePlayList;
    }
    constructor(json){
        this.privStyleList = [];
        if (!!json) {
            this.privName = json.Name;
            this.privLocale = json.Locale;
            this.privShortName = json.ShortName;
            this.privLocaleName = json.LocaleName;
            this.privDisplayName = json.DisplayName;
            this.privLocalName = json.LocalName;
            this.privVoiceType = json.VoiceType.endsWith("Standard") ? $0cdad55f816f9742$var$SynthesisVoiceType.OnlineStandard : $0cdad55f816f9742$var$SynthesisVoiceType.OnlineNeural;
            this.privGender = $0cdad55f816f9742$var$GENDER_LOOKUP[json.Gender] || $0cdad55f816f9742$var$SynthesisVoiceGender.Unknown;
            if (!!json.StyleList && Array.isArray(json.StyleList)) for (const style of json.StyleList)this.privStyleList.push(style);
            this.privSampleRateHertz = json.SampleRateHertz;
            this.privStatus = json.Status;
            if (json.ExtendedPropertyMap) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privExtendedPropertyMap = json.ExtendedPropertyMap;
            this.privWordsPerMinute = json.WordsPerMinute;
            if (Array.isArray(json.SecondaryLocaleList)) this.privSecondaryLocaleList = [
                ...json.SecondaryLocaleList
            ];
            if (Array.isArray(json.RolePlayList)) this.privRolePlayList = [
                ...json.RolePlayList
            ];
        }
    }
}
module.exports.VoiceInfo = $0cdad55f816f9742$var$VoiceInfo;

});

parcelRegister("hMgSu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerAudioDestination = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $lrnFA = parcelRequire("lrnFA");

var $9Xjoq = parcelRequire("9Xjoq");
const $cf1402efe5d4b445$var$MediaDurationPlaceholderSeconds = 1800;
const $cf1402efe5d4b445$var$AudioFormatToMimeType = {
    [$9Xjoq.AudioFormatTag.PCM]: "audio/wav",
    [$9Xjoq.AudioFormatTag.MuLaw]: "audio/x-wav",
    [$9Xjoq.AudioFormatTag.MP3]: "audio/mpeg",
    [$9Xjoq.AudioFormatTag.OGG_OPUS]: "audio/ogg",
    [$9Xjoq.AudioFormatTag.WEBM_OPUS]: "audio/webm; codecs=opus",
    [$9Xjoq.AudioFormatTag.ALaw]: "audio/x-wav",
    [$9Xjoq.AudioFormatTag.FLAC]: "audio/flac",
    [$9Xjoq.AudioFormatTag.AMR_WB]: "audio/amr-wb",
    [$9Xjoq.AudioFormatTag.G722]: "audio/G722"
};
/**
 * Represents the speaker playback audio destination, which only works in browser.
 * Note: the SDK will try to use <a href="https://www.w3.org/TR/media-source/">Media Source Extensions</a> to play audio.
 * Mp3 format has better supports on Microsoft Edge, Chrome and Safari (desktop), so, it's better to specify mp3 format for playback.
 * @class SpeakerAudioDestination
 * Updated in version 1.17.0
 */ class $cf1402efe5d4b445$var$SpeakerAudioDestination {
    id() {
        return this.privId;
    }
    write(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    }
    close(cb, err) {
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined && typeof window !== "undefined") {
            if ((this.privFormat.formatTag === $9Xjoq.AudioFormatTag.PCM || this.privFormat.formatTag === $9Xjoq.AudioFormatTag.MuLaw || this.privFormat.formatTag === $9Xjoq.AudioFormatTag.ALaw) && this.privFormat.hasHeader === false) {
                // eslint-disable-next-line no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                let receivedAudio = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio).then(()=>{
                    receivedAudio = this.privFormat.addHeader(receivedAudio);
                    const audioBlob = new Blob([
                        receivedAudio
                    ], {
                        type: $cf1402efe5d4b445$var$AudioFormatToMimeType[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    this.notifyPlayback().then(()=>{
                        if (!!cb) cb();
                    }, (error)=>{
                        if (!!err) err(error);
                    });
                }, (error)=>{
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    }
    set format(format) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof AudioContext !== "undefined" || typeof window !== "undefined" && typeof window.webkitAudioContext !== "undefined") {
            this.privFormat = format;
            const mimeType = $cf1402efe5d4b445$var$AudioFormatToMimeType[this.privFormat.formatTag];
            if (mimeType === undefined) // eslint-disable-next-line no-console
            console.warn(`Unknown mimeType for format ${$9Xjoq.AudioFormatTag[this.privFormat.formatTag]}; playback is not supported.`);
            else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
                this.privAudio = new Audio();
                this.privAudioBuffer = [];
                this.privMediaSource = new MediaSource();
                this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                this.privAudio.load();
                this.privMediaSource.onsourceopen = ()=>{
                    this.privMediaSourceOpened = true;
                    this.privMediaSource.duration = $cf1402efe5d4b445$var$MediaDurationPlaceholderSeconds;
                    this.privSourceBuffer = this.privMediaSource.addSourceBuffer(mimeType);
                    this.privSourceBuffer.onupdate = ()=>{
                        this.updateSourceBuffer().catch((reason)=>{
                            $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
                        });
                    };
                    this.privSourceBuffer.onupdateend = ()=>{
                        this.handleSourceBufferUpdateEnd().catch((reason)=>{
                            $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
                        });
                    };
                    this.privSourceBuffer.onupdatestart = ()=>{
                        this.privAppendingToBuffer = false;
                    };
                };
                this.updateSourceBuffer().catch((reason)=>{
                    $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
                });
            } else {
                // eslint-disable-next-line no-console
                console.warn(`Format ${$9Xjoq.AudioFormatTag[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`);
                this.privAudioOutputStream = new $lrnFA.PullAudioOutputStreamImpl();
                this.privAudioOutputStream.format = this.privFormat;
                this.privAudio = new Audio();
            }
        }
    }
    get volume() {
        var _this_privAudio;
        var _this_privAudio_volume;
        return (_this_privAudio_volume = (_this_privAudio = this.privAudio) === null || _this_privAudio === void 0 ? void 0 : _this_privAudio.volume) !== null && _this_privAudio_volume !== void 0 ? _this_privAudio_volume : -1;
    }
    set volume(volume) {
        if (!!this.privAudio) this.privAudio.volume = volume;
    }
    mute() {
        if (!!this.privAudio) this.privAudio.muted = true;
    }
    unmute() {
        if (!!this.privAudio) this.privAudio.muted = false;
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        if (this.privAudio !== undefined) return this.privAudio.currentTime;
        return -1;
    }
    pause() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    }
    resume(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    }
    get internalAudio() {
        return this.privAudio;
    }
    async updateSourceBuffer() {
        if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
            this.privAppendingToBuffer = true;
            const binary = this.privAudioBuffer.shift();
            try {
                this.privSourceBuffer.appendBuffer(binary);
            } catch (error) {
                this.privAudioBuffer.unshift(binary);
                // eslint-disable-next-line no-console
                console.log("buffer filled, pausing addition of binaries until space is made");
                return;
            }
            await this.notifyPlayback();
        } else if (this.canEndStream()) await this.handleSourceBufferUpdateEnd();
    }
    async handleSourceBufferUpdateEnd() {
        if (this.canEndStream() && this.sourceBufferAvailable()) {
            this.privMediaSource.endOfStream();
            await this.notifyPlayback();
        }
    }
    async notifyPlayback() {
        if (!this.privPlaybackStarted && this.privAudio !== undefined) {
            this.privPlaybackStarted = true;
            if (!!this.onAudioStart) this.onAudioStart(this);
            this.privAudio.onended = ()=>{
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            };
            if (!this.privIsPaused) await this.privAudio.play();
        }
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
    constructor(audioDestinationId){
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : $iLPPT.createNoDashGuid();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
}
module.exports.SpeakerAudioDestination = $cf1402efe5d4b445$var$SpeakerAudioDestination;

});

parcelRegister("EygK1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionCanceledEventArgs = void 0;

var $kl0Sn = parcelRequire("kl0Sn");
/**
 * Defines content of a RecognitionErrorEvent.
 * @class ConversationTranscriptionCanceledEventArgs
 */ class $079e51a7c4d2a099$var$ConversationTranscriptionCanceledEventArgs extends $kl0Sn.CancellationEventArgsBase {
}
module.exports.ConversationTranscriptionCanceledEventArgs = $079e51a7c4d2a099$var$ConversationTranscriptionCanceledEventArgs;

});

parcelRegister("4BpHU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionCanceledEventArgs = void 0;

var $kl0Sn = parcelRequire("kl0Sn");
/**
 * Defines content of a MeetingTranscriptionCanceledEvent.
 * @class MeetingTranscriptionCanceledEventArgs
 */ class $359e8f1064add469$var$MeetingTranscriptionCanceledEventArgs extends $kl0Sn.CancellationEventArgsBase {
}
module.exports.MeetingTranscriptionCanceledEventArgs = $359e8f1064add469$var$MeetingTranscriptionCanceledEventArgs;

});

parcelRegister("2dw0X", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGradingSystem = void 0;
/**
 * Defines the point system for pronunciation score calibration; default value is FivePoint.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGradingSystem
 */ var $19d5a10ffe68633a$var$PronunciationAssessmentGradingSystem;
(function(PronunciationAssessmentGradingSystem) {
    /**
     * Five point calibration
     * @member PronunciationAssessmentGradingSystem.FivePoint
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["FivePoint"] = 1] = "FivePoint";
    /**
     * Hundred mark
     * @member PronunciationAssessmentGradingSystem.HundredMark
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["HundredMark"] = 2] = "HundredMark";
})($19d5a10ffe68633a$var$PronunciationAssessmentGradingSystem = module.exports.PronunciationAssessmentGradingSystem || (module.exports.PronunciationAssessmentGradingSystem = {}));

});

parcelRegister("3CEMv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGranularity = void 0;
/**
 * Defines the pronunciation evaluation granularity; default value is Phoneme.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGranularity
 */ var $2a348e03ac2f5858$var$PronunciationAssessmentGranularity;
(function(PronunciationAssessmentGranularity) {
    /**
     * Shows the score on the full text, word and phoneme level
     * @member PronunciationAssessmentGranularity.Phoneme
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Phoneme"] = 1] = "Phoneme";
    /**
     * Shows the score on the full text and word level
     * @member PronunciationAssessmentGranularity.Word
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Word"] = 2] = "Word";
    /**
     * Shows the score on the full text level only
     * @member PronunciationAssessmentGranularity.FullText
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["FullText"] = 3] = "FullText";
})($2a348e03ac2f5858$var$PronunciationAssessmentGranularity = module.exports.PronunciationAssessmentGranularity || (module.exports.PronunciationAssessmentGranularity = {}));

});

parcelRegister("2ZitX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentConfig = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Pronunciation assessment configuration.
 * @class PronunciationAssessmentConfig
 * Added in version 1.15.0.
 */ class $22cf9d7617431440$var$PronunciationAssessmentConfig {
    /**
     * @member PronunciationAssessmentConfig.fromJSON
     * @function
     * @public
     * @param {string} json The json string containing the pronunciation assessment parameters.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentConfig from json.
     * This method is designed to support the pronunciation assessment parameters still in preview.
     * Under normal circumstances, use the constructor instead.
     */ static fromJSON(json) {
        $3afpL.Contracts.throwIfNullOrUndefined(json, "json");
        const config = new $22cf9d7617431440$var$PronunciationAssessmentConfig("");
        config.privProperties = new $14iyq.PropertyCollection();
        config.properties.setProperty($14iyq.PropertyId.PronunciationAssessment_Json, json);
        return config;
    }
    toJSON() {
        this.updateJson();
        return this.privProperties.getProperty($14iyq.PropertyId.PronunciationAssessment_Params);
    }
    applyTo(recognizer) {
        this.updateJson();
        const recoBase = recognizer.internalData;
        recoBase.expectContentAssessmentResponse = !!this.privContentAssessmentTopic;
        recoBase.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($14iyq.PropertyId.PronunciationAssessment_Params), this.privContentAssessmentTopic, recoBase.isSpeakerDiarizationEnabled);
    }
    /**
     * Gets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @returns {string} Reference text.
     */ get referenceText() {
        return this.properties.getProperty($14iyq.PropertyId.PronunciationAssessment_ReferenceText);
    }
    /**
     * Gets/Sets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @param {string} referenceText - Reference text.
     */ set referenceText(referenceText) {
        $3afpL.Contracts.throwIfNullOrWhitespace(referenceText, "referenceText");
        this.properties.setProperty($14iyq.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
    }
    /**
     * Sets the phoneme alphabet.
     * The valid values are "SAPI" (default) and "IPA".
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
     * @function
     * @public
     * @param {string} phonemeAlphabet - Phoneme alphabet.
     */ set phonemeAlphabet(phonemeAlphabet) {
        $3afpL.Contracts.throwIfNullOrWhitespace(phonemeAlphabet, "phonemeAlphabet");
        this.privPhonemeAlphabet = phonemeAlphabet;
    }
    /**
     * Sets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @param {boolean} enableMiscue - enable miscue.
     */ set enableMiscue(enableMiscue) {
        const enableMiscueString = enableMiscue ? "true" : "false";
        this.properties.setProperty($14iyq.PropertyId.PronunciationAssessment_EnableMiscue, enableMiscueString);
    }
    /**
     * Gets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @return {boolean} enableMiscue - enable miscue.
     */ get enableMiscue() {
        const enableMiscueString = this.properties.getProperty($14iyq.PropertyId.PronunciationAssessment_EnableMiscue, "false");
        return enableMiscueString.toLowerCase() === "true";
    }
    /**
     * Sets the nbest phoneme count
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
     * @function
     * @public
     * @param {number} nbestPhonemeCount - NBest phoneme count.
     */ set nbestPhonemeCount(nbestPhonemeCount) {
        this.privNBestPhonemeCount = nbestPhonemeCount;
    }
    /**
     * Enables the prosody assessment.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableProsodyAssessment
     * @function
     * @public
     * @param {boolean} enableProsodyAssessment - enable prosody assessment.
     */ set enableProsodyAssessment(enableProsodyAssessment) {
        this.privEnableProsodyAssessment = enableProsodyAssessment;
    }
    /**
     * Enables content assessment and sets the topic.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableContentAssessmentWithTopic
     * @function
     * @public
     * @param {string} topic - Topic for content assessment.
     */ enableContentAssessmentWithTopic(topic) {
        this.privContentAssessmentTopic = topic;
    }
    /**
     * @member PronunciationAssessmentConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets a pronunciation assessment config properties
     */ get properties() {
        return this.privProperties;
    }
    updateJson() {
        const jsonString = this.privProperties.getProperty($14iyq.PropertyId.PronunciationAssessment_Json, "{}");
        const paramsJson = JSON.parse(jsonString);
        const referenceText = this.privProperties.getProperty($14iyq.PropertyId.PronunciationAssessment_ReferenceText);
        if (referenceText) paramsJson.referenceText = referenceText;
        const gradingSystem = this.privProperties.getProperty($14iyq.PropertyId.PronunciationAssessment_GradingSystem);
        if (gradingSystem) paramsJson.gradingSystem = gradingSystem;
        const granularity = this.privProperties.getProperty($14iyq.PropertyId.PronunciationAssessment_Granularity);
        if (granularity) paramsJson.granularity = granularity;
        if (this.privPhonemeAlphabet) paramsJson.phonemeAlphabet = this.privPhonemeAlphabet;
        if (this.privNBestPhonemeCount) paramsJson.nbestPhonemeCount = this.privNBestPhonemeCount;
        paramsJson.enableProsodyAssessment = this.privEnableProsodyAssessment;
        // always set dimension to Comprehensive
        paramsJson.dimension = "Comprehensive";
        const enableMiscueString = this.privProperties.getProperty($14iyq.PropertyId.PronunciationAssessment_EnableMiscue);
        if (enableMiscueString) paramsJson.enableMiscue = this.enableMiscue;
        this.privProperties.setProperty($14iyq.PropertyId.PronunciationAssessment_Params, JSON.stringify(paramsJson));
    }
    /**
     * PronunciationAssessmentConfig constructor.
     * @constructor
     * @param {string} referenceText
     * @param gradingSystem
     * @param granularity
     * @param enableMiscue
     */ constructor(referenceText, gradingSystem = $14iyq.PronunciationAssessmentGradingSystem.FivePoint, granularity = $14iyq.PronunciationAssessmentGranularity.Phoneme, enableMiscue = false){
        $3afpL.Contracts.throwIfNullOrUndefined(referenceText, "referenceText");
        this.privProperties = new $14iyq.PropertyCollection();
        this.privProperties.setProperty($14iyq.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        this.privProperties.setProperty($14iyq.PropertyId.PronunciationAssessment_GradingSystem, $14iyq.PronunciationAssessmentGradingSystem[gradingSystem]);
        this.privProperties.setProperty($14iyq.PropertyId.PronunciationAssessment_Granularity, $14iyq.PronunciationAssessmentGranularity[granularity]);
        this.privProperties.setProperty($14iyq.PropertyId.PronunciationAssessment_EnableMiscue, String(enableMiscue));
    }
}
module.exports.PronunciationAssessmentConfig = $22cf9d7617431440$var$PronunciationAssessmentConfig;

});

parcelRegister("jKfMR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentResult = module.exports.ContentAssessmentResult = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
class $e5fe8f2c16cae557$var$ContentAssessmentResult {
    /**
     * Correctness in using grammar and variety of sentence patterns.
     * Grammatical errors are jointly evaluated by lexical accuracy,
     * grammatical accuracy and diversity of sentence structures.
     * @member ContentAssessmentResult.prototype.grammarScore
     * @function
     * @public
     * @returns {number} Grammar score.
     */ get grammarScore() {
        return this.privPronJson.ContentAssessment.GrammarScore;
    }
    /**
     * Proficiency in lexical usage. It evaluates the speaker's effective usage
     * of words and their appropriateness within the given context to express
     * ideas accurately, as well as level of lexical complexity.
     * @member ContentAssessmentResult.prototype.vocabularyScore
     * @function
     * @public
     * @returns {number} Vocabulary score.
     */ get vocabularyScore() {
        return this.privPronJson.ContentAssessment.VocabularyScore;
    }
    /**
     * Level of understanding and engagement with the topic, which provides
     * insights into the speaker’s ability to express their thoughts and ideas
     * effectively and the ability to engage with the topic.
     * @member ContentAssessmentResult.prototype.topicScore
     * @function
     * @public
     * @returns {number} Topic score.
     */ get topicScore() {
        return this.privPronJson.ContentAssessment.TopicScore;
    }
    /**
     * @Internal
     * Do not use externally.
     */ constructor(detailResult){
        this.privPronJson = detailResult;
    }
}
module.exports.ContentAssessmentResult = $e5fe8f2c16cae557$var$ContentAssessmentResult;
/**
 * Pronunciation assessment results.
 * @class PronunciationAssessmentResult
 * Added in version 1.15.0.
 */ class $e5fe8f2c16cae557$var$PronunciationAssessmentResult {
    /**
     * @member PronunciationAssessmentResult.fromResult
     * @function
     * @public
     * @param {RecognitionResult} result The recognition result.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
     */ static fromResult(result) {
        $3afpL.Contracts.throwIfNullOrUndefined(result, "result");
        const json = result.properties.getProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult);
        $3afpL.Contracts.throwIfNullOrUndefined(json, "json");
        return new $e5fe8f2c16cae557$var$PronunciationAssessmentResult(json);
    }
    /**
     * Gets the detail result of pronunciation assessment.
     * @member PronunciationAssessmentConfig.prototype.detailResult
     * @function
     * @public
     * @returns {DetailResult} detail result.
     */ get detailResult() {
        return this.privPronJson;
    }
    /**
     * The score indicating the pronunciation accuracy of the given speech, which indicates
     * how closely the phonemes match a native speaker's pronunciation.
     * @member PronunciationAssessmentResult.prototype.accuracyScore
     * @function
     * @public
     * @returns {number} Accuracy score.
     */ get accuracyScore() {
        var _this_detailResult_PronunciationAssessment;
        return (_this_detailResult_PronunciationAssessment = this.detailResult.PronunciationAssessment) === null || _this_detailResult_PronunciationAssessment === void 0 ? void 0 : _this_detailResult_PronunciationAssessment.AccuracyScore;
    }
    /**
     * The overall score indicating the pronunciation quality of the given speech.
     * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
     * @member PronunciationAssessmentResult.prototype.pronunciationScore
     * @function
     * @public
     * @returns {number} Pronunciation score.
     */ get pronunciationScore() {
        var _this_detailResult_PronunciationAssessment;
        return (_this_detailResult_PronunciationAssessment = this.detailResult.PronunciationAssessment) === null || _this_detailResult_PronunciationAssessment === void 0 ? void 0 : _this_detailResult_PronunciationAssessment.PronScore;
    }
    /**
     * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
     * @member PronunciationAssessmentResult.prototype.completenessScore
     * @function
     * @public
     * @returns {number} Completeness score.
     */ get completenessScore() {
        var _this_detailResult_PronunciationAssessment;
        return (_this_detailResult_PronunciationAssessment = this.detailResult.PronunciationAssessment) === null || _this_detailResult_PronunciationAssessment === void 0 ? void 0 : _this_detailResult_PronunciationAssessment.CompletenessScore;
    }
    /**
     * The score indicating the fluency of the given speech.
     * @member PronunciationAssessmentResult.prototype.fluencyScore
     * @function
     * @public
     * @returns {number} Fluency score.
     */ get fluencyScore() {
        var _this_detailResult_PronunciationAssessment;
        return (_this_detailResult_PronunciationAssessment = this.detailResult.PronunciationAssessment) === null || _this_detailResult_PronunciationAssessment === void 0 ? void 0 : _this_detailResult_PronunciationAssessment.FluencyScore;
    }
    /**
     * The prosody score, which indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.
     * @member PronunciationAssessmentResult.prototype.prosodyScore
     * @function
     * @public
     * @returns {number} Prosody score.
     */ get prosodyScore() {
        var _this_detailResult_PronunciationAssessment;
        return (_this_detailResult_PronunciationAssessment = this.detailResult.PronunciationAssessment) === null || _this_detailResult_PronunciationAssessment === void 0 ? void 0 : _this_detailResult_PronunciationAssessment.ProsodyScore;
    }
    /**
     * The concent assessment result.
     * Only available when content assessment is enabled.
     * @member PronunciationAssessmentResult.prototype.contentAssessmentResult
     * @function
     * @public
     * @returns {ContentAssessmentResult} Content assessment result.
     */ get contentAssessmentResult() {
        if (this.detailResult.ContentAssessment === undefined) return undefined;
        return new $e5fe8f2c16cae557$var$ContentAssessmentResult(this.detailResult);
    }
    constructor(jsonString){
        const j = JSON.parse(jsonString);
        $3afpL.Contracts.throwIfNullOrUndefined(j.NBest[0], "NBest");
        this.privPronJson = j.NBest[0];
    }
}
module.exports.PronunciationAssessmentResult = $e5fe8f2c16cae557$var$PronunciationAssessmentResult;

});

parcelRegister("2l6Lj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarConfig = void 0;

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");
/**
 * Defines the talking avatar configuration.
 * @class AvatarConfig
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $1b42c9bb3c9c244e$var$AvatarConfig {
    /**
     * Indicates if the talking avatar is customized.
     */ get customized() {
        return this.privCustomized;
    }
    /**
     * Sets if the talking avatar is customized.
     */ set customized(value) {
        this.privCustomized = value;
    }
    /**
     * Gets the background color.
     */ get backgroundColor() {
        return this.privBackgroundColor;
    }
    /**
     * Sets the background color.
     */ set backgroundColor(value) {
        this.privBackgroundColor = value;
    }
    /**
     * Gets the background image.
     */ get backgroundImage() {
        return this.privBackgroundImage;
    }
    /**
     * Sets the background image.
     * @param {URL} value - The background image.
     */ set backgroundImage(value) {
        this.privBackgroundImage = value;
    }
    /**
     * Gets the remote ICE servers.
     * @remarks This method is designed to be used internally in the SDK.
     * @returns {RTCIceServer[]} The remote ICE servers.
     */ get remoteIceServers() {
        return this.privRemoteIceServers;
    }
    /**
     * Sets the remote ICE servers.
     * @remarks Normally, the ICE servers are gathered from the PeerConnection,
     * set this property to override the ICE servers. E.g., the ICE servers are
     * different in client and server side.
     * @param {RTCIceServer[]} value - The remote ICE servers.
     */ set remoteIceServers(value) {
        this.privRemoteIceServers = value;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} character - The avatar character.
     * @param {string} style - The avatar style.
     * @param {AvatarVideoFormat} videoFormat - The talking avatar output video format.
     */ constructor(character, style, videoFormat){
        this.privCustomized = false;
        $3afpL.Contracts.throwIfNullOrWhitespace(character, "character");
        this.character = character;
        this.style = style;
        if (videoFormat === undefined) videoFormat = new $14iyq.AvatarVideoFormat();
        this.videoFormat = videoFormat;
    }
}
module.exports.AvatarConfig = $1b42c9bb3c9c244e$var$AvatarConfig;

});

parcelRegister("OMsU8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarEventArgs = module.exports.AvatarEventTypes = void 0;
var $098a43ce30e6f5e6$var$AvatarEventTypes;
(function(AvatarEventTypes) {
    AvatarEventTypes["SwitchedToSpeaking"] = "SwitchedToSpeaking";
    AvatarEventTypes["SwitchedToIdle"] = "SwitchedToIdle";
    AvatarEventTypes["SessionClosed"] = "SessionClosed";
})($098a43ce30e6f5e6$var$AvatarEventTypes = module.exports.AvatarEventTypes || (module.exports.AvatarEventTypes = {}));
/**
 * Defines content for talking avatar events.
 * @class AvatarEventArgs
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $098a43ce30e6f5e6$var$AvatarEventArgs {
    /**
     * The type of the event.
     * @public
     * @returns {AvatarEventTypes} The type of the event.
     */ get type() {
        return this.privType;
    }
    /**
     * The time offset associated with this event.
     * @public
     * @returns {number} The time offset associated with this event.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * The description of the event.
     * @public
     * @returns {string} The description of the event.
     */ get description() {
        return this.privDescription;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} description - The description of the event.
     */ constructor(audioOffset, description){
        this.privOffset = audioOffset;
        this.privDescription = description;
    }
}
module.exports.AvatarEventArgs = $098a43ce30e6f5e6$var$AvatarEventArgs;

});

parcelRegister("9NbEP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarSynthesizer = void 0;

var $jCyuG = parcelRequire("jCyuG");

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3R9Dx = parcelRequire("3R9Dx");

var $14iyq = parcelRequire("14iyq");

var $3afpL = parcelRequire("3afpL");

var $aPoyg = parcelRequire("aPoyg");
/**
 * Defines the avatar synthesizer.
 * @class AvatarSynthesizer
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $7211bb99d8f072d0$var$AvatarSynthesizer extends $14iyq.Synthesizer {
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        // The service checks the audio format setting while it ignores it in avatar synthesis.
        this.privAdapter.audioOutputFormat = $3R9Dx.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($14iyq.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm);
    }
    /**
     * Starts the talking avatar session and establishes the WebRTC connection.
     * @member AvatarSynthesizer.prototype.startAvatarAsync
     * @function
     * @public
     * @param {AvatarWebRTCConnectionInfo} peerConnection - The peer connection.
     * @returns {Promise<SynthesisResult>} The promise of the connection result.
     */ async startAvatarAsync(peerConnection) {
        $3afpL.Contracts.throwIfNullOrUndefined(peerConnection, "peerConnection");
        this.privIceServers = peerConnection.getConfiguration().iceServers;
        $3afpL.Contracts.throwIfNullOrUndefined(this.privIceServers, "Ice servers must be set.");
        const iceGatheringDone = new $iLPPT.Deferred();
        // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/icegatheringstatechange_event
        peerConnection.onicegatheringstatechange = ()=>{
            $iLPPT.Events.instance.onEvent(new $iLPPT.PlatformEvent("peer connection: ice gathering state: " + peerConnection.iceGatheringState, $iLPPT.EventType.Debug));
            if (peerConnection.iceGatheringState === "complete") {
                $iLPPT.Events.instance.onEvent(new $iLPPT.PlatformEvent("peer connection: ice gathering complete.", $iLPPT.EventType.Info));
                iceGatheringDone.resolve();
            }
        };
        peerConnection.onicecandidate = (event)=>{
            if (event.candidate) $iLPPT.Events.instance.onEvent(new $iLPPT.PlatformEvent("peer connection: ice candidate: " + event.candidate.candidate, $iLPPT.EventType.Debug));
            else {
                $iLPPT.Events.instance.onEvent(new $iLPPT.PlatformEvent("peer connection: ice candidate: complete", $iLPPT.EventType.Debug));
                iceGatheringDone.resolve();
            }
        };
        // Set a timeout for ice gathering, currently 2 seconds.
        setTimeout(()=>{
            if (peerConnection.iceGatheringState !== "complete") {
                $iLPPT.Events.instance.onEvent(new $iLPPT.PlatformEvent("peer connection: ice gathering timeout.", $iLPPT.EventType.Warning));
                iceGatheringDone.resolve();
            }
        }, 2000);
        const sdp = await peerConnection.createOffer();
        await peerConnection.setLocalDescription(sdp);
        await iceGatheringDone.promise;
        $iLPPT.Events.instance.onEvent(new $iLPPT.PlatformEvent("peer connection: got local SDP.", $iLPPT.EventType.Info));
        this.privProperties.setProperty($14iyq.PropertyId.TalkingAvatarService_WebRTC_SDP, JSON.stringify(peerConnection.localDescription));
        const result = await this.speak("", false);
        if (result.reason !== $14iyq.ResultReason.SynthesizingAudioCompleted) return new $14iyq.SynthesisResult(result.resultId, result.reason, result.errorDetails, result.properties);
        const sdpAnswerString = atob(result.properties.getProperty($14iyq.PropertyId.TalkingAvatarService_WebRTC_SDP));
        const sdpAnswer = new RTCSessionDescription(JSON.parse(sdpAnswerString));
        await peerConnection.setRemoteDescription(sdpAnswer);
        return new $14iyq.SynthesisResult(result.resultId, result.reason, undefined, result.properties);
    }
    /**
     * Speaks plain text asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param {string} text - The plain text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */ async speakTextAsync(text) {
        const r = await this.speak(text, false);
        return new $14iyq.SynthesisResult(r.resultId, r.reason, r.errorDetails, r.properties);
    }
    /**
     * Speaks SSML asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param {string} ssml - The SSML text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */ async speakSsmlAsync(ssml) {
        const r = await this.speak(ssml, true);
        return new $14iyq.SynthesisResult(r.resultId, r.reason, r.errorDetails, r.properties);
    }
    /**
     * Speaks text asynchronously. The avatar will switch to idle state.
     * @member AvatarSynthesizer.prototype.stopSpeakingAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */ async stopSpeakingAsync() {
        while(this.synthesisRequestQueue.length() > 0){
            const request = await this.synthesisRequestQueue.dequeue();
            request.err("Synthesis is canceled by user.");
        }
        return this.privAdapter.stopSpeaking();
    }
    /**
     * Stops the talking avatar session and closes the WebRTC connection.
     * For now, this is the same as close().
     * You need to create a new AvatarSynthesizer instance to start a new session.
     * @member AvatarSynthesizer.prototype.stopAvatarAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */ async stopAvatarAsync() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposed);
        return this.dispose(true);
    }
    /**
     * Dispose of associated resources.
     * @member AvatarSynthesizer.prototype.close
     * @function
     * @public
     */ async close() {
        if (this.privDisposed) return;
        return this.dispose(true);
    }
    /**
     * Gets the ICE servers. Internal use only.
     */ get iceServers() {
        return this.privIceServers;
    }
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new $h6sQE.AvatarSynthesisAdapter(authentication, connectionFactory, synthesizerConfig, this, this.privAvatarConfig);
    }
    createRestSynthesisAdapter(_authentication, _synthesizerConfig) {
        return undefined;
    }
    createSynthesizerConfig(speechConfig) {
        const config = super.createSynthesizerConfig(speechConfig);
        config.avatarEnabled = true;
        return config;
    }
    async speak(text, isSSML) {
        const requestId = $iLPPT.createNoDashGuid();
        const deferredResult = new $iLPPT.Deferred();
        this.synthesisRequestQueue.enqueue(new $aPoyg.SynthesisRequest(requestId, text, isSSML, (e)=>{
            deferredResult.resolve(e);
            this.privSynthesizing = false;
            this.adapterSpeak();
        }, (e)=>{
            deferredResult.reject(e);
            this.privSynthesizing = false;
        }));
        this.adapterSpeak();
        return deferredResult.promise;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config.
     * @param {AvatarConfig} avatarConfig - The talking avatar config.
     */ constructor(speechConfig, avatarConfig){
        super(speechConfig);
        $3afpL.Contracts.throwIfNullOrUndefined(avatarConfig, "avatarConfig");
        this.privConnectionFactory = new $jCyuG.SpeechSynthesisConnectionFactory();
        this.privAvatarConfig = avatarConfig;
        this.implCommonSynthesizeSetup();
    }
}
module.exports.AvatarSynthesizer = $7211bb99d8f072d0$var$AvatarSynthesizer;

});
parcelRegister("jCyuG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");
class $e48c52b14e04b500$var$SpeechSynthesisConnectionFactory {
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
        const endpointId = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const hostPrefix = endpointId === undefined ? "tts" : "voice";
        const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
        const queryParams = {};
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        if (endpointId !== undefined && endpointId !== "") {
            if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.CustomVoiceDeploymentId) === -1) queryParams[$dq5v3.QueryParameterNames.CustomVoiceDeploymentId] = endpointId;
        }
        if (config.avatarEnabled) {
            if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.EnableAvatar) === -1) queryParams[$dq5v3.QueryParameterNames.EnableAvatar] = "true";
        }
        if (!endpoint) endpoint = host + this.synthesisUri;
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromParameters(config.parameters), enableCompression, connectionId);
    }
    constructor(){
        this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
}
module.exports.SpeechSynthesisConnectionFactory = $e48c52b14e04b500$var$SpeechSynthesisConnectionFactory;

});


parcelRegister("9gmDv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarVideoFormat = module.exports.Coordinate = void 0;
/* eslint-disable max-classes-per-file */ /**
 * Defines a coordinate in 2D space.
 * @class Coordinate
 * Added in version 1.33.0
 */ class $6be72ac6264f46b8$var$Coordinate {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
module.exports.Coordinate = $6be72ac6264f46b8$var$Coordinate;
/**
 * Defines the avatar output video format.
 * @class AvatarVideoFormat
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change in the future.
 */ class $6be72ac6264f46b8$var$AvatarVideoFormat {
    /**
     * Sets the video crop range.
     */ setCropRange(topLeft, bottomRight) {
        this.cropRange = {
            bottomRight: bottomRight,
            topLeft: topLeft
        };
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} codec - The video codec.
     * @param {number} bitrate - The video bitrate.
     * @param {number} width - The video width.
     * @param {number} height - The video height.
     */ constructor(codec = "H264", bitrate = 2000000, width = 1920, height = 1080){
        this.codec = codec;
        this.bitrate = bitrate;
        this.width = width;
        this.height = height;
    }
}
module.exports.AvatarVideoFormat = $6be72ac6264f46b8$var$AvatarVideoFormat;

});

parcelRegister("1iS1y", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarWebRTCConnectionResult = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Defines the avatar WebRTC connection result.
 * @class AvatarWebRTCConnectionResult
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change in the future.
 */ class $0f3160f5b0cd9519$var$AvatarWebRTCConnectionResult extends $14iyq.SynthesisResult {
    /**
     * Specifies SDP (Session Description Protocol) answer of WebRTC connection.
     * @member AvatarWebRTCConnectionResult.prototype.SDPAnswer
     * @function
     * @public
     * @returns {RTCSessionDescriptionInit} Specifies the SDP answer of WebRTC connection.
     */ get SDPAnswer() {
        return this.privSDPAnswer;
    }
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {RTCSessionDescriptionInit} SDPAnswer - The SDP answer of WebRTC connection.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(SDPAnswer, resultId, reason, errorDetails, properties){
        super(resultId, reason, errorDetails, properties);
        this.privSDPAnswer = SDPAnswer;
    }
}
module.exports.AvatarWebRTCConnectionResult = $0f3160f5b0cd9519$var$AvatarWebRTCConnectionResult;

});

parcelRegister("ua2zW", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $iLPPT = parcelRequire("iLPPT");
/**
 * Defines diagnostics API for managing console output
 * Added in version 1.21.0
 */ class $05aa974f369489c5$var$Diagnostics {
    static SetLoggingLevel(logLevel) {
        this.privListener = new $1JzGB.ConsoleLoggingListener(logLevel);
        $iLPPT.Events.instance.attachConsoleListener(this.privListener);
    }
    static StartConsoleOutput() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = true;
    }
    static StopConsoleOutput() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = false;
    }
    static SetLogOutputPath(path) {
        if (typeof window === "undefined") {
            if (!!this.privListener) this.privListener.logPath = path;
        } else throw new Error("File system logging not available in browser.");
    }
    static set onLogOutput(callback) {
        if (!!this.privListener) this.privListener.logCallback = callback;
    }
}
module.exports.Diagnostics = $05aa974f369489c5$var$Diagnostics;
$05aa974f369489c5$var$Diagnostics.privListener = undefined;

});



parcelRegister("kjmGU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ec972efa385f1b01$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestMessageAdapter = module.exports.RestRequestType = void 0;

const $ec972efa385f1b01$var$bent_1 = $ec972efa385f1b01$var$__importDefault((parcelRequire("igK0o")));

var $iLPPT = parcelRequire("iLPPT");
var $ec972efa385f1b01$var$RestRequestType;
(function(RestRequestType) {
    RestRequestType["Get"] = "GET";
    RestRequestType["Post"] = "POST";
    RestRequestType["Delete"] = "DELETE";
    RestRequestType["File"] = "file";
})($ec972efa385f1b01$var$RestRequestType = module.exports.RestRequestType || (module.exports.RestRequestType = {}));
// accept rest operations via request method and return abstracted objects from server response
class $ec972efa385f1b01$var$RestMessageAdapter {
    static extractHeaderValue(headerKey, headers) {
        let headerValue = "";
        try {
            const arr = headers.trim().split(/[\r\n]+/);
            const headerMap = {};
            arr.forEach((line)=>{
                const parts = line.split(": ");
                const header = parts.shift().toLowerCase();
                const value = parts.join(": ");
                headerMap[header] = value;
            });
            headerValue = headerMap[headerKey.toLowerCase()];
        } catch (e) {
        // ignore the error
        }
        return headerValue;
    }
    set options(configParams) {
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    setHeaders(key, value) {
        this.privHeaders[key] = value;
    }
    request(method, uri, queryParams = {}, body = null) {
        const responseReceivedDeferral = new $iLPPT.Deferred();
        const requestCommand = method === $ec972efa385f1b01$var$RestRequestType.File ? "POST" : method;
        const handleRestResponse = (data, j = {})=>{
            const d = data;
            return {
                data: JSON.stringify(j),
                headers: JSON.stringify(data.headers),
                json: j,
                ok: data.statusCode >= 200 && data.statusCode < 300,
                status: data.statusCode,
                statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        };
        const send = (postData)=>{
            const sendRequest = $ec972efa385f1b01$var$bent_1.default(uri, requestCommand, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
            const params = this.queryParams(queryParams) === "" ? "" : `?${this.queryParams(queryParams)}`;
            sendRequest(params, postData).then(async (data)=>{
                if (method === $ec972efa385f1b01$var$RestRequestType.Delete || data.statusCode === 204) // No JSON from Delete and reset (204) operations
                responseReceivedDeferral.resolve(handleRestResponse(data));
                else try {
                    const j = await data.json();
                    responseReceivedDeferral.resolve(handleRestResponse(data, j));
                } catch  {
                    responseReceivedDeferral.resolve(handleRestResponse(data));
                }
            }).catch((error)=>{
                responseReceivedDeferral.reject(error);
            });
        };
        if (this.privIgnoreCache) this.privHeaders["Cache-Control"] = "no-cache";
        if (method === $ec972efa385f1b01$var$RestRequestType.Post && body) {
            this.privHeaders["content-type"] = "application/json";
            this.privHeaders["Content-Type"] = "application/json";
        }
        send(body);
        return responseReceivedDeferral.promise;
    }
    queryParams(params = {}) {
        return Object.keys(params).map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
    }
    constructor(configParams){
        if (!configParams) throw new $iLPPT.ArgumentNullError("configParams");
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
}
module.exports.RestMessageAdapter = $ec972efa385f1b01$var$RestMessageAdapter;

});
parcelRegister("igK0o", function(module, exports) {
"use strict";

var $6lS2Y = parcelRequire("6lS2Y");
class $d4cd68530fe62fcd$var$StatusError extends Error {
    constructor(res, ...params){
        super(...params);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d4cd68530fe62fcd$var$StatusError);
        this.name = "StatusError";
        this.message = res.statusMessage;
        this.statusCode = res.status;
        this.res = res;
        this.json = res.json.bind(res);
        this.text = res.text.bind(res);
        this.arrayBuffer = res.arrayBuffer.bind(res);
        let buffer;
        const get = ()=>{
            if (!buffer) buffer = this.arrayBuffer();
            return buffer;
        };
        Object.defineProperty(this, "responseBody", {
            get: get
        });
        // match Node.js headers object
        this.headers = {};
        for (const [key, value] of res.headers.entries())this.headers[key.toLowerCase()] = value;
    }
}
const $d4cd68530fe62fcd$var$mkrequest = (statusCodes, method, encoding, headers, baseurl)=>async (_url, body, _headers = {})=>{
        _url = baseurl + (_url || "");
        let parsed = new URL(_url);
        if (!headers) headers = {};
        if (parsed.username) {
            headers.Authorization = "Basic " + btoa(parsed.username + ":" + parsed.password);
            parsed = new URL(parsed.protocol + "//" + parsed.host + parsed.pathname + parsed.search);
        }
        if (parsed.protocol !== "https:" && parsed.protocol !== "http:") throw new Error(`Unknown protocol, ${parsed.protocol}`);
        if (body) {
            if (body instanceof ArrayBuffer || ArrayBuffer.isView(body) || typeof body === "string") ;
            else if (typeof body === "object") {
                body = JSON.stringify(body);
                headers["Content-Type"] = "application/json";
            } else throw new Error("Unknown body type.");
        }
        _headers = new Headers({
            ...headers || {},
            ..._headers
        });
        const resp = await fetch(parsed, {
            method: method,
            headers: _headers,
            body: body
        });
        resp.statusCode = resp.status;
        if (!statusCodes.has(resp.status)) throw new $d4cd68530fe62fcd$var$StatusError(resp);
        if (encoding === "json") return resp.json();
        else if (encoding === "buffer") return resp.arrayBuffer();
        else if (encoding === "string") return resp.text();
        else return resp;
    };
module.exports = $6lS2Y($d4cd68530fe62fcd$var$mkrequest);

});
parcelRegister("6lS2Y", function(module, exports) {
"use strict";
const $49fea0d6dcf4bc99$var$encodings = new Set([
    "json",
    "buffer",
    "string"
]);
module.exports = (mkrequest)=>(...args)=>{
        const statusCodes = new Set();
        let method;
        let encoding;
        let headers;
        let baseurl = "";
        args.forEach((arg)=>{
            if (typeof arg === "string") {
                if (arg.toUpperCase() === arg) {
                    if (method) {
                        const msg = `Can't set method to ${arg}, already set to ${method}.`;
                        throw new Error(msg);
                    } else method = arg;
                } else if (arg.startsWith("http:") || arg.startsWith("https:")) baseurl = arg;
                else {
                    if ($49fea0d6dcf4bc99$var$encodings.has(arg)) encoding = arg;
                    else throw new Error(`Unknown encoding, ${arg}`);
                }
            } else if (typeof arg === "number") statusCodes.add(arg);
            else if (typeof arg === "object") {
                if (Array.isArray(arg) || arg instanceof Set) arg.forEach((code)=>statusCodes.add(code));
                else {
                    if (headers) throw new Error("Cannot set headers twice.");
                    headers = arg;
                }
            } else throw new Error(`Unknown type: ${typeof arg}`);
        });
        if (!method) method = "GET";
        if (statusCodes.size === 0) statusCodes.add(200);
        return mkrequest(statusCodes, method, encoding, headers, baseurl);
    };

});



parcelRegister("8v5nd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestConfigBase = void 0;
class $63056302504000e7$var$RestConfigBase {
    static get requestOptions() {
        return $63056302504000e7$var$RestConfigBase.privDefaultRequestOptions;
    }
    static get configParams() {
        return $63056302504000e7$var$RestConfigBase.privDefaultParams;
    }
    static get restErrors() {
        return $63056302504000e7$var$RestConfigBase.privRestErrors;
    }
}
module.exports.RestConfigBase = $63056302504000e7$var$RestConfigBase;
$63056302504000e7$var$RestConfigBase.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: false,
    timeout: 10000
};
$63056302504000e7$var$RestConfigBase.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$63056302504000e7$var$RestConfigBase.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};

});



parcelRegister("fN7yD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileConnectionFactory = module.exports.SpeakerRecognitionConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");
class $b7f14b6170ccb042$var$SpeakerRecognitionConnectionFactoryBase extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, endpointPath, connectionId) {
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint);
        if (!endpoint) {
            const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region);
            const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, `wss://${region}.spr-frontend.speech${hostSuffix}`);
            const scenario = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_SpeakerIdMode, "TextIndependentIdentification");
            endpoint = `${host}/speaker/ws/${this.scenarioToPath(scenario)}/${endpointPath}`;
        }
        const queryParams = {
            format: "simple",
            language: config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(config, queryParams, endpoint);
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        headers[$7Us8Y.HeaderNames.SpIDAuthKey] = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Key);
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    scenarioToPath(mode) {
        switch(mode){
            case "TextIndependentVerification":
            case "2":
                return "verification/text-independent";
            case "TextDependentVerification":
            case "1":
                return "verification/text-dependent";
            default:
                return "identification/text-independent";
        }
    }
}
class $b7f14b6170ccb042$var$SpeakerRecognitionConnectionFactory extends $b7f14b6170ccb042$var$SpeakerRecognitionConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        return super.create(config, authInfo, "recognition", connectionId);
    }
}
module.exports.SpeakerRecognitionConnectionFactory = $b7f14b6170ccb042$var$SpeakerRecognitionConnectionFactory;
class $b7f14b6170ccb042$var$VoiceProfileConnectionFactory extends $b7f14b6170ccb042$var$SpeakerRecognitionConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        return super.create(config, authInfo, "profile", connectionId);
    }
}
module.exports.VoiceProfileConnectionFactory = $b7f14b6170ccb042$var$VoiceProfileConnectionFactory;

});

parcelRegister("1cFkL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEndedEvent = module.exports.RecognitionCompletionStatus = module.exports.RecognitionStartedEvent = module.exports.ConnectingToServiceEvent = module.exports.ListeningStartedEvent = module.exports.RecognitionTriggeredEvent = module.exports.SpeechRecognitionEvent = void 0;

var $iLPPT = parcelRequire("iLPPT");
class $0e06f979de9f9a58$var$SpeechRecognitionEvent extends $iLPPT.PlatformEvent {
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
    constructor(eventName, requestId, sessionId, eventType = $iLPPT.EventType.Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
        this.privSessionId = sessionId;
    }
}
module.exports.SpeechRecognitionEvent = $0e06f979de9f9a58$var$SpeechRecognitionEvent;
class $0e06f979de9f9a58$var$RecognitionTriggeredEvent extends $0e06f979de9f9a58$var$SpeechRecognitionEvent {
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("RecognitionTriggeredEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
}
module.exports.RecognitionTriggeredEvent = $0e06f979de9f9a58$var$RecognitionTriggeredEvent;
class $0e06f979de9f9a58$var$ListeningStartedEvent extends $0e06f979de9f9a58$var$SpeechRecognitionEvent {
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("ListeningStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
}
module.exports.ListeningStartedEvent = $0e06f979de9f9a58$var$ListeningStartedEvent;
class $0e06f979de9f9a58$var$ConnectingToServiceEvent extends $0e06f979de9f9a58$var$SpeechRecognitionEvent {
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
    constructor(requestId, authFetchEventid, sessionId){
        super("ConnectingToServiceEvent", requestId, sessionId);
        this.privAuthFetchEventid = authFetchEventid;
    }
}
module.exports.ConnectingToServiceEvent = $0e06f979de9f9a58$var$ConnectingToServiceEvent;
class $0e06f979de9f9a58$var$RecognitionStartedEvent extends $0e06f979de9f9a58$var$SpeechRecognitionEvent {
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId){
        super("RecognitionStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
    }
}
module.exports.RecognitionStartedEvent = $0e06f979de9f9a58$var$RecognitionStartedEvent;
var $0e06f979de9f9a58$var$RecognitionCompletionStatus;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($0e06f979de9f9a58$var$RecognitionCompletionStatus = module.exports.RecognitionCompletionStatus || (module.exports.RecognitionCompletionStatus = {}));
class $0e06f979de9f9a58$var$RecognitionEndedEvent extends $0e06f979de9f9a58$var$SpeechRecognitionEvent {
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    get serviceTag() {
        return this.privServiceTag;
    }
    get status() {
        return this.privStatus;
    }
    get error() {
        return this.privError;
    }
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error){
        super("RecognitionEndedEvent", requestId, sessionId, status === $0e06f979de9f9a58$var$RecognitionCompletionStatus.Success ? $iLPPT.EventType.Info : $iLPPT.EventType.Error);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
        this.privStatus = status;
        this.privError = error;
        this.privServiceTag = serviceTag;
    }
}
module.exports.RecognitionEndedEvent = $0e06f979de9f9a58$var$RecognitionEndedEvent;

});

parcelRegister("g63fN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceRecognizerBase = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $gsMVS = parcelRequire("gsMVS");
class $bb7fbb087032a2d6$var$ServiceRecognizerBase {
    setTranslationJson() {
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            const languages = targetLanguages.split(",");
            const translationVoice = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
            const action = translationVoice !== undefined ? "Synthesize" : "None";
            this.privSpeechContext.setSection("translation", {
                onSuccess: {
                    action: action
                },
                output: {
                    interimResults: {
                        mode: "Always"
                    }
                },
                targetLanguages: languages
            });
            if (translationVoice !== undefined) {
                const languageToVoiceMap = {};
                for (const lang of languages)languageToVoiceMap[lang] = translationVoice;
                this.privSpeechContext.setSection("synthesis", {
                    defaultVoices: languageToVoiceMap
                });
            }
        }
    }
    setSpeechSegmentationTimeoutJson() {
        const speechSegmentationTimeout = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.Speech_SegmentationSilenceTimeoutMs, undefined);
        if (speechSegmentationTimeout !== undefined) {
            const mode = this.recognitionMode === $h6sQE.RecognitionMode.Conversation ? "CONVERSATION" : this.recognitionMode === $h6sQE.RecognitionMode.Dictation ? "DICTATION" : "INTERACTIVE";
            const segmentationSilenceTimeoutMs = parseInt(speechSegmentationTimeout, 10);
            const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = mode;
            phraseDetection[mode] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: segmentationSilenceTimeoutMs
                }
            };
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    }
    setLanguageIdJson() {
        const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== undefined) {
            const sourceLanguages = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
            let speechContextLidMode;
            if (this.privRecognizerConfig.languageIdMode === "Continuous") speechContextLidMode = "DetectContinuous";
            else speechContextLidMode = "DetectAtAudioStart";
            this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: sourceLanguages,
                mode: speechContextLidMode,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            const customModels = this.privRecognizerConfig.sourceLanguageModels;
            if (customModels !== undefined) {
                phraseDetection.customModels = customModels;
                phraseDetection.onInterim = {
                    action: "None"
                };
                phraseDetection.onSuccess = {
                    action: "None"
                };
            }
        }
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            phraseDetection.onInterim = {
                action: "Translate"
            };
            phraseDetection.onSuccess = {
                action: "Translate"
            };
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "None"
                },
                phraseResults: {
                    resultType: "None"
                }
            });
        }
        this.privSpeechContext.setSection("phraseDetection", phraseDetection);
    }
    setOutputDetailLevelJson() {
        if (this.privEnableSpeakerId) {
            const requestWordLevelTimestamps = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase();
            if (requestWordLevelTimestamps === "true") this.privSpeechContext.setWordLevelTimings();
            else {
                const outputFormat = this.privRecognizerConfig.parameters.getProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]).toLowerCase();
                if (outputFormat === $14iyq.OutputFormat[$14iyq.OutputFormat.Detailed].toLocaleLowerCase()) this.privSpeechContext.setDetailedOutputFormat();
            }
        }
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(token) {
        this.privRecognizerConfig.parameters.setProperty($14iyq.PropertyId.ConversationTranslator_Token, token);
    }
    set voiceProfileType(type) {
        this.privRecognizerConfig.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_SpeakerIdMode, type);
    }
    set authentication(auth) {
        this.privAuthentication = auth;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    async dispose(reason) {
        this.privIsDisposed = true;
        if (this.privConnectionConfigurationPromise !== undefined) try {
            const connection = await this.privConnectionConfigurationPromise;
            await connection.dispose(reason);
        } catch (error) {
            // The connection is in a bad state. But we're trying to kill it, so...
            return;
        }
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    async recognize(recoMode, successCallback, errorCallBack) {
        if (this.recognizeOverride !== undefined) {
            await this.recognizeOverride(recoMode, successCallback, errorCallBack);
            return;
        }
        // Clear the existing configuration promise to force a re-transmission of config and context.
        this.privConnectionConfigurationPromise = undefined;
        this.privRecognizerConfig.recognitionMode = recoMode;
        this.setSpeechSegmentationTimeoutJson();
        this.setTranslationJson();
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallBack;
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        let audioNode;
        try {
            const audioStreamNode = await this.audioSource.attach(this.privRequestSession.audioNodeId);
            const format = await this.audioSource.format;
            const deviceInfo = await this.audioSource.deviceInfo;
            this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === $h6sQE.type.Microphones;
            audioNode = new $1JzGB.ReplayableAudioNode(audioStreamNode, format.avgBytesPerSec);
            await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
        } catch (error) {
            await this.privRequestSession.onStopRecognizing();
            throw error;
        }
        try {
            await conPromise;
        } catch (error) {
            await this.cancelRecognitionLocal($14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.ConnectionFailure, error);
            return;
        }
        const sessionStartEventArgs = new $14iyq.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        audioSendPromise.catch(async (error)=>{
            await this.cancelRecognitionLocal($14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.RuntimeError, error);
        });
        return;
    }
    async stopRecognizing() {
        if (this.privRequestSession.isRecognizing) try {
            await this.audioSource.turnOff();
            await this.sendFinalAudio();
            await this.privRequestSession.onStopRecognizing();
            await this.privRequestSession.turnCompletionPromise;
        } finally{
            await this.privRequestSession.dispose();
        }
        return;
    }
    async connect() {
        await this.connectImpl();
        return Promise.resolve();
    }
    connectAsync(cb, err) {
        this.connectImpl().then(()=>{
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, (reason)=>{
            try {
                if (!!err) err(reason);
            /* eslint-disable no-empty */ } catch (error) {}
        });
    }
    async disconnect() {
        await this.cancelRecognitionLocal($14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.NoError, "Disconnecting");
        if (this.disconnectOverride !== undefined) await this.disconnectOverride();
        if (this.privConnectionPromise !== undefined) try {
            await (await this.privConnectionPromise).dispose();
        } catch (error) {}
        this.privConnectionPromise = undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(message) {
        return;
    }
    async sendNetworkMessage(path, payload) {
        const type = typeof payload === "string" ? $iLPPT.MessageType.Text : $iLPPT.MessageType.Binary;
        const contentType = typeof payload === "string" ? "application/json" : "";
        const connection = await this.fetchConnection();
        return connection.send(new $gsMVS.SpeechConnectionMessage(type, path, this.privRequestSession.requestId, contentType, payload));
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set expectContentAssessmentResponse(value) {
        this.privExpectContentAssessmentResponse = value;
    }
    async sendTelemetryData() {
        const telemetryData = this.privRequestSession.getTelemetry();
        if ($bb7fbb087032a2d6$var$ServiceRecognizerBase.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return;
        if (!!$bb7fbb087032a2d6$var$ServiceRecognizerBase.telemetryData) try {
            $bb7fbb087032a2d6$var$ServiceRecognizerBase.telemetryData(telemetryData);
        /* eslint-disable no-empty */ } catch  {}
        const connection = await this.fetchConnection();
        await connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData));
    }
    // Cancels recognition.
    async cancelRecognitionLocal(cancellationReason, errorCode, error) {
        if (!!this.privRequestSession.isRecognizing) {
            await this.privRequestSession.onStopRecognizing();
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
        }
    }
    async receiveMessage() {
        try {
            if (this.privIsDisposed) // We're done.
            return;
            let connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
            // indicates we are draining the queue and it came with no message;
            if (!message) return this.receiveMessage();
            this.privServiceHasSentMessage = true;
            const connectionMessage = $gsMVS.SpeechConnectionMessage.fromConnectionMessage(message);
            if (connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                case "turn.start":
                    this.privMustReportEndOfStream = true;
                    this.privRequestSession.onServiceTurnStartResponse();
                    break;
                case "speech.startdetected":
                    const speechStartDetected = $h6sQE.SpeechDetected.fromJSON(connectionMessage.textBody);
                    const speechStartEventArgs = new $14iyq.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                    if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                    break;
                case "speech.enddetected":
                    let json;
                    if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                    else // If the request was empty, the JSON returned is empty.
                    json = "{ Offset: 0 }";
                    const speechStopDetected = $h6sQE.SpeechDetected.fromJSON(json);
                    const speechStopEventArgs = new $14iyq.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                    if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                    break;
                case "turn.end":
                    await this.sendTelemetryData();
                    if (this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream) {
                        this.privMustReportEndOfStream = false;
                        await this.cancelRecognitionLocal($14iyq.CancellationReason.EndOfStream, $14iyq.CancellationErrorCode.NoError, undefined);
                    }
                    const sessionStopEventArgs = new $14iyq.SessionEventArgs(this.privRequestSession.sessionId);
                    await this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition);
                    if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                        return;
                    } else {
                        connection = await this.fetchConnection();
                        await this.sendPrePayloadJSON(connection);
                    }
                    break;
                default:
                    if (!await this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                    {
                        if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $iLPPT.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                    }
            }
            return this.receiveMessage();
        } catch (error) {
            return null;
        }
    }
    updateSpeakerDiarizationAudioOffset() {
        const bytesSent = this.privRequestSession.recognitionBytesSent;
        const audioOffsetMs = bytesSent / this.privAverageBytesPerMs;
        this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(audioOffsetMs);
    }
    sendSpeechContext(connection, generateNewRequestId) {
        if (this.privEnableSpeakerId) this.updateSpeakerDiarizationAudioOffset();
        const speechContextJson = this.speechContext.toJSON();
        if (generateNewRequestId) this.privRequestSession.onSpeechContext();
        if (speechContextJson) return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
        return;
    }
    noOp() {
        // operation not supported
        return;
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendPrePayloadJSON(connection, generateNewRequestId = true) {
        if (this.sendPrePayloadJSONOverride !== undefined) return this.sendPrePayloadJSONOverride(connection);
        await this.sendSpeechContext(connection, generateNewRequestId);
        await this.sendWaveHeader(connection);
        return;
    }
    async sendWaveHeader(connection) {
        const format = await this.audioSource.format;
        // this.writeBufferToConsole(format.header);
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header));
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        if (this.privConnectionPromise !== undefined) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === $iLPPT.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, requestSession, SpeechServiceConfigJson) {
        requestSession.onSpeechContext();
        // filter out anything that is not required for the service to work.
        if ($bb7fbb087032a2d6$var$ServiceRecognizerBase.telemetryDataEnabled !== true) {
            const withTelemetry = JSON.parse(SpeechServiceConfigJson);
            const replacement = {
                context: {
                    system: withTelemetry.context.system
                }
            };
            SpeechServiceConfigJson = JSON.stringify(replacement);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const json = JSON.parse(SpeechServiceConfigJson);
            json.context.DisableReferenceChannel = "True";
            json.context.MicSpec = "1_0_0";
            SpeechServiceConfigJson = JSON.stringify(json);
        }
        if (SpeechServiceConfigJson) return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
        return;
    }
    async fetchConnection() {
        if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
            if (connection.state() === $iLPPT.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            }
            return this.privConnectionConfigurationPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigurationPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.fetchConnection();
        });
        this.privConnectionConfigurationPromise = this.configureConnection();
        return await this.privConnectionConfigurationPromise;
    }
    async sendAudio(audioStreamNode) {
        const audioFormat = await this.audioSource.format;
        this.privAverageBytesPerMs = audioFormat.avgBytesPerSec / 1000;
        // The time we last sent data to the service.
        let nextSendTime = Date.now();
        // Max amount to send before we start to throttle
        const fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
        const maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
        const startRecogNumber = this.privRequestSession.recogNumber;
        const readAndUploadCycle = async ()=>{
            // If speech is done, stop sending audio.
            if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                const connection = await this.fetchConnection();
                const audioStreamChunk = await audioStreamNode.read();
                // we have a new audio chunk to upload.
                if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                return;
                let payload;
                let sendDelay;
                if (!audioStreamChunk || audioStreamChunk.isEnd) {
                    payload = null;
                    sendDelay = 0;
                } else {
                    payload = audioStreamChunk.buffer;
                    this.privRequestSession.onAudioSent(payload.byteLength);
                    if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                    else sendDelay = Math.max(0, nextSendTime - Date.now());
                }
                if (0 !== sendDelay) await this.delay(sendDelay);
                if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                // Are we still alive?
                if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                    connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(()=>{
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                    });
                    if (!(audioStreamChunk === null || audioStreamChunk === void 0 ? void 0 : audioStreamChunk.isEnd)) // this.writeBufferToConsole(payload);
                    // Regardless of success or failure, schedule the next upload.
                    // If the underlying connection was broken, the next cycle will
                    // get a new connection and re-transmit missing audio automatically.
                    return readAndUploadCycle();
                    else // the audio stream has been closed, no need to schedule next
                    // read-upload cycle.
                    if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                }
            }
        };
        return readAndUploadCycle();
    }
    async retryableConnect() {
        let isUnAuthorized = false;
        this.privAuthFetchEventId = $iLPPT.createNoDashGuid();
        const sessionId = this.privRequestSession.sessionId;
        this.privConnectionId = sessionId !== undefined ? sessionId : $iLPPT.createNoDashGuid();
        this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        let lastStatusCode = 0;
        let lastReason = "";
        while(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount){
            // Get the auth information for the connection. This is a bit of overkill for the current API surface, but leaving the plumbing in place to be able to raise a developer-customer
            // facing event when a connection fails to let them try and provide new auth information.
            const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
            const auth = await authPromise;
            await this.privRequestSession.onAuthCompleted(false);
            // Create the connection
            const connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
            // Attach the telemetry handlers.
            this.privRequestSession.listenForServiceTelemetry(connection.events);
            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
            // it'll stop sending events.
            connection.events.attach((event)=>{
                this.connectionEvents.onEvent(event);
            });
            const response = await connection.open();
            // 200 == everything is fine.
            if (response.statusCode === 200) {
                await this.privRequestSession.onConnectionEstablishCompleted(response.statusCode);
                return Promise.resolve(connection);
            } else if (response.statusCode === 1006) isUnAuthorized = true;
            lastStatusCode = response.statusCode;
            lastReason = response.reason;
            this.privRequestSession.onRetryConnection();
        }
        await this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason);
        return Promise.reject(`Unable to contact server. StatusCode: ${lastStatusCode}, ${this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint)} Reason: ${lastReason}`);
    }
    delay(delayMs) {
        return new Promise((resolve)=>this.privSetTimeout(resolve, delayMs));
    }
    writeBufferToConsole(buffer) {
        let out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            const readView = new Uint8Array(buffer);
            out += `${buffer.byteLength}\r\n`;
            for(let i = 0; i < buffer.byteLength; i++){
                out += readView[i].toString(16).padStart(2, "0") + " ";
                if ((i + 1) % 16 === 0) {
                    // eslint-disable-next-line no-console
                    console.info(out);
                    out = "";
                }
            }
        }
        // eslint-disable-next-line no-console
        console.info(out);
    }
    async sendFinalAudio() {
        const connection = await this.fetchConnection();
        await connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null));
        return;
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
        const connection = await this.connectImpl();
        if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
        await this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
        await this.sendPrePayloadJSON(connection, false);
        return connection;
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        // A promise for a connection, but one that has not had the speech context sent yet.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionPromise = undefined;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.privAverageBytesPerMs = 0;
        this.privEnableSpeakerId = false;
        this.privExpectContentAssessmentResponse = false;
        this.recognizeOverride = undefined;
        this.recognizeSpeaker = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.handleSpeechPhraseMessage = undefined;
        this.handleSpeechHypothesisMessage = undefined;
        if (!authentication) throw new $iLPPT.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $iLPPT.ArgumentNullError("connectionFactory");
        if (!audioSource) throw new $iLPPT.ArgumentNullError("audioSource");
        if (!recognizerConfig) throw new $iLPPT.ArgumentNullError("recognizerConfig");
        this.privEnableSpeakerId = recognizerConfig.isSpeakerDiarizationEnabled;
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new $h6sQE.RequestSession(this.privAudioSource.id());
        this.privConnectionEvents = new $iLPPT.EventSource();
        this.privServiceEvents = new $iLPPT.EventSource();
        this.privDynamicGrammar = new $h6sQE.DynamicGrammarBuilder();
        this.privSpeechContext = new $h6sQE.SpeechContext(this.privDynamicGrammar);
        this.privAgentConfig = new $h6sQE.AgentConfig();
        const webWorkerLoadType = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = $iLPPT.Timeout.setTimeout;
        else {
            if (typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = window.setTimeout.bind(window);
            if (typeof globalThis !== "undefined") // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = globalThis.setTimeout.bind(globalThis);
        }
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) this.cancelRecognitionLocal($14iyq.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $14iyq.CancellationErrorCode.BadRequestParameters : $14iyq.CancellationErrorCode.ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
        if (this.privEnableSpeakerId) this.privDiarizationSessionId = $iLPPT.createNoDashGuid();
        this.setLanguageIdJson();
        this.setOutputDetailLevelJson();
    }
}
module.exports.ServiceRecognizerBase = $bb7fbb087032a2d6$var$ServiceRecognizerBase;
$bb7fbb087032a2d6$var$ServiceRecognizerBase.telemetryDataEnabled = true;

});
parcelRegister("gsMVS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionMessage = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $7Us8Y = parcelRequire("7Us8Y");
class $bfc537dcd981540b$var$SpeechConnectionMessage extends $iLPPT.ConnectionMessage {
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(message) {
        let path = null;
        let requestId = null;
        let contentType = null;
        // let requestTimestamp = null;
        let streamId = null;
        const additionalHeaders = {};
        if (message.headers) {
            for(const headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === $7Us8Y.HeaderNames.Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === $7Us8Y.HeaderNames.RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === $7Us8Y.HeaderNames.ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === $7Us8Y.HeaderNames.RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new $bfc537dcd981540b$var$SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    }
    constructor(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id){
        if (!path) throw new $iLPPT.ArgumentNullError("path");
        if (!requestId) throw new $iLPPT.ArgumentNullError("requestId");
        const headers = {};
        headers[$7Us8Y.HeaderNames.Path] = path;
        headers[$7Us8Y.HeaderNames.RequestId] = requestId;
        headers[$7Us8Y.HeaderNames.RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[$7Us8Y.HeaderNames.ContentType] = contentType;
        if (streamId) headers[$7Us8Y.HeaderNames.RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(const headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) super(messageType, body, headers, id);
        else super(messageType, body, headers);
        this.privPath = path;
        this.privRequestId = requestId;
        this.privContentType = contentType;
        this.privStreamId = streamId;
        this.privAdditionalHeaders = additionalHeaders;
    }
}
module.exports.SpeechConnectionMessage = $bfc537dcd981540b$var$SpeechConnectionMessage;

});


parcelRegister("3oNx7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceRecognizer = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
class $279a093c56c4721a$var$ConversationServiceRecognizer extends $h6sQE.ServiceRecognizerBase {
    processTypeSpecificMessages(connectionMessage) {
        return;
    }
    handleRecognizedCallback(result, offset, sessionId) {
        return;
    }
    handleRecognizingCallback(result, duration, sessionId) {
        return;
    }
    async processSpeechMessages(connectionMessage) {
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                if (!!this.handleSpeechHypothesisMessage) this.handleSpeechHypothesisMessage(connectionMessage.textBody);
                processed = true;
                break;
            case "speech.phrase":
                if (!!this.handleSpeechPhraseMessage) await this.handleSpeechPhraseMessage(connectionMessage.textBody);
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {}
    async handleSpeechPhrase(textBody) {
        const simple = $h6sQE.SimpleSpeechPhrase.fromJSON(textBody);
        const resultReason = $h6sQE.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
        let result;
        const resultProps = new $14iyq.PropertyCollection();
        resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        const simpleOffset = simple.Offset + this.privRequestSession.currentTurnAudioOffset;
        let offset = simpleOffset;
        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
        if ($14iyq.ResultReason.Canceled === resultReason) {
            const cancelReason = $h6sQE.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
            const cancellationErrorCode = $h6sQE.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
            await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $h6sQE.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
        } else if (!(this.privRequestSession.isSpeechEnded && resultReason === $14iyq.ResultReason.NoMatch && simple.RecognitionStatus !== $h6sQE.RecognitionStatus.InitialSilenceTimeout)) {
            if (this.privRecognizerConfig.parameters.getProperty($h6sQE.OutputFormatPropertyName) === $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simpleOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, textBody, resultProps);
            else {
                const detailed = $h6sQE.DetailedSpeechPhrase.fromJSON(textBody);
                const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.Text, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, detailed.SpeakerId, undefined, offsetCorrectedJson, resultProps);
                offset = result.offset;
            }
            this.handleRecognizedCallback(result, offset, this.privRequestSession.sessionId);
        }
    }
    handleSpeechHypothesis(textBody) {
        const hypothesis = $h6sQE.SpeechHypothesis.fromJSON(textBody);
        const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
        const resultProps = new $14iyq.PropertyCollection();
        resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        const result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, $14iyq.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, textBody, resultProps);
        this.privRequestSession.onHypothesis(offset);
        this.handleRecognizingCallback(result, hypothesis.Duration, this.privRequestSession.sessionId);
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.handleSpeechPhraseMessage = async (textBody)=>this.handleSpeechPhrase(textBody);
        this.handleSpeechHypothesisMessage = (textBody)=>this.handleSpeechHypothesis(textBody);
    }
}
module.exports.ConversationServiceRecognizer = $279a093c56c4721a$var$ConversationServiceRecognizer;

});

parcelRegister("9t9fQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognizerConfig = module.exports.SpeechResultFormat = module.exports.RecognitionMode = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
var $6e4e004600d630e8$var$RecognitionMode;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($6e4e004600d630e8$var$RecognitionMode = module.exports.RecognitionMode || (module.exports.RecognitionMode = {}));
var $6e4e004600d630e8$var$SpeechResultFormat;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($6e4e004600d630e8$var$SpeechResultFormat = module.exports.SpeechResultFormat || (module.exports.SpeechResultFormat = {}));
class $6e4e004600d630e8$var$RecognizerConfig {
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(value) {
        this.privRecognitionMode = value;
        this.privRecognitionActivityTimeout = value === $6e4e004600d630e8$var$RecognitionMode.Interactive ? 8000 : 25000;
        this.privSpeechServiceConfig.Recognition = $6e4e004600d630e8$var$RecognitionMode[value];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $6e4e004600d630e8$var$RecognitionMode.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, undefined);
    }
    get sourceLanguageModels() {
        const models = [];
        let modelsExist = false;
        if (this.autoDetectSourceLanguages !== undefined) for (const language of this.autoDetectSourceLanguages.split(",")){
            const customProperty = language + $14iyq.PropertyId.SpeechServiceConnection_EndpointId.toString();
            const modelId = this.parameters.getProperty(customProperty, undefined);
            if (modelId !== undefined) {
                models.push({
                    language: language,
                    endpoint: modelId
                });
                modelsExist = true;
            } else models.push({
                language: language,
                endpoint: ""
            });
        }
        return modelsExist ? models : undefined;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    set isSpeakerDiarizationEnabled(value) {
        this.privEnableSpeakerId = value;
    }
    constructor(speechServiceConfig, parameters){
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $h6sQE.SpeechServiceConfig(new $h6sQE.Context(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        this.privLanguageIdMode = parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_LanguageIdMode, undefined);
        this.privEnableSpeakerId = false;
    }
}
module.exports.RecognizerConfig = $6e4e004600d630e8$var$RecognizerConfig;

});

parcelRegister("1DrjR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dGNzn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageFormatter = void 0;

var $iLPPT = parcelRequire("iLPPT");
const $9f75a615b9f89ec3$var$CRLF = "\r\n";
class $9f75a615b9f89ec3$var$WebsocketMessageFormatter {
    toConnectionMessage(message) {
        const deferral = new $iLPPT.Deferred();
        try {
            if (message.messageType === $iLPPT.MessageType.Text) {
                const textMessage = message.textContent;
                let headers = {};
                let body = null;
                if (textMessage) {
                    const headerBodySplit = textMessage.split("\r\n\r\n");
                    if (headerBodySplit && headerBodySplit.length > 0) {
                        headers = this.parseHeaders(headerBodySplit[0]);
                        if (headerBodySplit.length > 1) body = headerBodySplit[1];
                    }
                }
                deferral.resolve(new $iLPPT.ConnectionMessage(message.messageType, body, headers, message.id));
            } else if (message.messageType === $iLPPT.MessageType.Binary) {
                const binaryMessage = message.binaryContent;
                let headers = {};
                let body = null;
                if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                const dataView = new DataView(binaryMessage);
                const headerLength = dataView.getInt16(0);
                if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                let headersString = "";
                for(let i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                headers = this.parseHeaders(headersString);
                if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                deferral.resolve(new $iLPPT.ConnectionMessage(message.messageType, body, headers, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    fromConnectionMessage(message) {
        const deferral = new $iLPPT.Deferred();
        try {
            if (message.messageType === $iLPPT.MessageType.Text) {
                const payload = `${this.makeHeaders(message)}${$9f75a615b9f89ec3$var$CRLF}${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new $iLPPT.RawWebsocketMessage($iLPPT.MessageType.Text, payload, message.id));
            } else if (message.messageType === $iLPPT.MessageType.Binary) {
                const headersString = this.makeHeaders(message);
                const content = message.binaryBody;
                const headerBuffer = this.stringToArrayBuffer(headersString);
                const headerInt8Array = new Int8Array(headerBuffer);
                const headerLength = headerInt8Array.byteLength;
                const payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                payloadInt8Array[0] = headerLength >> 8 & 0xff;
                payloadInt8Array[1] = headerLength & 0xff;
                payloadInt8Array.set(headerInt8Array, 2);
                if (content) {
                    const bodyInt8Array = new Int8Array(content);
                    payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                }
                const payload = payloadInt8Array.buffer;
                deferral.resolve(new $iLPPT.RawWebsocketMessage($iLPPT.MessageType.Binary, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
    makeHeaders(message) {
        let headersString = "";
        if (message.headers) {
            for(const header in message.headers)if (header) headersString += `${header}: ${message.headers[header]}${$9f75a615b9f89ec3$var$CRLF}`;
        }
        return headersString;
    }
    parseHeaders(headersString) {
        const headers = {};
        if (headersString) {
            const headerMatches = headersString.match(/[^\r\n]+/g);
            if (headers) {
                for (const header of headerMatches)if (header) {
                    const separatorIndex = header.indexOf(":");
                    const headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                    const headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                    headers[headerName] = headerValue;
                }
            }
        }
        return headers;
    }
    stringToArrayBuffer(str) {
        const buffer = new ArrayBuffer(str.length);
        const view = new DataView(buffer);
        for(let i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
        return buffer;
    }
}
module.exports.WebsocketMessageFormatter = $9f75a615b9f89ec3$var$WebsocketMessageFormatter;

});

parcelRegister("iXxQM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $h6sQE = parcelRequire("h6sQE");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");
class $dcd7fea9612996c7$var$SpeechConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
        const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$dq5v3.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.Language) === -1) queryParams[$dq5v3.QueryParameterNames.Language] = language;
        }
        if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.Format) === -1) queryParams[$dq5v3.QueryParameterNames.Format] = config.parameters.getProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]).toLowerCase();
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$dq5v3.QueryParameterNames.EnableLanguageId] = "true";
        this.setCommonUrlParams(config, queryParams, endpoint);
        if (!endpoint) switch(config.recognitionMode){
            case $h6sQE.RecognitionMode.Conversation:
                if (config.parameters.getProperty($h6sQE.ForceDictationPropertyName, "false") === "true") endpoint = host + this.dictationRelativeUri;
                else if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.conversationRelativeUri;
                break;
            case $h6sQE.RecognitionMode.Dictation:
                endpoint = host + this.dictationRelativeUri;
                break;
            default:
                if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.interactiveRelativeUri; // default is interactive
                break;
        }
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
    constructor(){
        super(...arguments);
        this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
        this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
        this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";
        this.universalUri = "/speech/universal/v";
    }
}
module.exports.SpeechConnectionFactory = $dcd7fea9612996c7$var$SpeechConnectionFactory;

});

parcelRegister("poz4A", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriberConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");
class $04c563f33f304e35$var$ConversationTranscriberConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
        const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$dq5v3.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($dq5v3.QueryParameterNames.Language) === -1) queryParams[$dq5v3.QueryParameterNames.Language] = language;
        }
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$dq5v3.QueryParameterNames.EnableLanguageId] = "true";
        this.setV2UrlParams(config, queryParams, endpoint);
        if (!endpoint) endpoint = `${host}${this.universalUri}`;
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
    setV2UrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                $14iyq.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $dq5v3.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $14iyq.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $dq5v3.QueryParameterNames.EnableAudioLogging
            ],
            [
                $14iyq.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $dq5v3.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $14iyq.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $dq5v3.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $dq5v3.QueryParameterNames.Postprocessing
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_ProfanityOption,
                $dq5v3.QueryParameterNames.Profanity
            ],
            [
                $14iyq.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $dq5v3.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty($h6sQE.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
    constructor(){
        super(...arguments);
        this.universalUri = "/speech/universal/v2";
    }
}
module.exports.ConversationTranscriberConnectionFactory = $04c563f33f304e35$var$ConversationTranscriberConnectionFactory;

});

parcelRegister("gC33x", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");
class $c18290cd5cca9ef4$var$TranscriberConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region, "centralus");
        const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
        const hostDefault = "wss://transcribe." + region + ".cts.speech" + hostSuffix + this.multiaudioRelativeUri;
        const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, hostDefault);
        const queryParams = {};
        this.setQueryParams(queryParams, config, endpoint);
        if (!endpoint) endpoint = host;
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    setQueryParams(queryParams, config, endpointUrl) {
        const endpointId = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId && !($dq5v3.QueryParameterNames.CustomSpeechDeploymentId in queryParams)) queryParams[$dq5v3.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        if (language && !($dq5v3.QueryParameterNames.Language in queryParams)) queryParams[$dq5v3.QueryParameterNames.Language] = language;
        const wordLevelTimings = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true";
        const detailed = config.parameters.getProperty($h6sQE.OutputFormatPropertyName, $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) !== $14iyq.OutputFormat[$14iyq.OutputFormat.Simple];
        if (wordLevelTimings || detailed) queryParams[$dq5v3.QueryParameterNames.Format] = $14iyq.OutputFormat[$14iyq.OutputFormat.Detailed].toLowerCase();
        this.setCommonUrlParams(config, queryParams, endpointUrl);
    }
    constructor(){
        super(...arguments);
        this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
    }
}
module.exports.TranscriberConnectionFactory = $c18290cd5cca9ef4$var$TranscriberConnectionFactory;

});

parcelRegister("eLwOj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $Ay9jt = parcelRequire("Ay9jt");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $h6sQE = parcelRequire("h6sQE");

var $7Us8Y = parcelRequire("7Us8Y");

var $dq5v3 = parcelRequire("dq5v3");
class $abfee7f960ce14c1$var$TranslationConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const endpoint = this.getEndpointUrl(config);
        const queryParams = {};
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$dq5v3.QueryParameterNames.EnableLanguageId] = "true";
        this.setQueryParams(queryParams, config, endpoint);
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$7Us8Y.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($14iyq.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, headers, new $h6sQE.WebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    getEndpointUrl(config, returnRegionPlaceholder) {
        const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region);
        const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
        let endpointUrl = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpointUrl) {
            if (config.autoDetectSourceLanguages !== undefined) {
                const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + hostSuffix);
                endpointUrl = host + "/speech/universal/v2";
            } else {
                const host = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + hostSuffix);
                endpointUrl = host + "/speech/translation/cognitiveservices/v1";
            }
        }
        if (returnRegionPlaceholder === true) return endpointUrl;
        return $Ay9jt.StringUtils.formatString(endpointUrl, {
            region: region
        });
    }
    setQueryParams(queryParams, config, endpointUrl) {
        queryParams.from = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
        queryParams.to = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationToLanguages);
        queryParams.scenario = config.recognitionMode === $h6sQE.RecognitionMode.Interactive ? "interactive" : config.recognitionMode === $h6sQE.RecognitionMode.Conversation ? "conversation" : "";
        this.setCommonUrlParams(config, queryParams, endpointUrl);
        this.setUrlParameter($14iyq.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, $dq5v3.QueryParameterNames.StableTranslation, config, queryParams, endpointUrl);
        const translationVoice = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
        if (translationVoice !== undefined) {
            queryParams.voice = translationVoice;
            queryParams.features = "texttospeech";
        }
    }
}
module.exports.TranslationConnectionFactory = $abfee7f960ce14c1$var$TranslationConnectionFactory;

});

parcelRegister("1gp4n", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnumTranslation = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
class $0ebabb5a16473acc$var$EnumTranslation {
    static implTranslateRecognitionResult(recognitionStatus, expectEndOfDictation = false) {
        let reason = $14iyq.ResultReason.Canceled;
        switch(recognitionStatus){
            case $h6sQE.RecognitionStatus.Success:
                reason = $14iyq.ResultReason.RecognizedSpeech;
                break;
            case $h6sQE.RecognitionStatus.EndOfDictation:
                // If we need the result in EndOfDictation (typically some session level result),
                // translate into RecognizedSpeech, otherwise NoMatch
                reason = expectEndOfDictation ? $14iyq.ResultReason.RecognizedSpeech : $14iyq.ResultReason.NoMatch;
                break;
            case $h6sQE.RecognitionStatus.NoMatch:
            case $h6sQE.RecognitionStatus.InitialSilenceTimeout:
            case $h6sQE.RecognitionStatus.BabbleTimeout:
                reason = $14iyq.ResultReason.NoMatch;
                break;
            case $h6sQE.RecognitionStatus.Error:
            case $h6sQE.RecognitionStatus.BadRequest:
            case $h6sQE.RecognitionStatus.Forbidden:
            default:
                reason = $14iyq.ResultReason.Canceled;
                break;
        }
        return reason;
    }
    static implTranslateCancelResult(recognitionStatus) {
        let reason = $14iyq.CancellationReason.EndOfStream;
        switch(recognitionStatus){
            case $h6sQE.RecognitionStatus.Success:
            case $h6sQE.RecognitionStatus.EndOfDictation:
            case $h6sQE.RecognitionStatus.NoMatch:
                reason = $14iyq.CancellationReason.EndOfStream;
                break;
            case $h6sQE.RecognitionStatus.InitialSilenceTimeout:
            case $h6sQE.RecognitionStatus.BabbleTimeout:
            case $h6sQE.RecognitionStatus.Error:
            case $h6sQE.RecognitionStatus.BadRequest:
            case $h6sQE.RecognitionStatus.Forbidden:
            default:
                reason = $14iyq.CancellationReason.Error;
                break;
        }
        return reason;
    }
    static implTranslateCancelErrorCode(recognitionStatus) {
        let reason = $14iyq.CancellationErrorCode.NoError;
        switch(recognitionStatus){
            case $h6sQE.RecognitionStatus.Error:
                reason = $14iyq.CancellationErrorCode.ServiceError;
                break;
            case $h6sQE.RecognitionStatus.TooManyRequests:
                reason = $14iyq.CancellationErrorCode.TooManyRequests;
                break;
            case $h6sQE.RecognitionStatus.BadRequest:
                reason = $14iyq.CancellationErrorCode.BadRequestParameters;
                break;
            case $h6sQE.RecognitionStatus.Forbidden:
                reason = $14iyq.CancellationErrorCode.Forbidden;
                break;
            default:
                reason = $14iyq.CancellationErrorCode.NoError;
                break;
        }
        return reason;
    }
    static implTranslateErrorDetails(cancellationErrorCode) {
        let errorDetails = "The speech service encountered an internal error and could not continue.";
        switch(cancellationErrorCode){
            case $14iyq.CancellationErrorCode.Forbidden:
                errorDetails = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case $14iyq.CancellationErrorCode.BadRequestParameters:
                errorDetails = "Invalid parameter or unsupported audio format in the request.";
                break;
            case $14iyq.CancellationErrorCode.TooManyRequests:
                errorDetails = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
            default:
                break;
        }
        return errorDetails;
    }
}
module.exports.EnumTranslation = $0ebabb5a16473acc$var$EnumTranslation;

});

parcelRegister("gc2Gw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionStatus = module.exports.SynthesisStatus = void 0;
/**
 * @class SynthesisStatus
 * @private
 */ var $bc9fd98126e7c21a$var$SynthesisStatus;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($bc9fd98126e7c21a$var$SynthesisStatus = module.exports.SynthesisStatus || (module.exports.SynthesisStatus = {}));
var $bc9fd98126e7c21a$var$RecognitionStatus;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
    RecognitionStatus[RecognitionStatus["BadRequest"] = 7] = "BadRequest";
    RecognitionStatus[RecognitionStatus["Forbidden"] = 8] = "Forbidden";
})($bc9fd98126e7c21a$var$RecognitionStatus = module.exports.RecognitionStatus || (module.exports.RecognitionStatus = {}));

});

parcelRegister("kmGSs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEnd = void 0;

var $h6sQE = parcelRequire("h6sQE");
class $ed371f47a874d131$var$TranslationSynthesisEnd {
    static fromJSON(json) {
        return new $ed371f47a874d131$var$TranslationSynthesisEnd(json);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
    constructor(json){
        this.privSynthesisEnd = JSON.parse(json);
        if (!!this.privSynthesisEnd.SynthesisStatus) this.privSynthesisEnd.SynthesisStatus = $h6sQE.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
        if (!!this.privSynthesisEnd.Status) this.privSynthesisEnd.SynthesisStatus = $h6sQE.SynthesisStatus[this.privSynthesisEnd.Status];
    }
}
module.exports.TranslationSynthesisEnd = $ed371f47a874d131$var$TranslationSynthesisEnd;

});

parcelRegister("dClu3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationHypothesis = void 0;

var $3afpL = parcelRequire("3afpL");

var $8NfPo = parcelRequire("8NfPo");
class $9e9f7d389c45c782$var$TranslationHypothesis {
    static fromJSON(json) {
        return new $9e9f7d389c45c782$var$TranslationHypothesis(JSON.parse(json));
    }
    static fromTranslationResponse(translationHypothesis) {
        $3afpL.Contracts.throwIfNullOrUndefined(translationHypothesis, "translationHypothesis");
        const hypothesis = translationHypothesis.SpeechHypothesis;
        translationHypothesis.SpeechHypothesis = undefined;
        hypothesis.Translation = translationHypothesis;
        return new $9e9f7d389c45c782$var$TranslationHypothesis(hypothesis);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
    get Language() {
        var _this_privTranslationHypothesis_PrimaryLanguage;
        return (_this_privTranslationHypothesis_PrimaryLanguage = this.privTranslationHypothesis.PrimaryLanguage) === null || _this_privTranslationHypothesis_PrimaryLanguage === void 0 ? void 0 : _this_privTranslationHypothesis_PrimaryLanguage.Language;
    }
    constructor(hypothesis){
        this.privTranslationHypothesis = hypothesis;
        this.privTranslationHypothesis.Translation.TranslationStatus = $8NfPo.TranslationStatus[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
}
module.exports.TranslationHypothesis = $9e9f7d389c45c782$var$TranslationHypothesis;

});

parcelRegister("j6U8n", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationPhrase = void 0;

var $3afpL = parcelRequire("3afpL");

var $h6sQE = parcelRequire("h6sQE");

var $8NfPo = parcelRequire("8NfPo");
class $de9a1eee5e5fb57b$var$TranslationPhrase {
    static fromJSON(json) {
        return new $de9a1eee5e5fb57b$var$TranslationPhrase(JSON.parse(json));
    }
    static fromTranslationResponse(translationResponse) {
        $3afpL.Contracts.throwIfNullOrUndefined(translationResponse, "translationResponse");
        const phrase = translationResponse.SpeechPhrase;
        translationResponse.SpeechPhrase = undefined;
        phrase.Translation = translationResponse;
        phrase.Text = phrase.DisplayText;
        return new $de9a1eee5e5fb57b$var$TranslationPhrase(phrase);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Language() {
        var _this_privTranslationPhrase_PrimaryLanguage;
        return (_this_privTranslationPhrase_PrimaryLanguage = this.privTranslationPhrase.PrimaryLanguage) === null || _this_privTranslationPhrase_PrimaryLanguage === void 0 ? void 0 : _this_privTranslationPhrase_PrimaryLanguage.Language;
    }
    get Confidence() {
        var _this_privTranslationPhrase_PrimaryLanguage;
        return (_this_privTranslationPhrase_PrimaryLanguage = this.privTranslationPhrase.PrimaryLanguage) === null || _this_privTranslationPhrase_PrimaryLanguage === void 0 ? void 0 : _this_privTranslationPhrase_PrimaryLanguage.Confidence;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
    constructor(phrase){
        this.privTranslationPhrase = phrase;
        this.privTranslationPhrase.RecognitionStatus = $h6sQE.RecognitionStatus[this.privTranslationPhrase.RecognitionStatus];
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = $8NfPo.TranslationStatus[this.privTranslationPhrase.Translation.TranslationStatus];
    }
}
module.exports.TranslationPhrase = $de9a1eee5e5fb57b$var$TranslationPhrase;

});

parcelRegister("kcYAa", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationServiceRecognizer = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
// eslint-disable-next-line max-classes-per-file
class $eb63ec069f4ded46$var$TranslationServiceRecognizer extends $h6sQE.ConversationServiceRecognizer {
    async processTypeSpecificMessages(connectionMessage) {
        const resultProps = new $14iyq.PropertyCollection();
        let processed = await this.processSpeechMessages(connectionMessage);
        if (processed) return true;
        const handleTranslationPhrase = async (translatedPhrase)=>{
            this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);
            if (translatedPhrase.RecognitionStatus === $h6sQE.RecognitionStatus.Success) {
                // OK, the recognition was successful. How'd the translation do?
                const result = this.fireEventForResult(translatedPhrase, resultProps);
                if (!!this.privTranslationRecognizer.recognized) try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                // report result to promise.
                if (!!this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(result.result);
                    } catch (e) {
                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                    }
                    // Only invoke the call back once.
                    // and if it's successful don't invoke the
                    // error after that.
                    this.privSuccessCallback = undefined;
                    this.privErrorCallback = undefined;
                }
            } else {
                const reason = $h6sQE.EnumTranslation.implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                const result = new $14iyq.TranslationRecognitionResult(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, translatedPhrase.Language, translatedPhrase.Confidence, undefined, connectionMessage.textBody, resultProps);
                if (reason === $14iyq.ResultReason.Canceled) {
                    const cancelReason = $h6sQE.EnumTranslation.implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                    const cancellationErrorCode = $h6sQE.EnumTranslation.implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $h6sQE.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else {
                    if (!(this.privRequestSession.isSpeechEnded && reason === $14iyq.ResultReason.NoMatch && translatedPhrase.RecognitionStatus !== $h6sQE.RecognitionStatus.InitialSilenceTimeout)) {
                        const ev = new $14iyq.TranslationRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                        if (!!this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                    }
                    // report result to promise.
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                }
                processed = true;
            }
        };
        const handleTranslationHypothesis = (hypothesis, resultProperties)=>{
            const result = this.fireEventForResult(hypothesis, resultProperties);
            this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);
            if (!!this.privTranslationRecognizer.recognizing) try {
                this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
            /* eslint-disable no-empty */ } catch (error) {
            // Not going to let errors in the event handler
            // trip things up.
            }
            processed = true;
        };
        if (connectionMessage.messageType === $iLPPT.MessageType.Text) resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "translation.hypothesis":
                handleTranslationHypothesis($h6sQE.TranslationHypothesis.fromJSON(connectionMessage.textBody), resultProps);
                break;
            case "translation.response":
                const phrase = JSON.parse(connectionMessage.textBody);
                if (!!phrase.SpeechPhrase) await handleTranslationPhrase($h6sQE.TranslationPhrase.fromTranslationResponse(phrase));
                else {
                    const hypothesis = JSON.parse(connectionMessage.textBody);
                    if (!!hypothesis.SpeechHypothesis) handleTranslationHypothesis($h6sQE.TranslationHypothesis.fromTranslationResponse(hypothesis), resultProps);
                }
                break;
            case "translation.phrase":
                await handleTranslationPhrase($h6sQE.TranslationPhrase.fromJSON(connectionMessage.textBody));
                break;
            case "translation.synthesis":
                this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                processed = true;
                break;
            case "audio.end":
            case "translation.synthesis.end":
                const synthEnd = $h6sQE.TranslationSynthesisEnd.fromJSON(connectionMessage.textBody);
                switch(synthEnd.SynthesisStatus){
                    case $h6sQE.SynthesisStatus.Error:
                        if (!!this.privTranslationRecognizer.synthesizing) {
                            const result = new $14iyq.TranslationSynthesisResult($14iyq.ResultReason.Canceled, undefined);
                            const retEvent = new $14iyq.TranslationSynthesisEventArgs(result, this.privRequestSession.sessionId);
                            try {
                                this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privTranslationRecognizer.canceled) {
                            // And raise a canceled event to send the rich(er) error message back.
                            const canceledResult = new $14iyq.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, $14iyq.CancellationReason.Error, synthEnd.FailureReason, $14iyq.CancellationErrorCode.ServiceError, null);
                            try {
                                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        break;
                    case $h6sQE.SynthesisStatus.Success:
                        this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            const cancelEvent = new $14iyq.TranslationRecognitionCanceledEventArgs(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $14iyq.TranslationRecognitionResult(undefined, requestId, $14iyq.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* eslint-disable no-empty */ this.privSuccessCallback = undefined;
            } catch  {}
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new $14iyq.TranslationRecognitionEventArgs($14iyq.TranslationRecognitionResult.fromSpeechRecognitionResult(result), duration, sessionId);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const ev = new $14iyq.TranslationRecognitionEventArgs($14iyq.TranslationRecognitionResult.fromSpeechRecognitionResult(result), offset, sessionId);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    fireEventForResult(serviceResult, properties) {
        let translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new $14iyq.Translations();
            for (const translation of serviceResult.Translation.Translations)translations.set(translation.Language, translation.Text || translation.DisplayText);
        }
        let resultReason;
        let confidence;
        if (serviceResult instanceof $h6sQE.TranslationPhrase) {
            if (!!serviceResult.Translation && serviceResult.Translation.TranslationStatus === $iLPPT.TranslationStatus.Success) resultReason = $14iyq.ResultReason.TranslatedSpeech;
            else resultReason = $14iyq.ResultReason.RecognizedSpeech;
            confidence = serviceResult.Confidence;
        } else resultReason = $14iyq.ResultReason.TranslatingSpeech;
        const language = serviceResult.Language;
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new $14iyq.TranslationRecognitionResult(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, language, confidence, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
        const ev = new $14iyq.TranslationRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    sendSynthesisAudio(audio, sessionId) {
        const reason = undefined === audio ? $14iyq.ResultReason.SynthesizingAudioCompleted : $14iyq.ResultReason.SynthesizingAudio;
        const result = new $14iyq.TranslationSynthesisResult(reason, audio);
        const retEvent = new $14iyq.TranslationSynthesisEventArgs(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer);
        this.privTranslationRecognizer = translationRecognizer;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") this.privTranslationRecognizer.onConnection();
        });
    }
}
module.exports.TranslationServiceRecognizer = $eb63ec069f4ded46$var$TranslationServiceRecognizer;

});

parcelRegister("i19Fr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechDetected = void 0;
class $d1dfd1bf8de88027$var$SpeechDetected {
    static fromJSON(json) {
        return new $d1dfd1bf8de88027$var$SpeechDetected(json);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
    constructor(json){
        this.privSpeechStartDetected = JSON.parse(json);
    }
}
module.exports.SpeechDetected = $d1dfd1bf8de88027$var$SpeechDetected;

});

parcelRegister("4PUi4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechHypothesis = void 0;
class $385796f8b21aaa52$var$SpeechHypothesis {
    static fromJSON(json) {
        return new $385796f8b21aaa52$var$SpeechHypothesis(json);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
    constructor(json){
        this.privSpeechHypothesis = JSON.parse(json);
    }
}
module.exports.SpeechHypothesis = $385796f8b21aaa52$var$SpeechHypothesis;

});

parcelRegister("63ysI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechKeyword = void 0;
class $468dc15bdc3137f5$var$SpeechKeyword {
    static fromJSON(json) {
        return new $468dc15bdc3137f5$var$SpeechKeyword(json);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
    constructor(json){
        this.privSpeechKeyword = JSON.parse(json);
    }
}
module.exports.SpeechKeyword = $468dc15bdc3137f5$var$SpeechKeyword;

});

parcelRegister("lXRrG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechServiceRecognizer = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
// eslint-disable-next-line max-classes-per-file
class $ffd890d32115a40a$var$SpeechServiceRecognizer extends $h6sQE.ServiceRecognizerBase {
    async processTypeSpecificMessages(connectionMessage) {
        let result;
        const resultProps = new $14iyq.PropertyCollection();
        resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                const hypothesis = $h6sQE.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, $14iyq.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new $14iyq.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privSpeechRecognizer.recognizing) try {
                    this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $h6sQE.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                const resultReason = $h6sQE.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus, this.privExpectContentAssessmentResponse);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                if ($14iyq.ResultReason.Canceled === resultReason) {
                    const cancelReason = $h6sQE.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                    const cancellationErrorCode = $h6sQE.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $h6sQE.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else {
                    if (!(this.privRequestSession.isSpeechEnded && resultReason === $14iyq.ResultReason.NoMatch && simple.RecognitionStatus !== $h6sQE.RecognitionStatus.InitialSilenceTimeout)) {
                        if (this.privRecognizerConfig.parameters.getProperty($h6sQE.OutputFormatPropertyName) === $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                        else {
                            const detailed = $h6sQE.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                            const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                            const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                            result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $h6sQE.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, offsetCorrectedJson, resultProps);
                        }
                        const event = new $14iyq.SpeechRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                        if (!!this.privSpeechRecognizer.recognized) try {
                            this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                    }
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            const cancelEvent = new $14iyq.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $14iyq.SpeechRecognitionResult(requestId, $14iyq.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer);
        this.privSpeechRecognizer = speechRecognizer;
    }
}
module.exports.SpeechServiceRecognizer = $ffd890d32115a40a$var$SpeechServiceRecognizer;

});

parcelRegister("aK5bI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionServiceRecognizer = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
// eslint-disable-next-line max-classes-per-file
class $7d22397909351a57$var$ConversationTranscriptionServiceRecognizer extends $h6sQE.ServiceRecognizerBase {
    setSpeakerDiarizationJson() {
        if (this.privEnableSpeakerId) {
            const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = "Conversation";
            const speakerDiarization = {};
            speakerDiarization.mode = "Anonymous";
            speakerDiarization.audioSessionId = this.privDiarizationSessionId;
            speakerDiarization.audioOffsetMs = 0;
            phraseDetection.speakerDiarization = speakerDiarization;
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    }
    async processTypeSpecificMessages(connectionMessage) {
        let result;
        const resultProps = new $14iyq.PropertyCollection();
        resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                const hypothesis = $h6sQE.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $14iyq.ConversationTranscriptionResult(this.privRequestSession.requestId, $14iyq.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new $14iyq.ConversationTranscriptionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privConversationTranscriber.transcribing) try {
                    this.privConversationTranscriber.transcribing(this.privConversationTranscriber, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $h6sQE.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                const resultReason = $h6sQE.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                if ($14iyq.ResultReason.Canceled === resultReason) {
                    const cancelReason = $h6sQE.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                    const cancellationErrorCode = $h6sQE.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $h6sQE.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else if (!(this.privRequestSession.isSpeechEnded && resultReason === $14iyq.ResultReason.NoMatch && simple.RecognitionStatus !== $h6sQE.RecognitionStatus.InitialSilenceTimeout)) {
                    if (this.privRecognizerConfig.parameters.getProperty($h6sQE.OutputFormatPropertyName) === $14iyq.OutputFormat[$14iyq.OutputFormat.Simple]) result = new $14iyq.ConversationTranscriptionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, connectionMessage.textBody, resultProps);
                    else {
                        const detailed = $h6sQE.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                        const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                        const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                        result = new $14iyq.ConversationTranscriptionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $h6sQE.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, simple.SpeakerId, undefined, offsetCorrectedJson, resultProps);
                    }
                    const event = new $14iyq.ConversationTranscriptionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                    if (!!this.privConversationTranscriber.transcribed) try {
                        this.privConversationTranscriber.transcribed(this.privConversationTranscriber, event);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        if (!!this.privConversationTranscriber.canceled) {
            const cancelEvent = new $14iyq.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privConversationTranscriber.canceled(this.privConversationTranscriber, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, conversationTranscriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, conversationTranscriber);
        this.privConversationTranscriber = conversationTranscriber;
        this.setSpeakerDiarizationJson();
    }
}
module.exports.ConversationTranscriptionServiceRecognizer = $7d22397909351a57$var$ConversationTranscriptionServiceRecognizer;

});

parcelRegister("5Npd9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriptionServiceRecognizer = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $gsMVS = parcelRequire("gsMVS");
// eslint-disable-next-line max-classes-per-file
class $438515c26c1a80ec$var$TranscriptionServiceRecognizer extends $h6sQE.ConversationServiceRecognizer {
    async sendSpeechEventAsync(info, command) {
        if (!!this.privRequestSession.isRecognizing) {
            const connection = await this.fetchConnection();
            await this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command));
        }
    }
    async sendMeetingSpeechEventAsync(info, command) {
        if (!!this.privRequestSession.isRecognizing) {
            const connection = await this.fetchConnection();
            await this.sendSpeechEvent(connection, this.createMeetingSpeechEventPayload(info, command));
        }
    }
    processTypeSpecificMessages(connectionMessage) {
        return this.processSpeechMessages(connectionMessage);
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const event = new $14iyq.SpeechRecognitionEventArgs(result, offset, sessionId);
            this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event);
            if (!!this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(result);
                } catch (e) {
                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                }
                // Only invoke the call back once.
                // and if it's successful don't invoke the
                // error after that.
                this.privSuccessCallback = undefined;
                this.privErrorCallback = undefined;
            }
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new $14iyq.SpeechRecognitionEventArgs(result, duration, sessionId);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        if (this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            if (!!this.privTranscriberRecognizer.canceled) {
                const cancelEvent = new $14iyq.MeetingTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
                try {
                    this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
                /* eslint-disable no-empty */ } catch  {}
            }
        } else if (!!this.privTranscriberRecognizer.canceled) {
            const cancelEvent = new $14iyq.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $14iyq.SpeechRecognitionResult(requestId, $14iyq.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendTranscriptionStartJSON(connection) {
        await this.sendSpeechContext(connection, true);
        if (this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            const info = this.privTranscriberRecognizer.getMeetingInfo();
            const payload = this.createMeetingSpeechEventPayload(info, "start");
            await this.sendSpeechEvent(connection, payload);
        } else {
            const info = this.privTranscriberRecognizer.getConversationInfo();
            const payload = this.createSpeechEventPayload(info, "start");
            await this.sendSpeechEvent(connection, payload);
        }
        await this.sendWaveHeader(connection);
        return;
    }
    sendSpeechEvent(connection, payload) {
        const speechEventJson = JSON.stringify(payload);
        if (speechEventJson) return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speech.event", this.privRequestSession.requestId, "application/json", speechEventJson));
        return;
    }
    createSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.conversationProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        return eventDict;
    }
    createMeetingSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.meetingProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        return eventDict;
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, transcriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, transcriber);
        this.privTranscriberRecognizer = transcriber;
        this.sendPrePayloadJSONOverride = (connection)=>this.sendTranscriptionStartJSON(connection);
        if (this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps) === "true") this.privSpeechContext.setWordLevelTimings();
    }
}
module.exports.TranscriptionServiceRecognizer = $438515c26c1a80ec$var$TranscriptionServiceRecognizer;

});

parcelRegister("8fsM1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailedSpeechPhrase = void 0;

var $h6sQE = parcelRequire("h6sQE");
class $60160b4b272a944b$var$DetailedSpeechPhrase {
    static fromJSON(json) {
        return new $60160b4b272a944b$var$DetailedSpeechPhrase(json);
    }
    getJsonWithCorrectedOffsets(baseOffset) {
        if (!!this.privDetailedSpeechPhrase.NBest) {
            let firstWordOffset;
            for (const phrase of this.privDetailedSpeechPhrase.NBest)if (!!phrase.Words && !!phrase.Words[0]) {
                firstWordOffset = phrase.Words[0].Offset;
                break;
            }
            if (!!firstWordOffset && firstWordOffset < baseOffset) {
                const offset = baseOffset - firstWordOffset;
                for (const details of this.privDetailedSpeechPhrase.NBest){
                    if (!!details.Words) for (const word of details.Words)word.Offset += offset;
                    if (!!details.DisplayWords) for (const word of details.DisplayWords)word.Offset += offset;
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        if (!!this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0]) return this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText;
        return this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
    constructor(json){
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = $h6sQE.RecognitionStatus[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
}
module.exports.DetailedSpeechPhrase = $60160b4b272a944b$var$DetailedSpeechPhrase;

});

parcelRegister("8jnyi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleSpeechPhrase = void 0;

var $h6sQE = parcelRequire("h6sQE");
class $60d25e05bbcf0197$var$SimpleSpeechPhrase {
    static fromJSON(json) {
        return new $60d25e05bbcf0197$var$SimpleSpeechPhrase(json);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
    constructor(json){
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = $h6sQE.RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
}
module.exports.SimpleSpeechPhrase = $60d25e05bbcf0197$var$SimpleSpeechPhrase;

});

parcelRegister("hrRlI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddedLmIntent = void 0;
/**
 * @class AddedLmIntent
 */ // eslint-disable-next-line max-classes-per-file
class $cb3e5751a8bdb080$var$AddedLmIntent {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param modelImpl - The model.
     * @param intentName - The intent name.
     */ constructor(modelImpl, intentName){
        this.modelImpl = modelImpl;
        this.intentName = intentName;
    }
}
module.exports.AddedLmIntent = $cb3e5751a8bdb080$var$AddedLmIntent;

});

parcelRegister("8ctu6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentServiceRecognizer = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
// eslint-disable-next-line max-classes-per-file
class $5f8650b69cc3c964$var$IntentServiceRecognizer extends $h6sQE.ServiceRecognizerBase {
    setIntents(addedIntents, umbrellaIntent) {
        this.privAddedLmIntents = addedIntents;
        this.privUmbrellaIntent = umbrellaIntent;
        this.privIntentDataSent = true;
    }
    processTypeSpecificMessages(connectionMessage) {
        let result;
        let ev;
        let processed = false;
        const resultProps = new $14iyq.PropertyCollection();
        if (connectionMessage.messageType === $iLPPT.MessageType.Text) resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
                const speechHypothesis = $h6sQE.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                result = new $14iyq.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $14iyq.ResultReason.RecognizingIntent, speechHypothesis.Text, speechHypothesis.Duration, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, speechHypothesis.Language, speechHypothesis.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(result.offset);
                ev = new $14iyq.IntentRecognitionEventArgs(result, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                if (!!this.privIntentRecognizer.recognizing) try {
                    this.privIntentRecognizer.recognizing(this.privIntentRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $h6sQE.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                result = new $14iyq.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $h6sQE.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus), simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                ev = new $14iyq.IntentRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                const sendEvent = ()=>{
                    if (!!this.privIntentRecognizer.recognized) try {
                        this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    // report result to promise.
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                };
                // If intent data was sent, the terminal result for this recognizer is an intent being found.
                // If no intent data was sent, the terminal event is speech recognition being successful.
                if (false === this.privIntentDataSent || $14iyq.ResultReason.NoMatch === ev.result.reason) {
                    // Advance the buffers.
                    this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                    sendEvent();
                } else // Squirrel away the args, when the response event arrives it will build upon them
                // and then return
                this.privPendingIntentArgs = ev;
                processed = true;
                break;
            case "response":
                // Response from LUIS
                ev = this.privPendingIntentArgs;
                this.privPendingIntentArgs = undefined;
                if (undefined === ev) {
                    if ("" === connectionMessage.textBody) // This condition happens if there is nothing but silence in the
                    // audio sent to the service.
                    return;
                    // Odd... Not sure this can happen
                    ev = new $14iyq.IntentRecognitionEventArgs(new $14iyq.IntentRecognitionResult(), 0, this.privRequestSession.sessionId);
                }
                const intentResponse = $h6sQE.IntentResponse.fromJSON(connectionMessage.textBody);
                // If LUIS didn't return anything, send the existing event, else
                // modify it to show the match.
                // See if the intent found is in the list of intents asked for.
                if (null !== intentResponse && !!intentResponse.topScoringIntent && !!intentResponse.topScoringIntent.intent) {
                    let addedIntent = this.privAddedLmIntents[intentResponse.topScoringIntent.intent];
                    if (this.privUmbrellaIntent !== undefined) addedIntent = this.privUmbrellaIntent;
                    if (!!addedIntent) {
                        const intentId = addedIntent === undefined || addedIntent.intentName === undefined ? intentResponse.topScoringIntent.intent : addedIntent.intentName;
                        let reason = ev.result.reason;
                        if (undefined !== intentId) reason = $14iyq.ResultReason.RecognizedIntent;
                        // make sure, properties is set.
                        const properties = undefined !== ev.result.properties ? ev.result.properties : new $14iyq.PropertyCollection();
                        properties.setProperty($14iyq.PropertyId.LanguageUnderstandingServiceResponse_JsonResult, connectionMessage.textBody);
                        ev = new $14iyq.IntentRecognitionEventArgs(new $14iyq.IntentRecognitionResult(intentId, ev.result.resultId, reason, ev.result.text, ev.result.duration, ev.result.offset, undefined, undefined, ev.result.errorDetails, ev.result.json, properties), ev.offset, ev.sessionId);
                    }
                }
                this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                if (!!this.privIntentRecognizer.recognized) try {
                    this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                // report result to promise.
                if (!!this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(ev.result);
                    } catch (e) {
                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                    }
                    // Only invoke the call back once.
                    // and if it's successful don't invoke the
                    // error after that.
                    this.privSuccessCallback = undefined;
                    this.privErrorCallback = undefined;
                }
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $iLPPT.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        if (!!this.privIntentRecognizer.canceled) {
            const cancelEvent = new $14iyq.IntentRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, undefined, sessionId);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $14iyq.IntentRecognitionResult(undefined, requestId, $14iyq.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privIntentRecognizer = recognizer;
        this.privIntentDataSent = false;
    }
}
module.exports.IntentServiceRecognizer = $5f8650b69cc3c964$var$IntentServiceRecognizer;

});

parcelRegister("gzTst", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentResponse = void 0;
class $c11aef10205bc2d8$var$IntentResponse {
    static fromJSON(json) {
        return new $c11aef10205bc2d8$var$IntentResponse(json);
    }
    get query() {
        return this.privIntentResponse.query;
    }
    get topScoringIntent() {
        return this.privIntentResponse.topScoringIntent;
    }
    get entities() {
        return this.privIntentResponse.entities;
    }
    constructor(json){
        if (json === "") this.privIntentResponse = {};
        else this.privIntentResponse = JSON.parse(json);
    }
}
module.exports.IntentResponse = $c11aef10205bc2d8$var$IntentResponse;

});

parcelRegister("g118i", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("esGkY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestSession = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $1cFkL = parcelRequire("1cFkL");

var $hDGWD = parcelRequire("hDGWD");
class $a8748586892cda98$var$RequestSession {
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    // The number of bytes sent for the current recognition.
    // Counter is reset to 0 each time recognition is started.
    get recognitionBytesSent() {
        return this.privRecognitionBytesSent;
    }
    listenForServiceTelemetry(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privRecognitionBytesSent = 0;
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new $hDGWD.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new $1cFkL.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    async onAudioSourceAttachCompleted(audioNode, isError) {
        this.privAudioNode = audioNode;
        this.privIsAudioNodeDetached = false;
        if (isError) await this.onComplete();
        else this.onEvent(new $1cFkL.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.privSessionId = connectionId;
        this.onEvent(new $1cFkL.ConnectingToServiceEvent(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    async onAuthCompleted(isError) {
        if (isError) await this.onComplete();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async onConnectionEstablishCompleted(statusCode, reason) {
        if (statusCode === 200) {
            this.onEvent(new $1cFkL.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
            if (!!this.privAudioNode) this.privAudioNode.replay();
            this.privTurnStartAudioOffset = this.privLastRecoOffset;
            this.privBytesSent = 0;
            return;
        } else if (statusCode === 403) await this.onComplete();
    }
    async onServiceTurnEndResponse(continuousRecognition) {
        this.privTurnDeferral.resolve();
        if (!continuousRecognition || this.isSpeechEnded) {
            await this.onComplete();
            this.privInTurn = false;
        } else {
            // Start a new request set.
            this.privTurnStartAudioOffset = this.privLastRecoOffset;
            this.privAudioNode.replay();
        }
    }
    onSpeechContext() {
        this.privRequestId = $iLPPT.createNoDashGuid();
    }
    onServiceTurnStartResponse() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $iLPPT.Deferred();
    }
    onHypothesis(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    }
    onPhraseRecognized(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    }
    onServiceRecognized(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    }
    onAudioSent(bytesSent) {
        this.privBytesSent += bytesSent;
        this.privRecognitionBytesSent += bytesSent;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    async dispose() {
        if (!this.privIsDisposed) {
            // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
            for (const detachable of this.privDetachables)await detachable.detach();
            if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.dispose();
            this.privIsRecognizing = false;
        }
    }
    getTelemetry() {
        if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
        else return null;
    }
    async onStopRecognizing() {
        await this.onComplete();
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = true;
    }
    onEvent(event) {
        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    async onComplete() {
        if (!!this.privIsRecognizing) {
            this.privIsRecognizing = false;
            await this.detachAudioNode();
        }
    }
    async detachAudioNode() {
        if (!this.privIsAudioNodeDetached) {
            this.privIsAudioNodeDetached = true;
            if (this.privAudioNode) await this.privAudioNode.detach();
        }
    }
    constructor(audioSourceId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecognitionBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = $iLPPT.createNoDashGuid();
        this.privAudioNodeId = $iLPPT.createNoDashGuid();
        this.privTurnDeferral = new $iLPPT.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
}
module.exports.RequestSession = $a8748586892cda98$var$RequestSession;

});
parcelRegister("hDGWD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceTelemetryListener = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $1cFkL = parcelRequire("1cFkL");
class $cd77641ba87ae7e6$var$ServiceTelemetryListener {
    phraseReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    }
    hypothesisReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    }
    onEvent(e) {
        if (this.privIsDisposed) return;
        if (e instanceof $1cFkL.RecognitionTriggeredEvent && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        };
        if (e instanceof $iLPPT.AudioStreamNodeAttachingEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $iLPPT.AudioStreamNodeAttachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $iLPPT.AudioSourceErrorEvent && e.audioSourceId === this.privAudioSourceId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $iLPPT.AudioStreamNodeErrorEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $iLPPT.AudioStreamNodeDetachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $1cFkL.ConnectingToServiceEvent && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
        if (e instanceof $iLPPT.ConnectionStartEvent && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
        if (e instanceof $iLPPT.ConnectionEstablishedEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $iLPPT.ConnectionEstablishErrorEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Error: this.getConnectionError(e.statusCode),
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $iLPPT.ConnectionMessageReceivedEvent && e.connectionId === this.privConnectionId) {
            if (e.message && e.message.headers && e.message.headers.path) {
                if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                const maxMessagesToSend = 50;
                if (this.privReceivedMessages[e.message.headers.path].length < maxMessagesToSend) this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
            }
        }
    }
    getTelemetry() {
        const metrics = new Array();
        if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
        if (this.privMicMetric) metrics.push(this.privMicMetric);
        if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
        if (this.privPhraseLatencies.length > 0) metrics.push({
            PhraseLatencyMs: this.privPhraseLatencies
        });
        if (this.privHypothesisLatencies.length > 0) metrics.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const telemetry = {
            Metrics: metrics,
            ReceivedMessages: this.privReceivedMessages
        };
        const json = JSON.stringify(telemetry);
        // We dont want to send the same telemetry again. So clean those out.
        this.privReceivedMessages = {};
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
        return json;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = true;
    }
    getConnectionError(statusCode) {
        /*
        -- Websocket status codes --
        NormalClosure = 1000,
        EndpointUnavailable = 1001,
        ProtocolError = 1002,
        InvalidMessageType = 1003,
        Empty = 1005,
        InvalidPayloadData = 1007,
        PolicyViolation = 1008,
        MessageTooBig = 1009,
        MandatoryExtension = 1010,
        InternalServerError = 1011
        */ switch(statusCode){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + statusCode.toString();
        }
    }
    constructor(requestId, audioSourceId, audioNodeId){
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
}
module.exports.ServiceTelemetryListener = $cd77641ba87ae7e6$var$ServiceTelemetryListener;

});


parcelRegister("f6WX2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechContext = void 0;
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $b005250ae9cb1f8e$var$SpeechContext {
    /**
     * Gets a section of the speech.context object.
     * @param sectionName Name of the section to get.
     * @return string or Context JSON serializable object that represents the value.
     */ getSection(sectionName) {
        return this.privContext[sectionName] || {};
    }
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ setPronunciationAssessmentParams(params, contentAssessmentTopic, isSpeakerDiarizationEnabled = false) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        if (this.privContext.phraseDetection.enrichment === undefined) this.privContext.phraseDetection.enrichment = {
            pronunciationAssessment: {}
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        if (isSpeakerDiarizationEnabled) this.privContext.phraseDetection.mode = "Conversation";
        this.setWordLevelTimings();
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1) this.privContext.phraseOutput.detailed.options.push("SNR");
        if (!!contentAssessmentTopic) {
            this.privContext.phraseDetection.enrichment.contentAssessment = {
                topic: contentAssessmentTopic
            };
            this.privContext.phraseOutput.detailed.options.push("ContentAssessment");
        }
    }
    setDetailedOutputFormat() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
    }
    setWordLevelTimings() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    setSpeakerDiarizationAudioOffsetMs(audioOffsetMs) {
        this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = audioOffsetMs;
    }
    toJSON() {
        const dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        const ret = JSON.stringify(this.privContext);
        return ret;
    }
    constructor(dynamicGrammar){
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
}
module.exports.SpeechContext = $b005250ae9cb1f8e$var$SpeechContext;

});

parcelRegister("jrXqN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicGrammarBuilder = void 0;
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ class $e28ea3bb01123025$var$DynamicGrammarBuilder {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = undefined;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = undefined;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        const retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            const retPhrases = [];
            this.privPhrases.forEach((value)=>{
                retPhrases.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases
                }
            ];
        }
        return retObj;
    }
}
module.exports.DynamicGrammarBuilder = $e28ea3bb01123025$var$DynamicGrammarBuilder;

});

parcelRegister("j0A3U", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("c4HeY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceAdapter = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $8ejoP = parcelRequire("8ejoP");

var $iLPPT = parcelRequire("iLPPT");

var $3R9Dx = parcelRequire("3R9Dx");

var $14iyq = parcelRequire("14iyq");

var $u2heM = parcelRequire("u2heM");

var $h6sQE = parcelRequire("h6sQE");

var $agxoM = parcelRequire("agxoM");

var $gsMVS = parcelRequire("gsMVS");
class $8ca7666bca4bb4ae$var$DialogServiceAdapter extends $h6sQE.ServiceRecognizerBase {
    async sendMessage(message) {
        const interactionGuid = $iLPPT.createGuid();
        const requestId = $iLPPT.createNoDashGuid();
        const agentMessage = {
            context: {
                interactionId: interactionGuid
            },
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            messagePayload: JSON.parse(message),
            version: 0.5
        };
        const agentMessageJson = JSON.stringify(agentMessage);
        const connection = await this.fetchConnection();
        await connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "agent", requestId, "application/json", agentMessageJson));
    }
    async privDisconnect() {
        await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        this.agentConfigSent = false;
        return;
    }
    processTypeSpecificMessages(connectionMessage) {
        const resultProps = new $14iyq.PropertyCollection();
        if (connectionMessage.messageType === $iLPPT.MessageType.Text) resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let result;
        let processed;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.phrase":
                const speechPhrase = $h6sQE.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + speechPhrase.Offset + speechPhrase.Duration);
                if (speechPhrase.RecognitionStatus !== $h6sQE.RecognitionStatus.TooManyRequests && speechPhrase.RecognitionStatus !== $h6sQE.RecognitionStatus.Error) {
                    const args = this.fireEventForResult(speechPhrase, resultProps);
                    this.privLastResult = args.result;
                    if (!!this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "speech.hypothesis":
                const hypothesis = $h6sQE.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, $14iyq.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new $14iyq.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.keyword":
                const keyword = $h6sQE.SpeechKeyword.fromJSON(connectionMessage.textBody);
                result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, keyword.Status === "Accepted" ? $14iyq.ResultReason.RecognizedKeyword : $14iyq.ResultReason.NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, connectionMessage.textBody, resultProps);
                if (keyword.Status !== "Accepted") this.privLastResult = result;
                const event = new $14iyq.SpeechRecognitionEventArgs(result, result.duration, result.resultId);
                if (!!this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "audio":
                {
                    const audioRequestId = connectionMessage.requestId.toUpperCase();
                    const turn = this.privTurnStateManager.GetTurn(audioRequestId);
                    try {
                        // Empty binary message signals end of stream.
                        if (!connectionMessage.binaryBody) turn.endAudioStream();
                        else turn.audioStream.write(connectionMessage.binaryBody);
                    } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "response":
                this.handleResponseMessage(connectionMessage);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $iLPPT.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    async cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        if (!!this.privRequestSession.isRecognizing) await this.privRequestSession.onStopRecognizing();
        if (!!this.privDialogServiceConnector.canceled) {
            const properties = new $14iyq.PropertyCollection();
            properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
            const cancelEvent = new $14iyq.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
            if (!!this.privSuccessCallback) {
                const result = new $14iyq.SpeechRecognitionResult(undefined, $14iyq.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                try {
                    this.privSuccessCallback(result);
                    this.privSuccessCallback = undefined;
                /* eslint-disable no-empty */ } catch  {}
            }
        }
    }
    async listenOnce(recoMode, successCallback, errorCallback) {
        this.privRecognizerConfig.recognitionMode = recoMode;
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallback;
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($14iyq.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages();
        const node = await this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privDialogAudioSource.format;
        const deviceInfo = await this.privDialogAudioSource.deviceInfo;
        const audioNode = new $1JzGB.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (error) {
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.ConnectionFailure, error);
            return Promise.resolve();
        }
        const sessionStartEventArgs = new $14iyq.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, async (error)=>{
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.RuntimeError, error);
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    receiveDialogMessageOverride() {
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new $iLPPT.Deferred();
        const loop = async ()=>{
            try {
                const isDisposed = this.isDisposed();
                const terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                if (isDisposed || terminateMessageLoop) {
                    // We're done.
                    communicationCustodian.resolve(undefined);
                    return;
                }
                const connection = await this.fetchConnection();
                const message = await connection.read();
                if (!message) return loop();
                const connectionMessage = $gsMVS.SpeechConnectionMessage.fromConnectionMessage(message);
                switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        {
                            const turnRequestId = connectionMessage.requestId.toUpperCase();
                            const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                            else this.privRequestSession.onServiceTurnStartResponse();
                        }
                        break;
                    case "speech.startdetected":
                        const speechStartDetected = $h6sQE.SpeechDetected.fromJSON(connectionMessage.textBody);
                        const speechStartEventArgs = new $14iyq.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        break;
                    case "speech.enddetected":
                        let json;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        const speechStopDetected = $h6sQE.SpeechDetected.fromJSON(json);
                        this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                        const speechStopEventArgs = new $14iyq.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        break;
                    case "turn.end":
                        {
                            const turnEndRequestId = connectionMessage.requestId.toUpperCase();
                            const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnEndRequestId !== audioSessionReqId) this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                            else {
                                // Audio session turn
                                const sessionStopEventArgs = new $14iyq.SessionEventArgs(this.privRequestSession.sessionId);
                                await this.privRequestSession.onServiceTurnEndResponse(false);
                                if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                    if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                                }
                                // report result to promise.
                                if (!!this.privSuccessCallback && this.privLastResult) {
                                    try {
                                        this.privSuccessCallback(this.privLastResult);
                                        this.privLastResult = null;
                                    } catch (e) {
                                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                                    }
                                    // Only invoke the call back once.
                                    // and if it's successful don't invoke the
                                    // error after that.
                                    this.privSuccessCallback = undefined;
                                    this.privErrorCallback = undefined;
                                }
                            }
                        }
                        break;
                    default:
                        try {
                            const processed = await this.processTypeSpecificMessages(connectionMessage);
                            if (!processed) {
                                if (!!this.serviceEvents) this.serviceEvents.onEvent(new $iLPPT.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                            }
                        } catch (e) {
                        //
                        }
                }
                const ret = loop();
                return ret;
            } catch (error) {
                this.terminateMessageLoop = true;
                communicationCustodian.resolve();
            }
        };
        loop().catch((reason)=>{
            $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
        });
        return communicationCustodian.promise;
    }
    async startMessageLoop() {
        this.terminateMessageLoop = false;
        try {
            await this.receiveDialogMessageOverride();
        } catch (error) {
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.RuntimeError, error);
        }
        return Promise.resolve();
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configConnection(connection) {
        if (this.terminateMessageLoop) {
            this.terminateMessageLoop = false;
            return Promise.reject("Connection to service terminated.");
        }
        await this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
        await this.sendAgentConfig(connection);
        return connection;
    }
    async sendPreAudioMessages() {
        const connection = await this.fetchConnection();
        this.addKeywordContextData();
        await this.sendSpeechContext(connection, true);
        await this.sendAgentContext(connection);
        await this.sendWaveHeader(connection);
    }
    sendAgentConfig(connection) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.Conversation_DialogType) === $14iyq.DialogServiceConfig.DialogTypes.CustomCommands) {
                const config = this.agentConfig.get();
                config.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us");
                this.agentConfig.set(config);
            }
            this.onEvent(new $8ejoP.SendingAgentContextMessageEvent(this.agentConfig));
            const agentConfigJson = this.agentConfig.toJsonString();
            // guard against sending this multiple times on one connection
            this.agentConfigSent = true;
            return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "agent.config", this.privRequestSession.requestId, "application/json", agentConfigJson));
        }
        return;
    }
    sendAgentContext(connection) {
        const guid = $iLPPT.createGuid();
        const speechActivityTemplate = this.privDialogServiceConnector.properties.getProperty($14iyq.PropertyId.Conversation_Speech_Activity_Template);
        const agentContext = {
            channelData: "",
            context: {
                interactionId: guid
            },
            messagePayload: speechActivityTemplate,
            version: 0.5
        };
        const agentContextJson = JSON.stringify(agentContext);
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", agentContextJson));
    }
    fireEventForResult(serviceResult, properties) {
        const resultReason = $h6sQE.EnumTranslation.implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new $14iyq.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, JSON.stringify(serviceResult), properties);
        const ev = new $14iyq.SpeechRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    handleResponseMessage(responseMessage) {
        // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
        // event according to the message type that's specified.
        const responsePayload = JSON.parse(responseMessage.textBody);
        switch(responsePayload.messageType.toLowerCase()){
            case "message":
                const responseRequestId = responseMessage.requestId.toUpperCase();
                const activityPayload = $agxoM.ActivityPayloadResponse.fromJSON(responseMessage.textBody);
                const turn = this.privTurnStateManager.GetTurn(responseRequestId);
                // update the conversation Id
                if (activityPayload.conversationId) {
                    const updateAgentConfig = this.agentConfig.get();
                    updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                    this.agentConfig.set(updateAgentConfig);
                }
                const pullAudioOutputStream = turn.processActivityPayload(activityPayload, $3R9Dx.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)));
                const activity = new $14iyq.ActivityReceivedEventArgs(activityPayload.messagePayload, pullAudioOutputStream);
                if (!!this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, activity);
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            case "messagestatus":
                if (!!this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new $14iyq.TurnStatusReceivedEventArgs(responseMessage.textBody));
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            default:
                $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(`Unexpected response of type ${responsePayload.messageType}. Ignoring.`));
                break;
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $iLPPT.Events.instance.onEvent(event);
    }
    addKeywordContextData() {
        const keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        const keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        const keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        const keywords = keywordPropertyValue.split(";");
        const keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        const keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        const keywordDefinitionArray = [];
        for(let i = 0; i < keywords.length; i++){
            const definition = {};
            definition.text = keywords[i];
            if (i < keywordOffsets.length) definition.offset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword");
        this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector);
        this.privEvents = new $iLPPT.EventSource();
        this.privDialogServiceConnector = dialogServiceConnector;
        this.receiveMessageOverride = ()=>this.receiveDialogMessageOverride();
        this.privTurnStateManager = new $u2heM.DialogServiceTurnStateManager();
        this.recognizeOverride = (recoMode, successCallback, errorCallback)=>this.listenOnce(recoMode, successCallback, errorCallback);
        this.postConnectImplOverride = (connection)=>this.dialogConnectImpl(connection);
        this.configConnectionOverride = (connection)=>this.configConnection(connection);
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privDialogAudioSource = audioSource;
        this.agentConfigSent = false;
        this.privLastResult = null;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") this.terminateMessageLoop = true;
        });
    }
}
module.exports.DialogServiceAdapter = $8ca7666bca4bb4ae$var$DialogServiceAdapter;

});
parcelRegister("u2heM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnStateManager = void 0;

var $8EMmR = parcelRequire("8EMmR");

var $5hmtD = parcelRequire("5hmtD");
class $05a491a04c201001$var$DialogServiceTurnStateManager {
    StartTurn(id) {
        if (this.privTurnMap.has(id)) throw new $8EMmR.InvalidOperationError("Service error: There is already a turn with id:" + id);
        const turnState = new $5hmtD.DialogServiceTurnState(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    }
    GetTurn(id) {
        return this.privTurnMap.get(id);
    }
    CompleteTurn(id) {
        if (!this.privTurnMap.has(id)) throw new $8EMmR.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + id);
        const turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    }
    constructor(){
        this.privTurnMap = new Map();
        return;
    }
}
module.exports.DialogServiceTurnStateManager = $05a491a04c201001$var$DialogServiceTurnStateManager;

});
parcelRegister("5hmtD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnState = void 0;

var $3R9Dx = parcelRequire("3R9Dx");

var $lrnFA = parcelRequire("lrnFA");

var $agxoM = parcelRequire("agxoM");
class $3d7ff9c3823b13fa$var$DialogServiceTurnState {
    get audioStream() {
        // Called when is needed to stream.
        this.resetTurnEndTimeout();
        return this.privAudioStream;
    }
    processActivityPayload(payload, audioFormat) {
        if (payload.messageDataStreamType === $agxoM.MessageDataStreamType.TextToSpeechAudio) {
            this.privAudioStream = $lrnFA.AudioOutputStream.createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : $3R9Dx.AudioOutputFormatImpl.getDefaultOutputFormat();
        }
        return this.privAudioStream;
    }
    endAudioStream() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    }
    complete() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    }
    resetTurnEndTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = setTimeout(()=>{
            this.privTurnManager.CompleteTurn(this.privRequestId);
            return;
        }, 2000);
    }
    constructor(manager, requestId){
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    }
}
module.exports.DialogServiceTurnState = $3d7ff9c3823b13fa$var$DialogServiceTurnState;

});
parcelRegister("agxoM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageDataStreamType = module.exports.ActivityPayloadResponse = void 0;
class $77954e46be777768$var$ActivityPayloadResponse {
    static fromJSON(json) {
        return new $77954e46be777768$var$ActivityPayloadResponse(json);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
    constructor(json){
        this.privActivityResponse = JSON.parse(json);
    }
}
module.exports.ActivityPayloadResponse = $77954e46be777768$var$ActivityPayloadResponse;
var $77954e46be777768$var$MessageDataStreamType;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($77954e46be777768$var$MessageDataStreamType = module.exports.MessageDataStreamType || (module.exports.MessageDataStreamType = {}));

});




parcelRegister("8Veus", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgentConfig = void 0;
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ class $67eee30bd8537809$var$AgentConfig {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ set(value) {
        this.iPrivConfig = value;
    }
}
module.exports.AgentConfig = $67eee30bd8537809$var$AgentConfig;

});

parcelRegister("4rM4i", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iqzQG = parcelRequire("iqzQG");
Object.defineProperty(module.exports, "ConversationManager", {
    enumerable: true,
    get: function() {
        return $iqzQG.ConversationManager;
    }
});

var $kcZzg = parcelRequire("kcZzg");
Object.defineProperty(module.exports, "ConversationConnectionConfig", {
    enumerable: true,
    get: function() {
        return $kcZzg.ConversationConnectionConfig;
    }
});

var $fPi5r = parcelRequire("fPi5r");
Object.defineProperty(module.exports, "ConversationRecognizerFactory", {
    enumerable: true,
    get: function() {
        return $fPi5r.ConversationRecognizerFactory;
    }
});

var $5imPb = parcelRequire("5imPb");
Object.defineProperty(module.exports, "TranscriberRecognizer", {
    enumerable: true,
    get: function() {
        return $5imPb.TranscriberRecognizer;
    }
});

var $1UPtZ = parcelRequire("1UPtZ");
Object.defineProperty(module.exports, "ConversationReceivedTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $1UPtZ.ConversationReceivedTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "LockRoomEventArgs", {
    enumerable: true,
    get: function() {
        return $1UPtZ.LockRoomEventArgs;
    }
});
Object.defineProperty(module.exports, "MuteAllEventArgs", {
    enumerable: true,
    get: function() {
        return $1UPtZ.MuteAllEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantAttributeEventArgs", {
    enumerable: true,
    get: function() {
        return $1UPtZ.ParticipantAttributeEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantEventArgs", {
    enumerable: true,
    get: function() {
        return $1UPtZ.ParticipantEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantsListEventArgs", {
    enumerable: true,
    get: function() {
        return $1UPtZ.ParticipantsListEventArgs;
    }
});

var $3Wgl0 = parcelRequire("3Wgl0");
Object.defineProperty(module.exports, "ConversationTranslatorCommandTypes", {
    enumerable: true,
    get: function() {
        return $3Wgl0.ConversationTranslatorCommandTypes;
    }
});
Object.defineProperty(module.exports, "ConversationTranslatorMessageTypes", {
    enumerable: true,
    get: function() {
        return $3Wgl0.ConversationTranslatorMessageTypes;
    }
});
Object.defineProperty(module.exports, "InternalParticipants", {
    enumerable: true,
    get: function() {
        return $3Wgl0.InternalParticipants;
    }
});

});
parcelRegister("iqzQG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationManager = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $kcZzg = parcelRequire("kcZzg");
class $d6a6767dadae2966$var$ConversationManager {
    /**
     * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
     * @param args
     * @param conversationCode
     * @param callback
     * @param errorCallback
     */ createOrJoin(args, conversationCode, cb, err) {
        try {
            $3afpL.Contracts.throwIfNullOrUndefined(args, "args");
            const languageCode = args.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage, $kcZzg.ConversationConnectionConfig.defaultLanguageCode);
            const nickname = args.getProperty($14iyq.PropertyId.ConversationTranslator_Name, "conversation_host");
            const endpointHost = args.getProperty($14iyq.PropertyId.ConversationTranslator_Host, this.privHost);
            const correlationId = args.getProperty($14iyq.PropertyId.ConversationTranslator_CorrelationId);
            const subscriptionKey = args.getProperty($14iyq.PropertyId.SpeechServiceConnection_Key);
            const subscriptionRegion = args.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region);
            const authToken = args.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
            $3afpL.Contracts.throwIfNullOrWhitespace(languageCode, "languageCode");
            $3afpL.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
            $3afpL.Contracts.throwIfNullOrWhitespace(endpointHost, "endpointHost");
            const queryParams = {};
            queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
            queryParams[this.privRequestParams.languageCode] = languageCode;
            queryParams[this.privRequestParams.nickname] = nickname;
            const headers = {};
            if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
            headers[this.privRequestParams.clientAppId] = $kcZzg.ConversationConnectionConfig.clientAppId;
            if (conversationCode !== undefined) queryParams[this.privRequestParams.roomId] = conversationCode;
            else {
                $3afpL.Contracts.throwIfNullOrUndefined(subscriptionRegion, this.privErrors.authInvalidSubscriptionRegion);
                headers[this.privRequestParams.subscriptionRegion] = subscriptionRegion;
                if (subscriptionKey) headers[this.privRequestParams.subscriptionKey] = subscriptionKey;
                else if (authToken) headers[this.privRequestParams.authorization] = `Bearer ${authToken}`;
                else $3afpL.Contracts.throwIfNullOrUndefined(subscriptionKey, this.privErrors.authInvalidSubscriptionKey);
            }
            const config = {};
            config.headers = headers;
            this.privRestAdapter.options = config;
            const endpoint = `https://${endpointHost}${this.privRestPath}`;
            // TODO: support a proxy and certificate validation
            this.privRestAdapter.request($1JzGB.RestRequestType.Post, endpoint, queryParams, null).then((response)=>{
                const requestId = $1JzGB.RestMessageAdapter.extractHeaderValue(this.privRequestParams.requestId, response.headers);
                if (!response.ok) {
                    if (!!err) {
                        // get the error
                        let errorMessage = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", response.status.toString());
                        let errMessageRaw;
                        try {
                            errMessageRaw = JSON.parse(response.data);
                            errorMessage += ` [${errMessageRaw.error.code}: ${errMessageRaw.error.message}]`;
                        } catch (e) {
                            errorMessage += ` [${response.data}]`;
                        }
                        if (requestId) errorMessage += ` ${requestId}`;
                        err(errorMessage);
                    }
                    return;
                }
                const conversation = JSON.parse(response.data);
                if (conversation) conversation.requestId = requestId;
                if (!!cb) {
                    try {
                        cb(conversation);
                    } catch (e) {
                        if (!!err) err(e);
                    }
                    cb = undefined;
                }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            }).catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    }
    /**
     * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
     * @param args
     * @param sessionToken
     * @param callback
     */ leave(args, sessionToken) {
        return new Promise((resolve, reject)=>{
            try {
                $3afpL.Contracts.throwIfNullOrUndefined(args, this.privErrors.invalidArgs.replace("{arg}", "config"));
                $3afpL.Contracts.throwIfNullOrWhitespace(sessionToken, this.privErrors.invalidArgs.replace("{arg}", "token"));
                const endpointHost = args.getProperty($14iyq.PropertyId.ConversationTranslator_Host, this.privHost);
                const correlationId = args.getProperty($14iyq.PropertyId.ConversationTranslator_CorrelationId);
                const queryParams = {};
                queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
                queryParams[this.privRequestParams.sessionToken] = sessionToken;
                const headers = {};
                if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
                const config = {};
                config.headers = headers;
                this.privRestAdapter.options = config;
                const endpoint = `https://${endpointHost}${this.privRestPath}`;
                // TODO: support a proxy and certificate validation
                this.privRestAdapter.request($1JzGB.RestRequestType.Delete, endpoint, queryParams, null).then((response)=>{
                    response.ok;
                    resolve();
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                }).catch(()=>{});
            } catch (error) {
                if (error instanceof Error) {
                    const typedError = error;
                    reject(typedError.name + ": " + typedError.message);
                } else reject(error);
            }
        });
    }
    constructor(){
        //
        this.privRequestParams = $kcZzg.ConversationConnectionConfig.configParams;
        this.privErrors = $kcZzg.ConversationConnectionConfig.restErrors;
        this.privHost = $kcZzg.ConversationConnectionConfig.host;
        this.privApiVersion = $kcZzg.ConversationConnectionConfig.apiVersion;
        this.privRestPath = $kcZzg.ConversationConnectionConfig.restPath;
        this.privRestAdapter = new $1JzGB.RestMessageAdapter({});
    }
}
module.exports.ConversationManager = $d6a6767dadae2966$var$ConversationManager;

});
parcelRegister("kcZzg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionConfig = void 0;

var $8v5nd = parcelRequire("8v5nd");
class $eb64afb89a02c0cf$var$ConversationConnectionConfig extends $8v5nd.RestConfigBase {
    static get host() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privHost;
    }
    static get apiVersion() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privApiVersion;
    }
    static get clientAppId() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privClientAppId;
    }
    static get defaultLanguageCode() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privDefaultLanguageCode;
    }
    static get restPath() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privRestPath;
    }
    static get webSocketPath() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privWebSocketPath;
    }
    static get transcriptionEventKeys() {
        return $eb64afb89a02c0cf$var$ConversationConnectionConfig.privTranscriptionEventKeys;
    }
}
module.exports.ConversationConnectionConfig = $eb64afb89a02c0cf$var$ConversationConnectionConfig;
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privHost = "dev.microsofttranslator.com";
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privRestPath = "/capito/room";
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privApiVersion = "2.0";
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privDefaultLanguageCode = "en-US";
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privWebSocketPath = "/capito/translate";
$eb64afb89a02c0cf$var$ConversationConnectionConfig.privTranscriptionEventKeys = [
    "iCalUid",
    "callId",
    "organizer",
    "FLAC",
    "MTUri",
    "DifferentiateGuestSpeakers",
    "audiorecording",
    "Threadid",
    "OrganizerMri",
    "OrganizerTenantId",
    "UserToken"
];

});


parcelRegister("fPi5r", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorRecognizer = module.exports.ConversationRecognizerFactory = void 0;

var $h6sQE = parcelRequire("h6sQE");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $hZBiZ = parcelRequire("hZBiZ");

var $4Mc7T = parcelRequire("4Mc7T");
class $b859a61bf92c4c90$var$ConversationRecognizerFactory {
    static fromConfig(conversation, speechConfig, audioConfig) {
        return new $b859a61bf92c4c90$var$ConversationTranslatorRecognizer(conversation, speechConfig, audioConfig);
    }
}
module.exports.ConversationRecognizerFactory = $b859a61bf92c4c90$var$ConversationRecognizerFactory;
/**
 * Sends messages to the Conversation Translator websocket and listens for incoming events containing websocket messages.
 * Based off the recognizers in the SDK folder.
 */ class $b859a61bf92c4c90$var$ConversationTranslatorRecognizer extends $14iyq.Recognizer {
    set connected(cb) {
        this.privConnection.connected = cb;
    }
    set disconnected(cb) {
        this.privConnection.disconnected = cb;
    }
    /**
     * Return the speech language used by the recognizer
     */ get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    /**
     * Return the properties for the recognizer
     */ get properties() {
        return this.privProperties;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    /**
     * Connect to the recognizer
     * @param token
     */ connect(token, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
            this.privReco.conversationTranslatorToken = token;
            this.resetConversationTimeout();
            this.privReco.connectAsync(cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    }
    /**
     * Disconnect from the recognizer
     */ disconnect(cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privReco.disconnect().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch((reason)=>{
                $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
            });
        }
    }
    /**
     * Send the mute all participants command to the websocket
     * @param conversationId
     * @param participantId
     * @param isMuted
     */ sendRequest(command, cb, err) {
        try {
            $3afpL.Contracts.throwIfDisposed(this.privIsDisposed);
            this.sendMessage(command, cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch((reason)=>{
                $iLPPT.Events.instance.onEvent(new $iLPPT.BackgroundEvent(reason));
            });
        }
    }
    /**
     * Handle update of service auth token (#694)
     */ onToken(token) {
        this.privConversation.onToken(token);
    }
    /**
     * Close and dispose the recognizer
     */ async close() {
        if (!this.privIsDisposed) {
            if (!!this.privConnection) {
                this.privConnection.closeConnection();
                this.privConnection.close();
            }
            this.privConnection = undefined;
            await this.dispose(true);
        }
    }
    /**
     * Dispose the recognizer
     * @param disposing
     */ async dispose(disposing) {
        if (this.privIsDisposed) return;
        if (disposing) {
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privIsDisposed = true;
            if (!!this.privConnection) {
                this.privConnection.closeConnection();
                this.privConnection.close();
                this.privConnection = undefined;
            }
            await super.dispose(disposing);
        }
    }
    /**
     * Create the config for the recognizer
     * @param speechConfig
     */ createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.privProperties);
    }
    /**
     * Create the service recognizer.
     * The audio source is redundnant here but is required by the implementation.
     * @param authentication
     * @param connectionFactory
     * @param audioConfig
     * @param recognizerConfig
     */ createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new $4Mc7T.ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    sendMessage(msg, cb, err) {
        const withAsync = this.privReco;
        const PromiseToEmptyCallback = (promise, cb, err)=>{
            if (promise !== undefined) promise.then(()=>{
                try {
                    if (!!cb) cb();
                } catch (e) {
                    if (!!err) err(`'Unhandled error on promise callback: ${e}'`);
                }
            }, (reason)=>{
                try {
                    if (!!err) err(reason);
                // eslint-disable-next-line no-empty
                } catch (error) {}
            });
            else if (!!err) err("Null promise");
        };
        PromiseToEmptyCallback(withAsync.sendMessageAsync(msg), cb, err);
        this.resetConversationTimeout();
    }
    resetConversationTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.privClearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = this.privSetTimeout(()=>{
            this.sendRequest(this.privConversation.getKeepAlive());
        }, 60000);
    }
    constructor(conversation, speechConfig, audioConfig){
        const serviceConfigImpl = speechConfig;
        $3afpL.Contracts.throwIfNull(serviceConfigImpl, "speechConfig");
        const conversationImpl = conversation;
        $3afpL.Contracts.throwIfNull(conversationImpl, "conversationImpl");
        super(audioConfig, serviceConfigImpl.properties, new $hZBiZ.ConversationConnectionFactory());
        this.privConversation = conversationImpl;
        this.privIsDisposed = false;
        this.privProperties = serviceConfigImpl.properties.clone();
        this.privConnection = $14iyq.Connection.fromRecognizer(this);
        const webWorkerLoadType = this.privProperties.getProperty($14iyq.PropertyId.WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") {
            this.privSetTimeout = $iLPPT.Timeout.setTimeout;
            this.privClearTimeout = $iLPPT.Timeout.clearTimeout;
        } else if (typeof window !== "undefined") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = window.setTimeout.bind(window);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privClearTimeout = window.clearTimeout.bind(window);
        } else {
            this.privSetTimeout = setTimeout;
            this.privClearTimeout = clearTimeout;
        }
    }
}
module.exports.ConversationTranslatorRecognizer = $b859a61bf92c4c90$var$ConversationTranslatorRecognizer;

});
parcelRegister("hZBiZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionFactory = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $kcZzg = parcelRequire("kcZzg");

var $7y96p = parcelRequire("7y96p");
/**
 * Create a connection to the Conversation Translator websocket for sending instant messages and commands, and for receiving translated messages.
 * The conversation must already have been started or joined.
 */ class $d195123dbae06817$var$ConversationConnectionFactory extends $6wf4H.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const endpointHost = config.parameters.getProperty($14iyq.PropertyId.ConversationTranslator_Host, $kcZzg.ConversationConnectionConfig.host);
        const correlationId = config.parameters.getProperty($14iyq.PropertyId.ConversationTranslator_CorrelationId, $iLPPT.createGuid());
        const endpoint = `wss://${endpointHost}${$kcZzg.ConversationConnectionConfig.webSocketPath}`;
        const token = config.parameters.getProperty($14iyq.PropertyId.ConversationTranslator_Token, undefined);
        $3afpL.Contracts.throwIfNullOrUndefined(token, "token");
        const queryParams = {};
        queryParams[$kcZzg.ConversationConnectionConfig.configParams.apiVersion] = $kcZzg.ConversationConnectionConfig.apiVersion;
        queryParams[$kcZzg.ConversationConnectionConfig.configParams.token] = token;
        queryParams[$kcZzg.ConversationConnectionConfig.configParams.correlationId] = correlationId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $1JzGB.WebsocketConnection(endpoint, queryParams, {}, new $7y96p.ConversationWebsocketMessageFormatter(), $1JzGB.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
}
module.exports.ConversationConnectionFactory = $d195123dbae06817$var$ConversationConnectionFactory;

});
parcelRegister("7y96p", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationWebsocketMessageFormatter = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $3HRQ9 = parcelRequire("3HRQ9");
/**
 * Based off WebsocketMessageFormatter. The messages for Conversation Translator have some variations from the Speech messages.
 */ class $57f2c4e7fda25f71$var$ConversationWebsocketMessageFormatter {
    /**
     * Format incoming messages: text (speech partial/final, IM) or binary (tts)
     */ toConnectionMessage(message) {
        const deferral = new $iLPPT.Deferred();
        try {
            if (message.messageType === $iLPPT.MessageType.Text) {
                const incomingMessage = new $3HRQ9.ConversationConnectionMessage(message.messageType, message.textContent, {}, message.id);
                deferral.resolve(incomingMessage);
            } else if (message.messageType === $iLPPT.MessageType.Binary) deferral.resolve(new $3HRQ9.ConversationConnectionMessage(message.messageType, message.binaryContent, undefined, message.id));
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    /**
     * Format outgoing messages: text (commands or IM)
     */ fromConnectionMessage(message) {
        const deferral = new $iLPPT.Deferred();
        try {
            if (message.messageType === $iLPPT.MessageType.Text) {
                const payload = `${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new $iLPPT.RawWebsocketMessage($iLPPT.MessageType.Text, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
}
module.exports.ConversationWebsocketMessageFormatter = $57f2c4e7fda25f71$var$ConversationWebsocketMessageFormatter;

});
parcelRegister("3HRQ9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionMessage = void 0;

var $iLPPT = parcelRequire("iLPPT");
class $2b2f26c49b1ebb1e$var$ConversationConnectionMessage extends $iLPPT.ConnectionMessage {
    get conversationMessageType() {
        return this.privConversationMessageType;
    }
    constructor(messageType, body, headers, id){
        super(messageType, body, headers, id);
        const json = JSON.parse(this.textBody);
        if (json.type !== undefined) this.privConversationMessageType = json.type;
    }
}
module.exports.ConversationConnectionMessage = $2b2f26c49b1ebb1e$var$ConversationConnectionMessage;

});



parcelRegister("4Mc7T", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceAdapter = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $3HRQ9 = parcelRequire("3HRQ9");

var $kBPj0 = parcelRequire("kBPj0");

var $1UPtZ = parcelRequire("1UPtZ");

var $3Wgl0 = parcelRequire("3Wgl0");

var $GsE0A = parcelRequire("GsE0A");
/**
 * The service adapter handles sending and receiving messages to the Conversation Translator websocket.
 */ class $37a50d22c4605917$var$ConversationServiceAdapter extends $h6sQE.ServiceRecognizerBase {
    isDisposed() {
        return super.isDisposed() || this.privConversationIsDisposed;
    }
    async dispose(reason) {
        this.privConversationIsDisposed = true;
        if (this.privConnectionConfigPromise !== undefined) {
            const connection = await this.privConnectionConfigPromise;
            await connection.dispose(reason);
        }
        await super.dispose(reason);
    }
    async sendMessage(message) {
        const connection = await this.fetchConnection();
        return connection.send(new $3HRQ9.ConversationConnectionMessage($iLPPT.MessageType.Text, message));
    }
    async sendMessageAsync(message) {
        const connection = await this.fetchConnection();
        await connection.send(new $3HRQ9.ConversationConnectionMessage($iLPPT.MessageType.Text, message));
    }
    privDisconnect() {
        if (this.terminateMessageLoop) return;
        this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        return Promise.resolve();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async processTypeSpecificMessages() {
        return true;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        const cancelEvent = new $14iyq.ConversationTranslationCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
        try {
            if (!!this.privConversationServiceConnector.canceled) this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, cancelEvent);
        } catch  {
        // continue on error
        }
    }
    /**
     * Establishes a websocket connection to the end point.
     */ async conversationConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    /**
     * Process incoming websocket messages
     */ async receiveConversationMessageOverride() {
        if (this.isDisposed() || this.terminateMessageLoop) return Promise.resolve();
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new $iLPPT.Deferred();
        try {
            const connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.isDisposed() || this.terminateMessageLoop) {
                // We're done.
                communicationCustodian.resolve();
                return Promise.resolve();
            }
            if (!message) return this.receiveConversationMessageOverride();
            const sessionId = this.privConversationRequestSession.sessionId;
            const conversationMessageType = message.conversationMessageType.toLowerCase();
            let sendFinal = false;
            try {
                switch(conversationMessageType){
                    case "info":
                    case "participant_command":
                    case "command":
                        const commandPayload = $GsE0A.CommandResponsePayload.fromJSON(message.textBody);
                        switch(commandPayload.command.toLowerCase()){
                            /**
                             * 'ParticpantList' is the first message sent to the user after the websocket connection has opened.
                             * The consuming client must wait for this message to arrive
                             * before starting to send their own data.
                             */ case "participantlist":
                                const participantsPayload = $GsE0A.ParticipantsListPayloadResponse.fromJSON(message.textBody);
                                const participantsResult = participantsPayload.participants.map((p)=>{
                                    const participant = {
                                        avatar: p.avatar,
                                        displayName: p.nickname,
                                        id: p.participantId,
                                        isHost: p.ishost,
                                        isMuted: p.ismuted,
                                        isUsingTts: p.usetts,
                                        preferredLanguage: p.locale
                                    };
                                    return participant;
                                });
                                if (!!this.privConversationServiceConnector.participantsListReceived) this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantsListEventArgs(participantsPayload.roomid, participantsPayload.token, participantsPayload.translateTo, participantsPayload.profanityFilter, participantsPayload.roomProfanityFilter, participantsPayload.roomLocked, participantsPayload.muteAll, participantsResult, sessionId));
                                break;
                            /**
                             * 'SetTranslateToLanguages' represents the list of languages being used in the Conversation by all users(?).
                             * This is sent at the start of the Conversation
                             */ case "settranslatetolanguages":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantAttributeEventArgs(commandPayload.participantId, $3Wgl0.ConversationTranslatorCommandTypes.setTranslateToLanguages, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetProfanityFiltering' lets the client set the level of profanity filtering.
                             * If sent by the participant the setting will effect only their own profanity level.
                             * If sent by the host, the setting will effect all participants including the host.
                             * Note: the profanity filters differ from Speech Service (?): 'marked', 'raw', 'removed', 'tagged'
                             */ case "setprofanityfiltering":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantAttributeEventArgs(commandPayload.participantId, $3Wgl0.ConversationTranslatorCommandTypes.setProfanityFiltering, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetMute' is sent if the participant has been muted by the host.
                             * Check the 'participantId' to determine if the current user has been muted.
                             */ case "setmute":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantAttributeEventArgs(commandPayload.participantId, $3Wgl0.ConversationTranslatorCommandTypes.setMute, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetMuteAll' is sent if the Conversation has been muted by the host.
                             */ case "setmuteall":
                                if (!!this.privConversationServiceConnector.muteAllCommandReceived) this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $1UPtZ.MuteAllEventArgs(commandPayload.value, sessionId));
                                break;
                            /**
                             * 'RoomExpirationWarning' is sent towards the end of the Conversation session to give a timeout warning.
                             */ case "roomexpirationwarning":
                                if (!!this.privConversationServiceConnector.conversationExpiration) this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $14iyq.ConversationExpirationEventArgs(commandPayload.value, this.privConversationRequestSession.sessionId));
                                break;
                            /**
                             * 'SetUseTts' is sent as a confirmation if the user requests TTS to be turned on or off.
                             */ case "setusetts":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantAttributeEventArgs(commandPayload.participantId, $3Wgl0.ConversationTranslatorCommandTypes.setUseTTS, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetLockState' is set if the host has locked or unlocked the Conversation.
                             */ case "setlockstate":
                                if (!!this.privConversationServiceConnector.lockRoomCommandReceived) this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $1UPtZ.LockRoomEventArgs(commandPayload.value, sessionId));
                                break;
                            /**
                             * 'ChangeNickname' is received if a user changes their display name.
                             * Any cached particpiants list should be updated to reflect the display name.
                             */ case "changenickname":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantAttributeEventArgs(commandPayload.participantId, $3Wgl0.ConversationTranslatorCommandTypes.changeNickname, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'JoinSession' is sent when a user joins the Conversation.
                             */ case "joinsession":
                                const joinParticipantPayload = $GsE0A.ParticipantPayloadResponse.fromJSON(message.textBody);
                                const joiningParticipant = {
                                    avatar: joinParticipantPayload.avatar,
                                    displayName: joinParticipantPayload.nickname,
                                    id: joinParticipantPayload.participantId,
                                    isHost: joinParticipantPayload.ishost,
                                    isMuted: joinParticipantPayload.ismuted,
                                    isUsingTts: joinParticipantPayload.usetts,
                                    preferredLanguage: joinParticipantPayload.locale
                                };
                                if (!!this.privConversationServiceConnector.participantJoinCommandReceived) this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantEventArgs(joiningParticipant, sessionId));
                                break;
                            /**
                             * 'LeaveSession' is sent when a user leaves the Conversation'.
                             */ case "leavesession":
                                const leavingParticipant = {
                                    id: commandPayload.participantId
                                };
                                if (!!this.privConversationServiceConnector.participantLeaveCommandReceived) this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $1UPtZ.ParticipantEventArgs(leavingParticipant, sessionId));
                                break;
                            /**
                             * 'DisconnectSession' is sent when a user is disconnected from the session (e.g. network problem).
                             * Check the 'ParticipantId' to check whether the message is for the current user.
                             */ case "disconnectsession":
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const disconnectParticipant = {
                                    id: commandPayload.participantId
                                };
                                break;
                            case "token":
                                const token = new $h6sQE.CognitiveTokenAuthentication(()=>{
                                    const authorizationToken = commandPayload.token;
                                    return Promise.resolve(authorizationToken);
                                }, ()=>{
                                    const authorizationToken = commandPayload.token;
                                    return Promise.resolve(authorizationToken);
                                });
                                this.authentication = token;
                                this.privConversationServiceConnector.onToken(token);
                                break;
                            /**
                             * Message not recognized.
                             */ default:
                                break;
                        }
                        break;
                    /**
                     * 'partial' (or 'hypothesis') represents a unfinalized speech message.
                     */ case "partial":
                    /**
                     * 'final' (or 'phrase') represents a finalized speech message.
                     */ case "final":
                        const speechPayload = $GsE0A.SpeechResponsePayload.fromJSON(message.textBody);
                        const conversationResultReason = conversationMessageType === "final" ? $14iyq.ResultReason.TranslatedParticipantSpeech : $14iyq.ResultReason.TranslatingParticipantSpeech;
                        const speechResult = new $14iyq.ConversationTranslationResult(speechPayload.participantId, this.getTranslations(speechPayload.translations), speechPayload.language, speechPayload.id, conversationResultReason, speechPayload.recognition, undefined, undefined, message.textBody, undefined);
                        if (speechPayload.isFinal) {
                            // check the length, sometimes empty finals are returned
                            if (speechResult.text !== undefined && speechResult.text.length > 0) sendFinal = true;
                            else if (speechPayload.id === this.privLastPartialUtteranceId) // send final as normal. We had a non-empty partial for this same utterance
                            // so sending the empty final is important
                            sendFinal = true;
                            if (sendFinal) {
                                if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $1UPtZ.ConversationReceivedTranslationEventArgs($3Wgl0.ConversationTranslatorMessageTypes.final, speechResult, sessionId));
                            }
                        } else if (speechResult.text !== undefined) {
                            this.privLastPartialUtteranceId = speechPayload.id;
                            if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $1UPtZ.ConversationReceivedTranslationEventArgs($3Wgl0.ConversationTranslatorMessageTypes.partial, speechResult, sessionId));
                        }
                        break;
                    /**
                     * "translated_message" is a text message or instant message (IM).
                     */ case "translated_message":
                        const textPayload = $GsE0A.TextResponsePayload.fromJSON(message.textBody);
                        // TODO: (Native parity) a result reason should be set based whether the participantId is ours or not
                        const textResult = new $14iyq.ConversationTranslationResult(textPayload.participantId, this.getTranslations(textPayload.translations), textPayload.language, undefined, undefined, textPayload.originalText, undefined, undefined, undefined, message.textBody, undefined);
                        if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $1UPtZ.ConversationReceivedTranslationEventArgs($3Wgl0.ConversationTranslatorMessageTypes.instantMessage, textResult, sessionId));
                        break;
                    default:
                        break;
                }
            } catch (e) {
            // continue
            }
            return this.receiveConversationMessageOverride();
        } catch (e) {
            this.terminateMessageLoop = true;
        }
        return communicationCustodian.promise;
    }
    async startMessageLoop() {
        if (this.isDisposed()) return Promise.resolve();
        this.terminateMessageLoop = false;
        const messageRetrievalPromise = this.receiveConversationMessageOverride();
        try {
            const r = await messageRetrievalPromise;
            return r;
        } catch (error) {
            this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.RuntimeError, error);
            return null;
        }
    }
    // Takes an established websocket connection to the endpoint
    configConnection() {
        if (this.isDisposed()) return Promise.resolve(undefined);
        if (this.privConnectionConfigPromise !== undefined) return this.privConnectionConfigPromise.then((connection)=>{
            if (connection.state() === $iLPPT.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigPromise = undefined;
                return this.configConnection();
            }
            return this.privConnectionConfigPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigPromise = undefined;
            return this.configConnection();
        });
        if (this.terminateMessageLoop) return Promise.resolve(undefined);
        this.privConnectionConfigPromise = this.connectImpl().then((connection)=>connection);
        return this.privConnectionConfigPromise;
    }
    getTranslations(serviceResultTranslations) {
        let translations;
        if (undefined !== serviceResultTranslations) {
            translations = new $14iyq.Translations();
            for (const translation of serviceResultTranslations)translations.set(translation.lang, translation.translation);
        }
        return translations;
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector);
        this.privConnectionConfigPromise = undefined;
        this.privLastPartialUtteranceId = "";
        this.privConversationServiceConnector = conversationServiceConnector;
        this.privConversationAuthentication = authentication;
        this.receiveMessageOverride = ()=>this.receiveConversationMessageOverride();
        this.recognizeOverride = ()=>this.noOp();
        this.postConnectImplOverride = (connection)=>this.conversationConnectImpl(connection);
        this.configConnectionOverride = ()=>this.configConnection();
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privConversationRequestSession = new $kBPj0.ConversationRequestSession($iLPPT.createNoDashGuid());
        this.privConversationConnectionFactory = connectionFactory;
        this.privConversationIsDisposed = false;
    }
}
module.exports.ConversationServiceAdapter = $37a50d22c4605917$var$ConversationServiceAdapter;

});
parcelRegister("kBPj0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationRequestSession = void 0;

var $iLPPT = parcelRequire("iLPPT");
/**
 * Placeholder class for the Conversation Request Session. Based off RequestSession.
 * TODO: define what telemetry is required.
 */ class $f00f0f8bf3db79a8$var$ConversationRequestSession {
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get completionPromise() {
        return this.privRequestCompletionDeferral.promise;
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privSessionId = connectionId;
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) return;
        else if (statusCode === 403) this.onComplete();
    }
    onServiceTurnEndResponse(continuousRecognition) {
        if (!continuousRecognition) this.onComplete();
        else this.privRequestId = $iLPPT.createNoDashGuid();
    }
    async dispose() {
        if (!this.privIsDisposed) {
            // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
            for (const detachable of this.privDetachables)await detachable.detach();
        }
    }
    onComplete() {
    //
    }
    constructor(sessionId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privSessionId = sessionId;
        this.privRequestId = $iLPPT.createNoDashGuid();
        this.privRequestCompletionDeferral = new $iLPPT.Deferred();
    }
}
module.exports.ConversationRequestSession = $f00f0f8bf3db79a8$var$ConversationRequestSession;

});

parcelRegister("1UPtZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationReceivedTranslationEventArgs = module.exports.ParticipantsListEventArgs = module.exports.ParticipantAttributeEventArgs = module.exports.ParticipantEventArgs = module.exports.LockRoomEventArgs = module.exports.MuteAllEventArgs = void 0;

var $14iyq = parcelRequire("14iyq");
class $1652f4d2b3b8dccb$var$MuteAllEventArgs extends $14iyq.SessionEventArgs {
    get isMuted() {
        return this.privIsMuted;
    }
    constructor(isMuted, sessionId){
        super(sessionId);
        this.privIsMuted = isMuted;
    }
}
module.exports.MuteAllEventArgs = $1652f4d2b3b8dccb$var$MuteAllEventArgs;
class $1652f4d2b3b8dccb$var$LockRoomEventArgs extends $14iyq.SessionEventArgs {
    get isMuted() {
        return this.privIsLocked;
    }
    constructor(isLocked, sessionId){
        super(sessionId);
        this.privIsLocked = isLocked;
    }
}
module.exports.LockRoomEventArgs = $1652f4d2b3b8dccb$var$LockRoomEventArgs;
class $1652f4d2b3b8dccb$var$ParticipantEventArgs extends $14iyq.SessionEventArgs {
    get participant() {
        return this.privParticipant;
    }
    constructor(participant, sessionId){
        super(sessionId);
        this.privParticipant = participant;
    }
}
module.exports.ParticipantEventArgs = $1652f4d2b3b8dccb$var$ParticipantEventArgs;
class $1652f4d2b3b8dccb$var$ParticipantAttributeEventArgs extends $14iyq.SessionEventArgs {
    get value() {
        return this.privValue;
    }
    get key() {
        return this.privKey;
    }
    get id() {
        return this.privParticipantId;
    }
    constructor(participantId, key, value, sessionId){
        super(sessionId);
        this.privKey = key;
        this.privValue = value;
        this.privParticipantId = participantId;
    }
}
module.exports.ParticipantAttributeEventArgs = $1652f4d2b3b8dccb$var$ParticipantAttributeEventArgs;
class $1652f4d2b3b8dccb$var$ParticipantsListEventArgs extends $14iyq.SessionEventArgs {
    get sessionToken() {
        return this.privSessionToken;
    }
    get conversationId() {
        return this.privRoomId;
    }
    get translateTo() {
        return this.privTranslateTo;
    }
    get profanityFilter() {
        return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
        return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
        return this.privIsRoomLocked;
    }
    get isMuteAll() {
        return this.privIsMuteAll;
    }
    get participants() {
        return this.privParticipants;
    }
    constructor(conversationId, token, translateTo, profanityFilter, roomProfanityFilter, isRoomLocked, isMuteAll, participants, sessionId){
        super(sessionId);
        this.privRoomId = conversationId;
        this.privSessionToken = token;
        this.privTranslateTo = translateTo;
        this.privProfanityFilter = profanityFilter;
        this.privRoomProfanityFilter = roomProfanityFilter;
        this.privIsRoomLocked = isRoomLocked;
        this.privIsRoomLocked = isMuteAll;
        this.privParticipants = participants;
    }
}
module.exports.ParticipantsListEventArgs = $1652f4d2b3b8dccb$var$ParticipantsListEventArgs;
class $1652f4d2b3b8dccb$var$ConversationReceivedTranslationEventArgs {
    get payload() {
        return this.privPayload;
    }
    get command() {
        return this.privCommand;
    }
    get sessionId() {
        return this.privSessionId;
    }
    constructor(command, payload, sessionId){
        this.privPayload = payload;
        this.privCommand = command;
        this.privSessionId = sessionId;
    }
}
module.exports.ConversationReceivedTranslationEventArgs = $1652f4d2b3b8dccb$var$ConversationReceivedTranslationEventArgs;

});

parcelRegister("3Wgl0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorCommandTypes = module.exports.ConversationTranslatorMessageTypes = module.exports.InternalParticipants = void 0;
/** Users participating in the conversation */ class $2de37635ef4d75de$var$InternalParticipants {
    /**
     * Add or update a participant
     * @param value
     */ addOrUpdateParticipant(value) {
        if (value === undefined) return;
        const exists = this.getParticipantIndex(value.id);
        if (exists > -1) this.participants.splice(exists, 1, value);
        else this.participants.push(value);
        // ensure it was added ok
        return this.getParticipant(value.id);
    }
    /**
     * Find the participant's position in the participants list.
     * @param id
     */ getParticipantIndex(id) {
        return this.participants.findIndex((p)=>p.id === id);
    }
    /**
     * Find the participant by id.
     * @param id
     */ getParticipant(id) {
        return this.participants.find((p)=>p.id === id);
    }
    /**
     * Remove a participant from the participants list.
     */ deleteParticipant(id) {
        this.participants = this.participants.filter((p)=>p.id !== id);
    }
    /**
     * Helper to return the conversation host.
     */ get host() {
        return this.participants.find((p)=>p.isHost === true);
    }
    /**
     * Helper to return the current user.
     */ get me() {
        return this.getParticipant(this.meId);
    }
    constructor(participants = [], meId){
        this.participants = participants;
        this.meId = meId;
    }
}
module.exports.InternalParticipants = $2de37635ef4d75de$var$InternalParticipants;
/**
 * List of command message types
 */ module.exports.ConversationTranslatorMessageTypes = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    keepAlive: "keep_alive",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
};
/**
 * List of command types
 */ module.exports.ConversationTranslatorCommandTypes = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
};

});

parcelRegister("GsE0A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lcqjr = parcelRequire("lcqjr");
Object.defineProperty(module.exports, "CommandResponsePayload", {
    enumerable: true,
    get: function() {
        return $lcqjr.CommandResponsePayload;
    }
});

var $2pGLS = parcelRequire("2pGLS");
Object.defineProperty(module.exports, "ParticipantsListPayloadResponse", {
    enumerable: true,
    get: function() {
        return $2pGLS.ParticipantsListPayloadResponse;
    }
});
Object.defineProperty(module.exports, "ParticipantPayloadResponse", {
    enumerable: true,
    get: function() {
        return $2pGLS.ParticipantPayloadResponse;
    }
});

var $48wfy = parcelRequire("48wfy");
Object.defineProperty(module.exports, "SpeechResponsePayload", {
    enumerable: true,
    get: function() {
        return $48wfy.SpeechResponsePayload;
    }
});
Object.defineProperty(module.exports, "TextResponsePayload", {
    enumerable: true,
    get: function() {
        return $48wfy.TextResponsePayload;
    }
});

});
parcelRegister("lcqjr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommandResponsePayload = void 0;
const $f6ef2115b16a2700$var$parseCommandResponse = (json)=>JSON.parse(json);
class $f6ef2115b16a2700$var$CommandResponsePayload {
    get type() {
        return this.privCommandResponse.type;
    }
    get command() {
        return this.privCommandResponse.command;
    }
    get id() {
        return this.privCommandResponse.id;
    }
    get nickname() {
        return this.privCommandResponse.nickname;
    }
    get participantId() {
        return this.privCommandResponse.participantId;
    }
    get roomid() {
        return this.privCommandResponse.roomid;
    }
    get value() {
        return this.privCommandResponse.value;
    }
    get token() {
        return this.privCommandResponse.token;
    }
    static fromJSON(json) {
        return new $f6ef2115b16a2700$var$CommandResponsePayload(json);
    }
    constructor(json){
        this.privCommandResponse = $f6ef2115b16a2700$var$parseCommandResponse(json);
    }
}
module.exports.CommandResponsePayload = $f6ef2115b16a2700$var$CommandResponsePayload;

});

parcelRegister("2pGLS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantPayloadResponse = module.exports.ParticipantsListPayloadResponse = void 0;
const $1c1f1809f350f597$var$parseListResponse = (json)=>JSON.parse(json);
const $1c1f1809f350f597$var$parseParticipantResponse = (json)=>JSON.parse(json);
class $1c1f1809f350f597$var$ParticipantsListPayloadResponse {
    get roomid() {
        return this.privParticipantsPayloadResponse.roomid;
    }
    get id() {
        return this.privParticipantsPayloadResponse.id;
    }
    get command() {
        return this.privParticipantsPayloadResponse.command;
    }
    get participants() {
        return this.privParticipantsPayloadResponse.participants;
    }
    get token() {
        return this.privParticipantsPayloadResponse.token;
    }
    get translateTo() {
        return this.privParticipantsPayloadResponse.translateTo;
    }
    get profanityFilter() {
        return this.privParticipantsPayloadResponse.profanityFilter;
    }
    get roomProfanityFilter() {
        return this.privParticipantsPayloadResponse.roomProfanityFilter;
    }
    get roomLocked() {
        return this.privParticipantsPayloadResponse.roomLocked;
    }
    get muteAll() {
        return this.privParticipantsPayloadResponse.muteAll;
    }
    get type() {
        return this.privParticipantsPayloadResponse.type;
    }
    static fromJSON(json) {
        return new $1c1f1809f350f597$var$ParticipantsListPayloadResponse(json);
    }
    constructor(json){
        this.privParticipantsPayloadResponse = $1c1f1809f350f597$var$parseListResponse(json);
    }
}
module.exports.ParticipantsListPayloadResponse = $1c1f1809f350f597$var$ParticipantsListPayloadResponse;
class $1c1f1809f350f597$var$ParticipantPayloadResponse {
    get nickname() {
        return this.privParticipantPayloadResponse.nickname;
    }
    get locale() {
        return this.privParticipantPayloadResponse.locale;
    }
    get usetts() {
        return this.privParticipantPayloadResponse.usetts;
    }
    get ismuted() {
        return this.privParticipantPayloadResponse.ismuted;
    }
    get ishost() {
        return this.privParticipantPayloadResponse.ishost;
    }
    get participantId() {
        return this.privParticipantPayloadResponse.participantId;
    }
    get avatar() {
        return this.privParticipantPayloadResponse.avatar;
    }
    static fromJSON(json) {
        return new $1c1f1809f350f597$var$ParticipantPayloadResponse(json);
    }
    constructor(json){
        this.privParticipantPayloadResponse = $1c1f1809f350f597$var$parseParticipantResponse(json);
    }
}
module.exports.ParticipantPayloadResponse = $1c1f1809f350f597$var$ParticipantPayloadResponse;

});

parcelRegister("48wfy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextResponsePayload = module.exports.SpeechResponsePayload = void 0;
const $3030eced77b14ac6$var$parseSpeechResponse = (json)=>JSON.parse(json);
const $3030eced77b14ac6$var$parseTextResponse = (json)=>JSON.parse(json);
class $3030eced77b14ac6$var$SpeechResponsePayload {
    get recognition() {
        return this.privSpeechResponse.recognition;
    }
    get translations() {
        return this.privSpeechResponse.translations;
    }
    get id() {
        return this.privSpeechResponse.id;
    }
    get language() {
        return this.privSpeechResponse.language;
    }
    get nickname() {
        return this.privSpeechResponse.nickname;
    }
    get participantId() {
        return this.privSpeechResponse.participantId;
    }
    get roomid() {
        return this.privSpeechResponse.roomid;
    }
    get timestamp() {
        return this.privSpeechResponse.timestamp;
    }
    get type() {
        return this.privSpeechResponse.type;
    }
    get isFinal() {
        return this.privSpeechResponse.type === "final";
    }
    static fromJSON(json) {
        return new $3030eced77b14ac6$var$SpeechResponsePayload(json);
    }
    constructor(json){
        this.privSpeechResponse = $3030eced77b14ac6$var$parseSpeechResponse(json);
    }
}
module.exports.SpeechResponsePayload = $3030eced77b14ac6$var$SpeechResponsePayload;
class $3030eced77b14ac6$var$TextResponsePayload {
    get originalText() {
        return this.privTextResponse.originalText;
    }
    get translations() {
        return this.privTextResponse.translations;
    }
    get id() {
        return this.privTextResponse.id;
    }
    get language() {
        return this.privTextResponse.language;
    }
    get nickname() {
        return this.privTextResponse.nickname;
    }
    get participantId() {
        return this.privTextResponse.participantId;
    }
    get roomid() {
        return this.privTextResponse.roomid;
    }
    get timestamp() {
        return this.privTextResponse.timestamp;
    }
    get type() {
        return this.privTextResponse.type;
    }
    static fromJSON(json) {
        return new $3030eced77b14ac6$var$TextResponsePayload(json);
    }
    constructor(json){
        this.privTextResponse = $3030eced77b14ac6$var$parseTextResponse(json);
    }
}
module.exports.TextResponsePayload = $3030eced77b14ac6$var$TextResponsePayload;

});




parcelRegister("5imPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberRecognizer = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $3afpL = parcelRequire("3afpL");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
class $3db056ad9aed1934$var$TranscriberRecognizer extends $14iyq.Recognizer {
    get speechRecognitionLanguage() {
        $3afpL.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
        return this.privProperties;
    }
    get authorizationToken() {
        return this.properties.getProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(token) {
        $3afpL.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($14iyq.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    set conversation(c) {
        $3afpL.Contracts.throwIfNullOrUndefined(c, "Conversation");
        this.isMeetingRecognizer = false;
        this.privConversation = c;
    }
    getConversationInfo() {
        $3afpL.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation");
        return this.privConversation.conversationInfo;
    }
    set meeting(m) {
        $3afpL.Contracts.throwIfNullOrUndefined(m, "Meeting");
        this.isMeetingRecognizer = true;
        this.privMeeting = m;
    }
    getMeetingInfo() {
        $3afpL.Contracts.throwIfNullOrUndefined(this.privMeeting, "Meeting");
        return this.privMeeting.meetingInfo;
    }
    IsMeetingRecognizer() {
        return this.isMeetingRecognizer;
    }
    startContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($h6sQE.RecognitionMode.Conversation), cb, err);
    }
    stopContinuousRecognitionAsync(cb, err) {
        $iLPPT.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    async close() {
        if (!this.privDisposedRecognizer) await this.dispose(true);
    }
    // Push async join/leave conversation message via serviceRecognizer
    async pushConversationEvent(conversationInfo, command) {
        const reco = this.privReco;
        $3afpL.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
        await reco.sendSpeechEventAsync(conversationInfo, command);
    }
    // Push async join/leave meeting message via serviceRecognizer
    async pushMeetingEvent(meetingInfo, command) {
        const reco = this.privReco;
        $3afpL.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
        await reco.sendMeetingSpeechEventAsync(meetingInfo, command);
    }
    async enforceAudioGating() {
        const audioConfigImpl = this.audioConfig;
        const format = await audioConfigImpl.format;
        const channels = format.channels;
        if (channels === 1) {
            if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true") throw new Error("Single channel audio configuration for MeetingTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
        } else if (channels !== 8) throw new Error(`Unsupported audio configuration: Detected ${channels}-channel audio`);
        return;
    }
    connectMeetingCallbacks(transcriber) {
        this.isMeetingRecognizer = true;
        this.canceled = (s, e)=>{
            if (!!transcriber.canceled) transcriber.canceled(transcriber, e);
        };
        this.recognizing = (s, e)=>{
            if (!!transcriber.transcribing) transcriber.transcribing(transcriber, e);
        };
        this.recognized = (s, e)=>{
            if (!!transcriber.transcribed) transcriber.transcribed(transcriber, e);
        };
        this.sessionStarted = (s, e)=>{
            if (!!transcriber.sessionStarted) transcriber.sessionStarted(transcriber, e);
        };
        this.sessionStopped = (s, e)=>{
            if (!!transcriber.sessionStopped) transcriber.sessionStopped(transcriber, e);
        };
    }
    disconnectCallbacks() {
        this.canceled = undefined;
        this.recognizing = undefined;
        this.recognized = undefined;
        this.sessionStarted = undefined;
        this.sessionStopped = undefined;
    }
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $h6sQE.RecognizerConfig(speechConfig, this.properties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $h6sQE.TranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
    /**
     * TranscriberRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
     */ constructor(speechTranslationConfig, audioConfig){
        const speechTranslationConfigImpl = speechTranslationConfig;
        $3afpL.Contracts.throwIfNull(speechTranslationConfigImpl, "speechTranslationConfig");
        const audioConfigImpl = audioConfig;
        $3afpL.Contracts.throwIfNull(audioConfigImpl, "audioConfigImpl");
        $3afpL.Contracts.throwIfNullOrWhitespace(speechTranslationConfigImpl.speechRecognitionLanguage, $14iyq.PropertyId[$14iyq.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechTranslationConfigImpl.properties, new $h6sQE.TranscriberConnectionFactory());
        this.privDisposedRecognizer = false;
        this.isMeetingRecognizer = false;
    }
}
module.exports.TranscriberRecognizer = $3db056ad9aed1934$var$TranscriberRecognizer;

});


parcelRegister("5NtVi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAudioMetadata = module.exports.MetadataType = void 0;
var $4388bd7cdc570560$var$MetadataType;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
    MetadataType["SentenceBoundary"] = "SentenceBoundary";
    MetadataType["SessionEnd"] = "SessionEnd";
    MetadataType["AvatarSignal"] = "TalkingAvatarSignal";
})($4388bd7cdc570560$var$MetadataType = module.exports.MetadataType || (module.exports.MetadataType = {}));
class $4388bd7cdc570560$var$SynthesisAudioMetadata {
    static fromJSON(json) {
        return new $4388bd7cdc570560$var$SynthesisAudioMetadata(json);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
    constructor(json){
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
}
module.exports.SynthesisAudioMetadata = $4388bd7cdc570560$var$SynthesisAudioMetadata;

});

parcelRegister("8L7Ow", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisTurn = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $lrnFA = parcelRequire("lrnFA");

var $14iyq = parcelRequire("14iyq");

var $5NtVi = parcelRequire("5NtVi");

var $7PBHd = parcelRequire("7PBHd");
class $6608c6319a4f9fd2$var$SynthesisTurn {
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(value) {
        this.privStreamId = value;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    get extraProperties() {
        if (!!this.privWebRTCSDP) {
            const properties = new $14iyq.PropertyCollection();
            properties.setProperty($14iyq.PropertyId.TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP);
            return properties;
        }
        return undefined;
    }
    async getAllReceivedAudio() {
        if (!!this.privReceivedAudio) return Promise.resolve(this.privReceivedAudio);
        if (!this.privIsSynthesisEnded) return null;
        await this.readAllAudioFromStream();
        return Promise.resolve(this.privReceivedAudio);
    }
    async getAllReceivedAudioWithHeader() {
        if (!!this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
        if (!this.privIsSynthesisEnded) return null;
        if (this.audioOutputFormat.hasHeader) {
            const audio = await this.getAllReceivedAudio();
            this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(audio);
            return this.privReceivedAudioWithHeader;
        } else return this.getAllReceivedAudio();
    }
    startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new $lrnFA.PullAudioOutputStreamImpl();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privPartialVisemeAnimation = "";
        this.privWebRTCSDP = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new $7PBHd.SynthesisTriggeredEvent(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
    onPreConnectionStart(authFetchEventId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.onEvent(new $7PBHd.ConnectingToSynthesisServiceEvent(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) {
            this.onEvent(new $7PBHd.SynthesisStartedEvent(this.requestId, this.privAuthFetchEventId));
            this.privBytesReceived = 0;
            return;
        } else if (statusCode === 403) this.onComplete();
    }
    onServiceResponseMessage(responseJson) {
        const response = JSON.parse(responseJson);
        this.streamId = response.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = false;
        this.privTurnDeferral.resolve();
        this.onComplete();
    }
    onServiceTurnStartResponse(responseJson) {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $iLPPT.Deferred();
        const response = JSON.parse(responseJson);
        if (!!response.webrtc) this.privWebRTCSDP = response.webrtc.connectionString;
    }
    onAudioChunkReceived(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    }
    onTextBoundaryEvent(metadata) {
        this.updateTextOffset(metadata.Data.text.Text, metadata.Type);
    }
    onVisemeMetadataReceived(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    }
    onSessionEnd(metadata) {
        this.privAudioDuration = metadata.Data.Offset;
    }
    async constructSynthesisResult() {
        const audioBuffer = await this.getAllReceivedAudioWithHeader();
        return new $14iyq.SpeechSynthesisResult(this.requestId, $14iyq.ResultReason.SynthesizingAudioCompleted, audioBuffer, undefined, this.extraProperties, this.audioDuration);
    }
    dispose() {
        if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
        this.privIsDisposed = true;
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ getAndClearVisemeAnimation() {
        const animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    }
    onEvent(event) {
        $iLPPT.Events.instance.onEvent(event);
    }
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */ static isXmlTag(text) {
        return text.length >= 2 && text[0] === "<" && text[text.length - 1] === ">";
    }
    updateTextOffset(text, type) {
        if (type === $5NtVi.MetadataType.WordBoundary) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) {
                this.privNextSearchTextIndex = this.privTextOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privTextOffset) && !$6608c6319a4f9fd2$var$SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        } else {
            this.privSentenceOffset = this.privRawText.indexOf(text, this.privNextSearchSentenceIndex);
            if (this.privSentenceOffset >= 0) {
                this.privNextSearchSentenceIndex = this.privSentenceOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privSentenceOffset) && !$6608c6319a4f9fd2$var$SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        }
    }
    onComplete() {
        if (this.privIsSynthesizing) {
            this.privIsSynthesizing = false;
            this.privIsSynthesisEnded = true;
            this.privAudioOutputStream.close();
            this.privInTurn = false;
            if (this.privTurnAudioDestination !== undefined) {
                this.privTurnAudioDestination.close();
                this.privTurnAudioDestination = undefined;
            }
        }
    }
    async readAllAudioFromStream() {
        if (this.privIsSynthesisEnded) {
            this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
            try {
                await this.privAudioOutputStream.read(this.privReceivedAudio);
            } catch (e) {
                this.privReceivedAudio = new ArrayBuffer(0);
            }
        }
    }
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */ withinXmlTag(idx) {
        return this.privRawText.indexOf("<", idx + 1) > this.privRawText.indexOf(">", idx + 1);
    }
    constructor(){
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privRequestId = $iLPPT.createNoDashGuid();
        this.privTurnDeferral = new $iLPPT.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
}
module.exports.SynthesisTurn = $6608c6319a4f9fd2$var$SynthesisTurn;

});
parcelRegister("7PBHd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisStartedEvent = module.exports.ConnectingToSynthesisServiceEvent = module.exports.SynthesisTriggeredEvent = module.exports.SpeechSynthesisEvent = void 0;

var $iLPPT = parcelRequire("iLPPT");
class $5b3a8971fd0b734b$var$SpeechSynthesisEvent extends $iLPPT.PlatformEvent {
    get requestId() {
        return this.privRequestId;
    }
    constructor(eventName, requestId, eventType = $iLPPT.EventType.Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
    }
}
module.exports.SpeechSynthesisEvent = $5b3a8971fd0b734b$var$SpeechSynthesisEvent;
class $5b3a8971fd0b734b$var$SynthesisTriggeredEvent extends $5b3a8971fd0b734b$var$SpeechSynthesisEvent {
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
    constructor(requestId, sessionAudioDestinationId, turnAudioDestinationId){
        super("SynthesisTriggeredEvent", requestId);
        this.privSessionAudioDestinationId = sessionAudioDestinationId;
        this.privTurnAudioDestinationId = turnAudioDestinationId;
    }
}
module.exports.SynthesisTriggeredEvent = $5b3a8971fd0b734b$var$SynthesisTriggeredEvent;
class $5b3a8971fd0b734b$var$ConnectingToSynthesisServiceEvent extends $5b3a8971fd0b734b$var$SpeechSynthesisEvent {
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    constructor(requestId, authFetchEventId){
        super("ConnectingToSynthesisServiceEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
}
module.exports.ConnectingToSynthesisServiceEvent = $5b3a8971fd0b734b$var$ConnectingToSynthesisServiceEvent;
class $5b3a8971fd0b734b$var$SynthesisStartedEvent extends $5b3a8971fd0b734b$var$SpeechSynthesisEvent {
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    constructor(requestId, authFetchEventId){
        super("SynthesisStartedEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
}
module.exports.SynthesisStartedEvent = $5b3a8971fd0b734b$var$SynthesisStartedEvent;

});


parcelRegister("fLGdj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAdapterBase = void 0;

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $gsMVS = parcelRequire("gsMVS");
class $b7abfd8c3ec8745c$var$SynthesisAdapterBase {
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
        this.privSynthesisTurn.audioOutputFormat = format;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
        if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    async dispose(reason) {
        this.privIsDisposed = true;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
        if (this.privConnectionConfigurationPromise !== undefined) {
            const connection = await this.privConnectionConfigurationPromise;
            await connection.dispose(reason);
        }
    }
    async connect() {
        await this.connectImpl();
    }
    async sendNetworkMessage(path, payload) {
        const type = typeof payload === "string" ? $iLPPT.MessageType.Text : $iLPPT.MessageType.Binary;
        const contentType = typeof payload === "string" ? "application/json" : "";
        const connection = await this.fetchConnection();
        return connection.send(new $gsMVS.SpeechConnectionMessage(type, path, this.privSynthesisTurn.requestId, contentType, payload));
    }
    async Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        let ssml;
        if (isSSML) ssml = text;
        else ssml = this.privSynthesizer.buildSsml(text);
        if (this.speakOverride !== undefined) return this.speakOverride(ssml, requestId, successCallback, errorCallBack);
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallBack;
        this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
        try {
            await this.connectImpl();
            const connection = await this.fetchConnection();
            await this.sendSynthesisContext(connection);
            await this.sendSsmlMessage(connection, ssml, requestId);
            this.onSynthesisStarted(requestId);
            this.receiveMessage();
        } catch (e) {
            this.cancelSynthesisLocal($14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.ConnectionFailure, e);
            return Promise.reject(e);
        }
    }
    async stopSpeaking() {
        await this.connectImpl();
        const connection = await this.fetchConnection();
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
            action: "stop"
        })));
    }
    // Cancels synthesis.
    cancelSynthesis(requestId, _cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        const result = new $14iyq.SpeechSynthesisResult(requestId, $14iyq.ResultReason.Canceled, undefined, error, properties);
        this.onSynthesisCancelled(result);
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* eslint-disable no-empty */ } catch  {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(_connectionMessage) {
        return true;
    }
    async receiveMessage() {
        try {
            const connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
            if (this.privIsDisposed) // We're done.
            return;
            // indicates we are draining the queue and it came with no message;
            if (!message) {
                if (!this.privSynthesisTurn.isSynthesizing) return;
                else return this.receiveMessage();
            }
            const connectionMessage = $gsMVS.SpeechConnectionMessage.fromConnectionMessage(message);
            if (connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                case "turn.start":
                    this.privSynthesisTurn.onServiceTurnStartResponse(connectionMessage.textBody);
                    break;
                case "response":
                    this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                    break;
                case "audio":
                    if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                        this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                        this.onSynthesizing(connectionMessage.binaryBody);
                        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                    }
                    break;
                case "audio.metadata":
                    const metadataList = $h6sQE.SynthesisAudioMetadata.fromJSON(connectionMessage.textBody).Metadata;
                    for (const metadata of metadataList)switch(metadata.Type){
                        case $h6sQE.MetadataType.WordBoundary:
                        case $h6sQE.MetadataType.SentenceBoundary:
                            this.privSynthesisTurn.onTextBoundaryEvent(metadata);
                            const wordBoundaryEventArgs = new $14iyq.SpeechSynthesisWordBoundaryEventArgs(metadata.Data.Offset, metadata.Data.Duration, metadata.Data.text.Text, metadata.Data.text.Length, metadata.Type === $h6sQE.MetadataType.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, metadata.Data.text.BoundaryType);
                            this.onWordBoundary(wordBoundaryEventArgs);
                            break;
                        case $h6sQE.MetadataType.Bookmark:
                            const bookmarkEventArgs = new $14iyq.SpeechSynthesisBookmarkEventArgs(metadata.Data.Offset, metadata.Data.Bookmark);
                            this.onBookmarkReached(bookmarkEventArgs);
                            break;
                        case $h6sQE.MetadataType.Viseme:
                            this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                            if (metadata.Data.IsLastAnimation) {
                                const visemeEventArgs = new $14iyq.SpeechSynthesisVisemeEventArgs(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                this.onVisemeReceived(visemeEventArgs);
                            }
                            break;
                        case $h6sQE.MetadataType.AvatarSignal:
                            this.onAvatarEvent(metadata);
                            break;
                        case $h6sQE.MetadataType.SessionEnd:
                            this.privSynthesisTurn.onSessionEnd(metadata);
                            break;
                    }
                    break;
                case "turn.end":
                    this.privSynthesisTurn.onServiceTurnEndResponse();
                    let result;
                    try {
                        result = await this.privSynthesisTurn.constructSynthesisResult();
                        if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                    } catch (error) {
                        if (!!this.privErrorCallback) this.privErrorCallback(error);
                    }
                    this.onSynthesisCompleted(result);
                    break;
                default:
                    if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                    {
                        if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $iLPPT.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                    }
            }
            return this.receiveMessage();
        } catch (e) {
        // TODO: What goes here?
        }
    }
    sendSynthesisContext(connection) {
        this.setSynthesisContextSynthesisSection();
        const synthesisContextJson = this.synthesisContext.toJSON();
        if (synthesisContextJson) return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
        return;
    }
    setSpeechConfigSynthesisSection() {
        return;
    }
    connectImpl(isUnAuthorized = false) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === $iLPPT.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            return this.connectImpl();
        });
        this.privAuthFetchEventId = $iLPPT.createNoDashGuid();
        this.privConnectionId = $iLPPT.createNoDashGuid();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then(async (result)=>{
            this.privSynthesisTurn.onAuthCompleted(false);
            const connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
            // it'll stop sending events.
            connection.events.attach((event)=>{
                this.connectionEvents.onEvent(event);
            });
            const response = await connection.open();
            if (response.statusCode === 200) {
                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                return Promise.resolve(connection);
            } else if (response.statusCode === 403 && !isUnAuthorized) return this.connectImpl(true);
            else {
                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                return Promise.reject(`Unable to contact server. StatusCode: ${response.statusCode},
                    ${this.privSynthesizerConfig.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Url)} Reason: ${response.reason}`);
            }
        }, (error)=>{
            this.privSynthesisTurn.onAuthCompleted(true);
            throw new Error(error);
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, SpeechServiceConfigJson) {
        if (SpeechServiceConfigJson) return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
    }
    sendSsmlMessage(connection, ssml, requestId) {
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "ssml", requestId, "application/ssml+xml", ssml));
    }
    async fetchConnection() {
        if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
            if (connection.state() === $iLPPT.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                return this.fetchConnection();
            }
            return this.privConnectionConfigurationPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigurationPromise = undefined;
            return this.fetchConnection();
        });
        this.privConnectionConfigurationPromise = this.configureConnection();
        return await this.privConnectionConfigurationPromise;
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
        const connection = await this.connectImpl();
        if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
        this.setSpeechConfigSynthesisSection();
        await this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());
        return connection;
    }
    onAvatarEvent(_metadata) {
        return;
    }
    onSynthesisStarted(_requestId) {
        return;
    }
    onSynthesizing(_audio) {
        return;
    }
    onSynthesisCancelled(_result) {
        return;
    }
    onSynthesisCompleted(_result) {
        return;
    }
    onWordBoundary(_wordBoundaryEventArgs) {
        return;
    }
    onVisemeReceived(_visemeEventArgs) {
        return;
    }
    onBookmarkReached(_bookmarkEventArgs) {
        return;
    }
    constructor(authentication, connectionFactory, synthesizerConfig, audioDestination){
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        if (!authentication) throw new $iLPPT.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $iLPPT.ArgumentNullError("connectionFactory");
        if (!synthesizerConfig) throw new $iLPPT.ArgumentNullError("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new $h6sQE.SynthesisTurn();
        this.privConnectionEvents = new $iLPPT.EventSource();
        this.privServiceEvents = new $iLPPT.EventSource();
        this.privSynthesisContext = new $h6sQE.SynthesisContext();
        this.privAgentConfig = new $h6sQE.AgentConfig();
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) this.cancelSynthesisLocal($14iyq.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $14iyq.CancellationErrorCode.BadRequestParameters : $14iyq.CancellationErrorCode.ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
    }
}
module.exports.SynthesisAdapterBase = $b7abfd8c3ec8745c$var$SynthesisAdapterBase;
$b7abfd8c3ec8745c$var$SynthesisAdapterBase.telemetryDataEnabled = true;

});

parcelRegister("lkoPP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarSynthesisAdapter = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
class $f86ebaf42f9f6d6b$var$AvatarSynthesisAdapter extends $h6sQE.SynthesisAdapterBase {
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(undefined);
    }
    setSpeechConfigSynthesisSection() {
        var _this_privAvatarConfig_videoFormat, _this_privAvatarConfig_videoFormat1, _this_privAvatarConfig_videoFormat_cropRange_bottomRight, _this_privAvatarConfig_videoFormat_cropRange, _this_privAvatarConfig_videoFormat2, _this_privAvatarConfig_videoFormat_cropRange_bottomRight1, _this_privAvatarConfig_videoFormat_cropRange1, _this_privAvatarConfig_videoFormat3, _this_privAvatarConfig_videoFormat_cropRange_topLeft, _this_privAvatarConfig_videoFormat_cropRange2, _this_privAvatarConfig_videoFormat4, _this_privAvatarConfig_videoFormat_cropRange_topLeft1, _this_privAvatarConfig_videoFormat_cropRange3, _this_privAvatarConfig_videoFormat5, _this_privAvatarConfig_videoFormat6, _this_privAvatarConfig_videoFormat7, _this_privAvatarConfig_backgroundImage;
        var _this_privAvatarConfig_remoteIceServers;
        this.privSynthesizerConfig.synthesisVideoSection = {
            format: {
                bitrate: (_this_privAvatarConfig_videoFormat = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat === void 0 ? void 0 : _this_privAvatarConfig_videoFormat.bitrate,
                codec: (_this_privAvatarConfig_videoFormat1 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat1 === void 0 ? void 0 : _this_privAvatarConfig_videoFormat1.codec,
                crop: {
                    bottomRight: {
                        x: (_this_privAvatarConfig_videoFormat2 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat2 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange = _this_privAvatarConfig_videoFormat2.cropRange) === null || _this_privAvatarConfig_videoFormat_cropRange === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange_bottomRight = _this_privAvatarConfig_videoFormat_cropRange.bottomRight) === null || _this_privAvatarConfig_videoFormat_cropRange_bottomRight === void 0 ? void 0 : _this_privAvatarConfig_videoFormat_cropRange_bottomRight.x,
                        y: (_this_privAvatarConfig_videoFormat3 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat3 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange1 = _this_privAvatarConfig_videoFormat3.cropRange) === null || _this_privAvatarConfig_videoFormat_cropRange1 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange_bottomRight1 = _this_privAvatarConfig_videoFormat_cropRange1.bottomRight) === null || _this_privAvatarConfig_videoFormat_cropRange_bottomRight1 === void 0 ? void 0 : _this_privAvatarConfig_videoFormat_cropRange_bottomRight1.y
                    },
                    topLeft: {
                        x: (_this_privAvatarConfig_videoFormat4 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat4 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange2 = _this_privAvatarConfig_videoFormat4.cropRange) === null || _this_privAvatarConfig_videoFormat_cropRange2 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange_topLeft = _this_privAvatarConfig_videoFormat_cropRange2.topLeft) === null || _this_privAvatarConfig_videoFormat_cropRange_topLeft === void 0 ? void 0 : _this_privAvatarConfig_videoFormat_cropRange_topLeft.x,
                        y: (_this_privAvatarConfig_videoFormat5 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat5 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange3 = _this_privAvatarConfig_videoFormat5.cropRange) === null || _this_privAvatarConfig_videoFormat_cropRange3 === void 0 ? void 0 : (_this_privAvatarConfig_videoFormat_cropRange_topLeft1 = _this_privAvatarConfig_videoFormat_cropRange3.topLeft) === null || _this_privAvatarConfig_videoFormat_cropRange_topLeft1 === void 0 ? void 0 : _this_privAvatarConfig_videoFormat_cropRange_topLeft1.y
                    }
                },
                resolution: {
                    height: (_this_privAvatarConfig_videoFormat6 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat6 === void 0 ? void 0 : _this_privAvatarConfig_videoFormat6.height,
                    width: (_this_privAvatarConfig_videoFormat7 = this.privAvatarConfig.videoFormat) === null || _this_privAvatarConfig_videoFormat7 === void 0 ? void 0 : _this_privAvatarConfig_videoFormat7.width
                }
            },
            protocol: {
                name: "WebRTC",
                webrtcConfig: {
                    clientDescription: btoa(this.privSynthesizerConfig.parameters.getProperty($14iyq.PropertyId.TalkingAvatarService_WebRTC_SDP)),
                    iceServers: (_this_privAvatarConfig_remoteIceServers = this.privAvatarConfig.remoteIceServers) !== null && _this_privAvatarConfig_remoteIceServers !== void 0 ? _this_privAvatarConfig_remoteIceServers : this.privAvatarSynthesizer.iceServers
                }
            },
            talkingAvatar: {
                background: {
                    color: this.privAvatarConfig.backgroundColor,
                    image: {
                        url: (_this_privAvatarConfig_backgroundImage = this.privAvatarConfig.backgroundImage) === null || _this_privAvatarConfig_backgroundImage === void 0 ? void 0 : _this_privAvatarConfig_backgroundImage.toString()
                    }
                },
                character: this.privAvatarConfig.character,
                customized: this.privAvatarConfig.customized,
                style: this.privAvatarConfig.style
            }
        };
    }
    onAvatarEvent(metadata) {
        if (!!this.privAvatarSynthesizer.avatarEventReceived) {
            const avatarEventArgs = new $14iyq.AvatarEventArgs(metadata.Data.Offset, metadata.Data.Name);
            try {
                this.privAvatarSynthesizer.avatarEventReceived(this.privAvatarSynthesizer, avatarEventArgs);
            } catch (error) {
            // Not going to let errors in the event handler
            // trip things up.
            }
        }
    }
    constructor(authentication, connectionFactory, synthesizerConfig, avatarSynthesizer, avatarConfig){
        super(authentication, connectionFactory, synthesizerConfig, undefined);
        this.privAvatarSynthesizer = avatarSynthesizer;
        this.privSynthesizer = avatarSynthesizer;
        this.privAvatarConfig = avatarConfig;
    }
}
module.exports.AvatarSynthesisAdapter = $f86ebaf42f9f6d6b$var$AvatarSynthesisAdapter;

});

parcelRegister("8bhPC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisAdapter = void 0;

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");
class $5f4d2ecb901a9c94$var$SpeechSynthesisAdapter extends $h6sQE.SynthesisAdapterBase {
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(requestId) {
        const synthesisStartEventArgs = new $14iyq.SpeechSynthesisEventArgs(new $14iyq.SpeechSynthesisResult(requestId, $14iyq.ResultReason.SynthesizingAudioStarted));
        if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
    }
    onSynthesizing(audio) {
        if (!!this.privSpeechSynthesizer.synthesizing) try {
            const audioWithHeader = this.privSynthesisTurn.audioOutputFormat.addHeader(audio);
            const ev = new $14iyq.SpeechSynthesisEventArgs(new $14iyq.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $14iyq.ResultReason.SynthesizingAudio, audioWithHeader));
            this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onSynthesisCancelled(result) {
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            const cancelEvent = new $14iyq.SpeechSynthesisEventArgs(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    onSynthesisCompleted(result) {
        if (this.privSpeechSynthesizer.synthesisCompleted) try {
            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $14iyq.SpeechSynthesisEventArgs(result));
        } catch (e) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onWordBoundary(wordBoundaryEventArgs) {
        if (!!this.privSpeechSynthesizer.wordBoundary) try {
            this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onVisemeReceived(visemeEventArgs) {
        if (!!this.privSpeechSynthesizer.visemeReceived) try {
            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onBookmarkReached(bookmarkEventArgs) {
        if (!!this.privSpeechSynthesizer.bookmarkReached) try {
            this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    constructor(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination){
        super(authentication, connectionFactory, synthesizerConfig, audioDestination);
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSynthesizer = speechSynthesizer;
    }
}
module.exports.SpeechSynthesisAdapter = $5f4d2ecb901a9c94$var$SpeechSynthesisAdapter;

});

parcelRegister("av8Ig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRestAdapter = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $14iyq = parcelRequire("14iyq");

var $6wf4H = parcelRequire("6wf4H");

var $7Us8Y = parcelRequire("7Us8Y");
/**
 * Implements methods for speaker recognition classes, sending requests to endpoint
 * and parsing response into expected format
 * @class SynthesisRestAdapter
 */ class $7a538ed0eb59a264$var$SynthesisRestAdapter {
    /**
     * Sends list voices request to endpoint.
     * @function
     * @public
     * @param connectionId - guid for connectionId
     * @returns {Promise<IRestResponse>} rest response to status request
     */ getVoicesList(connectionId) {
        this.privRestAdapter.setHeaders($7Us8Y.HeaderNames.ConnectionId, connectionId);
        return this.privAuthentication.fetch(connectionId).then((authInfo)=>{
            this.privRestAdapter.setHeaders(authInfo.headerName, authInfo.token);
            return this.privRestAdapter.request($1JzGB.RestRequestType.Get, this.privUri);
        });
    }
    constructor(config, authentication){
        let endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            const region = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Region, "westus");
            const hostSuffix = $6wf4H.ConnectionFactoryBase.getHostSuffix(region);
            endpoint = config.parameters.getProperty($14iyq.PropertyId.SpeechServiceConnection_Host, `https://${region}.tts.speech${hostSuffix}`);
        }
        this.privUri = `${endpoint}/cognitiveservices/voices/list`;
        const options = $1JzGB.RestConfigBase.requestOptions;
        this.privRestAdapter = new $1JzGB.RestMessageAdapter(options);
        this.privAuthentication = authentication;
    }
}
module.exports.SynthesisRestAdapter = $7a538ed0eb59a264$var$SynthesisRestAdapter;

});

parcelRegister("6FV1U", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesizerConfig = module.exports.SynthesisServiceType = void 0;

var $h6sQE = parcelRequire("h6sQE");
var $4dc2cf5b3aa43f05$var$SynthesisServiceType;
(function(SynthesisServiceType) {
    SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
    SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})($4dc2cf5b3aa43f05$var$SynthesisServiceType = module.exports.SynthesisServiceType || (module.exports.SynthesisServiceType = {}));
class $4dc2cf5b3aa43f05$var$SynthesizerConfig {
    get parameters() {
        return this.privParameters;
    }
    get synthesisServiceType() {
        return this.privSynthesisServiceType;
    }
    set synthesisServiceType(value) {
        this.privSynthesisServiceType = value;
    }
    set synthesisVideoSection(value) {
        this.privSpeechServiceConfig.Context.synthesis = {
            video: value
        };
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    constructor(speechServiceConfig, parameters){
        this.privSynthesisServiceType = $4dc2cf5b3aa43f05$var$SynthesisServiceType.Standard;
        this.avatarEnabled = false;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $h6sQE.SpeechServiceConfig(new $h6sQE.Context(null));
        this.privParameters = parameters;
    }
}
module.exports.SynthesizerConfig = $4dc2cf5b3aa43f05$var$SynthesizerConfig;

});

parcelRegister("bbI9p", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisContext = void 0;

var $14iyq = parcelRequire("14iyq");
/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $8252f83210e8e6e2$var$SynthesisContext {
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */ set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    toJSON() {
        return JSON.stringify(this.privContext);
    }
    setSynthesisSection(speechSynthesizer) {
        const synthesisSection = this.buildSynthesisContext(speechSynthesizer);
        this.setSection("synthesis", synthesisSection);
    }
    buildSynthesisContext(speechSynthesizer) {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.bookmarkReached),
                    punctuationBoundaryEnabled: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.properties.getProperty($14iyq.PropertyId.SpeechServiceResponse_RequestPunctuationBoundary, !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.wordBoundary)),
                    sentenceBoundaryEnabled: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.properties.getProperty($14iyq.PropertyId.SpeechServiceResponse_RequestSentenceBoundary, false),
                    sessionEndEnabled: true,
                    visemeEnabled: !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.visemeReceived),
                    wordBoundaryEnabled: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.properties.getProperty($14iyq.PropertyId.SpeechServiceResponse_RequestWordBoundary, !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.wordBoundary))
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.autoDetectSourceLanguage
            }
        };
    }
    constructor(){
        this.privContext = {};
    }
}
module.exports.SynthesisContext = $8252f83210e8e6e2$var$SynthesisContext;

});

parcelRegister("kmU1B", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionConfig = void 0;

var $h6sQE = parcelRequire("h6sQE");
class $ed41521b28d1705f$var$SpeakerRecognitionConfig {
    get parameters() {
        return this.privParameters;
    }
    get Context() {
        return this.privContext;
    }
    constructor(context, parameters){
        this.privContext = context ? context : new $h6sQE.Context(null);
        this.privParameters = parameters;
    }
}
module.exports.SpeakerRecognitionConfig = $ed41521b28d1705f$var$SpeakerRecognitionConfig;

});

parcelRegister("1WVuz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerServiceRecognizer = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $gsMVS = parcelRequire("gsMVS");
// eslint-disable-next-line max-classes-per-file
class $16b7cdf2abb1af48$var$SpeakerServiceRecognizer extends $h6sQE.ServiceRecognizerBase {
    processTypeSpecificMessages(connectionMessage) {
        let processed = false;
        const resultProps = new $14iyq.PropertyCollection();
        if (connectionMessage.messageType === $iLPPT.MessageType.Text) resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speaker.response":
                const response = JSON.parse(connectionMessage.textBody);
                let result;
                if (response.status.statusCode.toLowerCase() !== "success") result = new $14iyq.SpeakerRecognitionResult(response, $14iyq.ResultReason.Canceled, $14iyq.CancellationErrorCode.ServiceError, response.status.reason);
                else result = new $14iyq.SpeakerRecognitionResult(response, $14iyq.ResultReason.RecognizedSpeaker);
                if (!!this.privResultDeferral) this.privResultDeferral.resolve(result);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $iLPPT.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        if (!!this.privResultDeferral) {
            const result = new $14iyq.SpeakerRecognitionResult({
                scenario: this.privSpeakerModel.scenario,
                status: {
                    statusCode: error,
                    reason: error
                }
            }, $14iyq.ResultReason.Canceled, errorCode, error);
            try {
                this.privResultDeferral.resolve(result);
            } catch (error) {
                this.privResultDeferral.reject(error);
            }
        }
    }
    async recognizeSpeakerOnce(model) {
        this.privSpeakerModel = model;
        this.voiceProfileType = model.scenario;
        if (!this.privResultDeferral) this.privResultDeferral = new $iLPPT.Deferred();
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($14iyq.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages(this.extractSpeakerContext(model));
        const node = await this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privSpeakerAudioSource.format;
        const deviceInfo = await this.privSpeakerAudioSource.deviceInfo;
        const audioNode = new $1JzGB.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (err) {
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.ConnectionFailure, err);
        }
        const sessionStartEventArgs = new $14iyq.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, (error)=>{
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.RuntimeError, error);
        });
        return this.privResultDeferral.promise;
    }
    async sendPreAudioMessages(context) {
        const connection = await this.fetchConnection();
        await this.sendSpeakerRecognition(connection, context);
    // await this.sendWaveHeader(connection);
    }
    async sendSpeakerRecognition(connection, context) {
        const speakerContextJson = JSON.stringify(context);
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", speakerContextJson));
    }
    extractSpeakerContext(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privSpeakerRecognizer = recognizer;
        this.privSpeakerAudioSource = audioSource;
        this.recognizeSpeaker = (model)=>this.recognizeSpeakerOnce(model);
        this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
}
module.exports.SpeakerServiceRecognizer = $16b7cdf2abb1af48$var$SpeakerServiceRecognizer;

});

parcelRegister("kdfbc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceServiceRecognizer = void 0;

var $1JzGB = parcelRequire("1JzGB");

var $iLPPT = parcelRequire("iLPPT");

var $14iyq = parcelRequire("14iyq");

var $h6sQE = parcelRequire("h6sQE");

var $gsMVS = parcelRequire("gsMVS");
// eslint-disable-next-line max-classes-per-file
class $eb70cbe3e5ca5f66$var$VoiceServiceRecognizer extends $h6sQE.ServiceRecognizerBase {
    set SpeakerAudioSource(audioSource) {
        this.privSpeakerAudioSource = audioSource;
    }
    processTypeSpecificMessages(connectionMessage) {
        let processed = false;
        const resultProps = new $14iyq.PropertyCollection();
        if (connectionMessage.messageType === $iLPPT.MessageType.Text) resultProps.setProperty($14iyq.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            // Profile management response for create, fetch, delete, reset
            case "speaker.profiles":
                const response = JSON.parse(connectionMessage.textBody);
                switch(response.operation.toLowerCase()){
                    case "create":
                        this.handleCreateResponse(response, connectionMessage.requestId);
                        break;
                    case "delete":
                    case "reset":
                        this.handleResultResponse(response, connectionMessage.requestId);
                        break;
                    case "fetch":
                        const enrollmentResponse = JSON.parse(connectionMessage.textBody);
                        this.handleFetchResponse(enrollmentResponse, connectionMessage.requestId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            // Activation and authorization phrase response
            case "speaker.phrases":
                const phraseResponse = JSON.parse(connectionMessage.textBody);
                this.handlePhrasesResponse(phraseResponse, connectionMessage.requestId);
                processed = true;
                break;
            // Enrollment response
            case "speaker.profile.enrollment":
                const enrollmentResponse1 = JSON.parse(connectionMessage.textBody);
                const result = new $14iyq.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(!!enrollmentResponse1.enrollment ? enrollmentResponse1.enrollment.enrollmentStatus : enrollmentResponse1.status.statusCode), !!enrollmentResponse1.enrollment ? JSON.stringify(enrollmentResponse1.enrollment) : undefined, enrollmentResponse1.status.reason);
                if (!!this.privDeferralMap.getId(connectionMessage.requestId)) this.privDeferralMap.complete(connectionMessage.requestId, result);
                this.privRequestSession.onSpeechEnded();
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $iLPPT.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $14iyq.PropertyCollection();
        // const enrollmentResponse: EnrollmentResponse = JSON.parse(connectionMessage.textBody) as EnrollmentResponse;
        properties.setProperty($h6sQE.CancellationErrorCodePropertyName, $14iyq.CancellationErrorCode[errorCode]);
        const result = new $14iyq.VoiceProfileEnrollmentResult($14iyq.ResultReason.Canceled, error, error);
        if (!!this.privDeferralMap.getId(requestId)) this.privDeferralMap.complete(requestId, result);
    }
    async createProfile(profileType, locale) {
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        this.voiceProfileType = profileType.toString();
        const conPromise = this.connectImpl();
        try {
            const createProfileDeferral = new $iLPPT.Deferred();
            await conPromise;
            await this.sendCreateProfile(createProfileDeferral, profileType, locale);
            this.receiveMessage();
            return createProfileDeferral.promise;
        } catch (err) {
            throw err;
        }
    }
    async resetProfile(profile) {
        this.voiceProfileType = profile.profileType.toString();
        return this.sendCommonRequest("reset", profile.profileType, profile);
    }
    async deleteProfile(profile) {
        this.voiceProfileType = profile.profileType.toString();
        return this.sendCommonRequest("delete", profile.profileType, profile);
    }
    async retrieveEnrollmentResult(profile) {
        this.voiceProfileType = profile.profileType.toString();
        this.privExpectedProfileId = profile.profileId;
        return this.sendCommonRequest("fetch", profile.profileType, profile);
    }
    async getAllProfiles(profileType) {
        this.voiceProfileType = profileType.toString();
        return this.sendCommonRequest("fetch", profileType);
    }
    async getActivationPhrases(profileType, lang) {
        this.voiceProfileType = profileType.toString();
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        try {
            const getPhrasesDeferral = new $iLPPT.Deferred();
            await conPromise;
            await this.sendPhrasesRequest(getPhrasesDeferral, profileType, lang);
            this.receiveMessage();
            return getPhrasesDeferral.promise;
        } catch (err) {
            throw err;
        }
    }
    async enrollProfile(profile) {
        this.voiceProfileType = profile.profileType.toString();
        const enrollmentDeferral = new $iLPPT.Deferred();
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($14iyq.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages(profile, enrollmentDeferral);
        const node = await this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privSpeakerAudioSource.format;
        const deviceInfo = await this.privSpeakerAudioSource.deviceInfo;
        const audioNode = new $1JzGB.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (err) {
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.ConnectionFailure, err);
        }
        const sessionStartEventArgs = new $14iyq.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, (error)=>{
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $14iyq.CancellationReason.Error, $14iyq.CancellationErrorCode.RuntimeError, error);
        });
        return enrollmentDeferral.promise;
    }
    async sendPreAudioMessages(profile, enrollmentDeferral) {
        const connection = await this.fetchConnection();
        this.privRequestSession.onSpeechContext();
        this.privDeferralMap.add(this.privRequestSession.requestId, enrollmentDeferral);
        await this.sendBaseRequest(connection, "enroll", this.scenarioFrom(profile.profileType), profile);
    }
    async sendPhrasesRequest(getPhrasesDeferral, profileType, locale) {
        const connection = await this.fetchConnection();
        this.privRequestSession.onSpeechContext();
        this.privDeferralMap.add(this.privRequestSession.requestId, getPhrasesDeferral);
        const scenario = this.scenarioFrom(profileType);
        const profileCreateRequest = {
            locale: locale,
            scenario: scenario
        };
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)));
    }
    async sendCreateProfile(createProfileDeferral, profileType, locale) {
        const connection = await this.fetchConnection();
        this.privRequestSession.onSpeechContext();
        this.privDeferralMap.add(this.privRequestSession.requestId, createProfileDeferral);
        const scenario = profileType === $14iyq.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : profileType === $14iyq.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
        const profileCreateRequest = {
            locale: locale,
            number: "1",
            scenario: scenario
        };
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)));
    }
    async sendCommonRequest(operation, profileType, profile) {
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        try {
            const deferral = new $iLPPT.Deferred();
            this.privRequestSession.onSpeechContext();
            await conPromise;
            const connection = await this.fetchConnection();
            this.privDeferralMap.add(this.privRequestSession.requestId, deferral);
            await this.sendBaseRequest(connection, operation, this.scenarioFrom(profileType), profile);
            this.receiveMessage();
            return deferral.promise;
        } catch (err) {
            throw err;
        }
    }
    async sendBaseRequest(connection, operation, scenario, profile) {
        const profileRequest = {
            scenario: scenario
        };
        if (!!profile) profileRequest.profileIds = [
            profile.profileId
        ];
        else profileRequest.maxPageSize = -1;
        return connection.send(new $gsMVS.SpeechConnectionMessage($iLPPT.MessageType.Text, `speaker.profile.${operation}`, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileRequest)));
    }
    extractSpeakerContext(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    }
    handlePhrasesResponse(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            if (response.status.statusCode.toLowerCase() !== "success") {
                const reason = $14iyq.ResultReason.Canceled;
                const result = new $14iyq.VoiceProfilePhraseResult(reason, response.status.statusCode, response.passPhraseType, []);
                this.privDeferralMap.complete(requestId, result);
            } else if (!!response.phrases && response.phrases.length > 0) {
                const reason = $14iyq.ResultReason.EnrollingVoiceProfile;
                const result = new $14iyq.VoiceProfilePhraseResult(reason, response.status.statusCode, response.passPhraseType, response.phrases);
                this.privDeferralMap.complete(requestId, result);
            } else throw new Error("Voice Profile get activation phrases failed, no phrases received");
        } else throw new Error(`Voice Profile get activation phrases request for requestID ${requestId} not found`);
    }
    handleCreateResponse(response, requestId) {
        if (!!response.profiles && response.profiles.length > 0) {
            if (!!this.privDeferralMap.getId(requestId)) {
                const profileIds = response.profiles.map((profile)=>profile.profileId);
                this.privDeferralMap.complete(requestId, profileIds);
            } else throw new Error(`Voice Profile create request for requestID ${requestId} not found`);
        } else throw new Error("Voice Profile create failed, no profile id received");
    }
    handleResultResponse(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            const successReason = response.operation.toLowerCase() === "delete" ? $14iyq.ResultReason.DeletedVoiceProfile : $14iyq.ResultReason.ResetVoiceProfile;
            const reason = response.status.statusCode.toLowerCase() === "success" ? successReason : $14iyq.ResultReason.Canceled;
            const result = new $14iyq.VoiceProfileResult(reason, `statusCode: ${response.status.statusCode}, errorDetails: ${response.status.reason}`);
            this.privDeferralMap.complete(requestId, result);
        } else throw new Error(`Voice Profile create request for requestID ${requestId} not found`);
    }
    handleFetchResponse(enrollmentResponse, requestId) {
        if (!!this.privDeferralMap.getId(requestId) && !!enrollmentResponse.profiles[0]) {
            if (!!this.privExpectedProfileId && enrollmentResponse.profiles.length === 1 && enrollmentResponse.profiles[0].profileId === this.privExpectedProfileId) {
                this.privExpectedProfileId = undefined;
                const profileInfo = enrollmentResponse.profiles[0];
                const result = new $14iyq.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(profileInfo.enrollmentStatus), JSON.stringify(profileInfo), enrollmentResponse.status.reason);
                this.privDeferralMap.complete(requestId, result);
            } else if (enrollmentResponse.profiles.length > 0) {
                const iProfiles = enrollmentResponse.profiles;
                const profileResults = [];
                for (const profile of iProfiles)profileResults.push(new $14iyq.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(profile.enrollmentStatus), JSON.stringify(profile), enrollmentResponse.status.reason));
                this.privDeferralMap.complete(requestId, profileResults);
            }
        } else throw new Error(`Voice Profile fetch request for requestID ${requestId} not found`);
    }
    enrollmentReasonFrom(statusCode) {
        switch(statusCode.toLowerCase()){
            case "enrolled":
                return $14iyq.ResultReason.EnrolledVoiceProfile;
            case "invalidlocale":
            case "invalidphrase":
            case "invalidaudioformat":
            case "invalidscenario":
            case "invalidprofilecount":
            case "invalidoperation":
            case "audiotooshort":
            case "audiotoolong":
            case "toomanyenrollments":
            case "storageconflict":
            case "profilenotfound":
            case "incompatibleprofiles":
            case "incompleteenrollment":
                return $14iyq.ResultReason.Canceled;
            default:
                return $14iyq.ResultReason.EnrollingVoiceProfile;
        }
    }
    scenarioFrom(profileType) {
        return profileType === $14iyq.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : profileType === $14iyq.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    }
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privDeferralMap = new $iLPPT.DeferralMap();
        this.privSpeakerAudioSource = audioSource;
        this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
}
module.exports.VoiceServiceRecognizer = $eb70cbe3e5ca5f66$var$VoiceServiceRecognizer;

});

parcelRegister("ePv0n", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.type = module.exports.connectivity = module.exports.Device = module.exports.OS = module.exports.System = module.exports.Context = module.exports.SpeechServiceConfig = void 0;
/* eslint-disable max-classes-per-file */ // The config is serialized and sent as the Speech.Config
class $acbde110be94ada9$var$SpeechServiceConfig {
    serialize() {
        return JSON.stringify(this, (key, value)=>{
            if (value && typeof value === "object" && !Array.isArray(value)) {
                const replacement = {};
                for(const k in value)if (Object.hasOwnProperty.call(value, k)) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                return replacement;
            }
            return value;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(value) {
        this.recognition = value.toLowerCase();
    }
    constructor(context){
        this.context = context;
    }
}
module.exports.SpeechServiceConfig = $acbde110be94ada9$var$SpeechServiceConfig;
class $acbde110be94ada9$var$Context {
    constructor(os){
        this.system = new $acbde110be94ada9$var$System();
        this.os = os;
    }
}
module.exports.Context = $acbde110be94ada9$var$Context;
class $acbde110be94ada9$var$System {
    constructor(){
        // Note: below will be patched for official builds.
        const SPEECHSDK_CLIENTSDK_VERSION = "1.40.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
}
module.exports.System = $acbde110be94ada9$var$System;
class $acbde110be94ada9$var$OS {
    constructor(platform, name, version){
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
}
module.exports.OS = $acbde110be94ada9$var$OS;
class $acbde110be94ada9$var$Device {
    constructor(manufacturer, model, version){
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
}
module.exports.Device = $acbde110be94ada9$var$Device;
var $acbde110be94ada9$var$connectivity;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($acbde110be94ada9$var$connectivity = module.exports.connectivity || (module.exports.connectivity = {}));
var $acbde110be94ada9$var$type;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($acbde110be94ada9$var$type = module.exports.type || (module.exports.type = {}));

});




parcelRegister("gnvKK", function(module, exports) {
"use strict";

var $53O4H = parcelRequire("53O4H");

var $3kONX = parcelRequire("3kONX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bec76ccf2f2a9e9a$var$React = $3kONX((parcelRequire("dgG1Y")));

var $bec76ccf2f2a9e9a$var$_createSvgIcon = $53O4H((parcelRequire("dbCoC")));
var $bec76ccf2f2a9e9a$var$_default = (0, $bec76ccf2f2a9e9a$var$_createSvgIcon.default)(/*#__PURE__*/ $bec76ccf2f2a9e9a$var$React.createElement("path", {
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}), "Phone");
module.exports.default = $bec76ccf2f2a9e9a$var$_default;

});

parcelRegister("lvs1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa823c0ec04fc741$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $6mYJl = parcelRequire("6mYJl");
var $fa823c0ec04fc741$export$2e2bcd8739ae039 = (0, $6mYJl.default)(/*#__PURE__*/ $dgG1Y.createElement($dgG1Y.Fragment, null, /*#__PURE__*/ $dgG1Y.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "2"
}), /*#__PURE__*/ $dgG1Y.createElement("path", {
    d: "M10 3h4v12h-4z"
})), "PriorityHigh");

});


parcelRegister("h73EU", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $c755edb41fe7c753$export$bfafe629242f30bd; });
$parcel$export(module.exports, "useWebSocket", function () { return $c755edb41fe7c753$export$ef4944d05bd3db0; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $adDXz = parcelRequire("adDXz");

var $31cpC = parcelRequire("31cpC");

var $ewdxp = parcelRequire("ewdxp");
const $c755edb41fe7c753$var$WebSocketContext = /*#__PURE__*/ (0, $dgG1Y.createContext)(null);
const $c755edb41fe7c753$export$bfafe629242f30bd = ({ children: children })=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [socket, setSocket] = (0, $dgG1Y.useState)(null);
    const setupSocket = (0, $dgG1Y.useCallback)(()=>{
        if (!auth.accountableAdmin) return undefined;
        let openCount = 1;
        const SOCKET_URL = "wss://899cjte703.execute-api.us-east-1.amazonaws.com/default/";
        const socketInstance = new (0, $adDXz.default)(SOCKET_URL);
        socketInstance.addEventListener("open", ()=>{
            socketInstance.send(JSON.stringify({
                event: "newConnection",
                token: auth.token,
                openCount: openCount
            }));
            openCount += 1;
        });
        socketInstance.addEventListener("close", ()=>{
            console.log("socket connection closed");
            setSocket(null);
        });
        socketInstance.addEventListener("message", (message)=>{
            if (message.data === "PING") setTimeout(()=>{
                socketInstance.send(JSON.stringify({
                    event: "PONG",
                    token: auth.token
                }));
            }, 10000);
            else if (message === null || message === void 0 ? void 0 : message.data.includes("Internal server error")) console.log("socket error");
            else {
                const { name: name } = JSON.parse(message.data);
                (0, (/*@__PURE__*/$parcel$interopDefault($31cpC))).success(`New message from: ${name}`);
                new Audio("https://accountableimages.s3.amazonaws.com/message.mp3").play();
            }
        });
        setSocket(socketInstance);
        return ()=>{
            socketInstance === null || socketInstance === void 0 ? void 0 : socketInstance.close();
        };
    }, [
        auth.accountableAdmin,
        auth.token
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        if (!auth.isLoggedIn && socket) socket.close();
        else if (!socket && auth.isLoggedIn) setupSocket();
        return ()=>{
            if (socket) socket.close();
        };
    }, [
        auth.isLoggedIn,
        setupSocket,
        socket
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($c755edb41fe7c753$var$WebSocketContext.Provider, {
        value: socket,
        children: children
    });
};
const $c755edb41fe7c753$export$ef4944d05bd3db0 = ()=>{
    return (0, $dgG1Y.useContext)($c755edb41fe7c753$var$WebSocketContext);
};

});
parcelRegister("adDXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $770a1d731c00536d$export$2e2bcd8739ae039; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $770a1d731c00536d$var$extendStatics = function(d, b) {
    $770a1d731c00536d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $770a1d731c00536d$var$extendStatics(d, b);
};
function $770a1d731c00536d$var$__extends(d, b) {
    $770a1d731c00536d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $770a1d731c00536d$var$__values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
}
function $770a1d731c00536d$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $770a1d731c00536d$var$__spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($770a1d731c00536d$var$__read(arguments[i]));
    return ar;
}
var $770a1d731c00536d$var$Event = /** @class */ function() {
    function Event(type, target) {
        this.target = target;
        this.type = type;
    }
    return Event;
}();
var $770a1d731c00536d$var$ErrorEvent = /** @class */ function(_super) {
    $770a1d731c00536d$var$__extends(ErrorEvent, _super);
    function ErrorEvent(error, target) {
        var _this = _super.call(this, "error", target) || this;
        _this.message = error.message;
        _this.error = error;
        return _this;
    }
    return ErrorEvent;
}($770a1d731c00536d$var$Event);
var $770a1d731c00536d$var$CloseEvent = /** @class */ function(_super) {
    $770a1d731c00536d$var$__extends(CloseEvent, _super);
    function CloseEvent(code, reason, target) {
        if (code === void 0) code = 1000;
        if (reason === void 0) reason = "";
        var _this = _super.call(this, "close", target) || this;
        _this.wasClean = true;
        _this.code = code;
        _this.reason = reason;
        return _this;
    }
    return CloseEvent;
}($770a1d731c00536d$var$Event);
/*!
 * Reconnecting WebSocket
 * by Pedro Ladaria <pedro.ladaria@gmail.com>
 * https://github.com/pladaria/reconnecting-websocket
 * License MIT
 */ var $770a1d731c00536d$var$getGlobalWebSocket = function() {
    if (typeof WebSocket !== "undefined") // @ts-ignore
    return WebSocket;
};
/**
 * Returns true if given argument looks like a WebSocket class
 */ var $770a1d731c00536d$var$isWebSocket = function(w) {
    return typeof w !== "undefined" && !!w && w.CLOSING === 2;
};
var $770a1d731c00536d$var$DEFAULT = {
    maxReconnectionDelay: 10000,
    minReconnectionDelay: 1000 + Math.random() * 4000,
    minUptime: 5000,
    reconnectionDelayGrowFactor: 1.3,
    connectionTimeout: 4000,
    maxRetries: Infinity,
    maxEnqueuedMessages: Infinity,
    startClosed: false,
    debug: false
};
var $770a1d731c00536d$var$ReconnectingWebSocket = /** @class */ function() {
    function ReconnectingWebSocket(url, protocols, options) {
        var _this = this;
        if (options === void 0) options = {};
        this._listeners = {
            error: [],
            message: [],
            open: [],
            close: []
        };
        this._retryCount = -1;
        this._shouldReconnect = true;
        this._connectLock = false;
        this._binaryType = "blob";
        this._closeCalled = false;
        this._messageQueue = [];
        /**
         * An event listener to be called when the WebSocket connection's readyState changes to CLOSED
         */ this.onclose = null;
        /**
         * An event listener to be called when an error occurs
         */ this.onerror = null;
        /**
         * An event listener to be called when a message is received from the server
         */ this.onmessage = null;
        /**
         * An event listener to be called when the WebSocket connection's readyState changes to OPEN;
         * this indicates that the connection is ready to send and receive data
         */ this.onopen = null;
        this._handleOpen = function(event) {
            _this._debug("open event");
            var _a = _this._options.minUptime, minUptime = _a === void 0 ? $770a1d731c00536d$var$DEFAULT.minUptime : _a;
            clearTimeout(_this._connectTimeout);
            _this._uptimeTimeout = setTimeout(function() {
                return _this._acceptOpen();
            }, minUptime);
            _this._ws.binaryType = _this._binaryType;
            // send enqueued messages (messages sent before websocket open event)
            _this._messageQueue.forEach(function(message) {
                return _this._ws.send(message);
            });
            _this._messageQueue = [];
            if (_this.onopen) _this.onopen(event);
            _this._listeners.open.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
        };
        this._handleMessage = function(event) {
            _this._debug("message event");
            if (_this.onmessage) _this.onmessage(event);
            _this._listeners.message.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
        };
        this._handleError = function(event) {
            _this._debug("error event", event.message);
            _this._disconnect(undefined, event.message === "TIMEOUT" ? "timeout" : undefined);
            if (_this.onerror) _this.onerror(event);
            _this._debug("exec error listeners");
            _this._listeners.error.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
            _this._connect();
        };
        this._handleClose = function(event) {
            _this._debug("close event");
            _this._clearTimeouts();
            if (_this._shouldReconnect) _this._connect();
            if (_this.onclose) _this.onclose(event);
            _this._listeners.close.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
        };
        this._url = url;
        this._protocols = protocols;
        this._options = options;
        if (this._options.startClosed) this._shouldReconnect = false;
        this._connect();
    }
    Object.defineProperty(ReconnectingWebSocket, "CONNECTING", {
        get: function() {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket, "OPEN", {
        get: function() {
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket, "CLOSING", {
        get: function() {
            return 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket, "CLOSED", {
        get: function() {
            return 3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "CONNECTING", {
        get: function() {
            return ReconnectingWebSocket.CONNECTING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "OPEN", {
        get: function() {
            return ReconnectingWebSocket.OPEN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "CLOSING", {
        get: function() {
            return ReconnectingWebSocket.CLOSING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "CLOSED", {
        get: function() {
            return ReconnectingWebSocket.CLOSED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "binaryType", {
        get: function() {
            return this._ws ? this._ws.binaryType : this._binaryType;
        },
        set: function(value) {
            this._binaryType = value;
            if (this._ws) this._ws.binaryType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "retryCount", {
        /**
         * Returns the number or connection retries
         */ get: function() {
            return Math.max(this._retryCount, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "bufferedAmount", {
        /**
         * The number of bytes of data that have been queued using calls to send() but not yet
         * transmitted to the network. This value resets to zero once all queued data has been sent.
         * This value does not reset to zero when the connection is closed; if you keep calling send(),
         * this will continue to climb. Read only
         */ get: function() {
            var bytes = this._messageQueue.reduce(function(acc, message) {
                if (typeof message === "string") acc += message.length; // not byte size
                else if (message instanceof Blob) acc += message.size;
                else acc += message.byteLength;
                return acc;
            }, 0);
            return bytes + (this._ws ? this._ws.bufferedAmount : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "extensions", {
        /**
         * The extensions selected by the server. This is currently only the empty string or a list of
         * extensions as negotiated by the connection
         */ get: function() {
            return this._ws ? this._ws.extensions : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "protocol", {
        /**
         * A string indicating the name of the sub-protocol the server selected;
         * this will be one of the strings specified in the protocols parameter when creating the
         * WebSocket object
         */ get: function() {
            return this._ws ? this._ws.protocol : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "readyState", {
        /**
         * The current state of the connection; this is one of the Ready state constants
         */ get: function() {
            if (this._ws) return this._ws.readyState;
            return this._options.startClosed ? ReconnectingWebSocket.CLOSED : ReconnectingWebSocket.CONNECTING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "url", {
        /**
         * The URL as resolved by the constructor
         */ get: function() {
            return this._ws ? this._ws.url : "";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Closes the WebSocket connection or connection attempt, if any. If the connection is already
     * CLOSED, this method does nothing
     */ ReconnectingWebSocket.prototype.close = function(code, reason) {
        if (code === void 0) code = 1000;
        this._closeCalled = true;
        this._shouldReconnect = false;
        this._clearTimeouts();
        if (!this._ws) {
            this._debug("close enqueued: no ws instance");
            return;
        }
        if (this._ws.readyState === this.CLOSED) {
            this._debug("close: already closed");
            return;
        }
        this._ws.close(code, reason);
    };
    /**
     * Closes the WebSocket connection or connection attempt and connects again.
     * Resets retry counter;
     */ ReconnectingWebSocket.prototype.reconnect = function(code, reason) {
        this._shouldReconnect = true;
        this._closeCalled = false;
        this._retryCount = -1;
        if (!this._ws || this._ws.readyState === this.CLOSED) this._connect();
        else {
            this._disconnect(code, reason);
            this._connect();
        }
    };
    /**
     * Enqueue specified data to be transmitted to the server over the WebSocket connection
     */ ReconnectingWebSocket.prototype.send = function(data) {
        if (this._ws && this._ws.readyState === this.OPEN) {
            this._debug("send", data);
            this._ws.send(data);
        } else {
            var _a = this._options.maxEnqueuedMessages, maxEnqueuedMessages = _a === void 0 ? $770a1d731c00536d$var$DEFAULT.maxEnqueuedMessages : _a;
            if (this._messageQueue.length < maxEnqueuedMessages) {
                this._debug("enqueue", data);
                this._messageQueue.push(data);
            }
        }
    };
    /**
     * Register an event handler of a specific event type
     */ ReconnectingWebSocket.prototype.addEventListener = function(type, listener) {
        if (this._listeners[type]) // @ts-ignore
        this._listeners[type].push(listener);
    };
    ReconnectingWebSocket.prototype.dispatchEvent = function(event) {
        var e_1, _a;
        var listeners = this._listeners[event.type];
        if (listeners) try {
            for(var listeners_1 = $770a1d731c00536d$var$__values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()){
                var listener = listeners_1_1.value;
                this._callEventListener(event, listener);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return true;
    };
    /**
     * Removes an event listener
     */ ReconnectingWebSocket.prototype.removeEventListener = function(type, listener) {
        if (this._listeners[type]) // @ts-ignore
        this._listeners[type] = this._listeners[type].filter(function(l) {
            return l !== listener;
        });
    };
    ReconnectingWebSocket.prototype._debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this._options.debug) // not using spread because compiled version uses Symbols
        // tslint:disable-next-line
        console.log.apply(console, $770a1d731c00536d$var$__spread([
            "RWS>"
        ], args));
    };
    ReconnectingWebSocket.prototype._getNextDelay = function() {
        var _a = this._options, _b = _a.reconnectionDelayGrowFactor, reconnectionDelayGrowFactor = _b === void 0 ? $770a1d731c00536d$var$DEFAULT.reconnectionDelayGrowFactor : _b, _c = _a.minReconnectionDelay, minReconnectionDelay = _c === void 0 ? $770a1d731c00536d$var$DEFAULT.minReconnectionDelay : _c, _d = _a.maxReconnectionDelay, maxReconnectionDelay = _d === void 0 ? $770a1d731c00536d$var$DEFAULT.maxReconnectionDelay : _d;
        var delay = 0;
        if (this._retryCount > 0) {
            delay = minReconnectionDelay * Math.pow(reconnectionDelayGrowFactor, this._retryCount - 1);
            if (delay > maxReconnectionDelay) delay = maxReconnectionDelay;
        }
        this._debug("next delay", delay);
        return delay;
    };
    ReconnectingWebSocket.prototype._wait = function() {
        var _this = this;
        return new Promise(function(resolve) {
            setTimeout(resolve, _this._getNextDelay());
        });
    };
    ReconnectingWebSocket.prototype._getNextUrl = function(urlProvider) {
        if (typeof urlProvider === "string") return Promise.resolve(urlProvider);
        if (typeof urlProvider === "function") {
            var url = urlProvider();
            if (typeof url === "string") return Promise.resolve(url);
            if (!!url.then) return url;
        }
        throw Error("Invalid URL");
    };
    ReconnectingWebSocket.prototype._connect = function() {
        var _this = this;
        if (this._connectLock || !this._shouldReconnect) return;
        this._connectLock = true;
        var _a = this._options, _b = _a.maxRetries, maxRetries = _b === void 0 ? $770a1d731c00536d$var$DEFAULT.maxRetries : _b, _c = _a.connectionTimeout, connectionTimeout = _c === void 0 ? $770a1d731c00536d$var$DEFAULT.connectionTimeout : _c, _d = _a.WebSocket, WebSocket1 = _d === void 0 ? $770a1d731c00536d$var$getGlobalWebSocket() : _d;
        if (this._retryCount >= maxRetries) {
            this._debug("max retries reached", this._retryCount, ">=", maxRetries);
            return;
        }
        this._retryCount++;
        this._debug("connect", this._retryCount);
        this._removeListeners();
        if (!$770a1d731c00536d$var$isWebSocket(WebSocket1)) throw Error("No valid WebSocket class provided");
        this._wait().then(function() {
            return _this._getNextUrl(_this._url);
        }).then(function(url) {
            // close could be called before creating the ws
            if (_this._closeCalled) return;
            _this._debug("connect", {
                url: url,
                protocols: _this._protocols
            });
            _this._ws = _this._protocols ? new WebSocket1(url, _this._protocols) : new WebSocket1(url);
            _this._ws.binaryType = _this._binaryType;
            _this._connectLock = false;
            _this._addListeners();
            _this._connectTimeout = setTimeout(function() {
                return _this._handleTimeout();
            }, connectionTimeout);
        });
    };
    ReconnectingWebSocket.prototype._handleTimeout = function() {
        this._debug("timeout event");
        this._handleError(new $770a1d731c00536d$var$ErrorEvent(Error("TIMEOUT"), this));
    };
    ReconnectingWebSocket.prototype._disconnect = function(code, reason) {
        if (code === void 0) code = 1000;
        this._clearTimeouts();
        if (!this._ws) return;
        this._removeListeners();
        try {
            this._ws.close(code, reason);
            this._handleClose(new $770a1d731c00536d$var$CloseEvent(code, reason, this));
        } catch (error) {
        // ignore
        }
    };
    ReconnectingWebSocket.prototype._acceptOpen = function() {
        this._debug("accept open");
        this._retryCount = 0;
    };
    ReconnectingWebSocket.prototype._callEventListener = function(event, listener) {
        if ("handleEvent" in listener) // @ts-ignore
        listener.handleEvent(event);
        else // @ts-ignore
        listener(event);
    };
    ReconnectingWebSocket.prototype._removeListeners = function() {
        if (!this._ws) return;
        this._debug("removeListeners");
        this._ws.removeEventListener("open", this._handleOpen);
        this._ws.removeEventListener("close", this._handleClose);
        this._ws.removeEventListener("message", this._handleMessage);
        // @ts-ignore
        this._ws.removeEventListener("error", this._handleError);
    };
    ReconnectingWebSocket.prototype._addListeners = function() {
        if (!this._ws) return;
        this._debug("addListeners");
        this._ws.addEventListener("open", this._handleOpen);
        this._ws.addEventListener("close", this._handleClose);
        this._ws.addEventListener("message", this._handleMessage);
        // @ts-ignore
        this._ws.addEventListener("error", this._handleError);
    };
    ReconnectingWebSocket.prototype._clearTimeouts = function() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._uptimeTimeout);
    };
    return ReconnectingWebSocket;
}();
var $770a1d731c00536d$export$2e2bcd8739ae039 = $770a1d731c00536d$var$ReconnectingWebSocket;

});

parcelRegister("31cpC", function(module, exports) {
"use client";
"use strict";
let $232b17eb8113110b$var$_ = (t)=>t, $232b17eb8113110b$var$t, $232b17eb8113110b$var$t1, $232b17eb8113110b$var$t2, $232b17eb8113110b$var$t3, $232b17eb8113110b$var$t4, $232b17eb8113110b$var$t5, $232b17eb8113110b$var$t6, $232b17eb8113110b$var$t7, $232b17eb8113110b$var$t8, $232b17eb8113110b$var$t9, $232b17eb8113110b$var$t10, $232b17eb8113110b$var$t11, $232b17eb8113110b$var$t12, $232b17eb8113110b$var$t13, $232b17eb8113110b$var$t14, $232b17eb8113110b$var$t15;
var $232b17eb8113110b$var$Y = Object.create;
var $232b17eb8113110b$var$E = Object.defineProperty;
var $232b17eb8113110b$var$q = Object.getOwnPropertyDescriptor;
var $232b17eb8113110b$var$G = Object.getOwnPropertyNames;
var $232b17eb8113110b$var$K = Object.getPrototypeOf, $232b17eb8113110b$var$Z = Object.prototype.hasOwnProperty;
var $232b17eb8113110b$var$ee = (e, t)=>{
    for(var o in t)$232b17eb8113110b$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $232b17eb8113110b$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $232b17eb8113110b$var$G(t))!$232b17eb8113110b$var$Z.call(e, r) && r !== o && $232b17eb8113110b$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $232b17eb8113110b$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $232b17eb8113110b$var$W = (e, t, o)=>(o = e != null ? $232b17eb8113110b$var$Y($232b17eb8113110b$var$K(e)) : {}, $232b17eb8113110b$var$j(t || !e || !e.__esModule ? $232b17eb8113110b$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $232b17eb8113110b$var$te = (e)=>$232b17eb8113110b$var$j($232b17eb8113110b$var$E({}, "__esModule", {
        value: !0
    }), e);
var $232b17eb8113110b$var$Ve = {};
$232b17eb8113110b$var$ee($232b17eb8113110b$var$Ve, {
    CheckmarkIcon: ()=>$232b17eb8113110b$var$F,
    ErrorIcon: ()=>$232b17eb8113110b$var$w,
    LoaderIcon: ()=>$232b17eb8113110b$var$M,
    ToastBar: ()=>$232b17eb8113110b$var$$,
    ToastIcon: ()=>$232b17eb8113110b$var$U,
    Toaster: ()=>$232b17eb8113110b$var$J,
    default: ()=>$232b17eb8113110b$var$_e,
    resolveValue: ()=>$232b17eb8113110b$var$u,
    toast: ()=>$232b17eb8113110b$var$n,
    useToaster: ()=>$232b17eb8113110b$var$V,
    useToasterStore: ()=>$232b17eb8113110b$var$_1
});
module.exports = $232b17eb8113110b$var$te($232b17eb8113110b$var$Ve);
var $232b17eb8113110b$var$oe = (e)=>typeof e == "function", $232b17eb8113110b$var$u = (e, t)=>$232b17eb8113110b$var$oe(e) ? e(t) : e;
var $232b17eb8113110b$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $232b17eb8113110b$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $232b17eb8113110b$var$re = 20;
var $232b17eb8113110b$var$v = new Map, $232b17eb8113110b$var$se = 1e3, $232b17eb8113110b$var$X = (e)=>{
    if ($232b17eb8113110b$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $232b17eb8113110b$var$v.delete(e), $232b17eb8113110b$var$l({
            type: 4,
            toastId: e
        });
    }, $232b17eb8113110b$var$se);
    $232b17eb8113110b$var$v.set(e, t);
}, $232b17eb8113110b$var$ae = (e)=>{
    let t = $232b17eb8113110b$var$v.get(e);
    t && clearTimeout(t);
}, $232b17eb8113110b$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $232b17eb8113110b$var$re)
            };
        case 1:
            return t.toast.id && $232b17eb8113110b$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $232b17eb8113110b$var$H(e, {
                type: 1,
                toast: o
            }) : $232b17eb8113110b$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $232b17eb8113110b$var$X(s) : e.toasts.forEach((a)=>{
                $232b17eb8113110b$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $232b17eb8113110b$var$I = [], $232b17eb8113110b$var$D = {
    toasts: [],
    pausedAt: void 0
}, $232b17eb8113110b$var$l = (e)=>{
    $232b17eb8113110b$var$D = $232b17eb8113110b$var$H($232b17eb8113110b$var$D, e), $232b17eb8113110b$var$I.forEach((t)=>{
        t($232b17eb8113110b$var$D);
    });
}, $232b17eb8113110b$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $232b17eb8113110b$var$_1 = (e = {})=>{
    let [t, o] = (0, (parcelRequire("dgG1Y")).useState)($232b17eb8113110b$var$D);
    (0, (parcelRequire("dgG1Y")).useEffect)(()=>($232b17eb8113110b$var$I.push(o), ()=>{
            let r = $232b17eb8113110b$var$I.indexOf(o);
            r > -1 && $232b17eb8113110b$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $232b17eb8113110b$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $232b17eb8113110b$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $232b17eb8113110b$var$Q()
    }), $232b17eb8113110b$var$S = (e)=>(t, o)=>{
        let s = $232b17eb8113110b$var$ce(t, e, o);
        return $232b17eb8113110b$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $232b17eb8113110b$var$n = (e, t)=>$232b17eb8113110b$var$S("blank")(e, t);
$232b17eb8113110b$var$n.error = $232b17eb8113110b$var$S("error");
$232b17eb8113110b$var$n.success = $232b17eb8113110b$var$S("success");
$232b17eb8113110b$var$n.loading = $232b17eb8113110b$var$S("loading");
$232b17eb8113110b$var$n.custom = $232b17eb8113110b$var$S("custom");
$232b17eb8113110b$var$n.dismiss = (e)=>{
    $232b17eb8113110b$var$l({
        type: 3,
        toastId: e
    });
};
$232b17eb8113110b$var$n.remove = (e)=>$232b17eb8113110b$var$l({
        type: 4,
        toastId: e
    });
$232b17eb8113110b$var$n.promise = (e, t, o)=>{
    let s = $232b17eb8113110b$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($232b17eb8113110b$var$n.success($232b17eb8113110b$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $232b17eb8113110b$var$n.error($232b17eb8113110b$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $232b17eb8113110b$var$pe = (e, t)=>{
    $232b17eb8113110b$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $232b17eb8113110b$var$de = ()=>{
    $232b17eb8113110b$var$l({
        type: 5,
        time: Date.now()
    });
}, $232b17eb8113110b$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $232b17eb8113110b$var$_1(e);
    (0, (parcelRequire("dgG1Y")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $232b17eb8113110b$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$232b17eb8113110b$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("dgG1Y")).useCallback)(()=>{
        o && $232b17eb8113110b$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("dgG1Y")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $232b17eb8113110b$var$pe,
            startPause: $232b17eb8113110b$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $232b17eb8113110b$var$T = $232b17eb8113110b$var$W((parcelRequire("dgG1Y")));

var $i5144 = parcelRequire("i5144");

var $232b17eb8113110b$var$y = $232b17eb8113110b$var$W((parcelRequire("dgG1Y")));

var $i5144 = parcelRequire("i5144");

var $i5144 = parcelRequire("i5144");
var $232b17eb8113110b$var$me = $i5144.keyframes($232b17eb8113110b$var$t || ($232b17eb8113110b$var$t = $232b17eb8113110b$var$_`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`)), $232b17eb8113110b$var$ue = $i5144.keyframes($232b17eb8113110b$var$t1 || ($232b17eb8113110b$var$t1 = $232b17eb8113110b$var$_`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`)), $232b17eb8113110b$var$le = $i5144.keyframes($232b17eb8113110b$var$t2 || ($232b17eb8113110b$var$t2 = $232b17eb8113110b$var$_`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`)), $232b17eb8113110b$var$w = (0, $i5144.styled)("div")($232b17eb8113110b$var$t3 || ($232b17eb8113110b$var$t3 = $232b17eb8113110b$var$_`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${0};
  position: relative;
  transform: rotate(45deg);

  animation: ${0} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${0} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${0};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${0} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`), (e)=>e.primary || "#ff4b4b", $232b17eb8113110b$var$me, $232b17eb8113110b$var$ue, (e)=>e.secondary || "#fff", $232b17eb8113110b$var$le);

var $i5144 = parcelRequire("i5144");
var $232b17eb8113110b$var$Te = $i5144.keyframes($232b17eb8113110b$var$t4 || ($232b17eb8113110b$var$t4 = $232b17eb8113110b$var$_`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`)), $232b17eb8113110b$var$M = (0, $i5144.styled)("div")($232b17eb8113110b$var$t5 || ($232b17eb8113110b$var$t5 = $232b17eb8113110b$var$_`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${0};
  border-right-color: ${0};
  animation: ${0} 1s linear infinite;
`), (e)=>e.secondary || "#e0e0e0", (e)=>e.primary || "#616161", $232b17eb8113110b$var$Te);

var $i5144 = parcelRequire("i5144");
var $232b17eb8113110b$var$fe = $i5144.keyframes($232b17eb8113110b$var$t6 || ($232b17eb8113110b$var$t6 = $232b17eb8113110b$var$_`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`)), $232b17eb8113110b$var$ye = $i5144.keyframes($232b17eb8113110b$var$t7 || ($232b17eb8113110b$var$t7 = $232b17eb8113110b$var$_`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`)), $232b17eb8113110b$var$F = (0, $i5144.styled)("div")($232b17eb8113110b$var$t8 || ($232b17eb8113110b$var$t8 = $232b17eb8113110b$var$_`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${0};
  position: relative;
  transform: rotate(45deg);

  animation: ${0} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${0} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${0};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`), (e)=>e.primary || "#61d345", $232b17eb8113110b$var$fe, $232b17eb8113110b$var$ye, (e)=>e.secondary || "#fff");
var $232b17eb8113110b$var$ge = (0, $i5144.styled)("div")($232b17eb8113110b$var$t9 || ($232b17eb8113110b$var$t9 = $232b17eb8113110b$var$_`
  position: absolute;
`)), $232b17eb8113110b$var$he = (0, $i5144.styled)("div")($232b17eb8113110b$var$t10 || ($232b17eb8113110b$var$t10 = $232b17eb8113110b$var$_`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`)), $232b17eb8113110b$var$xe = $i5144.keyframes($232b17eb8113110b$var$t11 || ($232b17eb8113110b$var$t11 = $232b17eb8113110b$var$_`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`)), $232b17eb8113110b$var$be = (0, $i5144.styled)("div")($232b17eb8113110b$var$t12 || ($232b17eb8113110b$var$t12 = $232b17eb8113110b$var$_`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${0} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`), $232b17eb8113110b$var$xe), $232b17eb8113110b$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $232b17eb8113110b$var$y.createElement($232b17eb8113110b$var$be, null, t) : t : o === "blank" ? null : $232b17eb8113110b$var$y.createElement($232b17eb8113110b$var$he, null, $232b17eb8113110b$var$y.createElement($232b17eb8113110b$var$M, {
        ...s
    }), o !== "loading" && $232b17eb8113110b$var$y.createElement($232b17eb8113110b$var$ge, null, o === "error" ? $232b17eb8113110b$var$y.createElement($232b17eb8113110b$var$w, {
        ...s
    }) : $232b17eb8113110b$var$y.createElement($232b17eb8113110b$var$F, {
        ...s
    })));
};
var $232b17eb8113110b$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $232b17eb8113110b$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $232b17eb8113110b$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $232b17eb8113110b$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $232b17eb8113110b$var$Ee = (0, $i5144.styled)("div")($232b17eb8113110b$var$t13 || ($232b17eb8113110b$var$t13 = $232b17eb8113110b$var$_`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`)), $232b17eb8113110b$var$Re = (0, $i5144.styled)("div")($232b17eb8113110b$var$t14 || ($232b17eb8113110b$var$t14 = $232b17eb8113110b$var$_`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`)), $232b17eb8113110b$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $232b17eb8113110b$var$R() ? [
        $232b17eb8113110b$var$Pe,
        $232b17eb8113110b$var$Oe
    ] : [
        $232b17eb8113110b$var$Se(s),
        $232b17eb8113110b$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $i5144.keyframes)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $i5144.keyframes)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $232b17eb8113110b$var$$ = $232b17eb8113110b$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $232b17eb8113110b$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $232b17eb8113110b$var$T.createElement($232b17eb8113110b$var$U, {
        toast: e
    }), c = $232b17eb8113110b$var$T.createElement($232b17eb8113110b$var$Re, {
        ...e.ariaProps
    }, $232b17eb8113110b$var$u(e.message, e));
    return $232b17eb8113110b$var$T.createElement($232b17eb8113110b$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $232b17eb8113110b$var$T.createElement($232b17eb8113110b$var$T.Fragment, null, a, c));
});

var $i5144 = parcelRequire("i5144");

var $232b17eb8113110b$var$f = $232b17eb8113110b$var$W((parcelRequire("dgG1Y")));
(0, $i5144.setup)($232b17eb8113110b$var$f.createElement);
var $232b17eb8113110b$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $232b17eb8113110b$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $232b17eb8113110b$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $232b17eb8113110b$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $232b17eb8113110b$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $232b17eb8113110b$var$ke = $i5144.css($232b17eb8113110b$var$t15 || ($232b17eb8113110b$var$t15 = $232b17eb8113110b$var$_`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`)), $232b17eb8113110b$var$L = 16, $232b17eb8113110b$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $232b17eb8113110b$var$V(o);
    return $232b17eb8113110b$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $232b17eb8113110b$var$L,
            left: $232b17eb8113110b$var$L,
            right: $232b17eb8113110b$var$L,
            bottom: $232b17eb8113110b$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $232b17eb8113110b$var$De(g, z);
        return $232b17eb8113110b$var$f.createElement($232b17eb8113110b$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $232b17eb8113110b$var$ke : "",
            style: O
        }, p.type === "custom" ? $232b17eb8113110b$var$u(p.message, p) : r ? r(p) : $232b17eb8113110b$var$f.createElement($232b17eb8113110b$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $232b17eb8113110b$var$_e = $232b17eb8113110b$var$n;

});
parcelRegister("i5144", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $d299850eb4648906$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $d299850eb4648906$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "setup", function () { return $d299850eb4648906$export$de27182ff8187d6c; });
$parcel$export(module.exports, "styled", function () { return $d299850eb4648906$export$3817b7a54a07cec7; });
let $d299850eb4648906$var$e = {
    data: ""
}, $d299850eb4648906$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $d299850eb4648906$var$e, $d299850eb4648906$export$54aba348a7896325 = (e)=>{
    let r = $d299850eb4648906$var$t(e), l = r.data;
    return r.data = "", l;
}, $d299850eb4648906$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $d299850eb4648906$var$a = /\/\*[^]*?\*\/|  +/g, $d299850eb4648906$var$n = /\n+/g, $d299850eb4648906$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $d299850eb4648906$var$o(c, n) : n + "{" + $d299850eb4648906$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $d299850eb4648906$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $d299850eb4648906$var$o.p ? $d299850eb4648906$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $d299850eb4648906$var$c = {}, $d299850eb4648906$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $d299850eb4648906$var$s(e[r]);
        return t;
    }
    return e;
}, $d299850eb4648906$var$i = (e, t, r, i, p)=>{
    let u = $d299850eb4648906$var$s(e), d = $d299850eb4648906$var$c[u] || ($d299850eb4648906$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$d299850eb4648906$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $d299850eb4648906$var$l.exec(e.replace($d299850eb4648906$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($d299850eb4648906$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($d299850eb4648906$var$n, " ").trim();
            return o[0];
        })(e);
        $d299850eb4648906$var$c[d] = $d299850eb4648906$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $d299850eb4648906$var$c.g ? $d299850eb4648906$var$c.g : null;
    return r && ($d299850eb4648906$var$c.g = $d299850eb4648906$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($d299850eb4648906$var$c[d], t, i, f), d;
}, $d299850eb4648906$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $d299850eb4648906$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $d299850eb4648906$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $d299850eb4648906$var$i(l.unshift ? l.raw ? $d299850eb4648906$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $d299850eb4648906$var$t(r.target), r.g, r.o, r.k);
}
let $d299850eb4648906$var$d, $d299850eb4648906$var$f, $d299850eb4648906$var$g, $d299850eb4648906$export$442f1a04865e4790 = $d299850eb4648906$export$dbf350e5966cf602.bind({
    g: 1
}), $d299850eb4648906$export$d25ddfdf17c3ad3e = $d299850eb4648906$export$dbf350e5966cf602.bind({
    k: 1
});
function $d299850eb4648906$export$de27182ff8187d6c(e, t, r, l) {
    $d299850eb4648906$var$o.p = t, $d299850eb4648906$var$d = e, $d299850eb4648906$var$f = r, $d299850eb4648906$var$g = l;
}
function $d299850eb4648906$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $d299850eb4648906$var$f && $d299850eb4648906$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $d299850eb4648906$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $d299850eb4648906$var$g && i[0] && $d299850eb4648906$var$g(c), $d299850eb4648906$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});




parcelRegister("fD19N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b60b65470893a1b9$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $en0cX = parcelRequire("en0cX");

var $4m0VC = parcelRequire("4m0VC");
var $7efta = parcelRequire("7efta");
var $hEZLG = parcelRequire("hEZLG");
var $ekoiq = parcelRequire("ekoiq");
var $gJFkA = parcelRequire("gJFkA");
var $cWJc2 = parcelRequire("cWJc2");
var $6wnIC = parcelRequire("6wnIC");
var $lqAG1 = parcelRequire("lqAG1");
var $5MowX = parcelRequire("5MowX");
var $f2CoU = parcelRequire("f2CoU");
var $1u2lJ = parcelRequire("1u2lJ");
var $12a5h = parcelRequire("12a5h");
var $hMt12 = parcelRequire("hMt12");
var $k0kWg = parcelRequire("k0kWg");
var $1QHfa = parcelRequire("1QHfa");

var $h2Xtr = parcelRequire("h2Xtr");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $04Fi6 = parcelRequire("04Fi6");

var $5t9Vu = parcelRequire("5t9Vu");

var $6FpSS = parcelRequire("6FpSS");


var $hgbGA = parcelRequire("hgbGA");

var $8wOzK = parcelRequire("8wOzK");

var $gElWY = parcelRequire("gElWY");

var $T5LKB = parcelRequire("T5LKB");



var $cLr7D = parcelRequire("cLr7D");

var $cxFzf = parcelRequire("cxFzf");

var $jYTVM = parcelRequire("jYTVM");

var $d9ASo = parcelRequire("d9ASo");

var $jFtgc = parcelRequire("jFtgc");

var $7RXGR = parcelRequire("7RXGR");

var $fl052 = parcelRequire("fl052");

var $1uo3W = parcelRequire("1uo3W");

var $lBH8Z = parcelRequire("lBH8Z");
var $8o3ta = parcelRequire("8o3ta");
var $hlbJR = parcelRequire("hlbJR");
(0, (/*@__PURE__*/$parcel$interopDefault($jFtgc))).vfs = (0, (/*@__PURE__*/$parcel$interopDefault($7RXGR))).pdfMake.vfs;
const $b60b65470893a1b9$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(6)
        },
        divider: {
            margin: theme.spacing(1, 0)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        add: {
            alignContent: "right"
        }
    }));
const $b60b65470893a1b9$var$Tox = (props)=>{
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $b60b65470893a1b9$var$useStyles();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const [showModal, setShowModal] = (0, $dgG1Y.useState)(false);
    const [toxes, setToxes] = (0, $dgG1Y.useState)([]);
    const [editTox, setEditTox] = (0, $dgG1Y.useState)(null); //for payer edit button
    const [rerender, setReRender] = (0, $dgG1Y.useState)(false);
    const { adminUsers: adminUsers, getAdminUsers: getAdminUsers, setSelectedButton: setSelectedButton, selectedButton: selectedButton, setFilterText: setFilterText, filterText: filterText, handleSetArsUser: handleSetArsUser, arsUser: arsUser, filterByARS: filterByARS } = (0, $gElWY.useGetFilters)(sendRequest, auth, showModal, false, null, rerender, null, setReRender);
    const [selectedUser, setSelectedUser] = (0, $dgG1Y.useState)();
    const [messageCount, setMessageCount] = (0, $dgG1Y.useState)(1); //how many previous messages to pull
    const [toxType, setToxType] = (0, $dgG1Y.useState)("ALL");
    const [toxResultFilter, setToxResultFilter] = (0, $dgG1Y.useState)("ALL");
    const [isStatusModalOpen, setIsStatusModalOpen] = (0, $dgG1Y.useState)(false);
    const [selectedTox, setSelectedTox] = (0, $dgG1Y.useState)(null);
    const [contextMenu, setContextMenu] = (0, $dgG1Y.useState)(null);
    const handleContextMenu = (event)=>{
        event.preventDefault();
        setContextMenu(contextMenu === null ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
        } : null);
    };
    const handleClose = ()=>{
        setContextMenu(null);
    };
    const [orderModalOpen, setOrderModalOpen] = (0, $dgG1Y.useState)("");
    (0, $dgG1Y.useEffect)(()=>{
        if (props.selectedUser && adminUsers) {
            setSelectedButton(2); //set to all users
            const user = adminUsers.find((users)=>users._id === props.selectedUser);
            if (user) {
                const myUser = {
                    alt: user.firstName + " " + user.lastName,
                    title: user.firstName + " " + user.lastName,
                    subtitle: user.phoneNumber || "No Number Entered",
                    id: user._id,
                    unread: "0",
                    timeZone: user.timeZone || "UTC"
                };
                setSelectedUser(myUser);
            }
        }
    }, [
        adminUsers,
        props.selectedUser,
        setSelectedButton
    ]);
    const getToxes = (0, $dgG1Y.useCallback)(async ()=>{
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/gettoxes", "POST", JSON.stringify({
                user: selectedUser || null,
                count: messageCount
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData && !responseData.message) {
                let toxes = responseData;
                if (toxResultFilter !== "ALL") toxes = toxes.filter((tox)=>tox.toxResult === toxResultFilter);
                if (toxType !== "ALL") toxes = toxes.filter((tox)=>tox.toxType === toxType);
                // Sort toxes by date in descending order
                if (toxes.length > 0) {
                    toxes.sort((a, b)=>a.toxDate < b.toxDate ? 1 : -1);
                    setToxes(toxes);
                } else setToxes([]);
            }
        } catch (err) {
            console.log(err);
        }
    }, [
        sendRequest,
        auth.token,
        selectedUser,
        messageCount,
        toxType,
        toxResultFilter
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        //get users for tenant
        getToxes();
    }, [
        sendRequest,
        getToxes,
        auth.token,
        selectedUser,
        messageCount,
        toxType,
        toxResultFilter
    ]);
    const addTox = (event)=>{
        event.preventDefault();
        setEditTox(null);
        setShowModal(true);
    };
    const showEditModal = (event)=>{
        setEditTox(event.currentTarget.value);
        setShowModal(true);
    };
    const createPDF = async (event)=>{
        if (!toxes) alert("Please select a user with data to export");
        else {
            let documentData = null;
            const data = [];
            data.push({
                text: "You Are Accountable Toxicology Results",
                style: "header",
                alignment: "center"
            });
            data.push({
                text: "https://youareaccountable.com",
                style: "subheader",
                alignment: "center"
            });
            data.push({
                text: "646-450-7641",
                style: "subheader",
                alignment: "center"
            });
            data.push({
                image: "data:image/png;base64,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",
                alignment: "center"
            });
            const table = {
                style: "tableExample",
                table: {
                    body: [
                        [
                            "Member Name",
                            "Date",
                            "Result",
                            "Type",
                            "Notes"
                        ]
                    ]
                }
            };
            toxes.map(async (tox)=>{
                let toxValue = "";
                switch(tox.toxType){
                    case 1:
                        toxValue = "Alcohol";
                        break;
                    case 2:
                        toxValue = "10 Panel";
                        break;
                    case 3:
                        toxValue = "12 Panel";
                        break;
                    case 4:
                        toxValue = "14 Panel";
                        break;
                    case 5:
                        toxValue = "Lab Confirmation";
                        break;
                    case 6:
                        toxValue = "Breathalyzer";
                        break;
                    case 7:
                        toxValue = "Medication Monitoring";
                        break;
                }
                table.table.body.push([
                    selectedUser ? selectedUser.title : auth.tenant,
                    new Date(tox.toxDate).toLocaleString(),
                    tox.toxResult,
                    toxValue,
                    tox.Notes
                ]);
            });
            data.push(table);
            documentData = {
                content: data,
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [
                            0,
                            0,
                            0,
                            10
                        ]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [
                            0,
                            10,
                            0,
                            5
                        ]
                    },
                    tableExample: {
                        margin: [
                            0,
                            5,
                            0,
                            15
                        ]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: "black"
                    }
                }
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($jFtgc))).createPdf(documentData).download("YouAreAccountableToxExport.pdf");
        }
    };
    const deleteTox = async (event)=>{
        event.preventDefault();
        const target = event.currentTarget.value; //current target gets lost on async.
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/deletetox", "POST", JSON.stringify({
                toxid: event.currentTarget.value
            }), {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData.valid) setToxes(toxes.filter((tox)=>tox._id !== target)); //remove deleted object
        } catch (err) {}
    };
    const handleChange = (event)=>{
        const target = event.target.value;
        setFilterText(target);
        if (target.length > 2) getAdminUsers(target);
        else if (target.length < (filterText && filterText.length)) getAdminUsers(target);
    };
    const saveSelectedUser = (event)=>{
        setSelectedUser(event);
        setMessageCount(1);
    };
    const getMoreResults = (event)=>{
        setMessageCount(messageCount + 1);
    };
    const handleFilterByType = async (event)=>{
        const { value: value } = event.target;
        setToxType(value);
    };
    const handleToxResultFilter = async (event)=>{
        const { value: value } = event.target;
        setToxResultFilter(value);
    };
    const handleStatusClick = (tox)=>{
        setSelectedTox(tox);
        setIsStatusModalOpen(true);
    };
    const handleReviewLabTest = async (toxId, status, testResult, reviewNotes)=>{
        const responseData = await fetch("https://apiv2.youareaccountable.com/api/tests/review-test", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            },
            body: JSON.stringify({
                toxId: toxId,
                status: status,
                testResult: testResult,
                reviewNotes: reviewNotes
            })
        });
        const data = await responseData.json();
        // Set toxes with the new status
        setToxes(toxes.map((tox)=>tox._id === toxId ? {
                ...tox,
                status: data.status
            } : tox));
    };
    const formattedNotes = (notes)=>{
        return notes.split("\n").map((note)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)("span", {
                children: [
                    note,
                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                ]
            }, note));
    };
    const getTimezoneAbbreviation = (timeZone)=>{
        const date = new Date();
        const options = {
            timeZoneName: "short",
            timeZone: timeZone
        };
        // Get timezone abbreviation by parsing it from the formatted date string
        const timeZoneString = date.toLocaleString("en-US", options);
        const abbreviation = timeZoneString.split(" ").pop();
        return abbreviation;
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Tox",
                alert: error,
                clearError: clearError
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1uo3W.default), {
                open: orderModalOpen,
                clear: ()=>setOrderModalOpen("")
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8o3ta.default), {
                keepMounted: true,
                open: contextMenu !== null,
                onClose: handleClose,
                anchorReference: "anchorPosition",
                anchorPosition: contextMenu !== null ? {
                    top: contextMenu.mouseY,
                    left: contextMenu.mouseX
                } : undefined,
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                    onClick: ()=>{
                        setOrderModalOpen(selectedUser.id);
                        handleClose();
                    },
                    children: "View Orders"
                })
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                className: classes.textField,
                label: "Filter By Last Name",
                name: "filter",
                onChange: handleChange,
                variant: "outlined"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fl052.default), {
                open: isStatusModalOpen,
                onClose: ()=>setIsStatusModalOpen(false),
                tox: selectedTox,
                onApprove: (testResult, reviewNotes)=>{
                    handleReviewLabTest(selectedTox._id, "Accepted", testResult, reviewNotes);
                    setIsStatusModalOpen(false);
                },
                onReject: (reviewNotes)=>{
                    handleReviewLabTest(selectedTox._id, "Rejected", null, reviewNotes);
                    setIsStatusModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                container: true,
                spacing: 4,
                children: [
                    (auth.accountableAdmin || auth.program || auth.programProvider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $5t9Vu.default), {
                        open: showModal,
                        close: setShowModal,
                        userId: selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id,
                        clientTimeZone: selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.timeZone,
                        onAddTox: getToxes,
                        getProgramUsers: selectedButton === 7 && auth.accountableAdmin
                    }),
                    (auth.accountableAdmin || auth.provider || auth.programProvider || auth.program) && !props.selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        item: true,
                        lg: 3,
                        sm: 12,
                        xl: 3,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                                children: [
                                    (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $T5LKB.default), {
                                                selectedButton: selectedButton,
                                                setSelectedButton: setSelectedButton,
                                                authContext: auth
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                variant: "h4",
                                                color: "primary",
                                                children: "Members"
                                            }),
                                            auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $d9ASo.default), {
                                                auth: auth,
                                                arsUser: arsUser,
                                                handleSetArsUser: handleSetArsUser,
                                                filterByARS: filterByARS
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $8wOzK.ChatList), {
                                        onClick: saveSelectedUser,
                                        className: "chat-list",
                                        dataSource: adminUsers.map((user)=>{
                                            return {
                                                avatar: (0, (/*@__PURE__*/$parcel$interopDefault($jYTVM))),
                                                alt: user.firstName + " " + user.lastName,
                                                title: user.firstName + " " + user.lastName,
                                                subtitle: user.phoneNumber || "No Number Entered",
                                                meds: user.medications,
                                                harmReductionNotes: user.harmReductionNotes,
                                                id: user._id,
                                                unread: "0",
                                                timeZone: user.timeZone
                                            };
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        item: true,
                        lg: props.selectedUser ? 12 : 8,
                        sm: 12,
                        xl: props.selectedUser ? 12 : 8,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7efta.default), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hEZLG.default), {
                                children: [
                                    (auth.accountableAdmin || auth.provider) && !selectedUser && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        gutterBottom: true,
                                        className: classes.title,
                                        color: "textSecondary",
                                        variant: "h3",
                                        children: "Please Select a User"
                                    }),
                                    (selectedUser || !auth.accountableAdmin && !auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        gutterBottom: true,
                                        className: classes.title,
                                        color: "textSecondary",
                                        variant: "h3",
                                        children: [
                                            selectedUser ? selectedUser.title : auth.tenant,
                                            "'s Toxicology Results"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        variant: "h6",
                                        gutterBottom: true,
                                        children: [
                                            "Toxicologies act as a safety measure for you and your loved ones. It reduces your families/support systems worries about needing to monitor you and allows you to not feel overwhelmed in your own home. It allows you to work on communication and growing along your path of recovery together. Toxicologies also serve as a way to see your progress - you will be able to see how far you have come and it is a testament to all of the hard work that you have been doing.",
                                            " "
                                        ]
                                    }),
                                    selectedUser && (selectedUser.meds || selectedUser.harmReductionNotes) && auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                    selectedUser && selectedUser.meds && selectedUser.meds.length > 0 && auth.accountableAdmin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        variant: "h4",
                                        gutterBottom: true,
                                        children: [
                                            "Current Medications: ",
                                            selectedUser.meds.join(", ")
                                        ]
                                    }),
                                    selectedUser && auth.accountableAdmin && selectedUser.harmReductionNotes && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        variant: "h4",
                                        gutterBottom: true,
                                        children: [
                                            "Harm Reduction Parameters: ",
                                            selectedUser.harmReductionNotes
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                        container: true,
                                        justify: "flex-end",
                                        children: [
                                            (auth.accountableAdmin || auth.programProvider || auth.program) && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                color: "secondary",
                                                onClick: addTox,
                                                children: [
                                                    "Add Tox\xa0\xa0",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04Fi6))), {
                                                        color: "secondary",
                                                        fontSize: "small"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                onClick: createPDF,
                                                variant: "contained",
                                                color: "secondary",
                                                children: "Download Export"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                        container: true,
                                        justify: "center",
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                            color: "primary",
                                            onClick: getMoreResults,
                                            variant: "contained",
                                            children: [
                                                "See Prior Results\xa0\xa0",
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cxFzf))), {
                                                    color: "secondary",
                                                    fontSize: "small"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                        container: true,
                                        justifyContent: "space-evenly",
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                                    className: classes.formControl,
                                                    children: [
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                                            id: "case-label",
                                                            children: "Filter by Tox Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lqAG1.default), {
                                                            labelId: "case-label",
                                                            id: "case-select",
                                                            value: toxType || "ALL",
                                                            onChange: handleFilterByType,
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: "ALL",
                                                                    children: "Show All"
                                                                }, "ALL"),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: 2,
                                                                    children: "10 Panel"
                                                                }, 2),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: 3,
                                                                    children: "12 Panel"
                                                                }, 3),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: 4,
                                                                    children: "14 Panel"
                                                                }, 4),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: 5,
                                                                    children: "Lab Confirmation"
                                                                }, 5),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: 6,
                                                                    children: "Breathalyzer"
                                                                }, 6),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: 7,
                                                                    children: "Medication Monitoring"
                                                                }, 7)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $ekoiq.default), {
                                                    className: classes.formControl,
                                                    children: [
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cWJc2.default), {
                                                            id: "case-label",
                                                            children: "Filter by Tox Result"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lqAG1.default), {
                                                            labelId: "case-label",
                                                            id: "case-select",
                                                            value: toxResultFilter || "ALL",
                                                            onChange: handleToxResultFilter,
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: "ALL",
                                                                    children: "Show All"
                                                                }, "ALL"),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: "Positive",
                                                                    children: "Positive"
                                                                }, 2),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: "Missed",
                                                                    children: "Missed"
                                                                }, 3),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: "Update",
                                                                    children: "Update"
                                                                }, 4),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                                    value: "Negative",
                                                                    children: "Negative"
                                                                }, 5)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $12a5h.default), {
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $5MowX.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hMt12.default), {
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                        children: [
                                                            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Last Name"
                                                            }),
                                                            (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "First Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1u2lJ.default), {
                                                                children: [
                                                                    "Tox Date (",
                                                                    getTimezoneAbbreviation(selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.timeZone),
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Tox Result"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Status"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Tox Type"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "DNA Confirmation"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Kit"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Notes"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Report"
                                                            }),
                                                            auth.accountableAdmin && false,
                                                            (auth.accountableAdmin || auth.program || auth.programProvider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: "Delete"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f2CoU.default), {
                                                    children: ((auth.accountableAdmin || auth.provider) && selectedUser || !auth.accountableAdmin && !auth.provider) && toxes && toxes.map((tox)=>{
                                                        let toxValue = "";
                                                        switch(tox.toxType){
                                                            case 1:
                                                                toxValue = "Alcohol";
                                                                break;
                                                            case 2:
                                                                toxValue = "10 Panel";
                                                                break;
                                                            case 3:
                                                                toxValue = "12 Panel";
                                                                break;
                                                            case 4:
                                                                toxValue = "14 Panel";
                                                                break;
                                                            case 5:
                                                                toxValue = "Lab Confirmation";
                                                                break;
                                                            case 6:
                                                                toxValue = "Breathalyzer";
                                                                break;
                                                        }
                                                        let dnaConfirmation = "Not Set";
                                                        if (tox.dnaConfirmation) switch(tox.dnaConfirmation){
                                                            case "1":
                                                                dnaConfirmation = "Not Applicable";
                                                                break;
                                                            case "2":
                                                                dnaConfirmation = "Pass";
                                                                break;
                                                            case "3":
                                                                dnaConfirmation = "Indeterminate";
                                                                break;
                                                            case "4":
                                                                dnaConfirmation = "Fail";
                                                                break;
                                                        }
                                                        return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                            onContextMenu: (event)=>handleContextMenu(event),
                                                            children: [
                                                                (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.User.lastName
                                                                }),
                                                                (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.User.firstName
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($b60b65470893a1b9$var$FormattedDate, {
                                                                        date: tox.toxDate,
                                                                        timeZone: selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.timeZone
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.toxResult
                                                                }),
                                                                (auth.accountableAdmin || auth.provider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    onClick: ()=>{
                                                                        if (tox.videoKey) handleStatusClick(tox);
                                                                    },
                                                                    style: {
                                                                        cursor: tox.videoKey ? "pointer" : "default",
                                                                        color: tox.videoKey ? "blue" : "inherit",
                                                                        textDecoration: tox.videoKey ? "underline" : "none"
                                                                    },
                                                                    children: tox.status
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: toxValue
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: dnaConfirmation
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: tox.kit
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hlbJR.default), {
                                                                        title: formattedNotes(tox.Notes) || "",
                                                                        arrow: true,
                                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
                                                                            sx: {
                                                                                width: 250,
                                                                                display: "-webkit-box",
                                                                                WebkitLineClamp: 10,
                                                                                WebkitBoxOrient: "vertical",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                                                children: formattedNotes(tox.Notes)
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                                        variant: "contained",
                                                                        disabled: !tox.report,
                                                                        onClick: ()=>{
                                                                            window.open(tox.report, "_blank");
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cLr7D))), {})
                                                                    })
                                                                }),
                                                                auth.accountableAdmin && false,
                                                                (auth.accountableAdmin || auth.program || auth.programProvider) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                                        variant: "contained",
                                                                        color: "secondary",
                                                                        value: tox._id,
                                                                        onClick: deleteTox,
                                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6FpSS))), {})
                                                                    }, tox._id)
                                                                })
                                                            ]
                                                        }, tox._id);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $b60b65470893a1b9$var$FormattedDate = ({ date: date, timeZone: timeZone = "EST" })=>{
    let timezoneToUse = timeZone || "EST";
    if (!date) return null;
    const dateObj = new Date(date);
    // Check if it's midnight in UTC
    if (dateObj.getUTCHours() === 0 && dateObj.getUTCMinutes() === 0 && dateObj.getUTCSeconds() === 0 && dateObj.getUTCMilliseconds() === 0) timezoneToUse = "UTC";
    const month = dateObj.toLocaleString("en-US", {
        month: "numeric",
        timeZone: timezoneToUse
    });
    const day = dateObj.toLocaleString("en-US", {
        day: "numeric",
        timeZone: timezoneToUse
    });
    const year = dateObj.toLocaleString("en-US", {
        year: "numeric",
        timeZone: timezoneToUse
    });
    const [hour, ampm] = dateObj.toLocaleString("en-US", {
        hour: "numeric",
        timeZone: timezoneToUse
    }).split(" ");
    let minute = dateObj.toLocaleString("en-US", {
        minute: "numeric",
        timeZone: timezoneToUse
    });
    if (minute.length === 1) minute = `0${minute}`;
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                children: `${month}/${day}/${year}`
            }),
            timezoneToUse !== "UTC" && /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                style: {
                    fontSize: "12px",
                    color: "grey"
                },
                children: `${hour}:${minute} ${ampm}`
            })
        ]
    });
};
var $b60b65470893a1b9$export$2e2bcd8739ae039 = $b60b65470893a1b9$var$Tox;

});
parcelRegister("fl052", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74379fa66a41d1d$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $lBH8Z = parcelRequire("lBH8Z");
var $iJ8f3 = parcelRequire("iJ8f3");
var $7cH5t = parcelRequire("7cH5t");
var $kDVit = parcelRequire("kDVit");
var $Rego2 = parcelRequire("Rego2");
var $gg1yl = parcelRequire("gg1yl");
var $4wnpT = parcelRequire("4wnpT");
var $kMmDg = parcelRequire("kMmDg");
var $6xSIW = parcelRequire("6xSIW");
var $kngbJ = parcelRequire("kngbJ");

var $iuDcE = parcelRequire("iuDcE");
const $c74379fa66a41d1d$var$VideoTestReviewModal = ({ open: open, onClose: onClose, tox: tox, onApprove: onApprove, onReject: onReject })=>{
    const theme = (0, $kngbJ.default)();
    const isDesktop = (0, $6xSIW.default)(theme.breakpoints.up("md"));
    const [testResult, setTestResult] = (0, $dgG1Y.useState)(null);
    const [reviewNotes, setReviewNotes] = (0, $dgG1Y.useState)("");
    const [isReviewed, setIsReviewed] = (0, $dgG1Y.useState)(false);
    // Clear state and check if tox is already reviewed when modal is opened
    (0, $dgG1Y.useEffect)(()=>{
        if (open) {
            setTestResult((tox === null || tox === void 0 ? void 0 : tox.testResult) || null);
            setReviewNotes((tox === null || tox === void 0 ? void 0 : tox.reviewNotes) || "");
            setIsReviewed(Boolean((tox === null || tox === void 0 ? void 0 : tox.testResult) || (tox === null || tox === void 0 ? void 0 : tox.reviewNotes)));
        }
    }, [
        open,
        tox
    ]);
    const handleApprove = ()=>{
        if ((tox === null || tox === void 0 ? void 0 : tox.toxType) === 2) {
            if (testResult) onApprove(testResult, reviewNotes);
        } else onApprove(undefined, reviewNotes);
    };
    const handleReject = ()=>{
        onReject(reviewNotes);
    };
    const isActionDisabled = isReviewed || (tox === null || tox === void 0 ? void 0 : tox.toxType) === 2 && (!testResult || !reviewNotes.trim());
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kDVit.default), {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
            sx: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                maxWidth: isDesktop ? 900 : 500,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                maxHeight: "90vh",
                height: "90vh",
                display: "flex",
                flexDirection: "column"
            },
            children: isDesktop ? /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$DesktopLayout, {
                tox: tox,
                onApprove: handleApprove,
                onReject: handleReject,
                testResult: testResult,
                setTestResult: setTestResult,
                reviewNotes: reviewNotes,
                setReviewNotes: setReviewNotes,
                isActionDisabled: isActionDisabled,
                isReviewed: isReviewed
            }) : /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$MobileLayout, {
                tox: tox,
                onApprove: handleApprove,
                onReject: handleReject,
                testResult: testResult,
                setTestResult: setTestResult,
                reviewNotes: reviewNotes,
                setReviewNotes: setReviewNotes,
                isActionDisabled: isActionDisabled,
                isReviewed: isReviewed
            })
        })
    });
};
const $c74379fa66a41d1d$var$DesktopLayout = ({ tox: tox, onApprove: onApprove, onReject: onReject, testResult: testResult, setTestResult: setTestResult, reviewNotes: reviewNotes, setReviewNotes: setReviewNotes, isActionDisabled: isActionDisabled, isReviewed: isReviewed })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
        sx: {
            display: "flex",
            flexDirection: "row",
            gap: 2,
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
                sx: {
                    width: "60%",
                    position: "relative",
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)("video", {
                    controls: true,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        maxHeight: "100%"
                    },
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)("source", {
                        src: tox === null || tox === void 0 ? void 0 : tox.videoKey,
                        type: "video/mp4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
                sx: {
                    width: "40%",
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
                        sx: {
                            flexGrow: 1,
                            overflowY: "auto",
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                                variant: "h6",
                                component: "h2",
                                children: "Notes:"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                                children: tox === null || tox === void 0 ? void 0 : tox.Notes.split("\n").map((note, index)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)("span", {
                                        children: [
                                            note,
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    (tox === null || tox === void 0 ? void 0 : tox.toxType) === 2 && /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$TestResultSelection, {
                        testResult: testResult,
                        setTestResult: setTestResult,
                        disabled: isReviewed
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$ReviewNotesInput, {
                        reviewNotes: reviewNotes,
                        setReviewNotes: setReviewNotes,
                        disabled: isReviewed,
                        required: (tox === null || tox === void 0 ? void 0 : tox.toxType) === 2
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$ButtonGroup, {
                        onApprove: onApprove,
                        onReject: onReject,
                        isDisabled: isActionDisabled
                    })
                ]
            })
        ]
    });
const $c74379fa66a41d1d$var$MobileLayout = ({ tox: tox, onApprove: onApprove, onReject: onReject, testResult: testResult, setTestResult: setTestResult, reviewNotes: reviewNotes, setReviewNotes: setReviewNotes, isActionDisabled: isActionDisabled, isReviewed: isReviewed })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
        sx: {
            display: "flex",
            flexDirection: "column",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
                sx: {
                    position: "relative",
                    flexGrow: 1,
                    minHeight: 0
                },
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)("video", {
                    controls: true,
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    },
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)("source", {
                        src: tox === null || tox === void 0 ? void 0 : tox.videoKey,
                        type: "video/mp4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
                sx: {
                    flexShrink: 0,
                    overflowY: "auto",
                    maxHeight: "40%"
                },
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                        variant: "h6",
                        component: "h2",
                        children: "Notes:"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                        sx: {
                            mb: 2
                        },
                        children: tox === null || tox === void 0 ? void 0 : tox.Notes.split("\n").map((note, index)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)("span", {
                                children: [
                                    note,
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {})
                                ]
                            }, index))
                    }),
                    (tox === null || tox === void 0 ? void 0 : tox.toxType) === 2 && /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$TestResultSelection, {
                        testResult: testResult,
                        setTestResult: setTestResult,
                        disabled: isReviewed
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$ReviewNotesInput, {
                        reviewNotes: reviewNotes,
                        setReviewNotes: setReviewNotes,
                        disabled: isReviewed,
                        required: (tox === null || tox === void 0 ? void 0 : tox.toxType) === 2
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)($c74379fa66a41d1d$var$ButtonGroup, {
                        onApprove: onApprove,
                        onReject: onReject,
                        isDisabled: isActionDisabled
                    })
                ]
            })
        ]
    });
const $c74379fa66a41d1d$var$TestResultSelection = ({ testResult: testResult, setTestResult: setTestResult, disabled: disabled })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
        sx: {
            mb: 2
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                variant: "subtitle1",
                children: "Instant Test Result:"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gg1yl.default), {
                row: true,
                value: testResult,
                onChange: (e)=>setTestResult(e.target.value),
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7cH5t.default), {
                        value: "Positive",
                        control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $Rego2.default), {
                            disabled: disabled
                        }),
                        label: "Positive"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7cH5t.default), {
                        value: "Negative",
                        control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $Rego2.default), {
                            disabled: disabled
                        }),
                        label: "Negative"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7cH5t.default), {
                        value: "N/A",
                        control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $Rego2.default), {
                            disabled: disabled
                        }),
                        label: "N/A"
                    })
                ]
            })
        ]
    });
const $c74379fa66a41d1d$var$ReviewNotesInput = ({ reviewNotes: reviewNotes, setReviewNotes: setReviewNotes, disabled: disabled, required: required })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
        sx: {
            mb: 2
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                variant: "subtitle1",
                children: "Review Notes:"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4wnpT.default), {
                multiline: true,
                rows: 3,
                fullWidth: true,
                value: reviewNotes,
                onChange: (e)=>setReviewNotes(e.target.value),
                placeholder: "Enter additional review notes here...",
                disabled: disabled,
                required: required,
                error: required && !reviewNotes.trim(),
                helperText: required && !reviewNotes.trim() ? "Review notes are required" : ""
            })
        ]
    });
const $c74379fa66a41d1d$var$ButtonGroup = ({ onApprove: onApprove, onReject: onReject, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                onClick: onReject,
                variant: "contained",
                fullWidth: true,
                disabled: isDisabled,
                sx: {
                    backgroundColor: (0, $iuDcE.default).error.main,
                    color: (0, $iuDcE.default).error.contrastText
                },
                children: "Reject"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iJ8f3.default), {
                onClick: onApprove,
                fullWidth: true,
                variant: "contained",
                disabled: isDisabled,
                children: "Approve"
            })
        ]
    });
var $c74379fa66a41d1d$export$2e2bcd8739ae039 = $c74379fa66a41d1d$var$VideoTestReviewModal;

});
parcelRegister("Rego2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a0003bf305b2610$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $2YiNh = parcelRequire("2YiNh");

var $asHUK = parcelRequire("asHUK");

var $9TQfG = parcelRequire("9TQfG");

var $cPjEp = parcelRequire("cPjEp");

var $5cF86 = parcelRequire("5cF86");

var $iAroQ = parcelRequire("iAroQ");

var $gbRjc = parcelRequire("gbRjc");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $0a0003bf305b2610$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $9TQfG.default)(color)}`,
            size !== "medium" && `size${(0, $9TQfG.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $1wSL5.default)(slots, (0, $gbRjc.getRadioUtilityClass), classes)
    };
};
const $0a0003bf305b2610$var$RadioRoot = (0, $dTuzq.default)((0, $2YiNh.default), {
    shouldForwardProp: (prop)=>(0, $c1SJa.default)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $9TQfG.default)(ownerState.size)}`],
            styles[`color${(0, $9TQfG.default)(ownerState.color)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $gbRjc.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: "default",
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    "&:hover": {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        "&:hover": {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kqewD.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $gbRjc.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    "&:hover": {
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            }
        ]
    })));
function $0a0003bf305b2610$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $0a0003bf305b2610$var$defaultCheckedIcon = /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $asHUK.default), {
    checked: true
});
const $0a0003bf305b2610$var$defaultIcon = /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $asHUK.default), {});
const $0a0003bf305b2610$var$Radio = /*#__PURE__*/ $dgG1Y.forwardRef(function Radio(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $0a0003bf305b2610$var$defaultCheckedIcon, color: color = "primary", icon: icon = $0a0003bf305b2610$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className, disabled: disabledProp, disableRipple: disableRipple = false, ...other } = props;
    const muiFormControl = (0, $5cF86.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    disabled !== null && disabled !== void 0 ? disabled : disabled = false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $0a0003bf305b2610$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $iAroQ.default)();
    let checked = checkedProp;
    const onChange = (0, $cPjEp.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $0a0003bf305b2610$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    var _defaultIcon_props_fontSize, _defaultCheckedIcon_props_fontSize;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($0a0003bf305b2610$var$RadioRoot, {
        type: "radio",
        icon: /*#__PURE__*/ $dgG1Y.cloneElement(icon, {
            fontSize: (_defaultIcon_props_fontSize = $0a0003bf305b2610$var$defaultIcon.props.fontSize) !== null && _defaultIcon_props_fontSize !== void 0 ? _defaultIcon_props_fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $dgG1Y.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon_props_fontSize = $0a0003bf305b2610$var$defaultCheckedIcon.props.fontSize) !== null && _defaultCheckedIcon_props_fontSize !== void 0 ? _defaultCheckedIcon_props_fontSize : size
        }),
        disabled: disabled,
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $8MGTi.default)(classes.root, className),
        ...other
    });
});
var $0a0003bf305b2610$export$2e2bcd8739ae039 = $0a0003bf305b2610$var$Radio;

});
parcelRegister("asHUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79de9564d047c7e4$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");


var $7aCBJ = parcelRequire("7aCBJ");

var $4ALZP = parcelRequire("4ALZP");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $79de9564d047c7e4$var$RadioButtonIconRoot = (0, $dTuzq.default)("span", {
    shouldForwardProp: (0, $c1SJa.default)
})({
    position: "relative",
    display: "flex"
});
const $79de9564d047c7e4$var$RadioButtonIconBackground = (0, $dTuzq.default)((0, $7aCBJ.default))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $79de9564d047c7e4$var$RadioButtonIconDot = (0, $dTuzq.default)((0, $4ALZP.default))((0, $iIVKJ.default)(({ theme: theme })=>({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: "scale(1)",
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $79de9564d047c7e4$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($79de9564d047c7e4$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)($79de9564d047c7e4$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)($79de9564d047c7e4$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $79de9564d047c7e4$export$2e2bcd8739ae039 = $79de9564d047c7e4$var$RadioButtonIcon;

});
parcelRegister("7aCBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53876a360e176812$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $53876a360e176812$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");

});

parcelRegister("4ALZP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $357fc1486435f8a1$export$2e2bcd8739ae039; });
parcelRequire("dgG1Y");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $357fc1486435f8a1$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");

});


parcelRegister("cPjEp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0268ed61e9c53836$export$2e2bcd8739ae039; });

var $hbyNy = parcelRequire("hbyNy");
var $0268ed61e9c53836$export$2e2bcd8739ae039 = (0, $hbyNy.default);

});

parcelRegister("iAroQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d880d7d033a5adfe$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $haacD = parcelRequire("haacD");
"use client";
function $d880d7d033a5adfe$export$2e2bcd8739ae039() {
    return $dgG1Y.useContext((0, $haacD.default));
}

});
parcelRegister("haacD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7eb48e9009cbfc2$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * @ignore - internal component.
 */ const $c7eb48e9009cbfc2$var$RadioGroupContext = /*#__PURE__*/ $dgG1Y.createContext(undefined);
var $c7eb48e9009cbfc2$export$2e2bcd8739ae039 = $c7eb48e9009cbfc2$var$RadioGroupContext;

});


parcelRegister("gbRjc", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", function () { return $bc97066bc0bf6da9$export$192f7b2363c77155; });
$parcel$export(module.exports, "default", function () { return $bc97066bc0bf6da9$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $bc97066bc0bf6da9$export$192f7b2363c77155(slot) {
    return (0, $5xHgF.default)("MuiRadio", slot);
}
const $bc97066bc0bf6da9$var$radioClasses = (0, $eFHYA.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $bc97066bc0bf6da9$export$2e2bcd8739ae039 = $bc97066bc0bf6da9$var$radioClasses;

});


parcelRegister("gg1yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd5f58595016eb35$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $glpsp = parcelRequire("glpsp");

var $gdmO7 = parcelRequire("gdmO7");

var $51QVq = parcelRequire("51QVq");

var $fPTK9 = parcelRequire("fPTK9");

var $haacD = parcelRequire("haacD");

var $dZybT = parcelRequire("dZybT");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $bd5f58595016eb35$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $gdmO7.getRadioGroupUtilityClass), classes);
};
const $bd5f58595016eb35$var$RadioGroup = /*#__PURE__*/ $dgG1Y.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $dgG1Y.useRef(null);
    const classes = $bd5f58595016eb35$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $fPTK9.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $dgG1Y.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $51QVq.default)(ref, rootRef);
    const name = (0, $dZybT.default)(nameProp);
    const contextValue = $dgG1Y.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $haacD.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $glpsp.default), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $8MGTi.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $bd5f58595016eb35$export$2e2bcd8739ae039 = $bd5f58595016eb35$var$RadioGroup;

});
parcelRegister("glpsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be625ac263447f4c$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $cRTfj = parcelRequire("cRTfj");

var $5cF86 = parcelRequire("5cF86");

var $57Zgm = parcelRequire("57Zgm");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $be625ac263447f4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $cRTfj.getFormGroupUtilityClass), classes);
};
const $be625ac263447f4c$var$FormGroupRoot = (0, $dTuzq.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: "row"
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $be625ac263447f4c$var$FormGroup = /*#__PURE__*/ $dgG1Y.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $5cF86.default)();
    const fcs = (0, $57Zgm.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $be625ac263447f4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($be625ac263447f4c$var$FormGroupRoot, {
        className: (0, $8MGTi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $be625ac263447f4c$export$2e2bcd8739ae039 = $be625ac263447f4c$var$FormGroup;

});
parcelRegister("cRTfj", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", function () { return $95e549f64a54aa95$export$d72d4cbdc30b331f; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $95e549f64a54aa95$export$d72d4cbdc30b331f(slot) {
    return (0, $5xHgF.default)("MuiFormGroup", slot);
}
const $95e549f64a54aa95$var$formGroupClasses = (0, $eFHYA.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $95e549f64a54aa95$export$2e2bcd8739ae039 = $95e549f64a54aa95$var$formGroupClasses;

});


parcelRegister("gdmO7", function(module, exports) {

$parcel$export(module.exports, "getRadioGroupUtilityClass", function () { return $bcdf8d5441c7af73$export$c4cff3a43f7cabb6; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $bcdf8d5441c7af73$export$c4cff3a43f7cabb6(slot) {
    return (0, $5xHgF.default)("MuiRadioGroup", slot);
}
const $bcdf8d5441c7af73$var$radioGroupClasses = (0, $eFHYA.default)("MuiRadioGroup", [
    "root",
    "row",
    "error"
]);
var $bcdf8d5441c7af73$export$2e2bcd8739ae039 = $bcdf8d5441c7af73$var$radioGroupClasses;

});

parcelRegister("dZybT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2fb7e6e22c01cf8$export$2e2bcd8739ae039; });

var $383VY = parcelRequire("383VY");
"use client";
var $a2fb7e6e22c01cf8$export$2e2bcd8739ae039 = (0, $383VY.default);

});



parcelRegister("1uo3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $115b4220c6dcf024$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $4m0VC = parcelRequire("4m0VC");
var $62uyF = parcelRequire("62uyF");
var $6UFAs = parcelRequire("6UFAs");
var $f4GCu = parcelRequire("f4GCu");
var $3teb5 = parcelRequire("3teb5");
var $lqAxB = parcelRequire("lqAxB");
var $6wnIC = parcelRequire("6wnIC");
var $5MowX = parcelRequire("5MowX");
var $f2CoU = parcelRequire("f2CoU");
var $1u2lJ = parcelRequire("1u2lJ");
var $12a5h = parcelRequire("12a5h");
var $hMt12 = parcelRequire("hMt12");
var $k0kWg = parcelRequire("k0kWg");
var $hgbGA = parcelRequire("hgbGA");

var $ewdxp = parcelRequire("ewdxp");

var $56aO2 = parcelRequire("56aO2");

var $hrNT2 = parcelRequire("hrNT2");
const $115b4220c6dcf024$var$OrderListingModal = (props)=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const { sendRequest: sendRequest } = (0, $56aO2.useHttpClient)();
    const [orders, setOrders] = (0, $dgG1Y.useState)([]);
    const [filteredOrders, setFilteredOrders] = (0, $dgG1Y.useState)([]);
    const [startDate, setStartDate] = (0, $dgG1Y.useState)("");
    const [endDate, setEndDate] = (0, $dgG1Y.useState)("");
    const [pageSize, setPageSize] = (0, $dgG1Y.useState)(10);
    const [currentPage, setCurrentPage] = (0, $dgG1Y.useState)(1);
    const [addOrderModalOpen, setAddOrderModalOpen] = (0, $dgG1Y.useState)(false);
    (0, $dgG1Y.useEffect)(()=>{
        const fetchOrders = async ()=>{
            try {
                const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/order/clientOrder`, "POST", JSON.stringify({
                    id: props.open
                }), {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                setOrders(responseData.orders);
                setFilteredOrders(responseData.orders);
            } catch (err) {}
        };
        fetchOrders();
    }, [
        sendRequest,
        auth.token,
        addOrderModalOpen,
        props.open
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        const filterOrders = ()=>{
            const filtered = orders.filter((order)=>{
                const shipDate = new Date(order.requestedDate);
                return (!startDate || new Date(shipDate.toDateString()) >= new Date(startDate)) && (!endDate || new Date(shipDate.toDateString()) <= new Date(endDate));
            }).sort((a, b)=>new Date(b.requestedDate) - new Date(a.requestedDate));
            setFilteredOrders(filtered);
            setCurrentPage(1);
        };
        filterOrders();
    }, [
        startDate,
        endDate,
        orders
    ]);
    const handlePageSizeChange = (event)=>{
        setPageSize(event.target.value);
        setCurrentPage(1); // Reset to first page with new page size
    };
    const totalPages = Math.ceil(filteredOrders.length / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    let displayedOrders = null;
    if (filteredOrders.length > 0) displayedOrders = filteredOrders.slice(startIndex, startIndex + pageSize);
    const getProductString = (order)=>{
        const products = [];
        if (order.labTestQuantity > 0) products.push(`${order.labTestQuantity}x Lab Test`);
        if (order.instantTestQuantity > 0) products.push(`${order.instantTestQuantity}x Instant Test`);
        if (order.breathalyzerQuantity > 0) products.push(`${order.breathalyzerQuantity}x Breathalyzer`);
        if (order.phoneStandQuantity > 0) products.push(`${order.phoneStandQuantity}x AI Phone Stand`);
        return products.length > 0 ? products.join(", ") : order.kitsRequested || "N/A";
    };
    const isProgramAdmin = auth.program || auth.siteAdmin;
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            addOrderModalOpen && (auth.accountableAdmin || isProgramAdmin) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hrNT2.default), {
                open: addOrderModalOpen,
                clear: ()=>setAddOrderModalOpen(false),
                client: props.open
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $62uyF.default), {
                open: props.open,
                onClose: ()=>props.clear(),
                "aria-labelledby": "order-dialog-title",
                "aria-describedby": "order-dialog-description",
                fullWidth: true,
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lqAxB.default), {
                        children: "Order Listing"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f4GCu.default), {
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $3teb5.default), {
                            children: [
                                (auth.accountableAdmin || isProgramAdmin) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                    variant: "contained",
                                    color: "primary",
                                    onClick: ()=>setAddOrderModalOpen(props.open),
                                    children: "Add Order"
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("input", {
                                    type: "date",
                                    value: startDate,
                                    onChange: (e)=>setStartDate(e.target.value),
                                    style: {
                                        margin: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("input", {
                                    type: "date",
                                    value: endDate,
                                    onChange: (e)=>setEndDate(e.target.value),
                                    style: {
                                        margin: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                    select: true,
                                    label: "Rows per page",
                                    value: pageSize,
                                    onChange: handlePageSizeChange,
                                    helperText: "Select the number of rows to display",
                                    children: [
                                        5,
                                        10,
                                        25,
                                        50,
                                        100
                                    ].map((option)=>/*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                            value: option,
                                            children: option
                                        }, option))
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $12a5h.default), {
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $5MowX.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hMt12.default), {
                                                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Request Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Shipping Option"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Products"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Billed"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Shipped Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Mailing Address"
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                            children: "Outbound Status"
                                                        }),
                                                        [
                                                            ...Array(8)
                                                        ].map((_, index)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1u2lJ.default), {
                                                                children: [
                                                                    "Kit #",
                                                                    index + 1
                                                                ]
                                                            }, index))
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f2CoU.default), {
                                                children: displayedOrders === null || displayedOrders === void 0 ? void 0 : displayedOrders.map((order)=>{
                                                    var _order_Kits;
                                                    const productString = getProductString(order);
                                                    var _order_shippingOption;
                                                    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $k0kWg.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: new Date(order.requestedDate).toDateString()
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: (_order_shippingOption = order.shippingOption) !== null && _order_shippingOption !== void 0 ? _order_shippingOption : order.orderType
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: productString
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: order.billed ? "Yes" : "No"
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1u2lJ.default), {
                                                                children: new Date(order.fulfilledDate).toDateString()
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1u2lJ.default), {
                                                                children: [
                                                                    order.shippingAddressLine1,
                                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                                                    order.shippingAddressLine2,
                                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                                                    order.shippingCity,
                                                                    ", ",
                                                                    order.shippingState,
                                                                    ", ",
                                                                    order.shippingZip
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1u2lJ.default), {
                                                                children: [
                                                                    "Tracking:",
                                                                    " ",
                                                                    order.trackingURL ? /*#__PURE__*/ (0, $fR5Jw.jsx)("a", {
                                                                        href: order.trackingURL,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: order.shippingStatus
                                                                    }) : order.trackingNumber
                                                                ]
                                                            }),
                                                            (_order_Kits = order.Kits) === null || _order_Kits === void 0 ? void 0 : _order_Kits.map((kit)=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1u2lJ.default), {
                                                                    children: [
                                                                        "Kit ID: ",
                                                                        kit.kitID,
                                                                        " Tracking:",
                                                                        " ",
                                                                        kit.trackingURL ? /*#__PURE__*/ (0, $fR5Jw.jsx)("a", {
                                                                            href: kit.trackingURL,
                                                                            target: "_blank",
                                                                            rel: "noreferrer",
                                                                            children: kit.shippingStatus
                                                                        }) : kit.trackingNumber
                                                                    ]
                                                                }, kit._id))
                                                        ]
                                                    }, order.id);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $6UFAs.default), {
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                disabled: currentPage === 1,
                                onClick: ()=>setCurrentPage(currentPage - 1),
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                disabled: currentPage === totalPages || totalPages === 0,
                                onClick: ()=>setCurrentPage(currentPage + 1),
                                children: "Next"
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                onClick: ()=>props.clear(),
                                color: "primary",
                                autoFocus: true,
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $115b4220c6dcf024$export$2e2bcd8739ae039 = $115b4220c6dcf024$var$OrderListingModal;

});
parcelRegister("hrNT2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3ba7c20678967c$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $4m0VC = parcelRequire("4m0VC");
var $9alxb = parcelRequire("9alxb");
var $62uyF = parcelRequire("62uyF");
var $6UFAs = parcelRequire("6UFAs");
var $f4GCu = parcelRequire("f4GCu");
var $lqAxB = parcelRequire("lqAxB");
var $7y4r0 = parcelRequire("7y4r0");
var $gJFkA = parcelRequire("gJFkA");
var $6wnIC = parcelRequire("6wnIC");
var $hgbGA = parcelRequire("hgbGA");
var $1QHfa = parcelRequire("1QHfa");

var $56aO2 = parcelRequire("56aO2");

var $ewdxp = parcelRequire("ewdxp");

var $cVxYB = parcelRequire("cVxYB");

var $en0cX = parcelRequire("en0cX");
const $cb3ba7c20678967c$var$AddOrderModal = ({ open: open, onClose: onClose, clear: clear })=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)(); // Assuming you use a custom hook for HTTP requests
    const [partners, setPartners] = (0, $dgG1Y.useState)([]);
    const [orderDetails, setOrderDetails] = (0, $dgG1Y.useState)({
        kitsRequested: "",
        orderType: "Lab Test",
        shippingAddressLine1: "",
        shippingAddressLine2: "",
        shippingCity: "",
        shippingState: "",
        shippingZip: "",
        quantity: "",
        quantity2: "",
        quantity3: "",
        carrier: "",
        trackingNumber: "",
        shippingStatus: "Pending",
        theUser: "",
        expeditedShipping: "0",
        expeditedShippingCharge: "0",
        specialShippingRate: "",
        notes: "",
        shippingOption: "Shipbob",
        instantTestQuantity: "",
        labTestQuantity: "",
        includeBAC: false,
        includePhoneStand: false,
        partner: ""
    });
    const fetchPartners = (0, $dgG1Y.useCallback)(async ()=>{
        const response = await fetch(`${"https://apiv2.youareaccountable.com"}/api/partners`, {
            headers: {
                Authorization: `Bearer ${auth.token}`,
                "Content-Type": "application/json"
            }
        });
        const data = await response.json();
        console.log(data);
        setPartners(data);
    }, [
        auth.token
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        fetchPartners();
    }, [
        fetchPartners
    ]);
    // Fetch client information when `open` changes and is truthy.
    (0, $dgG1Y.useEffect)(()=>{
        const fetchClientInfo = async ()=>{
            if (!open) return; // Do nothing if `open` is falsy.
            try {
                const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/accountable/user`, "POST", JSON.stringify({
                    id: open
                }), {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${auth.token}`
                });
                if (responseData) setOrderDetails((prevState)=>({
                        ...prevState,
                        shippingAddressLine1: responseData.shippingAddressLine1,
                        shippingAddressLine2: responseData.shippingAddressLine2,
                        shippingCity: responseData.shippingCity,
                        shippingState: responseData.shippingState,
                        shippingZip: responseData.shippingZip,
                        theUser: responseData._id
                    }));
            } catch (error) {
                console.error("Failed to fetch client information:", error);
            }
        };
        fetchClientInfo();
    }, [
        open,
        sendRequest,
        auth.token
    ]);
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setOrderDetails((prevState)=>{
            const newState = {
                ...prevState
            };
            if (name === "instantTestQuantity" || name === "labTestQuantity") {
                const numValue = parseInt(value);
                if (numValue < 0 || name === "instantTestQuantity" && numValue > 12) return prevState;
            }
            // Handle expedited shipping logic
            if (name === "expeditedShipping") {
                if (value === "1") {
                    // If selecting free expedited shipping, disable paid expedited
                    newState.expeditedShipping = "1";
                    newState.expeditedShippingCharge = "0";
                    newState.specialShippingRate = "";
                } else // If unchecking free expedited shipping, just reset it
                newState.expeditedShipping = "0";
            } else if (name === "expeditedShippingCharge") {
                if (value === "1") {
                    // If selecting paid expedited, disable free expedited
                    newState.expeditedShipping = "0";
                    newState.expeditedShippingCharge = "1";
                    newState.specialShippingRate = newState.specialShippingRate || "35";
                } else {
                    // If unchecking paid expedited, reset all related fields
                    newState.expeditedShippingCharge = "0";
                    newState.specialShippingRate = "";
                }
            } else if (name === "specialShippingRate") // Only allow special shipping rate when paid expedited is selected
            {
                if (prevState.expeditedShippingCharge === "1") newState[name] = value;
            } else newState[name] = value;
            if (newState.shippingOption !== "Received from Partner") newState.partner = ""; // Reset partner if not received from partner
            else // Default to include BAC if received from partner (only option for creating partner orders at the moment)
            newState.includeBAC = true;
            return newState;
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        try {
            const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/order/submitOrder`, "POST", JSON.stringify(orderDetails), {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth.token}`
            });
            setOrderDetails({
                kitsRequested: "",
                orderType: "Lab Test",
                shippingAddressLine1: "",
                shippingAddressLine2: "",
                shippingCity: "",
                shippingState: "",
                shippingZip: "",
                quantity: "",
                quantity2: "",
                carrier: "",
                trackingNumber: "",
                shippingStatus: "Pending",
                theUser: "",
                expeditedShipping: "0",
                expeditedShippingCharge: "0",
                specialShippingRate: "",
                notes: "",
                shippingOption: "Shipbob",
                instantTestQuantity: "",
                labTestQuantity: "",
                includeBAC: false,
                includePhoneStand: false,
                partner: ""
            });
            clear();
        } catch (error) {
            console.error("Failed to fetch client information:", error);
        }
        console.log(orderDetails);
    // Submit logic here
    };
    const isReceivedFromPartner = orderDetails.shippingOption === "Received from Partner";
    const shippingCharge = orderDetails.specialShippingRate || (orderDetails.expeditedShippingCharge === "1" ? "35" : "0");
    // Add this validation function
    const isFormValid = ()=>{
        if (isReceivedFromPartner) {
            if (!orderDetails.partner) return false;
            if (!orderDetails.includeBAC) return false;
        }
        const hasQuantity = orderDetails.instantTestQuantity > 0 || orderDetails.labTestQuantity > 0 || orderDetails.includeBAC;
        const hasAddress = orderDetails.shippingAddressLine1 && orderDetails.shippingCity && orderDetails.shippingState && orderDetails.shippingZip;
        return hasQuantity && hasAddress;
    };
    const isProgramAdmin = auth.program && auth.programProvider;
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Ordering",
                alert: error,
                clearError: clearError
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $62uyF.default), {
                open: !!open,
                onClose: onClose,
                "aria-labelledby": "form-dialog-title",
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lqAxB.default), {
                        id: "form-dialog-title",
                        children: "Add New Order"
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f4GCu.default), {
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        !isProgramAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $hgbGA.default), {
                                                fullWidth: true,
                                                label: "Shipping Option",
                                                variant: "outlined",
                                                select: true,
                                                name: "shippingOption",
                                                value: orderDetails.shippingOption,
                                                onChange: handleInputChange,
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                        value: "Shipbob",
                                                        children: "Shipbob"
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                        value: "Local Office",
                                                        children: "Local Office"
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                        value: "Received from Partner",
                                                        children: "Received from Partner"
                                                    })
                                                ]
                                            })
                                        }),
                                        isReceivedFromPartner && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                fullWidth: true,
                                                label: "Partner Name",
                                                variant: "outlined",
                                                select: true,
                                                name: "partner",
                                                value: orderDetails.partner,
                                                onChange: handleInputChange,
                                                children: partners.map((partner)=>/*#__PURE__*/ (0, $fR5Jw.jsx)((0, $6wnIC.default), {
                                                        value: partner._id,
                                                        children: partner.name
                                                    }, partner._id))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                            children: [
                                                !isReceivedFromPartner && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                            item: true,
                                                            xs: 12,
                                                            sm: 4,
                                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                                label: "Instant Test Quantity",
                                                                fullWidth: true,
                                                                variant: "outlined",
                                                                type: "number",
                                                                name: "instantTestQuantity",
                                                                value: orderDetails.instantTestQuantity,
                                                                onChange: handleInputChange
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                            item: true,
                                                            xs: 12,
                                                            sm: 4,
                                                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                                label: "Lab Test Quantity",
                                                                fullWidth: true,
                                                                variant: "outlined",
                                                                type: "number",
                                                                name: "labTestQuantity",
                                                                value: orderDetails.labTestQuantity,
                                                                onChange: handleInputChange,
                                                                helperText: isReceivedFromPartner ? "" : "$125 per lab test"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 4,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7y4r0.default), {
                                                            control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                                                checked: orderDetails.includeBAC,
                                                                onChange: (e)=>handleInputChange({
                                                                        target: {
                                                                            name: "includeBAC",
                                                                            value: e.target.checked
                                                                        }
                                                                    }),
                                                                name: "includeBAC",
                                                                color: "primary"
                                                            }),
                                                            label: "Include BAC"
                                                        }),
                                                        auth.harambe && !isReceivedFromPartner && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7y4r0.default), {
                                                            control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                                                checked: orderDetails.includePhoneStand,
                                                                onChange: (e)=>handleInputChange({
                                                                        target: {
                                                                            name: "includePhoneStand",
                                                                            value: e.target.checked
                                                                        }
                                                                    }),
                                                                name: "includePhoneStand",
                                                                color: "primary"
                                                            }),
                                                            label: "Include Phone Stand"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isReceivedFromPartner && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 6,
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                        label: "Shipping Address Line 1",
                                                        fullWidth: true,
                                                        variant: "outlined",
                                                        name: "shippingAddressLine1",
                                                        value: orderDetails.shippingAddressLine1,
                                                        onChange: handleInputChange
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 6,
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                        label: "Shipping Address Line 2",
                                                        fullWidth: true,
                                                        variant: "outlined",
                                                        name: "shippingAddressLine2",
                                                        value: orderDetails.shippingAddressLine2,
                                                        onChange: handleInputChange
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 4,
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                        label: "City",
                                                        fullWidth: true,
                                                        variant: "outlined",
                                                        name: "shippingCity",
                                                        value: orderDetails.shippingCity,
                                                        onChange: handleInputChange
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 4,
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                        label: "State",
                                                        fullWidth: true,
                                                        variant: "outlined",
                                                        name: "shippingState",
                                                        value: orderDetails.shippingState,
                                                        onChange: handleInputChange
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 4,
                                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                        label: "Zip Code",
                                                        fullWidth: true,
                                                        variant: "outlined",
                                                        name: "shippingZip",
                                                        value: orderDetails.shippingZip,
                                                        onChange: handleInputChange
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                            item: true,
                                            xs: 12,
                                            sm: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                    label: "Notes",
                                                    fullWidth: true,
                                                    variant: "outlined",
                                                    name: "notes",
                                                    value: orderDetails.notes,
                                                    onChange: handleInputChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                            item: true,
                                            xs: 12,
                                            sm: 6,
                                            children: [
                                                !isProgramAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7y4r0.default), {
                                                    control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                                        checked: orderDetails.expeditedShipping === "1",
                                                        onChange: (e)=>handleInputChange({
                                                                target: {
                                                                    name: "expeditedShipping",
                                                                    value: e.target.checked ? "1" : "0"
                                                                }
                                                            }),
                                                        name: "expeditedShipping",
                                                        color: "primary",
                                                        disabled: orderDetails.expeditedShippingCharge === "1"
                                                    }),
                                                    label: "Expedited Shipping - Initial Order - No Charge"
                                                }),
                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7y4r0.default), {
                                                    control: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                                        checked: orderDetails.expeditedShippingCharge === "1",
                                                        onChange: (e)=>handleInputChange({
                                                                target: {
                                                                    name: "expeditedShippingCharge",
                                                                    value: e.target.checked ? "1" : "0"
                                                                }
                                                            }),
                                                        name: "expeditedShippingCharge",
                                                        color: "primary",
                                                        disabled: orderDetails.expeditedShipping === "1"
                                                    }),
                                                    label: isProgramAdmin ? "Expedited Shipping" : "Expedited Shipping - Charge"
                                                }),
                                                orderDetails.expeditedShippingCharge === "1" && !isProgramAdmin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                    label: "Special Shipping Rate",
                                                    InputLabelProps: {
                                                        shrink: true
                                                    },
                                                    fullWidth: true,
                                                    variant: "outlined",
                                                    name: "specialShippingRate",
                                                    value: orderDetails.specialShippingRate,
                                                    onChange: handleInputChange,
                                                    helperText: "Leave empty for default $35 charge"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                variant: "body1",
                                                children: [
                                                    "This order will charge $",
                                                    shippingCharge,
                                                    " for shipping"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                            variant: "h6",
                                            style: {
                                                marginTop: "20px"
                                            },
                                            children: "Order Summary"
                                        }),
                                        orderDetails.labTestQuantity > 0 && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                            children: [
                                                "Lab Tests: $",
                                                Number(orderDetails.labTestQuantity) * 125,
                                                "(",
                                                orderDetails.labTestQuantity,
                                                " \xd7 $125)"
                                            ]
                                        }),
                                        orderDetails.instantTestQuantity > 0 && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                            children: [
                                                "Instant Tests: $0 (",
                                                orderDetails.instantTestQuantity,
                                                " \xd7 $0)"
                                            ]
                                        }),
                                        orderDetails.includeBAC && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                            children: "BAC: $125"
                                        }),
                                        (orderDetails.expeditedShipping === "1" || orderDetails.expeditedShippingCharge === "1") && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                            children: [
                                                "Expedited Shipping: $",
                                                shippingCharge
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                            variant: "subtitle1",
                                            style: {
                                                marginTop: "10px",
                                                fontWeight: "bold"
                                            },
                                            children: [
                                                "Total: $",
                                                Number(orderDetails.labTestQuantity) * 125 + (orderDetails.includeBAC ? 125 : 0) + Number(shippingCharge)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $6UFAs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                            onClick: clear,
                                            color: "primary",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                            type: "submit",
                                            color: "primary",
                                            onClick: handleSubmit,
                                            disabled: !isFormValid(),
                                            children: "Submit Order"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $cb3ba7c20678967c$export$2e2bcd8739ae039 = $cb3ba7c20678967c$var$AddOrderModal;

});
parcelRegister("7y4r0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57ef260326a73d89$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");


var $fJyy2 = parcelRequire("fJyy2");

var $7xfqK = parcelRequire("7xfqK");

var $1QHfa = parcelRequire("1QHfa");

var $bdWPY = parcelRequire("bdWPY");
var $57ef260326a73d89$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            // For correct alignment with the text.
            verticalAlign: "middle",
            WebkitTapHighlightColor: "transparent",
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            "&$disabled": {
                cursor: "default"
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: "row-reverse",
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: "column-reverse",
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: "column",
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $57ef260326a73d89$var$FormControlLabel = /*#__PURE__*/ $dgG1Y.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "end" : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $gZz4Z.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $fJyy2.default)();
    var disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach(function(key) {
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $dgG1Y.createElement("label", (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, className, labelPlacement !== "end" && classes["labelPlacement".concat((0, $bdWPY.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $dgG1Y.cloneElement(control, controlProps), /*#__PURE__*/ $dgG1Y.createElement((0, $1QHfa.default), {
        component: "span",
        className: (0, $cXVHi.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $57ef260326a73d89$export$2e2bcd8739ae039 = (0, $7xfqK.default)($57ef260326a73d89$export$9dd6ff9ea0189349, {
    name: "MuiFormControlLabel"
})($57ef260326a73d89$var$FormControlLabel);

});



parcelRegister("hlbJR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9fd80e22bb41c9c$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $2wmnn = parcelRequire("2wmnn");


var $1wSL5 = parcelRequire("1wSL5");

var $kqewD = parcelRequire("kqewD");

var $gK9Ik = parcelRequire("gK9Ik");

var $69eGa = parcelRequire("69eGa");

var $bEw0x = parcelRequire("bEw0x");

var $dTuzq = parcelRequire("dTuzq");
var $kngbJ = parcelRequire("kngbJ");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $9TQfG = parcelRequire("9TQfG");

var $lUlBP = parcelRequire("lUlBP");

var $lb1hk = parcelRequire("lb1hk");

var $eGG39 = parcelRequire("eGG39");

var $51QVq = parcelRequire("51QVq");

var $dZybT = parcelRequire("dZybT");

var $fPTK9 = parcelRequire("fPTK9");

var $eAnru = parcelRequire("eAnru");

var $gW4C7 = parcelRequire("gW4C7");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $c9fd80e22bb41c9c$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $c9fd80e22bb41c9c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $9TQfG.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $gW4C7.getTooltipUtilityClass), classes);
};
const $c9fd80e22bb41c9c$var$TooltipPopper = (0, $dTuzq.default)((0, $lb1hk.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none",
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: "auto"
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: "none"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $gW4C7.default).arrow}`]: {
                        top: 0,
                        marginTop: "-0.71em",
                        "&::before": {
                            transformOrigin: "0 100%"
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $gW4C7.default).arrow}`]: {
                        bottom: 0,
                        marginBottom: "-0.71em",
                        "&::before": {
                            transformOrigin: "100% 0"
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $gW4C7.default).arrow}`]: {
                        height: "1em",
                        width: "0.71em",
                        "&::before": {
                            transformOrigin: "100% 100%"
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $gW4C7.default).arrow}`]: {
                        height: "1em",
                        width: "0.71em",
                        "&::before": {
                            transformOrigin: "0 0"
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $gW4C7.default).arrow}`]: {
                        left: 0,
                        marginLeft: "-0.71em"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $gW4C7.default).arrow}`]: {
                        right: 0,
                        marginRight: "-0.71em"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $gW4C7.default).arrow}`]: {
                        right: 0,
                        marginRight: "-0.71em"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $gW4C7.default).arrow}`]: {
                        left: 0,
                        marginLeft: "-0.71em"
                    }
                }
            }
        ]
    })));
const $c9fd80e22bb41c9c$var$TooltipTooltip = (0, $dTuzq.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $9TQfG.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kqewD.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $gW4C7.default).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: "right center"
        },
        [`.${(0, $gW4C7.default).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: "left center"
        },
        [`.${(0, $gW4C7.default).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: "center bottom",
            marginBottom: "14px"
        },
        [`.${(0, $gW4C7.default).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: "center top",
            marginTop: "14px"
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: "relative",
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: "8px 16px",
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$c9fd80e22bb41c9c$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: "14px"
                    },
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: "14px"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: "24px"
                    },
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: "24px"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: "14px"
                    },
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: "14px"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: "24px"
                    },
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: "24px"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: "24px"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $gW4C7.default).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: "24px"
                    }
                }
            }
        ]
    })));
const $c9fd80e22bb41c9c$var$TooltipArrow = (0, $dTuzq.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})((0, $iIVKJ.default)(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kqewD.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    })));
let $c9fd80e22bb41c9c$var$hystersisOpen = false;
const $c9fd80e22bb41c9c$var$hystersisTimer = new (0, $2wmnn.Timeout)();
let $c9fd80e22bb41c9c$var$cursorPosition = {
    x: 0,
    y: 0
};
function $c9fd80e22bb41c9c$export$b9ee5a7ace0541f8() {
    $c9fd80e22bb41c9c$var$hystersisOpen = false;
    $c9fd80e22bb41c9c$var$hystersisTimer.clear();
}
function $c9fd80e22bb41c9c$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $c9fd80e22bb41c9c$var$Tooltip = /*#__PURE__*/ $dgG1Y.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $dgG1Y.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $kngbJ.default)();
    const isRtl = (0, $gK9Ik.useRtl)();
    const [childNode, setChildNode] = $dgG1Y.useState();
    const [arrowRef, setArrowRef] = $dgG1Y.useState(null);
    const ignoreNonTouchEvents = $dgG1Y.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $2wmnn.default)();
    const enterTimer = (0, $2wmnn.default)();
    const leaveTimer = (0, $2wmnn.default)();
    const touchTimer = (0, $2wmnn.default)();
    const [openState, setOpenState] = (0, $fPTK9.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $dZybT.default)(idProp);
    const prevUserSelect = $dgG1Y.useRef();
    const stopTouchInteraction = (0, $eGG39.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $dgG1Y.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $c9fd80e22bb41c9c$var$hystersisTimer.clear();
        $c9fd80e22bb41c9c$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $eGG39.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $c9fd80e22bb41c9c$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $c9fd80e22bb41c9c$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $c9fd80e22bb41c9c$var$hystersisOpen && enterNextDelay) enterTimer.start($c9fd80e22bb41c9c$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $dgG1Y.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $69eGa.default)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $69eGa.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $dgG1Y.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === "Escape") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $51QVq.default)((0, $bEw0x.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $dgG1Y.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $c9fd80e22bb41c9c$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $8MGTi.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $c9fd80e22bb41c9c$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $c9fd80e22bb41c9c$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $c9fd80e22bb41c9c$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $c9fd80e22bb41c9c$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === "function" ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $dgG1Y.useMemo(()=>{
        var _PopperProps_popperOptions, _resolvedPopperProps_popperOptions;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps_popperOptions = PopperProps.popperOptions) === null || _PopperProps_popperOptions === void 0 ? void 0 : _PopperProps_popperOptions.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps === null || resolvedPopperProps === void 0 ? void 0 : (_resolvedPopperProps_popperOptions = resolvedPopperProps.popperOptions) === null || _resolvedPopperProps_popperOptions === void 0 ? void 0 : _resolvedPopperProps_popperOptions.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps === null || resolvedPopperProps === void 0 ? void 0 : resolvedPopperProps.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps === null || resolvedPopperProps === void 0 ? void 0 : resolvedPopperProps.popperOptions
    ]);
    const classes = $c9fd80e22bb41c9c$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === "function" ? slotProps.transition(ownerState) : slotProps.transition;
    var _components_Transition, _slotProps_arrow, _slotProps_tooltip;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: (_components_Transition = components.Transition) !== null && _components_Transition !== void 0 ? _components_Transition : TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: (_slotProps_arrow = slotProps.arrow) !== null && _slotProps_arrow !== void 0 ? _slotProps_arrow : componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps !== null && resolvedPopperProps !== void 0 ? resolvedPopperProps : componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: (_slotProps_tooltip = slotProps.tooltip) !== null && _slotProps_tooltip !== void 0 ? _slotProps_tooltip : componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps !== null && resolvedTransitionProps !== void 0 ? resolvedTransitionProps : componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $eAnru.default)("popper", {
        elementType: $c9fd80e22bb41c9c$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $8MGTi.default)(classes.popper, PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $eAnru.default)("transition", {
        elementType: (0, $lUlBP.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $eAnru.default)("tooltip", {
        elementType: $c9fd80e22bb41c9c$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $eAnru.default)("arrow", {
        elementType: $c9fd80e22bb41c9c$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
        children: [
            /*#__PURE__*/ $dgG1Y.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $fR5Jw.jsx)(PopperSlot, {
                as: PopperComponentProp !== null && PopperComponentProp !== void 0 ? PopperComponentProp : (0, $lb1hk.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $c9fd80e22bb41c9c$var$cursorPosition.y,
                            left: $c9fd80e22bb41c9c$var$cursorPosition.x,
                            right: $c9fd80e22bb41c9c$var$cursorPosition.x,
                            bottom: $c9fd80e22bb41c9c$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $fR5Jw.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $c9fd80e22bb41c9c$export$2e2bcd8739ae039 = $c9fd80e22bb41c9c$var$Tooltip;

});
parcelRegister("lb1hk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6ab9def911e22c1$export$2e2bcd8739ae039; });

var $gK9Ik = parcelRequire("gK9Ik");




var $dgG1Y = parcelRequire("dgG1Y");

var $8QMYV = parcelRequire("8QMYV");

var $dTuzq = parcelRequire("dTuzq");

var $aR3AP = parcelRequire("aR3AP");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $f6ab9def911e22c1$var$PopperRoot = (0, $dTuzq.default)((0, $8QMYV.default), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $f6ab9def911e22c1$var$Popper = /*#__PURE__*/ $dgG1Y.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $gK9Ik.useRtl)();
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    var _slots_root;
    const RootComponent = (_slots_root = slots === null || slots === void 0 ? void 0 : slots.root) !== null && _slots_root !== void 0 ? _slots_root : components === null || components === void 0 ? void 0 : components.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($f6ab9def911e22c1$var$PopperRoot, {
        as: component,
        direction: isRtl ? "rtl" : "ltr",
        slots: {
            root: RootComponent
        },
        slotProps: slotProps !== null && slotProps !== void 0 ? slotProps : componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $f6ab9def911e22c1$export$2e2bcd8739ae039 = $f6ab9def911e22c1$var$Popper;

});
parcelRegister("8QMYV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67192cc8edb08110$export$2e2bcd8739ae039; });

var $dgG1Y = parcelRequire("dgG1Y");

var $2gobp = parcelRequire("2gobp");
var $huSf2 = parcelRequire("huSf2");
var $1ZLdA = parcelRequire("1ZLdA");

var $dD51g = parcelRequire("dD51g");


var $1wSL5 = parcelRequire("1wSL5");

var $a3oUN = parcelRequire("a3oUN");

var $5dz7O = parcelRequire("5dz7O");

var $iI3vX = parcelRequire("iI3vX");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $67192cc8edb08110$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $67192cc8edb08110$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $67192cc8edb08110$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $67192cc8edb08110$var$isVirtualElement(element) {
    return !$67192cc8edb08110$var$isHTMLElement(element);
}
const $67192cc8edb08110$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $iI3vX.getPopperUtilityClass), classes);
};
const $67192cc8edb08110$var$defaultPopperOptions = {};
const $67192cc8edb08110$var$PopperTooltip = /*#__PURE__*/ $dgG1Y.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $dgG1Y.useRef(null);
    const ownRef = (0, $1ZLdA.default)(tooltipRef, forwardedRef);
    const popperRef = $dgG1Y.useRef(null);
    const handlePopperRef = (0, $1ZLdA.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $dgG1Y.useRef(handlePopperRef);
    (0, $huSf2.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $dgG1Y.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $67192cc8edb08110$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $dgG1Y.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $dgG1Y.useState($67192cc8edb08110$var$resolveAnchorEl(anchorEl));
    $dgG1Y.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $dgG1Y.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($67192cc8edb08110$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $huSf2.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $dD51g.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $67192cc8edb08110$var$useUtilityClasses(props);
    var _slots_root;
    const Root = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : "div";
    const rootProps = (0, $a3oUN.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsx)(Root, {
        ...rootProps,
        children: typeof children === "function" ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $67192cc8edb08110$var$Popper = /*#__PURE__*/ $dgG1Y.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $67192cc8edb08110$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $dgG1Y.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $67192cc8edb08110$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $67192cc8edb08110$var$isHTMLElement(resolvedAnchorEl) ? (0, $2gobp.default)(resolvedAnchorEl).body : (0, $2gobp.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $5dz7O.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)($67192cc8edb08110$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $67192cc8edb08110$export$2e2bcd8739ae039 = $67192cc8edb08110$var$Popper;

});
parcelRegister("dD51g", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $9ec2cf9f2e791f32$export$8f7491d57c8f97a9; });

var $1zvlp = parcelRequire("1zvlp");

var $4lgUV = parcelRequire("4lgUV");

var $gRJJt = parcelRequire("gRJJt");

var $wSJDI = parcelRequire("wSJDI");

var $bjiGl = parcelRequire("bjiGl");

var $dGIOU = parcelRequire("dGIOU");

var $3q4qi = parcelRequire("3q4qi");

var $g2Ojy = parcelRequire("g2Ojy");

var $1VNHo = parcelRequire("1VNHo");

var $6MUg0 = parcelRequire("6MUg0");


var $9ec2cf9f2e791f32$export$d34966752335dd47 = [
    (0, $4lgUV.default),
    (0, $gRJJt.default),
    (0, $wSJDI.default),
    (0, $bjiGl.default),
    (0, $dGIOU.default),
    (0, $3q4qi.default),
    (0, $g2Ojy.default),
    (0, $1VNHo.default),
    (0, $6MUg0.default)
];
var $9ec2cf9f2e791f32$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1zvlp.popperGenerator)({
    defaultModifiers: $9ec2cf9f2e791f32$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("1zvlp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $12515fa6fb5451fa$export$ed5e13716264f202; });

var $fK7xg = parcelRequire("fK7xg");

var $aLUir = parcelRequire("aLUir");

var $1HuQs = parcelRequire("1HuQs");

var $b3S5p = parcelRequire("b3S5p");

var $3ZAMd = parcelRequire("3ZAMd");

var $fpGJi = parcelRequire("fpGJi");

var $denPE = parcelRequire("denPE");


var $iJd9x = parcelRequire("iJd9x");
var $12515fa6fb5451fa$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $12515fa6fb5451fa$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $12515fa6fb5451fa$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $12515fa6fb5451fa$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $12515fa6fb5451fa$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $iJd9x.isElement)(reference) ? (0, $1HuQs.default)(reference) : reference.contextElement ? (0, $1HuQs.default)(reference.contextElement) : [],
                    popper: (0, $1HuQs.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3ZAMd.default)((0, $denPE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$12515fa6fb5451fa$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $fK7xg.default)(reference, (0, $b3S5p.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $aLUir.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fpGJi.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$12515fa6fb5451fa$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $12515fa6fb5451fa$export$8f7491d57c8f97a9 = /*#__PURE__*/ $12515fa6fb5451fa$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fK7xg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b760ff4e670feb2d$export$2e2bcd8739ae039; });

var $8LvIw = parcelRequire("8LvIw");

var $bfPFl = parcelRequire("bfPFl");

var $BRjpD = parcelRequire("BRjpD");

var $iJd9x = parcelRequire("iJd9x");

var $ixenM = parcelRequire("ixenM");

var $hwwQ1 = parcelRequire("hwwQ1");

var $eJtRq = parcelRequire("eJtRq");

var $9TYtw = parcelRequire("9TYtw");
function $b760ff4e670feb2d$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9TYtw.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9TYtw.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b760ff4e670feb2d$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $iJd9x.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $iJd9x.isHTMLElement)(offsetParent) && $b760ff4e670feb2d$var$isElementScaled(offsetParent);
    var documentElement = (0, $hwwQ1.default)(offsetParent);
    var rect = (0, $8LvIw.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $BRjpD.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $eJtRq.default)(documentElement)) scroll = (0, $bfPFl.default)(offsetParent);
        if ((0, $iJd9x.isHTMLElement)(offsetParent)) {
            offsets = (0, $8LvIw.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $ixenM.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("8LvIw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a59a142f8f0399$export$2e2bcd8739ae039; });

var $iJd9x = parcelRequire("iJd9x");

var $9TYtw = parcelRequire("9TYtw");

var $evuM1 = parcelRequire("evuM1");

var $bAuwd = parcelRequire("bAuwd");
function $01a59a142f8f0399$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $iJd9x.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9TYtw.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9TYtw.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $iJd9x.isElement)(element) ? (0, $evuM1.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bAuwd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("iJd9x", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $da26a1dd06fdc64c$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $da26a1dd06fdc64c$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $da26a1dd06fdc64c$export$af51f0f06c0f328a; });

var $evuM1 = parcelRequire("evuM1");
function $da26a1dd06fdc64c$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $evuM1.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $da26a1dd06fdc64c$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $evuM1.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $da26a1dd06fdc64c$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $evuM1.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("evuM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8fbd4e7bf9c40f0$export$2e2bcd8739ae039; });
function $a8fbd4e7bf9c40f0$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("9TYtw", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $7358293b7c5ba66b$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $7358293b7c5ba66b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $7358293b7c5ba66b$export$2077e0241d6afd3c; });
var $7358293b7c5ba66b$export$8960430cfd85939f = Math.max;
var $7358293b7c5ba66b$export$96ec731ed4dcb222 = Math.min;
var $7358293b7c5ba66b$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bAuwd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86fabad941755c53$export$2e2bcd8739ae039; });

var $2rXEW = parcelRequire("2rXEW");
function $86fabad941755c53$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $2rXEW.default)());
}

});
parcelRegister("2rXEW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c8c6182e84628a6$export$2e2bcd8739ae039; });
function $1c8c6182e84628a6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("bfPFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83192c3340fcd146$export$2e2bcd8739ae039; });

var $gFmww = parcelRequire("gFmww");

var $evuM1 = parcelRequire("evuM1");

var $iJd9x = parcelRequire("iJd9x");

var $6Rdle = parcelRequire("6Rdle");
function $83192c3340fcd146$export$2e2bcd8739ae039(node) {
    if (node === (0, $evuM1.default)(node) || !(0, $iJd9x.isHTMLElement)(node)) return (0, $gFmww.default)(node);
    else return (0, $6Rdle.default)(node);
}

});
parcelRegister("gFmww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c221f25d17a84a9b$export$2e2bcd8739ae039; });

var $evuM1 = parcelRequire("evuM1");
function $c221f25d17a84a9b$export$2e2bcd8739ae039(node) {
    var win = (0, $evuM1.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("6Rdle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fe20aa402d75ed9$export$2e2bcd8739ae039; });
function $4fe20aa402d75ed9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("BRjpD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $071ccf7d3e80c8d6$export$2e2bcd8739ae039; });
function $071ccf7d3e80c8d6$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("ixenM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7e6771f18ea4199$export$2e2bcd8739ae039; });

var $8LvIw = parcelRequire("8LvIw");

var $hwwQ1 = parcelRequire("hwwQ1");

var $gFmww = parcelRequire("gFmww");
function $d7e6771f18ea4199$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8LvIw.default)((0, $hwwQ1.default)(element)).left + (0, $gFmww.default)(element).scrollLeft;
}

});
parcelRegister("hwwQ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1ee5cecdb4411d$export$2e2bcd8739ae039; });

var $iJd9x = parcelRequire("iJd9x");
function $cc1ee5cecdb4411d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $iJd9x.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("eJtRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab9c6e62bb2d59b5$export$2e2bcd8739ae039; });

var $l05Oo = parcelRequire("l05Oo");
function $ab9c6e62bb2d59b5$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $l05Oo.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("l05Oo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f49e1b2e43c5e44b$export$2e2bcd8739ae039; });

var $evuM1 = parcelRequire("evuM1");
function $f49e1b2e43c5e44b$export$2e2bcd8739ae039(element) {
    return (0, $evuM1.default)(element).getComputedStyle(element);
}

});



parcelRegister("aLUir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d79f67acfc20993$export$2e2bcd8739ae039; });

var $8LvIw = parcelRequire("8LvIw");
function $7d79f67acfc20993$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8LvIw.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("1HuQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13d1bbc4f9ac43e6$export$2e2bcd8739ae039; });

var $4uLC6 = parcelRequire("4uLC6");

var $gCrM2 = parcelRequire("gCrM2");

var $evuM1 = parcelRequire("evuM1");

var $eJtRq = parcelRequire("eJtRq");
function $13d1bbc4f9ac43e6$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4uLC6.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $evuM1.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $eJtRq.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($13d1bbc4f9ac43e6$export$2e2bcd8739ae039((0, $gCrM2.default)(target)));
}

});
parcelRegister("4uLC6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $345ee5cd45b41149$export$2e2bcd8739ae039; });

var $gCrM2 = parcelRequire("gCrM2");

var $eJtRq = parcelRequire("eJtRq");

var $BRjpD = parcelRequire("BRjpD");

var $iJd9x = parcelRequire("iJd9x");
function $345ee5cd45b41149$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $BRjpD.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $iJd9x.isHTMLElement)(node) && (0, $eJtRq.default)(node)) return node;
    return $345ee5cd45b41149$export$2e2bcd8739ae039((0, $gCrM2.default)(node));
}

});
parcelRegister("gCrM2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c195bd3a20f22187$export$2e2bcd8739ae039; });

var $BRjpD = parcelRequire("BRjpD");

var $hwwQ1 = parcelRequire("hwwQ1");

var $iJd9x = parcelRequire("iJd9x");
function $c195bd3a20f22187$export$2e2bcd8739ae039(element) {
    if ((0, $BRjpD.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $iJd9x.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $hwwQ1.default)(element) // fallback
    );
}

});



parcelRegister("b3S5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80d9ede98c5aaa6c$export$2e2bcd8739ae039; });

var $evuM1 = parcelRequire("evuM1");

var $BRjpD = parcelRequire("BRjpD");

var $l05Oo = parcelRequire("l05Oo");

var $iJd9x = parcelRequire("iJd9x");

var $hhmyt = parcelRequire("hhmyt");

var $gCrM2 = parcelRequire("gCrM2");

var $2rXEW = parcelRequire("2rXEW");
function $80d9ede98c5aaa6c$var$getTrueOffsetParent(element) {
    if (!(0, $iJd9x.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $l05Oo.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $80d9ede98c5aaa6c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $2rXEW.default)());
    var isIE = /Trident/i.test((0, $2rXEW.default)());
    if (isIE && (0, $iJd9x.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $l05Oo.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $gCrM2.default)(element);
    if ((0, $iJd9x.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $iJd9x.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $BRjpD.default)(currentNode)) < 0){
        var css = (0, $l05Oo.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $80d9ede98c5aaa6c$export$2e2bcd8739ae039(element) {
    var window = (0, $evuM1.default)(element);
    var offsetParent = $80d9ede98c5aaa6c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $hhmyt.default)(offsetParent) && (0, $l05Oo.default)(offsetParent).position === "static")offsetParent = $80d9ede98c5aaa6c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $BRjpD.default)(offsetParent) === "html" || (0, $BRjpD.default)(offsetParent) === "body" && (0, $l05Oo.default)(offsetParent).position === "static")) return window;
    return offsetParent || $80d9ede98c5aaa6c$var$getContainingBlock(element) || window;
}

});
parcelRegister("hhmyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c94585290b1c5270$export$2e2bcd8739ae039; });

var $BRjpD = parcelRequire("BRjpD");
function $c94585290b1c5270$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $BRjpD.default)(element)) >= 0;
}

});


parcelRegister("3ZAMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e8398ab9d65844d$export$2e2bcd8739ae039; });

var $cEt57 = parcelRequire("cEt57");
function $2e8398ab9d65844d$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2e8398ab9d65844d$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2e8398ab9d65844d$var$order(modifiers); // order based on phase
    return (0, $cEt57.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cEt57", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $935fc775d174a701$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $935fc775d174a701$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $935fc775d174a701$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $935fc775d174a701$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $935fc775d174a701$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $935fc775d174a701$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $935fc775d174a701$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $935fc775d174a701$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $935fc775d174a701$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $935fc775d174a701$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $935fc775d174a701$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $935fc775d174a701$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $935fc775d174a701$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $935fc775d174a701$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $935fc775d174a701$export$d087d3878fdf71d5; });
var $935fc775d174a701$export$1e95b668f3b82d = "top";
var $935fc775d174a701$export$40e543e69a8b3fbb = "bottom";
var $935fc775d174a701$export$79ffe56a765070d2 = "right";
var $935fc775d174a701$export$eabcd2c8791e7bf4 = "left";
var $935fc775d174a701$export$dfb5619354ba860 = "auto";
var $935fc775d174a701$export$aec2ce47c367b8c3 = [
    $935fc775d174a701$export$1e95b668f3b82d,
    $935fc775d174a701$export$40e543e69a8b3fbb,
    $935fc775d174a701$export$79ffe56a765070d2,
    $935fc775d174a701$export$eabcd2c8791e7bf4
];
var $935fc775d174a701$export$b3571188c770cc5a = "start";
var $935fc775d174a701$export$bd5df0f255a350f8 = "end";
var $935fc775d174a701$export$390fd549c5303b4d = "clippingParents";
var $935fc775d174a701$export$d7b7311ec04a3e8f = "viewport";
var $935fc775d174a701$export$ae5ab1c730825774 = "popper";
var $935fc775d174a701$export$ca50aac9f3ba507f = "reference";
var $935fc775d174a701$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935fc775d174a701$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935fc775d174a701$export$b3571188c770cc5a,
        placement + "-" + $935fc775d174a701$export$bd5df0f255a350f8
    ]);
}, []);
var $935fc775d174a701$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935fc775d174a701$export$aec2ce47c367b8c3, [
    $935fc775d174a701$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935fc775d174a701$export$b3571188c770cc5a,
        placement + "-" + $935fc775d174a701$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935fc775d174a701$export$421679a7c3d56e = "beforeRead";
var $935fc775d174a701$export$aafa59e2e03f2942 = "read";
var $935fc775d174a701$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $935fc775d174a701$export$c65e99957a05207c = "beforeMain";
var $935fc775d174a701$export$f22da7240b7add18 = "main";
var $935fc775d174a701$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935fc775d174a701$export$8d4d2d70e7d46032 = "beforeWrite";
var $935fc775d174a701$export$68d8715fc104d294 = "write";
var $935fc775d174a701$export$70a6e5159acce2e6 = "afterWrite";
var $935fc775d174a701$export$d087d3878fdf71d5 = [
    $935fc775d174a701$export$421679a7c3d56e,
    $935fc775d174a701$export$aafa59e2e03f2942,
    $935fc775d174a701$export$6964f6c886723980,
    $935fc775d174a701$export$c65e99957a05207c,
    $935fc775d174a701$export$f22da7240b7add18,
    $935fc775d174a701$export$bab79516f2d662fe,
    $935fc775d174a701$export$8d4d2d70e7d46032,
    $935fc775d174a701$export$68d8715fc104d294,
    $935fc775d174a701$export$70a6e5159acce2e6
];

});


parcelRegister("fpGJi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38a560ae2aba370$export$2e2bcd8739ae039; });
function $b38a560ae2aba370$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("denPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a1f11b45d19c31c$export$2e2bcd8739ae039; });
function $9a1f11b45d19c31c$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4lgUV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32963efecfbdcf1b$export$2e2bcd8739ae039; });

var $evuM1 = parcelRequire("evuM1");
var $32963efecfbdcf1b$var$passive = {
    passive: true
};
function $32963efecfbdcf1b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $evuM1.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $32963efecfbdcf1b$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $32963efecfbdcf1b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $32963efecfbdcf1b$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $32963efecfbdcf1b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $32963efecfbdcf1b$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $32963efecfbdcf1b$var$effect,
    data: {}
};

});

parcelRegister("gRJJt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47512190f76bfe8$export$2e2bcd8739ae039; });

var $hIWTg = parcelRequire("hIWTg");
function $c47512190f76bfe8$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $hIWTg.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c47512190f76bfe8$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $c47512190f76bfe8$var$popperOffsets,
    data: {}
};

});
parcelRegister("hIWTg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce743a1cd1b9113a$export$2e2bcd8739ae039; });

var $fhJPe = parcelRequire("fhJPe");

var $kBqs9 = parcelRequire("kBqs9");

var $2yFjn = parcelRequire("2yFjn");

var $cEt57 = parcelRequire("cEt57");
function $ce743a1cd1b9113a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $fhJPe.default)(placement) : null;
    var variation = placement ? (0, $kBqs9.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cEt57.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cEt57.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cEt57.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cEt57.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2yFjn.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $cEt57.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cEt57.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("fhJPe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20bfd79a0cf82b6$export$2e2bcd8739ae039; });

function $b20bfd79a0cf82b6$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("kBqs9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $effbc860a2f87ec0$export$2e2bcd8739ae039; });
function $effbc860a2f87ec0$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("2yFjn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dcecd5a1994cdcc$export$2e2bcd8739ae039; });
function $1dcecd5a1994cdcc$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("wSJDI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $062d72874f6ff229$export$2e2bcd8739ae039; });

var $cEt57 = parcelRequire("cEt57");

var $b3S5p = parcelRequire("b3S5p");

var $evuM1 = parcelRequire("evuM1");

var $hwwQ1 = parcelRequire("hwwQ1");

var $l05Oo = parcelRequire("l05Oo");

var $fhJPe = parcelRequire("fhJPe");

var $kBqs9 = parcelRequire("kBqs9");

var $9TYtw = parcelRequire("9TYtw");
var $062d72874f6ff229$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $062d72874f6ff229$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9TYtw.round)(x * dpr) / dpr || 0,
        y: (0, $9TYtw.round)(y * dpr) / dpr || 0
    };
}
function $062d72874f6ff229$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $cEt57.left);
    var sideY = (0, $cEt57.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $b3S5p.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $evuM1.default)(popper)) {
            offsetParent = (0, $hwwQ1.default)(popper);
            if ((0, $l05Oo.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cEt57.top) || (placement === (0, $cEt57.left) || placement === (0, $cEt57.right)) && variation === (0, $cEt57.end)) {
            sideY = (0, $cEt57.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cEt57.left) || (placement === (0, $cEt57.top) || placement === (0, $cEt57.bottom)) && variation === (0, $cEt57.end)) {
            sideX = (0, $cEt57.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $062d72874f6ff229$var$unsetSides);
    var _ref4 = roundOffsets === true ? $062d72874f6ff229$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $evuM1.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $062d72874f6ff229$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $fhJPe.default)(state.placement),
        variation: (0, $kBqs9.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $062d72874f6ff229$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $062d72874f6ff229$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $062d72874f6ff229$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $062d72874f6ff229$var$computeStyles,
    data: {}
};

});

parcelRegister("bjiGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83bff5e318dc83f7$export$2e2bcd8739ae039; });

var $BRjpD = parcelRequire("BRjpD");

var $iJd9x = parcelRequire("iJd9x");
// and applies them to the HTMLElements such as popper and arrow
function $83bff5e318dc83f7$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $iJd9x.isHTMLElement)(element) || !(0, $BRjpD.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83bff5e318dc83f7$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $iJd9x.isHTMLElement)(element) || !(0, $BRjpD.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83bff5e318dc83f7$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83bff5e318dc83f7$var$applyStyles,
    effect: $83bff5e318dc83f7$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("dGIOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f71f6f5da7fe299$export$2e2bcd8739ae039; });

var $fhJPe = parcelRequire("fhJPe");

var $cEt57 = parcelRequire("cEt57");
function $9f71f6f5da7fe299$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $fhJPe.default)(placement);
    var invertDistance = [
        (0, $cEt57.left),
        (0, $cEt57.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cEt57.left),
        (0, $cEt57.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $9f71f6f5da7fe299$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cEt57.placements).reduce(function(acc, placement) {
        acc[placement] = $9f71f6f5da7fe299$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9f71f6f5da7fe299$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $9f71f6f5da7fe299$var$offset
};

});

parcelRegister("3q4qi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d73b28f4194591$export$2e2bcd8739ae039; });

var $3vS09 = parcelRequire("3vS09");

var $fhJPe = parcelRequire("fhJPe");

var $3WJFN = parcelRequire("3WJFN");

var $1rI0f = parcelRequire("1rI0f");

var $aylaC = parcelRequire("aylaC");

var $cEt57 = parcelRequire("cEt57");

var $kBqs9 = parcelRequire("kBqs9");
function $27d73b28f4194591$var$getExpandedFallbackPlacements(placement) {
    if ((0, $fhJPe.default)(placement) === (0, $cEt57.auto)) return [];
    var oppositePlacement = (0, $3vS09.default)(placement);
    return [
        (0, $3WJFN.default)(placement),
        oppositePlacement,
        (0, $3WJFN.default)(oppositePlacement)
    ];
}
function $27d73b28f4194591$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $fhJPe.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3vS09.default)(preferredPlacement)
    ] : $27d73b28f4194591$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $fhJPe.default)(placement) === (0, $cEt57.auto) ? (0, $aylaC.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $fhJPe.default)(placement);
        var isStartVariation = (0, $kBqs9.default)(placement) === (0, $cEt57.start);
        var isVertical = [
            (0, $cEt57.top),
            (0, $cEt57.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $1rI0f.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cEt57.right) : (0, $cEt57.left) : isStartVariation ? (0, $cEt57.bottom) : (0, $cEt57.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3vS09.default)(mainVariationSide);
        var altVariationSide = (0, $3vS09.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $27d73b28f4194591$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $27d73b28f4194591$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3vS09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ee27ea9e5c3cb9$export$2e2bcd8739ae039; });
var $28ee27ea9e5c3cb9$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $28ee27ea9e5c3cb9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $28ee27ea9e5c3cb9$var$hash[matched];
    });
}

});

parcelRegister("3WJFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dfa3795dd17aed2$export$2e2bcd8739ae039; });
var $2dfa3795dd17aed2$var$hash = {
    start: "end",
    end: "start"
};
function $2dfa3795dd17aed2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2dfa3795dd17aed2$var$hash[matched];
    });
}

});

parcelRegister("1rI0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10da722804e5a48b$export$2e2bcd8739ae039; });

var $fD0vo = parcelRequire("fD0vo");

var $hwwQ1 = parcelRequire("hwwQ1");

var $8LvIw = parcelRequire("8LvIw");

var $hIWTg = parcelRequire("hIWTg");

var $7f072 = parcelRequire("7f072");

var $cEt57 = parcelRequire("cEt57");

var $iJd9x = parcelRequire("iJd9x");

var $fTJdU = parcelRequire("fTJdU");

var $ezhkO = parcelRequire("ezhkO");
function $10da722804e5a48b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cEt57.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cEt57.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cEt57.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $fTJdU.default)(typeof padding !== "number" ? padding : (0, $ezhkO.default)(padding, (0, $cEt57.basePlacements)));
    var altContext = elementContext === (0, $cEt57.popper) ? (0, $cEt57.reference) : (0, $cEt57.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $fD0vo.default)((0, $iJd9x.isElement)(element) ? element : element.contextElement || (0, $hwwQ1.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8LvIw.default)(state.elements.reference);
    var popperOffsets = (0, $hIWTg.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $7f072.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cEt57.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cEt57.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cEt57.right),
                (0, $cEt57.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cEt57.top),
                (0, $cEt57.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("fD0vo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02efa8d64626d255$export$2e2bcd8739ae039; });

var $cEt57 = parcelRequire("cEt57");

var $9wRKf = parcelRequire("9wRKf");

var $2hl6D = parcelRequire("2hl6D");

var $1HuQs = parcelRequire("1HuQs");

var $b3S5p = parcelRequire("b3S5p");

var $hwwQ1 = parcelRequire("hwwQ1");

var $l05Oo = parcelRequire("l05Oo");

var $iJd9x = parcelRequire("iJd9x");

var $8LvIw = parcelRequire("8LvIw");

var $gCrM2 = parcelRequire("gCrM2");

var $6qjxc = parcelRequire("6qjxc");

var $BRjpD = parcelRequire("BRjpD");

var $7f072 = parcelRequire("7f072");

var $9TYtw = parcelRequire("9TYtw");
function $02efa8d64626d255$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8LvIw.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $02efa8d64626d255$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cEt57.viewport) ? (0, $7f072.default)((0, $9wRKf.default)(element, strategy)) : (0, $iJd9x.isElement)(clippingParent) ? $02efa8d64626d255$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $7f072.default)((0, $2hl6D.default)((0, $hwwQ1.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $02efa8d64626d255$var$getClippingParents(element) {
    var clippingParents = (0, $1HuQs.default)((0, $gCrM2.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $l05Oo.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $iJd9x.isHTMLElement)(element) ? (0, $b3S5p.default)(element) : element;
    if (!(0, $iJd9x.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $iJd9x.isElement)(clippingParent) && (0, $6qjxc.default)(clippingParent, clipperElement) && (0, $BRjpD.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $02efa8d64626d255$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $02efa8d64626d255$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $02efa8d64626d255$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9TYtw.max)(rect.top, accRect.top);
        accRect.right = (0, $9TYtw.min)(rect.right, accRect.right);
        accRect.bottom = (0, $9TYtw.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9TYtw.max)(rect.left, accRect.left);
        return accRect;
    }, $02efa8d64626d255$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9wRKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f00cad275d5630b$export$2e2bcd8739ae039; });

var $evuM1 = parcelRequire("evuM1");

var $hwwQ1 = parcelRequire("hwwQ1");

var $ixenM = parcelRequire("ixenM");

var $bAuwd = parcelRequire("bAuwd");
function $6f00cad275d5630b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $evuM1.default)(element);
    var html = (0, $hwwQ1.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bAuwd.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $ixenM.default)(element),
        y: y
    };
}

});

parcelRegister("2hl6D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a8d8a89d28f45b7$export$2e2bcd8739ae039; });

var $hwwQ1 = parcelRequire("hwwQ1");

var $l05Oo = parcelRequire("l05Oo");

var $ixenM = parcelRequire("ixenM");

var $gFmww = parcelRequire("gFmww");

var $9TYtw = parcelRequire("9TYtw");
function $1a8d8a89d28f45b7$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $hwwQ1.default)(element);
    var winScroll = (0, $gFmww.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9TYtw.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9TYtw.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $ixenM.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $l05Oo.default)(body || html).direction === "rtl") x += (0, $9TYtw.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("6qjxc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ad452f3202b0bc8$export$2e2bcd8739ae039; });

var $iJd9x = parcelRequire("iJd9x");
function $4ad452f3202b0bc8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $iJd9x.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("7f072", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $545a057ae1cb203e$export$2e2bcd8739ae039; });
function $545a057ae1cb203e$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fTJdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92f1280b7118916$export$2e2bcd8739ae039; });

var $8Cj7J = parcelRequire("8Cj7J");
function $b92f1280b7118916$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8Cj7J.default)(), paddingObject);
}

});
parcelRegister("8Cj7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6460b4ead0526081$export$2e2bcd8739ae039; });
function $6460b4ead0526081$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("ezhkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9b1c7e01a550400$export$2e2bcd8739ae039; });
function $a9b1c7e01a550400$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("aylaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aed804f078855f3$export$2e2bcd8739ae039; });

var $kBqs9 = parcelRequire("kBqs9");

var $cEt57 = parcelRequire("cEt57");

var $1rI0f = parcelRequire("1rI0f");

var $fhJPe = parcelRequire("fhJPe");
function $7aed804f078855f3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cEt57.placements) : _options$allowedAutoP;
    var variation = (0, $kBqs9.default)(placement);
    var placements = variation ? flipVariations ? (0, $cEt57.variationPlacements) : (0, $cEt57.variationPlacements).filter(function(placement) {
        return (0, $kBqs9.default)(placement) === variation;
    }) : (0, $cEt57.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $1rI0f.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $fhJPe.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("g2Ojy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae3dc9cc0a44a5a$export$2e2bcd8739ae039; });

var $cEt57 = parcelRequire("cEt57");

var $fhJPe = parcelRequire("fhJPe");

var $2yFjn = parcelRequire("2yFjn");

var $6Jl9F = parcelRequire("6Jl9F");

var $fQ2la = parcelRequire("fQ2la");

var $aLUir = parcelRequire("aLUir");

var $b3S5p = parcelRequire("b3S5p");

var $1rI0f = parcelRequire("1rI0f");

var $kBqs9 = parcelRequire("kBqs9");

var $8Cj7J = parcelRequire("8Cj7J");

var $9TYtw = parcelRequire("9TYtw");
function $bae3dc9cc0a44a5a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $1rI0f.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $fhJPe.default)(state.placement);
    var variation = (0, $kBqs9.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2yFjn.default)(basePlacement);
    var altAxis = (0, $6Jl9F.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $cEt57.top) : (0, $cEt57.left);
        var altSide = mainAxis === "y" ? (0, $cEt57.bottom) : (0, $cEt57.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cEt57.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cEt57.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $aLUir.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8Cj7J.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fQ2la.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $b3S5p.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fQ2la.within)(tether ? (0, $9TYtw.min)(min, tetherMin) : min, offset, tether ? (0, $9TYtw.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $cEt57.top) : (0, $cEt57.left);
        var _altSide = mainAxis === "x" ? (0, $cEt57.bottom) : (0, $cEt57.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cEt57.top),
            (0, $cEt57.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fQ2la.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fQ2la.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bae3dc9cc0a44a5a$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $bae3dc9cc0a44a5a$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("6Jl9F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e675af33304bab1$export$2e2bcd8739ae039; });
function $4e675af33304bab1$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("fQ2la", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $b87d871e6dbe3990$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $b87d871e6dbe3990$export$86c8af6d3ef0b4a; });

var $9TYtw = parcelRequire("9TYtw");
function $b87d871e6dbe3990$export$f28d906d67a997f3(min, value, max) {
    return (0, $9TYtw.max)(min, (0, $9TYtw.min)(value, max));
}
function $b87d871e6dbe3990$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b87d871e6dbe3990$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("1VNHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1681aa77aa2d63e1$export$2e2bcd8739ae039; });

var $fhJPe = parcelRequire("fhJPe");

var $aLUir = parcelRequire("aLUir");

var $6qjxc = parcelRequire("6qjxc");

var $b3S5p = parcelRequire("b3S5p");

var $2yFjn = parcelRequire("2yFjn");

var $fQ2la = parcelRequire("fQ2la");

var $fTJdU = parcelRequire("fTJdU");

var $ezhkO = parcelRequire("ezhkO");

var $cEt57 = parcelRequire("cEt57");
var $1681aa77aa2d63e1$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $fTJdU.default)(typeof padding !== "number" ? padding : (0, $ezhkO.default)(padding, (0, $cEt57.basePlacements)));
};
function $1681aa77aa2d63e1$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $fhJPe.default)(state.placement);
    var axis = (0, $2yFjn.default)(basePlacement);
    var isVertical = [
        (0, $cEt57.left),
        (0, $cEt57.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1681aa77aa2d63e1$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $aLUir.default)(arrowElement);
    var minProp = axis === "y" ? (0, $cEt57.top) : (0, $cEt57.left);
    var maxProp = axis === "y" ? (0, $cEt57.bottom) : (0, $cEt57.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $b3S5p.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fQ2la.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1681aa77aa2d63e1$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $6qjxc.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1681aa77aa2d63e1$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1681aa77aa2d63e1$var$arrow,
    effect: $1681aa77aa2d63e1$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("6MUg0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f12dd4248768e69$export$2e2bcd8739ae039; });

var $cEt57 = parcelRequire("cEt57");

var $1rI0f = parcelRequire("1rI0f");
function $4f12dd4248768e69$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $4f12dd4248768e69$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cEt57.top),
        (0, $cEt57.right),
        (0, $cEt57.bottom),
        (0, $cEt57.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $4f12dd4248768e69$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $1rI0f.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $1rI0f.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $4f12dd4248768e69$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $4f12dd4248768e69$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $4f12dd4248768e69$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $4f12dd4248768e69$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $4f12dd4248768e69$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $4f12dd4248768e69$var$hide
};

});


parcelRegister("iI3vX", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", function () { return $d9ef0ff469b10e0c$export$1b69b6cd0fa638a1; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $d9ef0ff469b10e0c$export$1b69b6cd0fa638a1(slot) {
    return (0, $5xHgF.default)("MuiPopper", slot);
}
const $d9ef0ff469b10e0c$var$popperClasses = (0, $eFHYA.default)("MuiPopper", [
    "root"
]);
var $d9ef0ff469b10e0c$export$2e2bcd8739ae039 = $d9ef0ff469b10e0c$var$popperClasses;

});



parcelRegister("gW4C7", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", function () { return $c545a4502cb1de59$export$837848f5f6cee923; });
$parcel$export(module.exports, "default", function () { return $c545a4502cb1de59$export$2e2bcd8739ae039; });

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $c545a4502cb1de59$export$837848f5f6cee923(slot) {
    return (0, $5xHgF.default)("MuiTooltip", slot);
}
const $c545a4502cb1de59$var$tooltipClasses = (0, $eFHYA.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $c545a4502cb1de59$export$2e2bcd8739ae039 = $c545a4502cb1de59$var$tooltipClasses;

});




parcelRegister("mtiuV", function(module, exports) {

$parcel$export(module.exports, "useNotifications", function () { return $0438c80862157490$export$53d5ca6c3f53e109; });

var $dgG1Y = parcelRequire("dgG1Y");

var $ewdxp = parcelRequire("ewdxp");

var $56aO2 = parcelRequire("56aO2");
const $0438c80862157490$export$53d5ca6c3f53e109 = ()=>{
    const [notifications, setNotifications] = (0, $dgG1Y.useState)([]);
    const [renderCount, setRenderCount] = (0, $dgG1Y.useState)(0); //hack to force re-render when notification read. 
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const [filterByARS, setFilterByARS] = (0, $dgG1Y.useState)([]); //for ARS filter
    const [arsUser, setARSUser] = (0, $dgG1Y.useState)(0); //for ARS filter
    (0, $dgG1Y.useEffect)(()=>{
        //get users for tenant
        const getNotifications = async ()=>{
            try {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/notification/getNotifications", "GET", null, {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData) setNotifications(responseData);
            } catch (err) {}
        };
        const getNotificationsByUser = async ()=>{
            try {
                const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/notification/getNotificationsByUser", "POST", JSON.stringify({
                    NotifiedUser: arsUser
                }), {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth.token
                });
                if (responseData) setNotifications(responseData);
            } catch (err) {}
        };
        if (!arsUser) getNotifications();
        if (arsUser) getNotificationsByUser();
    }, [
        renderCount,
        arsUser
    ]);
    const reRender = async ()=>{
        let count = renderCount;
        count++;
        setRenderCount(count);
    };
    const handleSetArsUser = (event)=>{
        event.preventDefault();
        let value = event.target.value;
        setARSUser(value);
        let count = renderCount;
        count++;
        setRenderCount(count);
    };
    (0, $dgG1Y.useEffect)(()=>{
        //get permission level for protected subpages.
        const getARS = async ()=>{
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/accountable/adminusersfilter", "GET", null, {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token
            });
            if (responseData) setFilterByARS(responseData);
        };
        if (auth.accountableAdmin) getARS();
    }, [
        auth.accountableAdmin
    ]);
    return {
        notifications: notifications,
        reRender: reRender,
        auth: auth,
        isLoading: isLoading,
        error: error,
        clearError: clearError,
        filterByARS: filterByARS,
        setFilterByARS: setFilterByARS,
        handleSetArsUser: handleSetArsUser,
        arsUser: arsUser,
        setARSUser: setARSUser
    };
};

});

parcelRegister("bMqk9", function(module, exports) {

$parcel$export(module.exports, "Facebook", function () { return (parcelRequire("4mku7")).default; });
$parcel$export(module.exports, "Google", function () { return (parcelRequire("cDM9n")).default; });
$parcel$export(module.exports, "Apple", function () { return (parcelRequire("ierCi")).default; });

var $4mku7 = parcelRequire("4mku7");

var $cDM9n = parcelRequire("cDM9n");

var $ierCi = parcelRequire("ierCi");

});
parcelRegister("4mku7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32c91b5d5b030765$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $4j6wO = parcelRequire("4j6wO");
function $32c91b5d5b030765$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4j6wO.default), {
        ...props,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
            d: "M9.53144612,22.005 L9.53144612,13.0552149 L6.44166667,13.0552149 L6.44166667,9.49875 L9.53144612,9.49875 L9.53144612,6.68484375 C9.53144612,5.19972656 9.95946769,4.04680661 10.8155103,3.22608401 C11.6715529,2.4053613 12.808485,1.995 14.2263057,1.995 C15.3766134,1.995 16.3129099,2.04710915 17.0351961,2.15132812 L17.0351961,5.3169726 L15.1090998,5.3169726 C14.3868137,5.3169726 13.8919142,5.47330073 13.6244006,5.78595698 C13.4103902,6.04650407 13.3033846,6.46337874 13.3033846,7.03658198 L13.3033846,9.49875 L16.71418,9.49875 L16.2326559,13.0552149 L13.3033846,13.0552149 L13.3033846,22.005 L9.53144612,22.005 Z"
        })
    });
}

});

parcelRegister("cDM9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $933e7a2db7db1773$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $4j6wO = parcelRequire("4j6wO");
function $933e7a2db7db1773$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4j6wO.default), {
        ...props,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
            d: "M21,12.2177419 C21,13.9112905 20.6311475,15.4233869 19.8934426,16.7540323 C19.1557377,18.0846776 18.1168031,19.1249998 16.7766393,19.875 C15.4364756,20.6250002 13.8934424,21 12.147541,21 C10.4999998,21 8.97540984,20.5947579 7.57377049,19.7842742 C6.17213115,18.9737905 5.05942604,17.8790323 4.23565574,16.5 C3.41188543,15.1209677 3,13.6209679 3,12 C3,10.3790321 3.41188543,8.87903226 4.23565574,7.5 C5.05942604,6.12096774 6.17213115,5.02620949 7.57377049,4.21572581 C8.97540984,3.40524212 10.4999998,3 12.147541,3 C14.5327871,3 16.5737705,3.78629051 18.2704918,5.35887097 L15.7991803,7.71774194 C15.0122953,6.96774175 14.0655738,6.52016129 12.9590164,6.375 C11.9262295,6.22983871 10.9057375,6.375 9.89754098,6.81048387 C8.88934445,7.24596774 8.07786904,7.89919355 7.46311475,8.77016129 C6.79918033,9.71370968 6.46721311,10.7903228 6.46721311,12 C6.46721311,13.0403228 6.72540984,13.9899192 7.24180328,14.8487903 C7.75819672,15.7076615 8.4467215,16.3971776 9.30737705,16.9173387 C10.1680326,17.4374998 11.1147541,17.6975806 12.147541,17.6975806 C13.2540984,17.6975806 14.2254096,17.455645 15.0614754,16.9717742 C15.7254098,16.5846772 16.2786885,16.0645161 16.7213115,15.4112903 C17.0409838,14.8790321 17.2499998,14.3467744 17.3483607,13.8145161 L12.147541,13.8145161 L12.147541,10.6935484 L20.852459,10.6935484 C20.9508199,11.2258066 21,11.7338712 21,12.2177419 Z"
        })
    });
}

});

parcelRegister("ierCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d45ef4e69d279b48$export$2e2bcd8739ae039; });

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $4j6wO = parcelRequire("4j6wO");
function $d45ef4e69d279b48$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4j6wO.default), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
                d: "M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282z"
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
                d: "M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282z"
            })
        ]
    });
}

});


parcelRegister("a4HP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $755c452ea783301a$export$2e2bcd8739ae039; });

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $bdWPY = parcelRequire("bdWPY");

var $7xfqK = parcelRequire("7xfqK");


var $h9piZ = parcelRequire("h9piZ");

var $arbQ3 = parcelRequire("arbQ3");

var $1QHfa = parcelRequire("1QHfa");
var $755c452ea783301a$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: "none"
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: "underline"
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$focusVisible": {
            outline: "auto"
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $755c452ea783301a$var$Link = /*#__PURE__*/ $dgG1Y.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "a" : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? "hover" : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? "inherit" : _props$variant, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $h9piZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $dgG1Y.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $arbQ3.default)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $dgG1Y.createElement((0, $1QHfa.default), (0, $bh1oa.default)({
        className: (0, $cXVHi.default)(classes.root, classes["underline".concat((0, $bdWPY.default)(underline))], className, focusVisible && classes.focusVisible, component === "button" && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $755c452ea783301a$export$2e2bcd8739ae039 = (0, $7xfqK.default)($755c452ea783301a$export$9dd6ff9ea0189349, {
    name: "MuiLink"
})($755c452ea783301a$var$Link);

});

parcelRegister("fuS1D", function(module, exports) {

$parcel$export(module.exports, "useConfirmEmail", function () { return $bbd40cff20da7cf5$export$3a088df1749310c7; });

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("kunpB");
var $fOZMN = parcelRequire("fOZMN");
var $kunpB = parcelRequire("kunpB");

var $56aO2 = parcelRequire("56aO2");
const $bbd40cff20da7cf5$export$3a088df1749310c7 = ()=>{
    const { sendRequest: sendRequest } = (0, $56aO2.useHttpClient)();
    const [confirmEmail, setConfirmEmail] = (0, $dgG1Y.useState)();
    const [emailConfirmed, setEmailConfirmed] = (0, $dgG1Y.useState)(false);
    const [searchParams] = (0, $kunpB.useSearchParams)();
    const navigate = (0, $fOZMN.useNavigate)();
    const key = searchParams.get("key");
    (0, $dgG1Y.useEffect)(()=>{
        if (key && !emailConfirmed) {
            setConfirmEmail("Thank you for confirming your email");
            const verifyEmail = async ()=>{
                try {
                    const responseData = await sendRequest(`${"https://apiv2.youareaccountable.com"}/api/users/confirm?key=${key}`);
                    if (responseData.valid) {
                        setEmailConfirmed(true);
                        // Remove the 'key' query parameter from the URL
                        navigate("", {
                            replace: true
                        });
                    } else setConfirmEmail("Error Confirming Email. Please Try Again Later");
                } catch (error) {
                    setConfirmEmail("Error Confirming Email. Please Try Again Later");
                }
            };
            verifyEmail();
        }
    }, [
        key,
        emailConfirmed,
        sendRequest,
        navigate
    ]);
    const clearConfirmEmail = ()=>{
        setConfirmEmail(undefined);
    };
    return {
        confirmEmail: confirmEmail,
        clearConfirmEmail: clearConfirmEmail
    };
};

});

parcelRegister("45PbL", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("hmpyV"))((parcelRequire("7W7bw")).resolve("54ob7")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("9CvPE")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("72K8J")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("79tue")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("hQiLa")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("g5u4T")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5Yi04")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5chF0")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("lyrrG")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("aKvWu")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("54GgZ"))
]).then(()=>parcelRequire("dxKe9"));

});
parcelRegister("hmpyV", function(module, exports) {
"use strict";

var $l1oaD = parcelRequire("l1oaD");
module.exports = $l1oaD(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("l1oaD", function(module, exports) {
"use strict";
var $f4dc70b5fe45fee1$var$cachedBundles = {};
var $f4dc70b5fe45fee1$var$cachedPreloads = {};
var $f4dc70b5fe45fee1$var$cachedPrefetches = {};
function $f4dc70b5fe45fee1$var$getCache(type) {
    switch(type){
        case "preload":
            return $f4dc70b5fe45fee1$var$cachedPreloads;
        case "prefetch":
            return $f4dc70b5fe45fee1$var$cachedPrefetches;
        default:
            return $f4dc70b5fe45fee1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f4dc70b5fe45fee1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("f6wNG", function(module, exports) {
"use strict";

var $l1oaD = parcelRequire("l1oaD");
module.exports = $l1oaD(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});


parcelRegister("7Yk0H", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("lTXro")).then(()=>parcelRequire("30tdO"));

});

parcelRegister("5ITwD", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("67NFA")).then(()=>parcelRequire("63oVK"));

});

parcelRegister("1CSMF", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("hmpyV"))((parcelRequire("7W7bw")).resolve("8m87i")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("72K8J")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("lFgtU")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("aKvWu")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("gLtuz"))
]).then(()=>parcelRequire("3Sqc3"));

});

parcelRegister("fDNgw", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("gEXPU")).then(()=>parcelRequire("7tUWO"));

});

parcelRegister("cbMg5", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("72K8J")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("79tue")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("hQiLa")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("g5u4T")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5Yi04")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5chF0")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("lyrrG"))
]).then(()=>parcelRequire("aRwjb"));

});

parcelRegister("eVXD0", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("9CvPE")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5Yi04")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("jiNF5"))
]).then(()=>parcelRequire("2pFiX"));

});

parcelRegister("5OcDX", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("72K8J")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("lFgtU"))
]).then(()=>parcelRequire("gsDyv"));

});

parcelRegister("9T8C5", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("kPbGZ")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("79tue")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("hQiLa")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("g5u4T")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("hM2Pl"))
]).then(()=>parcelRequire("fbTOf"));

});

parcelRegister("5QJam", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("eAt9X")).then(()=>parcelRequire("gYAgq"));

});

parcelRegister("7TO1B", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5a4RI")).then(()=>parcelRequire("knC6C"));

});

parcelRegister("jspsi", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("ksnUq")).then(()=>parcelRequire("egb6E"));

});

parcelRegister("3tbI5", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("loMb7")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("kJDPT"))
]).then(()=>parcelRequire("gF1BD"));

});

parcelRegister("7bwNy", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("loMb7")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("2lgxZ"))
]).then(()=>parcelRequire("ipn3a"));

});

parcelRegister("gLUEm", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("hmpyV"))((parcelRequire("7W7bw")).resolve("hF5Sq")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5Yi04")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5chF0")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("kppjH"))
]).then(()=>parcelRequire("fVKEk"));

});

parcelRegister("6C0yF", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("9CvPE")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5Yi04")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("4dVtE"))
]).then(()=>parcelRequire("aB4R8"));

});

parcelRegister("1ltvV", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("acrmT")).then(()=>parcelRequire("hTcRt"));

});

parcelRegister("4Ib4t", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("EsGK6")).then(()=>parcelRequire("i2OFL"));

});

parcelRegister("hcMFO", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("azyi6")).then(()=>parcelRequire("6odAU"));

});

parcelRegister("bMRRC", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("iGyoW"))
]).then(()=>parcelRequire("8lJ6K"));

});

parcelRegister("4xPO8", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("g5u4T")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("dQuDR"))
]).then(()=>parcelRequire("9XxdK"));

});

parcelRegister("eX4Zf", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("iqnQF")).then(()=>parcelRequire("ag9Gt"));

});

parcelRegister("f1Bja", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("19ls8")).then(()=>parcelRequire("66LO7"));

});

parcelRegister("5wi4l", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("hmpyV"))((parcelRequire("7W7bw")).resolve("8ZIKZ")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5JENV"))
]).then(()=>parcelRequire("kdkf8"));

});

parcelRegister("jz3ab", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("9aD4S")).then(()=>parcelRequire("dkXyk"));

});

parcelRegister("9Ydz5", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("6kdDO"))
]).then(()=>parcelRequire("9HPb2"));

});

parcelRegister("7SSu2", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5Yi04")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("5chF0")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("3iAS4"))
]).then(()=>parcelRequire("4ws12"));

});

parcelRegister("4wfaV", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("bgeSU")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("lS3N7"))
]).then(()=>parcelRequire("kvJfo"));

});

parcelRegister("j15ZB", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("kPbGZ")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("guIZ0"))
]).then(()=>parcelRequire("lDAH2"));

});

parcelRegister("iYVvJ", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("hmpyV"))((parcelRequire("7W7bw")).resolve("x2zXx")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("bgeSU")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("bVwVa"))
]).then(()=>parcelRequire("k7cAM"));

});

parcelRegister("f4xh9", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("4gbg6"))
]).then(()=>parcelRequire("lXBhD"));

});

parcelRegister("lPfTI", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("cI5ef"))
]).then(()=>parcelRequire("4bBye"));

});

parcelRegister("5AaYp", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("bIq4o"))
]).then(()=>parcelRequire("aWUiR"));

});

parcelRegister("kIkGf", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("kIzHh"))
]).then(()=>parcelRequire("eYGXo"));

});

parcelRegister("kgMqx", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("79tue")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("fXbdF"))
]).then(()=>parcelRequire("luaXX"));

});

parcelRegister("5xXPk", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("bgeSU")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("i6vnR"))
]).then(()=>parcelRequire("IJr66"));

});

parcelRegister("5CH0J", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("2SnMc")).then(()=>parcelRequire("9zYbL"));

});

parcelRegister("iQxUW", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("50oJf")),
    (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("23MBL"))
]).then(()=>parcelRequire("dtYT7"));

});

parcelRegister("eyjni", function(module, exports) {


module.exports = (parcelRequire("f6wNG"))((parcelRequire("7W7bw")).resolve("dIRBQ")).then(()=>parcelRequire("7JkP5"));

});

parcelRegister("byHow", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("dgG1Y")));
})(module.exports, function(exports1, React) {
    "use strict";
    React = React && Object.prototype.hasOwnProperty.call(React, "default") ? React["default"] : React;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    var ReactPropTypesSecret_1 = ReactPropTypesSecret;
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    var factoryWithThrowingShims = function() {
        function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret_1) // It is still safe when called from React.
            return;
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
        }
        shim.isRequired = shim;
        function getShim() {
            return shim;
        }
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    var propTypes = createCommonjsModule(function(module) {
        // By explicitly using `prop-types` you are opting into new production behavior.
        // http://fb.me/prop-types-in-prod
        module.exports = factoryWithThrowingShims();
    });
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(INVALID_STRIPE_ERROR);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(validateStripe)
        };
        var stripe = validateStripe(raw);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    var CartElementContext = /*#__PURE__*/ React.createContext(null);
    CartElementContext.displayName = "CartElementContext";
    var parseCartElementContext = function parseCartElementContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), cart = _React$useState2[0], setCart = _React$useState2[1];
        var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), cartState = _React$useState4[0], setCartState = _React$useState4[1]; // For a sync stripe instance, initialize into context
        var _React$useState5 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState6 = _slicedToArray(_React$useState5, 2), ctx = _React$useState6[0], setContext = _React$useState6[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            var anyStripe = ctx.stripe;
            if (!anyStripe || !anyStripe._registerWrapper || !anyStripe.registerAppInfo) return;
            anyStripe._registerWrapper({
                name: "react-stripe-js",
                version: "1.16.5"
            });
            anyStripe.registerAppInfo({
                name: "react-stripe-js",
                version: "1.16.5",
                url: "https://stripe.com/docs/stripe-js/react"
            });
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CartElementContext.Provider, {
            value: {
                cart: cart,
                setCart: setCart,
                cartState: cartState,
                setCartState: setCartState
            }
        }, children));
    };
    Elements.propTypes = {
        stripe: propTypes.any,
        options: propTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    var useCartElementContextWithUseCase = function useCartElementContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(CartElementContext);
        return parseCartElementContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsContextWi2 = useElementsContextWithUseCase("calls useStripe()"), stripe = _useElementsContextWi2.stripe;
        return stripe;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElement = function useCartElement() {
        var _useCartElementContex = useCartElementContextWithUseCase("calls useCartElement()"), cart = _useCartElementContex.cart;
        return cart;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElementState = function useCartElementState() {
        var _useCartElementContex2 = useCartElementContextWithUseCase("calls useCartElementState()"), cartState = _useCartElementContex2.cartState;
        return cartState;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: propTypes.func.isRequired
    };
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onCheckout = _ref.onCheckout, onLineItemClick = _ref.onLineItemClick, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var _useElementsContextWi = useElementsContextWithUseCase("mounts <".concat(displayName, ">")), elements = _useElementsContextWi.elements;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null);
            var _useCartElementContex = useCartElementContextWithUseCase("mounts <".concat(displayName, ">")), setCart = _useCartElementContex.setCart, setCartState = _useCartElementContex.setCartState; // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "lineitemclick", onLineItemClick);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            var readyCallback;
            if (type === "cart") readyCallback = function readyCallback(event) {
                setCartState(event);
                onReady && onReady(event);
            };
            else if (onReady) {
                if (type === "payButton") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            var changeCallback = type === "cart" ? function(event) {
                setCartState(event);
                onChange && onChange(event);
            } : onChange;
            useAttachEvent(element, "change", changeCallback);
            var checkoutCallback = type === "cart" ? function(event) {
                setCartState(event);
                onCheckout && onCheckout(event);
            } : onCheckout;
            useAttachEvent(element, "checkout", checkoutCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && elements && domNode.current !== null) {
                    var newElement = elements.create(type, options);
                    if (type === "cart" && setCart) // we know that elements.create return value must be of type StripeCartElement if type is 'cart',
                    // we need to cast because typescript is not able to infer which overloaded method is used based off param type
                    setCart(newElement);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    newElement.mount(domNode.current);
                }
            }, [
                elements,
                options,
                setCart
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current) {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    }
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            // Validate that we are in the right context by calling useElementsContextWithUseCase.
            useElementsContextWithUseCase("mounts <".concat(displayName, ">"));
            useCartElementContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: propTypes.string,
            className: propTypes.string,
            onChange: propTypes.func,
            onBlur: propTypes.func,
            onFocus: propTypes.func,
            onReady: propTypes.func,
            onEscape: propTypes.func,
            onClick: propTypes.func,
            onLoadError: propTypes.func,
            onLoaderStart: propTypes.func,
            onNetworksChange: propTypes.func,
            onCheckout: propTypes.func,
            onLineItemClick: propTypes.func,
            onConfirm: propTypes.func,
            onCancel: propTypes.func,
            onShippingAddressChange: propTypes.func,
            onShippingRateChange: propTypes.func,
            options: propTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PayButtonElement = createElementComponent("payButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/elements/cart-element
   */ var CartElement = createElementComponent("cart", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CartElement = CartElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EpsBankElement = EpsBankElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PayButtonElement = PayButtonElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCartElement = useCartElement;
    exports1.useCartElementState = useCartElementState;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("kqmsT", function(module, exports) {

$parcel$export(module.exports, "PostHogProvider", function () { return $ede7a96dcf4e81d9$export$4d1dc63dbef5194f; });
$parcel$export(module.exports, "usePostHog", function () { return $ede7a96dcf4e81d9$export$ba1c575d7c165008; });

var $6Tdd1 = parcelRequire("6Tdd1");

var $dgG1Y = parcelRequire("dgG1Y");
var $ede7a96dcf4e81d9$export$ef76d7336c7309f5 = (0, $dgG1Y.createContext)({
    client: (0, $6Tdd1.default)
});
function $ede7a96dcf4e81d9$export$4d1dc63dbef5194f(_a) {
    var children = _a.children, client = _a.client, apiKey = _a.apiKey, options = _a.options;
    var posthog = (0, $dgG1Y.useMemo)(function() {
        if (client && apiKey) console.warn("[PostHog.js] You have provided both a client and an apiKey to PostHogProvider. The apiKey will be ignored in favour of the client.");
        if (client && options) console.warn("[PostHog.js] You have provided both a client and options to PostHogProvider. The options will be ignored in favour of the client.");
        if (client) return client;
        if (apiKey) {
            if ((0, $6Tdd1.default).__loaded) console.warn("[PostHog.js] was already loaded elsewhere. This may cause issues.");
            (0, $6Tdd1.default).init(apiKey, options);
        }
        return 0, $6Tdd1.default;
    }, [
        client,
        apiKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement($ede7a96dcf4e81d9$export$ef76d7336c7309f5.Provider, {
        value: {
            client: posthog
        }
    }, children);
}
var $ede7a96dcf4e81d9$export$ba1c575d7c165008 = function() {
    var client = (0, $dgG1Y.useContext)($ede7a96dcf4e81d9$export$ef76d7336c7309f5).client;
    return client;
};
function $ede7a96dcf4e81d9$export$e9beec7734875ebd(flag) {
    var client = $ede7a96dcf4e81d9$export$ba1c575d7c165008();
    var _a = (0, $dgG1Y.useState)(), featureEnabled = _a[0], setFeatureEnabled = _a[1];
    (0, $dgG1Y.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureEnabled(client.isFeatureEnabled(flag));
        });
    }, [
        client,
        flag
    ]);
    return featureEnabled;
}
function $ede7a96dcf4e81d9$export$21b3a717c06e8b6d(flag) {
    var client = $ede7a96dcf4e81d9$export$ba1c575d7c165008();
    var _a = (0, $dgG1Y.useState)(), featureFlagPayload = _a[0], setFeatureFlagPayload = _a[1];
    (0, $dgG1Y.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureFlagPayload(client.getFeatureFlagPayload(flag));
        });
    }, [
        client,
        flag
    ]);
    return featureFlagPayload;
}
function $ede7a96dcf4e81d9$export$31a96876dff98722() {
    var client = $ede7a96dcf4e81d9$export$ba1c575d7c165008();
    var _a = (0, $dgG1Y.useState)(), featureFlags = _a[0], setFeatureFlags = _a[1];
    (0, $dgG1Y.useEffect)(function() {
        return client.onFeatureFlags(function(flags) {
            setFeatureFlags(flags);
        });
    }, [
        client
    ]);
    return featureFlags;
}
function $ede7a96dcf4e81d9$export$446efd8c49462bdd(flag) {
    var client = $ede7a96dcf4e81d9$export$ba1c575d7c165008();
    var _a = (0, $dgG1Y.useState)(), featureFlagVariantKey = _a[0], setFeatureFlagVariantKey = _a[1];
    (0, $dgG1Y.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureFlagVariantKey(client.getFeatureFlag(flag));
        });
    }, [
        client,
        flag
    ]);
    return featureFlagVariantKey;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ede7a96dcf4e81d9$var$__assign = function() {
    $ede7a96dcf4e81d9$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ede7a96dcf4e81d9$var$__assign.apply(this, arguments);
};
function $ede7a96dcf4e81d9$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ede7a96dcf4e81d9$export$3d3d20183fb62861(_a) {
    var flag = _a.flag, match = _a.match, children = _a.children, fallback = _a.fallback, visibilityObserverOptions = _a.visibilityObserverOptions, trackInteraction = _a.trackInteraction, trackView = _a.trackView, props = $ede7a96dcf4e81d9$var$__rest(_a, [
        "flag",
        "match",
        "children",
        "fallback",
        "visibilityObserverOptions",
        "trackInteraction",
        "trackView"
    ]);
    var payload = $ede7a96dcf4e81d9$export$21b3a717c06e8b6d(flag);
    var variant = $ede7a96dcf4e81d9$export$446efd8c49462bdd(flag);
    var shouldTrackInteraction = trackInteraction !== null && trackInteraction !== void 0 ? trackInteraction : true;
    var shouldTrackView = trackView !== null && trackView !== void 0 ? trackView : true;
    if (match === undefined || variant === match) {
        var childNode = typeof children === "function" ? children(payload) : children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement($ede7a96dcf4e81d9$var$VisibilityAndClickTracker, $ede7a96dcf4e81d9$var$__assign({
            flag: flag,
            options: visibilityObserverOptions,
            trackInteraction: shouldTrackInteraction,
            trackView: shouldTrackView
        }, props), childNode);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).Fragment, null, fallback);
}
function $ede7a96dcf4e81d9$var$captureFeatureInteraction(flag, posthog) {
    var _a;
    posthog.capture("$feature_interaction", {
        feature_flag: flag,
        $set: (_a = {}, _a["$feature_interaction/".concat(flag)] = true, _a)
    });
}
function $ede7a96dcf4e81d9$var$captureFeatureView(flag, posthog) {
    posthog.capture("$feature_view", {
        feature_flag: flag
    });
}
function $ede7a96dcf4e81d9$var$VisibilityAndClickTracker(_a) {
    var flag = _a.flag, children = _a.children, trackInteraction = _a.trackInteraction, trackView = _a.trackView, options = _a.options, props = $ede7a96dcf4e81d9$var$__rest(_a, [
        "flag",
        "children",
        "trackInteraction",
        "trackView",
        "options"
    ]);
    var ref = (0, $dgG1Y.useRef)(null);
    var posthog = $ede7a96dcf4e81d9$export$ba1c575d7c165008();
    var visibilityTrackedRef = (0, $dgG1Y.useRef)(false);
    var clickTrackedRef = (0, $dgG1Y.useRef)(false);
    var cachedOnClick = (0, $dgG1Y.useCallback)(function() {
        if (!clickTrackedRef.current && trackInteraction) {
            $ede7a96dcf4e81d9$var$captureFeatureInteraction(flag, posthog);
            clickTrackedRef.current = true;
        }
    }, [
        flag,
        posthog,
        trackInteraction
    ]);
    (0, $dgG1Y.useEffect)(function() {
        if (ref.current === null || !trackView) return;
        var onIntersect = function(entry) {
            if (!visibilityTrackedRef.current && entry.isIntersecting) {
                $ede7a96dcf4e81d9$var$captureFeatureView(flag, posthog);
                visibilityTrackedRef.current = true;
            }
        };
        var observer = new IntersectionObserver(function(_a) {
            var entry = _a[0];
            return onIntersect(entry);
        }, $ede7a96dcf4e81d9$var$__assign({
            threshold: 0.1
        }, options));
        observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        flag,
        options,
        posthog,
        ref,
        trackView
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement("div", $ede7a96dcf4e81d9$var$__assign({
        ref: ref
    }, props, {
        onClick: cachedOnClick
    }), children);
}

});
parcelRegister("6Tdd1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $504220289e15410d$export$2e2bcd8739ae039; });
function $504220289e15410d$var$e(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
    }
    return n;
}
function $504220289e15410d$var$t(t) {
    for(var n = 1; n < arguments.length; n++){
        var i = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $504220289e15410d$var$e(Object(i), !0).forEach(function(e) {
            $504220289e15410d$var$o(t, e, i[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : $504220289e15410d$var$e(Object(i)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
        });
    }
    return t;
}
function $504220289e15410d$var$n(e) {
    return $504220289e15410d$var$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $504220289e15410d$var$n(e);
}
function $504220289e15410d$var$i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $504220289e15410d$var$r(e, t) {
    for(var n = 0; n < t.length; n++){
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
}
function $504220289e15410d$var$s(e, t, n) {
    return t && $504220289e15410d$var$r(e.prototype, t), n && $504220289e15410d$var$r(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $504220289e15410d$var$o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $504220289e15410d$var$a(e, t) {
    if (null == e) return {};
    var n, i, r = function(e, t) {
        if (null == e) return {};
        var n, i, r = {}, s = Object.keys(e);
        for(i = 0; i < s.length; i++)n = s[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(i = 0; i < s.length; i++)n = s[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
}
function $504220289e15410d$var$u(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == n) return;
        var i, r, s = [], o = !0, a = !1;
        try {
            for(n = n.call(e); !(o = (i = n.next()).done) && (s.push(i.value), !t || s.length !== t); o = !0);
        } catch (e) {
            a = !0, r = e;
        } finally{
            try {
                o || null == n.return || n.return();
            } finally{
                if (a) throw r;
            }
        }
        return s;
    }(e, t) || $504220289e15410d$var$c(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $504220289e15410d$var$l(e) {
    return function(e) {
        if (Array.isArray(e)) return $504220289e15410d$var$d(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || $504220289e15410d$var$c(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $504220289e15410d$var$c(e, t) {
    if (e) {
        if ("string" == typeof e) return $504220289e15410d$var$d(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $504220289e15410d$var$d(e, t) : void 0;
    }
}
function $504220289e15410d$var$d(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, i = new Array(t); n < t; n++)i[n] = e[n];
    return i;
}
function $504220289e15410d$var$h(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $504220289e15410d$var$c(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var i = 0, r = function() {};
            return {
                s: r,
                n: function() {
                    return i >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: r
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var s, o = !0, a = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return o = e.done, e;
        },
        e: function(e) {
            a = !0, s = e;
        },
        f: function() {
            try {
                o || null == n.return || n.return();
            } finally{
                if (a) throw s;
            }
        }
    };
}
var $504220289e15410d$var$f = {
    DEBUG: !1,
    LIB_VERSION: "1.161.6"
}, $504220289e15410d$var$v = Array.isArray, $504220289e15410d$var$p = Object.prototype, $504220289e15410d$var$g = $504220289e15410d$var$p.hasOwnProperty, $504220289e15410d$var$_ = $504220289e15410d$var$p.toString, $504220289e15410d$var$m = $504220289e15410d$var$v || function(e) {
    return "[object Array]" === $504220289e15410d$var$_.call(e);
}, $504220289e15410d$var$y = function(e) {
    return "function" == typeof e;
}, $504220289e15410d$var$b = function(e) {
    return e === Object(e) && !$504220289e15410d$var$m(e);
}, $504220289e15410d$var$k = function(e) {
    if ($504220289e15410d$var$b(e)) {
        for(var t in e)if ($504220289e15410d$var$g.call(e, t)) return !1;
        return !0;
    }
    return !1;
}, $504220289e15410d$var$w = function(e) {
    return void 0 === e;
}, $504220289e15410d$var$S = function(e) {
    return "[object String]" == $504220289e15410d$var$_.call(e);
}, $504220289e15410d$var$E = function(e) {
    return $504220289e15410d$var$S(e) && 0 === e.trim().length;
}, $504220289e15410d$var$I = function(e) {
    return null === e;
}, $504220289e15410d$var$x = function(e) {
    return $504220289e15410d$var$w(e) || $504220289e15410d$var$I(e);
}, $504220289e15410d$var$F = function(e) {
    return "[object Number]" == $504220289e15410d$var$_.call(e);
}, $504220289e15410d$var$R = function(e) {
    return "[object Boolean]" === $504220289e15410d$var$_.call(e);
}, $504220289e15410d$var$P = function(e) {
    return e instanceof FormData;
}, $504220289e15410d$var$T = "undefined" != typeof window ? window : void 0, $504220289e15410d$var$C = "undefined" != typeof globalThis ? globalThis : $504220289e15410d$var$T, $504220289e15410d$var$O = Array.prototype, $504220289e15410d$var$$ = $504220289e15410d$var$O.forEach, $504220289e15410d$var$M = $504220289e15410d$var$O.indexOf, $504220289e15410d$var$A = null == $504220289e15410d$var$C ? void 0 : $504220289e15410d$var$C.navigator, $504220289e15410d$var$L = null == $504220289e15410d$var$C ? void 0 : $504220289e15410d$var$C.document, $504220289e15410d$var$D = null == $504220289e15410d$var$C ? void 0 : $504220289e15410d$var$C.location, $504220289e15410d$var$N = null == $504220289e15410d$var$C ? void 0 : $504220289e15410d$var$C.fetch, $504220289e15410d$var$q = null != $504220289e15410d$var$C && $504220289e15410d$var$C.XMLHttpRequest && "withCredentials" in new $504220289e15410d$var$C.XMLHttpRequest ? $504220289e15410d$var$C.XMLHttpRequest : void 0, $504220289e15410d$var$B = null == $504220289e15410d$var$C ? void 0 : $504220289e15410d$var$C.AbortController, $504220289e15410d$var$H = null == $504220289e15410d$var$A ? void 0 : $504220289e15410d$var$A.userAgent, $504220289e15410d$var$U = null != $504220289e15410d$var$T ? $504220289e15410d$var$T : {}, $504220289e15410d$var$j = "[PostHog.js]", $504220289e15410d$var$W = {
    _log: function(e) {
        if ($504220289e15410d$var$T && ($504220289e15410d$var$f.DEBUG || $504220289e15410d$var$U.POSTHOG_DEBUG) && !$504220289e15410d$var$w($504220289e15410d$var$T.console) && $504220289e15410d$var$T.console) {
            for(var t = ("__rrweb_original__" in $504220289e15410d$var$T.console[e]) ? $504220289e15410d$var$T.console[e].__rrweb_original__ : $504220289e15410d$var$T.console[e], n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)i[r - 1] = arguments[r];
            t.apply(void 0, [
                $504220289e15410d$var$j
            ].concat(i));
        }
    },
    info: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $504220289e15410d$var$W._log.apply($504220289e15410d$var$W, [
            "log"
        ].concat(t));
    },
    warn: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $504220289e15410d$var$W._log.apply($504220289e15410d$var$W, [
            "warn"
        ].concat(t));
    },
    error: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $504220289e15410d$var$W._log.apply($504220289e15410d$var$W, [
            "error"
        ].concat(t));
    },
    critical: function() {
        for(var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
        (e = console).error.apply(e, [
            $504220289e15410d$var$j
        ].concat(n));
    },
    uninitializedWarning: function(e) {
        $504220289e15410d$var$W.error("You must initialize PostHog before calling ".concat(e));
    }
}, $504220289e15410d$var$V = {}, $504220289e15410d$var$z = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function $504220289e15410d$var$G(e, t, n) {
    if ($504220289e15410d$var$m(e)) {
        if ($504220289e15410d$var$$ && e.forEach === $504220289e15410d$var$$) e.forEach(t, n);
        else if ("length" in e && e.length === +e.length) {
            for(var i = 0, r = e.length; i < r; i++)if (i in e && t.call(n, e[i], i) === $504220289e15410d$var$V) return;
        }
    }
}
function $504220289e15410d$var$Q(e, t, n) {
    if (!$504220289e15410d$var$x(e)) {
        if ($504220289e15410d$var$m(e)) return $504220289e15410d$var$G(e, t, n);
        if ($504220289e15410d$var$P(e)) {
            var i, r = $504220289e15410d$var$h(e.entries());
            try {
                for(r.s(); !(i = r.n()).done;){
                    var s = i.value;
                    if (t.call(n, s[1], s[0]) === $504220289e15410d$var$V) return;
                }
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
        } else for(var o in e)if ($504220289e15410d$var$g.call(e, o) && t.call(n, e[o], o) === $504220289e15410d$var$V) return;
    }
}
var $504220289e15410d$var$J = function(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
    return $504220289e15410d$var$G(n, function(t) {
        for(var n in t)void 0 !== t[n] && (e[n] = t[n]);
    }), e;
};
function $504220289e15410d$var$Y(e, t) {
    return -1 !== e.indexOf(t);
}
function $504220289e15410d$var$X(e) {
    for(var t = Object.keys(e), n = t.length, i = new Array(n); n--;)i[n] = [
        t[n],
        e[t[n]]
    ];
    return i;
}
var $504220289e15410d$var$K = function() {
    return Date.now = Date.now || function() {
        return +new Date;
    }, Date.now();
}, $504220289e15410d$var$Z = function(e) {
    try {
        return e();
    } catch (e) {
        return;
    }
}, $504220289e15410d$var$ee = function(e) {
    return function() {
        try {
            for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
            return e.apply(this, n);
        } catch (e) {
            $504220289e15410d$var$W.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $504220289e15410d$var$W.critical(e);
        }
    };
}, $504220289e15410d$var$te = function(e) {
    var t = {};
    return $504220289e15410d$var$Q(e, function(e, n) {
        $504220289e15410d$var$S(e) && e.length > 0 && (t[n] = e);
    }), t;
}, $504220289e15410d$var$ne = function(e) {
    return e.replace(/^\$/, "");
};
function $504220289e15410d$var$ie(e, t) {
    var n, i, r;
    return n = e, i = function(e) {
        return $504220289e15410d$var$S(e) && !$504220289e15410d$var$I(t) ? e.slice(0, t) : e;
    }, r = new Set, function e(t, n) {
        var s;
        return t !== Object(t) ? i ? i(t, n) : t : r.has(t) ? void 0 : (r.add(t), $504220289e15410d$var$m(t) ? (s = [], $504220289e15410d$var$G(t, function(t) {
            s.push(e(t));
        })) : (s = {}, $504220289e15410d$var$Q(t, function(t, n) {
            r.has(t) || (s[n] = e(t, n));
        })), s);
    }(n);
}
var $504220289e15410d$export$6a00d17b5aff0af, $504220289e15410d$var$se = function(e) {
    var t, n, i, r, s = "";
    for(t = n = 0, i = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, r = 0; r < i; r++){
        var o = e.charCodeAt(r), a = null;
        o < 128 ? n++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $504220289e15410d$var$I(a) || (n > t && (s += e.substring(t, n)), s += a, t = n = r + 1);
    }
    return n > t && (s += e.substring(t, e.length)), s;
}, $504220289e15410d$var$oe = function() {
    function e(t) {
        return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
    }
    return e.preventDefault = function() {
        this.returnValue = !1;
    }, e.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(t, n, i, r, s) {
        if (t) {
            if (t.addEventListener && !r) t.addEventListener(n, i, !!s);
            else {
                var o = "on" + n, a = t[o];
                t[o] = function(t, n, i) {
                    return function(r) {
                        if (r = r || e(null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.event)) {
                            var s, o = !0;
                            $504220289e15410d$var$y(i) && (s = i(r));
                            var a = n.call(t, r);
                            return !1 !== s && !1 !== a || (o = !1), o;
                        }
                    };
                }(t, i, a);
            }
        } else $504220289e15410d$var$W.error("No valid element provided to register_event");
    };
}();
function $504220289e15410d$var$ae(e, t) {
    for(var n = 0; n < e.length; n++)if (t(e[n])) return e[n];
}
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}($504220289e15410d$export$6a00d17b5aff0af || ($504220289e15410d$export$6a00d17b5aff0af = {}));
var $504220289e15410d$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $504220289e15410d$var$le = "$people_distinct_id", $504220289e15410d$var$ce = "__alias", $504220289e15410d$var$de = "__timers", $504220289e15410d$var$he = "$autocapture_disabled_server_side", $504220289e15410d$var$fe = "$heatmaps_enabled_server_side", $504220289e15410d$var$ve = "$exception_capture_enabled_server_side", $504220289e15410d$var$pe = "$exception_capture_endpoint_suffix", $504220289e15410d$var$ge = "$web_vitals_enabled_server_side", $504220289e15410d$var$_e = "$web_vitals_allowed_metrics", $504220289e15410d$var$me = "$session_recording_enabled_server_side", $504220289e15410d$var$ye = "$console_log_recording_enabled_server_side", $504220289e15410d$var$be = "$session_recording_network_payload_capture", $504220289e15410d$var$ke = "$session_recording_canvas_recording", $504220289e15410d$var$we = "$replay_sample_rate", $504220289e15410d$var$Se = "$replay_minimum_duration", $504220289e15410d$var$Ee = "$sesid", $504220289e15410d$var$Ie = "$session_is_sampled", $504220289e15410d$var$xe = "$enabled_feature_flags", $504220289e15410d$var$Fe = "$early_access_features", $504220289e15410d$var$Re = "$stored_person_properties", $504220289e15410d$var$Pe = "$stored_group_properties", $504220289e15410d$var$Te = "$surveys", $504220289e15410d$var$Ce = "$surveys_activated", $504220289e15410d$var$Oe = "$flag_call_reported", $504220289e15410d$var$$e = "$user_state", $504220289e15410d$var$Me = "$client_session_props", $504220289e15410d$var$Ae = "$capture_rate_limit", $504220289e15410d$var$Le = "$initial_campaign_params", $504220289e15410d$var$De = "$initial_referrer_info", $504220289e15410d$var$Ne = "$initial_person_info", $504220289e15410d$var$qe = "$epp", $504220289e15410d$var$Be = "__POSTHOG_TOOLBAR__", $504220289e15410d$var$He = [
    $504220289e15410d$var$le,
    $504220289e15410d$var$ce,
    "__cmpns",
    $504220289e15410d$var$de,
    $504220289e15410d$var$me,
    $504220289e15410d$var$fe,
    $504220289e15410d$var$Ee,
    $504220289e15410d$var$xe,
    $504220289e15410d$var$$e,
    $504220289e15410d$var$Fe,
    $504220289e15410d$var$Pe,
    $504220289e15410d$var$Re,
    $504220289e15410d$var$Te,
    $504220289e15410d$var$Oe,
    $504220289e15410d$var$Me,
    $504220289e15410d$var$Ae,
    $504220289e15410d$var$Le,
    $504220289e15410d$var$De,
    $504220289e15410d$var$qe
], $504220289e15410d$var$Ue = "$active_feature_flags", $504220289e15410d$var$je = "$override_feature_flags", $504220289e15410d$var$We = "$feature_flag_payloads", $504220289e15410d$var$Ve = function(e) {
    var t, n = {}, i = $504220289e15410d$var$h($504220289e15410d$var$X(e || {}));
    try {
        for(i.s(); !(t = i.n()).done;){
            var r = $504220289e15410d$var$u(t.value, 2), s = r[0], o = r[1];
            o && (n[s] = o);
        }
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    return n;
}, $504220289e15410d$var$ze = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this.instance = t, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "getFlags",
            value: function() {
                return Object.keys(this.getFlagVariants());
            }
        },
        {
            key: "getFlagVariants",
            value: function() {
                var e = this.instance.get_property($504220289e15410d$var$xe), t = this.instance.get_property($504220289e15410d$var$je);
                if (!t) return e || {};
                for(var n = $504220289e15410d$var$J({}, e), i = Object.keys(t), r = 0; r < i.length; r++)n[i[r]] = t[i[r]];
                return this._override_warning || ($504220289e15410d$var$W.warn(" Overriding feature flags!", {
                    enabledFlags: e,
                    overriddenFlags: t,
                    finalFlags: n
                }), this._override_warning = !0), n;
            }
        },
        {
            key: "getFlagPayloads",
            value: function() {
                return this.instance.get_property($504220289e15410d$var$We) || {};
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
            }
        },
        {
            key: "setAnonymousDistinctId",
            value: function(e) {
                this.$anon_distinct_id = e;
            }
        },
        {
            key: "setReloadingPaused",
            value: function(e) {
                this.reloadFeatureFlagsInAction = e;
            }
        },
        {
            key: "resetRequestQueue",
            value: function() {
                this.reloadFeatureFlagsQueued = !1;
            }
        },
        {
            key: "_startReloadTimer",
            value: function() {
                var e = this;
                this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(function() {
                    !e.reloadFeatureFlagsInAction && e.reloadFeatureFlagsQueued && (e.reloadFeatureFlagsQueued = !1, e._reloadFeatureFlagsRequest());
                }, 5);
            }
        },
        {
            key: "_reloadFeatureFlagsRequest",
            value: function() {
                var e = this;
                if (!this.instance.config.advanced_disable_feature_flags) {
                    this.setReloadingPaused(!0);
                    var t = this.instance.config.token, n = this.instance.get_property($504220289e15410d$var$Re), i = this.instance.get_property($504220289e15410d$var$Pe), r = {
                        token: t,
                        distinct_id: this.instance.get_distinct_id(),
                        groups: this.instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: n,
                        group_properties: i,
                        disable_flags: this.instance.config.advanced_disable_feature_flags || void 0
                    };
                    this.instance._send_request({
                        method: "POST",
                        url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
                        data: r,
                        compression: this.instance.config.disable_compression ? void 0 : $504220289e15410d$export$6a00d17b5aff0af.Base64,
                        timeout: this.instance.config.feature_flag_request_timeout_ms,
                        callback: function(t) {
                            var n;
                            e.setReloadingPaused(!1);
                            var i = !0;
                            200 === t.statusCode && (e.$anon_distinct_id = void 0, i = !1), e.receivedFeatureFlags(null !== (n = t.json) && void 0 !== n ? n : {}, i), e._startReloadTimer();
                        }
                    });
                }
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) {
                    var n, i = this.getFlagVariants()[e], r = "".concat(i), s = this.instance.get_property($504220289e15410d$var$Oe) || {};
                    if (t.send_event || !("send_event" in t)) {
                        if (!(e in s) || !s[e].includes(r)) $504220289e15410d$var$m(s[e]) ? s[e].push(r) : s[e] = [
                            r
                        ], null === (n = this.instance.persistence) || void 0 === n || n.register($504220289e15410d$var$o({}, $504220289e15410d$var$Oe, s)), this.instance.capture("$feature_flag_called", {
                            $feature_flag: e,
                            $feature_flag_response: i
                        });
                    }
                    return i;
                }
                $504220289e15410d$var$W.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                return this.getFlagPayloads()[e];
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
                $504220289e15410d$var$W.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "addFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers.push(e);
            }
        },
        {
            key: "removeFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter(function(t) {
                    return t !== e;
                });
            }
        },
        {
            key: "receivedFeatureFlags",
            value: function(e, n) {
                if (this.instance.persistence) {
                    this.instance.decideEndpointWasHit = !0;
                    var i = this.getFlagVariants(), r = this.getFlagPayloads();
                    !function(e, n) {
                        var i, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, a = e.featureFlags, u = e.featureFlagPayloads;
                        if (a) {
                            if ($504220289e15410d$var$m(a)) {
                                var l, c = {};
                                if (a) for(var d = 0; d < a.length; d++)c[a[d]] = !0;
                                n && n.register(($504220289e15410d$var$o(l = {}, $504220289e15410d$var$Ue, a), $504220289e15410d$var$o(l, $504220289e15410d$var$xe, c), l));
                            } else {
                                var h = a, f = u;
                                e.errorsWhileComputingFlags && (h = $504220289e15410d$var$t($504220289e15410d$var$t({}, r), h), f = $504220289e15410d$var$t($504220289e15410d$var$t({}, s), f)), n && n.register(($504220289e15410d$var$o(i = {}, $504220289e15410d$var$Ue, Object.keys($504220289e15410d$var$Ve(h))), $504220289e15410d$var$o(i, $504220289e15410d$var$xe, h || {}), $504220289e15410d$var$o(i, $504220289e15410d$var$We, f || {}), i));
                            }
                        }
                    }(e, this.instance.persistence, i, r), this._fireFeatureFlagsCallbacks(n);
                }
            }
        },
        {
            key: "override",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (!this.instance.__loaded || !this.instance.persistence) return $504220289e15410d$var$W.uninitializedWarning("posthog.feature_flags.override");
                if (this._override_warning = t, !1 === e) this.instance.persistence.unregister($504220289e15410d$var$je);
                else if ($504220289e15410d$var$m(e)) {
                    for(var n = {}, i = 0; i < e.length; i++)n[e[i]] = !0;
                    this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$je, n));
                } else this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$je, e));
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                var t = this;
                if (this.addFeatureFlagsHandler(e), this.instance.decideEndpointWasHit) {
                    var n = this._prepareFeatureFlagsForCallbacks(), i = n.flags, r = n.flagVariants;
                    e(i, r);
                }
                return function() {
                    return t.removeFeatureFlagsHandler(e);
                };
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, n) {
                var i, r, s = $504220289e15410d$var$o({}, "$feature_enrollment/".concat(e), n);
                this.instance.capture("$feature_enrollment_update", {
                    $feature_flag: e,
                    $feature_enrollment: n,
                    $set: s
                }), this.setPersonPropertiesForFlags(s, !1);
                var a = $504220289e15410d$var$t($504220289e15410d$var$t({}, this.getFlagVariants()), {}, $504220289e15410d$var$o({}, e, n));
                null === (i = this.instance.persistence) || void 0 === i || i.register(($504220289e15410d$var$o(r = {}, $504220289e15410d$var$Ue, Object.keys($504220289e15410d$var$Ve(a))), $504220289e15410d$var$o(r, $504220289e15410d$var$xe, a), r)), this._fireFeatureFlagsCallbacks();
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = this.instance.get_property($504220289e15410d$var$Fe);
                if (i && !n) return e(i);
                this.instance._send_request({
                    transport: "XHR",
                    url: this.instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=".concat(this.instance.config.token)),
                    method: "GET",
                    callback: function(n) {
                        var i;
                        if (n.json) {
                            var r = n.json.earlyAccessFeatures;
                            return null === (i = t.instance.persistence) || void 0 === i || i.register($504220289e15410d$var$o({}, $504220289e15410d$var$Fe, r)), e(r);
                        }
                    }
                });
            }
        },
        {
            key: "_prepareFeatureFlagsForCallbacks",
            value: function() {
                var e = this.getFlags(), t = this.getFlagVariants();
                return {
                    flags: e.filter(function(e) {
                        return t[e];
                    }),
                    flagVariants: Object.keys(t).filter(function(e) {
                        return t[e];
                    }).reduce(function(e, n) {
                        return e[n] = t[n], e;
                    }, {})
                };
            }
        },
        {
            key: "_fireFeatureFlagsCallbacks",
            value: function(e) {
                var t = this._prepareFeatureFlagsForCallbacks(), n = t.flags, i = t.flagVariants;
                this.featureFlagEventHandlers.forEach(function(t) {
                    return t(n, i, {
                        errorsLoading: e
                    });
                });
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.instance.get_property($504220289e15410d$var$Re) || {};
                this.instance.register($504220289e15410d$var$o({}, $504220289e15410d$var$Re, $504220289e15410d$var$t($504220289e15410d$var$t({}, i), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.instance.unregister($504220289e15410d$var$Re);
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.instance.get_property($504220289e15410d$var$Pe) || {};
                0 !== Object.keys(i).length && Object.keys(i).forEach(function(n) {
                    i[n] = $504220289e15410d$var$t($504220289e15410d$var$t({}, i[n]), e[n]), delete e[n];
                }), this.instance.register($504220289e15410d$var$o({}, $504220289e15410d$var$Pe, $504220289e15410d$var$t($504220289e15410d$var$t({}, i), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                if (e) {
                    var n = this.instance.get_property($504220289e15410d$var$Pe) || {};
                    this.instance.register($504220289e15410d$var$o({}, $504220289e15410d$var$Pe, $504220289e15410d$var$t($504220289e15410d$var$t({}, n), {}, $504220289e15410d$var$o({}, e, {}))));
                } else this.instance.unregister($504220289e15410d$var$Pe);
            }
        }
    ]), e;
}();
Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return $504220289e15410d$var$F(e) && isFinite(e) && Math.floor(e) === e;
});
var $504220289e15410d$var$Ge = "0123456789abcdef", $504220289e15410d$var$Qe = function() {
    function e(t) {
        if ($504220289e15410d$var$i(this, e), this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "toString",
            value: function() {
                for(var e = "", t = 0; t < this.bytes.length; t++)e = e + $504220289e15410d$var$Ge.charAt(this.bytes[t] >>> 4) + $504220289e15410d$var$Ge.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
                if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
                return e;
            }
        },
        {
            key: "clone",
            value: function() {
                return new e(this.bytes.slice(0));
            }
        },
        {
            key: "equals",
            value: function(e) {
                return 0 === this.compareTo(e);
            }
        },
        {
            key: "compareTo",
            value: function(e) {
                for(var t = 0; t < 16; t++){
                    var n = this.bytes[t] - e.bytes[t];
                    if (0 !== n) return Math.sign(n);
                }
                return 0;
            }
        }
    ], [
        {
            key: "fromFieldsV7",
            value: function(t, n, i, r) {
                if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(i) || !Number.isInteger(r) || t < 0 || n < 0 || i < 0 || r < 0 || t > 0xffffffffffff || n > 4095 || i > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
                var s = new Uint8Array(16);
                return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | n >>> 8, s[7] = n, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new e(s);
            }
        }
    ]), e;
}(), $504220289e15410d$var$Je = function() {
    function e() {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "timestamp", 0), $504220289e15410d$var$o(this, "counter", 0), $504220289e15410d$var$o(this, "random", new $504220289e15410d$var$Ke);
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "generate",
            value: function() {
                var e = this.generateOrAbort();
                if ($504220289e15410d$var$w(e)) {
                    this.timestamp = 0;
                    var t = this.generateOrAbort();
                    if ($504220289e15410d$var$w(t)) throw new Error("Could not generate UUID after timestamp reset");
                    return t;
                }
                return e;
            }
        },
        {
            key: "generateOrAbort",
            value: function() {
                var e = Date.now();
                if (e > this.timestamp) this.timestamp = e, this.resetCounter();
                else {
                    if (!(e + 1e4 > this.timestamp)) return;
                    this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
                }
                return $504220289e15410d$var$Qe.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
            }
        },
        {
            key: "resetCounter",
            value: function() {
                this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
            }
        }
    ]), e;
}(), $504220289e15410d$var$Ye = function(e) {
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
$504220289e15410d$var$T && !$504220289e15410d$var$w($504220289e15410d$var$T.crypto) && crypto.getRandomValues && ($504220289e15410d$var$Ye = function(e) {
    return crypto.getRandomValues(e);
});
var $504220289e15410d$var$Xe, $504220289e15410d$var$Ke = function() {
    function e() {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "buffer", new Uint32Array(8)), $504220289e15410d$var$o(this, "cursor", 1 / 0);
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "nextUint32",
            value: function() {
                return this.cursor >= this.buffer.length && ($504220289e15410d$var$Ye(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
            }
        }
    ]), e;
}(), $504220289e15410d$var$Ze = function() {
    return $504220289e15410d$var$et().toString();
}, $504220289e15410d$var$et = function() {
    return ($504220289e15410d$var$Xe || ($504220289e15410d$var$Xe = new $504220289e15410d$var$Je)).generate();
}, $504220289e15410d$var$tt = "Thu, 01 Jan 1970 00:00:00 GMT", $504220289e15410d$var$nt = "";
var $504220289e15410d$var$it = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $504220289e15410d$var$rt(e, t) {
    if (t) {
        var n = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $504220289e15410d$var$L;
            if ($504220289e15410d$var$nt) return $504220289e15410d$var$nt;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            for(var n = e.split("."), i = Math.min(n.length, 8), r = "dmn_chk_" + $504220289e15410d$var$Ze(), s = new RegExp("(^|;)\\s*" + r + "=1"); !$504220289e15410d$var$nt && i--;){
                var o = n.slice(i).join("."), a = r + "=1;domain=." + o;
                t.cookie = a, s.test(t.cookie) && (t.cookie = a + ";expires=" + $504220289e15410d$var$tt, $504220289e15410d$var$nt = o);
            }
            return $504220289e15410d$var$nt;
        }(e);
        if (!n) {
            var i = function(e) {
                var t = e.match($504220289e15410d$var$it);
                return t ? t[0] : "";
            }(e);
            i !== n && $504220289e15410d$var$W.info("Warning: cookie subdomain discovery mismatch", i, n), n = i;
        }
        return n ? "; domain=." + n : "";
    }
    return "";
}
var $504220289e15410d$var$st, $504220289e15410d$var$ot = {
    is_supported: function() {
        return !!$504220289e15410d$var$L;
    },
    error: function(e) {
        $504220289e15410d$var$W.error("cookieStore error: " + e);
    },
    get: function(e) {
        if ($504220289e15410d$var$L) {
            try {
                for(var t = e + "=", n = $504220289e15410d$var$L.cookie.split(";").filter(function(e) {
                    return e.length;
                }), i = 0; i < n.length; i++){
                    for(var r = n[i]; " " == r.charAt(0);)r = r.substring(1, r.length);
                    if (0 === r.indexOf(t)) return decodeURIComponent(r.substring(t.length, r.length));
                }
            } catch (e) {}
            return null;
        }
    },
    parse: function(e) {
        var t;
        try {
            t = JSON.parse($504220289e15410d$var$ot.get(e)) || {};
        } catch (e) {}
        return t;
    },
    set: function(e, t, n, i, r) {
        if ($504220289e15410d$var$L) try {
            var s = "", o = "", a = $504220289e15410d$var$rt($504220289e15410d$var$L.location.hostname, i);
            if (n) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * n * 3600000), s = "; expires=" + u.toUTCString();
            }
            r && (o = "; secure");
            var l = e + "=" + encodeURIComponent(JSON.stringify(t)) + s + "; SameSite=Lax; path=/" + a + o;
            return l.length > 3686.4 && $504220289e15410d$var$W.warn("cookieStore warning: large cookie, len=" + l.length), $504220289e15410d$var$L.cookie = l, l;
        } catch (e) {
            return;
        }
    },
    remove: function(e, t) {
        try {
            $504220289e15410d$var$ot.set(e, "", -1, t);
        } catch (e) {
            return;
        }
    }
}, $504220289e15410d$var$at = null, $504220289e15410d$var$ut = {
    is_supported: function() {
        if (!$504220289e15410d$var$I($504220289e15410d$var$at)) return $504220289e15410d$var$at;
        var e = !0;
        if ($504220289e15410d$var$w($504220289e15410d$var$T)) e = !1;
        else try {
            var t = "__mplssupport__";
            $504220289e15410d$var$ut.set(t, "xyz"), '"xyz"' !== $504220289e15410d$var$ut.get(t) && (e = !1), $504220289e15410d$var$ut.remove(t);
        } catch (t) {
            e = !1;
        }
        return e || $504220289e15410d$var$W.error("localStorage unsupported; falling back to cookie store"), $504220289e15410d$var$at = e, e;
    },
    error: function(e) {
        $504220289e15410d$var$W.error("localStorage error: " + e);
    },
    get: function(e) {
        try {
            return null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.localStorage.getItem(e);
        } catch (e) {
            $504220289e15410d$var$ut.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($504220289e15410d$var$ut.get(e)) || {};
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $504220289e15410d$var$T || $504220289e15410d$var$T.localStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $504220289e15410d$var$ut.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $504220289e15410d$var$T || $504220289e15410d$var$T.localStorage.removeItem(e);
        } catch (e) {
            $504220289e15410d$var$ut.error(e);
        }
    }
}, $504220289e15410d$var$lt = [
    "distinct_id",
    $504220289e15410d$var$Ee,
    $504220289e15410d$var$Ie,
    $504220289e15410d$var$qe
], $504220289e15410d$var$ct = $504220289e15410d$var$t($504220289e15410d$var$t({}, $504220289e15410d$var$ut), {}, {
    parse: function(e) {
        try {
            var t = {};
            try {
                t = $504220289e15410d$var$ot.parse(e) || {};
            } catch (e) {}
            var n = $504220289e15410d$var$J(t, JSON.parse($504220289e15410d$var$ut.get(e) || "{}"));
            return $504220289e15410d$var$ut.set(e, n), n;
        } catch (e) {}
        return null;
    },
    set: function(e, t, n, i, r, s) {
        try {
            $504220289e15410d$var$ut.set(e, t, void 0, void 0, s);
            var o = {};
            $504220289e15410d$var$lt.forEach(function(e) {
                t[e] && (o[e] = t[e]);
            }), Object.keys(o).length && $504220289e15410d$var$ot.set(e, o, n, i, r, s);
        } catch (e) {
            $504220289e15410d$var$ut.error(e);
        }
    },
    remove: function(e, t) {
        try {
            null == $504220289e15410d$var$T || $504220289e15410d$var$T.localStorage.removeItem(e), $504220289e15410d$var$ot.remove(e, t);
        } catch (e) {
            $504220289e15410d$var$ut.error(e);
        }
    }
}), $504220289e15410d$var$dt = {}, $504220289e15410d$var$ht = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        $504220289e15410d$var$W.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return $504220289e15410d$var$dt[e] || null;
    },
    parse: function(e) {
        return $504220289e15410d$var$dt[e] || null;
    },
    set: function(e, t) {
        $504220289e15410d$var$dt[e] = t;
    },
    remove: function(e) {
        delete $504220289e15410d$var$dt[e];
    }
}, $504220289e15410d$var$ft = null, $504220289e15410d$var$vt = {
    is_supported: function() {
        if (!$504220289e15410d$var$I($504220289e15410d$var$ft)) return $504220289e15410d$var$ft;
        if ($504220289e15410d$var$ft = !0, $504220289e15410d$var$w($504220289e15410d$var$T)) $504220289e15410d$var$ft = !1;
        else try {
            var e = "__support__";
            $504220289e15410d$var$vt.set(e, "xyz"), '"xyz"' !== $504220289e15410d$var$vt.get(e) && ($504220289e15410d$var$ft = !1), $504220289e15410d$var$vt.remove(e);
        } catch (e) {
            $504220289e15410d$var$ft = !1;
        }
        return $504220289e15410d$var$ft;
    },
    error: function(e) {
        $504220289e15410d$var$W.error("sessionStorage error: ", e);
    },
    get: function(e) {
        try {
            return null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.sessionStorage.getItem(e);
        } catch (e) {
            $504220289e15410d$var$vt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($504220289e15410d$var$vt.get(e)) || null;
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $504220289e15410d$var$T || $504220289e15410d$var$T.sessionStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $504220289e15410d$var$vt.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $504220289e15410d$var$T || $504220289e15410d$var$T.sessionStorage.removeItem(e);
        } catch (e) {
            $504220289e15410d$var$vt.error(e);
        }
    }
}, $504220289e15410d$var$pt = [
    "localhost",
    "127.0.0.1"
], $504220289e15410d$var$gt = function(e) {
    var t = null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.createElement("a");
    return $504220289e15410d$var$w(t) ? null : (t.href = e, t);
}, $504220289e15410d$var$_t = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch (e) {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, $504220289e15410d$var$mt = function(e) {
    var t, n, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&", r = [];
    return $504220289e15410d$var$Q(e, function(e, i) {
        $504220289e15410d$var$w(e) || $504220289e15410d$var$w(i) || "undefined" === i || (t = encodeURIComponent(function(e) {
            return e instanceof File;
        }(e) ? e.name : e.toString()), n = encodeURIComponent(i), r[r.length] = n + "=" + t);
    }), r.join(i);
}, $504220289e15410d$var$yt = function(e, t) {
    for(var n, i = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), r = 0; r < i.length; r++){
        var s = i[r].split("=");
        if (s[0] === t) {
            n = s;
            break;
        }
    }
    if (!$504220289e15410d$var$m(n) || n.length < 2) return "";
    var o = n[1];
    try {
        o = decodeURIComponent(o);
    } catch (e) {
        $504220289e15410d$var$W.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $504220289e15410d$var$bt = function(e, t) {
    var n = e.match(new RegExp(t + "=([^&]*)"));
    return n ? n[1] : null;
}, $504220289e15410d$var$kt = "Mobile", $504220289e15410d$var$wt = "iOS", $504220289e15410d$var$St = "Android", $504220289e15410d$var$Et = "Tablet", $504220289e15410d$var$It = $504220289e15410d$var$St + " " + $504220289e15410d$var$Et, $504220289e15410d$var$xt = "iPad", $504220289e15410d$var$Ft = "Apple", $504220289e15410d$var$Rt = $504220289e15410d$var$Ft + " Watch", $504220289e15410d$var$Pt = "Safari", $504220289e15410d$var$Tt = "BlackBerry", $504220289e15410d$var$Ct = "Samsung", $504220289e15410d$var$Ot = $504220289e15410d$var$Ct + "Browser", $504220289e15410d$var$$t = $504220289e15410d$var$Ct + " Internet", $504220289e15410d$var$Mt = "Chrome", $504220289e15410d$var$At = $504220289e15410d$var$Mt + " OS", $504220289e15410d$var$Lt = $504220289e15410d$var$Mt + " " + $504220289e15410d$var$wt, $504220289e15410d$var$Dt = "Internet Explorer", $504220289e15410d$var$Nt = $504220289e15410d$var$Dt + " " + $504220289e15410d$var$kt, $504220289e15410d$var$qt = "Opera", $504220289e15410d$var$Bt = $504220289e15410d$var$qt + " Mini", $504220289e15410d$var$Ht = "Edge", $504220289e15410d$var$Ut = "Microsoft " + $504220289e15410d$var$Ht, $504220289e15410d$var$jt = "Firefox", $504220289e15410d$var$Wt = $504220289e15410d$var$jt + " " + $504220289e15410d$var$wt, $504220289e15410d$var$Vt = "Nintendo", $504220289e15410d$var$zt = "PlayStation", $504220289e15410d$var$Gt = "Xbox", $504220289e15410d$var$Qt = $504220289e15410d$var$St + " " + $504220289e15410d$var$kt, $504220289e15410d$var$Jt = $504220289e15410d$var$kt + " " + $504220289e15410d$var$Pt, $504220289e15410d$var$Yt = "Windows", $504220289e15410d$var$Xt = $504220289e15410d$var$Yt + " Phone", $504220289e15410d$var$Kt = "Nokia", $504220289e15410d$var$Zt = "Ouya", $504220289e15410d$var$en = "Generic", $504220289e15410d$var$tn = $504220289e15410d$var$en + " " + $504220289e15410d$var$kt.toLowerCase(), $504220289e15410d$var$nn = $504220289e15410d$var$en + " " + $504220289e15410d$var$Et.toLowerCase(), $504220289e15410d$var$rn = "Konqueror", $504220289e15410d$var$sn = "(\\d+(\\.\\d+)?)", $504220289e15410d$var$on = new RegExp("Version/" + $504220289e15410d$var$sn), $504220289e15410d$var$an = new RegExp($504220289e15410d$var$Gt, "i"), $504220289e15410d$var$un = new RegExp($504220289e15410d$var$zt + " \\w+", "i"), $504220289e15410d$var$ln = new RegExp($504220289e15410d$var$Vt + " \\w+", "i"), $504220289e15410d$var$cn = new RegExp($504220289e15410d$var$Tt + "|PlayBook|BB10", "i"), $504220289e15410d$var$dn = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $504220289e15410d$var$hn = function(e, t) {
    return t && $504220289e15410d$var$Y(t, $504220289e15410d$var$Ft) || function(e) {
        return $504220289e15410d$var$Y(e, $504220289e15410d$var$Pt) && !$504220289e15410d$var$Y(e, $504220289e15410d$var$Mt) && !$504220289e15410d$var$Y(e, $504220289e15410d$var$St);
    }(e);
}, $504220289e15410d$var$fn = function(e, t) {
    return t = t || "", $504220289e15410d$var$Y(e, " OPR/") && $504220289e15410d$var$Y(e, "Mini") ? $504220289e15410d$var$Bt : $504220289e15410d$var$Y(e, " OPR/") ? $504220289e15410d$var$qt : $504220289e15410d$var$cn.test(e) ? $504220289e15410d$var$Tt : $504220289e15410d$var$Y(e, "IE" + $504220289e15410d$var$kt) || $504220289e15410d$var$Y(e, "WPDesktop") ? $504220289e15410d$var$Nt : $504220289e15410d$var$Y(e, $504220289e15410d$var$Ot) ? $504220289e15410d$var$$t : $504220289e15410d$var$Y(e, $504220289e15410d$var$Ht) || $504220289e15410d$var$Y(e, "Edg/") ? $504220289e15410d$var$Ut : $504220289e15410d$var$Y(e, "FBIOS") ? "Facebook " + $504220289e15410d$var$kt : $504220289e15410d$var$Y(e, "UCWEB") || $504220289e15410d$var$Y(e, "UCBrowser") ? "UC Browser" : $504220289e15410d$var$Y(e, "CriOS") ? $504220289e15410d$var$Lt : $504220289e15410d$var$Y(e, "CrMo") ? $504220289e15410d$var$Mt : $504220289e15410d$var$Y(e, $504220289e15410d$var$St) && $504220289e15410d$var$Y(e, $504220289e15410d$var$Pt) ? $504220289e15410d$var$Qt : $504220289e15410d$var$Y(e, $504220289e15410d$var$Mt) ? $504220289e15410d$var$Mt : $504220289e15410d$var$Y(e, "FxiOS") ? $504220289e15410d$var$Wt : $504220289e15410d$var$Y(e.toLowerCase(), $504220289e15410d$var$rn.toLowerCase()) ? $504220289e15410d$var$rn : $504220289e15410d$var$hn(e, t) ? $504220289e15410d$var$Y(e, $504220289e15410d$var$kt) ? $504220289e15410d$var$Jt : $504220289e15410d$var$Pt : $504220289e15410d$var$Y(e, $504220289e15410d$var$jt) ? $504220289e15410d$var$jt : $504220289e15410d$var$Y(e, "MSIE") || $504220289e15410d$var$Y(e, "Trident/") ? $504220289e15410d$var$Dt : $504220289e15410d$var$Y(e, "Gecko") ? $504220289e15410d$var$jt : "";
}, $504220289e15410d$var$vn = ($504220289e15410d$var$o($504220289e15410d$var$st = {}, $504220289e15410d$var$Nt, [
    new RegExp("rv:" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Ut, [
    new RegExp($504220289e15410d$var$Ht + "?\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Mt, [
    new RegExp("(" + $504220289e15410d$var$Mt + "|CrMo)\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Lt, [
    new RegExp("CriOS\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, "UC Browser", [
    new RegExp("(UCBrowser|UCWEB)\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Pt, [
    $504220289e15410d$var$on
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Jt, [
    $504220289e15410d$var$on
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$qt, [
    new RegExp("(Opera|OPR)\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$jt, [
    new RegExp($504220289e15410d$var$jt + "\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Wt, [
    new RegExp("FxiOS\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$rn, [
    new RegExp("Konqueror[:/]?" + $504220289e15410d$var$sn, "i")
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Tt, [
    new RegExp($504220289e15410d$var$Tt + " " + $504220289e15410d$var$sn),
    $504220289e15410d$var$on
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Qt, [
    new RegExp("android\\s" + $504220289e15410d$var$sn, "i")
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$$t, [
    new RegExp($504220289e15410d$var$Ot + "\\/" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, $504220289e15410d$var$Dt, [
    new RegExp("(rv:|MSIE )" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$o($504220289e15410d$var$st, "Mozilla", [
    new RegExp("rv:" + $504220289e15410d$var$sn)
]), $504220289e15410d$var$st), $504220289e15410d$var$pn = [
    [
        new RegExp($504220289e15410d$var$Gt + "; " + $504220289e15410d$var$Gt + " (.*?)[);]", "i"),
        function(e) {
            return [
                $504220289e15410d$var$Gt,
                e && e[1] || ""
            ];
        }
    ],
    [
        new RegExp($504220289e15410d$var$Vt, "i"),
        [
            $504220289e15410d$var$Vt,
            ""
        ]
    ],
    [
        new RegExp($504220289e15410d$var$zt, "i"),
        [
            $504220289e15410d$var$zt,
            ""
        ]
    ],
    [
        $504220289e15410d$var$cn,
        [
            $504220289e15410d$var$Tt,
            ""
        ]
    ],
    [
        new RegExp($504220289e15410d$var$Yt, "i"),
        function(e, t) {
            if (/Phone/.test(t) || /WPDesktop/.test(t)) return [
                $504220289e15410d$var$Xt,
                ""
            ];
            if (new RegExp($504220289e15410d$var$kt).test(t) && !/IEMobile\b/.test(t)) return [
                $504220289e15410d$var$Yt + " " + $504220289e15410d$var$kt,
                ""
            ];
            var n = /Windows NT ([0-9.]+)/i.exec(t);
            if (n && n[1]) {
                var i = n[1], r = $504220289e15410d$var$dn[i] || "";
                return /arm/i.test(t) && (r = "RT"), [
                    $504220289e15410d$var$Yt,
                    r
                ];
            }
            return [
                $504220289e15410d$var$Yt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        function(e) {
            if (e && e[3]) {
                var t = [
                    e[3],
                    e[4],
                    e[5] || "0"
                ];
                return [
                    $504220289e15410d$var$wt,
                    t.join(".")
                ];
            }
            return [
                $504220289e15410d$var$wt,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        function(e) {
            var t = "";
            return e && e.length >= 3 && (t = $504220289e15410d$var$w(e[2]) ? e[3] : e[2]), [
                "watchOS",
                t
            ];
        }
    ],
    [
        new RegExp("(" + $504220289e15410d$var$St + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $504220289e15410d$var$St + ")", "i"),
        function(e) {
            if (e && e[2]) {
                var t = [
                    e[2],
                    e[3],
                    e[4] || "0"
                ];
                return [
                    $504220289e15410d$var$St,
                    t.join(".")
                ];
            }
            return [
                $504220289e15410d$var$St,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        function(e) {
            var t = [
                "Mac OS X",
                ""
            ];
            if (e && e[1]) {
                var n = [
                    e[1],
                    e[2],
                    e[3] || "0"
                ];
                t[1] = n.join(".");
            }
            return t;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $504220289e15410d$var$At,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $504220289e15410d$var$gn = function(e) {
    return $504220289e15410d$var$ln.test(e) ? $504220289e15410d$var$Vt : $504220289e15410d$var$un.test(e) ? $504220289e15410d$var$zt : $504220289e15410d$var$an.test(e) ? $504220289e15410d$var$Gt : new RegExp($504220289e15410d$var$Zt, "i").test(e) ? $504220289e15410d$var$Zt : new RegExp("(" + $504220289e15410d$var$Xt + "|WPDesktop)", "i").test(e) ? $504220289e15410d$var$Xt : /iPad/.test(e) ? $504220289e15410d$var$xt : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? $504220289e15410d$var$Rt : $504220289e15410d$var$cn.test(e) ? $504220289e15410d$var$Tt : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp($504220289e15410d$var$Kt, "i").test(e) ? $504220289e15410d$var$Kt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp($504220289e15410d$var$kt).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? $504220289e15410d$var$St : $504220289e15410d$var$It : $504220289e15410d$var$St : new RegExp("(pda|" + $504220289e15410d$var$kt + ")", "i").test(e) ? $504220289e15410d$var$tn : new RegExp($504220289e15410d$var$Et, "i").test(e) && !new RegExp($504220289e15410d$var$Et + " pc", "i").test(e) ? $504220289e15410d$var$nn : "";
}, $504220289e15410d$var$_n = "https?://(.*)", $504220289e15410d$var$mn = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gad_source",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "mc_cid",
    "igshid",
    "ttclid",
    "rdt_cid"
], $504220289e15410d$var$yn = {
    campaignParams: function(e) {
        return $504220289e15410d$var$L ? this._campaignParamsFromUrl($504220289e15410d$var$L.URL, e) : {};
    },
    _campaignParamsFromUrl: function(e, t) {
        var n = $504220289e15410d$var$mn.concat(t || []), i = {};
        return $504220289e15410d$var$Q(n, function(t) {
            var n = $504220289e15410d$var$yt(e, t);
            n && (i[t] = n);
        }), i;
    },
    _searchEngine: function(e) {
        return e ? 0 === e.search($504220289e15410d$var$_n + "google.([^/?]*)") ? "google" : 0 === e.search($504220289e15410d$var$_n + "bing.com") ? "bing" : 0 === e.search($504220289e15410d$var$_n + "yahoo.com") ? "yahoo" : 0 === e.search($504220289e15410d$var$_n + "duckduckgo.com") ? "duckduckgo" : null : null;
    },
    _searchInfoFromReferrer: function(e) {
        var t = $504220289e15410d$var$yn._searchEngine(e), n = "yahoo" != t ? "q" : "p", i = {};
        if (!$504220289e15410d$var$I(t)) {
            i.$search_engine = t;
            var r = $504220289e15410d$var$L ? $504220289e15410d$var$yt($504220289e15410d$var$L.referrer, n) : "";
            r.length && (i.ph_keyword = r);
        }
        return i;
    },
    searchInfo: function() {
        var e = null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.referrer;
        return e ? this._searchInfoFromReferrer(e) : {};
    },
    browser: $504220289e15410d$var$fn,
    browserVersion: function(e, t) {
        var n = $504220289e15410d$var$fn(e, t), i = $504220289e15410d$var$vn[n];
        if ($504220289e15410d$var$w(i)) return null;
        for(var r = 0; r < i.length; r++){
            var s = i[r], o = e.match(s);
            if (o) return parseFloat(o[o.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    os: function(e) {
        for(var t = 0; t < $504220289e15410d$var$pn.length; t++){
            var n = $504220289e15410d$var$u($504220289e15410d$var$pn[t], 2), i = n[0], r = n[1], s = i.exec(e), o = s && ($504220289e15410d$var$y(r) ? r(s, e) : r);
            if (o) return o;
        }
        return [
            "",
            ""
        ];
    },
    device: $504220289e15410d$var$gn,
    deviceType: function(e) {
        var t = $504220289e15410d$var$gn(e);
        return t === $504220289e15410d$var$xt || t === $504220289e15410d$var$It || "Kobo" === t || "Kindle Fire" === t || t === $504220289e15410d$var$nn ? $504220289e15410d$var$Et : t === $504220289e15410d$var$Vt || t === $504220289e15410d$var$Gt || t === $504220289e15410d$var$zt || t === $504220289e15410d$var$Zt ? "Console" : t === $504220289e15410d$var$Rt ? "Wearable" : t ? $504220289e15410d$var$kt : "Desktop";
    },
    referrer: function() {
        return (null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != $504220289e15410d$var$L && $504220289e15410d$var$L.referrer && (null === (e = $504220289e15410d$var$gt($504220289e15410d$var$L.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    referrerInfo: function() {
        return {
            $referrer: this.referrer(),
            $referring_domain: this.referringDomain()
        };
    },
    initialPersonInfo: function() {
        return {
            r: this.referrer(),
            u: null == $504220289e15410d$var$D ? void 0 : $504220289e15410d$var$D.href
        };
    },
    initialPersonPropsFromInfo: function(e) {
        var t, n = e.r, i = e.u, r = {
            $initial_referrer: n,
            $initial_referring_domain: null == n ? void 0 : "$direct" == n ? "$direct" : null === (t = $504220289e15410d$var$gt(n)) || void 0 === t ? void 0 : t.host
        };
        if (i) {
            r.$initial_current_url = i;
            var s = $504220289e15410d$var$gt(i);
            r.$initial_host = null == s ? void 0 : s.host, r.$initial_pathname = null == s ? void 0 : s.pathname, $504220289e15410d$var$Q(this._campaignParamsFromUrl(i), function(e, t) {
                r["$initial_" + $504220289e15410d$var$ne(t)] = e;
            });
        }
        n && $504220289e15410d$var$Q(this._searchInfoFromReferrer(n), function(e, t) {
            r["$initial_" + $504220289e15410d$var$ne(t)] = e;
        });
        return r;
    },
    properties: function() {
        if (!$504220289e15410d$var$H) return {};
        var e = $504220289e15410d$var$u($504220289e15410d$var$yn.os($504220289e15410d$var$H), 2), t = e[0], n = e[1];
        return $504220289e15410d$var$J($504220289e15410d$var$te({
            $os: t,
            $os_version: n,
            $browser: $504220289e15410d$var$yn.browser($504220289e15410d$var$H, navigator.vendor),
            $device: $504220289e15410d$var$yn.device($504220289e15410d$var$H),
            $device_type: $504220289e15410d$var$yn.deviceType($504220289e15410d$var$H)
        }), {
            $current_url: null == $504220289e15410d$var$D ? void 0 : $504220289e15410d$var$D.href,
            $host: null == $504220289e15410d$var$D ? void 0 : $504220289e15410d$var$D.host,
            $pathname: null == $504220289e15410d$var$D ? void 0 : $504220289e15410d$var$D.pathname,
            $raw_user_agent: $504220289e15410d$var$H.length > 1e3 ? $504220289e15410d$var$H.substring(0, 997) + "..." : $504220289e15410d$var$H,
            $browser_version: $504220289e15410d$var$yn.browserVersion($504220289e15410d$var$H, navigator.vendor),
            $browser_language: $504220289e15410d$var$yn.browserLanguage(),
            $screen_height: null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.screen.height,
            $screen_width: null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.screen.width,
            $viewport_height: null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.innerHeight,
            $viewport_width: null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.innerWidth,
            $lib: "web",
            $lib_version: $504220289e15410d$var$f.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: $504220289e15410d$var$K() / 1e3
        });
    },
    people_properties: function() {
        if (!$504220289e15410d$var$H) return {};
        var e = $504220289e15410d$var$u($504220289e15410d$var$yn.os($504220289e15410d$var$H), 2), t = e[0], n = e[1];
        return $504220289e15410d$var$J($504220289e15410d$var$te({
            $os: t,
            $os_version: n,
            $browser: $504220289e15410d$var$yn.browser($504220289e15410d$var$H, navigator.vendor)
        }), {
            $browser_version: $504220289e15410d$var$yn.browserVersion($504220289e15410d$var$H, navigator.vendor)
        });
    }
}, $504220289e15410d$var$bn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $504220289e15410d$var$kn = function() {
    function e(n) {
        $504220289e15410d$var$i(this, e), this.config = n, this.props = {}, this.campaign_params_saved = !1, this.name = function(e) {
            var t = "";
            return e.token && (t = e.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), e.persistence_name ? "ph_" + e.persistence_name : "ph_" + t + "_posthog";
        }(n), this.storage = this.buildStorage(n), this.load(), n.debug && $504220289e15410d$var$W.info("Persistence loaded", n.persistence, $504220289e15410d$var$t({}, this.props)), this.update_config(n, n), this.save();
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "buildStorage",
            value: function(e) {
                -1 === $504220289e15410d$var$bn.indexOf(e.persistence.toLowerCase()) && ($504220289e15410d$var$W.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
                var t = e.persistence.toLowerCase();
                return "localstorage" === t && $504220289e15410d$var$ut.is_supported() ? $504220289e15410d$var$ut : "localstorage+cookie" === t && $504220289e15410d$var$ct.is_supported() ? $504220289e15410d$var$ct : "sessionstorage" === t && $504220289e15410d$var$vt.is_supported() ? $504220289e15410d$var$vt : "memory" === t ? $504220289e15410d$var$ht : "cookie" === t ? $504220289e15410d$var$ot : $504220289e15410d$var$ct.is_supported() ? $504220289e15410d$var$ct : $504220289e15410d$var$ot;
            }
        },
        {
            key: "properties",
            value: function() {
                var e = {};
                return $504220289e15410d$var$Q(this.props, function(t, n) {
                    if (n === $504220289e15410d$var$xe && $504220289e15410d$var$b(t)) for(var i = Object.keys(t), r = 0; r < i.length; r++)e["$feature/".concat(i[r])] = t[i[r]];
                    else o = n, a = !1, ($504220289e15410d$var$I(s = $504220289e15410d$var$He) ? a : $504220289e15410d$var$M && s.indexOf === $504220289e15410d$var$M ? -1 != s.indexOf(o) : ($504220289e15410d$var$Q(s, function(e) {
                        if (a || (a = e === o)) return $504220289e15410d$var$V;
                    }), a)) || (e[n] = t);
                    var s, o, a;
                }), e;
            }
        },
        {
            key: "load",
            value: function() {
                if (!this.disabled) {
                    var e = this.storage.parse(this.name);
                    e && (this.props = $504220289e15410d$var$J({}, e));
                }
            }
        },
        {
            key: "save",
            value: function() {
                this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure, this.config.debug);
            }
        },
        {
            key: "remove",
            value: function() {
                this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
            }
        },
        {
            key: "clear",
            value: function() {
                this.remove(), this.props = {};
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var i = this;
                if ($504220289e15410d$var$b(e)) {
                    $504220289e15410d$var$w(t) && (t = "None"), this.expire_days = $504220289e15410d$var$w(n) ? this.default_expiry : n;
                    var r = !1;
                    if ($504220289e15410d$var$Q(e, function(e, n) {
                        i.props.hasOwnProperty(n) && i.props[n] !== t || (i.props[n] = e, r = !0);
                    }), r) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n = this;
                if ($504220289e15410d$var$b(e)) {
                    this.expire_days = $504220289e15410d$var$w(t) ? this.default_expiry : t;
                    var i = !1;
                    if ($504220289e15410d$var$Q(e, function(t, r) {
                        e.hasOwnProperty(r) && n.props[r] !== t && (n.props[r] = t, i = !0);
                    }), i) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "unregister",
            value: function(e) {
                e in this.props && (delete this.props[e], this.save());
            }
        },
        {
            key: "update_campaign_params",
            value: function() {
                this.campaign_params_saved || (this.register($504220289e15410d$var$yn.campaignParams(this.config.custom_campaign_params)), this.campaign_params_saved = !0);
            }
        },
        {
            key: "update_search_keyword",
            value: function() {
                this.register($504220289e15410d$var$yn.searchInfo());
            }
        },
        {
            key: "update_referrer_info",
            value: function() {
                this.register_once($504220289e15410d$var$yn.referrerInfo(), void 0);
            }
        },
        {
            key: "set_initial_person_info",
            value: function() {
                this.props[$504220289e15410d$var$Le] || this.props[$504220289e15410d$var$De] || this.register_once($504220289e15410d$var$o({}, $504220289e15410d$var$Ne, $504220289e15410d$var$yn.initialPersonInfo()), void 0);
            }
        },
        {
            key: "get_referrer_info",
            value: function() {
                return $504220289e15410d$var$te({
                    $referrer: this.props.$referrer,
                    $referring_domain: this.props.$referring_domain
                });
            }
        },
        {
            key: "get_initial_props",
            value: function() {
                var e = this, t = {};
                $504220289e15410d$var$Q([
                    $504220289e15410d$var$De,
                    $504220289e15410d$var$Le
                ], function(n) {
                    var i = e.props[n];
                    i && $504220289e15410d$var$Q(i, function(e, n) {
                        t["$initial_" + $504220289e15410d$var$ne(n)] = e;
                    });
                });
                var n = this.props[$504220289e15410d$var$Ne];
                if (n) {
                    var i = $504220289e15410d$var$yn.initialPersonPropsFromInfo(n);
                    $504220289e15410d$var$J(t, i);
                }
                return t;
            }
        },
        {
            key: "safe_merge",
            value: function(e) {
                return $504220289e15410d$var$Q(this.props, function(t, n) {
                    n in e || (e[n] = t);
                }), e;
            }
        },
        {
            key: "update_config",
            value: function(e, t) {
                if (this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), e.persistence !== t.persistence) {
                    var n = this.buildStorage(e), i = this.props;
                    this.clear(), this.storage = n, this.props = i, this.save();
                }
            }
        },
        {
            key: "set_disabled",
            value: function(e) {
                this.disabled = e, this.disabled ? this.remove() : this.save();
            }
        },
        {
            key: "set_cross_subdomain",
            value: function(e) {
                e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
            }
        },
        {
            key: "get_cross_subdomain",
            value: function() {
                return !!this.cross_subdomain;
            }
        },
        {
            key: "set_secure",
            value: function(e) {
                e !== this.secure && (this.secure = e, this.remove(), this.save());
            }
        },
        {
            key: "set_event_timer",
            value: function(e, t) {
                var n = this.props[$504220289e15410d$var$de] || {};
                n[e] = t, this.props[$504220289e15410d$var$de] = n, this.save();
            }
        },
        {
            key: "remove_event_timer",
            value: function(e) {
                var t = (this.props[$504220289e15410d$var$de] || {})[e];
                return $504220289e15410d$var$w(t) || (delete this.props[$504220289e15410d$var$de][e], this.save()), t;
            }
        },
        {
            key: "get_property",
            value: function(e) {
                return this.props[e];
            }
        },
        {
            key: "set_property",
            value: function(e, t) {
                this.props[e] = t, this.save();
            }
        }
    ]), e;
}();
function $504220289e15410d$var$wn(e) {
    var t;
    return JSON.stringify(e, (t = [], function(e, n) {
        if ($504220289e15410d$var$b(n)) {
            for(; t.length > 0 && t.at(-1) !== this;)t.pop();
            return t.includes(n) ? "[Circular]" : (t.push(n), n);
        }
        return n;
    })).length;
}
function $504220289e15410d$var$Sn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6606028.8;
    if (e.size >= t && e.data.length > 1) {
        var n = Math.floor(e.data.length / 2), i = e.data.slice(0, n), r = e.data.slice(n);
        return [
            $504220289e15410d$var$Sn({
                size: $504220289e15410d$var$wn(i),
                data: i,
                sessionId: e.sessionId,
                windowId: e.windowId
            }),
            $504220289e15410d$var$Sn({
                size: $504220289e15410d$var$wn(r),
                data: r,
                sessionId: e.sessionId,
                windowId: e.windowId
            })
        ].flatMap(function(e) {
            return e;
        });
    }
    return [
        e
    ];
}
var $504220289e15410d$var$En = function(e) {
    return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
}($504220289e15410d$var$En || {}), $504220289e15410d$var$In = function(e) {
    return e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e;
}($504220289e15410d$var$In || {});
function $504220289e15410d$var$xn(e) {
    return e ? $504220289e15410d$var$z(e).split(/\s+/) : [];
}
function $504220289e15410d$var$Fn(e) {
    var t = null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.location.href;
    return !!(t && e && e.some(function(e) {
        return t.match(e);
    }));
}
function $504220289e15410d$var$Rn(e) {
    var t = "";
    switch($504220289e15410d$var$n(e.className)){
        case "string":
            t = e.className;
            break;
        case "object":
            t = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return $504220289e15410d$var$xn(t);
}
function $504220289e15410d$var$Pn(e) {
    return $504220289e15410d$var$x(e) ? null : $504220289e15410d$var$z(e).split(/(\s+)/).filter(function(e) {
        return $504220289e15410d$var$zn(e);
    }).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $504220289e15410d$var$Tn(e) {
    var t = "";
    return $504220289e15410d$var$Nn(e) && !$504220289e15410d$var$qn(e) && e.childNodes && e.childNodes.length && $504220289e15410d$var$Q(e.childNodes, function(e) {
        var n;
        $504220289e15410d$var$$n(e) && e.textContent && (t += null !== (n = $504220289e15410d$var$Pn(e.textContent)) && void 0 !== n ? n : "");
    }), $504220289e15410d$var$z(t);
}
function $504220289e15410d$var$Cn(e) {
    return !!e && 1 === e.nodeType;
}
function $504220289e15410d$var$On(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function $504220289e15410d$var$$n(e) {
    return !!e && 3 === e.nodeType;
}
function $504220289e15410d$var$Mn(e) {
    return !!e && 11 === e.nodeType;
}
var $504220289e15410d$var$An = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $504220289e15410d$var$Ln(e) {
    var t = e.parentNode;
    return !(!t || !$504220289e15410d$var$Cn(t)) && t;
}
function $504220289e15410d$var$Dn(e, t) {
    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0, s = arguments.length > 4 ? arguments[4] : void 0;
    if (!$504220289e15410d$var$T || !e || $504220289e15410d$var$On(e, "html") || !$504220289e15410d$var$Cn(e)) return !1;
    if (null != i && i.url_allowlist && !$504220289e15410d$var$Fn(i.url_allowlist)) return !1;
    if (null != i && i.url_ignorelist && $504220289e15410d$var$Fn(i.url_ignorelist)) return !1;
    if (null != i && i.dom_event_allowlist) {
        var o = i.dom_event_allowlist;
        if (o && !o.some(function(e) {
            return t.type === e;
        })) return !1;
    }
    for(var a = !1, u = [
        e
    ], l = !0, c = e; c.parentNode && !$504220289e15410d$var$On(c, "body");)if ($504220289e15410d$var$Mn(c.parentNode)) u.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (!(l = $504220289e15410d$var$Ln(c))) break;
        if (r || $504220289e15410d$var$An.indexOf(l.tagName.toLowerCase()) > -1) a = !0;
        else {
            var d = $504220289e15410d$var$T.getComputedStyle(l);
            d && "pointer" === d.getPropertyValue("cursor") && (a = !0);
        }
        u.push(l), c = l;
    }
    if (!function(e, t) {
        var i = null == t ? void 0 : t.element_allowlist;
        if ($504220289e15410d$var$w(i)) return !0;
        var r, s = $504220289e15410d$var$h(e);
        try {
            var o = function() {
                var e = r.value;
                if (i.some(function(t) {
                    return e.tagName.toLowerCase() === t;
                })) return {
                    v: !0
                };
            };
            for(s.s(); !(r = s.n()).done;){
                var a = o();
                if ("object" === $504220289e15410d$var$n(a)) return a.v;
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
        return !1;
    }(u, i)) return !1;
    if (!function(e, t) {
        var i = null == t ? void 0 : t.css_selector_allowlist;
        if ($504220289e15410d$var$w(i)) return !0;
        var r, s = $504220289e15410d$var$h(e);
        try {
            var o = function() {
                var e = r.value;
                if (i.some(function(t) {
                    return e.matches(t);
                })) return {
                    v: !0
                };
            };
            for(s.s(); !(r = s.n()).done;){
                var a = o();
                if ("object" === $504220289e15410d$var$n(a)) return a.v;
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
        return !1;
    }(u, i)) return !1;
    var f = $504220289e15410d$var$T.getComputedStyle(e);
    if (f && "pointer" === f.getPropertyValue("cursor") && "click" === t.type) return !0;
    var v = e.tagName.toLowerCase();
    switch(v){
        case "html":
            return !1;
        case "form":
            return (s || [
                "submit"
            ]).indexOf(t.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (s || [
                "change",
                "click"
            ]).indexOf(t.type) >= 0;
        default:
            return a ? (s || [
                "click"
            ]).indexOf(t.type) >= 0 : (s || [
                "click"
            ]).indexOf(t.type) >= 0 && ($504220289e15410d$var$An.indexOf(v) > -1 || "true" === e.getAttribute("contenteditable"));
    }
}
function $504220289e15410d$var$Nn(e) {
    for(var t = e; t.parentNode && !$504220289e15410d$var$On(t, "body"); t = t.parentNode){
        var n = $504220289e15410d$var$Rn(t);
        if ($504220289e15410d$var$Y(n, "ph-sensitive") || $504220289e15410d$var$Y(n, "ph-no-capture")) return !1;
    }
    if ($504220289e15410d$var$Y($504220289e15410d$var$Rn(e), "ph-include")) return !0;
    var i = e.type || "";
    if ($504220289e15410d$var$S(i)) switch(i.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var r = e.name || e.id || "";
    if ($504220289e15410d$var$S(r)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(r.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $504220289e15410d$var$qn(e) {
    return !!($504220289e15410d$var$On(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || $504220289e15410d$var$On(e, "select") || $504220289e15410d$var$On(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
var $504220289e15410d$var$Bn = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $504220289e15410d$var$Hn = new RegExp("^(?:".concat($504220289e15410d$var$Bn, ")$")), $504220289e15410d$var$Un = new RegExp($504220289e15410d$var$Bn), $504220289e15410d$var$jn = "\\d{3}-?\\d{2}-?\\d{4}", $504220289e15410d$var$Wn = new RegExp("^(".concat($504220289e15410d$var$jn, ")$")), $504220289e15410d$var$Vn = new RegExp("(".concat($504220289e15410d$var$jn, ")"));
function $504220289e15410d$var$zn(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    if ($504220289e15410d$var$x(e)) return !1;
    if ($504220289e15410d$var$S(e)) {
        if (e = $504220289e15410d$var$z(e), (t ? $504220289e15410d$var$Hn : $504220289e15410d$var$Un).test((e || "").replace(/[- ]/g, ""))) return !1;
        if ((t ? $504220289e15410d$var$Wn : $504220289e15410d$var$Vn).test(e)) return !1;
    }
    return !0;
}
function $504220289e15410d$var$Gn(e) {
    var t = $504220289e15410d$var$Tn(e);
    return $504220289e15410d$var$zn(t = "".concat(t, " ").concat($504220289e15410d$var$Qn(e)).trim()) ? t : "";
}
function $504220289e15410d$var$Qn(e) {
    var t = "";
    return e && e.childNodes && e.childNodes.length && $504220289e15410d$var$Q(e.childNodes, function(e) {
        var n;
        if (e && "span" === (null === (n = e.tagName) || void 0 === n ? void 0 : n.toLowerCase())) try {
            var i = $504220289e15410d$var$Tn(e);
            t = "".concat(t, " ").concat(i).trim(), e.childNodes && e.childNodes.length && (t = "".concat(t, " ").concat($504220289e15410d$var$Qn(e)).trim());
        } catch (e) {
            $504220289e15410d$var$W.error(e);
        }
    }), t;
}
function $504220289e15410d$var$Jn(e) {
    return function(e) {
        var n = e.map(function(e) {
            var n, i, r = "";
            if (e.tag_name && (r += e.tag_name), e.attr_class) {
                e.attr_class.sort();
                var s, o = $504220289e15410d$var$h(e.attr_class);
                try {
                    for(o.s(); !(s = o.n()).done;){
                        var a = s.value;
                        r += ".".concat(a.replace(/"/g, ""));
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
            }
            var l = $504220289e15410d$var$t($504220289e15410d$var$t($504220289e15410d$var$t($504220289e15410d$var$t({}, e.text ? {
                text: e.text
            } : {}), {}, {
                "nth-child": null !== (n = e.nth_child) && void 0 !== n ? n : 0,
                "nth-of-type": null !== (i = e.nth_of_type) && void 0 !== i ? i : 0
            }, e.href ? {
                href: e.href
            } : {}), e.attr_id ? {
                attr_id: e.attr_id
            } : {}), e.attributes), c = {};
            return $504220289e15410d$var$X(l).sort(function(e, t) {
                var n = $504220289e15410d$var$u(e, 1)[0], i = $504220289e15410d$var$u(t, 1)[0];
                return n.localeCompare(i);
            }).forEach(function(e) {
                var t = $504220289e15410d$var$u(e, 2), n = t[0], i = t[1];
                return c[$504220289e15410d$var$Yn(n.toString())] = $504220289e15410d$var$Yn(i.toString());
            }), r += ":", r += $504220289e15410d$var$X(l).map(function(e) {
                var t = $504220289e15410d$var$u(e, 2), n = t[0], i = t[1];
                return "".concat(n, '="').concat(i, '"');
            }).join("");
        });
        return n.join(";");
    }(function(e) {
        return e.map(function(e) {
            var t, n, i = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (n = e.attr__href) || void 0 === n ? void 0 : n.slice(0, 2048),
                attr_class: $504220289e15410d$var$Xn(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return $504220289e15410d$var$X(e).filter(function(e) {
                return 0 === $504220289e15410d$var$u(e, 1)[0].indexOf("attr__");
            }).forEach(function(e) {
                var t = $504220289e15410d$var$u(e, 2), n = t[0], r = t[1];
                return i.attributes[n] = r;
            }), i;
        });
    }(e));
}
function $504220289e15410d$var$Yn(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function $504220289e15410d$var$Xn(e) {
    var t = e.attr__class;
    return t ? $504220289e15410d$var$m(t) ? t : $504220289e15410d$var$xn(t) : void 0;
}
var $504220289e15410d$var$Kn = "[SessionRecording]", $504220289e15410d$var$Zn = "redacted", $504220289e15410d$var$ei = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: function(e) {
        return e;
    },
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io"
    ]
}, $504220289e15410d$var$ti = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $504220289e15410d$var$ni = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $504220289e15410d$var$ii = [
    "/s/",
    "/e/",
    "/i/"
];
function $504220289e15410d$var$ri(e, t, n, i) {
    if ($504220289e15410d$var$x(e)) return e;
    var r = (null == t ? void 0 : t["content-length"]) || function(e) {
        return new Blob([
            e
        ]).size;
    }(e);
    return $504220289e15410d$var$S(r) && (r = parseInt(r)), r > n ? $504220289e15410d$var$Kn + " ".concat(i, " body too large to record (").concat(r, " bytes)") : e;
}
function $504220289e15410d$var$si(e, t) {
    if ($504220289e15410d$var$x(e)) return e;
    var n = e;
    return $504220289e15410d$var$zn(n, !1) || (n = $504220289e15410d$var$Kn + " " + t + " body " + $504220289e15410d$var$Zn), $504220289e15410d$var$Q($504220289e15410d$var$ni, function(e) {
        var i, r;
        null !== (i = n) && void 0 !== i && i.length && -1 !== (null === (r = n) || void 0 === r ? void 0 : r.indexOf(e)) && (n = $504220289e15410d$var$Kn + " " + t + " body " + $504220289e15410d$var$Zn + " as might contain: " + e);
    }), n;
}
var $504220289e15410d$var$oi, $504220289e15410d$var$ai = function(e, n) {
    var i, r, s, o = {
        payloadSizeLimitBytes: $504220289e15410d$var$ei.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: $504220289e15410d$var$l($504220289e15410d$var$ei.performanceEntryTypeToObserve),
        payloadHostDenyList: [].concat($504220289e15410d$var$l(n.payloadHostDenyList || []), $504220289e15410d$var$l($504220289e15410d$var$ei.payloadHostDenyList))
    }, a = !1 !== e.session_recording.recordHeaders && n.recordHeaders, u = !1 !== e.session_recording.recordBody && n.recordBody, c = !1 !== e.capture_performance && n.recordPerformance, d = (i = o, s = Math.min(1e6, null !== (r = i.payloadSizeLimitBytes) && void 0 !== r ? r : 1e6), function(e) {
        return null != e && e.requestBody && (e.requestBody = $504220289e15410d$var$ri(e.requestBody, e.requestHeaders, s, "Request")), null != e && e.responseBody && (e.responseBody = $504220289e15410d$var$ri(e.responseBody, e.responseHeaders, s, "Response")), e;
    }), h = function(e) {
        var t, n;
        return d(function(e) {
            var t = $504220289e15410d$var$gt(e.name);
            if (!(t && t.pathname && $504220289e15410d$var$ii.some(function(e) {
                return 0 === t.pathname.indexOf(e);
            }))) return e;
        }((n = (t = e).requestHeaders, $504220289e15410d$var$x(n) || $504220289e15410d$var$Q(Object.keys(null != n ? n : {}), function(e) {
            $504220289e15410d$var$ti.includes(e.toLowerCase()) && (n[e] = $504220289e15410d$var$Zn);
        }), t)));
    }, f = $504220289e15410d$var$y(e.session_recording.maskNetworkRequestFn);
    return f && $504220289e15410d$var$y(e.session_recording.maskCapturedNetworkRequestFn) && $504220289e15410d$var$W.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), f && (e.session_recording.maskCapturedNetworkRequestFn = function(n) {
        var i = e.session_recording.maskNetworkRequestFn({
            url: n.name
        });
        return $504220289e15410d$var$t($504220289e15410d$var$t({}, n), {}, {
            name: null == i ? void 0 : i.url
        });
    }), o.maskRequestFn = $504220289e15410d$var$y(e.session_recording.maskCapturedNetworkRequestFn) ? function(t) {
        var n, i, r, s = h(t);
        return s && null !== (n = null === (i = (r = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === i ? void 0 : i.call(r, s)) && void 0 !== n ? n : void 0;
    } : function(e) {
        return function(e) {
            if (!$504220289e15410d$var$w(e)) return e.requestBody = $504220289e15410d$var$si(e.requestBody, "Request"), e.responseBody = $504220289e15410d$var$si(e.responseBody, "Response"), e;
        }(h(e));
    }, $504220289e15410d$var$t($504220289e15410d$var$t($504220289e15410d$var$t({}, $504220289e15410d$var$ei), o), {}, {
        recordHeaders: a,
        recordBody: u,
        recordPerformance: c,
        recordInitialRequests: c
    });
}, $504220289e15410d$var$ui = $504220289e15410d$var$s(function e(t) {
    var n, r, s = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "bucketSize", 100), $504220289e15410d$var$o(this, "refillRate", 10), $504220289e15410d$var$o(this, "mutationBuckets", {}), $504220289e15410d$var$o(this, "loggedTracker", {}), $504220289e15410d$var$o(this, "refillBuckets", function() {
        Object.keys(s.mutationBuckets).forEach(function(e) {
            s.mutationBuckets[e] = s.mutationBuckets[e] + s.refillRate, s.mutationBuckets[e] >= s.bucketSize && delete s.mutationBuckets[e];
        });
    }), $504220289e15410d$var$o(this, "getNodeOrRelevantParent", function(e) {
        var t = s.rrweb.mirror.getNode(e);
        if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
            var n = t.closest("svg");
            if (n) return [
                s.rrweb.mirror.getId(n),
                n
            ];
        }
        return [
            e,
            t
        ];
    }), $504220289e15410d$var$o(this, "numberOfChanges", function(e) {
        var t, n, i, r, s, o, a, u;
        return (null !== (t = null === (n = e.removes) || void 0 === n ? void 0 : n.length) && void 0 !== t ? t : 0) + (null !== (i = null === (r = e.attributes) || void 0 === r ? void 0 : r.length) && void 0 !== i ? i : 0) + (null !== (s = null === (o = e.texts) || void 0 === o ? void 0 : o.length) && void 0 !== s ? s : 0) + (null !== (a = null === (u = e.adds) || void 0 === u ? void 0 : u.length) && void 0 !== a ? a : 0);
    }), $504220289e15410d$var$o(this, "throttleMutations", function(e) {
        if (3 !== e.type || 0 !== e.data.source) return e;
        var t = e.data, n = s.numberOfChanges(t);
        t.attributes && (t.attributes = t.attributes.filter(function(e) {
            var t, n, i, r = $504220289e15410d$var$u(s.getNodeOrRelevantParent(e.id), 2), o = r[0], a = r[1];
            if (0 === s.mutationBuckets[o]) return !1;
            (s.mutationBuckets[o] = null !== (t = s.mutationBuckets[o]) && void 0 !== t ? t : s.bucketSize, s.mutationBuckets[o] = Math.max(s.mutationBuckets[o] - 1, 0), 0 === s.mutationBuckets[o]) && (s.loggedTracker[o] || (s.loggedTracker[o] = !0, null === (n = (i = s.options).onBlockedNode) || void 0 === n || n.call(i, o, a)));
            return e;
        }));
        var i = s.numberOfChanges(t);
        return 0 !== i || n === i ? e : void 0;
    }), this.rrweb = t, this.options = a, this.refillRate = null !== (n = this.options.refillRate) && void 0 !== n ? n : this.refillRate, this.bucketSize = null !== (r = this.options.bucketSize) && void 0 !== r ? r : this.bucketSize, setInterval(function() {
        s.refillBuckets();
    }, 1e3);
}), $504220289e15410d$var$li = 3e5, $504220289e15410d$var$ci = $504220289e15410d$var$li, $504220289e15410d$var$di = [
    $504220289e15410d$var$In.MouseMove,
    $504220289e15410d$var$In.MouseInteraction,
    $504220289e15410d$var$In.Scroll,
    $504220289e15410d$var$In.ViewportResize,
    $504220289e15410d$var$In.Input,
    $504220289e15410d$var$In.TouchMove,
    $504220289e15410d$var$In.MediaInteraction,
    $504220289e15410d$var$In.Drag
], $504220289e15410d$var$hi = function(e) {
    return {
        rrwebMethod: e,
        enqueuedAt: Date.now(),
        attempt: 1
    };
}, $504220289e15410d$var$fi = "[SessionRecording]", $504220289e15410d$var$vi = function() {
    function e(t) {
        var n = this;
        if ($504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "queuedRRWebEvents", []), $504220289e15410d$var$o(this, "isIdle", !1), $504220289e15410d$var$o(this, "_linkedFlagSeen", !1), $504220289e15410d$var$o(this, "_lastActivityTimestamp", Date.now()), $504220289e15410d$var$o(this, "_linkedFlag", null), $504220289e15410d$var$o(this, "_removePageViewCaptureHook", void 0), $504220289e15410d$var$o(this, "_onSessionIdListener", void 0), $504220289e15410d$var$o(this, "_persistDecideOnSessionListener", void 0), $504220289e15410d$var$o(this, "_samplingSessionListener", void 0), $504220289e15410d$var$o(this, "_forceAllowLocalhostNetworkCapture", !1), $504220289e15410d$var$o(this, "_onBeforeUnload", function() {
            n._flushBuffer();
        }), $504220289e15410d$var$o(this, "_onOffline", function() {
            n._tryAddCustomEvent("browser offline", {});
        }), $504220289e15410d$var$o(this, "_onOnline", function() {
            n._tryAddCustomEvent("browser online", {});
        }), $504220289e15410d$var$o(this, "_onVisibilityChange", function() {
            if (null != $504220289e15410d$var$L && $504220289e15410d$var$L.visibilityState) {
                var e = "window " + $504220289e15410d$var$L.visibilityState;
                n._tryAddCustomEvent(e, {});
            }
        }), this.instance = t, this._captureStarted = !1, this._endpoint = "/s/", this.stopRrweb = void 0, this.receivedDecide = !1, !this.instance.sessionManager) throw $504220289e15410d$var$W.error($504220289e15410d$var$fi + " started without valid sessionManager"), new Error($504220289e15410d$var$fi + " started without valid sessionManager. This is a bug.");
        var r = this.sessionManager.checkAndGetSessionAndWindowId(), s = r.sessionId, a = r.windowId;
        this.sessionId = s, this.windowId = a, this.buffer = this.clearBuffer();
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "rrwebRecord",
            get: function() {
                var e;
                return null == $504220289e15410d$var$U || null === (e = $504220289e15410d$var$U.rrweb) || void 0 === e ? void 0 : e.record;
            }
        },
        {
            key: "started",
            get: function() {
                return this._captureStarted;
            }
        },
        {
            key: "sessionManager",
            get: function() {
                if (!this.instance.sessionManager) throw new Error($504220289e15410d$var$fi + " must be started with a valid sessionManager.");
                return this.instance.sessionManager;
            }
        },
        {
            key: "fullSnapshotIntervalMillis",
            get: function() {
                var e;
                return (null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.full_snapshot_interval_millis) || $504220289e15410d$var$li;
            }
        },
        {
            key: "isSampled",
            get: function() {
                var e = this.instance.get_property($504220289e15410d$var$Ie);
                return $504220289e15410d$var$R(e) ? e : null;
            }
        },
        {
            key: "sessionDuration",
            get: function() {
                var e, t, n = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], i = this.sessionManager.checkAndGetSessionAndWindowId(!0).sessionStartTimestamp;
                return n ? n.timestamp - i : null;
            }
        },
        {
            key: "isRecordingEnabled",
            get: function() {
                var e = !!this.instance.get_property($504220289e15410d$var$me), t = !this.instance.config.disable_session_recording;
                return $504220289e15410d$var$T && e && t;
            }
        },
        {
            key: "isConsoleLogCaptureEnabled",
            get: function() {
                var e = !!this.instance.get_property($504220289e15410d$var$ye), t = this.instance.config.enable_recording_console_log;
                return null != t ? t : e;
            }
        },
        {
            key: "canvasRecording",
            get: function() {
                var e = this.instance.get_property($504220289e15410d$var$ke);
                return e && e.fps && e.quality ? {
                    enabled: e.enabled,
                    fps: e.fps,
                    quality: e.quality
                } : void 0;
            }
        },
        {
            key: "networkPayloadCapture",
            get: function() {
                var e, t, n = this.instance.get_property($504220289e15410d$var$be), i = {
                    recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
                    recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
                }, r = (null == i ? void 0 : i.recordHeaders) || (null == n ? void 0 : n.recordHeaders), s = (null == i ? void 0 : i.recordBody) || (null == n ? void 0 : n.recordBody), o = $504220289e15410d$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.network_timing : this.instance.config.capture_performance, a = !!($504220289e15410d$var$R(o) ? o : null == n ? void 0 : n.capturePerformance);
                return r || s || a ? {
                    recordHeaders: r,
                    recordBody: s,
                    recordPerformance: a
                } : void 0;
            }
        },
        {
            key: "sampleRate",
            get: function() {
                var e = this.instance.get_property($504220289e15410d$var$we);
                return $504220289e15410d$var$F(e) ? e : null;
            }
        },
        {
            key: "minimumDuration",
            get: function() {
                var e = this.instance.get_property($504220289e15410d$var$Se);
                return $504220289e15410d$var$F(e) ? e : null;
            }
        },
        {
            key: "status",
            get: function() {
                return this.receivedDecide ? this.isRecordingEnabled ? $504220289e15410d$var$x(this._linkedFlag) || this._linkedFlagSeen ? $504220289e15410d$var$R(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "buffering" : "disabled" : "buffering";
            }
        },
        {
            key: "startIfEnabledOrStop",
            value: function() {
                var e = this;
                this.isRecordingEnabled ? (this._startCapture(), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("beforeunload", this._onBeforeUnload), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("offline", this._onOffline), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("online", this._onOnline), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("visibilitychange", this._onVisibilityChange), this._setupSampling(), $504220289e15410d$var$x(this._removePageViewCaptureHook) && (this._removePageViewCaptureHook = this.instance._addCaptureHook(function(t) {
                    try {
                        if ("$pageview" === t) {
                            var n = $504220289e15410d$var$T ? e._maskUrl($504220289e15410d$var$T.location.href) : "";
                            if (!n) return;
                            e._tryAddCustomEvent("$pageview", {
                                href: n
                            });
                        }
                    } catch (e) {
                        $504220289e15410d$var$W.error("Could not add $pageview to rrweb session", e);
                    }
                })), this._onSessionIdListener || (this._onSessionIdListener = this.sessionManager.onSessionId(function(t, n, i) {
                    i && e._tryAddCustomEvent("$session_id_change", {
                        sessionId: t,
                        windowId: n,
                        changeReason: i
                    });
                })), $504220289e15410d$var$W.info($504220289e15410d$var$fi + " started")) : this.stopRecording();
            }
        },
        {
            key: "stopRecording",
            value: function() {
                var e, t, n;
                this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1, null == $504220289e15410d$var$T || $504220289e15410d$var$T.removeEventListener("beforeunload", this._onBeforeUnload), null == $504220289e15410d$var$T || $504220289e15410d$var$T.removeEventListener("offline", this._onOffline), null == $504220289e15410d$var$T || $504220289e15410d$var$T.removeEventListener("online", this._onOnline), null == $504220289e15410d$var$T || $504220289e15410d$var$T.removeEventListener("visibilitychange", this._onVisibilityChange), this.clearBuffer(), clearInterval(this._fullSnapshotTimer), null === (e = this._removePageViewCaptureHook) || void 0 === e || e.call(this), this._removePageViewCaptureHook = void 0, null === (t = this._onSessionIdListener) || void 0 === t || t.call(this), this._onSessionIdListener = void 0, null === (n = this._samplingSessionListener) || void 0 === n || n.call(this), this._samplingSessionListener = void 0, $504220289e15410d$var$W.info($504220289e15410d$var$fi + " stopped"));
            }
        },
        {
            key: "makeSamplingDecision",
            value: function(e) {
                var t, n = this.sessionId !== e, i = this.sampleRate;
                if ($504220289e15410d$var$F(i)) {
                    var r, s = this.isSampled, a = n || !$504220289e15410d$var$R(s);
                    if (a) r = Math.random() < i;
                    else r = s;
                    !r && a && $504220289e15410d$var$W.warn($504220289e15410d$var$fi + " Sample rate (".concat(i, ") has determined that this sessionId (").concat(e, ") will not be sent to the server.")), this._tryAddCustomEvent("samplingDecisionMade", {
                        sampleRate: i
                    }), null === (t = this.instance.persistence) || void 0 === t || t.register($504220289e15410d$var$o({}, $504220289e15410d$var$Ie, r));
                } else {
                    var u;
                    null === (u = this.instance.persistence) || void 0 === u || u.register($504220289e15410d$var$o({}, $504220289e15410d$var$Ie, null));
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t, n, i, r = this;
                (this._persistDecideResponse(e), this._linkedFlag = (null === (t = e.sessionRecording) || void 0 === t ? void 0 : t.linkedFlag) || null, null !== (n = e.sessionRecording) && void 0 !== n && n.endpoint) && (this._endpoint = null === (i = e.sessionRecording) || void 0 === i ? void 0 : i.endpoint);
                if (this._setupSampling(), !$504220289e15410d$var$x(this._linkedFlag) && !this._linkedFlagSeen) {
                    var s = $504220289e15410d$var$S(this._linkedFlag) ? this._linkedFlag : this._linkedFlag.flag, o = $504220289e15410d$var$S(this._linkedFlag) ? null : this._linkedFlag.variant;
                    this.instance.onFeatureFlags(function(e, t) {
                        var n = $504220289e15410d$var$b(t) && s in t, i = o ? t[s] === o : n;
                        if (i) {
                            var a = {
                                linkedFlag: s,
                                linkedVariant: o
                            }, u = "linked flag matched";
                            $504220289e15410d$var$W.info($504220289e15410d$var$fi + " " + u, a), r._tryAddCustomEvent(u, a);
                        }
                        r._linkedFlagSeen = i;
                    });
                }
                this.receivedDecide = !0, this.startIfEnabledOrStop();
            }
        },
        {
            key: "_setupSampling",
            value: function() {
                var e = this;
                $504220289e15410d$var$F(this.sampleRate) && $504220289e15410d$var$x(this._samplingSessionListener) && (this._samplingSessionListener = this.sessionManager.onSessionId(function(t) {
                    e.makeSamplingDecision(t);
                }));
            }
        },
        {
            key: "_persistDecideResponse",
            value: function(e) {
                if (this.instance.persistence) {
                    var n, i = this.instance.persistence, r = function() {
                        var n, r, s, a, u, l, c, d, h = null === (n = e.sessionRecording) || void 0 === n ? void 0 : n.sampleRate, f = $504220289e15410d$var$x(h) ? null : parseFloat(h), v = null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.minimumDurationMilliseconds;
                        i.register(($504220289e15410d$var$o(d = {}, $504220289e15410d$var$me, !!e.sessionRecording), $504220289e15410d$var$o(d, $504220289e15410d$var$ye, null === (s = e.sessionRecording) || void 0 === s ? void 0 : s.consoleLogRecordingEnabled), $504220289e15410d$var$o(d, $504220289e15410d$var$be, $504220289e15410d$var$t({
                            capturePerformance: e.capturePerformance
                        }, null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.networkPayloadCapture)), $504220289e15410d$var$o(d, $504220289e15410d$var$ke, {
                            enabled: null === (u = e.sessionRecording) || void 0 === u ? void 0 : u.recordCanvas,
                            fps: null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.canvasFps,
                            quality: null === (c = e.sessionRecording) || void 0 === c ? void 0 : c.canvasQuality
                        }), $504220289e15410d$var$o(d, $504220289e15410d$var$we, f), $504220289e15410d$var$o(d, $504220289e15410d$var$Se, $504220289e15410d$var$w(v) ? null : v), d));
                    };
                    r(), null === (n = this._persistDecideOnSessionListener) || void 0 === n || n.call(this), this._persistDecideOnSessionListener = this.sessionManager.onSessionId(r);
                }
            }
        },
        {
            key: "log",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
                null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
                    type: 6,
                    data: {
                        plugin: "rrweb/console@1",
                        payload: {
                            level: n,
                            trace: [],
                            payload: [
                                JSON.stringify(e)
                            ]
                        }
                    },
                    timestamp: $504220289e15410d$var$K()
                });
            }
        },
        {
            key: "_startCapture",
            value: function() {
                var e = this;
                $504220289e15410d$var$w(Object.assign) || this._captureStarted || this.instance.config.disable_session_recording || this.instance.consent.isOptedOut() || (this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId(), this.rrwebRecord ? this._onScriptLoaded() : this.instance.requestRouter.loadScript("/static/recorder.js?v=".concat($504220289e15410d$var$f.LIB_VERSION), function(t) {
                    if (t) return $504220289e15410d$var$W.error($504220289e15410d$var$fi + " could not load recorder.js", t);
                    e._onScriptLoaded();
                }));
            }
        },
        {
            key: "isInteractiveEvent",
            value: function(e) {
                var t;
                return 3 === e.type && -1 !== $504220289e15410d$var$di.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
            }
        },
        {
            key: "_updateWindowAndSessionIds",
            value: function(e) {
                var t = this.isInteractiveEvent(e);
                t || this.isIdle || e.timestamp - this._lastActivityTimestamp > $504220289e15410d$var$ci && (this.isIdle = !0, clearInterval(this._fullSnapshotTimer), this._tryAddCustomEvent("sessionIdle", {
                    eventTimestamp: e.timestamp,
                    lastActivityTimestamp: this._lastActivityTimestamp,
                    threshold: $504220289e15410d$var$ci,
                    bufferLength: this.buffer.data.length,
                    bufferSize: this.buffer.size
                }), this._flushBuffer());
                var n = !1;
                if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
                    reason: "user activity",
                    type: e.type
                }), n = !0)), !this.isIdle) {
                    var i = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), r = i.windowId, s = i.sessionId, o = this.sessionId !== s, a = this.windowId !== r;
                    this.windowId = r, this.sessionId = s, o || a ? (this.stopRecording(), this.startIfEnabledOrStop()) : n && this._scheduleFullSnapshot();
                }
            }
        },
        {
            key: "_tryRRWebMethod",
            value: function(e) {
                try {
                    return e.rrwebMethod(), !0;
                } catch (t) {
                    return this.queuedRRWebEvents.length < 10 ? this.queuedRRWebEvents.push({
                        enqueuedAt: e.enqueuedAt || Date.now(),
                        attempt: e.attempt++,
                        rrwebMethod: e.rrwebMethod
                    }) : $504220289e15410d$var$W.warn($504220289e15410d$var$fi + " could not emit queued rrweb event.", t, e), !1;
                }
            }
        },
        {
            key: "_tryAddCustomEvent",
            value: function(e, t) {
                var n = this;
                return this._tryRRWebMethod($504220289e15410d$var$hi(function() {
                    return n.rrwebRecord.addCustomEvent(e, t);
                }));
            }
        },
        {
            key: "_tryTakeFullSnapshot",
            value: function() {
                var e = this;
                return this._tryRRWebMethod($504220289e15410d$var$hi(function() {
                    return e.rrwebRecord.takeFullSnapshot();
                }));
            }
        },
        {
            key: "_onScriptLoaded",
            value: function() {
                for(var e, n = this, i = {
                    blockClass: "ph-no-capture",
                    blockSelector: void 0,
                    ignoreClass: "ph-ignore-input",
                    maskTextClass: "ph-mask",
                    maskTextSelector: void 0,
                    maskTextFn: void 0,
                    maskAllInputs: !0,
                    maskInputOptions: {
                        password: !0
                    },
                    maskInputFn: void 0,
                    slimDOMOptions: {},
                    collectFonts: !1,
                    inlineStylesheet: !0,
                    recordCrossOriginIframes: !1
                }, r = this.instance.config.session_recording, s = 0, o = Object.entries(r || {}); s < o.length; s++){
                    var a = $504220289e15410d$var$u(o[s], 2), l = a[0], c = a[1];
                    l in i && ("maskInputOptions" === l ? i.maskInputOptions = $504220289e15410d$var$t({
                        password: !0
                    }, c) : i[l] = c);
                }
                if (this.canvasRecording && this.canvasRecording.enabled && (i.recordCanvas = !0, i.sampling = {
                    canvas: this.canvasRecording.fps
                }, i.dataURLOptions = {
                    type: "image/webp",
                    quality: this.canvasRecording.quality
                }), this.rrwebRecord) {
                    this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new $504220289e15410d$var$ui(this.rrwebRecord, {
                        onBlockedNode: function(e, t) {
                            var i = "Too many mutations on node '".concat(e, "'. Rate limiting. This could be due to SVG animations or something similar");
                            $504220289e15410d$var$W.info(i, {
                                node: t
                            }), n.log($504220289e15410d$var$fi + " " + i, "warn");
                        }
                    });
                    var d = this._gatherRRWebPlugins();
                    this.stopRrweb = this.rrwebRecord($504220289e15410d$var$t({
                        emit: function(e) {
                            n.onRRwebEmit(e);
                        },
                        plugins: d
                    }, i)), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
                        sessionRecordingOptions: i,
                        activePlugins: d.map(function(e) {
                            return null == e ? void 0 : e.name;
                        })
                    }), this._tryAddCustomEvent("$posthog_config", {
                        config: this.instance.config
                    });
                } else $504220289e15410d$var$W.error($504220289e15410d$var$fi + "onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
            }
        },
        {
            key: "_scheduleFullSnapshot",
            value: function() {
                var e = this;
                if (this._fullSnapshotTimer && clearInterval(this._fullSnapshotTimer), !this.isIdle) {
                    var t = this.fullSnapshotIntervalMillis;
                    t && (this._fullSnapshotTimer = setInterval(function() {
                        e._tryTakeFullSnapshot();
                    }, t));
                }
            }
        },
        {
            key: "_gatherRRWebPlugins",
            value: function() {
                var e = [];
                ($504220289e15410d$var$U.rrwebConsoleRecord && this.isConsoleLogCaptureEnabled && e.push($504220289e15410d$var$U.rrwebConsoleRecord.getRecordConsolePlugin()), this.networkPayloadCapture && $504220289e15410d$var$y($504220289e15410d$var$U.getRecordNetworkPlugin)) && (!$504220289e15410d$var$pt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push($504220289e15410d$var$U.getRecordNetworkPlugin($504220289e15410d$var$ai(this.instance.config, this.networkPayloadCapture))) : $504220289e15410d$var$W.info($504220289e15410d$var$fi + " NetworkCapture not started because we are on localhost."));
                return e;
            }
        },
        {
            key: "onRRwebEmit",
            value: function(e) {
                if (this._processQueuedEvents(), e && $504220289e15410d$var$b(e)) {
                    if (e.type === $504220289e15410d$var$En.Meta) {
                        var t = this._maskUrl(e.data.href);
                        if (this._lastHref = t, !t) return;
                        e.data.href = t;
                    } else this._pageViewFallBack();
                    e.type === $504220289e15410d$var$En.FullSnapshot && this._scheduleFullSnapshot();
                    var n = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
                    if (n) {
                        var i = function(e) {
                            var t = e;
                            if (t && $504220289e15410d$var$b(t) && 6 === t.type && $504220289e15410d$var$b(t.data) && "rrweb/console@1" === t.data.plugin) {
                                t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                                for(var n = [], i = 0; i < t.data.payload.payload.length; i++)t.data.payload.payload[i] && t.data.payload.payload[i].length > 2e3 ? n.push(t.data.payload.payload[i].slice(0, 2e3) + "...[truncated]") : n.push(t.data.payload.payload[i]);
                                return t.data.payload.payload = n, e;
                            }
                            return e;
                        }(n), r = $504220289e15410d$var$wn(i);
                        if (this._updateWindowAndSessionIds(i), !this.isIdle || i.type === $504220289e15410d$var$En.Custom) {
                            var s = {
                                $snapshot_bytes: r,
                                $snapshot_data: i,
                                $session_id: this.sessionId,
                                $window_id: this.windowId
                            };
                            "disabled" !== this.status ? this._captureSnapshotBuffered(s) : this.clearBuffer();
                        }
                    }
                }
            }
        },
        {
            key: "_pageViewFallBack",
            value: function() {
                if (!this.instance.config.capture_pageview && $504220289e15410d$var$T) {
                    var e = this._maskUrl($504220289e15410d$var$T.location.href);
                    this._lastHref !== e && (this._tryAddCustomEvent("$url_changed", {
                        href: e
                    }), this._lastHref = e);
                }
            }
        },
        {
            key: "_processQueuedEvents",
            value: function() {
                var e = this;
                if (this.queuedRRWebEvents.length) {
                    var t = $504220289e15410d$var$l(this.queuedRRWebEvents);
                    this.queuedRRWebEvents = [], t.forEach(function(t) {
                        Date.now() - t.enqueuedAt <= 2e3 && e._tryRRWebMethod(t);
                    });
                }
            }
        },
        {
            key: "_maskUrl",
            value: function(e) {
                var t = this.instance.config.session_recording;
                if (t.maskNetworkRequestFn) {
                    var n, i = {
                        url: e
                    };
                    return null === (n = i = t.maskNetworkRequestFn(i)) || void 0 === n ? void 0 : n.url;
                }
                return e;
            }
        },
        {
            key: "clearBuffer",
            value: function() {
                return this.buffer = {
                    size: 0,
                    data: [],
                    sessionId: this.sessionId,
                    windowId: this.windowId
                }, this.buffer;
            }
        },
        {
            key: "_flushBuffer",
            value: function() {
                var e = this;
                this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
                var t = this.minimumDuration, n = this.sessionDuration, i = $504220289e15410d$var$F(n) && n >= 0, r = $504220289e15410d$var$F(t) && i && n < t;
                if ("buffering" === this.status || r) return this.flushBufferTimer = setTimeout(function() {
                    e._flushBuffer();
                }, 2e3), this.buffer;
                this.buffer.data.length > 0 && $504220289e15410d$var$Sn(this.buffer).forEach(function(t) {
                    e._captureSnapshot({
                        $snapshot_bytes: t.size,
                        $snapshot_data: t.data,
                        $session_id: t.sessionId,
                        $window_id: t.windowId
                    });
                });
                return this.clearBuffer();
            }
        },
        {
            key: "_captureSnapshotBuffered",
            value: function(e) {
                var t, n = this, i = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
                !this.isIdle && (this.buffer.size + e.$snapshot_bytes + i > 943718.4 || this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || this.isIdle || (this.flushBufferTimer = setTimeout(function() {
                    n._flushBuffer();
                }, 2e3));
            }
        },
        {
            key: "_captureSnapshot",
            value: function(e) {
                this.instance.capture("$snapshot", e, {
                    _url: this.instance.requestRouter.endpointFor("api", this._endpoint),
                    _noTruncate: !0,
                    _batchKey: "recordings",
                    skip_client_rate_limiting: !0
                });
            }
        },
        {
            key: "overrideLinkedFlag",
            value: function() {
                this._linkedFlagSeen = !0;
            }
        }
    ]), e;
}(), $504220289e15410d$var$pi = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this.instance = t, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "call",
            value: function() {
                var e = this, t = {
                    token: this.instance.config.token,
                    distinct_id: this.instance.get_distinct_id(),
                    groups: this.instance.getGroups(),
                    person_properties: this.instance.get_property($504220289e15410d$var$Re),
                    group_properties: this.instance.get_property($504220289e15410d$var$Pe),
                    disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0
                };
                this.instance._send_request({
                    method: "POST",
                    url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
                    data: t,
                    compression: this.instance.config.disable_compression ? void 0 : $504220289e15410d$export$6a00d17b5aff0af.Base64,
                    timeout: this.instance.config.feature_flag_request_timeout_ms,
                    callback: function(t) {
                        return e.parseDecideResponse(t.json);
                    }
                });
            }
        },
        {
            key: "parseDecideResponse",
            value: function(e) {
                var t = this;
                this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer();
                var n = !e;
                if (this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(null != e ? e : {}, n), n) $504220289e15410d$var$W.error("Failed to fetch feature flags from PostHog.");
                else {
                    if (!$504220289e15410d$var$L || !$504220289e15410d$var$L.body) return $504220289e15410d$var$W.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(function() {
                        t.parseDecideResponse(e);
                    }, 500);
                    if (this.instance._afterDecideResponse(e), e.siteApps) {
                        if (this.instance.config.opt_in_site_apps) {
                            var i, r = $504220289e15410d$var$h(e.siteApps);
                            try {
                                var s = function() {
                                    var e = i.value, n = e.id, r = e.url, s = t.instance.requestRouter.endpointFor("api", r);
                                    $504220289e15410d$var$U["__$$ph_site_app_".concat(n)] = t.instance, t.instance.requestRouter.loadScript(s, function(e) {
                                        if (e) return $504220289e15410d$var$W.error("Error while initializing PostHog app with config id ".concat(n), e);
                                    });
                                };
                                for(r.s(); !(i = r.n()).done;)s();
                            } catch (e) {
                                r.e(e);
                            } finally{
                                r.f();
                            }
                        } else e.siteApps.length > 0 && $504220289e15410d$var$W.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
                    }
                }
            }
        }
    ]), e;
}(), $504220289e15410d$var$gi = null != $504220289e15410d$var$T && $504220289e15410d$var$T.location ? $504220289e15410d$var$bt($504220289e15410d$var$T.location.hash, "__posthog") || $504220289e15410d$var$bt(location.hash, "state") : null, $504220289e15410d$var$_i = "_postHogToolbarParams";
!function(e) {
    e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED";
}($504220289e15410d$var$oi || ($504220289e15410d$var$oi = {}));
var $504220289e15410d$var$mi = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this.instance = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "setToolbarState",
            value: function(e) {
                $504220289e15410d$var$U.ph_toolbar_state = e;
            }
        },
        {
            key: "getToolbarState",
            value: function() {
                var e;
                return null !== (e = $504220289e15410d$var$U.ph_toolbar_state) && void 0 !== e ? e : $504220289e15410d$var$oi.UNINITIALIZED;
            }
        },
        {
            key: "maybeLoadToolbar",
            value: function() {
                var e, t, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                if (!$504220289e15410d$var$T || !$504220289e15410d$var$L) return !1;
                n = null !== (e = n) && void 0 !== e ? e : $504220289e15410d$var$T.location, r = null !== (t = r) && void 0 !== t ? t : $504220289e15410d$var$T.history;
                try {
                    if (!i) {
                        try {
                            $504220289e15410d$var$T.localStorage.setItem("test", "test"), $504220289e15410d$var$T.localStorage.removeItem("test");
                        } catch (e) {
                            return !1;
                        }
                        i = null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.localStorage;
                    }
                    var s, o = $504220289e15410d$var$gi || $504220289e15410d$var$bt(n.hash, "__posthog") || $504220289e15410d$var$bt(n.hash, "state"), a = o ? $504220289e15410d$var$Z(function() {
                        return JSON.parse(atob(decodeURIComponent(o)));
                    }) || $504220289e15410d$var$Z(function() {
                        return JSON.parse(decodeURIComponent(o));
                    }) : null;
                    return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? n.hash = a.desiredHash : r ? r.replaceState(r.state, "", n.pathname + n.search) : n.hash = "")) : ((s = JSON.parse(i.getItem($504220289e15410d$var$_i) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
                } catch (e) {
                    return !1;
                }
            }
        },
        {
            key: "_callLoadToolbar",
            value: function(e) {
                ($504220289e15410d$var$U.ph_load_toolbar || $504220289e15410d$var$U.ph_load_editor)(e, this.instance);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                var n = this, i = !(null == $504220289e15410d$var$L || !$504220289e15410d$var$L.getElementById($504220289e15410d$var$Be));
                if (!$504220289e15410d$var$T || i) return !1;
                var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $504220289e15410d$var$t($504220289e15410d$var$t({
                    token: this.instance.config.token
                }, e), {}, {
                    apiURL: this.instance.requestRouter.endpointFor("ui")
                }, r ? {
                    instrument: !1
                } : {});
                if ($504220289e15410d$var$T.localStorage.setItem($504220289e15410d$var$_i, JSON.stringify($504220289e15410d$var$t($504220289e15410d$var$t({}, s), {}, {
                    source: void 0
                }))), this.getToolbarState() === $504220289e15410d$var$oi.LOADED) this._callLoadToolbar(s);
                else if (this.getToolbarState() === $504220289e15410d$var$oi.UNINITIALIZED) {
                    this.setToolbarState($504220289e15410d$var$oi.LOADING);
                    var o = 3e5, a = Math.floor(Date.now() / o) * o;
                    this.instance.requestRouter.loadScript("/static/toolbar.js?t=".concat(a), function(e) {
                        if (e) return $504220289e15410d$var$W.error("Failed to load toolbar", e), void n.setToolbarState($504220289e15410d$var$oi.UNINITIALIZED);
                        n.setToolbarState($504220289e15410d$var$oi.LOADED), n._callLoadToolbar(s);
                    }), $504220289e15410d$var$oe($504220289e15410d$var$T, "turbolinks:load", function() {
                        n.setToolbarState($504220289e15410d$var$oi.UNINITIALIZED), n.loadToolbar(s);
                    });
                }
                return !0;
            }
        },
        {
            key: "_loadEditor",
            value: function(e) {
                return this.loadToolbar(e);
            }
        },
        {
            key: "maybeLoadEditor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                return this.maybeLoadToolbar(e, t, n);
            }
        }
    ]), e;
}(), $504220289e15410d$var$yi = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "isPaused", !0), $504220289e15410d$var$o(this, "queue", []), $504220289e15410d$var$o(this, "flushTimeoutMs", 3e3), this.sendRequest = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "enqueue",
            value: function(e) {
                this.queue.push(e), this.flushTimeout || this.setFlushTimeout();
            }
        },
        {
            key: "unload",
            value: function() {
                var e = this;
                this.clearFlushTimeout();
                var n = this.queue.length > 0 ? this.formatQueue() : {}, i = Object.values(n);
                [].concat($504220289e15410d$var$l(i.filter(function(e) {
                    return 0 === e.url.indexOf("/e");
                })), $504220289e15410d$var$l(i.filter(function(e) {
                    return 0 !== e.url.indexOf("/e");
                }))).map(function(n) {
                    e.sendRequest($504220289e15410d$var$t($504220289e15410d$var$t({}, n), {}, {
                        transport: "sendBeacon"
                    }));
                });
            }
        },
        {
            key: "enable",
            value: function() {
                this.isPaused = !1, this.setFlushTimeout();
            }
        },
        {
            key: "setFlushTimeout",
            value: function() {
                var e = this;
                this.isPaused || (this.flushTimeout = setTimeout(function() {
                    if (e.clearFlushTimeout(), e.queue.length > 0) {
                        var t = e.formatQueue(), n = function(n) {
                            var i = t[n], r = (new Date).getTime();
                            i.data && $504220289e15410d$var$m(i.data) && $504220289e15410d$var$Q(i.data, function(e) {
                                e.offset = Math.abs(e.timestamp - r), delete e.timestamp;
                            }), e.sendRequest(i);
                        };
                        for(var i in t)n(i);
                    }
                }, this.flushTimeoutMs));
            }
        },
        {
            key: "clearFlushTimeout",
            value: function() {
                clearTimeout(this.flushTimeout), this.flushTimeout = void 0;
            }
        },
        {
            key: "formatQueue",
            value: function() {
                var e = {};
                return $504220289e15410d$var$Q(this.queue, function(n) {
                    var i, r = n, s = (r ? r.batchKey : null) || r.url;
                    $504220289e15410d$var$w(e[s]) && (e[s] = $504220289e15410d$var$t($504220289e15410d$var$t({}, r), {}, {
                        data: []
                    })), null === (i = e[s].data) || void 0 === i || i.push(r.data);
                }), this.queue = [], e;
            }
        }
    ]), e;
}(), $504220289e15410d$var$bi = Uint8Array, $504220289e15410d$var$ki = Uint16Array, $504220289e15410d$var$wi = Uint32Array, $504220289e15410d$var$Si = new $504220289e15410d$var$bi([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $504220289e15410d$var$Ei = new $504220289e15410d$var$bi([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $504220289e15410d$var$Ii = new $504220289e15410d$var$bi([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $504220289e15410d$var$xi = function(e, t) {
    for(var n = new $504220289e15410d$var$ki(31), i = 0; i < 31; ++i)n[i] = t += 1 << e[i - 1];
    var r = new $504220289e15410d$var$wi(n[30]);
    for(i = 1; i < 30; ++i)for(var s = n[i]; s < n[i + 1]; ++s)r[s] = s - n[i] << 5 | i;
    return [
        n,
        r
    ];
}, $504220289e15410d$var$Fi = $504220289e15410d$var$xi($504220289e15410d$var$Si, 2), $504220289e15410d$var$Ri = $504220289e15410d$var$Fi[0], $504220289e15410d$var$Pi = $504220289e15410d$var$Fi[1];
$504220289e15410d$var$Ri[28] = 258, $504220289e15410d$var$Pi[258] = 28;
for(var $504220289e15410d$var$Ti = $504220289e15410d$var$xi($504220289e15410d$var$Ei, 0)[1], $504220289e15410d$var$Ci = new $504220289e15410d$var$ki(32768), $504220289e15410d$var$Oi = 0; $504220289e15410d$var$Oi < 32768; ++$504220289e15410d$var$Oi){
    var $504220289e15410d$var$$i = (43690 & $504220289e15410d$var$Oi) >>> 1 | (21845 & $504220289e15410d$var$Oi) << 1;
    $504220289e15410d$var$$i = (61680 & ($504220289e15410d$var$$i = (52428 & $504220289e15410d$var$$i) >>> 2 | (13107 & $504220289e15410d$var$$i) << 2)) >>> 4 | (3855 & $504220289e15410d$var$$i) << 4, $504220289e15410d$var$Ci[$504220289e15410d$var$Oi] = ((65280 & $504220289e15410d$var$$i) >>> 8 | (255 & $504220289e15410d$var$$i) << 8) >>> 1;
}
var $504220289e15410d$var$Mi = function(e, t, n) {
    for(var i = e.length, r = 0, s = new $504220289e15410d$var$ki(t); r < i; ++r)++s[e[r] - 1];
    var o, a = new $504220289e15410d$var$ki(t);
    for(r = 0; r < t; ++r)a[r] = a[r - 1] + s[r - 1] << 1;
    if (n) {
        o = new $504220289e15410d$var$ki(1 << t);
        var u = 15 - t;
        for(r = 0; r < i; ++r)if (e[r]) for(var l = r << 4 | e[r], c = t - e[r], d = a[e[r] - 1]++ << c, h = d | (1 << c) - 1; d <= h; ++d)o[$504220289e15410d$var$Ci[d] >>> u] = l;
    } else for(o = new $504220289e15410d$var$ki(i), r = 0; r < i; ++r)o[r] = $504220289e15410d$var$Ci[a[e[r] - 1]++] >>> 15 - e[r];
    return o;
}, $504220289e15410d$var$Ai = new $504220289e15410d$var$bi(288);
for($504220289e15410d$var$Oi = 0; $504220289e15410d$var$Oi < 144; ++$504220289e15410d$var$Oi)$504220289e15410d$var$Ai[$504220289e15410d$var$Oi] = 8;
for($504220289e15410d$var$Oi = 144; $504220289e15410d$var$Oi < 256; ++$504220289e15410d$var$Oi)$504220289e15410d$var$Ai[$504220289e15410d$var$Oi] = 9;
for($504220289e15410d$var$Oi = 256; $504220289e15410d$var$Oi < 280; ++$504220289e15410d$var$Oi)$504220289e15410d$var$Ai[$504220289e15410d$var$Oi] = 7;
for($504220289e15410d$var$Oi = 280; $504220289e15410d$var$Oi < 288; ++$504220289e15410d$var$Oi)$504220289e15410d$var$Ai[$504220289e15410d$var$Oi] = 8;
var $504220289e15410d$var$Li = new $504220289e15410d$var$bi(32);
for($504220289e15410d$var$Oi = 0; $504220289e15410d$var$Oi < 32; ++$504220289e15410d$var$Oi)$504220289e15410d$var$Li[$504220289e15410d$var$Oi] = 5;
var $504220289e15410d$var$Di = $504220289e15410d$var$Mi($504220289e15410d$var$Ai, 9, 0), $504220289e15410d$var$Ni = $504220289e15410d$var$Mi($504220289e15410d$var$Li, 5, 0), $504220289e15410d$var$qi = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, $504220289e15410d$var$Bi = function(e, t, n) {
    (null == t || t < 0) && (t = 0), (null == n || n > e.length) && (n = e.length);
    var i = new (e instanceof $504220289e15410d$var$ki ? $504220289e15410d$var$ki : e instanceof $504220289e15410d$var$wi ? $504220289e15410d$var$wi : $504220289e15410d$var$bi)(n - t);
    return i.set(e.subarray(t, n)), i;
}, $504220289e15410d$var$Hi = function(e, t, n) {
    n <<= 7 & t;
    var i = t / 8 >> 0;
    e[i] |= n, e[i + 1] |= n >>> 8;
}, $504220289e15410d$var$Ui = function(e, t, n) {
    n <<= 7 & t;
    var i = t / 8 >> 0;
    e[i] |= n, e[i + 1] |= n >>> 8, e[i + 2] |= n >>> 16;
}, $504220289e15410d$var$ji = function(e, t) {
    for(var n = [], i = 0; i < e.length; ++i)e[i] && n.push({
        s: i,
        f: e[i]
    });
    var r = n.length, s = n.slice();
    if (!r) return [
        new $504220289e15410d$var$bi(0),
        0
    ];
    if (1 == r) {
        var o = new $504220289e15410d$var$bi(n[0].s + 1);
        return o[n[0].s] = 1, [
            o,
            1
        ];
    }
    n.sort(function(e, t) {
        return e.f - t.f;
    }), n.push({
        s: -1,
        f: 25001
    });
    var a = n[0], u = n[1], l = 0, c = 1, d = 2;
    for(n[0] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    }; c != r - 1;)a = n[n[l].f < n[d].f ? l++ : d++], u = n[l != c && n[l].f < n[d].f ? l++ : d++], n[c++] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    };
    var h = s[0].s;
    for(i = 1; i < r; ++i)s[i].s > h && (h = s[i].s);
    var f = new $504220289e15410d$var$ki(h + 1), v = $504220289e15410d$var$Wi(n[c - 1], f, 0);
    if (v > t) {
        i = 0;
        var p = 0, g = v - t, _ = 1 << g;
        for(s.sort(function(e, t) {
            return f[t.s] - f[e.s] || e.f - t.f;
        }); i < r; ++i){
            var m = s[i].s;
            if (!(f[m] > t)) break;
            p += _ - (1 << v - f[m]), f[m] = t;
        }
        for(p >>>= g; p > 0;){
            var y = s[i].s;
            f[y] < t ? p -= 1 << t - f[y]++ - 1 : ++i;
        }
        for(; i >= 0 && p; --i){
            var b = s[i].s;
            f[b] == t && (--f[b], ++p);
        }
        v = t;
    }
    return [
        new $504220289e15410d$var$bi(f),
        v
    ];
}, $504220289e15410d$var$Wi = function e(t, n, i) {
    return -1 == t.s ? Math.max(e(t.l, n, i + 1), e(t.r, n, i + 1)) : n[t.s] = i;
}, $504220289e15410d$var$Vi = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var n = new $504220289e15410d$var$ki(++t), i = 0, r = e[0], s = 1, o = function(e) {
        n[i++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == r && a != t) ++s;
    else {
        if (!r && s > 2) {
            for(; s > 138; s -= 138)o(32754);
            s > 2 && (o(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
        } else if (s > 3) {
            for(o(r), --s; s > 6; s -= 6)o(8304);
            s > 2 && (o(s - 3 << 5 | 8208), s = 0);
        }
        for(; s--;)o(r);
        s = 1, r = e[a];
    }
    return [
        n.subarray(0, i),
        t
    ];
}, $504220289e15410d$var$zi = function(e, t) {
    for(var n = 0, i = 0; i < t.length; ++i)n += e[i] * t[i];
    return n;
}, $504220289e15410d$var$Gi = function(e, t, n) {
    var i = n.length, r = $504220289e15410d$var$qi(t + 2);
    e[r] = 255 & i, e[r + 1] = i >>> 8, e[r + 2] = 255 ^ e[r], e[r + 3] = 255 ^ e[r + 1];
    for(var s = 0; s < i; ++s)e[r + s + 4] = n[s];
    return 8 * (r + 4 + i);
}, $504220289e15410d$var$Qi = function(e, t, n, i, r, s, o, a, u, l, c) {
    $504220289e15410d$var$Hi(t, c++, n), ++r[256];
    for(var d = $504220289e15410d$var$ji(r, 15), h = d[0], f = d[1], v = $504220289e15410d$var$ji(s, 15), p = v[0], g = v[1], _ = $504220289e15410d$var$Vi(h), m = _[0], y = _[1], b = $504220289e15410d$var$Vi(p), k = b[0], w = b[1], S = new $504220289e15410d$var$ki(19), E = 0; E < m.length; ++E)S[31 & m[E]]++;
    for(E = 0; E < k.length; ++E)S[31 & k[E]]++;
    for(var I = $504220289e15410d$var$ji(S, 7), x = I[0], F = I[1], R = 19; R > 4 && !x[$504220289e15410d$var$Ii[R - 1]]; --R);
    var P, T, C, O, $ = l + 5 << 3, M = $504220289e15410d$var$zi(r, $504220289e15410d$var$Ai) + $504220289e15410d$var$zi(s, $504220289e15410d$var$Li) + o, A = $504220289e15410d$var$zi(r, h) + $504220289e15410d$var$zi(s, p) + o + 14 + 3 * R + $504220289e15410d$var$zi(S, x) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if ($ <= M && $ <= A) return $504220289e15410d$var$Gi(t, c, e.subarray(u, u + l));
    if ($504220289e15410d$var$Hi(t, c, 1 + (A < M)), c += 2, A < M) {
        P = $504220289e15410d$var$Mi(h, f, 0), T = h, C = $504220289e15410d$var$Mi(p, g, 0), O = p;
        var L = $504220289e15410d$var$Mi(x, F, 0);
        $504220289e15410d$var$Hi(t, c, y - 257), $504220289e15410d$var$Hi(t, c + 5, w - 1), $504220289e15410d$var$Hi(t, c + 10, R - 4), c += 14;
        for(E = 0; E < R; ++E)$504220289e15410d$var$Hi(t, c + 3 * E, x[$504220289e15410d$var$Ii[E]]);
        c += 3 * R;
        for(var D = [
            m,
            k
        ], N = 0; N < 2; ++N){
            var q = D[N];
            for(E = 0; E < q.length; ++E){
                var B = 31 & q[E];
                $504220289e15410d$var$Hi(t, c, L[B]), c += x[B], B > 15 && ($504220289e15410d$var$Hi(t, c, q[E] >>> 5 & 127), c += q[E] >>> 12);
            }
        }
    } else P = $504220289e15410d$var$Di, T = $504220289e15410d$var$Ai, C = $504220289e15410d$var$Ni, O = $504220289e15410d$var$Li;
    for(E = 0; E < a; ++E)if (i[E] > 255) {
        B = i[E] >>> 18 & 31;
        $504220289e15410d$var$Ui(t, c, P[B + 257]), c += T[B + 257], B > 7 && ($504220289e15410d$var$Hi(t, c, i[E] >>> 23 & 31), c += $504220289e15410d$var$Si[B]);
        var H = 31 & i[E];
        $504220289e15410d$var$Ui(t, c, C[H]), c += O[H], H > 3 && ($504220289e15410d$var$Ui(t, c, i[E] >>> 5 & 8191), c += $504220289e15410d$var$Ei[H]);
    } else $504220289e15410d$var$Ui(t, c, P[i[E]]), c += T[i[E]];
    return $504220289e15410d$var$Ui(t, c, P[256]), c + T[256];
}, $504220289e15410d$var$Ji = new $504220289e15410d$var$wi([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $504220289e15410d$var$Yi = new $504220289e15410d$var$bi(0), $504220289e15410d$var$Xi = function() {
    for(var e = new $504220289e15410d$var$wi(256), t = 0; t < 256; ++t){
        for(var n = t, i = 9; --i;)n = (1 & n && 3988292384) ^ n >>> 1;
        e[t] = n;
    }
    return e;
}(), $504220289e15410d$var$Ki = function(e, t, n, i, r) {
    return function(e, t, n, i, r, s) {
        var o = e.length, a = new $504220289e15410d$var$bi(i + o + 5 * (1 + Math.floor(o / 7e3)) + r), u = a.subarray(i, a.length - r), l = 0;
        if (!t || o < 8) for(var c = 0; c <= o; c += 65535){
            var d = c + 65535;
            d < o ? l = $504220289e15410d$var$Gi(u, l, e.subarray(c, d)) : (u[c] = s, l = $504220289e15410d$var$Gi(u, l, e.subarray(c, o)));
        }
        else {
            for(var h = $504220289e15410d$var$Ji[t - 1], f = h >>> 13, v = 8191 & h, p = (1 << n) - 1, g = new $504220289e15410d$var$ki(32768), _ = new $504220289e15410d$var$ki(p + 1), m = Math.ceil(n / 3), y = 2 * m, b = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << y) & p;
            }, k = new $504220289e15410d$var$wi(25e3), w = new $504220289e15410d$var$ki(288), S = new $504220289e15410d$var$ki(32), E = 0, I = 0, x = (c = 0, 0), F = 0, R = 0; c < o; ++c){
                var P = b(c), T = 32767 & c, C = _[P];
                if (g[T] = C, _[P] = T, F <= c) {
                    var O = o - c;
                    if ((E > 7e3 || x > 24576) && O > 423) {
                        l = $504220289e15410d$var$Qi(e, u, 0, k, w, S, I, x, R, c - R, l), x = E = I = 0, R = c;
                        for(var $ = 0; $ < 286; ++$)w[$] = 0;
                        for($ = 0; $ < 30; ++$)S[$] = 0;
                    }
                    var M = 2, A = 0, L = v, D = T - C & 32767;
                    if (O > 2 && P == b(c - D)) for(var N = Math.min(f, O) - 1, q = Math.min(32767, c), B = Math.min(258, O); D <= q && --L && T != C;){
                        if (e[c + M] == e[c + M - D]) {
                            for(var H = 0; H < B && e[c + H] == e[c + H - D]; ++H);
                            if (H > M) {
                                if (M = H, A = D, H > N) break;
                                var U = Math.min(D, H - 2), j = 0;
                                for($ = 0; $ < U; ++$){
                                    var W = c - D + $ + 32768 & 32767, V = W - g[W] + 32768 & 32767;
                                    V > j && (j = V, C = W);
                                }
                            }
                        }
                        D += (T = C) - (C = g[T]) + 32768 & 32767;
                    }
                    if (A) {
                        k[x++] = 268435456 | $504220289e15410d$var$Pi[M] << 18 | $504220289e15410d$var$Ti[A];
                        var z = 31 & $504220289e15410d$var$Pi[M], G = 31 & $504220289e15410d$var$Ti[A];
                        I += $504220289e15410d$var$Si[z] + $504220289e15410d$var$Ei[G], ++w[257 + z], ++S[G], F = c + M, ++E;
                    } else k[x++] = e[c], ++w[e[c]];
                }
            }
            l = $504220289e15410d$var$Qi(e, u, s, k, w, S, I, x, R, c - R, l), s || (l = $504220289e15410d$var$Gi(u, l, $504220289e15410d$var$Yi));
        }
        return $504220289e15410d$var$Bi(a, 0, i + $504220289e15410d$var$qi(l) + r);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, n, i, !r);
}, $504220289e15410d$var$Zi = function(e, t, n) {
    for(; n; ++t)e[t] = n, n >>>= 8;
};
function $504220289e15410d$var$er(e, t) {
    void 0 === t && (t = {});
    var n = function() {
        var e = 4294967295;
        return {
            p: function(t) {
                for(var n = e, i = 0; i < t.length; ++i)n = $504220289e15410d$var$Xi[255 & n ^ t[i]] ^ n >>> 8;
                e = n;
            },
            d: function() {
                return 4294967295 ^ e;
            }
        };
    }(), i = e.length;
    n.p(e);
    var r, s = $504220289e15410d$var$Ki(e, t, 10 + ((r = t).filename && r.filename.length + 1 || 0), 8), o = s.length;
    return function(e, t) {
        var n = t.filename;
        if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && $504220289e15410d$var$Zi(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), n) {
            e[3] = 8;
            for(var i = 0; i <= n.length; ++i)e[i + 10] = n.charCodeAt(i);
        }
    }(s, t), $504220289e15410d$var$Zi(s, o - 8, n.d()), $504220289e15410d$var$Zi(s, o - 4, i), s;
}
var $504220289e15410d$var$tr = !!$504220289e15410d$var$q || !!$504220289e15410d$var$N, $504220289e15410d$var$nr = "text/plain", $504220289e15410d$var$ir = function(e, n) {
    var i = $504220289e15410d$var$u(e.split("?"), 2), r = i[0], s = i[1], o = $504220289e15410d$var$t({}, n);
    null == s || s.split("&").forEach(function(e) {
        var t = $504220289e15410d$var$u(e.split("="), 1)[0];
        delete o[t];
    });
    var a = $504220289e15410d$var$mt(o);
    return a = a ? (s ? s + "&" : "") + a : s, "".concat(r, "?").concat(a);
}, $504220289e15410d$var$rr = function(e) {
    var t = e.data, n = e.compression;
    if (t) {
        if (n === $504220289e15410d$export$6a00d17b5aff0af.GZipJS) {
            var i = $504220289e15410d$var$er(function(e, t) {
                var n = e.length;
                if (!t && "undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
                for(var i = new $504220289e15410d$var$bi(e.length + (e.length >>> 1)), r = 0, s = function(e) {
                    i[r++] = e;
                }, o = 0; o < n; ++o){
                    if (r + 5 > i.length) {
                        var a = new $504220289e15410d$var$bi(r + 8 + (n - o << 1));
                        a.set(i), i = a;
                    }
                    var u = e.charCodeAt(o);
                    u < 128 || t ? s(u) : u < 2048 ? (s(192 | u >>> 6), s(128 | 63 & u)) : u > 55295 && u < 57344 ? (s(240 | (u = 65536 + (1047552 & u) | 1023 & e.charCodeAt(++o)) >>> 18), s(128 | u >>> 12 & 63), s(128 | u >>> 6 & 63), s(128 | 63 & u)) : (s(224 | u >>> 12), s(128 | u >>> 6 & 63), s(128 | 63 & u));
                }
                return $504220289e15410d$var$Bi(i, 0, r);
            }(JSON.stringify(t)), {
                mtime: 0
            }), r = new Blob([
                i
            ], {
                type: $504220289e15410d$var$nr
            });
            return {
                contentType: $504220289e15410d$var$nr,
                body: r,
                estimatedSize: r.size
            };
        }
        if (n === $504220289e15410d$export$6a00d17b5aff0af.Base64) {
            var s = function(e) {
                var t, n, i, r, s, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, u = 0, l = "", c = [];
                if (!e) return e;
                e = $504220289e15410d$var$se(e);
                do t = (s = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 18 & 63, n = s >> 12 & 63, i = s >> 6 & 63, r = 63 & s, c[u++] = o.charAt(t) + o.charAt(n) + o.charAt(i) + o.charAt(r);
                while (a < e.length);
                switch(l = c.join(""), e.length % 3){
                    case 1:
                        l = l.slice(0, -2) + "==";
                        break;
                    case 2:
                        l = l.slice(0, -1) + "=";
                }
                return l;
            }(JSON.stringify(t)), o = function(e) {
                return "data=" + encodeURIComponent("string" == typeof e ? e : JSON.stringify(e));
            }(s);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = JSON.stringify(t);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, $504220289e15410d$var$sr = [];
$504220289e15410d$var$q && $504220289e15410d$var$sr.push({
    transport: "XHR",
    method: function(e) {
        var t, n = new $504220289e15410d$var$q;
        n.open(e.method || "GET", e.url, !0);
        var i = null !== (t = $504220289e15410d$var$rr(e)) && void 0 !== t ? t : {}, r = i.contentType, s = i.body;
        $504220289e15410d$var$Q(e.headers, function(e, t) {
            n.setRequestHeader(t, e);
        }), r && n.setRequestHeader("Content-Type", r), e.timeout && (n.timeout = e.timeout), n.withCredentials = !0, n.onreadystatechange = function() {
            if (4 === n.readyState) {
                var t, i = {
                    statusCode: n.status,
                    text: n.responseText
                };
                if (200 === n.status) try {
                    i.json = JSON.parse(n.responseText);
                } catch (e) {}
                null === (t = e.callback) || void 0 === t || t.call(e, i);
            }
        }, n.send(s);
    }
}), $504220289e15410d$var$N && $504220289e15410d$var$sr.push({
    transport: "fetch",
    method: function(e) {
        var t, n, i = null !== (t = $504220289e15410d$var$rr(e)) && void 0 !== t ? t : {}, r = i.contentType, s = i.body, o = i.estimatedSize, a = new Headers;
        $504220289e15410d$var$Q(e.headers, function(e, t) {
            a.append(t, e);
        }), r && a.append("Content-Type", r);
        var u = e.url, l = null;
        if ($504220289e15410d$var$B) {
            var c = new $504220289e15410d$var$B;
            l = {
                signal: c.signal,
                timeout: setTimeout(function() {
                    return c.abort();
                }, e.timeout)
            };
        }
        $504220289e15410d$var$N(u, {
            method: (null == e ? void 0 : e.method) || "GET",
            headers: a,
            keepalive: "POST" === e.method && (o || 0) < 65536,
            body: s,
            signal: null === (n = l) || void 0 === n ? void 0 : n.signal
        }).then(function(t) {
            return t.text().then(function(n) {
                var i, r = {
                    statusCode: t.status,
                    text: n
                };
                if (200 === t.status) try {
                    r.json = JSON.parse(n);
                } catch (e) {
                    $504220289e15410d$var$W.error(e);
                }
                null === (i = e.callback) || void 0 === i || i.call(e, r);
            });
        }).catch(function(t) {
            var n;
            $504220289e15410d$var$W.error(t), null === (n = e.callback) || void 0 === n || n.call(e, {
                statusCode: 0,
                text: t
            });
        }).finally(function() {
            return l ? clearTimeout(l.timeout) : null;
        });
    }
}), null != $504220289e15410d$var$A && $504220289e15410d$var$A.sendBeacon && $504220289e15410d$var$sr.push({
    transport: "sendBeacon",
    method: function(e) {
        var t = $504220289e15410d$var$ir(e.url, {
            beacon: "1"
        });
        try {
            var n, i = null !== (n = $504220289e15410d$var$rr(e)) && void 0 !== n ? n : {}, r = i.contentType, s = i.body, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $504220289e15410d$var$A.sendBeacon(t, o);
        } catch (e) {}
    }
});
var $504220289e15410d$var$or = [
    "retriesPerformedSoFar"
];
var $504220289e15410d$var$ar, $504220289e15410d$var$ur = function() {
    function e(t) {
        var n = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "isPolling", !1), $504220289e15410d$var$o(this, "pollIntervalMs", 3e3), $504220289e15410d$var$o(this, "queue", []), this.instance = t, this.queue = [], this.areWeOnline = !0, !$504220289e15410d$var$w($504220289e15410d$var$T) && "onLine" in $504220289e15410d$var$T.navigator && (this.areWeOnline = $504220289e15410d$var$T.navigator.onLine, $504220289e15410d$var$T.addEventListener("online", function() {
            n.areWeOnline = !0, n.flush();
        }), $504220289e15410d$var$T.addEventListener("offline", function() {
            n.areWeOnline = !1;
        }));
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "retriableRequest",
            value: function(e) {
                var n = this, i = e.retriesPerformedSoFar, r = $504220289e15410d$var$a(e, $504220289e15410d$var$or);
                $504220289e15410d$var$F(i) && i > 0 && (r.url = $504220289e15410d$var$ir(r.url, {
                    retry_count: i
                })), this.instance._send_request($504220289e15410d$var$t($504220289e15410d$var$t({}, r), {}, {
                    callback: function(e) {
                        var s;
                        200 !== e.statusCode && (e.statusCode < 400 || e.statusCode >= 500) && (null != i ? i : 0) < 10 ? n.enqueue($504220289e15410d$var$t({
                            retriesPerformedSoFar: i
                        }, r)) : null === (s = r.callback) || void 0 === s || s.call(r, e);
                    }
                }));
            }
        },
        {
            key: "enqueue",
            value: function(e) {
                var t = e.retriesPerformedSoFar || 0;
                e.retriesPerformedSoFar = t + 1;
                var n = function(e) {
                    var t = 3e3 * Math.pow(2, e), n = t / 2, i = Math.min(18e5, t), r = (Math.random() - .5) * (i - n);
                    return Math.ceil(i + r);
                }(t), i = Date.now() + n;
                this.queue.push({
                    retryAt: i,
                    requestOptions: e
                });
                var r = "Enqueued failed request for retry in ".concat(n);
                navigator.onLine || (r += " (Browser is offline)"), $504220289e15410d$var$W.warn(r), this.isPolling || (this.isPolling = !0, this.poll());
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                this.poller && clearTimeout(this.poller), this.poller = setTimeout(function() {
                    e.areWeOnline && e.queue.length > 0 && e.flush(), e.poll();
                }, this.pollIntervalMs);
            }
        },
        {
            key: "flush",
            value: function() {
                var e = Date.now(), t = [], n = this.queue.filter(function(n) {
                    return n.retryAt < e || (t.push(n), !1);
                });
                if (this.queue = t, n.length > 0) {
                    var i, r = $504220289e15410d$var$h(n);
                    try {
                        for(r.s(); !(i = r.n()).done;){
                            var s = i.value.requestOptions;
                            this.retriableRequest(s);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
            }
        },
        {
            key: "unload",
            value: function() {
                this.poller && (clearTimeout(this.poller), this.poller = void 0);
                var e, n = $504220289e15410d$var$h(this.queue);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var i = e.value.requestOptions;
                        try {
                            this.instance._send_request($504220289e15410d$var$t($504220289e15410d$var$t({}, i), {}, {
                                transport: "sendBeacon"
                            }));
                        } catch (e) {
                            $504220289e15410d$var$W.error(e);
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.queue = [];
            }
        }
    ]), e;
}(), $504220289e15410d$var$lr = 1800, $504220289e15410d$var$cr = function() {
    function e(t, n, r, s) {
        var a;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_sessionIdChangedHandlers", []), this.config = t, this.persistence = n, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = r || $504220289e15410d$var$Ze, this._windowIdGenerator = s || $504220289e15410d$var$Ze;
        var u = t.persistence_name || t.token, l = t.session_idle_timeout_seconds || $504220289e15410d$var$lr;
        if ($504220289e15410d$var$F(l) ? l > $504220289e15410d$var$lr ? $504220289e15410d$var$W.warn("session_idle_timeout_seconds cannot be  greater than 30 minutes. Using 30 minutes instead.") : l < 60 && $504220289e15410d$var$W.warn("session_idle_timeout_seconds cannot be less than 60 seconds. Using 60 seconds instead.") : ($504220289e15410d$var$W.warn("session_idle_timeout_seconds must be a number. Defaulting to 30 minutes."), l = $504220289e15410d$var$lr), this._sessionTimeoutMs = 1e3 * Math.min(Math.max(l, 60), $504220289e15410d$var$lr), this._window_id_storage_key = "ph_" + u + "_window_id", this._primary_window_exists_storage_key = "ph_" + u + "_primary_window_exists", this._canUseSessionStorage()) {
            var c = $504220289e15410d$var$vt.parse(this._window_id_storage_key), d = $504220289e15410d$var$vt.parse(this._primary_window_exists_storage_key);
            c && !d ? this._windowId = c : $504220289e15410d$var$vt.remove(this._window_id_storage_key), $504220289e15410d$var$vt.set(this._primary_window_exists_storage_key, !0);
        }
        if (null !== (a = this.config.bootstrap) && void 0 !== a && a.sessionID) try {
            var h = function(e) {
                var t = e.replace(/-/g, "");
                if (32 !== t.length) throw new Error("Not a valid UUID");
                if ("7" !== t[12]) throw new Error("Not a UUIDv7");
                return parseInt(t.substring(0, 12), 16);
            }(this.config.bootstrap.sessionID);
            this._setSessionId(this.config.bootstrap.sessionID, (new Date).getTime(), h);
        } catch (e) {
            $504220289e15410d$var$W.error("Invalid sessionID in bootstrap", e);
        }
        this._listenToReloadWindow();
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "onSessionId",
            value: function(e) {
                var t = this;
                return $504220289e15410d$var$w(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), function() {
                    t._sessionIdChangedHandlers = t._sessionIdChangedHandlers.filter(function(t) {
                        return t !== e;
                    });
                };
            }
        },
        {
            key: "_canUseSessionStorage",
            value: function() {
                return "memory" !== this.config.persistence && !this.persistence.disabled && $504220289e15410d$var$vt.is_supported();
            }
        },
        {
            key: "_setWindowId",
            value: function(e) {
                e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && $504220289e15410d$var$vt.set(this._window_id_storage_key, e));
            }
        },
        {
            key: "_getWindowId",
            value: function() {
                return this._windowId ? this._windowId : this._canUseSessionStorage() ? $504220289e15410d$var$vt.parse(this._window_id_storage_key) : null;
            }
        },
        {
            key: "_setSessionId",
            value: function(e, t, n) {
                e === this._sessionId && t === this._sessionActivityTimestamp && n === this._sessionStartTimestamp || (this._sessionStartTimestamp = n, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$Ee, [
                    t,
                    e,
                    n
                ])));
            }
        },
        {
            key: "_getSessionId",
            value: function() {
                if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
                    this._sessionActivityTimestamp,
                    this._sessionId,
                    this._sessionStartTimestamp
                ];
                var e = this.persistence.props[$504220289e15410d$var$Ee];
                return $504220289e15410d$var$m(e) && 2 === e.length && e.push(e[0]), e || [
                    0,
                    null,
                    0
                ];
            }
        },
        {
            key: "resetSessionId",
            value: function() {
                this._setSessionId(null, null, null);
            }
        },
        {
            key: "_listenToReloadWindow",
            value: function() {
                var e = this;
                null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("beforeunload", function() {
                    e._canUseSessionStorage() && $504220289e15410d$var$vt.remove(e._primary_window_exists_storage_key);
                });
            }
        },
        {
            key: "checkAndGetSessionAndWindowId",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || (new Date).getTime(), n = $504220289e15410d$var$u(this._getSessionId(), 3), i = n[0], r = n[1], s = n[2], o = this._getWindowId(), a = $504220289e15410d$var$F(s) && s > 0 && Math.abs(t - s) > 864e5, l = !1, c = !r, d = !e && Math.abs(t - i) > this._sessionTimeoutMs;
                c || d || a ? (r = this._sessionIdGenerator(), o = this._windowIdGenerator(), $504220289e15410d$var$W.info("[SessionId] new session ID generated", {
                    sessionId: r,
                    windowId: o,
                    changeReason: {
                        noSessionId: c,
                        activityTimeout: d,
                        sessionPastMaximumLength: a
                    }
                }), s = t, l = !0) : o || (o = this._windowIdGenerator(), l = !0);
                var h = 0 === i || !e || a ? t : i, f = 0 === s ? (new Date).getTime() : s;
                return this._setWindowId(o), this._setSessionId(r, h, f), l && this._sessionIdChangedHandlers.forEach(function(e) {
                    return e(r, o, l ? {
                        noSessionId: c,
                        activityTimeout: d,
                        sessionPastMaximumLength: a
                    } : void 0);
                }), {
                    sessionId: r,
                    windowId: o,
                    sessionStartTimestamp: f,
                    changeReason: l ? {
                        noSessionId: c,
                        activityTimeout: d,
                        sessionPastMaximumLength: a
                    } : void 0
                };
            }
        }
    ]), e;
}();
!function(e) {
    e.US = "us", e.EU = "eu", e.CUSTOM = "custom";
}($504220289e15410d$var$ar || ($504220289e15410d$var$ar = {}));
var $504220289e15410d$var$dr = "i.posthog.com", $504220289e15410d$var$hr = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_regionCache", {}), this.instance = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "apiHost",
            get: function() {
                var e = this.instance.config.api_host.trim().replace(/\/$/, "");
                return "https://app.posthog.com" === e ? "https://us.i.posthog.com" : e;
            }
        },
        {
            key: "uiHost",
            get: function() {
                var e, t = null === (e = this.instance.config.ui_host) || void 0 === e ? void 0 : e.replace(/\/$/, "");
                return t || (t = this.apiHost.replace(".".concat($504220289e15410d$var$dr), ".posthog.com")), "https://app.posthog.com" === t ? "https://us.posthog.com" : t;
            }
        },
        {
            key: "region",
            get: function() {
                return this._regionCache[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = $504220289e15410d$var$ar.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = $504220289e15410d$var$ar.EU : this._regionCache[this.apiHost] = $504220289e15410d$var$ar.CUSTOM), this._regionCache[this.apiHost];
            }
        },
        {
            key: "endpointFor",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                if (t && (t = "/" === t[0] ? t : "/".concat(t)), "ui" === e) return this.uiHost + t;
                if (this.region === $504220289e15410d$var$ar.CUSTOM) return this.apiHost + t;
                var n = $504220289e15410d$var$dr + t;
                switch(e){
                    case "assets":
                        return "https://".concat(this.region, "-assets.").concat(n);
                    case "api":
                        return "https://".concat(this.region, ".").concat(n);
                }
            }
        },
        {
            key: "loadScript",
            value: function(e, t) {
                if (this.instance.config.disable_external_dependency_loading) return $504220289e15410d$var$W.warn("".concat(e, " was requested but loading of external scripts is disabled.")), t("Loading of external scripts is disabled");
                var n = "/" === e[0] ? this.endpointFor("assets", e) : e, i = function() {
                    if (!$504220289e15410d$var$L) return t("document not found");
                    var e = $504220289e15410d$var$L.createElement("script");
                    e.type = "text/javascript", e.src = n, e.onload = function(e) {
                        return t(void 0, e);
                    }, e.onerror = function(e) {
                        return t(e);
                    };
                    var i, r = $504220289e15410d$var$L.querySelectorAll("body > script");
                    r.length > 0 ? null === (i = r[0].parentNode) || void 0 === i || i.insertBefore(e, r[0]) : $504220289e15410d$var$L.body.appendChild(e);
                };
                null != $504220289e15410d$var$L && $504220289e15410d$var$L.body ? i() : null == $504220289e15410d$var$L || $504220289e15410d$var$L.addEventListener("DOMContentLoaded", i);
            }
        }
    ]), e;
}(), $504220289e15410d$var$fr = "posthog-js";
function $504220289e15410d$var$vr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.organization, i = t.projectId, r = t.prefix, s = t.severityAllowList, o = void 0 === s ? [
        "error"
    ] : s;
    return function(t) {
        var s, a, u, l, c;
        if (!("*" === o || o.includes(t.level)) || !e.__loaded) return t;
        t.tags || (t.tags = {});
        var d = e.requestRouter.endpointFor("ui", "/project/".concat(e.config.token, "/person/").concat(e.get_distinct_id()));
        t.tags["PostHog Person URL"] = d, e.sessionRecordingStarted() && (t.tags["PostHog Recording URL"] = e.get_session_replay_url({
            withTimestamp: !0
        }));
        var h = (null === (s = t.exception) || void 0 === s ? void 0 : s.values) || [], f = {
            $exception_message: (null === (a = h[0]) || void 0 === a ? void 0 : a.value) || t.message,
            $exception_type: null === (u = h[0]) || void 0 === u ? void 0 : u.type,
            $exception_personURL: d,
            $exception_level: t.level,
            $sentry_event_id: t.event_id,
            $sentry_exception: t.exception,
            $sentry_exception_message: (null === (l = h[0]) || void 0 === l ? void 0 : l.value) || t.message,
            $sentry_exception_type: null === (c = h[0]) || void 0 === c ? void 0 : c.type,
            $sentry_tags: t.tags,
            $level: t.level
        };
        return n && i && (f.$sentry_url = (r || "https://sentry.io/organizations/") + n + "/issues/?project=" + i + "&query=" + t.event_id), e.exceptions.sendExceptionEvent(f), t;
    };
}
var $504220289e15410d$var$pr = $504220289e15410d$var$s(function e(t, n, r, s, o) {
    $504220289e15410d$var$i(this, e), this.name = $504220289e15410d$var$fr, this.setupOnce = function(e) {
        e($504220289e15410d$var$vr(t, {
            organization: n,
            projectId: r,
            prefix: s,
            severityAllowList: o
        }));
    };
});
function $504220289e15410d$var$gr(e, t) {
    var n = e.config.segment;
    if (!n) return t();
    !function(e, t) {
        var n = e.config.segment;
        if (!n) return t();
        var i = function(n) {
            var i = function() {
                return n.anonymousId() || $504220289e15410d$var$Ze();
            };
            e.config.get_device_id = i, n.id() && (e.register({
                distinct_id: n.id(),
                $device_id: i()
            }), e.persistence.set_property($504220289e15410d$var$$e, "identified")), t();
        }, r = n.user();
        "then" in r && $504220289e15410d$var$y(r.then) ? r.then(function(e) {
            return i(e);
        }) : i(r);
    }(e, function() {
        n.register(function(e) {
            Promise && Promise.resolve || $504220289e15410d$var$W.warn("This browser does not have Promise support, and can not use the segment integration");
            var t = function(t, n) {
                var i;
                if (!n) return t;
                t.event.userId || t.event.anonymousId === e.get_distinct_id() || ($504220289e15410d$var$W.info("Segment integration does not have a userId set, resetting PostHog"), e.reset()), t.event.userId && t.event.userId !== e.get_distinct_id() && ($504220289e15410d$var$W.info("Segment integration has a userId set, identifying with PostHog"), e.identify(t.event.userId));
                var r = e._calculate_event_properties(n, null !== (i = t.event.properties) && void 0 !== i ? i : {}, new Date);
                return t.event.properties = Object.assign({}, r, t.event.properties), t;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: function() {
                    return !0;
                },
                load: function() {
                    return Promise.resolve();
                },
                track: function(e) {
                    return t(e, e.event.event);
                },
                page: function(e) {
                    return t(e, "$pageview");
                },
                identify: function(e) {
                    return t(e, "$identify");
                },
                screen: function(e) {
                    return t(e, "$screen");
                }
            };
        }(e)).then(function() {
            t();
        });
    });
}
var $504220289e15410d$export$22779822dd24228f, $504220289e15410d$export$9c2ac61661d417f8, $504220289e15410d$export$bbed2da3bd3bb001, $504220289e15410d$var$br = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this._instance = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "doPageView",
            value: function(e) {
                var t, n = this._previousPageViewProperties(e);
                return this._currentPath = null !== (t = null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.location.pathname) && void 0 !== t ? t : "", this._instance.scrollManager.resetContext(), this._prevPageviewTimestamp = e, n;
            }
        },
        {
            key: "doPageLeave",
            value: function(e) {
                return this._previousPageViewProperties(e);
            }
        },
        {
            key: "_previousPageViewProperties",
            value: function(e) {
                var t = this._currentPath, n = this._prevPageviewTimestamp, i = this._instance.scrollManager.getContext();
                if (!n) return {};
                var r = {};
                if (i) {
                    var s = i.maxScrollHeight, o = i.lastScrollY, a = i.maxScrollY, u = i.maxContentHeight, l = i.lastContentY, c = i.maxContentY;
                    if (!($504220289e15410d$var$w(s) || $504220289e15410d$var$w(o) || $504220289e15410d$var$w(a) || $504220289e15410d$var$w(u) || $504220289e15410d$var$w(l) || $504220289e15410d$var$w(c))) s = Math.ceil(s), o = Math.ceil(o), a = Math.ceil(a), u = Math.ceil(u), l = Math.ceil(l), c = Math.ceil(c), r = {
                        $prev_pageview_last_scroll: o,
                        $prev_pageview_last_scroll_percentage: s <= 1 ? 1 : $504220289e15410d$var$kr(o / s, 0, 1),
                        $prev_pageview_max_scroll: a,
                        $prev_pageview_max_scroll_percentage: s <= 1 ? 1 : $504220289e15410d$var$kr(a / s, 0, 1),
                        $prev_pageview_last_content: l,
                        $prev_pageview_last_content_percentage: u <= 1 ? 1 : $504220289e15410d$var$kr(l / u, 0, 1),
                        $prev_pageview_max_content: c,
                        $prev_pageview_max_content_percentage: u <= 1 ? 1 : $504220289e15410d$var$kr(c / u, 0, 1)
                    };
                }
                return t && (r.$prev_pageview_pathname = t), n && (r.$prev_pageview_duration = (e.getTime() - n.getTime()) / 1e3), r;
            }
        }
    ]), e;
}();
function $504220289e15410d$var$kr(e, t, n) {
    return Math.max(t, Math.min(e, n));
}
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}($504220289e15410d$export$22779822dd24228f || ($504220289e15410d$export$22779822dd24228f = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}($504220289e15410d$export$9c2ac61661d417f8 || ($504220289e15410d$export$9c2ac61661d417f8 = {})), function(e) {
    e.NextQuestion = "next_question", e.End = "end", e.ResponseBased = "response_based", e.SpecificQuestion = "specific_question";
}($504220289e15410d$export$bbed2da3bd3bb001 || ($504220289e15410d$export$bbed2da3bd3bb001 = {}));
var $504220289e15410d$var$wr = function() {
    function e() {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "events", {}), this.events = {};
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "on",
            value: function(e, t) {
                var n = this;
                return this.events[e] || (this.events[e] = []), this.events[e].push(t), function() {
                    n.events[e] = n.events[e].filter(function(e) {
                        return e !== t;
                    });
                };
            }
        },
        {
            key: "emit",
            value: function(e, t) {
                var n, i = $504220289e15410d$var$h(this.events[e] || []);
                try {
                    for(i.s(); !(n = i.n()).done;)(0, n.value)(t);
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                var r, s = $504220289e15410d$var$h(this.events["*"] || []);
                try {
                    for(s.s(); !(r = s.n()).done;)(0, r.value)(e, t);
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
            }
        }
    ]), e;
}(), $504220289e15410d$var$Sr = function() {
    function e(t) {
        var n = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_debugEventEmitter", new $504220289e15410d$var$wr), $504220289e15410d$var$o(this, "checkStep", function(e, t) {
            return n.checkStepEvent(e, t) && n.checkStepUrl(e, t) && n.checkStepElement(e, t);
        }), $504220289e15410d$var$o(this, "checkStepEvent", function(e, t) {
            return null == t || !t.event || (null == e ? void 0 : e.event) === (null == t ? void 0 : t.event);
        }), this.instance = t, this.actionEvents = new Set, this.actionRegistry = new Set;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "init",
            value: function() {
                var e, t = this;
                if (!$504220289e15410d$var$w(null === (e = this.instance) || void 0 === e ? void 0 : e._addCaptureHook)) {
                    var n;
                    null === (n = this.instance) || void 0 === n || n._addCaptureHook(function(e, n) {
                        t.on(e, n);
                    });
                }
            }
        },
        {
            key: "register",
            value: function(e) {
                var t, n, i = this;
                if (!$504220289e15410d$var$w(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) && (e.forEach(function(e) {
                    var t, n;
                    null === (t = i.actionRegistry) || void 0 === t || t.add(e), null === (n = e.steps) || void 0 === n || n.forEach(function(e) {
                        var t;
                        null === (t = i.actionEvents) || void 0 === t || t.add((null == e ? void 0 : e.event) || "");
                    });
                }), null !== (n = this.instance) && void 0 !== n && n.autocapture)) {
                    var r, s = new Set;
                    e.forEach(function(e) {
                        var t;
                        null === (t = e.steps) || void 0 === t || t.forEach(function(e) {
                            null != e && e.selector && s.add(null == e ? void 0 : e.selector);
                        });
                    }), null === (r = this.instance) || void 0 === r || r.autocapture.setElementSelectors(s);
                }
            }
        },
        {
            key: "on",
            value: function(e, t) {
                var n, i = this;
                null != t && 0 != e.length && (this.actionEvents.has(e) || this.actionEvents.has(null == t ? void 0 : t.event)) && this.actionRegistry && (null === (n = this.actionRegistry) || void 0 === n ? void 0 : n.size) > 0 && this.actionRegistry.forEach(function(e) {
                    i.checkAction(t, e) && i._debugEventEmitter.emit("actionCaptured", e.name);
                });
            }
        },
        {
            key: "_addActionHook",
            value: function(e) {
                this.onAction("actionCaptured", function(t) {
                    return e(t);
                });
            }
        },
        {
            key: "checkAction",
            value: function(e, t) {
                if (null == (null == t ? void 0 : t.steps)) return !1;
                var n, i = $504220289e15410d$var$h(t.steps);
                try {
                    for(i.s(); !(n = i.n()).done;){
                        var r = n.value;
                        if (this.checkStep(e, r)) return !0;
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return !1;
            }
        },
        {
            key: "onAction",
            value: function(e, t) {
                return this._debugEventEmitter.on(e, t);
            }
        },
        {
            key: "checkStepUrl",
            value: function(t, n) {
                if (null != n && n.url) {
                    var i, r = null == t || null === (i = t.properties) || void 0 === i ? void 0 : i.$current_url;
                    if (!r || "string" != typeof r) return !1;
                    if (!e.matchString(r, null == n ? void 0 : n.url, (null == n ? void 0 : n.url_matching) || "contains")) return !1;
                }
                return !0;
            }
        },
        {
            key: "checkStepElement",
            value: function(t, n) {
                if ((null != n && n.href || null != n && n.tag_name || null != n && n.text) && !this.getElementsList(t).some(function(t) {
                    return !(null != n && n.href && !e.matchString(t.href || "", null == n ? void 0 : n.href, (null == n ? void 0 : n.href_matching) || "exact")) && (null == n || !n.tag_name || t.tag_name === (null == n ? void 0 : n.tag_name)) && !(null != n && n.text && !e.matchString(t.text || "", null == n ? void 0 : n.text, (null == n ? void 0 : n.text_matching) || "exact") && !e.matchString(t.$el_text || "", null == n ? void 0 : n.text, (null == n ? void 0 : n.text_matching) || "exact"));
                })) return !1;
                if (null != n && n.selector) {
                    var i, r = null == t || null === (i = t.properties) || void 0 === i ? void 0 : i.$element_selectors;
                    if (!r) return !1;
                    if (!r.includes(null == n ? void 0 : n.selector)) return !1;
                }
                return !0;
            }
        },
        {
            key: "getElementsList",
            value: function(e) {
                return null == (null == e ? void 0 : e.properties.$elements) ? [] : null == e ? void 0 : e.properties.$elements;
            }
        }
    ], [
        {
            key: "matchString",
            value: function(t, n, i) {
                switch(i){
                    case "regex":
                        return !!$504220289e15410d$var$T && $504220289e15410d$var$_t(t, n);
                    case "exact":
                        return n === t;
                    case "contains":
                        var r = e.escapeStringRegexp(n).replace(/_/g, ".").replace(/%/g, ".*");
                        return $504220289e15410d$var$_t(t, r);
                    default:
                        return !1;
                }
            }
        },
        {
            key: "escapeStringRegexp",
            value: function(e) {
                return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
            }
        }
    ]), e;
}(), $504220289e15410d$var$Er = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this.instance = t, this.eventToSurveys = new Map, this.actionToSurveys = new Map;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "register",
            value: function(e) {
                var t;
                $504220289e15410d$var$w(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) || (this.setupEventBasedSurveys(e), this.setupActionBasedSurveys(e));
            }
        },
        {
            key: "setupActionBasedSurveys",
            value: function(e) {
                var t = this, n = e.filter(function(e) {
                    var t, n, i, r;
                    return (null === (t = e.conditions) || void 0 === t ? void 0 : t.actions) && (null === (n = e.conditions) || void 0 === n || null === (i = n.actions) || void 0 === i || null === (r = i.values) || void 0 === r ? void 0 : r.length) > 0;
                });
                if (0 !== n.length) {
                    if (null == this.actionMatcher) {
                        this.actionMatcher = new $504220289e15410d$var$Sr(this.instance), this.actionMatcher.init();
                        this.actionMatcher._addActionHook(function(e) {
                            t.onAction(e);
                        });
                    }
                    n.forEach(function(e) {
                        var n, i, r, s, o, a, u, l, c, d;
                        e.conditions && null !== (n = e.conditions) && void 0 !== n && n.actions && null !== (i = e.conditions) && void 0 !== i && null !== (r = i.actions) && void 0 !== r && r.values && (null === (s = e.conditions) || void 0 === s || null === (o = s.actions) || void 0 === o || null === (a = o.values) || void 0 === a ? void 0 : a.length) > 0 && (null === (u = t.actionMatcher) || void 0 === u || u.register(e.conditions.actions.values), null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c || null === (d = c.values) || void 0 === d || d.forEach(function(n) {
                            if (n && n.name) {
                                var i = t.actionToSurveys.get(n.name);
                                i && i.push(e.id), t.actionToSurveys.set(n.name, i || [
                                    e.id
                                ]);
                            }
                        }));
                    });
                }
            }
        },
        {
            key: "setupEventBasedSurveys",
            value: function(e) {
                var t, n = this;
                if (0 !== e.filter(function(e) {
                    var t, n, i, r;
                    return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (n = e.conditions) || void 0 === n || null === (i = n.events) || void 0 === i || null === (r = i.values) || void 0 === r ? void 0 : r.length) > 0;
                }).length) null === (t = this.instance) || void 0 === t || t._addCaptureHook(function(e, t) {
                    n.onEvent(e, t);
                }), e.forEach(function(e) {
                    var t, i, r;
                    null === (t = e.conditions) || void 0 === t || null === (i = t.events) || void 0 === i || null === (r = i.values) || void 0 === r || r.forEach(function(t) {
                        if (t && t.name) {
                            var i = n.eventToSurveys.get(t.name);
                            i && i.push(e.id), n.eventToSurveys.set(t.name, i || [
                                e.id
                            ]);
                        }
                    });
                });
            }
        },
        {
            key: "onEvent",
            value: function(t, n) {
                var i, r, s = (null === (i = this.instance) || void 0 === i || null === (r = i.persistence) || void 0 === r ? void 0 : r.props[$504220289e15410d$var$Ce]) || [];
                if (e.SURVEY_SHOWN_EVENT_NAME == t && n && s.length > 0) {
                    var o, a = null == n || null === (o = n.properties) || void 0 === o ? void 0 : o.$survey_id;
                    if (a) {
                        var u = s.indexOf(a);
                        u >= 0 && (s.splice(u, 1), this._updateActivatedSurveys(s));
                    }
                } else this.eventToSurveys.has(t) && this._updateActivatedSurveys(s.concat(this.eventToSurveys.get(t) || []));
            }
        },
        {
            key: "onAction",
            value: function(e) {
                var t, n, i = (null === (t = this.instance) || void 0 === t || null === (n = t.persistence) || void 0 === n ? void 0 : n.props[$504220289e15410d$var$Ce]) || [];
                this.actionToSurveys.has(e) && this._updateActivatedSurveys(i.concat(this.actionToSurveys.get(e) || []));
            }
        },
        {
            key: "_updateActivatedSurveys",
            value: function(e) {
                var t, n;
                null === (t = this.instance) || void 0 === t || null === (n = t.persistence) || void 0 === n || n.register($504220289e15410d$var$o({}, $504220289e15410d$var$Ce, $504220289e15410d$var$l(new Set(e))));
            }
        },
        {
            key: "getSurveys",
            value: function() {
                var e, t, n = null === (e = this.instance) || void 0 === e || null === (t = e.persistence) || void 0 === t ? void 0 : t.props[$504220289e15410d$var$Ce];
                return n || [];
            }
        },
        {
            key: "getEventToSurveys",
            value: function() {
                return this.eventToSurveys;
            }
        },
        {
            key: "_getActionMatcher",
            value: function() {
                return this.actionMatcher;
            }
        }
    ]), e;
}();
$504220289e15410d$var$o($504220289e15410d$var$Er, "SURVEY_SHOWN_EVENT_NAME", "survey shown");
var $504220289e15410d$var$Ir = "[Surveys]", $504220289e15410d$var$xr = {
    icontains: function(e) {
        return !!$504220289e15410d$var$T && $504220289e15410d$var$T.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1;
    },
    not_icontains: function(e) {
        return !!$504220289e15410d$var$T && -1 === $504220289e15410d$var$T.location.href.toLowerCase().indexOf(e.toLowerCase());
    },
    regex: function(e) {
        return !!$504220289e15410d$var$T && $504220289e15410d$var$_t($504220289e15410d$var$T.location.href, e);
    },
    not_regex: function(e) {
        return !!$504220289e15410d$var$T && !$504220289e15410d$var$_t($504220289e15410d$var$T.location.href, e);
    },
    exact: function(e) {
        return (null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.location.href) === e;
    },
    is_not: function(e) {
        return (null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.location.href) !== e;
    }
};
var $504220289e15410d$var$Fr = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this.instance = t, this._surveyEventReceiver = null;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "afterDecideResponse",
            value: function(e) {
                this._decideServerResponse = !!e.surveys, this.loadIfEnabled();
            }
        },
        {
            key: "loadIfEnabled",
            value: function() {
                var e = this, t = null == $504220289e15410d$var$U ? void 0 : $504220289e15410d$var$U.extendPostHogWithSurveys;
                this.instance.config.disable_surveys || !this._decideServerResponse || t || (null == this._surveyEventReceiver && (this._surveyEventReceiver = new $504220289e15410d$var$Er(this.instance)), this.instance.requestRouter.loadScript("/static/surveys.js", function(t) {
                    if (t) return $504220289e15410d$var$W.error($504220289e15410d$var$Ir, "Could not load surveys script", t);
                    e._surveyManager = $504220289e15410d$var$U.extendPostHogWithSurveys(e.instance);
                }));
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (this.instance.config.disable_surveys) return e([]);
                null == this._surveyEventReceiver && (this._surveyEventReceiver = new $504220289e15410d$var$Er(this.instance));
                var i = this.instance.get_property($504220289e15410d$var$Te);
                if (i && !n) return e(i);
                this.instance._send_request({
                    url: this.instance.requestRouter.endpointFor("api", "/api/surveys/?token=".concat(this.instance.config.token)),
                    method: "GET",
                    transport: "XHR",
                    callback: function(n) {
                        var i;
                        if (200 !== n.statusCode || !n.json) return e([]);
                        var r, s = n.json.surveys || [], a = s.filter(function(e) {
                            var t, n, i, r, s, o, a, u, l, c, d, h;
                            return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (n = e.conditions) || void 0 === n || null === (i = n.events) || void 0 === i ? void 0 : i.values) && (null === (r = e.conditions) || void 0 === r || null === (s = r.events) || void 0 === s || null === (o = s.values) || void 0 === o ? void 0 : o.length) > 0 || (null === (a = e.conditions) || void 0 === a ? void 0 : a.actions) && (null === (u = e.conditions) || void 0 === u || null === (l = u.actions) || void 0 === l ? void 0 : l.values) && (null === (c = e.conditions) || void 0 === c || null === (d = c.actions) || void 0 === d || null === (h = d.values) || void 0 === h ? void 0 : h.length) > 0;
                        });
                        a.length > 0 && (null === (r = t._surveyEventReceiver) || void 0 === r || r.register(a));
                        return null === (i = t.instance.persistence) || void 0 === i || i.register($504220289e15410d$var$o({}, $504220289e15410d$var$Te, s)), e(s);
                    }
                });
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.getSurveys(function(n) {
                    var i, r = n.filter(function(e) {
                        return !(!e.start_date || e.end_date);
                    }).filter(function(e) {
                        var t, n, i, r;
                        if (!e.conditions) return !0;
                        var s = null === (t = e.conditions) || void 0 === t || !t.url || $504220289e15410d$var$xr[null !== (n = null === (i = e.conditions) || void 0 === i ? void 0 : i.urlMatchType) && void 0 !== n ? n : "icontains"](e.conditions.url), o = null === (r = e.conditions) || void 0 === r || !r.selector || (null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.querySelector(e.conditions.selector));
                        return s && o;
                    }), s = null === (i = t._surveyEventReceiver) || void 0 === i ? void 0 : i.getSurveys(), o = r.filter(function(e) {
                        var n, i, r, o, a, u, l, c, d, h;
                        if (!e.linked_flag_key && !e.targeting_flag_key && !e.internal_targeting_flag_key) return !0;
                        var f = !e.linked_flag_key || t.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), v = !e.targeting_flag_key || t.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key), p = (null === (n = e.conditions) || void 0 === n ? void 0 : n.events) && (null === (i = e.conditions) || void 0 === i || null === (r = i.events) || void 0 === r ? void 0 : r.values) && (null === (o = e.conditions) || void 0 === o || null === (a = o.events) || void 0 === a ? void 0 : a.values.length) > 0, g = (null === (u = e.conditions) || void 0 === u ? void 0 : u.actions) && (null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c ? void 0 : c.values) && (null === (d = e.conditions) || void 0 === d || null === (h = d.actions) || void 0 === h ? void 0 : h.values.length) > 0, _ = !p && !g || (null == s ? void 0 : s.includes(e.id)), m = t._canActivateRepeatedly(e), y = !(e.internal_targeting_flag_key && !m) || t.instance.featureFlags.isFeatureEnabled(e.internal_targeting_flag_key);
                        return f && v && y && _;
                    });
                    return e(o);
                }, n);
            }
        },
        {
            key: "getNextSurveyStep",
            value: function(e, t, n) {
                var i, r = e.questions[t], s = t + 1;
                if (null === (i = r.branching) || void 0 === i || !i.type) return t === e.questions.length - 1 ? $504220289e15410d$export$bbed2da3bd3bb001.End : s;
                if (r.branching.type === $504220289e15410d$export$bbed2da3bd3bb001.End) return $504220289e15410d$export$bbed2da3bd3bb001.End;
                if (r.branching.type === $504220289e15410d$export$bbed2da3bd3bb001.SpecificQuestion) {
                    if (Number.isInteger(r.branching.index)) return r.branching.index;
                } else if (r.branching.type === $504220289e15410d$export$bbed2da3bd3bb001.ResponseBased) {
                    if (r.type === $504220289e15410d$export$9c2ac61661d417f8.SingleChoice) {
                        var o, a, u = r.choices.indexOf("".concat(n));
                        if (null !== (o = r.branching) && void 0 !== o && null !== (a = o.responseValues) && void 0 !== a && a.hasOwnProperty(u)) {
                            var l = r.branching.responseValues[u];
                            return Number.isInteger(l) ? l : l === $504220289e15410d$export$bbed2da3bd3bb001.End ? $504220289e15410d$export$bbed2da3bd3bb001.End : s;
                        }
                    } else if (r.type === $504220289e15410d$export$9c2ac61661d417f8.Rating) {
                        var c, d;
                        if ("number" != typeof n || !Number.isInteger(n)) throw new Error("The response type must be an integer");
                        var h = function(e, t) {
                            if (3 === t) {
                                if (e < 1 || e > 3) throw new Error("The response must be in range 1-3");
                                return 1 === e ? "negative" : 2 === e ? "neutral" : "positive";
                            }
                            if (5 === t) {
                                if (e < 1 || e > 5) throw new Error("The response must be in range 1-5");
                                return e <= 2 ? "negative" : 3 === e ? "neutral" : "positive";
                            }
                            if (10 === t) {
                                if (e < 0 || e > 10) throw new Error("The response must be in range 0-10");
                                return e <= 6 ? "detractors" : e <= 8 ? "passives" : "promoters";
                            }
                            throw new Error("The scale must be one of: 3, 5, 10");
                        }(n, r.scale);
                        if (null !== (c = r.branching) && void 0 !== c && null !== (d = c.responseValues) && void 0 !== d && d.hasOwnProperty(h)) {
                            var f = r.branching.responseValues[h];
                            return Number.isInteger(f) ? f : f === $504220289e15410d$export$bbed2da3bd3bb001.End ? $504220289e15410d$export$bbed2da3bd3bb001.End : s;
                        }
                    }
                    return s;
                }
                return $504220289e15410d$var$W.warn($504220289e15410d$var$Ir, "Falling back to next question index due to unexpected branching type"), s;
            }
        },
        {
            key: "_canActivateRepeatedly",
            value: function(e) {
                var t;
                return $504220289e15410d$var$x(null === (t = $504220289e15410d$var$U.__PosthogExtensions__) || void 0 === t ? void 0 : t.canActivateRepeatedly) ? ($504220289e15410d$var$W.warn($504220289e15410d$var$Ir, "canActivateRepeatedly is not defined, must init before calling"), !1) : $504220289e15410d$var$U.__PosthogExtensions__.canActivateRepeatedly(e);
            }
        },
        {
            key: "canRenderSurvey",
            value: function(e) {
                var t = this;
                $504220289e15410d$var$x(this._surveyManager) ? $504220289e15410d$var$W.warn($504220289e15410d$var$Ir, "canActivateRepeatedly is not defined, must init before calling") : this.getSurveys(function(n) {
                    var i = n.filter(function(t) {
                        return t.id === e;
                    })[0];
                    t._surveyManager.canRenderSurvey(i);
                });
            }
        },
        {
            key: "renderSurvey",
            value: function(e, t) {
                var n = this;
                $504220289e15410d$var$x(this._surveyManager) ? $504220289e15410d$var$W.warn($504220289e15410d$var$Ir, "canActivateRepeatedly is not defined, must init before calling") : this.getSurveys(function(i) {
                    var r = i.filter(function(t) {
                        return t.id === e;
                    })[0];
                    n._surveyManager.renderSurvey(r, null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.querySelector(t));
                });
            }
        }
    ]), e;
}(), $504220289e15410d$var$Rr = function() {
    function e(t) {
        var n, r, s = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "serverLimits", {}), $504220289e15410d$var$o(this, "lastEventRateLimited", !1), $504220289e15410d$var$o(this, "checkForLimiting", function(e) {
            var t = e.text;
            if (t && t.length) try {
                (JSON.parse(t).quota_limited || []).forEach(function(e) {
                    $504220289e15410d$var$W.info("[RateLimiter] ".concat(e || "events", " is quota limited.")), s.serverLimits[e] = (new Date).getTime() + 6e4;
                });
            } catch (e) {
                return void $504220289e15410d$var$W.warn('[RateLimiter] could not rate limit - continuing. Error: "'.concat(null == e ? void 0 : e.message, '"'), {
                    text: t
                });
            }
        }), this.instance = t, this.captureEventsPerSecond = (null === (n = t.config.rate_limiting) || void 0 === n ? void 0 : n.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null === (r = t.config.rate_limiting) || void 0 === r ? void 0 : r.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "clientRateLimitContext",
            value: function() {
                var e, t, n, i = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], r = (new Date).getTime(), s = null !== (e = null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.get_property($504220289e15410d$var$Ae)) && void 0 !== e ? e : {
                    tokens: this.captureEventsBurstLimit,
                    last: r
                };
                s.tokens += (r - s.last) / 1e3 * this.captureEventsPerSecond, s.last = r, s.tokens > this.captureEventsBurstLimit && (s.tokens = this.captureEventsBurstLimit);
                var o = s.tokens < 1;
                return o || i || (s.tokens = Math.max(0, s.tokens - 1)), !o || this.lastEventRateLimited || i || this.instance.capture("$$client_ingestion_warning", {
                    $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to ".concat(this.captureEventsPerSecond, " events per second and ").concat(this.captureEventsBurstLimit, " events burst limit.")
                }, {
                    skip_client_rate_limiting: !0
                }), this.lastEventRateLimited = o, null === (n = this.instance.persistence) || void 0 === n || n.set_property($504220289e15410d$var$Ae, s), {
                    isRateLimited: o,
                    remainingTokens: s.tokens
                };
            }
        },
        {
            key: "isServerRateLimited",
            value: function(e) {
                var t = this.serverLimits[e || "events"] || !1;
                return !1 !== t && (new Date).getTime() < t;
            }
        }
    ]), e;
}(), $504220289e15410d$var$Pr = function() {
    return $504220289e15410d$var$t({
        initialPathName: (null == $504220289e15410d$var$D ? void 0 : $504220289e15410d$var$D.pathname) || "",
        referringDomain: $504220289e15410d$var$yn.referringDomain()
    }, $504220289e15410d$var$yn.campaignParams());
}, $504220289e15410d$var$Tr = function() {
    function e(t, n, r) {
        var s = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_onSessionIdCallback", function(e) {
            var t = s._getStoredProps();
            if (!t || t.sessionId !== e) {
                var n = {
                    sessionId: e,
                    props: s._sessionSourceParamGenerator()
                };
                s._persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$Me, n));
            }
        }), this._sessionIdManager = t, this._persistence = n, this._sessionSourceParamGenerator = r || $504220289e15410d$var$Pr, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "_getStoredProps",
            value: function() {
                return this._persistence.props[$504220289e15410d$var$Me];
            }
        },
        {
            key: "getSessionProps",
            value: function() {
                var e, t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
                return t ? {
                    $client_session_initial_referring_host: t.referringDomain,
                    $client_session_initial_pathname: t.initialPathName,
                    $client_session_initial_utm_source: t.utm_source,
                    $client_session_initial_utm_campaign: t.utm_campaign,
                    $client_session_initial_utm_medium: t.utm_medium,
                    $client_session_initial_utm_content: t.utm_content,
                    $client_session_initial_utm_term: t.utm_term
                } : {};
            }
        }
    ]), e;
}(), $504220289e15410d$var$Cr = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "headlesschrome",
    "cypress",
    "Google-HotelAdsVerifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "Bytespider;"
], $504220289e15410d$var$Or = function(e, t) {
    if (!e) return !1;
    var n = e.toLowerCase();
    return $504220289e15410d$var$Cr.concat(t || []).some(function(e) {
        var t = e.toLowerCase();
        return -1 !== n.indexOf(t);
    });
}, $504220289e15410d$var$$r = function() {
    function e() {
        $504220289e15410d$var$i(this, e), this.clicks = [];
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "isRageClick",
            value: function(e, t, n) {
                var i = this.clicks[this.clicks.length - 1];
                if (i && Math.abs(e - i.x) + Math.abs(t - i.y) < 30 && n - i.timestamp < 1e3) {
                    if (this.clicks.push({
                        x: e,
                        y: t,
                        timestamp: n
                    }), 3 === this.clicks.length) return !0;
                } else this.clicks = [
                    {
                        x: e,
                        y: t,
                        timestamp: n
                    }
                ];
                return !1;
            }
        }
    ]), e;
}();
function $504220289e15410d$var$Mr(e) {
    var t;
    return e.id === $504220289e15410d$var$Be || !(null === (t = e.closest) || void 0 === t || !t.call(e, "#" + $504220289e15410d$var$Be));
}
var $504220289e15410d$var$Ar = function() {
    function e(t) {
        var n, r = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "rageclicks", new $504220289e15410d$var$$r), $504220289e15410d$var$o(this, "_enabledServerSide", !1), $504220289e15410d$var$o(this, "_initialized", !1), $504220289e15410d$var$o(this, "_flushInterval", null), this.instance = t, this._enabledServerSide = !(null === (n = this.instance.persistence) || void 0 === n || !n.props[$504220289e15410d$var$fe]), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("beforeunload", function() {
            r.flush();
        });
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "flushIntervalMilliseconds",
            get: function() {
                var e = 5e3;
                return $504220289e15410d$var$b(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (e = this.instance.config.capture_heatmaps.flush_interval_milliseconds), e;
            }
        },
        {
            key: "isEnabled",
            get: function() {
                return $504220289e15410d$var$w(this.instance.config.capture_heatmaps) ? $504220289e15410d$var$w(this.instance.config.enable_heatmaps) ? this._enabledServerSide : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                if (this.isEnabled) {
                    if (this._initialized) return;
                    $504220289e15410d$var$W.info("[heatmaps] starting..."), this._setupListeners(), this._flushInterval = setInterval(this.flush.bind(this), this.flushIntervalMilliseconds);
                } else {
                    var e;
                    clearInterval(null !== (e = this._flushInterval) && void 0 !== e ? e : void 0), this.getAndClearBuffer();
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = !!e.heatmaps;
                this.instance.persistence && this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$fe, t)), this._enabledServerSide = t, this.startIfEnabled();
            }
        },
        {
            key: "getAndClearBuffer",
            value: function() {
                var e = this.buffer;
                return this.buffer = void 0, e;
            }
        },
        {
            key: "_setupListeners",
            value: function() {
                var e = this;
                $504220289e15410d$var$T && $504220289e15410d$var$L && ($504220289e15410d$var$oe($504220289e15410d$var$L, "click", function(t) {
                    return e._onClick(t || (null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.event));
                }, !1, !0), $504220289e15410d$var$oe($504220289e15410d$var$L, "mousemove", function(t) {
                    return e._onMouseMove(t || (null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.event));
                }, !1, !0), this._initialized = !0);
            }
        },
        {
            key: "_getProperties",
            value: function(e, t) {
                var n = this.instance.scrollManager.scrollY(), i = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), s = function(e, t, n) {
                    for(var i = e; i && !$504220289e15410d$var$On(i, "body");){
                        if (i === n) return !1;
                        if ($504220289e15410d$var$Y(t, null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.getComputedStyle(i).position)) return !0;
                        i = $504220289e15410d$var$Ln(i);
                    }
                    return !1;
                }(e.target, [
                    "fixed",
                    "sticky"
                ], r);
                return {
                    x: e.clientX + (s ? 0 : i),
                    y: e.clientY + (s ? 0 : n),
                    target_fixed: s,
                    type: t
                };
            }
        },
        {
            key: "_onClick",
            value: function(e) {
                var n;
                if (!$504220289e15410d$var$Mr(e.target)) {
                    var i = this._getProperties(e, "click");
                    null !== (n = this.rageclicks) && void 0 !== n && n.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._capture($504220289e15410d$var$t($504220289e15410d$var$t({}, i), {}, {
                        type: "rageclick"
                    })), this._capture(i);
                }
            }
        },
        {
            key: "_onMouseMove",
            value: function(e) {
                var t = this;
                $504220289e15410d$var$Mr(e.target) || (clearTimeout(this._mouseMoveTimeout), this._mouseMoveTimeout = setTimeout(function() {
                    t._capture(t._getProperties(e, "mousemove"));
                }, 500));
            }
        },
        {
            key: "_capture",
            value: function(e) {
                if ($504220289e15410d$var$T) {
                    var t = $504220289e15410d$var$T.location.href;
                    this.buffer = this.buffer || {}, this.buffer[t] || (this.buffer[t] = []), this.buffer[t].push(e);
                }
            }
        },
        {
            key: "flush",
            value: function() {
                this.buffer && !$504220289e15410d$var$k(this.buffer) && this.instance.capture("$$heatmap", {
                    $heatmap_data: this.getAndClearBuffer()
                });
            }
        }
    ]), e;
}(), $504220289e15410d$var$Lr = function() {
    function e(t) {
        var n = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_updateScrollData", function() {
            var e, t, i, r;
            n.context || (n.context = {});
            var s = n.scrollElement(), o = n.scrollY(), a = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, u = o + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            n.context.lastScrollY = Math.ceil(o), n.context.maxScrollY = Math.max(o, null !== (e = n.context.maxScrollY) && void 0 !== e ? e : 0), n.context.maxScrollHeight = Math.max(a, null !== (t = n.context.maxScrollHeight) && void 0 !== t ? t : 0), n.context.lastContentY = u, n.context.maxContentY = Math.max(u, null !== (i = n.context.maxContentY) && void 0 !== i ? i : 0), n.context.maxContentHeight = Math.max(l, null !== (r = n.context.maxContentHeight) && void 0 !== r ? r : 0);
        }), this.instance = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "getContext",
            value: function() {
                return this.context;
            }
        },
        {
            key: "resetContext",
            value: function() {
                var e = this.context;
                return setTimeout(this._updateScrollData, 0), e;
            }
        },
        {
            key: "startMeasuringScrollPosition",
            value: function() {
                null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("scroll", this._updateScrollData, !0), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("scrollend", this._updateScrollData, !0), null == $504220289e15410d$var$T || $504220289e15410d$var$T.addEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "scrollElement",
            value: function() {
                if (!this.instance.config.scroll_root_selector) return null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.document.documentElement;
                var e, t = $504220289e15410d$var$h($504220289e15410d$var$m(this.instance.config.scroll_root_selector) ? this.instance.config.scroll_root_selector : [
                    this.instance.config.scroll_root_selector
                ]);
                try {
                    for(t.s(); !(e = t.n()).done;){
                        var n = e.value, i = null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.document.querySelector(n);
                        if (i) return i;
                    }
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
            }
        },
        {
            key: "scrollY",
            value: function() {
                if (this.instance.config.scroll_root_selector) {
                    var e = this.scrollElement();
                    return e && e.scrollTop || 0;
                }
                return $504220289e15410d$var$T && ($504220289e15410d$var$T.scrollY || $504220289e15410d$var$T.pageYOffset || $504220289e15410d$var$T.document.documentElement.scrollTop) || 0;
            }
        },
        {
            key: "scrollX",
            value: function() {
                if (this.instance.config.scroll_root_selector) {
                    var e = this.scrollElement();
                    return e && e.scrollLeft || 0;
                }
                return $504220289e15410d$var$T && ($504220289e15410d$var$T.scrollX || $504220289e15410d$var$T.pageXOffset || $504220289e15410d$var$T.document.documentElement.scrollLeft) || 0;
            }
        }
    ]), e;
}(), $504220289e15410d$var$Dr = "$copy_autocapture";
function $504220289e15410d$var$Nr(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
var $504220289e15410d$var$qr, $504220289e15410d$var$Br = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_initialized", !1), $504220289e15410d$var$o(this, "_isDisabledServerSide", null), $504220289e15410d$var$o(this, "rageclicks", new $504220289e15410d$var$$r), $504220289e15410d$var$o(this, "_elementsChainAsString", !1), this.instance = t, this._elementSelectors = null;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "config",
            get: function() {
                var e, t, n = $504220289e15410d$var$b(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
                return n.url_allowlist = null === (e = n.url_allowlist) || void 0 === e ? void 0 : e.map(function(e) {
                    return new RegExp(e);
                }), n.url_ignorelist = null === (t = n.url_ignorelist) || void 0 === t ? void 0 : t.map(function(e) {
                    return new RegExp(e);
                }), n;
            }
        },
        {
            key: "_addDomEventHandlers",
            value: function() {
                var e = this;
                if (this.isBrowserSupported()) {
                    if ($504220289e15410d$var$T && $504220289e15410d$var$L) {
                        var t = function(t) {
                            t = t || (null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.event);
                            try {
                                e._captureEvent(t);
                            } catch (e) {
                                $504220289e15410d$var$W.error("Failed to capture event", e);
                            }
                        }, n = function(t) {
                            t = t || (null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.event), e._captureEvent(t, $504220289e15410d$var$Dr);
                        };
                        $504220289e15410d$var$oe($504220289e15410d$var$L, "submit", t, !1, !0), $504220289e15410d$var$oe($504220289e15410d$var$L, "change", t, !1, !0), $504220289e15410d$var$oe($504220289e15410d$var$L, "click", t, !1, !0), this.config.capture_copied_text && ($504220289e15410d$var$oe($504220289e15410d$var$L, "copy", n, !1, !0), $504220289e15410d$var$oe($504220289e15410d$var$L, "cut", n, !1, !0));
                    }
                } else $504220289e15410d$var$W.info("Disabling Automatic Event Collection because this browser is not supported");
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                this.isEnabled && !this._initialized && (this._addDomEventHandlers(), this._initialized = !0);
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                e.elementsChainAsString && (this._elementsChainAsString = e.elementsChainAsString), this.instance.persistence && this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$he, !!e.autocapture_opt_out)), this._isDisabledServerSide = !!e.autocapture_opt_out, this.startIfEnabled();
            }
        },
        {
            key: "setElementSelectors",
            value: function(e) {
                this._elementSelectors = e;
            }
        },
        {
            key: "getElementSelectors",
            value: function(e) {
                var t, n = [];
                return null === (t = this._elementSelectors) || void 0 === t || t.forEach(function(t) {
                    var i = null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.querySelectorAll(t);
                    null == i || i.forEach(function(i) {
                        e === i && n.push(t);
                    });
                }), n;
            }
        },
        {
            key: "isEnabled",
            get: function() {
                var e, t, n = null === (e = this.instance.persistence) || void 0 === e ? void 0 : e.props[$504220289e15410d$var$he], i = this._isDisabledServerSide;
                if ($504220289e15410d$var$I(i) && !$504220289e15410d$var$R(n) && !this.instance.config.advanced_disable_decide) return !1;
                var r = null !== (t = this._isDisabledServerSide) && void 0 !== t ? t : !!n;
                return !!this.instance.config.autocapture && !r;
            }
        },
        {
            key: "_previousElementSibling",
            value: function(e) {
                if (e.previousElementSibling) return e.previousElementSibling;
                var t = e;
                do t = t.previousSibling;
                while (t && !$504220289e15410d$var$Cn(t));
                return t;
            }
        },
        {
            key: "_getAugmentPropertiesFromElement",
            value: function(e) {
                if (!$504220289e15410d$var$Nn(e)) return {};
                var t = {};
                return $504220289e15410d$var$Q(e.attributes, function(e) {
                    if (e.name && 0 === e.name.indexOf("data-ph-capture-attribute")) {
                        var n = e.name.replace("data-ph-capture-attribute-", ""), i = e.value;
                        n && i && $504220289e15410d$var$zn(i) && (t[n] = i);
                    }
                }), t;
            }
        },
        {
            key: "_getPropertiesFromElement",
            value: function(e, t, n) {
                var i, r = e.tagName.toLowerCase(), s = {
                    tag_name: r
                };
                $504220289e15410d$var$An.indexOf(r) > -1 && !n && ("a" === r.toLowerCase() || "button" === r.toLowerCase() ? s.$el_text = $504220289e15410d$var$Nr(1024, $504220289e15410d$var$Gn(e)) : s.$el_text = $504220289e15410d$var$Nr(1024, $504220289e15410d$var$Tn(e)));
                var o = $504220289e15410d$var$Rn(e);
                o.length > 0 && (s.classes = o.filter(function(e) {
                    return "" !== e;
                }));
                var a = null === (i = this.config) || void 0 === i ? void 0 : i.element_attribute_ignorelist;
                $504220289e15410d$var$Q(e.attributes, function(n) {
                    var i;
                    if ((!$504220289e15410d$var$qn(e) || -1 !== [
                        "name",
                        "id",
                        "class",
                        "aria-label"
                    ].indexOf(n.name)) && (null == a || !a.includes(n.name)) && !t && $504220289e15410d$var$zn(n.value) && (i = n.name, !$504220289e15410d$var$S(i) || "_ngcontent" !== i.substring(0, 10) && "_nghost" !== i.substring(0, 7))) {
                        var r = n.value;
                        "class" === n.name && (r = $504220289e15410d$var$xn(r).join(" ")), s["attr__" + n.name] = $504220289e15410d$var$Nr(1024, r);
                    }
                });
                for(var u = 1, l = 1, c = e; c = this._previousElementSibling(c);)u++, c.tagName === e.tagName && l++;
                return s.nth_child = u, s.nth_of_type = l, s;
            }
        },
        {
            key: "_getDefaultProperties",
            value: function(e) {
                return {
                    $event_type: e,
                    $ce_version: 1
                };
            }
        },
        {
            key: "_getEventTarget",
            value: function(e) {
                var t;
                return $504220289e15410d$var$w(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
            }
        },
        {
            key: "_captureEvent",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "$autocapture";
                if (this.isEnabled) {
                    var i, r = this._getEventTarget(e);
                    if ($504220289e15410d$var$$n(r) && (r = r.parentNode || null), "$autocapture" === n && "click" === e.type && e instanceof MouseEvent) this.instance.config.rageclick && null !== (i = this.rageclicks) && void 0 !== i && i.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._captureEvent(e, "$rageclick");
                    var s = n === $504220289e15410d$var$Dr;
                    if (r && $504220289e15410d$var$Dn(r, e, this.config, s, s ? [
                        "copy",
                        "cut"
                    ] : void 0)) {
                        for(var o, a, u = [
                            r
                        ], l = r; l.parentNode && !$504220289e15410d$var$On(l, "body");)$504220289e15410d$var$Mn(l.parentNode) ? (u.push(l.parentNode.host), l = l.parentNode.host) : (u.push(l.parentNode), l = l.parentNode);
                        var c, d, h = [], f = {}, v = !1;
                        if ($504220289e15410d$var$Q(u, function(e) {
                            var n = $504220289e15410d$var$Nn(e);
                            "a" === e.tagName.toLowerCase() && (c = e.getAttribute("href"), c = n && $504220289e15410d$var$zn(c) && c), $504220289e15410d$var$Y($504220289e15410d$var$Rn(e), "ph-no-capture") && (v = !0), h.push(t._getPropertiesFromElement(e, t.instance.config.mask_all_element_attributes, t.instance.config.mask_all_text));
                            var i = t._getAugmentPropertiesFromElement(e);
                            $504220289e15410d$var$J(f, i);
                        }), this.instance.config.mask_all_text || ("a" === r.tagName.toLowerCase() || "button" === r.tagName.toLowerCase() ? h[0].$el_text = $504220289e15410d$var$Gn(r) : h[0].$el_text = $504220289e15410d$var$Tn(r)), c) {
                            var p, g;
                            h[0].attr__href = c;
                            var _ = null === (p = $504220289e15410d$var$gt(c)) || void 0 === p ? void 0 : p.host, m = null == $504220289e15410d$var$T || null === (g = $504220289e15410d$var$T.location) || void 0 === g ? void 0 : g.host;
                            _ && m && _ !== m && (d = c);
                        }
                        if (v) return !1;
                        var y = $504220289e15410d$var$J(this._getDefaultProperties(e.type), this._elementsChainAsString ? {
                            $elements_chain: $504220289e15410d$var$Jn(h)
                        } : {
                            $elements: h
                        }, null !== (o = h[0]) && void 0 !== o && o.$el_text ? {
                            $el_text: null === (a = h[0]) || void 0 === a ? void 0 : a.$el_text
                        } : {}, d && "click" === e.type ? {
                            $external_click_url: d
                        } : {}, f), b = this.getElementSelectors(r);
                        if (b && b.length > 0 && (y.$element_selectors = b), n === $504220289e15410d$var$Dr) {
                            var k, w = $504220289e15410d$var$Pn(null == $504220289e15410d$var$T || null === (k = $504220289e15410d$var$T.getSelection()) || void 0 === k ? void 0 : k.toString()), S = e.type || "clipboard";
                            if (!w) return !1;
                            y.$selected_content = w, y.$copy_type = S;
                        }
                        return this.instance.capture(n, y), !0;
                    }
                }
            }
        },
        {
            key: "isBrowserSupported",
            value: function() {
                return $504220289e15410d$var$y(null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.querySelectorAll);
            }
        }
    ]), e;
}(), $504220289e15410d$var$Hr = function() {
    function e(t) {
        var n = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_restoreXHRPatch", void 0), $504220289e15410d$var$o(this, "_restoreFetchPatch", void 0), $504220289e15410d$var$o(this, "_startCapturing", function() {
            $504220289e15410d$var$w(n._restoreXHRPatch) && $504220289e15410d$var$U.postHogTracingHeadersPatchFns._patchXHR(n.instance.sessionManager), $504220289e15410d$var$w(n._restoreFetchPatch) && $504220289e15410d$var$U.postHogTracingHeadersPatchFns._patchFetch(n.instance.sessionManager);
        }), this.instance = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "_loadScript",
            value: function(e) {
                $504220289e15410d$var$U.postHogTracingHeadersPatchFns && e(), this.instance.requestRouter.loadScript("/static/tracing-headers.js?v=".concat($504220289e15410d$var$f.LIB_VERSION), function(t) {
                    if (t) return $504220289e15410d$var$W.error("[TRACING-HEADERS] failed to load script", t);
                    e();
                });
            }
        },
        {
            key: "startIfEnabledOrStop",
            value: function() {
                var e, t;
                this.instance.config.__add_tracing_headers ? this._loadScript(this._startCapturing) : (null === (e = this._restoreXHRPatch) || void 0 === e || e.call(this), null === (t = this._restoreFetchPatch) || void 0 === t || t.call(this), this._restoreXHRPatch = void 0, this._restoreFetchPatch = void 0);
            }
        }
    ]), e;
}();
!function(e) {
    e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED";
}($504220289e15410d$var$qr || ($504220289e15410d$var$qr = {}));
var $504220289e15410d$var$Ur = function() {
    function e(t) {
        $504220289e15410d$var$i(this, e), this.instance = t;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "config",
            get: function() {
                return this.instance.config;
            }
        },
        {
            key: "consent",
            get: function() {
                return this.getDnt() ? $504220289e15410d$var$qr.DENIED : this.storedConsent;
            }
        },
        {
            key: "isOptedOut",
            value: function() {
                return this.consent === $504220289e15410d$var$qr.DENIED || this.consent === $504220289e15410d$var$qr.PENDING && this.config.opt_out_capturing_by_default;
            }
        },
        {
            key: "isOptedIn",
            value: function() {
                return !this.isOptedOut();
            }
        },
        {
            key: "optInOut",
            value: function(e) {
                this.storage.set(this.storageKey, e ? 1 : 0, this.config.cookie_expiration, this.config.cross_subdomain_cookie, this.config.secure_cookie);
            }
        },
        {
            key: "reset",
            value: function() {
                this.storage.remove(this.storageKey, this.config.cross_subdomain_cookie);
            }
        },
        {
            key: "storageKey",
            get: function() {
                var e = this.instance.config, t = e.token;
                return (e.opt_out_capturing_cookie_prefix || "__ph_opt_in_out_") + t;
            }
        },
        {
            key: "storedConsent",
            get: function() {
                var e = this.storage.get(this.storageKey);
                return "1" === e ? $504220289e15410d$var$qr.GRANTED : "0" === e ? $504220289e15410d$var$qr.DENIED : $504220289e15410d$var$qr.PENDING;
            }
        },
        {
            key: "storage",
            get: function() {
                if (!this._storage) {
                    var e = this.config.opt_out_capturing_persistence_type;
                    this._storage = "localStorage" === e ? $504220289e15410d$var$ut : $504220289e15410d$var$ot;
                    var t = "localStorage" === e ? $504220289e15410d$var$ot : $504220289e15410d$var$ut;
                    t.get(this.storageKey) && (this._storage.get(this.storageKey) || this.optInOut("1" === t.get(this.storageKey)), t.remove(this.storageKey, this.config.cross_subdomain_cookie));
                }
                return this._storage;
            }
        },
        {
            key: "getDnt",
            value: function() {
                return !!this.config.respect_dnt && !!$504220289e15410d$var$ae([
                    null == $504220289e15410d$var$A ? void 0 : $504220289e15410d$var$A.doNotTrack,
                    null == $504220289e15410d$var$A ? void 0 : $504220289e15410d$var$A.msDoNotTrack,
                    $504220289e15410d$var$U.doNotTrack
                ], function(e) {
                    return $504220289e15410d$var$Y([
                        !0,
                        1,
                        "1",
                        "yes"
                    ], e);
                });
            }
        }
    ]), e;
}(), $504220289e15410d$var$jr = "[Exception Autocapture]", $504220289e15410d$var$Wr = function() {
    function e(t) {
        var n, r = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "originalOnUnhandledRejectionHandler", void 0), $504220289e15410d$var$o(this, "startCapturing", function() {
            if ($504220289e15410d$var$T && r.isEnabled && !r.hasHandlers && !r.isCapturing) {
                var e = $504220289e15410d$var$T.posthogErrorWrappingFunctions.wrapOnError, t = $504220289e15410d$var$T.posthogErrorWrappingFunctions.wrapUnhandledRejection;
                if (e && t) try {
                    r.unwrapOnError = e(r.captureException.bind(r)), r.unwrapUnhandledRejection = t(r.captureException.bind(r));
                } catch (e) {
                    $504220289e15410d$var$W.error($504220289e15410d$var$jr + " failed to start", e), r.stopCapturing();
                }
                else $504220289e15410d$var$W.error($504220289e15410d$var$jr + " failed to load error wrapping functions - cannot start");
            }
        }), this.instance = t, this.remoteEnabled = !(null === (n = this.instance.persistence) || void 0 === n || !n.props[$504220289e15410d$var$ve]), this.startIfEnabled();
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "isEnabled",
            get: function() {
                var e;
                return null !== (e = this.remoteEnabled) && void 0 !== e && e;
            }
        },
        {
            key: "isCapturing",
            get: function() {
                var e;
                return !(null == $504220289e15410d$var$T || null === (e = $504220289e15410d$var$T.onerror) || void 0 === e || !e.__POSTHOG_INSTRUMENTED__);
            }
        },
        {
            key: "hasHandlers",
            get: function() {
                return this.originalOnUnhandledRejectionHandler || this.unwrapOnError;
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                this.isEnabled && !this.isCapturing && ($504220289e15410d$var$W.info($504220289e15410d$var$jr + " enabled, starting..."), this.loadScript(this.startCapturing));
            }
        },
        {
            key: "loadScript",
            value: function(e) {
                this.hasHandlers && e(), this.instance.requestRouter.loadScript("/static/exception-autocapture.js?v=".concat($504220289e15410d$var$f.LIB_VERSION), function(t) {
                    if (t) return $504220289e15410d$var$W.error($504220289e15410d$var$jr + " failed to load script", t);
                    e();
                });
            }
        },
        {
            key: "stopCapturing",
            value: function() {
                var e, t;
                null === (e = this.unwrapOnError) || void 0 === e || e.call(this), null === (t = this.unwrapUnhandledRejection) || void 0 === t || t.call(this);
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = e.autocaptureExceptions;
                this.remoteEnabled = !!t || !1, this.instance.persistence && this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$ve, this.remoteEnabled)), this.startIfEnabled();
            }
        },
        {
            key: "captureException",
            value: function(e) {
                var t = this.instance.requestRouter.endpointFor("ui");
                e.$exception_personURL = "".concat(t, "/project/").concat(this.instance.config.token, "/person/").concat(this.instance.get_distinct_id()), this.instance.exceptions.sendExceptionEvent(e);
            }
        }
    ]), e;
}(), $504220289e15410d$var$Vr = 9e5, $504220289e15410d$var$zr = "[Web Vitals]", $504220289e15410d$var$Gr = function() {
    function e(n) {
        var r, s = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "_enabledServerSide", !1), $504220289e15410d$var$o(this, "_initialized", !1), $504220289e15410d$var$o(this, "buffer", {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }), $504220289e15410d$var$o(this, "_flushToCapture", function() {
            clearTimeout(s._delayedFlushTimer), 0 !== s.buffer.metrics.length && (s.instance.capture("$web_vitals", s.buffer.metrics.reduce(function(e, n) {
                var i;
                return $504220289e15410d$var$t($504220289e15410d$var$t({}, e), {}, ($504220289e15410d$var$o(i = {}, "$web_vitals_".concat(n.name, "_event"), $504220289e15410d$var$t({}, n)), $504220289e15410d$var$o(i, "$web_vitals_".concat(n.name, "_value"), n.value), i));
            }, {})), s.buffer = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }), $504220289e15410d$var$o(this, "_addToBuffer", function(e) {
            var n, i = null === (n = s.instance.sessionManager) || void 0 === n ? void 0 : n.checkAndGetSessionAndWindowId(!0);
            if ($504220289e15410d$var$w(i)) $504220289e15410d$var$W.error($504220289e15410d$var$zr + "Could not read session ID. Dropping metrics!");
            else {
                s.buffer = s.buffer || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = s._currentURL();
                if (!$504220289e15410d$var$w(r)) {
                    if ($504220289e15410d$var$x(null == e ? void 0 : e.name) || $504220289e15410d$var$x(null == e ? void 0 : e.value)) $504220289e15410d$var$W.error($504220289e15410d$var$zr + "Invalid metric received", e);
                    else if (s._maxAllowedValue && e.value >= s._maxAllowedValue) $504220289e15410d$var$W.error($504220289e15410d$var$zr + "Ignoring metric with value >= " + s._maxAllowedValue, e);
                    else s.buffer.url !== r && (s._flushToCapture(), s._delayedFlushTimer = setTimeout(s._flushToCapture, 8e3)), $504220289e15410d$var$w(s.buffer.url) && (s.buffer.url = r), s.buffer.firstMetricTimestamp = $504220289e15410d$var$w(s.buffer.firstMetricTimestamp) ? Date.now() : s.buffer.firstMetricTimestamp, s.buffer.metrics.push($504220289e15410d$var$t($504220289e15410d$var$t({}, e), {}, {
                        $current_url: r,
                        $session_id: i.sessionId,
                        $window_id: i.windowId,
                        timestamp: Date.now()
                    })), s.buffer.metrics.length === s.allowedMetrics.length && s._flushToCapture();
                }
            }
        }), $504220289e15410d$var$o(this, "_startCapturing", function() {
            var e, t, n, i, r = $504220289e15410d$var$U.__PosthogExtensions__;
            if (!$504220289e15410d$var$w(r)) {
                var o = r.postHogWebVitalsCallbacks;
                e = o.onLCP, t = o.onCLS, n = o.onFCP, i = o.onINP;
            }
            e && t && n && i ? (s.allowedMetrics.indexOf("LCP") > -1 && e(s._addToBuffer.bind(s)), s.allowedMetrics.indexOf("CLS") > -1 && t(s._addToBuffer.bind(s)), s.allowedMetrics.indexOf("FCP") > -1 && n(s._addToBuffer.bind(s)), s.allowedMetrics.indexOf("INP") > -1 && i(s._addToBuffer.bind(s)), s._initialized = !0) : $504220289e15410d$var$W.error($504220289e15410d$var$zr + "web vitals callbacks not loaded - not starting");
        }), this.instance = n, this._enabledServerSide = !(null === (r = this.instance.persistence) || void 0 === r || !r.props[$504220289e15410d$var$ge]), this.startIfEnabled();
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "allowedMetrics",
            get: function() {
                var e, t, n = $504220289e15410d$var$b(this.instance.config.capture_performance) ? null === (e = this.instance.config.capture_performance) || void 0 === e ? void 0 : e.web_vitals_allowed_metrics : void 0;
                return $504220289e15410d$var$w(n) ? (null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.props[$504220289e15410d$var$_e]) || [
                    "CLS",
                    "FCP",
                    "INP",
                    "LCP"
                ] : n;
            }
        },
        {
            key: "_maxAllowedValue",
            get: function() {
                var e = $504220289e15410d$var$b(this.instance.config.capture_performance) && $504220289e15410d$var$F(this.instance.config.capture_performance.__web_vitals_max_value) ? this.instance.config.capture_performance.__web_vitals_max_value : $504220289e15410d$var$Vr;
                return 0 < e && e <= 6e4 ? $504220289e15410d$var$Vr : e;
            }
        },
        {
            key: "isEnabled",
            get: function() {
                var e = $504220289e15410d$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals : void 0;
                return $504220289e15410d$var$R(e) ? e : this._enabledServerSide;
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                this.isEnabled && !this._initialized && ($504220289e15410d$var$W.info($504220289e15410d$var$zr + " enabled, starting..."), this.loadScript(this._startCapturing));
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = $504220289e15410d$var$b(e.capturePerformance) && !!e.capturePerformance.web_vitals, n = $504220289e15410d$var$b(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
                this.instance.persistence && (this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$ge, t)), this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$_e, n))), this._enabledServerSide = t, this.startIfEnabled();
            }
        },
        {
            key: "loadScript",
            value: function(e) {
                var t;
                null !== (t = $504220289e15410d$var$U.__PosthogExtensions__) && void 0 !== t && t.postHogWebVitalsCallbacks && e(), this.instance.requestRouter.loadScript("/static/web-vitals.js?v=".concat($504220289e15410d$var$f.LIB_VERSION), function(t) {
                    t ? $504220289e15410d$var$W.error($504220289e15410d$var$zr + " failed to load script", t) : e();
                });
            }
        },
        {
            key: "_currentURL",
            value: function() {
                var e = $504220289e15410d$var$T ? $504220289e15410d$var$T.location.href : void 0;
                return e || $504220289e15410d$var$W.error($504220289e15410d$var$zr + "Could not determine current URL"), e;
            }
        }
    ]), e;
}(), $504220289e15410d$var$Qr = {
    icontains: function(e, t) {
        return !!$504220289e15410d$var$T && t.href.toLowerCase().indexOf(e.toLowerCase()) > -1;
    },
    not_icontains: function(e, t) {
        return !!$504220289e15410d$var$T && -1 === t.href.toLowerCase().indexOf(e.toLowerCase());
    },
    regex: function(e, t) {
        return !!$504220289e15410d$var$T && $504220289e15410d$var$_t(t.href, e);
    },
    not_regex: function(e, t) {
        return !!$504220289e15410d$var$T && !$504220289e15410d$var$_t(t.href, e);
    },
    exact: function(e, t) {
        return t.href === e;
    },
    is_not: function(e, t) {
        return t.href !== e;
    }
}, $504220289e15410d$var$Jr = function() {
    function e(t) {
        var n = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "getWebExperimentsAndEvaluateDisplayLogic", function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            n.getWebExperiments(function(t) {
                e.logInfo("retrieved web experiments from the server"), n._flagToExperiments = new Map, t.forEach(function(t) {
                    if (t.feature_flag_key && n._featureFlags && n._featureFlags[t.feature_flag_key]) {
                        var i;
                        if (n._flagToExperiments) e.logInfo("setting flag key ", t.feature_flag_key, " to web experiment ", t), null === (i = n._flagToExperiments) || void 0 === i || i.set(t.feature_flag_key, t);
                        var r = n._featureFlags[t.feature_flag_key];
                        r && t.variants[r] && e.applyTransforms(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var o = t.variants[s];
                        e.matchesTestVariant(o) && e.applyTransforms(t.name, s, o.transforms);
                    }
                });
            }, t);
        }), this.instance = t;
        this.instance.onFeatureFlags && this.instance.onFeatureFlags(function(e) {
            n.applyFeatureFlagChanges(e);
        }), this._flagToExperiments = new Map;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "applyFeatureFlagChanges",
            value: function(t) {
                var n = this;
                e.logInfo("applying feature flags", t), $504220289e15410d$var$x(this._flagToExperiments) || this.instance.config.disable_web_experiments || t.forEach(function(t) {
                    var i;
                    if (n._flagToExperiments && null !== (i = n._flagToExperiments) && void 0 !== i && i.has(t)) {
                        var r, s = n.instance.getFeatureFlag(t), o = null === (r = n._flagToExperiments) || void 0 === r ? void 0 : r.get(t);
                        s && null != o && o.variants[s] && e.applyTransforms(o.name, s, o.variants[s].transforms);
                    }
                });
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                this._featureFlags = e.featureFlags, this.loadIfEnabled();
            }
        },
        {
            key: "loadIfEnabled",
            value: function() {
                this.instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
            }
        },
        {
            key: "getWebExperiments",
            value: function(e, t) {
                if (this.instance.config.disable_web_experiments) return e([]);
                var n = this.instance.get_property("$web_experiments");
                if (n && !t) return e(n);
                this.instance._send_request({
                    url: this.instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=".concat(this.instance.config.token)),
                    method: "GET",
                    transport: "XHR",
                    callback: function(t) {
                        if (200 !== t.statusCode || !t.json) return e([]);
                        var n = t.json.experiments || [];
                        return e(n);
                    }
                });
            }
        }
    ], [
        {
            key: "matchesTestVariant",
            value: function(t) {
                return !$504220289e15410d$var$x(t.conditions) && e.matchUrlConditions(t) && e.matchUTMConditions(t);
            }
        },
        {
            key: "matchUrlConditions",
            value: function(t) {
                var n;
                if ($504220289e15410d$var$x(t.conditions) || $504220289e15410d$var$x(null === (n = t.conditions) || void 0 === n ? void 0 : n.url)) return !0;
                var i, r, s, o = e.getWindowLocation();
                return !!o && (null === (i = t.conditions) || void 0 === i || !i.url || $504220289e15410d$var$Qr[null !== (r = null === (s = t.conditions) || void 0 === s ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, o));
            }
        },
        {
            key: "getWindowLocation",
            value: function() {
                return null == $504220289e15410d$var$T ? void 0 : $504220289e15410d$var$T.location;
            }
        },
        {
            key: "matchUTMConditions",
            value: function(e) {
                var t;
                if ($504220289e15410d$var$x(e.conditions) || $504220289e15410d$var$x(null === (t = e.conditions) || void 0 === t ? void 0 : t.utm)) return !0;
                var n = $504220289e15410d$var$yn.campaignParams();
                if (n.utm_source) {
                    var i, r, s, o, a, u, l, c, d, h, f, v, p, g, _, m, y = null === (i = e.conditions) || void 0 === i || null === (r = i.utm) || void 0 === r || !r.utm_campaign || (null === (s = e.conditions) || void 0 === s || null === (o = s.utm) || void 0 === o ? void 0 : o.utm_campaign) == n.utm_campaign, b = null === (a = e.conditions) || void 0 === a || null === (u = a.utm) || void 0 === u || !u.utm_source || (null === (l = e.conditions) || void 0 === l || null === (c = l.utm) || void 0 === c ? void 0 : c.utm_source) == n.utm_source, k = null === (d = e.conditions) || void 0 === d || null === (h = d.utm) || void 0 === h || !h.utm_medium || (null === (f = e.conditions) || void 0 === f || null === (v = f.utm) || void 0 === v ? void 0 : v.utm_medium) == n.utm_medium, w = null === (p = e.conditions) || void 0 === p || null === (g = p.utm) || void 0 === g || !g.utm_term || (null === (_ = e.conditions) || void 0 === _ || null === (m = _.utm) || void 0 === m ? void 0 : m.utm_term) == n.utm_term;
                    return y && k && w && b;
                }
                return !1;
            }
        },
        {
            key: "logInfo",
            value: function(e) {
                for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                $504220289e15410d$var$W.info("[WebExperiments] ".concat(e), n);
            }
        },
        {
            key: "applyTransforms",
            value: function(t, n, i) {
                i.forEach(function(i) {
                    if (i.selector) {
                        var r;
                        e.logInfo("applying transform of variant ".concat(n, " for experiment ").concat(t, " "), i);
                        var s = null === (r = document) || void 0 === r ? void 0 : r.querySelectorAll(i.selector);
                        null == s || s.forEach(function(e) {
                            var t = e;
                            i.attributes && i.attributes.forEach(function(e) {
                                switch(e.name){
                                    case "text":
                                        t.innerText = e.value;
                                        break;
                                    case "html":
                                        t.innerHTML = e.value;
                                        break;
                                    case "cssClass":
                                        t.className = e.value;
                                        break;
                                    default:
                                        t.setAttribute(e.name, e.value);
                                }
                            }), i.text && (t.innerText = i.text), i.html && (t.innerHTML = i.html), i.className && (t.className = i.className);
                        });
                    }
                });
            }
        }
    ]), e;
}(), $504220289e15410d$var$Yr = "/e/", $504220289e15410d$var$Xr = function() {
    function e(t) {
        var n;
        $504220289e15410d$var$i(this, e), this.instance = t, this._endpointSuffix = (null === (n = this.instance.persistence) || void 0 === n ? void 0 : n.props[$504220289e15410d$var$pe]) || $504220289e15410d$var$Yr;
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "endpoint",
            get: function() {
                return this.instance.requestRouter.endpointFor("api", this._endpointSuffix);
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = e.autocaptureExceptions;
                this._endpointSuffix = $504220289e15410d$var$b(t) && t.endpoint || $504220289e15410d$var$Yr, this.instance.persistence && this.instance.persistence.register($504220289e15410d$var$o({}, $504220289e15410d$var$pe, this._endpointSuffix));
            }
        },
        {
            key: "sendExceptionEvent",
            value: function(e) {
                this.instance.capture("$exception", e, {
                    _noTruncate: !0,
                    _batchKey: "exceptionEvent",
                    _url: this.endpoint
                });
            }
        }
    ]), e;
}(), $504220289e15410d$var$Kr = {}, $504220289e15410d$var$Zr = function() {}, $504220289e15410d$var$es = "posthog", $504220289e15410d$var$ts = !$504220289e15410d$var$tr && -1 === (null == $504220289e15410d$var$H ? void 0 : $504220289e15410d$var$H.indexOf("MSIE")) && -1 === (null == $504220289e15410d$var$H ? void 0 : $504220289e15410d$var$H.indexOf("Mozilla")), $504220289e15410d$var$ns = function() {
    var e, t, n;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: (t = null == $504220289e15410d$var$L ? void 0 : $504220289e15410d$var$L.location, n = null == t ? void 0 : t.hostname, !!$504220289e15410d$var$S(n) && "herokuapp.com" !== n.split(".").slice(-2).join(".")),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $504220289e15410d$var$Zr,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: "if_capture_pageview",
        debug: $504220289e15410d$var$D && $504220289e15410d$var$S(null == $504220289e15410d$var$D ? void 0 : $504220289e15410d$var$D.search) && -1 !== $504220289e15410d$var$D.search.indexOf("__posthog_debug=true") || !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $504220289e15410d$var$T || null === (e = $504220289e15410d$var$T.location) || void 0 === e ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        on_request_error: function(e) {
            var t = "Bad HTTP status: " + e.statusCode + " " + e.text;
            $504220289e15410d$var$W.error(t);
        },
        get_device_id: function(e) {
            return e;
        },
        _onCapture: $504220289e15410d$var$Zr,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "always",
        __add_tracing_headers: !1
    };
}, $504220289e15410d$var$is = function(e) {
    var t = {};
    $504220289e15410d$var$w(e.process_person) || (t.person_profiles = e.process_person), $504220289e15410d$var$w(e.xhr_headers) || (t.request_headers = e.xhr_headers), $504220289e15410d$var$w(e.cookie_name) || (t.persistence_name = e.cookie_name), $504220289e15410d$var$w(e.disable_cookie) || (t.disable_persistence = e.disable_cookie);
    var n = $504220289e15410d$var$J({}, t, e);
    return $504220289e15410d$var$m(e.property_blacklist) && ($504220289e15410d$var$w(e.property_denylist) ? n.property_denylist = e.property_blacklist : $504220289e15410d$var$m(e.property_denylist) ? n.property_denylist = [].concat($504220289e15410d$var$l(e.property_blacklist), $504220289e15410d$var$l(e.property_denylist)) : $504220289e15410d$var$W.error("Invalid value for property_denylist config: " + e.property_denylist)), n;
}, $504220289e15410d$var$rs = function() {
    function e() {
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "__forceAllowLocalhost", !1);
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "_forceAllowLocalhost",
            get: function() {
                return this.__forceAllowLocalhost;
            },
            set: function(e) {
                $504220289e15410d$var$W.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
            }
        }
    ]), e;
}(), $504220289e15410d$export$a9d6b9cbf49b8241 = function() {
    function e() {
        var t = this;
        $504220289e15410d$var$i(this, e), $504220289e15410d$var$o(this, "webPerformance", new $504220289e15410d$var$rs), $504220289e15410d$var$o(this, "version", $504220289e15410d$var$f.LIB_VERSION), $504220289e15410d$var$o(this, "_internalEventEmitter", new $504220289e15410d$var$wr), this.config = $504220289e15410d$var$ns(), this.decideEndpointWasHit = !1, this.SentryIntegration = $504220289e15410d$var$pr, this.sentryIntegration = function(e) {
            return function(e, t) {
                var n = $504220289e15410d$var$vr(e, t);
                return {
                    name: $504220289e15410d$var$fr,
                    processEvent: function(e) {
                        return n(e);
                    }
                };
            }(t, e);
        }, this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this._initialPageviewCaptured = !1, this.featureFlags = new $504220289e15410d$var$ze(this), this.toolbar = new $504220289e15410d$var$mi(this), this.scrollManager = new $504220289e15410d$var$Lr(this), this.pageViewManager = new $504220289e15410d$var$br(this), this.surveys = new $504220289e15410d$var$Fr(this), this.experiments = new $504220289e15410d$var$Jr(this), this.exceptions = new $504220289e15410d$var$Xr(this), this.rateLimiter = new $504220289e15410d$var$Rr(this), this.requestRouter = new $504220289e15410d$var$hr(this), this.consent = new $504220289e15410d$var$Ur(this), this.people = {
            set: function(e, n, i) {
                var r = $504220289e15410d$var$S(e) ? $504220289e15410d$var$o({}, e, n) : e;
                t.setPersonProperties(r), null == i || i({});
            },
            set_once: function(e, n, i) {
                var r = $504220289e15410d$var$S(e) ? $504220289e15410d$var$o({}, e, n) : e;
                t.setPersonProperties(void 0, r), null == i || i({});
            }
        }, this.on("eventCaptured", function(e) {
            return $504220289e15410d$var$W.info("send", e);
        });
    }
    return $504220289e15410d$var$s(e, [
        {
            key: "init",
            value: function(t, n, i) {
                if (i && i !== $504220289e15410d$var$es) {
                    var r, s = null !== (r = $504220289e15410d$var$Kr[i]) && void 0 !== r ? r : new e;
                    return s._init(t, n, i), $504220289e15410d$var$Kr[i] = s, $504220289e15410d$var$Kr[$504220289e15410d$var$es][i] = s, s;
                }
                return this._init(t, n, i);
            }
        },
        {
            key: "_init",
            value: function(e) {
                var n, i, r = this, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = arguments.length > 2 ? arguments[2] : void 0;
                if ($504220289e15410d$var$w(e) || $504220289e15410d$var$E(e)) return $504220289e15410d$var$W.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
                if (this.__loaded) return $504220289e15410d$var$W.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
                this.__loaded = !0, this.config = {}, this._triggered_notifs = [], this.set_config($504220289e15410d$var$J({}, $504220289e15410d$var$ns(), $504220289e15410d$var$is(s), {
                    name: o,
                    token: e
                })), this.config.on_xhr_error && $504220289e15410d$var$W.error("[posthog] on_xhr_error is deprecated. Use on_request_error instead"), this.compression = s.disable_compression ? void 0 : $504220289e15410d$export$6a00d17b5aff0af.GZipJS, this.persistence = new $504220289e15410d$var$kn(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $504220289e15410d$var$kn($504220289e15410d$var$t($504220289e15410d$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                }));
                var a = $504220289e15410d$var$t({}, this.persistence.props), u = $504220289e15410d$var$t({}, this.sessionPersistence.props);
                if (this._requestQueue = new $504220289e15410d$var$yi(function(e) {
                    return r._send_retriable_request(e);
                }), this._retryQueue = new $504220289e15410d$var$ur(this), this.__request_queue = [], this.sessionManager = new $504220289e15410d$var$cr(this.config, this.persistence), this.sessionPropsManager = new $504220289e15410d$var$Tr(this.sessionManager, this.persistence), new $504220289e15410d$var$Hr(this).startIfEnabledOrStop(), this.sessionRecording = new $504220289e15410d$var$vi(this), this.sessionRecording.startIfEnabledOrStop(), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $504220289e15410d$var$Br(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $504220289e15410d$var$Ar(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $504220289e15410d$var$Gr(this), this.exceptionObserver = new $504220289e15410d$var$Wr(this), this.exceptionObserver.startIfEnabled(), $504220289e15410d$var$f.DEBUG = $504220289e15410d$var$f.DEBUG || this.config.debug, $504220289e15410d$var$f.DEBUG && $504220289e15410d$var$W.info("Starting in debug mode", {
                    this: this,
                    config: s,
                    thisC: $504220289e15410d$var$t({}, this.config),
                    p: a,
                    s: u
                }), this._sync_opt_out_with_persistence(), void 0 !== (null === (n = s.bootstrap) || void 0 === n ? void 0 : n.distinctID)) {
                    var l, c, d = this.config.get_device_id($504220289e15410d$var$Ze()), h = null !== (l = s.bootstrap) && void 0 !== l && l.isIdentifiedID ? d : s.bootstrap.distinctID;
                    this.persistence.set_property($504220289e15410d$var$$e, null !== (c = s.bootstrap) && void 0 !== c && c.isIdentifiedID ? "identified" : "anonymous"), this.register({
                        distinct_id: s.bootstrap.distinctID,
                        $device_id: h
                    });
                }
                if (this._hasBootstrappedFeatureFlags()) {
                    var v, p, g = Object.keys((null === (v = s.bootstrap) || void 0 === v ? void 0 : v.featureFlags) || {}).filter(function(e) {
                        var t, n;
                        return !(null === (t = s.bootstrap) || void 0 === t || null === (n = t.featureFlags) || void 0 === n || !n[e]);
                    }).reduce(function(e, t) {
                        var n, i;
                        return e[t] = (null === (n = s.bootstrap) || void 0 === n || null === (i = n.featureFlags) || void 0 === i ? void 0 : i[t]) || !1, e;
                    }, {}), _ = Object.keys((null === (p = s.bootstrap) || void 0 === p ? void 0 : p.featureFlagPayloads) || {}).filter(function(e) {
                        return g[e];
                    }).reduce(function(e, t) {
                        var n, i, r, o;
                        null !== (n = s.bootstrap) && void 0 !== n && null !== (i = n.featureFlagPayloads) && void 0 !== i && i[t] && (e[t] = null === (r = s.bootstrap) || void 0 === r || null === (o = r.featureFlagPayloads) || void 0 === o ? void 0 : o[t]);
                        return e;
                    }, {});
                    this.featureFlags.receivedFeatureFlags({
                        featureFlags: g,
                        featureFlagPayloads: _
                    });
                }
                if (!this.get_distinct_id()) {
                    var m = this.config.get_device_id($504220289e15410d$var$Ze());
                    this.register_once({
                        distinct_id: m,
                        $device_id: m
                    }, ""), this.persistence.set_property($504220289e15410d$var$$e, "anonymous");
                }
                return null == $504220289e15410d$var$T || null === (i = $504220289e15410d$var$T.addEventListener) || void 0 === i || i.call($504220289e15410d$var$T, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), this.toolbar.maybeLoadToolbar(), s.segment ? $504220289e15410d$var$gr(this, function() {
                    return r._loaded();
                }) : this._loaded(), $504220289e15410d$var$y(this.config._onCapture) && this.on("eventCaptured", function(e) {
                    return r.config._onCapture(e.event, e);
                }), this;
            }
        },
        {
            key: "_afterDecideResponse",
            value: function(e) {
                var t, n, i, r, s, o, a, u, l;
                this.compression = void 0, e.supportedCompression && !this.config.disable_compression && (this.compression = $504220289e15410d$var$Y(e.supportedCompression, $504220289e15410d$export$6a00d17b5aff0af.GZipJS) ? $504220289e15410d$export$6a00d17b5aff0af.GZipJS : $504220289e15410d$var$Y(e.supportedCompression, $504220289e15410d$export$6a00d17b5aff0af.Base64) ? $504220289e15410d$export$6a00d17b5aff0af.Base64 : void 0), null !== (t = e.analytics) && void 0 !== t && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), null === (n = this.sessionRecording) || void 0 === n || n.afterDecideResponse(e), null === (i = this.autocapture) || void 0 === i || i.afterDecideResponse(e), null === (r = this.heatmaps) || void 0 === r || r.afterDecideResponse(e), null === (s = this.experiments) || void 0 === s || s.afterDecideResponse(e), null === (o = this.surveys) || void 0 === o || o.afterDecideResponse(e), null === (a = this.webVitalsAutocapture) || void 0 === a || a.afterDecideResponse(e), null === (u = this.exceptions) || void 0 === u || u.afterDecideResponse(e), null === (l = this.exceptionObserver) || void 0 === l || l.afterDecideResponse(e);
            }
        },
        {
            key: "_loaded",
            value: function() {
                var e = this, t = this.config.advanced_disable_decide;
                t || this.featureFlags.setReloadingPaused(!0);
                try {
                    this.config.loaded(this);
                } catch (e) {
                    $504220289e15410d$var$W.critical("`loaded` function failed", e);
                }
                this._start_queue_if_opted_in(), this.config.capture_pageview && setTimeout(function() {
                    e.consent.isOptedIn() && e._captureInitialPageview();
                }, 1), t || (new $504220289e15410d$var$pi(this).call(), this.featureFlags.resetRequestQueue());
            }
        },
        {
            key: "_start_queue_if_opted_in",
            value: function() {
                var e;
                this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.enable());
            }
        },
        {
            key: "_dom_loaded",
            value: function() {
                var e = this;
                this.has_opted_out_capturing() || $504220289e15410d$var$G(this.__request_queue, function(t) {
                    return e._send_retriable_request(t);
                }), this.__request_queue = [], this._start_queue_if_opted_in();
            }
        },
        {
            key: "_handle_unload",
            value: function() {
                var e, t;
                this.config.request_batching ? (this._shouldCapturePageleave() && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this._shouldCapturePageleave() && this.capture("$pageleave", null, {
                    transport: "sendBeacon"
                });
            }
        },
        {
            key: "_send_request",
            value: function(e) {
                var n = this;
                this.__loaded && ($504220289e15410d$var$ts ? this.__request_queue.push(e) : this.rateLimiter.isServerRateLimited(e.batchKey) || (e.transport = e.transport || this.config.api_transport, e.url = $504220289e15410d$var$ir(e.url, {
                    ip: this.config.ip ? 1 : 0
                }), e.headers = $504220289e15410d$var$t({}, this.config.request_headers), e.compression = "best-available" === e.compression ? this.compression : e.compression, function(e) {
                    var n, i, r, s = $504220289e15410d$var$t({}, e);
                    s.timeout = s.timeout || 6e4, s.url = $504220289e15410d$var$ir(s.url, {
                        _: (new Date).getTime().toString(),
                        ver: $504220289e15410d$var$f.LIB_VERSION,
                        compression: s.compression
                    });
                    var o = null !== (n = s.transport) && void 0 !== n ? n : "XHR", a = null !== (i = null === (r = $504220289e15410d$var$ae($504220289e15410d$var$sr, function(e) {
                        return e.transport === o;
                    })) || void 0 === r ? void 0 : r.method) && void 0 !== i ? i : $504220289e15410d$var$sr[0].method;
                    if (!a) throw new Error("No available transport method");
                    a(s);
                }($504220289e15410d$var$t($504220289e15410d$var$t({}, e), {}, {
                    callback: function(t) {
                        var i, r, s;
                        (n.rateLimiter.checkForLimiting(t), t.statusCode >= 400) && (null === (r = (s = n.config).on_request_error) || void 0 === r || r.call(s, t));
                        null === (i = e.callback) || void 0 === i || i.call(e, t);
                    }
                }))));
            }
        },
        {
            key: "_send_retriable_request",
            value: function(e) {
                this._retryQueue ? this._retryQueue.retriableRequest(e) : this._send_request(e);
            }
        },
        {
            key: "_execute_array",
            value: function(e) {
                var t, n = this, i = [], r = [], s = [];
                $504220289e15410d$var$G(e, function(e) {
                    e && (t = e[0], $504220289e15410d$var$m(t) ? s.push(e) : $504220289e15410d$var$y(e) ? e.call(n) : $504220289e15410d$var$m(e) && "alias" === t ? i.push(e) : $504220289e15410d$var$m(e) && -1 !== t.indexOf("capture") && $504220289e15410d$var$y(n[t]) ? s.push(e) : r.push(e));
                });
                var o = function(e, t) {
                    $504220289e15410d$var$G(e, function(e) {
                        if ($504220289e15410d$var$m(e[0])) {
                            var n = t;
                            $504220289e15410d$var$Q(e, function(e) {
                                n = n[e[0]].apply(n, e.slice(1));
                            });
                        } else this[e[0]].apply(this, e.slice(1));
                    }, t);
                };
                o(i, this), o(r, this), o(s, this);
            }
        },
        {
            key: "_hasBootstrappedFeatureFlags",
            value: function() {
                var e, t;
                return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
            }
        },
        {
            key: "push",
            value: function(e) {
                this._execute_array([
                    e
                ]);
            }
        },
        {
            key: "capture",
            value: function(e, n, i) {
                var r;
                if (this.__loaded && this.persistence && this.sessionPersistence && this._requestQueue) {
                    if (!this.consent.isOptedOut()) {
                        if (!$504220289e15410d$var$w(e) && $504220289e15410d$var$S(e)) {
                            if (this.config.opt_out_useragent_filter || !this._is_bot()) {
                                var s = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                                if (null == s || !s.isRateLimited) {
                                    this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.store_google || this.config.save_referrer) && this.persistence.set_initial_person_info();
                                    var o = new Date, a = (null == i ? void 0 : i.timestamp) || o, u = {
                                        uuid: $504220289e15410d$var$Ze(),
                                        event: e,
                                        properties: this._calculate_event_properties(e, n || {}, a)
                                    };
                                    s && (u.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens), (null == i ? void 0 : i.$set) && (u.$set = null == i ? void 0 : i.$set);
                                    var l = this._calculate_set_once_properties(null == i ? void 0 : i.$set_once);
                                    l && (u.$set_once = l), (u = $504220289e15410d$var$ie(u, null != i && i._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, $504220289e15410d$var$w(null == i ? void 0 : i.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o);
                                    var c = $504220289e15410d$var$t($504220289e15410d$var$t({}, u.properties.$set), u.$set);
                                    $504220289e15410d$var$k(c) || this.setPersonPropertiesForFlags(c), this._internalEventEmitter.emit("eventCaptured", u);
                                    var d = {
                                        method: "POST",
                                        url: null !== (r = null == i ? void 0 : i._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                        data: u,
                                        compression: "best-available",
                                        batchKey: null == i ? void 0 : i._batchKey
                                    };
                                    return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this._send_retriable_request(d) : this._requestQueue.enqueue(d), u;
                                }
                                $504220289e15410d$var$W.critical("This capture call is ignored due to client rate limiting.");
                            }
                        } else $504220289e15410d$var$W.error("No event name provided to posthog.capture");
                    }
                } else $504220289e15410d$var$W.uninitializedWarning("posthog.capture");
            }
        },
        {
            key: "_addCaptureHook",
            value: function(e) {
                return this.on("eventCaptured", function(t) {
                    return e(t.event, t);
                });
            }
        },
        {
            key: "_calculate_event_properties",
            value: function(e, n, i) {
                if (i = i || new Date, !this.persistence || !this.sessionPersistence) return n;
                var r = this.persistence.remove_event_timer(e), s = $504220289e15410d$var$t({}, n);
                if (s.token = this.config.token, "$snapshot" === e) {
                    var o = $504220289e15410d$var$t($504220289e15410d$var$t({}, this.persistence.properties()), this.sessionPersistence.properties());
                    return s.distinct_id = o.distinct_id, (!$504220289e15410d$var$S(s.distinct_id) && !$504220289e15410d$var$F(s.distinct_id) || $504220289e15410d$var$E(s.distinct_id)) && $504220289e15410d$var$W.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), s;
                }
                var a = $504220289e15410d$var$yn.properties();
                if (this.sessionManager) {
                    var u = this.sessionManager.checkAndGetSessionAndWindowId(), l = u.sessionId, c = u.windowId;
                    s.$session_id = l, s.$window_id = c;
                }
                if (this.requestRouter.region === $504220289e15410d$var$ar.CUSTOM && (s.$lib_custom_api_host = this.config.api_host), this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
                    var d = this.sessionPropsManager.getSessionProps();
                    s = $504220289e15410d$var$J(s, d);
                }
                if (!this.config.disable_scroll_properties) {
                    var h = {};
                    "$pageview" === e ? h = this.pageViewManager.doPageView(i) : "$pageleave" === e && (h = this.pageViewManager.doPageLeave(i)), s = $504220289e15410d$var$J(s, h);
                }
                if ("$pageview" === e && $504220289e15410d$var$L && (s.title = $504220289e15410d$var$L.title), !$504220289e15410d$var$w(r)) {
                    var f = i.getTime() - r;
                    s.$duration = parseFloat((f / 1e3).toFixed(3));
                }
                $504220289e15410d$var$H && this.config.opt_out_useragent_filter && (s.$browser_type = this._is_bot() ? "bot" : "browser"), (s = $504220289e15410d$var$J({}, a, this.persistence.properties(), this.sessionPersistence.properties(), s)).$is_identified = this._isIdentified(), $504220289e15410d$var$m(this.config.property_denylist) ? $504220289e15410d$var$Q(this.config.property_denylist, function(e) {
                    delete s[e];
                }) : $504220289e15410d$var$W.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
                var v = this.config.sanitize_properties;
                return v && (s = v(s, e)), s.$process_person_profile = this._hasPersonProcessing(), s;
            }
        },
        {
            key: "_calculate_set_once_properties",
            value: function(e) {
                if (!this.persistence || !this._hasPersonProcessing()) return e;
                var t = $504220289e15410d$var$J({}, this.persistence.get_initial_props(), e || {});
                return $504220289e15410d$var$k(t) ? void 0 : t;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n;
                null === (n = this.persistence) || void 0 === n || n.register(e, t);
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var i;
                null === (i = this.persistence) || void 0 === i || i.register_once(e, t, n);
            }
        },
        {
            key: "register_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
            }
        },
        {
            key: "unregister",
            value: function(e) {
                var t;
                null === (t = this.persistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "unregister_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "_register_single",
            value: function(e, t) {
                this.register($504220289e15410d$var$o({}, e, t));
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e, t) {
                return this.featureFlags.getFeatureFlag(e, t);
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                var t = this.featureFlags.getFeatureFlagPayload(e);
                try {
                    return JSON.parse(t);
                } catch (e) {
                    return t;
                }
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e, t) {
                return this.featureFlags.isFeatureEnabled(e, t);
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.featureFlags.reloadFeatureFlags();
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, t) {
                this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.featureFlags.getEarlyAccessFeatures(e, t);
            }
        },
        {
            key: "on",
            value: function(e, t) {
                return this._internalEventEmitter.on(e, t);
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                return this.featureFlags.onFeatureFlags(e);
            }
        },
        {
            key: "onSessionId",
            value: function(e) {
                var t, n;
                return null !== (t = null === (n = this.sessionManager) || void 0 === n ? void 0 : n.onSessionId(e)) && void 0 !== t ? t : function() {};
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getSurveys(e, t);
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getActiveMatchingSurveys(e, t);
            }
        },
        {
            key: "renderSurvey",
            value: function(e, t) {
                this.surveys.renderSurvey(e, t);
            }
        },
        {
            key: "canRenderSurvey",
            value: function(e) {
                this.surveys.canRenderSurvey(e);
            }
        },
        {
            key: "getNextSurveyStep",
            value: function(e, t, n) {
                return this.surveys.getNextSurveyStep(e, t, n);
            }
        },
        {
            key: "identify",
            value: function(e, t, n) {
                if (!this.__loaded || !this.persistence) return $504220289e15410d$var$W.uninitializedWarning("posthog.identify");
                if ($504220289e15410d$var$F(e) && (e = e.toString(), $504220289e15410d$var$W.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), e) {
                    if ([
                        "distinct_id",
                        "distinctid"
                    ].includes(e.toLowerCase())) $504220289e15410d$var$W.critical('The string "'.concat(e, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
                    else if (this._requirePersonProcessing("posthog.identify")) {
                        var i = this.get_distinct_id();
                        if (this.register({
                            $user_id: e
                        }), !this.get_property("$device_id")) {
                            var r = i;
                            this.register_once({
                                $had_persisted_distinct_id: !0,
                                $device_id: r
                            }, "");
                        }
                        e !== i && e !== this.get_property($504220289e15410d$var$ce) && (this.unregister($504220289e15410d$var$ce), this.register({
                            distinct_id: e
                        }));
                        var s = "anonymous" === (this.persistence.get_property($504220289e15410d$var$$e) || "anonymous");
                        e !== i && s ? (this.persistence.set_property($504220289e15410d$var$$e, "identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
                            distinct_id: e,
                            $anon_distinct_id: i
                        }, {
                            $set: t || {},
                            $set_once: n || {}
                        }), this.featureFlags.setAnonymousDistinctId(i)) : (t || n) && this.setPersonProperties(t, n), e !== i && (this.reloadFeatureFlags(), this.unregister($504220289e15410d$var$Oe));
                    }
                } else $504220289e15410d$var$W.error("Unique user id has not been set in posthog.identify");
            }
        },
        {
            key: "setPersonProperties",
            value: function(e, t) {
                (e || t) && this._requirePersonProcessing("posthog.setPersonProperties") && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
                    $set: e || {},
                    $set_once: t || {}
                }));
            }
        },
        {
            key: "group",
            value: function(e, n, i) {
                if (e && n) {
                    if (this._requirePersonProcessing("posthog.group")) {
                        var r = this.getGroups();
                        r[e] !== n && this.resetGroupPropertiesForFlags(e), this.register({
                            $groups: $504220289e15410d$var$t($504220289e15410d$var$t({}, r), {}, $504220289e15410d$var$o({}, e, n))
                        }), i && (this.capture("$groupidentify", {
                            $group_type: e,
                            $group_key: n,
                            $group_set: i
                        }), this.setGroupPropertiesForFlags($504220289e15410d$var$o({}, e, i))), r[e] === n || i || this.reloadFeatureFlags();
                    }
                } else $504220289e15410d$var$W.error("posthog.group requires a group type and group key");
            }
        },
        {
            key: "resetGroups",
            value: function() {
                this.register({
                    $groups: {}
                }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this._requirePersonProcessing("posthog.setPersonPropertiesForFlags") && this.featureFlags.setPersonPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.featureFlags.resetPersonPropertiesForFlags();
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this._requirePersonProcessing("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                this.featureFlags.resetGroupPropertiesForFlags(e);
            }
        },
        {
            key: "reset",
            value: function(e) {
                var t, n, i, r;
                if ($504220289e15410d$var$W.info("reset"), !this.__loaded) return $504220289e15410d$var$W.uninitializedWarning("posthog.reset");
                var s = this.get_property("$device_id");
                this.consent.reset(), null === (t = this.persistence) || void 0 === t || t.clear(), null === (n = this.sessionPersistence) || void 0 === n || n.clear(), null === (i = this.persistence) || void 0 === i || i.set_property($504220289e15410d$var$$e, "anonymous"), null === (r = this.sessionManager) || void 0 === r || r.resetSessionId();
                var o = this.config.get_device_id($504220289e15410d$var$Ze());
                this.register_once({
                    distinct_id: o,
                    $device_id: e ? o : s
                }, "");
            }
        },
        {
            key: "get_distinct_id",
            value: function() {
                return this.get_property("distinct_id");
            }
        },
        {
            key: "getGroups",
            value: function() {
                return this.get_property("$groups") || {};
            }
        },
        {
            key: "get_session_id",
            value: function() {
                var e, t;
                return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
            }
        },
        {
            key: "get_session_replay_url",
            value: function(e) {
                if (!this.sessionManager) return "";
                var t = this.sessionManager.checkAndGetSessionAndWindowId(!0), n = t.sessionId, i = t.sessionStartTimestamp, r = this.requestRouter.endpointFor("ui", "/project/".concat(this.config.token, "/replay/").concat(n));
                if (null != e && e.withTimestamp && i) {
                    var s, o = null !== (s = e.timestampLookBack) && void 0 !== s ? s : 10;
                    if (!i) return r;
                    var a = Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - o, 0);
                    r += "?t=".concat(a);
                }
                return r;
            }
        },
        {
            key: "alias",
            value: function(e, t) {
                return e === this.get_property($504220289e15410d$var$le) ? ($504220289e15410d$var$W.critical("Attempting to create alias for existing People user - aborting."), -2) : this._requirePersonProcessing("posthog.alias") ? ($504220289e15410d$var$w(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single($504220289e15410d$var$ce, e), this.capture("$create_alias", {
                    alias: e,
                    distinct_id: t
                })) : ($504220289e15410d$var$W.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1)) : void 0;
            }
        },
        {
            key: "set_config",
            value: function(e) {
                var n, i, r, s, o = $504220289e15410d$var$t({}, this.config);
                $504220289e15410d$var$b(e) && ($504220289e15410d$var$J(this.config, $504220289e15410d$var$is(e)), null === (n = this.persistence) || void 0 === n || n.update_config(this.config, o), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $504220289e15410d$var$kn($504220289e15410d$var$t($504220289e15410d$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), $504220289e15410d$var$ut.is_supported() && "true" === $504220289e15410d$var$ut.get("ph_debug") && (this.config.debug = !0), this.config.debug && ($504220289e15410d$var$f.DEBUG = !0, $504220289e15410d$var$W.info("set_config", {
                    config: e,
                    oldConfig: o,
                    newConfig: $504220289e15410d$var$t({}, this.config)
                })), null === (i = this.sessionRecording) || void 0 === i || i.startIfEnabledOrStop(), null === (r = this.autocapture) || void 0 === r || r.startIfEnabled(), null === (s = this.heatmaps) || void 0 === s || s.startIfEnabled(), this.surveys.loadIfEnabled(), this._sync_opt_out_with_persistence());
            }
        },
        {
            key: "startSessionRecording",
            value: function(e) {
                var t, n = $504220289e15410d$var$R(e) && e;
                if (n || null != e && e.sampling) {
                    var i, r, s = null === (i = this.sessionManager) || void 0 === i ? void 0 : i.checkAndGetSessionAndWindowId();
                    null === (r = this.persistence) || void 0 === r || r.register($504220289e15410d$var$o({}, $504220289e15410d$var$Ie, !0)), $504220289e15410d$var$W.info("Session recording started with sampling override for session: ", null == s ? void 0 : s.sessionId);
                }
                (n || null != e && e.linked_flag) && (null === (t = this.sessionRecording) || void 0 === t || t.overrideLinkedFlag(), $504220289e15410d$var$W.info("Session recording started with linked_flags override"));
                this.set_config({
                    disable_session_recording: !1
                });
            }
        },
        {
            key: "stopSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !0
                });
            }
        },
        {
            key: "sessionRecordingStarted",
            value: function() {
                var e;
                return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
            }
        },
        {
            key: "captureException",
            value: function(e, n) {
                var i = $504220289e15410d$var$y($504220289e15410d$var$U.parseErrorAsProperties) ? $504220289e15410d$var$U.parseErrorAsProperties([
                    e.message,
                    void 0,
                    void 0,
                    void 0,
                    e
                ]) : $504220289e15410d$var$t({
                    $exception_type: e.name,
                    $exception_message: e.message,
                    $exception_level: "error"
                }, n);
                this.exceptions.sendExceptionEvent(i);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                return this.toolbar.loadToolbar(e);
            }
        },
        {
            key: "get_property",
            value: function(e) {
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "getSessionProperty",
            value: function(e) {
                var t;
                return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "toString",
            value: function() {
                var e, t = null !== (e = this.config.name) && void 0 !== e ? e : $504220289e15410d$var$es;
                return t !== $504220289e15410d$var$es && (t = $504220289e15410d$var$es + "." + t), t;
            }
        },
        {
            key: "_isIdentified",
            value: function() {
                var e, t;
                return "identified" === (null === (e = this.persistence) || void 0 === e ? void 0 : e.get_property($504220289e15410d$var$$e)) || "identified" === (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.get_property($504220289e15410d$var$$e));
            }
        },
        {
            key: "_hasPersonProcessing",
            value: function() {
                var e, t, n, i;
                return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $504220289e15410d$var$k(this.getGroups()) && (null === (e = this.persistence) || void 0 === e || null === (t = e.props) || void 0 === t || !t[$504220289e15410d$var$ce]) && (null === (n = this.persistence) || void 0 === n || null === (i = n.props) || void 0 === i || !i[$504220289e15410d$var$qe]));
            }
        },
        {
            key: "_shouldCapturePageleave",
            value: function() {
                return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && this.config.capture_pageview;
            }
        },
        {
            key: "createPersonProfile",
            value: function() {
                this._hasPersonProcessing() || this._requirePersonProcessing("posthog.createPersonProfile") && this.setPersonProperties({}, {});
            }
        },
        {
            key: "_requirePersonProcessing",
            value: function(e) {
                return "never" === this.config.person_profiles ? ($504220289e15410d$var$W.error(e + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._register_single($504220289e15410d$var$qe, !0), !0);
            }
        },
        {
            key: "_sync_opt_out_with_persistence",
            value: function() {
                var e, t, n, i, r = this.consent.isOptedOut(), s = this.config.opt_out_persistence_by_default, o = this.config.disable_persistence || r && !!s;
                (null === (e = this.persistence) || void 0 === e ? void 0 : e.disabled) !== o && (null === (n = this.persistence) || void 0 === n || n.set_disabled(o));
                (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.disabled) !== o && (null === (i = this.sessionPersistence) || void 0 === i || i.set_disabled(o));
            }
        },
        {
            key: "opt_in_capturing",
            value: function(e) {
                var t;
                (this.consent.optInOut(!0), this._sync_opt_out_with_persistence(), $504220289e15410d$var$w(null == e ? void 0 : e.captureEventName) || null != e && e.captureEventName) && this.capture(null !== (t = null == e ? void 0 : e.captureEventName) && void 0 !== t ? t : "$opt_in", null == e ? void 0 : e.captureProperties, {
                    send_instantly: !0
                });
                this.config.capture_pageview && this._captureInitialPageview();
            }
        },
        {
            key: "opt_out_capturing",
            value: function() {
                this.consent.optInOut(!1), this._sync_opt_out_with_persistence();
            }
        },
        {
            key: "has_opted_in_capturing",
            value: function() {
                return this.consent.isOptedIn();
            }
        },
        {
            key: "has_opted_out_capturing",
            value: function() {
                return this.consent.isOptedOut();
            }
        },
        {
            key: "clear_opt_in_out_capturing",
            value: function() {
                this.consent.reset(), this._sync_opt_out_with_persistence();
            }
        },
        {
            key: "_is_bot",
            value: function() {
                return $504220289e15410d$var$A ? function(e, t) {
                    if (!e) return !1;
                    var n = e.userAgent;
                    if (n && $504220289e15410d$var$Or(n, t)) return !0;
                    try {
                        var i = null == e ? void 0 : e.userAgentData;
                        if (null != i && i.brands && i.brands.some(function(e) {
                            return $504220289e15410d$var$Or(null == e ? void 0 : e.brand, t);
                        })) return !0;
                    } catch (e) {}
                    return !!e.webdriver;
                }($504220289e15410d$var$A, this.config.custom_blocked_useragents) : void 0;
            }
        },
        {
            key: "_captureInitialPageview",
            value: function() {
                $504220289e15410d$var$L && !this._initialPageviewCaptured && (this._initialPageviewCaptured = !0, this.capture("$pageview", {
                    title: $504220289e15410d$var$L.title
                }, {
                    send_instantly: !0
                }));
            }
        },
        {
            key: "debug",
            value: function(e) {
                !1 === e ? (null == $504220289e15410d$var$T || $504220289e15410d$var$T.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
                    debug: !1
                })) : (null == $504220289e15410d$var$T || $504220289e15410d$var$T.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
                    debug: !0
                }));
            }
        }
    ]), e;
}();
!function(e, t) {
    for(var n = 0; n < t.length; n++)e.prototype[t[n]] = $504220289e15410d$var$ee(e.prototype[t[n]]);
}($504220289e15410d$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $504220289e15410d$var$os, $504220289e15410d$export$2e2bcd8739ae039 = ($504220289e15410d$var$os = $504220289e15410d$var$Kr[$504220289e15410d$var$es] = new $504220289e15410d$export$a9d6b9cbf49b8241, function() {
    function e() {
        e.done || (e.done = !0, $504220289e15410d$var$ts = !1, $504220289e15410d$var$Q($504220289e15410d$var$Kr, function(e) {
            e._dom_loaded();
        }));
    }
    null != $504220289e15410d$var$L && $504220289e15410d$var$L.addEventListener && ("complete" === $504220289e15410d$var$L.readyState ? e() : $504220289e15410d$var$L.addEventListener("DOMContentLoaded", e, !1)), $504220289e15410d$var$T && $504220289e15410d$var$oe($504220289e15410d$var$T, "load", e, !0);
}(), $504220289e15410d$var$os);

});


parcelRegister("bPnDo", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $dylH1 = parcelRequire("dylH1");

var $lMadu = parcelRequire("lMadu");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $dylH1.isBrowserBundle)() && Object.prototype.toString.call(typeof $lMadu !== "undefined" ? $lMadu : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("dylH1", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $9ddf471ec08385b6$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $9ddf471ec08385b6$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9ddf471ec08385b6$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $9ddf471ec08385b6$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("lMadu", function(module, exports) {
// shim for using process in browser
var $fda60178d2b23045$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fda60178d2b23045$var$cachedSetTimeout;
var $fda60178d2b23045$var$cachedClearTimeout;
function $fda60178d2b23045$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $fda60178d2b23045$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $fda60178d2b23045$var$cachedSetTimeout = setTimeout;
        else $fda60178d2b23045$var$cachedSetTimeout = $fda60178d2b23045$var$defaultSetTimout;
    } catch (e) {
        $fda60178d2b23045$var$cachedSetTimeout = $fda60178d2b23045$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $fda60178d2b23045$var$cachedClearTimeout = clearTimeout;
        else $fda60178d2b23045$var$cachedClearTimeout = $fda60178d2b23045$var$defaultClearTimeout;
    } catch (e) {
        $fda60178d2b23045$var$cachedClearTimeout = $fda60178d2b23045$var$defaultClearTimeout;
    }
})();
function $fda60178d2b23045$var$runTimeout(fun) {
    if ($fda60178d2b23045$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fda60178d2b23045$var$cachedSetTimeout === $fda60178d2b23045$var$defaultSetTimout || !$fda60178d2b23045$var$cachedSetTimeout) && setTimeout) {
        $fda60178d2b23045$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fda60178d2b23045$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fda60178d2b23045$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fda60178d2b23045$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fda60178d2b23045$var$runClearTimeout(marker) {
    if ($fda60178d2b23045$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fda60178d2b23045$var$cachedClearTimeout === $fda60178d2b23045$var$defaultClearTimeout || !$fda60178d2b23045$var$cachedClearTimeout) && clearTimeout) {
        $fda60178d2b23045$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fda60178d2b23045$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fda60178d2b23045$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fda60178d2b23045$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fda60178d2b23045$var$queue = [];
var $fda60178d2b23045$var$draining = false;
var $fda60178d2b23045$var$currentQueue;
var $fda60178d2b23045$var$queueIndex = -1;
function $fda60178d2b23045$var$cleanUpNextTick() {
    if (!$fda60178d2b23045$var$draining || !$fda60178d2b23045$var$currentQueue) return;
    $fda60178d2b23045$var$draining = false;
    if ($fda60178d2b23045$var$currentQueue.length) $fda60178d2b23045$var$queue = $fda60178d2b23045$var$currentQueue.concat($fda60178d2b23045$var$queue);
    else $fda60178d2b23045$var$queueIndex = -1;
    if ($fda60178d2b23045$var$queue.length) $fda60178d2b23045$var$drainQueue();
}
function $fda60178d2b23045$var$drainQueue() {
    if ($fda60178d2b23045$var$draining) return;
    var timeout = $fda60178d2b23045$var$runTimeout($fda60178d2b23045$var$cleanUpNextTick);
    $fda60178d2b23045$var$draining = true;
    var len = $fda60178d2b23045$var$queue.length;
    while(len){
        $fda60178d2b23045$var$currentQueue = $fda60178d2b23045$var$queue;
        $fda60178d2b23045$var$queue = [];
        while(++$fda60178d2b23045$var$queueIndex < len)if ($fda60178d2b23045$var$currentQueue) $fda60178d2b23045$var$currentQueue[$fda60178d2b23045$var$queueIndex].run();
        $fda60178d2b23045$var$queueIndex = -1;
        len = $fda60178d2b23045$var$queue.length;
    }
    $fda60178d2b23045$var$currentQueue = null;
    $fda60178d2b23045$var$draining = false;
    $fda60178d2b23045$var$runClearTimeout(timeout);
}
$fda60178d2b23045$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fda60178d2b23045$var$queue.push(new $fda60178d2b23045$var$Item(fun, args));
    if ($fda60178d2b23045$var$queue.length === 1 && !$fda60178d2b23045$var$draining) $fda60178d2b23045$var$runTimeout($fda60178d2b23045$var$drainQueue);
};
// v8 likes predictible objects
function $fda60178d2b23045$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fda60178d2b23045$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fda60178d2b23045$var$process.title = "browser";
$fda60178d2b23045$var$process.browser = true;
$fda60178d2b23045$var$process.env = {};
$fda60178d2b23045$var$process.argv = [];
$fda60178d2b23045$var$process.version = ""; // empty string to avoid regexp issues
$fda60178d2b23045$var$process.versions = {};
function $fda60178d2b23045$var$noop() {}
$fda60178d2b23045$var$process.on = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.addListener = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.once = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.off = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.removeListener = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.removeAllListeners = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.emit = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.prependListener = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.prependOnceListener = $fda60178d2b23045$var$noop;
$fda60178d2b23045$var$process.listeners = function(name) {
    return [];
};
$fda60178d2b23045$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$fda60178d2b23045$var$process.cwd = function() {
    return "/";
};
$fda60178d2b23045$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$fda60178d2b23045$var$process.umask = function() {
    return 0;
};

});



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $8iZJl = parcelRequire("8iZJl");

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");

var $bh1oa = parcelRequire("bh1oa");

var $dgG1Y = parcelRequire("dgG1Y");



var $hiqiT = parcelRequire("hiqiT");

var $57IP6 = parcelRequire("57IP6");

var $gVjjv = parcelRequire("gVjjv");
function $a62e91a3828fa522$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $bh1oa.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $a62e91a3828fa522$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $57IP6.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $a62e91a3828fa522$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $gVjjv.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).createElement((0, $hiqiT.default).Provider, {
        value: theme
    }, children);
}
var $a62e91a3828fa522$export$2e2bcd8739ae039 = $a62e91a3828fa522$var$ThemeProvider;


parcelRequire("dgG1Y");
parcelRequire("dgG1Y");

var $dgG1Y = parcelRequire("dgG1Y");


var $dgG1Y = parcelRequire("dgG1Y");



var $dgG1Y = parcelRequire("dgG1Y");
const $80a1824ff5ea0d91$var$ThemeContext = /*#__PURE__*/ $dgG1Y.createContext(null);
var $80a1824ff5ea0d91$export$2e2bcd8739ae039 = $80a1824ff5ea0d91$var$ThemeContext;



var $dgG1Y = parcelRequire("dgG1Y");

function $2f727d4d57fa5c61$export$2e2bcd8739ae039() {
    const theme = $dgG1Y.useContext((0, $80a1824ff5ea0d91$export$2e2bcd8739ae039));
    return theme;
}


const $2286d2274d04be9a$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $2286d2274d04be9a$export$2e2bcd8739ae039 = $2286d2274d04be9a$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $fR5Jw = parcelRequire("fR5Jw");
function $c737a138f6537625$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $c737a138f6537625$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $2f727d4d57fa5c61$export$2e2bcd8739ae039)();
    const theme = $dgG1Y.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $c737a138f6537625$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $2286d2274d04be9a$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $80a1824ff5ea0d91$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $c737a138f6537625$export$2e2bcd8739ae039 = $c737a138f6537625$var$ThemeProvider;



parcelRequire("2OelD");
var $hBw4X = parcelRequire("hBw4X");

var $aByKf = parcelRequire("aByKf");

var $gK9Ik = parcelRequire("gK9Ik");

var $bSXLK = parcelRequire("bSXLK");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $25a33d2fbee8faca$var$EMPTY_THEME = {};
function $25a33d2fbee8faca$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $dgG1Y.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $25a33d2fbee8faca$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $aByKf.default)($25a33d2fbee8faca$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $2f727d4d57fa5c61$export$2e2bcd8739ae039)() || $25a33d2fbee8faca$var$EMPTY_THEME;
    const engineTheme = $25a33d2fbee8faca$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $25a33d2fbee8faca$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === "rtl";
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $c737a138f6537625$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hBw4X.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gK9Ik.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $bSXLK.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $25a33d2fbee8faca$export$2e2bcd8739ae039 = $25a33d2fbee8faca$var$ThemeProvider;



var $79EgL = parcelRequire("79EgL");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $2b1aafd7c2521913$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $79EgL.default) in themeInput ? themeInput[0, $79EgL.default] : undefined;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $25a33d2fbee8faca$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $79EgL.default) : undefined,
        theme: scopedTheme || themeInput
    });
}


parcelRequire("dgG1Y");

var $2RnpB = parcelRequire("2RnpB");

var $dgG1Y = parcelRequire("dgG1Y");


var $jaTkQ = parcelRequire("jaTkQ");


/**
 * Split this component for RSC import
 */ parcelRequire("dgG1Y");

var $fR5Jw = parcelRequire("fR5Jw");
const $01114552ecf7cb48$export$ff0fa3047d11164c = "mode";
const $01114552ecf7cb48$export$665054ea9d94dab9 = "color-scheme";
const $01114552ecf7cb48$export$14ebe5b26ee7fb38 = "data-color-scheme";
function $01114552ecf7cb48$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = "system", defaultLightColorScheme: defaultLightColorScheme = "light", defaultDarkColorScheme: defaultDarkColorScheme = "dark", modeStorageKey: modeStorageKey = $01114552ecf7cb48$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $01114552ecf7cb48$export$665054ea9d94dab9, attribute: initialAttribute = $01114552ecf7cb48$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = "document.documentElement", nonce: nonce } = options || {};
    let setter = "";
    let attribute = initialAttribute;
    if (initialAttribute === "class") attribute = ".%s";
    if (initialAttribute === "data") attribute = "[data-%s]";
    if (attribute.startsWith(".")) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split("=");
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $fR5Jw.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === "undefined" ? nonce : "",
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $dgG1Y = parcelRequire("dgG1Y");

"use client";
function $873363e23ca6f25b$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== "undefined" && typeof window.matchMedia === "function" && mode === "system") {
        const mql = window.matchMedia("(prefers-color-scheme: dark)");
        if (mql.matches) return "dark";
        return "light";
    }
    return undefined;
}
function $873363e23ca6f25b$var$processState(state, callback) {
    if (state.mode === "light" || state.mode === "system" && state.systemMode === "light") return callback("light");
    if (state.mode === "dark" || state.mode === "system" && state.systemMode === "dark") return callback("dark");
    return undefined;
}
function $873363e23ca6f25b$export$3caa7590cc1987bd(state) {
    return $873363e23ca6f25b$var$processState(state, (mode)=>{
        if (mode === "light") return state.lightColorScheme;
        if (mode === "dark") return state.darkColorScheme;
        return undefined;
    });
}
function $873363e23ca6f25b$var$initializeValue(key, defaultValue) {
    if (typeof window === "undefined") return undefined;
    let value;
    try {
        value = localStorage.getItem(key) || undefined;
        if (!value) // the first time that user enters the site.
        localStorage.setItem(key, defaultValue);
    } catch  {
    // Unsupported
    }
    return value || defaultValue;
}
function $873363e23ca6f25b$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = "light", defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $01114552ecf7cb48$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $01114552ecf7cb48$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === "undefined" ? undefined : window, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(",");
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const [state, setState] = $dgG1Y.useState(()=>{
        const initialMode = $873363e23ca6f25b$var$initializeValue(modeStorageKey, defaultMode);
        const lightColorScheme = $873363e23ca6f25b$var$initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
        const darkColorScheme = $873363e23ca6f25b$var$initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        return {
            mode: initialMode,
            systemMode: $873363e23ca6f25b$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $dgG1Y.useState(noSsr || !isMultiSchemes);
    $dgG1Y.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $873363e23ca6f25b$export$3caa7590cc1987bd(state);
    const setMode = $dgG1Y.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode !== null && mode !== void 0 ? mode : defaultMode;
            try {
                localStorage.setItem(modeStorageKey, newMode);
            } catch  {
            // Unsupported
            }
            return {
                ...currentState,
                mode: newMode,
                systemMode: $873363e23ca6f25b$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorageKey,
        defaultMode
    ]);
    const setColorScheme = $dgG1Y.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            try {
                localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
                localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
            } catch  {
            // Unsupported
            }
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === "string") {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $873363e23ca6f25b$var$processState(currentState, (mode)=>{
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
                    } catch  {
                    // Unsupported
                    }
                    if (mode === "light") newState.lightColorScheme = value;
                    if (mode === "dark") newState.darkColorScheme = value;
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        colorSchemeStorageKey,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $dgG1Y.useCallback((event)=>{
        if (state.mode === "system") setState((currentState)=>{
            const systemMode = (event === null || event === void 0 ? void 0 : event.matches) ? "dark" : "light";
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $dgG1Y.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $dgG1Y.useEffect(()=>{
        if (typeof window.matchMedia !== "function" || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia("(prefers-color-scheme: dark)");
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $dgG1Y.useEffect(()=>{
        if (storageWindow && isMultiSchemes) {
            const handleStorage = (event)=>{
                const value = event.newValue;
                if (typeof event.key === "string" && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
                    // If the key is deleted, value will be null then reset color scheme to the default one.
                    if (event.key.endsWith("light")) setColorScheme({
                        light: value
                    });
                    if (event.key.endsWith("dark")) setColorScheme({
                        dark: value
                    });
                }
                if (event.key === modeStorageKey && (!value || [
                    "light",
                    "dark",
                    "system"
                ].includes(value))) setMode(value || defaultMode);
            };
            // For syncing color-scheme changes between iframes
            storageWindow.addEventListener("storage", handleStorage);
            return ()=>{
                storageWindow.removeEventListener("storage", handleStorage);
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        modeStorageKey,
        colorSchemeStorageKey,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



var $fR5Jw = parcelRequire("fR5Jw");
const $27f1c077dfc5773f$export$c09f426c4535c3ec = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function $27f1c077dfc5773f$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $01114552ecf7cb48$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $01114552ecf7cb48$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $dgG1Y.createContext(undefined);
    const useColorScheme = ()=>$dgG1Y.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        var _colorSchemes_restThemeProp_defaultColorScheme_palette, _colorSchemes_restThemeProp_defaultColorScheme, _restThemeProp_palette, _memoTheme_generateStyleSheets;
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageWindow: storageWindow = typeof window === "undefined" ? undefined : window, documentNode: documentNode = typeof document === "undefined" ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === "undefined" ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = "system", noSsr: noSsr } = props;
        const hasMounted = $dgG1Y.useRef(false);
        const upperTheme = (0, $2f727d4d57fa5c61$export$2e2bcd8739ae039)();
        const ctx = $dgG1Y.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $dgG1Y.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === "function" ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(",");
        const allColorSchemes = $dgG1Y.useMemo(()=>joinedColorSchemes.split(","), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : ((_colorSchemes_restThemeProp_defaultColorScheme = colorSchemes[restThemeProp.defaultColorScheme]) === null || _colorSchemes_restThemeProp_defaultColorScheme === void 0 ? void 0 : (_colorSchemes_restThemeProp_defaultColorScheme_palette = _colorSchemes_restThemeProp_defaultColorScheme.palette) === null || _colorSchemes_restThemeProp_defaultColorScheme_palette === void 0 ? void 0 : _colorSchemes_restThemeProp_defaultColorScheme_palette.mode) || ((_restThemeProp_palette = restThemeProp.palette) === null || _restThemeProp_palette === void 0 ? void 0 : _restThemeProp_palette.mode);
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $873363e23ca6f25b$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $dgG1Y.useMemo(()=>{
            var _restThemeProp_generateThemeVars;
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = ((_restThemeProp_generateThemeVars = restThemeProp.generateThemeVars) === null || _restThemeProp_generateThemeVars === void 0 ? void 0 : _restThemeProp_generateThemeVars.call(restThemeProp)) || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === "function") theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === "object") // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === "object") // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        $dgG1Y.useEffect(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== "media") {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === "class") rule = `.%s`;
                if (selector === "data") rule = `[data-%s]`;
                if ((selector === null || selector === void 0 ? void 0 : selector.startsWith("data-")) && !selector.includes("%s")) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith(".")) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace("%s", scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace("%s", colorScheme));
                } else {
                    const matches = rule.replace("%s", colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split("=");
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, "") : "");
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $dgG1Y.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement("style");
                css.appendChild(documentNode.createTextNode($27f1c077dfc5773f$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $dgG1Y.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $dgG1Y.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && (upperTheme === null || upperTheme === void 0 ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $fR5Jw.jsxs)($dgG1Y.Fragment, {
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $25a33d2fbee8faca$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jaTkQ.default), {
                    styles: ((_memoTheme_generateStyleSheets = memoTheme.generateStyleSheets) === null || _memoTheme_generateStyleSheets === void 0 ? void 0 : _memoTheme_generateStyleSheets.call(memoTheme)) || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $fR5Jw.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $01114552ecf7cb48$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $iikr3 = parcelRequire("iikr3");

var $1NRdZ = parcelRequire("1NRdZ");

var $79EgL = parcelRequire("79EgL");
parcelRequire("dgG1Y");


var $fR5Jw = parcelRequire("fR5Jw");
const $e3244d39ccce8d19$export$f84bd70098573c5c = {
    attribute: "data-mui-color-scheme",
    colorSchemeStorageKey: "mui-color-scheme",
    defaultLightColorScheme: "light",
    defaultDarkColorScheme: "dark",
    modeStorageKey: "mui-mode"
};
var $e3244d39ccce8d19$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $01114552ecf7cb48$export$2e2bcd8739ae039), {
        ...$e3244d39ccce8d19$export$f84bd70098573c5c,
        ...props
    });
};



var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const { CssVarsProvider: $c5fd9c8718d8d83e$var$InternalCssVarsProvider, useColorScheme: $c5fd9c8718d8d83e$export$6343629ee1b29116, getInitColorSchemeScript: $c5fd9c8718d8d83e$var$deprecatedGetInitColorSchemeScript } = (0, $27f1c077dfc5773f$export$2e2bcd8739ae039)({
    themeId: (0, $79EgL.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $iikr3.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $e3244d39ccce8d19$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $e3244d39ccce8d19$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $e3244d39ccce8d19$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $e3244d39ccce8d19$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $1NRdZ.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $2RnpB.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $c5fd9c8718d8d83e$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $c5fd9c8718d8d83e$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($c5fd9c8718d8d83e$var$InternalCssVarsProvider, {
        ...props
    });
}
let $c5fd9c8718d8d83e$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $c5fd9c8718d8d83e$export$f9a57b4a2abf8ed = (params)=>{
    if (!$c5fd9c8718d8d83e$var$warnedInitScriptOnce) {
        console.warn([
            "MUI: The getInitColorSchemeScript function has been deprecated.",
            "",
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            "and replace the function call with `<InitColorSchemeScript />` instead."
        ].join("\n"));
        $c5fd9c8718d8d83e$var$warnedInitScriptOnce = true;
    }
    return $c5fd9c8718d8d83e$var$deprecatedGetInitColorSchemeScript(params);
};
const $c5fd9c8718d8d83e$export$50ec01b133c61652 = $c5fd9c8718d8d83e$var$InternalCssVarsProvider;



var $79EgL = parcelRequire("79EgL");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $7506a74e5505d072$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    if (typeof theme === "function") return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2b1aafd7c2521913$export$2e2bcd8739ae039), {
        theme: theme,
        ...props
    });
    const muiTheme = (0, $79EgL.default) in theme ? theme[0, $79EgL.default] : theme;
    if (!("colorSchemes" in muiTheme)) return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2b1aafd7c2521913$export$2e2bcd8739ae039), {
        theme: theme,
        ...props
    });
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $c5fd9c8718d8d83e$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}



var $8DY8l = parcelRequire("8DY8l");


var $cVxYB = parcelRequire("cVxYB");

var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $fOZMN = parcelRequire("fOZMN");parcelRequire("kunpB");
var $fOZMN = parcelRequire("fOZMN");

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $jlzll = parcelRequire("jlzll");

var $h2Xtr = parcelRequire("h2Xtr");

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");

var $cXVHi = parcelRequire("cXVHi");

var $h2Xtr = parcelRequire("h2Xtr");

var $bh1oa = parcelRequire("bh1oa");

var $gZz4Z = parcelRequire("gZz4Z");

var $dgG1Y = parcelRequire("dgG1Y");


var $cXVHi = parcelRequire("cXVHi");

var $7xfqK = parcelRequire("7xfqK");

var $bdWPY = parcelRequire("bdWPY");

var $2Po3a = parcelRequire("2Po3a");
var $bdf1b3c86656d5e5$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColorDefault = theme.palette.type === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            boxSizing: "border-box",
            // Prevent padding issue with the Modal and fixed positioned AppBar.
            zIndex: theme.zIndex.appBar,
            flexShrink: 0
        },
        /* Styles applied to the root element if `position="fixed"`. */ positionFixed: {
            position: "fixed",
            top: 0,
            left: "auto",
            right: 0,
            "@media print": {
                // Prevent the app bar to be visible on each printed page.
                position: "absolute"
            }
        },
        /* Styles applied to the root element if `position="absolute"`. */ positionAbsolute: {
            position: "absolute",
            top: 0,
            left: "auto",
            right: 0
        },
        /* Styles applied to the root element if `position="sticky"`. */ positionSticky: {
            // ⚠️ sticky is not supported by IE 11.
            position: "sticky",
            top: 0,
            left: "auto",
            right: 0
        },
        /* Styles applied to the root element if `position="static"`. */ positionStatic: {
            position: "static"
        },
        /* Styles applied to the root element if `position="relative"`. */ positionRelative: {
            position: "relative"
        },
        /* Styles applied to the root element if `color="default"`. */ colorDefault: {
            backgroundColor: backgroundColorDefault,
            color: theme.palette.getContrastText(backgroundColorDefault)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="transparent"`. */ colorTransparent: {
            backgroundColor: "transparent",
            color: "inherit"
        }
    };
};
var $bdf1b3c86656d5e5$var$AppBar = /*#__PURE__*/ $dgG1Y.forwardRef(function AppBar(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$position = props.position, position = _props$position === void 0 ? "fixed" : _props$position, other = (0, $gZz4Z.default)(props, [
        "classes",
        "className",
        "color",
        "position"
    ]);
    return /*#__PURE__*/ $dgG1Y.createElement((0, $2Po3a.default), (0, $bh1oa.default)({
        square: true,
        component: "header",
        elevation: 4,
        className: (0, $cXVHi.default)(classes.root, classes["position".concat((0, $bdWPY.default)(position))], classes["color".concat((0, $bdWPY.default)(color))], className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $bdf1b3c86656d5e5$export$2e2bcd8739ae039 = (0, $7xfqK.default)($bdf1b3c86656d5e5$export$9dd6ff9ea0189349, {
    name: "MuiAppBar"
})($bdf1b3c86656d5e5$var$AppBar);


var $3XSLK = parcelRequire("3XSLK");
var $6f13ade8f385c770$exports = {};

$6f13ade8f385c770$exports = (parcelRequire("28PFx")).getBundleURL("4temp") + "white_logo_transparent_background.2184994d.png";


const $f32c46492dc91619$var$useStyles = (0, $h2Xtr.default)(()=>({
        root: {
            boxShadow: "none"
        }
    }));
const $f32c46492dc91619$var$Topbar = (props)=>{
    const { className: className, ...rest } = props;
    const classes = $f32c46492dc91619$var$useStyles();
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $bdf1b3c86656d5e5$export$2e2bcd8739ae039), {
        ...rest,
        className: (0, $cXVHi.default)(classes.root, className),
        color: "primary",
        position: "fixed",
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3XSLK.default), {
            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kunpB.Link), {
                to: "/",
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)("img", {
                    alt: "Logo",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6f13ade8f385c770$exports))),
                    height: "60px"
                })
            })
        })
    });
};
var $f32c46492dc91619$export$2e2bcd8739ae039 = $f32c46492dc91619$var$Topbar;


const $83a03f40458c9c95$var$useStyles = (0, $h2Xtr.default)(()=>({
        root: {
            paddingTop: 64,
            height: "100%"
        },
        content: {
            height: "100%"
        }
    }));
const $83a03f40458c9c95$var$Minimal = (props)=>{
    const { children: children } = props;
    const classes = $83a03f40458c9c95$var$useStyles();
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f32c46492dc91619$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fR5Jw.jsx)("main", {
                className: classes.content,
                children: children
            })
        ]
    });
};
$83a03f40458c9c95$var$Minimal.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($jlzll))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jlzll))).string
};
var $83a03f40458c9c95$export$2e2bcd8739ae039 = $83a03f40458c9c95$var$Minimal;



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $cXVHi = parcelRequire("cXVHi");

var $kngbJ = parcelRequire("kngbJ");

var $6xSIW = parcelRequire("6xSIW");

var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $lBH8Z = parcelRequire("lBH8Z");
var $j0KmW = parcelRequire("j0KmW");
var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");


var $1wSL5 = parcelRequire("1wSL5");

var $gK9Ik = parcelRequire("gK9Ik");

var $kDVit = parcelRequire("kDVit");

var $dgG1Y = parcelRequire("dgG1Y");


var $dlCX6 = parcelRequire("dlCX6");




var $bEw0x = parcelRequire("bEw0x");

var $blSgQ = parcelRequire("blSgQ");

var $51QVq = parcelRequire("51QVq");

var $kngbJ = parcelRequire("kngbJ");

var $bDI8z = parcelRequire("bDI8z");

var $44E5a = parcelRequire("44E5a");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
function $4d751c377875356a$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $44E5a.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4d751c377875356a$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $4d751c377875356a$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4d751c377875356a$var$resolveContainer(containerProp);
    const transform = $4d751c377875356a$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4d751c377875356a$var$Slide = /*#__PURE__*/ $dgG1Y.forwardRef(function Slide(props, ref) {
    const theme = (0, $kngbJ.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dlCX6.default), ...other } = props;
    const childrenRef = $dgG1Y.useRef(null);
    const handleRef = (0, $51QVq.default)((0, $bEw0x.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4d751c377875356a$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $bDI8z.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $bDI8z.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create("transform", {
            ...transitionProps
        });
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $bDI8z.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $4d751c377875356a$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $dgG1Y.useCallback(()=>{
        if (childrenRef.current) $4d751c377875356a$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $dgG1Y.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $blSgQ.default)(()=>{
            if (childrenRef.current) $4d751c377875356a$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $44E5a.default)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $dgG1Y.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $dgG1Y.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $4d751c377875356a$export$2e2bcd8739ae039 = $4d751c377875356a$var$Slide;



var $cBhUq = parcelRequire("cBhUq");

var $9TQfG = parcelRequire("9TQfG");

var $c1SJa = parcelRequire("c1SJa");

var $dTuzq = parcelRequire("dTuzq");
var $kngbJ = parcelRequire("kngbJ");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $ff026490cbabcb10$export$b801318a856c9cd2(slot) {
    return (0, $5xHgF.default)("MuiDrawer", slot);
}
const $ff026490cbabcb10$var$drawerClasses = (0, $eFHYA.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $ff026490cbabcb10$export$2e2bcd8739ae039 = $ff026490cbabcb10$var$drawerClasses;



var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $86237586877b20ee$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $86237586877b20ee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $9TQfG.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $9TQfG.default)(anchor)}`
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $ff026490cbabcb10$export$b801318a856c9cd2), classes);
};
const $86237586877b20ee$var$DrawerRoot = (0, $dTuzq.default)((0, $kDVit.default), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $86237586877b20ee$var$overridesResolver
})((0, $iIVKJ.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $86237586877b20ee$var$DrawerDockedRoot = (0, $dTuzq.default)("div", {
    shouldForwardProp: (0, $c1SJa.default),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $86237586877b20ee$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $86237586877b20ee$var$DrawerPaper = (0, $dTuzq.default)((0, $cBhUq.default), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $9TQfG.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $9TQfG.default)(ownerState.anchor)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: "left"
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: "top"
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "auto",
                    maxHeight: "100%"
                }
            },
            {
                props: {
                    anchor: "right"
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: "bottom"
                },
                style: {
                    top: "auto",
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: "auto",
                    maxHeight: "100%"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === "left" && ownerState.variant !== "temporary",
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === "top" && ownerState.variant !== "temporary",
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === "right" && ownerState.variant !== "temporary",
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === "bottom" && ownerState.variant !== "temporary",
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $86237586877b20ee$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $86237586877b20ee$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].includes(anchor);
}
function $86237586877b20ee$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === "rtl" && $86237586877b20ee$export$2a62b49acb270576(anchor) ? $86237586877b20ee$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $86237586877b20ee$var$Drawer = /*#__PURE__*/ $dgG1Y.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $kngbJ.default)();
    const isRtl = (0, $gK9Ik.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $4d751c377875356a$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary", ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $dgG1Y.useRef(false);
    $dgG1Y.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $86237586877b20ee$export$830f4f08342d299e({
        direction: isRtl ? "rtl" : "ltr"
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $86237586877b20ee$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $fR5Jw.jsx)($86237586877b20ee$var$DrawerPaper, {
        elevation: variant === "temporary" ? elevation : 0,
        square: true,
        ...PaperProps,
        className: (0, $8MGTi.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    });
    if (variant === "permanent") return /*#__PURE__*/ (0, $fR5Jw.jsx)($86237586877b20ee$var$DrawerDockedRoot, {
        className: (0, $8MGTi.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $fR5Jw.jsx)(TransitionComponent, {
        in: open,
        direction: $86237586877b20ee$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current,
        ...SlideProps,
        children: drawer
    });
    if (variant === "persistent") return /*#__PURE__*/ (0, $fR5Jw.jsx)($86237586877b20ee$var$DrawerDockedRoot, {
        className: (0, $8MGTi.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($86237586877b20ee$var$DrawerRoot, {
        BackdropProps: {
            ...BackdropProps,
            ...BackdropPropsProp,
            transitionDuration: transitionDuration
        },
        className: (0, $8MGTi.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref,
        ...other,
        ...ModalProps,
        children: slidingDrawer
    });
});
var $86237586877b20ee$export$2e2bcd8739ae039 = $86237586877b20ee$var$Drawer;


var $kMmDg = parcelRequire("kMmDg");
var $dcfbd96f371d84d7$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $dcfbd96f371d84d7$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($dcfbd96f371d84d7$exports, "__esModule", {
    value: true
});
$dcfbd96f371d84d7$exports.default = void 0;

var $dcfbd96f371d84d7$var$_createSvgIcon = $dcfbd96f371d84d7$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $dcfbd96f371d84d7$var$_default = $dcfbd96f371d84d7$exports.default = (0, $dcfbd96f371d84d7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M3 13h8V3H3zm0 8h8v-6H3zm10 0h8V11h-8zm0-18v6h8V3z"
}), "Dashboard");


var $3bc070f83ba0e664$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $3bc070f83ba0e664$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($3bc070f83ba0e664$exports, "__esModule", {
    value: true
});
$3bc070f83ba0e664$exports.default = void 0;

var $3bc070f83ba0e664$var$_createSvgIcon = $3bc070f83ba0e664$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $3bc070f83ba0e664$var$_default = $3bc070f83ba0e664$exports.default = (0, $3bc070f83ba0e664$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), "People");


var $cf8bef216921c542$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $cf8bef216921c542$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($cf8bef216921c542$exports, "__esModule", {
    value: true
});
$cf8bef216921c542$exports.default = void 0;

var $cf8bef216921c542$var$_createSvgIcon = $cf8bef216921c542$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $cf8bef216921c542$var$_default = $cf8bef216921c542$exports.default = (0, $cf8bef216921c542$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58z"
}), "AccountBox");


var $0693db25e46f523a$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $0693db25e46f523a$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($0693db25e46f523a$exports, "__esModule", {
    value: true
});
$0693db25e46f523a$exports.default = void 0;

var $0693db25e46f523a$var$_createSvgIcon = $0693db25e46f523a$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $0693db25e46f523a$var$_default = $0693db25e46f523a$exports.default = (0, $0693db25e46f523a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2M11 16l4-4-4-4v3H1v2h10z"
}), "Input");


var $de4bf9b8e7ab8b7e$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $de4bf9b8e7ab8b7e$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($de4bf9b8e7ab8b7e$exports, "__esModule", {
    value: true
});
$de4bf9b8e7ab8b7e$exports.default = void 0;

var $de4bf9b8e7ab8b7e$var$_createSvgIcon = $de4bf9b8e7ab8b7e$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $de4bf9b8e7ab8b7e$var$_default = $de4bf9b8e7ab8b7e$exports.default = (0, $de4bf9b8e7ab8b7e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"
}), "Favorite");


var $8e4e0c6d49c7b8ae$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $8e4e0c6d49c7b8ae$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($8e4e0c6d49c7b8ae$exports, "__esModule", {
    value: true
});
$8e4e0c6d49c7b8ae$exports.default = void 0;

var $8e4e0c6d49c7b8ae$var$_createSvgIcon = $8e4e0c6d49c7b8ae$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $8e4e0c6d49c7b8ae$var$_default = $8e4e0c6d49c7b8ae$exports.default = (0, $8e4e0c6d49c7b8ae$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle");


var $da157ff513be7a7e$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $da157ff513be7a7e$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($da157ff513be7a7e$exports, "__esModule", {
    value: true
});
$da157ff513be7a7e$exports.default = void 0;

var $da157ff513be7a7e$var$_createSvgIcon = $da157ff513be7a7e$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $da157ff513be7a7e$var$_default = $da157ff513be7a7e$exports.default = (0, $da157ff513be7a7e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "ReportProblem");


var $07b4672465c3851b$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $07b4672465c3851b$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($07b4672465c3851b$exports, "__esModule", {
    value: true
});
$07b4672465c3851b$exports.default = void 0;

var $07b4672465c3851b$var$_createSvgIcon = $07b4672465c3851b$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $07b4672465c3851b$var$_default = $07b4672465c3851b$exports.default = (0, $07b4672465c3851b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M9 11H7V9h2zm4 0h-2V9h2zm4 0h-2V9h2z"
}), "Sms");


var $15969c7c9eed960f$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $15969c7c9eed960f$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($15969c7c9eed960f$exports, "__esModule", {
    value: true
});
$15969c7c9eed960f$exports.default = void 0;

var $15969c7c9eed960f$var$_createSvgIcon = $15969c7c9eed960f$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $15969c7c9eed960f$var$_default = $15969c7c9eed960f$exports.default = (0, $15969c7c9eed960f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "m22 5.72-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9m0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), "AccessAlarm");


var $119484a45ad94f77$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $119484a45ad94f77$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($119484a45ad94f77$exports, "__esModule", {
    value: true
});
$119484a45ad94f77$exports.default = void 0;

var $119484a45ad94f77$var$_createSvgIcon = $119484a45ad94f77$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $119484a45ad94f77$var$_default = $119484a45ad94f77$exports.default = (0, $119484a45ad94f77$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6 16h-2v-2h2zm2.07-7.75-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), "LiveHelp");


var $78012fd9c9fe3c0a$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $78012fd9c9fe3c0a$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($78012fd9c9fe3c0a$exports, "__esModule", {
    value: true
});
$78012fd9c9fe3c0a$exports.default = void 0;

var $78012fd9c9fe3c0a$var$_createSvgIcon = $78012fd9c9fe3c0a$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $78012fd9c9fe3c0a$var$_default = $78012fd9c9fe3c0a$exports.default = (0, $78012fd9c9fe3c0a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
}), "ShowChart");


var $2d3f4ccb05f9611a$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $2d3f4ccb05f9611a$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($2d3f4ccb05f9611a$exports, "__esModule", {
    value: true
});
$2d3f4ccb05f9611a$exports.default = void 0;

var $2d3f4ccb05f9611a$var$_createSvgIcon = $2d3f4ccb05f9611a$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $2d3f4ccb05f9611a$var$_default = $2d3f4ccb05f9611a$exports.default = (0, $2d3f4ccb05f9611a$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $fR5Jw.jsx)("circle", {
        cx: "9",
        cy: "9",
        r: "4"
    }, "0"),
    /*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
        d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4m7.76-9.64-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27M20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14"
    }, "1")
], "RecordVoiceOver");



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");

var $iJ8f3 = parcelRequire("iJ8f3");
var $eiHeI = parcelRequire("eiHeI");
var $jayBd = parcelRequire("jayBd");
var $f9Dhz = parcelRequire("f9Dhz");

var $ewdxp = parcelRequire("ewdxp");

var $8DY8l = parcelRequire("8DY8l");
const $3cfcc9ce8122c996$var$SidebarNav = ({ pages: pages, sx: sx })=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    const handleLogout = (event)=>{
        event.preventDefault();
        auth.logout();
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $jayBd.default), {
        disablePadding: true,
        sx: sx,
        children: pages.map((page)=>/*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).Fragment, {
                children: page.logout ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f9Dhz.default), {
                    disableGutters: true,
                    sx: {
                        mb: 0.5,
                        p: 0
                    },
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($3cfcc9ce8122c996$var$NavButton, {
                        to: page.href,
                        icon: page.icon,
                        title: page.title,
                        onClick: handleLogout
                    })
                }) : /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                    children: [
                        !page.logout && (!page.User && (!page.hide || auth.accountableAdmin || auth.provider) || page.User && !auth.accountableAdmin && !auth.provider) && (!page.admin || auth.accountableAdmin) && (!page.supervisor || auth.supervisor) && (!page.harambe || auth.harambe) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f9Dhz.default), {
                            disableGutters: true,
                            sx: {
                                mb: 0.5,
                                p: 0
                            },
                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)($3cfcc9ce8122c996$var$NavButton, {
                                to: page.href,
                                icon: page.icon,
                                title: page.title
                            })
                        }),
                        !page.logout && (page.Program && auth.program || page.siteAdmin && auth.siteAdmin) && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f9Dhz.default), {
                            disableGutters: true,
                            sx: {
                                mb: 0.5,
                                p: 0
                            },
                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)($3cfcc9ce8122c996$var$NavButton, {
                                to: page.href,
                                icon: page.icon,
                                title: page.title
                            })
                        })
                    ]
                })
            }, page.title))
    });
};
const $3cfcc9ce8122c996$var$NavButton = ({ to: to, icon: icon, title: title, onClick: onClick, ...props })=>{
    const buttonSx = {
        color: (0, $eiHeI).blueGrey[700],
        padding: "8px 8px",
        justifyContent: "flex-start",
        textTransform: "none",
        letterSpacing: 0,
        width: "100%",
        fontWeight: "medium",
        "&.active": {
            color: (0, $8DY8l.theme).palette.primary.main,
            "& .icon": {
                color: (0, $8DY8l.theme).palette.primary.main
            }
        },
        ...props.sx
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $iJ8f3.default), {
        component: (0, $kunpB.NavLink),
        to: to,
        onClick: onClick,
        sx: buttonSx,
        ...props,
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)("span", {
                className: "icon",
                style: {
                    marginRight: 8,
                    display: "flex",
                    alignItems: "center"
                },
                children: icon
            }),
            title
        ]
    });
};
var $3cfcc9ce8122c996$export$2e2bcd8739ae039 = $3cfcc9ce8122c996$var$SidebarNav;


var $5c4b038e0b2eedab$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $5c4b038e0b2eedab$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($5c4b038e0b2eedab$exports, "__esModule", {
    value: true
});
$5c4b038e0b2eedab$exports.default = void 0;

var $5c4b038e0b2eedab$var$_createSvgIcon = $5c4b038e0b2eedab$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $5c4b038e0b2eedab$var$_default = $5c4b038e0b2eedab$exports.default = (0, $5c4b038e0b2eedab$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55M12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3"
}), "LocalLibrary");


var $bd6ecd53ad3fffed$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $bd6ecd53ad3fffed$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($bd6ecd53ad3fffed$exports, "__esModule", {
    value: true
});
$bd6ecd53ad3fffed$exports.default = void 0;

var $bd6ecd53ad3fffed$var$_createSvgIcon = $bd6ecd53ad3fffed$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $bd6ecd53ad3fffed$var$_default = $bd6ecd53ad3fffed$exports.default = (0, $bd6ecd53ad3fffed$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 17H7v-7h2zm4 0h-2V7h2zm4 0h-2v-4h2z"
}), "Assessment");


var $b22cbcd30d441a49$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $b22cbcd30d441a49$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($b22cbcd30d441a49$exports, "__esModule", {
    value: true
});
$b22cbcd30d441a49$exports.default = void 0;

var $b22cbcd30d441a49$var$_createSvgIcon = $b22cbcd30d441a49$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $b22cbcd30d441a49$var$_default = $b22cbcd30d441a49$exports.default = (0, $b22cbcd30d441a49$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10m2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99m0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99z"
}), "PieChart");


var $a3beac85031c91a6$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $a3beac85031c91a6$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($a3beac85031c91a6$exports, "__esModule", {
    value: true
});
$a3beac85031c91a6$exports.default = void 0;

var $a3beac85031c91a6$var$_createSvgIcon = $a3beac85031c91a6$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $a3beac85031c91a6$var$_default = $a3beac85031c91a6$exports.default = (0, $a3beac85031c91a6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5"
}), "PeopleRounded");


var $2294de50bc57132c$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $2294de50bc57132c$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($2294de50bc57132c$exports, "__esModule", {
    value: true
});
$2294de50bc57132c$exports.default = void 0;

var $2294de50bc57132c$var$_createSvgIcon = $2294de50bc57132c$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $2294de50bc57132c$var$_default = $2294de50bc57132c$exports.default = (0, $2294de50bc57132c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
}), "Mail");


var $f3a22713811f18e0$exports = {};
"use strict";
"use client";

var $53O4H = parcelRequire("53O4H");
var $f3a22713811f18e0$require$_interopRequireDefault = $53O4H.default;
Object.defineProperty($f3a22713811f18e0$exports, "__esModule", {
    value: true
});
$f3a22713811f18e0$exports.default = void 0;

var $f3a22713811f18e0$var$_createSvgIcon = $f3a22713811f18e0$require$_interopRequireDefault((parcelRequire("cZslG")));

var $fR5Jw = parcelRequire("fR5Jw");
var $f3a22713811f18e0$var$_default = $f3a22713811f18e0$exports.default = (0, $f3a22713811f18e0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4"
}), "Build");



var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $a71557f6917abb53$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "Visibility");


const $630ae7654710b908$var$Sidebar = (props)=>{
    const { open: open, variant: variant, onClose: onClose, className: className, ...rest } = props;
    const pages = [
        {
            title: "My Dashboard",
            href: "/dashboard",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcfbd96f371d84d7$exports))), {})
        },
        {
            title: "Outcomes Analytics",
            href: "/analytics",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b22cbcd30d441a49$exports))), {}),
            admin: true,
            Program: true,
            siteAdmin: true
        },
        {
            title: "Onboarding",
            href: "/onboarding",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3beac85031c91a6$exports))), {}),
            admin: true
        },
        {
            title: "Ask AJ",
            href: "/accountableGPT",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($119484a45ad94f77$exports))), {}),
            admin: true
        },
        {
            title: "Member Reports",
            href: "/reports",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bd6ecd53ad3fffed$exports))), {}),
            admin: true
        },
        {
            title: "Wellness Goal Plan",
            href: "/goal",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e4e0c6d49c7b8ae$exports))), {})
        },
        {
            title: "Goal Library",
            href: "/goallibrary",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5c4b038e0b2eedab$exports))), {})
        },
        {
            title: "Safety Plan",
            href: "/safety",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($da157ff513be7a7e$exports))), {}),
            User: true
        },
        {
            title: "Communication Log",
            href: "/sms",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($07b4672465c3851b$exports))), {})
        },
        /* {
      title: 'Community Chat',
      href: '/groupchat',
      icon: <GroupIcon />
    },*/ {
            title: "Survey Results",
            href: "/surveyresults",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78012fd9c9fe3c0a$exports))), {})
        },
        {
            title: "Scheduled Messages",
            href: "/schedule",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15969c7c9eed960f$exports))), {}),
            admin: true
        },
        {
            title: "Manage Surveys",
            href: "/surveyadmin",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($119484a45ad94f77$exports))), {}),
            admin: true
        },
        {
            title: "Toxicology Results",
            href: "/tox",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($de4bf9b8e7ab8b7e$exports))), {})
        },
        {
            title: "Toxicology Reviews",
            href: "/tox-reviews",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a71557f6917abb53$export$2e2bcd8739ae039), {}),
            admin: true
        },
        {
            title: "Scheduled Tests",
            href: "/scheduled-tests/users",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15969c7c9eed960f$exports))), {}),
            admin: true,
            Program: true
        },
        {
            title: "Breathalyzer Results",
            href: "/vendoralerts",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2d3f4ccb05f9611a$exports))), {})
        },
        {
            title: "My Members",
            href: "/adminportal",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bc070f83ba0e664$exports))), {}),
            hide: true
        },
        {
            title: "Kits",
            href: "/kits",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2294de50bc57132c$exports))), {}),
            admin: true
        },
        {
            title: "Orders",
            href: "/orders",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2294de50bc57132c$exports))), {}),
            admin: true
        },
        {
            title: "Care Team Members",
            href: "/Users",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bc070f83ba0e664$exports))), {}),
            User: true,
            Program: true,
            siteAdmin: true
        },
        {
            title: "Account Settings",
            href: "/account",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf8bef216921c542$exports))), {})
        },
        {
            title: "Audits",
            href: "/audits",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bd6ecd53ad3fffed$exports))), {}),
            supervisor: true
        },
        {
            title: "Admin Tools",
            href: "/admin-tools",
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3a22713811f18e0$exports))), {}),
            harambe: true
        },
        {
            title: "Logout",
            href: "/sign-in",
            logout: true,
            icon: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0693db25e46f523a$exports))), {})
        }
    ];
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $86237586877b20ee$export$2e2bcd8739ae039), {
        anchor: "left",
        sx: {
            width: 240,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
                width: 240,
                boxSizing: "border-box",
                top: {
                    lg: 64
                },
                height: {
                    lg: "calc(100% - 64px)"
                }
            }
        },
        onClose: onClose,
        open: open,
        variant: variant,
        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
            sx: {
                backgroundColor: "background.paper",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                p: 2
            },
            ...rest,
            children: [
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kMmDg.default), {
                    align: "left",
                    variant: "h5",
                    sx: {
                        ml: 1
                    },
                    children: props.tenantname
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $j0KmW.default), {
                    sx: {
                        my: 2
                    }
                }),
                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3cfcc9ce8122c996$export$2e2bcd8739ae039), {
                    sx: {
                        mb: 2
                    },
                    pages: pages
                })
            ]
        })
    });
};
var $630ae7654710b908$export$2e2bcd8739ae039 = $630ae7654710b908$var$Sidebar;



var $fR5Jw = parcelRequire("fR5Jw");
parcelRequire("dgG1Y");

var $cXVHi = parcelRequire("cXVHi");

var $h2Xtr = parcelRequire("h2Xtr");
const $2754b08c9e4e10c8$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            padding: theme.spacing(4)
        }
    }));
const $2754b08c9e4e10c8$var$Footer = (props)=>{
    const { className: className, ...rest } = props;
    const classes = $2754b08c9e4e10c8$var$useStyles();
    return /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
        ...rest,
        className: (0, $cXVHi.default)(classes.root, className)
    });
};
var $2754b08c9e4e10c8$export$2e2bcd8739ae039 = $2754b08c9e4e10c8$var$Footer;



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $1wSL5 = parcelRequire("1wSL5");

var $dTuzq = parcelRequire("dTuzq");

var $iIVKJ = parcelRequire("iIVKJ");

var $aR3AP = parcelRequire("aR3AP");

var $9TQfG = parcelRequire("9TQfG");

var $80lma = parcelRequire("80lma");

var $cBhUq = parcelRequire("cBhUq");

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $df32ecb546415fd9$export$47a2da616e55e8e9(slot) {
    return (0, $5xHgF.default)("MuiAppBar", slot);
}
const $df32ecb546415fd9$var$appBarClasses = (0, $eFHYA.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $df32ecb546415fd9$export$2e2bcd8739ae039 = $df32ecb546415fd9$var$appBarClasses;



var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $f4904cfaf2c34ee2$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $9TQfG.default)(color)}`,
            `position${(0, $9TQfG.default)(position)}`
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $df32ecb546415fd9$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $f4904cfaf2c34ee2$var$joinVars = (var1, var2)=>var1 ? `${var1 === null || var1 === void 0 ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $f4904cfaf2c34ee2$var$AppBarRoot = (0, $dTuzq.default)((0, $cBhUq.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $9TQfG.default)(ownerState.position)}`],
            styles[`color${(0, $9TQfG.default)(ownerState.color)}`]
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: "fixed"
                },
                style: {
                    position: "fixed",
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: "auto",
                    right: 0,
                    "@media print": {
                        // Prevent the app bar to be visible on each printed page.
                        position: "absolute"
                    }
                }
            },
            {
                props: {
                    position: "absolute"
                },
                style: {
                    position: "absolute",
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: "auto",
                    right: 0
                }
            },
            {
                props: {
                    position: "sticky"
                },
                style: {
                    position: "sticky",
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: "auto",
                    right: 0
                }
            },
            {
                props: {
                    position: "static"
                },
                style: {
                    position: "static"
                }
            },
            {
                props: {
                    position: "relative"
                },
                style: {
                    position: "relative"
                }
            },
            {
                props: {
                    color: "inherit"
                },
                style: {
                    "--AppBar-color": "inherit"
                }
            },
            {
                props: {
                    color: "default"
                },
                style: {
                    "--AppBar-background": theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    "--AppBar-color": theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles("dark", {
                        "--AppBar-background": theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        "--AppBar-color": theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)([
                "contrastText"
            ])).map(([color])=>{
                var _theme_vars, _theme_vars1;
                return {
                    props: {
                        color: color
                    },
                    style: {
                        "--AppBar-background": ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette[color].main,
                        "--AppBar-color": ((_theme_vars1 = theme.vars) !== null && _theme_vars1 !== void 0 ? _theme_vars1 : theme).palette[color].contrastText
                    }
                };
            }),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        "inherit",
                        "transparent"
                    ].includes(props.color),
                style: {
                    backgroundColor: "var(--AppBar-background)",
                    color: "var(--AppBar-color)"
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        "inherit",
                        "transparent"
                    ].includes(props.color),
                style: {
                    backgroundColor: "var(--AppBar-background)",
                    color: "var(--AppBar-color)",
                    ...theme.applyStyles("dark", {
                        backgroundColor: theme.vars ? $f4904cfaf2c34ee2$var$joinVars(theme.vars.palette.AppBar.darkBg, "var(--AppBar-background)") : null,
                        color: theme.vars ? $f4904cfaf2c34ee2$var$joinVars(theme.vars.palette.AppBar.darkColor, "var(--AppBar-color)") : null
                    })
                }
            },
            {
                props: {
                    color: "transparent"
                },
                style: {
                    "--AppBar-background": "transparent",
                    "--AppBar-color": "inherit",
                    backgroundColor: "var(--AppBar-background)",
                    color: "var(--AppBar-color)",
                    ...theme.applyStyles("dark", {
                        backgroundImage: "none"
                    })
                }
            }
        ]
    })));
const $f4904cfaf2c34ee2$var$AppBar = /*#__PURE__*/ $dgG1Y.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $f4904cfaf2c34ee2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($f4904cfaf2c34ee2$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $8MGTi.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref,
        ...other
    });
});
var $f4904cfaf2c34ee2$export$2e2bcd8739ae039 = $f4904cfaf2c34ee2$var$AppBar;


var $4sMUg = parcelRequire("4sMUg");
var $lBH8Z = parcelRequire("lBH8Z");
var $4VA2s = parcelRequire("4VA2s");
var $iAs39 = parcelRequire("iAs39");
var $2MkBK = parcelRequire("2MkBK");

var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $f1f83fa3f8c4800f$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2M11 16l4-4-4-4v3H1v2h10z"
}), "Input");


var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $bc7874760461f514$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu");


var $4OQMF = parcelRequire("4OQMF");

var $fR5Jw = parcelRequire("fR5Jw");
"use client";
var $1a4a11bca2919b55$export$2e2bcd8739ae039 = (0, $4OQMF.default)(/*#__PURE__*/ (0, $fR5Jw.jsx)("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2m6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5z"
}), "NotificationsOutlined");



var $kngbJ = parcelRequire("kngbJ");

var $6xSIW = parcelRequire("6xSIW");

var $kqcrq = parcelRequire("kqcrq");

var $cVxYB = parcelRequire("cVxYB");

var $en0cX = parcelRequire("en0cX");

var $mtiuV = parcelRequire("mtiuV");

const $0657ae7bc35c58df$var$Topbar = (props)=>{
    const { className: className, onSidebarOpen: onSidebarOpen, ...rest } = props;
    const [anchor, setAnchor] = (0, $dgG1Y.useState)(null);
    const { notifications: notifications, auth: auth, isLoading: isLoading, error: error, clearError: clearError } = (0, $mtiuV.useNotifications)();
    const theme = (0, $kngbJ.default)();
    const isMediumScreen = (0, $6xSIW.default)(theme.breakpoints.up("md"));
    const [topbarNotifications, setTopbarNotifications] = (0, $dgG1Y.useState)([]);
    const logoutHandler = (event)=>{
        event.preventDefault();
        auth.logout();
    };
    const showNotifications = (event)=>setAnchor(event.currentTarget);
    const handleClose = ()=>setAnchor(null);
    const onNotificationRead = (newNotifications)=>{
        setTopbarNotifications(newNotifications);
    };
    (0, $dgG1Y.useEffect)(()=>{
        setTopbarNotifications(notifications);
    }, [
        notifications
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Creating Team Member",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $iAs39.default), {
                open: Boolean(anchor),
                anchorEl: anchor,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                sx: {
                    "& .MuiPopover-paper": {
                        width: "100%",
                        maxWidth: 600,
                        maxHeight: "90vh",
                        overflowY: "auto",
                        [theme.breakpoints.down("sm")]: {
                            maxWidth: "95%"
                        }
                    }
                },
                slotProps: {
                    paper: {
                        style: {
                            marginTop: 8
                        }
                    }
                },
                marginThreshold: 0,
                disableScrollLock: true,
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kqcrq.default), {
                    notifications: topbarNotifications,
                    auth: auth,
                    onNotificationRead: onNotificationRead
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f4904cfaf2c34ee2$export$2e2bcd8739ae039), {
                ...rest,
                sx: {
                    boxShadow: "none"
                },
                children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $2MkBK.default), {
                    children: [
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kunpB.Link), {
                            to: "/",
                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
                                component: "img",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6f13ade8f385c770$exports))),
                                alt: "Logo",
                                sx: {
                                    height: 60
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $lBH8Z.default), {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        isMediumScreen ? /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $lBH8Z.default), {
                            sx: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4VA2s.default), {
                                    sx: {
                                        marginLeft: theme.spacing(2),
                                        color: "white"
                                    },
                                    onClick: showNotifications,
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4sMUg.default), {
                                        badgeContent: topbarNotifications.length,
                                        color: "error",
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1a4a11bca2919b55$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4VA2s.default), {
                                    color: "inherit",
                                    onClick: logoutHandler,
                                    sx: {
                                        marginLeft: theme.spacing(2),
                                        color: "white"
                                    },
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $f1f83fa3f8c4800f$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4VA2s.default), {
                            sx: {
                                marginLeft: theme.spacing(2),
                                color: "white"
                            },
                            onClick: onSidebarOpen,
                            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $bc7874760461f514$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        ]
    });
};
var $0657ae7bc35c58df$export$2e2bcd8739ae039 = $0657ae7bc35c58df$var$Topbar;


const $0bb6679a27de4034$var$Main = (props)=>{
    const { children: children } = props;
    const theme = (0, $kngbJ.default)();
    const isMediumScreen = (0, $6xSIW.default)(theme.breakpoints.up("md"));
    const [openSidebar, setOpenSidebar] = (0, $dgG1Y.useState)(false);
    const handleSidebarOpen = ()=>{
        setOpenSidebar(true);
    };
    const handleSidebarClose = ()=>{
        setOpenSidebar(false);
    };
    const shouldOpenSidebar = isMediumScreen ? true : openSidebar;
    const styles = {
        root: {
            paddingTop: isMediumScreen ? 64 : 56,
            height: "100%"
        },
        shiftContent: {
            paddingLeft: 240
        },
        content: {
            height: "100%"
        }
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        style: {
            ...styles.root,
            ...isMediumScreen ? styles.shiftContent : {}
        },
        className: (0, $cXVHi.default)({
            root: true,
            shiftContent: isMediumScreen
        }),
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0657ae7bc35c58df$export$2e2bcd8739ae039), {
                onSidebarOpen: handleSidebarOpen
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $630ae7654710b908$export$2e2bcd8739ae039), {
                onClose: handleSidebarClose,
                open: shouldOpenSidebar,
                variant: isMediumScreen ? "persistent" : "temporary",
                tenantname: props.tenantname
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)("main", {
                style: styles.content,
                children: [
                    children,
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2754b08c9e4e10c8$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $0bb6679a27de4034$export$2e2bcd8739ae039 = $0bb6679a27de4034$var$Main;



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");
var $fOZMN = parcelRequire("fOZMN");

var $h2Xtr = parcelRequire("h2Xtr");

var $4m0VC = parcelRequire("4m0VC");
var $9alxb = parcelRequire("9alxb");
var $7p6xb = parcelRequire("7p6xb");
var $gJFkA = parcelRequire("gJFkA");
var $2aFzn = parcelRequire("2aFzn");
var $hgbGA = parcelRequire("hgbGA");
var $1QHfa = parcelRequire("1QHfa");

var $dgG1Y = parcelRequire("dgG1Y");


var $8MGTi = parcelRequire("8MGTi");

var $kqewD = parcelRequire("kqewD");


var $1wSL5 = parcelRequire("1wSL5");

var $69eGa = parcelRequire("69eGa");

var $9TQfG = parcelRequire("9TQfG");

var $dTuzq = parcelRequire("dTuzq");
var $kngbJ = parcelRequire("kngbJ");

var $iIVKJ = parcelRequire("iIVKJ");

var $80lma = parcelRequire("80lma");

var $aR3AP = parcelRequire("aR3AP");

var $kMmDg = parcelRequire("kMmDg");

var $eFHYA = parcelRequire("eFHYA");

var $5xHgF = parcelRequire("5xHgF");
function $934155f7a9807c38$export$d6efab9620b78fec(slot) {
    return (0, $5xHgF.default)("MuiLink", slot);
}
const $934155f7a9807c38$var$linkClasses = (0, $eFHYA.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $934155f7a9807c38$export$2e2bcd8739ae039 = $934155f7a9807c38$var$linkClasses;



var $fY2z8 = parcelRequire("fY2z8");

var $kqewD = parcelRequire("kqewD");
const $c0cabbdee32e3167$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    const color = (0, $fY2z8.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $fY2z8.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kqewD.alpha)(color, 0.4);
};
var $c0cabbdee32e3167$export$2e2bcd8739ae039 = $c0cabbdee32e3167$var$getTextDecoration;



var $fR5Jw = parcelRequire("fR5Jw");
"use client";
const $c5a4424246730174$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $c5a4424246730174$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $9TQfG.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $1wSL5.default)(slots, (0, $934155f7a9807c38$export$d6efab9620b78fec), classes);
};
const $c5a4424246730174$var$LinkRoot = (0, $dTuzq.default)((0, $kMmDg.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $9TQfG.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})((0, $iIVKJ.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: "none"
                },
                style: {
                    textDecoration: "none"
                }
            },
            {
                props: {
                    underline: "hover"
                },
                style: {
                    textDecoration: "none",
                    "&:hover": {
                        textDecoration: "underline"
                    }
                }
            },
            {
                props: {
                    underline: "always"
                },
                style: {
                    textDecoration: "underline",
                    "&:hover": {
                        textDecorationColor: "inherit"
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === "always" && ownerState.color !== "inherit",
                style: {
                    textDecorationColor: "var(--Link-underlineColor)"
                }
            },
            ...Object.entries(theme.palette).filter((0, $80lma.default)()).map(([color])=>({
                    props: {
                        underline: "always",
                        color: color
                    },
                    style: {
                        "--Link-underlineColor": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.4)` : (0, $kqewD.alpha)(theme.palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: "always",
                    color: "textPrimary"
                },
                style: {
                    "--Link-underlineColor": theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kqewD.alpha)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: "always",
                    color: "textSecondary"
                },
                style: {
                    "--Link-underlineColor": theme.vars ? `rgba(${theme.vars.palette.text.secondaryChannel} / 0.4)` : (0, $kqewD.alpha)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: "always",
                    color: "textDisabled"
                },
                style: {
                    "--Link-underlineColor": (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: "button"
                },
                style: {
                    position: "relative",
                    WebkitTapHighlightColor: "transparent",
                    backgroundColor: "transparent",
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    MozAppearance: "none",
                    // Reset
                    WebkitAppearance: "none",
                    // Reset
                    "&::-moz-focus-inner": {
                        borderStyle: "none" // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $934155f7a9807c38$export$2e2bcd8739ae039).focusVisible}`]: {
                        outline: "auto"
                    }
                }
            }
        ]
    };
}));
const $c5a4424246730174$var$Link = /*#__PURE__*/ $dgG1Y.forwardRef(function Link(inProps, ref) {
    const props = (0, $aR3AP.useDefaultProps)({
        props: inProps,
        name: "MuiLink"
    });
    const theme = (0, $kngbJ.default)();
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $dgG1Y.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $69eGa.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $69eGa.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $c5a4424246730174$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)($c5a4424246730174$var$LinkRoot, {
        color: color,
        className: (0, $8MGTi.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$c5a4424246730174$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === "always" && color !== "inherit" && !$c5a4424246730174$var$v6Colors[color] && {
                "--Link-underlineColor": (0, $c0cabbdee32e3167$export$2e2bcd8739ae039)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $c5a4424246730174$export$2e2bcd8739ae039 = $c5a4424246730174$var$Link;



var $en0cX = parcelRequire("en0cX");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $ewdxp = parcelRequire("ewdxp");

var $jUw8I = parcelRequire("jUw8I");
parcelRequire("bMqk9");
var $4mku7 = parcelRequire("4mku7");
var $cDM9n = parcelRequire("cDM9n");
var $312fb930ff5cd7bd$exports = {};

$312fb930ff5cd7bd$exports = (parcelRequire("28PFx")).getBundleURL("4temp") + "Original.f51eff19.png";



var $htjEL = parcelRequire("htjEL");
const $d92f15fb15445a71$var$schema = {
    firstName: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    lastName: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    phoneNumber: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    email: [
        (0, $htjEL.required),
        (0, $htjEL.email),
        (0, $htjEL.maxLength)(64)
    ],
    password: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(128),
        (0, $htjEL.minLength)(6)
    ],
    policy: [
        (0, $htjEL.required),
        (0, $htjEL.checked)
    ]
};
const $d92f15fb15445a71$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            backgroundColor: theme.palette.background.default,
            height: "100%"
        },
        grid: {
            height: "100%"
        },
        quoteContainer: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        quote: {
            backgroundColor: theme.palette.background.light,
            height: "50%",
            display: "flex",
            justifyContent: "top",
            alignItems: "top",
            backgroundImage: `url(${0, (/*@__PURE__*/$parcel$interopDefault($312fb930ff5cd7bd$exports))})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top"
        },
        quoteInner: {
            textAlign: "center",
            flexBasis: "100%",
            backgroundColor: theme.palette.background.light,
            height: "50%"
        },
        quoteText: {
            color: theme.palette.primary,
            fontWeight: 300,
            backgroundColor: theme.palette.background.light,
            marginLeft: "10px",
            marginRight: "10px"
        },
        name: {
            marginTop: theme.spacing(3),
            color: theme.palette.white
        },
        bio: {
            color: theme.palette.white
        },
        contentContainer: {},
        content: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        contentHeader: {
            display: "flex",
            alignItems: "center",
            paddingTop: theme.spacing(5),
            paddingBototm: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        logoImage: {
            marginLeft: theme.spacing(4)
        },
        contentBody: {
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
                justifyContent: "center"
            }
        },
        form: {
            paddingLeft: 100,
            paddingRight: 100,
            paddingBottom: 125,
            flexBasis: 700,
            [theme.breakpoints.down("sm")]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2)
            }
        },
        title: {
            marginTop: theme.spacing(3)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        policy: {
            marginTop: theme.spacing(1),
            display: "flex",
            alignItems: "center"
        },
        policyCheckbox: {
            marginLeft: "-14px"
        },
        signUpButton: {
            margin: theme.spacing(2, 0)
        }
    }));
const $d92f15fb15445a71$var$SignUp = ()=>{
    const navigate = (0, $fOZMN.useNavigate)();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    if (auth.isLoggedIn) auth.logout();
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $d92f15fb15445a71$var$useStyles();
    const { hasError: hasError, handleChange: handleChange, formState: formState } = (0, $jUw8I.useForm)($d92f15fb15445a71$var$schema);
    const handleBack = ()=>{
        navigate(-1);
    };
    const handleSignUp = async (event)=>{
        event.preventDefault();
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/users/signup", "POST", JSON.stringify({
                firstName: formState.values.firstName,
                lastName: formState.values.lastName,
                phoneNumber: formState.values.phoneNumber,
                email: formState.values.email,
                password: formState.values.password
            }), {
                "Content-Type": "application/json"
            });
            console.log(responseData.userId);
            if (responseData.token) {
                auth.login(responseData.userId, responseData.email, responseData.tenant, responseData.token, null, true, responseData.status);
                navigate("/dashboard");
            }
        } catch (err) {
            console.log(err);
        }
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Logging In",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                className: classes.grid,
                container: true,
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                        className: classes.quoteContainer,
                        item: true,
                        lg: 5,
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                className: classes.quote
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                className: classes.quoteInner,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h3",
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("b", {
                                            children: "Congratulations on taking this step in your recovery"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h4",
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("b", {
                                            children: "You're in good company"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h5",
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("i", {
                                                children: '"I can\u2019t say enough positive things about Accountable! They have been super supportive in helping me transition back into life at home after my inpatient treatment. They are always there if I need to talk or need advice. They help me set weekly goals for therapy, meetings and workouts and hold me to it. I highly recommend using Accountable!"'
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            "-Sal B.",
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("i", {
                                                children: "\"Thank you so much for believing and supporting me! I would have NEVER EVER made it this far without you and this amazing program! There will be harder times and I'm sure lots of tears in my future but I'm more excited and positive that I can do it and am worth it....then I ever ever thought I'd be ever! Thank you Accountable!\""
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            "-Elisabeth D."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        className: classes.content,
                        item: true,
                        lg: 7,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                            className: classes.content,
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                    className: classes.contentHeader,
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2aFzn.default), {
                                        onClick: handleBack
                                    })
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                    className: classes.contentBody,
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("form", {
                                        className: classes.form,
                                        onSubmit: handleSignUp,
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                className: classes.title,
                                                variant: "h2",
                                                gutterBottom: true,
                                                children: "Welcome to Accountable"
                                            }),
                                            !window.myMessenger && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                gutterBottom: true,
                                                variant: "h5",
                                                children: "Sign up with Facebook or Google"
                                            }),
                                            !window.myMessenger && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                                className: classes.socialButtons,
                                                container: true,
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                            color: "secondary",
                                                            href: "https://apiv2.youareaccountable.com/api/users/fb/auth",
                                                            size: "large",
                                                            variant: "contained",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4mku7.default), {
                                                                    className: classes.socialIcon
                                                                }),
                                                                "Sign up with Facebook"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                            href: "https://apiv2.youareaccountable.com/api/users/google/auth",
                                                            size: "large",
                                                            variant: "contained",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cDM9n.default), {
                                                                    className: classes.socialIcon
                                                                }),
                                                                "Sign up with Google"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                                style: {
                                                    paddingTop: "12px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                        color: "textSecondary",
                                                        variant: "h5",
                                                        gutterBottom: true,
                                                        children: "If you are a GEHA Client, sign up here"
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                        color: "primary",
                                                        size: "large",
                                                        fullWidth: true,
                                                        variant: "contained",
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $c5a4424246730174$export$2e2bcd8739ae039), {
                                                            color: "inherit",
                                                            component: (0, $kunpB.Link),
                                                            to: "/insurance",
                                                            variant: "h6",
                                                            children: "GEHA Client Sign Up"
                                                        })
                                                    })
                                                ]
                                            }),
                                            !window.myMessenger && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                gutterBottom: true,
                                                variant: "h5",
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                                    "Or use your email to create new account"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("firstName"),
                                                fullWidth: true,
                                                helperText: hasError("firstName") ? formState.errors.firstName[0] : null,
                                                label: "First name",
                                                name: "firstName",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.firstName || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("lastName"),
                                                fullWidth: true,
                                                helperText: hasError("lastName") ? formState.errors.lastName[0] : null,
                                                label: "Last name",
                                                name: "lastName",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.lastName || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("phoneNumber"),
                                                fullWidth: true,
                                                helperText: hasError("phoneNumber") ? formState.errors.phoneNumber[0] : null,
                                                label: "Phone Number",
                                                name: "phoneNumber",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.phoneNumber || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("email"),
                                                fullWidth: true,
                                                helperText: hasError("email") ? formState.errors.email[0] : null,
                                                label: "Email address",
                                                name: "email",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.email || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("password"),
                                                fullWidth: true,
                                                helperText: hasError("password") ? formState.errors.password[0] : null,
                                                label: "Password",
                                                name: "password",
                                                onChange: handleChange,
                                                type: "password",
                                                value: formState.values.password || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                                className: classes.policy,
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                                        checked: formState.values.policy || false,
                                                        className: classes.policyCheckbox,
                                                        color: "primary",
                                                        name: "policy",
                                                        onChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                        className: classes.policyText,
                                                        color: "textSecondary",
                                                        variant: "body1",
                                                        children: [
                                                            "I have read the",
                                                            " ",
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $c5a4424246730174$export$2e2bcd8739ae039), {
                                                                color: "primary",
                                                                component: (0, $kunpB.Link),
                                                                to: "/terms",
                                                                underline: "always",
                                                                variant: "h6",
                                                                children: "Terms and Conditions"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            hasError("policy") && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7p6xb.default), {
                                                error: true,
                                                children: formState.errors.policy[0]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                className: classes.signUpButton,
                                                color: "primary",
                                                disabled: !formState.isValid,
                                                fullWidth: true,
                                                size: "large",
                                                type: "submit",
                                                variant: "contained",
                                                children: "Sign up now"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                variant: "body1",
                                                children: [
                                                    "Have an account?",
                                                    " ",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $c5a4424246730174$export$2e2bcd8739ae039), {
                                                        component: (0, $kunpB.Link),
                                                        to: "/sign-in",
                                                        variant: "h6",
                                                        children: "Sign in"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $d92f15fb15445a71$export$2e2bcd8739ae039 = $d92f15fb15445a71$var$SignUp;



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");
var $fOZMN = parcelRequire("fOZMN");

var $56aO2 = parcelRequire("56aO2");

var $h2Xtr = parcelRequire("h2Xtr");

var $4m0VC = parcelRequire("4m0VC");
var $gJFkA = parcelRequire("gJFkA");
var $a4HP0 = parcelRequire("a4HP0");
var $hgbGA = parcelRequire("hgbGA");
var $1QHfa = parcelRequire("1QHfa");

var $en0cX = parcelRequire("en0cX");

var $cVxYB = parcelRequire("cVxYB");
parcelRequire("bMqk9");
var $ierCi = parcelRequire("ierCi");
var $4mku7 = parcelRequire("4mku7");
var $cDM9n = parcelRequire("cDM9n");

var $ewdxp = parcelRequire("ewdxp");

var $fuS1D = parcelRequire("fuS1D");

var $jUw8I = parcelRequire("jUw8I");


var $htjEL = parcelRequire("htjEL");
const $ffe991997516fca7$var$schema = {
    email: [
        (0, $htjEL.required),
        (0, $htjEL.email),
        (0, $htjEL.maxLength)(64)
    ],
    password: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(128)
    ]
};
const $ffe991997516fca7$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            backgroundColor: theme.palette.background.default,
            height: "100%"
        },
        grid: {
            height: "100%"
        },
        quoteContainer: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        quote: {
            backgroundColor: theme.palette.background.light,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${0, (/*@__PURE__*/$parcel$interopDefault($312fb930ff5cd7bd$exports))})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center"
        },
        quoteInner: {
            textAlign: "center",
            flexBasis: "600px"
        },
        quoteText: {
            color: theme.palette.primary,
            fontWeight: 300,
            marginTop: theme.spacing(90)
        },
        name: {
            marginTop: theme.spacing(3),
            color: theme.palette.white
        },
        bio: {
            color: theme.palette.white
        },
        contentContainer: {},
        content: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        contentHeader: {
            display: "flex",
            alignItems: "center",
            paddingTop: theme.spacing(5),
            paddingBototm: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        logoImage: {
            marginLeft: theme.spacing(4)
        },
        contentBody: {
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
                justifyContent: "center"
            }
        },
        form: {
            paddingLeft: 100,
            paddingRight: 75,
            paddingBottom: 125,
            flexBasis: 700,
            [theme.breakpoints.down("sm")]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2)
            }
        },
        title: {
            marginTop: theme.spacing(3)
        },
        socialButtons: {
            marginTop: theme.spacing(3)
        },
        socialIcon: {
            marginRight: theme.spacing(1)
        },
        sugestion: {
            marginTop: theme.spacing(2)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        signInButton: {
            margin: theme.spacing(2, 0)
        }
    }));
const $ffe991997516fca7$var$SignIn = ()=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    if (auth.isLoggedIn) auth.logout();
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $ffe991997516fca7$var$useStyles();
    const { hasError: hasError, handleChange: handleChange, formState: formState } = (0, $jUw8I.useForm)($ffe991997516fca7$var$schema);
    const [providerLogin, setProviderLogin] = (0, $dgG1Y.useState)(false);
    const [emailVal, setEmailVal] = (0, $dgG1Y.useState)();
    const navigate = (0, $fOZMN.useNavigate)();
    const location = (0, $fOZMN.useLocation)();
    const { confirmEmail: confirmEmail, clearConfirmEmail: clearConfirmEmail } = (0, $fuS1D.useConfirmEmail)();
    (0, $dgG1Y.useEffect)(()=>{
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get("prov")) setProviderLogin(true);
        if (searchParams.get("email")) setEmailVal(searchParams.get("email"));
    }, [
        location.search
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        if (emailVal) {
            const email = document.querySelector("input[name='email']");
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
            nativeInputValueSetter.call(email, "is working");
            const inputEvent = new Event("input", {
                bubbles: true
            });
            email.dispatchEvent(inputEvent);
        }
    }, [
        emailVal
    ]);
    const handleSignIn = async (event)=>{
        event.preventDefault();
        const redirectPath = new URLSearchParams(location.search).get("redirect");
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/users/login", "POST", JSON.stringify({
                email: formState.values.email,
                password: formState.values.password
            }), {
                "Content-Type": "application/json"
            });
            console.log(responseData.userId);
            if (responseData.token) {
                auth.login(responseData.userId, responseData.email, responseData.tenant, responseData.token, null, true, responseData.status, responseData.accountableAdmin, responseData.siteAdmin, responseData.harambe, responseData.program, responseData.provider, responseData.programProvider, responseData.supervisor);
                if (redirectPath) navigate(`/${redirectPath}`);
                else navigate("/");
            }
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            confirmEmail && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!confirmEmail,
                title: "Email Confirmation",
                alert: confirmEmail,
                clearError: clearConfirmEmail
            }),
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Signing Up",
                alert: error,
                clearError: clearError
            }),
            auth.error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!auth.error,
                title: "Error Signing Up",
                alert: auth.error,
                clearError: auth.clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                className: classes.grid,
                container: true,
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        className: classes.quoteContainer,
                        item: true,
                        lg: 5,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                            className: classes.quote,
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                className: classes.quoteInner,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h1"
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                        className: classes.person,
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                className: classes.name,
                                                variant: "body1"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                className: classes.bio,
                                                variant: "body2"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        className: classes.content,
                        item: true,
                        lg: 7,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                            className: classes.content,
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                    className: classes.contentHeader
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                    className: classes.contentBody,
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("form", {
                                        className: classes.form,
                                        onSubmit: handleSignIn,
                                        children: [
                                            !providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                className: classes.title,
                                                variant: "h2",
                                                children: "Sign in"
                                            }),
                                            providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                className: classes.title,
                                                variant: "h2",
                                                children: "Care Team Member Sign in"
                                            }),
                                            providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                gutterBottom: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                                    " Sign in with your email address, or",
                                                    " ",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a4HP0.default), {
                                                        component: (0, $kunpB.Link),
                                                        to: "/ForgotPassword",
                                                        variant: "h6",
                                                        children: "Reset Your Password"
                                                    })
                                                ]
                                            }),
                                            !providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                gutterBottom: true,
                                                children: "Sign in with Facebook or Google"
                                            }),
                                            !providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                                                className: classes.socialButtons,
                                                container: true,
                                                spacing: 2,
                                                justify: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                            color: "secondary",
                                                            href: "https://apiv2.youareaccountable.com/api/users/fb/auth",
                                                            size: "large",
                                                            variant: "contained",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4mku7.default), {
                                                                    className: classes.socialIcon
                                                                }),
                                                                "Login with Facebook"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                            href: "https://apiv2.youareaccountable.com/api/users/google/auth",
                                                            size: "large",
                                                            variant: "contained",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cDM9n.default), {
                                                                    className: classes.socialIcon
                                                                }),
                                                                "Login with Google"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $4m0VC.default), {
                                                            style: {
                                                                background: "black",
                                                                color: "white"
                                                            },
                                                            href: "https://apiv2.youareaccountable.com/api/users/apple/auth",
                                                            size: "large",
                                                            variant: "contained",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $ierCi.default), {
                                                                    className: classes.socialIcon
                                                                }),
                                                                "Login with Apple"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            !providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                align: "center",
                                                className: classes.sugestion,
                                                color: "textSecondary",
                                                variant: "body1",
                                                children: "or login with your email address"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("email"),
                                                fullWidth: true,
                                                helperText: hasError("email") ? formState.errors.email[0] : null,
                                                label: "Email address",
                                                name: "email",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.email || emailVal || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("password"),
                                                fullWidth: true,
                                                helperText: hasError("password") ? formState.errors.password[0] : null,
                                                label: "Password",
                                                name: "password",
                                                onChange: handleChange,
                                                type: "password",
                                                value: formState.values.password || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                className: classes.signInButton,
                                                color: "primary",
                                                disabled: !formState.isValid,
                                                fullWidth: true,
                                                size: "large",
                                                type: "submit",
                                                variant: "contained",
                                                children: "Sign in now"
                                            }),
                                            !providerLogin && /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                variant: "body1",
                                                children: [
                                                    "Don't have an account?",
                                                    " ",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a4HP0.default), {
                                                        component: (0, $kunpB.Link),
                                                        to: "/sign-up",
                                                        variant: "h6",
                                                        children: "Sign up"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                variant: "body1",
                                                children: [
                                                    " ",
                                                    "Forgot your password?",
                                                    " ",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a4HP0.default), {
                                                        component: (0, $kunpB.Link),
                                                        to: "/ForgotPassword",
                                                        variant: "h6",
                                                        children: "Reset Password"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $ffe991997516fca7$export$2e2bcd8739ae039 = $ffe991997516fca7$var$SignIn;



var $fR5Jw = parcelRequire("fR5Jw");

var $dgG1Y = parcelRequire("dgG1Y");

var $kunpB = parcelRequire("kunpB");
var $fOZMN = parcelRequire("fOZMN");

var $h2Xtr = parcelRequire("h2Xtr");

var $4m0VC = parcelRequire("4m0VC");
var $9alxb = parcelRequire("9alxb");
var $7p6xb = parcelRequire("7p6xb");
var $gJFkA = parcelRequire("gJFkA");
var $2aFzn = parcelRequire("2aFzn");
var $a4HP0 = parcelRequire("a4HP0");
var $hgbGA = parcelRequire("hgbGA");
var $1QHfa = parcelRequire("1QHfa");

var $en0cX = parcelRequire("en0cX");

var $cVxYB = parcelRequire("cVxYB");

var $56aO2 = parcelRequire("56aO2");

var $ewdxp = parcelRequire("ewdxp");

var $jUw8I = parcelRequire("jUw8I");


var $htjEL = parcelRequire("htjEL");
const $c98c099519c83d2a$var$schema = {
    firstName: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    lastName: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    company: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    phoneNumber: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(32)
    ],
    email: [
        (0, $htjEL.required),
        (0, $htjEL.email),
        (0, $htjEL.maxLength)(64)
    ],
    password: [
        (0, $htjEL.required),
        (0, $htjEL.maxLength)(128),
        (0, $htjEL.minLength)(6)
    ],
    policy: [
        (0, $htjEL.required),
        (0, $htjEL.checked)
    ]
};
const $c98c099519c83d2a$var$useStyles = (0, $h2Xtr.default)((theme)=>({
        root: {
            backgroundColor: theme.palette.background.default,
            height: "100%"
        },
        grid: {
            height: "100%"
        },
        quoteContainer: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        quote: {
            backgroundColor: theme.palette.background.light,
            height: "50%",
            display: "flex",
            justifyContent: "top",
            alignItems: "top",
            backgroundImage: `url(${0, (/*@__PURE__*/$parcel$interopDefault($312fb930ff5cd7bd$exports))})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top"
        },
        quoteInner: {
            textAlign: "center",
            flexBasis: "100%",
            backgroundColor: theme.palette.background.light,
            height: "50%"
        },
        quoteText: {
            color: theme.palette.primary,
            fontWeight: 300,
            backgroundColor: theme.palette.background.light,
            marginLeft: "10px",
            marginRight: "10px"
        },
        name: {
            marginTop: theme.spacing(3),
            color: theme.palette.white
        },
        bio: {
            color: theme.palette.white
        },
        contentContainer: {},
        content: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        contentHeader: {
            display: "flex",
            alignItems: "center",
            paddingTop: theme.spacing(5),
            paddingBototm: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        logoImage: {
            marginLeft: theme.spacing(4)
        },
        contentBody: {
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
                justifyContent: "center"
            }
        },
        form: {
            paddingLeft: 100,
            paddingRight: 100,
            paddingBottom: 125,
            flexBasis: 700,
            [theme.breakpoints.down("sm")]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2)
            }
        },
        title: {
            marginTop: theme.spacing(3)
        },
        textField: {
            marginTop: theme.spacing(2)
        },
        policy: {
            marginTop: theme.spacing(1),
            display: "flex",
            alignItems: "center"
        },
        policyCheckbox: {
            marginLeft: "-14px"
        },
        signUpButton: {
            margin: theme.spacing(2, 0)
        }
    }));
const $c98c099519c83d2a$var$ProgramSignUp = ()=>{
    const navigate = (0, $fOZMN.useNavigate)();
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    if (auth.isLoggedIn) auth.logout();
    const { isLoading: isLoading, error: error, sendRequest: sendRequest, clearError: clearError } = (0, $56aO2.useHttpClient)();
    const classes = $c98c099519c83d2a$var$useStyles();
    const { hasError: hasError, handleChange: handleChange, formState: formState } = (0, $jUw8I.useForm)($c98c099519c83d2a$var$schema);
    const handleBack = ()=>{
        navigate(-1);
    };
    const handleSignUp = async (event)=>{
        event.preventDefault();
        try {
            const responseData = await sendRequest("https://apiv2.youareaccountable.com/api/users/signup", "POST", JSON.stringify({
                firstName: formState.values.firstName,
                lastName: formState.values.lastName,
                phoneNumber: formState.values.phoneNumber,
                email: formState.values.email,
                password: formState.values.password,
                treatmentProgram: true,
                company: formState.values.company
            }), {
                "Content-Type": "application/json"
            });
            if (responseData.token) {
                auth.login(responseData.userId, responseData.email, responseData.tenant, responseData.token, null, true, responseData.status, false, false, false, true, true, false);
                navigate("/dashboard");
            }
        } catch (err) {
            console.log(err);
        }
    };
    return /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
        className: classes.root,
        children: [
            error && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $en0cX.default), {
                open: !!error,
                title: "Error Logging In",
                alert: error,
                clearError: clearError
            }),
            isLoading && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                open: isLoading
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                className: classes.grid,
                container: true,
                children: [
                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $gJFkA.default), {
                        className: classes.quoteContainer,
                        item: true,
                        lg: 5,
                        children: [
                            /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                className: classes.quote
                            }),
                            /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                className: classes.quoteInner,
                                children: [
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h3",
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("b", {
                                            children: "Congratulations on taking this step in your recovery"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h4",
                                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)("b", {
                                            children: "You're in good company"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                        className: classes.quoteText,
                                        variant: "h5",
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("i", {
                                                children: '"I can\u2019t say enough positive things about Accountable! They have been super supportive in helping me transition back into life at home after my inpatient treatment. They are always there if I need to talk or need advice. They help me set weekly goals for therapy, meetings and workouts and hold me to it. I highly recommend using Accountable!"'
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            "-Sal B.",
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("i", {
                                                children: "\"Thank you so much for believing and supporting me! I would have NEVER EVER made it this far without you and this amazing program! There will be harder times and I'm sure lots of tears in my future but I'm more excited and positive that I can do it and am worth it....then I ever ever thought I'd be ever! Thank you Accountable!\""
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)("br", {}),
                                            "-Elisabeth D."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $gJFkA.default), {
                        className: classes.content,
                        item: true,
                        lg: 7,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                            className: classes.content,
                            children: [
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                    className: classes.contentHeader,
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $2aFzn.default), {
                                        onClick: handleBack
                                    })
                                }),
                                /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
                                    className: classes.contentBody,
                                    children: /*#__PURE__*/ (0, $fR5Jw.jsxs)("form", {
                                        className: classes.form,
                                        onSubmit: handleSignUp,
                                        children: [
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $1QHfa.default), {
                                                className: classes.title,
                                                variant: "h2",
                                                gutterBottom: true,
                                                children: "Welcome to Accountable's Provider Signup"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("firstName"),
                                                fullWidth: true,
                                                helperText: hasError("firstName") ? formState.errors.firstName[0] : null,
                                                label: "First name",
                                                name: "firstName",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.firstName || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("lastName"),
                                                fullWidth: true,
                                                helperText: hasError("lastName") ? formState.errors.lastName[0] : null,
                                                label: "Last name",
                                                name: "lastName",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.lastName || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("company"),
                                                fullWidth: true,
                                                helperText: hasError("company") ? formState.errors.company[0] : null,
                                                label: "Company",
                                                name: "company",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.company || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("phoneNumber"),
                                                fullWidth: true,
                                                helperText: hasError("phoneNumber") ? formState.errors.phoneNumber[0] : null,
                                                label: "Phone Number",
                                                name: "phoneNumber",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.phoneNumber || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("email"),
                                                fullWidth: true,
                                                helperText: hasError("email") ? formState.errors.email[0] : null,
                                                label: "Email address",
                                                name: "email",
                                                onChange: handleChange,
                                                type: "text",
                                                value: formState.values.email || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $hgbGA.default), {
                                                className: classes.textField,
                                                error: hasError("password"),
                                                fullWidth: true,
                                                helperText: hasError("password") ? formState.errors.password[0] : null,
                                                label: "Password",
                                                name: "password",
                                                onChange: handleChange,
                                                type: "password",
                                                value: formState.values.password || "",
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)("div", {
                                                className: classes.policy,
                                                children: [
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $9alxb.default), {
                                                        checked: formState.values.policy || false,
                                                        className: classes.policyCheckbox,
                                                        color: "primary",
                                                        name: "policy",
                                                        onChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                        className: classes.policyText,
                                                        color: "textSecondary",
                                                        variant: "body1",
                                                        children: [
                                                            "I have read the",
                                                            " ",
                                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a4HP0.default), {
                                                                color: "primary",
                                                                component: (0, $kunpB.Link),
                                                                to: "/programterms",
                                                                underline: "always",
                                                                variant: "h6",
                                                                children: "Terms and Conditions"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            hasError("policy") && /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7p6xb.default), {
                                                error: true,
                                                children: formState.errors.policy[0]
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $4m0VC.default), {
                                                className: classes.signUpButton,
                                                color: "primary",
                                                disabled: !formState.isValid,
                                                fullWidth: true,
                                                size: "large",
                                                type: "submit",
                                                variant: "contained",
                                                children: "Sign up now"
                                            }),
                                            /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $1QHfa.default), {
                                                color: "textSecondary",
                                                variant: "body1",
                                                children: [
                                                    "Have an account?",
                                                    " ",
                                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a4HP0.default), {
                                                        component: (0, $kunpB.Link),
                                                        to: "/sign-in",
                                                        variant: "h6",
                                                        children: "Sign in"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $c98c099519c83d2a$export$2e2bcd8739ae039 = $c98c099519c83d2a$var$ProgramSignUp;



var $ewdxp = parcelRequire("ewdxp");

var $dgG1Y = parcelRequire("dgG1Y");
const $08ddcaf23b3e3aef$var$ExternalRedirect = ({ to: to })=>{
    (0, $dgG1Y.useEffect)(()=>{
        window.location.href = to;
    }, [
        to
    ]);
    return null;
};
var $08ddcaf23b3e3aef$export$2e2bcd8739ae039 = $08ddcaf23b3e3aef$var$ExternalRedirect;



const $7d9f2f555e26cb24$var$Dashboard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("45PbL"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$ForgotPassword = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("7Yk0H"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$ResetPassword = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5ITwD"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$Account = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("1CSMF"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$Onboarding = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("fDNgw"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$Tox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>Promise.resolve((parcelRequire("fD19N")))); // lazy load code splitting

const $7d9f2f555e26cb24$var$AdminPortal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("cbMg5"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$Goal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("eVXD0"))); // lazy load code splitting

const $7d9f2f555e26cb24$var$Users = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5OcDX")));

const $7d9f2f555e26cb24$var$UserDetails = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("9T8C5")));

const $7d9f2f555e26cb24$var$SafetyPlan = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5QJam")));

const $7d9f2f555e26cb24$var$Sms = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>Promise.resolve((parcelRequire("EDk0j"))));

const $7d9f2f555e26cb24$var$ScheduleMessages = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("7TO1B")));

const $7d9f2f555e26cb24$var$CreateSurvey = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("jspsi")));

const $7d9f2f555e26cb24$var$SurveyForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("3tbI5")));

const $7d9f2f555e26cb24$var$GoalSurveyForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("7bwNy")));

const $7d9f2f555e26cb24$var$SurveyResults = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("gLUEm")));

const $7d9f2f555e26cb24$var$VendorAlerts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>Promise.resolve((parcelRequire("6PhUi")))); // lazy load code splitting

const $7d9f2f555e26cb24$var$GoalLibrary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("6C0yF")));

const $7d9f2f555e26cb24$var$MemberReports = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("1ltvV")));

const $7d9f2f555e26cb24$var$InsuranceReports = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("4Ib4t")));

const $7d9f2f555e26cb24$var$SingleInsuranceReport = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("hcMFO")));

const $7d9f2f555e26cb24$var$Audits = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("bMRRC")));

const $7d9f2f555e26cb24$var$CoachAudit = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("4xPO8")));

const $7d9f2f555e26cb24$var$Reinforcement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("eX4Zf")));

const $7d9f2f555e26cb24$var$Analytics = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("f1Bja")));

const $7d9f2f555e26cb24$var$AccountableGPT = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5wi4l")));

const $7d9f2f555e26cb24$var$InsuranceSignUp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("jz3ab")));

const $7d9f2f555e26cb24$var$Kits = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("9Ydz5")));

const $7d9f2f555e26cb24$var$Orders = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("7SSu2")));

const $7d9f2f555e26cb24$var$RekognitionOverview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("4wfaV")));

const $7d9f2f555e26cb24$var$RekognitionFaceSearchJob = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("j15ZB")));

const $7d9f2f555e26cb24$var$ToxReviews = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("iYVvJ")));

const $7d9f2f555e26cb24$var$Invoices = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("f4xh9")));

const $7d9f2f555e26cb24$var$StripeInvoiceDetails = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("lPfTI")));

const $7d9f2f555e26cb24$var$InvoiceDetails = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5AaYp")));

const $7d9f2f555e26cb24$var$UpcomingStripeInvoiceDetails = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("kIkGf")));

const $7d9f2f555e26cb24$var$GehaEligibility = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("kgMqx")));

const $7d9f2f555e26cb24$var$ScheduledTests = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5xXPk")));

const $7d9f2f555e26cb24$var$CheckoutSuccess = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("5CH0J")));

const $7d9f2f555e26cb24$var$Partners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("iQxUW")));

const $7d9f2f555e26cb24$var$AdminTools = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).lazy(()=>(parcelRequire("eyjni")));
const $7d9f2f555e26cb24$var$loggedOutDirects = [
    "sign-in",
    "sign-up",
    "program-sign-up",
    "insurance",
    "ForgotPassword",
    "resetpw",
    "survey",
    "goalsurvey",
    "surveyresults",
    "reinforcement"
];
const $7d9f2f555e26cb24$var$excludedRoutes = [
    "surveyresults",
    "survey",
    "reinforcement",
    "goalsurvey",
    "resetpw"
];
const $7d9f2f555e26cb24$var$AppRoutes = ()=>{
    const auth = (0, $dgG1Y.useContext)((0, $ewdxp.AuthContext));
    let routes;
    const location = (0, $fOZMN.useLocation)();
    const navigate = (0, $fOZMN.useNavigate)();
    const [currentPath, setCurrentPath] = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useState("");
    const { search: search } = location; // confirm email
    const params = new URLSearchParams(search);
    const key = params.get("key");
    const redirect = params.get("redirect");
    let dashboard = "/dashboard";
    if (key) dashboard = `/dashboard?key=${key}`; // send confirmation key to dashboard if logged in.
    let tenantName = "";
    if ((auth.program || auth.programProvider) && auth.tenant) tenantName = auth.tenant;
    else if (auth.provider && auth.email) tenantName = auth.email;
    else if (auth.tenant) tenantName = auth.tenant;
    const setCurrentPathCallback = (0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).useCallback((page)=>{
        setCurrentPath(page);
    }, []);
    (0, $dgG1Y.useEffect)(()=>{
        var _location_pathname;
        const redirectToURL = (page)=>{
            setCurrentPathCallback(page);
            navigate(`/${page}`);
        };
        const newPath = location === null || location === void 0 ? void 0 : (_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.substring(1);
        if (!$7d9f2f555e26cb24$var$excludedRoutes.includes(newPath)) {
            if (!auth.isLoggedIn) {
                if ($7d9f2f555e26cb24$var$loggedOutDirects.includes(newPath)) {
                    if (redirect && redirect !== "") redirectToURL(newPath + "?redirect=" + redirect);
                    else redirectToURL(newPath);
                } else redirectToURL("sign-in?redirect=" + newPath);
            }
            if (auth.isLoggedIn) {
                if (newPath === "sign-in" || newPath === "sign-up" || newPath === "program-sign-up" || newPath === "insurance") redirectToURL("dashboard");
                else if (redirect && !$7d9f2f555e26cb24$var$loggedOutDirects.includes(newPath) && redirect !== "") redirectToURL(redirect);
            }
        }
    }, [
        auth.isLoggedIn,
        currentPath,
        location === null || location === void 0 ? void 0 : location.pathname,
        redirect,
        navigate,
        setCurrentPathCallback
    ]);
    if (auth.stripeStatus && auth.stripeStatus.status === "canceled" && auth.isLoggedIn) routes = /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fOZMN.Routes), {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/account",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: auth.tenant,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Account, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/checkout/success",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$CheckoutSuccess, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Navigate), {
                    to: "/account?billing=true",
                    replace: true
                })
            })
        ]
    });
    else if (auth.isLoggedIn) routes = /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fOZMN.Routes), {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/dashboard",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Dashboard, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/account",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Account, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/tox",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Tox, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/vendoralerts",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$VendorAlerts, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/goal",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Goal, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/accountableGPT",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$AccountableGPT, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/adminportal",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$AdminPortal, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/users",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Users, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/scheduled-tests/users",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$ScheduledTests, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/scheduled-tests/users/:userId",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$UserDetails, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/safety",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$SafetyPlan, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/sms",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Sms, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/schedule",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$ScheduleMessages, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/surveyadmin",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$CreateSurvey, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/goallibrary",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$GoalLibrary, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/survey",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$SurveyForm, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/goalsurvey",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$GoalSurveyForm, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/surveyresults",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$SurveyResults, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/reports",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$MemberReports, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/insurance-reports",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$InsuranceReports, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/insurance-reports/:id",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$SingleInsuranceReport, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/analytics",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Analytics, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/onboarding",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Onboarding, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/reinforcement",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Reinforcement, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/kits",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Kits, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/orders",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Orders, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/audits",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Audits, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/audits/:id",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$CoachAudit, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/rekognition",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$RekognitionOverview, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/rekognition/face-search-jobs/:id",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$RekognitionFaceSearchJob, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/tox-reviews",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$ToxReviews, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/program-invoices",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Invoices, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/program-invoices/:programId",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$InvoiceDetails, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/program-invoices/:programId/invoice/:stripeInvoiceId",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$StripeInvoiceDetails, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/program-invoices/:programId/upcoming",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$UpcomingStripeInvoiceDetails, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/geha-eligibility",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$GehaEligibility, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/website",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $08ddcaf23b3e3aef$export$2e2bcd8739ae039), {
                    to: "https://youareaccountable.com/"
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/scholarships",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $08ddcaf23b3e3aef$export$2e2bcd8739ae039), {
                    to: "https://youareaccountable.com/scholarships/"
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/resetpw",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$ResetPassword, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/checkout/success",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$CheckoutSuccess, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/partners",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Partners, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/admin-tools",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $0bb6679a27de4034$export$2e2bcd8739ae039), {
                    tenantname: tenantName,
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$AdminTools, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Navigate), {
                    to: dashboard,
                    replace: true
                })
            })
        ]
    });
    else routes = /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fOZMN.Routes), {
        children: [
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/sign-in",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $ffe991997516fca7$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/sign-up",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $d92f15fb15445a71$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/program-sign-up",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $c98c099519c83d2a$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/insurance",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$InsuranceSignUp, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/ForgotPassword",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$ForgotPassword, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/resetpw",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$ResetPassword, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/survey",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$SurveyForm, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/goalsurvey",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$GoalSurveyForm, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/surveyresults",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$SurveyResults, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/reinforcement",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $83a03f40458c9c95$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($7d9f2f555e26cb24$var$Reinforcement, {})
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/terms",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $08ddcaf23b3e3aef$export$2e2bcd8739ae039), {
                    to: "https://youareaccountable.com/terms"
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/programterms",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $08ddcaf23b3e3aef$export$2e2bcd8739ae039), {
                    to: "https://youareaccountable.com/terms-of-service-partner-program"
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/website",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $08ddcaf23b3e3aef$export$2e2bcd8739ae039), {
                    to: "https://youareaccountable.com/"
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/scholarships",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $08ddcaf23b3e3aef$export$2e2bcd8739ae039), {
                    to: "https://youareaccountable.com/scholarships/"
                })
            }),
            /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $fOZMN.Navigate), {
                    to: "/sign-in",
                    replace: true
                })
            })
        ]
    });
    return routes;
};
var $7d9f2f555e26cb24$export$2e2bcd8739ae039 = $7d9f2f555e26cb24$var$AppRoutes;



var $dgG1Y = parcelRequire("dgG1Y");
var $fe6867bc990fd95e$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $fe6867bc990fd95e$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


const $8198006dff50ff4e$export$1d39dc5b47e56ff0 = ()=>{
    const [authState, setAuthState] = (0, $dgG1Y.useState)({
        token: null,
        userId: null,
        email: null,
        tenant: null,
        error: null,
        authProvider: false,
        stripeStatus: null,
        tokenExpirationDate: null,
        accountableAdmin: false,
        supervisor: false,
        provider: false,
        programProvider: false,
        program: false,
        client: false,
        harambe: false,
        siteAdmin: false,
        wsClient: null,
        loading: true
    });
    const logOutTimer = (0, $dgG1Y.useRef)();
    const login = (0, $dgG1Y.useCallback)((uid, email, tenant, token, expirationDate, authprovider, status, accountableAdmin, siteAdmin, harambe, program, provider, programProvider, supervisor)=>{
        const tokenExpirationDate = expirationDate || new Date(new Date().getTime() + 43200000);
        setAuthState((prevState)=>({
                ...prevState,
                token: token,
                userId: uid,
                email: email,
                tenant: tenant,
                authProvider: authprovider,
                stripeStatus: status,
                tokenExpirationDate: tokenExpirationDate,
                accountableAdmin: accountableAdmin,
                siteAdmin: siteAdmin,
                harambe: harambe,
                program: program,
                provider: provider,
                programProvider: programProvider,
                supervisor: supervisor,
                loading: false
            }));
        localStorage.setItem("userData", JSON.stringify({
            userId: uid,
            email: email,
            tenant: tenant,
            token: token,
            expiration: tokenExpirationDate.toISOString(),
            authProvider: authprovider,
            status: status,
            accountableAdmin: accountableAdmin,
            siteAdmin: siteAdmin,
            harambe: harambe,
            programProvider: programProvider,
            program: program,
            provider: provider,
            supervisor: supervisor
        }));
    }, []);
    const updateSettings = (0, $dgG1Y.useCallback)((company, email, stripe)=>{
        setAuthState((prevState)=>({
                ...prevState,
                tenant: company || prevState.tenant,
                email: email || prevState.email,
                stripeStatus: stripe || prevState.stripeStatus
            }));
    }, []);
    const logout = (0, $dgG1Y.useCallback)(()=>{
        setAuthState((prevState)=>({
                ...prevState,
                token: null,
                tokenExpirationDate: null,
                userId: null,
                loading: false,
                accountableAdmin: false,
                harambe: false,
                supervisor: false,
                wsClient: null
            }));
        if (authState.wsClient && authState.wsClient.readyState === WebSocket.OPEN) authState.wsClient.close(1000, "Closing connection on logout");
        localStorage.removeItem("userData");
    }, [
        authState.wsClient
    ]);
    const clearError = (0, $dgG1Y.useCallback)((value)=>{
        setAuthState((prevState)=>({
                ...prevState,
                error: value
            }));
    }, []);
    (0, $dgG1Y.useEffect)(()=>{
        const failData = (0, (/*@__PURE__*/$parcel$interopDefault($fe6867bc990fd95e$exports))).get("fail");
        if (failData) {
            setAuthState((prevState)=>({
                    ...prevState,
                    error: failData,
                    loading: false
                }));
            (0, (/*@__PURE__*/$parcel$interopDefault($fe6867bc990fd95e$exports))).set("fail", "test", {
                path: "/",
                domain: ".youareaccountable.com",
                expires: -7
            });
        }
        let storedData = (0, (/*@__PURE__*/$parcel$interopDefault($fe6867bc990fd95e$exports))).get("auth");
        if (storedData) {
            storedData = JSON.parse(storedData.replace("j:", ""));
            storedData.expiration = new Date(new Date().getTime() + 43200000);
            storedData.authProvider = false;
            (0, (/*@__PURE__*/$parcel$interopDefault($fe6867bc990fd95e$exports))).set("auth", "test", {
                path: "/",
                domain: ".youareaccountable.com",
                expires: -7
            });
        }
        if (!storedData) {
            const localData = localStorage.getItem("userData");
            storedData = localData ? JSON.parse(localData) : null;
        }
        if (storedData && storedData.token && new Date(storedData.expiration) > new Date()) login(storedData.userId, storedData.email, storedData.tenant, storedData.token, new Date(storedData.expiration), storedData.authProvider, storedData.status, storedData.accountableAdmin, storedData.siteAdmin, storedData.harambe, storedData.program, storedData.provider, storedData.programProvider, storedData.supervisor);
        else setAuthState((prevState)=>({
                ...prevState,
                loading: false
            }));
    }, [
        login
    ]);
    (0, $dgG1Y.useEffect)(()=>{
        if (authState.token && authState.tokenExpirationDate) {
            const remainingTime = authState.tokenExpirationDate.getTime() - new Date().getTime();
            logOutTimer.current = setTimeout(logout, remainingTime);
        } else clearTimeout(logOutTimer.current);
        return ()=>{
            if (logOutTimer.current) clearTimeout(logOutTimer.current);
        };
    }, [
        authState.token,
        authState.tokenExpirationDate,
        logout
    ]);
    const INACTIVITY_TIMEOUT = 3500000; // 3500 seconds (about 58 minutes)
    (0, $dgG1Y.useEffect)(()=>{
        const events = [
            "mousemove",
            "mousedown",
            "resize",
            "keydown",
            "touchstart",
            "wheel"
        ];
        let inactivityTimer;
        const resetInactivityTimer = ()=>{
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(logout, INACTIVITY_TIMEOUT);
            localStorage.setItem("lastActivity", Date.now().toString());
        };
        const handleStorageChange = (event)=>{
            if (event.key === "lastActivity") resetInactivityTimer();
        };
        events.forEach((event)=>window.addEventListener(event, resetInactivityTimer));
        window.addEventListener("storage", handleStorageChange);
        resetInactivityTimer();
        return ()=>{
            clearTimeout(inactivityTimer);
            events.forEach((event)=>window.removeEventListener(event, resetInactivityTimer));
            window.removeEventListener("storage", handleStorageChange);
        };
    }, [
        logout
    ]);
    return {
        ...authState,
        isLoggedIn: authState.token !== null,
        login: login,
        logout: logout,
        clearError: clearError,
        updateSettings: updateSettings,
        setAccountableAdmin: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    accountableAdmin: value
                })),
        setSiteAdmin: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    siteAdmin: value
                })),
        setHarambe: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    harambe: value
                })),
        setProvider: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    provider: value
                })),
        setProgram: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    program: value
                })),
        setProgramProvider: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    programProvider: value
                })),
        setClient: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    client: value
                })),
        setWsClient: (client)=>setAuthState((prevState)=>({
                    ...prevState,
                    wsClient: client
                })),
        setSupervisor: (value)=>setAuthState((prevState)=>({
                    ...prevState,
                    supervisor: value
                }))
    };
};



var $ewdxp = parcelRequire("ewdxp");

var $byHow = parcelRequire("byHow");
var $8f4fcabcce3cbb7e$var$V3_URL = "https://js.stripe.com/v3";
var $8f4fcabcce3cbb7e$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $8f4fcabcce3cbb7e$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $8f4fcabcce3cbb7e$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($8f4fcabcce3cbb7e$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$8f4fcabcce3cbb7e$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $8f4fcabcce3cbb7e$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($8f4fcabcce3cbb7e$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $8f4fcabcce3cbb7e$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.54.2",
        startTime: startTime
    });
};
var $8f4fcabcce3cbb7e$var$stripePromise = null;
var $8f4fcabcce3cbb7e$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($8f4fcabcce3cbb7e$var$stripePromise !== null) return $8f4fcabcce3cbb7e$var$stripePromise;
    $8f4fcabcce3cbb7e$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($8f4fcabcce3cbb7e$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $8f4fcabcce3cbb7e$var$findScript();
            if (script && params) console.warn($8f4fcabcce3cbb7e$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $8f4fcabcce3cbb7e$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $8f4fcabcce3cbb7e$var$stripePromise;
};
var $8f4fcabcce3cbb7e$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $8f4fcabcce3cbb7e$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $8f4fcabcce3cbb7e$var$stripePromise$1 = Promise.resolve().then(function() {
    return $8f4fcabcce3cbb7e$var$loadScript(null);
});
var $8f4fcabcce3cbb7e$var$loadCalled = false;
$8f4fcabcce3cbb7e$var$stripePromise$1["catch"](function(err) {
    if (!$8f4fcabcce3cbb7e$var$loadCalled) console.warn(err);
});
var $8f4fcabcce3cbb7e$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $8f4fcabcce3cbb7e$var$loadCalled = true;
    var startTime = Date.now();
    return $8f4fcabcce3cbb7e$var$stripePromise$1.then(function(maybeStripe) {
        return $8f4fcabcce3cbb7e$var$initStripe(maybeStripe, args, startTime);
    });
};



var $31cpC = parcelRequire("31cpC");

var $h73EU = parcelRequire("h73EU");

var $kqmsT = parcelRequire("kqmsT");

var $dgG1Y = parcelRequire("dgG1Y");
parcelRequire("kunpB");
var $fOZMN = parcelRequire("fOZMN");

var $kqmsT = parcelRequire("kqmsT");
function $624dafee53c8d4ff$export$2e2bcd8739ae039() {
    let location = (0, $fOZMN.useLocation)();
    const posthog = (0, $kqmsT.usePostHog)();
    // Track pageviews
    (0, $dgG1Y.useEffect)(()=>{
        if (posthog) posthog.capture("$pageview", {
            $current_url: location.pathname
        });
    }, [
        location.pathname,
        posthog
    ]);
    return null;
}


const $3e9dfbf313955633$var$stripePromise = (0, $8f4fcabcce3cbb7e$export$de80f7562c3fd6b1)("pk_live_51HUyyqGRkl9Br31kMIW4O8nQoq5UYtepU7co1noiCoHPzNLerxJXPeAOD0TeyHrvagf7qEGugeZ2JMeHG0LNl7jq00bAfHw9to");
const $3e9dfbf313955633$var$App = ()=>{
    const auth = (0, $8198006dff50ff4e$export$1d39dc5b47e56ff0)();
    const posthog = (0, $kqmsT.usePostHog)();
    (0, $dgG1Y.useEffect)(()=>{
        if (auth.token && auth.userId) posthog.identify(auth.userId, {
            accountableAdmin: auth.accountableAdmin || false
        });
    }, [
        auth.token,
        auth.userId
    ]);
    return /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $byHow.Elements), {
        stripe: $3e9dfbf313955633$var$stripePromise,
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $ewdxp.AuthContext).Provider, {
            value: auth,
            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $h73EU.WebSocketProvider), {
                children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $a62e91a3828fa522$export$2e2bcd8739ae039), {
                    theme: (0, $8DY8l.legacyTheme),
                    children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7506a74e5505d072$export$2e2bcd8739ae039), {
                        theme: (0, $8DY8l.theme),
                        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kunpB.BrowserRouter), {
                            children: /*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $dgG1Y.Suspense), {
                                fallback: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                                    open: true
                                }),
                                children: [
                                    auth.loading ? /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $cVxYB.default), {
                                        open: true
                                    }) : /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $7d9f2f555e26cb24$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $624dafee53c8d4ff$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $31cpC.Toaster), {
                                        position: "top-right",
                                        toastOptions: {
                                            duration: Infinity
                                        },
                                        children: (t)=>/*#__PURE__*/ (0, $fR5Jw.jsx)((0, $31cpC.ToastBar), {
                                                toast: t,
                                                children: ({ icon: icon, message: message })=>/*#__PURE__*/ (0, $fR5Jw.jsxs)((0, $fR5Jw.Fragment), {
                                                        children: [
                                                            icon,
                                                            message,
                                                            t.type !== "loading" && /*#__PURE__*/ (0, $fR5Jw.jsx)("button", {
                                                                onClick: ()=>(0, $31cpC.toast).dismiss(t.id),
                                                                children: "X"
                                                            })
                                                        ]
                                                    })
                                            })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};
var $3e9dfbf313955633$export$2e2bcd8739ae039 = $3e9dfbf313955633$var$App;


// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $9c2e85f3aff73b46$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $9c2e85f3aff73b46$export$6503ec6e8aabbaf(config) {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener("load", ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($9c2e85f3aff73b46$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $9c2e85f3aff73b46$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $9c2e85f3aff73b46$var$registerValidSW(swUrl, config);
        });
    }
}
function $9c2e85f3aff73b46$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("Content is cached for offline use.");
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error("Error during service worker registration:", error);
    });
}
function $9c2e85f3aff73b46$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl, {
        headers: {
            "Service-Worker": "script"
        }
    }).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get("content-type");
        if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $9c2e85f3aff73b46$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $9c2e85f3aff73b46$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    }).catch((error)=>{
        console.error(error.message);
    });
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3549cd95261873e2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $7bc2b85f84f1fb97$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $7bc2b85f84f1fb97$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $7bc2b85f84f1fb97$var$isGlobalObj(window) || typeof self == "object" && $7bc2b85f84f1fb97$var$isGlobalObj(self) || typeof $parcel$global == "object" && $7bc2b85f84f1fb97$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $7bc2b85f84f1fb97$export$256479dc0cea61c4() {
    return $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $7bc2b85f84f1fb97$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $2bd19015b7869ed8$var$PREFIX = "Sentry Logger ";
const $2bd19015b7869ed8$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $2bd19015b7869ed8$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $2bd19015b7869ed8$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($2bd19015b7869ed8$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $2bd19015b7869ed8$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $2bd19015b7869ed8$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $3549cd95261873e2$export$16a28057038b10ef) $2bd19015b7869ed8$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $2bd19015b7869ed8$export$cda52e2a8927a2ca(()=>{
                (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).console[name](`${$2bd19015b7869ed8$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $2bd19015b7869ed8$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $2bd19015b7869ed8$export$af88d00dbe7f521 = $2bd19015b7869ed8$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5030e00c131eea58$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $579f76a2b219152d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $579f76a2b219152d$export$7740643b9eeaf0c4() {
    return Date.now() / $579f76a2b219152d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $579f76a2b219152d$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $579f76a2b219152d$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $579f76a2b219152d$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $579f76a2b219152d$export$ee52dced521e3e18 = $579f76a2b219152d$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $579f76a2b219152d$export$c5907b5a8838db13 = $579f76a2b219152d$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $579f76a2b219152d$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $579f76a2b219152d$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $579f76a2b219152d$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $579f76a2b219152d$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $579f76a2b219152d$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $579f76a2b219152d$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $26965e7f4b3c51e7$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$e6127cc7fe7395c3(wat) {
    switch($26965e7f4b3c51e7$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $26965e7f4b3c51e7$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$var$isBuiltin(wat, className) {
    return $26965e7f4b3c51e7$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$9f9636d330b71954(wat) {
    return $26965e7f4b3c51e7$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$ef9e2056653f0c8e(wat) {
    return $26965e7f4b3c51e7$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$12e869b2a583f783(wat) {
    return $26965e7f4b3c51e7$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$844ec244b1367d54(wat) {
    return $26965e7f4b3c51e7$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$c3825b437cbdea5c(wat) {
    return wat === null || $26965e7f4b3c51e7$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$53b83ca8eaab0383(wat) {
    return $26965e7f4b3c51e7$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $26965e7f4b3c51e7$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $26965e7f4b3c51e7$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$49841c62b9eff15(wat) {
    return $26965e7f4b3c51e7$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $26965e7f4b3c51e7$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$bc2894c7158efbac(wat) {
    return $26965e7f4b3c51e7$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $26965e7f4b3c51e7$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $bec17cc7ed6c6bca$var$WINDOW = (0, $7bc2b85f84f1fb97$export$256479dc0cea61c4)();
const $bec17cc7ed6c6bca$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $bec17cc7ed6c6bca$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $bec17cc7ed6c6bca$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $bec17cc7ed6c6bca$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $bec17cc7ed6c6bca$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($bec17cc7ed6c6bca$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $26965e7f4b3c51e7$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $bec17cc7ed6c6bca$export$1cfafeee2987818b() {
    try {
        return $bec17cc7ed6c6bca$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bec17cc7ed6c6bca$export$c660c1f3ab49225c(selector) {
    if ($bec17cc7ed6c6bca$var$WINDOW.document && $bec17cc7ed6c6bca$var$WINDOW.document.querySelector) return $bec17cc7ed6c6bca$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $bec17cc7ed6c6bca$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$bec17cc7ed6c6bca$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $2ce85545280315e6$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $2ce85545280315e6$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2ce85545280315e6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $26965e7f4b3c51e7$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $2ce85545280315e6$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $26965e7f4b3c51e7$export$844ec244b1367d54)(value)) return false;
    if ((0, $26965e7f4b3c51e7$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $26965e7f4b3c51e7$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $2ce85545280315e6$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$2ce85545280315e6$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $a4503473509e6905$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $a4503473509e6905$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $a4503473509e6905$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $3549cd95261873e2$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $a4503473509e6905$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $a4503473509e6905$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $a4503473509e6905$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $a4503473509e6905$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $a4503473509e6905$export$62ff257738bf57f5(value) {
    if ((0, $26965e7f4b3c51e7$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$a4503473509e6905$var$getOwnProperties(value)
    };
    else if ((0, $26965e7f4b3c51e7$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $a4503473509e6905$var$serializeEventTarget(value.target),
            currentTarget: $a4503473509e6905$var$serializeEventTarget(value.currentTarget),
            ...$a4503473509e6905$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $26965e7f4b3c51e7$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $a4503473509e6905$var$serializeEventTarget(target) {
    try {
        return (0, $26965e7f4b3c51e7$export$45a5e7f76e0caa8d)(target) ? (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $a4503473509e6905$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $a4503473509e6905$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($a4503473509e6905$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $2ce85545280315e6$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $2ce85545280315e6$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $a4503473509e6905$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $a4503473509e6905$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $a4503473509e6905$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($a4503473509e6905$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $a4503473509e6905$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($a4503473509e6905$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $a4503473509e6905$var$isPojo(input) {
    if (!(0, $26965e7f4b3c51e7$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $a4503473509e6905$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $26965e7f4b3c51e7$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $65daed3d61181daa$export$19f53698e68b2496() {
    const gbl = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $65daed3d61181daa$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $65daed3d61181daa$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $65daed3d61181daa$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $65daed3d61181daa$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $65daed3d61181daa$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $65daed3d61181daa$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $65daed3d61181daa$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $65daed3d61181daa$export$d364f2020ab30578(input) {
    const match = input.match($65daed3d61181daa$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $65daed3d61181daa$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $2ce85545280315e6$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $2ce85545280315e6$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $2ce85545280315e6$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $65daed3d61181daa$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $a4503473509e6905$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $65daed3d61181daa$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $b0d27915ad3ef6a1$export$849dbeeeda01ae98 = "production";





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $d0bb8be585a0f1f4$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($d0bb8be585a0f1f4$var$States || ($d0bb8be585a0f1f4$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa(value) {
    return new $d0bb8be585a0f1f4$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $d0bb8be585a0f1f4$export$78e43115b553f358(reason) {
    return new $d0bb8be585a0f1f4$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $d0bb8be585a0f1f4$export$6f292d4960313241 {
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $d0bb8be585a0f1f4$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $d0bb8be585a0f1f4$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($d0bb8be585a0f1f4$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($d0bb8be585a0f1f4$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $d0bb8be585a0f1f4$var$States.PENDING) return;
            if ((0, $26965e7f4b3c51e7$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $d0bb8be585a0f1f4$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $d0bb8be585a0f1f4$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $d0bb8be585a0f1f4$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
    constructor(executor){
        $d0bb8be585a0f1f4$export$6f292d4960313241.prototype.__init.call(this);
        $d0bb8be585a0f1f4$export$6f292d4960313241.prototype.__init2.call(this);
        $d0bb8be585a0f1f4$export$6f292d4960313241.prototype.__init3.call(this);
        $d0bb8be585a0f1f4$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $d0bb8be585a0f1f4$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $d37f32692ebac6bd$export$3c4238858b85e8ac() {
    return (0, $7bc2b85f84f1fb97$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $d37f32692ebac6bd$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $d37f32692ebac6bd$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $d37f32692ebac6bd$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $d0bb8be585a0f1f4$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $5030e00c131eea58$export$16a28057038b10ef) && processor.id && result === null && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $26965e7f4b3c51e7$export$f5b060c2914b97c8)(result)) result.then((final)=>$d37f32692ebac6bd$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $d37f32692ebac6bd$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $d4f7cdbed5b8ce9e$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $579f76a2b219152d$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $65daed3d61181daa$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$d4f7cdbed5b8ce9e$var$sessionToJSON(session)
    };
    if (context) $d4f7cdbed5b8ce9e$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $d4f7cdbed5b8ce9e$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $579f76a2b219152d$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $65daed3d61181daa$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $d4f7cdbed5b8ce9e$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $d4f7cdbed5b8ce9e$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $d4f7cdbed5b8ce9e$var$sessionToJSON(session) {
    return (0, $a4503473509e6905$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $7ebe641278e8a4c4$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $75ed204ec2c223a9$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $75ed204ec2c223a9$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $75ed204ec2c223a9$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $c6dc8b4022d3f0a5$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $c6dc8b4022d3f0a5$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $c6dc8b4022d3f0a5$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $c6dc8b4022d3f0a5$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $c6dc8b4022d3f0a5$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($c6dc8b4022d3f0a5$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $c6dc8b4022d3f0a5$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $c6dc8b4022d3f0a5$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $c6dc8b4022d3f0a5$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $c6dc8b4022d3f0a5$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $c6dc8b4022d3f0a5$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($c6dc8b4022d3f0a5$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($c6dc8b4022d3f0a5$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $c6dc8b4022d3f0a5$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $c6dc8b4022d3f0a5$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $c6dc8b4022d3f0a5$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $c6dc8b4022d3f0a5$var$defaultFunctionName;
        return fn.name || $c6dc8b4022d3f0a5$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $c6dc8b4022d3f0a5$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $c6dc8b4022d3f0a5$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $75ed204ec2c223a9$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458193ce2072e151$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $458193ce2072e151$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $458193ce2072e151$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $458193ce2072e151$export$a3295358bff77e(object, depth);
    if ($458193ce2072e151$var$jsonSize(normalized) > maxSize) return $458193ce2072e151$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $458193ce2072e151$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $7ebe641278e8a4c4$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $26965e7f4b3c51e7$export$c9f5652083b8129d)(value)) return value;
    const stringified = $458193ce2072e151$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $458193ce2072e151$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $a4503473509e6905$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $458193ce2072e151$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $458193ce2072e151$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $26965e7f4b3c51e7$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $26965e7f4b3c51e7$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $458193ce2072e151$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $458193ce2072e151$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $458193ce2072e151$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458193ce2072e151$var$jsonSize(value) {
    return $458193ce2072e151$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $458193ce2072e151$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}









const $45a99172e2665bf8$export$9ca9946bd449ac06 = "baggage";
const $45a99172e2665bf8$export$6e69537d67fa20f = "sentry-";
const $45a99172e2665bf8$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $45a99172e2665bf8$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $45a99172e2665bf8$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $26965e7f4b3c51e7$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $45a99172e2665bf8$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $45a99172e2665bf8$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($45a99172e2665bf8$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($45a99172e2665bf8$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $45a99172e2665bf8$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$45a99172e2665bf8$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $45a99172e2665bf8$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $45a99172e2665bf8$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $45a99172e2665bf8$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $45a99172e2665bf8$export$bdd844ddb2def819) {
            (0, $3549cd95261873e2$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $c738bc01dada2b49$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $c738bc01dada2b49$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($c738bc01dada2b49$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $c738bc01dada2b49$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $c738bc01dada2b49$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $45a99172e2665bf8$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $65daed3d61181daa$export$19f53698e68b2496)(),
            spanId: (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $65daed3d61181daa$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16),
            spanId: (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $c738bc01dada2b49$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $c738bc01dada2b49$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $45a99172e2665bf8$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $65daed3d61181daa$export$19f53698e68b2496)(),
        spanId: (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $65daed3d61181daa$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16),
        spanId: (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $c738bc01dada2b49$export$f35d907436da45cf(traceId = (0, $65daed3d61181daa$export$19f53698e68b2496)(), spanId = (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $750851faedae500f$export$208d5b368507fb8b = 0x0;
const $750851faedae500f$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $750851faedae500f$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $750851faedae500f$export$92d8c23565496537(span);
    return (0, $a4503473509e6905$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $750851faedae500f$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $750851faedae500f$export$5caecac1caaf3a71(span);
    return (0, $c738bc01dada2b49$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $750851faedae500f$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $750851faedae500f$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $750851faedae500f$var$ensureTimestampInSeconds(input.getTime());
    return (0, $579f76a2b219152d$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $750851faedae500f$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $750851faedae500f$export$92d8c23565496537(span) {
    if ($750851faedae500f$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $750851faedae500f$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $750851faedae500f$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $750851faedae500f$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $0b9a24c8403b5f2a$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $65daed3d61181daa$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $579f76a2b219152d$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $0b9a24c8403b5f2a$var$applyClientOptions(prepared, options);
    $0b9a24c8403b5f2a$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $0b9a24c8403b5f2a$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $0b9a24c8403b5f2a$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $65daed3d61181daa$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $50a2913d3c2cbab7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $536ef71ac1c0d2d5$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $536ef71ac1c0d2d5$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $536ef71ac1c0d2d5$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $d37f32692ebac6bd$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $d37f32692ebac6bd$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $0b9a24c8403b5f2a$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $0b9a24c8403b5f2a$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $0b9a24c8403b5f2a$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $b0d27915ad3ef6a1$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $2ce85545280315e6$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $2ce85545280315e6$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $2ce85545280315e6$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $0b9a24c8403b5f2a$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $0b9a24c8403b5f2a$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $0b9a24c8403b5f2a$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $0b9a24c8403b5f2a$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $0b9a24c8403b5f2a$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $0b9a24c8403b5f2a$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $0b9a24c8403b5f2a$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $458193ce2072e151$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $458193ce2072e151$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $458193ce2072e151$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $458193ce2072e151$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $458193ce2072e151$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $750851faedae500f$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $458193ce2072e151$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $0b9a24c8403b5f2a$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $50a2913d3c2cbab7$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $0b9a24c8403b5f2a$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($0b9a24c8403b5f2a$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($0b9a24c8403b5f2a$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $0b9a24c8403b5f2a$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $50a2913d3c2cbab7$export$775b6bb06e53a214) || typeof hint === "function";
}
const $0b9a24c8403b5f2a$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $0b9a24c8403b5f2a$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$0b9a24c8403b5f2a$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fe010f6f6efcb5f1$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().captureException(exception, (0, $0b9a24c8403b5f2a$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fe010f6f6efcb5f1$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fe010f6f6efcb5f1$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $fe010f6f6efcb5f1$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $fe010f6f6efcb5f1$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $fe010f6f6efcb5f1$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $fe010f6f6efcb5f1$export$9a4fed82c350c2bd(callback) {
    return (0, $35009d14216a34ba$export$70d775fb1f267027)(()=>{
        return callback((0, $35009d14216a34ba$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $fe010f6f6efcb5f1$export$e57ac09b143d92a2(span, callback) {
    return $fe010f6f6efcb5f1$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $fe010f6f6efcb5f1$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fe010f6f6efcb5f1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $fe010f6f6efcb5f1$export$c7be4b0125a10cba();
    const client = $fe010f6f6efcb5f1$export$6bb76d6eba7e258c();
    if (!client) (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $65daed3d61181daa$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fe010f6f6efcb5f1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $fe010f6f6efcb5f1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $579f76a2b219152d$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $fe010f6f6efcb5f1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $579f76a2b219152d$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $26965e7f4b3c51e7$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fe010f6f6efcb5f1$export$4909b86c8034bf73(timeout) {
    const client = $fe010f6f6efcb5f1$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fe010f6f6efcb5f1$export$8360e631d277ea4d(timeout) {
    const client = $fe010f6f6efcb5f1$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $fe010f6f6efcb5f1$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $fe010f6f6efcb5f1$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $fe010f6f6efcb5f1$export$3f95c6f800b78024() {
    return !!$fe010f6f6efcb5f1$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $fe010f6f6efcb5f1$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $35009d14216a34ba$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fe010f6f6efcb5f1$export$c0d84948cecf78d8(context) {
    const client = $fe010f6f6efcb5f1$export$6bb76d6eba7e258c();
    const isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)();
    const currentScope = $fe010f6f6efcb5f1$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $b0d27915ad3ef6a1$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $d4f7cdbed5b8ce9e$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $d4f7cdbed5b8ce9e$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $fe010f6f6efcb5f1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $fe010f6f6efcb5f1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)();
    const currentScope = $fe010f6f6efcb5f1$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $d4f7cdbed5b8ce9e$export$56521d9ba90f62ee)(session);
    $fe010f6f6efcb5f1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fe010f6f6efcb5f1$var$_sendSessionUpdate() {
    const isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)();
    const currentScope = $fe010f6f6efcb5f1$export$c7be4b0125a10cba();
    const client = $fe010f6f6efcb5f1$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fe010f6f6efcb5f1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fe010f6f6efcb5f1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $fe010f6f6efcb5f1$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $d58c5848735b0003$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $b7892217fe0631f5$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $a4503473509e6905$export$d25f2688db1bb433)({
        environment: options.environment || (0, $b0d27915ad3ef6a1$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $b7892217fe0631f5$export$a117f995597e25df(span) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $b7892217fe0631f5$export$366bad00d6815eed((0, $750851faedae500f$export$92d8c23565496537)(span).trace_id || "", client, (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $d58c5848735b0003$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $750851faedae500f$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $750851faedae500f$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $536ef71ac1c0d2d5$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $536ef71ac1c0d2d5$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $536ef71ac1c0d2d5$var$applySpanToEvent(event, span);
    $536ef71ac1c0d2d5$var$applyFingerprintToEvent(event, fingerprint);
    $536ef71ac1c0d2d5$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $536ef71ac1c0d2d5$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $536ef71ac1c0d2d5$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $536ef71ac1c0d2d5$export$b1a120a2871faa46(data, "extra", extra);
    $536ef71ac1c0d2d5$export$b1a120a2871faa46(data, "tags", tags);
    $536ef71ac1c0d2d5$export$b1a120a2871faa46(data, "user", user);
    $536ef71ac1c0d2d5$export$b1a120a2871faa46(data, "contexts", contexts);
    $536ef71ac1c0d2d5$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $536ef71ac1c0d2d5$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $536ef71ac1c0d2d5$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $a4503473509e6905$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $a4503473509e6905$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $a4503473509e6905$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $a4503473509e6905$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $536ef71ac1c0d2d5$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $536ef71ac1c0d2d5$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $536ef71ac1c0d2d5$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $750851faedae500f$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $d58c5848735b0003$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $b7892217fe0631f5$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $750851faedae500f$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $536ef71ac1c0d2d5$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $65daed3d61181daa$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $50a2913d3c2cbab7$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $50a2913d3c2cbab7$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $50a2913d3c2cbab7$export$775b6bb06e53a214 {
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $50a2913d3c2cbab7$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $50a2913d3c2cbab7$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $d4f7cdbed5b8ce9e$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $50a2913d3c2cbab7$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $26965e7f4b3c51e7$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $50a2913d3c2cbab7$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $50a2913d3c2cbab7$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $579f76a2b219152d$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $536ef71ac1c0d2d5$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $d37f32692ebac6bd$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $d37f32692ebac6bd$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $65daed3d61181daa$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $65daed3d61181daa$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $65daed3d61181daa$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $50a2913d3c2cbab7$var$generatePropagationContext();
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $50a2913d3c2cbab7$export$aa55d5ab8e05984f() {
    if (!$50a2913d3c2cbab7$var$globalScope) $50a2913d3c2cbab7$var$globalScope = new $50a2913d3c2cbab7$export$775b6bb06e53a214();
    return $50a2913d3c2cbab7$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $50a2913d3c2cbab7$export$c83048efd17527d6(scope) {
    $50a2913d3c2cbab7$var$globalScope = scope;
}
function $50a2913d3c2cbab7$var$generatePropagationContext() {
    return {
        traceId: (0, $65daed3d61181daa$export$19f53698e68b2496)(),
        spanId: (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16)
    };
}



const $eeaeda57c0b5ba08$export$31499a9cd224b78c = "7.120.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $35009d14216a34ba$export$24a86ef7798177e4 = parseFloat((0, $eeaeda57c0b5ba08$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $35009d14216a34ba$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $35009d14216a34ba$export$8c41bb232f1008b1 {
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $26965e7f4b3c51e7$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $65daed3d61181daa$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $65daed3d61181daa$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $65daed3d61181daa$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $35009d14216a34ba$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $579f76a2b219152d$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $2bd19015b7869ed8$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $35009d14216a34ba$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $35009d14216a34ba$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $5030e00c131eea58$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $d4f7cdbed5b8ce9e$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $b0d27915ad3ef6a1$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $d4f7cdbed5b8ce9e$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $d4f7cdbed5b8ce9e$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $35009d14216a34ba$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $35009d14216a34ba$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $50a2913d3c2cbab7$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $50a2913d3c2cbab7$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $35009d14216a34ba$export$19eade501500c6c1() {
    (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $35009d14216a34ba$export$4188a14ad302d1bc(hub) {
    const registry = $35009d14216a34ba$export$19eade501500c6c1();
    const oldHub = $35009d14216a34ba$export$bfa8a924a84a76b7(registry);
    $35009d14216a34ba$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $35009d14216a34ba$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $35009d14216a34ba$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $35009d14216a34ba$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $35009d14216a34ba$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $35009d14216a34ba$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $35009d14216a34ba$var$getGlobalHub(registry = $35009d14216a34ba$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$35009d14216a34ba$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $35009d14216a34ba$export$bfa8a924a84a76b7(registry).isOlderThan($35009d14216a34ba$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $35009d14216a34ba$export$849f05434e95d2f2(registry, new $35009d14216a34ba$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $35009d14216a34ba$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $35009d14216a34ba$export$236689a79f5aa020(carrier, parent = $35009d14216a34ba$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$35009d14216a34ba$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $35009d14216a34ba$export$bfa8a924a84a76b7(carrier).isOlderThan($35009d14216a34ba$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $35009d14216a34ba$export$849f05434e95d2f2(carrier, new $35009d14216a34ba$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $35009d14216a34ba$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $35009d14216a34ba$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $35009d14216a34ba$export$70d775fb1f267027(callback, options = {}) {
    const registry = $35009d14216a34ba$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $35009d14216a34ba$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $35009d14216a34ba$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $7bc2b85f84f1fb97$export$7e223ec222791509)("hub", ()=>new $35009d14216a34ba$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $35009d14216a34ba$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $97cf2caf887a1678$var$handlers = {};
const $97cf2caf887a1678$var$instrumented = {};
/** Add a handler function. */ function $97cf2caf887a1678$export$a4e09611e30da72e(type, handler) {
    $97cf2caf887a1678$var$handlers[type] = $97cf2caf887a1678$var$handlers[type] || [];
    $97cf2caf887a1678$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $97cf2caf887a1678$export$b17eab759a1cb5fe() {
    Object.keys($97cf2caf887a1678$var$handlers).forEach((key)=>{
        $97cf2caf887a1678$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $97cf2caf887a1678$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$97cf2caf887a1678$var$instrumented[type]) {
        instrumentFn();
        $97cf2caf887a1678$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $97cf2caf887a1678$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $97cf2caf887a1678$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $3549cd95261873e2$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $bbcc5af9b3fdfb97$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bbcc5af9b3fdfb97$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $bbcc5af9b3fdfb97$var$instrumentError);
}
function $bbcc5af9b3fdfb97$var$instrumentError() {
    $bbcc5af9b3fdfb97$var$_oldOnErrorHandler = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).onerror;
    (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $97cf2caf887a1678$export$b18c893e424d3127)("error", handlerData);
        if ($bbcc5af9b3fdfb97$var$_oldOnErrorHandler && !$bbcc5af9b3fdfb97$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $bbcc5af9b3fdfb97$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $c1d55b0d1edb70e2$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c1d55b0d1edb70e2$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $c1d55b0d1edb70e2$var$instrumentUnhandledRejection);
}
function $c1d55b0d1edb70e2$var$instrumentUnhandledRejection() {
    $c1d55b0d1edb70e2$var$_oldOnUnhandledRejectionHandler = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $97cf2caf887a1678$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($c1d55b0d1edb70e2$var$_oldOnUnhandledRejectionHandler && !$c1d55b0d1edb70e2$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $c1d55b0d1edb70e2$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a1bb097315d33d7b$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $a1bb097315d33d7b$export$8e9a29865c0a1226 = (0, $c738bc01dada2b49$export$8e9a29865c0a1226);


let $c5d99cbdd63cbb00$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $c5d99cbdd63cbb00$export$637857c1d87b640c() {
    if ($c5d99cbdd63cbb00$var$errorsInstrumented) return;
    $c5d99cbdd63cbb00$var$errorsInstrumented = true;
    (0, $bbcc5af9b3fdfb97$export$55b5c3ba2194f0c6)($c5d99cbdd63cbb00$var$errorCallback);
    (0, $c1d55b0d1edb70e2$export$8bf4fc6858821a4e)($c5d99cbdd63cbb00$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $c5d99cbdd63cbb00$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$c5d99cbdd63cbb00$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $66041db8a54de2cd$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $66041db8a54de2cd$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $66041db8a54de2cd$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $26965e7f4b3c51e7$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $b0e54440d83352e4$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $a22b4e9d1ae7de18$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
    const scope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $a22b4e9d1ae7de18$var$normalizeContext(context);
    const activeSpan = $a22b4e9d1ae7de18$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $66041db8a54de2cd$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $a22b4e9d1ae7de18$export$a1bd95187356f372(context, callback) {
    const spanContext = $a22b4e9d1ae7de18$var$normalizeContext(context);
    return (0, $35009d14216a34ba$export$70d775fb1f267027)(()=>{
        return (0, $fe010f6f6efcb5f1$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $a22b4e9d1ae7de18$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $66041db8a54de2cd$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $750851faedae500f$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $a22b4e9d1ae7de18$export$cb9e396e6b90b703 = $a22b4e9d1ae7de18$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $a22b4e9d1ae7de18$export$c10292ad04b92aea(context, callback) {
    const spanContext = $a22b4e9d1ae7de18$var$normalizeContext(context);
    return (0, $35009d14216a34ba$export$70d775fb1f267027)(()=>{
        return (0, $fe010f6f6efcb5f1$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $a22b4e9d1ae7de18$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $66041db8a54de2cd$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $750851faedae500f$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $a22b4e9d1ae7de18$export$63dbba021a6b4047(context) {
    if (!(0, $b0e54440d83352e4$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $a22b4e9d1ae7de18$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $a22b4e9d1ae7de18$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $a22b4e9d1ae7de18$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $a22b4e9d1ae7de18$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)().getSpan();
}
const $a22b4e9d1ae7de18$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $c738bc01dada2b49$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $5030e00c131eea58$export$16a28057038b10ef) && traceparentData) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $a4503473509e6905$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $35009d14216a34ba$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $a22b4e9d1ae7de18$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $b0e54440d83352e4$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $b7892217fe0631f5$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $750851faedae500f$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $a22b4e9d1ae7de18$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $a22b4e9d1ae7de18$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $750851faedae500f$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $a22b4e9d1ae7de18$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $a22b4e9d1ae7de18$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $a22b4e9d1ae7de18$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $a4503473509e6905$export$e73679ffaf56810e)(span, $a22b4e9d1ae7de18$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $a4503473509e6905$export$e73679ffaf56810e)(span, $a22b4e9d1ae7de18$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $a22b4e9d1ae7de18$export$c08fbc656a245d03(span) {
    return {
        scope: span[$a22b4e9d1ae7de18$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$a22b4e9d1ae7de18$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $d17596add32509ba$var$SPAN_METRIC_SUMMARY;
function $d17596add32509ba$var$getMetricStorageForSpan(span) {
    return $d17596add32509ba$var$SPAN_METRIC_SUMMARY ? $d17596add32509ba$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $d17596add32509ba$export$2e7205e45c58797d(span) {
    const storage = $d17596add32509ba$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $a4503473509e6905$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $d17596add32509ba$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $a22b4e9d1ae7de18$export$1be426a8e585c83e)();
    if (span) {
        const storage = $d17596add32509ba$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$d17596add32509ba$var$SPAN_METRIC_SUMMARY) $d17596add32509ba$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $d17596add32509ba$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $b8adcea182c00730$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $b8adcea182c00730$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $b8adcea182c00730$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $b8adcea182c00730$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $b8adcea182c00730$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $791c69c8711e0dc9$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($791c69c8711e0dc9$export$beb8e6a823e89c5d || ($791c69c8711e0dc9$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $791c69c8711e0dc9$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $791c69c8711e0dc9$export$ac65c70d78fcdb55 = $791c69c8711e0dc9$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $791c69c8711e0dc9$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $791c69c8711e0dc9$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $3bb0d593b2ee70d6$export$10c95c129cd0d4fe {
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
}
/**
 * Span contains all data about a span
 */ class $3bb0d593b2ee70d6$export$5f1714a13ed34c01 {
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $b8adcea182c00730$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $b8adcea182c00730$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $b8adcea182c00730$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $b8adcea182c00730$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $750851faedae500f$export$eb571cd9b5d98de8) : (0, $750851faedae500f$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $3bb0d593b2ee70d6$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $d58c5848735b0003$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $5030e00c131eea58$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $750851faedae500f$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $791c69c8711e0dc9$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $d58c5848735b0003$export$c4c6a79b1260ca1b)(this);
        if ((0, $5030e00c131eea58$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $750851faedae500f$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $750851faedae500f$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $a4503473509e6905$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $750851faedae500f$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $a4503473509e6905$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $b8adcea182c00730$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $b8adcea182c00730$export$cca8dd30f57f805e],
            _metrics_summary: (0, $d17596add32509ba$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $b8adcea182c00730$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $65daed3d61181daa$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $65daed3d61181daa$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $579f76a2b219152d$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $b8adcea182c00730$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $b8adcea182c00730$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
}











/** JSDoc */ class $925efd2d5af052c4$export$febc5573c75cefb0 extends (0, $3bb0d593b2ee70d6$export$5f1714a13ed34c01) {
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $b8adcea182c00730$export$d7a7d984b0791405] && {
                source: this._attributes[0, $b8adcea182c00730$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $b8adcea182c00730$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $b8adcea182c00730$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $b8adcea182c00730$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $3bb0d593b2ee70d6$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $750851faedae500f$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $a4503473509e6905$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $b7892217fe0631f5$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $750851faedae500f$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $750851faedae500f$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $a22b4e9d1ae7de18$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $750851faedae500f$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $a4503473509e6905$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $b7892217fe0631f5$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $d17596add32509ba$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
}


const $c8dc185fd7d9c9e4$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $c8dc185fd7d9c9e4$var$FINISH_REASON_TAG = "finishReason";
const $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $c8dc185fd7d9c9e4$export$370d6113c18ba86c extends (0, $3bb0d593b2ee70d6$export$10c95c129cd0d4fe) {
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $750851faedae500f$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $c8dc185fd7d9c9e4$export$b279e6bd7040371f extends (0, $925efd2d5af052c4$export$febc5573c75cefb0) {
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $750851faedae500f$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($c8dc185fd7d9c9e4$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $750851faedae500f$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $750851faedae500f$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $5030e00c131eea58$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $c8dc185fd7d9c9e4$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $579f76a2b219152d$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $c8dc185fd7d9c9e4$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $c8dc185fd7d9c9e4$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $c8dc185fd7d9c9e4$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $c8dc185fd7d9c9e4$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $a202afed95055bdd$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $b0e54440d83352e4$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $b8adcea182c00730$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $b8adcea182c00730$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $b8adcea182c00730$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $b8adcea182c00730$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$a202afed95055bdd$export$2603c8d332a51c42(sampleRate)) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $5030e00c131eea58$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $750851faedae500f$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $a202afed95055bdd$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $26965e7f4b3c51e7$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $506b5ddf0f62f730$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $750851faedae500f$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $506b5ddf0f62f730$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $925efd2d5af052c4$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $a202afed95055bdd$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $506b5ddf0f62f730$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $c8dc185fd7d9c9e4$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $a202afed95055bdd$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $506b5ddf0f62f730$export$653d0ef2bad9cdf9() {
    const carrier = (0, $35009d14216a34ba$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $506b5ddf0f62f730$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $506b5ddf0f62f730$var$traceHeaders;
    (0, $c5d99cbdd63cbb00$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4cd2215f9a33fd2e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $4014b6467323111c$export$56d8a8a25bd48b81 = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $45add5f716865713$export$6f18f55521af71a1() {
    if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document) (0, $4014b6467323111c$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
        if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $750851faedae500f$export$92d8c23565496537)(activeTransaction);
            (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $5e4a4adad8274fb4$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $f45915c05f8fd739$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $791345e152841cd9$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $4014b6467323111c$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $4014b6467323111c$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $791345e152841cd9$export$6431553786c94949 = ()=>{
    if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $4014b6467323111c$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $791345e152841cd9$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $4014b6467323111c$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a7f7921d05271e73$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $791345e152841cd9$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f2ac6bfc5936fa34$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $791345e152841cd9$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document && (0, $4014b6467323111c$export$56d8a8a25bd48b81).document.prerendering || (0, $a7f7921d05271e73$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $f45915c05f8fd739$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $e7ca6c75f33afecd$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $07353e1c1419fadf$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $4014b6467323111c$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $39f8509ae1e9cb19$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $f2ac6bfc5936fa34$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $e7ca6c75f33afecd$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $5e4a4adad8274fb4$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $07353e1c1419fadf$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bed1e5a6c043e848$var$firstHiddenTime = -1;
const $bed1e5a6c043e848$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document && (0, $4014b6467323111c$export$56d8a8a25bd48b81).document.visibilityState) $bed1e5a6c043e848$var$firstHiddenTime = (0, $4014b6467323111c$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $4014b6467323111c$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bed1e5a6c043e848$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $07353e1c1419fadf$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $bed1e5a6c043e848$var$firstHiddenTime = timeStamp;
    }, true);
};
const $bed1e5a6c043e848$export$443f86b2c77012c4 = ()=>{
    if ($bed1e5a6c043e848$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bed1e5a6c043e848$var$initHiddenTime();
        $bed1e5a6c043e848$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $bed1e5a6c043e848$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $38fe17c7165eaccd$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $bed1e5a6c043e848$export$443f86b2c77012c4)();
    const metric = (0, $f2ac6bfc5936fa34$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $e7ca6c75f33afecd$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $5e4a4adad8274fb4$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $07353e1c1419fadf$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $ee196849edd3f7b1$var$interactionCountEstimate = 0;
let $ee196849edd3f7b1$var$minKnownInteractionId = Infinity;
let $ee196849edd3f7b1$var$maxKnownInteractionId = 0;
const $ee196849edd3f7b1$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $ee196849edd3f7b1$var$minKnownInteractionId = Math.min($ee196849edd3f7b1$var$minKnownInteractionId, e.interactionId);
            $ee196849edd3f7b1$var$maxKnownInteractionId = Math.max($ee196849edd3f7b1$var$maxKnownInteractionId, e.interactionId);
            $ee196849edd3f7b1$var$interactionCountEstimate = $ee196849edd3f7b1$var$maxKnownInteractionId ? ($ee196849edd3f7b1$var$maxKnownInteractionId - $ee196849edd3f7b1$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $ee196849edd3f7b1$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $ee196849edd3f7b1$export$8a962f2683a476d1 = ()=>{
    return $ee196849edd3f7b1$var$po ? $ee196849edd3f7b1$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $ee196849edd3f7b1$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $ee196849edd3f7b1$var$po) return;
    $ee196849edd3f7b1$var$po = (0, $e7ca6c75f33afecd$export$d1203567a167490e)("event", $ee196849edd3f7b1$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $3c1c708a4329d5d8$var$getInteractionCountForNavigation = ()=>{
    return (0, $ee196849edd3f7b1$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $3c1c708a4329d5d8$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $3c1c708a4329d5d8$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $3c1c708a4329d5d8$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $3c1c708a4329d5d8$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $3c1c708a4329d5d8$var$longestInteractionList[$3c1c708a4329d5d8$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $3c1c708a4329d5d8$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $3c1c708a4329d5d8$var$longestInteractionList.length < $3c1c708a4329d5d8$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $3c1c708a4329d5d8$var$longestInteractionMap[interaction.id] = interaction;
            $3c1c708a4329d5d8$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $3c1c708a4329d5d8$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $3c1c708a4329d5d8$var$longestInteractionList.splice($3c1c708a4329d5d8$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $3c1c708a4329d5d8$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $3c1c708a4329d5d8$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($3c1c708a4329d5d8$var$longestInteractionList.length - 1, Math.floor($3c1c708a4329d5d8$var$getInteractionCountForNavigation() / 50));
    return $3c1c708a4329d5d8$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3c1c708a4329d5d8$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $ee196849edd3f7b1$export$67d90cda6b78a2eb)();
    const metric = (0, $f2ac6bfc5936fa34$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $3c1c708a4329d5d8$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$3c1c708a4329d5d8$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $3c1c708a4329d5d8$var$processEntry(entry);
            }
        });
        const inp = $3c1c708a4329d5d8$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $e7ca6c75f33afecd$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $5e4a4adad8274fb4$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $07353e1c1419fadf$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $3c1c708a4329d5d8$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $23cf07b59fd375b3$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $23cf07b59fd375b3$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $bed1e5a6c043e848$export$443f86b2c77012c4)();
    const metric = (0, $f2ac6bfc5936fa34$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $a7f7921d05271e73$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $e7ca6c75f33afecd$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $5e4a4adad8274fb4$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$23cf07b59fd375b3$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $23cf07b59fd375b3$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $07353e1c1419fadf$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $7f04373944188f0c$var$whenReady = (callback)=>{
    if (!(0, $4014b6467323111c$export$56d8a8a25bd48b81).document) return;
    if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$7f04373944188f0c$var$whenReady(callback), true);
    else if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$7f04373944188f0c$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $7f04373944188f0c$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $f2ac6bfc5936fa34$export$3c29b44508a0612b)("TTFB");
    const report = (0, $5e4a4adad8274fb4$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $7f04373944188f0c$var$whenReady(()=>{
        const navEntry = (0, $791345e152841cd9$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $a7f7921d05271e73$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $29db847506b9b5a1$var$handlers = {};
const $29db847506b9b5a1$var$instrumented = {};
let $29db847506b9b5a1$var$_previousCls;
let $29db847506b9b5a1$var$_previousFid;
let $29db847506b9b5a1$var$_previousLcp;
let $29db847506b9b5a1$var$_previousTtfb;
let $29db847506b9b5a1$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $29db847506b9b5a1$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $29db847506b9b5a1$var$addMetricObserver("cls", callback, $29db847506b9b5a1$var$instrumentCls, $29db847506b9b5a1$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $29db847506b9b5a1$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $29db847506b9b5a1$var$addMetricObserver("lcp", callback, $29db847506b9b5a1$var$instrumentLcp, $29db847506b9b5a1$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $29db847506b9b5a1$export$699d9529c099a797(callback) {
    return $29db847506b9b5a1$var$addMetricObserver("ttfb", callback, $29db847506b9b5a1$var$instrumentTtfb, $29db847506b9b5a1$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $29db847506b9b5a1$export$2707d7471c0b918f(callback) {
    return $29db847506b9b5a1$var$addMetricObserver("fid", callback, $29db847506b9b5a1$var$instrumentFid, $29db847506b9b5a1$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $29db847506b9b5a1$export$da3b76aa2022cbd7(callback) {
    return $29db847506b9b5a1$var$addMetricObserver("inp", callback, $29db847506b9b5a1$var$instrumentInp, $29db847506b9b5a1$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $29db847506b9b5a1$export$69816c1a049f8db6(type, callback) {
    $29db847506b9b5a1$var$addHandler(type, callback);
    if (!$29db847506b9b5a1$var$instrumented[type]) {
        $29db847506b9b5a1$var$instrumentPerformanceObserver(type);
        $29db847506b9b5a1$var$instrumented[type] = true;
    }
    return $29db847506b9b5a1$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $29db847506b9b5a1$var$triggerHandlers(type, data) {
    const typeHandlers = $29db847506b9b5a1$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $29db847506b9b5a1$var$instrumentCls() {
    return (0, $39f8509ae1e9cb19$export$a7873055838e5ad8)((metric)=>{
        $29db847506b9b5a1$var$triggerHandlers("cls", {
            metric: metric
        });
        $29db847506b9b5a1$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $29db847506b9b5a1$var$instrumentFid() {
    return (0, $38fe17c7165eaccd$export$39705a25c49af873)((metric)=>{
        $29db847506b9b5a1$var$triggerHandlers("fid", {
            metric: metric
        });
        $29db847506b9b5a1$var$_previousFid = metric;
    });
}
function $29db847506b9b5a1$var$instrumentLcp() {
    return (0, $23cf07b59fd375b3$export$947b1626ab8d5632)((metric)=>{
        $29db847506b9b5a1$var$triggerHandlers("lcp", {
            metric: metric
        });
        $29db847506b9b5a1$var$_previousLcp = metric;
    });
}
function $29db847506b9b5a1$var$instrumentTtfb() {
    return (0, $7f04373944188f0c$export$33a01e6c5f2c7e33)((metric)=>{
        $29db847506b9b5a1$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $29db847506b9b5a1$var$_previousTtfb = metric;
    });
}
function $29db847506b9b5a1$var$instrumentInp() {
    return (0, $3c1c708a4329d5d8$export$7df4b36ecaed99e1)((metric)=>{
        $29db847506b9b5a1$var$triggerHandlers("inp", {
            metric: metric
        });
        $29db847506b9b5a1$var$_previousInp = metric;
    });
}
function $29db847506b9b5a1$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $29db847506b9b5a1$var$addHandler(type, callback);
    let stopListening;
    if (!$29db847506b9b5a1$var$instrumented[type]) {
        stopListening = instrumentFn();
        $29db847506b9b5a1$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $29db847506b9b5a1$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $29db847506b9b5a1$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $e7ca6c75f33afecd$export$d1203567a167490e)(type, (entries)=>{
        $29db847506b9b5a1$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $29db847506b9b5a1$var$addHandler(type, handler) {
    $29db847506b9b5a1$var$handlers[type] = $29db847506b9b5a1$var$handlers[type] || [];
    $29db847506b9b5a1$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $29db847506b9b5a1$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $29db847506b9b5a1$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $3ab8e6b6875d3feb$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $3ab8e6b6875d3feb$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $3ab8e6b6875d3feb$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $3ab8e6b6875d3feb$export$b892860177f70a30(str) {
    const match = $3ab8e6b6875d3feb$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $2bd19015b7869ed8$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $3ab8e6b6875d3feb$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $3ab8e6b6875d3feb$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $3ab8e6b6875d3feb$var$validateDsn(dsn) {
    if (!(0, $3549cd95261873e2$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$3ab8e6b6875d3feb$var$isValidProtocol(protocol)) {
        (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $3ab8e6b6875d3feb$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $3ab8e6b6875d3feb$export$b892860177f70a30(from) : $3ab8e6b6875d3feb$var$dsnFromComponents(from);
    if (!components || !$3ab8e6b6875d3feb$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ddd7798536c68ec2$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ddd7798536c68ec2$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $ddd7798536c68ec2$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $ddd7798536c68ec2$export$604a45d95a155e2b(envelope, types) {
    return $ddd7798536c68ec2$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $ddd7798536c68ec2$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $ddd7798536c68ec2$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $ddd7798536c68ec2$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $ddd7798536c68ec2$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $458193ce2072e151$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $ddd7798536c68ec2$var$concatBuffers(parts);
}
function $ddd7798536c68ec2$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $ddd7798536c68ec2$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $ddd7798536c68ec2$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $ddd7798536c68ec2$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $a4503473509e6905$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $ddd7798536c68ec2$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $ddd7798536c68ec2$export$b11169581eeaf237(type) {
    return $ddd7798536c68ec2$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $ddd7798536c68ec2$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $ddd7798536c68ec2$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $a4503473509e6905$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $80b0d42bd64214a9$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(dsn);
    const items = spans.map($80b0d42bd64214a9$var$createSpanItem);
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(headers, items);
}
function $80b0d42bd64214a9$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $9e0679508ae4db4a$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $853e78b4012bf61e$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $853e78b4012bf61e$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $853e78b4012bf61e$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $853e78b4012bf61e$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $422c081df250a4e1$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $422c081df250a4e1$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $83230636b5a8bab7$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $83230636b5a8bab7$var$msToSec(time) {
    return time / 1000;
}
function $83230636b5a8bab7$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $4014b6467323111c$export$56d8a8a25bd48b81) && (0, $4014b6467323111c$export$56d8a8a25bd48b81).addEventListener && (0, $4014b6467323111c$export$56d8a8a25bd48b81).performance;
}
let $83230636b5a8bab7$var$_performanceCursor = 0;
let $83230636b5a8bab7$var$_measurements = {};
let $83230636b5a8bab7$var$_lcpEntry;
let $83230636b5a8bab7$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $83230636b5a8bab7$export$7c69f0412d101b88() {
    const performance = $83230636b5a8bab7$var$getBrowserPerformanceAPI();
    if (performance && (0, $579f76a2b219152d$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $4014b6467323111c$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $83230636b5a8bab7$var$_trackFID();
        const clsCallback = $83230636b5a8bab7$var$_trackCLS();
        const lcpCallback = $83230636b5a8bab7$var$_trackLCP();
        const ttfbCallback = $83230636b5a8bab7$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $83230636b5a8bab7$export$f396d19077034ad2() {
    (0, $29db847506b9b5a1$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $83230636b5a8bab7$var$msToSec((0, $579f76a2b219152d$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $83230636b5a8bab7$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $83230636b5a8bab7$export$e27543e0976315e4() {
    (0, $29db847506b9b5a1$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $83230636b5a8bab7$var$msToSec((0, $579f76a2b219152d$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $83230636b5a8bab7$var$msToSec(entry.duration);
                const span = {
                    description: (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $bec17cc7ed6c6bca$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $83230636b5a8bab7$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $83230636b5a8bab7$var$getBrowserPerformanceAPI();
    if (performance && (0, $579f76a2b219152d$export$baf075a948ffc0bf)) {
        const inpCallback = $83230636b5a8bab7$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $83230636b5a8bab7$var$_trackCLS() {
    return (0, $29db847506b9b5a1$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $83230636b5a8bab7$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $83230636b5a8bab7$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $83230636b5a8bab7$var$_trackLCP() {
    return (0, $29db847506b9b5a1$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $83230636b5a8bab7$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $83230636b5a8bab7$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $83230636b5a8bab7$var$_trackFID() {
    return (0, $29db847506b9b5a1$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $83230636b5a8bab7$var$msToSec((0, $579f76a2b219152d$export$baf075a948ffc0bf));
        const startTime = $83230636b5a8bab7$var$msToSec(entry.startTime);
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $83230636b5a8bab7$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $83230636b5a8bab7$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $83230636b5a8bab7$var$_trackTtfb() {
    return (0, $29db847506b9b5a1$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $83230636b5a8bab7$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $83230636b5a8bab7$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $83230636b5a8bab7$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $29db847506b9b5a1$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $83230636b5a8bab7$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $83230636b5a8bab7$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $83230636b5a8bab7$var$msToSec((0, $579f76a2b219152d$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $83230636b5a8bab7$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $3bb0d593b2ee70d6$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $83230636b5a8bab7$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $80b0d42bd64214a9$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $83230636b5a8bab7$export$5f8fa6b3467a7443(transaction) {
    const performance = $83230636b5a8bab7$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $4014b6467323111c$export$56d8a8a25bd48b81).performance.getEntries || !(0, $579f76a2b219152d$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $83230636b5a8bab7$var$msToSec((0, $579f76a2b219152d$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $750851faedae500f$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($83230636b5a8bab7$var$_performanceCursor).forEach((entry)=>{
        const startTime = $83230636b5a8bab7$var$msToSec(entry.startTime);
        const duration = $83230636b5a8bab7$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $83230636b5a8bab7$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $83230636b5a8bab7$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bed1e5a6c043e848$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $83230636b5a8bab7$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $83230636b5a8bab7$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $83230636b5a8bab7$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $83230636b5a8bab7$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $83230636b5a8bab7$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $83230636b5a8bab7$var$_addTtfbRequestTimeToMeasurements($83230636b5a8bab7$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$83230636b5a8bab7$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $83230636b5a8bab7$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $83230636b5a8bab7$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $83230636b5a8bab7$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $83230636b5a8bab7$var$_measurements["mark.fid"];
        if (fidMark && $83230636b5a8bab7$var$_measurements["fid"]) {
            // create span for FID
            (0, $422c081df250a4e1$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $83230636b5a8bab7$var$msToSec($83230636b5a8bab7$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $83230636b5a8bab7$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $83230636b5a8bab7$var$_measurements)) delete $83230636b5a8bab7$var$_measurements.cls;
        Object.keys($83230636b5a8bab7$var$_measurements).forEach((measurementName)=>{
            (0, $9e0679508ae4db4a$export$7cc31b475d33a706)(measurementName, $83230636b5a8bab7$var$_measurements[measurementName].value, $83230636b5a8bab7$var$_measurements[measurementName].unit);
        });
        $83230636b5a8bab7$var$_tagMetricInfo(transaction);
    }
    $83230636b5a8bab7$var$_lcpEntry = undefined;
    $83230636b5a8bab7$var$_clsEntry = undefined;
    $83230636b5a8bab7$var$_measurements = {};
}
/** Create measure related spans */ function $83230636b5a8bab7$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $422c081df250a4e1$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $83230636b5a8bab7$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $83230636b5a8bab7$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $83230636b5a8bab7$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $83230636b5a8bab7$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $83230636b5a8bab7$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $83230636b5a8bab7$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $83230636b5a8bab7$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $422c081df250a4e1$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $83230636b5a8bab7$var$msToSec(start),
        endTimestamp: timeOrigin + $83230636b5a8bab7$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $83230636b5a8bab7$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $422c081df250a4e1$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $83230636b5a8bab7$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $83230636b5a8bab7$var$msToSec(entry.responseEnd)
        });
        (0, $422c081df250a4e1$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $83230636b5a8bab7$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $83230636b5a8bab7$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $83230636b5a8bab7$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $853e78b4012bf61e$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $83230636b5a8bab7$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $83230636b5a8bab7$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $83230636b5a8bab7$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $4014b6467323111c$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $422c081df250a4e1$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $4014b6467323111c$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $83230636b5a8bab7$var$_trackNavigator(transaction) {
    const navigator = (0, $4014b6467323111c$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $422c081df250a4e1$export$27169ccae1b439e3)(connection.rtt)) $83230636b5a8bab7$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $422c081df250a4e1$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $422c081df250a4e1$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $83230636b5a8bab7$var$_tagMetricInfo(transaction) {
    if ($83230636b5a8bab7$var$_lcpEntry) {
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($83230636b5a8bab7$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)($83230636b5a8bab7$var$_lcpEntry.element));
        if ($83230636b5a8bab7$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $83230636b5a8bab7$var$_lcpEntry.id);
        if ($83230636b5a8bab7$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $83230636b5a8bab7$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $83230636b5a8bab7$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($83230636b5a8bab7$var$_clsEntry && $83230636b5a8bab7$var$_clsEntry.sources) {
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $83230636b5a8bab7$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(source.node)));
    }
}
function $83230636b5a8bab7$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $83230636b5a8bab7$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $83230636b5a8bab7$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $791345e152841cd9$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $83230636b5a8bab7$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $b0e54440d83352e4$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $4014b6467323111c$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $a202afed95055bdd$export$2603c8d332a51c42)(sampleRate)) {
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $3da2b5d85b33da30$var$WINDOW = (0, $7bc2b85f84f1fb97$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $3da2b5d85b33da30$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $3da2b5d85b33da30$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $3da2b5d85b33da30$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $3da2b5d85b33da30$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $3da2b5d85b33da30$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3da2b5d85b33da30$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $3da2b5d85b33da30$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$3da2b5d85b33da30$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($3da2b5d85b33da30$export$18cf36ed71d733e7($3da2b5d85b33da30$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $3da2b5d85b33da30$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $3da2b5d85b33da30$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $3549cd95261873e2$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $3da2b5d85b33da30$export$531055a6c684a70a() {
    return "ReportingObserver" in $3da2b5d85b33da30$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $3da2b5d85b33da30$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$3da2b5d85b33da30$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $806c2415d1487b82$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $806c2415d1487b82$var$instrumentFetch);
}
function $806c2415d1487b82$var$instrumentFetch() {
    if (!(0, $3da2b5d85b33da30$export$c82d238e23c40b21)()) return;
    (0, $a4503473509e6905$export$9563e054e6f787fb)((0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $806c2415d1487b82$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $97cf2caf887a1678$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $97cf2caf887a1678$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $97cf2caf887a1678$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $806c2415d1487b82$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $806c2415d1487b82$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($806c2415d1487b82$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $806c2415d1487b82$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $806c2415d1487b82$var$getUrlFromResource(url),
            method: $806c2415d1487b82$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $806c2415d1487b82$var$getUrlFromResource(arg),
        method: $806c2415d1487b82$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $e4bb6fb96ec6ca73$var$WINDOW = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
const $e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e4bb6fb96ec6ca73$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $e4bb6fb96ec6ca73$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $e4bb6fb96ec6ca73$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$e4bb6fb96ec6ca73$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $a4503473509e6905$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $26965e7f4b3c51e7$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $e4bb6fb96ec6ca73$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $97cf2caf887a1678$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $a4503473509e6905$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $a4503473509e6905$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $26965e7f4b3c51e7$export$844ec244b1367d54)(header) && (0, $26965e7f4b3c51e7$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $a4503473509e6905$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $97cf2caf887a1678$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $e4bb6fb96ec6ca73$var$parseUrl(url) {
    if ((0, $26965e7f4b3c51e7$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $f6c81b6a8f9aac61$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $b0e54440d83352e4$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $f6c81b6a8f9aac61$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $f6c81b6a8f9aac61$var$getFullURL(url);
    const host = fullUrl ? (0, $853e78b4012bf61e$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $a22b4e9d1ae7de18$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $b8adcea182c00730$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $f6c81b6a8f9aac61$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $f6c81b6a8f9aac61$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $750851faedae500f$export$7e9f8ae9e4a328ab)(span) : (0, $c738bc01dada2b49$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $45a99172e2665bf8$export$56766feef403f365)(dsc || (span ? (0, $b7892217fe0631f5$export$a117f995597e25df)(span) : (0, $b7892217fe0631f5$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $26965e7f4b3c51e7$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $26965e7f4b3c51e7$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $45a99172e2665bf8$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $45a99172e2665bf8$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $f6c81b6a8f9aac61$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $f6c81b6a8f9aac61$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $791c69c8711e0dc9$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $5973dd7427bb4ba7$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $5973dd7427bb4ba7$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $5973dd7427bb4ba7$export$15bd0305d05ad07b,
    tracePropagationTargets: $5973dd7427bb4ba7$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $5973dd7427bb4ba7$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $5973dd7427bb4ba7$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $5973dd7427bb4ba7$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$5973dd7427bb4ba7$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $806c2415d1487b82$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $f6c81b6a8f9aac61$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $5973dd7427bb4ba7$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $853e78b4012bf61e$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $5973dd7427bb4ba7$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $e4bb6fb96ec6ca73$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $5973dd7427bb4ba7$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $5973dd7427bb4ba7$var$addHTTPTimings(createdSpan);
    });
}
function $5973dd7427bb4ba7$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $5973dd7427bb4ba7$var$addHTTPTimings(span) {
    const { url: url } = (0, $750851faedae500f$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $29db847506b9b5a1$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($5973dd7427bb4ba7$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $5973dd7427bb4ba7$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $5973dd7427bb4ba7$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $5973dd7427bb4ba7$var$getAbsoluteTime(time = 0) {
    return (((0, $579f76a2b219152d$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $5973dd7427bb4ba7$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $5973dd7427bb4ba7$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $579f76a2b219152d$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $5973dd7427bb4ba7$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $5973dd7427bb4ba7$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $2ce85545280315e6$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $5973dd7427bb4ba7$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $5973dd7427bb4ba7$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
    if (!(0, $b0e54440d83352e4$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $791c69c8711e0dc9$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    const isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)();
    const fullUrl = $5973dd7427bb4ba7$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $853e78b4012bf61e$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $a22b4e9d1ae7de18$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $b8adcea182c00730$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $750851faedae500f$export$7e9f8ae9e4a328ab)(span) : (0, $c738bc01dada2b49$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $45a99172e2665bf8$export$56766feef403f365)(dsc || (span ? (0, $b7892217fe0631f5$export$a117f995597e25df)(span) : (0, $b7892217fe0631f5$export$366bad00d6815eed)(traceId, client, scope)));
        $5973dd7427bb4ba7$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $5973dd7427bb4ba7$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $45a99172e2665bf8$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $5973dd7427bb4ba7$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $4014b6467323111c$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $9dd75972e56bcbb6$var$WINDOW = (0, $7bc2b85f84f1fb97$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $9dd75972e56bcbb6$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $9dd75972e56bcbb6$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $9dd75972e56bcbb6$var$WINDOW && !!$9dd75972e56bcbb6$var$WINDOW.history.pushState && !!$9dd75972e56bcbb6$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $37489a764b40e666$var$WINDOW = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
let $37489a764b40e666$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $37489a764b40e666$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $37489a764b40e666$var$instrumentHistory);
}
function $37489a764b40e666$var$instrumentHistory() {
    if (!(0, $9dd75972e56bcbb6$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $37489a764b40e666$var$WINDOW.onpopstate;
    $37489a764b40e666$var$WINDOW.onpopstate = function(...args) {
        const to = $37489a764b40e666$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $37489a764b40e666$var$lastHref;
        $37489a764b40e666$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $97cf2caf887a1678$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $37489a764b40e666$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $37489a764b40e666$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $97cf2caf887a1678$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $a4503473509e6905$export$9563e054e6f787fb)($37489a764b40e666$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $a4503473509e6905$export$9563e054e6f787fb)($37489a764b40e666$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




/**
 * Default function implementing pageload and navigation transactions
 */ function $47eee37bcf6331ea$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $4014b6467323111c$export$56d8a8a25bd48b81) || !(0, $4014b6467323111c$export$56d8a8a25bd48b81).location) {
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $4014b6467323111c$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $4014b6467323111c$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $579f76a2b219152d$export$baf075a948ffc0bf) ? (0, $579f76a2b219152d$export$baf075a948ffc0bf) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $37489a764b40e666$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $4014b6467323111c$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $eff1881618a97372$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $eff1881618a97372$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $c8dc185fd7d9c9e4$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $47eee37bcf6331ea$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $5973dd7427bb4ba7$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $eff1881618a97372$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $eff1881618a97372$export$46d3bbd0375f5fa4 {
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $45add5f716865713$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $5973dd7427bb4ba7$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $eff1881618a97372$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $eff1881618a97372$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $c738bc01dada2b49$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $4014b6467323111c$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $506b5ddf0f62f730$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document) {
                (0, $4014b6467323111c$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, $4014b6467323111c$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $4014b6467323111c$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $83230636b5a8bab7$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $4014b6467323111c$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $b8adcea182c00730$export$d7a7d984b0791405)]: this._latestRoute.context ? $eff1881618a97372$var$getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, $506b5ddf0f62f730$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, $4014b6467323111c$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $a1bb097315d33d7b$export$a7feb32fdd923295)();
            const currentScope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($eff1881618a97372$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $eff1881618a97372$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $eff1881618a97372$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $29db847506b9b5a1$export$69816c1a049f8db6)("event", handleEntries);
        (0, $29db847506b9b5a1$export$69816c1a049f8db6)("first-input", handleEntries);
    }
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $eff1881618a97372$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $506b5ddf0f62f730$export$653d0ef2bad9cdf9)();
        if (0, $4cd2215f9a33fd2e$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$eff1881618a97372$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $83230636b5a8bab7$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $83230636b5a8bab7$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $83230636b5a8bab7$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $83230636b5a8bab7$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
}
/** Returns the value of a meta tag */ function $eff1881618a97372$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $bec17cc7ed6c6bca$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $eff1881618a97372$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $b8adcea182c00730$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $b8adcea182c00730$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $eff1881618a97372$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}








const $a72c16e1d374cf39$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $a72c16e1d374cf39$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $a72c16e1d374cf39$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $65daed3d61181daa$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $a72c16e1d374cf39$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $a72c16e1d374cf39$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $a72c16e1d374cf39$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $a72c16e1d374cf39$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $a72c16e1d374cf39$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $a72c16e1d374cf39$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($a72c16e1d374cf39$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $d37f32692ebac6bd$export$8e4e25f54d456511), (0, $35009d14216a34ba$export$a07cdf6544bbd7c));
        $a72c16e1d374cf39$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $a72c16e1d374cf39$export$2d8f5188773bcddd(integration) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $a72c16e1d374cf39$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $a72c16e1d374cf39$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $a72c16e1d374cf39$export$2323046b9414659f(fn) {
    return fn;
}


let $19a24d0a86859965$var$originalFunctionToString;
const $19a24d0a86859965$var$INTEGRATION_NAME = "FunctionToString";
const $19a24d0a86859965$var$SETUP_CLIENTS = new WeakMap();
const $19a24d0a86859965$var$_functionToStringIntegration = ()=>{
    return {
        name: $19a24d0a86859965$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $19a24d0a86859965$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $a4503473509e6905$export$e6cc1e135e2092e5)(this);
                    const context = $19a24d0a86859965$var$SETUP_CLIENTS.has((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $19a24d0a86859965$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $19a24d0a86859965$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $19a24d0a86859965$export$7918117e9202e4fb = (0, $a72c16e1d374cf39$export$2323046b9414659f)($19a24d0a86859965$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $19a24d0a86859965$export$da4704525c20ae79 = (0, $a72c16e1d374cf39$export$afa219bf23651160)($19a24d0a86859965$var$INTEGRATION_NAME, $19a24d0a86859965$export$7918117e9202e4fb);


const $5f6b1ac02dacf7c1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $5f6b1ac02dacf7c1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $5f6b1ac02dacf7c1$var$_getIngestEndpoint(dsn) {
    return `${$5f6b1ac02dacf7c1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $5f6b1ac02dacf7c1$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $a4503473509e6905$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $5f6b1ac02dacf7c1$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $5f6b1ac02dacf7c1$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$5f6b1ac02dacf7c1$var$_getIngestEndpoint(dsn)}?${$5f6b1ac02dacf7c1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $5f6b1ac02dacf7c1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $3ab8e6b6875d3feb$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$5f6b1ac02dacf7c1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $37a3a1081cb310eb$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $37a3a1081cb310eb$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $37a3a1081cb310eb$var$INTEGRATION_NAME = "InboundFilters";
const $37a3a1081cb310eb$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $37a3a1081cb310eb$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $37a3a1081cb310eb$var$_mergeOptions(options, clientOptions);
            return $37a3a1081cb310eb$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $37a3a1081cb310eb$export$cb3c5c2ceb9818ba = (0, $a72c16e1d374cf39$export$2323046b9414659f)($37a3a1081cb310eb$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $37a3a1081cb310eb$export$2ffbb5359dcc6be4 = (0, $a72c16e1d374cf39$export$afa219bf23651160)($37a3a1081cb310eb$var$INTEGRATION_NAME, $37a3a1081cb310eb$export$cb3c5c2ceb9818ba);
function $37a3a1081cb310eb$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $37a3a1081cb310eb$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $37a3a1081cb310eb$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $37a3a1081cb310eb$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $37a3a1081cb310eb$var$_isSentryError(event)) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($37a3a1081cb310eb$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($37a3a1081cb310eb$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($37a3a1081cb310eb$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}.\nUrl: ${$37a3a1081cb310eb$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$37a3a1081cb310eb$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}.\nUrl: ${$37a3a1081cb310eb$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $37a3a1081cb310eb$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $37a3a1081cb310eb$var$_getPossibleEventMessages(event).some((message)=>(0, $2ce85545280315e6$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $37a3a1081cb310eb$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $2ce85545280315e6$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $37a3a1081cb310eb$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $37a3a1081cb310eb$var$_getEventFilterUrl(event);
    return !url ? false : (0, $2ce85545280315e6$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $37a3a1081cb310eb$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $37a3a1081cb310eb$var$_getEventFilterUrl(event);
    return !url ? true : (0, $2ce85545280315e6$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $37a3a1081cb310eb$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $5030e00c131eea58$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $37a3a1081cb310eb$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $37a3a1081cb310eb$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $37a3a1081cb310eb$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $37a3a1081cb310eb$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $65daed3d61181daa$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $fa6adb73b7e41f22$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $5030e00c131eea58$export$16a28057038b10ef) (0, $2bd19015b7869ed8$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $2bd19015b7869ed8$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $fa6adb73b7e41f22$export$ecb76f41d43c0e43(client);
    $fa6adb73b7e41f22$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $fa6adb73b7e41f22$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $fa6adb73b7e41f22$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $8d6d8fa29480b658$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $eeaeda57c0b5ba08$export$31499a9cd224b78c)
            })),
        version: (0, $eeaeda57c0b5ba08$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $db543b1659d52b2d$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $92ed77a93b22a11f$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $92ed77a93b22a11f$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ddd7798536c68ec2$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $92ed77a93b22a11f$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ddd7798536c68ec2$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $92ed77a93b22a11f$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $ddd7798536c68ec2$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $b730e2f2e5e158f0$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $a4503473509e6905$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $b730e2f2e5e158f0$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $b730e2f2e5e158f0$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $b730e2f2e5e158f0$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $b730e2f2e5e158f0$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $b730e2f2e5e158f0$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $b730e2f2e5e158f0$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $b730e2f2e5e158f0$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $b730e2f2e5e158f0$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $b730e2f2e5e158f0$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $b730e2f2e5e158f0$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $b730e2f2e5e158f0$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $b730e2f2e5e158f0$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $b730e2f2e5e158f0$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $59ddd341e243efe7$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(dsn);
    const item = $59ddd341e243efe7$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $59ddd341e243efe7$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $b730e2f2e5e158f0$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $9e83634a1d36543d$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $9e83634a1d36543d$export$4f22f74eddb7716a {
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $65daed3d61181daa$export$6de4ffac6a2f1098)(exception)) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log($9e83634a1d36543d$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $26965e7f4b3c51e7$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $26965e7f4b3c51e7$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $65daed3d61181daa$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log($9e83634a1d36543d$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $d4f7cdbed5b8ce9e$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $a72c16e1d374cf39$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $a72c16e1d374cf39$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $92ed77a93b22a11f$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $ddd7798536c68ec2$export$d650323442802f6f)(env, (0, $ddd7798536c68ec2$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $92ed77a93b22a11f$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $59ddd341e243efe7$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $a72c16e1d374cf39$export$51abed9797baa598)(this, integrations);
        (0, $a72c16e1d374cf39$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $d4f7cdbed5b8ce9e$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $d0bb8be585a0f1f4$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $35009d14216a34ba$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $0b9a24c8403b5f2a$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $b7892217fe0631f5$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $5030e00c131eea58$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $9e83634a1d36543d$var$isTransactionEvent(event);
        const isError = $9e83634a1d36543d$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $d0bb8be585a0f1f4$export$78e43115b553f358)(new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $9e83634a1d36543d$var$processBeforeSend(options, prepared, hint);
            return $9e83634a1d36543d$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $3ab8e6b6875d3feb$export$128827c3562ec0cb)(options.dsn);
        else (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $5f6b1ac02dacf7c1$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $9e83634a1d36543d$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $26965e7f4b3c51e7$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $26965e7f4b3c51e7$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $26965e7f4b3c51e7$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $9e83634a1d36543d$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($9e83634a1d36543d$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($9e83634a1d36543d$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $9e83634a1d36543d$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $9e83634a1d36543d$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $9e83634a1d36543d$export$9aac0b9f77928fbf(callback) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $4c375c8caf601f04$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $579f76a2b219152d$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $dylH1 = parcelRequire("dylH1");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0b82046eb15ea62$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $dc20ec07bee77b64$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $dc20ec07bee77b64$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $dc20ec07bee77b64$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $dc20ec07bee77b64$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $26965e7f4b3c51e7$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $dc20ec07bee77b64$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $458193ce2072e151$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $dc20ec07bee77b64$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $dc20ec07bee77b64$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $dc20ec07bee77b64$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $dc20ec07bee77b64$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $dc20ec07bee77b64$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $dc20ec07bee77b64$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $dc20ec07bee77b64$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($dc20ec07bee77b64$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dc20ec07bee77b64$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $dc20ec07bee77b64$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $dc20ec07bee77b64$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $65daed3d61181daa$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $dc20ec07bee77b64$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $dc20ec07bee77b64$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $dc20ec07bee77b64$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $26965e7f4b3c51e7$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $dc20ec07bee77b64$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $26965e7f4b3c51e7$export$ef9e2056653f0c8e)(exception) || (0, $26965e7f4b3c51e7$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $dc20ec07bee77b64$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $26965e7f4b3c51e7$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $dc20ec07bee77b64$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $65daed3d61181daa$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $26965e7f4b3c51e7$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $dc20ec07bee77b64$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $26965e7f4b3c51e7$export$53b83ca8eaab0383)(exception) || (0, $26965e7f4b3c51e7$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $dc20ec07bee77b64$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $65daed3d61181daa$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $dc20ec07bee77b64$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $65daed3d61181daa$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $65daed3d61181daa$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $dc20ec07bee77b64$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $dc20ec07bee77b64$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $26965e7f4b3c51e7$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $dc20ec07bee77b64$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $a4503473509e6905$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $26965e7f4b3c51e7$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $26965e7f4b3c51e7$export$9671ea99bd126ace)(exception)) {
        const className = $dc20ec07bee77b64$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $dc20ec07bee77b64$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $9b6d3be157f87479$export$56d8a8a25bd48b81 = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
let $9b6d3be157f87479$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9b6d3be157f87479$export$b79738ab10c590b2() {
    return $9b6d3be157f87479$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9b6d3be157f87479$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9b6d3be157f87479$var$ignoreOnError++;
    setTimeout(()=>{
        $9b6d3be157f87479$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9b6d3be157f87479$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $a4503473509e6905$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9b6d3be157f87479$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9b6d3be157f87479$export$1265a142ff5ba165();
            (0, $fe010f6f6efcb5f1$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $65daed3d61181daa$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $65daed3d61181daa$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $fe010f6f6efcb5f1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $a4503473509e6905$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $a4503473509e6905$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $1140920b17fdbb1a$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $1140920b17fdbb1a$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $1140920b17fdbb1a$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $e59df057b65fcbfb$export$1df9218a526d318d extends (0, $9e83634a1d36543d$export$4f22f74eddb7716a) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $dc20ec07bee77b64$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $dc20ec07bee77b64$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $1140920b17fdbb1a$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $4c375c8caf601f04$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $3ab8e6b6875d3feb$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $dylH1.getSDKSource)();
        (0, $8d6d8fa29480b658$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document) (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
}









const $dd2aff0520204ee9$var$WINDOW = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
const $dd2aff0520204ee9$var$DEBOUNCE_DURATION = 1000;
let $dd2aff0520204ee9$var$debounceTimerID;
let $dd2aff0520204ee9$var$lastCapturedEventType;
let $dd2aff0520204ee9$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dd2aff0520204ee9$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $dd2aff0520204ee9$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $dd2aff0520204ee9$export$3014bbf0af0e1d4a() {
    if (!$dd2aff0520204ee9$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $97cf2caf887a1678$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $dd2aff0520204ee9$var$makeDOMEventHandler(triggerDOMHandler, true);
    $dd2aff0520204ee9$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $dd2aff0520204ee9$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $dd2aff0520204ee9$var$WINDOW[target] && $dd2aff0520204ee9$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $a4503473509e6905$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $dd2aff0520204ee9$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $a4503473509e6905$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $dd2aff0520204ee9$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $dd2aff0520204ee9$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $dd2aff0520204ee9$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $dd2aff0520204ee9$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $dd2aff0520204ee9$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $dd2aff0520204ee9$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($dd2aff0520204ee9$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $a4503473509e6905$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $a4503473509e6905$export$e73679ffaf56810e)(target, "_sentryId", (0, $65daed3d61181daa$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$dd2aff0520204ee9$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $dd2aff0520204ee9$var$lastCapturedEventType = event.type;
            $dd2aff0520204ee9$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($dd2aff0520204ee9$var$debounceTimerID);
        $dd2aff0520204ee9$var$debounceTimerID = $dd2aff0520204ee9$var$WINDOW.setTimeout(()=>{
            $dd2aff0520204ee9$var$lastCapturedEventTargetId = undefined;
            $dd2aff0520204ee9$var$lastCapturedEventType = undefined;
        }, $dd2aff0520204ee9$var$DEBOUNCE_DURATION);
    };
}
function $dd2aff0520204ee9$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bd1846203888a895$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $97cf2caf887a1678$export$a4e09611e30da72e)(type, handler);
    (0, $97cf2caf887a1678$export$e18d6c5462c01368)(type, $bd1846203888a895$var$instrumentConsole);
}
function $bd1846203888a895$var$instrumentConsole() {
    if (!("console" in (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1))) return;
    (0, $2bd19015b7869ed8$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).console)) return;
        (0, $a4503473509e6905$export$9563e054e6f787fb)((0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $2bd19015b7869ed8$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $97cf2caf887a1678$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $2bd19015b7869ed8$export$77c4ce905194557b)[level];
                log && log.apply((0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $adebbfeccd07b3f0$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $adebbfeccd07b3f0$export$e01cef29b4327697(level) {
    return $adebbfeccd07b3f0$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $adebbfeccd07b3f0$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $adebbfeccd07b3f0$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $56f4792f9a6d0db0$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $56f4792f9a6d0db0$var$INTEGRATION_NAME = "Breadcrumbs";
const $56f4792f9a6d0db0$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $56f4792f9a6d0db0$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $bd1846203888a895$export$1d6e0d073f9e6723)($56f4792f9a6d0db0$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $dd2aff0520204ee9$export$5aeffd3db2cf9df7)($56f4792f9a6d0db0$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $e4bb6fb96ec6ca73$export$26ace48dd54c9aea)($56f4792f9a6d0db0$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $806c2415d1487b82$export$f75d3c772c923df0)($56f4792f9a6d0db0$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $37489a764b40e666$export$3f18c56c58114e75)($56f4792f9a6d0db0$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $56f4792f9a6d0db0$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $56f4792f9a6d0db0$export$c079d904b326663a = (0, $a72c16e1d374cf39$export$2323046b9414659f)($56f4792f9a6d0db0$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $56f4792f9a6d0db0$export$2dc68d50d56fbbd = (0, $a72c16e1d374cf39$export$afa219bf23651160)($56f4792f9a6d0db0$var$INTEGRATION_NAME, $56f4792f9a6d0db0$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $56f4792f9a6d0db0$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client) return;
        (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $65daed3d61181daa$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $56f4792f9a6d0db0$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $56f4792f9a6d0db0$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$56f4792f9a6d0db0$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$56f4792f9a6d0db0$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $56f4792f9a6d0db0$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $56f4792f9a6d0db0$var$_isEvent(event) ? event.target : event;
            target = (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $bec17cc7ed6c6bca$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $56f4792f9a6d0db0$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $adebbfeccd07b3f0$export$d771ef054122c30a)(handlerData.level),
            message: (0, $2ce85545280315e6$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $2ce85545280315e6$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $56f4792f9a6d0db0$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $56f4792f9a6d0db0$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $56f4792f9a6d0db0$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $853e78b4012bf61e$export$7a5253c0f62e0150)((0, $9b6d3be157f87479$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $853e78b4012bf61e$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $853e78b4012bf61e$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $56f4792f9a6d0db0$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $0d843755c0810527$var$INTEGRATION_NAME = "Dedupe";
const $0d843755c0810527$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $0d843755c0810527$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($0d843755c0810527$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $0d843755c0810527$export$6d39aa44cd0c7567 = (0, $a72c16e1d374cf39$export$2323046b9414659f)($0d843755c0810527$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $0d843755c0810527$export$688d98c249d31ad3 = (0, $a72c16e1d374cf39$export$afa219bf23651160)($0d843755c0810527$var$INTEGRATION_NAME, $0d843755c0810527$export$6d39aa44cd0c7567);
function $0d843755c0810527$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($0d843755c0810527$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($0d843755c0810527$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $0d843755c0810527$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$0d843755c0810527$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0d843755c0810527$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $0d843755c0810527$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $0d843755c0810527$var$_getExceptionFromEvent(previousEvent);
    const currentException = $0d843755c0810527$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$0d843755c0810527$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0d843755c0810527$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $0d843755c0810527$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $0d843755c0810527$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $0d843755c0810527$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $0d843755c0810527$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $0d843755c0810527$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $0d843755c0810527$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $d4a1b09e1576fadf$var$INTEGRATION_NAME = "GlobalHandlers";
const $d4a1b09e1576fadf$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $d4a1b09e1576fadf$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $d4a1b09e1576fadf$var$_installGlobalOnErrorHandler(client);
                $d4a1b09e1576fadf$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $d4a1b09e1576fadf$var$_installGlobalOnUnhandledRejectionHandler(client);
                $d4a1b09e1576fadf$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $d4a1b09e1576fadf$export$66acc70e8cf2b71a = (0, $a72c16e1d374cf39$export$2323046b9414659f)($d4a1b09e1576fadf$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d4a1b09e1576fadf$export$204155decbc90e5a = (0, $a72c16e1d374cf39$export$afa219bf23651160)($d4a1b09e1576fadf$var$INTEGRATION_NAME, $d4a1b09e1576fadf$export$66acc70e8cf2b71a);
function $d4a1b09e1576fadf$var$_installGlobalOnErrorHandler(client) {
    (0, $bbcc5af9b3fdfb97$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d4a1b09e1576fadf$var$getOptions();
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client || (0, $9b6d3be157f87479$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $26965e7f4b3c51e7$export$844ec244b1367d54)(msg) ? $d4a1b09e1576fadf$var$_eventFromIncompleteOnError(msg, url, line, column) : $d4a1b09e1576fadf$var$_enhanceEventWithInitialFrame((0, $dc20ec07bee77b64$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $fe010f6f6efcb5f1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $d4a1b09e1576fadf$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $c1d55b0d1edb70e2$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d4a1b09e1576fadf$var$getOptions();
        if ((0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)() !== client || (0, $9b6d3be157f87479$export$b79738ab10c590b2)()) return;
        const error = $d4a1b09e1576fadf$var$_getUnhandledRejectionError(e);
        const event = (0, $26965e7f4b3c51e7$export$c3825b437cbdea5c)(error) ? $d4a1b09e1576fadf$var$_eventFromRejectionWithPrimitive(error) : (0, $dc20ec07bee77b64$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $fe010f6f6efcb5f1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $d4a1b09e1576fadf$var$_getUnhandledRejectionError(error) {
    if ((0, $26965e7f4b3c51e7$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $d4a1b09e1576fadf$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d4a1b09e1576fadf$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $26965e7f4b3c51e7$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $d4a1b09e1576fadf$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d4a1b09e1576fadf$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $26965e7f4b3c51e7$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $bec17cc7ed6c6bca$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $d4a1b09e1576fadf$var$globalHandlerLog(type) {
    (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $d4a1b09e1576fadf$var$getOptions() {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $4b1d8bab25c6b0e6$var$INTEGRATION_NAME = "HttpContext";
const $4b1d8bab25c6b0e6$var$_httpContextIntegration = ()=>{
    return {
        name: $4b1d8bab25c6b0e6$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9b6d3be157f87479$export$56d8a8a25bd48b81).navigator && !(0, $9b6d3be157f87479$export$56d8a8a25bd48b81).location && !(0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).location && (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $4b1d8bab25c6b0e6$export$1378794447170364 = (0, $a72c16e1d374cf39$export$2323046b9414659f)($4b1d8bab25c6b0e6$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4b1d8bab25c6b0e6$export$5d2ee9a544b09a94 = (0, $a72c16e1d374cf39$export$afa219bf23651160)($4b1d8bab25c6b0e6$var$INTEGRATION_NAME, $4b1d8bab25c6b0e6$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $ed6afd8d9b7fed89$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $26965e7f4b3c51e7$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $ed6afd8d9b7fed89$var$truncateAggregateExceptions($ed6afd8d9b7fed89$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $ed6afd8d9b7fed89$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $26965e7f4b3c51e7$export$49034edbe6b62415)(error[key], Error)) {
        $ed6afd8d9b7fed89$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $ed6afd8d9b7fed89$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $ed6afd8d9b7fed89$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $26965e7f4b3c51e7$export$49034edbe6b62415)(childError, Error)) {
            $ed6afd8d9b7fed89$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $ed6afd8d9b7fed89$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $ed6afd8d9b7fed89$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $ed6afd8d9b7fed89$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $ed6afd8d9b7fed89$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $ed6afd8d9b7fed89$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $2ce85545280315e6$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $8103bb9184562799$var$DEFAULT_KEY = "cause";
const $8103bb9184562799$var$DEFAULT_LIMIT = 5;
const $8103bb9184562799$var$INTEGRATION_NAME = "LinkedErrors";
const $8103bb9184562799$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $8103bb9184562799$var$DEFAULT_LIMIT;
    const key = options.key || $8103bb9184562799$var$DEFAULT_KEY;
    return {
        name: $8103bb9184562799$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $ed6afd8d9b7fed89$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $dc20ec07bee77b64$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $8103bb9184562799$export$ebabb00eb7f3a395 = (0, $a72c16e1d374cf39$export$2323046b9414659f)($8103bb9184562799$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $8103bb9184562799$export$8d1e60aaf616fb4f = (0, $a72c16e1d374cf39$export$afa219bf23651160)($8103bb9184562799$var$INTEGRATION_NAME, $8103bb9184562799$export$ebabb00eb7f3a395);





const $bc8d14e27f084444$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $bc8d14e27f084444$var$INTEGRATION_NAME = "TryCatch";
const $bc8d14e27f084444$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $bc8d14e27f084444$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $a4503473509e6905$export$9563e054e6f787fb)((0, $9b6d3be157f87479$export$56d8a8a25bd48b81), "setTimeout", $bc8d14e27f084444$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $a4503473509e6905$export$9563e054e6f787fb)((0, $9b6d3be157f87479$export$56d8a8a25bd48b81), "setInterval", $bc8d14e27f084444$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $a4503473509e6905$export$9563e054e6f787fb)((0, $9b6d3be157f87479$export$56d8a8a25bd48b81), "requestAnimationFrame", $bc8d14e27f084444$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $9b6d3be157f87479$export$56d8a8a25bd48b81)) (0, $a4503473509e6905$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $bc8d14e27f084444$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $bc8d14e27f084444$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($bc8d14e27f084444$var$_wrapEventTarget);
            }
        }
    };
};
const $bc8d14e27f084444$export$59bfe9f1c76150e = (0, $a72c16e1d374cf39$export$2323046b9414659f)($bc8d14e27f084444$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $bc8d14e27f084444$export$f1a018517668e6d3 = (0, $a72c16e1d374cf39$export$afa219bf23651160)($bc8d14e27f084444$var$INTEGRATION_NAME, $bc8d14e27f084444$export$59bfe9f1c76150e);
function $bc8d14e27f084444$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9b6d3be157f87479$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bc8d14e27f084444$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9b6d3be157f87479$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $bc8d14e27f084444$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $a4503473509e6905$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $a4503473509e6905$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9b6d3be157f87479$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $bc8d14e27f084444$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $a4503473509e6905$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9b6d3be157f87479$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9b6d3be157f87479$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $c6dc8b4022d3f0a5$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $a4503473509e6905$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $d301992108f2f164$var$UNKNOWN_FUNCTION = "?";
const $d301992108f2f164$var$OPERA10_PRIORITY = 10;
const $d301992108f2f164$var$OPERA11_PRIORITY = 20;
const $d301992108f2f164$var$CHROME_PRIORITY = 30;
const $d301992108f2f164$var$WINJS_PRIORITY = 40;
const $d301992108f2f164$var$GECKO_PRIORITY = 50;
function $d301992108f2f164$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $d301992108f2f164$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $d301992108f2f164$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $d301992108f2f164$var$chromeStackParserFn = (line)=>{
    const parts = $d301992108f2f164$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $d301992108f2f164$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $d301992108f2f164$var$extractSafariExtensionDetails(parts[1] || $d301992108f2f164$var$UNKNOWN_FUNCTION, parts[2]);
        return $d301992108f2f164$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $d301992108f2f164$export$263a749fff749872 = [
    $d301992108f2f164$var$CHROME_PRIORITY,
    $d301992108f2f164$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $d301992108f2f164$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $d301992108f2f164$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $d301992108f2f164$var$gecko = (line)=>{
    const parts = $d301992108f2f164$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $d301992108f2f164$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $d301992108f2f164$var$UNKNOWN_FUNCTION;
        [func, filename] = $d301992108f2f164$var$extractSafariExtensionDetails(func, filename);
        return $d301992108f2f164$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $d301992108f2f164$export$cdba47a5dd2804d = [
    $d301992108f2f164$var$GECKO_PRIORITY,
    $d301992108f2f164$var$gecko
];
const $d301992108f2f164$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $d301992108f2f164$var$winjs = (line)=>{
    const parts = $d301992108f2f164$var$winjsRegex.exec(line);
    return parts ? $d301992108f2f164$var$createFrame(parts[2], parts[1] || $d301992108f2f164$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $d301992108f2f164$export$179460296da408e8 = [
    $d301992108f2f164$var$WINJS_PRIORITY,
    $d301992108f2f164$var$winjs
];
const $d301992108f2f164$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $d301992108f2f164$var$opera10 = (line)=>{
    const parts = $d301992108f2f164$var$opera10Regex.exec(line);
    return parts ? $d301992108f2f164$var$createFrame(parts[2], parts[3] || $d301992108f2f164$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $d301992108f2f164$export$f892b52c880ffc7a = [
    $d301992108f2f164$var$OPERA10_PRIORITY,
    $d301992108f2f164$var$opera10
];
const $d301992108f2f164$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $d301992108f2f164$var$opera11 = (line)=>{
    const parts = $d301992108f2f164$var$opera11Regex.exec(line);
    return parts ? $d301992108f2f164$var$createFrame(parts[5], parts[3] || parts[4] || $d301992108f2f164$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $d301992108f2f164$export$af11af13f09fb0dc = [
    $d301992108f2f164$var$OPERA11_PRIORITY,
    $d301992108f2f164$var$opera11
];
const $d301992108f2f164$export$7197c0fe6554c079 = [
    $d301992108f2f164$export$263a749fff749872,
    $d301992108f2f164$export$cdba47a5dd2804d,
    $d301992108f2f164$export$179460296da408e8
];
const $d301992108f2f164$export$2b2b997d81bf3907 = (0, $c6dc8b4022d3f0a5$export$a5739666fb2d03d4)(...$d301992108f2f164$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $d301992108f2f164$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $d301992108f2f164$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $7e925941e6509111$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $7e925941e6509111$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $7e925941e6509111$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $7e925941e6509111$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $7e925941e6509111$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $7e925941e6509111$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $7e925941e6509111$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $7e925941e6509111$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $29a2c493ba95a4ca$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $d0bb8be585a0f1f4$export$78e43115b553f358)(new (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $d0bb8be585a0f1f4$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $5c814522289486e5$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $5c814522289486e5$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $29a2c493ba95a4ca$export$85a4f67f852183e6)(options.bufferSize || $5c814522289486e5$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $ddd7798536c68ec2$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $ddd7798536c68ec2$export$b11169581eeaf237)(type);
            if ((0, $7e925941e6509111$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $5c814522289486e5$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $ddd7798536c68ec2$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $ddd7798536c68ec2$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $5c814522289486e5$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $ddd7798536c68ec2$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $ddd7798536c68ec2$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $7e925941e6509111$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $db543b1659d52b2d$export$5949942ba2a7c0e2)) {
                (0, $5030e00c131eea58$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $d0bb8be585a0f1f4$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $5c814522289486e5$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $459b924ec2a864d5$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $459b924ec2a864d5$export$8be2119ce08e3379() {
    if ($459b924ec2a864d5$var$cachedFetchImpl) return $459b924ec2a864d5$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $3da2b5d85b33da30$export$18cf36ed71d733e7)((0, $9b6d3be157f87479$export$56d8a8a25bd48b81).fetch)) return $459b924ec2a864d5$var$cachedFetchImpl = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).fetch.bind((0, $9b6d3be157f87479$export$56d8a8a25bd48b81));
    const document = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $459b924ec2a864d5$var$cachedFetchImpl = fetchImpl.bind((0, $9b6d3be157f87479$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $459b924ec2a864d5$export$d499686d2dd738c6() {
    $459b924ec2a864d5$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $13e488dfa752641a$export$b2311068c46d7cc8(options, nativeFetch = (0, $459b924ec2a864d5$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $459b924ec2a864d5$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $d0bb8be585a0f1f4$export$78e43115b553f358)(e);
        }
    }
    return (0, $5c814522289486e5$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $5de8a0b09bce06fc$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $5de8a0b09bce06fc$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $d0bb8be585a0f1f4$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $5de8a0b09bce06fc$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $5c814522289486e5$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $0644d6e90f309483$export$5ef831fccfce35e5 = [
    (0, $37a3a1081cb310eb$export$cb3c5c2ceb9818ba)(),
    (0, $19a24d0a86859965$export$7918117e9202e4fb)(),
    (0, $bc8d14e27f084444$export$59bfe9f1c76150e)(),
    (0, $56f4792f9a6d0db0$export$c079d904b326663a)(),
    (0, $d4a1b09e1576fadf$export$66acc70e8cf2b71a)(),
    (0, $8103bb9184562799$export$ebabb00eb7f3a395)(),
    (0, $0d843755c0810527$export$6d39aa44cd0c7567)(),
    (0, $4b1d8bab25c6b0e6$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $0644d6e90f309483$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$0644d6e90f309483$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $0644d6e90f309483$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $0644d6e90f309483$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $9b6d3be157f87479$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $c6dc8b4022d3f0a5$export$1d5cf88b347146d4)(options.stackParser || (0, $d301992108f2f164$export$2b2b997d81bf3907)),
        integrations: (0, $a72c16e1d374cf39$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $3da2b5d85b33da30$export$edf3cb81fd7d2a3e)() ? (0, $13e488dfa752641a$export$b2311068c46d7cc8) : (0, $5de8a0b09bce06fc$export$5e1441cee30d5a39))
    };
    (0, $fa6adb73b7e41f22$export$5333c3f1c58d9bc1)((0, $e59df057b65fcbfb$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $0644d6e90f309483$var$startSessionTracking();
}
const $0644d6e90f309483$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $35009d14216a34ba$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document) {
        (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $5f6b1ac02dacf7c1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document.head || (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0644d6e90f309483$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0644d6e90f309483$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0644d6e90f309483$export$4997ffc0176396a6(fn) {
    return (0, $9b6d3be157f87479$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $0644d6e90f309483$var$startSessionTracking() {
    if (typeof (0, $9b6d3be157f87479$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $e0b82046eb15ea62$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $fe010f6f6efcb5f1$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $fe010f6f6efcb5f1$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $37489a764b40e666$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $fe010f6f6efcb5f1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $fe010f6f6efcb5f1$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $0644d6e90f309483$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}




var $bUYS0 = parcelRequire("bUYS0");

var $dgG1Y = parcelRequire("dgG1Y");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $259dfe3223857cef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $68efdbb5eaa5efea$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $68efdbb5eaa5efea$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $68efdbb5eaa5efea$export$6ef4c0367e27f2d5 = "unknown";
const $68efdbb5eaa5efea$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $68efdbb5eaa5efea$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $68efdbb5eaa5efea$export$e926676385687eaf extends $dgG1Y.Component {
    componentDidCatch(error, { componentStack: componentStack }) {
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $fe010f6f6efcb5f1$export$ec58d9285c204497)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($68efdbb5eaa5efea$export$a87138b73900f5b($dgG1Y.version) && (0, $26965e7f4b3c51e7$export$e6127cc7fe7395c3)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $68efdbb5eaa5efea$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $fe010f6f6efcb5f1$export$f5282963edea4a68)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack: componentStack
                        }
                    }
                },
                // If users provide a fallback component we can assume they are handling the error.
                // Therefore, we set the mechanism depending on the presence of the fallback prop.
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $0644d6e90f309483$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($68efdbb5eaa5efea$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($dgG1Y.isValidElement(element)) return element;
            if (fallback) (0, $259dfe3223857cef$export$16a28057038b10ef) && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
    constructor(props){
        super(props);
        $68efdbb5eaa5efea$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $68efdbb5eaa5efea$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on("afterSendEvent", (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, $0644d6e90f309483$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $68efdbb5eaa5efea$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $68efdbb5eaa5efea$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$dgG1Y.createElement($68efdbb5eaa5efea$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $68efdbb5eaa5efea$var$_jsxFileName,
                lineNumber: 240
            }
        }, $dgG1Y.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $68efdbb5eaa5efea$var$_jsxFileName,
                lineNumber: 241
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($bUYS0)))(Wrapped, WrappedComponent);
    return Wrapped;
}



/**
 * Inits the React SDK
 */ function $f935bb49ce831c88$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $8d6d8fa29480b658$export$b9f95b027256052c)(opts, "react");
    (0, $0644d6e90f309483$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $9b8933466fce0239$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $1139fbe80b7f282a$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $bPnDo = parcelRequire("bPnDo");

/**
 * Returns true if we are in the browser.
 */ function $58181eccc4b62443$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $bPnDo.isNodeEnv)() || $58181eccc4b62443$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $58181eccc4b62443$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).process !== undefined && (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1).process.type === "renderer");
}


/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $c28edac5b94496e9$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $c28edac5b94496e9$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $c28edac5b94496e9$var$checkDsn(url, dsn) || $c28edac5b94496e9$var$checkTunnel(url, tunnel);
}
function $c28edac5b94496e9$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $c28edac5b94496e9$var$removeTrailingSlash(url) === $c28edac5b94496e9$var$removeTrailingSlash(tunnel);
}
function $c28edac5b94496e9$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $c28edac5b94496e9$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $c28edac5b94496e9$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $3e3fe5b73bfaf71c$var$WINDOW = (0, $7bc2b85f84f1fb97$export$f1a6cdb1459e81d1);
const $3e3fe5b73bfaf71c$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $3e3fe5b73bfaf71c$var$REPLAY_EVENT_NAME = "replay_event";
const $3e3fe5b73bfaf71c$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $3e3fe5b73bfaf71c$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $3e3fe5b73bfaf71c$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $3e3fe5b73bfaf71c$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $3e3fe5b73bfaf71c$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $3e3fe5b73bfaf71c$var$BUFFER_CHECKOUT_TIME = 60000;
const $3e3fe5b73bfaf71c$var$RETRY_BASE_INTERVAL = 5000;
const $3e3fe5b73bfaf71c$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $3e3fe5b73bfaf71c$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $3e3fe5b73bfaf71c$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $3e3fe5b73bfaf71c$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $3e3fe5b73bfaf71c$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $3e3fe5b73bfaf71c$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $3e3fe5b73bfaf71c$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $3e3fe5b73bfaf71c$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $3e3fe5b73bfaf71c$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $3e3fe5b73bfaf71c$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $3e3fe5b73bfaf71c$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $3e3fe5b73bfaf71c$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($3e3fe5b73bfaf71c$var$NodeType$1 || ($3e3fe5b73bfaf71c$var$NodeType$1 = {}));
function $3e3fe5b73bfaf71c$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $3e3fe5b73bfaf71c$var$isShadowRoot(n) {
    const host = $3e3fe5b73bfaf71c$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($3e3fe5b73bfaf71c$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $3e3fe5b73bfaf71c$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $3e3fe5b73bfaf71c$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $3e3fe5b73bfaf71c$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $3e3fe5b73bfaf71c$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $3e3fe5b73bfaf71c$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $3e3fe5b73bfaf71c$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $3e3fe5b73bfaf71c$var$stringifyRule(rule) {
    let importStringified;
    if ($3e3fe5b73bfaf71c$var$isCSSImportRule(rule)) try {
        importStringified = $3e3fe5b73bfaf71c$var$stringifyStylesheet(rule.styleSheet) || $3e3fe5b73bfaf71c$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($3e3fe5b73bfaf71c$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $3e3fe5b73bfaf71c$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $3e3fe5b73bfaf71c$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $3e3fe5b73bfaf71c$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $3e3fe5b73bfaf71c$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $3e3fe5b73bfaf71c$var$Mirror {
    getId(n) {
        if (!n) return -1;
        const id = $3e3fe5b73bfaf71c$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $3e3fe5b73bfaf71c$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $3e3fe5b73bfaf71c$var$createMirror() {
    return new $3e3fe5b73bfaf71c$var$Mirror();
}
function $3e3fe5b73bfaf71c$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $3e3fe5b73bfaf71c$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $3e3fe5b73bfaf71c$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $3e3fe5b73bfaf71c$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $3e3fe5b73bfaf71c$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $3e3fe5b73bfaf71c$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $3e3fe5b73bfaf71c$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$3e3fe5b73bfaf71c$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $3e3fe5b73bfaf71c$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $3e3fe5b73bfaf71c$var$toLowerCase(type) : null;
}
function $3e3fe5b73bfaf71c$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $3e3fe5b73bfaf71c$var$_id = 1;
const $3e3fe5b73bfaf71c$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $3e3fe5b73bfaf71c$var$IGNORED_NODE = -2;
function $3e3fe5b73bfaf71c$var$genId() {
    return $3e3fe5b73bfaf71c$var$_id++;
}
function $3e3fe5b73bfaf71c$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $3e3fe5b73bfaf71c$var$toLowerCase(element.tagName);
    if ($3e3fe5b73bfaf71c$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $3e3fe5b73bfaf71c$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $3e3fe5b73bfaf71c$var$canvasService;
let $3e3fe5b73bfaf71c$var$canvasCtx;
const $3e3fe5b73bfaf71c$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $3e3fe5b73bfaf71c$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $3e3fe5b73bfaf71c$var$URL_WWW_MATCH = /^www\..*/i;
const $3e3fe5b73bfaf71c$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $3e3fe5b73bfaf71c$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($3e3fe5b73bfaf71c$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($3e3fe5b73bfaf71c$var$URL_PROTOCOL_MATCH.test(filePath) || $3e3fe5b73bfaf71c$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($3e3fe5b73bfaf71c$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$3e3fe5b73bfaf71c$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $3e3fe5b73bfaf71c$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $3e3fe5b73bfaf71c$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $3e3fe5b73bfaf71c$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($3e3fe5b73bfaf71c$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($3e3fe5b73bfaf71c$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $3e3fe5b73bfaf71c$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $3e3fe5b73bfaf71c$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $3e3fe5b73bfaf71c$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $3e3fe5b73bfaf71c$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $3e3fe5b73bfaf71c$var$absoluteToStylesheet(value, $3e3fe5b73bfaf71c$var$getHref());
    else if (tagName === "object" && name === "data") return $3e3fe5b73bfaf71c$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $3e3fe5b73bfaf71c$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $3e3fe5b73bfaf71c$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $3e3fe5b73bfaf71c$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $3e3fe5b73bfaf71c$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $3e3fe5b73bfaf71c$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $3e3fe5b73bfaf71c$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($3e3fe5b73bfaf71c$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $3e3fe5b73bfaf71c$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $3e3fe5b73bfaf71c$var$distanceToMatch(el, $3e3fe5b73bfaf71c$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $3e3fe5b73bfaf71c$var$distanceToMatch(el, $3e3fe5b73bfaf71c$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $3e3fe5b73bfaf71c$var$distanceToMatch(el, $3e3fe5b73bfaf71c$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $3e3fe5b73bfaf71c$var$distanceToMatch(el, $3e3fe5b73bfaf71c$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $3e3fe5b73bfaf71c$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $3e3fe5b73bfaf71c$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $3e3fe5b73bfaf71c$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $3e3fe5b73bfaf71c$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $3e3fe5b73bfaf71c$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $3e3fe5b73bfaf71c$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $3e3fe5b73bfaf71c$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $3e3fe5b73bfaf71c$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $3e3fe5b73bfaf71c$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $3e3fe5b73bfaf71c$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $3e3fe5b73bfaf71c$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $3e3fe5b73bfaf71c$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $3e3fe5b73bfaf71c$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($3e3fe5b73bfaf71c$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $3e3fe5b73bfaf71c$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $3e3fe5b73bfaf71c$var$absoluteToStylesheet(textContent, $3e3fe5b73bfaf71c$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $3e3fe5b73bfaf71c$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $3e3fe5b73bfaf71c$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $3e3fe5b73bfaf71c$var$maskInputValue({
            isMasked: $3e3fe5b73bfaf71c$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $3e3fe5b73bfaf71c$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $3e3fe5b73bfaf71c$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $3e3fe5b73bfaf71c$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $3e3fe5b73bfaf71c$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$3e3fe5b73bfaf71c$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $3e3fe5b73bfaf71c$var$transformAttribute(doc, tagName, $3e3fe5b73bfaf71c$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $3e3fe5b73bfaf71c$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $3e3fe5b73bfaf71c$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $3e3fe5b73bfaf71c$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $3e3fe5b73bfaf71c$var$absoluteToStylesheet(cssText, $3e3fe5b73bfaf71c$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $3e3fe5b73bfaf71c$var$getInputType(el);
        const value = $3e3fe5b73bfaf71c$var$getInputValue(el, $3e3fe5b73bfaf71c$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $3e3fe5b73bfaf71c$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $3e3fe5b73bfaf71c$var$shouldMaskInput({
                type: type,
                tagName: $3e3fe5b73bfaf71c$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $3e3fe5b73bfaf71c$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$3e3fe5b73bfaf71c$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$3e3fe5b73bfaf71c$var$canvasService) {
            $3e3fe5b73bfaf71c$var$canvasService = doc.createElement("canvas");
            $3e3fe5b73bfaf71c$var$canvasCtx = $3e3fe5b73bfaf71c$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $3e3fe5b73bfaf71c$var$canvasService.width = image.naturalWidth;
                $3e3fe5b73bfaf71c$var$canvasService.height = image.naturalHeight;
                $3e3fe5b73bfaf71c$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $3e3fe5b73bfaf71c$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $3e3fe5b73bfaf71c$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $3e3fe5b73bfaf71c$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $3e3fe5b73bfaf71c$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $3e3fe5b73bfaf71c$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $3e3fe5b73bfaf71c$var$NodeType$1.Comment) return true;
    else if (sn.type === $3e3fe5b73bfaf71c$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "application-name" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.rel) === "icon" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "robots" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "googlebot" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "author" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "generator" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "framework" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "publisher" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "progid" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "verification" || $3e3fe5b73bfaf71c$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $3e3fe5b73bfaf71c$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $3e3fe5b73bfaf71c$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($3e3fe5b73bfaf71c$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $3e3fe5b73bfaf71c$var$IGNORED_NODE;
    else id = $3e3fe5b73bfaf71c$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $3e3fe5b73bfaf71c$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $3e3fe5b73bfaf71c$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Document || serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $3e3fe5b73bfaf71c$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($3e3fe5b73bfaf71c$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $3e3fe5b73bfaf71c$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $3e3fe5b73bfaf71c$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $3e3fe5b73bfaf71c$var$isShadowRoot(n.parentNode) && $3e3fe5b73bfaf71c$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Element && serializedNode.tagName === "iframe") $3e3fe5b73bfaf71c$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $3e3fe5b73bfaf71c$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $3e3fe5b73bfaf71c$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $3e3fe5b73bfaf71c$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $3e3fe5b73bfaf71c$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $3e3fe5b73bfaf71c$var$snapshot(n, options) {
    const { mirror: mirror = new $3e3fe5b73bfaf71c$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $3e3fe5b73bfaf71c$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $3e3fe5b73bfaf71c$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $3e3fe5b73bfaf71c$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $3e3fe5b73bfaf71c$var$_mirror = {
    map: {},
    getId () {
        console.error($3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $3e3fe5b73bfaf71c$var$_mirror = new Proxy($3e3fe5b73bfaf71c$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($3e3fe5b73bfaf71c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $3e3fe5b73bfaf71c$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $3e3fe5b73bfaf71c$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $3e3fe5b73bfaf71c$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $3e3fe5b73bfaf71c$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $3e3fe5b73bfaf71c$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$3e3fe5b73bfaf71c$var$hookSetter(target, key, original || {}, true);
}
function $3e3fe5b73bfaf71c$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $3e3fe5b73bfaf71c$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $3e3fe5b73bfaf71c$var$nowTimestamp = ()=>new Date().getTime();
function $3e3fe5b73bfaf71c$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $3e3fe5b73bfaf71c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $3e3fe5b73bfaf71c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $3e3fe5b73bfaf71c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $3e3fe5b73bfaf71c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $3e3fe5b73bfaf71c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $3e3fe5b73bfaf71c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $3e3fe5b73bfaf71c$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $3e3fe5b73bfaf71c$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $3e3fe5b73bfaf71c$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $3e3fe5b73bfaf71c$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $3e3fe5b73bfaf71c$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $3e3fe5b73bfaf71c$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $3e3fe5b73bfaf71c$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $3e3fe5b73bfaf71c$var$distanceToMatch(el, $3e3fe5b73bfaf71c$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $3e3fe5b73bfaf71c$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $3e3fe5b73bfaf71c$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $3e3fe5b73bfaf71c$var$IGNORED_NODE;
}
function $3e3fe5b73bfaf71c$var$isAncestorRemoved(target, mirror) {
    if ($3e3fe5b73bfaf71c$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $3e3fe5b73bfaf71c$var$isAncestorRemoved(target.parentNode, mirror);
}
function $3e3fe5b73bfaf71c$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $3e3fe5b73bfaf71c$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $3e3fe5b73bfaf71c$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $3e3fe5b73bfaf71c$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $3e3fe5b73bfaf71c$var$hasShadowRoot(n) {
    return Boolean($3e3fe5b73bfaf71c$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $3e3fe5b73bfaf71c$var$StyleSheetMirror {
    getId(stylesheet) {
        return (0, $9b8933466fce0239$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
}
function $3e3fe5b73bfaf71c$var$getShadowHost(n) {
    let shadowHost = null;
    if ($3e3fe5b73bfaf71c$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $3e3fe5b73bfaf71c$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $3e3fe5b73bfaf71c$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $3e3fe5b73bfaf71c$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $3e3fe5b73bfaf71c$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $3e3fe5b73bfaf71c$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $3e3fe5b73bfaf71c$var$shadowHostInDom(n);
}
const $3e3fe5b73bfaf71c$var$cachedImplementations = {};
function $3e3fe5b73bfaf71c$var$getImplementation(name) {
    const cached = $3e3fe5b73bfaf71c$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $3e3fe5b73bfaf71c$var$cachedImplementations[name] = impl.bind(window);
}
function $3e3fe5b73bfaf71c$var$onRequestAnimationFrame(...rest) {
    return $3e3fe5b73bfaf71c$var$getImplementation("requestAnimationFrame")(...rest);
}
function $3e3fe5b73bfaf71c$var$setTimeout$1(...rest) {
    return $3e3fe5b73bfaf71c$var$getImplementation("setTimeout")(...rest);
}
function $3e3fe5b73bfaf71c$var$clearTimeout$1(...rest) {
    return $3e3fe5b73bfaf71c$var$getImplementation("clearTimeout")(...rest);
}
var $3e3fe5b73bfaf71c$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($3e3fe5b73bfaf71c$var$EventType || {});
var $3e3fe5b73bfaf71c$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($3e3fe5b73bfaf71c$var$IncrementalSource || {});
var $3e3fe5b73bfaf71c$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($3e3fe5b73bfaf71c$var$MouseInteractions || {});
var $3e3fe5b73bfaf71c$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($3e3fe5b73bfaf71c$var$PointerTypes || {});
function $3e3fe5b73bfaf71c$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $3e3fe5b73bfaf71c$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $3e3fe5b73bfaf71c$var$DoubleLinkedList {
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $3e3fe5b73bfaf71c$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $3e3fe5b73bfaf71c$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $3e3fe5b73bfaf71c$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
}
const $3e3fe5b73bfaf71c$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $3e3fe5b73bfaf71c$var$MutationBuffer {
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $3e3fe5b73bfaf71c$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $3e3fe5b73bfaf71c$var$IGNORED_NODE;
                while(nextId === $3e3fe5b73bfaf71c$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$3e3fe5b73bfaf71c$var$inDom(n)) return;
                const parentId = $3e3fe5b73bfaf71c$var$isShadowRoot(n.parentNode) ? this.mirror.getId($3e3fe5b73bfaf71c$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $3e3fe5b73bfaf71c$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($3e3fe5b73bfaf71c$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($3e3fe5b73bfaf71c$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($3e3fe5b73bfaf71c$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($3e3fe5b73bfaf71c$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$3e3fe5b73bfaf71c$var$isAncestorInSet(this.droppedSet, n) && !$3e3fe5b73bfaf71c$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($3e3fe5b73bfaf71c$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($3e3fe5b73bfaf71c$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$3e3fe5b73bfaf71c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $3e3fe5b73bfaf71c$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $3e3fe5b73bfaf71c$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $3e3fe5b73bfaf71c$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $3e3fe5b73bfaf71c$var$getInputValue(target, tagName, type);
                            const isInputMasked = $3e3fe5b73bfaf71c$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $3e3fe5b73bfaf71c$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $3e3fe5b73bfaf71c$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($3e3fe5b73bfaf71c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$3e3fe5b73bfaf71c$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $3e3fe5b73bfaf71c$var$transformAttribute(this.doc, $3e3fe5b73bfaf71c$var$toLowerCase(target.tagName), $3e3fe5b73bfaf71c$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($3e3fe5b73bfaf71c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $3e3fe5b73bfaf71c$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($3e3fe5b73bfaf71c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $3e3fe5b73bfaf71c$var$isIgnored(n, this.mirror) || !$3e3fe5b73bfaf71c$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $3e3fe5b73bfaf71c$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($3e3fe5b73bfaf71c$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$3e3fe5b73bfaf71c$var$moveKey(nodeId, parentId)]) $3e3fe5b73bfaf71c$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $3e3fe5b73bfaf71c$var$isShadowRoot(m.target) && $3e3fe5b73bfaf71c$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($3e3fe5b73bfaf71c$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$3e3fe5b73bfaf71c$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$3e3fe5b73bfaf71c$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($3e3fe5b73bfaf71c$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
}
function $3e3fe5b73bfaf71c$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$3e3fe5b73bfaf71c$var$deepDelete(addsSet, childN));
}
function $3e3fe5b73bfaf71c$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $3e3fe5b73bfaf71c$var$_isParentRemoved(removes, n, mirror);
}
function $3e3fe5b73bfaf71c$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $3e3fe5b73bfaf71c$var$_isParentRemoved(removes, parentNode, mirror);
}
function $3e3fe5b73bfaf71c$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $3e3fe5b73bfaf71c$var$_isAncestorInSet(set, n);
}
function $3e3fe5b73bfaf71c$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $3e3fe5b73bfaf71c$var$_isAncestorInSet(set, parentNode);
}
let $3e3fe5b73bfaf71c$var$errorHandler;
function $3e3fe5b73bfaf71c$var$registerErrorHandler(handler) {
    $3e3fe5b73bfaf71c$var$errorHandler = handler;
}
function $3e3fe5b73bfaf71c$var$unregisterErrorHandler() {
    $3e3fe5b73bfaf71c$var$errorHandler = undefined;
}
const $3e3fe5b73bfaf71c$var$callbackWrapper = (cb)=>{
    if (!$3e3fe5b73bfaf71c$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($3e3fe5b73bfaf71c$var$errorHandler && $3e3fe5b73bfaf71c$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $3e3fe5b73bfaf71c$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $3e3fe5b73bfaf71c$var$mutationBuffers = [];
function $3e3fe5b73bfaf71c$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $3e3fe5b73bfaf71c$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $3e3fe5b73bfaf71c$var$MutationBuffer();
    $3e3fe5b73bfaf71c$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $3e3fe5b73bfaf71c$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($3e3fe5b73bfaf71c$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $3e3fe5b73bfaf71c$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $3e3fe5b73bfaf71c$var$throttle$1($3e3fe5b73bfaf71c$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $3e3fe5b73bfaf71c$var$callbackWrapper($3e3fe5b73bfaf71c$var$throttle$1($3e3fe5b73bfaf71c$var$callbackWrapper((evt)=>{
        const target = $3e3fe5b73bfaf71c$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $3e3fe5b73bfaf71c$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $3e3fe5b73bfaf71c$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $3e3fe5b73bfaf71c$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $3e3fe5b73bfaf71c$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $3e3fe5b73bfaf71c$var$IncrementalSource.MouseMove : $3e3fe5b73bfaf71c$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $3e3fe5b73bfaf71c$var$on("mousemove", updatePosition, doc),
        $3e3fe5b73bfaf71c$var$on("touchmove", updatePosition, doc),
        $3e3fe5b73bfaf71c$var$on("drag", updatePosition, doc)
    ];
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $3e3fe5b73bfaf71c$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $3e3fe5b73bfaf71c$var$getEventTarget(event);
            if ($3e3fe5b73bfaf71c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $3e3fe5b73bfaf71c$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $3e3fe5b73bfaf71c$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $3e3fe5b73bfaf71c$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $3e3fe5b73bfaf71c$var$PointerTypes.Touch) {
                    if ($3e3fe5b73bfaf71c$var$MouseInteractions[eventKey] === $3e3fe5b73bfaf71c$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($3e3fe5b73bfaf71c$var$MouseInteractions[eventKey] === $3e3fe5b73bfaf71c$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $3e3fe5b73bfaf71c$var$PointerTypes.Pen;
            } else if ($3e3fe5b73bfaf71c$var$legacy_isTouchEvent(event)) pointerType = $3e3fe5b73bfaf71c$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $3e3fe5b73bfaf71c$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $3e3fe5b73bfaf71c$var$PointerTypes.Mouse) pointerType = null;
            } else if ($3e3fe5b73bfaf71c$var$MouseInteractions[eventKey] === $3e3fe5b73bfaf71c$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $3e3fe5b73bfaf71c$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $3e3fe5b73bfaf71c$var$callbackWrapper(mouseInteractionCb)({
                type: $3e3fe5b73bfaf71c$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($3e3fe5b73bfaf71c$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $3e3fe5b73bfaf71c$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($3e3fe5b73bfaf71c$var$MouseInteractions[eventKey]){
            case $3e3fe5b73bfaf71c$var$MouseInteractions.MouseDown:
            case $3e3fe5b73bfaf71c$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $3e3fe5b73bfaf71c$var$MouseInteractions.TouchStart:
            case $3e3fe5b73bfaf71c$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($3e3fe5b73bfaf71c$var$on(eventName, handler, doc));
    });
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $3e3fe5b73bfaf71c$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $3e3fe5b73bfaf71c$var$callbackWrapper($3e3fe5b73bfaf71c$var$throttle$1($3e3fe5b73bfaf71c$var$callbackWrapper((evt)=>{
        const target = $3e3fe5b73bfaf71c$var$getEventTarget(evt);
        if (!target || $3e3fe5b73bfaf71c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $3e3fe5b73bfaf71c$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $3e3fe5b73bfaf71c$var$on("scroll", updatePosition, doc);
}
function $3e3fe5b73bfaf71c$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $3e3fe5b73bfaf71c$var$callbackWrapper($3e3fe5b73bfaf71c$var$throttle$1($3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        const height = $3e3fe5b73bfaf71c$var$getWindowHeight();
        const width = $3e3fe5b73bfaf71c$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $3e3fe5b73bfaf71c$var$on("resize", updateDimension, win);
}
const $3e3fe5b73bfaf71c$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $3e3fe5b73bfaf71c$var$lastInputValueMap = new WeakMap();
function $3e3fe5b73bfaf71c$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $3e3fe5b73bfaf71c$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $3e3fe5b73bfaf71c$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $3e3fe5b73bfaf71c$var$INPUT_TAGS.indexOf(tagName) < 0 || $3e3fe5b73bfaf71c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $3e3fe5b73bfaf71c$var$getInputType(target);
        let text = $3e3fe5b73bfaf71c$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $3e3fe5b73bfaf71c$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $3e3fe5b73bfaf71c$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $3e3fe5b73bfaf71c$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $3e3fe5b73bfaf71c$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $3e3fe5b73bfaf71c$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $3e3fe5b73bfaf71c$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $3e3fe5b73bfaf71c$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $3e3fe5b73bfaf71c$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$3e3fe5b73bfaf71c$var$on(eventName, $3e3fe5b73bfaf71c$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$3e3fe5b73bfaf71c$var$hookSetter(p[0], p[1], {
            set () {
                $3e3fe5b73bfaf71c$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $3e3fe5b73bfaf71c$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($3e3fe5b73bfaf71c$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $3e3fe5b73bfaf71c$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $3e3fe5b73bfaf71c$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $3e3fe5b73bfaf71c$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $3e3fe5b73bfaf71c$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $3e3fe5b73bfaf71c$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($3e3fe5b73bfaf71c$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($3e3fe5b73bfaf71c$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($3e3fe5b73bfaf71c$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($3e3fe5b73bfaf71c$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$3e3fe5b73bfaf71c$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$3e3fe5b73bfaf71c$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $3e3fe5b73bfaf71c$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $3e3fe5b73bfaf71c$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $3e3fe5b73bfaf71c$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $3e3fe5b73bfaf71c$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($3e3fe5b73bfaf71c$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $3e3fe5b73bfaf71c$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $3e3fe5b73bfaf71c$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $3e3fe5b73bfaf71c$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId($3e3fe5b73bfaf71c$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $3e3fe5b73bfaf71c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $3e3fe5b73bfaf71c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $3e3fe5b73bfaf71c$var$getIdAndStyleId($3e3fe5b73bfaf71c$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $3e3fe5b73bfaf71c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $3e3fe5b73bfaf71c$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $3e3fe5b73bfaf71c$var$callbackWrapper((type)=>$3e3fe5b73bfaf71c$var$throttle$1($3e3fe5b73bfaf71c$var$callbackWrapper((event)=>{
            const target = $3e3fe5b73bfaf71c$var$getEventTarget(event);
            if (!target || $3e3fe5b73bfaf71c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $3e3fe5b73bfaf71c$var$on("play", handler(0), doc),
        $3e3fe5b73bfaf71c$var$on("pause", handler(1), doc),
        $3e3fe5b73bfaf71c$var$on("seeked", handler(2), doc),
        $3e3fe5b73bfaf71c$var$on("volumechange", handler(3), doc),
        $3e3fe5b73bfaf71c$var$on("ratechange", handler(4), doc)
    ];
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $3e3fe5b73bfaf71c$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $3e3fe5b73bfaf71c$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $3e3fe5b73bfaf71c$var$setTimeout$1($3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $3e3fe5b73bfaf71c$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $3e3fe5b73bfaf71c$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $3e3fe5b73bfaf71c$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $3e3fe5b73bfaf71c$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $3e3fe5b73bfaf71c$var$on("selectionchange", updateSelection);
}
function $3e3fe5b73bfaf71c$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $3e3fe5b73bfaf71c$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $3e3fe5b73bfaf71c$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $3e3fe5b73bfaf71c$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $3e3fe5b73bfaf71c$var$initMoveObserver(o);
    const mouseInteractionHandler = $3e3fe5b73bfaf71c$var$initMouseInteractionObserver(o);
    const scrollHandler = $3e3fe5b73bfaf71c$var$initScrollObserver(o);
    const viewportResizeHandler = $3e3fe5b73bfaf71c$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $3e3fe5b73bfaf71c$var$initInputObserver(o);
    const mediaInteractionHandler = $3e3fe5b73bfaf71c$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $3e3fe5b73bfaf71c$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $3e3fe5b73bfaf71c$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $3e3fe5b73bfaf71c$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $3e3fe5b73bfaf71c$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $3e3fe5b73bfaf71c$var$initSelectionObserver(o);
    const customElementObserver = $3e3fe5b73bfaf71c$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $3e3fe5b73bfaf71c$var$callbackWrapper(()=>{
        $3e3fe5b73bfaf71c$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $3e3fe5b73bfaf71c$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $3e3fe5b73bfaf71c$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $3e3fe5b73bfaf71c$var$CrossOriginIframeMirror {
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
}
function $3e3fe5b73bfaf71c$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $3e3fe5b73bfaf71c$var$IframeManagerNoop {
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
    constructor(){
        this.crossOriginIframeMirror = new $3e3fe5b73bfaf71c$var$CrossOriginIframeMirror($3e3fe5b73bfaf71c$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
}
class $3e3fe5b73bfaf71c$var$IframeManager {
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $3e3fe5b73bfaf71c$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $3e3fe5b73bfaf71c$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $3e3fe5b73bfaf71c$var$EventType.Meta:
            case $3e3fe5b73bfaf71c$var$EventType.Load:
            case $3e3fe5b73bfaf71c$var$EventType.DomContentLoaded:
                return false;
            case $3e3fe5b73bfaf71c$var$EventType.Plugin:
                return e;
            case $3e3fe5b73bfaf71c$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.Drag:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.TouchMove:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.ViewportResize:
                        return false;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.MediaInteraction:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.MouseInteraction:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.Scroll:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.CanvasMutation:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.StyleSheetRule:
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.Font:
                        return e;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $3e3fe5b73bfaf71c$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $3e3fe5b73bfaf71c$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $3e3fe5b73bfaf71c$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $3e3fe5b73bfaf71c$var$CrossOriginIframeMirror($3e3fe5b73bfaf71c$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $3e3fe5b73bfaf71c$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
}
class $3e3fe5b73bfaf71c$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $3e3fe5b73bfaf71c$var$ShadowDomManager {
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$3e3fe5b73bfaf71c$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $3e3fe5b73bfaf71c$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($3e3fe5b73bfaf71c$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $3e3fe5b73bfaf71c$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($3e3fe5b73bfaf71c$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($3e3fe5b73bfaf71c$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $3e3fe5b73bfaf71c$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
}
class $3e3fe5b73bfaf71c$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $3e3fe5b73bfaf71c$var$StylesheetManager {
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $3e3fe5b73bfaf71c$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $3e3fe5b73bfaf71c$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
}
class $3e3fe5b73bfaf71c$var$ProcessedNodeManager {
    periodicallyClear() {
        $3e3fe5b73bfaf71c$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
}
let $3e3fe5b73bfaf71c$var$wrappedEmit;
let $3e3fe5b73bfaf71c$var$_takeFullSnapshot;
const $3e3fe5b73bfaf71c$var$mirror = $3e3fe5b73bfaf71c$var$createMirror();
function $3e3fe5b73bfaf71c$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $3e3fe5b73bfaf71c$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $3e3fe5b73bfaf71c$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $3e3fe5b73bfaf71c$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $3e3fe5b73bfaf71c$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $3e3fe5b73bfaf71c$var$nowTimestamp();
        if ((0, $1139fbe80b7f282a$export$3cc482e6b02f32f7)([
            $3e3fe5b73bfaf71c$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $3e3fe5b73bfaf71c$var$EventType.FullSnapshot && !(e.type === $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot && e.data.source === $3e3fe5b73bfaf71c$var$IncrementalSource.Mutation)) $3e3fe5b73bfaf71c$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $1139fbe80b7f282a$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $3e3fe5b73bfaf71c$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $3e3fe5b73bfaf71c$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $3e3fe5b73bfaf71c$var$wrappedEmit({
            type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
            data: {
                source: $3e3fe5b73bfaf71c$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
            type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
            data: {
                source: $3e3fe5b73bfaf71c$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
            type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
            data: {
                source: $3e3fe5b73bfaf71c$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
            type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
            data: {
                source: $3e3fe5b73bfaf71c$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $3e3fe5b73bfaf71c$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $3e3fe5b73bfaf71c$var$IframeManagerNoop() : new $3e3fe5b73bfaf71c$var$IframeManager({
        mirror: $3e3fe5b73bfaf71c$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $3e3fe5b73bfaf71c$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $3e3fe5b73bfaf71c$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $3e3fe5b73bfaf71c$var$ProcessedNodeManager();
    const canvasManager = $3e3fe5b73bfaf71c$var$_getCanvasManager(getCanvasManager, {
        mirror: $3e3fe5b73bfaf71c$var$mirror,
        win: window,
        mutationCb: (p)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                data: {
                    source: $3e3fe5b73bfaf71c$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $3e3fe5b73bfaf71c$var$ShadowDomManagerNoop() : new $3e3fe5b73bfaf71c$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $3e3fe5b73bfaf71c$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $3e3fe5b73bfaf71c$var$wrappedEmit({
            type: $3e3fe5b73bfaf71c$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $3e3fe5b73bfaf71c$var$getWindowWidth(),
                height: $3e3fe5b73bfaf71c$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $3e3fe5b73bfaf71c$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $3e3fe5b73bfaf71c$var$snapshot(document, {
            mirror: $3e3fe5b73bfaf71c$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($3e3fe5b73bfaf71c$var$isSerializedIframe(n, $3e3fe5b73bfaf71c$var$mirror)) iframeManager.addIframe(n);
                if ($3e3fe5b73bfaf71c$var$isSerializedStylesheet(n, $3e3fe5b73bfaf71c$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($3e3fe5b73bfaf71c$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $3e3fe5b73bfaf71c$var$wrappedEmit({
            type: $3e3fe5b73bfaf71c$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $3e3fe5b73bfaf71c$var$getWindowScroll(window)
            }
        });
        $3e3fe5b73bfaf71c$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $3e3fe5b73bfaf71c$var$mirror.getId(document));
    };
    $3e3fe5b73bfaf71c$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $3e3fe5b73bfaf71c$var$callbackWrapper($3e3fe5b73bfaf71c$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $3e3fe5b73bfaf71c$var$wrappedEmit({
                        type: $3e3fe5b73bfaf71c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $3e3fe5b73bfaf71c$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $3e3fe5b73bfaf71c$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $1139fbe80b7f282a$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$3e3fe5b73bfaf71c$var$wrappedEmit({
                                        type: $3e3fe5b73bfaf71c$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($3e3fe5b73bfaf71c$var$on("DOMContentLoaded", ()=>{
                $3e3fe5b73bfaf71c$var$wrappedEmit({
                    type: $3e3fe5b73bfaf71c$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($3e3fe5b73bfaf71c$var$on("load", ()=>{
                $3e3fe5b73bfaf71c$var$wrappedEmit({
                    type: $3e3fe5b73bfaf71c$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $3e3fe5b73bfaf71c$var$_takeFullSnapshot = undefined;
            $3e3fe5b73bfaf71c$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $3e3fe5b73bfaf71c$var$takeFullSnapshot(isCheckout) {
    if (!$3e3fe5b73bfaf71c$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $3e3fe5b73bfaf71c$var$_takeFullSnapshot(isCheckout);
}
$3e3fe5b73bfaf71c$var$record.mirror = $3e3fe5b73bfaf71c$var$mirror;
$3e3fe5b73bfaf71c$var$record.takeFullSnapshot = $3e3fe5b73bfaf71c$var$takeFullSnapshot;
function $3e3fe5b73bfaf71c$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $3e3fe5b73bfaf71c$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $3e3fe5b73bfaf71c$var$CanvasManagerNoop();
    }
}
const $3e3fe5b73bfaf71c$var$ReplayEventTypeIncrementalSnapshot = 3;
const $3e3fe5b73bfaf71c$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $3e3fe5b73bfaf71c$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $3e3fe5b73bfaf71c$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $3e3fe5b73bfaf71c$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $3e3fe5b73bfaf71c$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $458193ce2072e151$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $3e3fe5b73bfaf71c$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $3e3fe5b73bfaf71c$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($3e3fe5b73bfaf71c$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $3e3fe5b73bfaf71c$var$getClickTargetNode(event) {
    const target = $3e3fe5b73bfaf71c$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $3e3fe5b73bfaf71c$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $3e3fe5b73bfaf71c$var$getTargetNode(event) {
    if ($3e3fe5b73bfaf71c$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $3e3fe5b73bfaf71c$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $3e3fe5b73bfaf71c$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $3e3fe5b73bfaf71c$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$3e3fe5b73bfaf71c$var$handlers) {
        $3e3fe5b73bfaf71c$var$handlers = [];
        $3e3fe5b73bfaf71c$var$monkeyPatchWindowOpen();
    }
    $3e3fe5b73bfaf71c$var$handlers.push(cb);
    return ()=>{
        const pos = $3e3fe5b73bfaf71c$var$handlers ? $3e3fe5b73bfaf71c$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $3e3fe5b73bfaf71c$var$handlers.splice(pos, 1);
    };
}
function $3e3fe5b73bfaf71c$var$monkeyPatchWindowOpen() {
    (0, $a4503473509e6905$export$9563e054e6f787fb)($3e3fe5b73bfaf71c$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($3e3fe5b73bfaf71c$var$handlers) try {
                $3e3fe5b73bfaf71c$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($3e3fe5b73bfaf71c$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $3e3fe5b73bfaf71c$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $3e3fe5b73bfaf71c$var$ClickDetector {
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $3e3fe5b73bfaf71c$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $3e3fe5b73bfaf71c$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($3e3fe5b73bfaf71c$var$ignoreElement(node, this._ignoreSelector) || !$3e3fe5b73bfaf71c$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $3e3fe5b73bfaf71c$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $3e3fe5b73bfaf71c$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $3e3fe5b73bfaf71c$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $3e3fe5b73bfaf71c$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $3e3fe5b73bfaf71c$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $3e3fe5b73bfaf71c$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $3e3fe5b73bfaf71c$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $3e3fe5b73bfaf71c$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
}
const $3e3fe5b73bfaf71c$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $3e3fe5b73bfaf71c$var$ignoreElement(node, ignoreSelector) {
    if (!$3e3fe5b73bfaf71c$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $3e3fe5b73bfaf71c$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $3e3fe5b73bfaf71c$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $3e3fe5b73bfaf71c$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$3e3fe5b73bfaf71c$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $3e3fe5b73bfaf71c$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $3e3fe5b73bfaf71c$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($3e3fe5b73bfaf71c$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $3e3fe5b73bfaf71c$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $3e3fe5b73bfaf71c$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $3e3fe5b73bfaf71c$var$isIncrementalEvent(event) {
    return event.type === $3e3fe5b73bfaf71c$var$ReplayEventTypeIncrementalSnapshot;
}
function $3e3fe5b73bfaf71c$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $3e3fe5b73bfaf71c$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $3e3fe5b73bfaf71c$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $3e3fe5b73bfaf71c$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($3e3fe5b73bfaf71c$var$NodeType || ($3e3fe5b73bfaf71c$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $3e3fe5b73bfaf71c$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $3e3fe5b73bfaf71c$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($3e3fe5b73bfaf71c$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $3e3fe5b73bfaf71c$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $3e3fe5b73bfaf71c$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $3e3fe5b73bfaf71c$var$handleClick(replay.clickDetector, result, $3e3fe5b73bfaf71c$var$getClickTargetNode(handlerData.event));
        $3e3fe5b73bfaf71c$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $3e3fe5b73bfaf71c$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $3e3fe5b73bfaf71c$var$record.mirror.getId(target);
    const node = nodeId && $3e3fe5b73bfaf71c$var$record.mirror.getNode(nodeId);
    const meta = node && $3e3fe5b73bfaf71c$var$record.mirror.getMeta(node);
    const element = meta && $3e3fe5b73bfaf71c$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $3e3fe5b73bfaf71c$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $3e3fe5b73bfaf71c$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $3e3fe5b73bfaf71c$var$handleDom(handlerData) {
    const { target: target, message: message } = $3e3fe5b73bfaf71c$var$getDomTarget(handlerData);
    return $3e3fe5b73bfaf71c$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$3e3fe5b73bfaf71c$var$getBaseDomBreadcrumb(target, message)
    });
}
function $3e3fe5b73bfaf71c$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $3e3fe5b73bfaf71c$var$getClickTargetNode(handlerData.event) : $3e3fe5b73bfaf71c$var$getTargetNode(handlerData.event);
        message = (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $3e3fe5b73bfaf71c$var$isElement(node) {
    return node.type === $3e3fe5b73bfaf71c$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $3e3fe5b73bfaf71c$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $3e3fe5b73bfaf71c$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $3e3fe5b73bfaf71c$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $3e3fe5b73bfaf71c$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $3e3fe5b73bfaf71c$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $bec17cc7ed6c6bca$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $3e3fe5b73bfaf71c$var$getBaseDomBreadcrumb(target, message);
    return $3e3fe5b73bfaf71c$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $3e3fe5b73bfaf71c$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $3e3fe5b73bfaf71c$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $3e3fe5b73bfaf71c$var$createResourceEntry,
    paint: $3e3fe5b73bfaf71c$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $3e3fe5b73bfaf71c$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $3e3fe5b73bfaf71c$var$createPerformanceEntries(entries) {
    return entries.map($3e3fe5b73bfaf71c$var$createPerformanceEntry).filter(Boolean);
}
function $3e3fe5b73bfaf71c$var$createPerformanceEntry(entry) {
    if (!$3e3fe5b73bfaf71c$var$ENTRY_TYPES[entry.entryType]) return null;
    return $3e3fe5b73bfaf71c$var$ENTRY_TYPES[entry.entryType](entry);
}
function $3e3fe5b73bfaf71c$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $579f76a2b219152d$export$baf075a948ffc0bf) || $3e3fe5b73bfaf71c$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $3e3fe5b73bfaf71c$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $3e3fe5b73bfaf71c$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $3e3fe5b73bfaf71c$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $3e3fe5b73bfaf71c$var$getAbsoluteTime(startTime),
        end: $3e3fe5b73bfaf71c$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $3e3fe5b73bfaf71c$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $3e3fe5b73bfaf71c$var$getAbsoluteTime(startTime),
        end: $3e3fe5b73bfaf71c$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $3e3fe5b73bfaf71c$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $3e3fe5b73bfaf71c$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $3e3fe5b73bfaf71c$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $3e3fe5b73bfaf71c$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $29db847506b9b5a1$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $29db847506b9b5a1$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($3e3fe5b73bfaf71c$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3e3fe5b73bfaf71c$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $3e3fe5b73bfaf71c$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $3e3fe5b73bfaf71c$var$e() {
    const e = new Blob([
        $3e3fe5b73bfaf71c$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $3e3fe5b73bfaf71c$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$3e3fe5b73bfaf71c$var$DEBUG_BUILD) return;
    (0, $2bd19015b7869ed8$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $3e3fe5b73bfaf71c$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $3e3fe5b73bfaf71c$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$3e3fe5b73bfaf71c$var$DEBUG_BUILD) return;
    (0, $2bd19015b7869ed8$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $3e3fe5b73bfaf71c$var$addLogBreadcrumb(message);
    }, 0);
}
function $3e3fe5b73bfaf71c$var$addLogBreadcrumb(message) {
    (0, $fe010f6f6efcb5f1$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $3e3fe5b73bfaf71c$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$3e3fe5b73bfaf71c$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $3e3fe5b73bfaf71c$var$EventBufferArray {
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $3e3fe5b73bfaf71c$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $3e3fe5b73bfaf71c$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $3e3fe5b73bfaf71c$var$timestampToMs(timestamp);
    }
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $3e3fe5b73bfaf71c$var$WorkerHandler {
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $3e3fe5b73bfaf71c$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $3e3fe5b73bfaf71c$var$EventBufferCompressionWorker {
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $3e3fe5b73bfaf71c$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $3e3fe5b73bfaf71c$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $3e3fe5b73bfaf71c$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
    /** @inheritdoc */ constructor(worker){
        this._worker = new $3e3fe5b73bfaf71c$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $3e3fe5b73bfaf71c$var$EventBufferProxy {
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $3e3fe5b73bfaf71c$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
    constructor(worker){
        this._fallback = new $3e3fe5b73bfaf71c$var$EventBufferArray();
        this._compression = new $3e3fe5b73bfaf71c$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
}
/**
 * Create an event buffer for replays.
 */ function $3e3fe5b73bfaf71c$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $3e3fe5b73bfaf71c$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $3e3fe5b73bfaf71c$var$logInfo("[Replay] Using simple buffer");
    return new $3e3fe5b73bfaf71c$var$EventBufferArray();
}
function $3e3fe5b73bfaf71c$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $3e3fe5b73bfaf71c$var$_getWorkerUrl();
        if (!workerUrl) return;
        $3e3fe5b73bfaf71c$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $3e3fe5b73bfaf71c$var$EventBufferProxy(worker);
    } catch (error) {
        $3e3fe5b73bfaf71c$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $3e3fe5b73bfaf71c$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $3e3fe5b73bfaf71c$var$e();
    return "";
}
/** If sessionStorage is available. */ function $3e3fe5b73bfaf71c$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $3e3fe5b73bfaf71c$var$WINDOW && !!$3e3fe5b73bfaf71c$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $3e3fe5b73bfaf71c$var$clearSession(replay) {
    $3e3fe5b73bfaf71c$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $3e3fe5b73bfaf71c$var$deleteSession() {
    if (!$3e3fe5b73bfaf71c$var$hasSessionStorage()) return;
    try {
        $3e3fe5b73bfaf71c$var$WINDOW.sessionStorage.removeItem($3e3fe5b73bfaf71c$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $3e3fe5b73bfaf71c$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $3e3fe5b73bfaf71c$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $65daed3d61181daa$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $3e3fe5b73bfaf71c$var$saveSession(session) {
    if (!$3e3fe5b73bfaf71c$var$hasSessionStorage()) return;
    try {
        $3e3fe5b73bfaf71c$var$WINDOW.sessionStorage.setItem($3e3fe5b73bfaf71c$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $3e3fe5b73bfaf71c$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $3e3fe5b73bfaf71c$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $3e3fe5b73bfaf71c$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $3e3fe5b73bfaf71c$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $3e3fe5b73bfaf71c$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $3e3fe5b73bfaf71c$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $3e3fe5b73bfaf71c$var$fetchSession(traceInternals) {
    if (!$3e3fe5b73bfaf71c$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $3e3fe5b73bfaf71c$var$WINDOW.sessionStorage.getItem($3e3fe5b73bfaf71c$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $3e3fe5b73bfaf71c$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $3e3fe5b73bfaf71c$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $3e3fe5b73bfaf71c$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $3e3fe5b73bfaf71c$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $3e3fe5b73bfaf71c$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $3e3fe5b73bfaf71c$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $3e3fe5b73bfaf71c$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$3e3fe5b73bfaf71c$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $3e3fe5b73bfaf71c$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $3e3fe5b73bfaf71c$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $3e3fe5b73bfaf71c$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $3e3fe5b73bfaf71c$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$3e3fe5b73bfaf71c$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $3e3fe5b73bfaf71c$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $3e3fe5b73bfaf71c$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $3e3fe5b73bfaf71c$var$isCustomEvent(event) {
    return event.type === $3e3fe5b73bfaf71c$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $3e3fe5b73bfaf71c$var$addEventSync(replay, event, isCheckout) {
    if (!$3e3fe5b73bfaf71c$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $3e3fe5b73bfaf71c$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $3e3fe5b73bfaf71c$var$addEvent(replay, event, isCheckout) {
    if (!$3e3fe5b73bfaf71c$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $3e3fe5b73bfaf71c$var$_addEvent(replay, event, isCheckout);
}
async function $3e3fe5b73bfaf71c$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $3e3fe5b73bfaf71c$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $3e3fe5b73bfaf71c$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $3e3fe5b73bfaf71c$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $3e3fe5b73bfaf71c$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $3e3fe5b73bfaf71c$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $3e3fe5b73bfaf71c$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $3e3fe5b73bfaf71c$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $3e3fe5b73bfaf71c$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $3e3fe5b73bfaf71c$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $3e3fe5b73bfaf71c$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $3e3fe5b73bfaf71c$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $3e3fe5b73bfaf71c$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $3e3fe5b73bfaf71c$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$3e3fe5b73bfaf71c$var$isErrorEvent(event) && !$3e3fe5b73bfaf71c$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($3e3fe5b73bfaf71c$var$isTransactionEvent(event)) {
            $3e3fe5b73bfaf71c$var$handleTransactionEvent(replay, event);
            return;
        }
        $3e3fe5b73bfaf71c$var$handleErrorEvent(replay, event);
    };
}
function $3e3fe5b73bfaf71c$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $3e3fe5b73bfaf71c$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $3e3fe5b73bfaf71c$var$isBaseTransportSend() {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $3e3fe5b73bfaf71c$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$3e3fe5b73bfaf71c$var$isErrorEvent(event)) return;
        $3e3fe5b73bfaf71c$var$handleHydrationError(replay, event);
    };
}
function $3e3fe5b73bfaf71c$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $3e3fe5b73bfaf71c$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $3e3fe5b73bfaf71c$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $3e3fe5b73bfaf71c$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $3e3fe5b73bfaf71c$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $3e3fe5b73bfaf71c$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $3e3fe5b73bfaf71c$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $3e3fe5b73bfaf71c$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $3e3fe5b73bfaf71c$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $3e3fe5b73bfaf71c$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $3e3fe5b73bfaf71c$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($3e3fe5b73bfaf71c$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$3e3fe5b73bfaf71c$var$isErrorEvent(event) && !$3e3fe5b73bfaf71c$var$isTransactionEvent(event) && !$3e3fe5b73bfaf71c$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($3e3fe5b73bfaf71c$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $3e3fe5b73bfaf71c$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($3e3fe5b73bfaf71c$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $3e3fe5b73bfaf71c$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $3e3fe5b73bfaf71c$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $3e3fe5b73bfaf71c$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $3e3fe5b73bfaf71c$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $3e3fe5b73bfaf71c$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $3e3fe5b73bfaf71c$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $3e3fe5b73bfaf71c$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $3e3fe5b73bfaf71c$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($3e3fe5b73bfaf71c$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $c28edac5b94496e9$export$d92e61f5600202af)(url, (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $3e3fe5b73bfaf71c$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($3e3fe5b73bfaf71c$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $3e3fe5b73bfaf71c$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $3e3fe5b73bfaf71c$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $3e3fe5b73bfaf71c$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $3e3fe5b73bfaf71c$var$handleFetch(handlerData);
        $3e3fe5b73bfaf71c$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $3e3fe5b73bfaf71c$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $3e3fe5b73bfaf71c$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $3e3fe5b73bfaf71c$var$handleXhr(handlerData);
        $3e3fe5b73bfaf71c$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $3e3fe5b73bfaf71c$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $3e3fe5b73bfaf71c$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $3e3fe5b73bfaf71c$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $3e3fe5b73bfaf71c$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $3e3fe5b73bfaf71c$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $3e3fe5b73bfaf71c$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $3e3fe5b73bfaf71c$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $a4503473509e6905$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $3e3fe5b73bfaf71c$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $3e3fe5b73bfaf71c$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $3e3fe5b73bfaf71c$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $3e3fe5b73bfaf71c$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $3e3fe5b73bfaf71c$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $3e3fe5b73bfaf71c$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $3e3fe5b73bfaf71c$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $3e3fe5b73bfaf71c$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $3e3fe5b73bfaf71c$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $3e3fe5b73bfaf71c$var$urlMatches(url, urls) {
    const fullUrl = $3e3fe5b73bfaf71c$var$getFullUrl(url);
    return (0, $2ce85545280315e6$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $3e3fe5b73bfaf71c$var$getFullUrl(url, baseURI = $3e3fe5b73bfaf71c$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($3e3fe5b73bfaf71c$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $3e3fe5b73bfaf71c$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $3e3fe5b73bfaf71c$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $3e3fe5b73bfaf71c$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $3e3fe5b73bfaf71c$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $3e3fe5b73bfaf71c$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $3e3fe5b73bfaf71c$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $3e3fe5b73bfaf71c$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $3e3fe5b73bfaf71c$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $3e3fe5b73bfaf71c$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $3e3fe5b73bfaf71c$var$urlMatches(url, options.networkDetailAllowUrls) && !$3e3fe5b73bfaf71c$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $3e3fe5b73bfaf71c$var$_getRequestInfo(options, hint.input, requestBodySize) : $3e3fe5b73bfaf71c$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $3e3fe5b73bfaf71c$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $3e3fe5b73bfaf71c$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $3e3fe5b73bfaf71c$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $3e3fe5b73bfaf71c$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $3e3fe5b73bfaf71c$var$getBodyString(requestBody);
    const data = $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $3e3fe5b73bfaf71c$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $3e3fe5b73bfaf71c$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $3e3fe5b73bfaf71c$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $3e3fe5b73bfaf71c$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $3e3fe5b73bfaf71c$var$_parseFetchResponseBody(response);
    const result = $3e3fe5b73bfaf71c$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $3e3fe5b73bfaf71c$var$mergeWarning(result, warning);
    return result;
}
function $3e3fe5b73bfaf71c$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $3e3fe5b73bfaf71c$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $3e3fe5b73bfaf71c$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $3e3fe5b73bfaf71c$var$_parseFetchResponseBody(response) {
    const res = $3e3fe5b73bfaf71c$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $3e3fe5b73bfaf71c$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $3e3fe5b73bfaf71c$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $3e3fe5b73bfaf71c$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $3e3fe5b73bfaf71c$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $3e3fe5b73bfaf71c$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $3e3fe5b73bfaf71c$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $3e3fe5b73bfaf71c$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $3e3fe5b73bfaf71c$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $3e3fe5b73bfaf71c$var$getAllowedHeaders(headers, allowedHeaders);
}
function $3e3fe5b73bfaf71c$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $3e3fe5b73bfaf71c$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $3e3fe5b73bfaf71c$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $3e3fe5b73bfaf71c$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $3e3fe5b73bfaf71c$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $3e3fe5b73bfaf71c$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $3e3fe5b73bfaf71c$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $3e3fe5b73bfaf71c$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $3e3fe5b73bfaf71c$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $3e3fe5b73bfaf71c$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $3e3fe5b73bfaf71c$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $3e3fe5b73bfaf71c$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $3e3fe5b73bfaf71c$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$3e3fe5b73bfaf71c$var$urlMatches(url, options.networkDetailAllowUrls) || $3e3fe5b73bfaf71c$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $3e3fe5b73bfaf71c$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $3e3fe5b73bfaf71c$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $e4bb6fb96ec6ca73$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $3e3fe5b73bfaf71c$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $3e3fe5b73bfaf71c$var$getAllowedHeaders($3e3fe5b73bfaf71c$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $3e3fe5b73bfaf71c$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $3e3fe5b73bfaf71c$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $3e3fe5b73bfaf71c$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $3e3fe5b73bfaf71c$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $3e3fe5b73bfaf71c$var$mergeWarning(response, responseWarning) : response
    };
}
function $3e3fe5b73bfaf71c$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $3e3fe5b73bfaf71c$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $3e3fe5b73bfaf71c$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $3e3fe5b73bfaf71c$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $3e3fe5b73bfaf71c$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $3e3fe5b73bfaf71c$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $3e3fe5b73bfaf71c$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$3e3fe5b73bfaf71c$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $806c2415d1487b82$export$f75d3c772c923df0)($3e3fe5b73bfaf71c$var$handleFetchSpanListener(replay));
            (0, $e4bb6fb96ec6ca73$export$26ace48dd54c9aea)($3e3fe5b73bfaf71c$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $3e3fe5b73bfaf71c$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($3e3fe5b73bfaf71c$var$_isXhrBreadcrumb(breadcrumb) && $3e3fe5b73bfaf71c$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $3e3fe5b73bfaf71c$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $3e3fe5b73bfaf71c$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($3e3fe5b73bfaf71c$var$_isFetchBreadcrumb(breadcrumb) && $3e3fe5b73bfaf71c$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $3e3fe5b73bfaf71c$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $3e3fe5b73bfaf71c$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $3e3fe5b73bfaf71c$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $3e3fe5b73bfaf71c$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $3e3fe5b73bfaf71c$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $3e3fe5b73bfaf71c$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $3e3fe5b73bfaf71c$var$_LAST_BREADCRUMB = null;
function $3e3fe5b73bfaf71c$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $3e3fe5b73bfaf71c$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $3e3fe5b73bfaf71c$var$handleScope(scope);
        if (!result) return;
        $3e3fe5b73bfaf71c$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $3e3fe5b73bfaf71c$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($3e3fe5b73bfaf71c$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $3e3fe5b73bfaf71c$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$3e3fe5b73bfaf71c$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $3e3fe5b73bfaf71c$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $3e3fe5b73bfaf71c$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $3e3fe5b73bfaf71c$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $3e3fe5b73bfaf71c$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $3e3fe5b73bfaf71c$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $3e3fe5b73bfaf71c$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $458193ce2072e151$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $3e3fe5b73bfaf71c$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $3e3fe5b73bfaf71c$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $3e3fe5b73bfaf71c$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $3e3fe5b73bfaf71c$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    scope.addScopeListener($3e3fe5b73bfaf71c$var$handleScopeListener(replay));
    (0, $dd2aff0520204ee9$export$5aeffd3db2cf9df7)($3e3fe5b73bfaf71c$var$handleDomListener(replay));
    (0, $37489a764b40e666$export$3f18c56c58114e75)($3e3fe5b73bfaf71c$var$handleHistorySpanListener(replay));
    $3e3fe5b73bfaf71c$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $3e3fe5b73bfaf71c$var$handleGlobalEventListener(replay, !$3e3fe5b73bfaf71c$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $9e83634a1d36543d$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($3e3fe5b73bfaf71c$var$hasHooks(client)) {
        client.on("beforeSendEvent", $3e3fe5b73bfaf71c$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $3e3fe5b73bfaf71c$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3e3fe5b73bfaf71c$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $3e3fe5b73bfaf71c$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($3e3fe5b73bfaf71c$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $3e3fe5b73bfaf71c$var$createMemoryEntry($3e3fe5b73bfaf71c$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $3e3fe5b73bfaf71c$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $3e3fe5b73bfaf71c$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $3e3fe5b73bfaf71c$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $3e3fe5b73bfaf71c$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$3e3fe5b73bfaf71c$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $3e3fe5b73bfaf71c$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $3e3fe5b73bfaf71c$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $3e3fe5b73bfaf71c$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $3e3fe5b73bfaf71c$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $3e3fe5b73bfaf71c$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $3e3fe5b73bfaf71c$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $3e3fe5b73bfaf71c$var$addEventSync(replay, $3e3fe5b73bfaf71c$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $3e3fe5b73bfaf71c$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $ddd7798536c68ec2$export$f93f7f385160c44e)((0, $ddd7798536c68ec2$export$92b6093782fe661b)(replayEvent, (0, $ddd7798536c68ec2$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $3e3fe5b73bfaf71c$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $3e3fe5b73bfaf71c$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $0b9a24c8403b5f2a$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $35009d14216a34ba$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $3e3fe5b73bfaf71c$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $3e3fe5b73bfaf71c$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    const scope = (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $3e3fe5b73bfaf71c$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $3e3fe5b73bfaf71c$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $3e3fe5b73bfaf71c$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $3e3fe5b73bfaf71c$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($3e3fe5b73bfaf71c$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $3e3fe5b73bfaf71c$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $7e925941e6509111$export$699aff705e0d49d4)({}, response);
    if ((0, $7e925941e6509111$export$6c91fec22056810a)(rateLimits, "replay")) throw new $3e3fe5b73bfaf71c$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $3e3fe5b73bfaf71c$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $3e3fe5b73bfaf71c$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $3e3fe5b73bfaf71c$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $3e3fe5b73bfaf71c$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $3e3fe5b73bfaf71c$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $3e3fe5b73bfaf71c$var$TransportStatusCodeError || err instanceof $3e3fe5b73bfaf71c$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $fe010f6f6efcb5f1$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($3e3fe5b73bfaf71c$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $fe010f6f6efcb5f1$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $3e3fe5b73bfaf71c$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$3e3fe5b73bfaf71c$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $3e3fe5b73bfaf71c$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $3e3fe5b73bfaf71c$var$THROTTLED = "__THROTTLED";
const $3e3fe5b73bfaf71c$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3e3fe5b73bfaf71c$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $3e3fe5b73bfaf71c$var$SKIPPED : $3e3fe5b73bfaf71c$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $3e3fe5b73bfaf71c$var$ReplayContainer {
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $3e3fe5b73bfaf71c$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $3e3fe5b73bfaf71c$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $3e3fe5b73bfaf71c$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $3e3fe5b73bfaf71c$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $3e3fe5b73bfaf71c$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $3e3fe5b73bfaf71c$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $3e3fe5b73bfaf71c$var$BUFFER_CHECKOUT_TIME
                },
                emit: $3e3fe5b73bfaf71c$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $3e3fe5b73bfaf71c$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $3e3fe5b73bfaf71c$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $3e3fe5b73bfaf71c$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $3e3fe5b73bfaf71c$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $3e3fe5b73bfaf71c$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $3e3fe5b73bfaf71c$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$3e3fe5b73bfaf71c$var$WINDOW.location.pathname}${$3e3fe5b73bfaf71c$var$WINDOW.location.hash}${$3e3fe5b73bfaf71c$var$WINDOW.location.search}`;
        const url = `${$3e3fe5b73bfaf71c$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $3e3fe5b73bfaf71c$var$THROTTLED) {
            const breadcrumb = $3e3fe5b73bfaf71c$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$3e3fe5b73bfaf71c$var$addEventSync(this, {
                    type: $3e3fe5b73bfaf71c$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $fe010f6f6efcb5f1$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $750851faedae500f$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $b8adcea182c00730$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $750851faedae500f$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $3e3fe5b73bfaf71c$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay]", error);
        if ($3e3fe5b73bfaf71c$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $fe010f6f6efcb5f1$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $3e3fe5b73bfaf71c$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($3e3fe5b73bfaf71c$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $3e3fe5b73bfaf71c$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $3e3fe5b73bfaf71c$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $3e3fe5b73bfaf71c$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $3e3fe5b73bfaf71c$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $3e3fe5b73bfaf71c$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $3e3fe5b73bfaf71c$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $3e3fe5b73bfaf71c$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $3e3fe5b73bfaf71c$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $3e3fe5b73bfaf71c$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $3e3fe5b73bfaf71c$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($3e3fe5b73bfaf71c$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $3e3fe5b73bfaf71c$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $3e3fe5b73bfaf71c$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $3e3fe5b73bfaf71c$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $3e3fe5b73bfaf71c$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $3e3fe5b73bfaf71c$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $3e3fe5b73bfaf71c$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $3e3fe5b73bfaf71c$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($3e3fe5b73bfaf71c$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $3e3fe5b73bfaf71c$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $3e3fe5b73bfaf71c$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $3e3fe5b73bfaf71c$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $3e3fe5b73bfaf71c$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $3e3fe5b73bfaf71c$var$DEBUG_BUILD && (0, $2bd19015b7869ed8$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $3e3fe5b73bfaf71c$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $3e3fe5b73bfaf71c$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $3e3fe5b73bfaf71c$var$ReplayContainer.prototype.__init.call(this);
        $3e3fe5b73bfaf71c$var$ReplayContainer.prototype.__init2.call(this);
        $3e3fe5b73bfaf71c$var$ReplayContainer.prototype.__init3.call(this);
        $3e3fe5b73bfaf71c$var$ReplayContainer.prototype.__init4.call(this);
        $3e3fe5b73bfaf71c$var$ReplayContainer.prototype.__init5.call(this);
        $3e3fe5b73bfaf71c$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $3e3fe5b73bfaf71c$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $3e3fe5b73bfaf71c$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $3e3fe5b73bfaf71c$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $3e3fe5b73bfaf71c$var$throttle((event, isCheckout)=>$3e3fe5b73bfaf71c$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($3e3fe5b73bfaf71c$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $3e3fe5b73bfaf71c$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $3e3fe5b73bfaf71c$var$ClickDetector(this, slowClickConfig);
    }
}
function $3e3fe5b73bfaf71c$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $2bd19015b7869ed8$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $3e3fe5b73bfaf71c$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $3e3fe5b73bfaf71c$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $3e3fe5b73bfaf71c$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $3e3fe5b73bfaf71c$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $3e3fe5b73bfaf71c$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $3e3fe5b73bfaf71c$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $3e3fe5b73bfaf71c$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $3e3fe5b73bfaf71c$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $3e3fe5b73bfaf71c$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $3e3fe5b73bfaf71c$var$_initialized = false;
const $3e3fe5b73bfaf71c$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $3e3fe5b73bfaf71c$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $3e3fe5b73bfaf71c$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $3e3fe5b73bfaf71c$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $3e3fe5b73bfaf71c$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $58181eccc4b62443$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $3e3fe5b73bfaf71c$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $3e3fe5b73bfaf71c$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $3e3fe5b73bfaf71c$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $3e3fe5b73bfaf71c$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $3e3fe5b73bfaf71c$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $3e3fe5b73bfaf71c$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $3e3fe5b73bfaf71c$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $3e3fe5b73bfaf71c$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$3e3fe5b73bfaf71c$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $3e3fe5b73bfaf71c$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $3e3fe5b73bfaf71c$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $3e3fe5b73bfaf71c$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $3e3fe5b73bfaf71c$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $3e3fe5b73bfaf71c$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$3e3fe5b73bfaf71c$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $58181eccc4b62443$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
}
$3e3fe5b73bfaf71c$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $3e3fe5b73bfaf71c$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $a4503473509e6905$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $2bd19015b7869ed8$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $2bd19015b7869ed8$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $3e3fe5b73bfaf71c$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$3e3fe5b73bfaf71c$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $3e3fe5b73bfaf71c$export$81cc0d0f72285d1() {
    const client = (0, $fe010f6f6efcb5f1$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $3e3fe5b73bfaf71c$export$b28310b2f161456b = $3e3fe5b73bfaf71c$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $3e3fe5b73bfaf71c$export$d7706faf7ab354bf = $3e3fe5b73bfaf71c$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $3e3fe5b73bfaf71c$export$a35c789ed37ee0f7 extends $3e3fe5b73bfaf71c$export$6b59b88de1ff9cb7 {
}



var $kqmsT = parcelRequire("kqmsT");
const $5c71235825629a21$var$options = {
    api_host: "https://us.i.posthog.com",
    mask_all_text: true,
    mask_all_element_attributes: true,
    capture_pageview: false // This is a SPA, so we need to capture the pageview manually
};
$f935bb49ce831c88$export$2cd8252107eb640b({
    dsn: "https://67b1cacd2d686829074e78d62ced5e05@o4506593884831744.ingest.sentry.io/4506594441887744",
    integrations: [
        new $eff1881618a97372$export$46d3bbd0375f5fa4(),
        new $3e3fe5b73bfaf71c$export$6b59b88de1ff9cb7({
            maskAllText: false,
            blockAllMedia: false
        })
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
    environment: "production"
});
const $5c71235825629a21$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8iZJl))).createRoot(document.getElementById("root"));
$5c71235825629a21$var$root.render(/*#__PURE__*/ (0, $fR5Jw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgG1Y))).StrictMode, {
    children: /*#__PURE__*/ (0, $fR5Jw.jsx)($68efdbb5eaa5efea$export$e926676385687eaf, {
        fallback: /*#__PURE__*/ (0, $fR5Jw.jsx)("div", {
            children: "An error has occurred"
        }),
        children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $kqmsT.PostHogProvider), {
            apiKey: "phc_BmC77pLpgnQ1HqkNFpm9HMAZF0mNTgx6oeJ1tlDCXe7",
            options: $5c71235825629a21$var$options,
            children: /*#__PURE__*/ (0, $fR5Jw.jsx)((0, $3e9dfbf313955633$export$2e2bcd8739ae039), {})
        })
    })
}));
$9c2e85f3aff73b46$export$d07f55d4c15c0440();

})();
//# sourceMappingURL=index.af86e647.js.map
